var wqe = Object.defineProperty;
var qee = (e) => {
  throw TypeError(e);
};
var xqe = (e, t, n) => t in e ? wqe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var rn = (e, t, n) => xqe(e, typeof t != "symbol" ? t + "" : t, n), tF = (e, t, n) => t.has(e) || qee("Cannot " + n);
var K = (e, t, n) => (tF(e, t, "read from private field"), n ? n.call(e) : t.get(e)), tt = (e, t, n) => t.has(e) ? qee("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), $e = (e, t, n, r) => (tF(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Dt = (e, t, n) => (tF(e, t, "access private method"), n);
var Hx = (e, t, n, r) => ({
  set _(i) {
    $e(e, t, i, n);
  },
  get _() {
    return K(e, t, r);
  }
});
import { jsx as y, Fragment as pt, jsxs as V } from "react/jsx-runtime";
import * as N from "react";
import ie, { createContext as Ri, useContext as kr, useCallback as qn, useState as He, useRef as Xe, useEffect as nt, forwardRef as Fo, createElement as oi, useLayoutEffect as Og, useImperativeHandle as rW, useMemo as Kt, memo as Ji, useReducer as a2, cloneElement as Sqe, useId as wve, useDebugValue as xve, useSyncExternalStore as Eqe, Component as Tqe } from "react";
import * as sb from "react-dom";
import _w, { createPortal as iW, unstable_batchedUpdates as Qx, flushSync as Sve } from "react-dom";
import { useNavigate as sT, Link as oW, useInRouterContext as kqe, useSearchParams as Eve } from "react-router-dom";
import Tve from "jszip";
const Cqe = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class DM {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || Cqe, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, i) {
    return i && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new DM(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new DM(this.logger, t);
  }
}
var of = new DM();
let l2 = class {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const i = this.observers[r].get(n) || 0;
      this.observers[r].set(n, i + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((s) => {
      let [l, c] = s;
      for (let a = 0; a < c; a++)
        l(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [l, c] = s;
      for (let a = 0; a < c; a++)
        l.apply(l, [t, ...r]);
    });
  }
};
const $x = () => {
  let e, t;
  const n = new Promise((r, i) => {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n;
}, Bee = (e) => e == null ? "" : "" + e, Nqe = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, Pqe = /###/g, Xee = (e) => e && e.indexOf("###") > -1 ? e.replace(Pqe, ".") : e, Wee = (e) => !e || typeof e == "string", yE = (e, t, n) => {
  const r = typeof t != "string" ? t : t.split(".");
  let i = 0;
  for (; i < r.length - 1; ) {
    if (Wee(e)) return {};
    const o = Xee(r[i]);
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++i;
  }
  return Wee(e) ? {} : {
    obj: e,
    k: Xee(r[i])
  };
}, Zee = (e, t, n) => {
  const {
    obj: r,
    k: i
  } = yE(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[i] = n;
    return;
  }
  let o = t[t.length - 1], s = t.slice(0, t.length - 1), l = yE(e, s, Object);
  for (; l.obj === void 0 && s.length; )
    o = `${s[s.length - 1]}.${o}`, s = s.slice(0, s.length - 1), l = yE(e, s, Object), l && l.obj && typeof l.obj[`${l.k}.${o}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${o}`] = n;
}, Iqe = (e, t, n, r) => {
  const {
    obj: i,
    k: o
  } = yE(e, t, Object);
  i[o] = i[o] || [], i[o].push(n);
}, _M = (e, t) => {
  const {
    obj: n,
    k: r
  } = yE(e, t);
  if (n)
    return n[r];
}, Rqe = (e, t, n) => {
  const r = _M(e, n);
  return r !== void 0 ? r : _M(t, n);
}, kve = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : kve(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, Zb = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Mqe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Dqe = (e) => typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => Mqe[t]) : e;
class _qe {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const Lqe = [" ", ",", "?", "!", ";"], zqe = new _qe(20), jqe = (e, t, n) => {
  t = t || "", n = n || "";
  const r = Lqe.filter((s) => t.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (r.length === 0) return !0;
  const i = zqe.getRegExp(`(${r.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let o = !i.test(e);
  if (!o) {
    const s = e.indexOf(n);
    s > 0 && !i.test(e.substring(0, s)) && (o = !0);
  }
  return o;
}, wq = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const r = t.split(n);
  let i = e;
  for (let o = 0; o < r.length; ) {
    if (!i || typeof i != "object")
      return;
    let s, l = "";
    for (let c = o; c < r.length; ++c)
      if (c !== o && (l += n), l += r[c], s = i[l], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && c < r.length - 1)
          continue;
        o += c - o + 1;
        break;
      }
    i = s;
  }
  return i;
}, LM = (e) => e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
class Hee extends l2 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, s = i.ignoreJSONStructure !== void 0 ? i.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, n], r && (Array.isArray(r) ? l.push(...r) : typeof r == "string" && o ? l.push(...r.split(o)) : l.push(r)));
    const c = _M(this.data, l);
    return !c && !n && !r && t.indexOf(".") > -1 && (t = l[0], n = l[1], r = l.slice(2).join(".")), c || !s || typeof r != "string" ? c : wq(this.data && this.data[t] && this.data[t][n], r, o);
  }
  addResource(t, n, r, i) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let l = [t, n];
    r && (l = l.concat(s ? r.split(s) : r)), t.indexOf(".") > -1 && (l = t.split("."), i = n, n = l[1]), this.addNamespaces(n), Zee(this.data, l, i), o.silent || this.emit("added", t, n, r, i);
  }
  addResources(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const o in r)
      (typeof r[o] == "string" || Array.isArray(r[o])) && this.addResource(t, n, o, r[o], {
        silent: !0
      });
    i.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, i, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, l = [t, n];
    t.indexOf(".") > -1 && (l = t.split("."), i = r, r = n, n = l[1]), this.addNamespaces(n);
    let c = _M(this.data, l) || {};
    s.skipCopy || (r = JSON.parse(JSON.stringify(r))), i ? kve(c, r, o) : c = {
      ...c,
      ...r
    }, Zee(this.data, l, c), s.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((i) => n[i] && Object.keys(n[i]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Cve = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, i) {
    return e.forEach((o) => {
      this.processors[o] && (t = this.processors[o].process(t, n, r, i));
    }), t;
  }
};
const Qee = {};
class zM extends l2 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Nqe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = of.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = n.ns || this.options.defaultNS || [];
    const s = r && t.indexOf(r) > -1, l = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !jqe(t, r, i);
    if (s && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: o
        };
      const a = t.split(r);
      (r !== i || r === i && this.options.ns.indexOf(a[0]) > -1) && (o = a.shift()), t = a.join(i);
    }
    return typeof o == "string" && (o = [o]), {
      key: t,
      namespaces: o
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const i = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1], a = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (a && a.toLowerCase() === "cimode") {
      if (u) {
        const O = n.nsSeparator || this.options.nsSeparator;
        return i ? {
          res: `${c}${O}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: a,
          usedNS: c,
          usedParams: this.getUsedParamsDetails(n)
        } : `${c}${O}${s}`;
      }
      return i ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: a,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    }
    const f = this.resolve(t, n);
    let d = f && f.res;
    const p = f && f.usedKey || s, h = f && f.exactUsedKey || s, m = Object.prototype.toString.apply(d), v = ["[object Number]", "[object Function]", "[object RegExp]"], b = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, A = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (A && d && (typeof d != "string" && typeof d != "boolean" && typeof d != "number") && v.indexOf(m) < 0 && !(typeof b == "string" && Array.isArray(d))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const O = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, d, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return i ? (f.res = O, f.usedParams = this.getUsedParamsDetails(n), f) : O;
      }
      if (o) {
        const O = Array.isArray(d), x = O ? [] : {}, S = O ? h : p;
        for (const E in d)
          if (Object.prototype.hasOwnProperty.call(d, E)) {
            const k = `${S}${o}${E}`;
            x[E] = this.translate(k, {
              ...n,
              joinArrays: !1,
              ns: l
            }), x[E] === k && (x[E] = d[E]);
          }
        d = x;
      }
    } else if (A && typeof b == "string" && Array.isArray(d))
      d = d.join(b), d && (d = this.extendTranslation(d, t, n, r));
    else {
      let O = !1, x = !1;
      const S = n.count !== void 0 && typeof n.count != "string", E = zM.hasDefaultValue(n), k = S ? this.pluralResolver.getSuffix(a, n.count, n) : "", T = n.ordinal && S ? this.pluralResolver.getSuffix(a, n.count, {
        ordinal: !1
      }) : "", R = S && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), j = R && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${k}`] || n[`defaultValue${T}`] || n.defaultValue;
      !this.isValidLookup(d) && E && (O = !0, d = j), this.isValidLookup(d) || (x = !0, d = s);
      const L = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && x ? void 0 : d, _ = E && j !== d && this.options.updateMissing;
      if (x || O || _) {
        if (this.logger.log(_ ? "updateKey" : "missingKey", a, c, s, _ ? j : d), o) {
          const I = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          I && I.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let U = [];
        const z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && z && z[0])
          for (let I = 0; I < z.length; I++)
            U.push(z[I]);
        else this.options.saveMissingTo === "all" ? U = this.languageUtils.toResolveHierarchy(n.lng || this.language) : U.push(n.lng || this.language);
        const C = (I, M, D) => {
          const X = E && D !== d ? D : L;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(I, c, M, X, _, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(I, c, M, X, _, n), this.emit("missingKey", I, c, M, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? U.forEach((I) => {
          const M = this.pluralResolver.getSuffixes(I, n);
          R && n[`defaultValue${this.options.pluralSeparator}zero`] && M.indexOf(`${this.options.pluralSeparator}zero`) < 0 && M.push(`${this.options.pluralSeparator}zero`), M.forEach((D) => {
            C([I], s + D, n[`defaultValue${D}`] || j);
          });
        }) : C(U, s, j));
      }
      d = this.extendTranslation(d, t, n, f, r), x && d === s && this.options.appendNamespaceToMissingKey && (d = `${c}:${s}`), (x || O) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${s}` : s, O ? d : void 0) : d = this.options.parseMissingKeyHandler(d));
    }
    return i ? (f.res = d, f.usedParams = this.getUsedParamsDetails(n), f) : d;
  }
  extendTranslation(t, n, r, i, o) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || i.usedLng, i.usedNS, i.usedKey, {
        resolved: i
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const a = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (a) {
        const d = t.match(this.interpolator.nestingRegexp);
        u = d && d.length;
      }
      let f = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), t = this.interpolator.interpolate(t, f, r.lng || this.language || i.usedLng, r), a) {
        const d = t.match(this.interpolator.nestingRegexp), p = d && d.length;
        u < p && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && i && i.res && (r.lng = this.language || i.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var d = arguments.length, p = new Array(d), h = 0; h < d; h++)
          p[h] = arguments[h];
        return o && o[0] === p[0] && !r.context ? (s.logger.warn(`It seems you are nesting recursively key: ${p[0]} in key: ${n[0]}`), null) : s.translate(...p, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const l = r.postProcess || this.options.postProcess, c = typeof l == "string" ? [l] : l;
    return t != null && c && c.length && r.applyPostProcessor !== !1 && (t = Cve.handle(c, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...i,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, i, o, s, l;
    return typeof t == "string" && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(r)) return;
      const a = this.extractFromKey(c, n), u = a.key;
      i = u;
      let f = a.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const d = n.count !== void 0 && typeof n.count != "string", p = d && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), h = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", m = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      f.forEach((v) => {
        this.isValidLookup(r) || (l = v, !Qee[`${m[0]}-${v}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(l) && (Qee[`${m[0]}-${v}`] = !0, this.logger.warn(`key "${i}" for languages "${m.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((b) => {
          if (this.isValidLookup(r)) return;
          s = b;
          const A = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(A, u, b, v, n);
          else {
            let O;
            d && (O = this.pluralResolver.getSuffix(b, n.count, n));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (A.push(u + O), n.ordinal && O.indexOf(S) === 0 && A.push(u + O.replace(S, this.options.pluralSeparator)), p && A.push(u + x)), h) {
              const E = `${u}${this.options.contextSeparator}${n.context}`;
              A.push(E), d && (A.push(E + O), n.ordinal && O.indexOf(S) === 0 && A.push(E + O.replace(S, this.options.pluralSeparator)), p && A.push(E + x));
            }
          }
          let w;
          for (; w = A.pop(); )
            this.isValidLookup(r) || (o = w, r = this.getResource(b, v, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: i,
      exactUsedKey: o,
      usedLng: s,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, i) : this.resourceStore.getResource(t, n, r, i);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && typeof t.replace != "string";
    let i = r ? t.replace : t;
    if (r && typeof t.count < "u" && (i.count = t.count), this.options.interpolation.defaultVariables && (i = {
      ...this.options.interpolation.defaultVariables,
      ...i
    }), !r) {
      i = {
        ...i
      };
      for (const o of n)
        delete i[o];
    }
    return i;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const nF = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class $ee {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = of.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = LM(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = LM(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((i) => i.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = nF(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = nF(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = nF(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((r) => {
      if (n) return;
      const i = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(i)) && (n = i);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n) return;
      const i = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(i)) return n = i;
      n = this.options.supportedLngs.find((o) => {
        if (o === i) return o;
        if (!(o.indexOf("-") < 0 && i.indexOf("-") < 0) && (o.indexOf("-") > 0 && i.indexOf("-") < 0 && o.substring(0, o.indexOf("-")) === i || o.indexOf(i) === 0 && i.length > 1))
          return o;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), i = [], o = (s) => {
      s && (this.isSupportedCode(s) ? i.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : typeof t == "string" && o(this.formatLanguageCode(t)), r.forEach((s) => {
      i.indexOf(s) < 0 && o(this.formatLanguageCode(s));
    }), i;
  }
}
let Fqe = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Uqe = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const Vqe = ["v1", "v2", "v3"], qqe = ["v4"], Kee = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Bqe = () => {
  const e = {};
  return Fqe.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: Uqe[t.fc]
      };
    });
  }), e;
};
class Xqe {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = of.create("pluralResolver"), (!this.options.compatibilityJSON || qqe.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Bqe(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const r = LM(t === "dev" ? "en" : t), i = n.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
          cleanedCode: r,
          type: i
        });
        if (o in this.pluralRulesCache)
          return this.pluralRulesCache[o];
        const s = new Intl.PluralRules(r, {
          type: i
        });
        return this.pluralRulesCache[o] = s, s;
      } catch {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((i) => `${n}${i}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((i, o) => Kee[i] - Kee[o]).map((i) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${i}`) : r.numbers.map((i) => this.getSuffix(t, i, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const i = this.getRule(t, r);
    return i ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${i.select(n)}` : this.getSuffixRetroCompatible(i, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let i = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (i === 2 ? i = "plural" : i === 1 && (i = ""));
    const o = () => this.options.prepend && i.toString() ? this.options.prepend + i.toString() : i.toString();
    return this.options.compatibilityJSON === "v1" ? i === 1 ? "" : typeof i == "number" ? `_plural_${i.toString()}` : o() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? o() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Vqe.includes(this.options.compatibilityJSON);
  }
}
const Gee = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, o = Rqe(e, t, n);
  return !o && i && typeof n == "string" && (o = wq(e, n, r), o === void 0 && (o = wq(t, n, r))), o;
}, rF = (e) => e.replace(/\$/g, "$$$$");
class Wqe {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = of.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: i,
      prefix: o,
      prefixEscaped: s,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: a,
      unescapeSuffix: u,
      unescapePrefix: f,
      nestingPrefix: d,
      nestingPrefixEscaped: p,
      nestingSuffix: h,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: v,
      maxReplaces: b,
      alwaysFormat: A
    } = t.interpolation;
    this.escape = n !== void 0 ? n : Dqe, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = i !== void 0 ? i : !1, this.prefix = o ? Zb(o) : s || "{{", this.suffix = l ? Zb(l) : c || "}}", this.formatSeparator = a || ",", this.unescapePrefix = u ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = d ? Zb(d) : p || Zb("$t("), this.nestingSuffix = h ? Zb(h) : m || Zb(")"), this.nestingOptionsSeparator = v || ",", this.maxReplaces = b || 1e3, this.alwaysFormat = A !== void 0 ? A : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, i) {
    let o, s, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, a = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const b = Gee(n, c, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, r, {
          ...i,
          ...n,
          interpolationkey: p
        }) : b;
      }
      const h = p.split(this.formatSeparator), m = h.shift().trim(), v = h.join(this.formatSeparator).trim();
      return this.format(Gee(n, c, m, this.options.keySeparator, this.options.ignoreJSONStructure), v, r, {
        ...i,
        ...n,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = i && i.missingInterpolationHandler || this.options.missingInterpolationHandler, f = i && i.interpolation && i.interpolation.skipOnVariables !== void 0 ? i.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => rF(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? rF(this.escape(p)) : rF(p)
    }].forEach((p) => {
      for (l = 0; o = p.regex.exec(t); ) {
        const h = o[1].trim();
        if (s = a(h), s === void 0)
          if (typeof u == "function") {
            const v = u(t, o, i);
            s = typeof v == "string" ? v : "";
          } else if (i && Object.prototype.hasOwnProperty.call(i, h))
            s = "";
          else if (f) {
            s = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), s = "";
        else typeof s != "string" && !this.useRawValueToEscape && (s = Bee(s));
        const m = p.safeValue(s);
        if (t = t.replace(o[0], m), f ? (p.regex.lastIndex += s.length, p.regex.lastIndex -= o[0].length) : p.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i, o, s;
    const l = (c, a) => {
      const u = this.nestingOptionsSeparator;
      if (c.indexOf(u) < 0) return c;
      const f = c.split(new RegExp(`${u}[ ]*{`));
      let d = `{${f[1]}`;
      c = f[0], d = this.interpolate(d, s);
      const p = d.match(/'/g), h = d.match(/"/g);
      (p && p.length % 2 === 0 && !h || h.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        s = JSON.parse(d), a && (s = {
          ...a,
          ...s
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, m), `${c}${u}${d}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, c;
    };
    for (; i = this.nestingRegexp.exec(t); ) {
      let c = [];
      s = {
        ...r
      }, s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let a = !1;
      if (i[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(i[1])) {
        const u = i[1].split(this.formatSeparator).map((f) => f.trim());
        i[1] = u.shift(), c = u, a = !0;
      }
      if (o = n(l.call(this, i[1].trim(), s), s), o && i[0] === t && typeof o != "string") return o;
      typeof o != "string" && (o = Bee(o)), o || (this.logger.warn(`missed to resolve ${i[1]} for nesting ${t}`), o = ""), a && (o = c.reduce((u, f) => this.format(u, f, r.lng, {
        ...r,
        interpolationkey: i[1].trim()
      }), o.trim())), t = t.replace(i[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const Zqe = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const i = r[1].substring(0, r[1].length - 1);
    t === "currency" && i.indexOf(":") < 0 ? n.currency || (n.currency = i.trim()) : t === "relativetime" && i.indexOf(":") < 0 ? n.range || (n.range = i.trim()) : i.split(";").forEach((s) => {
      if (s) {
        const [l, ...c] = s.split(":"), a = c.join(":").trim().replace(/^'+|'+$/g, ""), u = l.trim();
        n[u] || (n[u] = a), a === "false" && (n[u] = !1), a === "true" && (n[u] = !0), isNaN(a) || (n[u] = parseInt(a, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, Hb = (e) => {
  const t = {};
  return (n, r, i) => {
    let o = i;
    i && i.interpolationkey && i.formatParams && i.formatParams[i.interpolationkey] && i[i.interpolationkey] && (o = {
      ...o,
      [i.interpolationkey]: void 0
    });
    const s = r + JSON.stringify(o);
    let l = t[s];
    return l || (l = e(LM(r), i), t[s] = l), l(n);
  };
};
class Hqe {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = of.create("formatter"), this.options = t, this.formats = {
      number: Hb((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      }),
      currency: Hb((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (o) => i.format(o);
      }),
      datetime: Hb((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      }),
      relativetime: Hb((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (o) => i.format(o, r.range || "day");
      }),
      list: Hb((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (o) => i.format(o);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Hb(n);
  }
  format(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const o = n.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((l) => l.indexOf(")") > -1)) {
      const l = o.findIndex((c) => c.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, l)].join(this.formatSeparator);
    }
    return o.reduce((l, c) => {
      const {
        formatName: a,
        formatOptions: u
      } = Zqe(c);
      if (this.formats[a]) {
        let f = l;
        try {
          const d = i && i.formatParams && i.formatParams[i.interpolationkey] || {}, p = d.locale || d.lng || i.locale || i.lng || r;
          f = this.formats[a](l, p, {
            ...u,
            ...i,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${a}`);
      return l;
    }, t);
  }
}
const Qqe = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class $qe extends l2 {
  constructor(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = i, this.logger = of.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = i.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5, this.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, i.backend, i);
  }
  queueLoad(t, n, r, i) {
    const o = {}, s = {}, l = {}, c = {};
    return t.forEach((a) => {
      let u = !0;
      n.forEach((f) => {
        const d = `${a}|${f}`;
        !r.reload && this.store.hasResourceBundle(a, f) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? s[d] === void 0 && (s[d] = !0) : (this.state[d] = 1, u = !1, s[d] === void 0 && (s[d] = !0), o[d] === void 0 && (o[d] = !0), c[f] === void 0 && (c[f] = !0)));
      }), u || (l[a] = !0);
    }), (Object.keys(o).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: i
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, n, r) {
    const i = t.split("|"), o = i[0], s = i[1];
    n && this.emit("failedLoading", o, s, n), r && this.store.addResourceBundle(o, s, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2;
    const l = {};
    this.queue.forEach((c) => {
      Iqe(c.loaded, [o], s), Qqe(c, t), n && c.errors.push(n), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((a) => {
        l[a] || (l[a] = {});
        const u = c.loaded[a];
        u.length && u.forEach((f) => {
          l[a][f] === void 0 && (l[a][f] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, n, r) {
    let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: i,
        wait: o,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const l = (a, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (a && u && i < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, i + 1, o * 2, s);
        }, o);
        return;
      }
      s(a, u);
    }, c = this.backend[r].bind(this.backend);
    if (c.length === 2) {
      try {
        const a = c(t, n);
        a && typeof a.then == "function" ? a.then((u) => l(null, u)).catch(l) : l(null, a);
      } catch (a) {
        l(a);
      }
      return;
    }
    return c(t, n, l);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), i && i();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const o = this.queueLoad(t, n, r, i);
    if (!o.toLoad.length)
      return o.pending.length || i(), null;
    o.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), i = r[0], o = r[1];
    this.read(i, o, "read", void 0, void 0, (s, l) => {
      s && this.logger.warn(`${n}loading namespace ${o} for language ${i} failed`, s), !s && l && this.logger.log(`${n}loaded namespace ${o} for language ${i}`, l), this.loaded(t, s, l);
    });
  }
  saveMissing(t, n, r, i, o) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const c = {
          ...s,
          isUpdate: o
        }, a = this.backend.create.bind(this.backend);
        if (a.length < 6)
          try {
            let u;
            a.length === 5 ? u = a(t, n, r, i, c) : u = a(t, n, r, i), u && typeof u.then == "function" ? u.then((f) => l(null, f)).catch(l) : l(null, u);
          } catch (u) {
            l(u);
          }
        else
          a(t, n, r, i, l, c);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, i);
    }
  }
}
const Yee = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), typeof e[1] == "string" && (t.defaultValue = e[1]), typeof e[2] == "string" && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Jee = (e) => (typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), fP = () => {
}, Kqe = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class aT extends l2 {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Jee(t), this.services = {}, this.logger = of, this.modules = {
      external: []
    }, Kqe(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const i = Yee();
    this.options = {
      ...i,
      ...this.options,
      ...Jee(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...i.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const o = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? of.init(o(this.modules.logger), this.options) : of.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = Hqe);
      const f = new $ee(this.options);
      this.store = new Hee(this.options.resources, this.options);
      const d = this.services;
      d.logger = of, d.resourceStore = this.store, d.languageUtils = f, d.pluralResolver = new Xqe(f, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === i.interpolation.format) && (d.formatter = o(u), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Wqe(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new $qe(o(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(p) {
        for (var h = arguments.length, m = new Array(h > 1 ? h - 1 : 0), v = 1; v < h; v++)
          m[v - 1] = arguments[v];
        t.emit(p, ...m);
      }), this.modules.languageDetector && (d.languageDetector = o(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = o(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new zM(this.services, this.options), this.translator.on("*", function(p) {
        for (var h = arguments.length, m = new Array(h > 1 ? h - 1 : 0), v = 1; v < h; v++)
          m[v - 1] = arguments[v];
        t.emit(p, ...m);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = fP), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments), t;
      };
    });
    const c = $x(), a = () => {
      const u = (f, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), c.resolve(d), r(f, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? a() : setTimeout(a, 0), c;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fP;
    const i = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (i && i.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const o = [], s = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((a) => {
          a !== "cimode" && o.indexOf(a) < 0 && o.push(a);
        });
      };
      i ? s(i) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => s(c)), this.options.preload && this.options.preload.forEach((l) => s(l)), this.services.backendConnector.load(o, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(l);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const i = $x();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = fP), this.services.backendConnector.reload(t, n, (o) => {
      i.resolve(), r(o);
    }), i;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Cve.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const i = $x();
    this.emit("languageChanging", t);
    const o = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, s = (c, a) => {
      a ? (o(a), this.translator.changeLanguage(a), this.isLanguageChangingTo = void 0, this.emit("languageChanged", a), this.logger.log("languageChanged", a)) : this.isLanguageChangingTo = void 0, i.resolve(function() {
        return r.t(...arguments);
      }), n && n(c, function() {
        return r.t(...arguments);
      });
    }, l = (c) => {
      !t && !c && this.services.languageDetector && (c = []);
      const a = typeof c == "string" ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      a && (this.language || o(a), this.translator.language || this.translator.changeLanguage(a), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(a)), this.loadResources(a, (u) => {
        s(u, a);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(t), i;
  }
  getFixedT(t, n, r) {
    var i = this;
    const o = function(s, l) {
      let c;
      if (typeof l != "object") {
        for (var a = arguments.length, u = new Array(a > 2 ? a - 2 : 0), f = 2; f < a; f++)
          u[f - 2] = arguments[f];
        c = i.options.overloadTranslationOptionHandler([s, l].concat(u));
      } else
        c = {
          ...l
        };
      c.lng = c.lng || o.lng, c.lngs = c.lngs || o.lngs, c.ns = c.ns || o.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || r || o.keyPrefix);
      const d = i.options.keySeparator || ".";
      let p;
      return c.keyPrefix && Array.isArray(s) ? p = s.map((h) => `${c.keyPrefix}${d}${h}`) : p = c.keyPrefix ? `${c.keyPrefix}${d}${s}` : s, i.t(p, c);
    };
    return typeof t == "string" ? o.lng = t : o.lngs = t, o.ns = n, o.keyPrefix = r, o;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], i = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const s = (l, c) => {
      const a = this.services.backendConnector.state[`${l}|${c}`];
      return a === -1 || a === 2;
    };
    if (n.precheck) {
      const l = n.precheck(this, s);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(r, t) && (!i || s(o, t)));
  }
  loadNamespaces(t, n) {
    const r = $x();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((i) => {
      this.options.ns.indexOf(i) < 0 && this.options.ns.push(i);
    }), this.loadResources((i) => {
      r.resolve(), n && n(i);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = $x();
    typeof t == "string" && (t = [t]);
    const i = this.options.preload || [], o = t.filter((s) => i.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return o.length ? (this.options.preload = i.concat(o), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new $ee(Yee());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new aT(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fP;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const i = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new aT(i);
    return (t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      o[l] = this[l];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, r && (o.store = new Hee(this.store.data, i), o.services.resourceStore = o.store), o.translator = new zM(o.services, i), o.translator.on("*", function(l) {
      for (var c = arguments.length, a = new Array(c > 1 ? c - 1 : 0), u = 1; u < c; u++)
        a[u - 1] = arguments[u];
      o.emit(l, ...a);
    }), o.init(i, n), o.translator.options = i, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ur = aT.createInstance();
ur.createInstance = aT.createInstance;
ur.createInstance;
ur.dir;
ur.init;
ur.loadResources;
ur.reloadResources;
ur.use;
ur.changeLanguage;
ur.getFixedT;
const $g = ur.t;
ur.exists;
ur.setDefaultNamespace;
ur.hasLoadedNamespace;
ur.loadNamespaces;
ur.loadLanguages;
var lT = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function c2(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
const Gqe = (...e) => {
  console != null && console.warn && (tv(e[0]) && (e[0] = `react-i18next:: ${e[0]}`), console.warn(...e));
}, ete = {}, xq = (...e) => {
  tv(e[0]) && ete[e[0]] || (tv(e[0]) && (ete[e[0]] = /* @__PURE__ */ new Date()), Gqe(...e));
}, Nve = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, tte = (e, t, n) => {
  e.loadNamespaces(t, Nve(e, n));
}, nte = (e, t, n, r) => {
  tv(n) && (n = [n]), n.forEach((i) => {
    e.options.ns.indexOf(i) < 0 && e.options.ns.push(i);
  }), e.loadLanguages(t, Nve(e, r));
}, Yqe = (e, t, n = {}) => !t.languages || !t.languages.length ? (xq("i18n.languages were undefined or empty", t.languages), !0) : t.hasLoadedNamespace(e, {
  lng: n.lng,
  precheck: (r, i) => {
    var o;
    if (((o = n.bindI18n) == null ? void 0 : o.indexOf("languageChanging")) > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !i(r.isLanguageChangingTo, e)) return !1;
  }
}), tv = (e) => typeof e == "string", Jqe = (e) => typeof e == "object" && e !== null, eBe = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, tBe = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, nBe = (e) => tBe[e], rBe = (e) => e.replace(eBe, nBe);
let Sq = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: rBe
};
const iBe = (e = {}) => {
  Sq = {
    ...Sq,
    ...e
  };
}, oBe = () => Sq;
let Pve;
const sBe = (e) => {
  Pve = e;
}, aBe = () => Pve, lBe = {
  type: "3rdParty",
  init(e) {
    iBe(e.options.react), sBe(e);
  }
}, cBe = Ri();
class uBe {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      var r;
      (r = this.usedNamespaces)[n] ?? (r[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const dBe = (e, t) => {
  const n = Xe();
  return nt(() => {
    n.current = e;
  }, [e, t]), n.current;
}, Ive = (e, t, n, r) => e.getFixedT(t, n, r), fBe = (e, t, n, r) => qn(Ive(e, t, n, r), [e, t, n, r]), tc = (e, t = {}) => {
  var O, x, S, E;
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: i
  } = kr(cBe) || {}, o = n || r || aBe();
  if (o && !o.reportNamespaces && (o.reportNamespaces = new uBe()), !o) {
    xq("You will need to pass in an i18next instance by using initReactI18next");
    const k = (R, j) => tv(j) ? j : Jqe(j) && tv(j.defaultValue) ? j.defaultValue : Array.isArray(R) ? R[R.length - 1] : R, T = [k, {}, !1];
    return T.t = k, T.i18n = {}, T.ready = !1, T;
  }
  (O = o.options.react) != null && O.wait && xq("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const s = {
    ...oBe(),
    ...o.options.react,
    ...t
  }, {
    useSuspense: l,
    keyPrefix: c
  } = s;
  let a = i || ((x = o.options) == null ? void 0 : x.defaultNS);
  a = tv(a) ? [a] : a || ["translation"], (E = (S = o.reportNamespaces).addUsedNamespaces) == null || E.call(S, a);
  const u = (o.isInitialized || o.initializedStoreOnce) && a.every((k) => Yqe(k, o, s)), f = fBe(o, t.lng || null, s.nsMode === "fallback" ? a : a[0], c), d = () => f, p = () => Ive(o, t.lng || null, s.nsMode === "fallback" ? a : a[0], c), [h, m] = He(d);
  let v = a.join();
  t.lng && (v = `${t.lng}${v}`);
  const b = dBe(v), A = Xe(!0);
  nt(() => {
    const {
      bindI18n: k,
      bindI18nStore: T
    } = s;
    A.current = !0, !u && !l && (t.lng ? nte(o, t.lng, a, () => {
      A.current && m(p);
    }) : tte(o, a, () => {
      A.current && m(p);
    })), u && b && b !== v && A.current && m(p);
    const R = () => {
      A.current && m(p);
    };
    return k && (o == null || o.on(k, R)), T && (o == null || o.store.on(T, R)), () => {
      A.current = !1, o && (k == null || k.split(" ").forEach((j) => o.off(j, R))), T && o && T.split(" ").forEach((j) => o.store.off(j, R));
    };
  }, [o, v]), nt(() => {
    A.current && u && m(d);
  }, [o, c, u]);
  const w = [h, o, u];
  if (w.t = h, w.i18n = o, w.ready = u, u || !u && !l) return w;
  throw new Promise((k) => {
    t.lng ? nte(o, t.lng, a, () => k()) : tte(o, a, () => k());
  });
};
function pBe(e) {
  return vo(e) && !El(e) && !fC(e) && Symbol.asyncIterator in e;
}
function El(e) {
  return Array.isArray(e);
}
function Rve(e) {
  return typeof e == "bigint";
}
function dC(e) {
  return typeof e == "boolean";
}
function sW(e) {
  return e instanceof globalThis.Date;
}
function hBe(e) {
  return typeof e == "function";
}
function mBe(e) {
  return vo(e) && !El(e) && !fC(e) && Symbol.iterator in e;
}
function gBe(e) {
  return e === null;
}
function oh(e) {
  return typeof e == "number";
}
function vo(e) {
  return typeof e == "object" && e !== null;
}
function Mve(e) {
  return e instanceof globalThis.RegExp;
}
function Ki(e) {
  return typeof e == "string";
}
function yBe(e) {
  return typeof e == "symbol";
}
function fC(e) {
  return e instanceof globalThis.Uint8Array;
}
function Mo(e) {
  return e === void 0;
}
function vBe(e) {
  return e.map((t) => jM(t));
}
function bBe(e) {
  return new Date(e.getTime());
}
function OBe(e) {
  return new Uint8Array(e);
}
function ABe(e) {
  return new RegExp(e.source, e.flags);
}
function wBe(e) {
  const t = {};
  for (const n of Object.getOwnPropertyNames(e))
    t[n] = jM(e[n]);
  for (const n of Object.getOwnPropertySymbols(e))
    t[n] = jM(e[n]);
  return t;
}
function jM(e) {
  return El(e) ? vBe(e) : sW(e) ? bBe(e) : fC(e) ? OBe(e) : Mve(e) ? ABe(e) : vo(e) ? wBe(e) : e;
}
function du(e) {
  return jM(e);
}
function xBe(e, t) {
  return du(e);
}
function Dve(e) {
  return If(e) && Symbol.asyncIterator in e;
}
function _ve(e) {
  return If(e) && Symbol.iterator in e;
}
function Lve(e) {
  return e instanceof Promise;
}
function aW(e) {
  return e instanceof Date && Number.isFinite(e.getTime());
}
function lW(e) {
  return e instanceof globalThis.Uint8Array;
}
function zve(e, t) {
  return t in e;
}
function If(e) {
  return e !== null && typeof e == "object";
}
function cc(e) {
  return Array.isArray(e) && !ArrayBuffer.isView(e);
}
function Ag(e) {
  return e === void 0;
}
function u2(e) {
  return e === null;
}
function d2(e) {
  return typeof e == "boolean";
}
function Xn(e) {
  return typeof e == "number";
}
function jve(e) {
  return Number.isInteger(e);
}
function Rp(e) {
  return typeof e == "bigint";
}
function nc(e) {
  return typeof e == "string";
}
function Fve(e) {
  return typeof e == "function";
}
function f2(e) {
  return typeof e == "symbol";
}
function Uve(e) {
  return Rp(e) || d2(e) || u2(e) || Xn(e) || nc(e) || f2(e) || Ag(e);
}
var $i;
(function(e) {
  e.InstanceMode = "default", e.ExactOptionalPropertyTypes = !1, e.AllowArrayObject = !1, e.AllowNaN = !1, e.AllowNullVoid = !1;
  function t(s, l) {
    return e.ExactOptionalPropertyTypes ? l in s : s[l] !== void 0;
  }
  e.IsExactOptionalProperty = t;
  function n(s) {
    const l = If(s);
    return e.AllowArrayObject ? l : l && !cc(s);
  }
  e.IsObjectLike = n;
  function r(s) {
    return n(s) && !(s instanceof Date) && !(s instanceof Uint8Array);
  }
  e.IsRecordLike = r;
  function i(s) {
    return e.AllowNaN ? Xn(s) : Number.isFinite(s);
  }
  e.IsNumberLike = i;
  function o(s) {
    const l = Ag(s);
    return e.AllowNullVoid ? l || s === null : l;
  }
  e.IsVoidLike = o;
})($i || ($i = {}));
function SBe(e) {
  return globalThis.Object.freeze(e).map((t) => FM(t));
}
function EBe(e) {
  const t = {};
  for (const n of Object.getOwnPropertyNames(e))
    t[n] = FM(e[n]);
  for (const n of Object.getOwnPropertySymbols(e))
    t[n] = FM(e[n]);
  return globalThis.Object.freeze(t);
}
function FM(e) {
  return El(e) ? SBe(e) : sW(e) ? e : fC(e) ? e : Mve(e) ? e : vo(e) ? EBe(e) : e;
}
function Ft(e, t) {
  const n = t !== void 0 ? { ...t, ...e } : e;
  switch ($i.InstanceMode) {
    case "freeze":
      return FM(n);
    case "clone":
      return du(n);
    default:
      return n;
  }
}
class Ns extends Error {
  constructor(t) {
    super(t);
  }
}
const Qs = Symbol.for("TypeBox.Transform"), pC = Symbol.for("TypeBox.Readonly"), Ah = Symbol.for("TypeBox.Optional"), p2 = Symbol.for("TypeBox.Hint"), Ut = Symbol.for("TypeBox.Kind");
function Vve(e) {
  return vo(e) && e[pC] === "Readonly";
}
function ab(e) {
  return vo(e) && e[Ah] === "Optional";
}
function qve(e) {
  return mr(e, "Any");
}
function hC(e) {
  return mr(e, "Array");
}
function cW(e) {
  return mr(e, "AsyncIterator");
}
function Bve(e) {
  return mr(e, "BigInt");
}
function Xve(e) {
  return mr(e, "Boolean");
}
function Ym(e) {
  return mr(e, "Computed");
}
function uW(e) {
  return mr(e, "Constructor");
}
function TBe(e) {
  return mr(e, "Date");
}
function dW(e) {
  return mr(e, "Function");
}
function h2(e) {
  return mr(e, "Integer");
}
function ud(e) {
  return mr(e, "Intersect");
}
function fW(e) {
  return mr(e, "Iterator");
}
function mr(e, t) {
  return vo(e) && Ut in e && e[Ut] === t;
}
function Wve(e) {
  return dC(e) || oh(e) || Ki(e);
}
function mC(e) {
  return mr(e, "Literal");
}
function lb(e) {
  return mr(e, "MappedKey");
}
function mc(e) {
  return mr(e, "MappedResult");
}
function gC(e) {
  return mr(e, "Never");
}
function kBe(e) {
  return mr(e, "Not");
}
function CBe(e) {
  return mr(e, "Null");
}
function m2(e) {
  return mr(e, "Number");
}
function Rf(e) {
  return mr(e, "Object");
}
function pW(e) {
  return mr(e, "Promise");
}
function Zve(e) {
  return mr(e, "Record");
}
function Ol(e) {
  return mr(e, "Ref");
}
function Hve(e) {
  return mr(e, "RegExp");
}
function hW(e) {
  return mr(e, "String");
}
function NBe(e) {
  return mr(e, "Symbol");
}
function cb(e) {
  return mr(e, "TemplateLiteral");
}
function PBe(e) {
  return mr(e, "This");
}
function Ai(e) {
  return vo(e) && Qs in e;
}
function Lw(e) {
  return mr(e, "Tuple");
}
function mW(e) {
  return mr(e, "Undefined");
}
function Ps(e) {
  return mr(e, "Union");
}
function IBe(e) {
  return mr(e, "Uint8Array");
}
function RBe(e) {
  return mr(e, "Unknown");
}
function MBe(e) {
  return mr(e, "Unsafe");
}
function DBe(e) {
  return mr(e, "Void");
}
function _Be(e) {
  return vo(e) && Ut in e && Ki(e[Ut]);
}
function Ta(e) {
  return qve(e) || hC(e) || Xve(e) || Bve(e) || cW(e) || Ym(e) || uW(e) || TBe(e) || dW(e) || h2(e) || ud(e) || fW(e) || mC(e) || lb(e) || mc(e) || gC(e) || kBe(e) || CBe(e) || m2(e) || Rf(e) || pW(e) || Zve(e) || Ol(e) || Hve(e) || hW(e) || NBe(e) || cb(e) || PBe(e) || Lw(e) || mW(e) || Ps(e) || IBe(e) || RBe(e) || MBe(e) || DBe(e) || _Be(e);
}
const LBe = [
  "Any",
  "Array",
  "AsyncIterator",
  "BigInt",
  "Boolean",
  "Computed",
  "Constructor",
  "Date",
  "Enum",
  "Function",
  "Integer",
  "Intersect",
  "Iterator",
  "Literal",
  "MappedKey",
  "MappedResult",
  "Not",
  "Null",
  "Number",
  "Object",
  "Promise",
  "Record",
  "Ref",
  "RegExp",
  "String",
  "Symbol",
  "TemplateLiteral",
  "This",
  "Tuple",
  "Undefined",
  "Union",
  "Uint8Array",
  "Unknown",
  "Void"
];
function Qve(e) {
  try {
    return new RegExp(e), !0;
  } catch {
    return !1;
  }
}
function gW(e) {
  if (!Ki(e))
    return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e.charCodeAt(t);
    if (n >= 7 && n <= 13 || n === 27 || n === 127)
      return !1;
  }
  return !0;
}
function $ve(e) {
  return yW(e) || ki(e);
}
function Kx(e) {
  return Mo(e) || Rve(e);
}
function Wr(e) {
  return Mo(e) || oh(e);
}
function yW(e) {
  return Mo(e) || dC(e);
}
function Ur(e) {
  return Mo(e) || Ki(e);
}
function zBe(e) {
  return Mo(e) || Ki(e) && gW(e) && Qve(e);
}
function jBe(e) {
  return Mo(e) || Ki(e) && gW(e);
}
function Kve(e) {
  return Mo(e) || ki(e);
}
function UM(e) {
  return vo(e) && e[Ah] === "Optional";
}
function $u(e) {
  return gr(e, "Any") && Ur(e.$id);
}
function ub(e) {
  return gr(e, "Array") && e.type === "array" && Ur(e.$id) && ki(e.items) && Wr(e.minItems) && Wr(e.maxItems) && yW(e.uniqueItems) && Kve(e.contains) && Wr(e.minContains) && Wr(e.maxContains);
}
function vW(e) {
  return gr(e, "AsyncIterator") && e.type === "AsyncIterator" && Ur(e.$id) && ki(e.items);
}
function g2(e) {
  return gr(e, "BigInt") && e.type === "bigint" && Ur(e.$id) && Kx(e.exclusiveMaximum) && Kx(e.exclusiveMinimum) && Kx(e.maximum) && Kx(e.minimum) && Kx(e.multipleOf);
}
function db(e) {
  return gr(e, "Boolean") && e.type === "boolean" && Ur(e.$id);
}
function FBe(e) {
  return gr(e, "Computed") && Ki(e.target) && El(e.parameters) && e.parameters.every((t) => ki(t));
}
function y2(e) {
  return gr(e, "Constructor") && e.type === "Constructor" && Ur(e.$id) && El(e.parameters) && e.parameters.every((t) => ki(t)) && ki(e.returns);
}
function v2(e) {
  return gr(e, "Date") && e.type === "Date" && Ur(e.$id) && Wr(e.exclusiveMaximumTimestamp) && Wr(e.exclusiveMinimumTimestamp) && Wr(e.maximumTimestamp) && Wr(e.minimumTimestamp) && Wr(e.multipleOfTimestamp);
}
function b2(e) {
  return gr(e, "Function") && e.type === "Function" && Ur(e.$id) && El(e.parameters) && e.parameters.every((t) => ki(t)) && ki(e.returns);
}
function wh(e) {
  return gr(e, "Integer") && e.type === "integer" && Ur(e.$id) && Wr(e.exclusiveMaximum) && Wr(e.exclusiveMinimum) && Wr(e.maximum) && Wr(e.minimum) && Wr(e.multipleOf);
}
function Gve(e) {
  return vo(e) && Object.entries(e).every(([t, n]) => gW(t) && ki(n));
}
function fb(e) {
  return gr(e, "Intersect") && !(Ki(e.type) && e.type !== "object") && El(e.allOf) && e.allOf.every((t) => ki(t) && !WBe(t)) && Ur(e.type) && (yW(e.unevaluatedProperties) || Kve(e.unevaluatedProperties)) && Ur(e.$id);
}
function bW(e) {
  return gr(e, "Iterator") && e.type === "Iterator" && Ur(e.$id) && ki(e.items);
}
function gr(e, t) {
  return vo(e) && Ut in e && e[Ut] === t;
}
function Yve(e) {
  return wg(e) && Ki(e.const);
}
function Jve(e) {
  return wg(e) && oh(e.const);
}
function ebe(e) {
  return wg(e) && dC(e.const);
}
function wg(e) {
  return gr(e, "Literal") && Ur(e.$id) && UBe(e.const);
}
function UBe(e) {
  return dC(e) || oh(e) || Ki(e);
}
function VBe(e) {
  return gr(e, "MappedKey") && El(e.keys) && e.keys.every((t) => oh(t) || Ki(t));
}
function qBe(e) {
  return gr(e, "MappedResult") && Gve(e.properties);
}
function xg(e) {
  return gr(e, "Never") && vo(e.not) && Object.getOwnPropertyNames(e.not).length === 0;
}
function zA(e) {
  return gr(e, "Not") && ki(e.not);
}
function OW(e) {
  return gr(e, "Null") && e.type === "null" && Ur(e.$id);
}
function sl(e) {
  return gr(e, "Number") && e.type === "number" && Ur(e.$id) && Wr(e.exclusiveMaximum) && Wr(e.exclusiveMinimum) && Wr(e.maximum) && Wr(e.minimum) && Wr(e.multipleOf);
}
function Mi(e) {
  return gr(e, "Object") && e.type === "object" && Ur(e.$id) && Gve(e.properties) && $ve(e.additionalProperties) && Wr(e.minProperties) && Wr(e.maxProperties);
}
function AW(e) {
  return gr(e, "Promise") && e.type === "Promise" && Ur(e.$id) && ki(e.item);
}
function Ts(e) {
  return gr(e, "Record") && e.type === "object" && Ur(e.$id) && $ve(e.additionalProperties) && vo(e.patternProperties) && ((t) => {
    const n = Object.getOwnPropertyNames(t.patternProperties);
    return n.length === 1 && Qve(n[0]) && vo(t.patternProperties) && ki(t.patternProperties[n[0]]);
  })(e);
}
function BBe(e) {
  return gr(e, "Ref") && Ur(e.$id) && Ki(e.$ref);
}
function cT(e) {
  return gr(e, "RegExp") && Ur(e.$id) && Ki(e.source) && Ki(e.flags) && Wr(e.maxLength) && Wr(e.minLength);
}
function Ku(e) {
  return gr(e, "String") && e.type === "string" && Ur(e.$id) && Wr(e.minLength) && Wr(e.maxLength) && zBe(e.pattern) && jBe(e.format);
}
function uT(e) {
  return gr(e, "Symbol") && e.type === "symbol" && Ur(e.$id);
}
function dT(e) {
  return gr(e, "TemplateLiteral") && e.type === "string" && Ki(e.pattern) && e.pattern[0] === "^" && e.pattern[e.pattern.length - 1] === "$";
}
function XBe(e) {
  return gr(e, "This") && Ur(e.$id) && Ki(e.$ref);
}
function WBe(e) {
  return vo(e) && Qs in e;
}
function O2(e) {
  return gr(e, "Tuple") && e.type === "array" && Ur(e.$id) && oh(e.minItems) && oh(e.maxItems) && e.minItems === e.maxItems && // empty
  (Mo(e.items) && Mo(e.additionalItems) && e.minItems === 0 || El(e.items) && e.items.every((t) => ki(t)));
}
function Av(e) {
  return gr(e, "Undefined") && e.type === "undefined" && Ur(e.$id);
}
function sh(e) {
  return gr(e, "Union") && Ur(e.$id) && vo(e) && El(e.anyOf) && e.anyOf.every((t) => ki(t));
}
function yC(e) {
  return gr(e, "Uint8Array") && e.type === "Uint8Array" && Ur(e.$id) && Wr(e.minByteLength) && Wr(e.maxByteLength);
}
function Gu(e) {
  return gr(e, "Unknown") && Ur(e.$id);
}
function ZBe(e) {
  return gr(e, "Unsafe");
}
function A2(e) {
  return gr(e, "Void") && e.type === "void" && Ur(e.$id);
}
function HBe(e) {
  return vo(e) && Ut in e && Ki(e[Ut]) && !LBe.includes(e[Ut]);
}
function ki(e) {
  return vo(e) && ($u(e) || ub(e) || db(e) || g2(e) || vW(e) || FBe(e) || y2(e) || v2(e) || b2(e) || wh(e) || fb(e) || bW(e) || wg(e) || VBe(e) || qBe(e) || xg(e) || zA(e) || OW(e) || sl(e) || Mi(e) || AW(e) || Ts(e) || BBe(e) || cT(e) || Ku(e) || uT(e) || dT(e) || XBe(e) || O2(e) || Av(e) || sh(e) || yC(e) || Gu(e) || ZBe(e) || A2(e) || HBe(e));
}
const QBe = "(true|false)", PR = "(0|[1-9][0-9]*)", tbe = "(.*)", $Be = "(?!.*)", fT = `^${PR}$`, pT = `^${tbe}$`, KBe = `^${$Be}$`, nbe = /* @__PURE__ */ new Map();
function wW(e) {
  return nbe.has(e);
}
function xW(e) {
  return nbe.get(e);
}
const rbe = /* @__PURE__ */ new Map();
function hT(e) {
  return rbe.has(e);
}
function SW(e) {
  return rbe.get(e);
}
function GBe(e, t) {
  return e.includes(t);
}
function YBe(e) {
  return [...new Set(e)];
}
function JBe(e, t) {
  return e.filter((n) => t.includes(n));
}
function eXe(e, t) {
  return e.reduce((n, r) => JBe(n, r), t);
}
function tXe(e) {
  return e.length === 1 ? e[0] : e.length > 1 ? eXe(e.slice(1), e[0]) : [];
}
function nXe(e) {
  const t = [];
  for (const n of e)
    t.push(...n);
  return t;
}
function mT(e) {
  return Ft({ [Ut]: "Any" }, e);
}
function EW(e, t) {
  return Ft({ [Ut]: "Array", type: "array", items: e }, t);
}
function TW(e, t) {
  return Ft({ [Ut]: "AsyncIterator", type: "AsyncIterator", items: e }, t);
}
function vi(e, t, n) {
  return Ft({ [Ut]: "Computed", target: e, parameters: t }, n);
}
function rXe(e, t) {
  const { [t]: n, ...r } = e;
  return r;
}
function uc(e, t) {
  return t.reduce((n, r) => rXe(n, r), e);
}
function Uo(e) {
  return Ft({ [Ut]: "Never", not: {} }, e);
}
function Is(e) {
  return Ft({
    [Ut]: "MappedResult",
    properties: e
  });
}
function kW(e, t, n) {
  return Ft({ [Ut]: "Constructor", type: "Constructor", parameters: e, returns: t }, n);
}
function vC(e, t, n) {
  return Ft({ [Ut]: "Function", type: "Function", parameters: e, returns: t }, n);
}
function Eq(e, t) {
  return Ft({ [Ut]: "Union", anyOf: e }, t);
}
function iXe(e) {
  return e.some((t) => ab(t));
}
function rte(e) {
  return e.map((t) => ab(t) ? oXe(t) : t);
}
function oXe(e) {
  return uc(e, [Ah]);
}
function sXe(e, t) {
  return iXe(e) ? hb(Eq(rte(e), t)) : Eq(rte(e), t);
}
function zw(e, t) {
  return e.length === 1 ? Ft(e[0], t) : e.length === 0 ? Uo(t) : sXe(e, t);
}
function Rs(e, t) {
  return e.length === 0 ? Uo(t) : e.length === 1 ? Ft(e[0], t) : Eq(e, t);
}
class ite extends Ns {
}
function aXe(e) {
  return e.replace(/\\\$/g, "$").replace(/\\\*/g, "*").replace(/\\\^/g, "^").replace(/\\\|/g, "|").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}
function CW(e, t, n) {
  return e[t] === n && e.charCodeAt(t - 1) !== 92;
}
function Up(e, t) {
  return CW(e, t, "(");
}
function gT(e, t) {
  return CW(e, t, ")");
}
function ibe(e, t) {
  return CW(e, t, "|");
}
function lXe(e) {
  if (!(Up(e, 0) && gT(e, e.length - 1)))
    return !1;
  let t = 0;
  for (let n = 0; n < e.length; n++)
    if (Up(e, n) && (t += 1), gT(e, n) && (t -= 1), t === 0 && n !== e.length - 1)
      return !1;
  return !0;
}
function cXe(e) {
  return e.slice(1, e.length - 1);
}
function uXe(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    if (Up(e, n) && (t += 1), gT(e, n) && (t -= 1), ibe(e, n) && t === 0)
      return !0;
  return !1;
}
function dXe(e) {
  for (let t = 0; t < e.length; t++)
    if (Up(e, t))
      return !0;
  return !1;
}
function fXe(e) {
  let [t, n] = [0, 0];
  const r = [];
  for (let o = 0; o < e.length; o++)
    if (Up(e, o) && (t += 1), gT(e, o) && (t -= 1), ibe(e, o) && t === 0) {
      const s = e.slice(n, o);
      s.length > 0 && r.push(jA(s)), n = o + 1;
    }
  const i = e.slice(n);
  return i.length > 0 && r.push(jA(i)), r.length === 0 ? { type: "const", const: "" } : r.length === 1 ? r[0] : { type: "or", expr: r };
}
function pXe(e) {
  function t(i, o) {
    if (!Up(i, o))
      throw new ite("TemplateLiteralParser: Index must point to open parens");
    let s = 0;
    for (let l = o; l < i.length; l++)
      if (Up(i, l) && (s += 1), gT(i, l) && (s -= 1), s === 0)
        return [o, l];
    throw new ite("TemplateLiteralParser: Unclosed group parens in expression");
  }
  function n(i, o) {
    for (let s = o; s < i.length; s++)
      if (Up(i, s))
        return [o, s];
    return [o, i.length];
  }
  const r = [];
  for (let i = 0; i < e.length; i++)
    if (Up(e, i)) {
      const [o, s] = t(e, i), l = e.slice(o, s + 1);
      r.push(jA(l)), i = s;
    } else {
      const [o, s] = n(e, i), l = e.slice(o, s);
      l.length > 0 && r.push(jA(l)), i = s - 1;
    }
  return r.length === 0 ? { type: "const", const: "" } : r.length === 1 ? r[0] : { type: "and", expr: r };
}
function jA(e) {
  return lXe(e) ? jA(cXe(e)) : uXe(e) ? fXe(e) : dXe(e) ? pXe(e) : { type: "const", const: aXe(e) };
}
function NW(e) {
  return jA(e.slice(1, e.length - 1));
}
class hXe extends Ns {
}
function mXe(e) {
  return e.type === "or" && e.expr.length === 2 && e.expr[0].type === "const" && e.expr[0].const === "0" && e.expr[1].type === "const" && e.expr[1].const === "[1-9][0-9]*";
}
function gXe(e) {
  return e.type === "or" && e.expr.length === 2 && e.expr[0].type === "const" && e.expr[0].const === "true" && e.expr[1].type === "const" && e.expr[1].const === "false";
}
function yXe(e) {
  return e.type === "const" && e.const === ".*";
}
function yT(e) {
  return mXe(e) || yXe(e) ? !1 : gXe(e) ? !0 : e.type === "and" ? e.expr.every((t) => yT(t)) : e.type === "or" ? e.expr.every((t) => yT(t)) : e.type === "const" ? !0 : (() => {
    throw new hXe("Unknown expression type");
  })();
}
function vXe(e) {
  const t = NW(e.pattern);
  return yT(t);
}
class bXe extends Ns {
}
function* obe(e) {
  if (e.length === 1)
    return yield* e[0];
  for (const t of e[0])
    for (const n of obe(e.slice(1)))
      yield `${t}${n}`;
}
function* OXe(e) {
  return yield* obe(e.expr.map((t) => [...w2(t)]));
}
function* AXe(e) {
  for (const t of e.expr)
    yield* w2(t);
}
function* wXe(e) {
  return yield e.const;
}
function* w2(e) {
  return e.type === "and" ? yield* OXe(e) : e.type === "or" ? yield* AXe(e) : e.type === "const" ? yield* wXe(e) : (() => {
    throw new bXe("Unknown expression");
  })();
}
function sbe(e) {
  const t = NW(e.pattern);
  return yT(t) ? [...w2(t)] : [];
}
function yo(e, t) {
  return Ft({
    [Ut]: "Literal",
    const: e,
    type: typeof e
  }, t);
}
function abe(e) {
  return Ft({ [Ut]: "Boolean", type: "boolean" }, e);
}
function PW(e) {
  return Ft({ [Ut]: "BigInt", type: "bigint" }, e);
}
function jw(e) {
  return Ft({ [Ut]: "Number", type: "number" }, e);
}
function vT(e) {
  return Ft({ [Ut]: "String", type: "string" }, e);
}
function* xXe(e) {
  const t = e.trim().replace(/"|'/g, "");
  return t === "boolean" ? yield abe() : t === "number" ? yield jw() : t === "bigint" ? yield PW() : t === "string" ? yield vT() : yield (() => {
    const n = t.split("|").map((r) => yo(r.trim()));
    return n.length === 0 ? Uo() : n.length === 1 ? n[0] : zw(n);
  })();
}
function* SXe(e) {
  if (e[1] !== "{") {
    const t = yo("$"), n = Tq(e.slice(1));
    return yield* [t, ...n];
  }
  for (let t = 2; t < e.length; t++)
    if (e[t] === "}") {
      const n = xXe(e.slice(2, t)), r = Tq(e.slice(t + 1));
      return yield* [...n, ...r];
    }
  yield yo(e);
}
function* Tq(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t] === "$") {
      const n = yo(e.slice(0, t)), r = SXe(e.slice(t));
      return yield* [n, ...r];
    }
  yield yo(e);
}
function EXe(e) {
  return [...Tq(e)];
}
class TXe extends Ns {
}
function kXe(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function lbe(e, t) {
  return cb(e) ? e.pattern.slice(1, e.pattern.length - 1) : Ps(e) ? `(${e.anyOf.map((n) => lbe(n, t)).join("|")})` : m2(e) ? `${t}${PR}` : h2(e) ? `${t}${PR}` : Bve(e) ? `${t}${PR}` : hW(e) ? `${t}${tbe}` : mC(e) ? `${t}${kXe(e.const.toString())}` : Xve(e) ? `${t}${QBe}` : (() => {
    throw new TXe(`Unexpected Kind '${e[Ut]}'`);
  })();
}
function ote(e) {
  return `^${e.map((t) => lbe(t, "")).join("")}$`;
}
function VM(e) {
  const n = sbe(e).map((r) => yo(r));
  return zw(n);
}
function cbe(e, t) {
  const n = Ki(e) ? ote(EXe(e)) : ote(e);
  return Ft({ [Ut]: "TemplateLiteral", type: "string", pattern: n }, t);
}
function CXe(e) {
  return sbe(e).map((n) => n.toString());
}
function NXe(e) {
  const t = [];
  for (const n of e)
    t.push(...Sg(n));
  return t;
}
function PXe(e) {
  return [e.toString()];
}
function Sg(e) {
  return [...new Set(cb(e) ? CXe(e) : Ps(e) ? NXe(e.anyOf) : mC(e) ? PXe(e.const) : m2(e) ? ["[number]"] : h2(e) ? ["[number]"] : [])];
}
function IXe(e, t, n) {
  const r = {};
  for (const i of Object.getOwnPropertyNames(t))
    r[i] = x2(e, Sg(t[i]), n);
  return r;
}
function RXe(e, t, n) {
  return IXe(e, t.properties, n);
}
function MXe(e, t, n) {
  const r = RXe(e, t, n);
  return Is(r);
}
function ube(e, t) {
  return e.map((n) => dbe(n, t));
}
function DXe(e) {
  return e.filter((t) => !gC(t));
}
function _Xe(e, t) {
  return hbe(DXe(ube(e, t)));
}
function LXe(e) {
  return e.some((t) => gC(t)) ? [] : e;
}
function zXe(e, t) {
  return zw(LXe(ube(e, t)));
}
function jXe(e, t) {
  return t in e ? e[t] : t === "[number]" ? zw(e) : Uo();
}
function FXe(e, t) {
  return t === "[number]" ? e : Uo();
}
function UXe(e, t) {
  return t in e ? e[t] : Uo();
}
function dbe(e, t) {
  return ud(e) ? _Xe(e.allOf, t) : Ps(e) ? zXe(e.anyOf, t) : Lw(e) ? jXe(e.items ?? [], t) : hC(e) ? FXe(e.items, t) : Rf(e) ? UXe(e.properties, t) : Uo();
}
function IW(e, t) {
  return t.map((n) => dbe(e, n));
}
function ste(e, t) {
  return zw(IW(e, t));
}
function x2(e, t, n) {
  if (Ol(e) || Ol(t)) {
    const r = "Index types using Ref parameters require both Type and Key to be of TSchema";
    if (!Ta(e) || !Ta(t))
      throw new Ns(r);
    return vi("Index", [e, t]);
  }
  return mc(t) ? MXe(e, t, n) : lb(t) ? XXe(e, t, n) : Ft(Ta(t) ? ste(e, Sg(t)) : ste(e, t), n);
}
function VXe(e, t, n) {
  return { [t]: x2(e, [t], du(n)) };
}
function qXe(e, t, n) {
  return t.reduce((r, i) => ({ ...r, ...VXe(e, i, n) }), {});
}
function BXe(e, t, n) {
  return qXe(e, t.keys, n);
}
function XXe(e, t, n) {
  const r = BXe(e, t, n);
  return Is(r);
}
function RW(e, t) {
  return Ft({ [Ut]: "Iterator", type: "Iterator", items: e }, t);
}
function WXe(e) {
  const t = [];
  for (let n in e)
    ab(e[n]) || t.push(n);
  return t;
}
function ZXe(e, t) {
  const n = WXe(e), r = n.length > 0 ? { [Ut]: "Object", type: "object", properties: e, required: n } : { [Ut]: "Object", type: "object", properties: e };
  return Ft(r, t);
}
var Js = ZXe;
function fbe(e, t) {
  return Ft({ [Ut]: "Promise", type: "Promise", item: e }, t);
}
function HXe(e) {
  return Ft(uc(e, [pC]));
}
function QXe(e) {
  return Ft({ ...e, [pC]: "Readonly" });
}
function $Xe(e, t) {
  return t === !1 ? HXe(e) : QXe(e);
}
function pb(e, t) {
  const n = t ?? !0;
  return mc(e) ? YXe(e, n) : $Xe(e, n);
}
function KXe(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = pb(e[r], t);
  return n;
}
function GXe(e, t) {
  return KXe(e.properties, t);
}
function YXe(e, t) {
  const n = GXe(e, t);
  return Is(n);
}
function Fw(e, t) {
  return Ft(e.length > 0 ? { [Ut]: "Tuple", type: "array", items: e, additionalItems: !1, minItems: e.length, maxItems: e.length } : { [Ut]: "Tuple", type: "array", minItems: e.length, maxItems: e.length }, t);
}
function pbe(e, t) {
  return e in t ? Pc(e, t[e]) : Is(t);
}
function JXe(e) {
  return { [e]: yo(e) };
}
function e9e(e) {
  const t = {};
  for (const n of e)
    t[n] = yo(n);
  return t;
}
function t9e(e, t) {
  return GBe(t, e) ? JXe(e) : e9e(t);
}
function n9e(e, t) {
  const n = t9e(e, t);
  return pbe(e, n);
}
function Gx(e, t) {
  return t.map((n) => Pc(e, n));
}
function r9e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(t))
    n[r] = Pc(e, t[r]);
  return n;
}
function Pc(e, t) {
  const n = { ...t };
  return (
    // unevaluated modifier types
    ab(t) ? hb(Pc(e, uc(t, [Ah]))) : Vve(t) ? pb(Pc(e, uc(t, [pC]))) : (
      // unevaluated mapped types
      mc(t) ? pbe(e, t.properties) : lb(t) ? n9e(e, t.keys) : (
        // unevaluated types
        uW(t) ? kW(Gx(e, t.parameters), Pc(e, t.returns), n) : dW(t) ? vC(Gx(e, t.parameters), Pc(e, t.returns), n) : cW(t) ? TW(Pc(e, t.items), n) : fW(t) ? RW(Pc(e, t.items), n) : ud(t) ? Eg(Gx(e, t.allOf), n) : Ps(t) ? Rs(Gx(e, t.anyOf), n) : Lw(t) ? Fw(Gx(e, t.items ?? []), n) : Rf(t) ? Js(r9e(e, t.properties), n) : hC(t) ? EW(Pc(e, t.items), n) : pW(t) ? fbe(Pc(e, t.item), n) : t
      )
    )
  );
}
function i9e(e, t) {
  const n = {};
  for (const r of e)
    n[r] = Pc(r, t);
  return n;
}
function o9e(e, t, n) {
  const r = Ta(e) ? Sg(e) : e, i = t({ [Ut]: "MappedKey", keys: r }), o = i9e(r, i);
  return Js(o, n);
}
function s9e(e) {
  return Ft(uc(e, [Ah]));
}
function a9e(e) {
  return Ft({ ...e, [Ah]: "Optional" });
}
function l9e(e, t) {
  return t === !1 ? s9e(e) : a9e(e);
}
function hb(e, t) {
  const n = t ?? !0;
  return mc(e) ? d9e(e, n) : l9e(e, n);
}
function c9e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = hb(e[r], t);
  return n;
}
function u9e(e, t) {
  return c9e(e.properties, t);
}
function d9e(e, t) {
  const n = u9e(e, t);
  return Is(n);
}
function kq(e, t = {}) {
  const n = e.every((i) => Rf(i)), r = Ta(t.unevaluatedProperties) ? { unevaluatedProperties: t.unevaluatedProperties } : {};
  return Ft(t.unevaluatedProperties === !1 || Ta(t.unevaluatedProperties) || n ? { ...r, [Ut]: "Intersect", type: "object", allOf: e } : { ...r, [Ut]: "Intersect", allOf: e }, t);
}
function f9e(e) {
  return e.every((t) => ab(t));
}
function p9e(e) {
  return uc(e, [Ah]);
}
function ate(e) {
  return e.map((t) => ab(t) ? p9e(t) : t);
}
function h9e(e, t) {
  return f9e(e) ? hb(kq(ate(e), t)) : kq(ate(e), t);
}
function hbe(e, t = {}) {
  if (e.length === 1)
    return Ft(e[0], t);
  if (e.length === 0)
    return Uo(t);
  if (e.some((n) => Ai(n)))
    throw new Error("Cannot intersect transform types");
  return h9e(e, t);
}
function Eg(e, t) {
  if (e.length === 1)
    return Ft(e[0], t);
  if (e.length === 0)
    return Uo(t);
  if (e.some((n) => Ai(n)))
    throw new Error("Cannot intersect transform types");
  return kq(e, t);
}
function mb(...e) {
  const [t, n] = typeof e[0] == "string" ? [e[0], e[1]] : [e[0].$id, e[1]];
  if (typeof t != "string")
    throw new Ns("Ref: $ref must be a string");
  return Ft({ [Ut]: "Ref", $ref: t }, n);
}
function m9e(e, t) {
  return vi("Awaited", [vi(e, t)]);
}
function g9e(e) {
  return vi("Awaited", [mb(e)]);
}
function y9e(e) {
  return Eg(mbe(e));
}
function v9e(e) {
  return Rs(mbe(e));
}
function b9e(e) {
  return S2(e);
}
function mbe(e) {
  return e.map((t) => S2(t));
}
function S2(e, t) {
  return Ft(Ym(e) ? m9e(e.target, e.parameters) : ud(e) ? y9e(e.allOf) : Ps(e) ? v9e(e.anyOf) : pW(e) ? b9e(e.item) : Ol(e) ? g9e(e.$ref) : e, t);
}
function gbe(e) {
  const t = [];
  for (const n of e)
    t.push(gb(n));
  return t;
}
function O9e(e) {
  const t = gbe(e);
  return nXe(t);
}
function A9e(e) {
  const t = gbe(e);
  return tXe(t);
}
function w9e(e) {
  return e.map((t, n) => n.toString());
}
function x9e(e) {
  return ["[number]"];
}
function S9e(e) {
  return globalThis.Object.getOwnPropertyNames(e);
}
function E9e(e) {
  return Cq ? globalThis.Object.getOwnPropertyNames(e).map((n) => n[0] === "^" && n[n.length - 1] === "$" ? n.slice(1, n.length - 1) : n) : [];
}
function gb(e) {
  return ud(e) ? O9e(e.allOf) : Ps(e) ? A9e(e.anyOf) : Lw(e) ? w9e(e.items ?? []) : hC(e) ? x9e(e.items) : Rf(e) ? S9e(e.properties) : Zve(e) ? E9e(e.patternProperties) : [];
}
let Cq = !1;
function FA(e) {
  Cq = !0;
  const t = gb(e);
  return Cq = !1, `^(${t.map((r) => `(${r})`).join("|")})$`;
}
function T9e(e, t) {
  return vi("KeyOf", [vi(e, t)]);
}
function k9e(e) {
  return vi("KeyOf", [mb(e)]);
}
function C9e(e, t) {
  const n = gb(e), r = N9e(n), i = zw(r);
  return Ft(i, t);
}
function N9e(e) {
  return e.map((t) => t === "[number]" ? jw() : yo(t));
}
function MW(e, t) {
  return Ym(e) ? T9e(e.target, e.parameters) : Ol(e) ? k9e(e.$ref) : mc(e) ? R9e(e, t) : C9e(e, t);
}
function P9e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = MW(e[r], du(t));
  return n;
}
function I9e(e, t) {
  return P9e(e.properties, t);
}
function R9e(e, t) {
  const n = I9e(e, t);
  return Is(n);
}
function ybe(e) {
  const t = gb(e), n = IW(e, t);
  return t.map((r, i) => [t[i], n[i]]);
}
function M9e(e) {
  const t = [];
  for (const n of e)
    t.push(...gb(n));
  return YBe(t);
}
function D9e(e) {
  return e.filter((t) => !gC(t));
}
function _9e(e, t) {
  const n = [];
  for (const r of e)
    n.push(...IW(r, [t]));
  return D9e(n);
}
function L9e(e, t) {
  const n = {};
  for (const r of t)
    n[r] = hbe(_9e(e, r));
  return n;
}
function z9e(e, t) {
  const n = M9e(e), r = L9e(e, n);
  return Js(r, t);
}
function vbe(e) {
  return Ft({ [Ut]: "Date", type: "Date" }, e);
}
function bbe(e) {
  return Ft({ [Ut]: "Null", type: "null" }, e);
}
function Obe(e) {
  return Ft({ [Ut]: "Symbol", type: "symbol" }, e);
}
function Abe(e) {
  return Ft({ [Ut]: "Undefined", type: "undefined" }, e);
}
function wbe(e) {
  return Ft({ [Ut]: "Uint8Array", type: "Uint8Array" }, e);
}
function DW(e) {
  return Ft({ [Ut]: "Unknown" }, e);
}
function j9e(e) {
  return e.map((t) => _W(t, !1));
}
function F9e(e) {
  const t = {};
  for (const n of globalThis.Object.getOwnPropertyNames(e))
    t[n] = pb(_W(e[n], !1));
  return t;
}
function pP(e, t) {
  return t === !0 ? e : pb(e);
}
function _W(e, t) {
  return pBe(e) || mBe(e) ? pP(mT(), t) : El(e) ? pb(Fw(j9e(e))) : fC(e) ? wbe() : sW(e) ? vbe() : vo(e) ? pP(Js(F9e(e)), t) : hBe(e) ? pP(vC([], DW()), t) : Mo(e) ? Abe() : gBe(e) ? bbe() : yBe(e) ? Obe() : Rve(e) ? PW() : oh(e) || dC(e) || Ki(e) ? yo(e) : Js({});
}
function U9e(e, t) {
  return Ft(_W(e, !0), t);
}
function V9e(e, t) {
  return Fw(e.parameters, t);
}
function q9e(e, t) {
  if (Mo(e))
    throw new Error("Enum undefined or empty");
  const n = globalThis.Object.getOwnPropertyNames(e).filter((o) => isNaN(o)).map((o) => e[o]), i = [...new Set(n)].map((o) => yo(o));
  return Rs(i, { ...t, [p2]: "Enum" });
}
class B9e extends Ns {
}
var Ye;
(function(e) {
  e[e.Union = 0] = "Union", e[e.True = 1] = "True", e[e.False = 2] = "False";
})(Ye || (Ye = {}));
function nu(e) {
  return e === Ye.False ? e : Ye.True;
}
function Uw(e) {
  throw new B9e(e);
}
function Oo(e) {
  return xg(e) || fb(e) || sh(e) || Gu(e) || $u(e);
}
function Ao(e, t) {
  return xg(t) ? Ebe() : fb(t) ? E2(e, t) : sh(t) ? zW(e, t) : Gu(t) ? Nbe() : $u(t) ? LW() : Uw("StructuralRight");
}
function LW(e, t) {
  return Ye.True;
}
function X9e(e, t) {
  return fb(t) ? E2(e, t) : sh(t) && t.anyOf.some((n) => $u(n) || Gu(n)) ? Ye.True : sh(t) ? Ye.Union : Gu(t) || $u(t) ? Ye.True : Ye.Union;
}
function W9e(e, t) {
  return Gu(e) ? Ye.False : $u(e) ? Ye.Union : xg(e) ? Ye.True : Ye.False;
}
function Z9e(e, t) {
  return Mi(t) && T2(t) ? Ye.True : Oo(t) ? Ao(e, t) : ub(t) ? nu(Fr(e.items, t.items)) : Ye.False;
}
function H9e(e, t) {
  return Oo(t) ? Ao(e, t) : vW(t) ? nu(Fr(e.items, t.items)) : Ye.False;
}
function Q9e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : g2(t) ? Ye.True : Ye.False;
}
function xbe(e, t) {
  return ebe(e) || db(e) ? Ye.True : Ye.False;
}
function $9e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : db(t) ? Ye.True : Ye.False;
}
function K9e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : y2(t) ? e.parameters.length > t.parameters.length ? Ye.False : e.parameters.every((n, r) => nu(Fr(t.parameters[r], n)) === Ye.True) ? nu(Fr(e.returns, t.returns)) : Ye.False : Ye.False;
}
function G9e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : v2(t) ? Ye.True : Ye.False;
}
function Y9e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : b2(t) ? e.parameters.length > t.parameters.length ? Ye.False : e.parameters.every((n, r) => nu(Fr(t.parameters[r], n)) === Ye.True) ? nu(Fr(e.returns, t.returns)) : Ye.False : Ye.False;
}
function Sbe(e, t) {
  return wg(e) && oh(e.const) || sl(e) || wh(e) ? Ye.True : Ye.False;
}
function J9e(e, t) {
  return wh(t) || sl(t) ? Ye.True : Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : Ye.False;
}
function E2(e, t) {
  return t.allOf.every((n) => Fr(e, n) === Ye.True) ? Ye.True : Ye.False;
}
function e8e(e, t) {
  return e.allOf.some((n) => Fr(n, t) === Ye.True) ? Ye.True : Ye.False;
}
function t8e(e, t) {
  return Oo(t) ? Ao(e, t) : bW(t) ? nu(Fr(e.items, t.items)) : Ye.False;
}
function n8e(e, t) {
  return wg(t) && t.const === e.const ? Ye.True : Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : Ku(t) ? Cbe(e) : sl(t) ? Tbe(e) : wh(t) ? Sbe(e) : db(t) ? xbe(e) : Ye.False;
}
function Ebe(e, t) {
  return Ye.False;
}
function r8e(e, t) {
  return Ye.True;
}
function lte(e) {
  let [t, n] = [e, 0];
  for (; zA(t); )
    t = t.not, n += 1;
  return n % 2 === 0 ? t : DW();
}
function i8e(e, t) {
  return zA(e) ? Fr(lte(e), t) : zA(t) ? Fr(e, lte(t)) : Uw("Invalid fallthrough for Not");
}
function o8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : OW(t) ? Ye.True : Ye.False;
}
function Tbe(e, t) {
  return Jve(e) || sl(e) || wh(e) ? Ye.True : Ye.False;
}
function s8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : wh(t) || sl(t) ? Ye.True : Ye.False;
}
function Al(e, t) {
  return Object.getOwnPropertyNames(e.properties).length === t;
}
function cte(e) {
  return T2(e);
}
function ute(e) {
  return Al(e, 0) || Al(e, 1) && "description" in e.properties && sh(e.properties.description) && e.properties.description.anyOf.length === 2 && (Ku(e.properties.description.anyOf[0]) && Av(e.properties.description.anyOf[1]) || Ku(e.properties.description.anyOf[1]) && Av(e.properties.description.anyOf[0]));
}
function iF(e) {
  return Al(e, 0);
}
function dte(e) {
  return Al(e, 0);
}
function a8e(e) {
  return Al(e, 0);
}
function l8e(e) {
  return Al(e, 0);
}
function c8e(e) {
  return T2(e);
}
function u8e(e) {
  const t = jw();
  return Al(e, 0) || Al(e, 1) && "length" in e.properties && nu(Fr(e.properties.length, t)) === Ye.True;
}
function d8e(e) {
  return Al(e, 0);
}
function T2(e) {
  const t = jw();
  return Al(e, 0) || Al(e, 1) && "length" in e.properties && nu(Fr(e.properties.length, t)) === Ye.True;
}
function f8e(e) {
  const t = vC([mT()], mT());
  return Al(e, 0) || Al(e, 1) && "then" in e.properties && nu(Fr(e.properties.then, t)) === Ye.True;
}
function kbe(e, t) {
  return Fr(e, t) === Ye.False || UM(e) && !UM(t) ? Ye.False : Ye.True;
}
function na(e, t) {
  return Gu(e) ? Ye.False : $u(e) ? Ye.Union : xg(e) || Yve(e) && cte(t) || Jve(e) && iF(t) || ebe(e) && dte(t) || uT(e) && ute(t) || g2(e) && a8e(t) || Ku(e) && cte(t) || uT(e) && ute(t) || sl(e) && iF(t) || wh(e) && iF(t) || db(e) && dte(t) || yC(e) && c8e(t) || v2(e) && l8e(t) || y2(e) && d8e(t) || b2(e) && u8e(t) ? Ye.True : Ts(e) && Ku(Nq(e)) ? t[p2] === "Record" ? Ye.True : Ye.False : Ts(e) && sl(Nq(e)) ? Al(t, 0) ? Ye.True : Ye.False : Ye.False;
}
function p8e(e, t) {
  return Oo(t) ? Ao(e, t) : Ts(t) ? fu(e, t) : Mi(t) ? (() => {
    for (const n of Object.getOwnPropertyNames(t.properties)) {
      if (!(n in e.properties) && !UM(t.properties[n]))
        return Ye.False;
      if (UM(t.properties[n]))
        return Ye.True;
      if (kbe(e.properties[n], t.properties[n]) === Ye.False)
        return Ye.False;
    }
    return Ye.True;
  })() : Ye.False;
}
function h8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) && f8e(t) ? Ye.True : AW(t) ? nu(Fr(e.item, t.item)) : Ye.False;
}
function Nq(e) {
  return fT in e.patternProperties ? jw() : pT in e.patternProperties ? vT() : Uw("Unknown record key pattern");
}
function Pq(e) {
  return fT in e.patternProperties ? e.patternProperties[fT] : pT in e.patternProperties ? e.patternProperties[pT] : Uw("Unable to get record value schema");
}
function fu(e, t) {
  const [n, r] = [Nq(t), Pq(t)];
  return Yve(e) && sl(n) && nu(Fr(e, r)) === Ye.True ? Ye.True : yC(e) && sl(n) || Ku(e) && sl(n) || ub(e) && sl(n) ? Fr(e, r) : Mi(e) ? (() => {
    for (const i of Object.getOwnPropertyNames(e.properties))
      if (kbe(r, e.properties[i]) === Ye.False)
        return Ye.False;
    return Ye.True;
  })() : Ye.False;
}
function m8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? Fr(Pq(e), Pq(t)) : Ye.False;
}
function g8e(e, t) {
  const n = cT(e) ? vT() : e, r = cT(t) ? vT() : t;
  return Fr(n, r);
}
function Cbe(e, t) {
  return wg(e) && Ki(e.const) || Ku(e) ? Ye.True : Ye.False;
}
function y8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : Ku(t) ? Ye.True : Ye.False;
}
function v8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : uT(t) ? Ye.True : Ye.False;
}
function b8e(e, t) {
  return dT(e) ? Fr(VM(e), t) : dT(t) ? Fr(e, VM(t)) : Uw("Invalid fallthrough for TemplateLiteral");
}
function O8e(e, t) {
  return ub(t) && e.items !== void 0 && e.items.every((n) => Fr(n, t.items) === Ye.True);
}
function A8e(e, t) {
  return xg(e) ? Ye.True : Gu(e) ? Ye.False : $u(e) ? Ye.Union : Ye.False;
}
function w8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) && T2(t) || ub(t) && O8e(e, t) ? Ye.True : O2(t) ? Mo(e.items) && !Mo(t.items) || !Mo(e.items) && Mo(t.items) ? Ye.False : Mo(e.items) && !Mo(t.items) || e.items.every((n, r) => Fr(n, t.items[r]) === Ye.True) ? Ye.True : Ye.False : Ye.False;
}
function x8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : yC(t) ? Ye.True : Ye.False;
}
function S8e(e, t) {
  return Oo(t) ? Ao(e, t) : Mi(t) ? na(e, t) : Ts(t) ? fu(e, t) : A2(t) ? k8e(e) : Av(t) ? Ye.True : Ye.False;
}
function zW(e, t) {
  return t.anyOf.some((n) => Fr(e, n) === Ye.True) ? Ye.True : Ye.False;
}
function E8e(e, t) {
  return e.anyOf.every((n) => Fr(n, t) === Ye.True) ? Ye.True : Ye.False;
}
function Nbe(e, t) {
  return Ye.True;
}
function T8e(e, t) {
  return xg(t) ? Ebe() : fb(t) ? E2(e, t) : sh(t) ? zW(e, t) : $u(t) ? LW() : Ku(t) ? Cbe(e) : sl(t) ? Tbe(e) : wh(t) ? Sbe(e) : db(t) ? xbe(e) : ub(t) ? W9e(e) : O2(t) ? A8e(e) : Mi(t) ? na(e, t) : Gu(t) ? Ye.True : Ye.False;
}
function k8e(e, t) {
  return Av(e) || Av(e) ? Ye.True : Ye.False;
}
function C8e(e, t) {
  return fb(t) ? E2(e, t) : sh(t) ? zW(e, t) : Gu(t) ? Nbe() : $u(t) ? LW() : Mi(t) ? na(e, t) : A2(t) ? Ye.True : Ye.False;
}
function Fr(e, t) {
  return (
    // resolvable
    dT(e) || dT(t) ? b8e(e, t) : cT(e) || cT(t) ? g8e(e, t) : zA(e) || zA(t) ? i8e(e, t) : (
      // standard
      $u(e) ? X9e(e, t) : ub(e) ? Z9e(e, t) : g2(e) ? Q9e(e, t) : db(e) ? $9e(e, t) : vW(e) ? H9e(e, t) : y2(e) ? K9e(e, t) : v2(e) ? G9e(e, t) : b2(e) ? Y9e(e, t) : wh(e) ? J9e(e, t) : fb(e) ? e8e(e, t) : bW(e) ? t8e(e, t) : wg(e) ? n8e(e, t) : xg(e) ? r8e() : OW(e) ? o8e(e, t) : sl(e) ? s8e(e, t) : Mi(e) ? p8e(e, t) : Ts(e) ? m8e(e, t) : Ku(e) ? y8e(e, t) : uT(e) ? v8e(e, t) : O2(e) ? w8e(e, t) : AW(e) ? h8e(e, t) : yC(e) ? x8e(e, t) : Av(e) ? S8e(e, t) : sh(e) ? E8e(e, t) : Gu(e) ? T8e(e, t) : A2(e) ? C8e(e, t) : Uw(`Unknown left type operand '${e[Ut]}'`)
    )
  );
}
function bC(e, t) {
  return Fr(e, t);
}
function N8e(e, t, n, r, i) {
  const o = {};
  for (const s of globalThis.Object.getOwnPropertyNames(e))
    o[s] = jW(e[s], t, n, r, du(i));
  return o;
}
function P8e(e, t, n, r, i) {
  return N8e(e.properties, t, n, r, i);
}
function I8e(e, t, n, r, i) {
  const o = P8e(e, t, n, r, i);
  return Is(o);
}
function R8e(e, t, n, r) {
  const i = bC(e, t);
  return i === Ye.Union ? Rs([n, r]) : i === Ye.True ? n : r;
}
function jW(e, t, n, r, i) {
  return mc(e) ? I8e(e, t, n, r, i) : lb(e) ? Ft(L8e(e, t, n, r, i)) : Ft(R8e(e, t, n, r), i);
}
function M8e(e, t, n, r, i) {
  return {
    [e]: jW(yo(e), t, n, r, du(i))
  };
}
function D8e(e, t, n, r, i) {
  return e.reduce((o, s) => ({ ...o, ...M8e(s, t, n, r, i) }), {});
}
function _8e(e, t, n, r, i) {
  return D8e(e.keys, t, n, r, i);
}
function L8e(e, t, n, r, i) {
  const o = _8e(e, t, n, r, i);
  return Is(o);
}
function z8e(e) {
  return e.allOf.every((t) => Vw(t));
}
function j8e(e) {
  return e.anyOf.some((t) => Vw(t));
}
function F8e(e) {
  return !Vw(e.not);
}
function Vw(e) {
  return e[Ut] === "Intersect" ? z8e(e) : e[Ut] === "Union" ? j8e(e) : e[Ut] === "Not" ? F8e(e) : e[Ut] === "Undefined";
}
function U8e(e, t) {
  return FW(VM(e), t);
}
function V8e(e, t) {
  const n = e.filter((r) => bC(r, t) === Ye.False);
  return n.length === 1 ? n[0] : Rs(n);
}
function FW(e, t, n = {}) {
  return cb(e) ? Ft(U8e(e, t), n) : mc(e) ? Ft(X8e(e, t), n) : Ft(Ps(e) ? V8e(e.anyOf, t) : bC(e, t) !== Ye.False ? Uo() : e, n);
}
function q8e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = FW(e[r], t);
  return n;
}
function B8e(e, t) {
  return q8e(e.properties, t);
}
function X8e(e, t) {
  const n = B8e(e, t);
  return Is(n);
}
function W8e(e, t) {
  return UW(VM(e), t);
}
function Z8e(e, t) {
  const n = e.filter((r) => bC(r, t) !== Ye.False);
  return n.length === 1 ? n[0] : Rs(n);
}
function UW(e, t, n) {
  return cb(e) ? Ft(W8e(e, t), n) : mc(e) ? Ft($8e(e, t), n) : Ft(Ps(e) ? Z8e(e.anyOf, t) : bC(e, t) !== Ye.False ? e : Uo(), n);
}
function H8e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = UW(e[r], t);
  return n;
}
function Q8e(e, t) {
  return H8e(e.properties, t);
}
function $8e(e, t) {
  const n = Q8e(e, t);
  return Is(n);
}
function K8e(e, t) {
  return Ft(e.returns, t);
}
function G8e(e) {
  return Ft({ [Ut]: "Integer", type: "integer" }, e);
}
function Y8e(e, t, n) {
  return {
    [e]: qw(yo(e), t, du(n))
  };
}
function J8e(e, t, n) {
  return e.reduce((i, o) => ({ ...i, ...Y8e(o, t, n) }), {});
}
function e7e(e, t, n) {
  return J8e(e.keys, t, n);
}
function t7e(e, t, n) {
  const r = e7e(e, t, n);
  return Is(r);
}
function n7e(e) {
  const [t, n] = [e.slice(0, 1), e.slice(1)];
  return [t.toLowerCase(), n].join("");
}
function r7e(e) {
  const [t, n] = [e.slice(0, 1), e.slice(1)];
  return [t.toUpperCase(), n].join("");
}
function i7e(e) {
  return e.toUpperCase();
}
function o7e(e) {
  return e.toLowerCase();
}
function s7e(e, t, n) {
  const r = NW(e.pattern);
  if (!yT(r))
    return { ...e, pattern: Pbe(e.pattern, t) };
  const s = [...w2(r)].map((a) => yo(a)), l = Ibe(s, t), c = Rs(l);
  return cbe([c], n);
}
function Pbe(e, t) {
  return typeof e == "string" ? t === "Uncapitalize" ? n7e(e) : t === "Capitalize" ? r7e(e) : t === "Uppercase" ? i7e(e) : t === "Lowercase" ? o7e(e) : e : e.toString();
}
function Ibe(e, t) {
  return e.map((n) => qw(n, t));
}
function qw(e, t, n = {}) {
  return (
    // Intrinsic-Mapped-Inference
    lb(e) ? t7e(e, t, n) : (
      // Standard-Inference
      cb(e) ? s7e(e, t, n) : Ps(e) ? Rs(Ibe(e.anyOf, t), n) : mC(e) ? yo(Pbe(e.const, t), n) : (
        // Default Type
        Ft(e, n)
      )
    )
  );
}
function a7e(e, t = {}) {
  return qw(e, "Capitalize", t);
}
function l7e(e, t = {}) {
  return qw(e, "Lowercase", t);
}
function c7e(e, t = {}) {
  return qw(e, "Uncapitalize", t);
}
function u7e(e, t = {}) {
  return qw(e, "Uppercase", t);
}
function d7e(e, t, n) {
  const r = {};
  for (const i of globalThis.Object.getOwnPropertyNames(e))
    r[i] = OC(e[i], t, du(n));
  return r;
}
function f7e(e, t, n) {
  return d7e(e.properties, t, n);
}
function p7e(e, t, n) {
  const r = f7e(e, t, n);
  return Is(r);
}
function h7e(e, t) {
  return e.map((n) => VW(n, t));
}
function m7e(e, t) {
  return e.map((n) => VW(n, t));
}
function g7e(e, t) {
  const { [t]: n, ...r } = e;
  return r;
}
function y7e(e, t) {
  return t.reduce((n, r) => g7e(n, r), e);
}
function v7e(e, t) {
  const n = uc(e, [Qs, "$id", "required", "properties"]), r = y7e(e.properties, t);
  return Js(r, n);
}
function b7e(e) {
  const t = e.reduce((n, r) => Wve(r) ? [...n, yo(r)] : n, []);
  return Rs(t);
}
function VW(e, t) {
  return ud(e) ? Eg(h7e(e.allOf, t)) : Ps(e) ? Rs(m7e(e.anyOf, t)) : Rf(e) ? v7e(e, t) : Js({});
}
function OC(e, t, n) {
  const r = El(t) ? b7e(t) : t, i = Ta(t) ? Sg(t) : t, o = Ol(e), s = Ol(t);
  return mc(e) ? p7e(e, i, n) : lb(t) ? x7e(e, t, n) : o && s ? vi("Omit", [e, r], n) : !o && s ? vi("Omit", [e, r], n) : o && !s ? vi("Omit", [e, r], n) : Ft({ ...VW(e, i), ...n });
}
function O7e(e, t, n) {
  return { [t]: OC(e, [t], du(n)) };
}
function A7e(e, t, n) {
  return t.reduce((r, i) => ({ ...r, ...O7e(e, i, n) }), {});
}
function w7e(e, t, n) {
  return A7e(e, t.keys, n);
}
function x7e(e, t, n) {
  const r = w7e(e, t, n);
  return Is(r);
}
function S7e(e, t, n) {
  const r = {};
  for (const i of globalThis.Object.getOwnPropertyNames(e))
    r[i] = AC(e[i], t, du(n));
  return r;
}
function E7e(e, t, n) {
  return S7e(e.properties, t, n);
}
function T7e(e, t, n) {
  const r = E7e(e, t, n);
  return Is(r);
}
function k7e(e, t) {
  return e.map((n) => qW(n, t));
}
function C7e(e, t) {
  return e.map((n) => qW(n, t));
}
function N7e(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function P7e(e, t) {
  const n = uc(e, [Qs, "$id", "required", "properties"]), r = N7e(e.properties, t);
  return Js(r, n);
}
function I7e(e) {
  const t = e.reduce((n, r) => Wve(r) ? [...n, yo(r)] : n, []);
  return Rs(t);
}
function qW(e, t) {
  return ud(e) ? Eg(k7e(e.allOf, t)) : Ps(e) ? Rs(C7e(e.anyOf, t)) : Rf(e) ? P7e(e, t) : Js({});
}
function AC(e, t, n) {
  const r = El(t) ? I7e(t) : t, i = Ta(t) ? Sg(t) : t, o = Ol(e), s = Ol(t);
  return mc(e) ? T7e(e, i, n) : lb(t) ? _7e(e, t, n) : o && s ? vi("Pick", [e, r], n) : !o && s ? vi("Pick", [e, r], n) : o && !s ? vi("Pick", [e, r], n) : Ft({ ...qW(e, i), ...n });
}
function R7e(e, t, n) {
  return {
    [t]: AC(e, [t], du(n))
  };
}
function M7e(e, t, n) {
  return t.reduce((r, i) => ({ ...r, ...R7e(e, i, n) }), {});
}
function D7e(e, t, n) {
  return M7e(e, t.keys, n);
}
function _7e(e, t, n) {
  const r = D7e(e, t, n);
  return Is(r);
}
function L7e(e, t) {
  return vi("Partial", [vi(e, t)]);
}
function z7e(e) {
  return vi("Partial", [mb(e)]);
}
function j7e(e) {
  const t = {};
  for (const n of globalThis.Object.getOwnPropertyNames(e))
    t[n] = hb(e[n]);
  return t;
}
function F7e(e) {
  const t = uc(e, [Qs, "$id", "required", "properties"]), n = j7e(e.properties);
  return Js(n, t);
}
function fte(e) {
  return e.map((t) => Rbe(t));
}
function Rbe(e) {
  return Ym(e) ? L7e(e.target, e.parameters) : Ol(e) ? z7e(e.$ref) : ud(e) ? Eg(fte(e.allOf)) : Ps(e) ? Rs(fte(e.anyOf)) : Rf(e) ? F7e(e) : Js({});
}
function BW(e, t) {
  return mc(e) ? q7e(e, t) : Ft({ ...Rbe(e), ...t });
}
function U7e(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = BW(e[r], du(t));
  return n;
}
function V7e(e, t) {
  return U7e(e.properties, t);
}
function q7e(e, t) {
  const n = V7e(e, t);
  return Is(n);
}
function yb(e, t, n) {
  return Ft({ [Ut]: "Record", type: "object", patternProperties: { [e]: t } }, n);
}
function XW(e, t, n) {
  const r = {};
  for (const i of e)
    r[i] = t;
  return Js(r, { ...n, [p2]: "Record" });
}
function B7e(e, t, n) {
  return vXe(e) ? XW(Sg(e), t, n) : yb(e.pattern, t, n);
}
function X7e(e, t, n) {
  return XW(Sg(Rs(e)), t, n);
}
function W7e(e, t, n) {
  return XW([e.toString()], t, n);
}
function Z7e(e, t, n) {
  return yb(e.source, t, n);
}
function H7e(e, t, n) {
  const r = Mo(e.pattern) ? pT : e.pattern;
  return yb(r, t, n);
}
function Q7e(e, t, n) {
  return yb(pT, t, n);
}
function $7e(e, t, n) {
  return yb(KBe, t, n);
}
function K7e(e, t, n) {
  return yb(fT, t, n);
}
function G7e(e, t, n) {
  return yb(fT, t, n);
}
function Mbe(e, t, n = {}) {
  return Ym(t) ? vi("Record", [e, vi(t.target, t.parameters)], n) : Ym(e) ? vi("Record", [vi(t.target, t.parameters), t], n) : Ol(e) ? vi("Record", [mb(e.$ref), t]) : Ps(e) ? X7e(e.anyOf, t, n) : cb(e) ? B7e(e, t, n) : mC(e) ? W7e(e.const, t, n) : h2(e) ? K7e(e, t, n) : m2(e) ? G7e(e, t, n) : Hve(e) ? Z7e(e, t, n) : hW(e) ? H7e(e, t, n) : qve(e) ? Q7e(e, t, n) : gC(e) ? $7e(e, t, n) : Uo(n);
}
function Y7e(e, t) {
  return vi("Required", [vi(e, t)]);
}
function J7e(e) {
  return vi("Required", [mb(e)]);
}
function eWe(e) {
  const t = {};
  for (const n of globalThis.Object.getOwnPropertyNames(e))
    t[n] = uc(e[n], [Ah]);
  return t;
}
function tWe(e) {
  const t = uc(e, [Qs, "$id", "required", "properties"]), n = eWe(e.properties);
  return Js(n, t);
}
function pte(e) {
  return e.map((t) => Dbe(t));
}
function Dbe(e) {
  return Ym(e) ? Y7e(e.target, e.parameters) : Ol(e) ? J7e(e.$ref) : ud(e) ? Eg(pte(e.allOf)) : Ps(e) ? Rs(pte(e.anyOf)) : Rf(e) ? tWe(e) : Js({});
}
function WW(e, t) {
  return mc(e) ? iWe(e, t) : Ft({ ...Dbe(e), ...t });
}
function nWe(e, t) {
  const n = {};
  for (const r of globalThis.Object.getOwnPropertyNames(e))
    n[r] = WW(e[r], t);
  return n;
}
function rWe(e, t) {
  return nWe(e.properties, t);
}
function iWe(e, t) {
  const n = rWe(e, t);
  return Is(n);
}
function oWe(e, t) {
  return t.map((n) => Ol(n) ? _be(e, n.$ref) : ru(e, n));
}
function _be(e, t) {
  return t in e ? Ol(e[t]) ? _be(e, e[t].$ref) : ru(e, e[t]) : Uo();
}
function sWe(e) {
  return S2(e[0]);
}
function aWe(e) {
  return x2(e[0], e[1]);
}
function lWe(e) {
  return MW(e[0]);
}
function cWe(e) {
  return BW(e[0]);
}
function uWe(e) {
  return OC(e[0], e[1]);
}
function dWe(e) {
  return AC(e[0], e[1]);
}
function fWe(e) {
  return Mbe(e[0], e[1]);
}
function pWe(e) {
  return WW(e[0]);
}
function hWe(e, t, n) {
  const r = oWe(e, n);
  return t === "Awaited" ? sWe(r) : t === "Index" ? aWe(r) : t === "KeyOf" ? lWe(r) : t === "Partial" ? cWe(r) : t === "Omit" ? uWe(r) : t === "Pick" ? dWe(r) : t === "Record" ? fWe(r) : t === "Required" ? pWe(r) : Uo();
}
function mWe(e, t) {
  return Js(globalThis.Object.keys(t).reduce((n, r) => ({ ...n, [r]: ru(e, t[r]) }), {}));
}
function gWe(e, t, n) {
  return kW(wC(e, t), ru(e, n));
}
function yWe(e, t, n) {
  return vC(wC(e, t), ru(e, n));
}
function vWe(e, t) {
  return Fw(wC(e, t));
}
function bWe(e, t) {
  return Eg(wC(e, t));
}
function OWe(e, t) {
  return Rs(wC(e, t));
}
function AWe(e, t) {
  return EW(ru(e, t));
}
function wWe(e, t) {
  return TW(ru(e, t));
}
function xWe(e, t) {
  return RW(ru(e, t));
}
function wC(e, t) {
  return t.map((n) => ru(e, n));
}
function ru(e, t) {
  return (
    // Modifier Unwrap - Reapplied via CreateType Options
    ab(t) ? Ft(ru(e, uc(t, [Ah])), t) : Vve(t) ? Ft(ru(e, uc(t, [pC])), t) : (
      // Traveral
      hC(t) ? Ft(AWe(e, t.items), t) : cW(t) ? Ft(wWe(e, t.items), t) : Ym(t) ? Ft(hWe(e, t.target, t.parameters)) : uW(t) ? Ft(gWe(e, t.parameters, t.returns), t) : dW(t) ? Ft(yWe(e, t.parameters, t.returns), t) : ud(t) ? Ft(bWe(e, t.allOf), t) : fW(t) ? Ft(xWe(e, t.items), t) : Rf(t) ? Ft(mWe(e, t.properties), t) : Lw(t) ? Ft(vWe(e, t.items || []), t) : Ps(t) ? Ft(OWe(e, t.anyOf), t) : t
    )
  );
}
function SWe(e, t) {
  return t in e ? ru(e, e[t]) : Uo();
}
function EWe(e) {
  return globalThis.Object.getOwnPropertyNames(e).reduce((t, n) => ({ ...t, [n]: SWe(e, n) }), {});
}
class TWe {
  constructor(t) {
    const n = EWe(t), r = this.WithIdentifiers(n);
    this.$defs = r;
  }
  /** `[Json]` Imports a Type by Key. */
  Import(t, n) {
    const r = { ...this.$defs, [t]: Ft(this.$defs[t], n) };
    return Ft({ [Ut]: "Import", $defs: r, $ref: t });
  }
  // prettier-ignore
  WithIdentifiers(t) {
    return globalThis.Object.getOwnPropertyNames(t).reduce((n, r) => ({ ...n, [r]: { ...t[r], $id: r } }), {});
  }
}
function kWe(e) {
  return new TWe(e);
}
function CWe(e, t) {
  return Ft({ [Ut]: "Not", not: e }, t);
}
function NWe(e, t) {
  return Fw(e.parameters, t);
}
function PWe(e) {
  return pb(hb(e));
}
let IWe = 0;
function RWe(e, t = {}) {
  Mo(t.$id) && (t.$id = `T${IWe++}`);
  const n = xBe(e({ [Ut]: "This", $ref: `${t.$id}` }));
  return n.$id = t.$id, Ft({ [p2]: "Recursive", ...n }, t);
}
function MWe(e, t) {
  const n = Ki(e) ? new globalThis.RegExp(e) : e;
  return Ft({ [Ut]: "RegExp", type: "RegExp", source: n.source, flags: n.flags }, t);
}
function DWe(e) {
  return ud(e) ? e.allOf : Ps(e) ? e.anyOf : Lw(e) ? e.items ?? [] : [];
}
function _We(e) {
  return DWe(e);
}
function LWe(e, t) {
  return Ft(e.returns, t);
}
class zWe {
  constructor(t) {
    this.schema = t;
  }
  Decode(t) {
    return new jWe(this.schema, t);
  }
}
class jWe {
  constructor(t, n) {
    this.schema = t, this.decode = n;
  }
  EncodeTransform(t, n) {
    const o = { Encode: (s) => n[Qs].Encode(t(s)), Decode: (s) => this.decode(n[Qs].Decode(s)) };
    return { ...n, [Qs]: o };
  }
  EncodeSchema(t, n) {
    const r = { Decode: this.decode, Encode: t };
    return { ...n, [Qs]: r };
  }
  Encode(t) {
    return Ai(this.schema) ? this.EncodeTransform(t, this.schema) : this.EncodeSchema(t, this.schema);
  }
}
function FWe(e) {
  return new zWe(e);
}
function UWe(e = {}) {
  return Ft({ [Ut]: e[Ut] ?? "Unsafe" }, e);
}
function VWe(e) {
  return Ft({ [Ut]: "Void", type: "void" }, e);
}
const qWe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: mT,
  Array: EW,
  AsyncIterator: TW,
  Awaited: S2,
  BigInt: PW,
  Boolean: abe,
  Capitalize: a7e,
  Composite: z9e,
  Const: U9e,
  Constructor: kW,
  ConstructorParameters: V9e,
  Date: vbe,
  Enum: q9e,
  Exclude: FW,
  Extends: jW,
  Extract: UW,
  Function: vC,
  Index: x2,
  InstanceType: K8e,
  Integer: G8e,
  Intersect: Eg,
  Iterator: RW,
  KeyOf: MW,
  Literal: yo,
  Lowercase: l7e,
  Mapped: o9e,
  Module: kWe,
  Never: Uo,
  Not: CWe,
  Null: bbe,
  Number: jw,
  Object: Js,
  Omit: OC,
  Optional: hb,
  Parameters: NWe,
  Partial: BW,
  Pick: AC,
  Promise: fbe,
  Readonly: pb,
  ReadonlyOptional: PWe,
  Record: Mbe,
  Recursive: RWe,
  Ref: mb,
  RegExp: MWe,
  Required: WW,
  Rest: _We,
  ReturnType: LWe,
  String: vT,
  Symbol: Obe,
  TemplateLiteral: cbe,
  Transform: FWe,
  Tuple: Fw,
  Uint8Array: wbe,
  Uncapitalize: c7e,
  Undefined: Abe,
  Union: Rs,
  Unknown: DW,
  Unsafe: UWe,
  Uppercase: u7e,
  Void: VWe
}, Symbol.toStringTag, { value: "Module" })), g = qWe, Tg = {
  defaultMerge: Symbol("deepmerge-ts: default merge"),
  skip: Symbol("deepmerge-ts: skip")
};
Tg.defaultMerge;
function BWe(e, t) {
  return t;
}
function XWe(e, t) {
  return e.filter((n) => n !== void 0);
}
var hte;
(function(e) {
  e[e.NOT = 0] = "NOT", e[e.RECORD = 1] = "RECORD", e[e.ARRAY = 2] = "ARRAY", e[e.SET = 3] = "SET", e[e.MAP = 4] = "MAP", e[e.OTHER = 5] = "OTHER";
})(hte || (hte = {}));
function mte(e) {
  return typeof e != "object" || e === null ? 0 : Array.isArray(e) ? 2 : HWe(e) ? 1 : e instanceof Set ? 3 : e instanceof Map ? 4 : 5;
}
function WWe(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of [
      ...Object.keys(n),
      ...Object.getOwnPropertySymbols(n)
    ])
      t.add(r);
  return t;
}
function ZWe(e, t) {
  return typeof e == "object" && Object.prototype.propertyIsEnumerable.call(e, t);
}
function Lbe(e) {
  return {
    *[Symbol.iterator]() {
      for (const t of e)
        for (const n of t)
          yield n;
    }
  };
}
const gte = /* @__PURE__ */ new Set([
  "[object Object]",
  "[object Module]"
]);
function HWe(e) {
  if (!gte.has(Object.prototype.toString.call(e)))
    return !1;
  const { constructor: t } = e;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(n === null || typeof n != "object" || !gte.has(Object.prototype.toString.call(n)) || !n.hasOwnProperty("isPrototypeOf"));
}
function QWe(e, t, n) {
  const r = {};
  for (const i of WWe(e)) {
    const o = [];
    for (const c of e)
      ZWe(c, i) && o.push(c[i]);
    if (o.length === 0)
      continue;
    const s = t.metaDataUpdater(n, {
      key: i,
      parents: e
    }), l = zbe(o, t, s);
    l !== Tg.skip && (i === "__proto__" ? Object.defineProperty(r, i, {
      value: l,
      configurable: !0,
      enumerable: !0,
      writable: !0
    }) : r[i] = l);
  }
  return r;
}
function $We(e) {
  return e.flat();
}
function KWe(e) {
  return new Set(Lbe(e));
}
function GWe(e) {
  return new Map(Lbe(e));
}
function YWe(e) {
  return e.at(-1);
}
const hP = {
  mergeRecords: QWe,
  mergeArrays: $We,
  mergeSets: KWe,
  mergeMaps: GWe,
  mergeOthers: YWe
};
function JWe(...e) {
  return eZe({})(...e);
}
function eZe(e, t) {
  const n = tZe(e, r);
  function r(...i) {
    return zbe(i, n, t);
  }
  return r;
}
function tZe(e, t) {
  return {
    defaultMergeFunctions: hP,
    mergeFunctions: {
      ...hP,
      ...Object.fromEntries(Object.entries(e).filter(([n, r]) => Object.hasOwn(hP, n)).map(([n, r]) => r === !1 ? [n, hP.mergeOthers] : [n, r]))
    },
    metaDataUpdater: e.metaDataUpdater ?? BWe,
    deepmerge: t,
    useImplicitDefaultMerging: e.enableImplicitDefaultMerging ?? !1,
    filterValues: e.filterValues === !1 ? void 0 : e.filterValues ?? XWe,
    actions: Tg
  };
}
function zbe(e, t, n) {
  var o;
  const r = ((o = t.filterValues) == null ? void 0 : o.call(t, e, n)) ?? e;
  if (r.length === 0)
    return;
  if (r.length === 1)
    return oF(r, t, n);
  const i = mte(r[0]);
  if (i !== 0 && i !== 5) {
    for (let s = 1; s < r.length; s++)
      if (mte(r[s]) !== i)
        return oF(r, t, n);
  }
  switch (i) {
    case 1:
      return nZe(r, t, n);
    case 2:
      return rZe(r, t, n);
    case 3:
      return iZe(r, t, n);
    case 4:
      return oZe(r, t, n);
    default:
      return oF(r, t, n);
  }
}
function nZe(e, t, n) {
  const r = t.mergeFunctions.mergeRecords(e, t, n);
  return r === Tg.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeRecords !== t.defaultMergeFunctions.mergeRecords ? t.defaultMergeFunctions.mergeRecords(e, t, n) : r;
}
function rZe(e, t, n) {
  const r = t.mergeFunctions.mergeArrays(e, t, n);
  return r === Tg.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeArrays !== t.defaultMergeFunctions.mergeArrays ? t.defaultMergeFunctions.mergeArrays(e) : r;
}
function iZe(e, t, n) {
  const r = t.mergeFunctions.mergeSets(e, t, n);
  return r === Tg.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeSets !== t.defaultMergeFunctions.mergeSets ? t.defaultMergeFunctions.mergeSets(e) : r;
}
function oZe(e, t, n) {
  const r = t.mergeFunctions.mergeMaps(e, t, n);
  return r === Tg.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeMaps !== t.defaultMergeFunctions.mergeMaps ? t.defaultMergeFunctions.mergeMaps(e) : r;
}
function oF(e, t, n) {
  const r = t.mergeFunctions.mergeOthers(e, t, n);
  return r === Tg.defaultMerge || t.useImplicitDefaultMerging && r === void 0 && t.mergeFunctions.mergeOthers !== t.defaultMergeFunctions.mergeOthers ? t.defaultMergeFunctions.mergeOthers(e) : r;
}
function xC(e) {
  return e != null && typeof e == "string";
}
function De(e) {
  return e == null;
}
function jbe(e, t, n) {
  const r = Array.isArray(t) ? t : t.match(/([^[.\]])+/g);
  r.reduce((i, o, s) => (i[o] === void 0 && (i[o] = {}), s === r.length - 1 && (i[o] = n), i[o]), e);
}
function Iq(e, t, n) {
  return [...e.slice(0, t), n, ...e.slice(t)];
}
function Fbe(e, t) {
  let n, r;
  return function(i, ...o) {
    const s = () => {
      e(...o);
    };
    r === i && clearTimeout(n), r = i, n = setTimeout(s, t);
  };
}
function hy(e, t) {
  return JWe(e, t);
}
function sZe(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/\s+/g, "-").replace(/_/g, "-").toLowerCase().replace(/^-+|-+$/g, "");
}
function Ube(e) {
  return e == null ? !0 : typeof e == "string" || Array.isArray(e) ? e.length === 0 : typeof e == "object" ? Object.keys(e).length === 0 : !1;
}
function aZe(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").replace(/\s+/g, " ").replace(/^[a-z]/, (t) => t.toUpperCase()).replace(/\b[a-z]/g, (t) => t.toUpperCase());
}
function lZe(e) {
  return e.replace(/([-_][a-z])/g, (t) => t.toUpperCase().replace("-", "").replace("_", ""));
}
function Vbe(e) {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}
function cZe(e, t) {
  return Object.keys(e).reduce((n, r) => (t(e[r], r) && (n[r] = e[r]), n), {});
}
function uZe(e, t) {
  const n = [];
  for (let r = 0; r < e.length; r += t)
    n.push(e.slice(r, r + t));
  return n;
}
function dZe(e, t) {
  const n = [], r = [];
  return e.forEach((i, o) => {
    t(i, o, e) ? n.push(i) : r.push(i);
  }), [n, r];
}
function fZe(e) {
  return e.filter((t, n, r) => n === r.findIndex((i) => JSON.stringify(i) === JSON.stringify(t)));
}
function pZe(e, t) {
  if (e.size !== t.size) return !1;
  for (const [n, r] of e)
    if (!t.has(n) || t.get(n) !== r) return !1;
  return !0;
}
function hZe({
  index: e,
  limit: t
}) {
  return e < 0 ? 0 : e >= t ? t - 1 : e;
}
function mZe(e, t) {
  const n = { ...e };
  for (const r of t)
    delete n[r];
  return n;
}
function gZe(e, t) {
  return Object.fromEntries(
    Object.entries(e).filter(([n]) => !t.includes(n))
  );
}
const yZe = (e, t) => t === void 0 ? {} : {
  [e]: t
}, qbe = (e, t) => De(t) ? {} : {
  [e]: t
};
function vZe(e, t) {
  const n = { ...e };
  for (const r of t)
    delete n[r];
  return n;
}
function bZe(e) {
  return bT(e, (t) => {
    if (xC(t)) {
      const n = /\u0000/g;
      return t.replace(n, "");
    }
    return t;
  });
}
function bT(e, t) {
  return De(e) ? e : xC(e) ? t(e) : Array.isArray(e) ? e.map((n) => bT(n, t)) : Qp(e) ? Object.fromEntries(
    Object.entries(e).map(([n, r]) => [n, bT(r, t)])
  ) : e;
}
async function Rq(e, t) {
  if (De(e))
    return e;
  if (xC(e))
    return await t(e);
  if (Array.isArray(e))
    return await Promise.all(e.map((r) => Rq(r, t)));
  if (Qp(e)) {
    const n = await Promise.all(
      Object.entries(e).map(async ([r, i]) => [r, await Rq(i, t)])
    );
    return Object.fromEntries(n);
  }
  return e;
}
const Qp = (e) => typeof e == "object" && e !== null && !Array.isArray(e);
function OZe(e, t) {
  const n = {};
  for (const r of e) {
    const i = t(r);
    n[i] || (n[i] = []), n[i].push(r);
  }
  return n;
}
function AZe(e, t, n, r) {
  if (e !== t)
    throw new Error(`${n} and ${r} should be equal`);
}
function qm(e, t) {
  if (e == null)
    throw new Error(`${t} is null or undefined`);
}
function wZe(e, t, n, r) {
  if (e === t)
    throw new Error(`${n} and ${r} should not be equal`);
}
const xZe = (e) => e !== void 0;
function SZe(e, t) {
  if (e !== null)
    throw new Error(`${t} should be null`);
}
function EZe(e, t) {
  if (qm(e, t), e.length === 0)
    throw new Error(`${t} should be not empty`);
}
const Or = {
  id: g.String(),
  created: g.String(),
  updated: g.String()
}, It = (e) => g.Optional(g.Unsafe({
  ...e,
  nullable: !0
}));
function UA(e) {
  const t = e.anyOf.map((n) => n.const);
  return g.Optional(g.Unsafe({ type: "string", enum: t, nullable: !0 }));
}
function SC(e, t, n) {
  return Ft({
    [Ut]: "DiscriminatedUnion",
    anyOf: t,
    discriminator: {
      propertyName: e
    }
  }, n);
}
var Wi = /* @__PURE__ */ ((e) => (e.DUTCH = "nl", e.ENGLISH = "en", e.GERMAN = "de", e.FRENCH = "fr", e.SPANISH = "es", e.JAPANESE = "ja", e.CHINESE_SIMPLIFIED = "zh", e.PORTUGUESE = "pt", e.ARABIC = "ar", e.KURDISH_SORANI = "ckb", e.CHINESE_TRADITIONAL = "zh-TW", e))(Wi || {}), Es = /* @__PURE__ */ ((e) => (e.READ_APP_CONNECTION = "READ_APP_CONNECTION", e.WRITE_APP_CONNECTION = "WRITE_APP_CONNECTION", e.READ_FLOW = "READ_FLOW", e.WRITE_FLOW = "WRITE_FLOW", e.UPDATE_FLOW_STATUS = "UPDATE_FLOW_STATUS", e.WRITE_INVITATION = "WRITE_INVITATION", e.READ_INVITATION = "READ_INVITATION", e.READ_PROJECT_MEMBER = "READ_PROJECT_MEMBER", e.WRITE_PROJECT_MEMBER = "WRITE_PROJECT_MEMBER", e.WRITE_PROJECT_RELEASE = "WRITE_PROJECT_RELEASE", e.READ_PROJECT_RELEASE = "READ_PROJECT_RELEASE", e.READ_RUN = "READ_RUN", e.WRITE_RUN = "WRITE_RUN", e.READ_FOLDER = "READ_FOLDER", e.WRITE_FOLDER = "WRITE_FOLDER", e.WRITE_ALERT = "WRITE_ALERT", e.READ_ALERT = "READ_ALERT", e.READ_MCP = "READ_MCP", e.WRITE_MCP = "WRITE_MCP", e.WRITE_PROJECT = "WRITE_PROJECT", e.READ_PROJECT = "READ_PROJECT", e.READ_TODOS = "READ_TODOS", e.WRITE_TODOS = "WRITE_TODOS", e.READ_TABLE = "READ_TABLE", e.WRITE_TABLE = "WRITE_TABLE", e))(Es || {}), ZW = /* @__PURE__ */ ((e) => (e.DEFAULT = "DEFAULT", e.CUSTOM = "CUSTOM", e))(ZW || {});
const wv = "^[^./]+$", _O = g.Object({
  filename: g.String(),
  data: g.Unknown(),
  type: g.Literal("file"),
  mimetype: g.Optional(g.String())
}), TZe = (e) => typeof e == "object" && e !== null && "type" in e && e.type === "file" && "filename" in e && "data" in e && e.data instanceof Buffer, Tl = g.Record(g.String(), g.Unknown());
async function Bbe(e) {
  try {
    return { data: await e(), error: null };
  } catch (t) {
    return { data: null, error: t };
  }
}
function kZe(e) {
  try {
    return { data: e(), error: null };
  } catch (t) {
    return { data: null, error: t };
  }
}
const Xbe = g.String({
  pattern: "^#[0-9A-Fa-f]{6}$"
});
var qM = /* @__PURE__ */ ((e) => (e.PRODUCTION = "prod", e.DEVELOPMENT = "dev", e.TESTING = "test", e))(qM || {}), Bw = /* @__PURE__ */ ((e) => (e.COMMUNITY = "ce", e.ENTERPRISE = "ee", e.CLOUD = "cloud", e))(Bw || {}), As = /* @__PURE__ */ ((e) => (e.SHOW_BADGES = "SHOW_BADGES", e.SHOW_POWERED_BY_IN_FORM = "SHOW_POWERED_BY_IN_FORM", e.CLOUD_AUTH_ENABLED = "CLOUD_AUTH_ENABLED", e.CAN_CONFIGURE_AI_PROVIDER = "CAN_CONFIGURE_AI_PROVIDER", e.AGENTS_CONFIGURED = "AGENTS_CONFIGURED", e.CURRENT_VERSION = "CURRENT_VERSION", e.EDITION = "EDITION", e.EMAIL_AUTH_ENABLED = "EMAIL_AUTH_ENABLED", e.EXECUTION_DATA_RETENTION_DAYS = "EXECUTION_DATA_RETENTION_DAYS", e.ENVIRONMENT = "ENVIRONMENT", e.PUBLIC_URL = "PUBLIC_URL", e.LATEST_VERSION = "LATEST_VERSION", e.PRIVACY_POLICY_URL = "PRIVACY_POLICY_URL", e.PIECES_SYNC_MODE = "PIECES_SYNC_MODE", e.PRIVATE_PIECES_ENABLED = "PRIVATE_PIECES_ENABLED", e.FLOW_RUN_MEMORY_LIMIT_KB = "FLOW_RUN_MEMORY_LIMIT_KB", e.FLOW_RUN_TIME_SECONDS = "FLOW_RUN_TIME_SECONDS", e.SHOW_COMMUNITY = "SHOW_COMMUNITY", e.SUPPORTED_APP_WEBHOOKS = "SUPPORTED_APP_WEBHOOKS", e.TELEMETRY_ENABLED = "TELEMETRY_ENABLED", e.TEMPLATES_PROJECT_ID = "TEMPLATES_PROJECT_ID", e.TERMS_OF_SERVICE_URL = "TERMS_OF_SERVICE_URL", e.THEME = "THEME", e.THIRD_PARTY_AUTH_PROVIDER_REDIRECT_URL = "THIRD_PARTY_AUTH_PROVIDER_REDIRECT_URL", e.THIRD_PARTY_AUTH_PROVIDERS_TO_SHOW_MAP = "THIRD_PARTY_AUTH_PROVIDERS_TO_SHOW_MAP", e.SAML_AUTH_ACS_URL = "SAML_AUTH_ACS_URL", e.USER_CREATED = "USER_CREATED", e.WEBHOOK_URL_PREFIX = "WEBHOOK_URL_PREFIX", e.ALLOW_NPM_PACKAGES_IN_CODE_STEP = "ALLOW_NPM_PACKAGES_IN_CODE_STEP", e.PAUSED_FLOW_TIMEOUT_DAYS = "PAUSED_FLOW_TIMEOUT_DAYS", e.WEBHOOK_TIMEOUT_SECONDS = "WEBHOOK_TIMEOUT_SECONDS", e.MAX_RECORDS_PER_TABLE = "MAX_RECORDS_PER_TABLE", e.MAX_FIELDS_PER_TABLE = "MAX_FIELDS_PER_TABLE", e.MAX_FILE_SIZE_MB = "MAX_FILE_SIZE_MB", e.MAX_MCPS_PER_PROJECT = "MAX_MCPS_PER_PROJECT", e.ENABLE_FLOW_ON_PUBLISH = "ENABLE_FLOW_ON_PUBLISH", e.SHOW_ALERTS = "SHOW_ALERTS", e.SHOW_PROJECT_MEMBERS = "SHOW_PROJECT_MEMBERS", e.TEMPLATES_CATEGORIES = "TEMPLATES_CATEGORIES", e.CAN_BUY_AI_CREDITS = "CAN_BUY_AI_CREDITS", e.CAN_BUY_ACTIVE_FLOWS = "CAN_BUY_ACTIVE_FLOWS", e.SHOW_BILLING_LIMITS_ON_SIDEBAR = "SHOW_BILLING_LIMITS_ON_SIDEBAR", e.SHOW_BILLING_PAGE = "SHOW_BILLING_PAGE", e))(As || {}), VA = /* @__PURE__ */ ((e) => (e.ARCHIVE = "ARCHIVE", e.REGISTRY = "REGISTRY", e))(VA || {}), k2 = /* @__PURE__ */ ((e) => (e.CUSTOM = "CUSTOM", e.OFFICIAL = "OFFICIAL", e))(k2 || {});
const Wbe = g.Object({
  packageType: g.Literal(
    "ARCHIVE"
    /* ARCHIVE */
  ),
  pieceType: g.Enum(k2),
  pieceName: g.String(),
  pieceVersion: g.String(),
  archiveId: g.String(),
  platformId: g.String()
}), HW = g.Object({
  packageType: g.Literal(
    "REGISTRY"
    /* REGISTRY */
  ),
  pieceType: g.Literal(
    "OFFICIAL"
    /* OFFICIAL */
  ),
  pieceName: g.String(),
  pieceVersion: g.String()
}), QW = g.Object({
  packageType: g.Literal(
    "REGISTRY"
    /* REGISTRY */
  ),
  pieceType: g.Literal(
    "CUSTOM"
    /* CUSTOM */
  ),
  pieceName: g.String(),
  pieceVersion: g.String(),
  platformId: g.String()
}), CZe = g.Union([HW, QW]), C2 = g.Union([Wbe, HW, QW]);
var Of = /* @__PURE__ */ ((e) => (e.ARTIFICIAL_INTELLIGENCE = "ARTIFICIAL_INTELLIGENCE", e.COMMUNICATION = "COMMUNICATION", e.COMMERCE = "COMMERCE", e.CORE = "CORE", e.UNIVERSAL_AI = "UNIVERSAL_AI", e.FLOW_CONTROL = "FLOW_CONTROL", e.BUSINESS_INTELLIGENCE = "BUSINESS_INTELLIGENCE", e.ACCOUNTING = "ACCOUNTING", e.PRODUCTIVITY = "PRODUCTIVITY", e.CONTENT_AND_FILES = "CONTENT_AND_FILES", e.DEVELOPER_TOOLS = "DEVELOPER_TOOLS", e.CUSTOMER_SUPPORT = "CUSTOMER_SUPPORT", e.FORMS_AND_SURVEYS = "FORMS_AND_SURVEYS", e.HUMAN_RESOURCES = "HUMAN_RESOURCES", e.PAYMENT_PROCESSING = "PAYMENT_PROCESSING", e.MARKETING = "MARKETING", e.SALES_AND_CRM = "SALES_AND_CRM", e))(Of || {});
const $W = "^[0-9]+\\.[0-9]+\\.[0-9]+$", NZe = new RegExp($W), PZe = "^([~^])?[0-9]+\\.[0-9]+\\.[0-9]+$", xv = g.String({
  pattern: $W
}), EC = g.String({
  pattern: PZe
});
var OT = /* @__PURE__ */ ((e) => (e.ACTION = "ACTION", e.TRIGGER = "TRIGGER", e.ACTION_AND_TRIGGER = "ACTION_AND_TRIGGER", e))(OT || {}), KW = /* @__PURE__ */ ((e) => (e.NAME = "NAME", e.UPDATED = "UPDATED", e.CREATED = "CREATED", e.POPULARITY = "POPULARITY", e))(KW || {}), GW = /* @__PURE__ */ ((e) => (e.ASC = "ASC", e.DESC = "DESC", e))(GW || {});
const IZe = g.Object({
  name: g.String(),
  scope: g.String()
}), RZe = g.Object({
  name: g.String()
}), MZe = g.Object({
  projectId: g.Optional(g.String()),
  release: g.Optional(xv),
  includeTags: g.Optional(g.Boolean()),
  includeHidden: g.Optional(g.Boolean()),
  edition: g.Optional(g.Enum(Bw)),
  searchQuery: g.Optional(g.String()),
  sortBy: g.Optional(g.Enum(KW)),
  orderBy: g.Optional(g.Enum(GW)),
  categories: g.Optional(g.Array(g.Enum(Of))),
  suggestionType: g.Optional(g.Enum(OT)),
  locale: g.Optional(g.String())
}), DZe = g.Object({
  release: xv,
  edition: g.Enum(Bw)
}), _Ze = g.Object({
  projectId: g.Optional(g.String()),
  release: xv,
  name: g.String(),
  edition: g.Optional(g.Enum(Bw))
}), LZe = g.Object({
  version: g.Optional(EC),
  projectId: g.Optional(g.String()),
  locale: g.Optional(g.String())
}), zZe = g.Record(xv, g.Object({})), jZe = g.Object({
  projectId: g.String(),
  pieceName: g.String({}),
  pieceVersion: EC,
  actionOrTriggerName: g.String({}),
  propertyName: g.String({}),
  flowId: g.String(),
  flowVersionId: g.String(),
  input: g.Any({}),
  searchValue: g.Optional(g.String())
});
var Zbe = /* @__PURE__ */ ((e) => (e.PLATFORM = "PLATFORM", e))(Zbe || {});
const FZe = g.Union([
  g.Object({
    packageType: g.Literal(VA.ARCHIVE),
    scope: g.Literal(
      "PLATFORM"
      /* PLATFORM */
    ),
    pieceName: g.String({
      minLength: 1
    }),
    pieceVersion: xv,
    pieceArchive: _O
  }, {
    title: "Private Piece"
  }),
  g.Object({
    projectId: g.String(),
    packageType: g.Literal(VA.REGISTRY),
    scope: g.Literal(
      "PLATFORM"
      /* PLATFORM */
    ),
    pieceName: g.String({
      minLength: 1
    }),
    pieceVersion: xv
  }, {
    title: "NPM Piece"
  })
]);
var sF, yte;
function N2() {
  return yte || (yte = 1, sF = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...t) => console.error("SEMVER", ...t) : () => {
  }), sF;
}
var aF, vte;
function P2() {
  if (vte) return aF;
  vte = 1;
  const e = "2.0.0", t = 256, n = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, r = 16, i = t - 6;
  return aF = {
    MAX_LENGTH: t,
    MAX_SAFE_COMPONENT_LENGTH: r,
    MAX_SAFE_BUILD_LENGTH: i,
    MAX_SAFE_INTEGER: n,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: e,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, aF;
}
var mP = { exports: {} }, bte;
function TC() {
  return bte || (bte = 1, function(e, t) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: n,
      MAX_SAFE_BUILD_LENGTH: r,
      MAX_LENGTH: i
    } = P2(), o = N2();
    t = e.exports = {};
    const s = t.re = [], l = t.safeRe = [], c = t.src = [], a = t.t = {};
    let u = 0;
    const f = "[a-zA-Z0-9-]", d = [
      ["\\s", 1],
      ["\\d", i],
      [f, r]
    ], p = (m) => {
      for (const [v, b] of d)
        m = m.split(`${v}*`).join(`${v}{0,${b}}`).split(`${v}+`).join(`${v}{1,${b}}`);
      return m;
    }, h = (m, v, b) => {
      const A = p(v), w = u++;
      o(m, w, v), a[m] = w, c[w] = v, s[w] = new RegExp(v, b ? "g" : void 0), l[w] = new RegExp(A, b ? "g" : void 0);
    };
    h("NUMERICIDENTIFIER", "0|[1-9]\\d*"), h("NUMERICIDENTIFIERLOOSE", "\\d+"), h("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${f}*`), h("MAINVERSION", `(${c[a.NUMERICIDENTIFIER]})\\.(${c[a.NUMERICIDENTIFIER]})\\.(${c[a.NUMERICIDENTIFIER]})`), h("MAINVERSIONLOOSE", `(${c[a.NUMERICIDENTIFIERLOOSE]})\\.(${c[a.NUMERICIDENTIFIERLOOSE]})\\.(${c[a.NUMERICIDENTIFIERLOOSE]})`), h("PRERELEASEIDENTIFIER", `(?:${c[a.NUMERICIDENTIFIER]}|${c[a.NONNUMERICIDENTIFIER]})`), h("PRERELEASEIDENTIFIERLOOSE", `(?:${c[a.NUMERICIDENTIFIERLOOSE]}|${c[a.NONNUMERICIDENTIFIER]})`), h("PRERELEASE", `(?:-(${c[a.PRERELEASEIDENTIFIER]}(?:\\.${c[a.PRERELEASEIDENTIFIER]})*))`), h("PRERELEASELOOSE", `(?:-?(${c[a.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${c[a.PRERELEASEIDENTIFIERLOOSE]})*))`), h("BUILDIDENTIFIER", `${f}+`), h("BUILD", `(?:\\+(${c[a.BUILDIDENTIFIER]}(?:\\.${c[a.BUILDIDENTIFIER]})*))`), h("FULLPLAIN", `v?${c[a.MAINVERSION]}${c[a.PRERELEASE]}?${c[a.BUILD]}?`), h("FULL", `^${c[a.FULLPLAIN]}$`), h("LOOSEPLAIN", `[v=\\s]*${c[a.MAINVERSIONLOOSE]}${c[a.PRERELEASELOOSE]}?${c[a.BUILD]}?`), h("LOOSE", `^${c[a.LOOSEPLAIN]}$`), h("GTLT", "((?:<|>)?=?)"), h("XRANGEIDENTIFIERLOOSE", `${c[a.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), h("XRANGEIDENTIFIER", `${c[a.NUMERICIDENTIFIER]}|x|X|\\*`), h("XRANGEPLAIN", `[v=\\s]*(${c[a.XRANGEIDENTIFIER]})(?:\\.(${c[a.XRANGEIDENTIFIER]})(?:\\.(${c[a.XRANGEIDENTIFIER]})(?:${c[a.PRERELEASE]})?${c[a.BUILD]}?)?)?`), h("XRANGEPLAINLOOSE", `[v=\\s]*(${c[a.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[a.XRANGEIDENTIFIERLOOSE]})(?:\\.(${c[a.XRANGEIDENTIFIERLOOSE]})(?:${c[a.PRERELEASELOOSE]})?${c[a.BUILD]}?)?)?`), h("XRANGE", `^${c[a.GTLT]}\\s*${c[a.XRANGEPLAIN]}$`), h("XRANGELOOSE", `^${c[a.GTLT]}\\s*${c[a.XRANGEPLAINLOOSE]}$`), h("COERCEPLAIN", `(^|[^\\d])(\\d{1,${n}})(?:\\.(\\d{1,${n}}))?(?:\\.(\\d{1,${n}}))?`), h("COERCE", `${c[a.COERCEPLAIN]}(?:$|[^\\d])`), h("COERCEFULL", c[a.COERCEPLAIN] + `(?:${c[a.PRERELEASE]})?(?:${c[a.BUILD]})?(?:$|[^\\d])`), h("COERCERTL", c[a.COERCE], !0), h("COERCERTLFULL", c[a.COERCEFULL], !0), h("LONETILDE", "(?:~>?)"), h("TILDETRIM", `(\\s*)${c[a.LONETILDE]}\\s+`, !0), t.tildeTrimReplace = "$1~", h("TILDE", `^${c[a.LONETILDE]}${c[a.XRANGEPLAIN]}$`), h("TILDELOOSE", `^${c[a.LONETILDE]}${c[a.XRANGEPLAINLOOSE]}$`), h("LONECARET", "(?:\\^)"), h("CARETTRIM", `(\\s*)${c[a.LONECARET]}\\s+`, !0), t.caretTrimReplace = "$1^", h("CARET", `^${c[a.LONECARET]}${c[a.XRANGEPLAIN]}$`), h("CARETLOOSE", `^${c[a.LONECARET]}${c[a.XRANGEPLAINLOOSE]}$`), h("COMPARATORLOOSE", `^${c[a.GTLT]}\\s*(${c[a.LOOSEPLAIN]})$|^$`), h("COMPARATOR", `^${c[a.GTLT]}\\s*(${c[a.FULLPLAIN]})$|^$`), h("COMPARATORTRIM", `(\\s*)${c[a.GTLT]}\\s*(${c[a.LOOSEPLAIN]}|${c[a.XRANGEPLAIN]})`, !0), t.comparatorTrimReplace = "$1$2$3", h("HYPHENRANGE", `^\\s*(${c[a.XRANGEPLAIN]})\\s+-\\s+(${c[a.XRANGEPLAIN]})\\s*$`), h("HYPHENRANGELOOSE", `^\\s*(${c[a.XRANGEPLAINLOOSE]})\\s+-\\s+(${c[a.XRANGEPLAINLOOSE]})\\s*$`), h("STAR", "(<|>)?=?\\s*\\*"), h("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), h("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(mP, mP.exports)), mP.exports;
}
var lF, Ote;
function YW() {
  if (Ote) return lF;
  Ote = 1;
  const e = Object.freeze({ loose: !0 }), t = Object.freeze({});
  return lF = (r) => r ? typeof r != "object" ? e : r : t, lF;
}
var cF, Ate;
function Hbe() {
  if (Ate) return cF;
  Ate = 1;
  const e = /^[0-9]+$/, t = (r, i) => {
    const o = e.test(r), s = e.test(i);
    return o && s && (r = +r, i = +i), r === i ? 0 : o && !s ? -1 : s && !o ? 1 : r < i ? -1 : 1;
  };
  return cF = {
    compareIdentifiers: t,
    rcompareIdentifiers: (r, i) => t(i, r)
  }, cF;
}
var uF, wte;
function Fa() {
  if (wte) return uF;
  wte = 1;
  const e = N2(), { MAX_LENGTH: t, MAX_SAFE_INTEGER: n } = P2(), { safeRe: r, t: i } = TC(), o = YW(), { compareIdentifiers: s } = Hbe();
  class l {
    constructor(a, u) {
      if (u = o(u), a instanceof l) {
        if (a.loose === !!u.loose && a.includePrerelease === !!u.includePrerelease)
          return a;
        a = a.version;
      } else if (typeof a != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof a}".`);
      if (a.length > t)
        throw new TypeError(
          `version is longer than ${t} characters`
        );
      e("SemVer", a, u), this.options = u, this.loose = !!u.loose, this.includePrerelease = !!u.includePrerelease;
      const f = a.trim().match(u.loose ? r[i.LOOSE] : r[i.FULL]);
      if (!f)
        throw new TypeError(`Invalid Version: ${a}`);
      if (this.raw = a, this.major = +f[1], this.minor = +f[2], this.patch = +f[3], this.major > n || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > n || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > n || this.patch < 0)
        throw new TypeError("Invalid patch version");
      f[4] ? this.prerelease = f[4].split(".").map((d) => {
        if (/^[0-9]+$/.test(d)) {
          const p = +d;
          if (p >= 0 && p < n)
            return p;
        }
        return d;
      }) : this.prerelease = [], this.build = f[5] ? f[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(a) {
      if (e("SemVer.compare", this.version, this.options, a), !(a instanceof l)) {
        if (typeof a == "string" && a === this.version)
          return 0;
        a = new l(a, this.options);
      }
      return a.version === this.version ? 0 : this.compareMain(a) || this.comparePre(a);
    }
    compareMain(a) {
      return a instanceof l || (a = new l(a, this.options)), s(this.major, a.major) || s(this.minor, a.minor) || s(this.patch, a.patch);
    }
    comparePre(a) {
      if (a instanceof l || (a = new l(a, this.options)), this.prerelease.length && !a.prerelease.length)
        return -1;
      if (!this.prerelease.length && a.prerelease.length)
        return 1;
      if (!this.prerelease.length && !a.prerelease.length)
        return 0;
      let u = 0;
      do {
        const f = this.prerelease[u], d = a.prerelease[u];
        if (e("prerelease compare", u, f, d), f === void 0 && d === void 0)
          return 0;
        if (d === void 0)
          return 1;
        if (f === void 0)
          return -1;
        if (f === d)
          continue;
        return s(f, d);
      } while (++u);
    }
    compareBuild(a) {
      a instanceof l || (a = new l(a, this.options));
      let u = 0;
      do {
        const f = this.build[u], d = a.build[u];
        if (e("prerelease compare", u, f, d), f === void 0 && d === void 0)
          return 0;
        if (d === void 0)
          return 1;
        if (f === void 0)
          return -1;
        if (f === d)
          continue;
        return s(f, d);
      } while (++u);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(a, u, f) {
      switch (a) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", u, f);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", u, f);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", u, f), this.inc("pre", u, f);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", u, f), this.inc("pre", u, f);
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const d = Number(f) ? 1 : 0;
          if (!u && f === !1)
            throw new Error("invalid increment argument: identifier is empty");
          if (this.prerelease.length === 0)
            this.prerelease = [d];
          else {
            let p = this.prerelease.length;
            for (; --p >= 0; )
              typeof this.prerelease[p] == "number" && (this.prerelease[p]++, p = -2);
            if (p === -1) {
              if (u === this.prerelease.join(".") && f === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(d);
            }
          }
          if (u) {
            let p = [u, d];
            f === !1 && (p = [u]), s(this.prerelease[0], u) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = p) : this.prerelease = p;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${a}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return uF = l, uF;
}
var dF, xte;
function Qbe() {
  if (xte) return dF;
  xte = 1;
  const e = Fa();
  return dF = (n, r) => new e(n, r).major, dF;
}
var UZe = Qbe();
const Ste = /* @__PURE__ */ Sl(UZe);
var fF, Ete;
function $be() {
  if (Ete) return fF;
  Ete = 1;
  const e = Fa();
  return fF = (n, r) => new e(n, r).minor, fF;
}
var VZe = $be();
const Tte = /* @__PURE__ */ Sl(VZe);
var pF, kte;
function qZe() {
  return kte || (kte = 1, pF = function(e) {
    e.prototype[Symbol.iterator] = function* () {
      for (let t = this.head; t; t = t.next)
        yield t.value;
    };
  }), pF;
}
var hF, Cte;
function BZe() {
  if (Cte) return hF;
  Cte = 1, hF = e, e.Node = i, e.create = e;
  function e(o) {
    var s = this;
    if (s instanceof e || (s = new e()), s.tail = null, s.head = null, s.length = 0, o && typeof o.forEach == "function")
      o.forEach(function(a) {
        s.push(a);
      });
    else if (arguments.length > 0)
      for (var l = 0, c = arguments.length; l < c; l++)
        s.push(arguments[l]);
    return s;
  }
  e.prototype.removeNode = function(o) {
    if (o.list !== this)
      throw new Error("removing node which does not belong to this list");
    var s = o.next, l = o.prev;
    return s && (s.prev = l), l && (l.next = s), o === this.head && (this.head = s), o === this.tail && (this.tail = l), o.list.length--, o.next = null, o.prev = null, o.list = null, s;
  }, e.prototype.unshiftNode = function(o) {
    if (o !== this.head) {
      o.list && o.list.removeNode(o);
      var s = this.head;
      o.list = this, o.next = s, s && (s.prev = o), this.head = o, this.tail || (this.tail = o), this.length++;
    }
  }, e.prototype.pushNode = function(o) {
    if (o !== this.tail) {
      o.list && o.list.removeNode(o);
      var s = this.tail;
      o.list = this, o.prev = s, s && (s.next = o), this.tail = o, this.head || (this.head = o), this.length++;
    }
  }, e.prototype.push = function() {
    for (var o = 0, s = arguments.length; o < s; o++)
      n(this, arguments[o]);
    return this.length;
  }, e.prototype.unshift = function() {
    for (var o = 0, s = arguments.length; o < s; o++)
      r(this, arguments[o]);
    return this.length;
  }, e.prototype.pop = function() {
    if (this.tail) {
      var o = this.tail.value;
      return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, o;
    }
  }, e.prototype.shift = function() {
    if (this.head) {
      var o = this.head.value;
      return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, o;
    }
  }, e.prototype.forEach = function(o, s) {
    s = s || this;
    for (var l = this.head, c = 0; l !== null; c++)
      o.call(s, l.value, c, this), l = l.next;
  }, e.prototype.forEachReverse = function(o, s) {
    s = s || this;
    for (var l = this.tail, c = this.length - 1; l !== null; c--)
      o.call(s, l.value, c, this), l = l.prev;
  }, e.prototype.get = function(o) {
    for (var s = 0, l = this.head; l !== null && s < o; s++)
      l = l.next;
    if (s === o && l !== null)
      return l.value;
  }, e.prototype.getReverse = function(o) {
    for (var s = 0, l = this.tail; l !== null && s < o; s++)
      l = l.prev;
    if (s === o && l !== null)
      return l.value;
  }, e.prototype.map = function(o, s) {
    s = s || this;
    for (var l = new e(), c = this.head; c !== null; )
      l.push(o.call(s, c.value, this)), c = c.next;
    return l;
  }, e.prototype.mapReverse = function(o, s) {
    s = s || this;
    for (var l = new e(), c = this.tail; c !== null; )
      l.push(o.call(s, c.value, this)), c = c.prev;
    return l;
  }, e.prototype.reduce = function(o, s) {
    var l, c = this.head;
    if (arguments.length > 1)
      l = s;
    else if (this.head)
      c = this.head.next, l = this.head.value;
    else
      throw new TypeError("Reduce of empty list with no initial value");
    for (var a = 0; c !== null; a++)
      l = o(l, c.value, a), c = c.next;
    return l;
  }, e.prototype.reduceReverse = function(o, s) {
    var l, c = this.tail;
    if (arguments.length > 1)
      l = s;
    else if (this.tail)
      c = this.tail.prev, l = this.tail.value;
    else
      throw new TypeError("Reduce of empty list with no initial value");
    for (var a = this.length - 1; c !== null; a--)
      l = o(l, c.value, a), c = c.prev;
    return l;
  }, e.prototype.toArray = function() {
    for (var o = new Array(this.length), s = 0, l = this.head; l !== null; s++)
      o[s] = l.value, l = l.next;
    return o;
  }, e.prototype.toArrayReverse = function() {
    for (var o = new Array(this.length), s = 0, l = this.tail; l !== null; s++)
      o[s] = l.value, l = l.prev;
    return o;
  }, e.prototype.slice = function(o, s) {
    s = s || this.length, s < 0 && (s += this.length), o = o || 0, o < 0 && (o += this.length);
    var l = new e();
    if (s < o || s < 0)
      return l;
    o < 0 && (o = 0), s > this.length && (s = this.length);
    for (var c = 0, a = this.head; a !== null && c < o; c++)
      a = a.next;
    for (; a !== null && c < s; c++, a = a.next)
      l.push(a.value);
    return l;
  }, e.prototype.sliceReverse = function(o, s) {
    s = s || this.length, s < 0 && (s += this.length), o = o || 0, o < 0 && (o += this.length);
    var l = new e();
    if (s < o || s < 0)
      return l;
    o < 0 && (o = 0), s > this.length && (s = this.length);
    for (var c = this.length, a = this.tail; a !== null && c > s; c--)
      a = a.prev;
    for (; a !== null && c > o; c--, a = a.prev)
      l.push(a.value);
    return l;
  }, e.prototype.splice = function(o, s, ...l) {
    o > this.length && (o = this.length - 1), o < 0 && (o = this.length + o);
    for (var c = 0, a = this.head; a !== null && c < o; c++)
      a = a.next;
    for (var u = [], c = 0; a && c < s; c++)
      u.push(a.value), a = this.removeNode(a);
    a === null && (a = this.tail), a !== this.head && a !== this.tail && (a = a.prev);
    for (var c = 0; c < l.length; c++)
      a = t(this, a, l[c]);
    return u;
  }, e.prototype.reverse = function() {
    for (var o = this.head, s = this.tail, l = o; l !== null; l = l.prev) {
      var c = l.prev;
      l.prev = l.next, l.next = c;
    }
    return this.head = s, this.tail = o, this;
  };
  function t(o, s, l) {
    var c = s === o.head ? new i(l, null, s, o) : new i(l, s, s.next, o);
    return c.next === null && (o.tail = c), c.prev === null && (o.head = c), o.length++, c;
  }
  function n(o, s) {
    o.tail = new i(s, o.tail, null, o), o.head || (o.head = o.tail), o.length++;
  }
  function r(o, s) {
    o.head = new i(s, null, o.head, o), o.tail || (o.tail = o.head), o.length++;
  }
  function i(o, s, l, c) {
    if (!(this instanceof i))
      return new i(o, s, l, c);
    this.list = c, this.value = o, s ? (s.next = this, this.prev = s) : this.prev = null, l ? (l.prev = this, this.next = l) : this.next = null;
  }
  try {
    qZe()(e);
  } catch {
  }
  return hF;
}
var mF, Nte;
function XZe() {
  if (Nte) return mF;
  Nte = 1;
  const e = BZe(), t = Symbol("max"), n = Symbol("length"), r = Symbol("lengthCalculator"), i = Symbol("allowStale"), o = Symbol("maxAge"), s = Symbol("dispose"), l = Symbol("noDisposeOnSet"), c = Symbol("lruList"), a = Symbol("cache"), u = Symbol("updateAgeOnGet"), f = () => 1;
  class d {
    constructor(O) {
      if (typeof O == "number" && (O = { max: O }), O || (O = {}), O.max && (typeof O.max != "number" || O.max < 0))
        throw new TypeError("max must be a non-negative number");
      this[t] = O.max || 1 / 0;
      const x = O.length || f;
      if (this[r] = typeof x != "function" ? f : x, this[i] = O.stale || !1, O.maxAge && typeof O.maxAge != "number")
        throw new TypeError("maxAge must be a number");
      this[o] = O.maxAge || 0, this[s] = O.dispose, this[l] = O.noDisposeOnSet || !1, this[u] = O.updateAgeOnGet || !1, this.reset();
    }
    // resize the cache when the max changes.
    set max(O) {
      if (typeof O != "number" || O < 0)
        throw new TypeError("max must be a non-negative number");
      this[t] = O || 1 / 0, m(this);
    }
    get max() {
      return this[t];
    }
    set allowStale(O) {
      this[i] = !!O;
    }
    get allowStale() {
      return this[i];
    }
    set maxAge(O) {
      if (typeof O != "number")
        throw new TypeError("maxAge must be a non-negative number");
      this[o] = O, m(this);
    }
    get maxAge() {
      return this[o];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(O) {
      typeof O != "function" && (O = f), O !== this[r] && (this[r] = O, this[n] = 0, this[c].forEach((x) => {
        x.length = this[r](x.value, x.key), this[n] += x.length;
      })), m(this);
    }
    get lengthCalculator() {
      return this[r];
    }
    get length() {
      return this[n];
    }
    get itemCount() {
      return this[c].length;
    }
    rforEach(O, x) {
      x = x || this;
      for (let S = this[c].tail; S !== null; ) {
        const E = S.prev;
        A(this, O, S, x), S = E;
      }
    }
    forEach(O, x) {
      x = x || this;
      for (let S = this[c].head; S !== null; ) {
        const E = S.next;
        A(this, O, S, x), S = E;
      }
    }
    keys() {
      return this[c].toArray().map((O) => O.key);
    }
    values() {
      return this[c].toArray().map((O) => O.value);
    }
    reset() {
      this[s] && this[c] && this[c].length && this[c].forEach((O) => this[s](O.key, O.value)), this[a] = /* @__PURE__ */ new Map(), this[c] = new e(), this[n] = 0;
    }
    dump() {
      return this[c].map((O) => h(this, O) ? !1 : {
        k: O.key,
        v: O.value,
        e: O.now + (O.maxAge || 0)
      }).toArray().filter((O) => O);
    }
    dumpLru() {
      return this[c];
    }
    set(O, x, S) {
      if (S = S || this[o], S && typeof S != "number")
        throw new TypeError("maxAge must be a number");
      const E = S ? Date.now() : 0, k = this[r](x, O);
      if (this[a].has(O)) {
        if (k > this[t])
          return v(this, this[a].get(O)), !1;
        const j = this[a].get(O).value;
        return this[s] && (this[l] || this[s](O, j.value)), j.now = E, j.maxAge = S, j.value = x, this[n] += k - j.length, j.length = k, this.get(O), m(this), !0;
      }
      const T = new b(O, x, k, E, S);
      return T.length > this[t] ? (this[s] && this[s](O, x), !1) : (this[n] += T.length, this[c].unshift(T), this[a].set(O, this[c].head), m(this), !0);
    }
    has(O) {
      if (!this[a].has(O)) return !1;
      const x = this[a].get(O).value;
      return !h(this, x);
    }
    get(O) {
      return p(this, O, !0);
    }
    peek(O) {
      return p(this, O, !1);
    }
    pop() {
      const O = this[c].tail;
      return O ? (v(this, O), O.value) : null;
    }
    del(O) {
      v(this, this[a].get(O));
    }
    load(O) {
      this.reset();
      const x = Date.now();
      for (let S = O.length - 1; S >= 0; S--) {
        const E = O[S], k = E.e || 0;
        if (k === 0)
          this.set(E.k, E.v);
        else {
          const T = k - x;
          T > 0 && this.set(E.k, E.v, T);
        }
      }
    }
    prune() {
      this[a].forEach((O, x) => p(this, x, !1));
    }
  }
  const p = (w, O, x) => {
    const S = w[a].get(O);
    if (S) {
      const E = S.value;
      if (h(w, E)) {
        if (v(w, S), !w[i])
          return;
      } else
        x && (w[u] && (S.value.now = Date.now()), w[c].unshiftNode(S));
      return E.value;
    }
  }, h = (w, O) => {
    if (!O || !O.maxAge && !w[o])
      return !1;
    const x = Date.now() - O.now;
    return O.maxAge ? x > O.maxAge : w[o] && x > w[o];
  }, m = (w) => {
    if (w[n] > w[t])
      for (let O = w[c].tail; w[n] > w[t] && O !== null; ) {
        const x = O.prev;
        v(w, O), O = x;
      }
  }, v = (w, O) => {
    if (O) {
      const x = O.value;
      w[s] && w[s](x.key, x.value), w[n] -= x.length, w[a].delete(x.key), w[c].removeNode(O);
    }
  };
  class b {
    constructor(O, x, S, E, k) {
      this.key = O, this.value = x, this.length = S, this.now = E, this.maxAge = k || 0;
    }
  }
  const A = (w, O, x, S) => {
    let E = x.value;
    h(w, E) && (v(w, x), w[i] || (E = void 0)), E && O.call(S, E.value, E.key, w);
  };
  return mF = d, mF;
}
var gF, Pte;
function dd() {
  if (Pte) return gF;
  Pte = 1;
  const e = Fa();
  return gF = (n, r, i) => new e(n, i).compare(new e(r, i)), gF;
}
var yF, Ite;
function Kbe() {
  if (Ite) return yF;
  Ite = 1;
  const e = dd();
  return yF = (n, r, i) => e(n, r, i) === 0, yF;
}
var vF, Rte;
function Gbe() {
  if (Rte) return vF;
  Rte = 1;
  const e = dd();
  return vF = (n, r, i) => e(n, r, i) !== 0, vF;
}
var bF, Mte;
function I2() {
  if (Mte) return bF;
  Mte = 1;
  const e = dd();
  return bF = (n, r, i) => e(n, r, i) > 0, bF;
}
var OF, Dte;
function JW() {
  if (Dte) return OF;
  Dte = 1;
  const e = dd();
  return OF = (n, r, i) => e(n, r, i) >= 0, OF;
}
var AF, _te;
function eZ() {
  if (_te) return AF;
  _te = 1;
  const e = dd();
  return AF = (n, r, i) => e(n, r, i) < 0, AF;
}
var wF, Lte;
function tZ() {
  if (Lte) return wF;
  Lte = 1;
  const e = dd();
  return wF = (n, r, i) => e(n, r, i) <= 0, wF;
}
var xF, zte;
function Ybe() {
  if (zte) return xF;
  zte = 1;
  const e = Kbe(), t = Gbe(), n = I2(), r = JW(), i = eZ(), o = tZ();
  return xF = (l, c, a, u) => {
    switch (c) {
      case "===":
        return typeof l == "object" && (l = l.version), typeof a == "object" && (a = a.version), l === a;
      case "!==":
        return typeof l == "object" && (l = l.version), typeof a == "object" && (a = a.version), l !== a;
      case "":
      case "=":
      case "==":
        return e(l, a, u);
      case "!=":
        return t(l, a, u);
      case ">":
        return n(l, a, u);
      case ">=":
        return r(l, a, u);
      case "<":
        return i(l, a, u);
      case "<=":
        return o(l, a, u);
      default:
        throw new TypeError(`Invalid operator: ${c}`);
    }
  }, xF;
}
var SF, jte;
function R2() {
  if (jte) return SF;
  jte = 1;
  const e = Symbol("SemVer ANY");
  class t {
    static get ANY() {
      return e;
    }
    constructor(u, f) {
      if (f = n(f), u instanceof t) {
        if (u.loose === !!f.loose)
          return u;
        u = u.value;
      }
      u = u.trim().split(/\s+/).join(" "), s("comparator", u, f), this.options = f, this.loose = !!f.loose, this.parse(u), this.semver === e ? this.value = "" : this.value = this.operator + this.semver.version, s("comp", this);
    }
    parse(u) {
      const f = this.options.loose ? r[i.COMPARATORLOOSE] : r[i.COMPARATOR], d = u.match(f);
      if (!d)
        throw new TypeError(`Invalid comparator: ${u}`);
      this.operator = d[1] !== void 0 ? d[1] : "", this.operator === "=" && (this.operator = ""), d[2] ? this.semver = new l(d[2], this.options.loose) : this.semver = e;
    }
    toString() {
      return this.value;
    }
    test(u) {
      if (s("Comparator.test", u, this.options.loose), this.semver === e || u === e)
        return !0;
      if (typeof u == "string")
        try {
          u = new l(u, this.options);
        } catch {
          return !1;
        }
      return o(u, this.operator, this.semver, this.options);
    }
    intersects(u, f) {
      if (!(u instanceof t))
        throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new c(u.value, f).test(this.value) : u.operator === "" ? u.value === "" ? !0 : new c(this.value, f).test(u.semver) : (f = n(f), f.includePrerelease && (this.value === "<0.0.0-0" || u.value === "<0.0.0-0") || !f.includePrerelease && (this.value.startsWith("<0.0.0") || u.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && u.operator.startsWith(">") || this.operator.startsWith("<") && u.operator.startsWith("<") || this.semver.version === u.semver.version && this.operator.includes("=") && u.operator.includes("=") || o(this.semver, "<", u.semver, f) && this.operator.startsWith(">") && u.operator.startsWith("<") || o(this.semver, ">", u.semver, f) && this.operator.startsWith("<") && u.operator.startsWith(">")));
    }
  }
  SF = t;
  const n = YW(), { safeRe: r, t: i } = TC(), o = Ybe(), s = N2(), l = Fa(), c = fd();
  return SF;
}
var EF, Fte;
function fd() {
  if (Fte) return EF;
  Fte = 1;
  class e {
    constructor(_, U) {
      if (U = r(U), _ instanceof e)
        return _.loose === !!U.loose && _.includePrerelease === !!U.includePrerelease ? _ : new e(_.raw, U);
      if (_ instanceof i)
        return this.raw = _.value, this.set = [[_]], this.format(), this;
      if (this.options = U, this.loose = !!U.loose, this.includePrerelease = !!U.includePrerelease, this.raw = _.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((z) => this.parseRange(z.trim())).filter((z) => z.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        const z = this.set[0];
        if (this.set = this.set.filter((C) => !h(C[0])), this.set.length === 0)
          this.set = [z];
        else if (this.set.length > 1) {
          for (const C of this.set)
            if (C.length === 1 && m(C[0])) {
              this.set = [C];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((_) => _.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(_) {
      const z = ((this.options.includePrerelease && d) | (this.options.loose && p)) + ":" + _, C = n.get(z);
      if (C)
        return C;
      const I = this.options.loose, M = I ? l[c.HYPHENRANGELOOSE] : l[c.HYPHENRANGE];
      _ = _.replace(M, j(this.options.includePrerelease)), o("hyphen replace", _), _ = _.replace(l[c.COMPARATORTRIM], a), o("comparator trim", _), _ = _.replace(l[c.TILDETRIM], u), o("tilde trim", _), _ = _.replace(l[c.CARETTRIM], f), o("caret trim", _);
      let D = _.split(" ").map((H) => b(H, this.options)).join(" ").split(/\s+/).map((H) => R(H, this.options));
      I && (D = D.filter((H) => (o("loose invalid filter", H, this.options), !!H.match(l[c.COMPARATORLOOSE])))), o("range list", D);
      const X = /* @__PURE__ */ new Map(), B = D.map((H) => new i(H, this.options));
      for (const H of B) {
        if (h(H))
          return [H];
        X.set(H.value, H);
      }
      X.size > 1 && X.has("") && X.delete("");
      const q = [...X.values()];
      return n.set(z, q), q;
    }
    intersects(_, U) {
      if (!(_ instanceof e))
        throw new TypeError("a Range is required");
      return this.set.some((z) => v(z, U) && _.set.some((C) => v(C, U) && z.every((I) => C.every((M) => I.intersects(M, U)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(_) {
      if (!_)
        return !1;
      if (typeof _ == "string")
        try {
          _ = new s(_, this.options);
        } catch {
          return !1;
        }
      for (let U = 0; U < this.set.length; U++)
        if (F(this.set[U], _, this.options))
          return !0;
      return !1;
    }
  }
  EF = e;
  const t = XZe(), n = new t({ max: 1e3 }), r = YW(), i = R2(), o = N2(), s = Fa(), {
    safeRe: l,
    t: c,
    comparatorTrimReplace: a,
    tildeTrimReplace: u,
    caretTrimReplace: f
  } = TC(), { FLAG_INCLUDE_PRERELEASE: d, FLAG_LOOSE: p } = P2(), h = (L) => L.value === "<0.0.0-0", m = (L) => L.value === "", v = (L, _) => {
    let U = !0;
    const z = L.slice();
    let C = z.pop();
    for (; U && z.length; )
      U = z.every((I) => C.intersects(I, _)), C = z.pop();
    return U;
  }, b = (L, _) => (o("comp", L, _), L = x(L, _), o("caret", L), L = w(L, _), o("tildes", L), L = E(L, _), o("xrange", L), L = T(L, _), o("stars", L), L), A = (L) => !L || L.toLowerCase() === "x" || L === "*", w = (L, _) => L.trim().split(/\s+/).map((U) => O(U, _)).join(" "), O = (L, _) => {
    const U = _.loose ? l[c.TILDELOOSE] : l[c.TILDE];
    return L.replace(U, (z, C, I, M, D) => {
      o("tilde", L, z, C, I, M, D);
      let X;
      return A(C) ? X = "" : A(I) ? X = `>=${C}.0.0 <${+C + 1}.0.0-0` : A(M) ? X = `>=${C}.${I}.0 <${C}.${+I + 1}.0-0` : D ? (o("replaceTilde pr", D), X = `>=${C}.${I}.${M}-${D} <${C}.${+I + 1}.0-0`) : X = `>=${C}.${I}.${M} <${C}.${+I + 1}.0-0`, o("tilde return", X), X;
    });
  }, x = (L, _) => L.trim().split(/\s+/).map((U) => S(U, _)).join(" "), S = (L, _) => {
    o("caret", L, _);
    const U = _.loose ? l[c.CARETLOOSE] : l[c.CARET], z = _.includePrerelease ? "-0" : "";
    return L.replace(U, (C, I, M, D, X) => {
      o("caret", L, C, I, M, D, X);
      let B;
      return A(I) ? B = "" : A(M) ? B = `>=${I}.0.0${z} <${+I + 1}.0.0-0` : A(D) ? I === "0" ? B = `>=${I}.${M}.0${z} <${I}.${+M + 1}.0-0` : B = `>=${I}.${M}.0${z} <${+I + 1}.0.0-0` : X ? (o("replaceCaret pr", X), I === "0" ? M === "0" ? B = `>=${I}.${M}.${D}-${X} <${I}.${M}.${+D + 1}-0` : B = `>=${I}.${M}.${D}-${X} <${I}.${+M + 1}.0-0` : B = `>=${I}.${M}.${D}-${X} <${+I + 1}.0.0-0`) : (o("no pr"), I === "0" ? M === "0" ? B = `>=${I}.${M}.${D}${z} <${I}.${M}.${+D + 1}-0` : B = `>=${I}.${M}.${D}${z} <${I}.${+M + 1}.0-0` : B = `>=${I}.${M}.${D} <${+I + 1}.0.0-0`), o("caret return", B), B;
    });
  }, E = (L, _) => (o("replaceXRanges", L, _), L.split(/\s+/).map((U) => k(U, _)).join(" ")), k = (L, _) => {
    L = L.trim();
    const U = _.loose ? l[c.XRANGELOOSE] : l[c.XRANGE];
    return L.replace(U, (z, C, I, M, D, X) => {
      o("xRange", L, z, C, I, M, D, X);
      const B = A(I), q = B || A(M), H = q || A(D), Y = H;
      return C === "=" && Y && (C = ""), X = _.includePrerelease ? "-0" : "", B ? C === ">" || C === "<" ? z = "<0.0.0-0" : z = "*" : C && Y ? (q && (M = 0), D = 0, C === ">" ? (C = ">=", q ? (I = +I + 1, M = 0, D = 0) : (M = +M + 1, D = 0)) : C === "<=" && (C = "<", q ? I = +I + 1 : M = +M + 1), C === "<" && (X = "-0"), z = `${C + I}.${M}.${D}${X}`) : q ? z = `>=${I}.0.0${X} <${+I + 1}.0.0-0` : H && (z = `>=${I}.${M}.0${X} <${I}.${+M + 1}.0-0`), o("xRange return", z), z;
    });
  }, T = (L, _) => (o("replaceStars", L, _), L.trim().replace(l[c.STAR], "")), R = (L, _) => (o("replaceGTE0", L, _), L.trim().replace(l[_.includePrerelease ? c.GTE0PRE : c.GTE0], "")), j = (L) => (_, U, z, C, I, M, D, X, B, q, H, Y, J) => (A(z) ? U = "" : A(C) ? U = `>=${z}.0.0${L ? "-0" : ""}` : A(I) ? U = `>=${z}.${C}.0${L ? "-0" : ""}` : M ? U = `>=${U}` : U = `>=${U}${L ? "-0" : ""}`, A(B) ? X = "" : A(q) ? X = `<${+B + 1}.0.0-0` : A(H) ? X = `<${B}.${+q + 1}.0-0` : Y ? X = `<=${B}.${q}.${H}-${Y}` : L ? X = `<${B}.${q}.${+H + 1}-0` : X = `<=${X}`, `${U} ${X}`.trim()), F = (L, _, U) => {
    for (let z = 0; z < L.length; z++)
      if (!L[z].test(_))
        return !1;
    if (_.prerelease.length && !U.includePrerelease) {
      for (let z = 0; z < L.length; z++)
        if (o(L[z].semver), L[z].semver !== i.ANY && L[z].semver.prerelease.length > 0) {
          const C = L[z].semver;
          if (C.major === _.major && C.minor === _.minor && C.patch === _.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return EF;
}
var TF, Ute;
function Jbe() {
  if (Ute) return TF;
  Ute = 1;
  const e = Fa(), t = fd(), n = I2();
  return TF = (i, o) => {
    i = new t(i, o);
    let s = new e("0.0.0");
    if (i.test(s) || (s = new e("0.0.0-0"), i.test(s)))
      return s;
    s = null;
    for (let l = 0; l < i.set.length; ++l) {
      const c = i.set[l];
      let a = null;
      c.forEach((u) => {
        const f = new e(u.semver.version);
        switch (u.operator) {
          case ">":
            f.prerelease.length === 0 ? f.patch++ : f.prerelease.push(0), f.raw = f.format();
          /* fallthrough */
          case "":
          case ">=":
            (!a || n(f, a)) && (a = f);
            break;
          case "<":
          case "<=":
            break;
          /* istanbul ignore next */
          default:
            throw new Error(`Unexpected operation: ${u.operator}`);
        }
      }), a && (!s || n(s, a)) && (s = a);
    }
    return s && i.test(s) ? s : null;
  }, TF;
}
var WZe = Jbe();
const ZZe = /* @__PURE__ */ Sl(WZe);
class vb extends Error {
  constructor(t, n) {
    super(t.code + (n ? `: ${n}` : "")), this.error = t;
  }
  toString() {
    return JSON.stringify({
      code: this.error.code,
      message: this.message,
      params: this.error.params
    });
  }
}
var Ni = /* @__PURE__ */ ((e) => (e.MACHINE_NOT_CONNECTED = "MACHINE_NOT_CONNECTED", e.MACHINE_NOT_AVAILABLE = "MACHINE_NOT_AVAILABLE", e.INVALID_CUSTOM_DOMAIN = "INVALID_CUSTOM_DOMAIN", e.NO_CHAT_RESPONSE = "NO_CHAT_RESPONSE", e.ERROR_UPDATING_SUBSCRIPTION = "ERROR_UPDATING_SUBSCRIPTION", e.AUTHENTICATION = "AUTHENTICATION", e.AUTHORIZATION = "AUTHORIZATION", e.PROVIDER_PROXY_CONFIG_NOT_FOUND_FOR_PROVIDER = "PROVIDER_PROXY_CONFIG_NOT_FOUND_FOR_PROVIDER", e.AI_MODEL_NOT_SUPPORTED = "AI_MODEL_NOT_SUPPORTED", e.AI_PROVIDER_NOT_SUPPORTED = "AI_PROVIDER_NOT_SUPPORTED", e.AI_REQUEST_NOT_SUPPORTED = "AI_REQUEST_NOT_SUPPORTED", e.CONFIG_NOT_FOUND = "CONFIG_NOT_FOUND", e.DOMAIN_NOT_ALLOWED = "DOMAIN_NOT_ALLOWED", e.EMAIL_IS_NOT_VERIFIED = "EMAIL_IS_NOT_VERIFIED", e.ENGINE_OPERATION_FAILURE = "ENGINE_OPERATION_FAILURE", e.ENTITY_NOT_FOUND = "ENTITY_NOT_FOUND", e.EXECUTION_TIMEOUT = "EXECUTION_TIMEOUT", e.MEMORY_ISSUE = "MEMORY_ISSUE", e.TRIGGER_EXECUTION_FAILED = "TRIGGER_EXECUTION_FAILED", e.EMAIL_AUTH_DISABLED = "EMAIL_AUTH_DISABLED", e.EXISTING_USER = "EXISTING_USER", e.EXISTING_ALERT_CHANNEL = "EXISTING_ALERT_CHANNEL", e.PROJECT_EXTERNAL_ID_ALREADY_EXISTS = "PROJECT_EXTERNAL_ID_ALREADY_EXISTS", e.FLOW_FORM_NOT_FOUND = "FLOW_FORM_NOT_FOUND", e.FILE_NOT_FOUND = "FILE_NOT_FOUND", e.FLOW_INSTANCE_NOT_FOUND = "INSTANCE_NOT_FOUND", e.FLOW_NOT_FOUND = "FLOW_NOT_FOUND", e.FLOW_OPERATION_INVALID = "FLOW_OPERATION_INVALID", e.FLOW_OPERATION_IN_PROGRESS = "FLOW_OPERATION_IN_PROGRESS", e.FLOW_IN_USE = "FLOW_IN_USE", e.FLOW_RUN_NOT_FOUND = "FLOW_RUN_NOT_FOUND", e.INVALID_API_KEY = "INVALID_API_KEY", e.INVALID_APP_CONNECTION = "INVALID_APP_CONNECTION", e.INVALID_BEARER_TOKEN = "INVALID_BEARER_TOKEN", e.SESSION_EXPIRED = "SESSION_EXPIRED", e.INVALID_CLAIM = "INVALID_CLAIM", e.INVALID_CLOUD_CLAIM = "INVALID_CLOUD_CLAIM", e.INVALID_CREDENTIALS = "INVALID_CREDENTIALS", e.INVALID_OR_EXPIRED_JWT_TOKEN = "INVALID_OR_EXPIRED_JWT_TOKEN", e.INVALID_OTP = "INVALID_OTP", e.INVALID_SAML_RESPONSE = "INVALID_SAML_RESPONSE", e.INVITATION_ONLY_SIGN_UP = "INVITATION_ONLY_SIGN_UP", e.JOB_REMOVAL_FAILURE = "JOB_REMOVAL_FAILURE", e.OPEN_AI_FAILED = "OPEN_AI_FAILED", e.PAUSE_METADATA_MISSING = "PAUSE_METADATA_MISSING", e.PERMISSION_DENIED = "PERMISSION_DENIED", e.PIECE_NOT_FOUND = "PIECE_NOT_FOUND", e.PIECE_TRIGGER_NOT_FOUND = "PIECE_TRIGGER_NOT_FOUND", e.QUOTA_EXCEEDED = "QUOTA_EXCEEDED", e.FEATURE_DISABLED = "FEATURE_DISABLED", e.AI_CREDIT_LIMIT_EXCEEDED = "AI_CREDIT_LIMIT_EXCEEDED", e.SIGN_UP_DISABLED = "SIGN_UP_DISABLED", e.STEP_NOT_FOUND = "STEP_NOT_FOUND", e.SYSTEM_PROP_INVALID = "SYSTEM_PROP_INVALID", e.SYSTEM_PROP_NOT_DEFINED = "SYSTEM_PROP_NOT_DEFINED", e.TEST_TRIGGER_FAILED = "TEST_TRIGGER_FAILED", e.TRIGGER_UPDATE_STATUS = "TRIGGER_UPDATE_STATUS", e.TRIGGER_FAILED = "TRIGGER_FAILED", e.USER_IS_INACTIVE = "USER_IS_INACTIVE", e.VALIDATION = "VALIDATION", e.INVALID_LICENSE_KEY = "INVALID_LICENSE_KEY", e.EMAIL_ALREADY_HAS_ACTIVATION_KEY = "EMAIL_ALREADY_HAS_ACTIVATION_KEY", e.INVALID_SMTP_CREDENTIALS = "INVALID_SMTP_CREDENTIALS", e.INVALID_GIT_CREDENTIALS = "INVALID_GIT_CREDENTIALS", e.INVALID_RELEASE_TYPE = "INVALID_RELEASE_TYPE", e.MCP_PIECE_REQUIRES_CONNECTION = "MCP_PIECE_REQUIRES_CONNECTION", e.MCP_PIECE_CONNECTION_MISMATCH = "MCP_PIECE_CONNECTION_MISMATCH", e.SUBFLOW_FAILED = "SUBFLOW_FAILED", e.DOES_NOT_MEET_BUSINESS_REQUIREMENTS = "DOES_NOT_MEET_BUSINESS_REQUIREMENTS", e))(Ni || {});
const HZe = (e) => {
  const { pieceName: t, pieceVersion: n } = e;
  return `${t}-${n}`;
}, QZe = (e) => {
  const t = e.startsWith("@") ? e.split("/").pop() : e;
  return qm(t, "Full piece name"), t.startsWith("piece-") ? t.split("-").slice(1).join("-") : t;
}, $Ze = (e) => e.split("-").slice(0, -1).join("-"), KZe = (e) => {
  var s;
  const { module: t, pieceName: n, pieceVersion: r } = e, i = Object.values(t), o = [];
  for (const l of i) {
    if (l != null && l.constructor.name === "Piece")
      return l;
    o.push((s = l == null ? void 0 : l.constructor) == null ? void 0 : s.name);
  }
  throw new vb({
    code: Ni.PIECE_NOT_FOUND,
    params: {
      pieceName: n,
      pieceVersion: r,
      message: `Failed to extract piece from module, found constructors: ${o.join(", ")}`
    }
  });
}, GZe = (e) => {
  const t = ZZe(e);
  return t ? `${Ste(t)}.${Tte(t)}` : `${Ste(e)}.${Tte(e)}`;
}, e0e = 512;
var t0e = /* @__PURE__ */ ((e) => (e.OFFICIAL_AUTO = "OFFICIAL_AUTO", e.NONE = "NONE", e))(t0e || {}), dc = /* @__PURE__ */ ((e) => (e.MANUAL = "MANUAL", e.DYNAMIC = "DYNAMIC", e))(dc || {});
const nZ = g.Object({
  type: g.Enum(dc),
  schema: g.Optional(g.Any())
});
var rZ = /* @__PURE__ */ ((e) => (e.UNKNOWN = "UNKNOWN", e.FLOW_RUN_LOG = "FLOW_RUN_LOG", e.PACKAGE_ARCHIVE = "PACKAGE_ARCHIVE", e.FLOW_STEP_FILE = "FLOW_STEP_FILE", e.SAMPLE_DATA = "SAMPLE_DATA", e.TRIGGER_PAYLOAD = "TRIGGER_PAYLOAD", e.SAMPLE_DATA_INPUT = "SAMPLE_DATA_INPUT", e.TRIGGER_EVENT_FILE = "TRIGGER_EVENT_FILE", e.PROJECT_RELEASE = "PROJECT_RELEASE", e.FLOW_VERSION_BACKUP = "FLOW_VERSION_BACKUP", e.PLATFORM_ASSET = "PLATFORM_ASSET", e))(rZ || {}), iZ = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.GZIP = "GZIP", e))(iZ || {}), oZ = /* @__PURE__ */ ((e) => (e.S3 = "S3", e.DB = "DB", e))(oZ || {});
const n0e = g.Object({
  ...Or,
  projectId: g.Optional(g.String()),
  platformId: g.Optional(g.String()),
  type: g.Enum(rZ),
  compression: g.Enum(iZ),
  data: g.Optional(g.Unknown()),
  location: g.Enum(oZ),
  size: g.Optional(g.Number()),
  fileName: g.Optional(g.String()),
  s3Key: g.Optional(g.String()),
  metadata: g.Optional(g.Record(g.String(), g.String()))
});
var Jm = /* @__PURE__ */ ((e) => (e.INPUT = "INPUT", e.OUTPUT = "OUTPUT", e))(Jm || {});
const YZe = "dataType";
var wy = /* @__PURE__ */ ((e) => (e.JSON = "JSON", e.STRING = "STRING", e))(wy || {});
const r0e = g.Object({
  stepName: g.String(),
  payload: g.Unknown(),
  type: g.Enum(Jm),
  dataType: g.Enum(wy)
}), JZe = g.Object({
  flowId: g.String(),
  flowVersionId: g.String(),
  stepName: g.String(),
  projectId: g.String(),
  type: g.Enum(Jm)
}), eHe = g.Object({
  projectId: g.String(),
  flowVersionId: g.String(),
  stepName: g.String()
}), sZ = g.Object({
  runId: g.String(),
  success: g.Boolean(),
  input: g.Unknown(),
  output: g.Unknown(),
  sampleDataFileId: g.Optional(g.String()),
  sampleDataInputFileId: g.Optional(g.String()),
  standardError: g.String(),
  standardOutput: g.String()
}), tHe = g.Array(g.Tuple([g.String(), g.Number()])), M2 = g.Object(
  {
    sampleDataFileId: g.Optional(g.String()),
    sampleDataInputFileId: g.Optional(g.String()),
    lastTestDate: g.Optional(g.String())
  },
  {
    additionalProperties: !0
  }
), i0e = {
  sampleDataFileId: void 0,
  sampleDataInputFileId: void 0
}, nHe = AC(n0e, ["id", "size", "type"]);
var qe = /* @__PURE__ */ ((e) => (e.CODE = "CODE", e.PIECE = "PIECE", e.LOOP_ON_ITEMS = "LOOP_ON_ITEMS", e.ROUTER = "ROUTER", e))(qe || {}), ah = /* @__PURE__ */ ((e) => (e.EXECUTE_ALL_MATCH = "EXECUTE_ALL_MATCH", e.EXECUTE_FIRST_MATCH = "EXECUTE_FIRST_MATCH", e))(ah || {}), iu = /* @__PURE__ */ ((e) => (e.FALLBACK = "FALLBACK", e.CONDITION = "CONDITION", e))(iu || {});
const kC = {
  name: g.String({}),
  valid: g.Boolean({}),
  displayName: g.String({}),
  skip: g.Optional(g.Boolean({}))
}, D2 = {
  sampleData: g.Optional(M2),
  customLogoUrl: g.Optional(g.String())
}, aZ = g.Optional(
  g.Object({
    continueOnFailure: g.Optional(
      g.Object({
        value: g.Optional(g.Boolean())
      })
    ),
    retryOnFailure: g.Optional(
      g.Object({
        value: g.Optional(g.Boolean())
      })
    )
  })
), o0e = g.Object({
  packageJson: g.String({}),
  code: g.String({})
}), s0e = g.Object({
  ...D2,
  sourceCode: o0e,
  input: g.Record(g.String({}), g.Any()),
  errorHandlingOptions: aZ
}), CC = g.Object({
  ...kC,
  type: g.Literal(
    "CODE"
    /* CODE */
  ),
  settings: s0e
}), lZ = g.Object({
  ...D2,
  propertySettings: g.Record(g.String(), nZ),
  pieceName: g.String({}),
  pieceVersion: EC,
  actionName: g.Optional(g.String({})),
  input: g.Record(g.String({}), g.Unknown()),
  errorHandlingOptions: aZ
}), NC = g.Object({
  ...kC,
  type: g.Literal(
    "PIECE"
    /* PIECE */
  ),
  settings: lZ
}), a0e = g.Object({
  ...D2,
  items: g.String()
}), PC = g.Object({
  ...kC,
  type: g.Literal(
    "LOOP_ON_ITEMS"
    /* LOOP_ON_ITEMS */
  ),
  settings: a0e
});
var Gr = /* @__PURE__ */ ((e) => (e.TEXT_CONTAINS = "TEXT_CONTAINS", e.TEXT_DOES_NOT_CONTAIN = "TEXT_DOES_NOT_CONTAIN", e.TEXT_EXACTLY_MATCHES = "TEXT_EXACTLY_MATCHES", e.TEXT_DOES_NOT_EXACTLY_MATCH = "TEXT_DOES_NOT_EXACTLY_MATCH", e.TEXT_STARTS_WITH = "TEXT_START_WITH", e.TEXT_DOES_NOT_START_WITH = "TEXT_DOES_NOT_START_WITH", e.TEXT_ENDS_WITH = "TEXT_ENDS_WITH", e.TEXT_DOES_NOT_END_WITH = "TEXT_DOES_NOT_END_WITH", e.NUMBER_IS_GREATER_THAN = "NUMBER_IS_GREATER_THAN", e.NUMBER_IS_LESS_THAN = "NUMBER_IS_LESS_THAN", e.NUMBER_IS_EQUAL_TO = "NUMBER_IS_EQUAL_TO", e.BOOLEAN_IS_TRUE = "BOOLEAN_IS_TRUE", e.BOOLEAN_IS_FALSE = "BOOLEAN_IS_FALSE", e.DATE_IS_BEFORE = "DATE_IS_BEFORE", e.DATE_IS_EQUAL = "DATE_IS_EQUAL", e.DATE_IS_AFTER = "DATE_IS_AFTER", e.LIST_CONTAINS = "LIST_CONTAINS", e.LIST_DOES_NOT_CONTAIN = "LIST_DOES_NOT_CONTAIN", e.LIST_IS_EMPTY = "LIST_IS_EMPTY", e.LIST_IS_NOT_EMPTY = "LIST_IS_NOT_EMPTY", e.EXISTS = "EXISTS", e.DOES_NOT_EXIST = "DOES_NOT_EXIST", e))(Gr || {});
const Mq = [
  "EXISTS",
  "DOES_NOT_EXIST",
  "BOOLEAN_IS_TRUE",
  "BOOLEAN_IS_FALSE",
  "LIST_IS_EMPTY",
  "LIST_IS_NOT_EMPTY"
  /* LIST_IS_NOT_EMPTY */
], l0e = [
  "TEXT_CONTAINS",
  "TEXT_DOES_NOT_CONTAIN",
  "TEXT_EXACTLY_MATCHES",
  "TEXT_DOES_NOT_EXACTLY_MATCH",
  "TEXT_START_WITH",
  "TEXT_DOES_NOT_START_WITH",
  "TEXT_ENDS_WITH",
  "TEXT_DOES_NOT_END_WITH",
  "LIST_CONTAINS",
  "LIST_DOES_NOT_CONTAIN"
  /* LIST_DOES_NOT_CONTAIN */
], rHe = [
  g.Literal(
    "TEXT_CONTAINS"
    /* TEXT_CONTAINS */
  ),
  g.Literal(
    "TEXT_DOES_NOT_CONTAIN"
    /* TEXT_DOES_NOT_CONTAIN */
  ),
  g.Literal(
    "TEXT_EXACTLY_MATCHES"
    /* TEXT_EXACTLY_MATCHES */
  ),
  g.Literal(
    "TEXT_DOES_NOT_EXACTLY_MATCH"
    /* TEXT_DOES_NOT_EXACTLY_MATCH */
  ),
  g.Literal(
    "TEXT_START_WITH"
    /* TEXT_STARTS_WITH */
  ),
  g.Literal(
    "TEXT_DOES_NOT_START_WITH"
    /* TEXT_DOES_NOT_START_WITH */
  ),
  g.Literal(
    "TEXT_ENDS_WITH"
    /* TEXT_ENDS_WITH */
  ),
  g.Literal(
    "TEXT_DOES_NOT_END_WITH"
    /* TEXT_DOES_NOT_END_WITH */
  ),
  g.Literal(
    "LIST_CONTAINS"
    /* LIST_CONTAINS */
  ),
  g.Literal(
    "LIST_DOES_NOT_CONTAIN"
    /* LIST_DOES_NOT_CONTAIN */
  )
], iHe = [
  g.Literal(
    "NUMBER_IS_GREATER_THAN"
    /* NUMBER_IS_GREATER_THAN */
  ),
  g.Literal(
    "NUMBER_IS_LESS_THAN"
    /* NUMBER_IS_LESS_THAN */
  ),
  g.Literal(
    "NUMBER_IS_EQUAL_TO"
    /* NUMBER_IS_EQUAL_TO */
  )
], oHe = [
  g.Literal(
    "DATE_IS_BEFORE"
    /* DATE_IS_BEFORE */
  ),
  g.Literal(
    "DATE_IS_EQUAL"
    /* DATE_IS_EQUAL */
  ),
  g.Literal(
    "DATE_IS_AFTER"
    /* DATE_IS_AFTER */
  )
], sHe = [
  g.Literal(
    "EXISTS"
    /* EXISTS */
  ),
  g.Literal(
    "DOES_NOT_EXIST"
    /* DOES_NOT_EXIST */
  ),
  g.Literal(
    "BOOLEAN_IS_TRUE"
    /* BOOLEAN_IS_TRUE */
  ),
  g.Literal(
    "BOOLEAN_IS_FALSE"
    /* BOOLEAN_IS_FALSE */
  ),
  g.Literal(
    "LIST_IS_EMPTY"
    /* LIST_IS_EMPTY */
  ),
  g.Literal(
    "LIST_IS_NOT_EMPTY"
    /* LIST_IS_NOT_EMPTY */
  )
], c0e = (e) => g.Object({
  firstValue: g.String(e ? { minLength: 1 } : {}),
  secondValue: g.String(e ? { minLength: 1 } : {}),
  caseSensitive: g.Optional(g.Boolean()),
  operator: g.Optional(g.Union(rHe))
}), u0e = (e) => g.Object({
  firstValue: g.String(e ? { minLength: 1 } : {}),
  secondValue: g.String(e ? { minLength: 1 } : {}),
  operator: g.Optional(g.Union(iHe))
}), d0e = (e) => g.Object({
  firstValue: g.String(e ? { minLength: 1 } : {}),
  secondValue: g.String(e ? { minLength: 1 } : {}),
  operator: g.Optional(g.Union(oHe))
}), f0e = (e) => g.Object({
  firstValue: g.String(e ? { minLength: 1 } : {}),
  operator: g.Optional(g.Union(sHe))
}), cZ = (e) => g.Union([
  c0e(e),
  u0e(e),
  d0e(e),
  f0e(e)
]), aHe = cZ(!0), p0e = cZ(!1), lHe = c0e(!1), cHe = u0e(!1), uHe = d0e(!1), dHe = f0e(!1), _2 = (e) => g.Array(
  g.Union([
    g.Object({
      conditions: g.Array(g.Array(cZ(e))),
      branchType: g.Literal(
        "CONDITION"
        /* CONDITION */
      ),
      branchName: g.String()
    }),
    g.Object({
      branchType: g.Literal(
        "FALLBACK"
        /* FALLBACK */
      ),
      branchName: g.String()
    })
  ])
), uZ = g.Object({
  ...D2,
  branches: _2(!1),
  executionType: g.Enum(ah)
}), h0e = g.Object({
  branches: _2(!0),
  executionType: g.Enum(ah)
}), fHe = g.Recursive(
  (e) => g.Union([
    g.Intersect([
      CC,
      g.Object({
        nextAction: g.Optional(e)
      })
    ]),
    g.Intersect([
      NC,
      g.Object({
        nextAction: g.Optional(e)
      })
    ]),
    g.Intersect([
      PC,
      g.Object({
        nextAction: g.Optional(e),
        firstLoopAction: g.Optional(e)
      })
    ]),
    g.Intersect([
      g.Object({
        ...kC,
        type: g.Literal(
          "ROUTER"
          /* ROUTER */
        ),
        settings: uZ
      }),
      g.Object({
        nextAction: g.Optional(e),
        children: g.Array(g.Union([e, g.Null()]))
      })
    ])
  ])
), L2 = g.Object({
  ...kC,
  type: g.Literal(
    "ROUTER"
    /* ROUTER */
  ),
  settings: uZ
}), dZ = g.Union([
  CC,
  NC,
  PC,
  L2
]), vE = {
  firstValue: "",
  secondValue: "",
  operator: "TEXT_CONTAINS",
  caseSensitive: !1
};
let pHe = (e) => crypto.getRandomValues(new Uint8Array(e)), hHe = (e, t, n) => {
  let r = (2 << Math.log(e.length - 1) / Math.LN2) - 1, i = -~(1.6 * r * t / e.length);
  return (o = t) => {
    let s = "";
    for (; ; ) {
      let l = n(i), c = i | 0;
      for (; c--; )
        if (s += e[l[c] & r] || "", s.length === o) return s;
    }
  };
}, m0e = (e, t = 21) => hHe(e, t, pHe), Fu = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((t, n) => (n &= 63, n < 36 ? t += n.toString(36) : n < 62 ? t += (n - 26).toString(36).toUpperCase() : n > 62 ? t += "-" : t += "_", t), "");
const g0e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", y0e = 21, zn = g.String({
  pattern: `^[0-9a-zA-Z]{${y0e}}$`
}), IC = m0e(g0e, y0e), mHe = (e) => m0e(g0e, e)(), v0e = g.Object({
  ...Or,
  name: g.String(),
  userId: g.String()
}), IR = {
  "first-build": {
    imageUrl: "https://cdn.activepieces.com/badges/first-build.gif",
    title: "First Build",
    description: "I had published my first flow and automation is officially real."
  },
  "on-a-roll": {
    imageUrl: "https://cdn.activepieces.com/badges/on-a-roll.gif",
    title: "On a Roll",
    description: "I have 5 active flows and I'm getting the hang of this."
  },
  "automation-addict": {
    imageUrl: "https://cdn.activepieces.com/badges/automation-addict.gif",
    title: "Automation Addict",
    description: "I have 10 active flows and I'm basically an automation pro."
  },
  "cant-stop": {
    imageUrl: "https://cdn.activepieces.com/badges/cant-stop.gif",
    title: "Can't Stop",
    description: "I have 50 active flows and automation just happens around me."
  },
  "webhook-wizard": {
    imageUrl: "https://cdn.activepieces.com/badges/webhook-wizard.gif",
    title: "Webhook Wizard",
    description: "I used webhooks and my triggers are endless now."
  },
  "agentic-genius": {
    imageUrl: "https://cdn.activepieces.com/badges/agentic-genius.gif",
    title: "Agentic Genius",
    description: "I used AI and my automation just got smarter."
  },
  "coding-chad": {
    imageUrl: "https://cdn.activepieces.com/badges/coding-chad.gif",
    title: "Coding Chad",
    description: "I used custom code and made my flow do tricks no one else can."
  },
  "back-again": {
    imageUrl: "https://cdn.activepieces.com/badges/back-again.gif",
    title: "Back Again",
    description: "I tested a flow and it failed to run... but I learned something valuable."
  },
  victory: {
    imageUrl: "https://cdn.activepieces.com/badges/victory.gif",
    title: "Victory",
    description: "I tested a flow and it ran successfully... the joy is real!"
  }
};
var bb = /* @__PURE__ */ ((e) => (e.ADMIN = "ADMIN", e.MEMBER = "MEMBER", e.OPERATOR = "OPERATOR", e))(bb || {}), RC = /* @__PURE__ */ ((e) => (e.ACTIVE = "ACTIVE", e.INACTIVE = "INACTIVE", e))(RC || {});
const fZ = g.String({
  format: "email"
}), pZ = g.String({
  minLength: 8,
  maxLength: 64
}), b0e = g.Object({
  ...Or,
  platformRole: g.Enum(bb),
  status: g.Enum(RC),
  identityId: g.String(),
  externalId: It(g.String()),
  platformId: It(g.String()),
  lastActiveDate: It(g.String())
}), lh = g.Object({
  id: g.String(),
  email: g.String(),
  firstName: g.String(),
  status: g.Enum(RC),
  externalId: It(g.String()),
  platformId: It(g.String()),
  platformRole: g.Enum(bb),
  lastName: g.String(),
  created: g.String(),
  updated: g.String(),
  lastActiveDate: It(g.String())
}), gHe = g.Object({
  ...lh.properties,
  badges: g.Array(g.Pick(v0e, ["name", "created"]))
}), yHe = g.Object({
  status: g.Optional(g.Enum(RC)),
  platformRole: g.Optional(g.Enum(bb)),
  externalId: g.Optional(g.String())
}), vHe = g.Object({
  cursor: g.Optional(g.String()),
  limit: g.Optional(g.Number()),
  externalId: g.Optional(g.String())
});
var z2 = /* @__PURE__ */ ((e) => (e.ACTIVE = "ACTIVE", e.MISSING = "MISSING", e.ERROR = "ERROR", e))(z2 || {}), _u = /* @__PURE__ */ ((e) => (e.PROJECT = "PROJECT", e.PLATFORM = "PLATFORM", e))(_u || {}), Mn = /* @__PURE__ */ ((e) => (e.OAUTH2 = "OAUTH2", e.PLATFORM_OAUTH2 = "PLATFORM_OAUTH2", e.CLOUD_OAUTH2 = "CLOUD_OAUTH2", e.SECRET_TEXT = "SECRET_TEXT", e.BASIC_AUTH = "BASIC_AUTH", e.CUSTOM_AUTH = "CUSTOM_AUTH", e.NO_AUTH = "NO_AUTH", e))(Mn || {});
const bHe = g.Object({
  ...Or,
  externalId: g.String(),
  displayName: g.String(),
  type: g.Enum(Mn),
  pieceName: g.String(),
  projectIds: g.Array(zn),
  platformId: It(g.String()),
  scope: g.Enum(_u),
  status: g.Enum(z2),
  ownerId: It(g.String()),
  owner: It(lh),
  metadata: It(Tl),
  flowIds: It(g.Array(zn)),
  pieceVersion: g.String()
}, {
  description: "App connection is a connection to an external app."
}), OHe = g.Object({
  firstName: g.String(),
  lastName: g.String(),
  email: g.String()
}), Dq = (e, t) => {
  let n = t;
  return e && Object.entries(e).forEach(([r, i]) => {
    n = n.replace(`{${r}}`, String(i));
  }), n;
}, O0e = g.Object({
  cursor: g.Optional(g.String({})),
  projectId: g.String(),
  scope: g.Optional(g.Enum(_u)),
  pieceName: g.Optional(g.String({})),
  displayName: g.Optional(g.String({})),
  status: g.Optional(g.Array(g.Enum(z2))),
  limit: g.Optional(g.Number({}))
}), AHe = g.Object({
  externalId: g.String()
}), wHe = g.Omit(O0e, ["projectId"]), xHe = g.Object({
  projectId: g.String()
});
var hZ = /* @__PURE__ */ ((e) => (e.HEADER = "HEADER", e.BODY = "BODY", e))(hZ || {});
const Ob = {
  externalId: g.String({}),
  displayName: g.String({}),
  pieceName: g.String({}),
  projectId: g.String({}),
  metadata: g.Optional(Tl),
  pieceVersion: g.Optional(g.String({}))
}, nv = "both_client_credentials_and_authorization_code";
var Xs = /* @__PURE__ */ ((e) => (e.AUTHORIZATION_CODE = "authorization_code", e.CLIENT_CREDENTIALS = "client_credentials", e))(Xs || {});
const mZ = g.Record(g.String(), g.Unknown()), j2 = g.Object({
  ...Ob,
  type: g.Literal(Mn.CUSTOM_AUTH),
  value: g.Object({
    type: g.Literal(Mn.CUSTOM_AUTH),
    props: mZ
  })
}, {
  title: "Custom Auth",
  description: "Custom Auth"
}), gZ = g.Object({
  ...Ob,
  type: g.Literal(Mn.NO_AUTH),
  value: g.Object({
    type: g.Literal(Mn.NO_AUTH)
  })
}, {
  title: "No Auth",
  description: "No Auth"
}), yZ = {
  client_id: g.String({
    minLength: 1
  }),
  code: g.String({
    minLength: 1
  }),
  code_challenge: g.Optional(g.String({})),
  scope: g.String(),
  authorization_method: g.Optional(g.Enum(hZ))
}, AT = g.Object({
  ...Ob,
  type: g.Literal(Mn.PLATFORM_OAUTH2),
  value: g.Object({
    ...yZ,
    props: g.Optional(mZ),
    type: g.Literal(Mn.PLATFORM_OAUTH2),
    redirect_url: g.String({
      minLength: 1
    })
  })
}, {
  title: "Platform OAuth2",
  description: "Platform OAuth2"
}), wT = g.Object({
  ...Ob,
  type: g.Literal(Mn.CLOUD_OAUTH2),
  value: g.Object({
    ...yZ,
    props: g.Optional(mZ),
    scope: g.String(),
    type: g.Literal(Mn.CLOUD_OAUTH2)
  })
}, {
  title: "Cloud OAuth2",
  description: "Cloud OAuth2"
}), Xw = g.Object({
  ...Ob,
  type: g.Literal(Mn.SECRET_TEXT),
  value: g.Object({
    type: g.Literal(Mn.SECRET_TEXT),
    secret_text: g.String({
      minLength: 1
    })
  })
}, {
  title: "Secret Text",
  description: "Secret Text"
}), xT = g.Object({
  ...Ob,
  type: g.Literal(Mn.OAUTH2),
  value: g.Object({
    ...yZ,
    client_secret: g.String({
      minLength: 1
    }),
    grant_type: g.Optional(g.Enum(Xs)),
    props: g.Optional(g.Record(g.String(), g.Any())),
    authorization_method: g.Optional(g.Enum(hZ)),
    redirect_url: g.String({
      minLength: 1
    }),
    type: g.Literal(Mn.OAUTH2)
  })
}, {
  title: "OAuth2",
  description: "OAuth2"
}), MC = g.Object({
  ...Ob,
  type: g.Literal(Mn.BASIC_AUTH),
  value: g.Object({
    username: g.String({
      minLength: 1
    }),
    password: g.String({
      minLength: 1
    }),
    type: g.Literal(Mn.BASIC_AUTH)
  })
}, {
  title: "Basic Auth",
  description: "Basic Auth"
}), _q = g.Union([
  Xw,
  xT,
  wT,
  AT,
  MC,
  j2,
  gZ
]), SHe = g.Object({
  displayName: g.String({
    minLength: 1
  }),
  metadata: g.Optional(Tl)
}), EHe = g.Object({
  displayName: g.String({
    minLength: 1
  }),
  projectIds: g.Optional(g.Array(g.String())),
  metadata: g.Optional(Tl)
}), Kg = g.Object({
  scope: g.Literal(_u.PLATFORM),
  projectIds: g.Array(g.String()),
  externalId: g.Optional(g.String()),
  metadata: g.Optional(Tl)
}), THe = g.Union([
  g.Composite([g.Omit(Xw, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(xT, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(wT, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(AT, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(MC, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(j2, ["projectId", "externalId"]), Kg]),
  g.Composite([g.Omit(gZ, ["projectId", "externalId"]), Kg])
]), kHe = g.Object({
  sourceAppConnectionId: g.String(),
  targetAppConnectionId: g.String(),
  projectId: g.String()
}), CHe = g.Object({
  sourceAppConnectionIds: g.Array(g.String()),
  projectId: g.String()
});
var Ww = /* @__PURE__ */ ((e) => (e.SIGNED_UP = "signed.up", e.QUOTA_ALERT = "quota.alert", e.REQUEST_TRIAL_CLICKED = "request.trial.clicked", e.REQUEST_TRIAL_SUBMITTED = "request.trial.submitted", e.KEY_ACTIVATED = "key.activated", e.FLOW_ISSUE_CLICKED = "flow.issue.clicked", e.FLOW_ISSUE_RESOLVED = "flow.issue.resolved", e.USER_INVITED = "user.invited", e.UPGRADE_POPUP = "upgrade.popup", e.CREATED_FLOW = "flow.created", e.DEMO_IMPORTED = "demo.imported", e.FLOW_RUN_CREATED = "run.created", e.FLOW_PUBLISHED = "flow.published", e.FLOW_IMPORTED = "flow.imported", e.FLOW_IMPORTED_USING_FILE = "flow.imported.using.file", e.PIECES_SEARCH = "pieces.search", e.REFERRAL = "referral", e.REFERRAL_LINK_COPIED = "referral.link.copied", e.FLOW_SHARED = "flow.shared", e.TEMPLATE_SEARCH = "template.search", e.FORMS_VIEWED = "forms.viewed", e.FORMS_SUBMITTED = "forms.submitted", e.REWARDS_OPENED = "rewards.opened", e.REWARDS_INSTRUCTION_CLICKED = "rewards.instructions.clicked", e.TRIGGER_FAILURES_EXCEEDED = "trigger.failures.exceeded", e.AI_PROVIDER_USED = "ai.provider.used", e.AI_PROVIDER_CONFIGURED = "ai.provider.configured", e.MCP_TOOL_CALLED = "mcp.tool.called", e.UPGRADE_POPUP_OPENED = "upgrade.popup.opened", e.UPGRADE_CLICKED = "upgrade.clicked", e.OPENED_PRICING_FROM_DASHBOARD = "opened.pricing.from.dashboard", e.PIECE_SELECTOR_SEARCH = "piece.selector.search", e))(Ww || {}), A0e = /* @__PURE__ */ ((e) => (e.EXTRACT_PIECE_METADATA = "EXTRACT_PIECE_METADATA", e.EXECUTE_FLOW = "EXECUTE_FLOW", e.EXECUTE_PROPERTY = "EXECUTE_PROPERTY", e.EXECUTE_TRIGGER_HOOK = "EXECUTE_TRIGGER_HOOK", e.EXECUTE_VALIDATE_AUTH = "EXECUTE_VALIDATE_AUTH", e))(A0e || {}), vZ = /* @__PURE__ */ ((e) => (e.ON_ENABLE = "ON_ENABLE", e.ON_DISABLE = "ON_DISABLE", e.HANDSHAKE = "HANDSHAKE", e.RENEW = "RENEW", e.RUN = "RUN", e.TEST = "TEST", e))(vZ || {}), w0e = /* @__PURE__ */ ((e) => (e.ENGINE_RESPONSE = "engine-response", e.ENGINE_STDOUT = "engine-stdout", e.ENGINE_STDERR = "engine-stderr", e.ENGINE_READY = "engine-ready", e.ENGINE_OPERATION = "engine-operation", e.UPDATE_RUN_PROGRESS = "update-run-progress", e.SEND_FLOW_RESPONSE = "send-flow-response", e.UPDATE_STEP_PROGRESS = "update-step-progress", e))(w0e || {});
const NHe = g.Object({
  message: g.String()
}), PHe = g.Object({
  message: g.String()
});
var Zw = /* @__PURE__ */ ((e) => (e.WEBHOOK_RESPONSE = "WEBHOOK_RESPONSE", e.TEST_FLOW = "TEST_FLOW", e.NONE = "NONE", e))(Zw || {});
const x0e = g.Object({
  body: g.Unknown(),
  rawBody: g.Optional(g.Unknown()),
  headers: g.Record(g.String(), g.String()),
  queryParams: g.Record(g.String(), g.String())
}), IHe = g.Object({
  status: g.Number(),
  body: g.Unknown(),
  headers: g.Record(g.String(), g.String())
});
var S0e = /* @__PURE__ */ ((e) => (e.OK = "OK", e.INTERNAL_ERROR = "INTERNAL_ERROR", e.TIMEOUT = "TIMEOUT", e.MEMORY_ISSUE = "MEMORY_ISSUE", e))(S0e || {}), cr = /* @__PURE__ */ ((e) => (e.FAILED = "FAILED", e.QUOTA_EXCEEDED = "QUOTA_EXCEEDED", e.INTERNAL_ERROR = "INTERNAL_ERROR", e.PAUSED = "PAUSED", e.QUEUED = "QUEUED", e.RUNNING = "RUNNING", e.SUCCEEDED = "SUCCEEDED", e.MEMORY_LIMIT_EXCEEDED = "MEMORY_LIMIT_EXCEEDED", e.TIMEOUT = "TIMEOUT", e.CANCELED = "CANCELED", e))(cr || {}), E0e = /* @__PURE__ */ ((e) => (e.DELAY = "DELAY", e.WEBHOOK = "WEBHOOK", e))(E0e || {});
const T0e = g.Object({
  type: g.Literal(
    "DELAY"
    /* DELAY */
  ),
  resumeDateTime: g.String(),
  requestIdToReply: g.Optional(g.String()),
  handlerId: g.Optional(g.String({})),
  progressUpdateType: g.Optional(g.Enum(Zw))
}), k0e = g.Object({
  status: g.Optional(g.Number()),
  body: g.Optional(g.Unknown()),
  headers: g.Optional(g.Record(g.String(), g.String()))
}), RHe = g.Object({
  status: g.Optional(g.Number()),
  body: g.Optional(g.Unknown()),
  headers: g.Optional(g.Record(g.String(), g.String()))
}), C0e = g.Object({
  type: g.Literal(
    "WEBHOOK"
    /* WEBHOOK */
  ),
  requestId: g.String(),
  requestIdToReply: g.Optional(g.String()),
  response: k0e,
  handlerId: g.Optional(g.String({})),
  progressUpdateType: g.Optional(g.Enum(Zw))
}), bZ = g.Union([T0e, C0e]), DC = ({ status: e, ignoreInternalError: t }) => {
  switch (e) {
    case "SUCCEEDED":
    case "TIMEOUT":
    case "FAILED":
    case "QUOTA_EXCEEDED":
    case "MEMORY_LIMIT_EXCEEDED":
    case "CANCELED":
      return !0;
    case "INTERNAL_ERROR":
      return !t;
    case "QUEUED":
    case "RUNNING":
      return !1;
    case "PAUSED":
      return !1;
  }
}, N0e = [
  "FAILED",
  "INTERNAL_ERROR",
  "QUOTA_EXCEEDED",
  "TIMEOUT",
  "MEMORY_LIMIT_EXCEEDED"
  /* MEMORY_LIMIT_EXCEEDED */
], OZ = (e) => N0e.includes(e), MHe = "ap-parent-run-id", DHe = "ap-fail-parent-on-failure";
var eg = /* @__PURE__ */ ((e) => (e.PRODUCTION = "PRODUCTION", e.TESTING = "TESTING", e))(eg || {}), qA = /* @__PURE__ */ ((e) => (e.ON_LATEST_VERSION = "ON_LATEST_VERSION", e.FROM_FAILED_STEP = "FROM_FAILED_STEP", e))(qA || {});
const _He = g.Object({
  ...Or,
  projectId: g.String(),
  flowId: g.String(),
  parentRunId: g.Optional(g.String()),
  failParentOnFailure: g.Boolean(),
  triggeredBy: g.Optional(g.String()),
  tags: g.Optional(g.Array(g.String())),
  flowVersionId: g.String(),
  flowVersion: g.Optional(g.Object({
    displayName: g.Optional(g.String())
  })),
  logsFileId: It(g.String()),
  status: g.Enum(cr),
  startTime: g.Optional(g.String()),
  finishTime: g.Optional(g.String()),
  environment: g.Enum(eg),
  pauseMetadata: g.Optional(bZ),
  // The steps data may be missing if the flow has not started yet,
  // or if the run is older than AP_EXECUTION_DATA_RETENTION_DAYS and its execution data has been purged.
  steps: It(g.Record(g.String(), g.Unknown())),
  failedStep: g.Optional(g.Object({
    name: g.String(),
    displayName: g.String()
  })),
  stepNameToTest: g.Optional(g.String()),
  archivedAt: It(g.String({ default: null })),
  stepsCount: g.Optional(g.Number())
}), P0e = g.Object({
  name: g.String(),
  displayName: g.String(),
  message: g.String()
}), LHe = g.Object({
  runId: g.String(),
  tags: g.Optional(g.Array(g.String())),
  status: g.Enum(cr),
  projectId: g.String(),
  progressUpdateType: g.Optional(g.Enum(Zw)),
  workerHandlerId: It(g.String()),
  httpRequestId: It(g.String()),
  logsFileId: g.Optional(g.String()),
  stepNameToTest: g.Optional(g.String()),
  failedStep: g.Optional(P0e),
  startTime: g.Optional(g.String()),
  finishTime: g.Optional(g.String()),
  stepResponse: g.Optional(sZ),
  pauseMetadata: g.Optional(bZ),
  stepsCount: g.Optional(g.Number())
}), zHe = g.Object({
  projectId: g.String(),
  stepResponse: sZ
}), jHe = g.Object({
  token: g.String()
});
var AZ = /* @__PURE__ */ ((e) => (e.UPLOAD_DIRECTLY = "UPLOAD_DIRECTLY", e.REDIRECT_TO_S3 = "REDIRECT_TO_S3", e))(AZ || {});
const FHe = g.Object({
  logsFileId: g.String(),
  projectId: g.String(),
  flowRunId: g.String(),
  behavior: g.Enum(AZ)
}), UHe = g.Object({
  workerHandlerId: g.String(),
  httpRequestId: g.String(),
  runResponse: g.Object({
    status: g.Number(),
    body: g.Any(),
    headers: g.Record(g.String(), g.String())
  })
}), VHe = g.Object({
  versionId: g.String()
});
var di = /* @__PURE__ */ ((e) => (e.ORANGE = "orange", e.RED = "red", e.GREEN = "green", e.BLUE = "blue", e.PURPLE = "purple", e.YELLOW = "yellow", e))(di || {});
const Hw = g.Object({
  id: g.String(),
  content: g.String(),
  ownerId: It(g.String()),
  color: g.Enum(di),
  position: g.Object({
    x: g.Number(),
    y: g.Number()
  }),
  size: g.Object({
    width: g.Number(),
    height: g.Number()
  }),
  createdAt: g.String(),
  updatedAt: g.String()
}), F2 = "auth", wZ = g.Object({
  sampleData: g.Optional(M2),
  propertySettings: g.Record(g.String(), nZ),
  customLogoUrl: g.Optional(g.String()),
  pieceName: g.String({}),
  pieceVersion: EC,
  triggerName: g.Optional(g.String({})),
  input: g.Record(g.String({}), g.Any())
});
var Bt = /* @__PURE__ */ ((e) => (e.EMPTY = "EMPTY", e.PIECE = "PIECE_TRIGGER", e))(Bt || {});
const I0e = {
  name: g.String({}),
  valid: g.Boolean({}),
  displayName: g.String({}),
  nextAction: g.Optional(g.Any())
}, xZ = g.Object({
  ...I0e,
  type: g.Literal(
    "EMPTY"
    /* EMPTY */
  ),
  settings: g.Any()
}), U2 = g.Object({
  ...I0e,
  type: g.Literal(
    "PIECE_TRIGGER"
    /* PIECE */
  ),
  settings: wZ
}), V2 = g.Union([
  U2,
  xZ
]), qHe = "15";
var Lo = /* @__PURE__ */ ((e) => (e.LOCKED = "LOCKED", e.DRAFT = "DRAFT", e))(Lo || {});
const q2 = g.Object({
  ...Or,
  flowId: g.String(),
  displayName: g.String(),
  trigger: V2,
  updatedBy: It(g.String()),
  valid: g.Boolean(),
  schemaVersion: It(g.String()),
  agentIds: g.Array(g.String()),
  state: g.Enum(Lo),
  connectionIds: g.Array(g.String()),
  backupFiles: It(g.Record(g.String(), g.String())),
  notes: g.Array(Hw)
}), BHe = g.Object({
  ...Or,
  flowId: g.String(),
  displayName: g.String(),
  valid: g.Boolean(),
  state: g.Enum(Lo),
  updatedBy: It(g.String()),
  schemaVersion: It(g.String()),
  updatedByUser: It(lh)
}), XHe = {
  flowId: "mcp-flow-id",
  flowVersionId: "mcp-flow-version-id",
  flowVersionState: Lo.LOCKED,
  flowRunId: "mcp-flow-run-id",
  triggerPieceName: "mcp-trigger-piece-name"
}, WHe = [
  "HttpClient#sendRequest"
], SZ = 128, ZHe = 512 * 1024;
var R0e = /* @__PURE__ */ ((e) => (e.ENGINE = "ENGINE", e.USER = "USER", e))(R0e || {});
class gc extends Error {
  constructor(n, r, i, o) {
    super(r);
    rn(this, "type");
    this.cause = o, this.name = n, this.type = i;
  }
}
function Mf(e) {
  return JSON.stringify({
    message: e
  }, null, 2);
}
class HHe extends gc {
  constructor(t, n) {
    super("ConnectionNotFound", Mf(`connection (${t}) not found`), "USER", n);
  }
}
class QHe extends gc {
  constructor(t, n) {
    super("ConnectionLoadingFailure", Mf(`Failed to load connection (${t})`), "ENGINE", n);
  }
}
class $He extends gc {
  constructor(t, n) {
    super("ConnectionExpired", Mf(`connection (${t}) expired, reconnect again`), "USER", n);
  }
}
class KHe extends gc {
  constructor(n, r, i) {
    super("StorageLimitError", Mf(`Failed to read/write key "${n}", the value you are trying to read/write is larger than ${Math.floor(r / 1024)} KB`), "USER", i);
    rn(this, "maxStorageSizeInBytes");
    this.maxStorageSizeInBytes = r;
  }
}
class GHe extends gc {
  constructor(t, n) {
    super("StorageInvalidKeyError", Mf(`Failed to read/write key "${t}", the key is empty or longer than ${SZ} characters`), "USER", n);
  }
}
class YHe extends gc {
  constructor(t, n) {
    super("StorageError", Mf(`Failed to read/write key "${t}" due to ${JSON.stringify(n)}`), "ENGINE", n);
  }
}
class JHe extends gc {
  constructor(t) {
    super("FileStoreError", Mf(`Failed to store file due to ${JSON.stringify(t)}`), "ENGINE", t);
  }
}
class eQe extends gc {
  constructor(t, n) {
    super("PausedFlowTimeoutError", `The flow cannot be paused for more than ${n} days`, "USER", t);
  }
}
class tQe extends gc {
  constructor(t, n, r) {
    super("FileSizeError", JSON.stringify({
      message: "File size is larger than maximum supported size",
      currentFileSize: `${t} MB`,
      maximumSupportSize: `${n} MB`
    }), "USER", r);
  }
}
class nQe extends gc {
  constructor(t, n) {
    super("FetchError", Mf(`Failed to fetch from ${t}`), "ENGINE", n);
  }
}
class rQe extends gc {
  constructor(t, n) {
    super("InvalidCronExpressionError", Mf(`Invalid cron expression: ${t}`), "USER", n);
  }
}
class iQe extends gc {
  constructor(t, n, r) {
    super(t, Mf(n), "ENGINE", r);
  }
}
var M0e = /* @__PURE__ */ ((e) => (e.SANDBOX_PROCESS = "SANDBOX_PROCESS", e.SANDBOX_CODE_ONLY = "SANDBOX_CODE_ONLY", e.UNSANDBOXED = "UNSANDBOXED", e.SANDBOX_CODE_AND_PROCESS = "SANDBOX_CODE_AND_PROCESS", e))(M0e || {}), EZ = /* @__PURE__ */ ((e) => (e.BEGIN = "BEGIN", e.RESUME = "RESUME", e))(EZ || {});
const oQe = g.Object({
  steps: g.Record(g.String(), g.Unknown()),
  tags: g.Array(g.String())
}), sQe = 4, aQe = {
  critical: 1,
  high: 2,
  medium: 3,
  low: 4,
  veryLow: 5,
  lowest: 6
}, lQe = "high", cQe = "medium", uQe = "high", dQe = "lowest";
function fQe(e, t) {
  switch (e) {
    case eg.TESTING:
      return lQe;
    case eg.PRODUCTION:
      return De(t) ? cQe : uQe;
  }
}
function pQe(e) {
  switch (e.jobType) {
    case "EXECUTE_POLLING":
    case "RENEW_WEBHOOK":
      return "veryLow";
    case "EXECUTE_WEBHOOK":
      return "medium";
    case "EXECUTE_FLOW":
      return fQe(e.environment, e.synchronousHandlerId);
    case "EXECUTE_PROPERTY":
    case "EXECUTE_EXTRACT_PIECE_INFORMATION":
    case "EXECUTE_VALIDATION":
    case "EXECUTE_TRIGGER_HOOK":
      return "critical";
  }
}
var D0e = /* @__PURE__ */ ((e) => (e.RENEW_WEBHOOK = "RENEW_WEBHOOK", e.EXECUTE_POLLING = "EXECUTE_POLLING", e.EXECUTE_WEBHOOK = "EXECUTE_WEBHOOK", e.EXECUTE_FLOW = "EXECUTE_FLOW", e.EXECUTE_VALIDATION = "EXECUTE_VALIDATION", e.EXECUTE_TRIGGER_HOOK = "EXECUTE_TRIGGER_HOOK", e.EXECUTE_PROPERTY = "EXECUTE_PROPERTY", e.EXECUTE_EXTRACT_PIECE_INFORMATION = "EXECUTE_EXTRACT_PIECE_INFORMATION", e))(D0e || {});
const hQe = [
  "EXECUTE_WEBHOOK",
  "EXECUTE_FLOW",
  "EXECUTE_VALIDATION",
  "EXECUTE_TRIGGER_HOOK",
  "EXECUTE_PROPERTY",
  "EXECUTE_EXTRACT_PIECE_INFORMATION"
  /* EXECUTE_EXTRACT_PIECE_INFORMATION */
], _0e = g.Object({
  schemaVersion: g.Number(),
  projectId: g.String(),
  platformId: g.String(),
  flowVersionId: g.String(),
  flowId: g.String(),
  jobType: g.Literal(
    "RENEW_WEBHOOK"
    /* RENEW_WEBHOOK */
  )
}), L0e = g.Object({
  projectId: g.String(),
  platformId: g.String(),
  schemaVersion: g.Number(),
  flowVersionId: g.String(),
  flowId: g.String(),
  triggerType: g.Enum(Bt),
  jobType: g.Literal(
    "EXECUTE_POLLING"
    /* EXECUTE_POLLING */
  )
}), z0e = g.Object({
  projectId: g.String(),
  platformId: g.String(),
  jobType: g.Literal(
    "EXECUTE_FLOW"
    /* EXECUTE_FLOW */
  ),
  environment: g.Enum(eg),
  schemaVersion: g.Number(),
  flowId: g.String(),
  flowVersionId: g.String(),
  runId: g.String(),
  synchronousHandlerId: g.Optional(g.Union([g.String(), g.Null()])),
  httpRequestId: g.Optional(g.String()),
  payload: g.Any(),
  executeTrigger: g.Optional(g.Boolean()),
  executionType: g.Enum(EZ),
  progressUpdateType: g.Enum(Zw),
  stepNameToTest: g.Optional(g.String()),
  sampleData: g.Optional(g.Record(g.String(), g.Unknown())),
  logsUploadUrl: g.String(),
  logsFileId: g.String(),
  traceContext: g.Optional(g.Record(g.String(), g.String()))
}), j0e = g.Object({
  projectId: g.String(),
  platformId: g.String(),
  schemaVersion: g.Number(),
  requestId: g.String(),
  payload: g.Any(),
  runEnvironment: g.Enum(eg),
  flowId: g.String(),
  saveSampleData: g.Boolean(),
  flowVersionIdToRun: g.String(),
  execute: g.Boolean(),
  jobType: g.Literal(
    "EXECUTE_WEBHOOK"
    /* EXECUTE_WEBHOOK */
  ),
  parentRunId: g.Optional(g.String()),
  failParentOnFailure: g.Optional(g.Boolean()),
  traceContext: g.Optional(g.Record(g.String(), g.String()))
}), TZ = g.Object({
  requestId: g.String(),
  webserverId: g.String(),
  jobType: g.Literal(
    "EXECUTE_VALIDATION"
    /* EXECUTE_VALIDATION */
  ),
  projectId: g.Optional(g.String()),
  platformId: g.String(),
  piece: C2,
  schemaVersion: g.Number(),
  connectionValue: g.Unknown()
}), kZ = g.Object({
  requestId: g.String(),
  jobType: g.Literal(
    "EXECUTE_TRIGGER_HOOK"
    /* EXECUTE_TRIGGER_HOOK */
  ),
  platformId: g.String(),
  projectId: g.String(),
  schemaVersion: g.Number(),
  flowId: g.String(),
  flowVersionId: g.String(),
  test: g.Boolean(),
  webserverId: g.String(),
  hookType: g.Enum(vZ),
  triggerPayload: g.Optional(x0e)
}), CZ = g.Object({
  requestId: g.String(),
  jobType: g.Literal(
    "EXECUTE_PROPERTY"
    /* EXECUTE_PROPERTY */
  ),
  projectId: g.String(),
  platformId: g.String(),
  schemaVersion: g.Number(),
  flowVersion: g.Optional(q2),
  propertyName: g.String(),
  piece: C2,
  actionOrTriggerName: g.String(),
  input: g.Record(g.String(), g.Unknown()),
  webserverId: g.String(),
  sampleData: g.Record(g.String(), g.Unknown()),
  searchValue: g.Optional(g.String())
}), NZ = g.Object({
  requestId: g.String(),
  webserverId: g.String(),
  schemaVersion: g.Number(),
  jobType: g.Literal(
    "EXECUTE_EXTRACT_PIECE_INFORMATION"
    /* EXECUTE_EXTRACT_PIECE_INFORMATION */
  ),
  projectId: g.Optional(g.String()),
  platformId: g.String(),
  piece: C2
}), F0e = g.Union([
  TZ,
  kZ,
  CZ,
  NZ
]), mQe = g.Union([
  g.Omit(TZ, ["webserverId", "requestId", "schemaVersion"]),
  g.Omit(kZ, ["webserverId", "requestId", "schemaVersion"]),
  g.Omit(CZ, ["webserverId", "requestId", "schemaVersion"]),
  g.Omit(NZ, ["webserverId", "requestId", "schemaVersion"])
]), U0e = g.Union([
  L0e,
  _0e,
  z0e,
  j0e,
  F0e
]), V0e = g.Object({
  active: g.Number(),
  delayed: g.Number(),
  prioritized: g.Number(),
  waiting: g.Number(),
  "waiting-children": g.Number(),
  completed: g.Number(),
  failed: g.Number(),
  paused: g.Number()
}), gQe = g.Object({
  stats: V0e
}), yQe = g.Object({
  value: g.Array(g.String())
}), vQe = g.Object({
  flowId: g.Optional(g.Array(zn)),
  tags: g.Optional(g.Array(g.String({}))),
  status: g.Optional(g.Array(g.Enum(cr))),
  limit: g.Optional(g.Number({})),
  page: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({})),
  createdAfter: g.Optional(g.String({})),
  createdBefore: g.Optional(g.String({})),
  projectId: zn,
  failedStepName: g.Optional(g.String({})),
  flowRunIds: g.Optional(g.Array(zn)),
  includeArchived: g.Optional(g.Boolean({}))
});
var po = /* @__PURE__ */ ((e) => (e.FAILED = "FAILED", e.PAUSED = "PAUSED", e.RUNNING = "RUNNING", e.STOPPED = "STOPPED", e.SUCCEEDED = "SUCCEEDED", e))(po || {});
class Mp {
  constructor(t) {
    rn(this, "type");
    rn(this, "status");
    rn(this, "input");
    rn(this, "output");
    rn(this, "duration");
    rn(this, "errorMessage");
    this.type = t.type, this.status = t.status, this.input = t.input, this.output = t.output, this.duration = t.duration, this.errorMessage = t.errorMessage;
  }
  setOutput(t) {
    return new Mp({
      ...this,
      output: t
    });
  }
  setStatus(t) {
    return new Mp({
      ...this,
      status: t
    });
  }
  setErrorMessage(t) {
    return new Mp({
      ...this,
      errorMessage: t
    });
  }
  setDuration(t) {
    return new Mp({
      ...this,
      duration: t
    });
  }
  static create({
    input: t,
    type: n,
    status: r,
    output: i
  }) {
    return new Mp({
      input: t,
      type: n,
      status: r,
      output: i
    });
  }
}
class PZ extends Mp {
  static init({ input: t }) {
    return new PZ({
      type: qe.ROUTER,
      input: t,
      status: "SUCCEEDED"
      /* SUCCEEDED */
    });
  }
}
class mO extends Mp {
  constructor(t) {
    super(t), this.output = t.output ?? {
      item: void 0,
      index: 0,
      iterations: []
    };
  }
  static init({ input: t }) {
    return new mO({
      type: qe.LOOP_ON_ITEMS,
      input: t,
      status: "SUCCEEDED"
      /* SUCCEEDED */
    });
  }
  setIterations(t) {
    return new mO({
      ...this,
      output: {
        ...this.output,
        iterations: t
      }
    });
  }
  hasIteration(t) {
    var n;
    return !De((n = this.output) == null ? void 0 : n.iterations[t]);
  }
  setItemAndIndex({
    item: t,
    index: n
  }) {
    var r;
    return new mO({
      ...this,
      output: {
        item: t,
        index: n,
        iterations: ((r = this.output) == null ? void 0 : r.iterations) ?? []
      }
    });
  }
  addIteration() {
    var t, n, r;
    return new mO({
      ...this,
      output: {
        item: (t = this.output) == null ? void 0 : t.item,
        index: (n = this.output) == null ? void 0 : n.index,
        iterations: [...((r = this.output) == null ? void 0 : r.iterations) ?? [], {}]
      }
    });
  }
}
var hf = /* @__PURE__ */ ((e) => (e.POLLING = "POLLING", e.WEBHOOK = "WEBHOOK", e.APP_WEBHOOK = "APP_WEBHOOK", e))(hf || {}), LO = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.HEADER_PRESENT = "HEADER_PRESENT", e.QUERY_PRESENT = "QUERY_PRESENT", e.BODY_PARAM_PRESENT = "BODY_PARAM_PRESENT", e))(LO || {}), IZ = /* @__PURE__ */ ((e) => (e.CRON_EXPRESSION = "CRON_EXPRESSION", e))(IZ || {});
const q0e = g.Object({
  strategy: g.Enum(LO),
  paramName: g.Optional(g.String())
}), B0e = g.Object({
  type: g.Enum(IZ),
  cronExpression: g.String(),
  timezone: g.String()
}), RZ = g.Object({
  ...Or,
  type: g.Enum(hf),
  projectId: g.String(),
  flowId: g.String(),
  triggerName: g.String(),
  schedule: It(B0e),
  flowVersionId: g.String(),
  pieceName: g.String(),
  pieceVersion: g.String(),
  deleted: It(g.String()),
  simulate: g.Boolean()
});
var il = /* @__PURE__ */ ((e) => (e.ENABLED = "ENABLED", e.DISABLED = "DISABLED", e))(il || {}), MZ = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.DELETING = "DELETING", e.ENABLING = "ENABLING", e.DISABLING = "DISABLING", e))(MZ || {});
const bQe = (e) => `flow-execution-state:${e}`, DZ = g.Object({
  ...Or,
  projectId: g.String(),
  externalId: g.String(),
  ownerId: It(g.String()),
  folderId: It(g.String()),
  status: g.Enum(il),
  publishedVersionId: It(g.String()),
  metadata: It(Tl),
  operationStatus: g.Enum(MZ),
  timeSavedPerRun: It(g.Number())
}), _C = g.Composite([
  DZ,
  g.Object({
    version: q2,
    triggerSource: g.Optional(g.Pick(RZ, ["schedule"]))
  })
]), OQe = g.Composite([
  RZ,
  g.Object({
    flow: DZ
  })
]);
var kF, Vte;
function Qw() {
  if (Vte) return kF;
  Vte = 1;
  const e = Fa();
  return kF = (n, r, i = !1) => {
    if (n instanceof e)
      return n;
    try {
      return new e(n, r);
    } catch (o) {
      if (!i)
        return null;
      throw o;
    }
  }, kF;
}
var CF, qte;
function AQe() {
  if (qte) return CF;
  qte = 1;
  const e = Qw();
  return CF = (n, r) => {
    const i = e(n, r);
    return i ? i.version : null;
  }, CF;
}
var NF, Bte;
function wQe() {
  if (Bte) return NF;
  Bte = 1;
  const e = Qw();
  return NF = (n, r) => {
    const i = e(n.trim().replace(/^[=v]+/, ""), r);
    return i ? i.version : null;
  }, NF;
}
var PF, Xte;
function xQe() {
  if (Xte) return PF;
  Xte = 1;
  const e = Fa();
  return PF = (n, r, i, o, s) => {
    typeof i == "string" && (s = o, o = i, i = void 0);
    try {
      return new e(
        n instanceof e ? n.version : n,
        i
      ).inc(r, o, s).version;
    } catch {
      return null;
    }
  }, PF;
}
var IF, Wte;
function SQe() {
  if (Wte) return IF;
  Wte = 1;
  const e = Qw();
  return IF = (n, r) => {
    const i = e(n, null, !0), o = e(r, null, !0), s = i.compare(o);
    if (s === 0)
      return null;
    const l = s > 0, c = l ? i : o, a = l ? o : i, u = !!c.prerelease.length;
    if (!!a.prerelease.length && !u)
      return !a.patch && !a.minor ? "major" : c.patch ? "patch" : c.minor ? "minor" : "major";
    const d = u ? "pre" : "";
    return i.major !== o.major ? d + "major" : i.minor !== o.minor ? d + "minor" : i.patch !== o.patch ? d + "patch" : "prerelease";
  }, IF;
}
var RF, Zte;
function EQe() {
  if (Zte) return RF;
  Zte = 1;
  const e = Fa();
  return RF = (n, r) => new e(n, r).patch, RF;
}
var MF, Hte;
function TQe() {
  if (Hte) return MF;
  Hte = 1;
  const e = Qw();
  return MF = (n, r) => {
    const i = e(n, r);
    return i && i.prerelease.length ? i.prerelease : null;
  }, MF;
}
var DF, Qte;
function kQe() {
  if (Qte) return DF;
  Qte = 1;
  const e = dd();
  return DF = (n, r, i) => e(r, n, i), DF;
}
var _F, $te;
function CQe() {
  if ($te) return _F;
  $te = 1;
  const e = dd();
  return _F = (n, r) => e(n, r, !0), _F;
}
var LF, Kte;
function _Z() {
  if (Kte) return LF;
  Kte = 1;
  const e = Fa();
  return LF = (n, r, i) => {
    const o = new e(n, i), s = new e(r, i);
    return o.compare(s) || o.compareBuild(s);
  }, LF;
}
var zF, Gte;
function NQe() {
  if (Gte) return zF;
  Gte = 1;
  const e = _Z();
  return zF = (n, r) => n.sort((i, o) => e(i, o, r)), zF;
}
var jF, Yte;
function PQe() {
  if (Yte) return jF;
  Yte = 1;
  const e = _Z();
  return jF = (n, r) => n.sort((i, o) => e(o, i, r)), jF;
}
var FF, Jte;
function IQe() {
  if (Jte) return FF;
  Jte = 1;
  const e = Fa(), t = Qw(), { safeRe: n, t: r } = TC();
  return FF = (o, s) => {
    if (o instanceof e)
      return o;
    if (typeof o == "number" && (o = String(o)), typeof o != "string")
      return null;
    s = s || {};
    let l = null;
    if (!s.rtl)
      l = o.match(s.includePrerelease ? n[r.COERCEFULL] : n[r.COERCE]);
    else {
      const p = s.includePrerelease ? n[r.COERCERTLFULL] : n[r.COERCERTL];
      let h;
      for (; (h = p.exec(o)) && (!l || l.index + l[0].length !== o.length); )
        (!l || h.index + h[0].length !== l.index + l[0].length) && (l = h), p.lastIndex = h.index + h[1].length + h[2].length;
      p.lastIndex = -1;
    }
    if (l === null)
      return null;
    const c = l[2], a = l[3] || "0", u = l[4] || "0", f = s.includePrerelease && l[5] ? `-${l[5]}` : "", d = s.includePrerelease && l[6] ? `+${l[6]}` : "";
    return t(`${c}.${a}.${u}${f}${d}`, s);
  }, FF;
}
var UF, ene;
function B2() {
  if (ene) return UF;
  ene = 1;
  const e = fd();
  return UF = (n, r, i) => {
    try {
      r = new e(r, i);
    } catch {
      return !1;
    }
    return r.test(n);
  }, UF;
}
var VF, tne;
function RQe() {
  if (tne) return VF;
  tne = 1;
  const e = fd();
  return VF = (n, r) => new e(n, r).set.map((i) => i.map((o) => o.value).join(" ").trim().split(" ")), VF;
}
var qF, nne;
function MQe() {
  if (nne) return qF;
  nne = 1;
  const e = Fa(), t = fd();
  return qF = (r, i, o) => {
    let s = null, l = null, c = null;
    try {
      c = new t(i, o);
    } catch {
      return null;
    }
    return r.forEach((a) => {
      c.test(a) && (!s || l.compare(a) === -1) && (s = a, l = new e(s, o));
    }), s;
  }, qF;
}
var BF, rne;
function DQe() {
  if (rne) return BF;
  rne = 1;
  const e = Fa(), t = fd();
  return BF = (r, i, o) => {
    let s = null, l = null, c = null;
    try {
      c = new t(i, o);
    } catch {
      return null;
    }
    return r.forEach((a) => {
      c.test(a) && (!s || l.compare(a) === 1) && (s = a, l = new e(s, o));
    }), s;
  }, BF;
}
var XF, ine;
function _Qe() {
  if (ine) return XF;
  ine = 1;
  const e = fd();
  return XF = (n, r) => {
    try {
      return new e(n, r).range || "*";
    } catch {
      return null;
    }
  }, XF;
}
var WF, one;
function LZ() {
  if (one) return WF;
  one = 1;
  const e = Fa(), t = R2(), { ANY: n } = t, r = fd(), i = B2(), o = I2(), s = eZ(), l = tZ(), c = JW();
  return WF = (u, f, d, p) => {
    u = new e(u, p), f = new r(f, p);
    let h, m, v, b, A;
    switch (d) {
      case ">":
        h = o, m = l, v = s, b = ">", A = ">=";
        break;
      case "<":
        h = s, m = c, v = o, b = "<", A = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (i(u, f, p))
      return !1;
    for (let w = 0; w < f.set.length; ++w) {
      const O = f.set[w];
      let x = null, S = null;
      if (O.forEach((E) => {
        E.semver === n && (E = new t(">=0.0.0")), x = x || E, S = S || E, h(E.semver, x.semver, p) ? x = E : v(E.semver, S.semver, p) && (S = E);
      }), x.operator === b || x.operator === A || (!S.operator || S.operator === b) && m(u, S.semver))
        return !1;
      if (S.operator === A && v(u, S.semver))
        return !1;
    }
    return !0;
  }, WF;
}
var ZF, sne;
function LQe() {
  if (sne) return ZF;
  sne = 1;
  const e = LZ();
  return ZF = (n, r, i) => e(n, r, ">", i), ZF;
}
var HF, ane;
function zQe() {
  if (ane) return HF;
  ane = 1;
  const e = LZ();
  return HF = (n, r, i) => e(n, r, "<", i), HF;
}
var QF, lne;
function jQe() {
  if (lne) return QF;
  lne = 1;
  const e = fd();
  return QF = (n, r, i) => (n = new e(n, i), r = new e(r, i), n.intersects(r, i)), QF;
}
var $F, cne;
function FQe() {
  if (cne) return $F;
  cne = 1;
  const e = B2(), t = dd();
  return $F = (n, r, i) => {
    const o = [];
    let s = null, l = null;
    const c = n.sort((d, p) => t(d, p, i));
    for (const d of c)
      e(d, r, i) ? (l = d, s || (s = d)) : (l && o.push([s, l]), l = null, s = null);
    s && o.push([s, null]);
    const a = [];
    for (const [d, p] of o)
      d === p ? a.push(d) : !p && d === c[0] ? a.push("*") : p ? d === c[0] ? a.push(`<=${p}`) : a.push(`${d} - ${p}`) : a.push(`>=${d}`);
    const u = a.join(" || "), f = typeof r.raw == "string" ? r.raw : String(r);
    return u.length < f.length ? u : r;
  }, $F;
}
var KF, une;
function UQe() {
  if (une) return KF;
  une = 1;
  const e = fd(), t = R2(), { ANY: n } = t, r = B2(), i = dd(), o = (f, d, p = {}) => {
    if (f === d)
      return !0;
    f = new e(f, p), d = new e(d, p);
    let h = !1;
    e: for (const m of f.set) {
      for (const v of d.set) {
        const b = c(m, v, p);
        if (h = h || b !== null, b)
          continue e;
      }
      if (h)
        return !1;
    }
    return !0;
  }, s = [new t(">=0.0.0-0")], l = [new t(">=0.0.0")], c = (f, d, p) => {
    if (f === d)
      return !0;
    if (f.length === 1 && f[0].semver === n) {
      if (d.length === 1 && d[0].semver === n)
        return !0;
      p.includePrerelease ? f = s : f = l;
    }
    if (d.length === 1 && d[0].semver === n) {
      if (p.includePrerelease)
        return !0;
      d = l;
    }
    const h = /* @__PURE__ */ new Set();
    let m, v;
    for (const k of f)
      k.operator === ">" || k.operator === ">=" ? m = a(m, k, p) : k.operator === "<" || k.operator === "<=" ? v = u(v, k, p) : h.add(k.semver);
    if (h.size > 1)
      return null;
    let b;
    if (m && v) {
      if (b = i(m.semver, v.semver, p), b > 0)
        return null;
      if (b === 0 && (m.operator !== ">=" || v.operator !== "<="))
        return null;
    }
    for (const k of h) {
      if (m && !r(k, String(m), p) || v && !r(k, String(v), p))
        return null;
      for (const T of d)
        if (!r(k, String(T), p))
          return !1;
      return !0;
    }
    let A, w, O, x, S = v && !p.includePrerelease && v.semver.prerelease.length ? v.semver : !1, E = m && !p.includePrerelease && m.semver.prerelease.length ? m.semver : !1;
    S && S.prerelease.length === 1 && v.operator === "<" && S.prerelease[0] === 0 && (S = !1);
    for (const k of d) {
      if (x = x || k.operator === ">" || k.operator === ">=", O = O || k.operator === "<" || k.operator === "<=", m) {
        if (E && k.semver.prerelease && k.semver.prerelease.length && k.semver.major === E.major && k.semver.minor === E.minor && k.semver.patch === E.patch && (E = !1), k.operator === ">" || k.operator === ">=") {
          if (A = a(m, k, p), A === k && A !== m)
            return !1;
        } else if (m.operator === ">=" && !r(m.semver, String(k), p))
          return !1;
      }
      if (v) {
        if (S && k.semver.prerelease && k.semver.prerelease.length && k.semver.major === S.major && k.semver.minor === S.minor && k.semver.patch === S.patch && (S = !1), k.operator === "<" || k.operator === "<=") {
          if (w = u(v, k, p), w === k && w !== v)
            return !1;
        } else if (v.operator === "<=" && !r(v.semver, String(k), p))
          return !1;
      }
      if (!k.operator && (v || m) && b !== 0)
        return !1;
    }
    return !(m && O && !v && b !== 0 || v && x && !m && b !== 0 || E || S);
  }, a = (f, d, p) => {
    if (!f)
      return d;
    const h = i(f.semver, d.semver, p);
    return h > 0 ? f : h < 0 || d.operator === ">" && f.operator === ">=" ? d : f;
  }, u = (f, d, p) => {
    if (!f)
      return d;
    const h = i(f.semver, d.semver, p);
    return h < 0 ? f : h > 0 || d.operator === "<" && f.operator === "<=" ? d : f;
  };
  return KF = o, KF;
}
var GF, dne;
function VQe() {
  if (dne) return GF;
  dne = 1;
  const e = TC(), t = P2(), n = Fa(), r = Hbe(), i = Qw(), o = AQe(), s = wQe(), l = xQe(), c = SQe(), a = Qbe(), u = $be(), f = EQe(), d = TQe(), p = dd(), h = kQe(), m = CQe(), v = _Z(), b = NQe(), A = PQe(), w = I2(), O = eZ(), x = Kbe(), S = Gbe(), E = JW(), k = tZ(), T = Ybe(), R = IQe(), j = R2(), F = fd(), L = B2(), _ = RQe(), U = MQe(), z = DQe(), C = Jbe(), I = _Qe(), M = LZ(), D = LQe(), X = zQe(), B = jQe(), q = FQe(), H = UQe();
  return GF = {
    parse: i,
    valid: o,
    clean: s,
    inc: l,
    diff: c,
    major: a,
    minor: u,
    patch: f,
    prerelease: d,
    compare: p,
    rcompare: h,
    compareLoose: m,
    compareBuild: v,
    sort: b,
    rsort: A,
    gt: w,
    lt: O,
    eq: x,
    neq: S,
    gte: E,
    lte: k,
    cmp: T,
    coerce: R,
    Comparator: j,
    Range: F,
    satisfies: L,
    toComparators: _,
    maxSatisfying: U,
    minSatisfying: z,
    minVersion: C,
    validRange: I,
    outside: M,
    gtr: D,
    ltr: X,
    intersects: B,
    simplifyRange: q,
    subset: H,
    SemVer: n,
    re: e.re,
    src: e.src,
    tokens: e.t,
    SEMVER_SPEC_VERSION: t.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: t.RELEASE_TYPES,
    compareIdentifiers: r.compareIdentifiers,
    rcompareIdentifiers: r.rcompareIdentifiers
  }, GF;
}
var Lq = VQe();
const zq = /* @__PURE__ */ Sl(Lq), X2 = "@activepieces/piece-ai";
function X0e(e) {
  return Object.entries(qe).some(([, t]) => t === e);
}
function W0e(e) {
  return Object.entries(Bt).some(([, t]) => t === e);
}
function qQe(e, t) {
  const n = zZ(e, t);
  if (!X0e(n.type))
    throw new vb({
      code: Ni.STEP_NOT_FOUND,
      params: {
        stepName: e
      }
    });
  return n;
}
function BQe(e, t) {
  const n = zZ(e, t);
  if (!W0e(n.type))
    throw new vb({
      code: Ni.STEP_NOT_FOUND,
      params: {
        stepName: e
      }
    });
  return n;
}
function Z0e(e, t) {
  return jZ(t).find((n) => n.name === e);
}
function zZ(e, t) {
  const n = Z0e(e, t);
  if (De(n))
    throw new vb({
      code: Ni.STEP_NOT_FOUND,
      params: {
        stepName: e
      }
    });
  return n;
}
function zO(e, t) {
  const n = t(e);
  switch (n.type) {
    case qe.LOOP_ON_ITEMS: {
      const { firstLoopAction: r } = n;
      r && (n.firstLoopAction = zO(
        r,
        t
      ));
      break;
    }
    case qe.ROUTER: {
      const { children: r } = n;
      r && (n.children = r.map(
        (i) => i ? zO(i, t) : null
      ));
      break;
    }
  }
  return n.nextAction && (n.nextAction = zO(
    n.nextAction,
    t
  )), n;
}
function XQe(e, t) {
  const n = JSON.parse(JSON.stringify(e));
  return n.trigger = zO(
    n.trigger,
    t
  ), n;
}
function jZ(e) {
  const t = [];
  return zO(e, (n) => (t.push(n), n)), t;
}
const WQe = (e, t) => ({
  conditions: t ?? [[vE]],
  branchType: iu.CONDITION,
  branchName: e
});
function ZQe(e, t) {
  return At.getAllSteps(e).map((r, i) => ({
    ...r,
    dfsIndex: i
  })).filter((r) => At.getAllSteps(r).some((o) => o.name === t)).filter((r) => r.name !== t);
}
function H0e(e) {
  return jZ({
    ...e,
    nextAction: void 0
  });
}
function HQe(e, t) {
  switch (e.type) {
    case qe.ROUTER:
    case qe.LOOP_ON_ITEMS:
      return H0e(e).findIndex((r) => r.name === t) > -1;
  }
  return !1;
}
const QQe = (e, t = 1) => {
  const n = Array.isArray(e) ? e : At.getAllSteps(e).map((i) => i.name), r = [];
  for (let i = 1; i <= t; i++) {
    const o = Q0e(n);
    r.push(o), n.push(o);
  }
  return r;
}, Q0e = (e) => {
  const t = Array.isArray(e) ? e : At.getAllSteps(e).map((i) => i.name);
  let n = 1, r = "step_1";
  for (; t.includes(r); )
    n++, r = "step_" + n;
  return r;
};
function $Qe(e) {
  const t = [];
  let n = e.nextAction;
  for (; !De(n); )
    t.push(n), n = n.nextAction;
  return t;
}
function fne(e) {
  const t = e.match(/{{connections\['([^']*(?:'\s*,\s*'[^']*)*)'\]}}/);
  return !t || !t[1] ? [] : t[1].split(/'\s*,\s*'/).map((n) => n.trim());
}
function KQe(e) {
  const t = (n) => $0e(n) && "agentId" in n.settings.input ? n.settings.input.agentId : null;
  return At.getAllSteps(e.trigger).map((n) => t(n)).filter((n) => n !== null && n !== "");
}
function $0e(e) {
  return e.type === qe.PIECE && e.settings.pieceName === X2;
}
function GQe(e) {
  var r, i;
  const t = (i = (r = e.trigger.settings) == null ? void 0 : r.input) != null && i.auth ? fne(e.trigger.settings.input.auth) : [], n = At.getAllSteps(e.trigger).flatMap(
    (o) => {
      var s, l;
      return (l = (s = o.settings) == null ? void 0 : s.input) != null && l.auth ? fne(o.settings.input.auth) : [];
    }
  );
  return Array.from(/* @__PURE__ */ new Set([...t, ...n]));
}
const At = {
  isTrigger: W0e,
  isAction: X0e,
  getAllSteps: jZ,
  transferStep: zO,
  transferFlow: XQe,
  getStepOrThrow: zZ,
  getActionOrThrow: qQe,
  getTriggerOrThrow: BQe,
  getStep: Z0e,
  createBranch: WQe,
  findPathToStep: ZQe,
  isChildOf: HQe,
  findUnusedName: Q0e,
  findUnusedNames: QQe,
  getAllNextActionsWithoutChildren: $Qe,
  getAllChildSteps: H0e,
  extractConnectionIds: GQe,
  isAgentPiece: $0e,
  extractAgentIds: KQe
}, Ic = {
  makeFlowAutoUpgradable(e) {
    return At.transferFlow(e, (t) => {
      if (t.name !== t.name)
        return t;
      const n = JSON.parse(JSON.stringify(t));
      switch (t.type) {
        case qe.PIECE:
        case Bt.PIECE: {
          const { pieceVersion: r } = t.settings;
          n.settings.pieceVersion = Ic.getMostRecentPatchVersion(r);
          break;
        }
      }
      return n;
    });
  },
  getExactVersion(e) {
    return e.startsWith("^") || e.startsWith("~") ? e.slice(1) : e;
  },
  getUsedPieces(e) {
    return At.getAllSteps(e).filter((t) => t.type === qe.PIECE || t.type === Bt.PIECE).map((t) => t.settings.pieceName);
  },
  getMostRecentPatchVersion(e) {
    return e.startsWith("^") || e.startsWith("~") ? e : zq.valid(e) && zq.lt(e, "1.0.0") ? `~${e}` : `^${e}`;
  }
};
function K0e(e) {
  switch (e.errorType) {
    case Ze.ArrayContains:
      return "Expected array to contain at least one matching value";
    case Ze.ArrayMaxContains:
      return `Expected array to contain no more than ${e.schema.maxContains} matching values`;
    case Ze.ArrayMinContains:
      return `Expected array to contain at least ${e.schema.minContains} matching values`;
    case Ze.ArrayMaxItems:
      return `Expected array length to be less or equal to ${e.schema.maxItems}`;
    case Ze.ArrayMinItems:
      return `Expected array length to be greater or equal to ${e.schema.minItems}`;
    case Ze.ArrayUniqueItems:
      return "Expected array elements to be unique";
    case Ze.Array:
      return "Expected array";
    case Ze.AsyncIterator:
      return "Expected AsyncIterator";
    case Ze.BigIntExclusiveMaximum:
      return `Expected bigint to be less than ${e.schema.exclusiveMaximum}`;
    case Ze.BigIntExclusiveMinimum:
      return `Expected bigint to be greater than ${e.schema.exclusiveMinimum}`;
    case Ze.BigIntMaximum:
      return `Expected bigint to be less or equal to ${e.schema.maximum}`;
    case Ze.BigIntMinimum:
      return `Expected bigint to be greater or equal to ${e.schema.minimum}`;
    case Ze.BigIntMultipleOf:
      return `Expected bigint to be a multiple of ${e.schema.multipleOf}`;
    case Ze.BigInt:
      return "Expected bigint";
    case Ze.Boolean:
      return "Expected boolean";
    case Ze.DateExclusiveMinimumTimestamp:
      return `Expected Date timestamp to be greater than ${e.schema.exclusiveMinimumTimestamp}`;
    case Ze.DateExclusiveMaximumTimestamp:
      return `Expected Date timestamp to be less than ${e.schema.exclusiveMaximumTimestamp}`;
    case Ze.DateMinimumTimestamp:
      return `Expected Date timestamp to be greater or equal to ${e.schema.minimumTimestamp}`;
    case Ze.DateMaximumTimestamp:
      return `Expected Date timestamp to be less or equal to ${e.schema.maximumTimestamp}`;
    case Ze.DateMultipleOfTimestamp:
      return `Expected Date timestamp to be a multiple of ${e.schema.multipleOfTimestamp}`;
    case Ze.Date:
      return "Expected Date";
    case Ze.Function:
      return "Expected function";
    case Ze.IntegerExclusiveMaximum:
      return `Expected integer to be less than ${e.schema.exclusiveMaximum}`;
    case Ze.IntegerExclusiveMinimum:
      return `Expected integer to be greater than ${e.schema.exclusiveMinimum}`;
    case Ze.IntegerMaximum:
      return `Expected integer to be less or equal to ${e.schema.maximum}`;
    case Ze.IntegerMinimum:
      return `Expected integer to be greater or equal to ${e.schema.minimum}`;
    case Ze.IntegerMultipleOf:
      return `Expected integer to be a multiple of ${e.schema.multipleOf}`;
    case Ze.Integer:
      return "Expected integer";
    case Ze.IntersectUnevaluatedProperties:
      return "Unexpected property";
    case Ze.Intersect:
      return "Expected all values to match";
    case Ze.Iterator:
      return "Expected Iterator";
    case Ze.Literal:
      return `Expected ${typeof e.schema.const == "string" ? `'${e.schema.const}'` : e.schema.const}`;
    case Ze.Never:
      return "Never";
    case Ze.Not:
      return "Value should not match";
    case Ze.Null:
      return "Expected null";
    case Ze.NumberExclusiveMaximum:
      return `Expected number to be less than ${e.schema.exclusiveMaximum}`;
    case Ze.NumberExclusiveMinimum:
      return `Expected number to be greater than ${e.schema.exclusiveMinimum}`;
    case Ze.NumberMaximum:
      return `Expected number to be less or equal to ${e.schema.maximum}`;
    case Ze.NumberMinimum:
      return `Expected number to be greater or equal to ${e.schema.minimum}`;
    case Ze.NumberMultipleOf:
      return `Expected number to be a multiple of ${e.schema.multipleOf}`;
    case Ze.Number:
      return "Expected number";
    case Ze.Object:
      return "Expected object";
    case Ze.ObjectAdditionalProperties:
      return "Unexpected property";
    case Ze.ObjectMaxProperties:
      return `Expected object to have no more than ${e.schema.maxProperties} properties`;
    case Ze.ObjectMinProperties:
      return `Expected object to have at least ${e.schema.minProperties} properties`;
    case Ze.ObjectRequiredProperty:
      return "Expected required property";
    case Ze.Promise:
      return "Expected Promise";
    case Ze.RegExp:
      return "Expected string to match regular expression";
    case Ze.StringFormatUnknown:
      return `Unknown format '${e.schema.format}'`;
    case Ze.StringFormat:
      return `Expected string to match '${e.schema.format}' format`;
    case Ze.StringMaxLength:
      return `Expected string length less or equal to ${e.schema.maxLength}`;
    case Ze.StringMinLength:
      return `Expected string length greater or equal to ${e.schema.minLength}`;
    case Ze.StringPattern:
      return `Expected string to match '${e.schema.pattern}'`;
    case Ze.String:
      return "Expected string";
    case Ze.Symbol:
      return "Expected symbol";
    case Ze.TupleLength:
      return `Expected tuple to have ${e.schema.maxItems || 0} elements`;
    case Ze.Tuple:
      return "Expected tuple";
    case Ze.Uint8ArrayMaxByteLength:
      return `Expected byte length less or equal to ${e.schema.maxByteLength}`;
    case Ze.Uint8ArrayMinByteLength:
      return `Expected byte length greater or equal to ${e.schema.minByteLength}`;
    case Ze.Uint8Array:
      return "Expected Uint8Array";
    case Ze.Undefined:
      return "Expected undefined";
    case Ze.Union:
      return "Expected union value";
    case Ze.Void:
      return "Expected void";
    case Ze.Kind:
      return `Expected kind '${e.schema[Ut]}'`;
    default:
      return "Unknown error type";
  }
}
let G0e = K0e;
function YQe(e) {
  G0e = e;
}
function JQe() {
  return G0e;
}
class e$e extends Ns {
  constructor(t) {
    super(`Unable to dereference schema with $id '${t.$ref}'`), this.schema = t;
  }
}
function t$e(e, t) {
  const n = t.find((r) => r.$id === e.$ref);
  if (n === void 0)
    throw new e$e(e);
  return pu(n, t);
}
function W2(e, t) {
  return !nc(e.$id) || t.some((n) => n.$id === e.$id) || t.push(e), t;
}
function pu(e, t) {
  return e[Ut] === "This" || e[Ut] === "Ref" ? t$e(e, t) : e;
}
class n$e extends Ns {
  constructor(t) {
    super("Unable to hash value"), this.value = t;
  }
}
var fc;
(function(e) {
  e[e.Undefined = 0] = "Undefined", e[e.Null = 1] = "Null", e[e.Boolean = 2] = "Boolean", e[e.Number = 3] = "Number", e[e.String = 4] = "String", e[e.Object = 5] = "Object", e[e.Array = 6] = "Array", e[e.Date = 7] = "Date", e[e.Uint8Array = 8] = "Uint8Array", e[e.Symbol = 9] = "Symbol", e[e.BigInt = 10] = "BigInt";
})(fc || (fc = {}));
let gO = BigInt("14695981039346656037");
const [r$e, i$e] = [BigInt("1099511628211"), BigInt(
  "18446744073709551616"
  /* 2 ^ 64 */
)], o$e = Array.from({ length: 256 }).map((e, t) => BigInt(t)), Y0e = new Float64Array(1), J0e = new DataView(Y0e.buffer), eOe = new Uint8Array(Y0e.buffer);
function* s$e(e) {
  const t = e === 0 ? 1 : Math.ceil(Math.floor(Math.log2(e) + 1) / 8);
  for (let n = 0; n < t; n++)
    yield e >> 8 * (t - 1 - n) & 255;
}
function a$e(e) {
  ea(fc.Array);
  for (const t of e)
    BA(t);
}
function l$e(e) {
  ea(fc.Boolean), ea(e ? 1 : 0);
}
function c$e(e) {
  ea(fc.BigInt), J0e.setBigInt64(0, e);
  for (const t of eOe)
    ea(t);
}
function u$e(e) {
  ea(fc.Date), BA(e.getTime());
}
function d$e(e) {
  ea(fc.Null);
}
function f$e(e) {
  ea(fc.Number), J0e.setFloat64(0, e);
  for (const t of eOe)
    ea(t);
}
function p$e(e) {
  ea(fc.Object);
  for (const t of globalThis.Object.getOwnPropertyNames(e).sort())
    BA(t), BA(e[t]);
}
function h$e(e) {
  ea(fc.String);
  for (let t = 0; t < e.length; t++)
    for (const n of s$e(e.charCodeAt(t)))
      ea(n);
}
function m$e(e) {
  ea(fc.Symbol), BA(e.description);
}
function g$e(e) {
  ea(fc.Uint8Array);
  for (let t = 0; t < e.length; t++)
    ea(e[t]);
}
function y$e(e) {
  return ea(fc.Undefined);
}
function BA(e) {
  if (cc(e))
    return a$e(e);
  if (d2(e))
    return l$e(e);
  if (Rp(e))
    return c$e(e);
  if (aW(e))
    return u$e(e);
  if (u2(e))
    return d$e();
  if (Xn(e))
    return f$e(e);
  if (If(e))
    return p$e(e);
  if (nc(e))
    return h$e(e);
  if (f2(e))
    return m$e(e);
  if (lW(e))
    return g$e(e);
  if (Ag(e))
    return y$e();
  throw new n$e(e);
}
function ea(e) {
  gO = gO ^ o$e[e], gO = gO * r$e % i$e;
}
function FZ(e) {
  return gO = BigInt("14695981039346656037"), BA(e), gO;
}
class v$e extends Ns {
  constructor(t) {
    super("Unknown type"), this.schema = t;
  }
}
function b$e(e) {
  return e[Ut] === "Any" || e[Ut] === "Unknown";
}
function nr(e) {
  return e !== void 0;
}
function O$e(e, t, n) {
  return !0;
}
function A$e(e, t, n) {
  if (!cc(n) || nr(e.minItems) && !(n.length >= e.minItems) || nr(e.maxItems) && !(n.length <= e.maxItems) || !n.every((o) => Jo(e.items, t, o)) || e.uniqueItems === !0 && !function() {
    const o = /* @__PURE__ */ new Set();
    for (const s of n) {
      const l = FZ(s);
      if (o.has(l))
        return !1;
      o.add(l);
    }
    return !0;
  }())
    return !1;
  if (!(nr(e.contains) || Xn(e.minContains) || Xn(e.maxContains)))
    return !0;
  const r = nr(e.contains) ? e.contains : Uo(), i = n.reduce((o, s) => Jo(r, t, s) ? o + 1 : o, 0);
  return !(i === 0 || Xn(e.minContains) && i < e.minContains || Xn(e.maxContains) && i > e.maxContains);
}
function w$e(e, t, n) {
  return Dve(n);
}
function x$e(e, t, n) {
  return !(!Rp(n) || nr(e.exclusiveMaximum) && !(n < e.exclusiveMaximum) || nr(e.exclusiveMinimum) && !(n > e.exclusiveMinimum) || nr(e.maximum) && !(n <= e.maximum) || nr(e.minimum) && !(n >= e.minimum) || nr(e.multipleOf) && n % e.multipleOf !== BigInt(0));
}
function S$e(e, t, n) {
  return d2(n);
}
function E$e(e, t, n) {
  return Jo(e.returns, t, n.prototype);
}
function T$e(e, t, n) {
  return !(!aW(n) || nr(e.exclusiveMaximumTimestamp) && !(n.getTime() < e.exclusiveMaximumTimestamp) || nr(e.exclusiveMinimumTimestamp) && !(n.getTime() > e.exclusiveMinimumTimestamp) || nr(e.maximumTimestamp) && !(n.getTime() <= e.maximumTimestamp) || nr(e.minimumTimestamp) && !(n.getTime() >= e.minimumTimestamp) || nr(e.multipleOfTimestamp) && n.getTime() % e.multipleOfTimestamp !== 0);
}
function k$e(e, t, n) {
  return Fve(n);
}
function C$e(e, t, n) {
  const r = globalThis.Object.values(e.$defs), i = e.$defs[e.$ref];
  return Jo(i, [...t, ...r], n);
}
function N$e(e, t, n) {
  return !(!jve(n) || nr(e.exclusiveMaximum) && !(n < e.exclusiveMaximum) || nr(e.exclusiveMinimum) && !(n > e.exclusiveMinimum) || nr(e.maximum) && !(n <= e.maximum) || nr(e.minimum) && !(n >= e.minimum) || nr(e.multipleOf) && n % e.multipleOf !== 0);
}
function P$e(e, t, n) {
  const r = e.allOf.every((i) => Jo(i, t, n));
  if (e.unevaluatedProperties === !1) {
    const i = new RegExp(FA(e)), o = Object.getOwnPropertyNames(n).every((s) => i.test(s));
    return r && o;
  } else if (Ta(e.unevaluatedProperties)) {
    const i = new RegExp(FA(e)), o = Object.getOwnPropertyNames(n).every((s) => i.test(s) || Jo(e.unevaluatedProperties, t, n[s]));
    return r && o;
  } else
    return r;
}
function I$e(e, t, n) {
  return _ve(n);
}
function R$e(e, t, n) {
  return n === e.const;
}
function M$e(e, t, n) {
  return !1;
}
function D$e(e, t, n) {
  return !Jo(e.not, t, n);
}
function _$e(e, t, n) {
  return u2(n);
}
function L$e(e, t, n) {
  return !(!$i.IsNumberLike(n) || nr(e.exclusiveMaximum) && !(n < e.exclusiveMaximum) || nr(e.exclusiveMinimum) && !(n > e.exclusiveMinimum) || nr(e.minimum) && !(n >= e.minimum) || nr(e.maximum) && !(n <= e.maximum) || nr(e.multipleOf) && n % e.multipleOf !== 0);
}
function z$e(e, t, n) {
  if (!$i.IsObjectLike(n) || nr(e.minProperties) && !(Object.getOwnPropertyNames(n).length >= e.minProperties) || nr(e.maxProperties) && !(Object.getOwnPropertyNames(n).length <= e.maxProperties))
    return !1;
  const r = Object.getOwnPropertyNames(e.properties);
  for (const i of r) {
    const o = e.properties[i];
    if (e.required && e.required.includes(i)) {
      if (!Jo(o, t, n[i]) || (Vw(o) || b$e(o)) && !(i in n))
        return !1;
    } else if ($i.IsExactOptionalProperty(n, i) && !Jo(o, t, n[i]))
      return !1;
  }
  if (e.additionalProperties === !1) {
    const i = Object.getOwnPropertyNames(n);
    return e.required && e.required.length === r.length && i.length === r.length ? !0 : i.every((o) => r.includes(o));
  } else return typeof e.additionalProperties == "object" ? Object.getOwnPropertyNames(n).every((o) => r.includes(o) || Jo(e.additionalProperties, t, n[o])) : !0;
}
function j$e(e, t, n) {
  return Lve(n);
}
function F$e(e, t, n) {
  if (!$i.IsRecordLike(n) || nr(e.minProperties) && !(Object.getOwnPropertyNames(n).length >= e.minProperties) || nr(e.maxProperties) && !(Object.getOwnPropertyNames(n).length <= e.maxProperties))
    return !1;
  const [r, i] = Object.entries(e.patternProperties)[0], o = new RegExp(r), s = Object.entries(n).every(([a, u]) => o.test(a) ? Jo(i, t, u) : !0), l = typeof e.additionalProperties == "object" ? Object.entries(n).every(([a, u]) => o.test(a) ? !0 : Jo(e.additionalProperties, t, u)) : !0, c = e.additionalProperties === !1 ? Object.getOwnPropertyNames(n).every((a) => o.test(a)) : !0;
  return s && l && c;
}
function U$e(e, t, n) {
  return Jo(pu(e, t), t, n);
}
function V$e(e, t, n) {
  const r = new RegExp(e.source, e.flags);
  return nr(e.minLength) && !(n.length >= e.minLength) || nr(e.maxLength) && !(n.length <= e.maxLength) ? !1 : r.test(n);
}
function q$e(e, t, n) {
  return !nc(n) || nr(e.minLength) && !(n.length >= e.minLength) || nr(e.maxLength) && !(n.length <= e.maxLength) || nr(e.pattern) && !new RegExp(e.pattern).test(n) ? !1 : nr(e.format) ? wW(e.format) ? xW(e.format)(n) : !1 : !0;
}
function B$e(e, t, n) {
  return f2(n);
}
function X$e(e, t, n) {
  return nc(n) && new RegExp(e.pattern).test(n);
}
function W$e(e, t, n) {
  return Jo(pu(e, t), t, n);
}
function Z$e(e, t, n) {
  if (!cc(n) || e.items === void 0 && n.length !== 0 || n.length !== e.maxItems)
    return !1;
  if (!e.items)
    return !0;
  for (let r = 0; r < e.items.length; r++)
    if (!Jo(e.items[r], t, n[r]))
      return !1;
  return !0;
}
function H$e(e, t, n) {
  return Ag(n);
}
function Q$e(e, t, n) {
  return e.anyOf.some((r) => Jo(r, t, n));
}
function $$e(e, t, n) {
  return !(!lW(n) || nr(e.maxByteLength) && !(n.length <= e.maxByteLength) || nr(e.minByteLength) && !(n.length >= e.minByteLength));
}
function K$e(e, t, n) {
  return !0;
}
function G$e(e, t, n) {
  return $i.IsVoidLike(n);
}
function Y$e(e, t, n) {
  return hT(e[Ut]) ? SW(e[Ut])(e, n) : !1;
}
function Jo(e, t, n) {
  const r = nr(e.$id) ? W2(e, t) : t, i = e;
  switch (i[Ut]) {
    case "Any":
      return O$e();
    case "Array":
      return A$e(i, r, n);
    case "AsyncIterator":
      return w$e(i, r, n);
    case "BigInt":
      return x$e(i, r, n);
    case "Boolean":
      return S$e(i, r, n);
    case "Constructor":
      return E$e(i, r, n);
    case "Date":
      return T$e(i, r, n);
    case "Function":
      return k$e(i, r, n);
    case "Import":
      return C$e(i, r, n);
    case "Integer":
      return N$e(i, r, n);
    case "Intersect":
      return P$e(i, r, n);
    case "Iterator":
      return I$e(i, r, n);
    case "Literal":
      return R$e(i, r, n);
    case "Never":
      return M$e();
    case "Not":
      return D$e(i, r, n);
    case "Null":
      return _$e(i, r, n);
    case "Number":
      return L$e(i, r, n);
    case "Object":
      return z$e(i, r, n);
    case "Promise":
      return j$e(i, r, n);
    case "Record":
      return F$e(i, r, n);
    case "Ref":
      return U$e(i, r, n);
    case "RegExp":
      return V$e(i, r, n);
    case "String":
      return q$e(i, r, n);
    case "Symbol":
      return B$e(i, r, n);
    case "TemplateLiteral":
      return X$e(i, r, n);
    case "This":
      return W$e(i, r, n);
    case "Tuple":
      return Z$e(i, r, n);
    case "Undefined":
      return H$e(i, r, n);
    case "Union":
      return Q$e(i, r, n);
    case "Uint8Array":
      return $$e(i, r, n);
    case "Unknown":
      return K$e();
    case "Void":
      return G$e(i, r, n);
    default:
      if (!hT(i[Ut]))
        throw new v$e(i);
      return Y$e(i, r, n);
  }
}
function BM(...e) {
  return e.length === 3 ? Jo(e[0], e[1], e[2]) : Jo(e[0], [], e[1]);
}
var Ze;
(function(e) {
  e[e.ArrayContains = 0] = "ArrayContains", e[e.ArrayMaxContains = 1] = "ArrayMaxContains", e[e.ArrayMaxItems = 2] = "ArrayMaxItems", e[e.ArrayMinContains = 3] = "ArrayMinContains", e[e.ArrayMinItems = 4] = "ArrayMinItems", e[e.ArrayUniqueItems = 5] = "ArrayUniqueItems", e[e.Array = 6] = "Array", e[e.AsyncIterator = 7] = "AsyncIterator", e[e.BigIntExclusiveMaximum = 8] = "BigIntExclusiveMaximum", e[e.BigIntExclusiveMinimum = 9] = "BigIntExclusiveMinimum", e[e.BigIntMaximum = 10] = "BigIntMaximum", e[e.BigIntMinimum = 11] = "BigIntMinimum", e[e.BigIntMultipleOf = 12] = "BigIntMultipleOf", e[e.BigInt = 13] = "BigInt", e[e.Boolean = 14] = "Boolean", e[e.DateExclusiveMaximumTimestamp = 15] = "DateExclusiveMaximumTimestamp", e[e.DateExclusiveMinimumTimestamp = 16] = "DateExclusiveMinimumTimestamp", e[e.DateMaximumTimestamp = 17] = "DateMaximumTimestamp", e[e.DateMinimumTimestamp = 18] = "DateMinimumTimestamp", e[e.DateMultipleOfTimestamp = 19] = "DateMultipleOfTimestamp", e[e.Date = 20] = "Date", e[e.Function = 21] = "Function", e[e.IntegerExclusiveMaximum = 22] = "IntegerExclusiveMaximum", e[e.IntegerExclusiveMinimum = 23] = "IntegerExclusiveMinimum", e[e.IntegerMaximum = 24] = "IntegerMaximum", e[e.IntegerMinimum = 25] = "IntegerMinimum", e[e.IntegerMultipleOf = 26] = "IntegerMultipleOf", e[e.Integer = 27] = "Integer", e[e.IntersectUnevaluatedProperties = 28] = "IntersectUnevaluatedProperties", e[e.Intersect = 29] = "Intersect", e[e.Iterator = 30] = "Iterator", e[e.Kind = 31] = "Kind", e[e.Literal = 32] = "Literal", e[e.Never = 33] = "Never", e[e.Not = 34] = "Not", e[e.Null = 35] = "Null", e[e.NumberExclusiveMaximum = 36] = "NumberExclusiveMaximum", e[e.NumberExclusiveMinimum = 37] = "NumberExclusiveMinimum", e[e.NumberMaximum = 38] = "NumberMaximum", e[e.NumberMinimum = 39] = "NumberMinimum", e[e.NumberMultipleOf = 40] = "NumberMultipleOf", e[e.Number = 41] = "Number", e[e.ObjectAdditionalProperties = 42] = "ObjectAdditionalProperties", e[e.ObjectMaxProperties = 43] = "ObjectMaxProperties", e[e.ObjectMinProperties = 44] = "ObjectMinProperties", e[e.ObjectRequiredProperty = 45] = "ObjectRequiredProperty", e[e.Object = 46] = "Object", e[e.Promise = 47] = "Promise", e[e.RegExp = 48] = "RegExp", e[e.StringFormatUnknown = 49] = "StringFormatUnknown", e[e.StringFormat = 50] = "StringFormat", e[e.StringMaxLength = 51] = "StringMaxLength", e[e.StringMinLength = 52] = "StringMinLength", e[e.StringPattern = 53] = "StringPattern", e[e.String = 54] = "String", e[e.Symbol = 55] = "Symbol", e[e.TupleLength = 56] = "TupleLength", e[e.Tuple = 57] = "Tuple", e[e.Uint8ArrayMaxByteLength = 58] = "Uint8ArrayMaxByteLength", e[e.Uint8ArrayMinByteLength = 59] = "Uint8ArrayMinByteLength", e[e.Uint8Array = 60] = "Uint8Array", e[e.Undefined = 61] = "Undefined", e[e.Union = 62] = "Union", e[e.Void = 63] = "Void";
})(Ze || (Ze = {}));
class J$e extends Ns {
  constructor(t) {
    super("Unknown type"), this.schema = t;
  }
}
function Tp(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function er(e) {
  return e !== void 0;
}
class tOe {
  constructor(t) {
    this.iterator = t;
  }
  [Symbol.iterator]() {
    return this.iterator;
  }
  /** Returns the first value error or undefined if no errors */
  First() {
    const t = this.iterator.next();
    return t.done ? void 0 : t.value;
  }
}
function qt(e, t, n, r, i = []) {
  return {
    type: e,
    schema: t,
    path: n,
    value: r,
    message: JQe()({ errorType: e, path: n, schema: t, value: r, errors: i }),
    errors: i
  };
}
function* eKe(e, t, n, r) {
}
function* tKe(e, t, n, r) {
  if (!cc(r))
    return yield qt(Ze.Array, e, n, r);
  er(e.minItems) && !(r.length >= e.minItems) && (yield qt(Ze.ArrayMinItems, e, n, r)), er(e.maxItems) && !(r.length <= e.maxItems) && (yield qt(Ze.ArrayMaxItems, e, n, r));
  for (let s = 0; s < r.length; s++)
    yield* es(e.items, t, `${n}/${s}`, r[s]);
  if (e.uniqueItems === !0 && !function() {
    const s = /* @__PURE__ */ new Set();
    for (const l of r) {
      const c = FZ(l);
      if (s.has(c))
        return !1;
      s.add(c);
    }
    return !0;
  }() && (yield qt(Ze.ArrayUniqueItems, e, n, r)), !(er(e.contains) || er(e.minContains) || er(e.maxContains)))
    return;
  const i = er(e.contains) ? e.contains : Uo(), o = r.reduce((s, l, c) => es(i, t, `${n}${c}`, l).next().done === !0 ? s + 1 : s, 0);
  o === 0 && (yield qt(Ze.ArrayContains, e, n, r)), Xn(e.minContains) && o < e.minContains && (yield qt(Ze.ArrayMinContains, e, n, r)), Xn(e.maxContains) && o > e.maxContains && (yield qt(Ze.ArrayMaxContains, e, n, r));
}
function* nKe(e, t, n, r) {
  Dve(r) || (yield qt(Ze.AsyncIterator, e, n, r));
}
function* rKe(e, t, n, r) {
  if (!Rp(r))
    return yield qt(Ze.BigInt, e, n, r);
  er(e.exclusiveMaximum) && !(r < e.exclusiveMaximum) && (yield qt(Ze.BigIntExclusiveMaximum, e, n, r)), er(e.exclusiveMinimum) && !(r > e.exclusiveMinimum) && (yield qt(Ze.BigIntExclusiveMinimum, e, n, r)), er(e.maximum) && !(r <= e.maximum) && (yield qt(Ze.BigIntMaximum, e, n, r)), er(e.minimum) && !(r >= e.minimum) && (yield qt(Ze.BigIntMinimum, e, n, r)), er(e.multipleOf) && r % e.multipleOf !== BigInt(0) && (yield qt(Ze.BigIntMultipleOf, e, n, r));
}
function* iKe(e, t, n, r) {
  d2(r) || (yield qt(Ze.Boolean, e, n, r));
}
function* oKe(e, t, n, r) {
  yield* es(e.returns, t, n, r.prototype);
}
function* sKe(e, t, n, r) {
  if (!aW(r))
    return yield qt(Ze.Date, e, n, r);
  er(e.exclusiveMaximumTimestamp) && !(r.getTime() < e.exclusiveMaximumTimestamp) && (yield qt(Ze.DateExclusiveMaximumTimestamp, e, n, r)), er(e.exclusiveMinimumTimestamp) && !(r.getTime() > e.exclusiveMinimumTimestamp) && (yield qt(Ze.DateExclusiveMinimumTimestamp, e, n, r)), er(e.maximumTimestamp) && !(r.getTime() <= e.maximumTimestamp) && (yield qt(Ze.DateMaximumTimestamp, e, n, r)), er(e.minimumTimestamp) && !(r.getTime() >= e.minimumTimestamp) && (yield qt(Ze.DateMinimumTimestamp, e, n, r)), er(e.multipleOfTimestamp) && r.getTime() % e.multipleOfTimestamp !== 0 && (yield qt(Ze.DateMultipleOfTimestamp, e, n, r));
}
function* aKe(e, t, n, r) {
  Fve(r) || (yield qt(Ze.Function, e, n, r));
}
function* lKe(e, t, n, r) {
  const i = globalThis.Object.values(e.$defs), o = e.$defs[e.$ref];
  yield* es(o, [...t, ...i], n, r);
}
function* cKe(e, t, n, r) {
  if (!jve(r))
    return yield qt(Ze.Integer, e, n, r);
  er(e.exclusiveMaximum) && !(r < e.exclusiveMaximum) && (yield qt(Ze.IntegerExclusiveMaximum, e, n, r)), er(e.exclusiveMinimum) && !(r > e.exclusiveMinimum) && (yield qt(Ze.IntegerExclusiveMinimum, e, n, r)), er(e.maximum) && !(r <= e.maximum) && (yield qt(Ze.IntegerMaximum, e, n, r)), er(e.minimum) && !(r >= e.minimum) && (yield qt(Ze.IntegerMinimum, e, n, r)), er(e.multipleOf) && r % e.multipleOf !== 0 && (yield qt(Ze.IntegerMultipleOf, e, n, r));
}
function* uKe(e, t, n, r) {
  let i = !1;
  for (const o of e.allOf)
    for (const s of es(o, t, n, r))
      i = !0, yield s;
  if (i)
    return yield qt(Ze.Intersect, e, n, r);
  if (e.unevaluatedProperties === !1) {
    const o = new RegExp(FA(e));
    for (const s of Object.getOwnPropertyNames(r))
      o.test(s) || (yield qt(Ze.IntersectUnevaluatedProperties, e, `${n}/${s}`, r));
  }
  if (typeof e.unevaluatedProperties == "object") {
    const o = new RegExp(FA(e));
    for (const s of Object.getOwnPropertyNames(r))
      if (!o.test(s)) {
        const l = es(e.unevaluatedProperties, t, `${n}/${s}`, r[s]).next();
        l.done || (yield l.value);
      }
  }
}
function* dKe(e, t, n, r) {
  _ve(r) || (yield qt(Ze.Iterator, e, n, r));
}
function* fKe(e, t, n, r) {
  r !== e.const && (yield qt(Ze.Literal, e, n, r));
}
function* pKe(e, t, n, r) {
  yield qt(Ze.Never, e, n, r);
}
function* hKe(e, t, n, r) {
  es(e.not, t, n, r).next().done === !0 && (yield qt(Ze.Not, e, n, r));
}
function* mKe(e, t, n, r) {
  u2(r) || (yield qt(Ze.Null, e, n, r));
}
function* gKe(e, t, n, r) {
  if (!$i.IsNumberLike(r))
    return yield qt(Ze.Number, e, n, r);
  er(e.exclusiveMaximum) && !(r < e.exclusiveMaximum) && (yield qt(Ze.NumberExclusiveMaximum, e, n, r)), er(e.exclusiveMinimum) && !(r > e.exclusiveMinimum) && (yield qt(Ze.NumberExclusiveMinimum, e, n, r)), er(e.maximum) && !(r <= e.maximum) && (yield qt(Ze.NumberMaximum, e, n, r)), er(e.minimum) && !(r >= e.minimum) && (yield qt(Ze.NumberMinimum, e, n, r)), er(e.multipleOf) && r % e.multipleOf !== 0 && (yield qt(Ze.NumberMultipleOf, e, n, r));
}
function* yKe(e, t, n, r) {
  if (!$i.IsObjectLike(r))
    return yield qt(Ze.Object, e, n, r);
  er(e.minProperties) && !(Object.getOwnPropertyNames(r).length >= e.minProperties) && (yield qt(Ze.ObjectMinProperties, e, n, r)), er(e.maxProperties) && !(Object.getOwnPropertyNames(r).length <= e.maxProperties) && (yield qt(Ze.ObjectMaxProperties, e, n, r));
  const i = Array.isArray(e.required) ? e.required : [], o = Object.getOwnPropertyNames(e.properties), s = Object.getOwnPropertyNames(r);
  for (const l of i)
    s.includes(l) || (yield qt(Ze.ObjectRequiredProperty, e.properties[l], `${n}/${Tp(l)}`, void 0));
  if (e.additionalProperties === !1)
    for (const l of s)
      o.includes(l) || (yield qt(Ze.ObjectAdditionalProperties, e, `${n}/${Tp(l)}`, r[l]));
  if (typeof e.additionalProperties == "object")
    for (const l of s)
      o.includes(l) || (yield* es(e.additionalProperties, t, `${n}/${Tp(l)}`, r[l]));
  for (const l of o) {
    const c = e.properties[l];
    e.required && e.required.includes(l) ? (yield* es(c, t, `${n}/${Tp(l)}`, r[l]), Vw(e) && !(l in r) && (yield qt(Ze.ObjectRequiredProperty, c, `${n}/${Tp(l)}`, void 0))) : $i.IsExactOptionalProperty(r, l) && (yield* es(c, t, `${n}/${Tp(l)}`, r[l]));
  }
}
function* vKe(e, t, n, r) {
  Lve(r) || (yield qt(Ze.Promise, e, n, r));
}
function* bKe(e, t, n, r) {
  if (!$i.IsRecordLike(r))
    return yield qt(Ze.Object, e, n, r);
  er(e.minProperties) && !(Object.getOwnPropertyNames(r).length >= e.minProperties) && (yield qt(Ze.ObjectMinProperties, e, n, r)), er(e.maxProperties) && !(Object.getOwnPropertyNames(r).length <= e.maxProperties) && (yield qt(Ze.ObjectMaxProperties, e, n, r));
  const [i, o] = Object.entries(e.patternProperties)[0], s = new RegExp(i);
  for (const [l, c] of Object.entries(r))
    s.test(l) && (yield* es(o, t, `${n}/${Tp(l)}`, c));
  if (typeof e.additionalProperties == "object")
    for (const [l, c] of Object.entries(r))
      s.test(l) || (yield* es(e.additionalProperties, t, `${n}/${Tp(l)}`, c));
  if (e.additionalProperties === !1) {
    for (const [l, c] of Object.entries(r))
      if (!s.test(l))
        return yield qt(Ze.ObjectAdditionalProperties, e, `${n}/${Tp(l)}`, c);
  }
}
function* OKe(e, t, n, r) {
  yield* es(pu(e, t), t, n, r);
}
function* AKe(e, t, n, r) {
  if (!nc(r))
    return yield qt(Ze.String, e, n, r);
  if (er(e.minLength) && !(r.length >= e.minLength) && (yield qt(Ze.StringMinLength, e, n, r)), er(e.maxLength) && !(r.length <= e.maxLength) && (yield qt(Ze.StringMaxLength, e, n, r)), !new RegExp(e.source, e.flags).test(r))
    return yield qt(Ze.RegExp, e, n, r);
}
function* wKe(e, t, n, r) {
  if (!nc(r))
    return yield qt(Ze.String, e, n, r);
  er(e.minLength) && !(r.length >= e.minLength) && (yield qt(Ze.StringMinLength, e, n, r)), er(e.maxLength) && !(r.length <= e.maxLength) && (yield qt(Ze.StringMaxLength, e, n, r)), nc(e.pattern) && (new RegExp(e.pattern).test(r) || (yield qt(Ze.StringPattern, e, n, r))), nc(e.format) && (wW(e.format) ? xW(e.format)(r) || (yield qt(Ze.StringFormat, e, n, r)) : yield qt(Ze.StringFormatUnknown, e, n, r));
}
function* xKe(e, t, n, r) {
  f2(r) || (yield qt(Ze.Symbol, e, n, r));
}
function* SKe(e, t, n, r) {
  if (!nc(r))
    return yield qt(Ze.String, e, n, r);
  new RegExp(e.pattern).test(r) || (yield qt(Ze.StringPattern, e, n, r));
}
function* EKe(e, t, n, r) {
  yield* es(pu(e, t), t, n, r);
}
function* TKe(e, t, n, r) {
  if (!cc(r))
    return yield qt(Ze.Tuple, e, n, r);
  if (e.items === void 0 && r.length !== 0)
    return yield qt(Ze.TupleLength, e, n, r);
  if (r.length !== e.maxItems)
    return yield qt(Ze.TupleLength, e, n, r);
  if (e.items)
    for (let i = 0; i < e.items.length; i++)
      yield* es(e.items[i], t, `${n}/${i}`, r[i]);
}
function* kKe(e, t, n, r) {
  Ag(r) || (yield qt(Ze.Undefined, e, n, r));
}
function* CKe(e, t, n, r) {
  if (BM(e, t, r))
    return;
  const i = e.anyOf.map((o) => new tOe(es(o, t, n, r)));
  yield qt(Ze.Union, e, n, r, i);
}
function* NKe(e, t, n, r) {
  if (!lW(r))
    return yield qt(Ze.Uint8Array, e, n, r);
  er(e.maxByteLength) && !(r.length <= e.maxByteLength) && (yield qt(Ze.Uint8ArrayMaxByteLength, e, n, r)), er(e.minByteLength) && !(r.length >= e.minByteLength) && (yield qt(Ze.Uint8ArrayMinByteLength, e, n, r));
}
function* PKe(e, t, n, r) {
}
function* IKe(e, t, n, r) {
  $i.IsVoidLike(r) || (yield qt(Ze.Void, e, n, r));
}
function* RKe(e, t, n, r) {
  SW(e[Ut])(e, r) || (yield qt(Ze.Kind, e, n, r));
}
function* es(e, t, n, r) {
  const i = er(e.$id) ? [...t, e] : t, o = e;
  switch (o[Ut]) {
    case "Any":
      return yield* eKe();
    case "Array":
      return yield* tKe(o, i, n, r);
    case "AsyncIterator":
      return yield* nKe(o, i, n, r);
    case "BigInt":
      return yield* rKe(o, i, n, r);
    case "Boolean":
      return yield* iKe(o, i, n, r);
    case "Constructor":
      return yield* oKe(o, i, n, r);
    case "Date":
      return yield* sKe(o, i, n, r);
    case "Function":
      return yield* aKe(o, i, n, r);
    case "Import":
      return yield* lKe(o, i, n, r);
    case "Integer":
      return yield* cKe(o, i, n, r);
    case "Intersect":
      return yield* uKe(o, i, n, r);
    case "Iterator":
      return yield* dKe(o, i, n, r);
    case "Literal":
      return yield* fKe(o, i, n, r);
    case "Never":
      return yield* pKe(o, i, n, r);
    case "Not":
      return yield* hKe(o, i, n, r);
    case "Null":
      return yield* mKe(o, i, n, r);
    case "Number":
      return yield* gKe(o, i, n, r);
    case "Object":
      return yield* yKe(o, i, n, r);
    case "Promise":
      return yield* vKe(o, i, n, r);
    case "Record":
      return yield* bKe(o, i, n, r);
    case "Ref":
      return yield* OKe(o, i, n, r);
    case "RegExp":
      return yield* AKe(o, i, n, r);
    case "String":
      return yield* wKe(o, i, n, r);
    case "Symbol":
      return yield* xKe(o, i, n, r);
    case "TemplateLiteral":
      return yield* SKe(o, i, n, r);
    case "This":
      return yield* EKe(o, i, n, r);
    case "Tuple":
      return yield* TKe(o, i, n, r);
    case "Undefined":
      return yield* kKe(o, i, n, r);
    case "Union":
      return yield* CKe(o, i, n, r);
    case "Uint8Array":
      return yield* NKe(o, i, n, r);
    case "Unknown":
      return yield* PKe();
    case "Void":
      return yield* IKe(o, i, n, r);
    default:
      if (!hT(o[Ut]))
        throw new J$e(e);
      return yield* RKe(o, i, n, r);
  }
}
function XM(...e) {
  const t = e.length === 3 ? es(e[0], e[1], "", e[2]) : es(e[0], [], "", e[1]);
  return new tOe(t);
}
class MKe extends Ns {
  constructor(t, n, r) {
    super("Unable to decode value as it does not match the expected schema"), this.schema = t, this.value = n, this.error = r;
  }
}
class DKe extends Ns {
  constructor(t, n, r, i) {
    super(i instanceof Error ? i.message : "Unknown error"), this.schema = t, this.path = n, this.value = r, this.error = i;
  }
}
function Pi(e, t, n) {
  try {
    return Ai(e) ? e[Qs].Decode(n) : n;
  } catch (r) {
    throw new DKe(e, t, n, r);
  }
}
function _Ke(e, t, n, r) {
  return cc(r) ? Pi(e, n, r.map((i, o) => pd(e.items, t, `${n}/${o}`, i))) : Pi(e, n, r);
}
function LKe(e, t, n, r) {
  if (!If(r) || Uve(r))
    return Pi(e, n, r);
  const i = ybe(e), o = i.map((u) => u[0]), s = { ...r };
  for (const [u, f] of i)
    u in s && (s[u] = pd(f, t, `${n}/${u}`, s[u]));
  if (!Ai(e.unevaluatedProperties))
    return Pi(e, n, s);
  const l = Object.getOwnPropertyNames(s), c = e.unevaluatedProperties, a = { ...s };
  for (const u of l)
    o.includes(u) || (a[u] = Pi(c, `${n}/${u}`, a[u]));
  return Pi(e, n, a);
}
function zKe(e, t, n, r) {
  const i = globalThis.Object.values(e.$defs), o = e.$defs[e.$ref], s = e[Qs], l = { [Qs]: s, ...o };
  return pd(l, [...t, ...i], n, r);
}
function jKe(e, t, n, r) {
  return Pi(e, n, pd(e.not, t, n, r));
}
function FKe(e, t, n, r) {
  if (!If(r))
    return Pi(e, n, r);
  const i = gb(e), o = { ...r };
  for (const a of i)
    zve(o, a) && (Ag(o[a]) && (!mW(e.properties[a]) || $i.IsExactOptionalProperty(o, a)) || (o[a] = pd(e.properties[a], t, `${n}/${a}`, o[a])));
  if (!Ta(e.additionalProperties))
    return Pi(e, n, o);
  const s = Object.getOwnPropertyNames(o), l = e.additionalProperties, c = { ...o };
  for (const a of s)
    i.includes(a) || (c[a] = Pi(l, `${n}/${a}`, c[a]));
  return Pi(e, n, c);
}
function UKe(e, t, n, r) {
  if (!If(r))
    return Pi(e, n, r);
  const i = Object.getOwnPropertyNames(e.patternProperties)[0], o = new RegExp(i), s = { ...r };
  for (const u of Object.getOwnPropertyNames(r))
    o.test(u) && (s[u] = pd(e.patternProperties[i], t, `${n}/${u}`, s[u]));
  if (!Ta(e.additionalProperties))
    return Pi(e, n, s);
  const l = Object.getOwnPropertyNames(s), c = e.additionalProperties, a = { ...s };
  for (const u of l)
    o.test(u) || (a[u] = Pi(c, `${n}/${u}`, a[u]));
  return Pi(e, n, a);
}
function VKe(e, t, n, r) {
  const i = pu(e, t);
  return Pi(e, n, pd(i, t, n, r));
}
function qKe(e, t, n, r) {
  const i = pu(e, t);
  return Pi(e, n, pd(i, t, n, r));
}
function BKe(e, t, n, r) {
  return cc(r) && cc(e.items) ? Pi(e, n, e.items.map((i, o) => pd(i, t, `${n}/${o}`, r[o]))) : Pi(e, n, r);
}
function XKe(e, t, n, r) {
  for (const i of e.anyOf) {
    if (!BM(i, t, r))
      continue;
    const o = pd(i, t, n, r);
    return Pi(e, n, o);
  }
  return Pi(e, n, r);
}
function pd(e, t, n, r) {
  const i = W2(e, t), o = e;
  switch (e[Ut]) {
    case "Array":
      return _Ke(o, i, n, r);
    case "Import":
      return zKe(o, i, n, r);
    case "Intersect":
      return LKe(o, i, n, r);
    case "Not":
      return jKe(o, i, n, r);
    case "Object":
      return FKe(o, i, n, r);
    case "Record":
      return UKe(o, i, n, r);
    case "Ref":
      return VKe(o, i, n, r);
    case "Symbol":
      return Pi(o, n, r);
    case "This":
      return qKe(o, i, n, r);
    case "Tuple":
      return BKe(o, i, n, r);
    case "Union":
      return XKe(o, i, n, r);
    default:
      return Pi(o, n, r);
  }
}
function WKe(e, t, n) {
  return pd(e, t, "", n);
}
class ZKe extends Ns {
  constructor(t, n, r) {
    super("The encoded value does not match the expected schema"), this.schema = t, this.value = n, this.error = r;
  }
}
class HKe extends Ns {
  constructor(t, n, r, i) {
    super(`${i instanceof Error ? i.message : "Unknown error"}`), this.schema = t, this.path = n, this.value = r, this.error = i;
  }
}
function Ys(e, t, n) {
  try {
    return Ai(e) ? e[Qs].Encode(n) : n;
  } catch (r) {
    throw new HKe(e, t, n, r);
  }
}
function QKe(e, t, n, r) {
  const i = Ys(e, n, r);
  return cc(i) ? i.map((o, s) => Yu(e.items, t, `${n}/${s}`, o)) : i;
}
function $Ke(e, t, n, r) {
  const i = globalThis.Object.values(e.$defs), o = e.$defs[e.$ref], s = e[Qs], l = { [Qs]: s, ...o };
  return Yu(l, [...t, ...i], n, r);
}
function KKe(e, t, n, r) {
  const i = Ys(e, n, r);
  if (!If(r) || Uve(r))
    return i;
  const o = ybe(e), s = o.map((f) => f[0]), l = { ...i };
  for (const [f, d] of o)
    f in l && (l[f] = Yu(d, t, `${n}/${f}`, l[f]));
  if (!Ai(e.unevaluatedProperties))
    return l;
  const c = Object.getOwnPropertyNames(l), a = e.unevaluatedProperties, u = { ...l };
  for (const f of c)
    s.includes(f) || (u[f] = Ys(a, `${n}/${f}`, u[f]));
  return u;
}
function GKe(e, t, n, r) {
  return Ys(e.not, n, Ys(e, n, r));
}
function YKe(e, t, n, r) {
  const i = Ys(e, n, r);
  if (!If(i))
    return i;
  const o = gb(e), s = { ...i };
  for (const u of o)
    zve(s, u) && (Ag(s[u]) && (!mW(e.properties[u]) || $i.IsExactOptionalProperty(s, u)) || (s[u] = Yu(e.properties[u], t, `${n}/${u}`, s[u])));
  if (!Ta(e.additionalProperties))
    return s;
  const l = Object.getOwnPropertyNames(s), c = e.additionalProperties, a = { ...s };
  for (const u of l)
    o.includes(u) || (a[u] = Ys(c, `${n}/${u}`, a[u]));
  return a;
}
function JKe(e, t, n, r) {
  const i = Ys(e, n, r);
  if (!If(r))
    return i;
  const o = Object.getOwnPropertyNames(e.patternProperties)[0], s = new RegExp(o), l = { ...i };
  for (const f of Object.getOwnPropertyNames(r))
    s.test(f) && (l[f] = Yu(e.patternProperties[o], t, `${n}/${f}`, l[f]));
  if (!Ta(e.additionalProperties))
    return l;
  const c = Object.getOwnPropertyNames(l), a = e.additionalProperties, u = { ...l };
  for (const f of c)
    s.test(f) || (u[f] = Ys(a, `${n}/${f}`, u[f]));
  return u;
}
function eGe(e, t, n, r) {
  const i = pu(e, t), o = Yu(i, t, n, r);
  return Ys(e, n, o);
}
function tGe(e, t, n, r) {
  const i = pu(e, t), o = Yu(i, t, n, r);
  return Ys(e, n, o);
}
function nGe(e, t, n, r) {
  const i = Ys(e, n, r);
  return cc(e.items) ? e.items.map((o, s) => Yu(o, t, `${n}/${s}`, i[s])) : [];
}
function rGe(e, t, n, r) {
  for (const i of e.anyOf) {
    if (!BM(i, t, r))
      continue;
    const o = Yu(i, t, n, r);
    return Ys(e, n, o);
  }
  for (const i of e.anyOf) {
    const o = Yu(i, t, n, r);
    if (BM(e, t, o))
      return Ys(e, n, o);
  }
  return Ys(e, n, r);
}
function Yu(e, t, n, r) {
  const i = W2(e, t), o = e;
  switch (e[Ut]) {
    case "Array":
      return QKe(o, i, n, r);
    case "Import":
      return $Ke(o, i, n, r);
    case "Intersect":
      return KKe(o, i, n, r);
    case "Not":
      return GKe(o, i, n, r);
    case "Object":
      return YKe(o, i, n, r);
    case "Record":
      return JKe(o, i, n, r);
    case "Ref":
      return eGe(o, i, n, r);
    case "This":
      return tGe(o, i, n, r);
    case "Tuple":
      return nGe(o, i, n, r);
    case "Union":
      return rGe(o, i, n, r);
    default:
      return Ys(o, n, r);
  }
}
function iGe(e, t, n) {
  return Yu(e, t, "", n);
}
function oGe(e, t) {
  return Ai(e) || rs(e.items, t);
}
function sGe(e, t) {
  return Ai(e) || rs(e.items, t);
}
function aGe(e, t) {
  return Ai(e) || rs(e.returns, t) || e.parameters.some((n) => rs(n, t));
}
function lGe(e, t) {
  return Ai(e) || rs(e.returns, t) || e.parameters.some((n) => rs(n, t));
}
function cGe(e, t) {
  return Ai(e) || Ai(e.unevaluatedProperties) || e.allOf.some((n) => rs(n, t));
}
function uGe(e, t) {
  return Ai(e) || rs(e.items, t);
}
function dGe(e, t) {
  return Ai(e) || rs(e.not, t);
}
function fGe(e, t) {
  return Ai(e) || Object.values(e.properties).some((n) => rs(n, t)) || Ta(e.additionalProperties) && rs(e.additionalProperties, t);
}
function pGe(e, t) {
  return Ai(e) || rs(e.item, t);
}
function hGe(e, t) {
  const n = Object.getOwnPropertyNames(e.patternProperties)[0], r = e.patternProperties[n];
  return Ai(e) || rs(r, t) || Ta(e.additionalProperties) && Ai(e.additionalProperties);
}
function mGe(e, t) {
  return Ai(e) ? !0 : rs(pu(e, t), t);
}
function gGe(e, t) {
  return Ai(e) ? !0 : rs(pu(e, t), t);
}
function yGe(e, t) {
  return Ai(e) || !Ag(e.items) && e.items.some((n) => rs(n, t));
}
function vGe(e, t) {
  return Ai(e) || e.anyOf.some((n) => rs(n, t));
}
function rs(e, t) {
  const n = W2(e, t), r = e;
  if (e.$id && jq.has(e.$id))
    return !1;
  switch (e.$id && jq.add(e.$id), e[Ut]) {
    case "Array":
      return oGe(r, n);
    case "AsyncIterator":
      return sGe(r, n);
    case "Constructor":
      return aGe(r, n);
    case "Function":
      return lGe(r, n);
    case "Intersect":
      return cGe(r, n);
    case "Iterator":
      return uGe(r, n);
    case "Not":
      return dGe(r, n);
    case "Object":
      return fGe(r, n);
    case "Promise":
      return pGe(r, n);
    case "Record":
      return hGe(r, n);
    case "Ref":
      return mGe(r, n);
    case "This":
      return gGe(r, n);
    case "Tuple":
      return yGe(r, n);
    case "Union":
      return vGe(r, n);
    default:
      return Ai(e);
  }
}
const jq = /* @__PURE__ */ new Set();
function bGe(e, t) {
  return jq.clear(), rs(e, t);
}
class nOe {
  constructor(t, n, r, i) {
    this.schema = t, this.references = n, this.checkFunc = r, this.code = i, this.hasTransform = bGe(t, n);
  }
  /** Returns the generated assertion code used to validate this type. */
  Code() {
    return this.code;
  }
  /** Returns the schema type used to validate */
  Schema() {
    return this.schema;
  }
  /** Returns reference types used to validate */
  References() {
    return this.references;
  }
  /** Returns an iterator for each error in this value. */
  Errors(t) {
    return XM(this.schema, this.references, t);
  }
  /** Returns true if the value matches the compiled type. */
  Check(t) {
    return this.checkFunc(t);
  }
  /** Decodes a value or throws if error */
  Decode(t) {
    if (!this.checkFunc(t))
      throw new MKe(this.schema, t, this.Errors(t).First());
    return this.hasTransform ? WKe(this.schema, this.references, t) : t;
  }
  /** Encodes a value or throws if error */
  Encode(t) {
    const n = this.hasTransform ? iGe(this.schema, this.references, t) : t;
    if (!this.checkFunc(n))
      throw new ZKe(this.schema, t, this.Errors(t).First());
    return n;
  }
}
var Dp;
(function(e) {
  function t(o) {
    return o === 36;
  }
  e.DollarSign = t;
  function n(o) {
    return o === 95;
  }
  e.IsUnderscore = n;
  function r(o) {
    return o >= 65 && o <= 90 || o >= 97 && o <= 122;
  }
  e.IsAlpha = r;
  function i(o) {
    return o >= 48 && o <= 57;
  }
  e.IsNumeric = i;
})(Dp || (Dp = {}));
var WM;
(function(e) {
  function t(o) {
    return o.length === 0 ? !1 : Dp.IsNumeric(o.charCodeAt(0));
  }
  function n(o) {
    if (t(o))
      return !1;
    for (let s = 0; s < o.length; s++) {
      const l = o.charCodeAt(s);
      if (!(Dp.IsAlpha(l) || Dp.IsNumeric(l) || Dp.DollarSign(l) || Dp.IsUnderscore(l)))
        return !1;
    }
    return !0;
  }
  function r(o) {
    return o.replace(/'/g, "\\'");
  }
  function i(o, s) {
    return n(s) ? `${o}.${s}` : `${o}['${r(s)}']`;
  }
  e.Encode = i;
})(WM || (WM = {}));
var Fq;
(function(e) {
  function t(n) {
    const r = [];
    for (let i = 0; i < n.length; i++) {
      const o = n.charCodeAt(i);
      Dp.IsNumeric(o) || Dp.IsAlpha(o) ? r.push(n.charAt(i)) : r.push(`_${o}_`);
    }
    return r.join("").replace(/__/g, "_");
  }
  e.Encode = t;
})(Fq || (Fq = {}));
var Uq;
(function(e) {
  function t(n) {
    return n.replace(/'/g, "\\'");
  }
  e.Escape = t;
})(Uq || (Uq = {}));
class OGe extends Ns {
  constructor(t) {
    super("Unknown type"), this.schema = t;
  }
}
class pne extends Ns {
  constructor(t) {
    super("Preflight validation check failed to guard for the given schema"), this.schema = t;
  }
}
var my;
(function(e) {
  function t(s, l, c) {
    return $i.ExactOptionalPropertyTypes ? `('${l}' in ${s} ? ${c} : true)` : `(${WM.Encode(s, l)} !== undefined ? ${c} : true)`;
  }
  e.IsExactOptionalProperty = t;
  function n(s) {
    return $i.AllowArrayObject ? `(typeof ${s} === 'object' && ${s} !== null)` : `(typeof ${s} === 'object' && ${s} !== null && !Array.isArray(${s}))`;
  }
  e.IsObjectLike = n;
  function r(s) {
    return $i.AllowArrayObject ? `(typeof ${s} === 'object' && ${s} !== null && !(${s} instanceof Date) && !(${s} instanceof Uint8Array))` : `(typeof ${s} === 'object' && ${s} !== null && !Array.isArray(${s}) && !(${s} instanceof Date) && !(${s} instanceof Uint8Array))`;
  }
  e.IsRecordLike = r;
  function i(s) {
    return $i.AllowNaN ? `typeof ${s} === 'number'` : `Number.isFinite(${s})`;
  }
  e.IsNumberLike = i;
  function o(s) {
    return $i.AllowNullVoid ? `(${s} === undefined || ${s} === null)` : `${s} === undefined`;
  }
  e.IsVoidLike = o;
})(my || (my = {}));
var ST;
(function(e) {
  function t($) {
    return $[Ut] === "Any" || $[Ut] === "Unknown";
  }
  function* n($, pe, ee) {
    yield "true";
  }
  function* r($, pe, ee) {
    yield `Array.isArray(${ee})`;
    const [Ce, Ee] = [Y("value", "any"), Y("acc", "number")];
    Xn($.maxItems) && (yield `${ee}.length <= ${$.maxItems}`), Xn($.minItems) && (yield `${ee}.length >= ${$.minItems}`);
    const Ve = X($.items, pe, "value");
    if (yield `${ee}.every((${Ce}) => ${Ve})`, ki($.contains) || Xn($.minContains) || Xn($.maxContains)) {
      const et = ki($.contains) ? $.contains : Uo(), ft = X(et, pe, "value"), me = Xn($.minContains) ? [`(count >= ${$.minContains})`] : [], Te = Xn($.maxContains) ? [`(count <= ${$.maxContains})`] : [], re = `const count = value.reduce((${Ee}, ${Ce}) => ${ft} ? acc + 1 : acc, 0)`, le = ["(count > 0)", ...me, ...Te].join(" && ");
      yield `((${Ce}) => { ${re}; return ${le}})(${ee})`;
    }
    $.uniqueItems === !0 && (yield `((${Ce}) => { const set = new Set(); for(const element of value) { const hashed = hash(element); if(set.has(hashed)) { return false } else { set.add(hashed) } } return true } )(${ee})`);
  }
  function* i($, pe, ee) {
    yield `(typeof value === 'object' && Symbol.asyncIterator in ${ee})`;
  }
  function* o($, pe, ee) {
    yield `(typeof ${ee} === 'bigint')`, Rp($.exclusiveMaximum) && (yield `${ee} < BigInt(${$.exclusiveMaximum})`), Rp($.exclusiveMinimum) && (yield `${ee} > BigInt(${$.exclusiveMinimum})`), Rp($.maximum) && (yield `${ee} <= BigInt(${$.maximum})`), Rp($.minimum) && (yield `${ee} >= BigInt(${$.minimum})`), Rp($.multipleOf) && (yield `(${ee} % BigInt(${$.multipleOf})) === 0`);
  }
  function* s($, pe, ee) {
    yield `(typeof ${ee} === 'boolean')`;
  }
  function* l($, pe, ee) {
    yield* M($.returns, pe, `${ee}.prototype`);
  }
  function* c($, pe, ee) {
    yield `(${ee} instanceof Date) && Number.isFinite(${ee}.getTime())`, Xn($.exclusiveMaximumTimestamp) && (yield `${ee}.getTime() < ${$.exclusiveMaximumTimestamp}`), Xn($.exclusiveMinimumTimestamp) && (yield `${ee}.getTime() > ${$.exclusiveMinimumTimestamp}`), Xn($.maximumTimestamp) && (yield `${ee}.getTime() <= ${$.maximumTimestamp}`), Xn($.minimumTimestamp) && (yield `${ee}.getTime() >= ${$.minimumTimestamp}`), Xn($.multipleOfTimestamp) && (yield `(${ee}.getTime() % ${$.multipleOfTimestamp}) === 0`);
  }
  function* a($, pe, ee) {
    yield `(typeof ${ee} === 'function')`;
  }
  function* u($, pe, ee) {
    const Ce = globalThis.Object.getOwnPropertyNames($.$defs).reduce((Ee, Ve) => [...Ee, $.$defs[Ve]], []);
    yield* M(mb($.$ref), [...pe, ...Ce], ee);
  }
  function* f($, pe, ee) {
    yield `Number.isInteger(${ee})`, Xn($.exclusiveMaximum) && (yield `${ee} < ${$.exclusiveMaximum}`), Xn($.exclusiveMinimum) && (yield `${ee} > ${$.exclusiveMinimum}`), Xn($.maximum) && (yield `${ee} <= ${$.maximum}`), Xn($.minimum) && (yield `${ee} >= ${$.minimum}`), Xn($.multipleOf) && (yield `(${ee} % ${$.multipleOf}) === 0`);
  }
  function* d($, pe, ee) {
    const Ce = $.allOf.map((Ee) => X(Ee, pe, ee)).join(" && ");
    if ($.unevaluatedProperties === !1) {
      const Ee = q(`${new RegExp(FA($))};`), Ve = `Object.getOwnPropertyNames(${ee}).every(key => ${Ee}.test(key))`;
      yield `(${Ce} && ${Ve})`;
    } else if (ki($.unevaluatedProperties)) {
      const Ee = q(`${new RegExp(FA($))};`), Ve = `Object.getOwnPropertyNames(${ee}).every(key => ${Ee}.test(key) || ${X($.unevaluatedProperties, pe, `${ee}[key]`)})`;
      yield `(${Ce} && ${Ve})`;
    } else
      yield `(${Ce})`;
  }
  function* p($, pe, ee) {
    yield `(typeof value === 'object' && Symbol.iterator in ${ee})`;
  }
  function* h($, pe, ee) {
    typeof $.const == "number" || typeof $.const == "boolean" ? yield `(${ee} === ${$.const})` : yield `(${ee} === '${Uq.Escape($.const)}')`;
  }
  function* m($, pe, ee) {
    yield "false";
  }
  function* v($, pe, ee) {
    yield `(!${X($.not, pe, ee)})`;
  }
  function* b($, pe, ee) {
    yield `(${ee} === null)`;
  }
  function* A($, pe, ee) {
    yield my.IsNumberLike(ee), Xn($.exclusiveMaximum) && (yield `${ee} < ${$.exclusiveMaximum}`), Xn($.exclusiveMinimum) && (yield `${ee} > ${$.exclusiveMinimum}`), Xn($.maximum) && (yield `${ee} <= ${$.maximum}`), Xn($.minimum) && (yield `${ee} >= ${$.minimum}`), Xn($.multipleOf) && (yield `(${ee} % ${$.multipleOf}) === 0`);
  }
  function* w($, pe, ee) {
    yield my.IsObjectLike(ee), Xn($.minProperties) && (yield `Object.getOwnPropertyNames(${ee}).length >= ${$.minProperties}`), Xn($.maxProperties) && (yield `Object.getOwnPropertyNames(${ee}).length <= ${$.maxProperties}`);
    const Ce = Object.getOwnPropertyNames($.properties);
    for (const Ee of Ce) {
      const Ve = WM.Encode(ee, Ee), et = $.properties[Ee];
      if ($.required && $.required.includes(Ee))
        yield* M(et, pe, Ve), (Vw(et) || t(et)) && (yield `('${Ee}' in ${ee})`);
      else {
        const ft = X(et, pe, Ve);
        yield my.IsExactOptionalProperty(ee, Ee, ft);
      }
    }
    if ($.additionalProperties === !1)
      if ($.required && $.required.length === Ce.length)
        yield `Object.getOwnPropertyNames(${ee}).length === ${Ce.length}`;
      else {
        const Ee = `[${Ce.map((Ve) => `'${Ve}'`).join(", ")}]`;
        yield `Object.getOwnPropertyNames(${ee}).every(key => ${Ee}.includes(key))`;
      }
    if (typeof $.additionalProperties == "object") {
      const Ee = X($.additionalProperties, pe, `${ee}[key]`), Ve = `[${Ce.map((et) => `'${et}'`).join(", ")}]`;
      yield `(Object.getOwnPropertyNames(${ee}).every(key => ${Ve}.includes(key) || ${Ee}))`;
    }
  }
  function* O($, pe, ee) {
    yield `(typeof value === 'object' && typeof ${ee}.then === 'function')`;
  }
  function* x($, pe, ee) {
    yield my.IsRecordLike(ee), Xn($.minProperties) && (yield `Object.getOwnPropertyNames(${ee}).length >= ${$.minProperties}`), Xn($.maxProperties) && (yield `Object.getOwnPropertyNames(${ee}).length <= ${$.maxProperties}`);
    const [Ce, Ee] = Object.entries($.patternProperties)[0], Ve = q(`${new RegExp(Ce)}`), et = X(Ee, pe, "value"), ft = ki($.additionalProperties) ? X($.additionalProperties, pe, ee) : $.additionalProperties === !1 ? "false" : "true", me = `(${Ve}.test(key) ? ${et} : ${ft})`;
    yield `(Object.entries(${ee}).every(([key, value]) => ${me}))`;
  }
  function* S($, pe, ee) {
    const Ce = pu($, pe);
    if (D.functions.has($.$ref))
      return yield `${B($.$ref)}(${ee})`;
    yield* M(Ce, pe, ee);
  }
  function* E($, pe, ee) {
    const Ce = q(`${new RegExp($.source, $.flags)};`);
    yield `(typeof ${ee} === 'string')`, Xn($.maxLength) && (yield `${ee}.length <= ${$.maxLength}`), Xn($.minLength) && (yield `${ee}.length >= ${$.minLength}`), yield `${Ce}.test(${ee})`;
  }
  function* k($, pe, ee) {
    yield `(typeof ${ee} === 'string')`, Xn($.maxLength) && (yield `${ee}.length <= ${$.maxLength}`), Xn($.minLength) && (yield `${ee}.length >= ${$.minLength}`), $.pattern !== void 0 && (yield `${q(`${new RegExp($.pattern)};`)}.test(${ee})`), $.format !== void 0 && (yield `format('${$.format}', ${ee})`);
  }
  function* T($, pe, ee) {
    yield `(typeof ${ee} === 'symbol')`;
  }
  function* R($, pe, ee) {
    yield `(typeof ${ee} === 'string')`, yield `${q(`${new RegExp($.pattern)};`)}.test(${ee})`;
  }
  function* j($, pe, ee) {
    yield `${B($.$ref)}(${ee})`;
  }
  function* F($, pe, ee) {
    if (yield `Array.isArray(${ee})`, $.items === void 0)
      return yield `${ee}.length === 0`;
    yield `(${ee}.length === ${$.maxItems})`;
    for (let Ce = 0; Ce < $.items.length; Ce++)
      yield `${X($.items[Ce], pe, `${ee}[${Ce}]`)}`;
  }
  function* L($, pe, ee) {
    yield `${ee} === undefined`;
  }
  function* _($, pe, ee) {
    yield `(${$.anyOf.map((Ee) => X(Ee, pe, ee)).join(" || ")})`;
  }
  function* U($, pe, ee) {
    yield `${ee} instanceof Uint8Array`, Xn($.maxByteLength) && (yield `(${ee}.length <= ${$.maxByteLength})`), Xn($.minByteLength) && (yield `(${ee}.length >= ${$.minByteLength})`);
  }
  function* z($, pe, ee) {
    yield "true";
  }
  function* C($, pe, ee) {
    yield my.IsVoidLike(ee);
  }
  function* I($, pe, ee) {
    const Ce = D.instances.size;
    D.instances.set(Ce, $), yield `kind('${$[Ut]}', ${Ce}, ${ee})`;
  }
  function* M($, pe, ee, Ce = !0) {
    const Ee = nc($.$id) ? [...pe, $] : pe, Ve = $;
    if (Ce && nc($.$id)) {
      const et = B($.$id);
      if (D.functions.has(et))
        return yield `${et}(${ee})`;
      {
        D.functions.set(et, "<deferred>");
        const ft = H(et, $, pe, "value", !1);
        return D.functions.set(et, ft), yield `${et}(${ee})`;
      }
    }
    switch (Ve[Ut]) {
      case "Any":
        return yield* n();
      case "Array":
        return yield* r(Ve, Ee, ee);
      case "AsyncIterator":
        return yield* i(Ve, Ee, ee);
      case "BigInt":
        return yield* o(Ve, Ee, ee);
      case "Boolean":
        return yield* s(Ve, Ee, ee);
      case "Constructor":
        return yield* l(Ve, Ee, ee);
      case "Date":
        return yield* c(Ve, Ee, ee);
      case "Function":
        return yield* a(Ve, Ee, ee);
      case "Import":
        return yield* u(Ve, Ee, ee);
      case "Integer":
        return yield* f(Ve, Ee, ee);
      case "Intersect":
        return yield* d(Ve, Ee, ee);
      case "Iterator":
        return yield* p(Ve, Ee, ee);
      case "Literal":
        return yield* h(Ve, Ee, ee);
      case "Never":
        return yield* m();
      case "Not":
        return yield* v(Ve, Ee, ee);
      case "Null":
        return yield* b(Ve, Ee, ee);
      case "Number":
        return yield* A(Ve, Ee, ee);
      case "Object":
        return yield* w(Ve, Ee, ee);
      case "Promise":
        return yield* O(Ve, Ee, ee);
      case "Record":
        return yield* x(Ve, Ee, ee);
      case "Ref":
        return yield* S(Ve, Ee, ee);
      case "RegExp":
        return yield* E(Ve, Ee, ee);
      case "String":
        return yield* k(Ve, Ee, ee);
      case "Symbol":
        return yield* T(Ve, Ee, ee);
      case "TemplateLiteral":
        return yield* R(Ve, Ee, ee);
      case "This":
        return yield* j(Ve, Ee, ee);
      case "Tuple":
        return yield* F(Ve, Ee, ee);
      case "Undefined":
        return yield* L(Ve, Ee, ee);
      case "Union":
        return yield* _(Ve, Ee, ee);
      case "Uint8Array":
        return yield* U(Ve, Ee, ee);
      case "Unknown":
        return yield* z();
      case "Void":
        return yield* C(Ve, Ee, ee);
      default:
        if (!hT(Ve[Ut]))
          throw new OGe($);
        return yield* I(Ve, Ee, ee);
    }
  }
  const D = {
    language: "javascript",
    // target language
    functions: /* @__PURE__ */ new Map(),
    // local functions
    variables: /* @__PURE__ */ new Map(),
    // local variables
    instances: /* @__PURE__ */ new Map()
    // exterior kind instances
  };
  function X($, pe, ee, Ce = !0) {
    return `(${[...M($, pe, ee, Ce)].join(" && ")})`;
  }
  function B($) {
    return `check_${Fq.Encode($)}`;
  }
  function q($) {
    const pe = `local_${D.variables.size}`;
    return D.variables.set(pe, `const ${pe} = ${$}`), pe;
  }
  function H($, pe, ee, Ce, Ee = !0) {
    const [Ve, et] = [`
`, (re) => "".padStart(re, " ")], ft = Y("value", "any"), me = J("boolean"), Te = [...M(pe, ee, Ce, Ee)].map((re) => `${et(4)}${re}`).join(` &&${Ve}`);
    return `function ${$}(${ft})${me} {${Ve}${et(2)}return (${Ve}${Te}${Ve}${et(2)})
}`;
  }
  function Y($, pe) {
    const ee = D.language === "typescript" ? `: ${pe}` : "";
    return `${$}${ee}`;
  }
  function J($) {
    return D.language === "typescript" ? `: ${$}` : "";
  }
  function oe($, pe, ee) {
    const Ce = H("check", $, pe, "value"), Ee = Y("value", "any"), Ve = J("boolean"), et = [...D.functions.values()], ft = [...D.variables.values()], me = nc($.$id) ? `return function check(${Ee})${Ve} {
  return ${B($.$id)}(value)
}` : `return ${Ce}`;
    return [...ft, ...et, me].join(`
`);
  }
  function ce(...$) {
    const pe = { language: "javascript" }, [ee, Ce, Ee] = $.length === 2 && cc($[1]) ? [$[0], $[1], pe] : $.length === 2 && !cc($[1]) ? [$[0], [], $[1]] : $.length === 3 ? [$[0], $[1], $[2]] : $.length === 1 ? [$[0], [], pe] : [null, [], pe];
    if (D.language = Ee.language, D.variables.clear(), D.functions.clear(), D.instances.clear(), !ki(ee))
      throw new pne(ee);
    for (const Ve of Ce)
      if (!ki(Ve))
        throw new pne(Ve);
    return oe(ee, Ce);
  }
  e.Code = ce;
  function fe($, pe = []) {
    const ee = ce($, pe, { language: "javascript" }), Ce = globalThis.Function("kind", "format", "hash", ee), Ee = new Map(D.instances);
    function Ve(Te, re, le) {
      if (!hT(Te) || !Ee.has(re))
        return !1;
      const Oe = SW(Te), be = Ee.get(re);
      return Oe(be, le);
    }
    function et(Te, re) {
      return wW(Te) ? xW(Te)(re) : !1;
    }
    function ft(Te) {
      return FZ(Te);
    }
    const me = Ce(Ve, et, ft);
    return new nOe($, pe, me, ee);
  }
  e.Compile = fe;
})(ST || (ST = {}));
const AGe = ST.Compile(dZ);
function ET(e, {
  nextAction: t
}) {
  const n = {
    displayName: e.displayName,
    name: e.name,
    valid: !1,
    skip: e.skip,
    settings: {
      ...e.settings,
      customLogoUrl: e.settings.customLogoUrl
    },
    nextAction: t
  };
  let r;
  switch (e.type) {
    case qe.ROUTER:
      r = {
        ...n,
        type: qe.ROUTER,
        settings: e.settings,
        children: e.settings.branches.map(() => null)
      };
      break;
    case qe.LOOP_ON_ITEMS:
      r = {
        ...n,
        type: qe.LOOP_ON_ITEMS,
        settings: e.settings
      };
      break;
    case qe.PIECE:
      r = {
        ...n,
        type: qe.PIECE,
        settings: e.settings
      };
      break;
    case qe.CODE:
      r = {
        ...n,
        type: qe.CODE,
        settings: e.settings
      };
      break;
  }
  const i = (De(e.valid) ? !0 : e.valid) && AGe.Check(r);
  return {
    ...r,
    valid: i
  };
}
function wGe(e, t) {
  if (t.stepLocationRelativeToParent === Hn.INSIDE_LOOP)
    e.firstLoopAction = ET(t.action, {
      nextAction: e.firstLoopAction
    });
  else if (t.stepLocationRelativeToParent === Hn.AFTER)
    e.nextAction = ET(t.action, {
      nextAction: e.nextAction
    });
  else
    throw new vb(
      {
        code: Ni.FLOW_OPERATION_INVALID,
        params: {
          message: `Loop step parent ${t.stepLocationRelativeToParent} not found`
        }
      }
    );
  return e;
}
function xGe(e, t) {
  if (t.stepLocationRelativeToParent === Hn.INSIDE_BRANCH && !De(t.branchIndex))
    e.children[t.branchIndex] = ET(t.action, {
      nextAction: e.children[t.branchIndex] ?? void 0
    });
  else if (t.stepLocationRelativeToParent === Hn.AFTER)
    e.nextAction = ET(t.action, {
      nextAction: e.nextAction
    });
  else
    throw new vb({
      code: Ni.FLOW_OPERATION_INVALID,
      params: {
        message: `Router step parent ${t.stepLocationRelativeToParent} not found`
      }
    });
  return e;
}
function SGe(e, t) {
  return At.transferFlow(e, (n) => {
    if (n.name !== t.parentStep)
      return n;
    switch (n.type) {
      case qe.LOOP_ON_ITEMS:
        return wGe(n, t);
      case qe.ROUTER:
        return xGe(n, t);
      default:
        return n.nextAction = ET(t.action, {
          nextAction: n.nextAction
        }), n;
    }
  });
}
function EGe(e, t) {
  return At.transferFlow(e, (n) => {
    if (n.name !== t.stepName || n.type !== qe.ROUTER)
      return n;
    const r = n;
    return {
      ...r,
      settings: {
        ...r.settings,
        branches: Iq(r.settings.branches, t.branchIndex, At.createBranch(t.branchName, t.conditions))
      },
      children: Iq(r.children, t.branchIndex, null)
    };
  });
}
function TGe(e, t) {
  const n = At.getAllSteps(t.trigger), r = e.map((i) => At.getStepOrThrow(i, t.trigger)).filter((i) => At.isAction(i.type));
  return r.filter((i) => !r.filter((o) => o.name !== i.name).some((o) => At.isChildOf(o, i.name))).map((i) => {
    const o = JSON.parse(JSON.stringify(i));
    return o.nextAction = void 0, o;
  }).sort((i, o) => n.indexOf(i) - n.indexOf(o));
}
function kGe(e, t) {
  let n = e;
  for (const r of t.names)
    n = At.transferFlow(n, (i) => {
      if (i.nextAction && i.nextAction.name === r) {
        const o = i.nextAction;
        i.nextAction = o.nextAction;
      }
      switch (i.type) {
        case qe.LOOP_ON_ITEMS: {
          if (i.firstLoopAction && i.firstLoopAction.name === r) {
            const o = i.firstLoopAction;
            i.firstLoopAction = o.nextAction;
          }
          break;
        }
        case qe.ROUTER: {
          i.children = i.children.map((o) => o && o.name === r ? o.nextAction ?? null : o);
          break;
        }
      }
      return i;
    });
  return n;
}
function CGe(e, t) {
  return At.transferFlow(e, (n) => {
    if (n.name !== t.stepName || n.type !== qe.ROUTER)
      return n;
    const r = n;
    return {
      ...r,
      settings: {
        ...r.settings,
        branches: r.settings.branches.filter((i, o) => o !== t.branchIndex)
      },
      children: r.children.filter((i, o) => o !== t.branchIndex)
    };
  });
}
function NGe(e, t) {
  const n = At.getAllSteps(e.trigger).map((i) => i.name);
  return t.flatMap((i) => At.getAllSteps(i).map((o) => o.name)).reduce((i, o) => {
    const s = At.findUnusedName(n);
    return n.push(s), { ...i, [o]: s };
  }, {});
}
function PGe({
  input: e,
  oldStepName: t,
  newStepName: n
}) {
  const r = /{{(.*?)}}/g;
  return e.replace(r, (i, o) => `{{${o.replaceAll(
    new RegExp(`\\b${t}\\b`, "g"),
    `${n}`
  )}}}`);
}
function IGe(e, t) {
  return e.displayName = `${e.displayName} Copy`, e.name = t[e.name], "input" in e.settings && Object.keys(t).forEach((n) => {
    const r = e.settings;
    r.input = bT(
      r.input,
      (i) => xC(i) ? PGe({
        input: i,
        oldStepName: n,
        newStepName: t[n]
      }) : i
    );
  }), e.settings.sampleData && (e.settings = {
    ...e.settings,
    sampleData: {
      ...e.settings.sampleData,
      sampleDataFileId: void 0,
      sampleDataInputFileId: void 0,
      lastTestDate: void 0
    }
  }), e;
}
const XA = {
  mapToNewNames: NGe,
  clone: IGe
};
function RGe(e) {
  return {
    type: Tt.DELETE_ACTION,
    request: { names: [e] }
  };
}
function MGe(e) {
  return {
    type: Tt.UPDATE_TRIGGER,
    request: e
  };
}
function DGe(e) {
  return {
    type: Tt.CHANGE_NAME,
    request: { displayName: e }
  };
}
function Sv(e) {
  const t = [];
  for (; e; ) {
    switch (e.nextAction && t.push({
      type: Tt.ADD_ACTION,
      request: {
        parentStep: (e == null ? void 0 : e.name) ?? "",
        stepLocationRelativeToParent: Hn.AFTER,
        action: RR(e.nextAction)
      }
    }), e.type) {
      case qe.LOOP_ON_ITEMS: {
        e.firstLoopAction && (t.push({
          type: Tt.ADD_ACTION,
          request: {
            parentStep: e.name,
            stepLocationRelativeToParent: Hn.INSIDE_LOOP,
            action: RR(e.firstLoopAction)
          }
        }), t.push(...Sv(e.firstLoopAction)));
        break;
      }
      case qe.ROUTER: {
        if (e.children)
          for (const [n, r] of e.children.entries())
            De(r) || (t.push({
              type: Tt.ADD_ACTION,
              request: {
                parentStep: e.name,
                stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
                branchIndex: n,
                action: RR(r)
              }
            }), t.push(...Sv(r)));
        break;
      }
      case qe.CODE:
      case qe.PIECE:
      case Bt.PIECE:
      case Bt.EMPTY:
        break;
    }
    e = e.nextAction;
  }
  return t;
}
function _Ge(e, t) {
  const n = e.notes.map((o) => ({
    id: o.id
  })), r = (t.notes || []).map((o) => o);
  return [
    ...n.map((o) => ({
      type: Tt.DELETE_NOTE,
      request: o
    })),
    ...r.map((o) => ({
      type: Tt.ADD_NOTE,
      request: o
    }))
  ];
}
function RR(e) {
  const t = JSON.parse(JSON.stringify(e));
  switch (t.type) {
    case qe.ROUTER: {
      t.children = t.children.map((n) => De(n) ? null : RR(n));
      break;
    }
    case qe.LOOP_ON_ITEMS: {
      delete t.firstLoopAction;
      break;
    }
    case qe.PIECE:
    case qe.CODE:
      break;
  }
  return delete t.nextAction, t;
}
function LGe(e, t) {
  const r = At.getAllNextActionsWithoutChildren(e.trigger).map(
    (o) => RGe(o.name)
  ), i = Sv(t.trigger);
  return [
    DGe(t.displayName),
    ...r,
    MGe(t.trigger),
    ...i,
    ..._Ge(e, t)
  ];
}
function zGe(e, t) {
  const r = {
    ...JSON.parse(JSON.stringify(At.getActionOrThrow(e, t.trigger))),
    nextAction: void 0
  }, i = XA.mapToNewNames(t, [r]), o = At.transferStep(r, (l) => XA.clone(l, i)), s = Sv(o);
  return [
    {
      type: Tt.ADD_ACTION,
      request: {
        action: o,
        parentStep: e,
        stepLocationRelativeToParent: Hn.AFTER
      }
    },
    ...s
  ];
}
function jGe(e, t, n) {
  const r = At.getActionOrThrow(e, n.trigger), i = JSON.parse(JSON.stringify(r)), o = [{
    type: Tt.ADD_BRANCH,
    request: {
      branchName: `${i.settings.branches[t].branchName} Copy`,
      branchIndex: t + 1,
      stepName: e,
      conditions: i.settings.branches[t].branchType === iu.CONDITION ? i.settings.branches[t].conditions : void 0
    }
  }], s = i.children[t];
  if (!De(s)) {
    const l = XA.mapToNewNames(n, [s]), c = At.transferStep(s, (u) => XA.clone(u, l)), a = Sv(c);
    o.push({
      type: Tt.ADD_ACTION,
      request: {
        stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
        action: c,
        parentStep: e,
        branchIndex: t + 1
      }
    }), o.push(...a);
  }
  return o;
}
function FGe(e, t) {
  const n = At.getActionOrThrow(t.name, e.trigger);
  At.getStepOrThrow(t.newParentStep, e.trigger);
  const r = {
    ...n,
    nextAction: void 0
  }, i = [
    {
      type: Tt.DELETE_ACTION,
      request: {
        names: [t.name]
      }
    }
  ], o = [
    {
      type: Tt.ADD_ACTION,
      request: {
        action: r,
        parentStep: t.newParentStep,
        stepLocationRelativeToParent: t.stepLocationRelativeToNewParent,
        branchIndex: t.branchIndex
      }
    },
    ...Sv(r)
  ];
  return [
    ...i,
    ...o
  ];
}
const hne = (e, t) => e >= 0 && e < t;
function UGe(e, t) {
  return At.transferFlow(e, (n) => {
    if (n.name !== t.stepName || n.type !== qe.ROUTER)
      return n;
    const r = n;
    if (!hne(t.sourceBranchIndex, r.settings.branches.length) || !hne(t.targetBranchIndex, r.settings.branches.length) || t.sourceBranchIndex === t.targetBranchIndex || r.settings.branches[t.sourceBranchIndex].branchType === iu.FALLBACK || r.settings.branches[t.targetBranchIndex].branchType === iu.FALLBACK)
      return n;
    const i = r.settings.branches[t.sourceBranchIndex];
    r.settings.branches.splice(t.sourceBranchIndex, 1), r.settings.branches.splice(t.targetBranchIndex, 0, i);
    const o = r.children[t.sourceBranchIndex];
    return r.children.splice(t.sourceBranchIndex, 1), r.children.splice(t.targetBranchIndex, 0, o), r;
  });
}
const VGe = (e, t) => {
  const n = JSON.parse(JSON.stringify(e));
  return n.notes || (n.notes = []), n.notes = n.notes.map((r) => r.id === t.id ? { ...r, ...t, updatedAt: (/* @__PURE__ */ new Date()).toISOString() } : r), n;
}, qGe = (e, t) => {
  const n = JSON.parse(JSON.stringify(e));
  return n.notes || (n.notes = []), n.notes = n.notes.filter((r) => r.id !== t.id), n;
}, BGe = (e, t) => {
  const n = JSON.parse(JSON.stringify(e));
  return n.notes || (n.notes = []), n.notes.push({ ...t, createdAt: (/* @__PURE__ */ new Date()).toISOString(), updatedAt: (/* @__PURE__ */ new Date()).toISOString() }), n;
}, YF = {
  updateNote: VGe,
  deleteNote: qGe,
  addNote: BGe
}, rOe = (e, t, n) => {
  const r = XA.mapToNewNames(t, e), i = e.map((s) => At.transferStep(s, (l) => XA.clone(l, r))), o = [];
  for (let s = 0; s < i.length; s++) {
    s === 0 ? o.push({
      type: Tt.ADD_ACTION,
      request: {
        action: i[s],
        parentStep: n.parentStepName,
        stepLocationRelativeToParent: n.stepLocationRelativeToParent,
        branchIndex: n.stepLocationRelativeToParent === Hn.INSIDE_BRANCH ? n.branchIndex : void 0
      }
    }) : o.push({
      type: Tt.ADD_ACTION,
      request: {
        action: i[s],
        parentStep: i[s - 1].name,
        stepLocationRelativeToParent: Hn.AFTER
      }
    });
    const l = Sv(i[s]);
    o.push(...l);
  }
  return o;
};
function XGe(e, t) {
  return At.transferFlow(e, (n) => t.names.includes(n.name) ? {
    ...n,
    skip: t.skip
  } : n);
}
const WGe = ST.Compile(dZ);
function ZGe(e, t) {
  return At.transferFlow(e, (n) => {
    if (n.name !== t.name)
      return n;
    const r = {
      displayName: t.displayName,
      name: t.name,
      valid: !1,
      skip: t.skip,
      settings: {
        ...n.settings,
        customLogoUrl: t.settings.customLogoUrl
      }
    };
    let i;
    switch (t.type) {
      case qe.CODE: {
        i = {
          ...r,
          settings: t.settings,
          type: qe.CODE,
          nextAction: n.nextAction
        };
        break;
      }
      case qe.PIECE: {
        i = {
          ...r,
          settings: t.settings,
          type: qe.PIECE,
          nextAction: n.nextAction
        };
        break;
      }
      case qe.LOOP_ON_ITEMS: {
        i = {
          ...r,
          settings: t.settings,
          type: qe.LOOP_ON_ITEMS,
          firstLoopAction: "firstLoopAction" in n ? n.firstLoopAction : void 0,
          nextAction: n.nextAction
        };
        break;
      }
      case qe.ROUTER: {
        i = {
          ...r,
          settings: t.settings,
          type: qe.ROUTER,
          nextAction: n.nextAction,
          children: "children" in n ? n.children : [null, null]
        };
        break;
      }
    }
    const o = (De(t.valid) ? !0 : t.valid) && WGe.Check(i);
    return {
      ...i,
      valid: o
    };
  });
}
const HGe = ST.Compile(V2);
function QGe(e, t, n) {
  const r = {
    displayName: t.displayName,
    name: e,
    valid: !1,
    nextAction: n
  };
  let i;
  switch (t.type) {
    case Bt.EMPTY:
      i = {
        ...r,
        type: Bt.EMPTY,
        settings: t.settings
      };
      break;
    case Bt.PIECE:
      i = {
        ...r,
        type: Bt.PIECE,
        settings: t.settings
      };
      break;
  }
  const o = (De(t.valid) ? !0 : t.valid) && HGe.Check(i);
  return {
    ...i,
    valid: o
  };
}
function $Ge(e, t) {
  const n = At.getStepOrThrow(t.name, e.trigger), r = QGe(t.name, t, n.nextAction);
  return At.transferFlow(e, (i) => i.name === t.name ? r : i);
}
var Tt = /* @__PURE__ */ ((e) => (e.LOCK_AND_PUBLISH = "LOCK_AND_PUBLISH", e.CHANGE_STATUS = "CHANGE_STATUS", e.LOCK_FLOW = "LOCK_FLOW", e.CHANGE_FOLDER = "CHANGE_FOLDER", e.CHANGE_NAME = "CHANGE_NAME", e.MOVE_ACTION = "MOVE_ACTION", e.IMPORT_FLOW = "IMPORT_FLOW", e.UPDATE_TRIGGER = "UPDATE_TRIGGER", e.ADD_ACTION = "ADD_ACTION", e.UPDATE_ACTION = "UPDATE_ACTION", e.DELETE_ACTION = "DELETE_ACTION", e.DUPLICATE_ACTION = "DUPLICATE_ACTION", e.USE_AS_DRAFT = "USE_AS_DRAFT", e.DELETE_BRANCH = "DELETE_BRANCH", e.ADD_BRANCH = "ADD_BRANCH", e.DUPLICATE_BRANCH = "DUPLICATE_BRANCH", e.SET_SKIP_ACTION = "SET_SKIP_ACTION", e.UPDATE_METADATA = "UPDATE_METADATA", e.MOVE_BRANCH = "MOVE_BRANCH", e.SAVE_SAMPLE_DATA = "SAVE_SAMPLE_DATA", e.UPDATE_MINUTES_SAVED = "UPDATE_MINUTES_SAVED", e.UPDATE_OWNER = "UPDATE_OWNER", e.UPDATE_NOTE = "UPDATE_NOTE", e.DELETE_NOTE = "DELETE_NOTE", e.ADD_NOTE = "ADD_NOTE", e))(Tt || {});
const iOe = g.Object({
  branchIndex: g.Number(),
  stepName: g.String()
}), oOe = g.Omit(Hw, ["createdAt", "updatedAt"]), sOe = g.Object({
  id: g.String()
}), aOe = g.Omit(Hw, ["createdAt", "updatedAt", "ownerId"]), lOe = g.Object({
  branchIndex: g.Number(),
  stepName: g.String(),
  conditions: g.Optional(g.Array(g.Array(p0e))),
  branchName: g.String()
}), cOe = g.Object({
  sourceBranchIndex: g.Number(),
  targetBranchIndex: g.Number(),
  stepName: g.String()
}), uOe = g.Object({
  names: g.Array(g.String()),
  skip: g.Boolean()
}), dOe = g.Object({
  branchIndex: g.Number(),
  stepName: g.String()
});
var Hn = /* @__PURE__ */ ((e) => (e.AFTER = "AFTER", e.INSIDE_LOOP = "INSIDE_LOOP", e.INSIDE_BRANCH = "INSIDE_BRANCH", e))(Hn || {});
const fOe = g.Object({
  versionId: g.String()
}), pOe = g.Object({}), hOe = g.Object({
  displayName: g.String({}),
  trigger: V2,
  schemaVersion: It(g.String()),
  notes: It(g.Array(Hw))
}), mOe = g.Object({
  folderId: It(g.String({}))
}), gOe = g.Object({
  displayName: g.String({})
}), yOe = g.Object({
  names: g.Array(g.String())
}), UZ = g.Union([
  CC,
  PC,
  NC,
  L2
]), vOe = g.Object({
  stepName: g.String()
}), bOe = g.Object({
  name: g.String(),
  newParentStep: g.String(),
  stepLocationRelativeToNewParent: g.Optional(
    g.Enum(Hn)
  ),
  branchIndex: g.Optional(g.Number())
}), OOe = g.Object({
  parentStep: g.String(),
  stepLocationRelativeToParent: g.Optional(
    g.Enum(Hn)
  ),
  branchIndex: g.Optional(g.Number()),
  action: UZ
}), AOe = g.Union([xZ, U2]), wOe = g.Object({
  status: g.Enum(il)
}), xOe = g.Object({
  status: g.Optional(g.Enum(il))
}), SOe = g.Object({
  metadata: It(Tl)
}), EOe = g.Object({
  timeSavedPerRun: It(g.Number())
}), TOe = g.Object({
  ownerId: g.String()
}), KGe = g.Union([
  g.Object(
    {
      type: g.Literal(
        "MOVE_ACTION"
        /* MOVE_ACTION */
      ),
      request: bOe
    },
    {
      title: "Move Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "CHANGE_STATUS"
        /* CHANGE_STATUS */
      ),
      request: wOe
    },
    {
      title: "Change Status"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "LOCK_AND_PUBLISH"
        /* LOCK_AND_PUBLISH */
      ),
      request: xOe
    },
    {
      title: "Lock and Publish"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "USE_AS_DRAFT"
        /* USE_AS_DRAFT */
      ),
      request: fOe
    },
    {
      title: "Copy as Draft"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "LOCK_FLOW"
        /* LOCK_FLOW */
      ),
      request: pOe
    },
    {
      title: "Lock Flow"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "IMPORT_FLOW"
        /* IMPORT_FLOW */
      ),
      request: hOe
    },
    {
      title: "Import Flow"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "CHANGE_NAME"
        /* CHANGE_NAME */
      ),
      request: gOe
    },
    {
      title: "Change Name"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "DELETE_ACTION"
        /* DELETE_ACTION */
      ),
      request: yOe
    },
    {
      title: "Delete Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_ACTION"
        /* UPDATE_ACTION */
      ),
      request: UZ
    },
    {
      title: "Update Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "ADD_ACTION"
        /* ADD_ACTION */
      ),
      request: OOe
    },
    {
      title: "Add Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_TRIGGER"
        /* UPDATE_TRIGGER */
      ),
      request: AOe
    },
    {
      title: "Update Trigger"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "CHANGE_FOLDER"
        /* CHANGE_FOLDER */
      ),
      request: mOe
    },
    {
      title: "Change Folder"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "DUPLICATE_ACTION"
        /* DUPLICATE_ACTION */
      ),
      request: vOe
    },
    {
      title: "Duplicate Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "DELETE_BRANCH"
        /* DELETE_BRANCH */
      ),
      request: iOe
    },
    {
      title: "Delete Branch"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "ADD_BRANCH"
        /* ADD_BRANCH */
      ),
      request: lOe
    },
    {
      title: "Add Branch"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "DUPLICATE_BRANCH"
        /* DUPLICATE_BRANCH */
      ),
      request: dOe
    },
    {
      title: "Duplicate Branch"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "SET_SKIP_ACTION"
        /* SET_SKIP_ACTION */
      ),
      request: uOe
    },
    {
      title: "Skip Action"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_METADATA"
        /* UPDATE_METADATA */
      ),
      request: SOe
    },
    {
      title: "Update Metadata"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "MOVE_BRANCH"
        /* MOVE_BRANCH */
      ),
      request: cOe
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "SAVE_SAMPLE_DATA"
        /* SAVE_SAMPLE_DATA */
      ),
      request: r0e
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_MINUTES_SAVED"
        /* UPDATE_MINUTES_SAVED */
      ),
      request: EOe
    },
    {
      title: "Update Minutes Saved"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_OWNER"
        /* UPDATE_OWNER */
      ),
      request: TOe
    },
    {
      title: "Update Owner"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "UPDATE_NOTE"
        /* UPDATE_NOTE */
      ),
      request: oOe
    },
    {
      title: "Update Note"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "DELETE_NOTE"
        /* DELETE_NOTE */
      ),
      request: sOe
    },
    {
      title: "Delete Note"
    }
  ),
  g.Object(
    {
      type: g.Literal(
        "ADD_NOTE"
        /* ADD_NOTE */
      ),
      request: aOe
    },
    {
      title: "Add Note"
    }
  )
]), Uu = {
  getActionsForCopy: TGe,
  getOperationsForPaste: rOe,
  apply(e, t) {
    let n = JSON.parse(JSON.stringify(e));
    switch (t.type) {
      case "MOVE_ACTION": {
        FGe(n, t.request).forEach((i) => {
          n = Uu.apply(n, i);
        }), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "CHANGE_NAME":
        n.displayName = t.request.displayName;
        break;
      case "DUPLICATE_BRANCH": {
        jGe(t.request.stepName, t.request.branchIndex, n).forEach((i) => {
          n = Uu.apply(n, i);
        });
        break;
      }
      case "DUPLICATE_ACTION": {
        zGe(t.request.stepName, n).forEach((i) => {
          n = Uu.apply(n, i);
        });
        break;
      }
      case "LOCK_FLOW":
        n.state = Lo.LOCKED;
        break;
      case "ADD_ACTION": {
        n = SGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "DELETE_ACTION": {
        n = kGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "UPDATE_TRIGGER": {
        n = $Ge(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "ADD_BRANCH": {
        n = EGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "DELETE_BRANCH": {
        n = CGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "UPDATE_ACTION": {
        n = ZGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "IMPORT_FLOW": {
        LGe(n, t.request).forEach((i) => {
          n = Uu.apply(n, i);
        });
        break;
      }
      case "SET_SKIP_ACTION": {
        n = XGe(n, t.request);
        break;
      }
      case "MOVE_BRANCH": {
        n = UGe(n, t.request), n = Ic.makeFlowAutoUpgradable(n);
        break;
      }
      case "UPDATE_NOTE": {
        n = YF.updateNote(n, t.request);
        break;
      }
      case "DELETE_NOTE": {
        n = YF.deleteNote(n, t.request);
        break;
      }
      case "ADD_NOTE": {
        n = YF.addNote(n, t.request);
        break;
      }
    }
    return n.valid = At.getAllSteps(n.trigger).every((r) => {
      const i = r.type != Bt.EMPTY && r.type != Bt.PIECE && r.skip;
      return r.valid || i;
    }), n;
  }
}, GGe = g.Object({
  key: g.String({
    maxLength: SZ
  }),
  value: g.Optional(g.Any({}))
}), YGe = g.Object({
  key: g.String({})
}), JGe = g.Object({
  key: g.String({})
}), eYe = g.Object({
  flowId: zn
}), tYe = g.Object({
  projectId: g.String(),
  folderId: g.Optional(g.String())
});
var VZ = /* @__PURE__ */ ((e) => (e.EMAIL = "EMAIL", e.GOOGLE = "GOOGLE", e.SAML = "SAML", e.JWT = "JWT", e))(VZ || {});
const kOe = g.Object({
  ...Or,
  firstName: g.String(),
  lastName: g.String(),
  email: g.String(),
  password: g.String(),
  trackEvents: g.Boolean(),
  newsLetter: g.Boolean(),
  verified: g.Boolean(),
  tokenVersion: g.Optional(g.String()),
  provider: g.Enum(VZ)
}), COe = g.Pick(b0e, ["id", "platformRole", "status", "externalId", "platformId"]), nYe = g.Composite([
  COe,
  g.Pick(kOe, ["verified", "firstName", "lastName", "email", "trackEvents", "newsLetter"]),
  g.Object({
    token: g.String(),
    projectId: g.String()
  })
]), rYe = g.Object({
  email: fZ,
  password: pZ,
  firstName: g.String({
    pattern: wv
  }),
  lastName: g.String({
    pattern: wv
  }),
  trackEvents: g.Boolean(),
  newsLetter: g.Boolean()
}), iYe = g.Object({
  platformId: zn
}), oYe = g.Object({
  email: fZ,
  password: pZ
});
var qZ = /* @__PURE__ */ ((e) => (e.USER = "USER", e.ENGINE = "ENGINE", e.SERVICE = "SERVICE", e.WORKER = "WORKER", e.UNKNOWN = "UNKNOWN", e))(qZ || {});
const sYe = Object.values(qZ), aYe = {
  apiKey: []
};
var NOe = /* @__PURE__ */ ((e) => (e.PLATFORM = "PLATFORM", e.PROJECT = "PROJECT", e))(NOe || {}), Z2 = /* @__PURE__ */ ((e) => (e.LAST_WEEK = "last-week", e.LAST_MONTH = "last-month", e.ALL_TIME = "all-time", e))(Z2 || {});
const POe = g.Object({
  day: g.String(),
  flowId: g.String(),
  runs: g.Number()
}), IOe = g.Array(POe), ROe = g.Object({
  flowId: g.String(),
  flowName: g.String(),
  projectId: g.String(),
  projectName: g.String(),
  status: g.Enum(il),
  timeSavedPerRun: It(g.Number()),
  ownerId: It(g.String())
}), MOe = g.Array(ROe), lYe = g.Object({
  ...Or,
  cachedAt: g.String(),
  runs: IOe,
  outdated: g.Boolean(),
  flows: MOe,
  platformId: g.String(),
  users: g.Array(lh)
}), cYe = g.Object({
  projectId: g.String(),
  projectName: g.String(),
  flowCount: g.Number(),
  minutesSaved: It(g.Number())
}), uYe = g.Object({
  userId: g.String(),
  flowCount: g.Number(),
  minutesSaved: It(g.Number())
}), dYe = g.Object({
  timePeriod: g.Optional(g.Enum(Z2))
}), fYe = g.Object({
  timePeriod: g.Enum(Z2)
}), pYe = g.Object({
  flowVersionId: zn
}), hYe = g.Object({
  strategy: g.Enum(qA),
  projectId: zn
}), mYe = g.Object({
  projectId: zn,
  flowRunIds: g.Optional(g.Array(zn)),
  excludeFlowRunIds: g.Optional(g.Array(zn)),
  strategy: g.Enum(qA),
  status: g.Optional(g.Array(g.Enum(cr))),
  flowId: g.Optional(g.Array(zn)),
  createdAfter: g.Optional(g.String()),
  createdBefore: g.Optional(g.String()),
  failedStepName: g.Optional(g.String())
}), gYe = g.Object({
  projectId: zn,
  flowRunIds: g.Optional(g.Array(zn)),
  excludeFlowRunIds: g.Optional(g.Array(zn)),
  status: g.Optional(g.Array(g.Union([
    g.Literal(cr.PAUSED),
    g.Literal(cr.QUEUED)
  ]))),
  flowId: g.Optional(g.Array(zn)),
  createdAfter: g.Optional(g.String()),
  createdBefore: g.Optional(g.String())
}), yYe = g.Object({
  projectId: zn,
  flowRunIds: g.Optional(g.Array(zn)),
  excludeFlowRunIds: g.Optional(g.Array(zn)),
  status: g.Optional(g.Array(g.Enum(cr))),
  flowId: g.Optional(g.Array(zn)),
  createdAfter: g.Optional(g.String()),
  createdBefore: g.Optional(g.String()),
  failedStepName: g.Optional(g.String())
}), vYe = g.Object({
  displayName: g.String({}),
  /**If folderId is provided, folderName is ignored */
  folderId: g.Optional(g.String({})),
  folderName: g.Optional(g.String({})),
  projectId: g.String({}),
  metadata: g.Optional(Tl)
}), bYe = (e) => g.Object({
  data: g.Array(e),
  next: It(g.String({ description: "Cursor to the next page" })),
  previous: It(g.String({ description: "Cursor to the previous page" }))
}), OYe = g.Object({
  projectId: zn,
  flowId: g.String({}),
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({}))
}), AYe = g.Object({
  projectId: zn,
  flowId: g.String({}),
  mockData: g.Unknown()
}), DOe = g.Object({
  id: g.String(),
  projectId: g.String(),
  flowId: g.String(),
  sourceName: g.String(),
  fileId: g.String()
}), wYe = g.Composite([
  DOe,
  g.Object({
    payload: g.Unknown()
  })
]), xYe = g.Object({
  ...Or,
  id: g.String(),
  projectId: g.String(),
  displayName: g.String(),
  displayOrder: g.Number()
}), ZM = "NULL", SYe = g.Object({
  displayName: g.String(),
  projectId: g.String()
}), EYe = g.Object({
  displayName: g.String()
}), TYe = g.Object({
  id: g.String()
}), kYe = g.Object({
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({})),
  projectId: g.String()
}), CYe = g.Object({
  flowId: g.String(),
  flowVersionId: g.String(),
  stepName: g.String()
});
var BZ = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.FILE = "file", e.TEXT_AREA = "text_area", e.TOGGLE = "toggle", e))(BZ || {});
const _Oe = g.Object({
  displayName: g.String(),
  required: g.Boolean(),
  description: g.String(),
  type: g.Enum(BZ)
}), LOe = g.Object({
  inputs: g.Array(_Oe),
  waitForResponse: g.Boolean()
}), NYe = g.Object({
  id: g.String(),
  title: g.String(),
  props: LOe,
  projectId: g.String(),
  version: g.String()
}), zOe = g.Object({
  botName: g.String()
}), PYe = g.Object({
  id: g.String(),
  title: g.String(),
  props: zOe,
  projectId: g.String(),
  platformLogoUrl: g.String(),
  platformName: g.String()
}), Vq = "useDraft", IYe = g.Object({
  flowId: g.String(),
  stepName: g.String(),
  file: g.Optional(g.Pick(_O, ["data"])),
  contentLength: g.Number(),
  fileName: g.String()
}), RYe = g.Object({
  uploadUrl: g.Optional(g.String()),
  url: g.String()
});
var $l = /* @__PURE__ */ ((e) => (e.SIMULATION = "SIMULATION", e.TEST_FUNCTION = "TEST_FUNCTION", e))($l || {});
const MYe = g.Object({
  projectId: zn,
  flowId: zn,
  flowVersionId: zn,
  testStrategy: g.Enum($l)
}), DYe = g.Object({
  projectId: zn,
  flowId: zn
}), _Ye = g.Object({
  folderId: g.Optional(g.String()),
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({})),
  status: g.Optional(g.Array(g.Enum(il))),
  projectId: g.String({}),
  name: g.Optional(g.String({})),
  agentExternalIds: g.Optional(g.Array(g.String({}))),
  versionState: g.Optional(g.Enum(Lo)),
  connectionExternalIds: g.Optional(g.Array(g.String({}))),
  externalIds: g.Optional(g.Array(g.String({})))
}), LYe = g.Object({
  versionId: g.Optional(g.String({}))
}), zYe = g.Object({
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({}))
});
var XZ = /* @__PURE__ */ ((e) => (e.RED = "RED", e.BLUE = "BLUE", e.YELLOW = "YELLOW", e.PURPLE = "PURPLE", e.GREEN = "GREEN", e.PINK = "PINK", e.VIOLET = "VIOLET", e.ORANGE = "ORANGE", e.DARK_GREEN = "DARK_GREEN", e.CYAN = "CYAN", e.LAVENDER = "LAVENDER", e.DEEP_ORANGE = "DEEP_ORANGE", e))(XZ || {}), WZ = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.ALLOWED = "ALLOWED", e))(WZ || {}), H2 = /* @__PURE__ */ ((e) => (e.TEAM = "TEAM", e.PERSONAL = "PERSONAL", e))(H2 || {});
const jOe = g.Object({
  ...Or,
  projectId: g.String(),
  locked: g.Boolean({ default: !1 }),
  name: g.String(),
  piecesFilterType: g.Enum(WZ),
  pieces: g.Array(g.String())
}), FOe = g.Object({
  color: g.Enum(XZ)
}), UOe = g.Object({
  ...Or,
  deleted: It(g.String()),
  ownerId: g.String(),
  displayName: g.String(),
  platformId: zn,
  maxConcurrentJobs: It(g.Number()),
  type: g.Enum(H2),
  icon: FOe,
  externalId: g.Optional(g.String()),
  releasesEnabled: g.Boolean(),
  metadata: It(Tl)
}), jYe = g.Object(
  {
    totalUsers: g.Number(),
    activeUsers: g.Number(),
    totalFlows: g.Number(),
    activeFlows: g.Number()
  }
), VOe = g.Composite([
  g.Omit(UOe, ["deleted"]),
  g.Object({
    plan: jOe,
    analytics: jYe
  })
]), FYe = g.Object({
  displayName: g.Optional(g.String({
    pattern: wv
  })),
  metadata: g.Optional(Tl)
}), UYe = g.Object({
  id: g.String(),
  displayName: g.String()
}), VYe = g.Object({
  platformName: g.String(),
  projects: g.Array(VOe)
});
g.Object({
  textColor: g.String(),
  color: g.String()
});
const qYe = {
  RED: {
    textColor: "#ffffff",
    color: "#ef4444"
  },
  BLUE: {
    textColor: "#ffffff",
    color: "#3b82f6"
  },
  YELLOW: {
    textColor: "#ffffff",
    color: "#eab308"
  },
  PURPLE: {
    textColor: "#ffffff",
    color: "#a855f7"
  },
  GREEN: {
    textColor: "#ffffff",
    color: "#22c55e"
  },
  PINK: {
    textColor: "#ffffff",
    color: "#f472b6"
  },
  VIOLET: {
    textColor: "#ffffff",
    color: "#9333ea"
  },
  ORANGE: {
    textColor: "#ffffff",
    color: "#f97316"
  },
  DARK_GREEN: {
    textColor: "#ffffff",
    color: "#15803d"
  },
  CYAN: {
    textColor: "#ffffff",
    color: "#06b6d4"
  },
  LAVENDER: {
    textColor: "#ffffff",
    color: "#8b5cf6"
  },
  DEEP_ORANGE: {
    textColor: "#ffffff",
    color: "#ea580c"
  }
};
var qOe = /* @__PURE__ */ ((e) => (e.ADMIN = "Admin", e.EDITOR = "Editor", e.OPERATOR = "Operator", e.VIEWER = "Viewer", e))(qOe || {});
const BYe = g.Object({
  base64Url: g.String(),
  fileName: g.String(),
  extension: g.Optional(g.String())
}), XYe = g.Object({
  mimeType: g.String(),
  url: g.String(),
  fileName: g.Optional(g.String())
}), HM = g.Union([BYe, XYe]);
var QM = /* @__PURE__ */ ((e) => (e.FILE = "file", e.MARKDOWN = "markdown", e))(QM || {});
function WYe(e) {
  return e.toLowerCase().replace(/\s+(\w)/g, (n, r) => r.toUpperCase()).replace(/^(.)/, (n) => n.toLowerCase()).replaceAll(/[\\"''\n\r\t]/g, "");
}
const ZYe = g.Union([
  g.Object({
    type: g.Literal(
      "file"
      /* FILE */
    ),
    value: HM
  }),
  g.Object({
    type: g.Literal(
      "markdown"
      /* MARKDOWN */
    ),
    value: g.String(),
    files: g.Optional(g.Array(HM))
  })
]), HYe = g.Object({
  sessionId: g.String(),
  message: g.String(),
  files: g.Optional(g.Array(g.String()))
});
var ZZ = /* @__PURE__ */ ((e) => (e.GOOGLE = "google", e.SAML = "saml", e))(ZZ || {});
const QYe = g.Object({
  loginUrl: g.String()
}), $Ye = g.Object({
  providerName: g.Enum(ZZ),
  code: g.String()
}), HZ = g.Object({
  clientId: g.String(),
  clientSecret: g.String()
}), QZ = g.Object({
  clientId: g.String(),
  clientSecret: g.String()
}), BOe = g.Object({
  idpMetadata: g.String(),
  idpCertificate: g.String()
}), $Z = g.Object({
  google: It(HZ),
  github: It(QZ),
  saml: It(BOe)
}), XOe = g.Object({
  google: It(g.Pick(HZ, ["clientId"])),
  github: It(g.Pick(QZ, ["clientId"])),
  saml: It(g.Object({}))
});
var Q2 = /* @__PURE__ */ ((e) => (e.ALLOWED = "ALLOWED", e.BLOCKED = "BLOCKED", e))(Q2 || {}), WOe = /* @__PURE__ */ ((e) => (e.AI_CREDITS = "ai-credits", e.ACTIVE_FLOWS = "active-flows", e))(WOe || {});
const KZ = g.Object({
  totalAiCreditsUsed: g.Number(),
  totalAiCreditsUsedThisMonth: g.Number(),
  aiCreditsRemaining: g.Number(),
  aiCreditsLimit: g.Number(),
  activeFlows: g.Number()
});
var ZOe = /* @__PURE__ */ ((e) => (e.STANDARD = "standard", e.ENTERPRISE = "enterprise", e.APPSUMO_ACTIVEPIECES_TIER1 = "appsumo_activepieces_tier1", e.APPSUMO_ACTIVEPIECES_TIER2 = "appsumo_activepieces_tier2", e.APPSUMO_ACTIVEPIECES_TIER3 = "appsumo_activepieces_tier3", e.APPSUMO_ACTIVEPIECES_TIER4 = "appsumo_activepieces_tier4", e.APPSUMO_ACTIVEPIECES_TIER5 = "appsumo_activepieces_tier5", e.APPSUMO_ACTIVEPIECES_TIER6 = "appsumo_activepieces_tier6", e))(ZOe || {}), GZ = /* @__PURE__ */ ((e) => (e.NONE = "NONE", e.ONE = "ONE", e.UNLIMITED = "UNLIMITED", e))(GZ || {}), YZ = /* @__PURE__ */ ((e) => (e.ENABLED = "enabled", e.DISABLED = "disabled", e))(YZ || {});
const JZ = g.Object({
  ...Or,
  // TODO: We have to use the enum when we finalize the plan names
  plan: g.Optional(g.String()),
  platformId: g.String(),
  includedAiCredits: g.Number(),
  lastFreeAiCreditsRenewalDate: g.Optional(g.String()),
  aiCreditsAutoTopUpState: g.Enum(YZ),
  aiCreditsAutoTopUpThreshold: g.Optional(g.Number()),
  aiCreditsAutoTopUpCreditsToAdd: g.Optional(g.Number()),
  maxAutoTopUpCreditsMonthly: It(g.Number()),
  environmentsEnabled: g.Boolean(),
  analyticsEnabled: g.Boolean(),
  showPoweredBy: g.Boolean(),
  agentsEnabled: g.Boolean(),
  mcpsEnabled: g.Boolean(),
  tablesEnabled: g.Boolean(),
  todosEnabled: g.Boolean(),
  auditLogEnabled: g.Boolean(),
  embeddingEnabled: g.Boolean(),
  managePiecesEnabled: g.Boolean(),
  manageTemplatesEnabled: g.Boolean(),
  customAppearanceEnabled: g.Boolean(),
  teamProjectsLimit: g.Enum(GZ),
  projectRolesEnabled: g.Boolean(),
  customDomainsEnabled: g.Boolean(),
  globalConnectionsEnabled: g.Boolean(),
  customRolesEnabled: g.Boolean(),
  apiKeysEnabled: g.Boolean(),
  ssoEnabled: g.Boolean(),
  licenseKey: g.Optional(g.String()),
  licenseExpiresAt: g.Optional(g.String()),
  stripeCustomerId: g.Optional(g.String()),
  stripeSubscriptionId: g.Optional(g.String()),
  stripeSubscriptionStatus: g.Optional(g.String()),
  stripeSubscriptionStartDate: g.Optional(g.Number()),
  stripeSubscriptionEndDate: g.Optional(g.Number()),
  stripeSubscriptionCancelDate: g.Optional(g.Number()),
  projectsLimit: It(g.Number()),
  activeFlowsLimit: It(g.Number()),
  dedicatedWorkers: It(g.Object({
    trustedEnvironment: g.Boolean()
  }))
}), HOe = g.Omit(JZ, ["id", "platformId", "created", "updated"]), QOe = g.Object({
  ...Or,
  ownerId: zn,
  name: g.String(),
  primaryColor: g.String(),
  logoIconUrl: g.String(),
  fullLogoUrl: g.String(),
  favIconUrl: g.String(),
  /**
  * @deprecated Use projects filter instead.
  */
  filteredPieceNames: g.Array(g.String()),
  /**
  * @deprecated Use projects filter instead.
  */
  filteredPieceBehavior: g.Enum(Q2),
  cloudAuthEnabled: g.Boolean(),
  enforceAllowedAuthDomains: g.Boolean(),
  allowedAuthDomains: g.Array(g.String()),
  federatedAuthProviders: $Z,
  emailAuthEnabled: g.Boolean(),
  pinnedPieces: g.Array(g.String())
}), KYe = g.Composite([g.Object({
  federatedAuthProviders: It(XOe),
  plan: HOe,
  usage: g.Optional(KZ)
}), g.Pick(QOe, [
  "id",
  "created",
  "updated",
  "ownerId",
  "name",
  "plan",
  "primaryColor",
  "logoIconUrl",
  "fullLogoUrl",
  "favIconUrl",
  "filteredPieceNames",
  "filteredPieceBehavior",
  "cloudAuthEnabled",
  "enforceAllowedAuthDomains",
  "allowedAuthDomains",
  "emailAuthEnabled",
  "pinnedPieces"
])]), GYe = g.Object({
  plan: JZ,
  usage: KZ,
  nextBillingDate: g.Number(),
  nextBillingAmount: g.Number(),
  cancelAt: g.Optional(g.Number())
}), YYe = g.Object({
  base64: g.String(),
  mimetype: g.String()
}), JYe = g.Object({
  name: g.Optional(g.String({
    pattern: wv
  })),
  primaryColor: g.Optional(g.String()),
  logoIcon: g.Optional(_O),
  fullLogo: g.Optional(_O),
  favIcon: g.Optional(_O),
  filteredPieceNames: g.Optional(g.Array(g.String())),
  filteredPieceBehavior: g.Optional(g.Enum(Q2)),
  federatedAuthProviders: g.Optional($Z),
  cloudAuthEnabled: g.Optional(g.Boolean()),
  emailAuthEnabled: g.Optional(g.Boolean()),
  allowedAuthDomains: g.Optional(g.Array(g.String())),
  enforceAllowedAuthDomains: g.Optional(g.Boolean()),
  pinnedPieces: g.Optional(g.Array(g.String()))
}), eJe = g.Object({
  runIds: g.Optional(g.Array(zn)),
  createdAfter: g.String(),
  createdBefore: g.String()
}), tJe = g.Object({
  email: g.String(),
  licenseKey: g.String()
}), nJe = g.Object({
  platformId: g.String(),
  amountInUsd: g.Number()
});
var rv = /* @__PURE__ */ ((e) => (e.OPENAI = "openai", e.OPENROUTER = "openrouter", e.ANTHROPIC = "anthropic", e.AZURE = "azure", e.GOOGLE = "google", e.ACTIVEPIECES = "activepieces", e.CLOUDFLARE_GATEWAY = "cloudflare-gateway", e.CUSTOM = "custom", e))(rv || {});
const $Oe = [
  {
    provider: "openai",
    name: "OpenAI",
    markdown: $g(`Follow these instructions to get your OpenAI API Key:

1. Visit the following website: https://platform.openai.com/account/api-keys.
2. Once on the website, locate and click on the option to obtain your OpenAI API Key.

It is strongly recommended that you add your credit card information to your OpenAI account and upgrade to the paid plan **before** generating the API Key. This will help you prevent 429 errors.
`),
    logoUrl: "https://cdn.activepieces.com/pieces/openai.png"
  },
  {
    provider: "anthropic",
    name: "Anthropic",
    markdown: $g(`Follow these instructions to get your Claude API Key:

1. Visit the following website: https://console.anthropic.com/settings/keys.
2. Once on the website, locate and click on the option to obtain your Claude API Key.
`),
    logoUrl: "https://cdn.activepieces.com/pieces/claude.png"
  },
  {
    provider: "google",
    name: "Google Gemini",
    markdown: $g(`Follow these instructions to get your Google API Key:
1. Visit the following website: https://console.cloud.google.com/apis/credentials.
2. Once on the website, locate and click on the option to obtain your Google API Key.
`),
    logoUrl: "https://cdn.activepieces.com/pieces/google-gemini.png"
  },
  {
    provider: "azure",
    name: "Azure",
    logoUrl: "https://cdn.activepieces.com/pieces/azure-openai.png",
    markdown: $g(
      "Use the Azure Portal to browse to your OpenAI resource and retrieve an API key and resource name."
    )
  },
  {
    provider: "openrouter",
    name: "OpenRouter",
    logoUrl: "https://cdn.activepieces.com/pieces/openrouter.jpg",
    markdown: $g(`Follow these instructions to get your OpenRouter API Key:
1. Visit the following website: https://openrouter.ai/settings/keys.
2. Once on the website, locate and click on the option to obtain your OpenRouter API Key.`)
  },
  {
    provider: "cloudflare-gateway",
    name: "Cloudflare AI Gateway",
    logoUrl: "https://cdn.activepieces.com/pieces/cloudflare-gateway.png",
    markdown: $g(`Follow these instructions to get your Cloudflare AI Gateway API Key:
1. Visit the following website: https://developers.cloudflare.com/ai-gateway/get-started/.
2. Once on the website, follow the instructions to get your account id, gateway id and create an API Key.
3. After creating the gateway, make sure to enable the Authenticated Gateway Option in your settings.
4. For each provider you are using, include your keys in the Provider Keys tab.`)
  },
  {
    provider: "custom",
    name: "OpenAI Compatible",
    logoUrl: "https://cdn.activepieces.com/pieces/openai-compatible.png",
    markdown: $g(`Follow these instructions to get your OpenAI Compatible API Key:
1. Set the base url to your proxy url.
2. In the api key header, set the value of your auth header name.
3. In the api key, set your auth header value (full value including the Bearer if any).`)
  }
];
var $2 = /* @__PURE__ */ ((e) => (e.IMAGE = "image", e.TEXT = "text", e))($2 || {});
const xh = g.Object({
  apiKey: g.String()
}), eH = xh, tH = g.Intersect([
  xh,
  g.Object({
    apiKeyHash: g.String()
  })
]), nH = xh, rH = xh, iH = xh, oH = xh, sH = xh, aH = xh, lH = g.Object({}), cH = g.Object({}), uH = g.Object({
  modelId: g.String(),
  modelName: g.String(),
  modelType: g.Enum($2)
}), dH = g.Object({
  apiKeyHeader: g.String(),
  baseUrl: g.String(),
  models: g.Array(uH)
}), fH = g.Object({
  accountId: g.String(),
  gatewayId: g.String(),
  models: g.Array(uH)
}), pH = g.Object({
  resourceName: g.String()
}), hH = g.Object({}), mH = g.Object({}), gH = g.Object({}), yH = g.Union([
  eH,
  iH,
  oH,
  sH,
  aH,
  rH,
  nH,
  tH
]), K2 = g.Union([
  dH,
  fH,
  pH,
  lH,
  hH,
  mH,
  gH,
  cH
]), KOe = SC("provider", [
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "openai"
      /* OPENAI */
    ),
    config: mH,
    auth: sH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "openrouter"
      /* OPENROUTER */
    ),
    config: gH,
    auth: aH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "anthropic"
      /* ANTHROPIC */
    ),
    config: lH,
    auth: eH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "azure"
      /* AZURE */
    ),
    config: pH,
    auth: iH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "google"
      /* GOOGLE */
    ),
    config: hH,
    auth: oH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "cloudflare-gateway"
      /* CLOUDFLARE_GATEWAY */
    ),
    config: fH,
    auth: rH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "custom"
      /* CUSTOM */
    ),
    config: dH,
    auth: nH
  }),
  g.Object({
    displayName: g.String({ minLength: 1 }),
    provider: g.Literal(
      "activepieces"
      /* ACTIVEPIECES */
    ),
    config: cH,
    auth: tH
  })
]), rJe = g.Intersect([
  g.Object({ ...Or }),
  KOe,
  g.Object({
    displayName: g.String({ minLength: 1 }),
    platformId: g.String()
  })
]), iJe = g.Object({
  id: g.String(),
  name: g.String(),
  provider: g.Enum(rv),
  config: K2
}), oJe = g.Object({
  id: g.String(),
  name: g.String(),
  type: g.Enum($2)
}), sJe = KOe, aJe = g.Object({
  displayName: g.String({ minLength: 1 }),
  config: g.Optional(K2),
  auth: g.Optional(yH)
}), lJe = g.Object({
  provider: g.Enum(rv),
  config: K2,
  auth: yH
}), cJe = g.Object({
  error: g.Object({
    message: g.String(),
    type: g.String(),
    code: g.String()
  })
}), uJe = g.Object({
  ...Or,
  platformId: g.String(),
  name: g.String()
}), dJe = g.Object({
  ...Or,
  pieceName: g.String(),
  tagId: g.String(),
  platformId: g.String()
}), fJe = g.Object({
  limit: g.Optional(g.Number()),
  cursor: g.Optional(g.String())
}), pJe = g.Object({
  piecesName: g.Array(g.String()),
  tags: g.Array(g.String())
}), hJe = g.Object({
  name: g.String()
}), mJe = async (e, t, n, r) => {
  const i = (r == null ? void 0 : r.timeoutMs) ?? 4e3, o = (r == null ? void 0 : r.retries) ?? 3, s = (r == null ? void 0 : r.retryDelayMs) ?? 2e3;
  for (let l = 0; l <= o; l++) {
    const c = await Bbe(async () => {
      if (!e || !e.connected)
        throw new Error("Socket not connected");
      return await e.timeout(i).emitWithAck(t, n);
    });
    if (c.error)
      if (l < o)
        await new Promise((a) => setTimeout(a, s));
      else
        throw c.error;
    else
      return c.data;
  }
  throw new Error(`Failed to emit event after ${o} retries`);
};
var pi = /* @__PURE__ */ ((e) => (e.TEST_FLOW_RUN_STARTED = "TEST_FLOW_RUN_STARTED", e.TEST_STEP_FINISHED = "TEST_STEP_FINISHED", e.TEST_STEP_PROGRESS = "TEST_STEP_PROGRESS", e.REFRESH_PIECE = "REFRESH_PIECE", e.FLOW_RUN_PROGRESS = "FLOW_RUN_PROGRESS", e.TODO_CHANGED = "TODO_CHANGED", e.BADGE_AWARDED = "BADGE_AWARDED", e.TODO_ACTIVITY_CHANGED = "TODO_ACTIVITY_CHANGED", e.TODO_ACTIVITY_CREATED = "TODO_ACTIVITY_CREATED", e.FLOW_STATUS_UPDATED = "FLOW_STATUS_UPDATED", e))(pi || {});
const gJe = g.Object({
  todoId: g.String()
}), yJe = g.Object({
  activityId: g.String(),
  todoId: g.String(),
  content: g.String()
}), vJe = g.Object({
  todoId: g.String()
}), bJe = g.Object({
  badge: g.String(),
  userId: g.String()
});
var vH = /* @__PURE__ */ ((e) => (e.TEST_FLOW_RUN = "TEST_FLOW_RUN", e.CONNECT = "CONNECT", e.FETCH_WORKER_SETTINGS = "FETCH_WORKER_SETTINGS", e.DISCONNECT = "DISCONNECT", e.WORKER_HEALTHCHECK = "WORKER_HEALTHCHECK", e.EMIT_TEST_STEP_PROGRESS = "EMIT_TEST_STEP_PROGRESS", e.EMIT_TEST_STEP_FINISHED = "EMIT_TEST_STEP_FINISHED", e))(vH || {});
const OJe = "https://community.activepieces.com", GOe = "https://feedback.activepieces.com", AJe = g.Object({
  licenseKey: g.String(),
  platformId: g.String()
}), YOe = g.Object({
  id: g.String(),
  email: g.String(),
  expiresAt: g.String(),
  activatedAt: g.String(),
  createdAt: g.String(),
  key: g.String(),
  ssoEnabled: g.Boolean(),
  environmentsEnabled: g.Boolean(),
  showPoweredBy: g.Boolean(),
  embeddingEnabled: g.Boolean(),
  auditLogEnabled: g.Boolean(),
  customAppearanceEnabled: g.Boolean(),
  manageProjectsEnabled: g.Boolean(),
  managePiecesEnabled: g.Boolean(),
  manageTemplatesEnabled: g.Boolean(),
  apiKeysEnabled: g.Boolean(),
  customDomainsEnabled: g.Boolean(),
  projectRolesEnabled: g.Boolean(),
  analyticsEnabled: g.Boolean(),
  globalConnectionsEnabled: g.Boolean(),
  customRolesEnabled: g.Boolean(),
  agentsEnabled: g.Boolean(),
  tablesEnabled: g.Boolean(),
  todosEnabled: g.Boolean(),
  mcpsEnabled: g.Boolean()
}), wJe = g.Composite([g.Object({
  email: g.String(),
  companyName: g.String(),
  goal: g.String(),
  keyType: g.Optional(g.String())
}), g.Omit(YOe, ["id", "email", "expiresAt", "activatedAt", "key", "createdAt"])]), JOe = g.Object({
  ...Or,
  name: g.String(),
  permissions: g.Array(g.String()),
  platformId: g.Optional(g.String()),
  type: g.String(),
  userCount: g.Optional(g.Number())
});
var G2 = /* @__PURE__ */ ((e) => (e.PLATFORM = "PLATFORM", e.PROJECT = "PROJECT", e))(G2 || {}), Y2 = /* @__PURE__ */ ((e) => (e.PENDING = "PENDING", e.ACCEPTED = "ACCEPTED", e))(Y2 || {});
const eAe = g.Object({
  ...Or,
  email: g.String(),
  status: g.Enum(Y2),
  type: g.Enum(G2),
  platformId: g.String(),
  platformRole: UA(g.Enum(bb)),
  projectId: It(g.String()),
  projectRoleId: It(g.String()),
  projectRole: It(JOe)
}), xJe = g.Composite([eAe, g.Object({
  link: g.Optional(g.String())
})]), SJe = g.Union([
  g.Object({
    type: g.Literal(
      "PROJECT"
      /* PROJECT */
    ),
    email: g.String(),
    projectId: g.String(),
    projectRole: g.String()
  }),
  g.Object({
    type: g.Literal(
      "PLATFORM"
      /* PLATFORM */
    ),
    email: g.String(),
    platformRole: g.Enum(bb)
  })
]), EJe = g.Object({
  invitationToken: g.String()
}), TJe = g.Object({
  limit: g.Optional(g.Number()),
  cursor: g.Optional(g.String()),
  type: g.Enum(G2),
  projectId: It(g.String()),
  status: g.Optional(g.Enum(Y2))
});
var bH = /* @__PURE__ */ ((e) => (e.ONLINE = "ONLINE", e.OFFLINE = "OFFLINE", e))(bH || {});
const OH = g.Object({
  cpuUsagePercentage: g.Number(),
  diskInfo: g.Object({
    total: g.Number(),
    free: g.Number(),
    used: g.Number(),
    percentage: g.Number()
  }),
  workerId: g.String(),
  workerProps: g.Record(g.String(), g.String()),
  ramUsagePercentage: g.Number(),
  totalAvailableRamInBytes: g.Number(),
  totalCpuCores: g.Number(),
  ip: g.String(),
  totalSandboxes: g.Number(),
  freeSandboxes: g.Number()
}), tAe = g.Object({
  ...Or,
  information: OH
}), kJe = g.Composite([tAe, g.Object({
  status: g.Enum(bH)
})]), CJe = g.Object({
  jobId: g.String(),
  jobData: U0e,
  timeoutInSeconds: g.Number(),
  attempsStarted: g.Number(),
  engineToken: g.String()
});
var AH = /* @__PURE__ */ ((e) => (e.OK = "OK", e.INTERNAL_ERROR = "INTERNAL_ERROR", e))(AH || {});
const NJe = g.Object({
  status: g.Enum(AH),
  errorMessage: g.Optional(g.String()),
  delayInSeconds: g.Optional(g.Number())
}), PJe = OH, IJe = g.Object({
  PUBLIC_URL: g.String(),
  TRIGGER_TIMEOUT_SECONDS: g.Number(),
  TRIGGER_HOOKS_TIMEOUT_SECONDS: g.Number(),
  PAUSED_FLOW_TIMEOUT_DAYS: g.Number(),
  EXECUTION_MODE: g.String(),
  FLOW_TIMEOUT_SECONDS: g.Number(),
  WORKER_CONCURRENCY: g.Number(),
  LOG_LEVEL: g.String(),
  LOG_PRETTY: g.String(),
  ENVIRONMENT: g.String(),
  APP_WEBHOOK_SECRETS: g.String(),
  MAX_FLOW_RUN_LOG_SIZE_MB: g.Number(),
  MAX_FILE_SIZE_MB: g.Number(),
  SANDBOX_MEMORY_LIMIT: g.String(),
  SANDBOX_PROPAGATED_ENV_VARS: g.Array(g.String()),
  DEV_PIECES: g.Array(g.String()),
  SENTRY_DSN: g.Optional(g.String()),
  LOKI_PASSWORD: g.Optional(g.String()),
  LOKI_URL: g.Optional(g.String()),
  LOKI_USERNAME: g.Optional(g.String()),
  OTEL_ENABLED: g.Boolean(),
  HYPERDX_TOKEN: g.Optional(g.String()),
  FILE_STORAGE_LOCATION: g.String(),
  S3_USE_SIGNED_URLS: g.String(),
  QUEUE_MODE: g.Optional(g.String()),
  REDIS_TYPE: g.String(),
  REDIS_SSL_CA_FILE: g.Optional(g.String()),
  REDIS_DB: g.Optional(g.Number()),
  REDIS_HOST: g.Optional(g.String()),
  REDIS_PASSWORD: g.Optional(g.String()),
  REDIS_PORT: g.Optional(g.String()),
  REDIS_URL: g.Optional(g.String()),
  REDIS_USER: g.Optional(g.String()),
  REDIS_USE_SSL: g.Optional(g.Boolean()),
  REDIS_SENTINEL_ROLE: g.Optional(g.String()),
  REDIS_SENTINEL_HOSTS: g.Optional(g.String()),
  REDIS_SENTINEL_NAME: g.Optional(g.String()),
  REDIS_FAILED_JOB_RETENTION_DAYS: g.Number(),
  REDIS_FAILED_JOB_RETENTION_MAX_COUNT: g.Number(),
  PROJECT_RATE_LIMITER_ENABLED: g.Boolean(),
  MAX_CONCURRENT_JOBS_PER_PROJECT: g.Number(),
  JWT_SECRET: g.String(),
  PLATFORM_ID_FOR_DEDICATED_WORKER: g.Optional(g.String()),
  EDITION: g.String()
});
var gs = /* @__PURE__ */ ((e) => (e.BORDERLESS = "BORDERLESS", e.INFO = "INFO", e.WARNING = "WARNING", e.TIP = "TIP", e))(gs || {});
const RJe = g.Object({
  name: g.String({
    pattern: wv
  }),
  permissions: g.Array(g.String()),
  type: g.Enum(ZW)
}), MJe = g.Object({
  name: g.Optional(g.String({
    pattern: wv
  })),
  permissions: g.Optional(g.Array(g.String()))
}), DJe = g.Object({
  cursor: g.Optional(g.String()),
  limit: g.Optional(g.Number())
}), _Je = {
  async serialize(e) {
    return Buffer.from(JSON.stringify(e, null));
  }
};
var yO = /* @__PURE__ */ ((e) => (e.TEXT = "TEXT", e.NUMBER = "NUMBER", e.DATE = "DATE", e.STATIC_DROPDOWN = "STATIC_DROPDOWN", e))(yO || {});
const nAe = g.Union([g.Object({
  ...Or,
  name: g.String(),
  externalId: g.String(),
  type: g.Literal(
    "STATIC_DROPDOWN"
    /* STATIC_DROPDOWN */
  ),
  tableId: g.String(),
  projectId: g.String(),
  data: g.Object({
    options: g.Array(g.Object({
      value: g.String()
    }))
  })
}), g.Object({
  ...Or,
  name: g.String(),
  externalId: g.String(),
  type: g.Union([g.Literal(
    "TEXT"
    /* TEXT */
  ), g.Literal(
    "NUMBER"
    /* NUMBER */
  ), g.Literal(
    "DATE"
    /* DATE */
  )]),
  tableId: g.String(),
  projectId: g.String()
})]), LJe = {
  label: "",
  value: ""
};
var LC = /* @__PURE__ */ ((e) => (e.ON_NEW_RECORD = "ON_NEW_RECORD", e.ON_UPDATE_RECORD = "ON_UPDATE_RECORD", e))(LC || {}), zC = /* @__PURE__ */ ((e) => (e.ENABLED = "ENABLED", e.DISABLED = "DISABLED", e))(zC || {});
const rAe = g.Object({
  ...Or,
  name: g.String(),
  projectId: g.String(),
  externalId: g.String(),
  status: UA(g.Enum(zC)),
  trigger: UA(g.Enum(LC))
}), zJe = g.Composite([
  rAe,
  g.Object({
    fields: g.Array(nAe)
  })
]);
var J2 = /* @__PURE__ */ ((e) => (e.RECORD_CREATED = "RECORD_CREATED", e.RECORD_UPDATED = "RECORD_UPDATED", e.RECORD_DELETED = "RECORD_DELETED", e))(J2 || {});
const jJe = g.Object({
  ...Or,
  projectId: g.String(),
  tableId: g.String(),
  events: g.Array(g.Enum(J2)),
  flowId: g.String()
}), FJe = g.Object({
  projectId: g.String(),
  name: g.String(),
  externalId: g.Optional(g.String())
}), UJe = g.Object({
  fields: g.Array(g.Object({ id: g.String(), name: g.String() })),
  rows: g.Array(g.Record(g.String(), g.String())),
  name: g.String()
}), VJe = g.Object({
  events: g.Array(g.Enum(J2)),
  webhookUrl: g.String(),
  flowId: g.String()
}), qJe = g.Object({
  name: g.Optional(g.String()),
  trigger: g.Optional(g.Enum(LC)),
  status: g.Optional(g.Enum(zC))
}), BJe = g.Object({
  projectId: g.String(),
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({})),
  name: g.Optional(g.String({})),
  externalIds: g.Optional(g.Array(g.String()))
}), XJe = g.Object({
  options: g.Array(g.Object({
    value: g.String()
  }))
}), WJe = g.Union([g.Object({
  name: g.String(),
  type: g.Literal(yO.STATIC_DROPDOWN),
  tableId: g.String(),
  data: XJe,
  externalId: g.Optional(g.String())
}), g.Object({
  name: g.String(),
  type: g.Union([g.Literal(yO.TEXT), g.Literal(yO.NUMBER), g.Literal(yO.DATE)]),
  tableId: g.String(),
  externalId: g.Optional(g.String())
})]), ZJe = g.Object({
  name: g.String()
}), HJe = g.Object({
  tableId: g.String()
}), QJe = g.Object({
  records: g.Array(g.Array(g.Object({
    fieldId: g.String(),
    value: g.String()
  }))),
  tableId: g.String()
}), $Je = g.Object({
  cells: g.Optional(g.Array(g.Object({
    fieldId: g.String(),
    value: g.String()
  }))),
  tableId: g.String(),
  agentUpdate: g.Optional(g.Boolean())
});
var wH = /* @__PURE__ */ ((e) => (e.EQ = "eq", e.NEQ = "neq", e.GT = "gt", e.GTE = "gte", e.LT = "lt", e.LTE = "lte", e.CO = "co", e))(wH || {});
const iAe = g.Object({
  fieldId: g.String(),
  value: g.String(),
  operator: g.Optional(g.Enum(wH))
}), KJe = g.Object({
  tableId: g.String(),
  limit: g.Optional(g.Number({})),
  cursor: g.Optional(g.String({})),
  filters: g.Optional(g.Array(iAe))
}), GJe = g.Object({
  tableId: g.String(),
  ids: g.Array(g.String())
}), oAe = g.Object({
  ...Or,
  recordId: g.String(),
  fieldId: g.String(),
  projectId: g.String(),
  value: g.Unknown()
}), sAe = g.Object({
  ...Or,
  tableId: g.String(),
  projectId: g.String()
}), YJe = g.Composite([
  sAe,
  g.Object({
    cells: g.Record(g.String(), g.Composite([
      g.Pick(oAe, ["updated", "created", "value"]),
      g.Object({
        fieldName: g.String()
      })
    ]))
  })
]);
var xH = /* @__PURE__ */ ((e) => (e.GIT = "GIT", e.PROJECT = "PROJECT", e.ROLLBACK = "ROLLBACK", e))(xH || {});
const SH = {
  name: g.String(),
  description: It(g.String()),
  selectedFlowsIds: It(g.Array(g.String())),
  projectId: g.String()
}, aAe = g.Object({
  type: g.Literal(
    "GIT"
    /* GIT */
  ),
  ...SH
}), lAe = g.Object({
  type: g.Literal(
    "ROLLBACK"
    /* ROLLBACK */
  ),
  ...SH,
  projectReleaseId: g.String()
}), cAe = g.Object({
  type: g.Literal(
    "PROJECT"
    /* PROJECT */
  ),
  ...SH,
  targetProjectId: g.String()
}), JJe = SC("type", [
  lAe,
  cAe,
  aAe
]), eet = g.Union([
  g.Object({
    projectId: g.String(),
    type: g.Literal(
      "PROJECT"
      /* PROJECT */
    ),
    targetProjectId: g.String()
  }),
  g.Object({
    projectId: g.String(),
    type: g.Literal(
      "ROLLBACK"
      /* ROLLBACK */
    ),
    projectReleaseId: g.String()
  }),
  g.Object({
    projectId: g.String(),
    type: g.Literal(
      "GIT"
      /* GIT */
    )
  })
]), tet = g.Object({
  projectId: g.String(),
  cursor: It(g.String()),
  limit: g.Optional(g.Number({ default: 10 }))
}), net = g.Object({
  ...Or,
  projectId: g.String(),
  name: g.String(),
  description: It(g.String()),
  importedBy: It(g.String()),
  fileId: g.String(),
  type: g.Enum(xH),
  importedByUser: g.Optional(lh)
});
var uAe = /* @__PURE__ */ ((e) => (e.UPDATE_FLOW = "UPDATE_FLOW", e.CREATE_FLOW = "CREATE_FLOW", e.DELETE_FLOW = "DELETE_FLOW", e))(uAe || {}), dAe = /* @__PURE__ */ ((e) => (e.UPDATE_CONNECTION = "UPDATE_CONNECTION", e.CREATE_CONNECTION = "CREATE_CONNECTION", e))(dAe || {}), fAe = /* @__PURE__ */ ((e) => (e.UPDATE_TABLE = "UPDATE_TABLE", e.CREATE_TABLE = "CREATE_TABLE", e.DELETE_TABLE = "DELETE_TABLE", e))(fAe || {});
const KS = _C, bE = g.Object({
  externalId: g.String(),
  pieceName: g.String(),
  displayName: g.String()
}), pAe = g.Object({
  name: g.String(),
  type: g.String(),
  data: It(g.Object({
    options: g.Array(g.Object({
      value: g.String()
    }))
  })),
  externalId: g.String()
}), vO = g.Object({
  id: g.String(),
  name: g.String(),
  externalId: g.String(),
  fields: g.Array(pAe),
  status: UA(g.Enum(zC)),
  trigger: UA(g.Enum(LC))
}), hAe = g.Object({
  flows: g.Array(_C),
  // NOTE: This is optional because in old releases, the connections, tables, agents and mcp state is not present
  connections: g.Optional(g.Array(bE)),
  tables: g.Optional(g.Array(vO))
}), mAe = g.Union([
  g.Object({
    type: g.Literal(
      "UPDATE_FLOW"
      /* UPDATE_FLOW */
    ),
    newFlowState: KS,
    flowState: KS
  }),
  g.Object({
    type: g.Literal(
      "CREATE_FLOW"
      /* CREATE_FLOW */
    ),
    flowState: KS
  }),
  g.Object({
    type: g.Literal(
      "DELETE_FLOW"
      /* DELETE_FLOW */
    ),
    flowState: KS
  })
]), EH = g.Union([
  g.Object({
    type: g.Literal(
      "UPDATE_CONNECTION"
      /* UPDATE_CONNECTION */
    ),
    newConnectionState: bE,
    connectionState: bE
  }),
  g.Object({
    type: g.Literal(
      "CREATE_CONNECTION"
      /* CREATE_CONNECTION */
    ),
    connectionState: bE
  })
]), TH = g.Union([
  g.Object({
    type: g.Literal(
      "UPDATE_TABLE"
      /* UPDATE_TABLE */
    ),
    newTableState: vO,
    tableState: vO
  }),
  g.Object({
    type: g.Literal(
      "CREATE_TABLE"
      /* CREATE_TABLE */
    ),
    tableState: vO
  }),
  g.Object({
    type: g.Literal(
      "DELETE_TABLE"
      /* DELETE_TABLE */
    ),
    tableState: vO
  })
]), ret = g.Object({
  flows: g.Array(mAe),
  connections: g.Array(EH),
  tables: g.Array(TH)
}), gAe = g.Object({
  flowId: g.String(),
  message: g.String()
}), yAe = g.Union([
  g.Object({
    type: g.Literal(
      "CREATE_FLOW"
      /* CREATE_FLOW */
    ),
    flow: g.Object({
      id: g.String(),
      displayName: g.String()
    })
  }),
  g.Object({
    type: g.Literal(
      "UPDATE_FLOW"
      /* UPDATE_FLOW */
    ),
    flow: g.Object({
      id: g.String(),
      displayName: g.String()
    }),
    targetFlow: g.Object({
      id: g.String(),
      displayName: g.String()
    })
  }),
  g.Object({
    type: g.Literal(
      "DELETE_FLOW"
      /* DELETE_FLOW */
    ),
    flow: g.Object({
      id: g.String(),
      displayName: g.String()
    })
  })
]), iet = g.Object({
  flows: g.Array(yAe),
  connections: g.Array(EH),
  tables: g.Array(TH),
  errors: g.Array(gAe)
});
var Vp = /* @__PURE__ */ ((e) => (e.POSITIVE = "Positive (Green)", e.NEGATIVE = "Negative (Red)", e.NEUTRAL = "Neutral (Gray)", e))(Vp || {});
const WA = {
  name: "Unresolved",
  description: "Unresolved",
  variant: "Neutral (Gray)"
  /* NEUTRAL */
}, oet = {
  name: "Resolved",
  description: "Resolved",
  variant: "Positive (Green)"
  /* POSITIVE */
}, qq = {
  "Positive (Green)": {
    color: "#e5efe7",
    textColor: "#28813e"
  },
  "Negative (Red)": {
    color: "#fbe2e3",
    textColor: "#dd111b"
  },
  "Neutral (Gray)": {
    color: "#fef3c7",
    textColor: "#b45309"
  }
}, set = g.Object({
  status: g.String(),
  message: It(g.String())
}), aet = g.Object({
  id: g.String(),
  links: g.Array(
    g.Object({
      name: g.String(),
      url: g.String()
    })
  )
}), TT = g.Object({
  name: g.String(),
  description: It(g.String()),
  variant: g.Union([
    g.Literal(
      "Positive (Green)"
      /* POSITIVE */
    ),
    g.Literal(
      "Negative (Red)"
      /* NEGATIVE */
    ),
    g.Literal(
      "Neutral (Gray)"
      /* NEUTRAL */
    )
  ]),
  continueFlow: g.Boolean()
});
var jC = /* @__PURE__ */ ((e) => (e.TEST = "test", e.PRODUCTION = "production", e))(jC || {});
const vAe = g.Object({
  ...Or,
  title: g.String(),
  description: g.String(),
  status: TT,
  createdByUserId: It(g.String()),
  statusOptions: g.Array(TT),
  platformId: g.String(),
  projectId: g.String(),
  flowId: g.String(),
  runId: g.String(),
  assigneeId: It(g.String()),
  locked: g.Boolean(),
  resolveUrl: It(g.String()),
  environment: g.Enum(jC)
}), cet = g.Composite([
  vAe,
  g.Object({
    assignee: It(lh),
    createdByUser: It(lh),
    flow: It(_C)
  })
]);
var $s = /* @__PURE__ */ ((e) => (e.INTERNAL = "internal", e.EXTERNAL = "external", e))($s || {});
const bAe = g.Object({
  ...Or,
  todoId: g.String(),
  userId: It(g.String()),
  content: g.String()
}), uet = g.Composite([
  bAe,
  g.Object({
    user: It(lh)
  })
]), OAe = g.Array(TT, { minItems: 1 }), det = g.Object({
  platformId: zn,
  projectId: zn,
  flowId: g.Optional(zn),
  cursor: g.Optional(g.String()),
  limit: g.Optional(g.Integer({ minimum: 1, maximum: 100 })),
  assigneeId: g.Optional(zn),
  statusOptions: g.Optional(g.Array(g.String())),
  title: g.Optional(g.String()),
  environment: g.Optional(g.Enum(jC))
}), fet = g.Object({}), pet = g.Object({
  title: g.Optional(g.String()),
  description: g.Optional(g.String()),
  status: g.Optional(TT),
  statusOptions: g.Optional(OAe),
  assigneeId: g.Optional(zn),
  isTest: g.Optional(g.Boolean())
}), het = g.Object({
  title: g.String(),
  description: g.String(),
  statusOptions: OAe,
  flowId: zn,
  runId: g.Optional(zn),
  assigneeId: g.Optional(zn),
  resolveUrl: g.Optional(g.String()),
  environment: g.Optional(g.Enum(jC))
}), met = g.Object({
  status: g.String(),
  isTest: g.Optional(g.Boolean())
}), get = g.Object({
  todoId: zn,
  type: g.Optional(g.String()),
  cursor: g.Optional(g.String()),
  limit: g.Optional(g.Integer({ minimum: 1, maximum: 100 }))
}), yet = g.Object({
  todoId: zn,
  content: g.String()
}), vet = "@activepieces/piece-mcp";
var ez = /* @__PURE__ */ ((e) => (e.ENABLED = "ENABLED", e.DISABLED = "DISABLED", e))(ez || {});
const AAe = g.Object({
  ...Or,
  projectId: zn,
  status: g.Enum(ez),
  token: zn
}), bet = g.Composite([AAe, g.Object({
  flows: g.Array(_C)
})]), Oet = g.Object({
  status: g.Enum(ez)
});
var Kd = /* @__PURE__ */ ((e) => (e.TEXT = "Text", e.BOOLEAN = "Boolean", e.DATE = "Date", e.NUMBER = "Number", e.ARRAY = "Array", e.OBJECT = "Object", e))(Kd || {});
const wAe = g.Object({
  name: g.String(),
  description: g.Optional(g.String()),
  type: g.String(),
  required: g.Boolean()
}), Aet = g.Object({
  pieceName: g.String(),
  triggerName: g.String(),
  input: g.Object({
    toolName: g.String(),
    toolDescription: g.String(),
    inputSchema: g.Array(wAe),
    returnsResponse: g.Boolean()
  })
}), xAe = "updateTaskStatus";
var Cc = /* @__PURE__ */ ((e) => (e.AGENT_DECIDE = "agent-decide", e.CHOOSE_YOURSELF = "choose-yourself", e.LEAVE_EMPTY = "leave-empty", e))(Cc || {});
const SAe = g.Object({
  mode: g.Enum(Cc),
  value: g.Unknown()
}), EAe = g.Object({
  auth: g.Optional(g.String()),
  fields: g.Record(g.String(), SAe)
});
var Wu = /* @__PURE__ */ ((e) => (e.PIECE = "PIECE", e.FLOW = "FLOW", e.MCP = "MCP", e))(Wu || {}), Pm = /* @__PURE__ */ ((e) => (e.SSE = "sse", e.STREAMABLE_HTTP = "streamable-http", e.SIMPLE_HTTP = "http", e))(Pm || {}), xi = /* @__PURE__ */ ((e) => (e.NONE = "none", e.ACCESS_TOKEN = "access_token", e.API_KEY = "api_key", e.HEADERS = "headers", e))(xi || {});
const kH = {
  toolName: g.String({ minLength: 1 })
}, TAe = g.Object({
  type: g.Literal(
    "none"
    /* NONE */
  )
}), kAe = g.Object({
  type: g.Literal(
    "access_token"
    /* ACCESS_TOKEN */
  ),
  accessToken: g.String()
}), CAe = g.Object({
  type: g.Literal(
    "api_key"
    /* API_KEY */
  ),
  apiKey: g.String(),
  apiKeyHeader: g.String()
}), NAe = g.Object({
  type: g.Literal(
    "headers"
    /* HEADERS */
  ),
  headers: g.Record(g.String(), g.String())
}), PAe = g.Union([
  TAe,
  kAe,
  CAe,
  NAe
]), IAe = g.Object({
  pieceName: g.String(),
  pieceVersion: g.String(),
  actionName: g.String(),
  predefinedInput: g.Optional(EAe)
}), RAe = g.Object({
  type: g.Literal(
    "PIECE"
    /* PIECE */
  ),
  ...kH,
  pieceMetadata: IAe
}), MAe = g.Object({
  type: g.Literal(
    "FLOW"
    /* FLOW */
  ),
  ...kH,
  externalFlowId: g.String()
}), DAe = g.Object({
  type: g.Literal(
    "MCP"
    /* MCP */
  ),
  ...kH,
  serverUrl: g.String({ format: "uri" }),
  protocol: g.Enum(Pm),
  auth: PAe
}), wet = SC("type", [
  RAe,
  MAe,
  DAe
]);
var _c = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMBER = "number", e.BOOLEAN = "boolean", e))(_c || {}), iv = /* @__PURE__ */ ((e) => (e.COMPLETED = "COMPLETED", e.FAILED = "FAILED", e.IN_PROGRESS = "IN_PROGRESS", e))(iv || {}), $M = /* @__PURE__ */ ((e) => (e.MARKDOWN = "MARKDOWN", e.TOOL_CALL = "TOOL_CALL", e))($M || {}), tz = /* @__PURE__ */ ((e) => (e.IN_PROGRESS = "in-progress", e.COMPLETED = "completed", e))(tz || {}), KM = /* @__PURE__ */ ((e) => (e.SUCCESS = "SUCCESS", e.FAILED = "FAILED", e))(KM || {}), GM = /* @__PURE__ */ ((e) => (e.PIECE = "PIECE", e.FLOW = "FLOW", e.MCP = "MCP", e))(GM || {});
const xet = g.Object({
  displayName: g.String(),
  description: g.Optional(g.String()),
  type: g.Enum(_c)
});
var bO = /* @__PURE__ */ ((e) => (e.AGENT_TOOLS = "agentTools", e.STRUCTURED_OUTPUT = "structuredOutput", e.PROMPT = "prompt", e.MAX_STEPS = "maxSteps", e.AI_PROVIDER_MODEL = "aiProviderModel", e))(bO || {});
const _Ae = g.Object({
  type: g.Literal(
    "MARKDOWN"
    /* MARKDOWN */
  ),
  markdown: g.String()
}), JF = g.Object({
  type: g.Literal(
    "TOOL_CALL"
    /* TOOL_CALL */
  ),
  input: It(g.Record(g.String(), g.Unknown())),
  output: g.Optional(g.Unknown()),
  toolName: g.String(),
  status: g.Enum(tz),
  toolCallId: g.String(),
  startTime: g.String(),
  endTime: g.Optional(g.String())
}), LAe = SC("toolCallType", [
  g.Object({
    ...JF.properties,
    toolCallType: g.Literal(
      "PIECE"
      /* PIECE */
    ),
    pieceName: g.String(),
    pieceVersion: g.String(),
    actionName: g.String()
  }),
  g.Object({
    ...JF.properties,
    toolCallType: g.Literal(
      "FLOW"
      /* FLOW */
    ),
    displayName: g.String(),
    externalFlowId: g.String()
  }),
  g.Object({
    ...JF.properties,
    toolCallType: g.Literal(
      "MCP"
      /* MCP */
    ),
    displayName: g.String(),
    serverUrl: g.String()
  })
]), Eet = g.Union([_Ae, LAe]), zAe = g.Object({
  name: g.String(),
  description: g.String(),
  state: hAe
}), Tet = g.Object({
  projectId: g.String(),
  name: g.String(),
  description: g.Optional(g.String())
}), ket = g.Composite([
  zAe,
  g.Object({
    projectId: g.String()
  })
]);
var jAe = /* @__PURE__ */ ((e) => (e.COMPLETED = "COMPLETED", e.FAILED = "FAILED", e.INTERNAL_ERROR = "INTERNAL_ERROR", e.TIMED_OUT = "TIMED_OUT", e))(jAe || {});
const Cet = g.Object({
  pieces: g.Record(g.String(), g.Object({
    dailyStats: g.Record(g.String(), g.Object({
      success: g.Number(),
      failure: g.Number()
    })),
    totalRuns: g.Number()
  }))
}), nz = g.Object({
  title: g.String(),
  color: Xbe,
  icon: g.Optional(g.String())
});
var FC = /* @__PURE__ */ ((e) => (e.OFFICIAL = "OFFICIAL", e.SHARED = "SHARED", e.CUSTOM = "CUSTOM", e))(FC || {});
const rz = g.Composite([g.Omit(
  q2,
  ["id", "created", "updated", "flowId", "state", "updatedBy", "agentIds", "connectionIds", "backupFiles", "notes"]
), g.Object({
  description: g.Optional(g.String()),
  //notes were optional for old json templates
  notes: g.Optional(g.Array(Hw))
})]);
var iz = /* @__PURE__ */ ((e) => (e.PUBLISHED = "PUBLISHED", e.ARCHIVED = "ARCHIVED", e))(iz || {});
const FAe = g.Object({
  ...Or,
  name: g.String(),
  type: g.Enum(FC),
  summary: g.String(),
  description: g.String(),
  tags: g.Array(nz),
  blogUrl: It(g.String()),
  metadata: It(Tl),
  usageCount: g.Number(),
  author: g.String(),
  categories: g.Array(g.String()),
  pieces: g.Array(g.String()),
  platformId: It(g.String()),
  flows: g.Optional(g.Array(rz)),
  status: g.Enum(iz)
}), Net = OC(FAe, ["platformId", "id", "created", "updated", "usageCount"]), Pet = g.Object({
  name: g.String(),
  summary: g.String(),
  description: g.String(),
  tags: g.Optional(g.Array(nz)),
  blogUrl: g.Optional(g.String()),
  metadata: It(Tl),
  author: g.String(),
  categories: g.Array(g.String()),
  type: g.Enum(FC),
  flows: g.Optional(g.Array(rz))
}), UAe = g.Object({
  name: g.Optional(g.String()),
  summary: g.Optional(g.String()),
  description: g.Optional(g.String()),
  tags: g.Optional(g.Array(nz)),
  blogUrl: g.Optional(g.String()),
  metadata: It(Tl),
  status: g.Optional(g.Enum(iz)),
  categories: g.Optional(g.Array(g.String())),
  flows: g.Optional(g.Array(rz))
}), Iet = UAe, VAe = g.Object({
  type: g.Optional(g.Enum(FC)),
  pieces: g.Optional(g.Array(g.String())),
  tags: g.Optional(g.Array(g.String())),
  search: g.Optional(g.String()),
  category: g.Optional(g.String())
}), Ret = VAe, Met = g.Object({
  cpu: g.Boolean(),
  disk: g.Boolean(),
  ram: g.Boolean(),
  database: g.Boolean()
});
$i.ExactOptionalPropertyTypes = !1;
const Det = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AIErrorResponse: cJe,
  AIProvider: rJe,
  AIProviderAuthConfig: yH,
  AIProviderConfig: K2,
  AIProviderModel: oJe,
  AIProviderModelType: $2,
  AIProviderName: rv,
  AIProviderWithoutSensitiveData: iJe,
  AI_PIECE_NAME: X2,
  ALL_PRINCIPAL_TYPES: sYe,
  AUTHENTICATION_PROPERTY_NAME: F2,
  AcceptUserInvitationRequest: EJe,
  ActionErrorHandlingOptions: aZ,
  ActivePiecesProviderAuthConfig: tH,
  ActivePiecesProviderConfig: cH,
  ActivepiecesError: vb,
  AddActionRequest: OOe,
  AddBranchRequest: lOe,
  AddNoteRequest: aOe,
  AddPieceRequestBody: FZe,
  AdminRetryRunsRequestBody: eJe,
  AgentFlowTool: MAe,
  AgentMcpTool: DAe,
  AgentOutputField: xet,
  AgentOutputFieldType: _c,
  AgentPieceProps: bO,
  AgentPieceTool: RAe,
  AgentPieceToolMetadata: IAe,
  AgentStepBlock: Eet,
  AgentTaskStatus: iv,
  AgentTool: wet,
  AgentToolType: Wu,
  AiCreditsAutoTopUpState: YZ,
  AnalyticsFlowReport: MOe,
  AnalyticsFlowReportItem: ROe,
  AnalyticsReportRequest: dYe,
  AnalyticsRunsUsage: IOe,
  AnalyticsRunsUsageItem: POe,
  AnalyticsTimePeriod: Z2,
  AnthropicProviderAuthConfig: eH,
  AnthropicProviderConfig: lH,
  ApEdition: Bw,
  ApEnvironment: qM,
  ApFlagId: As,
  ApId: zn,
  ApMultipartFile: _O,
  AppConnectionOwners: OHe,
  AppConnectionScope: _u,
  AppConnectionStatus: z2,
  AppConnectionType: Mn,
  AppConnectionWithoutSensitiveData: bHe,
  ApplyLicenseKeyByEmailRequestBody: tJe,
  AuthenticationResponse: nYe,
  AzureProviderAuthConfig: iH,
  AzureProviderConfig: pH,
  BADGES: IR,
  BOTH_CLIENT_CREDENTIALS_AND_AUTHORIZATION_CODE: nv,
  BadgeAwarded: bJe,
  Base64EncodedFile: YYe,
  BaseAIProviderAuthConfig: xh,
  BaseModelSchema: Or,
  BranchCondition: p0e,
  BranchDateCondition: uHe,
  BranchExecutionType: iu,
  BranchNumberCondition: cHe,
  BranchOperator: Gr,
  BranchSingleValueCondition: dHe,
  BranchTextCondition: lHe,
  BulkActionOnRunsRequestBody: mYe,
  BulkArchiveActionOnRunsRequestBody: yYe,
  BulkCancelFlowRequestBody: gYe,
  CancelTestTriggerRequestBody: DYe,
  Cell: oAe,
  ChangeFolderRequest: mOe,
  ChangeNameRequest: gOe,
  ChangePublishedVersionIdRequest: xOe,
  ChatFormResponse: HYe,
  ChatUIProps: zOe,
  ChatUIResponse: PYe,
  ClaimTokenRequest: $Ye,
  CloudflareGatewayProviderAuthConfig: rH,
  CloudflareGatewayProviderConfig: fH,
  CodeActionSchema: CC,
  CodeActionSettings: s0e,
  ColorHex: Xbe,
  ColorName: XZ,
  ConnectionExpiredError: $He,
  ConnectionLoadingError: QHe,
  ConnectionNotFoundError: HHe,
  ConnectionOperation: EH,
  ConnectionOperationType: dAe,
  ConnectionState: bE,
  ConsumeJobRequest: CJe,
  ConsumeJobResponse: NJe,
  ConsumeJobResponseStatus: AH,
  ContentBlockType: $M,
  CountFlowsRequest: tYe,
  CreateAIProviderRequest: sJe,
  CreateAndWaitTodoResult: set,
  CreateFieldRequest: WJe,
  CreateFlowRequest: vYe,
  CreateFolderRequest: SYe,
  CreateMCPServerFromStepParams: CYe,
  CreateProjectReleaseFromGitRequestBody: aAe,
  CreateProjectReleaseFromProjectRequestBody: cAe,
  CreateProjectReleaseFromRollbackRequestBody: lAe,
  CreateProjectReleaseRequestBody: JJe,
  CreateProjectRoleRequestBody: RJe,
  CreateRecordsRequest: QJe,
  CreateStepRunRequestBody: eHe,
  CreateTableRequest: FJe,
  CreateTableWebhookRequest: VJe,
  CreateTemplateRequestBody: Pet,
  CreateTodoActivityRequestBody: yet,
  CreateTodoRequestBody: het,
  CreateTodoResult: aet,
  CreateTrialLicenseKeyRequestBody: wJe,
  CustomNpmPiecePackage: QW,
  DATA_TYPE_KEY_IN_FILE_METADATA: YZe,
  DEFAULT_MCP_DATA: XHe,
  DEFAULT_SAMPLE_DATA_SETTINGS: i0e,
  DefaultProjectRole: qOe,
  DelayPauseMetadata: T0e,
  DeleteActionRequest: yOe,
  DeleteBranchRequest: iOe,
  DeleteFolderRequest: TYe,
  DeleteNoteRequest: sOe,
  DeleteRecordsRequest: GJe,
  DeleteStoreEntryRequest: JGe,
  DiffReleaseRequest: eet,
  DiffState: ret,
  DiscriminatedUnion: SC,
  DuplicateBranchRequest: dOe,
  DuplicateStepRequest: vOe,
  ERROR_MESSAGES_TO_REDACT: WHe,
  EXACT_VERSION_PATTERN: $W,
  EXACT_VERSION_REGEX: NZe,
  EmailType: fZ,
  EmptyTrigger: xZ,
  EndpointScope: NOe,
  EngineGenericError: iQe,
  EngineHttpResponse: IHe,
  EngineOperationType: A0e,
  EngineResponseStatus: S0e,
  EngineSocketEvent: w0e,
  EngineStderr: PHe,
  EngineStdout: NHe,
  ErrorCode: Ni,
  ExactVersionType: xv,
  ExecuteExtractPieceMetadataJobData: NZ,
  ExecuteFlowJobData: z0e,
  ExecutePropertyJobData: CZ,
  ExecuteTriggerHookJobData: kZ,
  ExecuteValidateAuthJobData: TZ,
  ExecutionError: gc,
  ExecutionErrorType: R0e,
  ExecutionMode: M0e,
  ExecutionState: oQe,
  ExecutionToolStatus: KM,
  ExecutionType: EZ,
  ExportRequestBody: Tet,
  ExportTableResponse: UJe,
  FAILED_STATES: N0e,
  FAIL_PARENT_ON_FAILURE_HEADER: DHe,
  FailedStep: P0e,
  FederatedAuthnProviderConfig: $Z,
  FederatedAuthnProviderConfigWithoutSensitiveData: XOe,
  FetchError: nQe,
  Field: nAe,
  FieldControlMode: Cc,
  FieldState: pAe,
  FieldType: yO,
  File: n0e,
  FileCompression: iZ,
  FileLocation: oZ,
  FileResponseInterface: HM,
  FileSizeError: tQe,
  FileStoreError: JHe,
  FileType: rZ,
  Filter: iAe,
  FilterOperator: wH,
  FilteredPieceBehavior: Q2,
  Flow: DZ,
  FlowAction: fHe,
  FlowActionType: qe,
  FlowOperationRequest: KGe,
  FlowOperationStatus: MZ,
  FlowOperationType: Tt,
  FlowProjectOperation: yAe,
  FlowProjectOperationType: uAe,
  FlowRetryStrategy: qA,
  FlowRun: _He,
  FlowRunStatus: cr,
  FlowState: KS,
  FlowStatus: il,
  FlowSyncError: gAe,
  FlowTrigger: V2,
  FlowTriggerType: Bt,
  FlowVersion: q2,
  FlowVersionMetadata: BHe,
  FlowVersionState: Lo,
  FlowVersionTemplate: rz,
  Folder: xYe,
  FormInput: _Oe,
  FormInputType: BZ,
  FormProps: LOe,
  FormResponse: NYe,
  GenericStepOutput: Mp,
  GetAppConnectionForWorkerRequestQuery: AHe,
  GetFlowQueryParamsRequest: LYe,
  GetFlowVersionForWorkerRequest: VHe,
  GetPieceRequestParams: RZe,
  GetPieceRequestQuery: LZe,
  GetPieceRequestWithScopeParams: IZe,
  GetProviderConfigResponse: lJe,
  GetSampleDataRequest: JZe,
  GetStoreEntryRequest: YGe,
  GetSystemHealthChecksResponse: Met,
  GithubAuthnProviderConfig: QZ,
  GoogleAuthnProviderConfig: HZ,
  GoogleProviderAuthConfig: oH,
  GoogleProviderConfig: hH,
  HumanInputFormResult: ZYe,
  HumanInputFormResultTypes: QM,
  ImportFlowRequest: hOe,
  IncreaseAICreditsForPlatformRequestBody: nJe,
  InvalidCronExpressionError: rQe,
  InvitationStatus: Y2,
  InvitationType: G2,
  JOB_PRIORITY: aQe,
  JobData: U0e,
  LATEST_FLOW_SCHEMA_VERSION: qHe,
  LATEST_JOB_DATA_SCHEMA_VERSION: sQe,
  LeaderboardRequest: fYe,
  LicenseKeyEntity: YOe,
  ListAppConnectionOwnersRequestQuery: xHe,
  ListAppConnectionsRequestQuery: O0e,
  ListFieldsRequestQuery: HJe,
  ListFlowRunsRequestQuery: vQe,
  ListFlowTemplatesRequestQuery: VAe,
  ListFlowVersionRequest: zYe,
  ListFlowsFromAppConnectionRequestQuery: CHe,
  ListFlowsRequest: _Ye,
  ListFolderRequest: kYe,
  ListGlobalConnectionsRequestQuery: wHe,
  ListPiecesRequestQuery: MZe,
  ListProjectMembersForProjectRoleRequestQuery: DJe,
  ListProjectReleasesRequest: tet,
  ListRecordsRequest: KJe,
  ListTablesRequest: BJe,
  ListTagsRequest: fJe,
  ListTemplatesRequestQuery: Ret,
  ListTodoActivitiesQueryParams: get,
  ListTodoAssigneesRequestQuery: fet,
  ListTodosQueryParams: det,
  ListTriggerEventsRequest: OYe,
  ListUserInvitationsRequest: TJe,
  ListUsersRequestBody: vHe,
  ListVersionRequestQuery: _Ze,
  ListVersionsResponse: zZe,
  LocalesEnum: Wi,
  LockFlowRequest: pOe,
  LoopOnItemsActionSchema: PC,
  LoopOnItemsActionSettings: a0e,
  LoopStepOutput: mO,
  MAX_KEY_LENGTH_FOR_CORWDIN: e0e,
  MCP_TRIGGER_PIECE_NAME: vet,
  MachineInformation: OH,
  MarkdownContentBlock: _Ae,
  MarkdownVariant: gs,
  McpAuthAccessToken: kAe,
  McpAuthApiKey: CAe,
  McpAuthConfig: PAe,
  McpAuthHeaders: NAe,
  McpAuthNone: TAe,
  McpAuthType: xi,
  McpProperty: wAe,
  McpPropertyType: Kd,
  McpProtocol: Pm,
  McpServer: AAe,
  McpServerStatus: ez,
  McpTrigger: Aet,
  Metadata: Tl,
  MoveActionRequest: bOe,
  MoveBranchRequest: cOe,
  NON_SCHEDULED_JOB_TYPES: hQe,
  Note: Hw,
  NoteColorVariant: di,
  Nullable: It,
  NullableEnum: UA,
  OAuth2GrantType: Xs,
  OfficialPiecePackage: HW,
  OpenAICompatibleProviderAuthConfig: nH,
  OpenAICompatibleProviderConfig: dH,
  OpenAIProviderAuthConfig: sH,
  OpenAIProviderConfig: mH,
  OpenRouterProviderAuthConfig: aH,
  OpenRouterProviderConfig: gH,
  PARENT_RUN_ID_HEADER: MHe,
  PROJECT_COLOR_PALETTE: qYe,
  PackageType: VA,
  PasswordType: pZ,
  PauseMetadata: bZ,
  PauseType: E0e,
  PausedFlowTimeoutError: eQe,
  Permission: Es,
  PieceActionSchema: NC,
  PieceActionSettings: lZ,
  PieceCategory: Of,
  PieceOptionRequest: jZe,
  PieceOrderBy: GW,
  PiecePackage: C2,
  PieceScope: Zbe,
  PieceSortBy: KW,
  PieceSyncMode: t0e,
  PieceTag: dJe,
  PieceTrigger: U2,
  PieceTriggerSettings: wZ,
  PieceType: k2,
  PiecesFilterType: WZ,
  PlanName: ZOe,
  Platform: QOe,
  PlatformAnalyticsReport: lYe,
  PlatformBillingInformation: GYe,
  PlatformPlan: JZ,
  PlatformPlanLimits: HOe,
  PlatformRole: bb,
  PlatformUsage: KZ,
  PlatformUsageMetric: WOe,
  PlatformWithoutSensitiveData: KYe,
  PollingJobData: L0e,
  PopulatedFlow: _C,
  PopulatedMcpServer: bet,
  PopulatedRecord: YJe,
  PopulatedTable: zJe,
  PopulatedTodo: cet,
  PopulatedTriggerSource: OQe,
  PredefinedInputField: SAe,
  PredefinedInputsStructure: EAe,
  PrincipalType: qZ,
  PrivatePiecePackage: Wbe,
  ProgressUpdateType: Zw,
  Project: UOe,
  ProjectIcon: FOe,
  ProjectLeaderboardItem: cYe,
  ProjectMetaData: UYe,
  ProjectOperation: mAe,
  ProjectPlan: jOe,
  ProjectRelease: net,
  ProjectReleaseType: xH,
  ProjectRole: JOe,
  ProjectState: hAe,
  ProjectSyncPlan: iet,
  ProjectType: H2,
  ProjectWithLimits: VOe,
  ProjectWithLimitsWithPlatform: VYe,
  PropertyExecutionType: dc,
  PropertySettings: nZ,
  ProviderModelConfig: uH,
  PublicPiecePackage: CZe,
  PutStoreEntryRequest: GGe,
  QueueMetricsResponse: gQe,
  RATE_LIMIT_PRIORITY: dQe,
  RESOLVED_STATUS: oet,
  Record: sAe,
  RegistryPiecesRequestQuery: DZe,
  RenewWebhookJobData: _0e,
  ReplaceAppConnectionsRequestBody: kHe,
  ResolveTodoRequestQuery: met,
  RespondResponse: k0e,
  RetryFlowRequestBody: hYe,
  RoleType: ZW,
  RouterActionSchema: L2,
  RouterActionSettings: uZ,
  RouterActionSettingsWithValidation: h0e,
  RouterBranchesSchema: _2,
  RouterExecutionType: ah,
  RouterStepOutput: PZ,
  RunEnvironment: eg,
  SAFE_STRING_PATTERN: wv,
  SAMLAuthnProviderConfig: BOe,
  SERVICE_KEY_SECURITY_OPENAPI: aYe,
  STATUS_COLORS: qq,
  STATUS_VARIANT: Vp,
  STORE_KEY_MAX_LENGTH: SZ,
  STORE_VALUE_MAX_SIZE: ZHe,
  SUPPORTED_AI_PROVIDERS: $Oe,
  SampleDataDataType: wy,
  SampleDataFileType: Jm,
  SampleDataSetting: M2,
  SaveSampleDataRequest: r0e,
  SaveSampleDataResponse: nHe,
  SaveTriggerEventRequest: AYe,
  ScheduleOptions: B0e,
  SeekPage: bYe,
  SendFlowResponseRequest: UHe,
  SendUserInvitationRequest: SJe,
  SetPieceTagsRequest: pJe,
  SharedTemplate: Net,
  SignInRequest: oYe,
  SignUpRequest: rYe,
  SingleActionSchema: dZ,
  SkipActionRequest: uOe,
  Solution: zAe,
  SolutionRequestBody: ket,
  SourceCode: o0e,
  StaticDropdownEmptyOption: LJe,
  StatusOption: TT,
  StepExecutionPath: tHe,
  StepFileUpsertRequest: IYe,
  StepFileUpsertResponse: RYe,
  StepLocationRelativeToParent: Hn,
  StepOutputStatus: po,
  StepRunResponse: sZ,
  StopResponse: RHe,
  StorageError: YHe,
  StorageInvalidKeyError: GHe,
  StorageLimitError: KHe,
  SuggestionType: OT,
  SwitchPlatformRequest: iYe,
  TASK_COMPLETION_TOOL_NAME: xAe,
  Table: rAe,
  TableAutomationStatus: zC,
  TableAutomationTrigger: LC,
  TableOperation: TH,
  TableOperationType: fAe,
  TableState: vO,
  TableWebhook: jJe,
  TableWebhookEventType: J2,
  Tag: uJe,
  TeamProjectsLimit: GZ,
  TelemetryEventName: Ww,
  Template: FAe,
  TemplateStatus: iz,
  TemplateTag: nz,
  TemplateType: FC,
  TestFlowRunRequestBody: pYe,
  TestTriggerRequestBody: MYe,
  ThirdPartyAuthnProviderEnum: ZZ,
  Todo: vAe,
  TodoActivity: bAe,
  TodoActivityChanged: yJe,
  TodoActivityCreated: vJe,
  TodoActivityWithUser: uet,
  TodoChanged: gJe,
  TodoEnvironment: jC,
  TodoType: $s,
  ToolCallContentBlock: LAe,
  ToolCallStatus: tz,
  ToolCallType: GM,
  TriggerEvent: DOe,
  TriggerEventWithPayload: wYe,
  TriggerHookType: vZ,
  TriggerPayload: x0e,
  TriggerRunStatus: jAe,
  TriggerSource: RZ,
  TriggerSourceScheduleType: IZ,
  TriggerStatusReport: Cet,
  TriggerStrategy: hf,
  TriggerTestStrategy: $l,
  UNRESOLVED_STATUS: WA,
  USE_DRAFT_QUERY_PARAM_NAME: Vq,
  UncategorizedFolderId: ZM,
  UpdateAIProviderRequest: aJe,
  UpdateActionRequest: UZ,
  UpdateConnectionValueRequestBody: SHe,
  UpdateFieldRequest: ZJe,
  UpdateFlowStatusRequest: wOe,
  UpdateFlowTemplateRequestBody: UAe,
  UpdateFolderRequest: EYe,
  UpdateGlobalConnectionValueRequestBody: EHe,
  UpdateMcpServerRequest: Oet,
  UpdateMetadataRequest: SOe,
  UpdateMinutesSavedRequest: EOe,
  UpdateNoteRequest: oOe,
  UpdateOwnerRequest: TOe,
  UpdatePlatformRequestBody: JYe,
  UpdateProjectRequestInCommunity: FYe,
  UpdateProjectRoleRequestBody: MJe,
  UpdateRecordRequest: $Je,
  UpdateRunProgressRequest: LHe,
  UpdateStepProgressRequest: zHe,
  UpdateTableRequest: qJe,
  UpdateTemplateRequestBody: Iet,
  UpdateTemplatesCategoriesFlagRequestBody: yQe,
  UpdateTodoRequestBody: pet,
  UpdateTriggerRequest: AOe,
  UpdateUserRequestBody: yHe,
  UploadLogsBehavior: AZ,
  UploadLogsQueryParams: jHe,
  UploadLogsToken: FHe,
  UpsertAppConnectionRequestBody: _q,
  UpsertBasicAuthRequest: MC,
  UpsertCloudOAuth2Request: wT,
  UpsertCustomAuthRequest: j2,
  UpsertGlobalConnectionRequestBody: THe,
  UpsertNoAuthRequest: gZ,
  UpsertOAuth2Request: xT,
  UpsertPlatformOAuth2Request: AT,
  UpsertSecretTextRequest: Xw,
  UpsertTagRequest: hJe,
  UseAsDraftRequest: fOe,
  User: b0e,
  UserBadge: v0e,
  UserIdentity: kOe,
  UserIdentityProvider: VZ,
  UserInteractionJobData: F0e,
  UserInteractionJobDataWithoutWatchingInformation: mQe,
  UserInvitation: eAe,
  UserInvitationWithLink: xJe,
  UserLeaderboardItem: uYe,
  UserStatus: RC,
  UserWithBadges: gHe,
  UserWithMetaInformation: lh,
  UserWithoutPassword: COe,
  ValidBranchCondition: aHe,
  VerifyLicenseKeyRequestBody: AJe,
  VersionType: EC,
  WebhookHandshakeConfiguration: q0e,
  WebhookHandshakeStrategy: LO,
  WebhookJobData: j0e,
  WebhookPauseMetadata: C0e,
  WebhookUrlParams: eYe,
  WebsocketClientEvent: pi,
  WebsocketServerEvent: vH,
  WorkerJobStats: V0e,
  WorkerJobType: D0e,
  WorkerMachine: tAe,
  WorkerMachineHealthcheckRequest: PJe,
  WorkerMachineStatus: bH,
  WorkerMachineWithStatus: kJe,
  WorkerSettingsResponse: IJe,
  _getOperationsForPaste: rOe,
  apId: IC,
  applyFunctionToValues: Rq,
  applyFunctionToValuesSync: bT,
  asserNotEmpty: EZe,
  assertEqual: AZe,
  assertNotEqual: wZe,
  assertNotNullOrUndefined: qm,
  assertNull: SZe,
  camelCase: lZe,
  chunk: uZe,
  createKeyForFormInput: WYe,
  debounce: Fbe,
  deepMergeAndCast: hy,
  deleteProperties: mZe,
  deleteProps: vZe,
  emitWithAck: mJe,
  emptyCondition: vE,
  extractPieceFromModule: KZe,
  federatedAuthnLoginResponse: QYe,
  feedbackUrl: GOe,
  flowExecutionStateKey: bQe,
  flowOperations: Uu,
  flowPieceUtil: Ic,
  flowStructureUtil: At,
  getDefaultJobPriority: pQe,
  getPackageAliasForPiece: HZe,
  getPieceMajorAndMinorVersion: GZe,
  getPieceNameFromAlias: QZe,
  groupBy: OZe,
  insertAt: Iq,
  isEmpty: Ube,
  isFailedState: OZ,
  isFlowRunStateTerminal: DC,
  isMultipartFile: TZe,
  isNil: De,
  isNotUndefined: xZe,
  isObject: Qp,
  isString: xC,
  kebabCase: sZe,
  logSerializer: _Je,
  mapsAreSame: pZe,
  omit: gZe,
  parseToJsonIfPossible: Vbe,
  partition: dZe,
  pickBy: cZe,
  resolveValueFromProps: Dq,
  sanitizeObjectForPostgresql: bZe,
  secureApId: mHe,
  setAtPath: jbe,
  singleValueConditions: Mq,
  spreadIfDefined: qbe,
  spreadIfNotUndefined: yZe,
  startCase: aZe,
  supportUrl: OJe,
  textConditions: l0e,
  trimVersionFromAlias: $Ze,
  tryCatch: Bbe,
  tryCatchSync: kZe,
  unique: fZe,
  validateIndexBound: hZe
}, Symbol.toStringTag, { value: "Module" })), mne = {
  "An unexpected error occurred. Please try again in a moment.": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى بعد قليل.",
  "Are you sure?": "هل أنت متأكد؟",
  Back: "رجوع",
  Cancel: "إلغاء",
  Close: "إغلاق",
  "Close Sidebar": "إغلاق الشريط الجانبي",
  "Client ID": "معرّف العميل",
  "Client Secret": "سر العميل",
  Connect: "اتصال",
  "Connect to {displayName}": "الاتصال بـ {{displayName}}",
  Connection: "الاتصال",
  "Connection Name": "اسم الاتصال",
  "Connection name": "اسم الاتصال",
  Confirm: "تأكيد",
  "Create Connection": "إنشاء اتصال",
  "Custom OAuth2 App (Advanced)": "تطبيق OAuth2 مخصص (متقدم)",
  "Data Selector": "محدد البيانات",
  Disconnect: "قطع الاتصال",
  "Discard changes": "تجاهل التغييرات",
  "Discarding changes...": "جارٍ تجاهل التغييرات...",
  "External ID": "المعرّف الخارجي",
  Flow: "نظام العمل الذكي",
  "Flow not found": "لم يتم العثور على نظام العمل الذكي",
  "{{name}} has been exported.": "تم تصدير {{name}}.",
  "Flows have been exported.": "تم تصدير أنظمة العمل الذكية.",
  "Go to Dashboard": "الذهاب إلى لوحة التحكم",
  Export: "تصدير",
  Exporting: "جارٍ التصدير...",
  Import: "استيراد",
  "Import Flow": "استيراد نظام العمل الذكي",
  "Import flow": "استيراد نظام العمل الذكي",
  "Importing a flow will overwrite your current one.": "سيؤدي استيراد نظام العمل الذكي إلى استبدال نظام العمل الذكي الحالي.",
  Language: "اللغة",
  "Loading...": "جارٍ التحميل...",
  mins: "دقائق",
  hours: "ساعات",
  milliseconds: "مللي ثانية",
  minutes: "دقائق",
  min: "د",
  ms: "مللي ثانية",
  Next: "التالي",
  "Next step": "الخطوة التالية",
  "New Connection": "اتصال جديد",
  "No flow id provided": "لم يتم توفير معرّف نظام العمل الذكي",
  "No language found.": "لم يتم العثور على لغة.",
  "No matching data": "لا توجد بيانات مطابقة",
  "No pieces found": "لم يتم العثور على خدمات",
  "No runs found": "لم يتم العثور على أي تشغيلات",
  "No valid templates found. The following files failed to import: ": "لم يتم العثور على قوالب صالحة. فشلت الملفات التالية في الاستيراد: ",
  "Open Sidebar": "فتح الشريط الجانبي",
  "Please select a file first": "يرجى اختيار ملف أولاً",
  "Previous step": "الخطوة السابقة",
  Publish: "نشر",
  "Publishing...": "جارٍ النشر...",
  "OAuth2 (Recommended)": "OAuth2 (موصى به)",
  "Quickly connect using a preconfigured OAuth2 app. No setup required.": "اتصل بسرعة باستخدام تطبيق OAuth2 مُعد مسبقاً. لا يلزم أي إعداد.",
  "Recent Runs": "أحدث التشغيلات",
  Reconnect: "إعادة الاتصال",
  "Reconnect {displayName} Connection": "إعادة اتصال {{displayName}}",
  "Redirect URL": "رابط إعادة التوجيه",
  Rename: "إعادة التسمية",
  Runs: "التشغيلات",
  s: "ث",
  Save: "حفظ",
  "Saving...": "جارٍ الحفظ...",
  Send: "إرسال",
  Search: "بحث",
  "Search language...": "ابحث عن لغة...",
  seconds: "ثوانٍ",
  "Select a file": "اختر ملفاً",
  "Select language": "اختر اللغة",
  "Select a folder": "اختر مجلداً",
  "Select a connection": "اختر اتصالاً",
  "Select an Authentication Method": "اختر طريقة المصادقة",
  "Server-to-Server (Client Credentials)": "من خادم إلى خادم (بيانات اعتماد العميل)",
  "Authenticate securely from your server using the Client Credentials flow. Ideal for backend integrations.": "صادِق بأمان من الخادم باستخدام تدفق بيانات اعتماد العميل. مثالي للتكاملات الخلفية.",
  "Something went wrong": "حدث خطأ ما",
  "Something went wrong. Please try again.": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "Something went wrong and there are unsaved changes, please refresh and contact support if the problem persists.": "حدث خطأ وهناك تغييرات غير محفوظة. يرجى تحديث الصفحة والتواصل مع الدعم إذا استمرت المشكلة.",
  "Step Icon": "أيقونة الخطوة",
  "This will permanently delete the connection": "سيؤدي هذا إلى حذف الاتصال نهائياً",
  Today: "اليوم",
  "Toggle Sidebar": "تبديل الشريط الجانبي",
  Trigger: "المشغّل",
  "Try another method": "جرّب طريقة أخرى",
  "Try adjusting your search": "جرّب تعديل البحث",
  Uncategorized: "غير مصنف",
  "Unsaved Changes": "تغييرات غير محفوظة",
  Version: "الإصدار",
  "Version History": "سجل الإصدارات",
  Versions: "الإصدارات",
  View: "عرض",
  "Unsupported file type": "نوع الملف غير مدعوم",
  Yesterday: "أمس",
  "You have unpublished changes": "لديك تغييرات غير منشورة",
  Folders: "المجلدات",
  "Connect using your own OAuth2 credentials for more flexibility and control.": "اتصل باستخدام بيانات اعتماد OAuth2 الخاصة بك لمزيد من المرونة والتحكم.",
  flowsImported: "تم استيراد {{flowsCount}} من أنظمة العمل الذكية بنجاح"
}, gne = {
  "An unexpected error occurred. Please try again in a moment.": "هەڵەیەکی چاوەڕواننەکراو ڕوویدا. تکایە دوای چەند چرکەیەک دووبارە هەوڵ بدەرەوە.",
  "Are you sure?": "دڵنیایت؟",
  Back: "گەڕانەوە",
  Cancel: "هەڵوەشاندنەوە",
  Close: "داخستن",
  "Close Sidebar": "داخستنی شریتی لاتەنیشت",
  "Client ID": "Client ID",
  "Client Secret": "Client Secret",
  Connect: "پەیوەستکردن",
  "Connect to {displayName}": "پەیوەستکردن بە {{displayName}}",
  Connection: "پەیوەندی",
  "Connection Name": "ناوی پەیوەندی",
  "Connection name": "ناوی پەیوەندی",
  Confirm: "پەسەندکردن",
  "Create Connection": "دروستکردنی پەیوەندی",
  "Custom OAuth2 App (Advanced)": "ئەپی OAuth2 ی دڵخواز (پێشکەوتوو)",
  "Data Selector": "هەڵبژێرەری داتا",
  Disconnect: "پچڕاندنی پەیوەندی",
  "Discard changes": "ڕەتکردنەوەی گۆڕانکارییەکان",
  "Discarding changes...": "ڕەتکردنەوەی گۆڕانکارییەکان...",
  "External ID": "ناسنامەی دەرەکی",
  Flow: "فلۆ",
  "Flow not found": "فلۆ نەدۆزرایەوە",
  "{{name}} has been exported.": "{{name}} نێردرایە دەرەوە.",
  "Flows have been exported.": "فلۆکان نێردرانە دەرەوە.",
  "Go to Dashboard": "چوونە داشبۆرد",
  Export: "ناردنە دەرەوە",
  Exporting: "ناردنە دەرەوە...",
  Import: "هێنانە ناوەوە",
  "Import Flow": "هێنانە ناوەوەی فلۆ",
  "Import flow": "هێنانە ناوەوەی فلۆ",
  "Importing a flow will overwrite your current one.": "هێنانە ناوەوەی فلۆیەک شوێنی ئەوەی ئێستات دەگرێتەوە.",
  Language: "زمان",
  "Loading...": "بارکردن...",
  mins: "خولەک",
  hours: "کاتژمێر",
  milliseconds: "میلی‌چرکە",
  minutes: "خولەک",
  min: "خولەک",
  ms: "ms",
  Next: "دواتر",
  "Next step": "هەنگاوی دواتر",
  "New Connection": "پەیوەندی نوێ",
  "No flow id provided": "هیچ ناسنامەیەکی فلۆ دابین نەکراوە",
  "No language found.": "هیچ زمانێک نەدۆزرایەوە.",
  "No matching data": "هیچ داتایەکی گونجاو نەدۆزرایەوە",
  "No pieces found": "هیچ Piece نەدۆزرایەوە",
  "No runs found": "هیچ جێبەجێکردنێک نەدۆزرایەوە",
  "No valid templates found. The following files failed to import:": "هیچ داڕێژەیەکی گونجاو نەدۆزرایەوە. ئەم فایلانەی خوارەوە نەهێنرانە ناوەوە:",
  "Open Sidebar": "کردنەوەی شریتی لاتەنیشت",
  "Please select a file first": "تکایە سەرەتا فایلێک هەڵبژێرە",
  "Previous step": "هەنگاوی پێشوو",
  Publish: "بڵاوکردنەوە",
  "Publishing...": "بڵاوکردنەوە...",
  "OAuth2 (Recommended)": "OAuth2 (پێشنیارکراو)",
  "Quickly connect using a preconfigured OAuth2 app. No setup required.": "بە خێرایی پەیوەست ببە بە ئەپێکی OAuth2 ی پێشوەخت ڕێکخراو. پێویستی بە ڕێکخستن نییە.",
  "Recent Runs": "کارپێکردنەکانی دوایی",
  Reconnect: "پەیوەستکردنەوە",
  "Reconnect {displayName} Connection": "پەیوەستکردنەوەی پەیوەندی {{displayName}}",
  "Redirect URL": "بەستەری ئاڕاستەکردنەوە",
  Rename: "گۆڕینی ناو",
  Runs: "کارپێکردنەکان",
  s: "s",
  Save: "پاشەکەوتکردن",
  "Saving...": "پاشەکەوتکردن...",
  Send: "ناردن",
  Search: "گەڕان",
  "Search language...": "گەڕان بۆ زمان...",
  seconds: "چرکە",
  "Select a file": "پەڕگەیەک هەڵبژێرە",
  "Select language": "زمان هەڵبژێرە",
  "Select a folder": "فۆڵدەرێک هەڵبژێرە",
  "Select a connection": "پەیوەندییەک هەڵبژێرە",
  "Select an Authentication Method": "ڕێگەیەکی چەسپاندنی ناسنامە هەڵبژێرە",
  "Server-to-Server (Client Credentials)": "سێرڤەر-بۆ-سێرڤەر (Client Credentials)",
  "Authenticate securely from your server using the Client Credentials flow. Ideal for backend integrations.": "بە پارێزراوی لە سێرڤەرەکەتەوە ناسنامە پشتراستبکەوە بە بەکارهێنانی پرۆسەی Client Credentials. گونجاوە بۆ یەکخستنی بەشی پشتەوە (backend).",
  "Something went wrong": "هەڵەیەک ڕوویدا",
  "Something went wrong. Please try again.": "هەڵەیەک ڕوویدا. تکایە دووبارە هەوڵ بدەرەوە.",
  "Something went wrong and there are unsaved changes, please refresh and contact support if the problem persists.": "هەڵەیەک ڕوویدا و گۆڕانکاری پاشەکەوتنەکراو هەیە. تکایە پەڕەکە نوێ بکەرەوە، پەیوەندی بە پاڵپشتییەوە بکە ئەگەر کێشەکە بەردەوام بوو.",
  "Step Icon": "ئایکۆنی هەنگاو",
  "This will permanently delete the connection": "پەیوەندییەکە بە یەکجاری دەسڕێتەوە",
  Today: "ئەمڕۆ",
  "Toggle Sidebar": "کردنەوە/داخستنی شریتی لا",
  Trigger: "Trigger(پەلەپیتکە)",
  "Try another method": "ڕێگەیەکی تر تاقی بکەرەوە",
  "Try adjusting your search": "هەوڵی گۆڕینی گەڕانەکەت بدە",
  Uncategorized: "پۆلێننەکراو",
  "Unsaved Changes": "گۆڕانکارییە پاشەکەوتنەکراوەکان",
  Version: "وەشان",
  "Version History": "مێژووی وەشان",
  Versions: "وەشانەکان",
  View: "پیشاندان",
  "Unsupported file type": "جۆری پەڕگە پشتگیری ناکرێت",
  Yesterday: "دوێنێ",
  "You have unpublished changes": "گۆڕانکاری بڵاونەکراوەت هەیە",
  Folders: "فۆڵدەرەکان",
  "Connect using your own OAuth2 credentials for more flexibility and control.": "پەیوەست ببە بە بەکارهێنانی ناسنامەکانی OAuth2 ی خۆت بۆ نەرمی و کۆنترۆڵی زیاتر.",
  flowsImported: "لێشاوهاوردەکراو"
}, kT = Wi.ENGLISH, _et = /* @__PURE__ */ new Set([
  Wi.ARABIC,
  Wi.KURDISH_SORANI
]), Bq = Object.values(Wi);
let yne = !1;
const Let = (e, t = {}) => e.replace(/{([^}]+)}/g, (n, r) => t[r] !== void 0 ? String(t[r]) : `{${r}}`), UC = (e) => {
  const t = e == null ? void 0 : e.trim();
  if (!t)
    return kT;
  const n = Bq.find(
    (o) => o === t
  );
  if (n)
    return n;
  const r = t.split("-")[0];
  return Bq.find(
    (o) => o.toLowerCase() === r.toLowerCase()
  ) ?? kT;
}, CH = (e) => _et.has(UC(e)) ? "rtl" : "ltr", qAe = () => {
  if (typeof window > "u")
    return kT;
  const e = [
    document.documentElement.lang,
    window.localStorage.getItem("i18nextLng"),
    ...window.navigator.languages ?? [],
    window.navigator.language
  ];
  for (const t of e)
    if (t != null && t.trim())
      return UC(t);
  return kT;
}, YM = (e) => {
  const t = UC(e);
  if (typeof document < "u") {
    const n = document.documentElement;
    n.lang = t, n.dir = CH(t);
  }
  if (typeof window < "u")
    try {
      window.localStorage.setItem("i18nextLng", t);
    } catch {
    }
  return t;
};
if (!ur.isInitialized)
  ur.use(lBe).init({
    resources: {
      en: { translation: {} },
      ar: { translation: mne },
      ckb: { translation: gne }
    },
    lng: qAe(),
    fallbackLng: kT,
    supportedLngs: Bq,
    keySeparator: !1,
    nsSeparator: !1,
    returnNull: !1,
    returnEmptyString: !1,
    interpolation: {
      escapeValue: !1
    }
  });
else {
  const e = {
    [Wi.ARABIC]: mne,
    [Wi.KURDISH_SORANI]: gne
  };
  for (const [t, n] of Object.entries(e))
    ur.hasResourceBundle(t, "translation") || ur.addResourceBundle(t, "translation", n, !0, !0);
}
typeof window < "u" && !yne && (ur.on("languageChanged", YM), yne = !0);
YM(ur.resolvedLanguage ?? ur.language);
const Z = (e, t = {}) => {
  const n = ur.t(e, t);
  return n === e ? Let(e, t) : n;
};
ur.language;
const e5 = (e) => {
  const t = e.trim().toLowerCase(), n = t.startsWith("ar") || t.startsWith("ckb");
  document.documentElement.dir = n ? "rtl" : "ltr", document.documentElement.lang = e;
}, zet = () => {
  const e = localStorage.getItem("i18nextLng") || "en";
  ur.changeLanguage(e), e5(e), window.addEventListener("languageChanged", (t) => {
    const n = t.detail;
    ur.changeLanguage(n), e5(n);
  }), window.addEventListener("storage", (t) => {
    if (t.key === "i18nextLng") {
      const n = t.newValue || "en";
      ur.changeLanguage(n), e5(n);
    }
  });
}, jet = {}, vne = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (u, f) => {
    const d = typeof u == "function" ? u(t) : u;
    if (!Object.is(d, t)) {
      const p = t;
      t = f ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((h) => h(t, p));
    }
  }, i = () => t, c = { setState: r, getState: i, getInitialState: () => a, subscribe: (u) => (n.add(u), () => n.delete(u)), destroy: () => {
    (jet ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, a = t = e(r, i, c);
  return c;
}, BAe = (e) => e ? vne(e) : vne;
var gP = { exports: {} }, t5 = {}, yP = { exports: {} }, n5 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bne;
function Fet() {
  if (bne) return n5;
  bne = 1;
  var e = ie;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, s = e.useDebugValue;
  function l(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), m = h[0].inst, v = h[1];
    return o(function() {
      m.value = p, m.getSnapshot = d, c(m) && v({ inst: m });
    }, [f, p, d]), i(function() {
      return c(m) && v({ inst: m }), f(function() {
        c(m) && v({ inst: m });
      });
    }, [f]), s(p), p;
  }
  function c(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function a(f, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : l;
  return n5.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, n5;
}
var r5 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var One;
function Uet() {
  return One || (One = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ie, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var O = arguments.length, x = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++)
          x[S - 1] = arguments[S];
        r("error", w, x);
      }
    }
    function r(w, O, x) {
      {
        var S = t.ReactDebugCurrentFrame, E = S.getStackAddendum();
        E !== "" && (O += "%s", x = x.concat([E]));
        var k = x.map(function(T) {
          return String(T);
        });
        k.unshift("Warning: " + O), Function.prototype.apply.call(console[w], console, k);
      }
    }
    function i(w, O) {
      return w === O && (w !== 0 || 1 / w === 1 / O) || w !== w && O !== O;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = e.useState, l = e.useEffect, c = e.useLayoutEffect, a = e.useDebugValue, u = !1, f = !1;
    function d(w, O, x) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var S = O();
      if (!f) {
        var E = O();
        o(S, E) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var k = s({
        inst: {
          value: S,
          getSnapshot: O
        }
      }), T = k[0].inst, R = k[1];
      return c(function() {
        T.value = S, T.getSnapshot = O, p(T) && R({
          inst: T
        });
      }, [w, S, O]), l(function() {
        p(T) && R({
          inst: T
        });
        var j = function() {
          p(T) && R({
            inst: T
          });
        };
        return w(j);
      }, [w]), a(S), S;
    }
    function p(w) {
      var O = w.getSnapshot, x = w.value;
      try {
        var S = O();
        return !o(x, S);
      } catch {
        return !0;
      }
    }
    function h(w, O, x) {
      return O();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", v = !m, b = v ? h : d, A = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b;
    r5.useSyncExternalStore = A, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), r5;
}
var Ane;
function XAe() {
  return Ane || (Ane = 1, process.env.NODE_ENV === "production" ? yP.exports = Fet() : yP.exports = Uet()), yP.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wne;
function Vet() {
  if (wne) return t5;
  wne = 1;
  var e = ie, t = XAe();
  function n(a, u) {
    return a === u && (a !== 0 || 1 / a === 1 / u) || a !== a && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, s = e.useEffect, l = e.useMemo, c = e.useDebugValue;
  return t5.useSyncExternalStoreWithSelector = function(a, u, f, d, p) {
    var h = o(null);
    if (h.current === null) {
      var m = { hasValue: !1, value: null };
      h.current = m;
    } else m = h.current;
    h = l(function() {
      function b(S) {
        if (!A) {
          if (A = !0, w = S, S = d(S), p !== void 0 && m.hasValue) {
            var E = m.value;
            if (p(E, S)) return O = E;
          }
          return O = S;
        }
        if (E = O, r(w, S)) return E;
        var k = d(S);
        return p !== void 0 && p(E, k) ? E : (w = S, O = k);
      }
      var A = !1, w, O, x = f === void 0 ? null : f;
      return [function() {
        return b(u());
      }, x === null ? void 0 : function() {
        return b(x());
      }];
    }, [u, f, d, p]);
    var v = i(a, h[0], h[1]);
    return s(function() {
      m.hasValue = !0, m.value = v;
    }, [v]), c(v), v;
  }, t5;
}
var i5 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xne;
function qet() {
  return xne || (xne = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ie, t = XAe();
    function n(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, s = e.useEffect, l = e.useMemo, c = e.useDebugValue;
    function a(u, f, d, p, h) {
      var m = o(null), v;
      m.current === null ? (v = {
        hasValue: !1,
        value: null
      }, m.current = v) : v = m.current;
      var b = l(function() {
        var x = !1, S, E, k = function(F) {
          if (!x) {
            x = !0, S = F;
            var L = p(F);
            if (h !== void 0 && v.hasValue) {
              var _ = v.value;
              if (h(_, L))
                return E = _, _;
            }
            return E = L, L;
          }
          var U = S, z = E;
          if (r(U, F))
            return z;
          var C = p(F);
          return h !== void 0 && h(z, C) ? z : (S = F, E = C, C);
        }, T = d === void 0 ? null : d, R = function() {
          return k(f());
        }, j = T === null ? void 0 : function() {
          return k(T());
        };
        return [R, j];
      }, [f, d, p, h]), A = b[0], w = b[1], O = i(u, A, w);
      return s(function() {
        v.hasValue = !0, v.value = O;
      }, [O]), c(O), O;
    }
    i5.useSyncExternalStoreWithSelector = a, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), i5;
}
var Sne;
function Bet() {
  return Sne || (Sne = 1, process.env.NODE_ENV === "production" ? gP.exports = Vet() : gP.exports = qet()), gP.exports;
}
var Xet = Bet();
const WAe = /* @__PURE__ */ Sl(Xet), ZAe = {}, { useDebugValue: Wet } = ie, { useSyncExternalStoreWithSelector: Zet } = WAe;
let Ene = !1;
const Het = (e) => e;
function HAe(e, t = Het, n) {
  (ZAe ? "production" : void 0) !== "production" && n && !Ene && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), Ene = !0);
  const r = Zet(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return Wet(r), r;
}
const Tne = (e) => {
  (ZAe ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? BAe(e) : e, n = (r, i) => HAe(t, r, i);
  return Object.assign(n, t), n;
}, $w = (e) => e ? Tne(e) : Tne, Qet = $w(
  (e) => ({
    isOpen: !1,
    openDialog: () => e({ isOpen: !0 }),
    closeDialog: () => e({ isOpen: !1 })
  })
);
var Ab = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, ZA = typeof window > "u" || "Deno" in globalThis;
function Rc() {
}
function $et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xq(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function QAe(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function jO(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Du(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kne(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: l
  } = e;
  if (s) {
    if (r) {
      if (t.queryHash !== NH(s, t.options))
        return !1;
    } else if (!CT(t.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof l == "boolean" && t.isStale() !== l || i && i !== t.state.fetchStatus || o && !o(t));
}
function Cne(e, t) {
  const { exact: n, status: r, predicate: i, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ev(t.options.mutationKey) !== Ev(o))
        return !1;
    } else if (!CT(t.options.mutationKey, o))
      return !1;
  }
  return !(r && t.state.status !== r || i && !i(t));
}
function NH(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ev)(e);
}
function Ev(e) {
  return JSON.stringify(
    e,
    (t, n) => Wq(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function CT(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !CT(e[n], t[n])) : !1;
}
function PH(e, t) {
  if (e === t)
    return e;
  const n = Nne(e) && Nne(t);
  if (n || Wq(e) && Wq(t)) {
    const r = n ? e : Object.keys(e), i = r.length, o = n ? t : Object.keys(t), s = o.length, l = n ? [] : {};
    let c = 0;
    for (let a = 0; a < s; a++) {
      const u = n ? a : o[a];
      (!n && r.includes(u) || n) && e[u] === void 0 && t[u] === void 0 ? (l[u] = void 0, c++) : (l[u] = PH(e[u], t[u]), l[u] === e[u] && e[u] !== void 0 && c++);
    }
    return i === s && c === i ? e : l;
  }
  return t;
}
function JM(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Nne(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Wq(e) {
  if (!Pne(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!Pne(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Pne(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ket(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Zq(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? PH(e, t) : t;
}
function Get(e) {
  return e;
}
function Yet(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function Jet(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var Hq = Symbol(), $Ae = (e, t) => (process.env.NODE_ENV !== "production" && e.queryFn === Hq && console.error(
  `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === Hq ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn), Ly, hm, pA, rve, ett = (rve = class extends Ab {
  constructor() {
    super();
    tt(this, Ly);
    tt(this, hm);
    tt(this, pA);
    $e(this, pA, (n) => {
      if (!ZA && window.addEventListener) {
        const r = () => n();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    K(this, hm) || this.setEventListener(K(this, pA));
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || ((n = K(this, hm)) == null || n.call(this), $e(this, hm, void 0));
  }
  setEventListener(n) {
    var r;
    $e(this, pA, n), (r = K(this, hm)) == null || r.call(this), $e(this, hm, n((i) => {
      typeof i == "boolean" ? this.setFocused(i) : this.onFocus();
    }));
  }
  setFocused(n) {
    K(this, Ly) !== n && ($e(this, Ly, n), this.onFocus());
  }
  onFocus() {
    const n = this.isFocused();
    this.listeners.forEach((r) => {
      r(n);
    });
  }
  isFocused() {
    var n;
    return typeof K(this, Ly) == "boolean" ? K(this, Ly) : ((n = globalThis.document) == null ? void 0 : n.visibilityState) !== "hidden";
  }
}, Ly = new WeakMap(), hm = new WeakMap(), pA = new WeakMap(), rve), IH = new ett(), hA, mm, mA, ive, ttt = (ive = class extends Ab {
  constructor() {
    super();
    tt(this, hA, !0);
    tt(this, mm);
    tt(this, mA);
    $e(this, mA, (n) => {
      if (!ZA && window.addEventListener) {
        const r = () => n(!0), i = () => n(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", i, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", i);
        };
      }
    });
  }
  onSubscribe() {
    K(this, mm) || this.setEventListener(K(this, mA));
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || ((n = K(this, mm)) == null || n.call(this), $e(this, mm, void 0));
  }
  setEventListener(n) {
    var r;
    $e(this, mA, n), (r = K(this, mm)) == null || r.call(this), $e(this, mm, n(this.setOnline.bind(this)));
  }
  setOnline(n) {
    K(this, hA) !== n && ($e(this, hA, n), this.listeners.forEach((i) => {
      i(n);
    }));
  }
  isOnline() {
    return K(this, hA);
  }
}, hA = new WeakMap(), mm = new WeakMap(), mA = new WeakMap(), ive), eD = new ttt();
function ntt(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function KAe(e) {
  return (e ?? "online") === "online" ? eD.isOnline() : !0;
}
var GAe = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function o5(e) {
  return e instanceof GAe;
}
function YAe(e) {
  let t = !1, n = 0, r = !1, i, o, s;
  const l = new Promise((b, A) => {
    o = b, s = A;
  }), c = (b) => {
    var A;
    r || (h(new GAe(b)), (A = e.abort) == null || A.call(e));
  }, a = () => {
    t = !0;
  }, u = () => {
    t = !1;
  }, f = () => IH.isFocused() && (e.networkMode === "always" || eD.isOnline()) && e.canRun(), d = () => KAe(e.networkMode) && e.canRun(), p = (b) => {
    var A;
    r || (r = !0, (A = e.onSuccess) == null || A.call(e, b), i == null || i(), o(b));
  }, h = (b) => {
    var A;
    r || (r = !0, (A = e.onError) == null || A.call(e, b), i == null || i(), s(b));
  }, m = () => new Promise((b) => {
    var A;
    i = (w) => {
      (r || f()) && b(w);
    }, (A = e.onPause) == null || A.call(e);
  }).then(() => {
    var b;
    i = void 0, r || (b = e.onContinue) == null || b.call(e);
  }), v = () => {
    if (r)
      return;
    let b;
    const A = n === 0 ? e.initialPromise : void 0;
    try {
      b = A ?? e.fn();
    } catch (w) {
      b = Promise.reject(w);
    }
    Promise.resolve(b).then(p).catch((w) => {
      var k;
      if (r)
        return;
      const O = e.retry ?? (ZA ? 0 : 3), x = e.retryDelay ?? ntt, S = typeof x == "function" ? x(n, w) : x, E = O === !0 || typeof O == "number" && n < O || typeof O == "function" && O(n, w);
      if (t || !E) {
        h(w);
        return;
      }
      n++, (k = e.onFail) == null || k.call(e, n, w), Ket(S).then(() => f() ? void 0 : m()).then(() => {
        t ? h(w) : v();
      });
    });
  };
  return {
    promise: l,
    cancel: c,
    continue: () => (i == null || i(), l),
    cancelRetry: a,
    continueRetry: u,
    canStart: d,
    start: () => (d() ? v() : m().then(v), l)
  };
}
function rtt() {
  let e = [], t = 0, n = (d) => {
    d();
  }, r = (d) => {
    d();
  }, i = (d) => setTimeout(d, 0);
  const o = (d) => {
    i = d;
  }, s = (d) => {
    let p;
    t++;
    try {
      p = d();
    } finally {
      t--, t || a();
    }
    return p;
  }, l = (d) => {
    t ? e.push(d) : i(() => {
      n(d);
    });
  }, c = (d) => (...p) => {
    l(() => {
      d(...p);
    });
  }, a = () => {
    const d = e;
    e = [], d.length && i(() => {
      r(() => {
        d.forEach((p) => {
          n(p);
        });
      });
    });
  };
  return {
    batch: s,
    batchCalls: c,
    schedule: l,
    setNotifyFunction: (d) => {
      n = d;
    },
    setBatchNotifyFunction: (d) => {
      r = d;
    },
    setScheduler: o
  };
}
var Fi = rtt(), zy, ove, JAe = (ove = class {
  constructor() {
    tt(this, zy);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Xq(this.gcTime) && $e(this, zy, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (ZA ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    K(this, zy) && (clearTimeout(K(this, zy)), $e(this, zy, void 0));
  }
}, zy = new WeakMap(), ove), gA, yA, Nc, Vs, Hk, jy, Nu, yp, sve, itt = (sve = class extends JAe {
  constructor(t) {
    super();
    tt(this, Nu);
    tt(this, gA);
    tt(this, yA);
    tt(this, Nc);
    tt(this, Vs);
    tt(this, Hk);
    tt(this, jy);
    $e(this, jy, !1), $e(this, Hk, t.defaultOptions), this.setOptions(t.options), this.observers = [], $e(this, Nc, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, $e(this, gA, t.state || ott(this.options)), this.state = K(this, gA), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = K(this, Vs)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...K(this, Hk), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && K(this, Nc).remove(this);
  }
  setData(t, n) {
    const r = Zq(this.state.data, t, this.options);
    return Dt(this, Nu, yp).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    Dt(this, Nu, yp).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, i;
    const n = (r = K(this, Vs)) == null ? void 0 : r.promise;
    return (i = K(this, Vs)) == null || i.cancel(t), n ? n.then(Rc).catch(Rc) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(K(this, gA));
  }
  isActive() {
    return this.observers.some(
      (t) => Du(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !QAe(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = K(this, Vs)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = K(this, Vs)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), K(this, Nc).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (K(this, Vs) && (K(this, jy) ? K(this, Vs).cancel({ revert: !0 }) : K(this, Vs).cancelRetry()), this.scheduleGc()), K(this, Nc).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || Dt(this, Nu, yp).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var c, a, u;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (K(this, Vs))
        return K(this, Vs).continueRetry(), K(this, Vs).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const f = this.observers.find((d) => d.options.queryFn);
      f && this.setOptions(f.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), i = (f) => {
      Object.defineProperty(f, "signal", {
        enumerable: !0,
        get: () => ($e(this, jy, !0), r.signal)
      });
    }, o = () => {
      const f = $Ae(this.options, n), d = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return i(d), $e(this, jy, !1), this.options.persister ? this.options.persister(
        f,
        d,
        this
      ) : f(d);
    }, s = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: o
    };
    i(s), (c = this.options.behavior) == null || c.onFetch(
      s,
      this
    ), $e(this, yA, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((a = s.fetchOptions) == null ? void 0 : a.meta)) && Dt(this, Nu, yp).call(this, { type: "fetch", meta: (u = s.fetchOptions) == null ? void 0 : u.meta });
    const l = (f) => {
      var d, p, h, m;
      o5(f) && f.silent || Dt(this, Nu, yp).call(this, {
        type: "error",
        error: f
      }), o5(f) || ((p = (d = K(this, Nc).config).onError) == null || p.call(
        d,
        f,
        this
      ), (m = (h = K(this, Nc).config).onSettled) == null || m.call(
        h,
        this.state.data,
        f,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return $e(this, Vs, YAe({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: s.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (f) => {
        var d, p, h, m;
        if (f === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(f), (p = (d = K(this, Nc).config).onSuccess) == null || p.call(d, f, this), (m = (h = K(this, Nc).config).onSettled) == null || m.call(
          h,
          f,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: l,
      onFail: (f, d) => {
        Dt(this, Nu, yp).call(this, { type: "failed", failureCount: f, error: d });
      },
      onPause: () => {
        Dt(this, Nu, yp).call(this, { type: "pause" });
      },
      onContinue: () => {
        Dt(this, Nu, yp).call(this, { type: "continue" });
      },
      retry: s.options.retry,
      retryDelay: s.options.retryDelay,
      networkMode: s.options.networkMode,
      canRun: () => !0
    })), K(this, Vs).start();
  }
}, gA = new WeakMap(), yA = new WeakMap(), Nc = new WeakMap(), Vs = new WeakMap(), Hk = new WeakMap(), jy = new WeakMap(), Nu = new WeakSet(), yp = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...ewe(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = t.error;
        return o5(i) && i.revert && K(this, yA) ? { ...K(this, yA), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), Fi.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), K(this, Nc).notify({ query: this, type: "updated", action: t });
  });
}, sve);
function ewe(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: KAe(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function ott(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Bd, ave, stt = (ave = class extends Ab {
  constructor(t = {}) {
    super();
    tt(this, Bd);
    this.config = t, $e(this, Bd, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    const i = n.queryKey, o = n.queryHash ?? NH(i, n);
    let s = this.get(o);
    return s || (s = new itt({
      cache: this,
      queryKey: i,
      queryHash: o,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(i)
    }), this.add(s)), s;
  }
  add(t) {
    K(this, Bd).has(t.queryHash) || (K(this, Bd).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = K(this, Bd).get(t.queryHash);
    n && (t.destroy(), n === t && K(this, Bd).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    Fi.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return K(this, Bd).get(t);
  }
  getAll() {
    return [...K(this, Bd).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => kne(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => kne(t, r)) : n;
  }
  notify(t) {
    Fi.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    Fi.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Fi.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Bd = new WeakMap(), ave), Xd, ma, Fy, Wd, Xh, lve, att = (lve = class extends JAe {
  constructor(t) {
    super();
    tt(this, Wd);
    tt(this, Xd);
    tt(this, ma);
    tt(this, Fy);
    this.mutationId = t.mutationId, $e(this, ma, t.mutationCache), $e(this, Xd, []), this.state = t.state || twe(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    K(this, Xd).includes(t) || (K(this, Xd).push(t), this.clearGcTimeout(), K(this, ma).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    $e(this, Xd, K(this, Xd).filter((n) => n !== t)), this.scheduleGc(), K(this, ma).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    K(this, Xd).length || (this.state.status === "pending" ? this.scheduleGc() : K(this, ma).remove(this));
  }
  continue() {
    var t;
    return ((t = K(this, Fy)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var i, o, s, l, c, a, u, f, d, p, h, m, v, b, A, w, O, x, S, E;
    $e(this, Fy, YAe({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (k, T) => {
        Dt(this, Wd, Xh).call(this, { type: "failed", failureCount: k, error: T });
      },
      onPause: () => {
        Dt(this, Wd, Xh).call(this, { type: "pause" });
      },
      onContinue: () => {
        Dt(this, Wd, Xh).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => K(this, ma).canRun(this)
    }));
    const n = this.state.status === "pending", r = !K(this, Fy).canStart();
    try {
      if (!n) {
        Dt(this, Wd, Xh).call(this, { type: "pending", variables: t, isPaused: r }), await ((o = (i = K(this, ma).config).onMutate) == null ? void 0 : o.call(
          i,
          t,
          this
        ));
        const T = await ((l = (s = this.options).onMutate) == null ? void 0 : l.call(s, t));
        T !== this.state.context && Dt(this, Wd, Xh).call(this, {
          type: "pending",
          context: T,
          variables: t,
          isPaused: r
        });
      }
      const k = await K(this, Fy).start();
      return await ((a = (c = K(this, ma).config).onSuccess) == null ? void 0 : a.call(
        c,
        k,
        t,
        this.state.context,
        this
      )), await ((f = (u = this.options).onSuccess) == null ? void 0 : f.call(u, k, t, this.state.context)), await ((p = (d = K(this, ma).config).onSettled) == null ? void 0 : p.call(
        d,
        k,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((m = (h = this.options).onSettled) == null ? void 0 : m.call(h, k, null, t, this.state.context)), Dt(this, Wd, Xh).call(this, { type: "success", data: k }), k;
    } catch (k) {
      try {
        throw await ((b = (v = K(this, ma).config).onError) == null ? void 0 : b.call(
          v,
          k,
          t,
          this.state.context,
          this
        )), await ((w = (A = this.options).onError) == null ? void 0 : w.call(
          A,
          k,
          t,
          this.state.context
        )), await ((x = (O = K(this, ma).config).onSettled) == null ? void 0 : x.call(
          O,
          void 0,
          k,
          this.state.variables,
          this.state.context,
          this
        )), await ((E = (S = this.options).onSettled) == null ? void 0 : E.call(
          S,
          void 0,
          k,
          t,
          this.state.context
        )), k;
      } finally {
        Dt(this, Wd, Xh).call(this, { type: "error", error: k });
      }
    } finally {
      K(this, ma).runNext(this);
    }
  }
}, Xd = new WeakMap(), ma = new WeakMap(), Fy = new WeakMap(), Wd = new WeakSet(), Xh = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), Fi.batch(() => {
    K(this, Xd).forEach((r) => {
      r.onMutationUpdate(t);
    }), K(this, ma).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, lve);
function twe() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ul, Qk, cve, nwe = (cve = class extends Ab {
  constructor(t = {}) {
    super();
    tt(this, Ul);
    tt(this, Qk);
    this.config = t, $e(this, Ul, /* @__PURE__ */ new Map()), $e(this, Qk, Date.now());
  }
  build(t, n, r) {
    const i = new att({
      mutationCache: this,
      mutationId: ++Hx(this, Qk)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(i), i;
  }
  add(t) {
    const n = vP(t), r = K(this, Ul).get(n) ?? [];
    r.push(t), K(this, Ul).set(n, r), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    var r;
    const n = vP(t);
    if (K(this, Ul).has(n)) {
      const i = (r = K(this, Ul).get(n)) == null ? void 0 : r.filter((o) => o !== t);
      i && (i.length === 0 ? K(this, Ul).delete(n) : K(this, Ul).set(n, i));
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    var r;
    const n = (r = K(this, Ul).get(vP(t))) == null ? void 0 : r.find((i) => i.state.status === "pending");
    return !n || n === t;
  }
  runNext(t) {
    var r;
    const n = (r = K(this, Ul).get(vP(t))) == null ? void 0 : r.find((i) => i !== t && i.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    Fi.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return [...K(this, Ul).values()].flat();
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => Cne(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => Cne(t, n));
  }
  notify(t) {
    Fi.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return Fi.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Rc))
      )
    );
  }
}, Ul = new WeakMap(), Qk = new WeakMap(), cve);
function vP(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function ltt(e) {
  return {
    onFetch: (t, n) => {
      const r = async () => {
        var h, m, v, b, A;
        const i = t.options, o = (v = (m = (h = t.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : m.fetchMore) == null ? void 0 : v.direction, s = ((b = t.state.data) == null ? void 0 : b.pages) || [], l = ((A = t.state.data) == null ? void 0 : A.pageParams) || [], c = { pages: [], pageParams: [] };
        let a = !1;
        const u = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? a = !0 : t.signal.addEventListener("abort", () => {
              a = !0;
            }), t.signal)
          });
        }, f = $Ae(t.options, t.fetchOptions), d = async (w, O, x) => {
          if (a)
            return Promise.reject();
          if (O == null && w.pages.length)
            return Promise.resolve(w);
          const S = {
            queryKey: t.queryKey,
            pageParam: O,
            direction: x ? "backward" : "forward",
            meta: t.options.meta
          };
          u(S);
          const E = await f(
            S
          ), { maxPages: k } = t.options, T = x ? Jet : Yet;
          return {
            pages: T(w.pages, E, k),
            pageParams: T(w.pageParams, O, k)
          };
        };
        let p;
        if (o && s.length) {
          const w = o === "backward", O = w ? ctt : Ine, x = {
            pages: s,
            pageParams: l
          }, S = O(i, x);
          p = await d(x, S, w);
        } else {
          p = await d(
            c,
            l[0] ?? i.initialPageParam
          );
          const w = e ?? s.length;
          for (let O = 1; O < w; O++) {
            const x = Ine(i, p);
            p = await d(p, x);
          }
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var i, o;
        return (o = (i = t.options).persister) == null ? void 0 : o.call(
          i,
          r,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = r;
    }
  };
}
function Ine(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  );
}
function ctt(e, { pages: t, pageParams: n }) {
  var r;
  return (r = e.getPreviousPageParam) == null ? void 0 : r.call(
    e,
    t[0],
    t,
    n[0],
    n
  );
}
var Li, gm, ym, vA, bA, vm, OA, AA, uve, rwe = (uve = class {
  constructor(e = {}) {
    tt(this, Li);
    tt(this, gm);
    tt(this, ym);
    tt(this, vA);
    tt(this, bA);
    tt(this, vm);
    tt(this, OA);
    tt(this, AA);
    $e(this, Li, e.queryCache || new stt()), $e(this, gm, e.mutationCache || new nwe()), $e(this, ym, e.defaultOptions || {}), $e(this, vA, /* @__PURE__ */ new Map()), $e(this, bA, /* @__PURE__ */ new Map()), $e(this, vm, 0);
  }
  mount() {
    Hx(this, vm)._++, K(this, vm) === 1 && ($e(this, OA, IH.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), K(this, Li).onFocus());
    })), $e(this, AA, eD.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), K(this, Li).onOnline());
    })));
  }
  unmount() {
    var e, t;
    Hx(this, vm)._--, K(this, vm) === 0 && ((e = K(this, OA)) == null || e.call(this), $e(this, OA, void 0), (t = K(this, AA)) == null || t.call(this), $e(this, AA, void 0));
  }
  isFetching(e) {
    return K(this, Li).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return K(this, gm).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = K(this, Li).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = K(this, Li).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(jO(n.staleTime, r)) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return K(this, Li).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), i = K(this, Li).get(
      r.queryHash
    ), o = i == null ? void 0 : i.state.data, s = $et(t, o);
    if (s !== void 0)
      return K(this, Li).build(this, r).setData(s, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return Fi.batch(
      () => K(this, Li).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = K(this, Li).get(t.queryHash)) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = K(this, Li);
    Fi.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = K(this, Li), r = {
      type: "active",
      ...e
    };
    return Fi.batch(() => (n.findAll(e).forEach((i) => {
      i.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = Fi.batch(
      () => K(this, Li).findAll(e).map((i) => i.cancel(n))
    );
    return Promise.all(r).then(Rc).catch(Rc);
  }
  invalidateQueries(e = {}, t = {}) {
    return Fi.batch(() => {
      if (K(this, Li).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = Fi.batch(
      () => K(this, Li).findAll(e).filter((i) => !i.isDisabled()).map((i) => {
        let o = i.fetch(void 0, n);
        return n.throwOnError || (o = o.catch(Rc)), i.state.fetchStatus === "paused" ? Promise.resolve() : o;
      })
    );
    return Promise.all(r).then(Rc);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = K(this, Li).build(this, t);
    return n.isStaleByTime(
      jO(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Rc).catch(Rc);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = ltt(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Rc).catch(Rc);
  }
  resumePausedMutations() {
    return eD.isOnline() ? K(this, gm).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return K(this, Li);
  }
  getMutationCache() {
    return K(this, gm);
  }
  getDefaultOptions() {
    return K(this, ym);
  }
  setDefaultOptions(e) {
    $e(this, ym, e);
  }
  setQueryDefaults(e, t) {
    K(this, vA).set(Ev(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...K(this, vA).values()];
    let n = {};
    return t.forEach((r) => {
      CT(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    K(this, bA).set(Ev(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...K(this, bA).values()];
    let n = {};
    return t.forEach((r) => {
      CT(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...K(this, ym).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = NH(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === Hq && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...K(this, ym).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    K(this, Li).clear(), K(this, gm).clear();
  }
}, Li = new WeakMap(), gm = new WeakMap(), ym = new WeakMap(), vA = new WeakMap(), bA = new WeakMap(), vm = new WeakMap(), OA = new WeakMap(), AA = new WeakMap(), uve), Qa, sr, $k, ga, Uy, wA, Zd, Kk, xA, SA, Vy, qy, bm, EA, Rr, GS, Qq, $q, Kq, Gq, Yq, Jq, eB, iwe, dve, RH = (dve = class extends Ab {
  constructor(n, r) {
    super();
    tt(this, Rr);
    tt(this, Qa);
    tt(this, sr);
    tt(this, $k);
    tt(this, ga);
    tt(this, Uy);
    tt(this, wA);
    tt(this, Zd);
    tt(this, Kk);
    tt(this, xA);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    tt(this, SA);
    tt(this, Vy);
    tt(this, qy);
    tt(this, bm);
    tt(this, EA, /* @__PURE__ */ new Set());
    this.options = r, $e(this, Qa, n), $e(this, Zd, null), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (K(this, sr).addObserver(this), Rne(K(this, sr), this.options) ? Dt(this, Rr, GS).call(this) : this.updateResult(), Dt(this, Rr, Gq).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return tB(
      K(this, sr),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return tB(
      K(this, sr),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Dt(this, Rr, Yq).call(this), Dt(this, Rr, Jq).call(this), K(this, sr).removeObserver(this);
  }
  setOptions(n, r) {
    const i = this.options, o = K(this, sr);
    if (this.options = K(this, Qa).defaultQueryOptions(n), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Du(this.options.enabled, K(this, sr)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    Dt(this, Rr, eB).call(this), K(this, sr).setOptions(this.options), i._defaulted && !JM(this.options, i) && K(this, Qa).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: K(this, sr),
      observer: this
    });
    const s = this.hasListeners();
    s && Mne(
      K(this, sr),
      o,
      this.options,
      i
    ) && Dt(this, Rr, GS).call(this), this.updateResult(r), s && (K(this, sr) !== o || Du(this.options.enabled, K(this, sr)) !== Du(i.enabled, K(this, sr)) || jO(this.options.staleTime, K(this, sr)) !== jO(i.staleTime, K(this, sr))) && Dt(this, Rr, Qq).call(this);
    const l = Dt(this, Rr, $q).call(this);
    s && (K(this, sr) !== o || Du(this.options.enabled, K(this, sr)) !== Du(i.enabled, K(this, sr)) || l !== K(this, bm)) && Dt(this, Rr, Kq).call(this, l);
  }
  getOptimisticResult(n) {
    const r = K(this, Qa).getQueryCache().build(K(this, Qa), n), i = this.createResult(r, n);
    return dtt(this, i) && ($e(this, ga, i), $e(this, wA, this.options), $e(this, Uy, K(this, sr).state)), i;
  }
  getCurrentResult() {
    return K(this, ga);
  }
  trackResult(n, r) {
    const i = {};
    return Object.keys(n).forEach((o) => {
      Object.defineProperty(i, o, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(o), r == null || r(o), n[o])
      });
    }), i;
  }
  trackProp(n) {
    K(this, EA).add(n);
  }
  getCurrentQuery() {
    return K(this, sr);
  }
  refetch({ ...n } = {}) {
    return this.fetch({
      ...n
    });
  }
  fetchOptimistic(n) {
    const r = K(this, Qa).defaultQueryOptions(n), i = K(this, Qa).getQueryCache().build(K(this, Qa), r);
    return i.isFetchingOptimistic = !0, i.fetch().then(() => this.createResult(i, r));
  }
  fetch(n) {
    return Dt(this, Rr, GS).call(this, {
      ...n,
      cancelRefetch: n.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), K(this, ga)));
  }
  createResult(n, r) {
    var k;
    const i = K(this, sr), o = this.options, s = K(this, ga), l = K(this, Uy), c = K(this, wA), u = n !== i ? n.state : K(this, $k), { state: f } = n;
    let d = { ...f }, p = !1, h;
    if (r._optimisticResults) {
      const T = this.hasListeners(), R = !T && Rne(n, r), j = T && Mne(n, i, r, o);
      (R || j) && (d = {
        ...d,
        ...ewe(f.data, n.options)
      }), r._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: m, errorUpdatedAt: v, status: b } = d;
    if (r.select && d.data !== void 0)
      if (s && d.data === (l == null ? void 0 : l.data) && r.select === K(this, Kk))
        h = K(this, xA);
      else
        try {
          $e(this, Kk, r.select), h = r.select(d.data), h = Zq(s == null ? void 0 : s.data, h, r), $e(this, xA, h), $e(this, Zd, null);
        } catch (T) {
          $e(this, Zd, T);
        }
    else
      h = d.data;
    if (r.placeholderData !== void 0 && h === void 0 && b === "pending") {
      let T;
      if (s != null && s.isPlaceholderData && r.placeholderData === (c == null ? void 0 : c.placeholderData))
        T = s.data;
      else if (T = typeof r.placeholderData == "function" ? r.placeholderData(
        (k = K(this, SA)) == null ? void 0 : k.state.data,
        K(this, SA)
      ) : r.placeholderData, r.select && T !== void 0)
        try {
          T = r.select(T), $e(this, Zd, null);
        } catch (R) {
          $e(this, Zd, R);
        }
      T !== void 0 && (b = "success", h = Zq(
        s == null ? void 0 : s.data,
        T,
        r
      ), p = !0);
    }
    K(this, Zd) && (m = K(this, Zd), h = K(this, xA), v = Date.now(), b = "error");
    const A = d.fetchStatus === "fetching", w = b === "pending", O = b === "error", x = w && A, S = h !== void 0;
    return {
      status: b,
      fetchStatus: d.fetchStatus,
      isPending: w,
      isSuccess: b === "success",
      isError: O,
      isInitialLoading: x,
      isLoading: x,
      data: h,
      dataUpdatedAt: d.dataUpdatedAt,
      error: m,
      errorUpdatedAt: v,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > u.dataUpdateCount || d.errorUpdateCount > u.errorUpdateCount,
      isFetching: A,
      isRefetching: A && !w,
      isLoadingError: O && !S,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: p,
      isRefetchError: O && S,
      isStale: MH(n, r),
      refetch: this.refetch
    };
  }
  updateResult(n) {
    const r = K(this, ga), i = this.createResult(K(this, sr), this.options);
    if ($e(this, Uy, K(this, sr).state), $e(this, wA, this.options), K(this, Uy).data !== void 0 && $e(this, SA, K(this, sr)), JM(i, r))
      return;
    $e(this, ga, i);
    const o = {}, s = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: l } = this.options, c = typeof l == "function" ? l() : l;
      if (c === "all" || !c && !K(this, EA).size)
        return !0;
      const a = new Set(
        c ?? K(this, EA)
      );
      return this.options.throwOnError && a.add("error"), Object.keys(K(this, ga)).some((u) => {
        const f = u;
        return K(this, ga)[f] !== r[f] && a.has(f);
      });
    };
    (n == null ? void 0 : n.listeners) !== !1 && s() && (o.listeners = !0), Dt(this, Rr, iwe).call(this, { ...o, ...n });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Dt(this, Rr, Gq).call(this);
  }
}, Qa = new WeakMap(), sr = new WeakMap(), $k = new WeakMap(), ga = new WeakMap(), Uy = new WeakMap(), wA = new WeakMap(), Zd = new WeakMap(), Kk = new WeakMap(), xA = new WeakMap(), SA = new WeakMap(), Vy = new WeakMap(), qy = new WeakMap(), bm = new WeakMap(), EA = new WeakMap(), Rr = new WeakSet(), GS = function(n) {
  Dt(this, Rr, eB).call(this);
  let r = K(this, sr).fetch(
    this.options,
    n
  );
  return n != null && n.throwOnError || (r = r.catch(Rc)), r;
}, Qq = function() {
  Dt(this, Rr, Yq).call(this);
  const n = jO(
    this.options.staleTime,
    K(this, sr)
  );
  if (ZA || K(this, ga).isStale || !Xq(n))
    return;
  const i = QAe(K(this, ga).dataUpdatedAt, n) + 1;
  $e(this, Vy, setTimeout(() => {
    K(this, ga).isStale || this.updateResult();
  }, i));
}, $q = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(K(this, sr)) : this.options.refetchInterval) ?? !1;
}, Kq = function(n) {
  Dt(this, Rr, Jq).call(this), $e(this, bm, n), !(ZA || Du(this.options.enabled, K(this, sr)) === !1 || !Xq(K(this, bm)) || K(this, bm) === 0) && $e(this, qy, setInterval(() => {
    (this.options.refetchIntervalInBackground || IH.isFocused()) && Dt(this, Rr, GS).call(this);
  }, K(this, bm)));
}, Gq = function() {
  Dt(this, Rr, Qq).call(this), Dt(this, Rr, Kq).call(this, Dt(this, Rr, $q).call(this));
}, Yq = function() {
  K(this, Vy) && (clearTimeout(K(this, Vy)), $e(this, Vy, void 0));
}, Jq = function() {
  K(this, qy) && (clearInterval(K(this, qy)), $e(this, qy, void 0));
}, eB = function() {
  const n = K(this, Qa).getQueryCache().build(K(this, Qa), this.options);
  if (n === K(this, sr))
    return;
  const r = K(this, sr);
  $e(this, sr, n), $e(this, $k, n.state), this.hasListeners() && (r == null || r.removeObserver(this), n.addObserver(this));
}, iwe = function(n) {
  Fi.batch(() => {
    n.listeners && this.listeners.forEach((r) => {
      r(K(this, ga));
    }), K(this, Qa).getQueryCache().notify({
      query: K(this, sr),
      type: "observerResultsUpdated"
    });
  });
}, dve);
function utt(e, t) {
  return Du(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Rne(e, t) {
  return utt(e, t) || e.state.data !== void 0 && tB(e, t, t.refetchOnMount);
}
function tB(e, t, n) {
  if (Du(t.enabled, e) !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && MH(e, t);
  }
  return !1;
}
function Mne(e, t, n, r) {
  return (e !== t || Du(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && MH(e, n);
}
function MH(e, t) {
  return Du(t.enabled, e) !== !1 && e.isStaleByTime(jO(t.staleTime, e));
}
function dtt(e, t) {
  return !JM(e.getCurrentResult(), t);
}
function Dne(e, t) {
  return e.filter((n) => !t.includes(n));
}
function ftt(e, t, n) {
  const r = e.slice(0);
  return r[t] = n, r;
}
var By, Pu, TA, Vl, Xy, Gk, Yk, hc, owe, nB, rB, iB, fve, ptt = (fve = class extends Ab {
  constructor(t, n, r) {
    super();
    tt(this, hc);
    tt(this, By);
    tt(this, Pu);
    tt(this, TA);
    tt(this, Vl);
    tt(this, Xy);
    tt(this, Gk);
    tt(this, Yk);
    $e(this, By, t), $e(this, TA, []), $e(this, Vl, []), $e(this, Pu, []), this.setQueries(n);
  }
  onSubscribe() {
    this.listeners.size === 1 && K(this, Vl).forEach((t) => {
      t.subscribe((n) => {
        Dt(this, hc, rB).call(this, t, n);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), K(this, Vl).forEach((t) => {
      t.destroy();
    });
  }
  setQueries(t, n, r) {
    $e(this, TA, t), Fi.batch(() => {
      const i = K(this, Vl), o = Dt(this, hc, nB).call(this, K(this, TA));
      o.forEach(
        (a) => a.observer.setOptions(a.defaultedQueryOptions, r)
      );
      const s = o.map((a) => a.observer), l = s.map(
        (a) => a.getCurrentResult()
      ), c = s.some(
        (a, u) => a !== i[u]
      );
      i.length === s.length && !c || ($e(this, Vl, s), $e(this, Pu, l), this.hasListeners() && (Dne(i, s).forEach((a) => {
        a.destroy();
      }), Dne(s, i).forEach((a) => {
        a.subscribe((u) => {
          Dt(this, hc, rB).call(this, a, u);
        });
      }), Dt(this, hc, iB).call(this)));
    });
  }
  getCurrentResult() {
    return K(this, Pu);
  }
  getQueries() {
    return K(this, Vl).map((t) => t.getCurrentQuery());
  }
  getObservers() {
    return K(this, Vl);
  }
  getOptimisticResult(t, n) {
    const r = Dt(this, hc, nB).call(this, t), i = r.map(
      (o) => o.observer.getOptimisticResult(o.defaultedQueryOptions)
    );
    return [
      i,
      (o) => Dt(this, hc, owe).call(this, o ?? i, n),
      () => r.map((o, s) => {
        const l = i[s];
        return o.defaultedQueryOptions.notifyOnChangeProps ? l : o.observer.trackResult(l, (c) => {
          r.forEach((a) => {
            a.observer.trackProp(c);
          });
        });
      })
    ];
  }
}, By = new WeakMap(), Pu = new WeakMap(), TA = new WeakMap(), Vl = new WeakMap(), Xy = new WeakMap(), Gk = new WeakMap(), Yk = new WeakMap(), hc = new WeakSet(), owe = function(t, n) {
  return n ? ((!K(this, Xy) || K(this, Pu) !== K(this, Yk) || n !== K(this, Gk)) && ($e(this, Gk, n), $e(this, Yk, K(this, Pu)), $e(this, Xy, PH(
    K(this, Xy),
    n(t)
  ))), K(this, Xy)) : t;
}, nB = function(t) {
  const n = K(this, Vl), r = new Map(
    n.map((f) => [f.options.queryHash, f])
  ), i = t.map(
    (f) => K(this, By).defaultQueryOptions(f)
  ), o = i.flatMap((f) => {
    const d = r.get(f.queryHash);
    return d != null ? [{ defaultedQueryOptions: f, observer: d }] : [];
  }), s = new Set(
    o.map((f) => f.defaultedQueryOptions.queryHash)
  ), l = i.filter(
    (f) => !s.has(f.queryHash)
  ), c = (f) => {
    const d = K(this, By).defaultQueryOptions(f);
    return K(this, Vl).find(
      (h) => h.options.queryHash === d.queryHash
    ) ?? new RH(K(this, By), d);
  }, a = l.map((f) => ({
    defaultedQueryOptions: f,
    observer: c(f)
  })), u = (f, d) => i.indexOf(f.defaultedQueryOptions) - i.indexOf(d.defaultedQueryOptions);
  return o.concat(a).sort(u);
}, rB = function(t, n) {
  const r = K(this, Vl).indexOf(t);
  r !== -1 && ($e(this, Pu, ftt(K(this, Pu), r, n)), Dt(this, hc, iB).call(this));
}, iB = function() {
  Fi.batch(() => {
    this.listeners.forEach((t) => {
      t(K(this, Pu));
    });
  });
}, fve), Om, Am, $a, Np, ih, MR, oB, pve, htt = (pve = class extends Ab {
  constructor(n, r) {
    super();
    tt(this, ih);
    tt(this, Om);
    tt(this, Am);
    tt(this, $a);
    tt(this, Np);
    $e(this, Om, n), this.setOptions(r), this.bindMethods(), Dt(this, ih, MR).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    var i;
    const r = this.options;
    this.options = K(this, Om).defaultMutationOptions(n), JM(this.options, r) || K(this, Om).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: K(this, $a),
      observer: this
    }), r != null && r.mutationKey && this.options.mutationKey && Ev(r.mutationKey) !== Ev(this.options.mutationKey) ? this.reset() : ((i = K(this, $a)) == null ? void 0 : i.state.status) === "pending" && K(this, $a).setOptions(this.options);
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || (n = K(this, $a)) == null || n.removeObserver(this);
  }
  onMutationUpdate(n) {
    Dt(this, ih, MR).call(this), Dt(this, ih, oB).call(this, n);
  }
  getCurrentResult() {
    return K(this, Am);
  }
  reset() {
    var n;
    (n = K(this, $a)) == null || n.removeObserver(this), $e(this, $a, void 0), Dt(this, ih, MR).call(this), Dt(this, ih, oB).call(this);
  }
  mutate(n, r) {
    var i;
    return $e(this, Np, r), (i = K(this, $a)) == null || i.removeObserver(this), $e(this, $a, K(this, Om).getMutationCache().build(K(this, Om), this.options)), K(this, $a).addObserver(this), K(this, $a).execute(n);
  }
}, Om = new WeakMap(), Am = new WeakMap(), $a = new WeakMap(), Np = new WeakMap(), ih = new WeakSet(), MR = function() {
  var r;
  const n = ((r = K(this, $a)) == null ? void 0 : r.state) ?? twe();
  $e(this, Am, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, oB = function(n) {
  Fi.batch(() => {
    var r, i, o, s, l, c, a, u;
    if (K(this, Np) && this.hasListeners()) {
      const f = K(this, Am).variables, d = K(this, Am).context;
      (n == null ? void 0 : n.type) === "success" ? ((i = (r = K(this, Np)).onSuccess) == null || i.call(r, n.data, f, d), (s = (o = K(this, Np)).onSettled) == null || s.call(o, n.data, null, f, d)) : (n == null ? void 0 : n.type) === "error" && ((c = (l = K(this, Np)).onError) == null || c.call(l, n.error, f, d), (u = (a = K(this, Np)).onSettled) == null || u.call(
        a,
        void 0,
        n.error,
        f,
        d
      ));
    }
    this.listeners.forEach((f) => {
      f(K(this, Am));
    });
  });
}, pve), swe = N.createContext(
  void 0
), Kw = (e) => {
  const t = N.useContext(swe);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, mtt = ({
  client: e,
  children: t
}) => (N.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ y(swe.Provider, { value: e, children: t })), awe = N.createContext(!1), lwe = () => N.useContext(awe);
awe.Provider;
function gtt() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var ytt = N.createContext(gtt()), cwe = () => N.useContext(ytt);
function uwe(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
function vtt() {
}
var dwe = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, fwe = (e) => {
  N.useEffect(() => {
    e.clearReset();
  }, [e]);
}, pwe = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && r && uwe(n, [e.error, r]), hwe = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, btt = (e, t) => e.isLoading && e.isFetching && !t, sB = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, aB = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function mwe({
  queries: e,
  ...t
}, n) {
  const r = Kw(), i = lwe(), o = cwe(), s = N.useMemo(
    () => e.map((h) => {
      const m = r.defaultQueryOptions(
        h
      );
      return m._optimisticResults = i ? "isRestoring" : "optimistic", m;
    }),
    [e, r, i]
  );
  s.forEach((h) => {
    hwe(h), dwe(h, o);
  }), fwe(o);
  const [l] = N.useState(
    () => new ptt(
      r,
      s,
      t
    )
  ), [c, a, u] = l.getOptimisticResult(
    s,
    t.combine
  );
  N.useSyncExternalStore(
    N.useCallback(
      (h) => i ? () => {
      } : l.subscribe(Fi.batchCalls(h)),
      [l, i]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), N.useEffect(() => {
    l.setQueries(
      s,
      t,
      {
        listeners: !1
      }
    );
  }, [s, t, l]);
  const d = c.some(
    (h, m) => sB(s[m], h)
  ) ? c.flatMap((h, m) => {
    const v = s[m];
    if (v) {
      const b = new RH(r, v);
      if (sB(v, h))
        return aB(v, b, o);
      btt(h, i) && aB(v, b, o);
    }
    return [];
  }) : [];
  if (d.length > 0)
    throw Promise.all(d);
  const p = c.find(
    (h, m) => {
      const v = s[m];
      return v && pwe({
        result: h,
        errorResetBoundary: o,
        throwOnError: v.throwOnError,
        query: r.getQueryCache().get(v.queryHash)
      });
    }
  );
  if (p != null && p.error)
    throw p.error;
  return a(u());
}
function Ott(e, t, n) {
  var a, u, f, d;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Kw(), i = lwe(), o = cwe(), s = r.defaultQueryOptions(e);
  (u = (a = r.getDefaultOptions().queries) == null ? void 0 : a._experimental_beforeQuery) == null || u.call(
    a,
    s
  ), s._optimisticResults = i ? "isRestoring" : "optimistic", hwe(s), dwe(s, o), fwe(o);
  const [l] = N.useState(
    () => new t(
      r,
      s
    )
  ), c = l.getOptimisticResult(s);
  if (N.useSyncExternalStore(
    N.useCallback(
      (p) => {
        const h = i ? () => {
        } : l.subscribe(Fi.batchCalls(p));
        return l.updateResult(), h;
      },
      [l, i]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), N.useEffect(() => {
    l.setOptions(s, { listeners: !1 });
  }, [s, l]), sB(s, c))
    throw aB(s, l, o);
  if (pwe({
    result: c,
    errorResetBoundary: o,
    throwOnError: s.throwOnError,
    query: r.getQueryCache().get(s.queryHash)
  }))
    throw c.error;
  return (d = (f = r.getDefaultOptions().queries) == null ? void 0 : f._experimental_afterQuery) == null || d.call(
    f,
    s,
    c
  ), s.notifyOnChangeProps ? c : l.trackResult(c);
}
function pr(e, t) {
  return Ott(e, RH);
}
function dr(e, t) {
  const n = Kw(), [r] = N.useState(
    () => new htt(
      n,
      e
    )
  );
  N.useEffect(() => {
    r.setOptions(e);
  }, [r, e]);
  const i = N.useSyncExternalStore(
    N.useCallback(
      (s) => r.subscribe(Fi.batchCalls(s)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), o = N.useCallback(
    (s, l) => {
      r.mutate(s, l).catch(vtt);
    },
    [r]
  );
  if (i.error && uwe(r.options.throwOnError, [i.error]))
    throw i.error;
  return { ...i, mutate: o, mutateAsync: i.mutate };
}
var kd = {}, _ne;
function Att() {
  if (_ne) return kd;
  _ne = 1;
  var e = kd && kd.__assign || function() {
    return e = Object.assign || function(v) {
      for (var b, A = 1, w = arguments.length; A < w; A++) {
        b = arguments[A];
        for (var O in b) Object.prototype.hasOwnProperty.call(b, O) && (v[O] = b[O]);
      }
      return v;
    }, e.apply(this, arguments);
  }, t = kd && kd.__rest || function(v, b) {
    var A = {};
    for (var w in v) Object.prototype.hasOwnProperty.call(v, w) && b.indexOf(w) < 0 && (A[w] = v[w]);
    if (v != null && typeof Object.getOwnPropertySymbols == "function")
      for (var O = 0, w = Object.getOwnPropertySymbols(v); O < w.length; O++)
        b.indexOf(w[O]) < 0 && Object.prototype.propertyIsEnumerable.call(v, w[O]) && (A[w[O]] = v[w[O]]);
    return A;
  };
  Object.defineProperty(kd, "__esModule", { value: !0 }), kd.customRipple = void 0;
  var n = ie, r = function() {
    return document;
  }, i = 0.4, o = "__useRipple--ripple", s = "__useRipple--ripple-container";
  function l(v) {
    var b = (0, n.useRef)(null), A = e({ duration: 450, color: "rgba(255, 255, 255, .3)", cancelAutomatically: !1, timingFunction: "cubic-bezier(.42,.36,.28,.88)", disabled: !1, className: o, containerClassName: s, ignoreNonLeftClick: !0, ref: b }, v ?? {}), w = A.ref, O = t(A, ["ref"]), x = (0, n.useCallback)(function(S) {
      var E, k;
      if (!(!w.current || O.disabled || O.ignoreNonLeftClick && ((E = S.nativeEvent) === null || E === void 0 ? void 0 : E.which) !== 1 && ((k = S.nativeEvent) === null || k === void 0 ? void 0 : k.type) === "mousedown")) {
        var T = w.current;
        if (window.getComputedStyle(T).position === "static" && d([["position", "relative"]], T), !!T) {
          var R = T.querySelector(":scope > .".concat(O.containerClassName)), j = R ?? h(O.containerClassName);
          R || T.appendChild(j), requestAnimationFrame(function() {
            var F, L = Date.now(), _ = a(S, T, f(T, S, O)), U = ["mouseup", "touchend"], z = function() {
              var D = Date.now(), X = D - L;
              setTimeout(function() {
                p(_, O);
              }, X > 0.4 * O.duration ? 0 : i * O.duration - X);
              for (var B = 0, q = U; B < q.length; B++) {
                var H = q[B];
                r().removeEventListener(H, z);
              }
            };
            if (!O.cancelAutomatically && !m())
              for (var C = 0, I = U; C < I.length; C++) {
                var M = I[C];
                r().addEventListener(M, z);
              }
            else
              setTimeout(function() {
                return void p(_, O);
              }, O.duration * i);
            j.appendChild(_), (F = O.onSpawn) === null || F === void 0 || F.call(O, {
              ripple: _,
              cancelRipple: z,
              event: S,
              ref: w,
              container: j
            });
          });
        }
      }
    }, [w, O]);
    return [w, x];
  }
  kd.default = l;
  function c(v) {
    return function(b) {
      return l(e(e({}, v), b));
    };
  }
  kd.customRipple = c;
  function a(v, b, A) {
    var w = b.getBoundingClientRect(), O = w.top, x = w.left;
    return A.style.setProperty("top", u(v.clientY - O)), A.style.setProperty("left", u(v.clientX - x)), A;
  }
  function u(v) {
    return "".concat(v, "px");
  }
  function f(v, b, A, w) {
    var O = A.duration, x = A.color, S = A.timingFunction, E = A.className;
    w === void 0 && (w = document);
    var k = w.createElement("div"), T = b.clientX, R = b.clientY, j = v.getBoundingClientRect(), F = j.height, L = j.width, _ = j.top, U = j.left, z = Math.max(R - _, F - R + _), C = Math.max(T - U, L - T + U), I = u(Math.hypot(z, C) * 2), M = [
      ["position", "absolute"],
      ["height", I],
      ["width", I],
      ["transform", "translate(-50%, -50%) scale(0)"],
      ["pointer-events", "none"],
      ["border-radius", "50%"],
      ["opacity", ".6"],
      ["background", x],
      [
        "transition",
        "transform ".concat(O * 0.6, "ms ").concat(S, ", opacity ").concat(Math.max(O * 0.05, 140), "ms ease-out")
      ]
    ];
    return k.classList.add(E), window.requestAnimationFrame(function() {
      d([["transform", "translate(-50%, -50%) scale(1)"]], k);
    }), d(M, k);
  }
  function d(v, b) {
    if (!b)
      return b;
    for (var A = 0, w = v; A < w.length; A++) {
      var O = w[A], x = O[0], S = O[1];
      b.style.setProperty(x, S);
    }
    return b;
  }
  function p(v, b) {
    var A = b.duration, w = b.timingFunction;
    d([
      ["opacity", "0"],
      [
        "transition",
        "transform ".concat(A * 0.6, "ms ").concat(w, ", opacity ").concat(A * 0.65, "ms ease-in-out ").concat(A * 0.13, "ms")
      ]
    ], v), window.requestAnimationFrame(function() {
      v.addEventListener("transitionend", function(O) {
        O.propertyName === "opacity" && v.remove();
      });
    });
  }
  function h(v) {
    var b = r().createElement("div");
    return b.classList.add(v), d([
      ["position", "absolute"],
      ["height", "100%"],
      ["width", "100%"],
      ["border-radius", "inherit"],
      ["top", "0"],
      ["left", "0"],
      ["pointer-events", "none"],
      ["overflow", "hidden"]
    ], b);
  }
  function m() {
    var v, b;
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || ((b = (v = navigator) === null || v === void 0 ? void 0 : v.msMaxTouchPoints) !== null && b !== void 0 ? b : !1);
  }
  return kd;
}
var wtt = Att();
const xtt = /* @__PURE__ */ Sl(wtt);
function gwe(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Stt } = Object.prototype, { getPrototypeOf: DH } = Object, { iterator: oz, toStringTag: ywe } = Symbol, sz = /* @__PURE__ */ ((e) => (t) => {
  const n = Stt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), hd = (e) => (e = e.toLowerCase(), (t) => sz(t) === e), az = (e) => (t) => typeof t === e, { isArray: Gw } = Array, HA = az("undefined");
function VC(e) {
  return e !== null && !HA(e) && e.constructor !== null && !HA(e.constructor) && ml(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const vwe = hd("ArrayBuffer");
function Ett(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && vwe(e.buffer), t;
}
const Ttt = az("string"), ml = az("function"), bwe = az("number"), qC = (e) => e !== null && typeof e == "object", ktt = (e) => e === !0 || e === !1, DR = (e) => {
  if (sz(e) !== "object")
    return !1;
  const t = DH(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(ywe in e) && !(oz in e);
}, Ctt = (e) => {
  if (!qC(e) || VC(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Ntt = hd("Date"), Ptt = hd("File"), Itt = hd("Blob"), Rtt = hd("FileList"), Mtt = (e) => qC(e) && ml(e.pipe), Dtt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ml(e.append) && ((t = sz(e)) === "formdata" || // detect form-data instance
  t === "object" && ml(e.toString) && e.toString() === "[object FormData]"));
}, _tt = hd("URLSearchParams"), [Ltt, ztt, jtt, Ftt] = ["ReadableStream", "Request", "Response", "Headers"].map(hd), Utt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function BC(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), Gw(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    if (VC(e))
      return;
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (r = 0; r < s; r++)
      l = o[r], t.call(null, e[l], l, e);
  }
}
function Owe(e, t) {
  if (VC(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const xy = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Awe = (e) => !HA(e) && e !== xy;
function lB() {
  const { caseless: e, skipUndefined: t } = Awe(this) && this || {}, n = {}, r = (i, o) => {
    const s = e && Owe(n, o) || o;
    DR(n[s]) && DR(i) ? n[s] = lB(n[s], i) : DR(i) ? n[s] = lB({}, i) : Gw(i) ? n[s] = i.slice() : (!t || !HA(i)) && (n[s] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++)
    arguments[i] && BC(arguments[i], r);
  return n;
}
const Vtt = (e, t, n, { allOwnKeys: r } = {}) => (BC(t, (i, o) => {
  n && ml(i) ? e[o] = gwe(i, n) : e[o] = i;
}, { allOwnKeys: r }), e), qtt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Btt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Xtt = (e, t, n, r) => {
  let i, o, s;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      s = i[o], (!r || r(s, e, t)) && !l[s] && (t[s] = e[s], l[s] = !0);
    e = n !== !1 && DH(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Wtt = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Ztt = (e) => {
  if (!e) return null;
  if (Gw(e)) return e;
  let t = e.length;
  if (!bwe(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Htt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && DH(Uint8Array)), Qtt = (e, t) => {
  const r = (e && e[oz]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, $tt = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Ktt = hd("HTMLFormElement"), Gtt = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), Lne = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ytt = hd("RegExp"), wwe = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  BC(n, (i, o) => {
    let s;
    (s = t(i, o, e)) !== !1 && (r[o] = s || i);
  }), Object.defineProperties(e, r);
}, Jtt = (e) => {
  wwe(e, (t, n) => {
    if (ml(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (ml(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, ent = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((o) => {
      n[o] = !0;
    });
  };
  return Gw(e) ? r(e) : r(String(e).split(t)), n;
}, tnt = () => {
}, nnt = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function rnt(e) {
  return !!(e && ml(e.append) && e[ywe] === "FormData" && e[oz]);
}
const int = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (qC(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (VC(r))
        return r;
      if (!("toJSON" in r)) {
        t[i] = r;
        const o = Gw(r) ? [] : {};
        return BC(r, (s, l) => {
          const c = n(s, i + 1);
          !HA(c) && (o[l] = c);
        }), t[i] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, ont = hd("AsyncFunction"), snt = (e) => e && (qC(e) || ml(e)) && ml(e.then) && ml(e.catch), xwe = ((e, t) => e ? setImmediate : t ? ((n, r) => (xy.addEventListener("message", ({ source: i, data: o }) => {
  i === xy && o === n && r.length && r.shift()();
}, !1), (i) => {
  r.push(i), xy.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ml(xy.postMessage)
), ant = typeof queueMicrotask < "u" ? queueMicrotask.bind(xy) : typeof process < "u" && process.nextTick || xwe, lnt = (e) => e != null && ml(e[oz]), We = {
  isArray: Gw,
  isArrayBuffer: vwe,
  isBuffer: VC,
  isFormData: Dtt,
  isArrayBufferView: Ett,
  isString: Ttt,
  isNumber: bwe,
  isBoolean: ktt,
  isObject: qC,
  isPlainObject: DR,
  isEmptyObject: Ctt,
  isReadableStream: Ltt,
  isRequest: ztt,
  isResponse: jtt,
  isHeaders: Ftt,
  isUndefined: HA,
  isDate: Ntt,
  isFile: Ptt,
  isBlob: Itt,
  isRegExp: Ytt,
  isFunction: ml,
  isStream: Mtt,
  isURLSearchParams: _tt,
  isTypedArray: Htt,
  isFileList: Rtt,
  forEach: BC,
  merge: lB,
  extend: Vtt,
  trim: Utt,
  stripBOM: qtt,
  inherits: Btt,
  toFlatObject: Xtt,
  kindOf: sz,
  kindOfTest: hd,
  endsWith: Wtt,
  toArray: Ztt,
  forEachEntry: Qtt,
  matchAll: $tt,
  isHTMLForm: Ktt,
  hasOwnProperty: Lne,
  hasOwnProp: Lne,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: wwe,
  freezeMethods: Jtt,
  toObjectSet: ent,
  toCamelCase: Gtt,
  noop: tnt,
  toFiniteNumber: nnt,
  findKey: Owe,
  global: xy,
  isContextDefined: Awe,
  isSpecCompliantForm: rnt,
  toJSONObject: int,
  isAsyncFn: ont,
  isThenable: snt,
  setImmediate: xwe,
  asap: ant,
  isIterable: lnt
};
function Fn(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status ? i.status : null);
}
We.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: We.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Swe = Fn.prototype, Ewe = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Ewe[e] = { value: e };
});
Object.defineProperties(Fn, Ewe);
Object.defineProperty(Swe, "isAxiosError", { value: !0 });
Fn.from = (e, t, n, r, i, o) => {
  const s = Object.create(Swe);
  We.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (a) => a !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", c = t == null && e ? e.code : t;
  return Fn.call(s, l, c, n, r, i), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const cnt = null;
function cB(e) {
  return We.isPlainObject(e) || We.isArray(e);
}
function Twe(e) {
  return We.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function zne(e, t, n) {
  return e ? e.concat(t).map(function(i, o) {
    return i = Twe(i), !n && o ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function unt(e) {
  return We.isArray(e) && !e.some(cB);
}
const dnt = We.toFlatObject(We, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function lz(e, t, n) {
  if (!We.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = We.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, v) {
    return !We.isUndefined(v[m]);
  });
  const r = n.metaTokens, i = n.visitor || u, o = n.dots, s = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && We.isSpecCompliantForm(t);
  if (!We.isFunction(i))
    throw new TypeError("visitor must be a function");
  function a(h) {
    if (h === null) return "";
    if (We.isDate(h))
      return h.toISOString();
    if (We.isBoolean(h))
      return h.toString();
    if (!c && We.isBlob(h))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return We.isArrayBuffer(h) || We.isTypedArray(h) ? c && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function u(h, m, v) {
    let b = h;
    if (h && !v && typeof h == "object") {
      if (We.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (We.isArray(h) && unt(h) || (We.isFileList(h) || We.endsWith(m, "[]")) && (b = We.toArray(h)))
        return m = Twe(m), b.forEach(function(w, O) {
          !(We.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? zne([m], O, o) : s === null ? m : m + "[]",
            a(w)
          );
        }), !1;
    }
    return cB(h) ? !0 : (t.append(zne(v, m, o), a(h)), !1);
  }
  const f = [], d = Object.assign(dnt, {
    defaultVisitor: u,
    convertValue: a,
    isVisitable: cB
  });
  function p(h, m) {
    if (!We.isUndefined(h)) {
      if (f.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      f.push(h), We.forEach(h, function(b, A) {
        (!(We.isUndefined(b) || b === null) && i.call(
          t,
          b,
          We.isString(A) ? A.trim() : A,
          m,
          d
        )) === !0 && p(b, m ? m.concat(A) : [A]);
      }), f.pop();
    }
  }
  if (!We.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function jne(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function _H(e, t) {
  this._pairs = [], e && lz(e, this, t);
}
const kwe = _H.prototype;
kwe.append = function(t, n) {
  this._pairs.push([t, n]);
};
kwe.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, jne);
  } : jne;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function fnt(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Cwe(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || fnt;
  We.isFunction(n) && (n = {
    serialize: n
  });
  const i = n && n.serialize;
  let o;
  if (i ? o = i(t, n) : o = We.isURLSearchParams(t) ? t.toString() : new _H(t, n).toString(r), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Fne {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    We.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Nwe = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, pnt = typeof URLSearchParams < "u" ? URLSearchParams : _H, hnt = typeof FormData < "u" ? FormData : null, mnt = typeof Blob < "u" ? Blob : null, gnt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: pnt,
    FormData: hnt,
    Blob: mnt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, LH = typeof window < "u" && typeof document < "u", uB = typeof navigator == "object" && navigator || void 0, ynt = LH && (!uB || ["ReactNative", "NativeScript", "NS"].indexOf(uB.product) < 0), vnt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", bnt = LH && window.location.href || "http://localhost", Ont = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: LH,
  hasStandardBrowserEnv: ynt,
  hasStandardBrowserWebWorkerEnv: vnt,
  navigator: uB,
  origin: bnt
}, Symbol.toStringTag, { value: "Module" })), Zs = {
  ...Ont,
  ...gnt
};
function Ant(e, t) {
  return lz(e, new Zs.classes.URLSearchParams(), {
    visitor: function(n, r, i, o) {
      return Zs.isNode && We.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function wnt(e) {
  return We.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function xnt(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let o;
  for (r = 0; r < i; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function Pwe(e) {
  function t(n, r, i, o) {
    let s = n[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), c = o >= n.length;
    return s = !s && We.isArray(i) ? i.length : s, c ? (We.hasOwnProp(i, s) ? i[s] = [i[s], r] : i[s] = r, !l) : ((!i[s] || !We.isObject(i[s])) && (i[s] = []), t(n, r, i[s], o) && We.isArray(i[s]) && (i[s] = xnt(i[s])), !l);
  }
  if (We.isFormData(e) && We.isFunction(e.entries)) {
    const n = {};
    return We.forEachEntry(e, (r, i) => {
      t(wnt(r), i, n, 0);
    }), n;
  }
  return null;
}
function Snt(e, t, n) {
  if (We.isString(e))
    try {
      return (t || JSON.parse)(e), We.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const XC = {
  transitional: Nwe,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, o = We.isObject(t);
    if (o && We.isHTMLForm(t) && (t = new FormData(t)), We.isFormData(t))
      return i ? JSON.stringify(Pwe(t)) : t;
    if (We.isArrayBuffer(t) || We.isBuffer(t) || We.isStream(t) || We.isFile(t) || We.isBlob(t) || We.isReadableStream(t))
      return t;
    if (We.isArrayBufferView(t))
      return t.buffer;
    if (We.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Ant(t, this.formSerializer).toString();
      if ((l = We.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return lz(
          l ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return o || i ? (n.setContentType("application/json", !1), Snt(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || XC.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (We.isResponse(t) || We.isReadableStream(t))
      return t;
    if (t && We.isString(t) && (r && !this.responseType || i)) {
      const s = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Zs.classes.FormData,
    Blob: Zs.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
We.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  XC.headers[e] = {};
});
const Ent = We.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Tnt = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), n = s.substring(0, i).trim().toLowerCase(), r = s.substring(i + 1).trim(), !(!n || t[n] && Ent[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Une = Symbol("internals");
function Yx(e) {
  return e && String(e).trim().toLowerCase();
}
function _R(e) {
  return e === !1 || e == null ? e : We.isArray(e) ? e.map(_R) : String(e);
}
function knt(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Cnt = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function s5(e, t, n, r, i) {
  if (We.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!We.isString(t)) {
    if (We.isString(r))
      return t.indexOf(r) !== -1;
    if (We.isRegExp(r))
      return r.test(t);
  }
}
function Nnt(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Pnt(e, t) {
  const n = We.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, o, s) {
        return this[r].call(this, t, i, o, s);
      },
      configurable: !0
    });
  });
}
let gl = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function o(l, c, a) {
      const u = Yx(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = We.findKey(i, u);
      (!f || i[f] === void 0 || a === !0 || a === void 0 && i[f] !== !1) && (i[f || c] = _R(l));
    }
    const s = (l, c) => We.forEach(l, (a, u) => o(a, u, c));
    if (We.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (We.isString(t) && (t = t.trim()) && !Cnt(t))
      s(Tnt(t), n);
    else if (We.isObject(t) && We.isIterable(t)) {
      let l = {}, c, a;
      for (const u of t) {
        if (!We.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[a = u[0]] = (c = l[a]) ? We.isArray(c) ? [...c, u[1]] : [c, u[1]] : u[1];
      }
      s(l, n);
    } else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Yx(t), t) {
      const r = We.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return knt(i);
        if (We.isFunction(n))
          return n.call(this, i, r);
        if (We.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Yx(t), t) {
      const r = We.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || s5(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function o(s) {
      if (s = Yx(s), s) {
        const l = We.findKey(r, s);
        l && (!n || s5(r, r[l], l, n)) && (delete r[l], i = !0);
      }
    }
    return We.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || s5(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return We.forEach(this, (i, o) => {
      const s = We.findKey(r, o);
      if (s) {
        n[s] = _R(i), delete n[o];
        return;
      }
      const l = t ? Nnt(o) : String(o).trim();
      l !== o && delete n[o], n[l] = _R(i), r[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return We.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && We.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[Une] = this[Une] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(s) {
      const l = Yx(s);
      r[l] || (Pnt(i, s), r[l] = !0);
    }
    return We.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
gl.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
We.reduceDescriptors(gl.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
We.freezeMethods(gl);
function a5(e, t) {
  const n = this || XC, r = t || n, i = gl.from(r.headers);
  let o = r.data;
  return We.forEach(e, function(l) {
    o = l.call(n, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function Iwe(e) {
  return !!(e && e.__CANCEL__);
}
function Yw(e, t, n) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, t, n), this.name = "CanceledError";
}
We.inherits(Yw, Fn, {
  __CANCEL__: !0
});
function Rwe(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new Fn(
    "Request failed with status code " + n.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Int(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Rnt(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, o = 0, s;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const a = Date.now(), u = r[o];
    s || (s = a), n[i] = c, r[i] = a;
    let f = o, d = 0;
    for (; f !== i; )
      d += n[f++], f = f % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), a - s < t)
      return;
    const p = u && a - u;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function Mnt(e, t) {
  let n = 0, r = 1e3 / t, i, o;
  const s = (a, u = Date.now()) => {
    n = u, i = null, o && (clearTimeout(o), o = null), e(...a);
  };
  return [(...a) => {
    const u = Date.now(), f = u - n;
    f >= r ? s(a, u) : (i = a, o || (o = setTimeout(() => {
      o = null, s(i);
    }, r - f)));
  }, () => i && s(i)];
}
const tD = (e, t, n = 3) => {
  let r = 0;
  const i = Rnt(50, 250);
  return Mnt((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, c = s - r, a = i(c), u = s <= l;
    r = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: c,
      rate: a || void 0,
      estimated: a && l && u ? (l - s) / a : void 0,
      event: o,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, n);
}, Vne = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, qne = (e) => (...t) => We.asap(() => e(...t)), Dnt = Zs.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Zs.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Zs.origin),
  Zs.navigator && /(msie|trident)/i.test(Zs.navigator.userAgent)
) : () => !0, _nt = Zs.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, i, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(t)}`];
      We.isNumber(n) && l.push(`expires=${new Date(n).toUTCString()}`), We.isString(r) && l.push(`path=${r}`), We.isString(i) && l.push(`domain=${i}`), o === !0 && l.push("secure"), We.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Lnt(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function znt(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Mwe(e, t, n) {
  let r = !Lnt(t);
  return e && (r || n == !1) ? znt(e, t) : t;
}
const Bne = (e) => e instanceof gl ? { ...e } : e;
function Tv(e, t) {
  t = t || {};
  const n = {};
  function r(a, u, f, d) {
    return We.isPlainObject(a) && We.isPlainObject(u) ? We.merge.call({ caseless: d }, a, u) : We.isPlainObject(u) ? We.merge({}, u) : We.isArray(u) ? u.slice() : u;
  }
  function i(a, u, f, d) {
    if (We.isUndefined(u)) {
      if (!We.isUndefined(a))
        return r(void 0, a, f, d);
    } else return r(a, u, f, d);
  }
  function o(a, u) {
    if (!We.isUndefined(u))
      return r(void 0, u);
  }
  function s(a, u) {
    if (We.isUndefined(u)) {
      if (!We.isUndefined(a))
        return r(void 0, a);
    } else return r(void 0, u);
  }
  function l(a, u, f) {
    if (f in t)
      return r(a, u);
    if (f in e)
      return r(void 0, a);
  }
  const c = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (a, u, f) => i(Bne(a), Bne(u), f, !0)
  };
  return We.forEach(Object.keys({ ...e, ...t }), function(u) {
    const f = c[u] || i, d = f(e[u], t[u], u);
    We.isUndefined(d) && f !== l || (n[u] = d);
  }), n;
}
const Dwe = (e) => {
  const t = Tv({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: i, xsrfCookieName: o, headers: s, auth: l } = t;
  if (t.headers = s = gl.from(s), t.url = Cwe(Mwe(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), We.isFormData(n)) {
    if (Zs.hasStandardBrowserEnv || Zs.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (We.isFunction(n.getHeaders)) {
      const c = n.getHeaders(), a = ["content-type", "content-length"];
      Object.entries(c).forEach(([u, f]) => {
        a.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Zs.hasStandardBrowserEnv && (r && We.isFunction(r) && (r = r(t)), r || r !== !1 && Dnt(t.url))) {
    const c = i && o && _nt.read(o);
    c && s.set(i, c);
  }
  return t;
}, jnt = typeof XMLHttpRequest < "u", Fnt = jnt && function(e) {
  return new Promise(function(n, r) {
    const i = Dwe(e);
    let o = i.data;
    const s = gl.from(i.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: a } = i, u, f, d, p, h;
    function m() {
      p && p(), h && h(), i.cancelToken && i.cancelToken.unsubscribe(u), i.signal && i.signal.removeEventListener("abort", u);
    }
    let v = new XMLHttpRequest();
    v.open(i.method.toUpperCase(), i.url, !0), v.timeout = i.timeout;
    function b() {
      if (!v)
        return;
      const w = gl.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), x = {
        data: !l || l === "text" || l === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: w,
        config: e,
        request: v
      };
      Rwe(function(E) {
        n(E), m();
      }, function(E) {
        r(E), m();
      }, x), v = null;
    }
    "onloadend" in v ? v.onloadend = b : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, v.onabort = function() {
      v && (r(new Fn("Request aborted", Fn.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function(O) {
      const x = O && O.message ? O.message : "Network Error", S = new Fn(x, Fn.ERR_NETWORK, e, v);
      S.event = O || null, r(S), v = null;
    }, v.ontimeout = function() {
      let O = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const x = i.transitional || Nwe;
      i.timeoutErrorMessage && (O = i.timeoutErrorMessage), r(new Fn(
        O,
        x.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        v
      )), v = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in v && We.forEach(s.toJSON(), function(O, x) {
      v.setRequestHeader(x, O);
    }), We.isUndefined(i.withCredentials) || (v.withCredentials = !!i.withCredentials), l && l !== "json" && (v.responseType = i.responseType), a && ([d, h] = tD(a, !0), v.addEventListener("progress", d)), c && v.upload && ([f, p] = tD(c), v.upload.addEventListener("progress", f), v.upload.addEventListener("loadend", p)), (i.cancelToken || i.signal) && (u = (w) => {
      v && (r(!w || w.type ? new Yw(null, e, v) : w), v.abort(), v = null);
    }, i.cancelToken && i.cancelToken.subscribe(u), i.signal && (i.signal.aborted ? u() : i.signal.addEventListener("abort", u)));
    const A = Int(i.url);
    if (A && Zs.protocols.indexOf(A) === -1) {
      r(new Fn("Unsupported protocol " + A + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, Unt = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), i;
    const o = function(a) {
      if (!i) {
        i = !0, l();
        const u = a instanceof Error ? a : this.reason;
        r.abort(u instanceof Fn ? u : new Yw(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, o(new Fn(`timeout ${t} of ms exceeded`, Fn.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((a) => {
        a.unsubscribe ? a.unsubscribe(o) : a.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((a) => a.addEventListener("abort", o));
    const { signal: c } = r;
    return c.unsubscribe = () => We.asap(l), c;
  }
}, Vnt = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, i;
  for (; r < n; )
    i = r + t, yield e.slice(r, i), r = i;
}, qnt = async function* (e, t) {
  for await (const n of Bnt(e))
    yield* Vnt(n, t);
}, Bnt = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Xne = (e, t, n, r) => {
  const i = qnt(e, t);
  let o = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: a, value: u } = await i.next();
        if (a) {
          l(), c.close();
          return;
        }
        let f = u.byteLength;
        if (n) {
          let d = o += f;
          n(d);
        }
        c.enqueue(new Uint8Array(u));
      } catch (a) {
        throw l(a), a;
      }
    },
    cancel(c) {
      return l(c), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Wne = 64 * 1024, { isFunction: bP } = We, Xnt = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(We.global), {
  ReadableStream: Zne,
  TextEncoder: Hne
} = We.global, Qne = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Wnt = (e) => {
  e = We.merge.call({
    skipUndefined: !0
  }, Xnt, e);
  const { fetch: t, Request: n, Response: r } = e, i = t ? bP(t) : typeof fetch == "function", o = bP(n), s = bP(r);
  if (!i)
    return !1;
  const l = i && bP(Zne), c = i && (typeof Hne == "function" ? /* @__PURE__ */ ((h) => (m) => h.encode(m))(new Hne()) : async (h) => new Uint8Array(await new n(h).arrayBuffer())), a = o && l && Qne(() => {
    let h = !1;
    const m = new n(Zs.origin, {
      body: new Zne(),
      method: "POST",
      get duplex() {
        return h = !0, "half";
      }
    }).headers.has("Content-Type");
    return h && !m;
  }), u = s && l && Qne(() => We.isReadableStream(new r("").body)), f = {
    stream: u && ((h) => h.body)
  };
  i && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (m, v) => {
      let b = m && m[h];
      if (b)
        return b.call(m);
      throw new Fn(`Response type '${h}' is not supported`, Fn.ERR_NOT_SUPPORT, v);
    });
  });
  const d = async (h) => {
    if (h == null)
      return 0;
    if (We.isBlob(h))
      return h.size;
    if (We.isSpecCompliantForm(h))
      return (await new n(Zs.origin, {
        method: "POST",
        body: h
      }).arrayBuffer()).byteLength;
    if (We.isArrayBufferView(h) || We.isArrayBuffer(h))
      return h.byteLength;
    if (We.isURLSearchParams(h) && (h = h + ""), We.isString(h))
      return (await c(h)).byteLength;
  }, p = async (h, m) => {
    const v = We.toFiniteNumber(h.getContentLength());
    return v ?? d(m);
  };
  return async (h) => {
    let {
      url: m,
      method: v,
      data: b,
      signal: A,
      cancelToken: w,
      timeout: O,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: E,
      headers: k,
      withCredentials: T = "same-origin",
      fetchOptions: R
    } = Dwe(h), j = t || fetch;
    E = E ? (E + "").toLowerCase() : "text";
    let F = Unt([A, w && w.toAbortSignal()], O), L = null;
    const _ = F && F.unsubscribe && (() => {
      F.unsubscribe();
    });
    let U;
    try {
      if (S && a && v !== "get" && v !== "head" && (U = await p(k, b)) !== 0) {
        let X = new n(m, {
          method: "POST",
          body: b,
          duplex: "half"
        }), B;
        if (We.isFormData(b) && (B = X.headers.get("content-type")) && k.setContentType(B), X.body) {
          const [q, H] = Vne(
            U,
            tD(qne(S))
          );
          b = Xne(X.body, Wne, q, H);
        }
      }
      We.isString(T) || (T = T ? "include" : "omit");
      const z = o && "credentials" in n.prototype, C = {
        ...R,
        signal: F,
        method: v.toUpperCase(),
        headers: k.normalize().toJSON(),
        body: b,
        duplex: "half",
        credentials: z ? T : void 0
      };
      L = o && new n(m, C);
      let I = await (o ? j(L, R) : j(m, C));
      const M = u && (E === "stream" || E === "response");
      if (u && (x || M && _)) {
        const X = {};
        ["status", "statusText", "headers"].forEach((Y) => {
          X[Y] = I[Y];
        });
        const B = We.toFiniteNumber(I.headers.get("content-length")), [q, H] = x && Vne(
          B,
          tD(qne(x), !0)
        ) || [];
        I = new r(
          Xne(I.body, Wne, q, () => {
            H && H(), _ && _();
          }),
          X
        );
      }
      E = E || "text";
      let D = await f[We.findKey(f, E) || "text"](I, h);
      return !M && _ && _(), await new Promise((X, B) => {
        Rwe(X, B, {
          data: D,
          headers: gl.from(I.headers),
          status: I.status,
          statusText: I.statusText,
          config: h,
          request: L
        });
      });
    } catch (z) {
      throw _ && _(), z && z.name === "TypeError" && /Load failed|fetch/i.test(z.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, h, L),
        {
          cause: z.cause || z
        }
      ) : Fn.from(z, z && z.code, h, L);
    }
  };
}, Znt = /* @__PURE__ */ new Map(), _we = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: r, Response: i } = t, o = [
    r,
    i,
    n
  ];
  let s = o.length, l = s, c, a, u = Znt;
  for (; l--; )
    c = o[l], a = u.get(c), a === void 0 && u.set(c, a = l ? /* @__PURE__ */ new Map() : Wnt(t)), u = a;
  return a;
};
_we();
const zH = {
  http: cnt,
  xhr: Fnt,
  fetch: {
    get: _we
  }
};
We.forEach(zH, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const $ne = (e) => `- ${e}`, Hnt = (e) => We.isFunction(e) || e === null || e === !1;
function Qnt(e, t) {
  e = We.isArray(e) ? e : [e];
  const { length: n } = e;
  let r, i;
  const o = {};
  for (let s = 0; s < n; s++) {
    r = e[s];
    let l;
    if (i = r, !Hnt(r) && (i = zH[(l = String(r)).toLowerCase()], i === void 0))
      throw new Fn(`Unknown adapter '${l}'`);
    if (i && (We.isFunction(i) || (i = i.get(t))))
      break;
    o[l || "#" + s] = i;
  }
  if (!i) {
    const s = Object.entries(o).map(
      ([c, a]) => `adapter ${c} ` + (a === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = n ? s.length > 1 ? `since :
` + s.map($ne).join(`
`) : " " + $ne(s[0]) : "as no adapter specified";
    throw new Fn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return i;
}
const Lwe = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Qnt,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: zH
};
function l5(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Yw(null, e);
}
function Kne(e) {
  return l5(e), e.headers = gl.from(e.headers), e.data = a5.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Lwe.getAdapter(e.adapter || XC.adapter, e)(e).then(function(r) {
    return l5(e), r.data = a5.call(
      e,
      e.transformResponse,
      r
    ), r.headers = gl.from(r.headers), r;
  }, function(r) {
    return Iwe(r) || (l5(e), r && r.response && (r.response.data = a5.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = gl.from(r.response.headers))), Promise.reject(r);
  });
}
const zwe = "1.13.1", cz = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  cz[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Gne = {};
cz.transitional = function(t, n, r) {
  function i(o, s) {
    return "[Axios v" + zwe + "] Transitional option '" + o + "'" + s + (r ? ". " + r : "");
  }
  return (o, s, l) => {
    if (t === !1)
      throw new Fn(
        i(s, " has been removed" + (n ? " in " + n : "")),
        Fn.ERR_DEPRECATED
      );
    return n && !Gne[s] && (Gne[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, s, l) : !0;
  };
};
cz.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function $nt(e, t, n) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const o = r[i], s = t[o];
    if (s) {
      const l = e[o], c = l === void 0 || s(l, o, e);
      if (c !== !0)
        throw new Fn("option " + o + " must be " + c, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const LR = {
  assertOptions: $nt,
  validators: cz
}, Cd = LR.validators;
let ov = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Fne(),
      response: new Fne()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const o = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Tv(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: o } = n;
    r !== void 0 && LR.assertOptions(r, {
      silentJSONParsing: Cd.transitional(Cd.boolean),
      forcedJSONParsing: Cd.transitional(Cd.boolean),
      clarifyTimeoutError: Cd.transitional(Cd.boolean)
    }, !1), i != null && (We.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : LR.assertOptions(i, {
      encode: Cd.function,
      serialize: Cd.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), LR.assertOptions(n, {
      baseUrl: Cd.spelling("baseURL"),
      withXsrfToken: Cd.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s = o && We.merge(
      o.common,
      o[n.method]
    );
    o && We.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete o[h];
      }
    ), n.headers = gl.concat(s, o);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (c = c && m.synchronous, l.unshift(m.fulfilled, m.rejected));
    });
    const a = [];
    this.interceptors.response.forEach(function(m) {
      a.push(m.fulfilled, m.rejected);
    });
    let u, f = 0, d;
    if (!c) {
      const h = [Kne.bind(this), void 0];
      for (h.unshift(...l), h.push(...a), d = h.length, u = Promise.resolve(n); f < d; )
        u = u.then(h[f++], h[f++]);
      return u;
    }
    d = l.length;
    let p = n;
    for (; f < d; ) {
      const h = l[f++], m = l[f++];
      try {
        p = h(p);
      } catch (v) {
        m.call(this, v);
        break;
      }
    }
    try {
      u = Kne.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (f = 0, d = a.length; f < d; )
      u = u.then(a[f++], a[f++]);
    return u;
  }
  getUri(t) {
    t = Tv(this.defaults, t);
    const n = Mwe(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Cwe(n, t.params, t.paramsSerializer);
  }
};
We.forEach(["delete", "get", "head", "options"], function(t) {
  ov.prototype[t] = function(n, r) {
    return this.request(Tv(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
We.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, s, l) {
      return this.request(Tv(l || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  ov.prototype[t] = n(), ov.prototype[t + "Form"] = n(!0);
});
let Knt = class jwe {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const s = new Promise((l) => {
        r.subscribe(l), o = l;
      }).then(i);
      return s.cancel = function() {
        r.unsubscribe(o);
      }, s;
    }, t(function(o, s, l) {
      r.reason || (r.reason = new Yw(o, s, l), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new jwe(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
};
function Gnt(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Ynt(e) {
  return We.isObject(e) && e.isAxiosError === !0;
}
const dB = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(dB).forEach(([e, t]) => {
  dB[t] = e;
});
function Fwe(e) {
  const t = new ov(e), n = gwe(ov.prototype.request, t);
  return We.extend(n, ov.prototype, t, { allOwnKeys: !0 }), We.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return Fwe(Tv(e, i));
  }, n;
}
const Gi = Fwe(XC);
Gi.Axios = ov;
Gi.CanceledError = Yw;
Gi.CancelToken = Knt;
Gi.isCancel = Iwe;
Gi.VERSION = zwe;
Gi.toFormData = lz;
Gi.AxiosError = Fn;
Gi.Cancel = Gi.CanceledError;
Gi.all = function(t) {
  return Promise.all(t);
};
Gi.spread = Gnt;
Gi.isAxiosError = Ynt;
Gi.mergeConfig = Tv;
Gi.AxiosHeaders = gl;
Gi.formToJSON = (e) => Pwe(We.isHTMLForm(e) ? new FormData(e) : e);
Gi.getAdapter = Lwe.getAdapter;
Gi.HttpStatusCode = dB;
Gi.default = Gi;
const {
  Axios: Rhn,
  AxiosError: Mhn,
  CanceledError: Dhn,
  isCancel: _hn,
  CancelToken: Lhn,
  VERSION: zhn,
  all: jhn,
  Cancel: Fhn,
  isAxiosError: fB,
  spread: Uhn,
  toFormData: Vhn,
  AxiosHeaders: qhn,
  HttpStatusCode: Uwe,
  formToJSON: Bhn,
  getAdapter: Xhn,
  mergeConfig: Whn
} = Gi;
var c5, Yne;
function hu() {
  return Yne || (Yne = 1, c5 = TypeError), c5;
}
const nD = {}, Jnt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nD
}, Symbol.toStringTag, { value: "Module" })), jH = /* @__PURE__ */ c2(Jnt);
var u5, Jne;
function uz() {
  if (Jne) return u5;
  Jne = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = e && t && typeof t.get == "function" ? t.get : null, r = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, o = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = i && o && typeof o.get == "function" ? o.get : null, l = i && Set.prototype.forEach, c = typeof WeakMap == "function" && WeakMap.prototype, a = c ? WeakMap.prototype.has : null, u = typeof WeakSet == "function" && WeakSet.prototype, f = u ? WeakSet.prototype.has : null, d = typeof WeakRef == "function" && WeakRef.prototype, p = d ? WeakRef.prototype.deref : null, h = Boolean.prototype.valueOf, m = Object.prototype.toString, v = Function.prototype.toString, b = String.prototype.match, A = String.prototype.slice, w = String.prototype.replace, O = String.prototype.toUpperCase, x = String.prototype.toLowerCase, S = RegExp.prototype.test, E = Array.prototype.concat, k = Array.prototype.join, T = Array.prototype.slice, R = Math.floor, j = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, F = Object.getOwnPropertySymbols, L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, _ = typeof Symbol == "function" && typeof Symbol.iterator == "object", U = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === _ || !0) ? Symbol.toStringTag : null, z = Object.prototype.propertyIsEnumerable, C = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(Re) {
    return Re.__proto__;
  } : null);
  function I(Re, _e) {
    if (Re === 1 / 0 || Re === -1 / 0 || Re !== Re || Re && Re > -1e3 && Re < 1e3 || S.call(/e/, _e))
      return _e;
    var jt = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof Re == "number") {
      var st = Re < 0 ? -R(-Re) : R(Re);
      if (st !== Re) {
        var Mt = String(st), lt = A.call(_e, Mt.length + 1);
        return w.call(Mt, jt, "$&_") + "." + w.call(w.call(lt, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return w.call(_e, jt, "$&_");
  }
  var M = jH, D = M.custom, X = Ee(D) ? D : null, B = {
    __proto__: null,
    double: '"',
    single: "'"
  }, q = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  u5 = function Re(_e, jt, st, Mt) {
    var lt = jt || {};
    if (ft(lt, "quoteStyle") && !ft(B, lt.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ft(lt, "maxStringLength") && (typeof lt.maxStringLength == "number" ? lt.maxStringLength < 0 && lt.maxStringLength !== 1 / 0 : lt.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var xt = ft(lt, "customInspect") ? lt.customInspect : !0;
    if (typeof xt != "boolean" && xt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ft(lt, "indent") && lt.indent !== null && lt.indent !== "	" && !(parseInt(lt.indent, 10) === lt.indent && lt.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ft(lt, "numericSeparator") && typeof lt.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var yt = lt.numericSeparator;
    if (typeof _e > "u")
      return "undefined";
    if (_e === null)
      return "null";
    if (typeof _e == "boolean")
      return _e ? "true" : "false";
    if (typeof _e == "string")
      return ae(_e, lt);
    if (typeof _e == "number") {
      if (_e === 0)
        return 1 / 0 / _e > 0 ? "0" : "-0";
      var ct = String(_e);
      return yt ? I(_e, ct) : ct;
    }
    if (typeof _e == "bigint") {
      var Rt = String(_e) + "n";
      return yt ? I(_e, Rt) : Rt;
    }
    var Yt = typeof lt.depth > "u" ? 5 : lt.depth;
    if (typeof st > "u" && (st = 0), st >= Yt && Yt > 0 && typeof _e == "object")
      return oe(_e) ? "[Array]" : "[Object]";
    var Gt = Jt(lt, st);
    if (typeof Mt > "u")
      Mt = [];
    else if (re(Mt, _e) >= 0)
      return "[Circular]";
    function hn(de, Ne, Me) {
      if (Ne && (Mt = T.call(Mt), Mt.push(Ne)), Me) {
        var Ge = {
          depth: lt.depth
        };
        return ft(lt, "quoteStyle") && (Ge.quoteStyle = lt.quoteStyle), Re(de, Ge, st + 1, Mt);
      }
      return Re(de, lt, st + 1, Mt);
    }
    if (typeof _e == "function" && !fe(_e)) {
      var en = Te(_e), Sn = vn(_e, hn);
      return "[Function" + (en ? ": " + en : " (anonymous)") + "]" + (Sn.length > 0 ? " { " + k.call(Sn, ", ") + " }" : "");
    }
    if (Ee(_e)) {
      var Ar = _ ? w.call(String(_e), /^(Symbol\(.*\))_[^)]*$/, "$1") : L.call(_e);
      return typeof _e == "object" && !_ ? Fe(Ar) : Ar;
    }
    if (Q(_e)) {
      for (var or = "<" + x.call(String(_e.nodeName)), rr = _e.attributes || [], no = 0; no < rr.length; no++)
        or += " " + rr[no].name + "=" + H(Y(rr[no].value), "double", lt);
      return or += ">", _e.childNodes && _e.childNodes.length && (or += "..."), or += "</" + x.call(String(_e.nodeName)) + ">", or;
    }
    if (oe(_e)) {
      if (_e.length === 0)
        return "[]";
      var jn = vn(_e, hn);
      return Gt && !Ct(jn) ? "[" + yn(jn, Gt) + "]" : "[ " + k.call(jn, ", ") + " ]";
    }
    if ($(_e)) {
      var Xi = vn(_e, hn);
      return !("cause" in Error.prototype) && "cause" in _e && !z.call(_e, "cause") ? "{ [" + String(_e) + "] " + k.call(E.call("[cause]: " + hn(_e.cause), Xi), ", ") + " }" : Xi.length === 0 ? "[" + String(_e) + "]" : "{ [" + String(_e) + "] " + k.call(Xi, ", ") + " }";
    }
    if (typeof _e == "object" && xt) {
      if (X && typeof _e[X] == "function" && M)
        return M(_e, { depth: Yt - st });
      if (xt !== "symbol" && typeof _e.inspect == "function")
        return _e.inspect();
    }
    if (le(_e)) {
      var us = [];
      return r && r.call(_e, function(de, Ne) {
        us.push(hn(Ne, _e, !0) + " => " + hn(de, _e));
      }), Ot("Map", n.call(_e), us, Gt);
    }
    if (je(_e)) {
      var ca = [];
      return l && l.call(_e, function(de) {
        ca.push(hn(de, _e));
      }), Ot("Set", s.call(_e), ca, Gt);
    }
    if (Oe(_e))
      return Ke("WeakMap");
    if (xe(_e))
      return Ke("WeakSet");
    if (be(_e))
      return Ke("WeakRef");
    if (ee(_e))
      return Fe(hn(Number(_e)));
    if (Ve(_e))
      return Fe(hn(j.call(_e)));
    if (Ce(_e))
      return Fe(h.call(_e));
    if (pe(_e))
      return Fe(hn(String(_e)));
    if (typeof window < "u" && _e === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && _e === globalThis || typeof lT < "u" && _e === lT)
      return "{ [object globalThis] }";
    if (!ce(_e) && !fe(_e)) {
      var ge = vn(_e, hn), ve = C ? C(_e) === Object.prototype : _e instanceof Object || _e.constructor === Object, se = _e instanceof Object ? "" : "null prototype", P = !ve && U && Object(_e) === _e && U in _e ? A.call(me(_e), 8, -1) : se ? "Object" : "", W = ve || typeof _e.constructor != "function" ? "" : _e.constructor.name ? _e.constructor.name + " " : "", te = W + (P || se ? "[" + k.call(E.call([], P || [], se || []), ": ") + "] " : "");
      return ge.length === 0 ? te + "{}" : Gt ? te + "{" + yn(ge, Gt) + "}" : te + "{ " + k.call(ge, ", ") + " }";
    }
    return String(_e);
  };
  function H(Re, _e, jt) {
    var st = jt.quoteStyle || _e, Mt = B[st];
    return Mt + Re + Mt;
  }
  function Y(Re) {
    return w.call(String(Re), /"/g, "&quot;");
  }
  function J(Re) {
    return !U || !(typeof Re == "object" && (U in Re || typeof Re[U] < "u"));
  }
  function oe(Re) {
    return me(Re) === "[object Array]" && J(Re);
  }
  function ce(Re) {
    return me(Re) === "[object Date]" && J(Re);
  }
  function fe(Re) {
    return me(Re) === "[object RegExp]" && J(Re);
  }
  function $(Re) {
    return me(Re) === "[object Error]" && J(Re);
  }
  function pe(Re) {
    return me(Re) === "[object String]" && J(Re);
  }
  function ee(Re) {
    return me(Re) === "[object Number]" && J(Re);
  }
  function Ce(Re) {
    return me(Re) === "[object Boolean]" && J(Re);
  }
  function Ee(Re) {
    if (_)
      return Re && typeof Re == "object" && Re instanceof Symbol;
    if (typeof Re == "symbol")
      return !0;
    if (!Re || typeof Re != "object" || !L)
      return !1;
    try {
      return L.call(Re), !0;
    } catch {
    }
    return !1;
  }
  function Ve(Re) {
    if (!Re || typeof Re != "object" || !j)
      return !1;
    try {
      return j.call(Re), !0;
    } catch {
    }
    return !1;
  }
  var et = Object.prototype.hasOwnProperty || function(Re) {
    return Re in this;
  };
  function ft(Re, _e) {
    return et.call(Re, _e);
  }
  function me(Re) {
    return m.call(Re);
  }
  function Te(Re) {
    if (Re.name)
      return Re.name;
    var _e = b.call(v.call(Re), /^function\s*([\w$]+)/);
    return _e ? _e[1] : null;
  }
  function re(Re, _e) {
    if (Re.indexOf)
      return Re.indexOf(_e);
    for (var jt = 0, st = Re.length; jt < st; jt++)
      if (Re[jt] === _e)
        return jt;
    return -1;
  }
  function le(Re) {
    if (!n || !Re || typeof Re != "object")
      return !1;
    try {
      n.call(Re);
      try {
        s.call(Re);
      } catch {
        return !0;
      }
      return Re instanceof Map;
    } catch {
    }
    return !1;
  }
  function Oe(Re) {
    if (!a || !Re || typeof Re != "object")
      return !1;
    try {
      a.call(Re, a);
      try {
        f.call(Re, f);
      } catch {
        return !0;
      }
      return Re instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function be(Re) {
    if (!p || !Re || typeof Re != "object")
      return !1;
    try {
      return p.call(Re), !0;
    } catch {
    }
    return !1;
  }
  function je(Re) {
    if (!s || !Re || typeof Re != "object")
      return !1;
    try {
      s.call(Re);
      try {
        n.call(Re);
      } catch {
        return !0;
      }
      return Re instanceof Set;
    } catch {
    }
    return !1;
  }
  function xe(Re) {
    if (!f || !Re || typeof Re != "object")
      return !1;
    try {
      f.call(Re, f);
      try {
        a.call(Re, a);
      } catch {
        return !0;
      }
      return Re instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Q(Re) {
    return !Re || typeof Re != "object" ? !1 : typeof HTMLElement < "u" && Re instanceof HTMLElement ? !0 : typeof Re.nodeName == "string" && typeof Re.getAttribute == "function";
  }
  function ae(Re, _e) {
    if (Re.length > _e.maxStringLength) {
      var jt = Re.length - _e.maxStringLength, st = "... " + jt + " more character" + (jt > 1 ? "s" : "");
      return ae(A.call(Re, 0, _e.maxStringLength), _e) + st;
    }
    var Mt = q[_e.quoteStyle || "single"];
    Mt.lastIndex = 0;
    var lt = w.call(w.call(Re, Mt, "\\$1"), /[\x00-\x1f]/g, Pe);
    return H(lt, "single", _e);
  }
  function Pe(Re) {
    var _e = Re.charCodeAt(0), jt = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[_e];
    return jt ? "\\" + jt : "\\x" + (_e < 16 ? "0" : "") + O.call(_e.toString(16));
  }
  function Fe(Re) {
    return "Object(" + Re + ")";
  }
  function Ke(Re) {
    return Re + " { ? }";
  }
  function Ot(Re, _e, jt, st) {
    var Mt = st ? yn(jt, st) : k.call(jt, ", ");
    return Re + " (" + _e + ") {" + Mt + "}";
  }
  function Ct(Re) {
    for (var _e = 0; _e < Re.length; _e++)
      if (re(Re[_e], `
`) >= 0)
        return !1;
    return !0;
  }
  function Jt(Re, _e) {
    var jt;
    if (Re.indent === "	")
      jt = "	";
    else if (typeof Re.indent == "number" && Re.indent > 0)
      jt = k.call(Array(Re.indent + 1), " ");
    else
      return null;
    return {
      base: jt,
      prev: k.call(Array(_e + 1), jt)
    };
  }
  function yn(Re, _e) {
    if (Re.length === 0)
      return "";
    var jt = `
` + _e.prev + _e.base;
    return jt + k.call(Re, "," + jt) + `
` + _e.prev;
  }
  function vn(Re, _e) {
    var jt = oe(Re), st = [];
    if (jt) {
      st.length = Re.length;
      for (var Mt = 0; Mt < Re.length; Mt++)
        st[Mt] = ft(Re, Mt) ? _e(Re[Mt], Re) : "";
    }
    var lt = typeof F == "function" ? F(Re) : [], xt;
    if (_) {
      xt = {};
      for (var yt = 0; yt < lt.length; yt++)
        xt["$" + lt[yt]] = lt[yt];
    }
    for (var ct in Re)
      ft(Re, ct) && (jt && String(Number(ct)) === ct && ct < Re.length || _ && xt["$" + ct] instanceof Symbol || (S.call(/[^\w$]/, ct) ? st.push(_e(ct, Re) + ": " + _e(Re[ct], Re)) : st.push(ct + ": " + _e(Re[ct], Re))));
    if (typeof F == "function")
      for (var Rt = 0; Rt < lt.length; Rt++)
        z.call(Re, lt[Rt]) && st.push("[" + _e(lt[Rt]) + "]: " + _e(Re[lt[Rt]], Re));
    return st;
  }
  return u5;
}
var d5, ere;
function ert() {
  if (ere) return d5;
  ere = 1;
  var e = /* @__PURE__ */ uz(), t = /* @__PURE__ */ hu(), n = function(l, c, a) {
    for (var u = l, f; (f = u.next) != null; u = f)
      if (f.key === c)
        return u.next = f.next, a || (f.next = /** @type {NonNullable<typeof list.next>} */
        l.next, l.next = f), f;
  }, r = function(l, c) {
    if (l) {
      var a = n(l, c);
      return a && a.value;
    }
  }, i = function(l, c, a) {
    var u = n(l, c);
    u ? u.value = a : l.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: c,
      next: l.next,
      value: a
    };
  }, o = function(l, c) {
    return l ? !!n(l, c) : !1;
  }, s = function(l, c) {
    if (l)
      return n(l, c, !0);
  };
  return d5 = function() {
    var c, a = {
      assert: function(u) {
        if (!a.has(u))
          throw new t("Side channel does not contain " + e(u));
      },
      delete: function(u) {
        var f = c && c.next, d = s(c, u);
        return d && f && f === d && (c = void 0), !!d;
      },
      get: function(u) {
        return r(c, u);
      },
      has: function(u) {
        return o(c, u);
      },
      set: function(u, f) {
        c || (c = {
          next: void 0
        }), i(
          /** @type {NonNullable<typeof $o>} */
          c,
          u,
          f
        );
      }
    };
    return a;
  }, d5;
}
var f5, tre;
function FH() {
  return tre || (tre = 1, f5 = Object), f5;
}
var p5, nre;
function Vwe() {
  return nre || (nre = 1, p5 = Error), p5;
}
var h5, rre;
function trt() {
  return rre || (rre = 1, h5 = EvalError), h5;
}
var m5, ire;
function nrt() {
  return ire || (ire = 1, m5 = RangeError), m5;
}
var g5, ore;
function rrt() {
  return ore || (ore = 1, g5 = ReferenceError), g5;
}
var y5, sre;
function UH() {
  return sre || (sre = 1, y5 = SyntaxError), y5;
}
var v5, are;
function irt() {
  return are || (are = 1, v5 = URIError), v5;
}
var b5, lre;
function ort() {
  return lre || (lre = 1, b5 = Math.abs), b5;
}
var O5, cre;
function srt() {
  return cre || (cre = 1, O5 = Math.floor), O5;
}
var A5, ure;
function art() {
  return ure || (ure = 1, A5 = Math.max), A5;
}
var w5, dre;
function lrt() {
  return dre || (dre = 1, w5 = Math.min), w5;
}
var x5, fre;
function crt() {
  return fre || (fre = 1, x5 = Math.pow), x5;
}
var S5, pre;
function urt() {
  return pre || (pre = 1, S5 = Math.round), S5;
}
var E5, hre;
function drt() {
  return hre || (hre = 1, E5 = Number.isNaN || function(t) {
    return t !== t;
  }), E5;
}
var T5, mre;
function frt() {
  if (mre) return T5;
  mre = 1;
  var e = /* @__PURE__ */ drt();
  return T5 = function(n) {
    return e(n) || n === 0 ? n : n < 0 ? -1 : 1;
  }, T5;
}
var k5, gre;
function prt() {
  return gre || (gre = 1, k5 = Object.getOwnPropertyDescriptor), k5;
}
var C5, yre;
function wb() {
  if (yre) return C5;
  yre = 1;
  var e = /* @__PURE__ */ prt();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return C5 = e, C5;
}
var N5, vre;
function dz() {
  if (vre) return N5;
  vre = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return N5 = e, N5;
}
var P5, bre;
function fz() {
  return bre || (bre = 1, P5 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[n] = i;
    for (var o in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var l = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, n)
      );
      if (l.value !== i || l.enumerable !== !0)
        return !1;
    }
    return !0;
  }), P5;
}
var I5, Ore;
function VH() {
  if (Ore) return I5;
  Ore = 1;
  var e = typeof Symbol < "u" && Symbol, t = fz();
  return I5 = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, I5;
}
var R5, Are;
function qwe() {
  return Are || (Are = 1, R5 = typeof Reflect < "u" && Reflect.getPrototypeOf || null), R5;
}
var M5, wre;
function Bwe() {
  if (wre) return M5;
  wre = 1;
  var e = /* @__PURE__ */ FH();
  return M5 = e.getPrototypeOf || null, M5;
}
var D5, xre;
function hrt() {
  if (xre) return D5;
  xre = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, r = "[object Function]", i = function(c, a) {
    for (var u = [], f = 0; f < c.length; f += 1)
      u[f] = c[f];
    for (var d = 0; d < a.length; d += 1)
      u[d + c.length] = a[d];
    return u;
  }, o = function(c, a) {
    for (var u = [], f = a, d = 0; f < c.length; f += 1, d += 1)
      u[d] = c[f];
    return u;
  }, s = function(l, c) {
    for (var a = "", u = 0; u < l.length; u += 1)
      a += l[u], u + 1 < l.length && (a += c);
    return a;
  };
  return D5 = function(c) {
    var a = this;
    if (typeof a != "function" || t.apply(a) !== r)
      throw new TypeError(e + a);
    for (var u = o(arguments, 1), f, d = function() {
      if (this instanceof f) {
        var b = a.apply(
          this,
          i(u, arguments)
        );
        return Object(b) === b ? b : this;
      }
      return a.apply(
        c,
        i(u, arguments)
      );
    }, p = n(0, a.length - u.length), h = [], m = 0; m < p; m++)
      h[m] = "$" + m;
    if (f = Function("binder", "return function (" + s(h, ",") + "){ return binder.apply(this,arguments); }")(d), a.prototype) {
      var v = function() {
      };
      v.prototype = a.prototype, f.prototype = new v(), v.prototype = null;
    }
    return f;
  }, D5;
}
var _5, Sre;
function WC() {
  if (Sre) return _5;
  Sre = 1;
  var e = hrt();
  return _5 = Function.prototype.bind || e, _5;
}
var L5, Ere;
function qH() {
  return Ere || (Ere = 1, L5 = Function.prototype.call), L5;
}
var z5, Tre;
function BH() {
  return Tre || (Tre = 1, z5 = Function.prototype.apply), z5;
}
var j5, kre;
function mrt() {
  return kre || (kre = 1, j5 = typeof Reflect < "u" && Reflect && Reflect.apply), j5;
}
var F5, Cre;
function Xwe() {
  if (Cre) return F5;
  Cre = 1;
  var e = WC(), t = BH(), n = qH(), r = mrt();
  return F5 = r || e.call(n, t), F5;
}
var U5, Nre;
function XH() {
  if (Nre) return U5;
  Nre = 1;
  var e = WC(), t = /* @__PURE__ */ hu(), n = qH(), r = Xwe();
  return U5 = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new t("a function is required");
    return r(e, n, o);
  }, U5;
}
var V5, Pre;
function grt() {
  if (Pre) return V5;
  Pre = 1;
  var e = XH(), t = /* @__PURE__ */ wb(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var r = !!n && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, o = i.getPrototypeOf;
  return V5 = r && typeof r.get == "function" ? e([r.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(l) {
      return o(l == null ? l : i(l));
    }
  ) : !1, V5;
}
var q5, Ire;
function WH() {
  if (Ire) return q5;
  Ire = 1;
  var e = qwe(), t = Bwe(), n = /* @__PURE__ */ grt();
  return q5 = e ? function(i) {
    return e(i);
  } : t ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return t(i);
  } : n ? function(i) {
    return n(i);
  } : null, q5;
}
var B5, Rre;
function ZH() {
  if (Rre) return B5;
  Rre = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = WC();
  return B5 = n.call(e, t), B5;
}
var X5, Mre;
function Sh() {
  if (Mre) return X5;
  Mre = 1;
  var e, t = /* @__PURE__ */ FH(), n = /* @__PURE__ */ Vwe(), r = /* @__PURE__ */ trt(), i = /* @__PURE__ */ nrt(), o = /* @__PURE__ */ rrt(), s = /* @__PURE__ */ UH(), l = /* @__PURE__ */ hu(), c = /* @__PURE__ */ irt(), a = /* @__PURE__ */ ort(), u = /* @__PURE__ */ srt(), f = /* @__PURE__ */ art(), d = /* @__PURE__ */ lrt(), p = /* @__PURE__ */ crt(), h = /* @__PURE__ */ urt(), m = /* @__PURE__ */ frt(), v = Function, b = function(fe) {
    try {
      return v('"use strict"; return (' + fe + ").constructor;")();
    } catch {
    }
  }, A = /* @__PURE__ */ wb(), w = /* @__PURE__ */ dz(), O = function() {
    throw new l();
  }, x = A ? function() {
    try {
      return arguments.callee, O;
    } catch {
      try {
        return A(arguments, "callee").get;
      } catch {
        return O;
      }
    }
  }() : O, S = VH()(), E = WH(), k = Bwe(), T = qwe(), R = BH(), j = qH(), F = {}, L = typeof Uint8Array > "u" || !E ? e : E(Uint8Array), _ = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": S && E ? E([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": F,
    "%AsyncGenerator%": F,
    "%AsyncGeneratorFunction%": F,
    "%AsyncIteratorPrototype%": F,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": v,
    "%GeneratorFunction%": F,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": S && E ? E(E([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !S || !E ? e : E((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": A,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !S || !E ? e : E((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": S && E ? E(""[Symbol.iterator]()) : e,
    "%Symbol%": S ? Symbol : e,
    "%SyntaxError%": s,
    "%ThrowTypeError%": x,
    "%TypedArray%": L,
    "%TypeError%": l,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": j,
    "%Function.prototype.apply%": R,
    "%Object.defineProperty%": w,
    "%Object.getPrototypeOf%": k,
    "%Math.abs%": a,
    "%Math.floor%": u,
    "%Math.max%": f,
    "%Math.min%": d,
    "%Math.pow%": p,
    "%Math.round%": h,
    "%Math.sign%": m,
    "%Reflect.getPrototypeOf%": T
  };
  if (E)
    try {
      null.error;
    } catch (fe) {
      var U = E(E(fe));
      _["%Error.prototype%"] = U;
    }
  var z = function fe($) {
    var pe;
    if ($ === "%AsyncFunction%")
      pe = b("async function () {}");
    else if ($ === "%GeneratorFunction%")
      pe = b("function* () {}");
    else if ($ === "%AsyncGeneratorFunction%")
      pe = b("async function* () {}");
    else if ($ === "%AsyncGenerator%") {
      var ee = fe("%AsyncGeneratorFunction%");
      ee && (pe = ee.prototype);
    } else if ($ === "%AsyncIteratorPrototype%") {
      var Ce = fe("%AsyncGenerator%");
      Ce && E && (pe = E(Ce.prototype));
    }
    return _[$] = pe, pe;
  }, C = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, I = WC(), M = /* @__PURE__ */ ZH(), D = I.call(j, Array.prototype.concat), X = I.call(R, Array.prototype.splice), B = I.call(j, String.prototype.replace), q = I.call(j, String.prototype.slice), H = I.call(j, RegExp.prototype.exec), Y = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, J = /\\(\\)?/g, oe = function($) {
    var pe = q($, 0, 1), ee = q($, -1);
    if (pe === "%" && ee !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (ee === "%" && pe !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var Ce = [];
    return B($, Y, function(Ee, Ve, et, ft) {
      Ce[Ce.length] = et ? B(ft, J, "$1") : Ve || Ee;
    }), Ce;
  }, ce = function($, pe) {
    var ee = $, Ce;
    if (M(C, ee) && (Ce = C[ee], ee = "%" + Ce[0] + "%"), M(_, ee)) {
      var Ee = _[ee];
      if (Ee === F && (Ee = z(ee)), typeof Ee > "u" && !pe)
        throw new l("intrinsic " + $ + " exists, but is not available. Please file an issue!");
      return {
        alias: Ce,
        name: ee,
        value: Ee
      };
    }
    throw new s("intrinsic " + $ + " does not exist!");
  };
  return X5 = function($, pe) {
    if (typeof $ != "string" || $.length === 0)
      throw new l("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof pe != "boolean")
      throw new l('"allowMissing" argument must be a boolean');
    if (H(/^%?[^%]*%?$/, $) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var ee = oe($), Ce = ee.length > 0 ? ee[0] : "", Ee = ce("%" + Ce + "%", pe), Ve = Ee.name, et = Ee.value, ft = !1, me = Ee.alias;
    me && (Ce = me[0], X(ee, D([0, 1], me)));
    for (var Te = 1, re = !0; Te < ee.length; Te += 1) {
      var le = ee[Te], Oe = q(le, 0, 1), be = q(le, -1);
      if ((Oe === '"' || Oe === "'" || Oe === "`" || be === '"' || be === "'" || be === "`") && Oe !== be)
        throw new s("property names with quotes must have matching quotes");
      if ((le === "constructor" || !re) && (ft = !0), Ce += "." + le, Ve = "%" + Ce + "%", M(_, Ve))
        et = _[Ve];
      else if (et != null) {
        if (!(le in et)) {
          if (!pe)
            throw new l("base intrinsic for " + $ + " exists, but the property is not available.");
          return;
        }
        if (A && Te + 1 >= ee.length) {
          var je = A(et, le);
          re = !!je, re && "get" in je && !("originalValue" in je.get) ? et = je.get : et = et[le];
        } else
          re = M(et, le), et = et[le];
        re && !ft && (_[Ve] = et);
      }
    }
    return et;
  }, X5;
}
var W5, Dre;
function ra() {
  if (Dre) return W5;
  Dre = 1;
  var e = /* @__PURE__ */ Sh(), t = XH(), n = t([e("%String.prototype.indexOf%")]);
  return W5 = function(i, o) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(i, !!o)
    );
    return typeof s == "function" && n(i, ".prototype.") > -1 ? t(
      /** @type {const} */
      [s]
    ) : s;
  }, W5;
}
var Z5, _re;
function Wwe() {
  if (_re) return Z5;
  _re = 1;
  var e = /* @__PURE__ */ Sh(), t = /* @__PURE__ */ ra(), n = /* @__PURE__ */ uz(), r = /* @__PURE__ */ hu(), i = e("%Map%", !0), o = t("Map.prototype.get", !0), s = t("Map.prototype.set", !0), l = t("Map.prototype.has", !0), c = t("Map.prototype.delete", !0), a = t("Map.prototype.size", !0);
  return Z5 = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var f, d = {
      assert: function(p) {
        if (!d.has(p))
          throw new r("Side channel does not contain " + n(p));
      },
      delete: function(p) {
        if (f) {
          var h = c(f, p);
          return a(f) === 0 && (f = void 0), h;
        }
        return !1;
      },
      get: function(p) {
        if (f)
          return o(f, p);
      },
      has: function(p) {
        return f ? l(f, p) : !1;
      },
      set: function(p, h) {
        f || (f = new i()), s(f, p, h);
      }
    };
    return d;
  }, Z5;
}
var H5, Lre;
function yrt() {
  if (Lre) return H5;
  Lre = 1;
  var e = /* @__PURE__ */ Sh(), t = /* @__PURE__ */ ra(), n = /* @__PURE__ */ uz(), r = Wwe(), i = /* @__PURE__ */ hu(), o = e("%WeakMap%", !0), s = t("WeakMap.prototype.get", !0), l = t("WeakMap.prototype.set", !0), c = t("WeakMap.prototype.has", !0), a = t("WeakMap.prototype.delete", !0);
  return H5 = o ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var f, d, p = {
        assert: function(h) {
          if (!p.has(h))
            throw new i("Side channel does not contain " + n(h));
        },
        delete: function(h) {
          if (o && h && (typeof h == "object" || typeof h == "function")) {
            if (f)
              return a(f, h);
          } else if (r && d)
            return d.delete(h);
          return !1;
        },
        get: function(h) {
          return o && h && (typeof h == "object" || typeof h == "function") && f ? s(f, h) : d && d.get(h);
        },
        has: function(h) {
          return o && h && (typeof h == "object" || typeof h == "function") && f ? c(f, h) : !!d && d.has(h);
        },
        set: function(h, m) {
          o && h && (typeof h == "object" || typeof h == "function") ? (f || (f = new o()), l(f, h, m)) : r && (d || (d = r()), d.set(h, m));
        }
      };
      return p;
    }
  ) : r, H5;
}
var Q5, zre;
function pz() {
  if (zre) return Q5;
  zre = 1;
  var e = /* @__PURE__ */ hu(), t = /* @__PURE__ */ uz(), n = ert(), r = Wwe(), i = yrt(), o = i || r || n;
  return Q5 = function() {
    var l, c = {
      assert: function(a) {
        if (!c.has(a))
          throw new e("Side channel does not contain " + t(a));
      },
      delete: function(a) {
        return !!l && l.delete(a);
      },
      get: function(a) {
        return l && l.get(a);
      },
      has: function(a) {
        return !!l && l.has(a);
      },
      set: function(a, u) {
        l || (l = o()), l.set(a, u);
      }
    };
    return c;
  }, Q5;
}
var $5, jre;
function HH() {
  if (jre) return $5;
  jre = 1;
  var e = String.prototype.replace, t = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return $5 = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(r) {
        return e.call(r, t, "+");
      },
      RFC3986: function(r) {
        return String(r);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, $5;
}
var K5, Fre;
function Zwe() {
  if (Fre) return K5;
  Fre = 1;
  var e = /* @__PURE__ */ HH(), t = pz(), n = Object.prototype.hasOwnProperty, r = Array.isArray, i = t(), o = function(E, k) {
    return i.set(E, k), E;
  }, s = function(E) {
    return i.has(E);
  }, l = function(E) {
    return i.get(E);
  }, c = function(E, k) {
    i.set(E, k);
  }, a = function() {
    for (var S = [], E = 0; E < 256; ++E)
      S.push("%" + ((E < 16 ? "0" : "") + E.toString(16)).toUpperCase());
    return S;
  }(), u = function(E) {
    for (; E.length > 1; ) {
      var k = E.pop(), T = k.obj[k.prop];
      if (r(T)) {
        for (var R = [], j = 0; j < T.length; ++j)
          typeof T[j] < "u" && R.push(T[j]);
        k.obj[k.prop] = R;
      }
    }
  }, f = function(E, k) {
    for (var T = k && k.plainObjects ? { __proto__: null } : {}, R = 0; R < E.length; ++R)
      typeof E[R] < "u" && (T[R] = E[R]);
    return T;
  }, d = function S(E, k, T) {
    if (!k)
      return E;
    if (typeof k != "object" && typeof k != "function") {
      if (r(E))
        E.push(k);
      else if (E && typeof E == "object")
        if (s(E)) {
          var R = l(E) + 1;
          E[R] = k, c(E, R);
        } else (T && (T.plainObjects || T.allowPrototypes) || !n.call(Object.prototype, k)) && (E[k] = !0);
      else
        return [E, k];
      return E;
    }
    if (!E || typeof E != "object") {
      if (s(k)) {
        for (var j = Object.keys(k), F = T && T.plainObjects ? { __proto__: null, 0: E } : { 0: E }, L = 0; L < j.length; L++) {
          var _ = parseInt(j[L], 10);
          F[_ + 1] = k[j[L]];
        }
        return o(F, l(k) + 1);
      }
      return [E].concat(k);
    }
    var U = E;
    return r(E) && !r(k) && (U = f(E, T)), r(E) && r(k) ? (k.forEach(function(z, C) {
      if (n.call(E, C)) {
        var I = E[C];
        I && typeof I == "object" && z && typeof z == "object" ? E[C] = S(I, z, T) : E.push(z);
      } else
        E[C] = z;
    }), E) : Object.keys(k).reduce(function(z, C) {
      var I = k[C];
      return n.call(z, C) ? z[C] = S(z[C], I, T) : z[C] = I, z;
    }, U);
  }, p = function(E, k) {
    return Object.keys(k).reduce(function(T, R) {
      return T[R] = k[R], T;
    }, E);
  }, h = function(S, E, k) {
    var T = S.replace(/\+/g, " ");
    if (k === "iso-8859-1")
      return T.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(T);
    } catch {
      return T;
    }
  }, m = 1024, v = function(E, k, T, R, j) {
    if (E.length === 0)
      return E;
    var F = E;
    if (typeof E == "symbol" ? F = Symbol.prototype.toString.call(E) : typeof E != "string" && (F = String(E)), T === "iso-8859-1")
      return escape(F).replace(/%u[0-9a-f]{4}/gi, function(M) {
        return "%26%23" + parseInt(M.slice(2), 16) + "%3B";
      });
    for (var L = "", _ = 0; _ < F.length; _ += m) {
      for (var U = F.length >= m ? F.slice(_, _ + m) : F, z = [], C = 0; C < U.length; ++C) {
        var I = U.charCodeAt(C);
        if (I === 45 || I === 46 || I === 95 || I === 126 || I >= 48 && I <= 57 || I >= 65 && I <= 90 || I >= 97 && I <= 122 || j === e.RFC1738 && (I === 40 || I === 41)) {
          z[z.length] = U.charAt(C);
          continue;
        }
        if (I < 128) {
          z[z.length] = a[I];
          continue;
        }
        if (I < 2048) {
          z[z.length] = a[192 | I >> 6] + a[128 | I & 63];
          continue;
        }
        if (I < 55296 || I >= 57344) {
          z[z.length] = a[224 | I >> 12] + a[128 | I >> 6 & 63] + a[128 | I & 63];
          continue;
        }
        C += 1, I = 65536 + ((I & 1023) << 10 | U.charCodeAt(C) & 1023), z[z.length] = a[240 | I >> 18] + a[128 | I >> 12 & 63] + a[128 | I >> 6 & 63] + a[128 | I & 63];
      }
      L += z.join("");
    }
    return L;
  }, b = function(E) {
    for (var k = [{ obj: { o: E }, prop: "o" }], T = [], R = 0; R < k.length; ++R)
      for (var j = k[R], F = j.obj[j.prop], L = Object.keys(F), _ = 0; _ < L.length; ++_) {
        var U = L[_], z = F[U];
        typeof z == "object" && z !== null && T.indexOf(z) === -1 && (k.push({ obj: F, prop: U }), T.push(z));
      }
    return u(k), E;
  }, A = function(E) {
    return Object.prototype.toString.call(E) === "[object RegExp]";
  }, w = function(E) {
    return !E || typeof E != "object" ? !1 : !!(E.constructor && E.constructor.isBuffer && E.constructor.isBuffer(E));
  }, O = function(E, k, T, R) {
    if (s(E)) {
      var j = l(E) + 1;
      return E[j] = k, c(E, j), E;
    }
    var F = [].concat(E, k);
    return F.length > T ? o(f(F, { plainObjects: R }), F.length - 1) : F;
  }, x = function(E, k) {
    if (r(E)) {
      for (var T = [], R = 0; R < E.length; R += 1)
        T.push(k(E[R]));
      return T;
    }
    return k(E);
  };
  return K5 = {
    arrayToObject: f,
    assign: p,
    combine: O,
    compact: b,
    decode: h,
    encode: v,
    isBuffer: w,
    isOverflow: s,
    isRegExp: A,
    maybeMap: x,
    merge: d
  }, K5;
}
var G5, Ure;
function vrt() {
  if (Ure) return G5;
  Ure = 1;
  var e = pz(), t = /* @__PURE__ */ Zwe(), n = /* @__PURE__ */ HH(), r = Object.prototype.hasOwnProperty, i = {
    brackets: function(v) {
      return v + "[]";
    },
    comma: "comma",
    indices: function(v, b) {
      return v + "[" + b + "]";
    },
    repeat: function(v) {
      return v;
    }
  }, o = Array.isArray, s = Array.prototype.push, l = function(m, v) {
    s.apply(m, o(v) ? v : [v]);
  }, c = Date.prototype.toISOString, a = n.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: a,
    formatter: n.formatters[a],
    // deprecated
    indices: !1,
    serializeDate: function(v) {
      return c.call(v);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, f = function(v) {
    return typeof v == "string" || typeof v == "number" || typeof v == "boolean" || typeof v == "symbol" || typeof v == "bigint";
  }, d = {}, p = function m(v, b, A, w, O, x, S, E, k, T, R, j, F, L, _, U, z, C) {
    for (var I = v, M = C, D = 0, X = !1; (M = M.get(d)) !== void 0 && !X; ) {
      var B = M.get(v);
      if (D += 1, typeof B < "u") {
        if (B === D)
          throw new RangeError("Cyclic object value");
        X = !0;
      }
      typeof M.get(d) > "u" && (D = 0);
    }
    if (typeof T == "function" ? I = T(b, I) : I instanceof Date ? I = F(I) : A === "comma" && o(I) && (I = t.maybeMap(I, function(Ve) {
      return Ve instanceof Date ? F(Ve) : Ve;
    })), I === null) {
      if (x)
        return k && !U ? k(b, u.encoder, z, "key", L) : b;
      I = "";
    }
    if (f(I) || t.isBuffer(I)) {
      if (k) {
        var q = U ? b : k(b, u.encoder, z, "key", L);
        return [_(q) + "=" + _(k(I, u.encoder, z, "value", L))];
      }
      return [_(b) + "=" + _(String(I))];
    }
    var H = [];
    if (typeof I > "u")
      return H;
    var Y;
    if (A === "comma" && o(I))
      U && k && (I = t.maybeMap(I, k)), Y = [{ value: I.length > 0 ? I.join(",") || null : void 0 }];
    else if (o(T))
      Y = T;
    else {
      var J = Object.keys(I);
      Y = R ? J.sort(R) : J;
    }
    var oe = E ? String(b).replace(/\./g, "%2E") : String(b), ce = w && o(I) && I.length === 1 ? oe + "[]" : oe;
    if (O && o(I) && I.length === 0)
      return ce + "[]";
    for (var fe = 0; fe < Y.length; ++fe) {
      var $ = Y[fe], pe = typeof $ == "object" && $ && typeof $.value < "u" ? $.value : I[$];
      if (!(S && pe === null)) {
        var ee = j && E ? String($).replace(/\./g, "%2E") : String($), Ce = o(I) ? typeof A == "function" ? A(ce, ee) : ce : ce + (j ? "." + ee : "[" + ee + "]");
        C.set(v, D);
        var Ee = e();
        Ee.set(d, C), l(H, m(
          pe,
          Ce,
          A,
          w,
          O,
          x,
          S,
          E,
          A === "comma" && U && o(I) ? null : k,
          T,
          R,
          j,
          F,
          L,
          _,
          U,
          z,
          Ee
        ));
      }
    }
    return H;
  }, h = function(v) {
    if (!v)
      return u;
    if (typeof v.allowEmptyArrays < "u" && typeof v.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof v.encodeDotInKeys < "u" && typeof v.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (v.encoder !== null && typeof v.encoder < "u" && typeof v.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var b = v.charset || u.charset;
    if (typeof v.charset < "u" && v.charset !== "utf-8" && v.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var A = n.default;
    if (typeof v.format < "u") {
      if (!r.call(n.formatters, v.format))
        throw new TypeError("Unknown format option provided.");
      A = v.format;
    }
    var w = n.formatters[A], O = u.filter;
    (typeof v.filter == "function" || o(v.filter)) && (O = v.filter);
    var x;
    if (v.arrayFormat in i ? x = v.arrayFormat : "indices" in v ? x = v.indices ? "indices" : "repeat" : x = u.arrayFormat, "commaRoundTrip" in v && typeof v.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var S = typeof v.allowDots > "u" ? v.encodeDotInKeys === !0 ? !0 : u.allowDots : !!v.allowDots;
    return {
      addQueryPrefix: typeof v.addQueryPrefix == "boolean" ? v.addQueryPrefix : u.addQueryPrefix,
      allowDots: S,
      allowEmptyArrays: typeof v.allowEmptyArrays == "boolean" ? !!v.allowEmptyArrays : u.allowEmptyArrays,
      arrayFormat: x,
      charset: b,
      charsetSentinel: typeof v.charsetSentinel == "boolean" ? v.charsetSentinel : u.charsetSentinel,
      commaRoundTrip: !!v.commaRoundTrip,
      delimiter: typeof v.delimiter > "u" ? u.delimiter : v.delimiter,
      encode: typeof v.encode == "boolean" ? v.encode : u.encode,
      encodeDotInKeys: typeof v.encodeDotInKeys == "boolean" ? v.encodeDotInKeys : u.encodeDotInKeys,
      encoder: typeof v.encoder == "function" ? v.encoder : u.encoder,
      encodeValuesOnly: typeof v.encodeValuesOnly == "boolean" ? v.encodeValuesOnly : u.encodeValuesOnly,
      filter: O,
      format: A,
      formatter: w,
      serializeDate: typeof v.serializeDate == "function" ? v.serializeDate : u.serializeDate,
      skipNulls: typeof v.skipNulls == "boolean" ? v.skipNulls : u.skipNulls,
      sort: typeof v.sort == "function" ? v.sort : null,
      strictNullHandling: typeof v.strictNullHandling == "boolean" ? v.strictNullHandling : u.strictNullHandling
    };
  };
  return G5 = function(m, v) {
    var b = m, A = h(v), w, O;
    typeof A.filter == "function" ? (O = A.filter, b = O("", b)) : o(A.filter) && (O = A.filter, w = O);
    var x = [];
    if (typeof b != "object" || b === null)
      return "";
    var S = i[A.arrayFormat], E = S === "comma" && A.commaRoundTrip;
    w || (w = Object.keys(b)), A.sort && w.sort(A.sort);
    for (var k = e(), T = 0; T < w.length; ++T) {
      var R = w[T], j = b[R];
      A.skipNulls && j === null || l(x, p(
        j,
        R,
        S,
        E,
        A.allowEmptyArrays,
        A.strictNullHandling,
        A.skipNulls,
        A.encodeDotInKeys,
        A.encode ? A.encoder : null,
        A.filter,
        A.sort,
        A.allowDots,
        A.serializeDate,
        A.format,
        A.formatter,
        A.encodeValuesOnly,
        A.charset,
        k
      ));
    }
    var F = x.join(A.delimiter), L = A.addQueryPrefix === !0 ? "?" : "";
    return A.charsetSentinel && (A.charset === "iso-8859-1" ? L += "utf8=%26%2310003%3B&" : L += "utf8=%E2%9C%93&"), F.length > 0 ? L + F : "";
  }, G5;
}
var Y5, Vre;
function brt() {
  if (Vre) return Y5;
  Vre = 1;
  var e = /* @__PURE__ */ Zwe(), t = Object.prototype.hasOwnProperty, n = Array.isArray, r = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, i = function(p) {
    return p.replace(/&#(\d+);/g, function(h, m) {
      return String.fromCharCode(parseInt(m, 10));
    });
  }, o = function(p, h, m) {
    if (p && typeof p == "string" && h.comma && p.indexOf(",") > -1)
      return p.split(",");
    if (h.throwOnLimitExceeded && m >= h.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + h.arrayLimit + " element" + (h.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return p;
  }, s = "utf8=%26%2310003%3B", l = "utf8=%E2%9C%93", c = function(h, m) {
    var v = { __proto__: null }, b = m.ignoreQueryPrefix ? h.replace(/^\?/, "") : h;
    b = b.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var A = m.parameterLimit === 1 / 0 ? void 0 : m.parameterLimit, w = b.split(
      m.delimiter,
      m.throwOnLimitExceeded ? A + 1 : A
    );
    if (m.throwOnLimitExceeded && w.length > A)
      throw new RangeError("Parameter limit exceeded. Only " + A + " parameter" + (A === 1 ? "" : "s") + " allowed.");
    var O = -1, x, S = m.charset;
    if (m.charsetSentinel)
      for (x = 0; x < w.length; ++x)
        w[x].indexOf("utf8=") === 0 && (w[x] === l ? S = "utf-8" : w[x] === s && (S = "iso-8859-1"), O = x, x = w.length);
    for (x = 0; x < w.length; ++x)
      if (x !== O) {
        var E = w[x], k = E.indexOf("]="), T = k === -1 ? E.indexOf("=") : k + 1, R, j;
        if (T === -1 ? (R = m.decoder(E, r.decoder, S, "key"), j = m.strictNullHandling ? null : "") : (R = m.decoder(E.slice(0, T), r.decoder, S, "key"), R !== null && (j = e.maybeMap(
          o(
            E.slice(T + 1),
            m,
            n(v[R]) ? v[R].length : 0
          ),
          function(L) {
            return m.decoder(L, r.decoder, S, "value");
          }
        ))), j && m.interpretNumericEntities && S === "iso-8859-1" && (j = i(String(j))), E.indexOf("[]=") > -1 && (j = n(j) ? [j] : j), R !== null) {
          var F = t.call(v, R);
          F && m.duplicates === "combine" ? v[R] = e.combine(
            v[R],
            j,
            m.arrayLimit,
            m.plainObjects
          ) : (!F || m.duplicates === "last") && (v[R] = j);
        }
      }
    return v;
  }, a = function(p, h, m, v) {
    var b = 0;
    if (p.length > 0 && p[p.length - 1] === "[]") {
      var A = p.slice(0, -1).join("");
      b = Array.isArray(h) && h[A] ? h[A].length : 0;
    }
    for (var w = v ? h : o(h, m, b), O = p.length - 1; O >= 0; --O) {
      var x, S = p[O];
      if (S === "[]" && m.parseArrays)
        e.isOverflow(w) ? x = w : x = m.allowEmptyArrays && (w === "" || m.strictNullHandling && w === null) ? [] : e.combine(
          [],
          w,
          m.arrayLimit,
          m.plainObjects
        );
      else {
        x = m.plainObjects ? { __proto__: null } : {};
        var E = S.charAt(0) === "[" && S.charAt(S.length - 1) === "]" ? S.slice(1, -1) : S, k = m.decodeDotInKeys ? E.replace(/%2E/g, ".") : E, T = parseInt(k, 10);
        !m.parseArrays && k === "" ? x = { 0: w } : !isNaN(T) && S !== k && String(T) === k && T >= 0 && m.parseArrays && T <= m.arrayLimit ? (x = [], x[T] = w) : k !== "__proto__" && (x[k] = w);
      }
      w = x;
    }
    return w;
  }, u = function(h, m) {
    var v = m.allowDots ? h.replace(/\.([^.[]+)/g, "[$1]") : h;
    if (m.depth <= 0)
      return !m.plainObjects && t.call(Object.prototype, v) && !m.allowPrototypes ? void 0 : [v];
    var b = /(\[[^[\]]*])/, A = /(\[[^[\]]*])/g, w = b.exec(v), O = w ? v.slice(0, w.index) : v, x = [];
    if (O) {
      if (!m.plainObjects && t.call(Object.prototype, O) && !m.allowPrototypes)
        return;
      x.push(O);
    }
    for (var S = 0; (w = A.exec(v)) !== null && S < m.depth; ) {
      S += 1;
      var E = w[1].slice(1, -1);
      if (!m.plainObjects && t.call(Object.prototype, E) && !m.allowPrototypes)
        return;
      x.push(w[1]);
    }
    if (w) {
      if (m.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + m.depth + " and strictDepth is true");
      x.push("[" + v.slice(w.index) + "]");
    }
    return x;
  }, f = function(h, m, v, b) {
    if (h) {
      var A = u(h, v);
      if (A)
        return a(A, m, v, b);
    }
  }, d = function(h) {
    if (!h)
      return r;
    if (typeof h.allowEmptyArrays < "u" && typeof h.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof h.decodeDotInKeys < "u" && typeof h.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (h.decoder !== null && typeof h.decoder < "u" && typeof h.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof h.charset < "u" && h.charset !== "utf-8" && h.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof h.throwOnLimitExceeded < "u" && typeof h.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var m = typeof h.charset > "u" ? r.charset : h.charset, v = typeof h.duplicates > "u" ? r.duplicates : h.duplicates;
    if (v !== "combine" && v !== "first" && v !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var b = typeof h.allowDots > "u" ? h.decodeDotInKeys === !0 ? !0 : r.allowDots : !!h.allowDots;
    return {
      allowDots: b,
      allowEmptyArrays: typeof h.allowEmptyArrays == "boolean" ? !!h.allowEmptyArrays : r.allowEmptyArrays,
      allowPrototypes: typeof h.allowPrototypes == "boolean" ? h.allowPrototypes : r.allowPrototypes,
      allowSparse: typeof h.allowSparse == "boolean" ? h.allowSparse : r.allowSparse,
      arrayLimit: typeof h.arrayLimit == "number" ? h.arrayLimit : r.arrayLimit,
      charset: m,
      charsetSentinel: typeof h.charsetSentinel == "boolean" ? h.charsetSentinel : r.charsetSentinel,
      comma: typeof h.comma == "boolean" ? h.comma : r.comma,
      decodeDotInKeys: typeof h.decodeDotInKeys == "boolean" ? h.decodeDotInKeys : r.decodeDotInKeys,
      decoder: typeof h.decoder == "function" ? h.decoder : r.decoder,
      delimiter: typeof h.delimiter == "string" || e.isRegExp(h.delimiter) ? h.delimiter : r.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof h.depth == "number" || h.depth === !1 ? +h.depth : r.depth,
      duplicates: v,
      ignoreQueryPrefix: h.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof h.interpretNumericEntities == "boolean" ? h.interpretNumericEntities : r.interpretNumericEntities,
      parameterLimit: typeof h.parameterLimit == "number" ? h.parameterLimit : r.parameterLimit,
      parseArrays: h.parseArrays !== !1,
      plainObjects: typeof h.plainObjects == "boolean" ? h.plainObjects : r.plainObjects,
      strictDepth: typeof h.strictDepth == "boolean" ? !!h.strictDepth : r.strictDepth,
      strictNullHandling: typeof h.strictNullHandling == "boolean" ? h.strictNullHandling : r.strictNullHandling,
      throwOnLimitExceeded: typeof h.throwOnLimitExceeded == "boolean" ? h.throwOnLimitExceeded : !1
    };
  };
  return Y5 = function(p, h) {
    var m = d(h);
    if (p === "" || p === null || typeof p > "u")
      return m.plainObjects ? { __proto__: null } : {};
    for (var v = typeof p == "string" ? c(p, m) : p, b = m.plainObjects ? { __proto__: null } : {}, A = Object.keys(v), w = 0; w < A.length; ++w) {
      var O = A[w], x = f(O, v[O], m, typeof p == "string");
      b = e.merge(b, x, m);
    }
    return m.allowSparse === !0 ? b : e.compact(b);
  }, Y5;
}
var J5, qre;
function Ort() {
  if (qre) return J5;
  qre = 1;
  var e = /* @__PURE__ */ vrt(), t = /* @__PURE__ */ brt(), n = /* @__PURE__ */ HH();
  return J5 = {
    formats: n,
    parse: t,
    stringify: e
  }, J5;
}
var Art = /* @__PURE__ */ Ort();
const Bre = /* @__PURE__ */ Sl(Art);
var hve, mve, gve;
const Hwe = ((mve = (hve = window == null ? void 0 : window.env) == null ? void 0 : hve.REACT_APP_RAG_API_URL) == null ? void 0 : mve.replace(/\/api\/v1\/?$/, "")) || ((gve = window == null ? void 0 : window.env) == null ? void 0 : gve.REACT_APP_RAG_API_URL), kv = `${Hwe}/api/v1/omniflow`;
var yve;
const wrt = (((yve = window == null ? void 0 : window.env) == null ? void 0 : yve.REACT_APP_SOCKET_PATH) || "") + "/socket.io" || "/socket.io", xrt = [
  "/managed-authn/external-token",
  "/authentication/sign-in",
  "/authentication/sign-up",
  "/authn/local/verify-email",
  // '/flags',
  "/authn/federated/login",
  "/authn/federated/claim",
  "/otp",
  "/human-input",
  "/authn/local/reset-password",
  "/user-invitations/accept"
], Srt = ["/users/me"];
function Ert(e) {
  return !e.startsWith("http") && !e.startsWith("https");
}
function Trt(e) {
  var t, n;
  if (dt.isError(e)) {
    const r = (n = (t = e.response) == null ? void 0 : t.data) == null ? void 0 : n.code;
    (r === Ni.SESSION_EXPIRED || r === Ni.INVALID_BEARER_TOKEN) && console.log(r);
  }
}
async function tO(e, t = {}) {
  var s, l;
  let n = Ert(e) ? `${kv}${e}` : e;
  const r = n.startsWith(kv), i = xrt.some(
    (c) => e.startsWith(c)
  );
  n = n.replace("/omniflow/v1/", "/omniflow/"), e = e.replace("/v1/", "/"), console.debug("OMNIFLOW-API-REQUEST => ", e), console.debug("OMNIFLOW-API-REQUEST-RESOLVED-URL => ", n), await ((s = window.tokenManager) == null ? void 0 : s.refreshIfExpired());
  const o = (l = window.tokenManager) == null ? void 0 : l.getToken();
  return !o && !i ? Promise.reject(
    new Error("Authentication failed. You have been logged out.")
  ) : Gi({
    url: n,
    ...t,
    headers: {
      ...t.headers,
      Authorization: i || !r || !o ? void 0 : `Bearer ${o}`,
      "X-Organization-ID": localStorage.getItem("currentOrganizationId") || void 0
    }
  }).then(
    (c) => (t.responseType === "blob", c.data)
  ).catch(async (c) => {
    var a, u, f;
    if (fB(c) && ((a = c.response) == null ? void 0 : a.status) === 401 && !t._retry && (t._retry = !0, await ((u = window.tokenManager) == null ? void 0 : u.refreshIfExpired()), (f = window.tokenManager) == null ? void 0 : f.getToken()))
      return tO(e, t);
    throw fB(c) && !Srt.includes(e) && Trt(c), c;
  });
}
const dt = {
  isError(e) {
    return fB(e);
  },
  get: (e, t, n) => tO(e, {
    params: t,
    paramsSerializer: (r) => Bre.stringify(r, {
      arrayFormat: "repeat"
    }),
    ...n
  }),
  delete: (e, t, n) => tO(e, {
    method: "DELETE",
    params: t,
    data: n,
    paramsSerializer: (r) => Bre.stringify(r, {
      arrayFormat: "repeat"
    })
  }),
  post: (e, t, n, r) => tO(e, {
    method: "POST",
    data: t,
    headers: { "Content-Type": "application/json", ...r },
    params: n
  }),
  patch: (e, t, n) => tO(e, {
    method: "PATCH",
    data: t,
    headers: { "Content-Type": "application/json" },
    params: n
  }),
  any: (e, t) => tO(e, {
    ...t
  }),
  httpStatus: Uwe
}, Xre = {
  getAll() {
    return console.log("Calling flagsApi.getAll"), dt.get("/v1/flags");
  }
}, Go = {
  useFlags: () => pr({
    queryKey: ["flags"],
    queryFn: Xre.getAll,
    staleTime: 1 / 0
  }),
  useWebsiteBranding: () => ({
    websiteName: "Omniflow",
    colors: {
      avatar: "var(--color-98)",
      "blue-link": "var(--color-141)",
      danger: "var(--color-142)",
      primary: {
        default: "var(--color-75)",
        dark: "var(--color-75)",
        light: "var(--color-75)",
        medium: "var(--color-75)"
      },
      warn: {
        default: "var(--color-143)",
        light: "var(--color-144)",
        dark: "var(--color-145)"
      },
      success: {
        default: "var(--color-146)",
        light: "var(--color-147)"
      },
      selection: "var(--color-12)"
    },
    logos: {
      fullLogoUrl: `${window.env.REACT_APP_BASE_URL}/Bunyan_Logo_landscape.svg`,
      favIconUrl: `${window.env.REACT_APP_BASE_URL}/logo.png`,
      logoIconUrl: `${window.env.REACT_APP_BASE_URL}/logo.png`
    }
  }),
  useFlag: (e) => {
    var n;
    return {
      data: (n = pr({
        queryKey: ["flags"],
        queryFn: Xre.getAll,
        staleTime: 1 / 0
      }).data) == null ? void 0 : n[e]
    };
  }
}, krt = (e) => {
  const { hue: t, saturation: n, lightness: r } = Qwe(e);
  return `${t.toFixed(1)} ${(n * 100).toFixed(1)}% ${(r * 100).toFixed(1)}%`;
}, Qwe = (e) => {
  e = e.replace(/^#/, ""), e.length === 3 && (e = e.split("").map((a) => a + a).join(""));
  const t = parseInt(e.substring(0, 2), 16) / 255, n = parseInt(e.substring(2, 4), 16) / 255, r = parseInt(e.substring(4, 6), 16) / 255, i = Math.max(t, n, r), o = Math.min(t, n, r), s = (i + o) / 2;
  let l = 0, c = 0;
  if (i !== o) {
    const a = i - o;
    switch (c = s > 0.5 ? a / (2 - i - o) : a / (i + o), i) {
      case t:
        l = (n - r) / a + (n < r ? 6 : 0);
        break;
      case n:
        l = (r - t) / a + 2;
        break;
      case r:
        l = (t - n) / a + 4;
        break;
    }
    l /= 6;
  }
  return l = l * 360, {
    hue: l,
    saturation: c,
    lightness: s
  };
}, Jx = {
  hexToHslString: krt,
  parseToHsl: Qwe
}, Crt = {
  theme: "system",
  setTheme: () => null
}, $we = Ri(Crt), Nrt = (e) => {
  let t = document.querySelector("link[rel*='icon']");
  t || (t = document.createElement("link"), t.rel = "shortcut icon", document.head.appendChild(t)), t.href = e;
};
function Prt({
  children: e,
  defaultTheme: t = "dark",
  storageKey: n = "themeMode",
  ...r
}) {
  const [i, o] = He(
    () => localStorage.getItem(n) || t
  ), s = Go.useWebsiteBranding();
  nt(() => {
    if (!s) {
      console.warn("Website brand is not defined");
      return;
    }
    const c = window.document.documentElement, a = i === "system" ? "light" : i;
    switch (c.classList.remove("light-theme", "dark-theme"), document.title = s.websiteName, document.documentElement.style.setProperty(
      "--primary",
      Jx.hexToHslString(s.colors.primary.default)
    ), Nrt(s.logos.favIconUrl), a) {
      case "light": {
        document.documentElement.style.setProperty(
          "--primary-100",
          Jx.hexToHslString(s.colors.primary.light)
        ), document.documentElement.style.setProperty(
          "--primary-300",
          Jx.hexToHslString(s.colors.primary.dark)
        );
        break;
      }
      case "dark": {
        document.documentElement.style.setProperty(
          "--primary-100",
          Jx.hexToHslString(s.colors.primary.dark)
        ), document.documentElement.style.setProperty(
          "--primary-300",
          Jx.hexToHslString(s.colors.primary.light)
        );
        break;
      }
    }
    c.classList.add(`${a}-theme`);
  }, [i, s]);
  const l = {
    theme: i,
    setTheme: (c) => {
      localStorage.setItem(n, c), o(c);
    }
  };
  return /* @__PURE__ */ y($we.Provider, { ...r, value: l, children: e });
}
const Jw = () => {
  const e = kr($we);
  if (e === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}, Irt = () => {
  const { theme: e } = Jw();
  return xtt({
    color: e === "dark" ? "rgba(233, 233, 233, 0.2)" : "rgba(155, 155, 155, 0.2)",
    cancelAutomatically: !0
  });
};
function Rrt(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ZC(...e) {
  return (t) => e.forEach((n) => Rrt(n, t));
}
function xn(...e) {
  return N.useCallback(ZC(...e), e);
}
var is = N.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = N.Children.toArray(n), o = i.find(Mrt);
  if (o) {
    const s = o.props.children, l = i.map((c) => c === o ? N.Children.count(s) > 1 ? N.Children.only(null) : N.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ y(pB, { ...r, ref: t, children: N.isValidElement(s) ? N.cloneElement(s, void 0, l) : null });
  }
  return /* @__PURE__ */ y(pB, { ...r, ref: t, children: n });
});
is.displayName = "Slot";
var pB = N.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (N.isValidElement(n)) {
    const i = _rt(n);
    return N.cloneElement(n, {
      ...Drt(r, n.props),
      // @ts-ignore
      ref: t ? ZC(t, i) : i
    });
  }
  return N.Children.count(n) > 1 ? N.Children.only(null) : null;
});
pB.displayName = "SlotClone";
var Kwe = ({ children: e }) => /* @__PURE__ */ y(pt, { children: e });
function Mrt(e) {
  return N.isValidElement(e) && e.type === Kwe;
}
function Drt(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...l) => {
      o(...l), i(...l);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function _rt(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Gwe(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Gwe(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Lrt() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = Gwe(e)) && (r && (r += " "), r += t);
  return r;
}
const Wre = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Zre = Lrt, as = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Zre(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = t, s = Object.keys(i).map((a) => {
    const u = n == null ? void 0 : n[a], f = o == null ? void 0 : o[a];
    if (u === null) return null;
    const d = Wre(u) || Wre(f);
    return i[a][d];
  }), l = n && Object.entries(n).reduce((a, u) => {
    let [f, d] = u;
    return d === void 0 || (a[f] = d), a;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((a, u) => {
    let { class: f, className: d, ...p } = u;
    return Object.entries(p).every((h) => {
      let [m, v] = h;
      return Array.isArray(v) ? v.includes({
        ...o,
        ...l
      }[m]) : {
        ...o,
        ...l
      }[m] === v;
    }) ? [
      ...a,
      f,
      d
    ] : a;
  }, []);
  return Zre(e, s, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zrt = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), jrt = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), Hre = (e) => {
  const t = jrt(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Ywe = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), Frt = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Urt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vrt = Fo(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: o,
    iconNode: s,
    ...l
  }, c) => oi(
    "svg",
    {
      ref: c,
      ...Urt,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Ywe("lucide", i),
      ...!o && !Frt(l) && { "aria-hidden": "true" },
      ...l
    },
    [
      ...s.map(([a, u]) => oi(a, u)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gt = (e, t) => {
  const n = Fo(
    ({ className: r, ...i }, o) => oi(Vrt, {
      ref: o,
      iconNode: t,
      className: Ywe(
        `lucide-${zrt(Hre(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = Hre(e), n;
};
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qrt = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], Brt = gt("arrow-down", qrt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xrt = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
], Wrt = gt("arrow-left-right", Xrt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zrt = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], Hrt = gt("arrow-left", Zrt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qrt = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], Jwe = gt("arrow-right", Qrt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $rt = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Krt = gt("arrow-up", $rt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grt = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
], Yrt = gt("bold", Grt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jrt = [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
], hB = gt("bot", Jrt);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eit = [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
], tit = gt("braces", eit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nit = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], rit = gt("calendar", nit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iit = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], oit = gt("check-check", iit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sit = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Af = gt("check", sit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ait = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], ex = gt("chevron-down", ait);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lit = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], sv = gt("chevron-left", lit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cit = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], HC = gt("chevron-right", cit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uit = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], dit = gt("chevron-up", uit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fit = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], exe = gt("chevrons-up-down", fit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pit = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Qh = gt("circle-alert", pit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hit = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], mB = gt("circle-check-big", hit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mit = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], gB = gt("circle-check", mit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const git = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], Qre = gt("circle-dot", git);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yit = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], hz = gt("circle-x", yit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vit = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], QH = gt("circle", vit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bit = [
  ["path", { d: "M11 14h10", key: "1w8e9d" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v1.344", key: "1e62lh" }],
  ["path", { d: "m17 18 4-4-4-4", key: "z2g111" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 1.793-1.113", key: "bjbb7m" }],
  ["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", key: "ublpy" }]
], $re = gt("clipboard-paste", bit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oit = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
], Kre = gt("clipboard-plus", Oit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ait = [
  ["path", { d: "m16 18 6-6-6-6", key: "eg8j8" }],
  ["path", { d: "m8 6-6 6 6 6", key: "ppft3o" }]
], txe = gt("code", Ait);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wit = [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], $H = gt("copy-plus", wit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xit = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Cv = gt("copy", xit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sit = [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
], mz = gt("download", Sit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eit = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Tit = gt("ellipsis-vertical", Eit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kit = [
  ["path", { d: "m15 15 6 6", key: "1s409w" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }],
  ["path", { d: "M3 16v5h5", key: "1t08am" }],
  ["path", { d: "m3 21 6-6", key: "wwnumi" }],
  ["path", { d: "M3 8V3h5", key: "1ln10m" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }]
], Cit = gt("expand", kit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nit = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Pit = gt("eye-off", Nit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iit = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], NT = gt("eye", Iit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rit = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
], KH = gt("file", Rit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mit = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
], Dit = gt("fullscreen", Mit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _it = [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
], Lit = gt("gallery-vertical-end", _it);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zit = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], Gre = gt("globe", zit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jit = [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
], Fit = gt("goal", jit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uit = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], Vit = gt("grip-vertical", Uit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qit = [
  ["path", { d: "m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9", key: "1hayfq" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "15ts47"
    }
  ]
], Bit = gt("hammer", qit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xit = [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
], Wit = gt("hand", Xit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zit = [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
], Hit = gt("hash", Zit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qit = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], $it = gt("history", Qit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kit = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], Git = gt("image", Kit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yit = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
], Jit = gt("import", Yit);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eot = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], QA = gt("info", eot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tot = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
], not = gt("italic", tot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rot = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
], iot = gt("layout-grid", rot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oot = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], sot = gt("lightbulb", oot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aot = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], PT = gt("loader-circle", aot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lot = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], cot = gt("loader", lot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uot = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], dot = gt("lock", uot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fot = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
], pot = gt("mail", fot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hot = [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], mot = gt("map", hot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const got = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "18887p"
    }
  ],
  ["path", { d: "M7 11h10", key: "1twpyw" }],
  ["path", { d: "M7 15h6", key: "d9of3u" }],
  ["path", { d: "M7 7h8", key: "af5zfr" }]
], yot = gt("message-square-text", got);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vot = [["path", { d: "M5 12h14", key: "1ays0h" }]], GH = gt("minus", vot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bot = [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
], Oot = gt("mouse-pointer", bot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aot = [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], wot = gt("move-left", Aot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xot = [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Sot = gt("octagon-x", xot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eot = [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
], Tot = gt("package-open", Eot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kot = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
], Cot = gt("package", kot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Not = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], Pot = gt("panel-left", Not);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iot = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
], Rot = gt("panel-right-dashed", Iot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mot = [
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
      key: "1miecu"
    }
  ]
], nxe = gt("paperclip", Mot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dot = [
  ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1", key: "kaeet6" }],
  ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1", key: "1wsw3u" }]
], Yre = gt("pause", Dot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ot = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], $A = gt("pencil", _ot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lot = [
  [
    "path",
    {
      d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
      key: "10ikf1"
    }
  ]
], zot = gt("play", Lot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jot = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Da = gt("plus", jot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fot = [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
], rxe = gt("puzzle", Fot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uot = [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
], rD = gt("refresh-ccw", Uot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vot = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
], qot = gt("repeat", Vot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bot = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Xot = gt("rotate-ccw", Bot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wot = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], ixe = gt("route-off", Wot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zot = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], Hot = gt("route", Zot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qot = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], YH = gt("search-x", Qot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ot = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], QC = gt("search", $ot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kot = [
  [
    "path",
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      key: "1s2grr"
    }
  ],
  ["path", { d: "M20 2v4", key: "1rf3ol" }],
  ["path", { d: "M22 4h-4", key: "gwowj6" }],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
], Got = gt("sparkles", Kot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yot = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
], Jot = gt("split", Yot);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const est = [
  [
    "path",
    { d: "M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344", key: "2acyp4" }
  ],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], tst = gt("square-check-big", est);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nst = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
], rst = gt("square-function", nst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ist = [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
], ost = gt("square-terminal", ist);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sst = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], ast = gt("strikethrough", sst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lst = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
], cst = gt("timer-reset", lst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ust = [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
], iD = gt("timer", ust);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dst = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], oxe = gt("trash-2", dst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fst = [
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], xb = gt("trash", fst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pst = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], gz = gt("triangle-alert", pst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hst = [
  ["path", { d: "M12 4v16", key: "1654pz" }],
  ["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2", key: "e0r10z" }],
  ["path", { d: "M9 20h6", key: "s66wpe" }]
], mst = gt("type", hst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gst = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
], yst = gt("underline", gst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vst = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], bst = gt("video", vst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ost = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], JH = gt("workflow", Ost);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ast = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
      key: "1ngwbx"
    }
  ]
], sxe = gt("wrench", Ast);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wst = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], ks = gt("x", wst);
/**
 * @license lucide-react v0.544.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xst = [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
], Sst = gt("zap", xst);
function axe(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = axe(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Est() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = axe(e)) && (r && (r += " "), r += t);
  return r;
}
var zR = { exports: {} }, Tst = zR.exports, Jre;
function kst() {
  return Jre || (Jre = 1, function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(Tst, function() {
      var n = 1e3, r = 6e4, i = 36e5, o = "millisecond", s = "second", l = "minute", c = "hour", a = "day", u = "week", f = "month", d = "quarter", p = "year", h = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(L) {
        var _ = ["th", "st", "nd", "rd"], U = L % 100;
        return "[" + L + (_[(U - 20) % 10] || _[U] || _[0]) + "]";
      } }, w = function(L, _, U) {
        var z = String(L);
        return !z || z.length >= _ ? L : "" + Array(_ + 1 - z.length).join(U) + L;
      }, O = { s: w, z: function(L) {
        var _ = -L.utcOffset(), U = Math.abs(_), z = Math.floor(U / 60), C = U % 60;
        return (_ <= 0 ? "+" : "-") + w(z, 2, "0") + ":" + w(C, 2, "0");
      }, m: function L(_, U) {
        if (_.date() < U.date()) return -L(U, _);
        var z = 12 * (U.year() - _.year()) + (U.month() - _.month()), C = _.clone().add(z, f), I = U - C < 0, M = _.clone().add(z + (I ? -1 : 1), f);
        return +(-(z + (U - C) / (I ? C - M : M - C)) || 0);
      }, a: function(L) {
        return L < 0 ? Math.ceil(L) || 0 : Math.floor(L);
      }, p: function(L) {
        return { M: f, y: p, w: u, d: a, D: h, h: c, m: l, s, ms: o, Q: d }[L] || String(L || "").toLowerCase().replace(/s$/, "");
      }, u: function(L) {
        return L === void 0;
      } }, x = "en", S = {};
      S[x] = A;
      var E = function(L) {
        return L instanceof j;
      }, k = function L(_, U, z) {
        var C;
        if (!_) return x;
        if (typeof _ == "string") {
          var I = _.toLowerCase();
          S[I] && (C = I), U && (S[I] = U, C = I);
          var M = _.split("-");
          if (!C && M.length > 1) return L(M[0]);
        } else {
          var D = _.name;
          S[D] = _, C = D;
        }
        return !z && C && (x = C), C || !z && x;
      }, T = function(L, _) {
        if (E(L)) return L.clone();
        var U = typeof _ == "object" ? _ : {};
        return U.date = L, U.args = arguments, new j(U);
      }, R = O;
      R.l = k, R.i = E, R.w = function(L, _) {
        return T(L, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
      };
      var j = function() {
        function L(U) {
          this.$L = k(U.locale, null, !0), this.parse(U);
        }
        var _ = L.prototype;
        return _.parse = function(U) {
          this.$d = function(z) {
            var C = z.date, I = z.utc;
            if (C === null) return /* @__PURE__ */ new Date(NaN);
            if (R.u(C)) return /* @__PURE__ */ new Date();
            if (C instanceof Date) return new Date(C);
            if (typeof C == "string" && !/Z$/i.test(C)) {
              var M = C.match(v);
              if (M) {
                var D = M[2] - 1 || 0, X = (M[7] || "0").substring(0, 3);
                return I ? new Date(Date.UTC(M[1], D, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, X)) : new Date(M[1], D, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, X);
              }
            }
            return new Date(C);
          }(U), this.$x = U.x || {}, this.init();
        }, _.init = function() {
          var U = this.$d;
          this.$y = U.getFullYear(), this.$M = U.getMonth(), this.$D = U.getDate(), this.$W = U.getDay(), this.$H = U.getHours(), this.$m = U.getMinutes(), this.$s = U.getSeconds(), this.$ms = U.getMilliseconds();
        }, _.$utils = function() {
          return R;
        }, _.isValid = function() {
          return this.$d.toString() !== m;
        }, _.isSame = function(U, z) {
          var C = T(U);
          return this.startOf(z) <= C && C <= this.endOf(z);
        }, _.isAfter = function(U, z) {
          return T(U) < this.startOf(z);
        }, _.isBefore = function(U, z) {
          return this.endOf(z) < T(U);
        }, _.$g = function(U, z, C) {
          return R.u(U) ? this[z] : this.set(C, U);
        }, _.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, _.valueOf = function() {
          return this.$d.getTime();
        }, _.startOf = function(U, z) {
          var C = this, I = !!R.u(z) || z, M = R.p(U), D = function(ce, fe) {
            var $ = R.w(C.$u ? Date.UTC(C.$y, fe, ce) : new Date(C.$y, fe, ce), C);
            return I ? $ : $.endOf(a);
          }, X = function(ce, fe) {
            return R.w(C.toDate()[ce].apply(C.toDate("s"), (I ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(fe)), C);
          }, B = this.$W, q = this.$M, H = this.$D, Y = "set" + (this.$u ? "UTC" : "");
          switch (M) {
            case p:
              return I ? D(1, 0) : D(31, 11);
            case f:
              return I ? D(1, q) : D(0, q + 1);
            case u:
              var J = this.$locale().weekStart || 0, oe = (B < J ? B + 7 : B) - J;
              return D(I ? H - oe : H + (6 - oe), q);
            case a:
            case h:
              return X(Y + "Hours", 0);
            case c:
              return X(Y + "Minutes", 1);
            case l:
              return X(Y + "Seconds", 2);
            case s:
              return X(Y + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, _.endOf = function(U) {
          return this.startOf(U, !1);
        }, _.$set = function(U, z) {
          var C, I = R.p(U), M = "set" + (this.$u ? "UTC" : ""), D = (C = {}, C[a] = M + "Date", C[h] = M + "Date", C[f] = M + "Month", C[p] = M + "FullYear", C[c] = M + "Hours", C[l] = M + "Minutes", C[s] = M + "Seconds", C[o] = M + "Milliseconds", C)[I], X = I === a ? this.$D + (z - this.$W) : z;
          if (I === f || I === p) {
            var B = this.clone().set(h, 1);
            B.$d[D](X), B.init(), this.$d = B.set(h, Math.min(this.$D, B.daysInMonth())).$d;
          } else D && this.$d[D](X);
          return this.init(), this;
        }, _.set = function(U, z) {
          return this.clone().$set(U, z);
        }, _.get = function(U) {
          return this[R.p(U)]();
        }, _.add = function(U, z) {
          var C, I = this;
          U = Number(U);
          var M = R.p(z), D = function(q) {
            var H = T(I);
            return R.w(H.date(H.date() + Math.round(q * U)), I);
          };
          if (M === f) return this.set(f, this.$M + U);
          if (M === p) return this.set(p, this.$y + U);
          if (M === a) return D(1);
          if (M === u) return D(7);
          var X = (C = {}, C[l] = r, C[c] = i, C[s] = n, C)[M] || 1, B = this.$d.getTime() + U * X;
          return R.w(B, this);
        }, _.subtract = function(U, z) {
          return this.add(-1 * U, z);
        }, _.format = function(U) {
          var z = this, C = this.$locale();
          if (!this.isValid()) return C.invalidDate || m;
          var I = U || "YYYY-MM-DDTHH:mm:ssZ", M = R.z(this), D = this.$H, X = this.$m, B = this.$M, q = C.weekdays, H = C.months, Y = C.meridiem, J = function(fe, $, pe, ee) {
            return fe && (fe[$] || fe(z, I)) || pe[$].slice(0, ee);
          }, oe = function(fe) {
            return R.s(D % 12 || 12, fe, "0");
          }, ce = Y || function(fe, $, pe) {
            var ee = fe < 12 ? "AM" : "PM";
            return pe ? ee.toLowerCase() : ee;
          };
          return I.replace(b, function(fe, $) {
            return $ || function(pe) {
              switch (pe) {
                case "YY":
                  return String(z.$y).slice(-2);
                case "YYYY":
                  return R.s(z.$y, 4, "0");
                case "M":
                  return B + 1;
                case "MM":
                  return R.s(B + 1, 2, "0");
                case "MMM":
                  return J(C.monthsShort, B, H, 3);
                case "MMMM":
                  return J(H, B);
                case "D":
                  return z.$D;
                case "DD":
                  return R.s(z.$D, 2, "0");
                case "d":
                  return String(z.$W);
                case "dd":
                  return J(C.weekdaysMin, z.$W, q, 2);
                case "ddd":
                  return J(C.weekdaysShort, z.$W, q, 3);
                case "dddd":
                  return q[z.$W];
                case "H":
                  return String(D);
                case "HH":
                  return R.s(D, 2, "0");
                case "h":
                  return oe(1);
                case "hh":
                  return oe(2);
                case "a":
                  return ce(D, X, !0);
                case "A":
                  return ce(D, X, !1);
                case "m":
                  return String(X);
                case "mm":
                  return R.s(X, 2, "0");
                case "s":
                  return String(z.$s);
                case "ss":
                  return R.s(z.$s, 2, "0");
                case "SSS":
                  return R.s(z.$ms, 3, "0");
                case "Z":
                  return M;
              }
              return null;
            }(fe) || M.replace(":", "");
          });
        }, _.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, _.diff = function(U, z, C) {
          var I, M = this, D = R.p(z), X = T(U), B = (X.utcOffset() - this.utcOffset()) * r, q = this - X, H = function() {
            return R.m(M, X);
          };
          switch (D) {
            case p:
              I = H() / 12;
              break;
            case f:
              I = H();
              break;
            case d:
              I = H() / 3;
              break;
            case u:
              I = (q - B) / 6048e5;
              break;
            case a:
              I = (q - B) / 864e5;
              break;
            case c:
              I = q / i;
              break;
            case l:
              I = q / r;
              break;
            case s:
              I = q / n;
              break;
            default:
              I = q;
          }
          return C ? I : R.a(I);
        }, _.daysInMonth = function() {
          return this.endOf(f).$D;
        }, _.$locale = function() {
          return S[this.$L];
        }, _.locale = function(U, z) {
          if (!U) return this.$L;
          var C = this.clone(), I = k(U, z, !0);
          return I && (C.$L = I), C;
        }, _.clone = function() {
          return R.w(this.$d, this);
        }, _.toDate = function() {
          return new Date(this.valueOf());
        }, _.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, _.toISOString = function() {
          return this.$d.toISOString();
        }, _.toString = function() {
          return this.$d.toUTCString();
        }, L;
      }(), F = j.prototype;
      return T.prototype = F, [["$ms", o], ["$s", s], ["$m", l], ["$H", c], ["$W", a], ["$M", f], ["$y", p], ["$D", h]].forEach(function(L) {
        F[L[1]] = function(_) {
          return this.$g(_, L[0], L[1]);
        };
      }), T.extend = function(L, _) {
        return L.$i || (L(_, j, T), L.$i = !0), T;
      }, T.locale = k, T.isDayjs = E, T.unix = function(L) {
        return T(1e3 * L);
      }, T.en = S[x], T.Ls = S, T.p = {}, T;
    });
  }(zR)), zR.exports;
}
var Cst = kst();
const Gd = /* @__PURE__ */ Sl(Cst), eQ = "-";
function Nst(e) {
  const t = Ist(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function i(s) {
    const l = s.split(eQ);
    return l[0] === "" && l.length !== 1 && l.shift(), lxe(l, t) || Pst(s);
  }
  function o(s, l) {
    const c = n[s] || [];
    return l && r[s] ? [...c, ...r[s]] : c;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: o
  };
}
function lxe(e, t) {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? lxe(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(eQ);
  return (s = t.validators.find(({
    validator: l
  }) => l(o))) == null ? void 0 : s.classGroupId;
}
const eie = /^\[(.+)\]$/;
function Pst(e) {
  if (eie.test(e)) {
    const t = eie.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Ist(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Mst(Object.entries(e.classGroups), n).forEach(([o, s]) => {
    yB(s, r, o, t);
  }), r;
}
function yB(e, t, n, r) {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : tie(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (Rst(i)) {
        yB(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, s]) => {
      yB(s, tie(t, o), n, r);
    });
  });
}
function tie(e, t) {
  let n = e;
  return t.split(eQ).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function Rst(e) {
  return e.isThemeGetter;
}
function Mst(e, t) {
  return t ? e.map(([n, r]) => {
    const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([s, l]) => [t + s, l])) : o);
    return [n, i];
  }) : e;
}
function Dst(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, s) {
    n.set(o, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(o) {
      let s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}
const cxe = "!";
function _st(e) {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length;
  function s(l) {
    const c = [];
    let a = 0, u = 0, f;
    for (let v = 0; v < l.length; v++) {
      let b = l[v];
      if (a === 0) {
        if (b === i && (r || l.slice(v, v + o) === t)) {
          c.push(l.slice(u, v)), u = v + o;
          continue;
        }
        if (b === "/") {
          f = v;
          continue;
        }
      }
      b === "[" ? a++ : b === "]" && a--;
    }
    const d = c.length === 0 ? l : l.substring(u), p = d.startsWith(cxe), h = p ? d.substring(1) : d, m = f && f > u ? f - u : void 0;
    return {
      modifiers: c,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: m
    };
  }
  return n ? function(c) {
    return n({
      className: c,
      parseClassName: s
    });
  } : s;
}
function Lst(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function zst(e) {
  return {
    cache: Dst(e.cacheSize),
    parseClassName: _st(e),
    ...Nst(e)
  };
}
const jst = /\s+/;
function Fst(e, t) {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = /* @__PURE__ */ new Set();
  return e.trim().split(jst).map((s) => {
    const {
      modifiers: l,
      hasImportantModifier: c,
      baseClassName: a,
      maybePostfixModifierPosition: u
    } = n(s);
    let f = !!u, d = r(f ? a.substring(0, u) : a);
    if (!d) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (d = r(a), !d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      f = !1;
    }
    const p = Lst(l).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? p + cxe : p,
      classGroupId: d,
      originalClassName: s,
      hasPostfixModifier: f
    };
  }).reverse().filter((s) => {
    if (!s.isTailwindClass)
      return !0;
    const {
      modifierId: l,
      classGroupId: c,
      hasPostfixModifier: a
    } = s, u = l + c;
    return o.has(u) ? !1 : (o.add(u), i(c, a).forEach((f) => o.add(l + f)), !0);
  }).reverse().map((s) => s.originalClassName).join(" ");
}
function Ust() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = uxe(t)) && (r && (r += " "), r += n);
  return r;
}
function uxe(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = uxe(e[r])) && (n && (n += " "), n += t);
  return n;
}
function Vst(e, ...t) {
  let n, r, i, o = s;
  function s(c) {
    const a = t.reduce((u, f) => f(u), e());
    return n = zst(a), r = n.cache.get, i = n.cache.set, o = l, l(c);
  }
  function l(c) {
    const a = r(c);
    if (a)
      return a;
    const u = Fst(c, n);
    return i(c, u), u;
  }
  return function() {
    return o(Ust.apply(null, arguments));
  };
}
function ai(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const dxe = /^\[(?:([a-z-]+):)?(.+)\]$/i, qst = /^\d+\/\d+$/, Bst = /* @__PURE__ */ new Set(["px", "full", "screen"]), Xst = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Wst = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Zst = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Hst = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Qst = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Kf(e) {
  return Sy(e) || Bst.has(e) || qst.test(e);
}
function Dh(e) {
  return tx(e, "length", nat);
}
function Sy(e) {
  return !!e && !Number.isNaN(Number(e));
}
function OP(e) {
  return tx(e, "number", Sy);
}
function eS(e) {
  return !!e && Number.isInteger(Number(e));
}
function $st(e) {
  return e.endsWith("%") && Sy(e.slice(0, -1));
}
function Un(e) {
  return dxe.test(e);
}
function _h(e) {
  return Xst.test(e);
}
const Kst = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function Gst(e) {
  return tx(e, Kst, fxe);
}
function Yst(e) {
  return tx(e, "position", fxe);
}
const Jst = /* @__PURE__ */ new Set(["image", "url"]);
function eat(e) {
  return tx(e, Jst, iat);
}
function tat(e) {
  return tx(e, "", rat);
}
function tS() {
  return !0;
}
function tx(e, t, n) {
  const r = dxe.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function nat(e) {
  return Wst.test(e) && !Zst.test(e);
}
function fxe() {
  return !1;
}
function rat(e) {
  return Hst.test(e);
}
function iat(e) {
  return Qst.test(e);
}
function oat() {
  const e = ai("colors"), t = ai("spacing"), n = ai("blur"), r = ai("brightness"), i = ai("borderColor"), o = ai("borderRadius"), s = ai("borderSpacing"), l = ai("borderWidth"), c = ai("contrast"), a = ai("grayscale"), u = ai("hueRotate"), f = ai("invert"), d = ai("gap"), p = ai("gradientColorStops"), h = ai("gradientColorStopPositions"), m = ai("inset"), v = ai("margin"), b = ai("opacity"), A = ai("padding"), w = ai("saturate"), O = ai("scale"), x = ai("sepia"), S = ai("skew"), E = ai("space"), k = ai("translate"), T = () => ["auto", "contain", "none"], R = () => ["auto", "hidden", "clip", "visible", "scroll"], j = () => ["auto", Un, t], F = () => [Un, t], L = () => ["", Kf, Dh], _ = () => ["auto", Sy, Un], U = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], z = () => ["solid", "dashed", "dotted", "double", "none"], C = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], I = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", Un], D = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], X = () => [Sy, OP], B = () => [Sy, Un];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [tS],
      spacing: [Kf, Dh],
      blur: ["none", "", _h, Un],
      brightness: X(),
      borderColor: [e],
      borderRadius: ["none", "", "full", _h, Un],
      borderSpacing: F(),
      borderWidth: L(),
      contrast: X(),
      grayscale: M(),
      hueRotate: B(),
      invert: M(),
      gap: F(),
      gradientColorStops: [e],
      gradientColorStopPositions: [$st, Dh],
      inset: j(),
      margin: j(),
      opacity: X(),
      padding: F(),
      saturate: X(),
      scale: X(),
      sepia: M(),
      skew: B(),
      space: F(),
      translate: F()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Un]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [_h]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...U(), Un]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: R()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": R()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": R()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: T()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": T()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": T()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", eS, Un]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: j()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Un]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", eS, Un]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [tS]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", eS, Un]
        }, Un]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": _()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": _()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [tS]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [eS, Un]
        }, Un]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": _()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": _()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Un]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Un]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...I()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...I(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...I(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [A]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [A]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [A]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [A]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [A]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [A]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [A]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [A]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [A]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Un, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Un, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Un, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [_h]
        }, _h]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Un, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Un, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Un, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Un, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", _h, Dh]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", OP]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [tS]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Un]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Sy, OP]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Kf, Un]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Un]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Un]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Kf, Dh]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Kf, Un]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Un]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Un]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...U(), Yst]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Gst]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, eat]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...z(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...z()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Kf, Un]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Kf, Dh]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: L()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Kf, Dh]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", _h, tat]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [tS]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...C(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": C()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", _h, Un]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [a]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [a]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Un]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: B()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Un]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: B()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Un]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [O]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [O]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [O]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [eS, Un]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [k]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [k]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Un]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Un]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Un]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Kf, Dh, OP]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const sat = /* @__PURE__ */ Vst(oat);
class YS extends Error {
}
YS.prototype.name = "InvalidTokenError";
function aat(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function lat(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return aat(t);
  } catch {
    return atob(t);
  }
}
function tQ(e, t) {
  if (typeof e != "string")
    throw new YS("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new YS(`Invalid token specified: missing part #${n + 1}`);
  let i;
  try {
    i = lat(r);
  } catch (o) {
    throw new YS(`Invalid token specified: invalid base64 for part #${n + 1} (${o.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (o) {
    throw new YS(`Invalid token specified: invalid json for part #${n + 1} (${o.message})`);
  }
}
const am = class am {
  constructor(t) {
    am.instance = t;
  }
  static getInstance() {
    return am.instance || (am.instance = window.localStorage), am.instance;
  }
  static setInstanceToSessionStorage() {
    am.instance = window.sessionStorage;
  }
};
rn(am, "instance");
let Tc = am;
const pxe = {
  signIn(e) {
    return dt.post(
      "/v1/authentication/sign-in",
      e
    );
  },
  signUp(e) {
    return dt.post(
      "/v1/authentication/sign-up",
      e
    );
  },
  getFederatedAuthLoginUrl(e) {
    return dt.get("/v1/authn/federated/login", {
      providerName: e
    });
  },
  getCurrentProjectRole(e) {
    return dt.get("/v1/project-members/role", e);
  },
  claimThirdPartyRequest(e) {
    return dt.post(
      "/v1/authn/federated/claim",
      e
    );
  },
  sendOtpEmail(e) {
    return dt.post("/v1/otp", e);
  },
  resetPassword(e) {
    return dt.post("/v1/authn/local/reset-password", e);
  },
  verifyEmail(e) {
    return dt.post("/v1/authn/local/verify-email", e);
  },
  switchPlatform(e) {
    return dt.post(
      "/v1/authentication/switch-platform",
      e
    );
  }
}, AP = "kc_access_token", Qb = "projectId", cat = (e) => {
  const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")), n = t ? decodeURIComponent(t[3]) : null;
  return n ? n.trim() : null;
}, Rn = {
  setProjectId(e) {
    Tc.getInstance().setItem(Qb, e);
  },
  saveResponse(e, t) {
    t && Tc.setInstanceToSessionStorage(), Tc.getInstance().setItem(AP, e.token), Tc.getInstance().setItem(Qb, e.projectId), window.dispatchEvent(new Event("storage"));
  },
  isJwtExpired(e) {
    if (!e)
      return !0;
    try {
      const t = tQ(e);
      return !!(t && t.exp && Gd().isAfter(Gd.unix(t.exp)));
    } catch {
      return !0;
    }
  },
  getToken() {
    return cat(AP) ?? null;
  },
  getProjectId() {
    const e = this.getToken();
    if (De(e))
      return null;
    const t = Tc.getInstance().getItem(Qb);
    if (!De(t))
      return t;
    const n = nie(e);
    return "projectId" in n && typeof n.projectId == "string" ? n.projectId : null;
  },
  getCurrentUserId() {
    const e = this.getToken();
    return De(e) ? null : nie(e).id;
  },
  appendProjectRoutePrefix(e) {
    const t = this.getProjectId();
    return De(t) ? e : `/projects/${t}${e.startsWith("/") ? e : `/${e}`}`;
  },
  getPlatformId() {
    return "omniflow";
  },
  async switchToPlatform(e) {
    if (Rn.getPlatformId() === e)
      return;
    const t = await pxe.switchPlatform({
      platformId: e
    });
    Tc.getInstance().setItem(AP, t.token), Tc.getInstance().setItem(Qb, t.projectId), window.location.href = "/";
  },
  switchToProject(e) {
    Rn.getProjectId() !== e && (Tc.getInstance().setItem(Qb, e), window.dispatchEvent(new Event("storage")));
  },
  isLoggedIn() {
    const e = this.getToken();
    return De(e) ? !1 : !this.isJwtExpired(e);
  },
  clearSession() {
    Tc.getInstance().removeItem(Qb), Tc.getInstance().removeItem(AP);
  },
  logOut() {
    this.clearSession(), window.location.href = "/sign-in";
  }
};
function nie(e) {
  return tQ(e);
}
function Se(...e) {
  return sat(Est(e));
}
const uat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, rc = {
  emailRegex: uat,
  convertEnumToHumanReadable(e) {
    return e.split(/[_.]/).map(
      (n) => n.charAt(0).toUpperCase() + n.slice(1).toLocaleLowerCase()
    ).join(" ");
  },
  convertEnumToReadable(e) {
    return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase().replace(/_/g, " ");
  },
  formatNumber(e) {
    return new Intl.NumberFormat(ur.language).format(e);
  },
  formatDateOnlyOrFail(e, t) {
    try {
      return this.formatDateOnly(e);
    } catch {
      return t;
    }
  },
  formatDateOnly(e) {
    return Intl.DateTimeFormat(ur.language, {
      month: "numeric",
      day: "numeric",
      year: "numeric"
    }).format(e);
  },
  formatDateWithTime(e, t) {
    const n = Gd(), r = Gd(e), i = r.isSame(n, "day"), o = r.isSame(n.subtract(1, "day"), "day"), s = r.isSame(n, "year"), l = new Intl.DateTimeFormat(ur.language, {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    });
    return i ? `${Z("Today")}, ${l.format(e)}` : o ? `${Z("Yesterday")}, ${l.format(e)}` : s && !t ? Intl.DateTimeFormat(ur.language, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    }).format(e) : Intl.DateTimeFormat(ur.language, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    }).format(e);
  },
  formatDate(e) {
    const t = Gd(), n = Gd(e), r = n.isSame(t, "day"), i = n.isSame(t.subtract(1, "day"), "day"), o = n.isSame(t, "year");
    return r ? Z("Today") : i ? Z("Yesterday") : o ? Intl.DateTimeFormat(ur.language, {
      month: "short",
      day: "numeric"
    }).format(e) : Intl.DateTimeFormat(ur.language, {
      month: "short",
      day: "numeric",
      year: "numeric"
    }).format(e);
  },
  formatToHoursAndMinutes(e) {
    if (e < 60)
      return `${rc.formatNumber(e)} ${Z("mins")}`;
    const t = Math.floor(e / 60);
    return `${rc.formatNumber(t)} ${Z("hours")}`;
  },
  formatDateToAgo(e) {
    const t = Gd(), n = Gd(e), r = t.diff(n, "second"), i = t.diff(n, "minute"), o = t.diff(n, "hour"), s = t.diff(n, "day"), l = new Intl.RelativeTimeFormat(
      ur.language,
      { numeric: "auto" }
    );
    return r < 60 ? l.format(-r, "second") : i < 60 ? l.format(-i, "minute") : o < 24 ? l.format(-o, "hour") : s < 30 ? l.format(-s, "day") : n.format("MMM D, YYYY");
  },
  formatDuration(e, t) {
    if (e === void 0)
      return "-";
    if (e < 1e3) {
      const i = Math.floor(e);
      return t ? `${i} ${Z("ms")}` : `${i} ${Z("milliseconds")}`;
    }
    const n = Math.floor(e / 1e3), r = Math.floor(n / 60);
    if (n < 60)
      return t ? `${n} ${Z("s")}` : `${n} ${Z("seconds")}`;
    if (r > 0) {
      const i = n % 60;
      return t ? `${r} ${Z("min")} ${i > 0 ? `${i} ${Z("s")}` : ""}` : `${r} ${Z("minutes")}${i > 0 ? ` ${i} ${Z("seconds")}` : ""}`;
    }
    return t ? `${n} ${Z("s")}` : `${n} ${Z("seconds")}`;
  },
  urlIsNotLocalhostOrIp(e) {
    const t = new URL(e);
    return t.hostname === "localhost" || t.hostname === "127.0.0.1" || t.hostname === "::1" || /^(?:\d{1,3}\.){3}\d{1,3}$/.test(t.hostname) ? !1 : t.protocol === "https:";
  }
};
function dat(e) {
  const t = Xe(null);
  return nt(() => {
    e && (typeof e == "function" ? e(t.current) : e.current = t.current);
  }), t;
}
Wi.CHINESE_SIMPLIFIED + "", Wi.GERMAN + "", Wi.ENGLISH + "", Wi.SPANISH + "", Wi.FRENCH + "", Wi.JAPANESE + "", Wi.DUTCH + "", Wi.PORTUGUESE + "", Wi.ARABIC + "", Wi.KURDISH_SORANI + "", Wi.CHINESE_TRADITIONAL + "";
const hxe = (e) => {
  const [t, n] = He({ width: 0, height: 0 });
  return nt(() => {
    const r = (o) => {
      if (o[0]) {
        const { width: s, height: l } = o[0].contentRect;
        n({ width: s, height: l });
      }
    }, i = new ResizeObserver(r);
    return e.current && i.observe(e.current), () => {
      i.disconnect();
    };
  }, [e.current]), t;
}, e6 = (e) => !!e && typeof e == "string" && (e.includes("/api/v1/step-files/") || e.includes("file://")), mxe = "newFlow", fat = (e) => {
  switch (e) {
    case "csv":
      return "text/csv";
    case "json":
      return "application/json";
    case "txt":
      return "text/plain";
    default:
      return "text/plain";
  }
}, gxe = async ({
  obj: e,
  fileName: t,
  extension: n
}) => {
  const r = n === "zip" ? await e.generateAsync({ type: "blob" }) : (
    //utf-8 with bom
    new Blob([new Uint8Array([239, 187, 191]), e], {
      type: fat(n)
    })
  ), i = URL.createObjectURL(r), o = document.createElement("a");
  o.href = i, o.download = `${t}.${n}`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(i);
}, yxe = (e) => new Promise((t) => setTimeout(t, e)), vB = () => /(Mac)/i.test(navigator.userAgent), pat = (e) => e.toLowerCase().split(" ").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" "), vxe = ({
  shortcutKey: e,
  withCtrl: t,
  withShift: n,
  className: r
}) => {
  const i = /(Mac)/i.test(navigator.userAgent), o = (e == null ? void 0 : e.toLocaleLowerCase()) === "esc";
  return /* @__PURE__ */ V(
    "span",
    {
      className: Se(
        "grow text-xs tracking-widest text-muted-foreground",
        r
      ),
      children: [
        !o && t && (i ? "⌘" : "Ctrl"),
        !o && n && "Shift",
        !o && (t || n) && " + ",
        e && pat(e)
      ]
    }
  );
}, mu = ie.memo(
  ({ className: e, isLarge: t = !1 }) => /* @__PURE__ */ y(
    PT,
    {
      className: Se(
        "animate-spin  duration-1500 stroke-foreground size-5",
        {
          "size-[24px]": !t,
          "size-[50px]": t
        },
        e
      )
    }
  )
);
mu.displayName = "LoadingSpinner";
const hat = as(
  "inline-flex items-center justify-center  whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-1 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary stroke-background text-primary-foreground enabled:hover:bg-primary/90",
        basic: "text-primary font-medium underline-offset-4 enabled:hover:bg-accent",
        secondary: "text-secondary-foreground bg-secondary enabled:hover:bg-secondary/80 enabled:hover:text-secondary-foreground",
        destructive: "bg-destructive text-primary-foreground enabled:hover:bg-destructive/90",
        outline: "border-input bg-background enabled:hover:bg-accent enabled:hover:text-accent-foreground border",
        accent: "bg-accent text-accent-foreground enabled:hover:bg-accent/80",
        ghost: "hover:bg-gray-300/10 hover:text-accent-foreground dark:hover:bg-gray-300/10",
        link: "text-primary underline-offset-4 hover:underline",
        transparent: "text-primary enabled:hover:bg-transparent",
        "outline-primary": "text-primary font-medium enabled:hover:bg-primary/10 enabled:hover:border-primary enabled:hover:font-semibold"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        xl: "h-12 rounded-md px-8 has-[>svg]:px-6",
        icon: "size-9",
        xs: "h-6 px-2 text-xs py-2"
      }
    },
    compoundVariants: [
      {
        variant: "link",
        class: "px-0"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Qe = N.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    asChild: r = !1,
    loading: i = !1,
    keyboardShortcut: o,
    disabled: s,
    onKeyboardShortcut: l,
    children: c,
    ...a
  }, u) => {
    const f = r ? is : "button", d = /(Mac)/i.test(navigator.userAgent), p = (o == null ? void 0 : o.toLocaleLowerCase()) === "esc";
    N.useEffect(() => (o && document.addEventListener("keydown", h), () => {
      document.removeEventListener("keydown", h);
    }), [o, s]);
    const h = (m) => {
      const v = m.key === "Escape" && p, b = o && m.key === o.toLocaleLowerCase() && (d ? m.metaKey : m.ctrlKey);
      (v || b) && (m.preventDefault(), m.stopPropagation(), l && !s && l());
    };
    return /* @__PURE__ */ y(
      f,
      {
        className: Se(hat({ variant: t, size: n, className: e }), {}),
        ref: u,
        disabled: s || i,
        ...a,
        onClick: (m) => {
          i ? m.stopPropagation() : a.onClick && a.onClick(m);
        },
        children: i ? /* @__PURE__ */ y(
          mu,
          {
            className: Se("size-5", {
              "stroke-background": t === "default" || t === "secondary",
              "stroke-foreground": t !== "default" && t !== "secondary"
            })
          }
        ) : /* @__PURE__ */ V(pt, { children: [
          o && /* @__PURE__ */ V("div", { className: "flex justify-center items-center gap-2", children: [
            c,
            /* @__PURE__ */ y(vxe, { shortcutKey: o, withCtrl: !0 })
          ] }),
          !o && c
        ] })
      }
    );
  }
);
Qe.displayName = "Button";
function ot(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function mat(e, t) {
  const n = N.createContext(t);
  function r(o) {
    const { children: s, ...l } = o, c = N.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ y(n.Provider, { value: c, children: s });
  }
  function i(o) {
    const s = N.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, i];
}
function Ms(e, t = []) {
  let n = [];
  function r(o, s) {
    const l = N.createContext(s), c = n.length;
    n = [...n, s];
    function a(f) {
      const { scope: d, children: p, ...h } = f, m = (d == null ? void 0 : d[e][c]) || l, v = N.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ y(m.Provider, { value: v, children: p });
    }
    function u(f, d) {
      const p = (d == null ? void 0 : d[e][c]) || l, h = N.useContext(p);
      if (h) return h;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return a.displayName = o + "Provider", [a, u];
  }
  const i = () => {
    const o = n.map((s) => N.createContext(s));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || o;
      return N.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return i.scopeName = e, [r, gat(i, ...t)];
}
function gat(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((l, { useScope: c, scopeName: a }) => {
        const f = c(o)[`__scope${a}`];
        return { ...l, ...f };
      }, {});
      return N.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var yat = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Zt = yat.reduce((e, t) => {
  const n = N.forwardRef((r, i) => {
    const { asChild: o, ...s } = r, l = o ? is : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(l, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function yz(e, t) {
  e && sb.flushSync(() => e.dispatchEvent(t));
}
function ti(e) {
  const t = N.useRef(e);
  return N.useEffect(() => {
    t.current = e;
  }), N.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function bxe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ti(e);
  N.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var vat = "DismissableLayer", bB = "dismissableLayer.update", bat = "dismissableLayer.pointerDownOutside", Oat = "dismissableLayer.focusOutside", rie, Oxe = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nx = N.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: l,
      ...c
    } = e, a = N.useContext(Oxe), [u, f] = N.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = N.useState({}), h = xn(t, (E) => f(E)), m = Array.from(a.layers), [v] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(v), A = u ? m.indexOf(u) : -1, w = a.layersWithOutsidePointerEventsDisabled.size > 0, O = A >= b, x = xat((E) => {
      const k = E.target, T = [...a.branches].some((R) => R.contains(k));
      !O || T || (i == null || i(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d), S = Sat((E) => {
      const k = E.target;
      [...a.branches].some((R) => R.contains(k)) || (o == null || o(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d);
    return bxe((E) => {
      A === a.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && l && (E.preventDefault(), l()));
    }, d), N.useEffect(() => {
      if (u)
        return n && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (rie = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(u)), a.layers.add(u), iie(), () => {
          n && a.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = rie);
        };
    }, [u, d, n, a]), N.useEffect(() => () => {
      u && (a.layers.delete(u), a.layersWithOutsidePointerEventsDisabled.delete(u), iie());
    }, [u, a]), N.useEffect(() => {
      const E = () => p({});
      return document.addEventListener(bB, E), () => document.removeEventListener(bB, E);
    }, []), /* @__PURE__ */ y(
      Zt.div,
      {
        ...c,
        ref: h,
        style: {
          pointerEvents: w ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ot(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ot(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ot(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
nx.displayName = vat;
var Aat = "DismissableLayerBranch", wat = N.forwardRef((e, t) => {
  const n = N.useContext(Oxe), r = N.useRef(null), i = xn(t, r);
  return N.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ y(Zt.div, { ...e, ref: i });
});
wat.displayName = Aat;
function xat(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ti(e), r = N.useRef(!1), i = N.useRef(() => {
  });
  return N.useEffect(() => {
    const o = (l) => {
      if (l.target && !r.current) {
        let c = function() {
          Axe(
            bat,
            n,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Sat(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ti(e), r = N.useRef(!1);
  return N.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && Axe(Oat, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function iie() {
  const e = new CustomEvent(bB);
  document.dispatchEvent(e);
}
function Axe(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? yz(i, o) : i.dispatchEvent(o);
}
var qi = globalThis != null && globalThis.document ? N.useLayoutEffect : () => {
}, Eat = N.useId || (() => {
}), Tat = 0;
function ka(e) {
  const [t, n] = N.useState(Eat());
  return qi(() => {
    n((r) => r ?? String(Tat++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const kat = ["top", "right", "bottom", "left"], tg = Math.min, Wl = Math.max, oD = Math.round, wP = Math.floor, mf = (e) => ({
  x: e,
  y: e
}), Cat = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Nat = {
  start: "end",
  end: "start"
};
function OB(e, t, n) {
  return Wl(e, tg(t, n));
}
function ch(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function uh(e) {
  return e.split("-")[0];
}
function rx(e) {
  return e.split("-")[1];
}
function nQ(e) {
  return e === "x" ? "y" : "x";
}
function rQ(e) {
  return e === "y" ? "height" : "width";
}
function $p(e) {
  return ["top", "bottom"].includes(uh(e)) ? "y" : "x";
}
function iQ(e) {
  return nQ($p(e));
}
function Pat(e, t, n) {
  n === void 0 && (n = !1);
  const r = rx(e), i = iQ(e), o = rQ(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = sD(s)), [s, sD(s)];
}
function Iat(e) {
  const t = sD(e);
  return [AB(e), t, AB(t)];
}
function AB(e) {
  return e.replace(/start|end/g, (t) => Nat[t]);
}
function Rat(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function Mat(e, t, n, r) {
  const i = rx(e);
  let o = Rat(uh(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(AB)))), o;
}
function sD(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Cat[t]);
}
function Dat(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function wxe(e) {
  return typeof e != "number" ? Dat(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function aD(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function oie(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = $p(t), s = iQ(t), l = rQ(s), c = uh(t), a = o === "y", u = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, d = r[l] / 2 - i[l] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (rx(t)) {
    case "start":
      p[s] -= d * (n && a ? -1 : 1);
      break;
    case "end":
      p[s] += d * (n && a ? -1 : 1);
      break;
  }
  return p;
}
const _at = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, l = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let a = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: f
  } = oie(a, r, c), d = r, p = {}, h = 0;
  for (let m = 0; m < l.length; m++) {
    const {
      name: v,
      fn: b
    } = l[m], {
      x: A,
      y: w,
      data: O,
      reset: x
    } = await b({
      x: u,
      y: f,
      initialPlacement: r,
      placement: d,
      strategy: i,
      middlewareData: p,
      rects: a,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = A ?? u, f = w ?? f, p = {
      ...p,
      [v]: {
        ...p[v],
        ...O
      }
    }, x && h <= 50 && (h++, typeof x == "object" && (x.placement && (d = x.placement), x.rects && (a = x.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : x.rects), {
      x: u,
      y: f
    } = oie(a, d, c)), m = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: p
  };
};
async function IT(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: l,
    strategy: c
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = ch(t, e), h = wxe(p), v = l[d ? f === "floating" ? "reference" : "floating" : f], b = aD(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(v))) == null || n ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(l.floating)),
    boundary: a,
    rootBoundary: u,
    strategy: c
  })), A = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l.floating)), O = await (o.isElement == null ? void 0 : o.isElement(w)) ? await (o.getScale == null ? void 0 : o.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = aD(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: A,
    offsetParent: w,
    strategy: c
  }) : A);
  return {
    top: (b.top - x.top + h.top) / O.y,
    bottom: (x.bottom - b.bottom + h.bottom) / O.y,
    left: (b.left - x.left + h.left) / O.x,
    right: (x.right - b.right + h.right) / O.x
  };
}
const Lat = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: l,
      middlewareData: c
    } = t, {
      element: a,
      padding: u = 0
    } = ch(e, t) || {};
    if (a == null)
      return {};
    const f = wxe(u), d = {
      x: n,
      y: r
    }, p = iQ(i), h = rQ(p), m = await s.getDimensions(a), v = p === "y", b = v ? "top" : "left", A = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", O = o.reference[h] + o.reference[p] - d[p] - o.floating[h], x = d[p] - o.reference[p], S = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let E = S ? S[w] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(S))) && (E = l.floating[w] || o.floating[h]);
    const k = O / 2 - x / 2, T = E / 2 - m[h] / 2 - 1, R = tg(f[b], T), j = tg(f[A], T), F = R, L = E - m[h] - j, _ = E / 2 - m[h] / 2 + k, U = OB(F, _, L), z = !c.arrow && rx(i) != null && _ !== U && o.reference[h] / 2 - (_ < F ? R : j) - m[h] / 2 < 0, C = z ? _ < F ? _ - F : _ - L : 0;
    return {
      [p]: d[p] + C,
      data: {
        [p]: U,
        centerOffset: _ - U - C,
        ...z && {
          alignmentOffset: C
        }
      },
      reset: z
    };
  }
}), zat = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: l,
        platform: c,
        elements: a
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...v
      } = ch(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const b = uh(i), A = $p(l), w = uh(l) === l, O = await (c.isRTL == null ? void 0 : c.isRTL(a.floating)), x = d || (w || !m ? [sD(l)] : Iat(l)), S = h !== "none";
      !d && S && x.push(...Mat(l, m, h, O));
      const E = [l, ...x], k = await IT(t, v), T = [];
      let R = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (u && T.push(k[b]), f) {
        const U = Pat(i, s, O);
        T.push(k[U[0]], k[U[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: T
      }], !T.every((U) => U <= 0)) {
        var j, F;
        const U = (((j = o.flip) == null ? void 0 : j.index) || 0) + 1, z = E[U];
        if (z) {
          var L;
          const I = f === "alignment" ? A !== $p(z) : !1, M = ((L = R[0]) == null ? void 0 : L.overflows[0]) > 0;
          if (!I || M)
            return {
              data: {
                index: U,
                overflows: R
              },
              reset: {
                placement: z
              }
            };
        }
        let C = (F = R.filter((I) => I.overflows[0] <= 0).sort((I, M) => I.overflows[1] - M.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!C)
          switch (p) {
            case "bestFit": {
              var _;
              const I = (_ = R.filter((M) => {
                if (S) {
                  const D = $p(M.placement);
                  return D === A || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((D) => D > 0).reduce((D, X) => D + X, 0)]).sort((M, D) => M[1] - D[1])[0]) == null ? void 0 : _[0];
              I && (C = I);
              break;
            }
            case "initialPlacement":
              C = l;
              break;
          }
        if (i !== C)
          return {
            reset: {
              placement: C
            }
          };
      }
      return {};
    }
  };
};
function sie(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function aie(e) {
  return kat.some((t) => e[t] >= 0);
}
const jat = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = ch(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await IT(t, {
            ...i,
            elementContext: "reference"
          }), s = sie(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: aie(s)
            }
          };
        }
        case "escaped": {
          const o = await IT(t, {
            ...i,
            altBoundary: !0
          }), s = sie(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: aie(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Fat(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = uh(n), l = rx(n), c = $p(n) === "y", a = ["left", "top"].includes(s) ? -1 : 1, u = o && c ? -1 : 1, f = ch(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof h == "number" && (p = l === "end" ? h * -1 : h), c ? {
    x: p * u,
    y: d * a
  } : {
    x: d * a,
    y: p * u
  };
}
const Uat = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: l
      } = t, c = await Fat(t, e);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Vat = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: b,
              y: A
            } = v;
            return {
              x: b,
              y: A
            };
          }
        },
        ...c
      } = ch(e, t), a = {
        x: n,
        y: r
      }, u = await IT(t, c), f = $p(uh(i)), d = nQ(f);
      let p = a[d], h = a[f];
      if (o) {
        const v = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", A = p + u[v], w = p - u[b];
        p = OB(A, p, w);
      }
      if (s) {
        const v = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", A = h + u[v], w = h - u[b];
        h = OB(A, h, w);
      }
      const m = l.fn({
        ...t,
        [d]: p,
        [f]: h
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [d]: o,
            [f]: s
          }
        }
      };
    }
  };
}, qat = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: s
      } = t, {
        offset: l = 0,
        mainAxis: c = !0,
        crossAxis: a = !0
      } = ch(e, t), u = {
        x: n,
        y: r
      }, f = $p(i), d = nQ(f);
      let p = u[d], h = u[f];
      const m = ch(l, t), v = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const w = d === "y" ? "height" : "width", O = o.reference[d] - o.floating[w] + v.mainAxis, x = o.reference[d] + o.reference[w] - v.mainAxis;
        p < O ? p = O : p > x && (p = x);
      }
      if (a) {
        var b, A;
        const w = d === "y" ? "width" : "height", O = ["top", "left"].includes(uh(i)), x = o.reference[f] - o.floating[w] + (O && ((b = s.offset) == null ? void 0 : b[f]) || 0) + (O ? 0 : v.crossAxis), S = o.reference[f] + o.reference[w] + (O ? 0 : ((A = s.offset) == null ? void 0 : A[f]) || 0) - (O ? v.crossAxis : 0);
        h < x ? h = x : h > S && (h = S);
      }
      return {
        [d]: p,
        [f]: h
      };
    }
  };
}, Bat = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: s,
        elements: l
      } = t, {
        apply: c = () => {
        },
        ...a
      } = ch(e, t), u = await IT(t, a), f = uh(i), d = rx(i), p = $p(i) === "y", {
        width: h,
        height: m
      } = o.floating;
      let v, b;
      f === "top" || f === "bottom" ? (v = f, b = d === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (b = f, v = d === "end" ? "top" : "bottom");
      const A = m - u.top - u.bottom, w = h - u.left - u.right, O = tg(m - u[v], A), x = tg(h - u[b], w), S = !t.middlewareData.shift;
      let E = O, k = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = w), (r = t.middlewareData.shift) != null && r.enabled.y && (E = A), S && !d) {
        const R = Wl(u.left, 0), j = Wl(u.right, 0), F = Wl(u.top, 0), L = Wl(u.bottom, 0);
        p ? k = h - 2 * (R !== 0 || j !== 0 ? R + j : Wl(u.left, u.right)) : E = m - 2 * (F !== 0 || L !== 0 ? F + L : Wl(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: k,
        availableHeight: E
      });
      const T = await s.getDimensions(l.floating);
      return h !== T.width || m !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function vz() {
  return typeof window < "u";
}
function ix(e) {
  return xxe(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ic(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Df(e) {
  var t;
  return (t = (xxe(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function xxe(e) {
  return vz() ? e instanceof Node || e instanceof ic(e).Node : !1;
}
function Ju(e) {
  return vz() ? e instanceof Element || e instanceof ic(e).Element : !1;
}
function wf(e) {
  return vz() ? e instanceof HTMLElement || e instanceof ic(e).HTMLElement : !1;
}
function lie(e) {
  return !vz() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ic(e).ShadowRoot;
}
function $C(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ed(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Xat(e) {
  return ["table", "td", "th"].includes(ix(e));
}
function bz(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function oQ(e) {
  const t = sQ(), n = Ju(e) ? ed(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Wat(e) {
  let t = ng(e);
  for (; wf(t) && !KA(t); ) {
    if (oQ(t))
      return t;
    if (bz(t))
      return null;
    t = ng(t);
  }
  return null;
}
function sQ() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function KA(e) {
  return ["html", "body", "#document"].includes(ix(e));
}
function ed(e) {
  return ic(e).getComputedStyle(e);
}
function Oz(e) {
  return Ju(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ng(e) {
  if (ix(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    lie(e) && e.host || // Fallback.
    Df(e)
  );
  return lie(t) ? t.host : t;
}
function Sxe(e) {
  const t = ng(e);
  return KA(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : wf(t) && $C(t) ? t : Sxe(t);
}
function RT(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Sxe(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = ic(i);
  if (o) {
    const l = wB(s);
    return t.concat(s, s.visualViewport || [], $C(i) ? i : [], l && n ? RT(l) : []);
  }
  return t.concat(i, RT(i, [], n));
}
function wB(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Exe(e) {
  const t = ed(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = wf(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, l = oD(n) !== o || oD(r) !== s;
  return l && (n = o, r = s), {
    width: n,
    height: r,
    $: l
  };
}
function aQ(e) {
  return Ju(e) ? e : e.contextElement;
}
function FO(e) {
  const t = aQ(e);
  if (!wf(t))
    return mf(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = Exe(t);
  let s = (o ? oD(n.width) : n.width) / r, l = (o ? oD(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const Zat = /* @__PURE__ */ mf(0);
function Txe(e) {
  const t = ic(e);
  return !sQ() || !t.visualViewport ? Zat : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Hat(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ic(e) ? !1 : t;
}
function Nv(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = aQ(e);
  let s = mf(1);
  t && (r ? Ju(r) && (s = FO(r)) : s = FO(e));
  const l = Hat(o, n, r) ? Txe(o) : mf(0);
  let c = (i.left + l.x) / s.x, a = (i.top + l.y) / s.y, u = i.width / s.x, f = i.height / s.y;
  if (o) {
    const d = ic(o), p = r && Ju(r) ? ic(r) : r;
    let h = d, m = wB(h);
    for (; m && r && p !== h; ) {
      const v = FO(m), b = m.getBoundingClientRect(), A = ed(m), w = b.left + (m.clientLeft + parseFloat(A.paddingLeft)) * v.x, O = b.top + (m.clientTop + parseFloat(A.paddingTop)) * v.y;
      c *= v.x, a *= v.y, u *= v.x, f *= v.y, c += w, a += O, h = ic(m), m = wB(h);
    }
  }
  return aD({
    width: u,
    height: f,
    x: c,
    y: a
  });
}
function lQ(e, t) {
  const n = Oz(e).scrollLeft;
  return t ? t.left + n : Nv(Df(e)).left + n;
}
function kxe(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    lQ(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function Qat(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = Df(r), l = t ? bz(t.floating) : !1;
  if (r === s || l && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = mf(1);
  const u = mf(0), f = wf(r);
  if ((f || !f && !o) && ((ix(r) !== "body" || $C(s)) && (c = Oz(r)), wf(r))) {
    const p = Nv(r);
    a = FO(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  const d = s && !f && !o ? kxe(s, c, !0) : mf(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - c.scrollLeft * a.x + u.x + d.x,
    y: n.y * a.y - c.scrollTop * a.y + u.y + d.y
  };
}
function $at(e) {
  return Array.from(e.getClientRects());
}
function Kat(e) {
  const t = Df(e), n = Oz(e), r = e.ownerDocument.body, i = Wl(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Wl(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + lQ(e);
  const l = -n.scrollTop;
  return ed(r).direction === "rtl" && (s += Wl(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Gat(e, t) {
  const n = ic(e), r = Df(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, l = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const a = sQ();
    (!a || a && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function Yat(e, t) {
  const n = Nv(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = wf(e) ? FO(e) : mf(1), s = e.clientWidth * o.x, l = e.clientHeight * o.y, c = i * o.x, a = r * o.y;
  return {
    width: s,
    height: l,
    x: c,
    y: a
  };
}
function cie(e, t, n) {
  let r;
  if (t === "viewport")
    r = Gat(e, n);
  else if (t === "document")
    r = Kat(Df(e));
  else if (Ju(t))
    r = Yat(t, n);
  else {
    const i = Txe(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return aD(r);
}
function Cxe(e, t) {
  const n = ng(e);
  return n === t || !Ju(n) || KA(n) ? !1 : ed(n).position === "fixed" || Cxe(n, t);
}
function Jat(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = RT(e, [], !1).filter((l) => Ju(l) && ix(l) !== "body"), i = null;
  const o = ed(e).position === "fixed";
  let s = o ? ng(e) : e;
  for (; Ju(s) && !KA(s); ) {
    const l = ed(s), c = oQ(s);
    !c && l.position === "fixed" && (i = null), (o ? !c && !i : !c && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || $C(s) && !c && Cxe(e, s)) ? r = r.filter((u) => u !== s) : i = l, s = ng(s);
  }
  return t.set(e, r), r;
}
function elt(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? bz(t) ? [] : Jat(t, this._c) : [].concat(n), r], l = s[0], c = s.reduce((a, u) => {
    const f = cie(t, u, i);
    return a.top = Wl(f.top, a.top), a.right = tg(f.right, a.right), a.bottom = tg(f.bottom, a.bottom), a.left = Wl(f.left, a.left), a;
  }, cie(t, l, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function tlt(e) {
  const {
    width: t,
    height: n
  } = Exe(e);
  return {
    width: t,
    height: n
  };
}
function nlt(e, t, n) {
  const r = wf(t), i = Df(t), o = n === "fixed", s = Nv(e, !0, o, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = mf(0);
  function a() {
    c.x = lQ(i);
  }
  if (r || !r && !o)
    if ((ix(t) !== "body" || $C(i)) && (l = Oz(t)), r) {
      const p = Nv(t, !0, o, t);
      c.x = p.x + t.clientLeft, c.y = p.y + t.clientTop;
    } else i && a();
  o && !r && i && a();
  const u = i && !r && !o ? kxe(i, l) : mf(0), f = s.left + l.scrollLeft - c.x - u.x, d = s.top + l.scrollTop - c.y - u.y;
  return {
    x: f,
    y: d,
    width: s.width,
    height: s.height
  };
}
function t6(e) {
  return ed(e).position === "static";
}
function uie(e, t) {
  if (!wf(e) || ed(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Df(e) === n && (n = n.ownerDocument.body), n;
}
function Nxe(e, t) {
  const n = ic(e);
  if (bz(e))
    return n;
  if (!wf(e)) {
    let i = ng(e);
    for (; i && !KA(i); ) {
      if (Ju(i) && !t6(i))
        return i;
      i = ng(i);
    }
    return n;
  }
  let r = uie(e, t);
  for (; r && Xat(r) && t6(r); )
    r = uie(r, t);
  return r && KA(r) && t6(r) && !oQ(r) ? n : r || Wat(e) || n;
}
const rlt = async function(e) {
  const t = this.getOffsetParent || Nxe, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: nlt(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function ilt(e) {
  return ed(e).direction === "rtl";
}
const olt = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Qat,
  getDocumentElement: Df,
  getClippingRect: elt,
  getOffsetParent: Nxe,
  getElementRects: rlt,
  getClientRects: $at,
  getDimensions: tlt,
  getScale: FO,
  isElement: Ju,
  isRTL: ilt
};
function Pxe(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function slt(e, t) {
  let n = null, r;
  const i = Df(e);
  function o() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), o();
    const a = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: d,
      height: p
    } = a;
    if (l || t(), !d || !p)
      return;
    const h = wP(f), m = wP(i.clientWidth - (u + d)), v = wP(i.clientHeight - (f + p)), b = wP(u), w = {
      rootMargin: -h + "px " + -m + "px " + -v + "px " + -b + "px",
      threshold: Wl(0, tg(1, c)) || 1
    };
    let O = !0;
    function x(S) {
      const E = S[0].intersectionRatio;
      if (E !== c) {
        if (!O)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Pxe(a, e.getBoundingClientRect()) && s(), O = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function alt(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, a = aQ(e), u = i || o ? [...a ? RT(a) : [], ...RT(t)] : [];
  u.forEach((b) => {
    i && b.addEventListener("scroll", n, {
      passive: !0
    }), o && b.addEventListener("resize", n);
  });
  const f = a && l ? slt(a, n) : null;
  let d = -1, p = null;
  s && (p = new ResizeObserver((b) => {
    let [A] = b;
    A && A.target === a && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), n();
  }), a && !c && p.observe(a), p.observe(t));
  let h, m = c ? Nv(e) : null;
  c && v();
  function v() {
    const b = Nv(e);
    m && !Pxe(m, b) && n(), m = b, h = requestAnimationFrame(v);
  }
  return n(), () => {
    var b;
    u.forEach((A) => {
      i && A.removeEventListener("scroll", n), o && A.removeEventListener("resize", n);
    }), f == null || f(), (b = p) == null || b.disconnect(), p = null, c && cancelAnimationFrame(h);
  };
}
const llt = Uat, clt = Vat, ult = zat, dlt = Bat, flt = jat, die = Lat, plt = qat, hlt = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: olt,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return _at(e, t, {
    ...i,
    platform: o
  });
};
var jR = typeof document < "u" ? Og : nt;
function lD(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!lD(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !lD(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ixe(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function fie(e, t) {
  const n = Ixe(e);
  return Math.round(t * n) / n;
}
function n6(e) {
  const t = N.useRef(e);
  return jR(() => {
    t.current = e;
  }), t;
}
function mlt(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: a
  } = e, [u, f] = N.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, p] = N.useState(r);
  lD(d, r) || p(r);
  const [h, m] = N.useState(null), [v, b] = N.useState(null), A = N.useCallback((I) => {
    I !== S.current && (S.current = I, m(I));
  }, []), w = N.useCallback((I) => {
    I !== E.current && (E.current = I, b(I));
  }, []), O = o || h, x = s || v, S = N.useRef(null), E = N.useRef(null), k = N.useRef(u), T = c != null, R = n6(c), j = n6(i), F = n6(a), L = N.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const I = {
      placement: t,
      strategy: n,
      middleware: d
    };
    j.current && (I.platform = j.current), hlt(S.current, E.current, I).then((M) => {
      const D = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      _.current && !lD(k.current, D) && (k.current = D, sb.flushSync(() => {
        f(D);
      }));
    });
  }, [d, t, n, j, F]);
  jR(() => {
    a === !1 && k.current.isPositioned && (k.current.isPositioned = !1, f((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [a]);
  const _ = N.useRef(!1);
  jR(() => (_.current = !0, () => {
    _.current = !1;
  }), []), jR(() => {
    if (O && (S.current = O), x && (E.current = x), O && x) {
      if (R.current)
        return R.current(O, x, L);
      L();
    }
  }, [O, x, L, R, T]);
  const U = N.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: A,
    setFloating: w
  }), [A, w]), z = N.useMemo(() => ({
    reference: O,
    floating: x
  }), [O, x]), C = N.useMemo(() => {
    const I = {
      position: n,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return I;
    const M = fie(z.floating, u.x), D = fie(z.floating, u.y);
    return l ? {
      ...I,
      transform: "translate(" + M + "px, " + D + "px)",
      ...Ixe(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: D
    };
  }, [n, l, z.floating, u.x, u.y]);
  return N.useMemo(() => ({
    ...u,
    update: L,
    refs: U,
    elements: z,
    floatingStyles: C
  }), [u, L, U, z, C]);
}
const glt = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? die({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? die({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, ylt = (e, t) => ({
  ...llt(e),
  options: [e, t]
}), vlt = (e, t) => ({
  ...clt(e),
  options: [e, t]
}), blt = (e, t) => ({
  ...plt(e),
  options: [e, t]
}), Olt = (e, t) => ({
  ...ult(e),
  options: [e, t]
}), Alt = (e, t) => ({
  ...dlt(e),
  options: [e, t]
}), wlt = (e, t) => ({
  ...flt(e),
  options: [e, t]
}), xlt = (e, t) => ({
  ...glt(e),
  options: [e, t]
});
var Slt = "Arrow", Rxe = N.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ y(
    Zt.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ y("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Rxe.displayName = Slt;
var Elt = Rxe;
function Az(e) {
  const [t, n] = N.useState(void 0);
  return qi(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let s, l;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, a = Array.isArray(c) ? c[0] : c;
          s = a.inlineSize, l = a.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var cQ = "Popper", [Mxe, _f] = Ms(cQ), [Tlt, Dxe] = Mxe(cQ), _xe = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = N.useState(null);
  return /* @__PURE__ */ y(Tlt, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
_xe.displayName = cQ;
var Lxe = "PopperAnchor", zxe = N.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = Dxe(Lxe, n), s = N.useRef(null), l = xn(t, s);
    return N.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ y(Zt.div, { ...i, ref: l });
  }
);
zxe.displayName = Lxe;
var uQ = "PopperContent", [klt, Clt] = Mxe(uQ), jxe = N.forwardRef(
  (e, t) => {
    var oe, ce, fe, $, pe, ee;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: s = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: a = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: h,
      ...m
    } = e, v = Dxe(uQ, n), [b, A] = N.useState(null), w = xn(t, (Ce) => A(Ce)), [O, x] = N.useState(null), S = Az(O), E = (S == null ? void 0 : S.width) ?? 0, k = (S == null ? void 0 : S.height) ?? 0, T = r + (o !== "center" ? "-" + o : ""), R = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, j = Array.isArray(a) ? a : [a], F = j.length > 0, L = {
      padding: R,
      boundary: j.filter(Plt),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: _, floatingStyles: U, placement: z, isPositioned: C, middlewareData: I } = mlt({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...Ce) => alt(...Ce, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        ylt({ mainAxis: i + k, alignmentAxis: s }),
        c && vlt({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? blt() : void 0,
          ...L
        }),
        c && Olt({ ...L }),
        Alt({
          ...L,
          apply: ({ elements: Ce, rects: Ee, availableWidth: Ve, availableHeight: et }) => {
            const { width: ft, height: me } = Ee.reference, Te = Ce.floating.style;
            Te.setProperty("--radix-popper-available-width", `${Ve}px`), Te.setProperty("--radix-popper-available-height", `${et}px`), Te.setProperty("--radix-popper-anchor-width", `${ft}px`), Te.setProperty("--radix-popper-anchor-height", `${me}px`);
          }
        }),
        O && xlt({ element: O, padding: l }),
        Ilt({ arrowWidth: E, arrowHeight: k }),
        d && wlt({ strategy: "referenceHidden", ...L })
      ]
    }), [M, D] = Vxe(z), X = ti(h);
    qi(() => {
      C && (X == null || X());
    }, [C, X]);
    const B = (oe = I.arrow) == null ? void 0 : oe.x, q = (ce = I.arrow) == null ? void 0 : ce.y, H = ((fe = I.arrow) == null ? void 0 : fe.centerOffset) !== 0, [Y, J] = N.useState();
    return qi(() => {
      b && J(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ y(
      "div",
      {
        ref: _.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: C ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Y,
          "--radix-popper-transform-origin": [
            ($ = I.transformOrigin) == null ? void 0 : $.x,
            (pe = I.transformOrigin) == null ? void 0 : pe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ee = I.hide) == null ? void 0 : ee.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ y(
          klt,
          {
            scope: n,
            placedSide: M,
            onArrowChange: x,
            arrowX: B,
            arrowY: q,
            shouldHideArrow: H,
            children: /* @__PURE__ */ y(
              Zt.div,
              {
                "data-side": M,
                "data-align": D,
                ...m,
                ref: w,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: C ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
jxe.displayName = uQ;
var Fxe = "PopperArrow", Nlt = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Uxe = N.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Clt(Fxe, r), s = Nlt[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ y(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ y(
          Elt,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Uxe.displayName = Fxe;
function Plt(e) {
  return e !== null;
}
var Ilt = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, b, A;
    const { placement: n, rects: r, middlewareData: i } = t, s = ((v = i.arrow) == null ? void 0 : v.centerOffset) !== 0, l = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [a, u] = Vxe(n), f = { start: "0%", center: "50%", end: "100%" }[u], d = (((b = i.arrow) == null ? void 0 : b.x) ?? 0) + l / 2, p = (((A = i.arrow) == null ? void 0 : A.y) ?? 0) + c / 2;
    let h = "", m = "";
    return a === "bottom" ? (h = s ? f : `${d}px`, m = `${-c}px`) : a === "top" ? (h = s ? f : `${d}px`, m = `${r.floating.height + c}px`) : a === "right" ? (h = `${-c}px`, m = s ? f : `${p}px`) : a === "left" && (h = `${r.floating.width + c}px`, m = s ? f : `${p}px`), { data: { x: h, y: m } };
  }
});
function Vxe(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ox = _xe, sx = zxe, KC = jxe, GC = Uxe, Rlt = "Portal", ax = N.forwardRef((e, t) => {
  var l;
  const { container: n, ...r } = e, [i, o] = N.useState(!1);
  qi(() => o(!0), []);
  const s = n || i && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return s ? _w.createPortal(/* @__PURE__ */ y(Zt.div, { ...r, ref: t }), s) : null;
});
ax.displayName = Rlt;
function Mlt(e, t) {
  return N.useReducer((n, r) => t[n][r] ?? n, e);
}
var wo = (e) => {
  const { present: t, children: n } = e, r = Dlt(t), i = typeof n == "function" ? n({ present: r.isPresent }) : N.Children.only(n), o = xn(r.ref, _lt(i));
  return typeof n == "function" || r.isPresent ? N.cloneElement(i, { ref: o }) : null;
};
wo.displayName = "Presence";
function Dlt(e) {
  const [t, n] = N.useState(), r = N.useRef({}), i = N.useRef(e), o = N.useRef("none"), s = e ? "mounted" : "unmounted", [l, c] = Mlt(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const a = xP(r.current);
    o.current = l === "mounted" ? a : "none";
  }, [l]), qi(() => {
    const a = r.current, u = i.current;
    if (u !== e) {
      const d = o.current, p = xP(a);
      e ? c("MOUNT") : p === "none" || (a == null ? void 0 : a.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), qi(() => {
    if (t) {
      const a = (f) => {
        const p = xP(r.current).includes(f.animationName);
        f.target === t && p && sb.flushSync(() => c("ANIMATION_END"));
      }, u = (f) => {
        f.target === t && (o.current = xP(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", a), t.addEventListener("animationend", a), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", a), t.removeEventListener("animationend", a);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: N.useCallback((a) => {
      a && (r.current = getComputedStyle(a)), n(a);
    }, [])
  };
}
function xP(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function _lt(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function wl({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = Llt({ defaultProp: t, onChange: n }), o = e !== void 0, s = o ? e : r, l = ti(n), c = N.useCallback(
    (a) => {
      if (o) {
        const f = typeof a == "function" ? a(e) : a;
        f !== e && l(f);
      } else
        i(a);
    },
    [o, e, i, l]
  );
  return [s, c];
}
function Llt({
  defaultProp: e,
  onChange: t
}) {
  const n = N.useState(e), [r] = n, i = N.useRef(r), o = ti(t);
  return N.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var zlt = "VisuallyHidden", dQ = N.forwardRef(
  (e, t) => /* @__PURE__ */ y(
    Zt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
dQ.displayName = zlt;
var jlt = dQ, [wz, Zhn] = Ms("Tooltip", [
  _f
]), xz = _f(), qxe = "TooltipProvider", Flt = 700, xB = "tooltip.open", [Ult, fQ] = wz(qxe), Bxe = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Flt,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = e, [s, l] = N.useState(!0), c = N.useRef(!1), a = N.useRef(0);
  return N.useEffect(() => {
    const u = a.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ y(
    Ult,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: N.useCallback(() => {
        window.clearTimeout(a.current), l(!1);
      }, []),
      onClose: N.useCallback(() => {
        window.clearTimeout(a.current), a.current = window.setTimeout(
          () => l(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: N.useCallback((u) => {
        c.current = u;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
Bxe.displayName = qxe;
var Sz = "Tooltip", [Vlt, YC] = wz(Sz), Xxe = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: o,
    disableHoverableContent: s,
    delayDuration: l
  } = e, c = fQ(Sz, e.__scopeTooltip), a = xz(t), [u, f] = N.useState(null), d = ka(), p = N.useRef(0), h = s ?? c.disableHoverableContent, m = l ?? c.delayDuration, v = N.useRef(!1), [b = !1, A] = wl({
    prop: r,
    defaultProp: i,
    onChange: (E) => {
      E ? (c.onOpen(), document.dispatchEvent(new CustomEvent(xB))) : c.onClose(), o == null || o(E);
    }
  }), w = N.useMemo(() => b ? v.current ? "delayed-open" : "instant-open" : "closed", [b]), O = N.useCallback(() => {
    window.clearTimeout(p.current), v.current = !1, A(!0);
  }, [A]), x = N.useCallback(() => {
    window.clearTimeout(p.current), A(!1);
  }, [A]), S = N.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      v.current = !0, A(!0);
    }, m);
  }, [m, A]);
  return N.useEffect(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ y(ox, { ...a, children: /* @__PURE__ */ y(
    Vlt,
    {
      scope: t,
      contentId: d,
      open: b,
      stateAttribute: w,
      trigger: u,
      onTriggerChange: f,
      onTriggerEnter: N.useCallback(() => {
        c.isOpenDelayed ? S() : O();
      }, [c.isOpenDelayed, S, O]),
      onTriggerLeave: N.useCallback(() => {
        h ? x() : window.clearTimeout(p.current);
      }, [x, h]),
      onOpen: O,
      onClose: x,
      disableHoverableContent: h,
      children: n
    }
  ) });
};
Xxe.displayName = Sz;
var SB = "TooltipTrigger", pQ = N.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = YC(SB, n), o = fQ(SB, n), s = xz(n), l = N.useRef(null), c = xn(t, l, i.onTriggerChange), a = N.useRef(!1), u = N.useRef(!1), f = N.useCallback(() => a.current = !1, []);
    return N.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ y(sx, { asChild: !0, ...s, children: /* @__PURE__ */ y(
      Zt.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: ot(e.onPointerMove, (d) => {
          d.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: ot(e.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: ot(e.onPointerDown, () => {
          a.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: ot(e.onFocus, () => {
          a.current || i.onOpen();
        }),
        onBlur: ot(e.onBlur, i.onClose),
        onClick: ot(e.onClick, i.onClose)
      }
    ) });
  }
);
pQ.displayName = SB;
var hQ = "TooltipPortal", [qlt, Blt] = wz(hQ, {
  forceMount: void 0
}), Wxe = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = YC(hQ, t);
  return /* @__PURE__ */ y(qlt, { scope: t, forceMount: n, children: /* @__PURE__ */ y(wo, { present: n || o.open, children: /* @__PURE__ */ y(ax, { asChild: !0, container: i, children: r }) }) });
};
Wxe.displayName = hQ;
var GA = "TooltipContent", Zxe = N.forwardRef(
  (e, t) => {
    const n = Blt(GA, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, s = YC(GA, e.__scopeTooltip);
    return /* @__PURE__ */ y(wo, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ y(Hxe, { side: i, ...o, ref: t }) : /* @__PURE__ */ y(Xlt, { side: i, ...o, ref: t }) });
  }
), Xlt = N.forwardRef((e, t) => {
  const n = YC(GA, e.__scopeTooltip), r = fQ(GA, e.__scopeTooltip), i = N.useRef(null), o = xn(t, i), [s, l] = N.useState(null), { trigger: c, onClose: a } = n, u = i.current, { onPointerInTransitChange: f } = r, d = N.useCallback(() => {
    l(null), f(!1);
  }, [f]), p = N.useCallback(
    (h, m) => {
      const v = h.currentTarget, b = { x: h.clientX, y: h.clientY }, A = Hlt(b, v.getBoundingClientRect()), w = Qlt(b, A), O = $lt(m.getBoundingClientRect()), x = Glt([...w, ...O]);
      l(x), f(!0);
    },
    [f]
  );
  return N.useEffect(() => () => d(), [d]), N.useEffect(() => {
    if (c && u) {
      const h = (v) => p(v, u), m = (v) => p(v, c);
      return c.addEventListener("pointerleave", h), u.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", h), u.removeEventListener("pointerleave", m);
      };
    }
  }, [c, u, p, d]), N.useEffect(() => {
    if (s) {
      const h = (m) => {
        const v = m.target, b = { x: m.clientX, y: m.clientY }, A = (c == null ? void 0 : c.contains(v)) || (u == null ? void 0 : u.contains(v)), w = !Klt(b, s);
        A ? d() : w && (d(), a());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [c, u, s, a, d]), /* @__PURE__ */ y(Hxe, { ...e, ref: o });
}), [Wlt, Zlt] = wz(Sz, { isInside: !1 }), Hxe = N.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      ...l
    } = e, c = YC(GA, n), a = xz(n), { onClose: u } = c;
    return N.useEffect(() => (document.addEventListener(xB, u), () => document.removeEventListener(xB, u)), [u]), N.useEffect(() => {
      if (c.trigger) {
        const f = (d) => {
          const p = d.target;
          p != null && p.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, u]), /* @__PURE__ */ y(
      nx,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: s,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ V(
          KC,
          {
            "data-state": c.stateAttribute,
            ...a,
            ...l,
            ref: t,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ y(Kwe, { children: r }),
              /* @__PURE__ */ y(Wlt, { scope: n, isInside: !0, children: /* @__PURE__ */ y(jlt, { id: c.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
Zxe.displayName = GA;
var Qxe = "TooltipArrow", $xe = N.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = xz(n);
    return Zlt(
      Qxe,
      n
    ).isInside ? null : /* @__PURE__ */ y(GC, { ...i, ...r, ref: t });
  }
);
$xe.displayName = Qxe;
function Hlt(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Qlt(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function $lt(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function Klt(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const l = t[o].x, c = t[o].y, a = t[s].x, u = t[s].y;
    c > r != u > r && n < (a - l) * (r - c) / (u - c) + l && (i = !i);
  }
  return i;
}
function Glt(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Ylt(t);
}
function Ylt(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], s = t[t.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], s = n[n.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var Jlt = Bxe, ect = Xxe, tct = pQ, nct = Wxe, rct = Zxe, ict = $xe;
function Kp({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ y(
    Jlt,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function wn({
  ...e
}) {
  return /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ y(ect, { "data-slot": "tooltip", ...e }) });
}
function kn({
  ...e
}) {
  return /* @__PURE__ */ y(tct, { "data-slot": "tooltip-trigger", ...e });
}
function An({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ y(nct, { children: /* @__PURE__ */ V(
    rct,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: Se(
        "bg-foreground text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[2000] w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ y(ict, { className: "bg-foreground fill-foreground z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
const Pv = ({
  onClick: e,
  Icon: t,
  tooltipText: n
}) => /* @__PURE__ */ V(wn, { children: [
  /* @__PURE__ */ y(pQ, { asChild: !0, children: /* @__PURE__ */ y(
    Qe,
    {
      variant: "ghost",
      className: "opacity-50 shrink-0 h-6 w-6 rounded-xs",
      size: "icon",
      onClick: e,
      children: /* @__PURE__ */ y(t, { className: "w-4 h-4" })
    }
  ) }),
  n && /* @__PURE__ */ y(An, { side: "bottom", children: n })
] });
Pv.displayName = "SelectUtilButton";
const pie = "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-base shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", fr = N.forwardRef(
  ({ className: e, type: t, thin: n = !1, defaultFileName: r, ...i }, o) => {
    const [s, l] = N.useState(null), c = N.useRef(null), a = (f) => {
      var p, h;
      const d = (p = f.target.files) == null ? void 0 : p[0];
      l(d ? d.name : null), (h = i.onChange) == null || h.call(i, f);
    };
    rW(o, () => c.current);
    const u = () => {
      var f;
      (f = c.current) == null || f.click();
    };
    return t === "file" ? /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        "input",
        {
          type: "file",
          className: "hidden",
          ref: c,
          ...i,
          onChange: a
        }
      ),
      /* @__PURE__ */ V(
        "div",
        {
          onClick: u,
          className: Se(pie, "cursor-pointer items-center ", e),
          children: [
            /* @__PURE__ */ y(
              "input",
              {
                className: Se("grow cursor-pointer outline-none bg-transparent", {
                  "text-muted-foreground": !s
                }),
                value: s || r || Z("Select a file"),
                readOnly: !0
              }
            ),
            /* @__PURE__ */ y("div", { className: "basis-1", children: /* @__PURE__ */ y(
              Pv,
              {
                onClick: (f) => f.preventDefault(),
                tooltipText: s || Z("Select a file"),
                Icon: nxe
              }
            ) })
          ]
        }
      )
    ] }) : /* @__PURE__ */ y(
      "input",
      {
        type: t,
        className: Se(pie, e, {
          "h-8 p-2": n
        }),
        ref: c,
        ...i
      }
    );
  }
);
fr.displayName = "Input";
var oct = "Separator", hie = "horizontal", sct = ["horizontal", "vertical"], Kxe = N.forwardRef((e, t) => {
  const { decorative: n, orientation: r = hie, ...i } = e, o = act(r) ? r : hie, l = n ? { role: "none" } : { "aria-orientation": o === "vertical" ? o : void 0, role: "separator" };
  return /* @__PURE__ */ y(
    Zt.div,
    {
      "data-orientation": o,
      ...l,
      ...i,
      ref: t
    }
  );
});
Kxe.displayName = oct;
function act(e) {
  return sct.includes(e);
}
var Gxe = Kxe;
const Eh = N.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, i) => /* @__PURE__ */ y(
    Gxe,
    {
      ref: i,
      decorative: n,
      orientation: t,
      className: Se(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-px w-full" : "h-full w-px",
        e
      ),
      ...r
    }
  )
);
Eh.displayName = Gxe.displayName;
const Yxe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ V("div", { className: Se("flex w-full flex-row items-center", e), children: [
  /* @__PURE__ */ y("div", { className: "w-1/2 border" }),
  /* @__PURE__ */ y("span", { className: "mx-2 text-sm", children: t.children }),
  /* @__PURE__ */ y("div", { className: "w-1/2 border" })
] }));
Yxe.displayName = "HorizontalSeparatorWithText";
var r6 = "focusScope.autoFocusOnMount", i6 = "focusScope.autoFocusOnUnmount", mie = { bubbles: !1, cancelable: !0 }, lct = "FocusScope", lx = N.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = e, [l, c] = N.useState(null), a = ti(i), u = ti(o), f = N.useRef(null), d = xn(t, (m) => c(m)), p = N.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  N.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (p.paused || !l) return;
        const O = w.target;
        l.contains(O) ? f.current = O : Wh(f.current, { select: !0 });
      }, v = function(w) {
        if (p.paused || !l) return;
        const O = w.relatedTarget;
        O !== null && (l.contains(O) || Wh(f.current, { select: !0 }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const x of w)
            x.removedNodes.length > 0 && Wh(l);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", v);
      const A = new MutationObserver(b);
      return l && A.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", v), A.disconnect();
      };
    }
  }, [r, l, p.paused]), N.useEffect(() => {
    if (l) {
      yie.add(p);
      const m = document.activeElement;
      if (!l.contains(m)) {
        const b = new CustomEvent(r6, mie);
        l.addEventListener(r6, a), l.dispatchEvent(b), b.defaultPrevented || (cct(hct(Jxe(l)), { select: !0 }), document.activeElement === m && Wh(l));
      }
      return () => {
        l.removeEventListener(r6, a), setTimeout(() => {
          const b = new CustomEvent(i6, mie);
          l.addEventListener(i6, u), l.dispatchEvent(b), b.defaultPrevented || Wh(m ?? document.body, { select: !0 }), l.removeEventListener(i6, u), yie.remove(p);
        }, 0);
      };
    }
  }, [l, a, u, p]);
  const h = N.useCallback(
    (m) => {
      if (!n && !r || p.paused) return;
      const v = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (v && b) {
        const A = m.currentTarget, [w, O] = uct(A);
        w && O ? !m.shiftKey && b === O ? (m.preventDefault(), n && Wh(w, { select: !0 })) : m.shiftKey && b === w && (m.preventDefault(), n && Wh(O, { select: !0 })) : b === A && m.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ y(Zt.div, { tabIndex: -1, ...s, ref: d, onKeyDown: h });
});
lx.displayName = lct;
function cct(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Wh(r, { select: t }), document.activeElement !== n) return;
}
function uct(e) {
  const t = Jxe(e), n = gie(t, e), r = gie(t.reverse(), e);
  return [n, r];
}
function Jxe(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function gie(e, t) {
  for (const n of e)
    if (!dct(n, { upTo: t })) return n;
}
function dct(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function fct(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wh(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && fct(e) && t && e.select();
  }
}
var yie = pct();
function pct() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = vie(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = vie(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function vie(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function hct(e) {
  return e.filter((t) => t.tagName !== "A");
}
var o6 = 0;
function Ez() {
  N.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? bie()), document.body.insertAdjacentElement("beforeend", e[1] ?? bie()), o6++, () => {
      o6 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), o6--;
    };
  }, []);
}
function bie() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var EB = function(e, t) {
  return EB = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, EB(e, t);
};
function eSe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  EB(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var bi = function() {
  return bi = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, bi.apply(this, arguments);
};
function cx(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function tSe(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, n, r);
  else for (var l = e.length - 1; l >= 0; l--) (s = e[l]) && (o = (i < 3 ? s(o) : i > 3 ? s(t, n, o) : s(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}
function nSe(e, t) {
  return function(n, r) {
    t(n, r, e);
  };
}
function mct(e, t, n, r, i, o) {
  function s(b) {
    if (b !== void 0 && typeof b != "function") throw new TypeError("Function expected");
    return b;
  }
  for (var l = r.kind, c = l === "getter" ? "get" : l === "setter" ? "set" : "value", a = !t && e ? r.static ? e : e.prototype : null, u = t || (a ? Object.getOwnPropertyDescriptor(a, r.name) : {}), f, d = !1, p = n.length - 1; p >= 0; p--) {
    var h = {};
    for (var m in r) h[m] = m === "access" ? {} : r[m];
    for (var m in r.access) h.access[m] = r.access[m];
    h.addInitializer = function(b) {
      if (d) throw new TypeError("Cannot add initializers after decoration has completed");
      o.push(s(b || null));
    };
    var v = (0, n[p])(l === "accessor" ? { get: u.get, set: u.set } : u[c], h);
    if (l === "accessor") {
      if (v === void 0) continue;
      if (v === null || typeof v != "object") throw new TypeError("Object expected");
      (f = s(v.get)) && (u.get = f), (f = s(v.set)) && (u.set = f), (f = s(v.init)) && i.unshift(f);
    } else (f = s(v)) && (l === "field" ? i.unshift(f) : u[c] = f);
  }
  a && Object.defineProperty(a, r.name, u), d = !0;
}
function gct(e, t, n) {
  for (var r = arguments.length > 2, i = 0; i < t.length; i++)
    n = r ? t[i].call(e, n) : t[i].call(e);
  return r ? n : void 0;
}
function yct(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function vct(e, t, n) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: n ? "".concat(n, " ", t) : t });
}
function rSe(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function iSe(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function l(u) {
      try {
        a(r.next(u));
      } catch (f) {
        s(f);
      }
    }
    function c(u) {
      try {
        a(r.throw(u));
      } catch (f) {
        s(f);
      }
    }
    function a(u) {
      u.done ? o(u.value) : i(u.value).then(l, c);
    }
    a((r = r.apply(e, t || [])).next());
  });
}
function oSe(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(a) {
    return function(u) {
      return c([a, u]);
    };
  }
  function c(a) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, a[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = a[0] & 2 ? i.return : a[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, a[1])).done) return o;
      switch (i = 0, o && (a = [a[0] & 2, o.value]), a[0]) {
        case 0:
        case 1:
          o = a;
          break;
        case 4:
          return n.label++, { value: a[1], done: !1 };
        case 5:
          n.label++, i = a[1], a = [0];
          continue;
        case 7:
          a = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (a[0] === 6 || a[0] === 2)) {
            n = 0;
            continue;
          }
          if (a[0] === 3 && (!o || a[1] > o[0] && a[1] < o[3])) {
            n.label = a[1];
            break;
          }
          if (a[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = a;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(a);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      a = t.call(e, n);
    } catch (u) {
      a = [6, u], i = 0;
    } finally {
      r = o = 0;
    }
    if (a[0] & 5) throw a[1];
    return { value: a[0] ? a[1] : void 0, done: !0 };
  }
}
var Tz = Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
};
function sSe(e, t) {
  for (var n in e) n !== "default" && !Object.prototype.hasOwnProperty.call(t, n) && Tz(t, e, n);
}
function cD(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function mQ(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (l) {
    s = { error: l };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function aSe() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(mQ(arguments[t]));
  return e;
}
function lSe() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var o = arguments[t], s = 0, l = o.length; s < l; s++, i++)
      r[i] = o[s];
  return r;
}
function JC(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function YA(e) {
  return this instanceof YA ? (this.v = e, this) : new YA(e);
}
function cSe(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = {}, s("next"), s("throw"), s("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(d) {
    r[d] && (i[d] = function(p) {
      return new Promise(function(h, m) {
        o.push([d, p, h, m]) > 1 || l(d, p);
      });
    });
  }
  function l(d, p) {
    try {
      c(r[d](p));
    } catch (h) {
      f(o[0][3], h);
    }
  }
  function c(d) {
    d.value instanceof YA ? Promise.resolve(d.value.v).then(a, u) : f(o[0][2], d);
  }
  function a(d) {
    l("next", d);
  }
  function u(d) {
    l("throw", d);
  }
  function f(d, p) {
    d(p), o.shift(), o.length && l(o[0][0], o[0][1]);
  }
}
function uSe(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(i, o) {
    t[i] = e[i] ? function(s) {
      return (n = !n) ? { value: YA(e[i](s)), done: !1 } : o ? o(s) : s;
    } : o;
  }
}
function dSe(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof cD == "function" ? cD(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(l, c) {
        s = e[o](s), i(l, c, s.done, s.value);
      });
    };
  }
  function i(o, s, l, c) {
    Promise.resolve(c).then(function(a) {
      o({ value: a, done: l });
    }, s);
  }
}
function fSe(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var bct = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
};
function pSe(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Tz(t, e, n);
  return bct(t, e), t;
}
function hSe(e) {
  return e && e.__esModule ? e : { default: e };
}
function mSe(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function gSe(e, t, n, r, i) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function ySe(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function vSe(e, t, n) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var r;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = t[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = t[Symbol.dispose];
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    e.stack.push({ value: t, dispose: r, async: n });
  } else n && e.stack.push({ async: !0 });
  return t;
}
var Oct = typeof SuppressedError == "function" ? SuppressedError : function(e, t, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
};
function bSe(e) {
  function t(r) {
    e.error = e.hasError ? new Oct(r, e.error, "An error was suppressed during disposal.") : r, e.hasError = !0;
  }
  function n() {
    for (; e.stack.length; ) {
      var r = e.stack.pop();
      try {
        var i = r.dispose && r.dispose.call(r.value);
        if (r.async) return Promise.resolve(i).then(n, function(o) {
          return t(o), n();
        });
      } catch (o) {
        t(o);
      }
    }
    if (e.hasError) throw e.error;
  }
  return n();
}
const Act = {
  __extends: eSe,
  __assign: bi,
  __rest: cx,
  __decorate: tSe,
  __param: nSe,
  __metadata: rSe,
  __awaiter: iSe,
  __generator: oSe,
  __createBinding: Tz,
  __exportStar: sSe,
  __values: cD,
  __read: mQ,
  __spread: aSe,
  __spreadArrays: lSe,
  __spreadArray: JC,
  __await: YA,
  __asyncGenerator: cSe,
  __asyncDelegator: uSe,
  __asyncValues: dSe,
  __makeTemplateObject: fSe,
  __importStar: pSe,
  __importDefault: hSe,
  __classPrivateFieldGet: mSe,
  __classPrivateFieldSet: gSe,
  __classPrivateFieldIn: ySe,
  __addDisposableResource: vSe,
  __disposeResources: bSe
}, wct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: vSe,
  get __assign() {
    return bi;
  },
  __asyncDelegator: uSe,
  __asyncGenerator: cSe,
  __asyncValues: dSe,
  __await: YA,
  __awaiter: iSe,
  __classPrivateFieldGet: mSe,
  __classPrivateFieldIn: ySe,
  __classPrivateFieldSet: gSe,
  __createBinding: Tz,
  __decorate: tSe,
  __disposeResources: bSe,
  __esDecorate: mct,
  __exportStar: sSe,
  __extends: eSe,
  __generator: oSe,
  __importDefault: hSe,
  __importStar: pSe,
  __makeTemplateObject: fSe,
  __metadata: rSe,
  __param: nSe,
  __propKey: yct,
  __read: mQ,
  __rest: cx,
  __runInitializers: gct,
  __setFunctionName: vct,
  __spread: aSe,
  __spreadArray: JC,
  __spreadArrays: lSe,
  __values: cD,
  default: Act
}, Symbol.toStringTag, { value: "Module" }));
var UO = "right-scroll-bar-position", VO = "width-before-scroll-bar", xct = "with-scroll-bars-hidden", Sct = "--removed-body-scroll-bar-size";
function s6(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ect(e, t) {
  var n = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Tct = typeof window < "u" ? N.useLayoutEffect : N.useEffect, Oie = /* @__PURE__ */ new WeakMap();
function gQ(e, t) {
  var n = Ect(null, function(r) {
    return e.forEach(function(i) {
      return s6(i, r);
    });
  });
  return Tct(function() {
    var r = Oie.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), s = n.current;
      i.forEach(function(l) {
        o.has(l) || s6(l, null);
      }), o.forEach(function(l) {
        i.has(l) || s6(l, s);
      });
    }
    Oie.set(n, e);
  }, [e]), n;
}
function kct(e) {
  return e;
}
function Cct(e, t) {
  t === void 0 && (t = kct);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var s = t(o, r);
      return n.push(s), function() {
        n = n.filter(function(l) {
          return l !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(l) {
          return o(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(o), s = n;
      }
      var c = function() {
        var u = s;
        s = [], u.forEach(o);
      }, a = function() {
        return Promise.resolve().then(c);
      };
      a(), n = {
        push: function(u) {
          s.push(u), a();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return i;
}
function yQ(e) {
  e === void 0 && (e = {});
  var t = Cct(null);
  return t.options = bi({ async: !0, ssr: !1 }, e), t;
}
var OSe = function(e) {
  var t = e.sideCar, n = cx(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return N.createElement(r, bi({}, n));
};
OSe.isSideCarExport = !0;
function vQ(e, t) {
  return e.useMedium(t), OSe;
}
var ASe = yQ(), a6 = function() {
}, kz = N.forwardRef(function(e, t) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: a6,
    onWheelCapture: a6,
    onTouchMoveCapture: a6
  }), i = r[0], o = r[1], s = e.forwardProps, l = e.children, c = e.className, a = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, p = e.noIsolation, h = e.inert, m = e.allowPinchZoom, v = e.as, b = v === void 0 ? "div" : v, A = e.gapMode, w = cx(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = d, x = gQ([n, t]), S = bi(bi({}, w), i);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(O, { sideCar: ASe, removeScrollBar: a, shards: f, noIsolation: p, inert: h, setCallbacks: o, allowPinchZoom: !!m, lockRef: n, gapMode: A }),
    s ? N.cloneElement(N.Children.only(l), bi(bi({}, S), { ref: x })) : N.createElement(b, bi({}, S, { className: c, ref: x }), l)
  );
});
kz.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
kz.classNames = {
  fullWidth: VO,
  zeroRight: UO
};
var Nct = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Pct() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Nct();
  return t && e.setAttribute("nonce", t), e;
}
function Ict(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Rct(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Mct = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Pct()) && (Ict(t, n), Rct(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Dct = function() {
  var e = Mct();
  return function(t, n) {
    N.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Cz = function() {
  var e = Dct(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, _ct = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, l6 = function(e) {
  return parseInt(e || "", 10) || 0;
}, Lct = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [l6(n), l6(r), l6(i)];
}, zct = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return _ct;
  var t = Lct(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, jct = Cz(), qO = "data-scroll-locked", Fct = function(e, t, n, r) {
  var i = e.left, o = e.top, s = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(xct, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body[`).concat(qO, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(UO, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(VO, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(UO, " .").concat(UO, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(VO, " .").concat(VO, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(qO, `] {
    `).concat(Sct, ": ").concat(l, `px;
  }
`);
}, Aie = function() {
  var e = parseInt(document.body.getAttribute(qO) || "0", 10);
  return isFinite(e) ? e : 0;
}, Uct = function() {
  N.useEffect(function() {
    return document.body.setAttribute(qO, (Aie() + 1).toString()), function() {
      var e = Aie() - 1;
      e <= 0 ? document.body.removeAttribute(qO) : document.body.setAttribute(qO, e.toString());
    };
  }, []);
}, bQ = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Uct();
  var o = N.useMemo(function() {
    return zct(i);
  }, [i]);
  return N.createElement(jct, { styles: Fct(o, !t, i, n ? "" : "!important") });
}, TB = !1;
if (typeof window < "u")
  try {
    var SP = Object.defineProperty({}, "passive", {
      get: function() {
        return TB = !0, !0;
      }
    });
    window.addEventListener("test", SP, SP), window.removeEventListener("test", SP, SP);
  } catch {
    TB = !1;
  }
var $b = TB ? { passive: !1 } : !1, Vct = function(e) {
  return e.tagName === "TEXTAREA";
}, wSe = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Vct(e) && n[t] === "visible")
  );
}, qct = function(e) {
  return wSe(e, "overflowY");
}, Bct = function(e) {
  return wSe(e, "overflowX");
}, wie = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = xSe(e, r);
    if (i) {
      var o = SSe(e, r), s = o[1], l = o[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Xct = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Wct = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, xSe = function(e, t) {
  return e === "v" ? qct(t) : Bct(t);
}, SSe = function(e, t) {
  return e === "v" ? Xct(t) : Wct(t);
}, Zct = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Hct = function(e, t, n, r, i) {
  var o = Zct(e, window.getComputedStyle(t).direction), s = o * r, l = n.target, c = t.contains(l), a = !1, u = s > 0, f = 0, d = 0;
  do {
    var p = SSe(e, l), h = p[0], m = p[1], v = p[2], b = m - v - o * h;
    (h || b) && xSe(e, l) && (f += b, d += h), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(d) < 1) && (a = !0), a;
}, EP = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, xie = function(e) {
  return [e.deltaX, e.deltaY];
}, Sie = function(e) {
  return e && "current" in e ? e.current : e;
}, Qct = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $ct = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Kct = 0, Kb = [];
function Gct(e) {
  var t = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), i = N.useState(Kct++)[0], o = N.useState(Cz)[0], s = N.useRef(e);
  N.useEffect(function() {
    s.current = e;
  }, [e]), N.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = JC([e.lockRef.current], (e.shards || []).map(Sie), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = N.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = EP(m), A = n.current, w = "deltaX" in m ? m.deltaX : A[0] - b[0], O = "deltaY" in m ? m.deltaY : A[1] - b[1], x, S = m.target, E = Math.abs(w) > Math.abs(O) ? "h" : "v";
    if ("touches" in m && E === "h" && S.type === "range")
      return !1;
    var k = wie(E, S);
    if (!k)
      return !0;
    if (k ? x = E : (x = E === "v" ? "h" : "v", k = wie(E, S)), !k)
      return !1;
    if (!r.current && "changedTouches" in m && (w || O) && (r.current = x), !x)
      return !0;
    var T = r.current || x;
    return Hct(T, v, m, T === "h" ? w : O);
  }, []), c = N.useCallback(function(m) {
    var v = m;
    if (!(!Kb.length || Kb[Kb.length - 1] !== o)) {
      var b = "deltaY" in v ? xie(v) : EP(v), A = t.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && Qct(x.delta, b);
      })[0];
      if (A && A.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!A) {
        var w = (s.current.shards || []).map(Sie).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), O = w.length > 0 ? l(v, w[0]) : !s.current.noIsolation;
        O && v.cancelable && v.preventDefault();
      }
    }
  }, []), a = N.useCallback(function(m, v, b, A) {
    var w = { name: m, delta: v, target: b, should: A, shadowParent: Yct(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== w;
      });
    }, 1);
  }, []), u = N.useCallback(function(m) {
    n.current = EP(m), r.current = void 0;
  }, []), f = N.useCallback(function(m) {
    a(m.type, xie(m), m.target, l(m, e.lockRef.current));
  }, []), d = N.useCallback(function(m) {
    a(m.type, EP(m), m.target, l(m, e.lockRef.current));
  }, []);
  N.useEffect(function() {
    return Kb.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, $b), document.addEventListener("touchmove", c, $b), document.addEventListener("touchstart", u, $b), function() {
      Kb = Kb.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, $b), document.removeEventListener("touchmove", c, $b), document.removeEventListener("touchstart", u, $b);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return N.createElement(
    N.Fragment,
    null,
    h ? N.createElement(o, { styles: $ct(i) }) : null,
    p ? N.createElement(bQ, { gapMode: e.gapMode }) : null
  );
}
function Yct(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Jct = vQ(ASe, Gct);
var eN = N.forwardRef(function(e, t) {
  return N.createElement(kz, bi({}, e, { ref: t, sideCar: Jct }));
});
eN.classNames = kz.classNames;
var eut = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Gb = /* @__PURE__ */ new WeakMap(), TP = /* @__PURE__ */ new WeakMap(), kP = {}, c6 = 0, ESe = function(e) {
  return e && (e.host || ESe(e.parentNode));
}, tut = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = ESe(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, nut = function(e, t, n, r) {
  var i = tut(t, Array.isArray(e) ? e : [e]);
  kP[n] || (kP[n] = /* @__PURE__ */ new WeakMap());
  var o = kP[n], s = [], l = /* @__PURE__ */ new Set(), c = new Set(i), a = function(f) {
    !f || l.has(f) || (l.add(f), a(f.parentNode));
  };
  i.forEach(a);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (l.has(d))
        u(d);
      else
        try {
          var p = d.getAttribute(r), h = p !== null && p !== "false", m = (Gb.get(d) || 0) + 1, v = (o.get(d) || 0) + 1;
          Gb.set(d, m), o.set(d, v), s.push(d), m === 1 && h && TP.set(d, !0), v === 1 && d.setAttribute(n, "true"), h || d.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", d, b);
        }
    });
  };
  return u(t), l.clear(), c6++, function() {
    s.forEach(function(f) {
      var d = Gb.get(f) - 1, p = o.get(f) - 1;
      Gb.set(f, d), o.set(f, p), d || (TP.has(f) || f.removeAttribute(r), TP.delete(f)), p || f.removeAttribute(n);
    }), c6--, c6 || (Gb = /* @__PURE__ */ new WeakMap(), Gb = /* @__PURE__ */ new WeakMap(), TP = /* @__PURE__ */ new WeakMap(), kP = {});
  };
}, ux = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = eut(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), nut(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, OQ = "Dialog", [TSe, Hhn] = Ms(OQ), [rut, md] = TSe(OQ), kSe = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, l = N.useRef(null), c = N.useRef(null), [a = !1, u] = wl({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ y(
    rut,
    {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: ka(),
      titleId: ka(),
      descriptionId: ka(),
      open: a,
      onOpenChange: u,
      onOpenToggle: N.useCallback(() => u((f) => !f), [u]),
      modal: s,
      children: n
    }
  );
};
kSe.displayName = OQ;
var CSe = "DialogTrigger", AQ = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = md(CSe, n), o = xn(t, i.triggerRef);
    return /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": EQ(i.open),
        ...r,
        ref: o,
        onClick: ot(e.onClick, i.onOpenToggle)
      }
    );
  }
);
AQ.displayName = CSe;
var wQ = "DialogPortal", [iut, NSe] = TSe(wQ, {
  forceMount: void 0
}), PSe = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = md(wQ, t);
  return /* @__PURE__ */ y(iut, { scope: t, forceMount: n, children: N.Children.map(r, (s) => /* @__PURE__ */ y(wo, { present: n || o.open, children: /* @__PURE__ */ y(ax, { asChild: !0, container: i, children: s }) })) });
};
PSe.displayName = wQ;
var uD = "DialogOverlay", ISe = N.forwardRef(
  (e, t) => {
    const n = NSe(uD, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = md(uD, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ y(wo, { present: r || o.open, children: /* @__PURE__ */ y(out, { ...i, ref: t }) }) : null;
  }
);
ISe.displayName = uD;
var out = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = md(uD, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ y(eN, { as: is, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ y(
        Zt.div,
        {
          "data-state": EQ(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Iv = "DialogContent", RSe = N.forwardRef(
  (e, t) => {
    const n = NSe(Iv, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = md(Iv, e.__scopeDialog);
    return /* @__PURE__ */ y(wo, { present: r || o.open, children: o.modal ? /* @__PURE__ */ y(sut, { ...i, ref: t }) : /* @__PURE__ */ y(aut, { ...i, ref: t }) });
  }
);
RSe.displayName = Iv;
var sut = N.forwardRef(
  (e, t) => {
    const n = md(Iv, e.__scopeDialog), r = N.useRef(null), i = xn(t, n.contentRef, r);
    return N.useEffect(() => {
      const o = r.current;
      if (o) return ux(o);
    }, []), /* @__PURE__ */ y(
      MSe,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ot(e.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: ot(e.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || l) && o.preventDefault();
        }),
        onFocusOutside: ot(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), aut = N.forwardRef(
  (e, t) => {
    const n = md(Iv, e.__scopeDialog), r = N.useRef(!1), i = N.useRef(!1);
    return /* @__PURE__ */ y(
      MSe,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, l;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (l = n.triggerRef.current) == null || l.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, a;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((a = n.triggerRef.current) == null ? void 0 : a.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), MSe = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = e, l = md(Iv, n), c = N.useRef(null), a = xn(t, c);
    return Ez(), /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        lx,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ y(
            nx,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": EQ(l.open),
              ...s,
              ref: a,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y(lut, { titleId: l.titleId }),
        /* @__PURE__ */ y(uut, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), xQ = "DialogTitle", DSe = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = md(xQ, n);
    return /* @__PURE__ */ y(Zt.h2, { id: i.titleId, ...r, ref: t });
  }
);
DSe.displayName = xQ;
var _Se = "DialogDescription", LSe = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = md(_Se, n);
    return /* @__PURE__ */ y(Zt.p, { id: i.descriptionId, ...r, ref: t });
  }
);
LSe.displayName = _Se;
var zSe = "DialogClose", SQ = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = md(zSe, n);
    return /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ot(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
SQ.displayName = zSe;
function EQ(e) {
  return e ? "open" : "closed";
}
var jSe = "DialogTitleWarning", [Qhn, FSe] = mat(jSe, {
  contentName: Iv,
  titleName: xQ,
  docsSlug: "dialog"
}), lut = ({ titleId: e }) => {
  const t = FSe(jSe), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return N.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, cut = "DialogDescriptionWarning", uut = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${FSe(cut).contentName}}.`;
  return N.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, USe = kSe, dut = AQ, VSe = PSe, Nz = ISe, Pz = RSe, Iz = DSe, Rz = LSe, TQ = SQ;
const fut = USe, put = VSe, qSe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nz,
  {
    className: Se(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
qSe.displayName = Nz.displayName;
const hut = as(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), BSe = N.forwardRef(
  ({ side: e = "right", className: t, children: n, hideCloseButton: r = !1, ...i }, o) => /* @__PURE__ */ V(put, { children: [
    /* @__PURE__ */ y(qSe, {}),
    /* @__PURE__ */ V(
      Pz,
      {
        ref: o,
        className: Se(hut({ side: e }), t),
        ...i,
        children: [
          !r && /* @__PURE__ */ V(TQ, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent", children: [
            /* @__PURE__ */ y(ks, { className: "h-4 w-4" }),
            /* @__PURE__ */ y("span", { className: "sr-only", children: "Close" })
          ] }),
          n
        ]
      }
    )
  ] })
);
BSe.displayName = Pz.displayName;
const XSe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y(
  "div",
  {
    className: Se(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
XSe.displayName = "SheetHeader";
const WSe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Iz,
  {
    ref: n,
    className: Se("text-lg font-semibold text-foreground", e),
    ...t
  }
));
WSe.displayName = Iz.displayName;
const ZSe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Rz,
  {
    ref: n,
    className: Se("text-sm text-muted-foreground", e),
    ...t
  }
));
ZSe.displayName = Rz.displayName;
function Tr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ y(
    "div",
    {
      className: Se("animate-pulse rounded-md bg-muted/50", e),
      ...t
    }
  );
}
function kQ({
  className: e,
  numberOfItems: t = 3,
  ...n
}) {
  const r = Array(t).fill(null);
  return /* @__PURE__ */ y("div", { className: "space-y-3", children: r.map((i, o) => /* @__PURE__ */ y(
    Tr,
    {
      className: Se("h-4 w-full", e),
      ...n
    },
    o
  )) });
}
kQ.displayName = "SkeletonList";
Tr.displayName = "Skeleton";
const u6 = 768;
function Mz() {
  const [e, t] = N.useState(
    void 0
  );
  return N.useEffect(() => {
    const n = window.matchMedia(`(max-width: ${u6 - 1}px)`), r = () => {
      t(window.innerWidth < u6);
    };
    return n.addEventListener("change", r), t(window.innerWidth < u6), () => n.removeEventListener("change", r);
  }, []), !!e;
}
const mut = "18rem", gut = "18rem", yut = "3rem", vut = "b", HSe = "sidebar-state";
function but() {
  const e = localStorage.getItem(HSe);
  return e ? e === "true" : !0;
}
function Out(e) {
  localStorage.setItem(HSe, e.toString());
}
const QSe = N.createContext(null);
function dx() {
  const e = N.useContext(QSe);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
const $Se = N.forwardRef(
  ({
    defaultOpen: e,
    open: t,
    onOpenChange: n,
    className: r,
    style: i,
    children: o,
    ...s
  }, l) => {
    const c = Mz(), [a, u] = N.useState(!1), [f, d] = N.useState(
      e ?? but()
    ), p = t ?? f, h = N.useCallback(
      (A) => {
        const w = typeof A == "function" ? A(p) : A;
        n ? n(w) : d(w), Out(w);
      },
      [n, p]
    ), m = N.useCallback(() => c ? u((A) => !A) : h((A) => !A), [c, h, u]);
    N.useEffect(() => {
      const A = (w) => {
        w.key === vut && (w.metaKey || w.ctrlKey) && (w.preventDefault(), m());
      };
      return window.addEventListener("keydown", A), () => window.removeEventListener("keydown", A);
    }, [m]);
    const v = p ? "expanded" : "collapsed", b = N.useMemo(
      () => ({
        state: v,
        open: p,
        setOpen: h,
        isMobile: c,
        openMobile: a,
        setOpenMobile: u,
        toggleSidebar: m
      }),
      [
        v,
        p,
        h,
        c,
        a,
        u,
        m
      ]
    );
    return /* @__PURE__ */ y(QSe.Provider, { value: b, children: /* @__PURE__ */ y(Kp, { delayDuration: 0, children: /* @__PURE__ */ y(
      "div",
      {
        style: {
          "--sidebar-width": mut,
          "--sidebar-width-icon": yut,
          ...i
        },
        className: Se(
          "group/sidebar-wrapper flex min-h-svh w-full has-data-[variant=inset]:bg-sidebar",
          r
        ),
        ref: l,
        ...s,
        children: o
      }
    ) }) });
  }
);
$Se.displayName = "SidebarProvider";
const Aut = N.forwardRef(
  ({
    side: e = "left",
    variant: t = "sidebar",
    collapsible: n = "offcanvas",
    className: r,
    children: i,
    ...o
  }, s) => {
    const { isMobile: l, state: c, openMobile: a, setOpenMobile: u, setOpen: f } = dx();
    return n === "none" ? /* @__PURE__ */ y(
      "div",
      {
        className: Se(
          "flex h-full w-(--sidebar-width) flex-col bg-sidebar text-sidebar-foreground",
          r
        ),
        ref: s,
        ...o,
        children: i
      }
    ) : l ? /* @__PURE__ */ y(fut, { open: a, onOpenChange: u, ...o, children: /* @__PURE__ */ V(
      BSe,
      {
        "data-sidebar": "sidebar",
        "data-mobile": "true",
        className: "w-(--sidebar-width) bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
        style: {
          "--sidebar-width": gut
        },
        side: e,
        children: [
          /* @__PURE__ */ V(XSe, { className: "sr-only", children: [
            /* @__PURE__ */ y(WSe, { children: "Sidebar" }),
            /* @__PURE__ */ y(ZSe, { children: "Displays the mobile sidebar." })
          ] }),
          /* @__PURE__ */ y("div", { className: "flex h-full w-full flex-col", children: i })
        ]
      }
    ) }) : /* @__PURE__ */ V(
      "div",
      {
        ref: s,
        className: "group peer hidden text-sidebar-foreground md:block",
        "data-state": c,
        "data-collapsible": c === "collapsed" ? n : "",
        "data-variant": t,
        "data-side": e,
        children: [
          /* @__PURE__ */ y(
            "div",
            {
              className: Se(
                "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-in-out",
                "group-data-[collapsible=offcanvas]:w-0",
                "group-data-[side=right]:rotate-180",
                t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
              )
            }
          ),
          /* @__PURE__ */ y(
            "div",
            {
              className: Se(
                "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-in-out md:flex",
                e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-[--sidebar-width-icon]",
                c === "collapsed" && n === "icon" && "[&_*]:!cursor-nesw-resize [&_button]:!cursor-pointer [&_button]:relative [&_button]:z-20 [&_button_*]:!cursor-pointer [&_a]:!cursor-pointer [&_a]:relative [&_a]:z-20 [&_a_*]:!cursor-pointer [&_[role=button]]:!cursor-pointer [&_[role=button]]:relative [&_[role=button]]:z-20 [&_[role=button]_*]:!cursor-pointer [&_[data-sidebar=menu-button]]:!cursor-pointer [&_[data-sidebar=menu-button]]:relative [&_[data-sidebar=menu-button]]:z-20 [&_[data-sidebar=menu-button]_*]:!cursor-pointer cursor-nesw-resize",
                r
              ),
              ...o,
              children: /* @__PURE__ */ V(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: Se(
                    "flex h-full w-full flex-col bg-sidebar group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow-sm",
                    c === "collapsed" && n === "icon" && "relative"
                  ),
                  children: [
                    c === "collapsed" && n === "icon" && /* @__PURE__ */ y(
                      "div",
                      {
                        className: "absolute inset-0 !cursor-nesw-resize z-10",
                        onClick: () => f(!0),
                        "aria-hidden": "true"
                      }
                    ),
                    i
                  ]
                }
              )
            }
          )
        ]
      }
    );
  }
);
Aut.displayName = "Sidebar";
const KSe = N.forwardRef(({ className: e, onClick: t, iconClassName: n, ...r }, i) => {
  const { toggleSidebar: o, state: s } = dx();
  return /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V(
      Qe,
      {
        ref: i,
        "data-sidebar": "trigger",
        variant: "ghost",
        size: "icon",
        className: Se(e),
        onClick: (l) => {
          t == null || t(l), o();
        },
        ...r,
        children: [
          /* @__PURE__ */ y(Pot, {}),
          /* @__PURE__ */ y("span", { className: "sr-only", children: Z("Toggle Sidebar") })
        ]
      }
    ) }),
    /* @__PURE__ */ y(An, { children: Z(s === "expanded" ? "Close Sidebar" : "Open Sidebar") })
  ] });
});
KSe.displayName = "SidebarTrigger";
const wut = N.forwardRef(({ className: e, ...t }, n) => {
  const { toggleSidebar: r } = dx();
  return /* @__PURE__ */ y(
    "button",
    {
      ref: n,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: Se(
        "absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-in-out after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-sidebar-border group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex",
        "in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full hover:group-data-[collapsible=offcanvas]:bg-sidebar",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
});
wut.displayName = "SidebarRail";
const xut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "main",
  {
    ref: n,
    className: Se(
      "relative flex w-full flex-1 flex-col bg-background max-h-[calc(100vh)]",
      "md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:border-l",
      e
    ),
    ...t
  }
));
xut.displayName = "SidebarInset";
const Sut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  fr,
  {
    ref: n,
    "data-sidebar": "input",
    className: Se(
      "h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring",
      e
    ),
    ...t
  }
));
Sut.displayName = "SidebarInput";
const Eut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "header",
    className: Se("flex flex-col gap-2 p-2", e),
    ...t
  }
));
Eut.displayName = "SidebarHeader";
const Tut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "footer",
    className: Se("flex flex-col gap-2 p-2", e),
    ...t
  }
));
Tut.displayName = "SidebarFooter";
const kut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Eh,
  {
    ref: n,
    "data-sidebar": "separator",
    className: Se("m-2 w-auto bg-sidebar-border", e),
    ...t
  }
));
kut.displayName = "SidebarSeparator";
const Cut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "content",
    className: Se(
      "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
      e
    ),
    ...t
  }
));
Cut.displayName = "SidebarContent";
const Nut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "group",
    className: Se(
      "relative flex w-full min-w-0 flex-col px-2 py-0",
      e
    ),
    ...t
  }
));
Nut.displayName = "SidebarGroup";
const Put = N.forwardRef(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ y(
  t ? is : "div",
  {
    ref: r,
    "data-sidebar": "group-label",
    className: Se(
      "flex h-8 shrink-0 items-center rounded-sm px-2 text-xs font-medium text-sidebar-foreground/70 outline-none ring-sidebar-ring transition-[margin,opacity] duration-200 ease-in-out focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
      e
    ),
    ...n
  }
));
Put.displayName = "SidebarGroupLabel";
const Iut = N.forwardRef(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ y(
  t ? is : "button",
  {
    ref: r,
    "data-sidebar": "group-action",
    className: Se(
      "absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-sm p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 md:after:hidden",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...n
  }
));
Iut.displayName = "SidebarGroupAction";
const Rut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "group-content",
    className: Se("w-full text-sm", e),
    ...t
  }
));
Rut.displayName = "SidebarGroupContent";
const Mut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu",
    className: Se("flex w-full min-w-0 flex-col gap-1", e),
    ...t
  }
));
Mut.displayName = "SidebarMenu";
const Dut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "li",
  {
    ref: n,
    "data-sidebar": "menu-item",
    className: Se("group/menu-item relative", e),
    ...t
  }
));
Dut.displayName = "SidebarMenuItem";
const _ut = as(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-sm  text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent active:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Lut = N.forwardRef(
  ({
    asChild: e = !1,
    isActive: t = !1,
    variant: n = "default",
    size: r = "default",
    tooltip: i,
    className: o,
    ...s
  }, l) => {
    const c = e ? is : "button", { isMobile: a, state: u } = dx(), f = /* @__PURE__ */ y(
      c,
      {
        ref: l,
        "data-sidebar": "menu-button",
        "data-size": r,
        "data-active": t,
        className: Se(_ut({ variant: n, size: r }), o),
        ...s
      }
    );
    return i ? (typeof i == "string" && (i = {
      children: i
    }), /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: f }),
      /* @__PURE__ */ y(
        An,
        {
          side: "right",
          align: "center",
          hidden: u !== "collapsed" || a,
          ...i
        }
      )
    ] })) : f;
  }
);
Lut.displayName = "SidebarMenuButton";
const zut = N.forwardRef(({ className: e, asChild: t = !1, showOnHover: n = !1, ...r }, i) => /* @__PURE__ */ y(
  t ? is : "button",
  {
    ref: i,
    "data-sidebar": "menu-action",
    className: Se(
      "absolute right-1 top-2 flex aspect-square w-5 items-center justify-center rounded-sm p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 peer-hover/menu-button:text-sidebar-accent-foreground [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 md:after:hidden",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      n && "group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 peer-data-[active=true]/menu-button:text-sidebar-accent-foreground md:opacity-0",
      e
    ),
    ...r
  }
));
zut.displayName = "SidebarMenuAction";
const jut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    "data-sidebar": "menu-badge",
    className: Se(
      "pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-sm px-1 text-xs font-medium tabular-nums text-sidebar-foreground",
      "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
jut.displayName = "SidebarMenuBadge";
const Fut = N.forwardRef(({ className: e, showIcon: t = !1, ...n }, r) => {
  const i = N.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ V(
    "div",
    {
      ref: r,
      "data-sidebar": "menu-skeleton",
      className: Se("flex h-8 items-center gap-2 rounded-sm px-2", e),
      ...n,
      children: [
        t && /* @__PURE__ */ y(
          Tr,
          {
            className: "size-4 rounded-sm",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ y(
          Tr,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": i
            }
          }
        )
      ]
    }
  );
});
Fut.displayName = "SidebarMenuSkeleton";
const Uut = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu-sub",
    className: Se(
      "ml-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border pl-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
Uut.displayName = "SidebarMenuSub";
const Vut = N.forwardRef(({ ...e }, t) => /* @__PURE__ */ y("li", { ref: t, ...e }));
Vut.displayName = "SidebarMenuSubItem";
const qut = N.forwardRef(({ asChild: e = !1, size: t = "md", isActive: n, className: r, ...i }, o) => /* @__PURE__ */ y(
  e ? is : "a",
  {
    ref: o,
    "data-sidebar": "menu-sub-button",
    "data-size": t,
    "data-active": n,
    className: Se(
      "flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-sm px-2 text-sidebar-foreground outline-none ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground",
      "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
      t === "sm" && "text-xs",
      t === "md" && "text-sm",
      "group-data-[collapsible=icon]:hidden",
      r
    ),
    ...i
  }
));
qut.displayName = "SidebarMenuSubButton";
function xo(e) {
  if (typeof e == "string" || typeof e == "number") return "" + e;
  let t = "";
  if (Array.isArray(e))
    for (let n = 0, r; n < e.length; n++)
      (r = xo(e[n])) !== "" && (t += (t && " ") + r);
  else
    for (let n in e)
      e[n] && (t += (t && " ") + n);
  return t;
}
var But = { value: () => {
} };
function Dz() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new FR(n);
}
function FR(e) {
  this._ = e;
}
function Xut(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
FR.prototype = Dz.prototype = {
  constructor: FR,
  on: function(e, t) {
    var n = this._, r = Xut(e + "", n), i, o = -1, s = r.length;
    if (arguments.length < 2) {
      for (; ++o < s; ) if ((i = (e = r[o]).type) && (i = Wut(n[i], e.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++o < s; )
      if (i = (e = r[o]).type) n[i] = Eie(n[i], e.name, t);
      else if (t == null) for (i in n) n[i] = Eie(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new FR(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, o; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (o = this._[e], r = 0, i = o.length; r < i; ++r) o[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, o = r.length; i < o; ++i) r[i].value.apply(t, n);
  }
};
function Wut(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function Eie(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = But, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var kB = "http://www.w3.org/1999/xhtml";
const Tie = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: kB,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function _z(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), Tie.hasOwnProperty(t) ? { space: Tie[t], local: e } : e;
}
function Zut(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === kB && t.documentElement.namespaceURI === kB ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function Hut(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function GSe(e) {
  var t = _z(e);
  return (t.local ? Hut : Zut)(t);
}
function Qut() {
}
function CQ(e) {
  return e == null ? Qut : function() {
    return this.querySelector(e);
  };
}
function $ut(e) {
  typeof e != "function" && (e = CQ(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = t[i], s = o.length, l = r[i] = new Array(s), c, a, u = 0; u < s; ++u)
      (c = o[u]) && (a = e.call(c, c.__data__, u, o)) && ("__data__" in c && (a.__data__ = c.__data__), l[u] = a);
  return new pc(r, this._parents);
}
function Kut(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function Gut() {
  return [];
}
function YSe(e) {
  return e == null ? Gut : function() {
    return this.querySelectorAll(e);
  };
}
function Yut(e) {
  return function() {
    return Kut(e.apply(this, arguments));
  };
}
function Jut(e) {
  typeof e == "function" ? e = Yut(e) : e = YSe(e);
  for (var t = this._groups, n = t.length, r = [], i = [], o = 0; o < n; ++o)
    for (var s = t[o], l = s.length, c, a = 0; a < l; ++a)
      (c = s[a]) && (r.push(e.call(c, c.__data__, a, s)), i.push(c));
  return new pc(r, i);
}
function JSe(e) {
  return function() {
    return this.matches(e);
  };
}
function e1e(e) {
  return function(t) {
    return t.matches(e);
  };
}
var edt = Array.prototype.find;
function tdt(e) {
  return function() {
    return edt.call(this.children, e);
  };
}
function ndt() {
  return this.firstElementChild;
}
function rdt(e) {
  return this.select(e == null ? ndt : tdt(typeof e == "function" ? e : e1e(e)));
}
var idt = Array.prototype.filter;
function odt() {
  return Array.from(this.children);
}
function sdt(e) {
  return function() {
    return idt.call(this.children, e);
  };
}
function adt(e) {
  return this.selectAll(e == null ? odt : sdt(typeof e == "function" ? e : e1e(e)));
}
function ldt(e) {
  typeof e != "function" && (e = JSe(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = t[i], s = o.length, l = r[i] = [], c, a = 0; a < s; ++a)
      (c = o[a]) && e.call(c, c.__data__, a, o) && l.push(c);
  return new pc(r, this._parents);
}
function t1e(e) {
  return new Array(e.length);
}
function cdt() {
  return new pc(this._enter || this._groups.map(t1e), this._parents);
}
function dD(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
dD.prototype = {
  constructor: dD,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function udt(e) {
  return function() {
    return e;
  };
}
function ddt(e, t, n, r, i, o) {
  for (var s = 0, l, c = t.length, a = o.length; s < a; ++s)
    (l = t[s]) ? (l.__data__ = o[s], r[s] = l) : n[s] = new dD(e, o[s]);
  for (; s < c; ++s)
    (l = t[s]) && (i[s] = l);
}
function fdt(e, t, n, r, i, o, s) {
  var l, c, a = /* @__PURE__ */ new Map(), u = t.length, f = o.length, d = new Array(u), p;
  for (l = 0; l < u; ++l)
    (c = t[l]) && (d[l] = p = s.call(c, c.__data__, l, t) + "", a.has(p) ? i[l] = c : a.set(p, c));
  for (l = 0; l < f; ++l)
    p = s.call(e, o[l], l, o) + "", (c = a.get(p)) ? (r[l] = c, c.__data__ = o[l], a.delete(p)) : n[l] = new dD(e, o[l]);
  for (l = 0; l < u; ++l)
    (c = t[l]) && a.get(d[l]) === c && (i[l] = c);
}
function pdt(e) {
  return e.__data__;
}
function hdt(e, t) {
  if (!arguments.length) return Array.from(this, pdt);
  var n = t ? fdt : ddt, r = this._parents, i = this._groups;
  typeof e != "function" && (e = udt(e));
  for (var o = i.length, s = new Array(o), l = new Array(o), c = new Array(o), a = 0; a < o; ++a) {
    var u = r[a], f = i[a], d = f.length, p = mdt(e.call(u, u && u.__data__, a, r)), h = p.length, m = l[a] = new Array(h), v = s[a] = new Array(h), b = c[a] = new Array(d);
    n(u, f, m, v, b, p, t);
    for (var A = 0, w = 0, O, x; A < h; ++A)
      if (O = m[A]) {
        for (A >= w && (w = A + 1); !(x = v[w]) && ++w < h; ) ;
        O._next = x || null;
      }
  }
  return s = new pc(s, r), s._enter = l, s._exit = c, s;
}
function mdt(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function gdt() {
  return new pc(this._exit || this._groups.map(t1e), this._parents);
}
function ydt(e, t, n) {
  var r = this.enter(), i = this, o = this.exit();
  return typeof e == "function" ? (r = e(r), r && (r = r.selection())) : r = r.append(e + ""), t != null && (i = t(i), i && (i = i.selection())), n == null ? o.remove() : n(o), r && i ? r.merge(i).order() : i;
}
function vdt(e) {
  for (var t = e.selection ? e.selection() : e, n = this._groups, r = t._groups, i = n.length, o = r.length, s = Math.min(i, o), l = new Array(i), c = 0; c < s; ++c)
    for (var a = n[c], u = r[c], f = a.length, d = l[c] = new Array(f), p, h = 0; h < f; ++h)
      (p = a[h] || u[h]) && (d[h] = p);
  for (; c < i; ++c)
    l[c] = n[c];
  return new pc(l, this._parents);
}
function bdt() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var r = e[t], i = r.length - 1, o = r[i], s; --i >= 0; )
      (s = r[i]) && (o && s.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(s, o), o = s);
  return this;
}
function Odt(e) {
  e || (e = Adt);
  function t(f, d) {
    return f && d ? e(f.__data__, d.__data__) : !f - !d;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), o = 0; o < r; ++o) {
    for (var s = n[o], l = s.length, c = i[o] = new Array(l), a, u = 0; u < l; ++u)
      (a = s[u]) && (c[u] = a);
    c.sort(t);
  }
  return new pc(i, this._parents).order();
}
function Adt(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function wdt() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function xdt() {
  return Array.from(this);
}
function Sdt() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, o = r.length; i < o; ++i) {
      var s = r[i];
      if (s) return s;
    }
  return null;
}
function Edt() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function Tdt() {
  return !this.node();
}
function kdt(e) {
  for (var t = this._groups, n = 0, r = t.length; n < r; ++n)
    for (var i = t[n], o = 0, s = i.length, l; o < s; ++o)
      (l = i[o]) && e.call(l, l.__data__, o, i);
  return this;
}
function Cdt(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function Ndt(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Pdt(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function Idt(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function Rdt(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function Mdt(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function Ddt(e, t) {
  var n = _z(e);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((t == null ? n.local ? Ndt : Cdt : typeof t == "function" ? n.local ? Mdt : Rdt : n.local ? Idt : Pdt)(n, t));
}
function n1e(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function _dt(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Ldt(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function zdt(e, t, n) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
  };
}
function jdt(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? _dt : typeof t == "function" ? zdt : Ldt)(e, t, n ?? "")) : JA(this.node(), e);
}
function JA(e, t) {
  return e.style.getPropertyValue(t) || n1e(e).getComputedStyle(e, null).getPropertyValue(t);
}
function Fdt(e) {
  return function() {
    delete this[e];
  };
}
function Udt(e, t) {
  return function() {
    this[e] = t;
  };
}
function Vdt(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function qdt(e, t) {
  return arguments.length > 1 ? this.each((t == null ? Fdt : typeof t == "function" ? Vdt : Udt)(e, t)) : this.node()[e];
}
function r1e(e) {
  return e.trim().split(/^|\s+/);
}
function NQ(e) {
  return e.classList || new i1e(e);
}
function i1e(e) {
  this._node = e, this._names = r1e(e.getAttribute("class") || "");
}
i1e.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function o1e(e, t) {
  for (var n = NQ(e), r = -1, i = t.length; ++r < i; ) n.add(t[r]);
}
function s1e(e, t) {
  for (var n = NQ(e), r = -1, i = t.length; ++r < i; ) n.remove(t[r]);
}
function Bdt(e) {
  return function() {
    o1e(this, e);
  };
}
function Xdt(e) {
  return function() {
    s1e(this, e);
  };
}
function Wdt(e, t) {
  return function() {
    (t.apply(this, arguments) ? o1e : s1e)(this, e);
  };
}
function Zdt(e, t) {
  var n = r1e(e + "");
  if (arguments.length < 2) {
    for (var r = NQ(this.node()), i = -1, o = n.length; ++i < o; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? Wdt : t ? Bdt : Xdt)(n, t));
}
function Hdt() {
  this.textContent = "";
}
function Qdt(e) {
  return function() {
    this.textContent = e;
  };
}
function $dt(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function Kdt(e) {
  return arguments.length ? this.each(e == null ? Hdt : (typeof e == "function" ? $dt : Qdt)(e)) : this.node().textContent;
}
function Gdt() {
  this.innerHTML = "";
}
function Ydt(e) {
  return function() {
    this.innerHTML = e;
  };
}
function Jdt(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function eft(e) {
  return arguments.length ? this.each(e == null ? Gdt : (typeof e == "function" ? Jdt : Ydt)(e)) : this.node().innerHTML;
}
function tft() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function nft() {
  return this.each(tft);
}
function rft() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function ift() {
  return this.each(rft);
}
function oft(e) {
  var t = typeof e == "function" ? e : GSe(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function sft() {
  return null;
}
function aft(e, t) {
  var n = typeof e == "function" ? e : GSe(e), r = t == null ? sft : typeof t == "function" ? t : CQ(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function lft() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function cft() {
  return this.each(lft);
}
function uft() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function dft() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function fft(e) {
  return this.select(e ? dft : uft);
}
function pft(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function hft(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function mft(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", r = t.indexOf(".");
    return r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: n };
  });
}
function gft(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, r = -1, i = t.length, o; n < i; ++n)
        o = t[n], (!e.type || o.type === e.type) && o.name === e.name ? this.removeEventListener(o.type, o.listener, o.options) : t[++r] = o;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function yft(e, t, n) {
  return function() {
    var r = this.__on, i, o = hft(t);
    if (r) {
      for (var s = 0, l = r.length; s < l; ++s)
        if ((i = r[s]).type === e.type && i.name === e.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = o, i.options = n), i.value = t;
          return;
        }
    }
    this.addEventListener(e.type, o, n), i = { type: e.type, name: e.name, value: t, listener: o, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function vft(e, t, n) {
  var r = mft(e + ""), i, o = r.length, s;
  if (arguments.length < 2) {
    var l = this.node().__on;
    if (l) {
      for (var c = 0, a = l.length, u; c < a; ++c)
        for (i = 0, u = l[c]; i < o; ++i)
          if ((s = r[i]).type === u.type && s.name === u.name)
            return u.value;
    }
    return;
  }
  for (l = t ? yft : gft, i = 0; i < o; ++i) this.each(l(r[i], t, n));
  return this;
}
function a1e(e, t, n) {
  var r = n1e(e), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(t, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(t, !1, !1)), e.dispatchEvent(i);
}
function bft(e, t) {
  return function() {
    return a1e(this, e, t);
  };
}
function Oft(e, t) {
  return function() {
    return a1e(this, e, t.apply(this, arguments));
  };
}
function Aft(e, t) {
  return this.each((typeof t == "function" ? Oft : bft)(e, t));
}
function* wft() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], i = 0, o = r.length, s; i < o; ++i)
      (s = r[i]) && (yield s);
}
var l1e = [null];
function pc(e, t) {
  this._groups = e, this._parents = t;
}
function tN() {
  return new pc([[document.documentElement]], l1e);
}
function xft() {
  return this;
}
pc.prototype = tN.prototype = {
  constructor: pc,
  select: $ut,
  selectAll: Jut,
  selectChild: rdt,
  selectChildren: adt,
  filter: ldt,
  data: hdt,
  enter: cdt,
  exit: gdt,
  join: ydt,
  merge: vdt,
  selection: xft,
  order: bdt,
  sort: Odt,
  call: wdt,
  nodes: xdt,
  node: Sdt,
  size: Edt,
  empty: Tdt,
  each: kdt,
  attr: Ddt,
  style: jdt,
  property: qdt,
  classed: Zdt,
  text: Kdt,
  html: eft,
  raise: nft,
  lower: ift,
  append: oft,
  insert: aft,
  remove: cft,
  clone: fft,
  datum: pft,
  on: vft,
  dispatch: Aft,
  [Symbol.iterator]: wft
};
function Kl(e) {
  return typeof e == "string" ? new pc([[document.querySelector(e)]], [document.documentElement]) : new pc([[e]], l1e);
}
function Sft(e) {
  let t;
  for (; t = e.sourceEvent; ) e = t;
  return e;
}
function Iu(e, t) {
  if (e = Sft(e), t === void 0 && (t = e.currentTarget), t) {
    var n = t.ownerSVGElement || t;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = e.clientX, r.y = e.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (t.getBoundingClientRect) {
      var i = t.getBoundingClientRect();
      return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
    }
  }
  return [e.pageX, e.pageY];
}
const Eft = { passive: !1 }, MT = { capture: !0, passive: !1 };
function d6(e) {
  e.stopImmediatePropagation();
}
function BO(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function c1e(e) {
  var t = e.document.documentElement, n = Kl(e).on("dragstart.drag", BO, MT);
  "onselectstart" in t ? n.on("selectstart.drag", BO, MT) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function u1e(e, t) {
  var n = e.document.documentElement, r = Kl(e).on("dragstart.drag", null);
  t && (r.on("click.drag", BO, MT), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const CP = (e) => () => e;
function CB(e, {
  sourceEvent: t,
  subject: n,
  target: r,
  identifier: i,
  active: o,
  x: s,
  y: l,
  dx: c,
  dy: a,
  dispatch: u
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: o, enumerable: !0, configurable: !0 },
    x: { value: s, enumerable: !0, configurable: !0 },
    y: { value: l, enumerable: !0, configurable: !0 },
    dx: { value: c, enumerable: !0, configurable: !0 },
    dy: { value: a, enumerable: !0, configurable: !0 },
    _: { value: u }
  });
}
CB.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function Tft(e) {
  return !e.ctrlKey && !e.button;
}
function kft() {
  return this.parentNode;
}
function Cft(e, t) {
  return t ?? { x: e.x, y: e.y };
}
function Nft() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function d1e() {
  var e = Tft, t = kft, n = Cft, r = Nft, i = {}, o = Dz("start", "drag", "end"), s = 0, l, c, a, u, f = 0;
  function d(O) {
    O.on("mousedown.drag", p).filter(r).on("touchstart.drag", v).on("touchmove.drag", b, Eft).on("touchend.drag touchcancel.drag", A).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function p(O, x) {
    if (!(u || !e.call(this, O, x))) {
      var S = w(this, t.call(this, O, x), O, x, "mouse");
      S && (Kl(O.view).on("mousemove.drag", h, MT).on("mouseup.drag", m, MT), c1e(O.view), d6(O), a = !1, l = O.clientX, c = O.clientY, S("start", O));
    }
  }
  function h(O) {
    if (BO(O), !a) {
      var x = O.clientX - l, S = O.clientY - c;
      a = x * x + S * S > f;
    }
    i.mouse("drag", O);
  }
  function m(O) {
    Kl(O.view).on("mousemove.drag mouseup.drag", null), u1e(O.view, a), BO(O), i.mouse("end", O);
  }
  function v(O, x) {
    if (e.call(this, O, x)) {
      var S = O.changedTouches, E = t.call(this, O, x), k = S.length, T, R;
      for (T = 0; T < k; ++T)
        (R = w(this, E, O, x, S[T].identifier, S[T])) && (d6(O), R("start", O, S[T]));
    }
  }
  function b(O) {
    var x = O.changedTouches, S = x.length, E, k;
    for (E = 0; E < S; ++E)
      (k = i[x[E].identifier]) && (BO(O), k("drag", O, x[E]));
  }
  function A(O) {
    var x = O.changedTouches, S = x.length, E, k;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), E = 0; E < S; ++E)
      (k = i[x[E].identifier]) && (d6(O), k("end", O, x[E]));
  }
  function w(O, x, S, E, k, T) {
    var R = o.copy(), j = Iu(T || S, x), F, L, _;
    if ((_ = n.call(O, new CB("beforestart", {
      sourceEvent: S,
      target: d,
      identifier: k,
      active: s,
      x: j[0],
      y: j[1],
      dx: 0,
      dy: 0,
      dispatch: R
    }), E)) != null)
      return F = _.x - j[0] || 0, L = _.y - j[1] || 0, function U(z, C, I) {
        var M = j, D;
        switch (z) {
          case "start":
            i[k] = U, D = s++;
            break;
          case "end":
            delete i[k], --s;
          // falls through
          case "drag":
            j = Iu(I || C, x), D = s;
            break;
        }
        R.call(
          z,
          O,
          new CB(z, {
            sourceEvent: C,
            subject: _,
            target: d,
            identifier: k,
            active: D,
            x: j[0] + F,
            y: j[1] + L,
            dx: j[0] - M[0],
            dy: j[1] - M[1],
            dispatch: R
          }),
          E
        );
      };
  }
  return d.filter = function(O) {
    return arguments.length ? (e = typeof O == "function" ? O : CP(!!O), d) : e;
  }, d.container = function(O) {
    return arguments.length ? (t = typeof O == "function" ? O : CP(O), d) : t;
  }, d.subject = function(O) {
    return arguments.length ? (n = typeof O == "function" ? O : CP(O), d) : n;
  }, d.touchable = function(O) {
    return arguments.length ? (r = typeof O == "function" ? O : CP(!!O), d) : r;
  }, d.on = function() {
    var O = o.on.apply(o, arguments);
    return O === o ? d : O;
  }, d.clickDistance = function(O) {
    return arguments.length ? (f = (O = +O) * O, d) : Math.sqrt(f);
  }, d;
}
function PQ(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function f1e(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function nN() {
}
var DT = 0.7, fD = 1 / DT, XO = "\\s*([+-]?\\d+)\\s*", _T = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", gf = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Pft = /^#([0-9a-f]{3,8})$/, Ift = new RegExp(`^rgb\\(${XO},${XO},${XO}\\)$`), Rft = new RegExp(`^rgb\\(${gf},${gf},${gf}\\)$`), Mft = new RegExp(`^rgba\\(${XO},${XO},${XO},${_T}\\)$`), Dft = new RegExp(`^rgba\\(${gf},${gf},${gf},${_T}\\)$`), _ft = new RegExp(`^hsl\\(${_T},${gf},${gf}\\)$`), Lft = new RegExp(`^hsla\\(${_T},${gf},${gf},${_T}\\)$`), kie = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
PQ(nN, LT, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Cie,
  // Deprecated! Use color.formatHex.
  formatHex: Cie,
  formatHex8: zft,
  formatHsl: jft,
  formatRgb: Nie,
  toString: Nie
});
function Cie() {
  return this.rgb().formatHex();
}
function zft() {
  return this.rgb().formatHex8();
}
function jft() {
  return p1e(this).formatHsl();
}
function Nie() {
  return this.rgb().formatRgb();
}
function LT(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Pft.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Pie(t) : n === 3 ? new al(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? NP(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? NP(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Ift.exec(e)) ? new al(t[1], t[2], t[3], 1) : (t = Rft.exec(e)) ? new al(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Mft.exec(e)) ? NP(t[1], t[2], t[3], t[4]) : (t = Dft.exec(e)) ? NP(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = _ft.exec(e)) ? Mie(t[1], t[2] / 100, t[3] / 100, 1) : (t = Lft.exec(e)) ? Mie(t[1], t[2] / 100, t[3] / 100, t[4]) : kie.hasOwnProperty(e) ? Pie(kie[e]) : e === "transparent" ? new al(NaN, NaN, NaN, 0) : null;
}
function Pie(e) {
  return new al(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function NP(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new al(e, t, n, r);
}
function Fft(e) {
  return e instanceof nN || (e = LT(e)), e ? (e = e.rgb(), new al(e.r, e.g, e.b, e.opacity)) : new al();
}
function NB(e, t, n, r) {
  return arguments.length === 1 ? Fft(e) : new al(e, t, n, r ?? 1);
}
function al(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
PQ(al, NB, f1e(nN, {
  brighter(e) {
    return e = e == null ? fD : Math.pow(fD, e), new al(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? DT : Math.pow(DT, e), new al(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new al(av(this.r), av(this.g), av(this.b), pD(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Iie,
  // Deprecated! Use color.formatHex.
  formatHex: Iie,
  formatHex8: Uft,
  formatRgb: Rie,
  toString: Rie
}));
function Iie() {
  return `#${Ey(this.r)}${Ey(this.g)}${Ey(this.b)}`;
}
function Uft() {
  return `#${Ey(this.r)}${Ey(this.g)}${Ey(this.b)}${Ey((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Rie() {
  const e = pD(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${av(this.r)}, ${av(this.g)}, ${av(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function pD(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function av(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ey(e) {
  return e = av(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Mie(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Lu(e, t, n, r);
}
function p1e(e) {
  if (e instanceof Lu) return new Lu(e.h, e.s, e.l, e.opacity);
  if (e instanceof nN || (e = LT(e)), !e) return new Lu();
  if (e instanceof Lu) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), s = NaN, l = o - i, c = (o + i) / 2;
  return l ? (t === o ? s = (n - r) / l + (n < r) * 6 : n === o ? s = (r - t) / l + 2 : s = (t - n) / l + 4, l /= c < 0.5 ? o + i : 2 - o - i, s *= 60) : l = c > 0 && c < 1 ? 0 : s, new Lu(s, l, c, e.opacity);
}
function Vft(e, t, n, r) {
  return arguments.length === 1 ? p1e(e) : new Lu(e, t, n, r ?? 1);
}
function Lu(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
PQ(Lu, Vft, f1e(nN, {
  brighter(e) {
    return e = e == null ? fD : Math.pow(fD, e), new Lu(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? DT : Math.pow(DT, e), new Lu(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new al(
      f6(e >= 240 ? e - 240 : e + 120, i, r),
      f6(e, i, r),
      f6(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Lu(Die(this.h), PP(this.s), PP(this.l), pD(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = pD(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Die(this.h)}, ${PP(this.s) * 100}%, ${PP(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Die(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function PP(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function f6(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const h1e = (e) => () => e;
function qft(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Bft(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Xft(e) {
  return (e = +e) == 1 ? m1e : function(t, n) {
    return n - t ? Bft(t, n, e) : h1e(isNaN(t) ? n : t);
  };
}
function m1e(e, t) {
  var n = t - e;
  return n ? qft(e, n) : h1e(isNaN(e) ? t : e);
}
const _ie = function e(t) {
  var n = Xft(t);
  function r(i, o) {
    var s = n((i = NB(i)).r, (o = NB(o)).r), l = n(i.g, o.g), c = n(i.b, o.b), a = m1e(i.opacity, o.opacity);
    return function(u) {
      return i.r = s(u), i.g = l(u), i.b = c(u), i.opacity = a(u), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function $h(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
var PB = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, p6 = new RegExp(PB.source, "g");
function Wft(e) {
  return function() {
    return e;
  };
}
function Zft(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Hft(e, t) {
  var n = PB.lastIndex = p6.lastIndex = 0, r, i, o, s = -1, l = [], c = [];
  for (e = e + "", t = t + ""; (r = PB.exec(e)) && (i = p6.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), l[s] ? l[s] += o : l[++s] = o), (r = r[0]) === (i = i[0]) ? l[s] ? l[s] += i : l[++s] = i : (l[++s] = null, c.push({ i: s, x: $h(r, i) })), n = p6.lastIndex;
  return n < t.length && (o = t.slice(n), l[s] ? l[s] += o : l[++s] = o), l.length < 2 ? c[0] ? Zft(c[0].x) : Wft(t) : (t = c.length, function(a) {
    for (var u = 0, f; u < t; ++u) l[(f = c[u]).i] = f.x(a);
    return l.join("");
  });
}
var Lie = 180 / Math.PI, IB = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function g1e(e, t, n, r, i, o) {
  var s, l, c;
  return (s = Math.sqrt(e * e + t * t)) && (e /= s, t /= s), (c = e * n + t * r) && (n -= e * c, r -= t * c), (l = Math.sqrt(n * n + r * r)) && (n /= l, r /= l, c /= l), e * r < t * n && (e = -e, t = -t, c = -c, s = -s), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(t, e) * Lie,
    skewX: Math.atan(c) * Lie,
    scaleX: s,
    scaleY: l
  };
}
var IP;
function Qft(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? IB : g1e(t.a, t.b, t.c, t.d, t.e, t.f);
}
function $ft(e) {
  return e == null || (IP || (IP = document.createElementNS("http://www.w3.org/2000/svg", "g")), IP.setAttribute("transform", e), !(e = IP.transform.baseVal.consolidate())) ? IB : (e = e.matrix, g1e(e.a, e.b, e.c, e.d, e.e, e.f));
}
function y1e(e, t, n, r) {
  function i(a) {
    return a.length ? a.pop() + " " : "";
  }
  function o(a, u, f, d, p, h) {
    if (a !== f || u !== d) {
      var m = p.push("translate(", null, t, null, n);
      h.push({ i: m - 4, x: $h(a, f) }, { i: m - 2, x: $h(u, d) });
    } else (f || d) && p.push("translate(" + f + t + d + n);
  }
  function s(a, u, f, d) {
    a !== u ? (a - u > 180 ? u += 360 : u - a > 180 && (a += 360), d.push({ i: f.push(i(f) + "rotate(", null, r) - 2, x: $h(a, u) })) : u && f.push(i(f) + "rotate(" + u + r);
  }
  function l(a, u, f, d) {
    a !== u ? d.push({ i: f.push(i(f) + "skewX(", null, r) - 2, x: $h(a, u) }) : u && f.push(i(f) + "skewX(" + u + r);
  }
  function c(a, u, f, d, p, h) {
    if (a !== f || u !== d) {
      var m = p.push(i(p) + "scale(", null, ",", null, ")");
      h.push({ i: m - 4, x: $h(a, f) }, { i: m - 2, x: $h(u, d) });
    } else (f !== 1 || d !== 1) && p.push(i(p) + "scale(" + f + "," + d + ")");
  }
  return function(a, u) {
    var f = [], d = [];
    return a = e(a), u = e(u), o(a.translateX, a.translateY, u.translateX, u.translateY, f, d), s(a.rotate, u.rotate, f, d), l(a.skewX, u.skewX, f, d), c(a.scaleX, a.scaleY, u.scaleX, u.scaleY, f, d), a = u = null, function(p) {
      for (var h = -1, m = d.length, v; ++h < m; ) f[(v = d[h]).i] = v.x(p);
      return f.join("");
    };
  };
}
var Kft = y1e(Qft, "px, ", "px)", "deg)"), Gft = y1e($ft, ", ", ")", ")"), Yft = 1e-12;
function zie(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function Jft(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function ept(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const tpt = function e(t, n, r) {
  function i(o, s) {
    var l = o[0], c = o[1], a = o[2], u = s[0], f = s[1], d = s[2], p = u - l, h = f - c, m = p * p + h * h, v, b;
    if (m < Yft)
      b = Math.log(d / a) / t, v = function(E) {
        return [
          l + E * p,
          c + E * h,
          a * Math.exp(t * E * b)
        ];
      };
    else {
      var A = Math.sqrt(m), w = (d * d - a * a + r * m) / (2 * a * n * A), O = (d * d - a * a - r * m) / (2 * d * n * A), x = Math.log(Math.sqrt(w * w + 1) - w), S = Math.log(Math.sqrt(O * O + 1) - O);
      b = (S - x) / t, v = function(E) {
        var k = E * b, T = zie(x), R = a / (n * A) * (T * ept(t * k + x) - Jft(x));
        return [
          l + R * p,
          c + R * h,
          a * T / zie(t * k + x)
        ];
      };
    }
    return v.duration = b * 1e3 * t / Math.SQRT2, v;
  }
  return i.rho = function(o) {
    var s = Math.max(1e-3, +o), l = s * s, c = l * l;
    return e(s, l, c);
  }, i;
}(Math.SQRT2, 2, 4);
var ew = 0, JS = 0, nS = 0, v1e = 1e3, hD, e1, mD = 0, Rv = 0, Lz = 0, zT = typeof performance == "object" && performance.now ? performance : Date, b1e = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function IQ() {
  return Rv || (b1e(npt), Rv = zT.now() + Lz);
}
function npt() {
  Rv = 0;
}
function gD() {
  this._call = this._time = this._next = null;
}
gD.prototype = O1e.prototype = {
  constructor: gD,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? IQ() : +n) + (t == null ? 0 : +t), !this._next && e1 !== this && (e1 ? e1._next = this : hD = this, e1 = this), this._call = e, this._time = n, RB();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, RB());
  }
};
function O1e(e, t, n) {
  var r = new gD();
  return r.restart(e, t, n), r;
}
function rpt() {
  IQ(), ++ew;
  for (var e = hD, t; e; )
    (t = Rv - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --ew;
}
function jie() {
  Rv = (mD = zT.now()) + Lz, ew = JS = 0;
  try {
    rpt();
  } finally {
    ew = 0, opt(), Rv = 0;
  }
}
function ipt() {
  var e = zT.now(), t = e - mD;
  t > v1e && (Lz -= t, mD = e);
}
function opt() {
  for (var e, t = hD, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : hD = n);
  e1 = e, RB(r);
}
function RB(e) {
  if (!ew) {
    JS && (JS = clearTimeout(JS));
    var t = e - Rv;
    t > 24 ? (e < 1 / 0 && (JS = setTimeout(jie, e - zT.now() - Lz)), nS && (nS = clearInterval(nS))) : (nS || (mD = zT.now(), nS = setInterval(ipt, v1e)), ew = 1, b1e(jie));
  }
}
function Fie(e, t, n) {
  var r = new gD();
  return t = t == null ? 0 : +t, r.restart((i) => {
    r.stop(), e(i + t);
  }, t, n), r;
}
var spt = Dz("start", "end", "cancel", "interrupt"), apt = [], A1e = 0, Uie = 1, MB = 2, UR = 3, Vie = 4, DB = 5, VR = 6;
function zz(e, t, n, r, i, o) {
  var s = e.__transition;
  if (!s) e.__transition = {};
  else if (n in s) return;
  lpt(e, n, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: spt,
    tween: apt,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: A1e
  });
}
function RQ(e, t) {
  var n = gd(e, t);
  if (n.state > A1e) throw new Error("too late; already scheduled");
  return n;
}
function Lf(e, t) {
  var n = gd(e, t);
  if (n.state > UR) throw new Error("too late; already running");
  return n;
}
function gd(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function lpt(e, t, n) {
  var r = e.__transition, i;
  r[t] = n, n.timer = O1e(o, 0, n.time);
  function o(a) {
    n.state = Uie, n.timer.restart(s, n.delay, n.time), n.delay <= a && s(a - n.delay);
  }
  function s(a) {
    var u, f, d, p;
    if (n.state !== Uie) return c();
    for (u in r)
      if (p = r[u], p.name === n.name) {
        if (p.state === UR) return Fie(s);
        p.state === Vie ? (p.state = VR, p.timer.stop(), p.on.call("interrupt", e, e.__data__, p.index, p.group), delete r[u]) : +u < t && (p.state = VR, p.timer.stop(), p.on.call("cancel", e, e.__data__, p.index, p.group), delete r[u]);
      }
    if (Fie(function() {
      n.state === UR && (n.state = Vie, n.timer.restart(l, n.delay, n.time), l(a));
    }), n.state = MB, n.on.call("start", e, e.__data__, n.index, n.group), n.state === MB) {
      for (n.state = UR, i = new Array(d = n.tween.length), u = 0, f = -1; u < d; ++u)
        (p = n.tween[u].value.call(e, e.__data__, n.index, n.group)) && (i[++f] = p);
      i.length = f + 1;
    }
  }
  function l(a) {
    for (var u = a < n.duration ? n.ease.call(null, a / n.duration) : (n.timer.restart(c), n.state = DB, 1), f = -1, d = i.length; ++f < d; )
      i[f].call(e, u);
    n.state === DB && (n.on.call("end", e, e.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = VR, n.timer.stop(), delete r[t];
    for (var a in r) return;
    delete e.__transition;
  }
}
function qR(e, t) {
  var n = e.__transition, r, i, o = !0, s;
  if (n) {
    t = t == null ? null : t + "";
    for (s in n) {
      if ((r = n[s]).name !== t) {
        o = !1;
        continue;
      }
      i = r.state > MB && r.state < DB, r.state = VR, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete n[s];
    }
    o && delete e.__transition;
  }
}
function cpt(e) {
  return this.each(function() {
    qR(this, e);
  });
}
function upt(e, t) {
  var n, r;
  return function() {
    var i = Lf(this, e), o = i.tween;
    if (o !== n) {
      r = n = o;
      for (var s = 0, l = r.length; s < l; ++s)
        if (r[s].name === t) {
          r = r.slice(), r.splice(s, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function dpt(e, t, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var o = Lf(this, e), s = o.tween;
    if (s !== r) {
      i = (r = s).slice();
      for (var l = { name: t, value: n }, c = 0, a = i.length; c < a; ++c)
        if (i[c].name === t) {
          i[c] = l;
          break;
        }
      c === a && i.push(l);
    }
    o.tween = i;
  };
}
function fpt(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var r = gd(this.node(), n).tween, i = 0, o = r.length, s; i < o; ++i)
      if ((s = r[i]).name === e)
        return s.value;
    return null;
  }
  return this.each((t == null ? upt : dpt)(n, e, t));
}
function MQ(e, t, n) {
  var r = e._id;
  return e.each(function() {
    var i = Lf(this, r);
    (i.value || (i.value = {}))[t] = n.apply(this, arguments);
  }), function(i) {
    return gd(i, r).value[t];
  };
}
function w1e(e, t) {
  var n;
  return (typeof t == "number" ? $h : t instanceof LT ? _ie : (n = LT(t)) ? (t = n, _ie) : Hft)(e, t);
}
function ppt(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function hpt(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function mpt(e, t, n) {
  var r, i = n + "", o;
  return function() {
    var s = this.getAttribute(e);
    return s === i ? null : s === r ? o : o = t(r = s, n);
  };
}
function gpt(e, t, n) {
  var r, i = n + "", o;
  return function() {
    var s = this.getAttributeNS(e.space, e.local);
    return s === i ? null : s === r ? o : o = t(r = s, n);
  };
}
function ypt(e, t, n) {
  var r, i, o;
  return function() {
    var s, l = n(this), c;
    return l == null ? void this.removeAttribute(e) : (s = this.getAttribute(e), c = l + "", s === c ? null : s === r && c === i ? o : (i = c, o = t(r = s, l)));
  };
}
function vpt(e, t, n) {
  var r, i, o;
  return function() {
    var s, l = n(this), c;
    return l == null ? void this.removeAttributeNS(e.space, e.local) : (s = this.getAttributeNS(e.space, e.local), c = l + "", s === c ? null : s === r && c === i ? o : (i = c, o = t(r = s, l)));
  };
}
function bpt(e, t) {
  var n = _z(e), r = n === "transform" ? Gft : w1e;
  return this.attrTween(e, typeof t == "function" ? (n.local ? vpt : ypt)(n, r, MQ(this, "attr." + e, t)) : t == null ? (n.local ? hpt : ppt)(n) : (n.local ? gpt : mpt)(n, r, t));
}
function Opt(e, t) {
  return function(n) {
    this.setAttribute(e, t.call(this, n));
  };
}
function Apt(e, t) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, t.call(this, n));
  };
}
function wpt(e, t) {
  var n, r;
  function i() {
    var o = t.apply(this, arguments);
    return o !== r && (n = (r = o) && Apt(e, o)), n;
  }
  return i._value = t, i;
}
function xpt(e, t) {
  var n, r;
  function i() {
    var o = t.apply(this, arguments);
    return o !== r && (n = (r = o) && Opt(e, o)), n;
  }
  return i._value = t, i;
}
function Spt(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var r = _z(e);
  return this.tween(n, (r.local ? wpt : xpt)(r, t));
}
function Ept(e, t) {
  return function() {
    RQ(this, e).delay = +t.apply(this, arguments);
  };
}
function Tpt(e, t) {
  return t = +t, function() {
    RQ(this, e).delay = t;
  };
}
function kpt(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Ept : Tpt)(t, e)) : gd(this.node(), t).delay;
}
function Cpt(e, t) {
  return function() {
    Lf(this, e).duration = +t.apply(this, arguments);
  };
}
function Npt(e, t) {
  return t = +t, function() {
    Lf(this, e).duration = t;
  };
}
function Ppt(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? Cpt : Npt)(t, e)) : gd(this.node(), t).duration;
}
function Ipt(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Lf(this, e).ease = t;
  };
}
function Rpt(e) {
  var t = this._id;
  return arguments.length ? this.each(Ipt(t, e)) : gd(this.node(), t).ease;
}
function Mpt(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Lf(this, e).ease = n;
  };
}
function Dpt(e) {
  if (typeof e != "function") throw new Error();
  return this.each(Mpt(this._id, e));
}
function _pt(e) {
  typeof e != "function" && (e = JSe(e));
  for (var t = this._groups, n = t.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = t[i], s = o.length, l = r[i] = [], c, a = 0; a < s; ++a)
      (c = o[a]) && e.call(c, c.__data__, a, o) && l.push(c);
  return new dh(r, this._parents, this._name, this._id);
}
function Lpt(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, r = t.length, i = n.length, o = Math.min(r, i), s = new Array(r), l = 0; l < o; ++l)
    for (var c = t[l], a = n[l], u = c.length, f = s[l] = new Array(u), d, p = 0; p < u; ++p)
      (d = c[p] || a[p]) && (f[p] = d);
  for (; l < r; ++l)
    s[l] = t[l];
  return new dh(s, this._parents, this._name, this._id);
}
function zpt(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function jpt(e, t, n) {
  var r, i, o = zpt(t) ? RQ : Lf;
  return function() {
    var s = o(this, e), l = s.on;
    l !== r && (i = (r = l).copy()).on(t, n), s.on = i;
  };
}
function Fpt(e, t) {
  var n = this._id;
  return arguments.length < 2 ? gd(this.node(), n).on.on(e) : this.each(jpt(n, e, t));
}
function Upt(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function Vpt() {
  return this.on("end.remove", Upt(this._id));
}
function qpt(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = CQ(e));
  for (var r = this._groups, i = r.length, o = new Array(i), s = 0; s < i; ++s)
    for (var l = r[s], c = l.length, a = o[s] = new Array(c), u, f, d = 0; d < c; ++d)
      (u = l[d]) && (f = e.call(u, u.__data__, d, l)) && ("__data__" in u && (f.__data__ = u.__data__), a[d] = f, zz(a[d], t, n, d, a, gd(u, n)));
  return new dh(o, this._parents, t, n);
}
function Bpt(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = YSe(e));
  for (var r = this._groups, i = r.length, o = [], s = [], l = 0; l < i; ++l)
    for (var c = r[l], a = c.length, u, f = 0; f < a; ++f)
      if (u = c[f]) {
        for (var d = e.call(u, u.__data__, f, c), p, h = gd(u, n), m = 0, v = d.length; m < v; ++m)
          (p = d[m]) && zz(p, t, n, m, d, h);
        o.push(d), s.push(u);
      }
  return new dh(o, s, t, n);
}
var Xpt = tN.prototype.constructor;
function Wpt() {
  return new Xpt(this._groups, this._parents);
}
function Zpt(e, t) {
  var n, r, i;
  return function() {
    var o = JA(this, e), s = (this.style.removeProperty(e), JA(this, e));
    return o === s ? null : o === n && s === r ? i : i = t(n = o, r = s);
  };
}
function x1e(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Hpt(e, t, n) {
  var r, i = n + "", o;
  return function() {
    var s = JA(this, e);
    return s === i ? null : s === r ? o : o = t(r = s, n);
  };
}
function Qpt(e, t, n) {
  var r, i, o;
  return function() {
    var s = JA(this, e), l = n(this), c = l + "";
    return l == null && (c = l = (this.style.removeProperty(e), JA(this, e))), s === c ? null : s === r && c === i ? o : (i = c, o = t(r = s, l));
  };
}
function $pt(e, t) {
  var n, r, i, o = "style." + t, s = "end." + o, l;
  return function() {
    var c = Lf(this, e), a = c.on, u = c.value[o] == null ? l || (l = x1e(t)) : void 0;
    (a !== n || i !== u) && (r = (n = a).copy()).on(s, i = u), c.on = r;
  };
}
function Kpt(e, t, n) {
  var r = (e += "") == "transform" ? Kft : w1e;
  return t == null ? this.styleTween(e, Zpt(e, r)).on("end.style." + e, x1e(e)) : typeof t == "function" ? this.styleTween(e, Qpt(e, r, MQ(this, "style." + e, t))).each($pt(this._id, e)) : this.styleTween(e, Hpt(e, r, t), n).on("end.style." + e, null);
}
function Gpt(e, t, n) {
  return function(r) {
    this.style.setProperty(e, t.call(this, r), n);
  };
}
function Ypt(e, t, n) {
  var r, i;
  function o() {
    var s = t.apply(this, arguments);
    return s !== i && (r = (i = s) && Gpt(e, s, n)), r;
  }
  return o._value = t, o;
}
function Jpt(e, t, n) {
  var r = "style." + (e += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, Ypt(e, t, n ?? ""));
}
function eht(e) {
  return function() {
    this.textContent = e;
  };
}
function tht(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function nht(e) {
  return this.tween("text", typeof e == "function" ? tht(MQ(this, "text", e)) : eht(e == null ? "" : e + ""));
}
function rht(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function iht(e) {
  var t, n;
  function r() {
    var i = e.apply(this, arguments);
    return i !== n && (t = (n = i) && rht(i)), t;
  }
  return r._value = e, r;
}
function oht(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, iht(e));
}
function sht() {
  for (var e = this._name, t = this._id, n = S1e(), r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var s = r[o], l = s.length, c, a = 0; a < l; ++a)
      if (c = s[a]) {
        var u = gd(c, t);
        zz(c, e, n, a, s, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new dh(r, this._parents, e, n);
}
function aht() {
  var e, t, n = this, r = n._id, i = n.size();
  return new Promise(function(o, s) {
    var l = { value: s }, c = { value: function() {
      --i === 0 && o();
    } };
    n.each(function() {
      var a = Lf(this, r), u = a.on;
      u !== e && (t = (e = u).copy(), t._.cancel.push(l), t._.interrupt.push(l), t._.end.push(c)), a.on = t;
    }), i === 0 && o();
  });
}
var lht = 0;
function dh(e, t, n, r) {
  this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function S1e() {
  return ++lht;
}
var Gf = tN.prototype;
dh.prototype = {
  constructor: dh,
  select: qpt,
  selectAll: Bpt,
  selectChild: Gf.selectChild,
  selectChildren: Gf.selectChildren,
  filter: _pt,
  merge: Lpt,
  selection: Wpt,
  transition: sht,
  call: Gf.call,
  nodes: Gf.nodes,
  node: Gf.node,
  size: Gf.size,
  empty: Gf.empty,
  each: Gf.each,
  on: Fpt,
  attr: bpt,
  attrTween: Spt,
  style: Kpt,
  styleTween: Jpt,
  text: nht,
  textTween: oht,
  remove: Vpt,
  tween: fpt,
  delay: kpt,
  duration: Ppt,
  ease: Rpt,
  easeVarying: Dpt,
  end: aht,
  [Symbol.iterator]: Gf[Symbol.iterator]
};
function cht(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var uht = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cht
};
function dht(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return n;
}
function fht(e) {
  var t, n;
  e instanceof dh ? (t = e._id, e = e._name) : (t = S1e(), (n = uht).time = IQ(), e = e == null ? null : e + "");
  for (var r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var s = r[o], l = s.length, c, a = 0; a < l; ++a)
      (c = s[a]) && zz(c, e, t, a, s, n || dht(c, t));
  return new dh(r, this._parents, e, t);
}
tN.prototype.interrupt = cpt;
tN.prototype.transition = fht;
const RP = (e) => () => e;
function pht(e, {
  sourceEvent: t,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function qp(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
qp.prototype = {
  constructor: qp,
  scale: function(e) {
    return e === 1 ? this : new qp(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new qp(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var jz = new qp(1, 0, 0);
E1e.prototype = qp.prototype;
function E1e(e) {
  for (; !e.__zoom; ) if (!(e = e.parentNode)) return jz;
  return e.__zoom;
}
function h6(e) {
  e.stopImmediatePropagation();
}
function rS(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function hht(e) {
  return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function mht() {
  var e = this;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [[e.x, e.y], [e.x + e.width, e.y + e.height]]) : [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]]) : [[0, 0], [e.clientWidth, e.clientHeight]];
}
function qie() {
  return this.__zoom || jz;
}
function ght(e) {
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * (e.ctrlKey ? 10 : 1);
}
function yht() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function vht(e, t, n) {
  var r = e.invertX(t[0][0]) - n[0][0], i = e.invertX(t[1][0]) - n[1][0], o = e.invertY(t[0][1]) - n[0][1], s = e.invertY(t[1][1]) - n[1][1];
  return e.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    s > o ? (o + s) / 2 : Math.min(0, o) || Math.max(0, s)
  );
}
function T1e() {
  var e = hht, t = mht, n = vht, r = ght, i = yht, o = [0, 1 / 0], s = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], l = 250, c = tpt, a = Dz("start", "zoom", "end"), u, f, d, p = 500, h = 150, m = 0, v = 10;
  function b(_) {
    _.property("__zoom", qie).on("wheel.zoom", k, { passive: !1 }).on("mousedown.zoom", T).on("dblclick.zoom", R).filter(i).on("touchstart.zoom", j).on("touchmove.zoom", F).on("touchend.zoom touchcancel.zoom", L).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  b.transform = function(_, U, z, C) {
    var I = _.selection ? _.selection() : _;
    I.property("__zoom", qie), _ !== I ? x(_, U, z, C) : I.interrupt().each(function() {
      S(this, arguments).event(C).start().zoom(null, typeof U == "function" ? U.apply(this, arguments) : U).end();
    });
  }, b.scaleBy = function(_, U, z, C) {
    b.scaleTo(_, function() {
      var I = this.__zoom.k, M = typeof U == "function" ? U.apply(this, arguments) : U;
      return I * M;
    }, z, C);
  }, b.scaleTo = function(_, U, z, C) {
    b.transform(_, function() {
      var I = t.apply(this, arguments), M = this.__zoom, D = z == null ? O(I) : typeof z == "function" ? z.apply(this, arguments) : z, X = M.invert(D), B = typeof U == "function" ? U.apply(this, arguments) : U;
      return n(w(A(M, B), D, X), I, s);
    }, z, C);
  }, b.translateBy = function(_, U, z, C) {
    b.transform(_, function() {
      return n(this.__zoom.translate(
        typeof U == "function" ? U.apply(this, arguments) : U,
        typeof z == "function" ? z.apply(this, arguments) : z
      ), t.apply(this, arguments), s);
    }, null, C);
  }, b.translateTo = function(_, U, z, C, I) {
    b.transform(_, function() {
      var M = t.apply(this, arguments), D = this.__zoom, X = C == null ? O(M) : typeof C == "function" ? C.apply(this, arguments) : C;
      return n(jz.translate(X[0], X[1]).scale(D.k).translate(
        typeof U == "function" ? -U.apply(this, arguments) : -U,
        typeof z == "function" ? -z.apply(this, arguments) : -z
      ), M, s);
    }, C, I);
  };
  function A(_, U) {
    return U = Math.max(o[0], Math.min(o[1], U)), U === _.k ? _ : new qp(U, _.x, _.y);
  }
  function w(_, U, z) {
    var C = U[0] - z[0] * _.k, I = U[1] - z[1] * _.k;
    return C === _.x && I === _.y ? _ : new qp(_.k, C, I);
  }
  function O(_) {
    return [(+_[0][0] + +_[1][0]) / 2, (+_[0][1] + +_[1][1]) / 2];
  }
  function x(_, U, z, C) {
    _.on("start.zoom", function() {
      S(this, arguments).event(C).start();
    }).on("interrupt.zoom end.zoom", function() {
      S(this, arguments).event(C).end();
    }).tween("zoom", function() {
      var I = this, M = arguments, D = S(I, M).event(C), X = t.apply(I, M), B = z == null ? O(X) : typeof z == "function" ? z.apply(I, M) : z, q = Math.max(X[1][0] - X[0][0], X[1][1] - X[0][1]), H = I.__zoom, Y = typeof U == "function" ? U.apply(I, M) : U, J = c(H.invert(B).concat(q / H.k), Y.invert(B).concat(q / Y.k));
      return function(oe) {
        if (oe === 1) oe = Y;
        else {
          var ce = J(oe), fe = q / ce[2];
          oe = new qp(fe, B[0] - ce[0] * fe, B[1] - ce[1] * fe);
        }
        D.zoom(null, oe);
      };
    });
  }
  function S(_, U, z) {
    return !z && _.__zooming || new E(_, U);
  }
  function E(_, U) {
    this.that = _, this.args = U, this.active = 0, this.sourceEvent = null, this.extent = t.apply(_, U), this.taps = 0;
  }
  E.prototype = {
    event: function(_) {
      return _ && (this.sourceEvent = _), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(_, U) {
      return this.mouse && _ !== "mouse" && (this.mouse[1] = U.invert(this.mouse[0])), this.touch0 && _ !== "touch" && (this.touch0[1] = U.invert(this.touch0[0])), this.touch1 && _ !== "touch" && (this.touch1[1] = U.invert(this.touch1[0])), this.that.__zoom = U, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(_) {
      var U = Kl(this.that).datum();
      a.call(
        _,
        this.that,
        new pht(_, {
          sourceEvent: this.sourceEvent,
          target: b,
          transform: this.that.__zoom,
          dispatch: a
        }),
        U
      );
    }
  };
  function k(_, ...U) {
    if (!e.apply(this, arguments)) return;
    var z = S(this, U).event(_), C = this.__zoom, I = Math.max(o[0], Math.min(o[1], C.k * Math.pow(2, r.apply(this, arguments)))), M = Iu(_);
    if (z.wheel)
      (z.mouse[0][0] !== M[0] || z.mouse[0][1] !== M[1]) && (z.mouse[1] = C.invert(z.mouse[0] = M)), clearTimeout(z.wheel);
    else {
      if (C.k === I) return;
      z.mouse = [M, C.invert(M)], qR(this), z.start();
    }
    rS(_), z.wheel = setTimeout(D, h), z.zoom("mouse", n(w(A(C, I), z.mouse[0], z.mouse[1]), z.extent, s));
    function D() {
      z.wheel = null, z.end();
    }
  }
  function T(_, ...U) {
    if (d || !e.apply(this, arguments)) return;
    var z = _.currentTarget, C = S(this, U, !0).event(_), I = Kl(_.view).on("mousemove.zoom", B, !0).on("mouseup.zoom", q, !0), M = Iu(_, z), D = _.clientX, X = _.clientY;
    c1e(_.view), h6(_), C.mouse = [M, this.__zoom.invert(M)], qR(this), C.start();
    function B(H) {
      if (rS(H), !C.moved) {
        var Y = H.clientX - D, J = H.clientY - X;
        C.moved = Y * Y + J * J > m;
      }
      C.event(H).zoom("mouse", n(w(C.that.__zoom, C.mouse[0] = Iu(H, z), C.mouse[1]), C.extent, s));
    }
    function q(H) {
      I.on("mousemove.zoom mouseup.zoom", null), u1e(H.view, C.moved), rS(H), C.event(H).end();
    }
  }
  function R(_, ...U) {
    if (e.apply(this, arguments)) {
      var z = this.__zoom, C = Iu(_.changedTouches ? _.changedTouches[0] : _, this), I = z.invert(C), M = z.k * (_.shiftKey ? 0.5 : 2), D = n(w(A(z, M), C, I), t.apply(this, U), s);
      rS(_), l > 0 ? Kl(this).transition().duration(l).call(x, D, C, _) : Kl(this).call(b.transform, D, C, _);
    }
  }
  function j(_, ...U) {
    if (e.apply(this, arguments)) {
      var z = _.touches, C = z.length, I = S(this, U, _.changedTouches.length === C).event(_), M, D, X, B;
      for (h6(_), D = 0; D < C; ++D)
        X = z[D], B = Iu(X, this), B = [B, this.__zoom.invert(B), X.identifier], I.touch0 ? !I.touch1 && I.touch0[2] !== B[2] && (I.touch1 = B, I.taps = 0) : (I.touch0 = B, M = !0, I.taps = 1 + !!u);
      u && (u = clearTimeout(u)), M && (I.taps < 2 && (f = B[0], u = setTimeout(function() {
        u = null;
      }, p)), qR(this), I.start());
    }
  }
  function F(_, ...U) {
    if (this.__zooming) {
      var z = S(this, U).event(_), C = _.changedTouches, I = C.length, M, D, X, B;
      for (rS(_), M = 0; M < I; ++M)
        D = C[M], X = Iu(D, this), z.touch0 && z.touch0[2] === D.identifier ? z.touch0[0] = X : z.touch1 && z.touch1[2] === D.identifier && (z.touch1[0] = X);
      if (D = z.that.__zoom, z.touch1) {
        var q = z.touch0[0], H = z.touch0[1], Y = z.touch1[0], J = z.touch1[1], oe = (oe = Y[0] - q[0]) * oe + (oe = Y[1] - q[1]) * oe, ce = (ce = J[0] - H[0]) * ce + (ce = J[1] - H[1]) * ce;
        D = A(D, Math.sqrt(oe / ce)), X = [(q[0] + Y[0]) / 2, (q[1] + Y[1]) / 2], B = [(H[0] + J[0]) / 2, (H[1] + J[1]) / 2];
      } else if (z.touch0) X = z.touch0[0], B = z.touch0[1];
      else return;
      z.zoom("touch", n(w(D, X, B), z.extent, s));
    }
  }
  function L(_, ...U) {
    if (this.__zooming) {
      var z = S(this, U).event(_), C = _.changedTouches, I = C.length, M, D;
      for (h6(_), d && clearTimeout(d), d = setTimeout(function() {
        d = null;
      }, p), M = 0; M < I; ++M)
        D = C[M], z.touch0 && z.touch0[2] === D.identifier ? delete z.touch0 : z.touch1 && z.touch1[2] === D.identifier && delete z.touch1;
      if (z.touch1 && !z.touch0 && (z.touch0 = z.touch1, delete z.touch1), z.touch0) z.touch0[1] = this.__zoom.invert(z.touch0[0]);
      else if (z.end(), z.taps === 2 && (D = Iu(D, this), Math.hypot(f[0] - D[0], f[1] - D[1]) < v)) {
        var X = Kl(this).on("dblclick.zoom");
        X && X.apply(this, arguments);
      }
    }
  }
  return b.wheelDelta = function(_) {
    return arguments.length ? (r = typeof _ == "function" ? _ : RP(+_), b) : r;
  }, b.filter = function(_) {
    return arguments.length ? (e = typeof _ == "function" ? _ : RP(!!_), b) : e;
  }, b.touchable = function(_) {
    return arguments.length ? (i = typeof _ == "function" ? _ : RP(!!_), b) : i;
  }, b.extent = function(_) {
    return arguments.length ? (t = typeof _ == "function" ? _ : RP([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), b) : t;
  }, b.scaleExtent = function(_) {
    return arguments.length ? (o[0] = +_[0], o[1] = +_[1], b) : [o[0], o[1]];
  }, b.translateExtent = function(_) {
    return arguments.length ? (s[0][0] = +_[0][0], s[1][0] = +_[1][0], s[0][1] = +_[0][1], s[1][1] = +_[1][1], b) : [[s[0][0], s[0][1]], [s[1][0], s[1][1]]];
  }, b.constrain = function(_) {
    return arguments.length ? (n = _, b) : n;
  }, b.duration = function(_) {
    return arguments.length ? (l = +_, b) : l;
  }, b.interpolate = function(_) {
    return arguments.length ? (c = _, b) : c;
  }, b.on = function() {
    var _ = a.on.apply(a, arguments);
    return _ === a ? b : _;
  }, b.clickDistance = function(_) {
    return arguments.length ? (m = (_ = +_) * _, b) : Math.sqrt(m);
  }, b.tapDistance = function(_) {
    return arguments.length ? (v = +_, b) : v;
  }, b;
}
const gu = {
  error001: () => "[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001",
  error002: () => "It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
  error003: (e) => `Node type "${e}" not found. Using fallback type "default".`,
  error004: () => "The React Flow parent container needs a width and a height to render the graph.",
  error005: () => "Only child nodes can use a parent extent.",
  error006: () => "Can't create edge. An edge needs a source and a target.",
  error007: (e) => `The old edge with id=${e} does not exist.`,
  error009: (e) => `Marker type "${e}" doesn't exist.`,
  error008: (e, { id: t, sourceHandle: n, targetHandle: r }) => `Couldn't create edge for ${e} handle id: "${e === "source" ? n : r}", edge id: ${t}.`,
  error010: () => "Handle: No node id found. Make sure to only use a Handle inside a custom Node.",
  error011: (e) => `Edge type "${e}" not found. Using fallback type "default".`,
  error012: (e) => `Node with id "${e}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`,
  error013: (e = "react") => `It seems that you haven't loaded the styles. Please import '@xyflow/${e}/dist/style.css' or base.css to make sure everything is working properly.`
}, jT = [
  [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
  [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
], k1e = ["Enter", " ", "Escape"];
var tw;
(function(e) {
  e.Strict = "strict", e.Loose = "loose";
})(tw || (tw = {}));
var Bm;
(function(e) {
  e.Free = "free", e.Vertical = "vertical", e.Horizontal = "horizontal";
})(Bm || (Bm = {}));
var nw;
(function(e) {
  e.Partial = "partial", e.Full = "full";
})(nw || (nw = {}));
const C1e = {
  inProgress: !1,
  isValid: null,
  from: null,
  fromHandle: null,
  fromPosition: null,
  fromNode: null,
  to: null,
  toHandle: null,
  toPosition: null,
  toNode: null
};
var lm;
(function(e) {
  e.Bezier = "default", e.Straight = "straight", e.Step = "step", e.SmoothStep = "smoothstep", e.SimpleBezier = "simplebezier";
})(lm || (lm = {}));
var yD;
(function(e) {
  e.Arrow = "arrow", e.ArrowClosed = "arrowclosed";
})(yD || (yD = {}));
var sn;
(function(e) {
  e.Left = "left", e.Top = "top", e.Right = "right", e.Bottom = "bottom";
})(sn || (sn = {}));
const Bie = {
  [sn.Left]: sn.Right,
  [sn.Right]: sn.Left,
  [sn.Top]: sn.Bottom,
  [sn.Bottom]: sn.Top
};
function N1e(e) {
  return e === null ? null : e ? "valid" : "invalid";
}
const P1e = (e) => "id" in e && "source" in e && "target" in e, bht = (e) => "id" in e && "position" in e && !("source" in e) && !("target" in e), DQ = (e) => "id" in e && "internals" in e && !("source" in e) && !("target" in e), rN = (e, t = [0, 0]) => {
  const { width: n, height: r } = Th(e), i = e.origin ?? t, o = n * i[0], s = r * i[1];
  return {
    x: e.position.x - o,
    y: e.position.y - s
  };
}, I1e = (e, t = { nodeOrigin: [0, 0], nodeLookup: void 0 }) => {
  if (process.env.NODE_ENV === "development" && !t.nodeLookup && console.warn("Please use `getNodesBounds` from `useReactFlow`/`useSvelteFlow` hook to ensure correct values for sub flows. If not possible, you have to provide a nodeLookup to support sub flows."), e.length === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  const n = e.reduce((r, i) => {
    const o = typeof i == "string";
    let s = !t.nodeLookup && !o ? i : void 0;
    t.nodeLookup && (s = o ? t.nodeLookup.get(i) : DQ(i) ? i : t.nodeLookup.get(i.id));
    const l = s ? vD(s, t.nodeOrigin) : { x: 0, y: 0, x2: 0, y2: 0 };
    return Fz(r, l);
  }, { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 });
  return Uz(n);
}, iN = (e, t = {}) => {
  if (e.size === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  let n = { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 };
  return e.forEach((r) => {
    if (t.filter === void 0 || t.filter(r)) {
      const i = vD(r);
      n = Fz(n, i);
    }
  }), Uz(n);
}, R1e = (e, t, [n, r, i] = [0, 0, 1], o = !1, s = !1) => {
  const l = {
    ...oN(t, [n, r, i]),
    width: t.width / i,
    height: t.height / i
  }, c = [];
  for (const a of e.values()) {
    const { measured: u, selectable: f = !0, hidden: d = !1 } = a;
    if (s && !f || d)
      continue;
    const p = u.width ?? a.width ?? a.initialWidth ?? null, h = u.height ?? a.height ?? a.initialHeight ?? null, m = FT(l, iw(a)), v = (p ?? 0) * (h ?? 0), b = o && m > 0;
    (!a.internals.handleBounds || b || m >= v || a.dragging) && c.push(a);
  }
  return c;
}, Oht = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    n.add(r.id);
  }), t.filter((r) => n.has(r.source) || n.has(r.target));
};
function _B(e, t) {
  const n = /* @__PURE__ */ new Map(), r = t != null && t.nodes ? new Set(t.nodes.map((i) => i.id)) : null;
  return e.forEach((i) => {
    i.measured.width && i.measured.height && ((t == null ? void 0 : t.includeHiddenNodes) || !i.hidden) && (!r || r.has(i.id)) && n.set(i.id, i);
  }), n;
}
async function LB({ nodes: e, width: t, height: n, panZoom: r, minZoom: i, maxZoom: o }, s) {
  if (e.size === 0)
    return Promise.resolve(!1);
  const l = iN(e), c = _Q(l, t, n, (s == null ? void 0 : s.minZoom) ?? i, (s == null ? void 0 : s.maxZoom) ?? o, (s == null ? void 0 : s.padding) ?? 0.1);
  return await r.setViewport(c, { duration: s == null ? void 0 : s.duration }), Promise.resolve(!0);
}
function M1e({ nodeId: e, nextPosition: t, nodeLookup: n, nodeOrigin: r = [0, 0], nodeExtent: i, onError: o }) {
  const s = n.get(e), l = s.parentId ? n.get(s.parentId) : void 0, { x: c, y: a } = l ? l.internals.positionAbsolute : { x: 0, y: 0 }, u = s.origin ?? r;
  let f = i;
  if (s.extent === "parent" && !s.expandParent)
    if (!l)
      o == null || o("005", gu.error005());
    else {
      const p = l.measured.width, h = l.measured.height;
      p && h && (f = [
        [c, a],
        [c + p, a + h]
      ]);
    }
  else l && ow(s.extent) && (f = [
    [s.extent[0][0] + c, s.extent[0][1] + a],
    [s.extent[1][0] + c, s.extent[1][1] + a]
  ]);
  const d = ow(f) ? Mv(t, f, s.measured) : t;
  return {
    position: {
      x: d.x - c + s.measured.width * u[0],
      y: d.y - a + s.measured.height * u[1]
    },
    positionAbsolute: d
  };
}
async function Aht({ nodesToRemove: e = [], edgesToRemove: t = [], nodes: n, edges: r, onBeforeDelete: i }) {
  const o = new Set(e.map((d) => d.id)), s = [];
  for (const d of n) {
    if (d.deletable === !1)
      continue;
    const p = o.has(d.id), h = !p && d.parentId && s.find((m) => m.id === d.parentId);
    (p || h) && s.push(d);
  }
  const l = new Set(t.map((d) => d.id)), c = r.filter((d) => d.deletable !== !1), u = Oht(s, c);
  for (const d of c)
    l.has(d.id) && !u.find((h) => h.id === d.id) && u.push(d);
  if (!i)
    return {
      edges: u,
      nodes: s
    };
  const f = await i({
    nodes: s,
    edges: u
  });
  return typeof f == "boolean" ? f ? { edges: u, nodes: s } : { edges: [], nodes: [] } : f;
}
const rw = (e, t = 0, n = 1) => Math.min(Math.max(e, t), n), Mv = (e = { x: 0, y: 0 }, t, n) => ({
  x: rw(e.x, t[0][0], t[1][0] - ((n == null ? void 0 : n.width) ?? 0)),
  y: rw(e.y, t[0][1], t[1][1] - ((n == null ? void 0 : n.height) ?? 0))
});
function D1e(e, t, n) {
  const { width: r, height: i } = Th(n), { x: o, y: s } = n.internals.positionAbsolute;
  return Mv(e, [
    [o, s],
    [o + r, s + i]
  ], t);
}
const Xie = (e, t, n) => e < t ? rw(Math.abs(e - t), 1, t) / t : e > n ? -rw(Math.abs(e - n), 1, t) / t : 0, _1e = (e, t, n = 15, r = 40) => {
  const i = Xie(e.x, r, t.width - r) * n, o = Xie(e.y, r, t.height - r) * n;
  return [i, o];
}, Fz = (e, t) => ({
  x: Math.min(e.x, t.x),
  y: Math.min(e.y, t.y),
  x2: Math.max(e.x2, t.x2),
  y2: Math.max(e.y2, t.y2)
}), zB = ({ x: e, y: t, width: n, height: r }) => ({
  x: e,
  y: t,
  x2: e + n,
  y2: t + r
}), Uz = ({ x: e, y: t, x2: n, y2: r }) => ({
  x: e,
  y: t,
  width: n - e,
  height: r - t
}), iw = (e, t = [0, 0]) => {
  var i, o;
  const { x: n, y: r } = DQ(e) ? e.internals.positionAbsolute : rN(e, t);
  return {
    x: n,
    y: r,
    width: ((i = e.measured) == null ? void 0 : i.width) ?? e.width ?? e.initialWidth ?? 0,
    height: ((o = e.measured) == null ? void 0 : o.height) ?? e.height ?? e.initialHeight ?? 0
  };
}, vD = (e, t = [0, 0]) => {
  var i, o;
  const { x: n, y: r } = DQ(e) ? e.internals.positionAbsolute : rN(e, t);
  return {
    x: n,
    y: r,
    x2: n + (((i = e.measured) == null ? void 0 : i.width) ?? e.width ?? e.initialWidth ?? 0),
    y2: r + (((o = e.measured) == null ? void 0 : o.height) ?? e.height ?? e.initialHeight ?? 0)
  };
}, L1e = (e, t) => Uz(Fz(zB(e), zB(t))), FT = (e, t) => {
  const n = Math.max(0, Math.min(e.x + e.width, t.x + t.width) - Math.max(e.x, t.x)), r = Math.max(0, Math.min(e.y + e.height, t.y + t.height) - Math.max(e.y, t.y));
  return Math.ceil(n * r);
}, Wie = (e) => Vu(e.width) && Vu(e.height) && Vu(e.x) && Vu(e.y), Vu = (e) => !isNaN(e) && isFinite(e), z1e = (e, t) => {
  process.env.NODE_ENV === "development" && console.warn(`[React Flow]: ${t} Help: https://reactflow.dev/error#${e}`);
}, Vz = (e, t = [1, 1]) => ({
  x: t[0] * Math.round(e.x / t[0]),
  y: t[1] * Math.round(e.y / t[1])
}), oN = ({ x: e, y: t }, [n, r, i], o = !1, s = [1, 1]) => {
  const l = {
    x: (e - n) / i,
    y: (t - r) / i
  };
  return o ? Vz(l, s) : l;
}, j1e = ({ x: e, y: t }, [n, r, i]) => ({
  x: e * i + n,
  y: t * i + r
}), _Q = (e, t, n, r, i, o) => {
  const s = t / (e.width * (1 + o)), l = n / (e.height * (1 + o)), c = Math.min(s, l), a = rw(c, r, i), u = e.x + e.width / 2, f = e.y + e.height / 2, d = t / 2 - u * a, p = n / 2 - f * a;
  return { x: d, y: p, zoom: a };
}, bD = () => {
  var e;
  return typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : e.indexOf("Mac")) >= 0;
};
function ow(e) {
  return e !== void 0 && e !== "parent";
}
function Th(e) {
  var t, n;
  return {
    width: ((t = e.measured) == null ? void 0 : t.width) ?? e.width ?? e.initialWidth ?? 0,
    height: ((n = e.measured) == null ? void 0 : n.height) ?? e.height ?? e.initialHeight ?? 0
  };
}
function F1e(e) {
  var t, n;
  return (((t = e.measured) == null ? void 0 : t.width) ?? e.width ?? e.initialWidth) !== void 0 && (((n = e.measured) == null ? void 0 : n.height) ?? e.height ?? e.initialHeight) !== void 0;
}
function U1e(e, t = { width: 0, height: 0 }, n, r, i) {
  const o = { ...e }, s = r.get(n);
  if (s) {
    const l = s.origin || i;
    o.x += s.internals.positionAbsolute.x - (t.width ?? 0) * l[0], o.y += s.internals.positionAbsolute.y - (t.height ?? 0) * l[1];
  }
  return o;
}
function OE(e, { snapGrid: t = [0, 0], snapToGrid: n = !1, transform: r, containerBounds: i }) {
  const { x: o, y: s } = Gp(e), l = oN({ x: o - ((i == null ? void 0 : i.left) ?? 0), y: s - ((i == null ? void 0 : i.top) ?? 0) }, r), { x: c, y: a } = n ? Vz(l, t) : l;
  return {
    xSnapped: c,
    ySnapped: a,
    ...l
  };
}
const qz = (e) => ({
  width: e.offsetWidth,
  height: e.offsetHeight
}), V1e = (e) => {
  var t;
  return ((t = e.getRootNode) == null ? void 0 : t.call(e)) || (window == null ? void 0 : window.document);
}, wht = ["INPUT", "SELECT", "TEXTAREA"];
function jB(e) {
  var r, i;
  const t = ((i = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : i[0]) || e.target;
  return wht.includes(t == null ? void 0 : t.nodeName) || (t == null ? void 0 : t.hasAttribute("contenteditable")) || !!(t != null && t.closest(".nokey"));
}
const q1e = (e) => "clientX" in e, Gp = (e, t) => {
  var o, s;
  const n = q1e(e), r = n ? e.clientX : (o = e.touches) == null ? void 0 : o[0].clientX, i = n ? e.clientY : (s = e.touches) == null ? void 0 : s[0].clientY;
  return {
    x: r - ((t == null ? void 0 : t.left) ?? 0),
    y: i - ((t == null ? void 0 : t.top) ?? 0)
  };
}, Zie = (e, t, n, r, i) => {
  const o = t.querySelectorAll(`.${e}`);
  return !o || !o.length ? null : Array.from(o).map((s) => {
    const l = s.getBoundingClientRect();
    return {
      id: s.getAttribute("data-handleid"),
      type: e,
      nodeId: i,
      position: s.getAttribute("data-handlepos"),
      x: (l.left - n.left) / r,
      y: (l.top - n.top) / r,
      ...qz(s)
    };
  });
};
function B1e({ sourceX: e, sourceY: t, targetX: n, targetY: r, sourceControlX: i, sourceControlY: o, targetControlX: s, targetControlY: l }) {
  const c = e * 0.125 + i * 0.375 + s * 0.375 + n * 0.125, a = t * 0.125 + o * 0.375 + l * 0.375 + r * 0.125, u = Math.abs(c - e), f = Math.abs(a - t);
  return [c, a, u, f];
}
function MP(e, t) {
  return e >= 0 ? 0.5 * e : t * 25 * Math.sqrt(-e);
}
function Hie({ pos: e, x1: t, y1: n, x2: r, y2: i, c: o }) {
  switch (e) {
    case sn.Left:
      return [t - MP(t - r, o), n];
    case sn.Right:
      return [t + MP(r - t, o), n];
    case sn.Top:
      return [t, n - MP(n - i, o)];
    case sn.Bottom:
      return [t, n + MP(i - n, o)];
  }
}
function X1e({ sourceX: e, sourceY: t, sourcePosition: n = sn.Bottom, targetX: r, targetY: i, targetPosition: o = sn.Top, curvature: s = 0.25 }) {
  const [l, c] = Hie({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: i,
    c: s
  }), [a, u] = Hie({
    pos: o,
    x1: r,
    y1: i,
    x2: e,
    y2: t,
    c: s
  }), [f, d, p, h] = B1e({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: i,
    sourceControlX: l,
    sourceControlY: c,
    targetControlX: a,
    targetControlY: u
  });
  return [
    `M${e},${t} C${l},${c} ${a},${u} ${r},${i}`,
    f,
    d,
    p,
    h
  ];
}
function W1e({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const i = Math.abs(n - e) / 2, o = n < e ? n + i : n - i, s = Math.abs(r - t) / 2, l = r < t ? r + s : r - s;
  return [o, l, i, s];
}
function xht({ sourceNode: e, targetNode: t, selected: n = !1, zIndex: r = 0, elevateOnSelect: i = !1 }) {
  if (!i)
    return r;
  const o = n || t.selected || e.selected, s = Math.max(e.internals.z || 0, t.internals.z || 0, 1e3);
  return r + (o ? s : 0);
}
function Sht({ sourceNode: e, targetNode: t, width: n, height: r, transform: i }) {
  const o = Fz(vD(e), vD(t));
  o.x === o.x2 && (o.x2 += 1), o.y === o.y2 && (o.y2 += 1);
  const s = {
    x: -i[0] / i[2],
    y: -i[1] / i[2],
    width: n / i[2],
    height: r / i[2]
  };
  return FT(s, Uz(o)) > 0;
}
const Eht = ({ source: e, sourceHandle: t, target: n, targetHandle: r }) => `xy-edge__${e}${t || ""}-${n}${r || ""}`, Tht = (e, t) => t.some((n) => n.source === e.source && n.target === e.target && (n.sourceHandle === e.sourceHandle || !n.sourceHandle && !e.sourceHandle) && (n.targetHandle === e.targetHandle || !n.targetHandle && !e.targetHandle)), kht = (e, t) => {
  if (!e.source || !e.target)
    return z1e("006", gu.error006()), t;
  let n;
  return P1e(e) ? n = { ...e } : n = {
    ...e,
    id: Eht(e)
  }, Tht(n, t) ? t : (n.sourceHandle === null && delete n.sourceHandle, n.targetHandle === null && delete n.targetHandle, t.concat(n));
};
function Z1e({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const [i, o, s, l] = W1e({
    sourceX: e,
    sourceY: t,
    targetX: n,
    targetY: r
  });
  return [`M ${e},${t}L ${n},${r}`, i, o, s, l];
}
const Qie = {
  [sn.Left]: { x: -1, y: 0 },
  [sn.Right]: { x: 1, y: 0 },
  [sn.Top]: { x: 0, y: -1 },
  [sn.Bottom]: { x: 0, y: 1 }
}, Cht = ({ source: e, sourcePosition: t = sn.Bottom, target: n }) => t === sn.Left || t === sn.Right ? e.x < n.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : e.y < n.y ? { x: 0, y: 1 } : { x: 0, y: -1 }, $ie = (e, t) => Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
function Nht({ source: e, sourcePosition: t = sn.Bottom, target: n, targetPosition: r = sn.Top, center: i, offset: o }) {
  const s = Qie[t], l = Qie[r], c = { x: e.x + s.x * o, y: e.y + s.y * o }, a = { x: n.x + l.x * o, y: n.y + l.y * o }, u = Cht({
    source: c,
    sourcePosition: t,
    target: a
  }), f = u.x !== 0 ? "x" : "y", d = u[f];
  let p = [], h, m;
  const v = { x: 0, y: 0 }, b = { x: 0, y: 0 }, [A, w, O, x] = W1e({
    sourceX: e.x,
    sourceY: e.y,
    targetX: n.x,
    targetY: n.y
  });
  if (s[f] * l[f] === -1) {
    h = i.x ?? A, m = i.y ?? w;
    const E = [
      { x: h, y: c.y },
      { x: h, y: a.y }
    ], k = [
      { x: c.x, y: m },
      { x: a.x, y: m }
    ];
    s[f] === d ? p = f === "x" ? E : k : p = f === "x" ? k : E;
  } else {
    const E = [{ x: c.x, y: a.y }], k = [{ x: a.x, y: c.y }];
    if (f === "x" ? p = s.x === d ? k : E : p = s.y === d ? E : k, t === r) {
      const L = Math.abs(e[f] - n[f]);
      if (L <= o) {
        const _ = Math.min(o - 1, o - L);
        s[f] === d ? v[f] = (c[f] > e[f] ? -1 : 1) * _ : b[f] = (a[f] > n[f] ? -1 : 1) * _;
      }
    }
    if (t !== r) {
      const L = f === "x" ? "y" : "x", _ = s[f] === l[L], U = c[L] > a[L], z = c[L] < a[L];
      (s[f] === 1 && (!_ && U || _ && z) || s[f] !== 1 && (!_ && z || _ && U)) && (p = f === "x" ? E : k);
    }
    const T = { x: c.x + v.x, y: c.y + v.y }, R = { x: a.x + b.x, y: a.y + b.y }, j = Math.max(Math.abs(T.x - p[0].x), Math.abs(R.x - p[0].x)), F = Math.max(Math.abs(T.y - p[0].y), Math.abs(R.y - p[0].y));
    j >= F ? (h = (T.x + R.x) / 2, m = p[0].y) : (h = p[0].x, m = (T.y + R.y) / 2);
  }
  return [[
    e,
    { x: c.x + v.x, y: c.y + v.y },
    ...p,
    { x: a.x + b.x, y: a.y + b.y },
    n
  ], h, m, O, x];
}
function Pht(e, t, n, r) {
  const i = Math.min($ie(e, t) / 2, $ie(t, n) / 2, r), { x: o, y: s } = t;
  if (e.x === o && o === n.x || e.y === s && s === n.y)
    return `L${o} ${s}`;
  if (e.y === s) {
    const a = e.x < n.x ? -1 : 1, u = e.y < n.y ? 1 : -1;
    return `L ${o + i * a},${s}Q ${o},${s} ${o},${s + i * u}`;
  }
  const l = e.x < n.x ? 1 : -1, c = e.y < n.y ? -1 : 1;
  return `L ${o},${s + i * c}Q ${o},${s} ${o + i * l},${s}`;
}
function FB({ sourceX: e, sourceY: t, sourcePosition: n = sn.Bottom, targetX: r, targetY: i, targetPosition: o = sn.Top, borderRadius: s = 5, centerX: l, centerY: c, offset: a = 20 }) {
  const [u, f, d, p, h] = Nht({
    source: { x: e, y: t },
    sourcePosition: n,
    target: { x: r, y: i },
    targetPosition: o,
    center: { x: l, y: c },
    offset: a
  });
  return [u.reduce((v, b, A) => {
    let w = "";
    return A > 0 && A < u.length - 1 ? w = Pht(u[A - 1], b, u[A + 1], s) : w = `${A === 0 ? "M" : "L"}${b.x} ${b.y}`, v += w, v;
  }, ""), f, d, p, h];
}
function Kie(e) {
  var t;
  return e && !!(e.internals.handleBounds || (t = e.handles) != null && t.length) && !!(e.measured.width || e.width || e.initialWidth);
}
function Iht(e) {
  var f;
  const { sourceNode: t, targetNode: n } = e;
  if (!Kie(t) || !Kie(n))
    return null;
  const r = t.internals.handleBounds || Gie(t.handles), i = n.internals.handleBounds || Gie(n.handles), o = Yie((r == null ? void 0 : r.source) ?? [], e.sourceHandle), s = Yie(
    // when connection type is loose we can define all handles as sources and connect source -> source
    e.connectionMode === tw.Strict ? (i == null ? void 0 : i.target) ?? [] : ((i == null ? void 0 : i.target) ?? []).concat((i == null ? void 0 : i.source) ?? []),
    e.targetHandle
  );
  if (!o || !s)
    return (f = e.onError) == null || f.call(e, "008", gu.error008(o ? "target" : "source", {
      id: e.id,
      sourceHandle: e.sourceHandle,
      targetHandle: e.targetHandle
    })), null;
  const l = (o == null ? void 0 : o.position) || sn.Bottom, c = (s == null ? void 0 : s.position) || sn.Top, a = UT(t, o, l), u = UT(n, s, c);
  return {
    sourceX: a.x,
    sourceY: a.y,
    targetX: u.x,
    targetY: u.y,
    sourcePosition: l,
    targetPosition: c
  };
}
function Gie(e) {
  if (!e)
    return null;
  const t = [], n = [];
  for (const r of e)
    r.width = r.width ?? 1, r.height = r.height ?? 1, r.type === "source" ? t.push(r) : r.type === "target" && n.push(r);
  return {
    source: t,
    target: n
  };
}
function UT(e, t, n = sn.Left, r = !1) {
  const i = ((t == null ? void 0 : t.x) ?? 0) + e.internals.positionAbsolute.x, o = ((t == null ? void 0 : t.y) ?? 0) + e.internals.positionAbsolute.y, { width: s, height: l } = t ?? Th(e);
  if (r)
    return { x: i + s / 2, y: o + l / 2 };
  switch ((t == null ? void 0 : t.position) ?? n) {
    case sn.Top:
      return { x: i + s / 2, y: o };
    case sn.Right:
      return { x: i + s, y: o + l / 2 };
    case sn.Bottom:
      return { x: i + s / 2, y: o + l };
    case sn.Left:
      return { x: i, y: o + l / 2 };
  }
}
function Yie(e, t) {
  return e && (t ? e.find((n) => n.id === t) : e[0]) || null;
}
function UB(e, t) {
  return e ? typeof e == "string" ? e : `${t ? `${t}__` : ""}${Object.keys(e).sort().map((r) => `${r}=${e[r]}`).join("&")}` : "";
}
function Rht(e, { id: t, defaultColor: n, defaultMarkerStart: r, defaultMarkerEnd: i }) {
  const o = /* @__PURE__ */ new Set();
  return e.reduce((s, l) => ([l.markerStart || r, l.markerEnd || i].forEach((c) => {
    if (c && typeof c == "object") {
      const a = UB(c, t);
      o.has(a) || (s.push({ id: a, color: c.color || n, ...c }), o.add(a));
    }
  }), s), []).sort((s, l) => s.id.localeCompare(l.id));
}
const LQ = {
  nodeOrigin: [0, 0],
  nodeExtent: jT,
  elevateNodesOnSelect: !0,
  defaults: {}
}, Mht = {
  ...LQ,
  checkEquality: !0
};
function zQ(e, t) {
  const n = { ...e };
  for (const r in t)
    t[r] !== void 0 && (n[r] = t[r]);
  return n;
}
function Dht(e, t, n) {
  const r = zQ(LQ, n);
  for (const i of e.values())
    if (i.parentId)
      jQ(i, e, t, r);
    else {
      const o = rN(i, r.nodeOrigin), s = ow(i.extent) ? i.extent : r.nodeExtent, l = Mv(o, s, Th(i));
      i.internals.positionAbsolute = l;
    }
}
function VB(e, t, n, r) {
  var l, c;
  const i = zQ(Mht, r), o = new Map(t), s = i != null && i.elevateNodesOnSelect ? 1e3 : 0;
  t.clear(), n.clear();
  for (const a of e) {
    let u = o.get(a.id);
    if (i.checkEquality && a === (u == null ? void 0 : u.internals.userNode))
      t.set(a.id, u);
    else {
      const f = rN(a, i.nodeOrigin), d = ow(a.extent) ? a.extent : i.nodeExtent, p = Mv(f, d, Th(a));
      u = {
        ...i.defaults,
        ...a,
        measured: {
          width: (l = a.measured) == null ? void 0 : l.width,
          height: (c = a.measured) == null ? void 0 : c.height
        },
        internals: {
          positionAbsolute: p,
          // if user re-initializes the node or removes `measured` for whatever reason, we reset the handleBounds so that the node gets re-measured
          handleBounds: a.measured ? u == null ? void 0 : u.internals.handleBounds : void 0,
          z: H1e(a, s),
          userNode: a
        }
      }, t.set(a.id, u);
    }
    a.parentId && jQ(u, t, n, r);
  }
}
function _ht(e, t) {
  if (!e.parentId)
    return;
  const n = t.get(e.parentId);
  n ? n.set(e.id, e) : t.set(e.parentId, /* @__PURE__ */ new Map([[e.id, e]]));
}
function jQ(e, t, n, r) {
  const { elevateNodesOnSelect: i, nodeOrigin: o, nodeExtent: s } = zQ(LQ, r), l = e.parentId, c = t.get(l);
  if (!c) {
    console.warn(`Parent node ${l} not found. Please make sure that parent nodes are in front of their child nodes in the nodes array.`);
    return;
  }
  _ht(e, n);
  const a = i ? 1e3 : 0, { x: u, y: f, z: d } = Lht(e, c, o, s, a), { positionAbsolute: p } = e.internals, h = u !== p.x || f !== p.y;
  (h || d !== e.internals.z) && (e.internals = {
    ...e.internals,
    positionAbsolute: h ? { x: u, y: f } : p,
    z: d
  });
}
function H1e(e, t) {
  return (Vu(e.zIndex) ? e.zIndex : 0) + (e.selected ? t : 0);
}
function Lht(e, t, n, r, i) {
  const { x: o, y: s } = t.internals.positionAbsolute, l = Th(e), c = rN(e, n), a = ow(e.extent) ? Mv(c, e.extent, l) : c;
  let u = Mv({ x: o + a.x, y: s + a.y }, r, l);
  e.extent === "parent" && (u = D1e(u, l, t));
  const f = H1e(e, i), d = t.internals.z ?? 0;
  return {
    x: u.x,
    y: u.y,
    z: d > f ? d : f
  };
}
function FQ(e, t, n, r = [0, 0]) {
  var s;
  const i = [], o = /* @__PURE__ */ new Map();
  for (const l of e) {
    const c = t.get(l.parentId);
    if (!c)
      continue;
    const a = ((s = o.get(l.parentId)) == null ? void 0 : s.expandedRect) ?? iw(c), u = L1e(a, l.rect);
    o.set(l.parentId, { expandedRect: u, parent: c });
  }
  return o.size > 0 && o.forEach(({ expandedRect: l, parent: c }, a) => {
    var w;
    const u = c.internals.positionAbsolute, f = Th(c), d = c.origin ?? r, p = l.x < u.x ? Math.round(Math.abs(u.x - l.x)) : 0, h = l.y < u.y ? Math.round(Math.abs(u.y - l.y)) : 0, m = Math.max(f.width, Math.round(l.width)), v = Math.max(f.height, Math.round(l.height)), b = (m - f.width) * d[0], A = (v - f.height) * d[1];
    (p > 0 || h > 0 || b || A) && (i.push({
      id: a,
      type: "position",
      position: {
        x: c.position.x - p + b,
        y: c.position.y - h + A
      }
    }), (w = n.get(a)) == null || w.forEach((O) => {
      e.some((x) => x.id === O.id) || i.push({
        id: O.id,
        type: "position",
        position: {
          x: O.position.x + p,
          y: O.position.y + h
        }
      });
    })), (f.width < l.width || f.height < l.height || p || h) && i.push({
      id: a,
      type: "dimensions",
      setAttributes: !0,
      dimensions: {
        width: m + (p ? d[0] * p - b : 0),
        height: v + (h ? d[1] * h - A : 0)
      }
    });
  }), i;
}
function zht(e, t, n, r, i, o) {
  const s = r == null ? void 0 : r.querySelector(".xyflow__viewport");
  let l = !1;
  if (!s)
    return { changes: [], updatedInternals: l };
  const c = [], a = window.getComputedStyle(s), { m22: u } = new window.DOMMatrixReadOnly(a.transform), f = [];
  for (const d of e.values()) {
    const p = t.get(d.id);
    if (p)
      if (p.hidden)
        p.internals = {
          ...p.internals,
          handleBounds: void 0
        }, l = !0;
      else {
        const h = qz(d.nodeElement), m = p.measured.width !== h.width || p.measured.height !== h.height;
        if (!!(h.width && h.height && (m || !p.internals.handleBounds || d.force))) {
          const b = d.nodeElement.getBoundingClientRect(), A = ow(p.extent) ? p.extent : o;
          let { positionAbsolute: w } = p.internals;
          p.parentId && p.extent === "parent" ? w = D1e(w, h, t.get(p.parentId)) : A && (w = Mv(w, A, h)), p.measured = h, p.internals = {
            ...p.internals,
            positionAbsolute: w,
            handleBounds: {
              source: Zie("source", d.nodeElement, b, u, p.id),
              target: Zie("target", d.nodeElement, b, u, p.id)
            }
          }, p.parentId && jQ(p, t, n, { nodeOrigin: i }), l = !0, m && (c.push({
            id: p.id,
            type: "dimensions",
            dimensions: h
          }), p.expandParent && p.parentId && f.push({
            id: p.id,
            parentId: p.parentId,
            rect: iw(p, i)
          }));
        }
      }
  }
  if (f.length > 0) {
    const d = FQ(f, t, n, i);
    c.push(...d);
  }
  return { changes: c, updatedInternals: l };
}
async function jht({ delta: e, panZoom: t, transform: n, translateExtent: r, width: i, height: o }) {
  if (!t || !e.x && !e.y)
    return Promise.resolve(!1);
  const s = await t.setViewportConstrained({
    x: n[0] + e.x,
    y: n[1] + e.y,
    zoom: n[2]
  }, [
    [0, 0],
    [i, o]
  ], r), l = !!s && (s.x !== n[0] || s.y !== n[1] || s.k !== n[2]);
  return Promise.resolve(l);
}
function Q1e(e, t, n) {
  e.clear(), t.clear();
  for (const r of n) {
    const { source: i, target: o, sourceHandle: s = null, targetHandle: l = null } = r, c = `${i}-source-${s}`, a = `${o}-target-${l}`, u = e.get(c) || /* @__PURE__ */ new Map(), f = e.get(a) || /* @__PURE__ */ new Map(), d = { edgeId: r.id, source: i, target: o, sourceHandle: s, targetHandle: l };
    t.set(r.id, r), e.set(c, u.set(`${o}-${l}`, d)), e.set(a, f.set(`${i}-${s}`, d));
  }
}
function $1e(e, t) {
  if (!e.parentId)
    return !1;
  const n = t.get(e.parentId);
  return n ? n.selected ? !0 : $1e(n, t) : !1;
}
function Jie(e, t, n) {
  let r = e;
  do {
    if (r != null && r.matches(t))
      return !0;
    if (r === n)
      return !1;
    r = r.parentElement;
  } while (r);
  return !1;
}
function Fht(e, t, n, r) {
  const i = /* @__PURE__ */ new Map();
  for (const [o, s] of e)
    if ((s.selected || s.id === r) && (!s.parentId || !$1e(s, e)) && (s.draggable || t && typeof s.draggable > "u")) {
      const l = e.get(o);
      l && i.set(o, {
        id: o,
        position: l.position || { x: 0, y: 0 },
        distance: {
          x: n.x - l.internals.positionAbsolute.x,
          y: n.y - l.internals.positionAbsolute.y
        },
        extent: l.extent,
        parentId: l.parentId,
        origin: l.origin,
        expandParent: l.expandParent,
        internals: {
          positionAbsolute: l.internals.positionAbsolute || { x: 0, y: 0 }
        },
        measured: {
          width: l.measured.width ?? 0,
          height: l.measured.height ?? 0
        }
      });
    }
  return i;
}
function m6({ nodeId: e, dragItems: t, nodeLookup: n, dragging: r = !0 }) {
  var s, l, c;
  const i = [];
  for (const [a, u] of t) {
    const f = (s = n.get(a)) == null ? void 0 : s.internals.userNode;
    f && i.push({
      ...f,
      position: u.position,
      dragging: r
    });
  }
  if (!e)
    return [i[0], i];
  const o = (l = n.get(e)) == null ? void 0 : l.internals.userNode;
  return [
    o ? {
      ...o,
      position: ((c = t.get(e)) == null ? void 0 : c.position) || o.position,
      dragging: r
    } : i[0],
    i
  ];
}
function Uht({ onNodeMouseDown: e, getStoreItems: t, onDragStart: n, onDrag: r, onDragStop: i }) {
  let o = { x: null, y: null }, s = 0, l = /* @__PURE__ */ new Map(), c = !1, a = { x: 0, y: 0 }, u = null, f = !1, d = null, p = !1;
  function h({ noDragClassName: v, handleSelector: b, domNode: A, isSelectable: w, nodeId: O, nodeClickDistance: x = 0 }) {
    d = Kl(A);
    function S({ x: R, y: j }, F) {
      const { nodeLookup: L, nodeExtent: _, snapGrid: U, snapToGrid: z, nodeOrigin: C, onNodeDrag: I, onSelectionDrag: M, onError: D, updateNodePositions: X } = t();
      o = { x: R, y: j };
      let B = !1, q = { x: 0, y: 0, x2: 0, y2: 0 };
      if (l.size > 1 && _) {
        const H = iN(l);
        q = zB(H);
      }
      for (const [H, Y] of l) {
        if (!L.has(H))
          continue;
        let J = { x: R - Y.distance.x, y: j - Y.distance.y };
        z && (J = Vz(J, U));
        let oe = [
          [_[0][0], _[0][1]],
          [_[1][0], _[1][1]]
        ];
        if (l.size > 1 && _ && !Y.extent) {
          const { positionAbsolute: $ } = Y.internals, pe = $.x - q.x + _[0][0], ee = $.x + Y.measured.width - q.x2 + _[1][0], Ce = $.y - q.y + _[0][1], Ee = $.y + Y.measured.height - q.y2 + _[1][1];
          oe = [
            [pe, Ce],
            [ee, Ee]
          ];
        }
        const { position: ce, positionAbsolute: fe } = M1e({
          nodeId: H,
          nextPosition: J,
          nodeLookup: L,
          nodeExtent: oe,
          nodeOrigin: C,
          onError: D
        });
        B = B || Y.position.x !== ce.x || Y.position.y !== ce.y, Y.position = ce, Y.internals.positionAbsolute = fe;
      }
      if (B && (X(l, !0), F && (r || I || !O && M))) {
        const [H, Y] = m6({
          nodeId: O,
          dragItems: l,
          nodeLookup: L
        });
        r == null || r(F, l, H, Y), I == null || I(F, H, Y), O || M == null || M(F, Y);
      }
    }
    async function E() {
      if (!u)
        return;
      const { transform: R, panBy: j, autoPanSpeed: F } = t(), [L, _] = _1e(a, u, F);
      (L !== 0 || _ !== 0) && (o.x = (o.x ?? 0) - L / R[2], o.y = (o.y ?? 0) - _ / R[2], await j({ x: L, y: _ }) && S(o, null)), s = requestAnimationFrame(E);
    }
    function k(R) {
      var B;
      const { nodeLookup: j, multiSelectionActive: F, nodesDraggable: L, transform: _, snapGrid: U, snapToGrid: z, selectNodesOnDrag: C, onNodeDragStart: I, onSelectionDragStart: M, unselectNodesAndEdges: D } = t();
      f = !0, (!C || !w) && !F && O && ((B = j.get(O)) != null && B.selected || D()), w && C && O && (e == null || e(O));
      const X = OE(R.sourceEvent, { transform: _, snapGrid: U, snapToGrid: z, containerBounds: u });
      if (o = X, l = Fht(j, L, X, O), l.size > 0 && (n || I || !O && M)) {
        const [q, H] = m6({
          nodeId: O,
          dragItems: l,
          nodeLookup: j
        });
        n == null || n(R.sourceEvent, l, q, H), I == null || I(R.sourceEvent, q, H), O || M == null || M(R.sourceEvent, H);
      }
    }
    const T = d1e().clickDistance(x).on("start", (R) => {
      const { domNode: j, nodeDragThreshold: F, transform: L, snapGrid: _, snapToGrid: U } = t();
      u = (j == null ? void 0 : j.getBoundingClientRect()) || null, p = !1, F === 0 && k(R), o = OE(R.sourceEvent, { transform: L, snapGrid: _, snapToGrid: U, containerBounds: u }), a = Gp(R.sourceEvent, u);
    }).on("drag", (R) => {
      const { autoPanOnNodeDrag: j, transform: F, snapGrid: L, snapToGrid: _, nodeDragThreshold: U, nodeLookup: z } = t(), C = OE(R.sourceEvent, { transform: F, snapGrid: L, snapToGrid: _, containerBounds: u });
      if ((R.sourceEvent.type === "touchmove" && R.sourceEvent.touches.length > 1 || // if user deletes a node while dragging, we need to abort the drag to prevent errors
      O && !z.has(O)) && (p = !0), !p) {
        if (!c && j && f && (c = !0, E()), !f) {
          const I = C.xSnapped - (o.x ?? 0), M = C.ySnapped - (o.y ?? 0);
          Math.sqrt(I * I + M * M) > U && k(R);
        }
        (o.x !== C.xSnapped || o.y !== C.ySnapped) && l && f && (a = Gp(R.sourceEvent, u), S(C, R.sourceEvent));
      }
    }).on("end", (R) => {
      if (!(!f || p) && (c = !1, f = !1, cancelAnimationFrame(s), l.size > 0)) {
        const { nodeLookup: j, updateNodePositions: F, onNodeDragStop: L, onSelectionDragStop: _ } = t();
        if (F(l, !1), i || L || !O && _) {
          const [U, z] = m6({
            nodeId: O,
            dragItems: l,
            nodeLookup: j,
            dragging: !1
          });
          i == null || i(R.sourceEvent, l, U, z), L == null || L(R.sourceEvent, U, z), O || _ == null || _(R.sourceEvent, z);
        }
      }
    }).filter((R) => {
      const j = R.target;
      return !R.button && (!v || !Jie(j, `.${v}`, A)) && (!b || Jie(j, b, A));
    });
    d.call(T);
  }
  function m() {
    d == null || d.on(".drag", null);
  }
  return {
    update: h,
    destroy: m
  };
}
function Vht(e, t, n) {
  const r = [], i = {
    x: e.x - n,
    y: e.y - n,
    width: n * 2,
    height: n * 2
  };
  for (const o of t.values())
    FT(i, iw(o)) > 0 && r.push(o);
  return r;
}
const qht = 250;
function Bht(e, t, n, r) {
  var l, c;
  let i = [], o = 1 / 0;
  const s = Vht(e, n, t + qht);
  for (const a of s) {
    const u = [...((l = a.internals.handleBounds) == null ? void 0 : l.source) ?? [], ...((c = a.internals.handleBounds) == null ? void 0 : c.target) ?? []];
    for (const f of u) {
      if (r.nodeId === f.nodeId && r.type === f.type && r.id === f.id)
        continue;
      const { x: d, y: p } = UT(a, f, f.position, !0), h = Math.sqrt(Math.pow(d - e.x, 2) + Math.pow(p - e.y, 2));
      h > t || (h < o ? (i = [{ ...f, x: d, y: p }], o = h) : h === o && i.push({ ...f, x: d, y: p }));
    }
  }
  if (!i.length)
    return null;
  if (i.length > 1) {
    const a = r.type === "source" ? "target" : "source";
    return i.find((u) => u.type === a) ?? i[0];
  }
  return i[0];
}
function K1e(e, t, n, r, i, o = !1) {
  var a, u, f;
  const s = r.get(e);
  if (!s)
    return null;
  const l = i === "strict" ? (a = s.internals.handleBounds) == null ? void 0 : a[t] : [...((u = s.internals.handleBounds) == null ? void 0 : u.source) ?? [], ...((f = s.internals.handleBounds) == null ? void 0 : f.target) ?? []], c = (n ? l == null ? void 0 : l.find((d) => d.id === n) : l == null ? void 0 : l[0]) ?? null;
  return c && o ? { ...c, ...UT(s, c, c.position, !0) } : c;
}
function G1e(e, t) {
  return e || (t != null && t.classList.contains("target") ? "target" : t != null && t.classList.contains("source") ? "source" : null);
}
function Xht(e, t) {
  let n = null;
  return t ? n = !0 : e && !t && (n = !1), n;
}
const Y1e = () => !0;
function Wht(e, { connectionMode: t, connectionRadius: n, handleId: r, nodeId: i, edgeUpdaterType: o, isTarget: s, domNode: l, nodeLookup: c, lib: a, autoPanOnConnect: u, flowId: f, panBy: d, cancelConnection: p, onConnectStart: h, onConnect: m, onConnectEnd: v, isValidConnection: b = Y1e, onReconnectEnd: A, updateConnection: w, getTransform: O, getFromHandle: x, autoPanSpeed: S }) {
  const E = V1e(e.target);
  let k = 0, T;
  const { x: R, y: j } = Gp(e), F = E == null ? void 0 : E.elementFromPoint(R, j), L = G1e(o, F), _ = l == null ? void 0 : l.getBoundingClientRect();
  if (!_ || !L)
    return;
  const U = K1e(i, L, r, c, t);
  if (!U)
    return;
  let z = Gp(e, _), C = !1, I = null, M = !1, D = null;
  function X() {
    if (!u || !_)
      return;
    const [fe, $] = _1e(z, _, S);
    d({ x: fe, y: $ }), k = requestAnimationFrame(X);
  }
  const B = {
    ...U,
    nodeId: i,
    type: L,
    position: U.position
  }, q = c.get(i), Y = {
    inProgress: !0,
    isValid: null,
    from: UT(q, B, sn.Left, !0),
    fromHandle: B,
    fromPosition: B.position,
    fromNode: q,
    to: z,
    toHandle: null,
    toPosition: Bie[B.position],
    toNode: null
  };
  w(Y);
  let J = Y;
  h == null || h(e, { nodeId: i, handleId: r, handleType: L });
  function oe(fe) {
    if (!x() || !B) {
      ce(fe);
      return;
    }
    const $ = O();
    z = Gp(fe, _), T = Bht(oN(z, $, !1, [1, 1]), n, c, B), C || (X(), C = !0);
    const pe = J1e(fe, {
      handle: T,
      connectionMode: t,
      fromNodeId: i,
      fromHandleId: r,
      fromType: s ? "target" : "source",
      isValidConnection: b,
      doc: E,
      lib: a,
      flowId: f,
      nodeLookup: c
    });
    D = pe.handleDomNode, I = pe.connection, M = Xht(!!T, pe.isValid);
    const ee = {
      // from stays the same
      ...J,
      isValid: M,
      to: T && M ? j1e({ x: T.x, y: T.y }, $) : z,
      toHandle: pe.toHandle,
      toPosition: M && pe.toHandle ? pe.toHandle.position : Bie[B.position],
      toNode: pe.toHandle ? c.get(pe.toHandle.nodeId) : null
    };
    M && T && J.toHandle && ee.toHandle && J.toHandle.type === ee.toHandle.type && J.toHandle.nodeId === ee.toHandle.nodeId && J.toHandle.id === ee.toHandle.id && J.to.x === ee.to.x && J.to.y === ee.to.y || (w(ee), J = ee);
  }
  function ce(fe) {
    (T || D) && I && M && (m == null || m(I));
    const { inProgress: $, ...pe } = J, ee = {
      ...pe,
      toPosition: J.toHandle ? J.toPosition : null
    };
    v == null || v(fe, ee), o && (A == null || A(fe, ee)), p(), cancelAnimationFrame(k), C = !1, M = !1, I = null, D = null, E.removeEventListener("mousemove", oe), E.removeEventListener("mouseup", ce), E.removeEventListener("touchmove", oe), E.removeEventListener("touchend", ce);
  }
  E.addEventListener("mousemove", oe), E.addEventListener("mouseup", ce), E.addEventListener("touchmove", oe), E.addEventListener("touchend", ce);
}
function J1e(e, { handle: t, connectionMode: n, fromNodeId: r, fromHandleId: i, fromType: o, doc: s, lib: l, flowId: c, isValidConnection: a = Y1e, nodeLookup: u }) {
  const f = o === "target", d = t ? s.querySelector(`.${l}-flow__handle[data-id="${c}-${t == null ? void 0 : t.nodeId}-${t == null ? void 0 : t.id}-${t == null ? void 0 : t.type}"]`) : null, { x: p, y: h } = Gp(e), m = s.elementFromPoint(p, h), v = m != null && m.classList.contains(`${l}-flow__handle`) ? m : d, b = {
    handleDomNode: v,
    isValid: !1,
    connection: null,
    toHandle: null
  };
  if (v) {
    const A = G1e(void 0, v), w = v.getAttribute("data-nodeid"), O = v.getAttribute("data-handleid"), x = v.classList.contains("connectable"), S = v.classList.contains("connectableend");
    if (!w || !A)
      return b;
    const E = {
      source: f ? w : r,
      sourceHandle: f ? O : i,
      target: f ? r : w,
      targetHandle: f ? i : O
    };
    b.connection = E;
    const T = x && S && (n === tw.Strict ? f && A === "source" || !f && A === "target" : w !== r || O !== i);
    b.isValid = T && a(E), b.toHandle = K1e(w, A, O, u, n, !1);
  }
  return b;
}
const qB = {
  onPointerDown: Wht,
  isValid: J1e
};
function Zht({ domNode: e, panZoom: t, getTransform: n, getViewScale: r }) {
  const i = Kl(e);
  function o({ translateExtent: l, width: c, height: a, zoomStep: u = 10, pannable: f = !0, zoomable: d = !0, inversePan: p = !1 }) {
    const h = (w) => {
      const O = n();
      if (w.sourceEvent.type !== "wheel" || !t)
        return;
      const x = -w.sourceEvent.deltaY * (w.sourceEvent.deltaMode === 1 ? 0.05 : w.sourceEvent.deltaMode ? 1 : 2e-3) * u, S = O[2] * Math.pow(2, x);
      t.scaleTo(S);
    };
    let m = [0, 0];
    const v = (w) => {
      (w.sourceEvent.type === "mousedown" || w.sourceEvent.type === "touchstart") && (m = [
        w.sourceEvent.clientX ?? w.sourceEvent.touches[0].clientX,
        w.sourceEvent.clientY ?? w.sourceEvent.touches[0].clientY
      ]);
    }, b = (w) => {
      const O = n();
      if (w.sourceEvent.type !== "mousemove" && w.sourceEvent.type !== "touchmove" || !t)
        return;
      const x = [
        w.sourceEvent.clientX ?? w.sourceEvent.touches[0].clientX,
        w.sourceEvent.clientY ?? w.sourceEvent.touches[0].clientY
      ], S = [x[0] - m[0], x[1] - m[1]];
      m = x;
      const E = r() * Math.max(O[2], Math.log(O[2])) * (p ? -1 : 1), k = {
        x: O[0] - S[0] * E,
        y: O[1] - S[1] * E
      }, T = [
        [0, 0],
        [c, a]
      ];
      t.setViewportConstrained({
        x: k.x,
        y: k.y,
        zoom: O[2]
      }, T, l);
    }, A = T1e().on("start", v).on("zoom", f ? b : null).on("zoom.wheel", d ? h : null);
    i.call(A, {});
  }
  function s() {
    i.on("zoom", null);
  }
  return {
    update: o,
    destroy: s,
    pointer: Iu
  };
}
const Hht = (e, t) => e.x !== t.x || e.y !== t.y || e.zoom !== t.k, Bz = (e) => ({
  x: e.x,
  y: e.y,
  zoom: e.k
}), g6 = ({ x: e, y: t, zoom: n }) => jz.translate(e, t).scale(n), OO = (e, t) => e.target.closest(`.${t}`), eEe = (e, t) => t === 2 && Array.isArray(e) && e.includes(2), y6 = (e, t = 0, n = () => {
}) => {
  const r = typeof t == "number" && t > 0;
  return r || n(), r ? e.transition().duration(t).on("end", n) : e;
}, tEe = (e) => {
  const t = e.ctrlKey && bD() ? 10 : 1;
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * t;
};
function Qht({ zoomPanValues: e, noWheelClassName: t, d3Selection: n, d3Zoom: r, panOnScrollMode: i, panOnScrollSpeed: o, zoomOnPinch: s, onPanZoomStart: l, onPanZoom: c, onPanZoomEnd: a }) {
  return (u) => {
    if (OO(u, t))
      return !1;
    u.preventDefault(), u.stopImmediatePropagation();
    const f = n.property("__zoom").k || 1;
    if (u.ctrlKey && s) {
      const v = Iu(u), b = tEe(u), A = f * Math.pow(2, b);
      r.scaleTo(n, A, v, u);
      return;
    }
    const d = u.deltaMode === 1 ? 20 : 1;
    let p = i === Bm.Vertical ? 0 : u.deltaX * d, h = i === Bm.Horizontal ? 0 : u.deltaY * d;
    !bD() && u.shiftKey && i !== Bm.Vertical && (p = u.deltaY * d, h = 0), r.translateBy(
      n,
      -(p / f) * o,
      -(h / f) * o,
      // @ts-ignore
      { internal: !0 }
    );
    const m = Bz(n.property("__zoom"));
    clearTimeout(e.panScrollTimeout), e.isPanScrolling || (e.isPanScrolling = !0, l == null || l(u, m)), e.isPanScrolling && (c == null || c(u, m), e.panScrollTimeout = setTimeout(() => {
      a == null || a(u, m), e.isPanScrolling = !1;
    }, 150));
  };
}
function $ht({ noWheelClassName: e, preventScrolling: t, d3ZoomHandler: n }) {
  return function(r, i) {
    if (!t && r.type === "wheel" && !r.ctrlKey || OO(r, e))
      return null;
    r.preventDefault(), n.call(this, r, i);
  };
}
function Kht({ zoomPanValues: e, onDraggingChange: t, onPanZoomStart: n }) {
  return (r) => {
    var o, s, l;
    if ((o = r.sourceEvent) != null && o.internal)
      return;
    const i = Bz(r.transform);
    e.mouseButton = ((s = r.sourceEvent) == null ? void 0 : s.button) || 0, e.isZoomingOrPanning = !0, e.prevViewport = i, ((l = r.sourceEvent) == null ? void 0 : l.type) === "mousedown" && t(!0), n && (n == null || n(r.sourceEvent, i));
  };
}
function Ght({ zoomPanValues: e, panOnDrag: t, onPaneContextMenu: n, onTransformChange: r, onPanZoom: i }) {
  return (o) => {
    var s, l;
    e.usedRightMouseButton = !!(n && eEe(t, e.mouseButton ?? 0)), (s = o.sourceEvent) != null && s.sync || r([o.transform.x, o.transform.y, o.transform.k]), i && !((l = o.sourceEvent) != null && l.internal) && (i == null || i(o.sourceEvent, Bz(o.transform)));
  };
}
function Yht({ zoomPanValues: e, panOnDrag: t, panOnScroll: n, onDraggingChange: r, onPanZoomEnd: i, onPaneContextMenu: o }) {
  return (s) => {
    var l;
    if (!((l = s.sourceEvent) != null && l.internal) && (e.isZoomingOrPanning = !1, o && eEe(t, e.mouseButton ?? 0) && !e.usedRightMouseButton && s.sourceEvent && o(s.sourceEvent), e.usedRightMouseButton = !1, r(!1), i && Hht(e.prevViewport, s.transform))) {
      const c = Bz(s.transform);
      e.prevViewport = c, clearTimeout(e.timerId), e.timerId = setTimeout(
        () => {
          i == null || i(s.sourceEvent, c);
        },
        // we need a setTimeout for panOnScroll to supress multiple end events fired during scroll
        n ? 150 : 0
      );
    }
  };
}
function Jht({ zoomActivationKeyPressed: e, zoomOnScroll: t, zoomOnPinch: n, panOnDrag: r, panOnScroll: i, zoomOnDoubleClick: o, userSelectionActive: s, noWheelClassName: l, noPanClassName: c, lib: a }) {
  return (u) => {
    var h;
    const f = e || t, d = n && u.ctrlKey;
    if (u.button === 1 && u.type === "mousedown" && (OO(u, `${a}-flow__node`) || OO(u, `${a}-flow__edge`)))
      return !0;
    if (!r && !f && !i && !o && !n || s || OO(u, l) && u.type === "wheel" || OO(u, c) && (u.type !== "wheel" || i && u.type === "wheel" && !e) || !n && u.ctrlKey && u.type === "wheel")
      return !1;
    if (!n && u.type === "touchstart" && ((h = u.touches) == null ? void 0 : h.length) > 1)
      return u.preventDefault(), !1;
    if (!f && !i && !d && u.type === "wheel" || !r && (u.type === "mousedown" || u.type === "touchstart") || Array.isArray(r) && !r.includes(u.button) && u.type === "mousedown")
      return !1;
    const p = Array.isArray(r) && r.includes(u.button) || !u.button || u.button <= 1;
    return (!u.ctrlKey || u.type === "wheel") && p;
  };
}
function emt({ domNode: e, minZoom: t, maxZoom: n, paneClickDistance: r, translateExtent: i, viewport: o, onPanZoom: s, onPanZoomStart: l, onPanZoomEnd: c, onDraggingChange: a }) {
  const u = {
    isZoomingOrPanning: !1,
    usedRightMouseButton: !1,
    prevViewport: { x: 0, y: 0, zoom: 0 },
    mouseButton: 0,
    timerId: void 0,
    panScrollTimeout: void 0,
    isPanScrolling: !1
  }, f = e.getBoundingClientRect(), d = T1e().clickDistance(!Vu(r) || r < 0 ? 0 : r).scaleExtent([t, n]).translateExtent(i), p = Kl(e).call(d);
  w({
    x: o.x,
    y: o.y,
    zoom: rw(o.zoom, t, n)
  }, [
    [0, 0],
    [f.width, f.height]
  ], i);
  const h = p.on("wheel.zoom"), m = p.on("dblclick.zoom");
  d.wheelDelta(tEe);
  function v(F, L) {
    return p ? new Promise((_) => {
      d == null || d.transform(y6(p, L == null ? void 0 : L.duration, () => _(!0)), F);
    }) : Promise.resolve(!1);
  }
  function b({ noWheelClassName: F, noPanClassName: L, onPaneContextMenu: _, userSelectionActive: U, panOnScroll: z, panOnDrag: C, panOnScrollMode: I, panOnScrollSpeed: M, preventScrolling: D, zoomOnPinch: X, zoomOnScroll: B, zoomOnDoubleClick: q, zoomActivationKeyPressed: H, lib: Y, onTransformChange: J }) {
    U && !u.isZoomingOrPanning && A();
    const ce = z && !H && !U ? Qht({
      zoomPanValues: u,
      noWheelClassName: F,
      d3Selection: p,
      d3Zoom: d,
      panOnScrollMode: I,
      panOnScrollSpeed: M,
      zoomOnPinch: X,
      onPanZoomStart: l,
      onPanZoom: s,
      onPanZoomEnd: c
    }) : $ht({
      noWheelClassName: F,
      preventScrolling: D,
      d3ZoomHandler: h
    });
    if (p.on("wheel.zoom", ce, { passive: !1 }), !U) {
      const $ = Kht({
        zoomPanValues: u,
        onDraggingChange: a,
        onPanZoomStart: l
      });
      d.on("start", $);
      const pe = Ght({
        zoomPanValues: u,
        panOnDrag: C,
        onPaneContextMenu: !!_,
        onPanZoom: s,
        onTransformChange: J
      });
      d.on("zoom", pe);
      const ee = Yht({
        zoomPanValues: u,
        panOnDrag: C,
        panOnScroll: z,
        onPaneContextMenu: _,
        onPanZoomEnd: c,
        onDraggingChange: a
      });
      d.on("end", ee);
    }
    const fe = Jht({
      zoomActivationKeyPressed: H,
      panOnDrag: C,
      zoomOnScroll: B,
      panOnScroll: z,
      zoomOnDoubleClick: q,
      zoomOnPinch: X,
      userSelectionActive: U,
      noPanClassName: L,
      noWheelClassName: F,
      lib: Y
    });
    d.filter(fe), q ? p.on("dblclick.zoom", m) : p.on("dblclick.zoom", null);
  }
  function A() {
    d.on("zoom", null);
  }
  async function w(F, L, _) {
    const U = g6(F), z = d == null ? void 0 : d.constrain()(U, L, _);
    return z && await v(z), new Promise((C) => C(z));
  }
  async function O(F, L) {
    const _ = g6(F);
    return await v(_, L), new Promise((U) => U(_));
  }
  function x(F) {
    if (p) {
      const L = g6(F), _ = p.property("__zoom");
      (_.k !== F.zoom || _.x !== F.x || _.y !== F.y) && (d == null || d.transform(p, L, null, { sync: !0 }));
    }
  }
  function S() {
    const F = p ? E1e(p.node()) : { x: 0, y: 0, k: 1 };
    return { x: F.x, y: F.y, zoom: F.k };
  }
  function E(F, L) {
    return p ? new Promise((_) => {
      d == null || d.scaleTo(y6(p, L == null ? void 0 : L.duration, () => _(!0)), F);
    }) : Promise.resolve(!1);
  }
  function k(F, L) {
    return p ? new Promise((_) => {
      d == null || d.scaleBy(y6(p, L == null ? void 0 : L.duration, () => _(!0)), F);
    }) : Promise.resolve(!1);
  }
  function T(F) {
    d == null || d.scaleExtent(F);
  }
  function R(F) {
    d == null || d.translateExtent(F);
  }
  function j(F) {
    const L = !Vu(F) || F < 0 ? 0 : F;
    d == null || d.clickDistance(L);
  }
  return {
    update: b,
    destroy: A,
    setViewport: O,
    setViewportConstrained: w,
    getViewport: S,
    scaleTo: E,
    scaleBy: k,
    setScaleExtent: T,
    setTranslateExtent: R,
    syncViewport: x,
    setClickDistance: j
  };
}
var AE;
(function(e) {
  e.Line = "line", e.Handle = "handle";
})(AE || (AE = {}));
function tmt({ width: e, prevWidth: t, height: n, prevHeight: r, affectsX: i, affectsY: o }) {
  const s = e - t, l = n - r, c = [s > 0 ? 1 : s < 0 ? -1 : 0, l > 0 ? 1 : l < 0 ? -1 : 0];
  return s && i && (c[0] = c[0] * -1), l && o && (c[1] = c[1] * -1), c;
}
function nmt(e) {
  const t = e.includes("right") || e.includes("left"), n = e.includes("bottom") || e.includes("top"), r = e.includes("left"), i = e.includes("top");
  return {
    isHorizontal: t,
    isVertical: n,
    affectsX: r,
    affectsY: i
  };
}
function Lh(e, t) {
  return Math.max(0, t - e);
}
function zh(e, t) {
  return Math.max(0, e - t);
}
function DP(e, t, n) {
  return Math.max(0, t - e, e - n);
}
function eoe(e, t) {
  return e ? !t : t;
}
function rmt(e, t, n, r, i, o, s, l) {
  let { affectsX: c, affectsY: a } = t;
  const { isHorizontal: u, isVertical: f } = t, d = u && f, { xSnapped: p, ySnapped: h } = n, { minWidth: m, maxWidth: v, minHeight: b, maxHeight: A } = r, { x: w, y: O, width: x, height: S, aspectRatio: E } = e;
  let k = Math.floor(u ? p - e.pointerX : 0), T = Math.floor(f ? h - e.pointerY : 0);
  const R = x + (c ? -k : k), j = S + (a ? -T : T), F = -o[0] * x, L = -o[1] * S;
  let _ = DP(R, m, v), U = DP(j, b, A);
  if (s) {
    let I = 0, M = 0;
    c && k < 0 ? I = Lh(w + k + F, s[0][0]) : !c && k > 0 && (I = zh(w + R + F, s[1][0])), a && T < 0 ? M = Lh(O + T + L, s[0][1]) : !a && T > 0 && (M = zh(O + j + L, s[1][1])), _ = Math.max(_, I), U = Math.max(U, M);
  }
  if (l) {
    let I = 0, M = 0;
    c && k > 0 ? I = zh(w + k, l[0][0]) : !c && k < 0 && (I = Lh(w + R, l[1][0])), a && T > 0 ? M = zh(O + T, l[0][1]) : !a && T < 0 && (M = Lh(O + j, l[1][1])), _ = Math.max(_, I), U = Math.max(U, M);
  }
  if (i) {
    if (u) {
      const I = DP(R / E, b, A) * E;
      if (_ = Math.max(_, I), s) {
        let M = 0;
        !c && !a || c && !a && d ? M = zh(O + L + R / E, s[1][1]) * E : M = Lh(O + L + (c ? k : -k) / E, s[0][1]) * E, _ = Math.max(_, M);
      }
      if (l) {
        let M = 0;
        !c && !a || c && !a && d ? M = Lh(O + R / E, l[1][1]) * E : M = zh(O + (c ? k : -k) / E, l[0][1]) * E, _ = Math.max(_, M);
      }
    }
    if (f) {
      const I = DP(j * E, m, v) / E;
      if (U = Math.max(U, I), s) {
        let M = 0;
        !c && !a || a && !c && d ? M = zh(w + j * E + F, s[1][0]) / E : M = Lh(w + (a ? T : -T) * E + F, s[0][0]) / E, U = Math.max(U, M);
      }
      if (l) {
        let M = 0;
        !c && !a || a && !c && d ? M = Lh(w + j * E, l[1][0]) / E : M = zh(w + (a ? T : -T) * E, l[0][0]) / E, U = Math.max(U, M);
      }
    }
  }
  T = T + (T < 0 ? U : -U), k = k + (k < 0 ? _ : -_), i && (d ? R > j * E ? T = (eoe(c, a) ? -k : k) / E : k = (eoe(c, a) ? -T : T) * E : u ? (T = k / E, a = c) : (k = T * E, c = a));
  const z = c ? w + k : w, C = a ? O + T : O;
  return {
    width: x + (c ? -k : k),
    height: S + (a ? -T : T),
    x: o[0] * k * (c ? -1 : 1) + z,
    y: o[1] * T * (a ? -1 : 1) + C
  };
}
const nEe = { width: 0, height: 0, x: 0, y: 0 }, imt = {
  ...nEe,
  pointerX: 0,
  pointerY: 0,
  aspectRatio: 1
};
function omt(e) {
  return [
    [0, 0],
    [e.measured.width, e.measured.height]
  ];
}
function smt(e, t, n) {
  const r = t.position.x + e.position.x, i = t.position.y + e.position.y, o = e.measured.width ?? 0, s = e.measured.height ?? 0, l = n[0] * o, c = n[1] * s;
  return [
    [r - l, i - c],
    [r + o - l, i + s - c]
  ];
}
function amt({ domNode: e, nodeId: t, getStoreItems: n, onChange: r, onEnd: i }) {
  const o = Kl(e);
  function s({ controlPosition: c, boundaries: a, keepAspectRatio: u, onResizeStart: f, onResize: d, onResizeEnd: p, shouldResize: h }) {
    let m = { ...nEe }, v = { ...imt };
    const b = nmt(c);
    let A, w = null, O = [], x, S, E;
    const k = d1e().on("start", (T) => {
      const { nodeLookup: R, transform: j, snapGrid: F, snapToGrid: L, nodeOrigin: _, paneDomNode: U } = n();
      if (A = R.get(t), !A)
        return;
      w = (U == null ? void 0 : U.getBoundingClientRect()) ?? null;
      const { xSnapped: z, ySnapped: C } = OE(T.sourceEvent, {
        transform: j,
        snapGrid: F,
        snapToGrid: L,
        containerBounds: w
      });
      m = {
        width: A.measured.width ?? 0,
        height: A.measured.height ?? 0,
        x: A.position.x ?? 0,
        y: A.position.y ?? 0
      }, v = {
        ...m,
        pointerX: z,
        pointerY: C,
        aspectRatio: m.width / m.height
      }, x = void 0, A.parentId && (A.extent === "parent" || A.expandParent) && (x = R.get(A.parentId), S = x && A.extent === "parent" ? omt(x) : void 0), O = [], E = void 0;
      for (const [I, M] of R)
        if (M.parentId === t && (O.push({
          id: I,
          position: { ...M.position },
          extent: M.extent
        }), M.extent === "parent" || M.expandParent)) {
          const D = smt(M, A, M.origin ?? _);
          E ? E = [
            [Math.min(D[0][0], E[0][0]), Math.min(D[0][1], E[0][1])],
            [Math.max(D[1][0], E[1][0]), Math.max(D[1][1], E[1][1])]
          ] : E = D;
        }
      f == null || f(T, { ...m });
    }).on("drag", (T) => {
      const { transform: R, snapGrid: j, snapToGrid: F, nodeOrigin: L } = n(), _ = OE(T.sourceEvent, {
        transform: R,
        snapGrid: j,
        snapToGrid: F,
        containerBounds: w
      }), U = [];
      if (!A)
        return;
      const { x: z, y: C, width: I, height: M } = m, D = {}, X = A.origin ?? L, { width: B, height: q, x: H, y: Y } = rmt(v, b, _, a, u, X, S, E), J = B !== I, oe = q !== M, ce = H !== z && J, fe = Y !== C && oe;
      if (!ce && !fe && !J && !oe)
        return;
      if ((ce || fe || X[0] === 1 || X[1] === 1) && (D.x = ce ? H : m.x, D.y = fe ? Y : m.y, m.x = D.x, m.y = D.y, O.length > 0)) {
        const Ce = H - z, Ee = Y - C;
        for (const Ve of O)
          Ve.position = {
            x: Ve.position.x - Ce + X[0] * (B - I),
            y: Ve.position.y - Ee + X[1] * (q - M)
          }, U.push(Ve);
      }
      if ((J || oe) && (D.width = J ? B : m.width, D.height = oe ? q : m.height, m.width = D.width, m.height = D.height), x && A.expandParent) {
        const Ce = X[0] * (D.width ?? 0);
        D.x && D.x < Ce && (m.x = Ce, v.x = v.x - (D.x - Ce));
        const Ee = X[1] * (D.height ?? 0);
        D.y && D.y < Ee && (m.y = Ee, v.y = v.y - (D.y - Ee));
      }
      const $ = tmt({
        width: m.width,
        prevWidth: I,
        height: m.height,
        prevHeight: M,
        affectsX: b.affectsX,
        affectsY: b.affectsY
      }), pe = { ...m, direction: $ };
      (h == null ? void 0 : h(T, pe)) !== !1 && (d == null || d(T, pe), r(D, U));
    }).on("end", (T) => {
      p == null || p(T, { ...m }), i == null || i();
    });
    o.call(k);
  }
  function l() {
    o.on(".drag", null);
  }
  return {
    update: s,
    destroy: l
  };
}
const { useDebugValue: lmt } = ie, { useSyncExternalStoreWithSelector: cmt } = WAe, umt = (e) => e;
function rEe(e, t = umt, n) {
  const r = cmt(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return lmt(r), r;
}
const toe = (e, t) => {
  const n = BAe(e), r = (i, o = t) => rEe(n, i, o);
  return Object.assign(r, n), r;
}, dmt = (e, t) => e ? toe(e, t) : toe;
function Ii(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size) return !1;
    for (const [r, i] of e)
      if (!Object.is(i, t.get(r)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size) return !1;
    for (const r of e)
      if (!t.has(r))
        return !1;
    return !0;
  }
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !1;
  for (const r of n)
    if (!Object.prototype.hasOwnProperty.call(t, r) || !Object.is(e[r], t[r]))
      return !1;
  return !0;
}
const Xz = Ri(null), fmt = Xz.Provider, iEe = gu.error001();
function hr(e, t) {
  const n = kr(Xz);
  if (n === null)
    throw new Error(iEe);
  return rEe(n, e, t);
}
function mi() {
  const e = kr(Xz);
  if (e === null)
    throw new Error(iEe);
  return Kt(() => ({
    getState: e.getState,
    setState: e.setState,
    subscribe: e.subscribe
  }), [e]);
}
const noe = { display: "none" }, pmt = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0px, 0px, 0px, 0px)",
  clipPath: "inset(100%)"
}, oEe = "react-flow__node-desc", sEe = "react-flow__edge-desc", hmt = "react-flow__aria-live", mmt = (e) => e.ariaLiveMessage;
function gmt({ rfId: e }) {
  const t = hr(mmt);
  return y("div", { id: `${hmt}-${e}`, "aria-live": "assertive", "aria-atomic": "true", style: pmt, children: t });
}
function ymt({ rfId: e, disableKeyboardA11y: t }) {
  return V(pt, { children: [V("div", { id: `${oEe}-${e}`, style: noe, children: ["Press enter or space to select a node.", !t && "You can then use the arrow keys to move the node around.", " Press delete to remove it and escape to cancel.", " "] }), y("div", { id: `${sEe}-${e}`, style: noe, children: "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel." }), !t && y(gmt, { rfId: e })] });
}
const vmt = (e) => e.userSelectionActive ? "none" : "all";
function UQ({ position: e = "top-left", children: t, className: n, style: r, ...i }) {
  const o = hr(vmt), s = `${e}`.split("-");
  return y("div", { className: xo(["react-flow__panel", n, ...s]), style: { ...r, pointerEvents: o }, ...i, children: t });
}
function bmt({ proOptions: e, position: t = "bottom-right" }) {
  return e != null && e.hideAttribution ? null : y(UQ, { position: t, className: "react-flow__attribution", "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://pro.reactflow.dev", children: y("a", { href: "https://reactflow.dev", target: "_blank", rel: "noopener noreferrer", "aria-label": "React Flow attribution", children: "React Flow" }) });
}
const Omt = (e) => {
  const t = [], n = [];
  for (const [, r] of e.nodeLookup)
    r.selected && t.push(r.internals.userNode);
  for (const [, r] of e.edgeLookup)
    r.selected && n.push(r);
  return { selectedNodes: t, selectedEdges: n };
}, _P = (e) => e.id;
function Amt(e, t) {
  return Ii(e.selectedNodes.map(_P), t.selectedNodes.map(_P)) && Ii(e.selectedEdges.map(_P), t.selectedEdges.map(_P));
}
function wmt({ onSelectionChange: e }) {
  const t = mi(), { selectedNodes: n, selectedEdges: r } = hr(Omt, Amt);
  return nt(() => {
    const i = { nodes: n, edges: r };
    e == null || e(i), t.getState().onSelectionChangeHandlers.forEach((o) => o(i));
  }, [n, r, e]), null;
}
const xmt = (e) => !!e.onSelectionChangeHandlers;
function Smt({ onSelectionChange: e }) {
  const t = hr(xmt);
  return e || t ? y(wmt, { onSelectionChange: e }) : null;
}
const aEe = [0, 0], Emt = { x: 0, y: 0, zoom: 1 }, Tmt = [
  "nodes",
  "edges",
  "defaultNodes",
  "defaultEdges",
  "onConnect",
  "onConnectStart",
  "onConnectEnd",
  "onClickConnectStart",
  "onClickConnectEnd",
  "nodesDraggable",
  "nodesConnectable",
  "nodesFocusable",
  "edgesFocusable",
  "edgesReconnectable",
  "elevateNodesOnSelect",
  "elevateEdgesOnSelect",
  "minZoom",
  "maxZoom",
  "nodeExtent",
  "onNodesChange",
  "onEdgesChange",
  "elementsSelectable",
  "connectionMode",
  "snapGrid",
  "snapToGrid",
  "translateExtent",
  "connectOnClick",
  "defaultEdgeOptions",
  "fitView",
  "fitViewOptions",
  "onNodesDelete",
  "onEdgesDelete",
  "onDelete",
  "onNodeDrag",
  "onNodeDragStart",
  "onNodeDragStop",
  "onSelectionDrag",
  "onSelectionDragStart",
  "onSelectionDragStop",
  "onMoveStart",
  "onMove",
  "onMoveEnd",
  "noPanClassName",
  "nodeOrigin",
  "autoPanOnConnect",
  "autoPanOnNodeDrag",
  "onError",
  "connectionRadius",
  "isValidConnection",
  "selectNodesOnDrag",
  "nodeDragThreshold",
  "onBeforeDelete",
  "debug",
  "autoPanSpeed",
  "paneClickDistance"
], roe = [...Tmt, "rfId"], kmt = (e) => ({
  setNodes: e.setNodes,
  setEdges: e.setEdges,
  setMinZoom: e.setMinZoom,
  setMaxZoom: e.setMaxZoom,
  setTranslateExtent: e.setTranslateExtent,
  setNodeExtent: e.setNodeExtent,
  reset: e.reset,
  setDefaultNodesAndEdges: e.setDefaultNodesAndEdges,
  setPaneClickDistance: e.setPaneClickDistance
}), ioe = {
  // these are values that are also passed directly to other components
  // than the StoreUpdater. We can reduce the number of setStore calls
  // by setting the same values here as prev fields.
  translateExtent: jT,
  nodeOrigin: aEe,
  minZoom: 0.5,
  maxZoom: 2,
  elementsSelectable: !0,
  noPanClassName: "nopan",
  rfId: "1",
  paneClickDistance: 0
};
function Cmt(e) {
  const { setNodes: t, setEdges: n, setMinZoom: r, setMaxZoom: i, setTranslateExtent: o, setNodeExtent: s, reset: l, setDefaultNodesAndEdges: c, setPaneClickDistance: a } = hr(kmt, Ii), u = mi();
  nt(() => (c(e.defaultNodes, e.defaultEdges), () => {
    f.current = ioe, l();
  }), []);
  const f = Xe(ioe);
  return nt(
    () => {
      for (const d of roe) {
        const p = e[d], h = f.current[d];
        p !== h && (typeof e[d] > "u" || (d === "nodes" ? t(p) : d === "edges" ? n(p) : d === "minZoom" ? r(p) : d === "maxZoom" ? i(p) : d === "translateExtent" ? o(p) : d === "nodeExtent" ? s(p) : d === "paneClickDistance" ? a(p) : d === "fitView" ? u.setState({ fitViewOnInit: p }) : d === "fitViewOptions" ? u.setState({ fitViewOnInitOptions: p }) : u.setState({ [d]: p })));
      }
      f.current = e;
    },
    // Only re-run the effect if one of the fields we track changes
    roe.map((d) => e[d])
  ), null;
}
function ooe() {
  return typeof window > "u" || !window.matchMedia ? null : window.matchMedia("(prefers-color-scheme: dark)");
}
function Nmt(e) {
  var r;
  const [t, n] = He(e === "system" ? null : e);
  return nt(() => {
    if (e !== "system") {
      n(e);
      return;
    }
    const i = ooe(), o = () => n(i != null && i.matches ? "dark" : "light");
    return o(), i == null || i.addEventListener("change", o), () => {
      i == null || i.removeEventListener("change", o);
    };
  }, [e]), t !== null ? t : (r = ooe()) != null && r.matches ? "dark" : "light";
}
const soe = typeof document < "u" ? document : null;
function rg(e = null, t = { target: soe, actInsideInputWithModifier: !0 }) {
  const [n, r] = He(!1), i = Xe(!1), o = Xe(/* @__PURE__ */ new Set([])), [s, l] = Kt(() => {
    if (e !== null) {
      const a = (Array.isArray(e) ? e : [e]).filter((f) => typeof f == "string").map((f) => f.replace("+", `
`).replace(`

`, `
+`).split(`
`)), u = a.reduce((f, d) => f.concat(...d), []);
      return [a, u];
    }
    return [[], []];
  }, [e]);
  return nt(() => {
    const c = (t == null ? void 0 : t.target) || soe;
    if (e !== null) {
      const a = (d) => {
        if (i.current = d.ctrlKey || d.metaKey || d.shiftKey, (!i.current || i.current && !t.actInsideInputWithModifier) && jB(d))
          return !1;
        const h = loe(d.code, l);
        o.current.add(d[h]), aoe(s, o.current, !1) && (d.preventDefault(), r(!0));
      }, u = (d) => {
        if ((!i.current || i.current && !t.actInsideInputWithModifier) && jB(d))
          return !1;
        const h = loe(d.code, l);
        aoe(s, o.current, !0) ? (r(!1), o.current.clear()) : o.current.delete(d[h]), d.key === "Meta" && o.current.clear(), i.current = !1;
      }, f = () => {
        o.current.clear(), r(!1);
      };
      return c == null || c.addEventListener("keydown", a), c == null || c.addEventListener("keyup", u), window.addEventListener("blur", f), window.addEventListener("contextmenu", f), () => {
        c == null || c.removeEventListener("keydown", a), c == null || c.removeEventListener("keyup", u), window.removeEventListener("blur", f), window.removeEventListener("contextmenu", f);
      };
    }
  }, [e, r]), n;
}
function aoe(e, t, n) {
  return e.filter((r) => n || r.length === t.size).some((r) => r.every((i) => t.has(i)));
}
function loe(e, t) {
  return t.includes(e) ? "code" : "key";
}
const Pmt = () => {
  const e = mi();
  return Kt(() => ({
    zoomIn: (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1.2, { duration: t == null ? void 0 : t.duration }) : Promise.resolve(!1);
    },
    zoomOut: (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1 / 1.2, { duration: t == null ? void 0 : t.duration }) : Promise.resolve(!1);
    },
    zoomTo: (t, n) => {
      const { panZoom: r } = e.getState();
      return r ? r.scaleTo(t, { duration: n == null ? void 0 : n.duration }) : Promise.resolve(!1);
    },
    getZoom: () => e.getState().transform[2],
    setViewport: async (t, n) => {
      const { transform: [r, i, o], panZoom: s } = e.getState();
      return s ? (await s.setViewport({
        x: t.x ?? r,
        y: t.y ?? i,
        zoom: t.zoom ?? o
      }, { duration: n == null ? void 0 : n.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    getViewport: () => {
      const [t, n, r] = e.getState().transform;
      return { x: t, y: n, zoom: r };
    },
    fitView: (t) => {
      const { nodeLookup: n, minZoom: r, maxZoom: i, panZoom: o, domNode: s } = e.getState();
      if (!o || !s)
        return Promise.resolve(!1);
      const l = _B(n, t), { width: c, height: a } = qz(s);
      return LB({
        nodes: l,
        width: c,
        height: a,
        minZoom: r,
        maxZoom: i,
        panZoom: o
      }, t);
    },
    setCenter: async (t, n, r) => {
      const { width: i, height: o, maxZoom: s, panZoom: l } = e.getState(), c = typeof (r == null ? void 0 : r.zoom) < "u" ? r.zoom : s, a = i / 2 - t * c, u = o / 2 - n * c;
      return l ? (await l.setViewport({
        x: a,
        y: u,
        zoom: c
      }, { duration: r == null ? void 0 : r.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    fitBounds: async (t, n) => {
      const { width: r, height: i, minZoom: o, maxZoom: s, panZoom: l } = e.getState(), c = _Q(t, r, i, o, s, (n == null ? void 0 : n.padding) ?? 0.1);
      return l ? (await l.setViewport(c, { duration: n == null ? void 0 : n.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    screenToFlowPosition: (t, n = { snapToGrid: !0 }) => {
      const { transform: r, snapGrid: i, domNode: o } = e.getState();
      if (!o)
        return t;
      const { x: s, y: l } = o.getBoundingClientRect(), c = {
        x: t.x - s,
        y: t.y - l
      };
      return oN(c, r, n.snapToGrid, i);
    },
    flowToScreenPosition: (t) => {
      const { transform: n, domNode: r } = e.getState();
      if (!r)
        return t;
      const { x: i, y: o } = r.getBoundingClientRect(), s = j1e(t, n);
      return {
        x: s.x + i,
        y: s.y + o
      };
    }
  }), []);
};
function lEe(e, t) {
  const n = [], r = /* @__PURE__ */ new Map(), i = [];
  for (const o of e)
    if (o.type === "add") {
      i.push(o);
      continue;
    } else if (o.type === "remove" || o.type === "replace")
      r.set(o.id, [o]);
    else {
      const s = r.get(o.id);
      s ? s.push(o) : r.set(o.id, [o]);
    }
  for (const o of t) {
    const s = r.get(o.id);
    if (!s) {
      n.push(o);
      continue;
    }
    if (s[0].type === "remove")
      continue;
    if (s[0].type === "replace") {
      n.push({ ...s[0].item });
      continue;
    }
    const l = { ...o };
    for (const c of s)
      Imt(c, l);
    n.push(l);
  }
  return i.length && i.forEach((o) => {
    o.index !== void 0 ? n.splice(o.index, 0, { ...o.item }) : n.push({ ...o.item });
  }), n;
}
function Imt(e, t) {
  switch (e.type) {
    case "select": {
      t.selected = e.selected;
      break;
    }
    case "position": {
      typeof e.position < "u" && (t.position = e.position), typeof e.dragging < "u" && (t.dragging = e.dragging);
      break;
    }
    case "dimensions": {
      typeof e.dimensions < "u" && (t.measured ?? (t.measured = {}), t.measured.width = e.dimensions.width, t.measured.height = e.dimensions.height, e.setAttributes && (t.width = e.dimensions.width, t.height = e.dimensions.height)), typeof e.resizing == "boolean" && (t.resizing = e.resizing);
      break;
    }
  }
}
function Rmt(e, t) {
  return lEe(e, t);
}
function Mmt(e, t) {
  return lEe(e, t);
}
function fy(e, t) {
  return {
    id: e,
    type: "select",
    selected: t
  };
}
function AO(e, t = /* @__PURE__ */ new Set(), n = !1) {
  const r = [];
  for (const [i, o] of e) {
    const s = t.has(i);
    !(o.selected === void 0 && !s) && o.selected !== s && (n && (o.selected = s), r.push(fy(o.id, s)));
  }
  return r;
}
function coe({ items: e = [], lookup: t }) {
  var i;
  const n = [], r = new Map(e.map((o) => [o.id, o]));
  for (const [o, s] of e.entries()) {
    const l = t.get(s.id), c = ((i = l == null ? void 0 : l.internals) == null ? void 0 : i.userNode) ?? l;
    c !== void 0 && c !== s && n.push({ id: s.id, item: s, type: "replace" }), c === void 0 && n.push({ item: s, type: "add", index: o });
  }
  for (const [o] of t)
    r.get(o) === void 0 && n.push({ id: o, type: "remove" });
  return n;
}
function uoe(e) {
  return {
    id: e.id,
    type: "remove"
  };
}
const doe = (e) => bht(e), Dmt = (e) => P1e(e);
function cEe(e) {
  return Fo(e);
}
const _mt = typeof window < "u" ? Og : nt;
function foe(e) {
  const [t, n] = He(BigInt(0)), [r] = He(() => Lmt(() => n((i) => i + BigInt(1))));
  return _mt(() => {
    const i = r.get();
    i.length && (e(i), r.reset());
  }, [t]), r;
}
function Lmt(e) {
  let t = [];
  return {
    get: () => t,
    reset: () => {
      t = [];
    },
    push: (n) => {
      t.push(n), e();
    }
  };
}
const uEe = Ri(null);
function zmt({ children: e }) {
  const t = mi(), n = qn((l) => {
    const { nodes: c = [], setNodes: a, hasDefaultNodes: u, onNodesChange: f, nodeLookup: d } = t.getState();
    let p = c;
    for (const h of l)
      p = typeof h == "function" ? h(p) : h;
    u ? a(p) : f && f(coe({
      items: p,
      lookup: d
    }));
  }, []), r = foe(n), i = qn((l) => {
    const { edges: c = [], setEdges: a, hasDefaultEdges: u, onEdgesChange: f, edgeLookup: d } = t.getState();
    let p = c;
    for (const h of l)
      p = typeof h == "function" ? h(p) : h;
    u ? a(p) : f && f(coe({
      items: p,
      lookup: d
    }));
  }, []), o = foe(i), s = Kt(() => ({ nodeQueue: r, edgeQueue: o }), []);
  return y(uEe.Provider, { value: s, children: e });
}
function jmt() {
  const e = kr(uEe);
  if (!e)
    throw new Error("useBatchContext must be used within a BatchProvider");
  return e;
}
const Fmt = (e) => !!e.panZoom;
function yd() {
  const e = Pmt(), t = mi(), n = jmt(), r = hr(Fmt), i = Kt(() => {
    const o = (f) => t.getState().nodeLookup.get(f), s = (f) => {
      n.nodeQueue.push(f);
    }, l = (f) => {
      n.edgeQueue.push(f);
    }, c = (f) => {
      var b, A;
      const { nodeLookup: d, nodeOrigin: p } = t.getState(), h = doe(f) ? f : d.get(f.id), m = h.parentId ? U1e(h.position, h.measured, h.parentId, d, p) : h.position, v = {
        id: h.id,
        position: m,
        width: ((b = h.measured) == null ? void 0 : b.width) ?? h.width,
        height: ((A = h.measured) == null ? void 0 : A.height) ?? h.height,
        data: h.data
      };
      return iw(v);
    }, a = (f, d, p = { replace: !1 }) => {
      s((h) => h.map((m) => {
        if (m.id === f) {
          const v = typeof d == "function" ? d(m) : d;
          return p.replace && doe(v) ? v : { ...m, ...v };
        }
        return m;
      }));
    }, u = (f, d, p = { replace: !1 }) => {
      l((h) => h.map((m) => {
        if (m.id === f) {
          const v = typeof d == "function" ? d(m) : d;
          return p.replace && Dmt(v) ? v : { ...m, ...v };
        }
        return m;
      }));
    };
    return {
      getNodes: () => t.getState().nodes.map((f) => ({ ...f })),
      getNode: (f) => {
        var d;
        return (d = o(f)) == null ? void 0 : d.internals.userNode;
      },
      getInternalNode: o,
      getEdges: () => {
        const { edges: f = [] } = t.getState();
        return f.map((d) => ({ ...d }));
      },
      getEdge: (f) => t.getState().edgeLookup.get(f),
      setNodes: s,
      setEdges: l,
      addNodes: (f) => {
        const d = Array.isArray(f) ? f : [f];
        n.nodeQueue.push((p) => [...p, ...d]);
      },
      addEdges: (f) => {
        const d = Array.isArray(f) ? f : [f];
        n.edgeQueue.push((p) => [...p, ...d]);
      },
      toObject: () => {
        const { nodes: f = [], edges: d = [], transform: p } = t.getState(), [h, m, v] = p;
        return {
          nodes: f.map((b) => ({ ...b })),
          edges: d.map((b) => ({ ...b })),
          viewport: {
            x: h,
            y: m,
            zoom: v
          }
        };
      },
      deleteElements: async ({ nodes: f = [], edges: d = [] }) => {
        const { nodes: p, edges: h, onNodesDelete: m, onEdgesDelete: v, triggerNodeChanges: b, triggerEdgeChanges: A, onDelete: w, onBeforeDelete: O } = t.getState(), { nodes: x, edges: S } = await Aht({
          nodesToRemove: f,
          edgesToRemove: d,
          nodes: p,
          edges: h,
          onBeforeDelete: O
        }), E = S.length > 0, k = x.length > 0;
        if (E) {
          const T = S.map(uoe);
          v == null || v(S), A(T);
        }
        if (k) {
          const T = x.map(uoe);
          m == null || m(x), b(T);
        }
        return (k || E) && (w == null || w({ nodes: x, edges: S })), { deletedNodes: x, deletedEdges: S };
      },
      getIntersectingNodes: (f, d = !0, p) => {
        const h = Wie(f), m = h ? f : c(f), v = p !== void 0;
        return m ? (p || t.getState().nodes).filter((b) => {
          const A = t.getState().nodeLookup.get(b.id);
          if (A && !h && (b.id === f.id || !A.internals.positionAbsolute))
            return !1;
          const w = iw(v ? b : A), O = FT(w, m);
          return d && O > 0 || O >= m.width * m.height;
        }) : [];
      },
      isNodeIntersecting: (f, d, p = !0) => {
        const m = Wie(f) ? f : c(f);
        if (!m)
          return !1;
        const v = FT(m, d);
        return p && v > 0 || v >= m.width * m.height;
      },
      updateNode: a,
      updateNodeData: (f, d, p = { replace: !1 }) => {
        a(f, (h) => {
          const m = typeof d == "function" ? d(h) : d;
          return p.replace ? { ...h, data: m } : { ...h, data: { ...h.data, ...m } };
        }, p);
      },
      updateEdge: u,
      updateEdgeData: (f, d, p = { replace: !1 }) => {
        u(f, (h) => {
          const m = typeof d == "function" ? d(h) : d;
          return p.replace ? { ...h, data: m } : { ...h, data: { ...h.data, ...m } };
        }, p);
      },
      getNodesBounds: (f) => {
        const { nodeLookup: d, nodeOrigin: p } = t.getState();
        return I1e(f, { nodeLookup: d, nodeOrigin: p });
      },
      getHandleConnections: ({ type: f, id: d, nodeId: p }) => {
        var h;
        return Array.from(((h = t.getState().connectionLookup.get(`${p}-${f}-${d ?? null}`)) == null ? void 0 : h.values()) ?? []);
      }
    };
  }, []);
  return Kt(() => ({
    ...i,
    ...e,
    viewportInitialized: r
  }), [r]);
}
const poe = (e) => e.selected, Umt = { actInsideInputWithModifier: !1 }, Vmt = typeof window < "u" ? window : void 0;
function qmt({ deleteKeyCode: e, multiSelectionKeyCode: t }) {
  const n = mi(), { deleteElements: r } = yd(), i = rg(e, Umt), o = rg(t, { target: Vmt });
  nt(() => {
    if (i) {
      const { edges: s, nodes: l } = n.getState();
      r({ nodes: l.filter(poe), edges: s.filter(poe) }), n.setState({ nodesSelectionActive: !1 });
    }
  }, [i]), nt(() => {
    n.setState({ multiSelectionActive: o });
  }, [o]);
}
function Bmt(e) {
  const t = mi();
  nt(() => {
    const n = () => {
      var i, o;
      if (!e.current)
        return !1;
      const r = qz(e.current);
      (r.height === 0 || r.width === 0) && ((o = (i = t.getState()).onError) == null || o.call(i, "004", gu.error004())), t.setState({ width: r.width || 500, height: r.height || 500 });
    };
    if (e.current) {
      n(), window.addEventListener("resize", n);
      const r = new ResizeObserver(() => n());
      return r.observe(e.current), () => {
        window.removeEventListener("resize", n), r && e.current && r.unobserve(e.current);
      };
    }
  }, []);
}
const Wz = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
}, Xmt = (e) => ({
  userSelectionActive: e.userSelectionActive,
  lib: e.lib
});
function Wmt({ onPaneContextMenu: e, zoomOnScroll: t = !0, zoomOnPinch: n = !0, panOnScroll: r = !1, panOnScrollSpeed: i = 0.5, panOnScrollMode: o = Bm.Free, zoomOnDoubleClick: s = !0, panOnDrag: l = !0, defaultViewport: c, translateExtent: a, minZoom: u, maxZoom: f, zoomActivationKeyCode: d, preventScrolling: p = !0, children: h, noWheelClassName: m, noPanClassName: v, onViewportChange: b, isControlledViewport: A, paneClickDistance: w }) {
  const O = mi(), x = Xe(null), { userSelectionActive: S, lib: E } = hr(Xmt, Ii), k = rg(d), T = Xe();
  Bmt(x);
  const R = qn((j) => {
    b == null || b({ x: j[0], y: j[1], zoom: j[2] }), A || O.setState({ transform: j });
  }, [b, A]);
  return nt(() => {
    if (x.current) {
      T.current = emt({
        domNode: x.current,
        minZoom: u,
        maxZoom: f,
        translateExtent: a,
        viewport: c,
        paneClickDistance: w,
        onDraggingChange: (_) => O.setState({ paneDragging: _ }),
        onPanZoomStart: (_, U) => {
          const { onViewportChangeStart: z, onMoveStart: C } = O.getState();
          C == null || C(_, U), z == null || z(U);
        },
        onPanZoom: (_, U) => {
          const { onViewportChange: z, onMove: C } = O.getState();
          C == null || C(_, U), z == null || z(U);
        },
        onPanZoomEnd: (_, U) => {
          const { onViewportChangeEnd: z, onMoveEnd: C } = O.getState();
          C == null || C(_, U), z == null || z(U);
        }
      });
      const { x: j, y: F, zoom: L } = T.current.getViewport();
      return O.setState({
        panZoom: T.current,
        transform: [j, F, L],
        domNode: x.current.closest(".react-flow")
      }), () => {
        var _;
        (_ = T.current) == null || _.destroy();
      };
    }
  }, []), nt(() => {
    var j;
    (j = T.current) == null || j.update({
      onPaneContextMenu: e,
      zoomOnScroll: t,
      zoomOnPinch: n,
      panOnScroll: r,
      panOnScrollSpeed: i,
      panOnScrollMode: o,
      zoomOnDoubleClick: s,
      panOnDrag: l,
      zoomActivationKeyPressed: k,
      preventScrolling: p,
      noPanClassName: v,
      userSelectionActive: S,
      noWheelClassName: m,
      lib: E,
      onTransformChange: R
    });
  }, [
    e,
    t,
    n,
    r,
    i,
    o,
    s,
    l,
    k,
    p,
    v,
    S,
    m,
    E,
    R
  ]), y("div", { className: "react-flow__renderer", ref: x, style: Wz, children: h });
}
const Zmt = (e) => ({
  userSelectionActive: e.userSelectionActive,
  userSelectionRect: e.userSelectionRect
});
function Hmt() {
  const { userSelectionActive: e, userSelectionRect: t } = hr(Zmt, Ii);
  return e && t ? y("div", { className: "react-flow__selection react-flow__container", style: {
    width: t.width,
    height: t.height,
    transform: `translate(${t.x}px, ${t.y}px)`
  } }) : null;
}
const v6 = (e, t) => (n) => {
  n.target === t.current && (e == null || e(n));
}, Qmt = (e) => ({
  userSelectionActive: e.userSelectionActive,
  elementsSelectable: e.elementsSelectable,
  dragging: e.paneDragging
});
function $mt({ isSelecting: e, selectionKeyPressed: t, selectionMode: n = nw.Full, panOnDrag: r, selectionOnDrag: i, onSelectionStart: o, onSelectionEnd: s, onPaneClick: l, onPaneContextMenu: c, onPaneScroll: a, onPaneMouseEnter: u, onPaneMouseMove: f, onPaneMouseLeave: d, children: p }) {
  const h = Xe(null), m = mi(), v = Xe(0), b = Xe(0), A = Xe(), w = Xe(/* @__PURE__ */ new Map()), { userSelectionActive: O, elementsSelectable: x, dragging: S } = hr(Qmt, Ii), E = x && (e || O), k = Xe(!1), T = Xe(!1), R = () => {
    m.setState({ userSelectionActive: !1, userSelectionRect: null }), v.current = 0, b.current = 0;
  }, j = (I) => {
    if (k.current) {
      k.current = !1;
      return;
    }
    l == null || l(I), m.getState().resetSelectedElements(), m.setState({ nodesSelectionActive: !1 });
  }, F = (I) => {
    if (Array.isArray(r) && (r != null && r.includes(2))) {
      I.preventDefault();
      return;
    }
    c == null || c(I);
  }, L = a ? (I) => a(I) : void 0, _ = (I) => {
    var H, Y, J, oe;
    const { resetSelectedElements: M, domNode: D, edgeLookup: X } = m.getState();
    if (A.current = D == null ? void 0 : D.getBoundingClientRect(), !x || !e || I.button !== 0 || I.target !== h.current || !A.current)
      return;
    (Y = (H = I.target) == null ? void 0 : H.setPointerCapture) == null || Y.call(H, I.pointerId), T.current = !0, k.current = !1, w.current = /* @__PURE__ */ new Map();
    for (const [ce, fe] of X)
      w.current.set(fe.source, ((J = w.current.get(fe.source)) == null ? void 0 : J.add(ce)) || /* @__PURE__ */ new Set([ce])), w.current.set(fe.target, ((oe = w.current.get(fe.target)) == null ? void 0 : oe.add(ce)) || /* @__PURE__ */ new Set([ce]));
    const { x: B, y: q } = Gp(I.nativeEvent, A.current);
    M(), m.setState({
      userSelectionRect: {
        width: 0,
        height: 0,
        startX: B,
        startY: q,
        x: B,
        y: q
      }
    }), o == null || o(I);
  }, U = (I) => {
    const { userSelectionRect: M, edgeLookup: D, transform: X, nodeLookup: B, triggerNodeChanges: q, triggerEdgeChanges: H } = m.getState();
    if (!A.current || !M)
      return;
    k.current = !0;
    const { x: Y, y: J } = Gp(I.nativeEvent, A.current), { startX: oe, startY: ce } = M, fe = {
      startX: oe,
      startY: ce,
      x: Y < oe ? Y : oe,
      y: J < ce ? J : ce,
      width: Math.abs(Y - oe),
      height: Math.abs(J - ce)
    }, $ = R1e(B, fe, X, n === nw.Partial, !0), pe = /* @__PURE__ */ new Set(), ee = /* @__PURE__ */ new Set();
    for (const Ce of $) {
      ee.add(Ce.id);
      const Ee = w.current.get(Ce.id);
      if (Ee)
        for (const Ve of Ee)
          pe.add(Ve);
    }
    if (v.current !== ee.size) {
      v.current = ee.size;
      const Ce = AO(B, ee, !0);
      q(Ce);
    }
    if (b.current !== pe.size) {
      b.current = pe.size;
      const Ce = AO(D, pe);
      H(Ce);
    }
    m.setState({
      userSelectionRect: fe,
      userSelectionActive: !0,
      nodesSelectionActive: !1
    });
  }, z = (I) => {
    var D, X;
    if (I.button !== 0 || !T.current)
      return;
    (X = (D = I.target) == null ? void 0 : D.releasePointerCapture) == null || X.call(D, I.pointerId);
    const { userSelectionRect: M } = m.getState();
    !O && M && I.target === h.current && (j == null || j(I)), v.current > 0 && m.setState({ nodesSelectionActive: !0 }), R(), s == null || s(I), (t || i) && (k.current = !1), T.current = !1;
  }, C = r === !0 || Array.isArray(r) && r.includes(0);
  return V("div", { className: xo(["react-flow__pane", { draggable: C, dragging: S, selection: e }]), onClick: E ? void 0 : v6(j, h), onContextMenu: v6(F, h), onWheel: v6(L, h), onPointerEnter: E ? void 0 : u, onPointerDown: E ? _ : f, onPointerMove: E ? U : f, onPointerUp: E ? z : void 0, onPointerLeave: d, ref: h, style: Wz, children: [p, y(Hmt, {})] });
}
function BB({ id: e, store: t, unselect: n = !1, nodeRef: r }) {
  const { addSelectedNodes: i, unselectNodesAndEdges: o, multiSelectionActive: s, nodeLookup: l, onError: c } = t.getState(), a = l.get(e);
  if (!a) {
    c == null || c("012", gu.error012(e));
    return;
  }
  t.setState({ nodesSelectionActive: !1 }), a.selected ? (n || a.selected && s) && (o({ nodes: [a], edges: [] }), requestAnimationFrame(() => {
    var u;
    return (u = r == null ? void 0 : r.current) == null ? void 0 : u.blur();
  })) : i([e]);
}
function dEe({ nodeRef: e, disabled: t = !1, noDragClassName: n, handleSelector: r, nodeId: i, isSelectable: o, nodeClickDistance: s }) {
  const l = mi(), [c, a] = He(!1), u = Xe();
  return nt(() => {
    u.current = Uht({
      getStoreItems: () => l.getState(),
      onNodeMouseDown: (f) => {
        BB({
          id: f,
          store: l,
          nodeRef: e
        });
      },
      onDragStart: () => {
        a(!0);
      },
      onDragStop: () => {
        a(!1);
      }
    });
  }, []), nt(() => {
    var f, d;
    if (t)
      (f = u.current) == null || f.destroy();
    else if (e.current)
      return (d = u.current) == null || d.update({
        noDragClassName: n,
        handleSelector: r,
        domNode: e.current,
        isSelectable: o,
        nodeId: i,
        nodeClickDistance: s
      }), () => {
        var p;
        (p = u.current) == null || p.destroy();
      };
  }, [n, r, t, o, e, i]), c;
}
const Kmt = (e) => (t) => t.selected && (t.draggable || e && typeof t.draggable > "u");
function fEe() {
  const e = mi();
  return qn((n) => {
    const { nodeExtent: r, snapToGrid: i, snapGrid: o, nodesDraggable: s, onError: l, updateNodePositions: c, nodeLookup: a, nodeOrigin: u } = e.getState(), f = /* @__PURE__ */ new Map(), d = Kmt(s), p = i ? o[0] : 5, h = i ? o[1] : 5, m = n.direction.x * p * n.factor, v = n.direction.y * h * n.factor;
    for (const [, b] of a) {
      if (!d(b))
        continue;
      let A = {
        x: b.internals.positionAbsolute.x + m,
        y: b.internals.positionAbsolute.y + v
      };
      i && (A = Vz(A, o));
      const { position: w, positionAbsolute: O } = M1e({
        nodeId: b.id,
        nextPosition: A,
        nodeLookup: a,
        nodeExtent: r,
        nodeOrigin: u,
        onError: l
      });
      b.position = w, b.internals.positionAbsolute = O, f.set(b.id, b);
    }
    c(f);
  }, []);
}
const VQ = Ri(null), Gmt = VQ.Provider;
VQ.Consumer;
const pEe = () => kr(VQ), Ymt = (e) => ({
  connectOnClick: e.connectOnClick,
  noPanClassName: e.noPanClassName,
  rfId: e.rfId
}), Jmt = (e, t, n) => (r) => {
  const { connectionClickStartHandle: i, connectionMode: o, connection: s } = r, { fromHandle: l, toHandle: c, isValid: a } = s, u = (c == null ? void 0 : c.nodeId) === e && (c == null ? void 0 : c.id) === t && (c == null ? void 0 : c.type) === n;
  return {
    connectingFrom: (l == null ? void 0 : l.nodeId) === e && (l == null ? void 0 : l.id) === t && (l == null ? void 0 : l.type) === n,
    connectingTo: u,
    clickConnecting: (i == null ? void 0 : i.nodeId) === e && (i == null ? void 0 : i.id) === t && (i == null ? void 0 : i.type) === n,
    isPossibleEndHandle: o === tw.Strict ? (l == null ? void 0 : l.type) !== n : e !== (l == null ? void 0 : l.nodeId) || t !== (l == null ? void 0 : l.id),
    connectionInProcess: !!l,
    valid: u && a
  };
};
function egt({ type: e = "source", position: t = sn.Top, isValidConnection: n, isConnectable: r = !0, isConnectableStart: i = !0, isConnectableEnd: o = !0, id: s, onConnect: l, children: c, className: a, onMouseDown: u, onTouchStart: f, ...d }, p) {
  var _, U;
  const h = s || null, m = e === "target", v = mi(), b = pEe(), { connectOnClick: A, noPanClassName: w, rfId: O } = hr(Ymt, Ii), { connectingFrom: x, connectingTo: S, clickConnecting: E, isPossibleEndHandle: k, connectionInProcess: T, valid: R } = hr(Jmt(b, h, e), Ii);
  b || (U = (_ = v.getState()).onError) == null || U.call(_, "010", gu.error010());
  const j = (z) => {
    const { defaultEdgeOptions: C, onConnect: I, hasDefaultEdges: M } = v.getState(), D = {
      ...C,
      ...z
    };
    if (M) {
      const { edges: X, setEdges: B } = v.getState();
      B(kht(D, X));
    }
    I == null || I(D), l == null || l(D);
  }, F = (z) => {
    if (!b)
      return;
    const C = q1e(z.nativeEvent);
    if (i && (C && z.button === 0 || !C)) {
      const I = v.getState();
      qB.onPointerDown(z.nativeEvent, {
        autoPanOnConnect: I.autoPanOnConnect,
        connectionMode: I.connectionMode,
        connectionRadius: I.connectionRadius,
        domNode: I.domNode,
        nodeLookup: I.nodeLookup,
        lib: I.lib,
        isTarget: m,
        handleId: h,
        nodeId: b,
        flowId: I.rfId,
        panBy: I.panBy,
        cancelConnection: I.cancelConnection,
        onConnectStart: I.onConnectStart,
        onConnectEnd: I.onConnectEnd,
        updateConnection: I.updateConnection,
        onConnect: j,
        isValidConnection: n || I.isValidConnection,
        getTransform: () => v.getState().transform,
        getFromHandle: () => v.getState().connection.fromHandle,
        autoPanSpeed: I.autoPanSpeed
      });
    }
    C ? u == null || u(z) : f == null || f(z);
  }, L = (z) => {
    const { onClickConnectStart: C, onClickConnectEnd: I, connectionClickStartHandle: M, connectionMode: D, isValidConnection: X, lib: B, rfId: q, nodeLookup: H, connection: Y } = v.getState();
    if (!b || !M && !i)
      return;
    if (!M) {
      C == null || C(z.nativeEvent, { nodeId: b, handleId: h, handleType: e }), v.setState({ connectionClickStartHandle: { nodeId: b, type: e, id: h } });
      return;
    }
    const J = V1e(z.target), oe = n || X, { connection: ce, isValid: fe } = qB.isValid(z.nativeEvent, {
      handle: {
        nodeId: b,
        id: h,
        type: e
      },
      connectionMode: D,
      fromNodeId: M.nodeId,
      fromHandleId: M.id || null,
      fromType: M.type,
      isValidConnection: oe,
      flowId: q,
      doc: J,
      lib: B,
      nodeLookup: H
    });
    fe && ce && j(ce);
    const $ = structuredClone(Y);
    delete $.inProgress, $.toPosition = $.toHandle ? $.toHandle.position : null, I == null || I(z, $), v.setState({ connectionClickStartHandle: null });
  };
  return y("div", { "data-handleid": h, "data-nodeid": b, "data-handlepos": t, "data-id": `${O}-${b}-${h}-${e}`, className: xo([
    "react-flow__handle",
    `react-flow__handle-${t}`,
    "nodrag",
    w,
    a,
    {
      source: !m,
      target: m,
      connectable: r,
      connectablestart: i,
      connectableend: o,
      clickconnecting: E,
      connectingfrom: x,
      connectingto: S,
      valid: R,
      // shows where you can start a connection from
      // and where you can end it while connecting
      connectionindicator: r && (!T || k) && (T ? o : i)
    }
  ]), onMouseDown: F, onTouchStart: F, onClick: A ? L : void 0, ref: p, ...d, children: c });
}
const ou = Ji(cEe(egt));
function tgt({ data: e, isConnectable: t, sourcePosition: n = sn.Bottom }) {
  return V(pt, { children: [e == null ? void 0 : e.label, y(ou, { type: "source", position: n, isConnectable: t })] });
}
function ngt({ data: e, isConnectable: t, targetPosition: n = sn.Top, sourcePosition: r = sn.Bottom }) {
  return V(pt, { children: [y(ou, { type: "target", position: n, isConnectable: t }), e == null ? void 0 : e.label, y(ou, { type: "source", position: r, isConnectable: t })] });
}
function rgt() {
  return null;
}
function igt({ data: e, isConnectable: t, targetPosition: n = sn.Top }) {
  return V(pt, { children: [y(ou, { type: "target", position: n, isConnectable: t }), e == null ? void 0 : e.label] });
}
const OD = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
}, hoe = {
  input: tgt,
  default: ngt,
  output: igt,
  group: rgt
};
function ogt(e) {
  var t, n, r, i;
  return e.internals.handleBounds === void 0 ? {
    width: e.width ?? e.initialWidth ?? ((t = e.style) == null ? void 0 : t.width),
    height: e.height ?? e.initialHeight ?? ((n = e.style) == null ? void 0 : n.height)
  } : {
    width: e.width ?? ((r = e.style) == null ? void 0 : r.width),
    height: e.height ?? ((i = e.style) == null ? void 0 : i.height)
  };
}
const sgt = (e) => {
  const { width: t, height: n, x: r, y: i } = iN(e.nodeLookup, {
    filter: (o) => !!o.selected
  });
  return {
    width: Vu(t) ? t : null,
    height: Vu(n) ? n : null,
    userSelectionActive: e.userSelectionActive,
    transformString: `translate(${e.transform[0]}px,${e.transform[1]}px) scale(${e.transform[2]}) translate(${r}px,${i}px)`
  };
};
function agt({ onSelectionContextMenu: e, noPanClassName: t, disableKeyboardA11y: n }) {
  const r = mi(), { width: i, height: o, transformString: s, userSelectionActive: l } = hr(sgt, Ii), c = fEe(), a = Xe(null);
  if (nt(() => {
    var d;
    n || (d = a.current) == null || d.focus({
      preventScroll: !0
    });
  }, [n]), dEe({
    nodeRef: a
  }), l || !i || !o)
    return null;
  const u = e ? (d) => {
    const p = r.getState().nodes.filter((h) => h.selected);
    e(d, p);
  } : void 0, f = (d) => {
    Object.prototype.hasOwnProperty.call(OD, d.key) && c({
      direction: OD[d.key],
      factor: d.shiftKey ? 4 : 1
    });
  };
  return y("div", { className: xo(["react-flow__nodesselection", "react-flow__container", t]), style: {
    transform: s
  }, children: y("div", { ref: a, className: "react-flow__nodesselection-rect", onContextMenu: u, tabIndex: n ? void 0 : -1, onKeyDown: n ? void 0 : f, style: {
    width: i,
    height: o
  } }) });
}
const moe = typeof window < "u" ? window : void 0, lgt = (e) => ({ nodesSelectionActive: e.nodesSelectionActive, userSelectionActive: e.userSelectionActive });
function hEe({ children: e, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: i, onPaneContextMenu: o, onPaneScroll: s, paneClickDistance: l, deleteKeyCode: c, selectionKeyCode: a, selectionOnDrag: u, selectionMode: f, onSelectionStart: d, onSelectionEnd: p, multiSelectionKeyCode: h, panActivationKeyCode: m, zoomActivationKeyCode: v, elementsSelectable: b, zoomOnScroll: A, zoomOnPinch: w, panOnScroll: O, panOnScrollSpeed: x, panOnScrollMode: S, zoomOnDoubleClick: E, panOnDrag: k, defaultViewport: T, translateExtent: R, minZoom: j, maxZoom: F, preventScrolling: L, onSelectionContextMenu: _, noWheelClassName: U, noPanClassName: z, disableKeyboardA11y: C, onViewportChange: I, isControlledViewport: M }) {
  const { nodesSelectionActive: D, userSelectionActive: X } = hr(lgt), B = rg(a, { target: moe }), q = rg(m, { target: moe }), H = q || k, Y = q || O, J = u && H !== !0, oe = B || X || J;
  return qmt({ deleteKeyCode: c, multiSelectionKeyCode: h }), y(Wmt, { onPaneContextMenu: o, elementsSelectable: b, zoomOnScroll: A, zoomOnPinch: w, panOnScroll: Y, panOnScrollSpeed: x, panOnScrollMode: S, zoomOnDoubleClick: E, panOnDrag: !B && H, defaultViewport: T, translateExtent: R, minZoom: j, maxZoom: F, zoomActivationKeyCode: v, preventScrolling: L, noWheelClassName: U, noPanClassName: z, onViewportChange: I, isControlledViewport: M, paneClickDistance: l, children: V($mt, { onSelectionStart: d, onSelectionEnd: p, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: i, onPaneContextMenu: o, onPaneScroll: s, panOnDrag: H, isSelecting: !!oe, selectionMode: f, selectionKeyPressed: B, selectionOnDrag: J, children: [e, D && y(agt, { onSelectionContextMenu: _, noPanClassName: z, disableKeyboardA11y: C })] }) });
}
hEe.displayName = "FlowRenderer";
const cgt = Ji(hEe), ugt = (e) => (t) => e ? R1e(t.nodeLookup, { x: 0, y: 0, width: t.width, height: t.height }, t.transform, !0).map((n) => n.id) : Array.from(t.nodeLookup.keys());
function dgt(e) {
  return hr(qn(ugt(e), [e]), Ii);
}
const fgt = (e) => e.updateNodeInternals;
function pgt() {
  const e = hr(fgt), [t] = He(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((n) => {
    const r = /* @__PURE__ */ new Map();
    n.forEach((i) => {
      const o = i.target.getAttribute("data-id");
      r.set(o, {
        id: o,
        nodeElement: i.target,
        force: !0
      });
    }), e(r);
  }));
  return nt(() => () => {
    t == null || t.disconnect();
  }, [t]), t;
}
function hgt({ node: e, nodeType: t, hasDimensions: n, resizeObserver: r }) {
  const i = mi(), o = Xe(null), s = Xe(null), l = Xe(e.sourcePosition), c = Xe(e.targetPosition), a = Xe(t), u = n && !!e.internals.handleBounds;
  return nt(() => {
    o.current && !e.hidden && (!u || s.current !== o.current) && (s.current && (r == null || r.unobserve(s.current)), r == null || r.observe(o.current), s.current = o.current);
  }, [u, e.hidden]), nt(() => () => {
    s.current && (r == null || r.unobserve(s.current), s.current = null);
  }, []), nt(() => {
    if (o.current) {
      const f = a.current !== t, d = l.current !== e.sourcePosition, p = c.current !== e.targetPosition;
      (f || d || p) && (a.current = t, l.current = e.sourcePosition, c.current = e.targetPosition, i.getState().updateNodeInternals(/* @__PURE__ */ new Map([[e.id, { id: e.id, nodeElement: o.current, force: !0 }]])));
    }
  }, [e.id, t, e.sourcePosition, e.targetPosition]), o;
}
function mgt({ id: e, onClick: t, onMouseEnter: n, onMouseMove: r, onMouseLeave: i, onContextMenu: o, onDoubleClick: s, nodesDraggable: l, elementsSelectable: c, nodesConnectable: a, nodesFocusable: u, resizeObserver: f, noDragClassName: d, noPanClassName: p, disableKeyboardA11y: h, rfId: m, nodeTypes: v, nodeExtent: b, nodeClickDistance: A, onError: w }) {
  const { node: O, internals: x, isParent: S } = hr((ce) => {
    const fe = ce.nodeLookup.get(e), $ = ce.parentLookup.has(e);
    return {
      node: fe,
      internals: fe.internals,
      isParent: $
    };
  }, Ii);
  let E = O.type || "default", k = (v == null ? void 0 : v[E]) || hoe[E];
  k === void 0 && (w == null || w("003", gu.error003(E)), E = "default", k = hoe.default);
  const T = !!(O.draggable || l && typeof O.draggable > "u"), R = !!(O.selectable || c && typeof O.selectable > "u"), j = !!(O.connectable || a && typeof O.connectable > "u"), F = !!(O.focusable || u && typeof O.focusable > "u"), L = mi(), _ = F1e(O), U = hgt({ node: O, nodeType: E, hasDimensions: _, resizeObserver: f }), z = dEe({
    nodeRef: U,
    disabled: O.hidden || !T,
    noDragClassName: d,
    handleSelector: O.dragHandle,
    nodeId: e,
    isSelectable: R,
    nodeClickDistance: A
  }), C = fEe();
  if (O.hidden)
    return null;
  const I = Th(O), M = ogt(O), D = R || T || t || n || r || i, X = n ? (ce) => n(ce, { ...x.userNode }) : void 0, B = r ? (ce) => r(ce, { ...x.userNode }) : void 0, q = i ? (ce) => i(ce, { ...x.userNode }) : void 0, H = o ? (ce) => o(ce, { ...x.userNode }) : void 0, Y = s ? (ce) => s(ce, { ...x.userNode }) : void 0, J = (ce) => {
    const { selectNodesOnDrag: fe, nodeDragThreshold: $ } = L.getState();
    R && (!fe || !T || $ > 0) && BB({
      id: e,
      store: L,
      nodeRef: U
    }), t && t(ce, { ...x.userNode });
  }, oe = (ce) => {
    if (!(jB(ce.nativeEvent) || h))
      if (k1e.includes(ce.key) && R) {
        const fe = ce.key === "Escape";
        BB({
          id: e,
          store: L,
          unselect: fe,
          nodeRef: U
        });
      } else T && O.selected && Object.prototype.hasOwnProperty.call(OD, ce.key) && (L.setState({
        ariaLiveMessage: `Moved selected node ${ce.key.replace("Arrow", "").toLowerCase()}. New position, x: ${~~x.positionAbsolute.x}, y: ${~~x.positionAbsolute.y}`
      }), C({
        direction: OD[ce.key],
        factor: ce.shiftKey ? 4 : 1
      }));
  };
  return y("div", { className: xo([
    "react-flow__node",
    `react-flow__node-${E}`,
    {
      // this is overwritable by passing `nopan` as a class name
      [p]: T
    },
    O.className,
    {
      selected: O.selected,
      selectable: R,
      parent: S,
      draggable: T,
      dragging: z
    }
  ]), ref: U, style: {
    zIndex: x.z,
    transform: `translate(${x.positionAbsolute.x}px,${x.positionAbsolute.y}px)`,
    pointerEvents: D ? "all" : "none",
    visibility: _ ? "visible" : "hidden",
    ...O.style,
    ...M
  }, "data-id": e, "data-testid": `rf__node-${e}`, onMouseEnter: X, onMouseMove: B, onMouseLeave: q, onContextMenu: H, onClick: J, onDoubleClick: Y, onKeyDown: F ? oe : void 0, tabIndex: F ? 0 : void 0, role: F ? "button" : void 0, "aria-describedby": h ? void 0 : `${oEe}-${m}`, "aria-label": O.ariaLabel, children: y(Gmt, { value: e, children: y(k, { id: e, data: O.data, type: E, positionAbsoluteX: x.positionAbsolute.x, positionAbsoluteY: x.positionAbsolute.y, selected: O.selected, selectable: R, draggable: T, deletable: O.deletable ?? !0, isConnectable: j, sourcePosition: O.sourcePosition, targetPosition: O.targetPosition, dragging: z, dragHandle: O.dragHandle, zIndex: x.z, parentId: O.parentId, ...I }) }) });
}
const ggt = (e) => ({
  nodesDraggable: e.nodesDraggable,
  nodesConnectable: e.nodesConnectable,
  nodesFocusable: e.nodesFocusable,
  elementsSelectable: e.elementsSelectable,
  onError: e.onError
});
function mEe(e) {
  const { nodesDraggable: t, nodesConnectable: n, nodesFocusable: r, elementsSelectable: i, onError: o } = hr(ggt, Ii), s = dgt(e.onlyRenderVisibleElements), l = pgt();
  return y("div", { className: "react-flow__nodes", style: Wz, children: s.map((c) => (
    // The split of responsibilities between NodeRenderer and
    // NodeComponentWrapper may appear weird. However, it’s designed to
    // minimize the cost of updates when individual nodes change.
    //
    // For example, when you’re dragging a single node, that node gets
    // updated multiple times per second. If `NodeRenderer` were to update
    // every time, it would have to re-run the `nodes.map()` loop every
    // time. This gets pricey with hundreds of nodes, especially if every
    // loop cycle does more than just rendering a JSX element!
    //
    // As a result of this choice, we took the following implementation
    // decisions:
    // - NodeRenderer subscribes *only* to node IDs – and therefore
    //   rerender *only* when visible nodes are added or removed.
    // - NodeRenderer performs all operations the result of which can be
    //   shared between nodes (such as creating the `ResizeObserver`
    //   instance, or subscribing to `selector`). This means extra prop
    //   drilling into `NodeComponentWrapper`, but it means we need to run
    //   these operations only once – instead of once per node.
    // - Any operations that you’d normally write inside `nodes.map` are
    //   moved into `NodeComponentWrapper`. This ensures they are
    //   memorized – so if `NodeRenderer` *has* to rerender, it only
    //   needs to regenerate the list of nodes, nothing else.
    y(mgt, { id: c, nodeTypes: e.nodeTypes, nodeExtent: e.nodeExtent, onClick: e.onNodeClick, onMouseEnter: e.onNodeMouseEnter, onMouseMove: e.onNodeMouseMove, onMouseLeave: e.onNodeMouseLeave, onContextMenu: e.onNodeContextMenu, onDoubleClick: e.onNodeDoubleClick, noDragClassName: e.noDragClassName, noPanClassName: e.noPanClassName, rfId: e.rfId, disableKeyboardA11y: e.disableKeyboardA11y, resizeObserver: l, nodesDraggable: t, nodesConnectable: n, nodesFocusable: r, elementsSelectable: i, nodeClickDistance: e.nodeClickDistance, onError: o }, c)
  )) });
}
mEe.displayName = "NodeRenderer";
const ygt = Ji(mEe);
function vgt(e) {
  return hr(qn((n) => {
    if (!e)
      return n.edges.map((i) => i.id);
    const r = [];
    if (n.width && n.height)
      for (const i of n.edges) {
        const o = n.nodeLookup.get(i.source), s = n.nodeLookup.get(i.target);
        o && s && Sht({
          sourceNode: o,
          targetNode: s,
          width: n.width,
          height: n.height,
          transform: n.transform
        }) && r.push(i.id);
      }
    return r;
  }, [e]), Ii);
}
const bgt = ({ color: e = "none", strokeWidth: t = 1 }) => y("polyline", { style: {
  stroke: e,
  strokeWidth: t
}, strokeLinecap: "round", strokeLinejoin: "round", fill: "none", points: "-5,-4 0,0 -5,4" }), Ogt = ({ color: e = "none", strokeWidth: t = 1 }) => y("polyline", { style: {
  stroke: e,
  fill: e,
  strokeWidth: t
}, strokeLinecap: "round", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4 -5,-4" }), goe = {
  [yD.Arrow]: bgt,
  [yD.ArrowClosed]: Ogt
};
function Agt(e) {
  const t = mi();
  return Kt(() => {
    var i, o;
    return Object.prototype.hasOwnProperty.call(goe, e) ? goe[e] : ((o = (i = t.getState()).onError) == null || o.call(i, "009", gu.error009(e)), null);
  }, [e]);
}
const wgt = ({ id: e, type: t, color: n, width: r = 12.5, height: i = 12.5, markerUnits: o = "strokeWidth", strokeWidth: s, orient: l = "auto-start-reverse" }) => {
  const c = Agt(t);
  return c ? y("marker", { className: "react-flow__arrowhead", id: e, markerWidth: `${r}`, markerHeight: `${i}`, viewBox: "-10 -10 20 20", markerUnits: o, orient: l, refX: "0", refY: "0", children: y(c, { color: n, strokeWidth: s }) }) : null;
}, gEe = ({ defaultColor: e, rfId: t }) => {
  const n = hr((o) => o.edges), r = hr((o) => o.defaultEdgeOptions), i = Kt(() => Rht(n, {
    id: t,
    defaultColor: e,
    defaultMarkerStart: r == null ? void 0 : r.markerStart,
    defaultMarkerEnd: r == null ? void 0 : r.markerEnd
  }), [n, r, t, e]);
  return i.length ? y("svg", { className: "react-flow__marker", children: y("defs", { children: i.map((o) => y(wgt, { id: o.id, type: o.type, color: o.color, width: o.width, height: o.height, markerUnits: o.markerUnits, strokeWidth: o.strokeWidth, orient: o.orient }, o.id)) }) }) : null;
};
gEe.displayName = "MarkerDefinitions";
var xgt = Ji(gEe);
function yEe({ x: e, y: t, label: n, labelStyle: r = {}, labelShowBg: i = !0, labelBgStyle: o = {}, labelBgPadding: s = [2, 4], labelBgBorderRadius: l = 2, children: c, className: a, ...u }) {
  const [f, d] = He({ x: 1, y: 0, width: 0, height: 0 }), p = xo(["react-flow__edge-textwrapper", a]), h = Xe(null);
  return nt(() => {
    if (h.current) {
      const m = h.current.getBBox();
      d({
        x: m.x,
        y: m.y,
        width: m.width,
        height: m.height
      });
    }
  }, [n]), typeof n > "u" || !n ? null : V("g", { transform: `translate(${e - f.width / 2} ${t - f.height / 2})`, className: p, visibility: f.width ? "visible" : "hidden", ...u, children: [i && y("rect", { width: f.width + 2 * s[0], x: -s[0], y: -s[1], height: f.height + 2 * s[1], className: "react-flow__edge-textbg", style: o, rx: l, ry: l }), y("text", { className: "react-flow__edge-text", y: f.height / 2, dy: "0.3em", ref: h, style: r, children: n }), c] });
}
yEe.displayName = "EdgeText";
const Sgt = Ji(yEe);
function kh({ id: e, path: t, labelX: n, labelY: r, label: i, labelStyle: o, labelShowBg: s, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: a, style: u, markerEnd: f, markerStart: d, className: p, interactionWidth: h = 20 }) {
  return V(pt, { children: [y("path", { id: e, style: u, d: t, fill: "none", className: xo(["react-flow__edge-path", p]), markerEnd: f, markerStart: d }), h && y("path", { d: t, fill: "none", strokeOpacity: 0, strokeWidth: h, className: "react-flow__edge-interaction" }), i && Vu(n) && Vu(r) ? y(Sgt, { x: n, y: r, label: i, labelStyle: o, labelShowBg: s, labelBgStyle: l, labelBgPadding: c, labelBgBorderRadius: a }) : null] });
}
function yoe({ pos: e, x1: t, y1: n, x2: r, y2: i }) {
  return e === sn.Left || e === sn.Right ? [0.5 * (t + r), n] : [t, 0.5 * (n + i)];
}
function vEe({ sourceX: e, sourceY: t, sourcePosition: n = sn.Bottom, targetX: r, targetY: i, targetPosition: o = sn.Top }) {
  const [s, l] = yoe({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: i
  }), [c, a] = yoe({
    pos: o,
    x1: r,
    y1: i,
    x2: e,
    y2: t
  }), [u, f, d, p] = B1e({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: i,
    sourceControlX: s,
    sourceControlY: l,
    targetControlX: c,
    targetControlY: a
  });
  return [
    `M${e},${t} C${s},${l} ${c},${a} ${r},${i}`,
    u,
    f,
    d,
    p
  ];
}
function bEe(e) {
  return Ji(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: o, sourcePosition: s = sn.Bottom, targetPosition: l = sn.Top, label: c, labelStyle: a, labelShowBg: u, labelBgStyle: f, labelBgPadding: d, labelBgBorderRadius: p, style: h, markerEnd: m, markerStart: v, interactionWidth: b }) => {
    const [A, w, O] = vEe({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: i,
      targetY: o,
      targetPosition: l
    }), x = e.isInternal ? void 0 : t;
    return y(kh, { id: x, path: A, labelX: w, labelY: O, label: c, labelStyle: a, labelShowBg: u, labelBgStyle: f, labelBgPadding: d, labelBgBorderRadius: p, style: h, markerEnd: m, markerStart: v, interactionWidth: b });
  });
}
const Egt = bEe({ isInternal: !1 }), OEe = bEe({ isInternal: !0 });
Egt.displayName = "SimpleBezierEdge";
OEe.displayName = "SimpleBezierEdgeInternal";
function AEe(e) {
  return Ji(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: o, label: s, labelStyle: l, labelShowBg: c, labelBgStyle: a, labelBgPadding: u, labelBgBorderRadius: f, style: d, sourcePosition: p = sn.Bottom, targetPosition: h = sn.Top, markerEnd: m, markerStart: v, pathOptions: b, interactionWidth: A }) => {
    const [w, O, x] = FB({
      sourceX: n,
      sourceY: r,
      sourcePosition: p,
      targetX: i,
      targetY: o,
      targetPosition: h,
      borderRadius: b == null ? void 0 : b.borderRadius,
      offset: b == null ? void 0 : b.offset
    }), S = e.isInternal ? void 0 : t;
    return y(kh, { id: S, path: w, labelX: O, labelY: x, label: s, labelStyle: l, labelShowBg: c, labelBgStyle: a, labelBgPadding: u, labelBgBorderRadius: f, style: d, markerEnd: m, markerStart: v, interactionWidth: A });
  });
}
const wEe = AEe({ isInternal: !1 }), xEe = AEe({ isInternal: !0 });
wEe.displayName = "SmoothStepEdge";
xEe.displayName = "SmoothStepEdgeInternal";
function SEe(e) {
  return Ji(({ id: t, ...n }) => {
    var i;
    const r = e.isInternal ? void 0 : t;
    return y(wEe, { ...n, id: r, pathOptions: Kt(() => {
      var o;
      return { borderRadius: 0, offset: (o = n.pathOptions) == null ? void 0 : o.offset };
    }, [(i = n.pathOptions) == null ? void 0 : i.offset]) });
  });
}
const Tgt = SEe({ isInternal: !1 }), EEe = SEe({ isInternal: !0 });
Tgt.displayName = "StepEdge";
EEe.displayName = "StepEdgeInternal";
function TEe(e) {
  return Ji(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: o, label: s, labelStyle: l, labelShowBg: c, labelBgStyle: a, labelBgPadding: u, labelBgBorderRadius: f, style: d, markerEnd: p, markerStart: h, interactionWidth: m }) => {
    const [v, b, A] = Z1e({ sourceX: n, sourceY: r, targetX: i, targetY: o }), w = e.isInternal ? void 0 : t;
    return y(kh, { id: w, path: v, labelX: b, labelY: A, label: s, labelStyle: l, labelShowBg: c, labelBgStyle: a, labelBgPadding: u, labelBgBorderRadius: f, style: d, markerEnd: p, markerStart: h, interactionWidth: m });
  });
}
const kgt = TEe({ isInternal: !1 }), kEe = TEe({ isInternal: !0 });
kgt.displayName = "StraightEdge";
kEe.displayName = "StraightEdgeInternal";
function CEe(e) {
  return Ji(({ id: t, sourceX: n, sourceY: r, targetX: i, targetY: o, sourcePosition: s = sn.Bottom, targetPosition: l = sn.Top, label: c, labelStyle: a, labelShowBg: u, labelBgStyle: f, labelBgPadding: d, labelBgBorderRadius: p, style: h, markerEnd: m, markerStart: v, pathOptions: b, interactionWidth: A }) => {
    const [w, O, x] = X1e({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: i,
      targetY: o,
      targetPosition: l,
      curvature: b == null ? void 0 : b.curvature
    }), S = e.isInternal ? void 0 : t;
    return y(kh, { id: S, path: w, labelX: O, labelY: x, label: c, labelStyle: a, labelShowBg: u, labelBgStyle: f, labelBgPadding: d, labelBgBorderRadius: p, style: h, markerEnd: m, markerStart: v, interactionWidth: A });
  });
}
const Cgt = CEe({ isInternal: !1 }), NEe = CEe({ isInternal: !0 });
Cgt.displayName = "BezierEdge";
NEe.displayName = "BezierEdgeInternal";
const voe = {
  default: NEe,
  straight: kEe,
  step: EEe,
  smoothstep: xEe,
  simplebezier: OEe
}, boe = {
  sourceX: null,
  sourceY: null,
  targetX: null,
  targetY: null,
  sourcePosition: null,
  targetPosition: null
}, Ngt = (e, t, n) => n === sn.Left ? e - t : n === sn.Right ? e + t : e, Pgt = (e, t, n) => n === sn.Top ? e - t : n === sn.Bottom ? e + t : e, Ooe = "react-flow__edgeupdater";
function Aoe({ position: e, centerX: t, centerY: n, radius: r = 10, onMouseDown: i, onMouseEnter: o, onMouseOut: s, type: l }) {
  return y("circle", { onMouseDown: i, onMouseEnter: o, onMouseOut: s, className: xo([Ooe, `${Ooe}-${l}`]), cx: Ngt(t, r, e), cy: Pgt(n, r, e), r, stroke: "transparent", fill: "transparent" });
}
function Igt({ isReconnectable: e, reconnectRadius: t, edge: n, sourceX: r, sourceY: i, targetX: o, targetY: s, sourcePosition: l, targetPosition: c, onReconnect: a, onReconnectStart: u, onReconnectEnd: f, setReconnecting: d, setUpdateHover: p }) {
  const h = mi(), m = (O, x) => {
    if (O.button !== 0)
      return;
    const { autoPanOnConnect: S, domNode: E, isValidConnection: k, connectionMode: T, connectionRadius: R, lib: j, onConnectStart: F, onConnectEnd: L, cancelConnection: _, nodeLookup: U, rfId: z, panBy: C, updateConnection: I } = h.getState(), M = x.type === "target";
    d(!0), u == null || u(O, n, x.type);
    const D = (B, q) => {
      d(!1), f == null || f(B, n, x.type, q);
    }, X = (B) => a == null ? void 0 : a(n, B);
    qB.onPointerDown(O.nativeEvent, {
      autoPanOnConnect: S,
      connectionMode: T,
      connectionRadius: R,
      domNode: E,
      handleId: x.id,
      nodeId: x.nodeId,
      nodeLookup: U,
      isTarget: M,
      edgeUpdaterType: x.type,
      lib: j,
      flowId: z,
      cancelConnection: _,
      panBy: C,
      isValidConnection: k,
      onConnect: X,
      onConnectStart: F,
      onConnectEnd: L,
      onReconnectEnd: D,
      updateConnection: I,
      getTransform: () => h.getState().transform,
      getFromHandle: () => h.getState().connection.fromHandle
    });
  }, v = (O) => m(O, { nodeId: n.target, id: n.targetHandle ?? null, type: "target" }), b = (O) => m(O, { nodeId: n.source, id: n.sourceHandle ?? null, type: "source" }), A = () => p(!0), w = () => p(!1);
  return V(pt, { children: [(e === !0 || e === "source") && y(Aoe, { position: l, centerX: r, centerY: i, radius: t, onMouseDown: v, onMouseEnter: A, onMouseOut: w, type: "source" }), (e === !0 || e === "target") && y(Aoe, { position: c, centerX: o, centerY: s, radius: t, onMouseDown: b, onMouseEnter: A, onMouseOut: w, type: "target" })] });
}
function Rgt({ id: e, edgesFocusable: t, edgesReconnectable: n, elementsSelectable: r, onClick: i, onDoubleClick: o, onContextMenu: s, onMouseEnter: l, onMouseMove: c, onMouseLeave: a, reconnectRadius: u, onReconnect: f, onReconnectStart: d, onReconnectEnd: p, rfId: h, edgeTypes: m, noPanClassName: v, onError: b, disableKeyboardA11y: A }) {
  let w = hr((ee) => ee.edgeLookup.get(e));
  const O = hr((ee) => ee.defaultEdgeOptions);
  w = O ? { ...O, ...w } : w;
  let x = w.type || "default", S = (m == null ? void 0 : m[x]) || voe[x];
  S === void 0 && (b == null || b("011", gu.error011(x)), x = "default", S = voe.default);
  const E = !!(w.focusable || t && typeof w.focusable > "u"), k = typeof f < "u" && (w.reconnectable || n && typeof w.reconnectable > "u"), T = !!(w.selectable || r && typeof w.selectable > "u"), R = Xe(null), [j, F] = He(!1), [L, _] = He(!1), U = mi(), { zIndex: z, sourceX: C, sourceY: I, targetX: M, targetY: D, sourcePosition: X, targetPosition: B } = hr(qn((ee) => {
    const Ce = ee.nodeLookup.get(w.source), Ee = ee.nodeLookup.get(w.target);
    if (!Ce || !Ee)
      return {
        zIndex: w.zIndex,
        ...boe
      };
    const Ve = Iht({
      id: e,
      sourceNode: Ce,
      targetNode: Ee,
      sourceHandle: w.sourceHandle || null,
      targetHandle: w.targetHandle || null,
      connectionMode: ee.connectionMode,
      onError: b
    });
    return {
      zIndex: xht({
        selected: w.selected,
        zIndex: w.zIndex,
        sourceNode: Ce,
        targetNode: Ee,
        elevateOnSelect: ee.elevateEdgesOnSelect
      }),
      ...Ve || boe
    };
  }, [w.source, w.target, w.sourceHandle, w.targetHandle, w.selected, w.zIndex]), Ii), q = Kt(() => w.markerStart ? `url('#${UB(w.markerStart, h)}')` : void 0, [w.markerStart, h]), H = Kt(() => w.markerEnd ? `url('#${UB(w.markerEnd, h)}')` : void 0, [w.markerEnd, h]);
  if (w.hidden || C === null || I === null || M === null || D === null)
    return null;
  const Y = (ee) => {
    var et;
    const { addSelectedEdges: Ce, unselectNodesAndEdges: Ee, multiSelectionActive: Ve } = U.getState();
    T && (U.setState({ nodesSelectionActive: !1 }), w.selected && Ve ? (Ee({ nodes: [], edges: [w] }), (et = R.current) == null || et.blur()) : Ce([e])), i && i(ee, w);
  }, J = o ? (ee) => {
    o(ee, { ...w });
  } : void 0, oe = s ? (ee) => {
    s(ee, { ...w });
  } : void 0, ce = l ? (ee) => {
    l(ee, { ...w });
  } : void 0, fe = c ? (ee) => {
    c(ee, { ...w });
  } : void 0, $ = a ? (ee) => {
    a(ee, { ...w });
  } : void 0, pe = (ee) => {
    var Ce;
    if (!A && k1e.includes(ee.key) && T) {
      const { unselectNodesAndEdges: Ee, addSelectedEdges: Ve } = U.getState();
      ee.key === "Escape" ? ((Ce = R.current) == null || Ce.blur(), Ee({ edges: [w] })) : Ve([e]);
    }
  };
  return y("svg", { style: { zIndex: z }, children: V("g", { className: xo([
    "react-flow__edge",
    `react-flow__edge-${x}`,
    w.className,
    v,
    {
      selected: w.selected,
      animated: w.animated,
      inactive: !T && !i,
      updating: j,
      selectable: T
    }
  ]), onClick: Y, onDoubleClick: J, onContextMenu: oe, onMouseEnter: ce, onMouseMove: fe, onMouseLeave: $, onKeyDown: E ? pe : void 0, tabIndex: E ? 0 : void 0, role: E ? "button" : "img", "data-id": e, "data-testid": `rf__edge-${e}`, "aria-label": w.ariaLabel === null ? void 0 : w.ariaLabel || `Edge from ${w.source} to ${w.target}`, "aria-describedby": E ? `${sEe}-${h}` : void 0, ref: R, children: [!L && y(S, { id: e, source: w.source, target: w.target, type: w.type, selected: w.selected, animated: w.animated, selectable: T, deletable: w.deletable ?? !0, label: w.label, labelStyle: w.labelStyle, labelShowBg: w.labelShowBg, labelBgStyle: w.labelBgStyle, labelBgPadding: w.labelBgPadding, labelBgBorderRadius: w.labelBgBorderRadius, sourceX: C, sourceY: I, targetX: M, targetY: D, sourcePosition: X, targetPosition: B, data: w.data, style: w.style, sourceHandleId: w.sourceHandle, targetHandleId: w.targetHandle, markerStart: q, markerEnd: H, pathOptions: "pathOptions" in w ? w.pathOptions : void 0, interactionWidth: w.interactionWidth }), k && y(Igt, { edge: w, isReconnectable: k, reconnectRadius: u, onReconnect: f, onReconnectStart: d, onReconnectEnd: p, sourceX: C, sourceY: I, targetX: M, targetY: D, sourcePosition: X, targetPosition: B, setUpdateHover: F, setReconnecting: _ })] }) });
}
const Mgt = (e) => ({
  width: e.width,
  height: e.height,
  edgesFocusable: e.edgesFocusable,
  edgesReconnectable: e.edgesReconnectable,
  elementsSelectable: e.elementsSelectable,
  connectionMode: e.connectionMode,
  onError: e.onError
});
function PEe({ defaultMarkerColor: e, onlyRenderVisibleElements: t, rfId: n, edgeTypes: r, noPanClassName: i, onReconnect: o, onEdgeContextMenu: s, onEdgeMouseEnter: l, onEdgeMouseMove: c, onEdgeMouseLeave: a, onEdgeClick: u, reconnectRadius: f, onEdgeDoubleClick: d, onReconnectStart: p, onReconnectEnd: h, disableKeyboardA11y: m }) {
  const { edgesFocusable: v, edgesReconnectable: b, elementsSelectable: A, onError: w } = hr(Mgt, Ii), O = vgt(t);
  return V("div", { className: "react-flow__edges", children: [y(xgt, { defaultColor: e, rfId: n }), O.map((x) => y(Rgt, { id: x, edgesFocusable: v, edgesReconnectable: b, elementsSelectable: A, noPanClassName: i, onReconnect: o, onContextMenu: s, onMouseEnter: l, onMouseMove: c, onMouseLeave: a, onClick: u, reconnectRadius: f, onDoubleClick: d, onReconnectStart: p, onReconnectEnd: h, rfId: n, onError: w, edgeTypes: r, disableKeyboardA11y: m }, x))] });
}
PEe.displayName = "EdgeRenderer";
const Dgt = Ji(PEe), _gt = (e) => `translate(${e.transform[0]}px,${e.transform[1]}px) scale(${e.transform[2]})`;
function Lgt({ children: e }) {
  const t = hr(_gt);
  return y("div", { className: "react-flow__viewport xyflow__viewport react-flow__container", style: { transform: t }, children: e });
}
function zgt(e) {
  const t = yd(), n = Xe(!1);
  nt(() => {
    !n.current && t.viewportInitialized && e && (setTimeout(() => e(t), 1), n.current = !0);
  }, [e, t.viewportInitialized]);
}
const jgt = (e) => {
  var t;
  return (t = e.panZoom) == null ? void 0 : t.syncViewport;
};
function Fgt(e) {
  const t = hr(jgt), n = mi();
  return nt(() => {
    e && (t == null || t(e), n.setState({ transform: [e.x, e.y, e.zoom] }));
  }, [e, t]), null;
}
function Ugt(e) {
  return e.connection.inProgress ? { ...e.connection, to: oN(e.connection.to, e.transform) } : { ...e.connection };
}
function Vgt(e) {
  return Ugt;
}
function qgt(e) {
  const t = Vgt();
  return hr(t, Ii);
}
const Bgt = (e) => ({
  nodesConnectable: e.nodesConnectable,
  isValid: e.connection.isValid,
  inProgress: e.connection.inProgress,
  width: e.width,
  height: e.height
});
function Xgt({ containerStyle: e, style: t, type: n, component: r }) {
  const { nodesConnectable: i, width: o, height: s, isValid: l, inProgress: c } = hr(Bgt, Ii);
  return !(o && i && c) ? null : y("svg", { style: e, width: o, height: s, className: "react-flow__connectionline react-flow__container", children: y("g", { className: xo(["react-flow__connection", N1e(l)]), children: y(IEe, { style: t, type: n, CustomComponent: r, isValid: l }) }) });
}
const IEe = ({ style: e, type: t = lm.Bezier, CustomComponent: n, isValid: r }) => {
  const { inProgress: i, from: o, fromNode: s, fromHandle: l, fromPosition: c, to: a, toNode: u, toHandle: f, toPosition: d } = qgt();
  if (!i)
    return;
  if (n)
    return y(n, { connectionLineType: t, connectionLineStyle: e, fromNode: s, fromHandle: l, fromX: o.x, fromY: o.y, toX: a.x, toY: a.y, fromPosition: c, toPosition: d, connectionStatus: N1e(r), toNode: u, toHandle: f });
  let p = "";
  const h = {
    sourceX: o.x,
    sourceY: o.y,
    sourcePosition: c,
    targetX: a.x,
    targetY: a.y,
    targetPosition: d
  };
  switch (t) {
    case lm.Bezier:
      [p] = X1e(h);
      break;
    case lm.SimpleBezier:
      [p] = vEe(h);
      break;
    case lm.Step:
      [p] = FB({
        ...h,
        borderRadius: 0
      });
      break;
    case lm.SmoothStep:
      [p] = FB(h);
      break;
    default:
      [p] = Z1e(h);
  }
  return y("path", { d: p, fill: "none", className: "react-flow__connection-path", style: e });
};
IEe.displayName = "ConnectionLine";
const Wgt = {};
function woe(e = Wgt) {
  const t = Xe(e), n = mi();
  nt(() => {
    var r, i;
    if (process.env.NODE_ENV === "development") {
      const o = /* @__PURE__ */ new Set([...Object.keys(t.current), ...Object.keys(e)]);
      for (const s of o)
        if (t.current[s] !== e[s]) {
          (i = (r = n.getState()).onError) == null || i.call(r, "002", gu.error002());
          break;
        }
      t.current = e;
    }
  }, [e]);
}
function Zgt() {
  const e = mi(), t = Xe(!1);
  nt(() => {
    var n, r;
    if (process.env.NODE_ENV === "development" && !t.current) {
      const i = document.querySelector(".react-flow__pane");
      i && window.getComputedStyle(i).zIndex !== "1" && ((r = (n = e.getState()).onError) == null || r.call(n, "013", gu.error013("react"))), t.current = !0;
    }
  }, []);
}
function REe({ nodeTypes: e, edgeTypes: t, onInit: n, onNodeClick: r, onEdgeClick: i, onNodeDoubleClick: o, onEdgeDoubleClick: s, onNodeMouseEnter: l, onNodeMouseMove: c, onNodeMouseLeave: a, onNodeContextMenu: u, onSelectionContextMenu: f, onSelectionStart: d, onSelectionEnd: p, connectionLineType: h, connectionLineStyle: m, connectionLineComponent: v, connectionLineContainerStyle: b, selectionKeyCode: A, selectionOnDrag: w, selectionMode: O, multiSelectionKeyCode: x, panActivationKeyCode: S, zoomActivationKeyCode: E, deleteKeyCode: k, onlyRenderVisibleElements: T, elementsSelectable: R, defaultViewport: j, translateExtent: F, minZoom: L, maxZoom: _, preventScrolling: U, defaultMarkerColor: z, zoomOnScroll: C, zoomOnPinch: I, panOnScroll: M, panOnScrollSpeed: D, panOnScrollMode: X, zoomOnDoubleClick: B, panOnDrag: q, onPaneClick: H, onPaneMouseEnter: Y, onPaneMouseMove: J, onPaneMouseLeave: oe, onPaneScroll: ce, onPaneContextMenu: fe, paneClickDistance: $, nodeClickDistance: pe, onEdgeContextMenu: ee, onEdgeMouseEnter: Ce, onEdgeMouseMove: Ee, onEdgeMouseLeave: Ve, reconnectRadius: et, onReconnect: ft, onReconnectStart: me, onReconnectEnd: Te, noDragClassName: re, noWheelClassName: le, noPanClassName: Oe, disableKeyboardA11y: be, nodeExtent: je, rfId: xe, viewport: Q, onViewportChange: ae }) {
  return woe(e), woe(t), Zgt(), zgt(n), Fgt(Q), y(cgt, { onPaneClick: H, onPaneMouseEnter: Y, onPaneMouseMove: J, onPaneMouseLeave: oe, onPaneContextMenu: fe, onPaneScroll: ce, paneClickDistance: $, deleteKeyCode: k, selectionKeyCode: A, selectionOnDrag: w, selectionMode: O, onSelectionStart: d, onSelectionEnd: p, multiSelectionKeyCode: x, panActivationKeyCode: S, zoomActivationKeyCode: E, elementsSelectable: R, zoomOnScroll: C, zoomOnPinch: I, zoomOnDoubleClick: B, panOnScroll: M, panOnScrollSpeed: D, panOnScrollMode: X, panOnDrag: q, defaultViewport: j, translateExtent: F, minZoom: L, maxZoom: _, onSelectionContextMenu: f, preventScrolling: U, noDragClassName: re, noWheelClassName: le, noPanClassName: Oe, disableKeyboardA11y: be, onViewportChange: ae, isControlledViewport: !!Q, children: V(Lgt, { children: [y(Dgt, { edgeTypes: t, onEdgeClick: i, onEdgeDoubleClick: s, onReconnect: ft, onReconnectStart: me, onReconnectEnd: Te, onlyRenderVisibleElements: T, onEdgeContextMenu: ee, onEdgeMouseEnter: Ce, onEdgeMouseMove: Ee, onEdgeMouseLeave: Ve, reconnectRadius: et, defaultMarkerColor: z, noPanClassName: Oe, disableKeyboardA11y: be, rfId: xe }), y(Xgt, { style: m, type: h, component: v, containerStyle: b }), y("div", { className: "react-flow__edgelabel-renderer" }), y(ygt, { nodeTypes: e, onNodeClick: r, onNodeDoubleClick: o, onNodeMouseEnter: l, onNodeMouseMove: c, onNodeMouseLeave: a, onNodeContextMenu: u, nodeClickDistance: pe, onlyRenderVisibleElements: T, noPanClassName: Oe, noDragClassName: re, disableKeyboardA11y: be, nodeExtent: je, rfId: xe }), y("div", { className: "react-flow__viewport-portal" })] }) });
}
REe.displayName = "GraphView";
const Hgt = Ji(REe), xoe = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: i, height: o, fitView: s, nodeOrigin: l, nodeExtent: c } = {}) => {
  const a = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), p = r ?? t ?? [], h = n ?? e ?? [], m = l ?? [0, 0], v = c ?? jT;
  Q1e(f, d, p), VB(h, a, u, {
    nodeOrigin: m,
    nodeExtent: v,
    elevateNodesOnSelect: !1
  });
  let b = [0, 0, 1];
  if (s && i && o) {
    const A = iN(a, {
      filter: (S) => !!((S.width || S.initialWidth) && (S.height || S.initialHeight))
    }), { x: w, y: O, zoom: x } = _Q(A, i, o, 0.5, 2, 0.1);
    b = [w, O, x];
  }
  return {
    rfId: "1",
    width: 0,
    height: 0,
    transform: b,
    nodes: h,
    nodeLookup: a,
    parentLookup: u,
    edges: p,
    edgeLookup: d,
    connectionLookup: f,
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: n !== void 0,
    hasDefaultEdges: r !== void 0,
    panZoom: null,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: jT,
    nodeExtent: v,
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    connectionMode: tw.Strict,
    domNode: null,
    paneDragging: !1,
    noPanClassName: "nopan",
    nodeOrigin: m,
    nodeDragThreshold: 1,
    snapGrid: [15, 15],
    snapToGrid: !1,
    nodesDraggable: !0,
    nodesConnectable: !0,
    nodesFocusable: !0,
    edgesFocusable: !0,
    edgesReconnectable: !0,
    elementsSelectable: !0,
    elevateNodesOnSelect: !0,
    elevateEdgesOnSelect: !1,
    fitViewOnInit: !1,
    fitViewDone: !1,
    fitViewOnInitOptions: void 0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    connection: { ...C1e },
    connectionClickStartHandle: null,
    connectOnClick: !0,
    ariaLiveMessage: "",
    autoPanOnConnect: !0,
    autoPanOnNodeDrag: !0,
    autoPanSpeed: 15,
    connectionRadius: 20,
    onError: z1e,
    isValidConnection: void 0,
    onSelectionChangeHandlers: [],
    lib: "react",
    debug: !1
  };
}, Qgt = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: i, height: o, fitView: s, nodeOrigin: l, nodeExtent: c }) => dmt((a, u) => ({
  ...xoe({ nodes: e, edges: t, width: i, height: o, fitView: s, nodeOrigin: l, nodeExtent: c, defaultNodes: n, defaultEdges: r }),
  setNodes: (f) => {
    const { nodeLookup: d, parentLookup: p, nodeOrigin: h, elevateNodesOnSelect: m } = u();
    VB(f, d, p, {
      nodeOrigin: h,
      nodeExtent: c,
      elevateNodesOnSelect: m,
      checkEquality: !0
    }), a({ nodes: f });
  },
  setEdges: (f) => {
    const { connectionLookup: d, edgeLookup: p } = u();
    Q1e(d, p, f), a({ edges: f });
  },
  setDefaultNodesAndEdges: (f, d) => {
    if (f) {
      const { setNodes: p } = u();
      p(f), a({ hasDefaultNodes: !0 });
    }
    if (d) {
      const { setEdges: p } = u();
      p(d), a({ hasDefaultEdges: !0 });
    }
  },
  // Every node gets registerd at a ResizeObserver. Whenever a node
  // changes its dimensions, this function is called to measure the
  // new dimensions and update the nodes.
  updateNodeInternals: (f, d = { triggerFitView: !0 }) => {
    const { triggerNodeChanges: p, nodeLookup: h, parentLookup: m, fitViewOnInit: v, fitViewDone: b, fitViewOnInitOptions: A, domNode: w, nodeOrigin: O, nodeExtent: x, debug: S, fitViewSync: E } = u(), { changes: k, updatedInternals: T } = zht(f, h, m, w, O, x);
    if (T) {
      if (Dht(h, m, { nodeOrigin: O, nodeExtent: x }), d.triggerFitView) {
        let R = b;
        !b && v && (R = E({
          ...A,
          nodes: A == null ? void 0 : A.nodes
        })), a({ fitViewDone: R });
      } else
        a({});
      (k == null ? void 0 : k.length) > 0 && (S && console.log("React Flow: trigger node changes", k), p == null || p(k));
    }
  },
  updateNodePositions: (f, d = !1) => {
    const p = [], h = [];
    for (const [m, v] of f) {
      const b = {
        id: m,
        type: "position",
        position: v.position,
        dragging: d
      };
      v != null && v.expandParent && (v != null && v.parentId) && b.position && (p.push({
        id: m,
        parentId: v.parentId,
        rect: {
          ...v.internals.positionAbsolute,
          width: v.measured.width,
          height: v.measured.height
        }
      }), b.position.x = Math.max(0, b.position.x), b.position.y = Math.max(0, b.position.y)), h.push(b);
    }
    if (p.length > 0) {
      const { nodeLookup: m, parentLookup: v, nodeOrigin: b } = u(), A = FQ(p, m, v, b);
      h.push(...A);
    }
    u().triggerNodeChanges(h);
  },
  triggerNodeChanges: (f) => {
    const { onNodesChange: d, setNodes: p, nodes: h, hasDefaultNodes: m, debug: v } = u();
    if (f != null && f.length) {
      if (m) {
        const b = Rmt(f, h);
        p(b);
      }
      v && console.log("React Flow: trigger node changes", f), d == null || d(f);
    }
  },
  triggerEdgeChanges: (f) => {
    const { onEdgesChange: d, setEdges: p, edges: h, hasDefaultEdges: m, debug: v } = u();
    if (f != null && f.length) {
      if (m) {
        const b = Mmt(f, h);
        p(b);
      }
      v && console.log("React Flow: trigger edge changes", f), d == null || d(f);
    }
  },
  addSelectedNodes: (f) => {
    const { multiSelectionActive: d, edgeLookup: p, nodeLookup: h, triggerNodeChanges: m, triggerEdgeChanges: v } = u();
    if (d) {
      const b = f.map((A) => fy(A, !0));
      m(b);
      return;
    }
    m(AO(h, /* @__PURE__ */ new Set([...f]), !0)), v(AO(p));
  },
  addSelectedEdges: (f) => {
    const { multiSelectionActive: d, edgeLookup: p, nodeLookup: h, triggerNodeChanges: m, triggerEdgeChanges: v } = u();
    if (d) {
      const b = f.map((A) => fy(A, !0));
      v(b);
      return;
    }
    v(AO(p, /* @__PURE__ */ new Set([...f]))), m(AO(h, /* @__PURE__ */ new Set(), !0));
  },
  unselectNodesAndEdges: ({ nodes: f, edges: d } = {}) => {
    const { edges: p, nodes: h, nodeLookup: m, triggerNodeChanges: v, triggerEdgeChanges: b } = u(), A = f || h, w = d || p, O = A.map((S) => {
      const E = m.get(S.id);
      return E && (E.selected = !1), fy(S.id, !1);
    }), x = w.map((S) => fy(S.id, !1));
    v(O), b(x);
  },
  setMinZoom: (f) => {
    const { panZoom: d, maxZoom: p } = u();
    d == null || d.setScaleExtent([f, p]), a({ minZoom: f });
  },
  setMaxZoom: (f) => {
    const { panZoom: d, minZoom: p } = u();
    d == null || d.setScaleExtent([p, f]), a({ maxZoom: f });
  },
  setTranslateExtent: (f) => {
    var d;
    (d = u().panZoom) == null || d.setTranslateExtent(f), a({ translateExtent: f });
  },
  setPaneClickDistance: (f) => {
    var d;
    (d = u().panZoom) == null || d.setClickDistance(f);
  },
  resetSelectedElements: () => {
    const { edges: f, nodes: d, triggerNodeChanges: p, triggerEdgeChanges: h } = u(), m = d.reduce((b, A) => A.selected ? [...b, fy(A.id, !1)] : b, []), v = f.reduce((b, A) => A.selected ? [...b, fy(A.id, !1)] : b, []);
    p(m), h(v);
  },
  setNodeExtent: (f) => {
    const { nodes: d, nodeLookup: p, parentLookup: h, nodeOrigin: m, elevateNodesOnSelect: v, nodeExtent: b } = u();
    f[0][0] === b[0][0] && f[0][1] === b[0][1] && f[1][0] === b[1][0] && f[1][1] === b[1][1] || (VB(d, p, h, {
      nodeOrigin: m,
      nodeExtent: f,
      elevateNodesOnSelect: v,
      checkEquality: !1
    }), a({ nodeExtent: f }));
  },
  panBy: (f) => {
    const { transform: d, width: p, height: h, panZoom: m, translateExtent: v } = u();
    return jht({ delta: f, panZoom: m, transform: d, translateExtent: v, width: p, height: h });
  },
  fitView: (f) => {
    const { panZoom: d, width: p, height: h, minZoom: m, maxZoom: v, nodeLookup: b } = u();
    if (!d)
      return Promise.resolve(!1);
    const A = _B(b, f);
    return LB({
      nodes: A,
      width: p,
      height: h,
      panZoom: d,
      minZoom: m,
      maxZoom: v
    }, f);
  },
  // we can't call an asnychronous function in updateNodeInternals
  // for that we created this sync version of fitView
  fitViewSync: (f) => {
    const { panZoom: d, width: p, height: h, minZoom: m, maxZoom: v, nodeLookup: b } = u();
    if (!d)
      return !1;
    const A = _B(b, f);
    return LB({
      nodes: A,
      width: p,
      height: h,
      panZoom: d,
      minZoom: m,
      maxZoom: v
    }, f), A.size > 0;
  },
  cancelConnection: () => {
    a({
      connection: { ...C1e }
    });
  },
  updateConnection: (f) => {
    a({ connection: f });
  },
  reset: () => a({ ...xoe() })
}), Object.is);
function MEe({ initialNodes: e, initialEdges: t, defaultNodes: n, defaultEdges: r, initialWidth: i, initialHeight: o, fitView: s, nodeOrigin: l, nodeExtent: c, children: a }) {
  const [u] = He(() => Qgt({
    nodes: e,
    edges: t,
    defaultNodes: n,
    defaultEdges: r,
    width: i,
    height: o,
    fitView: s,
    nodeOrigin: l,
    nodeExtent: c
  }));
  return y(fmt, { value: u, children: y(zmt, { children: a }) });
}
function $gt({ children: e, nodes: t, edges: n, defaultNodes: r, defaultEdges: i, width: o, height: s, fitView: l, nodeOrigin: c, nodeExtent: a }) {
  return kr(Xz) ? y(pt, { children: e }) : y(MEe, { initialNodes: t, initialEdges: n, defaultNodes: r, defaultEdges: i, initialWidth: o, initialHeight: s, fitView: l, nodeOrigin: c, nodeExtent: a, children: e });
}
const Kgt = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  zIndex: 0
};
function Ggt({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, className: i, nodeTypes: o, edgeTypes: s, onNodeClick: l, onEdgeClick: c, onInit: a, onMove: u, onMoveStart: f, onMoveEnd: d, onConnect: p, onConnectStart: h, onConnectEnd: m, onClickConnectStart: v, onClickConnectEnd: b, onNodeMouseEnter: A, onNodeMouseMove: w, onNodeMouseLeave: O, onNodeContextMenu: x, onNodeDoubleClick: S, onNodeDragStart: E, onNodeDrag: k, onNodeDragStop: T, onNodesDelete: R, onEdgesDelete: j, onDelete: F, onSelectionChange: L, onSelectionDragStart: _, onSelectionDrag: U, onSelectionDragStop: z, onSelectionContextMenu: C, onSelectionStart: I, onSelectionEnd: M, onBeforeDelete: D, connectionMode: X, connectionLineType: B = lm.Bezier, connectionLineStyle: q, connectionLineComponent: H, connectionLineContainerStyle: Y, deleteKeyCode: J = "Backspace", selectionKeyCode: oe = "Shift", selectionOnDrag: ce = !1, selectionMode: fe = nw.Full, panActivationKeyCode: $ = "Space", multiSelectionKeyCode: pe = bD() ? "Meta" : "Control", zoomActivationKeyCode: ee = bD() ? "Meta" : "Control", snapToGrid: Ce, snapGrid: Ee, onlyRenderVisibleElements: Ve = !1, selectNodesOnDrag: et, nodesDraggable: ft, nodesConnectable: me, nodesFocusable: Te, nodeOrigin: re = aEe, edgesFocusable: le, edgesReconnectable: Oe, elementsSelectable: be = !0, defaultViewport: je = Emt, minZoom: xe = 0.5, maxZoom: Q = 2, translateExtent: ae = jT, preventScrolling: Pe = !0, nodeExtent: Fe, defaultMarkerColor: Ke = "#b1b1b7", zoomOnScroll: Ot = !0, zoomOnPinch: Ct = !0, panOnScroll: Jt = !1, panOnScrollSpeed: yn = 0.5, panOnScrollMode: vn = Bm.Free, zoomOnDoubleClick: Re = !0, panOnDrag: _e = !0, onPaneClick: jt, onPaneMouseEnter: st, onPaneMouseMove: Mt, onPaneMouseLeave: lt, onPaneScroll: xt, onPaneContextMenu: yt, paneClickDistance: ct = 0, nodeClickDistance: Rt = 0, children: Yt, onReconnect: Gt, onReconnectStart: hn, onReconnectEnd: en, onEdgeContextMenu: Sn, onEdgeDoubleClick: Ar, onEdgeMouseEnter: or, onEdgeMouseMove: rr, onEdgeMouseLeave: no, reconnectRadius: jn = 10, onNodesChange: Xi, onEdgesChange: us, noDragClassName: ca = "nodrag", noWheelClassName: ge = "nowheel", noPanClassName: ve = "nopan", fitView: se, fitViewOptions: P, connectOnClick: W, attributionPosition: te, proOptions: de, defaultEdgeOptions: Ne, elevateNodesOnSelect: Me, elevateEdgesOnSelect: Ge, disableKeyboardA11y: $t = !1, autoPanOnConnect: In, autoPanOnNodeDrag: Qn, autoPanSpeed: yr, connectionRadius: Cn, isValidConnection: Ln, onError: Lr, style: bn, id: Cr, nodeDragThreshold: ro, viewport: zs, onViewportChange: xd, width: ua, height: Pl, colorMode: Il = "light", debug: ye, ...Ae }, ht) {
  const On = Cr || "1", Wn = Nmt(Il);
  return y("div", { ...Ae, style: { ...bn, ...Kgt }, ref: ht, className: xo(["react-flow", i, Wn]), "data-testid": "rf__wrapper", id: Cr, children: V($gt, { nodes: e, edges: t, width: ua, height: Pl, fitView: se, nodeOrigin: re, nodeExtent: Fe, children: [y(Hgt, { onInit: a, onNodeClick: l, onEdgeClick: c, onNodeMouseEnter: A, onNodeMouseMove: w, onNodeMouseLeave: O, onNodeContextMenu: x, onNodeDoubleClick: S, nodeTypes: o, edgeTypes: s, connectionLineType: B, connectionLineStyle: q, connectionLineComponent: H, connectionLineContainerStyle: Y, selectionKeyCode: oe, selectionOnDrag: ce, selectionMode: fe, deleteKeyCode: J, multiSelectionKeyCode: pe, panActivationKeyCode: $, zoomActivationKeyCode: ee, onlyRenderVisibleElements: Ve, defaultViewport: je, translateExtent: ae, minZoom: xe, maxZoom: Q, preventScrolling: Pe, zoomOnScroll: Ot, zoomOnPinch: Ct, zoomOnDoubleClick: Re, panOnScroll: Jt, panOnScrollSpeed: yn, panOnScrollMode: vn, panOnDrag: _e, onPaneClick: jt, onPaneMouseEnter: st, onPaneMouseMove: Mt, onPaneMouseLeave: lt, onPaneScroll: xt, onPaneContextMenu: yt, paneClickDistance: ct, nodeClickDistance: Rt, onSelectionContextMenu: C, onSelectionStart: I, onSelectionEnd: M, onReconnect: Gt, onReconnectStart: hn, onReconnectEnd: en, onEdgeContextMenu: Sn, onEdgeDoubleClick: Ar, onEdgeMouseEnter: or, onEdgeMouseMove: rr, onEdgeMouseLeave: no, reconnectRadius: jn, defaultMarkerColor: Ke, noDragClassName: ca, noWheelClassName: ge, noPanClassName: ve, rfId: On, disableKeyboardA11y: $t, nodeExtent: Fe, viewport: zs, onViewportChange: xd }), y(Cmt, { nodes: e, edges: t, defaultNodes: n, defaultEdges: r, onConnect: p, onConnectStart: h, onConnectEnd: m, onClickConnectStart: v, onClickConnectEnd: b, nodesDraggable: ft, nodesConnectable: me, nodesFocusable: Te, edgesFocusable: le, edgesReconnectable: Oe, elementsSelectable: be, elevateNodesOnSelect: Me, elevateEdgesOnSelect: Ge, minZoom: xe, maxZoom: Q, nodeExtent: Fe, onNodesChange: Xi, onEdgesChange: us, snapToGrid: Ce, snapGrid: Ee, connectionMode: X, translateExtent: ae, connectOnClick: W, defaultEdgeOptions: Ne, fitView: se, fitViewOptions: P, onNodesDelete: R, onEdgesDelete: j, onDelete: F, onNodeDragStart: E, onNodeDrag: k, onNodeDragStop: T, onSelectionDrag: U, onSelectionDragStart: _, onSelectionDragStop: z, onMove: u, onMoveStart: f, onMoveEnd: d, noPanClassName: ve, nodeOrigin: re, rfId: On, autoPanOnConnect: In, autoPanOnNodeDrag: Qn, autoPanSpeed: yr, onError: Lr, connectionRadius: Cn, isValidConnection: Ln, selectNodesOnDrag: et, nodeDragThreshold: ro, onBeforeDelete: D, paneClickDistance: ct, debug: ye }), y(Smt, { onSelectionChange: L }), Yt, y(bmt, { proOptions: de, position: te }), y(ymt, { rfId: On, disableKeyboardA11y: $t })] }) });
}
var Ygt = cEe(Ggt);
const Jgt = (e) => {
  var t;
  return (t = e.domNode) == null ? void 0 : t.querySelector(".react-flow__viewport-portal");
};
function DEe({ children: e }) {
  const t = hr(Jgt);
  return t ? iW(e, t) : null;
}
const eyt = (e) => ({
  x: e.transform[0],
  y: e.transform[1],
  zoom: e.transform[2]
});
function tyt() {
  return hr(eyt, Ii);
}
function nyt({ dimensions: e, lineWidth: t, variant: n, className: r }) {
  return y("path", { strokeWidth: t, d: `M${e[0] / 2} 0 V${e[1]} M0 ${e[1] / 2} H${e[0]}`, className: xo(["react-flow__background-pattern", n, r]) });
}
function ryt({ radius: e, className: t }) {
  return y("circle", { cx: e, cy: e, r: e, className: xo(["react-flow__background-pattern", "dots", t]) });
}
var Yp;
(function(e) {
  e.Lines = "lines", e.Dots = "dots", e.Cross = "cross";
})(Yp || (Yp = {}));
const iyt = {
  [Yp.Dots]: 1,
  [Yp.Lines]: 1,
  [Yp.Cross]: 6
}, oyt = (e) => ({ transform: e.transform, patternId: `pattern-${e.rfId}` });
function _Ee({
  id: e,
  variant: t = Yp.Dots,
  // only used for dots and cross
  gap: n = 20,
  // only used for lines and cross
  size: r,
  lineWidth: i = 1,
  offset: o = 0,
  color: s,
  bgColor: l,
  style: c,
  className: a,
  patternClassName: u
}) {
  const f = Xe(null), { transform: d, patternId: p } = hr(oyt, Ii), h = r || iyt[t], m = t === Yp.Dots, v = t === Yp.Cross, b = Array.isArray(n) ? n : [n, n], A = [b[0] * d[2] || 1, b[1] * d[2] || 1], w = h * d[2], O = Array.isArray(o) ? o : [o, o], x = v ? [w, w] : A, S = [
    O[0] * d[2] || 1 + x[0] / 2,
    O[1] * d[2] || 1 + x[1] / 2
  ], E = `${p}${e || ""}`;
  return V("svg", { className: xo(["react-flow__background", a]), style: {
    ...c,
    ...Wz,
    "--xy-background-color-props": l,
    "--xy-background-pattern-color-props": s
  }, ref: f, "data-testid": "rf__background", children: [y("pattern", { id: E, x: d[0] % A[0], y: d[1] % A[1], width: A[0], height: A[1], patternUnits: "userSpaceOnUse", patternTransform: `translate(-${S[0]},-${S[1]})`, children: m ? y(ryt, { radius: w / 2, className: u }) : y(nyt, { dimensions: x, lineWidth: i, variant: t, className: u }) }), y("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${E})` })] });
}
_Ee.displayName = "Background";
const syt = Ji(_Ee);
function ayt() {
  return y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: y("path", { d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" }) });
}
function lyt() {
  return y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 5", children: y("path", { d: "M0 0h32v4.2H0z" }) });
}
function cyt() {
  return y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 30", children: y("path", { d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" }) });
}
function uyt() {
  return y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: y("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z" }) });
}
function dyt() {
  return y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: y("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z" }) });
}
function LP({ children: e, className: t, ...n }) {
  return y("button", { type: "button", className: xo(["react-flow__controls-button", t]), ...n, children: e });
}
const fyt = (e) => ({
  isInteractive: e.nodesDraggable || e.nodesConnectable || e.elementsSelectable,
  minZoomReached: e.transform[2] <= e.minZoom,
  maxZoomReached: e.transform[2] >= e.maxZoom
});
function LEe({ style: e, showZoom: t = !0, showFitView: n = !0, showInteractive: r = !0, fitViewOptions: i, onZoomIn: o, onZoomOut: s, onFitView: l, onInteractiveChange: c, className: a, children: u, position: f = "bottom-left", orientation: d = "vertical", "aria-label": p = "React Flow controls" }) {
  const h = mi(), { isInteractive: m, minZoomReached: v, maxZoomReached: b } = hr(fyt, Ii), { zoomIn: A, zoomOut: w, fitView: O } = yd(), x = () => {
    A(), o == null || o();
  }, S = () => {
    w(), s == null || s();
  }, E = () => {
    O(i), l == null || l();
  }, k = () => {
    h.setState({
      nodesDraggable: !m,
      nodesConnectable: !m,
      elementsSelectable: !m
    }), c == null || c(!m);
  };
  return V(UQ, { className: xo(["react-flow__controls", d === "horizontal" ? "horizontal" : "vertical", a]), position: f, style: e, "data-testid": "rf__controls", "aria-label": p, children: [t && V(pt, { children: [y(LP, { onClick: x, className: "react-flow__controls-zoomin", title: "zoom in", "aria-label": "zoom in", disabled: b, children: y(ayt, {}) }), y(LP, { onClick: S, className: "react-flow__controls-zoomout", title: "zoom out", "aria-label": "zoom out", disabled: v, children: y(lyt, {}) })] }), n && y(LP, { className: "react-flow__controls-fitview", onClick: E, title: "fit view", "aria-label": "fit view", children: y(cyt, {}) }), r && y(LP, { className: "react-flow__controls-interactive", onClick: k, title: "toggle interactivity", "aria-label": "toggle interactivity", children: m ? y(dyt, {}) : y(uyt, {}) }), u] });
}
LEe.displayName = "Controls";
Ji(LEe);
function pyt({ id: e, x: t, y: n, width: r, height: i, style: o, color: s, strokeColor: l, strokeWidth: c, className: a, borderRadius: u, shapeRendering: f, selected: d, onClick: p }) {
  const { background: h, backgroundColor: m } = o || {}, v = s || h || m;
  return y("rect", { className: xo(["react-flow__minimap-node", { selected: d }, a]), x: t, y: n, rx: u, ry: u, width: r, height: i, style: {
    fill: v,
    stroke: l,
    strokeWidth: c
  }, shapeRendering: f, onClick: p ? (b) => p(b, e) : void 0 });
}
const hyt = Ji(pyt), myt = (e) => e.nodes.map((t) => t.id), b6 = (e) => e instanceof Function ? e : () => e;
function gyt({
  nodeStrokeColor: e,
  nodeColor: t,
  nodeClassName: n = "",
  nodeBorderRadius: r = 5,
  nodeStrokeWidth: i,
  // We need to rename the prop to be `CapitalCase` so that JSX will render it as
  // a component properly.
  nodeComponent: o = hyt,
  onClick: s
}) {
  const l = hr(myt, Ii), c = b6(t), a = b6(e), u = b6(n), f = typeof window > "u" || window.chrome ? "crispEdges" : "geometricPrecision";
  return y(pt, { children: l.map((d) => (
    // The split of responsibilities between MiniMapNodes and
    // NodeComponentWrapper may appear weird. However, it’s designed to
    // minimize the cost of updates when individual nodes change.
    //
    // For more details, see a similar commit in `NodeRenderer/index.tsx`.
    y(vyt, { id: d, nodeColorFunc: c, nodeStrokeColorFunc: a, nodeClassNameFunc: u, nodeBorderRadius: r, nodeStrokeWidth: i, NodeComponent: o, onClick: s, shapeRendering: f }, d)
  )) });
}
function yyt({ id: e, nodeColorFunc: t, nodeStrokeColorFunc: n, nodeClassNameFunc: r, nodeBorderRadius: i, nodeStrokeWidth: o, shapeRendering: s, NodeComponent: l, onClick: c }) {
  const { node: a, x: u, y: f, width: d, height: p } = hr((h) => {
    const m = h.nodeLookup.get(e), { x: v, y: b } = m.internals.positionAbsolute, { width: A, height: w } = Th(m);
    return {
      node: m,
      x: v,
      y: b,
      width: A,
      height: w
    };
  }, Ii);
  return !a || a.hidden || !F1e(a) ? null : y(l, { x: u, y: f, width: d, height: p, style: a.style, selected: !!a.selected, className: r(a), color: t(a), borderRadius: i, strokeColor: n(a), strokeWidth: o, shapeRendering: s, onClick: c, id: a.id });
}
const vyt = Ji(yyt);
var byt = Ji(gyt);
const Oyt = 200, Ayt = 150, wyt = (e) => {
  const t = {
    x: -e.transform[0] / e.transform[2],
    y: -e.transform[1] / e.transform[2],
    width: e.width / e.transform[2],
    height: e.height / e.transform[2]
  };
  return {
    viewBB: t,
    boundingRect: e.nodeLookup.size > 0 ? L1e(iN(e.nodeLookup), t) : t,
    rfId: e.rfId,
    panZoom: e.panZoom,
    translateExtent: e.translateExtent,
    flowWidth: e.width,
    flowHeight: e.height
  };
}, xyt = "react-flow__minimap-desc";
function zEe({
  style: e,
  className: t,
  nodeStrokeColor: n,
  nodeColor: r,
  nodeClassName: i = "",
  nodeBorderRadius: o = 5,
  nodeStrokeWidth: s,
  // We need to rename the prop to be `CapitalCase` so that JSX will render it as
  // a component properly.
  nodeComponent: l,
  bgColor: c,
  maskColor: a,
  maskStrokeColor: u,
  maskStrokeWidth: f,
  position: d = "bottom-right",
  onClick: p,
  onNodeClick: h,
  pannable: m = !1,
  zoomable: v = !1,
  ariaLabel: b = "React Flow mini map",
  inversePan: A,
  zoomStep: w = 10,
  offsetScale: O = 5
}) {
  const x = mi(), S = Xe(null), { boundingRect: E, viewBB: k, rfId: T, panZoom: R, translateExtent: j, flowWidth: F, flowHeight: L } = hr(wyt, Ii), _ = (e == null ? void 0 : e.width) ?? Oyt, U = (e == null ? void 0 : e.height) ?? Ayt, z = E.width / _, C = E.height / U, I = Math.max(z, C), M = I * _, D = I * U, X = O * I, B = E.x - (M - E.width) / 2 - X, q = E.y - (D - E.height) / 2 - X, H = M + X * 2, Y = D + X * 2, J = `${xyt}-${T}`, oe = Xe(0), ce = Xe();
  oe.current = I, nt(() => {
    if (S.current && R)
      return ce.current = Zht({
        domNode: S.current,
        panZoom: R,
        getTransform: () => x.getState().transform,
        getViewScale: () => oe.current
      }), () => {
        var pe;
        (pe = ce.current) == null || pe.destroy();
      };
  }, [R]), nt(() => {
    var pe;
    (pe = ce.current) == null || pe.update({
      translateExtent: j,
      width: F,
      height: L,
      inversePan: A,
      pannable: m,
      zoomStep: w,
      zoomable: v
    });
  }, [m, v, A, w, j, F, L]);
  const fe = p ? (pe) => {
    var Ee;
    const [ee, Ce] = ((Ee = ce.current) == null ? void 0 : Ee.pointer(pe)) || [0, 0];
    p(pe, { x: ee, y: Ce });
  } : void 0, $ = h ? qn((pe, ee) => {
    const Ce = x.getState().nodeLookup.get(ee);
    h(pe, Ce);
  }, []) : void 0;
  return y(UQ, { position: d, style: {
    ...e,
    "--xy-minimap-background-color-props": typeof c == "string" ? c : void 0,
    "--xy-minimap-mask-background-color-props": typeof a == "string" ? a : void 0,
    "--xy-minimap-mask-stroke-color-props": typeof u == "string" ? u : void 0,
    "--xy-minimap-mask-stroke-width-props": typeof f == "number" ? f * I : void 0,
    "--xy-minimap-node-background-color-props": typeof r == "string" ? r : void 0,
    "--xy-minimap-node-stroke-color-props": typeof n == "string" ? n : void 0,
    "--xy-minimap-node-stroke-width-props": typeof s == "string" ? s : void 0
  }, className: xo(["react-flow__minimap", t]), "data-testid": "rf__minimap", children: V("svg", { width: _, height: U, viewBox: `${B} ${q} ${H} ${Y}`, className: "react-flow__minimap-svg", role: "img", "aria-labelledby": J, ref: S, onClick: fe, children: [b && y("title", { id: J, children: b }), y(byt, { onClick: $, nodeColor: r, nodeStrokeColor: n, nodeBorderRadius: o, nodeClassName: i, nodeStrokeWidth: s, nodeComponent: l }), y("path", { className: "react-flow__minimap-mask", d: `M${B - X},${q - X}h${H + X * 2}v${Y + X * 2}h${-H - X * 2}z
        M${k.x},${k.y}h${k.width}v${k.height}h${-k.width}z`, fillRule: "evenodd", pointerEvents: "none" })] }) });
}
zEe.displayName = "MiniMap";
const Syt = Ji(zEe);
function Eyt({ nodeId: e, position: t, variant: n = AE.Handle, className: r, style: i = {}, children: o, color: s, minWidth: l = 10, minHeight: c = 10, maxWidth: a = Number.MAX_VALUE, maxHeight: u = Number.MAX_VALUE, keepAspectRatio: f = !1, shouldResize: d, onResizeStart: p, onResize: h, onResizeEnd: m }) {
  const v = pEe(), b = typeof e == "string" ? e : v, A = mi(), w = Xe(null), O = n === AE.Line ? "right" : "bottom-right", x = t ?? O, S = Xe(null);
  nt(() => {
    if (!(!w.current || !b))
      return S.current || (S.current = amt({
        domNode: w.current,
        nodeId: b,
        getStoreItems: () => {
          const { nodeLookup: R, transform: j, snapGrid: F, snapToGrid: L, nodeOrigin: _, domNode: U } = A.getState();
          return {
            nodeLookup: R,
            transform: j,
            snapGrid: F,
            snapToGrid: L,
            nodeOrigin: _,
            paneDomNode: U
          };
        },
        onChange: (R, j) => {
          const { triggerNodeChanges: F, nodeLookup: L, parentLookup: _, nodeOrigin: U } = A.getState(), z = [], C = { x: R.x, y: R.y }, I = L.get(b);
          if (I && I.expandParent && I.parentId) {
            const M = I.origin ?? U, D = R.width ?? I.measured.width, X = R.height ?? I.measured.height, B = {
              id: I.id,
              parentId: I.parentId,
              rect: {
                width: D,
                height: X,
                ...U1e({
                  x: R.x ?? I.position.x,
                  y: R.y ?? I.position.y
                }, { width: D, height: X }, I.parentId, L, M)
              }
            }, q = FQ([B], L, _, U);
            z.push(...q), C.x = R.x ? Math.max(M[0] * D, R.x) : void 0, C.y = R.y ? Math.max(M[1] * X, R.y) : void 0;
          }
          if (C.x !== void 0 && C.y !== void 0) {
            const M = {
              id: b,
              type: "position",
              position: { ...C }
            };
            z.push(M);
          }
          if (R.width !== void 0 && R.height !== void 0) {
            const M = {
              id: b,
              type: "dimensions",
              resizing: !0,
              setAttributes: !0,
              dimensions: {
                width: R.width,
                height: R.height
              }
            };
            z.push(M);
          }
          for (const M of j) {
            const D = {
              ...M,
              type: "position"
            };
            z.push(D);
          }
          F(z);
        },
        onEnd: () => {
          const R = {
            id: b,
            type: "dimensions",
            resizing: !1
          };
          A.getState().triggerNodeChanges([R]);
        }
      })), S.current.update({
        controlPosition: x,
        boundaries: {
          minWidth: l,
          minHeight: c,
          maxWidth: a,
          maxHeight: u
        },
        keepAspectRatio: f,
        onResizeStart: p,
        onResize: h,
        onResizeEnd: m,
        shouldResize: d
      }), () => {
        var R;
        (R = S.current) == null || R.destroy();
      };
  }, [
    x,
    l,
    c,
    a,
    u,
    f,
    p,
    h,
    m,
    d
  ]);
  const E = x.split("-"), k = n === AE.Line ? "borderColor" : "backgroundColor", T = s ? { ...i, [k]: s } : i;
  return y("div", { className: xo(["react-flow__resize-control", "nodrag", ...E, n, r]), ref: w, style: T, children: o });
}
const Tyt = Ji(Eyt), Ks = {
  findLastStepWithStatus: qQ,
  findLoopsState: kyt,
  extractStepOutput: (e, t, n, r) => {
    const i = n[e];
    if (!De(i))
      return i;
    const o = At.findPathToStep(r, e).filter(
      (s) => s.type === qe.LOOP_ON_ITEMS && At.isChildOf(s, e)
    );
    if (o.length > 0)
      return Nyt(o, t, e, n);
  },
  getStatusIconForStep(e) {
    switch (e) {
      case po.RUNNING:
        return {
          variant: "default",
          Icon: iD,
          text: Z("Running")
        };
      case po.PAUSED:
        return {
          variant: "default",
          Icon: Yre,
          text: Z("Paused")
        };
      case po.STOPPED:
      case po.SUCCEEDED:
        return {
          variant: "success",
          Icon: gB,
          text: Z("Succeeded")
        };
      case po.FAILED:
        return {
          variant: "error",
          Icon: Qh,
          text: Z("Failed")
        };
    }
  },
  getStatusContainerClassName(e) {
    return Se("text-xs   border rounded-md leading-none", {
      "text-green-800 bg-green-50 border-green-200 dark:text-green-200 dark:bg-green-900 dark:border-green-800": e === "success",
      "text-red-800 bg-red-50  border-red-200 dark:text-red-200 dark:bg-red-900 dark:border-red-800": e === "error",
      "bg-background  border-border text-foreground": e === "default"
    });
  },
  getStatusIcon(e) {
    switch (e) {
      case cr.QUEUED:
        return {
          variant: "default",
          Icon: iD
        };
      case cr.RUNNING:
        return {
          variant: "default",
          Icon: zot
        };
      case cr.SUCCEEDED:
        return {
          variant: "success",
          Icon: gB
        };
      case cr.FAILED:
        return {
          variant: "error",
          Icon: Qh
        };
      case cr.PAUSED:
        return {
          variant: "default",
          Icon: Yre
        };
      case cr.CANCELED:
        return {
          variant: "default",
          Icon: hz
        };
      case cr.MEMORY_LIMIT_EXCEEDED:
        return {
          variant: "error",
          Icon: Qh
        };
      case cr.QUOTA_EXCEEDED:
        return {
          variant: "error",
          Icon: Qh
        };
      case cr.INTERNAL_ERROR:
        return {
          variant: "error",
          Icon: Qh
        };
      case cr.TIMEOUT:
        return {
          variant: "error",
          Icon: Qh
        };
    }
  }
};
function kyt(e, t, n) {
  const i = At.getAllSteps(e.trigger).filter((s) => s.type === qe.LOOP_ON_ITEMS).map((s) => ({
    output: t.steps ? t.steps[s.name] : void 0,
    step: s
  })), o = t.steps ? qQ(t.status, t.steps) : null;
  return i.reduce((s, { step: l, output: c }) => {
    const a = o && At.isChildOf(l, o);
    return De(c) ? {
      ...s,
      [l.name]: 0
    } : a && c.output ? {
      ...s,
      [l.name]: c.output.iterations.length - 1
    } : {
      ...s,
      [l.name]: n[l.name] ?? 0
    };
  }, n);
}
function qQ(e, t) {
  if (De(t) || e === cr.SUCCEEDED)
    return null;
  const n = OZ(e) ? po.FAILED : void 0;
  return Object.entries(t).reduce((r, [i, o]) => {
    if (o.type === qe.LOOP_ON_ITEMS && o.output && De(r)) {
      const s = Cyt(
        o,
        e
      );
      if (!De(s))
        return s;
    }
    return De(n) || o.status === n ? i : null;
  }, null);
}
function Cyt(e, t) {
  if (!e.output)
    return null;
  for (const n of e.output.iterations) {
    const r = qQ(t, n);
    if (!De(r))
      return r;
  }
  return null;
}
function Nyt(e, t, n, r) {
  if (e.length === 0)
    return;
  let i = r[e[0].name];
  for (let o = 0; o < e.length; o++) {
    const s = e[o], l = Pyt(e, o, n);
    if (i = Iyt({
      loopStepOutput: i,
      loopName: s.name,
      targetStepName: l,
      loopsIndexes: t
    }), !i)
      return;
  }
  return i;
}
function Pyt(e, t, n) {
  return t + 1 < e.length ? e[t + 1].name : n;
}
function Iyt({
  loopStepOutput: e,
  loopName: t,
  targetStepName: n,
  loopsIndexes: r
}) {
  if (!(e != null && e.output))
    return;
  const i = r[t], o = e.output.iterations;
  if (i < 0 || i >= o.length)
    return;
  const s = o[i];
  if (!De(s))
    return s[n];
}
var zr = /* @__PURE__ */ ((e) => (e.NONE = "none", e.PIECE_SETTINGS = "piece-settings", e.VERSIONS = "versions", e.RUNS = "runs", e))(zr || {}), Jd = /* @__PURE__ */ ((e) => (e.TEST_FLOW = "test-flow", e.TEST_STEP = "test-step", e))(Jd || {});
function Ryt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Kt(
    () => (r) => {
      t.forEach((i) => i(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const Zz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function fx(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function BQ(e) {
  return "nodeType" in e;
}
function Ua(e) {
  var t, n;
  return e ? fx(e) ? e : BQ(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function XQ(e) {
  const {
    Document: t
  } = Ua(e);
  return e instanceof t;
}
function sN(e) {
  return fx(e) ? !1 : e instanceof Ua(e).HTMLElement;
}
function jEe(e) {
  return e instanceof Ua(e).SVGElement;
}
function px(e) {
  return e ? fx(e) ? e.document : BQ(e) ? XQ(e) ? e : sN(e) || jEe(e) ? e.ownerDocument : document : document : document;
}
const su = Zz ? Og : nt;
function Hz(e) {
  const t = Xe(e);
  return su(() => {
    t.current = e;
  }), qn(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function Myt() {
  const e = Xe(null), t = qn((r, i) => {
    e.current = setInterval(r, i);
  }, []), n = qn(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function VT(e, t) {
  t === void 0 && (t = [e]);
  const n = Xe(e);
  return su(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function aN(e, t) {
  const n = Xe();
  return Kt(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function AD(e) {
  const t = Hz(e), n = Xe(null), r = qn(
    (i) => {
      i !== n.current && (t == null || t(i, n.current)), n.current = i;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function wD(e) {
  const t = Xe();
  return nt(() => {
    t.current = e;
  }, [e]), t.current;
}
let O6 = {};
function lN(e, t) {
  return Kt(() => {
    if (t)
      return t;
    const n = O6[e] == null ? 0 : O6[e] + 1;
    return O6[e] = n, e + "-" + n;
  }, [e, t]);
}
function FEe(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return r.reduce((o, s) => {
      const l = Object.entries(s);
      for (const [c, a] of l) {
        const u = o[c];
        u != null && (o[c] = u + e * a);
      }
      return o;
    }, {
      ...t
    });
  };
}
const WO = /* @__PURE__ */ FEe(1), xD = /* @__PURE__ */ FEe(-1);
function Dyt(e) {
  return "clientX" in e && "clientY" in e;
}
function Qz(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Ua(e.target);
  return t && e instanceof t;
}
function _yt(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Ua(e.target);
  return t && e instanceof t;
}
function SD(e) {
  if (_yt(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Dyt(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const ig = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [ig.Translate.toString(e), ig.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), Soe = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Lyt(e) {
  return e.matches(Soe) ? e : e.querySelector(Soe);
}
const zyt = {
  display: "none"
};
function jyt(e) {
  let {
    id: t,
    value: n
  } = e;
  return ie.createElement("div", {
    id: t,
    style: zyt
  }, n);
}
function Fyt(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const i = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return ie.createElement("div", {
    id: t,
    style: i,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Uyt() {
  const [e, t] = He("");
  return {
    announce: qn((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const UEe = /* @__PURE__ */ Ri(null);
function WQ(e) {
  const t = kr(UEe);
  nt(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Vyt() {
  const [e] = He(() => /* @__PURE__ */ new Set()), t = qn((r) => (e.add(r), () => e.delete(r)), [e]);
  return [qn((r) => {
    let {
      type: i,
      event: o
    } = r;
    e.forEach((s) => {
      var l;
      return (l = s[i]) == null ? void 0 : l.call(s, o);
    });
  }, [e]), t];
}
const qyt = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, Byt = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Xyt(e) {
  let {
    announcements: t = Byt,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: i = qyt
  } = e;
  const {
    announce: o,
    announcement: s
  } = Uyt(), l = lN("DndLiveRegion"), [c, a] = He(!1);
  if (nt(() => {
    a(!0);
  }, []), WQ(Kt(() => ({
    onDragStart(f) {
      let {
        active: d
      } = f;
      o(t.onDragStart({
        active: d
      }));
    },
    onDragMove(f) {
      let {
        active: d,
        over: p
      } = f;
      t.onDragMove && o(t.onDragMove({
        active: d,
        over: p
      }));
    },
    onDragOver(f) {
      let {
        active: d,
        over: p
      } = f;
      o(t.onDragOver({
        active: d,
        over: p
      }));
    },
    onDragEnd(f) {
      let {
        active: d,
        over: p
      } = f;
      o(t.onDragEnd({
        active: d,
        over: p
      }));
    },
    onDragCancel(f) {
      let {
        active: d,
        over: p
      } = f;
      o(t.onDragCancel({
        active: d,
        over: p
      }));
    }
  }), [o, t])), !c)
    return null;
  const u = ie.createElement(ie.Fragment, null, ie.createElement(jyt, {
    id: r,
    value: i.draggable
  }), ie.createElement(Fyt, {
    id: l,
    announcement: s
  }));
  return n ? iW(u, n) : u;
}
var Po;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Po || (Po = {}));
function ED() {
}
function wE(e, t) {
  return Kt(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function VEe() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Kt(
    () => [...t].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const td = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function Wyt(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Zyt(e, t) {
  const n = SD(e);
  if (!n)
    return "0 0";
  const r = {
    x: (n.x - t.left) / t.width * 100,
    y: (n.y - t.top) / t.height * 100
  };
  return r.x + "% " + r.y + "%";
}
function Hyt(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return n - r;
}
function Qyt(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return r - n;
}
function $yt(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function Eoe(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const Kyt = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = Eoe(t, t.left, t.top), o = [];
  for (const s of r) {
    const {
      id: l
    } = s, c = n.get(l);
    if (c) {
      const a = Wyt(Eoe(c), i);
      o.push({
        id: l,
        data: {
          droppableContainer: s,
          value: a
        }
      });
    }
  }
  return o.sort(Hyt);
};
function Gyt(e, t) {
  const n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), i = Math.min(t.left + t.width, e.left + e.width), o = Math.min(t.top + t.height, e.top + e.height), s = i - r, l = o - n;
  if (r < i && n < o) {
    const c = t.width * t.height, a = e.width * e.height, u = s * l, f = u / (c + a - u);
    return Number(f.toFixed(4));
  }
  return 0;
}
const XB = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = [];
  for (const o of r) {
    const {
      id: s
    } = o, l = n.get(s);
    if (l) {
      const c = Gyt(l, t);
      c > 0 && i.push({
        id: s,
        data: {
          droppableContainer: o,
          value: c
        }
      });
    }
  }
  return i.sort(Qyt);
};
function Yyt(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function qEe(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : td;
}
function Jyt(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return i.reduce((s, l) => ({
      ...s,
      top: s.top + e * l.y,
      bottom: s.bottom + e * l.y,
      left: s.left + e * l.x,
      right: s.right + e * l.x
    }), {
      ...n
    });
  };
}
const evt = /* @__PURE__ */ Jyt(1);
function BEe(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function tvt(e, t, n) {
  const r = BEe(t);
  if (!r)
    return e;
  const {
    scaleX: i,
    scaleY: o,
    x: s,
    y: l
  } = r, c = e.left - s - (1 - i) * parseFloat(n), a = e.top - l - (1 - o) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = i ? e.width / i : e.width, f = o ? e.height / o : e.height;
  return {
    width: u,
    height: f,
    top: a,
    right: c + u,
    bottom: a + f,
    left: c
  };
}
const nvt = {
  ignoreTransform: !1
};
function hx(e, t) {
  t === void 0 && (t = nvt);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: a,
      transformOrigin: u
    } = Ua(e).getComputedStyle(e);
    a && (n = tvt(n, a, u));
  }
  const {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  } = n;
  return {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  };
}
function Toe(e) {
  return hx(e, {
    ignoreTransform: !0
  });
}
function rvt(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function ivt(e, t) {
  return t === void 0 && (t = Ua(e).getComputedStyle(e)), t.position === "fixed";
}
function ovt(e, t) {
  t === void 0 && (t = Ua(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((i) => {
    const o = t[i];
    return typeof o == "string" ? n.test(o) : !1;
  });
}
function ZQ(e, t) {
  const n = [];
  function r(i) {
    if (t != null && n.length >= t || !i)
      return n;
    if (XQ(i) && i.scrollingElement != null && !n.includes(i.scrollingElement))
      return n.push(i.scrollingElement), n;
    if (!sN(i) || jEe(i) || n.includes(i))
      return n;
    const o = Ua(e).getComputedStyle(i);
    return i !== e && ovt(i, o) && n.push(i), ivt(i, o) ? n : r(i.parentNode);
  }
  return e ? r(e) : n;
}
function XEe(e) {
  const [t] = ZQ(e, 1);
  return t ?? null;
}
function A6(e) {
  return !Zz || !e ? null : fx(e) ? e : BQ(e) ? XQ(e) || e === px(e).scrollingElement ? window : sN(e) ? e : null : null;
}
function WEe(e) {
  return fx(e) ? e.scrollX : e.scrollLeft;
}
function ZEe(e) {
  return fx(e) ? e.scrollY : e.scrollTop;
}
function WB(e) {
  return {
    x: WEe(e),
    y: ZEe(e)
  };
}
var Ho;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Ho || (Ho = {}));
function HEe(e) {
  return !Zz || !e ? !1 : e === document.scrollingElement;
}
function QEe(e) {
  const t = {
    x: 0,
    y: 0
  }, n = HEe(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, r = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, i = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, s = e.scrollTop >= r.y, l = e.scrollLeft >= r.x;
  return {
    isTop: i,
    isLeft: o,
    isBottom: s,
    isRight: l,
    maxScroll: r,
    minScroll: t
  };
}
const svt = {
  x: 0.2,
  y: 0.2
};
function avt(e, t, n, r, i) {
  let {
    top: o,
    left: s,
    right: l,
    bottom: c
  } = n;
  r === void 0 && (r = 10), i === void 0 && (i = svt);
  const {
    isTop: a,
    isBottom: u,
    isLeft: f,
    isRight: d
  } = QEe(e), p = {
    x: 0,
    y: 0
  }, h = {
    x: 0,
    y: 0
  }, m = {
    height: t.height * i.y,
    width: t.width * i.x
  };
  return !a && o <= t.top + m.height ? (p.y = Ho.Backward, h.y = r * Math.abs((t.top + m.height - o) / m.height)) : !u && c >= t.bottom - m.height && (p.y = Ho.Forward, h.y = r * Math.abs((t.bottom - m.height - c) / m.height)), !d && l >= t.right - m.width ? (p.x = Ho.Forward, h.x = r * Math.abs((t.right - m.width - l) / m.width)) : !f && s <= t.left + m.width && (p.x = Ho.Backward, h.x = r * Math.abs((t.left + m.width - s) / m.width)), {
    direction: p,
    speed: h
  };
}
function lvt(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: o,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: o,
      bottom: s,
      width: o,
      height: s
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: i
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: i,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function $Ee(e) {
  return e.reduce((t, n) => WO(t, WB(n)), td);
}
function cvt(e) {
  return e.reduce((t, n) => t + WEe(n), 0);
}
function uvt(e) {
  return e.reduce((t, n) => t + ZEe(n), 0);
}
function KEe(e, t) {
  if (t === void 0 && (t = hx), !e)
    return;
  const {
    top: n,
    left: r,
    bottom: i,
    right: o
  } = t(e);
  XEe(e) && (i <= 0 || o <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const dvt = [["x", ["left", "right"], cvt], ["y", ["top", "bottom"], uvt]];
class HQ {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = ZQ(n), i = $Ee(r);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [o, s, l] of dvt)
      for (const c of s)
        Object.defineProperty(this, c, {
          get: () => {
            const a = l(r), u = i[o] - a;
            return this.rect[c] + u;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class xE {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, r) {
    var i;
    (i = this.target) == null || i.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function fvt(e) {
  const {
    EventTarget: t
  } = Ua(e);
  return e instanceof t ? e : px(e);
}
function w6(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var Mc;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Mc || (Mc = {}));
function koe(e) {
  e.preventDefault();
}
function pvt(e) {
  e.stopPropagation();
}
var Pr;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter";
})(Pr || (Pr = {}));
const GEe = {
  start: [Pr.Space, Pr.Enter],
  cancel: [Pr.Esc],
  end: [Pr.Space, Pr.Enter]
}, hvt = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case Pr.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case Pr.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case Pr.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case Pr.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class QQ {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new xE(px(n)), this.windowListeners = new xE(Ua(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Mc.Resize, this.handleCancel), this.windowListeners.add(Mc.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Mc.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, r = t.node.current;
    r && KEe(r), n(td);
  }
  handleKeyDown(t) {
    if (Qz(t)) {
      const {
        active: n,
        context: r,
        options: i
      } = this.props, {
        keyboardCodes: o = GEe,
        coordinateGetter: s = hvt,
        scrollBehavior: l = "smooth"
      } = i, {
        code: c
      } = t;
      if (o.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (o.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: a
      } = r.current, u = a ? {
        x: a.left,
        y: a.top
      } : td;
      this.referenceCoordinates || (this.referenceCoordinates = u);
      const f = s(t, {
        active: n,
        context: r.current,
        currentCoordinates: u
      });
      if (f) {
        const d = xD(f, u), p = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: h
        } = r.current;
        for (const m of h) {
          const v = t.code, {
            isTop: b,
            isRight: A,
            isLeft: w,
            isBottom: O,
            maxScroll: x,
            minScroll: S
          } = QEe(m), E = lvt(m), k = {
            x: Math.min(v === Pr.Right ? E.right - E.width / 2 : E.right, Math.max(v === Pr.Right ? E.left : E.left + E.width / 2, f.x)),
            y: Math.min(v === Pr.Down ? E.bottom - E.height / 2 : E.bottom, Math.max(v === Pr.Down ? E.top : E.top + E.height / 2, f.y))
          }, T = v === Pr.Right && !A || v === Pr.Left && !w, R = v === Pr.Down && !O || v === Pr.Up && !b;
          if (T && k.x !== f.x) {
            const j = m.scrollLeft + d.x, F = v === Pr.Right && j <= x.x || v === Pr.Left && j >= S.x;
            if (F && !d.y) {
              m.scrollTo({
                left: j,
                behavior: l
              });
              return;
            }
            F ? p.x = m.scrollLeft - j : p.x = v === Pr.Right ? m.scrollLeft - x.x : m.scrollLeft - S.x, p.x && m.scrollBy({
              left: -p.x,
              behavior: l
            });
            break;
          } else if (R && k.y !== f.y) {
            const j = m.scrollTop + d.y, F = v === Pr.Down && j <= x.y || v === Pr.Up && j >= S.y;
            if (F && !d.x) {
              m.scrollTo({
                top: j,
                behavior: l
              });
              return;
            }
            F ? p.y = m.scrollTop - j : p.y = v === Pr.Down ? m.scrollTop - x.y : m.scrollTop - S.y, p.y && m.scrollBy({
              top: -p.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, WO(xD(f, this.referenceCoordinates), p));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
QQ.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: r = GEe,
      onActivation: i
    } = t, {
      active: o
    } = n;
    const {
      code: s
    } = e.nativeEvent;
    if (r.start.includes(s)) {
      const l = o.activatorNode.current;
      return l && e.target !== l ? !1 : (e.preventDefault(), i == null || i({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function Coe(e) {
  return !!(e && "distance" in e);
}
function Noe(e) {
  return !!(e && "delay" in e);
}
class $Q {
  constructor(t, n, r) {
    var i;
    r === void 0 && (r = fvt(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: o
    } = t, {
      target: s
    } = o;
    this.props = t, this.events = n, this.document = px(s), this.documentListeners = new xE(this.document), this.listeners = new xE(r), this.windowListeners = new xE(Ua(s)), this.initialCoordinates = (i = SD(o)) != null ? i : td, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), this.windowListeners.add(Mc.Resize, this.handleCancel), this.windowListeners.add(Mc.DragStart, koe), this.windowListeners.add(Mc.VisibilityChange, this.handleCancel), this.windowListeners.add(Mc.ContextMenu, koe), this.documentListeners.add(Mc.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (Noe(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay);
        return;
      }
      if (Coe(n))
        return;
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(Mc.Click, pvt, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Mc.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: r,
      initialCoordinates: i,
      props: o
    } = this, {
      onMove: s,
      options: {
        activationConstraint: l
      }
    } = o;
    if (!i)
      return;
    const c = (n = SD(t)) != null ? n : td, a = xD(i, c);
    if (!r && l) {
      if (Coe(l)) {
        if (l.tolerance != null && w6(a, l.tolerance))
          return this.handleCancel();
        if (w6(a, l.distance))
          return this.handleStart();
      }
      return Noe(l) && w6(a, l.tolerance) ? this.handleCancel() : void 0;
    }
    t.cancelable && t.preventDefault(), s(c);
  }
  handleEnd() {
    const {
      onEnd: t
    } = this.props;
    this.detach(), t();
  }
  handleCancel() {
    const {
      onCancel: t
    } = this.props;
    this.detach(), t();
  }
  handleKeydown(t) {
    t.code === Pr.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const mvt = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class KQ extends $Q {
  constructor(t) {
    const {
      event: n
    } = t, r = px(n.target);
    super(t, mvt, r);
  }
}
KQ.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const gvt = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var ZB;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(ZB || (ZB = {}));
class YEe extends $Q {
  constructor(t) {
    super(t, gvt, px(t.event.target));
  }
}
YEe.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return n.button === ZB.RightClick ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const x6 = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class GQ extends $Q {
  constructor(t) {
    super(t, x6);
  }
  static setup() {
    return window.addEventListener(x6.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(x6.move.name, t);
    };
    function t() {
    }
  }
}
GQ.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    const {
      touches: i
    } = n;
    return i.length > 1 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
var SE;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(SE || (SE = {}));
var TD;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(TD || (TD = {}));
function yvt(e) {
  let {
    acceleration: t,
    activator: n = SE.Pointer,
    canScroll: r,
    draggingRect: i,
    enabled: o,
    interval: s = 5,
    order: l = TD.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: a,
    scrollableAncestorRects: u,
    delta: f,
    threshold: d
  } = e;
  const p = bvt({
    delta: f,
    disabled: !o
  }), [h, m] = Myt(), v = Xe({
    x: 0,
    y: 0
  }), b = Xe({
    x: 0,
    y: 0
  }), A = Kt(() => {
    switch (n) {
      case SE.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case SE.DraggableRect:
        return i;
    }
  }, [n, i, c]), w = Xe(null), O = qn(() => {
    const S = w.current;
    if (!S)
      return;
    const E = v.current.x * b.current.x, k = v.current.y * b.current.y;
    S.scrollBy(E, k);
  }, []), x = Kt(() => l === TD.TreeOrder ? [...a].reverse() : a, [l, a]);
  nt(
    () => {
      if (!o || !a.length || !A) {
        m();
        return;
      }
      for (const S of x) {
        if ((r == null ? void 0 : r(S)) === !1)
          continue;
        const E = a.indexOf(S), k = u[E];
        if (!k)
          continue;
        const {
          direction: T,
          speed: R
        } = avt(S, k, A, t, d);
        for (const j of ["x", "y"])
          p[j][T[j]] || (R[j] = 0, T[j] = 0);
        if (R.x > 0 || R.y > 0) {
          m(), w.current = S, h(O, s), v.current = R, b.current = T;
          return;
        }
      }
      v.current = {
        x: 0,
        y: 0
      }, b.current = {
        x: 0,
        y: 0
      }, m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      O,
      r,
      m,
      o,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(A),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(p),
      h,
      a,
      x,
      u,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(d)
    ]
  );
}
const vvt = {
  x: {
    [Ho.Backward]: !1,
    [Ho.Forward]: !1
  },
  y: {
    [Ho.Backward]: !1,
    [Ho.Forward]: !1
  }
};
function bvt(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const r = wD(t);
  return aN((i) => {
    if (n || !r || !i)
      return vvt;
    const o = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [Ho.Backward]: i.x[Ho.Backward] || o.x === -1,
        [Ho.Forward]: i.x[Ho.Forward] || o.x === 1
      },
      y: {
        [Ho.Backward]: i.y[Ho.Backward] || o.y === -1,
        [Ho.Forward]: i.y[Ho.Forward] || o.y === 1
      }
    };
  }, [n, t, r]);
}
function Ovt(e, t) {
  const n = t !== null ? e.get(t) : void 0, r = n ? n.node.current : null;
  return aN((i) => {
    var o;
    return t === null ? null : (o = r ?? i) != null ? o : null;
  }, [r, t]);
}
function Avt(e, t) {
  return Kt(() => e.reduce((n, r) => {
    const {
      sensor: i
    } = r, o = i.activators.map((s) => ({
      eventName: s.eventName,
      handler: t(s.handler, r)
    }));
    return [...n, ...o];
  }, []), [e, t]);
}
var qT;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(qT || (qT = {}));
var HB;
(function(e) {
  e.Optimized = "optimized";
})(HB || (HB = {}));
const Poe = /* @__PURE__ */ new Map();
function wvt(e, t) {
  let {
    dragging: n,
    dependencies: r,
    config: i
  } = t;
  const [o, s] = He(null), {
    frequency: l,
    measure: c,
    strategy: a
  } = i, u = Xe(e), f = v(), d = VT(f), p = qn(function(b) {
    b === void 0 && (b = []), !d.current && s((A) => A === null ? b : A.concat(b.filter((w) => !A.includes(w))));
  }, [d]), h = Xe(null), m = aN((b) => {
    if (f && !n)
      return Poe;
    if (!b || b === Poe || u.current !== e || o != null) {
      const A = /* @__PURE__ */ new Map();
      for (let w of e) {
        if (!w)
          continue;
        if (o && o.length > 0 && !o.includes(w.id) && w.rect.current) {
          A.set(w.id, w.rect.current);
          continue;
        }
        const O = w.node.current, x = O ? new HQ(c(O), O) : null;
        w.rect.current = x, x && A.set(w.id, x);
      }
      return A;
    }
    return b;
  }, [e, o, n, f, c]);
  return nt(() => {
    u.current = e;
  }, [e]), nt(
    () => {
      f || p();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, f]
  ), nt(
    () => {
      o && o.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(o)]
  ), nt(
    () => {
      f || typeof l != "number" || h.current !== null || (h.current = setTimeout(() => {
        p(), h.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, f, p, ...r]
  ), {
    droppableRects: m,
    measureDroppableContainers: p,
    measuringScheduled: o != null
  };
  function v() {
    switch (a) {
      case qT.Always:
        return !1;
      case qT.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function YQ(e, t) {
  return aN((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function xvt(e, t) {
  return YQ(e, t);
}
function Svt(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Hz(t), i = Kt(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: o
    } = window;
    return new o(r);
  }, [r, n]);
  return nt(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function $z(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Hz(t), i = Kt(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: o
      } = window;
      return new o(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return nt(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function Evt(e) {
  return new HQ(hx(e), e);
}
function Ioe(e, t, n) {
  t === void 0 && (t = Evt);
  const [r, i] = a2(l, null), o = Svt({
    callback(c) {
      if (e)
        for (const a of c) {
          const {
            type: u,
            target: f
          } = a;
          if (u === "childList" && f instanceof HTMLElement && f.contains(e)) {
            i();
            break;
          }
        }
    }
  }), s = $z({
    callback: i
  });
  return su(() => {
    i(), e ? (s == null || s.observe(e), o == null || o.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (s == null || s.disconnect(), o == null || o.disconnect());
  }, [e]), r;
  function l(c) {
    if (!e)
      return null;
    if (e.isConnected === !1) {
      var a;
      return (a = c ?? n) != null ? a : null;
    }
    const u = t(e);
    return JSON.stringify(c) === JSON.stringify(u) ? c : u;
  }
}
function Tvt(e) {
  const t = YQ(e);
  return qEe(e, t);
}
const Roe = [];
function kvt(e) {
  const t = Xe(e), n = aN((r) => e ? r && r !== Roe && e && t.current && e.parentNode === t.current.parentNode ? r : ZQ(e) : Roe, [e]);
  return nt(() => {
    t.current = e;
  }, [e]), n;
}
function Cvt(e) {
  const [t, n] = He(null), r = Xe(e), i = qn((o) => {
    const s = A6(o.target);
    s && n((l) => l ? (l.set(s, WB(s)), new Map(l)) : null);
  }, []);
  return nt(() => {
    const o = r.current;
    if (e !== o) {
      s(o);
      const l = e.map((c) => {
        const a = A6(c);
        return a ? (a.addEventListener("scroll", i, {
          passive: !0
        }), [a, WB(a)]) : null;
      }).filter((c) => c != null);
      n(l.length ? new Map(l) : null), r.current = e;
    }
    return () => {
      s(e), s(o);
    };
    function s(l) {
      l.forEach((c) => {
        const a = A6(c);
        a == null || a.removeEventListener("scroll", i);
      });
    }
  }, [i, e]), Kt(() => e.length ? t ? Array.from(t.values()).reduce((o, s) => WO(o, s), td) : $Ee(e) : td, [e, t]);
}
function Moe(e, t) {
  t === void 0 && (t = []);
  const n = Xe(null);
  return nt(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), nt(() => {
    const r = e !== td;
    r && !n.current && (n.current = e), !r && n.current && (n.current = null);
  }, [e]), n.current ? xD(e, n.current) : td;
}
function Nvt(e) {
  nt(
    () => {
      if (!Zz)
        return;
      const t = e.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function Pvt(e, t) {
  return Kt(() => e.reduce((n, r) => {
    let {
      eventName: i,
      handler: o
    } = r;
    return n[i] = (s) => {
      o(s, t);
    }, n;
  }, {}), [e, t]);
}
function JEe(e) {
  return Kt(() => e ? rvt(e) : null, [e]);
}
const S6 = [];
function Ivt(e, t) {
  t === void 0 && (t = hx);
  const [n] = e, r = JEe(n ? Ua(n) : null), [i, o] = a2(l, S6), s = $z({
    callback: o
  });
  return e.length > 0 && i === S6 && o(), su(() => {
    e.length ? e.forEach((c) => s == null ? void 0 : s.observe(c)) : (s == null || s.disconnect(), o());
  }, [e]), i;
  function l() {
    return e.length ? e.map((c) => HEe(c) ? r : new HQ(t(c), c)) : S6;
  }
}
function eTe(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return sN(t) ? t : e;
}
function Rvt(e) {
  let {
    measure: t
  } = e;
  const [n, r] = He(null), i = qn((a) => {
    for (const {
      target: u
    } of a)
      if (sN(u)) {
        r((f) => {
          const d = t(u);
          return f ? {
            ...f,
            width: d.width,
            height: d.height
          } : d;
        });
        break;
      }
  }, [t]), o = $z({
    callback: i
  }), s = qn((a) => {
    const u = eTe(a);
    o == null || o.disconnect(), u && (o == null || o.observe(u)), r(u ? t(u) : null);
  }, [t, o]), [l, c] = AD(s);
  return Kt(() => ({
    nodeRef: l,
    rect: n,
    setRef: c
  }), [n, l, c]);
}
const Mvt = [{
  sensor: KQ,
  options: {}
}, {
  sensor: QQ,
  options: {}
}], Dvt = {
  current: {}
}, BR = {
  draggable: {
    measure: Toe
  },
  droppable: {
    measure: Toe,
    strategy: qT.WhileDragging,
    frequency: HB.Optimized
  },
  dragOverlay: {
    measure: hx
  }
};
class EE extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const _vt = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new EE(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: ED
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: BR,
  measureDroppableContainers: ED,
  windowRect: null,
  measuringScheduled: !1
}, tTe = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: ED,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: ED
}, cN = /* @__PURE__ */ Ri(tTe), nTe = /* @__PURE__ */ Ri(_vt);
function Lvt() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new EE()
    }
  };
}
function zvt(e, t) {
  switch (t.type) {
    case Po.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case Po.DragMove:
      return e.draggable.active ? {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      } : e;
    case Po.DragEnd:
    case Po.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Po.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, i = new EE(e.droppable.containers);
      return i.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case Po.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: i
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const s = new EE(e.droppable.containers);
      return s.set(n, {
        ...o,
        disabled: i
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    case Po.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const o = new EE(e.droppable.containers);
      return o.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    default:
      return e;
  }
}
function jvt(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: i
  } = kr(cN), o = wD(r), s = wD(n == null ? void 0 : n.id);
  return nt(() => {
    if (!t && !r && o && s != null) {
      if (!Qz(o) || document.activeElement === o.target)
        return;
      const l = i.get(s);
      if (!l)
        return;
      const {
        activatorNode: c,
        node: a
      } = l;
      if (!c.current && !a.current)
        return;
      requestAnimationFrame(() => {
        for (const u of [c.current, a.current]) {
          if (!u)
            continue;
          const f = Lyt(u);
          if (f) {
            f.focus();
            break;
          }
        }
      });
    }
  }, [r, t, i, s, o]), null;
}
function rTe(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((i, o) => o({
    transform: i,
    ...r
  }), n) : n;
}
function Fvt(e) {
  return Kt(
    () => ({
      draggable: {
        ...BR.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...BR.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...BR.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function Uvt(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: r,
    config: i = !0
  } = e;
  const o = Xe(!1), {
    x: s,
    y: l
  } = typeof i == "boolean" ? {
    x: i,
    y: i
  } : i;
  su(() => {
    if (!s && !l || !t) {
      o.current = !1;
      return;
    }
    if (o.current || !r)
      return;
    const a = t == null ? void 0 : t.node.current;
    if (!a || a.isConnected === !1)
      return;
    const u = n(a), f = qEe(u, r);
    if (s || (f.x = 0), l || (f.y = 0), o.current = !0, Math.abs(f.x) > 0 || Math.abs(f.y) > 0) {
      const d = XEe(a);
      d && d.scrollBy({
        top: f.y,
        left: f.x
      });
    }
  }, [t, s, l, r, n]);
}
const Kz = /* @__PURE__ */ Ri({
  ...td,
  scaleX: 1,
  scaleY: 1
});
var Kh;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Kh || (Kh = {}));
const iTe = /* @__PURE__ */ Ji(function(t) {
  var n, r, i, o;
  let {
    id: s,
    accessibility: l,
    autoScroll: c = !0,
    children: a,
    sensors: u = Mvt,
    collisionDetection: f = XB,
    measuring: d,
    modifiers: p,
    ...h
  } = t;
  const m = a2(zvt, void 0, Lvt), [v, b] = m, [A, w] = Vyt(), [O, x] = He(Kh.Uninitialized), S = O === Kh.Initialized, {
    draggable: {
      active: E,
      nodes: k,
      translate: T
    },
    droppable: {
      containers: R
    }
  } = v, j = E ? k.get(E) : null, F = Xe({
    initial: null,
    translated: null
  }), L = Kt(() => {
    var lt;
    return E != null ? {
      id: E,
      // It's possible for the active node to unmount while dragging
      data: (lt = j == null ? void 0 : j.data) != null ? lt : Dvt,
      rect: F
    } : null;
  }, [E, j]), _ = Xe(null), [U, z] = He(null), [C, I] = He(null), M = VT(h, Object.values(h)), D = lN("DndDescribedBy", s), X = Kt(() => R.getEnabled(), [R]), B = Fvt(d), {
    droppableRects: q,
    measureDroppableContainers: H,
    measuringScheduled: Y
  } = wvt(X, {
    dragging: S,
    dependencies: [T.x, T.y],
    config: B.droppable
  }), J = Ovt(k, E), oe = Kt(() => C ? SD(C) : null, [C]), ce = Mt(), fe = xvt(J, B.draggable.measure);
  Uvt({
    activeNode: E ? k.get(E) : null,
    config: ce.layoutShiftCompensation,
    initialRect: fe,
    measure: B.draggable.measure
  });
  const $ = Ioe(J, B.draggable.measure, fe), pe = Ioe(J ? J.parentElement : null), ee = Xe({
    activatorEvent: null,
    active: null,
    activeNode: J,
    collisionRect: null,
    collisions: null,
    droppableRects: q,
    draggableNodes: k,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: R,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), Ce = R.getNodeFor((n = ee.current.over) == null ? void 0 : n.id), Ee = Rvt({
    measure: B.dragOverlay.measure
  }), Ve = (r = Ee.nodeRef.current) != null ? r : J, et = S ? (i = Ee.rect) != null ? i : $ : null, ft = !!(Ee.nodeRef.current && Ee.rect), me = Tvt(ft ? null : $), Te = JEe(Ve ? Ua(Ve) : null), re = kvt(S ? Ce ?? J : null), le = Ivt(re), Oe = rTe(p, {
    transform: {
      x: T.x - me.x,
      y: T.y - me.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: C,
    active: L,
    activeNodeRect: $,
    containerNodeRect: pe,
    draggingNodeRect: et,
    over: ee.current.over,
    overlayNodeRect: Ee.rect,
    scrollableAncestors: re,
    scrollableAncestorRects: le,
    windowRect: Te
  }), be = oe ? WO(oe, T) : null, je = Cvt(re), xe = Moe(je), Q = Moe(je, [$]), ae = WO(Oe, xe), Pe = et ? evt(et, Oe) : null, Fe = L && Pe ? f({
    active: L,
    collisionRect: Pe,
    droppableRects: q,
    droppableContainers: X,
    pointerCoordinates: be
  }) : null, Ke = $yt(Fe, "id"), [Ot, Ct] = He(null), Jt = ft ? Oe : WO(Oe, Q), yn = Yyt(Jt, (o = Ot == null ? void 0 : Ot.rect) != null ? o : null, $), vn = qn(
    (lt, xt) => {
      let {
        sensor: yt,
        options: ct
      } = xt;
      if (_.current == null)
        return;
      const Rt = k.get(_.current);
      if (!Rt)
        return;
      const Yt = lt.nativeEvent, Gt = new yt({
        active: _.current,
        activeNode: Rt,
        event: Yt,
        options: ct,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: ee,
        onStart(en) {
          const Sn = _.current;
          if (Sn == null)
            return;
          const Ar = k.get(Sn);
          if (!Ar)
            return;
          const {
            onDragStart: or
          } = M.current, rr = {
            active: {
              id: Sn,
              data: Ar.data,
              rect: F
            }
          };
          Qx(() => {
            or == null || or(rr), x(Kh.Initializing), b({
              type: Po.DragStart,
              initialCoordinates: en,
              active: Sn
            }), A({
              type: "onDragStart",
              event: rr
            });
          });
        },
        onMove(en) {
          b({
            type: Po.DragMove,
            coordinates: en
          });
        },
        onEnd: hn(Po.DragEnd),
        onCancel: hn(Po.DragCancel)
      });
      Qx(() => {
        z(Gt), I(lt.nativeEvent);
      });
      function hn(en) {
        return async function() {
          const {
            active: Ar,
            collisions: or,
            over: rr,
            scrollAdjustedTranslate: no
          } = ee.current;
          let jn = null;
          if (Ar && no) {
            const {
              cancelDrop: Xi
            } = M.current;
            jn = {
              activatorEvent: Yt,
              active: Ar,
              collisions: or,
              delta: no,
              over: rr
            }, en === Po.DragEnd && typeof Xi == "function" && await Promise.resolve(Xi(jn)) && (en = Po.DragCancel);
          }
          _.current = null, Qx(() => {
            b({
              type: en
            }), x(Kh.Uninitialized), Ct(null), z(null), I(null);
            const Xi = en === Po.DragEnd ? "onDragEnd" : "onDragCancel";
            if (jn) {
              const us = M.current[Xi];
              us == null || us(jn), A({
                type: Xi,
                event: jn
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [k]
  ), Re = qn((lt, xt) => (yt, ct) => {
    const Rt = yt.nativeEvent, Yt = k.get(ct);
    if (
      // Another sensor is already instantiating
      _.current !== null || // No active draggable
      !Yt || // Event has already been captured
      Rt.dndKit || Rt.defaultPrevented
    )
      return;
    const Gt = {
      active: Yt
    };
    lt(yt, xt.options, Gt) === !0 && (Rt.dndKit = {
      capturedBy: xt.sensor
    }, _.current = ct, vn(yt, xt));
  }, [k, vn]), _e = Avt(u, Re);
  Nvt(u), su(() => {
    $ && O === Kh.Initializing && x(Kh.Initialized);
  }, [$, O]), nt(
    () => {
      const {
        onDragMove: lt
      } = M.current, {
        active: xt,
        activatorEvent: yt,
        collisions: ct,
        over: Rt
      } = ee.current;
      if (!xt || !yt)
        return;
      const Yt = {
        active: xt,
        activatorEvent: yt,
        collisions: ct,
        delta: {
          x: ae.x,
          y: ae.y
        },
        over: Rt
      };
      Qx(() => {
        lt == null || lt(Yt), A({
          type: "onDragMove",
          event: Yt
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ae.x, ae.y]
  ), nt(
    () => {
      const {
        active: lt,
        activatorEvent: xt,
        collisions: yt,
        droppableContainers: ct,
        scrollAdjustedTranslate: Rt
      } = ee.current;
      if (!lt || _.current == null || !xt || !Rt)
        return;
      const {
        onDragOver: Yt
      } = M.current, Gt = ct.get(Ke), hn = Gt && Gt.rect.current ? {
        id: Gt.id,
        rect: Gt.rect.current,
        data: Gt.data,
        disabled: Gt.disabled
      } : null, en = {
        active: lt,
        activatorEvent: xt,
        collisions: yt,
        delta: {
          x: Rt.x,
          y: Rt.y
        },
        over: hn
      };
      Qx(() => {
        Ct(hn), Yt == null || Yt(en), A({
          type: "onDragOver",
          event: en
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ke]
  ), su(() => {
    ee.current = {
      activatorEvent: C,
      active: L,
      activeNode: J,
      collisionRect: Pe,
      collisions: Fe,
      droppableRects: q,
      draggableNodes: k,
      draggingNode: Ve,
      draggingNodeRect: et,
      droppableContainers: R,
      over: Ot,
      scrollableAncestors: re,
      scrollAdjustedTranslate: ae
    }, F.current = {
      initial: et,
      translated: Pe
    };
  }, [L, J, Fe, Pe, k, Ve, et, q, R, Ot, re, ae]), yvt({
    ...ce,
    delta: T,
    draggingRect: Pe,
    pointerCoordinates: be,
    scrollableAncestors: re,
    scrollableAncestorRects: le
  });
  const jt = Kt(() => ({
    active: L,
    activeNode: J,
    activeNodeRect: $,
    activatorEvent: C,
    collisions: Fe,
    containerNodeRect: pe,
    dragOverlay: Ee,
    draggableNodes: k,
    droppableContainers: R,
    droppableRects: q,
    over: Ot,
    measureDroppableContainers: H,
    scrollableAncestors: re,
    scrollableAncestorRects: le,
    measuringConfiguration: B,
    measuringScheduled: Y,
    windowRect: Te
  }), [L, J, $, C, Fe, pe, Ee, k, R, q, Ot, H, re, le, B, Y, Te]), st = Kt(() => ({
    activatorEvent: C,
    activators: _e,
    active: L,
    activeNodeRect: $,
    ariaDescribedById: {
      draggable: D
    },
    dispatch: b,
    draggableNodes: k,
    over: Ot,
    measureDroppableContainers: H
  }), [C, _e, L, $, b, D, k, Ot, H]);
  return ie.createElement(UEe.Provider, {
    value: w
  }, ie.createElement(cN.Provider, {
    value: st
  }, ie.createElement(nTe.Provider, {
    value: jt
  }, ie.createElement(Kz.Provider, {
    value: yn
  }, a)), ie.createElement(jvt, {
    disabled: (l == null ? void 0 : l.restoreFocus) === !1
  })), ie.createElement(Xyt, {
    ...l,
    hiddenTextDescribedById: D
  }));
  function Mt() {
    const lt = (U == null ? void 0 : U.autoScrollEnabled) === !1, xt = typeof c == "object" ? c.enabled === !1 : c === !1, yt = S && !lt && !xt;
    return typeof c == "object" ? {
      ...c,
      enabled: yt
    } : {
      enabled: yt
    };
  }
}), Vvt = /* @__PURE__ */ Ri(null), Doe = "button", qvt = "Droppable";
function JQ(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: i
  } = e;
  const o = lN(qvt), {
    activators: s,
    activatorEvent: l,
    active: c,
    activeNodeRect: a,
    ariaDescribedById: u,
    draggableNodes: f,
    over: d
  } = kr(cN), {
    role: p = Doe,
    roleDescription: h = "draggable",
    tabIndex: m = 0
  } = i ?? {}, v = (c == null ? void 0 : c.id) === t, b = kr(v ? Kz : Vvt), [A, w] = AD(), [O, x] = AD(), S = Pvt(s, t), E = VT(n);
  su(
    () => (f.set(t, {
      id: t,
      key: o,
      node: A,
      activatorNode: O,
      data: E
    }), () => {
      const T = f.get(t);
      T && T.key === o && f.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [f, t]
  );
  const k = Kt(() => ({
    role: p,
    tabIndex: m,
    "aria-disabled": r,
    "aria-pressed": v && p === Doe ? !0 : void 0,
    "aria-roledescription": h,
    "aria-describedby": u.draggable
  }), [r, p, m, v, h, u.draggable]);
  return {
    active: c,
    activatorEvent: l,
    activeNodeRect: a,
    attributes: k,
    isDragging: v,
    listeners: r ? void 0 : S,
    node: A,
    over: d,
    setNodeRef: w,
    setActivatorNodeRef: x,
    transform: b
  };
}
function oTe() {
  return kr(nTe);
}
const Bvt = "Droppable", Xvt = {
  timeout: 25
};
function e$(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: i
  } = e;
  const o = lN(Bvt), {
    active: s,
    dispatch: l,
    over: c,
    measureDroppableContainers: a
  } = kr(cN), u = Xe({
    disabled: n
  }), f = Xe(!1), d = Xe(null), p = Xe(null), {
    disabled: h,
    updateMeasurementsFor: m,
    timeout: v
  } = {
    ...Xvt,
    ...i
  }, b = VT(m ?? r), A = qn(
    () => {
      if (!f.current) {
        f.current = !0;
        return;
      }
      p.current != null && clearTimeout(p.current), p.current = setTimeout(() => {
        a(Array.isArray(b.current) ? b.current : [b.current]), p.current = null;
      }, v);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), w = $z({
    callback: A,
    disabled: h || !s
  }), O = qn((k, T) => {
    w && (T && (w.unobserve(T), f.current = !1), k && w.observe(k));
  }, [w]), [x, S] = AD(O), E = VT(t);
  return nt(() => {
    !w || !x.current || (w.disconnect(), f.current = !1, w.observe(x.current));
  }, [x, w]), su(
    () => (l({
      type: Po.RegisterDroppable,
      element: {
        id: r,
        key: o,
        disabled: n,
        node: x,
        rect: d,
        data: E
      }
    }), () => l({
      type: Po.UnregisterDroppable,
      key: o,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), nt(() => {
    n !== u.current.disabled && (l({
      type: Po.SetDroppableDisabled,
      id: r,
      key: o,
      disabled: n
    }), u.current.disabled = n);
  }, [r, o, n, l]), {
    active: s,
    rect: d,
    isOver: (c == null ? void 0 : c.id) === r,
    node: x,
    over: c,
    setNodeRef: S
  };
}
function Wvt(e) {
  let {
    animation: t,
    children: n
  } = e;
  const [r, i] = He(null), [o, s] = He(null), l = wD(n);
  return !n && !r && l && i(l), su(() => {
    if (!o)
      return;
    const c = r == null ? void 0 : r.key, a = r == null ? void 0 : r.props.id;
    if (c == null || a == null) {
      i(null);
      return;
    }
    Promise.resolve(t(a, o)).then(() => {
      i(null);
    });
  }, [t, r, o]), ie.createElement(ie.Fragment, null, n, r ? Sqe(r, {
    ref: s
  }) : null);
}
const Zvt = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function Hvt(e) {
  let {
    children: t
  } = e;
  return ie.createElement(cN.Provider, {
    value: tTe
  }, ie.createElement(Kz.Provider, {
    value: Zvt
  }, t));
}
const Qvt = {
  position: "fixed",
  touchAction: "none"
}, $vt = (e) => Qz(e) ? "transform 250ms ease" : void 0, Kvt = /* @__PURE__ */ Fo((e, t) => {
  let {
    as: n,
    activatorEvent: r,
    adjustScale: i,
    children: o,
    className: s,
    rect: l,
    style: c,
    transform: a,
    transition: u = $vt
  } = e;
  if (!l)
    return null;
  const f = i ? a : {
    ...a,
    scaleX: 1,
    scaleY: 1
  }, d = {
    ...Qvt,
    width: l.width,
    height: l.height,
    top: l.top,
    left: l.left,
    transform: ig.Transform.toString(f),
    transformOrigin: i && r ? Zyt(r, l) : void 0,
    transition: typeof u == "function" ? u(r) : u,
    ...c
  };
  return ie.createElement(n, {
    className: s,
    style: d,
    ref: t
  }, o);
}), sTe = (e) => (t) => {
  let {
    active: n,
    dragOverlay: r
  } = t;
  const i = {}, {
    styles: o,
    className: s
  } = e;
  if (o != null && o.active)
    for (const [l, c] of Object.entries(o.active))
      c !== void 0 && (i[l] = n.node.style.getPropertyValue(l), n.node.style.setProperty(l, c));
  if (o != null && o.dragOverlay)
    for (const [l, c] of Object.entries(o.dragOverlay))
      c !== void 0 && r.node.style.setProperty(l, c);
  return s != null && s.active && n.node.classList.add(s.active), s != null && s.dragOverlay && r.node.classList.add(s.dragOverlay), function() {
    for (const [c, a] of Object.entries(i))
      n.node.style.setProperty(c, a);
    s != null && s.active && n.node.classList.remove(s.active);
  };
}, Gvt = (e) => {
  let {
    transform: {
      initial: t,
      final: n
    }
  } = e;
  return [{
    transform: ig.Transform.toString(t)
  }, {
    transform: ig.Transform.toString(n)
  }];
}, Yvt = {
  duration: 250,
  easing: "ease",
  keyframes: Gvt,
  sideEffects: /* @__PURE__ */ sTe({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function Jvt(e) {
  let {
    config: t,
    draggableNodes: n,
    droppableContainers: r,
    measuringConfiguration: i
  } = e;
  return Hz((o, s) => {
    if (t === null)
      return;
    const l = n.get(o);
    if (!l)
      return;
    const c = l.node.current;
    if (!c)
      return;
    const a = eTe(s);
    if (!a)
      return;
    const {
      transform: u
    } = Ua(s).getComputedStyle(s), f = BEe(u);
    if (!f)
      return;
    const d = typeof t == "function" ? t : ebt(t);
    return KEe(c, i.draggable.measure), d({
      active: {
        id: o,
        data: l.data,
        node: c,
        rect: i.draggable.measure(c)
      },
      draggableNodes: n,
      dragOverlay: {
        node: s,
        rect: i.dragOverlay.measure(a)
      },
      droppableContainers: r,
      measuringConfiguration: i,
      transform: f
    });
  });
}
function ebt(e) {
  const {
    duration: t,
    easing: n,
    sideEffects: r,
    keyframes: i
  } = {
    ...Yvt,
    ...e
  };
  return (o) => {
    let {
      active: s,
      dragOverlay: l,
      transform: c,
      ...a
    } = o;
    if (!t)
      return;
    const u = {
      x: l.rect.left - s.rect.left,
      y: l.rect.top - s.rect.top
    }, f = {
      scaleX: c.scaleX !== 1 ? s.rect.width * c.scaleX / l.rect.width : 1,
      scaleY: c.scaleY !== 1 ? s.rect.height * c.scaleY / l.rect.height : 1
    }, d = {
      x: c.x - u.x,
      y: c.y - u.y,
      ...f
    }, p = i({
      ...a,
      active: s,
      dragOverlay: l,
      transform: {
        initial: c,
        final: d
      }
    }), [h] = p, m = p[p.length - 1];
    if (JSON.stringify(h) === JSON.stringify(m))
      return;
    const v = r == null ? void 0 : r({
      active: s,
      dragOverlay: l,
      ...a
    }), b = l.node.animate(p, {
      duration: t,
      easing: n,
      fill: "forwards"
    });
    return new Promise((A) => {
      b.onfinish = () => {
        v == null || v(), A();
      };
    });
  };
}
let _oe = 0;
function tbt(e) {
  return Kt(() => {
    if (e != null)
      return _oe++, _oe;
  }, [e]);
}
const aTe = /* @__PURE__ */ ie.memo((e) => {
  let {
    adjustScale: t = !1,
    children: n,
    dropAnimation: r,
    style: i,
    transition: o,
    modifiers: s,
    wrapperElement: l = "div",
    className: c,
    zIndex: a = 999
  } = e;
  const {
    activatorEvent: u,
    active: f,
    activeNodeRect: d,
    containerNodeRect: p,
    draggableNodes: h,
    droppableContainers: m,
    dragOverlay: v,
    over: b,
    measuringConfiguration: A,
    scrollableAncestors: w,
    scrollableAncestorRects: O,
    windowRect: x
  } = oTe(), S = kr(Kz), E = tbt(f == null ? void 0 : f.id), k = rTe(s, {
    activatorEvent: u,
    active: f,
    activeNodeRect: d,
    containerNodeRect: p,
    draggingNodeRect: v.rect,
    over: b,
    overlayNodeRect: v.rect,
    scrollableAncestors: w,
    scrollableAncestorRects: O,
    transform: S,
    windowRect: x
  }), T = YQ(d), R = Jvt({
    config: r,
    draggableNodes: h,
    droppableContainers: m,
    measuringConfiguration: A
  }), j = T ? v.setRef : void 0;
  return ie.createElement(Hvt, null, ie.createElement(Wvt, {
    animation: R
  }, f && E ? ie.createElement(Kvt, {
    key: E,
    id: f.id,
    ref: j,
    as: l,
    activatorEvent: u,
    adjustScale: t,
    className: c,
    transition: o,
    rect: T,
    style: {
      zIndex: a,
      ...i
    },
    transform: k
  }, n) : null));
});
function lTe(e, t, n) {
  var r = this, i = Xe(null), o = Xe(0), s = Xe(null), l = Xe([]), c = Xe(), a = Xe(), u = Xe(e), f = Xe(!0);
  u.current = e;
  var d = typeof window < "u", p = !t && t !== 0 && d;
  if (typeof e != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var h = !!(n = n || {}).leading, m = !("trailing" in n) || !!n.trailing, v = "maxWait" in n, b = "debounceOnServer" in n && !!n.debounceOnServer, A = v ? Math.max(+n.maxWait || 0, t) : null;
  nt(function() {
    return f.current = !0, function() {
      f.current = !1;
    };
  }, []);
  var w = Kt(function() {
    var O = function(R) {
      var j = l.current, F = c.current;
      return l.current = c.current = null, o.current = R, a.current = u.current.apply(F, j);
    }, x = function(R, j) {
      p && cancelAnimationFrame(s.current), s.current = p ? requestAnimationFrame(R) : setTimeout(R, j);
    }, S = function(R) {
      if (!f.current) return !1;
      var j = R - i.current;
      return !i.current || j >= t || j < 0 || v && R - o.current >= A;
    }, E = function(R) {
      return s.current = null, m && l.current ? O(R) : (l.current = c.current = null, a.current);
    }, k = function R() {
      var j = Date.now();
      if (S(j)) return E(j);
      if (f.current) {
        var F = t - (j - i.current), L = v ? Math.min(F, A - (j - o.current)) : F;
        x(R, L);
      }
    }, T = function() {
      if (d || b) {
        var R = Date.now(), j = S(R);
        if (l.current = [].slice.call(arguments), c.current = r, i.current = R, j) {
          if (!s.current && f.current) return o.current = i.current, x(k, t), h ? O(i.current) : a.current;
          if (v) return x(k, t), O(i.current);
        }
        return s.current || x(k, t), a.current;
      }
    };
    return T.cancel = function() {
      s.current && (p ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), o.current = 0, l.current = i.current = c.current = s.current = null;
    }, T.isPending = function() {
      return !!s.current;
    }, T.flush = function() {
      return s.current ? E(Date.now()) : a.current;
    }, T;
  }, [h, v, t, A, m, p, d, b]);
  return w;
}
function nbt(e, t) {
  return e === t;
}
function rbt(e, t) {
  return t;
}
function Gz(e, t, n) {
  var r = nbt, i = a2(rbt, e), o = i[0], s = i[1], l = lTe(qn(function(a) {
    return s(a);
  }, [s]), t, n), c = Xe(e);
  return r(c.current, e) || (l(e), c.current = e), [o, l];
}
var t$ = "Popover", [cTe, $hn] = Ms(t$, [
  _f
]), uN = _f(), [ibt, kg] = cTe(t$), uTe = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !1
  } = e, l = uN(t), c = N.useRef(null), [a, u] = N.useState(!1), [f = !1, d] = wl({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ y(ox, { ...l, children: /* @__PURE__ */ y(
    ibt,
    {
      scope: t,
      contentId: ka(),
      triggerRef: c,
      open: f,
      onOpenChange: d,
      onOpenToggle: N.useCallback(() => d((p) => !p), [d]),
      hasCustomAnchor: a,
      onCustomAnchorAdd: N.useCallback(() => u(!0), []),
      onCustomAnchorRemove: N.useCallback(() => u(!1), []),
      modal: s,
      children: n
    }
  ) });
};
uTe.displayName = t$;
var dTe = "PopoverAnchor", obt = N.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = kg(dTe, n), o = uN(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: l } = i;
    return N.useEffect(() => (s(), () => l()), [s, l]), /* @__PURE__ */ y(sx, { ...o, ...r, ref: t });
  }
);
obt.displayName = dTe;
var fTe = "PopoverTrigger", pTe = N.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = kg(fTe, n), o = uN(n), s = xn(t, i.triggerRef), l = /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": vTe(i.open),
        ...r,
        ref: s,
        onClick: ot(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? l : /* @__PURE__ */ y(sx, { asChild: !0, ...o, children: l });
  }
);
pTe.displayName = fTe;
var n$ = "PopoverPortal", [sbt, abt] = cTe(n$, {
  forceMount: void 0
}), hTe = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = kg(n$, t);
  return /* @__PURE__ */ y(sbt, { scope: t, forceMount: n, children: /* @__PURE__ */ y(wo, { present: n || o.open, children: /* @__PURE__ */ y(ax, { asChild: !0, container: i, children: r }) }) });
};
hTe.displayName = n$;
var sw = "PopoverContent", mTe = N.forwardRef(
  (e, t) => {
    const n = abt(sw, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = kg(sw, e.__scopePopover);
    return /* @__PURE__ */ y(wo, { present: r || o.open, children: o.modal ? /* @__PURE__ */ y(lbt, { ...i, ref: t }) : /* @__PURE__ */ y(cbt, { ...i, ref: t }) });
  }
);
mTe.displayName = sw;
var lbt = N.forwardRef(
  (e, t) => {
    const n = kg(sw, e.__scopePopover), r = N.useRef(null), i = xn(t, r), o = N.useRef(!1);
    return N.useEffect(() => {
      const s = r.current;
      if (s) return ux(s);
    }, []), /* @__PURE__ */ y(eN, { as: is, allowPinchZoom: !0, children: /* @__PURE__ */ y(
      gTe,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ot(e.onCloseAutoFocus, (s) => {
          var l;
          s.preventDefault(), o.current || (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: ot(
          e.onPointerDownOutside,
          (s) => {
            const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, a = l.button === 2 || c;
            o.current = a;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: ot(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), cbt = N.forwardRef(
  (e, t) => {
    const n = kg(sw, e.__scopePopover), r = N.useRef(!1), i = N.useRef(!1);
    return /* @__PURE__ */ y(
      gTe,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, l;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (l = n.triggerRef.current) == null || l.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, a;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((a = n.triggerRef.current) == null ? void 0 : a.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), gTe = N.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: a,
      onInteractOutside: u,
      ...f
    } = e, d = kg(sw, n), p = uN(n);
    return Ez(), /* @__PURE__ */ y(
      lx,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ y(
          nx,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: l,
            onPointerDownOutside: c,
            onFocusOutside: a,
            onDismiss: () => d.onOpenChange(!1),
            children: /* @__PURE__ */ y(
              KC,
              {
                "data-state": vTe(d.open),
                role: "dialog",
                id: d.contentId,
                ...p,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), yTe = "PopoverClose", ubt = N.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = kg(yTe, n);
    return /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ot(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
ubt.displayName = yTe;
var dbt = "PopoverArrow", fbt = N.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = uN(n);
    return /* @__PURE__ */ y(GC, { ...i, ...r, ref: t });
  }
);
fbt.displayName = dbt;
function vTe(e) {
  return e ? "open" : "closed";
}
var bTe = uTe, OTe = pTe, ATe = hTe, r$ = mTe;
const mx = bTe, gx = OTe, Sb = N.forwardRef(
  ({ className: e, align: t = "center", sideOffset: n = 4, container: r, ...i }, o) => /* @__PURE__ */ y(ATe, { container: r, children: /* @__PURE__ */ y(
    r$,
    {
      ref: o,
      align: t,
      sideOffset: n,
      className: Se(
        "z-[1500] w-72 rounded-md border bg-background p-4 text-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...i
    }
  ) })
);
Sb.displayName = r$.displayName;
const wTe = Ri({
  searchQuery: "",
  setSearchQuery: () => {
  }
}), pbt = ({
  children: e
}) => {
  const [t, n] = He("");
  return /* @__PURE__ */ y(wTe.Provider, { value: { searchQuery: t, setSearchQuery: n }, children: e });
}, Yz = () => kr(wTe);
var $o = /* @__PURE__ */ ((e) => (e.EXPLORE = "EXPLORE", e.AI_AND_AGENTS = "AI_AND_AGENTS", e.APPS = "APPS", e.UTILITY = "UTILITY", e.NONE = "NONE", e))($o || {});
const xTe = Ri({
  selectedTab: "EXPLORE",
  setSelectedTab: (e) => {
  },
  resetToBeforeNoneWasSelected: () => {
  },
  setSelectedPieceInExplore: (e) => {
  },
  selectedPieceInExplore: null
}), hbt = ({
  children: e,
  onTabChange: t,
  initiallySelectedTab: n
}) => {
  const [r, i] = He(n), [o, s] = He(n), [l, c] = He(null);
  return /* @__PURE__ */ y(
    xTe.Provider,
    {
      value: {
        selectedTab: r,
        setSelectedPieceInExplore: c,
        selectedPieceInExplore: l,
        setSelectedTab: (a) => {
          a !== "NONE" && (s(a), t(a)), i(a);
        },
        resetToBeforeNoneWasSelected: () => {
          i(o);
        }
      },
      children: e
    }
  );
}, yx = () => {
  const e = kr(xTe);
  if (!e)
    throw new Error(
      "usePieceSelectorTabs must be used within a PieceSelectorTabsProvider"
    );
  return e;
}, STe = N.forwardRef(
  ({ type: e, ...t }, n) => /* @__PURE__ */ V("div", { className: "grow flex items-center gap-2 w-full rounded-md border border-input bg-background px-3 transition-colors focus-within:border-ring focus-within:ring-1 focus-within:ring-ring focus-within:outline-none disabled:cursor-not-allowed disabled:opacity-50 box-border", children: [
    /* @__PURE__ */ y(QC, { className: "size-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ y(
      "input",
      {
        className: "flex h-9 grow bg-transparent py-1 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed",
        type: e,
        ref: n,
        ...t,
        onChange: (r) => t.onChange(r.target.value),
        "data-testid": "pieces-search-input"
      }
    ),
    t.value !== "" && /* @__PURE__ */ y(
      Pv,
      {
        tooltipText: Z("Clear"),
        onClick: (r) => {
          r.stopPropagation(), r.preventDefault(), t.onChange("");
        },
        Icon: ks
      }
    )
  ] })
);
STe.displayName = "SearchInput";
const ETe = ({
  searchInputRef: e,
  onSearchChange: t
}) => {
  const { searchQuery: n, setSearchQuery: r } = Yz(), {
    resetToBeforeNoneWasSelected: i,
    setSelectedTab: o,
    selectedPieceInExplore: s,
    selectedTab: l,
    setSelectedPieceInExplore: c
  } = yx(), a = s && l === $o.EXPLORE;
  return /* @__PURE__ */ V("div", { className: "p-2 flex gap-2 items-center", children: [
    a && /* @__PURE__ */ y(
      Qe,
      {
        variant: "ghost",
        size: "icon",
        onClick: () => {
          c(null);
        },
        children: /* @__PURE__ */ y(Hrt, { className: "size-4 rtl:rotate-180" })
      }
    ),
    /* @__PURE__ */ y(
      STe,
      {
        placeholder: Z("Search"),
        value: n,
        ref: e,
        onChange: (u) => {
          r(u), t(u), u === "" ? i() : o($o.NONE);
        }
      }
    )
  ] });
};
ETe.displayName = "PiecesSearchInput";
function Jz(e) {
  const t = e + "CollectionProvider", [n, r] = Ms(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (p) => {
    const { scope: h, children: m } = p, v = ie.useRef(null), b = ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y(i, { scope: h, itemMap: b, collectionRef: v, children: m });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", c = ie.forwardRef(
    (p, h) => {
      const { scope: m, children: v } = p, b = o(l, m), A = xn(h, b.collectionRef);
      return /* @__PURE__ */ y(is, { ref: A, children: v });
    }
  );
  c.displayName = l;
  const a = e + "CollectionItemSlot", u = "data-radix-collection-item", f = ie.forwardRef(
    (p, h) => {
      const { scope: m, children: v, ...b } = p, A = ie.useRef(null), w = xn(h, A), O = o(a, m);
      return ie.useEffect(() => (O.itemMap.set(A, { ref: A, ...b }), () => void O.itemMap.delete(A))), /* @__PURE__ */ y(is, { [u]: "", ref: w, children: v });
    }
  );
  f.displayName = a;
  function d(p) {
    const h = o(e + "CollectionConsumer", p);
    return ie.useCallback(() => {
      const v = h.collectionRef.current;
      if (!v) return [];
      const b = Array.from(v.querySelectorAll(`[${u}]`));
      return Array.from(h.itemMap.values()).sort(
        (O, x) => b.indexOf(O.ref.current) - b.indexOf(x.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: f },
    d,
    r
  ];
}
var mbt = N.createContext(void 0);
function Eb(e) {
  const t = N.useContext(mbt);
  return e || t || "ltr";
}
var E6 = "rovingFocusGroup.onEntryFocus", gbt = { bubbles: !1, cancelable: !0 }, ej = "RovingFocusGroup", [QB, TTe, ybt] = Jz(ej), [vbt, Cg] = Ms(
  ej,
  [ybt]
), [bbt, Obt] = vbt(ej), kTe = N.forwardRef(
  (e, t) => /* @__PURE__ */ y(QB.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(QB.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(Abt, { ...e, ref: t }) }) })
);
kTe.displayName = ej;
var Abt = N.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: s,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: a,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = e, d = N.useRef(null), p = xn(t, d), h = Eb(o), [m = null, v] = wl({
    prop: s,
    defaultProp: l,
    onChange: c
  }), [b, A] = N.useState(!1), w = ti(a), O = TTe(n), x = N.useRef(!1), [S, E] = N.useState(0);
  return N.useEffect(() => {
    const k = d.current;
    if (k)
      return k.addEventListener(E6, w), () => k.removeEventListener(E6, w);
  }, [w]), /* @__PURE__ */ y(
    bbt,
    {
      scope: n,
      orientation: r,
      dir: h,
      loop: i,
      currentTabStopId: m,
      onItemFocus: N.useCallback(
        (k) => v(k),
        [v]
      ),
      onItemShiftTab: N.useCallback(() => A(!0), []),
      onFocusableItemAdd: N.useCallback(
        () => E((k) => k + 1),
        []
      ),
      onFocusableItemRemove: N.useCallback(
        () => E((k) => k - 1),
        []
      ),
      children: /* @__PURE__ */ y(
        Zt.div,
        {
          tabIndex: b || S === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: ot(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: ot(e.onFocus, (k) => {
            const T = !x.current;
            if (k.target === k.currentTarget && T && !b) {
              const R = new CustomEvent(E6, gbt);
              if (k.currentTarget.dispatchEvent(R), !R.defaultPrevented) {
                const j = O().filter((z) => z.focusable), F = j.find((z) => z.active), L = j.find((z) => z.id === m), U = [F, L, ...j].filter(
                  Boolean
                ).map((z) => z.ref.current);
                PTe(U, u);
              }
            }
            x.current = !1;
          }),
          onBlur: ot(e.onBlur, () => A(!1))
        }
      )
    }
  );
}), CTe = "RovingFocusGroupItem", NTe = N.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...s
    } = e, l = ka(), c = o || l, a = Obt(CTe, n), u = a.currentTabStopId === c, f = TTe(n), { onFocusableItemAdd: d, onFocusableItemRemove: p } = a;
    return N.useEffect(() => {
      if (r)
        return d(), () => p();
    }, [r, d, p]), /* @__PURE__ */ y(
      QB.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ y(
          Zt.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": a.orientation,
            ...s,
            ref: t,
            onMouseDown: ot(e.onMouseDown, (h) => {
              r ? a.onItemFocus(c) : h.preventDefault();
            }),
            onFocus: ot(e.onFocus, () => a.onItemFocus(c)),
            onKeyDown: ot(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                a.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const m = Sbt(h, a.orientation, a.dir);
              if (m !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let b = f().filter((A) => A.focusable).map((A) => A.ref.current);
                if (m === "last") b.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && b.reverse();
                  const A = b.indexOf(h.currentTarget);
                  b = a.loop ? Ebt(b, A + 1) : b.slice(A + 1);
                }
                setTimeout(() => PTe(b));
              }
            })
          }
        )
      }
    );
  }
);
NTe.displayName = CTe;
var wbt = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function xbt(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Sbt(e, t, n) {
  const r = xbt(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return wbt[r];
}
function PTe(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Ebt(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var tj = kTe, nj = NTe, i$ = "Tabs", [Tbt, Khn] = Ms(i$, [
  Cg
]), ITe = Cg(), [kbt, o$] = Tbt(i$), RTe = N.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: s = "horizontal",
      dir: l,
      activationMode: c = "automatic",
      ...a
    } = e, u = Eb(l), [f, d] = wl({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ y(
      kbt,
      {
        scope: n,
        baseId: ka(),
        value: f,
        onValueChange: d,
        orientation: s,
        dir: u,
        activationMode: c,
        children: /* @__PURE__ */ y(
          Zt.div,
          {
            dir: u,
            "data-orientation": s,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
RTe.displayName = i$;
var MTe = "TabsList", DTe = N.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = e, o = o$(MTe, n), s = ITe(n);
    return /* @__PURE__ */ y(
      tj,
      {
        asChild: !0,
        ...s,
        orientation: o.orientation,
        dir: o.dir,
        loop: r,
        children: /* @__PURE__ */ y(
          Zt.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
DTe.displayName = MTe;
var _Te = "TabsTrigger", LTe = N.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, s = o$(_Te, n), l = ITe(n), c = FTe(s.baseId, r), a = UTe(s.baseId, r), u = r === s.value;
    return /* @__PURE__ */ y(
      nj,
      {
        asChild: !0,
        ...l,
        focusable: !i,
        active: u,
        children: /* @__PURE__ */ y(
          Zt.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": a,
            "data-state": u ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: c,
            ...o,
            ref: t,
            onMouseDown: ot(e.onMouseDown, (f) => {
              !i && f.button === 0 && f.ctrlKey === !1 ? s.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: ot(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && s.onValueChange(r);
            }),
            onFocus: ot(e.onFocus, () => {
              const f = s.activationMode !== "manual";
              !u && !i && f && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
LTe.displayName = _Te;
var zTe = "TabsContent", jTe = N.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: o, ...s } = e, l = o$(zTe, n), c = FTe(l.baseId, r), a = UTe(l.baseId, r), u = r === l.value, f = N.useRef(u);
    return N.useEffect(() => {
      const d = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(d);
    }, []), /* @__PURE__ */ y(wo, { present: i || u, children: ({ present: d }) => /* @__PURE__ */ y(
      Zt.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": l.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !d,
        id: a,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: d && o
      }
    ) });
  }
);
jTe.displayName = zTe;
function FTe(e, t) {
  return `${e}-trigger-${t}`;
}
function UTe(e, t) {
  return `${e}-content-${t}`;
}
var Cbt = RTe, VTe = DTe, qTe = LTe, BTe = jTe;
const vx = Cbt, Nbt = as("inline-flex ", {
  variants: {
    variant: {
      default: "items-center justify-center h-10 rounded-md bg-muted p-1 text-muted-foreground",
      outline: ""
      // Add more variants here
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Pbt = as("inline-flex items-center justify-center", {
  variants: {
    variant: {
      default: "whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-xs",
      outline: "px-3 py-1.5 text-sm font-medium ring-offset-background transition-all border-b-2 border-transparent data-[state=active]:border-secondary data-[state=active]:text-foreground text-muted-foreground"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Tb = N.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ y(
  VTe,
  {
    ref: r,
    className: Se(Nbt({ variant: t, className: e })),
    ...n
  }
));
Tb.displayName = VTe.displayName;
const Ca = N.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ y(
  qTe,
  {
    ref: r,
    className: Se(Pbt({ variant: t, className: e })),
    ...n
  }
));
Ca.displayName = qTe.displayName;
const yl = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  BTe,
  {
    ref: n,
    className: Se(
      "mt-5 ring-offset-background focus-visible:outline-none",
      e
    ),
    ...t
  }
));
yl.displayName = BTe.displayName;
const Ibt = ({ tabs: e }) => {
  const { selectedTab: t, setSelectedTab: n } = yx();
  return /* @__PURE__ */ y(
    vx,
    {
      value: t,
      onValueChange: (r) => n(r),
      className: "max-w-xs w-full",
      children: /* @__PURE__ */ y(Tb, { className: "h-14 w-full grid grid-cols-4 p-0 bg-background justify-start rounded-none", children: e.map((r) => /* @__PURE__ */ V(
        Ca,
        {
          value: r.value,
          className: `flex flex-col rounded-none bg-background h-full
               data-[state=active]:text-accent-foreground data-[state=active]:shadow-none
               border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:active  data-[state=active]:text-primary   [&>svg]:size-5  [&>svg]:shrink-0`,
          children: [
            r.icon,
            /* @__PURE__ */ y("span", { className: "mt-1.5 text-[13px]", children: r.name })
          ]
        },
        r.value
      )) })
    }
  );
}, XTe = g.Object({
  retryOnFailure: g.Object({
    defaultValue: g.Optional(g.Boolean()),
    hide: g.Optional(g.Boolean())
  }),
  continueOnFailure: g.Object({
    defaultValue: g.Optional(g.Boolean()),
    hide: g.Optional(g.Boolean())
  })
});
class WTe {
  constructor(t, n, r, i, o, s, l, c) {
    this.name = t, this.displayName = n, this.description = r, this.props = i, this.run = o, this.test = s, this.requireAuth = l, this.errorHandlingOptions = c;
  }
}
const Rbt = (e) => new WTe(
  e.name,
  e.displayName,
  e.description,
  e.props,
  e.run,
  e.test ?? e.run,
  e.requireAuth ?? !0,
  e.errorHandlingOptions ?? {
    continueOnFailure: {
      defaultValue: !1
    },
    retryOnFailure: {
      defaultValue: !1
    }
  }
), ls = g.Object({
  displayName: g.String(),
  description: g.Optional(g.String())
}), eo = (e, t) => g.Object({
  type: g.Literal(t),
  required: g.Boolean(),
  defaultValue: g.Optional(g.Any())
});
var Le = /* @__PURE__ */ ((e) => (e.SHORT_TEXT = "SHORT_TEXT", e.LONG_TEXT = "LONG_TEXT", e.MARKDOWN = "MARKDOWN", e.DROPDOWN = "DROPDOWN", e.STATIC_DROPDOWN = "STATIC_DROPDOWN", e.NUMBER = "NUMBER", e.CHECKBOX = "CHECKBOX", e.OAUTH2 = "OAUTH2", e.SECRET_TEXT = "SECRET_TEXT", e.ARRAY = "ARRAY", e.OBJECT = "OBJECT", e.BASIC_AUTH = "BASIC_AUTH", e.JSON = "JSON", e.MULTI_SELECT_DROPDOWN = "MULTI_SELECT_DROPDOWN", e.STATIC_MULTI_SELECT_DROPDOWN = "STATIC_MULTI_SELECT_DROPDOWN", e.DYNAMIC = "DYNAMIC", e.CUSTOM_AUTH = "CUSTOM_AUTH", e.DATE_TIME = "DATE_TIME", e.FILE = "FILE", e.CUSTOM = "CUSTOM", e.COLOR = "COLOR", e))(Le || {});
const bx = g.Composite([
  ls,
  eo(g.String(), Le.SHORT_TEXT)
]), rj = g.Composite([
  ls,
  eo(g.String(), Le.LONG_TEXT)
]), ZTe = g.Object({
  label: g.String(),
  value: g.Unknown()
}), s$ = g.Object({
  disabled: g.Optional(g.Boolean()),
  placeholder: g.Optional(g.String()),
  options: g.Array(ZTe)
}), Ox = g.Composite([
  ls,
  g.Object({
    options: s$
  }),
  eo(g.Unknown(), Le.STATIC_DROPDOWN)
]), ij = g.Composite([
  ls,
  g.Object({
    options: s$
  }),
  eo(g.Array(g.Unknown()), Le.STATIC_MULTI_SELECT_DROPDOWN)
]), HTe = g.Composite([
  ls,
  eo(g.Unknown(), Le.DROPDOWN),
  g.Object({
    refreshers: g.Array(g.String())
  })
]), a$ = g.Composite([
  ls,
  eo(g.Array(g.Unknown()), Le.MULTI_SELECT_DROPDOWN),
  g.Object({
    refreshers: g.Array(g.String())
  })
]), oj = g.Composite([
  ls,
  eo(g.Boolean(), Le.CHECKBOX)
]), sj = g.Composite([
  ls,
  eo(g.Number(), Le.NUMBER)
]);
class Mbt {
  constructor(t, n, r) {
    this.filename = t, this.data = n, this.extension = r;
  }
  get base64() {
    return this.data.toString("base64");
  }
}
const l$ = g.Composite([
  ls,
  eo(g.Unknown(), Le.FILE)
]), c$ = g.Composite([
  ls,
  eo(g.String(), Le.DATE_TIME)
]), QTe = g.Record(g.String(), g.Union([
  bx,
  rj,
  Ox,
  a$,
  ij,
  oj,
  sj,
  l$,
  c$
])), u$ = g.Composite([
  ls,
  g.Object({
    properties: QTe
  }),
  eo(g.Array(g.Unknown()), Le.ARRAY)
]), d$ = g.Composite([
  ls,
  eo(
    g.Union([g.Record(g.String(), g.Unknown())]),
    Le.JSON
  )
]), $Te = g.Union([
  bx,
  Ox,
  d$,
  u$,
  ij
]), Dbt = g.Record(g.String(), $Te), KTe = g.Composite([
  g.Object({
    refreshers: g.Array(g.String())
  }),
  ls,
  eo(g.Unknown(), Le.DYNAMIC)
]), _bt = g.Composite([
  ls,
  eo(g.Void(), Le.MARKDOWN)
]), GTe = g.Composite([
  ls,
  eo(
    g.Record(g.String(), g.Unknown()),
    Le.OBJECT
  )
]), Lbt = g.Composite([
  ls,
  eo(g.String(), Le.COLOR)
]), YTe = g.Union([
  bx,
  rj,
  _bt,
  oj,
  Ox,
  ij,
  HTe,
  a$,
  KTe,
  sj,
  u$,
  GTe,
  d$,
  c$,
  l$,
  Lbt
]), zbt = {
  ShortText(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.SHORT_TEXT
    };
  },
  Checkbox(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.CHECKBOX
    };
  },
  LongText(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.LONG_TEXT
    };
  },
  MarkDown(e) {
    return {
      displayName: "Markdown",
      required: !1,
      description: e.value,
      type: Le.MARKDOWN,
      valueSchema: void 0,
      variant: e.variant ?? gs.INFO
    };
  },
  Number(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.NUMBER
    };
  },
  Json(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.JSON
    };
  },
  Array(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.ARRAY
    };
  },
  Object(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.OBJECT
    };
  },
  Dropdown(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.DROPDOWN
    };
  },
  StaticDropdown(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.STATIC_DROPDOWN
    };
  },
  MultiSelectDropdown(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.MULTI_SELECT_DROPDOWN
    };
  },
  DynamicProperties(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.DYNAMIC
    };
  },
  StaticMultiSelectDropdown(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.STATIC_MULTI_SELECT_DROPDOWN
    };
  },
  DateTime(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.DATE_TIME
    };
  },
  File(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.FILE
    };
  },
  Custom(e) {
    const t = e.code.toString();
    return {
      ...e,
      code: t,
      valueSchema: void 0,
      type: Le.CUSTOM
    };
  },
  Color(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.COLOR
    };
  }
}, aj = g.Object({
  displayName: g.String(),
  description: g.Optional(g.String())
}), JTe = g.Object({
  username: g.String(),
  password: g.String()
}), eke = g.Composite([
  aj,
  g.Object({
    username: g.Object({
      displayName: g.String(),
      description: g.Optional(g.String())
    }),
    password: g.Object({
      displayName: g.String(),
      description: g.Optional(g.String())
    })
  }),
  eo(JTe, Le.BASIC_AUTH)
]), jbt = g.Record(g.String(), g.Union([
  bx,
  rj,
  sj,
  oj,
  Ox
])), tke = g.Composite([
  aj,
  g.Object({
    props: jbt
  }),
  eo(g.Unknown(), Le.CUSTOM_AUTH)
]), f$ = g.Composite([
  aj,
  eo(g.Object({
    auth: g.String()
  }), Le.SECRET_TEXT)
]);
var p$ = /* @__PURE__ */ ((e) => (e.HEADER = "HEADER", e.BODY = "BODY", e))(p$ || {});
const nke = g.Union([
  bx,
  f$,
  Ox
]), rke = g.Record(g.String(), nke), Fbt = g.Object({
  props: g.Optional(g.Record(g.String(), nke)),
  authUrl: g.String(),
  tokenUrl: g.String(),
  scope: g.Array(g.String()),
  prompt: g.Optional(g.Union([g.Literal("none"), g.Literal("consent"), g.Literal("login"), g.Literal("omit")])),
  pkce: g.Optional(g.Boolean()),
  pkceMethod: g.Optional(g.Union([g.Literal("plain"), g.Literal("S256")])),
  authorizationMethod: g.Optional(g.Enum(p$)),
  grantType: g.Optional(g.Union([g.Enum(Xs), g.Literal(nv)])),
  extra: g.Optional(g.Record(g.String(), g.String()))
}), ike = g.Object({
  access_token: g.String(),
  props: g.Optional(rke),
  data: g.Record(g.String(), g.Any())
}), oke = g.Composite([
  aj,
  Fbt,
  eo(ike, Le.OAUTH2)
]), kD = g.Union([
  eke,
  tke,
  oke,
  f$
]), TE = "Connection", Ubt = {
  SecretText(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.SECRET_TEXT
    };
  },
  OAuth2(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.OAUTH2,
      displayName: e.displayName || TE
    };
  },
  BasicAuth(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.BASIC_AUTH,
      displayName: e.displayName || TE,
      required: !0
    };
  },
  CustomAuth(e) {
    return {
      ...e,
      valueSchema: void 0,
      type: Le.CUSTOM_AUTH,
      displayName: e.displayName || TE
    };
  },
  None() {
  }
};
function h$({ authValueType: e, pieceAuth: t }) {
  return !Array.isArray(t) || De(t) ? t : t.find((n) => Vbt[e] === n.type);
}
const Vbt = {
  [Mn.OAUTH2]: Le.OAUTH2,
  [Mn.CLOUD_OAUTH2]: Le.OAUTH2,
  [Mn.PLATFORM_OAUTH2]: Le.OAUTH2,
  [Mn.BASIC_AUTH]: Le.BASIC_AUTH,
  [Mn.CUSTOM_AUTH]: Le.CUSTOM_AUTH,
  [Mn.SECRET_TEXT]: Le.SECRET_TEXT,
  [Mn.NO_AUTH]: void 0
}, qbt = g.Composite([
  ls,
  eo(g.Unknown(), Le.CUSTOM),
  g.Object({
    code: g.String()
  })
]);
function ske(e, t, n = !0) {
  const r = Object.entries(e), i = [g.Null(), g.Undefined()], o = g.Not(
    g.Union(i),
    g.Unknown()
  ), s = {};
  for (const [l, c] of r) {
    switch (c.type) {
      case Le.MARKDOWN:
        s[l] = g.Optional(
          g.Union([g.Null(), g.Undefined(), g.Never(), g.Unknown()])
        );
        break;
      case Le.DATE_TIME:
      case Le.SHORT_TEXT:
      case Le.LONG_TEXT:
      case Le.COLOR:
      case Le.FILE:
        s[l] = g.String({
          minLength: c.required ? 1 : void 0
        });
        break;
      case Le.CHECKBOX:
        s[l] = g.Union([
          g.Boolean({ defaultValue: !1 }),
          g.String({})
        ]);
        break;
      case Le.NUMBER:
        s[l] = g.Union([
          g.String({
            minLength: c.required ? 1 : void 0
          }),
          g.Number()
        ]);
        break;
      case Le.STATIC_DROPDOWN:
      case Le.DROPDOWN:
        s[l] = o;
        break;
      case Le.BASIC_AUTH:
      case Le.CUSTOM_AUTH:
      case Le.SECRET_TEXT:
      case Le.OAUTH2:
        break;
      case Le.ARRAY: {
        const a = De(c.properties) ? g.String({
          minLength: c.required ? 1 : void 0
        }) : ske(c.properties, void 0);
        s[l] = g.Union([
          g.Array(a, {
            minItems: c.required ? 1 : void 0
          }),
          //for inline items mode
          g.Record(g.String(), g.Unknown()),
          //for normal dynamic input mode
          g.String({
            minLength: c.required ? 1 : void 0
          })
        ]);
        break;
      }
      case Le.OBJECT:
        s[l] = g.Union([
          g.Record(g.String(), g.Any()),
          g.String({
            minLength: c.required ? 1 : void 0
          })
        ]);
        break;
      case Le.JSON:
        s[l] = g.Union([
          g.Record(g.String(), g.Any()),
          g.Array(g.Any()),
          g.String({
            minLength: c.required ? 1 : void 0
          })
        ]);
        break;
      case Le.MULTI_SELECT_DROPDOWN:
      case Le.STATIC_MULTI_SELECT_DROPDOWN:
        s[l] = g.Union([
          g.Array(g.Any(), {
            minItems: c.required ? 1 : void 0
          }),
          g.String({
            minLength: c.required ? 1 : void 0
          })
        ]);
        break;
      case Le.DYNAMIC:
        s[l] = g.Record(g.String(), g.Any());
        break;
      case Le.CUSTOM:
        s[l] = g.Unknown();
        break;
    }
    !c.required && c.type !== Le.ARRAY && (s[l] = g.Optional(
      g.Union(
        Ube(s[l]) ? [g.Any(), ...i] : [s[l], ...i]
      )
    ));
  }
  return t && n && (s[F2] = g.String({
    minLength: 1
  })), g.Object(s);
}
const Dv = {
  buildSchema: ske
}, ake = g.Union([YTe, kD]), lke = g.Record(g.String(), ake), Bbt = g.Record(g.String(), YTe), Xbt = "_dedupe_key";
var cke = /* @__PURE__ */ ((e) => (e.CRON = "CRON", e.NONE = "NONE", e))(cke || {});
const uke = g.Union([
  g.Object({
    strategy: g.Literal(
      "CRON"
      /* CRON */
    ),
    cronExpression: g.String()
  }),
  g.Object({
    strategy: g.Literal(
      "NONE"
      /* NONE */
    )
  })
]);
class XR {
  constructor(t, n, r, i, o, s, l, c, a, u, f, d, p, h, m, v, b) {
    this.name = t, this.displayName = n, this.description = r, this.requireAuth = i, this.props = o, this.type = s, this.handshakeConfiguration = l, this.onHandshake = c, this.renewConfiguration = a, this.onRenew = u, this.onEnable = f, this.onDisable = d, this.onStart = p, this.run = h, this.test = m, this.sampleData = v, this.testStrategy = b;
  }
}
const Wbt = (e) => {
  switch (e.type) {
    case hf.WEBHOOK:
      return new XR(
        e.name,
        e.displayName,
        e.description,
        e.requireAuth ?? !0,
        e.props,
        e.type,
        e.handshakeConfiguration ?? { strategy: LO.NONE },
        e.onHandshake ?? (async () => ({ status: 200 })),
        e.renewConfiguration ?? {
          strategy: "NONE"
          /* NONE */
        },
        e.onRenew ?? (async () => Promise.resolve()),
        e.onEnable,
        e.onDisable,
        e.onStart ?? (async () => Promise.resolve()),
        e.run,
        e.test ?? (() => Promise.resolve([e.sampleData])),
        e.sampleData,
        e.test ? $l.TEST_FUNCTION : $l.SIMULATION
      );
    case hf.POLLING:
      return new XR(
        e.name,
        e.displayName,
        e.description,
        e.requireAuth ?? !0,
        e.props,
        e.type,
        { strategy: LO.NONE },
        async () => ({ status: 200 }),
        {
          strategy: "NONE"
          /* NONE */
        },
        async () => Promise.resolve(),
        e.onEnable,
        e.onDisable,
        e.onStart ?? (async () => Promise.resolve()),
        e.run,
        e.test ?? (() => Promise.resolve([e.sampleData])),
        e.sampleData,
        $l.TEST_FUNCTION
      );
    case hf.APP_WEBHOOK:
      return new XR(
        e.name,
        e.displayName,
        e.description,
        e.requireAuth ?? !0,
        e.props,
        e.type,
        { strategy: LO.NONE },
        async () => ({ status: 200 }),
        {
          strategy: "NONE"
          /* NONE */
        },
        async () => Promise.resolve(),
        e.onEnable,
        e.onDisable,
        e.onStart ?? (async () => Promise.resolve()),
        e.run,
        e.test ?? (() => Promise.resolve([e.sampleData])),
        e.sampleData,
        De(e.sampleData) && De(e.test) ? $l.SIMULATION : $l.TEST_FUNCTION
      );
  }
};
var dke = /* @__PURE__ */ ((e) => (e.PROJECT = "COLLECTION", e.FLOW = "FLOW", e))(dke || {}), fke = /* @__PURE__ */ ((e) => (e.V1 = "1", e))(fke || {});
const pke = "1", WR = "0.73.0", Zbt = {
  makeActionContextBackwardCompatible({ context: e, contextVersion: t }) {
    switch (t) {
      case void 0:
        return Hbt(e);
      case "1":
        return e;
    }
  }
};
function Hbt(e) {
  return {
    ...e,
    serverUrl: e.server.publicUrl
  };
}
class hke {
  constructor(t, n, r, i, o, s, l, c, a = WR, u, f = "") {
    rn(this, "_actions", {});
    rn(this, "_triggers", {});
    // this method didn't exist in older version
    rn(this, "getContextInfo", () => ({ version: pke }));
    this.displayName = t, this.logoUrl = n, this.authors = r, this.events = i, this.categories = l, this.auth = c, this.minimumSupportedRelease = a, this.maximumSupportedRelease = u, this.description = f, (!Lq.valid(a) || Lq.lt(a, WR)) && (this.minimumSupportedRelease = WR), o.forEach((d) => this._actions[d.name] = d), s.forEach((d) => this._triggers[d.name] = d);
  }
  metadata() {
    var t;
    return {
      displayName: this.displayName,
      logoUrl: this.logoUrl,
      actions: this._actions,
      triggers: this._triggers,
      categories: this.categories,
      description: this.description,
      authors: this.authors,
      auth: this.auth,
      minimumSupportedRelease: this.minimumSupportedRelease,
      maximumSupportedRelease: this.maximumSupportedRelease,
      contextInfo: (t = this.getContextInfo) == null ? void 0 : t.call(this)
    };
  }
  getAction(t) {
    return this._actions[t];
  }
  getTrigger(t) {
    return this._triggers[t];
  }
  actions() {
    return this._actions;
  }
  triggers() {
    return this._triggers;
  }
}
const Qbt = (e) => {
  if (e.auth && Array.isArray(e.auth) && !e.auth.every(
    (n, r, i) => r === i.findIndex((o) => o.type === n.type)
  ))
    throw new Error("Auth properties must be unique by type");
  return new hke(
    e.displayName,
    e.logoUrl,
    e.authors ?? [],
    e.events,
    e.actions,
    e.triggers,
    e.categories ?? [],
    e.auth,
    e.minimumSupportedRelease,
    e.maximumSupportedRelease,
    e.description
  );
}, $bt = g.Optional(g.Partial(g.Record(g.Enum(Wi), g.Record(g.String(), g.String())))), mke = g.Object({
  id: g.Optional(g.String()),
  name: g.String(),
  displayName: g.String(),
  logoUrl: g.String(),
  description: g.String(),
  projectId: g.Optional(g.String()),
  authors: g.Array(g.String()),
  platformId: g.Optional(g.String()),
  directoryPath: g.Optional(g.String()),
  auth: g.Optional(g.Union([kD, g.Array(kD)])),
  version: g.String(),
  categories: g.Optional(g.Array(g.Enum(Of))),
  minimumSupportedRelease: g.Optional(g.String()),
  maximumSupportedRelease: g.Optional(g.String()),
  i18n: $bt
}), lj = g.Object({
  name: g.String(),
  displayName: g.String(),
  description: g.String(),
  props: lke,
  requireAuth: g.Boolean(),
  errorHandlingOptions: g.Optional(XTe)
}), m$ = g.Composite([
  g.Omit(lj, ["requireAuth"]),
  g.Object({
    type: g.Enum(hf),
    sampleData: g.Unknown(),
    handshakeConfiguration: g.Optional(q0e),
    renewConfiguration: g.Optional(uke),
    testStrategy: g.Enum($l)
  })
]), g$ = g.Composite([
  mke,
  g.Object({
    actions: g.Record(g.String(), lj),
    triggers: g.Record(g.String(), m$)
  })
]), gke = g.Composite([
  g.Omit(g$, ["actions", "triggers"]),
  g.Object({
    actions: g.Number(),
    triggers: g.Number(),
    suggestedActions: g.Optional(g.Array(m$)),
    suggestedTriggers: g.Optional(g.Array(lj))
  })
]), yke = g.Object({
  projectUsage: g.Number(),
  tags: g.Optional(g.Array(g.String())),
  pieceType: g.Enum(k2),
  packageType: g.Enum(VA),
  platformId: g.Optional(g.String()),
  archiveId: g.Optional(g.String())
}), Kbt = g.Composite([
  g$,
  yke
]), Gbt = g.Composite([
  gke,
  yke
]), Ybt = g.Object({
  name: g.String(),
  version: g.String()
}), vke = {
  translatePiece: (e, t) => {
    var n;
    if (!t)
      return e;
    try {
      const r = (n = e.i18n) == null ? void 0 : n[t];
      if (!r)
        return e;
      const i = structuredClone(e);
      return vke.pathsToValuesToTranslate.forEach((o) => {
        $B(i, o, r);
      }), i;
    } catch (r) {
      return console.error(`error translating piece ${e.name}:`, r), e;
    }
  },
  /**Gets the piece metadata regardles of piece location (node_modules or dist), wasn't included inside piece.metadata() for backwards compatibility issues (if an old ap version installs a new piece it would fail)*/
  initializeI18n: async (e) => {
    try {
      const t = Object.values(Wi), n = {};
      for (const r of t) {
        const i = await e0t(r, e);
        i && (n[r] = i);
      }
      return Object.keys(n).length > 0 ? n : void 0;
    } catch (t) {
      console.log(`Error initializing i18n for ${e}:`, t);
      return;
    }
  },
  pathsToValuesToTranslate: [
    "description",
    "auth.username.displayName",
    "auth.username.description",
    "auth.password.displayName",
    "auth.password.description",
    "auth.props.*.displayName",
    "auth.props.*.description",
    "auth.props.*.options.options.*.label",
    "auth.description",
    "actions.*.displayName",
    "actions.*.description",
    "actions.*.props.*.displayName",
    "actions.*.props.*.description",
    "actions.*.props.*.options.options.*.label",
    "triggers.*.displayName",
    "triggers.*.description",
    "triggers.*.props.*.displayName",
    "triggers.*.props.*.description",
    "triggers.*.props.*.options.options.*.label"
  ]
};
function $B(e, t, n) {
  const r = t.split(".");
  if (r[0] === "*")
    return Object.values(e).forEach((l) => $B(l, r.slice(1).join("."), n));
  const i = e[r[0]];
  if (!i)
    return;
  if (r.length > 1)
    return $B(i, r.slice(1).join("."), n);
  const o = e[r[0]], s = n[o.slice(0, e0e)];
  s && (e[r[0]] = s);
}
async function Jbt(e) {
  try {
    return await nD.access(e), !0;
  } catch {
    return !1;
  }
}
const e0t = async (e, t) => {
  const n = nD.join(t, "src", "i18n", `${e}.json`);
  if (!await Jbt(n))
    return null;
  try {
    const r = await nD.readFile(n, "utf8"), i = JSON.parse(r);
    if (typeof i == "object" && i !== null)
      return i;
    throw new Error(`Invalid i18n file format for ${e} in piece ${t}`);
  } catch (r) {
    return console.error(`Error reading i18n file for ${e} in piece ${t}:`, r), null;
  }
}, t0t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionBase: lj,
  ApFile: Mbt,
  ArrayProperty: u$,
  ArraySubProps: QTe,
  BasePropertySchema: ls,
  BasicAuthProperty: eke,
  BasicAuthPropertyValue: JTe,
  CheckboxProperty: oj,
  ContextVersion: fke,
  CustomAuthProperty: tke,
  CustomProperty: qbt,
  DEDUPE_KEY_PROPERTY: Xbt,
  DEFAULT_CONNECTION_DISPLAY_NAME: TE,
  DateTimeProperty: c$,
  DropdownOption: ZTe,
  DropdownProperty: HTe,
  DropdownState: s$,
  DynamicProp: $Te,
  DynamicProperties: KTe,
  DynamicPropsValue: Dbt,
  ErrorHandlingOptionsParam: XTe,
  FileProperty: l$,
  IAction: WTe,
  ITrigger: XR,
  InputPropertyMap: Bbt,
  JsonProperty: d$,
  LATEST_CONTEXT_VERSION: pke,
  LongTextProperty: rj,
  MINIMUM_SUPPORTED_RELEASE_AFTER_LATEST_CONTEXT_VERSION: WR,
  MultiSelectDropdownProperty: a$,
  NumberProperty: sj,
  OAuth2AuthorizationMethod: p$,
  OAuth2Property: oke,
  OAuth2PropertyValue: ike,
  OAuth2Props: rke,
  ObjectProperty: GTe,
  Piece: hke,
  PieceAuth: Ubt,
  PieceAuthProperty: kD,
  PieceBase: mke,
  PieceMetadata: g$,
  PieceMetadataModel: Kbt,
  PieceMetadataModelSummary: Gbt,
  PieceMetadataSummary: gke,
  PiecePackageInformation: Ybt,
  PieceProperty: ake,
  PiecePropertyMap: lke,
  Property: zbt,
  PropertyType: Le,
  SecretTextProperty: f$,
  ShortTextProperty: bx,
  StaticDropdownProperty: Ox,
  StaticMultiSelectDropdownProperty: ij,
  StoreScope: dke,
  TriggerBase: m$,
  TriggerStrategy: hf,
  WebhookRenewConfiguration: uke,
  WebhookRenewStrategy: cke,
  backwardCompatabilityContextUtils: Zbt,
  createAction: Rbt,
  createPiece: Qbt,
  createTrigger: Wbt,
  getAuthPropertyForValue: h$,
  piecePropertiesUtils: Dv,
  pieceTranslation: vke
}, Symbol.toStringTag, { value: "Module" }));
function Loe(e, t, n) {
  switch (e) {
    case qe.PIECE:
      return t && n && t.actions[n] ? Dv.buildSchema(
        t.actions[n].props,
        t.auth,
        t.actions[n].requireAuth
      ) : g.Object({});
    case Bt.PIECE:
      return t && n && t.triggers[n] ? Dv.buildSchema(
        t.triggers[n].props,
        t.auth,
        t.triggers[n].requireAuth
      ) : g.Object({});
    default:
      throw new Error("Unsupported type: " + e);
  }
}
function bke({
  property: e,
  dynamicInputModeToggled: t
}) {
  switch (e.type) {
    case Le.ARRAY:
      return t && e.properties ? {} : t ? "" : e.defaultValue ?? [];
    case Le.OBJECT:
    case Le.JSON:
      return t ? "" : e.defaultValue ?? {};
    case Le.SHORT_TEXT:
    case Le.LONG_TEXT:
    case Le.MARKDOWN:
    case Le.FILE:
    case Le.DATE_TIME:
    case Le.NUMBER:
      return e.defaultValue ?? "";
    case Le.DYNAMIC:
      return {};
    case Le.CHECKBOX:
      return t ? "" : e.defaultValue ?? !1;
    case Le.DROPDOWN:
    case Le.STATIC_DROPDOWN:
    case Le.MULTI_SELECT_DROPDOWN:
    case Le.STATIC_MULTI_SELECT_DROPDOWN:
      return t ? "" : e.type === Le.MULTI_SELECT_DROPDOWN || e.type === Le.STATIC_MULTI_SELECT_DROPDOWN ? e.defaultValue ?? [] : e.defaultValue ?? null;
    case Le.COLOR:
      return t ? "" : e.defaultValue ?? "";
    case Le.OAUTH2:
    case Le.CUSTOM_AUTH:
    case Le.BASIC_AUTH:
    case Le.SECRET_TEXT:
    case Le.CUSTOM:
      return "";
  }
}
function n0t({
  props: e,
  existingInput: t,
  propertySettings: n
}) {
  return Object.entries(e).reduce(
    (r, [i, o]) => {
      var s;
      return r[i] = //we specifically check for undefined because null is a valid value
      t[i] === void 0 ? bke({
        property: o,
        dynamicInputModeToggled: ((s = n == null ? void 0 : n[i]) == null ? void 0 : s.type) === dc.DYNAMIC
      }) : t[i], r;
    },
    {}
  );
}
function r0t(e) {
  if (De(e))
    return g.Object({
      request: g.Composite([
        g.Omit(_q, ["externalId"])
      ])
    });
  const t = g.Object({
    externalId: g.String({
      pattern: "^[A-Za-z0-9_\\-@\\+\\.]*$",
      minLength: 1,
      errorMessage: Z("Name can only contain letters, numbers and underscores")
    })
  });
  switch (e.type) {
    case Le.SECRET_TEXT:
      return g.Object({
        request: g.Composite([
          g.Omit(Xw, ["externalId", "displayName"]),
          t
        ])
      });
    case Le.BASIC_AUTH:
      return g.Object({
        request: g.Composite([
          g.Omit(MC, ["externalId", "displayName"]),
          t
        ])
      });
    case Le.CUSTOM_AUTH:
      return g.Object({
        request: g.Composite([
          g.Omit(j2, [
            "externalId",
            "value",
            "displayName"
          ]),
          t,
          g.Object({
            value: g.Object({
              props: Dv.buildSchema(e.props, void 0)
            })
          })
        ])
      });
    case Le.OAUTH2:
      return g.Object({
        request: g.Composite([
          g.Omit(
            g.Union([
              xT,
              wT,
              AT
            ]),
            ["externalId", "displayName", "value"]
          ),
          g.Object({
            //props in the request schema is any object, so we need to build a schema for it
            value: g.Composite([
              g.Omit(
                g.Union([
                  xT.properties.value,
                  wT.properties.value,
                  AT.properties.value
                ]),
                ["props"]
              ),
              g.Object({
                props: g.Optional(
                  Dv.buildSchema(e.props ?? {}, void 0)
                )
              })
            ])
          }),
          t
        ])
      });
    default:
      return g.Object({
        request: g.Composite([
          g.Omit(_q, [
            "externalId",
            "displayName"
          ]),
          t
        ])
      });
  }
}
const Bc = {
  /**When we use deepEqual if one object has an undefined value and the other doesn't have the key, that's an unequality, so to be safe we remove undefined values */
  removeUndefinedFromInput: (e) => {
    const t = JSON.parse(JSON.stringify(e));
    return t.type !== Bt.PIECE && t.type !== qe.PIECE ? e : (t.settings.input = Object.fromEntries(
      Object.entries(t.settings.input).filter(
        ([n, r]) => r !== void 0
      )
    ), t.nextAction = null, t);
  },
  buildPieceSchema: (e, t, n) => {
    switch (e) {
      case qe.LOOP_ON_ITEMS:
        return g.Composite([
          g.Omit(PC, ["settings"]),
          g.Object({
            settings: g.Object({
              items: g.String({
                minLength: 1
              })
            })
          })
        ]);
      case qe.ROUTER:
        return g.Intersect([
          g.Omit(L2, ["settings"]),
          g.Object({
            settings: g.Object({
              branches: _2(!0),
              executionType: g.Enum(ah),
              sampleData: M2
            })
          })
        ]);
      case qe.CODE:
        return CC;
      case qe.PIECE:
        return g.Composite([
          g.Omit(NC, ["settings"]),
          g.Object({
            settings: g.Composite([
              g.Omit(lZ, ["input", "actionName"]),
              g.Object({
                actionName: g.String({
                  minLength: 1
                }),
                input: Loe(
                  e,
                  n,
                  t
                )
              })
            ])
          })
        ]);
      case Bt.PIECE:
        return g.Composite([
          g.Omit(U2, ["settings"]),
          g.Object({
            settings: g.Composite([
              g.Omit(wZ, ["input", "triggerName"]),
              g.Object({
                triggerName: g.String({
                  minLength: 1
                }),
                input: Loe(
                  e,
                  n,
                  t
                )
              })
            ])
          })
        ]);
      default:
        throw new Error("Unsupported type: " + e);
    }
  },
  getDefaultValueForProperties: n0t,
  buildConnectionSchema: r0t,
  getDefaultPropertyValue: bke
}, i0t = `export const code = async (inputs) => {
  return true;
};`, o0t = [
  {
    pieceName: "@activepieces/piece-todos",
    actionName: "wait_for_approval"
  },
  {
    pieceName: "@activepieces/piece-todos",
    actionName: "createTodoAndWait"
  }
], s0t = (e) => {
  const t = Object.values(e.suggestedActions ?? {});
  return Object.values(t).filter(
    (r) => !o0t.some(
      (i) => i.actionName === r.name && i.pieceName === e.pieceName
    )
  );
}, ZR = (e) => e.type === qe.PIECE || At.isTrigger(e.type) && e.type === Bt.PIECE, a0t = (e, t) => {
  switch (e.type) {
    case qe.CODE:
      return !0;
    case qe.PIECE:
    case Bt.PIECE: {
      const r = (t && "input" in t ? t.input : void 0) ?? Oke(e), i = Dv.buildSchema(
        e.actionOrTrigger.props,
        e.pieceMetadata.auth
      ), o = XM(i, r).First() === void 0, s = e.actionOrTrigger.requireAuth, l = !De(e.pieceMetadata.auth);
      return o && (!s || !l);
    }
    case qe.LOOP_ON_ITEMS:
      return !!(t && "input" in t && t.input.items);
    case Bt.EMPTY:
      return !1;
    case qe.ROUTER:
      return t ? Array.from(
        XM(
          h0e,
          t
        )
      ).length === 0 : !1;
  }
}, Oke = (e) => ZR(e) ? Bc.getDefaultValueForProperties({
  props: {
    ...e.actionOrTrigger.props
  },
  existingInput: {}
}) : {}, l0t = ({
  stepName: e,
  pieceSelectorItem: t,
  overrideDefaultSettings: n,
  customLogoUrl: r
}) => {
  const i = {
    continueOnFailure: {
      value: !1
    },
    retryOnFailure: {
      value: !1
    }
  }, o = Oke(t), s = a0t(
    t,
    n
  ), l = {
    name: e,
    valid: s,
    displayName: ZR(t) ? t.actionOrTrigger.displayName : t.displayName,
    skip: !1,
    settings: {
      customLogoUrl: r,
      sampleData: i0e
    }
  };
  switch (t.type) {
    case qe.CODE:
      return hy(
        {
          type: qe.CODE,
          settings: n ?? {
            sourceCode: {
              code: i0t,
              packageJson: "{}"
            },
            input: o,
            errorHandlingOptions: i
          }
        },
        l
      );
    case qe.LOOP_ON_ITEMS:
      return hy(
        {
          type: qe.LOOP_ON_ITEMS,
          settings: n ?? {
            items: ""
          }
        },
        l
      );
    case qe.ROUTER:
      return hy(
        {
          type: qe.ROUTER,
          settings: n ?? {
            executionType: ah.EXECUTE_FIRST_MATCH,
            branches: [
              {
                conditions: [
                  [
                    {
                      operator: Gr.TEXT_EXACTLY_MATCHES,
                      firstValue: "",
                      secondValue: "",
                      caseSensitive: !1
                    }
                  ]
                ],
                branchType: iu.CONDITION,
                branchName: "Branch 1"
              },
              {
                branchType: iu.FALLBACK,
                branchName: "Otherwise"
              }
            ]
          },
          children: [null, null]
        },
        l
      );
    case qe.PIECE: {
      if (!ZR(t))
        throw new Error(
          `Invalid piece selector item ${JSON.stringify(t)}`
        );
      return hy(
        {
          type: qe.PIECE,
          settings: n ?? {
            pieceName: t.pieceMetadata.pieceName,
            actionName: t.actionOrTrigger.name,
            pieceVersion: t.pieceMetadata.pieceVersion,
            input: o,
            errorHandlingOptions: i,
            propertySettings: Object.fromEntries(
              Object.entries(o).map(([c]) => [
                c,
                {
                  type: dc.MANUAL,
                  schema: void 0
                }
              ])
            )
          }
        },
        l
      );
    }
    case Bt.PIECE: {
      if (!ZR(t))
        throw new Error(
          `Invalid piece selector item ${JSON.stringify(t)}`
        );
      return hy(
        {
          type: Bt.PIECE,
          settings: n ?? {
            pieceName: t.pieceMetadata.pieceName,
            triggerName: t.actionOrTrigger.name,
            pieceVersion: t.pieceMetadata.pieceVersion,
            input: o,
            propertySettings: Object.fromEntries(
              Object.entries(o).map(([c]) => [
                c,
                {
                  type: dc.MANUAL
                }
              ])
            )
          }
        },
        l
      );
    }
    default:
      throw new Error("Unsupported type: " + t.type);
  }
}, c0t = () => {
  const e = Xe(u0t), t = Xe(null);
  if (!t.current)
    return {
      listHeightRef: e,
      popoverTriggerRef: t,
      searchInputDivHeight: T6
    };
  const n = t.current.getBoundingClientRect(), r = window.innerHeight || document.documentElement.clientHeight;
  if (n.top < r - n.bottom) {
    const o = r - n.bottom - T6;
    e.current = Math.max(
      zoe,
      o
    );
  } else {
    const o = n.top - T6 - d0t;
    e.current = Math.max(
      zoe,
      o
    );
  }
  return {
    listHeightRef: e,
    popoverTriggerRef: t
  };
}, u0t = 300, zoe = 100, T6 = 113, d0t = 64, f0t = 48, p0t = 41, h0t = 28, BT = {
  PIECE_ITEM_HEIGHT: f0t,
  ACTION_OR_TRIGGER_ITEM_HEIGHT: p0t,
  CATEGORY_ITEM_HEIGHT: h0t
}, m0t = (e, t) => e === "@activepieces/piece-mcp" && t === "mcp_tool", g0t = (e, t) => e === "@activepieces/piece-forms" && t === "chat_submission", y0t = (e, t) => {
  switch (e.type) {
    case Tt.UPDATE_ACTION:
      return e.stepName;
    case Tt.ADD_ACTION:
      return At.findUnusedName(t.trigger);
    case Tt.UPDATE_TRIGGER:
      return "trigger";
  }
}, xf = {
  getDefaultStepValues: l0t,
  useAdjustPieceListHeightToAvailableSpace: c0t,
  isMcpToolTrigger: m0t,
  isChatTrigger: g0t,
  removeHiddenActions: s0t,
  getStepNameFromOperationType: y0t
};
function v0t(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const b0t = (e) => {
  switch (e) {
    case "success":
      return w0t;
    case "info":
      return S0t;
    case "warning":
      return x0t;
    case "error":
      return E0t;
    default:
      return null;
  }
}, O0t = Array(12).fill(0), A0t = ({ visible: e, className: t }) => /* @__PURE__ */ ie.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    t
  ].filter(Boolean).join(" "),
  "data-visible": e
}, /* @__PURE__ */ ie.createElement("div", {
  className: "sonner-spinner"
}, O0t.map((n, r) => /* @__PURE__ */ ie.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), w0t = /* @__PURE__ */ ie.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ ie.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), x0t = /* @__PURE__ */ ie.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ ie.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), S0t = /* @__PURE__ */ ie.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ ie.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), E0t = /* @__PURE__ */ ie.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ ie.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), T0t = /* @__PURE__ */ ie.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ ie.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ ie.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), k0t = () => {
  const [e, t] = ie.useState(document.hidden);
  return ie.useEffect(() => {
    const n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
};
let KB = 1;
class C0t {
  constructor() {
    this.subscribe = (t) => (this.subscribers.push(t), () => {
      const n = this.subscribers.indexOf(t);
      this.subscribers.splice(n, 1);
    }), this.publish = (t) => {
      this.subscribers.forEach((n) => n(t));
    }, this.addToast = (t) => {
      this.publish(t), this.toasts = [
        ...this.toasts,
        t
      ];
    }, this.create = (t) => {
      var n;
      const { message: r, ...i } = t, o = typeof (t == null ? void 0 : t.id) == "number" || ((n = t.id) == null ? void 0 : n.length) > 0 ? t.id : KB++, s = this.toasts.find((c) => c.id === o), l = t.dismissible === void 0 ? !0 : t.dismissible;
      return this.dismissedToasts.has(o) && this.dismissedToasts.delete(o), s ? this.toasts = this.toasts.map((c) => c.id === o ? (this.publish({
        ...c,
        ...t,
        id: o,
        title: r
      }), {
        ...c,
        ...t,
        id: o,
        dismissible: l,
        title: r
      }) : c) : this.addToast({
        title: r,
        ...i,
        dismissible: l,
        id: o
      }), o;
    }, this.dismiss = (t) => (t ? (this.dismissedToasts.add(t), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: t,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), t), this.message = (t, n) => this.create({
      ...n,
      message: t
    }), this.error = (t, n) => this.create({
      ...n,
      message: t,
      type: "error"
    }), this.success = (t, n) => this.create({
      ...n,
      type: "success",
      message: t
    }), this.info = (t, n) => this.create({
      ...n,
      type: "info",
      message: t
    }), this.warning = (t, n) => this.create({
      ...n,
      type: "warning",
      message: t
    }), this.loading = (t, n) => this.create({
      ...n,
      type: "loading",
      message: t
    }), this.promise = (t, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: t,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const i = Promise.resolve(t instanceof Function ? t() : t);
      let o = r !== void 0, s;
      const l = i.then(async (a) => {
        if (s = [
          "resolve",
          a
        ], ie.isValidElement(a))
          o = !1, this.create({
            id: r,
            type: "default",
            message: a
          });
        else if (P0t(a) && !a.ok) {
          o = !1;
          const f = typeof n.error == "function" ? await n.error(`HTTP error! status: ${a.status}`) : n.error, d = typeof n.description == "function" ? await n.description(`HTTP error! status: ${a.status}`) : n.description, h = typeof f == "object" && !ie.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "error",
            description: d,
            ...h
          });
        } else if (a instanceof Error) {
          o = !1;
          const f = typeof n.error == "function" ? await n.error(a) : n.error, d = typeof n.description == "function" ? await n.description(a) : n.description, h = typeof f == "object" && !ie.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "error",
            description: d,
            ...h
          });
        } else if (n.success !== void 0) {
          o = !1;
          const f = typeof n.success == "function" ? await n.success(a) : n.success, d = typeof n.description == "function" ? await n.description(a) : n.description, h = typeof f == "object" && !ie.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "success",
            description: d,
            ...h
          });
        }
      }).catch(async (a) => {
        if (s = [
          "reject",
          a
        ], n.error !== void 0) {
          o = !1;
          const u = typeof n.error == "function" ? await n.error(a) : n.error, f = typeof n.description == "function" ? await n.description(a) : n.description, p = typeof u == "object" && !ie.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: f,
            ...p
          });
        }
      }).finally(() => {
        o && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), c = () => new Promise((a, u) => l.then(() => s[0] === "reject" ? u(s[1]) : a(s[1])).catch(u));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: c
      } : Object.assign(r, {
        unwrap: c
      });
    }, this.custom = (t, n) => {
      const r = (n == null ? void 0 : n.id) || KB++;
      return this.create({
        jsx: t(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Ga = new C0t(), N0t = (e, t) => {
  const n = (t == null ? void 0 : t.id) || KB++;
  return Ga.addToast({
    title: e,
    ...t,
    id: n
  }), n;
}, P0t = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", I0t = N0t, R0t = () => Ga.toasts, M0t = () => Ga.getActiveToasts(), vr = Object.assign(I0t, {
  success: Ga.success,
  info: Ga.info,
  warning: Ga.warning,
  error: Ga.error,
  custom: Ga.custom,
  message: Ga.message,
  promise: Ga.promise,
  dismiss: Ga.dismiss,
  loading: Ga.loading
}, {
  getHistory: R0t,
  getToasts: M0t
});
v0t("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}[data-sonner-toaster][data-lifted=true]{transform:translateY(-8px)}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function zP(e) {
  return e.label !== void 0;
}
const D0t = 3, _0t = "24px", L0t = "16px", joe = 4e3, z0t = 356, j0t = 14, F0t = 45, U0t = 200;
function Nd(...e) {
  return e.filter(Boolean).join(" ");
}
function V0t(e) {
  const [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
const q0t = (e) => {
  var t, n, r, i, o, s, l, c, a;
  const { invert: u, toast: f, unstyled: d, interacting: p, setHeights: h, visibleToasts: m, heights: v, index: b, toasts: A, expanded: w, removeToast: O, defaultRichColors: x, closeButton: S, style: E, cancelButtonStyle: k, actionButtonStyle: T, className: R = "", descriptionClassName: j = "", duration: F, position: L, gap: _, expandByDefault: U, classNames: z, icons: C, closeButtonAriaLabel: I = "Close toast" } = e, [M, D] = ie.useState(null), [X, B] = ie.useState(null), [q, H] = ie.useState(!1), [Y, J] = ie.useState(!1), [oe, ce] = ie.useState(!1), [fe, $] = ie.useState(!1), [pe, ee] = ie.useState(!1), [Ce, Ee] = ie.useState(0), [Ve, et] = ie.useState(0), ft = ie.useRef(f.duration || F || joe), me = ie.useRef(null), Te = ie.useRef(null), re = b === 0, le = b + 1 <= m, Oe = f.type, be = f.dismissible !== !1, je = f.className || "", xe = f.descriptionClassName || "", Q = ie.useMemo(() => v.findIndex((ct) => ct.toastId === f.id) || 0, [
    v,
    f.id
  ]), ae = ie.useMemo(() => {
    var ct;
    return (ct = f.closeButton) != null ? ct : S;
  }, [
    f.closeButton,
    S
  ]), Pe = ie.useMemo(() => f.duration || F || joe, [
    f.duration,
    F
  ]), Fe = ie.useRef(0), Ke = ie.useRef(0), Ot = ie.useRef(0), Ct = ie.useRef(null), [Jt, yn] = L.split("-"), vn = ie.useMemo(() => v.reduce((ct, Rt, Yt) => Yt >= Q ? ct : ct + Rt.height, 0), [
    v,
    Q
  ]), Re = k0t(), _e = f.invert || u, jt = Oe === "loading";
  Ke.current = ie.useMemo(() => Q * _ + vn, [
    Q,
    vn
  ]), ie.useEffect(() => {
    ft.current = Pe;
  }, [
    Pe
  ]), ie.useEffect(() => {
    H(!0);
  }, []), ie.useEffect(() => {
    const ct = Te.current;
    if (ct) {
      const Rt = ct.getBoundingClientRect().height;
      return et(Rt), h((Yt) => [
        {
          toastId: f.id,
          height: Rt,
          position: f.position
        },
        ...Yt
      ]), () => h((Yt) => Yt.filter((Gt) => Gt.toastId !== f.id));
    }
  }, [
    h,
    f.id
  ]), ie.useLayoutEffect(() => {
    if (!q) return;
    const ct = Te.current, Rt = ct.style.height;
    ct.style.height = "auto";
    const Yt = ct.getBoundingClientRect().height;
    ct.style.height = Rt, et(Yt), h((Gt) => Gt.find((en) => en.toastId === f.id) ? Gt.map((en) => en.toastId === f.id ? {
      ...en,
      height: Yt
    } : en) : [
      {
        toastId: f.id,
        height: Yt,
        position: f.position
      },
      ...Gt
    ]);
  }, [
    q,
    f.title,
    f.description,
    h,
    f.id
  ]);
  const st = ie.useCallback(() => {
    J(!0), Ee(Ke.current), h((ct) => ct.filter((Rt) => Rt.toastId !== f.id)), setTimeout(() => {
      O(f);
    }, U0t);
  }, [
    f,
    O,
    h,
    Ke
  ]);
  ie.useEffect(() => {
    if (f.promise && Oe === "loading" || f.duration === 1 / 0 || f.type === "loading") return;
    let ct;
    return w || p || Re ? (() => {
      if (Ot.current < Fe.current) {
        const Gt = (/* @__PURE__ */ new Date()).getTime() - Fe.current;
        ft.current = ft.current - Gt;
      }
      Ot.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      ft.current !== 1 / 0 && (Fe.current = (/* @__PURE__ */ new Date()).getTime(), ct = setTimeout(() => {
        f.onAutoClose == null || f.onAutoClose.call(f, f), st();
      }, ft.current));
    })(), () => clearTimeout(ct);
  }, [
    w,
    p,
    f,
    Oe,
    Re,
    st
  ]), ie.useEffect(() => {
    f.delete && st();
  }, [
    st,
    f.delete
  ]);
  function Mt() {
    var ct;
    if (C != null && C.loading) {
      var Rt;
      return /* @__PURE__ */ ie.createElement("div", {
        className: Nd(z == null ? void 0 : z.loader, f == null || (Rt = f.classNames) == null ? void 0 : Rt.loader, "sonner-loader"),
        "data-visible": Oe === "loading"
      }, C.loading);
    }
    return /* @__PURE__ */ ie.createElement(A0t, {
      className: Nd(z == null ? void 0 : z.loader, f == null || (ct = f.classNames) == null ? void 0 : ct.loader),
      visible: Oe === "loading"
    });
  }
  const lt = f.icon || (C == null ? void 0 : C[Oe]) || b0t(Oe);
  var xt, yt;
  return /* @__PURE__ */ ie.createElement("li", {
    tabIndex: 0,
    ref: Te,
    className: Nd(R, je, z == null ? void 0 : z.toast, f == null || (t = f.classNames) == null ? void 0 : t.toast, z == null ? void 0 : z.default, z == null ? void 0 : z[Oe], f == null || (n = f.classNames) == null ? void 0 : n[Oe]),
    "data-sonner-toast": "",
    "data-rich-colors": (xt = f.richColors) != null ? xt : x,
    "data-styled": !(f.jsx || f.unstyled || d),
    "data-mounted": q,
    "data-promise": !!f.promise,
    "data-swiped": pe,
    "data-removed": Y,
    "data-visible": le,
    "data-y-position": Jt,
    "data-x-position": yn,
    "data-index": b,
    "data-front": re,
    "data-swiping": oe,
    "data-dismissible": be,
    "data-type": Oe,
    "data-invert": _e,
    "data-swipe-out": fe,
    "data-swipe-direction": X,
    "data-expanded": !!(w || U && q),
    style: {
      "--index": b,
      "--toasts-before": b,
      "--z-index": A.length - b,
      "--offset": `${Y ? Ce : Ke.current}px`,
      "--initial-height": U ? "auto" : `${Ve}px`,
      ...E,
      ...f.style
    },
    onDragEnd: () => {
      ce(!1), D(null), Ct.current = null;
    },
    onPointerDown: (ct) => {
      jt || !be || (me.current = /* @__PURE__ */ new Date(), Ee(Ke.current), ct.target.setPointerCapture(ct.pointerId), ct.target.tagName !== "BUTTON" && (ce(!0), Ct.current = {
        x: ct.clientX,
        y: ct.clientY
      }));
    },
    onPointerUp: () => {
      var ct, Rt, Yt;
      if (fe || !be) return;
      Ct.current = null;
      const Gt = Number(((ct = Te.current) == null ? void 0 : ct.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), hn = Number(((Rt = Te.current) == null ? void 0 : Rt.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), en = (/* @__PURE__ */ new Date()).getTime() - ((Yt = me.current) == null ? void 0 : Yt.getTime()), Sn = M === "x" ? Gt : hn, Ar = Math.abs(Sn) / en;
      if (Math.abs(Sn) >= F0t || Ar > 0.11) {
        Ee(Ke.current), f.onDismiss == null || f.onDismiss.call(f, f), B(M === "x" ? Gt > 0 ? "right" : "left" : hn > 0 ? "down" : "up"), st(), $(!0);
        return;
      } else {
        var or, rr;
        (or = Te.current) == null || or.style.setProperty("--swipe-amount-x", "0px"), (rr = Te.current) == null || rr.style.setProperty("--swipe-amount-y", "0px");
      }
      ee(!1), ce(!1), D(null);
    },
    onPointerMove: (ct) => {
      var Rt, Yt, Gt;
      if (!Ct.current || !be || ((Rt = window.getSelection()) == null ? void 0 : Rt.toString().length) > 0) return;
      const en = ct.clientY - Ct.current.y, Sn = ct.clientX - Ct.current.x;
      var Ar;
      const or = (Ar = e.swipeDirections) != null ? Ar : V0t(L);
      !M && (Math.abs(Sn) > 1 || Math.abs(en) > 1) && D(Math.abs(Sn) > Math.abs(en) ? "x" : "y");
      let rr = {
        x: 0,
        y: 0
      };
      const no = (jn) => 1 / (1.5 + Math.abs(jn) / 20);
      if (M === "y") {
        if (or.includes("top") || or.includes("bottom"))
          if (or.includes("top") && en < 0 || or.includes("bottom") && en > 0)
            rr.y = en;
          else {
            const jn = en * no(en);
            rr.y = Math.abs(jn) < Math.abs(en) ? jn : en;
          }
      } else if (M === "x" && (or.includes("left") || or.includes("right")))
        if (or.includes("left") && Sn < 0 || or.includes("right") && Sn > 0)
          rr.x = Sn;
        else {
          const jn = Sn * no(Sn);
          rr.x = Math.abs(jn) < Math.abs(Sn) ? jn : Sn;
        }
      (Math.abs(rr.x) > 0 || Math.abs(rr.y) > 0) && ee(!0), (Yt = Te.current) == null || Yt.style.setProperty("--swipe-amount-x", `${rr.x}px`), (Gt = Te.current) == null || Gt.style.setProperty("--swipe-amount-y", `${rr.y}px`);
    }
  }, ae && !f.jsx && Oe !== "loading" ? /* @__PURE__ */ ie.createElement("button", {
    "aria-label": I,
    "data-disabled": jt,
    "data-close-button": !0,
    onClick: jt || !be ? () => {
    } : () => {
      st(), f.onDismiss == null || f.onDismiss.call(f, f);
    },
    className: Nd(z == null ? void 0 : z.closeButton, f == null || (r = f.classNames) == null ? void 0 : r.closeButton)
  }, (yt = C == null ? void 0 : C.close) != null ? yt : T0t) : null, (Oe || f.icon || f.promise) && f.icon !== null && ((C == null ? void 0 : C[Oe]) !== null || f.icon) ? /* @__PURE__ */ ie.createElement("div", {
    "data-icon": "",
    className: Nd(z == null ? void 0 : z.icon, f == null || (i = f.classNames) == null ? void 0 : i.icon)
  }, f.promise || f.type === "loading" && !f.icon ? f.icon || Mt() : null, f.type !== "loading" ? lt : null) : null, /* @__PURE__ */ ie.createElement("div", {
    "data-content": "",
    className: Nd(z == null ? void 0 : z.content, f == null || (o = f.classNames) == null ? void 0 : o.content)
  }, /* @__PURE__ */ ie.createElement("div", {
    "data-title": "",
    className: Nd(z == null ? void 0 : z.title, f == null || (s = f.classNames) == null ? void 0 : s.title)
  }, f.jsx ? f.jsx : typeof f.title == "function" ? f.title() : f.title), f.description ? /* @__PURE__ */ ie.createElement("div", {
    "data-description": "",
    className: Nd(j, xe, z == null ? void 0 : z.description, f == null || (l = f.classNames) == null ? void 0 : l.description)
  }, typeof f.description == "function" ? f.description() : f.description) : null), /* @__PURE__ */ ie.isValidElement(f.cancel) ? f.cancel : f.cancel && zP(f.cancel) ? /* @__PURE__ */ ie.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: f.cancelButtonStyle || k,
    onClick: (ct) => {
      zP(f.cancel) && be && (f.cancel.onClick == null || f.cancel.onClick.call(f.cancel, ct), st());
    },
    className: Nd(z == null ? void 0 : z.cancelButton, f == null || (c = f.classNames) == null ? void 0 : c.cancelButton)
  }, f.cancel.label) : null, /* @__PURE__ */ ie.isValidElement(f.action) ? f.action : f.action && zP(f.action) ? /* @__PURE__ */ ie.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: f.actionButtonStyle || T,
    onClick: (ct) => {
      zP(f.action) && (f.action.onClick == null || f.action.onClick.call(f.action, ct), !ct.defaultPrevented && st());
    },
    className: Nd(z == null ? void 0 : z.actionButton, f == null || (a = f.classNames) == null ? void 0 : a.actionButton)
  }, f.action.label) : null);
};
function Foe() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function B0t(e, t) {
  const n = {};
  return [
    e,
    t
  ].forEach((r, i) => {
    const o = i === 1, s = o ? "--mobile-offset" : "--offset", l = o ? L0t : _0t;
    function c(a) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((u) => {
        n[`${s}-${u}`] = typeof a == "number" ? `${a}px` : a;
      });
    }
    typeof r == "number" || typeof r == "string" ? c(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((a) => {
      r[a] === void 0 ? n[`${s}-${a}`] = l : n[`${s}-${a}`] = typeof r[a] == "number" ? `${r[a]}px` : r[a];
    }) : c(l);
  }), n;
}
const X0t = /* @__PURE__ */ ie.forwardRef(function(t, n) {
  const { invert: r, position: i = "bottom-right", hotkey: o = [
    "altKey",
    "KeyT"
  ], expand: s, closeButton: l, className: c, offset: a, mobileOffset: u, theme: f = "light", richColors: d, duration: p, style: h, visibleToasts: m = D0t, toastOptions: v, dir: b = Foe(), gap: A = j0t, icons: w, containerAriaLabel: O = "Notifications" } = t, [x, S] = ie.useState([]), E = ie.useMemo(() => Array.from(new Set([
    i
  ].concat(x.filter((X) => X.position).map((X) => X.position)))), [
    x,
    i
  ]), [k, T] = ie.useState([]), [R, j] = ie.useState(!1), [F, L] = ie.useState(!1), [_, U] = ie.useState(f !== "system" ? f : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), z = ie.useRef(null), C = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), I = ie.useRef(null), M = ie.useRef(!1), D = ie.useCallback((X) => {
    S((B) => {
      var q;
      return (q = B.find((H) => H.id === X.id)) != null && q.delete || Ga.dismiss(X.id), B.filter(({ id: H }) => H !== X.id);
    });
  }, []);
  return ie.useEffect(() => Ga.subscribe((X) => {
    if (X.dismiss) {
      requestAnimationFrame(() => {
        S((B) => B.map((q) => q.id === X.id ? {
          ...q,
          delete: !0
        } : q));
      });
      return;
    }
    setTimeout(() => {
      _w.flushSync(() => {
        S((B) => {
          const q = B.findIndex((H) => H.id === X.id);
          return q !== -1 ? [
            ...B.slice(0, q),
            {
              ...B[q],
              ...X
            },
            ...B.slice(q + 1)
          ] : [
            X,
            ...B
          ];
        });
      });
    });
  }), [
    x
  ]), ie.useEffect(() => {
    if (f !== "system") {
      U(f);
      return;
    }
    if (f === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? U("dark") : U("light")), typeof window > "u") return;
    const X = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      X.addEventListener("change", ({ matches: B }) => {
        U(B ? "dark" : "light");
      });
    } catch {
      X.addListener(({ matches: q }) => {
        try {
          U(q ? "dark" : "light");
        } catch (H) {
          console.error(H);
        }
      });
    }
  }, [
    f
  ]), ie.useEffect(() => {
    x.length <= 1 && j(!1);
  }, [
    x
  ]), ie.useEffect(() => {
    const X = (B) => {
      var q;
      if (o.every((J) => B[J] || B.code === J)) {
        var Y;
        j(!0), (Y = z.current) == null || Y.focus();
      }
      B.code === "Escape" && (document.activeElement === z.current || (q = z.current) != null && q.contains(document.activeElement)) && j(!1);
    };
    return document.addEventListener("keydown", X), () => document.removeEventListener("keydown", X);
  }, [
    o
  ]), ie.useEffect(() => {
    if (z.current)
      return () => {
        I.current && (I.current.focus({
          preventScroll: !0
        }), I.current = null, M.current = !1);
      };
  }, [
    z.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ ie.createElement("section", {
    ref: n,
    "aria-label": `${O} ${C}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, E.map((X, B) => {
    var q;
    const [H, Y] = X.split("-");
    return x.length ? /* @__PURE__ */ ie.createElement("ol", {
      key: X,
      dir: b === "auto" ? Foe() : b,
      tabIndex: -1,
      ref: z,
      className: c,
      "data-sonner-toaster": !0,
      "data-sonner-theme": _,
      "data-y-position": H,
      "data-lifted": R && x.length > 1 && !s,
      "data-x-position": Y,
      style: {
        "--front-toast-height": `${((q = k[0]) == null ? void 0 : q.height) || 0}px`,
        "--width": `${z0t}px`,
        "--gap": `${A}px`,
        ...h,
        ...B0t(a, u)
      },
      onBlur: (J) => {
        M.current && !J.currentTarget.contains(J.relatedTarget) && (M.current = !1, I.current && (I.current.focus({
          preventScroll: !0
        }), I.current = null));
      },
      onFocus: (J) => {
        J.target instanceof HTMLElement && J.target.dataset.dismissible === "false" || M.current || (M.current = !0, I.current = J.relatedTarget);
      },
      onMouseEnter: () => j(!0),
      onMouseMove: () => j(!0),
      onMouseLeave: () => {
        F || j(!1);
      },
      onDragEnd: () => j(!1),
      onPointerDown: (J) => {
        J.target instanceof HTMLElement && J.target.dataset.dismissible === "false" || L(!0);
      },
      onPointerUp: () => L(!1)
    }, x.filter((J) => !J.position && B === 0 || J.position === X).map((J, oe) => {
      var ce, fe;
      return /* @__PURE__ */ ie.createElement(q0t, {
        key: J.id,
        icons: w,
        index: oe,
        toast: J,
        defaultRichColors: d,
        duration: (ce = v == null ? void 0 : v.duration) != null ? ce : p,
        className: v == null ? void 0 : v.className,
        descriptionClassName: v == null ? void 0 : v.descriptionClassName,
        invert: r,
        visibleToasts: m,
        closeButton: (fe = v == null ? void 0 : v.closeButton) != null ? fe : l,
        interacting: F,
        position: X,
        style: v == null ? void 0 : v.style,
        unstyled: v == null ? void 0 : v.unstyled,
        classNames: v == null ? void 0 : v.classNames,
        cancelButtonStyle: v == null ? void 0 : v.cancelButtonStyle,
        actionButtonStyle: v == null ? void 0 : v.actionButtonStyle,
        closeButtonAriaLabel: v == null ? void 0 : v.closeButtonAriaLabel,
        removeToast: D,
        toasts: x.filter(($) => $.position == J.position),
        heights: k.filter(($) => $.position == J.position),
        setHeights: T,
        expandByDefault: s,
        gap: A,
        expanded: R,
        swipeDirections: t.swipeDirections
      });
    })) : null;
  }));
}), k6 = {
  deleteAccount() {
    return dt.delete(
      `/v1/platforms/${Rn.getPlatformId()}`
    );
  },
  getCurrentPlatform() {
    const e = Rn.getPlatformId();
    if (!e)
      throw Error("No platform id found");
    console.log("Sending Platform request to", e);
    try {
      const t = dt.get(`/v1/platforms/${e}`);
      return console.log("Returning platform details", t), t;
    } catch (t) {
      console.error("Error happened while trying to get platform details", t);
    }
  },
  verifyLicenseKey(e) {
    const t = Rn.getPlatformId();
    if (!t)
      throw Error("No platform id found");
    return dt.post("/v1/license-keys/verify", {
      platformId: t,
      licenseKey: e
    });
  },
  update(e, t) {
    return dt.post(
      `/v1/platforms/${t}`,
      e
    );
  },
  updateWithFormData(e, t) {
    return dt.post(
      `/v1/platforms/${t}`,
      e,
      {},
      {
        "Content-Type": "multipart/form-data"
      }
    );
  }
}, dN = {
  useDeleteAccount: () => {
    const e = sT();
    return dr({
      mutationFn: async () => {
        await k6.deleteAccount();
      },
      onSuccess: () => {
        vr.success(Z("Account deleted successfully")), e("/sign-in");
      }
    });
  },
  useCurrentPlatform: () => {
    const e = Rn.getPlatformId();
    console.log("PERFORMING plarform query with current platformID", e);
    const t = pr({
      queryKey: ["platform", e],
      queryFn: k6.getCurrentPlatform,
      staleTime: 1 / 0
    });
    return console.log("PERFORMED platform query", t.data), {
      platform: t.data,
      refetch: async () => {
        await t.refetch();
      },
      setCurrentPlatform: (n, r) => {
        n.setQueryData(["platform", e], r);
      }
    };
  },
  useUpdateLisenceKey: (e) => {
    const t = Rn.getPlatformId();
    return dr({
      mutationFn: async (n) => {
        n.trim() !== "" && await k6.verifyLicenseKey(n.trim());
      },
      onSuccess: () => {
        e.invalidateQueries({
          queryKey: ["platform", t]
        }), e.invalidateQueries({
          queryKey: Go.queryKey
        }), vr.success(Z("License activated successfully!"));
      },
      onError: () => {
        vr.error(Z("Activation failed, invalid license key"));
      }
    });
  }
};
function GB(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function W0t(e, t) {
  return N.useReducer((n, r) => t[n][r] ?? n, e);
}
var y$ = "ScrollArea", [Ake, Ghn] = Ms(y$), [Z0t, yu] = Ake(y$), wke = N.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: i,
      scrollHideDelay: o = 600,
      ...s
    } = e, [l, c] = N.useState(null), [a, u] = N.useState(null), [f, d] = N.useState(null), [p, h] = N.useState(null), [m, v] = N.useState(null), [b, A] = N.useState(0), [w, O] = N.useState(0), [x, S] = N.useState(!1), [E, k] = N.useState(!1), T = xn(t, (j) => c(j)), R = Eb(i);
    return /* @__PURE__ */ y(
      Z0t,
      {
        scope: n,
        type: r,
        dir: R,
        scrollHideDelay: o,
        scrollArea: l,
        viewport: a,
        onViewportChange: u,
        content: f,
        onContentChange: d,
        scrollbarX: p,
        onScrollbarXChange: h,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: m,
        onScrollbarYChange: v,
        scrollbarYEnabled: E,
        onScrollbarYEnabledChange: k,
        onCornerWidthChange: A,
        onCornerHeightChange: O,
        children: /* @__PURE__ */ y(
          Zt.div,
          {
            dir: R,
            ...s,
            ref: T,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": w + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
wke.displayName = y$;
var xke = "ScrollAreaViewport", Ske = N.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: i, ...o } = e, s = yu(xke, n), l = N.useRef(null), c = xn(t, l, s.onViewportChange);
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ y(
        Zt.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...o,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: s.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: s.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ y("div", { ref: s.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Ske.displayName = xke;
var zf = "ScrollAreaScrollbar", v$ = N.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = yu(zf, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: s } = i, l = e.orientation === "horizontal";
    return N.useEffect(() => (l ? o(!0) : s(!0), () => {
      l ? o(!1) : s(!1);
    }), [l, o, s]), i.type === "hover" ? /* @__PURE__ */ y(H0t, { ...r, ref: t, forceMount: n }) : i.type === "scroll" ? /* @__PURE__ */ y(Q0t, { ...r, ref: t, forceMount: n }) : i.type === "auto" ? /* @__PURE__ */ y(Eke, { ...r, ref: t, forceMount: n }) : i.type === "always" ? /* @__PURE__ */ y(b$, { ...r, ref: t }) : null;
  }
);
v$.displayName = zf;
var H0t = N.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = yu(zf, e.__scopeScrollArea), [o, s] = N.useState(!1);
  return N.useEffect(() => {
    const l = i.scrollArea;
    let c = 0;
    if (l) {
      const a = () => {
        window.clearTimeout(c), s(!0);
      }, u = () => {
        c = window.setTimeout(() => s(!1), i.scrollHideDelay);
      };
      return l.addEventListener("pointerenter", a), l.addEventListener("pointerleave", u), () => {
        window.clearTimeout(c), l.removeEventListener("pointerenter", a), l.removeEventListener("pointerleave", u);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ y(wo, { present: n || o, children: /* @__PURE__ */ y(
    Eke,
    {
      "data-state": o ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), Q0t = N.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = yu(zf, e.__scopeScrollArea), o = e.orientation === "horizontal", s = uj(() => c("SCROLL_END"), 100), [l, c] = W0t("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return N.useEffect(() => {
    if (l === "idle") {
      const a = window.setTimeout(() => c("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(a);
    }
  }, [l, i.scrollHideDelay, c]), N.useEffect(() => {
    const a = i.viewport, u = o ? "scrollLeft" : "scrollTop";
    if (a) {
      let f = a[u];
      const d = () => {
        const p = a[u];
        f !== p && (c("SCROLL"), s()), f = p;
      };
      return a.addEventListener("scroll", d), () => a.removeEventListener("scroll", d);
    }
  }, [i.viewport, o, c, s]), /* @__PURE__ */ y(wo, { present: n || l !== "hidden", children: /* @__PURE__ */ y(
    b$,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: ot(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: ot(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), Eke = N.forwardRef((e, t) => {
  const n = yu(zf, e.__scopeScrollArea), { forceMount: r, ...i } = e, [o, s] = N.useState(!1), l = e.orientation === "horizontal", c = uj(() => {
    if (n.viewport) {
      const a = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(l ? a : u);
    }
  }, 10);
  return aw(n.viewport, c), aw(n.content, c), /* @__PURE__ */ y(wo, { present: r || o, children: /* @__PURE__ */ y(
    b$,
    {
      "data-state": o ? "visible" : "hidden",
      ...i,
      ref: t
    }
  ) });
}), b$ = N.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, i = yu(zf, e.__scopeScrollArea), o = N.useRef(null), s = N.useRef(0), [l, c] = N.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), a = Pke(l.viewport, l.content), u = {
    ...r,
    sizes: l,
    onSizesChange: c,
    hasThumb: a > 0 && a < 1,
    onThumbChange: (d) => o.current = d,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (d) => s.current = d
  };
  function f(d, p) {
    return eOt(d, s.current, l, p);
  }
  return n === "horizontal" ? /* @__PURE__ */ y(
    $0t,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const d = i.viewport.scrollLeft, p = Uoe(d, l, i.dir);
          o.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (d) => {
        i.viewport && (i.viewport.scrollLeft = d);
      },
      onDragScroll: (d) => {
        i.viewport && (i.viewport.scrollLeft = f(d, i.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ y(
    K0t,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const d = i.viewport.scrollTop, p = Uoe(d, l);
          o.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (d) => {
        i.viewport && (i.viewport.scrollTop = d);
      },
      onDragScroll: (d) => {
        i.viewport && (i.viewport.scrollTop = f(d));
      }
    }
  ) : null;
}), $0t = N.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = yu(zf, e.__scopeScrollArea), [s, l] = N.useState(), c = N.useRef(null), a = xn(t, c, o.onScrollbarXChange);
  return N.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ y(
    kke,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: a,
      sizes: n,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": cj(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, f) => {
        if (o.viewport) {
          const d = o.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(d), Rke(d, f) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && s && r({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: ND(s.paddingLeft),
            paddingEnd: ND(s.paddingRight)
          }
        });
      }
    }
  );
}), K0t = N.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = yu(zf, e.__scopeScrollArea), [s, l] = N.useState(), c = N.useRef(null), a = xn(t, c, o.onScrollbarYChange);
  return N.useEffect(() => {
    c.current && l(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ y(
    kke,
    {
      "data-orientation": "vertical",
      ...i,
      ref: a,
      sizes: n,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": cj(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, f) => {
        if (o.viewport) {
          const d = o.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(d), Rke(d, f) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && s && r({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: ND(s.paddingTop),
            paddingEnd: ND(s.paddingBottom)
          }
        });
      }
    }
  );
}), [G0t, Tke] = Ake(zf), kke = N.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: i,
    onThumbChange: o,
    onThumbPointerUp: s,
    onThumbPointerDown: l,
    onThumbPositionChange: c,
    onDragScroll: a,
    onWheelScroll: u,
    onResize: f,
    ...d
  } = e, p = yu(zf, n), [h, m] = N.useState(null), v = xn(t, (T) => m(T)), b = N.useRef(null), A = N.useRef(""), w = p.viewport, O = r.content - r.viewport, x = ti(u), S = ti(c), E = uj(f, 10);
  function k(T) {
    if (b.current) {
      const R = T.clientX - b.current.left, j = T.clientY - b.current.top;
      a({ x: R, y: j });
    }
  }
  return N.useEffect(() => {
    const T = (R) => {
      const j = R.target;
      (h == null ? void 0 : h.contains(j)) && x(R, O);
    };
    return document.addEventListener("wheel", T, { passive: !1 }), () => document.removeEventListener("wheel", T, { passive: !1 });
  }, [w, h, O, x]), N.useEffect(S, [r, S]), aw(h, E), aw(p.content, E), /* @__PURE__ */ y(
    G0t,
    {
      scope: n,
      scrollbar: h,
      hasThumb: i,
      onThumbChange: ti(o),
      onThumbPointerUp: ti(s),
      onThumbPositionChange: S,
      onThumbPointerDown: ti(l),
      children: /* @__PURE__ */ y(
        Zt.div,
        {
          ...d,
          ref: v,
          style: { position: "absolute", ...d.style },
          onPointerDown: ot(e.onPointerDown, (T) => {
            T.button === 0 && (T.target.setPointerCapture(T.pointerId), b.current = h.getBoundingClientRect(), A.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), k(T));
          }),
          onPointerMove: ot(e.onPointerMove, k),
          onPointerUp: ot(e.onPointerUp, (T) => {
            const R = T.target;
            R.hasPointerCapture(T.pointerId) && R.releasePointerCapture(T.pointerId), document.body.style.webkitUserSelect = A.current, p.viewport && (p.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), CD = "ScrollAreaThumb", Cke = N.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = Tke(CD, e.__scopeScrollArea);
    return /* @__PURE__ */ y(wo, { present: n || i.hasThumb, children: /* @__PURE__ */ y(Y0t, { ref: t, ...r }) });
  }
), Y0t = N.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...i } = e, o = yu(CD, n), s = Tke(CD, n), { onThumbPositionChange: l } = s, c = xn(
      t,
      (f) => s.onThumbChange(f)
    ), a = N.useRef(), u = uj(() => {
      a.current && (a.current(), a.current = void 0);
    }, 100);
    return N.useEffect(() => {
      const f = o.viewport;
      if (f) {
        const d = () => {
          if (u(), !a.current) {
            const p = tOt(f, l);
            a.current = p, l();
          }
        };
        return l(), f.addEventListener("scroll", d), () => f.removeEventListener("scroll", d);
      }
    }, [o.viewport, u, l]), /* @__PURE__ */ y(
      Zt.div,
      {
        "data-state": s.hasThumb ? "visible" : "hidden",
        ...i,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: ot(e.onPointerDownCapture, (f) => {
          const p = f.target.getBoundingClientRect(), h = f.clientX - p.left, m = f.clientY - p.top;
          s.onThumbPointerDown({ x: h, y: m });
        }),
        onPointerUp: ot(e.onPointerUp, s.onThumbPointerUp)
      }
    );
  }
);
Cke.displayName = CD;
var O$ = "ScrollAreaCorner", Nke = N.forwardRef(
  (e, t) => {
    const n = yu(O$, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ y(J0t, { ...e, ref: t }) : null;
  }
);
Nke.displayName = O$;
var J0t = N.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, i = yu(O$, n), [o, s] = N.useState(0), [l, c] = N.useState(0), a = !!(o && l);
  return aw(i.scrollbarX, () => {
    var f;
    const u = ((f = i.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    i.onCornerHeightChange(u), c(u);
  }), aw(i.scrollbarY, () => {
    var f;
    const u = ((f = i.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    i.onCornerWidthChange(u), s(u);
  }), a ? /* @__PURE__ */ y(
    Zt.div,
    {
      ...r,
      ref: t,
      style: {
        width: o,
        height: l,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function ND(e) {
  return e ? parseInt(e, 10) : 0;
}
function Pke(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function cj(e) {
  const t = Pke(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function eOt(e, t, n, r = "ltr") {
  const i = cj(n), o = i / 2, s = t || o, l = i - s, c = n.scrollbar.paddingStart + s, a = n.scrollbar.size - n.scrollbar.paddingEnd - l, u = n.content - n.viewport, f = r === "ltr" ? [0, u] : [u * -1, 0];
  return Ike([c, a], f)(e);
}
function Uoe(e, t, n = "ltr") {
  const r = cj(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - i, s = t.content - t.viewport, l = o - r, c = n === "ltr" ? [0, s] : [s * -1, 0], a = GB(e, c);
  return Ike([0, s], [0, l])(a);
}
function Ike(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Rke(e, t) {
  return e > 0 && e < t;
}
var tOt = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function i() {
    const o = { left: e.scrollLeft, top: e.scrollTop }, s = n.left !== o.left, l = n.top !== o.top;
    (s || l) && t(), n = o, r = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(r);
};
function uj(e, t) {
  const n = ti(e), r = N.useRef(0);
  return N.useEffect(() => () => window.clearTimeout(r.current), []), N.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function aw(e, t) {
  const n = ti(t);
  qi(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [e, n]);
}
var Mke = wke, nOt = Ske, rOt = Nke;
const Bi = N.forwardRef(
  ({
    className: e,
    children: t,
    viewPortClassName: n,
    viewPortRef: r,
    orientation: i = "vertical",
    showGradient: o = !1,
    gradientClassName: s,
    ...l
  }, c) => {
    const [a, u] = N.useState(!1), f = N.useRef(null), d = r || f;
    return N.useEffect(() => {
      if (!o || !d.current) return;
      const p = d.current, h = () => {
        const { scrollTop: v, scrollHeight: b, clientHeight: A } = p, w = b > A, O = v + A >= b - 1;
        u(w && !O);
      };
      h(), p.addEventListener("scroll", h);
      const m = new ResizeObserver(h);
      return p.firstElementChild && m.observe(p.firstElementChild), () => {
        p.removeEventListener("scroll", h), m.disconnect();
      };
    }, [o, d]), /* @__PURE__ */ V(
      Mke,
      {
        ref: c,
        className: Se("relative overflow-hidden", e),
        ...l,
        children: [
          /* @__PURE__ */ y(
            nOt,
            {
              className: Se(
                "size-full rounded-[inherit] [&>div]:block!",
                n
              ),
              ref: d,
              children: t
            }
          ),
          /* @__PURE__ */ y(A$, { orientation: i }),
          /* @__PURE__ */ y(rOt, {}),
          o && a && /* @__PURE__ */ y(
            "div",
            {
              className: Se(
                "pointer-events-none absolute bottom-0 left-0 right-0 h-1/5 bg-linear-to-t from-sidebar to-transparent",
                s
              )
            }
          )
        ]
      }
    );
  }
);
Bi.displayName = Mke.displayName;
const A$ = N.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ y(
  v$,
  {
    ref: r,
    orientation: t,
    className: Se(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-px",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px",
      e
    ),
    ...n,
    children: /* @__PURE__ */ y(Cke, { className: "relative flex-1 rounded-full bg-border" })
  }
));
A$.displayName = v$.displayName;
const w$ = Fo(({ children: e, className: t, listClassName: n, ...r }, i) => /* @__PURE__ */ V(
  Bi,
  {
    className: `h-full overflow-auto ${t}`,
    viewPortClassName: "[&>div]:h-full",
    children: [
      /* @__PURE__ */ y(
        "div",
        {
          ref: i,
          className: Se("flex flex-col h-full w-full", n),
          ...r,
          children: e
        }
      ),
      /* @__PURE__ */ y(A$, { orientation: "horizontal" })
    ]
  }
));
w$.displayName = "CardList";
const iOt = as("flex items-center gap-4 w-full py-4 px-2 ", {
  variants: {
    interactive: {
      true: "cursor-pointer transition-all hover:bg-accent hover:text-accent-foreground",
      false: "cursor-default text-accent-foreground/50 font-semibold"
    },
    selected: {
      true: "bg-accent text-accent-foreground",
      false: ""
    }
  },
  defaultVariants: {
    interactive: !0,
    selected: !1
  }
}), Ng = ie.forwardRef(
  ({ children: e, onClick: t, className: n, interactive: r, selected: i, ...o }, s) => /* @__PURE__ */ y(
    "div",
    {
      onClick: t,
      ref: s,
      className: Se(
        iOt({ interactive: r, selected: i }),
        n
      ),
      ...o,
      children: e
    }
  )
);
Ng.displayName = "CardListItem";
const Ax = ie.memo(
  ({ numberOfCards: e = 3, withCircle: t = !0 }) => /* @__PURE__ */ y(pt, { children: [...Array(e)].map((n, r) => /* @__PURE__ */ V("div", { className: "flex items-center gap-4 w-full py-4 px-5", children: [
    t && /* @__PURE__ */ y(Tr, { className: "h-8 w-8 rounded-full" }),
    /* @__PURE__ */ V("div", { className: "space-y-2", children: [
      /* @__PURE__ */ y(Tr, { className: "h-4 w-[250px]" }),
      /* @__PURE__ */ y(Tr, { className: "h-4 w-[200px]" })
    ] })
  ] }, r)) })
);
Ax.displayName = "CardListItemSkeleton";
const Dke = ie.memo(({ message: e }) => /* @__PURE__ */ V("div", { className: "flex h-full w-full items-center justify-center gap-3 flex-col text-muted-foreground", children: [
  /* @__PURE__ */ y(Tot, { className: "w-10 h-10" }),
  /* @__PURE__ */ y("div", { className: "text-center tracking-tight", children: e })
] }));
Dke.displayName = "CardListEmpty";
var Be = typeof window < "u" ? window : void 0, ll = typeof globalThis < "u" ? globalThis : Be, _ke = Array.prototype, Voe = _ke.forEach, qoe = _ke.indexOf, Jl = ll == null ? void 0 : ll.navigator, Wt = ll == null ? void 0 : ll.document, Ya = ll == null ? void 0 : ll.location, YB = ll == null ? void 0 : ll.fetch, JB = ll != null && ll.XMLHttpRequest && "withCredentials" in new ll.XMLHttpRequest() ? ll.XMLHttpRequest : void 0, Boe = ll == null ? void 0 : ll.AbortController, Zo = Jl == null ? void 0 : Jl.userAgent, Tn = Be ?? {}, Gh = { DEBUG: !1, LIB_VERSION: "1.195.0" }, PD = {}, dj = function(e) {
  return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function ZO(e, t, n) {
  if (Qi(e)) {
    if (Voe && e.forEach === Voe) e.forEach(t, n);
    else if ("length" in e && e.length === +e.length) {
      for (var r = 0, i = e.length; r < i; r++) if (r in e && t.call(n, e[r], r) === PD) return;
    }
  }
}
function Xr(e, t, n) {
  if (!ei(e)) {
    if (Qi(e)) return ZO(e, t, n);
    if (uOt(e)) {
      for (var r of e.entries()) if (t.call(n, r[1], r[0]) === PD) return;
    } else for (var i in e) if (jke.call(e, i) && t.call(n, e[i], i) === PD) return;
  }
}
var Oa = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return ZO(n, function(i) {
    for (var o in i) i[o] !== void 0 && (e[o] = i[o]);
  }), e;
};
function Yn(e, t) {
  return e.indexOf(t) !== -1;
}
function HR(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; ) r[n] = [t[n], e[t[n]]];
  return r;
}
var Xoe = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, oOt = function(e) {
  return function() {
    try {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
      return e.apply(this, n);
    } catch (i) {
      un.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), un.critical(i);
    }
  };
}, ID = function(e) {
  var t = {};
  return Xr(e, function(n, r) {
    ws(n) && n.length > 0 && (t[r] = n);
  }), t;
}, eX = function(e) {
  return e.replace(/^\$/, "");
};
function sOt(e, t) {
  return n = e, r = (o) => ws(o) && !Pg(t) ? o.slice(0, t) : o, i = /* @__PURE__ */ new Set(), function o(s, l) {
    return s !== Object(s) ? r ? r(s, l) : s : i.has(s) ? void 0 : (i.add(s), Qi(s) ? (c = [], ZO(s, (a) => {
      c.push(o(a));
    })) : (c = {}, Xr(s, (a, u) => {
      i.has(a) || (c[u] = o(a, u));
    })), c);
    var c;
  }(n);
  var n, r, i;
}
var aOt = function(e) {
  var t, n, r, i, o = "";
  for (t = n = 0, r = (e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`)).length, i = 0; i < r; i++) {
    var s = e.charCodeAt(i), l = null;
    s < 128 ? n++ : l = s > 127 && s < 2048 ? String.fromCharCode(s >> 6 | 192, 63 & s | 128) : String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, 63 & s | 128), Pg(l) || (n > t && (o += e.substring(t, n)), o += l, t = n = i + 1);
  }
  return n > t && (o += e.substring(t, e.length)), o;
}, _p = function() {
  function e(t) {
    return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
  }
  return e.preventDefault = function() {
    this.returnValue = !1;
  }, e.stopPropagation = function() {
    this.cancelBubble = !0;
  }, function(t, n, r, i, o) {
    if (t) if (t.addEventListener && !i) t.addEventListener(n, r, !!o);
    else {
      var s = "on" + n, l = t[s];
      t[s] = /* @__PURE__ */ function(c, a, u) {
        return function(f) {
          if (f = f || e(Be == null ? void 0 : Be.event)) {
            var d, p = !0;
            Xc(u) && (d = u(f));
            var h = a.call(c, f);
            return d !== !1 && h !== !1 || (p = !1), p;
          }
        };
      }(t, r, l);
    }
    else un.error("No valid element provided to register_event");
  };
}();
function Lke(e, t) {
  for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
}
var zu, C6 = "$copy_autocapture", lOt = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"];
(function(e) {
  e.GZipJS = "gzip-js", e.Base64 = "base64";
})(zu || (zu = {}));
var cOt = Array.isArray, zke = Object.prototype, jke = zke.hasOwnProperty, fj = zke.toString, Qi = cOt || function(e) {
  return fj.call(e) === "[object Array]";
}, Xc = (e) => typeof e == "function", fo = (e) => e === Object(e) && !Qi(e), wO = (e) => {
  if (fo(e)) {
    for (var t in e) if (jke.call(e, t)) return !1;
    return !0;
  }
  return !1;
}, cn = (e) => e === void 0, ws = (e) => fj.call(e) == "[object String]", Woe = (e) => ws(e) && e.trim().length === 0, Pg = (e) => e === null, ei = (e) => cn(e) || Pg(e), Zl = (e) => fj.call(e) == "[object Number]", Ty = (e) => fj.call(e) === "[object Boolean]", uOt = (e) => e instanceof FormData, dOt = (e) => Yn(lOt, e), Fke = (e) => {
  var t = { _log: function(n) {
    if (Be && (Gh.DEBUG || Tn.POSTHOG_DEBUG) && !cn(Be.console) && Be.console) {
      for (var r = ("__rrweb_original__" in Be.console[n]) ? Be.console[n].__rrweb_original__ : Be.console[n], i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) o[s - 1] = arguments[s];
      r(e, ...o);
    }
  }, info: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
    t._log("log", ...r);
  }, warn: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
    t._log("warn", ...r);
  }, error: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
    t._log("error", ...r);
  }, critical: function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
    console.error(e, ...r);
  }, uninitializedWarning: (n) => {
    t.error("You must initialize PostHog before calling ".concat(n));
  }, createLogger: (n) => Fke("".concat(e, " ").concat(n)) };
  return t;
}, un = Fke("[PostHog.js]"), Va = un.createLogger, fOt = Va("[ExternalScriptsLoader]"), Zoe = (e, t, n) => {
  if (e.config.disable_external_dependency_loading) return fOt.warn("".concat(t, " was requested but loading of external scripts is disabled.")), n("Loading of external scripts is disabled");
  var r = () => {
    if (!Wt) return n("document not found");
    var i = Wt.createElement("script");
    i.type = "text/javascript", i.crossOrigin = "anonymous", i.src = t, i.onload = (l) => n(void 0, l), i.onerror = (l) => n(l);
    var o, s = Wt.querySelectorAll("body > script");
    s.length > 0 ? (o = s[0].parentNode) === null || o === void 0 || o.insertBefore(i, s[0]) : Wt.body.appendChild(i);
  };
  Wt != null && Wt.body ? r() : Wt == null || Wt.addEventListener("DOMContentLoaded", r);
};
function Hoe(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hoe(Object(n), !0).forEach(function(r) {
      Vt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hoe(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Vt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Uke(e, t) {
  if (e == null) return {};
  var n, r, i = function(s, l) {
    if (s == null) return {};
    var c, a, u = {}, f = Object.keys(s);
    for (a = 0; a < f.length; a++) c = f[a], l.indexOf(c) >= 0 || (u[c] = s[c]);
    return u;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
Tn.__PosthogExtensions__ = Tn.__PosthogExtensions__ || {}, Tn.__PosthogExtensions__.loadExternalDependency = (e, t, n) => {
  var r = "/static/".concat(t, ".js") + "?v=".concat(e.version);
  if (t === "remote-config" && (r = "/array/".concat(e.config.token, "/config.js")), t === "toolbar") {
    var i = 3e5, o = Math.floor(Date.now() / i) * i;
    r = "".concat(r, "&t=").concat(o);
  }
  var s = e.requestRouter.endpointFor("assets", r);
  Zoe(e, s, n);
}, Tn.__PosthogExtensions__.loadSiteApp = (e, t, n) => {
  var r = e.requestRouter.endpointFor("api", t);
  Zoe(e, r, n);
};
var Vke = "$people_distinct_id", t1 = "__alias", n1 = "__timers", Qoe = "$autocapture_disabled_server_side", tX = "$heatmaps_enabled_server_side", $oe = "$exception_capture_enabled_server_side", Koe = "$web_vitals_enabled_server_side", qke = "$dead_clicks_enabled_server_side", Goe = "$web_vitals_allowed_metrics", nX = "$session_recording_enabled_server_side", Yoe = "$console_log_recording_enabled_server_side", Joe = "$session_recording_network_payload_capture", ese = "$session_recording_canvas_recording", tse = "$replay_sample_rate", nse = "$replay_minimum_duration", rse = "$replay_script_config", RD = "$sesid", r1 = "$session_is_sampled", N6 = "$session_recording_url_trigger_activated_session", P6 = "$session_recording_event_trigger_activated_session", xO = "$enabled_feature_flags", rX = "$early_access_features", SO = "$stored_person_properties", Yh = "$stored_group_properties", iX = "$surveys", jP = "$surveys_activated", MD = "$flag_call_reported", Op = "$user_state", oX = "$client_session_props", sX = "$capture_rate_limit", aX = "$initial_campaign_params", lX = "$initial_referrer_info", cX = "$initial_person_info", DD = "$epp", Bke = "__POSTHOG_TOOLBAR__", pOt = [Vke, t1, "__cmpns", n1, nX, tX, RD, xO, Op, rX, Yh, SO, iX, MD, oX, sX, aX, lX, DD], FP = Va("[FeatureFlags]"), I6 = "$active_feature_flags", UP = "$override_feature_flags", ise = "$feature_flag_payloads", ose = (e) => {
  var t = {};
  for (var [n, r] of HR(e || {})) r && (t[n] = r);
  return t;
};
class hOt {
  constructor(t) {
    this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagVariants() {
    var t = this.instance.get_property(xO), n = this.instance.get_property(UP);
    if (!n) return t || {};
    for (var r = Oa({}, t), i = Object.keys(n), o = 0; o < i.length; o++) r[i[o]] = n[i[o]];
    return this._override_warning || (FP.warn(" Overriding feature flags!", { enabledFlags: t, overriddenFlags: n, finalFlags: r }), this._override_warning = !0), r;
  }
  getFlagPayloads() {
    return this.instance.get_property(ise) || {};
  }
  reloadFeatureFlags() {
    this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
  }
  setAnonymousDistinctId(t) {
    this.$anon_distinct_id = t;
  }
  setReloadingPaused(t) {
    this.reloadFeatureFlagsInAction = t;
  }
  resetRequestQueue() {
    this.reloadFeatureFlagsQueued = !1;
  }
  _startReloadTimer() {
    this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(() => {
      !this.reloadFeatureFlagsInAction && this.reloadFeatureFlagsQueued && (this.reloadFeatureFlagsQueued = !1, this._reloadFeatureFlagsRequest());
    }, 5);
  }
  _reloadFeatureFlagsRequest() {
    if (!this.instance.config.advanced_disable_feature_flags) {
      this.setReloadingPaused(!0);
      var t = this.instance.config.token, n = this.instance.get_property(SO), r = this.instance.get_property(Yh), i = { token: t, distinct_id: this.instance.get_distinct_id(), groups: this.instance.getGroups(), $anon_distinct_id: this.$anon_distinct_id, person_properties: n, group_properties: r, disable_flags: this.instance.config.advanced_disable_feature_flags || void 0 };
      this.instance._send_request({ method: "POST", url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"), data: i, compression: this.instance.config.disable_compression ? void 0 : zu.Base64, timeout: this.instance.config.feature_flag_request_timeout_ms, callback: (o) => {
        var s;
        this.setReloadingPaused(!1);
        var l = !0;
        o.statusCode === 200 && (this.$anon_distinct_id = void 0, l = !1), this.receivedFeatureFlags((s = o.json) !== null && s !== void 0 ? s : {}, l), this._startReloadTimer();
      } });
    }
  }
  getFeatureFlag(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
      var r, i = this.getFlagVariants()[t], o = "".concat(i), s = this.instance.get_property(MD) || {};
      return (n.send_event || !("send_event" in n)) && (!(t in s) || !s[t].includes(o)) && (Qi(s[t]) ? s[t].push(o) : s[t] = [o], (r = this.instance.persistence) === null || r === void 0 || r.register({ [MD]: s }), this.instance.capture("$feature_flag_called", { $feature_flag: t, $feature_flag_response: i })), i;
    }
    FP.warn('getFeatureFlag for key "' + t + `" failed. Feature flags didn't load in time.`);
  }
  getFeatureFlagPayload(t) {
    return this.getFlagPayloads()[t];
  }
  isFeatureEnabled(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(t, n);
    FP.warn('isFeatureEnabled for key "' + t + `" failed. Feature flags didn't load in time.`);
  }
  addFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers.push(t);
  }
  removeFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((n) => n !== t);
  }
  receivedFeatureFlags(t, n) {
    if (this.instance.persistence) {
      this.instance.decideEndpointWasHit = !0;
      var r = this.getFlagVariants(), i = this.getFlagPayloads();
      (function(o, s) {
        var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = o.featureFlags, u = o.featureFlagPayloads;
        if (a) if (Qi(a)) {
          var f = {};
          if (a) for (var d = 0; d < a.length; d++) f[a[d]] = !0;
          s && s.register({ [I6]: a, [xO]: f });
        } else {
          var p = a, h = u;
          o.errorsWhileComputingFlags && (p = bt(bt({}, l), p), h = bt(bt({}, c), h)), s && s.register({ [I6]: Object.keys(ose(p)), [xO]: p || {}, [ise]: h || {} });
        }
      })(t, this.instance.persistence, r, i), this._fireFeatureFlagsCallbacks(n);
    }
  }
  override(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    if (!this.instance.__loaded || !this.instance.persistence) return FP.uninitializedWarning("posthog.feature_flags.override");
    if (this._override_warning = n, t === !1) this.instance.persistence.unregister(UP);
    else if (Qi(t)) {
      for (var r = {}, i = 0; i < t.length; i++) r[t[i]] = !0;
      this.instance.persistence.register({ [UP]: r });
    } else this.instance.persistence.register({ [UP]: t });
  }
  onFeatureFlags(t) {
    if (this.addFeatureFlagsHandler(t), this.instance.decideEndpointWasHit) {
      var { flags: n, flagVariants: r } = this._prepareFeatureFlagsForCallbacks();
      t(n, r);
    }
    return () => this.removeFeatureFlagsHandler(t);
  }
  updateEarlyAccessFeatureEnrollment(t, n) {
    var r, i = { ["$feature_enrollment/".concat(t)]: n };
    this.instance.capture("$feature_enrollment_update", { $feature_flag: t, $feature_enrollment: n, $set: i }), this.setPersonPropertiesForFlags(i, !1);
    var o = bt(bt({}, this.getFlagVariants()), {}, { [t]: n });
    (r = this.instance.persistence) === null || r === void 0 || r.register({ [I6]: Object.keys(ose(o)), [xO]: o }), this._fireFeatureFlagsCallbacks();
  }
  getEarlyAccessFeatures(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], r = this.instance.get_property(rX);
    if (r && !n) return t(r);
    this.instance._send_request({ transport: "XHR", url: this.instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=".concat(this.instance.config.token)), method: "GET", callback: (i) => {
      var o;
      if (i.json) {
        var s = i.json.earlyAccessFeatures;
        return (o = this.instance.persistence) === null || o === void 0 || o.register({ [rX]: s }), t(s);
      }
    } });
  }
  _prepareFeatureFlagsForCallbacks() {
    var t = this.getFlags(), n = this.getFlagVariants();
    return { flags: t.filter((r) => n[r]), flagVariants: Object.keys(n).filter((r) => n[r]).reduce((r, i) => (r[i] = n[i], r), {}) };
  }
  _fireFeatureFlagsCallbacks(t) {
    var { flags: n, flagVariants: r } = this._prepareFeatureFlagsForCallbacks();
    this.featureFlagEventHandlers.forEach((i) => i(n, r, { errorsLoading: t }));
  }
  setPersonPropertiesForFlags(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], r = this.instance.get_property(SO) || {};
    this.instance.register({ [SO]: bt(bt({}, r), t) }), n && this.instance.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags() {
    this.instance.unregister(SO);
  }
  setGroupPropertiesForFlags(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], r = this.instance.get_property(Yh) || {};
    Object.keys(r).length !== 0 && Object.keys(r).forEach((i) => {
      r[i] = bt(bt({}, r[i]), t[i]), delete t[i];
    }), this.instance.register({ [Yh]: bt(bt({}, r), t) }), n && this.instance.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(t) {
    if (t) {
      var n = this.instance.get_property(Yh) || {};
      this.instance.register({ [Yh]: bt(bt({}, n), {}, { [t]: {} }) });
    } else this.instance.unregister(Yh);
  }
}
Math.trunc || (Math.trunc = function(e) {
  return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
  return Zl(e) && isFinite(e) && Math.floor(e) === e;
});
var sse = "0123456789abcdef";
class _D {
  constructor(t) {
    if (this.bytes = t, t.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(t, n, r, i) {
    if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(r) || !Number.isInteger(i) || t < 0 || n < 0 || r < 0 || i < 0 || t > 281474976710655 || n > 4095 || r > 1073741823 || i > 4294967295) throw new RangeError("invalid field value");
    var o = new Uint8Array(16);
    return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / Math.pow(2, 8), o[5] = t, o[6] = 112 | n >>> 8, o[7] = n, o[8] = 128 | r >>> 24, o[9] = r >>> 16, o[10] = r >>> 8, o[11] = r, o[12] = i >>> 24, o[13] = i >>> 16, o[14] = i >>> 8, o[15] = i, new _D(o);
  }
  toString() {
    for (var t = "", n = 0; n < this.bytes.length; n++) t = t + sse.charAt(this.bytes[n] >>> 4) + sse.charAt(15 & this.bytes[n]), n !== 3 && n !== 5 && n !== 7 && n !== 9 || (t += "-");
    if (t.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return t;
  }
  clone() {
    return new _D(this.bytes.slice(0));
  }
  equals(t) {
    return this.compareTo(t) === 0;
  }
  compareTo(t) {
    for (var n = 0; n < 16; n++) {
      var r = this.bytes[n] - t.bytes[n];
      if (r !== 0) return Math.sign(r);
    }
    return 0;
  }
}
class mOt {
  constructor() {
    Vt(this, "timestamp", 0), Vt(this, "counter", 0), Vt(this, "random", new gOt());
  }
  generate() {
    var t = this.generateOrAbort();
    if (cn(t)) {
      this.timestamp = 0;
      var n = this.generateOrAbort();
      if (cn(n)) throw new Error("Could not generate UUID after timestamp reset");
      return n;
    }
    return t;
  }
  generateOrAbort() {
    var t = Date.now();
    if (t > this.timestamp) this.timestamp = t, this.resetCounter();
    else {
      if (!(t + 1e4 > this.timestamp)) return;
      this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
    }
    return _D.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
  }
  resetCounter() {
    this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
  }
}
var ase, Xke = (e) => {
  if (typeof UUIDV7_DENY_WEAK_RNG < "u" && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (var t = 0; t < e.length; t++) e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return e;
};
Be && !cn(Be.crypto) && crypto.getRandomValues && (Xke = (e) => crypto.getRandomValues(e));
class gOt {
  constructor() {
    Vt(this, "buffer", new Uint32Array(8)), Vt(this, "cursor", 1 / 0);
  }
  nextUint32() {
    return this.cursor >= this.buffer.length && (Xke(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
  }
}
var Im = () => yOt().toString(), yOt = () => (ase || (ase = new mOt())).generate(), vOt = "Thu, 01 Jan 1970 00:00:00 GMT", iS = "", bOt = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function OOt(e, t) {
  if (t) {
    var n = function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wt;
      if (iS) return iS;
      if (!o || ["localhost", "127.0.0.1"].includes(i)) return "";
      for (var s = i.split("."), l = Math.min(s.length, 8), c = "dmn_chk_" + Im(), a = new RegExp("(^|;)\\s*" + c + "=1"); !iS && l--; ) {
        var u = s.slice(l).join("."), f = c + "=1;domain=." + u;
        o.cookie = f, a.test(o.cookie) && (o.cookie = f + ";expires=" + vOt, iS = u);
      }
      return iS;
    }(e);
    if (!n) {
      var r = ((i) => {
        var o = i.match(bOt);
        return o ? o[0] : "";
      })(e);
      r !== n && un.info("Warning: cookie subdomain discovery mismatch", r, n), n = r;
    }
    return n ? "; domain=." + n : "";
  }
  return "";
}
var Jp = { is_supported: () => !!Wt, error: function(e) {
  un.error("cookieStore error: " + e);
}, get: function(e) {
  if (Wt) {
    try {
      for (var t = e + "=", n = Wt.cookie.split(";").filter((o) => o.length), r = 0; r < n.length; r++) {
        for (var i = n[r]; i.charAt(0) == " "; ) i = i.substring(1, i.length);
        if (i.indexOf(t) === 0) return decodeURIComponent(i.substring(t.length, i.length));
      }
    } catch {
    }
    return null;
  }
}, parse: function(e) {
  var t;
  try {
    t = JSON.parse(Jp.get(e)) || {};
  } catch {
  }
  return t;
}, set: function(e, t, n, r, i) {
  if (Wt) try {
    var o = "", s = "", l = OOt(Wt.location.hostname, r);
    if (n) {
      var c = /* @__PURE__ */ new Date();
      c.setTime(c.getTime() + 24 * n * 60 * 60 * 1e3), o = "; expires=" + c.toUTCString();
    }
    i && (s = "; secure");
    var a = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + l + s;
    return a.length > 3686.4 && un.warn("cookieStore warning: large cookie, len=" + a.length), Wt.cookie = a, a;
  } catch {
    return;
  }
}, remove: function(e, t) {
  try {
    Jp.set(e, "", -1, t);
  } catch {
    return;
  }
} }, R6 = null, Io = { is_supported: function() {
  if (!Pg(R6)) return R6;
  var e = !0;
  if (cn(Be)) e = !1;
  else try {
    var t = "__mplssupport__";
    Io.set(t, "xyz"), Io.get(t) !== '"xyz"' && (e = !1), Io.remove(t);
  } catch {
    e = !1;
  }
  return e || un.error("localStorage unsupported; falling back to cookie store"), R6 = e, e;
}, error: function(e) {
  un.error("localStorage error: " + e);
}, get: function(e) {
  try {
    return Be == null ? void 0 : Be.localStorage.getItem(e);
  } catch (t) {
    Io.error(t);
  }
  return null;
}, parse: function(e) {
  try {
    return JSON.parse(Io.get(e)) || {};
  } catch {
  }
  return null;
}, set: function(e, t) {
  try {
    Be == null || Be.localStorage.setItem(e, JSON.stringify(t));
  } catch (n) {
    Io.error(n);
  }
}, remove: function(e) {
  try {
    Be == null || Be.localStorage.removeItem(e);
  } catch (t) {
    Io.error(t);
  }
} }, AOt = ["distinct_id", RD, r1, DD, cX], VP = bt(bt({}, Io), {}, { parse: function(e) {
  try {
    var t = {};
    try {
      t = Jp.parse(e) || {};
    } catch {
    }
    var n = Oa(t, JSON.parse(Io.get(e) || "{}"));
    return Io.set(e, n), n;
  } catch {
  }
  return null;
}, set: function(e, t, n, r, i, o) {
  try {
    Io.set(e, t, void 0, void 0, o);
    var s = {};
    AOt.forEach((l) => {
      t[l] && (s[l] = t[l]);
    }), Object.keys(s).length && Jp.set(e, s, n, r, i, o);
  } catch (l) {
    Io.error(l);
  }
}, remove: function(e, t) {
  try {
    Be == null || Be.localStorage.removeItem(e), Jp.remove(e, t);
  } catch (n) {
    Io.error(n);
  }
} }), qP = {}, wOt = { is_supported: function() {
  return !0;
}, error: function(e) {
  un.error("memoryStorage error: " + e);
}, get: function(e) {
  return qP[e] || null;
}, parse: function(e) {
  return qP[e] || null;
}, set: function(e, t) {
  qP[e] = t;
}, remove: function(e) {
  delete qP[e];
} }, Gg = null, ms = { is_supported: function() {
  if (!Pg(Gg)) return Gg;
  if (Gg = !0, cn(Be)) Gg = !1;
  else try {
    var e = "__support__";
    ms.set(e, "xyz"), ms.get(e) !== '"xyz"' && (Gg = !1), ms.remove(e);
  } catch {
    Gg = !1;
  }
  return Gg;
}, error: function(e) {
  un.error("sessionStorage error: ", e);
}, get: function(e) {
  try {
    return Be == null ? void 0 : Be.sessionStorage.getItem(e);
  } catch (t) {
    ms.error(t);
  }
  return null;
}, parse: function(e) {
  try {
    return JSON.parse(ms.get(e)) || null;
  } catch {
  }
  return null;
}, set: function(e, t) {
  try {
    Be == null || Be.sessionStorage.setItem(e, JSON.stringify(t));
  } catch (n) {
    ms.error(n);
  }
}, remove: function(e) {
  try {
    Be == null || Be.sessionStorage.removeItem(e);
  } catch (t) {
    ms.error(t);
  }
} }, xOt = ["localhost", "127.0.0.1"], HO = (e) => {
  var t = Wt == null ? void 0 : Wt.createElement("a");
  return cn(t) ? null : (t.href = e, t);
}, lw = function(e, t) {
  return !!function(n) {
    try {
      new RegExp(n);
    } catch {
      return !1;
    }
    return !0;
  }(t) && new RegExp(t).test(e);
}, SOt = function(e) {
  var t, n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&", i = [];
  return Xr(e, function(o, s) {
    cn(o) || cn(s) || s === "undefined" || (t = encodeURIComponent(((l) => l instanceof File)(o) ? o.name : o.toString()), n = encodeURIComponent(s), i[i.length] = n + "=" + t);
  }), i.join(r);
}, LD = function(e, t) {
  for (var n, r = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), i = 0; i < r.length; i++) {
    var o = r[i].split("=");
    if (o[0] === t) {
      n = o;
      break;
    }
  }
  if (!Qi(n) || n.length < 2) return "";
  var s = n[1];
  try {
    s = decodeURIComponent(s);
  } catch {
    un.error("Skipping decoding for malformed query param: " + s);
  }
  return s.replace(/\+/g, " ");
}, zD = function(e, t) {
  var n = e.match(new RegExp(t + "=([^&]*)"));
  return n ? n[1] : null;
}, Qc = "Mobile", jD = "iOS", sf = "Android", XT = "Tablet", Wke = sf + " " + XT, Zke = "iPad", Hke = "Apple", Qke = Hke + " Watch", WT = "Safari", cw = "BlackBerry", $ke = "Samsung", Kke = $ke + "Browser", Gke = $ke + " Internet", _v = "Chrome", EOt = _v + " OS", Yke = _v + " " + jD, x$ = "Internet Explorer", Jke = x$ + " " + Qc, S$ = "Opera", TOt = S$ + " Mini", E$ = "Edge", eCe = "Microsoft " + E$, QO = "Firefox", tCe = QO + " " + jD, ZT = "Nintendo", HT = "PlayStation", $O = "Xbox", nCe = sf + " " + Qc, rCe = Qc + " " + WT, i1 = "Windows", uX = i1 + " Phone", lse = "Nokia", dX = "Ouya", iCe = "Generic", kOt = iCe + " " + Qc.toLowerCase(), oCe = iCe + " " + XT.toLowerCase(), fX = "Konqueror", ha = "(\\d+(\\.\\d+)?)", M6 = new RegExp("Version/" + ha), COt = new RegExp($O, "i"), NOt = new RegExp(HT + " \\w+", "i"), POt = new RegExp(ZT + " \\w+", "i"), T$ = new RegExp(cw + "|PlayBook|BB10", "i"), IOt = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, ROt = (e, t) => t && Yn(t, Hke) || function(n) {
  return Yn(n, WT) && !Yn(n, _v) && !Yn(n, sf);
}(e), cse = function(e, t) {
  return t = t || "", Yn(e, " OPR/") && Yn(e, "Mini") ? TOt : Yn(e, " OPR/") ? S$ : T$.test(e) ? cw : Yn(e, "IE" + Qc) || Yn(e, "WPDesktop") ? Jke : Yn(e, Kke) ? Gke : Yn(e, E$) || Yn(e, "Edg/") ? eCe : Yn(e, "FBIOS") ? "Facebook " + Qc : Yn(e, "UCWEB") || Yn(e, "UCBrowser") ? "UC Browser" : Yn(e, "CriOS") ? Yke : Yn(e, "CrMo") || Yn(e, _v) ? _v : Yn(e, sf) && Yn(e, WT) ? nCe : Yn(e, "FxiOS") ? tCe : Yn(e.toLowerCase(), fX.toLowerCase()) ? fX : ROt(e, t) ? Yn(e, Qc) ? rCe : WT : Yn(e, QO) ? QO : Yn(e, "MSIE") || Yn(e, "Trident/") ? x$ : Yn(e, "Gecko") ? QO : "";
}, MOt = { [Jke]: [new RegExp("rv:" + ha)], [eCe]: [new RegExp(E$ + "?\\/" + ha)], [_v]: [new RegExp("(" + _v + "|CrMo)\\/" + ha)], [Yke]: [new RegExp("CriOS\\/" + ha)], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/" + ha)], [WT]: [M6], [rCe]: [M6], [S$]: [new RegExp("(Opera|OPR)\\/" + ha)], [QO]: [new RegExp(QO + "\\/" + ha)], [tCe]: [new RegExp("FxiOS\\/" + ha)], [fX]: [new RegExp("Konqueror[:/]?" + ha, "i")], [cw]: [new RegExp(cw + " " + ha), M6], [nCe]: [new RegExp("android\\s" + ha, "i")], [Gke]: [new RegExp(Kke + "\\/" + ha)], [x$]: [new RegExp("(rv:|MSIE )" + ha)], Mozilla: [new RegExp("rv:" + ha)] }, use = [[new RegExp($O + "; " + $O + " (.*?)[);]", "i"), (e) => [$O, e && e[1] || ""]], [new RegExp(ZT, "i"), [ZT, ""]], [new RegExp(HT, "i"), [HT, ""]], [T$, [cw, ""]], [new RegExp(i1, "i"), (e, t) => {
  if (/Phone/.test(t) || /WPDesktop/.test(t)) return [uX, ""];
  if (new RegExp(Qc).test(t) && !/IEMobile\b/.test(t)) return [i1 + " " + Qc, ""];
  var n = /Windows NT ([0-9.]+)/i.exec(t);
  if (n && n[1]) {
    var r = n[1], i = IOt[r] || "";
    return /arm/i.test(t) && (i = "RT"), [i1, i];
  }
  return [i1, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (e) => {
  if (e && e[3]) {
    var t = [e[3], e[4], e[5] || "0"];
    return [jD, t.join(".")];
  }
  return [jD, ""];
}], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (e) => {
  var t = "";
  return e && e.length >= 3 && (t = cn(e[2]) ? e[3] : e[2]), ["watchOS", t];
}], [new RegExp("(" + sf + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + sf + ")", "i"), (e) => {
  if (e && e[2]) {
    var t = [e[2], e[3], e[4] || "0"];
    return [sf, t.join(".")];
  }
  return [sf, ""];
}], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (e) => {
  var t = ["Mac OS X", ""];
  if (e && e[1]) {
    var n = [e[1], e[2], e[3] || "0"];
    t[1] = n.join(".");
  }
  return t;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, [EOt, ""]], [/Linux|debian/i, ["Linux", ""]]], dse = function(e) {
  return POt.test(e) ? ZT : NOt.test(e) ? HT : COt.test(e) ? $O : new RegExp(dX, "i").test(e) ? dX : new RegExp("(" + uX + "|WPDesktop)", "i").test(e) ? uX : /iPad/.test(e) ? Zke : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? Qke : T$.test(e) ? cw : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp(lse, "i").test(e) ? lse : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp(Qc).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? sf : Wke : sf : new RegExp("(pda|" + Qc + ")", "i").test(e) ? kOt : new RegExp(XT, "i").test(e) && !new RegExp(XT + " pc", "i").test(e) ? oCe : "";
}, BP = "https?://(.*)", DOt = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gad_source", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "mc_cid", "igshid", "ttclid", "rdt_cid"], zi = { campaignParams: function(e) {
  return Wt ? this._campaignParamsFromUrl(Wt.URL, e) : {};
}, _campaignParamsFromUrl: function(e, t) {
  var n = DOt.concat(t || []), r = {};
  return Xr(n, function(i) {
    var o = LD(e, i);
    r[i] = o || null;
  }), r;
}, _searchEngine: function(e) {
  return e ? e.search(BP + "google.([^/?]*)") === 0 ? "google" : e.search(BP + "bing.com") === 0 ? "bing" : e.search(BP + "yahoo.com") === 0 ? "yahoo" : e.search(BP + "duckduckgo.com") === 0 ? "duckduckgo" : null : null;
}, _searchInfoFromReferrer: function(e) {
  var t = zi._searchEngine(e), n = t != "yahoo" ? "q" : "p", r = {};
  if (!Pg(t)) {
    r.$search_engine = t;
    var i = Wt ? LD(Wt.referrer, n) : "";
    i.length && (r.ph_keyword = i);
  }
  return r;
}, searchInfo: function() {
  var e = Wt == null ? void 0 : Wt.referrer;
  return e ? this._searchInfoFromReferrer(e) : {};
}, browser: cse, browserVersion: function(e, t) {
  var n = cse(e, t), r = MOt[n];
  if (cn(r)) return null;
  for (var i = 0; i < r.length; i++) {
    var o = r[i], s = e.match(o);
    if (s) return parseFloat(s[s.length - 2]);
  }
  return null;
}, browserLanguage: function() {
  return navigator.language || navigator.userLanguage;
}, browserLanguagePrefix: function() {
  var e = this.browserLanguage();
  return typeof e == "string" ? e.split("-")[0] : void 0;
}, os: function(e) {
  for (var t = 0; t < use.length; t++) {
    var [n, r] = use[t], i = n.exec(e), o = i && (Xc(r) ? r(i, e) : r);
    if (o) return o;
  }
  return ["", ""];
}, device: dse, deviceType: function(e) {
  var t = dse(e);
  return t === Zke || t === Wke || t === "Kobo" || t === "Kindle Fire" || t === oCe ? XT : t === ZT || t === $O || t === HT || t === dX ? "Console" : t === Qke ? "Wearable" : t ? Qc : "Desktop";
}, referrer: function() {
  return (Wt == null ? void 0 : Wt.referrer) || "$direct";
}, referringDomain: function() {
  var e;
  return Wt != null && Wt.referrer && ((e = HO(Wt.referrer)) === null || e === void 0 ? void 0 : e.host) || "$direct";
}, referrerInfo: function() {
  return { $referrer: this.referrer(), $referring_domain: this.referringDomain() };
}, initialPersonInfo: function() {
  return { r: this.referrer().substring(0, 1e3), u: Ya == null ? void 0 : Ya.href.substring(0, 1e3) };
}, initialPersonPropsFromInfo: function(e) {
  var t, { r: n, u: r } = e, i = { $initial_referrer: n, $initial_referring_domain: n == null ? void 0 : n == "$direct" ? "$direct" : (t = HO(n)) === null || t === void 0 ? void 0 : t.host };
  if (r) {
    i.$initial_current_url = r;
    var o = HO(r);
    i.$initial_host = o == null ? void 0 : o.host, i.$initial_pathname = o == null ? void 0 : o.pathname, Xr(this._campaignParamsFromUrl(r), function(s, l) {
      i["$initial_" + eX(l)] = s;
    });
  }
  return n && Xr(this._searchInfoFromReferrer(n), function(s, l) {
    i["$initial_" + eX(l)] = s;
  }), i;
}, timezone: function() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}, timezoneOffset: function() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch {
    return;
  }
}, properties: function() {
  if (!Zo) return {};
  var [e, t] = zi.os(Zo);
  return Oa(ID({ $os: e, $os_version: t, $browser: zi.browser(Zo, navigator.vendor), $device: zi.device(Zo), $device_type: zi.deviceType(Zo), $timezone: zi.timezone(), $timezone_offset: zi.timezoneOffset() }), { $current_url: Ya == null ? void 0 : Ya.href, $host: Ya == null ? void 0 : Ya.host, $pathname: Ya == null ? void 0 : Ya.pathname, $raw_user_agent: Zo.length > 1e3 ? Zo.substring(0, 997) + "..." : Zo, $browser_version: zi.browserVersion(Zo, navigator.vendor), $browser_language: zi.browserLanguage(), $browser_language_prefix: zi.browserLanguagePrefix(), $screen_height: Be == null ? void 0 : Be.screen.height, $screen_width: Be == null ? void 0 : Be.screen.width, $viewport_height: Be == null ? void 0 : Be.innerHeight, $viewport_width: Be == null ? void 0 : Be.innerWidth, $lib: "web", $lib_version: Gh.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
}, people_properties: function() {
  if (!Zo) return {};
  var [e, t] = zi.os(Zo);
  return Oa(ID({ $os: e, $os_version: t, $browser: zi.browser(Zo, navigator.vendor) }), { $browser_version: zi.browserVersion(Zo, navigator.vendor) });
} }, _Ot = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"];
class D6 {
  constructor(t) {
    this.config = t, this.props = {}, this.campaign_params_saved = !1, this.name = ((n) => {
      var r = "";
      return n.token && (r = n.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), n.persistence_name ? "ph_" + n.persistence_name : "ph_" + r + "_posthog";
    })(t), this.storage = this.buildStorage(t), this.load(), t.debug && un.info("Persistence loaded", t.persistence, bt({}, this.props)), this.update_config(t, t), this.save();
  }
  buildStorage(t) {
    _Ot.indexOf(t.persistence.toLowerCase()) === -1 && (un.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
    var n = t.persistence.toLowerCase();
    return n === "localstorage" && Io.is_supported() ? Io : n === "localstorage+cookie" && VP.is_supported() ? VP : n === "sessionstorage" && ms.is_supported() ? ms : n === "memory" ? wOt : n === "cookie" ? Jp : VP.is_supported() ? VP : Jp;
  }
  properties() {
    var t = {};
    return Xr(this.props, function(n, r) {
      if (r === xO && fo(n)) for (var i = Object.keys(n), o = 0; o < i.length; o++) t["$feature/".concat(i[o])] = n[i[o]];
      else l = r, c = !1, (Pg(s = pOt) ? c : qoe && s.indexOf === qoe ? s.indexOf(l) != -1 : (Xr(s, function(a) {
        if (c || (c = a === l)) return PD;
      }), c)) || (t[r] = n);
      var s, l, c;
    }), t;
  }
  load() {
    if (!this.disabled) {
      var t = this.storage.parse(this.name);
      t && (this.props = Oa({}, t));
    }
  }
  save() {
    this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure, this.config.debug);
  }
  remove() {
    this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(t, n, r) {
    if (fo(t)) {
      cn(n) && (n = "None"), this.expire_days = cn(r) ? this.default_expiry : r;
      var i = !1;
      if (Xr(t, (o, s) => {
        this.props.hasOwnProperty(s) && this.props[s] !== n || (this.props[s] = o, i = !0);
      }), i) return this.save(), !0;
    }
    return !1;
  }
  register(t, n) {
    if (fo(t)) {
      this.expire_days = cn(n) ? this.default_expiry : n;
      var r = !1;
      if (Xr(t, (i, o) => {
        t.hasOwnProperty(o) && this.props[o] !== i && (this.props[o] = i, r = !0);
      }), r) return this.save(), !0;
    }
    return !1;
  }
  unregister(t) {
    t in this.props && (delete this.props[t], this.save());
  }
  update_campaign_params() {
    if (!this.campaign_params_saved) {
      var t = zi.campaignParams(this.config.custom_campaign_params);
      wO(ID(t)) || this.register(t), this.campaign_params_saved = !0;
    }
  }
  update_search_keyword() {
    this.register(zi.searchInfo());
  }
  update_referrer_info() {
    this.register_once(zi.referrerInfo(), void 0);
  }
  set_initial_person_info() {
    this.props[aX] || this.props[lX] || this.register_once({ [cX]: zi.initialPersonInfo() }, void 0);
  }
  get_referrer_info() {
    return ID({ $referrer: this.props.$referrer, $referring_domain: this.props.$referring_domain });
  }
  get_initial_props() {
    var t = {};
    Xr([lX, aX], (i) => {
      var o = this.props[i];
      o && Xr(o, function(s, l) {
        t["$initial_" + eX(l)] = s;
      });
    });
    var n = this.props[cX];
    if (n) {
      var r = zi.initialPersonPropsFromInfo(n);
      Oa(t, r);
    }
    return t;
  }
  safe_merge(t) {
    return Xr(this.props, function(n, r) {
      r in t || (t[r] = n);
    }), t;
  }
  update_config(t, n) {
    if (this.default_expiry = this.expire_days = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== n.persistence) {
      var r = this.buildStorage(t), i = this.props;
      this.clear(), this.storage = r, this.props = i, this.save();
    }
  }
  set_disabled(t) {
    this.disabled = t, this.disabled ? this.remove() : this.save();
  }
  set_cross_subdomain(t) {
    t !== this.cross_subdomain && (this.cross_subdomain = t, this.remove(), this.save());
  }
  get_cross_subdomain() {
    return !!this.cross_subdomain;
  }
  set_secure(t) {
    t !== this.secure && (this.secure = t, this.remove(), this.save());
  }
  set_event_timer(t, n) {
    var r = this.props[n1] || {};
    r[t] = n, this.props[n1] = r, this.save();
  }
  remove_event_timer(t) {
    var n = (this.props[n1] || {})[t];
    return cn(n) || (delete this.props[n1][t], this.save()), n;
  }
  get_property(t) {
    return this.props[t];
  }
  set_property(t, n) {
    this.props[t] = n, this.save();
  }
}
function FD(e) {
  var t, n;
  return ((t = JSON.stringify(e, (n = [], function(r, i) {
    if (fo(i)) {
      for (; n.length > 0 && n[n.length - 1] !== this; ) n.pop();
      return n.includes(i) ? "[Circular]" : (n.push(i), i);
    }
    return i;
  }))) === null || t === void 0 ? void 0 : t.length) || 0;
}
function pX(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 66060288e-1;
  if (e.size >= t && e.data.length > 1) {
    var n = Math.floor(e.data.length / 2), r = e.data.slice(0, n), i = e.data.slice(n);
    return [pX({ size: FD(r), data: r, sessionId: e.sessionId, windowId: e.windowId }), pX({ size: FD(i), data: i, sessionId: e.sessionId, windowId: e.windowId })].flatMap((o) => o);
  }
  return [e];
}
var Ap = ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(Ap || {}), Cu = ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(Cu || {});
function fse(e) {
  var t;
  return e.id === Bke || !((t = e.closest) === null || t === void 0 || !t.call(e, ".toolbar-global-fade-container"));
}
function pj(e) {
  return !!e && e.nodeType === 1;
}
function Xm(e, t) {
  return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function sCe(e) {
  return !!e && e.nodeType === 3;
}
function aCe(e) {
  return !!e && e.nodeType === 11;
}
function k$(e) {
  return e ? dj(e).split(/\s+/) : [];
}
function pse(e) {
  var t = Be == null ? void 0 : Be.location.href;
  return !!(t && e && e.some((n) => t.match(n)));
}
function UD(e) {
  var t = "";
  switch (typeof e.className) {
    case "string":
      t = e.className;
      break;
    case "object":
      t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
      break;
    default:
      t = "";
  }
  return k$(t);
}
function lCe(e) {
  return ei(e) ? null : dj(e).split(/(\s+)/).filter((t) => uw(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function hj(e) {
  var t = "";
  return mX(e) && !dCe(e) && e.childNodes && e.childNodes.length && Xr(e.childNodes, function(n) {
    var r;
    sCe(n) && n.textContent && (t += (r = lCe(n.textContent)) !== null && r !== void 0 ? r : "");
  }), dj(t);
}
function cCe(e) {
  return cn(e.target) ? e.srcElement || null : (t = e.target) !== null && t !== void 0 && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
  var t;
}
var hX = ["a", "button", "form", "input", "select", "textarea", "label"];
function uCe(e) {
  var t = e.parentNode;
  return !(!t || !pj(t)) && t;
}
function LOt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0;
  if (!Be || !e || Xm(e, "html") || !pj(e) || n != null && n.url_allowlist && !pse(n.url_allowlist) || n != null && n.url_ignorelist && pse(n.url_ignorelist)) return !1;
  if (n != null && n.dom_event_allowlist) {
    var o = n.dom_event_allowlist;
    if (o && !o.some((p) => t.type === p)) return !1;
  }
  for (var s = !1, l = [e], c = !0, a = e; a.parentNode && !Xm(a, "body"); ) if (aCe(a.parentNode)) l.push(a.parentNode.host), a = a.parentNode.host;
  else {
    if (!(c = uCe(a))) break;
    if (r || hX.indexOf(c.tagName.toLowerCase()) > -1) s = !0;
    else {
      var u = Be.getComputedStyle(c);
      u && u.getPropertyValue("cursor") === "pointer" && (s = !0);
    }
    l.push(c), a = c;
  }
  if (!function(p, h) {
    var m = h == null ? void 0 : h.element_allowlist;
    if (cn(m)) return !0;
    var v = function(w) {
      if (m.some((O) => w.tagName.toLowerCase() === O)) return { v: !0 };
    };
    for (var b of p) {
      var A = v(b);
      if (typeof A == "object") return A.v;
    }
    return !1;
  }(l, n) || !function(p, h) {
    var m = h == null ? void 0 : h.css_selector_allowlist;
    if (cn(m)) return !0;
    var v = function(w) {
      if (m.some((O) => w.matches(O))) return { v: !0 };
    };
    for (var b of p) {
      var A = v(b);
      if (typeof A == "object") return A.v;
    }
    return !1;
  }(l, n)) return !1;
  var f = Be.getComputedStyle(e);
  if (f && f.getPropertyValue("cursor") === "pointer" && t.type === "click") return !0;
  var d = e.tagName.toLowerCase();
  switch (d) {
    case "html":
      return !1;
    case "form":
      return (i || ["submit"]).indexOf(t.type) >= 0;
    case "input":
    case "select":
    case "textarea":
      return (i || ["change", "click"]).indexOf(t.type) >= 0;
    default:
      return s ? (i || ["click"]).indexOf(t.type) >= 0 : (i || ["click"]).indexOf(t.type) >= 0 && (hX.indexOf(d) > -1 || e.getAttribute("contenteditable") === "true");
  }
}
function mX(e) {
  for (var t = e; t.parentNode && !Xm(t, "body"); t = t.parentNode) {
    var n = UD(t);
    if (Yn(n, "ph-sensitive") || Yn(n, "ph-no-capture")) return !1;
  }
  if (Yn(UD(e), "ph-include")) return !0;
  var r = e.type || "";
  if (ws(r)) switch (r.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  var i = e.name || e.id || "";
  return !(ws(i) && /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, "")));
}
function dCe(e) {
  return !!(Xm(e, "input") && !["button", "checkbox", "submit", "reset"].includes(e.type) || Xm(e, "select") || Xm(e, "textarea") || e.getAttribute("contenteditable") === "true");
}
var fCe = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", zOt = new RegExp("^(?:".concat(fCe, ")$")), jOt = new RegExp(fCe), pCe = "\\d{3}-?\\d{2}-?\\d{4}", FOt = new RegExp("^(".concat(pCe, ")$")), UOt = new RegExp("(".concat(pCe, ")"));
function uw(e) {
  var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
  return !(ei(e) || ws(e) && (e = dj(e), (t ? zOt : jOt).test((e || "").replace(/[- ]/g, "")) || (t ? FOt : UOt).test(e)));
}
function hCe(e) {
  var t = hj(e);
  return uw(t = "".concat(t, " ").concat(mCe(e)).trim()) ? t : "";
}
function mCe(e) {
  var t = "";
  return e && e.childNodes && e.childNodes.length && Xr(e.childNodes, function(n) {
    var r;
    if (n && ((r = n.tagName) === null || r === void 0 ? void 0 : r.toLowerCase()) === "span") try {
      var i = hj(n);
      t = "".concat(t, " ").concat(i).trim(), n.childNodes && n.childNodes.length && (t = "".concat(t, " ").concat(mCe(n)).trim());
    } catch (o) {
      un.error("[AutoCapture]", o);
    }
  }), t;
}
function VOt(e) {
  return function(t) {
    var n = t.map((r) => {
      var i, o, s = "";
      if (r.tag_name && (s += r.tag_name), r.attr_class) for (var l of (r.attr_class.sort(), r.attr_class)) s += ".".concat(l.replace(/"/g, ""));
      var c = bt(bt(bt(bt({}, r.text ? { text: r.text } : {}), {}, { "nth-child": (i = r.nth_child) !== null && i !== void 0 ? i : 0, "nth-of-type": (o = r.nth_of_type) !== null && o !== void 0 ? o : 0 }, r.href ? { href: r.href } : {}), r.attr_id ? { attr_id: r.attr_id } : {}), r.attributes), a = {};
      return HR(c).sort((u, f) => {
        var [d] = u, [p] = f;
        return d.localeCompare(p);
      }).forEach((u) => {
        var [f, d] = u;
        return a[hse(f.toString())] = hse(d.toString());
      }), s += ":", s += HR(c).map((u) => {
        var [f, d] = u;
        return "".concat(f, '="').concat(d, '"');
      }).join("");
    });
    return n.join(";");
  }(function(t) {
    return t.map((n) => {
      var r, i, o = { text: (r = n.$el_text) === null || r === void 0 ? void 0 : r.slice(0, 400), tag_name: n.tag_name, href: (i = n.attr__href) === null || i === void 0 ? void 0 : i.slice(0, 2048), attr_class: qOt(n), attr_id: n.attr__id, nth_child: n.nth_child, nth_of_type: n.nth_of_type, attributes: {} };
      return HR(n).filter((s) => {
        var [l] = s;
        return l.indexOf("attr__") === 0;
      }).forEach((s) => {
        var [l, c] = s;
        return o.attributes[l] = c;
      }), o;
    });
  }(e));
}
function hse(e) {
  return e.replace(/"|\\"/g, '\\"');
}
function qOt(e) {
  var t = e.attr__class;
  return t ? Qi(t) ? t : k$(t) : void 0;
}
var gX = "[SessionRecording]", yX = "redacted", XP = { initiatorTypes: ["audio", "beacon", "body", "css", "early-hint", "embed", "fetch", "frame", "iframe", "icon", "image", "img", "input", "link", "navigation", "object", "ping", "script", "track", "video", "xmlhttprequest"], maskRequestFn: (e) => e, recordHeaders: !1, recordBody: !1, recordInitialRequests: !1, recordPerformance: !1, performanceEntryTypeToObserve: ["first-input", "navigation", "paint", "resource"], payloadSizeLimitBytes: 1e6, payloadHostDenyList: [".lr-ingest.io", ".ingest.sentry.io"] }, BOt = ["authorization", "x-forwarded-for", "authorization", "cookie", "set-cookie", "x-api-key", "x-real-ip", "remote-addr", "forwarded", "proxy-authorization", "x-csrf-token", "x-csrftoken", "x-xsrf-token"], XOt = ["password", "secret", "passwd", "api_key", "apikey", "auth", "credentials", "mysql_pwd", "privatekey", "private_key", "token"], WOt = ["/s/", "/e/", "/i/"];
function mse(e, t, n, r) {
  if (ei(e)) return e;
  var i = (t == null ? void 0 : t["content-length"]) || function(o) {
    return new Blob([o]).size;
  }(e);
  return ws(i) && (i = parseInt(i)), i > n ? gX + " ".concat(r, " body too large to record (").concat(i, " bytes)") : e;
}
function gse(e, t) {
  if (ei(e)) return e;
  var n = e;
  return uw(n, !1) || (n = gX + " " + t + " body " + yX), Xr(XOt, (r) => {
    var i, o;
    (i = n) !== null && i !== void 0 && i.length && ((o = n) === null || o === void 0 ? void 0 : o.indexOf(r)) !== -1 && (n = gX + " " + t + " body " + yX + " as might contain: " + r);
  }), n;
}
var ZOt = (e, t) => {
  var n, r, i, o = { payloadSizeLimitBytes: XP.payloadSizeLimitBytes, performanceEntryTypeToObserve: [...XP.performanceEntryTypeToObserve], payloadHostDenyList: [...t.payloadHostDenyList || [], ...XP.payloadHostDenyList] }, s = e.session_recording.recordHeaders !== !1 && t.recordHeaders, l = e.session_recording.recordBody !== !1 && t.recordBody, c = e.capture_performance !== !1 && t.recordPerformance, a = (n = o, i = Math.min(1e6, (r = n.payloadSizeLimitBytes) !== null && r !== void 0 ? r : 1e6), (d) => (d != null && d.requestBody && (d.requestBody = mse(d.requestBody, d.requestHeaders, i, "Request")), d != null && d.responseBody && (d.responseBody = mse(d.responseBody, d.responseHeaders, i, "Response")), d)), u = (d) => {
    return a(((m, v) => {
      var b, A = HO(m.name), w = v.indexOf("http") === 0 ? (b = HO(v)) === null || b === void 0 ? void 0 : b.pathname : v;
      w === "/" && (w = "");
      var O = A == null ? void 0 : A.pathname.replace(w || "", "");
      if (!(A && O && WOt.some((x) => O.indexOf(x) === 0))) return m;
    })((h = (p = d).requestHeaders, ei(h) || Xr(Object.keys(h ?? {}), (m) => {
      BOt.includes(m.toLowerCase()) && (h[m] = yX);
    }), p), e.api_host));
    var p, h;
  }, f = Xc(e.session_recording.maskNetworkRequestFn);
  return f && Xc(e.session_recording.maskCapturedNetworkRequestFn) && un.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), f && (e.session_recording.maskCapturedNetworkRequestFn = (d) => {
    var p = e.session_recording.maskNetworkRequestFn({ url: d.name });
    return bt(bt({}, d), {}, { name: p == null ? void 0 : p.url });
  }), o.maskRequestFn = Xc(e.session_recording.maskCapturedNetworkRequestFn) ? (d) => {
    var p, h, m, v = u(d);
    return v && (p = (h = (m = e.session_recording).maskCapturedNetworkRequestFn) === null || h === void 0 ? void 0 : h.call(m, v)) !== null && p !== void 0 ? p : void 0;
  } : (d) => function(p) {
    if (!cn(p)) return p.requestBody = gse(p.requestBody, "Request"), p.responseBody = gse(p.responseBody, "Response"), p;
  }(u(d)), bt(bt(bt({}, XP), o), {}, { recordHeaders: s, recordBody: l, recordPerformance: c, recordInitialRequests: c });
};
function af(e, t, n, r, i) {
  return t > n && (un.warn("min cannot be greater than max."), t = n), Zl(e) ? e > n ? (r && un.warn(r + " cannot be  greater than max: " + n + ". Using max value instead."), n) : e < t ? (r && un.warn(r + " cannot be less than min: " + t + ". Using min value instead."), t) : e : (r && un.warn(r + " must be a number. using max or fallback. max: " + n + ", fallback: " + i), af(i || n, t, n, r));
}
class HOt {
  constructor(t) {
    var n, r, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Vt(this, "bucketSize", 100), Vt(this, "refillRate", 10), Vt(this, "mutationBuckets", {}), Vt(this, "loggedTracker", {}), Vt(this, "refillBuckets", () => {
      Object.keys(this.mutationBuckets).forEach((o) => {
        this.mutationBuckets[o] = this.mutationBuckets[o] + this.refillRate, this.mutationBuckets[o] >= this.bucketSize && delete this.mutationBuckets[o];
      });
    }), Vt(this, "getNodeOrRelevantParent", (o) => {
      var s = this.rrweb.mirror.getNode(o);
      if ((s == null ? void 0 : s.nodeName) !== "svg" && s instanceof Element) {
        var l = s.closest("svg");
        if (l) return [this.rrweb.mirror.getId(l), l];
      }
      return [o, s];
    }), Vt(this, "numberOfChanges", (o) => {
      var s, l, c, a, u, f, d, p;
      return ((s = (l = o.removes) === null || l === void 0 ? void 0 : l.length) !== null && s !== void 0 ? s : 0) + ((c = (a = o.attributes) === null || a === void 0 ? void 0 : a.length) !== null && c !== void 0 ? c : 0) + ((u = (f = o.texts) === null || f === void 0 ? void 0 : f.length) !== null && u !== void 0 ? u : 0) + ((d = (p = o.adds) === null || p === void 0 ? void 0 : p.length) !== null && d !== void 0 ? d : 0);
    }), Vt(this, "throttleMutations", (o) => {
      if (o.type !== 3 || o.data.source !== 0) return o;
      var s = o.data, l = this.numberOfChanges(s);
      s.attributes && (s.attributes = s.attributes.filter((a) => {
        var u, f, d, [p, h] = this.getNodeOrRelevantParent(a.id);
        return this.mutationBuckets[p] === 0 ? !1 : (this.mutationBuckets[p] = (u = this.mutationBuckets[p]) !== null && u !== void 0 ? u : this.bucketSize, this.mutationBuckets[p] = Math.max(this.mutationBuckets[p] - 1, 0), this.mutationBuckets[p] === 0 && (this.loggedTracker[p] || (this.loggedTracker[p] = !0, (f = (d = this.options).onBlockedNode) === null || f === void 0 || f.call(d, p, h))), a);
      }));
      var c = this.numberOfChanges(s);
      return c !== 0 || l === c ? o : void 0;
    }), this.rrweb = t, this.options = i, this.refillRate = af((n = this.options.refillRate) !== null && n !== void 0 ? n : this.refillRate, 0, 100, "mutation throttling refill rate"), this.bucketSize = af((r = this.options.bucketSize) !== null && r !== void 0 ? r : this.bucketSize, 0, 100, "mutation throttling bucket size"), setInterval(() => {
      this.refillBuckets();
    }, 1e3);
  }
}
var $c = Uint8Array, cl = Uint16Array, dw = Uint32Array, C$ = new $c([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), N$ = new $c([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), yse = new $c([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), gCe = function(e, t) {
  for (var n = new cl(31), r = 0; r < 31; ++r) n[r] = t += 1 << e[r - 1];
  var i = new dw(n[30]);
  for (r = 1; r < 30; ++r) for (var o = n[r]; o < n[r + 1]; ++o) i[o] = o - n[r] << 5 | r;
  return [n, i];
}, yCe = gCe(C$, 2), QOt = yCe[0], vX = yCe[1];
QOt[28] = 258, vX[258] = 28;
for (var vse = gCe(N$, 0)[1], vCe = new cl(32768), fi = 0; fi < 32768; ++fi) {
  var Yg = (43690 & fi) >>> 1 | (21845 & fi) << 1;
  Yg = (61680 & (Yg = (52428 & Yg) >>> 2 | (13107 & Yg) << 2)) >>> 4 | (3855 & Yg) << 4, vCe[fi] = ((65280 & Yg) >>> 8 | (255 & Yg) << 8) >>> 1;
}
var kE = function(e, t, n) {
  for (var r = e.length, i = 0, o = new cl(t); i < r; ++i) ++o[e[i] - 1];
  var s, l = new cl(t);
  for (i = 0; i < t; ++i) l[i] = l[i - 1] + o[i - 1] << 1;
  for (s = new cl(r), i = 0; i < r; ++i) s[i] = vCe[l[e[i] - 1]++] >>> 15 - e[i];
  return s;
}, Lv = new $c(288);
for (fi = 0; fi < 144; ++fi) Lv[fi] = 8;
for (fi = 144; fi < 256; ++fi) Lv[fi] = 9;
for (fi = 256; fi < 280; ++fi) Lv[fi] = 7;
for (fi = 280; fi < 288; ++fi) Lv[fi] = 8;
var VD = new $c(32);
for (fi = 0; fi < 32; ++fi) VD[fi] = 5;
var $Ot = kE(Lv, 9), KOt = kE(VD, 5), bCe = function(e) {
  return (e / 8 >> 0) + (7 & e && 1);
}, OCe = function(e, t, n) {
  (n == null || n > e.length) && (n = e.length);
  var r = new (e instanceof cl ? cl : e instanceof dw ? dw : $c)(n - t);
  return r.set(e.subarray(t, n)), r;
}, Yf = function(e, t, n) {
  n <<= 7 & t;
  var r = t / 8 >> 0;
  e[r] |= n, e[r + 1] |= n >>> 8;
}, oS = function(e, t, n) {
  n <<= 7 & t;
  var r = t / 8 >> 0;
  e[r] |= n, e[r + 1] |= n >>> 8, e[r + 2] |= n >>> 16;
}, _6 = function(e, t) {
  for (var n = [], r = 0; r < e.length; ++r) e[r] && n.push({ s: r, f: e[r] });
  var i = n.length, o = n.slice();
  if (!i) return [new $c(0), 0];
  if (i == 1) {
    var s = new $c(n[0].s + 1);
    return s[n[0].s] = 1, [s, 1];
  }
  n.sort(function(x, S) {
    return x.f - S.f;
  }), n.push({ s: -1, f: 25001 });
  var l = n[0], c = n[1], a = 0, u = 1, f = 2;
  for (n[0] = { s: -1, f: l.f + c.f, l, r: c }; u != i - 1; ) l = n[n[a].f < n[f].f ? a++ : f++], c = n[a != u && n[a].f < n[f].f ? a++ : f++], n[u++] = { s: -1, f: l.f + c.f, l, r: c };
  var d = o[0].s;
  for (r = 1; r < i; ++r) o[r].s > d && (d = o[r].s);
  var p = new cl(d + 1), h = bX(n[u - 1], p, 0);
  if (h > t) {
    r = 0;
    var m = 0, v = h - t, b = 1 << v;
    for (o.sort(function(x, S) {
      return p[S.s] - p[x.s] || x.f - S.f;
    }); r < i; ++r) {
      var A = o[r].s;
      if (!(p[A] > t)) break;
      m += b - (1 << h - p[A]), p[A] = t;
    }
    for (m >>>= v; m > 0; ) {
      var w = o[r].s;
      p[w] < t ? m -= 1 << t - p[w]++ - 1 : ++r;
    }
    for (; r >= 0 && m; --r) {
      var O = o[r].s;
      p[O] == t && (--p[O], ++m);
    }
    h = t;
  }
  return [new $c(p), h];
}, bX = function(e, t, n) {
  return e.s == -1 ? Math.max(bX(e.l, t, n + 1), bX(e.r, t, n + 1)) : t[e.s] = n;
}, bse = function(e) {
  for (var t = e.length; t && !e[--t]; ) ;
  for (var n = new cl(++t), r = 0, i = e[0], o = 1, s = function(c) {
    n[r++] = c;
  }, l = 1; l <= t; ++l) if (e[l] == i && l != t) ++o;
  else {
    if (!i && o > 2) {
      for (; o > 138; o -= 138) s(32754);
      o > 2 && (s(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
    } else if (o > 3) {
      for (s(i), --o; o > 6; o -= 6) s(8304);
      o > 2 && (s(o - 3 << 5 | 8208), o = 0);
    }
    for (; o--; ) s(i);
    o = 1, i = e[l];
  }
  return [n.subarray(0, r), t];
}, sS = function(e, t) {
  for (var n = 0, r = 0; r < t.length; ++r) n += e[r] * t[r];
  return n;
}, OX = function(e, t, n) {
  var r = n.length, i = bCe(t + 2);
  e[i] = 255 & r, e[i + 1] = r >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
  for (var o = 0; o < r; ++o) e[i + o + 4] = n[o];
  return 8 * (i + 4 + r);
}, Ose = function(e, t, n, r, i, o, s, l, c, a, u) {
  Yf(t, u++, n), ++i[256];
  for (var f = _6(i, 15), d = f[0], p = f[1], h = _6(o, 15), m = h[0], v = h[1], b = bse(d), A = b[0], w = b[1], O = bse(m), x = O[0], S = O[1], E = new cl(19), k = 0; k < A.length; ++k) E[31 & A[k]]++;
  for (k = 0; k < x.length; ++k) E[31 & x[k]]++;
  for (var T = _6(E, 7), R = T[0], j = T[1], F = 19; F > 4 && !R[yse[F - 1]]; --F) ;
  var L, _, U, z, C = a + 5 << 3, I = sS(i, Lv) + sS(o, VD) + s, M = sS(i, d) + sS(o, m) + s + 14 + 3 * F + sS(E, R) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
  if (C <= I && C <= M) return OX(t, u, e.subarray(c, c + a));
  if (Yf(t, u, 1 + (M < I)), u += 2, M < I) {
    L = kE(d, p), _ = d, U = kE(m, v), z = m;
    var D = kE(R, j);
    for (Yf(t, u, w - 257), Yf(t, u + 5, S - 1), Yf(t, u + 10, F - 4), u += 14, k = 0; k < F; ++k) Yf(t, u + 3 * k, R[yse[k]]);
    u += 3 * F;
    for (var X = [A, x], B = 0; B < 2; ++B) {
      var q = X[B];
      for (k = 0; k < q.length; ++k) {
        var H = 31 & q[k];
        Yf(t, u, D[H]), u += R[H], H > 15 && (Yf(t, u, q[k] >>> 5 & 127), u += q[k] >>> 12);
      }
    }
  } else L = $Ot, _ = Lv, U = KOt, z = VD;
  for (k = 0; k < l; ++k) if (r[k] > 255) {
    H = r[k] >>> 18 & 31, oS(t, u, L[H + 257]), u += _[H + 257], H > 7 && (Yf(t, u, r[k] >>> 23 & 31), u += C$[H]);
    var Y = 31 & r[k];
    oS(t, u, U[Y]), u += z[Y], Y > 3 && (oS(t, u, r[k] >>> 5 & 8191), u += N$[Y]);
  } else oS(t, u, L[r[k]]), u += _[r[k]];
  return oS(t, u, L[256]), u + _[256];
}, GOt = new dw([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), YOt = function() {
  for (var e = new dw(256), t = 0; t < 256; ++t) {
    for (var n = t, r = 9; --r; ) n = (1 & n && 3988292384) ^ n >>> 1;
    e[t] = n;
  }
  return e;
}(), JOt = function() {
  var e = 4294967295;
  return { p: function(t) {
    for (var n = e, r = 0; r < t.length; ++r) n = YOt[255 & n ^ t[r]] ^ n >>> 8;
    e = n;
  }, d: function() {
    return 4294967295 ^ e;
  } };
}, eAt = function(e, t, n, r, i) {
  return function(o, s, l, c, a, u) {
    var f = o.length, d = new $c(c + f + 5 * (1 + Math.floor(f / 7e3)) + a), p = d.subarray(c, d.length - a), h = 0;
    if (!s || f < 8) for (var m = 0; m <= f; m += 65535) {
      var v = m + 65535;
      v < f ? h = OX(p, h, o.subarray(m, v)) : (p[m] = u, h = OX(p, h, o.subarray(m, f)));
    }
    else {
      for (var b = GOt[s - 1], A = b >>> 13, w = 8191 & b, O = (1 << l) - 1, x = new cl(32768), S = new cl(O + 1), E = Math.ceil(l / 3), k = 2 * E, T = function(ft) {
        return (o[ft] ^ o[ft + 1] << E ^ o[ft + 2] << k) & O;
      }, R = new dw(25e3), j = new cl(288), F = new cl(32), L = 0, _ = 0, U = (m = 0, 0), z = 0, C = 0; m < f; ++m) {
        var I = T(m), M = 32767 & m, D = S[I];
        if (x[M] = D, S[I] = M, z <= m) {
          var X = f - m;
          if ((L > 7e3 || U > 24576) && X > 423) {
            h = Ose(o, p, 0, R, j, F, _, U, C, m - C, h), U = L = _ = 0, C = m;
            for (var B = 0; B < 286; ++B) j[B] = 0;
            for (B = 0; B < 30; ++B) F[B] = 0;
          }
          var q = 2, H = 0, Y = w, J = M - D & 32767;
          if (X > 2 && I == T(m - J)) for (var oe = Math.min(A, X) - 1, ce = Math.min(32767, m), fe = Math.min(258, X); J <= ce && --Y && M != D; ) {
            if (o[m + q] == o[m + q - J]) {
              for (var $ = 0; $ < fe && o[m + $] == o[m + $ - J]; ++$) ;
              if ($ > q) {
                if (q = $, H = J, $ > oe) break;
                var pe = Math.min(J, $ - 2), ee = 0;
                for (B = 0; B < pe; ++B) {
                  var Ce = m - J + B + 32768 & 32767, Ee = Ce - x[Ce] + 32768 & 32767;
                  Ee > ee && (ee = Ee, D = Ce);
                }
              }
            }
            J += (M = D) - (D = x[M]) + 32768 & 32767;
          }
          if (H) {
            R[U++] = 268435456 | vX[q] << 18 | vse[H];
            var Ve = 31 & vX[q], et = 31 & vse[H];
            _ += C$[Ve] + N$[et], ++j[257 + Ve], ++F[et], z = m + q, ++L;
          } else R[U++] = o[m], ++j[o[m]];
        }
      }
      h = Ose(o, p, u, R, j, F, _, U, C, m - C, h);
    }
    return OCe(d, 0, c + bCe(h) + a);
  }(e, t.level == null ? 6 : t.level, t.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, r, !0);
}, AX = function(e, t, n) {
  for (; n; ++t) e[t] = n, n >>>= 8;
}, tAt = function(e, t) {
  var n = t.filename;
  if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : t.level == 9 ? 2 : 0, e[9] = 3, t.mtime != 0 && AX(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
    e[3] = 8;
    for (var r = 0; r <= n.length; ++r) e[r + 10] = n.charCodeAt(r);
  }
}, nAt = function(e) {
  return 10 + (e.filename && e.filename.length + 1 || 0);
};
function ACe(e, t) {
  t === void 0 && (t = {});
  var n = JOt(), r = e.length;
  n.p(e);
  var i = eAt(e, t, nAt(t), 8), o = i.length;
  return tAt(i, t), AX(i, o - 8, n.d()), AX(i, o - 4, r), i;
}
function wCe(e, t) {
  var n = e.length;
  if (typeof TextEncoder < "u") return new TextEncoder().encode(e);
  for (var r = new $c(e.length + (e.length >>> 1)), i = 0, o = function(a) {
    r[i++] = a;
  }, s = 0; s < n; ++s) {
    if (i + 5 > r.length) {
      var l = new $c(i + 8 + (n - s << 1));
      l.set(r), r = l;
    }
    var c = e.charCodeAt(s);
    c < 128 || t ? o(c) : c < 2048 ? (o(192 | c >>> 6), o(128 | 63 & c)) : c > 55295 && c < 57344 ? (o(240 | (c = 65536 + (1047552 & c) | 1023 & e.charCodeAt(++s)) >>> 18), o(128 | c >>> 12 & 63), o(128 | c >>> 6 & 63), o(128 | 63 & c)) : (o(224 | c >>> 12), o(128 | c >>> 6 & 63), o(128 | 63 & c));
  }
  return OCe(r, 0, i);
}
var QR = "[SessionRecording]", Fs = Va(QR), rAt = 3e5, iAt = [Cu.MouseMove, Cu.MouseInteraction, Cu.Scroll, Cu.ViewportResize, Cu.Input, Cu.TouchMove, Cu.MediaInteraction, Cu.Drag], Ase = (e) => ({ rrwebMethod: e, enqueuedAt: Date.now(), attempt: 1 });
function Jg(e) {
  return function(t, n) {
    for (var r = "", i = 0; i < t.length; ) {
      var o = t[i++];
      r += String.fromCharCode(o);
    }
    return r;
  }(ACe(wCe(JSON.stringify(e))));
}
function wse(e) {
  return e.type === Ap.Custom && e.data.tag === "sessionIdle";
}
function xse(e, t) {
  return t.some((n) => n.matching === "regex" && new RegExp(n.url).test(e));
}
class oAt {
  get sessionIdleThresholdMilliseconds() {
    return this.instance.config.session_recording.session_idle_threshold_ms || 3e5;
  }
  get rrwebRecord() {
    var t, n;
    return Tn == null || (t = Tn.__PosthogExtensions__) === null || t === void 0 || (n = t.rrweb) === null || n === void 0 ? void 0 : n.record;
  }
  get started() {
    return this._captureStarted;
  }
  get sessionManager() {
    if (!this.instance.sessionManager) throw new Error(QR + " must be started with a valid sessionManager.");
    return this.instance.sessionManager;
  }
  get fullSnapshotIntervalMillis() {
    var t, n;
    return this.triggerStatus === "trigger_pending" ? 6e4 : (t = (n = this.instance.config.session_recording) === null || n === void 0 ? void 0 : n.full_snapshot_interval_millis) !== null && t !== void 0 ? t : rAt;
  }
  get isSampled() {
    var t = this.instance.get_property(r1);
    return Ty(t) ? t : null;
  }
  get sessionDuration() {
    var t, n, r = (t = this.buffer) === null || t === void 0 ? void 0 : t.data[((n = this.buffer) === null || n === void 0 ? void 0 : n.data.length) - 1], { sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
    return r ? r.timestamp - i : null;
  }
  get isRecordingEnabled() {
    var t = !!this.instance.get_property(nX), n = !this.instance.config.disable_session_recording;
    return Be && t && n;
  }
  get isConsoleLogCaptureEnabled() {
    var t = !!this.instance.get_property(Yoe), n = this.instance.config.enable_recording_console_log;
    return n ?? t;
  }
  get canvasRecording() {
    var t, n, r, i, o, s, l = this.instance.config.session_recording.captureCanvas, c = this.instance.get_property(ese), a = (t = (n = l == null ? void 0 : l.recordCanvas) !== null && n !== void 0 ? n : c == null ? void 0 : c.enabled) !== null && t !== void 0 && t, u = (r = (i = l == null ? void 0 : l.canvasFps) !== null && i !== void 0 ? i : c == null ? void 0 : c.fps) !== null && r !== void 0 ? r : 0, f = (o = (s = l == null ? void 0 : l.canvasQuality) !== null && s !== void 0 ? s : c == null ? void 0 : c.quality) !== null && o !== void 0 ? o : 0;
    return { enabled: a, fps: af(u, 0, 12, "canvas recording fps"), quality: af(f, 0, 1, "canvas recording quality") };
  }
  get networkPayloadCapture() {
    var t, n, r = this.instance.get_property(Joe), i = { recordHeaders: (t = this.instance.config.session_recording) === null || t === void 0 ? void 0 : t.recordHeaders, recordBody: (n = this.instance.config.session_recording) === null || n === void 0 ? void 0 : n.recordBody }, o = (i == null ? void 0 : i.recordHeaders) || (r == null ? void 0 : r.recordHeaders), s = (i == null ? void 0 : i.recordBody) || (r == null ? void 0 : r.recordBody), l = fo(this.instance.config.capture_performance) ? this.instance.config.capture_performance.network_timing : this.instance.config.capture_performance, c = !!(Ty(l) ? l : r != null && r.capturePerformance);
    return o || s || c ? { recordHeaders: o, recordBody: s, recordPerformance: c } : void 0;
  }
  get sampleRate() {
    var t = this.instance.get_property(tse);
    return Zl(t) ? t : null;
  }
  get minimumDuration() {
    var t = this.instance.get_property(nse);
    return Zl(t) ? t : null;
  }
  get status() {
    return this.receivedDecide ? this.isRecordingEnabled ? this._urlBlocked ? "paused" : ei(this._linkedFlag) || this._linkedFlagSeen ? this.triggerStatus === "trigger_pending" ? "buffering" : Ty(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
  }
  get urlTriggerStatus() {
    var t;
    return this._urlTriggers.length === 0 ? "trigger_disabled" : ((t = this.instance) === null || t === void 0 ? void 0 : t.get_property(N6)) === this.sessionId ? "trigger_activated" : "trigger_pending";
  }
  get eventTriggerStatus() {
    var t;
    return this._eventTriggers.length === 0 ? "trigger_disabled" : ((t = this.instance) === null || t === void 0 ? void 0 : t.get_property(P6)) === this.sessionId ? "trigger_activated" : "trigger_pending";
  }
  get triggerStatus() {
    var t = this.eventTriggerStatus === "trigger_activated" || this.urlTriggerStatus === "trigger_activated", n = this.eventTriggerStatus === "trigger_pending" || this.urlTriggerStatus === "trigger_pending";
    return t ? "trigger_activated" : n ? "trigger_pending" : "trigger_disabled";
  }
  constructor(t) {
    if (Vt(this, "queuedRRWebEvents", []), Vt(this, "isIdle", !1), Vt(this, "_linkedFlagSeen", !1), Vt(this, "_lastActivityTimestamp", Date.now()), Vt(this, "_linkedFlag", null), Vt(this, "_removePageViewCaptureHook", void 0), Vt(this, "_onSessionIdListener", void 0), Vt(this, "_persistDecideOnSessionListener", void 0), Vt(this, "_samplingSessionListener", void 0), Vt(this, "_urlTriggers", []), Vt(this, "_urlBlocklist", []), Vt(this, "_urlBlocked", !1), Vt(this, "_eventTriggers", []), Vt(this, "_removeEventTriggerCaptureHook", void 0), Vt(this, "_forceAllowLocalhostNetworkCapture", !1), Vt(this, "_onBeforeUnload", () => {
      this._flushBuffer();
    }), Vt(this, "_onOffline", () => {
      this._tryAddCustomEvent("browser offline", {});
    }), Vt(this, "_onOnline", () => {
      this._tryAddCustomEvent("browser online", {});
    }), Vt(this, "_onVisibilityChange", () => {
      if (Wt != null && Wt.visibilityState) {
        var i = "window " + Wt.visibilityState;
        this._tryAddCustomEvent(i, {});
      }
    }), this.instance = t, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, !this.instance.sessionManager) throw Fs.error("started without valid sessionManager"), new Error(QR + " started without valid sessionManager. This is a bug.");
    var { sessionId: n, windowId: r } = this.sessionManager.checkAndGetSessionAndWindowId();
    this.sessionId = n, this.windowId = r, this.buffer = this.clearBuffer(), this.sessionIdleThresholdMilliseconds >= this.sessionManager.sessionTimeoutMs && Fs.warn("session_idle_threshold_ms (".concat(this.sessionIdleThresholdMilliseconds, ") is greater than the session timeout (").concat(this.sessionManager.sessionTimeoutMs, "). Session will never be detected as idle"));
  }
  startIfEnabledOrStop(t) {
    this.isRecordingEnabled ? (this._startCapture(t), Be == null || Be.addEventListener("beforeunload", this._onBeforeUnload), Be == null || Be.addEventListener("offline", this._onOffline), Be == null || Be.addEventListener("online", this._onOnline), Be == null || Be.addEventListener("visibilitychange", this._onVisibilityChange), this._setupSampling(), this._addEventTriggerListener(), ei(this._removePageViewCaptureHook) && (this._removePageViewCaptureHook = this.instance.on("eventCaptured", (n) => {
      try {
        if (n.event === "$pageview") {
          var r = n != null && n.properties.$current_url ? this._maskUrl(n == null ? void 0 : n.properties.$current_url) : "";
          if (!r) return;
          this._tryAddCustomEvent("$pageview", { href: r });
        }
      } catch (i) {
        Fs.error("Could not add $pageview to rrweb session", i);
      }
    })), this._onSessionIdListener || (this._onSessionIdListener = this.sessionManager.onSessionId((n, r, i) => {
      var o, s, l, c;
      i && (this._tryAddCustomEvent("$session_id_change", { sessionId: n, windowId: r, changeReason: i }), (o = this.instance) === null || o === void 0 || (s = o.persistence) === null || s === void 0 || s.unregister(P6), (l = this.instance) === null || l === void 0 || (c = l.persistence) === null || c === void 0 || c.unregister(N6));
    }))) : this.stopRecording();
  }
  stopRecording() {
    var t, n, r, i;
    this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, Be == null || Be.removeEventListener("beforeunload", this._onBeforeUnload), Be == null || Be.removeEventListener("offline", this._onOffline), Be == null || Be.removeEventListener("online", this._onOnline), Be == null || Be.removeEventListener("visibilitychange", this._onVisibilityChange), this.clearBuffer(), clearInterval(this._fullSnapshotTimer), (t = this._removePageViewCaptureHook) === null || t === void 0 || t.call(this), this._removePageViewCaptureHook = void 0, (n = this._removeEventTriggerCaptureHook) === null || n === void 0 || n.call(this), this._removeEventTriggerCaptureHook = void 0, (r = this._onSessionIdListener) === null || r === void 0 || r.call(this), this._onSessionIdListener = void 0, (i = this._samplingSessionListener) === null || i === void 0 || i.call(this), this._samplingSessionListener = void 0, Fs.info("stopped"));
  }
  makeSamplingDecision(t) {
    var n, r = this.sessionId !== t, i = this.sampleRate;
    if (Zl(i)) {
      var o, s = this.isSampled, l = r || !Ty(s);
      l ? o = Math.random() < i : o = s, l && (o ? this._reportStarted("sampled") : Fs.warn("Sample rate (".concat(i, ") has determined that this sessionId (").concat(t, ") will not be sent to the server.")), this._tryAddCustomEvent("samplingDecisionMade", { sampleRate: i, isSampled: o })), (n = this.instance.persistence) === null || n === void 0 || n.register({ [r1]: o });
    } else {
      var c;
      (c = this.instance.persistence) === null || c === void 0 || c.register({ [r1]: null });
    }
  }
  onRemoteConfig(t) {
    var n, r, i, o, s, l;
    if (this._persistRemoteConfig(t), this._linkedFlag = ((n = t.sessionRecording) === null || n === void 0 ? void 0 : n.linkedFlag) || null, (r = t.sessionRecording) !== null && r !== void 0 && r.endpoint && (this._endpoint = (l = t.sessionRecording) === null || l === void 0 ? void 0 : l.endpoint), this._setupSampling(), !ei(this._linkedFlag) && !this._linkedFlagSeen) {
      var c = ws(this._linkedFlag) ? this._linkedFlag : this._linkedFlag.flag, a = ws(this._linkedFlag) ? null : this._linkedFlag.variant;
      this.instance.onFeatureFlags((u, f) => {
        var d = fo(f) && c in f, p = a ? f[c] === a : d;
        p && this._reportStarted("linked_flag_matched", { linkedFlag: c, linkedVariant: a }), this._linkedFlagSeen = p;
      });
    }
    (i = t.sessionRecording) !== null && i !== void 0 && i.urlTriggers && (this._urlTriggers = t.sessionRecording.urlTriggers), (o = t.sessionRecording) !== null && o !== void 0 && o.urlBlocklist && (this._urlBlocklist = t.sessionRecording.urlBlocklist), (s = t.sessionRecording) !== null && s !== void 0 && s.eventTriggers && (this._eventTriggers = t.sessionRecording.eventTriggers), this.receivedDecide = !0, this.startIfEnabledOrStop();
  }
  _setupSampling() {
    Zl(this.sampleRate) && ei(this._samplingSessionListener) && (this._samplingSessionListener = this.sessionManager.onSessionId((t) => {
      this.makeSamplingDecision(t);
    }));
  }
  _persistRemoteConfig(t) {
    if (this.instance.persistence) {
      var n, r = this.instance.persistence, i = () => {
        var o, s, l, c, a, u, f, d, p = (o = t.sessionRecording) === null || o === void 0 ? void 0 : o.sampleRate, h = ei(p) ? null : parseFloat(p), m = (s = t.sessionRecording) === null || s === void 0 ? void 0 : s.minimumDurationMilliseconds;
        r.register({ [nX]: !!t.sessionRecording, [Yoe]: (l = t.sessionRecording) === null || l === void 0 ? void 0 : l.consoleLogRecordingEnabled, [Joe]: bt({ capturePerformance: t.capturePerformance }, (c = t.sessionRecording) === null || c === void 0 ? void 0 : c.networkPayloadCapture), [ese]: { enabled: (a = t.sessionRecording) === null || a === void 0 ? void 0 : a.recordCanvas, fps: (u = t.sessionRecording) === null || u === void 0 ? void 0 : u.canvasFps, quality: (f = t.sessionRecording) === null || f === void 0 ? void 0 : f.canvasQuality }, [tse]: h, [nse]: cn(m) ? null : m, [rse]: (d = t.sessionRecording) === null || d === void 0 ? void 0 : d.scriptConfig });
      };
      i(), (n = this._persistDecideOnSessionListener) === null || n === void 0 || n.call(this), this._persistDecideOnSessionListener = this.sessionManager.onSessionId(i);
    }
  }
  log(t) {
    var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "log";
    (n = this.instance.sessionRecording) === null || n === void 0 || n.onRRwebEmit({ type: 6, data: { plugin: "rrweb/console@1", payload: { level: r, trace: [], payload: [JSON.stringify(t)] } }, timestamp: Date.now() });
  }
  _startCapture(t) {
    if (!cn(Object.assign) && !cn(Array.from) && !(this._captureStarted || this.instance.config.disable_session_recording || this.instance.consent.isOptedOut())) {
      var n, r;
      this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId(), this.rrwebRecord ? this._onScriptLoaded() : (n = Tn.__PosthogExtensions__) === null || n === void 0 || (r = n.loadExternalDependency) === null || r === void 0 || r.call(n, this.instance, this.scriptName, (i) => {
        if (i) return Fs.error("could not load recorder", i);
        this._onScriptLoaded();
      }), Fs.info("starting"), this.status === "active" && this._reportStarted(t || "recording_initialized");
    }
  }
  get scriptName() {
    var t, n, r;
    return ((t = this.instance) === null || t === void 0 || (n = t.persistence) === null || n === void 0 || (r = n.get_property(rse)) === null || r === void 0 ? void 0 : r.script) || "recorder";
  }
  isInteractiveEvent(t) {
    var n;
    return t.type === 3 && iAt.indexOf((n = t.data) === null || n === void 0 ? void 0 : n.source) !== -1;
  }
  _updateWindowAndSessionIds(t) {
    var n = this.isInteractiveEvent(t);
    n || this.isIdle || t.timestamp - this._lastActivityTimestamp > this.sessionIdleThresholdMilliseconds && (this.isIdle = !0, clearInterval(this._fullSnapshotTimer), this._tryAddCustomEvent("sessionIdle", { eventTimestamp: t.timestamp, lastActivityTimestamp: this._lastActivityTimestamp, threshold: this.sessionIdleThresholdMilliseconds, bufferLength: this.buffer.data.length, bufferSize: this.buffer.size }), this._flushBuffer());
    var r = !1;
    if (n && (this._lastActivityTimestamp = t.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", { reason: "user activity", type: t.type }), r = !0)), !this.isIdle) {
      var { windowId: i, sessionId: o } = this.sessionManager.checkAndGetSessionAndWindowId(!n, t.timestamp), s = this.sessionId !== o, l = this.windowId !== i;
      this.windowId = i, this.sessionId = o, s || l ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : r && this._scheduleFullSnapshot();
    }
  }
  _tryRRWebMethod(t) {
    try {
      return t.rrwebMethod(), !0;
    } catch (n) {
      return this.queuedRRWebEvents.length < 10 ? this.queuedRRWebEvents.push({ enqueuedAt: t.enqueuedAt || Date.now(), attempt: t.attempt++, rrwebMethod: t.rrwebMethod }) : Fs.warn("could not emit queued rrweb event.", n, t), !1;
    }
  }
  _tryAddCustomEvent(t, n) {
    return this._tryRRWebMethod(Ase(() => this.rrwebRecord.addCustomEvent(t, n)));
  }
  _tryTakeFullSnapshot() {
    return this._tryRRWebMethod(Ase(() => this.rrwebRecord.takeFullSnapshot()));
  }
  _onScriptLoaded() {
    var t, n = { blockClass: "ph-no-capture", blockSelector: void 0, ignoreClass: "ph-ignore-input", maskTextClass: "ph-mask", maskTextSelector: void 0, maskTextFn: void 0, maskAllInputs: !0, maskInputOptions: { password: !0 }, maskInputFn: void 0, slimDOMOptions: {}, collectFonts: !1, inlineStylesheet: !0, recordCrossOriginIframes: !1 }, r = this.instance.config.session_recording;
    for (var [i, o] of Object.entries(r || {})) i in n && (i === "maskInputOptions" ? n.maskInputOptions = bt({ password: !0 }, o) : n[i] = o);
    if (this.canvasRecording && this.canvasRecording.enabled && (n.recordCanvas = !0, n.sampling = { canvas: this.canvasRecording.fps }, n.dataURLOptions = { type: "image/webp", quality: this.canvasRecording.quality }), this.rrwebRecord) {
      this.mutationRateLimiter = (t = this.mutationRateLimiter) !== null && t !== void 0 ? t : new HOt(this.rrwebRecord, { refillRate: this.instance.config.session_recording.__mutationRateLimiterRefillRate, bucketSize: this.instance.config.session_recording.__mutationRateLimiterBucketSize, onBlockedNode: (l, c) => {
        var a = "Too many mutations on node '".concat(l, "'. Rate limiting. This could be due to SVG animations or something similar");
        Fs.info(a, { node: c }), this.log(QR + " " + a, "warn");
      } });
      var s = this._gatherRRWebPlugins();
      this.stopRrweb = this.rrwebRecord(bt({ emit: (l) => {
        this.onRRwebEmit(l);
      }, plugins: s }, n)), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", { sessionRecordingOptions: n, activePlugins: s.map((l) => l == null ? void 0 : l.name) }), this._tryAddCustomEvent("$posthog_config", { config: this.instance.config });
    } else Fs.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
  }
  _scheduleFullSnapshot() {
    if (this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), !this.isIdle) {
      var t = this.fullSnapshotIntervalMillis;
      t && (this._fullSnapshotTimer = setInterval(() => {
        this._tryTakeFullSnapshot();
      }, t));
    }
  }
  _gatherRRWebPlugins() {
    var t, n, r, i, o = [], s = (t = Tn.__PosthogExtensions__) === null || t === void 0 || (n = t.rrwebPlugins) === null || n === void 0 ? void 0 : n.getRecordConsolePlugin;
    s && this.isConsoleLogCaptureEnabled && o.push(s());
    var l = (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.rrwebPlugins) === null || i === void 0 ? void 0 : i.getRecordNetworkPlugin;
    return this.networkPayloadCapture && Xc(l) && (!xOt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? o.push(l(ZOt(this.instance.config, this.networkPayloadCapture))) : Fs.info("NetworkCapture not started because we are on localhost.")), o;
  }
  onRRwebEmit(t) {
    var n;
    if (this._processQueuedEvents(), t && fo(t)) {
      if (t.type === Ap.Meta) {
        var r = this._maskUrl(t.data.href);
        if (this._lastHref = r, !r) return;
        t.data.href = r;
      } else this._pageViewFallBack();
      if (this._checkUrlTriggerConditions(), this.status !== "paused" || function(f) {
        return f.type === Ap.Custom && f.data.tag === "recording paused";
      }(t)) {
        t.type === Ap.FullSnapshot && this._scheduleFullSnapshot(), t.type === Ap.FullSnapshot && this.triggerStatus === "trigger_pending" && this.clearBuffer();
        var i = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(t) : t;
        if (i) {
          var o = function(f) {
            var d = f;
            if (d && fo(d) && d.type === 6 && fo(d.data) && d.data.plugin === "rrweb/console@1") {
              d.data.payload.payload.length > 10 && (d.data.payload.payload = d.data.payload.payload.slice(0, 10), d.data.payload.payload.push("...[truncated]"));
              for (var p = [], h = 0; h < d.data.payload.payload.length; h++) d.data.payload.payload[h] && d.data.payload.payload[h].length > 2e3 ? p.push(d.data.payload.payload[h].slice(0, 2e3) + "...[truncated]") : p.push(d.data.payload.payload[h]);
              return d.data.payload.payload = p, f;
            }
            return f;
          }(i);
          if (this._updateWindowAndSessionIds(o), !this.isIdle || wse(o)) {
            if (wse(o)) {
              var s = o.data.payload;
              if (s) {
                var l = s.lastActivityTimestamp, c = s.threshold;
                o.timestamp = l + c;
              }
            }
            var a = (n = this.instance.config.session_recording.compress_events) === null || n === void 0 || n ? function(f) {
              if (FD(f) < 1024) return f;
              try {
                if (f.type === Ap.FullSnapshot) return bt(bt({}, f), {}, { data: Jg(f.data), cv: "2024-10" });
                if (f.type === Ap.IncrementalSnapshot && f.data.source === Cu.Mutation) return bt(bt({}, f), {}, { cv: "2024-10", data: bt(bt({}, f.data), {}, { texts: Jg(f.data.texts), attributes: Jg(f.data.attributes), removes: Jg(f.data.removes), adds: Jg(f.data.adds) }) });
                if (f.type === Ap.IncrementalSnapshot && f.data.source === Cu.StyleSheetRule) return bt(bt({}, f), {}, { cv: "2024-10", data: bt(bt({}, f.data), {}, { adds: Jg(f.data.adds), removes: Jg(f.data.removes) }) });
              } catch (d) {
                Fs.error("could not compress event - will use uncompressed event", d);
              }
              return f;
            }(o) : o, u = { $snapshot_bytes: FD(a), $snapshot_data: a, $session_id: this.sessionId, $window_id: this.windowId };
            this.status !== "disabled" ? this._captureSnapshotBuffered(u) : this.clearBuffer();
          }
        }
      }
    }
  }
  _pageViewFallBack() {
    if (!this.instance.config.capture_pageview && Be) {
      var t = this._maskUrl(Be.location.href);
      this._lastHref !== t && (this._tryAddCustomEvent("$url_changed", { href: t }), this._lastHref = t);
    }
  }
  _processQueuedEvents() {
    if (this.queuedRRWebEvents.length) {
      var t = [...this.queuedRRWebEvents];
      this.queuedRRWebEvents = [], t.forEach((n) => {
        Date.now() - n.enqueuedAt <= 2e3 && this._tryRRWebMethod(n);
      });
    }
  }
  _maskUrl(t) {
    var n = this.instance.config.session_recording;
    if (n.maskNetworkRequestFn) {
      var r, i = { url: t };
      return (r = i = n.maskNetworkRequestFn(i)) === null || r === void 0 ? void 0 : r.url;
    }
    return t;
  }
  clearBuffer() {
    return this.buffer = { size: 0, data: [], sessionId: this.sessionId, windowId: this.windowId }, this.buffer;
  }
  _flushBuffer() {
    this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
    var t = this.minimumDuration, n = this.sessionDuration, r = Zl(n) && n >= 0, i = Zl(t) && r && n < t;
    return this.status === "buffering" || i ? (this.flushBufferTimer = setTimeout(() => {
      this._flushBuffer();
    }, 2e3), this.buffer) : (this.buffer.data.length > 0 && pX(this.buffer).forEach((o) => {
      this._captureSnapshot({ $snapshot_bytes: o.size, $snapshot_data: o.data, $session_id: o.sessionId, $window_id: o.windowId });
    }), this.clearBuffer());
  }
  _captureSnapshotBuffered(t) {
    var n, r = 2 + (((n = this.buffer) === null || n === void 0 ? void 0 : n.data.length) || 0);
    !this.isIdle && (this.buffer.size + t.$snapshot_bytes + r > 943718.4 || this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), this.buffer.size += t.$snapshot_bytes, this.buffer.data.push(t.$snapshot_data), this.flushBufferTimer || this.isIdle || (this.flushBufferTimer = setTimeout(() => {
      this._flushBuffer();
    }, 2e3));
  }
  _captureSnapshot(t) {
    this.instance.capture("$snapshot", t, { _url: this.instance.requestRouter.endpointFor("api", this._endpoint), _noTruncate: !0, _batchKey: "recordings", skip_client_rate_limiting: !0 });
  }
  _checkUrlTriggerConditions() {
    if (Be !== void 0 && Be.location.href) {
      var t = Be.location.href, n = this.status === "paused", r = xse(t, this._urlBlocklist);
      r && !n ? this._pauseRecording() : !r && n && this._resumeRecording(), xse(t, this._urlTriggers) && this._activateTrigger("url");
    }
  }
  _activateTrigger(t) {
    var n, r;
    this.triggerStatus === "trigger_pending" && ((n = this.instance) === null || n === void 0 || (r = n.persistence) === null || r === void 0 || r.register({ [t === "url" ? N6 : P6]: this.sessionId }), this._flushBuffer(), this._reportStarted(t + "_trigger_matched"));
  }
  _pauseRecording() {
    var t, n;
    this.status !== "paused" && (this._urlBlocked = !0, Wt == null || (t = Wt.body) === null || t === void 0 || (n = t.classList) === null || n === void 0 || n.add("ph-no-capture"), clearInterval(this._fullSnapshotTimer), setTimeout(() => {
      this._flushBuffer();
    }, 100), Fs.info("recording paused due to URL blocker"), this._tryAddCustomEvent("recording paused", { reason: "url blocker" }));
  }
  _resumeRecording() {
    var t, n;
    this.status === "paused" && (this._urlBlocked = !1, Wt == null || (t = Wt.body) === null || t === void 0 || (n = t.classList) === null || n === void 0 || n.remove("ph-no-capture"), this._tryTakeFullSnapshot(), this._scheduleFullSnapshot(), this._tryAddCustomEvent("recording resumed", { reason: "left blocked url" }), Fs.info("recording resumed"));
  }
  _addEventTriggerListener() {
    this._eventTriggers.length !== 0 && ei(this._removeEventTriggerCaptureHook) && (this._removeEventTriggerCaptureHook = this.instance.on("eventCaptured", (t) => {
      try {
        this._eventTriggers.includes(t.event) && this._activateTrigger("event");
      } catch (n) {
        Fs.error("Could not activate event trigger", n);
      }
    }));
  }
  overrideLinkedFlag() {
    this._linkedFlagSeen = !0, this._reportStarted("linked_flag_overridden");
  }
  overrideSampling() {
    var t;
    (t = this.instance.persistence) === null || t === void 0 || t.register({ [r1]: !0 }), this._reportStarted("sampling_overridden");
  }
  overrideTrigger(t) {
    this._activateTrigger(t);
  }
  _reportStarted(t, n) {
    this.instance.register_for_session({ $session_recording_start_reason: t }), Fs.info(t.replace("_", " "), n), Yn(["recording_initialized", "session_id_changed"], t) || this._tryAddCustomEvent(t, n);
  }
}
var jh = Va("[Decide]");
class sAt {
  constructor(t) {
    this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
  }
  _loadRemoteConfigJs(t) {
    var n, r, i;
    (n = Tn.__PosthogExtensions__) !== null && n !== void 0 && n.loadExternalDependency ? (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.loadExternalDependency) === null || i === void 0 || i.call(r, this.instance, "remote-config", () => t(Tn._POSTHOG_CONFIG)) : (jh.error("PostHog Extensions not found. Cannot load remote config."), t());
  }
  _loadRemoteConfigJSON(t) {
    this.instance._send_request({ method: "GET", url: this.instance.requestRouter.endpointFor("assets", "/array/".concat(this.instance.config.token, "/config")), callback: (n) => {
      t(n.json);
    } });
  }
  call() {
    var t = !!this.instance.config.advanced_disable_decide;
    if (t || this.instance.featureFlags.resetRequestQueue(), this.instance.config.__preview_remote_config) return Tn._POSTHOG_CONFIG ? (jh.info("Using preloaded remote config", Tn._POSTHOG_CONFIG), void this.onRemoteConfig(Tn._POSTHOG_CONFIG)) : t ? void jh.warn("Remote config is disabled. Falling back to local config.") : void this._loadRemoteConfigJs((r) => {
      if (!r) return jh.info("No config found after loading remote JS config. Falling back to JSON."), void this._loadRemoteConfigJSON((i) => {
        this.onRemoteConfig(i);
      });
      this.onRemoteConfig(r);
    });
    if (!t) {
      var n = { token: this.instance.config.token, distinct_id: this.instance.get_distinct_id(), groups: this.instance.getGroups(), person_properties: this.instance.get_property(SO), group_properties: this.instance.get_property(Yh), disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0 };
      this.instance._send_request({ method: "POST", url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"), data: n, compression: this.instance.config.disable_compression ? void 0 : zu.Base64, timeout: this.instance.config.feature_flag_request_timeout_ms, callback: (r) => this.parseDecideResponse(r.json) });
    }
  }
  parseDecideResponse(t) {
    this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer();
    var n = !t;
    if (this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(t ?? {}, n), !n) return Wt && Wt.body ? void this.instance._onRemoteConfig(t) : (jh.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.parseDecideResponse(t);
    }, 500));
    jh.error("Failed to fetch feature flags from PostHog.");
  }
  onRemoteConfig(t) {
    if (t) {
      if (!Wt || !Wt.body) return jh.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
        this.onRemoteConfig(t);
      }, 500);
      this.instance._onRemoteConfig(t), t.hasFeatureFlags !== !1 && (this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags.reloadFeatureFlags());
    } else jh.error("Failed to fetch remote config from PostHog.");
  }
}
var wp, aAt = Be != null && Be.location ? zD(Be.location.hash, "__posthog") || zD(location.hash, "state") : null, Sse = "_postHogToolbarParams";
(function(e) {
  e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
})(wp || (wp = {}));
class lAt {
  constructor(t) {
    this.instance = t;
  }
  setToolbarState(t) {
    Tn.ph_toolbar_state = t;
  }
  getToolbarState() {
    var t;
    return (t = Tn.ph_toolbar_state) !== null && t !== void 0 ? t : wp.UNINITIALIZED;
  }
  maybeLoadToolbar() {
    var t, n, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    if (!Be || !Wt) return !1;
    r = (t = r) !== null && t !== void 0 ? t : Be.location, o = (n = o) !== null && n !== void 0 ? n : Be.history;
    try {
      if (!i) {
        try {
          Be.localStorage.setItem("test", "test"), Be.localStorage.removeItem("test");
        } catch {
          return !1;
        }
        i = Be == null ? void 0 : Be.localStorage;
      }
      var s, l = aAt || zD(r.hash, "__posthog") || zD(r.hash, "state"), c = l ? Xoe(() => JSON.parse(atob(decodeURIComponent(l)))) || Xoe(() => JSON.parse(decodeURIComponent(l))) : null;
      return c && c.action === "ph_authorize" ? ((s = c).source = "url", s && Object.keys(s).length > 0 && (c.desiredHash ? r.hash = c.desiredHash : o ? o.replaceState(o.state, "", r.pathname + r.search) : r.hash = "")) : ((s = JSON.parse(i.getItem(Sse) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
    } catch {
      return !1;
    }
  }
  _callLoadToolbar(t) {
    (Tn.ph_load_toolbar || Tn.ph_load_editor)(t, this.instance);
  }
  loadToolbar(t) {
    var n = !(Wt == null || !Wt.getElementById(Bke));
    if (!Be || n) return !1;
    var r = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, i = bt(bt({ token: this.instance.config.token }, t), {}, { apiURL: this.instance.requestRouter.endpointFor("ui") }, r ? { instrument: !1 } : {});
    if (Be.localStorage.setItem(Sse, JSON.stringify(bt(bt({}, i), {}, { source: void 0 }))), this.getToolbarState() === wp.LOADED) this._callLoadToolbar(i);
    else if (this.getToolbarState() === wp.UNINITIALIZED) {
      var o, s;
      this.setToolbarState(wp.LOADING), (o = Tn.__PosthogExtensions__) === null || o === void 0 || (s = o.loadExternalDependency) === null || s === void 0 || s.call(o, this.instance, "toolbar", (l) => {
        if (l) return un.error("[Toolbar] Failed to load", l), void this.setToolbarState(wp.UNINITIALIZED);
        this.setToolbarState(wp.LOADED), this._callLoadToolbar(i);
      }), _p(Be, "turbolinks:load", () => {
        this.setToolbarState(wp.UNINITIALIZED), this.loadToolbar(i);
      });
    }
    return !0;
  }
  _loadEditor(t) {
    return this.loadToolbar(t);
  }
  maybeLoadEditor() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    return this.maybeLoadToolbar(t, n, r);
  }
}
let cAt = class {
  constructor(t) {
    Vt(this, "isPaused", !0), Vt(this, "queue", []), Vt(this, "flushTimeoutMs", 3e3), this.sendRequest = t;
  }
  enqueue(t) {
    this.queue.push(t), this.flushTimeout || this.setFlushTimeout();
  }
  unload() {
    this.clearFlushTimeout();
    var t = this.queue.length > 0 ? this.formatQueue() : {}, n = Object.values(t), r = [...n.filter((i) => i.url.indexOf("/e") === 0), ...n.filter((i) => i.url.indexOf("/e") !== 0)];
    r.map((i) => {
      this.sendRequest(bt(bt({}, i), {}, { transport: "sendBeacon" }));
    });
  }
  enable() {
    this.isPaused = !1, this.setFlushTimeout();
  }
  setFlushTimeout() {
    var t = this;
    this.isPaused || (this.flushTimeout = setTimeout(() => {
      if (this.clearFlushTimeout(), this.queue.length > 0) {
        var n = this.formatQueue(), r = function(o) {
          var s = n[o], l = (/* @__PURE__ */ new Date()).getTime();
          s.data && Qi(s.data) && Xr(s.data, (c) => {
            c.offset = Math.abs(c.timestamp - l), delete c.timestamp;
          }), t.sendRequest(s);
        };
        for (var i in n) r(i);
      }
    }, this.flushTimeoutMs));
  }
  clearFlushTimeout() {
    clearTimeout(this.flushTimeout), this.flushTimeout = void 0;
  }
  formatQueue() {
    var t = {};
    return Xr(this.queue, (n) => {
      var r, i = n, o = (i ? i.batchKey : null) || i.url;
      cn(t[o]) && (t[o] = bt(bt({}, i), {}, { data: [] })), (r = t[o].data) === null || r === void 0 || r.push(i.data);
    }), this.queue = [], t;
  }
};
var uAt = !!JB || !!YB, Ese = "text/plain", qD = (e, t) => {
  var [n, r] = e.split("?"), i = bt({}, t);
  r == null || r.split("&").forEach((s) => {
    var [l] = s.split("=");
    delete i[l];
  });
  var o = SOt(i);
  return o = o ? (r ? r + "&" : "") + o : r, "".concat(n, "?").concat(o);
}, WP = (e, t) => JSON.stringify(e, (n, r) => typeof r == "bigint" ? r.toString() : r, t), L6 = (e) => {
  var { data: t, compression: n } = e;
  if (t) {
    if (n === zu.GZipJS) {
      var r = ACe(wCe(WP(t)), { mtime: 0 }), i = new Blob([r], { type: Ese });
      return { contentType: Ese, body: i, estimatedSize: i.size };
    }
    if (n === zu.Base64) {
      var o = function(c) {
        var a, u, f, d, p, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", m = 0, v = 0, b = "", A = [];
        if (!c) return c;
        c = aOt(c);
        do
          a = (p = c.charCodeAt(m++) << 16 | c.charCodeAt(m++) << 8 | c.charCodeAt(m++)) >> 18 & 63, u = p >> 12 & 63, f = p >> 6 & 63, d = 63 & p, A[v++] = h.charAt(a) + h.charAt(u) + h.charAt(f) + h.charAt(d);
        while (m < c.length);
        switch (b = A.join(""), c.length % 3) {
          case 1:
            b = b.slice(0, -2) + "==";
            break;
          case 2:
            b = b.slice(0, -1) + "=";
        }
        return b;
      }(WP(t)), s = ((c) => "data=" + encodeURIComponent(typeof c == "string" ? c : WP(c)))(o);
      return { contentType: "application/x-www-form-urlencoded", body: s, estimatedSize: new Blob([s]).size };
    }
    var l = WP(t);
    return { contentType: "application/json", body: l, estimatedSize: new Blob([l]).size };
  }
}, CE = [];
JB && CE.push({ transport: "XHR", method: (e) => {
  var t, n = new JB();
  n.open(e.method || "GET", e.url, !0);
  var { contentType: r, body: i } = (t = L6(e)) !== null && t !== void 0 ? t : {};
  Xr(e.headers, function(o, s) {
    n.setRequestHeader(s, o);
  }), r && n.setRequestHeader("Content-Type", r), e.timeout && (n.timeout = e.timeout), n.withCredentials = !0, n.onreadystatechange = () => {
    if (n.readyState === 4) {
      var o, s = { statusCode: n.status, text: n.responseText };
      if (n.status === 200) try {
        s.json = JSON.parse(n.responseText);
      } catch {
      }
      (o = e.callback) === null || o === void 0 || o.call(e, s);
    }
  }, n.send(i);
} }), YB && CE.push({ transport: "fetch", method: (e) => {
  var t, n, { contentType: r, body: i, estimatedSize: o } = (t = L6(e)) !== null && t !== void 0 ? t : {}, s = new Headers();
  Xr(e.headers, function(u, f) {
    s.append(f, u);
  }), r && s.append("Content-Type", r);
  var l = e.url, c = null;
  if (Boe) {
    var a = new Boe();
    c = { signal: a.signal, timeout: setTimeout(() => a.abort(), e.timeout) };
  }
  YB(l, { method: (e == null ? void 0 : e.method) || "GET", headers: s, keepalive: e.method === "POST" && (o || 0) < 52428.8, body: i, signal: (n = c) === null || n === void 0 ? void 0 : n.signal }).then((u) => u.text().then((f) => {
    var d, p = { statusCode: u.status, text: f };
    if (u.status === 200) try {
      p.json = JSON.parse(f);
    } catch (h) {
      un.error(h);
    }
    (d = e.callback) === null || d === void 0 || d.call(e, p);
  })).catch((u) => {
    var f;
    un.error(u), (f = e.callback) === null || f === void 0 || f.call(e, { statusCode: 0, text: u });
  }).finally(() => c ? clearTimeout(c.timeout) : null);
} }), Jl != null && Jl.sendBeacon && CE.push({ transport: "sendBeacon", method: (e) => {
  var t = qD(e.url, { beacon: "1" });
  try {
    var n, { contentType: r, body: i } = (n = L6(e)) !== null && n !== void 0 ? n : {}, o = typeof i == "string" ? new Blob([i], { type: r }) : i;
    Jl.sendBeacon(t, o);
  } catch {
  }
} });
var dAt = ["retriesPerformedSoFar"];
let fAt = class {
  constructor(t) {
    Vt(this, "isPolling", !1), Vt(this, "pollIntervalMs", 3e3), Vt(this, "queue", []), this.instance = t, this.queue = [], this.areWeOnline = !0, !cn(Be) && "onLine" in Be.navigator && (this.areWeOnline = Be.navigator.onLine, Be.addEventListener("online", () => {
      this.areWeOnline = !0, this.flush();
    }), Be.addEventListener("offline", () => {
      this.areWeOnline = !1;
    }));
  }
  retriableRequest(t) {
    var { retriesPerformedSoFar: n } = t, r = Uke(t, dAt);
    Zl(n) && n > 0 && (r.url = qD(r.url, { retry_count: n })), this.instance._send_request(bt(bt({}, r), {}, { callback: (i) => {
      var o;
      i.statusCode !== 200 && (i.statusCode < 400 || i.statusCode >= 500) && (n ?? 0) < 10 ? this.enqueue(bt({ retriesPerformedSoFar: n }, r)) : (o = r.callback) === null || o === void 0 || o.call(r, i);
    } }));
  }
  enqueue(t) {
    var n = t.retriesPerformedSoFar || 0;
    t.retriesPerformedSoFar = n + 1;
    var r = function(s) {
      var l = 3e3 * Math.pow(2, s), c = l / 2, a = Math.min(18e5, l), u = (Math.random() - 0.5) * (a - c);
      return Math.ceil(a + u);
    }(n), i = Date.now() + r;
    this.queue.push({ retryAt: i, requestOptions: t });
    var o = "Enqueued failed request for retry in ".concat(r);
    navigator.onLine || (o += " (Browser is offline)"), un.warn(o), this.isPolling || (this.isPolling = !0, this.poll());
  }
  poll() {
    this.poller && clearTimeout(this.poller), this.poller = setTimeout(() => {
      this.areWeOnline && this.queue.length > 0 && this.flush(), this.poll();
    }, this.pollIntervalMs);
  }
  flush() {
    var t = Date.now(), n = [], r = this.queue.filter((o) => o.retryAt < t || (n.push(o), !1));
    if (this.queue = n, r.length > 0) for (var { requestOptions: i } of r) this.retriableRequest(i);
  }
  unload() {
    for (var { requestOptions: t } of (this.poller && (clearTimeout(this.poller), this.poller = void 0), this.queue)) try {
      this.instance._send_request(bt(bt({}, t), {}, { transport: "sendBeacon" }));
    } catch (n) {
      un.error(n);
    }
    this.queue = [];
  }
};
var ky, Tse = Va("[SessionId]");
class pAt {
  constructor(t, n, r) {
    var i;
    if (Vt(this, "_sessionIdChangedHandlers", []), !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    this.config = t.config, this.persistence = t.persistence, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = n || Im, this._windowIdGenerator = r || Im;
    var o = this.config.persistence_name || this.config.token, s = this.config.session_idle_timeout_seconds || 1800;
    if (this._sessionTimeoutMs = 1e3 * af(s, 60, 36e3, "session_idle_timeout_seconds", 1800), t.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this._window_id_storage_key = "ph_" + o + "_window_id", this._primary_window_exists_storage_key = "ph_" + o + "_primary_window_exists", this._canUseSessionStorage()) {
      var l = ms.parse(this._window_id_storage_key), c = ms.parse(this._primary_window_exists_storage_key);
      l && !c ? this._windowId = l : ms.remove(this._window_id_storage_key), ms.set(this._primary_window_exists_storage_key, !0);
    }
    if ((i = this.config.bootstrap) !== null && i !== void 0 && i.sessionID) try {
      var a = ((u) => {
        var f = u.replace(/-/g, "");
        if (f.length !== 32) throw new Error("Not a valid UUID");
        if (f[12] !== "7") throw new Error("Not a UUIDv7");
        return parseInt(f.substring(0, 12), 16);
      })(this.config.bootstrap.sessionID);
      this._setSessionId(this.config.bootstrap.sessionID, (/* @__PURE__ */ new Date()).getTime(), a);
    } catch (u) {
      Tse.error("Invalid sessionID in bootstrap", u);
    }
    this._listenToReloadWindow();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(t) {
    return cn(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(t), this._sessionId && t(this._sessionId, this._windowId), () => {
      this._sessionIdChangedHandlers = this._sessionIdChangedHandlers.filter((n) => n !== t);
    };
  }
  _canUseSessionStorage() {
    return this.config.persistence !== "memory" && !this.persistence.disabled && ms.is_supported();
  }
  _setWindowId(t) {
    t !== this._windowId && (this._windowId = t, this._canUseSessionStorage() && ms.set(this._window_id_storage_key, t));
  }
  _getWindowId() {
    return this._windowId ? this._windowId : this._canUseSessionStorage() ? ms.parse(this._window_id_storage_key) : null;
  }
  _setSessionId(t, n, r) {
    t === this._sessionId && n === this._sessionActivityTimestamp && r === this._sessionStartTimestamp || (this._sessionStartTimestamp = r, this._sessionActivityTimestamp = n, this._sessionId = t, this.persistence.register({ [RD]: [n, t, r] }));
  }
  _getSessionId() {
    if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [this._sessionActivityTimestamp, this._sessionId, this._sessionStartTimestamp];
    var t = this.persistence.props[RD];
    return Qi(t) && t.length === 2 && t.push(t[0]), t || [0, null, 0];
  }
  resetSessionId() {
    this._setSessionId(null, null, null);
  }
  _listenToReloadWindow() {
    Be == null || Be.addEventListener("beforeunload", () => {
      this._canUseSessionStorage() && ms.remove(this._primary_window_exists_storage_key);
    });
  }
  checkAndGetSessionAndWindowId() {
    var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null) || (/* @__PURE__ */ new Date()).getTime(), [r, i, o] = this._getSessionId(), s = this._getWindowId(), l = Zl(o) && o > 0 && Math.abs(n - o) > 864e5, c = !1, a = !i, u = !t && Math.abs(n - r) > this.sessionTimeoutMs;
    a || u || l ? (i = this._sessionIdGenerator(), s = this._windowIdGenerator(), Tse.info("new session ID generated", { sessionId: i, windowId: s, changeReason: { noSessionId: a, activityTimeout: u, sessionPastMaximumLength: l } }), o = n, c = !0) : s || (s = this._windowIdGenerator(), c = !0);
    var f = r === 0 || !t || l ? n : r, d = o === 0 ? (/* @__PURE__ */ new Date()).getTime() : o;
    return this._setWindowId(s), this._setSessionId(i, f, d), c && this._sessionIdChangedHandlers.forEach((p) => p(i, s, c ? { noSessionId: a, activityTimeout: u, sessionPastMaximumLength: l } : void 0)), { sessionId: i, windowId: s, sessionStartTimestamp: d, changeReason: c ? { noSessionId: a, activityTimeout: u, sessionPastMaximumLength: l } : void 0, lastActivityTimestamp: r };
  }
}
(function(e) {
  e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
})(ky || (ky = {}));
var kse = "i.posthog.com";
class hAt {
  constructor(t) {
    Vt(this, "_regionCache", {}), this.instance = t;
  }
  get apiHost() {
    var t = this.instance.config.api_host.trim().replace(/\/$/, "");
    return t === "https://app.posthog.com" ? "https://us.i.posthog.com" : t;
  }
  get uiHost() {
    var t, n = (t = this.instance.config.ui_host) === null || t === void 0 ? void 0 : t.replace(/\/$/, "");
    return n || (n = this.apiHost.replace(".".concat(kse), ".posthog.com")), n === "https://app.posthog.com" ? "https://us.posthog.com" : n;
  }
  get region() {
    return this._regionCache[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = ky.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = ky.EU : this._regionCache[this.apiHost] = ky.CUSTOM), this._regionCache[this.apiHost];
  }
  endpointFor(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (n && (n = n[0] === "/" ? n : "/".concat(n)), t === "ui") return this.uiHost + n;
    if (this.region === ky.CUSTOM) return this.apiHost + n;
    var r = kse + n;
    switch (t) {
      case "assets":
        return "https://".concat(this.region, "-assets.").concat(r);
      case "api":
        return "https://".concat(this.region, ".").concat(r);
    }
  }
}
var xCe = "posthog-js";
function SCe(e) {
  var { organization: t, projectId: n, prefix: r, severityAllowList: i = ["error"] } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (o) => {
    var s, l, c, a, u;
    if (!(i === "*" || i.includes(o.level)) || !e.__loaded) return o;
    o.tags || (o.tags = {});
    var f = e.requestRouter.endpointFor("ui", "/project/".concat(e.config.token, "/person/").concat(e.get_distinct_id()));
    o.tags["PostHog Person URL"] = f, e.sessionRecordingStarted() && (o.tags["PostHog Recording URL"] = e.get_session_replay_url({ withTimestamp: !0 }));
    var d = ((s = o.exception) === null || s === void 0 ? void 0 : s.values) || [];
    d.map((h) => {
      h.stacktrace && (h.stacktrace.type = "raw");
    });
    var p = { $exception_message: ((l = d[0]) === null || l === void 0 ? void 0 : l.value) || o.message, $exception_type: (c = d[0]) === null || c === void 0 ? void 0 : c.type, $exception_personURL: f, $exception_level: o.level, $exception_list: d, $sentry_event_id: o.event_id, $sentry_exception: o.exception, $sentry_exception_message: ((a = d[0]) === null || a === void 0 ? void 0 : a.value) || o.message, $sentry_exception_type: (u = d[0]) === null || u === void 0 ? void 0 : u.type, $sentry_tags: o.tags };
    return t && n && (p.$sentry_url = (r || "https://sentry.io/organizations/") + t + "/issues/?project=" + n + "&query=" + o.event_id), e.exceptions.sendExceptionEvent(p), o;
  };
}
class mAt {
  constructor(t, n, r, i, o) {
    this.name = xCe, this.setupOnce = function(s) {
      s(SCe(t, { organization: n, projectId: r, prefix: i, severityAllowList: o }));
    };
  }
}
var Cse, BD, Eu, z6 = Va("[SegmentIntegration]");
function gAt(e, t) {
  var n = e.config.segment;
  if (!n) return t();
  (function(r, i) {
    var o = r.config.segment;
    if (!o) return i();
    var s = (c) => {
      var a = () => c.anonymousId() || Im();
      r.config.get_device_id = a, c.id() && (r.register({ distinct_id: c.id(), $device_id: a() }), r.persistence.set_property(Op, "identified")), i();
    }, l = o.user();
    "then" in l && Xc(l.then) ? l.then((c) => s(c)) : s(l);
  })(e, () => {
    n.register(((r) => {
      Promise && Promise.resolve || z6.warn("This browser does not have Promise support, and can not use the segment integration");
      var i = (o, s) => {
        var l;
        if (!s) return o;
        o.event.userId || o.event.anonymousId === r.get_distinct_id() || (z6.info("No userId set, resetting PostHog"), r.reset()), o.event.userId && o.event.userId !== r.get_distinct_id() && (z6.info("UserId set, identifying with PostHog"), r.identify(o.event.userId));
        var c = r._calculate_event_properties(s, (l = o.event.properties) !== null && l !== void 0 ? l : {}, /* @__PURE__ */ new Date());
        return o.event.properties = Object.assign({}, c, o.event.properties), o;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded: () => !0, load: () => Promise.resolve(), track: (o) => i(o, o.event.event), page: (o) => i(o, "$pageview"), identify: (o) => i(o, "$identify"), screen: (o) => i(o, "$screen") };
    })(e)).then(() => {
      t();
    });
  });
}
class yAt {
  constructor(t) {
    this._instance = t;
  }
  doPageView(t) {
    var n, r = this._previousPageViewProperties(t);
    return this._currentPath = (n = Be == null ? void 0 : Be.location.pathname) !== null && n !== void 0 ? n : "", this._instance.scrollManager.resetContext(), this._prevPageviewTimestamp = t, r;
  }
  doPageLeave(t) {
    return this._previousPageViewProperties(t);
  }
  _previousPageViewProperties(t) {
    var n = this._currentPath, r = this._prevPageviewTimestamp, i = this._instance.scrollManager.getContext();
    if (!r) return {};
    var o = {};
    if (i) {
      var { maxScrollHeight: s, lastScrollY: l, maxScrollY: c, maxContentHeight: a, lastContentY: u, maxContentY: f } = i;
      cn(s) || cn(l) || cn(c) || cn(a) || cn(u) || cn(f) || (s = Math.ceil(s), l = Math.ceil(l), c = Math.ceil(c), a = Math.ceil(a), u = Math.ceil(u), f = Math.ceil(f), o = { $prev_pageview_last_scroll: l, $prev_pageview_last_scroll_percentage: s <= 1 ? 1 : af(l / s, 0, 1), $prev_pageview_max_scroll: c, $prev_pageview_max_scroll_percentage: s <= 1 ? 1 : af(c / s, 0, 1), $prev_pageview_last_content: u, $prev_pageview_last_content_percentage: a <= 1 ? 1 : af(u / a, 0, 1), $prev_pageview_max_content: f, $prev_pageview_max_content_percentage: a <= 1 ? 1 : af(f / a, 0, 1) });
    }
    return n && (o.$prev_pageview_pathname = n), r && (o.$prev_pageview_duration = (t.getTime() - r.getTime()) / 1e3), o;
  }
}
(function(e) {
  e.Popover = "popover", e.API = "api", e.Widget = "widget";
})(Cse || (Cse = {})), function(e) {
  e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}(BD || (BD = {})), function(e) {
  e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question";
}(Eu || (Eu = {}));
class ECe {
  constructor() {
    Vt(this, "events", {}), this.events = {};
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = []), this.events[t].push(n), () => {
      this.events[t] = this.events[t].filter((r) => r !== n);
    };
  }
  emit(t, n) {
    for (var r of this.events[t] || []) r(n);
    for (var i of this.events["*"] || []) i(t, n);
  }
}
class gy {
  constructor(t) {
    Vt(this, "_debugEventEmitter", new ECe()), Vt(this, "checkStep", (n, r) => this.checkStepEvent(n, r) && this.checkStepUrl(n, r) && this.checkStepElement(n, r)), Vt(this, "checkStepEvent", (n, r) => r == null || !r.event || (n == null ? void 0 : n.event) === (r == null ? void 0 : r.event)), this.instance = t, this.actionEvents = /* @__PURE__ */ new Set(), this.actionRegistry = /* @__PURE__ */ new Set();
  }
  init() {
    var t;
    if (!cn((t = this.instance) === null || t === void 0 ? void 0 : t._addCaptureHook)) {
      var n;
      (n = this.instance) === null || n === void 0 || n._addCaptureHook((r, i) => {
        this.on(r, i);
      });
    }
  }
  register(t) {
    var n, r;
    if (!cn((n = this.instance) === null || n === void 0 ? void 0 : n._addCaptureHook) && (t.forEach((s) => {
      var l, c;
      (l = this.actionRegistry) === null || l === void 0 || l.add(s), (c = s.steps) === null || c === void 0 || c.forEach((a) => {
        var u;
        (u = this.actionEvents) === null || u === void 0 || u.add((a == null ? void 0 : a.event) || "");
      });
    }), (r = this.instance) !== null && r !== void 0 && r.autocapture)) {
      var i, o = /* @__PURE__ */ new Set();
      t.forEach((s) => {
        var l;
        (l = s.steps) === null || l === void 0 || l.forEach((c) => {
          c != null && c.selector && o.add(c == null ? void 0 : c.selector);
        });
      }), (i = this.instance) === null || i === void 0 || i.autocapture.setElementSelectors(o);
    }
  }
  on(t, n) {
    var r;
    n != null && t.length != 0 && (this.actionEvents.has(t) || this.actionEvents.has(n == null ? void 0 : n.event)) && this.actionRegistry && ((r = this.actionRegistry) === null || r === void 0 ? void 0 : r.size) > 0 && this.actionRegistry.forEach((i) => {
      this.checkAction(n, i) && this._debugEventEmitter.emit("actionCaptured", i.name);
    });
  }
  _addActionHook(t) {
    this.onAction("actionCaptured", (n) => t(n));
  }
  checkAction(t, n) {
    if ((n == null ? void 0 : n.steps) == null) return !1;
    for (var r of n.steps) if (this.checkStep(t, r)) return !0;
    return !1;
  }
  onAction(t, n) {
    return this._debugEventEmitter.on(t, n);
  }
  checkStepUrl(t, n) {
    if (n != null && n.url) {
      var r, i = t == null || (r = t.properties) === null || r === void 0 ? void 0 : r.$current_url;
      if (!i || typeof i != "string" || !gy.matchString(i, n == null ? void 0 : n.url, (n == null ? void 0 : n.url_matching) || "contains")) return !1;
    }
    return !0;
  }
  static matchString(t, n, r) {
    switch (r) {
      case "regex":
        return !!Be && lw(t, n);
      case "exact":
        return n === t;
      case "contains":
        var i = gy.escapeStringRegexp(n).replace(/_/g, ".").replace(/%/g, ".*");
        return lw(t, i);
      default:
        return !1;
    }
  }
  static escapeStringRegexp(t) {
    return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }
  checkStepElement(t, n) {
    if ((n != null && n.href || n != null && n.tag_name || n != null && n.text) && !this.getElementsList(t).some((o) => !(n != null && n.href && !gy.matchString(o.href || "", n == null ? void 0 : n.href, (n == null ? void 0 : n.href_matching) || "exact")) && (n == null || !n.tag_name || o.tag_name === (n == null ? void 0 : n.tag_name)) && !(n != null && n.text && !gy.matchString(o.text || "", n == null ? void 0 : n.text, (n == null ? void 0 : n.text_matching) || "exact") && !gy.matchString(o.$el_text || "", n == null ? void 0 : n.text, (n == null ? void 0 : n.text_matching) || "exact")))) return !1;
    if (n != null && n.selector) {
      var r, i = t == null || (r = t.properties) === null || r === void 0 ? void 0 : r.$element_selectors;
      if (!i || !i.includes(n == null ? void 0 : n.selector)) return !1;
    }
    return !0;
  }
  getElementsList(t) {
    return (t == null ? void 0 : t.properties.$elements) == null ? [] : t == null ? void 0 : t.properties.$elements;
  }
}
class QT {
  constructor(t) {
    this.instance = t, this.eventToSurveys = /* @__PURE__ */ new Map(), this.actionToSurveys = /* @__PURE__ */ new Map();
  }
  register(t) {
    var n;
    cn((n = this.instance) === null || n === void 0 ? void 0 : n._addCaptureHook) || (this.setupEventBasedSurveys(t), this.setupActionBasedSurveys(t));
  }
  setupActionBasedSurveys(t) {
    var n = t.filter((r) => {
      var i, o, s, l;
      return ((i = r.conditions) === null || i === void 0 ? void 0 : i.actions) && ((o = r.conditions) === null || o === void 0 || (s = o.actions) === null || s === void 0 || (l = s.values) === null || l === void 0 ? void 0 : l.length) > 0;
    });
    n.length !== 0 && (this.actionMatcher == null && (this.actionMatcher = new gy(this.instance), this.actionMatcher.init(), this.actionMatcher._addActionHook((r) => {
      this.onAction(r);
    })), n.forEach((r) => {
      var i, o, s, l, c, a, u, f, d, p;
      r.conditions && (i = r.conditions) !== null && i !== void 0 && i.actions && (o = r.conditions) !== null && o !== void 0 && (s = o.actions) !== null && s !== void 0 && s.values && ((l = r.conditions) === null || l === void 0 || (c = l.actions) === null || c === void 0 || (a = c.values) === null || a === void 0 ? void 0 : a.length) > 0 && ((u = this.actionMatcher) === null || u === void 0 || u.register(r.conditions.actions.values), (f = r.conditions) === null || f === void 0 || (d = f.actions) === null || d === void 0 || (p = d.values) === null || p === void 0 || p.forEach((h) => {
        if (h && h.name) {
          var m = this.actionToSurveys.get(h.name);
          m && m.push(r.id), this.actionToSurveys.set(h.name, m || [r.id]);
        }
      }));
    }));
  }
  setupEventBasedSurveys(t) {
    var n;
    t.filter((r) => {
      var i, o, s, l;
      return ((i = r.conditions) === null || i === void 0 ? void 0 : i.events) && ((o = r.conditions) === null || o === void 0 || (s = o.events) === null || s === void 0 || (l = s.values) === null || l === void 0 ? void 0 : l.length) > 0;
    }).length !== 0 && ((n = this.instance) === null || n === void 0 || n._addCaptureHook((r, i) => {
      this.onEvent(r, i);
    }), t.forEach((r) => {
      var i, o, s;
      (i = r.conditions) === null || i === void 0 || (o = i.events) === null || o === void 0 || (s = o.values) === null || s === void 0 || s.forEach((l) => {
        if (l && l.name) {
          var c = this.eventToSurveys.get(l.name);
          c && c.push(r.id), this.eventToSurveys.set(l.name, c || [r.id]);
        }
      });
    }));
  }
  onEvent(t, n) {
    var r, i, o = ((r = this.instance) === null || r === void 0 || (i = r.persistence) === null || i === void 0 ? void 0 : i.props[jP]) || [];
    if (QT.SURVEY_SHOWN_EVENT_NAME == t && n && o.length > 0) {
      var s, l = n == null || (s = n.properties) === null || s === void 0 ? void 0 : s.$survey_id;
      if (l) {
        var c = o.indexOf(l);
        c >= 0 && (o.splice(c, 1), this._updateActivatedSurveys(o));
      }
    } else this.eventToSurveys.has(t) && this._updateActivatedSurveys(o.concat(this.eventToSurveys.get(t) || []));
  }
  onAction(t) {
    var n, r, i = ((n = this.instance) === null || n === void 0 || (r = n.persistence) === null || r === void 0 ? void 0 : r.props[jP]) || [];
    this.actionToSurveys.has(t) && this._updateActivatedSurveys(i.concat(this.actionToSurveys.get(t) || []));
  }
  _updateActivatedSurveys(t) {
    var n, r;
    (n = this.instance) === null || n === void 0 || (r = n.persistence) === null || r === void 0 || r.register({ [jP]: [...new Set(t)] });
  }
  getSurveys() {
    var t, n, r = (t = this.instance) === null || t === void 0 || (n = t.persistence) === null || n === void 0 ? void 0 : n.props[jP];
    return r || [];
  }
  getEventToSurveys() {
    return this.eventToSurveys;
  }
  _getActionMatcher() {
    return this.actionMatcher;
  }
}
Vt(QT, "SURVEY_SHOWN_EVENT_NAME", "survey shown");
var TCe, Vi, kCe, yy, Nse, CCe, wX, NCe, xX = {}, PCe = [], vAt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, P$ = Array.isArray;
function Rm(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function ICe(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function j6(e, t, n, r, i) {
  var o = { type: e, props: t, key: n, ref: r, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: i ?? ++kCe, __i: -1, __u: 0 };
  return i == null && Vi.vnode != null && Vi.vnode(o), o;
}
function I$(e) {
  return e.children;
}
function $R(e, t) {
  this.props = e, this.context = t;
}
function fw(e, t) {
  if (t == null) return e.__ ? fw(e.__, e.__i + 1) : null;
  for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
  return typeof e.type == "function" ? fw(e) : null;
}
function RCe(e) {
  var t, n;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) {
      e.__e = e.__c.base = n.__e;
      break;
    }
    return RCe(e);
  }
}
function SX(e) {
  (!e.__d && (e.__d = !0) && yy.push(e) && !XD.__r++ || Nse !== Vi.debounceRendering) && ((Nse = Vi.debounceRendering) || CCe)(XD);
}
function XD() {
  var e, t, n, r, i, o, s, l, c;
  for (yy.sort(wX); e = yy.shift(); ) e.__d && (t = yy.length, r = void 0, o = (i = (n = e).__v).__e, l = [], c = [], (s = n.__P) && ((r = Rm({}, i)).__v = i.__v + 1, Vi.vnode && Vi.vnode(r), _Ce(s, r, i, n.__n, s.ownerSVGElement !== void 0, 32 & i.__u ? [o] : null, l, o ?? fw(i), !!(32 & i.__u), c), r.__.__k[r.__i] = r, AAt(l, r, c), r.__e != o && RCe(r)), yy.length > t && yy.sort(wX));
  XD.__r = 0;
}
function MCe(e, t, n, r, i, o, s, l, c, a, u) {
  var f, d, p, h, m, v = r && r.__k || PCe, b = t.length;
  for (n.__d = c, bAt(n, t, v), c = n.__d, f = 0; f < b; f++) (p = n.__k[f]) != null && typeof p != "boolean" && typeof p != "function" && (d = p.__i === -1 ? xX : v[p.__i] || xX, p.__i = f, _Ce(e, p, d, i, o, s, l, c, a, u), h = p.__e, p.ref && d.ref != p.ref && (d.ref && R$(d.ref, null, p), u.push(p.ref, p.__c || h, p)), m == null && h != null && (m = h), 65536 & p.__u || d.__k === p.__k ? c = DCe(p, c, e) : typeof p.type == "function" && p.__d !== void 0 ? c = p.__d : h && (c = h.nextSibling), p.__d = void 0, p.__u &= -196609);
  n.__d = c, n.__e = m;
}
function bAt(e, t, n) {
  var r, i, o, s, l, c = t.length, a = n.length, u = a, f = 0;
  for (e.__k = [], r = 0; r < c; r++) (i = e.__k[r] = (i = t[r]) == null || typeof i == "boolean" || typeof i == "function" ? null : typeof i == "string" || typeof i == "number" || typeof i == "bigint" || i.constructor == String ? j6(null, i, null, null, i) : P$(i) ? j6(I$, { children: i }, null, null, null) : i.constructor === void 0 && i.__b > 0 ? j6(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) != null ? (i.__ = e, i.__b = e.__b + 1, l = OAt(i, n, s = r + f, u), i.__i = l, o = null, l !== -1 && (u--, (o = n[l]) && (o.__u |= 131072)), o == null || o.__v === null ? (l == -1 && f--, typeof i.type != "function" && (i.__u |= 65536)) : l !== s && (l === s + 1 ? f++ : l > s ? u > c - s ? f += l - s : f-- : f = l < s && l == s - 1 ? l - s : 0, l !== r + f && (i.__u |= 65536))) : (o = n[r]) && o.key == null && o.__e && (o.__e == e.__d && (e.__d = fw(o)), EX(o, o, !1), n[r] = null, u--);
  if (u) for (r = 0; r < a; r++) (o = n[r]) != null && (131072 & o.__u) == 0 && (o.__e == e.__d && (e.__d = fw(o)), EX(o, o));
}
function DCe(e, t, n) {
  var r, i;
  if (typeof e.type == "function") {
    for (r = e.__k, i = 0; r && i < r.length; i++) r[i] && (r[i].__ = e, t = DCe(r[i], t, n));
    return t;
  }
  return e.__e != t && (n.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function OAt(e, t, n, r) {
  var i = e.key, o = e.type, s = n - 1, l = n + 1, c = t[n];
  if (c === null || c && i == c.key && o === c.type) return n;
  if (r > (c != null && (131072 & c.__u) == 0 ? 1 : 0)) for (; s >= 0 || l < t.length; ) {
    if (s >= 0) {
      if ((c = t[s]) && (131072 & c.__u) == 0 && i == c.key && o === c.type) return s;
      s--;
    }
    if (l < t.length) {
      if ((c = t[l]) && (131072 & c.__u) == 0 && i == c.key && o === c.type) return l;
      l++;
    }
  }
  return -1;
}
function Pse(e, t, n) {
  t[0] === "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || vAt.test(t) ? n : n + "px";
}
function ZP(e, t, n, r, i) {
  var o;
  e: if (t === "style") if (typeof n == "string") e.style.cssText = n;
  else {
    if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || Pse(e.style, t, "");
    if (n) for (t in n) r && n[t] === r[t] || Pse(e.style, t, n[t]);
  }
  else if (t[0] === "o" && t[1] === "n") o = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? r ? n.u = r.u : (n.u = Date.now(), e.addEventListener(t, o ? Rse : Ise, o)) : e.removeEventListener(t, o ? Rse : Ise, o);
  else {
    if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t !== "rowSpan" && t !== "colSpan" && t !== "role" && t in e) try {
      e[t] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n == null || n === !1 && t[4] !== "-" ? e.removeAttribute(t) : e.setAttribute(t, n));
  }
}
function Ise(e) {
  var t = this.l[e.type + !1];
  if (e.t) {
    if (e.t <= t.u) return;
  } else e.t = Date.now();
  return t(Vi.event ? Vi.event(e) : e);
}
function Rse(e) {
  return this.l[e.type + !0](Vi.event ? Vi.event(e) : e);
}
function _Ce(e, t, n, r, i, o, s, l, c, a) {
  var u, f, d, p, h, m, v, b, A, w, O, x, S, E, k, T = t.type;
  if (t.constructor !== void 0) return null;
  128 & n.__u && (c = !!(32 & n.__u), o = [l = t.__e = n.__e]), (u = Vi.__b) && u(t);
  e: if (typeof T == "function") try {
    if (b = t.props, A = (u = T.contextType) && r[u.__c], w = u ? A ? A.props.value : u.__ : r, n.__c ? v = (f = t.__c = n.__c).__ = f.__E : ("prototype" in T && T.prototype.render ? t.__c = f = new T(b, w) : (t.__c = f = new $R(b, w), f.constructor = T, f.render = xAt), A && A.sub(f), f.props = b, f.state || (f.state = {}), f.context = w, f.__n = r, d = f.__d = !0, f.__h = [], f._sb = []), f.__s == null && (f.__s = f.state), T.getDerivedStateFromProps != null && (f.__s == f.state && (f.__s = Rm({}, f.__s)), Rm(f.__s, T.getDerivedStateFromProps(b, f.__s))), p = f.props, h = f.state, f.__v = t, d) T.getDerivedStateFromProps == null && f.componentWillMount != null && f.componentWillMount(), f.componentDidMount != null && f.__h.push(f.componentDidMount);
    else {
      if (T.getDerivedStateFromProps == null && b !== p && f.componentWillReceiveProps != null && f.componentWillReceiveProps(b, w), !f.__e && (f.shouldComponentUpdate != null && f.shouldComponentUpdate(b, f.__s, w) === !1 || t.__v === n.__v)) {
        for (t.__v !== n.__v && (f.props = b, f.state = f.__s, f.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function(R) {
          R && (R.__ = t);
        }), O = 0; O < f._sb.length; O++) f.__h.push(f._sb[O]);
        f._sb = [], f.__h.length && s.push(f);
        break e;
      }
      f.componentWillUpdate != null && f.componentWillUpdate(b, f.__s, w), f.componentDidUpdate != null && f.__h.push(function() {
        f.componentDidUpdate(p, h, m);
      });
    }
    if (f.context = w, f.props = b, f.__P = e, f.__e = !1, x = Vi.__r, S = 0, "prototype" in T && T.prototype.render) {
      for (f.state = f.__s, f.__d = !1, x && x(t), u = f.render(f.props, f.state, f.context), E = 0; E < f._sb.length; E++) f.__h.push(f._sb[E]);
      f._sb = [];
    } else do
      f.__d = !1, x && x(t), u = f.render(f.props, f.state, f.context), f.state = f.__s;
    while (f.__d && ++S < 25);
    f.state = f.__s, f.getChildContext != null && (r = Rm(Rm({}, r), f.getChildContext())), d || f.getSnapshotBeforeUpdate == null || (m = f.getSnapshotBeforeUpdate(p, h)), MCe(e, P$(k = u != null && u.type === I$ && u.key == null ? u.props.children : u) ? k : [k], t, n, r, i, o, s, l, c, a), f.base = t.__e, t.__u &= -161, f.__h.length && s.push(f), v && (f.__E = f.__ = null);
  } catch (R) {
    t.__v = null, c || o != null ? (t.__e = l, t.__u |= c ? 160 : 32, o[o.indexOf(l)] = null) : (t.__e = n.__e, t.__k = n.__k), Vi.__e(R, t, n);
  }
  else o == null && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = wAt(n.__e, t, n, r, i, o, s, c, a);
  (u = Vi.diffed) && u(t);
}
function AAt(e, t, n) {
  t.__d = void 0;
  for (var r = 0; r < n.length; r++) R$(n[r], n[++r], n[++r]);
  Vi.__c && Vi.__c(t, e), e.some(function(i) {
    try {
      e = i.__h, i.__h = [], e.some(function(o) {
        o.call(i);
      });
    } catch (o) {
      Vi.__e(o, i.__v);
    }
  });
}
function wAt(e, t, n, r, i, o, s, l, c) {
  var a, u, f, d, p, h, m, v = n.props, b = t.props, A = t.type;
  if (A === "svg" && (i = !0), o != null) {
    for (a = 0; a < o.length; a++) if ((p = o[a]) && "setAttribute" in p == !!A && (A ? p.localName === A : p.nodeType === 3)) {
      e = p, o[a] = null;
      break;
    }
  }
  if (e == null) {
    if (A === null) return document.createTextNode(b);
    e = i ? document.createElementNS("http://www.w3.org/2000/svg", A) : document.createElement(A, b.is && b), o = null, l = !1;
  }
  if (A === null) v === b || l && e.data === b || (e.data = b);
  else {
    if (o = o && TCe.call(e.childNodes), v = n.props || xX, !l && o != null) for (v = {}, a = 0; a < e.attributes.length; a++) v[(p = e.attributes[a]).name] = p.value;
    for (a in v) p = v[a], a == "children" || (a == "dangerouslySetInnerHTML" ? f = p : a === "key" || a in b || ZP(e, a, null, p, i));
    for (a in b) p = b[a], a == "children" ? d = p : a == "dangerouslySetInnerHTML" ? u = p : a == "value" ? h = p : a == "checked" ? m = p : a === "key" || l && typeof p != "function" || v[a] === p || ZP(e, a, p, v[a], i);
    if (u) l || f && (u.__html === f.__html || u.__html === e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
    else if (f && (e.innerHTML = ""), MCe(e, P$(d) ? d : [d], t, n, r, i && A !== "foreignObject", o, s, o ? o[0] : n.__k && fw(n, 0), l, c), o != null) for (a = o.length; a--; ) o[a] != null && ICe(o[a]);
    l || (a = "value", h !== void 0 && (h !== e[a] || A === "progress" && !h || A === "option" && h !== v[a]) && ZP(e, a, h, v[a], !1), a = "checked", m !== void 0 && m !== e[a] && ZP(e, a, m, v[a], !1));
  }
  return e;
}
function R$(e, t, n) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (r) {
    Vi.__e(r, n);
  }
}
function EX(e, t, n) {
  var r, i;
  if (Vi.unmount && Vi.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || R$(r, null, t)), (r = e.__c) != null) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (o) {
      Vi.__e(o, t);
    }
    r.base = r.__P = null, e.__c = void 0;
  }
  if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && EX(r[i], t, n || typeof e.type != "function");
  n || e.__e == null || ICe(e.__e), e.__ = e.__e = e.__d = void 0;
}
function xAt(e, t, n) {
  return this.constructor(e, n);
}
TCe = PCe.slice, Vi = { __e: function(e, t, n, r) {
  for (var i, o, s; t = t.__; ) if ((i = t.__c) && !i.__) try {
    if ((o = i.constructor) && o.getDerivedStateFromError != null && (i.setState(o.getDerivedStateFromError(e)), s = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), s = i.__d), s) return i.__E = i;
  } catch (l) {
    e = l;
  }
  throw e;
} }, kCe = 0, $R.prototype.setState = function(e, t) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Rm({}, this.state), typeof e == "function" && (e = e(Rm({}, n), this.props)), e && Rm(n, e), e != null && this.__v && (t && this._sb.push(t), SX(this));
}, $R.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), SX(this));
}, $R.prototype.render = I$, yy = [], CCe = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, wX = function(e, t) {
  return e.__v.__b - t.__v.__b;
}, XD.__r = 0, NCe = 0;
(function(e, t) {
  var n = { __c: t = "__cC" + NCe++, __: e, Consumer: function(r, i) {
    return r.children(i);
  }, Provider: function(r) {
    var i, o;
    return this.getChildContext || (i = [], (o = {})[t] = this, this.getChildContext = function() {
      return o;
    }, this.shouldComponentUpdate = function(s) {
      this.props.value !== s.value && i.some(function(l) {
        l.__e = !0, SX(l);
      });
    }, this.sub = function(s) {
      i.push(s);
      var l = s.componentWillUnmount;
      s.componentWillUnmount = function() {
        i.splice(i.indexOf(s), 1), l && l.call(s);
      };
    }), r.children;
  } };
  n.Provider.__ = n.Consumer.contextType = n;
})({ isPreviewMode: !1, previewPageIndex: 0, handleCloseSurveyPopup: () => {
}, isPopup: !0 });
var aS = Va("[Surveys]"), SAt = { icontains: (e) => !!Be && Be.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1, not_icontains: (e) => !!Be && Be.location.href.toLowerCase().indexOf(e.toLowerCase()) === -1, regex: (e) => !!Be && lw(Be.location.href, e), not_regex: (e) => !!Be && !lw(Be.location.href, e), exact: (e) => (Be == null ? void 0 : Be.location.href) === e, is_not: (e) => (Be == null ? void 0 : Be.location.href) !== e };
let EAt = class {
  constructor(t) {
    this.instance = t, this._surveyEventReceiver = null;
  }
  onRemoteConfig(t) {
    this._decideServerResponse = !!t.surveys, this.loadIfEnabled();
  }
  reset() {
    localStorage.removeItem("lastSeenSurveyDate");
    var t = (() => {
      for (var n = [], r = 0; r < localStorage.length; r++) {
        var i = localStorage.key(r);
        i != null && i.startsWith("seenSurvey_") && n.push(i);
      }
      return n;
    })();
    t.forEach((n) => localStorage.removeItem(n));
  }
  loadIfEnabled() {
    var t, n, r, i = Tn == null || (t = Tn.__PosthogExtensions__) === null || t === void 0 ? void 0 : t.generateSurveys;
    this.instance.config.disable_surveys || !this._decideServerResponse || i || (this._surveyEventReceiver == null && (this._surveyEventReceiver = new QT(this.instance)), (n = Tn.__PosthogExtensions__) === null || n === void 0 || (r = n.loadExternalDependency) === null || r === void 0 || r.call(n, this.instance, "surveys", (o) => {
      var s, l;
      if (o) return aS.error("Could not load surveys script", o);
      this._surveyManager = (s = Tn.__PosthogExtensions__) === null || s === void 0 || (l = s.generateSurveys) === null || l === void 0 ? void 0 : l.call(s, this.instance);
    }));
  }
  getSurveys(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    if (this.instance.config.disable_surveys) return t([]);
    this._surveyEventReceiver == null && (this._surveyEventReceiver = new QT(this.instance));
    var r = this.instance.get_property(iX);
    if (r && !n) return t(r);
    this.instance._send_request({ url: this.instance.requestRouter.endpointFor("api", "/api/surveys/?token=".concat(this.instance.config.token)), method: "GET", transport: "XHR", callback: (i) => {
      var o;
      if (i.statusCode !== 200 || !i.json) return t([]);
      var s, l = i.json.surveys || [], c = l.filter((a) => {
        var u, f, d, p, h, m, v, b, A, w, O, x;
        return ((u = a.conditions) === null || u === void 0 ? void 0 : u.events) && ((f = a.conditions) === null || f === void 0 || (d = f.events) === null || d === void 0 ? void 0 : d.values) && ((p = a.conditions) === null || p === void 0 || (h = p.events) === null || h === void 0 || (m = h.values) === null || m === void 0 ? void 0 : m.length) > 0 || ((v = a.conditions) === null || v === void 0 ? void 0 : v.actions) && ((b = a.conditions) === null || b === void 0 || (A = b.actions) === null || A === void 0 ? void 0 : A.values) && ((w = a.conditions) === null || w === void 0 || (O = w.actions) === null || O === void 0 || (x = O.values) === null || x === void 0 ? void 0 : x.length) > 0;
      });
      return c.length > 0 && ((s = this._surveyEventReceiver) === null || s === void 0 || s.register(c)), (o = this.instance.persistence) === null || o === void 0 || o.register({ [iX]: l }), t(l);
    } });
  }
  getActiveMatchingSurveys(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    this.getSurveys((r) => {
      var i, o = r.filter((c) => !(!c.start_date || c.end_date)).filter((c) => {
        var a, u, f, d;
        if (!c.conditions) return !0;
        var p = (a = c.conditions) === null || a === void 0 || !a.url || SAt[(u = (f = c.conditions) === null || f === void 0 ? void 0 : f.urlMatchType) !== null && u !== void 0 ? u : "icontains"](c.conditions.url), h = (d = c.conditions) === null || d === void 0 || !d.selector || (Wt == null ? void 0 : Wt.querySelector(c.conditions.selector));
        return p && h;
      }), s = (i = this._surveyEventReceiver) === null || i === void 0 ? void 0 : i.getSurveys(), l = o.filter((c) => {
        var a, u, f, d, p, h, m, v, b, A, w;
        if (!(c.linked_flag_key || c.targeting_flag_key || c.internal_targeting_flag_key || (a = c.feature_flag_keys) !== null && a !== void 0 && a.length)) return !0;
        var O = !c.linked_flag_key || this.instance.featureFlags.isFeatureEnabled(c.linked_flag_key), x = !c.targeting_flag_key || this.instance.featureFlags.isFeatureEnabled(c.targeting_flag_key), S = ((u = c.conditions) === null || u === void 0 ? void 0 : u.events) && ((f = c.conditions) === null || f === void 0 || (d = f.events) === null || d === void 0 ? void 0 : d.values) && ((p = c.conditions) === null || p === void 0 || (h = p.events) === null || h === void 0 ? void 0 : h.values.length) > 0, E = ((m = c.conditions) === null || m === void 0 ? void 0 : m.actions) && ((v = c.conditions) === null || v === void 0 || (b = v.actions) === null || b === void 0 ? void 0 : b.values) && ((A = c.conditions) === null || A === void 0 || (w = A.actions) === null || w === void 0 ? void 0 : w.values.length) > 0, k = !S && !E || (s == null ? void 0 : s.includes(c.id)), T = this._canActivateRepeatedly(c), R = !(c.internal_targeting_flag_key && !T) || this.instance.featureFlags.isFeatureEnabled(c.internal_targeting_flag_key), j = this.checkFlags(c);
        return O && x && R && k && j;
      });
      return t(l);
    }, n);
  }
  checkFlags(t) {
    var n;
    return (n = t.feature_flag_keys) === null || n === void 0 || !n.length || t.feature_flag_keys.every((r) => {
      var { key: i, value: o } = r;
      return !i || !o || this.instance.featureFlags.isFeatureEnabled(o);
    });
  }
  getNextSurveyStep(t, n, r) {
    var i, o = t.questions[n], s = n + 1;
    if ((i = o.branching) === null || i === void 0 || !i.type) return n === t.questions.length - 1 ? Eu.End : s;
    if (o.branching.type === Eu.End) return Eu.End;
    if (o.branching.type === Eu.SpecificQuestion) {
      if (Number.isInteger(o.branching.index)) return o.branching.index;
    } else if (o.branching.type === Eu.ResponseBased) {
      if (o.type === BD.SingleChoice) {
        var l, c, a = o.choices.indexOf("".concat(r));
        if ((l = o.branching) !== null && l !== void 0 && (c = l.responseValues) !== null && c !== void 0 && c.hasOwnProperty(a)) {
          var u = o.branching.responseValues[a];
          return Number.isInteger(u) ? u : u === Eu.End ? Eu.End : s;
        }
      } else if (o.type === BD.Rating) {
        var f, d;
        if (typeof r != "number" || !Number.isInteger(r)) throw new Error("The response type must be an integer");
        var p = function(m, v) {
          if (v === 3) {
            if (m < 1 || m > 3) throw new Error("The response must be in range 1-3");
            return m === 1 ? "negative" : m === 2 ? "neutral" : "positive";
          }
          if (v === 5) {
            if (m < 1 || m > 5) throw new Error("The response must be in range 1-5");
            return m <= 2 ? "negative" : m === 3 ? "neutral" : "positive";
          }
          if (v === 7) {
            if (m < 1 || m > 7) throw new Error("The response must be in range 1-7");
            return m <= 3 ? "negative" : m === 4 ? "neutral" : "positive";
          }
          if (v === 10) {
            if (m < 0 || m > 10) throw new Error("The response must be in range 0-10");
            return m <= 6 ? "detractors" : m <= 8 ? "passives" : "promoters";
          }
          throw new Error("The scale must be one of: 3, 5, 7, 10");
        }(r, o.scale);
        if ((f = o.branching) !== null && f !== void 0 && (d = f.responseValues) !== null && d !== void 0 && d.hasOwnProperty(p)) {
          var h = o.branching.responseValues[p];
          return Number.isInteger(h) ? h : h === Eu.End ? Eu.End : s;
        }
      }
      return s;
    }
    return aS.warn("Falling back to next question index due to unexpected branching type"), s;
  }
  _canActivateRepeatedly(t) {
    var n;
    return ei((n = Tn.__PosthogExtensions__) === null || n === void 0 ? void 0 : n.canActivateRepeatedly) ? (aS.warn("init was not called"), !1) : Tn.__PosthogExtensions__.canActivateRepeatedly(t);
  }
  canRenderSurvey(t) {
    ei(this._surveyManager) ? aS.warn("init was not called") : this.getSurveys((n) => {
      var r = n.filter((i) => i.id === t)[0];
      this._surveyManager.canRenderSurvey(r);
    });
  }
  renderSurvey(t, n) {
    ei(this._surveyManager) ? aS.warn("init was not called") : this.getSurveys((r) => {
      var i = r.filter((o) => o.id === t)[0];
      this._surveyManager.renderSurvey(i, Wt == null ? void 0 : Wt.querySelector(n));
    });
  }
};
var Mse = Va("[RateLimiter]");
class TAt {
  constructor(t) {
    var n, r;
    Vt(this, "serverLimits", {}), Vt(this, "lastEventRateLimited", !1), Vt(this, "checkForLimiting", (i) => {
      var o = i.text;
      if (o && o.length) try {
        (JSON.parse(o).quota_limited || []).forEach((s) => {
          Mse.info("".concat(s || "events", " is quota limited.")), this.serverLimits[s] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (s) {
        return void Mse.warn('could not rate limit - continuing. Error: "'.concat(s == null ? void 0 : s.message, '"'), { text: o });
      }
    }), this.instance = t, this.captureEventsPerSecond = ((n = t.config.rate_limiting) === null || n === void 0 ? void 0 : n.events_per_second) || 10, this.captureEventsBurstLimit = Math.max(((r = t.config.rate_limiting) === null || r === void 0 ? void 0 : r.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  clientRateLimitContext() {
    var t, n, r, i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], o = (/* @__PURE__ */ new Date()).getTime(), s = (t = (n = this.instance.persistence) === null || n === void 0 ? void 0 : n.get_property(sX)) !== null && t !== void 0 ? t : { tokens: this.captureEventsBurstLimit, last: o };
    s.tokens += (o - s.last) / 1e3 * this.captureEventsPerSecond, s.last = o, s.tokens > this.captureEventsBurstLimit && (s.tokens = this.captureEventsBurstLimit);
    var l = s.tokens < 1;
    return l || i || (s.tokens = Math.max(0, s.tokens - 1)), !l || this.lastEventRateLimited || i || this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to ".concat(this.captureEventsPerSecond, " events per second and ").concat(this.captureEventsBurstLimit, " events burst limit.") }, { skip_client_rate_limiting: !0 }), this.lastEventRateLimited = l, (r = this.instance.persistence) === null || r === void 0 || r.set_property(sX, s), { isRateLimited: l, remainingTokens: s.tokens };
  }
  isServerRateLimited(t) {
    var n = this.serverLimits[t || "events"] || !1;
    return n !== !1 && (/* @__PURE__ */ new Date()).getTime() < n;
  }
}
var kAt = () => bt({ initialPathName: (Ya == null ? void 0 : Ya.pathname) || "", referringDomain: zi.referringDomain() }, zi.campaignParams());
class CAt {
  constructor(t, n, r) {
    Vt(this, "_onSessionIdCallback", (i) => {
      var o = this._getStoredProps();
      if (!o || o.sessionId !== i) {
        var s = { sessionId: i, props: this._sessionSourceParamGenerator() };
        this._persistence.register({ [oX]: s });
      }
    }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = r || kAt, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
  }
  _getStoredProps() {
    return this._persistence.props[oX];
  }
  getSessionProps() {
    var t, n = (t = this._getStoredProps()) === null || t === void 0 ? void 0 : t.props;
    return n ? { $client_session_initial_referring_host: n.referringDomain, $client_session_initial_pathname: n.initialPathName, $client_session_initial_utm_source: n.utm_source, $client_session_initial_utm_campaign: n.utm_campaign, $client_session_initial_utm_medium: n.utm_medium, $client_session_initial_utm_content: n.utm_content, $client_session_initial_utm_term: n.utm_term } : {};
  }
}
var NAt = ["ahrefsbot", "ahrefssiteaudit", "applebot", "baiduspider", "bingbot", "bingpreview", "bot.htm", "bot.php", "crawler", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "gptbot", "http://yandex.com/bots", "hubspot", "ia_archiver", "linkedinbot", "mj12bot", "msnbot", "nessus", "petalbot", "pinterest", "prerender", "rogerbot", "screaming frog", "semrushbot", "sitebulb", "slurp", "turnitin", "twitterbot", "vercelbot", "yahoo! slurp", "yandexbot", "headlesschrome", "cypress", "Google-HotelAdsVerifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleweblight", "mediapartners-google", "storebot-google", "Bytespider;"], Dse = function(e, t) {
  if (!e) return !1;
  var n = e.toLowerCase();
  return NAt.concat(t || []).some((r) => {
    var i = r.toLowerCase();
    return n.indexOf(i) !== -1;
  });
}, LCe = function(e, t) {
  if (!e) return !1;
  var n = e.userAgent;
  if (n && Dse(n, t)) return !0;
  try {
    var r = e == null ? void 0 : e.userAgentData;
    if (r != null && r.brands && r.brands.some((i) => Dse(i == null ? void 0 : i.brand, t))) return !0;
  } catch {
  }
  return !!e.webdriver;
};
class zCe {
  constructor() {
    this.clicks = [];
  }
  isRageClick(t, n, r) {
    var i = this.clicks[this.clicks.length - 1];
    if (i && Math.abs(t - i.x) + Math.abs(n - i.y) < 30 && r - i.timestamp < 1e3) {
      if (this.clicks.push({ x: t, y: n, timestamp: r }), this.clicks.length === 3) return !0;
    } else this.clicks = [{ x: t, y: n, timestamp: r }];
    return !1;
  }
}
var HP = Va("[Dead Clicks]"), PAt = () => !0, IAt = (e) => {
  var t, n = !((t = e.instance.persistence) === null || t === void 0 || !t.get_property(qke)), r = e.instance.config.capture_dead_clicks;
  return Ty(r) ? r : n;
};
class jCe {
  get lazyLoadedDeadClicksAutocapture() {
    return this._lazyLoadedDeadClicksAutocapture;
  }
  constructor(t, n, r) {
    this.instance = t, this.isEnabled = n, this.onCapture = r, this.startIfEnabled();
  }
  onRemoteConfig(t) {
    this.instance.persistence && this.instance.persistence.register({ [qke]: t == null ? void 0 : t.captureDeadClicks }), this.startIfEnabled();
  }
  startIfEnabled() {
    this.isEnabled(this) && this.loadScript(() => {
      this.start();
    });
  }
  loadScript(t) {
    var n, r, i;
    (n = Tn.__PosthogExtensions__) !== null && n !== void 0 && n.initDeadClicksAutocapture && t(), (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.loadExternalDependency) === null || i === void 0 || i.call(r, this.instance, "dead-clicks-autocapture", (o) => {
      o ? HP.error("failed to load script", o) : t();
    });
  }
  start() {
    var t;
    if (Wt) {
      if (!this._lazyLoadedDeadClicksAutocapture && (t = Tn.__PosthogExtensions__) !== null && t !== void 0 && t.initDeadClicksAutocapture) {
        var n = fo(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
        n.__onCapture = this.onCapture, this._lazyLoadedDeadClicksAutocapture = Tn.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, n), this._lazyLoadedDeadClicksAutocapture.start(Wt), HP.info("starting...");
      }
    } else HP.error("`document` not found. Cannot start.");
  }
  stop() {
    this._lazyLoadedDeadClicksAutocapture && (this._lazyLoadedDeadClicksAutocapture.stop(), this._lazyLoadedDeadClicksAutocapture = void 0, HP.info("stopping..."));
  }
}
var RAt = Va("[Heatmaps]");
class MAt {
  constructor(t) {
    var n;
    Vt(this, "rageclicks", new zCe()), Vt(this, "_enabledServerSide", !1), Vt(this, "_initialized", !1), Vt(this, "_flushInterval", null), this.instance = t, this._enabledServerSide = !((n = this.instance.persistence) === null || n === void 0 || !n.props[tX]), Be == null || Be.addEventListener("beforeunload", () => {
      this.flush();
    });
  }
  get flushIntervalMilliseconds() {
    var t = 5e3;
    return fo(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
  }
  get isEnabled() {
    return cn(this.instance.config.capture_heatmaps) ? cn(this.instance.config.enable_heatmaps) ? this._enabledServerSide : this.instance.config.enable_heatmaps : this.instance.config.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this._initialized) return;
      RAt.info("starting..."), this._setupListeners(), this._flushInterval = setInterval(this.flush.bind(this), this.flushIntervalMilliseconds);
    } else {
      var t, n;
      clearInterval((t = this._flushInterval) !== null && t !== void 0 ? t : void 0), (n = this.deadClicksCapture) === null || n === void 0 || n.stop(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(t) {
    var n = !!t.heatmaps;
    this.instance.persistence && this.instance.persistence.register({ [tX]: n }), this._enabledServerSide = n, this.startIfEnabled();
  }
  getAndClearBuffer() {
    var t = this.buffer;
    return this.buffer = void 0, t;
  }
  _onDeadClick(t) {
    this._onClick(t.originalEvent, "deadclick");
  }
  _setupListeners() {
    Be && Wt && (_p(Wt, "click", (t) => this._onClick(t || (Be == null ? void 0 : Be.event)), !1, !0), _p(Wt, "mousemove", (t) => this._onMouseMove(t || (Be == null ? void 0 : Be.event)), !1, !0), this.deadClicksCapture = new jCe(this.instance, PAt, this._onDeadClick.bind(this)), this.deadClicksCapture.startIfEnabled(), this._initialized = !0);
  }
  _getProperties(t, n) {
    var r = this.instance.scrollManager.scrollY(), i = this.instance.scrollManager.scrollX(), o = this.instance.scrollManager.scrollElement(), s = function(l, c, a) {
      for (var u = l; u && pj(u) && !Xm(u, "body"); ) {
        if (u === a) return !1;
        if (Yn(c, Be == null ? void 0 : Be.getComputedStyle(u).position)) return !0;
        u = uCe(u);
      }
      return !1;
    }(cCe(t), ["fixed", "sticky"], o);
    return { x: t.clientX + (s ? 0 : i), y: t.clientY + (s ? 0 : r), target_fixed: s, type: n };
  }
  _onClick(t) {
    var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "click";
    if (!fse(t.target)) {
      var i = this._getProperties(t, r);
      (n = this.rageclicks) !== null && n !== void 0 && n.isRageClick(t.clientX, t.clientY, (/* @__PURE__ */ new Date()).getTime()) && this._capture(bt(bt({}, i), {}, { type: "rageclick" })), this._capture(i);
    }
  }
  _onMouseMove(t) {
    fse(t.target) || (clearTimeout(this._mouseMoveTimeout), this._mouseMoveTimeout = setTimeout(() => {
      this._capture(this._getProperties(t, "mousemove"));
    }, 500));
  }
  _capture(t) {
    if (Be) {
      var n = Be.location.href;
      this.buffer = this.buffer || {}, this.buffer[n] || (this.buffer[n] = []), this.buffer[n].push(t);
    }
  }
  flush() {
    this.buffer && !wO(this.buffer) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}
class DAt {
  constructor(t) {
    Vt(this, "_updateScrollData", () => {
      var n, r, i, o;
      this.context || (this.context = {});
      var s = this.scrollElement(), l = this.scrollY(), c = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = l + ((s == null ? void 0 : s.clientHeight) || 0), u = (s == null ? void 0 : s.scrollHeight) || 0;
      this.context.lastScrollY = Math.ceil(l), this.context.maxScrollY = Math.max(l, (n = this.context.maxScrollY) !== null && n !== void 0 ? n : 0), this.context.maxScrollHeight = Math.max(c, (r = this.context.maxScrollHeight) !== null && r !== void 0 ? r : 0), this.context.lastContentY = a, this.context.maxContentY = Math.max(a, (i = this.context.maxContentY) !== null && i !== void 0 ? i : 0), this.context.maxContentHeight = Math.max(u, (o = this.context.maxContentHeight) !== null && o !== void 0 ? o : 0);
    }), this.instance = t;
  }
  getContext() {
    return this.context;
  }
  resetContext() {
    var t = this.context;
    return setTimeout(this._updateScrollData, 0), t;
  }
  startMeasuringScrollPosition() {
    Be == null || Be.addEventListener("scroll", this._updateScrollData, !0), Be == null || Be.addEventListener("scrollend", this._updateScrollData, !0), Be == null || Be.addEventListener("resize", this._updateScrollData);
  }
  scrollElement() {
    if (!this.instance.config.scroll_root_selector) return Be == null ? void 0 : Be.document.documentElement;
    var t = Qi(this.instance.config.scroll_root_selector) ? this.instance.config.scroll_root_selector : [this.instance.config.scroll_root_selector];
    for (var n of t) {
      var r = Be == null ? void 0 : Be.document.querySelector(n);
      if (r) return r;
    }
  }
  scrollY() {
    if (this.instance.config.scroll_root_selector) {
      var t = this.scrollElement();
      return t && t.scrollTop || 0;
    }
    return Be && (Be.scrollY || Be.pageYOffset || Be.document.documentElement.scrollTop) || 0;
  }
  scrollX() {
    if (this.instance.config.scroll_root_selector) {
      var t = this.scrollElement();
      return t && t.scrollLeft || 0;
    }
    return Be && (Be.scrollX || Be.pageXOffset || Be.document.documentElement.scrollLeft) || 0;
  }
}
var _se = Va("[AutoCapture]");
function F6(e, t) {
  return t.length > e ? t.slice(0, e) + "..." : t;
}
function _At(e) {
  if (e.previousElementSibling) return e.previousElementSibling;
  var t = e;
  do
    t = t.previousSibling;
  while (t && !pj(t));
  return t;
}
function LAt(e, t, n, r) {
  var i = e.tagName.toLowerCase(), o = { tag_name: i };
  hX.indexOf(i) > -1 && !n && (i.toLowerCase() === "a" || i.toLowerCase() === "button" ? o.$el_text = F6(1024, hCe(e)) : o.$el_text = F6(1024, hj(e)));
  var s = UD(e);
  s.length > 0 && (o.classes = s.filter(function(u) {
    return u !== "";
  })), Xr(e.attributes, function(u) {
    var f;
    if ((!dCe(e) || ["name", "id", "class", "aria-label"].indexOf(u.name) !== -1) && (r == null || !r.includes(u.name)) && !t && uw(u.value) && (f = u.name, !ws(f) || f.substring(0, 10) !== "_ngcontent" && f.substring(0, 7) !== "_nghost")) {
      var d = u.value;
      u.name === "class" && (d = k$(d).join(" ")), o["attr__" + u.name] = F6(1024, d);
    }
  });
  for (var l = 1, c = 1, a = e; a = _At(a); ) l++, a.tagName === e.tagName && c++;
  return o.nth_child = l, o.nth_of_type = c, o;
}
function zAt(e, t) {
  for (var n, r, { e: i, maskAllElementAttributes: o, maskAllText: s, elementAttributeIgnoreList: l, elementsChainAsString: c } = t, a = [e], u = e; u.parentNode && !Xm(u, "body"); ) aCe(u.parentNode) ? (a.push(u.parentNode.host), u = u.parentNode.host) : (a.push(u.parentNode), u = u.parentNode);
  var f, d = [], p = {}, h = !1, m = !1;
  if (Xr(a, (O) => {
    var x = mX(O);
    O.tagName.toLowerCase() === "a" && (h = O.getAttribute("href"), h = x && h && uw(h) && h), Yn(UD(O), "ph-no-capture") && (m = !0), d.push(LAt(O, o, s, l));
    var S = function(E) {
      if (!mX(E)) return {};
      var k = {};
      return Xr(E.attributes, function(T) {
        if (T.name && T.name.indexOf("data-ph-capture-attribute") === 0) {
          var R = T.name.replace("data-ph-capture-attribute-", ""), j = T.value;
          R && j && uw(j) && (k[R] = j);
        }
      }), k;
    }(O);
    Oa(p, S);
  }), m) return { props: {}, explicitNoCapture: m };
  if (s || (e.tagName.toLowerCase() === "a" || e.tagName.toLowerCase() === "button" ? d[0].$el_text = hCe(e) : d[0].$el_text = hj(e)), h) {
    var v, b;
    d[0].attr__href = h;
    var A = (v = HO(h)) === null || v === void 0 ? void 0 : v.host, w = Be == null || (b = Be.location) === null || b === void 0 ? void 0 : b.host;
    A && w && A !== w && (f = h);
  }
  return { props: Oa({ $event_type: i.type, $ce_version: 1 }, c ? {} : { $elements: d }, { $elements_chain: VOt(d) }, (n = d[0]) !== null && n !== void 0 && n.$el_text ? { $el_text: (r = d[0]) === null || r === void 0 ? void 0 : r.$el_text } : {}, f && i.type === "click" ? { $external_click_url: f } : {}, p) };
}
class jAt {
  constructor(t) {
    Vt(this, "_initialized", !1), Vt(this, "_isDisabledServerSide", null), Vt(this, "rageclicks", new zCe()), Vt(this, "_elementsChainAsString", !1), this.instance = t, this._elementSelectors = null;
  }
  get config() {
    var t, n, r = fo(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
    return r.url_allowlist = (t = r.url_allowlist) === null || t === void 0 ? void 0 : t.map((i) => new RegExp(i)), r.url_ignorelist = (n = r.url_ignorelist) === null || n === void 0 ? void 0 : n.map((i) => new RegExp(i)), r;
  }
  _addDomEventHandlers() {
    if (this.isBrowserSupported()) {
      if (Be && Wt) {
        var t = (r) => {
          r = r || (Be == null ? void 0 : Be.event);
          try {
            this._captureEvent(r);
          } catch (i) {
            _se.error("Failed to capture event", i);
          }
        }, n = (r) => {
          r = r || (Be == null ? void 0 : Be.event), this._captureEvent(r, C6);
        };
        _p(Wt, "submit", t, !1, !0), _p(Wt, "change", t, !1, !0), _p(Wt, "click", t, !1, !0), this.config.capture_copied_text && (_p(Wt, "copy", n, !1, !0), _p(Wt, "cut", n, !1, !0));
      }
    } else _se.info("Disabling Automatic Event Collection because this browser is not supported");
  }
  startIfEnabled() {
    this.isEnabled && !this._initialized && (this._addDomEventHandlers(), this._initialized = !0);
  }
  onRemoteConfig(t) {
    t.elementsChainAsString && (this._elementsChainAsString = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({ [Qoe]: !!t.autocapture_opt_out }), this._isDisabledServerSide = !!t.autocapture_opt_out, this.startIfEnabled();
  }
  setElementSelectors(t) {
    this._elementSelectors = t;
  }
  getElementSelectors(t) {
    var n, r = [];
    return (n = this._elementSelectors) === null || n === void 0 || n.forEach((i) => {
      var o = Wt == null ? void 0 : Wt.querySelectorAll(i);
      o == null || o.forEach((s) => {
        t === s && r.push(i);
      });
    }), r;
  }
  get isEnabled() {
    var t, n, r = (t = this.instance.persistence) === null || t === void 0 ? void 0 : t.props[Qoe], i = this._isDisabledServerSide;
    if (Pg(i) && !Ty(r) && !this.instance.config.advanced_disable_decide) return !1;
    var o = (n = this._isDisabledServerSide) !== null && n !== void 0 ? n : !!r;
    return !!this.instance.config.autocapture && !o;
  }
  _captureEvent(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "$autocapture";
    if (this.isEnabled) {
      var r, i = cCe(t);
      sCe(i) && (i = i.parentNode || null), n === "$autocapture" && t.type === "click" && t instanceof MouseEvent && this.instance.config.rageclick && (r = this.rageclicks) !== null && r !== void 0 && r.isRageClick(t.clientX, t.clientY, (/* @__PURE__ */ new Date()).getTime()) && this._captureEvent(t, "$rageclick");
      var o = n === C6;
      if (i && LOt(i, t, this.config, o, o ? ["copy", "cut"] : void 0)) {
        var { props: s, explicitNoCapture: l } = zAt(i, { e: t, maskAllElementAttributes: this.instance.config.mask_all_element_attributes, maskAllText: this.instance.config.mask_all_text, elementAttributeIgnoreList: this.config.element_attribute_ignorelist, elementsChainAsString: this._elementsChainAsString });
        if (l) return !1;
        var c = this.getElementSelectors(i);
        if (c && c.length > 0 && (s.$element_selectors = c), n === C6) {
          var a, u = lCe(Be == null || (a = Be.getSelection()) === null || a === void 0 ? void 0 : a.toString()), f = t.type || "clipboard";
          if (!u) return !1;
          s.$selected_content = u, s.$copy_type = f;
        }
        return this.instance.capture(n, s), !0;
      }
    }
  }
  isBrowserSupported() {
    return Xc(Wt == null ? void 0 : Wt.querySelectorAll);
  }
}
var FAt = Va("[TracingHeaders]");
class UAt {
  constructor(t) {
    Vt(this, "_restoreXHRPatch", void 0), Vt(this, "_restoreFetchPatch", void 0), Vt(this, "_startCapturing", () => {
      var n, r, i, o;
      cn(this._restoreXHRPatch) && ((n = Tn.__PosthogExtensions__) === null || n === void 0 || (r = n.tracingHeadersPatchFns) === null || r === void 0 || r._patchXHR(this.instance.sessionManager)), cn(this._restoreFetchPatch) && ((i = Tn.__PosthogExtensions__) === null || i === void 0 || (o = i.tracingHeadersPatchFns) === null || o === void 0 || o._patchFetch(this.instance.sessionManager));
    }), this.instance = t;
  }
  _loadScript(t) {
    var n, r, i;
    (n = Tn.__PosthogExtensions__) !== null && n !== void 0 && n.tracingHeadersPatchFns && t(), (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.loadExternalDependency) === null || i === void 0 || i.call(r, this.instance, "tracing-headers", (o) => {
      if (o) return FAt.error("failed to load script", o);
      t();
    });
  }
  startIfEnabledOrStop() {
    var t, n;
    this.instance.config.__add_tracing_headers ? this._loadScript(this._startCapturing) : ((t = this._restoreXHRPatch) === null || t === void 0 || t.call(this), (n = this._restoreFetchPatch) === null || n === void 0 || n.call(this), this._restoreXHRPatch = void 0, this._restoreFetchPatch = void 0);
  }
}
var Jh;
(function(e) {
  e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED";
})(Jh || (Jh = {}));
class VAt {
  constructor(t) {
    this.instance = t;
  }
  get config() {
    return this.instance.config;
  }
  get consent() {
    return this.getDnt() ? Jh.DENIED : this.storedConsent;
  }
  isOptedOut() {
    return this.consent === Jh.DENIED || this.consent === Jh.PENDING && this.config.opt_out_capturing_by_default;
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  optInOut(t) {
    this.storage.set(this.storageKey, t ? 1 : 0, this.config.cookie_expiration, this.config.cross_subdomain_cookie, this.config.secure_cookie);
  }
  reset() {
    this.storage.remove(this.storageKey, this.config.cross_subdomain_cookie);
  }
  get storageKey() {
    var { token: t, opt_out_capturing_cookie_prefix: n } = this.instance.config;
    return (n || "__ph_opt_in_out_") + t;
  }
  get storedConsent() {
    var t = this.storage.get(this.storageKey);
    return t === "1" ? Jh.GRANTED : t === "0" ? Jh.DENIED : Jh.PENDING;
  }
  get storage() {
    if (!this._storage) {
      var t = this.config.opt_out_capturing_persistence_type;
      this._storage = t === "localStorage" ? Io : Jp;
      var n = t === "localStorage" ? Jp : Io;
      n.get(this.storageKey) && (this._storage.get(this.storageKey) || this.optInOut(n.get(this.storageKey) === "1"), n.remove(this.storageKey, this.config.cross_subdomain_cookie));
    }
    return this._storage;
  }
  getDnt() {
    return !!this.config.respect_dnt && !!Lke([Jl == null ? void 0 : Jl.doNotTrack, Jl == null ? void 0 : Jl.msDoNotTrack, Tn.doNotTrack], (t) => Yn([!0, 1, "1", "yes"], t));
  }
}
var QP = Va("[ExceptionAutocapture]");
class qAt {
  constructor(t) {
    var n;
    Vt(this, "originalOnUnhandledRejectionHandler", void 0), Vt(this, "startCapturing", () => {
      var r, i, o, s;
      if (Be && this.isEnabled && !this.hasHandlers && !this.isCapturing) {
        var l = (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.errorWrappingFunctions) === null || i === void 0 ? void 0 : i.wrapOnError, c = (o = Tn.__PosthogExtensions__) === null || o === void 0 || (s = o.errorWrappingFunctions) === null || s === void 0 ? void 0 : s.wrapUnhandledRejection;
        if (l && c) try {
          this.unwrapOnError = l(this.captureException.bind(this)), this.unwrapUnhandledRejection = c(this.captureException.bind(this));
        } catch (a) {
          QP.error("failed to start", a), this.stopCapturing();
        }
        else QP.error("failed to load error wrapping functions - cannot start");
      }
    }), this.instance = t, this.remoteEnabled = !((n = this.instance.persistence) === null || n === void 0 || !n.props[$oe]), this.startIfEnabled();
  }
  get isEnabled() {
    var t;
    return (t = this.remoteEnabled) !== null && t !== void 0 && t;
  }
  get isCapturing() {
    var t;
    return !(Be == null || (t = Be.onerror) === null || t === void 0 || !t.__POSTHOG_INSTRUMENTED__);
  }
  get hasHandlers() {
    return this.originalOnUnhandledRejectionHandler || this.unwrapOnError;
  }
  startIfEnabled() {
    this.isEnabled && !this.isCapturing && (QP.info("enabled, starting..."), this.loadScript(this.startCapturing));
  }
  loadScript(t) {
    var n, r;
    this.hasHandlers && t(), (n = Tn.__PosthogExtensions__) === null || n === void 0 || (r = n.loadExternalDependency) === null || r === void 0 || r.call(n, this.instance, "exception-autocapture", (i) => {
      if (i) return QP.error("failed to load script", i);
      t();
    });
  }
  stopCapturing() {
    var t, n;
    (t = this.unwrapOnError) === null || t === void 0 || t.call(this), (n = this.unwrapUnhandledRejection) === null || n === void 0 || n.call(this);
  }
  onRemoteConfig(t) {
    var n = t.autocaptureExceptions;
    this.remoteEnabled = !!n || !1, this.instance.persistence && this.instance.persistence.register({ [$oe]: this.remoteEnabled }), this.startIfEnabled();
  }
  captureException(t) {
    var n = this.instance.requestRouter.endpointFor("ui");
    t.$exception_personURL = "".concat(n, "/project/").concat(this.instance.config.token, "/person/").concat(this.instance.get_distinct_id()), this.instance.exceptions.sendExceptionEvent(t);
  }
}
var ey = Va("[Web Vitals]"), Lse = 9e5;
class BAt {
  constructor(t) {
    var n;
    Vt(this, "_enabledServerSide", !1), Vt(this, "_initialized", !1), Vt(this, "buffer", { url: void 0, metrics: [], firstMetricTimestamp: void 0 }), Vt(this, "_flushToCapture", () => {
      clearTimeout(this._delayedFlushTimer), this.buffer.metrics.length !== 0 && (this.instance.capture("$web_vitals", this.buffer.metrics.reduce((r, i) => bt(bt({}, r), {}, { ["$web_vitals_".concat(i.name, "_event")]: bt({}, i), ["$web_vitals_".concat(i.name, "_value")]: i.value }), {})), this.buffer = { url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }), Vt(this, "_addToBuffer", (r) => {
      var i, o = (i = this.instance.sessionManager) === null || i === void 0 ? void 0 : i.checkAndGetSessionAndWindowId(!0);
      if (cn(o)) ey.error("Could not read session ID. Dropping metrics!");
      else {
        this.buffer = this.buffer || { url: void 0, metrics: [], firstMetricTimestamp: void 0 };
        var s = this._currentURL();
        cn(s) || (ei(r == null ? void 0 : r.name) || ei(r == null ? void 0 : r.value) ? ey.error("Invalid metric received", r) : this._maxAllowedValue && r.value >= this._maxAllowedValue ? ey.error("Ignoring metric with value >= " + this._maxAllowedValue, r) : (this.buffer.url !== s && (this._flushToCapture(), this._delayedFlushTimer = setTimeout(this._flushToCapture, this.flushToCaptureTimeoutMs)), cn(this.buffer.url) && (this.buffer.url = s), this.buffer.firstMetricTimestamp = cn(this.buffer.firstMetricTimestamp) ? Date.now() : this.buffer.firstMetricTimestamp, r.attribution && r.attribution.interactionTargetElement && (r.attribution.interactionTargetElement = void 0), this.buffer.metrics.push(bt(bt({}, r), {}, { $current_url: s, $session_id: o.sessionId, $window_id: o.windowId, timestamp: Date.now() })), this.buffer.metrics.length === this.allowedMetrics.length && this._flushToCapture()));
      }
    }), Vt(this, "_startCapturing", () => {
      var r, i, o, s, l = Tn.__PosthogExtensions__;
      cn(l) || cn(l.postHogWebVitalsCallbacks) || ({ onLCP: r, onCLS: i, onFCP: o, onINP: s } = l.postHogWebVitalsCallbacks), r && i && o && s ? (this.allowedMetrics.indexOf("LCP") > -1 && r(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && o(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && s(this._addToBuffer.bind(this)), this._initialized = !0) : ey.error("web vitals callbacks not loaded - not starting");
    }), this.instance = t, this._enabledServerSide = !((n = this.instance.persistence) === null || n === void 0 || !n.props[Koe]), this.startIfEnabled();
  }
  get allowedMetrics() {
    var t, n, r = fo(this.instance.config.capture_performance) ? (t = this.instance.config.capture_performance) === null || t === void 0 ? void 0 : t.web_vitals_allowed_metrics : void 0;
    return cn(r) ? ((n = this.instance.persistence) === null || n === void 0 ? void 0 : n.props[Goe]) || ["CLS", "FCP", "INP", "LCP"] : r;
  }
  get flushToCaptureTimeoutMs() {
    return (fo(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get _maxAllowedValue() {
    var t = fo(this.instance.config.capture_performance) && Zl(this.instance.config.capture_performance.__web_vitals_max_value) ? this.instance.config.capture_performance.__web_vitals_max_value : Lse;
    return 0 < t && t <= 6e4 ? Lse : t;
  }
  get isEnabled() {
    var t = fo(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals : void 0;
    return Ty(t) ? t : this._enabledServerSide;
  }
  startIfEnabled() {
    this.isEnabled && !this._initialized && (ey.info("enabled, starting..."), this.loadScript(this._startCapturing));
  }
  onRemoteConfig(t) {
    var n = fo(t.capturePerformance) && !!t.capturePerformance.web_vitals, r = fo(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
    this.instance.persistence && (this.instance.persistence.register({ [Koe]: n }), this.instance.persistence.register({ [Goe]: r })), this._enabledServerSide = n, this.startIfEnabled();
  }
  loadScript(t) {
    var n, r, i;
    (n = Tn.__PosthogExtensions__) !== null && n !== void 0 && n.postHogWebVitalsCallbacks && t(), (r = Tn.__PosthogExtensions__) === null || r === void 0 || (i = r.loadExternalDependency) === null || i === void 0 || i.call(r, this.instance, "web-vitals", (o) => {
      o ? ey.error("failed to load script", o) : t();
    });
  }
  _currentURL() {
    var t = Be ? Be.location.href : void 0;
    return t || ey.error("Could not determine current URL"), t;
  }
}
var XAt = { icontains: (e, t) => !!Be && t.href.toLowerCase().indexOf(e.toLowerCase()) > -1, not_icontains: (e, t) => !!Be && t.href.toLowerCase().indexOf(e.toLowerCase()) === -1, regex: (e, t) => !!Be && lw(t.href, e), not_regex: (e, t) => !!Be && !lw(t.href, e), exact: (e, t) => t.href === e, is_not: (e, t) => t.href !== e };
class Wo {
  constructor(t) {
    var n = this;
    Vt(this, "getWebExperimentsAndEvaluateDisplayLogic", function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      n.getWebExperiments((i) => {
        Wo.logInfo("retrieved web experiments from the server"), n._flagToExperiments = /* @__PURE__ */ new Map(), i.forEach((o) => {
          if (o.feature_flag_key) {
            var s;
            n._flagToExperiments && (Wo.logInfo("setting flag key ", o.feature_flag_key, " to web experiment ", o), (s = n._flagToExperiments) === null || s === void 0 || s.set(o.feature_flag_key, o));
            var l = n.instance.getFeatureFlag(o.feature_flag_key);
            ws(l) && o.variants[l] && n.applyTransforms(o.name, l, o.variants[l].transforms);
          } else if (o.variants) for (var c in o.variants) {
            var a = o.variants[c];
            Wo.matchesTestVariant(a) && n.applyTransforms(o.name, c, a.transforms);
          }
        });
      }, r);
    }), this.instance = t, this.instance.onFeatureFlags((r) => {
      this.onFeatureFlags(r);
    });
  }
  onFeatureFlags(t) {
    if (this._is_bot()) Wo.logInfo("Refusing to render web experiment since the viewer is a likely bot");
    else if (!this.instance.config.disable_web_experiments) {
      if (ei(this._flagToExperiments)) return this._flagToExperiments = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      Wo.logInfo("applying feature flags", t), t.forEach((n) => {
        var r;
        if (this._flagToExperiments && (r = this._flagToExperiments) !== null && r !== void 0 && r.has(n)) {
          var i, o = this.instance.getFeatureFlag(n), s = (i = this._flagToExperiments) === null || i === void 0 ? void 0 : i.get(n);
          o && s != null && s.variants[o] && this.applyTransforms(s.name, o, s.variants[o].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    var t = Wo.getWindowLocation();
    if (t != null && t.search) {
      var n = LD(t == null ? void 0 : t.search, "__experiment_id"), r = LD(t == null ? void 0 : t.search, "__experiment_variant");
      n && r && (Wo.logInfo("previewing web experiments ".concat(n, " && ").concat(r)), this.getWebExperiments((i) => {
        this.showPreviewWebExperiment(parseInt(n), r, i);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this.instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(t, n, r) {
    if (this.instance.config.disable_web_experiments && !r) return t([]);
    var i = this.instance.get_property("$web_experiments");
    if (i && !n) return t(i);
    this.instance._send_request({ url: this.instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=".concat(this.instance.config.token)), method: "GET", transport: "XHR", callback: (o) => {
      if (o.statusCode !== 200 || !o.json) return t([]);
      var s = o.json.experiments || [];
      return t(s);
    } });
  }
  showPreviewWebExperiment(t, n, r) {
    var i = r.filter((o) => o.id === t);
    i && i.length > 0 && (Wo.logInfo("Previewing web experiment [".concat(i[0].name, "] with variant [").concat(n, "]")), this.applyTransforms(i[0].name, n, i[0].variants[n].transforms, !0));
  }
  static matchesTestVariant(t) {
    return !ei(t.conditions) && Wo.matchUrlConditions(t) && Wo.matchUTMConditions(t);
  }
  static matchUrlConditions(t) {
    var n;
    if (ei(t.conditions) || ei((n = t.conditions) === null || n === void 0 ? void 0 : n.url)) return !0;
    var r, i, o, s = Wo.getWindowLocation();
    return !!s && ((r = t.conditions) === null || r === void 0 || !r.url || XAt[(i = (o = t.conditions) === null || o === void 0 ? void 0 : o.urlMatchType) !== null && i !== void 0 ? i : "icontains"](t.conditions.url, s));
  }
  static getWindowLocation() {
    return Be == null ? void 0 : Be.location;
  }
  static matchUTMConditions(t) {
    var n;
    if (ei(t.conditions) || ei((n = t.conditions) === null || n === void 0 ? void 0 : n.utm)) return !0;
    var r = zi.campaignParams();
    if (r.utm_source) {
      var i, o, s, l, c, a, u, f, d, p, h, m, v, b, A, w, O = (i = t.conditions) === null || i === void 0 || (o = i.utm) === null || o === void 0 || !o.utm_campaign || ((s = t.conditions) === null || s === void 0 || (l = s.utm) === null || l === void 0 ? void 0 : l.utm_campaign) == r.utm_campaign, x = (c = t.conditions) === null || c === void 0 || (a = c.utm) === null || a === void 0 || !a.utm_source || ((u = t.conditions) === null || u === void 0 || (f = u.utm) === null || f === void 0 ? void 0 : f.utm_source) == r.utm_source, S = (d = t.conditions) === null || d === void 0 || (p = d.utm) === null || p === void 0 || !p.utm_medium || ((h = t.conditions) === null || h === void 0 || (m = h.utm) === null || m === void 0 ? void 0 : m.utm_medium) == r.utm_medium, E = (v = t.conditions) === null || v === void 0 || (b = v.utm) === null || b === void 0 || !b.utm_term || ((A = t.conditions) === null || A === void 0 || (w = A.utm) === null || w === void 0 ? void 0 : w.utm_term) == r.utm_term;
      return O && S && E && x;
    }
    return !1;
  }
  static logInfo(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
    un.info("[WebExperiments] ".concat(t), r);
  }
  applyTransforms(t, n, r, i) {
    var o;
    this._is_bot() ? Wo.logInfo("Refusing to render web experiment since the viewer is a likely bot") : n !== "control" ? r.forEach((s) => {
      if (s.selector) {
        var l;
        Wo.logInfo("applying transform of variant ".concat(n, " for experiment ").concat(t, " "), s);
        var c, a = 0, u = (l = document) === null || l === void 0 ? void 0 : l.querySelectorAll(s.selector);
        u == null || u.forEach((f) => {
          var d = f;
          a += 1, s.attributes && s.attributes.forEach((p) => {
            switch (p.name) {
              case "text":
                d.innerText = p.value;
                break;
              case "html":
                d.innerHTML = p.value;
                break;
              case "cssClass":
                d.className = p.value;
                break;
              default:
                d.setAttribute(p.name, p.value);
            }
          }), s.text && (d.innerText = s.text), s.html && (d.parentElement ? d.parentElement.innerHTML = s.html : d.innerHTML = s.html), s.css && d.setAttribute("style", s.css);
        }), this.instance && this.instance.capture && this.instance.capture("$web_experiment_applied", { $web_experiment_name: t, $web_experiment_variant: n, $web_experiment_preview: i, $web_experiment_document_url: (c = Wo.getWindowLocation()) === null || c === void 0 ? void 0 : c.href, $web_experiment_elements_modified: a });
      }
    }) : (Wo.logInfo("Control variants leave the page unmodified."), this.instance && this.instance.capture && this.instance.capture("$web_experiment_applied", { $web_experiment_name: t, $web_experiment_preview: i, $web_experiment_variant: n, $web_experiment_document_url: (o = Wo.getWindowLocation()) === null || o === void 0 ? void 0 : o.href, $web_experiment_elements_modified: 0 }));
  }
  _is_bot() {
    return Jl && this.instance ? LCe(Jl, this.instance.config.custom_blocked_useragents) : void 0;
  }
}
class WAt {
  constructor(t) {
    this.instance = t;
  }
  sendExceptionEvent(t) {
    this.instance.capture("$exception", t, { _noTruncate: !0, _batchKey: "exceptionEvent" });
  }
}
var ZAt = ["$set_once", "$set"], ty = Va("[SiteApps]");
let HAt = class {
  constructor(t) {
    this.instance = t, this.bufferedInvocations = [], this.apps = {};
  }
  get isEnabled() {
    return !!this.instance.config.opt_in_site_apps;
  }
  eventCollector(t, n) {
    if (n) {
      var r = this.globalsForEvent(n);
      this.bufferedInvocations.push(r), this.bufferedInvocations.length > 1e3 && (this.bufferedInvocations = this.bufferedInvocations.slice(10));
    }
  }
  init() {
    if (this.isEnabled) {
      var t = this.instance._addCaptureHook(this.eventCollector.bind(this));
      this.stopBuffering = () => {
        t(), this.bufferedInvocations = [], this.stopBuffering = void 0;
      };
    }
  }
  globalsForEvent(t) {
    var n, r, i, o, s, l, c;
    if (!t) throw new Error("Event payload is required");
    var a = {}, u = this.instance.get_property("$groups") || [], f = this.instance.get_property("$stored_group_properties") || {};
    for (var [d, p] of Object.entries(f)) a[d] = { id: u[d], type: d, properties: p };
    var { $set_once: h, $set: m } = t;
    return { event: bt(bt({}, Uke(t, ZAt)), {}, { properties: bt(bt(bt({}, t.properties), m ? { $set: bt(bt({}, (n = (r = t.properties) === null || r === void 0 ? void 0 : r.$set) !== null && n !== void 0 ? n : {}), m) } : {}), h ? { $set_once: bt(bt({}, (i = (o = t.properties) === null || o === void 0 ? void 0 : o.$set_once) !== null && i !== void 0 ? i : {}), h) } : {}), elements_chain: (s = (l = t.properties) === null || l === void 0 ? void 0 : l.$elements_chain) !== null && s !== void 0 ? s : "", distinct_id: (c = t.properties) === null || c === void 0 ? void 0 : c.distinct_id }), person: { properties: this.instance.get_property("$stored_person_properties") }, groups: a };
  }
  setupSiteApp(t) {
    var n = { id: t.id, loaded: !1, errored: !1 };
    this.apps[t.id] = n;
    var r = (o) => {
      var s;
      for (var l of (this.apps[t.id].errored = !o, this.apps[t.id].loaded = !0, ty.info("Site app with id ".concat(t.id, " ").concat(o ? "loaded" : "errored")), o && this.bufferedInvocations.length && (ty.info("Processing ".concat(this.bufferedInvocations.length, " events for site app with id ").concat(t.id)), this.bufferedInvocations.forEach((c) => {
        var a;
        return (a = n.processEvent) === null || a === void 0 ? void 0 : a.call(n, c);
      })), Object.values(this.apps))) if (!l.loaded) return;
      (s = this.stopBuffering) === null || s === void 0 || s.call(this);
    };
    try {
      var { processEvent: i } = t.init({ posthog: this.instance, callback: (o) => {
        r(o);
      } });
      i && (n.processEvent = i);
    } catch (o) {
      ty.error("Error while initializing PostHog app with config id ".concat(t.id), o), r(!1);
    }
  }
  onCapturedEvent(t) {
    if (Object.keys(this.apps).length !== 0) {
      var n = this.globalsForEvent(t);
      for (var r of Object.values(this.apps)) try {
        var i;
        (i = r.processEvent) === null || i === void 0 || i.call(r, n);
      } catch (o) {
        ty.error("Error while processing event ".concat(t.event, " for site app ").concat(r.id), o);
      }
    }
  }
  onRemoteConfig(t) {
    var n, r, i = this;
    if (Qi(Tn._POSTHOG_JS_APPS)) {
      if (!this.isEnabled) return void ty.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
      for (var o of Tn._POSTHOG_JS_APPS) this.setupSiteApp(o);
      var s;
      Tn._POSTHOG_JS_APPS.length ? this.instance.on("eventCaptured", (u) => this.onCapturedEvent(u)) : (s = this.stopBuffering) === null || s === void 0 || s.call(this);
    } else if ((n = this.stopBuffering) === null || n === void 0 || n.call(this), (r = t.siteApps) !== null && r !== void 0 && r.length) if (this.isEnabled) {
      var l = function(u, f) {
        var d, p;
        Tn["__$$ph_site_app_".concat(u)] = i.instance, (d = Tn.__PosthogExtensions__) === null || d === void 0 || (p = d.loadSiteApp) === null || p === void 0 || p.call(d, i.instance, f, (h) => {
          if (h) return ty.error("Error while initializing PostHog app with config id ".concat(u), h);
        });
      };
      for (var { id: c, url: a } of t.siteApps) l(c, a);
    } else ty.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
};
var NE = {}, TX = () => {
}, nO = "posthog", FCe = !uAt && (Zo == null ? void 0 : Zo.indexOf("MSIE")) === -1 && (Zo == null ? void 0 : Zo.indexOf("Mozilla")) === -1, zse = () => {
  var e, t, n;
  return { api_host: "https://us.i.posthog.com", ui_host: null, token: "", autocapture: !0, rageclick: !0, cross_subdomain_cookie: (t = Wt == null ? void 0 : Wt.location, n = t == null ? void 0 : t.hostname, !!ws(n) && n.split(".").slice(-2).join(".") !== "herokuapp.com"), persistence: "localStorage+cookie", persistence_name: "", loaded: TX, store_google: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageview: !0, capture_pageleave: "if_capture_pageview", debug: Ya && ws(Ya == null ? void 0 : Ya.search) && Ya.search.indexOf("__posthog_debug=true") !== -1 || !1, verbose: !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, enable_recording_console_log: void 0, secure_cookie: (Be == null || (e = Be.location) === null || e === void 0 ? void 0 : e.protocol) === "https:", ip: !0, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, inapp_protocol: "//", inapp_link_new_window: !1, request_batching: !0, properties_string_max_length: 65535, session_recording: {}, mask_all_element_attributes: !1, mask_all_text: !1, advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, on_request_error: (r) => {
    var i = "Bad HTTP status: " + r.statusCode + " " + r.text;
    un.error(i);
  }, get_device_id: (r) => r, _onCapture: TX, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: "identified_only", __add_tracing_headers: !1, before_send: void 0 };
}, jse = (e) => {
  var t = {};
  cn(e.process_person) || (t.person_profiles = e.process_person), cn(e.xhr_headers) || (t.request_headers = e.xhr_headers), cn(e.cookie_name) || (t.persistence_name = e.cookie_name), cn(e.disable_cookie) || (t.disable_persistence = e.disable_cookie);
  var n = Oa({}, t, e);
  return Qi(e.property_blacklist) && (cn(e.property_denylist) ? n.property_denylist = e.property_blacklist : Qi(e.property_denylist) ? n.property_denylist = [...e.property_blacklist, ...e.property_denylist] : un.error("Invalid value for property_denylist config: " + e.property_denylist)), n;
};
class QAt {
  constructor() {
    Vt(this, "__forceAllowLocalhost", !1);
  }
  get _forceAllowLocalhost() {
    return this.__forceAllowLocalhost;
  }
  set _forceAllowLocalhost(t) {
    un.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
  }
}
class mj {
  constructor() {
    Vt(this, "webPerformance", new QAt()), Vt(this, "version", Gh.LIB_VERSION), Vt(this, "_internalEventEmitter", new ECe()), this.config = zse(), this.decideEndpointWasHit = !1, this.SentryIntegration = mAt, this.sentryIntegration = (t) => function(n, r) {
      var i = SCe(n, r);
      return { name: xCe, processEvent: (o) => i(o) };
    }(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this._initialPageviewCaptured = !1, this._initialPersonProfilesConfig = null, this.featureFlags = new hOt(this), this.toolbar = new lAt(this), this.scrollManager = new DAt(this), this.pageViewManager = new yAt(this), this.surveys = new EAt(this), this.experiments = new Wo(this), this.exceptions = new WAt(this), this.rateLimiter = new TAt(this), this.requestRouter = new hAt(this), this.consent = new VAt(this), this.people = { set: (t, n, r) => {
      var i = ws(t) ? { [t]: n } : t;
      this.setPersonProperties(i), r == null || r({});
    }, set_once: (t, n, r) => {
      var i = ws(t) ? { [t]: n } : t;
      this.setPersonProperties(void 0, i), r == null || r({});
    } }, this.on("eventCaptured", (t) => un.info('send "'.concat(t == null ? void 0 : t.event, '"'), t));
  }
  init(t, n, r) {
    if (r && r !== nO) {
      var i, o = (i = NE[r]) !== null && i !== void 0 ? i : new mj();
      return o._init(t, n, r), NE[r] = o, NE[nO][r] = o, o;
    }
    return this._init(t, n, r);
  }
  _init(t) {
    var n, r, i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 ? arguments[2] : void 0;
    if (cn(t) || Woe(t)) return un.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    if (this.__loaded) return un.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = {}, this._triggered_notifs = [], o.person_profiles && (this._initialPersonProfilesConfig = o.person_profiles), this.set_config(Oa({}, zse(), jse(o), { name: s, token: t })), this.config.on_xhr_error && un.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = o.disable_compression ? void 0 : zu.GZipJS, this.persistence = new D6(this.config), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new D6(bt(bt({}, this.config), {}, { persistence: "sessionStorage" }));
    var l = bt({}, this.persistence.props), c = bt({}, this.sessionPersistence.props);
    if (this._requestQueue = new cAt((A) => this._send_retriable_request(A)), this._retryQueue = new fAt(this), this.__request_queue = [], this.sessionManager = new pAt(this), this.sessionPropsManager = new CAt(this.sessionManager, this.persistence), new UAt(this).startIfEnabledOrStop(), this.siteApps = new HAt(this), (n = this.siteApps) === null || n === void 0 || n.init(), this.sessionRecording = new oAt(this), this.sessionRecording.startIfEnabledOrStop(), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new jAt(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new MAt(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new BAt(this), this.exceptionObserver = new qAt(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new jCe(this, IAt), this.deadClicksAutocapture.startIfEnabled(), Gh.DEBUG = Gh.DEBUG || this.config.debug, Gh.DEBUG && un.info("Starting in debug mode", { this: this, config: o, thisC: bt({}, this.config), p: l, s: c }), this._sync_opt_out_with_persistence(), ((r = o.bootstrap) === null || r === void 0 ? void 0 : r.distinctID) !== void 0) {
      var a, u, f = this.config.get_device_id(Im()), d = (a = o.bootstrap) !== null && a !== void 0 && a.isIdentifiedID ? f : o.bootstrap.distinctID;
      this.persistence.set_property(Op, (u = o.bootstrap) !== null && u !== void 0 && u.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: o.bootstrap.distinctID, $device_id: d });
    }
    if (this._hasBootstrappedFeatureFlags()) {
      var p, h, m = Object.keys(((p = o.bootstrap) === null || p === void 0 ? void 0 : p.featureFlags) || {}).filter((A) => {
        var w, O;
        return !((w = o.bootstrap) === null || w === void 0 || (O = w.featureFlags) === null || O === void 0 || !O[A]);
      }).reduce((A, w) => {
        var O, x;
        return A[w] = ((O = o.bootstrap) === null || O === void 0 || (x = O.featureFlags) === null || x === void 0 ? void 0 : x[w]) || !1, A;
      }, {}), v = Object.keys(((h = o.bootstrap) === null || h === void 0 ? void 0 : h.featureFlagPayloads) || {}).filter((A) => m[A]).reduce((A, w) => {
        var O, x, S, E;
        return (O = o.bootstrap) !== null && O !== void 0 && (x = O.featureFlagPayloads) !== null && x !== void 0 && x[w] && (A[w] = (S = o.bootstrap) === null || S === void 0 || (E = S.featureFlagPayloads) === null || E === void 0 ? void 0 : E[w]), A;
      }, {});
      this.featureFlags.receivedFeatureFlags({ featureFlags: m, featureFlagPayloads: v });
    }
    if (!this.get_distinct_id()) {
      var b = this.config.get_device_id(Im());
      this.register_once({ distinct_id: b, $device_id: b }, ""), this.persistence.set_property(Op, "anonymous");
    }
    return Be == null || (i = Be.addEventListener) === null || i === void 0 || i.call(Be, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), this.toolbar.maybeLoadToolbar(), o.segment ? gAt(this, () => this._loaded()) : this._loaded(), Xc(this.config._onCapture) && this.config._onCapture !== TX && (un.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (A) => this.config._onCapture(A.event, A))), this;
  }
  _onRemoteConfig(t) {
    var n, r, i, o, s, l, c, a, u;
    this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = Yn(t.supportedCompression, zu.GZipJS) ? zu.GZipJS : Yn(t.supportedCompression, zu.Base64) ? zu.Base64 : void 0), (n = t.analytics) !== null && n !== void 0 && n.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({ person_profiles: this._initialPersonProfilesConfig ? this._initialPersonProfilesConfig : t.defaultIdentifiedOnly ? "identified_only" : "always" }), (r = this.siteApps) === null || r === void 0 || r.onRemoteConfig(t), (i = this.sessionRecording) === null || i === void 0 || i.onRemoteConfig(t), (o = this.autocapture) === null || o === void 0 || o.onRemoteConfig(t), (s = this.heatmaps) === null || s === void 0 || s.onRemoteConfig(t), (l = this.surveys) === null || l === void 0 || l.onRemoteConfig(t), (c = this.webVitalsAutocapture) === null || c === void 0 || c.onRemoteConfig(t), (a = this.exceptionObserver) === null || a === void 0 || a.onRemoteConfig(t), (u = this.deadClicksAutocapture) === null || u === void 0 || u.onRemoteConfig(t);
  }
  _loaded() {
    this.config.advanced_disable_decide || this.featureFlags.setReloadingPaused(!0);
    try {
      this.config.loaded(this);
    } catch (t) {
      un.critical("`loaded` function failed", t);
    }
    this._start_queue_if_opted_in(), this.config.capture_pageview && setTimeout(() => {
      this.consent.isOptedIn() && this._captureInitialPageview();
    }, 1), new sAt(this).call();
  }
  _start_queue_if_opted_in() {
    var t;
    this.has_opted_out_capturing() || this.config.request_batching && ((t = this._requestQueue) === null || t === void 0 || t.enable());
  }
  _dom_loaded() {
    this.has_opted_out_capturing() || ZO(this.__request_queue, (t) => this._send_retriable_request(t)), this.__request_queue = [], this._start_queue_if_opted_in();
  }
  _handle_unload() {
    var t, n;
    this.config.request_batching ? (this._shouldCapturePageleave() && this.capture("$pageleave"), (t = this._requestQueue) === null || t === void 0 || t.unload(), (n = this._retryQueue) === null || n === void 0 || n.unload()) : this._shouldCapturePageleave() && this.capture("$pageleave", null, { transport: "sendBeacon" });
  }
  _send_request(t) {
    this.__loaded && (FCe ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = qD(t.url, { ip: this.config.ip ? 1 : 0 }), t.headers = bt({}, this.config.request_headers), t.compression = t.compression === "best-available" ? this.compression : t.compression, ((n) => {
      var r, i, o, s = bt({}, n);
      s.timeout = s.timeout || 6e4, s.url = qD(s.url, { _: (/* @__PURE__ */ new Date()).getTime().toString(), ver: Gh.LIB_VERSION, compression: s.compression });
      var l = (r = s.transport) !== null && r !== void 0 ? r : "XHR", c = (i = (o = Lke(CE, (a) => a.transport === l)) === null || o === void 0 ? void 0 : o.method) !== null && i !== void 0 ? i : CE[0].method;
      if (!c) throw new Error("No available transport method");
      c(s);
    })(bt(bt({}, t), {}, { callback: (n) => {
      var r, i, o;
      this.rateLimiter.checkForLimiting(n), n.statusCode >= 400 && ((i = (o = this.config).on_request_error) === null || i === void 0 || i.call(o, n)), (r = t.callback) === null || r === void 0 || r.call(t, n);
    } }))));
  }
  _send_retriable_request(t) {
    this._retryQueue ? this._retryQueue.retriableRequest(t) : this._send_request(t);
  }
  _execute_array(t) {
    var n, r = [], i = [], o = [];
    ZO(t, (l) => {
      l && (n = l[0], Qi(n) ? o.push(l) : Xc(l) ? l.call(this) : Qi(l) && n === "alias" ? r.push(l) : Qi(l) && n.indexOf("capture") !== -1 && Xc(this[n]) ? o.push(l) : i.push(l));
    });
    var s = function(l, c) {
      ZO(l, function(a) {
        if (Qi(a[0])) {
          var u = c;
          Xr(a, function(f) {
            u = u[f[0]].apply(u, f.slice(1));
          });
        } else this[a[0]].apply(this, a.slice(1));
      }, c);
    };
    s(r, this), s(i, this), s(o, this);
  }
  _hasBootstrappedFeatureFlags() {
    var t, n;
    return ((t = this.config.bootstrap) === null || t === void 0 ? void 0 : t.featureFlags) && Object.keys((n = this.config.bootstrap) === null || n === void 0 ? void 0 : n.featureFlags).length > 0 || !1;
  }
  push(t) {
    this._execute_array([t]);
  }
  capture(t, n, r) {
    var i;
    if (this.__loaded && this.persistence && this.sessionPersistence && this._requestQueue) {
      if (!this.consent.isOptedOut()) if (!cn(t) && ws(t)) {
        if (this.config.opt_out_useragent_filter || !this._is_bot()) {
          var o = r != null && r.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
          if (o == null || !o.isRateLimited) {
            this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.store_google || this.config.save_referrer) && this.persistence.set_initial_person_info();
            var s = /* @__PURE__ */ new Date(), l = (r == null ? void 0 : r.timestamp) || s, c = { uuid: Im(), event: t, properties: this._calculate_event_properties(t, n || {}, l) };
            o && (c.properties.$lib_rate_limit_remaining_tokens = o.remainingTokens), r != null && r.$set && (c.$set = r == null ? void 0 : r.$set);
            var a = this._calculate_set_once_properties(r == null ? void 0 : r.$set_once);
            a && (c.$set_once = a), (c = sOt(c, r != null && r._noTruncate ? null : this.config.properties_string_max_length)).timestamp = l, cn(r == null ? void 0 : r.timestamp) || (c.properties.$event_time_override_provided = !0, c.properties.$event_time_override_system_time = s);
            var u = bt(bt({}, c.properties.$set), c.$set);
            if (wO(u) || this.setPersonPropertiesForFlags(u), !ei(this.config.before_send)) {
              var f = this._runBeforeSend(c);
              if (!f) return;
              c = f;
            }
            this._internalEventEmitter.emit("eventCaptured", c);
            var d = { method: "POST", url: (i = r == null ? void 0 : r._url) !== null && i !== void 0 ? i : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), data: c, compression: "best-available", batchKey: r == null ? void 0 : r._batchKey };
            return !this.config.request_batching || r && (r == null || !r._batchKey) || r != null && r.send_instantly ? this._send_retriable_request(d) : this._requestQueue.enqueue(d), c;
          }
          un.critical("This capture call is ignored due to client rate limiting.");
        }
      } else un.error("No event name provided to posthog.capture");
    } else un.uninitializedWarning("posthog.capture");
  }
  _addCaptureHook(t) {
    return this.on("eventCaptured", (n) => t(n.event, n));
  }
  _calculate_event_properties(t, n, r) {
    if (r = r || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return n;
    var i = this.persistence.remove_event_timer(t), o = bt({}, n);
    if (o.token = this.config.token, t === "$snapshot") {
      var s = bt(bt({}, this.persistence.properties()), this.sessionPersistence.properties());
      return o.distinct_id = s.distinct_id, (!ws(o.distinct_id) && !Zl(o.distinct_id) || Woe(o.distinct_id)) && un.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), o;
    }
    var l = zi.properties();
    if (this.sessionManager) {
      var { sessionId: c, windowId: a } = this.sessionManager.checkAndGetSessionAndWindowId();
      o.$session_id = c, o.$window_id = a;
    }
    if (this.sessionRecording && (o.$recording_status = this.sessionRecording.status), this.requestRouter.region === ky.CUSTOM && (o.$lib_custom_api_host = this.config.api_host), this.sessionPropsManager && this.config.__preview_send_client_session_params && (t === "$pageview" || t === "$pageleave" || t === "$autocapture")) {
      var u = this.sessionPropsManager.getSessionProps();
      o = Oa(o, u);
    }
    if (!this.config.disable_scroll_properties) {
      var f = {};
      t === "$pageview" ? f = this.pageViewManager.doPageView(r) : t === "$pageleave" && (f = this.pageViewManager.doPageLeave(r)), o = Oa(o, f);
    }
    if (t === "$pageview" && Wt && (o.title = Wt.title), !cn(i)) {
      var d = r.getTime() - i;
      o.$duration = parseFloat((d / 1e3).toFixed(3));
    }
    Zo && this.config.opt_out_useragent_filter && (o.$browser_type = this._is_bot() ? "bot" : "browser"), (o = Oa({}, l, this.persistence.properties(), this.sessionPersistence.properties(), o)).$is_identified = this._isIdentified(), Qi(this.config.property_denylist) ? Xr(this.config.property_denylist, function(m) {
      delete o[m];
    }) : un.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    var p = this.config.sanitize_properties;
    p && (o = p(o, t));
    var h = this._hasPersonProcessing();
    return o.$process_person_profile = h, h && this._requirePersonProcessing("_calculate_event_properties"), o;
  }
  _calculate_set_once_properties(t) {
    if (!this.persistence || !this._hasPersonProcessing()) return t;
    var n = Oa({}, this.persistence.get_initial_props(), t || {}), r = this.config.sanitize_properties;
    return r && (n = r(n, "$set_once")), wO(n) ? void 0 : n;
  }
  register(t, n) {
    var r;
    (r = this.persistence) === null || r === void 0 || r.register(t, n);
  }
  register_once(t, n, r) {
    var i;
    (i = this.persistence) === null || i === void 0 || i.register_once(t, n, r);
  }
  register_for_session(t) {
    var n;
    (n = this.sessionPersistence) === null || n === void 0 || n.register(t);
  }
  unregister(t) {
    var n;
    (n = this.persistence) === null || n === void 0 || n.unregister(t);
  }
  unregister_for_session(t) {
    var n;
    (n = this.sessionPersistence) === null || n === void 0 || n.unregister(t);
  }
  _register_single(t, n) {
    this.register({ [t]: n });
  }
  getFeatureFlag(t, n) {
    return this.featureFlags.getFeatureFlag(t, n);
  }
  getFeatureFlagPayload(t) {
    var n = this.featureFlags.getFeatureFlagPayload(t);
    try {
      return JSON.parse(n);
    } catch {
      return n;
    }
  }
  isFeatureEnabled(t, n) {
    return this.featureFlags.isFeatureEnabled(t, n);
  }
  reloadFeatureFlags() {
    this.featureFlags.reloadFeatureFlags();
  }
  updateEarlyAccessFeatureEnrollment(t, n) {
    this.featureFlags.updateEarlyAccessFeatureEnrollment(t, n);
  }
  getEarlyAccessFeatures(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return this.featureFlags.getEarlyAccessFeatures(t, n);
  }
  on(t, n) {
    return this._internalEventEmitter.on(t, n);
  }
  onFeatureFlags(t) {
    return this.featureFlags.onFeatureFlags(t);
  }
  onSessionId(t) {
    var n, r;
    return (n = (r = this.sessionManager) === null || r === void 0 ? void 0 : r.onSessionId(t)) !== null && n !== void 0 ? n : () => {
    };
  }
  getSurveys(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    this.surveys.getSurveys(t, n);
  }
  getActiveMatchingSurveys(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    this.surveys.getActiveMatchingSurveys(t, n);
  }
  renderSurvey(t, n) {
    this.surveys.renderSurvey(t, n);
  }
  canRenderSurvey(t) {
    this.surveys.canRenderSurvey(t);
  }
  getNextSurveyStep(t, n, r) {
    return this.surveys.getNextSurveyStep(t, n, r);
  }
  identify(t, n, r) {
    if (!this.__loaded || !this.persistence) return un.uninitializedWarning("posthog.identify");
    if (Zl(t) && (t = t.toString(), un.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
      if (["distinct_id", "distinctid"].includes(t.toLowerCase())) un.critical('The string "'.concat(t, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
      else if (this._requirePersonProcessing("posthog.identify")) {
        var i = this.get_distinct_id();
        if (this.register({ $user_id: t }), !this.get_property("$device_id")) {
          var o = i;
          this.register_once({ $had_persisted_distinct_id: !0, $device_id: o }, "");
        }
        t !== i && t !== this.get_property(t1) && (this.unregister(t1), this.register({ distinct_id: t }));
        var s = (this.persistence.get_property(Op) || "anonymous") === "anonymous";
        t !== i && s ? (this.persistence.set_property(Op, "identified"), this.setPersonPropertiesForFlags(n || {}, !1), this.capture("$identify", { distinct_id: t, $anon_distinct_id: i }, { $set: n || {}, $set_once: r || {} }), this.featureFlags.setAnonymousDistinctId(i)) : (n || r) && this.setPersonProperties(n, r), t !== i && (this.reloadFeatureFlags(), this.unregister(MD));
      }
    } else un.error("Unique user id has not been set in posthog.identify");
  }
  setPersonProperties(t, n) {
    (t || n) && this._requirePersonProcessing("posthog.setPersonProperties") && (this.setPersonPropertiesForFlags(t || {}), this.capture("$set", { $set: t || {}, $set_once: n || {} }));
  }
  group(t, n, r) {
    if (t && n) {
      if (this._requirePersonProcessing("posthog.group")) {
        var i = this.getGroups();
        i[t] !== n && this.resetGroupPropertiesForFlags(t), this.register({ $groups: bt(bt({}, i), {}, { [t]: n }) }), r && (this.capture("$groupidentify", { $group_type: t, $group_key: n, $group_set: r }), this.setGroupPropertiesForFlags({ [t]: r })), i[t] === n || r || this.reloadFeatureFlags();
      }
    } else un.error("posthog.group requires a group type and group key");
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    this._requirePersonProcessing("posthog.setPersonPropertiesForFlags") && this.featureFlags.setPersonPropertiesForFlags(t, n);
  }
  resetPersonPropertiesForFlags() {
    this.featureFlags.resetPersonPropertiesForFlags();
  }
  setGroupPropertiesForFlags(t) {
    var n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    this._requirePersonProcessing("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, n);
  }
  resetGroupPropertiesForFlags(t) {
    this.featureFlags.resetGroupPropertiesForFlags(t);
  }
  reset(t) {
    var n, r, i, o, s;
    if (un.info("reset"), !this.__loaded) return un.uninitializedWarning("posthog.reset");
    var l = this.get_property("$device_id");
    this.consent.reset(), (n = this.persistence) === null || n === void 0 || n.clear(), (r = this.sessionPersistence) === null || r === void 0 || r.clear(), (i = this.surveys) === null || i === void 0 || i.reset(), (o = this.persistence) === null || o === void 0 || o.set_property(Op, "anonymous"), (s = this.sessionManager) === null || s === void 0 || s.resetSessionId();
    var c = this.config.get_device_id(Im());
    this.register_once({ distinct_id: c, $device_id: t ? c : l }, "");
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var t, n;
    return (t = (n = this.sessionManager) === null || n === void 0 ? void 0 : n.checkAndGetSessionAndWindowId(!0).sessionId) !== null && t !== void 0 ? t : "";
  }
  get_session_replay_url(t) {
    if (!this.sessionManager) return "";
    var { sessionId: n, sessionStartTimestamp: r } = this.sessionManager.checkAndGetSessionAndWindowId(!0), i = this.requestRouter.endpointFor("ui", "/project/".concat(this.config.token, "/replay/").concat(n));
    if (t != null && t.withTimestamp && r) {
      var o, s = (o = t.timestampLookBack) !== null && o !== void 0 ? o : 10;
      if (!r) return i;
      var l = Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - r) / 1e3) - s, 0);
      i += "?t=".concat(l);
    }
    return i;
  }
  alias(t, n) {
    return t === this.get_property(Vke) ? (un.critical("Attempting to create alias for existing People user - aborting."), -2) : this._requirePersonProcessing("posthog.alias") ? (cn(n) && (n = this.get_distinct_id()), t !== n ? (this._register_single(t1, t), this.capture("$create_alias", { alias: t, distinct_id: n })) : (un.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
  }
  set_config(t) {
    var n, r, i, o, s = bt({}, this.config);
    fo(t) && (Oa(this.config, jse(t)), (n = this.persistence) === null || n === void 0 || n.update_config(this.config, s), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new D6(bt(bt({}, this.config), {}, { persistence: "sessionStorage" })), Io.is_supported() && Io.get("ph_debug") === "true" && (this.config.debug = !0), this.config.debug && (Gh.DEBUG = !0, un.info("set_config", { config: t, oldConfig: s, newConfig: bt({}, this.config) })), (r = this.sessionRecording) === null || r === void 0 || r.startIfEnabledOrStop(), (i = this.autocapture) === null || i === void 0 || i.startIfEnabled(), (o = this.heatmaps) === null || o === void 0 || o.startIfEnabled(), this.surveys.loadIfEnabled(), this._sync_opt_out_with_persistence());
  }
  startSessionRecording(t) {
    var n = t === !0, r = { sampling: n || !(t == null || !t.sampling), linked_flag: n || !(t == null || !t.linked_flag), url_trigger: n || !(t == null || !t.url_trigger), event_trigger: n || !(t == null || !t.event_trigger) };
    if (Object.values(r).some(Boolean)) {
      var i, o, s, l, c;
      (i = this.sessionManager) === null || i === void 0 || i.checkAndGetSessionAndWindowId(), r.sampling && ((o = this.sessionRecording) === null || o === void 0 || o.overrideSampling()), r.linked_flag && ((s = this.sessionRecording) === null || s === void 0 || s.overrideLinkedFlag()), r.url_trigger && ((l = this.sessionRecording) === null || l === void 0 || l.overrideTrigger("url")), r.event_trigger && ((c = this.sessionRecording) === null || c === void 0 || c.overrideTrigger("event"));
    }
    this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var t;
    return !((t = this.sessionRecording) === null || t === void 0 || !t.started);
  }
  captureException(t, n) {
    var r, i = new Error("PostHog syntheticException"), o = Xc((r = Tn.__PosthogExtensions__) === null || r === void 0 ? void 0 : r.parseErrorAsProperties) ? Tn.__PosthogExtensions__.parseErrorAsProperties([t.message, void 0, void 0, void 0, t], { syntheticException: i }) : bt({ $exception_level: "error", $exception_list: [{ type: t.name, value: t.message, mechanism: { handled: !0, synthetic: !1 } }] }, n);
    this.exceptions.sendExceptionEvent(o);
  }
  loadToolbar(t) {
    return this.toolbar.loadToolbar(t);
  }
  get_property(t) {
    var n;
    return (n = this.persistence) === null || n === void 0 ? void 0 : n.props[t];
  }
  getSessionProperty(t) {
    var n;
    return (n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.props[t];
  }
  toString() {
    var t, n = (t = this.config.name) !== null && t !== void 0 ? t : nO;
    return n !== nO && (n = nO + "." + n), n;
  }
  _isIdentified() {
    var t, n;
    return ((t = this.persistence) === null || t === void 0 ? void 0 : t.get_property(Op)) === "identified" || ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.get_property(Op)) === "identified";
  }
  _hasPersonProcessing() {
    var t, n, r, i;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && wO(this.getGroups()) && ((t = this.persistence) === null || t === void 0 || (n = t.props) === null || n === void 0 || !n[t1]) && ((r = this.persistence) === null || r === void 0 || (i = r.props) === null || i === void 0 || !i[DD]));
  }
  _shouldCapturePageleave() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && this.config.capture_pageview;
  }
  createPersonProfile() {
    this._hasPersonProcessing() || this._requirePersonProcessing("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  _requirePersonProcessing(t) {
    return this.config.person_profiles === "never" ? (un.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._register_single(DD, !0), !0);
  }
  _sync_opt_out_with_persistence() {
    var t, n, r, i, o = this.consent.isOptedOut(), s = this.config.opt_out_persistence_by_default, l = this.config.disable_persistence || o && !!s;
    ((t = this.persistence) === null || t === void 0 ? void 0 : t.disabled) !== l && ((r = this.persistence) === null || r === void 0 || r.set_disabled(l)), ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.disabled) !== l && ((i = this.sessionPersistence) === null || i === void 0 || i.set_disabled(l));
  }
  opt_in_capturing(t) {
    var n;
    this.consent.optInOut(!0), this._sync_opt_out_with_persistence(), (cn(t == null ? void 0 : t.captureEventName) || t != null && t.captureEventName) && this.capture((n = t == null ? void 0 : t.captureEventName) !== null && n !== void 0 ? n : "$opt_in", t == null ? void 0 : t.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this._captureInitialPageview();
  }
  opt_out_capturing() {
    this.consent.optInOut(!1), this._sync_opt_out_with_persistence();
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this._sync_opt_out_with_persistence();
  }
  _is_bot() {
    return Jl ? LCe(Jl, this.config.custom_blocked_useragents) : void 0;
  }
  _captureInitialPageview() {
    Wt && !this._initialPageviewCaptured && (this._initialPageviewCaptured = !0, this.capture("$pageview", { title: Wt.title }, { send_instantly: !0 }));
  }
  debug(t) {
    t === !1 ? (Be == null || Be.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({ debug: !1 })) : (Be == null || Be.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({ debug: !0 }));
  }
  _runBeforeSend(t) {
    if (ei(this.config.before_send)) return t;
    var n = Qi(this.config.before_send) ? this.config.before_send : [this.config.before_send], r = t;
    for (var i of n) {
      if (r = i(r), ei(r)) {
        var o = "Event '".concat(t.event, "' was rejected in beforeSend function");
        return dOt(t.event) ? un.warn("".concat(o, ". This can cause unexpected behavior.")) : un.info(o), null;
      }
      r.properties && !wO(r.properties) || un.warn("Event '".concat(t.event, "' has no properties after beforeSend function, this is likely an error."));
    }
    return r;
  }
}
(function(e, t) {
  for (var n = 0; n < t.length; n++) e.prototype[t[n]] = oOt(e.prototype[t[n]]);
})(mj, ["identify"]);
var Fse;
Fse = NE[nO] = new mj(), function() {
  function e() {
    e.done || (e.done = !0, FCe = !1, Xr(NE, function(t) {
      t._dom_loaded();
    }));
  }
  Wt != null && Wt.addEventListener && (Wt.readyState === "complete" ? e() : Wt.addEventListener("DOMContentLoaded", e, !1)), Be && _p(Be, "load", e, !0);
}();
function U6(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  e && e.addEventListener && e.addEventListener.apply(e, t);
}
function V6(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  e && e.removeEventListener && e.removeEventListener.apply(e, t);
}
var UCe = typeof window < "u", $At = function(e) {
  nt(e, []);
}, Use = function(e) {
  var t = window.history, n = t[e];
  t[e] = function(r) {
    var i = n.apply(this, arguments), o = new Event(e.toLowerCase());
    return o.state = r, window.dispatchEvent(o), i;
  };
};
UCe && (Use("pushState"), Use("replaceState"));
var KAt = function() {
  return {
    trigger: "load",
    length: 1
  };
}, $P = function(e) {
  var t = window.history, n = t.state, r = t.length, i = window.location, o = i.hash, s = i.host, l = i.hostname, c = i.href, a = i.origin, u = i.pathname, f = i.port, d = i.protocol, p = i.search;
  return {
    trigger: e,
    state: n,
    length: r,
    hash: o,
    host: s,
    hostname: l,
    href: c,
    origin: a,
    pathname: u,
    port: f,
    protocol: d,
    search: p
  };
}, GAt = function() {
  var e = He($P("load")), t = e[0], n = e[1];
  return nt(function() {
    var r = function() {
      return n($P("popstate"));
    }, i = function() {
      return n($P("pushstate"));
    }, o = function() {
      return n($P("replacestate"));
    };
    return U6(window, "popstate", r), U6(window, "pushstate", i), U6(window, "replacestate", o), function() {
      V6(window, "popstate", r), V6(window, "pushstate", i), V6(window, "replacestate", o);
    };
  }, []), t;
}, YAt = typeof Event == "function";
const JAt = UCe && YAt ? GAt : KAt;
function Vse(e) {
  var t = Xe();
  return nt(function() {
    t.current = e;
  }), t.current;
}
const wx = /* @__PURE__ */ c2(wct), qse = {
  getUserById(e) {
    return dt.get(`/v1/users/${e}`);
  }
}, gj = {
  useCurrentUser: () => {
    const e = Rn.getCurrentUserId(), t = Rn.getToken(), n = Rn.isJwtExpired(t);
    return pr({
      queryKey: ["currentUser", e],
      queryFn: async () => {
        if (!e || n)
          return null;
        try {
          return await qse.getUserById(e);
        } catch (r) {
          return console.error(r), null;
        }
      },
      staleTime: 1 / 0
    });
  },
  useUserById: (e) => pr({
    queryKey: ["user", e],
    queryFn: async () => {
      try {
        return await qse.getUserById(e);
      } catch (t) {
        return console.error(t), null;
      }
    },
    enabled: !De(e),
    staleTime: 1 / 0
  }),
  invalidateCurrentUser: (e) => {
    const t = Rn.getCurrentUserId();
    e.invalidateQueries({ queryKey: ["currentUser", t] });
  },
  getCurrentUserPlatformRole: () => {
    const { data: e } = gj.useCurrentUser();
    return e == null ? void 0 : e.platformRole;
  }
}, ewt = ie.createContext({
  capture: () => {
  },
  reset: () => {
  }
}), yj = () => ie.useContext(ewt), Lp = {
  list(e) {
    return dt.get(
      "/v1/app-connections",
      e
    );
  },
  upsert(e) {
    return dt.post(
      "/v1/app-connections",
      e
    );
  },
  delete(e, t) {
    return dt.delete(`/app-connections/${e}`, { projectId: t });
  },
  update(e, t) {
    return dt.post(
      `/v1/app-connections/${e}`,
      t
    );
  },
  replace(e) {
    return dt.post("/v1/app-connections/replace", e);
  },
  getOwners(e) {
    return dt.get(
      "/v1/app-connections/owners",
      e
    );
  }
}, WD = (e) => e.type === qe.PIECE || e.type === Bt.PIECE ? e.categories.includes(Of.FLOW_CONTROL) : e.type === qe.LOOP_ON_ITEMS || e.type === qe.ROUTER, twt = (e) => {
  const t = [], r = fN(e).filter(VCe), i = {
    title: Z("Recommended"),
    metadata: []
  }, o = {
    title: Z("Others"),
    metadata: []
  }, s = r.filter(
    (c) => c.categories.includes(Of.UNIVERSAL_AI)
  );
  s.length > 0 && (i.metadata = s, t.push(i));
  const l = r.filter(
    (c) => !s.includes(c)
  );
  return l.length > 0 && (o.metadata = l, t.push(o)), t;
}, VCe = (e) => e.type === qe.PIECE || e.type === Bt.PIECE ? e.categories.some(
  (t) => [
    Of.UNIVERSAL_AI,
    Of.ARTIFICIAL_INTELLIGENCE
  ].includes(t)
) : !1, qCe = (e) => (e.type !== Bt.PIECE && e.type !== qe.PIECE || e.categories.includes(Of.CORE)) && !WD(e), nwt = (e) => !qCe(e) && !VCe(e) && !WD(e), rwt = (e, t) => {
  const r = fN(e).filter(
    (i) => t.includes(i.pieceName)
  );
  return M$(r, t);
}, Bse = [
  "@activepieces/piece-google-sheets",
  "@activepieces/piece-slack",
  "@activepieces/piece-notion",
  "@activepieces/piece-gmail",
  "@activepieces/piece-hubspot",
  "@activepieces/piece-openai",
  "@activepieces/piece-google-forms",
  "@activepieces/piece-google-drive",
  "@activepieces/piece-google-docs"
], iwt = (e, t) => {
  const r = fN(e).filter(
    (i) => Bse.includes(i.pieceName) && !t.includes(i.pieceName)
  );
  return M$(r, Bse);
}, fN = (e) => e.filter(
  (t) => t.type === qe.PIECE || t.type === Bt.PIECE
), owt = (e, t) => {
  const n = fN(e), r = t === "action" ? Wse : Xse, i = n.filter(
    (o) => r.includes(o.pieceName)
  );
  return M$(
    i,
    t === "action" ? Wse : Xse
  );
}, M$ = (e, t) => fN(e).sort((r, i) => t.indexOf(r.pieceName) - t.indexOf(i.pieceName)), Xse = [
  "@activepieces/piece-webhook",
  "@activepieces/piece-schedule",
  "@activepieces/piece-forms",
  "@activepieces/piece-tables"
], Wse = [
  X2,
  "@activepieces/piece-http",
  "@activepieces/piece-tables",
  "@activepieces/piece-todos",
  "@activepieces/piece-forms",
  "@activepieces/piece-webhook",
  "@activepieces/piece-text-helper",
  "@activepieces/piece-date-helper"
], swt = {
  isFlowController: WD,
  getAiAndAgentsPieces: twt,
  isUtilityPiece: qCe,
  isAppPiece: nwt,
  getPinnedPieces: rwt,
  getPopularPieces: iwt,
  getHighlightedPieces: owt
}, awt = () => Z("An unexpected error occurred. Please try again in a moment.");
function Kc() {
  vr.error(Z("Something went wrong"), {
    description: awt(),
    duration: 3e3
  });
}
const ny = {
  id: "unsaved-changes",
  get title() {
    return Z("Unsaved Changes");
  },
  get description() {
    return Z(
      "Something went wrong and there are unsaved changes, please refresh and contact support if the problem persists."
    );
  },
  duration: 1 / 0,
  closeButton: !0
}, lwt = ({ ...e }) => {
  const { theme: t } = Jw(), { i18n: n } = tc();
  return /* @__PURE__ */ y(
    X0t,
    {
      dir: CH(n.resolvedLanguage ?? n.language),
      theme: t,
      className: "toaster group",
      expand: !0,
      toastOptions: {
        classNames: {
          toast: `
            data-[type=error]:text-destructive-300!
            data-[type=warning]:text-warning-300!
            data-[type=success]:text-success-300!
          `,
          description: `
            data-[type=error]:text-destructive-300!
            data-[type=warning]:text-warning-300!
            data-[type=success]:text-success-300!
          `
        },
        descriptionClassName: "text-inherit!"
      },
      icons: {
        success: /* @__PURE__ */ y(gB, { className: "size-4" }),
        info: /* @__PURE__ */ y(QA, { className: "size-4" }),
        warning: /* @__PURE__ */ y(gz, { className: "size-4" }),
        error: /* @__PURE__ */ y(Sot, { className: "size-4 text-destructive" }),
        loading: /* @__PURE__ */ y(PT, { className: "size-4 animate-spin" })
      },
      style: {
        "--normal-text": "var(--foreground)",
        "--normal-bg": "var(--background)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)"
      },
      ...e
    }
  );
}, Yd = {
  list(e) {
    return dt.get("/v1/pieces", e);
  },
  get(e) {
    return dt.get(`/v1/pieces/${e.name}`, {
      version: e.version ?? void 0,
      locale: e.locale ?? void 0,
      projectId: e.projectId ?? void 0
    });
  },
  options(e, t) {
    return dt.post("/v1/pieces/options", e).catch((n) => {
      console.error(n), Kc();
      const r = {
        options: {},
        type: Le.DYNAMIC
      }, i = {
        options: {
          options: [],
          disabled: !0,
          placeholder: Z(
            "An internal error occurred, please contact support"
          )
        },
        type: Le.DROPDOWN
      };
      return t === Le.DYNAMIC ? r : i;
    });
  },
  syncFromCloud() {
    return dt.post("/v1/pieces/sync", {});
  },
  async install(e) {
    const t = new FormData();
    if (t.set("packageType", e.packageType), t.set("pieceName", e.pieceName), t.set("pieceVersion", e.pieceVersion), t.set("scope", e.scope), e.packageType === VA.ARCHIVE) {
      const n = await e.pieceArchive.arrayBuffer();
      t.append("pieceArchive", new Blob([n]));
    }
    return dt.post("/v1/pieces", t, void 0, {
      "Content-Type": "multipart/form-data"
    });
  },
  delete(e) {
    return dt.delete(`/v1/pieces/${e}`);
  }
}, PE = {
  [qe.CODE]: {
    displayName: Z("Code"),
    logoUrl: "https://cdn.activepieces.com/pieces/code.svg",
    description: Z("Powerful Node.js & TypeScript code with npm"),
    type: qe.CODE
  },
  [qe.LOOP_ON_ITEMS]: {
    displayName: Z("Loop on Items"),
    logoUrl: "https://cdn.activepieces.com/pieces/loop.svg",
    description: "Iterate over a list of items",
    type: qe.LOOP_ON_ITEMS
  },
  [qe.ROUTER]: {
    displayName: Z("Router"),
    logoUrl: "https://cdn.activepieces.com/pieces/branch.svg",
    description: Z("Split your flow into branches depending on condition(s)"),
    type: qe.ROUTER
  },
  [Bt.EMPTY]: {
    displayName: Z("Empty Trigger"),
    logoUrl: "https://cdn.activepieces.com/pieces/empty-trigger.svg",
    description: Z("Empty Trigger"),
    type: Bt.EMPTY
  }
}, BCe = [
  PE[qe.CODE],
  PE[qe.LOOP_ON_ITEMS],
  PE[qe.ROUTER]
], kX = {
  createTodo: "createTodo",
  createTodoAndWait: "createTodoAndWait",
  waitForApproval: "wait_for_approval"
}, KO = {
  getKeys(e, t) {
    const n = e.type === qe.PIECE || e.type === Bt.PIECE, r = n ? e.settings.pieceName : void 0, i = n ? e.settings.pieceVersion : void 0, o = n && "customLogoUrl" in e ? e.customLogoUrl : void 0;
    return [r, i, o, t, e.type];
  },
  async getMetadata(e, t) {
    const n = "customLogoUrl" in e ? e.customLogoUrl : void 0;
    switch (e.type) {
      case qe.ROUTER:
      case qe.LOOP_ON_ITEMS:
      case qe.CODE:
      case Bt.EMPTY:
        return {
          ...PE[e.type],
          ...qbe("logoUrl", n),
          actionOrTriggerOrAgentDisplayName: "",
          actionOrTriggerOrAgentDescription: ""
        };
      case qe.PIECE:
      case Bt.PIECE: {
        const r = await Yd.get({
          name: e.settings.pieceName,
          version: e.settings.pieceVersion,
          locale: t
        }), i = KO.mapPieceToMetadata({
          piece: r,
          type: e.type === qe.PIECE ? "action" : "trigger"
        }), o = e.type === qe.PIECE ? r.actions[e.settings.actionName].displayName : r.triggers[e.settings.triggerName].displayName, s = e.type === qe.PIECE ? r.actions[e.settings.actionName].description : r.triggers[e.settings.triggerName].description;
        return {
          ...i,
          errorHandlingOptions: cwt(r, e),
          actionOrTriggerOrAgentDescription: s,
          actionOrTriggerOrAgentDisplayName: o
        };
      }
    }
  },
  mapPieceToMetadata({
    piece: e,
    type: t
  }) {
    return {
      displayName: e.displayName,
      logoUrl: e.logoUrl,
      description: e.description,
      type: t === "action" ? qe.PIECE : Bt.PIECE,
      pieceType: e.pieceType,
      pieceName: e.name,
      pieceVersion: e.version,
      categories: e.categories ?? [],
      packageType: e.packageType,
      auth: e.auth
    };
  },
  getAgentRunId(e) {
    if (e)
      return "output" in e && "agentRunId" in e.output ? e.output.agentRunId : void 0;
  }
};
function cwt(e, t) {
  if (At.isTrigger(t.type))
    return {
      continueOnFailure: {
        hide: !0
      },
      retryOnFailure: {
        hide: !0
      }
    };
  const n = t.type === qe.PIECE ? e.actions[t.settings.actionName] : null, r = n == null ? void 0 : n.errorHandlingOptions;
  return r || {
    continueOnFailure: {
      hide: !1,
      defaultValue: !1
    },
    retryOnFailure: {
      hide: !1,
      defaultValue: !1
    }
  };
}
const vd = {
  useStepMetadata: ({ step: e }) => {
    const { i18n: t } = tc(), n = pr({
      queryKey: Zse(e, t.language),
      queryFn: () => KO.getMetadata(e, t.language)
    });
    return {
      stepMetadata: n.data,
      isLoading: n.isLoading
    };
  },
  useStepsMetadata: (e) => {
    const { i18n: t } = tc();
    return mwe({
      queries: e.map((n) => ({
        queryKey: Zse(
          n,
          t.language
        ),
        queryFn: () => KO.getMetadata(n, t.language),
        staleTime: 1 / 0
      }))
    });
  },
  useAllStepsMetadata: ({ searchQuery: e, type: t, enabled: n }) => {
    const { i18n: r } = tc(), i = pr({
      queryKey: ["pieces-metadata", e, t],
      queryFn: async () => {
        const l = (await Yd.list({
          projectId: Rn.getProjectId(),
          searchQuery: e,
          suggestionType: t === "action" ? OT.ACTION : OT.TRIGGER,
          locale: r.language
        })).filter(
          (c) => t === "action" && c.actions > 0 || t === "trigger" && c.triggers > 0
        ).map((c) => ({
          ...KO.mapPieceToMetadata({
            piece: c,
            type: t
          }),
          suggestedActions: c.suggestedActions,
          suggestedTriggers: c.suggestedTriggers
        }));
        switch (t) {
          case "action":
            return [...BCe.filter(
              (a) => uwt(e, a)
            ), ...l];
          case "trigger":
            return [...l];
        }
      },
      enabled: n,
      staleTime: e ? 0 : 1 / 0
    });
    return {
      refetch: i.refetch,
      metadata: i.data,
      isLoading: i.isLoading
    };
  }
};
function uwt(e, t) {
  return e ? JSON.stringify({ data: t }).toLowerCase().includes(e == null ? void 0 : e.toLowerCase()) : !0;
}
const Zse = (e, t) => {
  const n = e.type === qe.PIECE || e.type === Bt.PIECE, r = n ? e.settings.pieceName : void 0, i = n ? e.settings.pieceVersion : void 0, o = "customLogoUrl" in e ? e.customLogoUrl : void 0, s = e.type === qe.PIECE ? e.settings.actionName : void 0, l = e.type === Bt.PIECE ? e.settings.triggerName : void 0;
  return [
    s,
    l,
    r,
    i,
    o,
    t,
    e.type
  ];
}, XCe = Ri({
  flowId: "",
  projectId: "",
  platformId: "",
  apiService: {},
  runId: null,
  setRunId: () => {
  },
  clearRunId: () => {
  }
}), dwt = ({ flowId: e, projectId: t, platformId: n, apiService: r, runId: i, children: o }) => {
  const [s, l] = He(i), c = () => l(null);
  return /* @__PURE__ */ y(XCe.Provider, { value: { flowId: e, projectId: t, platformId: n, apiService: r, runId: s, setRunId: l, clearRunId: c }, children: o });
}, ol = () => kr(XCe), {
  getPinnedPieces: WCe,
  getPopularPieces: ZCe,
  getAiAndAgentsPieces: fwt,
  isUtilityPiece: pwt,
  isAppPiece: Hse,
  getHighlightedPieces: hwt,
  isFlowController: mwt
} = swt, nd = {
  usePiece: ({ name: e, version: t, enabled: n = !0 }) => {
    const { i18n: r } = tc(), i = pr({
      queryKey: ["piece", e, t],
      queryFn: () => Yd.get({ name: e, version: t, locale: r.language }),
      staleTime: 1 / 0,
      enabled: n
    });
    return console.log("Performed the usePiece query for", e, t, "with result", i.data), {
      pieceModel: i.data,
      isLoading: i.isLoading,
      isSuccess: i.isSuccess,
      refetch: i.refetch
    };
  },
  usePieceModelForStepSettings: ({
    name: e,
    version: t,
    enabled: n = !0,
    getExactVersion: r
  }) => {
    const i = t ? Ic.getExactVersion(t) : void 0, o = i ? Ic.getMostRecentPatchVersion(i) : void 0, s = nd.usePiece({
      name: e,
      version: i,
      enabled: n
    }), l = nd.usePiece({
      name: e,
      version: o,
      enabled: n
    });
    return {
      pieceModel: r ? s.pieceModel : l.pieceModel,
      isLoading: s.isLoading || l.isLoading,
      isSuccess: s.isSuccess && l.isSuccess,
      refetch: () => {
        s.refetch(), l.refetch();
      }
    };
  },
  useMultiplePieces: ({ names: e }) => {
    const { i18n: t } = tc();
    return mwe({
      queries: e.map((n) => ({
        queryKey: ["piece", n, void 0],
        queryFn: () => Yd.get({
          name: n,
          version: void 0,
          locale: t.language
        }),
        staleTime: 1 / 0
      }))
    });
  },
  usePieces: ({
    searchQuery: e,
    includeHidden: t = !1,
    includeTags: n = !1
  }) => {
    const { i18n: r } = tc(), i = pr({
      queryKey: ["pieces", e, t],
      queryFn: () => Yd.list({
        projectId: Rn.getProjectId(),
        searchQuery: e,
        includeHidden: t,
        includeTags: n,
        locale: r.language
      }),
      staleTime: e ? 0 : 1 / 0
    });
    return {
      pieces: i.data,
      isLoading: i.isLoading,
      refetch: i.refetch
    };
  },
  usePiecesSearch: (e) => {
    console.log("Using pieceHooks.usePiecesSearch with props", e);
    const { selectedTab: t } = yx();
    console.log("Current selectedTab is", t);
    const { capture: n } = yj();
    console.log("Telemetry capture function is", n);
    const { data: r } = Go.useFlag(
      As.ENVIRONMENT
    );
    console.log("Current environment is", r);
    const { metadata: i, isLoading: o } = vd.useAllStepsMetadata(e);
    console.log("Steps metadata fetched:", i);
    const { platform: s } = dN.useCurrentPlatform();
    if (console.log("Current platform is", s), !i || o)
      return {
        isLoading: !0,
        data: []
      };
    const l = gwt(i), c = WCe(
      l,
      s.pinnedPieces ?? []
    );
    console.log("Pinned pieces determined:", c);
    const a = ZCe(
      l,
      s.pinnedPieces ?? []
    );
    console.log("Popular pieces determined:", a);
    const u = l.filter(mwt), f = l.filter(pwt), p = l.filter(
      (w) => !a.includes(w) && !c.includes(w)
    ).filter(Hse), h = {
      title: Z("Utility"),
      metadata: f
    }, m = {
      title: Z("Flow Controller"),
      metadata: u
    }, v = {
      title: Z("Apps"),
      metadata: p
    }, b = {
      title: Z("Popular"),
      metadata: a
    }, A = {
      title: Z("All"),
      metadata: l
    };
    switch (t) {
      case $o.EXPLORE:
        return {
          isLoading: !1,
          data: ywt(
            l,
            s,
            e.type,
            r
          )
        };
      case $o.UTILITY:
        return {
          isLoading: !1,
          data: [h, m]
        };
      case $o.AI_AND_AGENTS:
        return {
          isLoading: !1,
          data: fwt(l)
        };
      case $o.APPS: {
        const O = {
          isLoading: !1,
          data: [{
            ...b,
            metadata: b.metadata.filter(Hse)
          }, v]
        };
        return c.length > 0 && O.data.unshift({
          title: Z("Highlights"),
          metadata: c
        }), O;
      }
      case $o.NONE:
        return e.shouldCaptureEvent && e.searchQuery.length > 3 && n({
          name: Ww.PIECE_SELECTOR_SEARCH,
          payload: {
            search: e.searchQuery,
            isTrigger: e.type === "trigger",
            selectedActionOrTriggerName: null
          }
        }), {
          isLoading: !1,
          data: A.metadata.length > 0 ? [A] : []
        };
    }
  },
  usePieceOptions: ({
    onSuccess: e,
    onError: t,
    onMutate: n
  }) => dr({
    mutationFn: async ({ request: r, propertyType: i }) => (n(), Yd.options(r, i)),
    onSuccess: e,
    onError: t,
    retry: 1,
    retryDelay: 1e3
  }),
  usePieceForEmbeddingConnection: ({
    pieceName: e,
    connectionExternalId: t
  }) => {
    const { projectId: n } = ol();
    return pr({
      queryKey: ["piece", e, t],
      queryFn: async () => {
        const r = (await Lp.list({
          pieceName: e,
          limit: 1,
          projectId: n
        })).data.find(
          (i) => i.externalId === t
        );
        return r ? Yd.get({
          name: r.pieceName,
          version: r.pieceVersion
        }) : Yd.get({ name: e });
      },
      staleTime: 1 / 0
    });
  }
}, gwt = (e) => e.filter((t) => {
  const n = t.type === qe.PIECE && t.suggestedActions && t.suggestedActions.length > 0, r = t.type === Bt.PIECE && t.suggestedTriggers && t.suggestedTriggers.length > 0, i = t.type !== qe.PIECE && t.type !== Bt.PIECE;
  return n || r || i;
}), ywt = (e, t, n, r) => {
  const i = {
    title: Z("Popular"),
    metadata: r === qM.DEVELOPMENT ? e : []
  };
  if (r === qM.DEVELOPMENT)
    return [i];
  const o = WCe(
    e,
    t.pinnedPieces ?? []
  ), s = ZCe(
    e,
    t.pinnedPieces ?? []
  );
  s.length > 0 && (i.metadata = [...i.metadata, ...s]);
  const l = {
    title: Z("Highlights"),
    metadata: []
  }, c = hwt(e, n), a = e.find(
    (d) => d.type === qe.CODE
  ), u = e.find(
    (d) => d.type === qe.ROUTER
  ), f = e.find(
    (d) => d.type === qe.LOOP_ON_ITEMS
  );
  return c.length > 0 && l.metadata.push(...c), u && l.metadata.splice(0, 0, u), a && l.metadata.splice(3, 0, a), f && l.metadata.splice(5, 0, f), o.length > 0 && (l.metadata = [
    ...o,
    ...l.metadata
  ]), [i, l];
}, vwt = "data:image/png;base64,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", bwt = "data:image/png;base64,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", Owt = "data:image/png;base64,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";
function vj(e) {
  const t = N.useRef({ value: e, previous: e });
  return N.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var D$ = "Radio", [Awt, HCe] = Ms(D$), [wwt, xwt] = Awt(D$), QCe = N.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: i = !1,
      required: o,
      disabled: s,
      value: l = "on",
      onCheck: c,
      ...a
    } = e, [u, f] = N.useState(null), d = xn(t, (m) => f(m)), p = N.useRef(!1), h = u ? !!u.closest("form") : !0;
    return /* @__PURE__ */ V(wwt, { scope: n, checked: i, disabled: s, children: [
      /* @__PURE__ */ y(
        Zt.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": GCe(i),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...a,
          ref: d,
          onClick: ot(e.onClick, (m) => {
            i || c == null || c(), h && (p.current = m.isPropagationStopped(), p.current || m.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ y(
        Swt,
        {
          control: u,
          bubbles: !p.current,
          name: r,
          value: l,
          checked: i,
          required: o,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
QCe.displayName = D$;
var $Ce = "RadioIndicator", KCe = N.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...i } = e, o = xwt($Ce, n);
    return /* @__PURE__ */ y(wo, { present: r || o.checked, children: /* @__PURE__ */ y(
      Zt.span,
      {
        "data-state": GCe(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: t
      }
    ) });
  }
);
KCe.displayName = $Ce;
var Swt = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = N.useRef(null), s = vj(n), l = Az(t);
  return N.useEffect(() => {
    const c = o.current, a = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(a, "checked").set;
    if (s !== n && f) {
      const d = new Event("click", { bubbles: r });
      f.call(c, n), c.dispatchEvent(d);
    }
  }, [s, n, r]), /* @__PURE__ */ y(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function GCe(e) {
  return e ? "checked" : "unchecked";
}
var Ewt = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], _$ = "RadioGroup", [Twt, nmn] = Ms(_$, [
  Cg,
  HCe
]), YCe = Cg(), JCe = HCe(), [kwt, Cwt] = Twt(_$), eNe = N.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: i,
      value: o,
      required: s = !1,
      disabled: l = !1,
      orientation: c,
      dir: a,
      loop: u = !0,
      onValueChange: f,
      ...d
    } = e, p = YCe(n), h = Eb(a), [m, v] = wl({
      prop: o,
      defaultProp: i,
      onChange: f
    });
    return /* @__PURE__ */ y(
      kwt,
      {
        scope: n,
        name: r,
        required: s,
        disabled: l,
        value: m,
        onValueChange: v,
        children: /* @__PURE__ */ y(
          tj,
          {
            asChild: !0,
            ...p,
            orientation: c,
            dir: h,
            loop: u,
            children: /* @__PURE__ */ y(
              Zt.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": c,
                "data-disabled": l ? "" : void 0,
                dir: h,
                ...d,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
eNe.displayName = _$;
var tNe = "RadioGroupItem", nNe = N.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...i } = e, o = Cwt(tNe, n), s = o.disabled || r, l = YCe(n), c = JCe(n), a = N.useRef(null), u = xn(t, a), f = o.value === i.value, d = N.useRef(!1);
    return N.useEffect(() => {
      const p = (m) => {
        Ewt.includes(m.key) && (d.current = !0);
      }, h = () => d.current = !1;
      return document.addEventListener("keydown", p), document.addEventListener("keyup", h), () => {
        document.removeEventListener("keydown", p), document.removeEventListener("keyup", h);
      };
    }, []), /* @__PURE__ */ y(
      nj,
      {
        asChild: !0,
        ...l,
        focusable: !s,
        active: f,
        children: /* @__PURE__ */ y(
          QCe,
          {
            disabled: s,
            required: o.required,
            checked: f,
            ...c,
            ...i,
            name: o.name,
            ref: u,
            onCheck: () => o.onValueChange(i.value),
            onKeyDown: ot((p) => {
              p.key === "Enter" && p.preventDefault();
            }),
            onFocus: ot(i.onFocus, () => {
              var p;
              d.current && ((p = a.current) == null || p.click());
            })
          }
        )
      }
    );
  }
);
nNe.displayName = tNe;
var Nwt = "RadioGroupIndicator", rNe = N.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, i = JCe(n);
    return /* @__PURE__ */ y(KCe, { ...i, ...r, ref: t });
  }
);
rNe.displayName = Nwt;
var Pwt = eNe, Iwt = nNe, Rwt = rNe;
function Mwt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ y(
    Pwt,
    {
      "data-slot": "radio-group",
      className: Se("grid gap-3", e),
      ...t
    }
  );
}
function Dwt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ y(
    Iwt,
    {
      "data-slot": "radio-group-item",
      className: Se(
        "border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-2xs transition-[color,box-shadow] outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ y(
        Rwt,
        {
          "data-slot": "radio-group-indicator",
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ y(QH, { className: "fill-primary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" })
        }
      )
    }
  );
}
const L$ = ({
  items: e,
  onChange: t,
  value: n,
  onHover: r,
  className: i
}) => /* @__PURE__ */ y("div", { className: Se("space-y-4", i), children: /* @__PURE__ */ y(Mwt, { value: JSON.stringify(n), children: e.map((o, s) => {
  const l = o.value === n;
  return /* @__PURE__ */ V(
    Ng,
    {
      className: Se(
        "p-4 rounded-lg border block hover:border-primary/50 hover:bg-muted/50",
        {
          "border-primary bg-primary/5": l
        }
      ),
      onClick: () => t(o.value),
      onMouseEnter: () => r && r(o.value),
      onMouseLeave: () => r && r(null),
      children: [
        /* @__PURE__ */ V("div", { className: "flex justify-between items-center mb-2", children: [
          /* @__PURE__ */ V("h4", { className: "text-md font-medium flex items-center gap-2", children: [
            o.label,
            o.labelExtra
          ] }),
          /* @__PURE__ */ y("div", { className: "shrink-0 w-5 h-5", children: /* @__PURE__ */ y(
            Dwt,
            {
              value: JSON.stringify(o.value),
              className: "scale-125"
            }
          ) })
        ] }),
        /* @__PURE__ */ y("div", { className: "text-sm text-muted-foreground", children: o.description })
      ]
    },
    s
  );
}) }) });
L$.displayName = "RadioGroupList";
const qa = USe, z$ = dut, _wt = VSe, fh = TQ, iNe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nz,
  {
    ref: n,
    tabIndex: -1,
    className: Se(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 outline-none",
      e
    ),
    ...t
  }
));
iNe.displayName = Nz.displayName;
const ia = N.forwardRef(
  ({
    className: e,
    children: t,
    withCloseButton: n = !0,
    showOverlay: r = !0,
    ...i
  }, o) => {
    const { i18n: s } = tc(), l = s.dir() === "rtl";
    return /* @__PURE__ */ V(_wt, { children: [
      r && /* @__PURE__ */ y(iNe, {}),
      /* @__PURE__ */ V(
        Pz,
        {
          ref: o,
          className: Se(
            "fixed left-[50%] top-[50%] outline-none z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] g4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
            e
          ),
          ...i,
          children: [
            t,
            n && /* @__PURE__ */ V(
              TQ,
              {
                className: Se(
                  "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none",
                  l ? "left-4" : "right-4"
                ),
                children: [
                  /* @__PURE__ */ y(ks, { className: "size-4" }),
                  /* @__PURE__ */ y("span", { className: "sr-only", children: "Close" })
                ]
              }
            )
          ]
        }
      )
    ] });
  }
);
ia.displayName = Pz.displayName;
const Ds = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y(
  "div",
  {
    className: Se(
      "flex flex-col space-y-1.5 gap-3 text-center sm:text-left mb-4",
      e
    ),
    ...t
  }
);
Ds.displayName = "DialogHeader";
const kl = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y(
  "div",
  {
    className: Se(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-4",
      e
    ),
    ...t
  }
);
kl.displayName = "DialogFooter";
const _s = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Iz,
  {
    ref: n,
    className: Se(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
_s.displayName = Iz.displayName;
const kb = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Rz,
  {
    ref: n,
    className: Se("text-sm text-muted-foreground", e),
    ...t
  }
));
kb.displayName = Rz.displayName;
const Lwt = {
  isEmbedded: !1,
  hideSideNav: !1,
  hideFlowsPageNavbar: !1,
  disableNavigationInBuilder: !1,
  hideFolders: !1,
  hideFlowNameInBuilder: !1,
  hideExportAndImportFlow: !1,
  useDarkBackground: window.opener !== null,
  hideHomeButtonInBuilder: !1,
  emitHomeButtonClickedEvent: !1,
  homeButtonIcon: "logo",
  hideDuplicateFlow: !1,
  hidePageHeader: !1
}, zwt = Ri({
  embedState: Lwt,
  setEmbedState: () => {
  }
}), bd = () => kr(zwt), jwt = () => {
  const { embedState: e } = bd(), t = sT();
  return e.isEmbedded ? (n, r) => t({
    pathname: n,
    search: r
  }) : (n, r) => window.open(
    `${n}${r ? "?" + r : ""}`,
    "_blank",
    "noopener noreferrer"
  );
}, Qse = "from", Fwt = "state", Uwt = "activepiecesLogin", Vwt = "providerName", qwt = (e) => {
  switch (e) {
    case $s.INTERNAL:
      return kX.createTodoAndWait;
    case $s.EXTERNAL:
      return kX.createTodo;
  }
}, oNe = (e, t) => {
  var r;
  const n = (r = e.suggestedActions) == null ? void 0 : r.find(
    (i) => i.name === t
  );
  return De(n) ? (Kc(), console.error(`Action ${t} not found in piece metadata`), null) : n;
}, $se = ({
  parentStepName: e,
  logoUrl: t,
  handleAddingOrUpdatingStep: n
}) => {
  const r = {
    branches: [
      {
        conditions: [
          [
            {
              operator: Gr.TEXT_EXACTLY_MATCHES,
              firstValue: `{{ ${e}['status'] }}`,
              secondValue: "Accepted",
              caseSensitive: !1
            }
          ]
        ],
        branchType: iu.CONDITION,
        branchName: "Accepted"
      },
      {
        branchType: iu.FALLBACK,
        branchName: "Rejected"
      }
    ],
    executionType: ah.EXECUTE_FIRST_MATCH
  };
  return n({
    pieceSelectorItem: {
      ...PE[qe.ROUTER],
      displayName: Z("Check Todo Status")
    },
    operation: {
      type: Tt.ADD_ACTION,
      actionLocation: {
        parentStep: e,
        stepLocationRelativeToParent: Hn.AFTER
      }
    },
    selectStepAfter: !1,
    overrideSettings: r,
    customLogoUrl: t
  });
}, Bwt = ({
  pieceMetadata: e,
  operation: t,
  todoType: n,
  handleAddingOrUpdatingStep: r
}) => {
  const i = qwt(n), o = oNe(
    e,
    i
  );
  return De(o) ? null : r({
    pieceSelectorItem: {
      actionOrTrigger: o,
      type: qe.PIECE,
      pieceMetadata: e
    },
    operation: t,
    selectStepAfter: !0
  });
}, Xwt = ({
  pieceMetadata: e,
  parentStepName: t,
  handleAddingOrUpdatingStep: n
}) => {
  const r = oNe(
    e,
    kX.waitForApproval
  );
  if (De(r))
    return null;
  const i = {
    actionOrTrigger: r,
    type: qe.PIECE,
    pieceMetadata: e
  }, o = {
    pieceSelectorItem: i,
    operation: {
      type: Tt.ADD_ACTION,
      actionLocation: {
        parentStep: t,
        stepLocationRelativeToParent: Hn.AFTER
      }
    },
    selectStepAfter: !1
  }, s = n(o), l = xf.getDefaultStepValues({
    stepName: s,
    pieceSelectorItem: {
      actionOrTrigger: r,
      type: qe.PIECE,
      pieceMetadata: e
    }
  });
  return l.settings.input.taskId = `{{ ${t}['id'] }}`, n({
    pieceSelectorItem: i,
    operation: {
      type: Tt.UPDATE_ACTION,
      stepName: s
    },
    selectStepAfter: !1,
    overrideSettings: l.settings
  });
};
/*! Fast Average Color | © 2025 Denis Seleznev | MIT License | https://github.com/fast-average-color/fast-average-color */
function Wwt(e) {
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function Kse(e) {
  return "#" + e.map(Wwt).join("");
}
function Zwt(e) {
  var t = (e[0] * 299 + e[1] * 587 + e[2] * 114) / 1e3;
  return t < 128;
}
function Hwt(e) {
  return e ? Qwt(e) ? e : [e] : [];
}
function Qwt(e) {
  return Array.isArray(e[0]);
}
function j$(e, t, n) {
  for (var r = 0; r < n.length; r++)
    if ($wt(e, t, n[r]))
      return !0;
  return !1;
}
function $wt(e, t, n) {
  switch (n.length) {
    case 3:
      if (Kwt(e, t, n))
        return !0;
      break;
    case 4:
      if (Gwt(e, t, n))
        return !0;
      break;
    case 5:
      if (Ywt(e, t, n))
        return !0;
      break;
    default:
      return !1;
  }
}
function Kwt(e, t, n) {
  return e[t + 3] !== 255 || e[t] === n[0] && e[t + 1] === n[1] && e[t + 2] === n[2];
}
function Gwt(e, t, n) {
  return e[t + 3] && n[3] ? e[t] === n[0] && e[t + 1] === n[1] && e[t + 2] === n[2] && e[t + 3] === n[3] : e[t + 3] === n[3];
}
function KP(e, t, n) {
  return e >= t - n && e <= t + n;
}
function Ywt(e, t, n) {
  var r = n[0], i = n[1], o = n[2], s = n[3], l = n[4], c = e[t + 3], a = KP(c, s, l);
  return s ? !!(!c && a || KP(e[t], r, l) && KP(e[t + 1], i, l) && KP(e[t + 2], o, l) && a) : a;
}
var Jwt = 24;
function ext(e, t, n) {
  for (var r = {}, i = n.dominantDivider || Jwt, o = n.ignoredColor, s = n.step, l = [0, 0, 0, 0, 0], c = 0; c < t; c += s) {
    var a = e[c], u = e[c + 1], f = e[c + 2], d = e[c + 3];
    if (!(o && j$(e, c, o))) {
      var p = Math.round(a / i) + "," + Math.round(u / i) + "," + Math.round(f / i);
      r[p] ? r[p] = [
        r[p][0] + a * d,
        r[p][1] + u * d,
        r[p][2] + f * d,
        r[p][3] + d,
        r[p][4] + 1
      ] : r[p] = [a * d, u * d, f * d, d, 1], l[4] < r[p][4] && (l = r[p]);
    }
  }
  var h = l[0], m = l[1], v = l[2], b = l[3], A = l[4];
  return b ? [
    Math.round(h / b),
    Math.round(m / b),
    Math.round(v / b),
    Math.round(b / A)
  ] : n.defaultColor;
}
function txt(e, t, n) {
  for (var r = 0, i = 0, o = 0, s = 0, l = 0, c = n.ignoredColor, a = n.step, u = 0; u < t; u += a) {
    var f = e[u + 3], d = e[u] * f, p = e[u + 1] * f, h = e[u + 2] * f;
    c && j$(e, u, c) || (r += d, i += p, o += h, s += f, l++);
  }
  return s ? [
    Math.round(r / s),
    Math.round(i / s),
    Math.round(o / s),
    Math.round(s / l)
  ] : n.defaultColor;
}
function nxt(e, t, n) {
  for (var r = 0, i = 0, o = 0, s = 0, l = 0, c = n.ignoredColor, a = n.step, u = 0; u < t; u += a) {
    var f = e[u], d = e[u + 1], p = e[u + 2], h = e[u + 3];
    c && j$(e, u, c) || (r += f * f * h, i += d * d * h, o += p * p * h, s += h, l++);
  }
  return s ? [
    Math.round(Math.sqrt(r / s)),
    Math.round(Math.sqrt(i / s)),
    Math.round(Math.sqrt(o / s)),
    Math.round(s / l)
  ] : n.defaultColor;
}
function Gse(e) {
  return o1(e, "defaultColor", [0, 0, 0, 0]);
}
function o1(e, t, n) {
  return e[t] === void 0 ? n : e[t];
}
var Yse = 10, CX = 100;
function rxt(e) {
  return e.search(/\.svg(\?|$)/i) !== -1;
}
function ixt(e) {
  if (sNe(e)) {
    var t = e.naturalWidth, n = e.naturalHeight;
    return !e.naturalWidth && rxt(e.src) && (t = n = CX), {
      width: t,
      height: n
    };
  }
  return sxt(e) ? {
    width: e.videoWidth,
    height: e.videoHeight
  } : lNe(e) ? {
    width: e.codedWidth,
    height: e.codedHeight
  } : {
    width: e.width,
    height: e.height
  };
}
function Jse(e) {
  return axt(e) ? "canvas" : oxt(e) ? "offscreencanvas" : lNe(e) ? "videoframe" : lxt(e) ? "imagebitmap" : e.src;
}
function sNe(e) {
  return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement;
}
var aNe = typeof OffscreenCanvas < "u";
function oxt(e) {
  return aNe && e instanceof OffscreenCanvas;
}
function sxt(e) {
  return typeof HTMLVideoElement < "u" && e instanceof HTMLVideoElement;
}
function lNe(e) {
  return typeof VideoFrame < "u" && e instanceof VideoFrame;
}
function axt(e) {
  return typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement;
}
function lxt(e) {
  return typeof ImageBitmap < "u" && e instanceof ImageBitmap;
}
function cxt(e, t) {
  var n = o1(t, "left", 0), r = o1(t, "top", 0), i = o1(t, "width", e.width), o = o1(t, "height", e.height), s = i, l = o;
  if (t.mode === "precision")
    return {
      srcLeft: n,
      srcTop: r,
      srcWidth: i,
      srcHeight: o,
      destWidth: s,
      destHeight: l
    };
  var c;
  return i > o ? (c = i / o, s = CX, l = Math.round(s / c)) : (c = o / i, l = CX, s = Math.round(l / c)), (s > i || l > o || s < Yse || l < Yse) && (s = i, l = o), {
    srcLeft: n,
    srcTop: r,
    srcWidth: i,
    srcHeight: o,
    destWidth: s,
    destHeight: l
  };
}
var uxt = typeof window > "u";
function dxt() {
  return uxt ? aNe ? new OffscreenCanvas(1, 1) : null : document.createElement("canvas");
}
var fxt = "FastAverageColor: ";
function Pd(e) {
  return Error(fxt + e);
}
function lS(e, t) {
  t || console.error(e);
}
var pxt = (
  /** @class */
  function() {
    function e() {
      this.canvas = null, this.ctx = null;
    }
    return e.prototype.getColorAsync = function(t, n) {
      if (!t)
        return Promise.reject(Pd("call .getColorAsync() without resource"));
      if (typeof t == "string") {
        if (typeof Image > "u")
          return Promise.reject(Pd("resource as string is not supported in this environment"));
        var r = new Image();
        return r.crossOrigin = n && n.crossOrigin || "", r.src = t, this.bindImageEvents(r, n);
      } else {
        if (sNe(t) && !t.complete)
          return this.bindImageEvents(t, n);
        var i = this.getColor(t, n);
        return i.error ? Promise.reject(i.error) : Promise.resolve(i);
      }
    }, e.prototype.getColor = function(t, n) {
      n = n || {};
      var r = Gse(n);
      if (!t) {
        var i = Pd("call .getColor() without resource");
        return lS(i, n.silent), this.prepareResult(r, i);
      }
      var o = ixt(t), s = cxt(o, n);
      if (!s.srcWidth || !s.srcHeight || !s.destWidth || !s.destHeight) {
        var i = Pd('incorrect sizes for resource "'.concat(Jse(t), '"'));
        return lS(i, n.silent), this.prepareResult(r, i);
      }
      if (!this.canvas && (this.canvas = dxt(), !this.canvas)) {
        var i = Pd("OffscreenCanvas is not supported in this browser");
        return lS(i, n.silent), this.prepareResult(r, i);
      }
      if (!this.ctx) {
        if (this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), !this.ctx) {
          var i = Pd("Canvas Context 2D is not supported in this browser");
          return lS(i, n.silent), this.prepareResult(r);
        }
        this.ctx.imageSmoothingEnabled = !1;
      }
      this.canvas.width = s.destWidth, this.canvas.height = s.destHeight;
      try {
        this.ctx.clearRect(0, 0, s.destWidth, s.destHeight), this.ctx.drawImage(t, s.srcLeft, s.srcTop, s.srcWidth, s.srcHeight, 0, 0, s.destWidth, s.destHeight);
        var l = this.ctx.getImageData(0, 0, s.destWidth, s.destHeight).data;
        return this.prepareResult(this.getColorFromArray4(l, n));
      } catch (c) {
        var i = Pd("security error (CORS) for resource ".concat(Jse(t), `.
Details: https://developer.mozilla.org/en/docs/Web/HTML/CORS_enabled_image`));
        return lS(i, n.silent), n.silent || console.error(c), this.prepareResult(r, i);
      }
    }, e.prototype.getColorFromArray4 = function(t, n) {
      n = n || {};
      var r = 4, i = t.length, o = Gse(n);
      if (i < r)
        return o;
      var s = i - i % r, l = (n.step || 1) * r, c;
      switch (n.algorithm || "sqrt") {
        case "simple":
          c = txt;
          break;
        case "sqrt":
          c = nxt;
          break;
        case "dominant":
          c = ext;
          break;
        default:
          throw Pd("".concat(n.algorithm, " is unknown algorithm"));
      }
      return c(t, s, {
        defaultColor: o,
        ignoredColor: Hwt(n.ignoredColor),
        step: l,
        dominantDivider: n.dominantDivider
      });
    }, e.prototype.prepareResult = function(t, n) {
      var r = t.slice(0, 3), i = [t[0], t[1], t[2], t[3] / 255], o = Zwt(t);
      return {
        value: [t[0], t[1], t[2], t[3]],
        rgb: "rgb(" + r.join(",") + ")",
        rgba: "rgba(" + i.join(",") + ")",
        hex: Kse(r),
        hexa: Kse(t),
        isDark: o,
        isLight: !o,
        error: n
      };
    }, e.prototype.destroy = function() {
      this.canvas && (this.canvas.width = 1, this.canvas.height = 1, this.canvas = null), this.ctx = null;
    }, e.prototype.bindImageEvents = function(t, n) {
      var r = this;
      return new Promise(function(i, o) {
        var s = function() {
          a();
          var u = r.getColor(t, n);
          u.error ? o(u.error) : i(u);
        }, l = function() {
          a(), o(Pd('Error loading image "'.concat(t.src, '"')));
        }, c = function() {
          a(), o(Pd('Image "'.concat(t.src, '" loading aborted')));
        }, a = function() {
          t.removeEventListener("load", s), t.removeEventListener("error", l), t.removeEventListener("abort", c);
        };
        t.addEventListener("load", s), t.addEventListener("error", l), t.addEventListener("abort", c);
      });
    }, e;
  }()
);
const ZD = {
  isGrayColor: (e, t, n) => {
    const s = e <= 150 && t <= 150 && n <= 150, l = e >= 225 && t >= 225 && n >= 225, c = Math.abs(e - t), a = Math.abs(e - n), u = Math.abs(t - n), f = c <= 15 && a <= 15 && u <= 15;
    return s || l || f;
  },
  fac: new pxt(),
  useAverageColorInImage: ({
    imgUrl: e,
    transparency: t
  }) => {
    const { data: n } = pr({
      queryKey: ["averageColorInImage", e, t],
      queryFn: async () => {
        const r = new Image();
        return r.crossOrigin = "anonymous", r.src = e, new Promise((i) => {
          r.onload = () => {
            ZD.fac.getColorAsync(r, { algorithm: "simple" }).then((o) => {
              const [s, l, c] = o.value;
              ZD.isGrayColor(s, l, c) ? i(null) : i(
                `color-mix(in srgb, rgb(${s},${l},${c}) ${t}%, #fff 92%)`
              );
            }).catch(() => {
              i(null);
            });
          };
        });
      }
    });
    return n;
  }
}, cNe = ({
  src: e,
  alt: t,
  fallback: n,
  ...r
}) => {
  const [i, o] = He(!1), [s, l] = He(!0), c = ZD.useAverageColorInImage({
    imgUrl: e ?? "",
    transparency: 10
  }), a = () => {
    l(!1);
  }, u = () => {
    o(!0), l(!1);
  }, { className: f, ...d } = r;
  return /* @__PURE__ */ V(
    "span",
    {
      className: Se(
        "relative inline-block h-full w-full rounded-lg",
        f,
        {
          "bg-background": c === null,
          "border border-border/50 dark:bg-foreground/10": c === null && r.border
        }
      ),
      style: c ? {
        backgroundColor: c
      } : {},
      children: [
        s && !i && /* @__PURE__ */ y("span", { className: "absolute inset-0 flex items-center justify-center", children: n ?? /* @__PURE__ */ y(Tr, { className: "w-full h-full" }) }),
        i ? /* @__PURE__ */ y("span", { className: "absolute inset-0 flex items-center justify-center", children: n ?? /* @__PURE__ */ y(Tr, { className: "w-full h-full" }) }) : /* @__PURE__ */ y(
          "img",
          {
            src: e,
            alt: t,
            onLoad: a,
            onError: u,
            className: Se(
              "transition-opacity duration-500 w-full h-full object-contain",
              {
                "opacity-0": s,
                "opacity-100": !s
              }
            ),
            ...d
          }
        )
      ]
    }
  );
}, hxt = as(
  "flex rounded-md items-center justify-center   ",
  {
    variants: {
      circle: {
        true: "rounded-full p-2",
        false: ""
      },
      size: {
        xxl: "size-[64px] p-4",
        xl: "size-[48px]",
        lg: "size-[40px]",
        md: "size-[36px] p-1.5",
        sm: "size-[25px]",
        xs: "size-[18px]"
      },
      border: {
        true: "border border-solid"
      }
    },
    defaultVariants: {}
  }
), Ig = ie.memo(
  ({
    displayName: e,
    logoUrl: t,
    border: n,
    size: r,
    circle: i = !1,
    showTooltip: o,
    background: s
  }) => /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
      "div",
      {
        className: Se(hxt({ border: n, size: r, circle: i })),
        style: s ? { backgroundColor: s } : void 0,
        children: t ? /* @__PURE__ */ y(
          cNe,
          {
            src: t,
            alt: e,
            className: "object-contain w-full h-full",
            fallback: /* @__PURE__ */ y(Tr, { className: "rounded-full w-full h-full" })
          },
          t
        ) : /* @__PURE__ */ y(Tr, { className: "rounded-full w-full h-full" })
      }
    ) }),
    o ? /* @__PURE__ */ y(An, { side: "bottom", children: e }) : null
  ] })
);
Ig.displayName = "PieceIcon";
const mxt = (e) => e.type === qe.PIECE || e.type === Bt.PIECE ? {
  displayName: e.actionOrTrigger.displayName,
  description: e.actionOrTrigger.description
} : {
  displayName: e.displayName,
  description: e.description
}, F$ = ({
  item: e,
  hidePieceIconAndDescription: t,
  stepMetadataWithSuggestions: n,
  onClick: r
}) => {
  const i = t ? {
    height: `${BT.ACTION_OR_TRIGGER_ITEM_HEIGHT}px`,
    maxHeight: `${BT.ACTION_OR_TRIGGER_ITEM_HEIGHT}px`
  } : {
    minHeight: "54px"
  }, o = mxt(e);
  return /* @__PURE__ */ y(
    Ng,
    {
      className: Se("p-2 w-full ", {
        truncate: t
      }),
      onClick: r,
      style: i,
      children: /* @__PURE__ */ V("div", { className: "flex gap-3 items-center", children: [
        /* @__PURE__ */ y(
          "div",
          {
            className: Se({
              "opacity-0": t
            }),
            children: /* @__PURE__ */ y(
              Ig,
              {
                logoUrl: n.logoUrl,
                displayName: n.displayName,
                showTooltip: !1,
                size: "sm"
              }
            )
          }
        ),
        /* @__PURE__ */ V("div", { className: "flex flex-col gap-0.5", children: [
          /* @__PURE__ */ y("div", { className: "text-sm", children: o.displayName }),
          !t && /* @__PURE__ */ y("div", { className: "text-xs text-muted-foreground", children: o.description.endsWith(".") ? o.description.slice(0, -1) : o.description })
        ] })
      ] })
    }
  );
};
F$.displayName = "GenericActionOrTriggerItem";
const uNe = ({
  operation: e,
  pieceSelectorItem: t,
  hidePieceIconAndDescription: n
}) => {
  const [r, i] = He($s.INTERNAL), [o, s] = He(null), [l] = tn((f) => [
    f.handleAddingOrUpdatingStep
  ]), c = () => {
    const f = Bwt({
      pieceMetadata: t.pieceMetadata,
      operation: e,
      todoType: r,
      handleAddingOrUpdatingStep: l
    });
    if (!De(f))
      switch (r) {
        case $s.INTERNAL: {
          $se({
            parentStepName: f,
            logoUrl: t.pieceMetadata.logoUrl,
            handleAddingOrUpdatingStep: l
          });
          break;
        }
        case $s.EXTERNAL: {
          const d = Xwt({
            pieceMetadata: t.pieceMetadata,
            parentStepName: f,
            handleAddingOrUpdatingStep: l
          });
          if (!d)
            return;
          $se({
            parentStepName: d,
            logoUrl: t.pieceMetadata.logoUrl,
            handleAddingOrUpdatingStep: l
          });
          break;
        }
      }
  }, [a, u] = He(!1);
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      F$,
      {
        item: t,
        hidePieceIconAndDescription: n,
        stepMetadataWithSuggestions: t.pieceMetadata,
        onClick: () => u(!0)
      }
    ),
    /* @__PURE__ */ y(qa, { open: a, onOpenChange: u, children: /* @__PURE__ */ V(ia, { className: "max-w-6xl max-h-[80vh] overflow-hidden flex flex-col", children: [
      /* @__PURE__ */ y(Ds, { className: "shrink-0", children: /* @__PURE__ */ y(_s, { className: "text-xl", children: Z("Create Todo") }) }),
      /* @__PURE__ */ y("div", { className: "flex-1 overflow-y-auto pr-1", children: /* @__PURE__ */ V("div", { className: "flex flex-col md:flex-row gap-6", children: [
        /* @__PURE__ */ V("div", { className: "md:w-1/2 space-y-6", children: [
          /* @__PURE__ */ y("h3", { className: "text-lg font-medium", children: Z("Where would you like the todo to be reviewed?") }),
          /* @__PURE__ */ y("div", { className: "space-y-4", children: /* @__PURE__ */ y(
            yxt,
            {
              setTodoType: i,
              setHoveredOption: s,
              selectedTodoType: r
            }
          ) })
        ] }),
        /* @__PURE__ */ y("div", { className: "md:w-1/2 flex flex-col items-center justify-center", children: /* @__PURE__ */ y(gxt, { todoType: o || r }) })
      ] }) }),
      /* @__PURE__ */ V(kl, { className: "shrink-0 mt-3 pt-3", children: [
        /* @__PURE__ */ y(
          Qe,
          {
            variant: "outline",
            onClick: () => u(!1),
            className: "mr-2",
            children: Z("Cancel")
          }
        ),
        /* @__PURE__ */ y(Qe, { onClick: c, children: Z("Add Steps") })
      ] })
    ] }) })
  ] });
};
uNe.displayName = "CreateTodoDialog";
const gxt = ({ todoType: e }) => {
  const t = e === $s.INTERNAL ? vwt : Owt, n = e === $s.INTERNAL ? "Todos flow" : "External channel flow", r = e === $s.INTERNAL ? Z("Preview (Activepieces Todos)") : Z("Preview (External channel)"), i = e === $s.INTERNAL ? Z("Users will manage tasks directly in our interface") : Z(
    "Send notifications with approval links via external channels like Slack, Teams or Email. Best for collaborating with external stakeholders."
  );
  return /* @__PURE__ */ y("div", { className: "overflow-hidden p-3 w-full h-full", children: /* @__PURE__ */ V("div", { className: "flex flex-col items-center h-[480px]", children: [
    /* @__PURE__ */ y("h3", { className: "text-md font-medium mb-3 text-center", children: r }),
    /* @__PURE__ */ V("div", { className: "w-full h-[350px]  rounded mb-2 flex items-center justify-center bg-muted/50 relative", children: [
      /* @__PURE__ */ y("img", { src: t, alt: n, className: "w-full h-full object-contain" }),
      /* @__PURE__ */ y("div", { className: "absolute -bottom-1 left-0 right-0 h-28 bg-linear-to-t from-white dark:from-background to-transparent" })
    ] }),
    /* @__PURE__ */ y("p", { className: "text-sm text-muted-foreground italic text-center mb-2", children: i })
  ] }) });
}, yxt = ({
  setTodoType: e,
  setHoveredOption: t,
  selectedTodoType: n
}) => {
  const r = jwt();
  return /* @__PURE__ */ y(
    L$,
    {
      value: n,
      items: [
        {
          label: Z("Internal Todos"),
          value: $s.INTERNAL,
          description: Z("Users will manage tasks directly in our interface"),
          labelExtra: /* @__PURE__ */ V(wn, { delayDuration: 100, children: [
            /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(QA, { className: "w-4 h-4" }) }),
            /* @__PURE__ */ y(An, { side: "right", className: "w-[550px]", children: /* @__PURE__ */ V("div", { className: "space-y-2", children: [
              /* @__PURE__ */ V("div", { children: [
                /* @__PURE__ */ y("span", { className: "text-sm select-none", children: Z("Users will manage tasks directly in our interface") }),
                " ",
                /* @__PURE__ */ y(
                  "span",
                  {
                    className: "text-sm text-primary underline cursor-pointer",
                    onClick: () => r("/todos"),
                    children: Z("here")
                  }
                )
              ] }),
              /* @__PURE__ */ y("div", { className: "bg-muted rounded p-1", children: /* @__PURE__ */ y(
                "img",
                {
                  src: bwt,
                  alt: "Todo UI",
                  className: "w-full h-auto rounded"
                }
              ) })
            ] }) })
          ] })
        },
        {
          label: Z("External Channel (Slack, Teams, Email, ...)"),
          value: $s.EXTERNAL,
          description: Z(
            "Send notifications with approval links via external channels like Slack, Teams or Email. Best for collaborating with external stakeholders."
          )
        }
      ],
      onChange: e,
      onHover: t
    }
  );
}, dNe = (e) => {
  switch (e.type) {
    case qe.PIECE:
      return xf.removeHiddenActions(
        e
      ).map((n) => ({
        actionOrTrigger: n,
        type: qe.PIECE,
        pieceMetadata: e
      }));
    case Bt.PIECE:
      return Object.values(
        e.suggestedTriggers ?? {}
      ).map((n) => ({
        actionOrTrigger: n,
        type: Bt.PIECE,
        pieceMetadata: e
      }));
    case qe.CODE:
    case qe.LOOP_ON_ITEMS:
    case qe.ROUTER:
      return BCe.filter(
        (t) => t.type === e.type
      );
    default:
      return [];
  }
}, U$ = ({
  stepMetadataWithSuggestions: e,
  hidePieceIconAndDescription: t,
  operation: n
}) => {
  const { capture: r } = yj(), { searchQuery: i } = Yz(), [o] = tn((l) => [
    l.handleAddingOrUpdatingStep
  ]);
  if (De(e))
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 items-center justify-center h-full w-full", children: [
      /* @__PURE__ */ y(wot, { className: "w-10 h-10 rtl:rotate-180" }),
      /* @__PURE__ */ y("div", { className: "text-sm", children: Z("Please select a piece first") })
    ] });
  const s = dNe(
    e
  );
  return /* @__PURE__ */ y(Bi, { className: "h-full", viewPortClassName: "h-full", children: /* @__PURE__ */ y(w$, { className: "min-w-[350px] h-full gap-0", listClassName: "gap-0", children: s && s.map((l, c) => l.type === qe.PIECE && l.actionOrTrigger.name === "createTodo" ? /* @__PURE__ */ y(
    uNe,
    {
      pieceSelectorItem: l,
      operation: n,
      hidePieceIconAndDescription: t
    },
    c
  ) : /* @__PURE__ */ y(
    F$,
    {
      item: l,
      hidePieceIconAndDescription: t,
      stepMetadataWithSuggestions: e,
      onClick: () => {
        (l.type === qe.PIECE || l.type === Bt.PIECE) && r({
          name: Ww.PIECE_SELECTOR_SEARCH,
          payload: {
            search: i,
            isTrigger: l.type === Bt.PIECE,
            selectedActionOrTriggerName: l.actionOrTrigger.name
          }
        }), o({
          pieceSelectorItem: l,
          operation: n,
          selectStepAfter: !0
        });
      }
    },
    c
  )) }) });
}, vxt = (e) => e.type === qe.PIECE || e.type === Bt.PIECE ? {
  displayName: e.actionOrTrigger.displayName,
  description: e.actionOrTrigger.description
} : {
  displayName: e.displayName,
  description: e.description
}, fNe = ({
  item: e,
  stepMetadataWithSuggestions: t,
  onClick: n
}) => {
  const r = vxt(e);
  return /* @__PURE__ */ y(
    Ng,
    {
      className: "p-4 w-full h-full rounded-md flex flex-col justify-between h-[125px]",
      onClick: n,
      children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-3", children: [
        /* @__PURE__ */ y("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ y(
          Ig,
          {
            logoUrl: t.logoUrl,
            displayName: t.displayName,
            showTooltip: !1,
            size: "lg"
          }
        ) }),
        /* @__PURE__ */ y("div", { className: "flex flex-col gap-1 text-center", children: /* @__PURE__ */ y("div", { className: "text-sm font-medium leading-tight", children: r.displayName }) })
      ] })
    }
  );
};
fNe.displayName = "AIActionItem";
const bxt = {
  run_agent: "https://cdn.activepieces.com/pieces/agent.png",
  generateImage: "https://cdn.activepieces.com/pieces/image-ai.svg",
  askAi: "https://cdn.activepieces.com/pieces/text-ai.svg",
  summarizeText: "https://cdn.activepieces.com/pieces/text-ai.svg",
  classifyText: "https://cdn.activepieces.com/pieces/text-ai.svg",
  extractStructuredData: "https://cdn.activepieces.com/pieces/ai-utility.svg"
}, Oxt = ({
  stepMetadataWithSuggestions: e,
  hidePieceIconAndDescription: t,
  operation: n
}) => {
  const { capture: r } = yj(), { searchQuery: i } = Yz(), [o] = tn((a) => [
    a.handleAddingOrUpdatingStep
  ]), { data: s } = Go.useFlag(
    As.AGENTS_CONFIGURED
  ), l = sT(), c = dNe(
    e
  );
  return /* @__PURE__ */ y(Bi, { className: "h-full", viewPortClassName: "h-full", children: /* @__PURE__ */ y("div", { className: "grid grid-cols-3 p-2 gap-3 min-w-[350px]", children: c.map((a, u) => {
    const f = a.type === qe.PIECE ? bxt[a.actionOrTrigger.name] : "https://cdn.activepieces.com/pieces/image-ai.svg";
    return /* @__PURE__ */ y(
      fNe,
      {
        item: a,
        hidePieceIconAndDescription: t,
        stepMetadataWithSuggestions: {
          ...e,
          logoUrl: f
        },
        onClick: () => {
          if (!s) {
            vr("Connect to OpenAI", {
              description: Z(
                "To create an agent, you'll first need to connect to OpenAI in platform settings."
              ),
              action: {
                label: "Set Up",
                onClick: () => {
                  l("/platform/setup/ai");
                }
              }
            });
            return;
          }
          a.type === qe.PIECE && r({
            name: Ww.PIECE_SELECTOR_SEARCH,
            payload: {
              search: i,
              isTrigger: !1,
              selectedActionOrTriggerName: a.actionOrTrigger.name
            }
          }), o({
            pieceSelectorItem: a,
            operation: n,
            selectStepAfter: !0
          });
        }
      },
      u
    );
  }) }) });
}, Axt = ({ operation: e }) => {
  const { selectedTab: t } = yx(), { pieceModel: n, isLoading: r } = nd.usePiece({
    name: "@activepieces/piece-ai"
  });
  if (t !== $o.AI_AND_AGENTS || ![Tt.ADD_ACTION, Tt.UPDATE_ACTION].includes(
    e.type
  ))
    return null;
  if (r || De(n))
    return /* @__PURE__ */ y("div", { className: "flex flex-col gap-2 w-full", children: /* @__PURE__ */ y(Ax, { numberOfCards: 2, withCircle: !1 }) });
  const o = {
    ...KO.mapPieceToMetadata({
      piece: n,
      type: "action"
    }),
    suggestedActions: Object.values(n == null ? void 0 : n.actions),
    suggestedTriggers: Object.values(n.triggers)
  };
  return /* @__PURE__ */ y("div", { className: "w-full", children: /* @__PURE__ */ y(
    Oxt,
    {
      stepMetadataWithSuggestions: o,
      hidePieceIconAndDescription: !1,
      operation: e
    }
  ) });
}, wxt = ({
  operation: e
}) => {
  const { i18n: t } = tc(), n = t.dir() === "rtl", { selectedTab: r, selectedPieceInExplore: i, setSelectedPieceInExplore: o } = yx(), { data: s, isLoading: l } = nd.usePiecesSearch({
    shouldCaptureEvent: !1,
    searchQuery: "",
    type: e.type === Tt.UPDATE_TRIGGER ? "trigger" : "action"
  });
  return r !== $o.EXPLORE ? null : l ? /* @__PURE__ */ y("div", { className: "flex flex-col gap-2 w-full", children: /* @__PURE__ */ y(Ax, { numberOfCards: 2, withCircle: !1 }) }) : i ? /* @__PURE__ */ y("div", { className: "w-full", children: /* @__PURE__ */ y(
    U$,
    {
      stepMetadataWithSuggestions: i,
      hidePieceIconAndDescription: !1,
      operation: e
    }
  ) }) : /* @__PURE__ */ y(Bi, { className: "h-full w-full", children: /* @__PURE__ */ y("div", { className: "flex  p-2 ", dir: n ? "rtl" : "ltr", children: s.map((c) => /* @__PURE__ */ V("div", { className: "flex w-[50%] flex-col gap-0.5 ", children: [
    /* @__PURE__ */ y("div", { className: "text-sm text-muted-foreground mb-1.5", children: c.title }),
    c.metadata.map((a) => /* @__PURE__ */ V(
      Ng,
      {
        className: "rounded-sm py-3",
        onClick: () => o(a),
        children: [
          /* @__PURE__ */ V("div", { className: "flex gap-2 items-center h-full", children: [
            /* @__PURE__ */ y(
              Ig,
              {
                logoUrl: a.logoUrl,
                displayName: a.displayName,
                showTooltip: !1,
                size: "sm"
              }
            ),
            /* @__PURE__ */ y("div", { className: "grow h-full flex items-center justify-left text-sm", children: a.displayName })
          ] }),
          " "
        ]
      },
      a.displayName
    ))
  ] }, c.title)) }) });
};
function Yb(e, t, n) {
  let r = n.initialDeps ?? [], i;
  function o() {
    var s, l, c, a;
    let u;
    n.key && ((s = n.debug) != null && s.call(n)) && (u = Date.now());
    const f = e();
    if (!(f.length !== r.length || f.some((h, m) => r[m] !== h)))
      return i;
    r = f;
    let p;
    if (n.key && ((l = n.debug) != null && l.call(n)) && (p = Date.now()), i = t(...f), n.key && ((c = n.debug) != null && c.call(n))) {
      const h = Math.round((Date.now() - u) * 100) / 100, m = Math.round((Date.now() - p) * 100) / 100, v = m / 16, b = (A, w) => {
        for (A = String(A); A.length < w; )
          A = " " + A;
        return A;
      };
      console.info(
        `%c⏱ ${b(m, 5)} /${b(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * v, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (a = n == null ? void 0 : n.onChange) == null || a.call(n, i), i;
  }
  return o.updateDeps = (s) => {
    r = s;
  }, o;
}
function eae(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const xxt = (e, t) => Math.abs(e - t) <= 1, Sxt = (e, t, n) => {
  let r;
  return function(...i) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, i), n);
  };
}, tae = (e) => {
  const { offsetWidth: t, offsetHeight: n } = e;
  return { width: t, height: n };
}, Ext = (e) => e, Txt = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let i = t; i <= n; i++)
    r.push(i);
  return r;
}, kxt = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const i = (s) => {
    const { width: l, height: c } = s;
    t({ width: Math.round(l), height: Math.round(c) });
  };
  if (i(tae(n)), !r.ResizeObserver)
    return () => {
    };
  const o = new r.ResizeObserver((s) => {
    const l = () => {
      const c = s[0];
      if (c != null && c.borderBoxSize) {
        const a = c.borderBoxSize[0];
        if (a) {
          i({ width: a.inlineSize, height: a.blockSize });
          return;
        }
      }
      i(tae(n));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(l) : l();
  });
  return o.observe(n, { box: "border-box" }), () => {
    o.unobserve(n);
  };
}, nae = {
  passive: !0
}, rae = typeof window > "u" ? !0 : "onscrollend" in window, Cxt = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let i = 0;
  const o = e.options.useScrollendEvent && rae ? () => {
  } : Sxt(
    r,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (u) => () => {
    const { horizontal: f, isRtl: d } = e.options;
    i = f ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, o(), t(i, u);
  }, l = s(!0), c = s(!1);
  c(), n.addEventListener("scroll", l, nae);
  const a = e.options.useScrollendEvent && rae;
  return a && n.addEventListener("scrollend", c, nae), () => {
    n.removeEventListener("scroll", l), a && n.removeEventListener("scrollend", c);
  };
}, Nxt = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[n.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, Pxt = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var i, o;
  const s = e + t;
  (o = (i = r.scrollElement) == null ? void 0 : i.scrollTo) == null || o.call(i, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class Ixt {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((o) => {
          const s = () => {
            this._measureElement(o.target, o);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = r()) == null || i.disconnect(), n = null;
        },
        observe: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, i]) => {
        typeof i > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Ext,
        rangeExtractor: Txt,
        onChange: () => {
        },
        measureElement: Nxt,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, i;
      (i = (r = this.options).onChange) == null || i.call(r, this, n);
    }, this.maybeNotify = Yb(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, o) => {
            this.scrollAdjustments = 0, this.scrollDirection = o ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = o, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const l = n[s];
        if (i.has(l.lane))
          continue;
        const c = o.get(
          l.lane
        );
        if (c == null || l.end > c.end ? o.set(l.lane, l) : l.end < c.end && i.set(l.lane, !0), i.size === this.options.lanes)
          break;
      }
      return o.size === this.options.lanes ? Array.from(o.values()).sort((s, l) => s.end === l.end ? s.index - l.index : s.end - l.end)[0] : void 0;
    }, this.getMeasurementOptions = Yb(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, i, o, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: i,
        getItemKey: o,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Yb(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: i, getItemKey: o, enabled: s }, l) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const a = this.measurementsCache.slice(0, c);
        for (let u = c; u < n; u++) {
          const f = o(u), d = this.options.lanes === 1 ? a[u - 1] : this.getFurthestMeasurement(a, u), p = d ? d.end + this.options.gap : r + i, h = l.get(f), m = typeof h == "number" ? h : this.options.estimateSize(u), v = p + m, b = d ? d.lane : u % this.options.lanes;
          a[u] = {
            index: u,
            start: p,
            size: m,
            end: v,
            key: f,
            lane: b
          };
        }
        return this.measurementsCache = a, a;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Yb(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, i, o) => this.range = n.length > 0 && r > 0 ? Rxt({
        measurements: n,
        outerSize: r,
        scrollOffset: i,
        lanes: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Yb(
      () => {
        let n = null, r = null;
        const i = this.calculateRange();
        return i && (n = i.startIndex, r = i.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, i, o, s) => o === null || s === null ? [] : n({
        startIndex: o,
        endIndex: s,
        overscan: r,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, i = n.getAttribute(r);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const i = this.indexFromElement(n), o = this.measurementsCache[i];
      if (!o)
        return;
      const s = o.key, l = this.elementsCache.get(s);
      l !== n && (l && this.observer.unobserve(l), this.observer.observe(n), this.elementsCache.set(s, n)), n.isConnected && this.resizeItem(i, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.itemSizeCache.get(i.key) ?? i.size, s = r - o;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, s, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, i) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Yb(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const i = [];
        for (let o = 0, s = n.length; o < s; o++) {
          const l = n[o], c = r[l];
          i.push(c);
        }
        return i;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return eae(
          r[pNe(
            0,
            r.length - 1,
            (i) => eae(r[i]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r, i = 0) => {
      const o = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (r = n >= s + o ? "end" : "start"), r === "center" ? n += (i - o) / 2 : r === "end" && (n -= o);
      const l = this.getTotalSize() - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (i.end >= s + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (i.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const l = r === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(l, r, i.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: i } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const o = this.getOffsetForIndex(n, r);
      if (!o) return;
      const [s, l] = o;
      this._scrollToOffset(s, { adjustments: void 0, behavior: i }), i !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const a = this.getOffsetForIndex(n, l);
          if (!a) return;
          const [u] = a, f = this.getScrollOffset();
          xxt(u, f) || this.scrollToIndex(n, { align: l, behavior: i });
        } else
          this.scrollToIndex(n, { align: l, behavior: i });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let i;
      if (r.length === 0)
        i = this.options.paddingStart;
      else if (this.options.lanes === 1)
        i = ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const o = Array(this.options.lanes).fill(null);
        let s = r.length - 1;
        for (; s >= 0 && o.some((l) => l === null); ) {
          const l = r[s];
          o[l.lane] === null && (o[l.lane] = l.end), s--;
        }
        i = Math.max(...o.filter((l) => l !== null));
      }
      return Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: i
    }) => {
      this.options.scrollToFn(n, { behavior: i, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const pNe = (e, t, n, r) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, o = n(i);
    if (o < r)
      e = i + 1;
    else if (o > r)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function Rxt({
  measurements: e,
  outerSize: t,
  scrollOffset: n,
  lanes: r
}) {
  const i = e.length - 1, o = (c) => e[c].start;
  if (e.length <= r)
    return {
      startIndex: 0,
      endIndex: i
    };
  let s = pNe(
    0,
    i,
    o,
    n
  ), l = s;
  if (r === 1)
    for (; l < i && e[l].end < n + t; )
      l++;
  else if (r > 1) {
    const c = Array(r).fill(0);
    for (; l < i && c.some((u) => u < n + t); ) {
      const u = e[l];
      c[u.lane] = u.end, l++;
    }
    const a = Array(r).fill(n + t);
    for (; s >= 0 && a.some((u) => u >= n); ) {
      const u = e[s];
      a[u.lane] = u.start, s--;
    }
    s = Math.max(0, s - s % r), l = Math.min(i, l + (r - 1 - l % r));
  }
  return { startIndex: s, endIndex: l };
}
const iae = typeof document < "u" ? N.useLayoutEffect : N.useEffect;
function Mxt(e) {
  const t = N.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (i, o) => {
      var s;
      o ? Sve(t) : t(), (s = e.onChange) == null || s.call(e, i, o);
    }
  }, [r] = N.useState(
    () => new Ixt(n)
  );
  return r.setOptions(n), iae(() => r._didMount(), []), iae(() => r._willUpdate()), r;
}
function Dxt(e) {
  return Mxt({
    observeElementRect: kxt,
    observeElementOffset: Cxt,
    scrollToFn: Pxt,
    ...e
  });
}
const V$ = ({
  items: e,
  renderItem: t,
  overscan: n = 5,
  estimateSize: r,
  getItemKey: i,
  initialScroll: o,
  className: s,
  ...l
}) => {
  const { i18n: c } = tc(), a = c.dir() === "rtl", u = N.useRef(null), f = Dxt({
    count: e.length,
    getScrollElement: () => u.current,
    estimateSize: r,
    overscan: n,
    getItemKey: i || ((p) => p)
  }), d = f.getVirtualItems();
  return N.useEffect(() => {
    De(o) || o.index > -1 && (f.scrollToIndex(o.index, {
      align: "start",
      behavior: "auto"
    }), o != null && o.clickAfterScroll && setTimeout(() => {
      var m;
      const p = (m = u.current) == null ? void 0 : m.querySelector(
        `[data-virtual-index="${o.index}"]`
      ), h = p == null ? void 0 : p.children[0];
      h instanceof HTMLElement && h.click();
    }, 100));
  }, [f]), /* @__PURE__ */ y(
    Bi,
    {
      viewPortRef: u,
      ...l,
      className: Se("h-full", s),
      dir: a ? "rtl" : "ltr",
      children: /* @__PURE__ */ y(
        "div",
        {
          style: {
            height: `${f.getTotalSize()}px`,
            width: "100%",
            position: "relative"
          },
          children: d.map((p) => /* @__PURE__ */ y(
            "div",
            {
              "data-virtual-index": p.index,
              style: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: `${p.size}px`,
                transform: `translateY(${p.start}px)`
              },
              children: t(e[p.index], p.index)
            },
            p.key
          ))
        }
      )
    }
  );
};
V$.displayName = "VirtualizedScrollArea";
const _xt = () => {
  const { data: e } = Go.useFlag(
    As.SHOW_COMMUNITY
  ), t = bd().embedState.isEmbedded, n = e && !t;
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 items-center justify-center h-full ", children: [
    /* @__PURE__ */ y(YH, { className: "w-14 h-14" }),
    /* @__PURE__ */ y("div", { className: "text-sm ", children: Z("No pieces found") }),
    /* @__PURE__ */ y("div", { className: "text-sm ", children: Z("Try adjusting your search") }),
    n && /* @__PURE__ */ y(
      Qe,
      {
        variant: "default",
        size: "sm",
        onClick: () => {
          window.open(`${GOe}`, "_blank", "noopener noreferrer");
        },
        children: Z("Request Piece")
      }
    )
  ] });
}, hNe = ({
  pieceMetadata: e,
  searchQuery: t,
  operation: n,
  isTemporaryDisabledUntilNextCursorMove: r
}) => {
  const i = Mz(), o = t.length > 0 || i, s = Xe(!1), l = async () => {
    r || o || (s.current = !0, await yxe(250), s.current && a(e));
  }, [
    c,
    a
  ] = tn((f) => [
    f.selectedPieceMetadataInPieceSelector,
    f.setSelectedPieceMetadataInPieceSelector
  ]), u = BT.PIECE_ITEM_HEIGHT;
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      Ng,
      {
        className: Se("flex-col p-3 gap-1 items-start truncate", {
          "hover:bg-transparent!": r
        }),
        style: { height: `${u}px`, maxHeight: `${u}px` },
        selected: (c == null ? void 0 : c.displayName) === e.displayName && t.length === 0,
        interactive: !o,
        onMouseEnter: l,
        onMouseMove: l,
        onClick: () => {
          o || a(e);
        },
        onMouseLeave: () => {
          s.current = !1;
        },
        id: e.displayName,
        "data-testid": e.displayName,
        children: /* @__PURE__ */ V("div", { className: "flex gap-2 items-center h-full", children: [
          /* @__PURE__ */ y(
            Ig,
            {
              logoUrl: e.logoUrl,
              displayName: e.displayName,
              showTooltip: !1,
              size: "sm"
            }
          ),
          /* @__PURE__ */ y("div", { className: "grow h-full flex items-center justify-left text-sm", children: e.displayName })
        ] })
      }
    ),
    o && /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y(
      U$,
      {
        stepMetadataWithSuggestions: e,
        hidePieceIconAndDescription: !0,
        operation: n
      }
    ) })
  ] });
};
hNe.displayName = "PieceCardListItem";
const Lxt = ({
  searchQuery: e,
  operation: t,
  stepToReplacePieceDisplayName: n
}) => {
  const r = Mz(), [i] = tn(
    (b) => [b.selectedPieceMetadataInPieceSelector]
  ), { isLoading: o, data: s } = nd.usePiecesSearch({
    shouldCaptureEvent: !0,
    searchQuery: e,
    type: t.type === Tt.UPDATE_TRIGGER ? "trigger" : "action"
  }), l = !o && s.length === 0, [c, a] = He(!1), u = e.length > 0 || r, f = zxt(
    s,
    u
  ), d = f.findIndex(
    (b) => b.displayName === n
  ), { selectedTab: p } = yx(), h = o, m = e.length === 0 && !r && !l && !h, v = !l && !h;
  return [$o.EXPLORE, $o.AI_AND_AGENTS].includes(
    p
  ) ? null : /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V(
      "div",
      {
        className: Se("w-full md:w-[250px] md:min-w-[250px] transition-all ", {
          "w-full md:w-full": e.length > 0 || l
        }),
        children: [
          h && /* @__PURE__ */ y("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ y(Ax, { numberOfCards: 2, withCircle: !1 }) }),
          v && /* @__PURE__ */ y(
            V$,
            {
              initialScroll: {
                index: d,
                clickAfterScroll: !0
              },
              items: f,
              estimateSize: (b) => f[b].height,
              getItemKey: (b) => f[b].id,
              renderItem: (b) => b.isCategory ? /* @__PURE__ */ y(
                "div",
                {
                  className: Se("p-2 pb-0 text-sm text-muted-foreground"),
                  id: b.displayName,
                  children: b.displayName
                }
              ) : /* @__PURE__ */ y(
                hNe,
                {
                  pieceMetadata: b.pieceMetadata,
                  searchQuery: e,
                  operation: t,
                  isTemporaryDisabledUntilNextCursorMove: !c
                }
              )
            },
            `${p}-${e}`
          ),
          l && /* @__PURE__ */ y(_xt, {})
        ]
      }
    ),
    m && /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(Eh, { orientation: "vertical", className: "h-full" }),
      /* @__PURE__ */ y(
        U$,
        {
          stepMetadataWithSuggestions: i,
          hidePieceIconAndDescription: !1,
          operation: t
        }
      )
    ] })
  ] });
}, zxt = (e, t) => e.reduce((n, r) => (t || n.push({
  id: r.title,
  displayName: r.title,
  height: BT.CATEGORY_ITEM_HEIGHT,
  isCategory: !0
}), r.metadata.forEach((i, o) => {
  n.push({
    id: `${i.displayName}-${o}`,
    height: jxt(
      i,
      t
    ),
    isCategory: !1,
    pieceMetadata: i,
    displayName: i.displayName
  });
}), n), []), jxt = (e, t) => {
  const { ACTION_OR_TRIGGER_ITEM_HEIGHT: n, PIECE_ITEM_HEIGHT: r } = BT;
  if (e.type === qe.PIECE && t) {
    const o = xf.removeHiddenActions(e);
    return n * Object.values(o).length + r;
  }
  return e.type === Bt.PIECE && t ? n * Object.values(e.suggestedTriggers ?? {}).length + r : (e.type === qe.CODE || e.type === qe.LOOP_ON_ITEMS || e.type === qe.ROUTER) && t ? n + r : r;
}, Fxt = (e, t) => {
  const n = [
    {
      value: $o.EXPLORE,
      name: Z("Explore"),
      icon: /* @__PURE__ */ y(iot, { className: "size-5" })
    },
    {
      value: $o.APPS,
      name: Z("Apps"),
      icon: /* @__PURE__ */ y(rxe, { className: "size-5" })
    },
    {
      value: $o.UTILITY,
      name: Z("Utility"),
      icon: /* @__PURE__ */ y(sxe, { className: "size-5" })
    }
  ];
  return [
    Tt.ADD_ACTION,
    Tt.UPDATE_ACTION
  ].includes(e) && !t && n.splice(1, 0, {
    value: $o.AI_AND_AGENTS,
    name: Z("AI & Agents"),
    icon: /* @__PURE__ */ y(Got, { className: "size-5" })
  }), n;
}, q$ = (e) => /* @__PURE__ */ y(pbt, { children: /* @__PURE__ */ y(Uxt, { ...e }) }), Uxt = ({
  children: e,
  operation: t,
  id: n,
  openSelectorOnClick: r = !0,
  stepToReplacePieceDisplayName: i
}) => {
  const [
    o,
    s,
    l,
    c,
    a
  ] = tn((E) => [
    E.openedPieceSelectorStepNameOrAddButtonId,
    E.setOpenedPieceSelectorStepNameOrAddButtonId,
    E.setSelectedPieceMetadataInPieceSelector,
    E.flowVersion.trigger.type === Bt.EMPTY && n === "trigger",
    E.deselectStep
  ]), { searchQuery: u, setSearchQuery: f } = Yz(), d = t.type === Tt.UPDATE_ACTION || t.type === Tt.UPDATE_TRIGGER && !c, [p] = Gz(u, 300), h = o === n, m = Mz(), { listHeightRef: v, popoverTriggerRef: b } = xf.useAdjustPieceListHeightToAvailableSpace(), A = Math.min(v.current, 300), w = Xe(null);
  nt(() => {
    h && setTimeout(() => {
      var E;
      (E = w.current) == null || E.focus();
    });
  }, [h]);
  const O = () => {
    f(""), l(null);
  }, { platform: x } = dN.useCurrentPlatform(), S = Kt(
    () => Fxt(t.type, (x == null ? void 0 : x.plan.embeddingEnabled) ?? !1),
    [t.type, x == null ? void 0 : x.plan.embeddingEnabled]
  );
  return /* @__PURE__ */ V(
    mx,
    {
      open: h,
      modal: !0,
      onOpenChange: (E) => {
        E || (O(), s(null), c && a());
      },
      children: [
        /* @__PURE__ */ y(
          gx,
          {
            ref: b,
            asChild: !0,
            onClick: () => {
              r && s(n);
            },
            children: e
          }
        ),
        /* @__PURE__ */ y(
          hbt,
          {
            initiallySelectedTab: d || m ? $o.NONE : $o.EXPLORE,
            onTabChange: O,
            children: /* @__PURE__ */ y(
              Sb,
              {
                onContextMenu: (E) => {
                  E.stopPropagation();
                },
                className: "w-[340px] md:w-[600px] p-0 shadow-lg",
                onClick: (E) => {
                  E.stopPropagation(), E.preventDefault();
                },
                collisionPadding: 64,
                children: /* @__PURE__ */ V(pt, { children: [
                  /* @__PURE__ */ V("div", { children: [
                    /* @__PURE__ */ y(
                      ETe,
                      {
                        searchInputRef: w,
                        onSearchChange: (E) => {
                          l(null), E === "" && O();
                        }
                      }
                    ),
                    !m && /* @__PURE__ */ y(Ibt, { tabs: S }),
                    /* @__PURE__ */ y(Eh, { orientation: "horizontal", className: "mt-1" })
                  ] }),
                  /* @__PURE__ */ V(
                    "div",
                    {
                      className: " flex flex-row max-h-[300px]",
                      style: {
                        height: A + "px"
                      },
                      children: [
                        /* @__PURE__ */ y(wxt, { operation: t }),
                        /* @__PURE__ */ y(Axt, { operation: t }),
                        /* @__PURE__ */ y(
                          Lxt,
                          {
                            searchQuery: u === "" ? "" : p,
                            operation: t,
                            stepToReplacePieceDisplayName: m ? void 0 : i
                          }
                        )
                      ]
                    }
                  )
                ] })
              }
            )
          },
          h ? "open" : "closed"
        )
      ]
    }
  );
}, zv = ie.memo((e) => {
  const [t, n] = He(!1), [r, i, o] = tn((c) => [
    c.activeDraggingStep,
    c.readonly,
    c.openedPieceSelectorStepNameOrAddButtonId === e.edgeId
  ]), { setNodeRef: s } = e$({
    id: e.edgeId,
    data: {
      accepts: Ie.DRAGGED_STEP_TAG,
      ...e
    }
  }), l = !De(r);
  return WQ({
    onDragMove(c) {
      var a, u;
      n(((u = (a = c.collisions) == null ? void 0 : a[0]) == null ? void 0 : u.id) === e.edgeId);
    },
    onDragEnd() {
      n(!1);
    }
  }), /* @__PURE__ */ V(pt, { children: [
    l && !i && /* @__PURE__ */ y(
      "div",
      {
        style: {
          width: Ie.AP_NODE_SIZE.ADD_BUTTON.width + "px",
          height: Ie.AP_NODE_SIZE.ADD_BUTTON.height + "px"
        },
        className: Se("transition-all bg-primary/90  rounded-md", {
          "shadow-add-button": t
        }),
        children: /* @__PURE__ */ y(
          "div",
          {
            style: {
              width: Ie.AP_NODE_SIZE.STEP.width + "px",
              height: Ie.AP_NODE_SIZE.STEP.height + "px",
              left: `${-Ie.AP_NODE_SIZE.STEP.width / 2}px`,
              top: `${-60 / 2}px`
            },
            className: Se(" absolute    rounded-md box-content "),
            ref: s
          }
        )
      }
    ),
    !l && !i && /* @__PURE__ */ y(
      q$,
      {
        operation: Na.createAddOperationFromAddButtonData(e),
        id: e.edgeId,
        children: /* @__PURE__ */ y(
          "div",
          {
            style: {
              width: Ie.AP_NODE_SIZE.ADD_BUTTON.width + "px",
              height: Ie.AP_NODE_SIZE.ADD_BUTTON.height + "px"
            },
            children: /* @__PURE__ */ y(
              "div",
              {
                style: {
                  width: Ie.AP_NODE_SIZE.ADD_BUTTON.width + "px",
                  height: Ie.AP_NODE_SIZE.ADD_BUTTON.height + "px"
                },
                className: Se("rounded-md cursor-pointer transition-all z-50", {
                  "shadow-add-button": o
                }),
                children: /* @__PURE__ */ y(
                  "div",
                  {
                    style: {
                      width: Ie.AP_NODE_SIZE.ADD_BUTTON.width + "px",
                      height: Ie.AP_NODE_SIZE.ADD_BUTTON.height + "px"
                    },
                    className: Se(
                      "bg-background  border border-border border-solid relative group overflow-visible rounded-md cursor-pointer  flex items-center justify-center  transition-all duration-300 ease-in-out",
                      {
                        "bg-primary border-primary": o
                      }
                    ),
                    "data-testid": "add-action-button",
                    children: !o && /* @__PURE__ */ y(Da, { className: "w-3 h-3 stroke-[3px] text-foreground" })
                  }
                )
              }
            )
          }
        )
      }
    )
  ] });
});
zv.displayName = "ApAddButton";
const Vxt = ({
  sourceX: e,
  sourceY: t,
  targetX: n,
  targetY: r,
  data: i,
  id: o
}) => {
  const s = Math.abs(e - n) - 2 * Ie.ARC_LENGTH, l = i.verticalSpaceBetweenReturnNodeStartAndEnd, c = " m-5 -6 l6 6  m-6 0 m6 0 l-6 6 m3 -6", a = Ie.VERTICAL_SPACE_BETWEEN_STEPS - 2 * Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE + 8, u = `
  M ${e - 0.5} ${t - Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE}
  v 1
  ${Ie.ARC_LEFT_DOWN} h -${s}
  ${Ie.ARC_RIGHT_UP} v -${l}
  a15,15 0 0,1 15,-15
  
  h ${s / 2 - 2 * Ie.ARC_LENGTH}
   ${c}
 
  M ${e - Ie.ARC_LENGTH - s / 2} ${t + Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE + Ie.ARC_LENGTH / 2}
   v${a} ${i.drawArrowHeadAfterEnd ? Ie.ARROW_DOWN : ""} 
   `, f = {
    x: e - s / 2 - Ie.ARC_LENGTH - Ie.AP_NODE_SIZE.ADD_BUTTON.width / 2,
    y: t + a / 2
  }, d = !1;
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      kh,
      {
        path: u,
        style: { strokeWidth: `${Ie.LINE_WIDTH}px` },
        className: "relative"
      }
    ),
    d,
    /* @__PURE__ */ y(
      "foreignObject",
      {
        x: f.x,
        y: f.y,
        width: Ie.AP_NODE_SIZE.ADD_BUTTON.width,
        height: Ie.AP_NODE_SIZE.ADD_BUTTON.height,
        className: "overflow-visible",
        children: /* @__PURE__ */ y(
          zv,
          {
            edgeId: o,
            stepLocationRelativeToParent: Hn.AFTER,
            parentStepName: i.parentStepName
          }
        )
      }
    ),
    d
  ] });
}, qxt = ({
  sourceX: e,
  sourceY: t,
  targetX: n,
  data: r,
  source: i,
  id: o
}) => {
  const s = t + Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE, l = Ie.VERTICAL_SPACE_BETWEEN_STEPS - 2 * Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE, c = Math.abs(n - e) - 2 * Ie.ARC_LENGTH, a = `M ${e} ${s} v${l / 2}
  ${Ie.ARC_RIGHT_DOWN} h${c}
  ${Ie.ARC_RIGHT} v${l}
   ${r.isLoopEmpty ? "" : Ie.ARROW_DOWN}`, u = !1, f = {
    x: e - Ie.AP_NODE_SIZE.ADD_BUTTON.width / 2 + c + Ie.ARC_LENGTH * 2,
    y: s + l + Ie.ARC_LENGTH
  };
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      kh,
      {
        path: a,
        style: { strokeWidth: `${Ie.LINE_WIDTH}px` },
        className: "relative"
      }
    ),
    !r.isLoopEmpty && /* @__PURE__ */ y(
      "foreignObject",
      {
        x: f.x,
        y: f.y,
        width: Ie.AP_NODE_SIZE.ADD_BUTTON.width,
        height: Ie.AP_NODE_SIZE.ADD_BUTTON.height,
        className: "overflow-visible cursor-default",
        children: /* @__PURE__ */ y(
          zv,
          {
            edgeId: o,
            stepLocationRelativeToParent: Hn.INSIDE_LOOP,
            parentStepName: i
          }
        )
      }
    ),
    u
  ] });
}, Bxt = ({
  sourceX: e,
  targetX: t,
  targetY: n,
  sourceY: r,
  data: i,
  id: o
}) => {
  const s = Ie.VERTICAL_SPACE_BETWEEN_STEPS - 2 * Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE, l = (Math.abs(t - e) - 2 * Ie.ARC_LENGTH) * (t > e ? 1 : -1), c = Math.abs(t - e), u = (() => {
    let f = `M ${e - 0.5} ${r - Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE}`;
    return f += `v ${i.verticalSpaceBetweenLastNodeInBranchAndEndLine}`, c >= Ie.ARC_LENGTH ? f += t > e ? Ie.ARC_RIGHT_DOWN : Ie.ARC_LEFT_DOWN : f += `v ${Ie.ARC_LENGTH + Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE + 2}`, i.drawHorizontalLine && (f += `h ${l} ${t > e ? Ie.ARC_RIGHT : Ie.ARC_LEFT}`), i.drawEndingVerticalLine && (f += `v${s}`, i.isNextStepEmpty || (f += Ie.ARROW_DOWN)), f;
  })();
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      kh,
      {
        path: u,
        style: { strokeWidth: `${Ie.LINE_WIDTH}px` }
      }
    ),
    i.drawEndingVerticalLine && /* @__PURE__ */ y(
      "foreignObject",
      {
        x: t - Ie.AP_NODE_SIZE.ADD_BUTTON.width / 2 - Ie.LINE_WIDTH / 2,
        y: n - s,
        width: Ie.AP_NODE_SIZE.ADD_BUTTON.width,
        height: Ie.AP_NODE_SIZE.ADD_BUTTON.height,
        className: "overflow-visible",
        children: /* @__PURE__ */ y(
          zv,
          {
            edgeId: o,
            stepLocationRelativeToParent: Hn.AFTER,
            parentStepName: i.routerOrBranchStepName
          }
        )
      }
    )
  ] });
};
var NX = ["Enter", " "], Xxt = ["ArrowDown", "PageUp", "Home"], mNe = ["ArrowUp", "PageDown", "End"], Wxt = [...Xxt, ...mNe], Zxt = {
  ltr: [...NX, "ArrowRight"],
  rtl: [...NX, "ArrowLeft"]
}, Hxt = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, pN = "Menu", [$T, Qxt, $xt] = Jz(pN), [Cb, gNe] = Ms(pN, [
  $xt,
  _f,
  Cg
]), bj = _f(), yNe = Cg(), [Kxt, Nb] = Cb(pN), [Gxt, hN] = Cb(pN), vNe = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: s = !0 } = e, l = bj(t), [c, a] = N.useState(null), u = N.useRef(!1), f = ti(o), d = Eb(i);
  return N.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ y(ox, { ...l, children: /* @__PURE__ */ y(
    Kxt,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: c,
      onContentChange: a,
      children: /* @__PURE__ */ y(
        Gxt,
        {
          scope: t,
          onClose: N.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: d,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
vNe.displayName = pN;
var Yxt = "MenuAnchor", B$ = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = bj(n);
    return /* @__PURE__ */ y(sx, { ...i, ...r, ref: t });
  }
);
B$.displayName = Yxt;
var X$ = "MenuPortal", [Jxt, bNe] = Cb(X$, {
  forceMount: void 0
}), ONe = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Nb(X$, t);
  return /* @__PURE__ */ y(Jxt, { scope: t, forceMount: n, children: /* @__PURE__ */ y(wo, { present: n || o.open, children: /* @__PURE__ */ y(ax, { asChild: !0, container: i, children: r }) }) });
};
ONe.displayName = X$;
var Gc = "MenuContent", [eSt, W$] = Cb(Gc), ANe = N.forwardRef(
  (e, t) => {
    const n = bNe(Gc, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Nb(Gc, e.__scopeMenu), s = hN(Gc, e.__scopeMenu);
    return /* @__PURE__ */ y($T.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(wo, { present: r || o.open, children: /* @__PURE__ */ y($T.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ y(tSt, { ...i, ref: t }) : /* @__PURE__ */ y(nSt, { ...i, ref: t }) }) }) });
  }
), tSt = N.forwardRef(
  (e, t) => {
    const n = Nb(Gc, e.__scopeMenu), r = N.useRef(null), i = xn(t, r);
    return N.useEffect(() => {
      const o = r.current;
      if (o) return ux(o);
    }, []), /* @__PURE__ */ y(
      Z$,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ot(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), nSt = N.forwardRef((e, t) => {
  const n = Nb(Gc, e.__scopeMenu);
  return /* @__PURE__ */ y(
    Z$,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Z$ = N.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: o,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: l,
      onEntryFocus: c,
      onEscapeKeyDown: a,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: d,
      onDismiss: p,
      disableOutsideScroll: h,
      ...m
    } = e, v = Nb(Gc, n), b = hN(Gc, n), A = bj(n), w = yNe(n), O = Qxt(n), [x, S] = N.useState(null), E = N.useRef(null), k = xn(t, E, v.onContentChange), T = N.useRef(0), R = N.useRef(""), j = N.useRef(0), F = N.useRef(null), L = N.useRef("right"), _ = N.useRef(0), U = h ? eN : N.Fragment, z = h ? { as: is, allowPinchZoom: !0 } : void 0, C = (M) => {
      var oe, ce;
      const D = R.current + M, X = O().filter((fe) => !fe.disabled), B = document.activeElement, q = (oe = X.find((fe) => fe.ref.current === B)) == null ? void 0 : oe.textValue, H = X.map((fe) => fe.textValue), Y = hSt(H, D, q), J = (ce = X.find((fe) => fe.textValue === Y)) == null ? void 0 : ce.ref.current;
      (function fe($) {
        R.current = $, window.clearTimeout(T.current), $ !== "" && (T.current = window.setTimeout(() => fe(""), 1e3));
      })(D), J && setTimeout(() => J.focus());
    };
    N.useEffect(() => () => window.clearTimeout(T.current), []), Ez();
    const I = N.useCallback((M) => {
      var X, B;
      return L.current === ((X = F.current) == null ? void 0 : X.side) && gSt(M, (B = F.current) == null ? void 0 : B.area);
    }, []);
    return /* @__PURE__ */ y(
      eSt,
      {
        scope: n,
        searchRef: R,
        onItemEnter: N.useCallback(
          (M) => {
            I(M) && M.preventDefault();
          },
          [I]
        ),
        onItemLeave: N.useCallback(
          (M) => {
            var D;
            I(M) || ((D = E.current) == null || D.focus(), S(null));
          },
          [I]
        ),
        onTriggerLeave: N.useCallback(
          (M) => {
            I(M) && M.preventDefault();
          },
          [I]
        ),
        pointerGraceTimerRef: j,
        onPointerGraceIntentChange: N.useCallback((M) => {
          F.current = M;
        }, []),
        children: /* @__PURE__ */ y(U, { ...z, children: /* @__PURE__ */ y(
          lx,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: ot(o, (M) => {
              var D;
              M.preventDefault(), (D = E.current) == null || D.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ y(
              nx,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: a,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: d,
                onDismiss: p,
                children: /* @__PURE__ */ y(
                  tj,
                  {
                    asChild: !0,
                    ...w,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: S,
                    onEntryFocus: ot(c, (M) => {
                      b.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ y(
                      KC,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": zNe(v.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...A,
                        ...m,
                        ref: k,
                        style: { outline: "none", ...m.style },
                        onKeyDown: ot(m.onKeyDown, (M) => {
                          const X = M.target.closest("[data-radix-menu-content]") === M.currentTarget, B = M.ctrlKey || M.altKey || M.metaKey, q = M.key.length === 1;
                          X && (M.key === "Tab" && M.preventDefault(), !B && q && C(M.key));
                          const H = E.current;
                          if (M.target !== H || !Wxt.includes(M.key)) return;
                          M.preventDefault();
                          const J = O().filter((oe) => !oe.disabled).map((oe) => oe.ref.current);
                          mNe.includes(M.key) && J.reverse(), fSt(J);
                        }),
                        onBlur: ot(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(T.current), R.current = "");
                        }),
                        onPointerMove: ot(
                          e.onPointerMove,
                          KT((M) => {
                            const D = M.target, X = _.current !== M.clientX;
                            if (M.currentTarget.contains(D) && X) {
                              const B = M.clientX > _.current ? "right" : "left";
                              L.current = B, _.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ANe.displayName = Gc;
var rSt = "MenuGroup", H$ = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(Zt.div, { role: "group", ...r, ref: t });
  }
);
H$.displayName = rSt;
var iSt = "MenuLabel", wNe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(Zt.div, { ...r, ref: t });
  }
);
wNe.displayName = iSt;
var HD = "MenuItem", oae = "menu.itemSelect", Oj = N.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...i } = e, o = N.useRef(null), s = hN(HD, e.__scopeMenu), l = W$(HD, e.__scopeMenu), c = xn(t, o), a = N.useRef(!1), u = () => {
      const f = o.current;
      if (!n && f) {
        const d = new CustomEvent(oae, { bubbles: !0, cancelable: !0 });
        f.addEventListener(oae, (p) => r == null ? void 0 : r(p), { once: !0 }), yz(f, d), d.defaultPrevented ? a.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ y(
      xNe,
      {
        ...i,
        ref: c,
        disabled: n,
        onClick: ot(e.onClick, u),
        onPointerDown: (f) => {
          var d;
          (d = e.onPointerDown) == null || d.call(e, f), a.current = !0;
        },
        onPointerUp: ot(e.onPointerUp, (f) => {
          var d;
          a.current || (d = f.currentTarget) == null || d.click();
        }),
        onKeyDown: ot(e.onKeyDown, (f) => {
          const d = l.searchRef.current !== "";
          n || d && f.key === " " || NX.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Oj.displayName = HD;
var xNe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, s = W$(HD, n), l = yNe(n), c = N.useRef(null), a = xn(t, c), [u, f] = N.useState(!1), [d, p] = N.useState("");
    return N.useEffect(() => {
      const h = c.current;
      h && p((h.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ y(
      $T.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? d,
        children: /* @__PURE__ */ y(nj, { asChild: !0, ...l, focusable: !r, children: /* @__PURE__ */ y(
          Zt.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...o,
            ref: a,
            onPointerMove: ot(
              e.onPointerMove,
              KT((h) => {
                r ? s.onItemLeave(h) : (s.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ot(
              e.onPointerLeave,
              KT((h) => s.onItemLeave(h))
            ),
            onFocus: ot(e.onFocus, () => f(!0)),
            onBlur: ot(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), oSt = "MenuCheckboxItem", SNe = N.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = e;
    return /* @__PURE__ */ y(NNe, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ y(
      Oj,
      {
        role: "menuitemcheckbox",
        "aria-checked": QD(n) ? "mixed" : n,
        ...i,
        ref: t,
        "data-state": $$(n),
        onSelect: ot(
          i.onSelect,
          () => r == null ? void 0 : r(QD(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
SNe.displayName = oSt;
var ENe = "MenuRadioGroup", [sSt, aSt] = Cb(
  ENe,
  { value: void 0, onValueChange: () => {
  } }
), TNe = N.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...i } = e, o = ti(r);
    return /* @__PURE__ */ y(sSt, { scope: e.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ y(H$, { ...i, ref: t }) });
  }
);
TNe.displayName = ENe;
var kNe = "MenuRadioItem", CNe = N.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = aSt(kNe, e.__scopeMenu), o = n === i.value;
    return /* @__PURE__ */ y(NNe, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ y(
      Oj,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...r,
        ref: t,
        "data-state": $$(o),
        onSelect: ot(
          r.onSelect,
          () => {
            var s;
            return (s = i.onValueChange) == null ? void 0 : s.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
CNe.displayName = kNe;
var Q$ = "MenuItemIndicator", [NNe, lSt] = Cb(
  Q$,
  { checked: !1 }
), PNe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...i } = e, o = lSt(Q$, n);
    return /* @__PURE__ */ y(
      wo,
      {
        present: r || QD(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ y(
          Zt.span,
          {
            ...i,
            ref: t,
            "data-state": $$(o.checked)
          }
        )
      }
    );
  }
);
PNe.displayName = Q$;
var cSt = "MenuSeparator", INe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(
      Zt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
INe.displayName = cSt;
var uSt = "MenuArrow", RNe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = bj(n);
    return /* @__PURE__ */ y(GC, { ...i, ...r, ref: t });
  }
);
RNe.displayName = uSt;
var dSt = "MenuSub", [rmn, MNe] = Cb(dSt), s1 = "MenuSubTrigger", DNe = N.forwardRef(
  (e, t) => {
    const n = Nb(s1, e.__scopeMenu), r = hN(s1, e.__scopeMenu), i = MNe(s1, e.__scopeMenu), o = W$(s1, e.__scopeMenu), s = N.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: c } = o, a = { __scopeMenu: e.__scopeMenu }, u = N.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return N.useEffect(() => u, [u]), N.useEffect(() => {
      const f = l.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [l, c]), /* @__PURE__ */ y(B$, { asChild: !0, ...a, children: /* @__PURE__ */ y(
      xNe,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": zNe(n.open),
        ...e,
        ref: ZC(t, i.onTriggerChange),
        onClick: (f) => {
          var d;
          (d = e.onClick) == null || d.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ot(
          e.onPointerMove,
          KT((f) => {
            o.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: ot(
          e.onPointerLeave,
          KT((f) => {
            var p, h;
            u();
            const d = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (d) {
              const m = (h = n.content) == null ? void 0 : h.dataset.side, v = m === "right", b = v ? -5 : 5, A = d[v ? "left" : "right"], w = d[v ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + b, y: f.clientY },
                  { x: A, y: d.top },
                  { x: w, y: d.top },
                  { x: w, y: d.bottom },
                  { x: A, y: d.bottom }
                ],
                side: m
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(f), f.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ot(e.onKeyDown, (f) => {
          var p;
          const d = o.searchRef.current !== "";
          e.disabled || d && f.key === " " || Zxt[r.dir].includes(f.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
DNe.displayName = s1;
var _Ne = "MenuSubContent", LNe = N.forwardRef(
  (e, t) => {
    const n = bNe(Gc, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Nb(Gc, e.__scopeMenu), s = hN(Gc, e.__scopeMenu), l = MNe(_Ne, e.__scopeMenu), c = N.useRef(null), a = xn(t, c);
    return /* @__PURE__ */ y($T.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(wo, { present: r || o.open, children: /* @__PURE__ */ y($T.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(
      Z$,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...i,
        ref: a,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          s.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: ot(e.onFocusOutside, (u) => {
          u.target !== l.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: ot(e.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: ot(e.onKeyDown, (u) => {
          var p;
          const f = u.currentTarget.contains(u.target), d = Hxt[s.dir].includes(u.key);
          f && d && (o.onOpenChange(!1), (p = l.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
LNe.displayName = _Ne;
function zNe(e) {
  return e ? "open" : "closed";
}
function QD(e) {
  return e === "indeterminate";
}
function $$(e) {
  return QD(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function fSt(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function pSt(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function hSt(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((a) => a === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let s = pSt(e, Math.max(o, 0));
  i.length === 1 && (s = s.filter((a) => a !== n));
  const c = s.find(
    (a) => a.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function mSt(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const l = t[o].x, c = t[o].y, a = t[s].x, u = t[s].y;
    c > r != u > r && n < (a - l) * (r - c) / (u - c) + l && (i = !i);
  }
  return i;
}
function gSt(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return mSt(n, t);
}
function KT(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var ySt = vNe, vSt = B$, bSt = ONe, OSt = ANe, ASt = H$, wSt = wNe, xSt = Oj, SSt = SNe, ESt = TNe, TSt = CNe, kSt = PNe, CSt = INe, NSt = RNe, PSt = DNe, ISt = LNe, K$ = "DropdownMenu", [RSt, imn] = Ms(
  K$,
  [gNe]
), Ba = gNe(), [MSt, jNe] = RSt(K$), FNe = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: i,
    defaultOpen: o,
    onOpenChange: s,
    modal: l = !0
  } = e, c = Ba(t), a = N.useRef(null), [u = !1, f] = wl({
    prop: i,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ y(
    MSt,
    {
      scope: t,
      triggerId: ka(),
      triggerRef: a,
      contentId: ka(),
      open: u,
      onOpenChange: f,
      onOpenToggle: N.useCallback(() => f((d) => !d), [f]),
      modal: l,
      children: /* @__PURE__ */ y(ySt, { ...c, open: u, onOpenChange: f, dir: r, modal: l, children: n })
    }
  );
};
FNe.displayName = K$;
var UNe = "DropdownMenuTrigger", G$ = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = jNe(UNe, n), s = Ba(n);
    return /* @__PURE__ */ y(vSt, { asChild: !0, ...s, children: /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: ZC(t, o.triggerRef),
        onPointerDown: ot(e.onPointerDown, (l) => {
          !r && l.button === 0 && l.ctrlKey === !1 && (o.onOpenToggle(), o.open || l.preventDefault());
        }),
        onKeyDown: ot(e.onKeyDown, (l) => {
          r || (["Enter", " "].includes(l.key) && o.onOpenToggle(), l.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
        })
      }
    ) });
  }
);
G$.displayName = UNe;
var DSt = "DropdownMenuPortal", VNe = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Ba(t);
  return /* @__PURE__ */ y(bSt, { ...r, ...n });
};
VNe.displayName = DSt;
var qNe = "DropdownMenuContent", BNe = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = jNe(qNe, n), o = Ba(n), s = N.useRef(!1);
    return /* @__PURE__ */ y(
      OSt,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ...r,
        ref: t,
        onCloseAutoFocus: ot(e.onCloseAutoFocus, (l) => {
          var c;
          s.current || (c = i.triggerRef.current) == null || c.focus(), s.current = !1, l.preventDefault();
        }),
        onInteractOutside: ot(e.onInteractOutside, (l) => {
          const c = l.detail.originalEvent, a = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || a;
          (!i.modal || u) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
BNe.displayName = qNe;
var _St = "DropdownMenuGroup", LSt = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
    return /* @__PURE__ */ y(ASt, { ...i, ...r, ref: t });
  }
);
LSt.displayName = _St;
var zSt = "DropdownMenuLabel", XNe = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
    return /* @__PURE__ */ y(wSt, { ...i, ...r, ref: t });
  }
);
XNe.displayName = zSt;
var jSt = "DropdownMenuItem", WNe = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
    return /* @__PURE__ */ y(xSt, { ...i, ...r, ref: t });
  }
);
WNe.displayName = jSt;
var FSt = "DropdownMenuCheckboxItem", ZNe = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(SSt, { ...i, ...r, ref: t });
});
ZNe.displayName = FSt;
var USt = "DropdownMenuRadioGroup", VSt = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(ESt, { ...i, ...r, ref: t });
});
VSt.displayName = USt;
var qSt = "DropdownMenuRadioItem", HNe = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(TSt, { ...i, ...r, ref: t });
});
HNe.displayName = qSt;
var BSt = "DropdownMenuItemIndicator", QNe = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(kSt, { ...i, ...r, ref: t });
});
QNe.displayName = BSt;
var XSt = "DropdownMenuSeparator", $Ne = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(CSt, { ...i, ...r, ref: t });
});
$Ne.displayName = XSt;
var WSt = "DropdownMenuArrow", ZSt = N.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
    return /* @__PURE__ */ y(NSt, { ...i, ...r, ref: t });
  }
);
ZSt.displayName = WSt;
var HSt = "DropdownMenuSubTrigger", KNe = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(PSt, { ...i, ...r, ref: t });
});
KNe.displayName = HSt;
var QSt = "DropdownMenuSubContent", GNe = N.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Ba(n);
  return /* @__PURE__ */ y(
    ISt,
    {
      ...i,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
GNe.displayName = QSt;
var $St = FNe, KSt = G$, GSt = VNe, YNe = BNe, JNe = XNe, ePe = WNe, tPe = ZNe, nPe = HNe, rPe = QNe, iPe = $Ne, oPe = KNe, sPe = GNe;
const mN = $St, Aj = KSt, YSt = N.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ V(
  oPe,
  {
    ref: i,
    className: Se(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:outline-none focus-visible:outline-none focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ y(HC, { className: "rtl:scale-x-[-1] ml-auto size-4" })
    ]
  }
));
YSt.displayName = oPe.displayName;
const JSt = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  sPe,
  {
    ref: n,
    className: Se(
      "z-50 min-w-32 overflow-hidden rounded-md border bg-background p-1 text-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
JSt.displayName = sPe.displayName;
const xx = N.forwardRef(({ className: e, sideOffset: t = 4, noAnimationOnOut: n = !1, ...r }, i) => /* @__PURE__ */ y(GSt, { children: /* @__PURE__ */ y(
  YNe,
  {
    ref: i,
    sideOffset: t,
    className: Se(
      "z-50 min-w-32  overflow-hidden rounded-md border bg-background p-1 text-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      { "data-[state=closed]:animate-out ": !n },
      e
    ),
    ...r
  }
) }));
xx.displayName = YNe.displayName;
const wa = N.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ y(
  ePe,
  {
    ref: r,
    className: Se(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:outline-none focus-visible:outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
wa.displayName = ePe.displayName;
const e1t = N.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ V(
  tPe,
  {
    ref: i,
    className: Se(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:outline-none focus-visible:outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ y("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ y(rPe, { children: /* @__PURE__ */ y(Af, { className: "size-4" }) }) }),
      t
    ]
  }
));
e1t.displayName = tPe.displayName;
const t1t = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ V(
  nPe,
  {
    ref: r,
    className: Se(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:outline-none focus-visible:outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ y("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ y(rPe, { children: /* @__PURE__ */ y(QH, { className: "size-2 fill-current" }) }) }),
      t
    ]
  }
));
t1t.displayName = nPe.displayName;
const n1t = N.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ y(
  JNe,
  {
    ref: r,
    className: Se(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
n1t.displayName = JNe.displayName;
const aPe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  iPe,
  {
    ref: n,
    className: Se("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
aPe.displayName = iPe.displayName;
const r1t = (e) => {
  var v, b;
  const [
    t,
    n,
    r,
    i,
    o,
    s,
    l
  ] = tn((A) => [
    A.selectedStep,
    A.selectedBranchIndex,
    A.selectStepByName,
    A.setSelectedBranchIndex,
    At.getStep(e.sourceNodeName, A.flowVersion.trigger),
    A.applyOperation,
    A.readonly
  ]), c = e.stepLocationRelativeToParent === Hn.INSIDE_BRANCH && (o == null ? void 0 : o.type) === qe.ROUTER && ((b = (v = o.settings.branches) == null ? void 0 : v[e.branchIndex]) == null ? void 0 : b.branchType) === iu.FALLBACK, u = e.stepLocationRelativeToParent !== Hn.INSIDE_BRANCH || c, f = t === e.sourceNodeName && e.stepLocationRelativeToParent === Hn.INSIDE_BRANCH && e.branchIndex === n, { fitView: d } = yd(), [p, h] = He(!1);
  if (De(o) || o.type !== qe.ROUTER)
    return /* @__PURE__ */ y(pt, {});
  const m = o.settings.branches ?? [];
  return /* @__PURE__ */ y(
    "div",
    {
      className: "h-full flex items-center justify-center ",
      onContextMenu: (A) => {
        A.preventDefault(), A.stopPropagation(), h(!0);
      },
      children: /* @__PURE__ */ y(
        "div",
        {
          className: "bg-builder-background",
          style: {
            paddingTop: Ie.LABEL_VERTICAL_PADDING / 2 + "px",
            paddingBottom: Ie.LABEL_VERTICAL_PADDING / 2 + "px"
          },
          children: /* @__PURE__ */ V(
            "div",
            {
              className: Se(
                "flex items-center justify-center gap-0.5 select-none transition-all rounded-md  text-sm border  border-solid bg-primary-100/30 dark:bg-primary-100/15  border-primary/50   px-2 text-primary/80 dark:text-primary/90   hover:text-primary hover:border-primary",
                {
                  "border-primary text-primary": f,
                  "bg-border/60 text-foreground/70 dark:text-foreground/70  border-border hover:text-foreground/70 hover:bg-border/60 hover:border-border cursor-default": u
                }
              ),
              style: {
                height: Ie.LABEL_HEIGHT + "px",
                maxWidth: Ie.AP_NODE_SIZE.STEP.width - 10 + "px"
              },
              onClick: () => {
                e.stepLocationRelativeToParent === Hn.INSIDE_BRANCH && !u && (r(e.sourceNodeName), i(e.branchIndex), d(
                  Na.createFocusStepInGraphParams(
                    e.targetNodeName
                  )
                ));
              },
              children: [
                /* @__PURE__ */ y("div", { className: "truncate", children: e.label === "Otherwise" ? Z("Otherwise") : e.label }),
                !u && !l && o.type === qe.ROUTER && /* @__PURE__ */ V(
                  mN,
                  {
                    modal: !0,
                    open: p,
                    onOpenChange: h,
                    children: [
                      /* @__PURE__ */ y(G$, { asChild: !0, children: /* @__PURE__ */ y(
                        "div",
                        {
                          className: "h-5 shrink-0 border border-transparent hover:border-solid hover:border-primary-300/50 transition-all rounded-full w-5 flex items-center justify-center",
                          onClick: (A) => A.stopPropagation(),
                          children: /* @__PURE__ */ y(Tit, { className: "h-4 w-4" })
                        }
                      ) }),
                      /* @__PURE__ */ V(
                        xx,
                        {
                          onClick: (A) => {
                            A.preventDefault(), A.stopPropagation();
                          },
                          children: [
                            /* @__PURE__ */ y(
                              wa,
                              {
                                onSelect: (A) => {
                                  A.preventDefault(), A.stopPropagation(), s({
                                    type: Tt.DUPLICATE_BRANCH,
                                    request: {
                                      stepName: e.sourceNodeName,
                                      branchIndex: e.branchIndex
                                    }
                                  }), i(e.branchIndex + 1);
                                },
                                children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer  flex-row gap-2 items-center", children: [
                                  /* @__PURE__ */ y($H, { className: "h-4 w-4" }),
                                  /* @__PURE__ */ y("span", { children: Z("Duplicate Branch") })
                                ] })
                              }
                            ),
                            /* @__PURE__ */ y(aPe, {}),
                            /* @__PURE__ */ y(
                              wa,
                              {
                                disabled: m.length <= 2,
                                onSelect: (A) => {
                                  A.preventDefault(), A.stopPropagation(), i(null), s({
                                    type: Tt.DELETE_BRANCH,
                                    request: {
                                      stepName: e.sourceNodeName,
                                      branchIndex: e.branchIndex
                                    }
                                  }), r(e.sourceNodeName);
                                },
                                children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer  flex-row gap-2 items-center", children: [
                                  /* @__PURE__ */ y(oxe, { className: "h-4 w-4 text-destructive" }),
                                  /* @__PURE__ */ y("span", { className: "text-destructive", children: Z("Delete Branch") })
                                ] })
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}, i1t = ({
  sourceX: e,
  targetX: t,
  targetY: n,
  data: r,
  source: i,
  target: o,
  id: s
}) => {
  const l = Ie.VERTICAL_SPACE_BETWEEN_STEPS - Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE + Ie.LABEL_HEIGHT, c = Math.abs(t - e), u = (() => {
    let d = `M ${t} ${n - Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE}`;
    if (r.isBranchEmpty || (d += Ie.ARROW_DOWN), d += `v -${l}`, c >= Ie.ARC_LENGTH) {
      if (d += e > t ? " a12,12 0 0,1 12,-12" : " a-12,-12 0 0,0 -12,-12", r.drawHorizontalLine) {
        const p = (Math.abs(t - e) + 3 - 2 * Ie.ARC_LENGTH) * (e > t ? 1 : -1);
        d += `h ${p}`, d += e > t ? Ie.ARC_LEFT_UP : Ie.ARC_RIGHT_UP;
      }
      if (r.drawStartingVerticalLine) {
        const p = Ie.VERTICAL_SPACE_BETWEEN_STEPS / 2 - 2 * Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE;
        d += `v -${p}`;
      }
    } else
      d += `v -${Ie.ARC_LENGTH + Ie.VERTICAL_SPACE_BETWEEN_STEP_AND_LINE}`;
    return d;
  })(), f = r.stepLocationRelativeToParent === Hn.INSIDE_BRANCH ? {
    label: r.label,
    targetNodeName: o,
    stepLocationRelativeToParent: r.stepLocationRelativeToParent,
    branchIndex: r.branchIndex
  } : {
    label: r.label,
    targetNodeName: o,
    stepLocationRelativeToParent: r.stepLocationRelativeToParent
  };
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      kh,
      {
        path: u,
        style: { strokeWidth: `${Ie.LINE_WIDTH}px` }
      }
    ),
    !r.isBranchEmpty && /* @__PURE__ */ V(
      "foreignObject",
      {
        x: t - Ie.AP_NODE_SIZE.ADD_BUTTON.width / 2,
        y: n - l / 2,
        width: Ie.AP_NODE_SIZE.ADD_BUTTON.width,
        height: Ie.AP_NODE_SIZE.ADD_BUTTON.height,
        className: "overflow-visible",
        children: [
          r.stepLocationRelativeToParent !== Hn.INSIDE_BRANCH && /* @__PURE__ */ y(
            zv,
            {
              edgeId: s,
              stepLocationRelativeToParent: r.stepLocationRelativeToParent,
              parentStepName: i
            }
          ),
          r.stepLocationRelativeToParent === Hn.INSIDE_BRANCH && /* @__PURE__ */ y(
            zv,
            {
              edgeId: s,
              stepLocationRelativeToParent: r.stepLocationRelativeToParent,
              parentStepName: i,
              branchIndex: r.branchIndex
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ y(
      "foreignObject",
      {
        width: Ie.AP_NODE_SIZE.STEP.width - 10 + "px",
        height: Ie.LABEL_HEIGHT + Ie.LABEL_VERTICAL_PADDING + "px",
        x: t - (Ie.AP_NODE_SIZE.STEP.width - 10) / 2,
        y: n - l / 2 - Ie.AP_NODE_SIZE.ADD_BUTTON.height - 30,
        className: "flex items-center ",
        children: /* @__PURE__ */ y(
          r1t,
          {
            sourceNodeName: i,
            targetNodeName: o,
            stepLocationRelativeToParent: r.stepLocationRelativeToParent,
            branchIndex: r.branchIndex,
            label: r.label
          },
          f.label + f.targetNodeName
        )
      }
    )
  ] });
}, o1t = ({
  sourceX: e,
  sourceY: t,
  targetY: n,
  data: r,
  id: i,
  source: o
}) => {
  const s = e, l = t, c = n - t, a = `M ${s} ${l} v${c}
   ${r.drawArrowHead ? Ie.ARROW_DOWN : ""}`;
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      kh,
      {
        path: a,
        style: { strokeWidth: `${Ie.LINE_WIDTH}px` }
      }
    ),
    !r.hideAddButton && /* @__PURE__ */ y(
      "foreignObject",
      {
        x: s - Ie.AP_NODE_SIZE.ADD_BUTTON.width / 2,
        y: l + (n - t) / 2 - Ie.AP_NODE_SIZE.ADD_BUTTON.height / 2,
        width: Ie.AP_NODE_SIZE.ADD_BUTTON.width,
        height: Ie.AP_NODE_SIZE.ADD_BUTTON.height,
        className: "overflow-visible cursor-default",
        children: /* @__PURE__ */ y(
          zv,
          {
            edgeId: i,
            parentStepName: o,
            stepLocationRelativeToParent: Hn.AFTER
          }
        )
      }
    ),
    !1
  ] });
}, lPe = ie.memo(
  ({ data: e, id: t }) => {
    const [n, r] = He(!1), [i, o, s] = tn((u) => [
      u.readonly,
      u.activeDraggingStep,
      u.openedPieceSelectorStepNameOrAddButtonId === t
    ]), l = wve(), { setNodeRef: c } = e$({
      id: l,
      data: {
        accepts: Ie.DRAGGED_STEP_TAG,
        ...e
      }
    }), a = !De(o);
    return WQ({
      onDragMove(u) {
        var f;
        r(((f = u.over) == null ? void 0 : f.id) === l);
      },
      onDragEnd() {
        r(!1);
      }
    }), /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ V(
        "div",
        {
          style: {
            height: `${Ie.AP_NODE_SIZE.STEP.height}px`,
            width: `${Ie.AP_NODE_SIZE.STEP.width}px`
          },
          className: "flex justify-center items-center ",
          children: [
            !i && //we use transparent colors when opening the piece selector, so to not show the pattern of the background inside the button, we wrap the big add button in a div with the background color
            /* @__PURE__ */ y("div", { className: "bg-builder-background", children: /* @__PURE__ */ V(
              "div",
              {
                style: {
                  height: `${Ie.AP_NODE_SIZE.BIG_ADD_BUTTON.height}px`,
                  width: `${Ie.AP_NODE_SIZE.BIG_ADD_BUTTON.width}px`
                },
                className: " cursor-auto border-none flex items-center justify-center relative ",
                children: [
                  /* @__PURE__ */ y(
                    "div",
                    {
                      style: {
                        height: `${Ie.AP_NODE_SIZE.BIG_ADD_BUTTON.height}px`,
                        width: `${Ie.AP_NODE_SIZE.BIG_ADD_BUTTON.width}px`
                      },
                      id: t,
                      className: Se("rounded-lg bg-background relative", {
                        "bg-primary/80": a || s,
                        "shadow-add-button": n || s,
                        "transition-all": n || s || a
                      }),
                      children: !a && /* @__PURE__ */ y(
                        q$,
                        {
                          operation: Na.createAddOperationFromAddButtonData(
                            e
                          ),
                          id: t,
                          children: /* @__PURE__ */ y("span", { children: /* @__PURE__ */ y(
                            Qe,
                            {
                              variant: "transparent",
                              className: "w-full h-full flex items-center hover:bg-accent-foreground rounded-lg border-border border-solid border",
                              children: /* @__PURE__ */ y(
                                Da,
                                {
                                  className: Se("w-6 h-6 text-foreground ", {
                                    "opacity-0": a || s
                                  })
                                }
                              )
                            }
                          ) })
                        }
                      )
                    }
                  ),
                  a && //this is an invisible div that is used to show the drop indicator when the step is being dragged over the big add button, it is a rectangle so there is more leanancy to drop the step on the big add button
                  /* @__PURE__ */ y(
                    "div",
                    {
                      style: {
                        height: `${Ie.AP_NODE_SIZE.STEP.height}px`,
                        width: `${Ie.AP_NODE_SIZE.STEP.width}px`,
                        top: `-${Ie.AP_NODE_SIZE.STEP.height / 2 - Ie.AP_NODE_SIZE.BIG_ADD_BUTTON.width / 2}px`
                      },
                      className: " absolute ",
                      ref: c,
                      children: " "
                    }
                  )
                ]
              }
            ) }),
            i && /* @__PURE__ */ y(
              "div",
              {
                style: {
                  height: `${Ie.AP_NODE_SIZE.STEP.height}px`,
                  width: `${Ie.AP_NODE_SIZE.STEP.width}px`
                },
                className: " cursor-auto  flex items-center justify-center relative ",
                children: /* @__PURE__ */ y(
                  "svg",
                  {
                    height: Ie.AP_NODE_SIZE.STEP.height,
                    width: Ie.AP_NODE_SIZE.STEP.width,
                    className: "overflow-visible border-transparent ",
                    style: {
                      stroke: "var(--xy-edge-stroke, var(--xy-edge-stroke))"
                    },
                    shapeRendering: "auto",
                    children: /* @__PURE__ */ y("g", { children: /* @__PURE__ */ y(
                      "path",
                      {
                        d: `M ${Ie.AP_NODE_SIZE.STEP.width / 2} -10 v ${Ie.AP_NODE_SIZE.STEP.height + 14}`,
                        fill: "transparent",
                        strokeWidth: "1.5"
                      }
                    ) })
                  }
                )
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ y(
        ou,
        {
          type: "source",
          position: sn.Bottom,
          style: Ie.HANDLE_STYLING
        }
      ),
      /* @__PURE__ */ y(
        ou,
        {
          type: "target",
          position: sn.Top,
          style: Ie.HANDLE_STYLING
        }
      )
    ] });
  }
);
lPe.displayName = "ApBigAddButtonCanvasNode";
const Y$ = () => /* @__PURE__ */ y(
  "div",
  {
    className: " text-center w-[41px] bg-builder-background text-foreground/70 rounded-md animate-fade -ml-[20px]",
    id: "flow-end-button",
    children: /* @__PURE__ */ y("div", { className: "w-full text-center text-sm h-full bg-border/80 p-1 rounded-md", children: Z("End") })
  },
  "flow-end-button"
);
Y$.displayName = "FlowEndWidget";
const cPe = ({ data: e }) => /* @__PURE__ */ V(pt, { children: [
  /* @__PURE__ */ y("div", { className: "h-px w-px relative ", children: e.showWidget && /* @__PURE__ */ y(Y$, {}) }),
  /* @__PURE__ */ y(
    ou,
    {
      type: "target",
      position: sn.Top,
      style: Ie.HANDLE_STYLING
    }
  ),
  /* @__PURE__ */ y(
    ou,
    {
      type: "source",
      position: sn.Bottom,
      style: Ie.HANDLE_STYLING
    }
  )
] });
cPe.displayName = "ApGraphEndWidgetNode";
const uPe = () => /* @__PURE__ */ V(pt, { children: [
  /* @__PURE__ */ y(
    "div",
    {
      className: "h-px bg-transparent pointer-events-none ",
      style: {
        width: Ie.AP_NODE_SIZE.LOOP_RETURN_NODE.width
      }
    }
  ),
  /* @__PURE__ */ y(
    ou,
    {
      type: "source",
      position: sn.Top,
      style: Ie.HANDLE_STYLING
    }
  ),
  /* @__PURE__ */ y(
    ou,
    {
      type: "target",
      position: sn.Bottom,
      style: Ie.HANDLE_STYLING
    }
  )
] });
uPe.displayName = "EmptyLoopReturnCanvasNode";
function ps(e) {
  this.content = e;
}
ps.prototype = {
  constructor: ps,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e) return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var r = n && n != e ? this.remove(n) : this, i = r.find(e), o = r.content.slice();
    return i == -1 ? o.push(n || e, t) : (o[i + 1] = t, n && (o[i] = n)), new ps(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new ps(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new ps([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new ps(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var r = this.remove(t), i = r.content.slice(), o = r.find(e);
    return i.splice(o == -1 ? i.length : o, 0, t, n), new ps(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = ps.from(e), e.size ? new ps(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = ps.from(e), e.size ? new ps(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = ps.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
ps.from = function(e) {
  if (e instanceof ps) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new ps(t);
};
function dPe(e, t, n) {
  for (let r = 0; ; r++) {
    if (r == e.childCount || r == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let i = e.child(r), o = t.child(r);
    if (i == o) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return n;
    if (i.isText && i.text != o.text) {
      for (let s = 0; i.text[s] == o.text[s]; s++)
        n++;
      return n;
    }
    if (i.content.size || o.content.size) {
      let s = dPe(i.content, o.content, n + 1);
      if (s != null)
        return s;
    }
    n += i.nodeSize;
  }
}
function fPe(e, t, n, r) {
  for (let i = e.childCount, o = t.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: n, b: r };
    let s = e.child(--i), l = t.child(--o), c = s.nodeSize;
    if (s == l) {
      n -= c, r -= c;
      continue;
    }
    if (!s.sameMarkup(l))
      return { a: n, b: r };
    if (s.isText && s.text != l.text) {
      let a = 0, u = Math.min(s.text.length, l.text.length);
      for (; a < u && s.text[s.text.length - a - 1] == l.text[l.text.length - a - 1]; )
        a++, n--, r--;
      return { a: n, b: r };
    }
    if (s.content.size || l.content.size) {
      let a = fPe(s.content, l.content, n - 1, r - 1);
      if (a)
        return a;
    }
    n -= c, r -= c;
  }
}
class at {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let r = 0; r < t.length; r++)
        this.size += t[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, r, i = 0, o) {
    for (let s = 0, l = 0; l < n; s++) {
      let c = this.content[s], a = l + c.nodeSize;
      if (a > t && r(c, i + l, o || null, s) !== !1 && c.content.size) {
        let u = l + 1;
        c.nodesBetween(Math.max(0, t - u), Math.min(c.content.size, n - u), r, i + u);
      }
      l = a;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, r, i) {
    let o = "", s = !0;
    return this.nodesBetween(t, n, (l, c) => {
      let a = l.isText ? l.text.slice(Math.max(t, c) - c, n - c) : l.isLeaf ? i ? typeof i == "function" ? i(l) : i : l.type.spec.leafText ? l.type.spec.leafText(l) : "" : "";
      l.isBlock && (l.isLeaf && a || l.isTextblock) && r && (s ? s = !1 : o += r), o += a;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, r = t.firstChild, i = this.content.slice(), o = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), o = 1); o < t.content.length; o++)
      i.push(t.content[o]);
    return new at(i, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > t)
      for (let o = 0, s = 0; s < n; o++) {
        let l = this.content[o], c = s + l.nodeSize;
        c > t && ((s < t || c > n) && (l.isText ? l = l.cut(Math.max(0, t - s), Math.min(l.text.length, n - s)) : l = l.cut(Math.max(0, t - s - 1), Math.min(l.content.size, n - s - 1))), r.push(l), i += l.nodeSize), s = c;
      }
    return new at(r, i);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? at.empty : t == 0 && n == this.content.length ? this : new at(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let r = this.content[t];
    if (r == n)
      return this;
    let i = this.content.slice(), o = this.size + n.nodeSize - r.nodeSize;
    return i[t] = n, new at(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new at([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new at(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      t(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return dPe(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, r = t.size) {
    return fPe(this, t, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(t) {
    if (t == 0)
      return GP(0, t);
    if (t == this.size)
      return GP(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let n = 0, r = 0; ; n++) {
      let i = this.child(n), o = r + i.nodeSize;
      if (o >= t)
        return o == t ? GP(n + 1, o) : GP(n, r);
      r = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return at.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new at(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return at.empty;
    let n, r = 0;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      r += o.nodeSize, i && o.isText && t[i - 1].sameMarkup(o) ? (n || (n = t.slice(0, i)), n[n.length - 1] = o.withText(n[n.length - 1].text + o.text)) : n && n.push(o);
    }
    return new at(n || t, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return at.empty;
    if (t instanceof at)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new at([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
at.empty = new at([], 0);
const q6 = { index: 0, offset: 0 };
function GP(e, t) {
  return q6.index = e, q6.offset = t, q6;
}
function $D(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!$D(e[r], t[r]))
        return !1;
  } else {
    for (let r in e)
      if (!(r in t) || !$D(e[r], t[r]))
        return !1;
    for (let r in t)
      if (!(r in e))
        return !1;
  }
  return !0;
}
let Zr = class PX {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, r = !1;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (this.eq(o))
        return t;
      if (this.type.excludes(o.type))
        n || (n = t.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return t;
        !r && o.type.rank > this.type.rank && (n || (n = t.slice(0, i)), n.push(this), r = !0), n && n.push(o);
      }
    }
    return n || (n = t.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && $D(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = t.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let i = r.create(n.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!t[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return PX.none;
    if (t instanceof PX)
      return [t];
    let n = t.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
Zr.none = [];
class KD extends Error {
}
class zt {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, r) {
    this.content = t, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let r = hPe(this.content, t + this.openStart, n);
    return r && new zt(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new zt(pPe(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return zt.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new zt(at.fromJSON(t, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let r = 0, i = 0;
    for (let o = t.firstChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.firstChild)
      r++;
    for (let o = t.lastChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new zt(t, r, i);
  }
}
zt.empty = new zt(at.empty, 0, 0);
function pPe(e, t, n) {
  let { index: r, offset: i } = e.findIndex(t), o = e.maybeChild(r), { index: s, offset: l } = e.findIndex(n);
  if (i == t || o.isText) {
    if (l != n && !e.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != s)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, o.copy(pPe(o.content, t - i - 1, n - i - 1)));
}
function hPe(e, t, n, r) {
  let { index: i, offset: o } = e.findIndex(t), s = e.maybeChild(i);
  if (o == t || s.isText)
    return r && !r.canReplace(i, i, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
  let l = hPe(s.content, t - o - 1, n, s);
  return l && e.replaceChild(i, s.copy(l));
}
function s1t(e, t, n) {
  if (n.openStart > e.depth)
    throw new KD("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new KD("Inconsistent open depths");
  return mPe(e, t, n, 0);
}
function mPe(e, t, n, r) {
  let i = e.index(r), o = e.node(r);
  if (i == t.index(r) && r < e.depth - n.openStart) {
    let s = mPe(e, t, n, r + 1);
    return o.copy(o.content.replaceChild(i, s));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
      let s = e.parent, l = s.content;
      return cv(s, l.cut(0, e.parentOffset).append(n.content).append(l.cut(t.parentOffset)));
    } else {
      let { start: s, end: l } = a1t(n, e);
      return cv(o, yPe(e, s, l, t, r));
    }
  else return cv(o, GD(e, t, r));
}
function gPe(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new KD("Cannot join " + t.type.name + " onto " + e.type.name);
}
function IX(e, t, n) {
  let r = e.node(n);
  return gPe(r, t.node(n)), r;
}
function lv(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function IE(e, t, n, r) {
  let i = (t || e).node(n), o = 0, s = t ? t.index(n) : i.childCount;
  e && (o = e.index(n), e.depth > n ? o++ : e.textOffset && (lv(e.nodeAfter, r), o++));
  for (let l = o; l < s; l++)
    lv(i.child(l), r);
  t && t.depth == n && t.textOffset && lv(t.nodeBefore, r);
}
function cv(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function yPe(e, t, n, r, i) {
  let o = e.depth > i && IX(e, t, i + 1), s = r.depth > i && IX(n, r, i + 1), l = [];
  return IE(null, e, i, l), o && s && t.index(i) == n.index(i) ? (gPe(o, s), lv(cv(o, yPe(e, t, n, r, i + 1)), l)) : (o && lv(cv(o, GD(e, t, i + 1)), l), IE(t, n, i, l), s && lv(cv(s, GD(n, r, i + 1)), l)), IE(r, null, i, l), new at(l);
}
function GD(e, t, n) {
  let r = [];
  if (IE(null, e, n, r), e.depth > n) {
    let i = IX(e, t, n + 1);
    lv(cv(i, GD(e, t, n + 1)), r);
  }
  return IE(t, null, n, r), new at(r);
}
function a1t(e, t) {
  let n = t.depth - e.openStart, i = t.node(n).copy(e.content);
  for (let o = n - 1; o >= 0; o--)
    i = t.node(o).copy(at.from(i));
  return {
    start: i.resolveNoCache(e.openStart + n),
    end: i.resolveNoCache(i.content.size - e.openEnd - n)
  };
}
class GT {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = t.child(n);
    return r ? t.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let o = 0; o < t; o++)
      i += r.child(o).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return Zr.none;
    if (this.textOffset)
      return t.child(n).marks;
    let r = t.maybeChild(n - 1), i = t.maybeChild(n);
    if (!r) {
      let l = r;
      r = i, i = l;
    }
    let o = r.marks;
    for (var s = 0; s < o.length; s++)
      o[s].type.spec.inclusive === !1 && (!i || !o[s].isInSet(i.marks)) && (o = o[s--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = t.parent.maybeChild(t.index());
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!i || !r[o].isInSet(i.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); r >= 0; r--)
      if (t.pos <= this.end(r) && (!n || n(this.node(r))))
        return new YD(this, t, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, o = n;
    for (let s = t; ; ) {
      let { index: l, offset: c } = s.content.findIndex(o), a = o - c;
      if (r.push(s, l, i + c), !a || (s = s.child(l), s.isText))
        break;
      o = a - 1, i += c + 1;
    }
    return new GT(n, r, o);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    let r = sae.get(t);
    if (r)
      for (let o = 0; o < r.elts.length; o++) {
        let s = r.elts[o];
        if (s.pos == n)
          return s;
      }
    else
      sae.set(t, r = new l1t());
    let i = r.elts[r.i] = GT.resolve(t, n);
    return r.i = (r.i + 1) % c1t, i;
  }
}
class l1t {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const c1t = 12, sae = /* @__PURE__ */ new WeakMap();
class YD {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const u1t = /* @__PURE__ */ Object.create(null);
let Wm = class RX {
  /**
  @internal
  */
  constructor(t, n, r, i = Zr.none) {
    this.type = t, this.attrs = n, this.marks = i, this.content = r || at.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, r, i = 0) {
    this.content.nodesBetween(t, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(t, n, r, i) {
    return this.content.textBetween(t, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, r) {
    return this.type == t && $D(this.attrs, n || t.defaultAttrs || u1t) && Zr.sameSet(this.marks, r || Zr.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new RX(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new RX(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, r = !1) {
    if (t == n)
      return zt.empty;
    let i = this.resolve(t), o = this.resolve(n), s = r ? 0 : i.sharedDepth(n), l = i.start(s), a = i.node(s).content.cut(i.pos - l, o.pos - l);
    return new zt(a, i.depth - s, o.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, r) {
    return s1t(this.resolve(t), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(t);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == t || n.isText)
        return n;
      t -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: r } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(t);
    if (r < t)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return GT.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return GT.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, r) {
    let i = !1;
    return n > t && this.nodesBetween(t, n, (o) => (r.isInSet(o.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), vPe(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, r = at.empty, i = 0, o = r.childCount) {
    let s = this.contentMatchAt(t).matchFragment(r, i, o), l = s && s.matchFragment(this.content, n);
    if (!l || !l.validEnd)
      return !1;
    for (let c = i; c < o; c++)
      if (!this.type.allowsMarks(r.child(c).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let o = this.contentMatchAt(t).matchType(r), s = o && o.matchFragment(this.content, n);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let t = Zr.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), t = r.addToSet(t);
    }
    if (!Zr.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, r);
    }
    let i = at.fromJSON(t, n.content), o = t.nodeType(n.type).create(n.attrs, i, r);
    return o.type.checkAttrs(o.attrs), o;
  }
};
Wm.prototype.text = void 0;
let d1t = class MX extends Wm {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    if (super(t, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : vPe(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new MX(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new MX(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
};
function vPe(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class jv {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let r = new f1t(t, n);
    if (r.next == null)
      return jv.empty;
    let i = bPe(r);
    r.next && r.err("Unexpected trailing text");
    let o = b1t(v1t(i));
    return O1t(o, r), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, r = t.childCount) {
    let i = this;
    for (let o = n; i && o < r; o++)
      i = i.matchType(t.child(o).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < t.next.length; r++)
        if (this.next[n].type == t.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, r = 0) {
    let i = [this];
    function o(s, l) {
      let c = s.matchFragment(t, r);
      if (c && (!n || c.validEnd))
        return at.from(l.map((a) => a.createAndFill()));
      for (let a = 0; a < s.next.length; a++) {
        let { type: u, next: f } = s.next[a];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(f) == -1) {
          i.push(f);
          let d = o(f, l.concat(u));
          if (d)
            return d;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == t)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), o = i.match;
      if (o.matchType(t)) {
        let s = [];
        for (let l = i; l.type; l = l.via)
          s.push(l.type);
        return s.reverse();
      }
      for (let s = 0; s < o.next.length; s++) {
        let { type: l, next: c } = o.next[s];
        !l.isLeaf && !l.hasRequiredAttrs() && !(l.name in n) && (!i.type || c.validEnd) && (r.push({ match: l.contentMatch, type: l, via: i }), n[l.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(r) {
      t.push(r);
      for (let i = 0; i < r.next.length; i++)
        t.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), t.map((r, i) => {
      let o = i + (r.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < r.next.length; s++)
        o += (s ? ", " : "") + r.next[s].type.name + "->" + t.indexOf(r.next[s].next);
      return o;
    }).join(`
`);
  }
}
jv.empty = new jv(!0);
class f1t {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function bPe(e) {
  let t = [];
  do
    t.push(p1t(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function p1t(e) {
  let t = [];
  do
    t.push(h1t(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function h1t(e) {
  let t = y1t(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = m1t(e, t);
    else
      break;
  return t;
}
function aae(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function m1t(e, t) {
  let n = aae(e), r = n;
  return e.eat(",") && (e.next != "}" ? r = aae(e) : r = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: t };
}
function g1t(e, t) {
  let n = e.nodeTypes, r = n[t];
  if (r)
    return [r];
  let i = [];
  for (let o in n) {
    let s = n[o];
    s.isInGroup(t) && i.push(s);
  }
  return i.length == 0 && e.err("No node type or group '" + t + "' found"), i;
}
function y1t(e) {
  if (e.eat("(")) {
    let t = bPe(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = g1t(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function v1t(e) {
  let t = [[]];
  return i(o(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function r(s, l, c) {
    let a = { term: c, to: l };
    return t[s].push(a), a;
  }
  function i(s, l) {
    s.forEach((c) => c.to = l);
  }
  function o(s, l) {
    if (s.type == "choice")
      return s.exprs.reduce((c, a) => c.concat(o(a, l)), []);
    if (s.type == "seq")
      for (let c = 0; ; c++) {
        let a = o(s.exprs[c], l);
        if (c == s.exprs.length - 1)
          return a;
        i(a, l = n());
      }
    else if (s.type == "star") {
      let c = n();
      return r(l, c), i(o(s.expr, c), c), [r(c)];
    } else if (s.type == "plus") {
      let c = n();
      return i(o(s.expr, l), c), i(o(s.expr, c), c), [r(c)];
    } else {
      if (s.type == "opt")
        return [r(l)].concat(o(s.expr, l));
      if (s.type == "range") {
        let c = l;
        for (let a = 0; a < s.min; a++) {
          let u = n();
          i(o(s.expr, c), u), c = u;
        }
        if (s.max == -1)
          i(o(s.expr, c), c);
        else
          for (let a = s.min; a < s.max; a++) {
            let u = n();
            r(c, u), i(o(s.expr, c), u), c = u;
          }
        return [r(c)];
      } else {
        if (s.type == "name")
          return [r(l, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function OPe(e, t) {
  return t - e;
}
function lae(e, t) {
  let n = [];
  return r(t), n.sort(OPe);
  function r(i) {
    let o = e[i];
    if (o.length == 1 && !o[0].term)
      return r(o[0].to);
    n.push(i);
    for (let s = 0; s < o.length; s++) {
      let { term: l, to: c } = o[s];
      !l && n.indexOf(c) == -1 && r(c);
    }
  }
}
function b1t(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(lae(e, 0));
  function n(r) {
    let i = [];
    r.forEach((s) => {
      e[s].forEach(({ term: l, to: c }) => {
        if (!l)
          return;
        let a;
        for (let u = 0; u < i.length; u++)
          i[u][0] == l && (a = i[u][1]);
        lae(e, c).forEach((u) => {
          a || i.push([l, a = []]), a.indexOf(u) == -1 && a.push(u);
        });
      });
    });
    let o = t[r.join(",")] = new jv(r.indexOf(e.length - 1) > -1);
    for (let s = 0; s < i.length; s++) {
      let l = i[s][1].sort(OPe);
      o.next.push({ type: i[s][0], next: t[l.join(",")] || n(l) });
    }
    return o;
  }
}
function O1t(e, t) {
  for (let n = 0, r = [e]; n < r.length; n++) {
    let i = r[n], o = !i.validEnd, s = [];
    for (let l = 0; l < i.next.length; l++) {
      let { type: c, next: a } = i.next[l];
      s.push(c.name), o && !(c.isText || c.hasRequiredAttrs()) && (o = !1), r.indexOf(a) == -1 && r.push(a);
    }
    o && t.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function APe(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault)
      return null;
    t[n] = r.default;
  }
  return t;
}
function wPe(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let i = t && t[r];
    if (i === void 0) {
      let o = e[r];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function xPe(e, t, n, r) {
  for (let i in t)
    if (!(i in e))
      throw new RangeError(`Unsupported attribute ${i} for ${n} of type ${i}`);
  for (let i in e) {
    let o = e[i];
    o.validate && o.validate(t[i]);
  }
}
function SPe(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  if (t)
    for (let r in t)
      n[r] = new w1t(e, r, t[r]);
  return n;
}
let cae = class EPe {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.name = t, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = SPe(t, r.attrs), this.defaultAttrs = APe(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == jv.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(t) {
    return this.groups.indexOf(t) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : wPe(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Wm(this, this.computeAttrs(t), at.from(n), Zr.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, r) {
    return n = at.from(n), this.checkContent(n), new Wm(this, this.computeAttrs(t), n, Zr.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, r) {
    if (t = this.computeAttrs(t), n = at.from(n), n.size) {
      let s = this.contentMatch.fillBefore(n);
      if (!s)
        return null;
      n = s.append(n);
    }
    let i = this.contentMatch.matchFragment(n), o = i && i.fillBefore(at.empty, !0);
    return o ? new Wm(this, t, n.append(o), Zr.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < t.childCount; r++)
      if (!this.allowsMarks(t.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(t) {
    xPe(this.attrs, t, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let r = 0; r < t.length; r++)
      this.allowsMarkType(t[r].type) ? n && n.push(t[r]) : n || (n = t.slice(0, r));
    return n ? n.length ? n : Zr.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null);
    t.forEach((o, s) => r[o] = new EPe(o, n, s));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function A1t(e, t, n) {
  let r = n.split("|");
  return (i) => {
    let o = i === null ? "null" : typeof i;
    if (r.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${t} on type ${e}, got ${o}`);
  };
}
class w1t {
  constructor(t, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? A1t(t, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class wj {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.rank = n, this.schema = r, this.spec = i, this.attrs = SPe(t, i.attrs), this.excluded = null;
    let o = APe(this.attrs);
    this.instance = o ? new Zr(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new Zr(this, wPe(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return t.forEach((o, s) => r[o] = new wj(o, i++, n, s)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  @internal
  */
  checkAttrs(t) {
    xPe(this.attrs, t, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
let TPe = class {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in t)
      n[i] = t[i];
    n.nodes = ps.from(t.nodes), n.marks = ps.from(t.marks || {}), this.nodes = cae.compile(this.spec.nodes, this), this.marks = wj.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let o = this.nodes[i], s = o.spec.content || "", l = o.spec.marks;
      if (o.contentMatch = r[s] || (r[s] = jv.parse(s, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = l == "_" ? null : l ? uae(this, l.split(" ")) : l == "" || !o.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let o = this.marks[i], s = o.spec.excludes;
      o.excluded = s == null ? [o] : s == "" ? [] : uae(this, s.split(" "));
    }
    this.nodeFromJSON = (i) => Wm.fromJSON(this, i), this.markFromJSON = (i) => Zr.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, r, i) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof cae) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let r = this.nodes.text;
    return new d1t(r, r.defaultAttrs, t, Zr.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
};
function uae(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r], o = e.marks[i], s = o;
    if (o)
      n.push(o);
    else
      for (let l in e.marks) {
        let c = e.marks[l];
        (i == "_" || c.spec.group && c.spec.group.split(" ").indexOf(i) > -1) && n.push(s = c);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
function x1t(e) {
  return e.tag != null;
}
function S1t(e) {
  return e.style != null;
}
class eh {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((i) => {
      if (x1t(i))
        this.tags.push(i);
      else if (S1t(i)) {
        let o = /[^=]*/.exec(i.style)[0];
        r.indexOf(o) < 0 && r.push(o), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let o = t.nodes[i.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let r = new fae(this, n, !1);
    return r.addAll(t, Zr.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let r = new fae(this, n, !0);
    return r.addAll(t, Zr.none, n.from, n.to), zt.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (k1t(t, o.tag) && (o.namespace === void 0 || t.namespaceURI == o.namespace) && (!o.context || n.matchesContext(o.context))) {
        if (o.getAttrs) {
          let s = o.getAttrs(t);
          if (s === !1)
            continue;
          o.attrs = s || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, r, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let s = this.styles[o], l = s.style;
      if (!(l.indexOf(t) != 0 || s.context && !r.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      l.length > t.length && (l.charCodeAt(t.length) != 61 || l.slice(t.length + 1) != n))) {
        if (s.getAttrs) {
          let c = s.getAttrs(n);
          if (c === !1)
            continue;
          s.attrs = c || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function r(i) {
      let o = i.priority == null ? 50 : i.priority, s = 0;
      for (; s < n.length; s++) {
        let l = n[s];
        if ((l.priority == null ? 50 : l.priority) < o)
          break;
      }
      n.splice(s, 0, i);
    }
    for (let i in t.marks) {
      let o = t.marks[i].spec.parseDOM;
      o && o.forEach((s) => {
        r(s = pae(s)), s.mark || s.ignore || s.clearMark || (s.mark = i);
      });
    }
    for (let i in t.nodes) {
      let o = t.nodes[i].spec.parseDOM;
      o && o.forEach((s) => {
        r(s = pae(s)), s.node || s.ignore || s.mark || (s.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new eh(t, eh.schemaRules(t)));
  }
}
const kPe = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, E1t = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, CPe = { ol: !0, ul: !0 }, YT = 1, DX = 2, KR = 4;
function dae(e, t, n) {
  return t != null ? (t ? YT : 0) | (t === "full" ? DX : 0) : e && e.whitespace == "pre" ? YT | DX : n & -5;
}
class YP {
  constructor(t, n, r, i, o, s) {
    this.type = t, this.attrs = n, this.marks = r, this.solid = i, this.options = s, this.content = [], this.activeMarks = Zr.none, this.match = o || (s & KR ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(at.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(t.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & YT)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let o = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let n = at.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(at.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !kPe.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
let fae = class {
  constructor(t, n, r) {
    this.parser = t, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = n.topNode, o, s = dae(null, n.preserveWhitespace, 0) | (r ? KR : 0);
    i ? o = new YP(i.type, i.attrs, Zr.none, !0, n.topMatch || i.type.contentMatch, s) : r ? o = new YP(null, null, Zr.none, !0, null, s) : o = new YP(t.schema.topNodeType, null, Zr.none, !0, null, s), this.nodes = [o], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t, n) {
    t.nodeType == 3 ? this.addTextNode(t, n) : t.nodeType == 1 && this.addElement(t, n);
  }
  addTextNode(t, n) {
    let r = t.nodeValue, i = this.top, o = i.options & DX ? "full" : this.localPreserveWS || (i.options & YT) > 0, { schema: s } = this.parser;
    if (o === "full" || i.inlineContext(t) || /[^ \t\r\n\u000c]/.test(r)) {
      if (o)
        if (o === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (s.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(s.linebreakReplacement.create())) {
          let l = r.split(/\r?\n|\r/);
          for (let c = 0; c < l.length; c++)
            c && this.insertNode(s.linebreakReplacement.create(), n, !0), l[c] && this.insertNode(s.text(l[c]), n, !/\S/.test(l[c]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let l = i.content[i.content.length - 1], c = t.previousSibling;
        (!l || c && c.nodeName == "BR" || l.isText && /[ \t\r\n\u000c]$/.test(l.text)) && (r = r.slice(1));
      }
      r && this.insertNode(s.text(r), n, !/\S/.test(r)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n, r) {
    let i = this.localPreserveWS, o = this.top;
    (t.tagName == "PRE" || /pre/.test(t.style && t.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = t.nodeName.toLowerCase(), l;
    CPe.hasOwnProperty(s) && this.parser.normalizeLists && T1t(t);
    let c = this.options.ruleFromNode && this.options.ruleFromNode(t) || (l = this.parser.matchTag(t, this, r));
    e: if (c ? c.ignore : E1t.hasOwnProperty(s))
      this.findInside(t), this.ignoreFallback(t, n);
    else if (!c || c.skip || c.closeParent) {
      c && c.closeParent ? this.open = Math.max(0, this.open - 1) : c && c.skip.nodeType && (t = c.skip);
      let a, u = this.needsBlock;
      if (kPe.hasOwnProperty(s))
        o.content.length && o.content[0].isInline && this.open && (this.open--, o = this.top), a = !0, o.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t, n);
        break e;
      }
      let f = c && c.skip ? n : this.readStyles(t, n);
      f && this.addAll(t, f), a && this.sync(o), this.needsBlock = u;
    } else {
      let a = this.readStyles(t, n);
      a && this.addElementByRule(t, c, a, c.consuming === !1 ? l : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t, n) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(t, n) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(t, n) {
    let r = t.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let o = this.parser.matchedStyles[i], s = r.getPropertyValue(o);
        if (s)
          for (let l = void 0; ; ) {
            let c = this.parser.matchStyle(o, s, this, l);
            if (!c)
              break;
            if (c.ignore)
              return null;
            if (c.clearMark ? n = n.filter((a) => !c.clearMark(a)) : n = n.concat(this.parser.schema.marks[c.mark].create(c.attrs)), c.consuming === !1)
              l = c;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, r, i) {
    let o, s;
    if (n.node)
      if (s = this.parser.schema.nodes[n.node], s.isLeaf)
        this.insertNode(s.create(n.attrs), r, t.nodeName == "BR") || this.leafFallback(t, r);
      else {
        let c = this.enter(s, n.attrs || null, r, n.preserveWhitespace);
        c && (o = !0, r = c);
      }
    else {
      let c = this.parser.schema.marks[n.mark];
      r = r.concat(c.create(n.attrs));
    }
    let l = this.top;
    if (s && s.isLeaf)
      this.findInside(t);
    else if (i)
      this.addElement(t, r, i);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((c) => this.insertNode(c, r, !1));
    else {
      let c = t;
      typeof n.contentElement == "string" ? c = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? c = n.contentElement(t) : n.contentElement && (c = n.contentElement), this.findAround(t, c, !0), this.addAll(c, r), this.findAround(t, c, !1);
    }
    o && this.sync(l) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, r, i) {
    let o = r || 0;
    for (let s = r ? t.childNodes[r] : t.firstChild, l = i == null ? null : t.childNodes[i]; s != l; s = s.nextSibling, ++o)
      this.findAtPoint(t, o), this.addDOM(s, n);
    this.findAtPoint(t, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t, n, r) {
    let i, o;
    for (let s = this.open, l = 0; s >= 0; s--) {
      let c = this.nodes[s], a = c.findWrapping(t);
      if (a && (!i || i.length > a.length + l) && (i = a, o = c, !a.length))
        break;
      if (c.solid) {
        if (r)
          break;
        l += 2;
      }
    }
    if (!i)
      return null;
    this.sync(o);
    for (let s = 0; s < i.length; s++)
      n = this.enterInner(i[s], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t, n, r) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (n = this.enterInner(o, null, n));
    }
    let i = this.findPlace(t, n, r);
    if (i) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(t.type));
      let s = Zr.none;
      for (let l of i.concat(t.marks))
        (o.type ? o.type.allowsMarkType(l.type) : hae(l.type, t.type)) && (s = l.addToSet(s));
      return o.content.push(t.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, r, i) {
    let o = this.findPlace(t.create(n), r, !1);
    return o && (o = this.enterInner(t, n, r, !0, i)), o;
  }
  // Open a node of the given type
  enterInner(t, n, r, i = !1, o) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(t);
    let l = dae(t, o, s.options);
    s.options & KR && s.content.length == 0 && (l |= KR);
    let c = Zr.none;
    return r = r.filter((a) => (s.type ? s.type.allowsMarkType(a.type) : hae(a.type, t)) ? (c = a.addToSet(c), !1) : !0), this.nodes.push(new YP(t, n, c, i, null, l)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == t)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= YT);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        t += r[i].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, r) {
    if (t != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && t.nodeType == 1 && t.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), o = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), s = (l, c) => {
      for (; l >= 0; l--) {
        let a = n[l];
        if (a == "") {
          if (l == n.length - 1 || l == 0)
            continue;
          for (; c >= o; c--)
            if (s(l - 1, c))
              return !0;
          return !1;
        } else {
          let u = c > 0 || c == 0 && i ? this.nodes[c].type : r && c >= o ? r.node(c - o).type : null;
          if (!u || u.name != a && !u.isInGroup(a))
            return !1;
          c--;
        }
      }
      return !0;
    };
    return s(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let r = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
};
function T1t(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let r = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    r && CPe.hasOwnProperty(r) && n ? (n.appendChild(t), t = n) : r == "li" ? n = t : r && (n = null);
  }
}
function k1t(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function pae(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function hae(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(e))
      continue;
    let o = [], s = (l) => {
      o.push(l);
      for (let c = 0; c < l.edgeCount; c++) {
        let { type: a, next: u } = l.edge(c);
        if (a == t || o.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(i.contentMatch))
      return !0;
  }
}
class Pb {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, r) {
    r || (r = B6(n).createDocumentFragment());
    let i = r, o = [];
    return t.forEach((s) => {
      if (o.length || s.marks.length) {
        let l = 0, c = 0;
        for (; l < o.length && c < s.marks.length; ) {
          let a = s.marks[c];
          if (!this.marks[a.type.name]) {
            c++;
            continue;
          }
          if (!a.eq(o[l][0]) || a.type.spec.spanning === !1)
            break;
          l++, c++;
        }
        for (; l < o.length; )
          i = o.pop()[1];
        for (; c < s.marks.length; ) {
          let a = s.marks[c++], u = this.serializeMark(a, s.isInline, n);
          u && (o.push([a, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(s, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    let { dom: r, contentDOM: i } = GR(B6(n), this.nodes[t.type.name](t), null, t.attrs);
    if (i) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let r = this.serializeNodeInner(t, n);
    for (let i = t.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(t.marks[i], t.isInline, n);
      o && ((o.contentDOM || o.dom).appendChild(r), r = o.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(t, n, r = {}) {
    let i = this.marks[t.type.name];
    return i && GR(B6(r), i(t, n), null, t.attrs);
  }
  static renderSpec(t, n, r = null, i) {
    return GR(t, n, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Pb(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = mae(t.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return mae(t.marks);
  }
}
function mae(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function B6(e) {
  return e.document || window.document;
}
const gae = /* @__PURE__ */ new WeakMap();
function C1t(e) {
  let t = gae.get(e);
  return t === void 0 && gae.set(e, t = N1t(e)), t;
}
function N1t(e) {
  let t = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          t || (t = []), t.push(r);
        else
          for (let i = 0; i < r.length; i++)
            n(r[i]);
      else
        for (let i in r)
          n(r[i]);
  }
  return n(e), t;
}
function GR(e, t, n, r) {
  if (typeof t == "string")
    return { dom: e.createTextNode(t) };
  if (t.nodeType != null)
    return { dom: t };
  if (t.dom && t.dom.nodeType != null)
    return t;
  let i = t[0], o;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (o = C1t(r)) && o.indexOf(t) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = i.indexOf(" ");
  s > 0 && (n = i.slice(0, s), i = i.slice(s + 1));
  let l, c = n ? e.createElementNS(n, i) : e.createElement(i), a = t[1], u = 1;
  if (a && typeof a == "object" && a.nodeType == null && !Array.isArray(a)) {
    u = 2;
    for (let f in a)
      if (a[f] != null) {
        let d = f.indexOf(" ");
        d > 0 ? c.setAttributeNS(f.slice(0, d), f.slice(d + 1), a[f]) : f == "style" && c.style ? c.style.cssText = a[f] : c.setAttribute(f, a[f]);
      }
  }
  for (let f = u; f < t.length; f++) {
    let d = t[f];
    if (d === 0) {
      if (f < t.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: c, contentDOM: c };
    } else {
      let { dom: p, contentDOM: h } = GR(e, d, n, r);
      if (c.appendChild(p), h) {
        if (l)
          throw new RangeError("Multiple content holes");
        l = h;
      }
    }
  }
  return { dom: c, contentDOM: l };
}
const NPe = 65535, PPe = Math.pow(2, 16);
function P1t(e, t) {
  return e + t * PPe;
}
function yae(e) {
  return e & NPe;
}
function I1t(e) {
  return (e - (e & NPe)) / PPe;
}
const IPe = 1, RPe = 2, YR = 4, MPe = 8;
class _X {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & MPe) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (IPe | YR)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (RPe | YR)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & YR) > 0;
  }
}
class Gl {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && Gl.empty)
      return Gl.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, r = yae(t);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + I1t(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0, o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let c = this.ranges[l] - (this.inverted ? i : 0);
      if (c > t)
        break;
      let a = this.ranges[l + o], u = this.ranges[l + s], f = c + a;
      if (t <= f) {
        let d = a ? t == c ? -1 : t == f ? 1 : n : n, p = c + i + (d < 0 ? 0 : u);
        if (r)
          return p;
        let h = t == (n < 0 ? c : f) ? null : P1t(l / 3, t - c), m = t == c ? RPe : t == f ? IPe : YR;
        return (n < 0 ? t != c : t != f) && (m |= MPe), new _X(p, m, h);
      }
      i += u - a;
    }
    return r ? t + i : new _X(t + i, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let r = 0, i = yae(n), o = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let c = this.ranges[l] - (this.inverted ? r : 0);
      if (c > t)
        break;
      let a = this.ranges[l + o], u = c + a;
      if (t <= u && l == i * 3)
        return !0;
      r += this.ranges[l + s] - a;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i], l = s - (this.inverted ? o : 0), c = s + (this.inverted ? 0 : o), a = this.ranges[i + n], u = this.ranges[i + r];
      t(l, l + a, c, c + u), o += u - a;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Gl(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? Gl.empty : new Gl(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
Gl.empty = new Gl([]);
class JT {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t, n, r = 0, i = t ? t.length : 0) {
    this.mirror = n, this.from = r, this.to = i, this._maps = t || [], this.ownData = !(t || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new JT(this._maps, this.mirror, t, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(t), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, r = this._maps.length; n < t._maps.length; n++) {
      let i = t.getMirror(n);
      this.appendMap(t._maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, r = this._maps.length + t._maps.length; n >= 0; n--) {
      let i = t.getMirror(n);
      this.appendMap(t._maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new JT();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let r = this.from; r < this.to; r++)
      t = this._maps[r].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let s = this._maps[o], l = s.mapResult(t, n);
      if (l.recover != null) {
        let c = this.getMirror(o);
        if (c != null && c > o && c < this.to) {
          o = c, t = this._maps[c].recover(l.recover);
          continue;
        }
      }
      i |= l.delInfo, t = l.pos;
    }
    return r ? t : new _X(t, i, null);
  }
}
const X6 = /* @__PURE__ */ Object.create(null);
class oa {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Gl.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = X6[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in X6)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return X6[t] = n, n.prototype.jsonID = t, n;
  }
}
class ho {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new ho(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new ho(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, r, i) {
    try {
      return ho.ok(t.replace(n, r, i));
    } catch (o) {
      if (o instanceof KD)
        return ho.fail(o.message);
      throw o;
    }
  }
}
function J$(e, t, n) {
  let r = [];
  for (let i = 0; i < e.childCount; i++) {
    let o = e.child(i);
    o.content.size && (o = o.copy(J$(o.content, t, o))), o.isInline && (o = t(o, n, i)), r.push(o);
  }
  return at.fromArray(r);
}
class Mm extends oa {
  /**
  Create a mark step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = t.resolve(this.from), i = r.node(r.sharedDepth(this.to)), o = new zt(J$(n.content, (s, l) => !s.isAtom || !l.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), i), n.openStart, n.openEnd);
    return ho.fromReplace(t, this.from, this.to, o);
  }
  invert() {
    return new qu(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Mm(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Mm && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Mm(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Mm(n.from, n.to, t.markFromJSON(n.mark));
  }
}
oa.jsonID("addMark", Mm);
class qu extends oa {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = new zt(J$(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), t), n.openStart, n.openEnd);
    return ho.fromReplace(t, this.from, this.to, r);
  }
  invert() {
    return new Mm(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new qu(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof qu && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new qu(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new qu(n.from, n.to, t.markFromJSON(n.mark));
  }
}
oa.jsonID("removeMark", qu);
class Dm extends oa {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ho.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return ho.fromReplace(t, this.pos, this.pos + 1, new zt(at.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new Dm(this.pos, n.marks[i]);
        return new Dm(this.pos, this.mark);
      }
    }
    return new Fv(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Dm(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Dm(n.pos, t.markFromJSON(n.mark));
  }
}
oa.jsonID("addNodeMark", Dm);
class Fv extends oa {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ho.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return ho.fromReplace(t, this.pos, this.pos + 1, new zt(at.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Dm(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Fv(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Fv(n.pos, t.markFromJSON(n.mark));
  }
}
oa.jsonID("removeNodeMark", Fv);
class Qo extends oa {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, r, i = !1) {
    super(), this.from = t, this.to = n, this.slice = r, this.structure = i;
  }
  apply(t) {
    return this.structure && LX(t, this.from, this.to) ? ho.fail("Structure replace would overwrite content") : ho.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new Gl([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new Qo(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new Qo(n.pos, Math.max(n.pos, r.pos), this.slice, this.structure);
  }
  merge(t) {
    if (!(t instanceof Qo) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? zt.empty : new zt(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new Qo(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? zt.empty : new zt(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new Qo(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Qo(n.from, n.to, zt.fromJSON(t, n.slice), !!n.structure);
  }
}
oa.jsonID("replace", Qo);
class ts extends oa {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, r, i, o, s, l = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = o, this.insert = s, this.structure = l;
  }
  apply(t) {
    if (this.structure && (LX(t, this.from, this.gapFrom) || LX(t, this.gapTo, this.to)))
      return ho.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return ho.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? ho.fromReplace(t, this.from, this.to, r) : ho.fail("Content does not fit in gap");
  }
  getMap() {
    return new Gl([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new ts(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), o = this.to == this.gapTo ? r.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || o > r.pos ? null : new ts(n.pos, r.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new ts(n.from, n.to, n.gapFrom, n.gapTo, zt.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
oa.jsonID("replaceAround", ts);
function LX(e, t, n) {
  let r = e.resolve(t), i = n - t, o = r.depth;
  for (; i > 0 && o > 0 && r.indexAfter(o) == r.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let s = r.node(o).maybeChild(r.indexAfter(o));
    for (; i > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, i--;
    }
  }
  return !1;
}
function R1t(e, t, n, r) {
  let i = [], o = [], s, l;
  e.doc.nodesBetween(t, n, (c, a, u) => {
    if (!c.isInline)
      return;
    let f = c.marks;
    if (!r.isInSet(f) && u.type.allowsMarkType(r.type)) {
      let d = Math.max(a, t), p = Math.min(a + c.nodeSize, n), h = r.addToSet(f);
      for (let m = 0; m < f.length; m++)
        f[m].isInSet(h) || (s && s.to == d && s.mark.eq(f[m]) ? s.to = p : i.push(s = new qu(d, p, f[m])));
      l && l.to == d ? l.to = p : o.push(l = new Mm(d, p, r));
    }
  }), i.forEach((c) => e.step(c)), o.forEach((c) => e.step(c));
}
function M1t(e, t, n, r) {
  let i = [], o = 0;
  e.doc.nodesBetween(t, n, (s, l) => {
    if (!s.isInline)
      return;
    o++;
    let c = null;
    if (r instanceof wj) {
      let a = s.marks, u;
      for (; u = r.isInSet(a); )
        (c || (c = [])).push(u), a = u.removeFromSet(a);
    } else r ? r.isInSet(s.marks) && (c = [r]) : c = s.marks;
    if (c && c.length) {
      let a = Math.min(l + s.nodeSize, n);
      for (let u = 0; u < c.length; u++) {
        let f = c[u], d;
        for (let p = 0; p < i.length; p++) {
          let h = i[p];
          h.step == o - 1 && f.eq(i[p].style) && (d = h);
        }
        d ? (d.to = a, d.step = o) : i.push({ style: f, from: Math.max(l, t), to: a, step: o });
      }
    }
  }), i.forEach((s) => e.step(new qu(s.from, s.to, s.style)));
}
function eK(e, t, n, r = n.contentMatch, i = !0) {
  let o = e.doc.nodeAt(t), s = [], l = t + 1;
  for (let c = 0; c < o.childCount; c++) {
    let a = o.child(c), u = l + a.nodeSize, f = r.matchType(a.type);
    if (!f)
      s.push(new Qo(l, u, zt.empty));
    else {
      r = f;
      for (let d = 0; d < a.marks.length; d++)
        n.allowsMarkType(a.marks[d].type) || e.step(new qu(l, u, a.marks[d]));
      if (i && a.isText && n.whitespace != "pre") {
        let d, p = /\r?\n|\r/g, h;
        for (; d = p.exec(a.text); )
          h || (h = new zt(at.from(n.schema.text(" ", n.allowedMarks(a.marks))), 0, 0)), s.push(new Qo(l + d.index, l + d.index + d[0].length, h));
      }
    }
    l = u;
  }
  if (!r.validEnd) {
    let c = r.fillBefore(at.empty, !0);
    e.replace(l, l, new zt(c, 0, 0));
  }
  for (let c = s.length - 1; c >= 0; c--)
    e.step(s[c]);
}
function D1t(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function Sx(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let r = e.depth, i = 0, o = 0; ; --r) {
    let s = e.$from.node(r), l = e.$from.index(r) + i, c = e.$to.indexAfter(r) - o;
    if (r < e.depth && s.canReplace(l, c, n))
      return r;
    if (r == 0 || s.type.spec.isolating || !D1t(s, l, c))
      break;
    l && (i = 1), c < s.childCount && (o = 1);
  }
  return null;
}
function _1t(e, t, n) {
  let { $from: r, $to: i, depth: o } = t, s = r.before(o + 1), l = i.after(o + 1), c = s, a = l, u = at.empty, f = 0;
  for (let h = o, m = !1; h > n; h--)
    m || r.index(h) > 0 ? (m = !0, u = at.from(r.node(h).copy(u)), f++) : c--;
  let d = at.empty, p = 0;
  for (let h = o, m = !1; h > n; h--)
    m || i.after(h + 1) < i.end(h) ? (m = !0, d = at.from(i.node(h).copy(d)), p++) : a++;
  e.step(new ts(c, a, s, l, new zt(u.append(d), f, p), u.size - f, !0));
}
function tK(e, t, n = null, r = e) {
  let i = L1t(e, t), o = i && z1t(r, t);
  return o ? i.map(vae).concat({ type: t, attrs: n }).concat(o.map(vae)) : null;
}
function vae(e) {
  return { type: e, attrs: null };
}
function L1t(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.contentMatchAt(r).findWrapping(t);
  if (!o)
    return null;
  let s = o.length ? o[0] : t;
  return n.canReplaceWith(r, i, s) ? o : null;
}
function z1t(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.child(r), s = t.contentMatch.findWrapping(o.type);
  if (!s)
    return null;
  let c = (s.length ? s[s.length - 1] : t).contentMatch;
  for (let a = r; c && a < i; a++)
    c = c.matchType(n.child(a).type);
  return !c || !c.validEnd ? null : s;
}
function j1t(e, t, n) {
  let r = at.empty;
  for (let s = n.length - 1; s >= 0; s--) {
    if (r.size) {
      let l = n[s].type.contentMatch.matchFragment(r);
      if (!l || !l.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = at.from(n[s].type.create(n[s].attrs, r));
  }
  let i = t.start, o = t.end;
  e.step(new ts(i, o, i, o, new zt(r, 0, 0), n.length, !0));
}
function F1t(e, t, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = e.steps.length;
  e.doc.nodesBetween(t, n, (s, l) => {
    let c = typeof i == "function" ? i(s) : i;
    if (s.isTextblock && !s.hasMarkup(r, c) && U1t(e.doc, e.mapping.slice(o).map(l), r)) {
      let a = null;
      if (r.schema.linebreakReplacement) {
        let p = r.whitespace == "pre", h = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        p && !h ? a = !1 : !p && h && (a = !0);
      }
      a === !1 && _Pe(e, s, l, o), eK(e, e.mapping.slice(o).map(l, 1), r, void 0, a === null);
      let u = e.mapping.slice(o), f = u.map(l, 1), d = u.map(l + s.nodeSize, 1);
      return e.step(new ts(f, d, f + 1, d - 1, new zt(at.from(r.create(c, null, s.marks)), 0, 0), 1, !0)), a === !0 && DPe(e, s, l, o), !1;
    }
  });
}
function DPe(e, t, n, r) {
  t.forEach((i, o) => {
    if (i.isText) {
      let s, l = /\r?\n|\r/g;
      for (; s = l.exec(i.text); ) {
        let c = e.mapping.slice(r).map(n + 1 + o + s.index);
        e.replaceWith(c, c + 1, t.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function _Pe(e, t, n, r) {
  t.forEach((i, o) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let s = e.mapping.slice(r).map(n + 1 + o);
      e.replaceWith(s, s + 1, t.type.schema.text(`
`));
    }
  });
}
function U1t(e, t, n) {
  let r = e.resolve(t), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function V1t(e, t, n, r, i) {
  let o = e.doc.nodeAt(t);
  if (!o)
    throw new RangeError("No node at given position");
  n || (n = o.type);
  let s = n.create(r, null, i || o.marks);
  if (o.isLeaf)
    return e.replaceWith(t, t + o.nodeSize, s);
  if (!n.validContent(o.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new ts(t, t + o.nodeSize, t + 1, t + o.nodeSize - 1, new zt(at.from(s), 0, 0), 1, !0));
}
function th(e, t, n = 1, r) {
  let i = e.resolve(t), o = i.depth - n, s = r && r[r.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !s.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let a = i.depth - 1, u = n - 2; a > o; a--, u--) {
    let f = i.node(a), d = i.index(a);
    if (f.type.spec.isolating)
      return !1;
    let p = f.content.cutByIndex(d, f.childCount), h = r && r[u + 1];
    h && (p = p.replaceChild(0, h.type.create(h.attrs)));
    let m = r && r[u] || f;
    if (!f.canReplace(d + 1, f.childCount) || !m.type.validContent(p))
      return !1;
  }
  let l = i.indexAfter(o), c = r && r[0];
  return i.node(o).canReplaceWith(l, l, c ? c.type : i.node(o + 1).type);
}
function q1t(e, t, n = 1, r) {
  let i = e.doc.resolve(t), o = at.empty, s = at.empty;
  for (let l = i.depth, c = i.depth - n, a = n - 1; l > c; l--, a--) {
    o = at.from(i.node(l).copy(o));
    let u = r && r[a];
    s = at.from(u ? u.type.create(u.attrs, s) : i.node(l).copy(s));
  }
  e.step(new Qo(t, t, new zt(o.append(s), n, n), !0));
}
function Rg(e, t) {
  let n = e.resolve(t), r = n.index();
  return LPe(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function B1t(e, t) {
  t.content.size || e.type.compatibleContent(t.type);
  let n = e.contentMatchAt(e.childCount), { linebreakReplacement: r } = e.type.schema;
  for (let i = 0; i < t.childCount; i++) {
    let o = t.child(i), s = o.type == r ? e.type.schema.nodes.text : o.type;
    if (n = n.matchType(s), !n || !e.type.allowsMarks(o.marks))
      return !1;
  }
  return n.validEnd;
}
function LPe(e, t) {
  return !!(e && t && !e.isLeaf && B1t(e, t));
}
function xj(e, t, n = -1) {
  let r = e.resolve(t);
  for (let i = r.depth; ; i--) {
    let o, s, l = r.index(i);
    if (i == r.depth ? (o = r.nodeBefore, s = r.nodeAfter) : n > 0 ? (o = r.node(i + 1), l++, s = r.node(i).maybeChild(l)) : (o = r.node(i).maybeChild(l - 1), s = r.node(i + 1)), o && !o.isTextblock && LPe(o, s) && r.node(i).canReplace(l, l + 1))
      return t;
    if (i == 0)
      break;
    t = n < 0 ? r.before(i) : r.after(i);
  }
}
function X1t(e, t, n) {
  let r = null, { linebreakReplacement: i } = e.doc.type.schema, o = e.doc.resolve(t - n), s = o.node().type;
  if (i && s.inlineContent) {
    let u = s.whitespace == "pre", f = !!s.contentMatch.matchType(i);
    u && !f ? r = !1 : !u && f && (r = !0);
  }
  let l = e.steps.length;
  if (r === !1) {
    let u = e.doc.resolve(t + n);
    _Pe(e, u.node(), u.before(), l);
  }
  s.inlineContent && eK(e, t + n - 1, s, o.node().contentMatchAt(o.index()), r == null);
  let c = e.mapping.slice(l), a = c.map(t - n);
  if (e.step(new Qo(a, c.map(t + n, -1), zt.empty, !0)), r === !0) {
    let u = e.doc.resolve(a);
    DPe(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function W1t(e, t, n) {
  let r = e.resolve(t);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return t;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.index(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.before(i + 1);
      if (o > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.indexAfter(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.after(i + 1);
      if (o < r.node(i).childCount)
        return null;
    }
  return null;
}
function zPe(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size)
    return t;
  let i = n.content;
  for (let o = 0; o < n.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (n.openStart == 0 && n.size ? 2 : 1); o++)
    for (let s = r.depth; s >= 0; s--) {
      let l = s == r.depth ? 0 : r.pos <= (r.start(s + 1) + r.end(s + 1)) / 2 ? -1 : 1, c = r.index(s) + (l > 0 ? 1 : 0), a = r.node(s), u = !1;
      if (o == 1)
        u = a.canReplace(c, c, i);
      else {
        let f = a.contentMatchAt(c).findWrapping(i.firstChild.type);
        u = f && a.canReplaceWith(c, c, f[0]);
      }
      if (u)
        return l == 0 ? r.pos : l < 0 ? r.before(s + 1) : r.after(s + 1);
    }
  return null;
}
function Sj(e, t, n = t, r = zt.empty) {
  if (t == n && !r.size)
    return null;
  let i = e.resolve(t), o = e.resolve(n);
  return jPe(i, o, r) ? new Qo(t, n, r) : new Z1t(i, o, r).fit();
}
function jPe(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class Z1t {
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = at.empty;
    for (let i = 0; i <= t.depth; i++) {
      let o = t.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(t.indexAfter(i))
      });
    }
    for (let i = t.depth; i > 0; i--)
      this.placed = at.from(t.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let a = this.findFittable();
      a ? this.placeNodes(a) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(t < 0 ? this.$to : r.doc.resolve(t));
    if (!i)
      return null;
    let o = this.placed, s = r.depth, l = i.depth;
    for (; s && l && o.childCount == 1; )
      o = o.firstChild.content, s--, l--;
    let c = new zt(o, s, l);
    return t > -1 ? new ts(r.pos, t, this.$to.pos, this.$to.end(), c, n) : c.size || r.pos != this.$to.pos ? new Qo(r.pos, i.pos, c) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < t; r++) {
      let o = n.firstChild;
      if (n.childCount > 1 && (i = 0), o.type.spec.isolating && i <= r) {
        t = r;
        break;
      }
      n = o.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? t : this.unplaced.openStart; r >= 0; r--) {
        let i, o = null;
        r ? (o = W6(this.unplaced.content, r - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let s = i.firstChild;
        for (let l = this.depth; l >= 0; l--) {
          let { type: c, match: a } = this.frontier[l], u, f = null;
          if (n == 1 && (s ? a.matchType(s.type) || (f = a.fillBefore(at.from(s), !1)) : o && c.compatibleContent(o.type)))
            return { sliceDepth: r, frontierDepth: l, parent: o, inject: f };
          if (n == 2 && s && (u = a.findWrapping(s.type)))
            return { sliceDepth: r, frontierDepth: l, parent: o, wrap: u };
          if (o && a.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = W6(t, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new zt(t, n + 1, Math.max(r, i.size + n >= t.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = W6(t, n);
    if (i.childCount <= 1 && n > 0) {
      let o = t.size - n <= n + i.size;
      this.unplaced = new zt(a1(t, n - 1, 1), n - 1, o ? n - 1 : r);
    } else
      this.unplaced = new zt(a1(t, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: r, inject: i, wrap: o }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let s = this.unplaced, l = r ? r.content : s.content, c = s.openStart - t, a = 0, u = [], { match: f, type: d } = this.frontier[n];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      f = f.matchFragment(i);
    }
    let p = l.size + t - (s.content.size - s.openEnd);
    for (; a < l.childCount; ) {
      let m = l.child(a), v = f.matchType(m.type);
      if (!v)
        break;
      a++, (a > 1 || c == 0 || m.content.size) && (f = v, u.push(FPe(m.mark(d.allowedMarks(m.marks)), a == 1 ? c : 0, a == l.childCount ? p : -1)));
    }
    let h = a == l.childCount;
    h || (p = -1), this.placed = l1(this.placed, n, at.from(u)), this.frontier[n].match = f, h && p < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, v = l; m < p; m++) {
      let b = v.lastChild;
      this.frontier.push({ type: b.type, match: b.contentMatchAt(b.childCount) }), v = b.content;
    }
    this.unplaced = h ? t == 0 ? zt.empty : new zt(a1(s.content, t - 1, 1), t - 1, p < 0 ? s.openEnd : t - 1) : new zt(a1(s.content, t, a), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !Z6(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(t) {
    e: for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], o = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), s = Z6(t, n, i, r, o);
      if (s) {
        for (let l = n - 1; l >= 0; l--) {
          let { match: c, type: a } = this.frontier[l], u = Z6(t, l, a, c, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: s, move: o ? t.doc.resolve(t.after(n + 1)) : t };
      }
    }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = l1(this.placed, n.depth, n.fit)), t = n.move;
    for (let r = n.depth + 1; r <= t.depth; r++) {
      let i = t.node(r), o = i.type.contentMatch.fillBefore(i.content, !0, t.index(r));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return t;
  }
  openFrontierNode(t, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(t), this.placed = l1(this.placed, this.depth, at.from(t.create(n, r))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(at.empty, !0);
    n.childCount && (this.placed = l1(this.placed, this.frontier.length, n));
  }
}
function a1(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(a1(e.firstChild.content, t - 1, n)));
}
function l1(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(l1(e.lastChild.content, t - 1, n)));
}
function W6(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function FPe(e, t, n) {
  if (t <= 0)
    return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, FPe(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(at.empty, !0)))), e.copy(r);
}
function Z6(e, t, n, r, i) {
  let o = e.node(t), s = i ? e.indexAfter(t) : e.index(t);
  if (s == o.childCount && !n.compatibleContent(o.type))
    return null;
  let l = r.fillBefore(o.content, !0, s);
  return l && !H1t(n, o.content, s) ? l : null;
}
function H1t(e, t, n) {
  for (let r = n; r < t.childCount; r++)
    if (!e.allowsMarks(t.child(r).marks))
      return !0;
  return !1;
}
function Q1t(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function $1t(e, t, n, r) {
  if (!r.size)
    return e.deleteRange(t, n);
  let i = e.doc.resolve(t), o = e.doc.resolve(n);
  if (jPe(i, o, r))
    return e.step(new Qo(t, n, r));
  let s = VPe(i, o);
  s[s.length - 1] == 0 && s.pop();
  let l = -(i.depth + 1);
  s.unshift(l);
  for (let d = i.depth, p = i.pos - 1; d > 0; d--, p--) {
    let h = i.node(d).type.spec;
    if (h.defining || h.definingAsContext || h.isolating)
      break;
    s.indexOf(d) > -1 ? l = d : i.before(d) == p && s.splice(1, 0, -d);
  }
  let c = s.indexOf(l), a = [], u = r.openStart;
  for (let d = r.content, p = 0; ; p++) {
    let h = d.firstChild;
    if (a.push(h), p == r.openStart)
      break;
    d = h.content;
  }
  for (let d = u - 1; d >= 0; d--) {
    let p = a[d], h = Q1t(p.type);
    if (h && !p.sameMarkup(i.node(Math.abs(l) - 1)))
      u = d;
    else if (h || !p.type.isTextblock)
      break;
  }
  for (let d = r.openStart; d >= 0; d--) {
    let p = (d + u + 1) % (r.openStart + 1), h = a[p];
    if (h)
      for (let m = 0; m < s.length; m++) {
        let v = s[(m + c) % s.length], b = !0;
        v < 0 && (b = !1, v = -v);
        let A = i.node(v - 1), w = i.index(v - 1);
        if (A.canReplaceWith(w, w, h.type, h.marks))
          return e.replace(i.before(v), b ? o.after(v) : n, new zt(UPe(r.content, 0, r.openStart, p), p, r.openEnd));
      }
  }
  let f = e.steps.length;
  for (let d = s.length - 1; d >= 0 && (e.replace(t, n, r), !(e.steps.length > f)); d--) {
    let p = s[d];
    p < 0 || (t = i.before(p), n = o.after(p));
  }
}
function UPe(e, t, n, r, i) {
  if (t < n) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(UPe(o.content, t + 1, n, r, o)));
  }
  if (t > r) {
    let o = i.contentMatchAt(0), s = o.fillBefore(e).append(e);
    e = s.append(o.matchFragment(s).fillBefore(at.empty, !0));
  }
  return e;
}
function K1t(e, t, n, r) {
  if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let i = W1t(e.doc, t, r.type);
    i != null && (t = n = i);
  }
  e.replaceRange(t, n, new zt(at.from(r), 0, 0));
}
function G1t(e, t, n) {
  let r = e.doc.resolve(t), i = e.doc.resolve(n), o = VPe(r, i);
  for (let s = 0; s < o.length; s++) {
    let l = o[s], c = s == o.length - 1;
    if (c && l == 0 || r.node(l).type.contentMatch.validEnd)
      return e.delete(r.start(l), i.end(l));
    if (l > 0 && (c || r.node(l - 1).canReplace(r.index(l - 1), i.indexAfter(l - 1))))
      return e.delete(r.before(l), i.after(l));
  }
  for (let s = 1; s <= r.depth && s <= i.depth; s++)
    if (t - r.start(s) == r.depth - s && n > r.end(s) && i.end(s) - n != i.depth - s && r.start(s - 1) == i.start(s - 1) && r.node(s - 1).canReplace(r.index(s - 1), i.index(s - 1)))
      return e.delete(r.before(s), n);
  e.delete(t, n);
}
function VPe(e, t) {
  let n = [], r = Math.min(e.depth, t.depth);
  for (let i = r; i >= 0; i--) {
    let o = e.start(i);
    if (o < e.pos - (e.depth - i) || t.end(i) > t.pos + (t.depth - i) || e.node(i).type.spec.isolating || t.node(i).type.spec.isolating)
      break;
    (o == t.start(i) || i == e.depth && i == t.depth && e.parent.inlineContent && t.parent.inlineContent && i && t.start(i - 1) == o - 1) && n.push(i);
  }
  return n;
}
class GO extends oa {
  /**
  Construct an attribute step.
  */
  constructor(t, n, r) {
    super(), this.pos = t, this.attr = n, this.value = r;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ho.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in n.attrs)
      r[o] = n.attrs[o];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return ho.fromReplace(t, this.pos, this.pos + 1, new zt(at.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return Gl.empty;
  }
  invert(t) {
    return new GO(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new GO(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new GO(n.pos, n.attr, n.value);
  }
}
oa.jsonID("attr", GO);
class ek extends oa {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      n[i] = t.attrs[i];
    n[this.attr] = this.value;
    let r = t.type.create(n, t.content, t.marks);
    return ho.ok(r);
  }
  getMap() {
    return Gl.empty;
  }
  invert(t) {
    return new ek(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new ek(n.attr, n.value);
  }
}
oa.jsonID("docAttr", ek);
let pw = class extends Error {
};
pw = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
pw.prototype = Object.create(Error.prototype);
pw.prototype.constructor = pw;
pw.prototype.name = "TransformError";
class nK {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new JT();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new pw(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, r = zt.empty) {
    let i = Sj(this.doc, t, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, r) {
    return this.replace(t, n, new zt(at.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, zt.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, r) {
    return $1t(this, t, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, r) {
    return K1t(this, t, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return G1t(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return _1t(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return X1t(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return j1t(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, r, i = null) {
    return F1t(this, t, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, r = null, i) {
    return V1t(this, t, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, r) {
    return this.step(new GO(t, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new ek(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new Dm(t, n)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    let r = this.doc.nodeAt(t);
    if (!r)
      throw new RangeError("No node at position " + t);
    if (n instanceof Zr)
      n.isInSet(r.marks) && this.step(new Fv(t, n));
    else {
      let i = r.marks, o, s = [];
      for (; o = n.isInSet(i); )
        s.push(new Fv(t, o)), i = o.removeFromSet(i);
      for (let l = s.length - 1; l >= 0; l--)
        this.step(s[l]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(t, n = 1, r) {
    return q1t(this, t, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, r) {
    return R1t(this, t, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, r) {
    return M1t(this, t, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, r) {
    return eK(this, t, n, r), this;
  }
}
const H6 = /* @__PURE__ */ Object.create(null);
class En {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, r) {
    this.$anchor = t, this.$head = n, this.ranges = r || [new qPe(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = zt.empty) {
    let r = n.content.lastChild, i = null;
    for (let l = 0; l < n.openEnd; l++)
      i = r, r = r.lastChild;
    let o = t.steps.length, s = this.ranges;
    for (let l = 0; l < s.length; l++) {
      let { $from: c, $to: a } = s[l], u = t.mapping.slice(o);
      t.replaceRange(u.map(c.pos), u.map(a.pos), l ? zt.empty : n), l == 0 && Aae(t, o, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let r = t.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: s, $to: l } = i[o], c = t.mapping.slice(r), a = c.map(s.pos), u = c.map(l.pos);
      o ? t.deleteRange(a, u) : (t.replaceRangeWith(a, u, n), Aae(t, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, r = !1) {
    let i = t.parent.inlineContent ? new pn(t) : rO(t.node(0), t.parent, t.pos, t.index(), n, r);
    if (i)
      return i;
    for (let o = t.depth - 1; o >= 0; o--) {
      let s = n < 0 ? rO(t.node(0), t.node(o), t.before(o + 1), t.index(o), n, r) : rO(t.node(0), t.node(o), t.after(o + 1), t.index(o) + 1, n, r);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new oc(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return rO(t, t, 0, 0, 1) || new oc(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return rO(t, t, t.content.size, t.childCount, -1) || new oc(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = H6[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in H6)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return H6[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return pn.between(this.$anchor, this.$head).getBookmark();
  }
}
En.prototype.visible = !0;
let qPe = class {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}, bae = !1;
function Oae(e) {
  !bae && !e.parent.inlineContent && (bae = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class pn extends En {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    Oae(t), Oae(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return En.near(r);
    let i = t.resolve(n.map(this.anchor));
    return new pn(i.parent.inlineContent ? i : r, r);
  }
  replace(t, n = zt.empty) {
    if (super.replace(t, n), n == zt.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && t.ensureMarks(r);
    }
  }
  eq(t) {
    return t instanceof pn && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new Ej(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new pn(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, r = n) {
    let i = t.resolve(n);
    return new this(i, r == n ? i : t.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, r) {
    let i = t.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let o = En.findFrom(n, r, !0) || En.findFrom(n, -r, !0);
      if (o)
        n = o.$head;
      else
        return En.near(n, r);
    }
    return t.parent.inlineContent || (i == 0 ? t = n : (t = (En.findFrom(t, -r, !0) || En.findFrom(t, r, !0)).$anchor, t.pos < n.pos != i < 0 && (t = n))), new pn(t, n);
  }
}
En.jsonID("text", pn);
class Ej {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new Ej(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return pn.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class dn extends En {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, r = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, r), this.node = n;
  }
  map(t, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), o = t.resolve(i);
    return r ? En.near(o) : new dn(o);
  }
  content() {
    return new zt(at.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof dn && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new rK(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new dn(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new dn(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
dn.prototype.visible = !1;
En.jsonID("node", dn);
class rK {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor);
    return n ? new Ej(r, r) : new rK(r);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), r = n.nodeAfter;
    return r && dn.isSelectable(r) ? new dn(n) : En.near(n);
  }
}
class oc extends En {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = zt.empty) {
    if (n == zt.empty) {
      t.delete(0, t.doc.content.size);
      let r = En.atStart(t.doc);
      r.eq(t.selection) || t.setSelection(r);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new oc(t);
  }
  map(t) {
    return new oc(t);
  }
  eq(t) {
    return t instanceof oc;
  }
  getBookmark() {
    return Y1t;
  }
}
En.jsonID("all", oc);
const Y1t = {
  map() {
    return this;
  },
  resolve(e) {
    return new oc(e);
  }
};
function rO(e, t, n, r, i, o = !1) {
  if (t.inlineContent)
    return pn.create(e, n);
  for (let s = r - (i > 0 ? 0 : 1); i > 0 ? s < t.childCount : s >= 0; s += i) {
    let l = t.child(s);
    if (l.isAtom) {
      if (!o && dn.isSelectable(l))
        return dn.create(e, n - (i < 0 ? l.nodeSize : 0));
    } else {
      let c = rO(e, l, n + i, i < 0 ? l.childCount : 0, i, o);
      if (c)
        return c;
    }
    n += l.nodeSize * i;
  }
  return null;
}
function Aae(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t)
    return;
  let i = e.steps[r];
  if (!(i instanceof Qo || i instanceof ts))
    return;
  let o = e.mapping.maps[r], s;
  o.forEach((l, c, a, u) => {
    s == null && (s = u);
  }), e.setSelection(En.near(e.doc.resolve(s), n));
}
const wae = 1, xae = 2, Sae = 4;
let J1t = class extends nK {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | wae) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & wae) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= xae, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return Zr.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & xae) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let r = this.selection;
    return n && (t = t.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Zr.none))), r.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(i.text(t), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), !t)
        return this.deleteRange(n, r);
      let o = this.storedMarks;
      if (!o) {
        let s = this.doc.resolve(n);
        o = r == n ? s.marks() : s.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(t, o)), !this.selection.empty && this.selection.to == n + t.length && this.setSelection(En.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Sae, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Sae) > 0;
  }
};
function Eae(e, t) {
  return !t || !e ? e : e.bind(t);
}
class c1 {
  constructor(t, n, r) {
    this.name = t, this.init = Eae(n.init, r), this.apply = Eae(n.apply, r);
  }
}
const eEt = [
  new c1("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new c1("selection", {
    init(e, t) {
      return e.selection || En.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new c1("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, r) {
      return r.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new c1("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
let Q6 = class {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = eEt.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new c1(r.key, r.spec.state, r));
    });
  }
}, tEt = class u1 {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], r = this.applyInner(t), i = null;
    for (; ; ) {
      let o = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let l = this.config.plugins[s];
        if (l.spec.appendTransaction) {
          let c = i ? i[s].n : 0, a = i ? i[s].state : this, u = c < n.length && l.spec.appendTransaction.call(l, c ? n.slice(c) : n, a, r);
          if (u && r.filterTransaction(u, s)) {
            if (u.setMeta("appendedTransaction", t), !i) {
              i = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                i.push(f < s ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), o = !0;
          }
          i && (i[s] = { state: r, n: n.length });
        }
      }
      if (!o)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new u1(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let o = r[i];
      n[o.name] = o.apply(t, this[o.name], this, n);
    }
    return n;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new J1t(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new Q6(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new u1(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(t, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new Q6(this.schema, t.plugins), r = n.fields, i = new u1(n);
    for (let o = 0; o < r.length; o++) {
      let s = r[o].name;
      i[s] = this.hasOwnProperty(s) ? this[s] : r[o].init(t, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), t && typeof t == "object")
      for (let r in t) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = t[r], o = i.spec.state;
        o && o.toJSON && (n[r] = o.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new Q6(t.schema, t.plugins), o = new u1(i);
    return i.fields.forEach((s) => {
      if (s.name == "doc")
        o.doc = Wm.fromJSON(t.schema, n.doc);
      else if (s.name == "selection")
        o.selection = En.fromJSON(o.doc, n.selection);
      else if (s.name == "storedMarks")
        n.storedMarks && (o.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (r)
          for (let l in r) {
            let c = r[l], a = c.spec.state;
            if (c.key == s.name && a && a.fromJSON && Object.prototype.hasOwnProperty.call(n, l)) {
              o[s.name] = a.fromJSON.call(c, t, n[l], o);
              return;
            }
          }
        o[s.name] = s.init(t, o);
      }
    }), o;
  }
};
function BPe(e, t, n) {
  for (let r in e) {
    let i = e[r];
    i instanceof Function ? i = i.bind(t) : r == "handleDOMEvents" && (i = BPe(i, t, {})), n[r] = i;
  }
  return n;
}
class $r {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && BPe(t.props, this, this.props), this.key = t.key ? t.key.key : XPe("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const $6 = /* @__PURE__ */ Object.create(null);
function XPe(e) {
  return e in $6 ? e + "$" + ++$6[e] : ($6[e] = 0, e + "$");
}
class gi {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = XPe(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const iK = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function WPe(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const ZPe = (e, t, n) => {
  let r = WPe(e, n);
  if (!r)
    return !1;
  let i = oK(r);
  if (!i) {
    let s = r.blockRange(), l = s && Sx(s);
    return l == null ? !1 : (t && t(e.tr.lift(s, l).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (tIe(e, i, t, -1))
    return !0;
  if (r.parent.content.size == 0 && (hw(o, "end") || dn.isSelectable(o)))
    for (let s = r.depth; ; s--) {
      let l = Sj(e.doc, r.before(s), r.after(s), zt.empty);
      if (l && l.slice.size < l.to - l.from) {
        if (t) {
          let c = e.tr.step(l);
          c.setSelection(hw(o, "end") ? En.findFrom(c.doc.resolve(c.mapping.map(i.pos, -1)), -1) : dn.create(c.doc, i.pos - o.nodeSize)), t(c.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || r.node(s - 1).childCount > 1)
        break;
    }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, nEt = (e, t, n) => {
  let r = WPe(e, n);
  if (!r)
    return !1;
  let i = oK(r);
  return i ? HPe(e, i, t) : !1;
}, rEt = (e, t, n) => {
  let r = $Pe(e, n);
  if (!r)
    return !1;
  let i = sK(r);
  return i ? HPe(e, i, t) : !1;
};
function HPe(e, t, n) {
  let r = t.nodeBefore, i = r, o = t.pos - 1;
  for (; !i.isTextblock; o--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let s = t.nodeAfter, l = s, c = t.pos + 1;
  for (; !l.isTextblock; c++) {
    if (l.type.spec.isolating)
      return !1;
    let u = l.firstChild;
    if (!u)
      return !1;
    l = u;
  }
  let a = Sj(e.doc, o, c, zt.empty);
  if (!a || a.from != o || a instanceof Qo && a.slice.size >= c - o)
    return !1;
  if (n) {
    let u = e.tr.step(a);
    u.setSelection(pn.create(u.doc, o)), n(u.scrollIntoView());
  }
  return !0;
}
function hw(e, t, n = !1) {
  for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const QPe = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0)
      return !1;
    o = oK(r);
  }
  let s = o && o.nodeBefore;
  return !s || !dn.isSelectable(s) ? !1 : (t && t(e.tr.setSelection(dn.create(e.doc, o.pos - s.nodeSize)).scrollIntoView()), !0);
};
function oK(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function $Pe(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const KPe = (e, t, n) => {
  let r = $Pe(e, n);
  if (!r)
    return !1;
  let i = sK(r);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (tIe(e, i, t, 1))
    return !0;
  if (r.parent.content.size == 0 && (hw(o, "start") || dn.isSelectable(o))) {
    let s = Sj(e.doc, r.before(), r.after(), zt.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (t) {
        let l = e.tr.step(s);
        l.setSelection(hw(o, "start") ? En.findFrom(l.doc.resolve(l.mapping.map(i.pos)), 1) : dn.create(l.doc, l.mapping.map(i.pos))), t(l.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, GPe = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size)
      return !1;
    o = sK(r);
  }
  let s = o && o.nodeAfter;
  return !s || !dn.isSelectable(s) ? !1 : (t && t(e.tr.setSelection(dn.create(e.doc, o.pos)).scrollIntoView()), !0);
};
function sK(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const iEt = (e, t) => {
  let n = e.selection, r = n instanceof dn, i;
  if (r) {
    if (n.node.isTextblock || !Rg(e.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = xj(e.doc, n.from, -1), i == null)
    return !1;
  if (t) {
    let o = e.tr.join(i);
    r && o.setSelection(dn.create(o.doc, i - e.doc.resolve(i).nodeBefore.nodeSize)), t(o.scrollIntoView());
  }
  return !0;
}, oEt = (e, t) => {
  let n = e.selection, r;
  if (n instanceof dn) {
    if (n.node.isTextblock || !Rg(e.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = xj(e.doc, n.to, 1), r == null)
    return !1;
  return t && t(e.tr.join(r).scrollIntoView()), !0;
}, sEt = (e, t) => {
  let { $from: n, $to: r } = e.selection, i = n.blockRange(r), o = i && Sx(i);
  return o == null ? !1 : (t && t(e.tr.lift(i, o).scrollIntoView()), !0);
}, YPe = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function aK(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const aEt = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), o = n.indexAfter(-1), s = aK(i.contentMatchAt(o));
  if (!s || !i.canReplaceWith(o, o, s))
    return !1;
  if (t) {
    let l = n.after(), c = e.tr.replaceWith(l, l, s.createAndFill());
    c.setSelection(En.near(c.doc.resolve(l), 1)), t(c.scrollIntoView());
  }
  return !0;
}, JPe = (e, t) => {
  let n = e.selection, { $from: r, $to: i } = n;
  if (n instanceof oc || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = aK(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (t) {
    let s = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, l = e.tr.insert(s, o.createAndFill());
    l.setSelection(pn.create(l.doc, s + 1)), t(l.scrollIntoView());
  }
  return !0;
}, eIe = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let o = n.before();
    if (th(e.doc, o))
      return t && t(e.tr.split(o).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && Sx(r);
  return i == null ? !1 : (t && t(e.tr.lift(r, i).scrollIntoView()), !0);
};
function lEt(e) {
  return (t, n) => {
    let { $from: r, $to: i } = t.selection;
    if (t.selection instanceof dn && t.selection.node.isBlock)
      return !r.parentOffset || !th(t.doc, r.pos) ? !1 : (n && n(t.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let o = [], s, l, c = !1, a = !1;
    for (let p = r.depth; ; p--)
      if (r.node(p).isBlock) {
        c = r.end(p) == r.pos + (r.depth - p), a = r.start(p) == r.pos - (r.depth - p), l = aK(r.node(p - 1).contentMatchAt(r.indexAfter(p - 1))), o.unshift(c && l ? { type: l } : null), s = p;
        break;
      } else {
        if (p == 1)
          return !1;
        o.unshift(null);
      }
    let u = t.tr;
    (t.selection instanceof pn || t.selection instanceof oc) && u.deleteSelection();
    let f = u.mapping.map(r.pos), d = th(u.doc, f, o.length, o);
    if (d || (o[0] = l ? { type: l } : null, d = th(u.doc, f, o.length, o)), !d)
      return !1;
    if (u.split(f, o.length, o), !c && a && r.node(s).type != l) {
      let p = u.mapping.map(r.before(s)), h = u.doc.resolve(p);
      l && r.node(s - 1).canReplaceWith(h.index(), h.index() + 1, l) && u.setNodeMarkup(u.mapping.map(r.before(s)), l);
    }
    return n && n(u.scrollIntoView()), !0;
  };
}
const cEt = lEt(), uEt = (e, t) => {
  let { $from: n, to: r } = e.selection, i, o = n.sharedDepth(r);
  return o == 0 ? !1 : (i = n.before(o), t && t(e.tr.setSelection(dn.create(e.doc, i))), !0);
};
function dEt(e, t, n) {
  let r = t.nodeBefore, i = t.nodeAfter, o = t.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && t.parent.canReplace(o - 1, o) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(o, o + 1) || !(i.isTextblock || Rg(e.doc, t.pos)) ? !1 : (n && n(e.tr.join(t.pos).scrollIntoView()), !0);
}
function tIe(e, t, n, r) {
  let i = t.nodeBefore, o = t.nodeAfter, s, l, c = i.type.spec.isolating || o.type.spec.isolating;
  if (!c && dEt(e, t, n))
    return !0;
  let a = !c && t.parent.canReplace(t.index(), t.index() + 1);
  if (a && (s = (l = i.contentMatchAt(i.childCount)).findWrapping(o.type)) && l.matchType(s[0] || o.type).validEnd) {
    if (n) {
      let p = t.pos + o.nodeSize, h = at.empty;
      for (let b = s.length - 1; b >= 0; b--)
        h = at.from(s[b].create(null, h));
      h = at.from(i.copy(h));
      let m = e.tr.step(new ts(t.pos - 1, p, t.pos, p, new zt(h, 1, 0), s.length, !0)), v = m.doc.resolve(p + 2 * s.length);
      v.nodeAfter && v.nodeAfter.type == i.type && Rg(m.doc, v.pos) && m.join(v.pos), n(m.scrollIntoView());
    }
    return !0;
  }
  let u = o.type.spec.isolating || r > 0 && c ? null : En.findFrom(t, 1), f = u && u.$from.blockRange(u.$to), d = f && Sx(f);
  if (d != null && d >= t.depth)
    return n && n(e.tr.lift(f, d).scrollIntoView()), !0;
  if (a && hw(o, "start", !0) && hw(i, "end")) {
    let p = i, h = [];
    for (; h.push(p), !p.isTextblock; )
      p = p.lastChild;
    let m = o, v = 1;
    for (; !m.isTextblock; m = m.firstChild)
      v++;
    if (p.canReplace(p.childCount, p.childCount, m.content)) {
      if (n) {
        let b = at.empty;
        for (let w = h.length - 1; w >= 0; w--)
          b = at.from(h[w].copy(b));
        let A = e.tr.step(new ts(t.pos - h.length, t.pos + o.nodeSize, t.pos + v, t.pos + o.nodeSize - v, new zt(b, h.length, 0), 0, !0));
        n(A.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function nIe(e) {
  return function(t, n) {
    let r = t.selection, i = e < 0 ? r.$from : r.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (n && n(t.tr.setSelection(pn.create(t.doc, e < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const fEt = nIe(-1), pEt = nIe(1);
function hEt(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, s = i.blockRange(o), l = s && tK(s, e, t);
    return l ? (r && r(n.tr.wrap(s, l).scrollIntoView()), !0) : !1;
  };
}
function Tae(e, t = null) {
  return function(n, r) {
    let i = !1;
    for (let o = 0; o < n.selection.ranges.length && !i; o++) {
      let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[o];
      n.doc.nodesBetween(s, l, (c, a) => {
        if (i)
          return !1;
        if (!(!c.isTextblock || c.hasMarkup(e, t)))
          if (c.type == e)
            i = !0;
          else {
            let u = n.doc.resolve(a), f = u.index();
            i = u.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let o = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: l }, $to: { pos: c } } = n.selection.ranges[s];
        o.setBlockType(l, c, e, t);
      }
      r(o.scrollIntoView());
    }
    return !0;
  };
}
function lK(...e) {
  return function(t, n, r) {
    for (let i = 0; i < e.length; i++)
      if (e[i](t, n, r))
        return !0;
    return !1;
  };
}
lK(iK, ZPe, QPe);
lK(iK, KPe, GPe);
lK(YPe, JPe, eIe, cEt);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function mEt(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, s = i.blockRange(o);
    if (!s)
      return !1;
    let l = r ? n.tr : null;
    return gEt(l, s, e, t) ? (r && r(l.scrollIntoView()), !0) : !1;
  };
}
function gEt(e, t, n, r = null) {
  let i = !1, o = t, s = t.$from.doc;
  if (t.depth >= 2 && t.$from.node(t.depth - 1).type.compatibleContent(n) && t.startIndex == 0) {
    if (t.$from.index(t.depth - 1) == 0)
      return !1;
    let c = s.resolve(t.start - 2);
    o = new YD(c, c, t.depth), t.endIndex < t.parent.childCount && (t = new YD(t.$from, s.resolve(t.$to.end(t.depth)), t.depth)), i = !0;
  }
  let l = tK(o, n, r, t);
  return l ? (e && yEt(e, t, l, i, n), !0) : !1;
}
function yEt(e, t, n, r, i) {
  let o = at.empty;
  for (let u = n.length - 1; u >= 0; u--)
    o = at.from(n[u].type.create(n[u].attrs, o));
  e.step(new ts(t.start - (r ? 2 : 0), t.end, t.start, t.end, new zt(o, 0, 0), n.length, !0));
  let s = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == i && (s = u + 1);
  let l = n.length - s, c = t.start + n.length - (r ? 2 : 0), a = t.parent;
  for (let u = t.startIndex, f = t.endIndex, d = !0; u < f; u++, d = !1)
    !d && th(e.doc, c, l) && (e.split(c, l), c += 2 * l), c += a.child(u).nodeSize;
  return e;
}
function vEt(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (s) => s.childCount > 0 && s.firstChild.type == e);
    return o ? n ? r.node(o.depth - 1).type == e ? bEt(t, n, e, o) : OEt(t, n, o) : !0 : !1;
  };
}
function bEt(e, t, n, r) {
  let i = e.tr, o = r.end, s = r.$to.end(r.depth);
  o < s && (i.step(new ts(o - 1, s, o, s, new zt(at.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new YD(i.doc.resolve(r.$from.pos), i.doc.resolve(s), r.depth));
  const l = Sx(r);
  if (l == null)
    return !1;
  i.lift(r, l);
  let c = i.doc.resolve(i.mapping.map(o, -1) - 1);
  return Rg(i.doc, c.pos) && c.nodeBefore.type == c.nodeAfter.type && i.join(c.pos), t(i.scrollIntoView()), !0;
}
function OEt(e, t, n) {
  let r = e.tr, i = n.parent;
  for (let p = n.end, h = n.endIndex - 1, m = n.startIndex; h > m; h--)
    p -= i.child(h).nodeSize, r.delete(p - 1, p + 1);
  let o = r.doc.resolve(n.start), s = o.nodeAfter;
  if (r.mapping.map(n.end) != n.start + o.nodeAfter.nodeSize)
    return !1;
  let l = n.startIndex == 0, c = n.endIndex == i.childCount, a = o.node(-1), u = o.index(-1);
  if (!a.canReplace(u + (l ? 0 : 1), u + 1, s.content.append(c ? at.empty : at.from(i))))
    return !1;
  let f = o.pos, d = f + s.nodeSize;
  return r.step(new ts(f - (l ? 1 : 0), d + (c ? 1 : 0), f + 1, d - 1, new zt((l ? at.empty : at.from(i.copy(at.empty))).append(c ? at.empty : at.from(i.copy(at.empty))), l ? 0 : 1, c ? 0 : 1), l ? 0 : 1)), t(r.scrollIntoView()), !0;
}
function AEt(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (a) => a.childCount > 0 && a.firstChild.type == e);
    if (!o)
      return !1;
    let s = o.startIndex;
    if (s == 0)
      return !1;
    let l = o.parent, c = l.child(s - 1);
    if (c.type != e)
      return !1;
    if (n) {
      let a = c.lastChild && c.lastChild.type == l.type, u = at.from(a ? e.create() : null), f = new zt(at.from(e.create(null, at.from(l.type.create(null, u)))), a ? 3 : 1, 0), d = o.start, p = o.end;
      n(t.tr.step(new ts(d - (a ? 3 : 1), p, d, p, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const ys = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, mw = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let zX = null;
const xp = function(e, t, n) {
  let r = zX || (zX = document.createRange());
  return r.setEnd(e, n ?? e.nodeValue.length), r.setStart(e, t || 0), r;
}, wEt = function() {
  zX = null;
}, Uv = function(e, t, n, r) {
  return n && (kae(e, t, n, r, -1) || kae(e, t, n, r, 1));
}, xEt = /^(img|br|input|textarea|hr)$/i;
function kae(e, t, n, r, i) {
  for (var o; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : Fc(e))) {
      let s = e.parentNode;
      if (!s || s.nodeType != 1 || gN(e) || xEt.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = ys(e) + (i < 0 ? 0 : 1), e = s;
    } else if (e.nodeType == 1) {
      let s = e.childNodes[t + (i < 0 ? -1 : 0)];
      if (s.nodeType == 1 && s.contentEditable == "false")
        if (!((o = s.pmViewDesc) === null || o === void 0) && o.ignoreForSelection)
          t += i;
        else
          return !1;
      else
        e = s, t = i < 0 ? Fc(e) : 0;
    } else
      return !1;
  }
}
function Fc(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function SEt(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t - 1], t = Fc(e);
    } else if (e.parentNode && !gN(e))
      t = ys(e), e = e.parentNode;
    else
      return null;
  }
}
function EEt(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && t < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t], t = 0;
    } else if (e.parentNode && !gN(e))
      t = ys(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function TEt(e, t, n) {
  for (let r = t == 0, i = t == Fc(e); r || i; ) {
    if (e == n)
      return !0;
    let o = ys(e);
    if (e = e.parentNode, !e)
      return !1;
    r = r && o == 0, i = i && o == Fc(e);
  }
}
function gN(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const Tj = function(e) {
  return e.focusNode && Uv(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function vy(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function kEt(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function CEt(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let r = e.caretPositionFromPoint(t, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Fc(r.offsetNode), r.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let r = e.caretRangeFromPoint(t, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Fc(r.startContainer), r.startOffset) };
  }
}
const Sf = typeof navigator < "u" ? navigator : null, Cae = typeof document < "u" ? document : null, Mg = Sf && Sf.userAgent || "", jX = /Edge\/(\d+)/.exec(Mg), rIe = /MSIE \d/.exec(Mg), FX = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Mg), vl = !!(rIe || FX || jX), Zm = rIe ? document.documentMode : FX ? +FX[1] : jX ? +jX[1] : 0, Yc = !vl && /gecko\/(\d+)/i.test(Mg);
Yc && +(/Firefox\/(\d+)/.exec(Mg) || [0, 0])[1];
const UX = !vl && /Chrome\/(\d+)/.exec(Mg), Yo = !!UX, iIe = UX ? +UX[1] : 0, Cs = !vl && !!Sf && /Apple Computer/.test(Sf.vendor), gw = Cs && (/Mobile\/\w+/.test(Mg) || !!Sf && Sf.maxTouchPoints > 2), Dc = gw || (Sf ? /Mac/.test(Sf.platform) : !1), oIe = Sf ? /Win/.test(Sf.platform) : !1, Bp = /Android \d/.test(Mg), yN = !!Cae && "webkitFontSmoothing" in Cae.documentElement.style, NEt = yN ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function PEt(e) {
  let t = e.defaultView && e.defaultView.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function Jf(e, t) {
  return typeof e == "number" ? e : e[t];
}
function IEt(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function Nae(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0, i = e.someProp("scrollMargin") || 5, o = e.dom.ownerDocument;
  for (let s = n || e.dom; s; ) {
    if (s.nodeType != 1) {
      s = mw(s);
      continue;
    }
    let l = s, c = l == o.body, a = c ? PEt(o) : IEt(l), u = 0, f = 0;
    if (t.top < a.top + Jf(r, "top") ? f = -(a.top - t.top + Jf(i, "top")) : t.bottom > a.bottom - Jf(r, "bottom") && (f = t.bottom - t.top > a.bottom - a.top ? t.top + Jf(i, "top") - a.top : t.bottom - a.bottom + Jf(i, "bottom")), t.left < a.left + Jf(r, "left") ? u = -(a.left - t.left + Jf(i, "left")) : t.right > a.right - Jf(r, "right") && (u = t.right - a.right + Jf(i, "right")), u || f)
      if (c)
        o.defaultView.scrollBy(u, f);
      else {
        let p = l.scrollLeft, h = l.scrollTop;
        f && (l.scrollTop += f), u && (l.scrollLeft += u);
        let m = l.scrollLeft - p, v = l.scrollTop - h;
        t = { left: t.left - m, top: t.top - v, right: t.right - m, bottom: t.bottom - v };
      }
    let d = c ? "fixed" : getComputedStyle(s).position;
    if (/^(fixed|sticky)$/.test(d))
      break;
    s = d == "absolute" ? s.offsetParent : mw(s);
  }
}
function REt(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, i;
  for (let o = (t.left + t.right) / 2, s = n + 1; s < Math.min(innerHeight, t.bottom); s += 5) {
    let l = e.root.elementFromPoint(o, s);
    if (!l || l == e.dom || !e.dom.contains(l))
      continue;
    let c = l.getBoundingClientRect();
    if (c.top >= n - 20) {
      r = l, i = c.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: sIe(e.dom) };
}
function sIe(e) {
  let t = [], n = e.ownerDocument;
  for (let r = e; r && (t.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), e != n); r = mw(r))
    ;
  return t;
}
function MEt({ refDOM: e, refTop: t, stack: n }) {
  let r = e ? e.getBoundingClientRect().top : 0;
  aIe(n, r == 0 ? 0 : r - t);
}
function aIe(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: r, top: i, left: o } = e[n];
    r.scrollTop != i + t && (r.scrollTop = i + t), r.scrollLeft != o && (r.scrollLeft = o);
  }
}
let Jb = null;
function DEt(e) {
  if (e.setActive)
    return e.setActive();
  if (Jb)
    return e.focus(Jb);
  let t = sIe(e);
  e.focus(Jb == null ? {
    get preventScroll() {
      return Jb = { preventScroll: !0 }, !0;
    }
  } : void 0), Jb || (Jb = !1, aIe(t, 0));
}
function lIe(e, t) {
  let n, r = 2e8, i, o = 0, s = t.top, l = t.top, c, a;
  for (let u = e.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let d;
    if (u.nodeType == 1)
      d = u.getClientRects();
    else if (u.nodeType == 3)
      d = xp(u).getClientRects();
    else
      continue;
    for (let p = 0; p < d.length; p++) {
      let h = d[p];
      if (h.top <= s && h.bottom >= l) {
        s = Math.max(h.bottom, s), l = Math.min(h.top, l);
        let m = h.left > t.left ? h.left - t.left : h.right < t.left ? t.left - h.right : 0;
        if (m < r) {
          n = u, r = m, i = m && n.nodeType == 3 ? {
            left: h.right < t.left ? h.right : h.left,
            top: t.top
          } : t, u.nodeType == 1 && m && (o = f + (t.left >= (h.left + h.right) / 2 ? 1 : 0));
          continue;
        }
      } else h.top > t.top && !c && h.left <= t.left && h.right >= t.left && (c = u, a = { left: Math.max(h.left, Math.min(h.right, t.left)), top: h.top });
      !n && (t.left >= h.right && t.top >= h.top || t.left >= h.left && t.top >= h.bottom) && (o = f + 1);
    }
  }
  return !n && c && (n = c, i = a, r = 0), n && n.nodeType == 3 ? _Et(n, i) : !n || r && n.nodeType == 1 ? { node: e, offset: o } : lIe(n, i);
}
function _Et(e, t) {
  let n = e.nodeValue.length, r = document.createRange(), i;
  for (let o = 0; o < n; o++) {
    r.setEnd(e, o + 1), r.setStart(e, o);
    let s = Zh(r, 1);
    if (s.top != s.bottom && cK(t, s)) {
      i = { node: e, offset: o + (t.left >= (s.left + s.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), i || { node: e, offset: 0 };
}
function cK(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function LEt(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function zEt(e, t, n) {
  let { node: r, offset: i } = lIe(t, n), o = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let s = r.getBoundingClientRect();
    o = s.left != s.right && n.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(r, i, o);
}
function jEt(e, t, n, r) {
  let i = -1;
  for (let o = t, s = !1; o != e.dom; ) {
    let l = e.docView.nearestDesc(o, !0), c;
    if (!l)
      return null;
    if (l.dom.nodeType == 1 && (l.node.isBlock && l.parent || !l.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((c = l.dom.getBoundingClientRect()).width || c.height) && (l.node.isBlock && l.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(l.dom.nodeName) && (!s && c.left > r.left || c.top > r.top ? i = l.posBefore : (!s && c.right < r.left || c.bottom < r.top) && (i = l.posAfter), s = !0), !l.contentDOM && i < 0 && !l.node.isText))
      return (l.node.isBlock ? r.top < (c.top + c.bottom) / 2 : r.left < (c.left + c.right) / 2) ? l.posBefore : l.posAfter;
    o = l.dom.parentNode;
  }
  return i > -1 ? i : e.docView.posFromDOM(t, n, -1);
}
function cIe(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), o = i; ; ) {
      let s = e.childNodes[o];
      if (s.nodeType == 1) {
        let l = s.getClientRects();
        for (let c = 0; c < l.length; c++) {
          let a = l[c];
          if (cK(t, a))
            return cIe(s, t, a);
        }
      }
      if ((o = (o + 1) % r) == i)
        break;
    }
  return e;
}
function FEt(e, t) {
  let n = e.dom.ownerDocument, r, i = 0, o = CEt(n, t.left, t.top);
  o && ({ node: r, offset: i } = o);
  let s = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), l;
  if (!s || !e.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let a = e.dom.getBoundingClientRect();
    if (!cK(t, a) || (s = cIe(e.dom, t, a), !s))
      return null;
  }
  if (Cs)
    for (let a = s; r && a; a = mw(a))
      a.draggable && (r = void 0);
  if (s = LEt(s, t), r) {
    if (Yc && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let u = r.childNodes[i], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= t.left && f.bottom > t.top && i++;
    }
    let a;
    yN && i && r.nodeType == 1 && (a = r.childNodes[i - 1]).nodeType == 1 && a.contentEditable == "false" && a.getBoundingClientRect().top >= t.top && i--, r == e.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? l = e.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (l = jEt(e, r, i, t));
  }
  l == null && (l = zEt(e, s, t));
  let c = e.docView.nearestDesc(s, !0);
  return { pos: l, inside: c ? c.posAtStart - c.border : -1 };
}
function Pae(e) {
  return e.top < e.bottom || e.left < e.right;
}
function Zh(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let r = n[t < 0 ? 0 : n.length - 1];
    if (Pae(r))
      return r;
  }
  return Array.prototype.find.call(n, Pae) || e.getBoundingClientRect();
}
const UEt = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function uIe(e, t, n) {
  let { node: r, offset: i, atom: o } = e.docView.domFromPos(t, n < 0 ? -1 : 1), s = yN || Yc;
  if (r.nodeType == 3)
    if (s && (UEt.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let c = Zh(xp(r, i, i), n);
      if (Yc && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let a = Zh(xp(r, i - 1, i - 1), -1);
        if (a.top == c.top) {
          let u = Zh(xp(r, i, i + 1), -1);
          if (u.top != c.top)
            return cS(u, u.left < a.left);
        }
      }
      return c;
    } else {
      let c = i, a = i, u = n < 0 ? 1 : -1;
      return n < 0 && !i ? (a++, u = -1) : n >= 0 && i == r.nodeValue.length ? (c--, u = 1) : n < 0 ? c-- : a++, cS(Zh(xp(r, c, a), u), u < 0);
    }
  if (!e.state.doc.resolve(t - (o || 0)).parent.inlineContent) {
    if (o == null && i && (n < 0 || i == Fc(r))) {
      let c = r.childNodes[i - 1];
      if (c.nodeType == 1)
        return K6(c.getBoundingClientRect(), !1);
    }
    if (o == null && i < Fc(r)) {
      let c = r.childNodes[i];
      if (c.nodeType == 1)
        return K6(c.getBoundingClientRect(), !0);
    }
    return K6(r.getBoundingClientRect(), n >= 0);
  }
  if (o == null && i && (n < 0 || i == Fc(r))) {
    let c = r.childNodes[i - 1], a = c.nodeType == 3 ? xp(c, Fc(c) - (s ? 0 : 1)) : c.nodeType == 1 && (c.nodeName != "BR" || !c.nextSibling) ? c : null;
    if (a)
      return cS(Zh(a, 1), !1);
  }
  if (o == null && i < Fc(r)) {
    let c = r.childNodes[i];
    for (; c.pmViewDesc && c.pmViewDesc.ignoreForCoords; )
      c = c.nextSibling;
    let a = c ? c.nodeType == 3 ? xp(c, 0, s ? 0 : 1) : c.nodeType == 1 ? c : null : null;
    if (a)
      return cS(Zh(a, -1), !0);
  }
  return cS(Zh(r.nodeType == 3 ? xp(r) : r, -n), n >= 0);
}
function cS(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function K6(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function dIe(e, t, n) {
  let r = e.state, i = e.root.activeElement;
  r != t && e.updateState(t), i != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), i != e.dom && i && i.focus();
  }
}
function VEt(e, t, n) {
  let r = t.selection, i = n == "up" ? r.$from : r.$to;
  return dIe(e, t, () => {
    let { node: o } = e.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let l = e.docView.nearestDesc(o, !0);
      if (!l)
        break;
      if (l.node.isBlock) {
        o = l.contentDOM || l.dom;
        break;
      }
      o = l.dom.parentNode;
    }
    let s = uIe(e, i.pos, 1);
    for (let l = o.firstChild; l; l = l.nextSibling) {
      let c;
      if (l.nodeType == 1)
        c = l.getClientRects();
      else if (l.nodeType == 3)
        c = xp(l, 0, l.nodeValue.length).getClientRects();
      else
        continue;
      for (let a = 0; a < c.length; a++) {
        let u = c[a];
        if (u.bottom > u.top + 1 && (n == "up" ? s.top - u.top > (u.bottom - s.top) * 2 : u.bottom - s.bottom > (s.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const qEt = /[\u0590-\u08ac]/;
function BEt(e, t, n) {
  let { $head: r } = t.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, o = !i, s = i == r.parent.content.size, l = e.domSelection();
  return l ? !qEt.test(r.parent.textContent) || !l.modify ? n == "left" || n == "backward" ? o : s : dIe(e, t, () => {
    let { focusNode: c, focusOffset: a, anchorNode: u, anchorOffset: f } = e.domSelectionRange(), d = l.caretBidiLevel;
    l.modify("move", n, "character");
    let p = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: h, focusOffset: m } = e.domSelectionRange(), v = h && !p.contains(h.nodeType == 1 ? h : h.parentNode) || c == h && a == m;
    try {
      l.collapse(u, f), c && (c != u || a != f) && l.extend && l.extend(c, a);
    } catch {
    }
    return d != null && (l.caretBidiLevel = d), v;
  }) : r.pos == r.start() || r.pos == r.end();
}
let Iae = null, Rae = null, Mae = !1;
function XEt(e, t, n) {
  return Iae == t && Rae == n ? Mae : (Iae = t, Rae = n, Mae = n == "up" || n == "down" ? VEt(e, t, n) : BEt(e, t, n));
}
const Jc = 0, Dae = 1, Cy = 2, Ef = 3;
class vN {
  constructor(t, n, r, i) {
    this.parent = t, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = Jc, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, r) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == t)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, r) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (r < 0) {
        let o, s;
        if (t == this.contentDOM)
          o = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.previousSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let o, s;
        if (t == this.contentDOM)
          o = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.nextSibling;
        }
        for (; o && !((s = o.pmViewDesc) && s.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let i;
    if (t == this.dom && this.contentDOM)
      i = n > ys(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (i == null && n == t.childNodes.length)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let r = !0, i = t; i; i = i.parentNode) {
      let o = this.getDesc(i), s;
      if (o && (!n || o.node))
        if (r && (s = o.nodeDOM) && !(s.nodeType == 1 ? s.contains(t.nodeType == 1 ? t : t.parentNode) : s == t))
          r = !1;
        else
          return o;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(t, n, r) {
    for (let i = t; i; i = i.parentNode) {
      let o = this.getDesc(i);
      if (o)
        return o.localPosFromDOM(t, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], o = r + i.size;
      if (r == t && o != r) {
        for (; !i.border && i.children.length; )
          for (let s = 0; s < i.children.length; s++) {
            let l = i.children[s];
            if (l.size) {
              i = l;
              break;
            }
          }
        return i;
      }
      if (t < o)
        return i.descAt(t - r - i.border);
      r = o;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let r = 0, i = 0;
    for (let o = 0; r < this.children.length; r++) {
      let s = this.children[r], l = o + s.size;
      if (l > t || s instanceof pIe) {
        i = t - o;
        break;
      }
      o = l;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let o; r && !(o = this.children[r - 1]).size && o instanceof fIe && o.side >= 0; r--)
      ;
    if (n <= 0) {
      let o, s = !0;
      for (; o = r ? this.children[r - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); r--, s = !1)
        ;
      return o && n && s && !o.border && !o.domAtom ? o.domFromPos(o.size, n) : { node: this.contentDOM, offset: o ? ys(o.dom) + 1 : 0 };
    } else {
      let o, s = !0;
      for (; o = r < this.children.length ? this.children[r] : null, !(!o || o.dom.parentNode == this.contentDOM); r++, s = !1)
        ;
      return o && s && !o.border && !o.domAtom ? o.domFromPos(0, n) : { node: this.contentDOM, offset: o ? ys(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, o = -1;
    for (let s = r, l = 0; ; l++) {
      let c = this.children[l], a = s + c.size;
      if (i == -1 && t <= a) {
        let u = s + c.border;
        if (t >= u && n <= a - c.border && c.node && c.contentDOM && this.contentDOM.contains(c.contentDOM))
          return c.parseRange(t, n, u);
        t = s;
        for (let f = l; f > 0; f--) {
          let d = this.children[f - 1];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(1)) {
            i = ys(d.dom) + 1;
            break;
          }
          t -= d.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (a > n || l == this.children.length - 1)) {
        n = a;
        for (let u = l + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            o = ys(f.dom);
            break;
          }
          n += f.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      s = a;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: i, toOffset: o };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: r } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, r, i = !1) {
    let o = Math.min(t, n), s = Math.max(t, n);
    for (let p = 0, h = 0; p < this.children.length; p++) {
      let m = this.children[p], v = h + m.size;
      if (o > h && s < v)
        return m.setSelection(t - h - m.border, n - h - m.border, r, i);
      h = v;
    }
    let l = this.domFromPos(t, t ? -1 : 1), c = n == t ? l : this.domFromPos(n, n ? -1 : 1), a = r.root.getSelection(), u = r.domSelectionRange(), f = !1;
    if ((Yc || Cs) && t == n) {
      let { node: p, offset: h } = l;
      if (p.nodeType == 3) {
        if (f = !!(h && p.nodeValue[h - 1] == `
`), f && h == p.nodeValue.length)
          for (let m = p, v; m; m = m.parentNode) {
            if (v = m.nextSibling) {
              v.nodeName == "BR" && (l = c = { node: v.parentNode, offset: ys(v) + 1 });
              break;
            }
            let b = m.pmViewDesc;
            if (b && b.node && b.node.isBlock)
              break;
          }
      } else {
        let m = p.childNodes[h - 1];
        f = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (Yc && u.focusNode && u.focusNode != c.node && u.focusNode.nodeType == 1) {
      let p = u.focusNode.childNodes[u.focusOffset];
      p && p.contentEditable == "false" && (i = !0);
    }
    if (!(i || f && Cs) && Uv(l.node, l.offset, u.anchorNode, u.anchorOffset) && Uv(c.node, c.offset, u.focusNode, u.focusOffset))
      return;
    let d = !1;
    if ((a.extend || t == n) && !(f && Yc)) {
      a.collapse(l.node, l.offset);
      try {
        t != n && a.extend(c.node, c.offset), d = !0;
      } catch {
      }
    }
    if (!d) {
      if (t > n) {
        let h = l;
        l = c, c = h;
      }
      let p = document.createRange();
      p.setEnd(c.node, c.offset), p.setStart(l.node, l.offset), a.removeAllRanges(), a.addRange(p);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let o = this.children[i], s = r + o.size;
      if (r == s ? t <= s && n >= r : t < s && n > r) {
        let l = r + o.border, c = s - o.border;
        if (t >= l && n <= c) {
          this.dirty = t == r || n == s ? Cy : Dae, t == l && n == c && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = Ef : o.markDirty(t - l, n - l);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Cy : Ef;
      }
      r = s;
    }
    this.dirty = Cy;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let r = t == 1 ? Cy : Dae;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(t) {
    return !1;
  }
}
class fIe extends vN {
  constructor(t, n, r, i) {
    let o, s = n.type.toDOM;
    if (typeof s == "function" && (s = s(r, () => {
      if (!o)
        return i;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !n.type.spec.raw) {
      if (s.nodeType != 1) {
        let l = document.createElement("span");
        l.appendChild(s), s = l;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(t, [], s, null), this.widget = n, this.widget = n, o = this;
  }
  matchesWidget(t) {
    return this.dirty == Jc && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class WEt extends vN {
  constructor(t, n, r, i) {
    super(t, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class Vv extends vN {
  constructor(t, n, r, i, o) {
    super(t, [], r, i), this.mark = n, this.spec = o;
  }
  static create(t, n, r, i) {
    let o = i.nodeViews[n.type.name], s = o && o(n, i, r);
    return (!s || !s.dom) && (s = Pb.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new Vv(t, n, s.dom, s.contentDOM || s.dom, s);
  }
  parseRule() {
    return this.dirty & Ef || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != Ef && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != Jc) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Jc;
    }
  }
  slice(t, n, r) {
    let i = Vv.create(this.parent, this.mark, !0, r), o = this.children, s = this.size;
    n < s && (o = qX(o, n, s, r)), t > 0 && (o = qX(o, 0, t, r));
    for (let l = 0; l < o.length; l++)
      o[l].parent = i;
    return i.children = o, i;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Hm extends vN {
  constructor(t, n, r, i, o, s, l, c, a) {
    super(t, [], o, s), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = l;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, r, i, o, s) {
    let l = o.nodeViews[n.type.name], c, a = l && l(n, o, () => {
      if (!c)
        return s;
      if (c.parent)
        return c.parent.posBeforeChild(c);
    }, r, i), u = a && a.dom, f = a && a.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = Pb.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !f && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let d = u;
    return u = gIe(u, r, n), a ? c = new ZEt(t, n, r, i, u, f || null, d, a, o, s + 1) : n.isText ? new kj(t, n, r, i, u, d, o) : new Hm(t, n, r, i, u, f || null, d, o, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          t.contentElement = r.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => at.empty);
    }
    return t;
  }
  matchesNode(t, n, r) {
    return this.dirty == Jc && t.eq(this.node) && JD(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let r = this.node.inlineContent, i = n, o = t.composing ? this.localCompositionInfo(t, n) : null, s = o && o.pos > -1 ? o : null, l = o && o.pos < 0, c = new QEt(this, s && s.node, t);
    GEt(this.node, this.innerDeco, (a, u, f) => {
      a.spec.marks ? c.syncToMarks(a.spec.marks, r, t, u) : a.type.side >= 0 && !f && c.syncToMarks(u == this.node.childCount ? Zr.none : this.node.child(u).marks, r, t, u), c.placeWidget(a, t, i);
    }, (a, u, f, d) => {
      c.syncToMarks(a.marks, r, t, d);
      let p;
      c.findNodeMatch(a, u, f, d) || l && t.state.selection.from > i && t.state.selection.to < i + a.nodeSize && (p = c.findIndexWithChild(o.node)) > -1 && c.updateNodeAt(a, u, f, p, t) || c.updateNextNode(a, u, f, t, d, i) || c.addNode(a, u, f, t, i), i += a.nodeSize;
    }), c.syncToMarks([], r, t, 0), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || this.dirty == Cy) && (s && this.protectLocalComposition(t, s), hIe(this.contentDOM, this.children, t), gw && YEt(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: r, to: i } = t.state.selection;
    if (!(t.state.selection instanceof pn) || r < n || i > n + this.node.content.size)
      return null;
    let o = t.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = o.nodeValue, l = JEt(this.node.content, s, r - n, i - n);
      return l < 0 ? null : { node: o, pos: l, text: s };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let o = n;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let s = new WEt(this, o, n, i);
    t.input.compositionNodes.push(s), this.children = qX(this.children, r, r + i.length, t, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, r, i) {
    return this.dirty == Ef || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, r, i), !0);
  }
  updateInner(t, n, r, i) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Jc;
  }
  updateOuterDeco(t) {
    if (JD(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = mIe(this.dom, this.nodeDOM, VX(this.outerDeco, this.node, n), VX(t, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function _ae(e, t, n, r, i) {
  gIe(r, t, e);
  let o = new Hm(void 0, e, t, n, r, r, r, i, 0);
  return o.contentDOM && o.updateChildren(i, 0), o;
}
class kj extends Hm {
  constructor(t, n, r, i, o, s, l) {
    super(t, n, r, i, o, null, s, l, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, r, i) {
    return this.dirty == Ef || this.dirty != Jc && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Jc || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = t, this.dirty = Jc, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, r) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, r);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, r) {
    let i = this.node.cut(t, n), o = document.createTextNode(i.text);
    return new kj(this.parent, i, this.outerDeco, this.innerDeco, o, o, r);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = Ef);
  }
  get domAtom() {
    return !1;
  }
  isText(t) {
    return this.node.text == t;
  }
}
class pIe extends vN {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == Jc && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class ZEt extends Hm {
  constructor(t, n, r, i, o, s, l, c, a, u) {
    super(t, n, r, i, o, s, l, a, u), this.spec = c;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, r, i) {
    if (this.dirty == Ef)
      return !1;
    if (this.spec.update && (this.node.type == t.type || this.spec.multiType)) {
      let o = this.spec.update(t, n, r);
      return o && this.updateInner(t, n, r, i), o;
    } else return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(t, n, r.root) : super.setSelection(t, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function hIe(e, t, n) {
  let r = e.firstChild, i = !1;
  for (let o = 0; o < t.length; o++) {
    let s = t[o], l = s.dom;
    if (l.parentNode == e) {
      for (; l != r; )
        r = Lae(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, e.insertBefore(l, r);
    if (s instanceof Vv) {
      let c = r ? r.previousSibling : e.lastChild;
      hIe(s.contentDOM, s.children, n), r = c ? c.nextSibling : e.firstChild;
    }
  }
  for (; r; )
    r = Lae(r), i = !0;
  i && n.trackWrites == e && (n.trackWrites = null);
}
const RE = function(e) {
  e && (this.nodeName = e);
};
RE.prototype = /* @__PURE__ */ Object.create(null);
const Ny = [new RE()];
function VX(e, t, n) {
  if (e.length == 0)
    return Ny;
  let r = n ? Ny[0] : new RE(), i = [r];
  for (let o = 0; o < e.length; o++) {
    let s = e[o].type.attrs;
    if (s) {
      s.nodeName && i.push(r = new RE(s.nodeName));
      for (let l in s) {
        let c = s[l];
        c != null && (n && i.length == 1 && i.push(r = new RE(t.isInline ? "span" : "div")), l == "class" ? r.class = (r.class ? r.class + " " : "") + c : l == "style" ? r.style = (r.style ? r.style + ";" : "") + c : l != "nodeName" && (r[l] = c));
      }
    }
  }
  return i;
}
function mIe(e, t, n, r) {
  if (n == Ny && r == Ny)
    return t;
  let i = t;
  for (let o = 0; o < r.length; o++) {
    let s = r[o], l = n[o];
    if (o) {
      let c;
      l && l.nodeName == s.nodeName && i != e && (c = i.parentNode) && c.nodeName.toLowerCase() == s.nodeName || (c = document.createElement(s.nodeName), c.pmIsDeco = !0, c.appendChild(i), l = Ny[0]), i = c;
    }
    HEt(i, l || Ny[0], s);
  }
  return i;
}
function HEt(e, t, n) {
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && e.classList.remove(r[o]);
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && e.classList.add(i[o]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(t.style); )
        e.style.removeProperty(i[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function gIe(e, t, n) {
  return mIe(e, e, Ny, VX(t, n, e.nodeType != 1));
}
function JD(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function Lae(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class QEt {
  constructor(t, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = $Et(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let r = t; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, r, i) {
    let o = 0, s = this.stack.length >> 1, l = Math.min(s, t.length);
    for (; o < l && (o == s - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(t[o]) && t[o].type.spec.spanning !== !1; )
      o++;
    for (; o < s; )
      this.destroyRest(), this.top.dirty = Jc, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let c = -1, a = this.top.children.length;
      i < this.preMatch.index && (a = Math.min(this.index + 3, a));
      for (let u = this.index; u < a; u++) {
        let f = this.top.children[u];
        if (f.matchesMark(t[s]) && !this.isLocked(f.dom)) {
          c = u;
          break;
        }
      }
      if (c > -1)
        c > this.index && (this.changed = !0, this.destroyBetween(this.index, c)), this.top = this.top.children[this.index];
      else {
        let u = Vv.create(this.top, t[s], n, r);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, r, i) {
    let o = -1, s;
    if (i >= this.preMatch.index && (s = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && s.matchesNode(t, n, r))
      o = this.top.children.indexOf(s, this.index);
    else
      for (let l = this.index, c = Math.min(this.top.children.length, l + 5); l < c; l++) {
        let a = this.top.children[l];
        if (a.matchesNode(t, n, r) && !this.preMatch.matched.has(a)) {
          o = l;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(t, n, r, i, o) {
    let s = this.top.children[i];
    return s.dirty == Ef && s.dom == s.contentDOM && (s.dirty = Cy), s.update(t, n, r, o) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = t.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, r, i, o, s) {
    for (let l = this.index; l < this.top.children.length; l++) {
      let c = this.top.children[l];
      if (c instanceof Hm) {
        let a = this.preMatch.matched.get(c);
        if (a != null && a != o)
          return !1;
        let u = c.dom, f, d = this.isLocked(u) && !(t.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == t.text && c.dirty != Ef && JD(n, c.outerDeco));
        if (!d && c.update(t, n, r, i))
          return this.destroyBetween(this.index, l), c.dom != u && (this.changed = !0), this.index++, !0;
        if (!d && (f = this.recreateWrapper(c, t, n, r, i, s)))
          return this.destroyBetween(this.index, l), this.top.children[this.index] = f, f.contentDOM && (f.dirty = Cy, f.updateChildren(i, s + 1), f.dirty = Jc), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, r, i, o, s) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content) || !JD(r, t.outerDeco) || !i.eq(t.innerDeco))
      return null;
    let l = Hm.create(this.top, n, r, i, o, s);
    if (l.contentDOM) {
      l.children = t.children, t.children = [];
      for (let c of l.children)
        c.parent = l;
    }
    return t.destroy(), l;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, r, i, o) {
    let s = Hm.create(this.top, t, n, r, i, o);
    s.contentDOM && s.updateChildren(i, o + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(t, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(t) && (t == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new fIe(this.top, t, n, r);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof Vv; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof kj) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((Cs || Yo) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let r = document.createElement(t);
      t == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), t == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new pIe(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function $Et(e, t) {
  let n = t, r = n.children.length, i = e.childCount, o = /* @__PURE__ */ new Map(), s = [];
  e: for (; i > 0; ) {
    let l;
    for (; ; )
      if (r) {
        let a = n.children[r - 1];
        if (a instanceof Vv)
          n = a, r = a.children.length;
        else {
          l = a, r--;
          break;
        }
      } else {
        if (n == t)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let c = l.node;
    if (c) {
      if (c != e.child(i - 1))
        break;
      --i, o.set(l, i), s.push(l);
    }
  }
  return { index: i, matched: o, matches: s.reverse() };
}
function KEt(e, t) {
  return e.type.side - t.type.side;
}
function GEt(e, t, n, r) {
  let i = t.locals(e), o = 0;
  if (i.length == 0) {
    for (let a = 0; a < e.childCount; a++) {
      let u = e.child(a);
      r(u, i, t.forChild(o, u), a), o += u.nodeSize;
    }
    return;
  }
  let s = 0, l = [], c = null;
  for (let a = 0; ; ) {
    let u, f;
    for (; s < i.length && i[s].to == o; ) {
      let v = i[s++];
      v.widget && (u ? (f || (f = [u])).push(v) : u = v);
    }
    if (u)
      if (f) {
        f.sort(KEt);
        for (let v = 0; v < f.length; v++)
          n(f[v], a, !!c);
      } else
        n(u, a, !!c);
    let d, p;
    if (c)
      p = -1, d = c, c = null;
    else if (a < e.childCount)
      p = a, d = e.child(a++);
    else
      break;
    for (let v = 0; v < l.length; v++)
      l[v].to <= o && l.splice(v--, 1);
    for (; s < i.length && i[s].from <= o && i[s].to > o; )
      l.push(i[s++]);
    let h = o + d.nodeSize;
    if (d.isText) {
      let v = h;
      s < i.length && i[s].from < v && (v = i[s].from);
      for (let b = 0; b < l.length; b++)
        l[b].to < v && (v = l[b].to);
      v < h && (c = d.cut(v - o), d = d.cut(0, v - o), h = v, p = -1);
    } else
      for (; s < i.length && i[s].to < h; )
        s++;
    let m = d.isInline && !d.isLeaf ? l.filter((v) => !v.inline) : l.slice();
    r(d, m, t.forChild(o, d), p), o = h;
  }
}
function YEt(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function JEt(e, t, n, r) {
  for (let i = 0, o = 0; i < e.childCount && o <= r; ) {
    let s = e.child(i++), l = o;
    if (o += s.nodeSize, !s.isText)
      continue;
    let c = s.text;
    for (; i < e.childCount; ) {
      let a = e.child(i++);
      if (o += a.nodeSize, !a.isText)
        break;
      c += a.text;
    }
    if (o >= n) {
      if (o >= r && c.slice(r - t.length - l, r - l) == t)
        return r - t.length;
      let a = l < r ? c.lastIndexOf(t, r - l - 1) : -1;
      if (a >= 0 && a + t.length + l >= n)
        return l + a;
      if (n == r && c.length >= r + t.length - l && c.slice(r - l, r - l + t.length) == t)
        return r;
    }
  }
  return -1;
}
function qX(e, t, n, r, i) {
  let o = [];
  for (let s = 0, l = 0; s < e.length; s++) {
    let c = e[s], a = l, u = l += c.size;
    a >= n || u <= t ? o.push(c) : (a < t && o.push(c.slice(0, t - a, r)), i && (o.push(i), i = void 0), u > n && o.push(c.slice(n - a, c.size, r)));
  }
  return o;
}
function uK(e, t = null) {
  let n = e.domSelectionRange(), r = e.state.doc;
  if (!n.focusNode)
    return null;
  let i = e.docView.nearestDesc(n.focusNode), o = i && i.size == 0, s = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (s < 0)
    return null;
  let l = r.resolve(s), c, a;
  if (Tj(n)) {
    for (c = s; i && !i.node; )
      i = i.parent;
    let f = i.node;
    if (i && f.isAtom && dn.isSelectable(f) && i.parent && !(f.isInline && TEt(n.focusNode, n.focusOffset, i.dom))) {
      let d = i.posBefore;
      a = new dn(s == d ? l : r.resolve(d));
    }
  } else {
    if (n instanceof e.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let f = s, d = s;
      for (let p = 0; p < n.rangeCount; p++) {
        let h = n.getRangeAt(p);
        f = Math.min(f, e.docView.posFromDOM(h.startContainer, h.startOffset, 1)), d = Math.max(d, e.docView.posFromDOM(h.endContainer, h.endOffset, -1));
      }
      if (f < 0)
        return null;
      [c, s] = d == e.state.selection.anchor ? [d, f] : [f, d], l = r.resolve(s);
    } else
      c = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (c < 0)
      return null;
  }
  let u = r.resolve(c);
  if (!a) {
    let f = t == "pointer" || e.state.selection.head < l.pos && !o ? 1 : -1;
    a = dK(e, u, l, f);
  }
  return a;
}
function yIe(e) {
  return e.editable ? e.hasFocus() : bIe(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function nh(e, t = !1) {
  let n = e.state.selection;
  if (vIe(e, n), !!yIe(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && Yo) {
      let r = e.domSelectionRange(), i = e.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && Uv(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      tTt(e);
    else {
      let { anchor: r, head: i } = n, o, s;
      zae && !(n instanceof pn) && (n.$from.parent.inlineContent || (o = jae(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (s = jae(e, n.to))), e.docView.setSelection(r, i, e, t), zae && (o && Fae(o), s && Fae(s)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && eTt(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const zae = Cs || Yo && iIe < 63;
function jae(e, t) {
  let { node: n, offset: r } = e.docView.domFromPos(t, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, o = r ? n.childNodes[r - 1] : null;
  if (Cs && i && i.contentEditable == "false")
    return G6(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return G6(i);
    if (o)
      return G6(o);
  }
}
function G6(e) {
  return e.contentEditable = "true", Cs && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Fae(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function eTt(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!yIe(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function tTt(e) {
  let t = e.domSelection();
  if (!t)
    return;
  let n = e.cursorWrapper.dom, r = n.nodeName == "IMG";
  r ? t.collapse(n.parentNode, ys(n) + 1) : t.collapse(n, 0), !r && !e.state.selection.visible && vl && Zm <= 11 && (n.disabled = !0, n.disabled = !1);
}
function vIe(e, t) {
  if (t instanceof dn) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (Uae(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    Uae(e);
}
function Uae(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function dK(e, t, n, r) {
  return e.someProp("createSelectionBetween", (i) => i(e, t, n)) || pn.between(t, n, r);
}
function Vae(e) {
  return e.editable && !e.hasFocus() ? !1 : bIe(e);
}
function bIe(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function nTt(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return Uv(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function BX(e, t) {
  let { $anchor: n, $head: r } = e.selection, i = t > 0 ? n.max(r) : n.min(r), o = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
  return o && En.findFrom(o, t);
}
function em(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function qae(e, t, n) {
  let r = e.state.selection;
  if (r instanceof pn)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let s = e.state.doc.resolve(i.pos + o.nodeSize * (t < 0 ? -1 : 1));
      return em(e, new pn(r.$anchor, s));
    } else if (r.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let i = BX(e.state, t);
        return i && i instanceof dn ? em(e, i) : !1;
      } else if (!(Dc && n.indexOf("m") > -1)) {
        let i = r.$head, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter, s;
        if (!o || o.isText)
          return !1;
        let l = t < 0 ? i.pos - o.nodeSize : i.pos;
        return o.isAtom || (s = e.docView.descAt(l)) && !s.contentDOM ? dn.isSelectable(o) ? em(e, new dn(t < 0 ? e.state.doc.resolve(i.pos - o.nodeSize) : i)) : yN ? em(e, new pn(e.state.doc.resolve(t < 0 ? l : l + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof dn && r.node.isInline)
      return em(e, new pn(t > 0 ? r.$to : r.$from));
    {
      let i = BX(e.state, t);
      return i ? em(e, i) : !1;
    }
  }
}
function e_(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function ME(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function e0(e, t) {
  return t < 0 ? rTt(e) : iTt(e);
}
function rTt(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i, o, s = !1;
  for (Yc && n.nodeType == 1 && r < e_(n) && ME(n.childNodes[r], -1) && (s = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let l = n.childNodes[r - 1];
        if (ME(l, -1))
          i = n, o = --r;
        else if (l.nodeType == 3)
          n = l, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (OIe(n))
        break;
      {
        let l = n.previousSibling;
        for (; l && ME(l, -1); )
          i = n.parentNode, o = ys(l), l = l.previousSibling;
        if (l)
          n = l, r = e_(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = 0;
        }
      }
    }
  s ? XX(e, n, r) : i && XX(e, i, o);
}
function iTt(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i = e_(n), o, s;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let l = n.childNodes[r];
      if (ME(l, 1))
        o = n, s = ++r;
      else
        break;
    } else {
      if (OIe(n))
        break;
      {
        let l = n.nextSibling;
        for (; l && ME(l, 1); )
          o = l.parentNode, s = ys(l) + 1, l = l.nextSibling;
        if (l)
          n = l, r = 0, i = e_(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = i = 0;
        }
      }
    }
  o && XX(e, o, s);
}
function OIe(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function oTt(e, t) {
  for (; e && t == e.childNodes.length && !gN(e); )
    t = ys(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function sTt(e, t) {
  for (; e && !t && !gN(e); )
    t = ys(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function XX(e, t, n) {
  if (t.nodeType != 3) {
    let o, s;
    (s = oTt(t, n)) ? (t = s, n = 0) : (o = sTt(t, n)) && (t = o, n = o.nodeValue.length);
  }
  let r = e.domSelection();
  if (!r)
    return;
  if (Tj(r)) {
    let o = document.createRange();
    o.setEnd(t, n), o.setStart(t, n), r.removeAllRanges(), r.addRange(o);
  } else r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: i } = e;
  setTimeout(() => {
    e.state == i && nh(e);
  }, 50);
}
function Bae(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(Yo || oIe) && n.parent.inlineContent) {
    let i = e.coordsAtPos(t);
    if (t > n.start()) {
      let o = e.coordsAtPos(t - 1), s = (o.top + o.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left < i.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let o = e.coordsAtPos(t + 1), s = (o.top + o.bottom) / 2;
      if (s > i.top && s < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Xae(e, t, n) {
  let r = e.state.selection;
  if (r instanceof pn && !r.empty || n.indexOf("s") > -1 || Dc && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = r;
  if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let s = BX(e.state, t);
    if (s && s instanceof dn)
      return em(e, s);
  }
  if (!i.parent.inlineContent) {
    let s = t < 0 ? i : o, l = r instanceof oc ? En.near(s, t) : En.findFrom(s, t);
    return l ? em(e, l) : !1;
  }
  return !1;
}
function Wae(e, t) {
  if (!(e.state.selection instanceof pn))
    return !0;
  let { $head: n, $anchor: r, empty: i } = e.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let o = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (o && !o.isText) {
    let s = e.state.tr;
    return t < 0 ? s.delete(n.pos - o.nodeSize, n.pos) : s.delete(n.pos, n.pos + o.nodeSize), e.dispatch(s), !0;
  }
  return !1;
}
function Zae(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function aTt(e) {
  if (!Cs || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let r = t.firstChild;
    Zae(e, r, "true"), setTimeout(() => Zae(e, r, "false"), 20);
  }
  return !1;
}
function lTt(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function cTt(e, t) {
  let n = t.keyCode, r = lTt(t);
  if (n == 8 || Dc && n == 72 && r == "c")
    return Wae(e, -1) || e0(e, -1);
  if (n == 46 && !t.shiftKey || Dc && n == 68 && r == "c")
    return Wae(e, 1) || e0(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Dc && n == 66 && r == "c") {
    let i = n == 37 ? Bae(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return qae(e, i, r) || e0(e, i);
  } else if (n == 39 || Dc && n == 70 && r == "c") {
    let i = n == 39 ? Bae(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return qae(e, i, r) || e0(e, i);
  } else {
    if (n == 38 || Dc && n == 80 && r == "c")
      return Xae(e, -1, r) || e0(e, -1);
    if (n == 40 || Dc && n == 78 && r == "c")
      return aTt(e) || Xae(e, 1, r) || e0(e, 1);
    if (r == (Dc ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function fK(e, t) {
  e.someProp("transformCopied", (p) => {
    t = p(t, e);
  });
  let n = [], { content: r, openStart: i, openEnd: o } = t;
  for (; i > 1 && o > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, o--;
    let p = r.firstChild;
    n.push(p.type.name, p.attrs != p.type.defaultAttrs ? p.attrs : null), r = p.content;
  }
  let s = e.someProp("clipboardSerializer") || Pb.fromSchema(e.state.schema), l = TIe(), c = l.createElement("div");
  c.appendChild(s.serializeFragment(r, { document: l }));
  let a = c.firstChild, u, f = 0;
  for (; a && a.nodeType == 1 && (u = EIe[a.nodeName.toLowerCase()]); ) {
    for (let p = u.length - 1; p >= 0; p--) {
      let h = l.createElement(u[p]);
      for (; c.firstChild; )
        h.appendChild(c.firstChild);
      c.appendChild(h), f++;
    }
    a = c.firstChild;
  }
  a && a.nodeType == 1 && a.setAttribute("data-pm-slice", `${i} ${o}${f ? ` -${f}` : ""} ${JSON.stringify(n)}`);
  let d = e.someProp("clipboardTextSerializer", (p) => p(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: c, text: d, slice: t };
}
function AIe(e, t, n, r, i) {
  let o = i.parent.type.spec.code, s, l;
  if (!n && !t)
    return null;
  let c = !!t && (r || o || !n);
  if (c) {
    if (e.someProp("transformPastedText", (d) => {
      t = d(t, o || r, e);
    }), o)
      return l = new zt(at.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (d) => {
        l = d(l, e, !0);
      }), l;
    let f = e.someProp("clipboardTextParser", (d) => d(t, i, r, e));
    if (f)
      l = f;
    else {
      let d = i.marks(), { schema: p } = e.state, h = Pb.fromSchema(p);
      s = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let v = s.appendChild(document.createElement("p"));
        m && v.appendChild(h.serializeNode(p.text(m, d)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      n = f(n, e);
    }), s = pTt(n), yN && hTt(s);
  let a = s && s.querySelector("[data-pm-slice]"), u = a && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(a.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let d = s.firstChild;
      for (; d && d.nodeType != 1; )
        d = d.nextSibling;
      if (!d)
        break;
      s = d;
    }
  if (l || (l = (e.someProp("clipboardParser") || e.someProp("domParser") || eh.fromSchema(e.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(c || u),
    context: i,
    ruleFromNode(d) {
      return d.nodeName == "BR" && !d.nextSibling && d.parentNode && !uTt.test(d.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    l = mTt(Hae(l, +u[1], +u[2]), u[4]);
  else if (l = zt.maxOpen(dTt(l.content, i), !0), l.openStart || l.openEnd) {
    let f = 0, d = 0;
    for (let p = l.content.firstChild; f < l.openStart && !p.type.spec.isolating; f++, p = p.firstChild)
      ;
    for (let p = l.content.lastChild; d < l.openEnd && !p.type.spec.isolating; d++, p = p.lastChild)
      ;
    l = Hae(l, f, d);
  }
  return e.someProp("transformPasted", (f) => {
    l = f(l, e, c);
  }), l;
}
const uTt = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function dTt(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let i = t.node(n).contentMatchAt(t.index(n)), o, s = [];
    if (e.forEach((l) => {
      if (!s)
        return;
      let c = i.findWrapping(l.type), a;
      if (!c)
        return s = null;
      if (a = s.length && o.length && xIe(c, o, l, s[s.length - 1], 0))
        s[s.length - 1] = a;
      else {
        s.length && (s[s.length - 1] = SIe(s[s.length - 1], o.length));
        let u = wIe(l, c);
        s.push(u), i = i.matchType(u.type), o = c;
      }
    }), s)
      return at.from(s);
  }
  return e;
}
function wIe(e, t, n = 0) {
  for (let r = t.length - 1; r >= n; r--)
    e = t[r].create(null, at.from(e));
  return e;
}
function xIe(e, t, n, r, i) {
  if (i < e.length && i < t.length && e[i] == t[i]) {
    let o = xIe(e, t, n, r.lastChild, i + 1);
    if (o)
      return r.copy(r.content.replaceChild(r.childCount - 1, o));
    if (r.contentMatchAt(r.childCount).matchType(i == e.length - 1 ? n.type : e[i + 1]))
      return r.copy(r.content.append(at.from(wIe(n, e, i + 1))));
  }
}
function SIe(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, SIe(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(at.empty, !0);
  return e.copy(n.append(r));
}
function WX(e, t, n, r, i, o) {
  let s = t < 0 ? e.firstChild : e.lastChild, l = s.content;
  return e.childCount > 1 && (o = 0), i < r - 1 && (l = WX(l, t, n, r, i + 1, o)), i >= n && (l = t < 0 ? s.contentMatchAt(0).fillBefore(l, o <= i).append(l) : l.append(s.contentMatchAt(s.childCount).fillBefore(at.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, s.copy(l));
}
function Hae(e, t, n) {
  return t < e.openStart && (e = new zt(WX(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new zt(WX(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const EIe = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Qae = null;
function TIe() {
  return Qae || (Qae = document.implementation.createHTMLDocument("title"));
}
let Y6 = null;
function fTt(e) {
  let t = window.trustedTypes;
  return t ? (Y6 || (Y6 = t.defaultPolicy || t.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), Y6.createHTML(e)) : e;
}
function pTt(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = TIe().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), i;
  if ((i = r && EIe[r[1].toLowerCase()]) && (e = i.map((o) => "<" + o + ">").join("") + e + i.map((o) => "</" + o + ">").reverse().join("")), n.innerHTML = fTt(e), i)
    for (let o = 0; o < i.length; o++)
      n = n.querySelector(i[o]) || n;
  return n;
}
function hTt(e) {
  let t = e.querySelectorAll(Yo ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
  }
}
function mTt(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: i, openStart: o, openEnd: s } = e;
  for (let l = r.length - 2; l >= 0; l -= 2) {
    let c = n.nodes[r[l]];
    if (!c || c.hasRequiredAttrs())
      break;
    i = at.from(c.create(r[l + 1], i)), o++, s++;
  }
  return new zt(i, o, s);
}
const _a = {}, La = {}, gTt = { touchstart: !0, touchmove: !0 };
let yTt = class {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
};
function vTt(e) {
  for (let t in _a) {
    let n = _a[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (r) => {
      OTt(e, r) && !pK(e, r) && (e.editable || !(r.type in La)) && n(e, r);
    }, gTt[t] ? { passive: !0 } : void 0);
  }
  Cs && e.dom.addEventListener("input", () => null), ZX(e);
}
function _m(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function bTt(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function ZX(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (r) => pK(e, r));
  });
}
function pK(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let r = n[t.type];
    return r ? r(e, t) || t.defaultPrevented : !1;
  });
}
function OTt(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function ATt(e, t) {
  !pK(e, t) && _a[t.type] && (e.editable || !(t.type in La)) && _a[t.type](e, t);
}
La.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !CIe(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Bp && Yo && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), gw && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      e.input.lastIOSEnter = r, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == r && (e.someProp("handleKeyDown", (i) => i(e, vy(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (r) => r(e, n)) || cTt(e, n) ? n.preventDefault() : _m(e, "key");
};
La.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
La.keypress = (e, t) => {
  let n = t;
  if (CIe(e, n) || !n.charCode || n.ctrlKey && !n.altKey || Dc && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (i) => i(e, n))) {
    n.preventDefault();
    return;
  }
  let r = e.state.selection;
  if (!(r instanceof pn) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode), o = () => e.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !e.someProp("handleTextInput", (s) => s(e, r.$from.pos, r.$to.pos, i, o)) && e.dispatch(o()), n.preventDefault();
  }
};
function Cj(e) {
  return { left: e.clientX, top: e.clientY };
}
function wTt(e, t) {
  let n = t.x - e.clientX, r = t.y - e.clientY;
  return n * n + r * r < 100;
}
function hK(e, t, n, r, i) {
  if (r == -1)
    return !1;
  let o = e.state.doc.resolve(r);
  for (let s = o.depth + 1; s > 0; s--)
    if (e.someProp(t, (l) => s > o.depth ? l(e, n, o.nodeAfter, o.before(s), i, !0) : l(e, n, o.node(s), o.before(s), i, !1)))
      return !0;
  return !1;
}
function YO(e, t, n) {
  if (e.focused || e.focus(), e.state.selection.eq(t))
    return;
  let r = e.state.tr.setSelection(t);
  r.setMeta("pointer", !0), e.dispatch(r);
}
function xTt(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), r = n.nodeAfter;
  return r && r.isAtom && dn.isSelectable(r) ? (YO(e, new dn(n)), !0) : !1;
}
function STt(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, r, i;
  n instanceof dn && (r = n.node);
  let o = e.state.doc.resolve(t);
  for (let s = o.depth + 1; s > 0; s--) {
    let l = s > o.depth ? o.nodeAfter : o.node(s);
    if (dn.isSelectable(l)) {
      r && n.$from.depth > 0 && s >= n.$from.depth && o.before(n.$from.depth + 1) == n.$from.pos ? i = o.before(n.$from.depth) : i = o.before(s);
      break;
    }
  }
  return i != null ? (YO(e, dn.create(e.state.doc, i)), !0) : !1;
}
function ETt(e, t, n, r, i) {
  return hK(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (o) => o(e, t, r)) || (i ? STt(e, n) : xTt(e, n));
}
function TTt(e, t, n, r) {
  return hK(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (i) => i(e, t, r));
}
function kTt(e, t, n, r) {
  return hK(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (i) => i(e, t, r)) || CTt(e, n, r);
}
function CTt(e, t, n) {
  if (n.button != 0)
    return !1;
  let r = e.state.doc;
  if (t == -1)
    return r.inlineContent ? (YO(e, pn.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let s = o > i.depth ? i.nodeAfter : i.node(o), l = i.before(o);
    if (s.inlineContent)
      YO(e, pn.create(r, l + 1, l + 1 + s.content.size));
    else if (dn.isSelectable(s))
      YO(e, dn.create(r, l));
    else
      continue;
    return !0;
  }
}
function mK(e) {
  return t_(e);
}
const kIe = Dc ? "metaKey" : "ctrlKey";
_a.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = mK(e), i = Date.now(), o = "singleClick";
  i - e.input.lastClick.time < 500 && wTt(n, e.input.lastClick) && !n[kIe] && e.input.lastClick.button == n.button && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: o, button: n.button };
  let s = e.posAtCoords(Cj(n));
  s && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new NTt(e, s, n, !!r)) : (o == "doubleClick" ? TTt : kTt)(e, s.pos, s.inside, n) ? n.preventDefault() : _m(e, "pointer"));
};
class NTt {
  constructor(t, n, r, i) {
    this.view = t, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!r[kIe], this.allowDefault = r.shiftKey;
    let o, s;
    if (n.inside > -1)
      o = t.state.doc.nodeAt(n.inside), s = n.inside;
    else {
      let u = t.state.doc.resolve(n.pos);
      o = u.parent, s = u.depth ? u.before() : 0;
    }
    const l = i ? null : r.target, c = l ? t.docView.nearestDesc(l, !0) : null;
    this.target = c && c.nodeDOM.nodeType == 1 ? c.nodeDOM : null;
    let { selection: a } = t.state;
    (r.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || a instanceof dn && a.from <= s && a.to > s) && (this.mightDrag = {
      node: o,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Yc && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), _m(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => nh(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Cj(t))), this.updateAllowDefault(t), this.allowDefault || !n ? _m(this.view, "pointer") : ETt(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Cs && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Yo && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (YO(this.view, En.near(this.view.state.doc.resolve(n.pos))), t.preventDefault()) : _m(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), _m(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
_a.touchstart = (e) => {
  e.input.lastTouch = Date.now(), mK(e), _m(e, "pointer");
};
_a.touchmove = (e) => {
  e.input.lastTouch = Date.now(), _m(e, "pointer");
};
_a.contextmenu = (e) => mK(e);
function CIe(e, t) {
  return e.composing ? !0 : Cs && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const PTt = Bp ? 5e3 : -1;
La.compositionstart = La.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$to;
    if (t.selection instanceof pn && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || Yo && oIe && ITt(e)))
      e.markCursor = e.state.storedMarks || n.marks(), t_(e, !0), e.markCursor = null;
    else if (t_(e, !t.selection.empty), Yc && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = e.domSelectionRange();
      for (let i = r.focusNode, o = r.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let s = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let l = e.domSelection();
          l && l.collapse(s, s.nodeValue.length);
          break;
        } else
          i = s, o = -1;
      }
    }
    e.input.composing = !0;
  }
  NIe(e, PTt);
};
function ITt(e) {
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (!t || t.nodeType != 1 || n >= t.childNodes.length)
    return !1;
  let r = t.childNodes[n];
  return r.nodeType == 1 && r.contentEditable == "false";
}
La.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, NIe(e, 20));
};
function NIe(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => t_(e), t));
}
function PIe(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = MTt()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function RTt(e) {
  let t = e.domSelectionRange();
  if (!t.focusNode)
    return null;
  let n = SEt(t.focusNode, t.focusOffset), r = EEt(t.focusNode, t.focusOffset);
  if (n && r && n != r) {
    let i = r.pmViewDesc, o = e.domObserver.lastChangedTextNode;
    if (n == o || r == o)
      return o;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (e.input.compositionNode == r) {
      let s = n.pmViewDesc;
      if (!(!s || !s.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function MTt() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function t_(e, t = !1) {
  if (!(Bp && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), PIe(e), t || e.docView && e.docView.dirty) {
      let n = uK(e), r = e.state.selection;
      return n && !n.eq(r) ? e.dispatch(e.state.tr.setSelection(n)) : (e.markCursor || t) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function DTt(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const tk = vl && Zm < 15 || gw && NEt < 604;
_a.copy = La.cut = (e, t) => {
  let n = t, r = e.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let o = tk ? null : n.clipboardData, s = r.content(), { dom: l, text: c } = fK(e, s);
  o ? (n.preventDefault(), o.clearData(), o.setData("text/html", l.innerHTML), o.setData("text/plain", c)) : DTt(e, l), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function _Tt(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function LTt(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? nk(e, r.value, null, i, t) : nk(e, r.textContent, r.innerHTML, i, t);
  }, 50);
}
function nk(e, t, n, r, i) {
  let o = AIe(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", (c) => c(e, i, o || zt.empty)))
    return !0;
  if (!o)
    return !1;
  let s = _Tt(o), l = s ? e.state.tr.replaceSelectionWith(s, r) : e.state.tr.replaceSelection(o);
  return e.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function IIe(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
La.paste = (e, t) => {
  let n = t;
  if (e.composing && !Bp)
    return;
  let r = tk ? null : n.clipboardData, i = e.input.shiftKey && e.input.lastKeyCode != 45;
  r && nk(e, IIe(r), r.getData("text/html"), i, n) ? n.preventDefault() : LTt(e, n);
};
class RIe {
  constructor(t, n, r) {
    this.slice = t, this.move = n, this.node = r;
  }
}
const zTt = Dc ? "altKey" : "ctrlKey";
function MIe(e, t) {
  let n = e.someProp("dragCopies", (r) => !r(t));
  return n ?? !t[zTt];
}
_a.dragstart = (e, t) => {
  let n = t, r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = e.state.selection, o = i.empty ? null : e.posAtCoords(Cj(n)), s;
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof dn ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      s = dn.create(e.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let f = e.docView.nearestDesc(n.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (s = dn.create(e.state.doc, f.posBefore));
    }
  }
  let l = (s || e.state.selection).content(), { dom: c, text: a, slice: u } = fK(e, l);
  (!n.dataTransfer.files.length || !Yo || iIe > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(tk ? "Text" : "text/html", c.innerHTML), n.dataTransfer.effectAllowed = "copyMove", tk || n.dataTransfer.setData("text/plain", a), e.dragging = new RIe(u, MIe(e, n), s);
};
_a.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
La.dragover = La.dragenter = (e, t) => t.preventDefault();
La.drop = (e, t) => {
  try {
    jTt(e, t, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function jTt(e, t, n) {
  if (!t.dataTransfer)
    return;
  let r = e.posAtCoords(Cj(t));
  if (!r)
    return;
  let i = e.state.doc.resolve(r.pos), o = n && n.slice;
  o ? e.someProp("transformPasted", (p) => {
    o = p(o, e, !1);
  }) : o = AIe(e, IIe(t.dataTransfer), tk ? null : t.dataTransfer.getData("text/html"), !1, i);
  let s = !!(n && MIe(e, t));
  if (e.someProp("handleDrop", (p) => p(e, t, o || zt.empty, s))) {
    t.preventDefault();
    return;
  }
  if (!o)
    return;
  t.preventDefault();
  let l = o ? zPe(e.state.doc, i.pos, o) : i.pos;
  l == null && (l = i.pos);
  let c = e.state.tr;
  if (s) {
    let { node: p } = n;
    p ? p.replace(c) : c.deleteSelection();
  }
  let a = c.mapping.map(l), u = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = c.doc;
  if (u ? c.replaceRangeWith(a, a, o.content.firstChild) : c.replaceRange(a, a, o), c.doc.eq(f))
    return;
  let d = c.doc.resolve(a);
  if (u && dn.isSelectable(o.content.firstChild) && d.nodeAfter && d.nodeAfter.sameMarkup(o.content.firstChild))
    c.setSelection(new dn(d));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((h, m, v, b) => p = b), c.setSelection(dK(e, d, c.doc.resolve(p)));
  }
  e.focus(), e.dispatch(c.setMeta("uiEvent", "drop"));
}
_a.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && nh(e);
  }, 20));
};
_a.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
_a.beforeinput = (e, t) => {
  if (Yo && Bp && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: r } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != r || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, vy(8, "Backspace")))))
        return;
      let { $cursor: i } = e.state.selection;
      i && i.pos > 0 && e.dispatch(e.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in La)
  _a[e] = La[e];
function rk(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
let $ae = class DIe {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || uv, this.side = this.spec.side || 0;
  }
  map(t, n, r, i) {
    let { pos: o, deleted: s } = t.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return s ? null : new za(o - r, o - r, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof DIe && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && rk(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
};
class Qm {
  constructor(t, n) {
    this.attrs = t, this.spec = n || uv;
  }
  map(t, n, r, i) {
    let o = t.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, s = t.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return o >= s ? null : new za(o, s, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof Qm && rk(this.attrs, t.attrs) && rk(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof Qm;
  }
  destroy() {
  }
}
let FTt = class _Ie {
  constructor(t, n) {
    this.attrs = t, this.spec = n || uv;
  }
  map(t, n, r, i) {
    let o = t.mapResult(n.from + i, 1);
    if (o.deleted)
      return null;
    let s = t.mapResult(n.to + i, -1);
    return s.deleted || s.pos <= o.pos ? null : new za(o.pos - r, s.pos - r, this);
  }
  valid(t, n) {
    let { index: r, offset: i } = t.content.findIndex(n.from), o;
    return i == n.from && !(o = t.child(r)).isText && i + o.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof _Ie && rk(this.attrs, t.attrs) && rk(this.spec, t.spec);
  }
  destroy() {
  }
}, za = class d1 {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new d1(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, r) {
    return this.type.map(t, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, r) {
    return new d1(t, t, new $ae(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, r, i) {
    return new d1(t, n, new Qm(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, r, i) {
    return new d1(t, n, new FTt(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Qm;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof $ae;
  }
};
const iO = [], uv = {};
class Vr {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : iO, this.children = n.length ? n : iO;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? n_(n, t, 0, uv) : Bs;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, r) {
    let i = [];
    return this.findInner(t ?? 0, n ?? 1e9, i, 0, r), i;
  }
  findInner(t, n, r, i, o) {
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      l.from <= n && l.to >= t && (!o || o(l.spec)) && r.push(l.copy(l.from + i, l.to + i));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < n && this.children[s + 1] > t) {
        let l = this.children[s] + 1;
        this.children[s + 2].findInner(t - l, n - l, r, i + l, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, r) {
    return this == Bs || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, r || uv);
  }
  /**
  @internal
  */
  mapInner(t, n, r, i, o) {
    let s;
    for (let l = 0; l < this.local.length; l++) {
      let c = this.local[l].map(t, r, i);
      c && c.type.valid(n, c) ? (s || (s = [])).push(c) : o.onRemove && o.onRemove(this.local[l].spec);
    }
    return this.children.length ? UTt(this.children, s || [], t, n, r, i, o) : s ? new Vr(s.sort(dv), iO) : Bs;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == Bs ? Vr.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, r) {
    let i, o = 0;
    t.forEach((l, c) => {
      let a = c + r, u;
      if (u = zIe(n, l, a)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < c; )
          o += 3;
        i[o] == c ? i[o + 2] = i[o + 2].addInner(l, u, a + 1) : i.splice(o, 0, c, c + l.nodeSize, n_(u, l, a + 1, uv)), o += 3;
      }
    });
    let s = LIe(o ? jIe(n) : n, -r);
    for (let l = 0; l < s.length; l++)
      s[l].type.valid(t, s[l]) || s.splice(l--, 1);
    return new Vr(s.length ? this.local.concat(s).sort(dv) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == Bs ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let r = this.children, i = this.local;
    for (let o = 0; o < r.length; o += 3) {
      let s, l = r[o] + n, c = r[o + 1] + n;
      for (let u = 0, f; u < t.length; u++)
        (f = t[u]) && f.from > l && f.to < c && (t[u] = null, (s || (s = [])).push(f));
      if (!s)
        continue;
      r == this.children && (r = this.children.slice());
      let a = r[o + 2].removeInner(s, l + 1);
      a != Bs ? r[o + 2] = a : (r.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, s; o < t.length; o++)
        if (s = t[o])
          for (let l = 0; l < i.length; l++)
            i[l].eq(s, n) && (i == this.local && (i = this.local.slice()), i.splice(l--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Vr(i, r) : Bs;
  }
  forChild(t, n) {
    if (this == Bs)
      return this;
    if (n.isLeaf)
      return Vr.empty;
    let r, i;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= t) {
        this.children[l] == t && (r = this.children[l + 2]);
        break;
      }
    let o = t + 1, s = o + n.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let c = this.local[l];
      if (c.from < s && c.to > o && c.type instanceof Qm) {
        let a = Math.max(o, c.from) - o, u = Math.min(s, c.to) - o;
        a < u && (i || (i = [])).push(c.copy(a, u));
      }
    }
    if (i) {
      let l = new Vr(i.sort(dv), iO);
      return r ? new cm([l, r]) : l;
    }
    return r || Bs;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof Vr) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return gK(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == Bs)
      return iO;
    if (t.inlineContent || !this.local.some(Qm.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Qm || n.push(this.local[r]);
    return n;
  }
  forEachSet(t) {
    t(this);
  }
}
Vr.empty = new Vr([], []);
Vr.removeOverlap = gK;
const Bs = Vr.empty;
class cm {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const r = this.members.map((i) => i.map(t, n, uv));
    return cm.from(r);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return Vr.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(t, n);
      o != Bs && (o instanceof cm ? r = r.concat(o.members) : r.push(o));
    }
    return cm.from(r);
  }
  eq(t) {
    if (!(t instanceof cm) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(t);
      if (o.length)
        if (!n)
          n = o;
        else {
          r && (n = n.slice(), r = !1);
          for (let s = 0; s < o.length; s++)
            n.push(o[s]);
        }
    }
    return n ? gK(r ? n : n.sort(dv)) : iO;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return Bs;
      case 1:
        return t[0];
      default:
        return new cm(t.every((n) => n instanceof Vr) ? t : t.reduce((n, r) => n.concat(r instanceof Vr ? r : r.members), []));
    }
  }
  forEachSet(t) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(t);
  }
}
function UTt(e, t, n, r, i, o, s) {
  let l = e.slice();
  for (let a = 0, u = o; a < n.maps.length; a++) {
    let f = 0;
    n.maps[a].forEach((d, p, h, m) => {
      let v = m - h - (p - d);
      for (let b = 0; b < l.length; b += 3) {
        let A = l[b + 1];
        if (A < 0 || d > A + u - f)
          continue;
        let w = l[b] + u - f;
        p >= w ? l[b + 1] = d <= w ? -2 : -1 : d >= u && v && (l[b] += v, l[b + 1] += v);
      }
      f += v;
    }), u = n.maps[a].map(u, -1);
  }
  let c = !1;
  for (let a = 0; a < l.length; a += 3)
    if (l[a + 1] < 0) {
      if (l[a + 1] == -2) {
        c = !0, l[a + 1] = -1;
        continue;
      }
      let u = n.map(e[a] + o), f = u - i;
      if (f < 0 || f >= r.content.size) {
        c = !0;
        continue;
      }
      let d = n.map(e[a + 1] + o, -1), p = d - i, { index: h, offset: m } = r.content.findIndex(f), v = r.maybeChild(h);
      if (v && m == f && m + v.nodeSize == p) {
        let b = l[a + 2].mapInner(n, v, u + 1, e[a] + o + 1, s);
        b != Bs ? (l[a] = f, l[a + 1] = p, l[a + 2] = b) : (l[a + 1] = -2, c = !0);
      } else
        c = !0;
    }
  if (c) {
    let a = VTt(l, e, t, n, i, o, s), u = n_(a, r, 0, s);
    t = u.local;
    for (let f = 0; f < l.length; f += 3)
      l[f + 1] < 0 && (l.splice(f, 3), f -= 3);
    for (let f = 0, d = 0; f < u.children.length; f += 3) {
      let p = u.children[f];
      for (; d < l.length && l[d] < p; )
        d += 3;
      l.splice(d, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new Vr(t.sort(dv), l);
}
function LIe(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r];
    n.push(new za(i.from + t, i.to + t, i.type));
  }
  return n;
}
function VTt(e, t, n, r, i, o, s) {
  function l(c, a) {
    for (let u = 0; u < c.local.length; u++) {
      let f = c.local[u].map(r, i, a);
      f ? n.push(f) : s.onRemove && s.onRemove(c.local[u].spec);
    }
    for (let u = 0; u < c.children.length; u += 3)
      l(c.children[u + 2], c.children[u] + a + 1);
  }
  for (let c = 0; c < e.length; c += 3)
    e[c + 1] == -1 && l(e[c + 2], t[c] + o + 1);
  return n;
}
function zIe(e, t, n) {
  if (t.isLeaf)
    return null;
  let r = n + t.nodeSize, i = null;
  for (let o = 0, s; o < e.length; o++)
    (s = e[o]) && s.from > n && s.to < r && ((i || (i = [])).push(s), e[o] = null);
  return i;
}
function jIe(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function n_(e, t, n, r) {
  let i = [], o = !1;
  t.forEach((l, c) => {
    let a = zIe(e, l, c + n);
    if (a) {
      o = !0;
      let u = n_(a, l, n + c + 1, r);
      u != Bs && i.push(c, c + l.nodeSize, u);
    }
  });
  let s = LIe(o ? jIe(e) : e, -n).sort(dv);
  for (let l = 0; l < s.length; l++)
    s[l].type.valid(t, s[l]) || (r.onRemove && r.onRemove(s[l].spec), s.splice(l--, 1));
  return s.length || i.length ? new Vr(s, i) : Bs;
}
function dv(e, t) {
  return e.from - t.from || e.to - t.to;
}
function gK(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to)
      for (let i = n + 1; i < t.length; i++) {
        let o = t[i];
        if (o.from == r.from) {
          o.to != r.to && (t == e && (t = e.slice()), t[i] = o.copy(o.from, r.to), Kae(t, i + 1, o.copy(r.to, o.to)));
          continue;
        } else {
          o.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, o.from), Kae(t, i, r.copy(o.from, r.to)));
          break;
        }
      }
  }
  return t;
}
function Kae(e, t, n) {
  for (; t < e.length && dv(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function J6(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let r = n(e.state);
    r && r != Bs && t.push(r);
  }), e.cursorWrapper && t.push(Vr.create(e.state.doc, [e.cursorWrapper.deco])), cm.from(t);
}
const qTt = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, BTt = vl && Zm <= 11;
class XTt {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
let WTt = class {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new XTt(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      vl && Zm <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : Cs && t.composing && r.some((i) => i.type == "childList" && i.target.nodeName == "TR") ? (t.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), BTt && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, qTt)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Vae(this.view)) {
      if (this.suppressingSelectionUpdates)
        return nh(this.view);
      if (vl && Zm <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && Uv(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let o = t.focusNode; o; o = mw(o))
      n.add(o);
    for (let o = t.anchorNode; o; o = mw(o))
      if (n.has(o)) {
        r = o;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = t.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Vae(t) && !this.ignoreSelectionChange(r), o = -1, s = -1, l = !1, c = [];
    if (t.editable)
      for (let u = 0; u < n.length; u++) {
        let f = this.registerMutation(n[u], c);
        f && (o = o < 0 ? f.from : Math.min(f.from, o), s = s < 0 ? f.to : Math.max(f.to, s), f.typeOver && (l = !0));
      }
    if (Yc && c.length) {
      let u = c.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, d] = u;
        f.parentNode && f.parentNode.parentNode == d.parentNode ? d.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let d of u) {
          let p = d.parentNode;
          p && p.nodeName == "LI" && (!f || QTt(t, f) != p) && d.remove();
        }
      }
    } else if ((Yo || Cs) && c.some((u) => u.nodeName == "BR") && (t.input.lastKeyCode == 8 || t.input.lastKeyCode == 46)) {
      for (let u of c)
        if (u.nodeName == "BR" && u.parentNode) {
          let f = u.nextSibling;
          f && f.nodeType == 1 && f.contentEditable == "false" && u.parentNode.removeChild(u);
        }
    }
    let a = null;
    o < 0 && i && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && Tj(r) && (a = uK(t)) && a.eq(En.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, nh(t), this.currentSelection.set(r), t.scrollToSelection()) : (o > -1 || i) && (o > -1 && (t.docView.markDirty(o, s), ZTt(t)), t.input.badSafariComposition && (t.input.badSafariComposition = !1, $Tt(t, c)), this.handleDOMChange(o, s, l, c), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(r) || nh(t), this.currentSelection.set(r));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (r == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !r || r.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let u = 0; u < t.addedNodes.length; u++) {
        let f = t.addedNodes[u];
        n.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(t.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = t.previousSibling, o = t.nextSibling;
      if (vl && Zm <= 11 && t.addedNodes.length)
        for (let u = 0; u < t.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: d } = t.addedNodes[u];
          (!f || Array.prototype.indexOf.call(t.addedNodes, f) < 0) && (i = f), (!d || Array.prototype.indexOf.call(t.addedNodes, d) < 0) && (o = d);
        }
      let s = i && i.parentNode == t.target ? ys(i) + 1 : 0, l = r.localPosFromDOM(t.target, s, -1), c = o && o.parentNode == t.target ? ys(o) : t.target.childNodes.length, a = r.localPosFromDOM(t.target, c, 1);
      return { from: l, to: a };
    } else return t.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = t.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: t.target.nodeValue == t.oldValue
    });
  }
}, Gae = /* @__PURE__ */ new WeakMap(), Yae = !1;
function ZTt(e) {
  if (!Gae.has(e) && (Gae.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Yc, Yae)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Yae = !0;
  }
}
function Jae(e, t) {
  let n = t.startContainer, r = t.startOffset, i = t.endContainer, o = t.endOffset, s = e.domAtPos(e.state.selection.anchor);
  return Uv(s.node, s.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function HTt(e, t) {
  if (t.getComposedRanges) {
    let i = t.getComposedRanges(e.root)[0];
    if (i)
      return Jae(e, i);
  }
  let n;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", r, !0), n ? Jae(e, n) : null;
}
function QTt(e, t) {
  for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
    let r = e.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function $Tt(e, t) {
  var n;
  let { focusNode: r, focusOffset: i } = e.domSelectionRange();
  for (let o of t)
    if (((n = o.parentNode) === null || n === void 0 ? void 0 : n.nodeName) == "TR") {
      let s = o.nextSibling;
      for (; s && s.nodeName != "TD" && s.nodeName != "TH"; )
        s = s.nextSibling;
      if (s) {
        let l = s;
        for (; ; ) {
          let c = l.firstChild;
          if (!c || c.nodeType != 1 || c.contentEditable == "false" || /^(BR|IMG)$/.test(c.nodeName))
            break;
          l = c;
        }
        l.insertBefore(o, l.firstChild), r == o && e.domSelection().collapse(o, i);
      } else
        o.parentNode.removeChild(o);
    }
}
function KTt(e, t, n) {
  let { node: r, fromOffset: i, toOffset: o, from: s, to: l } = e.docView.parseRange(t, n), c = e.domSelectionRange(), a, u = c.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (a = [{ node: u, offset: c.anchorOffset }], Tj(c) || a.push({ node: c.focusNode, offset: c.focusOffset })), Yo && e.input.lastKeyCode === 8)
    for (let v = o; v > i; v--) {
      let b = r.childNodes[v - 1], A = b.pmViewDesc;
      if (b.nodeName == "BR" && !A) {
        o = v;
        break;
      }
      if (!A || A.size)
        break;
    }
  let f = e.state.doc, d = e.someProp("domParser") || eh.fromSchema(e.state.schema), p = f.resolve(s), h = null, m = d.parse(r, {
    topNode: p.parent,
    topMatch: p.parent.contentMatchAt(p.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: p.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: a,
    ruleFromNode: GTt,
    context: p
  });
  if (a && a[0].pos != null) {
    let v = a[0].pos, b = a[1] && a[1].pos;
    b == null && (b = v), h = { anchor: v + s, head: b + s };
  }
  return { doc: m, sel: h, from: s, to: l };
}
function GTt(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Cs && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || Cs && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const YTt = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function JTt(e, t, n, r, i) {
  let o = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let E = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, k = uK(e, E);
    if (k && !e.state.selection.eq(k)) {
      if (Yo && Bp && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (R) => R(e, vy(13, "Enter"))))
        return;
      let T = e.state.tr.setSelection(k);
      E == "pointer" ? T.setMeta("pointer", !0) : E == "key" && T.scrollIntoView(), o && T.setMeta("composition", o), e.dispatch(T);
    }
    return;
  }
  let s = e.state.doc.resolve(t), l = s.sharedDepth(n);
  t = s.before(l + 1), n = e.state.doc.resolve(n).after(l + 1);
  let c = e.state.selection, a = KTt(e, t, n), u = e.state.doc, f = u.slice(a.from, a.to), d, p;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (d = e.state.selection.to, p = "end") : (d = e.state.selection.from, p = "start"), e.input.lastKeyCode = null;
  let h = nkt(f.content, a.doc.content, a.from, d, p);
  if (h && e.input.domChangeCount++, (gw && e.input.lastIOSEnter > Date.now() - 225 || Bp) && i.some((E) => E.nodeType == 1 && !YTt.test(E.nodeName)) && (!h || h.endA >= h.endB) && e.someProp("handleKeyDown", (E) => E(e, vy(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!h)
    if (r && c instanceof pn && !c.empty && c.$head.sameParent(c.$anchor) && !e.composing && !(a.sel && a.sel.anchor != a.sel.head))
      h = { start: c.from, endA: c.to, endB: c.to };
    else {
      if (a.sel) {
        let E = ele(e, e.state.doc, a.sel);
        if (E && !E.eq(e.state.selection)) {
          let k = e.state.tr.setSelection(E);
          o && k.setMeta("composition", o), e.dispatch(k);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && h.start == h.endB && e.state.selection instanceof pn && (h.start > e.state.selection.from && h.start <= e.state.selection.from + 2 && e.state.selection.from >= a.from ? h.start = e.state.selection.from : h.endA < e.state.selection.to && h.endA >= e.state.selection.to - 2 && e.state.selection.to <= a.to && (h.endB += e.state.selection.to - h.endA, h.endA = e.state.selection.to)), vl && Zm <= 11 && h.endB == h.start + 1 && h.endA == h.start && h.start > a.from && a.doc.textBetween(h.start - a.from - 1, h.start - a.from + 1) == "  " && (h.start--, h.endA--, h.endB--);
  let m = a.doc.resolveNoCache(h.start - a.from), v = a.doc.resolveNoCache(h.endB - a.from), b = u.resolve(h.start), A = m.sameParent(v) && m.parent.inlineContent && b.end() >= h.endA;
  if ((gw && e.input.lastIOSEnter > Date.now() - 225 && (!A || i.some((E) => E.nodeName == "DIV" || E.nodeName == "P")) || !A && m.pos < a.doc.content.size && (!m.sameParent(v) || !m.parent.inlineContent) && m.pos < v.pos && !/\S/.test(a.doc.textBetween(m.pos, v.pos, "", ""))) && e.someProp("handleKeyDown", (E) => E(e, vy(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > h.start && tkt(u, h.start, h.endA, m, v) && e.someProp("handleKeyDown", (E) => E(e, vy(8, "Backspace")))) {
    Bp && Yo && e.domObserver.suppressSelectionUpdates();
    return;
  }
  Yo && h.endB == h.start && (e.input.lastChromeDelete = Date.now()), Bp && !A && m.start() != v.start() && v.parentOffset == 0 && m.depth == v.depth && a.sel && a.sel.anchor == a.sel.head && a.sel.head == h.endA && (h.endB -= 2, v = a.doc.resolveNoCache(h.endB - a.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(E) {
      return E(e, vy(13, "Enter"));
    });
  }, 20));
  let w = h.start, O = h.endA, x = (E) => {
    let k = E || e.state.tr.replace(w, O, a.doc.slice(h.start - a.from, h.endB - a.from));
    if (a.sel) {
      let T = ele(e, k.doc, a.sel);
      T && !(Yo && e.composing && T.empty && (h.start != h.endB || e.input.lastChromeDelete < Date.now() - 100) && (T.head == w || T.head == k.mapping.map(O) - 1) || vl && T.empty && T.head == w) && k.setSelection(T);
    }
    return o && k.setMeta("composition", o), k.scrollIntoView();
  }, S;
  if (A)
    if (m.pos == v.pos) {
      vl && Zm <= 11 && m.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => nh(e), 20));
      let E = x(e.state.tr.delete(w, O)), k = u.resolve(h.start).marksAcross(u.resolve(h.endA));
      k && E.ensureMarks(k), e.dispatch(E);
    } else if (
      // Adding or removing a mark
      h.endA == h.endB && (S = ekt(m.parent.content.cut(m.parentOffset, v.parentOffset), b.parent.content.cut(b.parentOffset, h.endA - b.start())))
    ) {
      let E = x(e.state.tr);
      S.type == "add" ? E.addMark(w, O, S.mark) : E.removeMark(w, O, S.mark), e.dispatch(E);
    } else if (m.parent.child(m.index()).isText && m.index() == v.index() - (v.textOffset ? 0 : 1)) {
      let E = m.parent.textBetween(m.parentOffset, v.parentOffset), k = () => x(e.state.tr.insertText(E, w, O));
      e.someProp("handleTextInput", (T) => T(e, w, O, E, k)) || e.dispatch(k());
    } else
      e.dispatch(x());
  else
    e.dispatch(x());
}
function ele(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : dK(e, t.resolve(n.anchor), t.resolve(n.head));
}
function ekt(e, t) {
  let n = e.firstChild.marks, r = t.firstChild.marks, i = n, o = r, s, l, c;
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  for (let u = 0; u < n.length; u++)
    o = n[u].removeFromSet(o);
  if (i.length == 1 && o.length == 0)
    l = i[0], s = "add", c = (u) => u.mark(l.addToSet(u.marks));
  else if (i.length == 0 && o.length == 1)
    l = o[0], s = "remove", c = (u) => u.mark(l.removeFromSet(u.marks));
  else
    return null;
  let a = [];
  for (let u = 0; u < t.childCount; u++)
    a.push(c(t.child(u)));
  if (at.from(a).eq(e))
    return { mark: l, type: s };
}
function tkt(e, t, n, r, i) {
  if (
    // The content must have shrunk
    n - t <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    eU(r, !0, !1) < i.pos
  )
    return !1;
  let o = e.resolve(t);
  if (!r.parent.isTextblock) {
    let l = o.nodeAfter;
    return l != null && n == t + l.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let s = e.resolve(eU(o, !0, !0));
  return !s.parent.isTextblock || s.pos > n || eU(s, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(s.parent.content);
}
function eU(e, t, n) {
  let r = e.depth, i = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount); )
    r--, i++, t = !1;
  if (n) {
    let o = e.node(r).maybeChild(e.indexAfter(r));
    for (; o && !o.isLeaf; )
      o = o.firstChild, i++;
  }
  return i;
}
function nkt(e, t, n, r, i) {
  let o = e.findDiffStart(t, n);
  if (o == null)
    return null;
  let { a: s, b: l } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (i == "end") {
    let c = Math.max(0, o - Math.min(s, l));
    r -= s + c - o;
  }
  if (s < o && e.size < t.size) {
    let c = r <= o && r >= s ? o - r : 0;
    o -= c, o && o < t.size && tle(t.textBetween(o - 1, o + 1)) && (o += c ? 1 : -1), l = o + (l - s), s = o;
  } else if (l < o) {
    let c = r <= o && r >= l ? o - r : 0;
    o -= c, o && o < e.size && tle(e.textBetween(o - 1, o + 1)) && (o += c ? 1 : -1), s = o + (s - l), l = o;
  }
  return { start: o, endA: s, endB: l };
}
function tle(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
let FIe = class {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new yTt(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(sle), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = ile(this), rle(this), this.nodeViews = ole(this), this.docView = _ae(this.state.doc, nle(this), J6(this), this.dom, this), this.domObserver = new WTt(this, (r, i, o, s) => JTt(this, r, i, o, s)), this.domObserver.start(), vTt(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && ZX(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(sle), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in t)
      n[r] = t[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var r;
    let i = this.state, o = !1, s = !1;
    t.storedMarks && this.composing && (PIe(this), s = !0), this.state = t;
    let l = i.plugins != t.plugins || this._props.plugins != n.plugins;
    if (l || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let p = ole(this);
      ikt(p, this.nodeViews) && (this.nodeViews = p, o = !0);
    }
    (l || n.handleDOMEvents != this._props.handleDOMEvents) && ZX(this), this.editable = ile(this), rle(this);
    let c = J6(this), a = nle(this), u = i.plugins != t.plugins && !i.doc.eq(t.doc) ? "reset" : t.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", f = o || !this.docView.matchesNode(t.doc, a, c);
    (f || !t.selection.eq(i.selection)) && (s = !0);
    let d = u == "preserve" && s && this.dom.style.overflowAnchor == null && REt(this);
    if (s) {
      this.domObserver.stop();
      let p = f && (vl || Yo) && !this.composing && !i.selection.empty && !t.selection.empty && rkt(i.selection, t.selection);
      if (f) {
        let h = Yo ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = RTt(this)), (o || !this.docView.update(t.doc, a, c, this)) && (this.docView.updateOuterDeco(a), this.docView.destroy(), this.docView = _ae(t.doc, a, c, this.dom, this)), h && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (p = !0);
      }
      p || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && nTt(this)) ? nh(this, p) : (vIe(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : d && MEt(d);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!(!t || !this.dom.contains(t.nodeType == 1 ? t : t.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof dn) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && Nae(this, n.getBoundingClientRect(), t);
      } else
        Nae(this, this.coordsAtPos(this.state.selection.head, 1), t);
    }
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let r = t.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let o = r.from + (this.state.doc.content.size - n.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == r.node && (i = o);
    }
    this.dragging = new RIe(t.slice, t.move, i < 0 ? void 0 : dn.create(this.state.doc, i));
  }
  someProp(t, n) {
    let r = this._props && this._props[t], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let l = this.directPlugins[s].props[t];
      if (l != null && (i = n ? n(l) : l))
        return i;
    }
    let o = this.state.plugins;
    if (o)
      for (let s = 0; s < o.length; s++) {
        let l = o[s].props[t];
        if (l != null && (i = n ? n(l) : l))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (vl) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && DEt(this.dom), nh(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return FEt(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return uIe(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, r = -1) {
    let i = this.docView.posFromDOM(t, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return XEt(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return nk(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return nk(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(t) {
    return fK(this, t);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (bTt(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], J6(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, wEt());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return ATt(this, t);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let t = this.domSelection();
    return t ? Cs && this.root.nodeType === 11 && kEt(this.dom.ownerDocument) == this.dom && HTt(this, t) || t : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
};
FIe.prototype.dispatch = function(e) {
  let t = this._props.dispatchTransaction;
  t ? t.call(this, e) : this.updateState(this.state.apply(e));
};
function nle(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let r in n)
        r == "class" ? t.class += " " + n[r] : r == "style" ? t.style = (t.style ? t.style + ";" : "") + n[r] : !t[r] && r != "contenteditable" && r != "nodeName" && (t[r] = String(n[r]));
  }), t.translate || (t.translate = "no"), [za.node(0, e.state.doc.content.size, t)];
}
function rle(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: za.widget(e.state.selection.from, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function ile(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function rkt(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function ole(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(t, i) || (t[i] = r[i]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function ikt(e, t) {
  let n = 0, r = 0;
  for (let i in e) {
    if (e[i] != t[i])
      return !0;
    n++;
  }
  for (let i in t)
    r++;
  return n != r;
}
function sle(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var ph = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, ik = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, okt = typeof navigator < "u" && /Mac/.test(navigator.platform), skt = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var vs = 0; vs < 10; vs++) ph[48 + vs] = ph[96 + vs] = String(vs);
for (var vs = 1; vs <= 24; vs++) ph[vs + 111] = "F" + vs;
for (var vs = 65; vs <= 90; vs++)
  ph[vs] = String.fromCharCode(vs + 32), ik[vs] = String.fromCharCode(vs);
for (var tU in ph) ik.hasOwnProperty(tU) || (ik[tU] = ph[tU]);
function UIe(e) {
  var t = okt && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || skt && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? ik : ph)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const akt = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), lkt = typeof navigator < "u" && /Win/.test(navigator.platform);
function ckt(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let r, i, o, s;
  for (let l = 0; l < t.length - 1; l++) {
    let c = t[l];
    if (/^(cmd|meta|m)$/i.test(c))
      s = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      akt ? s = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), s && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
function ukt(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[ckt(n)] = e[n];
  return t;
}
function nU(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function dkt(e) {
  return new $r({ props: { handleKeyDown: yK(e) } });
}
function yK(e) {
  let t = ukt(e);
  return function(n, r) {
    let i = UIe(r), o, s = t[nU(i, r)];
    if (s && s(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let l = t[nU(i, r, !1)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(lkt && r.ctrlKey && r.altKey) && (o = ph[r.keyCode]) && o != i) {
        let l = t[nU(o, r)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
var fkt = Object.defineProperty, vK = (e, t) => {
  for (var n in t)
    fkt(e, n, { get: t[n], enumerable: !0 });
};
function Nj(e) {
  const { state: t, transaction: n } = e;
  let { selection: r } = n, { doc: i } = n, { storedMarks: o } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return o;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, o = n.storedMarks, n;
    }
  };
}
var Pj = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: n } = this, { view: r } = t, { tr: i } = n, o = this.buildProps(i);
    return Object.fromEntries(
      Object.entries(e).map(([s, l]) => [s, (...a) => {
        const u = l(...a)(o);
        return !i.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(i), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: n, editor: r, state: i } = this, { view: o } = r, s = [], l = !!e, c = e || i.tr, a = () => (!l && t && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), s.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(n).map(([f, d]) => [f, (...h) => {
          const m = this.buildProps(c, t), v = d(...h)(m);
          return s.push(v), u;
        }])
      ),
      run: a
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: t, state: n } = this, r = !1, i = e || n.tr, o = this.buildProps(i, r);
    return {
      ...Object.fromEntries(
        Object.entries(t).map(([l, c]) => [l, (...a) => c(...a)({ ...o, dispatch: void 0 })])
      ),
      chain: () => this.createChain(i, r)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: n, editor: r, state: i } = this, { view: o } = r, s = {
      tr: e,
      editor: r,
      view: o,
      state: Nj({
        state: i,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(n).map(([l, c]) => [l, (...a) => c(...a)(s)])
        );
      }
    };
    return s;
  }
}, Tu = {};
vK(Tu, {
  blur: () => pkt,
  clearContent: () => hkt,
  clearNodes: () => mkt,
  command: () => gkt,
  createParagraphNear: () => ykt,
  cut: () => vkt,
  deleteCurrentNode: () => bkt,
  deleteNode: () => Okt,
  deleteRange: () => Akt,
  deleteSelection: () => wkt,
  enter: () => xkt,
  exitCode: () => Skt,
  extendMarkRange: () => Ekt,
  first: () => Tkt,
  focus: () => Ckt,
  forEach: () => Nkt,
  insertContent: () => Pkt,
  insertContentAt: () => Mkt,
  joinBackward: () => Lkt,
  joinDown: () => _kt,
  joinForward: () => zkt,
  joinItemBackward: () => jkt,
  joinItemForward: () => Fkt,
  joinTextblockBackward: () => Ukt,
  joinTextblockForward: () => Vkt,
  joinUp: () => Dkt,
  keyboardShortcut: () => Bkt,
  lift: () => Xkt,
  liftEmptyBlock: () => Wkt,
  liftListItem: () => Zkt,
  newlineInCode: () => Hkt,
  resetAttributes: () => Qkt,
  scrollIntoView: () => $kt,
  selectAll: () => Kkt,
  selectNodeBackward: () => Gkt,
  selectNodeForward: () => Ykt,
  selectParentNode: () => Jkt,
  selectTextblockEnd: () => eCt,
  selectTextblockStart: () => tCt,
  setContent: () => nCt,
  setMark: () => wCt,
  setMeta: () => xCt,
  setNode: () => SCt,
  setNodeSelection: () => ECt,
  setTextDirection: () => TCt,
  setTextSelection: () => kCt,
  sinkListItem: () => CCt,
  splitBlock: () => NCt,
  splitListItem: () => PCt,
  toggleList: () => ICt,
  toggleMark: () => RCt,
  toggleNode: () => MCt,
  toggleWrap: () => DCt,
  undoInputRule: () => _Ct,
  unsetAllMarks: () => LCt,
  unsetMark: () => zCt,
  unsetTextDirection: () => jCt,
  updateAttributes: () => FCt,
  wrapIn: () => UCt,
  wrapInList: () => VCt
});
var pkt = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) == null || n.removeAllRanges());
}), !0), hkt = (e = !0) => ({ commands: t }) => t.setContent("", { emitUpdate: e }), mkt = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: r } = t, { ranges: i } = r;
  return n && i.forEach(({ $from: o, $to: s }) => {
    e.doc.nodesBetween(o.pos, s.pos, (l, c) => {
      if (l.type.isText)
        return;
      const { doc: a, mapping: u } = t, f = a.resolve(u.map(c)), d = a.resolve(u.map(c + l.nodeSize)), p = f.blockRange(d);
      if (!p)
        return;
      const h = Sx(p);
      if (l.type.isTextblock) {
        const { defaultType: m } = f.parent.contentMatchAt(f.index());
        t.setNodeMarkup(p.start, m);
      }
      (h || h === 0) && t.lift(p, h);
    });
  }), !0;
}, gkt = (e) => (t) => e(t), ykt = () => ({ state: e, dispatch: t }) => JPe(e, t), vkt = (e, t) => ({ editor: n, tr: r }) => {
  const { state: i } = n, o = i.doc.slice(e.from, e.to);
  r.deleteRange(e.from, e.to);
  const s = r.mapping.map(t);
  return r.insert(s, o.content), r.setSelection(new pn(r.doc.resolve(Math.max(s - 1, 0)))), !0;
}, bkt = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = e.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === r.type) {
      if (t) {
        const l = i.before(o), c = i.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function bo(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
var Okt = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const i = bo(e, n.schema), o = t.selection.$anchor;
  for (let s = o.depth; s > 0; s -= 1)
    if (o.node(s).type === i) {
      if (r) {
        const c = o.before(s), a = o.after(s);
        t.delete(c, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Akt = (e) => ({ tr: t, dispatch: n }) => {
  const { from: r, to: i } = e;
  return n && t.delete(r, i), !0;
}, wkt = () => ({ state: e, dispatch: t }) => iK(e, t), xkt = () => ({ commands: e }) => e.keyboardShortcut("Enter"), Skt = () => ({ state: e, dispatch: t }) => aEt(e, t);
function bK(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function r_(e, t, n = { strict: !0 }) {
  const r = Object.keys(t);
  return r.length ? r.every((i) => n.strict ? t[i] === e[i] : bK(t[i]) ? t[i].test(e[i]) : t[i] === e[i]) : !0;
}
function VIe(e, t, n = {}) {
  return e.find((r) => r.type === t && r_(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((i) => [i, r.attrs[i]])),
    n
  ));
}
function ale(e, t, n = {}) {
  return !!VIe(e, t, n);
}
function OK(e, t, n) {
  var r;
  if (!e || !t)
    return;
  let i = e.parent.childAfter(e.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === t)) && (i = e.parent.childBefore(e.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === t) || (n = n || ((r = i.node.marks[0]) == null ? void 0 : r.attrs), !VIe([...i.node.marks], t, n)))
    return;
  let s = i.index, l = e.start() + i.offset, c = s + 1, a = l + i.node.nodeSize;
  for (; s > 0 && ale([...e.parent.child(s - 1).marks], t, n); )
    s -= 1, l -= e.parent.child(s).nodeSize;
  for (; c < e.parent.childCount && ale([...e.parent.child(c).marks], t, n); )
    a += e.parent.child(c).nodeSize, c += 1;
  return {
    from: l,
    to: a
  };
}
function Ch(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
var Ekt = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const o = Ch(e, r.schema), { doc: s, selection: l } = n, { $from: c, from: a, to: u } = l;
  if (i) {
    const f = OK(c, o, t);
    if (f && f.from <= a && f.to >= u) {
      const d = pn.create(s, f.from, f.to);
      n.setSelection(d);
    }
  }
  return !0;
}, Tkt = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](t))
      return !0;
  return !1;
};
function qIe(e) {
  return e instanceof pn;
}
function Py(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function BIe(e, t = null) {
  if (!t)
    return null;
  const n = En.atStart(e), r = En.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return r;
  const i = n.from, o = r.to;
  return t === "all" ? pn.create(e, Py(0, i, o), Py(e.content.size, i, o)) : pn.create(e, Py(t, i, o), Py(t, i, o));
}
function lle() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function i_() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function kkt() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var Ckt = (e = null, t = {}) => ({ editor: n, view: r, tr: i, dispatch: o }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const s = () => {
    (i_() || lle()) && r.dom.focus(), kkt() && !i_() && !lle() && r.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && e === null || e === !1)
    return !0;
  if (o && e === null && !qIe(n.state.selection))
    return s(), !0;
  const l = BIe(i.doc, e) || n.state.selection, c = n.state.selection.eq(l);
  return o && (c || i.setSelection(l), c && i.storedMarks && i.setStoredMarks(i.storedMarks), s()), !0;
}, Nkt = (e, t) => (n) => e.every((r, i) => t(r, { ...n, index: i })), Pkt = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), XIe = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && XIe(r);
  }
  return e;
};
function f1(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return XIe(n);
}
function ok(e, t, n) {
  if (e instanceof Wm || e instanceof at)
    return e;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof e == "object" && e !== null, i = typeof e == "string";
  if (r)
    try {
      if (Array.isArray(e) && e.length > 0)
        return at.fromArray(e.map((l) => t.nodeFromJSON(l)));
      const s = t.nodeFromJSON(e);
      return n.errorOnInvalidContent && s.check(), s;
    } catch (o) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", o), ok("", t, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let s = !1, l = "";
      const c = new TPe({
        topNode: t.spec.topNode,
        marks: t.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: t.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (a) => (s = !0, l = typeof a == "string" ? a : a.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? eh.fromSchema(c).parseSlice(f1(e), n.parseOptions) : eh.fromSchema(c).parse(f1(e), n.parseOptions), n.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${l}`)
        });
    }
    const o = eh.fromSchema(t);
    return n.slice ? o.parseSlice(f1(e), n.parseOptions).content : o.parse(f1(e), n.parseOptions);
  }
  return ok("", t, n);
}
function Ikt(e, t, n) {
  const r = e.steps.length - 1;
  if (r < t)
    return;
  const i = e.steps[r];
  if (!(i instanceof Qo || i instanceof ts))
    return;
  const o = e.mapping.maps[r];
  let s = 0;
  o.forEach((l, c, a, u) => {
    s === 0 && (s = u);
  }), e.setSelection(En.near(e.doc.resolve(s), n));
}
var Rkt = (e) => !("type" in e), Mkt = (e, t, n) => ({ tr: r, dispatch: i, editor: o }) => {
  var s;
  if (i) {
    n = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let l;
    const c = (v) => {
      o.emit("contentError", {
        editor: o,
        error: v,
        disableCollaboration: () => {
          "collaboration" in o.storage && typeof o.storage.collaboration == "object" && o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      });
    }, a = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !o.options.enableContentCheck && o.options.emitContentError)
      try {
        ok(t, o.schema, {
          parseOptions: a,
          errorOnInvalidContent: !0
        });
      } catch (v) {
        c(v);
      }
    try {
      l = ok(t, o.schema, {
        parseOptions: a,
        errorOnInvalidContent: (s = n.errorOnInvalidContent) != null ? s : o.options.enableContentCheck
      });
    } catch (v) {
      return c(v), !1;
    }
    let { from: u, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, d = !0, p = !0;
    if ((Rkt(l) ? l : [l]).forEach((v) => {
      v.check(), d = d ? v.isText && v.marks.length === 0 : !1, p = p ? v.isBlock : !1;
    }), u === f && p) {
      const { parent: v } = r.doc.resolve(u);
      v.isTextblock && !v.type.spec.code && !v.childCount && (u -= 1, f += 1);
    }
    let m;
    if (d) {
      if (Array.isArray(t))
        m = t.map((v) => v.text || "").join("");
      else if (t instanceof at) {
        let v = "";
        t.forEach((b) => {
          b.text && (v += b.text);
        }), m = v;
      } else typeof t == "object" && t && t.text ? m = t.text : m = t;
      r.insertText(m, u, f);
    } else {
      m = l;
      const v = r.doc.resolve(u), b = v.node(), A = v.parentOffset === 0, w = b.isText || b.isTextblock, O = b.content.size > 0;
      A && w && O && (u = Math.max(0, u - 1)), r.replaceWith(u, f, m);
    }
    n.updateSelection && Ikt(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: u, text: m }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: u, text: m });
  }
  return !0;
}, Dkt = () => ({ state: e, dispatch: t }) => iEt(e, t), _kt = () => ({ state: e, dispatch: t }) => oEt(e, t), Lkt = () => ({ state: e, dispatch: t }) => ZPe(e, t), zkt = () => ({ state: e, dispatch: t }) => KPe(e, t), jkt = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = xj(e.doc, e.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, Fkt = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = xj(e.doc, e.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, Ukt = () => ({ state: e, dispatch: t }) => nEt(e, t), Vkt = () => ({ state: e, dispatch: t }) => rEt(e, t);
function WIe() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function qkt(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let r, i, o, s;
  for (let l = 0; l < t.length - 1; l += 1) {
    const c = t[l];
    if (/^(cmd|meta|m)$/i.test(c))
      s = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      i_() || WIe() ? s = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${c}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), o && (n = `Shift-${n}`), n;
}
var Bkt = (e) => ({ editor: t, view: n, tr: r, dispatch: i }) => {
  const o = qkt(e).split(/-(?!$)/), s = o.find((a) => !["Alt", "Ctrl", "Meta", "Shift"].includes(a)), l = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), c = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (a) => a(n, l));
  });
  return c == null || c.steps.forEach((a) => {
    const u = a.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function og(e, t, n = {}) {
  const { from: r, to: i, empty: o } = e.selection, s = t ? bo(t, e.schema) : null, l = [];
  e.doc.nodesBetween(r, i, (f, d) => {
    if (f.isText)
      return;
    const p = Math.max(r, d), h = Math.min(i, d + f.nodeSize);
    l.push({
      node: f,
      from: p,
      to: h
    });
  });
  const c = i - r, a = l.filter((f) => s ? s.name === f.node.type.name : !0).filter((f) => r_(f.node.attrs, n, { strict: !1 }));
  return o ? !!a.length : a.reduce((f, d) => f + d.to - d.from, 0) >= c;
}
var Xkt = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = bo(e, n.schema);
  return og(n, i, t) ? sEt(n, r) : !1;
}, Wkt = () => ({ state: e, dispatch: t }) => eIe(e, t), Zkt = (e) => ({ state: t, dispatch: n }) => {
  const r = bo(e, t.schema);
  return vEt(r)(t, n);
}, Hkt = () => ({ state: e, dispatch: t }) => YPe(e, t);
function Ij(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function cle(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((r, i) => (n.includes(i) || (r[i] = e[i]), r), {});
}
var Qkt = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const l = Ij(
    typeof e == "string" ? e : e.name,
    r.schema
  );
  if (!l)
    return !1;
  l === "node" && (o = bo(e, r.schema)), l === "mark" && (s = Ch(e, r.schema));
  let c = !1;
  return n.selection.ranges.forEach((a) => {
    r.doc.nodesBetween(a.$from.pos, a.$to.pos, (u, f) => {
      o && o === u.type && (c = !0, i && n.setNodeMarkup(f, void 0, cle(u.attrs, t))), s && u.marks.length && u.marks.forEach((d) => {
        s === d.type && (c = !0, i && n.addMark(f, f + u.nodeSize, s.create(cle(d.attrs, t))));
      });
    });
  }), c;
}, $kt = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), Kkt = () => ({ tr: e, dispatch: t }) => {
  if (t) {
    const n = new oc(e.doc);
    e.setSelection(n);
  }
  return !0;
}, Gkt = () => ({ state: e, dispatch: t }) => QPe(e, t), Ykt = () => ({ state: e, dispatch: t }) => GPe(e, t), Jkt = () => ({ state: e, dispatch: t }) => uEt(e, t), eCt = () => ({ state: e, dispatch: t }) => pEt(e, t), tCt = () => ({ state: e, dispatch: t }) => fEt(e, t);
function HX(e, t, n = {}, r = {}) {
  return ok(e, t, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
var nCt = (e, { errorOnInvalidContent: t, emitUpdate: n = !0, parseOptions: r = {} } = {}) => ({ editor: i, tr: o, dispatch: s, commands: l }) => {
  const { doc: c } = o;
  if (r.preserveWhitespace !== "full") {
    const a = HX(e, i.schema, r, {
      errorOnInvalidContent: t ?? i.options.enableContentCheck
    });
    return s && o.replaceWith(0, c.content.size, a).setMeta("preventUpdate", !n), !0;
  }
  return s && o.setMeta("preventUpdate", !n), l.insertContentAt({ from: 0, to: c.content.size }, e, {
    parseOptions: r,
    errorOnInvalidContent: t ?? i.options.enableContentCheck
  });
};
function ZIe(e, t) {
  const n = Ch(t, e.schema), { from: r, to: i, empty: o } = e.selection, s = [];
  o ? (e.storedMarks && s.push(...e.storedMarks), s.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, i, (c) => {
    s.push(...c.marks);
  });
  const l = s.find((c) => c.type.name === n.name);
  return l ? { ...l.attrs } : {};
}
function HIe(e, t) {
  const n = new nK(e);
  return t.forEach((r) => {
    r.steps.forEach((i) => {
      n.step(i);
    });
  }), n;
}
function rCt(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function iCt(e, t, n) {
  const r = [];
  return e.nodesBetween(t.from, t.to, (i, o) => {
    n(i) && r.push({
      node: i,
      pos: o
    });
  }), r;
}
function QIe(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const r = e.node(n);
    if (t(r))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
  }
}
function Rj(e) {
  return (t) => QIe(t.$from, e);
}
function on(e, t, n) {
  return e.config[t] === void 0 && e.parent ? on(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? on(e.parent, t, n) : null
  }) : e.config[t];
}
function Mj(e) {
  return e.map((t) => {
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    }, r = on(t, "addExtensions", n);
    return r ? [t, ...Mj(r())] : t;
  }).flat(10);
}
function AK(e, t) {
  const n = Pb.fromSchema(t).serializeFragment(e), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
function $Ie(e) {
  return typeof e == "function";
}
function Nr(e, t = void 0, ...n) {
  return $Ie(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function oCt(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function yw(e) {
  const t = e.filter((i) => i.type === "extension"), n = e.filter((i) => i.type === "node"), r = e.filter((i) => i.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: r
  };
}
function KIe(e) {
  const t = [], { nodeExtensions: n, markExtensions: r } = yw(e), i = [...n, ...r], o = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((s) => {
    const l = {
      name: s.name,
      options: s.options,
      storage: s.storage,
      extensions: i
    }, c = on(
      s,
      "addGlobalAttributes",
      l
    );
    if (!c)
      return;
    c().forEach((u) => {
      u.types.forEach((f) => {
        Object.entries(u.attributes).forEach(([d, p]) => {
          t.push({
            type: f,
            name: d,
            attribute: {
              ...o,
              ...p
            }
          });
        });
      });
    });
  }), i.forEach((s) => {
    const l = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, c = on(
      s,
      "addAttributes",
      l
    );
    if (!c)
      return;
    const a = c();
    Object.entries(a).forEach(([u, f]) => {
      const d = {
        ...o,
        ...f
      };
      typeof (d == null ? void 0 : d.default) == "function" && (d.default = d.default()), d != null && d.isRequired && (d == null ? void 0 : d.default) === void 0 && delete d.default, t.push({
        type: s.name,
        name: u,
        attribute: d
      });
    });
  }), t;
}
function Ir(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const r = { ...t };
    return Object.entries(n).forEach(([i, o]) => {
      if (!r[i]) {
        r[i] = o;
        return;
      }
      if (i === "class") {
        const l = o ? String(o).split(" ") : [], c = r[i] ? r[i].split(" ") : [], a = l.filter((u) => !c.includes(u));
        r[i] = [...c, ...a].join(" ");
      } else if (i === "style") {
        const l = o ? o.split(";").map((u) => u.trim()).filter(Boolean) : [], c = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], a = /* @__PURE__ */ new Map();
        c.forEach((u) => {
          const [f, d] = u.split(":").map((p) => p.trim());
          a.set(f, d);
        }), l.forEach((u) => {
          const [f, d] = u.split(":").map((p) => p.trim());
          a.set(f, d);
        }), r[i] = Array.from(a.entries()).map(([u, f]) => `${u}: ${f}`).join("; ");
      } else
        r[i] = o;
    }), r;
  }, {});
}
function sk(e, t) {
  return t.filter((n) => n.type === e.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, r) => Ir(n, r), {});
}
function sCt(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function ule(e, t) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (n) => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (r === !1)
        return !1;
      const i = t.reduce((o, s) => {
        const l = s.attribute.parseHTML ? s.attribute.parseHTML(n) : sCt(n.getAttribute(s.name));
        return l == null ? o : {
          ...o,
          [s.name]: l
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function dle(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && oCt(n) ? !1 : n != null)
  );
}
function fle(e) {
  var t, n;
  const r = {};
  return !((t = e == null ? void 0 : e.attribute) != null && t.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (r.default = e.attribute.default), ((n = e == null ? void 0 : e.attribute) == null ? void 0 : n.validate) !== void 0 && (r.validate = e.attribute.validate), [e.name, r];
}
function GIe(e, t) {
  var n;
  const r = KIe(e), { nodeExtensions: i, markExtensions: o } = yw(e), s = (n = i.find((a) => on(a, "topNode"))) == null ? void 0 : n.name, l = Object.fromEntries(
    i.map((a) => {
      const u = r.filter((b) => b.type === a.name), f = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: t
      }, d = e.reduce((b, A) => {
        const w = on(A, "extendNodeSchema", f);
        return {
          ...b,
          ...w ? w(a) : {}
        };
      }, {}), p = dle({
        ...d,
        content: Nr(on(a, "content", f)),
        marks: Nr(on(a, "marks", f)),
        group: Nr(on(a, "group", f)),
        inline: Nr(on(a, "inline", f)),
        atom: Nr(on(a, "atom", f)),
        selectable: Nr(on(a, "selectable", f)),
        draggable: Nr(on(a, "draggable", f)),
        code: Nr(on(a, "code", f)),
        whitespace: Nr(on(a, "whitespace", f)),
        linebreakReplacement: Nr(
          on(a, "linebreakReplacement", f)
        ),
        defining: Nr(on(a, "defining", f)),
        isolating: Nr(on(a, "isolating", f)),
        attrs: Object.fromEntries(u.map(fle))
      }), h = Nr(on(a, "parseHTML", f));
      h && (p.parseDOM = h.map(
        (b) => ule(b, u)
      ));
      const m = on(a, "renderHTML", f);
      m && (p.toDOM = (b) => m({
        node: b,
        HTMLAttributes: sk(b, u)
      }));
      const v = on(a, "renderText", f);
      return v && (p.toText = v), [a.name, p];
    })
  ), c = Object.fromEntries(
    o.map((a) => {
      const u = r.filter((v) => v.type === a.name), f = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: t
      }, d = e.reduce((v, b) => {
        const A = on(b, "extendMarkSchema", f);
        return {
          ...v,
          ...A ? A(a) : {}
        };
      }, {}), p = dle({
        ...d,
        inclusive: Nr(on(a, "inclusive", f)),
        excludes: Nr(on(a, "excludes", f)),
        group: Nr(on(a, "group", f)),
        spanning: Nr(on(a, "spanning", f)),
        code: Nr(on(a, "code", f)),
        attrs: Object.fromEntries(u.map(fle))
      }), h = Nr(on(a, "parseHTML", f));
      h && (p.parseDOM = h.map(
        (v) => ule(v, u)
      ));
      const m = on(a, "renderHTML", f);
      return m && (p.toDOM = (v) => m({
        mark: v,
        HTMLAttributes: sk(v, u)
      })), [a.name, p];
    })
  );
  return new TPe({
    topNode: s,
    nodes: l,
    marks: c
  });
}
function aCt(e) {
  const t = e.filter((n, r) => e.indexOf(n) !== r);
  return Array.from(new Set(t));
}
function o_(e) {
  return e.sort((n, r) => {
    const i = on(n, "priority") || 100, o = on(r, "priority") || 100;
    return i > o ? -1 : i < o ? 1 : 0;
  });
}
function wK(e) {
  const t = o_(Mj(e)), n = aCt(t.map((r) => r.name));
  return n.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${n.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`
  ), t;
}
function lCt(e, t) {
  const n = wK(e);
  return GIe(n, t);
}
function cCt(e, t) {
  const n = lCt(t), r = f1(e);
  return eh.fromSchema(n).parse(r).toJSON();
}
function YIe(e, t, n) {
  const { from: r, to: i } = t, { blockSeparator: o = `

`, textSerializers: s = {} } = n || {};
  let l = "";
  return e.nodesBetween(r, i, (c, a, u, f) => {
    var d;
    c.isBlock && a > r && (l += o);
    const p = s == null ? void 0 : s[c.type.name];
    if (p)
      return u && (l += p({
        node: c,
        pos: a,
        parent: u,
        index: f,
        range: t
      })), !1;
    c.isText && (l += (d = c == null ? void 0 : c.text) == null ? void 0 : d.slice(Math.max(r, a) - a, i - a));
  }), l;
}
function uCt(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return YIe(e, n, t);
}
function JIe(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText])
  );
}
function dCt(e, t) {
  const n = bo(t, e.schema), { from: r, to: i } = e.selection, o = [];
  e.doc.nodesBetween(r, i, (l) => {
    o.push(l);
  });
  const s = o.reverse().find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function eRe(e, t) {
  const n = Ij(
    typeof t == "string" ? t : t.name,
    e.schema
  );
  return n === "node" ? dCt(e, t) : n === "mark" ? ZIe(e, t) : {};
}
function fCt(e, t = JSON.stringify) {
  const n = {};
  return e.filter((r) => {
    const i = t(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : n[i] = !0;
  });
}
function pCt(e) {
  const t = fCt(e);
  return t.length === 1 ? t : t.filter((n, r) => !t.filter((o, s) => s !== r).some((o) => n.oldRange.from >= o.oldRange.from && n.oldRange.to <= o.oldRange.to && n.newRange.from >= o.newRange.from && n.newRange.to <= o.newRange.to));
}
function tRe(e) {
  const { mapping: t, steps: n } = e, r = [];
  return t.maps.forEach((i, o) => {
    const s = [];
    if (i.ranges.length)
      i.forEach((l, c) => {
        s.push({ from: l, to: c });
      });
    else {
      const { from: l, to: c } = n[o];
      if (l === void 0 || c === void 0)
        return;
      s.push({ from: l, to: c });
    }
    s.forEach(({ from: l, to: c }) => {
      const a = t.slice(o).map(l, -1), u = t.slice(o).map(c), f = t.invert().map(a, -1), d = t.invert().map(u);
      r.push({
        oldRange: {
          from: f,
          to: d
        },
        newRange: {
          from: a,
          to: u
        }
      });
    });
  }), pCt(r);
}
function xK(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach((i) => {
    const o = n.resolve(e), s = OK(o, i.type);
    s && r.push({
      mark: i,
      ...s
    });
  }) : n.nodesBetween(e, t, (i, o) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(
      ...i.marks.map((s) => ({
        from: o,
        to: o + i.nodeSize,
        mark: s
      }))
    );
  }), r;
}
var hCt = (e, t, n, r = 20) => {
  const i = e.doc.resolve(n);
  let o = r, s = null;
  for (; o > 0 && s === null; ) {
    const l = i.node(o);
    (l == null ? void 0 : l.type.name) === t ? s = l : o -= 1;
  }
  return [s, o];
};
function JP(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function JR(e, t, n) {
  return Object.fromEntries(
    Object.entries(n).filter(([r]) => {
      const i = e.find((o) => o.type === t && o.name === r);
      return i ? i.attribute.keepOnSplit : !1;
    })
  );
}
var mCt = (e, t = 500) => {
  let n = "";
  const r = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, r - t), r, (i, o, s, l) => {
    var c, a;
    const u = ((a = (c = i.type.spec).toText) == null ? void 0 : a.call(c, {
      node: i,
      pos: o,
      parent: s,
      index: l
    })) || i.textContent || "%leaf%";
    n += i.isAtom && !i.isText ? u : u.slice(0, Math.max(0, r - o));
  }), n;
};
function QX(e, t, n = {}) {
  const { empty: r, ranges: i } = e.selection, o = t ? Ch(t, e.schema) : null;
  if (r)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => o ? o.name === f.type.name : !0).find((f) => r_(f.attrs, n, { strict: !1 }));
  let s = 0;
  const l = [];
  if (i.forEach(({ $from: f, $to: d }) => {
    const p = f.pos, h = d.pos;
    e.doc.nodesBetween(p, h, (m, v) => {
      if (!m.isText && !m.marks.length)
        return;
      const b = Math.max(p, v), A = Math.min(h, v + m.nodeSize), w = A - b;
      s += w, l.push(
        ...m.marks.map((O) => ({
          mark: O,
          from: b,
          to: A
        }))
      );
    });
  }), s === 0)
    return !1;
  const c = l.filter((f) => o ? o.name === f.mark.type.name : !0).filter((f) => r_(f.mark.attrs, n, { strict: !1 })).reduce((f, d) => f + d.to - d.from, 0), a = l.filter((f) => o ? f.mark.type !== o && f.mark.type.excludes(o) : !0).reduce((f, d) => f + d.to - d.from, 0);
  return (c > 0 ? c + a : c) >= s;
}
function gCt(e, t, n = {}) {
  if (!t)
    return og(e, null, n) || QX(e, null, n);
  const r = Ij(t, e.schema);
  return r === "node" ? og(e, t, n) : r === "mark" ? QX(e, t, n) : !1;
}
var yCt = (e, t) => {
  const { $from: n, $to: r, $anchor: i } = e.selection;
  if (t) {
    const o = Rj((l) => l.type.name === t)(e.selection);
    if (!o)
      return !1;
    const s = e.doc.resolve(o.pos + 1);
    return i.pos + 1 === s.end();
  }
  return !(r.parentOffset < r.parent.nodeSize - 2 || n.pos !== r.pos);
}, vCt = (e) => {
  const { $from: t, $to: n } = e.selection;
  return !(t.parentOffset > 0 || t.pos !== n.pos);
};
function ple(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
function hle(e, t) {
  const { nodeExtensions: n } = yw(t), r = n.find((s) => s.name === e);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, o = Nr(on(r, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function bN(e, {
  checkChildren: t = !0,
  ignoreWhitespace: n = !1
} = {}) {
  var r;
  if (n) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return /^\s*$/m.test((r = e.text) != null ? r : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (t) {
    let i = !0;
    return e.content.forEach((o) => {
      i !== !1 && (bN(o, { ignoreWhitespace: n, checkChildren: t }) || (i = !1));
    }), i;
  }
  return !1;
}
function nRe(e) {
  return e instanceof dn;
}
var rRe = class iRe {
  constructor(t) {
    this.position = t;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(t) {
    return new iRe(t.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function bCt(e, t) {
  const n = t.mapping.mapResult(e.position);
  return {
    position: new rRe(n.pos),
    mapResult: n
  };
}
function OCt(e) {
  return new rRe(e);
}
function ACt(e, t, n) {
  var r;
  const { selection: i } = t;
  let o = null;
  if (qIe(i) && (o = i.$cursor), o) {
    const l = (r = e.storedMarks) != null ? r : o.marks();
    return o.parent.type.allowsMarkType(n) && (!!n.isInSet(l) || !l.some((a) => a.type.excludes(n)));
  }
  const { ranges: s } = i;
  return s.some(({ $from: l, $to: c }) => {
    let a = l.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(l.pos, c.pos, (u, f, d) => {
      if (a)
        return !1;
      if (u.isInline) {
        const p = !d || d.type.allowsMarkType(n), h = !!n.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(n));
        a = p && h;
      }
      return !a;
    }), a;
  });
}
var wCt = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = n, { empty: s, ranges: l } = o, c = Ch(e, r.schema);
  if (i)
    if (s) {
      const a = ZIe(r, c);
      n.addStoredMark(
        c.create({
          ...a,
          ...t
        })
      );
    } else
      l.forEach((a) => {
        const u = a.$from.pos, f = a.$to.pos;
        r.doc.nodesBetween(u, f, (d, p) => {
          const h = Math.max(p, u), m = Math.min(p + d.nodeSize, f);
          d.marks.find((b) => b.type === c) ? d.marks.forEach((b) => {
            c === b.type && n.addMark(
              h,
              m,
              c.create({
                ...b.attrs,
                ...t
              })
            );
          }) : n.addMark(h, m, c.create(t));
        });
      });
  return ACt(r, n, c);
}, xCt = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), SCt = (e, t = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const o = bo(e, n.schema);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), o.isTextblock ? i().command(({ commands: l }) => Tae(o, { ...s, ...t })(n) ? !0 : l.clearNodes()).command(({ state: l }) => Tae(o, { ...s, ...t })(l, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, ECt = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, i = Py(e, 0, r.content.size), o = dn.create(r, i);
    t.setSelection(o);
  }
  return !0;
}, TCt = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = r;
  let s, l;
  return typeof t == "number" ? (s = t, l = t) : t && "from" in t && "to" in t ? (s = t.from, l = t.to) : (s = o.from, l = o.to), i && n.doc.nodesBetween(s, l, (c, a) => {
    c.isText || n.setNodeMarkup(a, void 0, {
      ...c.attrs,
      dir: e
    });
  }), !0;
}, kCt = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, { from: i, to: o } = typeof e == "number" ? { from: e, to: e } : e, s = pn.atStart(r).from, l = pn.atEnd(r).to, c = Py(i, s, l), a = Py(o, s, l), u = pn.create(r, c, a);
    t.setSelection(u);
  }
  return !0;
}, CCt = (e) => ({ state: t, dispatch: n }) => {
  const r = bo(e, t.schema);
  return AEt(r)(t, n);
};
function mle(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => t == null ? void 0 : t.includes(i.type.name));
    e.tr.ensureMarks(r);
  }
}
var NCt = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: i }) => {
  const { selection: o, doc: s } = t, { $from: l, $to: c } = o, a = i.extensionManager.attributes, u = JR(a, l.node().type.name, l.node().attrs);
  if (o instanceof dn && o.node.isBlock)
    return !l.parentOffset || !th(s, l.pos) ? !1 : (r && (e && mle(n, i.extensionManager.splittableMarks), t.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  const f = c.parentOffset === c.parent.content.size, d = l.depth === 0 ? void 0 : rCt(l.node(-1).contentMatchAt(l.indexAfter(-1)));
  let p = f && d ? [
    {
      type: d,
      attrs: u
    }
  ] : void 0, h = th(t.doc, t.mapping.map(l.pos), 1, p);
  if (!p && !h && th(t.doc, t.mapping.map(l.pos), 1, d ? [{ type: d }] : void 0) && (h = !0, p = d ? [
    {
      type: d,
      attrs: u
    }
  ] : void 0), r) {
    if (h && (o instanceof pn && t.deleteSelection(), t.split(t.mapping.map(l.pos), 1, p), d && !f && !l.parentOffset && l.parent.type !== d)) {
      const m = t.mapping.map(l.before()), v = t.doc.resolve(m);
      l.node(-1).canReplaceWith(v.index(), v.index() + 1, d) && t.setNodeMarkup(t.mapping.map(l.before()), d);
    }
    e && mle(n, i.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return h;
}, PCt = (e, t = {}) => ({ tr: n, state: r, dispatch: i, editor: o }) => {
  var s;
  const l = bo(e, r.schema), { $from: c, $to: a } = r.selection, u = r.selection.node;
  if (u && u.isBlock || c.depth < 2 || !c.sameParent(a))
    return !1;
  const f = c.node(-1);
  if (f.type !== l)
    return !1;
  const d = o.extensionManager.attributes;
  if (c.parent.content.size === 0 && c.node(-1).childCount === c.indexAfter(-1)) {
    if (c.depth === 2 || c.node(-3).type !== l || c.index(-2) !== c.node(-2).childCount - 1)
      return !1;
    if (i) {
      let b = at.empty;
      const A = c.index(-1) ? 1 : c.index(-2) ? 2 : 3;
      for (let k = c.depth - A; k >= c.depth - 3; k -= 1)
        b = at.from(c.node(k).copy(b));
      const w = (
        // eslint-disable-next-line no-nested-ternary
        c.indexAfter(-1) < c.node(-2).childCount ? 1 : c.indexAfter(-2) < c.node(-3).childCount ? 2 : 3
      ), O = {
        ...JR(d, c.node().type.name, c.node().attrs),
        ...t
      }, x = ((s = l.contentMatch.defaultType) == null ? void 0 : s.createAndFill(O)) || void 0;
      b = b.append(at.from(l.createAndFill(null, x) || void 0));
      const S = c.before(c.depth - (A - 1));
      n.replace(S, c.after(-w), new zt(b, 4 - A, 0));
      let E = -1;
      n.doc.nodesBetween(S, n.doc.content.size, (k, T) => {
        if (E > -1)
          return !1;
        k.isTextblock && k.content.size === 0 && (E = T + 1);
      }), E > -1 && n.setSelection(pn.near(n.doc.resolve(E))), n.scrollIntoView();
    }
    return !0;
  }
  const p = a.pos === c.end() ? f.contentMatchAt(0).defaultType : null, h = {
    ...JR(d, f.type.name, f.attrs),
    ...t
  }, m = {
    ...JR(d, c.node().type.name, c.node().attrs),
    ...t
  };
  n.delete(c.pos, a.pos);
  const v = p ? [
    { type: l, attrs: h },
    { type: p, attrs: m }
  ] : [{ type: l, attrs: h }];
  if (!th(n.doc, c.pos, 2))
    return !1;
  if (i) {
    const { selection: b, storedMarks: A } = r, { splittableMarks: w } = o.extensionManager, O = A || b.$to.parentOffset && b.$from.marks();
    if (n.split(c.pos, 2, v).scrollIntoView(), !O || !i)
      return !0;
    const x = O.filter((S) => w.includes(S.type.name));
    n.ensureMarks(x);
  }
  return !0;
}, rU = (e, t) => {
  const n = Rj((s) => s.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && Rg(e.doc, n.pos) && e.join(n.pos), !0;
}, iU = (e, t) => {
  const n = Rj((s) => s.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && Rg(e.doc, r) && e.join(r), !0;
}, ICt = (e, t, n, r = {}) => ({ editor: i, tr: o, state: s, dispatch: l, chain: c, commands: a, can: u }) => {
  const { extensions: f, splittableMarks: d } = i.extensionManager, p = bo(e, s.schema), h = bo(t, s.schema), { selection: m, storedMarks: v } = s, { $from: b, $to: A } = m, w = b.blockRange(A), O = v || m.$to.parentOffset && m.$from.marks();
  if (!w)
    return !1;
  const x = Rj((S) => hle(S.type.name, f))(m);
  if (w.depth >= 1 && x && w.depth - x.depth <= 1) {
    if (x.node.type === p)
      return a.liftListItem(h);
    if (hle(x.node.type.name, f) && p.validContent(x.node.content) && l)
      return c().command(() => (o.setNodeMarkup(x.pos, p), !0)).command(() => rU(o, p)).command(() => iU(o, p)).run();
  }
  return !n || !O || !l ? c().command(() => u().wrapInList(p, r) ? !0 : a.clearNodes()).wrapInList(p, r).command(() => rU(o, p)).command(() => iU(o, p)).run() : c().command(() => {
    const S = u().wrapInList(p, r), E = O.filter((k) => d.includes(k.type.name));
    return o.ensureMarks(E), S ? !0 : a.clearNodes();
  }).wrapInList(p, r).command(() => rU(o, p)).command(() => iU(o, p)).run();
}, RCt = (e, t = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = n, s = Ch(e, r.schema);
  return QX(r, s, t) ? i.unsetMark(s, { extendEmptyMarkRange: o }) : i.setMark(s, t);
}, MCt = (e, t, n = {}) => ({ state: r, commands: i }) => {
  const o = bo(e, r.schema), s = bo(t, r.schema), l = og(r, o, n);
  let c;
  return r.selection.$anchor.sameParent(r.selection.$head) && (c = r.selection.$anchor.parent.attrs), l ? i.setNode(s, c) : i.setNode(o, { ...c, ...n });
}, DCt = (e, t = {}) => ({ state: n, commands: r }) => {
  const i = bo(e, n.schema);
  return og(n, i, t) ? r.lift(i) : r.wrapIn(i, t);
}, _Ct = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let o;
    if (i.spec.isInputRules && (o = i.getState(e))) {
      if (t) {
        const s = e.tr, l = o.transform;
        for (let c = l.steps.length - 1; c >= 0; c -= 1)
          s.step(l.steps[c].invert(l.docs[c]));
        if (o.text) {
          const c = s.doc.resolve(o.from).marks();
          s.replaceWith(o.from, o.to, e.schema.text(o.text, c));
        } else
          s.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, LCt = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: r, ranges: i } = n;
  return r || t && i.forEach((o) => {
    e.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, zCt = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: s = !1 } = t, { selection: l } = n, c = Ch(e, r.schema), { $from: a, empty: u, ranges: f } = l;
  if (!i)
    return !0;
  if (u && s) {
    let { from: d, to: p } = l;
    const h = (o = a.marks().find((v) => v.type === c)) == null ? void 0 : o.attrs, m = OK(a, c, h);
    m && (d = m.from, p = m.to), n.removeMark(d, p, c);
  } else
    f.forEach((d) => {
      n.removeMark(d.$from.pos, d.$to.pos, c);
    });
  return n.removeStoredMark(c), !0;
}, jCt = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const { selection: i } = n;
  let o, s;
  return typeof e == "number" ? (o = e, s = e) : e && "from" in e && "to" in e ? (o = e.from, s = e.to) : (o = i.from, s = i.to), r && t.doc.nodesBetween(o, s, (l, c) => {
    if (l.isText)
      return;
    const a = { ...l.attrs };
    delete a.dir, t.setNodeMarkup(c, void 0, a);
  }), !0;
}, FCt = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, s = null;
  const l = Ij(
    typeof e == "string" ? e : e.name,
    r.schema
  );
  if (!l)
    return !1;
  l === "node" && (o = bo(e, r.schema)), l === "mark" && (s = Ch(e, r.schema));
  let c = !1;
  return n.selection.ranges.forEach((a) => {
    const u = a.$from.pos, f = a.$to.pos;
    let d, p, h, m;
    n.selection.empty ? r.doc.nodesBetween(u, f, (v, b) => {
      o && o === v.type && (c = !0, h = Math.max(b, u), m = Math.min(b + v.nodeSize, f), d = b, p = v);
    }) : r.doc.nodesBetween(u, f, (v, b) => {
      b < u && o && o === v.type && (c = !0, h = Math.max(b, u), m = Math.min(b + v.nodeSize, f), d = b, p = v), b >= u && b <= f && (o && o === v.type && (c = !0, i && n.setNodeMarkup(b, void 0, {
        ...v.attrs,
        ...t
      })), s && v.marks.length && v.marks.forEach((A) => {
        if (s === A.type && (c = !0, i)) {
          const w = Math.max(b, u), O = Math.min(b + v.nodeSize, f);
          n.addMark(
            w,
            O,
            s.create({
              ...A.attrs,
              ...t
            })
          );
        }
      }));
    }), p && (d !== void 0 && i && n.setNodeMarkup(d, void 0, {
      ...p.attrs,
      ...t
    }), s && p.marks.length && p.marks.forEach((v) => {
      s === v.type && i && n.addMark(
        h,
        m,
        s.create({
          ...v.attrs,
          ...t
        })
      );
    }));
  }), c;
}, UCt = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = bo(e, n.schema);
  return hEt(i, t)(n, r);
}, VCt = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = bo(e, n.schema);
  return mEt(i, t)(n, r);
}, qCt = class {
  constructor() {
    this.callbacks = {};
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), this;
  }
  emit(t, ...n) {
    const r = this.callbacks[t];
    return r && r.forEach((i) => i.apply(this, n)), this;
  }
  off(t, n) {
    const r = this.callbacks[t];
    return r && (n ? this.callbacks[t] = r.filter((i) => i !== n) : delete this.callbacks[t]), this;
  }
  once(t, n) {
    const r = (...i) => {
      this.off(t, r), n.apply(this, i);
    };
    return this.on(t, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, Dj = class {
  constructor(e) {
    var t;
    this.find = e.find, this.handler = e.handler, this.undoable = (t = e.undoable) != null ? t : !0;
  }
}, BCt = (e, t) => {
  if (bK(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function eI(e) {
  var t;
  const { editor: n, from: r, to: i, text: o, rules: s, plugin: l } = e, { view: c } = n;
  if (c.composing)
    return !1;
  const a = c.state.doc.resolve(r);
  if (
    // check for code node
    a.parent.type.spec.code || (t = a.nodeBefore || a.nodeAfter) != null && t.marks.find((d) => d.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = mCt(a) + o;
  return s.forEach((d) => {
    if (u)
      return;
    const p = BCt(f, d.find);
    if (!p)
      return;
    const h = c.state.tr, m = Nj({
      state: c.state,
      transaction: h
    }), v = {
      from: r - (p[0].length - o.length),
      to: i
    }, { commands: b, chain: A, can: w } = new Pj({
      editor: n,
      state: m
    });
    d.handler({
      state: m,
      range: v,
      match: p,
      commands: b,
      chain: A,
      can: w
    }) === null || !h.steps.length || (d.undoable && h.setMeta(l, {
      transform: h,
      from: r,
      to: i,
      text: o
    }), c.dispatch(h), u = !0);
  }), u;
}
function XCt(e) {
  const { editor: t, rules: n } = e, r = new $r({
    state: {
      init() {
        return null;
      },
      apply(i, o, s) {
        const l = i.getMeta(r);
        if (l)
          return l;
        const c = i.getMeta("applyInputRules");
        return !!c && setTimeout(() => {
          let { text: u } = c;
          typeof u == "string" ? u = u : u = AK(at.from(u), s.schema);
          const { from: f } = c, d = f + u.length;
          eI({
            editor: t,
            from: f,
            to: d,
            text: u,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(i, o, s, l) {
        return eI({
          editor: t,
          from: o,
          to: s,
          text: l,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: o } = i.state.selection;
          o && eI({
            editor: t,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: s } = i.state.selection;
        return s ? eI({
          editor: t,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function WCt(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function tI(e) {
  return WCt(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function oRe(e, t) {
  const n = { ...e };
  return tI(e) && tI(t) && Object.keys(t).forEach((r) => {
    tI(t[r]) && tI(e[r]) ? n[r] = oRe(e[r], t[r]) : n[r] = t[r];
  }), n;
}
var SK = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Nr(
        on(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Nr(
        on(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => oRe(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new this.constructor({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = "name" in e ? e.name : t.parent.name, t;
  }
}, Ib = class sRe extends SK {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new sRe(n);
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: r } = t.state, i = t.state.selection.$from;
    if (i.pos === i.end()) {
      const s = i.marks();
      if (!!!s.find((a) => (a == null ? void 0 : a.type.name) === n.name))
        return !1;
      const c = s.find((a) => (a == null ? void 0 : a.type.name) === n.name);
      return c && r.removeStoredMark(c), r.insertText(" ", i.pos), t.view.dispatch(r), !0;
    }
    return !1;
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
};
function ZCt(e) {
  return typeof e == "number";
}
var HCt = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, QCt = (e, t, n) => {
  if (bK(t))
    return [...e.matchAll(t)];
  const r = t(e, n);
  return r ? r.map((i) => {
    const o = [i.text];
    return o.index = i.index, o.input = e, o.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(i.replaceWith)), o;
  }) : [];
};
function $Ct(e) {
  const { editor: t, state: n, from: r, to: i, rule: o, pasteEvent: s, dropEvent: l } = e, { commands: c, chain: a, can: u } = new Pj({
    editor: t,
    state: n
  }), f = [];
  return n.doc.nodesBetween(r, i, (p, h) => {
    var m, v, b, A, w;
    if ((v = (m = p.type) == null ? void 0 : m.spec) != null && v.code || !(p.isText || p.isTextblock || p.isInline))
      return;
    const O = (w = (A = (b = p.content) == null ? void 0 : b.size) != null ? A : p.nodeSize) != null ? w : 0, x = Math.max(r, h), S = Math.min(i, h + O);
    if (x >= S)
      return;
    const E = p.isText ? p.text || "" : p.textBetween(x - h, S - h, void 0, "￼");
    QCt(E, o.find, s).forEach((T) => {
      if (T.index === void 0)
        return;
      const R = x + T.index + 1, j = R + T[0].length, F = {
        from: n.tr.mapping.map(R),
        to: n.tr.mapping.map(j)
      }, L = o.handler({
        state: n,
        range: F,
        match: T,
        commands: c,
        chain: a,
        can: u,
        pasteEvent: s,
        dropEvent: l
      });
      f.push(L);
    });
  }), f.every((p) => p !== null);
}
var nI = null, KCt = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) == null || t.setData("text/html", e), n;
};
function GCt(e) {
  const { editor: t, rules: n } = e;
  let r = null, i = !1, o = !1, s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, l;
  try {
    l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    l = null;
  }
  const c = ({
    state: u,
    from: f,
    to: d,
    rule: p,
    pasteEvt: h
  }) => {
    const m = u.tr, v = Nj({
      state: u,
      transaction: m
    });
    if (!(!$Ct({
      editor: t,
      state: v,
      from: Math.max(f - 1, 0),
      to: d.b - 1,
      rule: p,
      pasteEvent: h,
      dropEvent: l
    }) || !m.steps.length)) {
      try {
        l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        l = null;
      }
      return s = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return n.map((u) => new $r({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const d = (h) => {
        var m;
        r = (m = f.dom.parentElement) != null && m.contains(h.target) ? f.dom.parentElement : null, r && (nI = t);
      }, p = () => {
        nI && (nI = null);
      };
      return window.addEventListener("dragstart", d), window.addEventListener("dragend", p), {
        destroy() {
          window.removeEventListener("dragstart", d), window.removeEventListener("dragend", p);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, d) => {
          if (o = r === f.dom.parentElement, l = d, !o) {
            const p = nI;
            p != null && p.isEditable && setTimeout(() => {
              const h = p.state.selection;
              h && p.commands.deleteRange({ from: h.from, to: h.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, d) => {
          var p;
          const h = (p = d.clipboardData) == null ? void 0 : p.getData("text/html");
          return s = d, i = !!(h != null && h.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, d, p) => {
      const h = f[0], m = h.getMeta("uiEvent") === "paste" && !i, v = h.getMeta("uiEvent") === "drop" && !o, b = h.getMeta("applyPasteRules"), A = !!b;
      if (!m && !v && !A)
        return;
      if (A) {
        let { text: x } = b;
        typeof x == "string" ? x = x : x = AK(at.from(x), p.schema);
        const { from: S } = b, E = S + x.length, k = KCt(x);
        return c({
          rule: u,
          state: p,
          from: S,
          to: { b: E },
          pasteEvt: k
        });
      }
      const w = d.doc.content.findDiffStart(p.doc.content), O = d.doc.content.findDiffEnd(p.doc.content);
      if (!(!ZCt(w) || !O || w === O.b))
        return c({
          rule: u,
          state: p,
          from: w,
          to: O,
          pasteEvt: s
        });
    }
  }));
}
var _j = class {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.baseExtensions = e, this.extensions = wK(e), this.schema = GIe(this.extensions, t), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const n = {
        name: t.name,
        options: t.options,
        storage: this.editor.extensionStorage[t.name],
        editor: this.editor,
        type: JP(t.name, this.schema)
      }, r = on(t, "addCommands", n);
      return r ? {
        ...e,
        ...r()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return o_([...this.extensions].reverse()).flatMap((r) => {
      const i = {
        name: r.name,
        options: r.options,
        storage: this.editor.extensionStorage[r.name],
        editor: e,
        type: JP(r.name, this.schema)
      }, o = [], s = on(
        r,
        "addKeyboardShortcuts",
        i
      );
      let l = {};
      if (r.type === "mark" && on(r, "exitable", i) && (l.ArrowRight = () => Ib.handleExit({ editor: e, mark: r })), s) {
        const d = Object.fromEntries(
          Object.entries(s()).map(([p, h]) => [p, () => h({ editor: e })])
        );
        l = { ...l, ...d };
      }
      const c = dkt(l);
      o.push(c);
      const a = on(r, "addInputRules", i);
      if (ple(r, e.options.enableInputRules) && a) {
        const d = a();
        if (d && d.length) {
          const p = XCt({
            editor: e,
            rules: d
          }), h = Array.isArray(p) ? p : [p];
          o.push(...h);
        }
      }
      const u = on(r, "addPasteRules", i);
      if (ple(r, e.options.enablePasteRules) && u) {
        const d = u();
        if (d && d.length) {
          const p = GCt({ editor: e, rules: d });
          o.push(...p);
        }
      }
      const f = on(
        r,
        "addProseMirrorPlugins",
        i
      );
      if (f) {
        const d = f();
        o.push(...d);
      }
      return o;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return KIe(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = yw(this.extensions);
    return Object.fromEntries(
      t.filter((n) => !!on(n, "addNodeView")).map((n) => {
        const r = this.attributes.filter((c) => c.type === n.name), i = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: e,
          type: bo(n.name, this.schema)
        }, o = on(n, "addNodeView", i);
        if (!o)
          return [];
        const s = o();
        if (!s)
          return [];
        const l = (c, a, u, f, d) => {
          const p = sk(c, r);
          return s({
            // pass-through
            node: c,
            view: a,
            getPos: u,
            decorations: f,
            innerDecorations: d,
            // tiptap-specific
            editor: e,
            extension: n,
            HTMLAttributes: p
          });
        };
        return [n.name, l];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: t } = this;
    return o_([...this.extensions].reverse()).reduceRight((r, i) => {
      const o = {
        name: i.name,
        options: i.options,
        storage: this.editor.extensionStorage[i.name],
        editor: t,
        type: JP(i.name, this.schema)
      }, s = on(
        i,
        "dispatchTransaction",
        o
      );
      return s ? (l) => {
        s.call(o, { transaction: l, next: r });
      } : r;
    }, e);
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: t } = yw(this.extensions);
    return Object.fromEntries(
      t.filter((n) => !!on(n, "addMarkView")).map((n) => {
        const r = this.attributes.filter((l) => l.type === n.name), i = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: e,
          type: Ch(n.name, this.schema)
        }, o = on(n, "addMarkView", i);
        if (!o)
          return [];
        const s = (l, c, a) => {
          const u = sk(l, r);
          return o()({
            // pass-through
            mark: l,
            view: c,
            inline: a,
            // tiptap-specific
            editor: e,
            extension: n,
            HTMLAttributes: u,
            updateAttributes: (f) => {
              pNt(l, e, f);
            }
          });
        };
        return [n.name, s];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((t) => [t.name, t.storage])
    ), e.forEach((t) => {
      var n;
      const r = {
        name: t.name,
        options: t.options,
        storage: this.editor.extensionStorage[t.name],
        editor: this.editor,
        type: JP(t.name, this.schema)
      };
      t.type === "mark" && ((n = Nr(on(t, "keepOnSplit", r))) == null || n) && this.splittableMarks.push(t.name);
      const i = on(t, "onBeforeCreate", r), o = on(t, "onCreate", r), s = on(t, "onUpdate", r), l = on(
        t,
        "onSelectionUpdate",
        r
      ), c = on(t, "onTransaction", r), a = on(t, "onFocus", r), u = on(t, "onBlur", r), f = on(t, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), o && this.editor.on("create", o), s && this.editor.on("update", s), l && this.editor.on("selectionUpdate", l), c && this.editor.on("transaction", c), a && this.editor.on("focus", a), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
};
_j.resolve = wK;
_j.sort = o_;
_j.flatten = Mj;
var YCt = {};
vK(YCt, {
  ClipboardTextSerializer: () => lRe,
  Commands: () => cRe,
  Delete: () => uRe,
  Drop: () => dRe,
  Editable: () => fRe,
  FocusEvents: () => hRe,
  Keymap: () => mRe,
  Paste: () => gRe,
  Tabindex: () => yRe,
  TextDirection: () => vRe,
  focusEventsPluginKey: () => pRe
});
var si = class aRe extends SK {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new aRe(n);
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
}, lRe = si.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: i } = t, { ranges: o } = i, s = Math.min(...o.map((u) => u.$from.pos)), l = Math.max(...o.map((u) => u.$to.pos)), c = JIe(n);
            return YIe(r, { from: s, to: l }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: c
            });
          }
        }
      })
    ];
  }
}), cRe = si.create({
  name: "commands",
  addCommands() {
    return {
      ...Tu
    };
  }
}), uRe = si.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: t }) {
    var n, r, i;
    const o = () => {
      var s, l, c, a;
      if ((a = (c = (l = (s = this.editor.options.coreExtensionOptions) == null ? void 0 : s.delete) == null ? void 0 : l.filterTransaction) == null ? void 0 : c.call(l, e)) != null ? a : e.getMeta("y-sync$"))
        return;
      const u = HIe(e.before, [e, ...t]);
      tRe(u).forEach((p) => {
        u.mapping.mapResult(p.oldRange.from).deletedAfter && u.mapping.mapResult(p.oldRange.to).deletedBefore && u.before.nodesBetween(p.oldRange.from, p.oldRange.to, (h, m) => {
          const v = m + h.nodeSize - 2, b = p.oldRange.from <= m && v <= p.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: h,
            from: m,
            to: v,
            newFrom: u.mapping.map(m),
            newTo: u.mapping.map(v),
            deletedRange: p.oldRange,
            newRange: p.newRange,
            partial: !b,
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        });
      });
      const d = u.mapping;
      u.steps.forEach((p, h) => {
        var m, v;
        if (p instanceof qu) {
          const b = d.slice(h).map(p.from, -1), A = d.slice(h).map(p.to), w = d.invert().map(b, -1), O = d.invert().map(A), x = (m = u.doc.nodeAt(b - 1)) == null ? void 0 : m.marks.some((E) => E.eq(p.mark)), S = (v = u.doc.nodeAt(A)) == null ? void 0 : v.marks.some((E) => E.eq(p.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: p.mark,
            from: p.from,
            to: p.to,
            deletedRange: {
              from: w,
              to: O
            },
            newRange: {
              from: b,
              to: A
            },
            partial: !!(S || x),
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        }
      });
    };
    (i = (r = (n = this.editor.options.coreExtensionOptions) == null ? void 0 : n.delete) == null ? void 0 : r.async) == null || i ? setTimeout(o, 0) : o();
  }
}), dRe = si.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("tiptapDrop"),
        props: {
          handleDrop: (e, t, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: t,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), fRe = si.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), pRe = new gi("focusEvents"), hRe = si.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new $r({
        key: pRe,
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), mRe = si.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: l }) => {
        const { selection: c, doc: a } = l, { empty: u, $anchor: f } = c, { pos: d, parent: p } = f, h = f.parent.isTextblock && d > 0 ? l.doc.resolve(d - 1) : f, m = h.parent.type.spec.isolating, v = f.pos - f.parentOffset, b = m && h.parent.childCount === 1 ? v === f.pos : En.atStart(a).from === d;
        return !u || !p.type.isTextblock || p.textContent.length || !b || b && f.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, o = {
      ...r,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return i_() || WIe() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new $r({
        key: new gi("clearDocument"),
        appendTransaction: (e, t, n) => {
          if (e.some((m) => m.getMeta("composition")))
            return;
          const r = e.some((m) => m.docChanged) && !t.doc.eq(n.doc), i = e.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: o, from: s, to: l } = t.selection, c = En.atStart(t.doc).from, a = En.atEnd(t.doc).to;
          if (o || !(s === c && l === a) || !bN(n.doc))
            return;
          const d = n.tr, p = Nj({
            state: n,
            transaction: d
          }), { commands: h } = new Pj({
            editor: this.editor,
            state: p
          });
          if (h.clearNodes(), !!d.steps.length)
            return d;
        }
      })
    ];
  }
}), gRe = si.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("tiptapPaste"),
        props: {
          handlePaste: (e, t, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: t,
              slice: n
            });
          }
        }
      })
    ];
  }
}), yRe = si.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), vRe = si.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = yw(this.extensions);
    return [
      {
        types: e.filter((t) => t.name !== "text").map((t) => t.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (t) => {
              const n = t.getAttribute("dir");
              return n && (n === "ltr" || n === "rtl" || n === "auto") ? n : this.options.direction;
            },
            renderHTML: (t) => t.dir ? {
              dir: t.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), JCt = class oO {
  constructor(t, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = t, this.editor = n, this.currentNode = i;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) != null ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new oO(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new oO(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new oO(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, o = n.isAtom && !n.isText, s = this.pos + r + (o ? 0 : 1);
      if (s < 0 || s > this.resolvedPos.doc.nodeSize - 2)
        return;
      const l = this.resolvedPos.doc.resolve(s);
      if (!i && l.depth <= this.depth)
        return;
      const c = new oO(l, this.editor, i, i ? n : null);
      i && (c.actualDepth = this.depth + 1), t.push(new oO(l, this.editor, i, i ? n : null));
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const o = i.node.attrs, s = Object.keys(n);
          for (let l = 0; l < s.length; l += 1) {
            const c = s[l];
            if (o[c] !== n[c])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const o = Object.keys(n);
    return this.children.forEach((s) => {
      r && i.length > 0 || (s.node.type.name === t && o.every((c) => n[c] === s.node.attrs[c]) && i.push(s), !(r && i.length > 0) && (i = i.concat(s.querySelectorAll(t, n, r))));
    }), i;
  }
  setAttribute(t) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...t
    }), this.editor.view.dispatch(n);
  }
}, eNt = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function tNt(e, t, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return t && i.setAttribute("nonce", t), i.setAttribute("data-tiptap-style", ""), i.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(i), i;
}
var nNt = class extends qCt {
  constructor(t = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: i }) => {
        throw i;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: bCt,
      createMappablePosition: OCt
    }, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: i, slice: o, moved: s }) => this.options.onDrop(i, o, s)), this.on("paste", ({ event: i, slice: o }) => this.options.onPaste(i, o)), this.on("delete", this.options.onDelete);
    const n = this.createDoc(), r = BIe(n, this.options.autofocus);
    this.editorState = tEt.create({
      doc: n,
      schema: this.schema,
      selection: r || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(t) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(t), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const t = this.editorView.dom;
      t != null && t.editor && delete t.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (t) {
        console.warn("Failed to remove CSS element:", t);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = tNt(eNt, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (t) => {
          this.editorState = t;
        },
        dispatch: (t) => {
          this.dispatchTransaction(t);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (t, n) => {
          if (this.editorView)
            return this.editorView[n];
          if (n === "state")
            return this.editorState;
          if (n in t)
            return Reflect.get(t, n);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${n}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(t, n) {
    const r = $Ie(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(t).forEach((o) => {
      const s = typeof o == "string" ? `${o}$` : o.key;
      r = r.filter((l) => !l.key.startsWith(s));
    }), n.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n;
    const i = [...this.options.enableCoreExtensions ? [
      fRe,
      lRe.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) == null ? void 0 : t.clipboardTextSerializer) == null ? void 0 : n.blockSeparator
      }),
      cRe,
      hRe,
      mRe,
      yRe,
      dRe,
      gRe,
      uRe,
      vRe.configure({
        direction: this.options.textDirection
      })
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new _j(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Pj({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let t;
    try {
      t = HX(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (n) {
      if (!(n instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(n.message))
        throw n;
      this.emit("contentError", {
        editor: this,
        error: n,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((r) => r.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = HX(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return t;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(t) {
    const { editorProps: n, enableExtensionDispatchTransaction: r } = this.options, i = n.dispatchTransaction || this.dispatchTransaction.bind(this), o = r ? this.extensionManager.dispatchTransaction(i) : i;
    this.editorView = new FIe(t, {
      ...n,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...n == null ? void 0 : n.attributes
      },
      dispatchTransaction: o,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const s = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(s), this.prependClass(), this.injectCSS();
    const l = this.view.dom;
    l.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((u) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(u);
      });
      return;
    }
    const { state: n, transactions: r } = this.state.applyTransaction(t), i = !this.state.selection.eq(n.selection), o = r.includes(t), s = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: t,
      nextState: n
    }), !o)
      return;
    this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t,
      appendedTransactions: r.slice(1)
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const l = r.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), c = l == null ? void 0 : l.getMeta("focus"), a = l == null ? void 0 : l.getMeta("blur");
    c && this.emit("focus", {
      editor: this,
      event: c.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: l
    }), a && this.emit("blur", {
      editor: this,
      event: a.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: l
    }), !(t.getMeta("preventUpdate") || !r.some((u) => u.docChanged) || s.doc.eq(n.doc)) && this.emit("update", {
      editor: this,
      transaction: t,
      appendedTransactions: r.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return eRe(this.state, t);
  }
  isActive(t, n) {
    const r = typeof t == "string" ? t : null, i = typeof t == "string" ? n : t;
    return gCt(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return AK(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = t || {};
    return uCt(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...JIe(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return bN(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t, n;
    return (n = (t = this.editorView) == null ? void 0 : t.isDestroyed) != null ? n : !0;
  }
  $node(t, n) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t);
    return new JCt(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function vw(e) {
  return new Dj({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = Nr(e.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, s = r[r.length - 1], l = r[0];
      if (s) {
        const c = l.search(/\S/), a = n.from + l.indexOf(s), u = a + s.length;
        if (xK(n.from, n.to, t.doc).filter((p) => p.mark.type.excluded.find((m) => m === e.type && m !== p.mark.type)).filter((p) => p.to > a).length)
          return null;
        u < n.to && o.delete(u, n.to), a > n.from && o.delete(n.from + c, a);
        const d = n.from + c + s.length;
        o.addMark(n.from + c, d, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function bRe(e) {
  return new Dj({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = Nr(e.getAttributes, void 0, r) || {}, { tr: o } = t, s = n.from;
      let l = n.to;
      const c = e.type.create(i);
      if (r[1]) {
        const a = r[0].lastIndexOf(r[1]);
        let u = s + a;
        u > l ? u = l : l = u + r[1].length;
        const f = r[0][r[0].length - 1];
        o.insertText(f, s + r[0].length - 1), o.replaceWith(u, l, c);
      } else if (r[0]) {
        const a = e.type.isInline ? s : s - 1;
        o.insert(a, e.type.create(i)).delete(o.mapping.map(s), o.mapping.map(l));
      }
      o.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function $X(e) {
  return new Dj({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = t.doc.resolve(n.from), o = Nr(e.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, o);
    },
    undoable: e.undoable
  });
}
function bw(e) {
  return new Dj({
    find: e.find,
    handler: ({ state: t, range: n, match: r, chain: i }) => {
      const o = Nr(e.getAttributes, void 0, r) || {}, s = t.tr.delete(n.from, n.to), c = s.doc.resolve(n.from).blockRange(), a = c && tK(c, e.type, o);
      if (!a)
        return null;
      if (s.wrap(c, a), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: d } = t, { splittableMarks: p } = e.editor.extensionManager, h = d || f.$to.parentOffset && f.$from.marks();
        if (h) {
          const m = h.filter((v) => p.includes(v.type.name));
          s.ensureMarks(m);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(f, o).run();
      }
      const u = s.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === e.type && Rg(s.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, u)) && s.join(n.from - 1);
    },
    undoable: e.undoable
  });
}
var rNt = (e) => "touches" in e, iNt = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (l) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const c = l.clientX - this.startX, a = l.clientY - this.startY;
      this.handleResize(c, a);
    }, this.handleTouchMove = (l) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const c = l.touches[0];
      if (!c)
        return;
      const a = c.clientX - this.startX, u = c.clientY - this.startY;
      this.handleResize(a, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const l = this.element.offsetWidth, c = this.element.offsetHeight;
      this.onCommit(l, c), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (l) => {
      l.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (l) => {
      l.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var t, n, r, i, o, s;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (t = e.options) != null && t.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (n = e.options) != null && n.max && (this.maxSize = e.options.max), (r = e == null ? void 0 : e.options) != null && r.directions && (this.directions = e.options.directions), (i = e.options) != null && i.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (o = e.options) != null && o.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (s = e.options) != null && s.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    return this.contentElement;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, t, n) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, t, n) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const t = document.createElement("div");
    return t.dataset.resizeHandle = e, t.style.position = "absolute", this.classNames.handle && (t.className = this.classNames.handle), t;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, t) {
    const n = t.includes("top"), r = t.includes("bottom"), i = t.includes("left"), o = t.includes("right");
    n && (e.style.top = "0"), r && (e.style.bottom = "0"), i && (e.style.left = "0"), o && (e.style.right = "0"), (t === "top" || t === "bottom") && (e.style.left = "0", e.style.right = "0"), (t === "left" || t === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let t;
      this.createCustomHandle ? t = this.createCustomHandle(e) : t = this.createHandle(e), t instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), t = this.createHandle(e)), this.createCustomHandle || this.positionHandle(t, e), t.addEventListener("mousedown", (n) => this.handleResizeStart(n, e)), t.addEventListener("touchstart", (n) => this.handleResizeStart(n, e)), this.handleMap.set(e, t), this.wrapper.appendChild(t);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, t = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, t ? (this.element.style.height = `${t}px`, this.initialHeight = t) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, t) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = t, rNt(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, t) {
    if (!this.activeHandle)
      return;
    const n = this.preserveAspectRatio || this.isShiftKeyPressed, { width: r, height: i } = this.calculateNewDimensions(this.activeHandle, e, t), o = this.applyConstraints(r, i, n);
    this.element.style.width = `${o.width}px`, this.element.style.height = `${o.height}px`, this.onResize && this.onResize(o.width, o.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, t, n) {
    let r = this.startWidth, i = this.startHeight;
    const o = e.includes("right"), s = e.includes("left"), l = e.includes("bottom"), c = e.includes("top");
    return o ? r = this.startWidth + t : s && (r = this.startWidth - t), l ? i = this.startHeight + n : c && (i = this.startHeight - n), (e === "right" || e === "left") && (r = this.startWidth + (o ? t : -t)), (e === "top" || e === "bottom") && (i = this.startHeight + (l ? n : -n)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(r, i, e) : { width: r, height: i };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, t, n) {
    var r, i, o, s;
    if (!n) {
      let a = Math.max(this.minSize.width, e), u = Math.max(this.minSize.height, t);
      return (r = this.maxSize) != null && r.width && (a = Math.min(this.maxSize.width, a)), (i = this.maxSize) != null && i.height && (u = Math.min(this.maxSize.height, u)), { width: a, height: u };
    }
    let l = e, c = t;
    return l < this.minSize.width && (l = this.minSize.width, c = l / this.aspectRatio), c < this.minSize.height && (c = this.minSize.height, l = c * this.aspectRatio), (o = this.maxSize) != null && o.width && l > this.maxSize.width && (l = this.maxSize.width, c = l / this.aspectRatio), (s = this.maxSize) != null && s.height && c > this.maxSize.height && (c = this.maxSize.height, l = c * this.aspectRatio), { width: l, height: c };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, t, n) {
    const r = n === "left" || n === "right", i = n === "top" || n === "bottom";
    return r ? {
      width: e,
      height: e / this.aspectRatio
    } : i ? {
      width: t * this.aspectRatio,
      height: t
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function oNt(e, t) {
  const { selection: n } = e, { $from: r } = n;
  if (n instanceof dn) {
    const o = r.index();
    return r.parent.canReplaceWith(o, o + 1, t);
  }
  let i = r.depth;
  for (; i >= 0; ) {
    const o = r.index(i);
    if (r.node(i).contentMatchAt(o).matchType(t))
      return !0;
    i -= 1;
  }
  return !1;
}
function sNt(e) {
  return e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var aNt = {};
vK(aNt, {
  createAtomBlockMarkdownSpec: () => lNt,
  createBlockMarkdownSpec: () => cNt,
  createInlineMarkdownSpec: () => fNt,
  parseAttributes: () => EK,
  parseIndentedBlocks: () => KX,
  renderNestedMarkdownContent: () => kK,
  serializeAttributes: () => TK
});
function EK(e) {
  if (!(e != null && e.trim()))
    return {};
  const t = {}, n = [], r = e.replace(/["']([^"']*)["']/g, (a) => (n.push(a), `__QUOTED_${n.length - 1}__`)), i = r.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (i) {
    const a = i.map((u) => u.trim().slice(1));
    t.class = a.join(" ");
  }
  const o = r.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  o && (t.id = o[1]);
  const s = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(r.matchAll(s)).forEach(([, a, u]) => {
    var f;
    const d = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), p = n[d];
    p && (t[a] = p.slice(1, -1));
  });
  const c = r.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return c && c.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (t[u] = !0);
  }), t;
}
function TK(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const t = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((r) => t.push(`.${r}`)), e.id && t.push(`#${e.id}`), Object.entries(e).forEach(([n, r]) => {
    n === "class" || n === "id" || (r === !0 ? t.push(n) : r !== !1 && r != null && t.push(`${n}="${String(r)}"`));
  }), t.join(" ");
}
function lNt(e) {
  const {
    nodeName: t,
    name: n,
    parseAttributes: r = EK,
    serializeAttributes: i = TK,
    defaultAttributes: o = {},
    requiredAttributes: s = [],
    allowedAttributes: l
  } = e, c = n || t, a = (u) => {
    if (!l)
      return u;
    const f = {};
    return l.forEach((d) => {
      d in u && (f[d] = u[d]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const d = { ...o, ...u.attributes };
      return f.createNode(t, d, []);
    },
    markdownTokenizer: {
      name: t,
      level: "block",
      start(u) {
        var f;
        const d = new RegExp(`^:::${c}(?:\\s|$)`, "m"), p = (f = u.match(d)) == null ? void 0 : f.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(u, f, d) {
        const p = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), h = u.match(p);
        if (!h)
          return;
        const m = h[1] || "", v = r(m);
        if (!s.find((A) => !(A in v)))
          return {
            type: t,
            raw: h[0],
            attributes: v
          };
      }
    },
    renderMarkdown: (u) => {
      const f = a(u.attrs || {}), d = i(f), p = d ? ` {${d}}` : "";
      return `:::${c}${p} :::`;
    }
  };
}
function cNt(e) {
  const {
    nodeName: t,
    name: n,
    getContent: r,
    parseAttributes: i = EK,
    serializeAttributes: o = TK,
    defaultAttributes: s = {},
    content: l = "block",
    allowedAttributes: c
  } = e, a = n || t, u = (f) => {
    if (!c)
      return f;
    const d = {};
    return c.forEach((p) => {
      p in f && (d[p] = f[p]);
    }), d;
  };
  return {
    parseMarkdown: (f, d) => {
      let p;
      if (r) {
        const m = r(f);
        p = typeof m == "string" ? [{ type: "text", text: m }] : m;
      } else l === "block" ? p = d.parseChildren(f.tokens || []) : p = d.parseInline(f.tokens || []);
      const h = { ...s, ...f.attributes };
      return d.createNode(t, h, p);
    },
    markdownTokenizer: {
      name: t,
      level: "block",
      start(f) {
        var d;
        const p = new RegExp(`^:::${a}`, "m"), h = (d = f.match(p)) == null ? void 0 : d.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(f, d, p) {
        var h;
        const m = new RegExp(`^:::${a}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), v = f.match(m);
        if (!v)
          return;
        const [b, A = ""] = v, w = i(A);
        let O = 1;
        const x = b.length;
        let S = "";
        const E = /^:::([\w-]*)(\s.*)?/gm, k = f.slice(x);
        for (E.lastIndex = 0; ; ) {
          const T = E.exec(k);
          if (T === null)
            break;
          const R = T.index, j = T[1];
          if (!((h = T[2]) != null && h.endsWith(":::"))) {
            if (j)
              O += 1;
            else if (O -= 1, O === 0) {
              const F = k.slice(0, R);
              S = F.trim();
              const L = f.slice(0, x + R + T[0].length);
              let _ = [];
              if (S)
                if (l === "block")
                  for (_ = p.blockTokens(F), _.forEach((U) => {
                    U.text && (!U.tokens || U.tokens.length === 0) && (U.tokens = p.inlineTokens(U.text));
                  }); _.length > 0; ) {
                    const U = _[_.length - 1];
                    if (U.type === "paragraph" && (!U.text || U.text.trim() === ""))
                      _.pop();
                    else
                      break;
                  }
                else
                  _ = p.inlineTokens(S);
              return {
                type: t,
                raw: L,
                attributes: w,
                content: S,
                tokens: _
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, d) => {
      const p = u(f.attrs || {}), h = o(p), m = h ? ` {${h}}` : "", v = d.renderChildren(f.content || [], `

`);
      return `:::${a}${m}

${v}

:::`;
    }
  };
}
function uNt(e) {
  if (!e.trim())
    return {};
  const t = {}, n = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let r = n.exec(e);
  for (; r !== null; ) {
    const [, i, o, s] = r;
    t[i] = o || s, r = n.exec(e);
  }
  return t;
}
function dNt(e) {
  return Object.entries(e).filter(([, t]) => t != null).map(([t, n]) => `${t}="${n}"`).join(" ");
}
function fNt(e) {
  const {
    nodeName: t,
    name: n,
    getContent: r,
    parseAttributes: i = uNt,
    serializeAttributes: o = dNt,
    defaultAttributes: s = {},
    selfClosing: l = !1,
    allowedAttributes: c
  } = e, a = n || t, u = (d) => {
    if (!c)
      return d;
    const p = {};
    return c.forEach((h) => {
      const m = typeof h == "string" ? h : h.name, v = typeof h == "string" ? void 0 : h.skipIfDefault;
      if (m in d) {
        const b = d[m];
        if (v !== void 0 && b === v)
          return;
        p[m] = b;
      }
    }), p;
  }, f = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (d, p) => {
      const h = { ...s, ...d.attributes };
      if (l)
        return p.createNode(t, h);
      const m = r ? r(d) : d.content || "";
      return m ? p.createNode(t, h, [p.createTextNode(m)]) : p.createNode(t, h, []);
    },
    markdownTokenizer: {
      name: t,
      level: "inline",
      start(d) {
        const p = l ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), h = d.match(p), m = h == null ? void 0 : h.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(d, p, h) {
        const m = l ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), v = d.match(m);
        if (!v)
          return;
        let b = "", A = "";
        if (l) {
          const [, O] = v;
          A = O;
        } else {
          const [, O, x] = v;
          A = O, b = x || "";
        }
        const w = i(A.trim());
        return {
          type: t,
          raw: v[0],
          content: b.trim(),
          attributes: w
        };
      }
    },
    renderMarkdown: (d) => {
      let p = "";
      r ? p = r(d) : d.content && d.content.length > 0 && (p = d.content.filter((b) => b.type === "text").map((b) => b.text).join(""));
      const h = u(d.attrs || {}), m = o(h), v = m ? ` ${m}` : "";
      return l ? `[${a}${v}]` : `[${a}${v}]${p}[/${a}]`;
    }
  };
}
function KX(e, t, n) {
  var r, i, o, s;
  const l = e.split(`
`), c = [];
  let a = "", u = 0;
  const f = t.baseIndentSize || 2;
  for (; u < l.length; ) {
    const d = l[u], p = d.match(t.itemPattern);
    if (!p) {
      if (c.length > 0)
        break;
      if (d.trim() === "") {
        u += 1, a = `${a}${d}
`;
        continue;
      } else
        return;
    }
    const h = t.extractItemData(p), { indentLevel: m, mainContent: v } = h;
    a = `${a}${d}
`;
    const b = [v];
    for (u += 1; u < l.length; ) {
      const x = l[u];
      if (x.trim() === "") {
        const E = l.slice(u + 1).findIndex((R) => R.trim() !== "");
        if (E === -1)
          break;
        if ((((i = (r = l[u + 1 + E].match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : i.length) || 0) > m) {
          b.push(x), a = `${a}${x}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((s = (o = x.match(/^(\s*)/)) == null ? void 0 : o[1]) == null ? void 0 : s.length) || 0) > m)
        b.push(x), a = `${a}${x}
`, u += 1;
      else
        break;
    }
    let A;
    const w = b.slice(1);
    if (w.length > 0) {
      const x = w.map((S) => S.slice(m + f)).join(`
`);
      x.trim() && (t.customNestedParser ? A = t.customNestedParser(x) : A = n.blockTokens(x));
    }
    const O = t.createToken(h, A);
    c.push(O);
  }
  if (c.length !== 0)
    return {
      items: c,
      raw: a
    };
}
function kK(e, t, n, r) {
  if (!e || !Array.isArray(e.content))
    return "";
  const i = typeof n == "function" ? n(r) : n, [o, ...s] = e.content, l = t.renderChildren([o]), c = [`${i}${l}`];
  return s && s.length > 0 && s.forEach((a) => {
    const u = t.renderChildren([a]);
    if (u) {
      const f = u.split(`
`).map((d) => d ? t.indent(d) : "").join(`
`);
      c.push(f);
    }
  }), c.join(`
`);
}
function pNt(e, t, n = {}) {
  const { state: r } = t, { doc: i, tr: o } = r, s = e;
  i.descendants((l, c) => {
    const a = o.mapping.map(c), u = o.mapping.map(c) + l.nodeSize;
    let f = null;
    if (l.marks.forEach((p) => {
      if (p !== s)
        return !1;
      f = p;
    }), !f)
      return;
    let d = !1;
    if (Object.keys(n).forEach((p) => {
      n[p] !== f.attrs[p] && (d = !0);
    }), d) {
      const p = e.type.create({
        ...e.attrs,
        ...n
      });
      o.removeMark(a, u, e.type), o.addMark(a, u, p);
    }
  }), o.docChanged && t.view.dispatch(o);
}
var So = class ORe extends SK {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new ORe(n);
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
};
function qv(e) {
  return new HCt({
    find: e.find,
    handler: ({ state: t, range: n, match: r, pasteEvent: i }) => {
      const o = Nr(e.getAttributes, void 0, r, i);
      if (o === !1 || o === null)
        return null;
      const { tr: s } = t, l = r[r.length - 1], c = r[0];
      let a = n.to;
      if (l) {
        const u = c.search(/\S/), f = n.from + c.indexOf(l), d = f + l.length;
        if (xK(n.from, n.to, t.doc).filter((h) => h.mark.type.excluded.find((v) => v === e.type && v !== h.mark.type)).filter((h) => h.to > f).length)
          return null;
        d < n.to && s.delete(d, n.to), f > n.from && s.delete(n.from + u, f), a = n.from + u + l.length, s.addMark(n.from + u, a, e.type.create(o || {})), s.removeStoredMark(e.type);
      }
    }
  });
}
var s_ = (e, t) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(t);
  const { children: n, ...r } = t ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, r, n];
}, hNt = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, mNt = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, gNt = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, yNt = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, ARe = Ib.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ s_("strong", { ...Ir(this.options.HTMLAttributes, e), children: /* @__PURE__ */ s_("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, t) => t.applyMark("bold", t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => `**${t.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      vw({
        find: hNt,
        type: this.type
      }),
      vw({
        find: gNt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qv({
        find: mNt,
        type: this.type
      }),
      qv({
        find: yNt,
        type: this.type
      })
    ];
  }
}), CK = So.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `

`) : ""
}), vNt = CK, bNt = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, ONt = So.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", Ir(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, t) => t.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var t, n, r, i, o, s;
    const l = (n = (t = e.attrs) == null ? void 0 : t.src) != null ? n : "", c = (i = (r = e.attrs) == null ? void 0 : r.alt) != null ? i : "", a = (s = (o = e.attrs) == null ? void 0 : o.title) != null ? s : "";
    return a ? `![${c}](${l} "${a}")` : `![${c}](${l})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: t, minHeight: n, alwaysPreserveAspectRatio: r } = this.options.resize;
    return ({ node: i, getPos: o, HTMLAttributes: s, editor: l }) => {
      const c = document.createElement("img");
      Object.entries(s).forEach(([f, d]) => {
        if (d != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              c.setAttribute(f, d);
              break;
          }
      }), c.src = s.src;
      const a = new iNt({
        element: c,
        editor: l,
        node: i,
        getPos: o,
        onResize: (f, d) => {
          c.style.width = `${f}px`, c.style.height = `${d}px`;
        },
        onCommit: (f, d) => {
          const p = o();
          p !== void 0 && this.editor.chain().setNodeSelection(p).updateAttributes(this.name, {
            width: f,
            height: d
          }).run();
        },
        onUpdate: (f, d, p) => f.type === i.type,
        options: {
          directions: e,
          min: {
            width: t,
            height: n
          },
          preserveAspectRatio: r === !0
        }
      }), u = a.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", c.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, a;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      bRe({
        find: bNt,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, n, r] = e;
          return { src: n, alt: t, title: r };
        }
      })
    ];
  }
}), ANt = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, wNt = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, xNt = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, SNt = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, wRe = Ib.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, t) => t.applyMark("italic", t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => `*${t.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      vw({
        find: ANt,
        type: this.type
      }),
      vw({
        find: xNt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qv({
        find: wNt,
        type: this.type
      }),
      qv({
        find: SNt,
        type: this.type
      })
    ];
  }
}), ENt = Object.defineProperty, TNt = (e, t) => {
  for (var n in t)
    ENt(e, n, { get: t[n], enumerable: !0 });
}, kNt = "listItem", gle = "textStyle", yle = /^\s*([-+*])\s$/, NK = So.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ir(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, t) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? t.parseChildren(e.items) : []
  },
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(kNt, this.editor.getAttributes(gle)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = bw({
      find: yle,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = bw({
      find: yle,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(gle),
      editor: this.editor
    })), [e];
  }
}), PK = So.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ir(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, t) => {
    if (e.type !== "list_item")
      return [];
    let n = [];
    if (e.tokens && e.tokens.length > 0)
      if (e.tokens.some((i) => i.type === "paragraph"))
        n = t.parseChildren(e.tokens);
      else {
        const i = e.tokens[0];
        if (i && i.type === "text" && i.tokens && i.tokens.length > 0) {
          if (n = [
            {
              type: "paragraph",
              content: t.parseInline(i.tokens)
            }
          ], e.tokens.length > 1) {
            const s = e.tokens.slice(1), l = t.parseChildren(s);
            n.push(...l);
          }
        } else
          n = t.parseChildren(e.tokens);
      }
    return n.length === 0 && (n = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: n
    };
  },
  renderMarkdown: (e, t, n) => kK(
    e,
    t,
    (r) => r.parentType === "bulletList" ? "- " : r.parentType === "orderedList" ? `${r.index + 1}. ` : "- ",
    n
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), CNt = {};
TNt(CNt, {
  findListItemPos: () => ON,
  getNextListDepth: () => IK,
  handleBackspace: () => GX,
  handleDelete: () => YX,
  hasListBefore: () => xRe,
  hasListItemAfter: () => NNt,
  hasListItemBefore: () => SRe,
  listItemHasSubList: () => ERe,
  nextListIsDeeper: () => TRe,
  nextListIsHigher: () => kRe
});
var ON = (e, t) => {
  const { $from: n } = t.selection, r = bo(e, t.schema);
  let i = null, o = n.depth, s = n.pos, l = null;
  for (; o > 0 && l === null; )
    i = n.node(o), i.type === r ? l = o : (o -= 1, s -= 1);
  return l === null ? null : { $pos: t.doc.resolve(s), depth: l };
}, IK = (e, t) => {
  const n = ON(e, t);
  if (!n)
    return !1;
  const [, r] = hCt(t, e, n.$pos.pos + 4);
  return r;
}, xRe = (e, t, n) => {
  const { $anchor: r } = e.selection, i = Math.max(0, r.pos - 2), o = e.doc.resolve(i).node();
  return !(!o || !n.includes(o.type.name));
}, SRe = (e, t) => {
  var n;
  const { $anchor: r } = t.selection, i = t.doc.resolve(r.pos - 2);
  return !(i.index() === 0 || ((n = i.nodeBefore) == null ? void 0 : n.type.name) !== e);
}, ERe = (e, t, n) => {
  if (!n)
    return !1;
  const r = bo(e, t.schema);
  let i = !1;
  return n.descendants((o) => {
    o.type === r && (i = !0);
  }), i;
}, GX = (e, t, n) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!og(e.state, t) && xRe(e.state, t, n)) {
    const { $anchor: l } = e.state.selection, c = e.state.doc.resolve(l.before() - 1), a = [];
    c.node().descendants((d, p) => {
      d.type.name === t && a.push({ node: d, pos: p });
    });
    const u = a.at(-1);
    if (!u)
      return !1;
    const f = e.state.doc.resolve(c.start() + u.pos + 1);
    return e.chain().cut({ from: l.start() - 1, to: l.end() + 1 }, f.end()).joinForward().run();
  }
  if (!og(e.state, t) || !vCt(e.state))
    return !1;
  const r = ON(t, e.state);
  if (!r)
    return !1;
  const o = e.state.doc.resolve(r.$pos.pos - 2).node(r.depth), s = ERe(t, e.state, o);
  return SRe(t, e.state) && !s ? e.commands.joinItemBackward() : e.chain().liftListItem(t).run();
}, TRe = (e, t) => {
  const n = IK(e, t), r = ON(e, t);
  return !r || !n ? !1 : n > r.depth;
}, kRe = (e, t) => {
  const n = IK(e, t), r = ON(e, t);
  return !r || !n ? !1 : n < r.depth;
}, YX = (e, t) => {
  if (!og(e.state, t) || !yCt(e.state, t))
    return !1;
  const { selection: n } = e.state, { $from: r, $to: i } = n;
  return !n.empty && r.sameParent(i) ? !1 : TRe(t, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(t).joinBackward().run() : kRe(t, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, NNt = (e, t) => {
  var n;
  const { $anchor: r } = t.selection, i = t.doc.resolve(r.pos - r.parentOffset - 2);
  return !(i.index() === i.parent.childCount - 1 || ((n = i.nodeAfter) == null ? void 0 : n.type.name) !== e);
}, CRe = si.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          e.state.schema.nodes[n] !== void 0 && YX(e, n) && (t = !0);
        }), t;
      },
      "Mod-Delete": ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          e.state.schema.nodes[n] !== void 0 && YX(e, n) && (t = !0);
        }), t;
      },
      Backspace: ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          e.state.schema.nodes[n] !== void 0 && GX(e, n, r) && (t = !0);
        }), t;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          e.state.schema.nodes[n] !== void 0 && GX(e, n, r) && (t = !0);
        }), t;
      }
    };
  }
}), vle = /^(\s*)(\d+)\.\s+(.*)$/, PNt = /^\s/;
function INt(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const i = e[n], o = i.match(vle);
    if (!o)
      break;
    const [, s, l, c] = o, a = s.length;
    let u = c, f = n + 1;
    const d = [i];
    for (; f < e.length; ) {
      const p = e[f];
      if (p.match(vle))
        break;
      if (p.trim() === "")
        d.push(p), u += `
`, f += 1;
      else if (p.match(PNt))
        d.push(p), u += `
${p.slice(a + 2)}`, f += 1;
      else
        break;
    }
    t.push({
      indent: a,
      number: parseInt(l, 10),
      content: u.trim(),
      raw: d.join(`
`)
    }), r = f, n = f;
  }
  return [t, r];
}
function NRe(e, t, n) {
  var r;
  const i = [];
  let o = 0;
  for (; o < e.length; ) {
    const s = e[o];
    if (s.indent === t) {
      const l = s.content.split(`
`), c = ((r = l[0]) == null ? void 0 : r.trim()) || "", a = [];
      c && a.push({
        type: "paragraph",
        raw: c,
        tokens: n.inlineTokens(c)
      });
      const u = l.slice(1).join(`
`).trim();
      if (u) {
        const p = n.blockTokens(u);
        a.push(...p);
      }
      let f = o + 1;
      const d = [];
      for (; f < e.length && e[f].indent > t; )
        d.push(e[f]), f += 1;
      if (d.length > 0) {
        const p = Math.min(...d.map((m) => m.indent)), h = NRe(d, p, n);
        a.push({
          type: "list",
          ordered: !0,
          start: d[0].number,
          items: h,
          raw: d.map((m) => m.raw).join(`
`)
        });
      }
      i.push({
        type: "list_item",
        raw: s.raw,
        tokens: a
      }), o = f;
    } else
      o += 1;
  }
  return i;
}
function RNt(e, t) {
  return e.map((n) => {
    if (n.type !== "list_item")
      return t.parseChildren([n])[0];
    const r = [];
    return n.tokens && n.tokens.length > 0 && n.tokens.forEach((i) => {
      if (i.type === "paragraph" || i.type === "list" || i.type === "blockquote" || i.type === "code")
        r.push(...t.parseChildren([i]));
      else if (i.type === "text" && i.tokens) {
        const o = t.parseChildren([i]);
        r.push({
          type: "paragraph",
          content: o
        });
      } else {
        const o = t.parseChildren([i]);
        o.length > 0 && r.push(...o);
      }
    }), {
      type: "listItem",
      content: r
    };
  });
}
var MNt = "listItem", ble = "textStyle", Ole = /^(\d+)\.\s$/, RK = So.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", Ir(this.options.HTMLAttributes, n), 0] : ["ol", Ir(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, t) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const n = e.start || 1, r = e.items ? RNt(e.items, t) : [];
    return n !== 1 ? {
      type: "orderedList",
      attrs: { start: n },
      content: r
    } : {
      type: "orderedList",
      content: r
    };
  },
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const t = e.match(/^(\s*)(\d+)\.\s+/), n = t == null ? void 0 : t.index;
      return n !== void 0 ? n : -1;
    },
    tokenize: (e, t, n) => {
      var r;
      const i = e.split(`
`), [o, s] = INt(i);
      if (o.length === 0)
        return;
      const l = NRe(o, 0, n);
      return l.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((r = o[0]) == null ? void 0 : r.number) || 1,
        items: l,
        raw: i.slice(0, s).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(MNt, this.editor.getAttributes(ble)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = bw({
      find: Ole,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = bw({
      find: Ole,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(ble) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [e];
  }
}), DNt = /^\s*(\[([( |x])?\])\s$/, _Nt = So.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const t = e.getAttribute("data-checked");
          return t === "" || t === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "li",
      Ir(this.options.HTMLAttributes, t, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, t) => {
    const n = [];
    if (e.tokens && e.tokens.length > 0 ? n.push(t.createNode("paragraph", {}, t.parseInline(e.tokens))) : e.text ? n.push(t.createNode("paragraph", {}, [t.createNode("text", { text: e.text })])) : n.push(t.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const r = t.parseChildren(e.nestedTokens);
      n.push(...r);
    }
    return t.createNode("taskItem", { checked: e.checked || !1 }, n);
  },
  renderMarkdown: (e, t) => {
    var n;
    const i = `- [${(n = e.attrs) != null && n.checked ? "x" : " "}] `;
    return kK(e, t, i);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: t, getPos: n, editor: r }) => {
      const i = document.createElement("li"), o = document.createElement("label"), s = document.createElement("span"), l = document.createElement("input"), c = document.createElement("div"), a = (f) => {
        var d, p;
        l.ariaLabel = ((p = (d = this.options.a11y) == null ? void 0 : d.checkboxLabel) == null ? void 0 : p.call(d, f, l.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      a(e), o.contentEditable = "false", l.type = "checkbox", l.addEventListener("mousedown", (f) => f.preventDefault()), l.addEventListener("change", (f) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          l.checked = !l.checked;
          return;
        }
        const { checked: d } = f.target;
        r.isEditable && typeof n == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: p }) => {
          const h = n();
          if (typeof h != "number")
            return !1;
          const m = p.doc.nodeAt(h);
          return p.setNodeMarkup(h, void 0, {
            ...m == null ? void 0 : m.attrs,
            checked: d
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, d) || (l.checked = !l.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, d]) => {
        i.setAttribute(f, d);
      }), i.dataset.checked = e.attrs.checked, l.checked = e.attrs.checked, o.append(l, s), i.append(o, c), Object.entries(t).forEach(([f, d]) => {
        i.setAttribute(f, d);
      });
      let u = new Set(Object.keys(t));
      return {
        dom: i,
        contentDOM: c,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          i.dataset.checked = f.attrs.checked, l.checked = f.attrs.checked, a(f);
          const d = r.extensionManager.attributes, p = sk(f, d), h = new Set(Object.keys(p)), m = this.options.HTMLAttributes;
          return u.forEach((v) => {
            h.has(v) || (v in m ? i.setAttribute(v, m[v]) : i.removeAttribute(v));
          }), Object.entries(p).forEach(([v, b]) => {
            b == null ? v in m ? i.setAttribute(v, m[v]) : i.removeAttribute(v) : i.setAttribute(v, b);
          }), u = h, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      bw({
        find: DNt,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), LNt = So.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ir(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, t) => t.createNode("taskList", {}, t.parseChildren(e.items || [])),
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var t;
      const n = (t = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : t.index;
      return n !== void 0 ? n : -1;
    },
    tokenize(e, t, n) {
      const r = (o) => {
        const s = KX(
          o,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (l) => ({
              indentLevel: l[1].length,
              mainContent: l[4],
              checked: l[3].toLowerCase() === "x"
            }),
            createToken: (l, c) => ({
              type: "taskItem",
              raw: "",
              mainContent: l.mainContent,
              indentLevel: l.indentLevel,
              checked: l.checked,
              text: l.mainContent,
              tokens: n.inlineTokens(l.mainContent),
              nestedTokens: c
            }),
            // Allow recursive nesting
            customNestedParser: r
          },
          n
        );
        return s ? [
          {
            type: "taskList",
            raw: s.raw,
            items: s.items
          }
        ] : n.blockTokens(o);
      }, i = KX(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (o) => ({
            indentLevel: o[1].length,
            mainContent: o[4],
            checked: o[3].toLowerCase() === "x"
          }),
          createToken: (o, s) => ({
            type: "taskItem",
            raw: "",
            mainContent: o.mainContent,
            indentLevel: o.indentLevel,
            checked: o.checked,
            text: o.mainContent,
            tokens: n.inlineTokens(o.mainContent),
            nestedTokens: s
          }),
          // Use the recursive parser for nested content
          customNestedParser: r
        },
        n
      );
      if (i)
        return {
          type: "taskList",
          raw: i.raw,
          items: i.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
si.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(NK.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(PK.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(CRe.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(RK.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(_Nt.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(LNt.configure(this.options.taskList)), e;
  }
});
var MK = So.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Ir(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, t) => {
    const n = e.tokens || [];
    return n.length === 1 && n[0].type === "image" ? t.parseChildren([n[0]]) : t.createNode(
      "paragraph",
      void 0,
      // no attributes for paragraph
      t.parseInline(n)
    );
  },
  renderMarkdown: (e, t) => !e || !Array.isArray(e.content) ? "" : t.renderChildren(e.content),
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), zNt = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, jNt = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, PRe = Ib.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Ir(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, t) => t.applyMark("strike", t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => `~~${t.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      vw({
        find: zNt,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qv({
        find: jNt,
        type: this.type
      })
    ];
  }
});
let JX, e9;
if (typeof WeakMap < "u") {
  let e = /* @__PURE__ */ new WeakMap();
  JX = (t) => e.get(t), e9 = (t, n) => (e.set(t, n), n);
} else {
  const e = [];
  let n = 0;
  JX = (r) => {
    for (let i = 0; i < e.length; i += 2) if (e[i] == r) return e[i + 1];
  }, e9 = (r, i) => (n == 10 && (n = 0), e[n++] = r, e[n++] = i);
}
var Ui = class {
  constructor(e, t, n, r) {
    this.width = e, this.height = t, this.map = n, this.problems = r;
  }
  findCell(e) {
    for (let t = 0; t < this.map.length; t++) {
      const n = this.map[t];
      if (n != e) continue;
      const r = t % this.width, i = t / this.width | 0;
      let o = r + 1, s = i + 1;
      for (let l = 1; o < this.width && this.map[t + l] == n; l++) o++;
      for (let l = 1; s < this.height && this.map[t + this.width * l] == n; l++) s++;
      return {
        left: r,
        top: i,
        right: o,
        bottom: s
      };
    }
    throw new RangeError(`No cell with offset ${e} found`);
  }
  colCount(e) {
    for (let t = 0; t < this.map.length; t++) if (this.map[t] == e) return t % this.width;
    throw new RangeError(`No cell with offset ${e} found`);
  }
  nextCell(e, t, n) {
    const { left: r, right: i, top: o, bottom: s } = this.findCell(e);
    return t == "horiz" ? (n < 0 ? r == 0 : i == this.width) ? null : this.map[o * this.width + (n < 0 ? r - 1 : i)] : (n < 0 ? o == 0 : s == this.height) ? null : this.map[r + this.width * (n < 0 ? o - 1 : s)];
  }
  rectBetween(e, t) {
    const { left: n, right: r, top: i, bottom: o } = this.findCell(e), { left: s, right: l, top: c, bottom: a } = this.findCell(t);
    return {
      left: Math.min(n, s),
      top: Math.min(i, c),
      right: Math.max(r, l),
      bottom: Math.max(o, a)
    };
  }
  cellsInRect(e) {
    const t = [], n = {};
    for (let r = e.top; r < e.bottom; r++) for (let i = e.left; i < e.right; i++) {
      const o = r * this.width + i, s = this.map[o];
      n[s] || (n[s] = !0, !(i == e.left && i && this.map[o - 1] == s || r == e.top && r && this.map[o - this.width] == s) && t.push(s));
    }
    return t;
  }
  positionAt(e, t, n) {
    for (let r = 0, i = 0; ; r++) {
      const o = i + n.child(r).nodeSize;
      if (r == e) {
        let s = t + e * this.width;
        const l = (e + 1) * this.width;
        for (; s < l && this.map[s] < i; ) s++;
        return s == l ? o - 1 : this.map[s];
      }
      i = o;
    }
  }
  static get(e) {
    return JX(e) || e9(e, FNt(e));
  }
};
function FNt(e) {
  if (e.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + e.type.name);
  const t = UNt(e), n = e.childCount, r = [];
  let i = 0, o = null;
  const s = [];
  for (let a = 0, u = t * n; a < u; a++) r[a] = 0;
  for (let a = 0, u = 0; a < n; a++) {
    const f = e.child(a);
    u++;
    for (let h = 0; ; h++) {
      for (; i < r.length && r[i] != 0; ) i++;
      if (h == f.childCount) break;
      const m = f.child(h), { colspan: v, rowspan: b, colwidth: A } = m.attrs;
      for (let w = 0; w < b; w++) {
        if (w + a >= n) {
          (o || (o = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: b - w
          });
          break;
        }
        const O = i + w * t;
        for (let x = 0; x < v; x++) {
          r[O + x] == 0 ? r[O + x] = u : (o || (o = [])).push({
            type: "collision",
            row: a,
            pos: u,
            n: v - x
          });
          const S = A && A[x];
          if (S) {
            const E = (O + x) % t * 2, k = s[E];
            k == null || k != S && s[E + 1] == 1 ? (s[E] = S, s[E + 1] = 1) : k == S && s[E + 1]++;
          }
        }
      }
      i += v, u += m.nodeSize;
    }
    const d = (a + 1) * t;
    let p = 0;
    for (; i < d; ) r[i++] == 0 && p++;
    p && (o || (o = [])).push({
      type: "missing",
      row: a,
      n: p
    }), u++;
  }
  (t === 0 || n === 0) && (o || (o = [])).push({ type: "zero_sized" });
  const l = new Ui(t, n, r, o);
  let c = !1;
  for (let a = 0; !c && a < s.length; a += 2) s[a] != null && s[a + 1] < n && (c = !0);
  return c && VNt(l, s, e), l;
}
function UNt(e) {
  let t = -1, n = !1;
  for (let r = 0; r < e.childCount; r++) {
    const i = e.child(r);
    let o = 0;
    if (n) for (let s = 0; s < r; s++) {
      const l = e.child(s);
      for (let c = 0; c < l.childCount; c++) {
        const a = l.child(c);
        s + a.attrs.rowspan > r && (o += a.attrs.colspan);
      }
    }
    for (let s = 0; s < i.childCount; s++) {
      const l = i.child(s);
      o += l.attrs.colspan, l.attrs.rowspan > 1 && (n = !0);
    }
    t == -1 ? t = o : t != o && (t = Math.max(t, o));
  }
  return t;
}
function VNt(e, t, n) {
  e.problems || (e.problems = []);
  const r = {};
  for (let i = 0; i < e.map.length; i++) {
    const o = e.map[i];
    if (r[o]) continue;
    r[o] = !0;
    const s = n.nodeAt(o);
    if (!s) throw new RangeError(`No cell with offset ${o} found`);
    let l = null;
    const c = s.attrs;
    for (let a = 0; a < c.colspan; a++) {
      const u = t[(i + a) % e.width * 2];
      u != null && (!c.colwidth || c.colwidth[a] != u) && ((l || (l = qNt(c)))[a] = u);
    }
    l && e.problems.unshift({
      type: "colwidth mismatch",
      pos: o,
      colwidth: l
    });
  }
}
function qNt(e) {
  if (e.colwidth) return e.colwidth.slice();
  const t = [];
  for (let n = 0; n < e.colspan; n++) t.push(0);
  return t;
}
function ta(e) {
  let t = e.cached.tableNodeTypes;
  if (!t) {
    t = e.cached.tableNodeTypes = {};
    for (const n in e.nodes) {
      const r = e.nodes[n], i = r.spec.tableRole;
      i && (t[i] = r);
    }
  }
  return t;
}
const um = new gi("selectingCells");
function Bv(e) {
  for (let t = e.depth - 1; t > 0; t--) if (e.node(t).type.spec.tableRole == "row") return e.node(0).resolve(e.before(t + 1));
  return null;
}
function BNt(e) {
  for (let t = e.depth; t > 0; t--) {
    const n = e.node(t).type.spec.tableRole;
    if (n === "cell" || n === "header_cell") return e.node(t);
  }
  return null;
}
function Od(e) {
  const t = e.selection.$head;
  for (let n = t.depth; n > 0; n--) if (t.node(n).type.spec.tableRole == "row") return !0;
  return !1;
}
function Lj(e) {
  const t = e.selection;
  if ("$anchorCell" in t && t.$anchorCell) return t.$anchorCell.pos > t.$headCell.pos ? t.$anchorCell : t.$headCell;
  if ("node" in t && t.node && t.node.type.spec.tableRole == "cell") return t.$anchor;
  const n = Bv(t.$head) || XNt(t.$head);
  if (n) return n;
  throw new RangeError(`No cell found around position ${t.head}`);
}
function XNt(e) {
  for (let t = e.nodeAfter, n = e.pos; t; t = t.firstChild, n++) {
    const r = t.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return e.doc.resolve(n);
  }
  for (let t = e.nodeBefore, n = e.pos; t; t = t.lastChild, n--) {
    const r = t.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return e.doc.resolve(n - t.nodeSize);
  }
}
function t9(e) {
  return e.parent.type.spec.tableRole == "row" && !!e.nodeAfter;
}
function WNt(e) {
  return e.node(0).resolve(e.pos + e.nodeAfter.nodeSize);
}
function DK(e, t) {
  return e.depth == t.depth && e.pos >= t.start(-1) && e.pos <= t.end(-1);
}
function IRe(e, t, n) {
  const r = e.node(-1), i = Ui.get(r), o = e.start(-1), s = i.nextCell(e.pos - o, t, n);
  return s == null ? null : e.node(0).resolve(o + s);
}
function Xv(e, t, n = 1) {
  const r = {
    ...e,
    colspan: e.colspan - n
  };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(t, n), r.colwidth.some((i) => i > 0) || (r.colwidth = null)), r;
}
function RRe(e, t, n = 1) {
  const r = {
    ...e,
    colspan: e.colspan + n
  };
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let i = 0; i < n; i++) r.colwidth.splice(t, 0, 0);
  }
  return r;
}
function ZNt(e, t, n) {
  const r = ta(t.type.schema).header_cell;
  for (let i = 0; i < e.height; i++) if (t.nodeAt(e.map[n + i * e.width]).type != r) return !1;
  return !0;
}
var ii = class vp extends En {
  constructor(t, n = t) {
    const r = t.node(-1), i = Ui.get(r), o = t.start(-1), s = i.rectBetween(t.pos - o, n.pos - o), l = t.node(0), c = i.cellsInRect(s).filter((u) => u != n.pos - o);
    c.unshift(n.pos - o);
    const a = c.map((u) => {
      const f = r.nodeAt(u);
      if (!f) throw new RangeError(`No cell with offset ${u} found`);
      const d = o + u + 1;
      return new qPe(l.resolve(d), l.resolve(d + f.content.size));
    });
    super(a[0].$from, a[0].$to, a), this.$anchorCell = t, this.$headCell = n;
  }
  map(t, n) {
    const r = t.resolve(n.map(this.$anchorCell.pos)), i = t.resolve(n.map(this.$headCell.pos));
    if (t9(r) && t9(i) && DK(r, i)) {
      const o = this.$anchorCell.node(-1) != r.node(-1);
      return o && this.isRowSelection() ? vp.rowSelection(r, i) : o && this.isColSelection() ? vp.colSelection(r, i) : new vp(r, i);
    }
    return pn.between(r, i);
  }
  content() {
    const t = this.$anchorCell.node(-1), n = Ui.get(t), r = this.$anchorCell.start(-1), i = n.rectBetween(this.$anchorCell.pos - r, this.$headCell.pos - r), o = {}, s = [];
    for (let c = i.top; c < i.bottom; c++) {
      const a = [];
      for (let u = c * n.width + i.left, f = i.left; f < i.right; f++, u++) {
        const d = n.map[u];
        if (o[d]) continue;
        o[d] = !0;
        const p = n.findCell(d);
        let h = t.nodeAt(d);
        if (!h) throw new RangeError(`No cell with offset ${d} found`);
        const m = i.left - p.left, v = p.right - i.right;
        if (m > 0 || v > 0) {
          let b = h.attrs;
          if (m > 0 && (b = Xv(b, 0, m)), v > 0 && (b = Xv(b, b.colspan - v, v)), p.left < i.left) {
            if (h = h.type.createAndFill(b), !h) throw new RangeError(`Could not create cell with attrs ${JSON.stringify(b)}`);
          } else h = h.type.create(b, h.content);
        }
        if (p.top < i.top || p.bottom > i.bottom) {
          const b = {
            ...h.attrs,
            rowspan: Math.min(p.bottom, i.bottom) - Math.max(p.top, i.top)
          };
          p.top < i.top ? h = h.type.createAndFill(b) : h = h.type.create(b, h.content);
        }
        a.push(h);
      }
      s.push(t.child(c).copy(at.from(a)));
    }
    const l = this.isColSelection() && this.isRowSelection() ? t : s;
    return new zt(at.from(l), 1, 1);
  }
  replace(t, n = zt.empty) {
    const r = t.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      const { $from: l, $to: c } = i[s], a = t.mapping.slice(r);
      t.replace(a.map(l.pos), a.map(c.pos), s ? zt.empty : n);
    }
    const o = En.findFrom(t.doc.resolve(t.mapping.slice(r).map(this.to)), -1);
    o && t.setSelection(o);
  }
  replaceWith(t, n) {
    this.replace(t, new zt(at.from(n), 0, 0));
  }
  forEachCell(t) {
    const n = this.$anchorCell.node(-1), r = Ui.get(n), i = this.$anchorCell.start(-1), o = r.cellsInRect(r.rectBetween(this.$anchorCell.pos - i, this.$headCell.pos - i));
    for (let s = 0; s < o.length; s++) t(n.nodeAt(o[s]), i + o[s]);
  }
  isColSelection() {
    const t = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(t, n) > 0) return !1;
    const r = t + this.$anchorCell.nodeAfter.attrs.rowspan, i = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, i) == this.$headCell.node(-1).childCount;
  }
  static colSelection(t, n = t) {
    const r = t.node(-1), i = Ui.get(r), o = t.start(-1), s = i.findCell(t.pos - o), l = i.findCell(n.pos - o), c = t.node(0);
    return s.top <= l.top ? (s.top > 0 && (t = c.resolve(o + i.map[s.left])), l.bottom < i.height && (n = c.resolve(o + i.map[i.width * (i.height - 1) + l.right - 1]))) : (l.top > 0 && (n = c.resolve(o + i.map[l.left])), s.bottom < i.height && (t = c.resolve(o + i.map[i.width * (i.height - 1) + s.right - 1]))), new vp(t, n);
  }
  isRowSelection() {
    const t = this.$anchorCell.node(-1), n = Ui.get(t), r = this.$anchorCell.start(-1), i = n.colCount(this.$anchorCell.pos - r), o = n.colCount(this.$headCell.pos - r);
    if (Math.min(i, o) > 0) return !1;
    const s = i + this.$anchorCell.nodeAfter.attrs.colspan, l = o + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(s, l) == n.width;
  }
  eq(t) {
    return t instanceof vp && t.$anchorCell.pos == this.$anchorCell.pos && t.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(t, n = t) {
    const r = t.node(-1), i = Ui.get(r), o = t.start(-1), s = i.findCell(t.pos - o), l = i.findCell(n.pos - o), c = t.node(0);
    return s.left <= l.left ? (s.left > 0 && (t = c.resolve(o + i.map[s.top * i.width])), l.right < i.width && (n = c.resolve(o + i.map[i.width * (l.top + 1) - 1]))) : (l.left > 0 && (n = c.resolve(o + i.map[l.top * i.width])), s.right < i.width && (t = c.resolve(o + i.map[i.width * (s.top + 1) - 1]))), new vp(t, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(t, n) {
    return new vp(t.resolve(n.anchor), t.resolve(n.head));
  }
  static create(t, n, r = n) {
    return new vp(t.resolve(n), t.resolve(r));
  }
  getBookmark() {
    return new HNt(this.$anchorCell.pos, this.$headCell.pos);
  }
};
ii.prototype.visible = !1;
En.jsonID("cell", ii);
var HNt = class MRe {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new MRe(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    const n = t.resolve(this.anchor), r = t.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && DK(n, r) ? new ii(n, r) : En.near(r, 1);
  }
};
function QNt(e) {
  if (!(e.selection instanceof ii)) return null;
  const t = [];
  return e.selection.forEachCell((n, r) => {
    t.push(za.node(r, r + n.nodeSize, { class: "selectedCell" }));
  }), Vr.create(e.doc, t);
}
function $Nt({ $from: e, $to: t }) {
  if (e.pos == t.pos || e.pos < t.pos - 6) return !1;
  let n = e.pos, r = t.pos, i = e.depth;
  for (; i >= 0 && !(e.after(i + 1) < e.end(i)); i--, n++) ;
  for (let o = t.depth; o >= 0 && !(t.before(o + 1) > t.start(o)); o--, r--) ;
  return n == r && /row|table/.test(e.node(i).type.spec.tableRole);
}
function KNt({ $from: e, $to: t }) {
  let n, r;
  for (let i = e.depth; i > 0; i--) {
    const o = e.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      n = o;
      break;
    }
  }
  for (let i = t.depth; i > 0; i--) {
    const o = t.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      r = o;
      break;
    }
  }
  return n !== r && t.parentOffset === 0;
}
function GNt(e, t, n) {
  const r = (t || e).selection, i = (t || e).doc;
  let o, s;
  if (r instanceof dn && (s = r.node.type.spec.tableRole)) {
    if (s == "cell" || s == "header_cell") o = ii.create(i, r.from);
    else if (s == "row") {
      const l = i.resolve(r.from + 1);
      o = ii.rowSelection(l, l);
    } else if (!n) {
      const l = Ui.get(r.node), c = r.from + 1, a = c + l.map[l.width * l.height - 1];
      o = ii.create(i, c + 1, a);
    }
  } else r instanceof pn && $Nt(r) ? o = pn.create(i, r.from) : r instanceof pn && KNt(r) && (o = pn.create(i, r.$from.start(), r.$from.end()));
  return o && (t || (t = e.tr)).setSelection(o), t;
}
const YNt = new gi("fix-tables");
function DRe(e, t, n, r) {
  const i = e.childCount, o = t.childCount;
  e: for (let s = 0, l = 0; s < o; s++) {
    const c = t.child(s);
    for (let a = l, u = Math.min(i, s + 3); a < u; a++) if (e.child(a) == c) {
      l = a + 1, n += c.nodeSize;
      continue e;
    }
    r(c, n), l < i && e.child(l).sameMarkup(c) ? DRe(e.child(l), c, n + 1, r) : c.nodesBetween(0, c.content.size, r, n + 1), n += c.nodeSize;
  }
}
function _Re(e, t) {
  let n;
  const r = (i, o) => {
    i.type.spec.tableRole == "table" && (n = JNt(e, i, o, n));
  };
  return t ? t.doc != e.doc && DRe(t.doc, e.doc, 0, r) : e.doc.descendants(r), n;
}
function JNt(e, t, n, r) {
  const i = Ui.get(t);
  if (!i.problems) return r;
  r || (r = e.tr);
  const o = [];
  for (let c = 0; c < i.height; c++) o.push(0);
  for (let c = 0; c < i.problems.length; c++) {
    const a = i.problems[c];
    if (a.type == "collision") {
      const u = t.nodeAt(a.pos);
      if (!u) continue;
      const f = u.attrs;
      for (let d = 0; d < f.rowspan; d++) o[a.row + d] += a.n;
      r.setNodeMarkup(r.mapping.map(n + 1 + a.pos), null, Xv(f, f.colspan - a.n, a.n));
    } else if (a.type == "missing") o[a.row] += a.n;
    else if (a.type == "overlong_rowspan") {
      const u = t.nodeAt(a.pos);
      if (!u) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + a.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - a.n
      });
    } else if (a.type == "colwidth mismatch") {
      const u = t.nodeAt(a.pos);
      if (!u) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + a.pos), null, {
        ...u.attrs,
        colwidth: a.colwidth
      });
    } else if (a.type == "zero_sized") {
      const u = r.mapping.map(n);
      r.delete(u, u + t.nodeSize);
    }
  }
  let s, l;
  for (let c = 0; c < o.length; c++) o[c] && (s == null && (s = c), l = c);
  for (let c = 0, a = n + 1; c < i.height; c++) {
    const u = t.child(c), f = a + u.nodeSize, d = o[c];
    if (d > 0) {
      let p = "cell";
      u.firstChild && (p = u.firstChild.type.spec.tableRole);
      const h = [];
      for (let v = 0; v < d; v++) {
        const b = ta(e.schema)[p].createAndFill();
        b && h.push(b);
      }
      const m = (c == 0 || s == c - 1) && l == c ? a + 1 : f - 1;
      r.insert(r.mapping.map(m), h);
    }
    a = f;
  }
  return r.setMeta(YNt, { fixTables: !0 });
}
function jf(e) {
  const t = e.selection, n = Lj(e), r = n.node(-1), i = n.start(-1), o = Ui.get(r);
  return {
    ...t instanceof ii ? o.rectBetween(t.$anchorCell.pos - i, t.$headCell.pos - i) : o.findCell(n.pos - i),
    tableStart: i,
    map: o,
    table: r
  };
}
function LRe(e, { map: t, tableStart: n, table: r }, i) {
  let o = i > 0 ? -1 : 0;
  ZNt(t, r, i + o) && (o = i == 0 || i == t.width ? null : 0);
  for (let s = 0; s < t.height; s++) {
    const l = s * t.width + i;
    if (i > 0 && i < t.width && t.map[l - 1] == t.map[l]) {
      const c = t.map[l], a = r.nodeAt(c);
      e.setNodeMarkup(e.mapping.map(n + c), null, RRe(a.attrs, i - t.colCount(c))), s += a.attrs.rowspan - 1;
    } else {
      const c = o == null ? ta(r.type.schema).cell : r.nodeAt(t.map[l + o]).type, a = t.positionAt(s, i, r);
      e.insert(e.mapping.map(n + a), c.createAndFill());
    }
  }
  return e;
}
function ePt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e);
    t(LRe(e.tr, n, n.left));
  }
  return !0;
}
function tPt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e);
    t(LRe(e.tr, n, n.right));
  }
  return !0;
}
function nPt(e, { map: t, table: n, tableStart: r }, i) {
  const o = e.mapping.maps.length;
  for (let s = 0; s < t.height; ) {
    const l = s * t.width + i, c = t.map[l], a = n.nodeAt(c), u = a.attrs;
    if (i > 0 && t.map[l - 1] == c || i < t.width - 1 && t.map[l + 1] == c) e.setNodeMarkup(e.mapping.slice(o).map(r + c), null, Xv(u, i - t.colCount(c)));
    else {
      const f = e.mapping.slice(o).map(r + c);
      e.delete(f, f + a.nodeSize);
    }
    s += u.rowspan;
  }
}
function rPt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e), r = e.tr;
    if (n.left == 0 && n.right == n.map.width) return !1;
    for (let i = n.right - 1; nPt(r, n, i), i != n.left; i--) {
      const o = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!o) throw new RangeError("No table found");
      n.table = o, n.map = Ui.get(o);
    }
    t(r);
  }
  return !0;
}
function iPt(e, t, n) {
  var r;
  const i = ta(t.type.schema).header_cell;
  for (let o = 0; o < e.width; o++) if (((r = t.nodeAt(e.map[o + n * e.width])) === null || r === void 0 ? void 0 : r.type) != i) return !1;
  return !0;
}
function zRe(e, { map: t, tableStart: n, table: r }, i) {
  let o = n;
  for (let a = 0; a < i; a++) o += r.child(a).nodeSize;
  const s = [];
  let l = i > 0 ? -1 : 0;
  iPt(t, r, i + l) && (l = i == 0 || i == t.height ? null : 0);
  for (let a = 0, u = t.width * i; a < t.width; a++, u++) if (i > 0 && i < t.height && t.map[u] == t.map[u - t.width]) {
    const f = t.map[u], d = r.nodeAt(f).attrs;
    e.setNodeMarkup(n + f, null, {
      ...d,
      rowspan: d.rowspan + 1
    }), a += d.colspan - 1;
  } else {
    var c;
    const f = l == null ? ta(r.type.schema).cell : (c = r.nodeAt(t.map[u + l * t.width])) === null || c === void 0 ? void 0 : c.type, d = f == null ? void 0 : f.createAndFill();
    d && s.push(d);
  }
  return e.insert(o, ta(r.type.schema).row.create(null, s)), e;
}
function oPt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e);
    t(zRe(e.tr, n, n.top));
  }
  return !0;
}
function sPt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e);
    t(zRe(e.tr, n, n.bottom));
  }
  return !0;
}
function aPt(e, { map: t, table: n, tableStart: r }, i) {
  let o = 0;
  for (let a = 0; a < i; a++) o += n.child(a).nodeSize;
  const s = o + n.child(i).nodeSize, l = e.mapping.maps.length;
  e.delete(o + r, s + r);
  const c = /* @__PURE__ */ new Set();
  for (let a = 0, u = i * t.width; a < t.width; a++, u++) {
    const f = t.map[u];
    if (!c.has(f)) {
      if (c.add(f), i > 0 && f == t.map[u - t.width]) {
        const d = n.nodeAt(f).attrs;
        e.setNodeMarkup(e.mapping.slice(l).map(f + r), null, {
          ...d,
          rowspan: d.rowspan - 1
        }), a += d.colspan - 1;
      } else if (i < t.height && f == t.map[u + t.width]) {
        const d = n.nodeAt(f), p = d.attrs, h = d.type.create({
          ...p,
          rowspan: d.attrs.rowspan - 1
        }, d.content), m = t.positionAt(i + 1, a, n);
        e.insert(e.mapping.slice(l).map(r + m), h), a += p.colspan - 1;
      }
    }
  }
}
function lPt(e, t) {
  if (!Od(e)) return !1;
  if (t) {
    const n = jf(e), r = e.tr;
    if (n.top == 0 && n.bottom == n.map.height) return !1;
    for (let i = n.bottom - 1; aPt(r, n, i), i != n.top; i--) {
      const o = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!o) throw new RangeError("No table found");
      n.table = o, n.map = Ui.get(n.table);
    }
    t(r);
  }
  return !0;
}
function Ale(e) {
  const t = e.content;
  return t.childCount == 1 && t.child(0).isTextblock && t.child(0).childCount == 0;
}
function cPt({ width: e, height: t, map: n }, r) {
  let i = r.top * e + r.left, o = i, s = (r.bottom - 1) * e + r.left, l = i + (r.right - r.left - 1);
  for (let c = r.top; c < r.bottom; c++) {
    if (r.left > 0 && n[o] == n[o - 1] || r.right < e && n[l] == n[l + 1]) return !0;
    o += e, l += e;
  }
  for (let c = r.left; c < r.right; c++) {
    if (r.top > 0 && n[i] == n[i - e] || r.bottom < t && n[s] == n[s + e]) return !0;
    i++, s++;
  }
  return !1;
}
function wle(e, t) {
  const n = e.selection;
  if (!(n instanceof ii) || n.$anchorCell.pos == n.$headCell.pos) return !1;
  const r = jf(e), { map: i } = r;
  if (cPt(i, r)) return !1;
  if (t) {
    const o = e.tr, s = {};
    let l = at.empty, c, a;
    for (let u = r.top; u < r.bottom; u++) for (let f = r.left; f < r.right; f++) {
      const d = i.map[u * i.width + f], p = r.table.nodeAt(d);
      if (!(s[d] || !p))
        if (s[d] = !0, c == null)
          c = d, a = p;
        else {
          Ale(p) || (l = l.append(p.content));
          const h = o.mapping.map(d + r.tableStart);
          o.delete(h, h + p.nodeSize);
        }
    }
    if (c == null || a == null) return !0;
    if (o.setNodeMarkup(c + r.tableStart, null, {
      ...RRe(a.attrs, a.attrs.colspan, r.right - r.left - a.attrs.colspan),
      rowspan: r.bottom - r.top
    }), l.size > 0) {
      const u = c + 1 + a.content.size, f = Ale(a) ? c + 1 : u;
      o.replaceWith(f + r.tableStart, u + r.tableStart, l);
    }
    o.setSelection(new ii(o.doc.resolve(c + r.tableStart))), t(o);
  }
  return !0;
}
function xle(e, t) {
  const n = ta(e.schema);
  return uPt(({ node: r }) => n[r.type.spec.tableRole])(e, t);
}
function uPt(e) {
  return (t, n) => {
    const r = t.selection;
    let i, o;
    if (r instanceof ii) {
      if (r.$anchorCell.pos != r.$headCell.pos) return !1;
      i = r.$anchorCell.nodeAfter, o = r.$anchorCell.pos;
    } else {
      var s;
      if (i = BNt(r.$from), !i) return !1;
      o = (s = Bv(r.$from)) === null || s === void 0 ? void 0 : s.pos;
    }
    if (i == null || o == null || i.attrs.colspan == 1 && i.attrs.rowspan == 1) return !1;
    if (n) {
      let l = i.attrs;
      const c = [], a = l.colwidth;
      l.rowspan > 1 && (l = {
        ...l,
        rowspan: 1
      }), l.colspan > 1 && (l = {
        ...l,
        colspan: 1
      });
      const u = jf(t), f = t.tr;
      for (let p = 0; p < u.right - u.left; p++) c.push(a ? {
        ...l,
        colwidth: a && a[p] ? [a[p]] : null
      } : l);
      let d;
      for (let p = u.top; p < u.bottom; p++) {
        let h = u.map.positionAt(p, u.left, u.table);
        p == u.top && (h += i.nodeSize);
        for (let m = u.left, v = 0; m < u.right; m++, v++)
          m == u.left && p == u.top || f.insert(d = f.mapping.map(h + u.tableStart, 1), e({
            node: i,
            row: p,
            col: m
          }).createAndFill(c[v]));
      }
      f.setNodeMarkup(o, e({
        node: i,
        row: u.top,
        col: u.left
      }), c[0]), r instanceof ii && f.setSelection(new ii(f.doc.resolve(r.$anchorCell.pos), d ? f.doc.resolve(d) : void 0)), n(f);
    }
    return !0;
  };
}
function dPt(e, t) {
  return function(n, r) {
    if (!Od(n)) return !1;
    const i = Lj(n);
    if (i.nodeAfter.attrs[e] === t) return !1;
    if (r) {
      const o = n.tr;
      n.selection instanceof ii ? n.selection.forEachCell((s, l) => {
        s.attrs[e] !== t && o.setNodeMarkup(l, null, {
          ...s.attrs,
          [e]: t
        });
      }) : o.setNodeMarkup(i.pos, null, {
        ...i.nodeAfter.attrs,
        [e]: t
      }), r(o);
    }
    return !0;
  };
}
function fPt(e) {
  return function(t, n) {
    if (!Od(t)) return !1;
    if (n) {
      const r = ta(t.schema), i = jf(t), o = t.tr, s = i.map.cellsInRect(e == "column" ? {
        left: i.left,
        top: 0,
        right: i.right,
        bottom: i.map.height
      } : e == "row" ? {
        left: 0,
        top: i.top,
        right: i.map.width,
        bottom: i.bottom
      } : i), l = s.map((c) => i.table.nodeAt(c));
      for (let c = 0; c < s.length; c++) l[c].type == r.header_cell && o.setNodeMarkup(i.tableStart + s[c], r.cell, l[c].attrs);
      if (o.steps.length === 0) for (let c = 0; c < s.length; c++) o.setNodeMarkup(i.tableStart + s[c], r.header_cell, l[c].attrs);
      n(o);
    }
    return !0;
  };
}
function Sle(e, t, n) {
  const r = t.map.cellsInRect({
    left: 0,
    top: 0,
    right: e == "row" ? t.map.width : 1,
    bottom: e == "column" ? t.map.height : 1
  });
  for (let i = 0; i < r.length; i++) {
    const o = t.table.nodeAt(r[i]);
    if (o && o.type !== n.header_cell) return !1;
  }
  return !0;
}
function ak(e, t) {
  return t = t || { useDeprecatedLogic: !1 }, t.useDeprecatedLogic ? fPt(e) : function(n, r) {
    if (!Od(n)) return !1;
    if (r) {
      const i = ta(n.schema), o = jf(n), s = n.tr, l = Sle("row", o, i), c = Sle("column", o, i), a = (e === "column" ? l : e === "row" && c) ? 1 : 0, u = e == "column" ? {
        left: 0,
        top: a,
        right: 1,
        bottom: o.map.height
      } : e == "row" ? {
        left: a,
        top: 0,
        right: o.map.width,
        bottom: 1
      } : o, f = e == "column" ? c ? i.cell : i.header_cell : e == "row" ? l ? i.cell : i.header_cell : i.cell;
      o.map.cellsInRect(u).forEach((d) => {
        const p = d + o.tableStart, h = s.doc.nodeAt(p);
        h && s.setNodeMarkup(p, f, h.attrs);
      }), r(s);
    }
    return !0;
  };
}
ak("row", { useDeprecatedLogic: !0 });
ak("column", { useDeprecatedLogic: !0 });
const pPt = ak("cell", { useDeprecatedLogic: !0 });
function hPt(e, t) {
  if (t < 0) {
    const n = e.nodeBefore;
    if (n) return e.pos - n.nodeSize;
    for (let r = e.index(-1) - 1, i = e.before(); r >= 0; r--) {
      const o = e.node(-1).child(r), s = o.lastChild;
      if (s) return i - 1 - s.nodeSize;
      i -= o.nodeSize;
    }
  } else {
    if (e.index() < e.parent.childCount - 1) return e.pos + e.nodeAfter.nodeSize;
    const n = e.node(-1);
    for (let r = e.indexAfter(-1), i = e.after(); r < n.childCount; r++) {
      const o = n.child(r);
      if (o.childCount) return i + 1;
      i += o.nodeSize;
    }
  }
  return null;
}
function Ele(e) {
  return function(t, n) {
    if (!Od(t)) return !1;
    const r = hPt(Lj(t), e);
    if (r == null) return !1;
    if (n) {
      const i = t.doc.resolve(r);
      n(t.tr.setSelection(pn.between(i, WNt(i))).scrollIntoView());
    }
    return !0;
  };
}
function mPt(e, t) {
  const n = e.selection.$anchor;
  for (let r = n.depth; r > 0; r--) if (n.node(r).type.spec.tableRole == "table")
    return t && t(e.tr.delete(n.before(r), n.after(r)).scrollIntoView()), !0;
  return !1;
}
function rI(e, t) {
  const n = e.selection;
  if (!(n instanceof ii)) return !1;
  if (t) {
    const r = e.tr, i = ta(e.schema).cell.createAndFill().content;
    n.forEachCell((o, s) => {
      o.content.eq(i) || r.replace(r.mapping.map(s + 1), r.mapping.map(s + o.nodeSize - 1), new zt(i, 0, 0));
    }), r.docChanged && t(r);
  }
  return !0;
}
function gPt(e) {
  if (e.size === 0) return null;
  let { content: t, openStart: n, openEnd: r } = e;
  for (; t.childCount == 1 && (n > 0 && r > 0 || t.child(0).type.spec.tableRole == "table"); )
    n--, r--, t = t.child(0).content;
  const i = t.child(0), o = i.type.spec.tableRole, s = i.type.schema, l = [];
  if (o == "row") for (let c = 0; c < t.childCount; c++) {
    let a = t.child(c).content;
    const u = c ? 0 : Math.max(0, n - 1), f = c < t.childCount - 1 ? 0 : Math.max(0, r - 1);
    (u || f) && (a = n9(ta(s).row, new zt(a, u, f)).content), l.push(a);
  }
  else if (o == "cell" || o == "header_cell") l.push(n || r ? n9(ta(s).row, new zt(t, n, r)).content : t);
  else return null;
  return yPt(s, l);
}
function yPt(e, t) {
  const n = [];
  for (let i = 0; i < t.length; i++) {
    const o = t[i];
    for (let s = o.childCount - 1; s >= 0; s--) {
      const { rowspan: l, colspan: c } = o.child(s).attrs;
      for (let a = i; a < i + l; a++) n[a] = (n[a] || 0) + c;
    }
  }
  let r = 0;
  for (let i = 0; i < n.length; i++) r = Math.max(r, n[i]);
  for (let i = 0; i < n.length; i++)
    if (i >= t.length && t.push(at.empty), n[i] < r) {
      const o = ta(e).cell.createAndFill(), s = [];
      for (let l = n[i]; l < r; l++) s.push(o);
      t[i] = t[i].append(at.from(s));
    }
  return {
    height: t.length,
    width: r,
    rows: t
  };
}
function n9(e, t) {
  const n = e.createAndFill();
  return new nK(n).replace(0, n.content.size, t).doc;
}
function vPt({ width: e, height: t, rows: n }, r, i) {
  if (e != r) {
    const o = [], s = [];
    for (let l = 0; l < n.length; l++) {
      const c = n[l], a = [];
      for (let u = o[l] || 0, f = 0; u < r; f++) {
        let d = c.child(f % c.childCount);
        u + d.attrs.colspan > r && (d = d.type.createChecked(Xv(d.attrs, d.attrs.colspan, u + d.attrs.colspan - r), d.content)), a.push(d), u += d.attrs.colspan;
        for (let p = 1; p < d.attrs.rowspan; p++) o[l + p] = (o[l + p] || 0) + d.attrs.colspan;
      }
      s.push(at.from(a));
    }
    n = s, e = r;
  }
  if (t != i) {
    const o = [];
    for (let s = 0, l = 0; s < i; s++, l++) {
      const c = [], a = n[l % t];
      for (let u = 0; u < a.childCount; u++) {
        let f = a.child(u);
        s + f.attrs.rowspan > i && (f = f.type.create({
          ...f.attrs,
          rowspan: Math.max(1, i - f.attrs.rowspan)
        }, f.content)), c.push(f);
      }
      o.push(at.from(c));
    }
    n = o, t = i;
  }
  return {
    width: e,
    height: t,
    rows: n
  };
}
function bPt(e, t, n, r, i, o, s) {
  const l = e.doc.type.schema, c = ta(l);
  let a, u;
  if (i > t.width) for (let f = 0, d = 0; f < t.height; f++) {
    const p = n.child(f);
    d += p.nodeSize;
    const h = [];
    let m;
    p.lastChild == null || p.lastChild.type == c.cell ? m = a || (a = c.cell.createAndFill()) : m = u || (u = c.header_cell.createAndFill());
    for (let v = t.width; v < i; v++) h.push(m);
    e.insert(e.mapping.slice(s).map(d - 1 + r), h);
  }
  if (o > t.height) {
    const f = [];
    for (let h = 0, m = (t.height - 1) * t.width; h < Math.max(t.width, i); h++) {
      const v = h >= t.width ? !1 : n.nodeAt(t.map[m + h]).type == c.header_cell;
      f.push(v ? u || (u = c.header_cell.createAndFill()) : a || (a = c.cell.createAndFill()));
    }
    const d = c.row.create(null, at.from(f)), p = [];
    for (let h = t.height; h < o; h++) p.push(d);
    e.insert(e.mapping.slice(s).map(r + n.nodeSize - 2), p);
  }
  return !!(a || u);
}
function Tle(e, t, n, r, i, o, s, l) {
  if (s == 0 || s == t.height) return !1;
  let c = !1;
  for (let a = i; a < o; a++) {
    const u = s * t.width + a, f = t.map[u];
    if (t.map[u - t.width] == f) {
      c = !0;
      const d = n.nodeAt(f), { top: p, left: h } = t.findCell(f);
      e.setNodeMarkup(e.mapping.slice(l).map(f + r), null, {
        ...d.attrs,
        rowspan: s - p
      }), e.insert(e.mapping.slice(l).map(t.positionAt(s, h, n)), d.type.createAndFill({
        ...d.attrs,
        rowspan: p + d.attrs.rowspan - s
      })), a += d.attrs.colspan - 1;
    }
  }
  return c;
}
function kle(e, t, n, r, i, o, s, l) {
  if (s == 0 || s == t.width) return !1;
  let c = !1;
  for (let a = i; a < o; a++) {
    const u = a * t.width + s, f = t.map[u];
    if (t.map[u - 1] == f) {
      c = !0;
      const d = n.nodeAt(f), p = t.colCount(f), h = e.mapping.slice(l).map(f + r);
      e.setNodeMarkup(h, null, Xv(d.attrs, s - p, d.attrs.colspan - (s - p))), e.insert(h + d.nodeSize, d.type.createAndFill(Xv(d.attrs, 0, s - p))), a += d.attrs.rowspan - 1;
    }
  }
  return c;
}
function Cle(e, t, n, r, i) {
  let o = n ? e.doc.nodeAt(n - 1) : e.doc;
  if (!o) throw new Error("No table found");
  let s = Ui.get(o);
  const { top: l, left: c } = r, a = c + i.width, u = l + i.height, f = e.tr;
  let d = 0;
  function p() {
    if (o = n ? f.doc.nodeAt(n - 1) : f.doc, !o) throw new Error("No table found");
    s = Ui.get(o), d = f.mapping.maps.length;
  }
  bPt(f, s, o, n, a, u, d) && p(), Tle(f, s, o, n, c, a, l, d) && p(), Tle(f, s, o, n, c, a, u, d) && p(), kle(f, s, o, n, l, u, c, d) && p(), kle(f, s, o, n, l, u, a, d) && p();
  for (let h = l; h < u; h++) {
    const m = s.positionAt(h, c, o), v = s.positionAt(h, a, o);
    f.replace(f.mapping.slice(d).map(m + n), f.mapping.slice(d).map(v + n), new zt(i.rows[h - l], 0, 0));
  }
  p(), f.setSelection(new ii(f.doc.resolve(n + s.positionAt(l, c, o)), f.doc.resolve(n + s.positionAt(u - 1, a - 1, o)))), t(f);
}
const OPt = yK({
  ArrowLeft: iI("horiz", -1),
  ArrowRight: iI("horiz", 1),
  ArrowUp: iI("vert", -1),
  ArrowDown: iI("vert", 1),
  "Shift-ArrowLeft": oI("horiz", -1),
  "Shift-ArrowRight": oI("horiz", 1),
  "Shift-ArrowUp": oI("vert", -1),
  "Shift-ArrowDown": oI("vert", 1),
  Backspace: rI,
  "Mod-Backspace": rI,
  Delete: rI,
  "Mod-Delete": rI
});
function eM(e, t, n) {
  return n.eq(e.selection) ? !1 : (t && t(e.tr.setSelection(n).scrollIntoView()), !0);
}
function iI(e, t) {
  return (n, r, i) => {
    if (!i) return !1;
    const o = n.selection;
    if (o instanceof ii) return eM(n, r, En.near(o.$headCell, t));
    if (e != "horiz" && !o.empty) return !1;
    const s = jRe(i, e, t);
    if (s == null) return !1;
    if (e == "horiz") return eM(n, r, En.near(n.doc.resolve(o.head + t), t));
    {
      const l = n.doc.resolve(s), c = IRe(l, e, t);
      let a;
      return c ? a = En.near(c, 1) : t < 0 ? a = En.near(n.doc.resolve(l.before(-1)), -1) : a = En.near(n.doc.resolve(l.after(-1)), 1), eM(n, r, a);
    }
  };
}
function oI(e, t) {
  return (n, r, i) => {
    if (!i) return !1;
    const o = n.selection;
    let s;
    if (o instanceof ii) s = o;
    else {
      const c = jRe(i, e, t);
      if (c == null) return !1;
      s = new ii(n.doc.resolve(c));
    }
    const l = IRe(s.$headCell, e, t);
    return l ? eM(n, r, new ii(s.$anchorCell, l)) : !1;
  };
}
function APt(e, t) {
  const n = e.state.doc, r = Bv(n.resolve(t));
  return r ? (e.dispatch(e.state.tr.setSelection(new ii(r))), !0) : !1;
}
function wPt(e, t, n) {
  if (!Od(e.state)) return !1;
  let r = gPt(n);
  const i = e.state.selection;
  if (i instanceof ii) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [at.from(n9(ta(e.state.schema).cell, n))]
    });
    const o = i.$anchorCell.node(-1), s = i.$anchorCell.start(-1), l = Ui.get(o).rectBetween(i.$anchorCell.pos - s, i.$headCell.pos - s);
    return r = vPt(r, l.right - l.left, l.bottom - l.top), Cle(e.state, e.dispatch, s, l, r), !0;
  } else if (r) {
    const o = Lj(e.state), s = o.start(-1);
    return Cle(e.state, e.dispatch, s, Ui.get(o.node(-1)).findCell(o.pos - s), r), !0;
  } else return !1;
}
function xPt(e, t) {
  var n;
  if (t.button != 0 || t.ctrlKey || t.metaKey) return;
  const r = Nle(e, t.target);
  let i;
  if (t.shiftKey && e.state.selection instanceof ii)
    o(e.state.selection.$anchorCell, t), t.preventDefault();
  else if (t.shiftKey && r && (i = Bv(e.state.selection.$anchor)) != null && ((n = oU(e, t)) === null || n === void 0 ? void 0 : n.pos) != i.pos)
    o(i, t), t.preventDefault();
  else if (!r) return;
  function o(c, a) {
    let u = oU(e, a);
    const f = um.getState(e.state) == null;
    if (!u || !DK(c, u)) if (f) u = c;
    else return;
    const d = new ii(c, u);
    if (f || !e.state.selection.eq(d)) {
      const p = e.state.tr.setSelection(d);
      f && p.setMeta(um, c.pos), e.dispatch(p);
    }
  }
  function s() {
    e.root.removeEventListener("mouseup", s), e.root.removeEventListener("dragstart", s), e.root.removeEventListener("mousemove", l), um.getState(e.state) != null && e.dispatch(e.state.tr.setMeta(um, -1));
  }
  function l(c) {
    const a = c, u = um.getState(e.state);
    let f;
    if (u != null) f = e.state.doc.resolve(u);
    else if (Nle(e, a.target) != r && (f = oU(e, t), !f))
      return s();
    f && o(f, a);
  }
  e.root.addEventListener("mouseup", s), e.root.addEventListener("dragstart", s), e.root.addEventListener("mousemove", l);
}
function jRe(e, t, n) {
  if (!(e.state.selection instanceof pn)) return null;
  const { $head: r } = e.state.selection;
  for (let i = r.depth - 1; i >= 0; i--) {
    const o = r.node(i);
    if ((n < 0 ? r.index(i) : r.indexAfter(i)) != (n < 0 ? 0 : o.childCount)) return null;
    if (o.type.spec.tableRole == "cell" || o.type.spec.tableRole == "header_cell") {
      const s = r.before(i), l = t == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return e.endOfTextblock(l) ? s : null;
    }
  }
  return null;
}
function Nle(e, t) {
  for (; t && t != e.dom; t = t.parentNode) if (t.nodeName == "TD" || t.nodeName == "TH") return t;
  return null;
}
function oU(e, t) {
  const n = e.posAtCoords({
    left: t.clientX,
    top: t.clientY
  });
  if (!n) return null;
  let { inside: r, pos: i } = n;
  return r >= 0 && Bv(e.state.doc.resolve(r)) || Bv(e.state.doc.resolve(i));
}
var SPt = class {
  constructor(t, n) {
    this.node = t, this.defaultCellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty("--default-cell-min-width", `${n}px`), this.colgroup = this.table.appendChild(document.createElement("colgroup")), r9(t, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type != this.node.type ? !1 : (this.node = t, r9(t, this.colgroup, this.table, this.defaultCellMinWidth), !0);
  }
  ignoreMutation(t) {
    return t.type == "attributes" && (t.target == this.table || this.colgroup.contains(t.target));
  }
};
function r9(e, t, n, r, i, o) {
  let s = 0, l = !0, c = t.firstChild;
  const a = e.firstChild;
  if (a) {
    for (let f = 0, d = 0; f < a.childCount; f++) {
      const { colspan: p, colwidth: h } = a.child(f).attrs;
      for (let m = 0; m < p; m++, d++) {
        const v = i == d ? o : h && h[m], b = v ? v + "px" : "";
        if (s += v || r, v || (l = !1), c)
          c.style.width != b && (c.style.width = b), c = c.nextSibling;
        else {
          const A = document.createElement("col");
          A.style.width = b, t.appendChild(A);
        }
      }
    }
    for (; c; ) {
      var u;
      const f = c.nextSibling;
      (u = c.parentNode) === null || u === void 0 || u.removeChild(c), c = f;
    }
    l ? (n.style.width = s + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = s + "px");
  }
}
const Yl = new gi("tableColumnResizing");
function EPt({ handleWidth: e = 5, cellMinWidth: t = 25, defaultCellMinWidth: n = 100, View: r = SPt, lastColumnResizable: i = !0 } = {}) {
  const o = new $r({
    key: Yl,
    state: {
      init(s, l) {
        var c;
        const a = (c = o.spec) === null || c === void 0 || (c = c.props) === null || c === void 0 ? void 0 : c.nodeViews, u = ta(l.schema).table.name;
        return r && a && (a[u] = (f, d) => new r(f, n, d)), new TPt(-1, !1);
      },
      apply(s, l) {
        return l.apply(s);
      }
    },
    props: {
      attributes: (s) => {
        const l = Yl.getState(s);
        return l && l.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (s, l) => {
          kPt(s, l, e, i);
        },
        mouseleave: (s) => {
          CPt(s);
        },
        mousedown: (s, l) => {
          NPt(s, l, t, n);
        }
      },
      decorations: (s) => {
        const l = Yl.getState(s);
        if (l && l.activeHandle > -1) return DPt(s, l.activeHandle);
      },
      nodeViews: {}
    }
  });
  return o;
}
var TPt = class tM {
  constructor(t, n) {
    this.activeHandle = t, this.dragging = n;
  }
  apply(t) {
    const n = this, r = t.getMeta(Yl);
    if (r && r.setHandle != null) return new tM(r.setHandle, !1);
    if (r && r.setDragging !== void 0) return new tM(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && t.docChanged) {
      let i = t.mapping.map(n.activeHandle, -1);
      return t9(t.doc.resolve(i)) || (i = -1), new tM(i, n.dragging);
    }
    return n;
  }
};
function kPt(e, t, n, r) {
  if (!e.editable) return;
  const i = Yl.getState(e.state);
  if (i && !i.dragging) {
    const o = IPt(t.target);
    let s = -1;
    if (o) {
      const { left: l, right: c } = o.getBoundingClientRect();
      t.clientX - l <= n ? s = Ple(e, t, "left", n) : c - t.clientX <= n && (s = Ple(e, t, "right", n));
    }
    if (s != i.activeHandle) {
      if (!r && s !== -1) {
        const l = e.state.doc.resolve(s), c = l.node(-1), a = Ui.get(c), u = l.start(-1);
        if (a.colCount(l.pos - u) + l.nodeAfter.attrs.colspan - 1 == a.width - 1) return;
      }
      FRe(e, s);
    }
  }
}
function CPt(e) {
  if (!e.editable) return;
  const t = Yl.getState(e.state);
  t && t.activeHandle > -1 && !t.dragging && FRe(e, -1);
}
function NPt(e, t, n, r) {
  var i;
  if (!e.editable) return !1;
  const o = (i = e.dom.ownerDocument.defaultView) !== null && i !== void 0 ? i : window, s = Yl.getState(e.state);
  if (!s || s.activeHandle == -1 || s.dragging) return !1;
  const l = e.state.doc.nodeAt(s.activeHandle), c = PPt(e, s.activeHandle, l.attrs);
  e.dispatch(e.state.tr.setMeta(Yl, { setDragging: {
    startX: t.clientX,
    startWidth: c
  } }));
  function a(f) {
    o.removeEventListener("mouseup", a), o.removeEventListener("mousemove", u);
    const d = Yl.getState(e.state);
    d != null && d.dragging && (RPt(e, d.activeHandle, Ile(d.dragging, f, n)), e.dispatch(e.state.tr.setMeta(Yl, { setDragging: null })));
  }
  function u(f) {
    if (!f.which) return a(f);
    const d = Yl.getState(e.state);
    if (d && d.dragging) {
      const p = Ile(d.dragging, f, n);
      Rle(e, d.activeHandle, p, r);
    }
  }
  return Rle(e, s.activeHandle, c, r), o.addEventListener("mouseup", a), o.addEventListener("mousemove", u), t.preventDefault(), !0;
}
function PPt(e, t, { colspan: n, colwidth: r }) {
  const i = r && r[r.length - 1];
  if (i) return i;
  const o = e.domAtPos(t);
  let s = o.node.childNodes[o.offset].offsetWidth, l = n;
  if (r)
    for (let c = 0; c < n; c++) r[c] && (s -= r[c], l--);
  return s / l;
}
function IPt(e) {
  for (; e && e.nodeName != "TD" && e.nodeName != "TH"; ) e = e.classList && e.classList.contains("ProseMirror") ? null : e.parentNode;
  return e;
}
function Ple(e, t, n, r) {
  const i = n == "right" ? -r : r, o = e.posAtCoords({
    left: t.clientX + i,
    top: t.clientY
  });
  if (!o) return -1;
  const { pos: s } = o, l = Bv(e.state.doc.resolve(s));
  if (!l) return -1;
  if (n == "right") return l.pos;
  const c = Ui.get(l.node(-1)), a = l.start(-1), u = c.map.indexOf(l.pos - a);
  return u % c.width == 0 ? -1 : a + c.map[u - 1];
}
function Ile(e, t, n) {
  const r = t.clientX - e.startX;
  return Math.max(n, e.startWidth + r);
}
function FRe(e, t) {
  e.dispatch(e.state.tr.setMeta(Yl, { setHandle: t }));
}
function RPt(e, t, n) {
  const r = e.state.doc.resolve(t), i = r.node(-1), o = Ui.get(i), s = r.start(-1), l = o.colCount(r.pos - s) + r.nodeAfter.attrs.colspan - 1, c = e.state.tr;
  for (let a = 0; a < o.height; a++) {
    const u = a * o.width + l;
    if (a && o.map[u] == o.map[u - o.width]) continue;
    const f = o.map[u], d = i.nodeAt(f).attrs, p = d.colspan == 1 ? 0 : l - o.colCount(f);
    if (d.colwidth && d.colwidth[p] == n) continue;
    const h = d.colwidth ? d.colwidth.slice() : MPt(d.colspan);
    h[p] = n, c.setNodeMarkup(s + f, null, {
      ...d,
      colwidth: h
    });
  }
  c.docChanged && e.dispatch(c);
}
function Rle(e, t, n, r) {
  const i = e.state.doc.resolve(t), o = i.node(-1), s = i.start(-1), l = Ui.get(o).colCount(i.pos - s) + i.nodeAfter.attrs.colspan - 1;
  let c = e.domAtPos(i.start(-1)).node;
  for (; c && c.nodeName != "TABLE"; ) c = c.parentNode;
  c && r9(o, c.firstChild, c, r, l, n);
}
function MPt(e) {
  return Array(e).fill(0);
}
function DPt(e, t) {
  const n = [], r = e.doc.resolve(t), i = r.node(-1);
  if (!i) return Vr.empty;
  const o = Ui.get(i), s = r.start(-1), l = o.colCount(r.pos - s) + r.nodeAfter.attrs.colspan - 1;
  for (let a = 0; a < o.height; a++) {
    const u = l + a * o.width;
    if ((l == o.width - 1 || o.map[u] != o.map[u + 1]) && (a == 0 || o.map[u] != o.map[u - o.width])) {
      var c;
      const f = o.map[u], d = s + f + i.nodeAt(f).nodeSize - 1, p = document.createElement("div");
      p.className = "column-resize-handle", !((c = Yl.getState(e)) === null || c === void 0) && c.dragging && n.push(za.node(s + f, s + f + i.nodeAt(f).nodeSize, { class: "column-resize-dragging" })), n.push(za.widget(d, p));
    }
  }
  return Vr.create(e.doc, n);
}
function _Pt({ allowTableNodeSelection: e = !1 } = {}) {
  return new $r({
    key: um,
    state: {
      init() {
        return null;
      },
      apply(t, n) {
        const r = t.getMeta(um);
        if (r != null) return r == -1 ? null : r;
        if (n == null || !t.docChanged) return n;
        const { deleted: i, pos: o } = t.mapping.mapResult(n);
        return i ? null : o;
      }
    },
    props: {
      decorations: QNt,
      handleDOMEvents: { mousedown: xPt },
      createSelectionBetween(t) {
        return um.getState(t.state) != null ? t.state.selection : null;
      },
      handleTripleClick: APt,
      handleKeyDown: OPt,
      handlePaste: wPt
    },
    appendTransaction(t, n, r) {
      return GNt(r, _Re(r, n), e);
    }
  });
}
var LPt = So.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          var t, n;
          const r = e.getAttribute("colwidth"), i = r ? r.split(",").map((o) => parseInt(o, 10)) : null;
          if (!i) {
            const o = (t = e.closest("table")) == null ? void 0 : t.querySelectorAll("colgroup > col"), s = Array.from(((n = e.parentElement) == null ? void 0 : n.children) || []).indexOf(e);
            if (s && s > -1 && o && o[s]) {
              const l = o[s].getAttribute("width");
              return l ? [parseInt(l, 10)] : null;
            }
          }
          return i;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["td", Ir(this.options.HTMLAttributes, e), 0];
  }
}), zPt = So.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (e) => {
          const t = e.getAttribute("colwidth");
          return t ? t.split(",").map((r) => parseInt(r, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["th", Ir(this.options.HTMLAttributes, e), 0];
  }
}), jPt = So.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["tr", Ir(this.options.HTMLAttributes, e), 0];
  }
});
function i9(e, t) {
  return t ? ["width", `${Math.max(t, e)}px`] : ["min-width", `${e}px`];
}
function Mle(e, t, n, r, i, o) {
  var s;
  let l = 0, c = !0, a = t.firstChild;
  const u = e.firstChild;
  if (u !== null)
    for (let d = 0, p = 0; d < u.childCount; d += 1) {
      const { colspan: h, colwidth: m } = u.child(d).attrs;
      for (let v = 0; v < h; v += 1, p += 1) {
        const b = i === p ? o : m && m[v], A = b ? `${b}px` : "";
        if (l += b || r, b || (c = !1), a) {
          if (a.style.width !== A) {
            const [w, O] = i9(r, b);
            a.style.setProperty(w, O);
          }
          a = a.nextSibling;
        } else {
          const w = document.createElement("col"), [O, x] = i9(r, b);
          w.style.setProperty(O, x), t.appendChild(w);
        }
      }
    }
  for (; a; ) {
    const d = a.nextSibling;
    (s = a.parentNode) == null || s.removeChild(a), a = d;
  }
  const f = e.attrs.style && typeof e.attrs.style == "string" && /\bwidth\s*:/i.test(e.attrs.style);
  c && !f ? (n.style.width = `${l}px`, n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = `${l}px`);
}
var FPt = class {
  constructor(e, t) {
    this.node = e, this.cellMinWidth = t, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), e.attrs.style && (this.table.style.cssText = e.attrs.style), this.colgroup = this.table.appendChild(document.createElement("colgroup")), Mle(e, this.colgroup, this.table, t), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type !== this.node.type ? !1 : (this.node = e, Mle(e, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(e) {
    const t = e.target, n = this.dom.contains(t), r = this.contentDOM.contains(t);
    return !!(n && !r && (e.type === "attributes" || e.type === "childList" || e.type === "characterData"));
  }
};
function UPt(e, t, n, r) {
  let i = 0, o = !0;
  const s = [], l = e.firstChild;
  if (!l)
    return {};
  for (let f = 0, d = 0; f < l.childCount; f += 1) {
    const { colspan: p, colwidth: h } = l.child(f).attrs;
    for (let m = 0; m < p; m += 1, d += 1) {
      const v = n === d ? r : h && h[m];
      i += v || t, v || (o = !1);
      const [b, A] = i9(t, v);
      s.push(["col", { style: `${b}: ${A}` }]);
    }
  }
  const c = o ? `${i}px` : "", a = o ? "" : `${i}px`;
  return { colgroup: ["colgroup", {}, ...s], tableWidth: c, tableMinWidth: a };
}
function Dle(e, t) {
  return e.createAndFill();
}
function VPt(e) {
  if (e.cached.tableNodeTypes)
    return e.cached.tableNodeTypes;
  const t = {};
  return Object.keys(e.nodes).forEach((n) => {
    const r = e.nodes[n];
    r.spec.tableRole && (t[r.spec.tableRole] = r);
  }), e.cached.tableNodeTypes = t, t;
}
function qPt(e, t, n, r, i) {
  const o = VPt(e), s = [], l = [];
  for (let a = 0; a < n; a += 1) {
    const u = Dle(o.cell);
    if (u && l.push(u), r) {
      const f = Dle(o.header_cell);
      f && s.push(f);
    }
  }
  const c = [];
  for (let a = 0; a < t; a += 1)
    c.push(o.row.createChecked(null, r && a === 0 ? s : l));
  return o.table.createChecked(null, c);
}
function BPt(e) {
  return e instanceof ii;
}
var sI = ({ editor: e }) => {
  const { selection: t } = e.state;
  if (!BPt(t))
    return !1;
  let n = 0;
  const r = QIe(t.ranges[0].$from, (o) => o.type.name === "table");
  return r == null || r.node.descendants((o) => {
    if (o.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(o.type.name) && (n += 1);
  }), n === t.ranges.length ? (e.commands.deleteTable(), !0) : !1;
}, XPt = "";
function WPt(e) {
  return (e || "").replace(/\s+/g, " ").trim();
}
function ZPt(e, t, n = {}) {
  var r;
  const i = (r = n.cellLineSeparator) != null ? r : XPt;
  if (!e || !e.content || e.content.length === 0)
    return "";
  const o = [];
  e.content.forEach((h) => {
    const m = [];
    h.content && h.content.forEach((v) => {
      let b = "";
      v.content && Array.isArray(v.content) && v.content.length > 1 ? b = v.content.map((x) => t.renderChildren(x)).join(i) : b = v.content ? t.renderChildren(v.content) : "";
      const A = WPt(b), w = v.type === "tableHeader";
      m.push({ text: A, isHeader: w });
    }), o.push(m);
  });
  const s = o.reduce((h, m) => Math.max(h, m.length), 0);
  if (s === 0)
    return "";
  const l = new Array(s).fill(0);
  o.forEach((h) => {
    var m;
    for (let v = 0; v < s; v += 1) {
      const A = (((m = h[v]) == null ? void 0 : m.text) || "").length;
      A > l[v] && (l[v] = A), l[v] < 3 && (l[v] = 3);
    }
  });
  const c = (h, m) => h + " ".repeat(Math.max(0, m - h.length)), a = o[0], u = a.some((h) => h.isHeader);
  let f = `
`;
  const d = new Array(s).fill(0).map((h, m) => u && a[m] && a[m].text || "");
  return f += `| ${d.map((h, m) => c(h, l[m])).join(" | ")} |
`, f += `| ${l.map((h) => "-".repeat(Math.max(3, h))).join(" | ")} |
`, (u ? o.slice(1) : o).forEach((h) => {
    f += `| ${new Array(s).fill(0).map((m, v) => c(h[v] && h[v].text || "", l[v])).join(" | ")} |
`;
  }), f;
}
var HPt = ZPt, QPt = So.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      renderWrapper: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: FPt,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    const { colgroup: n, tableWidth: r, tableMinWidth: i } = UPt(e, this.options.cellMinWidth), o = t.style;
    function s() {
      return o || (r ? `width: ${r}` : `min-width: ${i}`);
    }
    const l = [
      "table",
      Ir(this.options.HTMLAttributes, t, {
        style: s()
      }),
      n,
      ["tbody", 0]
    ];
    return this.options.renderWrapper ? ["div", { class: "tableWrapper" }, l] : l;
  },
  parseMarkdown: (e, t) => {
    const n = [];
    if (e.header) {
      const r = [];
      e.header.forEach((i) => {
        r.push(t.createNode("tableHeader", {}, [{ type: "paragraph", content: t.parseInline(i.tokens) }]));
      }), n.push(t.createNode("tableRow", {}, r));
    }
    return e.rows && e.rows.forEach((r) => {
      const i = [];
      r.forEach((o) => {
        i.push(t.createNode("tableCell", {}, [{ type: "paragraph", content: t.parseInline(o.tokens) }]));
      }), n.push(t.createNode("tableRow", {}, i));
    }), t.createNode("table", void 0, n);
  },
  renderMarkdown: (e, t) => HPt(e, t),
  addCommands() {
    return {
      insertTable: ({ rows: e = 3, cols: t = 3, withHeaderRow: n = !0 } = {}) => ({ tr: r, dispatch: i, editor: o }) => {
        const s = qPt(o.schema, e, t, n);
        if (i) {
          const l = r.selection.from + 1;
          r.replaceSelectionWith(s).scrollIntoView().setSelection(pn.near(r.doc.resolve(l)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: e, dispatch: t }) => ePt(e, t),
      addColumnAfter: () => ({ state: e, dispatch: t }) => tPt(e, t),
      deleteColumn: () => ({ state: e, dispatch: t }) => rPt(e, t),
      addRowBefore: () => ({ state: e, dispatch: t }) => oPt(e, t),
      addRowAfter: () => ({ state: e, dispatch: t }) => sPt(e, t),
      deleteRow: () => ({ state: e, dispatch: t }) => lPt(e, t),
      deleteTable: () => ({ state: e, dispatch: t }) => mPt(e, t),
      mergeCells: () => ({ state: e, dispatch: t }) => wle(e, t),
      splitCell: () => ({ state: e, dispatch: t }) => xle(e, t),
      toggleHeaderColumn: () => ({ state: e, dispatch: t }) => ak("column")(e, t),
      toggleHeaderRow: () => ({ state: e, dispatch: t }) => ak("row")(e, t),
      toggleHeaderCell: () => ({ state: e, dispatch: t }) => pPt(e, t),
      mergeOrSplit: () => ({ state: e, dispatch: t }) => wle(e, t) ? !0 : xle(e, t),
      setCellAttribute: (e, t) => ({ state: n, dispatch: r }) => dPt(e, t)(n, r),
      goToNextCell: () => ({ state: e, dispatch: t }) => Ele(1)(e, t),
      goToPreviousCell: () => ({ state: e, dispatch: t }) => Ele(-1)(e, t),
      fixTables: () => ({ state: e, dispatch: t }) => (t && _Re(e), !0),
      setCellSelection: (e) => ({ tr: t, dispatch: n }) => {
        if (n) {
          const r = ii.create(t.doc, e.anchorCell, e.headCell);
          t.setSelection(r);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: sI,
      "Mod-Backspace": sI,
      Delete: sI,
      "Mod-Delete": sI
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        EPt({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      _Pt({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(e) {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      tableRole: Nr(on(e, "tableRole", t))
    };
  }
}), $Pt = si.create({
  name: "tableKit",
  addExtensions() {
    const e = [];
    return this.options.table !== !1 && e.push(QPt.configure(this.options.table)), this.options.tableCell !== !1 && e.push(LPt.configure(this.options.tableCell)), this.options.tableHeader !== !1 && e.push(zPt.configure(this.options.tableHeader)), this.options.tableRow !== !1 && e.push(jPt.configure(this.options.tableRow)), e;
  }
}), _K = So.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), KPt = _K, URe = Ib.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", Ir(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, t) {
    return t.applyMark(this.name || "underline", t.parseInline(e.tokens || []));
  },
  renderMarkdown(e, t) {
    return `++${t.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, t, n) {
      const i = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!i)
        return;
      const o = i[2].trim();
      return {
        type: "underline",
        raw: i[0],
        text: o,
        tokens: n.inlineTokens(o)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function GPt(e = {}) {
  return new $r({
    view(t) {
      return new YPt(t, e);
    }
  });
}
class YPt {
  constructor(t, n) {
    var r;
    this.editorView = t, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let o = (s) => {
        this[i](s);
      };
      return t.dom.addEventListener(i, o), { name: i, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: t, handler: n }) => this.editorView.dom.removeEventListener(t, n));
  }
  update(t, n) {
    this.cursorPos != null && n.doc != t.state.doc && (this.cursorPos > t.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(t) {
    t != this.cursorPos && (this.cursorPos = t, t == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let t = this.editorView.state.doc.resolve(this.cursorPos), n = !t.parent.inlineContent, r, i = this.editorView.dom, o = i.getBoundingClientRect(), s = o.width / i.offsetWidth, l = o.height / i.offsetHeight;
    if (n) {
      let f = t.nodeBefore, d = t.nodeAfter;
      if (f || d) {
        let p = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (p) {
          let h = p.getBoundingClientRect(), m = f ? h.bottom : h.top;
          f && d && (m = (m + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let v = this.width / 2 * l;
          r = { left: h.left, right: h.right, top: m - v, bottom: m + v };
        }
      }
    }
    if (!r) {
      let f = this.editorView.coordsAtPos(this.cursorPos), d = this.width / 2 * s;
      r = { left: f.left - d, right: f.left + d, top: f.top, bottom: f.bottom };
    }
    let c = this.editorView.dom.offsetParent;
    this.element || (this.element = c.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let a, u;
    if (!c || c == document.body && getComputedStyle(c).position == "static")
      a = -pageXOffset, u = -pageYOffset;
    else {
      let f = c.getBoundingClientRect(), d = f.width / c.offsetWidth, p = f.height / c.offsetHeight;
      a = f.left - c.scrollLeft * d, u = f.top - c.scrollTop * p;
    }
    this.element.style.left = (r.left - a) / s + "px", this.element.style.top = (r.top - u) / l + "px", this.element.style.width = (r.right - r.left) / s + "px", this.element.style.height = (r.bottom - r.top) / l + "px";
  }
  scheduleRemoval(t) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), t);
  }
  dragover(t) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: t.clientX, top: t.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, o = typeof i == "function" ? i(this.editorView, n, t) : i;
    if (n && !o) {
      let s = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let l = zPe(this.editorView.state.doc, s, this.editorView.dragging.slice);
        l != null && (s = l);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(t) {
    this.editorView.dom.contains(t.relatedTarget) || this.setCursor(null);
  }
}
class ji extends En {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    return ji.valid(r) ? new ji(r) : En.near(r);
  }
  content() {
    return zt.empty;
  }
  eq(t) {
    return t instanceof ji && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new ji(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new LK(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.isTextblock || !JPt(t) || !eIt(t))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(t.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, r = !1) {
    e: for (; ; ) {
      if (!r && ji.valid(t))
        return t;
      let i = t.pos, o = null;
      for (let s = t.depth; ; s--) {
        let l = t.node(s);
        if (n > 0 ? t.indexAfter(s) < l.childCount : t.index(s) > 0) {
          o = l.child(n > 0 ? t.indexAfter(s) : t.index(s) - 1);
          break;
        } else if (s == 0)
          return null;
        i += n;
        let c = t.doc.resolve(i);
        if (ji.valid(c))
          return c;
      }
      for (; ; ) {
        let s = n > 0 ? o.firstChild : o.lastChild;
        if (!s) {
          if (o.isAtom && !o.isText && !dn.isSelectable(o)) {
            t = t.doc.resolve(i + o.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        o = s, i += n;
        let l = t.doc.resolve(i);
        if (ji.valid(l))
          return l;
      }
      return null;
    }
  }
}
ji.prototype.visible = !1;
ji.findFrom = ji.findGapCursorFrom;
En.jsonID("gapcursor", ji);
class LK {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new LK(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return ji.valid(n) ? new ji(n) : En.near(n);
  }
}
function VRe(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function JPt(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), r = e.node(t);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || VRe(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function eIt(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), r = e.node(t);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || VRe(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function tIt() {
  return new $r({
    props: {
      decorations: oIt,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && ji.valid(n) ? new ji(n) : null;
      },
      handleClick: rIt,
      handleKeyDown: nIt,
      handleDOMEvents: { beforeinput: iIt }
    }
  });
}
const nIt = yK({
  ArrowLeft: aI("horiz", -1),
  ArrowRight: aI("horiz", 1),
  ArrowUp: aI("vert", -1),
  ArrowDown: aI("vert", 1)
});
function aI(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(r, i, o) {
    let s = r.selection, l = t > 0 ? s.$to : s.$from, c = s.empty;
    if (s instanceof pn) {
      if (!o.endOfTextblock(n) || l.depth == 0)
        return !1;
      c = !1, l = r.doc.resolve(t > 0 ? l.after() : l.before());
    }
    let a = ji.findGapCursorFrom(l, t, c);
    return a ? (i && i(r.tr.setSelection(new ji(a))), !0) : !1;
  };
}
function rIt(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let r = e.state.doc.resolve(t);
  if (!ji.valid(r))
    return !1;
  let i = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && dn.isSelectable(e.state.doc.nodeAt(i.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new ji(r))), !0);
}
function iIt(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof ji))
    return !1;
  let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = at.empty;
  for (let s = r.length - 1; s >= 0; s--)
    i = at.from(r[s].createAndFill(null, i));
  let o = e.state.tr.replace(n.pos, n.pos, new zt(i, 0, 0));
  return o.setSelection(pn.near(o.doc.resolve(n.pos + 1))), e.dispatch(o), !1;
}
function oIt(e) {
  if (!(e.selection instanceof ji))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", Vr.create(e.doc, [za.widget(e.selection.head, t, { key: "gapcursor" })]);
}
var a_ = 200, ns = function() {
};
ns.prototype.append = function(t) {
  return t.length ? (t = ns.from(t), !this.length && t || t.length < a_ && this.leafAppend(t) || this.length < a_ && t.leafPrepend(this) || this.appendInner(t)) : this;
};
ns.prototype.prepend = function(t) {
  return t.length ? ns.from(t).append(this) : this;
};
ns.prototype.appendInner = function(t) {
  return new sIt(this, t);
};
ns.prototype.slice = function(t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = this.length), t >= n ? ns.empty : this.sliceInner(Math.max(0, t), Math.min(this.length, n));
};
ns.prototype.get = function(t) {
  if (!(t < 0 || t >= this.length))
    return this.getInner(t);
};
ns.prototype.forEach = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(t, n, r, 0) : this.forEachInvertedInner(t, n, r, 0);
};
ns.prototype.map = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(o, s) {
    return i.push(t(o, s));
  }, n, r), i;
};
ns.from = function(t) {
  return t instanceof ns ? t : t && t.length ? new qRe(t) : ns.empty;
};
var qRe = /* @__PURE__ */ function(e) {
  function t(r) {
    e.call(this), this.values = r;
  }
  e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return t.prototype.flatten = function() {
    return this.values;
  }, t.prototype.sliceInner = function(i, o) {
    return i == 0 && o == this.length ? this : new t(this.values.slice(i, o));
  }, t.prototype.getInner = function(i) {
    return this.values[i];
  }, t.prototype.forEachInner = function(i, o, s, l) {
    for (var c = o; c < s; c++)
      if (i(this.values[c], l + c) === !1)
        return !1;
  }, t.prototype.forEachInvertedInner = function(i, o, s, l) {
    for (var c = o - 1; c >= s; c--)
      if (i(this.values[c], l + c) === !1)
        return !1;
  }, t.prototype.leafAppend = function(i) {
    if (this.length + i.length <= a_)
      return new t(this.values.concat(i.flatten()));
  }, t.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= a_)
      return new t(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(ns);
ns.empty = new qRe([]);
var sIt = /* @__PURE__ */ function(e) {
  function t(n, r) {
    e.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, t.prototype.forEachInner = function(r, i, o, s) {
    var l = this.left.length;
    if (i < l && this.left.forEachInner(r, i, Math.min(o, l), s) === !1 || o > l && this.right.forEachInner(r, Math.max(i - l, 0), Math.min(this.length, o) - l, s + l) === !1)
      return !1;
  }, t.prototype.forEachInvertedInner = function(r, i, o, s) {
    var l = this.left.length;
    if (i > l && this.right.forEachInvertedInner(r, i - l, Math.max(o, l) - l, s + l) === !1 || o < l && this.left.forEachInvertedInner(r, Math.min(i, l), o, s) === !1)
      return !1;
  }, t.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var o = this.left.length;
    return i <= o ? this.left.slice(r, i) : r >= o ? this.right.slice(r - o, i - o) : this.left.slice(r, o).append(this.right.slice(0, i - o));
  }, t.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new t(this.left, i);
  }, t.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new t(i, this.right);
  }, t.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new t(this.left, new t(this.right, r)) : new t(this, r);
  }, t;
}(ns);
const aIt = 500;
class ju {
  constructor(t, n) {
    this.items = t, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(t, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, o;
    n && (i = this.remapping(r, this.items.length), o = i.maps.length);
    let s = t.tr, l, c, a = [], u = [];
    return this.items.forEach((f, d) => {
      if (!f.step) {
        i || (i = this.remapping(r, d + 1), o = i.maps.length), o--, u.push(f);
        return;
      }
      if (i) {
        u.push(new Fh(f.map));
        let p = f.step.map(i.slice(o)), h;
        p && s.maybeStep(p).doc && (h = s.mapping.maps[s.mapping.maps.length - 1], a.push(new Fh(h, void 0, void 0, a.length + u.length))), o--, h && i.appendMap(h, o);
      } else
        s.maybeStep(f.step);
      if (f.selection)
        return l = i ? f.selection.map(i.slice(o)) : f.selection, c = new ju(this.items.slice(0, r).append(u.reverse().concat(a)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: c, transform: s, selection: l };
  }
  // Create a new branch with the given transform added.
  addTransform(t, n, r, i) {
    let o = [], s = this.eventCount, l = this.items, c = !i && l.length ? l.get(l.length - 1) : null;
    for (let u = 0; u < t.steps.length; u++) {
      let f = t.steps[u].invert(t.docs[u]), d = new Fh(t.mapping.maps[u], f, n), p;
      (p = c && c.merge(d)) && (d = p, u ? o.pop() : l = l.slice(0, l.length - 1)), o.push(d), n && (s++, n = void 0), i || (c = d);
    }
    let a = s - r.depth;
    return a > cIt && (l = lIt(l, a), s -= a), new ju(l.append(o), s);
  }
  remapping(t, n) {
    let r = new JT();
    return this.items.forEach((i, o) => {
      let s = i.mirrorOffset != null && o - i.mirrorOffset >= t ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, s);
    }, t, n), r;
  }
  addMaps(t) {
    return this.eventCount == 0 ? this : new ju(this.items.append(t.map((n) => new Fh(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(t, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), o = t.mapping, s = t.steps.length, l = this.eventCount;
    this.items.forEach((d) => {
      d.selection && l--;
    }, i);
    let c = n;
    this.items.forEach((d) => {
      let p = o.getMirror(--c);
      if (p == null)
        return;
      s = Math.min(s, p);
      let h = o.maps[p];
      if (d.step) {
        let m = t.steps[p].invert(t.docs[p]), v = d.selection && d.selection.map(o.slice(c + 1, p));
        v && l++, r.push(new Fh(h, m, v));
      } else
        r.push(new Fh(h));
    }, i);
    let a = [];
    for (let d = n; d < s; d++)
      a.push(new Fh(o.maps[d]));
    let u = this.items.slice(0, i).append(a).append(r), f = new ju(u, l);
    return f.emptyItemCount() > aIt && (f = f.compress(this.items.length - r.length)), f;
  }
  emptyItemCount() {
    let t = 0;
    return this.items.forEach((n) => {
      n.step || t++;
    }), t;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(t = this.items.length) {
    let n = this.remapping(0, t), r = n.maps.length, i = [], o = 0;
    return this.items.forEach((s, l) => {
      if (l >= t)
        i.push(s), s.selection && o++;
      else if (s.step) {
        let c = s.step.map(n.slice(r)), a = c && c.getMap();
        if (r--, a && n.appendMap(a, r), c) {
          let u = s.selection && s.selection.map(n.slice(r));
          u && o++;
          let f = new Fh(a.invert(), c, u), d, p = i.length - 1;
          (d = i.length && i[p].merge(f)) ? i[p] = d : i.push(f);
        }
      } else s.map && r--;
    }, this.items.length, 0), new ju(ns.from(i.reverse()), o);
  }
}
ju.empty = new ju(ns.empty, 0);
function lIt(e, t) {
  let n;
  return e.forEach((r, i) => {
    if (r.selection && t-- == 0)
      return n = i, !1;
  }), e.slice(n);
}
let Fh = class BRe {
  constructor(t, n, r, i) {
    this.map = t, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(t) {
    if (this.step && t.step && !t.selection) {
      let n = t.step.merge(this.step);
      if (n)
        return new BRe(n.getMap().invert(), n, this.selection);
    }
  }
}, tm = class {
  constructor(t, n, r, i, o) {
    this.done = t, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = o;
  }
};
const cIt = 20;
function uIt(e, t, n, r) {
  let i = n.getMeta(fv), o;
  if (i)
    return i.historyState;
  n.getMeta(pIt) && (e = new tm(e.done, e.undone, null, 0, -1));
  let s = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (s && s.getMeta(fv))
    return s.getMeta(fv).redo ? new tm(e.done.addTransform(n, void 0, r, nM(t)), e.undone, _le(n.mapping.maps), e.prevTime, e.prevComposition) : new tm(e.done, e.undone.addTransform(n, void 0, r, nM(t)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let l = n.getMeta("composition"), c = e.prevTime == 0 || !s && e.prevComposition != l && (e.prevTime < (n.time || 0) - r.newGroupDelay || !dIt(n, e.prevRanges)), a = s ? sU(e.prevRanges, n.mapping) : _le(n.mapping.maps);
    return new tm(e.done.addTransform(n, c ? t.selection.getBookmark() : void 0, r, nM(t)), ju.empty, a, n.time, l ?? e.prevComposition);
  } else return (o = n.getMeta("rebased")) ? new tm(e.done.rebased(n, o), e.undone.rebased(n, o), sU(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new tm(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), sU(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function dIt(e, t) {
  if (!t)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((r, i) => {
    for (let o = 0; o < t.length; o += 2)
      r <= t[o + 1] && i >= t[o] && (n = !0);
  }), n;
}
function _le(e) {
  let t = [];
  for (let n = e.length - 1; n >= 0 && t.length == 0; n--)
    e[n].forEach((r, i, o, s) => t.push(o, s));
  return t;
}
function sU(e, t) {
  if (!e)
    return null;
  let n = [];
  for (let r = 0; r < e.length; r += 2) {
    let i = t.map(e[r], 1), o = t.map(e[r + 1], -1);
    i <= o && n.push(i, o);
  }
  return n;
}
function fIt(e, t, n) {
  let r = nM(t), i = fv.get(t).spec.config, o = (n ? e.undone : e.done).popEvent(t, r);
  if (!o)
    return null;
  let s = o.selection.resolve(o.transform.doc), l = (n ? e.done : e.undone).addTransform(o.transform, t.selection.getBookmark(), i, r), c = new tm(n ? l : o.remaining, n ? o.remaining : l, null, 0, -1);
  return o.transform.setSelection(s).setMeta(fv, { redo: n, historyState: c });
}
let aU = !1, Lle = null;
function nM(e) {
  let t = e.plugins;
  if (Lle != t) {
    aU = !1, Lle = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].spec.historyPreserveItems) {
        aU = !0;
        break;
      }
  }
  return aU;
}
const fv = new gi("history"), pIt = new gi("closeHistory");
function XRe(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new $r({
    key: fv,
    state: {
      init() {
        return new tm(ju.empty, ju.empty, null, 0, -1);
      },
      apply(t, n, r) {
        return uIt(n, r, t, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(t, n) {
          let r = n.inputType, i = r == "historyUndo" ? zK : r == "historyRedo" ? jK : null;
          return !i || !t.editable ? !1 : (n.preventDefault(), i(t.state, t.dispatch));
        }
      }
    }
  });
}
function WRe(e, t) {
  return (n, r) => {
    let i = fv.getState(n);
    if (!i || (e ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let o = fIt(i, n, e);
      o && r(t ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const zK = WRe(!1, !0), jK = WRe(!0, !0);
si.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((t) => t !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const t = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const r = t.textBetween(0, t.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return t.nodeSize;
    }, this.storage.words = (e) => {
      const t = (e == null ? void 0 : e.node) || this.editor.state.doc, n = t.textBetween(0, t.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new $r({
        key: new gi("characterCount"),
        appendTransaction: (t, n, r) => {
          if (e)
            return;
          const i = this.options.limit;
          if (i == null || i === 0) {
            e = !0;
            return;
          }
          const o = this.storage.characters({ node: r.doc });
          if (o > i) {
            const s = o - i, l = 0, c = s;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`
            );
            const a = r.tr.deleteRange(l, c);
            return e = !0, a;
          }
          e = !0;
        },
        filterTransaction: (t, n) => {
          const r = this.options.limit;
          if (!t.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const i = this.storage.characters({ node: n.doc }), o = this.storage.characters({ node: t.doc });
          if (o <= r || i > r && o > r && o <= i)
            return !0;
          if (i > r && o > r && o > i || !t.getMeta("paste"))
            return !1;
          const l = t.selection.$head.pos, c = o - r, a = l - c, u = l;
          return t.deleteRange(a, u), !(this.storage.characters({ node: t.doc }) > r);
        }
      })
    ];
  }
});
var hIt = si.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [GPt(this.options)];
  }
}), mIt = si.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("focus"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const { isEditable: n, isFocused: r } = this.editor, { anchor: i } = t, o = [];
            if (!n || !r)
              return Vr.create(e, []);
            let s = 0;
            this.options.mode === "deepest" && e.descendants((c, a) => {
              if (c.isText)
                return;
              if (!(i >= a && i <= a + c.nodeSize - 1))
                return !1;
              s += 1;
            });
            let l = 0;
            return e.descendants((c, a) => {
              if (c.isText || !(i >= a && i <= a + c.nodeSize - 1))
                return !1;
              if (l += 1, this.options.mode === "deepest" && s - l > 0 || this.options.mode === "shallowest" && l > 1)
                return this.options.mode === "deepest";
              o.push(
                za.node(a, a + c.nodeSize, {
                  class: this.options.className
                })
              );
            }), Vr.create(e, o);
          }
        }
      })
    ];
  }
}), gIt = si.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [tIt()];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = Nr(on(e, "allowGapCursor", n))) != null ? t : null
    };
  }
});
si.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = t, i = [];
            if (!n)
              return null;
            const o = this.editor.isEmpty;
            return e.descendants((s, l) => {
              const c = r >= l && r <= l + s.nodeSize, a = !s.isLeaf && bN(s);
              if ((c || !this.options.showOnlyCurrent) && a) {
                const u = [this.options.emptyNodeClass];
                o && u.push(this.options.emptyEditorClass);
                const f = za.node(l, l + s.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: s,
                    pos: l,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                i.push(f);
              }
              return this.options.includeChildren;
            }), Vr.create(e, i);
          }
        }
      })
    ];
  }
});
si.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: t } = this;
    return [
      new $r({
        key: new gi("selection"),
        props: {
          decorations(n) {
            return n.selection.empty || e.isFocused || !e.isEditable || nRe(n.selection) || e.view.dragging ? null : Vr.create(n.doc, [
              za.inline(n.selection.from, n.selection.to, {
                class: t.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function zle({ types: e, node: t }) {
  return t && Array.isArray(e) && e.includes(t.type) || (t == null ? void 0 : t.type) === e;
}
var yIt = si.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const t = new gi(this.name), n = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", r = Object.entries(this.editor.schema.nodes).map(([, i]) => i).filter((i) => (this.options.notAfter || []).concat(n).includes(i.name));
    return [
      new $r({
        key: t,
        appendTransaction: (i, o, s) => {
          const { doc: l, tr: c, schema: a } = s, u = t.getState(s), f = l.content.size, d = a.nodes[n];
          if (u)
            return c.insert(f, d.create());
        },
        state: {
          init: (i, o) => {
            const s = o.tr.doc.lastChild;
            return !zle({ node: s, types: r });
          },
          apply: (i, o) => {
            if (!i.docChanged || i.getMeta("__uniqueIDTransaction"))
              return o;
            const s = i.doc.lastChild;
            return !zle({ node: s, types: r });
          }
        }
      })
    ];
  }
}), ZRe = si.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => zK(e, t),
      redo: () => ({ state: e, dispatch: t }) => jK(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [XRe(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
});
function FK() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
var Rb = FK();
function HRe(e) {
  Rb = e;
}
var DE = { exec: () => null };
function Dr(e, t = "") {
  let n = typeof e == "string" ? e : e.source;
  const r = {
    replace: (i, o) => {
      let s = typeof o == "string" ? o : o.source;
      return s = s.replace(Ea.caret, "$1"), n = n.replace(i, s), r;
    },
    getRegex: () => new RegExp(n, t)
  };
  return r;
}
var Ea = {
  codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
  outputLinkReplace: /\\([\[\]])/g,
  indentCodeCompensation: /^(\s+)(?:```)/,
  beginningSpace: /^\s+/,
  endingHash: /#$/,
  startingSpaceChar: /^ /,
  endingSpaceChar: / $/,
  nonSpaceChar: /[^ ]/,
  newLineCharGlobal: /\n/g,
  tabCharGlobal: /\t/g,
  multipleSpaceGlobal: /\s+/g,
  blankLine: /^[ \t]*$/,
  doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
  blockquoteStart: /^ {0,3}>/,
  blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
  blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
  listReplaceTabs: /^\t+/,
  listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
  listIsTask: /^\[[ xX]\] /,
  listReplaceTask: /^\[[ xX]\] +/,
  anyLine: /\n.*\n/,
  hrefBrackets: /^<(.*)>$/,
  tableDelimiter: /[:|]/,
  tableAlignChars: /^\||\| *$/g,
  tableRowBlankLine: /\n[ \t]*$/,
  tableAlignRight: /^ *-+: *$/,
  tableAlignCenter: /^ *:-+: *$/,
  tableAlignLeft: /^ *:-+ *$/,
  startATag: /^<a /i,
  endATag: /^<\/a>/i,
  startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
  endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
  startAngleBracket: /^</,
  endAngleBracket: />$/,
  pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
  unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
  escapeTest: /[&<>"']/,
  escapeReplace: /[&<>"']/g,
  escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
  escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
  unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
  caret: /(^|[^\[])\^/g,
  percentDecode: /%25/g,
  findPipe: /\|/g,
  splitPipe: / \|/,
  slashPipe: /\\\|/g,
  carriageReturn: /\r\n|\r/g,
  spaceLine: /^ +$/gm,
  notSpaceStart: /^\S*/,
  endingNewline: /\n$/,
  listItemRegex: (e) => new RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
  nextBulletRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
  hrRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
  fencesBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
  headingBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
  htmlBeginRegex: (e) => new RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i")
}, vIt = /^(?:[ \t]*(?:\n|$))+/, bIt = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, OIt = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, AN = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, AIt = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, UK = /(?:[*+-]|\d{1,9}[.)])/, QRe = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, $Re = Dr(QRe).replace(/bull/g, UK).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), wIt = Dr(QRe).replace(/bull/g, UK).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), VK = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, xIt = /^[^\n]+/, qK = /(?!\s*\])(?:\\.|[^\[\]\\])+/, SIt = Dr(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", qK).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), EIt = Dr(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, UK).getRegex(), zj = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", BK = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, TIt = Dr(
  "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))",
  "i"
).replace("comment", BK).replace("tag", zj).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), KRe = Dr(VK).replace("hr", AN).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", zj).getRegex(), kIt = Dr(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", KRe).getRegex(), XK = {
  blockquote: kIt,
  code: bIt,
  def: SIt,
  fences: OIt,
  heading: AIt,
  hr: AN,
  html: TIt,
  lheading: $Re,
  list: EIt,
  newline: vIt,
  paragraph: KRe,
  table: DE,
  text: xIt
}, jle = Dr(
  "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
).replace("hr", AN).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", zj).getRegex(), CIt = {
  ...XK,
  lheading: wIt,
  table: jle,
  paragraph: Dr(VK).replace("hr", AN).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", jle).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", zj).getRegex()
}, NIt = {
  ...XK,
  html: Dr(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", BK).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: DE,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: Dr(VK).replace("hr", AN).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", $Re).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, PIt = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, IIt = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, GRe = /^( {2,}|\\)\n(?!\s*$)/, RIt = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, jj = /[\p{P}\p{S}]/u, WK = /[\s\p{P}\p{S}]/u, YRe = /[^\s\p{P}\p{S}]/u, MIt = Dr(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, WK).getRegex(), JRe = /(?!~)[\p{P}\p{S}]/u, DIt = /(?!~)[\s\p{P}\p{S}]/u, _It = /(?:[^\s\p{P}\p{S}]|~)/u, LIt = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g, eMe = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, zIt = Dr(eMe, "u").replace(/punct/g, jj).getRegex(), jIt = Dr(eMe, "u").replace(/punct/g, JRe).getRegex(), tMe = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", FIt = Dr(tMe, "gu").replace(/notPunctSpace/g, YRe).replace(/punctSpace/g, WK).replace(/punct/g, jj).getRegex(), UIt = Dr(tMe, "gu").replace(/notPunctSpace/g, _It).replace(/punctSpace/g, DIt).replace(/punct/g, JRe).getRegex(), VIt = Dr(
  "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)",
  "gu"
).replace(/notPunctSpace/g, YRe).replace(/punctSpace/g, WK).replace(/punct/g, jj).getRegex(), qIt = Dr(/\\(punct)/, "gu").replace(/punct/g, jj).getRegex(), BIt = Dr(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), XIt = Dr(BK).replace("(?:-->|$)", "-->").getRegex(), WIt = Dr(
  "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>"
).replace("comment", XIt).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), l_ = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, ZIt = Dr(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", l_).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), nMe = Dr(/^!?\[(label)\]\[(ref)\]/).replace("label", l_).replace("ref", qK).getRegex(), rMe = Dr(/^!?\[(ref)\](?:\[\])?/).replace("ref", qK).getRegex(), HIt = Dr("reflink|nolink(?!\\()", "g").replace("reflink", nMe).replace("nolink", rMe).getRegex(), ZK = {
  _backpedal: DE,
  // only used for GFM url
  anyPunctuation: qIt,
  autolink: BIt,
  blockSkip: LIt,
  br: GRe,
  code: IIt,
  del: DE,
  emStrongLDelim: zIt,
  emStrongRDelimAst: FIt,
  emStrongRDelimUnd: VIt,
  escape: PIt,
  link: ZIt,
  nolink: rMe,
  punctuation: MIt,
  reflink: nMe,
  reflinkSearch: HIt,
  tag: WIt,
  text: RIt,
  url: DE
}, QIt = {
  ...ZK,
  link: Dr(/^!?\[(label)\]\((.*?)\)/).replace("label", l_).getRegex(),
  reflink: Dr(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", l_).getRegex()
}, o9 = {
  ...ZK,
  emStrongRDelimAst: UIt,
  emStrongLDelim: jIt,
  url: Dr(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, $It = {
  ...o9,
  br: Dr(GRe).replace("{2,}", "*").getRegex(),
  text: Dr(o9.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, lI = {
  normal: XK,
  gfm: CIt,
  pedantic: NIt
}, uS = {
  normal: ZK,
  gfm: o9,
  breaks: $It,
  pedantic: QIt
}, KIt = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, Fle = (e) => KIt[e];
function Ld(e, t) {
  if (t) {
    if (Ea.escapeTest.test(e))
      return e.replace(Ea.escapeReplace, Fle);
  } else if (Ea.escapeTestNoEncode.test(e))
    return e.replace(Ea.escapeReplaceNoEncode, Fle);
  return e;
}
function Ule(e) {
  try {
    e = encodeURI(e).replace(Ea.percentDecode, "%");
  } catch {
    return null;
  }
  return e;
}
function Vle(e, t) {
  var o;
  const n = e.replace(Ea.findPipe, (s, l, c) => {
    let a = !1, u = l;
    for (; --u >= 0 && c[u] === "\\"; ) a = !a;
    return a ? "|" : " |";
  }), r = n.split(Ea.splitPipe);
  let i = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !((o = r.at(-1)) != null && o.trim()) && r.pop(), t)
    if (r.length > t)
      r.splice(t);
    else
      for (; r.length < t; ) r.push("");
  for (; i < r.length; i++)
    r[i] = r[i].trim().replace(Ea.slashPipe, "|");
  return r;
}
function dS(e, t, n) {
  const r = e.length;
  if (r === 0)
    return "";
  let i = 0;
  for (; i < r && e.charAt(r - i - 1) === t; )
    i++;
  return e.slice(0, r - i);
}
function GIt(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  let n = 0;
  for (let r = 0; r < e.length; r++)
    if (e[r] === "\\")
      r++;
    else if (e[r] === t[0])
      n++;
    else if (e[r] === t[1] && (n--, n < 0))
      return r;
  return n > 0 ? -2 : -1;
}
function qle(e, t, n, r, i) {
  const o = t.href, s = t.title || null, l = e[1].replace(i.other.outputLinkReplace, "$1");
  r.state.inLink = !0;
  const c = {
    type: e[0].charAt(0) === "!" ? "image" : "link",
    raw: n,
    href: o,
    title: s,
    text: l,
    tokens: r.inlineTokens(l)
  };
  return r.state.inLink = !1, c;
}
function YIt(e, t, n) {
  const r = e.match(n.other.indentCodeCompensation);
  if (r === null)
    return t;
  const i = r[1];
  return t.split(`
`).map((o) => {
    const s = o.match(n.other.beginningSpace);
    if (s === null)
      return o;
    const [l] = s;
    return l.length >= i.length ? o.slice(i.length) : o;
  }).join(`
`);
}
var c_ = class {
  // set by the lexer
  constructor(e) {
    rn(this, "options");
    rn(this, "rules");
    // set by the lexer
    rn(this, "lexer");
    this.options = e || Rb;
  }
  space(e) {
    const t = this.rules.block.newline.exec(e);
    if (t && t[0].length > 0)
      return {
        type: "space",
        raw: t[0]
      };
  }
  code(e) {
    const t = this.rules.block.code.exec(e);
    if (t) {
      const n = t[0].replace(this.rules.other.codeRemoveIndent, "");
      return {
        type: "code",
        raw: t[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? n : dS(n, `
`)
      };
    }
  }
  fences(e) {
    const t = this.rules.block.fences.exec(e);
    if (t) {
      const n = t[0], r = YIt(n, t[3] || "", this.rules);
      return {
        type: "code",
        raw: n,
        lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
        text: r
      };
    }
  }
  heading(e) {
    const t = this.rules.block.heading.exec(e);
    if (t) {
      let n = t[2].trim();
      if (this.rules.other.endingHash.test(n)) {
        const r = dS(n, "#");
        (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (n = r.trim());
      }
      return {
        type: "heading",
        raw: t[0],
        depth: t[1].length,
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  hr(e) {
    const t = this.rules.block.hr.exec(e);
    if (t)
      return {
        type: "hr",
        raw: dS(t[0], `
`)
      };
  }
  blockquote(e) {
    const t = this.rules.block.blockquote.exec(e);
    if (t) {
      let n = dS(t[0], `
`).split(`
`), r = "", i = "";
      const o = [];
      for (; n.length > 0; ) {
        let s = !1;
        const l = [];
        let c;
        for (c = 0; c < n.length; c++)
          if (this.rules.other.blockquoteStart.test(n[c]))
            l.push(n[c]), s = !0;
          else if (!s)
            l.push(n[c]);
          else
            break;
        n = n.slice(c);
        const a = l.join(`
`), u = a.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        r = r ? `${r}
${a}` : a, i = i ? `${i}
${u}` : u;
        const f = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(u, o, !0), this.lexer.state.top = f, n.length === 0)
          break;
        const d = o.at(-1);
        if ((d == null ? void 0 : d.type) === "code")
          break;
        if ((d == null ? void 0 : d.type) === "blockquote") {
          const p = d, h = p.raw + `
` + n.join(`
`), m = this.blockquote(h);
          o[o.length - 1] = m, r = r.substring(0, r.length - p.raw.length) + m.raw, i = i.substring(0, i.length - p.text.length) + m.text;
          break;
        } else if ((d == null ? void 0 : d.type) === "list") {
          const p = d, h = p.raw + `
` + n.join(`
`), m = this.list(h);
          o[o.length - 1] = m, r = r.substring(0, r.length - d.raw.length) + m.raw, i = i.substring(0, i.length - p.raw.length) + m.raw, n = h.substring(o.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return {
        type: "blockquote",
        raw: r,
        tokens: o,
        text: i
      };
    }
  }
  list(e) {
    let t = this.rules.block.list.exec(e);
    if (t) {
      let n = t[1].trim();
      const r = n.length > 1, i = {
        type: "list",
        raw: "",
        ordered: r,
        start: r ? +n.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
      const o = this.rules.other.listItemRegex(n);
      let s = !1;
      for (; e; ) {
        let c = !1, a = "", u = "";
        if (!(t = o.exec(e)) || this.rules.block.hr.test(e))
          break;
        a = t[0], e = e.substring(a.length);
        let f = t[2].split(`
`, 1)[0].replace(this.rules.other.listReplaceTabs, (b) => " ".repeat(3 * b.length)), d = e.split(`
`, 1)[0], p = !f.trim(), h = 0;
        if (this.options.pedantic ? (h = 2, u = f.trimStart()) : p ? h = t[1].length + 1 : (h = t[2].search(this.rules.other.nonSpaceChar), h = h > 4 ? 1 : h, u = f.slice(h), h += t[1].length), p && this.rules.other.blankLine.test(d) && (a += d + `
`, e = e.substring(d.length + 1), c = !0), !c) {
          const b = this.rules.other.nextBulletRegex(h), A = this.rules.other.hrRegex(h), w = this.rules.other.fencesBeginRegex(h), O = this.rules.other.headingBeginRegex(h), x = this.rules.other.htmlBeginRegex(h);
          for (; e; ) {
            const S = e.split(`
`, 1)[0];
            let E;
            if (d = S, this.options.pedantic ? (d = d.replace(this.rules.other.listReplaceNesting, "  "), E = d) : E = d.replace(this.rules.other.tabCharGlobal, "    "), w.test(d) || O.test(d) || x.test(d) || b.test(d) || A.test(d))
              break;
            if (E.search(this.rules.other.nonSpaceChar) >= h || !d.trim())
              u += `
` + E.slice(h);
            else {
              if (p || f.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || w.test(f) || O.test(f) || A.test(f))
                break;
              u += `
` + d;
            }
            !p && !d.trim() && (p = !0), a += S + `
`, e = e.substring(S.length + 1), f = E.slice(h);
          }
        }
        i.loose || (s ? i.loose = !0 : this.rules.other.doubleBlankLine.test(a) && (s = !0));
        let m = null, v;
        this.options.gfm && (m = this.rules.other.listIsTask.exec(u), m && (v = m[0] !== "[ ] ", u = u.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
          type: "list_item",
          raw: a,
          task: !!m,
          checked: v,
          loose: !1,
          text: u,
          tokens: []
        }), i.raw += a;
      }
      const l = i.items.at(-1);
      if (l)
        l.raw = l.raw.trimEnd(), l.text = l.text.trimEnd();
      else
        return;
      i.raw = i.raw.trimEnd();
      for (let c = 0; c < i.items.length; c++)
        if (this.lexer.state.top = !1, i.items[c].tokens = this.lexer.blockTokens(i.items[c].text, []), !i.loose) {
          const a = i.items[c].tokens.filter((f) => f.type === "space"), u = a.length > 0 && a.some((f) => this.rules.other.anyLine.test(f.raw));
          i.loose = u;
        }
      if (i.loose)
        for (let c = 0; c < i.items.length; c++)
          i.items[c].loose = !0;
      return i;
    }
  }
  html(e) {
    const t = this.rules.block.html.exec(e);
    if (t)
      return {
        type: "html",
        block: !0,
        raw: t[0],
        pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
        text: t[0]
      };
  }
  def(e) {
    const t = this.rules.block.def.exec(e);
    if (t) {
      const n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
      return {
        type: "def",
        tag: n,
        raw: t[0],
        href: r,
        title: i
      };
    }
  }
  table(e) {
    var s;
    const t = this.rules.block.table.exec(e);
    if (!t || !this.rules.other.tableDelimiter.test(t[2]))
      return;
    const n = Vle(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = (s = t[3]) != null && s.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], o = {
      type: "table",
      raw: t[0],
      header: [],
      align: [],
      rows: []
    };
    if (n.length === r.length) {
      for (const l of r)
        this.rules.other.tableAlignRight.test(l) ? o.align.push("right") : this.rules.other.tableAlignCenter.test(l) ? o.align.push("center") : this.rules.other.tableAlignLeft.test(l) ? o.align.push("left") : o.align.push(null);
      for (let l = 0; l < n.length; l++)
        o.header.push({
          text: n[l],
          tokens: this.lexer.inline(n[l]),
          header: !0,
          align: o.align[l]
        });
      for (const l of i)
        o.rows.push(Vle(l, o.header.length).map((c, a) => ({
          text: c,
          tokens: this.lexer.inline(c),
          header: !1,
          align: o.align[a]
        })));
      return o;
    }
  }
  lheading(e) {
    const t = this.rules.block.lheading.exec(e);
    if (t)
      return {
        type: "heading",
        raw: t[0],
        depth: t[2].charAt(0) === "=" ? 1 : 2,
        text: t[1],
        tokens: this.lexer.inline(t[1])
      };
  }
  paragraph(e) {
    const t = this.rules.block.paragraph.exec(e);
    if (t) {
      const n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
      return {
        type: "paragraph",
        raw: t[0],
        text: n,
        tokens: this.lexer.inline(n)
      };
    }
  }
  text(e) {
    const t = this.rules.block.text.exec(e);
    if (t)
      return {
        type: "text",
        raw: t[0],
        text: t[0],
        tokens: this.lexer.inline(t[0])
      };
  }
  escape(e) {
    const t = this.rules.inline.escape.exec(e);
    if (t)
      return {
        type: "escape",
        raw: t[0],
        text: t[1]
      };
  }
  tag(e) {
    const t = this.rules.inline.tag.exec(e);
    if (t)
      return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: t[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: t[0]
      };
  }
  link(e) {
    const t = this.rules.inline.link.exec(e);
    if (t) {
      const n = t[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
        if (!this.rules.other.endAngleBracket.test(n))
          return;
        const o = dS(n.slice(0, -1), "\\");
        if ((n.length - o.length) % 2 === 0)
          return;
      } else {
        const o = GIt(t[2], "()");
        if (o === -2)
          return;
        if (o > -1) {
          const l = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + o;
          t[2] = t[2].substring(0, o), t[0] = t[0].substring(0, l).trim(), t[3] = "";
        }
      }
      let r = t[2], i = "";
      if (this.options.pedantic) {
        const o = this.rules.other.pedanticHrefTitle.exec(r);
        o && (r = o[1], i = o[3]);
      } else
        i = t[3] ? t[3].slice(1, -1) : "";
      return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? r = r.slice(1) : r = r.slice(1, -1)), qle(t, {
        href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
        title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
      }, t[0], this.lexer, this.rules);
    }
  }
  reflink(e, t) {
    let n;
    if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
      const r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[r.toLowerCase()];
      if (!i) {
        const o = n[0].charAt(0);
        return {
          type: "text",
          raw: o,
          text: o
        };
      }
      return qle(n, i, n[0], this.lexer, this.rules);
    }
  }
  emStrong(e, t, n = "") {
    let r = this.rules.inline.emStrongLDelim.exec(e);
    if (!r || r[3] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
    if (!(r[1] || r[2] || "") || !n || this.rules.inline.punctuation.exec(n)) {
      const o = [...r[0]].length - 1;
      let s, l, c = o, a = 0;
      const u = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (u.lastIndex = 0, t = t.slice(-1 * e.length + o); (r = u.exec(t)) != null; ) {
        if (s = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !s) continue;
        if (l = [...s].length, r[3] || r[4]) {
          c += l;
          continue;
        } else if ((r[5] || r[6]) && o % 3 && !((o + l) % 3)) {
          a += l;
          continue;
        }
        if (c -= l, c > 0) continue;
        l = Math.min(l, l + c + a);
        const f = [...r[0]][0].length, d = e.slice(0, o + r.index + f + l);
        if (Math.min(o, l) % 2) {
          const h = d.slice(1, -1);
          return {
            type: "em",
            raw: d,
            text: h,
            tokens: this.lexer.inlineTokens(h)
          };
        }
        const p = d.slice(2, -2);
        return {
          type: "strong",
          raw: d,
          text: p,
          tokens: this.lexer.inlineTokens(p)
        };
      }
    }
  }
  codespan(e) {
    const t = this.rules.inline.code.exec(e);
    if (t) {
      let n = t[2].replace(this.rules.other.newLineCharGlobal, " ");
      const r = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
      return r && i && (n = n.substring(1, n.length - 1)), {
        type: "codespan",
        raw: t[0],
        text: n
      };
    }
  }
  br(e) {
    const t = this.rules.inline.br.exec(e);
    if (t)
      return {
        type: "br",
        raw: t[0]
      };
  }
  del(e) {
    const t = this.rules.inline.del.exec(e);
    if (t)
      return {
        type: "del",
        raw: t[0],
        text: t[2],
        tokens: this.lexer.inlineTokens(t[2])
      };
  }
  autolink(e) {
    const t = this.rules.inline.autolink.exec(e);
    if (t) {
      let n, r;
      return t[2] === "@" ? (n = t[1], r = "mailto:" + n) : (n = t[1], r = n), {
        type: "link",
        raw: t[0],
        text: n,
        href: r,
        tokens: [
          {
            type: "text",
            raw: n,
            text: n
          }
        ]
      };
    }
  }
  url(e) {
    var n;
    let t;
    if (t = this.rules.inline.url.exec(e)) {
      let r, i;
      if (t[2] === "@")
        r = t[0], i = "mailto:" + r;
      else {
        let o;
        do
          o = t[0], t[0] = ((n = this.rules.inline._backpedal.exec(t[0])) == null ? void 0 : n[0]) ?? "";
        while (o !== t[0]);
        r = t[0], t[1] === "www." ? i = "http://" + t[0] : i = t[0];
      }
      return {
        type: "link",
        raw: t[0],
        text: r,
        href: i,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  inlineText(e) {
    const t = this.rules.inline.text.exec(e);
    if (t) {
      const n = this.lexer.state.inRawBlock;
      return {
        type: "text",
        raw: t[0],
        text: t[0],
        escaped: n
      };
    }
  }
}, Xp = class s9 {
  constructor(t) {
    rn(this, "tokens");
    rn(this, "options");
    rn(this, "state");
    rn(this, "tokenizer");
    rn(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || Rb, this.options.tokenizer = this.options.tokenizer || new c_(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      other: Ea,
      block: lI.normal,
      inline: uS.normal
    };
    this.options.pedantic ? (n.block = lI.pedantic, n.inline = uS.pedantic) : this.options.gfm && (n.block = lI.gfm, this.options.breaks ? n.inline = uS.breaks : n.inline = uS.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: lI,
      inline: uS
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new s9(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new s9(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(Ea.carriageReturn, `
`), this.blockTokens(t, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      const r = this.inlineQueue[n];
      this.inlineTokens(r.src, r.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(t, n = [], r = !1) {
    var i, o, s;
    for (this.options.pedantic && (t = t.replace(Ea.tabCharGlobal, "    ").replace(Ea.spaceLine, "")); t; ) {
      let l;
      if ((o = (i = this.options.extensions) == null ? void 0 : i.block) != null && o.some((a) => (l = a.call({ lexer: this }, t, n)) ? (t = t.substring(l.raw.length), n.push(l), !0) : !1))
        continue;
      if (l = this.tokenizer.space(t)) {
        t = t.substring(l.raw.length);
        const a = n.at(-1);
        l.raw.length === 1 && a !== void 0 ? a.raw += `
` : n.push(l);
        continue;
      }
      if (l = this.tokenizer.code(t)) {
        t = t.substring(l.raw.length);
        const a = n.at(-1);
        (a == null ? void 0 : a.type) === "paragraph" || (a == null ? void 0 : a.type) === "text" ? (a.raw += `
` + l.raw, a.text += `
` + l.text, this.inlineQueue.at(-1).src = a.text) : n.push(l);
        continue;
      }
      if (l = this.tokenizer.fences(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.heading(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.hr(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.blockquote(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.list(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.html(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.def(t)) {
        t = t.substring(l.raw.length);
        const a = n.at(-1);
        (a == null ? void 0 : a.type) === "paragraph" || (a == null ? void 0 : a.type) === "text" ? (a.raw += `
` + l.raw, a.text += `
` + l.raw, this.inlineQueue.at(-1).src = a.text) : this.tokens.links[l.tag] || (this.tokens.links[l.tag] = {
          href: l.href,
          title: l.title
        });
        continue;
      }
      if (l = this.tokenizer.table(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.lheading(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      let c = t;
      if ((s = this.options.extensions) != null && s.startBlock) {
        let a = 1 / 0;
        const u = t.slice(1);
        let f;
        this.options.extensions.startBlock.forEach((d) => {
          f = d.call({ lexer: this }, u), typeof f == "number" && f >= 0 && (a = Math.min(a, f));
        }), a < 1 / 0 && a >= 0 && (c = t.substring(0, a + 1));
      }
      if (this.state.top && (l = this.tokenizer.paragraph(c))) {
        const a = n.at(-1);
        r && (a == null ? void 0 : a.type) === "paragraph" ? (a.raw += `
` + l.raw, a.text += `
` + l.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : n.push(l), r = c.length !== t.length, t = t.substring(l.raw.length);
        continue;
      }
      if (l = this.tokenizer.text(t)) {
        t = t.substring(l.raw.length);
        const a = n.at(-1);
        (a == null ? void 0 : a.type) === "text" ? (a.raw += `
` + l.raw, a.text += `
` + l.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : n.push(l);
        continue;
      }
      if (t) {
        const a = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(a);
          break;
        } else
          throw new Error(a);
      }
    }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    var l, c, a;
    let r = t, i = null;
    if (this.tokens.links) {
      const u = Object.keys(this.tokens.links);
      if (u.length > 0)
        for (; (i = this.tokenizer.rules.inline.reflinkSearch.exec(r)) != null; )
          u.includes(i[0].slice(i[0].lastIndexOf("[") + 1, -1)) && (r = r.slice(0, i.index) + "[" + "a".repeat(i[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (i = this.tokenizer.rules.inline.anyPunctuation.exec(r)) != null; )
      r = r.slice(0, i.index) + "++" + r.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; (i = this.tokenizer.rules.inline.blockSkip.exec(r)) != null; )
      r = r.slice(0, i.index) + "[" + "a".repeat(i[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    let o = !1, s = "";
    for (; t; ) {
      o || (s = ""), o = !1;
      let u;
      if ((c = (l = this.options.extensions) == null ? void 0 : l.inline) != null && c.some((d) => (u = d.call({ lexer: this }, t, n)) ? (t = t.substring(u.raw.length), n.push(u), !0) : !1))
        continue;
      if (u = this.tokenizer.escape(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.tag(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.link(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.reflink(t, this.tokens.links)) {
        t = t.substring(u.raw.length);
        const d = n.at(-1);
        u.type === "text" && (d == null ? void 0 : d.type) === "text" ? (d.raw += u.raw, d.text += u.text) : n.push(u);
        continue;
      }
      if (u = this.tokenizer.emStrong(t, r, s)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.codespan(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.br(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.del(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (u = this.tokenizer.autolink(t)) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      if (!this.state.inLink && (u = this.tokenizer.url(t))) {
        t = t.substring(u.raw.length), n.push(u);
        continue;
      }
      let f = t;
      if ((a = this.options.extensions) != null && a.startInline) {
        let d = 1 / 0;
        const p = t.slice(1);
        let h;
        this.options.extensions.startInline.forEach((m) => {
          h = m.call({ lexer: this }, p), typeof h == "number" && h >= 0 && (d = Math.min(d, h));
        }), d < 1 / 0 && d >= 0 && (f = t.substring(0, d + 1));
      }
      if (u = this.tokenizer.inlineText(f)) {
        t = t.substring(u.raw.length), u.raw.slice(-1) !== "_" && (s = u.raw.slice(-1)), o = !0;
        const d = n.at(-1);
        (d == null ? void 0 : d.type) === "text" ? (d.raw += u.raw, d.text += u.text) : n.push(u);
        continue;
      }
      if (t) {
        const d = "Infinite loop on byte: " + t.charCodeAt(0);
        if (this.options.silent) {
          console.error(d);
          break;
        } else
          throw new Error(d);
      }
    }
    return n;
  }
}, u_ = class {
  // set by the parser
  constructor(e) {
    rn(this, "options");
    rn(this, "parser");
    this.options = e || Rb;
  }
  space(e) {
    return "";
  }
  code({ text: e, lang: t, escaped: n }) {
    var o;
    const r = (o = (t || "").match(Ea.notSpaceStart)) == null ? void 0 : o[0], i = e.replace(Ea.endingNewline, "") + `
`;
    return r ? '<pre><code class="language-' + Ld(r) + '">' + (n ? i : Ld(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : Ld(i, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: e }) {
    return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
  }
  html({ text: e }) {
    return e;
  }
  heading({ tokens: e, depth: t }) {
    return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
  }
  hr(e) {
    return `<hr>
`;
  }
  list(e) {
    const t = e.ordered, n = e.start;
    let r = "";
    for (let s = 0; s < e.items.length; s++) {
      const l = e.items[s];
      r += this.listitem(l);
    }
    const i = t ? "ol" : "ul", o = t && n !== 1 ? ' start="' + n + '"' : "";
    return "<" + i + o + `>
` + r + "</" + i + `>
`;
  }
  listitem(e) {
    var n;
    let t = "";
    if (e.task) {
      const r = this.checkbox({ checked: !!e.checked });
      e.loose ? ((n = e.tokens[0]) == null ? void 0 : n.type) === "paragraph" ? (e.tokens[0].text = r + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = r + " " + Ld(e.tokens[0].tokens[0].text), e.tokens[0].tokens[0].escaped = !0)) : e.tokens.unshift({
        type: "text",
        raw: r + " ",
        text: r + " ",
        escaped: !0
      }) : t += r + " ";
    }
    return t += this.parser.parse(e.tokens, !!e.loose), `<li>${t}</li>
`;
  }
  checkbox({ checked: e }) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: e }) {
    return `<p>${this.parser.parseInline(e)}</p>
`;
  }
  table(e) {
    let t = "", n = "";
    for (let i = 0; i < e.header.length; i++)
      n += this.tablecell(e.header[i]);
    t += this.tablerow({ text: n });
    let r = "";
    for (let i = 0; i < e.rows.length; i++) {
      const o = e.rows[i];
      n = "";
      for (let s = 0; s < o.length; s++)
        n += this.tablecell(o[s]);
      r += this.tablerow({ text: n });
    }
    return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
  }
  tablerow({ text: e }) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e) {
    const t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
    return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens: e }) {
    return `<strong>${this.parser.parseInline(e)}</strong>`;
  }
  em({ tokens: e }) {
    return `<em>${this.parser.parseInline(e)}</em>`;
  }
  codespan({ text: e }) {
    return `<code>${Ld(e, !0)}</code>`;
  }
  br(e) {
    return "<br>";
  }
  del({ tokens: e }) {
    return `<del>${this.parser.parseInline(e)}</del>`;
  }
  link({ href: e, title: t, tokens: n }) {
    const r = this.parser.parseInline(n), i = Ule(e);
    if (i === null)
      return r;
    e = i;
    let o = '<a href="' + e + '"';
    return t && (o += ' title="' + Ld(t) + '"'), o += ">" + r + "</a>", o;
  }
  image({ href: e, title: t, text: n, tokens: r }) {
    r && (n = this.parser.parseInline(r, this.parser.textRenderer));
    const i = Ule(e);
    if (i === null)
      return Ld(n);
    e = i;
    let o = `<img src="${e}" alt="${n}"`;
    return t && (o += ` title="${Ld(t)}"`), o += ">", o;
  }
  text(e) {
    return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : Ld(e.text);
  }
}, HK = class {
  // no need for block level renderers
  strong({ text: e }) {
    return e;
  }
  em({ text: e }) {
    return e;
  }
  codespan({ text: e }) {
    return e;
  }
  del({ text: e }) {
    return e;
  }
  html({ text: e }) {
    return e;
  }
  text({ text: e }) {
    return e;
  }
  link({ text: e }) {
    return "" + e;
  }
  image({ text: e }) {
    return "" + e;
  }
  br() {
    return "";
  }
}, Wp = class a9 {
  constructor(t) {
    rn(this, "options");
    rn(this, "renderer");
    rn(this, "textRenderer");
    this.options = t || Rb, this.options.renderer = this.options.renderer || new u_(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new HK();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new a9(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new a9(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    var i, o;
    let r = "";
    for (let s = 0; s < t.length; s++) {
      const l = t[s];
      if ((o = (i = this.options.extensions) == null ? void 0 : i.renderers) != null && o[l.type]) {
        const a = l, u = this.options.extensions.renderers[a.type].call({ parser: this }, a);
        if (u !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(a.type)) {
          r += u || "";
          continue;
        }
      }
      const c = l;
      switch (c.type) {
        case "space": {
          r += this.renderer.space(c);
          continue;
        }
        case "hr": {
          r += this.renderer.hr(c);
          continue;
        }
        case "heading": {
          r += this.renderer.heading(c);
          continue;
        }
        case "code": {
          r += this.renderer.code(c);
          continue;
        }
        case "table": {
          r += this.renderer.table(c);
          continue;
        }
        case "blockquote": {
          r += this.renderer.blockquote(c);
          continue;
        }
        case "list": {
          r += this.renderer.list(c);
          continue;
        }
        case "html": {
          r += this.renderer.html(c);
          continue;
        }
        case "paragraph": {
          r += this.renderer.paragraph(c);
          continue;
        }
        case "text": {
          let a = c, u = this.renderer.text(a);
          for (; s + 1 < t.length && t[s + 1].type === "text"; )
            a = t[++s], u += `
` + this.renderer.text(a);
          n ? r += this.renderer.paragraph({
            type: "paragraph",
            raw: u,
            text: u,
            tokens: [{ type: "text", raw: u, text: u, escaped: !0 }]
          }) : r += u;
          continue;
        }
        default: {
          const a = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n = this.renderer) {
    var i, o;
    let r = "";
    for (let s = 0; s < t.length; s++) {
      const l = t[s];
      if ((o = (i = this.options.extensions) == null ? void 0 : i.renderers) != null && o[l.type]) {
        const a = this.options.extensions.renderers[l.type].call({ parser: this }, l);
        if (a !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(l.type)) {
          r += a || "";
          continue;
        }
      }
      const c = l;
      switch (c.type) {
        case "escape": {
          r += n.text(c);
          break;
        }
        case "html": {
          r += n.html(c);
          break;
        }
        case "link": {
          r += n.link(c);
          break;
        }
        case "image": {
          r += n.image(c);
          break;
        }
        case "strong": {
          r += n.strong(c);
          break;
        }
        case "em": {
          r += n.em(c);
          break;
        }
        case "codespan": {
          r += n.codespan(c);
          break;
        }
        case "br": {
          r += n.br(c);
          break;
        }
        case "del": {
          r += n.del(c);
          break;
        }
        case "text": {
          r += n.text(c);
          break;
        }
        default: {
          const a = 'Token with "' + c.type + '" type was not found.';
          if (this.options.silent)
            return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return r;
  }
}, Aq, rM = (Aq = class {
  constructor(e) {
    rn(this, "options");
    rn(this, "block");
    this.options = e || Rb;
  }
  /**
   * Process markdown before marked
   */
  preprocess(e) {
    return e;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(e) {
    return e;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(e) {
    return e;
  }
  /**
   * Provide function to tokenize markdown
   */
  provideLexer() {
    return this.block ? Xp.lex : Xp.lexInline;
  }
  /**
   * Provide function to parse tokens
   */
  provideParser() {
    return this.block ? Wp.parse : Wp.parseInline;
  }
}, rn(Aq, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
])), Aq), JIt = class {
  constructor(...e) {
    rn(this, "defaults", FK());
    rn(this, "options", this.setOptions);
    rn(this, "parse", this.parseMarkdown(!0));
    rn(this, "parseInline", this.parseMarkdown(!1));
    rn(this, "Parser", Wp);
    rn(this, "Renderer", u_);
    rn(this, "TextRenderer", HK);
    rn(this, "Lexer", Xp);
    rn(this, "Tokenizer", c_);
    rn(this, "Hooks", rM);
    this.use(...e);
  }
  /**
   * Run callback for every token
   */
  walkTokens(e, t) {
    var r, i;
    let n = [];
    for (const o of e)
      switch (n = n.concat(t.call(this, o)), o.type) {
        case "table": {
          const s = o;
          for (const l of s.header)
            n = n.concat(this.walkTokens(l.tokens, t));
          for (const l of s.rows)
            for (const c of l)
              n = n.concat(this.walkTokens(c.tokens, t));
          break;
        }
        case "list": {
          const s = o;
          n = n.concat(this.walkTokens(s.items, t));
          break;
        }
        default: {
          const s = o;
          (i = (r = this.defaults.extensions) == null ? void 0 : r.childTokens) != null && i[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((l) => {
            const c = s[l].flat(1 / 0);
            n = n.concat(this.walkTokens(c, t));
          }) : s.tokens && (n = n.concat(this.walkTokens(s.tokens, t)));
        }
      }
    return n;
  }
  use(...e) {
    const t = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return e.forEach((n) => {
      const r = { ...n };
      if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const o = t.renderers[i.name];
          o ? t.renderers[i.name] = function(...s) {
            let l = i.renderer.apply(this, s);
            return l === !1 && (l = o.apply(this, s)), l;
          } : t.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const o = t[i.level];
          o ? o.unshift(i.tokenizer) : t[i.level] = [i.tokenizer], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [i.start] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
      }), r.extensions = t), n.renderer) {
        const i = this.defaults.renderer || new u_(this.defaults);
        for (const o in n.renderer) {
          if (!(o in i))
            throw new Error(`renderer '${o}' does not exist`);
          if (["options", "parser"].includes(o))
            continue;
          const s = o, l = n.renderer[s], c = i[s];
          i[s] = (...a) => {
            let u = l.apply(i, a);
            return u === !1 && (u = c.apply(i, a)), u || "";
          };
        }
        r.renderer = i;
      }
      if (n.tokenizer) {
        const i = this.defaults.tokenizer || new c_(this.defaults);
        for (const o in n.tokenizer) {
          if (!(o in i))
            throw new Error(`tokenizer '${o}' does not exist`);
          if (["options", "rules", "lexer"].includes(o))
            continue;
          const s = o, l = n.tokenizer[s], c = i[s];
          i[s] = (...a) => {
            let u = l.apply(i, a);
            return u === !1 && (u = c.apply(i, a)), u;
          };
        }
        r.tokenizer = i;
      }
      if (n.hooks) {
        const i = this.defaults.hooks || new rM();
        for (const o in n.hooks) {
          if (!(o in i))
            throw new Error(`hook '${o}' does not exist`);
          if (["options", "block"].includes(o))
            continue;
          const s = o, l = n.hooks[s], c = i[s];
          rM.passThroughHooks.has(o) ? i[s] = (a) => {
            if (this.defaults.async)
              return Promise.resolve(l.call(i, a)).then((f) => c.call(i, f));
            const u = l.call(i, a);
            return c.call(i, u);
          } : i[s] = (...a) => {
            let u = l.apply(i, a);
            return u === !1 && (u = c.apply(i, a)), u;
          };
        }
        r.hooks = i;
      }
      if (n.walkTokens) {
        const i = this.defaults.walkTokens, o = n.walkTokens;
        r.walkTokens = function(s) {
          let l = [];
          return l.push(o.call(this, s)), i && (l = l.concat(i.call(this, s))), l;
        };
      }
      this.defaults = { ...this.defaults, ...r };
    }), this;
  }
  setOptions(e) {
    return this.defaults = { ...this.defaults, ...e }, this;
  }
  lexer(e, t) {
    return Xp.lex(e, t ?? this.defaults);
  }
  parser(e, t) {
    return Wp.parse(e, t ?? this.defaults);
  }
  parseMarkdown(e) {
    return (n, r) => {
      const i = { ...r }, o = { ...this.defaults, ...i }, s = this.onError(!!o.silent, !!o.async);
      if (this.defaults.async === !0 && i.async === !1)
        return s(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof n > "u" || n === null)
        return s(new Error("marked(): input parameter is undefined or null"));
      if (typeof n != "string")
        return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
      o.hooks && (o.hooks.options = o, o.hooks.block = e);
      const l = o.hooks ? o.hooks.provideLexer() : e ? Xp.lex : Xp.lexInline, c = o.hooks ? o.hooks.provideParser() : e ? Wp.parse : Wp.parseInline;
      if (o.async)
        return Promise.resolve(o.hooks ? o.hooks.preprocess(n) : n).then((a) => l(a, o)).then((a) => o.hooks ? o.hooks.processAllTokens(a) : a).then((a) => o.walkTokens ? Promise.all(this.walkTokens(a, o.walkTokens)).then(() => a) : a).then((a) => c(a, o)).then((a) => o.hooks ? o.hooks.postprocess(a) : a).catch(s);
      try {
        o.hooks && (n = o.hooks.preprocess(n));
        let a = l(n, o);
        o.hooks && (a = o.hooks.processAllTokens(a)), o.walkTokens && this.walkTokens(a, o.walkTokens);
        let u = c(a, o);
        return o.hooks && (u = o.hooks.postprocess(u)), u;
      } catch (a) {
        return s(a);
      }
    };
  }
  onError(e, t) {
    return (n) => {
      if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
        const r = "<p>An error occurred:</p><pre>" + Ld(n.message + "", !0) + "</pre>";
        return t ? Promise.resolve(r) : r;
      }
      if (t)
        return Promise.reject(n);
      throw n;
    };
  }
}, Wv = new JIt();
function jr(e, t) {
  return Wv.parse(e, t);
}
jr.options = jr.setOptions = function(e) {
  return Wv.setOptions(e), jr.defaults = Wv.defaults, HRe(jr.defaults), jr;
};
jr.getDefaults = FK;
jr.defaults = Rb;
jr.use = function(...e) {
  return Wv.use(...e), jr.defaults = Wv.defaults, HRe(jr.defaults), jr;
};
jr.walkTokens = function(e, t) {
  return Wv.walkTokens(e, t);
};
jr.parseInline = Wv.parseInline;
jr.Parser = Wp;
jr.parser = Wp.parse;
jr.Renderer = u_;
jr.TextRenderer = HK;
jr.Lexer = Xp;
jr.lexer = Xp.lex;
jr.Tokenizer = c_;
jr.Hooks = rM;
jr.parse = jr;
jr.options;
jr.setOptions;
jr.use;
jr.walkTokens;
jr.parseInline;
Wp.parse;
Xp.lex;
function eRt(e, t) {
  const r = t.split(`
`).flatMap((i) => [i, ""]).map((i) => `${e}${i}`).join(`
`);
  return r.slice(0, r.length - 1);
}
function tRt(e, t) {
  const n = [];
  return Array.from(e.keys()).forEach((r) => {
    t.has(r) || n.push(r);
  }), n;
}
function nRt(e, t) {
  const n = [];
  return Array.from(t.entries()).forEach(([r, i]) => {
    e.has(r) || n.push({ type: r, mark: i });
  }), n;
}
function rRt(e, t, n, r) {
  const i = !n, o = n && n.type === "text" && (!n.marks || n.marks.length === 0), s = n && n.type === "text" && n.marks && !r(t, new Map(n.marks.map((c) => [c.type, c]))), l = [];
  if (i || o || s)
    if (n && n.type === "text" && n.marks) {
      const c = new Map(n.marks.map((a) => [a.type, a]));
      Array.from(e.keys()).forEach((a) => {
        c.has(a) || l.push(a);
      });
    } else (i || o) && l.push(...Array.from(e.keys()));
  return l;
}
function iRt(e, t) {
  let n = "";
  return Array.from(e.keys()).reverse().forEach((r) => {
    const i = e.get(r), o = t(r, i);
    o && (n = o + n);
  }), e.clear(), n;
}
function oRt(e, t, n) {
  let r = "";
  return Array.from(e.entries()).forEach(([i, o]) => {
    const s = n(i, o);
    s && (r += s), t.set(i, o);
  }), r;
}
function lU(e) {
  const n = (e.raw || e.text || "").match(/^(\s*)[-+*]\s+\[([ xX])\]\s+/);
  return n ? { isTask: !0, checked: n[2].toLowerCase() === "x", indentLevel: n[1].length } : { isTask: !1, indentLevel: 0 };
}
function cI(e, t) {
  return typeof e != "string" ? "json" : t;
}
var sRt = class {
  /**
   * Create a MarkdownManager.
   * @param options.marked Optional marked instance to use (injected).
   * @param options.markedOptions Optional options to pass to marked.setOptions
   * @param options.indentation Indentation settings (style and size).
   * @param options.extensions An array of Tiptap extensions to register for markdown parsing and rendering.
   */
  constructor(e) {
    this.baseExtensions = [], this.extensions = [], this.lastParseResult = null;
    var t, n, r, i, o;
    this.markedInstance = (t = e == null ? void 0 : e.marked) != null ? t : jr, this.lexer = new this.markedInstance.Lexer(), this.indentStyle = (r = (n = e == null ? void 0 : e.indentation) == null ? void 0 : n.style) != null ? r : "space", this.indentSize = (o = (i = e == null ? void 0 : e.indentation) == null ? void 0 : i.size) != null ? o : 2, this.baseExtensions = (e == null ? void 0 : e.extensions) || [], e != null && e.markedOptions && typeof this.markedInstance.setOptions == "function" && this.markedInstance.setOptions(e.markedOptions), this.registry = /* @__PURE__ */ new Map(), this.nodeTypeRegistry = /* @__PURE__ */ new Map(), e != null && e.extensions && (this.baseExtensions = e.extensions, Mj(e.extensions).forEach((l) => this.registerExtension(l, !1))), this.lexer = new this.markedInstance.Lexer();
  }
  /** Returns the underlying marked instance. */
  get instance() {
    return this.markedInstance;
  }
  /** Returns the correct indentCharacter (space or tab) */
  get indentCharacter() {
    return this.indentStyle === "space" ? " " : "	";
  }
  /** Returns the correct indentString repeated X times */
  get indentString() {
    return this.indentCharacter.repeat(this.indentSize);
  }
  /** Helper to quickly check whether a marked instance is available. */
  hasMarked() {
    return !!this.markedInstance;
  }
  /**
   * Register a Tiptap extension (Node/Mark/Extension). This will read
   * `markdownName`, `parseMarkdown`, `renderMarkdown` and `priority` from the
   * extension config (using the same resolution used across the codebase).
   */
  registerExtension(e, t = !0) {
    var n, r;
    this.extensions.push(e);
    const i = e.name, o = on(e, "markdownTokenName") || i, s = on(e, "parseMarkdown"), l = on(e, "renderMarkdown"), c = on(e, "markdownTokenizer"), a = (n = on(e, "markdownOptions")) != null ? n : null, u = (r = a == null ? void 0 : a.indentsContent) != null ? r : !1, f = {
      tokenName: o,
      nodeName: i,
      parseMarkdown: s,
      renderMarkdown: l,
      isIndenting: u,
      tokenizer: c
    };
    if (o && s) {
      const d = this.registry.get(o) || [];
      d.push(f), this.registry.set(o, d);
    }
    if (l) {
      const d = this.nodeTypeRegistry.get(i) || [];
      d.push(f), this.nodeTypeRegistry.set(i, d);
    }
    c && this.hasMarked() && (this.registerTokenizer(c), t && (this.lexer = new this.markedInstance.Lexer()));
  }
  /**
   * Register a custom tokenizer with marked.js for parsing non-standard markdown syntax.
   */
  registerTokenizer(e) {
    if (!this.hasMarked())
      return;
    const { name: t, start: n, level: r = "inline", tokenize: i } = e, l = {
      inlineTokens: (u) => this.lexer.inlineTokens(u),
      blockTokens: (u) => this.lexer.blockTokens(u)
    };
    let c;
    n ? c = typeof n == "function" ? n : (u) => u.indexOf(n) : c = (u) => {
      const f = i(u, [], l);
      return f && f.raw ? u.indexOf(f.raw) : -1;
    };
    const a = {
      name: t,
      level: r,
      start: c,
      tokenizer: (u, f) => {
        const d = i(u, f, l);
        if (d && d.type)
          return {
            ...d,
            type: d.type || t,
            raw: d.raw || "",
            tokens: d.tokens || []
          };
      },
      childTokens: []
    };
    this.markedInstance.use({
      extensions: [a]
    });
  }
  /** Get registered handlers for a token type and try each until one succeeds. */
  getHandlersForToken(e) {
    try {
      return this.registry.get(e) || [];
    } catch {
      return [];
    }
  }
  /** Get the first handler for a token type (for backwards compatibility). */
  getHandlerForToken(e) {
    const t = this.getHandlersForToken(e);
    if (t.length > 0)
      return t[0];
    const n = this.getHandlersForNodeType(e);
    return n.length > 0 ? n[0] : void 0;
  }
  /** Get registered handlers for a node type (for rendering). */
  getHandlersForNodeType(e) {
    try {
      return this.nodeTypeRegistry.get(e) || [];
    } catch {
      return [];
    }
  }
  /**
   * Serialize a ProseMirror-like JSON document (or node array) to a Markdown string
   * using registered renderers and fallback renderers.
   */
  serialize(e) {
    return e ? Array.isArray(e) ? this.renderNodes(e, e) : this.renderNodes(e, e) : "";
  }
  /**
   * Parse markdown string into Tiptap JSON document using registered extension handlers.
   */
  parse(e) {
    if (!this.hasMarked())
      throw new Error("No marked instance available for parsing");
    const t = this.markedInstance.lexer(e);
    return {
      type: "doc",
      content: this.parseTokens(t)
    };
  }
  /**
   * Convert an array of marked tokens into Tiptap JSON nodes using registered extension handlers.
   */
  parseTokens(e) {
    return e.map((t) => this.parseToken(t)).filter((t) => t !== null).flatMap((t) => Array.isArray(t) ? t : [t]);
  }
  /**
   * Parse a single token into Tiptap JSON using the appropriate registered handler.
   */
  parseToken(e) {
    if (!e.type)
      return null;
    if (e.type === "list")
      return this.parseListToken(e);
    const t = this.getHandlersForToken(e.type), n = this.createParseHelpers();
    if (t.find((i) => {
      if (!i.parseMarkdown)
        return !1;
      const o = i.parseMarkdown(e, n), s = this.normalizeParseResult(o);
      return s && (!Array.isArray(s) || s.length > 0) ? (this.lastParseResult = s, !0) : !1;
    }) && this.lastParseResult) {
      const i = this.lastParseResult;
      return this.lastParseResult = null, i;
    }
    return this.parseFallbackToken(e);
  }
  /**
   * Parse a list token, handling mixed bullet and task list items by splitting them into separate lists.
   * This ensures that consecutive task items and bullet items are grouped and parsed as separate list nodes.
   *
   * @param token The list token to parse
   * @returns Array of parsed list nodes, or null if parsing fails
   */
  parseListToken(e) {
    if (!e.items || e.items.length === 0)
      return this.parseTokenWithHandlers(e);
    const t = e.items.some((l) => lU(l).isTask), n = e.items.some((l) => !lU(l).isTask);
    if (!t || !n || this.getHandlersForToken("taskList").length === 0)
      return this.parseTokenWithHandlers(e);
    const r = [];
    let i = [], o = null;
    for (let l = 0; l < e.items.length; l += 1) {
      const c = e.items[l], { isTask: a, checked: u, indentLevel: f } = lU(c);
      let d = c;
      if (a) {
        const m = (c.raw || c.text || "").split(`
`), v = m[0].match(/^\s*[-+*]\s+\[([ xX])\]\s+(.*)$/), b = v ? v[2] : "";
        let A = [];
        if (m.length > 1 && m.slice(1).join(`
`).trim()) {
          const O = m.slice(1), x = O.filter((S) => S.trim());
          if (x.length > 0) {
            const S = Math.min(...x.map((T) => T.length - T.trimStart().length)), k = O.map((T) => T.trim() ? T.slice(S) : "").join(`
`).trim();
            k && (A = this.markedInstance.lexer(`${k}
`));
          }
        }
        d = {
          type: "taskItem",
          raw: "",
          mainContent: b,
          indentLevel: f,
          checked: u ?? !1,
          text: b,
          tokens: this.lexer.inlineTokens(b),
          nestedTokens: A
        };
      }
      const p = a ? "taskList" : "list";
      o !== p ? (i.length > 0 && r.push({ type: o, items: i }), i = [d], o = p) : i.push(d);
    }
    i.length > 0 && r.push({ type: o, items: i });
    const s = [];
    for (let l = 0; l < r.length; l += 1) {
      const c = r[l], a = { ...e, type: c.type, items: c.items }, u = this.parseToken(a);
      u && (Array.isArray(u) ? s.push(...u) : s.push(u));
    }
    return s.length > 0 ? s : null;
  }
  /**
   * Parse a token using registered handlers (extracted for reuse).
   */
  parseTokenWithHandlers(e) {
    if (!e.type)
      return null;
    const t = this.getHandlersForToken(e.type), n = this.createParseHelpers();
    if (t.find((i) => {
      if (!i.parseMarkdown)
        return !1;
      const o = i.parseMarkdown(e, n), s = this.normalizeParseResult(o);
      return s && (!Array.isArray(s) || s.length > 0) ? (this.lastParseResult = s, !0) : !1;
    }) && this.lastParseResult) {
      const i = this.lastParseResult;
      return this.lastParseResult = null, i;
    }
    return this.parseFallbackToken(e);
  }
  /**
   * Creates helper functions for parsing markdown tokens.
   * @returns An object containing helper functions for parsing.
   */
  createParseHelpers() {
    return {
      parseInline: (e) => this.parseInlineTokens(e),
      parseChildren: (e) => this.parseTokens(e),
      createTextNode: (e, t) => ({
        type: "text",
        text: e,
        marks: t || void 0
      }),
      createNode: (e, t, n) => {
        const r = {
          type: e,
          attrs: t || void 0,
          content: n || void 0
        };
        return (!t || Object.keys(t).length === 0) && delete r.attrs, r;
      },
      applyMark: (e, t, n) => ({
        mark: e,
        content: t,
        attrs: n && Object.keys(n).length > 0 ? n : void 0
      })
    };
  }
  /**
   * Escape special regex characters in a string.
   */
  escapeRegex(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  /**
   * Parse inline tokens (bold, italic, links, etc.) into text nodes with marks.
   * This is the complex part that handles mark nesting and boundaries.
   */
  parseInlineTokens(e) {
    var t, n, r, i;
    const o = [];
    for (let s = 0; s < e.length; s += 1) {
      const l = e[s];
      if (l.type === "text")
        o.push({
          type: "text",
          text: l.text || ""
        });
      else if (l.type === "html") {
        const c = ((n = (t = l.raw) != null ? t : l.text) != null ? n : "").toString(), a = /^<\/[\s]*[\w-]+/i.test(c), u = c.match(/^<[\s]*([\w-]+)(\s|>|\/|$)/i);
        if (!a && u && !/\/>$/.test(c)) {
          const d = u[1], p = this.escapeRegex(d), h = new RegExp(`^<\\/\\s*${p}\\b`, "i");
          let m = -1;
          const v = [c];
          for (let b = s + 1; b < e.length; b += 1) {
            const A = e[b], w = ((i = (r = A.raw) != null ? r : A.text) != null ? i : "").toString();
            if (v.push(w), A.type === "html" && h.test(w)) {
              m = b;
              break;
            }
          }
          if (m !== -1) {
            const b = v.join(""), A = {
              type: "html",
              raw: b,
              text: b,
              block: !1
            }, w = this.parseHTMLToken(A);
            if (w) {
              const O = this.normalizeParseResult(w);
              Array.isArray(O) ? o.push(...O) : O && o.push(O);
            }
            s = m;
            continue;
          }
        }
        const f = this.parseHTMLToken(l);
        if (f) {
          const d = this.normalizeParseResult(f);
          Array.isArray(d) ? o.push(...d) : d && o.push(d);
        }
      } else if (l.type) {
        const c = this.getHandlerForToken(l.type);
        if (c && c.parseMarkdown) {
          const a = this.createParseHelpers(), u = c.parseMarkdown(l, a);
          if (this.isMarkResult(u)) {
            const f = this.applyMarkToContent(u.mark, u.content, u.attrs);
            o.push(...f);
          } else {
            const f = this.normalizeParseResult(u);
            Array.isArray(f) ? o.push(...f) : f && o.push(f);
          }
        } else l.tokens && o.push(...this.parseInlineTokens(l.tokens));
      }
    }
    return o;
  }
  /**
   * Apply a mark to content nodes.
   */
  applyMarkToContent(e, t, n) {
    return t.map((r) => {
      if (r.type === "text") {
        const i = r.marks || [], o = n ? { type: e, attrs: n } : { type: e };
        return {
          ...r,
          marks: [...i, o]
        };
      }
      return {
        ...r,
        content: r.content ? this.applyMarkToContent(e, r.content, n) : void 0
      };
    });
  }
  /**
  * Check if a parse result represents a mark to be applied.
  */
  isMarkResult(e) {
    return e && typeof e == "object" && "mark" in e;
  }
  /**
   * Normalize parse results to ensure they're valid JSONContent.
   */
  normalizeParseResult(e) {
    return e ? this.isMarkResult(e) ? e.content : e : null;
  }
  /**
   * Fallback parsing for common tokens when no specific handler is registered.
   */
  parseFallbackToken(e) {
    switch (e.type) {
      case "paragraph":
        return {
          type: "paragraph",
          content: e.tokens ? this.parseInlineTokens(e.tokens) : []
        };
      case "heading":
        return {
          type: "heading",
          attrs: { level: e.depth || 1 },
          content: e.tokens ? this.parseInlineTokens(e.tokens) : []
        };
      case "text":
        return {
          type: "text",
          text: e.text || ""
        };
      case "html":
        return this.parseHTMLToken(e);
      case "space":
        return null;
      default:
        return e.tokens ? this.parseTokens(e.tokens) : null;
    }
  }
  /**
   * Parse HTML tokens using extensions' parseHTML methods.
   * This allows HTML within markdown to be parsed according to extension rules.
   */
  parseHTMLToken(e) {
    const t = e.text || e.raw || "";
    if (!t.trim())
      return null;
    try {
      const n = cCt(t, this.baseExtensions);
      return n.type === "doc" && n.content ? e.block ? n.content : n.content.length === 1 && n.content[0].type === "paragraph" && n.content[0].content ? n.content[0].content : n.content : n;
    } catch (n) {
      throw new Error(`Failed to parse HTML in markdown: ${n}`);
    }
  }
  renderNodeToMarkdown(e, t, n = 0, r = 0) {
    var i;
    if (e.type === "text")
      return e.text || "";
    if (!e.type)
      return "";
    const o = this.getHandlerForToken(e.type);
    if (!o)
      return "";
    const s = {
      renderChildren: (a, u) => {
        const f = o.isIndenting ? r + 1 : r;
        return !Array.isArray(a) && a.content ? this.renderNodes(a.content, e, u || "", n, f) : this.renderNodes(a, e, u || "", n, f);
      },
      indent: (a) => this.indentString + a,
      wrapInBlock: eRt
    }, l = {
      index: n,
      level: r,
      parentType: t == null ? void 0 : t.type,
      meta: {}
    };
    return ((i = o.renderMarkdown) == null ? void 0 : i.call(o, e, s, l)) || "";
  }
  /**
   * Render a node or an array of nodes. Parent type controls how children
   * are joined (which determines newline insertion between children).
   */
  renderNodes(e, t, n = "", r = 0, i = 0) {
    return Array.isArray(e) ? this.renderNodesWithMarkBoundaries(e, t, n, i) : e.type ? this.renderNodeToMarkdown(e, t, r, i) : "";
  }
  /**
   * Render an array of nodes while properly tracking mark boundaries.
   * This handles cases where marks span across multiple text nodes.
   */
  renderNodesWithMarkBoundaries(e, t, n = "", r = 0) {
    const i = [], o = /* @__PURE__ */ new Map();
    return e.forEach((s, l) => {
      const c = l < e.length - 1 ? e[l + 1] : null;
      if (s.type)
        if (s.type === "text") {
          let a = s.text || "";
          const u = new Map((s.marks || []).map((v) => [v.type, v])), f = tRt(o, u), d = nRt(o, u);
          f.forEach((v) => {
            const b = o.get(v), A = this.getMarkClosing(v, b);
            A && (a += A), o.delete(v);
          });
          let p = "";
          if (d.length > 0) {
            const v = a.match(/^(\s+)/);
            v && (p = v[1], a = a.slice(p.length));
          }
          d.forEach(({ type: v, mark: b }) => {
            const A = this.getMarkOpening(v, b);
            A && (a = A + a), o.set(v, b);
          }), a = p + a;
          const h = rRt(
            o,
            u,
            c,
            this.markSetsEqual.bind(this)
          );
          let m = "";
          if (h.length > 0) {
            const v = a.match(/(\s+)$/);
            v && (m = v[1], a = a.slice(0, -m.length));
          }
          h.forEach((v) => {
            const b = o.get(v), A = this.getMarkClosing(v, b);
            A && (a += A), o.delete(v);
          }), a += m, i.push(a);
        } else {
          const a = new Map(o), u = iRt(o, this.getMarkClosing.bind(this)), f = this.renderNodeToMarkdown(s, t, l, r), d = s.type === "hardBreak" ? "" : oRt(a, o, this.getMarkOpening.bind(this));
          i.push(u + f + d);
        }
    }), i.join(n);
  }
  /**
   * Get the opening markdown syntax for a mark type.
   */
  getMarkOpening(e, t) {
    const n = this.getHandlersForNodeType(e), r = n.length > 0 ? n[0] : void 0;
    if (!r || !r.renderMarkdown)
      return "";
    const i = "__TIPTAP_MARKDOWN_PLACEHOLDER__", o = {
      type: e,
      attrs: t.attrs || {},
      content: [{ type: "text", text: i }]
    };
    try {
      const s = r.renderMarkdown(
        o,
        {
          renderChildren: () => i,
          indent: (c) => c,
          wrapInBlock: (c, a) => c + a
        },
        { index: 0, level: 0, parentType: "text", meta: {} }
      ), l = s.indexOf(i);
      return l >= 0 ? s.substring(0, l) : "";
    } catch (s) {
      throw new Error(`Failed to get mark opening for ${e}: ${s}`);
    }
  }
  /**
   * Get the closing markdown syntax for a mark type.
   */
  getMarkClosing(e, t) {
    const n = this.getHandlersForNodeType(e), r = n.length > 0 ? n[0] : void 0;
    if (!r || !r.renderMarkdown)
      return "";
    const i = "__TIPTAP_MARKDOWN_PLACEHOLDER__", o = {
      type: e,
      attrs: t.attrs || {},
      content: [{ type: "text", text: i }]
    };
    try {
      const s = r.renderMarkdown(
        o,
        {
          renderChildren: () => i,
          indent: (a) => a,
          wrapInBlock: (a, u) => a + u
        },
        { index: 0, level: 0, parentType: "text", meta: {} }
      ), l = s.indexOf(i), c = l + i.length;
      return l >= 0 ? s.substring(c) : "";
    } catch (s) {
      throw new Error(`Failed to get mark closing for ${e}: ${s}`);
    }
  }
  /**
   * Check if two mark sets are equal.
   */
  markSetsEqual(e, t) {
    return e.size !== t.size ? !1 : Array.from(e.keys()).every((n) => t.has(n));
  }
}, Ble = sRt, aRt = si.create({
  name: "markdown",
  addOptions() {
    return {
      indentation: { style: "space", size: 2 },
      marked: void 0,
      markedOptions: {}
    };
  },
  addCommands() {
    return {
      setContent: (e, t) => {
        if (!(t != null && t.contentType) || cI(e, t == null ? void 0 : t.contentType) !== "markdown" || !this.editor.markdown)
          return Tu.setContent(e, t);
        const r = this.editor.markdown.parse(e);
        return Tu.setContent(r, t);
      },
      insertContent: (e, t) => {
        if (!(t != null && t.contentType) || cI(e, t == null ? void 0 : t.contentType) !== "markdown" || !this.editor.markdown)
          return Tu.insertContent(e, t);
        const r = this.editor.markdown.parse(e);
        return Tu.insertContent(r, t);
      },
      insertContentAt: (e, t, n) => {
        if (!(n != null && n.contentType) || cI(t, n == null ? void 0 : n.contentType) !== "markdown" || !this.editor.markdown)
          return Tu.insertContentAt(e, t, n);
        const i = this.editor.markdown.parse(t);
        return Tu.insertContentAt(e, i, n);
      }
    };
  },
  addStorage() {
    return {
      manager: new Ble({
        indentation: this.options.indentation,
        marked: this.options.marked,
        markedOptions: this.options.markedOptions,
        extensions: []
      })
    };
  },
  onBeforeCreate() {
    if (this.editor.markdown) {
      console.error(
        "[tiptap][markdown]: There is already a `markdown` property on the editor instance. This might lead to unexpected behavior."
      );
      return;
    }
    if (this.storage.manager = new Ble({
      indentation: this.options.indentation,
      marked: this.options.marked,
      markedOptions: this.options.markedOptions,
      extensions: this.editor.extensionManager.baseExtensions
    }), this.editor.markdown = this.storage.manager, this.editor.getMarkdown = () => this.storage.manager.serialize(this.editor.getJSON()), !this.editor.options.contentType || cI(this.editor.options.content, this.editor.options.contentType) !== "markdown")
      return;
    if (!this.editor.markdown)
      throw new Error(
        '[tiptap][markdown]: The `contentType` option is set to "markdown", but the Markdown extension is not added to the editor. Please add the Markdown extension to use this feature.'
      );
    if (this.editor.options.content === void 0 || typeof this.editor.options.content != "string")
      throw new Error(
        '[tiptap][markdown]: The `contentType` option is set to "markdown", but the initial content is not a string. Please provide the initial content as a markdown string.'
      );
    const t = this.editor.markdown.parse(this.editor.options.content);
    this.editor.options.content = t;
  }
});
const lRt = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, cRt = ({ renderers: e }) => ie.createElement(ie.Fragment, null, Object.entries(e).map(([t, n]) => _w.createPortal(n.reactElement, n.element, t)));
class uRt extends ie.Component {
  constructor(t) {
    super(t), this.editorContentRef = ie.createRef(), this.initialized = !1, this.state = {
      renderers: {}
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const { editor: t } = this.props;
    if (t && !t.isDestroyed && t.options.element) {
      if (t.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...t.options.element.childNodes), t.setOptions({
        element: n
      }), t.contentComponent = this, t.createNodeViews(), this.initialized = !0;
    }
  }
  maybeFlushSync(t) {
    this.initialized ? Sve(t) : t();
  }
  setRenderer(t, n) {
    this.maybeFlushSync(() => {
      this.setState(({ renderers: r }) => ({
        renderers: {
          ...r,
          [t]: n
        }
      }));
    });
  }
  removeRenderer(t) {
    this.maybeFlushSync(() => {
      this.setState(({ renderers: n }) => {
        const r = { ...n };
        return delete r[t], { renderers: r };
      });
    });
  }
  componentWillUnmount() {
    const { editor: t } = this.props;
    if (!t || (this.initialized = !1, t.isDestroyed || t.view.setProps({
      nodeViews: {}
    }), t.contentComponent = null, !t.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...t.options.element.childNodes), t.setOptions({
      element: n
    });
  }
  render() {
    const { editor: t, innerRef: n, ...r } = this.props;
    return ie.createElement(
      ie.Fragment,
      null,
      ie.createElement("div", { ref: lRt(n, this.editorContentRef), ...r }),
      ie.createElement(cRt, { renderers: this.state.renderers })
    );
  }
}
const dRt = Fo((e, t) => {
  const n = ie.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [e.editor]);
  return ie.createElement(uRt, {
    key: n,
    innerRef: t,
    ...e
  });
}), iMe = ie.memo(dRt);
class uI extends nNt {
  constructor() {
    super(...arguments), this.contentComponent = null;
  }
}
var l9 = { exports: {} }, cU = {}, dI = { exports: {} }, uU = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xle;
function fRt() {
  if (Xle) return uU;
  Xle = 1;
  var e = ie;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, s = e.useDebugValue;
  function l(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), m = h[0].inst, v = h[1];
    return o(function() {
      m.value = p, m.getSnapshot = d, c(m) && v({ inst: m });
    }, [f, p, d]), i(function() {
      return c(m) && v({ inst: m }), f(function() {
        c(m) && v({ inst: m });
      });
    }, [f]), s(p), p;
  }
  function c(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function a(f, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : l;
  return uU.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, uU;
}
var dU = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wle;
function pRt() {
  return Wle || (Wle = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ie, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var O = arguments.length, x = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++)
          x[S - 1] = arguments[S];
        r("error", w, x);
      }
    }
    function r(w, O, x) {
      {
        var S = t.ReactDebugCurrentFrame, E = S.getStackAddendum();
        E !== "" && (O += "%s", x = x.concat([E]));
        var k = x.map(function(T) {
          return String(T);
        });
        k.unshift("Warning: " + O), Function.prototype.apply.call(console[w], console, k);
      }
    }
    function i(w, O) {
      return w === O && (w !== 0 || 1 / w === 1 / O) || w !== w && O !== O;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = e.useState, l = e.useEffect, c = e.useLayoutEffect, a = e.useDebugValue, u = !1, f = !1;
    function d(w, O, x) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var S = O();
      if (!f) {
        var E = O();
        o(S, E) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var k = s({
        inst: {
          value: S,
          getSnapshot: O
        }
      }), T = k[0].inst, R = k[1];
      return c(function() {
        T.value = S, T.getSnapshot = O, p(T) && R({
          inst: T
        });
      }, [w, S, O]), l(function() {
        p(T) && R({
          inst: T
        });
        var j = function() {
          p(T) && R({
            inst: T
          });
        };
        return w(j);
      }, [w]), a(S), S;
    }
    function p(w) {
      var O = w.getSnapshot, x = w.value;
      try {
        var S = O();
        return !o(x, S);
      } catch {
        return !0;
      }
    }
    function h(w, O, x) {
      return O();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", v = !m, b = v ? h : d, A = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b;
    dU.useSyncExternalStore = A, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), dU;
}
var Zle;
function oMe() {
  return Zle || (Zle = 1, process.env.NODE_ENV === "production" ? dI.exports = fRt() : dI.exports = pRt()), dI.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hle;
function hRt() {
  if (Hle) return cU;
  Hle = 1;
  var e = ie, t = oMe();
  function n(a, u) {
    return a === u && (a !== 0 || 1 / a === 1 / u) || a !== a && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, s = e.useEffect, l = e.useMemo, c = e.useDebugValue;
  return cU.useSyncExternalStoreWithSelector = function(a, u, f, d, p) {
    var h = o(null);
    if (h.current === null) {
      var m = { hasValue: !1, value: null };
      h.current = m;
    } else m = h.current;
    h = l(function() {
      function b(S) {
        if (!A) {
          if (A = !0, w = S, S = d(S), p !== void 0 && m.hasValue) {
            var E = m.value;
            if (p(E, S)) return O = E;
          }
          return O = S;
        }
        if (E = O, r(w, S)) return E;
        var k = d(S);
        return p !== void 0 && p(E, k) ? E : (w = S, O = k);
      }
      var A = !1, w, O, x = f === void 0 ? null : f;
      return [function() {
        return b(u());
      }, x === null ? void 0 : function() {
        return b(x());
      }];
    }, [u, f, d, p]);
    var v = i(a, h[0], h[1]);
    return s(function() {
      m.hasValue = !0, m.value = v;
    }, [v]), c(v), v;
  }, cU;
}
var fU = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qle;
function mRt() {
  return Qle || (Qle = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ie, t = oMe();
    function n(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, s = e.useEffect, l = e.useMemo, c = e.useDebugValue;
    function a(u, f, d, p, h) {
      var m = o(null), v;
      m.current === null ? (v = {
        hasValue: !1,
        value: null
      }, m.current = v) : v = m.current;
      var b = l(function() {
        var x = !1, S, E, k = function(F) {
          if (!x) {
            x = !0, S = F;
            var L = p(F);
            if (h !== void 0 && v.hasValue) {
              var _ = v.value;
              if (h(_, L))
                return E = _, _;
            }
            return E = L, L;
          }
          var U = S, z = E;
          if (r(U, F))
            return z;
          var C = p(F);
          return h !== void 0 && h(z, C) ? z : (S = F, E = C, C);
        }, T = d === void 0 ? null : d, R = function() {
          return k(f());
        }, j = T === null ? void 0 : function() {
          return k(T());
        };
        return [R, j];
      }, [f, d, p, h]), A = b[0], w = b[1], O = i(u, A, w);
      return s(function() {
        v.hasValue = !0, v.value = O;
      }, [O]), c(O), O;
    }
    fU.useSyncExternalStoreWithSelector = a, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), fU;
}
process.env.NODE_ENV === "production" ? l9.exports = hRt() : l9.exports = mRt();
var gRt = l9.exports;
function yRt(e) {
  let t = 0, n = 0, r = { editor: e, transactionNumber: 0 }, i = e;
  const o = /* @__PURE__ */ new Set();
  return {
    /**
     * Get the current editor instance.
     */
    getSnapshot() {
      return t === n || (n = t, r = { editor: i, transactionNumber: t }), r;
    },
    /**
     * Always disable the editor on the server-side.
     */
    getServerSnapshot() {
      return { editor: null, transactionNumber: 0 };
    },
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(l) {
      return o.add(l), () => {
        o.delete(l);
      };
    },
    /**
     * Watch the editor instance for changes.
     */
    watch(l) {
      if (i = l, i) {
        const c = () => {
          t += 1, o.forEach((u) => u());
        }, a = i;
        return a.on("transaction", c), () => {
          a.off("transaction", c);
        };
      }
    }
  };
}
function vRt(e) {
  const [t] = He(() => yRt(e.editor)), n = gRt.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, e.selector, e.equalityFn);
  return nt(() => t.watch(e.editor), [e.editor]), xve(n), n;
}
const $le = process.env.NODE_ENV !== "production", c9 = typeof window > "u", bRt = c9 || !!(typeof window < "u" && window.next);
function sMe(e = {}, t = []) {
  const n = Xe(!1), [r, i] = He(() => {
    if (e.immediatelyRender === void 0)
      return c9 || bRt ? ($le && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : new uI(e);
    if (e.immediatelyRender && c9 && $le)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return e.immediatelyRender ? new uI(e) : null;
  });
  xve(r), nt(() => {
    let E = r;
    E ? Array.isArray(t) && t.length ? (E = new uI(e), i(E)) : E.setOptions(e) : (E = new uI(e), i(E));
  }, t);
  const { onBeforeCreate: o, onBlur: s, onCreate: l, onDestroy: c, onFocus: a, onSelectionUpdate: u, onTransaction: f, onUpdate: d, onContentError: p } = e, h = Xe(o), m = Xe(s), v = Xe(l), b = Xe(c), A = Xe(a), w = Xe(u), O = Xe(f), x = Xe(d), S = Xe(p);
  return nt(() => {
    r && (o && (r.off("beforeCreate", h.current), r.on("beforeCreate", o), h.current = o), s && (r.off("blur", m.current), r.on("blur", s), m.current = s), l && (r.off("create", v.current), r.on("create", l), v.current = l), c && (r.off("destroy", b.current), r.on("destroy", c), b.current = c), a && (r.off("focus", A.current), r.on("focus", a), A.current = a), u && (r.off("selectionUpdate", w.current), r.on("selectionUpdate", u), w.current = u), f && (r.off("transaction", O.current), r.on("transaction", f), O.current = f), d && (r.off("update", x.current), r.on("update", d), x.current = d), p && (r.off("contentError", S.current), r.on("contentError", p), S.current = p));
  }, [
    o,
    s,
    l,
    c,
    a,
    u,
    f,
    d,
    p,
    r
  ]), nt(() => (n.current = !0, () => {
    n.current = !1, r && setTimeout(() => {
      !n.current && !r.isDestroyed && r.destroy();
    });
  }), []), vRt({
    editor: r,
    selector: ({ transactionNumber: E }) => e.shouldRerenderOnTransaction === !1 ? null : e.immediatelyRender && E === 0 ? 0 : E + 1
  }), r;
}
const ORt = Ri({
  editor: null
});
ORt.Consumer;
const ARt = Ri({
  onDragStart: void 0
}), wRt = () => kr(ARt);
ie.forwardRef((e, t) => {
  const { onDragStart: n } = wRt(), r = e.as || "div";
  return ie.createElement(r, { ...e, ref: t, "data-node-view-wrapper": "", onDragStart: n, style: {
    whiteSpace: "normal",
    ...e.style
  } });
});
const aMe = ie.forwardRef(
  ({
    initialValue: e,
    onChange: t,
    className: n,
    disabled: r,
    placeholder: i,
    placeholderClassName: o,
    onlyEditableOnDoubleClick: s
  }, l) => {
    const c = sMe({
      extensions: [
        vNt,
        NK,
        RK,
        KPt,
        PK,
        mIt.configure({
          className: "has-focus",
          mode: "all"
        }),
        aRt,
        ONt.configure({
          inline: !0
        }),
        $Pt,
        PRe,
        ARe,
        wRe,
        URe,
        xRt,
        ZRe.configure({
          depth: 10
        }),
        si.create({
          addKeyboardShortcuts() {
            return {
              "Cmd-Enter"() {
                return c.commands.enter(), !0;
              },
              "Ctrl-Enter"() {
                return c.commands.enter(), !0;
              },
              "Shift-Enter"() {
                return c.commands.enter(), !0;
              }
            };
          }
        })
      ],
      content: e,
      contentType: "markdown",
      editable: !r && !s,
      onUpdate: ({ editor: u }) => {
        t(u.getMarkdown());
      },
      editorProps: {
        attributes: {
          class: Se(
            "bg-transparent text-inherit outline-none border-none p-0 m-0",
            n
          ),
          spellcheck: "false"
        }
      },
      onBlur: () => {
        var u;
        (u = window.getSelection()) == null || u.removeAllRanges(), s && c.setEditable(!1, !1);
      },
      parseOptions: {
        preserveWhitespace: "full"
      }
    });
    rW(l, () => c, [c]);
    const a = (u) => {
      r || !c.isEditable || u.stopPropagation();
    };
    return (
      //gotta add this nodrag nopan to prevent dnd-kit and React Flow interference with selection
      /* @__PURE__ */ V(
        "div",
        {
          className: Se("relative h-full nowheel", {
            "nodrag nopan": !c.isEditable
          }),
          onPointerDown: a,
          onMouseDown: a,
          onClick: a,
          onPointerUp: a,
          onMouseUp: a,
          onDoubleClick: () => {
            s && !r && c.setEditable(!0, !1);
          },
          children: [
            c.getText().trim() === "" && !r && /* @__PURE__ */ V(
              "div",
              {
                className: Se(
                  o,
                  "opacity-75 pointer-events-none  absolute  z-50 "
                ),
                children: [
                  " ",
                  i,
                  " "
                ]
              }
            ),
            /* @__PURE__ */ y(
              iMe,
              {
                className: c.isEditable ? "cursor-text select-text" : "",
                editor: c
              },
              r ? "disabled" : "enabled"
            )
          ]
        }
      )
    );
  }
);
aMe.displayName = "MarkdownInput";
const xRt = MK.extend({
  renderMarkdown: (e, t) => {
    const n = t.renderChildren(e.content ?? []);
    return !n || n.trim() === "" ? "<br>" : n;
  }
}), Fj = ({
  tooltipMessage: e,
  children: t
}) => {
  const n = Xe(null), [r, i] = He(!1), o = qn(() => {
    n.current && i(n.current.scrollWidth > n.current.clientWidth);
  }, []);
  nt(() => (o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o)), [o]);
  const s = ie.cloneElement(t, {
    ref: n,
    className: Se("truncate", t.props.className)
  });
  return r ? /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: s }),
    /* @__PURE__ */ y(An, { className: "max-w-md wrap-break-word whitespace-normal", children: /* @__PURE__ */ y("p", { children: e }) })
  ] }) }) : s;
}, lMe = ({ creatorId: e }) => {
  const { data: t } = gj.useUserById(e ?? null), n = t != null && t.firstName && (t != null && t.lastName) ? `${t.firstName} ${t.lastName}` : t == null ? void 0 : t.email;
  return /* @__PURE__ */ y("div", { className: "flex items-center justify-between gap-2", children: /* @__PURE__ */ y("div", { className: "grow", children: !De(n) && /* @__PURE__ */ y(Fj, { tooltipMessage: n, children: /* @__PURE__ */ y("div", { className: "text-xs opacity-65", children: n }) }) }) });
};
lMe.displayName = "NoteFooter";
const SRt = ({ editor: e }) => {
  const t = e.isActive("strike"), n = e.isActive("bold"), r = e.isActive("italic"), i = e.isActive("underline"), [o, s] = He({
    isStrikeActive: t,
    isBoldActive: n,
    isItalicActive: r,
    isUnderlineActive: i
  }), l = () => {
    e.setEditable(!0), e.chain().focus().toggleStrike().run(), e.commands.focus(), s({
      ...o,
      isStrikeActive: !t
    });
  }, c = () => {
    e.setEditable(!0), e.chain().focus().toggleBold().run(), e.commands.focus(), s({
      ...o,
      isBoldActive: !n
    });
  }, a = () => {
    e.setEditable(!0), e.chain().focus().toggleItalic().run(), e.commands.focus(), s({
      ...o,
      isItalicActive: !r
    });
  }, u = () => {
    e.setEditable(!0), e.chain().focus().toggleUnderline().run(), e.commands.focus(), s({
      ...o,
      isUnderlineActive: !i
    });
  };
  nt(() => {
    s({
      isStrikeActive: t,
      isBoldActive: n,
      isItalicActive: r,
      isUnderlineActive: i
    });
  }, [t, n, r, i]);
  const f = Xe(null);
  return /* @__PURE__ */ V(
    "div",
    {
      ref: f,
      className: "flex items-center gap-0.5 text-foreground",
      children: [
        /* @__PURE__ */ y(ERt, { editor: e, containerRef: f }),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: l,
            size: "icon",
            variant: t ? "default" : "ghost",
            children: /* @__PURE__ */ y(ast, { className: "size-4" })
          }
        ),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: c,
            size: "icon",
            variant: n ? "default" : "ghost",
            children: /* @__PURE__ */ y(Yrt, { className: "size-4" })
          }
        ),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: a,
            size: "icon",
            variant: r ? "default" : "ghost",
            children: /* @__PURE__ */ y(not, { className: "size-4" })
          }
        ),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: u,
            size: "icon",
            variant: i ? "default" : "ghost",
            children: /* @__PURE__ */ y(yst, { className: "size-4" })
          }
        )
      ]
    }
  );
}, ERt = ({
  editor: e,
  containerRef: t
}) => {
  const [n, r] = He(!1), [i, o] = He(""), s = () => {
    e.chain().focus().setImage({ src: i, alt: "note-img-" + Date.now() }).run(), e.commands.focus(), o(""), r(!1);
  };
  return /* @__PURE__ */ V(mx, { modal: !1, open: n, onOpenChange: r, children: [
    /* @__PURE__ */ y(gx, { asChild: !0, children: /* @__PURE__ */ y(Qe, { size: "icon", variant: "ghost", children: /* @__PURE__ */ y(Git, { className: "size-4" }) }) }),
    /* @__PURE__ */ y(
      Sb,
      {
        side: "top",
        className: "p-1 px-1.5 mb-1",
        container: t.current,
        children: /* @__PURE__ */ V("div", { className: "flex items-center gap-2 min-w-[200px]", children: [
          /* @__PURE__ */ y(
            fr,
            {
              className: "h-8",
              onPointerDown: (l) => l.stopPropagation(),
              onKeyDown: (l) => l.key === "Enter" && s(),
              type: "text",
              placeholder: "Enter image URL",
              value: i,
              onChange: (l) => o(l.target.value)
            }
          ),
          /* @__PURE__ */ y(
            Qe,
            {
              size: "icon",
              onClick: s,
              disabled: i.length === 0,
              variant: "ghost",
              children: /* @__PURE__ */ y(Brt, { className: "size-4" })
            }
          )
        ] })
      }
    )
  ] });
}, cMe = ({ editor: e, currentColor: t, id: n }) => {
  const r = Xe(null), [i, o] = tn((s) => [
    s.updateNoteColor,
    s.deleteNote
  ]);
  return /* @__PURE__ */ y("div", { ref: r, className: "absolute -top-[45px] w-full left-0", children: /* @__PURE__ */ y("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ V("div", { className: "p-1 bg-background flex items-center gap-0.5 shadow-md rounded-lg scale-65 border border-solid border-border", children: [
    /* @__PURE__ */ y(
      TRt,
      {
        currentColor: t,
        setCurrentColor: (s) => {
          i(n, s);
        },
        container: r.current
      }
    ),
    /* @__PURE__ */ y(SRt, { editor: e }),
    /* @__PURE__ */ y(Eh, { orientation: "vertical", className: "h-[30px]" }),
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "ghost",
        size: "icon",
        onClick: () => {
          o(n);
        },
        children: /* @__PURE__ */ y(xb, { className: "size-4 text-destructive" })
      }
    )
  ] }) }) });
}, fI = {
  [di.YELLOW]: "bg-amber-400",
  [di.ORANGE]: "bg-orange-400",
  [di.RED]: "bg-red-400",
  [di.GREEN]: "bg-green-400",
  [di.BLUE]: "bg-blue-400",
  [di.PURPLE]: "bg-purple-400"
}, TRt = ({
  currentColor: e,
  setCurrentColor: t,
  container: n
}) => /* @__PURE__ */ V(mx, { children: [
  /* @__PURE__ */ y(gx, { asChild: !0, children: /* @__PURE__ */ y(
    "div",
    {
      className: Se(
        fI[e] ?? fI[di.YELLOW],
        "mx-0.5 size-5 shrink-0  rounded-full cursor-pointer"
      ),
      role: "button"
    }
  ) }),
  /* @__PURE__ */ y(
    Sb,
    {
      container: n,
      side: "top",
      className: "w-[80px] p-1 mb-2",
      children: /* @__PURE__ */ y("div", { className: "flex items-center cursor-default gap-1 justify-between flex-wrap w-full ", children: Object.values(di).map((r) => /* @__PURE__ */ y(
        "div",
        {
          role: "button",
          className: "size-5 shrink-0 cursor-pointer grow flex items-center justify-center",
          onClick: () => {
            t(r);
          },
          children: /* @__PURE__ */ y(
            "div",
            {
              className: Se(
                fI[r] ?? fI[di.YELLOW],
                "size-4 shrink-0 rounded-full"
              )
            }
          )
        },
        r
      )) })
    }
  )
] });
cMe.displayName = "NoteTools";
const uMe = (e) => {
  const [t, n, r, i] = tn(
    (u) => [
      u.draggedNote,
      u.resizeNote,
      u.getNoteById(e.id),
      u.readonly
    ]
  ), { attributes: o, listeners: s, setNodeRef: l } = JQ({
    id: e.id,
    data: {
      type: Ie.DRAGGED_NOTE_TAG
    }
  }), [c, a] = He(e.data.size);
  return (t == null ? void 0 : t.id) === e.id || r === null ? null : /* @__PURE__ */ V("div", { className: "group note-node outline-none", children: [
    /* @__PURE__ */ y(
      Tyt,
      {
        minWidth: 150,
        minHeight: 150,
        maxWidth: 600,
        maxHeight: 600,
        onResize: (u, f) => {
          a({ width: f.width, height: f.height });
        },
        onResizeEnd: (u, f) => {
          n(e.id, {
            width: f.width,
            height: f.height
          });
        },
        children: /* @__PURE__ */ y(
          "button",
          {
            className: Se(
              "group-focus-within:block hidden outline-none cursor-nwse-resize  rounded-full bg-stone-50 border border-solid  -translate-x-[60%] -translate-y-[60%] p-0.75",
              Kle[r.color]
            )
          }
        )
      }
    ),
    /* @__PURE__ */ y(
      "div",
      {
        ref: l,
        ...o,
        ...s,
        className: Se(
          "p-0.75 outline-none group-focus-within:border-solid border border-transparent outline-none rounded-md",
          {
            "cursor-default": i
          },
          Kle[r.color]
        ),
        children: /* @__PURE__ */ y(
          dMe,
          {
            note: {
              ...r,
              size: c
            },
            isDragging: !1
          }
        )
      },
      e.data.size.height + e.data.size.width + r.position.x + r.position.y
    )
  ] });
};
uMe.displayName = "ApNoteCanvasNode";
const dMe = ({ note: e, isDragging: t }) => {
  const { id: n, ownerId: r, color: i, size: o } = e, { width: s, height: l } = o, [c, a] = He(e), [u, f] = tn((h) => [
    h.updateContent,
    h.readonly
  ]), d = lTe(
    (h, m) => {
      u(h, m);
    },
    500
  ), p = Xe(null);
  return /* @__PURE__ */ V(
    "div",
    {
      id: n,
      className: Se(
        "rounded-md border-solid shadow-sm p-2 ",
        pU[i]
      ),
      style: {
        width: `${s}px`,
        height: `${l}px`
      },
      children: [
        !t && !f && p.current && /* @__PURE__ */ y("div", { className: "opacity-0 focus-within:opacity-100 group-focus-within:opacity-100 transition-opacity duration-300", children: /* @__PURE__ */ y(
          cMe,
          {
            editor: p.current,
            currentColor: e.color,
            id: n
          }
        ) }),
        /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 h-full", children: [
          /* @__PURE__ */ y(
            "div",
            {
              onContextMenu: (h) => h.stopPropagation(),
              className: "grow h-full overflow-auto ",
              onDoubleClick: (h) => {
                var m;
                h.stopPropagation(), (m = p.current) == null || m.commands.focus();
              },
              onKeyDown: (h) => {
                h.stopPropagation(), h.key === "Shift" && h.stopPropagation();
              },
              children: /* @__PURE__ */ y(
                aMe,
                {
                  ref: p,
                  disabled: t || f,
                  initialValue: c.content,
                  className: Se("text-xs h-full", pU[i], {
                    "!cursor-grabbing": t,
                    "!text-foreground": !0
                  }),
                  onlyEditableOnDoubleClick: !0,
                  placeholder: Z("Double click to edit..."),
                  placeholderClassName: Se(
                    "text-xs",
                    pU[i]
                  ),
                  onChange: (h) => {
                    a({ ...c, content: h }), d(n, h);
                  }
                },
                `${c.id}-${f ? "readonly" : "editable"}-${c.position.x}-${c.position.y}`
              )
            }
          ),
          /* @__PURE__ */ y(lMe, { id: n, isDragging: t, creatorId: r })
        ] })
      ]
    }
  );
}, pU = {
  [di.YELLOW]: "dark:bg-[oklch(0.3052_0.0455_83.74)] dark:text-[oklch(0.8826_0.1328_86.23)] bg-[oklch(0.9638_0.0522_92.93)] text-[oklch(0.4784_0.1089_63.21)]",
  [di.ORANGE]: "dark:bg-[oklch(0.2968_0.0566_51.71)] dark:text-[oklch(0.8717_0.0836_58.75)] text-[oklch(0.4905_0.140461_44.9084)] bg-[oklch(0.9583_0.0245_61.65)]",
  [di.RED]: "dark:bg-[oklch(0.3046_0.0779_7.16)] dark:text-[oklch(0.9002_0.052_18.16)] bg-[oklch(0.956_0.0218_17.54)] text-[oklch(0.5141_0.1849_26.72)]",
  [di.GREEN]: "dark:bg-[oklch(0.3411_0.0464_168.94)] dark:text-[oklch(0.9025_0.0888_163.86)] text-[oklch(0.5208_0.115675_161.168)] bg-[oklch(0.9667_0.0353_162.37)]",
  [di.BLUE]: "dark:bg-[oklch(0.3086_0.0738_264.7)] dark:text-[oklch(0.8746_0.061_264.64)] bg-[oklch(0.9474_0.0249_263.33)] text-[oklch(0.4975_0.1752_261.14)]",
  [di.PURPLE]: "dark:bg-[oklch(0.2936_0.1027_291.89)] dark:text-[oklch(0.8565_0.0834_300.16)] text-[oklch(0.4647_0.186_293.18)] bg-[oklch(0.9633_0.0206_301.15)]"
}, Kle = {
  [di.YELLOW]: "dark:group-focus-within:text-[oklch(0.8826_0.1328_86.23)] group-focus-within:border-[oklch(0.4784_0.1089_63.21)]",
  [di.ORANGE]: "dark:group-focus-within:text-[oklch(0.8717_0.0836_58.75)] group-focus-within:border-[oklch(0.4905_0.140461_44.9084)]",
  [di.RED]: "dark:group-focus-within:text-[oklch(0.9002_0.052_18.16)] group-focus-within:border-[oklch(0.5141_0.1849_26.72)]",
  [di.GREEN]: "dark:group-focus-within:text-[oklch(0.9025_0.0888_163.86)] group-focus-within:border-[oklch(0.5208_0.115675_161.168)]",
  [di.BLUE]: "dark:group-focus-within:text-[oklch(0.8746_0.061_264.64)] group-focus-within:border-[oklch(0.4975_0.1752_261.14)]",
  [di.PURPLE]: "dark:group-focus-within:text-[oklch(0.8565_0.0834_300.16)] group-focus-within:border-[oklch(0.4647_0.186_293.18)]"
};
function Ff(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var kRt = ["color"], CRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, kRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), NRt = ["color"], PRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, NRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), IRt = ["color"], RRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, IRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), MRt = ["color"], DRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, MRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), _Rt = ["color"], LRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, _Rt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), zRt = ["color"], jRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, zRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), FRt = ["color"], fMe = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, FRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), URt = ["color"], pMe = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, URt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), VRt = ["color"], qRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, VRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), BRt = ["color"], XRt = /* @__PURE__ */ Fo(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Ff(e, BRt);
  return oi("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), oi("path", {
    d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const hMe = ({ stepName: e }) => {
  const [t, n, r, i, o, s] = tn((f) => {
    var d;
    return [
      f.setLoopIndex,
      f.loopsIndexes[e] ?? 0,
      f.run,
      f.flowVersion,
      f.loopsIndexes,
      (d = At.getStep(e, f.flowVersion.trigger)) == null ? void 0 : d.type
    ];
  }), l = Kt(() => r && r.steps ? Ks.extractStepOutput(
    e,
    o,
    r.steps,
    i.trigger
  ) : null, [r, e, o, i.trigger]), c = Xe(null), a = l && l.output && l.type === qe.LOOP_ON_ITEMS ? l.output.iterations.length : 0;
  function u(f) {
    const d = Math.max(
      1,
      Math.min(parseInt(f) ?? 1, a)
    );
    t(e, d - 1);
  }
  return De(r) || s !== qe.LOOP_ON_ITEMS ? /* @__PURE__ */ y(pt, {}) : /* @__PURE__ */ y("div", { className: "absolute -top-4 -left-[45px]", children: /* @__PURE__ */ V("div", { className: "flex items-center justify-center flex-col gap-0.5", children: [
    /* @__PURE__ */ y(
      Gle,
      {
        onChange: u,
        isIncreasing: !0,
        currentIndex: n
      }
    ),
    /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { children: /* @__PURE__ */ y(
        fr,
        {
          ref: c,
          className: "py-2 duration-300 w-[35px] px-0 h-[35px] animate-in fade-in bg-background border-border border border-solid rounded-md text-center !text-xs",
          type: "number",
          value: n + 1,
          min: 1,
          max: a,
          onClick: (f) => {
            f.button === 0 && (f.preventDefault(), f.stopPropagation());
          },
          onChange: (f) => {
            const d = De(f.target.value) || f.target.value.length === 0 || f.target.value === "e" ? "1" : f.target.value;
            u(d);
          }
        }
      ) }),
      /* @__PURE__ */ y(An, { side: "left", children: Z(
        "Show child steps output on round ({iteration}/{totalIterations})",
        { iteration: n + 1, totalIterations: a }
      ) })
    ] }),
    /* @__PURE__ */ y(
      Gle,
      {
        onChange: u,
        isIncreasing: !1,
        currentIndex: n
      }
    )
  ] }) });
};
hMe.displayName = "LoopIterationInput";
const Gle = ({
  onChange: e,
  isIncreasing: t,
  currentIndex: n
}) => /* @__PURE__ */ y(
  Qe,
  {
    variant: "ghost",
    onClick: (r) => {
      r.preventDefault(), r.stopPropagation(), e((n + (t ? 2 : 0)).toString());
    },
    className: "hover:bg-builder-background size-6",
    size: "icon",
    children: t ? /* @__PURE__ */ y(RRt, { className: "w-2 h-2" }) : /* @__PURE__ */ y(CRt, { className: "w-2 h-2" })
  }
), QK = ({ className: e }) => /* @__PURE__ */ V(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    className: Se(
      "stroke-1 dark:stroke-amber-900 stroke-amber-500 ",
      e
    ),
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ y(
        "circle",
        {
          cx: "8.08325",
          cy: "8.26868",
          r: "7.5",
          className: "dark:fill-amber-950 fill-amber-50 "
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M8.08325 3.69368C7.86445 3.69368 7.65461 3.7806 7.49989 3.93531C7.34517 4.09003 7.25825 4.29987 7.25825 4.51868V8.51868C7.25825 8.73748 7.34517 8.94732 7.49989 9.10204C7.65461 9.25676 7.86445 9.34368 8.08325 9.34368C8.30206 9.34368 8.5119 9.25676 8.66662 9.10204C8.82133 8.94732 8.90825 8.73748 8.90825 8.51868V4.51868C8.90825 4.29987 8.82133 4.09003 8.66662 3.93531C8.5119 3.7806 8.30206 3.69368 8.08325 3.69368ZM8.90825 12.0187C8.90825 11.563 8.53889 11.1937 8.08325 11.1937C7.62762 11.1937 7.25825 11.563 7.25825 12.0187C7.25825 12.4743 7.62762 12.8437 8.08325 12.8437C8.53889 12.8437 8.90825 12.4743 8.90825 12.0187Z",
          className: "dark:fill-amber-600 fill-amber-700",
          strokeWidth: "0.4"
        }
      )
    ]
  }
), WRt = ({
  isValid: e,
  isSkipped: t
}) => /* @__PURE__ */ y(
  "div",
  {
    className: "absolute flex items-center -left-[22px] bg-builder-background ",
    style: { height: `${Ie.AP_NODE_SIZE.STEP.height}px` },
    children: /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V("div", { children: [
        !e && !t && /* @__PURE__ */ y(QK, { className: "h-4 w-4" }),
        t && /* @__PURE__ */ y(ixe, { className: "w-3.5 h-3.5 animate-fade text-muted-foreground" })
      ] }) }),
      (!e || t) && /* @__PURE__ */ y(An, { children: /* @__PURE__ */ V("div", { children: [
        !e && !t && Z("Incomplete step"),
        t && Z("Skipped")
      ] }) })
    ] })
  }
), ZRt = ({ onClick: e }) => /* @__PURE__ */ y(
  Qe,
  {
    variant: "ghost",
    size: "sm",
    className: "p-1 size-7 ",
    onClick: e,
    children: /* @__PURE__ */ y(ex, { className: "w-4 h-4 stroke-muted-foreground" })
  }
), HRt = ({ duration: e }) => /* @__PURE__ */ V("div", { className: "text-xs text-muted-foreground shrink-0 flex items-center gap-1", children: [
  /* @__PURE__ */ y(iD, { className: "size-3" }),
  /* @__PURE__ */ y("span", { children: rc.formatDuration(e, !0) })
] }), mMe = ({
  stepName: e,
  pieceDisplayName: t
}) => {
  const [n, r, i] = tn((s) => [
    s.run,
    s.loopsIndexes,
    s.flowVersion
  ]), o = Kt(() => n && n.steps ? Ks.extractStepOutput(
    e,
    r,
    n.steps,
    i.trigger
  ) : null, [n, e, r, i.trigger]);
  return /* @__PURE__ */ V("div", { className: "flex justify-between mt-0.5 w-full items-center", children: [
    /* @__PURE__ */ y(
      Fj,
      {
        tooltipMessage: t,
        children: /* @__PURE__ */ y("div", { className: "text-xs text-muted-foreground truncate  grow shrink w-full", children: t })
      },
      t + (o == null ? void 0 : o.duration)
    ),
    o && /* @__PURE__ */ y(HRt, { duration: (o == null ? void 0 : o.duration) ?? 0 })
  ] });
};
mMe.displayName = "StepNodeRunDurationAndPieceName";
const QRt = ({
  stepDisplayName: e,
  stepIndex: t,
  isSkipped: n,
  pieceDisplayName: r,
  stepName: i
}) => /* @__PURE__ */ V("div", { className: "grow flex flex-col items-start justify-center min-w-0 w-full", children: [
  /* @__PURE__ */ y("div", { className: " flex items-center justify-between min-w-0 w-full", children: /* @__PURE__ */ y(Fj, { tooltipMessage: e, children: /* @__PURE__ */ V(
    "div",
    {
      className: Se("text-sm truncate grow shrink ", {
        "text-accent-foreground/70": n
      }),
      children: [
        t,
        ". ",
        e
      ]
    }
  ) }, e) }),
  /* @__PURE__ */ y(
    mMe,
    {
      stepName: i,
      pieceDisplayName: r
    }
  )
] }), $Rt = ({
  isSkipped: e,
  logoUrl: t,
  displayName: n
}) => /* @__PURE__ */ y(
  "div",
  {
    className: Se("flex items-center justify-center rounded-sm", {
      "opacity-80": e
    }),
    children: /* @__PURE__ */ y(
      cNe,
      {
        src: t,
        alt: n,
        border: !0,
        className: "w-9 h-9 p-2"
      },
      t + n
    )
  }
), KRt = ({ stepName: e }) => /* @__PURE__ */ y(
  "div",
  {
    className: "absolute left-full bg-builder-background ml-3 text-accent-foreground text-xs opacity-0 transition-all duration-300 group-hover:opacity-100 ",
    style: {
      top: `${Ie.AP_NODE_SIZE.STEP.height / 2 - 12}px`
    },
    children: e
  }
), GRt = {
  [po.RUNNING]: Z("Step running"),
  [po.PAUSED]: Z("Step paused"),
  [po.STOPPED]: Z("Step Stopped"),
  [po.SUCCEEDED]: Z("Step Succeeded"),
  [po.FAILED]: Z("Step Failed")
}, JO = ie.memo(
  ({ status: e, size: t, hideTooltip: n = !1 }) => {
    const { variant: r, Icon: i } = Ks.getStatusIconForStep(e);
    return e === po.RUNNING ? /* @__PURE__ */ y(mu, { className: "w-3 h-3 " }) : /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
        i,
        {
          className: Se("", {
            "size-3": t === "3",
            "size-4.5": t === "4.5",
            "size-4": t === "4",
            "size-5": t === "5",
            "text-green-700 dark:text-green-200": r === "success",
            "text-red-700 dark:text-red-200": r === "error",
            "text-foreground": r === "default"
          })
        }
      ) }),
      !n && /* @__PURE__ */ y(An, { side: "bottom", children: GRt[e] })
    ] });
  }
);
JO.displayName = "StepStatusIcon";
const gMe = ({ stepName: e }) => {
  const [t, n, r] = tn((l) => [
    l.run,
    l.loopsIndexes,
    l.flowVersion
  ]), i = Kt(() => Na.getStepStatus(
    e,
    t,
    n,
    r
  ), [e, t, n, r]);
  if (!i)
    return null;
  const { variant: o, text: s } = Ks.getStatusIconForStep(i);
  return /* @__PURE__ */ y("div", { className: "absolute right-[1px]  h-[20px] -top-[28px]", children: /* @__PURE__ */ V(
    "div",
    {
      className: Se(
        "flex gap-1 animate-in fade-in slide-in-from-bottom-2 duration-500 items-center  justify-center px-2 py-1",
        Ks.getStatusContainerClassName(o)
      ),
      children: [
        /* @__PURE__ */ y(
          JO,
          {
            status: i,
            size: "3",
            hideTooltip: !0
          }
        ),
        /* @__PURE__ */ y("div", { children: s })
      ]
    }
  ) });
};
gMe.displayName = "ApStepNodeStatus";
const YRt = ({ isSelected: e }) => /* @__PURE__ */ V(
  "div",
  {
    className: Se(
      "flex items-center absolute transition-all  -translate-y-[26px] -translate-x-[1px]  border-border border border-1   justify-center gap-1 rounded-t-md bg-background text-muted-foreground text-xs py-1 px-2 ",
      {
        "border-primary text-primary ": e,
        "group-hover:border-ring ": !e
      }
    ),
    children: [
      /* @__PURE__ */ y(Fit, { className: "w-[10px] h-[10px]" }),
      " ",
      Z("Trigger")
    ]
  }
), yMe = ie.memo(
  ({ data: { step: e } }) => {
    const [
      t,
      n,
      r,
      i,
      o,
      s,
      l,
      c,
      a
    ] = tn((S) => {
      var E;
      return [
        S.selectStepByName,
        S.selectedStep === e.name,
        S.activeDraggingStep === e.name,
        S.readonly,
        S.flowVersion,
        S.setSelectedBranchIndex,
        S.openedPieceSelectorStepNameOrAddButtonId === e.name,
        (E = At.getStep(e.name, S.flowVersion.trigger)) == null ? void 0 : E.valid,
        S.rightSidebar !== zr.NONE
      ];
    }), { stepMetadata: u } = vd.useStepMetadata({
      step: e
    }), f = Kt(() => At.getAllSteps(o.trigger).findIndex((E) => E.name === e.name) + 1, [e, o]), d = At.isTrigger(e.type), p = Na.isSkipped(e.name, o.trigger), { attributes: h, listeners: m, setNodeRef: v } = JQ({
      id: e.name,
      disabled: d || i,
      data: {
        type: Ie.DRAGGED_STEP_TAG
      }
    }), b = (S, E = !0) => {
      t(e.name), s(null), e.type === Bt.EMPTY && setOpenedPieceSelectorStepNameOrAddButtonId(e.name), E && (S.stopPropagation(), S.preventDefault());
    }, A = (S) => {
      S.stopPropagation(), S.preventDefault(), t(e.name), s(null);
      const E = S.currentTarget.closest(
        `[data-${Ie.STEP_CONTEXT_MENU_ATTRIBUTE}]`
      ), k = new MouseEvent("contextmenu", {
        bubbles: !0,
        cancelable: !0,
        view: window,
        button: 2,
        buttons: 2,
        clientX: S.clientX,
        clientY: S.clientY
      });
      (E ?? S.currentTarget).dispatchEvent(k);
    }, w = (S) => {
      if (b(S, !1), a)
        return;
      S.preventDefault(), S.stopPropagation();
      const E = S.currentTarget, k = E.getBoundingClientRect(), T = S.clientX - k.left, R = S.clientY - k.top;
      setTimeout(() => {
        const j = E.getBoundingClientRect(), F = j.left + T, L = j.top + R, _ = new MouseEvent("contextmenu", {
          bubbles: !0,
          cancelable: !0,
          clientX: F,
          clientY: L,
          button: 2,
          buttons: 2
        });
        E.dispatchEvent(_);
      }, Ie.SIDEBAR_ANIMATION_DURATION + 50);
    }, O = l ? {} : h, x = l ? {} : m;
    return /* @__PURE__ */ oi(
      "div",
      {
        [`data-${Ie.STEP_CONTEXT_MENU_ATTRIBUTE}`]: e.name,
        style: {
          height: `${Ie.AP_NODE_SIZE.STEP.height}px`,
          width: `${Ie.AP_NODE_SIZE.STEP.width}px`,
          maxWidth: `${Ie.AP_NODE_SIZE.STEP.width}px`
        },
        onContextMenu: (S) => w(S),
        className: Se(
          "transition-all border-box rounded-md border border-solid border-border relative overflow-show  group",
          {
            "border-primary": n,
            "bg-background": !r,
            "border-none": r,
            "shadow-none": r,
            "bg-accent": p,
            "rounded-tl-none": d,
            "hover:border-ring": !n
          }
        ),
        onClick: (S) => b(S),
        key: e.name,
        ref: l ? null : v,
        ...O,
        ...x
      },
      d && /* @__PURE__ */ y(YRt, { isSelected: n }),
      /* @__PURE__ */ y(
        WRt,
        {
          isValid: !!c,
          isSkipped: p
        }
      ),
      /* @__PURE__ */ y(hMe, { stepName: e.name }),
      /* @__PURE__ */ y(gMe, { stepName: e.name }),
      /* @__PURE__ */ y(KRt, { stepName: e.name }),
      /* @__PURE__ */ V("div", { className: "px-3 h-full w-full overflow-hidden", children: [
        !r && /* @__PURE__ */ y(
          q$,
          {
            operation: {
              type: JRt(e),
              stepName: e.name
            },
            id: e.name,
            openSelectorOnClick: !1,
            stepToReplacePieceDisplayName: u == null ? void 0 : u.displayName,
            children: /* @__PURE__ */ V(
              "div",
              {
                className: "flex items-center justify-center h-full w-full gap-[10px]",
                onClick: (S) => {
                  l || b(S);
                },
                children: [
                  /* @__PURE__ */ y(
                    $Rt,
                    {
                      isSkipped: p,
                      logoUrl: (u == null ? void 0 : u.logoUrl) ?? "",
                      displayName: (u == null ? void 0 : u.displayName) ?? ""
                    }
                  ),
                  /* @__PURE__ */ y(
                    QRt,
                    {
                      stepDisplayName: e.displayName,
                      stepIndex: f,
                      isSkipped: p,
                      pieceDisplayName: (u == null ? void 0 : u.displayName) ?? "",
                      stepName: e.name
                    }
                  ),
                  !i && /* @__PURE__ */ y(ZRt, { onClick: A })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ y(
          ou,
          {
            type: "source",
            style: Ie.HANDLE_STYLING,
            position: sn.Bottom
          }
        ),
        /* @__PURE__ */ y(
          ou,
          {
            type: "target",
            style: Ie.HANDLE_STYLING,
            position: sn.Top
          }
        )
      ] })
    );
  }
);
yMe.displayName = "ApStepCanvasNode";
function JRt(e) {
  return At.isTrigger(e.type) ? Tt.UPDATE_TRIGGER : Tt.UPDATE_ACTION;
}
var Ci = /* @__PURE__ */ ((e) => (e.STEP = "STEP", e.ADD_BUTTON = "ADD_BUTTON", e.BIG_ADD_BUTTON = "BIG_ADD_BUTTON", e.GRAPH_END_WIDGET = "GRAPH_END_WIDGET", e.GRAPH_START_WIDGET = "GRAPH_START_WIDGET", e.LOOP_RETURN_NODE = "LOOP_RETURN_NODE", e.NOTE = "NOTE", e))(Ci || {}), Uc = /* @__PURE__ */ ((e) => (e.STRAIGHT_LINE = "ApStraightLineEdge", e.LOOP_START_EDGE = "ApLoopStartEdge", e.LOOP_CLOSE_EDGE = "ApLoopCloseEdge", e.LOOP_RETURN_EDGE = "ApLoopReturnEdge", e.ROUTER_START_EDGE = "ApRouterStartEdge", e.ROUTER_END_EDGE = "ApRouterEndEdge", e))(Uc || {});
const ni = 15, eMt = `a${ni},${ni} 0 0,0 -${ni},${ni}`, tMt = `a${ni},${ni} 0 0,1 ${ni},${ni}`, nMt = `a${ni},${ni} 0 0,1 -${ni},${ni}`, rMt = `a${ni},${ni} 0 0,0 ${ni},${ni}`, iMt = `a${ni},${ni} 0 0,1 -${ni},-${ni}`, oMt = `a-${ni},-${ni} 0 0,0 ${ni},-${ni}`, sMt = "m6 -6 l-6 6 m-6 -6 l6 6", aMt = 7, vMe = 60, bMe = vMe * 1.5 + 2 * ni, OMe = 30, lMt = 12, cMt = 75, uMt = 75, dMt = 200, fMt = 250, pMt = bMe + OMe, hMt = 1.5, mMt = "dragged-step", gMt = "dragged-note", yMt = 80, vMt = {
  [Ci.BIG_ADD_BUTTON]: {
    height: 50,
    width: 50
  },
  [Ci.ADD_BUTTON]: {
    height: 20,
    width: 20
  },
  [Ci.STEP]: {
    height: 60,
    width: 232
  },
  [Ci.LOOP_RETURN_NODE]: {
    height: 60,
    width: 232
  },
  [Ci.GRAPH_END_WIDGET]: {
    height: 0,
    width: 0
  }
}, bMt = (e) => e === Ci.BIG_ADD_BUTTON || e === Ci.STEP || e === Ci.LOOP_RETURN_NODE, Ie = {
  ARC_LENGTH: ni,
  ARC_LEFT: eMt,
  ARC_RIGHT: tMt,
  ARC_LEFT_DOWN: nMt,
  ARC_RIGHT_DOWN: rMt,
  VERTICAL_OFFSET_BETWEEN_LOOP_AND_CHILD: bMe,
  AP_NODE_SIZE: vMt,
  VERTICAL_SPACE_BETWEEN_STEP_AND_LINE: aMt,
  ARROW_DOWN: sMt,
  VERTICAL_SPACE_BETWEEN_STEPS: vMe,
  ARC_RIGHT_UP: iMt,
  LINE_WIDTH: hMt,
  LABEL_HEIGHT: OMe,
  ARC_LEFT_UP: oMt,
  VERTICAL_OFFSET_BETWEEN_ROUTER_AND_CHILD: pMt,
  doesNodeAffectBoundingBox: bMt,
  edgeTypes: {
    [Uc.STRAIGHT_LINE]: o1t,
    [Uc.LOOP_START_EDGE]: qxt,
    [Uc.LOOP_RETURN_EDGE]: Vxt,
    [Uc.ROUTER_START_EDGE]: i1t,
    [Uc.ROUTER_END_EDGE]: Bxt
  },
  nodeTypes: {
    [Ci.STEP]: yMe,
    [Ci.LOOP_RETURN_NODE]: uPe,
    [Ci.BIG_ADD_BUTTON]: lPe,
    [Ci.GRAPH_END_WIDGET]: cPe,
    [Ci.NOTE]: uMe
  },
  DRAGGED_STEP_TAG: mMt,
  DRAGGED_NOTE_TAG: gMt,
  HORIZONTAL_SPACE_BETWEEN_NODES: yMt,
  HANDLE_STYLING: { opacity: 0, cursor: "default" },
  LABEL_VERTICAL_PADDING: lMt,
  STEP_DRAG_OVERLAY_WIDTH: cMt,
  STEP_DRAG_OVERLAY_HEIGHT: uMt,
  NOTE_CREATION_OVERLAY_WIDTH: dMt,
  NOTE_CREATION_OVERLAY_HEIGHT: fMt,
  STEP_CONTEXT_MENU_ATTRIBUTE: "step-context-menu",
  SELECTION_RECT_CHEVRON_ATTRIBUTE: "selection-rect-chevron",
  BUILDER_NAVIGATION_SIDEBAR_ID: "builder-navigation-sidebar",
  NODE_SELECTION_RECT_CLASS_NAME: "react-flow__nodesselection-rect",
  SIDEBAR_ANIMATION_DURATION: 200,
  DEFAULT_NOTE_CONTENT: "<br>",
  DEFAULT_NOTE_COLOR: di.BLUE
}, AMe = (e, t) => {
  const n = {
    id: `${e.name}-big-add-button-${t.edgeId}`,
    type: Ci.BIG_ADD_BUTTON,
    position: { x: 0, y: 0 },
    data: t,
    selectable: !1,
    style: {
      pointerEvents: "all"
    }
  }, r = {
    id: `${e.name}-subgraph-end-${t.edgeId}`,
    type: Ci.GRAPH_END_WIDGET,
    position: {
      x: Ie.AP_NODE_SIZE.STEP.width / 2,
      y: Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_SPACE_BETWEEN_STEPS
    },
    data: {},
    selectable: !1
  }, i = {
    id: `big-button-straight-line-for${t.edgeId}`,
    source: `${e.name}-big-add-button-${t.edgeId}`,
    target: `${e.name}-subgraph-end-${t.edgeId}`,
    type: Uc.STRAIGHT_LINE,
    data: {
      drawArrowHead: !1,
      hideAddButton: !0,
      parentStepName: e.name
    }
  };
  return {
    nodes: [n, r],
    edges: [i]
  };
}, OMt = (e, t) => {
  var o;
  const n = {
    id: e.name,
    type: Ci.STEP,
    position: { x: 0, y: 0 },
    data: {
      step: e
    },
    selectable: e.name !== "trigger",
    draggable: !0,
    style: {
      pointerEvents: "all"
    }
  }, r = {
    id: `${e.name}-subgraph-end`,
    type: Ci.GRAPH_END_WIDGET,
    position: {
      x: Ie.AP_NODE_SIZE.STEP.width / 2,
      y: t
    },
    data: {},
    selectable: !1
  }, i = {
    id: `${e.name}-${((o = e.nextAction) == null ? void 0 : o.name) ?? "graph-end"}-edge`,
    source: e.name,
    target: `${e.name}-subgraph-end`,
    type: Uc.STRAIGHT_LINE,
    data: {
      drawArrowHead: !De(e.nextAction),
      parentStepName: e.name
    }
  };
  return {
    nodes: [n, r],
    edges: e.type !== qe.LOOP_ON_ITEMS && e.type !== qe.ROUTER ? [i] : []
  };
}, Uj = (e) => {
  if (De(e))
    return {
      nodes: [],
      edges: []
    };
  const t = OMt(
    e,
    Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_SPACE_BETWEEN_STEPS
  ), n = e.type === qe.LOOP_ON_ITEMS ? wMt(e) : e.type === qe.ROUTER ? xMt(e) : null, r = n ? u9(t, n) : t, i = Uj(e.nextAction);
  return u9(
    r,
    $K(i, {
      x: 0,
      y: wN(r).height
    })
  );
};
function $K(e, t) {
  return {
    nodes: e.nodes.map((n) => ({
      ...n,
      position: {
        x: n.position.x + t.x,
        y: n.position.y + t.y
      }
    })),
    edges: e.edges
  };
}
function u9(e, t) {
  return {
    nodes: [...e.nodes, ...t.nodes],
    edges: [...e.edges, ...t.edges]
  };
}
function AMt(e) {
  return {
    nodes: [{ id: e }],
    duration: 1e3,
    maxZoom: 1.25,
    minZoom: 1.25
  };
}
const wN = (e) => {
  const t = Math.min(
    ...e.nodes.filter((l) => Ie.doesNodeAffectBoundingBox(l.type)).map((l) => l.position.x)
  ), n = Math.min(...e.nodes.map((l) => l.position.y)), r = Math.max(
    ...e.nodes.filter((l) => Ie.doesNodeAffectBoundingBox(l.type)).map(
      (l) => l.position.x + Ie.AP_NODE_SIZE.STEP.width
    )
  ), i = Math.max(...e.nodes.map((l) => l.position.y)), o = r - t, s = i - n;
  return {
    width: o,
    height: s,
    left: -t + Ie.AP_NODE_SIZE.STEP.width / 2,
    right: r - Ie.AP_NODE_SIZE.STEP.width / 2,
    top: n,
    bottom: i
  };
}, wMt = (e) => {
  const t = e.firstLoopAction ? Uj(e.firstLoopAction) : AMe(e, {
    parentStepName: e.name,
    stepLocationRelativeToParent: Hn.INSIDE_LOOP,
    edgeId: `${e.name}-loop-start-edge`
  }), n = wN(t), r = -(n.width + Ie.AP_NODE_SIZE.STEP.width + Ie.HORIZONTAL_SPACE_BETWEEN_NODES - Ie.AP_NODE_SIZE.STEP.width / 2 - n.right) / 2 - Ie.AP_NODE_SIZE.STEP.width / 2, i = {
    id: `${e.name}-loop-return-node`,
    type: Ci.LOOP_RETURN_NODE,
    position: {
      x: r + Ie.AP_NODE_SIZE.STEP.width / 2,
      y: Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_OFFSET_BETWEEN_LOOP_AND_CHILD + n.height / 2
    },
    data: {},
    selectable: !1
  }, o = $K(t, {
    x: r + Ie.AP_NODE_SIZE.STEP.width + Ie.HORIZONTAL_SPACE_BETWEEN_NODES + n.left,
    y: Ie.VERTICAL_OFFSET_BETWEEN_LOOP_AND_CHILD + Ie.AP_NODE_SIZE.STEP.height
  }), s = [
    {
      id: `${e.name}-loop-start-edge`,
      source: e.name,
      target: `${t.nodes[0].id}`,
      type: Uc.LOOP_START_EDGE,
      data: {
        isLoopEmpty: De(e.firstLoopAction)
      }
    },
    {
      id: `${e.name}-loop-return-node`,
      source: `${t.nodes[t.nodes.length - 1].id}`,
      target: `${e.name}-loop-return-node`,
      type: Uc.LOOP_RETURN_EDGE,
      data: {
        parentStepName: e.name,
        isLoopEmpty: De(e.firstLoopAction),
        drawArrowHeadAfterEnd: !De(e.nextAction),
        verticalSpaceBetweenReturnNodeStartAndEnd: n.height + Ie.VERTICAL_SPACE_BETWEEN_STEPS
      }
    }
  ], l = {
    id: `${e.name}-loop-subgraph-end`,
    type: Ci.GRAPH_END_WIDGET,
    position: {
      x: Ie.AP_NODE_SIZE.STEP.width / 2,
      y: Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_OFFSET_BETWEEN_LOOP_AND_CHILD + n.height + Ie.ARC_LENGTH + Ie.VERTICAL_SPACE_BETWEEN_STEPS
    },
    data: {},
    selectable: !1
  };
  return {
    nodes: [i, ...o.nodes, l],
    edges: [...s, ...o.edges]
  };
}, xMt = (e) => {
  const t = e.children.map((s, l) => s ? Uj(s) : AMe(e, {
    parentStepName: e.name,
    stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
    branchIndex: l,
    edgeId: `${e.name}-branch-${l}-start-edge`
  })), n = SMt(t), r = Math.max(
    ...n.map((s) => wN(s).height)
  ), i = {
    id: `${e.name}-branch-subgraph-end`,
    type: Ci.GRAPH_END_WIDGET,
    position: {
      x: Ie.AP_NODE_SIZE.STEP.width / 2,
      y: Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_OFFSET_BETWEEN_ROUTER_AND_CHILD + r + Ie.ARC_LENGTH + Ie.VERTICAL_SPACE_BETWEEN_STEPS
    },
    data: {},
    selectable: !1
  }, o = n.map((s, l) => {
    var c;
    return [
      {
        id: `${e.name}-branch-${l}-start-edge`,
        source: e.name,
        target: `${s.nodes[0].id}`,
        type: Uc.ROUTER_START_EDGE,
        data: {
          isBranchEmpty: De(e.children[l]),
          label: ((c = e.settings.branches[l]) == null ? void 0 : c.branchName) ?? `${Z("Branch")} ${l + 1} (missing branch)`,
          branchIndex: l,
          stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
          drawHorizontalLine: l === 0 || l === n.length - 1,
          drawStartingVerticalLine: l === 0
        }
      },
      {
        id: `${e.name}-branch-${l}-end-edge`,
        source: `${s.nodes.at(-1).id}`,
        target: i.id,
        type: Uc.ROUTER_END_EDGE,
        data: {
          drawEndingVerticalLine: l === 0,
          verticalSpaceBetweenLastNodeInBranchAndEndLine: i.position.y - s.nodes.at(-1).position.y - Ie.VERTICAL_SPACE_BETWEEN_STEPS - Ie.ARC_LENGTH,
          drawHorizontalLine: l === 0 || l === n.length - 1,
          routerOrBranchStepName: e.name,
          isNextStepEmpty: De(e.nextAction)
        }
      }
    ];
  }).flat();
  return {
    nodes: [
      ...n.map((s) => s.nodes).flat(),
      i
    ],
    edges: [...n.map((s) => s.edges).flat(), ...o]
  };
}, SMt = (e) => {
  const t = e.map(
    (i) => wN(i)
  );
  let r = -(t.reduce((i, o) => i + o.width, 0) + Ie.HORIZONTAL_SPACE_BETWEEN_NODES * (e.length - 1) - t[0].left - t[e.length - 1].right) / 2 - t[0].left;
  return t.map((i, o) => {
    const s = r + i.left;
    return r += i.width + Ie.HORIZONTAL_SPACE_BETWEEN_NODES, $K(e[o], {
      x: s,
      y: Ie.AP_NODE_SIZE.STEP.height + Ie.VERTICAL_OFFSET_BETWEEN_ROUTER_AND_CHILD
    });
  });
}, EMt = (e) => e.stepLocationRelativeToParent === Hn.INSIDE_BRANCH ? {
  type: Tt.ADD_ACTION,
  actionLocation: {
    parentStep: e.parentStepName,
    stepLocationRelativeToParent: e.stepLocationRelativeToParent,
    branchIndex: e.branchIndex
  }
} : {
  type: Tt.ADD_ACTION,
  actionLocation: {
    parentStep: e.parentStepName,
    stepLocationRelativeToParent: e.stepLocationRelativeToParent
  }
}, TMt = (e, t) => {
  const n = At.getStep(e, t);
  return De(n) || n.type === Bt.EMPTY || n.type === Bt.PIECE ? !1 : At.findPathToStep(t, e).filter(
    (i) => i.type === qe.LOOP_ON_ITEMS || i.type === qe.ROUTER
  ).filter(
    (i) => At.isChildOf(i, e)
  ).filter((i) => i.skip).length > 0 || !!n.skip;
}, kMt = (e, t, n, r) => {
  if (De(t) || De(e) || De(t.steps))
    return;
  const i = Ks.extractStepOutput(
    e,
    n,
    t.steps,
    r.trigger
  );
  return i == null ? void 0 : i.status;
};
function CMt(e) {
  return {
    nodes: e.map((t) => ({
      id: t.id,
      type: Ci.NOTE,
      draggable: !0,
      position: t.position,
      data: {
        content: t.content,
        creatorId: t.ownerId,
        color: t.color,
        size: t.size
      }
    })),
    edges: []
  };
}
function NMt(e, t) {
  const n = At.getAllSteps(t.trigger).find((i) => !i.valid), r = window.location.search.includes(mxe);
  return e || (r ? null : (n == null ? void 0 : n.name) ?? "trigger");
}
const PMt = () => document.querySelector(
  `.${Ie.NODE_SELECTION_RECT_CLASS_NAME}`
) !== null, Na = {
  createFlowGraph(e, t) {
    const n = Uj(e.trigger), r = CMt(t), i = n.nodes.findLast(
      (o) => o.type === Ci.GRAPH_END_WIDGET
    );
    return i ? i.data.showWidget = !0 : console.warn("Flow end widget not found"), u9(n, r);
  },
  createFocusStepInGraphParams: AMt,
  calculateGraphBoundingBox: wN,
  createAddOperationFromAddButtonData: EMt,
  isSkipped: TMt,
  getStepStatus: kMt,
  determineInitiallySelectedStep: NMt,
  doesSelectionRectangleExist: PMt
}, IMt = (e, t) => {
  var o;
  const n = (o = e.run) != null && o.steps ? Ks.findLastStepWithStatus(
    e.run.status,
    e.run.steps
  ) : null, r = Na.determineInitiallySelectedStep(
    n,
    e.flowVersion
  ), i = r === "trigger" && e.flowVersion.trigger.type === Bt.EMPTY;
  return {
    showMinimap: !1,
    setShowMinimap: (s) => t({ showMinimap: s }),
    readonly: e.readonly,
    hideTestWidget: e.hideTestWidget ?? !1,
    selectedStep: r,
    activeDraggingStep: null,
    rightSidebar: r && !i ? zr.PIECE_SETTINGS : zr.NONE,
    removeStepSelection: () => t({
      selectedStep: null,
      rightSidebar: zr.NONE,
      selectedBranchIndex: null
    }),
    setActiveDraggingStep: (s) => t({
      activeDraggingStep: s
    }),
    setSelectedBranchIndex: (s) => t({
      selectedBranchIndex: s
    }),
    setReadOnly: (s) => t({ readonly: s }),
    renameFlowClientSide: (s) => {
      t((l) => ({
        flowVersion: {
          ...l.flowVersion,
          displayName: s
        }
      }));
    },
    selectStepByName: (s) => {
      t((l) => {
        const c = De(s) ? [] : [s], a = s === "trigger" && l.flowVersion.trigger.type === Bt.EMPTY ? zr.NONE : zr.PIECE_SETTINGS;
        return {
          openedPieceSelectorStepNameOrAddButtonId: s === "trigger" && l.flowVersion.trigger.type === Bt.EMPTY ? "trigger" : null,
          selectedStep: s,
          rightSidebar: a,
          selectedBranchIndex: null,
          selectedNodes: c,
          chatDrawerOpenSource: null
        };
      });
    },
    exitStepSettings: () => t(() => ({
      rightSidebar: zr.NONE,
      selectedStep: null,
      selectedBranchIndex: null
    })),
    setRightSidebar: (s) => t({ rightSidebar: s }),
    selectedBranchIndex: null,
    selectedNodes: [],
    setSelectedNodes: (s) => t(() => ({
      selectedNodes: s
    })),
    deselectStep: () => t(() => ({
      rightSidebar: zr.NONE,
      selectedBranchIndex: null,
      selectedStep: null
    })),
    panningMode: RMt(),
    setPanningMode: (s) => (localStorage.setItem(wMe, s), t(() => ({
      panningMode: s
    }))),
    isFocusInsideListMapperModeInput: !1,
    setIsFocusInsideListMapperModeInput: (s) => t(() => ({
      isFocusInsideListMapperModeInput: s
    }))
  };
}, wMe = "defaultPanningMode";
function RMt() {
  return localStorage.getItem(wMe) === "grab" ? "grab" : "pan";
}
const MMt = (e) => ({
  chatDrawerOpenSource: null,
  chatSessionMessages: [],
  chatSessionId: IC(),
  setChatDrawerOpenSource: (t) => e({ chatDrawerOpenSource: t }),
  setChatSessionMessages: (t) => e({ chatSessionMessages: t }),
  addChatMessage: (t) => e((n) => ({
    chatSessionMessages: [...n.chatSessionMessages, t]
  })),
  clearChatSession: () => e({ chatSessionMessages: [], chatSessionId: null }),
  setChatSessionId: (t) => e({ chatSessionId: t })
});
let fS = !1;
function DMt(e) {
  var n, r;
  if (!dt.isError(e))
    return null;
  const t = (r = (n = e.response) == null ? void 0 : n.data) == null ? void 0 : r.detail;
  return typeof t == "string" && t.trim().length > 0 ? t : null;
}
const yi = {
  list(e) {
    return dt.get("/v1/flows", e);
  },
  create(e) {
    return dt.post("/v1/flows", e);
  },
  update(e, t, n = !1) {
    return dt.post(`/v1/flows/${e}`, t).then((r) => (fS = !1, vr.dismiss(ny.id), r)).catch((r) => {
      var i, o;
      if (n) {
        const s = (o = (i = r.response) == null ? void 0 : i.data) == null ? void 0 : o.code, l = DMt(r);
        s === Ni.FLOW_IN_USE ? vr.error(Z("Flow Is In Use"), {
          description: Z(
            "Flow is being used by another user, please try again later."
          ),
          duration: 1 / 0,
          action: {
            label: Z("Refresh"),
            onClick: () => window.location.reload()
          }
        }) : l ? (fS = !1, vr.dismiss(ny.id), vr.error(Z("Unable to save flow"), {
          description: l
        })) : fS || (fS = !0, vr.error(ny.title, {
          description: ny.description,
          duration: ny.duration,
          id: ny.id,
          closeButton: ny.closeButton,
          onDismiss: () => {
            fS = !0;
          }
        }));
      }
      throw r;
    });
  },
  getTemplate(e, t) {
    return dt.get(`/v1/flows/${e}/template`, {
      params: t
    });
  },
  get(e, t) {
    return dt.get(`/v1/flows/${e}`, t);
  },
  listVersions(e, t) {
    return dt.get(
      `/v1/flows/${e}/versions`,
      t
    );
  },
  delete(e) {
    return dt.delete(`/v1/flows/${e}`);
  },
  count(e) {
    return dt.get("/v1/flows/count", e);
  }
}, _Mt = new Error("request for lock canceled");
var LMt = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function l(u) {
      try {
        a(r.next(u));
      } catch (f) {
        s(f);
      }
    }
    function c(u) {
      try {
        a(r.throw(u));
      } catch (f) {
        s(f);
      }
    }
    function a(u) {
      u.done ? o(u.value) : i(u.value).then(l, c);
    }
    a((r = r.apply(e, t || [])).next());
  });
};
class zMt {
  constructor(t, n = _Mt) {
    this._value = t, this._cancelError = n, this._weightedQueues = [], this._weightedWaiters = [];
  }
  acquire(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((n, r) => {
      this._weightedQueues[t - 1] || (this._weightedQueues[t - 1] = []), this._weightedQueues[t - 1].push({ resolve: n, reject: r }), this._dispatch();
    });
  }
  runExclusive(t, n = 1) {
    return LMt(this, void 0, void 0, function* () {
      const [r, i] = yield this.acquire(n);
      try {
        return yield t(r);
      } finally {
        i();
      }
    });
  }
  waitForUnlock(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    return new Promise((n) => {
      this._weightedWaiters[t - 1] || (this._weightedWaiters[t - 1] = []), this._weightedWaiters[t - 1].push(n), this._dispatch();
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(t) {
    this._value = t, this._dispatch();
  }
  release(t = 1) {
    if (t <= 0)
      throw new Error(`invalid weight ${t}: must be positive`);
    this._value += t, this._dispatch();
  }
  cancel() {
    this._weightedQueues.forEach((t) => t.forEach((n) => n.reject(this._cancelError))), this._weightedQueues = [];
  }
  _dispatch() {
    var t;
    for (let n = this._value; n > 0; n--) {
      const r = (t = this._weightedQueues[n - 1]) === null || t === void 0 ? void 0 : t.shift();
      if (!r)
        continue;
      const i = this._value, o = n;
      this._value -= n, n = this._value + 1, r.resolve([i, this._newReleaser(o)]);
    }
    this._drainUnlockWaiters();
  }
  _newReleaser(t) {
    let n = !1;
    return () => {
      n || (n = !0, this.release(t));
    };
  }
  _drainUnlockWaiters() {
    for (let t = this._value; t > 0; t--)
      this._weightedWaiters[t - 1] && (this._weightedWaiters[t - 1].forEach((n) => n()), this._weightedWaiters[t - 1] = []);
  }
}
var jMt = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function l(u) {
      try {
        a(r.next(u));
      } catch (f) {
        s(f);
      }
    }
    function c(u) {
      try {
        a(r.throw(u));
      } catch (f) {
        s(f);
      }
    }
    function a(u) {
      u.done ? o(u.value) : i(u.value).then(l, c);
    }
    a((r = r.apply(e, t || [])).next());
  });
};
class FMt {
  constructor(t) {
    this._semaphore = new zMt(1, t);
  }
  acquire() {
    return jMt(this, void 0, void 0, function* () {
      const [, t] = yield this._semaphore.acquire();
      return t;
    });
  }
  runExclusive(t) {
    return this._semaphore.runExclusive(() => t());
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock() {
    return this._semaphore.waitForUnlock();
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
class UMt {
  constructor() {
    rn(this, "queue", []);
    rn(this, "lock", new FMt());
    rn(this, "halted", !1);
  }
  add(t) {
    this.queue.push(t), this.run();
  }
  halt() {
    this.halted = !0;
  }
  isHalted() {
    return this.halted;
  }
  size() {
    return this.queue.length;
  }
  run() {
    this.lock.runExclusive(async () => {
      const t = this.queue.shift();
      this.halted || await t();
    });
  }
}
const VMt = (e, t, n) => {
  const r = new UMt(), i = Fbe(
    (o) => {
      r.add(o);
    },
    1e3
  );
  return {
    saving: !1,
    outputSampleData: e.outputSampleData,
    inputSampleData: e.inputSampleData,
    flow: e.flow,
    flowVersion: e.flowVersion,
    renameFlowClientSide: (o) => {
      n((s) => ({
        flowVersion: {
          ...s.flowVersion,
          displayName: o
        }
      }));
    },
    moveToFolderClientSide: (o) => {
      n((s) => ({
        flow: {
          ...s.flow,
          folderId: o
        }
      }));
    },
    setFlow: (o) => n({ flow: o, selectedStep: null }),
    setSampleData: ({
      stepName: o,
      value: s,
      type: l
    }) => n((c) => l === "input" ? {
      inputSampleData: {
        ...c.inputSampleData,
        [o]: s
      }
    } : {
      outputSampleData: {
        ...c.outputSampleData,
        [o]: s
      }
    }),
    setIsPublishing: (o) => n((s) => (o ? (s.removeStepSelection(), s.setReadOnly(!0)) : s.setReadOnly(!1), {
      isPublishing: o
    })),
    isPublishing: !1,
    applyOperation: (o, s) => n((l) => {
      if (l.readonly || r.isHalted())
        return o.type === Tt.UPDATE_NOTE && !r.isHalted() ? {
          flowVersion: Uu.apply(
            l.flowVersion,
            o
          )
        } : (console.warn("Cannot apply operation while readonly or halted"), l);
      let c = Uu.apply(l.flowVersion, o);
      l.operationListeners.forEach((u) => {
        u(l.flowVersion, o);
      }), n({ saving: !0 });
      const a = async () => {
        try {
          const u = await yi.update(
            l.flow.id,
            o,
            !0
          );
          n((f) => ({
            flowVersion: {
              ...f.flowVersion,
              id: u.version.id,
              state: u.version.state
            },
            saving: r.size() !== 0
          })), s == null || s();
        } catch (u) {
          console.error(u), r.halt(), n({ saving: !1 });
        }
      };
      switch (o.type) {
        case Tt.SAVE_SAMPLE_DATA: {
          r.add(a);
          const u = At.getStep(
            o.request.stepName,
            c.trigger
          );
          if (De(u))
            return console.error(`Step ${o.request.stepName} not found`), l;
          u.settings.sampleData = {
            ...u.settings.sampleData,
            lastTestDate: Gd().toISOString()
          }, u.type === Bt.PIECE || u.type === Bt.EMPTY ? c = Uu.apply(c, {
            type: Tt.UPDATE_TRIGGER,
            request: u
          }) : c = Uu.apply(c, {
            type: Tt.UPDATE_ACTION,
            request: u
          });
          break;
        }
        case Tt.UPDATE_TRIGGER:
        case Tt.UPDATE_ACTION: {
          i(
            o.request.name,
            a
          );
          break;
        }
        case Tt.UPDATE_NOTE:
        case Tt.DELETE_NOTE:
        case Tt.ADD_NOTE: {
          i(o.request.id, a);
          break;
        }
        default:
          r.add(a);
      }
      return { flowVersion: c };
    }),
    setVersion: (o) => {
      const s = Na.determineInitiallySelectedStep(null, o), l = s === "trigger" && o.trigger.type === Bt.EMPTY;
      n((c) => ({
        flowVersion: o,
        run: null,
        selectedStep: s,
        readonly: c.flow.publishedVersionId !== o.id && o.state === Lo.LOCKED,
        rightSidebar: s && !l ? zr.PIECE_SETTINGS : zr.NONE,
        selectedBranchIndex: null
      }));
    },
    operationListeners: [],
    addOperationListener: (o) => n((s) => ({
      operationListeners: [...s.operationListeners, o]
    })),
    removeOperationListener: (o) => n((s) => ({
      operationListeners: s.operationListeners.filter(
        (l) => l !== o
      )
    })),
    handleAddingOrUpdatingStep: ({
      pieceSelectorItem: o,
      operation: s,
      overrideSettings: l,
      selectStepAfter: c,
      customLogoUrl: a
    }) => {
      const {
        applyOperation: u,
        selectStepByName: f,
        flowVersion: d,
        setOpenedPieceSelectorStepNameOrAddButtonId: p
      } = t(), h = xf.getDefaultStepValues({
        stepName: xf.getStepNameFromOperationType(
          s,
          d
        ),
        pieceSelectorItem: o,
        overrideDefaultSettings: l,
        customLogoUrl: a
      }), m = h.type === Bt.PIECE || h.type === Bt.EMPTY;
      switch (s.type) {
        case Tt.UPDATE_TRIGGER: {
          if (!m)
            break;
          d.trigger.type === Bt.EMPTY && n(() => ({
            rightSidebar: zr.PIECE_SETTINGS
          })), u({
            type: Tt.UPDATE_TRIGGER,
            request: h
          }), f("trigger");
          break;
        }
        case Tt.ADD_ACTION: {
          if (m)
            break;
          u({
            type: Tt.ADD_ACTION,
            request: {
              ...s.actionLocation,
              action: {
                ...h
              }
            }
          }), c && f(h.name);
          break;
        }
        case Tt.UPDATE_ACTION: {
          const v = At.getStep(
            s.stepName,
            d.trigger
          );
          if (De(v)) {
            console.error(
              "Trying to update an action that's not in the displayed flow version"
            );
            break;
          }
          if (!At.isAction(v.type) || !At.isAction(h.type))
            break;
          u({
            type: Tt.UPDATE_ACTION,
            request: {
              type: h.type,
              displayName: h.displayName,
              name: s.stepName,
              settings: {
                ...h.settings,
                customLogoUrl: a
              },
              valid: h.valid
            }
          });
          break;
        }
      }
      return p(null), h.name;
    }
  };
};
var KK = /* @__PURE__ */ ((e) => (e.CREATE = "create", e.MOVE = "move", e))(KK || {});
const qMt = (e, t) => ({
  noteDragOverlayMode: null,
  setNoteDragOverlayMode: (n) => {
    t({ noteDragOverlayMode: n });
  },
  addNote: (n) => {
    const r = IC();
    e().applyOperation({
      type: Tt.ADD_NOTE,
      request: {
        ...n,
        id: r
      }
    });
    const i = e().flowVersion.notes, o = i.findIndex((s) => s.id === r);
    o !== -1 && (i[o] = {
      ...i[o],
      ownerId: Rn.getCurrentUserId() ?? null
    }), i[o].ownerId = Rn.getCurrentUserId() ?? null, t(() => ({
      flowVersion: {
        ...e().flowVersion,
        notes: i
      },
      draggedNote: null,
      noteDragOverlayMode: null
    }));
  },
  updateContent: (n, r) => {
    const i = e().getNoteById(n);
    i && e().applyOperation({
      type: Tt.UPDATE_NOTE,
      request: {
        ...i,
        content: r
      }
    });
  },
  deleteNote: (n) => {
    e().applyOperation({
      type: Tt.DELETE_NOTE,
      request: {
        id: n
      }
    });
  },
  moveNote: (n, r) => {
    t(() => ({
      noteDragOverlayMode: null,
      draggedNote: null
    }));
    const i = e().getNoteById(n);
    i && e().applyOperation({
      type: Tt.UPDATE_NOTE,
      request: {
        ...i,
        position: r
      }
    });
  },
  resizeNote: (n, r) => {
    t(() => ({
      noteDragOverlayMode: null,
      draggedNote: null
    }));
    const i = e().getNoteById(n);
    i && e().applyOperation({
      type: Tt.UPDATE_NOTE,
      request: {
        ...i,
        size: r
      }
    });
  },
  draggedNote: null,
  setDraggedNote: (n, r) => {
    t({ draggedNote: n, noteDragOverlayMode: r });
  },
  getNoteById: (n) => e().flowVersion.notes.find((r) => r.id === n) ?? null,
  updateNoteColor: (n, r) => {
    const i = e().getNoteById(n);
    i && e().applyOperation({
      type: Tt.UPDATE_NOTE,
      request: {
        ...i,
        color: r
      }
    });
  }
}), BMt = (e, t) => ({
  openedPieceSelectorStepNameOrAddButtonId: null,
  setOpenedPieceSelectorStepNameOrAddButtonId: (n) => t((r) => {
    const i = r.flowVersion.trigger.type === Bt.EMPTY && n === "trigger";
    return {
      openedPieceSelectorStepNameOrAddButtonId: n,
      rightSidebar: i ? zr.NONE : r.rightSidebar
    };
  }),
  selectedPieceMetadataInPieceSelector: null,
  setSelectedPieceMetadataInPieceSelector: (n) => t(() => ({
    selectedPieceMetadataInPieceSelector: n
  }))
}), XMt = (e, t, n) => ({
  run: e.run,
  loopsIndexes: e.run && e.run.steps ? Ks.findLoopsState(
    e.flowVersion,
    e.run,
    {}
  ) : {},
  setRun: async (r, i) => n((o) => {
    const s = Ks.findLastStepWithStatus(
      r.status,
      r.steps
    ), l = r.steps ? Na.determineInitiallySelectedStep(
      s,
      i
    ) : o.selectedStep ?? "trigger";
    return {
      loopsIndexes: Ks.findLoopsState(
        i,
        r,
        o.loopsIndexes
      ),
      run: r,
      flowVersion: i,
      rightSidebar: l ? zr.PIECE_SETTINGS : zr.NONE,
      selectedStep: l,
      readonly: !0
    };
  }),
  clearRun: (r) => n({
    run: null,
    readonly: !r,
    loopsIndexes: {},
    selectedBranchIndex: null
  }),
  setLoopIndex: (r, i) => {
    n((o) => {
      const s = At.getStepOrThrow(
        r,
        o.flowVersion.trigger
      );
      if (s.type !== qe.LOOP_ON_ITEMS)
        return console.error(
          `Trying to set loop index for a step that is not a loop: ${r}`
        ), o;
      const l = At.getAllChildSteps(s).filter((a) => a.type === qe.LOOP_ON_ITEMS).filter((a) => a.name !== r), c = { ...o.loopsIndexes };
      return c[r] = i, l.forEach((a) => {
        var f;
        const u = Ks.extractStepOutput(
          a.name,
          c,
          ((f = o.run) == null ? void 0 : f.steps) ?? {},
          o.flowVersion.trigger
        );
        De(u) || De(u.output) ? c[a.name] = 0 : c[a.name] = Math.max(
          Math.min(
            c[a.name],
            u.output.iterations.length - 1
          ),
          0
        );
      }), {
        loopsIndexes: c
      };
    });
  }
}), WMt = (e) => ({
  setInsertMentionHandler: (t) => {
    e({ insertMention: t });
  },
  insertMention: null,
  isFocusInsideListMapperModeInput: !1,
  setIsFocusInsideListMapperModeInput: (t) => e(() => ({
    isFocusInsideListMapperModeInput: t
  }))
}), xMe = Ri(null);
function tn(e) {
  const t = kr(xMe);
  if (!t)
    throw new Error("Missing BuilderStateContext.Provider in the tree");
  return HAe(t, e);
}
const ZMt = (e) => $w((t, n) => {
  const r = VMt(e, n, t), i = BMt(n, t), o = XMt(e, n, t), s = MMt(t), l = IMt(e, t), c = WMt(t), a = qMt(n, t);
  return {
    ...r,
    ...a,
    ...o,
    ...i,
    ...s,
    ...l,
    ...c
  };
}), HMt = (e) => e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'") ? e.slice(1, -1) : e, QMt = (e) => {
  const t = Number(e);
  return Number.isNaN(t) ? e : `${t + 1}`;
}, $Mt = (e) => e.split(/\.|\[|\]/).filter((t) => t && t.trim().length > 0).map(QMt).map(HMt), SMe = /^flattenNestedKeys\((\w+),\s*\[(.*?)\]\)$/, KMt = (e) => {
  const t = e.match(/^\{\{(.*)\}\}$/);
  if (t) {
    const n = t[1].trim();
    return n.match(SMe) ? !0 : /^(step_\d+|trigger)/.test(n);
  }
  return !1;
};
function GMt(e, t, n) {
  return e.split(/(\{\{.*?\}\})/).map((i) => i.split(new RegExp(`(
)`))).flat(1).filter((i) => i).reduce(
    (i, o) => (o === `
` ? i.push({
      type: "paragraph",
      content: []
    }) : KMt(o) ? i[i.length - 1].content.push(
      EMe(o, t, n)
    ) : i[i.length - 1].content.push({
      type: "text",
      text: o
    }), i),
    [
      {
        content: [],
        type: "paragraph"
        /* paragraph */
      }
    ]
  );
}
function YMt(e) {
  const t = e.match(SMe);
  if (!t)
    return { isValid: !1 };
  const n = t[1], r = t[2].split(",").map((i) => i.trim().replace(/['"]/g, ""));
  return {
    isValid: !0,
    stepName: n,
    arrayPath: r
  };
}
const JMt = (e) => e.startsWith("{{") && e.endsWith("}}") ? e.slice(2, e.length - 2).trim() : e;
function eDt(e) {
  const t = JMt(e), { isValid: n, stepName: r, arrayPath: i } = YMt(
    t
  );
  if (n)
    return {
      stepName: r,
      path: i ?? []
    };
  const o = $Mt(t);
  return o.length === 0 ? {
    stepName: null,
    path: []
  } : {
    stepName: o[0],
    path: o.slice(1)
  };
}
function tDt(e, t, n) {
  const { stepName: r, path: i } = eDt(e), o = t.findIndex((l) => l.name === r);
  if (o < 0)
    return {
      displayText: `(Missing) ${r}`,
      serverValue: e,
      logoUrl: "/src/assets/img/custom/incomplete.png"
    };
  const s = n[o];
  return {
    displayText: `${o + 1}. ${(s == null ? void 0 : s.stepDisplayName) ?? ""} ${i.join(" ")}`,
    serverValue: e,
    logoUrl: s == null ? void 0 : s.logoUrl
  };
}
function EMe(e, t, n) {
  return {
    type: "mention",
    attrs: {
      id: e,
      label: JSON.stringify(
        tDt(e, t, n)
      )
    }
  };
}
function TMe(e) {
  return e.map((n, r) => {
    var i;
    switch (n.type) {
      case "hardBreak":
        return `
`;
      case "text":
        return n.text ? n.text.replaceAll(" ", " ") : "";
      case "mention":
        return (i = n.attrs) != null && i.label ? JSON.parse(n.attrs.label).serverValue : "";
      case "paragraph":
        return `${De(n.content) ? "" : TMe(n.content)}${r < e.length - 1 ? `
` : ""}`;
      default:
        return "";
    }
  }).join("");
}
const nDt = (e) => {
  const t = document.createElement("span"), n = JSON.parse(
    e.label || "{}"
  );
  if (t.className = "inline-flex bg-muted/10 break-all my-1 mx-px border border-[#9e9e9e] border-solid items-center gap-2 py-1 px-2 rounded-[3px] text-muted-foreground ", qm(e.label, "mentionAttrs.label"), qm(e.id, "mentionAttrs.id"), qm(
    n.displayText,
    "apMentionNodeAttrs.displayText"
  ), t.dataset.id = e.id, t.dataset.label = e.label, t.dataset.displayText = n.displayText, t.dataset.type = "mention", t.contentEditable = "false", n.logoUrl) {
    const i = document.createElement("img");
    i.src = n.logoUrl, i.className = "object-contain w-4 h-4", t.appendChild(i);
  } else {
    const i = document.createElement("span");
    i.className = "h-4 -mr-2", t.appendChild(i);
  }
  const r = document.createTextNode(
    n.displayText
  );
  return t.setAttribute("serverValue", n.serverValue), t.appendChild(r), t;
}, rDt = "ap-text-with-mentions", d9 = "ap-data-selector", iDt = (e) => e.classList.contains(d9) || !De(e.closest(`.${d9}`)), Zp = {
  convertTextToTipTapJsonContent: GMt,
  convertTiptapJsonToText: ({ content: e }) => {
    const t = e ?? [];
    return t.length === 1 && De(t[0].content) ? "" : TMe(t);
  },
  generateMentionHtmlElement: nDt,
  createMentionNodeFromText: EMe,
  inputWithMentionsCssClass: rDt,
  dataSelectorCssClassSelector: d9,
  isDataSelectorOrChildOfDataSelector: iDt
};
var GK = "Collapsible", [oDt, ymn] = Ms(GK), [sDt, YK] = oDt(GK), kMe = N.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: o,
      onOpenChange: s,
      ...l
    } = e, [c = !1, a] = wl({
      prop: r,
      defaultProp: i,
      onChange: s
    });
    return /* @__PURE__ */ y(
      sDt,
      {
        scope: n,
        disabled: o,
        contentId: ka(),
        open: c,
        onOpenToggle: N.useCallback(() => a((u) => !u), [a]),
        children: /* @__PURE__ */ y(
          Zt.div,
          {
            "data-state": eG(c),
            "data-disabled": o ? "" : void 0,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
kMe.displayName = GK;
var CMe = "CollapsibleTrigger", NMe = N.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = YK(CMe, n);
    return /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": eG(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: ot(e.onClick, i.onOpenToggle)
      }
    );
  }
);
NMe.displayName = CMe;
var JK = "CollapsibleContent", PMe = N.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = YK(JK, e.__scopeCollapsible);
    return /* @__PURE__ */ y(wo, { present: n || i.open, children: ({ present: o }) => /* @__PURE__ */ y(aDt, { ...r, ref: t, present: o }) });
  }
);
PMe.displayName = JK;
var aDt = N.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, s = YK(JK, n), [l, c] = N.useState(r), a = N.useRef(null), u = xn(t, a), f = N.useRef(0), d = f.current, p = N.useRef(0), h = p.current, m = s.open || l, v = N.useRef(m), b = N.useRef();
  return N.useEffect(() => {
    const A = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(A);
  }, []), qi(() => {
    const A = a.current;
    if (A) {
      b.current = b.current || {
        transitionDuration: A.style.transitionDuration,
        animationName: A.style.animationName
      }, A.style.transitionDuration = "0s", A.style.animationName = "none";
      const w = A.getBoundingClientRect();
      f.current = w.height, p.current = w.width, v.current || (A.style.transitionDuration = b.current.transitionDuration, A.style.animationName = b.current.animationName), c(r);
    }
  }, [s.open, r]), /* @__PURE__ */ y(
    Zt.div,
    {
      "data-state": eG(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !m,
      ...o,
      ref: u,
      style: {
        "--radix-collapsible-content-height": d ? `${d}px` : void 0,
        "--radix-collapsible-content-width": h ? `${h}px` : void 0,
        ...e.style
      },
      children: m && i
    }
  );
});
function eG(e) {
  return e ? "open" : "closed";
}
var lDt = kMe;
const cDt = lDt, uDt = NMe, dDt = ({ expanded: e }) => e ? /* @__PURE__ */ y(dit, { height: 15, width: 15 }) : /* @__PURE__ */ y(ex, { height: 15, width: 15 }), fDt = (e) => {
  (e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.target && e.target.click());
}, IMe = ({
  node: e,
  expanded: t,
  setExpanded: n,
  depth: r
}) => {
  const i = tn((p) => p.flowVersion), o = tn((p) => p.insertMention), [s, l] = Irt(), c = e.data.type === "value" ? At.getStep(e.data.propertyPath, i.trigger) : e.data.type === "test" ? At.getStep(e.data.stepName, i.trigger) : void 0, a = c ? vd.useStepMetadata({ step: c }).stepMetadata : void 0, u = e.data.type === "value" && e.data.insertable && !e.isLoopStepNode, f = !e.children && e.data.type === "value", d = 23 / (1 + r * 0.05);
  return /* @__PURE__ */ y(
    "div",
    {
      tabIndex: 0,
      onKeyDown: fDt,
      ref: s,
      onClick: (p) => {
        e.children && e.children.length > 0 ? (l(p), n(!t)) : o && e.data.type === "value" && e.data.insertable && (l(p), o(e.data.propertyPath));
      },
      className: "w-full max-w-full select-none focus:outline-none hover:bg-accent dark:hover:bg-accent/20 focus:bg-accent focus:bg-opacity-75 cursor-pointer group",
      children: /* @__PURE__ */ V("div", { className: "grow  max-w-full flex items-center gap-2 min-h-[48px] pr-3 select-none", children: [
        /* @__PURE__ */ y(
          "div",
          {
            style: {
              minWidth: `${r * d + (r === 0 ? 0 : 12) + 18}px`
            }
          }
        ),
        u && /* @__PURE__ */ V(wn, { children: [
          /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
            Qe,
            {
              className: "z-50 shrink-0 size-5 p-0 rounded-full",
              variant: "basic",
              size: "sm",
              onClick: (p) => {
                p.stopPropagation(), o && o(
                  e.data.type === "value" ? e.data.propertyPath : ""
                );
              },
              children: /* @__PURE__ */ y(Da, { className: "size-3.5" })
            }
          ) }),
          /* @__PURE__ */ y(An, { side: "top", children: Z("Insert") })
        ] }),
        a && /* @__PURE__ */ y("div", { className: "shrink-0", children: /* @__PURE__ */ y(
          Ig,
          {
            displayName: a.displayName,
            logoUrl: a.logoUrl,
            showTooltip: !1,
            circle: !1,
            border: !1,
            size: "sm"
          }
        ) }),
        e.data.type !== "test" && /* @__PURE__ */ y("div", { className: " truncate", children: e.data.displayName }),
        f && /* @__PURE__ */ V(pt, { children: [
          /* @__PURE__ */ y("div", { className: "shrink-0", children: ":" }),
          /* @__PURE__ */ y("div", { className: "flex-1 text-primary truncate", children: `${e.data.type === "value" ? e.data.value : ""}` })
        ] }),
        /* @__PURE__ */ y("div", { className: "ml-auto flex shrink-0 gap-2 items-center", children: e.children && e.children.length > 0 && /* @__PURE__ */ y("div", { className: "shrink-0 pr-5", children: /* @__PURE__ */ y(dDt, { expanded: t }) }) })
      ] })
    }
  );
};
IMe.displayName = "DataSelectorNodeContent";
const pDt = ({ stepName: e }) => {
  const t = e === "trigger", n = tn(
    (r) => r.selectStepByName
  );
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-3 select-none text-center px-12 py-10 grow items-center justify-center ", children: [
    /* @__PURE__ */ y("div", { children: Z(
      t ? "This trigger needs to have data loaded from your account, to use as sample data." : "This step needs to be tested in order to view its data."
    ) }),
    /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y(
      Qe,
      {
        onClick: () => n(e),
        variant: "default",
        size: "default",
        children: Z(t ? "Go to Trigger" : "Go to Step")
      }
    ) })
  ] });
}, hDt = 10, Yle = 32;
function mDt(e, t) {
  return {
    key: t,
    data: {
      type: "value",
      value: "",
      displayName: e,
      propertyPath: t,
      insertable: !1
    },
    children: [
      {
        data: {
          type: "test",
          stepName: t,
          parentDisplayName: e
        },
        key: `test_${t}`
      }
    ]
  };
}
function gDt(e, t) {
  return {
    key: e,
    data: {
      type: "chunk",
      displayName: e
    },
    children: t
  };
}
function RMe(e, t) {
  var r, i;
  const n = { ...e };
  for (const [o, s] of Object.entries(t)) {
    const l = RMe(
      ((r = n[o]) == null ? void 0 : r.properties) || {},
      s.properties
    );
    n[o] = {
      values: [...((i = n[o]) == null ? void 0 : i.values) || [], ...s.values],
      properties: l
    };
  }
  return n;
}
function d_(e) {
  var n;
  let t = {};
  if (Qp(e))
    for (const [r, i] of Object.entries(e)) {
      const o = ((n = t[r]) == null ? void 0 : n.values) || [];
      if (Array.isArray(i)) {
        const l = i.filter(
          (c) => !Qp(c) && !Array.isArray(c)
        );
        o.push(...l);
      } else Qp(i) || o.push(i);
      const s = d_(i);
      t[r] = {
        values: o,
        properties: s
      };
    }
  else if (Array.isArray(e))
    for (const r of e) {
      const i = d_(r);
      t = RMe(t, i);
    }
  return t;
}
function f9(e, t) {
  const n = [];
  for (const [r, i] of Object.entries(e)) {
    const o = t[0], s = [...t.slice(1), r], l = `flattenNestedKeys(${o}, ['${s.map((a) => String(a)).join("', '")}'])`, c = i.values.join(", ");
    n.push({
      key: r,
      data: {
        type: "value",
        value: c.length > Yle ? `${c.slice(0, Yle)}...` : c,
        displayName: r,
        propertyPath: l,
        insertable: !0
      },
      children: Object.keys(i.properties).length > 0 ? f9(i.properties, [...t, r]) : void 0
    });
  }
  return n;
}
function yDt(e) {
  return e.slice(1).reduce((n, r) => `${n}[${typeof r == "string" ? `'${bDt(String(r))}'` : r}]`, `${e[0]}`);
}
function t0(e, t, n, r, i = !0) {
  const o = Array.isArray(n) && n.length === 0 || Qp(n) && Object.keys(n).length === 0, s = yDt(t);
  return {
    key: s,
    data: {
      type: "value",
      value: o ? "Empty List" : n,
      displayName: e,
      propertyPath: s,
      insertable: i
    },
    children: r
  };
}
function vDt(e, t) {
  return Array.from(
    { length: Math.ceil(e.length / t) },
    (n, r) => ({
      items: e.slice(r * t, r * t + t),
      range: {
        start: r * t + 1,
        end: Math.min((r + 1) * t, e.length)
      }
    })
  );
}
function f_(e, t, n, r, i = !0) {
  if (Array.isArray(n)) {
    const o = n.some((s) => Qp(s));
    if (!r || !o) {
      const s = n.map(
        (a, u) => f_(
          `${e} [${u + 1}]`,
          [...t, u],
          a,
          r,
          i
        )
      ), l = vDt(s, hDt);
      return l.length === 1 ? t0(
        e,
        t,
        n,
        s,
        i
      ) : t0(
        e,
        t,
        void 0,
        l.map(
          (a) => gDt(
            `${e} [${a.range.start}-${a.range.end}]`,
            a.items
          )
        ),
        i
      );
    } else
      return t0(
        e,
        t,
        n,
        f9(d_(n), t),
        i
      );
  } else if (Qp(n)) {
    const o = Object.entries(n).map(([s, l]) => r ? t0(
      s,
      [...t, s],
      l,
      f9(d_(l), [
        ...t,
        s
      ]),
      i
    ) : f_(
      s,
      [...t, s],
      l,
      r,
      i
    ));
    return t0(
      e,
      t,
      n,
      o,
      i
    );
  } else
    return t0(
      e,
      t,
      n,
      void 0,
      i
    );
}
function bDt(e) {
  return e.replaceAll(/[\\"'\n\r\t’]/g, (t) => `\\${t}`);
}
function ODt(e) {
  if (e.data.type === "test")
    return e.data.parentDisplayName;
  if (e.data.type === "chunk")
    return e.data.displayName;
  if (De(e.data.value)) {
    if (e.data.value === null)
      return "null";
  } else return JSON.stringify(e.data.value).toLowerCase();
  return "";
}
function ADt(e, t, n) {
  var o;
  const r = `${e.dfsIndex + 1}. ${e.displayName}`;
  if (De((o = e.settings.sampleData) == null ? void 0 : o.lastTestDate))
    return mDt(r, e.name);
  if (e.type === qe.LOOP_ON_ITEMS) {
    const s = JSON.parse(JSON.stringify(t[e.name]));
    delete s.iterations;
    const l = f_(
      r,
      [e.name],
      s,
      n,
      !0
    );
    return l.isLoopStepNode = !0, l;
  }
  return f_(
    r,
    [e.name],
    t[e.name],
    n,
    !0
  );
}
function MMe(e, t) {
  return t ? e.map((r) => {
    const i = De(r.children) ? void 0 : MMe(r.children, t);
    if (i && i.length)
      return {
        ...r,
        children: i
      };
    const o = ODt(r);
    return (r.data.type === "value" ? r.data.displayName.toLowerCase() : "").toLowerCase().includes(t.toLowerCase()) || o.toLowerCase().includes(t.toLowerCase()) ? r : null;
  }).filter(
    (r) => !De(r)
  ) : e;
}
const tG = {
  isTestStepNode: (e) => e.data.type === "test",
  traverseStep: ADt,
  filterBy: MMe
}, nG = ({
  node: e,
  depth: t,
  searchTerm: n
}) => {
  const [r, i] = He(!1);
  return nt(() => {
    n && t <= 1 ? i(!0) : n || i(!1);
  }, [n, t]), tG.isTestStepNode(e) ? /* @__PURE__ */ y(pDt, { stepName: e.data.stepName }) : /* @__PURE__ */ y(cDt, { className: "w-full", open: r, onOpenChange: i, children: /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(uDt, { asChild: !0, className: "w-full relative", children: /* @__PURE__ */ y(
      IMe,
      {
        node: e,
        expanded: r,
        setExpanded: i,
        depth: t
      }
    ) }),
    /* @__PURE__ */ y(PMe, { className: "w-full", children: e.children && e.children.length > 0 && /* @__PURE__ */ y("div", { className: "flex flex-col ", children: e.children.map((s) => /* @__PURE__ */ y(
      nG,
      {
        depth: t + 1,
        node: s,
        searchTerm: n
      },
      s.key
    )) }) })
  ] }) });
};
nG.displayName = "DataSelectorNode";
var p1 = /* @__PURE__ */ ((e) => (e[e.EXPANDED = 0] = "EXPANDED", e[e.COLLAPSED = 1] = "COLLAPSED", e[e.DOCKED = 2] = "DOCKED", e))(p1 || {});
const wDt = ({
  state: e,
  setListSizeState: t
}) => {
  const n = (i) => {
    t(i);
  }, r = (i) => Se("", {
    "text-outline": e === i,
    "text-outline opacity-50": e !== i
  });
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
        Qe,
        {
          size: "icon",
          className: r(
            0
            /* EXPANDED */
          ),
          onClick: () => n(
            0
            /* EXPANDED */
          ),
          variant: "basic",
          children: /* @__PURE__ */ y(Cit, { className: "size-5" })
        }
      ) }),
      /* @__PURE__ */ y(An, { children: Z("Expand") })
    ] }),
    /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
        Qe,
        {
          size: "icon",
          className: r(
            2
            /* DOCKED */
          ),
          onClick: () => n(
            2
            /* DOCKED */
          ),
          variant: "basic",
          children: /* @__PURE__ */ y(Rot, { className: "size-5" })
        }
      ) }),
      /* @__PURE__ */ y(An, { children: Z("Dock") })
    ] }),
    /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
        Qe,
        {
          size: "icon",
          className: r(
            1
            /* COLLAPSED */
          ),
          onClick: () => n(
            1
            /* COLLAPSED */
          ),
          variant: "basic",
          children: /* @__PURE__ */ y(GH, { className: "size-5" })
        }
      ) }),
      /* @__PURE__ */ y(An, { children: Z("Minimize") })
    ] })
  ] });
}, xDt = (e) => {
  const { selectedStep: t, flowVersion: n } = e;
  return !t || !n || !n.trigger ? [] : At.findPathToStep(
    n.trigger,
    t
  ).map((i) => {
    try {
      return tG.traverseStep(
        i,
        e.outputSampleData,
        e.isFocusInsideListMapperModeInput
      );
    } catch (o) {
      return console.error("Failed to traverse step:", o), {
        key: `error-${i.name}`,
        data: {
          type: "chunk",
          displayName: `Error loading ${i.name}`
        }
      };
    }
  });
}, DMe = (e) => {
  if (De(e))
    return !1;
  if (e.classList.contains(Zp.inputWithMentionsCssClass))
    return !0;
  const t = e.parentElement;
  return t ? t && DMe(t) : !1;
}, _Me = ({ parentHeight: e, parentWidth: t }) => {
  const n = Xe(null), [r, i] = He(p1.DOCKED), [o, s] = He(""), l = tn(
    xDt
  ), c = tG.filterBy(
    l,
    o
  ), [a, u] = He(!1), f = qn(() => {
    const d = !De(n.current) && n.current.contains(document.activeElement) || DMe(document.activeElement);
    u(d);
  }, []);
  return nt(() => (document.addEventListener("focusin", f), document.addEventListener("focusout", f), () => {
    document.removeEventListener("focusin", f), document.removeEventListener("focusout", f);
  }), [f]), /* @__PURE__ */ V(
    "div",
    {
      ref: n,
      tabIndex: 0,
      className: Se(
        "absolute bottom-0 mr-5 mb-5 right-0 z-50 transition-all  border border-solid border-outline overflow-x-hidden bg-background shadow-lg rounded-md",
        {
          "opacity-0 pointer-events-none": !a
        },
        Zp.dataSelectorCssClassSelector
      ),
      children: [
        /* @__PURE__ */ V("div", { className: "text-lg items-center px-5 py-2 flex gap-2", children: [
          Z("Data Selector"),
          " ",
          /* @__PURE__ */ y("div", { className: "grow" }),
          " ",
          /* @__PURE__ */ y(
            wDt,
            {
              state: r,
              setListSizeState: i
            }
          )
        ] }),
        /* @__PURE__ */ V(
          "div",
          {
            style: {
              height: r === p1.COLLAPSED ? "0px" : r === p1.DOCKED ? "450px" : `${e - 100}px`,
              width: r !== p1.EXPANDED ? "450px" : `${t - 40}px`
            },
            className: "transition-all overflow-hidden",
            children: [
              /* @__PURE__ */ y("div", { className: "flex items-center gap-2 px-5 py-2", children: /* @__PURE__ */ y(
                fr,
                {
                  placeholder: Z("Search"),
                  value: o,
                  onChange: (d) => s(d.target.value)
                }
              ) }),
              /* @__PURE__ */ V(Bi, { className: "transition-all h-[calc(100%-56px)] w-full ", children: [
                c && c.map((d) => /* @__PURE__ */ y(
                  nG,
                  {
                    depth: 0,
                    node: d,
                    searchTerm: o
                  },
                  d.key
                )),
                c.length === 0 && /* @__PURE__ */ V("div", { className: "flex items-center justify-center gap-2 mt-5  flex-col", children: [
                  /* @__PURE__ */ y(YH, { className: "w-[35px] h-[35px]" }),
                  /* @__PURE__ */ y("div", { className: "text-center font-semibold text-md", children: Z("No matching data") }),
                  /* @__PURE__ */ y("div", { className: "text-center ", children: Z("Try adjusting your search") })
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
};
_Me.displayName = "DataSelector";
const LMe = 100, SDt = (e, t, n) => ({
  x: t.position.x + e / 2 - Ie.AP_NODE_SIZE.STEP.width * n / 2,
  y: t.position.y + Ie.AP_NODE_SIZE.GRAPH_END_WIDGET.height + LMe * n
}), EDt = (e, t) => e.y > t.height || e.x > t.width || e.x < 0, TDt = (e, t) => ({
  x: e.x > t.width ? -1 * (e.x - t.width + Ie.AP_NODE_SIZE.STEP.width * 2) : e.x < 0 ? -1 * e.x : 0,
  y: e.y > t.height ? e.y - t.height + Ie.AP_NODE_SIZE.STEP.height : 0
}), kDt = ({
  canvasWidth: e,
  canvasHeight: t,
  hasCanvasBeenInitialised: n,
  selectedStep: r
}) => {
  const { zoomIn: i, zoomOut: o, setViewport: s, getNodes: l, getNode: c, getViewport: a } = yd(), u = qn(() => {
    i({
      duration: 0
    });
  }, [i]), f = qn(() => {
    o({
      duration: 0
    });
  }, [o]), d = qn(
    (k) => {
      const T = l();
      if (T.length === 0) return;
      const R = Na.calculateGraphBoundingBox({
        nodes: T,
        edges: []
      }).height, j = Math.min(
        Math.max(t / R, 0.9),
        1.25
      );
      s(
        {
          x: e / 2 - Ie.AP_NODE_SIZE.STEP.width * j / 2,
          y: T[0].position.y + LMe * j + Ie.AP_NODE_SIZE.STEP.height,
          zoom: j
        },
        {
          duration: k ? 0 : 500
        }
      );
    },
    [l, t, s, e]
  );
  nt(() => {
    n && (d(!0), r && p(r));
  }, [n]);
  const p = (k) => {
    const T = c(k);
    if (!T) return;
    const R = a(), j = {
      height: t / R.zoom,
      width: e / R.zoom
    }, F = SDt(
      e,
      T,
      R.zoom
    );
    if (EDt(F, j)) {
      const L = TDt(
        F,
        j
      );
      s({
        x: R.x + L.x,
        y: R.y - L.y - Ie.AP_NODE_SIZE.STEP.height,
        zoom: R.zoom
      });
    }
  }, [h, m] = tn(
    (k) => [k.noteDragOverlayMode, k.setDraggedNote]
  ), [v, b, A, w, O] = tn((k) => [
    k.setPanningMode,
    k.panningMode,
    k.showMinimap,
    k.setShowMinimap,
    k.readonly
  ]), x = rg("Space"), S = rg("Shift"), E = (x || b === "grab") && !S;
  return /* @__PURE__ */ V(
    "div",
    {
      id: "canvas-controls",
      className: "z-50 absolute right-3 top-1/2 -translate-y-1/2 flex flex-col gap-2 pointer-events-none",
      children: [
        /* @__PURE__ */ y("div", { className: "flex items-center justify-center p-1.5 pointer-events-auto rounded-lg bg-background border border-sidebar-border", children: /* @__PURE__ */ y(
          n0,
          {
            tooltip: Z("Minimap" + (vB() ? " (⌘ + M)" : " (Ctrl + M)")),
            children: /* @__PURE__ */ y(
              Qe,
              {
                variant: A ? "default" : "ghost",
                size: "icon",
                onClick: () => {
                  w(!A);
                },
                children: /* @__PURE__ */ y(mot, { className: "size-4" })
              }
            )
          }
        ) }),
        /* @__PURE__ */ V("div", { className: "bg-background gap-2 flex flex-col items-center shadow-2xl justify-center border border-sidebar-border p-1.5 rounded-lg pointer-events-auto", children: [
          /* @__PURE__ */ V("div", { className: "flex flex-col items-center gap-2", children: [
            /* @__PURE__ */ y(n0, { tooltip: Z("Zoom in"), children: /* @__PURE__ */ y(Qe, { variant: "ghost", size: "icon", onClick: u, children: /* @__PURE__ */ y(Da, { className: "size-4" }) }) }),
            /* @__PURE__ */ y(n0, { tooltip: Z("Zoom out"), children: /* @__PURE__ */ y(Qe, { variant: "ghost", size: "icon", onClick: f, children: /* @__PURE__ */ y(GH, { className: "size-4" }) }) }),
            /* @__PURE__ */ y(n0, { tooltip: Z("Fit to view"), children: /* @__PURE__ */ y(
              Qe,
              {
                variant: "ghost",
                size: "icon",
                onClick: () => d(!1),
                children: /* @__PURE__ */ y(Dit, { className: "size-4" })
              }
            ) })
          ] }),
          /* @__PURE__ */ y(Eh, { orientation: "horizontal", className: "w-full" }),
          /* @__PURE__ */ V("div", { className: "flex flex-col items-center gap-2", children: [
            /* @__PURE__ */ y(n0, { tooltip: Z("Grab mode"), children: /* @__PURE__ */ y(
              Qe,
              {
                variant: E ? "default" : "ghost",
                size: "icon",
                onClick: () => v("grab"),
                children: /* @__PURE__ */ y(Wit, { className: "size-4" })
              }
            ) }),
            /* @__PURE__ */ y(n0, { tooltip: Z("Select mode"), children: /* @__PURE__ */ y(
              Qe,
              {
                variant: E ? "ghost" : "default",
                size: "icon",
                onClick: () => v("pan"),
                children: /* @__PURE__ */ y(Oot, { className: "size-4" })
              }
            ) })
          ] })
        ] })
      ]
    }
  );
}, n0 = ({
  children: e,
  tooltip: t
}) => /* @__PURE__ */ V(wn, { children: [
  /* @__PURE__ */ y(kn, { asChild: !0, children: e }),
  /* @__PURE__ */ y(An, { children: t })
] }), CDt = "anyOf[0]items", NDt = "properties.", PDt = (e) => e.split(".").map((t) => t === "" ? "" : isNaN(Number(t)) ? `${NDt}${t}` : CDt).join("."), zMe = Ri(
  void 0
), IDt = ({
  selectedStep: e,
  pieceModel: t,
  children: n
}) => {
  var c;
  const [r, i] = He(
    g.Object(g.Unknown())
  ), o = Xe(!1);
  if (!o.current && e) {
    const a = Bc.buildPieceSchema(
      e.type,
      e.settings.actionName ?? e.settings.triggerName,
      t ?? null
    );
    o.current = !0, i(a);
  }
  const s = qn(
    (a, u) => {
      i((f) => {
        const d = Dv.buildSchema(
          u,
          void 0
        ), p = { ...f }, h = PDt(a);
        return jbe(p, h, d), p;
      });
    },
    []
  ), l = (a, u, f) => {
    var d, p;
    (p = (d = e.settings) == null ? void 0 : d.propertySettings) != null && p[u] || f.setValue(
      `settings.propertySettings.${u}.type`,
      dc.MANUAL
    ), f.setValue(`settings.propertySettings.${u}.schema`, a);
  };
  return /* @__PURE__ */ y(
    zMe.Provider,
    {
      value: {
        selectedStep: e,
        pieceModel: t,
        formSchema: r,
        updateFormSchema: s,
        updatePropertySettingsSchema: l
      },
      children: n
    },
    (c = e.settings.sampleData) == null ? void 0 : c.lastTestDate
  );
}, rG = () => {
  const e = kr(zMe);
  if (e === void 0)
    throw new Error(
      "useStepSettingsContext must be used within a PieceSettingsProvider"
    );
  return e;
}, Tf = /* @__PURE__ */ Object.create(null);
Tf.open = "0";
Tf.close = "1";
Tf.ping = "2";
Tf.pong = "3";
Tf.message = "4";
Tf.upgrade = "5";
Tf.noop = "6";
const iM = /* @__PURE__ */ Object.create(null);
Object.keys(Tf).forEach((e) => {
  iM[Tf[e]] = e;
});
const p9 = { type: "error", data: "parser error" }, jMe = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", FMe = typeof ArrayBuffer == "function", UMe = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, iG = ({ type: e, data: t }, n, r) => jMe && t instanceof Blob ? n ? r(t) : Jle(t, r) : FMe && (t instanceof ArrayBuffer || UMe(t)) ? n ? r(t) : Jle(new Blob([t]), r) : r(Tf[e] + (t || "")), Jle = (e, t) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    t("b" + (r || ""));
  }, n.readAsDataURL(e);
};
function ece(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let hU;
function RDt(e, t) {
  if (jMe && e.data instanceof Blob)
    return e.data.arrayBuffer().then(ece).then(t);
  if (FMe && (e.data instanceof ArrayBuffer || UMe(e.data)))
    return t(ece(e.data));
  iG(e, !1, (n) => {
    hU || (hU = new TextEncoder()), t(hU.encode(n));
  });
}
const tce = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h1 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < tce.length; e++)
  h1[tce.charCodeAt(e)] = e;
const MDt = (e) => {
  let t = e.length * 0.75, n = e.length, r, i = 0, o, s, l, c;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const a = new ArrayBuffer(t), u = new Uint8Array(a);
  for (r = 0; r < n; r += 4)
    o = h1[e.charCodeAt(r)], s = h1[e.charCodeAt(r + 1)], l = h1[e.charCodeAt(r + 2)], c = h1[e.charCodeAt(r + 3)], u[i++] = o << 2 | s >> 4, u[i++] = (s & 15) << 4 | l >> 2, u[i++] = (l & 3) << 6 | c & 63;
  return a;
}, DDt = typeof ArrayBuffer == "function", oG = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: VMe(e, t)
    };
  const n = e.charAt(0);
  return n === "b" ? {
    type: "message",
    data: _Dt(e.substring(1), t)
  } : iM[n] ? e.length > 1 ? {
    type: iM[n],
    data: e.substring(1)
  } : {
    type: iM[n]
  } : p9;
}, _Dt = (e, t) => {
  if (DDt) {
    const n = MDt(e);
    return VMe(n, t);
  } else
    return { base64: !0, data: e };
}, VMe = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, qMe = "", LDt = (e, t) => {
  const n = e.length, r = new Array(n);
  let i = 0;
  e.forEach((o, s) => {
    iG(o, !1, (l) => {
      r[s] = l, ++i === n && t(r.join(qMe));
    });
  });
}, zDt = (e, t) => {
  const n = e.split(qMe), r = [];
  for (let i = 0; i < n.length; i++) {
    const o = oG(n[i], t);
    if (r.push(o), o.type === "error")
      break;
  }
  return r;
};
function jDt() {
  return new TransformStream({
    transform(e, t) {
      RDt(e, (n) => {
        const r = n.length;
        let i;
        if (r < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
        else if (r < 65536) {
          i = new Uint8Array(3);
          const o = new DataView(i.buffer);
          o.setUint8(0, 126), o.setUint16(1, r);
        } else {
          i = new Uint8Array(9);
          const o = new DataView(i.buffer);
          o.setUint8(0, 127), o.setBigUint64(1, BigInt(r));
        }
        e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
      });
    }
  });
}
let mU;
function pI(e) {
  return e.reduce((t, n) => t + n.length, 0);
}
function hI(e, t) {
  if (e[0].length === t)
    return e.shift();
  const n = new Uint8Array(t);
  let r = 0;
  for (let i = 0; i < t; i++)
    n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
  return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function FDt(e, t) {
  mU || (mU = new TextDecoder());
  const n = [];
  let r = 0, i = -1, o = !1;
  return new TransformStream({
    transform(s, l) {
      for (n.push(s); ; ) {
        if (r === 0) {
          if (pI(n) < 1)
            break;
          const c = hI(n, 1);
          o = (c[0] & 128) === 128, i = c[0] & 127, i < 126 ? r = 3 : i === 126 ? r = 1 : r = 2;
        } else if (r === 1) {
          if (pI(n) < 2)
            break;
          const c = hI(n, 2);
          i = new DataView(c.buffer, c.byteOffset, c.length).getUint16(0), r = 3;
        } else if (r === 2) {
          if (pI(n) < 8)
            break;
          const c = hI(n, 8), a = new DataView(c.buffer, c.byteOffset, c.length), u = a.getUint32(0);
          if (u > Math.pow(2, 21) - 1) {
            l.enqueue(p9);
            break;
          }
          i = u * Math.pow(2, 32) + a.getUint32(4), r = 3;
        } else {
          if (pI(n) < i)
            break;
          const c = hI(n, i);
          l.enqueue(oG(o ? c : mU.decode(c), t)), r = 0;
        }
        if (i === 0 || i > e) {
          l.enqueue(p9);
          break;
        }
      }
    }
  });
}
const BMe = 4;
function mo(e) {
  if (e) return UDt(e);
}
function UDt(e) {
  for (var t in mo.prototype)
    e[t] = mo.prototype[t];
  return e;
}
mo.prototype.on = mo.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
mo.prototype.once = function(e, t) {
  function n() {
    this.off(e, n), t.apply(this, arguments);
  }
  return n.fn = t, this.on(e, n), this;
};
mo.prototype.off = mo.prototype.removeListener = mo.prototype.removeAllListeners = mo.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + e];
  if (!n) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var r, i = 0; i < n.length; i++)
    if (r = n[i], r === t || r.fn === t) {
      n.splice(i, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + e], this;
};
mo.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, i = n.length; r < i; ++r)
      n[r].apply(this, t);
  }
  return this;
};
mo.prototype.emitReserved = mo.prototype.emit;
mo.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
mo.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const Vj = typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, n) => n(t, 0), Lc = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), VDt = "arraybuffer";
function XMe(e, ...t) {
  return t.reduce((n, r) => (e.hasOwnProperty(r) && (n[r] = e[r]), n), {});
}
const qDt = Lc.setTimeout, BDt = Lc.clearTimeout;
function qj(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = qDt.bind(Lc), e.clearTimeoutFn = BDt.bind(Lc)) : (e.setTimeoutFn = Lc.setTimeout.bind(Lc), e.clearTimeoutFn = Lc.clearTimeout.bind(Lc));
}
const XDt = 1.33;
function WDt(e) {
  return typeof e == "string" ? ZDt(e) : Math.ceil((e.byteLength || e.size) * XDt);
}
function ZDt(e) {
  let t = 0, n = 0;
  for (let r = 0, i = e.length; r < i; r++)
    t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
function WMe() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function HDt(e) {
  let t = "";
  for (let n in e)
    e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
  return t;
}
function QDt(e) {
  let t = {}, n = e.split("&");
  for (let r = 0, i = n.length; r < i; r++) {
    let o = n[r].split("=");
    t[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
  }
  return t;
}
class $Dt extends Error {
  constructor(t, n, r) {
    super(t), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class sG extends mo {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, qj(this, t), this.opts = t, this.query = t.query, this.socket = t.socket, this.supportsBinary = !t.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, n, r) {
    return super.emitReserved("error", new $Dt(t, n, r)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const n = oG(t, this.socket.binaryType);
    this.onPacket(n);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, n = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(n);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const n = HDt(t);
    return n.length ? "?" + n : "";
  }
}
class KDt extends sG {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", t();
    };
    if (this._polling || !this.writable) {
      let r = 0;
      this._polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    zDt(t, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, LDt(t, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", n = this.query || {};
    return this.opts.timestampRequests !== !1 && (n[this.opts.timestampParam] = WMe()), !this.supportsBinary && !n.sid && (n.b64 = 1), this.createUri(t, n);
  }
}
let ZMe = !1;
try {
  ZMe = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const GDt = ZMe;
function YDt() {
}
class JDt extends KDt {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), typeof location < "u") {
      const n = location.protocol === "https:";
      let r = location.port;
      r || (r = n ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || r !== t.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, n) {
    const r = this.request({
      method: "POST",
      data: t
    });
    r.on("success", n), r.on("error", (i, o) => {
      this.onError("xhr post error", i, o);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = t;
  }
}
class yf extends mo {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, n, r) {
    super(), this.createRequest = t, qj(this, r), this._opts = r, this._method = r.method || "GET", this._uri = n, this._data = r.data !== void 0 ? r.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var t;
    const n = XMe(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    n.xdomain = !!this._opts.xd;
    const r = this._xhr = this.createRequest(n);
    try {
      r.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
          for (let i in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(i) && r.setRequestHeader(i, this._opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        r.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this._opts.cookieJar) === null || t === void 0 || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (r.timeout = this._opts.requestTimeout), r.onreadystatechange = () => {
        var i;
        r.readyState === 3 && ((i = this._opts.cookieJar) === null || i === void 0 || i.parseCookies(
          // @ts-ignore
          r.getResponseHeader("set-cookie")
        )), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof r.status == "number" ? r.status : 0);
        }, 0));
      }, r.send(this._data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this._onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = yf.requestsCount++, yf.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(t) {
    this.emitReserved("error", t, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(t) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = YDt, t)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete yf.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const t = this._xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
yf.requestsCount = 0;
yf.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", nce);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in Lc ? "pagehide" : "unload";
    addEventListener(e, nce, !1);
  }
}
function nce() {
  for (let e in yf.requests)
    yf.requests.hasOwnProperty(e) && yf.requests[e].abort();
}
const e_t = function() {
  const e = HMe({
    xdomain: !1
  });
  return e && e.responseType !== null;
}();
class t_t extends JDt {
  constructor(t) {
    super(t);
    const n = t && t.forceBase64;
    this.supportsBinary = e_t && !n;
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd }, this.opts), new yf(HMe, this.uri(), t);
  }
}
function HMe(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || GDt))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new Lc[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const QMe = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class n_t extends sG {
  get name() {
    return "websocket";
  }
  doOpen() {
    const t = this.uri(), n = this.opts.protocols, r = QMe ? {} : XMe(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(t, n, r);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      iG(r, this.supportsBinary, (o) => {
        try {
          this.doWrite(r, o);
        } catch {
        }
        i && Vj(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", n = this.query || {};
    return this.opts.timestampRequests && (n[this.opts.timestampParam] = WMe()), this.supportsBinary || (n.b64 = 1), this.createUri(t, n);
  }
}
const gU = Lc.WebSocket || Lc.MozWebSocket;
let r_t = class extends n_t {
  createSocket(t, n, r) {
    return QMe ? new gU(t, n, r) : n ? new gU(t, n) : new gU(t);
  }
  doWrite(t, n) {
    this.ws.send(n);
  }
};
class i_t extends sG {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (t) {
      return this.emitReserved("error", t);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((t) => {
        const n = FDt(Number.MAX_SAFE_INTEGER, this.socket.binaryType), r = t.readable.pipeThrough(n).getReader(), i = jDt();
        i.readable.pipeTo(t.writable), this._writer = i.writable.getWriter();
        const o = () => {
          r.read().then(({ done: l, value: c }) => {
            l || (this.onPacket(c), o());
          }).catch((l) => {
          });
        };
        o();
        const s = { type: "open" };
        this.query.sid && (s.data = `{"sid":"${this.query.sid}"}`), this._writer.write(s).then(() => this.onOpen());
      });
    });
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      this._writer.write(r).then(() => {
        i && Vj(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this._transport) === null || t === void 0 || t.close();
  }
}
const o_t = {
  websocket: r_t,
  webtransport: i_t,
  polling: t_t
}, s_t = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, a_t = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function h9(e) {
  if (e.length > 8e3)
    throw "URI too long";
  const t = e, n = e.indexOf("["), r = e.indexOf("]");
  n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
  let i = s_t.exec(e || ""), o = {}, s = 14;
  for (; s--; )
    o[a_t[s]] = i[s] || "";
  return n != -1 && r != -1 && (o.source = t, o.host = o.host.substring(1, o.host.length - 1).replace(/;/g, ":"), o.authority = o.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), o.ipv6uri = !0), o.pathNames = l_t(o, o.path), o.queryKey = c_t(o, o.query), o;
}
function l_t(e, t) {
  const n = /\/{2,9}/g, r = t.replace(n, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && r.splice(0, 1), t.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function c_t(e, t) {
  const n = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, i, o) {
    i && (n[i] = o);
  }), n;
}
const m9 = typeof addEventListener == "function" && typeof removeEventListener == "function", oM = [];
m9 && addEventListener("offline", () => {
  oM.forEach((e) => e());
}, !1);
class $m extends mo {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, n) {
    if (super(), this.binaryType = VDt, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, t && typeof t == "object" && (n = t, t = null), t) {
      const r = h9(t);
      n.hostname = r.host, n.secure = r.protocol === "https" || r.protocol === "wss", n.port = r.port, r.query && (n.query = r.query);
    } else n.host && (n.hostname = h9(n.host).host);
    qj(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, n.transports.forEach((r) => {
      const i = r.prototype.name;
      this.transports.push(i), this._transportsByName[i] = r;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = QDt(this.opts.query)), m9 && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, oM.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = BMe, n.transport = t, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new this._transportsByName[t](r);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const t = this.opts.rememberUpgrade && $m.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const n = this.createTransport(t);
    n.open(), this.setTransport(n);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (n) => this._onClose("transport close", n));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", $m.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const n = new Error("server error");
          n.code = t.data, this._onError(n);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this._pingInterval = t.pingInterval, this._pingTimeout = t.pingTimeout, this._maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const t = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + t, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, t), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this._getWritablePackets();
      this.transport.send(t), this._prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const i = this.writeBuffer[r].data;
      if (i && (n += WDt(i)), r > 0 && n > this._maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const t = Date.now() > this._pingTimeoutTime;
    return t && (this._pingTimeoutTime = 0, Vj(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), t;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(t, n, r) {
    return this._sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(t, n, r) {
    return this._sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(t, n, r, i) {
    if (typeof n == "function" && (i = n, n = void 0), typeof r == "function" && (i = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const o = {
      type: t,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", o), this.writeBuffer.push(o), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this._onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), t();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : t();
    }) : this.upgrading ? r() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(t) {
    if ($m.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", t), this._onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(t, n) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), m9 && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const r = oM.indexOf(this._offlineEventListener);
        r !== -1 && oM.splice(r, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", t, n), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
$m.protocol = BMe;
class u_t extends $m {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let t = 0; t < this._upgrades.length; t++)
        this._probe(this._upgrades[t]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(t) {
    let n = this.createTransport(t), r = !1;
    $m.priorWebsocketSuccess = !1;
    const i = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (f) => {
        if (!r)
          if (f.type === "pong" && f.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            $m.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (u(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const d = new Error("probe error");
            d.transport = n.name, this.emitReserved("upgradeError", d);
          }
      }));
    };
    function o() {
      r || (r = !0, u(), n.close(), n = null);
    }
    const s = (f) => {
      const d = new Error("probe error: " + f);
      d.transport = n.name, o(), this.emitReserved("upgradeError", d);
    };
    function l() {
      s("transport closed");
    }
    function c() {
      s("socket closed");
    }
    function a(f) {
      n && f.name !== n.name && o();
    }
    const u = () => {
      n.removeListener("open", i), n.removeListener("error", s), n.removeListener("close", l), this.off("close", c), this.off("upgrading", a);
    };
    n.once("open", i), n.once("error", s), n.once("close", l), this.once("close", c), this.once("upgrading", a), this._upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      r || n.open();
    }, 200) : n.open();
  }
  onHandshake(t) {
    this._upgrades = this._filterUpgrades(t.upgrades), super.onHandshake(t);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(t) {
    const n = [];
    for (let r = 0; r < t.length; r++)
      ~this.transports.indexOf(t[r]) && n.push(t[r]);
    return n;
  }
}
let d_t = class extends u_t {
  constructor(t, n = {}) {
    const r = typeof t == "object" ? t : n;
    (!r.transports || r.transports && typeof r.transports[0] == "string") && (r.transports = (r.transports || ["polling", "websocket", "webtransport"]).map((i) => o_t[i]).filter((i) => !!i)), super(t, r);
  }
};
function f_t(e, t = "", n) {
  let r = e;
  n = n || typeof location < "u" && location, e == null && (e = n.protocol + "//" + n.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = n.protocol + e : e = n.host + e), /^(https?|wss?):\/\//.test(e) || (typeof n < "u" ? e = n.protocol + "//" + e : e = "https://" + e), r = h9(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const o = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + o + ":" + r.port + t, r.href = r.protocol + "://" + o + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const p_t = typeof ArrayBuffer == "function", h_t = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, $Me = Object.prototype.toString, m_t = typeof Blob == "function" || typeof Blob < "u" && $Me.call(Blob) === "[object BlobConstructor]", g_t = typeof File == "function" || typeof File < "u" && $Me.call(File) === "[object FileConstructor]";
function aG(e) {
  return p_t && (e instanceof ArrayBuffer || h_t(e)) || m_t && e instanceof Blob || g_t && e instanceof File;
}
function sM(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let n = 0, r = e.length; n < r; n++)
      if (sM(e[n]))
        return !0;
    return !1;
  }
  if (aG(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return sM(e.toJSON(), !0);
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && sM(e[n]))
      return !0;
  return !1;
}
function y_t(e) {
  const t = [], n = e.data, r = e;
  return r.data = g9(n, t), r.attachments = t.length, { packet: r, buffers: t };
}
function g9(e, t) {
  if (!e)
    return e;
  if (aG(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let r = 0; r < e.length; r++)
      n[r] = g9(e[r], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const n = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = g9(e[r], t));
    return n;
  }
  return e;
}
function v_t(e, t) {
  return e.data = y9(e.data, t), delete e.attachments, e;
}
function y9(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let n = 0; n < e.length; n++)
      e[n] = y9(e[n], t);
  else if (typeof e == "object")
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (e[n] = y9(e[n], t));
  return e;
}
const b_t = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], O_t = 5;
var lr;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(lr || (lr = {}));
class A_t {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === lr.EVENT || t.type === lr.ACK) && sM(t) ? this.encodeAsBinary({
      type: t.type === lr.EVENT ? lr.BINARY_EVENT : lr.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let n = "" + t.type;
    return (t.type === lr.BINARY_EVENT || t.type === lr.BINARY_ACK) && (n += t.attachments + "-"), t.nsp && t.nsp !== "/" && (n += t.nsp + ","), t.id != null && (n += t.id), t.data != null && (n += JSON.stringify(t.data, this.replacer)), n;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const n = y_t(t), r = this.encodeAsString(n.packet), i = n.buffers;
    return i.unshift(r), i;
  }
}
function rce(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class lG extends mo {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let n;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(t);
      const r = n.type === lr.BINARY_EVENT;
      r || n.type === lr.BINARY_ACK ? (n.type = r ? lr.EVENT : lr.ACK, this.reconstructor = new w_t(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (aG(t) || t.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(t), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let n = 0;
    const r = {
      type: Number(t.charAt(0))
    };
    if (lr[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === lr.BINARY_EVENT || r.type === lr.BINARY_ACK) {
      const o = n + 1;
      for (; t.charAt(++n) !== "-" && n != t.length; )
        ;
      const s = t.substring(o, n);
      if (s != Number(s) || t.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(s);
    }
    if (t.charAt(n + 1) === "/") {
      const o = n + 1;
      for (; ++n && !(t.charAt(n) === "," || n === t.length); )
        ;
      r.nsp = t.substring(o, n);
    } else
      r.nsp = "/";
    const i = t.charAt(n + 1);
    if (i !== "" && Number(i) == i) {
      const o = n + 1;
      for (; ++n; ) {
        const s = t.charAt(n);
        if (s == null || Number(s) != s) {
          --n;
          break;
        }
        if (n === t.length)
          break;
      }
      r.id = Number(t.substring(o, n + 1));
    }
    if (t.charAt(++n)) {
      const o = this.tryParse(t.substr(n));
      if (lG.isPayloadValid(r.type, o))
        r.data = o;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, n) {
    switch (t) {
      case lr.CONNECT:
        return rce(n);
      case lr.DISCONNECT:
        return n === void 0;
      case lr.CONNECT_ERROR:
        return typeof n == "string" || rce(n);
      case lr.EVENT:
      case lr.BINARY_EVENT:
        return Array.isArray(n) && (typeof n[0] == "number" || typeof n[0] == "string" && b_t.indexOf(n[0]) === -1);
      case lr.ACK:
      case lr.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class w_t {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const n = v_t(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const x_t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: lG,
  Encoder: A_t,
  get PacketType() {
    return lr;
  },
  protocol: O_t
}, Symbol.toStringTag, { value: "Module" }));
function Ru(e, t, n) {
  return e.on(t, n), function() {
    e.off(t, n);
  };
}
const S_t = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class KMe extends mo {
  /**
   * `Socket` constructor.
   */
  constructor(t, n, r) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = n, r && r.auth && (this.auth = r.auth), this._opts = Object.assign({}, r), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      Ru(t, "open", this.onopen.bind(this)),
      Ru(t, "packet", this.onpacket.bind(this)),
      Ru(t, "error", this.onerror.bind(this)),
      Ru(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...n) {
    var r, i, o;
    if (S_t.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (n.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(n), this;
    const s = {
      type: lr.EVENT,
      data: n
    };
    if (s.options = {}, s.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const u = this.ids++, f = n.pop();
      this._registerAckCallback(u, f), s.id = u;
    }
    const l = (i = (r = this.io.engine) === null || r === void 0 ? void 0 : r.transport) === null || i === void 0 ? void 0 : i.writable, c = this.connected && !(!((o = this.io.engine) === null || o === void 0) && o._hasPingExpired());
    return this.flags.volatile && !l || (c ? (this.notifyOutgoingListeners(s), this.packet(s)) : this.sendBuffer.push(s)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, n) {
    var r;
    const i = (r = this.flags.timeout) !== null && r !== void 0 ? r : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[t] = n;
      return;
    }
    const o = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let l = 0; l < this.sendBuffer.length; l++)
        this.sendBuffer[l].id === t && this.sendBuffer.splice(l, 1);
      n.call(this, new Error("operation has timed out"));
    }, i), s = (...l) => {
      this.io.clearTimeoutFn(o), n.apply(this, l);
    };
    s.withError = !0, this.acks[t] = s;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...n) {
    return new Promise((r, i) => {
      const o = (s, l) => s ? i(s) : r(l);
      o.withError = !0, n.push(o), this.emit(t, ...n);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let n;
    typeof t[t.length - 1] == "function" && (n = t.pop());
    const r = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((i, ...o) => r !== this._queue[0] ? void 0 : (i !== null ? r.tryCount > this._opts.retries && (this._queue.shift(), n && n(i)) : (this._queue.shift(), n && n(null, ...o)), r.pending = !1, this._drainQueue())), this._queue.push(r), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const n = this._queue[0];
    n.pending && !t || (n.pending = !0, n.tryCount++, this.flags = n.flags, this.emit.apply(this, n.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: lr.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, n), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((t) => {
      if (!this.sendBuffer.some((r) => String(r.id) === t)) {
        const r = this.acks[t];
        delete this.acks[t], r.withError && r.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case lr.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case lr.EVENT:
        case lr.BINARY_EVENT:
          this.onevent(t);
          break;
        case lr.ACK:
        case lr.BINARY_ACK:
          this.onack(t);
          break;
        case lr.DISCONNECT:
          this.ondisconnect();
          break;
        case lr.CONNECT_ERROR:
          this.destroy();
          const r = new Error(t.data.message);
          r.data = t.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const n = t.data || [];
    t.id != null && n.push(this.ack(t.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const n = this;
    let r = !1;
    return function(...i) {
      r || (r = !0, n.packet({
        type: lr.ACK,
        id: t,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const n = this.acks[t.id];
    typeof n == "function" && (delete this.acks[t.id], n.withError && t.data.unshift(null), n.apply(this, t.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, n) {
    this.id = t, this.recovered = n && this._pid === n, this._pid = n, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: lr.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, t.data);
    }
  }
}
function Ex(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Ex.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), n = Math.floor(t * this.jitter * e);
    e = (Math.floor(t * 10) & 1) == 0 ? e - n : e + n;
  }
  return Math.min(e, this.max) | 0;
};
Ex.prototype.reset = function() {
  this.attempts = 0;
};
Ex.prototype.setMin = function(e) {
  this.ms = e;
};
Ex.prototype.setMax = function(e) {
  this.max = e;
};
Ex.prototype.setJitter = function(e) {
  this.jitter = e;
};
class v9 extends mo {
  constructor(t, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (n = t, t = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, qj(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new Ex({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = t;
    const i = n.parser || x_t;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, t || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var n;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (n = this.backoff) === null || n === void 0 || n.setMin(t), this);
  }
  randomizationFactor(t) {
    var n;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (n = this.backoff) === null || n === void 0 || n.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var n;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (n = this.backoff) === null || n === void 0 || n.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new d_t(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = Ru(n, "open", function() {
      r.onopen(), t && t();
    }), o = (l) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", l), t ? t(l) : this.maybeReconnectOnOpen();
    }, s = Ru(n, "error", o);
    if (this._timeout !== !1) {
      const l = this._timeout, c = this.setTimeoutFn(() => {
        i(), o(new Error("timeout")), n.close();
      }, l);
      this.opts.autoUnref && c.unref(), this.subs.push(() => {
        this.clearTimeoutFn(c);
      });
    }
    return this.subs.push(i), this.subs.push(s), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(
      Ru(t, "ping", this.onping.bind(this)),
      Ru(t, "data", this.ondata.bind(this)),
      Ru(t, "error", this.onerror.bind(this)),
      Ru(t, "close", this.onclose.bind(this)),
      // @ts-ignore
      Ru(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    Vj(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, n) {
    let r = this.nsps[t];
    return r ? this._autoConnect && !r.active && r.connect() : (r = new KMe(this, t, n), this.nsps[t] = r), r;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const n = this.encoder.encode(t);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(t, n) {
    var r;
    this.cleanup(), (r = this.engine) === null || r === void 0 || r.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((i) => {
          i ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", i)) : t.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(() => {
        this.clearTimeoutFn(r);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const pS = {};
function aM(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const n = f_t(e, t.path || "/socket.io"), r = n.source, i = n.id, o = n.path, s = pS[i] && o in pS[i].nsps, l = t.forceNew || t["force new connection"] || t.multiplex === !1 || s;
  let c;
  return l ? c = new v9(r, t) : (pS[i] || (pS[i] = new v9(r, t)), c = pS[i]), n.query && !t.query && (t.query = n.queryKey), c.socket(n.path, t);
}
Object.assign(aM, {
  Manager: v9,
  Socket: KMe,
  io: aM,
  connect: aM
});
const Ec = aM(Hwe, {
  transports: ["websocket"],
  path: wrt,
  autoConnect: !1,
  reconnection: !0
}), GMe = ie.createContext(Ec), E_t = ({ children: e }) => {
  const t = Rn.getToken(), n = Xe(null);
  return nt(() => (t ? (Ec.auth = { token: t }, Ec.connected || (Ec.connect(), Ec.on("connect", () => {
    n.current && (vr.dismiss(n.current), n.current = null), console.log("connected to socket");
  }), Ec.on("disconnect", (r) => {
    if (!n.current) {
      const i = vr("Connection Lost", {
        id: "websocket-disconnected",
        description: "We are trying to reconnect...",
        duration: 1 / 0
      });
      n.current = (i == null ? void 0 : i.toString()) ?? null;
    }
    r === "io server disconnect" && Ec.connect();
  }))) : Ec.disconnect(), () => {
    Ec.off("connect"), Ec.off("disconnect"), Ec.disconnect();
  }), [t]), /* @__PURE__ */ y(GMe.Provider, { value: Ec, children: e });
}, Zv = () => ie.useContext(GMe);
function bs(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function ice(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function sg(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = ice(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : ice(e[i], null);
        }
      };
  };
}
function ja(...e) {
  return N.useCallback(sg(...e), e);
}
function T_t(e, t) {
  const n = N.createContext(t), r = (o) => {
    const { children: s, ...l } = o, c = N.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ y(n.Provider, { value: c, children: s });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const s = N.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function Tx(e, t = []) {
  let n = [];
  function r(o, s) {
    const l = N.createContext(s), c = n.length;
    n = [...n, s];
    const a = (f) => {
      var b;
      const { scope: d, children: p, ...h } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || l, v = N.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ y(m.Provider, { value: v, children: p });
    };
    a.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || l, h = N.useContext(p);
      if (h) return h;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [a, u];
  }
  const i = () => {
    const o = n.map((s) => N.createContext(s));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || o;
      return N.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return i.scopeName = e, [r, k_t(i, ...t)];
}
function k_t(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((l, { useScope: c, scopeName: a }) => {
        const f = c(o)[`__scope${a}`];
        return { ...l, ...f };
      }, {});
      return N.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var rd = globalThis != null && globalThis.document ? N.useLayoutEffect : () => {
}, C_t = N[" useId ".trim().toString()] || (() => {
}), N_t = 0;
function Zu(e) {
  const [t, n] = N.useState(C_t());
  return rd(() => {
    n((r) => r ?? String(N_t++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var P_t = N[" useInsertionEffect ".trim().toString()] || rd;
function p_({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, o, s] = I_t({
    defaultProp: t,
    onChange: n
  }), l = e !== void 0, c = l ? e : i;
  {
    const u = N.useRef(e !== void 0);
    N.useEffect(() => {
      const f = u.current;
      f !== l && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = l;
    }, [l, r]);
  }
  const a = N.useCallback(
    (u) => {
      var f;
      if (l) {
        const d = R_t(u) ? u(e) : u;
        d !== e && ((f = s.current) == null || f.call(s, d));
      } else
        o(u);
    },
    [l, e, o, s]
  );
  return [c, a];
}
function I_t({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = N.useState(e), i = N.useRef(n), o = N.useRef(t);
  return P_t(() => {
    o.current = t;
  }, [t]), N.useEffect(() => {
    var s;
    i.current !== n && ((s = o.current) == null || s.call(o, n), i.current = n);
  }, [n, i]), [n, r, o];
}
function R_t(e) {
  return typeof e == "function";
}
// @__NO_SIDE_EFFECTS__
function YMe(e) {
  const t = /* @__PURE__ */ M_t(e), n = N.forwardRef((r, i) => {
    const { children: o, ...s } = r, l = N.Children.toArray(o), c = l.find(__t);
    if (c) {
      const a = c.props.children, u = l.map((f) => f === c ? N.Children.count(a) > 1 ? N.Children.only(null) : N.isValidElement(a) ? a.props.children : null : f);
      return /* @__PURE__ */ y(t, { ...s, ref: i, children: N.isValidElement(a) ? N.cloneElement(a, void 0, u) : null });
    }
    return /* @__PURE__ */ y(t, { ...s, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function M_t(e) {
  const t = N.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (N.isValidElement(i)) {
      const s = z_t(i), l = L_t(o, i.props);
      return i.type !== N.Fragment && (l.ref = r ? sg(r, s) : s), N.cloneElement(i, l);
    }
    return N.Children.count(i) > 1 ? N.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var D_t = Symbol("radix.slottable");
function __t(e) {
  return N.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === D_t;
}
function L_t(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...l) => {
      const c = o(...l);
      return i(...l), c;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function z_t(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var j_t = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], to = j_t.reduce((e, t) => {
  const n = /* @__PURE__ */ YMe(`Primitive.${t}`), r = N.forwardRef((i, o) => {
    const { asChild: s, ...l } = i, c = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(c, { ...l, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function F_t(e, t) {
  e && sb.flushSync(() => e.dispatchEvent(t));
}
function ag(e) {
  const t = N.useRef(e);
  return N.useEffect(() => {
    t.current = e;
  }), N.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function U_t(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ag(e);
  N.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var V_t = "DismissableLayer", b9 = "dismissableLayer.update", q_t = "dismissableLayer.pointerDownOutside", B_t = "dismissableLayer.focusOutside", oce, JMe = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), cG = N.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: l,
      ...c
    } = e, a = N.useContext(JMe), [u, f] = N.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = N.useState({}), h = ja(t, (E) => f(E)), m = Array.from(a.layers), [v] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(v), A = u ? m.indexOf(u) : -1, w = a.layersWithOutsidePointerEventsDisabled.size > 0, O = A >= b, x = Z_t((E) => {
      const k = E.target, T = [...a.branches].some((R) => R.contains(k));
      !O || T || (i == null || i(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d), S = H_t((E) => {
      const k = E.target;
      [...a.branches].some((R) => R.contains(k)) || (o == null || o(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d);
    return U_t((E) => {
      A === a.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && l && (E.preventDefault(), l()));
    }, d), N.useEffect(() => {
      if (u)
        return n && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (oce = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(u)), a.layers.add(u), sce(), () => {
          n && a.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = oce);
        };
    }, [u, d, n, a]), N.useEffect(() => () => {
      u && (a.layers.delete(u), a.layersWithOutsidePointerEventsDisabled.delete(u), sce());
    }, [u, a]), N.useEffect(() => {
      const E = () => p({});
      return document.addEventListener(b9, E), () => document.removeEventListener(b9, E);
    }, []), /* @__PURE__ */ y(
      to.div,
      {
        ...c,
        ref: h,
        style: {
          pointerEvents: w ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: bs(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: bs(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: bs(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
cG.displayName = V_t;
var X_t = "DismissableLayerBranch", W_t = N.forwardRef((e, t) => {
  const n = N.useContext(JMe), r = N.useRef(null), i = ja(t, r);
  return N.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ y(to.div, { ...e, ref: i });
});
W_t.displayName = X_t;
function Z_t(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ag(e), r = N.useRef(!1), i = N.useRef(() => {
  });
  return N.useEffect(() => {
    const o = (l) => {
      if (l.target && !r.current) {
        let c = function() {
          eDe(
            q_t,
            n,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function H_t(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ag(e), r = N.useRef(!1);
  return N.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && eDe(B_t, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function sce() {
  const e = new CustomEvent(b9);
  document.dispatchEvent(e);
}
function eDe(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? F_t(i, o) : i.dispatchEvent(o);
}
var yU = "focusScope.autoFocusOnMount", vU = "focusScope.autoFocusOnUnmount", ace = { bubbles: !1, cancelable: !0 }, Q_t = "FocusScope", tDe = N.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = e, [l, c] = N.useState(null), a = ag(i), u = ag(o), f = N.useRef(null), d = ja(t, (m) => c(m)), p = N.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  N.useEffect(() => {
    if (r) {
      let m = function(w) {
        if (p.paused || !l) return;
        const O = w.target;
        l.contains(O) ? f.current = O : Hh(f.current, { select: !0 });
      }, v = function(w) {
        if (p.paused || !l) return;
        const O = w.relatedTarget;
        O !== null && (l.contains(O) || Hh(f.current, { select: !0 }));
      }, b = function(w) {
        if (document.activeElement === document.body)
          for (const x of w)
            x.removedNodes.length > 0 && Hh(l);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", v);
      const A = new MutationObserver(b);
      return l && A.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", v), A.disconnect();
      };
    }
  }, [r, l, p.paused]), N.useEffect(() => {
    if (l) {
      cce.add(p);
      const m = document.activeElement;
      if (!l.contains(m)) {
        const b = new CustomEvent(yU, ace);
        l.addEventListener(yU, a), l.dispatchEvent(b), b.defaultPrevented || ($_t(eLt(nDe(l)), { select: !0 }), document.activeElement === m && Hh(l));
      }
      return () => {
        l.removeEventListener(yU, a), setTimeout(() => {
          const b = new CustomEvent(vU, ace);
          l.addEventListener(vU, u), l.dispatchEvent(b), b.defaultPrevented || Hh(m ?? document.body, { select: !0 }), l.removeEventListener(vU, u), cce.remove(p);
        }, 0);
      };
    }
  }, [l, a, u, p]);
  const h = N.useCallback(
    (m) => {
      if (!n && !r || p.paused) return;
      const v = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (v && b) {
        const A = m.currentTarget, [w, O] = K_t(A);
        w && O ? !m.shiftKey && b === O ? (m.preventDefault(), n && Hh(w, { select: !0 })) : m.shiftKey && b === w && (m.preventDefault(), n && Hh(O, { select: !0 })) : b === A && m.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ y(to.div, { tabIndex: -1, ...s, ref: d, onKeyDown: h });
});
tDe.displayName = Q_t;
function $_t(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Hh(r, { select: t }), document.activeElement !== n) return;
}
function K_t(e) {
  const t = nDe(e), n = lce(t, e), r = lce(t.reverse(), e);
  return [n, r];
}
function nDe(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function lce(e, t) {
  for (const n of e)
    if (!G_t(n, { upTo: t })) return n;
}
function G_t(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Y_t(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Hh(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Y_t(e) && t && e.select();
  }
}
var cce = J_t();
function J_t() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = uce(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = uce(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function uce(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function eLt(e) {
  return e.filter((t) => t.tagName !== "A");
}
var tLt = "Portal", uG = N.forwardRef((e, t) => {
  var l;
  const { container: n, ...r } = e, [i, o] = N.useState(!1);
  rd(() => o(!0), []);
  const s = n || i && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return s ? _w.createPortal(/* @__PURE__ */ y(to.div, { ...r, ref: t }), s) : null;
});
uG.displayName = tLt;
function nLt(e, t) {
  return N.useReducer((n, r) => t[n][r] ?? n, e);
}
var kx = (e) => {
  const { present: t, children: n } = e, r = rLt(t), i = typeof n == "function" ? n({ present: r.isPresent }) : N.Children.only(n), o = ja(r.ref, iLt(i));
  return typeof n == "function" || r.isPresent ? N.cloneElement(i, { ref: o }) : null;
};
kx.displayName = "Presence";
function rLt(e) {
  const [t, n] = N.useState(), r = N.useRef(null), i = N.useRef(e), o = N.useRef("none"), s = e ? "mounted" : "unmounted", [l, c] = nLt(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const a = mI(r.current);
    o.current = l === "mounted" ? a : "none";
  }, [l]), rd(() => {
    const a = r.current, u = i.current;
    if (u !== e) {
      const d = o.current, p = mI(a);
      e ? c("MOUNT") : p === "none" || (a == null ? void 0 : a.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), rd(() => {
    if (t) {
      let a;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const m = mI(r.current).includes(CSS.escape(p.animationName));
        if (p.target === t && m && (c("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", a = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, d = (p) => {
        p.target === t && (o.current = mI(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(a), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: N.useCallback((a) => {
      r.current = a ? getComputedStyle(a) : null, n(a);
    }, [])
  };
}
function mI(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function iLt(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var bU = 0;
function oLt() {
  N.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? dce()), document.body.insertAdjacentElement("beforeend", e[1] ?? dce()), bU++, () => {
      bU === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), bU--;
    };
  }, []);
}
function dce() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var rDe = yQ(), OU = function() {
}, Bj = N.forwardRef(function(e, t) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: OU,
    onWheelCapture: OU,
    onTouchMoveCapture: OU
  }), i = r[0], o = r[1], s = e.forwardProps, l = e.children, c = e.className, a = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, p = e.noRelative, h = e.noIsolation, m = e.inert, v = e.allowPinchZoom, b = e.as, A = b === void 0 ? "div" : b, w = e.gapMode, O = cx(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = d, S = gQ([n, t]), E = bi(bi({}, O), i);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(x, { sideCar: rDe, removeScrollBar: a, shards: f, noRelative: p, noIsolation: h, inert: m, setCallbacks: o, allowPinchZoom: !!v, lockRef: n, gapMode: w }),
    s ? N.cloneElement(N.Children.only(l), bi(bi({}, E), { ref: S })) : N.createElement(A, bi({}, E, { className: c, ref: S }), l)
  );
});
Bj.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Bj.classNames = {
  fullWidth: VO,
  zeroRight: UO
};
var O9 = !1;
if (typeof window < "u")
  try {
    var gI = Object.defineProperty({}, "passive", {
      get: function() {
        return O9 = !0, !0;
      }
    });
    window.addEventListener("test", gI, gI), window.removeEventListener("test", gI, gI);
  } catch {
    O9 = !1;
  }
var r0 = O9 ? { passive: !1 } : !1, sLt = function(e) {
  return e.tagName === "TEXTAREA";
}, iDe = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !sLt(e) && n[t] === "visible")
  );
}, aLt = function(e) {
  return iDe(e, "overflowY");
}, lLt = function(e) {
  return iDe(e, "overflowX");
}, fce = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = oDe(e, r);
    if (i) {
      var o = sDe(e, r), s = o[1], l = o[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, cLt = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, uLt = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, oDe = function(e, t) {
  return e === "v" ? aLt(t) : lLt(t);
}, sDe = function(e, t) {
  return e === "v" ? cLt(t) : uLt(t);
}, dLt = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, fLt = function(e, t, n, r, i) {
  var o = dLt(e, window.getComputedStyle(t).direction), s = o * r, l = n.target, c = t.contains(l), a = !1, u = s > 0, f = 0, d = 0;
  do {
    if (!l)
      break;
    var p = sDe(e, l), h = p[0], m = p[1], v = p[2], b = m - v - o * h;
    (h || b) && oDe(e, l) && (f += b, d += h);
    var A = l.parentNode;
    l = A && A.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? A.host : A;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(d) < 1) && (a = !0), a;
}, yI = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, pce = function(e) {
  return [e.deltaX, e.deltaY];
}, hce = function(e) {
  return e && "current" in e ? e.current : e;
}, pLt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, hLt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, mLt = 0, i0 = [];
function gLt(e) {
  var t = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), i = N.useState(mLt++)[0], o = N.useState(Cz)[0], s = N.useRef(e);
  N.useEffect(function() {
    s.current = e;
  }, [e]), N.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = JC([e.lockRef.current], (e.shards || []).map(hce), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = N.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !s.current.allowPinchZoom;
    var b = yI(m), A = n.current, w = "deltaX" in m ? m.deltaX : A[0] - b[0], O = "deltaY" in m ? m.deltaY : A[1] - b[1], x, S = m.target, E = Math.abs(w) > Math.abs(O) ? "h" : "v";
    if ("touches" in m && E === "h" && S.type === "range")
      return !1;
    var k = fce(E, S);
    if (!k)
      return !0;
    if (k ? x = E : (x = E === "v" ? "h" : "v", k = fce(E, S)), !k)
      return !1;
    if (!r.current && "changedTouches" in m && (w || O) && (r.current = x), !x)
      return !0;
    var T = r.current || x;
    return fLt(T, v, m, T === "h" ? w : O);
  }, []), c = N.useCallback(function(m) {
    var v = m;
    if (!(!i0.length || i0[i0.length - 1] !== o)) {
      var b = "deltaY" in v ? pce(v) : yI(v), A = t.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && pLt(x.delta, b);
      })[0];
      if (A && A.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!A) {
        var w = (s.current.shards || []).map(hce).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), O = w.length > 0 ? l(v, w[0]) : !s.current.noIsolation;
        O && v.cancelable && v.preventDefault();
      }
    }
  }, []), a = N.useCallback(function(m, v, b, A) {
    var w = { name: m, delta: v, target: b, should: A, shadowParent: yLt(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== w;
      });
    }, 1);
  }, []), u = N.useCallback(function(m) {
    n.current = yI(m), r.current = void 0;
  }, []), f = N.useCallback(function(m) {
    a(m.type, pce(m), m.target, l(m, e.lockRef.current));
  }, []), d = N.useCallback(function(m) {
    a(m.type, yI(m), m.target, l(m, e.lockRef.current));
  }, []);
  N.useEffect(function() {
    return i0.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, r0), document.addEventListener("touchmove", c, r0), document.addEventListener("touchstart", u, r0), function() {
      i0 = i0.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, r0), document.removeEventListener("touchmove", c, r0), document.removeEventListener("touchstart", u, r0);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return N.createElement(
    N.Fragment,
    null,
    h ? N.createElement(o, { styles: hLt(i) }) : null,
    p ? N.createElement(bQ, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function yLt(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const vLt = vQ(rDe, gLt);
var aDe = N.forwardRef(function(e, t) {
  return N.createElement(Bj, bi({}, e, { ref: t, sideCar: vLt }));
});
aDe.classNames = Bj.classNames;
var Xj = "Dialog", [lDe, Omn] = Tx(Xj), [bLt, Ad] = lDe(Xj), cDe = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, l = N.useRef(null), c = N.useRef(null), [a, u] = p_({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: Xj
  });
  return /* @__PURE__ */ y(
    bLt,
    {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: Zu(),
      titleId: Zu(),
      descriptionId: Zu(),
      open: a,
      onOpenChange: u,
      onOpenToggle: N.useCallback(() => u((f) => !f), [u]),
      modal: s,
      children: n
    }
  );
};
cDe.displayName = Xj;
var uDe = "DialogTrigger", OLt = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ad(uDe, n), o = ja(t, i.triggerRef);
    return /* @__PURE__ */ y(
      to.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": pG(i.open),
        ...r,
        ref: o,
        onClick: bs(e.onClick, i.onOpenToggle)
      }
    );
  }
);
OLt.displayName = uDe;
var dG = "DialogPortal", [ALt, dDe] = lDe(dG, {
  forceMount: void 0
}), fDe = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = Ad(dG, t);
  return /* @__PURE__ */ y(ALt, { scope: t, forceMount: n, children: N.Children.map(r, (s) => /* @__PURE__ */ y(kx, { present: n || o.open, children: /* @__PURE__ */ y(uG, { asChild: !0, container: i, children: s }) })) });
};
fDe.displayName = dG;
var h_ = "DialogOverlay", pDe = N.forwardRef(
  (e, t) => {
    const n = dDe(h_, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ad(h_, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ y(kx, { present: r || o.open, children: /* @__PURE__ */ y(xLt, { ...i, ref: t }) }) : null;
  }
);
pDe.displayName = h_;
var wLt = /* @__PURE__ */ YMe("DialogOverlay.RemoveScroll"), xLt = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ad(h_, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ y(aDe, { as: wLt, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ y(
        to.div,
        {
          "data-state": pG(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Hv = "DialogContent", hDe = N.forwardRef(
  (e, t) => {
    const n = dDe(Hv, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = Ad(Hv, e.__scopeDialog);
    return /* @__PURE__ */ y(kx, { present: r || o.open, children: o.modal ? /* @__PURE__ */ y(SLt, { ...i, ref: t }) : /* @__PURE__ */ y(ELt, { ...i, ref: t }) });
  }
);
hDe.displayName = Hv;
var SLt = N.forwardRef(
  (e, t) => {
    const n = Ad(Hv, e.__scopeDialog), r = N.useRef(null), i = ja(t, n.contentRef, r);
    return N.useEffect(() => {
      const o = r.current;
      if (o) return ux(o);
    }, []), /* @__PURE__ */ y(
      mDe,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: bs(e.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: bs(e.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || l) && o.preventDefault();
        }),
        onFocusOutside: bs(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), ELt = N.forwardRef(
  (e, t) => {
    const n = Ad(Hv, e.__scopeDialog), r = N.useRef(!1), i = N.useRef(!1);
    return /* @__PURE__ */ y(
      mDe,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, l;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (l = n.triggerRef.current) == null || l.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, a;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((a = n.triggerRef.current) == null ? void 0 : a.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), mDe = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = e, l = Ad(Hv, n), c = N.useRef(null), a = ja(t, c);
    return oLt(), /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        tDe,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ y(
            cG,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": pG(l.open),
              ...s,
              ref: a,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y(CLt, { titleId: l.titleId }),
        /* @__PURE__ */ y(PLt, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), fG = "DialogTitle", gDe = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ad(fG, n);
    return /* @__PURE__ */ y(to.h2, { id: i.titleId, ...r, ref: t });
  }
);
gDe.displayName = fG;
var yDe = "DialogDescription", TLt = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ad(yDe, n);
    return /* @__PURE__ */ y(to.p, { id: i.descriptionId, ...r, ref: t });
  }
);
TLt.displayName = yDe;
var vDe = "DialogClose", kLt = N.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Ad(vDe, n);
    return /* @__PURE__ */ y(
      to.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: bs(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
kLt.displayName = vDe;
function pG(e) {
  return e ? "open" : "closed";
}
var bDe = "DialogTitleWarning", [Amn, ODe] = T_t(bDe, {
  contentName: Hv,
  titleName: fG,
  docsSlug: "dialog"
}), CLt = ({ titleId: e }) => {
  const t = ODe(bDe), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return N.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, NLt = "DialogDescriptionWarning", PLt = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ODe(NLt).contentName}}.`;
  return N.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, ADe = cDe, wDe = fDe, xDe = pDe, SDe = hDe, ILt = gDe;
function RLt(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const EDe = ie.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), xN = () => {
  const e = ie.useContext(EDe);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
RLt(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function MLt() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function DLt() {
  return hG(/^Mac/);
}
function _Lt() {
  return hG(/^iPhone/);
}
function mce() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function LLt() {
  return hG(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  DLt() && navigator.maxTouchPoints > 1;
}
function TDe() {
  return _Lt() || LLt();
}
function hG(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const zLt = 24, jLt = typeof window < "u" ? Og : nt;
function gce(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const AU = typeof document < "u" && window.visualViewport;
function yce(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function kDe(e) {
  for (yce(e) && (e = e.parentElement); e && !yce(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const FLt = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let vI = 0, wU;
function ULt(e = {}) {
  let { isDisabled: t } = e;
  jLt(() => {
    if (!t)
      return vI++, vI === 1 && TDe() && (wU = VLt()), () => {
        vI--, vI === 0 && (wU == null || wU());
      };
  }, [
    t
  ]);
}
function VLt() {
  let e, t = 0, n = (f) => {
    e = kDe(f.target), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    let d = f.changedTouches[0].pageY, p = e.scrollTop, h = e.scrollHeight - e.clientHeight;
    h !== 0 && ((p <= 0 && d > t || p >= h && d < t) && f.preventDefault(), t = d);
  }, i = (f) => {
    let d = f.target;
    A9(d) && d !== document.activeElement && (f.preventDefault(), d.style.transform = "translateY(-2000px)", d.focus(), requestAnimationFrame(() => {
      d.style.transform = "";
    }));
  }, o = (f) => {
    let d = f.target;
    A9(d) && (d.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      d.style.transform = "", AU && (AU.height < window.innerHeight ? requestAnimationFrame(() => {
        vce(d);
      }) : AU.addEventListener("resize", () => vce(d), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, l = window.pageXOffset, c = window.pageYOffset, a = gce(qLt(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = gce(hS(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), hS(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), hS(document, "touchend", i, {
    passive: !1,
    capture: !0
  }), hS(document, "focus", o, !0), hS(window, "scroll", s));
  return () => {
    a(), u(), window.scrollTo(l, c);
  };
}
function qLt(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function hS(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function vce(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = kDe(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, i = e.getBoundingClientRect().top, o = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + zLt;
      o > s && (n.scrollTop += i - r);
    }
    e = n.parentElement;
  }
}
function A9(e) {
  return e instanceof HTMLInputElement && !FLt.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function BLt(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function XLt(...e) {
  return (t) => e.forEach((n) => BLt(n, t));
}
function CDe(...e) {
  return N.useCallback(XLt(...e), e);
}
const NDe = /* @__PURE__ */ new WeakMap();
function Co(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([i, o]) => {
    if (i.startsWith("--")) {
      e.style.setProperty(i, o);
      return;
    }
    r[i] = e.style[i], e.style[i] = o;
  }), !n && NDe.set(e, r);
}
function WLt(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = NDe.get(e);
  n && (e.style[t] = n[t]);
}
const co = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function bI(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let i = r.match(/^matrix3d\((.+)\)$/);
  return i ? parseFloat(i[1].split(", ")[co(t) ? 13 : 12]) : (i = r.match(/^matrix\((.+)\)$/), i ? parseFloat(i[1].split(", ")[co(t) ? 5 : 4]) : null);
}
function ZLt(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function xU(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function HLt(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Si = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, PDe = 0.4, QLt = 0.25, $Lt = 100, IDe = 8, OI = 16, w9 = 26, SU = "vaul-dragging";
function RDe(e) {
  const t = ie.useRef(e);
  return ie.useEffect(() => {
    t.current = e;
  }), ie.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function KLt({ defaultProp: e, onChange: t }) {
  const n = ie.useState(e), [r] = n, i = ie.useRef(r), o = RDe(t);
  return ie.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
function MDe({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = KLt({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, s = o ? e : r, l = RDe(n), c = ie.useCallback((a) => {
    if (o) {
      const f = typeof a == "function" ? a(e) : a;
      f !== e && l(f);
    } else
      i(a);
  }, [
    o,
    e,
    i,
    l
  ]);
  return [
    s,
    c
  ];
}
function GLt({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: i, fadeFromIndex: o, onSnapPointChange: s, direction: l = "bottom", container: c, snapToSequentialPoint: a }) {
  const [u, f] = MDe({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [d, p] = ie.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  ie.useEffect(() => {
    function E() {
      p({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", E), () => window.removeEventListener("resize", E);
  }, []);
  const h = ie.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), m = ie.useMemo(() => {
    var E;
    return (E = n == null ? void 0 : n.findIndex((k) => k === u)) != null ? E : null;
  }, [
    n,
    u
  ]), v = n && n.length > 0 && (o || o === 0) && !Number.isNaN(o) && n[o] === u || !n, b = ie.useMemo(() => {
    const E = c ? {
      width: c.getBoundingClientRect().width,
      height: c.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var k;
    return (k = n == null ? void 0 : n.map((T) => {
      const R = typeof T == "string";
      let j = 0;
      if (R && (j = parseInt(T, 10)), co(l)) {
        const L = R ? j : d ? T * E.height : 0;
        return d ? l === "bottom" ? E.height - L : -E.height + L : L;
      }
      const F = R ? j : d ? T * E.width : 0;
      return d ? l === "right" ? E.width - F : -E.width + F : F;
    })) != null ? k : [];
  }, [
    n,
    d,
    c
  ]), A = ie.useMemo(() => m !== null ? b == null ? void 0 : b[m] : null, [
    b,
    m
  ]), w = ie.useCallback((E) => {
    var k;
    const T = (k = b == null ? void 0 : b.findIndex((R) => R === E)) != null ? k : null;
    s(T), Co(r.current, {
      transition: `transform ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      transform: co(l) ? `translate3d(0, ${E}px, 0)` : `translate3d(${E}px, 0, 0)`
    }), b && T !== b.length - 1 && o !== void 0 && T !== o && T < o ? Co(i.current, {
      transition: `opacity ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      opacity: "0"
    }) : Co(i.current, {
      transition: `opacity ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(T, 0)]);
  }, [
    r.current,
    n,
    b,
    o,
    i,
    f
  ]);
  ie.useEffect(() => {
    if (u || e) {
      var E;
      const k = (E = n == null ? void 0 : n.findIndex((T) => T === e || T === u)) != null ? E : -1;
      b && k !== -1 && typeof b[k] == "number" && w(b[k]);
    }
  }, [
    u,
    e,
    n,
    b,
    w
  ]);
  function O({ draggedDistance: E, closeDrawer: k, velocity: T, dismissible: R }) {
    if (o === void 0) return;
    const j = l === "bottom" || l === "right" ? (A ?? 0) - E : (A ?? 0) + E, F = m === o - 1, L = m === 0, _ = E > 0;
    if (F && Co(i.current, {
      transition: `opacity ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`
    }), !a && T > 2 && !_) {
      R ? k() : w(b[0]);
      return;
    }
    if (!a && T > 2 && _ && b && n) {
      w(b[n.length - 1]);
      return;
    }
    const U = b == null ? void 0 : b.reduce((C, I) => typeof C != "number" || typeof I != "number" ? C : Math.abs(I - j) < Math.abs(C - j) ? I : C), z = co(l) ? window.innerHeight : window.innerWidth;
    if (T > PDe && Math.abs(E) < z * 0.4) {
      const C = _ ? 1 : -1;
      if (C > 0 && h && n) {
        w(b[n.length - 1]);
        return;
      }
      if (L && C < 0 && R && k(), m === null) return;
      w(b[m + C]);
      return;
    }
    w(U);
  }
  function x({ draggedDistance: E }) {
    if (A === null) return;
    const k = l === "bottom" || l === "right" ? A - E : A + E;
    (l === "bottom" || l === "right") && k < b[b.length - 1] || (l === "top" || l === "left") && k > b[b.length - 1] || Co(r.current, {
      transform: co(l) ? `translate3d(0, ${k}px, 0)` : `translate3d(${k}px, 0, 0)`
    });
  }
  function S(E, k) {
    if (!n || typeof m != "number" || !b || o === void 0) return null;
    const T = m === o - 1;
    if (m >= o && k)
      return 0;
    if (T && !k) return 1;
    if (!v && !T) return null;
    const j = T ? m + 1 : m - 1, F = T ? b[j] - b[j - 1] : b[j + 1] - b[j], L = E / Math.abs(F);
    return T ? 1 - L : L;
  }
  return {
    isLastSnapPoint: h,
    activeSnapPoint: u,
    shouldFade: v,
    getPercentageDragged: S,
    setActiveSnapPoint: f,
    activeSnapPointIndex: m,
    onRelease: O,
    onDrag: x,
    snapPointsOffset: b
  };
}
const YLt = () => () => {
};
function JLt() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: i } = xN(), o = ie.useRef(null), s = Kt(() => document.body.style.backgroundColor, []);
  function l() {
    return (window.innerWidth - w9) / window.innerWidth;
  }
  ie.useEffect(() => {
    if (t && n) {
      o.current && clearTimeout(o.current);
      const c = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!c) return;
      HLt(r && !i ? xU(document.body, {
        background: "black"
      }) : YLt, xU(c, {
        transformOrigin: co(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Si.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Si.EASE.join(",")})`
      }));
      const a = xU(c, {
        borderRadius: `${IDe}px`,
        overflow: "hidden",
        ...co(e) ? {
          transform: `scale(${l()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${l()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        a(), o.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, Si.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let mS = null;
function e2t({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: i, noBodyStyles: o }) {
  const [s, l] = ie.useState(() => typeof window < "u" ? window.location.href : ""), c = ie.useRef(0), a = ie.useCallback(() => {
    if (mce() && mS === null && e && !o) {
      mS = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: d } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-c.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const p = d - window.innerHeight;
        p && c.current >= d && (document.body.style.top = `${-(c.current + p)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = ie.useCallback(() => {
    if (mce() && mS !== null && !o) {
      const f = -parseInt(document.body.style.top, 10), d = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, mS), window.requestAnimationFrame(() => {
        if (i && s !== window.location.href) {
          l(window.location.href);
          return;
        }
        window.scrollTo(d, f);
      }), mS = null;
    }
  }, [
    s
  ]);
  return ie.useEffect(() => {
    function f() {
      c.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), ie.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    t,
    u
  ]), ie.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && a(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    r,
    s,
    t,
    n,
    a,
    u
  ]), {
    restorePositionSetting: u
  };
}
function t2t({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: i, snapPoints: o, shouldScaleBackground: s = !1, setBackgroundColorOnScale: l = !0, closeThreshold: c = QLt, scrollLockTimeout: a = $Lt, dismissible: u = !0, handleOnly: f = !1, fadeFromIndex: d = o && o.length - 1, activeSnapPoint: p, setActiveSnapPoint: h, fixed: m, modal: v = !0, onClose: b, nested: A, noBodyStyles: w = !1, direction: O = "bottom", defaultOpen: x = !1, disablePreventScroll: S = !0, snapToSequentialPoint: E = !1, preventScrollRestoration: k = !1, repositionInputs: T = !0, onAnimationEnd: R, container: j, autoFocus: F = !1 }) {
  var L, _;
  const [U = !1, z] = MDe({
    defaultProp: x,
    prop: e,
    onChange: (st) => {
      t == null || t(st), !st && !A && ae(), setTimeout(() => {
        R == null || R(st);
      }, Si.DURATION * 1e3), st && !v && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), st || (document.body.style.pointerEvents = "auto");
    }
  }), [C, I] = ie.useState(!1), [M, D] = ie.useState(!1), [X, B] = ie.useState(!1), q = ie.useRef(null), H = ie.useRef(null), Y = ie.useRef(null), J = ie.useRef(null), oe = ie.useRef(null), ce = ie.useRef(!1), fe = ie.useRef(null), $ = ie.useRef(0), pe = ie.useRef(!1), ee = ie.useRef(!x), Ce = ie.useRef(0), Ee = ie.useRef(null), Ve = ie.useRef(((L = Ee.current) == null ? void 0 : L.getBoundingClientRect().height) || 0), et = ie.useRef(((_ = Ee.current) == null ? void 0 : _.getBoundingClientRect().width) || 0), ft = ie.useRef(0), me = ie.useCallback((st) => {
    o && st === be.length - 1 && (H.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Te, activeSnapPointIndex: re, setActiveSnapPoint: le, onRelease: Oe, snapPointsOffset: be, onDrag: je, shouldFade: xe, getPercentageDragged: Q } = GLt({
    snapPoints: o,
    activeSnapPointProp: p,
    setActiveSnapPointProp: h,
    drawerRef: Ee,
    fadeFromIndex: d,
    overlayRef: q,
    onSnapPointChange: me,
    direction: O,
    container: j,
    snapToSequentialPoint: E
  });
  ULt({
    isDisabled: !U || M || !v || X || !C || !T || !S
  });
  const { restorePositionSetting: ae } = e2t({
    isOpen: U,
    modal: v,
    nested: A ?? !1,
    hasBeenOpened: C,
    preventScrollRestoration: k,
    noBodyStyles: w
  });
  function Pe() {
    return (window.innerWidth - w9) / window.innerWidth;
  }
  function Fe(st) {
    var Mt, lt;
    !u && !o || Ee.current && !Ee.current.contains(st.target) || (Ve.current = ((Mt = Ee.current) == null ? void 0 : Mt.getBoundingClientRect().height) || 0, et.current = ((lt = Ee.current) == null ? void 0 : lt.getBoundingClientRect().width) || 0, D(!0), Y.current = /* @__PURE__ */ new Date(), TDe() && window.addEventListener("touchend", () => ce.current = !1, {
      once: !0
    }), st.target.setPointerCapture(st.pointerId), $.current = co(O) ? st.pageY : st.pageX);
  }
  function Ke(st, Mt) {
    var lt;
    let xt = st;
    const yt = (lt = window.getSelection()) == null ? void 0 : lt.toString(), ct = Ee.current ? bI(Ee.current, O) : null, Rt = /* @__PURE__ */ new Date();
    if (xt.tagName === "SELECT" || xt.hasAttribute("data-vaul-no-drag") || xt.closest("[data-vaul-no-drag]"))
      return !1;
    if (O === "right" || O === "left")
      return !0;
    if (H.current && Rt.getTime() - H.current.getTime() < 500)
      return !1;
    if (ct !== null && (O === "bottom" ? ct > 0 : ct < 0))
      return !0;
    if (yt && yt.length > 0)
      return !1;
    if (oe.current && Rt.getTime() - oe.current.getTime() < a && ct === 0 || Mt)
      return oe.current = Rt, !1;
    for (; xt; ) {
      if (xt.scrollHeight > xt.clientHeight) {
        if (xt.scrollTop !== 0)
          return oe.current = /* @__PURE__ */ new Date(), !1;
        if (xt.getAttribute("role") === "dialog")
          return !0;
      }
      xt = xt.parentNode;
    }
    return !0;
  }
  function Ot(st) {
    if (Ee.current && M) {
      const Mt = O === "bottom" || O === "right" ? 1 : -1, lt = ($.current - (co(O) ? st.pageY : st.pageX)) * Mt, xt = lt > 0, yt = o && !u && !xt;
      if (yt && re === 0) return;
      const ct = Math.abs(lt), Rt = document.querySelector("[data-vaul-drawer-wrapper]"), Yt = O === "bottom" || O === "top" ? Ve.current : et.current;
      let Gt = ct / Yt;
      const hn = Q(ct, xt);
      if (hn !== null && (Gt = hn), yt && Gt >= 1 || !ce.current && !Ke(st.target, xt)) return;
      if (Ee.current.classList.add(SU), ce.current = !0, Co(Ee.current, {
        transition: "none"
      }), Co(q.current, {
        transition: "none"
      }), o && je({
        draggedDistance: lt
      }), xt && !o) {
        const Sn = ZLt(lt), Ar = Math.min(Sn * -1, 0) * Mt;
        Co(Ee.current, {
          transform: co(O) ? `translate3d(0, ${Ar}px, 0)` : `translate3d(${Ar}px, 0, 0)`
        });
        return;
      }
      const en = 1 - Gt;
      if ((xe || d && re === d - 1) && (r == null || r(st, Gt), Co(q.current, {
        opacity: `${en}`,
        transition: "none"
      }, !0)), Rt && q.current && s) {
        const Sn = Math.min(Pe() + Gt * (1 - Pe()), 1), Ar = 8 - Gt * 8, or = Math.max(0, 14 - Gt * 14);
        Co(Rt, {
          borderRadius: `${Ar}px`,
          transform: co(O) ? `scale(${Sn}) translate3d(0, ${or}px, 0)` : `scale(${Sn}) translate3d(${or}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!o) {
        const Sn = ct * Mt;
        Co(Ee.current, {
          transform: co(O) ? `translate3d(0, ${Sn}px, 0)` : `translate3d(${Sn}px, 0, 0)`
        });
      }
    }
  }
  ie.useEffect(() => {
    window.requestAnimationFrame(() => {
      ee.current = !0;
    });
  }, []), ie.useEffect(() => {
    var st;
    function Mt() {
      if (!Ee.current || !T) return;
      const lt = document.activeElement;
      if (A9(lt) || pe.current) {
        var xt;
        const yt = ((xt = window.visualViewport) == null ? void 0 : xt.height) || 0, ct = window.innerHeight;
        let Rt = ct - yt;
        const Yt = Ee.current.getBoundingClientRect().height || 0, Gt = Yt > ct * 0.8;
        ft.current || (ft.current = Yt);
        const hn = Ee.current.getBoundingClientRect().top;
        if (Math.abs(Ce.current - Rt) > 60 && (pe.current = !pe.current), o && o.length > 0 && be && re) {
          const en = be[re] || 0;
          Rt += en;
        }
        if (Ce.current = Rt, Yt > yt || pe.current) {
          const en = Ee.current.getBoundingClientRect().height;
          let Sn = en;
          en > yt && (Sn = yt - (Gt ? hn : w9)), m ? Ee.current.style.height = `${en - Math.max(Rt, 0)}px` : Ee.current.style.height = `${Math.max(Sn, yt - hn)}px`;
        } else MLt() || (Ee.current.style.height = `${ft.current}px`);
        o && o.length > 0 && !pe.current ? Ee.current.style.bottom = "0px" : Ee.current.style.bottom = `${Math.max(Rt, 0)}px`;
      }
    }
    return (st = window.visualViewport) == null || st.addEventListener("resize", Mt), () => {
      var lt;
      return (lt = window.visualViewport) == null ? void 0 : lt.removeEventListener("resize", Mt);
    };
  }, [
    re,
    o,
    be
  ]);
  function Ct(st) {
    yn(), b == null || b(), st || z(!1), setTimeout(() => {
      o && le(o[0]);
    }, Si.DURATION * 1e3);
  }
  function Jt() {
    if (!Ee.current) return;
    const st = document.querySelector("[data-vaul-drawer-wrapper]"), Mt = bI(Ee.current, O);
    Co(Ee.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`
    }), Co(q.current, {
      transition: `opacity ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      opacity: "1"
    }), s && Mt && Mt > 0 && U && Co(st, {
      borderRadius: `${IDe}px`,
      overflow: "hidden",
      ...co(O) ? {
        transform: `scale(${Pe()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Pe()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Si.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Si.EASE.join(",")})`
    }, !0);
  }
  function yn() {
    !M || !Ee.current || (Ee.current.classList.remove(SU), ce.current = !1, D(!1), J.current = /* @__PURE__ */ new Date());
  }
  function vn(st) {
    if (!M || !Ee.current) return;
    Ee.current.classList.remove(SU), ce.current = !1, D(!1), J.current = /* @__PURE__ */ new Date();
    const Mt = bI(Ee.current, O);
    if (!st || !Ke(st.target, !1) || !Mt || Number.isNaN(Mt) || Y.current === null) return;
    const lt = J.current.getTime() - Y.current.getTime(), xt = $.current - (co(O) ? st.pageY : st.pageX), yt = Math.abs(xt) / lt;
    if (yt > 0.05 && (B(!0), setTimeout(() => {
      B(!1);
    }, 200)), o) {
      Oe({
        draggedDistance: xt * (O === "bottom" || O === "right" ? 1 : -1),
        closeDrawer: Ct,
        velocity: yt,
        dismissible: u
      }), i == null || i(st, !0);
      return;
    }
    if (O === "bottom" || O === "right" ? xt > 0 : xt < 0) {
      Jt(), i == null || i(st, !0);
      return;
    }
    if (yt > PDe) {
      Ct(), i == null || i(st, !1);
      return;
    }
    var ct;
    const Rt = Math.min((ct = Ee.current.getBoundingClientRect().height) != null ? ct : 0, window.innerHeight);
    var Yt;
    const Gt = Math.min((Yt = Ee.current.getBoundingClientRect().width) != null ? Yt : 0, window.innerWidth), hn = O === "left" || O === "right";
    if (Math.abs(Mt) >= (hn ? Gt : Rt) * c) {
      Ct(), i == null || i(st, !1);
      return;
    }
    i == null || i(st, !0), Jt();
  }
  ie.useEffect(() => (U && (Co(document.documentElement, {
    scrollBehavior: "auto"
  }), H.current = /* @__PURE__ */ new Date()), () => {
    WLt(document.documentElement, "scrollBehavior");
  }), [
    U
  ]);
  function Re(st) {
    const Mt = st ? (window.innerWidth - OI) / window.innerWidth : 1, lt = st ? -16 : 0;
    fe.current && window.clearTimeout(fe.current), Co(Ee.current, {
      transition: `transform ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      transform: co(O) ? `scale(${Mt}) translate3d(0, ${lt}px, 0)` : `scale(${Mt}) translate3d(${lt}px, 0, 0)`
    }), !st && Ee.current && (fe.current = setTimeout(() => {
      const xt = bI(Ee.current, O);
      Co(Ee.current, {
        transition: "none",
        transform: co(O) ? `translate3d(0, ${xt}px, 0)` : `translate3d(${xt}px, 0, 0)`
      });
    }, 500));
  }
  function _e(st, Mt) {
    if (Mt < 0) return;
    const lt = (window.innerWidth - OI) / window.innerWidth, xt = lt + Mt * (1 - lt), yt = -16 + Mt * OI;
    Co(Ee.current, {
      transform: co(O) ? `scale(${xt}) translate3d(0, ${yt}px, 0)` : `scale(${xt}) translate3d(${yt}px, 0, 0)`,
      transition: "none"
    });
  }
  function jt(st, Mt) {
    const lt = co(O) ? window.innerHeight : window.innerWidth, xt = Mt ? (lt - OI) / lt : 1, yt = Mt ? -16 : 0;
    Mt && Co(Ee.current, {
      transition: `transform ${Si.DURATION}s cubic-bezier(${Si.EASE.join(",")})`,
      transform: co(O) ? `scale(${xt}) translate3d(0, ${yt}px, 0)` : `scale(${xt}) translate3d(${yt}px, 0, 0)`
    });
  }
  return ie.useEffect(() => {
    v || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    v
  ]), /* @__PURE__ */ ie.createElement(ADe, {
    defaultOpen: x,
    onOpenChange: (st) => {
      !u && !st || (st ? I(!0) : Ct(!0), z(st));
    },
    open: U
  }, /* @__PURE__ */ ie.createElement(EDe.Provider, {
    value: {
      activeSnapPoint: Te,
      snapPoints: o,
      setActiveSnapPoint: le,
      drawerRef: Ee,
      overlayRef: q,
      onOpenChange: t,
      onPress: Fe,
      onRelease: vn,
      onDrag: Ot,
      dismissible: u,
      shouldAnimate: ee,
      handleOnly: f,
      isOpen: U,
      isDragging: M,
      shouldFade: xe,
      closeDrawer: Ct,
      onNestedDrag: _e,
      onNestedOpenChange: Re,
      onNestedRelease: jt,
      keyboardIsOpen: pe,
      modal: v,
      snapPointsOffset: be,
      activeSnapPointIndex: re,
      direction: O,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: l,
      noBodyStyles: w,
      container: j,
      autoFocus: F
    }
  }, n));
}
const n2t = /* @__PURE__ */ ie.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: i, shouldFade: o, isOpen: s, modal: l, shouldAnimate: c } = xN(), a = CDe(t, n), u = r && r.length > 0;
  if (!l)
    return null;
  const f = ie.useCallback((d) => i(d), [
    i
  ]);
  return /* @__PURE__ */ ie.createElement(xDe, {
    onMouseUp: f,
    ref: a,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && u ? "true" : "false",
    "data-vaul-snap-points-overlay": s && o ? "true" : "false",
    "data-vaul-animate": c != null && c.current ? "true" : "false",
    ...e
  });
});
n2t.displayName = "Drawer.Overlay";
const DDe = /* @__PURE__ */ ie.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, i) {
  const { drawerRef: o, onPress: s, onRelease: l, onDrag: c, keyboardIsOpen: a, snapPointsOffset: u, activeSnapPointIndex: f, modal: d, isOpen: p, direction: h, snapPoints: m, container: v, handleOnly: b, shouldAnimate: A, autoFocus: w } = xN(), [O, x] = ie.useState(!1), S = CDe(i, o), E = ie.useRef(null), k = ie.useRef(null), T = ie.useRef(!1), R = m && m.length > 0;
  JLt();
  const j = (L, _, U = 0) => {
    if (T.current) return !0;
    const z = Math.abs(L.y), C = Math.abs(L.x), I = C > z, M = [
      "bottom",
      "right"
    ].includes(_) ? 1 : -1;
    if (_ === "left" || _ === "right") {
      if (!(L.x * M < 0) && C >= 0 && C <= U)
        return I;
    } else if (!(L.y * M < 0) && z >= 0 && z <= U)
      return !I;
    return T.current = !0, !0;
  };
  ie.useEffect(() => {
    R && window.requestAnimationFrame(() => {
      x(!0);
    });
  }, []);
  function F(L) {
    E.current = null, T.current = !1, l(L);
  }
  return /* @__PURE__ */ ie.createElement(SDe, {
    "data-vaul-drawer-direction": h,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": O ? "true" : "false",
    "data-vaul-snap-points": p && R ? "true" : "false",
    "data-vaul-custom-container": v ? "true" : "false",
    "data-vaul-animate": A != null && A.current ? "true" : "false",
    ...r,
    ref: S,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[f ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (L) => {
      b || (r.onPointerDown == null || r.onPointerDown.call(r, L), E.current = {
        x: L.pageX,
        y: L.pageY
      }, s(L));
    },
    onOpenAutoFocus: (L) => {
      n == null || n(L), w || L.preventDefault();
    },
    onPointerDownOutside: (L) => {
      if (e == null || e(L), !d || L.defaultPrevented) {
        L.preventDefault();
        return;
      }
      a.current && (a.current = !1);
    },
    onFocusOutside: (L) => {
      if (!d) {
        L.preventDefault();
        return;
      }
    },
    onPointerMove: (L) => {
      if (k.current = L, b || (r.onPointerMove == null || r.onPointerMove.call(r, L), !E.current)) return;
      const _ = L.pageY - E.current.y, U = L.pageX - E.current.x, z = L.pointerType === "touch" ? 10 : 2;
      j({
        x: U,
        y: _
      }, h, z) ? c(L) : (Math.abs(U) > z || Math.abs(_) > z) && (E.current = null);
    },
    onPointerUp: (L) => {
      r.onPointerUp == null || r.onPointerUp.call(r, L), E.current = null, T.current = !1, l(L);
    },
    onPointerOut: (L) => {
      r.onPointerOut == null || r.onPointerOut.call(r, L), F(k.current);
    },
    onContextMenu: (L) => {
      r.onContextMenu == null || r.onContextMenu.call(r, L), k.current && F(k.current);
    }
  });
});
DDe.displayName = "Drawer.Content";
const r2t = 250, i2t = 120, o2t = /* @__PURE__ */ ie.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: i, isDragging: o, snapPoints: s, activeSnapPoint: l, setActiveSnapPoint: c, dismissible: a, handleOnly: u, isOpen: f, onPress: d, onDrag: p } = xN(), h = ie.useRef(null), m = ie.useRef(!1);
  function v() {
    if (m.current) {
      w();
      return;
    }
    window.setTimeout(() => {
      b();
    }, i2t);
  }
  function b() {
    if (o || e || m.current) {
      w();
      return;
    }
    if (w(), !s || s.length === 0) {
      a || i();
      return;
    }
    if (l === s[s.length - 1] && a) {
      i();
      return;
    }
    const x = s.findIndex((E) => E === l);
    if (x === -1) return;
    const S = s[x + 1];
    c(S);
  }
  function A() {
    h.current = window.setTimeout(() => {
      m.current = !0;
    }, r2t);
  }
  function w() {
    h.current && window.clearTimeout(h.current), m.current = !1;
  }
  return /* @__PURE__ */ ie.createElement("div", {
    onClick: v,
    onPointerCancel: w,
    onPointerDown: (O) => {
      u && d(O), A();
    },
    onPointerMove: (O) => {
      u && p(O);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ ie.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
o2t.displayName = "Drawer.Handle";
function s2t(e) {
  const t = xN(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ ie.createElement(wDe, {
    container: n,
    ...r
  });
}
const Wj = {
  Root: t2t,
  Content: DDe,
  Portal: s2t,
  Title: ILt
};
function a2t({
  onOpenChange: e,
  open: t,
  closeOnEscape: n = !0,
  ...r
}) {
  return N.useEffect(() => {
    if (!t || !e || !n) return;
    const i = (o) => {
      o.key === "Escape" && n && e(!1);
    };
    return window.addEventListener("keydown", i), () => window.removeEventListener("keydown", i);
  }, [t, e, n]), /* @__PURE__ */ y(
    Wj.Root,
    {
      "data-slot": "drawer",
      open: t,
      onOpenChange: e,
      ...r
    }
  );
}
function l2t({
  ...e
}) {
  return /* @__PURE__ */ y(Wj.Portal, { "data-slot": "drawer-portal", ...e });
}
function c2t({
  className: e,
  children: t,
  fullscreen: n = !1,
  ...r
}) {
  return /* @__PURE__ */ V(l2t, { "data-slot": "drawer-portal", children: [
    n && /* @__PURE__ */ y("style", { children: `
            [data-vaul-drawer][data-vaul-drawer-direction="right"]::after {
              display: none !important;
            }
          ` }),
    /* @__PURE__ */ V(
      Wj.Content,
      {
        "data-slot": "drawer-content",
        className: Se(
          "group/drawer-content bg-background fixed z-50 flex h-auto flex-col shadow-lg outline-none select-text",
          "data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[80vh] data-[vaul-drawer-direction=top]:rounded-b-lg data-[vaul-drawer-direction=top]:border-b",
          "data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[80vh] data-[vaul-drawer-direction=bottom]:rounded-t-lg data-[vaul-drawer-direction=bottom]:border-t",
          "data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=right]:shadow-[-10px_0_10px_-3px_rgba(0,0,0,0.1)]",
          "data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=left]:shadow-[10px_0_10px_-3px_rgba(0,0,0,0.1)]",
          n && "w-screen max-w-none",
          e
        ),
        ...r,
        children: [
          !n && /* @__PURE__ */ y("div", { className: "bg-muted mx-auto mt-4 hidden h-2 w-[100px] shrink-0 rounded-full group-data-[vaul-drawer-direction=bottom]/drawer-content:block" }),
          t
        ]
      }
    )
  ] });
}
function u2t({ className: e, ...t }) {
  return /* @__PURE__ */ y(
    "div",
    {
      "data-slot": "drawer-header",
      className: Se(
        "flex flex-col border border-b  gap-0.5 p-0 group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:gap-1.5 md:text-left",
        e
      ),
      ...t
    }
  );
}
function d2t({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ y(
    Wj.Title,
    {
      "data-slot": "drawer-title",
      className: Se("text-foreground font-semibold", e),
      ...t
    }
  );
}
const _De = ({
  brightSpinner: e = !1,
  mode: t = "fullscreen"
}) => /* @__PURE__ */ y(
  "div",
  {
    className: Se("flex h-screen w-screen items-center justify-center", {
      "h-full w-full": t === "container"
    }),
    children: /* @__PURE__ */ y(
      mu,
      {
        className: Se({
          "stroke-background!": e
        }),
        isLarge: !0
      }
    )
  }
);
function Ow() {
  return Ow = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ow.apply(null, arguments);
}
function LDe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var f2t = Og, p2t = function(t) {
  var n = ie.useRef(t);
  return f2t(function() {
    n.current = t;
  }), n;
}, bce = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, h2t = function(t, n) {
  var r = ie.useRef();
  return ie.useCallback(function(i) {
    t.current = i, r.current && bce(r.current, null), r.current = n, n && bce(n, i);
  }, [n]);
}, Oce = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, m2t = function(t) {
  Object.keys(Oce).forEach(function(n) {
    t.style.setProperty(n, Oce[n], "important");
  });
}, Ace = m2t, pa = null, wce = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function g2t(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), pa || (pa = document.createElement("textarea"), pa.setAttribute("tabindex", "-1"), pa.setAttribute("aria-hidden", "true"), Ace(pa)), pa.parentNode === null && document.body.appendChild(pa);
  var i = e.paddingSize, o = e.borderSize, s = e.sizingStyle, l = s.boxSizing;
  Object.keys(s).forEach(function(d) {
    var p = d;
    pa.style[p] = s[p];
  }), Ace(pa), pa.value = t;
  var c = wce(pa, e);
  pa.value = t, c = wce(pa, e), pa.value = "x";
  var a = pa.scrollHeight - i, u = a * n;
  l === "border-box" && (u = u + i + o), c = Math.max(u, c);
  var f = a * r;
  return l === "border-box" && (f = f + i + o), c = Math.min(f, c), [c, a];
}
var xce = function() {
}, y2t = function(t, n) {
  return t.reduce(function(r, i) {
    return r[i] = n[i], r;
  }, {});
}, v2t = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], b2t = !!document.documentElement.currentStyle, O2t = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = y2t(v2t, n), i = r.boxSizing;
  if (i === "")
    return null;
  b2t && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var o = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), s = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: o,
    borderSize: s
  };
}, A2t = O2t;
function zDe(e, t, n) {
  var r = p2t(n);
  N.useLayoutEffect(function() {
    var i = function(s) {
      return r.current(s);
    };
    if (e)
      return e.addEventListener(t, i), function() {
        return e.removeEventListener(t, i);
      };
  }, []);
}
var w2t = function(t) {
  zDe(window, "resize", t);
}, x2t = function(t) {
  zDe(document.fonts, "loadingdone", t);
}, S2t = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], E2t = function(t, n) {
  var r = t.cacheMeasurements, i = t.maxRows, o = t.minRows, s = t.onChange, l = s === void 0 ? xce : s, c = t.onHeightChange, a = c === void 0 ? xce : c, u = LDe(t, S2t), f = u.value !== void 0, d = N.useRef(null), p = h2t(d, n), h = N.useRef(0), m = N.useRef(), v = function() {
    var w = d.current, O = r && m.current ? m.current : A2t(w);
    if (O) {
      m.current = O;
      var x = g2t(O, w.value || w.placeholder || "x", o, i), S = x[0], E = x[1];
      h.current !== S && (h.current = S, w.style.setProperty("height", S + "px", "important"), a(S, {
        rowHeight: E
      }));
    }
  }, b = function(w) {
    f || v(), l(w);
  };
  return N.useLayoutEffect(v), w2t(v), x2t(v), /* @__PURE__ */ N.createElement("textarea", Ow({}, u, {
    onChange: b,
    ref: p
  }));
}, T2t = /* @__PURE__ */ N.forwardRef(E2t);
const mG = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  T2t,
  {
    cacheMeasurements: !1,
    minRows: 1,
    maxRows: 5,
    className: Se(
      "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm  placeholder:text-muted-foreground focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ref: n,
    ...t
  }
));
mG.displayName = "Textarea";
const k2t = ({
  file: e,
  index: t,
  onRemove: n
}) => {
  const r = e.type.startsWith("image/"), i = e.type.startsWith("video/");
  return /* @__PURE__ */ V("div", { className: "relative inline-block mr-2 mt-2 mb-3", children: [
    r && /* @__PURE__ */ y(
      "img",
      {
        src: URL.createObjectURL(e),
        alt: e.name,
        className: "w-20 h-20 object-cover rounded-lg"
      }
    ),
    i && /* @__PURE__ */ y(
      "video",
      {
        src: URL.createObjectURL(e),
        className: "w-20 h-20 object-cover rounded-lg"
      }
    ),
    !r && !i && /* @__PURE__ */ y("div", { className: "w-20 h-20 bg-foreground text-background rounded-lg flex items-center justify-center", children: /* @__PURE__ */ y(KH, { className: "w-8 h-8" }) }),
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "destructive",
        size: "icon",
        type: "button",
        onClick: (o) => {
          o.stopPropagation(), n(t);
        },
        className: "absolute -top-2 -right-2 rounded-full p-1 size-6",
        children: /* @__PURE__ */ y(ks, { className: "w-3 h-3" })
      }
    ),
    /* @__PURE__ */ y("p", { className: "text-xs mt-1 truncate w-20", children: e.name })
  ] }, t);
}, x9 = N.forwardRef(
  ({
    className: e,
    onSendMessage: t,
    disabled: n = !1,
    placeholder: r = "Type your message here...",
    ...i
  }, o) => {
    const [s, l] = He(""), [c, a] = He([]), u = Xe(null), f = Xe(null), d = hxe(f), p = (b) => {
      b && (a((A) => [...A, ...b]), u.current && (u.current.value = ""));
    }, h = (b) => {
      a((A) => A.filter((w, O) => O !== b));
    }, m = (b) => {
      b.preventDefault(), !(!s && c.length === 0 || n) && (t({
        textContent: s,
        files: c
      }), l(""), a([]));
    }, v = (b) => {
      b.key === "Enter" && !b.shiftKey && (b.preventDefault(), !n && (s || c.length > 0) && m(b));
    };
    return /* @__PURE__ */ y(
      "div",
      {
        className: "w-full",
        onDragOver: (b) => b.preventDefault(),
        onDrop: (b) => {
          b.preventDefault();
          const A = Array.from(b.dataTransfer.files);
          p(A);
        },
        children: /* @__PURE__ */ y("form", { onSubmit: m, className: "flex flex-col", children: /* @__PURE__ */ V("div", { className: "rounded-lg border shadow-xs", children: [
          c.length > 0 && /* @__PURE__ */ y(
            "div",
            {
              className: "px-4 py-3 w-full transition-all overflow-hidden",
              style: {
                height: `${d.height}px`
              },
              children: /* @__PURE__ */ y(
                "div",
                {
                  ref: f,
                  className: "flex items-start gap-3 flex-wrap",
                  children: c.map((b, A) => /* @__PURE__ */ y(
                    k2t,
                    {
                      file: b,
                      index: A,
                      onRemove: h
                    },
                    `${b.name}-${A}`
                  ))
                }
              )
            }
          ),
          /* @__PURE__ */ y(
            mG,
            {
              autoComplete: "off",
              ref: o,
              autoFocus: !0,
              minRows: 1,
              maxRows: 6,
              name: "message",
              className: Se(
                "px-4 py-3 text-sm placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 w-full resize-none border-0 shadow-none focus-visible:ring-0",
                e
              ),
              value: s,
              onKeyDown: v,
              onChange: (b) => l(b.target.value),
              onPaste: (b) => {
                const A = Array.from(b.clipboardData.items).filter((w) => w.kind === "file").map((w) => w.getAsFile()).filter((w) => !De(w));
                p(A);
              },
              placeholder: r,
              disabled: n,
              ...i
            }
          ),
          /* @__PURE__ */ V("div", { className: "flex justify-end items-center gap-4 px-4 py-2", children: [
            /* @__PURE__ */ y("label", { htmlFor: "file-upload", className: "cursor-pointer", children: /* @__PURE__ */ y(nxe, { className: "w-4 h-4 text-muted-foreground hover:text-foreground" }) }),
            /* @__PURE__ */ y(
              "input",
              {
                ref: u,
                id: "file-upload",
                type: "file",
                multiple: !0,
                onChange: (b) => {
                  p(
                    b.target.files && Array.from(b.target.files) || []
                  );
                },
                className: "hidden"
              }
            ),
            /* @__PURE__ */ y(
              Qe,
              {
                disabled: !s && c.length === 0 || n,
                type: "submit",
                size: "icon",
                variant: "default",
                children: /* @__PURE__ */ y(Krt, { className: "w-4 h-4" })
              }
            )
          ] })
        ] }) })
      }
    );
  }
);
x9.displayName = "ChatInput";
function C2t({ chatUI: e, botName: t }) {
  return /* @__PURE__ */ y("div", { className: "flex items-center justify-center py-8 px-4 font-bold", children: /* @__PURE__ */ V("div", { className: "flex flex-col items-center gap-1", children: [
    /* @__PURE__ */ y("div", { className: "flex items-center justify-center p-3 rounded-full", children: /* @__PURE__ */ y(
      "img",
      {
        src: "https://auth.bunyan.ai/resources/xdfav/login/bunyan/img/Bunyan_Logo_landscape.svg",
        alt: "Bot Avatar",
        className: "w-10 h-10"
      }
    ) }),
    /* @__PURE__ */ V("div", { className: "flex items-center gap-1 justify-center", children: [
      /* @__PURE__ */ V("p", { className: "animate-typing overflow-hidden whitespace-nowrap pr-1 hidden lg:block lg:text-xl text-foreground leading-8", children: [
        "Hi! I'm ",
        t,
        " 👋 How can I help you today?"
      ] }),
      /* @__PURE__ */ V("p", { className: "animate-typing-sm overflow-hidden whitespace-nowrap pr-1 lg:hidden text-xl text-foreground leading-8", children: [
        "Hi! I'm ",
        t,
        " 👋"
      ] }),
      /* @__PURE__ */ y("span", { className: "w-4 h-4 rounded-full bg-foreground animate-[fade_0.15s_ease-out_forwards_0.7s_reverse]" })
    ] })
  ] }) });
}
const N2t = ({
  open: e,
  onOpenChange: t,
  imageUrl: n
}) => (nt(() => {
  const r = (i) => {
    i.key === "Escape" && t(!1);
  };
  return document.addEventListener("keydown", r), () => {
    document.removeEventListener("keydown", r);
  };
}, []), e ? /* @__PURE__ */ y(
  "div",
  {
    className: "fixed inset-0 bg-black/80 z-50 flex items-center justify-center transition-colors duration-300",
    onKeyDown: (r) => {
      r.key === "Escape" && t(!1);
    },
    children: /* @__PURE__ */ V("div", { className: "bg-transparent border-none shadow-none flex items-center justify-center px-4", children: [
      /* @__PURE__ */ y("div", { className: "relative", children: /* @__PURE__ */ y(
        "img",
        {
          src: n || "",
          alt: "Full size image",
          className: "h-auto object-contain max-h-[90vh] sm:max-w-[90vw] shadow-xs rounded-md"
        }
      ) }),
      /* @__PURE__ */ V("div", { className: "flex gap-2 absolute top-2 right-2", children: [
        /* @__PURE__ */ y(
          Qe,
          {
            size: "icon",
            variant: "accent",
            onClick: () => {
              const r = document.createElement("a");
              r.href = n || "", r.download = "image", document.body.appendChild(r), r.click(), document.body.removeChild(r);
            },
            children: /* @__PURE__ */ y(mz, { className: "h-4 w-4" })
          }
        ),
        /* @__PURE__ */ y(
          Qe,
          {
            size: "icon",
            variant: "accent",
            onClick: () => t(!1),
            children: /* @__PURE__ */ y(ks, { className: "h-4 w-4" })
          }
        )
      ] })
    ] })
  }
) : null);
var gG = "Avatar", [P2t, wmn] = Ms(gG), [I2t, jDe] = P2t(gG), FDe = N.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [i, o] = N.useState("idle");
    return /* @__PURE__ */ y(
      I2t,
      {
        scope: n,
        imageLoadingStatus: i,
        onImageLoadingStatusChange: o,
        children: /* @__PURE__ */ y(Zt.span, { ...r, ref: t })
      }
    );
  }
);
FDe.displayName = gG;
var UDe = "AvatarImage", VDe = N.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: i = () => {
    }, ...o } = e, s = jDe(UDe, n), l = R2t(r), c = ti((a) => {
      i(a), s.onImageLoadingStatusChange(a);
    });
    return qi(() => {
      l !== "idle" && c(l);
    }, [l, c]), l === "loaded" ? /* @__PURE__ */ y(Zt.img, { ...o, ref: t, src: r }) : null;
  }
);
VDe.displayName = UDe;
var qDe = "AvatarFallback", BDe = N.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...i } = e, o = jDe(qDe, n), [s, l] = N.useState(r === void 0);
    return N.useEffect(() => {
      if (r !== void 0) {
        const c = window.setTimeout(() => l(!0), r);
        return () => window.clearTimeout(c);
      }
    }, [r]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ y(Zt.span, { ...i, ref: t }) : null;
  }
);
BDe.displayName = qDe;
function R2t(e) {
  const [t, n] = N.useState("idle");
  return qi(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const i = new window.Image(), o = (s) => () => {
      r && n(s);
    };
    return n("loading"), i.onload = o("loaded"), i.onerror = o("error"), i.src = e, () => {
      r = !1;
    };
  }, [e]), t;
}
var XDe = FDe, WDe = VDe, ZDe = BDe;
const yG = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  XDe,
  {
    ref: n,
    className: Se(
      "relative flex h-7 w-7 rounded-full flex items-center justify-center bg-muted-foreground",
      e
    ),
    ...t
  }
));
yG.displayName = XDe.displayName;
const HDe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  WDe,
  {
    ref: n,
    className: Se("aspect-square h-full w-full", e),
    ...t
  }
));
HDe.displayName = WDe.displayName;
const QDe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  ZDe,
  {
    ref: n,
    className: Se(
      "flex h-full w-full items-center justify-center rounded-full  border-none",
      e
    ),
    ...t
  }
));
QDe.displayName = ZDe.displayName;
function M2t() {
  return /* @__PURE__ */ V(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-foreground",
      children: [
        /* @__PURE__ */ y("circle", { cx: "4", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ y(
          "animate",
          {
            id: "spinner_qFRN",
            begin: "0;spinner_OcgL.end+0.25s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ y("circle", { cx: "12", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ y(
          "animate",
          {
            begin: "spinner_qFRN.begin+0.1s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ y("circle", { cx: "20", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ y(
          "animate",
          {
            id: "spinner_OcgL",
            begin: "spinner_qFRN.begin+0.2s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) })
      ]
    }
  );
}
const D2t = as("flex gap-2 w-full items-start relative group", {
  variants: {
    variant: {
      received: "self-start",
      sent: "self-end flex-row-reverse"
    },
    layout: {
      default: "",
      ai: "max-w-full w-full items-center"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), m_ = N.forwardRef(
  ({ className: e, variant: t, layout: n, children: r, ...i }, o) => /* @__PURE__ */ y(
    "div",
    {
      className: Se(
        D2t({ variant: t, layout: n, className: e }),
        "relative group"
      ),
      ref: o,
      ...i,
      children: N.Children.map(
        r,
        (s) => N.isValidElement(s) && typeof s.type != "string" ? N.cloneElement(s, {
          variant: t,
          layout: n
        }) : s
      )
    }
  )
);
m_.displayName = "ChatBubble";
const S9 = ({
  src: e,
  fallback: t,
  className: n
}) => /* @__PURE__ */ V(yG, { children: [
  /* @__PURE__ */ y(
    HDe,
    {
      src: e,
      alt: "Avatar",
      className: Se("aspect-square p-2", n)
    }
  ),
  /* @__PURE__ */ y(QDe, { className: "bg-background border", children: t })
] }), _2t = as("px-1", {
  variants: {
    variant: {
      received: "bg-background text-foreground rounded-3xl py-2",
      sent: "bg-accent text-accent-foreground rounded-3xl py-3 px-5"
    },
    layout: {
      default: "",
      ai: "border-t w-full rounded-none bg-transparent"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), g_ = N.forwardRef(
  ({ className: e, variant: t, layout: n, isLoading: r = !1, children: i, ...o }, s) => /* @__PURE__ */ y(
    "div",
    {
      className: Se(
        _2t({ variant: t, layout: n, className: e }),
        "wrap-break-word max-w-full whitespace-pre-wrap overflow-x-auto"
      ),
      ref: s,
      ...o,
      children: r ? /* @__PURE__ */ y("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ y(M2t, {}) }) : i
    }
  )
);
g_.displayName = "ChatBubbleMessage";
const L2t = ({
  icon: e,
  onClick: t,
  className: n,
  variant: r = "ghost",
  size: i = "icon",
  ...o
}) => /* @__PURE__ */ y(
  Qe,
  {
    variant: r,
    size: i,
    className: n,
    onClick: t,
    ...o,
    children: e
  }
), z2t = ({
  content: e,
  mimeType: t,
  fileName: n,
  role: r
}) => {
  const i = t == null ? void 0 : t.startsWith("video/");
  return /* @__PURE__ */ y(
    "a",
    {
      className: "p-2 w-80 rounded-lg border px-2 max-w-full hover:bg-muted transition-colors cursor-pointer",
      href: e,
      download: n ?? "file",
      children: /* @__PURE__ */ V("div", { className: "flex flex-row items-center gap-2", children: [
        /* @__PURE__ */ y("div", { className: "relative h-10 w-10 shrink-0 overflow-hidden rounded-md", children: /* @__PURE__ */ y("div", { className: "h-full w-full flex items-center justify-center bg-foreground text-background", children: i ? /* @__PURE__ */ y(bst, { className: "h-5 w-5" }) : /* @__PURE__ */ y(KH, { className: "h-5 w-5" }) }) }),
        /* @__PURE__ */ V("div", { className: "overflow-hidden flex flex-col gap-1", children: [
          /* @__PURE__ */ y("div", { className: "truncate font-semibold text-sm leading-none", children: n ?? (r === "user" ? "Untitled File" : "Download File") }),
          n && /* @__PURE__ */ y("div", { className: "truncate text-sm text-token-text-tertiary leading-none", children: r === "user" ? "View File" : "Download File" })
        ] })
      ] })
    }
  );
}, j2t = ({
  src: e,
  alt: t,
  fallback: n,
  ...r
}) => {
  const [i, o] = He(!1), [s, l] = He(!0), c = () => {
    l(!1);
  }, a = () => {
    o(!0), l(!1);
  }, { className: u, ...f } = r;
  return /* @__PURE__ */ V("span", { className: Se("relative inline-block h-full w-full", u), children: [
    s && !i && /* @__PURE__ */ y("span", { className: "absolute inset-0 flex items-center justify-center", children: n ?? /* @__PURE__ */ y(Tr, { className: "w-full h-full" }) }),
    i ? /* @__PURE__ */ y("span", { className: "absolute inset-0 flex items-center justify-center", children: n ?? /* @__PURE__ */ y(Tr, { className: "w-full h-full" }) }) : /* @__PURE__ */ y(
      "img",
      {
        src: e,
        alt: t,
        onLoad: c,
        onError: a,
        className: Se(
          "transition-opacity duration-500 w-full h-full object-contain",
          {
            "opacity-0": s,
            "opacity-100": !s
          },
          u
        ),
        ...f
      }
    )
  ] });
}, F2t = ({
  content: e,
  setSelectedImage: t
}) => /* @__PURE__ */ y("div", { className: "w-fit", children: /* @__PURE__ */ V("div", { className: "relative group", children: [
  /* @__PURE__ */ y(
    j2t,
    {
      src: e,
      alt: "Received image",
      className: "w-80 h-auto rounded-md cursor-pointer",
      onClick: () => t(e)
    }
  ),
  /* @__PURE__ */ y(
    "button",
    {
      onClick: (n) => {
        n.stopPropagation();
        const r = document.createElement("a");
        r.href = e, r.download = "image", document.body.appendChild(r), r.click(), document.body.removeChild(r);
      },
      className: "absolute top-2 right-2 bg-black bg-opacity-50 rounded-full p-1 hover:bg-opacity-75 transition-opacity opacity-0 group-hover:opacity-100",
      children: /* @__PURE__ */ y(mz, { className: "h-4 w-4 text-white" })
    }
  )
] }) }), $De = 1024;
let U2t = 0, EU = class {
  constructor(t, n) {
    this.from = t, this.to = n;
  }
}, Gn = class {
  /**
  Create a new node prop type.
  */
  constructor(t = {}) {
    this.id = U2t++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(t) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = au.match(t)), (n) => {
      let r = t(n);
      return r === void 0 ? null : [this, r];
    };
  }
};
Gn.closedBy = new Gn({ deserialize: (e) => e.split(" ") });
Gn.openedBy = new Gn({ deserialize: (e) => e.split(" ") });
Gn.group = new Gn({ deserialize: (e) => e.split(" ") });
Gn.isolate = new Gn({ deserialize: (e) => {
  if (e && e != "rtl" && e != "ltr" && e != "auto")
    throw new RangeError("Invalid value for isolate: " + e);
  return e || "auto";
} });
Gn.contextHash = new Gn({ perNode: !0 });
Gn.lookAhead = new Gn({ perNode: !0 });
Gn.mounted = new Gn({ perNode: !0 });
class y_ {
  constructor(t, n, r) {
    this.tree = t, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(t) {
    return t && t.props && t.props[Gn.mounted.id];
  }
}
const V2t = /* @__PURE__ */ Object.create(null);
let au = class KDe {
  /**
  @internal
  */
  constructor(t, n, r, i = 0) {
    this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(t) {
    let n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : V2t, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new KDe(t.name || "", n, t.id, r);
    if (t.props) {
      for (let o of t.props)
        if (Array.isArray(o) || (o = o(i)), o) {
          if (o[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[o[0].id] = o[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(t) {
    return this.props[t.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      let n = this.prop(Gn.group);
      return n ? n.indexOf(t) > -1 : !1;
    }
    return this.id == t;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in t)
      for (let i of r.split(" "))
        n[i] = t[r];
    return (r) => {
      for (let i = r.prop(Gn.group), o = -1; o < (i ? i.length : 0); o++) {
        let s = n[o < 0 ? r.name : i[o]];
        if (s)
          return s;
      }
    };
  }
};
au.none = new au(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class vG {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(t) {
    this.types = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...t) {
    let n = [];
    for (let r of this.types) {
      let i = null;
      for (let o of t) {
        let s = o(r);
        s && (i || (i = Object.assign({}, r.props)), i[s[0].id] = s[1]);
      }
      n.push(i ? new au(r.name, i, r.id, r.flags) : r);
    }
    return new vG(n);
  }
}
const AI = /* @__PURE__ */ new WeakMap(), Sce = /* @__PURE__ */ new WeakMap();
var Do;
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Do || (Do = {}));
class go {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(t, n, r, i, o) {
    if (this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, l] of o)
        this.props[typeof s == "number" ? s : s.id] = l;
    }
  }
  /**
  @internal
  */
  toString() {
    let t = y_.get(this);
    if (t && !t.overlay)
      return t.tree.toString();
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(t = 0) {
    return new T9(this.topNode, t);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(t, n = 0, r = 0) {
    let i = AI.get(this) || this.topNode, o = new T9(i);
    return o.moveTo(t, n), AI.set(this, o._tree), o;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new bl(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(t, n = 0) {
    let r = lk(AI.get(this) || this.topNode, t, n, !1);
    return AI.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(t, n = 0) {
    let r = lk(Sce.get(this) || this.topNode, t, n, !0);
    return Sce.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(t, n = 0) {
    return X2t(this, t, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(t) {
    let { enter: n, leave: r, from: i = 0, to: o = this.length } = t, s = t.mode || 0, l = (s & Do.IncludeAnonymous) > 0;
    for (let c = this.cursor(s | Do.IncludeAnonymous); ; ) {
      let a = !1;
      if (c.from <= o && c.to >= i && (!l && c.type.isAnonymous || n(c) !== !1)) {
        if (c.firstChild())
          continue;
        a = !0;
      }
      for (; a && r && (l || !c.type.isAnonymous) && r(c), !c.nextSibling(); ) {
        if (!c.parent())
          return;
        a = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let t = [];
    if (this.props)
      for (let n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(t = {}) {
    return this.children.length <= 8 ? this : AG(au.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new go(this.type, n, r, i, this.propValues), t.makeTree || ((n, r, i) => new go(au.none, n, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(t) {
    return W2t(t);
  }
}
go.empty = new go(au.none, [], [], 0);
class bG {
  constructor(t, n) {
    this.buffer = t, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new bG(this.buffer, this.index);
  }
}
class lg {
  /**
  Create a tree buffer.
  */
  constructor(t, n, r) {
    this.buffer = t, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return au.none;
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    for (let n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  }
  /**
  @internal
  */
  childString(t) {
    let n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), t += 4, r == t)
      return o;
    let s = [];
    for (; t < r; )
      s.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(t, n, r, i, o) {
    let { buffer: s } = this, l = -1;
    for (let c = t; c != n && !(GDe(o, i, s[c + 1], s[c + 2]) && (l = c, r > 0)); c = s[c + 3])
      ;
    return l;
  }
  /**
  @internal
  */
  slice(t, n, r) {
    let i = this.buffer, o = new Uint16Array(n - t), s = 0;
    for (let l = t, c = 0; l < n; ) {
      o[c++] = i[l++], o[c++] = i[l++] - r;
      let a = o[c++] = i[l++] - r;
      o[c++] = i[l++] - t, s = Math.max(s, a);
    }
    return new lg(o, s, this.set);
  }
}
function GDe(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function lk(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    let s = !r && e instanceof bl && e.index < 0 ? null : e.parent;
    if (!s)
      return e;
    e = s;
  }
  let o = r ? 0 : Do.IgnoreOverlays;
  if (r)
    for (let s = e, l = s.parent; l; s = l, l = s.parent)
      s instanceof bl && s.index < 0 && ((i = l.enter(t, n, o)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = l);
  for (; ; ) {
    let s = e.enter(t, n, o);
    if (!s)
      return e;
    e = s;
  }
}
class YDe {
  cursor(t = 0) {
    return new T9(this, t);
  }
  getChild(t, n = null, r = null) {
    let i = Ece(this, t, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(t, n = null, r = null) {
    return Ece(this, t, n, r);
  }
  resolve(t, n = 0) {
    return lk(this, t, n, !1);
  }
  resolveInner(t, n = 0) {
    return lk(this, t, n, !0);
  }
  matchContext(t) {
    return E9(this.parent, t);
  }
  enterUnfinishedNodesBefore(t) {
    let n = this.childBefore(t), r = this;
    for (; n; ) {
      let i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class bl extends YDe {
  constructor(t, n, r, i) {
    super(), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(t, n, r, i, o = 0) {
    for (let s = this; ; ) {
      for (let { children: l, positions: c } = s._tree, a = n > 0 ? l.length : -1; t != a; t += n) {
        let u = l[t], f = c[t] + s.from;
        if (GDe(i, r, f, f + u.length)) {
          if (u instanceof lg) {
            if (o & Do.ExcludeBuffers)
              continue;
            let d = u.findChild(0, u.buffer.length, n, r - f, i);
            if (d > -1)
              return new lf(new q2t(s, u, t, f), null, d);
          } else if (o & Do.IncludeAnonymous || !u.type.isAnonymous || OG(u)) {
            let d;
            if (!(o & Do.IgnoreMounts) && (d = y_.get(u)) && !d.overlay)
              return new bl(d.tree, f, t, s);
            let p = new bl(u, f, t, s);
            return o & Do.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? u.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & Do.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? t = s.index + n : t = n < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.nextChild(
      0,
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, n, r = 0) {
    let i;
    if (!(r & Do.IgnoreOverlays) && (i = y_.get(this._tree)) && i.overlay) {
      let o = t - this.from;
      for (let { from: s, to: l } of i.overlay)
        if ((n > 0 ? s <= o : s < o) && (n < 0 ? l >= o : l > o))
          return new bl(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, t, n, r);
  }
  nextSignificantParent() {
    let t = this;
    for (; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function Ece(e, t, n, r) {
  let i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (let s = !1; !s; )
      if (s = i.type.is(n), !i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function E9(e, t, n = t.length - 1) {
  for (let r = e; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class q2t {
  constructor(t, n, r, i) {
    this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }
}
class lf extends YDe {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(t, n, r) {
    super(), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  child(t, n, r) {
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new lf(this.context, this, o);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.child(
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.child(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, n, r = 0) {
    if (r & Do.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new lf(this.context, this, o);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(t) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + t,
      t,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: t } = this.context, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new lf(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: t } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new lf(this.context, this._parent, t.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let t = [], n = [], { buffer: r } = this.context, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      let s = r.buffer[this.index + 1];
      t.push(r.slice(i, o, s)), n.push(0);
    }
    return new go(this.type, t, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function JDe(e) {
  if (!e.length)
    return null;
  let t = 0, n = e[0];
  for (let o = 1; o < e.length; o++) {
    let s = e[o];
    (s.from > n.from || s.to < n.to) && (n = s, t = o);
  }
  let r = n instanceof bl && n.index < 0 ? null : n.parent, i = e.slice();
  return r ? i[t] = r : i.splice(t, 1), new B2t(i, n);
}
class B2t {
  constructor(t, n) {
    this.heads = t, this.node = n;
  }
  get next() {
    return JDe(this.heads);
  }
}
function X2t(e, t, n) {
  let r = e.resolveInner(t, n), i = null;
  for (let o = r instanceof bl ? r : r.context.parent; o; o = o.parent)
    if (o.index < 0) {
      let s = o.parent;
      (i || (i = [r])).push(s.resolve(t, n)), o = s;
    } else {
      let s = y_.get(o.tree);
      if (s && s.overlay && s.overlay[0].from <= t && s.overlay[s.overlay.length - 1].to >= t) {
        let l = new bl(s.tree, s.overlay[0].from + o.from, -1, o);
        (i || (i = [r])).push(lk(l, t, n, !1));
      }
    }
  return i ? JDe(i) : r;
}
class T9 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(t, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof bl)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (let r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  yieldNode(t) {
    return t ? (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0) : !1;
  }
  yieldBuf(t, n) {
    this.index = t;
    let { start: r, buffer: i } = this.buffer;
    return this.type = n || i.set.types[i.buffer[t]], this.from = r + i.buffer[t + 1], this.to = r + i.buffer[t + 2], !0;
  }
  /**
  @internal
  */
  yield(t) {
    return t ? t instanceof bl ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    let { buffer: i } = this.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return o < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(o));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(t) {
    return this.enterChild(
      1,
      t,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(t) {
    return this.enterChild(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(t, n, r = this.mode) {
    return this.buffer ? r & Do.ExcludeBuffers ? !1 : this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Do.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let t = this.mode & Do.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  }
  /**
  @internal
  */
  sibling(t) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (t < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(t) {
    let n, r, { buffer: i } = this;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = i);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let o = n + t, s = t < 0 ? -1 : r._tree.children.length; o != s; o += t) {
          let l = r._tree.children[o];
          if (this.mode & Do.IncludeAnonymous || l instanceof lg || !l.type.isAnonymous || OG(l))
            return !1;
        }
    return !0;
  }
  move(t, n) {
    if (n && this.enterChild(
      t,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(t = !0) {
    return this.move(1, t);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(t = !0) {
    return this.move(-1, t);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(t, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      e: for (let i = this.index, o = this.stack.length; o >= 0; ) {
        for (let s = t; s; s = s._parent)
          if (s.index == i) {
            if (i == this.index)
              return s;
            n = s, r = o + 1;
            break e;
          }
        i = this.stack[--o];
      }
    for (let i = r; i < this.stack.length; i++)
      n = new lf(this.buffer, n, this.stack[i]);
    return this.bufferNode = new lf(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(t, n) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; ; ) {
        if (i && n && n(this), i = this.type.isAnonymous, !r)
          return;
        if (this.nextSibling())
          break;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(t) {
    if (!this.buffer)
      return E9(this.node.parent, t);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return E9(this._tree, t, i);
      let s = r[n.buffer[this.stack[o]]];
      if (!s.isAnonymous) {
        if (t[i] && t[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function OG(e) {
  return e.children.some((t) => t instanceof lg || !t.type.isAnonymous || OG(t));
}
function W2t(e) {
  var t;
  let { buffer: n, nodeSet: r, maxBufferLength: i = $De, reused: o = [], minRepeatType: s = r.types.length } = e, l = Array.isArray(n) ? new bG(n, n.length) : n, c = r.types, a = 0, u = 0;
  function f(x, S, E, k, T, R) {
    let { id: j, start: F, end: L, size: _ } = l, U = u, z = a;
    for (; _ < 0; )
      if (l.next(), _ == -1) {
        let X = o[j];
        E.push(X), k.push(F - x);
        return;
      } else if (_ == -3) {
        a = j;
        return;
      } else if (_ == -4) {
        u = j;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${_}`);
    let C = c[j], I, M, D = F - x;
    if (L - F <= i && (M = v(l.pos - S, T))) {
      let X = new Uint16Array(M.size - M.skip), B = l.pos - M.size, q = X.length;
      for (; l.pos > B; )
        q = b(M.start, X, q);
      I = new lg(X, L - M.start, r), D = M.start - x;
    } else {
      let X = l.pos - _;
      l.next();
      let B = [], q = [], H = j >= s ? j : -1, Y = 0, J = L;
      for (; l.pos > X; )
        H >= 0 && l.id == H && l.size >= 0 ? (l.end <= J - i && (h(B, q, F, Y, l.end, J, H, U, z), Y = B.length, J = l.end), l.next()) : R > 2500 ? d(F, X, B, q) : f(F, X, B, q, H, R + 1);
      if (H >= 0 && Y > 0 && Y < B.length && h(B, q, F, Y, F, J, H, U, z), B.reverse(), q.reverse(), H > -1 && Y > 0) {
        let oe = p(C, z);
        I = AG(C, B, q, 0, B.length, 0, L - F, oe, oe);
      } else
        I = m(C, B, q, L - F, U - L, z);
    }
    E.push(I), k.push(D);
  }
  function d(x, S, E, k) {
    let T = [], R = 0, j = -1;
    for (; l.pos > S; ) {
      let { id: F, start: L, end: _, size: U } = l;
      if (U > 4)
        l.next();
      else {
        if (j > -1 && L < j)
          break;
        j < 0 && (j = _ - i), T.push(F, L, _), R++, l.next();
      }
    }
    if (R) {
      let F = new Uint16Array(R * 4), L = T[T.length - 2];
      for (let _ = T.length - 3, U = 0; _ >= 0; _ -= 3)
        F[U++] = T[_], F[U++] = T[_ + 1] - L, F[U++] = T[_ + 2] - L, F[U++] = U;
      E.push(new lg(F, T[2] - L, r)), k.push(L - x);
    }
  }
  function p(x, S) {
    return (E, k, T) => {
      let R = 0, j = E.length - 1, F, L;
      if (j >= 0 && (F = E[j]) instanceof go) {
        if (!j && F.type == x && F.length == T)
          return F;
        (L = F.prop(Gn.lookAhead)) && (R = k[j] + F.length + L);
      }
      return m(x, E, k, T, R, S);
    };
  }
  function h(x, S, E, k, T, R, j, F, L) {
    let _ = [], U = [];
    for (; x.length > k; )
      _.push(x.pop()), U.push(S.pop() + E - T);
    x.push(m(r.types[j], _, U, R - T, F - R, L)), S.push(T - E);
  }
  function m(x, S, E, k, T, R, j) {
    if (R) {
      let F = [Gn.contextHash, R];
      j = j ? [F].concat(j) : [F];
    }
    if (T > 25) {
      let F = [Gn.lookAhead, T];
      j = j ? [F].concat(j) : [F];
    }
    return new go(x, S, E, k, j);
  }
  function v(x, S) {
    let E = l.fork(), k = 0, T = 0, R = 0, j = E.end - i, F = { size: 0, start: 0, skip: 0 };
    e: for (let L = E.pos - x; E.pos > L; ) {
      let _ = E.size;
      if (E.id == S && _ >= 0) {
        F.size = k, F.start = T, F.skip = R, R += 4, k += 4, E.next();
        continue;
      }
      let U = E.pos - _;
      if (_ < 0 || U < L || E.start < j)
        break;
      let z = E.id >= s ? 4 : 0, C = E.start;
      for (E.next(); E.pos > U; ) {
        if (E.size < 0)
          if (E.size == -3)
            z += 4;
          else
            break e;
        else E.id >= s && (z += 4);
        E.next();
      }
      T = C, k += _, R += z;
    }
    return (S < 0 || k == x) && (F.size = k, F.start = T, F.skip = R), F.size > 4 ? F : void 0;
  }
  function b(x, S, E) {
    let { id: k, start: T, end: R, size: j } = l;
    if (l.next(), j >= 0 && k < s) {
      let F = E;
      if (j > 4) {
        let L = l.pos - (j - 4);
        for (; l.pos > L; )
          E = b(x, S, E);
      }
      S[--E] = F, S[--E] = R - x, S[--E] = T - x, S[--E] = k;
    } else j == -3 ? a = k : j == -4 && (u = k);
    return E;
  }
  let A = [], w = [];
  for (; l.pos > 0; )
    f(e.start || 0, e.bufferStart || 0, A, w, -1, 0);
  let O = (t = e.length) !== null && t !== void 0 ? t : A.length ? w[0] + A[0].length : 0;
  return new go(c[e.topID], A.reverse(), w.reverse(), O);
}
const Tce = /* @__PURE__ */ new WeakMap();
function lM(e, t) {
  if (!e.isAnonymous || t instanceof lg || t.type != e)
    return 1;
  let n = Tce.get(t);
  if (n == null) {
    n = 1;
    for (let r of t.children) {
      if (r.type != e || !(r instanceof go)) {
        n = 1;
        break;
      }
      n += lM(e, r);
    }
    Tce.set(t, n);
  }
  return n;
}
function AG(e, t, n, r, i, o, s, l, c) {
  let a = 0;
  for (let h = r; h < i; h++)
    a += lM(e, t[h]);
  let u = Math.ceil(
    a * 1.5 / 8
    /* Balance.BranchFactor */
  ), f = [], d = [];
  function p(h, m, v, b, A) {
    for (let w = v; w < b; ) {
      let O = w, x = m[w], S = lM(e, h[w]);
      for (w++; w < b; w++) {
        let E = lM(e, h[w]);
        if (S + E >= u)
          break;
        S += E;
      }
      if (w == O + 1) {
        if (S > u) {
          let E = h[O];
          p(E.children, E.positions, 0, E.children.length, m[O] + A);
          continue;
        }
        f.push(h[O]);
      } else {
        let E = m[w - 1] + h[w - 1].length - x;
        f.push(AG(e, h, m, O, w, x, E, null, c));
      }
      d.push(x + A - o);
    }
  }
  return p(t, n, r, i, 0), (l || c)(f, d, s);
}
class Z2t {
  constructor() {
    this.map = /* @__PURE__ */ new WeakMap();
  }
  setBuffer(t, n, r) {
    let i = this.map.get(t);
    i || this.map.set(t, i = /* @__PURE__ */ new Map()), i.set(n, r);
  }
  getBuffer(t, n) {
    let r = this.map.get(t);
    return r && r.get(n);
  }
  /**
  Set the value for this syntax node.
  */
  set(t, n) {
    t instanceof lf ? this.setBuffer(t.context.buffer, t.index, n) : t instanceof bl && this.map.set(t.tree, n);
  }
  /**
  Retrieve value for this syntax node, if it exists in the map.
  */
  get(t) {
    return t instanceof lf ? this.getBuffer(t.context.buffer, t.index) : t instanceof bl ? this.map.get(t.tree) : void 0;
  }
  /**
  Set the value for the node that a cursor currently points to.
  */
  cursorSet(t, n) {
    t.buffer ? this.setBuffer(t.buffer.buffer, t.index, n) : this.map.set(t.tree, n);
  }
  /**
  Retrieve the value for the node that a cursor currently points
  to.
  */
  cursorGet(t) {
    return t.buffer ? this.getBuffer(t.buffer.buffer, t.index) : this.map.get(t.tree);
  }
}
class pv {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(t, n, r, i, o = !1, s = !1) {
    this.from = t, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(t, n = [], r = !1) {
    let i = [new pv(0, t.length, t, 0, !1, r)];
    for (let o of n)
      o.to > t.length && i.push(o);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(t, n, r = 128) {
    if (!n.length)
      return t;
    let i = [], o = 1, s = t.length ? t[0] : null;
    for (let l = 0, c = 0, a = 0; ; l++) {
      let u = l < n.length ? n[l] : null, f = u ? u.fromA : 1e9;
      if (f - c >= r)
        for (; s && s.from < f; ) {
          let d = s;
          if (c >= d.from || f <= d.to || a) {
            let p = Math.max(d.from, c) - a, h = Math.min(d.to, f) - a;
            d = p >= h ? null : new pv(p, h, d.tree, d.offset + a, l > 0, !!u);
          }
          if (d && i.push(d), s.to > f)
            break;
          s = o < t.length ? t[o++] : null;
        }
      if (!u)
        break;
      c = u.toA, a = u.toA - u.toB;
    }
    return i;
  }
}
class e_e {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(t, n, r) {
    return typeof t == "string" && (t = new H2t(t)), r = r ? r.length ? r.map((i) => new EU(i.from, i.to)) : [new EU(0, 0)] : [new EU(0, t.length)], this.createParse(t, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(t, n, r) {
    let i = this.startParse(t, n, r);
    for (; ; ) {
      let o = i.advance();
      if (o)
        return o;
    }
  }
}
class H2t {
  constructor(t) {
    this.string = t;
  }
  get length() {
    return this.string.length;
  }
  chunk(t) {
    return this.string.slice(t);
  }
  get lineChunks() {
    return !1;
  }
  read(t, n) {
    return this.string.slice(t, n);
  }
}
new Gn({ perNode: !0 });
class v_ {
  /**
  @internal
  */
  constructor(t, n, r, i, o, s, l, c, a, u = 0, f) {
    this.p = t, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = s, this.buffer = l, this.bufferBase = c, this.curContext = a, this.lookAhead = u, this.parent = f;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((t, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(t, n, r = 0) {
    let i = t.parser.context;
    return new v_(t, [], n, r, r, 0, [], 0, i ? new kce(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(t, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = t;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(t) {
    var n;
    let r = t >> 19, i = t & 65535, { parser: o } = this.p, s = this.reducePos < this.pos - 25;
    s && this.setLookAhead(this.pos);
    let l = o.dynamicPrecedence(i);
    if (l && (this.score += l), r == 0) {
      this.pushState(o.getGoto(this.state, i, !0), this.reducePos), i < o.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, s ? 8 : 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let c = this.stack.length - (r - 1) * 3 - (t & 262144 ? 6 : 0), a = c ? this.stack[c - 2] : this.p.ranges[0].from, u = this.reducePos - a;
    u >= 2e3 && !(!((n = this.p.parser.nodeSet.types[i]) === null || n === void 0) && n.isAnonymous) && (a == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = u) : this.p.lastBigReductionSize < u && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = a, this.p.lastBigReductionSize = u));
    let f = c ? this.stack[c - 1] : 0, d = this.bufferBase + this.buffer.length - f;
    if (i < o.minRepeatTerm || t & 131072) {
      let p = o.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, a, p, d + 4, !0);
    }
    if (t & 262144)
      this.state = this.stack[c];
    else {
      let p = this.stack[c - 3];
      this.state = o.getGoto(p, i, !0);
    }
    for (; this.stack.length > c; )
      this.stack.pop();
    this.reduceContext(i, a);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(t, n, r, i = 4, o = !1) {
    if (t == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let s = this, l = this.buffer.length;
      if (l == 0 && s.parent && (l = s.bufferBase - s.parent.bufferBase, s = s.parent), l > 0 && s.buffer[l - 4] == 0 && s.buffer[l - 1] > -1) {
        if (n == r)
          return;
        if (s.buffer[l - 2] >= n) {
          s.buffer[l - 2] = r;
          return;
        }
      }
    }
    if (!o || this.pos == r)
      this.buffer.push(t, n, r, i);
    else {
      let s = this.buffer.length;
      if (s > 0 && this.buffer[s - 4] != 0) {
        let l = !1;
        for (let c = s; c > 0 && this.buffer[c - 2] > r; c -= 4)
          if (this.buffer[c - 1] >= 0) {
            l = !0;
            break;
          }
        if (l)
          for (; s > 0 && this.buffer[s - 2] > r; )
            this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, i > 4 && (i -= 4);
      }
      this.buffer[s] = t, this.buffer[s + 1] = n, this.buffer[s + 2] = r, this.buffer[s + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(t, n, r, i) {
    if (t & 131072)
      this.pushState(t & 65535, this.pos);
    else if ((t & 262144) == 0) {
      let o = t, { parser: s } = this.p;
      (i > this.pos || n <= s.maxNode) && (this.pos = i, s.stateFlag(
        o,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(o, r), this.shiftContext(n, r), n <= s.maxNode && this.buffer.push(n, r, i, 4);
    } else
      this.pos = i, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, i, 4);
  }
  // Apply an action
  /**
  @internal
  */
  apply(t, n, r, i) {
    t & 65536 ? this.reduce(t) : this.shift(t, n, r, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(t, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != t) && (this.p.reused.push(t), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + t.length, this.pushState(n, i), this.buffer.push(
      r,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t, this, this.p.stream.reset(this.pos - t.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let t = this, n = t.buffer.length;
    for (; n > 0 && t.buffer[n - 2] > t.reducePos; )
      n -= 4;
    let r = t.buffer.slice(n), i = t.bufferBase + n;
    for (; t && i == t.bufferBase; )
      t = t.parent;
    return new v_(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, t);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(t, n) {
    let r = t <= this.p.parser.maxNode;
    r && this.storeNode(t, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(t) {
    for (let n = new Q2t(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, t);
      if (r == 0)
        return !1;
      if ((r & 65536) == 0)
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(t) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let o = 0, s; o < n.length; o += 2)
        (s = n[o + 1]) != this.state && this.p.parser.hasAction(s, t) && i.push(n[o], s);
      if (this.stack.length < 120)
        for (let o = 0; i.length < 8 && o < n.length; o += 2) {
          let s = n[o + 1];
          i.some((l, c) => c & 1 && l == s) || i.push(n[o], s);
        }
      n = i;
    }
    let r = [];
    for (let i = 0; i < n.length && r.length < 4; i += 2) {
      let o = n[i + 1];
      if (o == this.state)
        continue;
      let s = this.split();
      s.pushState(o, this.pos), s.storeNode(0, s.pos, s.pos, 4, !0), s.shiftContext(n[i], this.pos), s.reducePos = this.pos, s.score -= 200, r.push(s);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: t } = this.p, n = t.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((n & 65536) == 0)
      return !1;
    if (!t.validAction(this.state, n)) {
      let r = n >> 19, i = n & 65535, o = this.stack.length - r * 3;
      if (o < 0 || t.getGoto(this.stack[o], i, !1) < 0) {
        let s = this.findForcedReduction();
        if (s == null)
          return !1;
        n = s;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: t } = this.p, n = [], r = (i, o) => {
      if (!n.includes(i))
        return n.push(i), t.allActions(i, (s) => {
          if (!(s & 393216)) if (s & 65536) {
            let l = (s >> 19) - o;
            if (l > 1) {
              let c = s & 65535, a = this.stack.length - l * 3;
              if (a >= 0 && t.getGoto(this.stack[a], c, !1) >= 0)
                return l << 19 | 65536 | c;
            }
          } else {
            let l = r(s, o + 1);
            if (l != null)
              return l;
          }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: t } = this.p;
    return t.data[t.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !t.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(t) {
    if (this.state != t.state || this.stack.length != t.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != t.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(t) {
    return this.p.parser.dialect.flags[t];
  }
  shiftContext(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t, this, this.p.stream.reset(n)));
  }
  reduceContext(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(t) {
    if (t != this.curContext.context) {
      let n = new kce(this.curContext.tracker, t);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(t) {
    t > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class kce {
  constructor(t, n) {
    this.tracker = t, this.context = n, this.hash = t.strict ? t.hash(n) : 0;
  }
}
class Q2t {
  constructor(t) {
    this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
  }
  reduce(t) {
    let n = t & 65535, r = t >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  }
}
class b_ {
  constructor(t, n, r) {
    this.stack = t, this.pos = n, this.index = r, this.buffer = t.buffer, this.index == 0 && this.maybeNext();
  }
  static create(t, n = t.bufferBase + t.buffer.length) {
    return new b_(t, n, n - t.bufferBase);
  }
  maybeNext() {
    let t = this.stack.parent;
    t != null && (this.index = this.stack.bufferBase - t.bufferBase, this.stack = t, this.buffer = t.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new b_(this.stack, this.pos, this.index);
  }
}
function m1(e, t = Uint16Array) {
  if (typeof e != "string")
    return e;
  let n = null;
  for (let r = 0, i = 0; r < e.length; ) {
    let o = 0;
    for (; ; ) {
      let s = e.charCodeAt(r++), l = !1;
      if (s == 126) {
        o = 65535;
        break;
      }
      s >= 92 && s--, s >= 34 && s--;
      let c = s - 32;
      if (c >= 46 && (c -= 46, l = !0), o += c, l)
        break;
      o *= 46;
    }
    n ? n[i++] = o : n = new t(o);
  }
  return n;
}
class cM {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const Cce = new cM();
class $2t {
  /**
  @internal
  */
  constructor(t, n) {
    this.input = t, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = Cce, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(t, n) {
    let r = this.range, i = this.rangeIndex, o = this.pos + t;
    for (; o < r.from; ) {
      if (!i)
        return null;
      let s = this.ranges[--i];
      o -= r.from - s.to, r = s;
    }
    for (; n < 0 ? o > r.to : o >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let s = this.ranges[++i];
      o += s.from - r.to, r = s;
    }
    return o;
  }
  /**
  @internal
  */
  clipPos(t) {
    if (t >= this.range.from && t < this.range.to)
      return t;
    for (let n of this.ranges)
      if (n.to > t)
        return Math.max(t, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(t) {
    let n = this.chunkOff + t, r, i;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + t, i = this.chunk.charCodeAt(n);
    else {
      let o = this.resolveOffset(t, 1);
      if (o == null)
        return -1;
      if (r = o, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let s = this.rangeIndex, l = this.range;
        for (; l.to <= r; )
          l = this.ranges[++s];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > l.to && (this.chunk2 = this.chunk2.slice(0, l.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(t, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(t, n) {
    this.token.value = t, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: t, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let t = this.input.chunk(this.pos), n = this.pos + t.length;
      this.chunk = n > this.range.to ? t.slice(0, this.range.to - this.pos) : t, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(t = 1) {
    for (this.chunkOff += t; this.pos + t >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(t, n) {
    if (n ? (this.token = n, n.start = t, n.lookAhead = t + 1, n.value = n.extended = -1) : this.token = Cce, this.pos != t) {
      if (this.pos = t, t == this.end)
        return this.setDone(), this;
      for (; t < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t >= this.chunkPos && t < this.chunkPos + this.chunk.length ? this.chunkOff = t - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(t, n) {
    if (t >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t - this.chunkPos, n - this.chunkPos);
    if (t >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t - this.chunk2Pos, n - this.chunk2Pos);
    if (t >= this.range.from && n <= this.range.to)
      return this.input.read(t, n);
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= n)
        break;
      i.to > t && (r += this.input.read(Math.max(i.from, t), Math.min(i.to, n)));
    }
    return r;
  }
}
class eA {
  constructor(t, n) {
    this.data = t, this.id = n;
  }
  token(t, n) {
    let { parser: r } = n.p;
    t_e(this.data, t, n, this.id, r.data, r.tokenPrecTable);
  }
}
eA.prototype.contextual = eA.prototype.fallback = eA.prototype.extend = !1;
class k9 {
  constructor(t, n, r) {
    this.precTable = n, this.elseToken = r, this.data = typeof t == "string" ? m1(t) : t;
  }
  token(t, n) {
    let r = t.pos, i = 0;
    for (; ; ) {
      let o = t.next < 0, s = t.resolveOffset(1, 1);
      if (t_e(this.data, t, n, 0, this.data, this.precTable), t.token.value > -1)
        break;
      if (this.elseToken == null)
        return;
      if (o || i++, s == null)
        break;
      t.reset(s, t.token);
    }
    i && (t.reset(r, t.token), t.acceptToken(this.elseToken, i));
  }
}
k9.prototype.contextual = eA.prototype.fallback = eA.prototype.extend = !1;
class SN {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(t, n = {}) {
    this.token = t, this.contextual = !!n.contextual, this.fallback = !!n.fallback, this.extend = !!n.extend;
  }
}
function t_e(e, t, n, r, i, o) {
  let s = 0, l = 1 << r, { dialect: c } = n.p.parser;
  e: for (; (l & e[s]) != 0; ) {
    let a = e[s + 1];
    for (let p = s + 3; p < a; p += 2)
      if ((e[p + 1] & l) > 0) {
        let h = e[p];
        if (c.allows(h) && (t.token.value == -1 || t.token.value == h || K2t(h, t.token.value, i, o))) {
          t.acceptToken(h);
          break;
        }
      }
    let u = t.next, f = 0, d = e[s + 2];
    if (t.next < 0 && d > f && e[a + d * 3 - 3] == 65535) {
      s = e[a + d * 3 - 1];
      continue e;
    }
    for (; f < d; ) {
      let p = f + d >> 1, h = a + p + (p << 1), m = e[h], v = e[h + 1] || 65536;
      if (u < m)
        d = p;
      else if (u >= v)
        f = p + 1;
      else {
        s = e[h + 2], t.advance();
        continue e;
      }
    }
    break;
  }
}
function Nce(e, t, n) {
  for (let r = t, i; (i = e[r]) != 65535; r++)
    if (i == n)
      return r - t;
  return -1;
}
function K2t(e, t, n, r) {
  let i = Nce(n, r, t);
  return i < 0 || Nce(n, r, e) < i;
}
const Ml = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let TU = null;
function Pce(e, t, n) {
  let r = e.cursor(Do.IncludeAnonymous);
  for (r.moveTo(t); ; )
    if (!(n < 0 ? r.childBefore(t) : r.childAfter(t)))
      for (; ; ) {
        if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            t - 25
            /* Lookahead.Margin */
          )) : Math.min(e.length, Math.max(
            r.from + 1,
            t + 25
            /* Lookahead.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : e.length;
      }
}
class G2t {
  constructor(t, n) {
    this.fragments = t, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let t = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t) {
      for (this.safeFrom = t.openStart ? Pce(t.tree, t.from + t.offset, 1) - t.offset : t.from, this.safeTo = t.openEnd ? Pce(t.tree, t.to + t.offset, -1) - t.offset : t.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t.tree), this.start.push(-t.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(t) {
    if (t < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], i = this.index[n];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let o = r.children[i], s = this.start[n] + r.positions[i];
      if (s > t)
        return this.nextStart = s, null;
      if (o instanceof go) {
        if (s == t) {
          if (s < this.safeFrom)
            return null;
          let l = s + o.length;
          if (l <= this.safeTo) {
            let c = o.prop(Gn.lookAhead);
            if (!c || l + c < this.fragment.to)
              return o;
          }
        }
        this.index[n]++, s + o.length >= Math.max(this.safeFrom, t) && (this.trees.push(o), this.start.push(s), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = s + o.length;
    }
  }
}
class Y2t {
  constructor(t, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map((r) => new cM());
  }
  getActions(t) {
    let n = 0, r = null, { parser: i } = t.p, { tokenizers: o } = i, s = i.stateSlot(
      t.state,
      3
      /* ParseState.TokenizerMask */
    ), l = t.curContext ? t.curContext.hash : 0, c = 0;
    for (let a = 0; a < o.length; a++) {
      if ((1 << a & s) == 0)
        continue;
      let u = o[a], f = this.tokens[a];
      if (!(r && !u.fallback) && ((u.contextual || f.start != t.pos || f.mask != s || f.context != l) && (this.updateCachedToken(f, u, t), f.mask = s, f.context = l), f.lookAhead > f.end + 25 && (c = Math.max(f.lookAhead, c)), f.value != 0)) {
        let d = n;
        if (f.extended > -1 && (n = this.addActions(t, f.extended, f.end, n)), n = this.addActions(t, f.value, f.end, n), !u.extend && (r = f, n > d))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return c && t.setLookAhead(c), !r && t.pos == this.stream.end && (r = new cM(), r.value = t.p.parser.eofTerm, r.start = r.end = t.pos, n = this.addActions(t, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(t) {
    if (this.mainToken)
      return this.mainToken;
    let n = new cM(), { pos: r, p: i } = t;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  }
  updateCachedToken(t, n, r) {
    let i = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(i, t), r), t.value > -1) {
      let { parser: o } = r.p;
      for (let s = 0; s < o.specialized.length; s++)
        if (o.specialized[s] == t.value) {
          let l = o.specializers[s](this.stream.read(t.start, t.end), r);
          if (l >= 0 && r.p.parser.dialect.allows(l >> 1)) {
            (l & 1) == 0 ? t.value = l >> 1 : t.extended = l >> 1;
            break;
          }
        }
    } else
      t.value = 0, t.end = this.stream.clipPos(i + 1);
  }
  putAction(t, n, r, i) {
    for (let o = 0; o < i; o += 3)
      if (this.actions[o] == t)
        return i;
    return this.actions[i++] = t, this.actions[i++] = n, this.actions[i++] = r, i;
  }
  addActions(t, n, r, i) {
    let { state: o } = t, { parser: s } = t.p, { data: l } = s;
    for (let c = 0; c < 2; c++)
      for (let a = s.stateSlot(
        o,
        c ? 2 : 1
        /* ParseState.Actions */
      ); ; a += 3) {
        if (l[a] == 65535)
          if (l[a + 1] == 1)
            a = kp(l, a + 2);
          else {
            i == 0 && l[a + 1] == 2 && (i = this.putAction(kp(l, a + 2), n, r, i));
            break;
          }
        l[a] == n && (i = this.putAction(kp(l, a + 1), n, r, i));
      }
    return i;
  }
}
class J2t {
  constructor(t, n, r, i) {
    this.parser = t, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new $2t(n, i), this.tokens = new Y2t(t, this.stream), this.topTerm = t.top[1];
    let { from: o } = i[0];
    this.stacks = [v_.start(this, t.top[0], o)], this.fragments = r.length && this.stream.end - o > t.bufferLength * 4 ? new G2t(r, t.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let t = this.stacks, n = this.minStackPos, r = this.stacks = [], i, o;
    if (this.bigReductionCount > 300 && t.length == 1) {
      let [s] = t;
      for (; s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let s = 0; s < t.length; s++) {
      let l = t[s];
      for (; ; ) {
        if (this.tokens.mainToken = null, l.pos > n)
          r.push(l);
        else {
          if (this.advanceStack(l, r, t))
            continue;
          {
            i || (i = [], o = []), i.push(l);
            let c = this.tokens.getMainToken(l);
            o.push(c.value, c.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let s = i && nzt(i);
      if (s)
        return Ml && console.log("Finish with " + this.stackID(s)), this.stackToTree(s);
      if (this.parser.strict)
        throw Ml && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let s = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, o, r);
      if (s)
        return Ml && console.log("Force-finish " + this.stackID(s)), this.stackToTree(s.forceAll());
    }
    if (this.recovering) {
      let s = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > s)
        for (r.sort((l, c) => c.score - l.score); r.length > s; )
          r.pop();
      r.some((l) => l.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let s = 0; s < r.length - 1; s++) {
        let l = r[s];
        for (let c = s + 1; c < r.length; c++) {
          let a = r[c];
          if (l.sameState(a) || l.buffer.length > 500 && a.buffer.length > 500)
            if ((l.score - a.score || l.buffer.length - a.buffer.length) > 0)
              r.splice(c--, 1);
            else {
              r.splice(s--, 1);
              continue e;
            }
        }
      }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let s = 1; s < r.length; s++)
      r[s].pos < this.minStackPos && (this.minStackPos = r[s].pos);
    return null;
  }
  stopAt(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(t, n, r) {
    let i = t.pos, { parser: o } = this, s = Ml ? this.stackID(t) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return t.forceReduce() ? t : null;
    if (this.fragments) {
      let a = t.curContext && t.curContext.tracker.strict, u = a ? t.curContext.hash : 0;
      for (let f = this.fragments.nodeAt(i); f; ) {
        let d = this.parser.nodeSet.types[f.type.id] == f.type ? o.getGoto(t.state, f.type.id) : -1;
        if (d > -1 && f.length && (!a || (f.prop(Gn.contextHash) || 0) == u))
          return t.useNode(f, d), Ml && console.log(s + this.stackID(t) + ` (via reuse of ${o.getName(f.type.id)})`), !0;
        if (!(f instanceof go) || f.children.length == 0 || f.positions[0] > 0)
          break;
        let p = f.children[0];
        if (p instanceof go && f.positions[0] == 0)
          f = p;
        else
          break;
      }
    }
    let l = o.stateSlot(
      t.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (l > 0)
      return t.reduce(l), Ml && console.log(s + this.stackID(t) + ` (via always-reduce ${o.getName(
        l & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (t.stack.length >= 8400)
      for (; t.stack.length > 6e3 && t.forceReduce(); )
        ;
    let c = this.tokens.getActions(t);
    for (let a = 0; a < c.length; ) {
      let u = c[a++], f = c[a++], d = c[a++], p = a == c.length || !r, h = p ? t : t.split(), m = this.tokens.mainToken;
      if (h.apply(u, f, m ? m.start : h.pos, d), Ml && console.log(s + this.stackID(h) + ` (via ${(u & 65536) == 0 ? "shift" : `reduce of ${o.getName(
        u & 65535
        /* Action.ValueMask */
      )}`} for ${o.getName(f)} @ ${i}${h == t ? "" : ", split"})`), p)
        return !0;
      h.pos > i ? n.push(h) : r.push(h);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(t, n) {
    let r = t.pos;
    for (; ; ) {
      if (!this.advanceStack(t, null, null))
        return !1;
      if (t.pos > r)
        return Ice(t, n), !0;
    }
  }
  runRecovery(t, n, r) {
    let i = null, o = !1;
    for (let s = 0; s < t.length; s++) {
      let l = t[s], c = n[s << 1], a = n[(s << 1) + 1], u = Ml ? this.stackID(l) + " -> " : "";
      if (l.deadEnd && (o || (o = !0, l.restart(), Ml && console.log(u + this.stackID(l) + " (restarted)"), this.advanceFully(l, r))))
        continue;
      let f = l.split(), d = u;
      for (let p = 0; f.forceReduce() && p < 10 && (Ml && console.log(d + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, r)); p++)
        Ml && (d = this.stackID(f) + " -> ");
      for (let p of l.recoverByInsert(c))
        Ml && console.log(u + this.stackID(p) + " (via recover-insert)"), this.advanceFully(p, r);
      this.stream.end > l.pos ? (a == l.pos && (a++, c = 0), l.recoverByDelete(c, a), Ml && console.log(u + this.stackID(l) + ` (via recover-delete ${this.parser.getName(c)})`), Ice(l, r)) : (!i || i.score < l.score) && (i = l);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(t) {
    return t.close(), go.build({
      buffer: b_.create(t),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: t.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(t) {
    let n = (TU || (TU = /* @__PURE__ */ new WeakMap())).get(t);
    return n || TU.set(t, n = String.fromCodePoint(this.nextStackID++)), n + t;
  }
}
function Ice(e, t) {
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    if (r.pos == e.pos && r.sameState(e)) {
      t[n].score < e.score && (t[n] = e);
      return;
    }
  }
  t.push(e);
}
class ezt {
  constructor(t, n, r) {
    this.source = t, this.flags = n, this.disabled = r;
  }
  allows(t) {
    return !this.disabled || this.disabled[t] == 0;
  }
}
const kU = (e) => e;
class tzt {
  /**
  Define a context tracker.
  */
  constructor(t) {
    this.start = t.start, this.shift = t.shift || kU, this.reduce = t.reduce || kU, this.reuse = t.reuse || kU, this.hash = t.hash || (() => 0), this.strict = t.strict !== !1;
  }
}
class ck extends e_e {
  /**
  @internal
  */
  constructor(t) {
    if (super(), this.wrappers = [], t.version != 14)
      throw new RangeError(`Parser version (${t.version}) doesn't match runtime version (14)`);
    let n = t.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let l = 0; l < t.repeatNodeCount; l++)
      n.push("");
    let r = Object.keys(t.topRules).map((l) => t.topRules[l][1]), i = [];
    for (let l = 0; l < n.length; l++)
      i.push([]);
    function o(l, c, a) {
      i[l].push([c, c.deserialize(String(a))]);
    }
    if (t.nodeProps)
      for (let l of t.nodeProps) {
        let c = l[0];
        typeof c == "string" && (c = Gn[c]);
        for (let a = 1; a < l.length; ) {
          let u = l[a++];
          if (u >= 0)
            o(u, c, l[a++]);
          else {
            let f = l[a + -u];
            for (let d = -u; d > 0; d--)
              o(l[a++], c, f);
            a++;
          }
        }
      }
    this.nodeSet = new vG(n.map((l, c) => au.define({
      name: c >= this.minRepeatTerm ? void 0 : l,
      id: c,
      props: i[c],
      top: r.indexOf(c) > -1,
      error: c == 0,
      skipped: t.skippedNodes && t.skippedNodes.indexOf(c) > -1
    }))), t.propSources && (this.nodeSet = this.nodeSet.extend(...t.propSources)), this.strict = !1, this.bufferLength = $De;
    let s = m1(t.tokenData);
    this.context = t.context, this.specializerSpecs = t.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let l = 0; l < this.specializerSpecs.length; l++)
      this.specialized[l] = this.specializerSpecs[l].term;
    this.specializers = this.specializerSpecs.map(Rce), this.states = m1(t.states, Uint32Array), this.data = m1(t.stateData), this.goto = m1(t.goto), this.maxTerm = t.maxTerm, this.tokenizers = t.tokenizers.map((l) => typeof l == "number" ? new eA(s, l) : l), this.topRules = t.topRules, this.dialects = t.dialects || {}, this.dynamicPrecedences = t.dynamicPrecedences || null, this.tokenPrecTable = t.tokenPrec, this.termNames = t.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(t, n, r) {
    let i = new J2t(this, t, n, r);
    for (let o of this.wrappers)
      i = o(i, t, n, r);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(t, n, r = !1) {
    let i = this.goto;
    if (n >= i[0])
      return -1;
    for (let o = i[n + 1]; ; ) {
      let s = i[o++], l = s & 1, c = i[o++];
      if (l && r)
        return c;
      for (let a = o + (s >> 1); o < a; o++)
        if (i[o] == t)
          return c;
      if (l)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(t, n) {
    let r = this.data;
    for (let i = 0; i < 2; i++)
      for (let o = this.stateSlot(
        t,
        i ? 2 : 1
        /* ParseState.Actions */
      ), s; ; o += 3) {
        if ((s = r[o]) == 65535)
          if (r[o + 1] == 1)
            s = r[o = kp(r, o + 2)];
          else {
            if (r[o + 1] == 2)
              return kp(r, o + 2);
            break;
          }
        if (s == n || s == 0)
          return kp(r, o + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(t, n) {
    return this.states[t * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(t, n) {
    return (this.stateSlot(
      t,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(t, n) {
    return !!this.allActions(t, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(t, n) {
    let r = this.stateSlot(
      t,
      4
      /* ParseState.DefaultReduce */
    ), i = r ? n(r) : void 0;
    for (let o = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); i == null; o += 3) {
      if (this.data[o] == 65535)
        if (this.data[o + 1] == 1)
          o = kp(this.data, o + 2);
        else
          break;
      i = n(kp(this.data, o + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(t) {
    let n = [];
    for (let r = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = kp(this.data, r + 2);
        else
          break;
      if ((this.data[r + 2] & 1) == 0) {
        let i = this.data[r + 1];
        n.some((o, s) => s & 1 && o == i) || n.push(this.data[r], i);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(t) {
    let n = Object.assign(Object.create(ck.prototype), this);
    if (t.props && (n.nodeSet = this.nodeSet.extend(...t.props)), t.top) {
      let r = this.topRules[t.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${t.top}`);
      n.top = r;
    }
    return t.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let i = t.tokenizers.find((o) => o.from == r);
      return i ? i.to : r;
    })), t.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let o = t.specializers.find((l) => l.from == r.external);
      if (!o)
        return r;
      let s = Object.assign(Object.assign({}, r), { external: o.to });
      return n.specializers[i] = Rce(s), s;
    })), t.contextTracker && (n.context = t.contextTracker), t.dialect && (n.dialect = this.parseDialect(t.dialect)), t.strict != null && (n.strict = t.strict), t.wrap && (n.wrappers = n.wrappers.concat(t.wrap)), t.bufferLength != null && (n.bufferLength = t.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(t) {
    return this.termNames ? this.termNames[t] : String(t <= this.maxNode && this.nodeSet.types[t].name || t);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(t) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[t] || 0;
  }
  /**
  @internal
  */
  parseDialect(t) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (t)
      for (let o of t.split(" ")) {
        let s = n.indexOf(o);
        s >= 0 && (r[s] = !0);
      }
    let i = null;
    for (let o = 0; o < n.length; o++)
      if (!r[o])
        for (let s = this.dialects[n[o]], l; (l = this.data[s++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[l] = 1;
    return new ezt(t, r, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(t) {
    return new ck(t);
  }
}
function kp(e, t) {
  return e[t] | e[t + 1] << 16;
}
function nzt(e) {
  let t = null;
  for (let n of e) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!t || t.score < n.score) && (t = n);
  }
  return t;
}
function Rce(e) {
  if (e.external) {
    let t = e.extend ? 1 : 0;
    return (n, r) => e.external(n, r) << 1 | t;
  }
  return e.get;
}
let rzt = 0, Cp = class C9 {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.set = n, this.base = r, this.modified = i, this.id = rzt++;
  }
  toString() {
    let { name: t } = this;
    for (let n of this.modified)
      n.name && (t = `${n.name}(${t})`);
    return t;
  }
  static define(t, n) {
    let r = typeof t == "string" ? t : "?";
    if (t instanceof C9 && (n = t), n != null && n.base)
      throw new Error("Can not derive from a modified tag");
    let i = new C9(r, [], null, []);
    if (i.set.push(i), n)
      for (let o of n.set)
        i.set.push(o);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(t) {
    let n = new Mce(t);
    return (r) => r.modified.indexOf(n) > -1 ? r : Mce.get(r.base || r, r.modified.concat(n).sort((i, o) => i.id - o.id));
  }
}, izt = 0, Mce = class n_e {
  constructor(t) {
    this.name = t, this.instances = [], this.id = izt++;
  }
  static get(t, n) {
    if (!n.length)
      return t;
    let r = n[0].instances.find((l) => l.base == t && ozt(n, l.modified));
    if (r)
      return r;
    let i = [], o = new Cp(t.name, i, t, n);
    for (let l of n)
      l.instances.push(o);
    let s = szt(n);
    for (let l of t.set)
      if (!l.modified.length)
        for (let c of s)
          i.push(n_e.get(l, c));
    return o;
  }
};
function ozt(e, t) {
  return e.length == t.length && e.every((n, r) => n == t[r]);
}
function szt(e) {
  let t = [[]];
  for (let n = 0; n < e.length; n++)
    for (let r = 0, i = t.length; r < i; r++)
      t.push(t[r].concat(e[n]));
  return t.sort((n, r) => r.length - n.length);
}
function wG(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" "))
      if (i) {
        let o = [], s = 2, l = i;
        for (let f = 0; ; ) {
          if (l == "..." && f > 0 && f + 3 == i.length) {
            s = 1;
            break;
          }
          let d = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(l);
          if (!d)
            throw new RangeError("Invalid path: " + i);
          if (o.push(d[0] == "*" ? "" : d[0][0] == '"' ? JSON.parse(d[0]) : d[0]), f += d[0].length, f == i.length)
            break;
          let p = i[f++];
          if (f == i.length && p == "!") {
            s = 0;
            break;
          }
          if (p != "/")
            throw new RangeError("Invalid path: " + i);
          l = i.slice(f);
        }
        let c = o.length - 1, a = o[c];
        if (!a)
          throw new RangeError("Invalid path: " + i);
        let u = new O_(r, s, c > 0 ? o.slice(0, c) : null);
        t[a] = u.sort(t[a]);
      }
  }
  return r_e.add(t);
}
const r_e = new Gn();
let O_ = class {
  constructor(t, n, r, i) {
    this.tags = t, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
};
O_.empty = new O_([], 2, null);
function i_e(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of e)
    if (!Array.isArray(o.tag))
      n[o.tag.id] = o.class;
    else
      for (let s of o.tag)
        n[s.id] = o.class;
  let { scope: r, all: i = null } = t || {};
  return {
    style: (o) => {
      let s = i;
      for (let l of o)
        for (let c of l.set) {
          let a = n[c.id];
          if (a) {
            s = s ? s + " " + a : a;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
function azt(e, t) {
  let n = null;
  for (let r of e) {
    let i = r.style(t);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function lzt(e, t, n, r = 0, i = e.length) {
  let o = new czt(r, Array.isArray(t) ? t : [t], n);
  o.highlightRange(e.cursor(), r, i, "", o.highlighters), o.flush(i);
}
class czt {
  constructor(t, n, r) {
    this.at = t, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(t, n) {
    n != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = n);
  }
  flush(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  }
  highlightRange(t, n, r, i, o) {
    let { type: s, from: l, to: c } = t;
    if (l >= r || c <= n)
      return;
    s.isTop && (o = this.highlighters.filter((p) => !p.scope || p.scope(s)));
    let a = i, u = uzt(t) || O_.empty, f = azt(o, u.tags);
    if (f && (a && (a += " "), a += f, u.mode == 1 && (i += (i ? " " : "") + f)), this.startSpan(Math.max(n, l), a), u.opaque)
      return;
    let d = t.tree && t.tree.prop(Gn.mounted);
    if (d && d.overlay) {
      let p = t.node.enter(d.overlay[0].from + l, 1), h = this.highlighters.filter((v) => !v.scope || v.scope(d.tree.type)), m = t.firstChild();
      for (let v = 0, b = l; ; v++) {
        let A = v < d.overlay.length ? d.overlay[v] : null, w = A ? A.from + l : c, O = Math.max(n, b), x = Math.min(r, w);
        if (O < x && m)
          for (; t.from < x && (this.highlightRange(t, O, x, i, o), this.startSpan(Math.min(x, t.to), a), !(t.to >= w || !t.nextSibling())); )
            ;
        if (!A || w > r)
          break;
        b = A.to + l, b > n && (this.highlightRange(p.cursor(), Math.max(n, A.from + l), Math.min(r, b), "", h), this.startSpan(Math.min(r, b), a));
      }
      m && t.parent();
    } else if (t.firstChild()) {
      d && (i = "");
      do
        if (!(t.to <= n)) {
          if (t.from >= r)
            break;
          this.highlightRange(t, n, r, i, o), this.startSpan(Math.min(r, t.to), a);
        }
      while (t.nextSibling());
      t.parent();
    }
  }
}
function uzt(e) {
  let t = e.type.prop(r_e);
  for (; t && t.context && !e.matchContext(t.context); )
    t = t.next;
  return t || null;
}
const _t = Cp.define, wI = _t(), nm = _t(), Dce = _t(nm), _ce = _t(nm), rm = _t(), xI = _t(rm), CU = _t(rm), zd = _t(), ry = _t(zd), Id = _t(), Rd = _t(), N9 = _t(), gS = _t(N9), SI = _t(), ke = {
  /**
  A comment.
  */
  comment: wI,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: _t(wI),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: _t(wI),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: _t(wI),
  /**
  Any kind of identifier.
  */
  name: nm,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: _t(nm),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: Dce,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: _t(Dce),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: _ce,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: _t(_ce),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: _t(nm),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: _t(nm),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: _t(nm),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: _t(nm),
  /**
  A literal value.
  */
  literal: rm,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: xI,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: _t(xI),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: _t(xI),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: _t(xI),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: CU,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: _t(CU),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: _t(CU),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: _t(rm),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: _t(rm),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: _t(rm),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: _t(rm),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: _t(rm),
  /**
  A language keyword.
  */
  keyword: Id,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: _t(Id),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: _t(Id),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: _t(Id),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: _t(Id),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: _t(Id),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: _t(Id),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: _t(Id),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: _t(Id),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: _t(Id),
  /**
  An operator.
  */
  operator: Rd,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: _t(Rd),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: _t(Rd),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: _t(Rd),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: _t(Rd),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: _t(Rd),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: _t(Rd),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: _t(Rd),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: _t(Rd),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: _t(Rd),
  /**
  Program or markup punctuation.
  */
  punctuation: N9,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: _t(N9),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: gS,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: _t(gS),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: _t(gS),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: _t(gS),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: _t(gS),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: zd,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: ry,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: _t(ry),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: _t(ry),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: _t(ry),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: _t(ry),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: _t(ry),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: _t(ry),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: _t(zd),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: _t(zd),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: _t(zd),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: _t(zd),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: _t(zd),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: _t(zd),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: _t(zd),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: _t(zd),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: _t(),
  /**
  Deleted text.
  */
  deleted: _t(),
  /**
  Changed text.
  */
  changed: _t(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: _t(),
  /**
  Metadata or meta-instruction.
  */
  meta: SI,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: _t(SI),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: _t(SI),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: _t(SI),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Cp.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Cp.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Cp.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Cp.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Cp.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Cp.defineModifier("special")
};
for (let e in ke) {
  let t = ke[e];
  t instanceof Cp && (t.name = e);
}
i_e([
  { tag: ke.link, class: "tok-link" },
  { tag: ke.heading, class: "tok-heading" },
  { tag: ke.emphasis, class: "tok-emphasis" },
  { tag: ke.strong, class: "tok-strong" },
  { tag: ke.keyword, class: "tok-keyword" },
  { tag: ke.atom, class: "tok-atom" },
  { tag: ke.bool, class: "tok-bool" },
  { tag: ke.url, class: "tok-url" },
  { tag: ke.labelName, class: "tok-labelName" },
  { tag: ke.inserted, class: "tok-inserted" },
  { tag: ke.deleted, class: "tok-deleted" },
  { tag: ke.literal, class: "tok-literal" },
  { tag: ke.string, class: "tok-string" },
  { tag: ke.number, class: "tok-number" },
  { tag: [ke.regexp, ke.escape, ke.special(ke.string)], class: "tok-string2" },
  { tag: ke.variableName, class: "tok-variableName" },
  { tag: ke.local(ke.variableName), class: "tok-variableName tok-local" },
  { tag: ke.definition(ke.variableName), class: "tok-variableName tok-definition" },
  { tag: ke.special(ke.variableName), class: "tok-variableName2" },
  { tag: ke.definition(ke.propertyName), class: "tok-propertyName tok-definition" },
  { tag: ke.typeName, class: "tok-typeName" },
  { tag: ke.namespace, class: "tok-namespace" },
  { tag: ke.className, class: "tok-className" },
  { tag: ke.macroName, class: "tok-macroName" },
  { tag: ke.propertyName, class: "tok-propertyName" },
  { tag: ke.operator, class: "tok-operator" },
  { tag: ke.comment, class: "tok-comment" },
  { tag: ke.meta, class: "tok-meta" },
  { tag: ke.invalid, class: "tok-invalid" },
  { tag: ke.punctuation, class: "tok-punctuation" }
]);
const dzt = 315, fzt = 316, Lce = 1, pzt = 2, hzt = 3, mzt = 4, gzt = 317, yzt = 319, vzt = 320, bzt = 5, Ozt = 6, Azt = 0, P9 = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], o_e = 125, wzt = 59, I9 = 47, xzt = 42, Szt = 43, Ezt = 45, Tzt = 60, kzt = 44, Czt = 63, Nzt = 46, Pzt = 91, Izt = new tzt({
  start: !1,
  shift(e, t) {
    return t == bzt || t == Ozt || t == yzt ? e : t == vzt;
  },
  strict: !1
}), Rzt = new SN((e, t) => {
  let { next: n } = e;
  (n == o_e || n == -1 || t.context) && e.acceptToken(gzt);
}, { contextual: !0, fallback: !0 }), Mzt = new SN((e, t) => {
  let { next: n } = e, r;
  P9.indexOf(n) > -1 || n == I9 && ((r = e.peek(1)) == I9 || r == xzt) || n != o_e && n != wzt && n != -1 && !t.context && e.acceptToken(dzt);
}, { contextual: !0 }), Dzt = new SN((e, t) => {
  e.next == Pzt && !t.context && e.acceptToken(fzt);
}, { contextual: !0 }), _zt = new SN((e, t) => {
  let { next: n } = e;
  if (n == Szt || n == Ezt) {
    if (e.advance(), n == e.next) {
      e.advance();
      let r = !t.context && t.canShift(Lce);
      e.acceptToken(r ? Lce : pzt);
    }
  } else n == Czt && e.peek(1) == Nzt && (e.advance(), e.advance(), (e.next < 48 || e.next > 57) && e.acceptToken(hzt));
}, { contextual: !0 });
function NU(e, t) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122 || e == 95 || e >= 192 || !t && e >= 48 && e <= 57;
}
const Lzt = new SN((e, t) => {
  if (e.next != Tzt || !t.dialectEnabled(Azt) || (e.advance(), e.next == I9)) return;
  let n = 0;
  for (; P9.indexOf(e.next) > -1; )
    e.advance(), n++;
  if (NU(e.next, !0)) {
    for (e.advance(), n++; NU(e.next, !1); )
      e.advance(), n++;
    for (; P9.indexOf(e.next) > -1; )
      e.advance(), n++;
    if (e.next == kzt) return;
    for (let r = 0; ; r++) {
      if (r == 7) {
        if (!NU(e.next, !0)) return;
        break;
      }
      if (e.next != "extends".charCodeAt(r)) break;
      e.advance(), n++;
    }
  }
  e.acceptToken(mzt, -n);
}), zzt = wG({
  "get set async static": ke.modifier,
  "for while do if else switch try catch finally return throw break continue default case": ke.controlKeyword,
  "in of await yield void typeof delete instanceof as satisfies": ke.operatorKeyword,
  "let var const using function class extends": ke.definitionKeyword,
  "import export from": ke.moduleKeyword,
  "with debugger new": ke.keyword,
  TemplateString: ke.special(ke.string),
  super: ke.atom,
  BooleanLiteral: ke.bool,
  this: ke.self,
  null: ke.null,
  Star: ke.modifier,
  VariableName: ke.variableName,
  "CallExpression/VariableName TaggedTemplateExpression/VariableName": ke.function(ke.variableName),
  VariableDefinition: ke.definition(ke.variableName),
  Label: ke.labelName,
  PropertyName: ke.propertyName,
  PrivatePropertyName: ke.special(ke.propertyName),
  "CallExpression/MemberExpression/PropertyName": ke.function(ke.propertyName),
  "FunctionDeclaration/VariableDefinition": ke.function(ke.definition(ke.variableName)),
  "ClassDeclaration/VariableDefinition": ke.definition(ke.className),
  "NewExpression/VariableName": ke.className,
  PropertyDefinition: ke.definition(ke.propertyName),
  PrivatePropertyDefinition: ke.definition(ke.special(ke.propertyName)),
  UpdateOp: ke.updateOperator,
  "LineComment Hashbang": ke.lineComment,
  BlockComment: ke.blockComment,
  Number: ke.number,
  String: ke.string,
  Escape: ke.escape,
  ArithOp: ke.arithmeticOperator,
  LogicOp: ke.logicOperator,
  BitOp: ke.bitwiseOperator,
  CompareOp: ke.compareOperator,
  RegExp: ke.regexp,
  Equals: ke.definitionOperator,
  Arrow: ke.function(ke.punctuation),
  ": Spread": ke.punctuation,
  "( )": ke.paren,
  "[ ]": ke.squareBracket,
  "{ }": ke.brace,
  "InterpolationStart InterpolationEnd": ke.special(ke.brace),
  ".": ke.derefOperator,
  ", ;": ke.separator,
  "@": ke.meta,
  TypeName: ke.typeName,
  TypeDefinition: ke.definition(ke.typeName),
  "type enum interface implements namespace module declare": ke.definitionKeyword,
  "abstract global Privacy readonly override": ke.modifier,
  "is keyof unique infer asserts": ke.operatorKeyword,
  JSXAttributeValue: ke.attributeValue,
  JSXText: ke.content,
  "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": ke.angleBracket,
  "JSXIdentifier JSXNameSpacedName": ke.tagName,
  "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": ke.attributeName,
  "JSXBuiltin/JSXIdentifier": ke.standard(ke.tagName)
}), jzt = { __proto__: null, export: 20, as: 25, from: 33, default: 36, async: 41, function: 42, in: 52, out: 55, const: 56, extends: 60, this: 64, true: 72, false: 72, null: 84, void: 88, typeof: 92, super: 108, new: 142, delete: 154, yield: 163, await: 167, class: 172, public: 235, private: 235, protected: 235, readonly: 237, instanceof: 256, satisfies: 259, import: 292, keyof: 349, unique: 353, infer: 359, asserts: 395, is: 397, abstract: 417, implements: 419, type: 421, let: 424, var: 426, using: 429, interface: 435, enum: 439, namespace: 445, module: 447, declare: 451, global: 455, for: 474, of: 483, while: 486, with: 490, do: 494, if: 498, else: 500, switch: 504, case: 510, try: 516, catch: 520, finally: 524, return: 528, throw: 532, break: 536, continue: 540, debugger: 544 }, Fzt = { __proto__: null, async: 129, get: 131, set: 133, declare: 195, public: 197, private: 197, protected: 197, static: 199, abstract: 201, override: 203, readonly: 209, accessor: 211, new: 401 }, Uzt = { __proto__: null, "<": 193 }, Vzt = ck.deserialize({
  version: 14,
  states: "$EOQ%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#DaO.QQlO'#DgO.bQlO'#DrO%[QlO'#DzO0fQlO'#ESOOQ!0Lf'#E['#E[O1PQ`O'#EXOOQO'#Ep'#EpOOQO'#Ik'#IkO1XQ`O'#GsO1dQ`O'#EoO1iQ`O'#EoO3hQ!0MxO'#JqO6[Q!0MxO'#JrO6uQ`O'#F]O6zQ,UO'#FtOOQ!0Lf'#Ff'#FfO7VO7dO'#FfO7eQMhO'#F|O9[Q`O'#F{OOQ!0Lf'#Jr'#JrOOQ!0Lb'#Jq'#JqO9aQ`O'#GwOOQ['#K^'#K^O9lQ`O'#IXO9qQ!0LrO'#IYOOQ['#J_'#J_OOQ['#I^'#I^Q`QlOOQ`QlOOO9yQ!L^O'#DvO:QQlO'#EOO:XQlO'#EQO9gQ`O'#GsO:`QMhO'#CoO:nQ`O'#EnO:yQ`O'#EyO;OQMhO'#FeO;mQ`O'#GsOOQO'#K_'#K_O;rQ`O'#K_O<QQ`O'#G{O<QQ`O'#G|O<QQ`O'#HOO9gQ`O'#HRO<wQ`O'#HUO>`Q`O'#CeO>pQ`O'#HbO>xQ`O'#HhO>xQ`O'#HjO`QlO'#HlO>xQ`O'#HnO>xQ`O'#HqO>}Q`O'#HwO?SQ!0LsO'#H}O%[QlO'#IPO?_Q!0LsO'#IRO?jQ!0LsO'#ITO9qQ!0LrO'#IVO?uQ!0MxO'#CiO@wQpO'#DlQOQ`OOO%[QlO'#EQOA_Q`O'#ETO:`QMhO'#EnOAjQ`O'#EnOAuQ!bO'#FeOOQ['#Cg'#CgOOQ!0Lb'#Dq'#DqOOQ!0Lb'#Ju'#JuO%[QlO'#JuOOQO'#Jx'#JxOOQO'#Ig'#IgOBuQpO'#EgOOQ!0Lb'#Ef'#EfOOQ!0Lb'#J|'#J|OCqQ!0MSO'#EgOC{QpO'#EWOOQO'#Jw'#JwODaQpO'#JxOEnQpO'#EWOC{QpO'#EgPE{O&2DjO'#CbPOOO)CD|)CD|OOOO'#I_'#I_OFWO#tO,59UOOQ!0Lh,59U,59UOOOO'#I`'#I`OFfO&jO,59UOFtQ!L^O'#DcOOOO'#Ib'#IbOF{O#@ItO,59{OOQ!0Lf,59{,59{OGZQlO'#IcOGnQ`O'#JsOImQ!fO'#JsO+}QlO'#JsOItQ`O,5:ROJ[Q`O'#EpOJiQ`O'#KSOJtQ`O'#KROJtQ`O'#KROJ|Q`O,5;^OKRQ`O'#KQOOQ!0Ln,5:^,5:^OKYQlO,5:^OMWQ!0MxO,5:fOMwQ`O,5:nONbQ!0LrO'#KPONiQ`O'#KOO9aQ`O'#KOON}Q`O'#KOO! VQ`O,5;]O! [Q`O'#KOO!#aQ!fO'#JrOOQ!0Lh'#Ci'#CiO%[QlO'#ESO!$PQ!fO,5:sOOQS'#Jy'#JyOOQO-E<i-E<iO9gQ`O,5=_O!$gQ`O,5=_O!$lQlO,5;ZO!&oQMhO'#EkO!(YQ`O,5;ZO!(_QlO'#DyO!(iQpO,5;dO!(qQpO,5;dO%[QlO,5;dOOQ['#FT'#FTOOQ['#FV'#FVO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eOOQ['#FZ'#FZO!)PQlO,5;tOOQ!0Lf,5;y,5;yOOQ!0Lf,5;z,5;zOOQ!0Lf,5;|,5;|O%[QlO'#IoO!+SQ!0LrO,5<iO%[QlO,5;eO!&oQMhO,5;eO!+qQMhO,5;eO!-cQMhO'#E^O%[QlO,5;wOOQ!0Lf,5;{,5;{O!-jQ,UO'#FjO!.gQ,UO'#KWO!.RQ,UO'#KWO!.nQ,UO'#KWOOQO'#KW'#KWO!/SQ,UO,5<SOOOW,5<`,5<`O!/eQlO'#FvOOOW'#In'#InO7VO7dO,5<QO!/lQ,UO'#FxOOQ!0Lf,5<Q,5<QO!0]Q$IUO'#CyOOQ!0Lh'#C}'#C}O!0pO#@ItO'#DRO!1^QMjO,5<eO!1eQ`O,5<hO!3QQ(CWO'#GXO!3_Q`O'#GYO!3dQ`O'#GYO!5SQ(CWO'#G^O!6XQpO'#GbOOQO'#Gn'#GnO!+xQMhO'#GmOOQO'#Gp'#GpO!+xQMhO'#GoO!6zQ$IUO'#JkOOQ!0Lh'#Jk'#JkO!7UQ`O'#JjO!7dQ`O'#JiO!7lQ`O'#CuOOQ!0Lh'#C{'#C{O!7}Q`O'#C}OOQ!0Lh'#DV'#DVOOQ!0Lh'#DX'#DXO1SQ`O'#DZO!+xQMhO'#GPO!+xQMhO'#GRO!8SQ`O'#GTO!8XQ`O'#GUO!3dQ`O'#G[O!+xQMhO'#GaO<QQ`O'#JjO!8^Q`O'#EqO!8{Q`O,5<gOOQ!0Lb'#Cr'#CrO!9TQ`O'#ErO!9}QpO'#EsOOQ!0Lb'#KQ'#KQO!:UQ!0LrO'#K`O9qQ!0LrO,5=cO`QlO,5>sOOQ['#Jg'#JgOOQ[,5>t,5>tOOQ[-E<[-E<[O!<TQ!0MxO,5:bO!9xQpO,5:`O!>nQ!0MxO,5:jO%[QlO,5:jO!AUQ!0MxO,5:lOOQO,5@y,5@yO!AuQMhO,5=_O!BTQ!0LrO'#JhO9[Q`O'#JhO!BfQ!0LrO,59ZO!BqQpO,59ZO!ByQMhO,59ZO:`QMhO,59ZO!CUQ`O,5;ZO!C^Q`O'#HaO!CrQ`O'#KcO%[QlO,5;}O!9xQpO,5<PO!CzQ`O,5=zO!DPQ`O,5=zO!DUQ`O,5=zO9qQ!0LrO,5=zO<QQ`O,5=jOOQO'#Cy'#CyO!DdQpO,5=gO!DlQMhO,5=hO!DwQ`O,5=jO!D|Q!bO,5=mO!EUQ`O'#K_O>}Q`O'#HWO9gQ`O'#HYO!EZQ`O'#HYO:`QMhO'#H[O!E`Q`O'#H[OOQ[,5=p,5=pO!EeQ`O'#H]O!EvQ`O'#CoO!E{Q`O,59PO!FVQ`O,59PO!H[QlO,59POOQ[,59P,59PO!HlQ!0LrO,59PO%[QlO,59PO!JwQlO'#HdOOQ['#He'#HeOOQ['#Hf'#HfO`QlO,5=|O!K_Q`O,5=|O`QlO,5>SO`QlO,5>UO!KdQ`O,5>WO`QlO,5>YO!KiQ`O,5>]O!KnQlO,5>cOOQ[,5>i,5>iO%[QlO,5>iO9qQ!0LrO,5>kOOQ[,5>m,5>mO# xQ`O,5>mOOQ[,5>o,5>oO# xQ`O,5>oOOQ[,5>q,5>qO#!fQpO'#D_O%[QlO'#JuO##XQpO'#JuO##cQpO'#DmO##tQpO'#DmO#&VQlO'#DmO#&^Q`O'#JtO#&fQ`O,5:WO#&kQ`O'#EtO#&yQ`O'#KTO#'RQ`O,5;_O#'WQpO'#DmO#'eQpO'#EVOOQ!0Lf,5:o,5:oO%[QlO,5:oO#'lQ`O,5:oO>}Q`O,5;YO!BqQpO,5;YO!ByQMhO,5;YO:`QMhO,5;YO#'tQ`O,5@aO#'yQ07dO,5:sOOQO-E<e-E<eO#)PQ!0MSO,5;ROC{QpO,5:rO#)ZQpO,5:rOC{QpO,5;RO!BfQ!0LrO,5:rOOQ!0Lb'#Ej'#EjOOQO,5;R,5;RO%[QlO,5;RO#)hQ!0LrO,5;RO#)sQ!0LrO,5;RO!BqQpO,5:rOOQO,5;X,5;XO#*RQ!0LrO,5;RPOOO'#I]'#I]P#*gO&2DjO,58|POOO,58|,58|OOOO-E<]-E<]OOQ!0Lh1G.p1G.pOOOO-E<^-E<^OOOO,59},59}O#*rQ!bO,59}OOOO-E<`-E<`OOQ!0Lf1G/g1G/gO#*wQ!fO,5>}O+}QlO,5>}OOQO,5?T,5?TO#+RQlO'#IcOOQO-E<a-E<aO#+`Q`O,5@_O#+hQ!fO,5@_O#+oQ`O,5@mOOQ!0Lf1G/m1G/mO%[QlO,5@nO#+wQ`O'#IiOOQO-E<g-E<gO#+oQ`O,5@mOOQ!0Lb1G0x1G0xOOQ!0Ln1G/x1G/xOOQ!0Ln1G0Y1G0YO%[QlO,5@kO#,]Q!0LrO,5@kO#,nQ!0LrO,5@kO#,uQ`O,5@jO9aQ`O,5@jO#,}Q`O,5@jO#-]Q`O'#IlO#,uQ`O,5@jOOQ!0Lb1G0w1G0wO!(iQpO,5:uO!(tQpO,5:uOOQS,5:w,5:wO#-}QdO,5:wO#.VQMhO1G2yO9gQ`O1G2yOOQ!0Lf1G0u1G0uO#.eQ!0MxO1G0uO#/jQ!0MvO,5;VOOQ!0Lh'#GW'#GWO#0WQ!0MzO'#JkO!$lQlO1G0uO#2cQ!fO'#JvO%[QlO'#JvO#2mQ`O,5:eOOQ!0Lh'#D_'#D_OOQ!0Lf1G1O1G1OO%[QlO1G1OOOQ!0Lf1G1f1G1fO#2rQ`O1G1OO#5WQ!0MxO1G1PO#5_Q!0MxO1G1PO#7uQ!0MxO1G1PO#7|Q!0MxO1G1PO#:dQ!0MxO1G1PO#<zQ!0MxO1G1PO#=RQ!0MxO1G1PO#=YQ!0MxO1G1PO#?pQ!0MxO1G1PO#?wQ!0MxO1G1PO#BUQ?MtO'#CiO#DPQ?MtO1G1`O#DWQ?MtO'#JrO#DkQ!0MxO,5?ZOOQ!0Lb-E<m-E<mO#FxQ!0MxO1G1PO#GuQ!0MzO1G1POOQ!0Lf1G1P1G1PO#HxQMjO'#J{O#ISQ`O,5:xO#IXQ!0MxO1G1cO#I{Q,UO,5<WO#JTQ,UO,5<XO#J]Q,UO'#FoO#JtQ`O'#FnOOQO'#KX'#KXOOQO'#Im'#ImO#JyQ,UO1G1nOOQ!0Lf1G1n1G1nOOOW1G1y1G1yO#K[Q?MtO'#JqO#KfQ`O,5<bO!)PQlO,5<bOOOW-E<l-E<lOOQ!0Lf1G1l1G1lO#KkQpO'#KWOOQ!0Lf,5<d,5<dO#KsQpO,5<dO#KxQMhO'#DTOOOO'#Ia'#IaO#LPO#@ItO,59mOOQ!0Lh,59m,59mO%[QlO1G2PO!8XQ`O'#IqO#L[Q`O,5<zOOQ!0Lh,5<w,5<wO!+xQMhO'#ItO#LxQMjO,5=XO!+xQMhO'#IvO#MkQMjO,5=ZO!&oQMhO,5=]OOQO1G2S1G2SO#MuQ!dO'#CrO#NYQ(CWO'#ErO$ _QpO'#GbO$ uQ!dO,5<sO$ |Q`O'#KZO9aQ`O'#KZO$![Q`O,5<uO!+xQMhO,5<tO$!aQ`O'#GZO$!rQ`O,5<tO$!wQ!dO'#GWO$#UQ!dO'#K[O$#`Q`O'#K[O!&oQMhO'#K[O$#eQ`O,5<xO$#jQlO'#JuO$#tQpO'#GcO##tQpO'#GcO$$VQ`O'#GgO!3dQ`O'#GkO$$[Q!0LrO'#IsO$$gQpO,5<|OOQ!0Lp,5<|,5<|O$$nQpO'#GcO$${QpO'#GdO$%^QpO'#GdO$%cQMjO,5=XO$%sQMjO,5=ZOOQ!0Lh,5=^,5=^O!+xQMhO,5@UO!+xQMhO,5@UO$&TQ`O'#IxO$&iQ`O,5@TO$&qQ`O,59aOOQ!0Lh,59i,59iO$'hQ$IYO,59uOOQ!0Lh'#Jo'#JoO$(ZQMjO,5<kO$(|QMjO,5<mO@oQ`O,5<oOOQ!0Lh,5<p,5<pO$)WQ`O,5<vO$)]QMjO,5<{O$)mQ`O,5@UO$){Q`O'#KOO!$lQlO1G2RO$*QQ`O1G2RO9aQ`O'#KRO9aQ`O'#EtO%[QlO'#EtO9aQ`O'#IzO$*VQ!0LrO,5@zOOQ[1G2}1G2}OOQ[1G4_1G4_OOQ!0Lf1G/|1G/|OOQ!0Lf1G/z1G/zO$,XQ!0MxO1G0UOOQ[1G2y1G2yO!&oQMhO1G2yO%[QlO1G2yO#.YQ`O1G2yO$.]QMhO'#EkOOQ!0Lb,5@S,5@SO$.jQ!0LrO,5@SOOQ[1G.u1G.uO!BfQ!0LrO1G.uO!BqQpO1G.uO!ByQMhO1G.uO$.{Q`O1G0uO$/QQ`O'#CiO$/]Q`O'#KdO$/eQ`O,5={O$/jQ`O'#KdO$/oQ`O'#KdO$/}Q`O'#JQO$0]Q`O,5@}O$0eQ!fO1G1iOOQ!0Lf1G1k1G1kO9gQ`O1G3fO@oQ`O1G3fO$0lQ`O1G3fO$0qQ`O1G3fOOQ[1G3f1G3fO!DwQ`O1G3UO!&oQMhO1G3RO$0vQ`O1G3ROOQ[1G3S1G3SO!&oQMhO1G3SO$0{Q`O1G3SO$1TQpO'#HQOOQ[1G3U1G3UO!6SQpO'#I|O!D|Q!bO1G3XOOQ[1G3X1G3XOOQ[,5=r,5=rO$1]QMhO,5=tO9gQ`O,5=tO$$VQ`O,5=vO9[Q`O,5=vO!BqQpO,5=vO!ByQMhO,5=vO:`QMhO,5=vO$1kQ`O'#KbO$1vQ`O,5=wOOQ[1G.k1G.kO$1{Q!0LrO1G.kO@oQ`O1G.kO$2WQ`O1G.kO9qQ!0LrO1G.kO$4`Q!fO,5APO$4mQ`O,5APO9aQ`O,5APO$4xQlO,5>OO$5PQ`O,5>OOOQ[1G3h1G3hO`QlO1G3hOOQ[1G3n1G3nOOQ[1G3p1G3pO>xQ`O1G3rO$5UQlO1G3tO$9YQlO'#HsOOQ[1G3w1G3wO$9gQ`O'#HyO>}Q`O'#H{OOQ[1G3}1G3}O$9oQlO1G3}O9qQ!0LrO1G4TOOQ[1G4V1G4VOOQ!0Lb'#G_'#G_O9qQ!0LrO1G4XO9qQ!0LrO1G4ZO$=vQ`O,5@aO!)PQlO,5;`O9aQ`O,5;`O>}Q`O,5:XO!)PQlO,5:XO!BqQpO,5:XO$={Q?MtO,5:XOOQO,5;`,5;`O$>VQpO'#IdO$>mQ`O,5@`OOQ!0Lf1G/r1G/rO$>uQpO'#IjO$?PQ`O,5@oOOQ!0Lb1G0y1G0yO##tQpO,5:XOOQO'#If'#IfO$?XQpO,5:qOOQ!0Ln,5:q,5:qO#'oQ`O1G0ZOOQ!0Lf1G0Z1G0ZO%[QlO1G0ZOOQ!0Lf1G0t1G0tO>}Q`O1G0tO!BqQpO1G0tO!ByQMhO1G0tOOQ!0Lb1G5{1G5{O!BfQ!0LrO1G0^OOQO1G0m1G0mO%[QlO1G0mO$?`Q!0LrO1G0mO$?kQ!0LrO1G0mO!BqQpO1G0^OC{QpO1G0^O$?yQ!0LrO1G0mOOQO1G0^1G0^O$@_Q!0MxO1G0mPOOO-E<Z-E<ZPOOO1G.h1G.hOOOO1G/i1G/iO$@iQ!bO,5<iO$@qQ!fO1G4iOOQO1G4o1G4oO%[QlO,5>}O$@{Q`O1G5yO$ATQ`O1G6XO$A]Q!fO1G6YO9aQ`O,5?TO$AgQ!0MxO1G6VO%[QlO1G6VO$AwQ!0LrO1G6VO$BYQ`O1G6UO$BYQ`O1G6UO9aQ`O1G6UO$BbQ`O,5?WO9aQ`O,5?WOOQO,5?W,5?WO$BvQ`O,5?WO$){Q`O,5?WOOQO-E<j-E<jOOQS1G0a1G0aOOQS1G0c1G0cO#.QQ`O1G0cOOQ[7+(e7+(eO!&oQMhO7+(eO%[QlO7+(eO$CUQ`O7+(eO$CaQMhO7+(eO$CoQ!0MzO,5=XO$EzQ!0MzO,5=ZO$HVQ!0MzO,5=XO$JhQ!0MzO,5=ZO$LyQ!0MzO,59uO% OQ!0MzO,5<kO%#ZQ!0MzO,5<mO%%fQ!0MzO,5<{OOQ!0Lf7+&a7+&aO%'wQ!0MxO7+&aO%(kQlO'#IeO%(xQ`O,5@bO%)QQ!fO,5@bOOQ!0Lf1G0P1G0PO%)[Q`O7+&jOOQ!0Lf7+&j7+&jO%)aQ?MtO,5:fO%[QlO7+&zO%)kQ?MtO,5:bO%)xQ?MtO,5:jO%*SQ?MtO,5:lO%*^QMhO'#IhO%*hQ`O,5@gOOQ!0Lh1G0d1G0dOOQO1G1r1G1rOOQO1G1s1G1sO%*pQ!jO,5<ZO!)PQlO,5<YOOQO-E<k-E<kOOQ!0Lf7+'Y7+'YOOOW7+'e7+'eOOOW1G1|1G1|O%*{Q`O1G1|OOQ!0Lf1G2O1G2OOOOO,59o,59oO%+QQ!dO,59oOOOO-E<_-E<_OOQ!0Lh1G/X1G/XO%+XQ!0MxO7+'kOOQ!0Lh,5?],5?]O%+{QMhO1G2fP%,SQ`O'#IqPOQ!0Lh-E<o-E<oO%,pQMjO,5?`OOQ!0Lh-E<r-E<rO%-cQMjO,5?bOOQ!0Lh-E<t-E<tO%-mQ!dO1G2wO%-tQ!dO'#CrO%.[QMhO'#KRO$#jQlO'#JuOOQ!0Lh1G2_1G2_O%.cQ`O'#IpO%.wQ`O,5@uO%.wQ`O,5@uO%/PQ`O,5@uO%/[Q`O,5@uOOQO1G2a1G2aO%/jQMjO1G2`O!+xQMhO1G2`O%/zQ(CWO'#IrO%0XQ`O,5@vO!&oQMhO,5@vO%0aQ!dO,5@vOOQ!0Lh1G2d1G2dO%2qQ!fO'#CiO%2{Q`O,5=POOQ!0Lb,5<},5<}O%3TQpO,5<}OOQ!0Lb,5=O,5=OOClQ`O,5<}O%3`QpO,5<}OOQ!0Lb,5=R,5=RO$){Q`O,5=VOOQO,5?_,5?_OOQO-E<q-E<qOOQ!0Lp1G2h1G2hO##tQpO,5<}O$#jQlO,5=PO%3nQ`O,5=OO%3yQpO,5=OO!+xQMhO'#ItO%4sQMjO1G2sO!+xQMhO'#IvO%5fQMjO1G2uO%5pQMjO1G5pO%5zQMjO1G5pOOQO,5?d,5?dOOQO-E<v-E<vOOQO1G.{1G.{O!9xQpO,59wO%[QlO,59wOOQ!0Lh,5<j,5<jO%6XQ`O1G2ZO!+xQMhO1G2bO!+xQMhO1G5pO!+xQMhO1G5pO%6^Q!0MxO7+'mOOQ!0Lf7+'m7+'mO!$lQlO7+'mO%7QQ`O,5;`OOQ!0Lb,5?f,5?fOOQ!0Lb-E<x-E<xO%7VQ!dO'#K]O#'oQ`O7+(eO4UQ!fO7+(eO$CXQ`O7+(eO%7aQ!0MvO'#CiO%7tQ!0MvO,5=SO%8fQ`O,5=SO%8nQ`O,5=SOOQ!0Lb1G5n1G5nOOQ[7+$a7+$aO!BfQ!0LrO7+$aO!BqQpO7+$aO!$lQlO7+&aO%8sQ`O'#JPO%9[Q`O,5AOOOQO1G3g1G3gO9gQ`O,5AOO%9[Q`O,5AOO%9dQ`O,5AOOOQO,5?l,5?lOOQO-E=O-E=OOOQ!0Lf7+'T7+'TO%9iQ`O7+)QO9qQ!0LrO7+)QO9gQ`O7+)QO@oQ`O7+)QOOQ[7+(p7+(pO%9nQ!0MvO7+(mO!&oQMhO7+(mO!DrQ`O7+(nOOQ[7+(n7+(nO!&oQMhO7+(nO%9xQ`O'#KaO%:TQ`O,5=lOOQO,5?h,5?hOOQO-E<z-E<zOOQ[7+(s7+(sO%;gQpO'#HZOOQ[1G3`1G3`O!&oQMhO1G3`O%[QlO1G3`O%;nQ`O1G3`O%;yQMhO1G3`O9qQ!0LrO1G3bO$$VQ`O1G3bO9[Q`O1G3bO!BqQpO1G3bO!ByQMhO1G3bO%<XQ`O'#JOO%<mQ`O,5@|O%<uQpO,5@|OOQ!0Lb1G3c1G3cOOQ[7+$V7+$VO@oQ`O7+$VO9qQ!0LrO7+$VO%=QQ`O7+$VO%[QlO1G6kO%[QlO1G6lO%=VQ!0LrO1G6kO%=aQlO1G3jO%=hQ`O1G3jO%=mQlO1G3jOOQ[7+)S7+)SO9qQ!0LrO7+)^O`QlO7+)`OOQ['#Kg'#KgOOQ['#JR'#JRO%=tQlO,5>_OOQ[,5>_,5>_O%[QlO'#HtO%>RQ`O'#HvOOQ[,5>e,5>eO9aQ`O,5>eOOQ[,5>g,5>gOOQ[7+)i7+)iOOQ[7+)o7+)oOOQ[7+)s7+)sOOQ[7+)u7+)uO%>WQpO1G5{O%>rQ?MtO1G0zO%>|Q`O1G0zOOQO1G/s1G/sO%?XQ?MtO1G/sO>}Q`O1G/sO!)PQlO'#DmOOQO,5?O,5?OOOQO-E<b-E<bOOQO,5?U,5?UOOQO-E<h-E<hO!BqQpO1G/sOOQO-E<d-E<dOOQ!0Ln1G0]1G0]OOQ!0Lf7+%u7+%uO#'oQ`O7+%uOOQ!0Lf7+&`7+&`O>}Q`O7+&`O!BqQpO7+&`OOQO7+%x7+%xO$@_Q!0MxO7+&XOOQO7+&X7+&XO%[QlO7+&XO%?cQ!0LrO7+&XO!BfQ!0LrO7+%xO!BqQpO7+%xO%?nQ!0LrO7+&XO%?|Q!0MxO7++qO%[QlO7++qO%@^Q`O7++pO%@^Q`O7++pOOQO1G4r1G4rO9aQ`O1G4rO%@fQ`O1G4rOOQS7+%}7+%}O#'oQ`O<<LPO4UQ!fO<<LPO%@tQ`O<<LPOOQ[<<LP<<LPO!&oQMhO<<LPO%[QlO<<LPO%@|Q`O<<LPO%AXQ!0MzO,5?`O%CdQ!0MzO,5?bO%EoQ!0MzO1G2`O%HQQ!0MzO1G2sO%J]Q!0MzO1G2uO%LhQ!fO,5?PO%[QlO,5?POOQO-E<c-E<cO%LrQ`O1G5|OOQ!0Lf<<JU<<JUO%LzQ?MtO1G0uO& RQ?MtO1G1PO& YQ?MtO1G1PO&#ZQ?MtO1G1PO&#bQ?MtO1G1PO&%cQ?MtO1G1PO&'dQ?MtO1G1PO&'kQ?MtO1G1PO&'rQ?MtO1G1PO&)sQ?MtO1G1PO&)zQ?MtO1G1PO&*RQ!0MxO<<JfO&+yQ?MtO1G1PO&,vQ?MvO1G1PO&-yQ?MvO'#JkO&0PQ?MtO1G1cO&0^Q?MtO1G0UO&0hQMjO,5?SOOQO-E<f-E<fO!)PQlO'#FqOOQO'#KY'#KYOOQO1G1u1G1uO&0rQ`O1G1tO&0wQ?MtO,5?ZOOOW7+'h7+'hOOOO1G/Z1G/ZO&1RQ!dO1G4wOOQ!0Lh7+(Q7+(QP!&oQMhO,5?]O!+xQMhO7+(cO&1YQ`O,5?[O9aQ`O,5?[OOQO-E<n-E<nO&1hQ`O1G6aO&1hQ`O1G6aO&1pQ`O1G6aO&1{QMjO7+'zO&2]Q!dO,5?^O&2gQ`O,5?^O!&oQMhO,5?^OOQO-E<p-E<pO&2lQ!dO1G6bO&2vQ`O1G6bO&3OQ`O1G2kO!&oQMhO1G2kOOQ!0Lb1G2i1G2iOOQ!0Lb1G2j1G2jO%3TQpO1G2iO!BqQpO1G2iOClQ`O1G2iOOQ!0Lb1G2q1G2qO&3TQpO1G2iO&3cQ`O1G2kO$){Q`O1G2jOClQ`O1G2jO$#jQlO1G2kO&3kQ`O1G2jO&4_QMjO,5?`OOQ!0Lh-E<s-E<sO&5QQMjO,5?bOOQ!0Lh-E<u-E<uO!+xQMhO7++[OOQ!0Lh1G/c1G/cO&5[Q`O1G/cOOQ!0Lh7+'u7+'uO&5aQMjO7+'|O&5qQMjO7++[O&5{QMjO7++[O&6YQ!0MxO<<KXOOQ!0Lf<<KX<<KXO&6|Q`O1G0zO!&oQMhO'#IyO&7RQ`O,5@wO&9TQ!fO<<LPO!&oQMhO1G2nO&9[Q!0LrO1G2nOOQ[<<G{<<G{O!BfQ!0LrO<<G{O&9mQ!0MxO<<I{OOQ!0Lf<<I{<<I{OOQO,5?k,5?kO&:aQ`O,5?kO&:fQ`O,5?kOOQO-E<}-E<}O&:tQ`O1G6jO&:tQ`O1G6jO9gQ`O1G6jO@oQ`O<<LlOOQ[<<Ll<<LlO&:|Q`O<<LlO9qQ!0LrO<<LlOOQ[<<LX<<LXO%9nQ!0MvO<<LXOOQ[<<LY<<LYO!DrQ`O<<LYO&;RQpO'#I{O&;^Q`O,5@{O!)PQlO,5@{OOQ[1G3W1G3WOOQO'#I}'#I}O9qQ!0LrO'#I}O&;fQpO,5=uOOQ[,5=u,5=uO&;mQpO'#EgO&;tQpO'#GeO&;yQ`O7+(zO&<OQ`O7+(zOOQ[7+(z7+(zO!&oQMhO7+(zO%[QlO7+(zO&<WQ`O7+(zOOQ[7+(|7+(|O9qQ!0LrO7+(|O$$VQ`O7+(|O9[Q`O7+(|O!BqQpO7+(|O&<cQ`O,5?jOOQO-E<|-E<|OOQO'#H^'#H^O&<nQ`O1G6hO9qQ!0LrO<<GqOOQ[<<Gq<<GqO@oQ`O<<GqO&<vQ`O7+,VO&<{Q`O7+,WO%[QlO7+,VO%[QlO7+,WOOQ[7+)U7+)UO&=QQ`O7+)UO&=VQlO7+)UO&=^Q`O7+)UOOQ[<<Lx<<LxOOQ[<<Lz<<LzOOQ[-E=P-E=POOQ[1G3y1G3yO&=cQ`O,5>`OOQ[,5>b,5>bO&=hQ`O1G4PO9aQ`O7+&fO!)PQlO7+&fOOQO7+%_7+%_O&=mQ?MtO1G6YO>}Q`O7+%_OOQ!0Lf<<Ia<<IaOOQ!0Lf<<Iz<<IzO>}Q`O<<IzOOQO<<Is<<IsO$@_Q!0MxO<<IsO%[QlO<<IsOOQO<<Id<<IdO!BfQ!0LrO<<IdO&=wQ!0LrO<<IsO&>SQ!0MxO<= ]O&>dQ`O<= [OOQO7+*^7+*^O9aQ`O7+*^OOQ[ANAkANAkO&>lQ!fOANAkO!&oQMhOANAkO#'oQ`OANAkO4UQ!fOANAkO&>sQ`OANAkO%[QlOANAkO&>{Q!0MzO7+'zO&A^Q!0MzO,5?`O&CiQ!0MzO,5?bO&EtQ!0MzO7+'|O&HVQ!fO1G4kO&HaQ?MtO7+&aO&JeQ?MvO,5=XO&LlQ?MvO,5=ZO&L|Q?MvO,5=XO&M^Q?MvO,5=ZO&MnQ?MvO,59uO' tQ?MvO,5<kO'#wQ?MvO,5<mO'&]Q?MvO,5<{O'(RQ?MtO7+'kO'(`Q?MtO7+'mO'(mQ`O,5<]OOQO7+'`7+'`OOQ!0Lh7+*c7+*cO'(rQMjO<<K}OOQO1G4v1G4vO'(yQ`O1G4vO')UQ`O1G4vO')dQ`O7++{O')dQ`O7++{O!&oQMhO1G4xO')lQ!dO1G4xO')vQ`O7++|O'*OQ`O7+(VO'*ZQ!dO7+(VOOQ!0Lb7+(T7+(TOOQ!0Lb7+(U7+(UO!BqQpO7+(TOClQ`O7+(TO'*eQ`O7+(VO!&oQMhO7+(VO$){Q`O7+(UO'*jQ`O7+(VOClQ`O7+(UO'*rQMjO<<NvOOQ!0Lh7+$}7+$}O!+xQMhO<<NvO'*|Q!dO,5?eOOQO-E<w-E<wO'+WQ!0MvO7+(YO!&oQMhO7+(YOOQ[AN=gAN=gO9gQ`O1G5VOOQO1G5V1G5VO'+hQ`O1G5VO'+mQ`O7+,UO'+mQ`O7+,UO9qQ!0LrOANBWO@oQ`OANBWOOQ[ANBWANBWOOQ[ANAsANAsOOQ[ANAtANAtO'+uQ`O,5?gOOQO-E<y-E<yO',QQ?MtO1G6gOOQO,5?i,5?iOOQO-E<{-E<{OOQ[1G3a1G3aO',[Q`O,5=POOQ[<<Lf<<LfO!&oQMhO<<LfO&;yQ`O<<LfO',aQ`O<<LfO%[QlO<<LfOOQ[<<Lh<<LhO9qQ!0LrO<<LhO$$VQ`O<<LhO9[Q`O<<LhO',iQpO1G5UO',tQ`O7+,SOOQ[AN=]AN=]O9qQ!0LrOAN=]OOQ[<= q<= qOOQ[<= r<= rO',|Q`O<= qO'-RQ`O<= rOOQ[<<Lp<<LpO'-WQ`O<<LpO'-]QlO<<LpOOQ[1G3z1G3zO>}Q`O7+)kO'-dQ`O<<JQO'-oQ?MtO<<JQOOQO<<Hy<<HyOOQ!0LfAN?fAN?fOOQOAN?_AN?_O$@_Q!0MxOAN?_OOQOAN?OAN?OO%[QlOAN?_OOQO<<Mx<<MxOOQ[G27VG27VO!&oQMhOG27VO#'oQ`OG27VO'-yQ!fOG27VO4UQ!fOG27VO'.QQ`OG27VO'.YQ?MtO<<JfO'.gQ?MvO1G2`O'0]Q?MvO,5?`O'2`Q?MvO,5?bO'4cQ?MvO1G2sO'6fQ?MvO1G2uO'8iQ?MtO<<KXO'8vQ?MtO<<I{OOQO1G1w1G1wO!+xQMhOANAiOOQO7+*b7+*bO'9TQ`O7+*bO'9`Q`O<= gO'9hQ!dO7+*dOOQ!0Lb<<Kq<<KqO$){Q`O<<KqOClQ`O<<KqO'9rQ`O<<KqO!&oQMhO<<KqOOQ!0Lb<<Ko<<KoO!BqQpO<<KoO'9}Q!dO<<KqOOQ!0Lb<<Kp<<KpO':XQ`O<<KqO!&oQMhO<<KqO$){Q`O<<KpO':^QMjOANDbO':hQ!0MvO<<KtOOQO7+*q7+*qO9gQ`O7+*qO':xQ`O<= pOOQ[G27rG27rO9qQ!0LrOG27rO!)PQlO1G5RO';QQ`O7+,RO';YQ`O1G2kO&;yQ`OANBQOOQ[ANBQANBQO!&oQMhOANBQO';_Q`OANBQOOQ[ANBSANBSO9qQ!0LrOANBSO$$VQ`OANBSOOQO'#H_'#H_OOQO7+*p7+*pOOQ[G22wG22wOOQ[ANE]ANE]OOQ[ANE^ANE^OOQ[ANB[ANB[O';gQ`OANB[OOQ[<<MV<<MVO!)PQlOAN?lOOQOG24yG24yO$@_Q!0MxOG24yO#'oQ`OLD,qOOQ[LD,qLD,qO!&oQMhOLD,qO';lQ!fOLD,qO';sQ?MvO7+'zO'=iQ?MvO,5?`O'?lQ?MvO,5?bO'AoQ?MvO7+'|O'CeQMjOG27TOOQO<<M|<<M|OOQ!0LbANA]ANA]O$){Q`OANA]OClQ`OANA]O'CuQ!dOANA]OOQ!0LbANAZANAZO'C|Q`OANA]O!&oQMhOANA]O'DXQ!dOANA]OOQ!0LbANA[ANA[OOQO<<N]<<N]OOQ[LD-^LD-^O'DcQ?MtO7+*mOOQO'#Gf'#GfOOQ[G27lG27lO&;yQ`OG27lO!&oQMhOG27lOOQ[G27nG27nO9qQ!0LrOG27nOOQ[G27vG27vO'DmQ?MtOG25WOOQOLD*eLD*eOOQ[!$(!]!$(!]O#'oQ`O!$(!]O!&oQMhO!$(!]O'DwQ!0MzOG27TOOQ!0LbG26wG26wO$){Q`OG26wO'GYQ`OG26wOClQ`OG26wO'GeQ!dOG26wO!&oQMhOG26wOOQ[LD-WLD-WO&;yQ`OLD-WOOQ[LD-YLD-YOOQ[!)9Ew!)9EwO#'oQ`O!)9EwOOQ!0LbLD,cLD,cO$){Q`OLD,cOClQ`OLD,cO'GlQ`OLD,cO'GwQ!dOLD,cOOQ[!$(!r!$(!rOOQ[!.K;c!.K;cO'HOQ?MvOG27TOOQ!0Lb!$( }!$( }O$){Q`O!$( }OClQ`O!$( }O'ItQ`O!$( }OOQ!0Lb!)9Ei!)9EiO$){Q`O!)9EiOClQ`O!)9EiOOQ!0Lb!.K;T!.K;TO$){Q`O!.K;TOOQ!0Lb!4/0o!4/0oO!)PQlO'#DzO1PQ`O'#EXO'JPQ!fO'#JqO'JWQ!L^O'#DvO'J_QlO'#EOO'JfQ!fO'#CiO'L|Q!fO'#CiO!)PQlO'#EQO'M^QlO,5;ZO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO,5;eO!)PQlO'#IoO( aQ`O,5<iO!)PQlO,5;eO( iQMhO,5;eO(#SQMhO,5;eO!)PQlO,5;wO!&oQMhO'#GmO( iQMhO'#GmO!&oQMhO'#GoO( iQMhO'#GoO1SQ`O'#DZO1SQ`O'#DZO!&oQMhO'#GPO( iQMhO'#GPO!&oQMhO'#GRO( iQMhO'#GRO!&oQMhO'#GaO( iQMhO'#GaO!)PQlO,5:jO(#ZQpO'#D_O(#eQpO'#JuO!)PQlO,5@nO'M^QlO1G0uO(#oQ?MtO'#CiO!)PQlO1G2PO!&oQMhO'#ItO( iQMhO'#ItO!&oQMhO'#IvO( iQMhO'#IvO(#yQ!dO'#CrO!&oQMhO,5<tO( iQMhO,5<tO'M^QlO1G2RO!)PQlO7+&zO!&oQMhO1G2`O( iQMhO1G2`O!&oQMhO'#ItO( iQMhO'#ItO!&oQMhO'#IvO( iQMhO'#IvO!&oQMhO1G2bO( iQMhO1G2bO'M^QlO7+'mO'M^QlO7+&aO!&oQMhOANAiO( iQMhOANAiO($^Q`O'#EoO($cQ`O'#EoO($kQ`O'#F]O($pQ`O'#EyO($uQ`O'#KSO(%QQ`O'#KQO(%]Q`O,5;ZO(%bQMjO,5<eO(%iQ`O'#GYO(%nQ`O'#GYO(%sQ`O,5<gO(%{Q`O,5;ZO(&TQ?MtO1G1`O(&[Q`O,5<tO(&aQ`O,5<tO(&fQ`O,5<vO(&kQ`O,5<vO(&pQ`O1G2RO(&uQ`O1G0uO(&zQMjO<<K}O('RQMjO<<K}O7eQMhO'#F|O9[Q`O'#F{OAjQ`O'#EnO!)PQlO,5;tO!3dQ`O'#GYO!3dQ`O'#GYO!3dQ`O'#G[O!3dQ`O'#G[O!+xQMhO7+(cO!+xQMhO7+(cO%-mQ!dO1G2wO%-mQ!dO1G2wO!&oQMhO,5=]O!&oQMhO,5=]",
  stateData: "((X~O'{OS'|OSTOS'}RQ~OPYOQYOSfOY!VOaqOdzOeyOl!POpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!uwO!xxO!|]O$W|O$niO%h}O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO&V!WO&]!XO&_!YO&a!ZO&c![O&f!]O&l!^O&r!_O&t!`O&v!aO&x!bO&z!cO(SSO(UTO(XUO(`VO(n[O~OWtO~P`OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(S!dO(UTO(XUO(`VO(n[O~Oa!wOs!nO!S!oO!b!yO!c!vO!d!vO!|;wO#T!pO#U!pO#V!xO#W!pO#X!pO#[!zO#]!zO(T!lO(UTO(XUO(d!mO(n!sO~O'}!{O~OP]XR]X[]Xa]Xj]Xr]X!Q]X!S]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X'y]X(`]X(q]X(x]X(y]X~O!g%RX~P(qO_!}O(U#PO(V!}O(W#PO~O_#QO(W#PO(X#PO(Y#QO~Ox#SO!U#TO(a#TO(b#VO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(S;{O(UTO(XUO(`VO(n[O~O![#ZO!]#WO!Y(gP!Y(uP~P+}O!^#cO~P`OPYOQYOSfOd!jOe!iOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(UTO(XUO(`VO(n[O~Op#mO![#iO!|]O#i#lO#j#iO(S;|O!k(rP~P.iO!l#oO(S#nO~O!x#sO!|]O%h#tO~O#k#uO~O!g#vO#k#uO~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!]$_O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(`VO(q$YO(x#|O(y#}O~Oa(eX'y(eX'v(eX!k(eX!Y(eX!_(eX%i(eX!g(eX~P1qO#S$dO#`$eO$Q$eOP(fXR(fX[(fXj(fXr(fX!Q(fX!S(fX!](fX!l(fX!p(fX#R(fX#n(fX#o(fX#p(fX#q(fX#r(fX#s(fX#t(fX#u(fX#v(fX#x(fX#z(fX#{(fX(`(fX(q(fX(x(fX(y(fX!_(fX%i(fX~Oa(fX'y(fX'v(fX!Y(fX!k(fXv(fX!g(fX~P4UO#`$eO~O$]$hO$_$gO$f$mO~OSfO!_$nO$i$oO$k$qO~Oh%VOj%cOk%cOl%cOp%WOr%XOs$tOt$tOz%YO|%ZO!O%[O!S${O!_$|O!i%aO!l$xO#j%bO$W%_O$t%]O$v%^O$y%`O(S$sO(UTO(XUO(`$uO(x$}O(y%POg(]P~O!l%dO~O!S%gO!_%hO(S%fO~O!g%lO~Oa%mO'y%mO~O!Q%qO~P%[O(T!lO~P%[O%n%uO~P%[Oh%VO!l%dO(S%fO(T!lO~Oe%|O!l%dO(S%fO~Oj$RO~O!Q&RO!_&OO!l&QO%j&UO(S%fO(T!lO(UTO(XUO`)VP~O!x#sO~O%s&WO!S)RX!_)RX(S)RX~O(S&XO~Ol!PO!u&^O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO~Od&cOe&bO!x&`O%h&aO%{&_O~P<VOd&fOeyOl!PO!_&eO!u&^O!xxO!|]O%h}O%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO~Ob&iO#`&lO%j&gO(T!lO~P=[O!l&mO!u&qO~O!l#oO~O!_XO~Oa%mO'w&yO'y%mO~Oa%mO'w&|O'y%mO~Oa%mO'w'OO'y%mO~O'v]X!Y]Xv]X!k]X&Z]X!_]X%i]X!g]X~P(qO!b']O!c'UO!d'UO(T!lO(UTO(XUO~Os'SO!S'RO!['VO(d'QO!^(hP!^(wP~P@cOn'`O!_'^O(S%fO~Oe'eO!l%dO(S%fO~O!Q&RO!l&QO~Os!nO!S!oO!|;wO#T!pO#U!pO#W!pO#X!pO(T!lO(UTO(XUO(d!mO(n!sO~O!b'kO!c'jO!d'jO#V!pO#['lO#]'lO~PA}Oa%mOh%VO!g#vO!l%dO'y%mO(q'nO~O!p'rO#`'pO~PC]Os!nO!S!oO(UTO(XUO(d!mO(n!sO~O!_XOs(lX!S(lX!b(lX!c(lX!d(lX!|(lX#T(lX#U(lX#V(lX#W(lX#X(lX#[(lX#](lX(T(lX(U(lX(X(lX(d(lX(n(lX~O!c'jO!d'jO(T!lO~PC{O(O'vO(P'vO(Q'xO~O_!}O(U'zO(V!}O(W'zO~O_#QO(W'zO(X'zO(Y#QO~Ov'|O~P%[Ox#SO!U#TO(a#TO(b(PO~O![(RO!Y'VX!Y']X!]'VX!]']X~P+}O!](TO!Y(gX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!](TO!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(`VO(q$YO(x#|O(y#}O~O!Y(gX~PGvO!Y(YO~O!Y(tX!](tX!g(tX!k(tX(q(tX~O#`(tX#k#dX!^(tX~PIyO#`(ZO!Y(vX!](vX~O!]([O!Y(uX~O!Y(_O~O#`$eO~PIyO!^(`O~P`OR#zO!Q#yO!S#{O!l#xO(`VOP!na[!naj!nar!na!]!na!p!na#R!na#n!na#o!na#p!na#q!na#r!na#s!na#t!na#u!na#v!na#x!na#z!na#{!na(q!na(x!na(y!na~Oa!na'y!na'v!na!Y!na!k!nav!na!_!na%i!na!g!na~PKaO!k(aO~O!g#vO#`(bO(q'nO!](sXa(sX'y(sX~O!k(sX~PM|O!S%gO!_%hO!|]O#i(gO#j(fO(S%fO~O!](hO!k(rX~O!k(jO~O!S%gO!_%hO#j(fO(S%fO~OP(fXR(fX[(fXj(fXr(fX!Q(fX!S(fX!](fX!l(fX!p(fX#R(fX#n(fX#o(fX#p(fX#q(fX#r(fX#s(fX#t(fX#u(fX#v(fX#x(fX#z(fX#{(fX(`(fX(q(fX(x(fX(y(fX~O!g#vO!k(fX~P! jOR(lO!Q(kO!l#xO#S$dO!|!{a!S!{a~O!x!{a%h!{a!_!{a#i!{a#j!{a(S!{a~P!#kO!x(pO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(S!dO(UTO(XUO(`VO(n[O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<eO!S${O!_$|O!i=vO!l$xO#j<kO$W%_O$t<gO$v<iO$y%`O(S(tO(UTO(XUO(`$uO(x$}O(y%PO~O#k(vO~O![(xO!k(jP~P%[O(d(zO(n[O~O!S(|O!l#xO(d(zO(n[O~OP;vOQ;vOSfOd=rOe!iOpkOr;vOskOtkOzkO|;vO!O;vO!SWO!WkO!XkO!_!eO!i;yO!lZO!o;vO!p;vO!q;vO!s;zO!u;}O!x!hO$W!kO$n=pO(S)ZO(UTO(XUO(`VO(n[O~O!]$_Oa$qa'y$qa'v$qa!k$qa!Y$qa!_$qa%i$qa!g$qa~Ol)bO~P!&oOh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O%[O!S${O!_$|O!i%aO!l$xO#j%bO$W%_O$t%]O$v%^O$y%`O(S(tO(UTO(XUO(`$uO(x$}O(y%PO~Og(oP~P!+xO!Q)gO!g)fO!_$^X$Z$^X$]$^X$_$^X$f$^X~O!g)fO!_(zX$Z(zX$](zX$_(zX$f(zX~O!Q)gO~P!.RO!Q)gO!_(zX$Z(zX$](zX$_(zX$f(zX~O!_)iO$Z)mO$])hO$_)hO$f)nO~O![)qO~P!)PO$]$hO$_$gO$f)uO~On$zX!Q$zX#S$zX'x$zX(x$zX(y$zX~OgmXg$zXnmX!]mX#`mX~P!/wOx)wO(a)xO(b)zO~On*TO!Q)|O'x)}O(x$}O(y%PO~Og){O~P!0{Og*UO~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<eO!S*WO!_*XO!i=vO!l$xO#j<kO$W%_O$t<gO$v<iO$y%`O(UTO(XUO(`$uO(x$}O(y%PO~O![*[O(S*VO!k(}P~P!1jO#k*^O~O!l*_O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<eO!S${O!_$|O!i=vO!l$xO#j<kO$W%_O$t<gO$v<iO$y%`O(S*aO(UTO(XUO(`$uO(x$}O(y%PO~O![*dO!Y)OP~P!3iOr*pOs!nO!S*fO!b*nO!c*hO!d*hO!l*_O#[*oO%`*jO(T!lO(UTO(XUO(d!mO~O!^*mO~P!5^O#S$dOn(_X!Q(_X'x(_X(x(_X(y(_X!](_X#`(_X~Og(_X$O(_X~P!6`On*uO#`*tOg(^X!](^X~O!]*vOg(]X~Oj%cOk%cOl%cO(S&XOg(]P~Os*yO~O!l+OO~O(S(tO~Op+TO!S%gO![#iO!_%hO!|]O#i#lO#j#iO(S%fO!k(rP~O!g#vO#k+UO~O!S%gO![+WO!]([O!_%hO(S%fO!Y(uP~Os'YO!S+YO![+XO(UTO(XUO(d(zO~O!^(wP~P!9iO!]+ZOa)SX'y)SX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(`VO(q$YO(x#|O(y#}O~Oa!ja!]!ja'y!ja'v!ja!Y!ja!k!jav!ja!_!ja%i!ja!g!ja~P!:aOR#zO!Q#yO!S#{O!l#xO(`VOP!ra[!raj!rar!ra!]!ra!p!ra#R!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#v!ra#x!ra#z!ra#{!ra(q!ra(x!ra(y!ra~Oa!ra'y!ra'v!ra!Y!ra!k!rav!ra!_!ra%i!ra!g!ra~P!<wOR#zO!Q#yO!S#{O!l#xO(`VOP!ta[!taj!tar!ta!]!ta!p!ta#R!ta#n!ta#o!ta#p!ta#q!ta#r!ta#s!ta#t!ta#u!ta#v!ta#x!ta#z!ta#{!ta(q!ta(x!ta(y!ta~Oa!ta'y!ta'v!ta!Y!ta!k!tav!ta!_!ta%i!ta!g!ta~P!?_Oh%VOn+dO!_'^O%i+cO~O!g+fOa([X!_([X'y([X!]([X~Oa%mO!_XO'y%mO~Oh%VO!l%dO~Oh%VO!l%dO(S%fO~O!g#vO#k(vO~Ob+qO%j+rO(S+nO(UTO(XUO!^)WP~O!]+sO`)VX~O[+wO~O`+xO~O!_&OO(S%fO(T!lO`)VP~Oh%VO#`+}O~Oh%VOn,QO!_$|O~O!_,SO~O!Q,UO!_XO~O%n%uO~O!x,ZO~Oe,`O~Ob,aO(S#nO(UTO(XUO!^)UP~Oe%|O~O%j!QO(S&XO~P=[O[,fO`,eO~OPYOQYOSfOdzOeyOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!iuO!lZO!oYO!pYO!qYO!svO!xxO!|]O$niO%h}O(UTO(XUO(`VO(n[O~O!_!eO!u!gO$W!kO(S!dO~P!F_O`,eOa%mO'y%mO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!x!hO$W!kO$niO(S!dO(UTO(XUO(`VO(n[O~Oa,kOl!OO!uwO%l!OO%m!OO%n!OO~P!HwO!l&mO~O&],qO~O!_,sO~O&n,uO&p,vOP&kaQ&kaS&kaY&kaa&kad&kae&kal&kap&kar&kas&kat&kaz&ka|&ka!O&ka!S&ka!W&ka!X&ka!_&ka!i&ka!l&ka!o&ka!p&ka!q&ka!s&ka!u&ka!x&ka!|&ka$W&ka$n&ka%h&ka%j&ka%l&ka%m&ka%n&ka%q&ka%s&ka%v&ka%w&ka%y&ka&V&ka&]&ka&_&ka&a&ka&c&ka&f&ka&l&ka&r&ka&t&ka&v&ka&x&ka&z&ka'v&ka(S&ka(U&ka(X&ka(`&ka(n&ka!^&ka&d&kab&ka&i&ka~O(S,{O~Oh!eX!]!RX!^!RX!g!RX!g!eX!l!eX#`!RX~O!]!eX!^!eX~P# }O!g-QO#`-POh(iX!]#hX!^#hX!g(iX!l(iX~O!](iX!^(iX~P#!pOh%VO!g-SO!l%dO!]!aX!^!aX~Os!nO!S!oO(UTO(XUO(d!mO~OP;vOQ;vOSfOd=rOe!iOpkOr;vOskOtkOzkO|;vO!O;vO!SWO!WkO!XkO!_!eO!i;yO!lZO!o;vO!p;vO!q;vO!s;zO!u;}O!x!hO$W!kO$n=pO(UTO(XUO(`VO(n[O~O(S<rO~P#$VO!]-WO!^(hX~O!^-YO~O!g-QO#`-PO!]#hX!^#hX~O!]-ZO!^(wX~O!^-]O~O!c-^O!d-^O(T!lO~P##tO!^-aO~P'_On-dO!_'^O~O!Y-iO~Os!{a!b!{a!c!{a!d!{a#T!{a#U!{a#V!{a#W!{a#X!{a#[!{a#]!{a(T!{a(U!{a(X!{a(d!{a(n!{a~P!#kO!p-nO#`-lO~PC]O!c-pO!d-pO(T!lO~PC{Oa%mO#`-lO'y%mO~Oa%mO!g#vO#`-lO'y%mO~Oa%mO!g#vO!p-nO#`-lO'y%mO(q'nO~O(O'vO(P'vO(Q-uO~Ov-vO~O!Y'Va!]'Va~P!:aO![-zO!Y'VX!]'VX~P%[O!](TO!Y(ga~O!Y(ga~PGvO!]([O!Y(ua~O!S%gO![.OO!_%hO(S%fO!Y']X!]']X~O#`.QO!](sa!k(saa(sa'y(sa~O!g#vO~P#,]O!](hO!k(ra~O!S%gO!_%hO#j.UO(S%fO~Op.ZO!S%gO![.WO!_%hO!|]O#i.YO#j.WO(S%fO!]'`X!k'`X~OR._O!l#xO~Oh%VOn.bO!_'^O%i.aO~Oa#ci!]#ci'y#ci'v#ci!Y#ci!k#civ#ci!_#ci%i#ci!g#ci~P!:aOn=|O!Q)|O'x)}O(x$}O(y%PO~O#k#_aa#_a#`#_a'y#_a!]#_a!k#_a!_#_a!Y#_a~P#/XO#k(_XP(_XR(_X[(_Xa(_Xj(_Xr(_X!S(_X!l(_X!p(_X#R(_X#n(_X#o(_X#p(_X#q(_X#r(_X#s(_X#t(_X#u(_X#v(_X#x(_X#z(_X#{(_X'y(_X(`(_X(q(_X!k(_X!Y(_X'v(_Xv(_X!_(_X%i(_X!g(_X~P!6`O!].oO!k(jX~P!:aO!k.rO~O!Y.tO~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(`VO[#mia#mij#mir#mi!]#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'y#mi(q#mi(x#mi(y#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#n#mi~P#2wO#n$OO~P#2wOP$[OR#zOr$aO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(`VO[#mia#mij#mi!]#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'y#mi(q#mi(x#mi(y#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#r#mi~P#5fO#r$QO~P#5fOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO(`VOa#mi!]#mi#x#mi#z#mi#{#mi'y#mi(q#mi(x#mi(y#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#v#mi~P#8TOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO(`VO(y#}Oa#mi!]#mi#z#mi#{#mi'y#mi(q#mi(x#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#x$UO~P#:kO#x#mi~P#:kO#v$SO~P#8TOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO(`VO(x#|O(y#}Oa#mi!]#mi#{#mi'y#mi(q#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#z#mi~P#=aO#z$WO~P#=aOP]XR]X[]Xj]Xr]X!Q]X!S]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(`]X(q]X(x]X(y]X!]]X!^]X~O$O]X~P#@OOP$[OR#zO[<_Oj<SOr<]O!Q#yO!S#{O!l#xO!p$[O#R<SO#n<PO#o<QO#p<QO#q<QO#r<RO#s<SO#t<SO#u<^O#v<TO#x<VO#z<XO#{<YO(`VO(q$YO(x#|O(y#}O~O$O.vO~P#B]O#S$dO#`<`O$Q<`O$O(fX!^(fX~P! jOa'ca!]'ca'y'ca'v'ca!k'ca!Y'cav'ca!_'ca%i'ca!g'ca~P!:aO[#mia#mij#mir#mi!]#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'y#mi(q#mi'v#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(`VO(x#mi(y#mi~P#E_On=|O!Q)|O'x)}O(x$}O(y%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(`#mi~P#E_O!].zOg(oX~P!0{Og.|O~Oa$Pi!]$Pi'y$Pi'v$Pi!Y$Pi!k$Piv$Pi!_$Pi%i$Pi!g$Pi~P!:aO$].}O$_.}O~O$]/OO$_/OO~O!g)fO#`/PO!_$cX$Z$cX$]$cX$_$cX$f$cX~O![/QO~O!_)iO$Z/SO$])hO$_)hO$f/TO~O!]<ZO!^(eX~P#B]O!^/UO~O!g)fO$f(zX~O$f/WO~Ov/XO~P!&oOx)wO(a)xO(b/[O~O!S/_O~O(x$}On%aa!Q%aa'x%aa(y%aa!]%aa#`%aa~Og%aa$O%aa~P#LaO(y%POn%ca!Q%ca'x%ca(x%ca!]%ca#`%ca~Og%ca$O%ca~P#MSO!]fX!gfX!kfX!k$zX(qfX~P!/wO![/hO!]([O(S/gO!Y(uP!Y)OP~P!1jOr*pO!b*nO!c*hO!d*hO!l*_O#[*oO%`*jO(T!lO(UTO(XUO~Os<oO!S/iO![+XO!^*mO(d<nO!^(wP~P#NmO!k/jO~P#/XO!]/kO!g#vO(q'nO!k(}X~O!k/pO~O!S%gO![*[O!_%hO(S%fO!k(}P~O#k/rO~O!Y$zX!]$zX!g%RX~P!/wO!]/sO!Y)OX~P#/XO!g/uO~O!Y/wO~OpkO(S/xO~P.iOh%VOr/}O!g#vO!l%dO(q'nO~O!g+fO~Oa%mO!]0RO'y%mO~O!^0TO~P!5^O!c0UO!d0UO(T!lO~P##tOs!nO!S0VO(UTO(XUO(d!mO~O#[0XO~Og%aa!]%aa#`%aa$O%aa~P!0{Og%ca!]%ca#`%ca$O%ca~P!0{Oj%cOk%cOl%cO(S&XOg'lX!]'lX~O!]*vOg(]a~Og0bO~OR0cO!Q0cO!S0dO#S$dOn}a'x}a(x}a(y}a!]}a#`}a~Og}a$O}a~P$&vO!Q)|O'x)}On$sa(x$sa(y$sa!]$sa#`$sa~Og$sa$O$sa~P$'rO!Q)|O'x)}On$ua(x$ua(y$ua!]$ua#`$ua~Og$ua$O$ua~P$(eO#k0gO~Og%Ta!]%Ta#`%Ta$O%Ta~P!0{On0iO#`0hOg(^a!](^a~O!g#vO~O#k0lO~O!]+ZOa)Sa'y)Sa~OR#zO!Q#yO!S#{O!l#xO(`VOP!ri[!rij!rir!ri!]!ri!p!ri#R!ri#n!ri#o!ri#p!ri#q!ri#r!ri#s!ri#t!ri#u!ri#v!ri#x!ri#z!ri#{!ri(q!ri(x!ri(y!ri~Oa!ri'y!ri'v!ri!Y!ri!k!riv!ri!_!ri%i!ri!g!ri~P$*bOh%VOr%XOs$tOt$tOz%YO|%ZO!O<eO!S${O!_$|O!i=vO!l$xO#j<kO$W%_O$t<gO$v<iO$y%`O(UTO(XUO(`$uO(x$}O(y%PO~Op0uO%]0vO(S0tO~P$,xO!g+fOa([a!_([a'y([a!]([a~O#k0|O~O[]X!]fX!^fX~O!]0}O!^)WX~O!^1PO~O[1QO~Ob1SO(S+nO(UTO(XUO~O!_&OO(S%fO`'tX!]'tX~O!]+sO`)Va~O!k1VO~P!:aO[1YO~O`1ZO~O#`1^O~On1aO!_$|O~O(d(zO!^)TP~Oh%VOn1jO!_1gO%i1iO~O[1tO!]1rO!^)UX~O!^1uO~O`1wOa%mO'y%mO~O(S#nO(UTO(XUO~O#S$dO#`$eO$Q$eOP(fXR(fX[(fXr(fX!Q(fX!S(fX!](fX!l(fX!p(fX#R(fX#n(fX#o(fX#p(fX#q(fX#r(fX#s(fX#t(fX#u(fX#v(fX#x(fX#z(fX#{(fX(`(fX(q(fX(x(fX(y(fX~Oj1zO&Z1{Oa(fX~P$2cOj1zO#`$eO&Z1{O~Oa1}O~P%[Oa2PO~O&d2SOP&biQ&biS&biY&bia&bid&bie&bil&bip&bir&bis&bit&biz&bi|&bi!O&bi!S&bi!W&bi!X&bi!_&bi!i&bi!l&bi!o&bi!p&bi!q&bi!s&bi!u&bi!x&bi!|&bi$W&bi$n&bi%h&bi%j&bi%l&bi%m&bi%n&bi%q&bi%s&bi%v&bi%w&bi%y&bi&V&bi&]&bi&_&bi&a&bi&c&bi&f&bi&l&bi&r&bi&t&bi&v&bi&x&bi&z&bi'v&bi(S&bi(U&bi(X&bi(`&bi(n&bi!^&bib&bi&i&bi~Ob2YO!^2WO&i2XO~P`O!_XO!l2[O~O&p,vOP&kiQ&kiS&kiY&kia&kid&kie&kil&kip&kir&kis&kit&kiz&ki|&ki!O&ki!S&ki!W&ki!X&ki!_&ki!i&ki!l&ki!o&ki!p&ki!q&ki!s&ki!u&ki!x&ki!|&ki$W&ki$n&ki%h&ki%j&ki%l&ki%m&ki%n&ki%q&ki%s&ki%v&ki%w&ki%y&ki&V&ki&]&ki&_&ki&a&ki&c&ki&f&ki&l&ki&r&ki&t&ki&v&ki&x&ki&z&ki'v&ki(S&ki(U&ki(X&ki(`&ki(n&ki!^&ki&d&kib&ki&i&ki~O!Y2bO~O!]!aa!^!aa~P#B]Os!nO!S!oO![2hO(d!mO!]'WX!^'WX~P@cO!]-WO!^(ha~O!]'^X!^'^X~P!9iO!]-ZO!^(wa~O!^2oO~P'_Oa%mO#`2xO'y%mO~Oa%mO!g#vO#`2xO'y%mO~Oa%mO!g#vO!p2|O#`2xO'y%mO(q'nO~Oa%mO'y%mO~P!:aO!]$_Ov$qa~O!Y'Vi!]'Vi~P!:aO!](TO!Y(gi~O!]([O!Y(ui~O!Y(vi!](vi~P!:aO!](si!k(sia(si'y(si~P!:aO#`3OO!](si!k(sia(si'y(si~O!](hO!k(ri~O!S%gO!_%hO!|]O#i3TO#j3SO(S%fO~O!S%gO!_%hO#j3SO(S%fO~On3[O!_'^O%i3ZO~Oh%VOn3[O!_'^O%i3ZO~O#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'y%aa(`%aa(q%aa!k%aa!Y%aa'v%aav%aa!_%aa%i%aa!g%aa~P#LaO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'y%ca(`%ca(q%ca!k%ca!Y%ca'v%cav%ca!_%ca%i%ca!g%ca~P#MSO#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!]%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'y%aa(`%aa(q%aa!k%aa!Y%aa'v%aa#`%aav%aa!_%aa%i%aa!g%aa~P#/XO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!]%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'y%ca(`%ca(q%ca!k%ca!Y%ca'v%ca#`%cav%ca!_%ca%i%ca!g%ca~P#/XO#k}aP}a[}aa}aj}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a'y}a(`}a(q}a!k}a!Y}a'v}av}a!_}a%i}a!g}a~P$&vO#k$saP$saR$sa[$saa$saj$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa'y$sa(`$sa(q$sa!k$sa!Y$sa'v$sav$sa!_$sa%i$sa!g$sa~P$'rO#k$uaP$uaR$ua[$uaa$uaj$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua'y$ua(`$ua(q$ua!k$ua!Y$ua'v$uav$ua!_$ua%i$ua!g$ua~P$(eO#k%TaP%TaR%Ta[%Taa%Taj%Tar%Ta!S%Ta!]%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta'y%Ta(`%Ta(q%Ta!k%Ta!Y%Ta'v%Ta#`%Tav%Ta!_%Ta%i%Ta!g%Ta~P#/XOa#cq!]#cq'y#cq'v#cq!Y#cq!k#cqv#cq!_#cq%i#cq!g#cq~P!:aO![3dO!]'XX!k'XX~P%[O!].oO!k(ja~O!].oO!k(ja~P!:aO!Y3gO~O$O!na!^!na~PKaO$O!ja!]!ja!^!ja~P#B]O$O!ra!^!ra~P!<wO$O!ta!^!ta~P!?_Og'[X!]'[X~P!+xO!].zOg(oa~OSfO!_3{O$d3|O~O!^4QO~Ov4RO~P#/XOa$mq!]$mq'y$mq'v$mq!Y$mq!k$mqv$mq!_$mq%i$mq!g$mq~P!:aO!Y4TO~P!&oO!S4UO~O!Q)|O'x)}O(y%POn'ha(x'ha!]'ha#`'ha~Og'ha$O'ha~P%,XO!Q)|O'x)}On'ja(x'ja(y'ja!]'ja#`'ja~Og'ja$O'ja~P%,zO(q$YO~P#/XO!YfX!Y$zX!]fX!]$zX!g%RX#`fX~P!/wO(S<xO~P!1jO!S%gO![4XO!_%hO(S%fO!]'dX!k'dX~O!]/kO!k(}a~O!]/kO!g#vO!k(}a~O!]/kO!g#vO(q'nO!k(}a~Og$|i!]$|i#`$|i$O$|i~P!0{O![4aO!Y'fX!]'fX~P!3iO!]/sO!Y)Oa~O!]/sO!Y)Oa~P#/XOP]XR]X[]Xj]Xr]X!Q]X!S]X!Y]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(`]X(q]X(x]X(y]X~Oj%YX!g%YX~P%0kOj4fO!g#vO~Oh%VO!g#vO!l%dO~Oh%VOr4kO!l%dO(q'nO~Or4pO!g#vO(q'nO~Os!nO!S4qO(UTO(XUO(d!mO~O(x$}On%ai!Q%ai'x%ai(y%ai!]%ai#`%ai~Og%ai$O%ai~P%4[O(y%POn%ci!Q%ci'x%ci(x%ci!]%ci#`%ci~Og%ci$O%ci~P%4}Og(^i!](^i~P!0{O#`4wOg(^i!](^i~P!0{O!k4zO~Oa$oq!]$oq'y$oq'v$oq!Y$oq!k$oqv$oq!_$oq%i$oq!g$oq~P!:aO!Y5QO~O!]5RO!_)PX~P#/XOa$zX!_$zX%^]X'y$zX!]$zX~P!/wO%^5UOaoXnoX!QoX!_oX'xoX'yoX(xoX(yoX!]oX~Op5VO(S#nO~O%^5UO~Ob5]O%j5^O(S+nO(UTO(XUO!]'sX!^'sX~O!]0}O!^)Wa~O[5bO~O`5cO~Oa%mO'y%mO~P#/XO!]5kO#`5mO!^)TX~O!^5nO~Or5tOs!nO!S*fO!b!yO!c!vO!d!vO!|;wO#T!pO#U!pO#V!pO#W!pO#X!pO#[5sO#]!zO(T!lO(UTO(XUO(d!mO(n!sO~O!^5rO~P%:YOn5yO!_1gO%i5xO~Oh%VOn5yO!_1gO%i5xO~Ob6QO(S#nO(UTO(XUO!]'rX!^'rX~O!]1rO!^)Ua~O(UTO(XUO(d6SO~O`6WO~Oj6ZO&Z6[O~PM|O!k6]O~P%[Oa6_O~Oa6_O~P%[Ob2YO!^6dO&i2XO~P`O!g6fO~O!g6hOh(ii!](ii!^(ii!g(ii!l(iir(ii(q(ii~O!]#hi!^#hi~P#B]O#`6iO!]#hi!^#hi~O!]!ai!^!ai~P#B]Oa%mO#`6rO'y%mO~Oa%mO!g#vO#`6rO'y%mO~O!](sq!k(sqa(sq'y(sq~P!:aO!](hO!k(rq~O!S%gO!_%hO#j6yO(S%fO~O!_'^O%i6|O~On7QO!_'^O%i6|O~O#k'haP'haR'ha['haa'haj'har'ha!S'ha!l'ha!p'ha#R'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#v'ha#x'ha#z'ha#{'ha'y'ha(`'ha(q'ha!k'ha!Y'ha'v'hav'ha!_'ha%i'ha!g'ha~P%,XO#k'jaP'jaR'ja['jaa'jaj'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja'y'ja(`'ja(q'ja!k'ja!Y'ja'v'jav'ja!_'ja%i'ja!g'ja~P%,zO#k$|iP$|iR$|i[$|ia$|ij$|ir$|i!S$|i!]$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i'y$|i(`$|i(q$|i!k$|i!Y$|i'v$|i#`$|iv$|i!_$|i%i$|i!g$|i~P#/XO#k%aiP%aiR%ai[%aia%aij%air%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai'y%ai(`%ai(q%ai!k%ai!Y%ai'v%aiv%ai!_%ai%i%ai!g%ai~P%4[O#k%ciP%ciR%ci[%cia%cij%cir%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci'y%ci(`%ci(q%ci!k%ci!Y%ci'v%civ%ci!_%ci%i%ci!g%ci~P%4}O!]'Xa!k'Xa~P!:aO!].oO!k(ji~O$O#ci!]#ci!^#ci~P#B]OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(`VO[#mij#mir#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(q#mi(x#mi(y#mi!]#mi!^#mi~O#n#mi~P%MXO#n<PO~P%MXOP$[OR#zOr<]O!Q#yO!S#{O!l#xO!p$[O#n<PO#o<QO#p<QO#q<QO(`VO[#mij#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(q#mi(x#mi(y#mi!]#mi!^#mi~O#r#mi~P& aO#r<RO~P& aOP$[OR#zO[<_Oj<SOr<]O!Q#yO!S#{O!l#xO!p$[O#R<SO#n<PO#o<QO#p<QO#q<QO#r<RO#s<SO#t<SO#u<^O(`VO#x#mi#z#mi#{#mi$O#mi(q#mi(x#mi(y#mi!]#mi!^#mi~O#v#mi~P&#iOP$[OR#zO[<_Oj<SOr<]O!Q#yO!S#{O!l#xO!p$[O#R<SO#n<PO#o<QO#p<QO#q<QO#r<RO#s<SO#t<SO#u<^O#v<TO(`VO(y#}O#z#mi#{#mi$O#mi(q#mi(x#mi!]#mi!^#mi~O#x<VO~P&%jO#x#mi~P&%jO#v<TO~P&#iOP$[OR#zO[<_Oj<SOr<]O!Q#yO!S#{O!l#xO!p$[O#R<SO#n<PO#o<QO#p<QO#q<QO#r<RO#s<SO#t<SO#u<^O#v<TO#x<VO(`VO(x#|O(y#}O#{#mi$O#mi(q#mi!]#mi!^#mi~O#z#mi~P&'yO#z<XO~P&'yOa#|y!]#|y'y#|y'v#|y!Y#|y!k#|yv#|y!_#|y%i#|y!g#|y~P!:aO[#mij#mir#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(q#mi!]#mi!^#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n<PO#o<QO#p<QO#q<QO(`VO(x#mi(y#mi~P&*uOn=}O!Q)|O'x)}O(x$}O(y%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(`#mi~P&*uO#S$dOP(_XR(_X[(_Xj(_Xn(_Xr(_X!Q(_X!S(_X!l(_X!p(_X#R(_X#n(_X#o(_X#p(_X#q(_X#r(_X#s(_X#t(_X#u(_X#v(_X#x(_X#z(_X#{(_X$O(_X'x(_X(`(_X(q(_X(x(_X(y(_X!](_X!^(_X~O$O$Pi!]$Pi!^$Pi~P#B]O$O!ri!^!ri~P$*bOg'[a!]'[a~P!0{O!^7dO~O!]'ca!^'ca~P#B]O!Y7eO~P#/XO!g#vO(q'nO!]'da!k'da~O!]/kO!k(}i~O!]/kO!g#vO!k(}i~Og$|q!]$|q#`$|q$O$|q~P!0{O!Y'fa!]'fa~P#/XO!g7lO~O!]/sO!Y)Oi~P#/XO!]/sO!Y)Oi~O!Y7oO~Oh%VOr7tO!l%dO(q'nO~Oj7vO!g#vO~Or7yO!g#vO(q'nO~O!Q)|O'x)}O(y%POn'ia(x'ia!]'ia#`'ia~Og'ia$O'ia~P&3vO!Q)|O'x)}On'ka(x'ka(y'ka!]'ka#`'ka~Og'ka$O'ka~P&4iO!Y7{O~Og%Oq!]%Oq#`%Oq$O%Oq~P!0{Og(^q!](^q~P!0{O#`7|Og(^q!](^q~P!0{Oa$oy!]$oy'y$oy'v$oy!Y$oy!k$oyv$oy!_$oy%i$oy!g$oy~P!:aO!g6hO~O!]5RO!_)Pa~O!_'^OP$TaR$Ta[$Taj$Tar$Ta!Q$Ta!S$Ta!]$Ta!l$Ta!p$Ta#R$Ta#n$Ta#o$Ta#p$Ta#q$Ta#r$Ta#s$Ta#t$Ta#u$Ta#v$Ta#x$Ta#z$Ta#{$Ta(`$Ta(q$Ta(x$Ta(y$Ta~O%i6|O~P&7ZO%^8QOa%[i!_%[i'y%[i!]%[i~Oa#cy!]#cy'y#cy'v#cy!Y#cy!k#cyv#cy!_#cy%i#cy!g#cy~P!:aO[8SO~Ob8UO(S+nO(UTO(XUO~O!]0}O!^)Wi~O`8YO~O(d(zO!]'oX!^'oX~O!]5kO!^)Ta~O!^8cO~P%:YO(n!sO~P$${O#[8dO~O!_1gO~O!_1gO%i8fO~On8iO!_1gO%i8fO~O[8nO!]'ra!^'ra~O!]1rO!^)Ui~O!k8rO~O!k8sO~O!k8vO~O!k8vO~P%[Oa8xO~O!g8yO~O!k8zO~O!](vi!^(vi~P#B]Oa%mO#`9SO'y%mO~O!](sy!k(sya(sy'y(sy~P!:aO!](hO!k(ry~O%i9VO~P&7ZO!_'^O%i9VO~O#k$|qP$|qR$|q[$|qa$|qj$|qr$|q!S$|q!]$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q'y$|q(`$|q(q$|q!k$|q!Y$|q'v$|q#`$|qv$|q!_$|q%i$|q!g$|q~P#/XO#k'iaP'iaR'ia['iaa'iaj'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia'y'ia(`'ia(q'ia!k'ia!Y'ia'v'iav'ia!_'ia%i'ia!g'ia~P&3vO#k'kaP'kaR'ka['kaa'kaj'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka'y'ka(`'ka(q'ka!k'ka!Y'ka'v'kav'ka!_'ka%i'ka!g'ka~P&4iO#k%OqP%OqR%Oq[%Oqa%Oqj%Oqr%Oq!S%Oq!]%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq'y%Oq(`%Oq(q%Oq!k%Oq!Y%Oq'v%Oq#`%Oqv%Oq!_%Oq%i%Oq!g%Oq~P#/XO!]'Xi!k'Xi~P!:aO$O#cq!]#cq!^#cq~P#B]O(x$}OP%aaR%aa[%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa$O%aa(`%aa(q%aa!]%aa!^%aa~On%aa!Q%aa'x%aa(y%aa~P&HnO(y%POP%caR%ca[%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca$O%ca(`%ca(q%ca!]%ca!^%ca~On%ca!Q%ca'x%ca(x%ca~P&JuOn=}O!Q)|O'x)}O(y%PO~P&HnOn=}O!Q)|O'x)}O(x$}O~P&JuOR0cO!Q0cO!S0dO#S$dOP}a[}aj}an}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a$O}a'x}a(`}a(q}a(x}a(y}a!]}a!^}a~O!Q)|O'x)}OP$saR$sa[$saj$san$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa$O$sa(`$sa(q$sa(x$sa(y$sa!]$sa!^$sa~O!Q)|O'x)}OP$uaR$ua[$uaj$uan$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua$O$ua(`$ua(q$ua(x$ua(y$ua!]$ua!^$ua~On=}O!Q)|O'x)}O(x$}O(y%PO~OP%TaR%Ta[%Taj%Tar%Ta!S%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta$O%Ta(`%Ta(q%Ta!]%Ta!^%Ta~P'%zO$O$mq!]$mq!^$mq~P#B]O$O$oq!]$oq!^$oq~P#B]O!^9dO~O$O9eO~P!0{O!g#vO!]'di!k'di~O!g#vO(q'nO!]'di!k'di~O!]/kO!k(}q~O!Y'fi!]'fi~P#/XO!]/sO!Y)Oq~Or9lO!g#vO(q'nO~O[9nO!Y9mO~P#/XO!Y9mO~Oj9tO!g#vO~Og(^y!](^y~P!0{O!]'ma!_'ma~P#/XOa%[q!_%[q'y%[q!]%[q~P#/XO[9yO~O!]0}O!^)Wq~O#`9}O!]'oa!^'oa~O!]5kO!^)Ti~P#B]O!S:PO~O!_1gO%i:SO~O(UTO(XUO(d:XO~O!]1rO!^)Uq~O!k:[O~O!k:]O~O!k:^O~O!k:^O~P%[O#`:aO!]#hy!^#hy~O!]#hy!^#hy~P#B]O%i:fO~P&7ZO!_'^O%i:fO~O$O#|y!]#|y!^#|y~P#B]OP$|iR$|i[$|ij$|ir$|i!S$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i$O$|i(`$|i(q$|i!]$|i!^$|i~P'%zO!Q)|O'x)}O(y%POP'haR'ha['haj'han'har'ha!S'ha!l'ha!p'ha#R'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#v'ha#x'ha#z'ha#{'ha$O'ha(`'ha(q'ha(x'ha!]'ha!^'ha~O!Q)|O'x)}OP'jaR'ja['jaj'jan'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja$O'ja(`'ja(q'ja(x'ja(y'ja!]'ja!^'ja~O(x$}OP%aiR%ai[%aij%ain%air%ai!Q%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai$O%ai'x%ai(`%ai(q%ai(y%ai!]%ai!^%ai~O(y%POP%ciR%ci[%cij%cin%cir%ci!Q%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci$O%ci'x%ci(`%ci(q%ci(x%ci!]%ci!^%ci~O$O$oy!]$oy!^$oy~P#B]O$O#cy!]#cy!^#cy~P#B]O!g#vO!]'dq!k'dq~O!]/kO!k(}y~O!Y'fq!]'fq~P#/XOr:pO!g#vO(q'nO~O[:tO!Y:sO~P#/XO!Y:sO~Og(^!R!](^!R~P!0{Oa%[y!_%[y'y%[y!]%[y~P#/XO!]0}O!^)Wy~O!]5kO!^)Tq~O(S:zO~O!_1gO%i:}O~O!k;QO~O%i;VO~P&7ZOP$|qR$|q[$|qj$|qr$|q!S$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q$O$|q(`$|q(q$|q!]$|q!^$|q~P'%zO!Q)|O'x)}O(y%POP'iaR'ia['iaj'ian'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia$O'ia(`'ia(q'ia(x'ia!]'ia!^'ia~O!Q)|O'x)}OP'kaR'ka['kaj'kan'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka$O'ka(`'ka(q'ka(x'ka(y'ka!]'ka!^'ka~OP%OqR%Oq[%Oqj%Oqr%Oq!S%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq$O%Oq(`%Oq(q%Oq!]%Oq!^%Oq~P'%zOg%e!Z!]%e!Z#`%e!Z$O%e!Z~P!0{O!Y;ZO~P#/XOr;[O!g#vO(q'nO~O[;^O!Y;ZO~P#/XO!]'oq!^'oq~P#B]O!]#h!Z!^#h!Z~P#B]O#k%e!ZP%e!ZR%e!Z[%e!Za%e!Zj%e!Zr%e!Z!S%e!Z!]%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z'y%e!Z(`%e!Z(q%e!Z!k%e!Z!Y%e!Z'v%e!Z#`%e!Zv%e!Z!_%e!Z%i%e!Z!g%e!Z~P#/XOr;fO!g#vO(q'nO~O!Y;gO~P#/XOr;nO!g#vO(q'nO~O!Y;oO~P#/XOP%e!ZR%e!Z[%e!Zj%e!Zr%e!Z!S%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z$O%e!Z(`%e!Z(q%e!Z!]%e!Z!^%e!Z~P'%zOr;rO!g#vO(q'nO~Ov(eX~P1qO!Q%qO~P!)PO(T!lO~P!)PO!YfX!]fX#`fX~P%0kOP]XR]X[]Xj]Xr]X!Q]X!S]X!]]X!]fX!l]X!p]X#R]X#S]X#`]X#`fX#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(`]X(q]X(x]X(y]X~O!gfX!k]X!kfX(qfX~P'JsOP;vOQ;vOSfOd=rOe!iOpkOr;vOskOtkOzkO|;vO!O;vO!SWO!WkO!XkO!_XO!i;yO!lZO!o;vO!p;vO!q;vO!s;zO!u;}O!x!hO$W!kO$n=pO(S)ZO(UTO(XUO(`VO(n[O~O!]<ZO!^$qa~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<fO!S${O!_$|O!i=wO!l$xO#j<lO$W%_O$t<hO$v<jO$y%`O(S(tO(UTO(XUO(`$uO(x$}O(y%PO~Ol)bO~P( iOr!eX(q!eX~P# }Or(iX(q(iX~P#!pO!^]X!^fX~P'JsO!YfX!Y$zX!]fX!]$zX#`fX~P!/wO#k<OO~O!g#vO#k<OO~O#`<`O~Oj<SO~O#`<pO!](vX!^(vX~O#`<`O!](tX!^(tX~O#k<qO~Og<sO~P!0{O#k<yO~O#k<zO~O!g#vO#k<{O~O!g#vO#k<qO~O$O<|O~P#B]O#k<}O~O#k=OO~O#k=TO~O#k=UO~O#k=VO~O#k=WO~O$O=XO~P!0{O$O=YO~P!0{Ok#S#T#U#W#X#[#i#j#u$n$t$v$y%]%^%h%i%j%q%s%v%w%y%{~'}T#o!X'{(T#ps#n#qr!Q'|$]'|(S$_(d~",
  goto: "$8g)[PPPPPP)]PP)`P)qP+R/WPPPP6bPP6xPP<pPPP@dP@zP@zPPP@zPCSP@zP@zP@zPCWPC]PCzPHtPPPHxPPPPHxK{PPPLRLsPHxPHxPP! RHxPPPHxPHxP!#YHxP!&p!'u!(OP!(r!(v!(r!,TPPPPPPP!,t!'uPP!-U!.vP!2SHxHx!2X!5e!:R!:R!>QPPP!>YHxPPPPPPPPP!AiP!BvPPHx!DXPHxPHxHxHxHxHxPHx!EkP!HuP!K{P!LP!LZ!L_!L_P!HrP!Lc!LcP# iP# mHxPHx# s#$xCW@zP@zP@z@zP#&V@z@z#(i@z#+a@z#-m@z@z#.]#0q#0q#0v#1P#0q#1[PP#0qP@z#1t@z#5s@z@z6bPPP#9xPPP#:c#:cP#:cP#:y#:cPP#;PP#:vP#:v#;d#:v#<O#<U#<X)`#<[)`P#<c#<c#<cP)`P)`P)`P)`PP)`P#<i#<lP#<l)`P#<pP#<sP)`P)`P)`P)`P)`P)`)`PP#<y#=P#=[#=b#=h#=n#=t#>S#>Y#>d#>j#>t#>z#?[#?b#@S#@f#@l#@r#AQ#Ag#C[#Cj#Cq#E]#Ek#G]#Gk#Gq#Gw#G}#HX#H_#He#Ho#IR#IXPPPPPPPPPPP#I_PPPPPPP#JS#MZ#Ns#Nz$ SPPP$&nP$&w$)p$0Z$0^$0a$1`$1c$1j$1rP$1x$1{P$2i$2m$3e$4s$4x$5`PP$5e$5k$5o$5r$5v$5z$6v$7_$7v$7z$7}$8Q$8W$8Z$8_$8cR!|RoqOXst!Z#d%l&p&r&s&u,n,s2S2VY!vQ'^-`1g5qQ%svQ%{yQ&S|Q&h!VS'U!e-WQ'd!iS'j!r!yU*h$|*X*lQ+l%|Q+y&UQ,_&bQ-^']Q-h'eQ-p'kQ0U*nQ1q,`R<m;z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9SS#q];w!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU*{%[<e<fQ+q&OQ,a&eQ,h&mQ0r+dQ0w+fQ1S+rQ1y,fQ3W.bQ5V0vQ5]0}Q6Q1rQ7O3[Q8U5^R9Y7Q'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s!S!nQ!r!v!y!z$|'U']'^'j'k'l*h*l*n*o-W-^-`-p0U0X1g5q5s%[$ti#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q&V|Q'S!eS'Y%h-ZQ+q&OQ,a&eQ0f+OQ1S+rQ1X+xQ1x,eQ1y,fQ5]0}Q5f1ZQ6Q1rQ6T1tQ6U1wQ8U5^Q8X5cQ8q6WQ9|8YQ:Y8nR<o*XrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR,c&i&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=r=s[#]WZ#W#Z'V(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ%vxQ%zyS&P|&UQ&]!TQ'a!hQ'c!iQ(o#sS+k%{%|Q+o&OQ,Y&`Q,^&bS-g'd'eQ.d(pQ0{+lQ1R+rQ1T+sQ1W+wQ1l,ZS1p,_,`Q2t-hQ5[0}Q5`1QQ5e1YQ6P1qQ8T5^Q8W5bQ9x8SR:w9y!U$zi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y!^%xy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pQ+e%vQ,O&YQ,R&ZQ,]&bQ.c(oQ1k,YU1o,^,_,`Q3].dQ5z1lS6O1p1qQ8m6P#f=t#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o=u<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YW%Ti%V*v=pS&Y!Q&gQ&Z!RQ&[!SQ+S%cR+|&W%]%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}T)x$u)yV*{%[<e<fW'Y!e%h*X-ZS({#y#zQ+`%qQ+v&RS.](k(lQ1b,SQ4x0cR8^5k'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s$i$^c#Y#e%p%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.w.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ'W!eR2i-W!W!nQ!e!r!v!y!z$|'U']'^'j'k'l*X*h*l*n*o-W-^-`-p0U0X1g5q5sR1d,UnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&w!^Q't!xS(q#u<OQ+i%yQ,W&]Q,X&_Q-e'bQ-r'mS.m(v<qS0k+U<{Q0y+jQ1f,VQ2Z,uQ2],vQ2e-RQ2r-fQ2u-jS5P0l=VQ5W0zS5Z0|=WQ6j2gQ6n2sQ6s2zQ8R5XQ8}6lQ9O6oQ9R6tR:`8z$d$]c#Y#e%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gS(m#p'gQ(}#zS+_%p.wS.^(l(nR3U._'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS#q];wQ&r!XQ&s!YQ&u![Q&v!]R2R,qQ'_!hQ+b%vQ-c'aS.`(o+eQ2p-bW3Y.c.d0q0sQ6m2qW6z3V3X3]5TU9U6{6}7PU:e9W9X9ZS;T:d:gQ;b;UR;j;cU!wQ'^-`T5o1g5q!Q_OXZ`st!V!Z#d#h%d%l&g&i&p&r&s&u(h,n,s.V2S2V]!pQ!r'^-`1g5qT#q];w%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS({#y#zS.](k(l!s=^$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU$fd)],hS(n#p'gU*s%R(u3vU0e*z.i7]Q5T0rQ6{3WQ9X7OR:g9Ym!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sQ'r!uS(d#g1|S-n'i'uQ/n*ZQ/{*gQ2|-qQ4]/oQ4i/}Q4j0OQ4o0WQ7h4WS7s4k4mS7w4p4rQ9g7iQ9k7oQ9p7tQ9u7yS:o9l9mS;Y:p:sS;e;Z;[S;m;f;gS;q;n;oR;t;rQ#wbQ'q!uS(c#g1|S(e#m+TQ+V%eQ+g%wQ+m%}U-m'i'r'uQ.R(dQ/m*ZQ/|*gQ0P*iQ0x+hQ1m,[S2y-n-qQ3R.ZS4[/n/oQ4e/yS4h/{0WQ4l0QQ5|1nQ6u2|Q7g4WQ7k4]U7r4i4o4rQ7u4nQ8k5}S9f7h7iQ9j7oQ9r7wQ9s7xQ:V8lQ:m9gS:n9k9mQ:v9uQ;P:WS;X:o:sS;d;Y;ZS;l;e;gS;p;m;oQ;s;qQ;u;tQ=a=[Q=l=eR=m=fV!wQ'^-`%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS#wz!j!r=Z$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=a=r%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SQ%ej!^%wy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pS%}z!jQ+h%xQ,[&bW1n,],^,_,`U5}1o1p1qS8l6O6PQ:W8m!r=[$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ=e=qR=f=r%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SY#bWZ#W#Z(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ,i&m!p=]$Z$n)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=`'VU'Z!e%h*XR2k-Z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9S!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ,h&mQ0r+dQ3W.bQ7O3[R9Y7Q!b$Tc#Y%p(Q(W(r(w)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!P<U)[)o-U.w2c2f3h3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!f$Vc#Y%p(Q(W(r(w)U)V)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!T<W)[)o-U.w2c2f3h3n3o3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!^$Zc#Y%p(Q(W(r(w)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;xQ4V/fz=s)[)o-U.w2c2f3h3w4P6k7W7a7b8`8|9[9b9c:y;R=gQ=x=zR=y={'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS$oh$pR3|/P'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$kf$qQ$ifS)h$l)lR)t$qT$jf$qT)j$l)l'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$oh$pQ$rhR)s$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9S!s=q$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s#glOPXZst!Z!`!o#S#d#o#{$n%l&i&l&m&p&r&s&u&y'R'`(|)q*f+Y+d,k,n,s-d.b/Q/i0V0d1j1z1{1}2P2S2V2X3[3{4q5y6Z6[6_7Q8i8x!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}Q+P%`Q/^)|o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!U$yi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yQ*`$zU*i$|*X*lQ+Q%aQ0Q*j#f=c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n=d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YQ=h=tQ=i=uQ=j=vR=k=w!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YnoOXst!Z#d%l&p&r&s&u,n,s2S2VS*c${*WQ,|&|Q,}'OR4`/s%[%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q,P&ZQ1`,RQ5i1_R8]5jV*k$|*X*lU*k$|*X*lT5p1g5qS/y*f/iQ4n0VT7x4q:PQ+g%wQ0P*iQ0x+hQ1m,[Q5|1nQ8k5}Q:V8lR;P:W!U%Oi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yx*P$v)c*Q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=oS0Y*q0Z#f<a#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<b<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!d<t(s)a*Y*b.e.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={`<u3u7X7[7`9]:h:k;kS=P.g3aT=Q7Z9`!U%Qi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y|*R$v)c*S*q+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=oS0[*r0]#f<c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!h<v(s)a*Y*b.f.g.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={d<w3u7Y7Z7`9]9^:h:i:k;kS=R.h3bT=S7[9arnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ&d!UR,k&mrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR&d!UQ,T&[R1[+|snOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ1h,YS5w1k1lU8e5u5v5zS:R8g8hS:{:Q:TQ;_:|R;i;`Q&k!VR,d&gR6T1tR:Y8nS&P|&UR1T+sQ&p!WR,n&qR,t&vT2T,s2VR,x&wQ,w&wR2^,xQ'w!{R-t'wSsOtQ#dXT%os#dQ#OTR'y#OQ#RUR'{#RQ)y$uR/Z)yQ#UVR(O#UQ#XWU(U#X(V-{Q(V#YR-{(WQ-X'WR2j-XQ.p(wS3e.p3fR3f.qQ-`'^R2n-`Y!rQ'^-`1g5qR'h!rQ.{)cR3z.{U#_W%g*WU(]#_(^-|Q(^#`R-|(XQ-['ZR2l-[t`OXst!V!Z#d%l&g&i&p&r&s&u,n,s2S2VS#hZ%dU#r`#h.VR.V(hQ(i#jQ.S(eW.[(i.S3P6wQ3P.TR6w3QQ)l$lR/R)lQ$phR)r$pQ$`cU)_$`-w<[Q-w;xR<[)oQ/l*ZW4Y/l4Z7j9hU4Z/m/n/oS7j4[4]R9h7k$e*O$v(s)a)c*Y*b*q*r*|*}+R.g.h.j.k.l/Y/b/d/f/q/v0^0_0p1]3^3_3`3u3y4S4^4_4c4s4u4{4|4}5h7R7S7T7U7Z7[7^7_7`7f7m7p7z7}8P9]9^9_9i9q9v9w:h:i:j:k:l:q:u;W;];h;k=b=n=o=z={Q/t*bU4b/t4d7nQ4d/vR7n4cS*l$|*XR0S*lx*Q$v)c*q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=o!d.e(s)a*Y*b.g.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/c*Q.e7Xa7X3u7Z7[7`9]:h:k;kQ0Z*qQ3a.gU4t0Z3a9`R9`7Z|*S$v)c*q*r+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=o!h.f(s)a*Y*b.g.h.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/e*S.f7Ye7Y3u7Z7[7`9]9^:h:i:k;kQ0]*rQ3b.hU4v0]3b9aR9a7[Q*w%UR0a*wQ5S0pR8O5SQ+[%jR0o+[Q5l1bS8_5l:OR:O8`Q,V&]R1e,VQ5q1gR8b5qQ1s,aS6R1s8oR8o6TQ1O+oW5_1O5a8V9zQ5a1RQ8V5`R9z8WQ+t&PR1U+tQ2V,sR6c2VYrOXst#dQ&t!ZQ+^%lQ,m&pQ,o&rQ,p&sQ,r&uQ2Q,nS2T,s2VR6b2SQ%npQ&x!_Q&{!aQ&}!bQ'P!cQ'o!uQ+]%kQ+i%yQ+{&VQ,c&kQ,z&zW-k'i'q'r'uQ-r'mQ0R*kQ0y+jS1v,d,gQ2_,yQ2`,|Q2a,}Q2u-jW2w-m-n-q-sQ5W0zQ5d1XQ5g1]Q5{1mQ6V1xQ6a2RU6p2v2y2|Q6s2zQ8R5XQ8Z5fQ8[5hQ8a5pQ8j5|Q8p6US9P6q6uQ9R6tQ9{8XQ:U8kQ:Z8qQ:b9QQ:x9|Q;O:VQ;S:cR;a;PQ%yyQ'b!iQ'm!uU+j%z%{%|Q-R'TU-f'c'd'eS-j'i'sQ/z*gS0z+k+lQ2g-TS2s-g-hQ2z-oS4g/{0OQ5X0{Q6l2mQ6o2tQ6t2{U7q4i4j4mQ9o7sR:r9pS$wi=pR*x%VU%Ui%V=pR0`*vQ$viS(s#v+fS)a$b$cQ)c$dQ*Y$xS*b${*WQ*q%OQ*r%QQ*|%]Q*}%^Q+R%bQ.g<aQ.h<cQ.j<gQ.k<iQ.l<kQ/Y)wQ/b*PQ/d*RQ/f*TQ/q*^S/v*d/hQ0^*tQ0_*ul0p+c,Q.a1a1i3Z5x6|8f9V:S:f:};VQ1]+}Q3^<tQ3_<vQ3`<yS3u<^<_Q3y.zS4S/_4UQ4^/rQ4_/sQ4c/uQ4s0YQ4u0[Q4{0gQ4|0hQ4}0iQ5h1^Q7R<}Q7S=PQ7T=RQ7U=TQ7Z<bQ7[<dQ7^<hQ7_<jQ7`<lQ7f4VQ7m4aQ7p4fQ7z4wQ7}5RQ8P5UQ9]<zQ9^<uQ9_<wQ9i7lQ9q7vQ9v7|Q9w8QQ:h=OQ:i=QQ:j=SQ:k=UQ:l9eQ:q9nQ:u9tQ;W=XQ;]:tQ;h;^Q;k=YQ=b=pQ=n=xQ=o=yQ=z=|R={=}Q*z%[Q.i<eR7]<fnpOXst!Z#d%l&p&r&s&u,n,s2S2VQ!fPS#fZ#oQ&z!`W'f!o*f0V4qQ'}#SQ)O#{Q)p$nS,g&i&lQ,l&mQ,y&yS-O'R/iQ-b'`Q.s(|Q/V)qQ0m+YQ0s+dQ2O,kQ2q-dQ3X.bQ4O/QQ4y0dQ5v1jQ6X1zQ6Y1{Q6^1}Q6`2PQ6e2XQ7P3[Q7c3{Q8h5yQ8t6ZQ8u6[Q8w6_Q9Z7QQ:T8iR:_8x#[cOPXZst!Z!`!o#d#o#{%l&i&l&m&p&r&s&u&y'R'`(|*f+Y+d,k,n,s-d.b/i0V0d1j1z1{1}2P2S2V2X3[4q5y6Z6[6_7Q8i8xQ#YWQ#eYQ%puQ%rvS%tw!gS(Q#W(TQ(W#ZQ(r#uQ(w#xQ)P$OQ)Q$PQ)R$QQ)S$RQ)T$SQ)U$TQ)V$UQ)W$VQ)X$WQ)Y$XQ)[$ZQ)^$_Q)`$aQ)e$eW)o$n)q/Q3{Q+a%sQ+u&QS-U'V2hQ-s'pS-x(R-zQ-}(ZQ.P(bQ.n(vQ.q(xQ.u;vQ.w;yQ.x;zQ.y;}Q/]){Q0j+UQ2c-PQ2f-SQ2v-lQ2}.QQ3c.oQ3h<OQ3i<PQ3j<QQ3k<RQ3l<SQ3m<TQ3n<UQ3o<VQ3p<WQ3q<XQ3r<YQ3s.vQ3t<]Q3w<`Q3x<mQ4P<ZQ5O0lQ5Y0|Q6k<pQ6q2xQ6v3OQ7V3dQ7W<qQ7a<sQ7b<{Q8`5mQ8|6iQ9Q6rQ9[<|Q9b=VQ9c=WQ:c9SQ:y9}Q;R:aQ;x#SR=g=sR#[WR'X!el!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sS'T!e-WU*g$|*X*lS-T'U']S0O*h*nQ0W*oQ2m-^Q4m0UR4r0XR(y#xQ!fQT-_'^-`]!qQ!r'^-`1g5qQ#p]R'g;wR)d$dY!uQ'^-`1g5qQ'i!rS's!v!yS'u!z5sS-o'j'kQ-q'lR2{-pT#kZ%dS#jZ%dS%jm,jU(e#h#i#lS.T(f(gQ.X(hQ0n+ZQ3Q.UU3R.V.W.YS6x3S3TR9T6yd#^W#W#Z%g(R([*W+W.O/hr#gZm#h#i#l%d(f(g(h+Z.U.V.W.Y3S3T6yS*Z$x*_Q/o*[Q1|,jQ2d-QQ4W/kQ6g2[Q7i4XQ8{6hT=_'V+XV#aW%g*WU#`W%g*WS(S#W([U(X#Z+W/hS-V'V+XT-y(R.OV'[!e%h*XQ$lfR)v$qT)k$l)lR3}/PT*]$x*_T*e${*WQ0q+cQ1_,QQ3V.aQ5j1aQ5u1iQ6}3ZQ8g5xQ9W6|Q:Q8fQ:d9VQ:|:SQ;U:fQ;`:}R;c;VnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&j!VR,c&gtmOXst!U!V!Z#d%l&g&p&r&s&u,n,s2S2VR,j&mT%km,jR1c,SR,b&eQ&T|R+z&UR+p&OT&n!W&qT&o!W&qT2U,s2V",
  nodeNames: "⚠ ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList in out const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
  maxTerm: 379,
  context: Izt,
  nodeProps: [
    ["isolate", -8, 5, 6, 14, 37, 39, 51, 53, 55, ""],
    ["group", -26, 9, 17, 19, 68, 207, 211, 215, 216, 218, 221, 224, 234, 236, 242, 244, 246, 248, 251, 257, 263, 265, 267, 269, 271, 273, 274, "Statement", -34, 13, 14, 32, 35, 36, 42, 51, 54, 55, 57, 62, 70, 72, 76, 80, 82, 84, 85, 110, 111, 120, 121, 136, 139, 141, 142, 143, 144, 145, 147, 148, 167, 169, 171, "Expression", -23, 31, 33, 37, 41, 43, 45, 173, 175, 177, 178, 180, 181, 182, 184, 185, 186, 188, 189, 190, 201, 203, 205, 206, "Type", -3, 88, 103, 109, "ClassItem"],
    ["openedBy", 23, "<", 38, "InterpolationStart", 56, "[", 60, "{", 73, "(", 160, "JSXStartCloseTag"],
    ["closedBy", -2, 24, 168, ">", 40, "InterpolationEnd", 50, "]", 61, "}", 74, ")", 165, "JSXEndTag"]
  ],
  propSources: [zzt],
  skippedNodes: [0, 5, 6, 277],
  repeatNodeCount: 37,
  tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$i&j(Y!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(Y!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$i&j(VpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(VpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Vp(Y!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$i&j(Vp(Y!b'{0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(W#S$i&j'|0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$i&j(Vp(Y!b'|0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$i&j!p),Q(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#v(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#v(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(U':f$i&j(Y!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$i&j(Y!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$i&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$d`$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$d``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$d`$i&j(Y!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(Y!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$d`(Y!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$i&j(Vp(Y!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$i&j(Vp(Y!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$i&j(Y!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$i&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(Y!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$i&j(VpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(VpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Vp(Y!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$i&j(n%1l(Vp(Y!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$i&j(Vp(Y!b$]#t(S,2j(d$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$i&j(Vp(Y!b$]#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$i&j(Vp(Y!b#p(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$i&j$Q(Ch(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(y+JY$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$i&j#z(Ch(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(X';W$i&j(VpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$i&j(VpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$i&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$d`$i&j(VpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(VpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$d`(VpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!l/.^$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!k!Lf$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$i&j(Vp(Y!b(T%&f#q(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$i&j(Vp(Y!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$i&j(Vp(Y!br+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!]+Jf$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$i&j(Vp(Y!b!Q.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_![!L^$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$i&j(Vp(Y!b#o(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$i&j(Vp(Y!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$i&j(Y!b!X7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$i&j!X7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$i&j!X7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!X7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!X7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$i&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$i&j(Y!b!X7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(Y!b!X7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(Y!b!X7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(Y!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$i&j(Y!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$i&j(Vp!X7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$i&j(Vp!X7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Vp!X7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Vp!X7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(VpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$i&j(VpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$i&j(Vp(Y!b!X7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Vp(Y!b!X7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Vp(Y!b!X7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Vp(Y!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$i&j(Vp(Y!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$i&j(Vp(Y!b'}0/l!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$i&j(Vp(Y!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$i&j(Y!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$i&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(Y!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$i&j(VpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(VpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Vp(Y!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$i&j$Q(Ch(Vp(Y!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Z#t$i&j(Vp(Y!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$i&j(Vp(Y!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!g$b$i&j$O)Lv(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#R-<U(Vp(Y!b$n7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$k&j(Vp(Y!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#r(Ch(Vp(Y!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$Q(Ch(Vp(Y!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#s(Ch(Vp(Y!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#`*!Y$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#k(Cl$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#s(Ch$f#|$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#s(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#r(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#r(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(q(Ct$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$i&j#{(Ch(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!|$Ip$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!S0,v$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$i&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$i&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$i&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$i&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$i&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!Y#)l$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#x(Ch$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$i&j(Vp(Y!b(`+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$i&j(Vp(Y!b(S,2j$_#t(d$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$i&j(Vp(Y!b$_#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!_#Hb(Vp(Y!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(x+JY$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_!^(CdvBr$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!q7`$i&j(Vp(Y!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$i&j(Vp(Y!b'{0/l$]#t(S,2j(d$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$i&j(Vp(Y!b'|0/l$]#t(S,2j(d$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
  tokenizers: [Mzt, Dzt, _zt, Lzt, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, Rzt, new k9("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOx~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!U~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(b~~", 141, 339), new k9("j~RQYZXz{^~^O(P~~aP!P!Qd~iO(Q~~", 25, 322)],
  topRules: { Script: [0, 7], SingleExpression: [1, 275], SingleClassItem: [2, 276] },
  dialects: { jsx: 0, ts: 15098 },
  dynamicPrecedences: { 80: 1, 82: 1, 94: 1, 169: 1, 199: 1 },
  specialized: [{ term: 326, get: (e) => jzt[e] || -1 }, { term: 342, get: (e) => Fzt[e] || -1 }, { term: 95, get: (e) => Uzt[e] || -1 }],
  tokenPrec: 15124
});
let R9 = [], s_e = [];
(() => {
  let e = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
  for (let t = 0, n = 0; t < e.length; t++)
    (t % 2 ? s_e : R9).push(n = n + e[t]);
})();
function qzt(e) {
  if (e < 768) return !1;
  for (let t = 0, n = R9.length; ; ) {
    let r = t + n >> 1;
    if (e < R9[r]) n = r;
    else if (e >= s_e[r]) t = r + 1;
    else return !0;
    if (t == n) return !1;
  }
}
function zce(e) {
  return e >= 127462 && e <= 127487;
}
const jce = 8205;
function Bzt(e, t, n = !0, r = !0) {
  return (n ? a_e : Xzt)(e, t, r);
}
function a_e(e, t, n) {
  if (t == e.length) return t;
  t && l_e(e.charCodeAt(t)) && c_e(e.charCodeAt(t - 1)) && t--;
  let r = PU(e, t);
  for (t += Fce(r); t < e.length; ) {
    let i = PU(e, t);
    if (r == jce || i == jce || n && qzt(i))
      t += Fce(i), r = i;
    else if (zce(i)) {
      let o = 0, s = t - 2;
      for (; s >= 0 && zce(PU(e, s)); )
        o++, s -= 2;
      if (o % 2 == 0) break;
      t += 2;
    } else
      break;
  }
  return t;
}
function Xzt(e, t, n) {
  for (; t > 0; ) {
    let r = a_e(e, t - 2, n);
    if (r < t) return r;
    t--;
  }
  return 0;
}
function PU(e, t) {
  let n = e.charCodeAt(t);
  if (!c_e(n) || t + 1 == e.length) return n;
  let r = e.charCodeAt(t + 1);
  return l_e(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function l_e(e) {
  return e >= 56320 && e < 57344;
}
function c_e(e) {
  return e >= 55296 && e < 56320;
}
function Fce(e) {
  return e < 65536 ? 1 : 2;
}
let Sr = class u_e {
  /**
  Get the line description around the given position.
  */
  lineAt(t) {
    if (t < 0 || t > this.length)
      throw new RangeError(`Invalid position ${t} in document of length ${this.length}`);
    return this.lineInner(t, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(t) {
    if (t < 1 || t > this.lines)
      throw new RangeError(`Invalid line number ${t} in ${this.lines}-line document`);
    return this.lineInner(t, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(t, n, r) {
    [t, n] = Aw(this, t, n);
    let i = [];
    return this.decompose(
      0,
      t,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      i,
      1
      /* Open.From */
    ), ef.from(i, this.length - (n - t) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(t) {
    return this.replace(this.length, this.length, t);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(t, n = this.length) {
    [t, n] = Aw(this, t, n);
    let r = [];
    return this.decompose(t, n, r, 0), ef.from(r, n - t);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(t) {
    if (t == this)
      return !0;
    if (t.length != this.length || t.lines != this.lines)
      return !1;
    let n = this.scanIdentical(t, 1), r = this.length - this.scanIdentical(t, -1), i = new _E(this), o = new _E(t);
    for (let s = n, l = n; ; ) {
      if (i.next(s), o.next(s), s = 0, i.lineBreak != o.lineBreak || i.done != o.done || i.value != o.value)
        return !1;
      if (l += i.value.length, i.done || l >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(t = 1) {
    return new _E(this, t);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(t, n = this.length) {
    return new d_e(this, t, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(t, n) {
    let r;
    if (t == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let i = this.line(t).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new f_e(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let t = [];
    return this.flatten(t), t;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(t) {
    if (t.length == 0)
      throw new RangeError("A document must have at least one line");
    return t.length == 1 && !t[0] ? u_e.empty : t.length <= 32 ? new Zi(t) : ef.from(Zi.split(t, []));
  }
};
class Zi extends Sr {
  constructor(t, n = Wzt(t)) {
    super(), this.text = t, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(t, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.text[o], l = i + s.length;
      if ((n ? r : l) >= t)
        return new Zzt(i, l, r, s);
      i = l + 1, r++;
    }
  }
  decompose(t, n, r, i) {
    let o = t <= 0 && n >= this.length ? this : new Zi(Uce(this.text, t, n), Math.min(n, this.length) - Math.max(0, t));
    if (i & 1) {
      let s = r.pop(), l = uM(o.text, s.text.slice(), 0, o.length);
      if (l.length <= 32)
        r.push(new Zi(l, s.length + o.length));
      else {
        let c = l.length >> 1;
        r.push(new Zi(l.slice(0, c)), new Zi(l.slice(c)));
      }
    } else
      r.push(o);
  }
  replace(t, n, r) {
    if (!(r instanceof Zi))
      return super.replace(t, n, r);
    [t, n] = Aw(this, t, n);
    let i = uM(this.text, uM(r.text, Uce(this.text, 0, t)), n), o = this.length + r.length - (n - t);
    return i.length <= 32 ? new Zi(i, o) : ef.from(Zi.split(i, []), o);
  }
  sliceString(t, n = this.length, r = `
`) {
    [t, n] = Aw(this, t, n);
    let i = "";
    for (let o = 0, s = 0; o <= n && s < this.text.length; s++) {
      let l = this.text[s], c = o + l.length;
      o > t && s && (i += r), t < c && n > o && (i += l.slice(Math.max(0, t - o), n - o)), o = c + 1;
    }
    return i;
  }
  flatten(t) {
    for (let n of this.text)
      t.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(t, n) {
    let r = [], i = -1;
    for (let o of t)
      r.push(o), i += o.length + 1, r.length == 32 && (n.push(new Zi(r, i)), r = [], i = -1);
    return i > -1 && n.push(new Zi(r, i)), n;
  }
}
class ef extends Sr {
  constructor(t, n) {
    super(), this.children = t, this.length = n, this.lines = 0;
    for (let r of t)
      this.lines += r.lines;
  }
  lineInner(t, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.children[o], l = i + s.length, c = r + s.lines - 1;
      if ((n ? c : l) >= t)
        return s.lineInner(t, n, r, i);
      i = l + 1, r = c + 1;
    }
  }
  decompose(t, n, r, i) {
    for (let o = 0, s = 0; s <= n && o < this.children.length; o++) {
      let l = this.children[o], c = s + l.length;
      if (t <= c && n >= s) {
        let a = i & ((s <= t ? 1 : 0) | (c >= n ? 2 : 0));
        s >= t && c <= n && !a ? r.push(l) : l.decompose(t - s, n - s, r, a);
      }
      s = c + 1;
    }
  }
  replace(t, n, r) {
    if ([t, n] = Aw(this, t, n), r.lines < this.lines)
      for (let i = 0, o = 0; i < this.children.length; i++) {
        let s = this.children[i], l = o + s.length;
        if (t >= o && n <= l) {
          let c = s.replace(t - o, n - o, r), a = this.lines - s.lines + c.lines;
          if (c.lines < a >> 4 && c.lines > a >> 6) {
            let u = this.children.slice();
            return u[i] = c, new ef(u, this.length - (n - t) + r.length);
          }
          return super.replace(o, l, c);
        }
        o = l + 1;
      }
    return super.replace(t, n, r);
  }
  sliceString(t, n = this.length, r = `
`) {
    [t, n] = Aw(this, t, n);
    let i = "";
    for (let o = 0, s = 0; o < this.children.length && s <= n; o++) {
      let l = this.children[o], c = s + l.length;
      s > t && o && (i += r), t < c && n > s && (i += l.sliceString(t - s, n - s, r)), s = c + 1;
    }
    return i;
  }
  flatten(t) {
    for (let n of this.children)
      n.flatten(t);
  }
  scanIdentical(t, n) {
    if (!(t instanceof ef))
      return 0;
    let r = 0, [i, o, s, l] = n > 0 ? [0, 0, this.children.length, t.children.length] : [this.children.length - 1, t.children.length - 1, -1, -1];
    for (; ; i += n, o += n) {
      if (i == s || o == l)
        return r;
      let c = this.children[i], a = t.children[o];
      if (c != a)
        return r + c.scanIdentical(a, n);
      r += c.length + 1;
    }
  }
  static from(t, n = t.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let p of t)
      r += p.lines;
    if (r < 32) {
      let p = [];
      for (let h of t)
        h.flatten(p);
      return new Zi(p, n);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), o = i << 1, s = i >> 1, l = [], c = 0, a = -1, u = [];
    function f(p) {
      let h;
      if (p.lines > o && p instanceof ef)
        for (let m of p.children)
          f(m);
      else p.lines > s && (c > s || !c) ? (d(), l.push(p)) : p instanceof Zi && c && (h = u[u.length - 1]) instanceof Zi && p.lines + h.lines <= 32 ? (c += p.lines, a += p.length + 1, u[u.length - 1] = new Zi(h.text.concat(p.text), h.length + 1 + p.length)) : (c + p.lines > i && d(), c += p.lines, a += p.length + 1, u.push(p));
    }
    function d() {
      c != 0 && (l.push(u.length == 1 ? u[0] : ef.from(u, a)), a = -1, c = u.length = 0);
    }
    for (let p of t)
      f(p);
    return d(), l.length == 1 ? l[0] : new ef(l, n);
  }
}
Sr.empty = /* @__PURE__ */ new Zi([""], 0);
function Wzt(e) {
  let t = -1;
  for (let n of e)
    t += n.length + 1;
  return t;
}
function uM(e, t, n = 0, r = 1e9) {
  for (let i = 0, o = 0, s = !0; o < e.length && i <= r; o++) {
    let l = e[o], c = i + l.length;
    c >= n && (c > r && (l = l.slice(0, r - i)), i < n && (l = l.slice(n - i)), s ? (t[t.length - 1] += l, s = !1) : t.push(l)), i = c + 1;
  }
  return t;
}
function Uce(e, t, n) {
  return uM(e, [""], t, n);
}
class _E {
  constructor(t, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [t], this.offsets = [n > 0 ? 1 : (t instanceof Zi ? t.text.length : t.children.length) << 1];
  }
  nextInner(t, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], o = this.offsets[r], s = o >> 1, l = i instanceof Zi ? i.text.length : i.children.length;
      if (s == (n > 0 ? l : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((o & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, t == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        t--;
      } else if (i instanceof Zi) {
        let c = i.text[s + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, c.length > Math.max(0, t))
          return this.value = t == 0 ? c : n > 0 ? c.slice(t) : c.slice(0, c.length - t), this;
        t -= c.length;
      } else {
        let c = i.children[s + (n < 0 ? -1 : 0)];
        t > c.length ? (t -= c.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(c), this.offsets.push(n > 0 ? 1 : (c instanceof Zi ? c.text.length : c.children.length) << 1));
      }
    }
  }
  next(t = 0) {
    return t < 0 && (this.nextInner(-t, -this.dir), t = this.value.length), this.nextInner(t, this.dir);
  }
}
class d_e {
  constructor(t, n, r) {
    this.value = "", this.done = !1, this.cursor = new _E(t, n > r ? -1 : 1), this.pos = n > r ? t.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(t, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    t += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    t > r && (t = r), r -= t;
    let { value: i } = this.cursor.next(t);
    return this.pos += (i.length + t) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(t = 0) {
    return t < 0 ? t = Math.max(t, this.from - this.pos) : t > 0 && (t = Math.min(t, this.to - this.pos)), this.nextInner(t, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class f_e {
  constructor(t) {
    this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(t = 0) {
    let { done: n, lineBreak: r, value: i } = this.inner.next(t);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (Sr.prototype[Symbol.iterator] = function() {
  return this.iter();
}, _E.prototype[Symbol.iterator] = d_e.prototype[Symbol.iterator] = f_e.prototype[Symbol.iterator] = function() {
  return this;
});
class Zzt {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function Aw(e, t, n) {
  return t = Math.max(0, Math.min(e.length, t)), [t, Math.max(t, Math.min(e.length, n))];
}
function xs(e, t, n = !0, r = !0) {
  return Bzt(e, t, n, r);
}
function Hzt(e) {
  return e >= 56320 && e < 57344;
}
function Qzt(e) {
  return e >= 55296 && e < 56320;
}
function el(e, t) {
  let n = e.charCodeAt(t);
  if (!Qzt(n) || t + 1 == e.length)
    return n;
  let r = e.charCodeAt(t + 1);
  return Hzt(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function xG(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
function tf(e) {
  return e < 65536 ? 1 : 2;
}
const M9 = /\r\n?|\n/;
var Os = /* @__PURE__ */ function(e) {
  return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
}(Os || (Os = {}));
class vf {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(t) {
    this.sections = t;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let t = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      t += this.sections[n];
    return t;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let t = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      t += r < 0 ? this.sections[n] : r;
    }
    return t;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(t) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length; ) {
      let o = this.sections[n++], s = this.sections[n++];
      s < 0 ? (t(r, i, o), i += o) : i += s, r += o;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(t, n = !1) {
    D9(this, t, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let t = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? t.push(r, i) : t.push(i, r);
    }
    return new vf(t);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(t) {
    return this.empty ? t : t.empty ? this : p_e(this, t);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(t, n = !1) {
    return t.empty ? this : _9(this, t, n);
  }
  mapPos(t, n = -1, r = Os.Simple) {
    let i = 0, o = 0;
    for (let s = 0; s < this.sections.length; ) {
      let l = this.sections[s++], c = this.sections[s++], a = i + l;
      if (c < 0) {
        if (a > t)
          return o + (t - i);
        o += l;
      } else {
        if (r != Os.Simple && a >= t && (r == Os.TrackDel && i < t && a > t || r == Os.TrackBefore && i < t || r == Os.TrackAfter && a > t))
          return null;
        if (a > t || a == t && n < 0 && !l)
          return t == i || n < 0 ? o : o + c;
        o += c;
      }
      i = a;
    }
    if (t > i)
      throw new RangeError(`Position ${t} is out of range for changeset of length ${i}`);
    return o;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(t, n = t) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n; ) {
      let o = this.sections[r++], s = this.sections[r++], l = i + o;
      if (s >= 0 && i <= n && l >= t)
        return i < t && l > n ? "cover" : !0;
      i = l;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      t += (t ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return t;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2 || t.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new vf(t);
  }
  /**
  @internal
  */
  static create(t) {
    return new vf(t);
  }
}
class Ro extends vf {
  constructor(t, n) {
    super(t), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(t) {
    if (this.length != t.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return D9(this, (n, r, i, o, s) => t = t.replace(i, i + (r - n), s), !1), t;
  }
  mapDesc(t, n = !1) {
    return _9(this, t, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(t) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, o = 0; i < n.length; i += 2) {
      let s = n[i], l = n[i + 1];
      if (l >= 0) {
        n[i] = l, n[i + 1] = s;
        let c = i >> 1;
        for (; r.length < c; )
          r.push(Sr.empty);
        r.push(s ? t.slice(o, o + s) : Sr.empty);
      }
      o += s;
    }
    return new Ro(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(t) {
    return this.empty ? t : t.empty ? this : p_e(this, t, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(t, n = !1) {
    return t.empty ? this : _9(this, t, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(t, n = !1) {
    D9(this, t, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return vf.create(this.sections);
  }
  /**
  @internal
  */
  filter(t) {
    let n = [], r = [], i = [], o = new uk(this);
    e: for (let s = 0, l = 0; ; ) {
      let c = s == t.length ? 1e9 : t[s++];
      for (; l < c || l == c && o.len == 0; ) {
        if (o.done)
          break e;
        let u = Math.min(o.len, c - l);
        Ws(i, u, -1);
        let f = o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0;
        Ws(n, u, f), f > 0 && Lm(r, n, o.text), o.forward(u), l += u;
      }
      let a = t[s++];
      for (; l < a; ) {
        if (o.done)
          break e;
        let u = Math.min(o.len, a - l);
        Ws(n, u, -1), Ws(i, u, o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0), o.forward(u), l += u;
      }
    }
    return {
      changes: new Ro(n, r),
      filtered: vf.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let t = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? t.push(r) : i == 0 ? t.push([r]) : t.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return t;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(t, n, r) {
    let i = [], o = [], s = 0, l = null;
    function c(u = !1) {
      if (!u && !i.length)
        return;
      s < n && Ws(i, n - s, -1);
      let f = new Ro(i, o);
      l = l ? l.compose(f.map(l)) : f, i = [], o = [], s = 0;
    }
    function a(u) {
      if (Array.isArray(u))
        for (let f of u)
          a(f);
      else if (u instanceof Ro) {
        if (u.length != n)
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${n})`);
        c(), l = l ? l.compose(u.map(l)) : u;
      } else {
        let { from: f, to: d = f, insert: p } = u;
        if (f > d || f < 0 || d > n)
          throw new RangeError(`Invalid change range ${f} to ${d} (in doc of length ${n})`);
        let h = p ? typeof p == "string" ? Sr.of(p.split(r || M9)) : p : Sr.empty, m = h.length;
        if (f == d && m == 0)
          return;
        f < s && c(), f > s && Ws(i, f - s, -1), Ws(i, d - f, m), Lm(o, i, h), s = d;
      }
    }
    return a(t), c(!l), l;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(t) {
    return new Ro(t ? [t, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (typeof o == "number")
        n.push(o, -1);
      else {
        if (!Array.isArray(o) || typeof o[0] != "number" || o.some((s, l) => l && typeof s != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (o.length == 1)
          n.push(o[0], 0);
        else {
          for (; r.length < i; )
            r.push(Sr.empty);
          r[i] = Sr.of(o.slice(1)), n.push(o[0], r[i].length);
        }
      }
    }
    return new Ro(n, r);
  }
  /**
  @internal
  */
  static createSet(t, n) {
    return new Ro(t, n);
  }
}
function Ws(e, t, n, r = !1) {
  if (t == 0 && n <= 0)
    return;
  let i = e.length - 2;
  i >= 0 && n <= 0 && n == e[i + 1] ? e[i] += t : i >= 0 && t == 0 && e[i] == 0 ? e[i + 1] += n : r ? (e[i] += t, e[i + 1] += n) : e.push(t, n);
}
function Lm(e, t, n) {
  if (n.length == 0)
    return;
  let r = t.length - 2 >> 1;
  if (r < e.length)
    e[e.length - 1] = e[e.length - 1].append(n);
  else {
    for (; e.length < r; )
      e.push(Sr.empty);
    e.push(n);
  }
}
function D9(e, t, n) {
  let r = e.inserted;
  for (let i = 0, o = 0, s = 0; s < e.sections.length; ) {
    let l = e.sections[s++], c = e.sections[s++];
    if (c < 0)
      i += l, o += l;
    else {
      let a = i, u = o, f = Sr.empty;
      for (; a += l, u += c, c && r && (f = f.append(r[s - 2 >> 1])), !(n || s == e.sections.length || e.sections[s + 1] < 0); )
        l = e.sections[s++], c = e.sections[s++];
      t(i, a, o, u, f), i = a, o = u;
    }
  }
}
function _9(e, t, n, r = !1) {
  let i = [], o = r ? [] : null, s = new uk(e), l = new uk(t);
  for (let c = -1; ; ) {
    if (s.done && l.len || l.done && s.len)
      throw new Error("Mismatched change set lengths");
    if (s.ins == -1 && l.ins == -1) {
      let a = Math.min(s.len, l.len);
      Ws(i, a, -1), s.forward(a), l.forward(a);
    } else if (l.ins >= 0 && (s.ins < 0 || c == s.i || s.off == 0 && (l.len < s.len || l.len == s.len && !n))) {
      let a = l.len;
      for (Ws(i, l.ins, -1); a; ) {
        let u = Math.min(s.len, a);
        s.ins >= 0 && c < s.i && s.len <= u && (Ws(i, 0, s.ins), o && Lm(o, i, s.text), c = s.i), s.forward(u), a -= u;
      }
      l.next();
    } else if (s.ins >= 0) {
      let a = 0, u = s.len;
      for (; u; )
        if (l.ins == -1) {
          let f = Math.min(u, l.len);
          a += f, u -= f, l.forward(f);
        } else if (l.ins == 0 && l.len < u)
          u -= l.len, l.next();
        else
          break;
      Ws(i, a, c < s.i ? s.ins : 0), o && c < s.i && Lm(o, i, s.text), c = s.i, s.forward(s.len - u);
    } else {
      if (s.done && l.done)
        return o ? Ro.createSet(i, o) : vf.create(i);
      throw new Error("Mismatched change set lengths");
    }
  }
}
function p_e(e, t, n = !1) {
  let r = [], i = n ? [] : null, o = new uk(e), s = new uk(t);
  for (let l = !1; ; ) {
    if (o.done && s.done)
      return i ? Ro.createSet(r, i) : vf.create(r);
    if (o.ins == 0)
      Ws(r, o.len, 0, l), o.next();
    else if (s.len == 0 && !s.done)
      Ws(r, 0, s.ins, l), i && Lm(i, r, s.text), s.next();
    else {
      if (o.done || s.done)
        throw new Error("Mismatched change set lengths");
      {
        let c = Math.min(o.len2, s.len), a = r.length;
        if (o.ins == -1) {
          let u = s.ins == -1 ? -1 : s.off ? 0 : s.ins;
          Ws(r, c, u, l), i && u && Lm(i, r, s.text);
        } else s.ins == -1 ? (Ws(r, o.off ? 0 : o.len, c, l), i && Lm(i, r, o.textBit(c))) : (Ws(r, o.off ? 0 : o.len, s.off ? 0 : s.ins, l), i && !s.off && Lm(i, r, s.text));
        l = (o.ins > c || s.ins >= 0 && s.len > c) && (l || r.length > a), o.forward2(c), s.forward(c);
      }
    }
  }
}
class uk {
  constructor(t) {
    this.set = t, this.i = 0, this.next();
  }
  next() {
    let { sections: t } = this.set;
    this.i < t.length ? (this.len = t[this.i++], this.ins = t[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: t } = this.set, n = this.i - 2 >> 1;
    return n >= t.length ? Sr.empty : t[n];
  }
  textBit(t) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !t ? Sr.empty : n[r].slice(this.off, t == null ? void 0 : this.off + t);
  }
  forward(t) {
    t == this.len ? this.next() : (this.len -= t, this.off += t);
  }
  forward2(t) {
    this.ins == -1 ? this.forward(t) : t == this.ins ? this.next() : (this.ins -= t, this.off += t);
  }
}
class Iy {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let t = this.flags & 7;
    return t == 7 ? null : t;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let t = this.flags >> 6;
    return t == 16777215 ? void 0 : t;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(t, n = -1) {
    let r, i;
    return this.empty ? r = i = t.mapPos(this.from, n) : (r = t.mapPos(this.from, 1), i = t.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new Iy(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(t, n = t) {
    if (t <= this.anchor && n >= this.anchor)
      return rt.range(t, n);
    let r = Math.abs(t - this.anchor) > Math.abs(n - this.anchor) ? t : n;
    return rt.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(t, n = !1) {
    return this.anchor == t.anchor && this.head == t.head && (!n || !this.empty || this.assoc == t.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(t) {
    if (!t || typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return rt.range(t.anchor, t.head);
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new Iy(t, n, r);
  }
}
class rt {
  constructor(t, n) {
    this.ranges = t, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(t, n = -1) {
    return t.empty ? this : rt.create(this.ranges.map((r) => r.map(t, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(t, n = !1) {
    if (this.ranges.length != t.ranges.length || this.mainIndex != t.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(t.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new rt([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(t, n = !0) {
    return rt.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(t, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = t, rt.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((t) => t.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(t) {
    if (!t || !Array.isArray(t.ranges) || typeof t.main != "number" || t.main >= t.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new rt(t.ranges.map((n) => Iy.fromJSON(n)), t.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(t, n = t) {
    return new rt([rt.range(t, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(t, n = 0) {
    if (t.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < t.length; i++) {
      let o = t[i];
      if (o.empty ? o.from <= r : o.from < r)
        return rt.normalized(t.slice(), n);
      r = o.to;
    }
    return new rt(t, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(t, n = 0, r, i) {
    return Iy.create(t, t, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(t, n, r, i) {
    let o = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return n < t ? Iy.create(n, t, 48 | o) : Iy.create(t, n, (n > t ? 8 : 0) | o);
  }
  /**
  @internal
  */
  static normalized(t, n = 0) {
    let r = t[n];
    t.sort((i, o) => i.from - o.from), n = t.indexOf(r);
    for (let i = 1; i < t.length; i++) {
      let o = t[i], s = t[i - 1];
      if (o.empty ? o.from <= s.to : o.from < s.to) {
        let l = s.from, c = Math.max(o.to, s.to);
        i <= n && n--, t.splice(--i, 2, o.anchor > o.head ? rt.range(c, l) : rt.range(l, c));
      }
    }
    return new rt(t, n);
  }
}
function h_e(e, t) {
  for (let n of e.ranges)
    if (n.to > t)
      throw new RangeError("Selection points outside of document");
}
let SG = 0;
class Ht {
  constructor(t, n, r, i, o) {
    this.combine = t, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = SG++, this.default = t([]), this.extensions = typeof o == "function" ? o(this) : o;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(t = {}) {
    return new Ht(t.combine || ((n) => n), t.compareInput || ((n, r) => n === r), t.compare || (t.combine ? (n, r) => n === r : EG), !!t.static, t.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(t) {
    return new dM([], this, 0, t);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new dM(t, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new dM(t, this, 2, n);
  }
  from(t, n) {
    return n || (n = (r) => r), this.compute([t], (r) => n(r.field(t)));
  }
}
function EG(e, t) {
  return e == t || e.length == t.length && e.every((n, r) => n === t[r]);
}
class dM {
  constructor(t, n, r, i) {
    this.dependencies = t, this.facet = n, this.type = r, this.value = i, this.id = SG++;
  }
  dynamicSlot(t) {
    var n;
    let r = this.value, i = this.facet.compareInput, o = this.id, s = t[o] >> 1, l = this.type == 2, c = !1, a = !1, u = [];
    for (let f of this.dependencies)
      f == "doc" ? c = !0 : f == "selection" ? a = !0 : (((n = t[f.id]) !== null && n !== void 0 ? n : 1) & 1) == 0 && u.push(t[f.id]);
    return {
      create(f) {
        return f.values[s] = r(f), 1;
      },
      update(f, d) {
        if (c && d.docChanged || a && (d.docChanged || d.selection) || L9(f, u)) {
          let p = r(f);
          if (l ? !Vce(p, f.values[s], i) : !i(p, f.values[s]))
            return f.values[s] = p, 1;
        }
        return 0;
      },
      reconfigure: (f, d) => {
        let p, h = d.config.address[o];
        if (h != null) {
          let m = w_(d, h);
          if (this.dependencies.every((v) => v instanceof Ht ? d.facet(v) === f.facet(v) : v instanceof cs ? d.field(v, !1) == f.field(v, !1) : !0) || (l ? Vce(p = r(f), m, i) : i(p = r(f), m)))
            return f.values[s] = m, 0;
        } else
          p = r(f);
        return f.values[s] = p, 1;
      }
    };
  }
}
function Vce(e, t, n) {
  if (e.length != t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function L9(e, t) {
  let n = !1;
  for (let r of t)
    LE(e, r) & 1 && (n = !0);
  return n;
}
function $zt(e, t, n) {
  let r = n.map((c) => e[c.id]), i = n.map((c) => c.type), o = r.filter((c) => !(c & 1)), s = e[t.id] >> 1;
  function l(c) {
    let a = [];
    for (let u = 0; u < r.length; u++) {
      let f = w_(c, r[u]);
      if (i[u] == 2)
        for (let d of f)
          a.push(d);
      else
        a.push(f);
    }
    return t.combine(a);
  }
  return {
    create(c) {
      for (let a of r)
        LE(c, a);
      return c.values[s] = l(c), 1;
    },
    update(c, a) {
      if (!L9(c, o))
        return 0;
      let u = l(c);
      return t.compare(u, c.values[s]) ? 0 : (c.values[s] = u, 1);
    },
    reconfigure(c, a) {
      let u = L9(c, r), f = a.config.facets[t.id], d = a.facet(t);
      if (f && !u && EG(n, f))
        return c.values[s] = d, 0;
      let p = l(c);
      return t.compare(p, d) ? (c.values[s] = d, 0) : (c.values[s] = p, 1);
    }
  };
}
const EI = /* @__PURE__ */ Ht.define({ static: !0 });
class cs {
  constructor(t, n, r, i, o) {
    this.id = t, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(t) {
    let n = new cs(SG++, t.create, t.update, t.compare || ((r, i) => r === i), t);
    return t.provide && (n.provides = t.provide(n)), n;
  }
  create(t) {
    let n = t.facet(EI).find((r) => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(t);
  }
  /**
  @internal
  */
  slot(t) {
    let n = t[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, i) => {
        let o = r.values[n], s = this.updateF(o, i);
        return this.compareF(o, s) ? 0 : (r.values[n] = s, 1);
      },
      reconfigure: (r, i) => {
        let o = r.facet(EI), s = i.facet(EI), l;
        return (l = o.find((c) => c.field == this)) && l != s.find((c) => c.field == this) ? (r.values[n] = l.create(r), 1) : i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1);
      }
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(t) {
    return [this, EI.of({ field: this, create: t })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const by = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function yS(e) {
  return (t) => new m_e(t, e);
}
const Dg = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ yS(by.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ yS(by.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ yS(by.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ yS(by.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ yS(by.lowest)
};
class m_e {
  constructor(t, n) {
    this.inner = t, this.prec = n;
  }
}
class Zj {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(t) {
    return new z9(this, t);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(t) {
    return Zj.reconfigure.of({ compartment: this, extension: t });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(t) {
    return t.config.compartments.get(this);
  }
}
class z9 {
  constructor(t, n) {
    this.compartment = t, this.inner = n;
  }
}
class A_ {
  constructor(t, n, r, i, o, s) {
    for (this.base = t, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = s, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(t) {
    let n = this.address[t.id];
    return n == null ? t.default : this.staticValues[n >> 1];
  }
  static resolve(t, n, r) {
    let i = [], o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map();
    for (let d of Kzt(t, n, s))
      d instanceof cs ? i.push(d) : (o[d.facet.id] || (o[d.facet.id] = [])).push(d);
    let l = /* @__PURE__ */ Object.create(null), c = [], a = [];
    for (let d of i)
      l[d.id] = a.length << 1, a.push((p) => d.slot(p));
    let u = r == null ? void 0 : r.config.facets;
    for (let d in o) {
      let p = o[d], h = p[0].facet, m = u && u[d] || [];
      if (p.every(
        (v) => v.type == 0
        /* Provider.Static */
      ))
        if (l[h.id] = c.length << 1 | 1, EG(m, p))
          c.push(r.facet(h));
        else {
          let v = h.combine(p.map((b) => b.value));
          c.push(r && h.compare(v, r.facet(h)) ? r.facet(h) : v);
        }
      else {
        for (let v of p)
          v.type == 0 ? (l[v.id] = c.length << 1 | 1, c.push(v.value)) : (l[v.id] = a.length << 1, a.push((b) => v.dynamicSlot(b)));
        l[h.id] = a.length << 1, a.push((v) => $zt(v, h, p));
      }
    }
    let f = a.map((d) => d(l));
    return new A_(t, s, f, l, c, o);
  }
}
function Kzt(e, t, n) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function o(s, l) {
    let c = i.get(s);
    if (c != null) {
      if (c <= l)
        return;
      let a = r[c].indexOf(s);
      a > -1 && r[c].splice(a, 1), s instanceof z9 && n.delete(s.compartment);
    }
    if (i.set(s, l), Array.isArray(s))
      for (let a of s)
        o(a, l);
    else if (s instanceof z9) {
      if (n.has(s.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let a = t.get(s.compartment) || s.inner;
      n.set(s.compartment, a), o(a, l);
    } else if (s instanceof m_e)
      o(s.inner, s.prec);
    else if (s instanceof cs)
      r[l].push(s), s.provides && o(s.provides, l);
    else if (s instanceof dM)
      r[l].push(s), s.facet.extensions && o(s.facet.extensions, by.default);
    else {
      let a = s.extension;
      if (!a)
        throw new Error(`Unrecognized extension value in extension set (${s}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      o(a, l);
    }
  }
  return o(e, by.default), r.reduce((s, l) => s.concat(l));
}
function LE(e, t) {
  if (t & 1)
    return 2;
  let n = t >> 1, r = e.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  e.status[n] = 4;
  let i = e.computeSlot(e, e.config.dynamicSlots[n]);
  return e.status[n] = 2 | i;
}
function w_(e, t) {
  return t & 1 ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
const g_e = /* @__PURE__ */ Ht.define(), j9 = /* @__PURE__ */ Ht.define({
  combine: (e) => e.some((t) => t),
  static: !0
}), y_e = /* @__PURE__ */ Ht.define({
  combine: (e) => e.length ? e[0] : void 0,
  static: !0
}), v_e = /* @__PURE__ */ Ht.define(), b_e = /* @__PURE__ */ Ht.define(), O_e = /* @__PURE__ */ Ht.define(), A_e = /* @__PURE__ */ Ht.define({
  combine: (e) => e.length ? e[0] : !1
});
class Uf {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new Gzt();
  }
}
class Gzt {
  /**
  Create an instance of this annotation.
  */
  of(t) {
    return new Uf(this, t);
  }
}
class Yzt {
  /**
  @internal
  */
  constructor(t) {
    this.map = t;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(t) {
    return new _n(this, t);
  }
}
class _n {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(t) {
    let n = this.type.map(this.value, t);
    return n === void 0 ? void 0 : n == this.value ? this : new _n(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(t) {
    return this.type == t;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(t = {}) {
    return new Yzt(t.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(t, n) {
    if (!t.length)
      return t;
    let r = [];
    for (let i of t) {
      let o = i.map(n);
      o && r.push(o);
    }
    return r;
  }
}
_n.reconfigure = /* @__PURE__ */ _n.define();
_n.appendConfig = /* @__PURE__ */ _n.define();
let Pa = class g1 {
  constructor(t, n, r, i, o, s) {
    this.startState = t, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = s, this._doc = null, this._state = null, r && h_e(r, n.newLength), o.some((l) => l.type == g1.time) || (this.annotations = o.concat(g1.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(t, n, r, i, o, s) {
    return new g1(t, n, r, i, o, s);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(t) {
    for (let n of this.annotations)
      if (n.type == t)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(t) {
    let n = this.annotation(g1.userEvent);
    return !!(n && (n == t || n.length > t.length && n.slice(0, t.length) == t && n[t.length] == "."));
  }
};
Pa.time = /* @__PURE__ */ Uf.define();
Pa.userEvent = /* @__PURE__ */ Uf.define();
Pa.addToHistory = /* @__PURE__ */ Uf.define();
Pa.remote = /* @__PURE__ */ Uf.define();
function Jzt(e, t) {
  let n = [];
  for (let r = 0, i = 0; ; ) {
    let o, s;
    if (r < e.length && (i == t.length || t[i] >= e[r]))
      o = e[r++], s = e[r++];
    else if (i < t.length)
      o = t[i++], s = t[i++];
    else
      return n;
    !n.length || n[n.length - 1] < o ? n.push(o, s) : n[n.length - 1] < s && (n[n.length - 1] = s);
  }
}
function w_e(e, t, n) {
  var r;
  let i, o, s;
  return n ? (i = t.changes, o = Ro.empty(t.changes.length), s = e.changes.compose(t.changes)) : (i = t.changes.map(e.changes), o = e.changes.mapDesc(t.changes, !0), s = e.changes.compose(i)), {
    changes: s,
    selection: t.selection ? t.selection.map(o) : (r = e.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: _n.mapEffects(e.effects, i).concat(_n.mapEffects(t.effects, o)),
    annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
    scrollIntoView: e.scrollIntoView || t.scrollIntoView
  };
}
function F9(e, t, n) {
  let r = t.selection, i = tA(t.annotations);
  return t.userEvent && (i = i.concat(Pa.userEvent.of(t.userEvent))), {
    changes: t.changes instanceof Ro ? t.changes : Ro.of(t.changes || [], n, e.facet(y_e)),
    selection: r && (r instanceof rt ? r : rt.single(r.anchor, r.head)),
    effects: tA(t.effects),
    annotations: i,
    scrollIntoView: !!t.scrollIntoView
  };
}
function x_e(e, t, n) {
  let r = F9(e, t.length ? t[0] : {}, e.doc.length);
  t.length && t[0].filter === !1 && (n = !1);
  for (let o = 1; o < t.length; o++) {
    t[o].filter === !1 && (n = !1);
    let s = !!t[o].sequential;
    r = w_e(r, F9(e, t[o], s ? r.changes.newLength : e.doc.length), s);
  }
  let i = Pa.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return tjt(n ? ejt(i) : i);
}
function ejt(e) {
  let t = e.startState, n = !0;
  for (let i of t.facet(v_e)) {
    let o = i(e);
    if (o === !1) {
      n = !1;
      break;
    }
    Array.isArray(o) && (n = n === !0 ? o : Jzt(n, o));
  }
  if (n !== !0) {
    let i, o;
    if (n === !1)
      o = e.changes.invertedDesc, i = Ro.empty(t.doc.length);
    else {
      let s = e.changes.filter(n);
      i = s.changes, o = s.filtered.mapDesc(s.changes).invertedDesc;
    }
    e = Pa.create(t, i, e.selection && e.selection.map(o), _n.mapEffects(e.effects, o), e.annotations, e.scrollIntoView);
  }
  let r = t.facet(b_e);
  for (let i = r.length - 1; i >= 0; i--) {
    let o = r[i](e);
    o instanceof Pa ? e = o : Array.isArray(o) && o.length == 1 && o[0] instanceof Pa ? e = o[0] : e = x_e(t, tA(o), !1);
  }
  return e;
}
function tjt(e) {
  let t = e.startState, n = t.facet(O_e), r = e;
  for (let i = n.length - 1; i >= 0; i--) {
    let o = n[i](e);
    o && Object.keys(o).length && (r = w_e(r, F9(t, o, e.changes.newLength), !0));
  }
  return r == e ? e : Pa.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
}
const njt = [];
function tA(e) {
  return e == null ? njt : Array.isArray(e) ? e : [e];
}
var Oi = /* @__PURE__ */ function(e) {
  return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
}(Oi || (Oi = {}));
const rjt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let U9;
try {
  U9 = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function ijt(e) {
  if (U9)
    return U9.test(e);
  for (let t = 0; t < e.length; t++) {
    let n = e[t];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || rjt.test(n)))
      return !0;
  }
  return !1;
}
function ojt(e) {
  return (t) => {
    if (!/\S/.test(t))
      return Oi.Space;
    if (ijt(t))
      return Oi.Word;
    for (let n = 0; n < e.length; n++)
      if (t.indexOf(e[n]) > -1)
        return Oi.Word;
    return Oi.Other;
  };
}
class $n {
  constructor(t, n, r, i, o, s) {
    this.config = t, this.doc = n, this.selection = r, this.values = i, this.status = t.statusTemplate.slice(), this.computeSlot = o, s && (s._state = this);
    for (let l = 0; l < this.config.dynamicSlots.length; l++)
      LE(this, l << 1);
    this.computeSlot = null;
  }
  field(t, n = !0) {
    let r = this.config.address[t.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return LE(this, r), w_(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...t) {
    return x_e(this, t, !0);
  }
  /**
  @internal
  */
  applyTransaction(t) {
    let n = this.config, { base: r, compartments: i } = n;
    for (let l of t.effects)
      l.is(Zj.reconfigure) ? (n && (i = /* @__PURE__ */ new Map(), n.compartments.forEach((c, a) => i.set(a, c)), n = null), i.set(l.value.compartment, l.value.extension)) : l.is(_n.reconfigure) ? (n = null, r = l.value) : l.is(_n.appendConfig) && (n = null, r = tA(r).concat(l.value));
    let o;
    n ? o = t.startState.values.slice() : (n = A_.resolve(r, i, this), o = new $n(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (c, a) => a.reconfigure(c, this), null).values);
    let s = t.startState.facet(j9) ? t.newSelection : t.newSelection.asSingle();
    new $n(n, t.newDoc, s, o, (l, c) => c.update(l, t), t);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(t) {
    return typeof t == "string" && (t = this.toText(t)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: t },
      range: rt.cursor(n.from + t.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(t) {
    let n = this.selection, r = t(n.ranges[0]), i = this.changes(r.changes), o = [r.range], s = tA(r.effects);
    for (let l = 1; l < n.ranges.length; l++) {
      let c = t(n.ranges[l]), a = this.changes(c.changes), u = a.map(i);
      for (let d = 0; d < l; d++)
        o[d] = o[d].map(u);
      let f = i.mapDesc(a, !0);
      o.push(c.range.map(f)), i = i.compose(u), s = _n.mapEffects(s, u).concat(_n.mapEffects(tA(c.effects), f));
    }
    return {
      changes: i,
      selection: rt.create(o, n.mainIndex),
      effects: s
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(t = []) {
    return t instanceof Ro ? t : Ro.of(t, this.doc.length, this.facet($n.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(t) {
    return Sr.of(t.split(this.facet($n.lineSeparator) || M9));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(t = 0, n = this.doc.length) {
    return this.doc.sliceString(t, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(t) {
    let n = this.config.address[t.id];
    return n == null ? t.default : (LE(this, n), w_(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(t) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (t)
      for (let r in t) {
        let i = t[r];
        i instanceof cs && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(t[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(t, n = {}, r) {
    if (!t || typeof t.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let o in r)
        if (Object.prototype.hasOwnProperty.call(t, o)) {
          let s = r[o], l = t[o];
          i.push(s.init((c) => s.spec.fromJSON(l, c)));
        }
    }
    return $n.create({
      doc: t.doc,
      selection: rt.fromJSON(t.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(t = {}) {
    let n = A_.resolve(t.extensions || [], /* @__PURE__ */ new Map()), r = t.doc instanceof Sr ? t.doc : Sr.of((t.doc || "").split(n.staticFacet($n.lineSeparator) || M9)), i = t.selection ? t.selection instanceof rt ? t.selection : rt.single(t.selection.anchor, t.selection.head) : rt.single(0);
    return h_e(i, r.length), n.staticFacet(j9) || (i = i.asSingle()), new $n(n, r, i, n.dynamicSlots.map(() => null), (o, s) => s.create(o), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet($n.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet($n.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(A_e);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(t, ...n) {
    for (let r of this.facet($n.phrases))
      if (Object.prototype.hasOwnProperty.call(r, t)) {
        t = r[t];
        break;
      }
    return n.length && (t = t.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let o = +(i || 1);
      return !o || o > n.length ? r : n[o - 1];
    })), t;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(t, n, r = -1) {
    let i = [];
    for (let o of this.facet(g_e))
      for (let s of o(this, n, r))
        Object.prototype.hasOwnProperty.call(s, t) && i.push(s[t]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(t) {
    return ojt(this.languageDataAt("wordChars", t).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(t) {
    let { text: n, from: r, length: i } = this.doc.lineAt(t), o = this.charCategorizer(t), s = t - r, l = t - r;
    for (; s > 0; ) {
      let c = xs(n, s, !1);
      if (o(n.slice(c, s)) != Oi.Word)
        break;
      s = c;
    }
    for (; l < i; ) {
      let c = xs(n, l);
      if (o(n.slice(l, c)) != Oi.Word)
        break;
      l = c;
    }
    return s == l ? null : rt.range(s + r, l + r);
  }
}
$n.allowMultipleSelections = j9;
$n.tabSize = /* @__PURE__ */ Ht.define({
  combine: (e) => e.length ? e[0] : 4
});
$n.lineSeparator = y_e;
$n.readOnly = A_e;
$n.phrases = /* @__PURE__ */ Ht.define({
  compare(e, t) {
    let n = Object.keys(e), r = Object.keys(t);
    return n.length == r.length && n.every((i) => e[i] == t[i]);
  }
});
$n.languageData = g_e;
$n.changeFilter = v_e;
$n.transactionFilter = b_e;
$n.transactionExtender = O_e;
Zj.reconfigure = /* @__PURE__ */ _n.define();
function Vf(e, t, n = {}) {
  let r = {};
  for (let i of e)
    for (let o of Object.keys(i)) {
      let s = i[o], l = r[o];
      if (l === void 0)
        r[o] = s;
      else if (!(l === s || s === void 0)) if (Object.hasOwnProperty.call(n, o))
        r[o] = n[o](l, s);
      else
        throw new Error("Config merge conflict for field " + o);
    }
  for (let i in t)
    r[i] === void 0 && (r[i] = t[i]);
  return r;
}
class Qv {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(t) {
    return this == t;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(t, n = t) {
    return dk.create(t, n, this);
  }
}
Qv.prototype.startSide = Qv.prototype.endSide = 0;
Qv.prototype.point = !1;
Qv.prototype.mapMode = Os.TrackDel;
class dk {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new dk(t, n, r);
  }
}
function V9(e, t) {
  return e.from - t.from || e.value.startSide - t.value.startSide;
}
class TG {
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(t, n, r, i = 0) {
    let o = r ? this.to : this.from;
    for (let s = i, l = o.length; ; ) {
      if (s == l)
        return s;
      let c = s + l >> 1, a = o[c] - t || (r ? this.value[c].endSide : this.value[c].startSide) - n;
      if (c == s)
        return a >= 0 ? s : l;
      a >= 0 ? l = c : s = c + 1;
    }
  }
  between(t, n, r, i) {
    for (let o = this.findIndex(n, -1e9, !0), s = this.findIndex(r, 1e9, !1, o); o < s; o++)
      if (i(this.from[o] + t, this.to[o] + t, this.value[o]) === !1)
        return !1;
  }
  map(t, n) {
    let r = [], i = [], o = [], s = -1, l = -1;
    for (let c = 0; c < this.value.length; c++) {
      let a = this.value[c], u = this.from[c] + t, f = this.to[c] + t, d, p;
      if (u == f) {
        let h = n.mapPos(u, a.startSide, a.mapMode);
        if (h == null || (d = p = h, a.startSide != a.endSide && (p = n.mapPos(u, a.endSide), p < d)))
          continue;
      } else if (d = n.mapPos(u, a.startSide), p = n.mapPos(f, a.endSide), d > p || d == p && a.startSide > 0 && a.endSide <= 0)
        continue;
      (p - d || a.endSide - a.startSide) < 0 || (s < 0 && (s = d), a.point && (l = Math.max(l, p - d)), r.push(a), i.push(d - s), o.push(p - s));
    }
    return { mapped: r.length ? new TG(i, o, r, l) : null, pos: s };
  }
}
class xr {
  constructor(t, n, r, i) {
    this.chunkPos = t, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(t, n, r, i) {
    return new xr(t, n, r, i);
  }
  /**
  @internal
  */
  get length() {
    let t = this.chunk.length - 1;
    return t < 0 ? 0 : Math.max(this.chunkEnd(t), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let t = this.nextLayer.size;
    for (let n of this.chunk)
      t += n.value.length;
    return t;
  }
  /**
  @internal
  */
  chunkEnd(t) {
    return this.chunkPos[t] + this.chunk[t].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(t) {
    let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: o = this.length } = t, s = t.filter;
    if (n.length == 0 && !s)
      return this;
    if (r && (n = n.slice().sort(V9)), this.isEmpty)
      return n.length ? xr.of(n) : this;
    let l = new S_e(this, null, -1).goto(0), c = 0, a = [], u = new hh();
    for (; l.value || c < n.length; )
      if (c < n.length && (l.from - n[c].from || l.startSide - n[c].value.startSide) >= 0) {
        let f = n[c++];
        u.addInner(f.from, f.to, f.value) || a.push(f);
      } else l.rangeIndex == 1 && l.chunkIndex < this.chunk.length && (c == n.length || this.chunkEnd(l.chunkIndex) < n[c].from) && (!s || i > this.chunkEnd(l.chunkIndex) || o < this.chunkPos[l.chunkIndex]) && u.addChunk(this.chunkPos[l.chunkIndex], this.chunk[l.chunkIndex]) ? l.nextChunk() : ((!s || i > l.to || o < l.from || s(l.from, l.to, l.value)) && (u.addInner(l.from, l.to, l.value) || a.push(dk.create(l.from, l.to, l.value))), l.next());
    return u.finishInner(this.nextLayer.isEmpty && !a.length ? xr.empty : this.nextLayer.update({ add: a, filter: s, filterFrom: i, filterTo: o }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(t) {
    if (t.empty || this.isEmpty)
      return this;
    let n = [], r = [], i = -1;
    for (let s = 0; s < this.chunk.length; s++) {
      let l = this.chunkPos[s], c = this.chunk[s], a = t.touchesRange(l, l + c.length);
      if (a === !1)
        i = Math.max(i, c.maxPoint), n.push(c), r.push(t.mapPos(l));
      else if (a === !0) {
        let { mapped: u, pos: f } = c.map(l, t);
        u && (i = Math.max(i, u.maxPoint), n.push(u), r.push(f));
      }
    }
    let o = this.nextLayer.map(t);
    return n.length == 0 ? o : new xr(r, n, o || xr.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(t, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let o = this.chunkPos[i], s = this.chunk[i];
        if (n >= o && t <= o + s.length && s.between(o, t - o, n - o, r) === !1)
          return;
      }
      this.nextLayer.between(t, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(t = 0) {
    return fk.from([this]).goto(t);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(t, n = 0) {
    return fk.from(t).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(t, n, r, i, o = -1) {
    let s = t.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), l = n.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), c = qce(s, l, r), a = new vS(s, c, o), u = new vS(l, c, o);
    r.iterGaps((f, d, p) => Bce(a, f, u, d, p, i)), r.empty && r.length == 0 && Bce(a, 0, u, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(t, n, r = 0, i) {
    i == null && (i = 999999999);
    let o = t.filter((u) => !u.isEmpty && n.indexOf(u) < 0), s = n.filter((u) => !u.isEmpty && t.indexOf(u) < 0);
    if (o.length != s.length)
      return !1;
    if (!o.length)
      return !0;
    let l = qce(o, s), c = new vS(o, l, 0).goto(r), a = new vS(s, l, 0).goto(r);
    for (; ; ) {
      if (c.to != a.to || !q9(c.active, a.active) || c.point && (!a.point || !c.point.eq(a.point)))
        return !1;
      if (c.to > i)
        return !0;
      c.next(), a.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(t, n, r, i, o = -1) {
    let s = new vS(t, null, o).goto(n), l = n, c = s.openStart;
    for (; ; ) {
      let a = Math.min(s.to, r);
      if (s.point) {
        let u = s.activeForPoint(s.to), f = s.pointFrom < n ? u.length + 1 : s.point.startSide < 0 ? u.length : Math.min(u.length, c);
        i.point(l, a, s.point, u, f, s.pointRank), c = Math.min(s.openEnd(a), u.length);
      } else a > l && (i.span(l, a, s.active, c), c = s.openEnd(a));
      if (s.to > r)
        return c + (s.point && s.to > r ? 1 : 0);
      l = s.to, s.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(t, n = !1) {
    let r = new hh();
    for (let i of t instanceof dk ? [t] : n ? sjt(t) : t)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(t) {
    if (!t.length)
      return xr.empty;
    let n = t[t.length - 1];
    for (let r = t.length - 2; r >= 0; r--)
      for (let i = t[r]; i != xr.empty; i = i.nextLayer)
        n = new xr(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
    return n;
  }
}
xr.empty = /* @__PURE__ */ new xr([], [], null, -1);
function sjt(e) {
  if (e.length > 1)
    for (let t = e[0], n = 1; n < e.length; n++) {
      let r = e[n];
      if (V9(t, r) > 0)
        return e.slice().sort(V9);
      t = r;
    }
  return e;
}
xr.empty.nextLayer = xr.empty;
class hh {
  finishChunk(t) {
    this.chunks.push(new TG(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, t && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(t, n, r) {
    this.addInner(t, n, r) || (this.nextLayer || (this.nextLayer = new hh())).add(t, n, r);
  }
  /**
  @internal
  */
  addInner(t, n, r) {
    let i = t - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (t - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = t), this.from.push(t - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = t, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - t)), !0);
  }
  /**
  @internal
  */
  addChunk(t, n) {
    if ((t - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(t);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + t, this.lastTo = n.to[r] + t, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(xr.empty);
  }
  /**
  @internal
  */
  finishInner(t) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return t;
    let n = xr.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(t) : t, this.setMaxPoint);
    return this.from = null, n;
  }
}
function qce(e, t, n) {
  let r = /* @__PURE__ */ new Map();
  for (let o of e)
    for (let s = 0; s < o.chunk.length; s++)
      o.chunk[s].maxPoint <= 0 && r.set(o.chunk[s], o.chunkPos[s]);
  let i = /* @__PURE__ */ new Set();
  for (let o of t)
    for (let s = 0; s < o.chunk.length; s++) {
      let l = r.get(o.chunk[s]);
      l != null && (n ? n.mapPos(l) : l) == o.chunkPos[s] && !(n != null && n.touchesRange(l, l + o.chunk[s].length)) && i.add(o.chunk[s]);
    }
  return i;
}
class S_e {
  constructor(t, n, r, i = 0) {
    this.layer = t, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(t, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(t, n, !1), this;
  }
  gotoInner(t, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < t || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(t - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(t, n) {
    (this.to - t || this.endSide - n) < 0 && this.gotoInner(t, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let t = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = t + n.from[this.rangeIndex];
        if (this.from = r, this.to = t + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(t) {
    if (t == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = t;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(t) {
    return this.from - t.from || this.startSide - t.startSide || this.rank - t.rank || this.to - t.to || this.endSide - t.endSide;
  }
}
class fk {
  constructor(t) {
    this.heap = t;
  }
  static from(t, n = null, r = -1) {
    let i = [];
    for (let o = 0; o < t.length; o++)
      for (let s = t[o]; !s.isEmpty; s = s.nextLayer)
        s.maxPoint >= r && i.push(new S_e(s, n, r, o));
    return i.length == 1 ? i[0] : new fk(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(t, n = -1e9) {
    for (let r of this.heap)
      r.goto(t, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      IU(this.heap, r);
    return this.next(), this;
  }
  forward(t, n) {
    for (let r of this.heap)
      r.forward(t, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      IU(this.heap, r);
    (this.to - t || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let t = this.heap[0];
      this.from = t.from, this.to = t.to, this.value = t.value, this.rank = t.rank, t.value && t.next(), IU(this.heap, 0);
    }
  }
}
function IU(e, t) {
  for (let n = e[t]; ; ) {
    let r = (t << 1) + 1;
    if (r >= e.length)
      break;
    let i = e[r];
    if (r + 1 < e.length && i.compare(e[r + 1]) >= 0 && (i = e[r + 1], r++), n.compare(i) < 0)
      break;
    e[r] = n, e[t] = i, t = r;
  }
}
class vS {
  constructor(t, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = fk.from(t, n, r);
  }
  goto(t, n = -1e9) {
    return this.cursor.goto(t, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = t, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(t, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - t || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(t, n);
  }
  removeActive(t) {
    TI(this.active, t), TI(this.activeTo, t), TI(this.activeRank, t), this.minActive = Xce(this.active, this.activeTo);
  }
  addActive(t) {
    let n = 0, { value: r, to: i, rank: o } = this.cursor;
    for (; n < this.activeRank.length && (o - this.activeRank[n] || i - this.activeTo[n]) > 0; )
      n++;
    kI(this.active, n, r), kI(this.activeTo, n, i), kI(this.activeRank, n, o), t && kI(t, n, this.cursor.from), this.minActive = Xce(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let t = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > t) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && TI(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > t) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let o = this.cursor.value;
          if (!o.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < t; i--)
        this.openStart++;
    }
  }
  activeForPoint(t) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > t || this.activeTo[r] == t && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(t) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > t; r--)
      n++;
    return n;
  }
}
function Bce(e, t, n, r, i, o) {
  e.goto(t), n.goto(r);
  let s = r + i, l = r, c = r - t;
  for (; ; ) {
    let a = e.to + c - n.to, u = a || e.endSide - n.endSide, f = u < 0 ? e.to + c : n.to, d = Math.min(f, s);
    if (e.point || n.point ? e.point && n.point && (e.point == n.point || e.point.eq(n.point)) && q9(e.activeForPoint(e.to), n.activeForPoint(n.to)) || o.comparePoint(l, d, e.point, n.point) : d > l && !q9(e.active, n.active) && o.compareRange(l, d, e.active, n.active), f > s)
      break;
    (a || e.openEnd != n.openEnd) && o.boundChange && o.boundChange(f), l = f, u <= 0 && e.next(), u >= 0 && n.next();
  }
}
function q9(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n] && !e[n].eq(t[n]))
      return !1;
  return !0;
}
function TI(e, t) {
  for (let n = t, r = e.length - 1; n < r; n++)
    e[n] = e[n + 1];
  e.pop();
}
function kI(e, t, n) {
  for (let r = e.length - 1; r >= t; r--)
    e[r + 1] = e[r];
  e[t] = n;
}
function Xce(e, t) {
  let n = -1, r = 1e9;
  for (let i = 0; i < t.length; i++)
    (t[i] - r || e[i].endSide - e[n].endSide) < 0 && (n = i, r = t[i]);
  return n;
}
function Cx(e, t, n = e.length) {
  let r = 0;
  for (let i = 0; i < n && i < e.length; )
    e.charCodeAt(i) == 9 ? (r += t - r % t, i++) : (r++, i = xs(e, i));
  return r;
}
function B9(e, t, n, r) {
  for (let i = 0, o = 0; ; ) {
    if (o >= t)
      return i;
    if (i == e.length)
      break;
    o += e.charCodeAt(i) == 9 ? n - o % n : 1, i = xs(e, i);
  }
  return r === !0 ? -1 : e.length;
}
const X9 = "ͼ", Wce = typeof Symbol > "u" ? "__" + X9 : Symbol.for(X9), W9 = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), Zce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class cg {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(t, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function i(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function o(s, l, c, a) {
      let u = [], f = /^@(\w+)\b/.exec(s[0]), d = f && f[1] == "keyframes";
      if (f && l == null) return c.push(s[0] + ";");
      for (let p in l) {
        let h = l[p];
        if (/&/.test(p))
          o(
            p.split(/,\s*/).map((m) => s.map((v) => m.replace(/&/, v))).reduce((m, v) => m.concat(v)),
            h,
            c
          );
        else if (h && typeof h == "object") {
          if (!f) throw new RangeError("The value of a property (" + p + ") should be a primitive value.");
          o(i(p), h, u, d);
        } else h != null && u.push(p.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + h + ";");
      }
      (u.length || d) && c.push((r && !f && !a ? s.map(r) : s).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let s in t) o(i(s), t[s], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let t = Zce[Wce] || 1;
    return Zce[Wce] = t + 1, X9 + t.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(t, n, r) {
    let i = t[W9], o = r && r.nonce;
    i ? o && i.setNonce(o) : i = new ajt(t, o), i.mount(Array.isArray(n) ? n : [n], t);
  }
}
let Hce = /* @__PURE__ */ new Map();
class ajt {
  constructor(t, n) {
    let r = t.ownerDocument || t, i = r.defaultView;
    if (!t.head && t.adoptedStyleSheets && i.CSSStyleSheet) {
      let o = Hce.get(r);
      if (o) return t[W9] = o;
      this.sheet = new i.CSSStyleSheet(), Hce.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], t[W9] = this;
  }
  mount(t, n) {
    let r = this.sheet, i = 0, o = 0;
    for (let s = 0; s < t.length; s++) {
      let l = t[s], c = this.modules.indexOf(l);
      if (c < o && c > -1 && (this.modules.splice(c, 1), o--, c = -1), c == -1) {
        if (this.modules.splice(o++, 0, l), r) for (let a = 0; a < l.rules.length; a++)
          r.insertRule(l.rules[a], i++);
      } else {
        for (; o < c; ) i += this.modules[o++].rules.length;
        i += l.rules.length, o++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let s = "";
      for (let c = 0; c < this.modules.length; c++)
        s += this.modules[c].getRules() + `
`;
      this.styleTag.textContent = s;
      let l = n.head || n;
      this.styleTag.parentNode != l && l.insertBefore(this.styleTag, l.firstChild);
    }
  }
  setNonce(t) {
    this.styleTag && this.styleTag.getAttribute("nonce") != t && this.styleTag.setAttribute("nonce", t);
  }
}
function qr() {
  var e = arguments[0];
  typeof e == "string" && (e = document.createElement(e));
  var t = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      var i = n[r];
      typeof i == "string" ? e.setAttribute(r, i) : i != null && (e[r] = i);
    }
    t++;
  }
  for (; t < arguments.length; t++) E_e(e, arguments[t]);
  return e;
}
function E_e(e, t) {
  if (typeof t == "string")
    e.appendChild(document.createTextNode(t));
  else if (t != null) if (t.nodeType != null)
    e.appendChild(t);
  else if (Array.isArray(t))
    for (var n = 0; n < t.length; n++) E_e(e, t[n]);
  else
    throw new RangeError("Unsupported child node: " + t);
}
function pk(e) {
  let t;
  return e.nodeType == 11 ? t = e.getSelection ? e : e.ownerDocument : t = e, t.getSelection();
}
function Z9(e, t) {
  return t ? e == t || e.contains(t.nodeType != 1 ? t.parentNode : t) : !1;
}
function fM(e, t) {
  if (!t.anchorNode)
    return !1;
  try {
    return Z9(e, t.anchorNode);
  } catch {
    return !1;
  }
}
function ww(e) {
  return e.nodeType == 3 ? Kv(e, 0, e.nodeValue.length).getClientRects() : e.nodeType == 1 ? e.getClientRects() : [];
}
function zE(e, t, n, r) {
  return n ? Qce(e, t, n, r, -1) || Qce(e, t, n, r, 1) : !1;
}
function $v(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}
function x_(e) {
  return e.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
function Qce(e, t, n, r, i) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : kf(e))) {
      if (e.nodeName == "DIV")
        return !1;
      let o = e.parentNode;
      if (!o || o.nodeType != 1)
        return !1;
      t = $v(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.nodeType == 1 && e.contentEditable == "false")
        return !1;
      t = i < 0 ? kf(e) : 0;
    } else
      return !1;
  }
}
function kf(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function EN(e, t) {
  let n = t ? e.left : e.right;
  return { left: n, right: n, top: e.top, bottom: e.bottom };
}
function ljt(e) {
  let t = e.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.innerWidth,
    top: 0,
    bottom: e.innerHeight
  };
}
function T_e(e, t) {
  let n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(t.width - e.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(t.height - e.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function cjt(e, t, n, r, i, o, s, l) {
  let c = e.ownerDocument, a = c.defaultView || window;
  for (let u = e, f = !1; u && !f; )
    if (u.nodeType == 1) {
      let d, p = u == c.body, h = 1, m = 1;
      if (p)
        d = ljt(a);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (f = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let A = u.getBoundingClientRect();
        ({ scaleX: h, scaleY: m } = T_e(u, A)), d = {
          left: A.left,
          right: A.left + u.clientWidth * h,
          top: A.top,
          bottom: A.top + u.clientHeight * m
        };
      }
      let v = 0, b = 0;
      if (i == "nearest")
        t.top < d.top ? (b = t.top - (d.top + s), n > 0 && t.bottom > d.bottom + b && (b = t.bottom - d.bottom + s)) : t.bottom > d.bottom && (b = t.bottom - d.bottom + s, n < 0 && t.top - b < d.top && (b = t.top - (d.top + s)));
      else {
        let A = t.bottom - t.top, w = d.bottom - d.top;
        b = (i == "center" && A <= w ? t.top + A / 2 - w / 2 : i == "start" || i == "center" && n < 0 ? t.top - s : t.bottom - w + s) - d.top;
      }
      if (r == "nearest" ? t.left < d.left ? (v = t.left - (d.left + o), n > 0 && t.right > d.right + v && (v = t.right - d.right + o)) : t.right > d.right && (v = t.right - d.right + o, n < 0 && t.left < d.left + v && (v = t.left - (d.left + o))) : v = (r == "center" ? t.left + (t.right - t.left) / 2 - (d.right - d.left) / 2 : r == "start" == l ? t.left - o : t.right - (d.right - d.left) + o) - d.left, v || b)
        if (p)
          a.scrollBy(v, b);
        else {
          let A = 0, w = 0;
          if (b) {
            let O = u.scrollTop;
            u.scrollTop += b / m, w = (u.scrollTop - O) * m;
          }
          if (v) {
            let O = u.scrollLeft;
            u.scrollLeft += v / h, A = (u.scrollLeft - O) * h;
          }
          t = {
            left: t.left - A,
            top: t.top - w,
            right: t.right - A,
            bottom: t.bottom - w
          }, A && Math.abs(A - v) < 1 && (r = "nearest"), w && Math.abs(w - b) < 1 && (i = "nearest");
        }
      if (p)
        break;
      (t.top < d.top || t.bottom > d.bottom || t.left < d.left || t.right > d.right) && (t = {
        left: Math.max(t.left, d.left),
        right: Math.min(t.right, d.right),
        top: Math.max(t.top, d.top),
        bottom: Math.min(t.bottom, d.bottom)
      }), u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
}
function ujt(e) {
  let t = e.ownerDocument, n, r;
  for (let i = e.parentNode; i && !(i == t.body || n && r); )
    if (i.nodeType == 1)
      !r && i.scrollHeight > i.clientHeight && (r = i), !n && i.scrollWidth > i.clientWidth && (n = i), i = i.assignedSlot || i.parentNode;
    else if (i.nodeType == 11)
      i = i.host;
    else
      break;
  return { x: n, y: r };
}
class djt {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(t) {
    return this.anchorNode == t.anchorNode && this.anchorOffset == t.anchorOffset && this.focusNode == t.focusNode && this.focusOffset == t.focusOffset;
  }
  setRange(t) {
    let { anchorNode: n, focusNode: r } = t;
    this.set(n, Math.min(t.anchorOffset, n ? kf(n) : 0), r, Math.min(t.focusOffset, r ? kf(r) : 0));
  }
  set(t, n, r, i) {
    this.anchorNode = t, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let o0 = null;
function k_e(e) {
  if (e.setActive)
    return e.setActive();
  if (o0)
    return e.focus(o0);
  let t = [];
  for (let n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (e.focus(o0 == null ? {
    get preventScroll() {
      return o0 = { preventScroll: !0 }, !0;
    }
  } : void 0), !o0) {
    o0 = !1;
    for (let n = 0; n < t.length; ) {
      let r = t[n++], i = t[n++], o = t[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != o && (r.scrollLeft = o);
    }
  }
}
let $ce;
function Kv(e, t, n = t) {
  let r = $ce || ($ce = document.createRange());
  return r.setEnd(e, n), r.setStart(e, t), r;
}
function nA(e, t, n, r) {
  let i = { key: t, code: t, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let o = new KeyboardEvent("keydown", i);
  o.synthetic = !0, e.dispatchEvent(o);
  let s = new KeyboardEvent("keyup", i);
  return s.synthetic = !0, e.dispatchEvent(s), o.defaultPrevented || s.defaultPrevented;
}
function fjt(e) {
  for (; e; ) {
    if (e && (e.nodeType == 9 || e.nodeType == 11 && e.host))
      return e;
    e = e.assignedSlot || e.parentNode;
  }
  return null;
}
function C_e(e) {
  for (; e.attributes.length; )
    e.removeAttributeNode(e.attributes[0]);
}
function pjt(e, t) {
  let n = t.focusNode, r = t.focusOffset;
  if (!n || t.anchorNode != n || t.anchorOffset != r)
    return !1;
  for (r = Math.min(r, kf(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = kf(n));
    } else {
      if (n == e)
        return !0;
      r = $v(n), n = n.parentNode;
    }
}
function N_e(e) {
  return e.scrollTop > Math.max(1, e.scrollHeight - e.clientHeight - 4);
}
function P_e(e, t) {
  for (let n = e, r = t; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = kf(n);
    } else if (n.parentNode && !x_(n))
      r = $v(n), n = n.parentNode;
    else
      return null;
  }
}
function I_e(e, t) {
  for (let n = e, r = t; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !x_(n))
      r = $v(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
class Hs {
  constructor(t, n, r = !0) {
    this.node = t, this.offset = n, this.precise = r;
  }
  static before(t, n) {
    return new Hs(t.parentNode, $v(t), n);
  }
  static after(t, n) {
    return new Hs(t.parentNode, $v(t) + 1, n);
  }
}
const kG = [];
class Hr {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(t) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == t)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(t) {
    return this.posBefore(t) + t.length;
  }
  sync(t, n) {
    if (this.flags & 2) {
      let r = this.dom, i = null, o;
      for (let s of this.children) {
        if (s.flags & 7) {
          if (!s.dom && (o = i ? i.nextSibling : r.firstChild)) {
            let l = Hr.get(o);
            (!l || !l.parent && l.canReuseDOM(s)) && s.reuseDOM(o);
          }
          s.sync(t, n), s.flags &= -8;
        }
        if (o = i ? i.nextSibling : r.firstChild, n && !n.written && n.node == r && o != s.dom && (n.written = !0), s.dom.parentNode == r)
          for (; o && o != s.dom; )
            o = Kce(o);
        else
          r.insertBefore(s.dom, o);
        i = s.dom;
      }
      for (o = i ? i.nextSibling : r.firstChild, o && n && n.node == r && (n.written = !0); o; )
        o = Kce(o);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(t, n), r.flags &= -8);
  }
  reuseDOM(t) {
  }
  localPosFromDOM(t, n) {
    let r;
    if (t == this.dom)
      r = this.dom.childNodes[n];
    else {
      let i = kf(t) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let o = t.parentNode;
        if (o == this.dom)
          break;
        i == 0 && o.firstChild != o.lastChild && (t == o.firstChild ? i = -1 : i = 1), t = o;
      }
      i < 0 ? r = t : r = t.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !Hr.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, o = 0; ; i++) {
      let s = this.children[i];
      if (s.dom == r)
        return o;
      o += s.length + s.breakAfter;
    }
  }
  domBoundsAround(t, n, r = 0) {
    let i = -1, o = -1, s = -1, l = -1;
    for (let c = 0, a = r, u = r; c < this.children.length; c++) {
      let f = this.children[c], d = a + f.length;
      if (a < t && d > n)
        return f.domBoundsAround(t, n, a);
      if (d >= t && i == -1 && (i = c, o = a), a > n && f.dom.parentNode == this.dom) {
        s = c, l = u;
        break;
      }
      u = d, a = d + f.breakAfter;
    }
    return {
      from: o,
      to: l < 0 ? r + this.length : l,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: s < this.children.length && s >= 0 ? this.children[s].dom : null
    };
  }
  markDirty(t = !1) {
    this.flags |= 2, this.markParentsDirty(t);
  }
  markParentsDirty(t) {
    for (let n = this.parent; n; n = n.parent) {
      if (t && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, t = !1;
    }
  }
  setParent(t) {
    this.parent != t && (this.parent = t, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(t) {
    this.dom != t && (this.dom && (this.dom.cmView = null), this.dom = t, t.cmView = this);
  }
  get rootView() {
    for (let t = this; ; ) {
      let n = t.parent;
      if (!n)
        return t;
      t = n;
    }
  }
  replaceChildren(t, n, r = kG) {
    this.markDirty();
    for (let i = t; i < n; i++) {
      let o = this.children[i];
      o.parent == this && r.indexOf(o) < 0 && o.destroy();
    }
    r.length < 250 ? this.children.splice(t, n - t, ...r) : this.children = [].concat(this.children.slice(0, t), r, this.children.slice(n));
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(t) {
    return !1;
  }
  ignoreEvent(t) {
    return !1;
  }
  childCursor(t = this.length) {
    return new R_e(this.children, t, this.children.length);
  }
  childPos(t, n = 1) {
    return this.childCursor().findPos(t, n);
  }
  toString() {
    let t = this.constructor.name.replace("View", "");
    return t + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(t) {
    return t.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(t, n, r, i, o, s) {
    return !1;
  }
  become(t) {
    return !1;
  }
  canReuseDOM(t) {
    return t.constructor == this.constructor && !((this.flags | t.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let t of this.children)
      t.parent == this && t.destroy();
    this.parent = null;
  }
}
Hr.prototype.breakAfter = 0;
function Kce(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class R_e {
  constructor(t, n, r) {
    this.children = t, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(t, n = 1) {
    for (; ; ) {
      if (t > this.pos || t == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function M_e(e, t, n, r, i, o, s, l, c) {
  let { children: a } = e, u = a.length ? a[t] : null, f = o.length ? o[o.length - 1] : null, d = f ? f.breakAfter : s;
  if (!(t == r && u && !s && !d && o.length < 2 && u.merge(n, i, o.length ? f : null, n == 0, l, c))) {
    if (r < a.length) {
      let p = a[r];
      p && (i < p.length || p.breakAfter && (f != null && f.breakAfter)) ? (t == r && (p = p.split(i), i = 0), !d && f && p.merge(0, i, f, !0, 0, c) ? o[o.length - 1] = p : ((i || p.children.length && !p.children[0].length) && p.merge(0, i, null, !1, 0, c), o.push(p))) : p != null && p.breakAfter && (f ? f.breakAfter = 1 : s = 1), r++;
    }
    for (u && (u.breakAfter = s, n > 0 && (!s && o.length && u.merge(n, u.length, o[0], !1, l, 0) ? u.breakAfter = o.shift().breakAfter : (n < u.length || u.children.length && u.children[u.children.length - 1].length == 0) && u.merge(n, u.length, null, !1, l, 0), t++)); t < r && o.length; )
      if (a[r - 1].become(o[o.length - 1]))
        r--, o.pop(), c = o.length ? 0 : l;
      else if (a[t].become(o[0]))
        t++, o.shift(), l = o.length ? 0 : c;
      else
        break;
    !o.length && t && r < a.length && !a[t - 1].breakAfter && a[r].merge(0, 0, a[t - 1], !1, l, c) && t--, (t < r || o.length) && e.replaceChildren(t, r, o);
  }
}
function D_e(e, t, n, r, i, o) {
  let s = e.childCursor(), { i: l, off: c } = s.findPos(n, 1), { i: a, off: u } = s.findPos(t, -1), f = t - n;
  for (let d of r)
    f += d.length;
  e.length += f, M_e(e, a, u, l, c, r, 0, i, o);
}
let tl = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, H9 = typeof document < "u" ? document : { documentElement: { style: {} } };
const Q9 = /* @__PURE__ */ /Edge\/(\d+)/.exec(tl.userAgent), L_e = /* @__PURE__ */ /MSIE \d/.test(tl.userAgent), $9 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(tl.userAgent), Hj = !!(L_e || $9 || Q9), Gce = !Hj && /* @__PURE__ */ /gecko\/(\d+)/i.test(tl.userAgent), RU = !Hj && /* @__PURE__ */ /Chrome\/(\d+)/.exec(tl.userAgent), hjt = "webkitFontSmoothing" in H9.documentElement.style, z_e = !Hj && /* @__PURE__ */ /Apple Computer/.test(tl.vendor), Yce = z_e && (/* @__PURE__ */ /Mobile\/\w+/.test(tl.userAgent) || tl.maxTouchPoints > 2);
var Qt = {
  mac: Yce || /* @__PURE__ */ /Mac/.test(tl.platform),
  windows: /* @__PURE__ */ /Win/.test(tl.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(tl.platform),
  ie: Hj,
  ie_version: L_e ? H9.documentMode || 6 : $9 ? +$9[1] : Q9 ? +Q9[1] : 0,
  gecko: Gce,
  gecko_version: Gce ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(tl.userAgent) || [0, 0])[1] : 0,
  chrome: !!RU,
  chrome_version: RU ? +RU[1] : 0,
  ios: Yce,
  android: /* @__PURE__ */ /Android\b/.test(tl.userAgent),
  safari: z_e,
  webkit_version: hjt ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(tl.userAgent) || [0, 0])[1] : 0,
  tabSize: H9.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const mjt = 256;
class id extends Hr {
  constructor(t) {
    super(), this.text = t;
  }
  get length() {
    return this.text.length;
  }
  createDOM(t) {
    this.setDOM(t || document.createTextNode(this.text));
  }
  sync(t, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(t) {
    t.nodeType == 3 && this.createDOM(t);
  }
  merge(t, n, r) {
    return this.flags & 8 || r && (!(r instanceof id) || this.length - (n - t) + r.length > mjt || r.flags & 8) ? !1 : (this.text = this.text.slice(0, t) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(t) {
    let n = new id(this.text.slice(t));
    return this.text = this.text.slice(0, t), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(t, n) {
    return t == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(t) {
    return new Hs(this.dom, t);
  }
  domBoundsAround(t, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(t, n) {
    return gjt(this.dom, t, n);
  }
}
class mh extends Hr {
  constructor(t, n = [], r = 0) {
    super(), this.mark = t, this.children = n, this.length = r;
    for (let i of n)
      i.setParent(this);
  }
  setAttrs(t) {
    if (C_e(t), this.mark.class && (t.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        t.setAttribute(n, this.mark.attrs[n]);
    return t;
  }
  canReuseDOM(t) {
    return super.canReuseDOM(t) && !((this.flags | t.flags) & 8);
  }
  reuseDOM(t) {
    t.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(t, n);
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof mh && r.mark.eq(this.mark)) || t && o <= 0 || n < this.length && s <= 0) ? !1 : (D_e(this, t, n, r ? r.children.slice() : [], o - 1, s - 1), this.markDirty(), !0);
  }
  split(t) {
    let n = [], r = 0, i = -1, o = 0;
    for (let l of this.children) {
      let c = r + l.length;
      c > t && n.push(r < t ? l.split(t - r) : l), i < 0 && r >= t && (i = o), r = c, o++;
    }
    let s = this.length - t;
    return this.length = t, i > -1 && (this.children.length = i, this.markDirty()), new mh(this.mark, n, s);
  }
  domAtPos(t) {
    return j_e(this, t);
  }
  coordsAt(t, n) {
    return U_e(this, t, n);
  }
}
function gjt(e, t, n) {
  let r = e.nodeValue.length;
  t > r && (t = r);
  let i = t, o = t, s = 0;
  t == 0 && n < 0 || t == r && n >= 0 ? Qt.chrome || Qt.gecko || (t ? (i--, s = 1) : o < r && (o++, s = -1)) : n < 0 ? i-- : o < r && o++;
  let l = Kv(e, i, o).getClientRects();
  if (!l.length)
    return null;
  let c = l[(s ? s < 0 : n >= 0) ? 0 : l.length - 1];
  return Qt.safari && !s && c.width == 0 && (c = Array.prototype.find.call(l, (a) => a.width) || c), s ? EN(c, s < 0) : c || null;
}
class zm extends Hr {
  static create(t, n, r) {
    return new zm(t, n, r);
  }
  constructor(t, n, r) {
    super(), this.widget = t, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(t) {
    let n = zm.create(this.widget, this.length - t, this.side);
    return this.length -= t, n;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof zm) || !this.widget.compare(r.widget) || t > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = t + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(t) {
    return t instanceof zm && t.side == this.side && this.widget.constructor == t.widget.constructor ? (this.widget.compare(t.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Sr.empty;
    let t = this;
    for (; t.parent; )
      t = t.parent;
    let { view: n } = t, r = n && n.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : Sr.empty;
  }
  domAtPos(t) {
    return (this.length ? t == 0 : this.side > 0) ? Hs.before(this.dom) : Hs.after(this.dom, t == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t, n) {
    let r = this.widget.coordsAt(this.dom, t, n);
    if (r)
      return r;
    let i = this.dom.getClientRects(), o = null;
    if (!i.length)
      return null;
    let s = this.side ? this.side < 0 : t > 0;
    for (let l = s ? i.length - 1 : 0; o = i[l], !(t > 0 ? l == 0 : l == i.length - 1 || o.top < o.bottom); l += s ? -1 : 1)
      ;
    return EN(o, !s);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class xw extends Hr {
  constructor(t) {
    super(), this.side = t;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(t) {
    return t instanceof xw && t.side == this.side;
  }
  split() {
    return new xw(this.side);
  }
  sync() {
    if (!this.dom) {
      let t = document.createElement("img");
      t.className = "cm-widgetBuffer", t.setAttribute("aria-hidden", "true"), this.setDOM(t);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(t) {
    return this.side > 0 ? Hs.before(this.dom) : Hs.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Sr.empty;
  }
  get isHidden() {
    return !0;
  }
}
id.prototype.children = zm.prototype.children = xw.prototype.children = kG;
function j_e(e, t) {
  let n = e.dom, { children: r } = e, i = 0;
  for (let o = 0; i < r.length; i++) {
    let s = r[i], l = o + s.length;
    if (!(l == o && s.getSide() <= 0)) {
      if (t > o && t < l && s.dom.parentNode == n)
        return s.domAtPos(t - o);
      if (t <= o)
        break;
      o = l;
    }
  }
  for (let o = i; o > 0; o--) {
    let s = r[o - 1];
    if (s.dom.parentNode == n)
      return s.domAtPos(s.length);
  }
  for (let o = i; o < r.length; o++) {
    let s = r[o];
    if (s.dom.parentNode == n)
      return s.domAtPos(0);
  }
  return new Hs(n, 0);
}
function F_e(e, t, n) {
  let r, { children: i } = e;
  n > 0 && t instanceof mh && i.length && (r = i[i.length - 1]) instanceof mh && r.mark.eq(t.mark) ? F_e(r, t.children[0], n - 1) : (i.push(t), t.setParent(e)), e.length += t.length;
}
function U_e(e, t, n) {
  let r = null, i = -1, o = null, s = -1;
  function l(a, u) {
    for (let f = 0, d = 0; f < a.children.length && d <= u; f++) {
      let p = a.children[f], h = d + p.length;
      h >= u && (p.children.length ? l(p, u - d) : (!o || o.isHidden && (n > 0 || vjt(o, p))) && (h > u || d == h && p.getSide() > 0) ? (o = p, s = u - d) : (d < u || d == h && p.getSide() < 0 && !p.isHidden) && (r = p, i = u - d)), d = h;
    }
  }
  l(e, t);
  let c = (n < 0 ? r : o) || r || o;
  return c ? c.coordsAt(Math.max(0, c == r ? i : s), n) : yjt(e);
}
function yjt(e) {
  let t = e.dom.lastChild;
  if (!t)
    return e.dom.getBoundingClientRect();
  let n = ww(t);
  return n[n.length - 1] || null;
}
function vjt(e, t) {
  let n = e.coordsAt(0, 1), r = t.coordsAt(0, 1);
  return n && r && r.top < n.bottom;
}
function K9(e, t) {
  for (let n in e)
    n == "class" && t.class ? t.class += " " + e.class : n == "style" && t.style ? t.style += ";" + e.style : t[n] = e[n];
  return t;
}
const Jce = /* @__PURE__ */ Object.create(null);
function S_(e, t, n) {
  if (e == t)
    return !0;
  e || (e = Jce), t || (t = Jce);
  let r = Object.keys(e), i = Object.keys(t);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let o of r)
    if (o != n && (i.indexOf(o) == -1 || e[o] !== t[o]))
      return !1;
  return !0;
}
function G9(e, t, n) {
  let r = !1;
  if (t)
    for (let i in t)
      n && i in n || (r = !0, i == "style" ? e.style.cssText = "" : e.removeAttribute(i));
  if (n)
    for (let i in n)
      t && t[i] == n[i] || (r = !0, i == "style" ? e.style.cssText = n[i] : e.setAttribute(i, n[i]));
  return r;
}
function bjt(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < e.attributes.length; n++) {
    let r = e.attributes[n];
    t[r.name] = r.value;
  }
  return t;
}
class qf {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(t) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(t, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(t) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(t, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(t) {
  }
}
var Ia = /* @__PURE__ */ function(e) {
  return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
}(Ia || (Ia = {}));
class ln extends Qv {
  constructor(t, n, r, i) {
    super(), this.startSide = t, this.endSide = n, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(t) {
    return new TN(t);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(t) {
    let n = Math.max(-1e4, Math.min(1e4, t.side || 0)), r = !!t.block;
    return n += r && !t.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new ug(t, n, n, r, t.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(t) {
    let n = !!t.block, r, i;
    if (t.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: o, end: s } = V_e(t, n);
      r = (o ? n ? -3e8 : -1 : 5e8) - 1, i = (s ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new ug(t, r, i, n, t.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(t) {
    return new kN(t);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(t, n = !1) {
    return xr.of(t, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
ln.none = xr.empty;
class TN extends ln {
  constructor(t) {
    let { start: n, end: r } = V_e(t);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, t), this.tagName = t.tagName || "span", this.class = t.class || "", this.attrs = t.attributes || null;
  }
  eq(t) {
    var n, r;
    return this == t || t instanceof TN && this.tagName == t.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (t.class || ((r = t.attrs) === null || r === void 0 ? void 0 : r.class)) && S_(this.attrs, t.attrs, "class");
  }
  range(t, n = t) {
    if (t >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(t, n);
  }
}
TN.prototype.point = !1;
class kN extends ln {
  constructor(t) {
    super(-2e8, -2e8, null, t);
  }
  eq(t) {
    return t instanceof kN && this.spec.class == t.spec.class && S_(this.spec.attributes, t.spec.attributes);
  }
  range(t, n = t) {
    if (n != t)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(t, n);
  }
}
kN.prototype.mapMode = Os.TrackBefore;
kN.prototype.point = !0;
class ug extends ln {
  constructor(t, n, r, i, o, s) {
    super(n, r, o, t), this.block = i, this.isReplace = s, this.mapMode = i ? n <= 0 ? Os.TrackBefore : Os.TrackAfter : Os.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? Ia.WidgetRange : this.startSide <= 0 ? Ia.WidgetBefore : Ia.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(t) {
    return t instanceof ug && Ojt(this.widget, t.widget) && this.block == t.block && this.startSide == t.startSide && this.endSide == t.endSide;
  }
  range(t, n = t) {
    if (this.isReplace && (t > n || t == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != t)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(t, n);
  }
}
ug.prototype.point = !0;
function V_e(e, t = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = e;
  return n == null && (n = e.inclusive), r == null && (r = e.inclusive), { start: n ?? t, end: r ?? t };
}
function Ojt(e, t) {
  return e == t || !!(e && t && e.compare(t));
}
function pM(e, t, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= e ? n[i] = Math.max(n[i], t) : n.push(e, t);
}
class uo extends Hr {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(t, n, r, i, o, s) {
    if (r) {
      if (!(r instanceof uo))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), D_e(this, t, n, r ? r.children.slice() : [], o, s), !0;
  }
  split(t) {
    let n = new uo();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: i } = this.childPos(t);
    i && (n.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let o = r; o < this.children.length; o++)
      n.append(this.children[o], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = t, n;
  }
  transferDOM(t) {
    this.dom && (this.markDirty(), t.setDOM(this.dom), t.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(t) {
    S_(this.attrs, t) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = t);
  }
  append(t, n) {
    F_e(this, t, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(t) {
    let n = t.spec.attributes, r = t.spec.class;
    n && (this.attrs = K9(n, this.attrs || {})), r && (this.attrs = K9({ class: r }, this.attrs || {}));
  }
  domAtPos(t) {
    return j_e(this, t);
  }
  reuseDOM(t) {
    t.nodeName == "DIV" && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, n) {
    var r;
    this.dom ? this.flags & 4 && (C_e(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (G9(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(t, n);
    let i = this.dom.lastChild;
    for (; i && Hr.get(i) instanceof mh; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = Hr.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!Qt.ios || !this.children.some((o) => o instanceof id))) {
      let o = document.createElement("BR");
      o.cmIgnore = !0, this.dom.appendChild(o);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let t = 0, n;
    for (let r of this.children) {
      if (!(r instanceof id) || /[^ -~]/.test(r.text))
        return null;
      let i = ww(r.dom);
      if (i.length != 1)
        return null;
      t += i[0].width, n = i[0].height;
    }
    return t ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: t / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(t, n) {
    let r = U_e(this, t, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, o = r.bottom - r.top;
      if (Math.abs(o - i.lineHeight) < 2 && i.textHeight < o) {
        let s = (o - i.textHeight) / 2;
        return { top: r.top + s, bottom: r.bottom - s, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(t) {
    return t instanceof uo && this.children.length == 0 && t.children.length == 0 && S_(this.attrs, t.attrs) && this.breakAfter == t.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(t, n) {
    for (let r = 0, i = 0; r < t.children.length; r++) {
      let o = t.children[r], s = i + o.length;
      if (s >= n) {
        if (o instanceof uo)
          return o;
        if (s > n)
          break;
      }
      i = s + o.breakAfter;
    }
    return null;
  }
}
class rh extends Hr {
  constructor(t, n, r) {
    super(), this.widget = t, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof rh) || !this.widget.compare(r.widget) || t > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = t + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(t) {
    return t == 0 ? Hs.before(this.dom) : Hs.after(this.dom, t == this.length);
  }
  split(t) {
    let n = this.length - t;
    this.length = t;
    let r = new rh(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return kG;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Sr.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(t) {
    return t instanceof rh && t.widget.constructor == this.widget.constructor ? (t.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, this.deco = t.deco, this.breakAfter = t.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(t, n) {
    let r = this.widget.coordsAt(this.dom, t, n);
    return r || (this.widget instanceof Y9 ? null : EN(this.dom.getBoundingClientRect(), this.length ? t == 0 : n <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(t) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : t < 0 ? n < 0 : r > 0;
  }
}
class Y9 extends qf {
  constructor(t) {
    super(), this.height = t;
  }
  toDOM() {
    let t = document.createElement("div");
    return t.className = "cm-gap", this.updateDOM(t), t;
  }
  eq(t) {
    return t.height == this.height;
  }
  updateDOM(t) {
    return t.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
class jE {
  constructor(t, n, r, i) {
    this.doc = t, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let t = this.content[this.content.length - 1];
    return !(t.breakAfter || t instanceof rh && t.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new uo()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(t = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(CI(new xw(-1), t), t.length), this.pendingBuffer = 0);
  }
  addBlockWidget(t) {
    this.flushBuffer(), this.curLine = null, this.content.push(t);
  }
  finish(t) {
    this.pendingBuffer && t <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(t && this.content.length && this.content[this.content.length - 1] instanceof rh) && this.getLine();
  }
  buildText(t, n, r) {
    for (; t > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: o, lineBreak: s, done: l } = this.cursor.next(this.skip);
        if (this.skip = 0, l)
          throw new Error("Ran out of text content when drawing inline views");
        if (s) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, t--;
          continue;
        } else
          this.text = o, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        t,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(CI(new id(this.text.slice(this.textOff, this.textOff + i)), n), r), this.atCursorPos = !0, this.textOff += i, t -= i, r = 0;
    }
  }
  span(t, n, r, i) {
    this.buildText(n - t, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  }
  point(t, n, r, i, o, s) {
    if (this.disallowBlockEffectsFor[s] && r instanceof ug) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let l = n - t;
    if (r instanceof ug)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new rh(r.widget || Sw.block, l, r));
      else {
        let c = zm.create(r.widget || Sw.inline, l, l ? 0 : r.startSide), a = this.atCursorPos && !c.isEditable && o <= i.length && (t < n || r.startSide > 0), u = !c.isEditable && (t < n || o > i.length || r.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !a && !c.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), a && (f.append(CI(new xw(1), i), o), o = i.length + Math.max(0, o - i.length)), f.append(CI(c, i), o), this.atCursorPos = u, this.pendingBuffer = u ? t < n || o > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    l && (this.textOff + l <= this.text.length ? this.textOff += l : (this.skip += l - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = o);
  }
  static build(t, n, r, i, o) {
    let s = new jE(t, n, r, o);
    return s.openEnd = xr.spans(i, n, r, s), s.openStart < 0 && (s.openStart = s.openEnd), s.finish(s.openEnd), s;
  }
}
function CI(e, t) {
  for (let n of t)
    e = new mh(n, [e], e.length);
  return e;
}
class Sw extends qf {
  constructor(t) {
    super(), this.tag = t;
  }
  eq(t) {
    return t.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(t) {
    return t.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
Sw.inline = /* @__PURE__ */ new Sw("span");
Sw.block = /* @__PURE__ */ new Sw("div");
var hi = /* @__PURE__ */ function(e) {
  return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
}(hi || (hi = {}));
const Gv = hi.LTR, CG = hi.RTL;
function q_e(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    t.push(1 << +e[n]);
  return t;
}
const Ajt = /* @__PURE__ */ q_e("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), wjt = /* @__PURE__ */ q_e("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), J9 = /* @__PURE__ */ Object.create(null), Md = [];
for (let e of ["()", "[]", "{}"]) {
  let t = /* @__PURE__ */ e.charCodeAt(0), n = /* @__PURE__ */ e.charCodeAt(1);
  J9[t] = n, J9[n] = -t;
}
function B_e(e) {
  return e <= 247 ? Ajt[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? wjt[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8204 ? 256 : 64336 <= e && e <= 65023 ? 4 : 1;
}
const xjt = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class jm {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? CG : Gv;
  }
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(t, n) {
    return this.dir == n == t ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(t, n) {
    return t == (this.dir == n);
  }
  /**
  @internal
  */
  static find(t, n, r, i) {
    let o = -1;
    for (let s = 0; s < t.length; s++) {
      let l = t[s];
      if (l.from <= n && l.to >= n) {
        if (l.level == r)
          return s;
        (o < 0 || (i != 0 ? i < 0 ? l.from < n : l.to > n : t[o].level > l.level)) && (o = s);
      }
    }
    if (o < 0)
      throw new RangeError("Index out of range");
    return o;
  }
}
function X_e(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], i = t[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !X_e(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const Br = [];
function Sjt(e, t, n, r, i) {
  for (let o = 0; o <= r.length; o++) {
    let s = o ? r[o - 1].to : t, l = o < r.length ? r[o].from : n, c = o ? 256 : i;
    for (let a = s, u = c, f = c; a < l; a++) {
      let d = B_e(e.charCodeAt(a));
      d == 512 ? d = u : d == 8 && f == 4 && (d = 16), Br[a] = d == 4 ? 2 : d, d & 7 && (f = d), u = d;
    }
    for (let a = s, u = c, f = c; a < l; a++) {
      let d = Br[a];
      if (d == 128)
        a < l - 1 && u == Br[a + 1] && u & 24 ? d = Br[a] = u : Br[a] = 256;
      else if (d == 64) {
        let p = a + 1;
        for (; p < l && Br[p] == 64; )
          p++;
        let h = a && u == 8 || p < n && Br[p] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let m = a; m < p; m++)
          Br[m] = h;
        a = p - 1;
      } else d == 8 && f == 1 && (Br[a] = 1);
      u = d, d & 7 && (f = d);
    }
  }
}
function Ejt(e, t, n, r, i) {
  let o = i == 1 ? 2 : 1;
  for (let s = 0, l = 0, c = 0; s <= r.length; s++) {
    let a = s ? r[s - 1].to : t, u = s < r.length ? r[s].from : n;
    for (let f = a, d, p, h; f < u; f++)
      if (p = J9[d = e.charCodeAt(f)])
        if (p < 0) {
          for (let m = l - 3; m >= 0; m -= 3)
            if (Md[m + 1] == -p) {
              let v = Md[m + 2], b = v & 2 ? i : v & 4 ? v & 1 ? o : i : 0;
              b && (Br[f] = Br[Md[m]] = b), l = m;
              break;
            }
        } else {
          if (Md.length == 189)
            break;
          Md[l++] = f, Md[l++] = d, Md[l++] = c;
        }
      else if ((h = Br[f]) == 2 || h == 1) {
        let m = h == i;
        c = m ? 0 : 1;
        for (let v = l - 3; v >= 0; v -= 3) {
          let b = Md[v + 2];
          if (b & 2)
            break;
          if (m)
            Md[v + 2] |= 2;
          else {
            if (b & 4)
              break;
            Md[v + 2] |= 4;
          }
        }
      }
  }
}
function Tjt(e, t, n, r) {
  for (let i = 0, o = r; i <= n.length; i++) {
    let s = i ? n[i - 1].to : e, l = i < n.length ? n[i].from : t;
    for (let c = s; c < l; ) {
      let a = Br[c];
      if (a == 256) {
        let u = c + 1;
        for (; ; )
          if (u == l) {
            if (i == n.length)
              break;
            u = n[i++].to, l = i < n.length ? n[i].from : t;
          } else if (Br[u] == 256)
            u++;
          else
            break;
        let f = o == 1, d = (u < t ? Br[u] : r) == 1, p = f == d ? f ? 1 : 2 : r;
        for (let h = u, m = i, v = m ? n[m - 1].to : e; h > c; )
          h == v && (h = n[--m].from, v = m ? n[m - 1].to : e), Br[--h] = p;
        c = u;
      } else
        o = a, c++;
    }
  }
}
function e8(e, t, n, r, i, o, s) {
  let l = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let c = t, a = 0; c < n; ) {
      let u = !0, f = !1;
      if (a == o.length || c < o[a].from) {
        let m = Br[c];
        m != l && (u = !1, f = m == 16);
      }
      let d = !u && l == 1 ? [] : null, p = u ? r : r + 1, h = c;
      e: for (; ; )
        if (a < o.length && h == o[a].from) {
          if (f)
            break e;
          let m = o[a];
          if (!u)
            for (let v = m.to, b = a + 1; ; ) {
              if (v == n)
                break e;
              if (b < o.length && o[b].from == v)
                v = o[b++].to;
              else {
                if (Br[v] == l)
                  break e;
                break;
              }
            }
          if (a++, d)
            d.push(m);
          else {
            m.from > c && s.push(new jm(c, m.from, p));
            let v = m.direction == Gv != !(p % 2);
            t8(e, v ? r + 1 : r, i, m.inner, m.from, m.to, s), c = m.to;
          }
          h = m.to;
        } else {
          if (h == n || (u ? Br[h] != l : Br[h] == l))
            break;
          h++;
        }
      d ? e8(e, c, h, r + 1, i, d, s) : c < h && s.push(new jm(c, h, p)), c = h;
    }
  else
    for (let c = n, a = o.length; c > t; ) {
      let u = !0, f = !1;
      if (!a || c > o[a - 1].to) {
        let m = Br[c - 1];
        m != l && (u = !1, f = m == 16);
      }
      let d = !u && l == 1 ? [] : null, p = u ? r : r + 1, h = c;
      e: for (; ; )
        if (a && h == o[a - 1].to) {
          if (f)
            break e;
          let m = o[--a];
          if (!u)
            for (let v = m.from, b = a; ; ) {
              if (v == t)
                break e;
              if (b && o[b - 1].to == v)
                v = o[--b].from;
              else {
                if (Br[v - 1] == l)
                  break e;
                break;
              }
            }
          if (d)
            d.push(m);
          else {
            m.to < c && s.push(new jm(m.to, c, p));
            let v = m.direction == Gv != !(p % 2);
            t8(e, v ? r + 1 : r, i, m.inner, m.from, m.to, s), c = m.from;
          }
          h = m.from;
        } else {
          if (h == t || (u ? Br[h - 1] != l : Br[h - 1] == l))
            break;
          h--;
        }
      d ? e8(e, h, c, r + 1, i, d, s) : h < c && s.push(new jm(h, c, p)), c = h;
    }
}
function t8(e, t, n, r, i, o, s) {
  let l = t % 2 ? 2 : 1;
  Sjt(e, i, o, r, l), Ejt(e, i, o, r, l), Tjt(i, o, r, l), e8(e, i, o, t, n, r, s);
}
function kjt(e, t, n) {
  if (!e)
    return [new jm(0, 0, t == CG ? 1 : 0)];
  if (t == Gv && !n.length && !xjt.test(e))
    return W_e(e.length);
  if (n.length)
    for (; e.length > Br.length; )
      Br[Br.length] = 256;
  let r = [], i = t == Gv ? 0 : 1;
  return t8(e, i, i, n, 0, e.length, r), r;
}
function W_e(e) {
  return [new jm(0, e, 0)];
}
let Z_e = "";
function Cjt(e, t, n, r, i) {
  var o;
  let s = r.head - e.from, l = jm.find(t, s, (o = r.bidiLevel) !== null && o !== void 0 ? o : -1, r.assoc), c = t[l], a = c.side(i, n);
  if (s == a) {
    let d = l += i ? 1 : -1;
    if (d < 0 || d >= t.length)
      return null;
    c = t[l = d], s = c.side(!i, n), a = c.side(i, n);
  }
  let u = xs(e.text, s, c.forward(i, n));
  (u < c.from || u > c.to) && (u = a), Z_e = e.text.slice(Math.min(s, u), Math.max(s, u));
  let f = l == (i ? t.length - 1 : 0) ? null : t[l + (i ? 1 : -1)];
  return f && u == a && f.level + (i ? 0 : 1) < c.level ? rt.cursor(f.side(!i, n) + e.from, f.forward(i, n) ? 1 : -1, f.level) : rt.cursor(u + e.from, c.forward(i, n) ? -1 : 1, c.level);
}
function Njt(e, t, n) {
  for (let r = t; r < n; r++) {
    let i = B_e(e.charCodeAt(r));
    if (i == 1)
      return Gv;
    if (i == 2 || i == 4)
      return CG;
  }
  return Gv;
}
const H_e = /* @__PURE__ */ Ht.define(), Q_e = /* @__PURE__ */ Ht.define(), $_e = /* @__PURE__ */ Ht.define(), K_e = /* @__PURE__ */ Ht.define(), n8 = /* @__PURE__ */ Ht.define(), G_e = /* @__PURE__ */ Ht.define(), Y_e = /* @__PURE__ */ Ht.define(), NG = /* @__PURE__ */ Ht.define(), PG = /* @__PURE__ */ Ht.define(), J_e = /* @__PURE__ */ Ht.define({
  combine: (e) => e.some((t) => t)
}), eLe = /* @__PURE__ */ Ht.define({
  combine: (e) => e.some((t) => t)
}), tLe = /* @__PURE__ */ Ht.define();
class rA {
  constructor(t, n = "nearest", r = "nearest", i = 5, o = 5, s = !1) {
    this.range = t, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o, this.isSnapshot = s;
  }
  map(t) {
    return t.empty ? this : new rA(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(t) {
    return this.range.to <= t.doc.length ? this : new rA(rt.cursor(t.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const NI = /* @__PURE__ */ _n.define({ map: (e, t) => e.map(t) }), nLe = /* @__PURE__ */ _n.define();
function ul(e, t, n) {
  let r = e.facet(K_e);
  r.length ? r[0](t) : window.onerror && window.onerror(String(t), n, void 0, void 0, t) || (n ? console.error(n + ":", t) : console.error(t));
}
const zp = /* @__PURE__ */ Ht.define({ combine: (e) => e.length ? e[0] : !0 });
let Pjt = 0;
const EO = /* @__PURE__ */ Ht.define({
  combine(e) {
    return e.filter((t, n) => {
      for (let r = 0; r < n; r++)
        if (e[r].plugin == t.plugin)
          return !1;
      return !0;
    });
  }
});
class Yi {
  constructor(t, n, r, i, o) {
    this.id = t, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.baseExtensions = o(this), this.extension = this.baseExtensions.concat(EO.of({ plugin: this, arg: void 0 }));
  }
  /**
  Create an extension for this plugin with the given argument.
  */
  of(t) {
    return this.baseExtensions.concat(EO.of({ plugin: this, arg: t }));
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(t, n) {
    const { eventHandlers: r, eventObservers: i, provide: o, decorations: s } = n || {};
    return new Yi(Pjt++, t, r, i, (l) => {
      let c = [];
      return s && c.push(hk.of((a) => {
        let u = a.plugin(l);
        return u ? s(u) : ln.none;
      })), o && c.push(o(l)), c;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(t, n) {
    return Yi.define((r, i) => new t(r, i), n);
  }
}
class MU {
  constructor(t) {
    this.spec = t, this.mustUpdate = null, this.value = null;
  }
  get plugin() {
    return this.spec && this.spec.plugin;
  }
  update(t) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (ul(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.plugin.create(t, this.spec.arg);
      } catch (n) {
        ul(t.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(t) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        ul(t.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const rLe = /* @__PURE__ */ Ht.define(), IG = /* @__PURE__ */ Ht.define(), hk = /* @__PURE__ */ Ht.define(), iLe = /* @__PURE__ */ Ht.define(), RG = /* @__PURE__ */ Ht.define(), oLe = /* @__PURE__ */ Ht.define();
function eue(e, t) {
  let n = e.state.facet(oLe);
  if (!n.length)
    return n;
  let r = n.map((o) => o instanceof Function ? o(e) : o), i = [];
  return xr.spans(r, t.from, t.to, {
    point() {
    },
    span(o, s, l, c) {
      let a = o - t.from, u = s - t.from, f = i;
      for (let d = l.length - 1; d >= 0; d--, c--) {
        let p = l[d].spec.bidiIsolate, h;
        if (p == null && (p = Njt(t.text, a, u)), c > 0 && f.length && (h = f[f.length - 1]).to == a && h.direction == p)
          h.to = u, f = h.inner;
        else {
          let m = { from: a, to: u, direction: p, inner: [] };
          f.push(m), f = m.inner;
        }
      }
    }
  }), i;
}
const sLe = /* @__PURE__ */ Ht.define();
function MG(e) {
  let t = 0, n = 0, r = 0, i = 0;
  for (let o of e.state.facet(sLe)) {
    let s = o(e);
    s && (s.left != null && (t = Math.max(t, s.left)), s.right != null && (n = Math.max(n, s.right)), s.top != null && (r = Math.max(r, s.top)), s.bottom != null && (i = Math.max(i, s.bottom)));
  }
  return { left: t, right: n, top: r, bottom: i };
}
const y1 = /* @__PURE__ */ Ht.define();
class eu {
  constructor(t, n, r, i) {
    this.fromA = t, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(t) {
    return new eu(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
  }
  addToSet(t) {
    let n = t.length, r = this;
    for (; n > 0; n--) {
      let i = t[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), t.splice(n - 1, 1);
      }
    }
    return t.splice(n, 0, r), t;
  }
  static extendWithRanges(t, n) {
    if (n.length == 0)
      return t;
    let r = [];
    for (let i = 0, o = 0, s = 0, l = 0; ; i++) {
      let c = i == t.length ? null : t[i], a = s - l, u = c ? c.fromB : 1e9;
      for (; o < n.length && n[o] < u; ) {
        let f = n[o], d = n[o + 1], p = Math.max(l, f), h = Math.min(u, d);
        if (p <= h && new eu(p + a, h + a, p, h).addToSet(r), d > u)
          break;
        o += 2;
      }
      if (!c)
        return r;
      new eu(c.fromA, c.toA, c.fromB, c.toB).addToSet(r), s = c.toA, l = c.toB;
    }
  }
}
class E_ {
  constructor(t, n, r) {
    this.view = t, this.state = n, this.transactions = r, this.flags = 0, this.startState = t.state, this.changes = Ro.empty(this.startState.doc.length);
    for (let o of r)
      this.changes = this.changes.compose(o.changes);
    let i = [];
    this.changes.iterChangedRanges((o, s, l, c) => i.push(new eu(o, s, l, c))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new E_(t, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((t) => t.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class tue extends Hr {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(t) {
    super(), this.view = t, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = ln.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(t.contentDOM), this.children = [new uo()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new eu(0, 0, 0, t.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(t) {
    var n;
    let r = t.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: a, toA: u }) => u < this.minWidthFrom || a > this.minWidthTo) ? (this.minWidthFrom = t.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = t.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(t);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !zjt(t.changes, this.hasComposition) && !t.selectionSet && (i = t.state.selection.main.head));
    let o = i > -1 ? Rjt(this.view, t.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: a, to: u } = this.hasComposition;
      r = new eu(a, u, t.changes.mapPos(a, -1), t.changes.mapPos(u, 1)).addToSet(r.slice());
    }
    this.hasComposition = o ? { from: o.range.fromB, to: o.range.toB } : null, (Qt.ie || Qt.chrome) && !o && t && t.state.doc.lines != t.startState.doc.lines && (this.forceSelection = !0);
    let s = this.decorations, l = this.updateDeco(), c = _jt(s, l, t.changes);
    return r = eu.extendWithRanges(r, c), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, t.startState.doc.length, o), t.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(t, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(t, n, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = Qt.chrome || Qt.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, s), this.flags &= -8, s && (s.written || i.selectionRange.focusNode != s.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (s) => s.flags &= -9
      /* ViewFlag.Composition */
    );
    let o = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let s of this.children)
        s instanceof rh && s.widget instanceof Y9 && o.push(s.dom);
    i.updateGaps(o);
  }
  updateChildren(t, n, r) {
    let i = r ? r.range.addToSet(t.slice()) : t, o = this.childCursor(n);
    for (let s = i.length - 1; ; s--) {
      let l = s >= 0 ? i[s] : null;
      if (!l)
        break;
      let { fromA: c, toA: a, fromB: u, toB: f } = l, d, p, h, m;
      if (r && r.range.fromB < f && r.range.toB > u) {
        let O = jE.build(this.view.state.doc, u, r.range.fromB, this.decorations, this.dynamicDecorationMap), x = jE.build(this.view.state.doc, r.range.toB, f, this.decorations, this.dynamicDecorationMap);
        p = O.breakAtStart, h = O.openStart, m = x.openEnd;
        let S = this.compositionView(r);
        x.breakAtStart ? S.breakAfter = 1 : x.content.length && S.merge(S.length, S.length, x.content[0], !1, x.openStart, 0) && (S.breakAfter = x.content[0].breakAfter, x.content.shift()), O.content.length && S.merge(0, 0, O.content[O.content.length - 1], !0, 0, O.openEnd) && O.content.pop(), d = O.content.concat(S).concat(x.content);
      } else
        ({ content: d, breakAtStart: p, openStart: h, openEnd: m } = jE.build(this.view.state.doc, u, f, this.decorations, this.dynamicDecorationMap));
      let { i: v, off: b } = o.findPos(a, 1), { i: A, off: w } = o.findPos(c, -1);
      M_e(this, A, w, v, b, d, p, h, m);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(t) {
    this.editContextFormatting = this.editContextFormatting.map(t.changes);
    for (let n of t.transactions)
      for (let r of n.effects)
        r.is(nLe) && (this.editContextFormatting = r.value);
  }
  compositionView(t) {
    let n = new id(t.text.nodeValue);
    n.flags |= 8;
    for (let { deco: i } of t.marks)
      n = new mh(i, [n], n.length);
    let r = new uo();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(t) {
    let n = (o, s) => {
      s.flags |= 8 | (s.children.some(
        (c) => c.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(s);
      let l = Hr.get(o);
      l && l != s && (l.dom = null), s.setDOM(o);
    }, r = this.childPos(t.range.fromB, 1), i = this.children[r.i];
    n(t.line, i);
    for (let o = t.marks.length - 1; o >= -1; o--)
      r = i.childPos(r.off, 1), i = i.children[r.i], n(o >= 0 ? t.marks[o].node : t.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(t = !1, n = !1) {
    (t || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, o = !i && !(this.view.state.facet(zp) || this.dom.tabIndex > -1) && fM(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || n || o))
      return;
    let s = this.forceSelection;
    this.forceSelection = !1;
    let l = this.view.state.selection.main, c = this.moveToLine(this.domAtPos(l.anchor)), a = l.empty ? c : this.moveToLine(this.domAtPos(l.head));
    if (Qt.gecko && l.empty && !this.hasComposition && Ijt(c)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => c.node.insertBefore(f, c.node.childNodes[c.offset] || null)), c = a = new Hs(f, 0), s = !0;
    }
    let u = this.view.observer.selectionRange;
    (s || !u.focusNode || (!zE(c.node, c.offset, u.anchorNode, u.anchorOffset) || !zE(a.node, a.offset, u.focusNode, u.focusOffset)) && !this.suppressWidgetCursorChange(u, l)) && (this.view.observer.ignore(() => {
      Qt.android && Qt.chrome && this.dom.contains(u.focusNode) && Ljt(u.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = pk(this.view.root);
      if (f) if (l.empty) {
        if (Qt.gecko) {
          let d = Mjt(c.node, c.offset);
          if (d && d != 3) {
            let p = (d == 1 ? P_e : I_e)(c.node, c.offset);
            p && (c = new Hs(p.node, p.offset));
          }
        }
        f.collapse(c.node, c.offset), l.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = l.bidiLevel);
      } else if (f.extend) {
        f.collapse(c.node, c.offset);
        try {
          f.extend(a.node, a.offset);
        } catch {
        }
      } else {
        let d = document.createRange();
        l.anchor > l.head && ([c, a] = [a, c]), d.setEnd(a.node, a.offset), d.setStart(c.node, c.offset), f.removeAllRanges(), f.addRange(d);
      }
      o && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(c, a)), this.impreciseAnchor = c.precise ? null : new Hs(u.anchorNode, u.anchorOffset), this.impreciseHead = a.precise ? null : new Hs(u.focusNode, u.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(t, n) {
    return this.hasComposition && n.empty && zE(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset) && this.posFromDOM(t.focusNode, t.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: t } = this, n = t.state.selection.main, r = pk(t.root), { anchorNode: i, anchorOffset: o } = t.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let s = uo.find(this, n.head);
    if (!s)
      return;
    let l = s.posAtStart;
    if (n.head == l || n.head == l + s.length)
      return;
    let c = this.coordsAt(n.head, -1), a = this.coordsAt(n.head, 1);
    if (!c || !a || c.bottom > a.top)
      return;
    let u = this.domAtPos(n.head + n.assoc);
    r.collapse(u.node, u.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), t.observer.readSelectionRange();
    let f = t.observer.selectionRange;
    t.docView.posFromDOM(f.anchorNode, f.anchorOffset) != n.from && r.collapse(i, o);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(t) {
    let n = this.dom, r;
    if (t.node != n)
      return t;
    for (let i = t.offset; !r && i < n.childNodes.length; i++) {
      let o = Hr.get(n.childNodes[i]);
      o instanceof uo && (r = o.domAtPos(0));
    }
    for (let i = t.offset - 1; !r && i >= 0; i--) {
      let o = Hr.get(n.childNodes[i]);
      o instanceof uo && (r = o.domAtPos(o.length));
    }
    return r ? new Hs(r.node, r.offset, !0) : t;
  }
  nearest(t) {
    for (let n = t; n; ) {
      let r = Hr.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(t, n) {
    let r = this.nearest(t);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(t, n) + r.posAtStart;
  }
  domAtPos(t) {
    let { i: n, off: r } = this.childCursor().findPos(t, -1);
    for (; n < this.children.length - 1; ) {
      let i = this.children[n];
      if (r < i.length || i instanceof uo)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(t, n) {
    let r = null, i = 0;
    for (let o = this.length, s = this.children.length - 1; s >= 0; s--) {
      let l = this.children[s], c = o - l.breakAfter, a = c - l.length;
      if (c < t)
        break;
      if (a <= t && (a < t || l.covers(-1)) && (c > t || l.covers(1)) && (!r || l instanceof uo && !(r instanceof uo && n >= 0)))
        r = l, i = a;
      else if (r && a == t && c == t && l instanceof rh && Math.abs(n) < 2) {
        if (l.deco.startSide < 0)
          break;
        s && (r = null);
      }
      o = a;
    }
    return r ? r.coordsAt(t - i, n) : null;
  }
  coordsForChar(t) {
    let { i: n, off: r } = this.childPos(t, 1), i = this.children[n];
    if (!(i instanceof uo))
      return null;
    for (; i.children.length; ) {
      let { i: l, off: c } = i.childPos(r, 1);
      for (; ; l++) {
        if (l == i.children.length)
          return null;
        if ((i = i.children[l]).length)
          break;
      }
      r = c;
    }
    if (!(i instanceof id))
      return null;
    let o = xs(i.text, r);
    if (o == r)
      return null;
    let s = Kv(i.dom, r, o).getClientRects();
    for (let l = 0; l < s.length; l++) {
      let c = s[l];
      if (l == s.length - 1 || c.top < c.bottom && c.left < c.right)
        return c;
    }
    return null;
  }
  measureVisibleLineHeights(t) {
    let n = [], { from: r, to: i } = t, o = this.view.contentDOM.clientWidth, s = o > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, l = -1, c = this.view.textDirection == hi.LTR;
    for (let a = 0, u = 0; u < this.children.length; u++) {
      let f = this.children[u], d = a + f.length;
      if (d > i)
        break;
      if (a >= r) {
        let p = f.dom.getBoundingClientRect();
        if (n.push(p.height), s) {
          let h = f.dom.lastChild, m = h ? ww(h) : [];
          if (m.length) {
            let v = m[m.length - 1], b = c ? v.right - p.left : p.right - v.left;
            b > l && (l = b, this.minWidth = o, this.minWidthFrom = a, this.minWidthTo = d);
          }
        }
      }
      a = d + f.breakAfter;
    }
    return n;
  }
  textDirectionAt(t) {
    let { i: n } = this.childPos(t, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? hi.RTL : hi.LTR;
  }
  measureTextSize() {
    for (let o of this.children)
      if (o instanceof uo) {
        let s = o.measureTextSize();
        if (s)
          return s;
      }
    let t = document.createElement("div"), n, r, i;
    return t.className = "cm-line", t.style.width = "99999px", t.style.position = "absolute", t.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(t);
      let o = ww(t.firstChild)[0];
      n = t.getBoundingClientRect().height, r = o ? o.width / 27 : 7, i = o ? o.height : n, t.remove();
    }), { lineHeight: n, charWidth: r, textHeight: i };
  }
  childCursor(t = this.length) {
    let n = this.children.length;
    return n && (t -= this.children[--n].length), new R_e(this.children, t, n);
  }
  computeBlockGapDeco() {
    let t = [], n = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let o = i == n.viewports.length ? null : n.viewports[i], s = o ? o.from - 1 : this.length;
      if (s > r) {
        let l = (n.lineBlockAt(s).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        t.push(ln.replace({
          widget: new Y9(l),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, s));
      }
      if (!o)
        break;
      r = o.to + 1;
    }
    return ln.set(t);
  }
  updateDeco() {
    let t = 1, n = this.view.state.facet(hk).map((o) => (this.dynamicDecorationMap[t++] = typeof o == "function") ? o(this.view) : o), r = !1, i = this.view.state.facet(iLe).map((o, s) => {
      let l = typeof o == "function";
      return l && (r = !0), l ? o(this.view) : o;
    });
    for (i.length && (this.dynamicDecorationMap[t++] = r, n.push(xr.join(i))), this.decorations = [
      this.editContextFormatting,
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; t < this.decorations.length; )
      this.dynamicDecorationMap[t++] = !1;
    return this.decorations;
  }
  scrollIntoView(t) {
    if (t.isSnapshot) {
      let a = this.view.viewState.lineBlockAt(t.range.head);
      this.view.scrollDOM.scrollTop = a.top - t.yMargin, this.view.scrollDOM.scrollLeft = t.xMargin;
      return;
    }
    for (let a of this.view.state.facet(tLe))
      try {
        if (a(this.view, t.range, t))
          return !0;
      } catch (u) {
        ul(this.view.state, u, "scroll handler");
      }
    let { range: n } = t, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), i;
    if (!r)
      return;
    !n.empty && (i = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let o = MG(this.view), s = {
      left: r.left - o.left,
      top: r.top - o.top,
      right: r.right + o.right,
      bottom: r.bottom + o.bottom
    }, { offsetWidth: l, offsetHeight: c } = this.view.scrollDOM;
    cjt(this.view.scrollDOM, s, n.head < n.anchor ? -1 : 1, t.x, t.y, Math.max(Math.min(t.xMargin, l), -l), Math.max(Math.min(t.yMargin, c), -c), this.view.textDirection == hi.LTR);
  }
}
function Ijt(e) {
  return e.node.nodeType == 1 && e.node.firstChild && (e.offset == 0 || e.node.childNodes[e.offset - 1].contentEditable == "false") && (e.offset == e.node.childNodes.length || e.node.childNodes[e.offset].contentEditable == "false");
}
function aLe(e, t) {
  let n = e.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = P_e(n.focusNode, n.focusOffset), i = I_e(n.focusNode, n.focusOffset), o = r || i;
  if (i && r && i.node != r.node) {
    let l = Hr.get(i.node);
    if (!l || l instanceof id && l.text != i.node.nodeValue)
      o = i;
    else if (e.docView.lastCompositionAfterCursor) {
      let c = Hr.get(r.node);
      !c || c instanceof id && c.text != r.node.nodeValue || (o = i);
    }
  }
  if (e.docView.lastCompositionAfterCursor = o != r, !o)
    return null;
  let s = t - o.offset;
  return { from: s, to: s + o.node.nodeValue.length, node: o.node };
}
function Rjt(e, t, n) {
  let r = aLe(e, n);
  if (!r)
    return null;
  let { node: i, from: o, to: s } = r, l = i.nodeValue;
  if (/[\n\r]/.test(l) || e.state.doc.sliceString(r.from, r.to) != l)
    return null;
  let c = t.invertedDesc, a = new eu(c.mapPos(o), c.mapPos(s), o, s), u = [];
  for (let f = i.parentNode; ; f = f.parentNode) {
    let d = Hr.get(f);
    if (d instanceof mh)
      u.push({ node: f, deco: d.mark });
    else {
      if (d instanceof uo || f.nodeName == "DIV" && f.parentNode == e.contentDOM)
        return { range: a, text: i, marks: u, line: f };
      if (f != e.contentDOM)
        u.push({ node: f, deco: new TN({
          inclusive: !0,
          attributes: bjt(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function Mjt(e, t) {
  return e.nodeType != 1 ? 0 : (t && e.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < e.childNodes.length && e.childNodes[t].contentEditable == "false" ? 2 : 0);
}
let Djt = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t, n) {
    pM(t, n, this.changes);
  }
  comparePoint(t, n) {
    pM(t, n, this.changes);
  }
  boundChange(t) {
    pM(t, t, this.changes);
  }
};
function _jt(e, t, n) {
  let r = new Djt();
  return xr.compare(e, t, n, r), r.changes;
}
function Ljt(e, t) {
  for (let n = e; n && n != t; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function zjt(e, t) {
  let n = !1;
  return t && e.iterChangedRanges((r, i) => {
    r < t.to && i > t.from && (n = !0);
  }), n;
}
function jjt(e, t, n = 1) {
  let r = e.charCategorizer(t), i = e.doc.lineAt(t), o = t - i.from;
  if (i.length == 0)
    return rt.cursor(t);
  o == 0 ? n = 1 : o == i.length && (n = -1);
  let s = o, l = o;
  n < 0 ? s = xs(i.text, o, !1) : l = xs(i.text, o);
  let c = r(i.text.slice(s, l));
  for (; s > 0; ) {
    let a = xs(i.text, s, !1);
    if (r(i.text.slice(a, s)) != c)
      break;
    s = a;
  }
  for (; l < i.length; ) {
    let a = xs(i.text, l);
    if (r(i.text.slice(l, a)) != c)
      break;
    l = a;
  }
  return rt.range(s + i.from, l + i.from);
}
function Fjt(e, t) {
  return t.left > e ? t.left - e : Math.max(0, e - t.right);
}
function Ujt(e, t) {
  return t.top > e ? t.top - e : Math.max(0, e - t.bottom);
}
function DU(e, t) {
  return e.top < t.bottom - 1 && e.bottom > t.top + 1;
}
function nue(e, t) {
  return t < e.top ? { top: t, left: e.left, right: e.right, bottom: e.bottom } : e;
}
function rue(e, t) {
  return t > e.bottom ? { top: e.top, left: e.left, right: e.right, bottom: t } : e;
}
function r8(e, t, n) {
  let r, i, o, s, l = !1, c, a, u, f;
  for (let h = e.firstChild; h; h = h.nextSibling) {
    let m = ww(h);
    for (let v = 0; v < m.length; v++) {
      let b = m[v];
      i && DU(i, b) && (b = nue(rue(b, i.bottom), i.top));
      let A = Fjt(t, b), w = Ujt(n, b);
      if (A == 0 && w == 0)
        return h.nodeType == 3 ? iue(h, t, n) : r8(h, t, n);
      if (!r || s > w || s == w && o > A) {
        r = h, i = b, o = A, s = w;
        let O = w ? n < b.top ? -1 : 1 : A ? t < b.left ? -1 : 1 : 0;
        l = !O || (O > 0 ? v < m.length - 1 : v > 0);
      }
      A == 0 ? n > b.bottom && (!u || u.bottom < b.bottom) ? (c = h, u = b) : n < b.top && (!f || f.top > b.top) && (a = h, f = b) : u && DU(u, b) ? u = rue(u, b.bottom) : f && DU(f, b) && (f = nue(f, b.top));
    }
  }
  if (u && u.bottom >= n ? (r = c, i = u) : f && f.top <= n && (r = a, i = f), !r)
    return { node: e, offset: 0 };
  let d = Math.max(i.left, Math.min(i.right, t));
  if (r.nodeType == 3)
    return iue(r, d, n);
  if (l && r.contentEditable != "false")
    return r8(r, d, n);
  let p = Array.prototype.indexOf.call(e.childNodes, r) + (t >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: e, offset: p };
}
function iue(e, t, n) {
  let r = e.nodeValue.length, i = -1, o = 1e9, s = 0;
  for (let l = 0; l < r; l++) {
    let c = Kv(e, l, l + 1).getClientRects();
    for (let a = 0; a < c.length; a++) {
      let u = c[a];
      if (u.top == u.bottom)
        continue;
      s || (s = t - u.left);
      let f = (u.top > n ? u.top - n : n - u.bottom) - 1;
      if (u.left - 1 <= t && u.right + 1 >= t && f < o) {
        let d = t >= (u.left + u.right) / 2, p = d;
        if ((Qt.chrome || Qt.gecko) && Kv(e, l).getBoundingClientRect().left == u.right && (p = !d), f <= 0)
          return { node: e, offset: l + (p ? 1 : 0) };
        i = l + (p ? 1 : 0), o = f;
      }
    }
  }
  return { node: e, offset: i > -1 ? i : s > 0 ? e.nodeValue.length : 0 };
}
function lLe(e, t, n, r = -1) {
  var i, o;
  let s = e.contentDOM.getBoundingClientRect(), l = s.top + e.viewState.paddingTop, c, { docHeight: a } = e.viewState, { x: u, y: f } = t, d = f - l;
  if (d < 0)
    return 0;
  if (d > a)
    return e.state.doc.length;
  for (let O = e.viewState.heightOracle.textHeight / 2, x = !1; c = e.elementAtHeight(d), c.type != Ia.Text; )
    for (; d = r > 0 ? c.bottom + O : c.top - O, !(d >= 0 && d <= a); ) {
      if (x)
        return n ? null : 0;
      x = !0, r = -r;
    }
  f = l + d;
  let p = c.from;
  if (p < e.viewport.from)
    return e.viewport.from == 0 ? 0 : n ? null : oue(e, s, c, u, f);
  if (p > e.viewport.to)
    return e.viewport.to == e.state.doc.length ? e.state.doc.length : n ? null : oue(e, s, c, u, f);
  let h = e.dom.ownerDocument, m = e.root.elementFromPoint ? e.root : h, v = m.elementFromPoint(u, f);
  v && !e.contentDOM.contains(v) && (v = null), v || (u = Math.max(s.left + 1, Math.min(s.right - 1, u)), v = m.elementFromPoint(u, f), v && !e.contentDOM.contains(v) && (v = null));
  let b, A = -1;
  if (v && ((i = e.docView.nearest(v)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (h.caretPositionFromPoint) {
      let O = h.caretPositionFromPoint(u, f);
      O && ({ offsetNode: b, offset: A } = O);
    } else if (h.caretRangeFromPoint) {
      let O = h.caretRangeFromPoint(u, f);
      O && ({ startContainer: b, startOffset: A } = O, (!e.contentDOM.contains(b) || Qt.safari && Vjt(b, A, u) || Qt.chrome && qjt(b, A, u)) && (b = void 0));
    }
    b && (A = Math.min(kf(b), A));
  }
  if (!b || !e.docView.dom.contains(b)) {
    let O = uo.find(e.docView, p);
    if (!O)
      return d > c.top + c.height / 2 ? c.to : c.from;
    ({ node: b, offset: A } = r8(O.dom, u, f));
  }
  let w = e.docView.nearest(b);
  if (!w)
    return null;
  if (w.isWidget && ((o = w.dom) === null || o === void 0 ? void 0 : o.nodeType) == 1) {
    let O = w.dom.getBoundingClientRect();
    return t.y < O.top || t.y <= O.bottom && t.x <= (O.left + O.right) / 2 ? w.posAtStart : w.posAtEnd;
  } else
    return w.localPosFromDOM(b, A) + w.posAtStart;
}
function oue(e, t, n, r, i) {
  let o = Math.round((r - t.left) * e.defaultCharacterWidth);
  if (e.lineWrapping && n.height > e.defaultLineHeight * 1.5) {
    let l = e.viewState.heightOracle.textHeight, c = Math.floor((i - n.top - (e.defaultLineHeight - l) * 0.5) / l);
    o += c * e.viewState.heightOracle.lineLength;
  }
  let s = e.state.sliceDoc(n.from, n.to);
  return n.from + B9(s, o, e.state.tabSize);
}
function Vjt(e, t, n) {
  let r;
  if (e.nodeType != 3 || t != (r = e.nodeValue.length))
    return !1;
  for (let i = e.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return Kv(e, r - 1, r).getBoundingClientRect().left > n;
}
function qjt(e, t, n) {
  if (t != 0)
    return !1;
  for (let i = e; ; ) {
    let o = i.parentNode;
    if (!o || o.nodeType != 1 || o.firstChild != i)
      return !1;
    if (o.classList.contains("cm-line"))
      break;
    i = o;
  }
  let r = e.nodeType == 1 ? e.getBoundingClientRect() : Kv(e, 0, Math.max(e.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function i8(e, t, n) {
  let r = e.lineBlockAt(t);
  if (Array.isArray(r.type)) {
    let i;
    for (let o of r.type) {
      if (o.from > t)
        break;
      if (!(o.to < t)) {
        if (o.from < t && o.to > t)
          return o;
        (!i || o.type == Ia.Text && (i.type != o.type || (n < 0 ? o.from < t : o.to > t))) && (i = o);
      }
    }
    return i || r;
  }
  return r;
}
function Bjt(e, t, n, r) {
  let i = i8(e, t.head, t.assoc || -1), o = !r || i.type != Ia.Text || !(e.lineWrapping || i.widgetLineBreaks) ? null : e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head);
  if (o) {
    let s = e.dom.getBoundingClientRect(), l = e.textDirectionAt(i.from), c = e.posAtCoords({
      x: n == (l == hi.LTR) ? s.right - 1 : s.left + 1,
      y: (o.top + o.bottom) / 2
    });
    if (c != null)
      return rt.cursor(c, n ? -1 : 1);
  }
  return rt.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function sue(e, t, n, r) {
  let i = e.state.doc.lineAt(t.head), o = e.bidiSpans(i), s = e.textDirectionAt(i.from);
  for (let l = t, c = null; ; ) {
    let a = Cjt(i, o, s, l, n), u = Z_e;
    if (!a) {
      if (i.number == (n ? e.state.doc.lines : 1))
        return l;
      u = `
`, i = e.state.doc.line(i.number + (n ? 1 : -1)), o = e.bidiSpans(i), a = e.visualLineSide(i, !n);
    }
    if (c) {
      if (!c(u))
        return l;
    } else {
      if (!r)
        return a;
      c = r(u);
    }
    l = a;
  }
}
function Xjt(e, t, n) {
  let r = e.state.charCategorizer(t), i = r(n);
  return (o) => {
    let s = r(o);
    return i == Oi.Space && (i = s), i == s;
  };
}
function Wjt(e, t, n, r) {
  let i = t.head, o = n ? 1 : -1;
  if (i == (n ? e.state.doc.length : 0))
    return rt.cursor(i, t.assoc);
  let s = t.goalColumn, l, c = e.contentDOM.getBoundingClientRect(), a = e.coordsAtPos(i, t.assoc || -1), u = e.documentTop;
  if (a)
    s == null && (s = a.left - c.left), l = o < 0 ? a.top : a.bottom;
  else {
    let p = e.viewState.lineBlockAt(i);
    s == null && (s = Math.min(c.right - c.left, e.defaultCharacterWidth * (i - p.from))), l = (o < 0 ? p.top : p.bottom) + u;
  }
  let f = c.left + s, d = r ?? e.viewState.heightOracle.textHeight >> 1;
  for (let p = 0; ; p += 10) {
    let h = l + (d + p) * o, m = lLe(e, { x: f, y: h }, !1, o);
    if (h < c.top || h > c.bottom || (o < 0 ? m < i : m > i)) {
      let v = e.docView.coordsForChar(m), b = !v || h < v.top ? -1 : 1;
      return rt.cursor(m, b, void 0, s);
    }
  }
}
function hM(e, t, n) {
  for (; ; ) {
    let r = 0;
    for (let i of e)
      i.between(t - 1, t + 1, (o, s, l) => {
        if (t > o && t < s) {
          let c = r || n || (t - o < s - t ? -1 : 1);
          t = c < 0 ? o : s, r = c;
        }
      });
    if (!r)
      return t;
  }
}
function _U(e, t, n) {
  let r = hM(e.state.facet(RG).map((i) => i(e)), n.from, t.head > n.from ? -1 : 1);
  return r == n.from ? n : rt.cursor(r, r < n.from ? 1 : -1);
}
const v1 = "￿";
class Zjt {
  constructor(t, n) {
    this.points = t, this.text = "", this.lineSeparator = n.facet($n.lineSeparator);
  }
  append(t) {
    this.text += t;
  }
  lineBreak() {
    this.text += v1;
  }
  readRange(t, n) {
    if (!t)
      return this;
    let r = t.parentNode;
    for (let i = t; ; ) {
      this.findPointBefore(r, i);
      let o = this.text.length;
      this.readNode(i);
      let s = i.nextSibling;
      if (s == n)
        break;
      let l = Hr.get(i), c = Hr.get(s);
      (l && c ? l.breakAfter : (l ? l.breakAfter : x_(i)) || x_(s) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > o) && this.lineBreak(), i = s;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(t) {
    let n = t.nodeValue;
    for (let r of this.points)
      r.node == t && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let o = -1, s = 1, l;
      if (this.lineSeparator ? (o = n.indexOf(this.lineSeparator, r), s = this.lineSeparator.length) : (l = i.exec(n)) && (o = l.index, s = l[0].length), this.append(n.slice(r, o < 0 ? n.length : o)), o < 0)
        break;
      if (this.lineBreak(), s > 1)
        for (let c of this.points)
          c.node == t && c.pos > this.text.length && (c.pos -= s - 1);
      r = o + s;
    }
  }
  readNode(t) {
    if (t.cmIgnore)
      return;
    let n = Hr.get(t), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(t, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else t.nodeType == 3 ? this.readTextNode(t) : t.nodeName == "BR" ? t.nextSibling && this.lineBreak() : t.nodeType == 1 && this.readRange(t.firstChild, null);
  }
  findPointBefore(t, n) {
    for (let r of this.points)
      r.node == t && t.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(t, n) {
    for (let r of this.points)
      (t.nodeType == 3 ? r.node == t : t.contains(r.node)) && (r.pos = this.text.length + (Hjt(t, r.node, r.offset) ? n : 0));
  }
}
function Hjt(e, t, n) {
  for (; ; ) {
    if (!t || n < kf(t))
      return !1;
    if (t == e)
      return !0;
    n = $v(t) + 1, t = t.parentNode;
  }
}
class aue {
  constructor(t, n) {
    this.node = t, this.offset = n, this.pos = -1;
  }
}
class Qjt {
  constructor(t, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let { impreciseHead: o, impreciseAnchor: s } = t.docView;
    if (t.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = t.docView.domBoundsAround(n, r, 0))) {
      let l = o || s ? [] : Gjt(t), c = new Zjt(l, t.state);
      c.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = c.text, this.newSel = Yjt(l, this.bounds.from);
    } else {
      let l = t.observer.selectionRange, c = o && o.node == l.focusNode && o.offset == l.focusOffset || !Z9(t.contentDOM, l.focusNode) ? t.state.selection.main.head : t.docView.posFromDOM(l.focusNode, l.focusOffset), a = s && s.node == l.anchorNode && s.offset == l.anchorOffset || !Z9(t.contentDOM, l.anchorNode) ? t.state.selection.main.anchor : t.docView.posFromDOM(l.anchorNode, l.anchorOffset), u = t.viewport;
      if ((Qt.ios || Qt.chrome) && t.state.selection.main.empty && c != a && (u.from > 0 || u.to < t.state.doc.length)) {
        let f = Math.min(c, a), d = Math.max(c, a), p = u.from - f, h = u.to - d;
        (p == 0 || p == 1 || f == 0) && (h == 0 || h == -1 || d == t.state.doc.length) && (c = 0, a = t.state.doc.length);
      }
      this.newSel = rt.single(a, c);
    }
  }
}
function cLe(e, t) {
  let n, { newSel: r } = t, i = e.state.selection.main, o = e.inputState.lastKeyTime > Date.now() - 100 ? e.inputState.lastKeyCode : -1;
  if (t.bounds) {
    let { from: s, to: l } = t.bounds, c = i.from, a = null;
    (o === 8 || Qt.android && t.text.length < l - s) && (c = i.to, a = "end");
    let u = Kjt(e.state.doc.sliceString(s, l, v1), t.text, c - s, a);
    u && (Qt.chrome && o == 13 && u.toB == u.from + 2 && t.text.slice(u.from, u.toB) == v1 + v1 && u.toB--, n = {
      from: s + u.from,
      to: s + u.toA,
      insert: Sr.of(t.text.slice(u.from, u.toB).split(v1))
    });
  } else r && (!e.hasFocus && e.state.facet(zp) || r.main.eq(i)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && t.typeOver && !i.empty && r && r.main.empty ? n = { from: i.from, to: i.to, insert: e.state.doc.slice(i.from, i.to) } : (Qt.mac || Qt.android) && n && n.from == n.to && n.from == i.head - 1 && /^\. ?$/.test(n.insert.toString()) && e.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = rt.single(r.main.anchor - 1, r.main.head - 1)), n = { from: n.from, to: n.to, insert: Sr.of([n.insert.toString().replace(".", " ")]) }) : n && n.from >= i.from && n.to <= i.to && (n.from != i.from || n.to != i.to) && i.to - i.from - (n.to - n.from) <= 4 ? n = {
    from: i.from,
    to: i.to,
    insert: e.state.doc.slice(i.from, n.from).append(n.insert).append(e.state.doc.slice(n.to, i.to))
  } : Qt.chrome && n && n.from == n.to && n.from == i.head && n.insert.toString() == `
 ` && e.lineWrapping && (r && (r = rt.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: Sr.of([" "]) }), n)
    return DG(e, n, r, o);
  if (r && !r.main.eq(i)) {
    let s = !1, l = "select";
    return e.inputState.lastSelectionTime > Date.now() - 50 && (e.inputState.lastSelectionOrigin == "select" && (s = !0), l = e.inputState.lastSelectionOrigin), e.dispatch({ selection: r, scrollIntoView: s, userEvent: l }), !0;
  } else
    return !1;
}
function DG(e, t, n, r = -1) {
  if (Qt.ios && e.inputState.flushIOSKey(t))
    return !0;
  let i = e.state.selection.main;
  if (Qt.android && (t.to == i.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (t.from == i.from || t.from == i.from - 1 && e.state.sliceDoc(t.from, i.from) == " ") && t.insert.length == 1 && t.insert.lines == 2 && nA(e.contentDOM, "Enter", 13) || (t.from == i.from - 1 && t.to == i.to && t.insert.length == 0 || r == 8 && t.insert.length < t.to - t.from && t.to > i.head) && nA(e.contentDOM, "Backspace", 8) || t.from == i.from && t.to == i.to + 1 && t.insert.length == 0 && nA(e.contentDOM, "Delete", 46)))
    return !0;
  let o = t.insert.toString();
  e.inputState.composing >= 0 && e.inputState.composing++;
  let s, l = () => s || (s = $jt(e, t, n));
  return e.state.facet(G_e).some((c) => c(e, t.from, t.to, o, l)) || e.dispatch(l()), !0;
}
function $jt(e, t, n) {
  let r, i = e.state, o = i.selection.main;
  if (t.from >= o.from && t.to <= o.to && t.to - t.from >= (o.to - o.from) / 3 && (!n || n.main.empty && n.main.from == t.from + t.insert.length) && e.inputState.composing < 0) {
    let l = o.from < t.from ? i.sliceDoc(o.from, t.from) : "", c = o.to > t.to ? i.sliceDoc(t.to, o.to) : "";
    r = i.replaceSelection(e.state.toText(l + t.insert.sliceString(0, void 0, e.state.lineBreak) + c));
  } else {
    let l = i.changes(t), c = n && n.main.to <= l.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && e.inputState.composing >= 0 && t.to <= o.to && t.to >= o.to - 10) {
      let a = e.state.sliceDoc(t.from, t.to), u, f = n && aLe(e, n.main.head);
      if (f) {
        let h = t.insert.length - (t.to - t.from);
        u = { from: f.from, to: f.to - h };
      } else
        u = e.state.doc.lineAt(o.head);
      let d = o.to - t.to, p = o.to - o.from;
      r = i.changeByRange((h) => {
        if (h.from == o.from && h.to == o.to)
          return { changes: l, range: c || h.map(l) };
        let m = h.to - d, v = m - a.length;
        if (h.to - h.from != p || e.state.sliceDoc(v, m) != a || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        h.to >= u.from && h.from <= u.to)
          return { range: h };
        let b = i.changes({ from: v, to: m, insert: t.insert }), A = h.to - o.to;
        return {
          changes: b,
          range: c ? rt.range(Math.max(0, c.anchor + A), Math.max(0, c.head + A)) : h.map(b)
        };
      });
    } else
      r = {
        changes: l,
        selection: c && i.selection.replaceRange(c)
      };
  }
  let s = "input.type";
  return (e.composing || e.inputState.compositionPendingChange && e.inputState.compositionEndedAt > Date.now() - 50) && (e.inputState.compositionPendingChange = !1, s += ".compose", e.inputState.compositionFirstChange && (s += ".start", e.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: s, scrollIntoView: !0 });
}
function Kjt(e, t, n, r) {
  let i = Math.min(e.length, t.length), o = 0;
  for (; o < i && e.charCodeAt(o) == t.charCodeAt(o); )
    o++;
  if (o == i && e.length == t.length)
    return null;
  let s = e.length, l = t.length;
  for (; s > 0 && l > 0 && e.charCodeAt(s - 1) == t.charCodeAt(l - 1); )
    s--, l--;
  if (r == "end") {
    let c = Math.max(0, o - Math.min(s, l));
    n -= s + c - o;
  }
  if (s < o && e.length < t.length) {
    let c = n <= o && n >= s ? o - n : 0;
    o -= c, l = o + (l - s), s = o;
  } else if (l < o) {
    let c = n <= o && n >= l ? o - n : 0;
    o -= c, s = o + (s - l), l = o;
  }
  return { from: o, toA: s, toB: l };
}
function Gjt(e) {
  let t = [];
  if (e.root.activeElement != e.contentDOM)
    return t;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o } = e.observer.selectionRange;
  return n && (t.push(new aue(n, r)), (i != n || o != r) && t.push(new aue(i, o))), t;
}
function Yjt(e, t) {
  if (e.length == 0)
    return null;
  let n = e[0].pos, r = e.length == 2 ? e[1].pos : n;
  return n > -1 && r > -1 ? rt.single(n + t, r + t) : null;
}
class Jjt {
  setSelectionOrigin(t) {
    this.lastSelectionOrigin = t, this.lastSelectionTime = Date.now();
  }
  constructor(t) {
    this.view = t, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t.hasFocus, Qt.safari && t.contentDOM.addEventListener("input", () => null), Qt.gecko && m3t(t.contentDOM.ownerDocument);
  }
  handleEvent(t) {
    !a3t(this.view, t) || this.ignoreDuringComposition(t) || t.type == "keydown" && this.keydown(t) || (this.view.updateState != 0 ? Promise.resolve().then(() => this.runHandlers(t.type, t)) : this.runHandlers(t.type, t));
  }
  runHandlers(t, n) {
    let r = this.handlers[t];
    if (r) {
      for (let i of r.observers)
        i(this.view, n);
      for (let i of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(t) {
    let n = e3t(t), r = this.handlers, i = this.view.contentDOM;
    for (let o in n)
      if (o != "scroll") {
        let s = !n[o].handlers.length, l = r[o];
        l && s != !l.handlers.length && (i.removeEventListener(o, this.handleEvent), l = null), l || i.addEventListener(o, this.handleEvent, { passive: s });
      }
    for (let o in r)
      o != "scroll" && !n[o] && i.removeEventListener(o, this.handleEvent);
    this.handlers = n;
  }
  keydown(t) {
    if (this.lastKeyCode = t.keyCode, this.lastKeyTime = Date.now(), t.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && t.keyCode != 27 && dLe.indexOf(t.keyCode) < 0 && (this.tabFocusMode = -1), Qt.android && Qt.chrome && !t.synthetic && (t.keyCode == 13 || t.keyCode == 8))
      return this.view.observer.delayAndroidKey(t.key, t.keyCode), !0;
    let n;
    return Qt.ios && !t.synthetic && !t.altKey && !t.metaKey && ((n = uLe.find((r) => r.keyCode == t.keyCode)) && !t.ctrlKey || t3t.indexOf(t.key) > -1 && t.ctrlKey && !t.shiftKey) ? (this.pendingIOSKey = n || t, setTimeout(() => this.flushIOSKey(), 250), !0) : (t.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(t) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && t && t.from < t.to && /^\S+$/.test(t.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, nA(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(t) {
    return /^key/.test(t.type) ? this.composing > 0 ? !0 : Qt.safari && !Qt.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(t) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t;
  }
  update(t) {
    this.view.observer.update(t), this.mouseSelection && this.mouseSelection.update(t), this.draggedContent && t.docChanged && (this.draggedContent = this.draggedContent.map(t.changes)), t.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function lue(e, t) {
  return (n, r) => {
    try {
      return t.call(e, r, n);
    } catch (i) {
      ul(n.state, i);
    }
  };
}
function e3t(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return t[r] || (t[r] = { observers: [], handlers: [] });
  }
  for (let r of e) {
    let i = r.spec, o = i && i.plugin.domEventHandlers, s = i && i.plugin.domEventObservers;
    if (o)
      for (let l in o) {
        let c = o[l];
        c && n(l).handlers.push(lue(r.value, c));
      }
    if (s)
      for (let l in s) {
        let c = s[l];
        c && n(l).observers.push(lue(r.value, c));
      }
  }
  for (let r in od)
    n(r).handlers.push(od[r]);
  for (let r in lu)
    n(r).observers.push(lu[r]);
  return t;
}
const uLe = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], t3t = "dthko", dLe = [16, 17, 18, 20, 91, 92, 224, 225], PI = 6;
function II(e) {
  return Math.max(0, e) * 0.7 + 8;
}
function n3t(e, t) {
  return Math.max(Math.abs(e.clientX - t.clientX), Math.abs(e.clientY - t.clientY));
}
class r3t {
  constructor(t, n, r, i) {
    this.view = t, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParents = ujt(t.contentDOM), this.atoms = t.state.facet(RG).map((s) => s(t));
    let o = t.contentDOM.ownerDocument;
    o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = t.state.facet($n.allowMultipleSelections) && i3t(t, n), this.dragging = s3t(t, n) && hLe(n) == 1 ? null : !1;
  }
  start(t) {
    this.dragging === !1 && this.select(t);
  }
  move(t) {
    if (t.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && n3t(this.startEvent, t) < 10)
      return;
    this.select(this.lastEvent = t);
    let n = 0, r = 0, i = 0, o = 0, s = this.view.win.innerWidth, l = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: i, right: s } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: o, bottom: l } = this.scrollParents.y.getBoundingClientRect());
    let c = MG(this.view);
    t.clientX - c.left <= i + PI ? n = -II(i - t.clientX) : t.clientX + c.right >= s - PI && (n = II(t.clientX - s)), t.clientY - c.top <= o + PI ? r = -II(o - t.clientY) : t.clientY + c.bottom >= l - PI && (r = II(t.clientY - l)), this.setScrollSpeed(n, r);
  }
  up(t) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let t = this.view.contentDOM.ownerDocument;
    t.removeEventListener("mousemove", this.move), t.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(t, n) {
    this.scrollSpeed = { x: t, y: n }, t || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: t, y: n } = this.scrollSpeed;
    t && this.scrollParents.x && (this.scrollParents.x.scrollLeft += t, t = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (t || n) && this.view.win.scrollBy(t, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(t) {
    let n = null;
    for (let r = 0; r < t.ranges.length; r++) {
      let i = t.ranges[r], o = null;
      if (i.empty) {
        let s = hM(this.atoms, i.from, 0);
        s != i.from && (o = rt.cursor(s, -1));
      } else {
        let s = hM(this.atoms, i.from, -1), l = hM(this.atoms, i.to, 1);
        (s != i.from || l != i.to) && (o = rt.range(i.from == i.anchor ? s : l, i.from == i.head ? s : l));
      }
      o && (n || (n = t.ranges.slice()), n[r] = o);
    }
    return n ? rt.create(n, t.mainIndex) : t;
  }
  select(t) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(t, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(t) {
    t.transactions.some((n) => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(t) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function i3t(e, t) {
  let n = e.state.facet(H_e);
  return n.length ? n[0](t) : Qt.mac ? t.metaKey : t.ctrlKey;
}
function o3t(e, t) {
  let n = e.state.facet(Q_e);
  return n.length ? n[0](t) : Qt.mac ? !t.altKey : !t.ctrlKey;
}
function s3t(e, t) {
  let { main: n } = e.state.selection;
  if (n.empty)
    return !1;
  let r = pk(e.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let o = 0; o < i.length; o++) {
    let s = i[o];
    if (s.left <= t.clientX && s.right >= t.clientX && s.top <= t.clientY && s.bottom >= t.clientY)
      return !0;
  }
  return !1;
}
function a3t(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target, r; n != e.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = Hr.get(n)) && r.ignoreEvent(t))
      return !1;
  return !0;
}
const od = /* @__PURE__ */ Object.create(null), lu = /* @__PURE__ */ Object.create(null), fLe = Qt.ie && Qt.ie_version < 15 || Qt.ios && Qt.webkit_version < 604;
function l3t(e) {
  let t = e.dom.parentNode;
  if (!t)
    return;
  let n = t.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    e.focus(), n.remove(), pLe(e, n.value);
  }, 50);
}
function Qj(e, t, n) {
  for (let r of e.facet(t))
    n = r(n, e);
  return n;
}
function pLe(e, t) {
  t = Qj(e.state, NG, t);
  let { state: n } = e, r, i = 1, o = n.toText(t), s = o.lines == n.selection.ranges.length;
  if (o8 != null && n.selection.ranges.every((c) => c.empty) && o8 == o.toString()) {
    let c = -1;
    r = n.changeByRange((a) => {
      let u = n.doc.lineAt(a.from);
      if (u.from == c)
        return { range: a };
      c = u.from;
      let f = n.toText((s ? o.line(i++).text : t) + n.lineBreak);
      return {
        changes: { from: u.from, insert: f },
        range: rt.cursor(a.from + f.length)
      };
    });
  } else s ? r = n.changeByRange((c) => {
    let a = o.line(i++);
    return {
      changes: { from: c.from, to: c.to, insert: a.text },
      range: rt.cursor(c.from + a.length)
    };
  }) : r = n.replaceSelection(o);
  e.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
lu.scroll = (e) => {
  e.inputState.lastScrollTop = e.scrollDOM.scrollTop, e.inputState.lastScrollLeft = e.scrollDOM.scrollLeft;
};
od.keydown = (e, t) => (e.inputState.setSelectionOrigin("select"), t.keyCode == 27 && e.inputState.tabFocusMode != 0 && (e.inputState.tabFocusMode = Date.now() + 2e3), !1);
lu.touchstart = (e, t) => {
  e.inputState.lastTouchTime = Date.now(), e.inputState.setSelectionOrigin("select.pointer");
};
lu.touchmove = (e) => {
  e.inputState.setSelectionOrigin("select.pointer");
};
od.mousedown = (e, t) => {
  if (e.observer.flush(), e.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of e.state.facet($_e))
    if (n = r(e, t), n)
      break;
  if (!n && t.button == 0 && (n = d3t(e, t)), n) {
    let r = !e.hasFocus;
    e.inputState.startMouseSelection(new r3t(e, t, n, r)), r && e.observer.ignore(() => {
      k_e(e.contentDOM);
      let o = e.root.activeElement;
      o && !o.contains(e.contentDOM) && o.blur();
    });
    let i = e.inputState.mouseSelection;
    if (i)
      return i.start(t), i.dragging === !1;
  }
  return !1;
};
function cue(e, t, n, r) {
  if (r == 1)
    return rt.cursor(t, n);
  if (r == 2)
    return jjt(e.state, t, n);
  {
    let i = uo.find(e.docView, t), o = e.state.doc.lineAt(i ? i.posAtEnd : t), s = i ? i.posAtStart : o.from, l = i ? i.posAtEnd : o.to;
    return l < e.state.doc.length && l == o.to && l++, rt.range(s, l);
  }
}
let uue = (e, t, n) => t >= n.top && t <= n.bottom && e >= n.left && e <= n.right;
function c3t(e, t, n, r) {
  let i = uo.find(e.docView, t);
  if (!i)
    return 1;
  let o = t - i.posAtStart;
  if (o == 0)
    return 1;
  if (o == i.length)
    return -1;
  let s = i.coordsAt(o, -1);
  if (s && uue(n, r, s))
    return -1;
  let l = i.coordsAt(o, 1);
  return l && uue(n, r, l) ? 1 : s && s.bottom >= r ? -1 : 1;
}
function due(e, t) {
  let n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
  return { pos: n, bias: c3t(e, n, t.clientX, t.clientY) };
}
const u3t = Qt.ie && Qt.ie_version <= 11;
let fue = null, pue = 0, hue = 0;
function hLe(e) {
  if (!u3t)
    return e.detail;
  let t = fue, n = hue;
  return fue = e, hue = Date.now(), pue = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (pue + 1) % 3 : 1;
}
function d3t(e, t) {
  let n = due(e, t), r = hLe(t), i = e.state.selection;
  return {
    update(o) {
      o.docChanged && (n.pos = o.changes.mapPos(n.pos), i = i.map(o.changes));
    },
    get(o, s, l) {
      let c = due(e, o), a, u = cue(e, c.pos, c.bias, r);
      if (n.pos != c.pos && !s) {
        let f = cue(e, n.pos, n.bias, r), d = Math.min(f.from, u.from), p = Math.max(f.to, u.to);
        u = d < u.from ? rt.range(d, p) : rt.range(p, d);
      }
      return s ? i.replaceRange(i.main.extend(u.from, u.to)) : l && r == 1 && i.ranges.length > 1 && (a = f3t(i, c.pos)) ? a : l ? i.addRange(u) : rt.create([u]);
    }
  };
}
function f3t(e, t) {
  for (let n = 0; n < e.ranges.length; n++) {
    let { from: r, to: i } = e.ranges[n];
    if (r <= t && i >= t)
      return rt.create(e.ranges.slice(0, n).concat(e.ranges.slice(n + 1)), e.mainIndex == n ? 0 : e.mainIndex - (e.mainIndex > n ? 1 : 0));
  }
  return null;
}
od.dragstart = (e, t) => {
  let { selection: { main: n } } = e.state;
  if (t.target.draggable) {
    let i = e.docView.nearest(t.target);
    if (i && i.isWidget) {
      let o = i.posAtStart, s = o + i.length;
      (o >= n.to || s <= n.from) && (n = rt.range(o, s));
    }
  }
  let { inputState: r } = e;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, t.dataTransfer && (t.dataTransfer.setData("Text", Qj(e.state, PG, e.state.sliceDoc(n.from, n.to))), t.dataTransfer.effectAllowed = "copyMove"), !1;
};
od.dragend = (e) => (e.inputState.draggedContent = null, !1);
function mue(e, t, n, r) {
  if (n = Qj(e.state, NG, n), !n)
    return;
  let i = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1), { draggedContent: o } = e.inputState, s = r && o && o3t(e, t) ? { from: o.from, to: o.to } : null, l = { from: i, insert: n }, c = e.state.changes(s ? [s, l] : l);
  e.focus(), e.dispatch({
    changes: c,
    selection: { anchor: c.mapPos(i, -1), head: c.mapPos(i, 1) },
    userEvent: s ? "move.drop" : "input.drop"
  }), e.inputState.draggedContent = null;
}
od.drop = (e, t) => {
  if (!t.dataTransfer)
    return !1;
  if (e.state.readOnly)
    return !0;
  let n = t.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, o = () => {
      ++i == n.length && mue(e, t, r.filter((s) => s != null).join(e.state.lineBreak), !1);
    };
    for (let s = 0; s < n.length; s++) {
      let l = new FileReader();
      l.onerror = o, l.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(l.result) || (r[s] = l.result), o();
      }, l.readAsText(n[s]);
    }
    return !0;
  } else {
    let r = t.dataTransfer.getData("Text");
    if (r)
      return mue(e, t, r, !0), !0;
  }
  return !1;
};
od.paste = (e, t) => {
  if (e.state.readOnly)
    return !0;
  e.observer.flush();
  let n = fLe ? null : t.clipboardData;
  return n ? (pLe(e, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (l3t(e), !1);
};
function p3t(e, t) {
  let n = e.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = t, r.focus(), r.selectionEnd = t.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), e.focus();
  }, 50);
}
function h3t(e) {
  let t = [], n = [], r = !1;
  for (let i of e.selection.ranges)
    i.empty || (t.push(e.sliceDoc(i.from, i.to)), n.push(i));
  if (!t.length) {
    let i = -1;
    for (let { from: o } of e.selection.ranges) {
      let s = e.doc.lineAt(o);
      s.number > i && (t.push(s.text), n.push({ from: s.from, to: Math.min(e.doc.length, s.to + 1) })), i = s.number;
    }
    r = !0;
  }
  return { text: Qj(e, PG, t.join(e.lineBreak)), ranges: n, linewise: r };
}
let o8 = null;
od.copy = od.cut = (e, t) => {
  let { text: n, ranges: r, linewise: i } = h3t(e.state);
  if (!n && !i)
    return !1;
  o8 = i ? n : null, t.type == "cut" && !e.state.readOnly && e.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let o = fLe ? null : t.clipboardData;
  return o ? (o.clearData(), o.setData("text/plain", n), !0) : (p3t(e, n), !1);
};
const mLe = /* @__PURE__ */ Uf.define();
function gLe(e, t) {
  let n = [];
  for (let r of e.facet(Y_e)) {
    let i = r(e, t);
    i && n.push(i);
  }
  return n.length ? e.update({ effects: n, annotations: mLe.of(!0) }) : null;
}
function yLe(e) {
  setTimeout(() => {
    let t = e.hasFocus;
    if (t != e.inputState.notifiedFocused) {
      let n = gLe(e.state, t);
      n ? e.dispatch(n) : e.update([]);
    }
  }, 10);
}
lu.focus = (e) => {
  e.inputState.lastFocusTime = Date.now(), !e.scrollDOM.scrollTop && (e.inputState.lastScrollTop || e.inputState.lastScrollLeft) && (e.scrollDOM.scrollTop = e.inputState.lastScrollTop, e.scrollDOM.scrollLeft = e.inputState.lastScrollLeft), yLe(e);
};
lu.blur = (e) => {
  e.observer.clearSelectionRange(), yLe(e);
};
lu.compositionstart = lu.compositionupdate = (e) => {
  e.observer.editContext || (e.inputState.compositionFirstChange == null && (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0));
};
lu.compositionend = (e) => {
  e.observer.editContext || (e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionPendingKey = !0, e.inputState.compositionPendingChange = e.observer.pendingRecords().length > 0, e.inputState.compositionFirstChange = null, Qt.chrome && Qt.android ? e.observer.flushSoon() : e.inputState.compositionPendingChange ? Promise.resolve().then(() => e.observer.flush()) : setTimeout(() => {
    e.inputState.composing < 0 && e.docView.hasComposition && e.update([]);
  }, 50));
};
lu.contextmenu = (e) => {
  e.inputState.lastContextMenu = Date.now();
};
od.beforeinput = (e, t) => {
  var n, r;
  if (t.inputType == "insertReplacementText" && e.observer.editContext) {
    let o = (n = t.dataTransfer) === null || n === void 0 ? void 0 : n.getData("text/plain"), s = t.getTargetRanges();
    if (o && s.length) {
      let l = s[0], c = e.posAtDOM(l.startContainer, l.startOffset), a = e.posAtDOM(l.endContainer, l.endOffset);
      return DG(e, { from: c, to: a, insert: e.state.toText(o) }, null), !0;
    }
  }
  let i;
  if (Qt.chrome && Qt.android && (i = uLe.find((o) => o.inputType == t.inputType)) && (e.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let o = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > o + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
    }, 100);
  }
  return Qt.ios && t.inputType == "deleteContentForward" && e.observer.flushSoon(), Qt.safari && t.inputType == "insertText" && e.inputState.composing >= 0 && setTimeout(() => lu.compositionend(e, t), 20), !1;
};
const gue = /* @__PURE__ */ new Set();
function m3t(e) {
  gue.has(e) || (gue.add(e), e.addEventListener("copy", () => {
  }), e.addEventListener("cut", () => {
  }));
}
const yue = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let Ew = !1;
function vue() {
  Ew = !1;
}
class g3t {
  constructor(t) {
    this.lineWrapping = t, this.doc = Sr.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(t, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(t).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - t - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(t) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(t) {
    return this.doc = t, this;
  }
  mustRefreshForWrapping(t) {
    return yue.indexOf(t) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(t) {
    let n = !1;
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(t, n, r, i, o, s) {
    let l = yue.indexOf(t) > -1, c = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != l;
    if (this.lineWrapping = l, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = o, c) {
      this.heightSamples = {};
      for (let a = 0; a < s.length; a++) {
        let u = s[a];
        u < 0 ? a++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return c;
  }
}
class y3t {
  constructor(t, n) {
    this.from = t, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class nf {
  /**
  @internal
  */
  constructor(t, n, r, i, o) {
    this.from = t, this.length = n, this.top = r, this.height = i, this._content = o;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? Ia.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof ug ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(t) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t._content) ? t._content : [t]);
    return new nf(this.from, this.length + t.length, this.top, this.height + t.height, n);
  }
}
var ci = /* @__PURE__ */ function(e) {
  return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
}(ci || (ci = {}));
const mM = 1e-3;
class Ra {
  constructor(t, n, r = 2) {
    this.length = t, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(t) {
    this.flags = (t ? 2 : 0) | this.flags & -3;
  }
  setHeight(t) {
    this.height != t && (Math.abs(this.height - t) > mM && (Ew = !0), this.height = t);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(t, n, r) {
    return Ra.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(t, n) {
    n.push(this);
  }
  decomposeRight(t, n) {
    n.push(this);
  }
  applyChanges(t, n, r, i) {
    let o = this, s = r.doc;
    for (let l = i.length - 1; l >= 0; l--) {
      let { fromA: c, toA: a, fromB: u, toB: f } = i[l], d = o.lineAt(c, ci.ByPosNoHeight, r.setDoc(n), 0, 0), p = d.to >= a ? d : o.lineAt(a, ci.ByPosNoHeight, r, 0, 0);
      for (f += p.to - a, a = p.to; l > 0 && d.from <= i[l - 1].toA; )
        c = i[l - 1].fromA, u = i[l - 1].fromB, l--, c < d.from && (d = o.lineAt(c, ci.ByPosNoHeight, r, 0, 0));
      u += d.from - c, c = d.from;
      let h = _G.build(r.setDoc(s), t, u, f);
      o = T_(o, o.replace(c, a, h));
    }
    return o.updateHeight(r, 0);
  }
  static empty() {
    return new Bl(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(t) {
    if (t.length == 1)
      return t[0];
    let n = 0, r = t.length, i = 0, o = 0;
    for (; ; )
      if (n == r)
        if (i > o * 2) {
          let l = t[n - 1];
          l.break ? t.splice(--n, 1, l.left, null, l.right) : t.splice(--n, 1, l.left, l.right), r += 1 + l.break, i -= l.size;
        } else if (o > i * 2) {
          let l = t[r];
          l.break ? t.splice(r, 1, l.left, null, l.right) : t.splice(r, 1, l.left, l.right), r += 2 + l.break, o -= l.size;
        } else
          break;
      else if (i < o) {
        let l = t[n++];
        l && (i += l.size);
      } else {
        let l = t[--r];
        l && (o += l.size);
      }
    let s = 0;
    return t[n - 1] == null ? (s = 1, n--) : t[n] == null && (s = 1, r++), new v3t(Ra.of(t.slice(0, n)), s, Ra.of(t.slice(r)));
  }
}
function T_(e, t) {
  return e == t ? e : (e.constructor != t.constructor && (Ew = !0), t);
}
Ra.prototype.size = 1;
class vLe extends Ra {
  constructor(t, n, r) {
    super(t, n), this.deco = r;
  }
  blockAt(t, n, r, i) {
    return new nf(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(t, n, r, i, o) {
    return this.blockAt(0, r, i, o);
  }
  forEachLine(t, n, r, i, o, s) {
    t <= o + this.length && n >= o && s(this.blockAt(0, r, i, o));
  }
  updateHeight(t, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setHeight(i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class Bl extends vLe {
  constructor(t, n) {
    super(t, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(t, n, r, i) {
    return new nf(i, this.length, r, this.height, this.breaks);
  }
  replace(t, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof Bl || i instanceof hs && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof hs ? i = new Bl(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : Ra.of(r);
  }
  updateHeight(t, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setHeight(i.heights[i.index++]) : (r || this.outdated) && this.setHeight(Math.max(this.widgetHeight, t.heightForLine(this.length - this.collapsed)) + this.breaks * t.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class hs extends Ra {
  constructor(t) {
    super(t, 0);
  }
  heightMetrics(t, n) {
    let r = t.doc.lineAt(n).number, i = t.doc.lineAt(n + this.length).number, o = i - r + 1, s, l = 0;
    if (t.lineWrapping) {
      let c = Math.min(this.height, t.lineHeight * o);
      s = c / o, this.length > o + 1 && (l = (this.height - c) / (this.length - o - 1));
    } else
      s = this.height / o;
    return { firstLine: r, lastLine: i, perLine: s, perChar: l };
  }
  blockAt(t, n, r, i) {
    let { firstLine: o, lastLine: s, perLine: l, perChar: c } = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let a = i + (t < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (t - r) / this.height)) * this.length)), u = n.doc.lineAt(a), f = l + u.length * c, d = Math.max(r, t - f / 2);
      return new nf(u.from, u.length, d, f, 0);
    } else {
      let a = Math.max(0, Math.min(s - o, Math.floor((t - r) / l))), { from: u, length: f } = n.doc.line(o + a);
      return new nf(u, f, r + l * a, l, 0);
    }
  }
  lineAt(t, n, r, i, o) {
    if (n == ci.ByHeight)
      return this.blockAt(t, r, i, o);
    if (n == ci.ByPosNoHeight) {
      let { from: p, to: h } = r.doc.lineAt(t);
      return new nf(p, h - p, 0, 0, 0);
    }
    let { firstLine: s, perLine: l, perChar: c } = this.heightMetrics(r, o), a = r.doc.lineAt(t), u = l + a.length * c, f = a.number - s, d = i + l * f + c * (a.from - o - f);
    return new nf(a.from, a.length, Math.max(i, Math.min(d, i + this.height - u)), u, 0);
  }
  forEachLine(t, n, r, i, o, s) {
    t = Math.max(t, o), n = Math.min(n, o + this.length);
    let { firstLine: l, perLine: c, perChar: a } = this.heightMetrics(r, o);
    for (let u = t, f = i; u <= n; ) {
      let d = r.doc.lineAt(u);
      if (u == t) {
        let h = d.number - l;
        f += c * h + a * (t - o - h);
      }
      let p = c + a * d.length;
      s(new nf(d.from, d.length, f, p, 0)), f += p, u = d.to + 1;
    }
  }
  replace(t, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let o = r[r.length - 1];
      o instanceof hs ? r[r.length - 1] = new hs(o.length + i) : r.push(null, new hs(i - 1));
    }
    if (t > 0) {
      let o = r[0];
      o instanceof hs ? r[0] = new hs(t + o.length) : r.unshift(new hs(t - 1), null);
    }
    return Ra.of(r);
  }
  decomposeLeft(t, n) {
    n.push(new hs(t - 1), null);
  }
  decomposeRight(t, n) {
    n.push(null, new hs(this.length - t - 1));
  }
  updateHeight(t, n = 0, r = !1, i) {
    let o = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let s = [], l = Math.max(n, i.from), c = -1;
      for (i.from > n && s.push(new hs(i.from - n - 1).updateHeight(t, n)); l <= o && i.more; ) {
        let u = t.doc.lineAt(l).length;
        s.length && s.push(null);
        let f = i.heights[i.index++];
        c == -1 ? c = f : Math.abs(f - c) >= mM && (c = -2);
        let d = new Bl(u, f);
        d.outdated = !1, s.push(d), l += u + 1;
      }
      l <= o && s.push(null, new hs(o - l).updateHeight(t, l));
      let a = Ra.of(s);
      return (c < 0 || Math.abs(a.height - this.height) >= mM || Math.abs(c - this.heightMetrics(t, n).perLine) >= mM) && (Ew = !0), T_(this, a);
    } else (r || this.outdated) && (this.setHeight(t.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class v3t extends Ra {
  constructor(t, n, r) {
    super(t.length + n + r.length, t.height + r.height, n | (t.outdated || r.outdated ? 2 : 0)), this.left = t, this.right = r, this.size = t.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(t, n, r, i) {
    let o = r + this.left.height;
    return t < o ? this.left.blockAt(t, n, r, i) : this.right.blockAt(t, n, o, i + this.left.length + this.break);
  }
  lineAt(t, n, r, i, o) {
    let s = i + this.left.height, l = o + this.left.length + this.break, c = n == ci.ByHeight ? t < s : t < l, a = c ? this.left.lineAt(t, n, r, i, o) : this.right.lineAt(t, n, r, s, l);
    if (this.break || (c ? a.to < l : a.from > l))
      return a;
    let u = n == ci.ByPosNoHeight ? ci.ByPosNoHeight : ci.ByPos;
    return c ? a.join(this.right.lineAt(l, u, r, s, l)) : this.left.lineAt(l, u, r, i, o).join(a);
  }
  forEachLine(t, n, r, i, o, s) {
    let l = i + this.left.height, c = o + this.left.length + this.break;
    if (this.break)
      t < c && this.left.forEachLine(t, n, r, i, o, s), n >= c && this.right.forEachLine(t, n, r, l, c, s);
    else {
      let a = this.lineAt(c, ci.ByPos, r, i, o);
      t < a.from && this.left.forEachLine(t, a.from - 1, r, i, o, s), a.to >= t && a.from <= n && s(a), n > a.to && this.right.forEachLine(a.to + 1, n, r, l, c, s);
    }
  }
  replace(t, n, r) {
    let i = this.left.length + this.break;
    if (n < i)
      return this.balanced(this.left.replace(t, n, r), this.right);
    if (t > this.left.length)
      return this.balanced(this.left, this.right.replace(t - i, n - i, r));
    let o = [];
    t > 0 && this.decomposeLeft(t, o);
    let s = o.length;
    for (let l of r)
      o.push(l);
    if (t > 0 && bue(o, s - 1), n < this.length) {
      let l = o.length;
      this.decomposeRight(n, o), bue(o, l);
    }
    return Ra.of(o);
  }
  decomposeLeft(t, n) {
    let r = this.left.length;
    if (t <= r)
      return this.left.decomposeLeft(t, n);
    n.push(this.left), this.break && (r++, t >= r && n.push(null)), t > r && this.right.decomposeLeft(t - r, n);
  }
  decomposeRight(t, n) {
    let r = this.left.length, i = r + this.break;
    if (t >= i)
      return this.right.decomposeRight(t - i, n);
    t < r && this.left.decomposeRight(t, n), this.break && t < i && n.push(null), n.push(this.right);
  }
  balanced(t, n) {
    return t.size > 2 * n.size || n.size > 2 * t.size ? Ra.of(this.break ? [t, null, n] : [t, n]) : (this.left = T_(this.left, t), this.right = T_(this.right, n), this.setHeight(t.height + n.height), this.outdated = t.outdated || n.outdated, this.size = t.size + n.size, this.length = t.length + this.break + n.length, this);
  }
  updateHeight(t, n = 0, r = !1, i) {
    let { left: o, right: s } = this, l = n + o.length + this.break, c = null;
    return i && i.from <= n + o.length && i.more ? c = o = o.updateHeight(t, n, r, i) : o.updateHeight(t, n, r), i && i.from <= l + s.length && i.more ? c = s = s.updateHeight(t, l, r, i) : s.updateHeight(t, l, r), c ? this.balanced(o, s) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function bue(e, t) {
  let n, r;
  e[t] == null && (n = e[t - 1]) instanceof hs && (r = e[t + 1]) instanceof hs && e.splice(t - 1, 3, new hs(n.length + 1 + r.length));
}
const b3t = 5;
class _G {
  constructor(t, n) {
    this.pos = t, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(t, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof Bl ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Bl(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(t, n, r) {
    if (t < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, o = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let s = n - t;
      r.block ? this.addBlock(new vLe(s, i, r)) : (s || o || i >= b3t) && this.addLineDeco(i, o, s);
    } else n > t && this.span(t, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: t, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = t, this.lineEnd = n, this.writtenTo < t && ((this.writtenTo < t - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new Bl(this.pos - t, -1)), this.writtenTo = this.pos;
  }
  blankContent(t, n) {
    let r = new hs(n - t);
    return this.oracle.doc.lineAt(t).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let t = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t instanceof Bl)
      return t;
    let n = new Bl(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(t) {
    this.enterLine();
    let n = t.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(t), this.writtenTo = this.pos = this.pos + t.length, n && n.endSide > 0 && (this.covering = t);
  }
  addLineDeco(t, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, t), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(t) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof Bl) && !this.isCovered ? this.nodes.push(new Bl(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = t;
    for (let i of this.nodes)
      i instanceof Bl && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(t, n, r, i) {
    let o = new _G(r, t);
    return xr.spans(n, r, i, o, 0), o.finish(r);
  }
}
function O3t(e, t, n) {
  let r = new A3t();
  return xr.compare(e, t, n, r, 0), r.changes;
}
class A3t {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(t, n, r, i) {
    (t < n || r && r.heightRelevant || i && i.heightRelevant) && pM(t, n, this.changes, 5);
  }
}
function w3t(e, t) {
  let n = e.getBoundingClientRect(), r = e.ownerDocument, i = r.defaultView || window, o = Math.max(0, n.left), s = Math.min(i.innerWidth, n.right), l = Math.max(0, n.top), c = Math.min(i.innerHeight, n.bottom);
  for (let a = e.parentNode; a && a != r.body; )
    if (a.nodeType == 1) {
      let u = a, f = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && f.overflow != "visible") {
        let d = u.getBoundingClientRect();
        o = Math.max(o, d.left), s = Math.min(s, d.right), l = Math.max(l, d.top), c = Math.min(a == e.parentNode ? i.innerHeight : c, d.bottom);
      }
      a = f.position == "absolute" || f.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (a.nodeType == 11)
      a = a.host;
    else
      break;
  return {
    left: o - n.left,
    right: Math.max(o, s) - n.left,
    top: l - (n.top + t),
    bottom: Math.max(l, c) - (n.top + t)
  };
}
function x3t(e) {
  let t = e.getBoundingClientRect(), n = e.ownerDocument.defaultView || window;
  return t.left < n.innerWidth && t.right > 0 && t.top < n.innerHeight && t.bottom > 0;
}
function S3t(e, t) {
  let n = e.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: t,
    bottom: n.bottom - (n.top + t)
  };
}
class LU {
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.size = r, this.displaySize = i;
  }
  static same(t, n) {
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++) {
      let i = t[r], o = n[r];
      if (i.from != o.from || i.to != o.to || i.size != o.size)
        return !1;
    }
    return !0;
  }
  draw(t, n) {
    return ln.replace({
      widget: new E3t(this.displaySize * (n ? t.scaleY : t.scaleX), n)
    }).range(this.from, this.to);
  }
}
class E3t extends qf {
  constructor(t, n) {
    super(), this.size = t, this.vertical = n;
  }
  eq(t) {
    return t.size == this.size && t.vertical == this.vertical;
  }
  toDOM() {
    let t = document.createElement("div");
    return this.vertical ? t.style.height = this.size + "px" : (t.style.width = this.size + "px", t.style.height = "2px", t.style.display = "inline-block"), t;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class Oue {
  constructor(t) {
    this.state = t, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = Aue, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = hi.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = t.facet(IG).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new g3t(n), this.stateDeco = t.facet(hk).filter((r) => typeof r != "function"), this.heightMap = Ra.empty().applyChanges(this.stateDeco, Sr.empty, this.heightOracle.setDoc(t.doc), [new eu(0, 0, 0, t.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = ln.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let t = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!t.some(({ from: o, to: s }) => i >= o && i <= s)) {
        let { from: o, to: s } = this.lineBlockAt(i);
        t.push(new RI(o, s));
      }
    }
    return this.viewports = t.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let t = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? Aue : new LG(this.heightOracle, this.heightMap, this.viewports), t.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (t) => {
      this.viewportLines.push(b1(t, this.scaler));
    });
  }
  update(t, n = null) {
    this.state = t.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(hk).filter((u) => typeof u != "function");
    let i = t.changedRanges, o = eu.extendWithRanges(i, O3t(r, this.stateDeco, t ? t.changes : Ro.empty(this.state.doc.length))), s = this.heightMap.height, l = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    vue(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, t.startState.doc, this.heightOracle.setDoc(this.state.doc), o), (this.heightMap.height != s || Ew) && (t.flags |= 2), l ? (this.scrollAnchorPos = t.changes.mapPos(l.from, -1), this.scrollAnchorHeight = l.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = s);
    let c = o.length ? this.mapViewport(this.viewport, t.changes) : this.viewport;
    (n && (n.range.head < c.from || n.range.head > c.to) || !this.viewportIsAppropriate(c)) && (c = this.getViewport(0, n));
    let a = c.from != this.viewport.from || c.to != this.viewport.to;
    this.viewport = c, t.flags |= this.updateForViewport(), (a || !t.changes.empty || t.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t.changes))), t.flags |= this.computeVisibleRanges(t.changes), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && t.selectionSet && t.view.lineWrapping && t.state.selection.main.empty && t.state.selection.main.assoc && !t.state.facet(eLe) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(t) {
    let n = t.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, o = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? hi.RTL : hi.LTR;
    let s = this.heightOracle.mustRefreshForWrapping(o), l = n.getBoundingClientRect(), c = s || this.mustMeasureContent || this.contentDOMHeight != l.height;
    this.contentDOMHeight = l.height, this.mustMeasureContent = !1;
    let a = 0, u = 0;
    if (l.width && l.height) {
      let { scaleX: O, scaleY: x } = T_e(n, l);
      (O > 5e-3 && Math.abs(this.scaleX - O) > 5e-3 || x > 5e-3 && Math.abs(this.scaleY - x) > 5e-3) && (this.scaleX = O, this.scaleY = x, a |= 16, s = c = !0);
    }
    let f = (parseInt(r.paddingTop) || 0) * this.scaleY, d = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != d) && (this.paddingTop = f, this.paddingBottom = d, a |= 18), this.editorWidth != t.scrollDOM.clientWidth && (i.lineWrapping && (c = !0), this.editorWidth = t.scrollDOM.clientWidth, a |= 16);
    let p = t.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != p && (this.scrollAnchorHeight = -1, this.scrollTop = p), this.scrolledToBottom = N_e(t.scrollDOM);
    let h = (this.printing ? S3t : w3t)(n, this.paddingTop), m = h.top - this.pixelViewport.top, v = h.bottom - this.pixelViewport.bottom;
    this.pixelViewport = h;
    let b = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (b != this.inView && (this.inView = b, b && (c = !0)), !this.inView && !this.scrollTarget && !x3t(t.dom))
      return 0;
    let A = l.width;
    if ((this.contentDOMWidth != A || this.editorHeight != t.scrollDOM.clientHeight) && (this.contentDOMWidth = l.width, this.editorHeight = t.scrollDOM.clientHeight, a |= 16), c) {
      let O = t.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(O) && (s = !0), s || i.lineWrapping && Math.abs(A - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: x, charWidth: S, textHeight: E } = t.docView.measureTextSize();
        s = x > 0 && i.refresh(o, x, S, E, A / S, O), s && (t.docView.minWidth = 0, a |= 16);
      }
      m > 0 && v > 0 ? u = Math.max(m, v) : m < 0 && v < 0 && (u = Math.min(m, v)), vue();
      for (let x of this.viewports) {
        let S = x.from == this.viewport.from ? O : t.docView.measureVisibleLineHeights(x);
        this.heightMap = (s ? Ra.empty().applyChanges(this.stateDeco, Sr.empty, this.heightOracle, [new eu(0, 0, 0, t.state.doc.length)]) : this.heightMap).updateHeight(i, 0, s, new y3t(x.from, S));
      }
      Ew && (a |= 2);
    }
    let w = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return w && (a & 2 && (a |= this.updateScaler()), this.viewport = this.getViewport(u, this.scrollTarget), a |= this.updateForViewport()), (a & 2 || w) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(s ? [] : this.lineGaps, t)), a |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, t.docView.enforceCursorAssoc()), a;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(t, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, t / 1e3 / 2)), i = this.heightMap, o = this.heightOracle, { visibleTop: s, visibleBottom: l } = this, c = new RI(i.lineAt(s - r * 1e3, ci.ByHeight, o, 0, 0).from, i.lineAt(l + (1 - r) * 1e3, ci.ByHeight, o, 0, 0).to);
    if (n) {
      let { head: a } = n.range;
      if (a < c.from || a > c.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = i.lineAt(a, ci.ByPos, o, 0, 0), d;
        n.y == "center" ? d = (f.top + f.bottom) / 2 - u / 2 : n.y == "start" || n.y == "nearest" && a < c.from ? d = f.top : d = f.bottom - u, c = new RI(i.lineAt(d - 1e3 / 2, ci.ByHeight, o, 0, 0).from, i.lineAt(d + u + 1e3 / 2, ci.ByHeight, o, 0, 0).to);
      }
    }
    return c;
  }
  mapViewport(t, n) {
    let r = n.mapPos(t.from, -1), i = n.mapPos(t.to, 1);
    return new RI(this.heightMap.lineAt(r, ci.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, ci.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: t, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(t, ci.ByPos, this.heightOracle, 0, 0), { bottom: o } = this.heightMap.lineAt(n, ci.ByPos, this.heightOracle, 0, 0), { visibleTop: s, visibleBottom: l } = this;
    return (t == 0 || i <= s - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || o >= l + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > s - 2 * 1e3 && o < l + 2 * 1e3;
  }
  mapLineGaps(t, n) {
    if (!t.length || n.empty)
      return t;
    let r = [];
    for (let i of t)
      n.touchesRange(i.from, i.to) || r.push(new LU(n.mapPos(i.from), n.mapPos(i.to), i.size, i.displaySize));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(t, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, o = i >> 1, s = i << 1;
    if (this.defaultTextDirection != hi.LTR && !r)
      return [];
    let l = [], c = (u, f, d, p) => {
      if (f - u < o)
        return;
      let h = this.state.selection.main, m = [h.from];
      h.empty || m.push(h.to);
      for (let b of m)
        if (b > u && b < f) {
          c(u, b - 10, d, p), c(b + 10, f, d, p);
          return;
        }
      let v = k3t(t, (b) => b.from >= d.from && b.to <= d.to && Math.abs(b.from - u) < o && Math.abs(b.to - f) < o && !m.some((A) => b.from < A && b.to > A));
      if (!v) {
        if (f < d.to && n && r && n.visibleRanges.some((w) => w.from <= f && w.to >= f)) {
          let w = n.moveToLineBoundary(rt.cursor(f), !1, !0).head;
          w > u && (f = w);
        }
        let b = this.gapSize(d, u, f, p), A = r || b < 2e6 ? b : 2e6;
        v = new LU(u, f, b, A);
      }
      l.push(v);
    }, a = (u) => {
      if (u.length < s || u.type != Ia.Text)
        return;
      let f = T3t(u.from, u.to, this.stateDeco);
      if (f.total < s)
        return;
      let d = this.scrollTarget ? this.scrollTarget.range.head : null, p, h;
      if (r) {
        let m = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, v, b;
        if (d != null) {
          let A = DI(f, d), w = ((this.visibleBottom - this.visibleTop) / 2 + m) / u.height;
          v = A - w, b = A + w;
        } else
          v = (this.visibleTop - u.top - m) / u.height, b = (this.visibleBottom - u.top + m) / u.height;
        p = MI(f, v), h = MI(f, b);
      } else {
        let m = f.total * this.heightOracle.charWidth, v = i * this.heightOracle.charWidth, b = 0;
        if (m > 2e6)
          for (let S of t)
            S.from >= u.from && S.from < u.to && S.size != S.displaySize && S.from * this.heightOracle.charWidth + b < this.pixelViewport.left && (b = S.size - S.displaySize);
        let A = this.pixelViewport.left + b, w = this.pixelViewport.right + b, O, x;
        if (d != null) {
          let S = DI(f, d), E = ((w - A) / 2 + v) / m;
          O = S - E, x = S + E;
        } else
          O = (A - v) / m, x = (w + v) / m;
        p = MI(f, O), h = MI(f, x);
      }
      p > u.from && c(u.from, p, u, f), h < u.to && c(h, u.to, u, f);
    };
    for (let u of this.viewportLines)
      Array.isArray(u.type) ? u.type.forEach(a) : a(u);
    return l;
  }
  gapSize(t, n, r, i) {
    let o = DI(i, r) - DI(i, n);
    return this.heightOracle.lineWrapping ? t.height * o : i.total * this.heightOracle.charWidth * o;
  }
  updateLineGaps(t) {
    LU.same(t, this.lineGaps) || (this.lineGaps = t, this.lineGapDeco = ln.set(t.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(t) {
    let n = this.stateDeco;
    this.lineGaps.length && (n = n.concat(this.lineGapDeco));
    let r = [];
    xr.spans(n, this.viewport.from, this.viewport.to, {
      span(o, s) {
        r.push({ from: o, to: s });
      },
      point() {
      }
    }, 20);
    let i = 0;
    if (r.length != this.visibleRanges.length)
      i = 12;
    else
      for (let o = 0; o < r.length && !(i & 8); o++) {
        let s = this.visibleRanges[o], l = r[o];
        (s.from != l.from || s.to != l.to) && (i |= 4, t && t.mapPos(s.from, -1) == l.from && t.mapPos(s.to, 1) == l.to || (i |= 8));
      }
    return this.visibleRanges = r, i;
  }
  lineBlockAt(t) {
    return t >= this.viewport.from && t <= this.viewport.to && this.viewportLines.find((n) => n.from <= t && n.to >= t) || b1(this.heightMap.lineAt(t, ci.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(t) {
    return t >= this.viewportLines[0].top && t <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((n) => n.top <= t && n.bottom >= t) || b1(this.heightMap.lineAt(this.scaler.fromDOM(t), ci.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(t) {
    let n = this.lineBlockAtHeight(t + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - t > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(t) {
    return b1(this.heightMap.blockAt(this.scaler.fromDOM(t), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
let RI = class {
  constructor(t, n) {
    this.from = t, this.to = n;
  }
};
function T3t(e, t, n) {
  let r = [], i = e, o = 0;
  return xr.spans(n, e, t, {
    span() {
    },
    point(s, l) {
      s > i && (r.push({ from: i, to: s }), o += s - i), i = l;
    }
  }, 20), i < t && (r.push({ from: i, to: t }), o += t - i), { total: o, ranges: r };
}
function MI({ total: e, ranges: t }, n) {
  if (n <= 0)
    return t[0].from;
  if (n >= 1)
    return t[t.length - 1].to;
  let r = Math.floor(e * n);
  for (let i = 0; ; i++) {
    let { from: o, to: s } = t[i], l = s - o;
    if (r <= l)
      return o + r;
    r -= l;
  }
}
function DI(e, t) {
  let n = 0;
  for (let { from: r, to: i } of e.ranges) {
    if (t <= i) {
      n += t - r;
      break;
    }
    n += i - r;
  }
  return n / e.total;
}
function k3t(e, t) {
  for (let n of e)
    if (t(n))
      return n;
}
const Aue = {
  toDOM(e) {
    return e;
  },
  fromDOM(e) {
    return e;
  },
  scale: 1,
  eq(e) {
    return e == this;
  }
};
class LG {
  constructor(t, n, r) {
    let i = 0, o = 0, s = 0;
    this.viewports = r.map(({ from: l, to: c }) => {
      let a = n.lineAt(l, ci.ByPos, t, 0, 0).top, u = n.lineAt(c, ci.ByPos, t, 0, 0).bottom;
      return i += u - a, { from: l, to: c, top: a, bottom: u, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let l of this.viewports)
      l.domTop = s + (l.top - o) * this.scale, s = l.domBottom = l.domTop + (l.bottom - l.top), o = l.bottom;
  }
  toDOM(t) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.top)
        return i + (t - r) * this.scale;
      if (t <= o.bottom)
        return o.domTop + (t - o.top);
      r = o.bottom, i = o.domBottom;
    }
  }
  fromDOM(t) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.domTop)
        return r + (t - i) / this.scale;
      if (t <= o.domBottom)
        return o.top + (t - o.domTop);
      r = o.bottom, i = o.domBottom;
    }
  }
  eq(t) {
    return t instanceof LG ? this.scale == t.scale && this.viewports.length == t.viewports.length && this.viewports.every((n, r) => n.from == t.viewports[r].from && n.to == t.viewports[r].to) : !1;
  }
}
function b1(e, t) {
  if (t.scale == 1)
    return e;
  let n = t.toDOM(e.top), r = t.toDOM(e.bottom);
  return new nf(e.from, e.length, n, r - n, Array.isArray(e._content) ? e._content.map((i) => b1(i, t)) : e._content);
}
const _I = /* @__PURE__ */ Ht.define({ combine: (e) => e.join(" ") }), s8 = /* @__PURE__ */ Ht.define({ combine: (e) => e.indexOf(!0) > -1 }), a8 = /* @__PURE__ */ cg.newName(), bLe = /* @__PURE__ */ cg.newName(), OLe = /* @__PURE__ */ cg.newName(), ALe = { "&light": "." + bLe, "&dark": "." + OLe };
function l8(e, t, n) {
  return new cg(t, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return e;
        if (!n || !n[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return n[i];
      }) : e + " " + r;
    }
  });
}
const C3t = /* @__PURE__ */ l8("." + a8, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-dialog": {
    padding: "2px 19px 4px 6px",
    position: "relative",
    "& label": { fontSize: "80%" }
  },
  ".cm-dialog-close": {
    position: "absolute",
    top: "3px",
    right: "4px",
    backgroundColor: "inherit",
    border: "none",
    font: "inherit",
    fontSize: "14px",
    padding: "0"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top",
    userSelect: "none"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, ALe), N3t = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, zU = Qt.ie && Qt.ie_version <= 11;
class P3t {
  constructor(t) {
    this.view = t, this.active = !1, this.editContext = null, this.selectionRange = new djt(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (Qt.ie && Qt.ie_version <= 11 || Qt.ios && t.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && t.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(Qt.chrome && Qt.chrome_version < 126) && (this.editContext = new R3t(t), t.state.facet(zp) && (t.contentDOM.editContext = this.editContext.editContext)), zU && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(t.scrollDOM)), this.addWindowListeners(this.win = t.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(t) {
    this.view.inputState.runHandlers("scroll", t), this.intersecting && this.view.measure();
  }
  onScroll(t) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(t);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(t) {
    (t.type == "change" || !t.type) && !t.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(t) {
    if (this.gapIntersection && (t.length != this.gaps.length || this.gaps.some((n, r) => n != t[r]))) {
      this.gapIntersection.disconnect();
      for (let n of t)
        this.gapIntersection.observe(n);
      this.gaps = t;
    }
  }
  onSelectionChange(t) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(zp) ? r.root.activeElement != this.dom : !fM(this.dom, i))
      return;
    let o = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (o && o.ignoreEvent(t)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (Qt.ie && Qt.ie_version <= 11 || Qt.android && Qt.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && zE(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: t } = this, n = pk(t.root);
    if (!n)
      return !1;
    let r = Qt.safari && t.root.nodeType == 11 && t.root.activeElement == this.dom && I3t(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let i = fM(this.dom, r);
    return i && !this.selectionChanged && t.inputState.lastFocusTime > Date.now() - 200 && t.inputState.lastTouchTime < Date.now() - 300 && pjt(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, t.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(t, n) {
    this.selectionRange.set(t.node, t.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let t = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && t < this.scrollTargets.length && this.scrollTargets[t] == r ? t++ : n || (n = this.scrollTargets.slice(0, t)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (t < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, t)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(t) {
    if (!this.active)
      return t();
    try {
      return this.stop(), t();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, N3t), zU && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), zU && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(t, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let o = this.delayedAndroidKey;
        o && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = o.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && o.force && nA(this.dom, o.key, o.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || t == "Enter") && (this.delayedAndroidKey = {
      key: t,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let t of this.observer.takeRecords())
      this.queue.push(t);
    return this.queue;
  }
  processRecords() {
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let o of t) {
      let s = this.readMutation(o);
      s && (s.typeOver && (i = !0), n == -1 ? { from: n, to: r } = s : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
    }
    return { from: n, to: r, typeOver: i };
  }
  readChange() {
    let { from: t, to: n, typeOver: r } = this.processRecords(), i = this.selectionChanged && fM(this.dom, this.selectionRange);
    if (t < 0 && !i)
      return null;
    t > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let o = new Qjt(this.view, t, n, r);
    return this.view.docView.domChanged = { newSel: o.newSel ? o.newSel.main : null }, o;
  }
  // Apply pending changes, if any
  flush(t = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    t && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = cLe(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !n.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), i;
  }
  readMutation(t) {
    let n = this.view.docView.nearest(t.target);
    if (!n || n.ignoreMutation(t))
      return null;
    if (n.markDirty(t.type == "attributes"), t.type == "attributes" && (n.flags |= 4), t.type == "childList") {
      let r = wue(n, t.previousSibling || t.target.previousSibling, -1), i = wue(n, t.nextSibling || t.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: i ? n.posBefore(i) : n.posAtEnd,
        typeOver: !1
      };
    } else return t.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: t.target.nodeValue == t.oldValue } : null;
  }
  setWindow(t) {
    t != this.win && (this.removeWindowListeners(this.win), this.win = t, this.addWindowListeners(this.win));
  }
  addWindowListeners(t) {
    t.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : t.addEventListener("beforeprint", this.onPrint), t.addEventListener("scroll", this.onScroll), t.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(t) {
    t.removeEventListener("scroll", this.onScroll), t.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : t.removeEventListener("beforeprint", this.onPrint), t.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(t) {
    this.editContext && (this.editContext.update(t), t.startState.facet(zp) != t.state.facet(zp) && (t.view.contentDOM.editContext = t.state.facet(zp) ? this.editContext.editContext : null));
  }
  destroy() {
    var t, n, r;
    this.stop(), (t = this.intersection) === null || t === void 0 || t.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function wue(e, t, n) {
  for (; t; ) {
    let r = Hr.get(t);
    if (r && r.parent == e)
      return r;
    let i = t.parentNode;
    t = i != e.dom ? i : n > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
function xue(e, t) {
  let n = t.startContainer, r = t.startOffset, i = t.endContainer, o = t.endOffset, s = e.docView.domAtPos(e.state.selection.main.anchor);
  return zE(s.node, s.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function I3t(e, t) {
  if (t.getComposedRanges) {
    let i = t.getComposedRanges(e.root)[0];
    if (i)
      return xue(e, i);
  }
  let n = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return e.contentDOM.addEventListener("beforeinput", r, !0), e.dom.ownerDocument.execCommand("indent"), e.contentDOM.removeEventListener("beforeinput", r, !0), n ? xue(e, n) : null;
}
class R3t {
  constructor(t) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(t.state);
    let n = this.editContext = new window.EditContext({
      text: t.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, t.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(t.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let i = t.state.selection.main, { anchor: o, head: s } = i, l = this.toEditorPos(r.updateRangeStart), c = this.toEditorPos(r.updateRangeEnd);
      t.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: r.updateRangeStart, editorBase: l, drifted: !1 });
      let a = { from: l, to: c, insert: Sr.of(r.text.split(`
`)) };
      if (a.from == this.from && o < this.from ? a.from = o : a.to == this.to && o > this.to && (a.to = o), a.from == a.to && !a.insert.length) {
        let u = rt.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd));
        u.main.eq(i) || t.dispatch({ selection: u, userEvent: "select" });
        return;
      }
      if ((Qt.mac || Qt.android) && a.from == s - 1 && /^\. ?$/.test(r.text) && t.contentDOM.getAttribute("autocorrect") == "off" && (a = { from: l, to: c, insert: Sr.of([r.text.replace(".", " ")]) }), this.pendingContextChange = a, !t.state.readOnly) {
        let u = this.to - this.from + (a.to - a.from + a.insert.length);
        DG(t, a, rt.single(this.toEditorPos(r.selectionStart, u), this.toEditorPos(r.selectionEnd, u)));
      }
      this.pendingContextChange && (this.revertPending(t.state), this.setSelection(t.state));
    }, this.handlers.characterboundsupdate = (r) => {
      let i = [], o = null;
      for (let s = this.toEditorPos(r.rangeStart), l = this.toEditorPos(r.rangeEnd); s < l; s++) {
        let c = t.coordsForChar(s);
        o = c && new DOMRect(c.left, c.top, c.right - c.left, c.bottom - c.top) || o || new DOMRect(), i.push(o);
      }
      n.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = (r) => {
      let i = [];
      for (let o of r.getTextFormats()) {
        let s = o.underlineStyle, l = o.underlineThickness;
        if (s != "None" && l != "None") {
          let c = this.toEditorPos(o.rangeStart), a = this.toEditorPos(o.rangeEnd);
          if (c < a) {
            let u = `text-decoration: underline ${s == "Dashed" ? "dashed " : s == "Squiggle" ? "wavy " : ""}${l == "Thin" ? 1 : 2}px`;
            i.push(ln.mark({ attributes: { style: u } }).range(c, a));
          }
        }
      }
      t.dispatch({ effects: nLe.of(ln.set(i)) });
    }, this.handlers.compositionstart = () => {
      t.inputState.composing < 0 && (t.inputState.composing = 0, t.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (t.inputState.composing = -1, t.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: r } = this.composing;
        this.composing = null, r && this.reset(t.state);
      }
    };
    for (let r in this.handlers)
      n.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = pk(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(t) {
    let n = 0, r = !1, i = this.pendingContextChange;
    return t.changes.iterChanges((o, s, l, c, a) => {
      if (r)
        return;
      let u = a.length - (s - o);
      if (i && s >= i.to)
        if (i.from == o && i.to == s && i.insert.eq(a)) {
          i = this.pendingContextChange = null, n += u, this.to += u;
          return;
        } else
          i = null, this.revertPending(t.state);
      if (o += n, s += n, s <= this.from)
        this.from += u, this.to += u;
      else if (o < this.to) {
        if (o < this.from || s > this.to || this.to - this.from + a.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(o), this.toContextPos(s), a.toString()), this.to += u;
      }
      n += u;
    }), i && !r && this.revertPending(t.state), !r;
  }
  update(t) {
    let n = this.pendingContextChange, r = t.startState.selection.main;
    this.composing && (this.composing.drifted || !t.changes.touchesRange(r.from, r.to) && t.transactions.some((i) => !i.isUserEvent("input.type") && i.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = t.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(t) || !this.rangeIsValid(t.state) ? (this.pendingContextChange = null, this.reset(t.state)) : (t.docChanged || t.selectionSet || n) && this.setSelection(t.state), (t.geometryChanged || t.docChanged || t.selectionSet) && t.view.requestMeasure(this.measureReq);
  }
  resetRange(t) {
    let { head: n } = t.selection.main;
    this.from = Math.max(
      0,
      n - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      t.doc.length,
      n + 1e4
      /* CxVp.Margin */
    );
  }
  reset(t) {
    this.resetRange(t), this.editContext.updateText(0, this.editContext.text.length, t.doc.sliceString(this.from, this.to)), this.setSelection(t);
  }
  revertPending(t) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), t.doc.sliceString(n.from, n.to));
  }
  setSelection(t) {
    let { main: n } = t.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), i = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(t) {
    let { head: n } = t.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < t.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(t, n = this.to - this.from) {
    t = Math.min(t, n);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (t - r.contextBase) : t + this.from;
  }
  toContextPos(t) {
    let n = this.composing;
    return n && n.drifted ? n.contextBase + (t - n.editorBase) : t - this.from;
  }
  destroy() {
    for (let t in this.handlers)
      this.editContext.removeEventListener(t, this.handlers[t]);
  }
}
class kt {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return !!this.inputState && this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return !!this.inputState && this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(t = {}) {
    var n;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), t.parent && t.parent.appendChild(this.dom);
    let { dispatch: r } = t;
    this.dispatchTransactions = t.dispatchTransactions || r && ((i) => i.forEach((o) => r(o, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = t.root || fjt(t.parent) || document, this.viewState = new Oue(t.state || $n.create(t)), t.scrollTo && t.scrollTo.is(NI) && (this.viewState.scrollTarget = t.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(EO).map((i) => new MU(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new P3t(this), this.inputState = new Jjt(this), this.inputState.ensureHandlers(this.plugins), this.docView = new tue(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((n = document.fonts) === null || n === void 0) && n.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...t) {
    let n = t.length == 1 && t[0] instanceof Pa ? t : t.length == 1 && Array.isArray(t[0]) ? t[0] : [this.state.update(...t)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, i, o = this.state;
    for (let d of t) {
      if (d.startState != o)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      o = d.state;
    }
    if (this.destroyed) {
      this.viewState.state = o;
      return;
    }
    let s = this.hasFocus, l = 0, c = null;
    t.some((d) => d.annotation(mLe)) ? (this.inputState.notifiedFocused = s, l = 1) : s != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = s, c = gLe(o, s), c || (l = 1));
    let a = this.observer.delayedAndroidKey, u = null;
    if (a ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(o.doc) || !this.state.selection.eq(o.selection)) && (u = null)) : this.observer.clear(), o.facet($n.phrases) != this.state.facet($n.phrases))
      return this.setState(o);
    i = E_.create(this, o, t), i.flags |= l;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let d of t) {
        if (f && (f = f.map(d.changes)), d.scrollIntoView) {
          let { main: p } = d.state.selection;
          f = new rA(p.empty ? p : rt.cursor(p.head, p.head > p.anchor ? -1 : 1));
        }
        for (let p of d.effects)
          p.is(NI) && (f = p.value.clip(this.state));
      }
      this.viewState.update(i, f), this.bidiCache = k_.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(y1) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(n, t.some((d) => d.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(_I) != i.state.facet(_I) && (this.viewState.mustMeasureContent = !0), (n || r || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty)
      for (let d of this.state.facet(n8))
        try {
          d(i);
        } catch (p) {
          ul(this.state, p, "update listener");
        }
    (c || u) && Promise.resolve().then(() => {
      c && this.state == c.startState && this.dispatch(c), u && !cLe(this, u) && a.force && nA(this.contentDOM, a.key, a.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = t;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new Oue(t), this.plugins = t.facet(EO).map((r) => new MU(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new tue(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(t) {
    let n = t.startState.facet(EO), r = t.state.facet(EO);
    if (n != r) {
      let i = [];
      for (let o of r) {
        let s = n.indexOf(o);
        if (s < 0)
          i.push(new MU(o));
        else {
          let l = this.plugins[s];
          l.mustUpdate = t, i.push(l);
        }
      }
      for (let o of this.plugins)
        o.mustUpdate != t && o.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = t;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let t of this.plugins) {
      let n = t.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          ul(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(t = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, t && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: o, scrollAnchorHeight: s } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let l = 0; ; l++) {
        if (s < 0)
          if (N_e(r))
            o = -1, s = this.viewState.heightMap.height;
          else {
            let p = this.viewState.scrollAnchorAt(i);
            o = p.from, s = p.top;
          }
        this.updateState = 1;
        let c = this.viewState.measure(this);
        if (!c && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (l > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let a = [];
        c & 4 || ([this.measureRequests, a] = [a, this.measureRequests]);
        let u = a.map((p) => {
          try {
            return p.read(this);
          } catch (h) {
            return ul(this.state, h), Sue;
          }
        }), f = E_.create(this, this.state, []), d = !1;
        f.flags |= c, n ? n.flags |= c : n = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), d = this.docView.update(f), d && this.docViewUpdate());
        for (let p = 0; p < a.length; p++)
          if (u[p] != Sue)
            try {
              let h = a[p];
              h.write && h.write(u[p], this);
            } catch (h) {
              ul(this.state, h);
            }
        if (d && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, s = -1;
              continue;
            } else {
              let h = (o < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(o).top) - s;
              if (h > 1 || h < -1) {
                i = i + h, r.scrollTop = i / this.scaleY, s = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let l of this.state.facet(n8))
        l(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return a8 + " " + (this.state.facet(s8) ? OLe : bLe) + " " + this.state.facet(_I);
  }
  updateAttrs() {
    let t = Eue(this, rLe, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(zp) ? "true" : "false",
      class: "cm-content",
      style: `${Qt.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), Eue(this, IG, n);
    let r = this.observer.ignore(() => {
      let i = G9(this.contentDOM, this.contentAttrs, n), o = G9(this.dom, this.editorAttrs, t);
      return i || o;
    });
    return this.editorAttrs = t, this.contentAttrs = n, r;
  }
  showAnnouncements(t) {
    let n = !0;
    for (let r of t)
      for (let i of r.effects)
        if (i.is(kt.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let o = this.announceDOM.appendChild(document.createElement("div"));
          o.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(y1);
    let t = this.state.facet(kt.cspNonce);
    cg.mount(this.root, this.styleModules.concat(C3t).reverse(), t ? { nonce: t } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(t) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), t) {
      if (this.measureRequests.indexOf(t) > -1)
        return;
      if (t.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === t.key) {
            this.measureRequests[n] = t;
            return;
          }
      }
      this.measureRequests.push(t);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(t) {
    let n = this.pluginMap.get(t);
    return (n === void 0 || n && n.plugin != t) && this.pluginMap.set(t, n = this.plugins.find((r) => r.plugin == t) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(t) {
    return this.readMeasured(), this.viewState.elementAtHeight(t);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(t) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(t) {
    return this.viewState.lineBlockAt(t);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(t, n, r) {
    return _U(this, t, sue(this, t, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(t, n) {
    return _U(this, t, sue(this, t, n, (r) => Xjt(this, t.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(t, n) {
    let r = this.bidiSpans(t), i = this.textDirectionAt(t.from), o = r[n ? r.length - 1 : 0];
    return rt.cursor(o.side(n, i) + t.from, o.forward(!n, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(t, n, r = !0) {
    return Bjt(this, t, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(t, n, r) {
    return _U(this, t, Wjt(this, t, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(t) {
    return this.docView.domAtPos(t);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(t, n = 0) {
    return this.docView.posFromDOM(t, n);
  }
  posAtCoords(t, n = !0) {
    return this.readMeasured(), lLe(this, t, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(t, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(t, n);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(t), o = this.bidiSpans(i), s = o[jm.find(o, t - i.from, -1, n)];
    return EN(r, s.dir == hi.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(t) {
    return this.readMeasured(), this.docView.coordsForChar(t);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(t) {
    return !this.state.facet(J_e) || t < this.viewport.from || t > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(t) {
    if (t.length > M3t)
      return W_e(t.length);
    let n = this.textDirectionAt(t.from), r;
    for (let o of this.bidiCache)
      if (o.from == t.from && o.dir == n && (o.fresh || X_e(o.isolates, r = eue(this, t))))
        return o.order;
    r || (r = eue(this, t));
    let i = kjt(t.text, n, r);
    return this.bidiCache.push(new k_(t.from, t.to, n, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var t;
    return (this.dom.ownerDocument.hasFocus() || Qt.safari && ((t = this.inputState) === null || t === void 0 ? void 0 : t.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      k_e(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(t) {
    this._root != t && (this._root = t, this.observer.setWindow((t.nodeType == 9 ? t : t.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let t of this.plugins)
      t.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(t, n = {}) {
    return NI.of(new rA(typeof t == "number" ? rt.cursor(t) : t, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: t, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(t);
    return NI.of(new rA(rt.cursor(r.from), "start", "start", r.top - t, n, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(t) {
    t == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof t == "boolean" ? this.inputState.tabFocusMode = t ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + t);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(t) {
    return Yi.define(() => ({}), { eventHandlers: t });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(t) {
    return Yi.define(() => ({}), { eventObservers: t });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(t, n) {
    let r = cg.newName(), i = [_I.of(r), y1.of(l8(`.${r}`, t))];
    return n && n.dark && i.push(s8.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(t) {
    return Dg.lowest(y1.of(l8("." + a8, t, ALe)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(t) {
    var n;
    let r = t.querySelector(".cm-content"), i = r && Hr.get(r) || Hr.get(t);
    return ((n = i == null ? void 0 : i.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
kt.styleModule = y1;
kt.inputHandler = G_e;
kt.clipboardInputFilter = NG;
kt.clipboardOutputFilter = PG;
kt.scrollHandler = tLe;
kt.focusChangeEffect = Y_e;
kt.perLineTextDirection = J_e;
kt.exceptionSink = K_e;
kt.updateListener = n8;
kt.editable = zp;
kt.mouseSelectionStyle = $_e;
kt.dragMovesSelection = Q_e;
kt.clickAddsSelectionRange = H_e;
kt.decorations = hk;
kt.outerDecorations = iLe;
kt.atomicRanges = RG;
kt.bidiIsolatedRanges = oLe;
kt.scrollMargins = sLe;
kt.darkTheme = s8;
kt.cspNonce = /* @__PURE__ */ Ht.define({ combine: (e) => e.length ? e[0] : "" });
kt.contentAttributes = IG;
kt.editorAttributes = rLe;
kt.lineWrapping = /* @__PURE__ */ kt.contentAttributes.of({ class: "cm-lineWrapping" });
kt.announce = /* @__PURE__ */ _n.define();
const M3t = 4096, Sue = {};
class k_ {
  constructor(t, n, r, i, o, s) {
    this.from = t, this.to = n, this.dir = r, this.isolates = i, this.fresh = o, this.order = s;
  }
  static update(t, n) {
    if (n.empty && !t.some((o) => o.fresh))
      return t;
    let r = [], i = t.length ? t[t.length - 1].dir : hi.LTR;
    for (let o = Math.max(0, t.length - 10); o < t.length; o++) {
      let s = t[o];
      s.dir == i && !n.touchesRange(s.from, s.to) && r.push(new k_(n.mapPos(s.from, 1), n.mapPos(s.to, -1), s.dir, s.isolates, !1, s.order));
    }
    return r;
  }
}
function Eue(e, t, n) {
  for (let r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
    let o = r[i], s = typeof o == "function" ? o(e) : o;
    s && K9(s, n);
  }
  return n;
}
const D3t = Qt.mac ? "mac" : Qt.windows ? "win" : Qt.linux ? "linux" : "key";
function _3t(e, t) {
  const n = e.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let i, o, s, l;
  for (let c = 0; c < n.length - 1; ++c) {
    const a = n[c];
    if (/^(cmd|meta|m)$/i.test(a))
      l = !0;
    else if (/^a(lt)?$/i.test(a))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      o = !0;
    else if (/^s(hift)?$/i.test(a))
      s = !0;
    else if (/^mod$/i.test(a))
      t == "mac" ? l = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + a);
  }
  return i && (r = "Alt-" + r), o && (r = "Ctrl-" + r), l && (r = "Meta-" + r), s && (r = "Shift-" + r), r;
}
function LI(e, t, n) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n !== !1 && t.shiftKey && (e = "Shift-" + e), e;
}
const L3t = /* @__PURE__ */ Dg.default(/* @__PURE__ */ kt.domEventHandlers({
  keydown(e, t) {
    return xLe(wLe(t.state), e, t, "editor");
  }
})), CN = /* @__PURE__ */ Ht.define({ enables: L3t }), Tue = /* @__PURE__ */ new WeakMap();
function wLe(e) {
  let t = e.facet(CN), n = Tue.get(t);
  return n || Tue.set(t, n = F3t(t.reduce((r, i) => r.concat(i), []))), n;
}
function z3t(e, t, n) {
  return xLe(wLe(e.state), t, e, n);
}
let dm = null;
const j3t = 4e3;
function F3t(e, t = D3t) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = (s, l) => {
    let c = r[s];
    if (c == null)
      r[s] = l;
    else if (c != l)
      throw new Error("Key binding " + s + " is used both as a regular binding and as a multi-stroke prefix");
  }, o = (s, l, c, a, u) => {
    var f, d;
    let p = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), h = l.split(/ (?!$)/).map((b) => _3t(b, t));
    for (let b = 1; b < h.length; b++) {
      let A = h.slice(0, b).join(" ");
      i(A, !0), p[A] || (p[A] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(w) => {
          let O = dm = { view: w, prefix: A, scope: s };
          return setTimeout(() => {
            dm == O && (dm = null);
          }, j3t), !0;
        }]
      });
    }
    let m = h.join(" ");
    i(m, !1);
    let v = p[m] || (p[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((d = (f = p._any) === null || f === void 0 ? void 0 : f.run) === null || d === void 0 ? void 0 : d.slice()) || []
    });
    c && v.run.push(c), a && (v.preventDefault = !0), u && (v.stopPropagation = !0);
  };
  for (let s of e) {
    let l = s.scope ? s.scope.split(" ") : ["editor"];
    if (s.any)
      for (let a of l) {
        let u = n[a] || (n[a] = /* @__PURE__ */ Object.create(null));
        u._any || (u._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: f } = s;
        for (let d in u)
          u[d].run.push((p) => f(p, c8));
      }
    let c = s[t] || s.key;
    if (c)
      for (let a of l)
        o(a, c, s.run, s.preventDefault, s.stopPropagation), s.shift && o(a, "Shift-" + c, s.shift, s.preventDefault, s.stopPropagation);
  }
  return n;
}
let c8 = null;
function xLe(e, t, n, r) {
  c8 = t;
  let i = UIe(t), o = el(i, 0), s = tf(o) == i.length && i != " ", l = "", c = !1, a = !1, u = !1;
  dm && dm.view == n && dm.scope == r && (l = dm.prefix + " ", dLe.indexOf(t.keyCode) < 0 && (a = !0, dm = null));
  let f = /* @__PURE__ */ new Set(), d = (v) => {
    if (v) {
      for (let b of v.run)
        if (!f.has(b) && (f.add(b), b(n)))
          return v.stopPropagation && (u = !0), !0;
      v.preventDefault && (v.stopPropagation && (u = !0), a = !0);
    }
    return !1;
  }, p = e[r], h, m;
  return p && (d(p[l + LI(i, t, !s)]) ? c = !0 : s && (t.altKey || t.metaKey || t.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(Qt.windows && t.ctrlKey && t.altKey) && (h = ph[t.keyCode]) && h != i ? (d(p[l + LI(h, t, !0)]) || t.shiftKey && (m = ik[t.keyCode]) != i && m != h && d(p[l + LI(m, t, !1)])) && (c = !0) : s && t.shiftKey && d(p[l + LI(i, t, !0)]) && (c = !0), !c && d(p._any) && (c = !0)), a && (c = !0), c && u && t.stopPropagation(), c8 = null, c;
}
class NN {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(t, n, r, i, o) {
    this.className = t, this.left = n, this.top = r, this.width = i, this.height = o;
  }
  draw() {
    let t = document.createElement("div");
    return t.className = this.className, this.adjust(t), t;
  }
  update(t, n) {
    return n.className != this.className ? !1 : (this.adjust(t), !0);
  }
  adjust(t) {
    t.style.left = this.left + "px", t.style.top = this.top + "px", this.width != null && (t.style.width = this.width + "px"), t.style.height = this.height + "px";
  }
  eq(t) {
    return this.left == t.left && this.top == t.top && this.width == t.width && this.height == t.height && this.className == t.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(t, n, r) {
    if (r.empty) {
      let i = t.coordsAtPos(r.head, r.assoc || 1);
      if (!i)
        return [];
      let o = SLe(t);
      return [new NN(n, i.left - o.left, i.top - o.top, null, i.bottom - i.top)];
    } else
      return U3t(t, n, r);
  }
}
function SLe(e) {
  let t = e.scrollDOM.getBoundingClientRect();
  return { left: (e.textDirection == hi.LTR ? t.left : t.right - e.scrollDOM.clientWidth * e.scaleX) - e.scrollDOM.scrollLeft * e.scaleX, top: t.top - e.scrollDOM.scrollTop * e.scaleY };
}
function kue(e, t, n, r) {
  let i = e.coordsAtPos(t, n * 2);
  if (!i)
    return r;
  let o = e.dom.getBoundingClientRect(), s = (i.top + i.bottom) / 2, l = e.posAtCoords({ x: o.left + 1, y: s }), c = e.posAtCoords({ x: o.right - 1, y: s });
  return l == null || c == null ? r : { from: Math.max(r.from, Math.min(l, c)), to: Math.min(r.to, Math.max(l, c)) };
}
function U3t(e, t, n) {
  if (n.to <= e.viewport.from || n.from >= e.viewport.to)
    return [];
  let r = Math.max(n.from, e.viewport.from), i = Math.min(n.to, e.viewport.to), o = e.textDirection == hi.LTR, s = e.contentDOM, l = s.getBoundingClientRect(), c = SLe(e), a = s.querySelector(".cm-line"), u = a && window.getComputedStyle(a), f = l.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), d = l.right - (u ? parseInt(u.paddingRight) : 0), p = i8(e, r, 1), h = i8(e, i, -1), m = p.type == Ia.Text ? p : null, v = h.type == Ia.Text ? h : null;
  if (m && (e.lineWrapping || p.widgetLineBreaks) && (m = kue(e, r, 1, m)), v && (e.lineWrapping || h.widgetLineBreaks) && (v = kue(e, i, -1, v)), m && v && m.from == v.from && m.to == v.to)
    return A(w(n.from, n.to, m));
  {
    let x = m ? w(n.from, null, m) : O(p, !1), S = v ? w(null, n.to, v) : O(h, !0), E = [];
    return (m || p).to < (v || h).from - (m && v ? 1 : 0) || p.widgetLineBreaks > 1 && x.bottom + e.defaultLineHeight / 2 < S.top ? E.push(b(f, x.bottom, d, S.top)) : x.bottom < S.top && e.elementAtHeight((x.bottom + S.top) / 2).type == Ia.Text && (x.bottom = S.top = (x.bottom + S.top) / 2), A(x).concat(E).concat(A(S));
  }
  function b(x, S, E, k) {
    return new NN(t, x - c.left, S - c.top, E - x, k - S);
  }
  function A({ top: x, bottom: S, horizontal: E }) {
    let k = [];
    for (let T = 0; T < E.length; T += 2)
      k.push(b(E[T], x, E[T + 1], S));
    return k;
  }
  function w(x, S, E) {
    let k = 1e9, T = -1e9, R = [];
    function j(_, U, z, C, I) {
      let M = e.coordsAtPos(_, _ == E.to ? -2 : 2), D = e.coordsAtPos(z, z == E.from ? 2 : -2);
      !M || !D || (k = Math.min(M.top, D.top, k), T = Math.max(M.bottom, D.bottom, T), I == hi.LTR ? R.push(o && U ? f : M.left, o && C ? d : D.right) : R.push(!o && C ? f : D.left, !o && U ? d : M.right));
    }
    let F = x ?? E.from, L = S ?? E.to;
    for (let _ of e.visibleRanges)
      if (_.to > F && _.from < L)
        for (let U = Math.max(_.from, F), z = Math.min(_.to, L); ; ) {
          let C = e.state.doc.lineAt(U);
          for (let I of e.bidiSpans(C)) {
            let M = I.from + C.from, D = I.to + C.from;
            if (M >= z)
              break;
            D > U && j(Math.max(M, U), x == null && M <= F, Math.min(D, z), S == null && D >= L, I.dir);
          }
          if (U = C.to + 1, U >= z)
            break;
        }
    return R.length == 0 && j(F, x == null, L, S == null, e.textDirection), { top: k, bottom: T, horizontal: R };
  }
  function O(x, S) {
    let E = l.top + (S ? x.top : x.bottom);
    return { top: E, bottom: E, horizontal: [] };
  }
}
function V3t(e, t) {
  return e.constructor == t.constructor && e.eq(t);
}
class q3t {
  constructor(t, n) {
    this.view = t, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = t.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(t.state), t.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, t);
  }
  update(t) {
    t.startState.facet(gM) != t.state.facet(gM) && this.setOrder(t.state), (this.layer.update(t, this.dom) || t.geometryChanged) && (this.scale(), t.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(t) {
    this.layer.updateOnDocViewUpdate !== !1 && t.requestMeasure(this.measureReq);
  }
  setOrder(t) {
    let n = 0, r = t.facet(gM);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: t, scaleY: n } = this.view;
    (t != this.scaleX || n != this.scaleY) && (this.scaleX = t, this.scaleY = n, this.dom.style.transform = `scale(${1 / t}, ${1 / n})`);
  }
  draw(t) {
    if (t.length != this.drawn.length || t.some((n, r) => !V3t(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let i of t)
        i.update && n && i.constructor && this.drawn[r].constructor && i.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(i.draw(), n);
      for (; n; ) {
        let i = n.nextSibling;
        n.remove(), n = i;
      }
      this.drawn = t;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const gM = /* @__PURE__ */ Ht.define();
function ELe(e) {
  return [
    Yi.define((t) => new q3t(t, e)),
    gM.of(e)
  ];
}
const mk = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (t, n) => Math.min(t, n),
      drawRangeCursor: (t, n) => t || n
    });
  }
});
function B3t(e = {}) {
  return [
    mk.of(e),
    X3t,
    W3t,
    Z3t,
    eLe.of(!0)
  ];
}
function TLe(e) {
  return e.startState.facet(mk) != e.state.facet(mk);
}
const X3t = /* @__PURE__ */ ELe({
  above: !0,
  markers(e) {
    let { state: t } = e, n = t.facet(mk), r = [];
    for (let i of t.selection.ranges) {
      let o = i == t.selection.main;
      if (i.empty || n.drawRangeCursor) {
        let s = o ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", l = i.empty ? i : rt.cursor(i.head, i.head > i.anchor ? -1 : 1);
        for (let c of NN.forRange(e, s, l))
          r.push(c);
      }
    }
    return r;
  },
  update(e, t) {
    e.transactions.some((r) => r.selection) && (t.style.animationName = t.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = TLe(e);
    return n && Cue(e.state, t), e.docChanged || e.selectionSet || n;
  },
  mount(e, t) {
    Cue(t.state, e);
  },
  class: "cm-cursorLayer"
});
function Cue(e, t) {
  t.style.animationDuration = e.facet(mk).cursorBlinkRate + "ms";
}
const W3t = /* @__PURE__ */ ELe({
  above: !1,
  markers(e) {
    return e.state.selection.ranges.map((t) => t.empty ? [] : NN.forRange(e, "cm-selectionBackground", t)).reduce((t, n) => t.concat(n));
  },
  update(e, t) {
    return e.docChanged || e.selectionSet || e.viewportChanged || TLe(e);
  },
  class: "cm-selectionLayer"
}), Z3t = /* @__PURE__ */ Dg.highest(/* @__PURE__ */ kt.theme({
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" },
    caretColor: "transparent !important"
  },
  ".cm-content": {
    caretColor: "transparent !important",
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
})), kLe = /* @__PURE__ */ _n.define({
  map(e, t) {
    return e == null ? null : t.mapPos(e);
  }
}), O1 = /* @__PURE__ */ cs.define({
  create() {
    return null;
  },
  update(e, t) {
    return e != null && (e = t.changes.mapPos(e)), t.effects.reduce((n, r) => r.is(kLe) ? r.value : n, e);
  }
}), H3t = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.view = e, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(e) {
    var t;
    let n = e.state.field(O1);
    n == null ? this.cursor != null && ((t = this.cursor) === null || t === void 0 || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (e.startState.field(O1) != n || e.docChanged || e.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: e } = this, t = e.state.field(O1), n = t != null && e.coordsAtPos(t);
    if (!n)
      return null;
    let r = e.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + e.scrollDOM.scrollLeft * e.scaleX,
      top: n.top - r.top + e.scrollDOM.scrollTop * e.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(e) {
    if (this.cursor) {
      let { scaleX: t, scaleY: n } = this.view;
      e ? (this.cursor.style.left = e.left / t + "px", this.cursor.style.top = e.top / n + "px", this.cursor.style.height = e.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(e) {
    this.view.state.field(O1) != e && this.view.dispatch({ effects: kLe.of(e) });
  }
}, {
  eventObservers: {
    dragover(e) {
      this.setDropPos(this.view.posAtCoords({ x: e.clientX, y: e.clientY }));
    },
    dragleave(e) {
      (e.target == this.view.contentDOM || !this.view.contentDOM.contains(e.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function Q3t() {
  return [O1, H3t];
}
function Nue(e, t, n, r, i) {
  t.lastIndex = 0;
  for (let o = e.iterRange(n, r), s = n, l; !o.next().done; s += o.value.length)
    if (!o.lineBreak)
      for (; l = t.exec(o.value); )
        i(s + l.index, l);
}
function $3t(e, t) {
  let n = e.visibleRanges;
  if (n.length == 1 && n[0].from == e.viewport.from && n[0].to == e.viewport.to)
    return n;
  let r = [];
  for (let { from: i, to: o } of n)
    i = Math.max(e.state.doc.lineAt(i).from, i - t), o = Math.min(e.state.doc.lineAt(o).to, o + t), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = o : r.push({ from: i, to: o });
  return r;
}
class K3t {
  /**
  Create a decorator.
  */
  constructor(t) {
    const { regexp: n, decoration: r, decorate: i, boundary: o, maxLength: s = 1e3 } = t;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, i)
      this.addMatch = (l, c, a, u) => i(u, a, a + l[0].length, l, c);
    else if (typeof r == "function")
      this.addMatch = (l, c, a, u) => {
        let f = r(l, c, a);
        f && u(a, a + l[0].length, f);
      };
    else if (r)
      this.addMatch = (l, c, a, u) => u(a, a + l[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = o, this.maxLength = s;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(t) {
    let n = new hh(), r = n.add.bind(n);
    for (let { from: i, to: o } of $3t(t, this.maxLength))
      Nue(t.state.doc, this.regexp, i, o, (s, l) => this.addMatch(l, t, s, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(t, n) {
    let r = 1e9, i = -1;
    return t.docChanged && t.changes.iterChanges((o, s, l, c) => {
      c >= t.view.viewport.from && l <= t.view.viewport.to && (r = Math.min(l, r), i = Math.max(c, i));
    }), t.viewportMoved || i - r > 1e3 ? this.createDeco(t.view) : i > -1 ? this.updateRange(t.view, n.map(t.changes), r, i) : n;
  }
  updateRange(t, n, r, i) {
    for (let o of t.visibleRanges) {
      let s = Math.max(o.from, r), l = Math.min(o.to, i);
      if (l >= s) {
        let c = t.state.doc.lineAt(s), a = c.to < l ? t.state.doc.lineAt(l) : c, u = Math.max(o.from, c.from), f = Math.min(o.to, a.to);
        if (this.boundary) {
          for (; s > c.from; s--)
            if (this.boundary.test(c.text[s - 1 - c.from])) {
              u = s;
              break;
            }
          for (; l < a.to; l++)
            if (this.boundary.test(a.text[l - a.from])) {
              f = l;
              break;
            }
        }
        let d = [], p, h = (m, v, b) => d.push(b.range(m, v));
        if (c == a)
          for (this.regexp.lastIndex = u - c.from; (p = this.regexp.exec(c.text)) && p.index < f - c.from; )
            this.addMatch(p, t, p.index + c.from, h);
        else
          Nue(t.state.doc, this.regexp, u, f, (m, v) => this.addMatch(v, t, m, h));
        n = n.update({ filterFrom: u, filterTo: f, filter: (m, v) => m < u || v > f, add: d });
      }
    }
    return n;
  }
}
const u8 = /x/.unicode != null ? "gu" : "g", G3t = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, u8), Y3t = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let jU = null;
function J3t() {
  var e;
  if (jU == null && typeof document < "u" && document.body) {
    let t = document.body.style;
    jU = ((e = t.tabSize) !== null && e !== void 0 ? e : t.MozTabSize) != null;
  }
  return jU || !1;
}
const yM = /* @__PURE__ */ Ht.define({
  combine(e) {
    let t = Vf(e, {
      render: null,
      specialChars: G3t,
      addSpecialChars: null
    });
    return (t.replaceTabs = !J3t()) && (t.specialChars = new RegExp("	|" + t.specialChars.source, u8)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, u8)), t;
  }
});
function eFt(e = {}) {
  return [yM.of(e), tFt()];
}
let Pue = null;
function tFt() {
  return Pue || (Pue = Yi.fromClass(class {
    constructor(e) {
      this.view = e, this.decorations = ln.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(e.state.facet(yM)), this.decorations = this.decorator.createDeco(e);
    }
    makeDecorator(e) {
      return new K3t({
        regexp: e.specialChars,
        decoration: (t, n, r) => {
          let { doc: i } = n.state, o = el(t[0], 0);
          if (o == 9) {
            let s = i.lineAt(r), l = n.state.tabSize, c = Cx(s.text, l, r - s.from);
            return ln.replace({
              widget: new oFt((l - c % l) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[o] || (this.decorationCache[o] = ln.replace({ widget: new iFt(e, o) }));
        },
        boundary: e.replaceTabs ? void 0 : /[^]/
      });
    }
    update(e) {
      let t = e.state.facet(yM);
      e.startState.facet(yM) != t ? (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(e.view)) : this.decorations = this.decorator.updateDeco(e, this.decorations);
    }
  }, {
    decorations: (e) => e.decorations
  }));
}
const nFt = "•";
function rFt(e) {
  return e >= 32 ? nFt : e == 10 ? "␤" : String.fromCharCode(9216 + e);
}
class iFt extends qf {
  constructor(t, n) {
    super(), this.options = t, this.code = n;
  }
  eq(t) {
    return t.code == this.code;
  }
  toDOM(t) {
    let n = rFt(this.code), r = t.state.phrase("Control character") + " " + (Y3t[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, n);
    if (i)
      return i;
    let o = document.createElement("span");
    return o.textContent = n, o.title = r, o.setAttribute("aria-label", r), o.className = "cm-specialChar", o;
  }
  ignoreEvent() {
    return !1;
  }
}
class oFt extends qf {
  constructor(t) {
    super(), this.width = t;
  }
  eq(t) {
    return t.width == this.width;
  }
  toDOM() {
    let t = document.createElement("span");
    return t.textContent = "	", t.className = "cm-tab", t.style.width = this.width + "px", t;
  }
  ignoreEvent() {
    return !1;
  }
}
function sFt() {
  return lFt;
}
const aFt = /* @__PURE__ */ ln.line({ class: "cm-activeLine" }), lFt = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.decorations = this.getDeco(e);
  }
  update(e) {
    (e.docChanged || e.selectionSet) && (this.decorations = this.getDeco(e.view));
  }
  getDeco(e) {
    let t = -1, n = [];
    for (let r of e.state.selection.ranges) {
      let i = e.lineBlockAt(r.head);
      i.from > t && (n.push(aFt.range(i.from)), t = i.from);
    }
    return ln.set(n);
  }
}, {
  decorations: (e) => e.decorations
});
let cFt = class extends qf {
  constructor(t) {
    super(), this.content = t;
  }
  toDOM(t) {
    let n = document.createElement("span");
    return n.className = "cm-placeholder", n.style.pointerEvents = "none", n.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(t) : this.content.cloneNode(!0)), n.setAttribute("aria-hidden", "true"), n;
  }
  coordsAt(t) {
    let n = t.firstChild ? ww(t.firstChild) : [];
    if (!n.length)
      return null;
    let r = window.getComputedStyle(t.parentNode), i = EN(n[0], r.direction != "rtl"), o = parseInt(r.lineHeight);
    return i.bottom - i.top > o * 1.5 ? { left: i.left, right: i.right, top: i.top, bottom: i.top + o } : i;
  }
  ignoreEvent() {
    return !1;
  }
};
function uFt(e) {
  let t = Yi.fromClass(class {
    constructor(n) {
      this.view = n, this.placeholder = e ? ln.set([ln.widget({ widget: new cFt(e), side: 1 }).range(0)]) : ln.none;
    }
    get decorations() {
      return this.view.state.doc.length ? ln.none : this.placeholder;
    }
  }, { decorations: (n) => n.decorations });
  return typeof e == "string" ? [
    t,
    kt.contentAttributes.of({ "aria-placeholder": e })
  ] : t;
}
const d8 = 2e3;
function dFt(e, t, n) {
  let r = Math.min(t.line, n.line), i = Math.max(t.line, n.line), o = [];
  if (t.off > d8 || n.off > d8 || t.col < 0 || n.col < 0) {
    let s = Math.min(t.off, n.off), l = Math.max(t.off, n.off);
    for (let c = r; c <= i; c++) {
      let a = e.doc.line(c);
      a.length <= l && o.push(rt.range(a.from + s, a.to + l));
    }
  } else {
    let s = Math.min(t.col, n.col), l = Math.max(t.col, n.col);
    for (let c = r; c <= i; c++) {
      let a = e.doc.line(c), u = B9(a.text, s, e.tabSize, !0);
      if (u < 0)
        o.push(rt.cursor(a.to));
      else {
        let f = B9(a.text, l, e.tabSize);
        o.push(rt.range(a.from + u, a.from + f));
      }
    }
  }
  return o;
}
function fFt(e, t) {
  let n = e.coordsAtPos(e.viewport.from);
  return n ? Math.round(Math.abs((n.left - t) / e.defaultCharacterWidth)) : -1;
}
function Iue(e, t) {
  let n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1), r = e.state.doc.lineAt(n), i = n - r.from, o = i > d8 ? -1 : i == r.length ? fFt(e, t.clientX) : Cx(r.text, e.state.tabSize, n - r.from);
  return { line: r.number, col: o, off: i };
}
function pFt(e, t) {
  let n = Iue(e, t), r = e.state.selection;
  return n ? {
    update(i) {
      if (i.docChanged) {
        let o = i.changes.mapPos(i.startState.doc.line(n.line).from), s = i.state.doc.lineAt(o);
        n = { line: s.number, col: n.col, off: Math.min(n.off, s.length) }, r = r.map(i.changes);
      }
    },
    get(i, o, s) {
      let l = Iue(e, i);
      if (!l)
        return r;
      let c = dFt(e.state, n, l);
      return c.length ? s ? rt.create(c.concat(r.ranges)) : rt.create(c) : r;
    }
  } : null;
}
function hFt(e) {
  let t = (n) => n.altKey && n.button == 0;
  return kt.mouseSelectionStyle.of((n, r) => t(r) ? pFt(n, r) : null);
}
const mFt = {
  Alt: [18, (e) => !!e.altKey],
  Control: [17, (e) => !!e.ctrlKey],
  Shift: [16, (e) => !!e.shiftKey],
  Meta: [91, (e) => !!e.metaKey]
}, gFt = { style: "cursor: crosshair" };
function yFt(e = {}) {
  let [t, n] = mFt[e.key || "Alt"], r = Yi.fromClass(class {
    constructor(i) {
      this.view = i, this.isDown = !1;
    }
    set(i) {
      this.isDown != i && (this.isDown = i, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(i) {
        this.set(i.keyCode == t || n(i));
      },
      keyup(i) {
        (i.keyCode == t || !n(i)) && this.set(!1);
      },
      mousemove(i) {
        this.set(n(i));
      }
    }
  });
  return [
    r,
    kt.contentAttributes.of((i) => {
      var o;
      return !((o = i.plugin(r)) === null || o === void 0) && o.isDown ? gFt : null;
    })
  ];
}
const bS = "-10000px";
class CLe {
  constructor(t, n, r, i) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = i, this.input = t.state.facet(n), this.tooltips = this.input.filter((s) => s);
    let o = null;
    this.tooltipViews = this.tooltips.map((s) => o = r(s, o));
  }
  update(t, n) {
    var r;
    let i = t.state.facet(this.facet), o = i.filter((c) => c);
    if (i === this.input) {
      for (let c of this.tooltipViews)
        c.update && c.update(t);
      return !1;
    }
    let s = [], l = n ? [] : null;
    for (let c = 0; c < o.length; c++) {
      let a = o[c], u = -1;
      if (a) {
        for (let f = 0; f < this.tooltips.length; f++) {
          let d = this.tooltips[f];
          d && d.create == a.create && (u = f);
        }
        if (u < 0)
          s[c] = this.createTooltipView(a, c ? s[c - 1] : null), l && (l[c] = !!a.above);
        else {
          let f = s[c] = this.tooltipViews[u];
          l && (l[c] = n[u]), f.update && f.update(t);
        }
      }
    }
    for (let c of this.tooltipViews)
      s.indexOf(c) < 0 && (this.removeTooltipView(c), (r = c.destroy) === null || r === void 0 || r.call(c));
    return n && (l.forEach((c, a) => n[a] = c), n.length = l.length), this.input = i, this.tooltips = o, this.tooltipViews = s, !0;
  }
}
function vFt(e) {
  let t = e.dom.ownerDocument.documentElement;
  return { top: 0, left: 0, bottom: t.clientHeight, right: t.clientWidth };
}
const FU = /* @__PURE__ */ Ht.define({
  combine: (e) => {
    var t, n, r;
    return {
      position: Qt.ios ? "absolute" : ((t = e.find((i) => i.position)) === null || t === void 0 ? void 0 : t.position) || "fixed",
      parent: ((n = e.find((i) => i.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = e.find((i) => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || vFt
    };
  }
}), Rue = /* @__PURE__ */ new WeakMap(), zG = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.view = e, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let t = e.state.facet(FU);
    this.position = t.position, this.parent = t.parent, this.classes = e.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new CLe(e, jG, (n, r) => this.createTooltip(n, r), (n) => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map((n) => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), e.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let e of this.manager.tooltipViews)
        this.intersectionObserver.observe(e.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(e) {
    e.transactions.length && (this.lastTransaction = Date.now());
    let t = this.manager.update(e, this.above);
    t && this.observeIntersection();
    let n = t || e.geometryChanged, r = e.state.facet(FU);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      n = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(e, t) {
    let n = e.create(this.view), r = t ? t.dom : null;
    if (n.dom.classList.add("cm-tooltip"), e.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let i = document.createElement("div");
      i.className = "cm-tooltip-arrow", n.dom.appendChild(i);
    }
    return n.dom.style.position = this.position, n.dom.style.top = bS, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var e, t, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (e = r.destroy) === null || e === void 0 || e.call(r);
    this.parent && this.container.remove(), (t = this.resizeObserver) === null || t === void 0 || t.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let e = 1, t = 1, n = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: o } = this.manager.tooltipViews[0];
      if (Qt.gecko)
        n = o.offsetParent != this.container.ownerDocument.body;
      else if (o.style.top == bS && o.style.left == "0px") {
        let s = o.getBoundingClientRect();
        n = Math.abs(s.top + 1e4) > 1 || Math.abs(s.left) > 1;
      }
    }
    if (n || this.position == "absolute")
      if (this.parent) {
        let o = this.parent.getBoundingClientRect();
        o.width && o.height && (e = o.width / this.parent.offsetWidth, t = o.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: t } = this.view.viewState);
    let r = this.view.scrollDOM.getBoundingClientRect(), i = MG(this.view);
    return {
      visible: {
        left: r.left + i.left,
        top: r.top + i.top,
        right: r.right - i.right,
        bottom: r.bottom - i.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((o, s) => {
        let l = this.manager.tooltipViews[s];
        return l.getCoords ? l.getCoords(o.pos) : this.view.coordsAtPos(o.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: o }) => o.getBoundingClientRect()),
      space: this.view.state.facet(FU).tooltipSpace(this.view),
      scaleX: e,
      scaleY: t,
      makeAbsolute: n
    };
  }
  writeMeasure(e) {
    var t;
    if (e.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let l of this.manager.tooltipViews)
        l.dom.style.position = "absolute";
    }
    let { visible: n, space: r, scaleX: i, scaleY: o } = e, s = [];
    for (let l = 0; l < this.manager.tooltips.length; l++) {
      let c = this.manager.tooltips[l], a = this.manager.tooltipViews[l], { dom: u } = a, f = e.pos[l], d = e.size[l];
      if (!f || c.clip !== !1 && (f.bottom <= Math.max(n.top, r.top) || f.top >= Math.min(n.bottom, r.bottom) || f.right < Math.max(n.left, r.left) - 0.1 || f.left > Math.min(n.right, r.right) + 0.1)) {
        u.style.top = bS;
        continue;
      }
      let p = c.arrow ? a.dom.querySelector(".cm-tooltip-arrow") : null, h = p ? 7 : 0, m = d.right - d.left, v = (t = Rue.get(a)) !== null && t !== void 0 ? t : d.bottom - d.top, b = a.offset || OFt, A = this.view.textDirection == hi.LTR, w = d.width > r.right - r.left ? A ? r.left : r.right - d.width : A ? Math.max(r.left, Math.min(f.left - (p ? 14 : 0) + b.x, r.right - m)) : Math.min(Math.max(r.left, f.left - m + (p ? 14 : 0) - b.x), r.right - m), O = this.above[l];
      !c.strictSide && (O ? f.top - v - h - b.y < r.top : f.bottom + v + h + b.y > r.bottom) && O == r.bottom - f.bottom > f.top - r.top && (O = this.above[l] = !O);
      let x = (O ? f.top - r.top : r.bottom - f.bottom) - h;
      if (x < v && a.resize !== !1) {
        if (x < this.view.defaultLineHeight) {
          u.style.top = bS;
          continue;
        }
        Rue.set(a, v), u.style.height = (v = x) / o + "px";
      } else u.style.height && (u.style.height = "");
      let S = O ? f.top - v - h - b.y : f.bottom + h + b.y, E = w + m;
      if (a.overlap !== !0)
        for (let k of s)
          k.left < E && k.right > w && k.top < S + v && k.bottom > S && (S = O ? k.top - v - 2 - h : k.bottom + h + 2);
      if (this.position == "absolute" ? (u.style.top = (S - e.parent.top) / o + "px", Mue(u, (w - e.parent.left) / i)) : (u.style.top = S / o + "px", Mue(u, w / i)), p) {
        let k = f.left + (A ? b.x : -b.x) - (w + 14 - 7);
        p.style.left = k / i + "px";
      }
      a.overlap !== !0 && s.push({ left: w, top: S, right: E, bottom: S + v }), u.classList.toggle("cm-tooltip-above", O), u.classList.toggle("cm-tooltip-below", !O), a.positioned && a.positioned(e.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let e of this.manager.tooltipViews)
        e.dom.style.top = bS;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function Mue(e, t) {
  let n = parseInt(e.style.left, 10);
  (isNaN(n) || Math.abs(t - n) > 1) && (e.style.left = t + "px");
}
const bFt = /* @__PURE__ */ kt.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), OFt = { x: 0, y: 0 }, jG = /* @__PURE__ */ Ht.define({
  enables: [zG, bFt]
}), C_ = /* @__PURE__ */ Ht.define({
  combine: (e) => e.reduce((t, n) => t.concat(n), [])
});
class $j {
  // Needs to be static so that host tooltip instances always match
  static create(t) {
    return new $j(t);
  }
  constructor(t) {
    this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new CLe(t, C_, (n, r) => this.createHostedView(n, r), (n) => n.dom.remove());
  }
  createHostedView(t, n) {
    let r = t.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(t) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(t);
    this.mounted = !0;
  }
  positioned(t) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(t);
  }
  update(t) {
    this.manager.update(t);
  }
  destroy() {
    var t;
    for (let n of this.manager.tooltipViews)
      (t = n.destroy) === null || t === void 0 || t.call(n);
  }
  passProp(t) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let i = r[t];
      if (i !== void 0) {
        if (n === void 0)
          n = i;
        else if (n !== i)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const AFt = /* @__PURE__ */ jG.compute([C_], (e) => {
  let t = e.facet(C_);
  return t.length === 0 ? null : {
    pos: Math.min(...t.map((n) => n.pos)),
    end: Math.max(...t.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: $j.create,
    above: t[0].above,
    arrow: t.some((n) => n.arrow)
  };
});
class wFt {
  constructor(t, n, r, i, o) {
    this.view = t, this.source = n, this.field = r, this.setHover = i, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: t.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let t = Date.now() - this.lastMove.time;
    t < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - t) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: t, lastMove: n } = this, r = t.docView.nearest(n.target);
    if (!r)
      return;
    let i, o = 1;
    if (r instanceof zm)
      i = r.posAtStart;
    else {
      if (i = t.posAtCoords(n), i == null)
        return;
      let l = t.coordsAtPos(i);
      if (!l || n.y < l.top || n.y > l.bottom || n.x < l.left - t.defaultCharacterWidth || n.x > l.right + t.defaultCharacterWidth)
        return;
      let c = t.bidiSpans(t.state.doc.lineAt(i)).find((u) => u.from <= i && u.to >= i), a = c && c.dir == hi.RTL ? -1 : 1;
      o = n.x < l.left ? -a : a;
    }
    let s = this.source(t, i, o);
    if (s != null && s.then) {
      let l = this.pending = { pos: i };
      s.then((c) => {
        this.pending == l && (this.pending = null, c && !(Array.isArray(c) && !c.length) && t.dispatch({ effects: this.setHover.of(Array.isArray(c) ? c : [c]) }));
      }, (c) => ul(t.state, c, "hover tooltip"));
    } else s && !(Array.isArray(s) && !s.length) && t.dispatch({ effects: this.setHover.of(Array.isArray(s) ? s : [s]) });
  }
  get tooltip() {
    let t = this.view.plugin(zG), n = t ? t.manager.tooltips.findIndex((r) => r.create == $j.create) : -1;
    return n > -1 ? t.manager.tooltipViews[n] : null;
  }
  mousemove(t) {
    var n, r;
    this.lastMove = { x: t.clientX, y: t.clientY, target: t.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: i, tooltip: o } = this;
    if (i.length && o && !xFt(o.dom, t) || this.pending) {
      let { pos: s } = i[0] || this.pending, l = (r = (n = i[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : s;
      (s == l ? this.view.posAtCoords(this.lastMove) != s : !SFt(this.view, s, l, t.clientX, t.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(t) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(t.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(t) {
    let n = (r) => {
      t.removeEventListener("mouseleave", n), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    t.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const zI = 4;
function xFt(e, t) {
  let { left: n, right: r, top: i, bottom: o } = e.getBoundingClientRect(), s;
  if (s = e.querySelector(".cm-tooltip-arrow")) {
    let l = s.getBoundingClientRect();
    i = Math.min(l.top, i), o = Math.max(l.bottom, o);
  }
  return t.clientX >= n - zI && t.clientX <= r + zI && t.clientY >= i - zI && t.clientY <= o + zI;
}
function SFt(e, t, n, r, i, o) {
  let s = e.scrollDOM.getBoundingClientRect(), l = e.documentTop + e.documentPadding.top + e.contentHeight;
  if (s.left > r || s.right < r || s.top > i || Math.min(s.bottom, l) < i)
    return !1;
  let c = e.posAtCoords({ x: r, y: i }, !1);
  return c >= t && c <= n;
}
function EFt(e, t = {}) {
  let n = _n.define(), r = cs.define({
    create() {
      return [];
    },
    update(i, o) {
      if (i.length && (t.hideOnChange && (o.docChanged || o.selection) ? i = [] : t.hideOn && (i = i.filter((s) => !t.hideOn(o, s))), o.docChanged)) {
        let s = [];
        for (let l of i) {
          let c = o.changes.mapPos(l.pos, -1, Os.TrackDel);
          if (c != null) {
            let a = Object.assign(/* @__PURE__ */ Object.create(null), l);
            a.pos = c, a.end != null && (a.end = o.changes.mapPos(a.end)), s.push(a);
          }
        }
        i = s;
      }
      for (let s of o.effects)
        s.is(n) && (i = s.value), s.is(TFt) && (i = []);
      return i;
    },
    provide: (i) => C_.from(i)
  });
  return {
    active: r,
    extension: [
      r,
      Yi.define((i) => new wFt(
        i,
        e,
        r,
        n,
        t.hoverTime || 300
        /* Hover.Time */
      )),
      AFt
    ]
  };
}
function NLe(e, t) {
  let n = e.plugin(zG);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(t);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const TFt = /* @__PURE__ */ _n.define(), Due = /* @__PURE__ */ Ht.define({
  combine(e) {
    let t, n;
    for (let r of e)
      t = t || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: t, bottomContainer: n };
  }
});
function gk(e, t) {
  let n = e.plugin(PLe), r = n ? n.specs.indexOf(t) : -1;
  return r > -1 ? n.panels[r] : null;
}
const PLe = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.input = e.state.facet(yk), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(e));
    let t = e.state.facet(Due);
    this.top = new jI(e, !0, t.topContainer), this.bottom = new jI(e, !1, t.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(e) {
    let t = e.state.facet(Due);
    this.top.container != t.topContainer && (this.top.sync([]), this.top = new jI(e.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new jI(e.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = e.state.facet(yk);
    if (n != this.input) {
      let r = n.filter((c) => c), i = [], o = [], s = [], l = [];
      for (let c of r) {
        let a = this.specs.indexOf(c), u;
        a < 0 ? (u = c(e.view), l.push(u)) : (u = this.panels[a], u.update && u.update(e)), i.push(u), (u.top ? o : s).push(u);
      }
      this.specs = r, this.panels = i, this.top.sync(o), this.bottom.sync(s);
      for (let c of l)
        c.dom.classList.add("cm-panel"), c.mount && c.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(e);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (e) => kt.scrollMargins.of((t) => {
    let n = t.plugin(e);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
let jI = class {
  constructor(t, n, r) {
    this.view = t, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(t) {
    for (let n of this.panels)
      n.destroy && t.indexOf(n) < 0 && n.destroy();
    this.panels = t, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let t = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; t != n.dom; )
          t = _ue(t);
        t = t.nextSibling;
      } else
        this.dom.insertBefore(n.dom, t);
    for (; t; )
      t = _ue(t);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let t of this.classes.split(" "))
        t && this.container.classList.remove(t);
      for (let t of (this.classes = this.view.themeClasses).split(" "))
        t && this.container.classList.add(t);
    }
  }
};
function _ue(e) {
  let t = e.nextSibling;
  return e.remove(), t;
}
const yk = /* @__PURE__ */ Ht.define({
  enables: PLe
});
class gh extends Qv {
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(t) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(t) {
  }
}
gh.prototype.elementClass = "";
gh.prototype.toDOM = void 0;
gh.prototype.mapMode = Os.TrackBefore;
gh.prototype.startSide = gh.prototype.endSide = -1;
gh.prototype.point = !0;
const vM = /* @__PURE__ */ Ht.define(), kFt = /* @__PURE__ */ Ht.define(), CFt = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => xr.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, FE = /* @__PURE__ */ Ht.define();
function NFt(e) {
  return [ILe(), FE.of({ ...CFt, ...e })];
}
const Lue = /* @__PURE__ */ Ht.define({
  combine: (e) => e.some((t) => t)
});
function ILe(e) {
  return [
    PFt
  ];
}
const PFt = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.view = e, this.prevViewport = e.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = e.state.facet(FE).map((t) => new jue(e, t));
    for (let t of this.gutters)
      this.dom.appendChild(t.dom);
    this.fixed = !e.state.facet(Lue), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), e.scrollDOM.insertBefore(this.dom, e.contentDOM);
  }
  update(e) {
    if (this.updateGutters(e)) {
      let t = this.prevViewport, n = e.view.viewport, r = Math.min(t.to, n.to) - Math.max(t.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    e.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(Lue) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = e.view.viewport;
  }
  syncGutters(e) {
    let t = this.dom.nextSibling;
    e && this.dom.remove();
    let n = xr.iter(this.view.state.facet(vM), this.view.viewport.from), r = [], i = this.gutters.map((o) => new IFt(o, this.view.viewport, -this.view.documentPadding.top));
    for (let o of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(o.type)) {
        let s = !0;
        for (let l of o.type)
          if (l.type == Ia.Text && s) {
            f8(n, r, l.from);
            for (let c of i)
              c.line(this.view, l, r);
            s = !1;
          } else if (l.widget)
            for (let c of i)
              c.widget(this.view, l);
      } else if (o.type == Ia.Text) {
        f8(n, r, o.from);
        for (let s of i)
          s.line(this.view, o, r);
      } else if (o.widget)
        for (let s of i)
          s.widget(this.view, o);
    for (let o of i)
      o.finish();
    e && this.view.scrollDOM.insertBefore(this.dom, t);
  }
  updateGutters(e) {
    let t = e.startState.facet(FE), n = e.state.facet(FE), r = e.docChanged || e.heightChanged || e.viewportChanged || !xr.eq(e.startState.facet(vM), e.state.facet(vM), e.view.viewport.from, e.view.viewport.to);
    if (t == n)
      for (let i of this.gutters)
        i.update(e) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let o of n) {
        let s = t.indexOf(o);
        s < 0 ? i.push(new jue(this.view, o)) : (this.gutters[s].update(e), i.push(this.gutters[s]));
      }
      for (let o of this.gutters)
        o.dom.remove(), i.indexOf(o) < 0 && o.destroy();
      for (let o of i)
        this.dom.appendChild(o.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let e of this.gutters)
      e.destroy();
    this.dom.remove();
  }
}, {
  provide: (e) => kt.scrollMargins.of((t) => {
    let n = t.plugin(e);
    return !n || n.gutters.length == 0 || !n.fixed ? null : t.textDirection == hi.LTR ? { left: n.dom.offsetWidth * t.scaleX } : { right: n.dom.offsetWidth * t.scaleX };
  })
});
function zue(e) {
  return Array.isArray(e) ? e : [e];
}
function f8(e, t, n) {
  for (; e.value && e.from <= n; )
    e.from == n && t.push(e.value), e.next();
}
class IFt {
  constructor(t, n, r) {
    this.gutter = t, this.height = r, this.i = 0, this.cursor = xr.iter(t.markers, n.from);
  }
  addElement(t, n, r) {
    let { gutter: i } = this, o = (n.top - this.height) / t.scaleY, s = n.height / t.scaleY;
    if (this.i == i.elements.length) {
      let l = new RLe(t, s, o, r);
      i.elements.push(l), i.dom.appendChild(l.dom);
    } else
      i.elements[this.i].update(t, s, o, r);
    this.height = n.bottom, this.i++;
  }
  line(t, n, r) {
    let i = [];
    f8(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let o = this.gutter.config.lineMarker(t, n, i);
    o && i.unshift(o);
    let s = this.gutter;
    i.length == 0 && !s.config.renderEmptyElements || this.addElement(t, n, i);
  }
  widget(t, n) {
    let r = this.gutter.config.widgetMarker(t, n.widget, n), i = r ? [r] : null;
    for (let o of t.state.facet(kFt)) {
      let s = o(t, n.widget, n);
      s && (i || (i = [])).push(s);
    }
    i && this.addElement(t, n, i);
  }
  finish() {
    let t = this.gutter;
    for (; t.elements.length > this.i; ) {
      let n = t.elements.pop();
      t.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class jue {
  constructor(t, n) {
    this.view = t, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let o = i.target, s;
        if (o != this.dom && this.dom.contains(o)) {
          for (; o.parentNode != this.dom; )
            o = o.parentNode;
          let c = o.getBoundingClientRect();
          s = (c.top + c.bottom) / 2;
        } else
          s = i.clientY;
        let l = t.lineBlockAtHeight(s - t.documentTop);
        n.domEventHandlers[r](t, l, i) && i.preventDefault();
      });
    this.markers = zue(n.markers(t)), n.initialSpacer && (this.spacer = new RLe(t, 0, 0, [n.initialSpacer(t)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(t) {
    let n = this.markers;
    if (this.markers = zue(this.config.markers(t.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], t);
      i != this.spacer.markers[0] && this.spacer.update(t.view, 0, 0, [i]);
    }
    let r = t.view.viewport;
    return !xr.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(t) : !1);
  }
  destroy() {
    for (let t of this.elements)
      t.destroy();
  }
}
class RLe {
  constructor(t, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, n, r, i);
  }
  update(t, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), RFt(this.markers, i) || this.setMarkers(t, i);
  }
  setMarkers(t, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let o = 0, s = 0; ; ) {
      let l = s, c = o < n.length ? n[o++] : null, a = !1;
      if (c) {
        let u = c.elementClass;
        u && (r += " " + u);
        for (let f = s; f < this.markers.length; f++)
          if (this.markers[f].compare(c)) {
            l = f, a = !0;
            break;
          }
      } else
        l = this.markers.length;
      for (; s < l; ) {
        let u = this.markers[s++];
        if (u.toDOM) {
          u.destroy(i);
          let f = i.nextSibling;
          i.remove(), i = f;
        }
      }
      if (!c)
        break;
      c.toDOM && (a ? i = i.nextSibling : this.dom.insertBefore(c.toDOM(t), i)), a && s++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function RFt(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].compare(t[n]))
      return !1;
  return !0;
}
const MFt = /* @__PURE__ */ Ht.define(), DFt = /* @__PURE__ */ Ht.define(), TO = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(t, n) {
        let r = Object.assign({}, t);
        for (let i in n) {
          let o = r[i], s = n[i];
          r[i] = o ? (l, c, a) => o(l, c, a) || s(l, c, a) : s;
        }
        return r;
      }
    });
  }
});
class UU extends gh {
  constructor(t) {
    super(), this.number = t;
  }
  eq(t) {
    return this.number == t.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function VU(e, t) {
  return e.state.facet(TO).formatNumber(t, e.state);
}
const _Ft = /* @__PURE__ */ FE.compute([TO], (e) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(t) {
    return t.state.facet(MFt);
  },
  lineMarker(t, n, r) {
    return r.some((i) => i.toDOM) ? null : new UU(VU(t, t.state.doc.lineAt(n.from).number));
  },
  widgetMarker: (t, n, r) => {
    for (let i of t.state.facet(DFt)) {
      let o = i(t, n, r);
      if (o)
        return o;
    }
    return null;
  },
  lineMarkerChange: (t) => t.startState.facet(TO) != t.state.facet(TO),
  initialSpacer(t) {
    return new UU(VU(t, Fue(t.state.doc.lines)));
  },
  updateSpacer(t, n) {
    let r = VU(n.view, Fue(n.view.state.doc.lines));
    return r == t.number ? t : new UU(r);
  },
  domEventHandlers: e.facet(TO).domEventHandlers
}));
function LFt(e = {}) {
  return [
    TO.of(e),
    ILe(),
    _Ft
  ];
}
function Fue(e) {
  let t = 9;
  for (; t < e; )
    t = t * 10 + 9;
  return t;
}
const zFt = /* @__PURE__ */ new class extends gh {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), jFt = /* @__PURE__ */ vM.compute(["selection"], (e) => {
  let t = [], n = -1;
  for (let r of e.selection.ranges) {
    let i = e.doc.lineAt(r.head).from;
    i > n && (n = i, t.push(zFt.range(i)));
  }
  return xr.of(t);
});
function FFt() {
  return jFt;
}
var qU;
const kO = /* @__PURE__ */ new Gn();
function MLe(e) {
  return Ht.define({
    combine: e ? (t) => t.concat(e) : void 0
  });
}
const FG = /* @__PURE__ */ new Gn();
class Bu {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(t, n, r = [], i = "") {
    this.data = t, this.name = i, $n.prototype.hasOwnProperty("tree") || Object.defineProperty($n.prototype, "tree", { get() {
      return zo(this);
    } }), this.parser = n, this.extension = [
      dg.of(this),
      $n.languageData.of((o, s, l) => {
        let c = Uue(o, s, l), a = c.type.prop(kO);
        if (!a)
          return [];
        let u = o.facet(a), f = c.type.prop(FG);
        if (f) {
          let d = c.resolve(s - c.from, l);
          for (let p of f)
            if (p.test(d, o)) {
              let h = o.facet(p.facet);
              return p.type == "replace" ? h : h.concat(u);
            }
        }
        return u;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(t, n, r = -1) {
    return Uue(t, n, r).type.prop(kO) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(t) {
    let n = t.facet(dg);
    if ((n == null ? void 0 : n.data) == this.data)
      return [{ from: 0, to: t.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], i = (o, s) => {
      if (o.prop(kO) == this.data) {
        r.push({ from: s, to: s + o.length });
        return;
      }
      let l = o.prop(Gn.mounted);
      if (l) {
        if (l.tree.prop(kO) == this.data) {
          if (l.overlay)
            for (let c of l.overlay)
              r.push({ from: c.from + s, to: c.to + s });
          else
            r.push({ from: s, to: s + o.length });
          return;
        } else if (l.overlay) {
          let c = r.length;
          if (i(l.tree, l.overlay[0].from + s), r.length > c)
            return;
        }
      }
      for (let c = 0; c < o.children.length; c++) {
        let a = o.children[c];
        a instanceof go && i(a, o.positions[c] + s);
      }
    };
    return i(zo(t), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
Bu.setState = /* @__PURE__ */ _n.define();
function Uue(e, t, n) {
  let r = e.facet(dg), i = zo(e).topNode;
  if (!r || r.allowsNesting)
    for (let o = i; o; o = o.enter(t, n, Do.ExcludeBuffers))
      o.type.isTop && (i = o);
  return i;
}
class vk extends Bu {
  constructor(t, n, r) {
    super(t, n, [], r), this.parser = n;
  }
  /**
  Define a language from a parser.
  */
  static define(t) {
    let n = MLe(t.languageData);
    return new vk(n, t.parser.configure({
      props: [kO.add((r) => r.isTop ? n : void 0)]
    }), t.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(t, n) {
    return new vk(this.data, this.parser.configure(t), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function zo(e) {
  let t = e.field(Bu.state, !1);
  return t ? t.tree : go.empty;
}
class UFt {
  /**
  Create an input object for the given document.
  */
  constructor(t) {
    this.doc = t, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(t) {
    return this.string = this.cursor.next(t - this.cursorPos).value, this.cursorPos = t + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(t) {
    return this.syncTo(t), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(t, n) {
    let r = this.cursorPos - this.string.length;
    return t < r || n >= this.cursorPos ? this.doc.sliceString(t, n) : this.string.slice(t - r, n - r);
  }
}
let OS = null;
class N_ {
  constructor(t, n, r = [], i, o, s, l, c) {
    this.parser = t, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = s, this.skipped = l, this.scheduleOn = c, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new N_(t, n, [], go.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new UFt(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(t, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != go.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof t == "number") {
        let i = Date.now() + t;
        t = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(pv.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (t())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let t, n;
    this.parse && (t = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > t) && this.parse.stopAt(t), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = t, this.tree = n, this.fragments = this.withoutTempSkipped(pv.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(t) {
    let n = OS;
    OS = this;
    try {
      return t();
    } finally {
      OS = n;
    }
  }
  withoutTempSkipped(t) {
    for (let n; n = this.tempSkipped.pop(); )
      t = Vue(t, n.from, n.to);
    return t;
  }
  /**
  @internal
  */
  changes(t, n) {
    let { fragments: r, tree: i, treeLen: o, viewport: s, skipped: l } = this;
    if (this.takeTree(), !t.empty) {
      let c = [];
      if (t.iterChangedRanges((a, u, f, d) => c.push({ fromA: a, toA: u, fromB: f, toB: d })), r = pv.applyChanges(r, c), i = go.empty, o = 0, s = { from: t.mapPos(s.from, -1), to: t.mapPos(s.to, 1) }, this.skipped.length) {
        l = [];
        for (let a of this.skipped) {
          let u = t.mapPos(a.from, 1), f = t.mapPos(a.to, -1);
          u < f && l.push({ from: u, to: f });
        }
      }
    }
    return new N_(this.parser, n, r, i, o, s, l, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(t) {
    if (this.viewport.from == t.from && this.viewport.to == t.to)
      return !1;
    this.viewport = t;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: o } = this.skipped[r];
      i < t.to && o > t.from && (this.fragments = Vue(this.fragments, i, o), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(t, n) {
    this.skipped.push({ from: t, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(t) {
    return new class extends e_e {
      createParse(n, r, i) {
        let o = i[0].from, s = i[i.length - 1].to;
        return {
          parsedPos: o,
          advance() {
            let c = OS;
            if (c) {
              for (let a of i)
                c.tempSkipped.push(a);
              t && (c.scheduleOn = c.scheduleOn ? Promise.all([c.scheduleOn, t]) : t);
            }
            return this.parsedPos = s, new go(au.none, [], [], s - o);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(t) {
    t = Math.min(t, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= t && n.length && n[0].from == 0 && n[0].to >= t;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return OS;
  }
}
function Vue(e, t, n) {
  return pv.applyChanges(e, [{ fromA: t, toA: n, fromB: t, toB: n }]);
}
class Tw {
  constructor(t) {
    this.context = t, this.tree = t.tree;
  }
  apply(t) {
    if (!t.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(t.changes, t.state), r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new Tw(n);
  }
  static init(t) {
    let n = Math.min(3e3, t.doc.length), r = N_.create(t.facet(dg).parser, t, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new Tw(r);
  }
}
Bu.state = /* @__PURE__ */ cs.define({
  create: Tw.init,
  update(e, t) {
    for (let n of t.effects)
      if (n.is(Bu.setState))
        return n.value;
    return t.startState.facet(dg) != t.state.facet(dg) ? Tw.init(t.state) : e.apply(t);
  }
});
let DLe = (e) => {
  let t = setTimeout(
    () => e(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(t);
};
typeof requestIdleCallback < "u" && (DLe = (e) => {
  let t = -1, n = setTimeout(
    () => {
      t = requestIdleCallback(e, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
});
const BU = typeof navigator < "u" && (!((qU = navigator.scheduling) === null || qU === void 0) && qU.isInputPending) ? () => navigator.scheduling.isInputPending() : null, VFt = /* @__PURE__ */ Yi.fromClass(class {
  constructor(t) {
    this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(t) {
    let n = this.view.state.field(Bu.state).context;
    (n.updateViewport(t.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (t.docChanged || t.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: t } = this.view, n = t.field(Bu.state);
    (n.tree != n.context.tree || !n.context.isDone(t.doc.length)) && (this.working = DLe(this.work));
  }
  work(t) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, o = r.field(Bu.state);
    if (o.tree == o.context.tree && o.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let s = Date.now() + Math.min(this.chunkBudget, 100, t && !BU ? Math.max(25, t.timeRemaining() - 5) : 1e9), l = o.context.treeLen < i && r.doc.length > i + 1e3, c = o.context.work(() => BU && BU() || Date.now() > s, i + (l ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (c || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({ effects: Bu.setState.of(new Tw(o.context)) })), this.chunkBudget > 0 && !(c && !l) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
  }
  checkAsyncSchedule(t) {
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(() => this.scheduleWork()).catch((n) => ul(this.view.state, n)).then(() => this.workScheduled--), t.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), dg = /* @__PURE__ */ Ht.define({
  combine(e) {
    return e.length ? e[0] : null;
  },
  enables: (e) => [
    Bu.state,
    VFt,
    kt.contentAttributes.compute([e], (t) => {
      let n = t.facet(e);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
});
class _Le {
  /**
  Create a language support object.
  */
  constructor(t, n = []) {
    this.language = t, this.support = n, this.extension = [t, n];
  }
}
const qFt = /* @__PURE__ */ Ht.define(), PN = /* @__PURE__ */ Ht.define({
  combine: (e) => {
    if (!e.length)
      return "  ";
    let t = e[0];
    if (!t || /\S/.test(t) || Array.from(t).some((n) => n != t[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(e[0]));
    return t;
  }
});
function P_(e) {
  let t = e.facet(PN);
  return t.charCodeAt(0) == 9 ? e.tabSize * t.length : t.length;
}
function bk(e, t) {
  let n = "", r = e.tabSize, i = e.facet(PN)[0];
  if (i == "	") {
    for (; t >= r; )
      n += "	", t -= r;
    i = " ";
  }
  for (let o = 0; o < t; o++)
    n += i;
  return n;
}
function UG(e, t) {
  e instanceof $n && (e = new Kj(e));
  for (let r of e.state.facet(qFt)) {
    let i = r(e, t);
    if (i !== void 0)
      return i;
  }
  let n = zo(e.state);
  return n.length >= t ? BFt(e, n, t) : null;
}
class Kj {
  /**
  Create an indent context.
  */
  constructor(t, n = {}) {
    this.state = t, this.options = n, this.unit = P_(t);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(t, n = 1) {
    let r = this.state.doc.lineAt(t), { simulateBreak: i, simulateDoubleBreak: o } = this.options;
    return i != null && i >= r.from && i <= r.to ? o && i == t ? { text: "", from: t } : (n < 0 ? i < t : i <= t) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(t, n = 1) {
    if (this.options.simulateDoubleBreak && t == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(t, n);
    return r.slice(t - i, Math.min(r.length, t + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(t, n = 1) {
    let { text: r, from: i } = this.lineAt(t, n), o = this.countColumn(r, t - i), s = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return s > -1 && (o += s - this.countColumn(r, r.search(/\S|$/))), o;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(t, n = t.length) {
    return Cx(t, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(t, n = 1) {
    let { text: r, from: i } = this.lineAt(t, n), o = this.options.overrideIndentation;
    if (o) {
      let s = o(i);
      if (s > -1)
        return s;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const VG = /* @__PURE__ */ new Gn();
function BFt(e, t, n) {
  let r = t.resolveStack(n), i = t.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let o = [];
    for (let s = i; s && !(s.from == r.node.from && s.type == r.node.type); s = s.parent)
      o.push(s);
    for (let s = o.length - 1; s >= 0; s--)
      r = { node: o[s], next: r };
  }
  return LLe(r, e, n);
}
function LLe(e, t, n) {
  for (let r = e; r; r = r.next) {
    let i = WFt(r.node);
    if (i)
      return i(qG.create(t, n, r));
  }
  return 0;
}
function XFt(e) {
  return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
}
function WFt(e) {
  let t = e.type.prop(VG);
  if (t)
    return t;
  let n = e.firstChild, r;
  if (n && (r = n.type.prop(Gn.closedBy))) {
    let i = e.lastChild, o = i && r.indexOf(i.name) > -1;
    return (s) => zLe(s, !0, 1, void 0, o && !XFt(s) ? i.from : void 0);
  }
  return e.parent == null ? ZFt : null;
}
function ZFt() {
  return 0;
}
class qG extends Kj {
  constructor(t, n, r) {
    super(t.state, t.options), this.base = t, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new qG(t, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(t) {
    let n = this.state.doc.lineAt(t.from);
    for (; ; ) {
      let r = t.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (HFt(r, t))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return LLe(this.context.next, this.base, this.pos);
  }
}
function HFt(e, t) {
  for (let n = t; n; n = n.parent)
    if (e == n)
      return !0;
  return !1;
}
function QFt(e) {
  let t = e.node, n = t.childAfter(t.from), r = t.lastChild;
  if (!n)
    return null;
  let i = e.options.simulateBreak, o = e.state.doc.lineAt(n.from), s = i == null || i <= o.from ? o.to : Math.min(o.to, i);
  for (let l = n.to; ; ) {
    let c = t.childAfter(l);
    if (!c || c == r)
      return null;
    if (!c.type.isSkipped) {
      if (c.from >= s)
        return null;
      let a = /^ */.exec(o.text.slice(n.to - o.from))[0].length;
      return { from: n.from, to: n.to + a };
    }
    l = c.to;
  }
}
function $Ft({ closing: e, align: t = !0, units: n = 1 }) {
  return (r) => zLe(r, t, n, e);
}
function zLe(e, t, n, r, i) {
  let o = e.textAfter, s = o.match(/^\s*/)[0].length, l = r && o.slice(s, s + r.length) == r || i == e.pos + s, c = t ? QFt(e) : null;
  return c ? l ? e.column(c.from) : e.column(c.to) : e.baseIndent + (l ? 0 : e.unit * n);
}
const KFt = (e) => e.baseIndent;
function UE({ except: e, units: t = 1 } = {}) {
  return (n) => {
    let r = e && e.test(n.textAfter);
    return n.baseIndent + (r ? 0 : t * n.unit);
  };
}
const GFt = 200;
function YFt() {
  return $n.transactionFilter.of((e) => {
    if (!e.docChanged || !e.isUserEvent("input.type") && !e.isUserEvent("input.complete"))
      return e;
    let t = e.startState.languageDataAt("indentOnInput", e.startState.selection.main.head);
    if (!t.length)
      return e;
    let n = e.newDoc, { head: r } = e.newSelection.main, i = n.lineAt(r);
    if (r > i.from + GFt)
      return e;
    let o = n.sliceString(i.from, r);
    if (!t.some((a) => a.test(o)))
      return e;
    let { state: s } = e, l = -1, c = [];
    for (let { head: a } of s.selection.ranges) {
      let u = s.doc.lineAt(a);
      if (u.from == l)
        continue;
      l = u.from;
      let f = UG(s, u.from);
      if (f == null)
        continue;
      let d = /^\s*/.exec(u.text)[0], p = bk(s, f);
      d != p && c.push({ from: u.from, to: u.from + d.length, insert: p });
    }
    return c.length ? [e, { changes: c, sequential: !0 }] : e;
  });
}
const JFt = /* @__PURE__ */ Ht.define(), BG = /* @__PURE__ */ new Gn();
function jLe(e) {
  let t = e.firstChild, n = e.lastChild;
  return t && t.to < n.from ? { from: t.to, to: n.type.isError ? e.to : n.from } : null;
}
function e5t(e, t, n) {
  let r = zo(e);
  if (r.length < n)
    return null;
  let i = r.resolveStack(n, 1), o = null;
  for (let s = i; s; s = s.next) {
    let l = s.node;
    if (l.to <= n || l.from > n)
      continue;
    if (o && l.from < t)
      break;
    let c = l.type.prop(BG);
    if (c && (l.to < r.length - 50 || r.length == e.doc.length || !t5t(l))) {
      let a = c(l, e);
      a && a.from <= n && a.from >= t && a.to > n && (o = a);
    }
  }
  return o;
}
function t5t(e) {
  let t = e.lastChild;
  return t && t.to == e.to && t.type.isError;
}
function I_(e, t, n) {
  for (let r of e.facet(JFt)) {
    let i = r(e, t, n);
    if (i)
      return i;
  }
  return e5t(e, t, n);
}
function FLe(e, t) {
  let n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const Gj = /* @__PURE__ */ _n.define({ map: FLe }), IN = /* @__PURE__ */ _n.define({ map: FLe });
function ULe(e) {
  let t = [];
  for (let { head: n } of e.state.selection.ranges)
    t.some((r) => r.from <= n && r.to >= n) || t.push(e.lineBlockAt(n));
  return t;
}
const Yv = /* @__PURE__ */ cs.define({
  create() {
    return ln.none;
  },
  update(e, t) {
    e = e.map(t.changes);
    for (let n of t.effects)
      if (n.is(Gj) && !n5t(e, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = t.state.facet(BLe), i = r ? ln.replace({ widget: new c5t(r(t.state, n.value)) }) : que;
        e = e.update({ add: [i.range(n.value.from, n.value.to)] });
      } else n.is(IN) && (e = e.update({
        filter: (r, i) => n.value.from != r || n.value.to != i,
        filterFrom: n.value.from,
        filterTo: n.value.to
      }));
    if (t.selection) {
      let n = !1, { head: r } = t.selection.main;
      e.between(r, r, (i, o) => {
        i < r && o > r && (n = !0);
      }), n && (e = e.update({
        filterFrom: r,
        filterTo: r,
        filter: (i, o) => o <= r || i >= r
      }));
    }
    return e;
  },
  provide: (e) => kt.decorations.from(e),
  toJSON(e, t) {
    let n = [];
    return e.between(0, t.doc.length, (r, i) => {
      n.push(r, i);
    }), n;
  },
  fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let t = [];
    for (let n = 0; n < e.length; ) {
      let r = e[n++], i = e[n++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      t.push(que.range(r, i));
    }
    return ln.set(t, !0);
  }
});
function R_(e, t, n) {
  var r;
  let i = null;
  return (r = e.field(Yv, !1)) === null || r === void 0 || r.between(t, n, (o, s) => {
    (!i || i.from > o) && (i = { from: o, to: s });
  }), i;
}
function n5t(e, t, n) {
  let r = !1;
  return e.between(t, t, (i, o) => {
    i == t && o == n && (r = !0);
  }), r;
}
function VLe(e, t) {
  return e.field(Yv, !1) ? t : t.concat(_n.appendConfig.of(XLe()));
}
const r5t = (e) => {
  for (let t of ULe(e)) {
    let n = I_(e.state, t.from, t.to);
    if (n)
      return e.dispatch({ effects: VLe(e.state, [Gj.of(n), qLe(e, n)]) }), !0;
  }
  return !1;
}, i5t = (e) => {
  if (!e.state.field(Yv, !1))
    return !1;
  let t = [];
  for (let n of ULe(e)) {
    let r = R_(e.state, n.from, n.to);
    r && t.push(IN.of(r), qLe(e, r, !1));
  }
  return t.length && e.dispatch({ effects: t }), t.length > 0;
};
function qLe(e, t, n = !0) {
  let r = e.state.doc.lineAt(t.from).number, i = e.state.doc.lineAt(t.to).number;
  return kt.announce.of(`${e.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${e.state.phrase("to")} ${i}.`);
}
const o5t = (e) => {
  let { state: t } = e, n = [];
  for (let r = 0; r < t.doc.length; ) {
    let i = e.lineBlockAt(r), o = I_(t, i.from, i.to);
    o && n.push(Gj.of(o)), r = (o ? e.lineBlockAt(o.to) : i).to + 1;
  }
  return n.length && e.dispatch({ effects: VLe(e.state, n) }), !!n.length;
}, s5t = (e) => {
  let t = e.state.field(Yv, !1);
  if (!t || !t.size)
    return !1;
  let n = [];
  return t.between(0, e.state.doc.length, (r, i) => {
    n.push(IN.of({ from: r, to: i }));
  }), e.dispatch({ effects: n }), !0;
}, a5t = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: r5t },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: i5t },
  { key: "Ctrl-Alt-[", run: o5t },
  { key: "Ctrl-Alt-]", run: s5t }
], l5t = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, BLe = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, l5t);
  }
});
function XLe(e) {
  return [Yv, f5t];
}
function WLe(e, t) {
  let { state: n } = e, r = n.facet(BLe), i = (s) => {
    let l = e.lineBlockAt(e.posAtDOM(s.target)), c = R_(e.state, l.from, l.to);
    c && e.dispatch({ effects: IN.of(c) }), s.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(e, i, t);
  let o = document.createElement("span");
  return o.textContent = r.placeholderText, o.setAttribute("aria-label", n.phrase("folded code")), o.title = n.phrase("unfold"), o.className = "cm-foldPlaceholder", o.onclick = i, o;
}
const que = /* @__PURE__ */ ln.replace({ widget: /* @__PURE__ */ new class extends qf {
  toDOM(e) {
    return WLe(e, null);
  }
}() });
class c5t extends qf {
  constructor(t) {
    super(), this.value = t;
  }
  eq(t) {
    return this.value == t.value;
  }
  toDOM(t) {
    return WLe(t, this.value);
  }
}
const u5t = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class XU extends gh {
  constructor(t, n) {
    super(), this.config = t, this.open = n;
  }
  eq(t) {
    return this.config == t.config && this.open == t.open;
  }
  toDOM(t) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = t.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function d5t(e = {}) {
  let t = Object.assign(Object.assign({}, u5t), e), n = new XU(t, !0), r = new XU(t, !1), i = Yi.fromClass(class {
    constructor(s) {
      this.from = s.viewport.from, this.markers = this.buildMarkers(s);
    }
    update(s) {
      (s.docChanged || s.viewportChanged || s.startState.facet(dg) != s.state.facet(dg) || s.startState.field(Yv, !1) != s.state.field(Yv, !1) || zo(s.startState) != zo(s.state) || t.foldingChanged(s)) && (this.markers = this.buildMarkers(s.view));
    }
    buildMarkers(s) {
      let l = new hh();
      for (let c of s.viewportLineBlocks) {
        let a = R_(s.state, c.from, c.to) ? r : I_(s.state, c.from, c.to) ? n : null;
        a && l.add(c.from, c.from, a);
      }
      return l.finish();
    }
  }), { domEventHandlers: o } = t;
  return [
    i,
    NFt({
      class: "cm-foldGutter",
      markers(s) {
        var l;
        return ((l = s.plugin(i)) === null || l === void 0 ? void 0 : l.markers) || xr.empty;
      },
      initialSpacer() {
        return new XU(t, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, o), { click: (s, l, c) => {
        if (o.click && o.click(s, l, c))
          return !0;
        let a = R_(s.state, l.from, l.to);
        if (a)
          return s.dispatch({ effects: IN.of(a) }), !0;
        let u = I_(s.state, l.from, l.to);
        return u ? (s.dispatch({ effects: Gj.of(u) }), !0) : !1;
      } })
    }),
    XLe()
  ];
}
const f5t = /* @__PURE__ */ kt.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class Nx {
  constructor(t, n) {
    this.specs = t;
    let r;
    function i(l) {
      let c = cg.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + c] = l, c;
    }
    const o = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, s = n.scope;
    this.scope = s instanceof Bu ? (l) => l.prop(kO) == s.data : s ? (l) => l == s : void 0, this.style = i_e(t.map((l) => ({
      tag: l.tag,
      class: l.class || i(Object.assign({}, l, { tag: null }))
    })), {
      all: o
    }).style, this.module = r ? new cg(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(t, n) {
    return new Nx(t, n || {});
  }
}
const p8 = /* @__PURE__ */ Ht.define(), ZLe = /* @__PURE__ */ Ht.define({
  combine(e) {
    return e.length ? [e[0]] : null;
  }
});
function WU(e) {
  let t = e.facet(p8);
  return t.length ? t : e.facet(ZLe);
}
function XG(e, t) {
  let n = [h5t], r;
  return e instanceof Nx && (e.module && n.push(kt.styleModule.of(e.module)), r = e.themeType), t != null && t.fallback ? n.push(ZLe.of(e)) : r ? n.push(p8.computeN([kt.darkTheme], (i) => i.facet(kt.darkTheme) == (r == "dark") ? [e] : [])) : n.push(p8.of(e)), n;
}
class p5t {
  constructor(t) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = zo(t.state), this.decorations = this.buildDeco(t, WU(t.state)), this.decoratedTo = t.viewport.to;
  }
  update(t) {
    let n = zo(t.state), r = WU(t.state), i = r != WU(t.startState), { viewport: o } = t.view, s = t.changes.mapPos(this.decoratedTo, 1);
    n.length < o.to && !i && n.type == this.tree.type && s >= o.to ? (this.decorations = this.decorations.map(t.changes), this.decoratedTo = s) : (n != this.tree || t.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(t.view, r), this.decoratedTo = o.to);
  }
  buildDeco(t, n) {
    if (!n || !this.tree.length)
      return ln.none;
    let r = new hh();
    for (let { from: i, to: o } of t.visibleRanges)
      lzt(this.tree, n, (s, l, c) => {
        r.add(s, l, this.markCache[c] || (this.markCache[c] = ln.mark({ class: c })));
      }, i, o);
    return r.finish();
  }
}
const h5t = /* @__PURE__ */ Dg.high(/* @__PURE__ */ Yi.fromClass(p5t, {
  decorations: (e) => e.decorations
})), m5t = /* @__PURE__ */ Nx.define([
  {
    tag: ke.meta,
    color: "#404740"
  },
  {
    tag: ke.link,
    textDecoration: "underline"
  },
  {
    tag: ke.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: ke.emphasis,
    fontStyle: "italic"
  },
  {
    tag: ke.strong,
    fontWeight: "bold"
  },
  {
    tag: ke.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: ke.keyword,
    color: "#708"
  },
  {
    tag: [ke.atom, ke.bool, ke.url, ke.contentSeparator, ke.labelName],
    color: "#219"
  },
  {
    tag: [ke.literal, ke.inserted],
    color: "#164"
  },
  {
    tag: [ke.string, ke.deleted],
    color: "#a11"
  },
  {
    tag: [ke.regexp, ke.escape, /* @__PURE__ */ ke.special(ke.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ ke.definition(ke.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ ke.local(ke.variableName),
    color: "#30a"
  },
  {
    tag: [ke.typeName, ke.namespace],
    color: "#085"
  },
  {
    tag: ke.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ ke.special(ke.variableName), ke.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ ke.definition(ke.propertyName),
    color: "#00c"
  },
  {
    tag: ke.comment,
    color: "#940"
  },
  {
    tag: ke.invalid,
    color: "#f00"
  }
]), g5t = /* @__PURE__ */ kt.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), HLe = 1e4, QLe = "()[]{}", $Le = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, {
      afterCursor: !0,
      brackets: QLe,
      maxScanDistance: HLe,
      renderMatch: b5t
    });
  }
}), y5t = /* @__PURE__ */ ln.mark({ class: "cm-matchingBracket" }), v5t = /* @__PURE__ */ ln.mark({ class: "cm-nonmatchingBracket" });
function b5t(e) {
  let t = [], n = e.matched ? y5t : v5t;
  return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
const O5t = /* @__PURE__ */ cs.define({
  create() {
    return ln.none;
  },
  update(e, t) {
    if (!t.docChanged && !t.selection)
      return e;
    let n = [], r = t.state.facet($Le);
    for (let i of t.state.selection.ranges) {
      if (!i.empty)
        continue;
      let o = cf(t.state, i.head, -1, r) || i.head > 0 && cf(t.state, i.head - 1, 1, r) || r.afterCursor && (cf(t.state, i.head, 1, r) || i.head < t.state.doc.length && cf(t.state, i.head + 1, -1, r));
      o && (n = n.concat(r.renderMatch(o, t.state)));
    }
    return ln.set(n, !0);
  },
  provide: (e) => kt.decorations.from(e)
}), A5t = [
  O5t,
  g5t
];
function w5t(e = {}) {
  return [$Le.of(e), A5t];
}
const x5t = /* @__PURE__ */ new Gn();
function h8(e, t, n) {
  let r = e.prop(t < 0 ? Gn.openedBy : Gn.closedBy);
  if (r)
    return r;
  if (e.name.length == 1) {
    let i = n.indexOf(e.name);
    if (i > -1 && i % 2 == (t < 0 ? 1 : 0))
      return [n[i + t]];
  }
  return null;
}
function m8(e) {
  let t = e.type.prop(x5t);
  return t ? t(e.node) : e;
}
function cf(e, t, n, r = {}) {
  let i = r.maxScanDistance || HLe, o = r.brackets || QLe, s = zo(e), l = s.resolveInner(t, n);
  for (let c = l; c; c = c.parent) {
    let a = h8(c.type, n, o);
    if (a && c.from < c.to) {
      let u = m8(c);
      if (u && (n > 0 ? t >= u.from && t < u.to : t > u.from && t <= u.to))
        return S5t(e, t, n, c, u, a, o);
    }
  }
  return E5t(e, t, n, s, l.type, i, o);
}
function S5t(e, t, n, r, i, o, s) {
  let l = r.parent, c = { from: i.from, to: i.to }, a = 0, u = l == null ? void 0 : l.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (a == 0 && o.indexOf(u.type.name) > -1 && u.from < u.to) {
          let f = m8(u);
          return { start: c, end: f ? { from: f.from, to: f.to } : void 0, matched: !0 };
        } else if (h8(u.type, n, s))
          a++;
        else if (h8(u.type, -n, s)) {
          if (a == 0) {
            let f = m8(u);
            return {
              start: c,
              end: f && f.from < f.to ? { from: f.from, to: f.to } : void 0,
              matched: !1
            };
          }
          a--;
        }
      }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
  return { start: c, matched: !1 };
}
function E5t(e, t, n, r, i, o, s) {
  let l = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1), c = s.indexOf(l);
  if (c < 0 || c % 2 == 0 != n > 0)
    return null;
  let a = { from: n < 0 ? t - 1 : t, to: n > 0 ? t + 1 : t }, u = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), f = 0;
  for (let d = 0; !u.next().done && d <= o; ) {
    let p = u.value;
    n < 0 && (d += p.length);
    let h = t + d * n;
    for (let m = n > 0 ? 0 : p.length - 1, v = n > 0 ? p.length : -1; m != v; m += n) {
      let b = s.indexOf(p[m]);
      if (!(b < 0 || r.resolveInner(h + m, 1).type != i))
        if (b % 2 == 0 == n > 0)
          f++;
        else {
          if (f == 1)
            return { start: a, end: { from: h + m, to: h + m + 1 }, matched: b >> 1 == c >> 1 };
          f--;
        }
    }
    n > 0 && (d += p.length);
  }
  return u.done ? { start: a, matched: !1 } : null;
}
const T5t = /* @__PURE__ */ Object.create(null), Bue = [au.none], Xue = [], Wue = /* @__PURE__ */ Object.create(null), k5t = /* @__PURE__ */ Object.create(null);
for (let [e, t] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  k5t[e] = /* @__PURE__ */ C5t(T5t, t);
function ZU(e, t) {
  Xue.indexOf(e) > -1 || (Xue.push(e), console.warn(t));
}
function C5t(e, t) {
  let n = [];
  for (let l of t.split(" ")) {
    let c = [];
    for (let a of l.split(".")) {
      let u = e[a] || ke[a];
      u ? typeof u == "function" ? c.length ? c = c.map(u) : ZU(a, `Modifier ${a} used at start of tag`) : c.length ? ZU(a, `Tag ${a} used as modifier`) : c = Array.isArray(u) ? u : [u] : ZU(a, `Unknown highlighting tag ${a}`);
    }
    for (let a of c)
      n.push(a);
  }
  if (!n.length)
    return 0;
  let r = t.replace(/ /g, "_"), i = r + " " + n.map((l) => l.id), o = Wue[i];
  if (o)
    return o.id;
  let s = Wue[i] = au.define({
    id: Bue.length,
    name: r,
    props: [wG({ [r]: n })]
  });
  return Bue.push(s), s.id;
}
hi.RTL, hi.LTR;
class KLe {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(t, n, r, i) {
    this.state = t, this.pos = n, this.explicit = r, this.view = i, this.abortListeners = [], this.abortOnDocChange = !1;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(t) {
    let n = zo(this.state).resolveInner(this.pos, -1);
    for (; n && t.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(t) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), i = n.text.slice(r - n.from, this.pos - n.from), o = i.search(YLe(t, !1));
    return o < 0 ? null : { from: r + o, to: this.pos, text: i.slice(o) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(t, n, r) {
    t == "abort" && this.abortListeners && (this.abortListeners.push(n), r && r.onDocChange && (this.abortOnDocChange = !0));
  }
}
function Zue(e) {
  let t = Object.keys(e).join(""), n = /\w/.test(t);
  return n && (t = t.replace(/\w/g, "")), `[${n ? "\\w" : ""}${t.replace(/[^\w\s]/g, "\\$&")}]`;
}
function N5t(e) {
  let t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of e) {
    t[i[0]] = !0;
    for (let o = 1; o < i.length; o++)
      n[i[o]] = !0;
  }
  let r = Zue(t) + Zue(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function GLe(e) {
  let t = e.map((i) => typeof i == "string" ? { label: i } : i), [n, r] = t.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : N5t(t);
  return (i) => {
    let o = i.matchBefore(r);
    return o || i.explicit ? { from: o ? o.from : i.pos, options: t, validFor: n } : null;
  };
}
function P5t(e, t) {
  return (n) => {
    for (let r = zo(n.state).resolveInner(n.pos, -1); r; r = r.parent) {
      if (e.indexOf(r.name) > -1)
        return null;
      if (r.type.isTop)
        break;
    }
    return t(n);
  };
}
class Hue {
  constructor(t, n, r, i) {
    this.completion = t, this.source = n, this.match = r, this.score = i;
  }
}
function hv(e) {
  return e.selection.main.from;
}
function YLe(e, t) {
  var n;
  let { source: r } = e, i = t && r[0] != "^", o = r[r.length - 1] != "$";
  return !i && !o ? e : new RegExp(`${i ? "^" : ""}(?:${r})${o ? "$" : ""}`, (n = e.flags) !== null && n !== void 0 ? n : e.ignoreCase ? "i" : "");
}
const WG = /* @__PURE__ */ Uf.define();
function I5t(e, t, n, r) {
  let { main: i } = e.selection, o = n - i.from, s = r - i.from;
  return Object.assign(Object.assign({}, e.changeByRange((l) => {
    if (l != i && n != r && e.sliceDoc(l.from + o, l.from + s) != e.sliceDoc(n, r))
      return { range: l };
    let c = e.toText(t);
    return {
      changes: { from: l.from + o, to: r == i.from ? l.to : l.from + s, insert: c },
      range: rt.cursor(l.from + o + c.length)
    };
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const Que = /* @__PURE__ */ new WeakMap();
function R5t(e) {
  if (!Array.isArray(e))
    return e;
  let t = Que.get(e);
  return t || Que.set(e, t = GLe(e)), t;
}
const M_ = /* @__PURE__ */ _n.define(), Ok = /* @__PURE__ */ _n.define();
class M5t {
  constructor(t) {
    this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < t.length; ) {
      let r = el(t, n), i = tf(r);
      this.chars.push(r);
      let o = t.slice(n, n + i), s = o.toUpperCase();
      this.folded.push(el(s == o ? o.toLowerCase() : s, 0)), n += i;
    }
    this.astral = t.length != this.chars.length;
  }
  ret(t, n) {
    return this.score = t, this.matched = n, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(t) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (t.length < this.pattern.length)
      return null;
    let { chars: n, folded: r, any: i, precise: o, byWord: s } = this;
    if (n.length == 1) {
      let A = el(t, 0), w = tf(A), O = w == t.length ? 0 : -100;
      if (A != n[0]) if (A == r[0])
        O += -200;
      else
        return null;
      return this.ret(O, [0, w]);
    }
    let l = t.indexOf(this.pattern);
    if (l == 0)
      return this.ret(t.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let c = n.length, a = 0;
    if (l < 0) {
      for (let A = 0, w = Math.min(t.length, 200); A < w && a < c; ) {
        let O = el(t, A);
        (O == n[a] || O == r[a]) && (i[a++] = A), A += tf(O);
      }
      if (a < c)
        return null;
    }
    let u = 0, f = 0, d = !1, p = 0, h = -1, m = -1, v = /[a-z]/.test(t), b = !0;
    for (let A = 0, w = Math.min(t.length, 200), O = 0; A < w && f < c; ) {
      let x = el(t, A);
      l < 0 && (u < c && x == n[u] && (o[u++] = A), p < c && (x == n[p] || x == r[p] ? (p == 0 && (h = A), m = A + 1, p++) : p = 0));
      let S, E = x < 255 ? x >= 48 && x <= 57 || x >= 97 && x <= 122 ? 2 : x >= 65 && x <= 90 ? 1 : 0 : (S = xG(x)) != S.toLowerCase() ? 1 : S != S.toUpperCase() ? 2 : 0;
      (!A || E == 1 && v || O == 0 && E != 0) && (n[f] == x || r[f] == x && (d = !0) ? s[f++] = A : s.length && (b = !1)), O = E, A += tf(x);
    }
    return f == c && s[0] == 0 && b ? this.result(-100 + (d ? -200 : 0), s, t) : p == c && h == 0 ? this.ret(-200 - t.length + (m == t.length ? 0 : -100), [0, m]) : l > -1 ? this.ret(-700 - t.length, [l, l + this.pattern.length]) : p == c ? this.ret(-900 - t.length, [h, m]) : f == c ? this.result(-100 + (d ? -200 : 0) + -700 + (b ? 0 : -1100), s, t) : n.length == 2 ? null : this.result((i[0] ? -700 : 0) + -200 + -1100, i, t);
  }
  result(t, n, r) {
    let i = [], o = 0;
    for (let s of n) {
      let l = s + (this.astral ? tf(el(r, s)) : 1);
      o && i[o - 1] == s ? i[o - 1] = l : (i[o++] = s, i[o++] = l);
    }
    return this.ret(t - r.length, i);
  }
}
class D5t {
  constructor(t) {
    this.pattern = t, this.matched = [], this.score = 0, this.folded = t.toLowerCase();
  }
  match(t) {
    if (t.length < this.pattern.length)
      return null;
    let n = t.slice(0, this.pattern.length), r = n == this.pattern ? 0 : n.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, n.length], this.score = r + (t.length == this.pattern.length ? 0 : -100), this);
  }
}
const Ko = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: _5t,
      filterStrict: !1,
      compareCompletions: (t, n) => t.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (t, n) => t && n,
      closeOnBlur: (t, n) => t && n,
      icons: (t, n) => t && n,
      tooltipClass: (t, n) => (r) => $ue(t(r), n(r)),
      optionClass: (t, n) => (r) => $ue(t(r), n(r)),
      addToOptions: (t, n) => t.concat(n),
      filterStrict: (t, n) => t || n
    });
  }
});
function $ue(e, t) {
  return e ? t ? e + " " + t : e : t;
}
function _5t(e, t, n, r, i, o) {
  let s = e.textDirection == hi.RTL, l = s, c = !1, a = "top", u, f, d = t.left - i.left, p = i.right - t.right, h = r.right - r.left, m = r.bottom - r.top;
  if (l && d < Math.min(h, p) ? l = !1 : !l && p < Math.min(h, d) && (l = !0), h <= (l ? d : p))
    u = Math.max(i.top, Math.min(n.top, i.bottom - m)) - t.top, f = Math.min(400, l ? d : p);
  else {
    c = !0, f = Math.min(
      400,
      (s ? t.right : i.right - t.left) - 30
      /* Info.Margin */
    );
    let A = i.bottom - t.bottom;
    A >= m || A > t.top ? u = n.bottom - t.top : (a = "bottom", u = t.bottom - n.top);
  }
  let v = (t.bottom - t.top) / o.offsetHeight, b = (t.right - t.left) / o.offsetWidth;
  return {
    style: `${a}: ${u / v}px; max-width: ${f / b}px`,
    class: "cm-completionInfo-" + (c ? s ? "left-narrow" : "right-narrow" : l ? "left" : "right")
  };
}
function L5t(e) {
  let t = e.addToOptions.slice();
  return e.icons && t.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), t.push({
    render(n, r, i, o) {
      let s = document.createElement("span");
      s.className = "cm-completionLabel";
      let l = n.displayLabel || n.label, c = 0;
      for (let a = 0; a < o.length; ) {
        let u = o[a++], f = o[a++];
        u > c && s.appendChild(document.createTextNode(l.slice(c, u)));
        let d = s.appendChild(document.createElement("span"));
        d.appendChild(document.createTextNode(l.slice(u, f))), d.className = "cm-completionMatchedText", c = f;
      }
      return c < l.length && s.appendChild(document.createTextNode(l.slice(c))), s;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), t.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function HU(e, t, n) {
  if (e <= n)
    return { from: 0, to: e };
  if (t < 0 && (t = 0), t <= e >> 1) {
    let i = Math.floor(t / n);
    return { from: i * n, to: (i + 1) * n };
  }
  let r = Math.floor((e - t) / n);
  return { from: e - (r + 1) * n, to: e - r * n };
}
class z5t {
  constructor(t, n, r) {
    this.view = t, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (c) => this.placeInfo(c),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = t.state.field(n), { options: o, selected: s } = i.open, l = t.state.facet(Ko);
    this.optionContent = L5t(l), this.optionClass = l.optionClass, this.tooltipClass = l.tooltipClass, this.range = HU(o.length, s, l.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(t.state), this.dom.addEventListener("mousedown", (c) => {
      let { options: a } = t.state.field(n).open;
      for (let u = c.target, f; u && u != this.dom; u = u.parentNode)
        if (u.nodeName == "LI" && (f = /-(\d+)$/.exec(u.id)) && +f[1] < a.length) {
          this.applyCompletion(t, a[+f[1]]), c.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (c) => {
      let a = t.state.field(this.stateField, !1);
      a && a.tooltip && t.state.facet(Ko).closeOnBlur && c.relatedTarget != t.contentDOM && t.dispatch({ effects: Ok.of(null) });
    }), this.showOptions(o, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(t, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(t, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(t) {
    var n;
    let r = t.state.field(this.stateField), i = t.startState.field(this.stateField);
    if (this.updateTooltipClass(t.state), r != i) {
      let { options: o, selected: s, disabled: l } = r.open;
      (!i.open || i.open.options != o) && (this.range = HU(o.length, s, t.state.facet(Ko).maxRenderedOptions), this.showOptions(o, r.id)), this.updateSel(), l != ((n = i.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!l);
    }
  }
  updateTooltipClass(t) {
    let n = this.tooltipClass(t);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(t) {
    this.space = t, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let t = this.view.state.field(this.stateField), n = t.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = HU(n.options.length, n.selected, this.view.state.facet(Ko).maxRenderedOptions), this.showOptions(n.options, t.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: i } = r;
      if (!i)
        return;
      let o = typeof i == "string" ? document.createTextNode(i) : i(r);
      if (!o)
        return;
      "then" in o ? o.then((s) => {
        s && this.view.state.field(this.stateField, !1) == t && this.addInfoPane(s, r);
      }).catch((s) => ul(this.view.state, s, "completion info")) : this.addInfoPane(o, r);
    }
  }
  addInfoPane(t, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", t.nodeType != null)
      r.appendChild(t), this.infoDestroy = null;
    else {
      let { dom: i, destroy: o } = t;
      r.appendChild(i), this.infoDestroy = o || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(t) {
    let n = null;
    for (let r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      r.nodeName != "LI" || !r.id ? i-- : i == t ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && F5t(this.list, n), n;
  }
  measureInfo() {
    let t = this.dom.querySelector("[aria-selected]");
    if (!t || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = t.getBoundingClientRect(), o = this.space;
    if (!o) {
      let s = this.dom.ownerDocument.documentElement;
      o = { left: 0, top: 0, right: s.clientWidth, bottom: s.clientHeight };
    }
    return i.top > Math.min(o.bottom, n.bottom) - 10 || i.bottom < Math.max(o.top, n.top) + 10 ? null : this.view.state.facet(Ko).positionInfo(this.view, n, i, r, o, this.dom);
  }
  placeInfo(t) {
    this.info && (t ? (t.style && (this.info.style.cssText = t.style), this.info.className = "cm-tooltip cm-completionInfo " + (t.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(t, n, r) {
    const i = document.createElement("ul");
    i.id = n, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions")), i.addEventListener("mousedown", (s) => {
      s.target == i && s.preventDefault();
    });
    let o = null;
    for (let s = r.from; s < r.to; s++) {
      let { completion: l, match: c } = t[s], { section: a } = l;
      if (a) {
        let d = typeof a == "string" ? a : a.name;
        if (d != o && (s > r.from || r.from == 0))
          if (o = d, typeof a != "string" && a.header)
            i.appendChild(a.header(a));
          else {
            let p = i.appendChild(document.createElement("completion-section"));
            p.textContent = d;
          }
      }
      const u = i.appendChild(document.createElement("li"));
      u.id = n + "-" + s, u.setAttribute("role", "option");
      let f = this.optionClass(l);
      f && (u.className = f);
      for (let d of this.optionContent) {
        let p = d(l, this.view.state, this.view, c);
        p && u.appendChild(p);
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < t.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function j5t(e, t) {
  return (n) => new z5t(n, e, t);
}
function F5t(e, t) {
  let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.height / e.offsetHeight;
  r.top < n.top ? e.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / i);
}
function Kue(e) {
  return (e.boost || 0) * 100 + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + (e.type ? 1 : 0);
}
function U5t(e, t) {
  let n = [], r = null, i = (a) => {
    n.push(a);
    let { section: u } = a.completion;
    if (u) {
      r || (r = []);
      let f = typeof u == "string" ? u : u.name;
      r.some((d) => d.name == f) || r.push(typeof u == "string" ? { name: f } : u);
    }
  }, o = t.facet(Ko);
  for (let a of e)
    if (a.hasResult()) {
      let u = a.result.getMatch;
      if (a.result.filter === !1)
        for (let f of a.result.options)
          i(new Hue(f, a.source, u ? u(f) : [], 1e9 - n.length));
      else {
        let f = t.sliceDoc(a.from, a.to), d, p = o.filterStrict ? new D5t(f) : new M5t(f);
        for (let h of a.result.options)
          if (d = p.match(h.label)) {
            let m = h.displayLabel ? u ? u(h, d.matched) : [] : d.matched;
            i(new Hue(h, a.source, m, d.score + (h.boost || 0)));
          }
      }
    }
  if (r) {
    let a = /* @__PURE__ */ Object.create(null), u = 0, f = (d, p) => {
      var h, m;
      return ((h = d.rank) !== null && h !== void 0 ? h : 1e9) - ((m = p.rank) !== null && m !== void 0 ? m : 1e9) || (d.name < p.name ? -1 : 1);
    };
    for (let d of r.sort(f))
      u -= 1e5, a[d.name] = u;
    for (let d of n) {
      let { section: p } = d.completion;
      p && (d.score += a[typeof p == "string" ? p : p.name]);
    }
  }
  let s = [], l = null, c = o.compareCompletions;
  for (let a of n.sort((u, f) => f.score - u.score || c(u.completion, f.completion))) {
    let u = a.completion;
    !l || l.label != u.label || l.detail != u.detail || l.type != null && u.type != null && l.type != u.type || l.apply != u.apply || l.boost != u.boost ? s.push(a) : Kue(a.completion) > Kue(l) && (s[s.length - 1] = a), l = a.completion;
  }
  return s;
}
class CO {
  constructor(t, n, r, i, o, s) {
    this.options = t, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = o, this.disabled = s;
  }
  setSelected(t, n) {
    return t == this.selected || t >= this.options.length ? this : new CO(this.options, Gue(n, t), this.tooltip, this.timestamp, t, this.disabled);
  }
  static build(t, n, r, i, o, s) {
    if (i && !s && t.some((a) => a.isPending))
      return i.setDisabled();
    let l = U5t(t, n);
    if (!l.length)
      return i && t.some((a) => a.isPending) ? i.setDisabled() : null;
    let c = n.facet(Ko).selectOnOpen ? 0 : -1;
    if (i && i.selected != c && i.selected != -1) {
      let a = i.options[i.selected].completion;
      for (let u = 0; u < l.length; u++)
        if (l[u].completion == a) {
          c = u;
          break;
        }
    }
    return new CO(l, Gue(r, c), {
      pos: t.reduce((a, u) => u.hasResult() ? Math.min(a, u.from) : a, 1e8),
      create: Z5t,
      above: o.aboveCursor
    }, i ? i.timestamp : Date.now(), c, !1);
  }
  map(t) {
    return new CO(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: t.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new CO(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
  }
}
class D_ {
  constructor(t, n, r) {
    this.active = t, this.id = n, this.open = r;
  }
  static start() {
    return new D_(X5t, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(t) {
    let { state: n } = t, r = n.facet(Ko), o = (r.override || n.languageDataAt("autocomplete", hv(n)).map(R5t)).map((c) => (this.active.find((u) => u.source == c) || new Wc(
      c,
      this.active.some(
        (u) => u.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(t, r));
    o.length == this.active.length && o.every((c, a) => c == this.active[a]) && (o = this.active);
    let s = this.open, l = t.effects.some((c) => c.is(ZG));
    s && t.docChanged && (s = s.map(t.changes)), t.selection || o.some((c) => c.hasResult() && t.changes.touchesRange(c.from, c.to)) || !V5t(o, this.active) || l ? s = CO.build(o, n, this.id, s, r, l) : s && s.disabled && !o.some((c) => c.isPending) && (s = null), !s && o.every((c) => !c.isPending) && o.some((c) => c.hasResult()) && (o = o.map((c) => c.hasResult() ? new Wc(
      c.source,
      0
      /* State.Inactive */
    ) : c));
    for (let c of t.effects)
      c.is(e2e) && (s = s && s.setSelected(c.value, this.id));
    return o == this.active && s == this.open ? this : new D_(o, this.id, s);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? q5t : B5t;
  }
}
function V5t(e, t) {
  if (e == t)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < e.length && !e[n].hasResult(); )
      n++;
    for (; r < t.length && !t[r].hasResult(); )
      r++;
    let i = n == e.length, o = r == t.length;
    if (i || o)
      return i == o;
    if (e[n++].result != t[r++].result)
      return !1;
  }
}
const q5t = {
  "aria-autocomplete": "list"
}, B5t = {};
function Gue(e, t) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": e
  };
  return t > -1 && (n["aria-activedescendant"] = e + "-" + t), n;
}
const X5t = [];
function JLe(e, t) {
  if (e.isUserEvent("input.complete")) {
    let r = e.annotation(WG);
    if (r && t.activateOnCompletion(r))
      return 12;
  }
  let n = e.isUserEvent("input.type");
  return n && t.activateOnTyping ? 5 : n ? 1 : e.isUserEvent("delete.backward") ? 2 : e.selection ? 8 : e.docChanged ? 16 : 0;
}
class Wc {
  constructor(t, n, r = !1) {
    this.source = t, this.state = n, this.explicit = r;
  }
  hasResult() {
    return !1;
  }
  get isPending() {
    return this.state == 1;
  }
  update(t, n) {
    let r = JLe(t, n), i = this;
    (r & 8 || r & 16 && this.touches(t)) && (i = new Wc(
      i.source,
      0
      /* State.Inactive */
    )), r & 4 && i.state == 0 && (i = new Wc(
      this.source,
      1
      /* State.Pending */
    )), i = i.updateFor(t, r);
    for (let o of t.effects)
      if (o.is(M_))
        i = new Wc(i.source, 1, o.value);
      else if (o.is(Ok))
        i = new Wc(
          i.source,
          0
          /* State.Inactive */
        );
      else if (o.is(ZG))
        for (let s of o.value)
          s.source == i.source && (i = s);
    return i;
  }
  updateFor(t, n) {
    return this.map(t.changes);
  }
  map(t) {
    return this;
  }
  touches(t) {
    return t.changes.touchesRange(hv(t.state));
  }
}
class iA extends Wc {
  constructor(t, n, r, i, o, s) {
    super(t, 3, n), this.limit = r, this.result = i, this.from = o, this.to = s;
  }
  hasResult() {
    return !0;
  }
  updateFor(t, n) {
    var r;
    if (!(n & 3))
      return this.map(t.changes);
    let i = this.result;
    i.map && !t.changes.empty && (i = i.map(i, t.changes));
    let o = t.changes.mapPos(this.from), s = t.changes.mapPos(this.to, 1), l = hv(t.state);
    if (l > s || !i || n & 2 && (hv(t.startState) == this.from || l < this.limit))
      return new Wc(
        this.source,
        n & 4 ? 1 : 0
        /* State.Inactive */
      );
    let c = t.changes.mapPos(this.limit);
    return W5t(i.validFor, t.state, o, s) ? new iA(this.source, this.explicit, c, i, o, s) : i.update && (i = i.update(i, o, s, new KLe(t.state, l, !1))) ? new iA(this.source, this.explicit, c, i, i.from, (r = i.to) !== null && r !== void 0 ? r : hv(t.state)) : new Wc(this.source, 1, this.explicit);
  }
  map(t) {
    return t.empty ? this : (this.result.map ? this.result.map(this.result, t) : this.result) ? new iA(this.source, this.explicit, t.mapPos(this.limit), this.result, t.mapPos(this.from), t.mapPos(this.to, 1)) : new Wc(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(t) {
    return t.changes.touchesRange(this.from, this.to);
  }
}
function W5t(e, t, n, r) {
  if (!e)
    return !1;
  let i = t.sliceDoc(n, r);
  return typeof e == "function" ? e(i, n, r, t) : YLe(e, !0).test(i);
}
const ZG = /* @__PURE__ */ _n.define({
  map(e, t) {
    return e.map((n) => n.map(t));
  }
}), e2e = /* @__PURE__ */ _n.define(), nl = /* @__PURE__ */ cs.define({
  create() {
    return D_.start();
  },
  update(e, t) {
    return e.update(t);
  },
  provide: (e) => [
    jG.from(e, (t) => t.tooltip),
    kt.contentAttributes.from(e, (t) => t.attrs)
  ]
});
function HG(e, t) {
  const n = t.completion.apply || t.completion.label;
  let r = e.state.field(nl).active.find((i) => i.source == t.source);
  return r instanceof iA ? (typeof n == "string" ? e.dispatch(Object.assign(Object.assign({}, I5t(e.state, n, r.from, r.to)), { annotations: WG.of(t.completion) })) : n(e, t.completion, r.from, r.to), !0) : !1;
}
const Z5t = /* @__PURE__ */ j5t(nl, HG);
function FI(e, t = "option") {
  return (n) => {
    let r = n.state.field(nl, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(Ko).interactionDelay)
      return !1;
    let i = 1, o;
    t == "page" && (o = NLe(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(o.dom.offsetHeight / o.dom.querySelector("li").offsetHeight) - 1));
    let { length: s } = r.open.options, l = r.open.selected > -1 ? r.open.selected + i * (e ? 1 : -1) : e ? 0 : s - 1;
    return l < 0 ? l = t == "page" ? 0 : s - 1 : l >= s && (l = t == "page" ? s - 1 : 0), n.dispatch({ effects: e2e.of(l) }), !0;
  };
}
const H5t = (e) => {
  let t = e.state.field(nl, !1);
  return e.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < e.state.facet(Ko).interactionDelay ? !1 : HG(e, t.open.options[t.open.selected]);
}, Yue = (e) => e.state.field(nl, !1) ? (e.dispatch({ effects: M_.of(!0) }), !0) : !1, Q5t = (e) => {
  let t = e.state.field(nl, !1);
  return !t || !t.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (e.dispatch({ effects: Ok.of(null) }), !0);
};
class $5t {
  constructor(t, n) {
    this.active = t, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const K5t = 50, G5t = 1e3, Y5t = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.view = e, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let t of e.state.field(nl).active)
      t.isPending && this.startQuery(t);
  }
  update(e) {
    let t = e.state.field(nl), n = e.state.facet(Ko);
    if (!e.selectionSet && !e.docChanged && e.startState.field(nl) == t)
      return;
    let r = e.transactions.some((o) => {
      let s = JLe(o, n);
      return s & 8 || (o.selection || o.docChanged) && !(s & 3);
    });
    for (let o = 0; o < this.running.length; o++) {
      let s = this.running[o];
      if (r || s.context.abortOnDocChange && e.docChanged || s.updates.length + e.transactions.length > K5t && Date.now() - s.time > G5t) {
        for (let l of s.context.abortListeners)
          try {
            l();
          } catch (c) {
            ul(this.view.state, c);
          }
        s.context.abortListeners = null, this.running.splice(o--, 1);
      } else
        s.updates.push(...e.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), e.transactions.some((o) => o.effects.some((s) => s.is(M_))) && (this.pendingStart = !0);
    let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
    if (this.debounceUpdate = t.active.some((o) => o.isPending && !this.running.some((s) => s.active.source == o.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0)
      for (let o of e.transactions)
        o.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && o.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: e } = this.view, t = e.field(nl);
    for (let n of t.active)
      n.isPending && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
    this.running.length && t.open && t.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Ko).updateSyncTime));
  }
  startQuery(e) {
    let { state: t } = this.view, n = hv(t), r = new KLe(t, n, e.explicit, this.view), i = new $5t(e, r);
    this.running.push(i), Promise.resolve(e.source(r)).then((o) => {
      i.context.aborted || (i.done = o || null, this.scheduleAccept());
    }, (o) => {
      this.view.dispatch({ effects: Ok.of(null) }), ul(this.view.state, o);
    });
  }
  scheduleAccept() {
    this.running.every((e) => e.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Ko).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var e;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let t = [], n = this.view.state.facet(Ko), r = this.view.state.field(nl);
    for (let i = 0; i < this.running.length; i++) {
      let o = this.running[i];
      if (o.done === void 0)
        continue;
      if (this.running.splice(i--, 1), o.done) {
        let l = hv(o.updates.length ? o.updates[0].startState : this.view.state), c = Math.min(l, o.done.from + (o.active.explicit ? 0 : 1)), a = new iA(o.active.source, o.active.explicit, c, o.done, o.done.from, (e = o.done.to) !== null && e !== void 0 ? e : l);
        for (let u of o.updates)
          a = a.update(u, n);
        if (a.hasResult()) {
          t.push(a);
          continue;
        }
      }
      let s = r.active.find((l) => l.source == o.active.source);
      if (s && s.isPending)
        if (o.done == null) {
          let l = new Wc(
            o.active.source,
            0
            /* State.Inactive */
          );
          for (let c of o.updates)
            l = l.update(c, n);
          l.isPending || t.push(l);
        } else
          this.startQuery(s);
    }
    (t.length || r.open && r.open.disabled) && this.view.dispatch({ effects: ZG.of(t) });
  }
}, {
  eventHandlers: {
    blur(e) {
      let t = this.view.state.field(nl, !1);
      if (t && t.tooltip && this.view.state.facet(Ko).closeOnBlur) {
        let n = t.open && NLe(this.view, t.open.tooltip);
        (!n || !n.dom.contains(e.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: Ok.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: M_.of(!1) }), 20), this.composing = 0;
    }
  }
}), J5t = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), e6t = /* @__PURE__ */ Dg.highest(/* @__PURE__ */ kt.domEventHandlers({
  keydown(e, t) {
    let n = t.state.field(nl, !1);
    if (!n || !n.open || n.open.disabled || n.open.selected < 0 || e.key.length > 1 || e.ctrlKey && !(J5t && e.altKey) || e.metaKey)
      return !1;
    let r = n.open.options[n.open.selected], i = n.active.find((s) => s.source == r.source), o = r.completion.commitCharacters || i.result.commitCharacters;
    return o && o.indexOf(e.key) > -1 && HG(t, r), !1;
  }
})), t2e = /* @__PURE__ */ kt.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class t6t {
  constructor(t, n, r, i) {
    this.field = t, this.line = n, this.from = r, this.to = i;
  }
}
class QG {
  constructor(t, n, r) {
    this.field = t, this.from = n, this.to = r;
  }
  map(t) {
    let n = t.mapPos(this.from, -1, Os.TrackDel), r = t.mapPos(this.to, 1, Os.TrackDel);
    return n == null || r == null ? null : new QG(this.field, n, r);
  }
}
class $G {
  constructor(t, n) {
    this.lines = t, this.fieldPositions = n;
  }
  instantiate(t, n) {
    let r = [], i = [n], o = t.doc.lineAt(n), s = /^\s*/.exec(o.text)[0];
    for (let c of this.lines) {
      if (r.length) {
        let a = s, u = /^\t*/.exec(c)[0].length;
        for (let f = 0; f < u; f++)
          a += t.facet(PN);
        i.push(n + a.length - u), c = a + c.slice(u);
      }
      r.push(c), n += c.length + 1;
    }
    let l = this.fieldPositions.map((c) => new QG(c.field, i[c.line] + c.from, i[c.line] + c.to));
    return { text: r, ranges: l };
  }
  static parse(t) {
    let n = [], r = [], i = [], o;
    for (let s of t.split(/\r\n?|\n/)) {
      for (; o = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(s); ) {
        let l = o[1] ? +o[1] : null, c = o[2] || o[3] || "", a = -1, u = c.replace(/\\[{}]/g, (f) => f[1]);
        for (let f = 0; f < n.length; f++)
          (l != null ? n[f].seq == l : u && n[f].name == u) && (a = f);
        if (a < 0) {
          let f = 0;
          for (; f < n.length && (l == null || n[f].seq != null && n[f].seq < l); )
            f++;
          n.splice(f, 0, { seq: l, name: u }), a = f;
          for (let d of i)
            d.field >= a && d.field++;
        }
        i.push(new t6t(a, r.length, o.index, o.index + u.length)), s = s.slice(0, o.index) + c + s.slice(o.index + o[0].length);
      }
      s = s.replace(/\\([{}])/g, (l, c, a) => {
        for (let u of i)
          u.line == r.length && u.from > a && (u.from--, u.to--);
        return c;
      }), r.push(s);
    }
    return new $G(r, i);
  }
}
let n6t = /* @__PURE__ */ ln.widget({ widget: /* @__PURE__ */ new class extends qf {
  toDOM() {
    let e = document.createElement("span");
    return e.className = "cm-snippetFieldPosition", e;
  }
  ignoreEvent() {
    return !1;
  }
}() }), r6t = /* @__PURE__ */ ln.mark({ class: "cm-snippetField" });
class Px {
  constructor(t, n) {
    this.ranges = t, this.active = n, this.deco = ln.set(t.map((r) => (r.from == r.to ? n6t : r6t).range(r.from, r.to)));
  }
  map(t) {
    let n = [];
    for (let r of this.ranges) {
      let i = r.map(t);
      if (!i)
        return null;
      n.push(i);
    }
    return new Px(n, this.active);
  }
  selectionInsideField(t) {
    return t.ranges.every((n) => this.ranges.some((r) => r.field == this.active && r.from <= n.from && r.to >= n.to));
  }
}
const RN = /* @__PURE__ */ _n.define({
  map(e, t) {
    return e && e.map(t);
  }
}), i6t = /* @__PURE__ */ _n.define(), Ak = /* @__PURE__ */ cs.define({
  create() {
    return null;
  },
  update(e, t) {
    for (let n of t.effects) {
      if (n.is(RN))
        return n.value;
      if (n.is(i6t) && e)
        return new Px(e.ranges, n.value);
    }
    return e && t.docChanged && (e = e.map(t.changes)), e && t.selection && !e.selectionInsideField(t.selection) && (e = null), e;
  },
  provide: (e) => kt.decorations.from(e, (t) => t ? t.deco : ln.none)
});
function KG(e, t) {
  return rt.create(e.filter((n) => n.field == t).map((n) => rt.range(n.from, n.to)));
}
function o6t(e) {
  let t = $G.parse(e);
  return (n, r, i, o) => {
    let { text: s, ranges: l } = t.instantiate(n.state, i), { main: c } = n.state.selection, a = {
      changes: { from: i, to: o == c.from ? c.to : o, insert: Sr.of(s) },
      scrollIntoView: !0,
      annotations: r ? [WG.of(r), Pa.userEvent.of("input.complete")] : void 0
    };
    if (l.length && (a.selection = KG(l, 0)), l.some((u) => u.field > 0)) {
      let u = new Px(l, 0), f = a.effects = [RN.of(u)];
      n.state.field(Ak, !1) === void 0 && f.push(_n.appendConfig.of([Ak, u6t, d6t, t2e]));
    }
    n.dispatch(n.state.update(a));
  };
}
function n2e(e) {
  return ({ state: t, dispatch: n }) => {
    let r = t.field(Ak, !1);
    if (!r || e < 0 && r.active == 0)
      return !1;
    let i = r.active + e, o = e > 0 && !r.ranges.some((s) => s.field == i + e);
    return n(t.update({
      selection: KG(r.ranges, i),
      effects: RN.of(o ? null : new Px(r.ranges, i)),
      scrollIntoView: !0
    })), !0;
  };
}
const s6t = ({ state: e, dispatch: t }) => e.field(Ak, !1) ? (t(e.update({ effects: RN.of(null) })), !0) : !1, a6t = /* @__PURE__ */ n2e(1), l6t = /* @__PURE__ */ n2e(-1), c6t = [
  { key: "Tab", run: a6t, shift: l6t },
  { key: "Escape", run: s6t }
], Jue = /* @__PURE__ */ Ht.define({
  combine(e) {
    return e.length ? e[0] : c6t;
  }
}), u6t = /* @__PURE__ */ Dg.highest(/* @__PURE__ */ CN.compute([Jue], (e) => e.facet(Jue)));
function Ha(e, t) {
  return Object.assign(Object.assign({}, t), { apply: o6t(e) });
}
const d6t = /* @__PURE__ */ kt.domEventHandlers({
  mousedown(e, t) {
    let n = t.state.field(Ak, !1), r;
    if (!n || (r = t.posAtCoords({ x: e.clientX, y: e.clientY })) == null)
      return !1;
    let i = n.ranges.find((o) => o.from <= r && o.to >= r);
    return !i || i.field == n.active ? !1 : (t.dispatch({
      selection: KG(n.ranges, i.field),
      effects: RN.of(n.ranges.some((o) => o.field > i.field) ? new Px(n.ranges, i.field) : null),
      scrollIntoView: !0
    }), !0);
  }
}), wk = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, Ry = /* @__PURE__ */ _n.define({
  map(e, t) {
    let n = t.mapPos(e, -1, Os.TrackAfter);
    return n ?? void 0;
  }
}), GG = /* @__PURE__ */ new class extends Qv {
}();
GG.startSide = 1;
GG.endSide = -1;
const r2e = /* @__PURE__ */ cs.define({
  create() {
    return xr.empty;
  },
  update(e, t) {
    if (e = e.map(t.changes), t.selection) {
      let n = t.state.doc.lineAt(t.selection.main.head);
      e = e.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of t.effects)
      n.is(Ry) && (e = e.update({ add: [GG.range(n.value, n.value + 1)] }));
    return e;
  }
});
function f6t() {
  return [h6t, r2e];
}
const QU = "()[]{}<>«»»«［］｛｝";
function i2e(e) {
  for (let t = 0; t < QU.length; t += 2)
    if (QU.charCodeAt(t) == e)
      return QU.charAt(t + 1);
  return xG(e < 128 ? e : e + 1);
}
function o2e(e, t) {
  return e.languageDataAt("closeBrackets", t)[0] || wk;
}
const p6t = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), h6t = /* @__PURE__ */ kt.inputHandler.of((e, t, n, r) => {
  if ((p6t ? e.composing : e.compositionStarted) || e.state.readOnly)
    return !1;
  let i = e.state.selection.main;
  if (r.length > 2 || r.length == 2 && tf(el(r, 0)) == 1 || t != i.from || n != i.to)
    return !1;
  let o = y6t(e.state, r);
  return o ? (e.dispatch(o), !0) : !1;
}), m6t = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let r = o2e(e, e.selection.main.head).brackets || wk.brackets, i = null, o = e.changeByRange((s) => {
    if (s.empty) {
      let l = v6t(e.doc, s.head);
      for (let c of r)
        if (c == l && Yj(e.doc, s.head) == i2e(el(c, 0)))
          return {
            changes: { from: s.head - c.length, to: s.head + c.length },
            range: rt.cursor(s.head - c.length)
          };
    }
    return { range: i = s };
  });
  return i || t(e.update(o, { scrollIntoView: !0, userEvent: "delete.backward" })), !i;
}, g6t = [
  { key: "Backspace", run: m6t }
];
function y6t(e, t) {
  let n = o2e(e, e.selection.main.head), r = n.brackets || wk.brackets;
  for (let i of r) {
    let o = i2e(el(i, 0));
    if (t == i)
      return o == i ? A6t(e, i, r.indexOf(i + i + i) > -1, n) : b6t(e, i, o, n.before || wk.before);
    if (t == o && s2e(e, e.selection.main.from))
      return O6t(e, i, o);
  }
  return null;
}
function s2e(e, t) {
  let n = !1;
  return e.field(r2e).between(0, e.doc.length, (r) => {
    r == t && (n = !0);
  }), n;
}
function Yj(e, t) {
  let n = e.sliceString(t, t + 2);
  return n.slice(0, tf(el(n, 0)));
}
function v6t(e, t) {
  let n = e.sliceString(t - 2, t);
  return tf(el(n, 0)) == n.length ? n : n.slice(1);
}
function b6t(e, t, n, r) {
  let i = null, o = e.changeByRange((s) => {
    if (!s.empty)
      return {
        changes: [{ insert: t, from: s.from }, { insert: n, from: s.to }],
        effects: Ry.of(s.to + t.length),
        range: rt.range(s.anchor + t.length, s.head + t.length)
      };
    let l = Yj(e.doc, s.head);
    return !l || /\s/.test(l) || r.indexOf(l) > -1 ? {
      changes: { insert: t + n, from: s.head },
      effects: Ry.of(s.head + t.length),
      range: rt.cursor(s.head + t.length)
    } : { range: i = s };
  });
  return i ? null : e.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function O6t(e, t, n) {
  let r = null, i = e.changeByRange((o) => o.empty && Yj(e.doc, o.head) == n ? {
    changes: { from: o.head, to: o.head + n.length, insert: n },
    range: rt.cursor(o.head + n.length)
  } : r = { range: o });
  return r ? null : e.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function A6t(e, t, n, r) {
  let i = r.stringPrefixes || wk.stringPrefixes, o = null, s = e.changeByRange((l) => {
    if (!l.empty)
      return {
        changes: [{ insert: t, from: l.from }, { insert: t, from: l.to }],
        effects: Ry.of(l.to + t.length),
        range: rt.range(l.anchor + t.length, l.head + t.length)
      };
    let c = l.head, a = Yj(e.doc, c), u;
    if (a == t) {
      if (ede(e, c))
        return {
          changes: { insert: t + t, from: c },
          effects: Ry.of(c + t.length),
          range: rt.cursor(c + t.length)
        };
      if (s2e(e, c)) {
        let d = n && e.sliceDoc(c, c + t.length * 3) == t + t + t ? t + t + t : t;
        return {
          changes: { from: c, to: c + d.length, insert: d },
          range: rt.cursor(c + d.length)
        };
      }
    } else {
      if (n && e.sliceDoc(c - 2 * t.length, c) == t + t && (u = tde(e, c - 2 * t.length, i)) > -1 && ede(e, u))
        return {
          changes: { insert: t + t + t + t, from: c },
          effects: Ry.of(c + t.length),
          range: rt.cursor(c + t.length)
        };
      if (e.charCategorizer(c)(a) != Oi.Word && tde(e, c, i) > -1 && !w6t(e, c, t, i))
        return {
          changes: { insert: t + t, from: c },
          effects: Ry.of(c + t.length),
          range: rt.cursor(c + t.length)
        };
    }
    return { range: o = l };
  });
  return o ? null : e.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function ede(e, t) {
  let n = zo(e).resolveInner(t + 1);
  return n.parent && n.from == t;
}
function w6t(e, t, n, r) {
  let i = zo(e).resolveInner(t, -1), o = r.reduce((s, l) => Math.max(s, l.length), 0);
  for (let s = 0; s < 5; s++) {
    let l = e.sliceDoc(i.from, Math.min(i.to, i.from + n.length + o)), c = l.indexOf(n);
    if (!c || c > -1 && r.indexOf(l.slice(0, c)) > -1) {
      let u = i.firstChild;
      for (; u && u.from == i.from && u.to - u.from > n.length + c; ) {
        if (e.sliceDoc(u.to - n.length, u.to) == n)
          return !1;
        u = u.firstChild;
      }
      return !0;
    }
    let a = i.to == t && i.parent;
    if (!a)
      break;
    i = a;
  }
  return !1;
}
function tde(e, t, n) {
  let r = e.charCategorizer(t);
  if (r(e.sliceDoc(t - 1, t)) != Oi.Word)
    return t;
  for (let i of n) {
    let o = t - i.length;
    if (e.sliceDoc(o, t) == i && r(e.sliceDoc(o - 1, o)) != Oi.Word)
      return o;
  }
  return -1;
}
function x6t(e = {}) {
  return [
    e6t,
    nl,
    Ko.of(e),
    Y5t,
    S6t,
    t2e
  ];
}
const a2e = [
  { key: "Ctrl-Space", run: Yue },
  { mac: "Alt-`", run: Yue },
  { key: "Escape", run: Q5t },
  { key: "ArrowDown", run: /* @__PURE__ */ FI(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ FI(!1) },
  { key: "PageDown", run: /* @__PURE__ */ FI(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ FI(!1, "page") },
  { key: "Enter", run: H5t }
], S6t = /* @__PURE__ */ Dg.highest(/* @__PURE__ */ CN.computeN([Ko], (e) => e.facet(Ko).defaultKeymap ? [a2e] : [])), l2e = [
  /* @__PURE__ */ Ha("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha(`try {
	\${}
} catch (\${error}) {
	\${}
}`, {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha(`if (\${}) {
	\${}
} else {
	\${}
}`, {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha(`class \${name} {
	constructor(\${params}) {
		\${}
	}
}`, {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
], E6t = /* @__PURE__ */ l2e.concat([
  /* @__PURE__ */ Ha("interface ${name} {\n	${}\n}", {
    label: "interface",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("type ${name} = ${type}", {
    label: "type",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ Ha("enum ${name} {\n	${}\n}", {
    label: "enum",
    detail: "definition",
    type: "keyword"
  })
]), nde = /* @__PURE__ */ new Z2t(), c2e = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function AS(e) {
  return (t, n) => {
    let r = t.node.getChild("VariableDefinition");
    return r && n(r, e), !0;
  };
}
const T6t = ["FunctionDeclaration"], k6t = {
  FunctionDeclaration: /* @__PURE__ */ AS("function"),
  ClassDeclaration: /* @__PURE__ */ AS("class"),
  ClassExpression: () => !0,
  EnumDeclaration: /* @__PURE__ */ AS("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ AS("type"),
  NamespaceDeclaration: /* @__PURE__ */ AS("namespace"),
  VariableDefinition(e, t) {
    e.matchContext(T6t) || t(e, "variable");
  },
  TypeDefinition(e, t) {
    t(e, "type");
  },
  __proto__: null
};
function u2e(e, t) {
  let n = nde.get(t);
  if (n)
    return n;
  let r = [], i = !0;
  function o(s, l) {
    let c = e.sliceString(s.from, s.to);
    r.push({ label: c, type: l });
  }
  return t.cursor(Do.IncludeAnonymous).iterate((s) => {
    if (i)
      i = !1;
    else if (s.name) {
      let l = k6t[s.name];
      if (l && l(s, o) || c2e.has(s.name))
        return !1;
    } else if (s.to - s.from > 8192) {
      for (let l of u2e(e, s.node))
        r.push(l);
      return !1;
    }
  }), nde.set(t, r), r;
}
const rde = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, d2e = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function C6t(e) {
  let t = zo(e.state).resolveInner(e.pos, -1);
  if (d2e.indexOf(t.name) > -1)
    return null;
  let n = t.name == "VariableName" || t.to - t.from < 20 && rde.test(e.state.sliceDoc(t.from, t.to));
  if (!n && !e.explicit)
    return null;
  let r = [];
  for (let i = t; i; i = i.parent)
    c2e.has(i.name) && (r = r.concat(u2e(e.state.doc, i)));
  return {
    options: r,
    from: n ? t.from : e.pos,
    validFor: rde
  };
}
const mv = /* @__PURE__ */ vk.define({
  name: "javascript",
  parser: /* @__PURE__ */ Vzt.configure({
    props: [
      /* @__PURE__ */ VG.add({
        IfStatement: /* @__PURE__ */ UE({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ UE({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: KFt,
        SwitchBody: (e) => {
          let t = e.textAfter, n = /^\s*\}/.test(t), r = /^\s*(case|default)\b/.test(t);
          return e.baseIndent + (n ? 0 : r ? 1 : 2) * e.unit;
        },
        Block: /* @__PURE__ */ $Ft({ closing: "}" }),
        ArrowFunction: (e) => e.baseIndent + e.unit,
        "TemplateString BlockComment": () => null,
        "Statement Property": /* @__PURE__ */ UE({ except: /^{/ }),
        JSXElement(e) {
          let t = /^\s*<\//.test(e.textAfter);
          return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
        },
        JSXEscape(e) {
          let t = /\s*\}/.test(e.textAfter);
          return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(e) {
          return e.column(e.node.from) + e.unit;
        }
      }),
      /* @__PURE__ */ BG.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": jLe,
        BlockComment(e) {
          return { from: e.from + 2, to: e.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
}), f2e = {
  test: (e) => /^JSX/.test(e.name),
  facet: /* @__PURE__ */ MLe({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
}, N6t = /* @__PURE__ */ mv.configure({ dialect: "ts" }, "typescript"), P6t = /* @__PURE__ */ mv.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ FG.add((e) => e.isTop ? [f2e] : void 0)]
}), I6t = /* @__PURE__ */ mv.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ FG.add((e) => e.isTop ? [f2e] : void 0)]
}, "typescript");
let p2e = (e) => ({ label: e, type: "keyword" });
const h2e = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(p2e), R6t = /* @__PURE__ */ h2e.concat(/* @__PURE__ */ ["declare", "implements", "private", "protected", "public"].map(p2e));
function m2e(e = {}) {
  let t = e.jsx ? e.typescript ? I6t : P6t : e.typescript ? N6t : mv, n = e.typescript ? E6t.concat(R6t) : l2e.concat(h2e);
  return new _Le(t, [
    mv.data.of({
      autocomplete: P5t(d2e, GLe(n))
    }),
    mv.data.of({
      autocomplete: C6t
    }),
    e.jsx ? _6t : []
  ]);
}
function M6t(e) {
  for (; ; ) {
    if (e.name == "JSXOpenTag" || e.name == "JSXSelfClosingTag" || e.name == "JSXFragmentTag")
      return e;
    if (e.name == "JSXEscape" || !e.parent)
      return null;
    e = e.parent;
  }
}
function ide(e, t, n = e.length) {
  for (let r = t == null ? void 0 : t.firstChild; r; r = r.nextSibling)
    if (r.name == "JSXIdentifier" || r.name == "JSXBuiltin" || r.name == "JSXNamespacedName" || r.name == "JSXMemberExpression")
      return e.sliceString(r.from, Math.min(r.to, n));
  return "";
}
const D6t = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), _6t = /* @__PURE__ */ kt.inputHandler.of((e, t, n, r, i) => {
  if ((D6t ? e.composing : e.compositionStarted) || e.state.readOnly || t != n || r != ">" && r != "/" || !mv.isActiveAt(e.state, t, -1))
    return !1;
  let o = i(), { state: s } = o, l = s.changeByRange((c) => {
    var a;
    let { head: u } = c, f = zo(s).resolveInner(u - 1, -1), d;
    if (f.name == "JSXStartTag" && (f = f.parent), !(s.doc.sliceString(u - 1, u) != r || f.name == "JSXAttributeValue" && f.to > u)) {
      if (r == ">" && f.name == "JSXFragmentTag")
        return { range: c, changes: { from: u, insert: "</>" } };
      if (r == "/" && f.name == "JSXStartCloseTag") {
        let p = f.parent, h = p.parent;
        if (h && p.from == u - 2 && ((d = ide(s.doc, h.firstChild, u)) || ((a = h.firstChild) === null || a === void 0 ? void 0 : a.name) == "JSXFragmentTag")) {
          let m = `${d}>`;
          return { range: rt.cursor(u + m.length, -1), changes: { from: u, insert: m } };
        }
      } else if (r == ">") {
        let p = M6t(f);
        if (p && p.name == "JSXOpenTag" && !/^\/?>|^<\//.test(s.doc.sliceString(u, u + 2)) && (d = ide(s.doc, p, u)))
          return { range: c, changes: { from: u, insert: `</${d}>` } };
      }
    }
    return { range: c };
  });
  return l.changes.empty ? !1 : (e.dispatch([
    o,
    s.update(l, { userEvent: "input.complete", scrollIntoView: !0 })
  ]), !0);
});
var g2e = (e) => {
  var {
    theme: t,
    settings: n = {},
    styles: r = []
  } = e, i = {
    ".cm-gutters": {}
  }, o = {};
  n.background && (o.backgroundColor = n.background), n.backgroundImage && (o.backgroundImage = n.backgroundImage), n.foreground && (o.color = n.foreground), n.fontSize && (o.fontSize = n.fontSize), (n.background || n.foreground) && (i["&"] = o), n.fontFamily && (i["&.cm-editor .cm-scroller"] = {
    fontFamily: n.fontFamily
  }), n.gutterBackground && (i[".cm-gutters"].backgroundColor = n.gutterBackground), n.gutterForeground && (i[".cm-gutters"].color = n.gutterForeground), n.gutterBorder && (i[".cm-gutters"].borderRightColor = n.gutterBorder), n.caret && (i[".cm-content"] = {
    caretColor: n.caret
  }, i[".cm-cursor, .cm-dropCursor"] = {
    borderLeftColor: n.caret
  });
  var s = {};
  n.gutterActiveForeground && (s.color = n.gutterActiveForeground), n.lineHighlight && (i[".cm-activeLine"] = {
    backgroundColor: n.lineHighlight
  }, s.backgroundColor = n.lineHighlight), i[".cm-activeLineGutter"] = s, n.selection && (i["&.cm-focused .cm-selectionBackground, & .cm-line::selection, & .cm-selectionLayer .cm-selectionBackground, .cm-content ::selection"] = {
    background: n.selection + " !important"
  }), n.selectionMatch && (i["& .cm-selectionMatch"] = {
    backgroundColor: n.selectionMatch
  });
  var l = kt.theme(i, {
    dark: t === "dark"
  }), c = Nx.define(r), a = [l, XG(c)];
  return a;
}, L6t = {
  background: "#fff",
  foreground: "#24292e",
  selection: "#BBDFFF",
  selectionMatch: "#BBDFFF",
  gutterBackground: "#fff",
  gutterForeground: "#6e7781"
}, z6t = [{
  tag: [ke.standard(ke.tagName), ke.tagName],
  color: "#116329"
}, {
  tag: [ke.comment, ke.bracket],
  color: "#6a737d"
}, {
  tag: [ke.className, ke.propertyName],
  color: "#6f42c1"
}, {
  tag: [ke.variableName, ke.attributeName, ke.number, ke.operator],
  color: "#005cc5"
}, {
  tag: [ke.keyword, ke.typeName, ke.typeOperator, ke.typeName],
  color: "#d73a49"
}, {
  tag: [ke.string, ke.meta, ke.regexp],
  color: "#032f62"
}, {
  tag: [ke.name, ke.quote],
  color: "#22863a"
}, {
  tag: [ke.heading, ke.strong],
  color: "#24292e",
  fontWeight: "bold"
}, {
  tag: [ke.emphasis],
  color: "#24292e",
  fontStyle: "italic"
}, {
  tag: [ke.deleted],
  color: "#b31d28",
  backgroundColor: "ffeef0"
}, {
  tag: [ke.atom, ke.bool, ke.special(ke.variableName)],
  color: "#e36209"
}, {
  tag: [ke.url, ke.escape, ke.regexp, ke.link],
  color: "#032f62"
}, {
  tag: ke.link,
  textDecoration: "underline"
}, {
  tag: ke.strikethrough,
  textDecoration: "line-through"
}, {
  tag: ke.invalid,
  color: "#cb2431"
}], j6t = (e) => {
  var {
    theme: t = "light",
    settings: n = {},
    styles: r = []
  } = {};
  return g2e({
    theme: t,
    settings: Ow({}, L6t, n),
    styles: [...z6t, ...r]
  });
}, __ = j6t(), F6t = {
  background: "#0d1117",
  foreground: "#c9d1d9",
  caret: "#c9d1d9",
  selection: "#003d73",
  selectionMatch: "#003d73",
  lineHighlight: "#36334280"
}, U6t = [{
  tag: [ke.standard(ke.tagName), ke.tagName],
  color: "#7ee787"
}, {
  tag: [ke.comment, ke.bracket],
  color: "#8b949e"
}, {
  tag: [ke.className, ke.propertyName],
  color: "#d2a8ff"
}, {
  tag: [ke.variableName, ke.attributeName, ke.number, ke.operator],
  color: "#79c0ff"
}, {
  tag: [ke.keyword, ke.typeName, ke.typeOperator, ke.typeName],
  color: "#ff7b72"
}, {
  tag: [ke.string, ke.meta, ke.regexp],
  color: "#a5d6ff"
}, {
  tag: [ke.name, ke.quote],
  color: "#7ee787"
}, {
  tag: [ke.heading, ke.strong],
  color: "#d2a8ff",
  fontWeight: "bold"
}, {
  tag: [ke.emphasis],
  color: "#d2a8ff",
  fontStyle: "italic"
}, {
  tag: [ke.deleted],
  color: "#ffdcd7",
  backgroundColor: "ffeef0"
}, {
  tag: [ke.atom, ke.bool, ke.special(ke.variableName)],
  color: "#ffab70"
}, {
  tag: ke.link,
  textDecoration: "underline"
}, {
  tag: ke.strikethrough,
  textDecoration: "line-through"
}, {
  tag: ke.invalid,
  color: "#f97583"
}], V6t = (e) => {
  var {
    theme: t = "dark",
    settings: n = {},
    styles: r = []
  } = {};
  return g2e({
    theme: t,
    settings: Ow({}, F6t, n),
    styles: [...U6t, ...r]
  });
}, L_ = V6t();
const q6t = (e) => {
  let { state: t } = e, n = t.doc.lineAt(t.selection.main.from), r = JG(e.state, n.from);
  return r.line ? B6t(e) : r.block ? W6t(e) : !1;
};
function YG(e, t) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let i = e(t, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
const B6t = /* @__PURE__ */ YG(
  Q6t,
  0
  /* CommentOption.Toggle */
), X6t = /* @__PURE__ */ YG(
  y2e,
  0
  /* CommentOption.Toggle */
), W6t = /* @__PURE__ */ YG(
  (e, t) => y2e(e, t, H6t(t)),
  0
  /* CommentOption.Toggle */
);
function JG(e, t) {
  let n = e.languageDataAt("commentTokens", t, 1);
  return n.length ? n[0] : {};
}
const wS = 50;
function Z6t(e, { open: t, close: n }, r, i) {
  let o = e.sliceDoc(r - wS, r), s = e.sliceDoc(i, i + wS), l = /\s*$/.exec(o)[0].length, c = /^\s*/.exec(s)[0].length, a = o.length - l;
  if (o.slice(a - t.length, a) == t && s.slice(c, c + n.length) == n)
    return {
      open: { pos: r - l, margin: l && 1 },
      close: { pos: i + c, margin: c && 1 }
    };
  let u, f;
  i - r <= 2 * wS ? u = f = e.sliceDoc(r, i) : (u = e.sliceDoc(r, r + wS), f = e.sliceDoc(i - wS, i));
  let d = /^\s*/.exec(u)[0].length, p = /\s*$/.exec(f)[0].length, h = f.length - p - n.length;
  return u.slice(d, d + t.length) == t && f.slice(h, h + n.length) == n ? {
    open: {
      pos: r + d + t.length,
      margin: /\s/.test(u.charAt(d + t.length)) ? 1 : 0
    },
    close: {
      pos: i - p - n.length,
      margin: /\s/.test(f.charAt(h - 1)) ? 1 : 0
    }
  } : null;
}
function H6t(e) {
  let t = [];
  for (let n of e.selection.ranges) {
    let r = e.doc.lineAt(n.from), i = n.to <= r.to ? r : e.doc.lineAt(n.to);
    i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : e.doc.lineAt(n.to - 1));
    let o = t.length - 1;
    o >= 0 && t[o].to > r.from ? t[o].to = i.to : t.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: i.to });
  }
  return t;
}
function y2e(e, t, n = t.selection.ranges) {
  let r = n.map((o) => JG(t, o.from).block);
  if (!r.every((o) => o))
    return null;
  let i = n.map((o, s) => Z6t(t, r[s], o.from, o.to));
  if (e != 2 && !i.every((o) => o))
    return { changes: t.changes(n.map((o, s) => i[s] ? [] : [{ from: o.from, insert: r[s].open + " " }, { from: o.to, insert: " " + r[s].close }])) };
  if (e != 1 && i.some((o) => o)) {
    let o = [];
    for (let s = 0, l; s < i.length; s++)
      if (l = i[s]) {
        let c = r[s], { open: a, close: u } = l;
        o.push({ from: a.pos - c.open.length, to: a.pos + a.margin }, { from: u.pos - u.margin, to: u.pos + c.close.length });
      }
    return { changes: o };
  }
  return null;
}
function Q6t(e, t, n = t.selection.ranges) {
  let r = [], i = -1;
  for (let { from: o, to: s } of n) {
    let l = r.length, c = 1e9, a = JG(t, o).line;
    if (a) {
      for (let u = o; u <= s; ) {
        let f = t.doc.lineAt(u);
        if (f.from > i && (o == s || s > f.from)) {
          i = f.from;
          let d = /^\s*/.exec(f.text)[0].length, p = d == f.length, h = f.text.slice(d, d + a.length) == a ? d : -1;
          d < f.text.length && d < c && (c = d), r.push({ line: f, comment: h, token: a, indent: d, empty: p, single: !1 });
        }
        u = f.to + 1;
      }
      if (c < 1e9)
        for (let u = l; u < r.length; u++)
          r[u].indent < r[u].line.text.length && (r[u].indent = c);
      r.length == l + 1 && (r[l].single = !0);
    }
  }
  if (e != 2 && r.some((o) => o.comment < 0 && (!o.empty || o.single))) {
    let o = [];
    for (let { line: l, token: c, indent: a, empty: u, single: f } of r)
      (f || !u) && o.push({ from: l.from + a, insert: c + " " });
    let s = t.changes(o);
    return { changes: s, selection: t.selection.map(s, 1) };
  } else if (e != 1 && r.some((o) => o.comment >= 0)) {
    let o = [];
    for (let { line: s, comment: l, token: c } of r)
      if (l >= 0) {
        let a = s.from + l, u = a + c.length;
        s.text[u - s.from] == " " && u++, o.push({ from: a, to: u });
      }
    return { changes: o };
  }
  return null;
}
const g8 = /* @__PURE__ */ Uf.define(), $6t = /* @__PURE__ */ Uf.define(), K6t = /* @__PURE__ */ Ht.define(), v2e = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (t, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (t, n) => (r, i) => t(r, i) || n(r, i)
    });
  }
}), b2e = /* @__PURE__ */ cs.define({
  create() {
    return uf.empty;
  },
  update(e, t) {
    let n = t.state.facet(v2e), r = t.annotation(g8);
    if (r) {
      let c = dl.fromTransaction(t, r.selection), a = r.side, u = a == 0 ? e.undone : e.done;
      return c ? u = z_(u, u.length, n.minDepth, c) : u = w2e(u, t.startState.selection), new uf(a == 0 ? r.rest : u, a == 0 ? u : r.rest);
    }
    let i = t.annotation($6t);
    if ((i == "full" || i == "before") && (e = e.isolate()), t.annotation(Pa.addToHistory) === !1)
      return t.changes.empty ? e : e.addMapping(t.changes.desc);
    let o = dl.fromTransaction(t), s = t.annotation(Pa.time), l = t.annotation(Pa.userEvent);
    return o ? e = e.addChanges(o, s, l, n, t) : t.selection && (e = e.addSelection(t.startState.selection, s, l, n.newGroupDelay)), (i == "full" || i == "after") && (e = e.isolate()), e;
  },
  toJSON(e) {
    return { done: e.done.map((t) => t.toJSON()), undone: e.undone.map((t) => t.toJSON()) };
  },
  fromJSON(e) {
    return new uf(e.done.map(dl.fromJSON), e.undone.map(dl.fromJSON));
  }
});
function G6t(e = {}) {
  return [
    b2e,
    v2e.of(e),
    kt.domEventHandlers({
      beforeinput(t, n) {
        let r = t.inputType == "historyUndo" ? O2e : t.inputType == "historyRedo" ? y8 : null;
        return r ? (t.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function Jj(e, t) {
  return function({ state: n, dispatch: r }) {
    if (!t && n.readOnly)
      return !1;
    let i = n.field(b2e, !1);
    if (!i)
      return !1;
    let o = i.pop(e, n, t);
    return o ? (r(o), !0) : !1;
  };
}
const O2e = /* @__PURE__ */ Jj(0, !1), y8 = /* @__PURE__ */ Jj(1, !1), Y6t = /* @__PURE__ */ Jj(0, !0), J6t = /* @__PURE__ */ Jj(1, !0);
class dl {
  constructor(t, n, r, i, o) {
    this.changes = t, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = o;
  }
  setSelAfter(t) {
    return new dl(this.changes, this.effects, this.mapped, this.startSelection, t);
  }
  toJSON() {
    var t, n, r;
    return {
      changes: (t = this.changes) === null || t === void 0 ? void 0 : t.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((i) => i.toJSON())
    };
  }
  static fromJSON(t) {
    return new dl(t.changes && Ro.fromJSON(t.changes), [], t.mapped && vf.fromJSON(t.mapped), t.startSelection && rt.fromJSON(t.startSelection), t.selectionsAfter.map(rt.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(t, n) {
    let r = Zc;
    for (let i of t.startState.facet(K6t)) {
      let o = i(t);
      o.length && (r = r.concat(o));
    }
    return !r.length && t.changes.empty ? null : new dl(t.changes.invert(t.startState.doc), r, void 0, n || t.startState.selection, Zc);
  }
  static selection(t) {
    return new dl(void 0, Zc, void 0, void 0, t);
  }
}
function z_(e, t, n, r) {
  let i = t + 1 > n + 20 ? t - n - 1 : 0, o = e.slice(i, t);
  return o.push(r), o;
}
function eUt(e, t) {
  let n = [], r = !1;
  return e.iterChangedRanges((i, o) => n.push(i, o)), t.iterChangedRanges((i, o, s, l) => {
    for (let c = 0; c < n.length; ) {
      let a = n[c++], u = n[c++];
      l >= a && s <= u && (r = !0);
    }
  }), r;
}
function tUt(e, t) {
  return e.ranges.length == t.ranges.length && e.ranges.filter((n, r) => n.empty != t.ranges[r].empty).length === 0;
}
function A2e(e, t) {
  return e.length ? t.length ? e.concat(t) : e : t;
}
const Zc = [], nUt = 200;
function w2e(e, t) {
  if (e.length) {
    let n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - nUt));
    return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), z_(e, e.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [dl.selection([t])];
}
function rUt(e) {
  let t = e[e.length - 1], n = e.slice();
  return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function $U(e, t) {
  if (!e.length)
    return e;
  let n = e.length, r = Zc;
  for (; n; ) {
    let i = iUt(e[n - 1], t, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let o = e.slice(0, n);
      return o[n - 1] = i, o;
    } else
      t = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [dl.selection(r)] : Zc;
}
function iUt(e, t, n) {
  let r = A2e(e.selectionsAfter.length ? e.selectionsAfter.map((l) => l.map(t)) : Zc, n);
  if (!e.changes)
    return dl.selection(r);
  let i = e.changes.map(t), o = t.mapDesc(e.changes, !0), s = e.mapped ? e.mapped.composeDesc(o) : o;
  return new dl(i, _n.mapEffects(e.effects, t), s, e.startSelection.map(o), r);
}
const oUt = /^(input\.type|delete)($|\.)/;
class uf {
  constructor(t, n, r = 0, i = void 0) {
    this.done = t, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new uf(this.done, this.undone) : this;
  }
  addChanges(t, n, r, i, o) {
    let s = this.done, l = s[s.length - 1];
    return l && l.changes && !l.changes.empty && t.changes && (!r || oUt.test(r)) && (!l.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(o, eUt(l.changes, t.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? s = z_(s, s.length - 1, i.minDepth, new dl(t.changes.compose(l.changes), A2e(_n.mapEffects(t.effects, l.changes), l.effects), l.mapped, l.startSelection, Zc)) : s = z_(s, s.length, i.minDepth, t), new uf(s, Zc, n, r);
  }
  addSelection(t, n, r, i) {
    let o = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Zc;
    return o.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && tUt(o[o.length - 1], t) ? this : new uf(w2e(this.done, t), this.undone, n, r);
  }
  addMapping(t) {
    return new uf($U(this.done, t), $U(this.undone, t), this.prevTime, this.prevUserEvent);
  }
  pop(t, n, r) {
    let i = t == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    let o = i[i.length - 1], s = o.selectionsAfter[0] || n.selection;
    if (r && o.selectionsAfter.length)
      return n.update({
        selection: o.selectionsAfter[o.selectionsAfter.length - 1],
        annotations: g8.of({ side: t, rest: rUt(i), selection: s }),
        userEvent: t == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (o.changes) {
      let l = i.length == 1 ? Zc : i.slice(0, i.length - 1);
      return o.mapped && (l = $U(l, o.mapped)), n.update({
        changes: o.changes,
        selection: o.startSelection,
        effects: o.effects,
        annotations: g8.of({ side: t, rest: l, selection: s }),
        filter: !1,
        userEvent: t == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
uf.empty = /* @__PURE__ */ new uf(Zc, Zc);
const sUt = [
  { key: "Mod-z", run: O2e, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: y8, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: y8, preventDefault: !0 },
  { key: "Mod-u", run: Y6t, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: J6t, preventDefault: !0 }
];
function Ix(e, t) {
  return rt.create(e.ranges.map(t), e.mainIndex);
}
function Bf(e, t) {
  return e.update({ selection: t, scrollIntoView: !0, userEvent: "select" });
}
function wd({ state: e, dispatch: t }, n) {
  let r = Ix(e.selection, n);
  return r.eq(e.selection, !0) ? !1 : (t(Bf(e, r)), !0);
}
function e3(e, t) {
  return rt.cursor(t ? e.to : e.from);
}
function x2e(e, t) {
  return wd(e, (n) => n.empty ? e.moveByChar(n, t) : e3(n, t));
}
function sa(e) {
  return e.textDirectionAt(e.state.selection.main.head) == hi.LTR;
}
const S2e = (e) => x2e(e, !sa(e)), E2e = (e) => x2e(e, sa(e));
function T2e(e, t) {
  return wd(e, (n) => n.empty ? e.moveByGroup(n, t) : e3(n, t));
}
const aUt = (e) => T2e(e, !sa(e)), lUt = (e) => T2e(e, sa(e));
function cUt(e, t, n) {
  if (t.type.prop(n))
    return !0;
  let r = t.to - t.from;
  return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function t3(e, t, n) {
  let r = zo(e).resolveInner(t.head), i = n ? Gn.closedBy : Gn.openedBy;
  for (let c = t.head; ; ) {
    let a = n ? r.childAfter(c) : r.childBefore(c);
    if (!a)
      break;
    cUt(e, a, i) ? r = a : c = n ? a.to : a.from;
  }
  let o = r.type.prop(i), s, l;
  return o && (s = n ? cf(e, r.from, 1) : cf(e, r.to, -1)) && s.matched ? l = n ? s.end.to : s.end.from : l = n ? r.to : r.from, rt.cursor(l, n ? -1 : 1);
}
const uUt = (e) => wd(e, (t) => t3(e.state, t, !sa(e))), dUt = (e) => wd(e, (t) => t3(e.state, t, sa(e)));
function k2e(e, t) {
  return wd(e, (n) => {
    if (!n.empty)
      return e3(n, t);
    let r = e.moveVertically(n, t);
    return r.head != n.head ? r : e.moveToLineBoundary(n, t);
  });
}
const C2e = (e) => k2e(e, !1), N2e = (e) => k2e(e, !0);
function P2e(e) {
  let t = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
  if (t) {
    for (let o of e.state.facet(kt.scrollMargins)) {
      let s = o(e);
      s != null && s.top && (n = Math.max(s == null ? void 0 : s.top, n)), s != null && s.bottom && (r = Math.max(s == null ? void 0 : s.bottom, r));
    }
    i = e.scrollDOM.clientHeight - n - r;
  } else
    i = (e.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: t,
    height: Math.max(e.defaultLineHeight, i - 5)
  };
}
function I2e(e, t) {
  let n = P2e(e), { state: r } = e, i = Ix(r.selection, (s) => s.empty ? e.moveVertically(s, t, n.height) : e3(s, t));
  if (i.eq(r.selection))
    return !1;
  let o;
  if (n.selfScroll) {
    let s = e.coordsAtPos(r.selection.main.head), l = e.scrollDOM.getBoundingClientRect(), c = l.top + n.marginTop, a = l.bottom - n.marginBottom;
    s && s.top > c && s.bottom < a && (o = kt.scrollIntoView(i.main.head, { y: "start", yMargin: s.top - c }));
  }
  return e.dispatch(Bf(r, i), { effects: o }), !0;
}
const ode = (e) => I2e(e, !1), v8 = (e) => I2e(e, !0);
function _g(e, t, n) {
  let r = e.lineBlockAt(t.head), i = e.moveToLineBoundary(t, n);
  if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
    let o = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    o && t.head != r.from + o && (i = rt.cursor(r.from + o));
  }
  return i;
}
const fUt = (e) => wd(e, (t) => _g(e, t, !0)), pUt = (e) => wd(e, (t) => _g(e, t, !1)), hUt = (e) => wd(e, (t) => _g(e, t, !sa(e))), mUt = (e) => wd(e, (t) => _g(e, t, sa(e))), gUt = (e) => wd(e, (t) => rt.cursor(e.lineBlockAt(t.head).from, 1)), yUt = (e) => wd(e, (t) => rt.cursor(e.lineBlockAt(t.head).to, -1));
function vUt(e, t, n) {
  let r = !1, i = Ix(e.selection, (o) => {
    let s = cf(e, o.head, -1) || cf(e, o.head, 1) || o.head > 0 && cf(e, o.head - 1, 1) || o.head < e.doc.length && cf(e, o.head + 1, -1);
    if (!s || !s.end)
      return o;
    r = !0;
    let l = s.start.from == o.head ? s.end.to : s.end.from;
    return rt.cursor(l);
  });
  return r ? (t(Bf(e, i)), !0) : !1;
}
const bUt = ({ state: e, dispatch: t }) => vUt(e, t);
function vu(e, t) {
  let n = Ix(e.state.selection, (r) => {
    let i = t(r);
    return rt.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return n.eq(e.state.selection) ? !1 : (e.dispatch(Bf(e.state, n)), !0);
}
function R2e(e, t) {
  return vu(e, (n) => e.moveByChar(n, t));
}
const M2e = (e) => R2e(e, !sa(e)), D2e = (e) => R2e(e, sa(e));
function _2e(e, t) {
  return vu(e, (n) => e.moveByGroup(n, t));
}
const OUt = (e) => _2e(e, !sa(e)), AUt = (e) => _2e(e, sa(e)), wUt = (e) => vu(e, (t) => t3(e.state, t, !sa(e))), xUt = (e) => vu(e, (t) => t3(e.state, t, sa(e)));
function L2e(e, t) {
  return vu(e, (n) => e.moveVertically(n, t));
}
const z2e = (e) => L2e(e, !1), j2e = (e) => L2e(e, !0);
function F2e(e, t) {
  return vu(e, (n) => e.moveVertically(n, t, P2e(e).height));
}
const sde = (e) => F2e(e, !1), ade = (e) => F2e(e, !0), SUt = (e) => vu(e, (t) => _g(e, t, !0)), EUt = (e) => vu(e, (t) => _g(e, t, !1)), TUt = (e) => vu(e, (t) => _g(e, t, !sa(e))), kUt = (e) => vu(e, (t) => _g(e, t, sa(e))), CUt = (e) => vu(e, (t) => rt.cursor(e.lineBlockAt(t.head).from)), NUt = (e) => vu(e, (t) => rt.cursor(e.lineBlockAt(t.head).to)), lde = ({ state: e, dispatch: t }) => (t(Bf(e, { anchor: 0 })), !0), cde = ({ state: e, dispatch: t }) => (t(Bf(e, { anchor: e.doc.length })), !0), ude = ({ state: e, dispatch: t }) => (t(Bf(e, { anchor: e.selection.main.anchor, head: 0 })), !0), dde = ({ state: e, dispatch: t }) => (t(Bf(e, { anchor: e.selection.main.anchor, head: e.doc.length })), !0), PUt = ({ state: e, dispatch: t }) => (t(e.update({ selection: { anchor: 0, head: e.doc.length }, userEvent: "select" })), !0), IUt = ({ state: e, dispatch: t }) => {
  let n = n3(e).map(({ from: r, to: i }) => rt.range(r, Math.min(i + 1, e.doc.length)));
  return t(e.update({ selection: rt.create(n), userEvent: "select" })), !0;
}, RUt = ({ state: e, dispatch: t }) => {
  let n = Ix(e.selection, (r) => {
    let i = zo(e), o = i.resolveStack(r.from, 1);
    if (r.empty) {
      let s = i.resolveStack(r.from, -1);
      s.node.from >= o.node.from && s.node.to <= o.node.to && (o = s);
    }
    for (let s = o; s; s = s.next) {
      let { node: l } = s;
      if ((l.from < r.from && l.to >= r.to || l.to > r.to && l.from <= r.from) && s.next)
        return rt.range(l.to, l.from);
    }
    return r;
  });
  return n.eq(e.selection) ? !1 : (t(Bf(e, n)), !0);
}, MUt = ({ state: e, dispatch: t }) => {
  let n = e.selection, r = null;
  return n.ranges.length > 1 ? r = rt.create([n.main]) : n.main.empty || (r = rt.create([rt.cursor(n.main.head)])), r ? (t(Bf(e, r)), !0) : !1;
};
function MN(e, t) {
  if (e.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = e, i = r.changeByRange((o) => {
    let { from: s, to: l } = o;
    if (s == l) {
      let c = t(o);
      c < s ? (n = "delete.backward", c = UI(e, c, !1)) : c > s && (n = "delete.forward", c = UI(e, c, !0)), s = Math.min(s, c), l = Math.max(l, c);
    } else
      s = UI(e, s, !1), l = UI(e, l, !0);
    return s == l ? { range: o } : { changes: { from: s, to: l }, range: rt.cursor(s, s < o.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (e.dispatch(r.update(i, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? kt.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function UI(e, t, n) {
  if (e instanceof kt)
    for (let r of e.state.facet(kt.atomicRanges).map((i) => i(e)))
      r.between(t, t, (i, o) => {
        i < t && o > t && (t = n ? o : i);
      });
  return t;
}
const U2e = (e, t, n) => MN(e, (r) => {
  let i = r.from, { state: o } = e, s = o.doc.lineAt(i), l, c;
  if (n && !t && i > s.from && i < s.from + 200 && !/[^ \t]/.test(l = s.text.slice(0, i - s.from))) {
    if (l[l.length - 1] == "	")
      return i - 1;
    let a = Cx(l, o.tabSize), u = a % P_(o) || P_(o);
    for (let f = 0; f < u && l[l.length - 1 - f] == " "; f++)
      i--;
    c = i;
  } else
    c = xs(s.text, i - s.from, t, t) + s.from, c == i && s.number != (t ? o.doc.lines : 1) ? c += t ? 1 : -1 : !t && /[\ufe00-\ufe0f]/.test(s.text.slice(c - s.from, i - s.from)) && (c = xs(s.text, c - s.from, !1, !1) + s.from);
  return c;
}), b8 = (e) => U2e(e, !1, !0), V2e = (e) => U2e(e, !0, !1), q2e = (e, t) => MN(e, (n) => {
  let r = n.head, { state: i } = e, o = i.doc.lineAt(r), s = i.charCategorizer(r);
  for (let l = null; ; ) {
    if (r == (t ? o.to : o.from)) {
      r == n.head && o.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
      break;
    }
    let c = xs(o.text, r - o.from, t) + o.from, a = o.text.slice(Math.min(r, c) - o.from, Math.max(r, c) - o.from), u = s(a);
    if (l != null && u != l)
      break;
    (a != " " || r != n.head) && (l = u), r = c;
  }
  return r;
}), B2e = (e) => q2e(e, !1), DUt = (e) => q2e(e, !0), _Ut = (e) => MN(e, (t) => {
  let n = e.lineBlockAt(t.head).to;
  return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), LUt = (e) => MN(e, (t) => {
  let n = e.moveToLineBoundary(t, !1).head;
  return t.head > n ? n : Math.max(0, t.head - 1);
}), zUt = (e) => MN(e, (t) => {
  let n = e.moveToLineBoundary(t, !0).head;
  return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), jUt = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = e.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: Sr.of(["", ""]) },
    range: rt.cursor(r.from)
  }));
  return t(e.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, FUt = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = e.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == e.doc.length)
      return { range: r };
    let i = r.from, o = e.doc.lineAt(i), s = i == o.from ? i - 1 : xs(o.text, i - o.from, !1) + o.from, l = i == o.to ? i + 1 : xs(o.text, i - o.from, !0) + o.from;
    return {
      changes: { from: s, to: l, insert: e.doc.slice(i, l).append(e.doc.slice(s, i)) },
      range: rt.cursor(l)
    };
  });
  return n.changes.empty ? !1 : (t(e.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function n3(e) {
  let t = [], n = -1;
  for (let r of e.selection.ranges) {
    let i = e.doc.lineAt(r.from), o = e.doc.lineAt(r.to);
    if (!r.empty && r.to == o.from && (o = e.doc.lineAt(r.to - 1)), n >= i.number) {
      let s = t[t.length - 1];
      s.to = o.to, s.ranges.push(r);
    } else
      t.push({ from: i.from, to: o.to, ranges: [r] });
    n = o.number + 1;
  }
  return t;
}
function X2e(e, t, n) {
  if (e.readOnly)
    return !1;
  let r = [], i = [];
  for (let o of n3(e)) {
    if (n ? o.to == e.doc.length : o.from == 0)
      continue;
    let s = e.doc.lineAt(n ? o.to + 1 : o.from - 1), l = s.length + 1;
    if (n) {
      r.push({ from: o.to, to: s.to }, { from: o.from, insert: s.text + e.lineBreak });
      for (let c of o.ranges)
        i.push(rt.range(Math.min(e.doc.length, c.anchor + l), Math.min(e.doc.length, c.head + l)));
    } else {
      r.push({ from: s.from, to: o.from }, { from: o.to, insert: e.lineBreak + s.text });
      for (let c of o.ranges)
        i.push(rt.range(c.anchor - l, c.head - l));
    }
  }
  return r.length ? (t(e.update({
    changes: r,
    scrollIntoView: !0,
    selection: rt.create(i, e.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const UUt = ({ state: e, dispatch: t }) => X2e(e, t, !1), VUt = ({ state: e, dispatch: t }) => X2e(e, t, !0);
function W2e(e, t, n) {
  if (e.readOnly)
    return !1;
  let r = [];
  for (let i of n3(e))
    n ? r.push({ from: i.from, insert: e.doc.slice(i.from, i.to) + e.lineBreak }) : r.push({ from: i.to, insert: e.lineBreak + e.doc.slice(i.from, i.to) });
  return t(e.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const qUt = ({ state: e, dispatch: t }) => W2e(e, t, !1), BUt = ({ state: e, dispatch: t }) => W2e(e, t, !0), XUt = (e) => {
  if (e.state.readOnly)
    return !1;
  let { state: t } = e, n = t.changes(n3(t).map(({ from: i, to: o }) => (i > 0 ? i-- : o < t.doc.length && o++, { from: i, to: o }))), r = Ix(t.selection, (i) => {
    let o;
    if (e.lineWrapping) {
      let s = e.lineBlockAt(i.head), l = e.coordsAtPos(i.head, i.assoc || 1);
      l && (o = s.bottom + e.documentTop - l.bottom + e.defaultLineHeight / 2);
    }
    return e.moveVertically(i, !0, o);
  }).map(n);
  return e.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function WUt(e, t) {
  if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1)))
    return { from: t, to: t };
  let n = zo(e).resolveInner(t), r = n.childBefore(t), i = n.childAfter(t), o;
  return r && i && r.to <= t && i.from >= t && (o = r.type.prop(Gn.closedBy)) && o.indexOf(i.name) > -1 && e.doc.lineAt(r.to).from == e.doc.lineAt(i.from).from && !/\S/.test(e.sliceDoc(r.to, i.from)) ? { from: r.to, to: i.from } : null;
}
const fde = /* @__PURE__ */ Z2e(!1), ZUt = /* @__PURE__ */ Z2e(!0);
function Z2e(e) {
  return ({ state: t, dispatch: n }) => {
    if (t.readOnly)
      return !1;
    let r = t.changeByRange((i) => {
      let { from: o, to: s } = i, l = t.doc.lineAt(o), c = !e && o == s && WUt(t, o);
      e && (o = s = (s <= l.to ? l : t.doc.lineAt(s)).to);
      let a = new Kj(t, { simulateBreak: o, simulateDoubleBreak: !!c }), u = UG(a, o);
      for (u == null && (u = Cx(/^\s*/.exec(t.doc.lineAt(o).text)[0], t.tabSize)); s < l.to && /\s/.test(l.text[s - l.from]); )
        s++;
      c ? { from: o, to: s } = c : o > l.from && o < l.from + 100 && !/\S/.test(l.text.slice(0, o)) && (o = l.from);
      let f = ["", bk(t, u)];
      return c && f.push(bk(t, a.lineIndent(l.from, -1))), {
        changes: { from: o, to: s, insert: Sr.of(f) },
        range: rt.cursor(o + 1 + f[1].length)
      };
    });
    return n(t.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function eY(e, t) {
  let n = -1;
  return e.changeByRange((r) => {
    let i = [];
    for (let s = r.from; s <= r.to; ) {
      let l = e.doc.lineAt(s);
      l.number > n && (r.empty || r.to > l.from) && (t(l, i, r), n = l.number), s = l.to + 1;
    }
    let o = e.changes(i);
    return {
      changes: i,
      range: rt.range(o.mapPos(r.anchor, 1), o.mapPos(r.head, 1))
    };
  });
}
const HUt = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new Kj(e, { overrideIndentation: (o) => {
    let s = n[o];
    return s ?? -1;
  } }), i = eY(e, (o, s, l) => {
    let c = UG(r, o.from);
    if (c == null)
      return;
    /\S/.test(o.text) || (c = 0);
    let a = /^\s*/.exec(o.text)[0], u = bk(e, c);
    (a != u || l.from < o.from + a.length) && (n[o.from] = c, s.push({ from: o.from, to: o.from + a.length, insert: u }));
  });
  return i.changes.empty || t(e.update(i, { userEvent: "indent" })), !0;
}, H2e = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(eY(e, (n, r) => {
  r.push({ from: n.from, insert: e.facet(PN) });
}), { userEvent: "input.indent" })), !0), Q2e = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(eY(e, (n, r) => {
  let i = /^\s*/.exec(n.text)[0];
  if (!i)
    return;
  let o = Cx(i, e.tabSize), s = 0, l = bk(e, Math.max(0, o - P_(e)));
  for (; s < i.length && s < l.length && i.charCodeAt(s) == l.charCodeAt(s); )
    s++;
  r.push({ from: n.from + s, to: n.from + i.length, insert: l.slice(s) });
}), { userEvent: "delete.dedent" })), !0), QUt = (e) => (e.setTabFocusMode(), !0), $Ut = [
  { key: "Ctrl-b", run: S2e, shift: M2e, preventDefault: !0 },
  { key: "Ctrl-f", run: E2e, shift: D2e },
  { key: "Ctrl-p", run: C2e, shift: z2e },
  { key: "Ctrl-n", run: N2e, shift: j2e },
  { key: "Ctrl-a", run: gUt, shift: CUt },
  { key: "Ctrl-e", run: yUt, shift: NUt },
  { key: "Ctrl-d", run: V2e },
  { key: "Ctrl-h", run: b8 },
  { key: "Ctrl-k", run: _Ut },
  { key: "Ctrl-Alt-h", run: B2e },
  { key: "Ctrl-o", run: jUt },
  { key: "Ctrl-t", run: FUt },
  { key: "Ctrl-v", run: v8 }
], KUt = /* @__PURE__ */ [
  { key: "ArrowLeft", run: S2e, shift: M2e, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: aUt, shift: OUt, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: hUt, shift: TUt, preventDefault: !0 },
  { key: "ArrowRight", run: E2e, shift: D2e, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: lUt, shift: AUt, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: mUt, shift: kUt, preventDefault: !0 },
  { key: "ArrowUp", run: C2e, shift: z2e, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: lde, shift: ude },
  { mac: "Ctrl-ArrowUp", run: ode, shift: sde },
  { key: "ArrowDown", run: N2e, shift: j2e, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: cde, shift: dde },
  { mac: "Ctrl-ArrowDown", run: v8, shift: ade },
  { key: "PageUp", run: ode, shift: sde },
  { key: "PageDown", run: v8, shift: ade },
  { key: "Home", run: pUt, shift: EUt, preventDefault: !0 },
  { key: "Mod-Home", run: lde, shift: ude },
  { key: "End", run: fUt, shift: SUt, preventDefault: !0 },
  { key: "Mod-End", run: cde, shift: dde },
  { key: "Enter", run: fde, shift: fde },
  { key: "Mod-a", run: PUt },
  { key: "Backspace", run: b8, shift: b8 },
  { key: "Delete", run: V2e },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: B2e },
  { key: "Mod-Delete", mac: "Alt-Delete", run: DUt },
  { mac: "Mod-Backspace", run: LUt },
  { mac: "Mod-Delete", run: zUt }
].concat(/* @__PURE__ */ $Ut.map((e) => ({ mac: e.key, run: e.run, shift: e.shift }))), GUt = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: uUt, shift: wUt },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: dUt, shift: xUt },
  { key: "Alt-ArrowUp", run: UUt },
  { key: "Shift-Alt-ArrowUp", run: qUt },
  { key: "Alt-ArrowDown", run: VUt },
  { key: "Shift-Alt-ArrowDown", run: BUt },
  { key: "Escape", run: MUt },
  { key: "Mod-Enter", run: ZUt },
  { key: "Alt-l", mac: "Ctrl-l", run: IUt },
  { key: "Mod-i", run: RUt, preventDefault: !0 },
  { key: "Mod-[", run: Q2e },
  { key: "Mod-]", run: H2e },
  { key: "Mod-Alt-\\", run: HUt },
  { key: "Shift-Mod-k", run: XUt },
  { key: "Shift-Mod-\\", run: bUt },
  { key: "Mod-/", run: q6t },
  { key: "Alt-A", run: X6t },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: QUt }
].concat(KUt), YUt = { key: "Tab", run: H2e, shift: Q2e }, pde = typeof String.prototype.normalize == "function" ? (e) => e.normalize("NFKD") : (e) => e;
class kw {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(t, n, r = 0, i = t.length, o, s) {
    this.test = s, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = t.iterRange(r, i), this.bufferStart = r, this.normalize = o ? (l) => o(pde(l)) : pde, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return el(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let t = this.peek();
      if (t < 0)
        return this.done = !0, this;
      let n = xG(t), r = this.bufferStart + this.bufferPos;
      this.bufferPos += tf(t);
      let i = this.normalize(n);
      if (i.length)
        for (let o = 0, s = r; ; o++) {
          let l = i.charCodeAt(o), c = this.match(l, s, this.bufferPos + this.bufferStart);
          if (o == i.length - 1) {
            if (c)
              return this.value = c, this;
            break;
          }
          s == r && o < n.length && n.charCodeAt(o) == l && s++;
        }
    }
  }
  match(t, n, r) {
    let i = null;
    for (let o = 0; o < this.matches.length; o += 2) {
      let s = this.matches[o], l = !1;
      this.query.charCodeAt(s) == t && (s == this.query.length - 1 ? i = { from: this.matches[o + 1], to: r } : (this.matches[o]++, l = !0)), l || (this.matches.splice(o, 2), o -= 2);
    }
    return this.query.charCodeAt(0) == t && (this.query.length == 1 ? i = { from: n, to: r } : this.matches.push(1, n)), i && this.test && !this.test(i.from, i.to, this.buffer, this.bufferStart) && (i = null), i;
  }
}
typeof Symbol < "u" && (kw.prototype[Symbol.iterator] = function() {
  return this;
});
const $2e = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, tY = "gm" + (/x/.unicode == null ? "" : "u");
class K2e {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(t, n, r, i = 0, o = t.length) {
    if (this.text = t, this.to = o, this.curLine = "", this.done = !1, this.value = $2e, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new G2e(t, n, r, i, o);
    this.re = new RegExp(n, tY + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = t.iter();
    let s = t.lineAt(i);
    this.curLineStart = s.from, this.matchPos = j_(t, i), this.getLine(this.curLineStart);
  }
  getLine(t) {
    this.iter.next(t), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let t = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = t;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = j_(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this;
        t = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), t = 0;
      else
        return this.done = !0, this;
    }
  }
}
const KU = /* @__PURE__ */ new WeakMap();
class oA {
  constructor(t, n) {
    this.from = t, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(t, n, r) {
    let i = KU.get(t);
    if (!i || i.from >= r || i.to <= n) {
      let l = new oA(n, t.sliceString(n, r));
      return KU.set(t, l), l;
    }
    if (i.from == n && i.to == r)
      return i;
    let { text: o, from: s } = i;
    return s > n && (o = t.sliceString(n, s) + o, s = n), i.to < r && (o += t.sliceString(i.to, r)), KU.set(t, new oA(s, o)), new oA(n, o.slice(n - s, r - s));
  }
}
class G2e {
  constructor(t, n, r, i, o) {
    this.text = t, this.to = o, this.done = !1, this.value = $2e, this.matchPos = j_(t, i), this.re = new RegExp(n, tY + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = oA.get(t, i, this.chunkEnd(
      i + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(t) {
    return t >= this.to ? this.to : this.text.lineAt(t).to;
  }
  next() {
    for (; ; ) {
      let t = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == t && (this.re.lastIndex = t + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, i = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this.matchPos = j_(this.text, i + (r == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = oA.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (K2e.prototype[Symbol.iterator] = G2e.prototype[Symbol.iterator] = function() {
  return this;
});
function JUt(e) {
  try {
    return new RegExp(e, tY), !0;
  } catch {
    return !1;
  }
}
function j_(e, t) {
  if (t >= e.length)
    return t;
  let n = e.lineAt(t), r;
  for (; t < n.to && (r = n.text.charCodeAt(t - n.from)) >= 56320 && r < 57344; )
    t++;
  return t;
}
function O8(e) {
  let t = String(e.state.doc.lineAt(e.state.selection.main.head).number), n = qr("input", { class: "cm-textfield", name: "line", value: t }), r = qr("form", {
    class: "cm-gotoLine",
    onkeydown: (o) => {
      o.keyCode == 27 ? (o.preventDefault(), e.dispatch({ effects: VE.of(!1) }), e.focus()) : o.keyCode == 13 && (o.preventDefault(), i());
    },
    onsubmit: (o) => {
      o.preventDefault(), i();
    }
  }, qr("label", e.state.phrase("Go to line"), ": ", n), " ", qr("button", { class: "cm-button", type: "submit" }, e.state.phrase("go")), qr("button", {
    name: "close",
    onclick: () => {
      e.dispatch({ effects: VE.of(!1) }), e.focus();
    },
    "aria-label": e.state.phrase("close"),
    type: "button"
  }, ["×"]));
  function i() {
    let o = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!o)
      return;
    let { state: s } = e, l = s.doc.lineAt(s.selection.main.head), [, c, a, u, f] = o, d = u ? +u.slice(1) : 0, p = a ? +a : l.number;
    if (a && f) {
      let v = p / 100;
      c && (v = v * (c == "-" ? -1 : 1) + l.number / s.doc.lines), p = Math.round(s.doc.lines * v);
    } else a && c && (p = p * (c == "-" ? -1 : 1) + l.number);
    let h = s.doc.line(Math.max(1, Math.min(s.doc.lines, p))), m = rt.cursor(h.from + Math.max(0, Math.min(d, h.length)));
    e.dispatch({
      effects: [VE.of(!1), kt.scrollIntoView(m.from, { y: "center" })],
      selection: m
    }), e.focus();
  }
  return { dom: r };
}
const VE = /* @__PURE__ */ _n.define(), hde = /* @__PURE__ */ cs.define({
  create() {
    return !0;
  },
  update(e, t) {
    for (let n of t.effects)
      n.is(VE) && (e = n.value);
    return e;
  },
  provide: (e) => yk.from(e, (t) => t ? O8 : null)
}), e4t = (e) => {
  let t = gk(e, O8);
  if (!t) {
    let n = [VE.of(!0)];
    e.state.field(hde, !1) == null && n.push(_n.appendConfig.of([hde, t4t])), e.dispatch({ effects: n }), t = gk(e, O8);
  }
  return t && t.dom.querySelector("input").select(), !0;
}, t4t = /* @__PURE__ */ kt.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    position: "relative",
    "& label": { fontSize: "80%" },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: "0"
    }
  }
}), n4t = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, r4t = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, n4t, {
      highlightWordAroundCursor: (t, n) => t || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function i4t(e) {
  return [c4t, l4t];
}
const o4t = /* @__PURE__ */ ln.mark({ class: "cm-selectionMatch" }), s4t = /* @__PURE__ */ ln.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function mde(e, t, n, r) {
  return (n == 0 || e(t.sliceDoc(n - 1, n)) != Oi.Word) && (r == t.doc.length || e(t.sliceDoc(r, r + 1)) != Oi.Word);
}
function a4t(e, t, n, r) {
  return e(t.sliceDoc(n, n + 1)) == Oi.Word && e(t.sliceDoc(r - 1, r)) == Oi.Word;
}
const l4t = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.decorations = this.getDeco(e);
  }
  update(e) {
    (e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
  }
  getDeco(e) {
    let t = e.state.facet(r4t), { state: n } = e, r = n.selection;
    if (r.ranges.length > 1)
      return ln.none;
    let i = r.main, o, s = null;
    if (i.empty) {
      if (!t.highlightWordAroundCursor)
        return ln.none;
      let c = n.wordAt(i.head);
      if (!c)
        return ln.none;
      s = n.charCategorizer(i.head), o = n.sliceDoc(c.from, c.to);
    } else {
      let c = i.to - i.from;
      if (c < t.minSelectionLength || c > 200)
        return ln.none;
      if (t.wholeWords) {
        if (o = n.sliceDoc(i.from, i.to), s = n.charCategorizer(i.head), !(mde(s, n, i.from, i.to) && a4t(s, n, i.from, i.to)))
          return ln.none;
      } else if (o = n.sliceDoc(i.from, i.to), !o)
        return ln.none;
    }
    let l = [];
    for (let c of e.visibleRanges) {
      let a = new kw(n.doc, o, c.from, c.to);
      for (; !a.next().done; ) {
        let { from: u, to: f } = a.value;
        if ((!s || mde(s, n, u, f)) && (i.empty && u <= i.from && f >= i.to ? l.push(s4t.range(u, f)) : (u >= i.to || f <= i.from) && l.push(o4t.range(u, f)), l.length > t.maxMatches))
          return ln.none;
      }
    }
    return ln.set(l);
  }
}, {
  decorations: (e) => e.decorations
}), c4t = /* @__PURE__ */ kt.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), u4t = ({ state: e, dispatch: t }) => {
  let { selection: n } = e, r = rt.create(n.ranges.map((i) => e.wordAt(i.head) || rt.cursor(i.head)), n.mainIndex);
  return r.eq(n) ? !1 : (t(e.update({ selection: r })), !0);
};
function d4t(e, t) {
  let { main: n, ranges: r } = e.selection, i = e.wordAt(n.head), o = i && i.from == n.from && i.to == n.to;
  for (let s = !1, l = new kw(e.doc, t, r[r.length - 1].to); ; )
    if (l.next(), l.done) {
      if (s)
        return null;
      l = new kw(e.doc, t, 0, Math.max(0, r[r.length - 1].from - 1)), s = !0;
    } else {
      if (s && r.some((c) => c.from == l.value.from))
        continue;
      if (o) {
        let c = e.wordAt(l.value.from);
        if (!c || c.from != l.value.from || c.to != l.value.to)
          continue;
      }
      return l.value;
    }
}
const f4t = ({ state: e, dispatch: t }) => {
  let { ranges: n } = e.selection;
  if (n.some((o) => o.from === o.to))
    return u4t({ state: e, dispatch: t });
  let r = e.sliceDoc(n[0].from, n[0].to);
  if (e.selection.ranges.some((o) => e.sliceDoc(o.from, o.to) != r))
    return !1;
  let i = d4t(e, r);
  return i ? (t(e.update({
    selection: e.selection.addRange(rt.range(i.from, i.to), !1),
    effects: kt.scrollIntoView(i.to)
  })), !0) : !1;
}, Rx = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Vf(e, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (t) => new S4t(t),
      scrollToMatch: (t) => kt.scrollIntoView(t)
    });
  }
});
class Y2e {
  /**
  Create a query object.
  */
  constructor(t) {
    this.search = t.search, this.caseSensitive = !!t.caseSensitive, this.literal = !!t.literal, this.regexp = !!t.regexp, this.replace = t.replace || "", this.valid = !!this.search && (!this.regexp || JUt(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!t.wholeWord;
  }
  /**
  @internal
  */
  unquote(t) {
    return this.literal ? t : t.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(t) {
    return this.search == t.search && this.replace == t.replace && this.caseSensitive == t.caseSensitive && this.regexp == t.regexp && this.wholeWord == t.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new g4t(this) : new h4t(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(t, n = 0, r) {
    let i = t.doc ? t : $n.create({ doc: t });
    return r == null && (r = i.doc.length), this.regexp ? aO(this, i, n, r) : sO(this, i, n, r);
  }
}
class J2e {
  constructor(t) {
    this.spec = t;
  }
}
function sO(e, t, n, r) {
  return new kw(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : (i) => i.toLowerCase(), e.wholeWord ? p4t(t.doc, t.charCategorizer(t.selection.main.head)) : void 0);
}
function p4t(e, t) {
  return (n, r, i, o) => ((o > n || o + i.length < r) && (o = Math.max(0, n - 2), i = e.sliceString(o, Math.min(e.length, r + 2))), (t(F_(i, n - o)) != Oi.Word || t(U_(i, n - o)) != Oi.Word) && (t(U_(i, r - o)) != Oi.Word || t(F_(i, r - o)) != Oi.Word));
}
class h4t extends J2e {
  constructor(t) {
    super(t);
  }
  nextMatch(t, n, r) {
    let i = sO(this.spec, t, r, t.doc.length).nextOverlapping();
    if (i.done) {
      let o = Math.min(t.doc.length, n + this.spec.unquoted.length);
      i = sO(this.spec, t, 0, o).nextOverlapping();
    }
    return i.done || i.value.from == n && i.value.to == r ? null : i.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(t, n, r) {
    for (let i = r; ; ) {
      let o = Math.max(n, i - 1e4 - this.spec.unquoted.length), s = sO(this.spec, t, o, i), l = null;
      for (; !s.nextOverlapping().done; )
        l = s.value;
      if (l)
        return l;
      if (o == n)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(t, n, r) {
    let i = this.prevMatchInRange(t, 0, n);
    return i || (i = this.prevMatchInRange(t, Math.max(0, r - this.spec.unquoted.length), t.doc.length)), i && (i.from != n || i.to != r) ? i : null;
  }
  getReplacement(t) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(t, n) {
    let r = sO(this.spec, t, 0, t.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(t, n, r, i) {
    let o = sO(this.spec, t, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, t.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
function aO(e, t, n, r) {
  return new K2e(t.doc, e.search, {
    ignoreCase: !e.caseSensitive,
    test: e.wholeWord ? m4t(t.charCategorizer(t.selection.main.head)) : void 0
  }, n, r);
}
function F_(e, t) {
  return e.slice(xs(e, t, !1), t);
}
function U_(e, t) {
  return e.slice(t, xs(e, t));
}
function m4t(e) {
  return (t, n, r) => !r[0].length || (e(F_(r.input, r.index)) != Oi.Word || e(U_(r.input, r.index)) != Oi.Word) && (e(U_(r.input, r.index + r[0].length)) != Oi.Word || e(F_(r.input, r.index + r[0].length)) != Oi.Word);
}
class g4t extends J2e {
  nextMatch(t, n, r) {
    let i = aO(this.spec, t, r, t.doc.length).next();
    return i.done && (i = aO(this.spec, t, 0, n).next()), i.done ? null : i.value;
  }
  prevMatchInRange(t, n, r) {
    for (let i = 1; ; i++) {
      let o = Math.max(
        n,
        r - i * 1e4
        /* FindPrev.ChunkSize */
      ), s = aO(this.spec, t, o, r), l = null;
      for (; !s.next().done; )
        l = s.value;
      if (l && (o == n || l.from > o + 10))
        return l;
      if (o == n)
        return null;
    }
  }
  prevMatch(t, n, r) {
    return this.prevMatchInRange(t, 0, n) || this.prevMatchInRange(t, r, t.doc.length);
  }
  getReplacement(t) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (n, r) => {
      if (r == "&")
        return t.match[0];
      if (r == "$")
        return "$";
      for (let i = r.length; i > 0; i--) {
        let o = +r.slice(0, i);
        if (o > 0 && o < t.match.length)
          return t.match[o] + r.slice(i);
      }
      return n;
    });
  }
  matchAll(t, n) {
    let r = aO(this.spec, t, 0, t.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(t, n, r, i) {
    let o = aO(this.spec, t, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, t.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
const xk = /* @__PURE__ */ _n.define(), nY = /* @__PURE__ */ _n.define(), Km = /* @__PURE__ */ cs.define({
  create(e) {
    return new GU(A8(e).create(), null);
  },
  update(e, t) {
    for (let n of t.effects)
      n.is(xk) ? e = new GU(n.value.create(), e.panel) : n.is(nY) && (e = new GU(e.query, n.value ? rY : null));
    return e;
  },
  provide: (e) => yk.from(e, (t) => t.panel)
});
class GU {
  constructor(t, n) {
    this.query = t, this.panel = n;
  }
}
const y4t = /* @__PURE__ */ ln.mark({ class: "cm-searchMatch" }), v4t = /* @__PURE__ */ ln.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), b4t = /* @__PURE__ */ Yi.fromClass(class {
  constructor(e) {
    this.view = e, this.decorations = this.highlight(e.state.field(Km));
  }
  update(e) {
    let t = e.state.field(Km);
    (t != e.startState.field(Km) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
  }
  highlight({ query: e, panel: t }) {
    if (!t || !e.spec.valid)
      return ln.none;
    let { view: n } = this, r = new hh();
    for (let i = 0, o = n.visibleRanges, s = o.length; i < s; i++) {
      let { from: l, to: c } = o[i];
      for (; i < s - 1 && c > o[i + 1].from - 2 * 250; )
        c = o[++i].to;
      e.highlight(n.state, l, c, (a, u) => {
        let f = n.state.selection.ranges.some((d) => d.from == a && d.to == u);
        r.add(a, u, f ? v4t : y4t);
      });
    }
    return r.finish();
  }
}, {
  decorations: (e) => e.decorations
});
function DN(e) {
  return (t) => {
    let n = t.state.field(Km, !1);
    return n && n.query.spec.valid ? e(t, n) : nze(t);
  };
}
const V_ = /* @__PURE__ */ DN((e, { query: t }) => {
  let { to: n } = e.state.selection.main, r = t.nextMatch(e.state, n, n);
  if (!r)
    return !1;
  let i = rt.single(r.from, r.to), o = e.state.facet(Rx);
  return e.dispatch({
    selection: i,
    effects: [iY(e, r), o.scrollToMatch(i.main, e)],
    userEvent: "select.search"
  }), tze(e), !0;
}), q_ = /* @__PURE__ */ DN((e, { query: t }) => {
  let { state: n } = e, { from: r } = n.selection.main, i = t.prevMatch(n, r, r);
  if (!i)
    return !1;
  let o = rt.single(i.from, i.to), s = e.state.facet(Rx);
  return e.dispatch({
    selection: o,
    effects: [iY(e, i), s.scrollToMatch(o.main, e)],
    userEvent: "select.search"
  }), tze(e), !0;
}), O4t = /* @__PURE__ */ DN((e, { query: t }) => {
  let n = t.matchAll(e.state, 1e3);
  return !n || !n.length ? !1 : (e.dispatch({
    selection: rt.create(n.map((r) => rt.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), A4t = ({ state: e, dispatch: t }) => {
  let n = e.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: i } = n.main, o = [], s = 0;
  for (let l = new kw(e.doc, e.sliceDoc(r, i)); !l.next().done; ) {
    if (o.length > 1e3)
      return !1;
    l.value.from == r && (s = o.length), o.push(rt.range(l.value.from, l.value.to));
  }
  return t(e.update({
    selection: rt.create(o, s),
    userEvent: "select.search.matches"
  })), !0;
}, gde = /* @__PURE__ */ DN((e, { query: t }) => {
  let { state: n } = e, { from: r, to: i } = n.selection.main;
  if (n.readOnly)
    return !1;
  let o = t.nextMatch(n, r, r);
  if (!o)
    return !1;
  let s = o, l = [], c, a, u = [];
  s.from == r && s.to == i && (a = n.toText(t.getReplacement(s)), l.push({ from: s.from, to: s.to, insert: a }), s = t.nextMatch(n, s.from, s.to), u.push(kt.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + ".")));
  let f = e.state.changes(l);
  return s && (c = rt.single(s.from, s.to).map(f), u.push(iY(e, s)), u.push(n.facet(Rx).scrollToMatch(c.main, e))), e.dispatch({
    changes: f,
    selection: c,
    effects: u,
    userEvent: "input.replace"
  }), !0;
}), w4t = /* @__PURE__ */ DN((e, { query: t }) => {
  if (e.state.readOnly)
    return !1;
  let n = t.matchAll(e.state, 1e9).map((i) => {
    let { from: o, to: s } = i;
    return { from: o, to: s, insert: t.getReplacement(i) };
  });
  if (!n.length)
    return !1;
  let r = e.state.phrase("replaced $ matches", n.length) + ".";
  return e.dispatch({
    changes: n,
    effects: kt.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function rY(e) {
  return e.state.facet(Rx).createPanel(e);
}
function A8(e, t) {
  var n, r, i, o, s;
  let l = e.selection.main, c = l.empty || l.to > l.from + 100 ? "" : e.sliceDoc(l.from, l.to);
  if (t && !c)
    return t;
  let a = e.facet(Rx);
  return new Y2e({
    search: ((n = t == null ? void 0 : t.literal) !== null && n !== void 0 ? n : a.literal) ? c : c.replace(/\n/g, "\\n"),
    caseSensitive: (r = t == null ? void 0 : t.caseSensitive) !== null && r !== void 0 ? r : a.caseSensitive,
    literal: (i = t == null ? void 0 : t.literal) !== null && i !== void 0 ? i : a.literal,
    regexp: (o = t == null ? void 0 : t.regexp) !== null && o !== void 0 ? o : a.regexp,
    wholeWord: (s = t == null ? void 0 : t.wholeWord) !== null && s !== void 0 ? s : a.wholeWord
  });
}
function eze(e) {
  let t = gk(e, rY);
  return t && t.dom.querySelector("[main-field]");
}
function tze(e) {
  let t = eze(e);
  t && t == e.root.activeElement && t.select();
}
const nze = (e) => {
  let t = e.state.field(Km, !1);
  if (t && t.panel) {
    let n = eze(e);
    if (n && n != e.root.activeElement) {
      let r = A8(e.state, t.query.spec);
      r.valid && e.dispatch({ effects: xk.of(r) }), n.focus(), n.select();
    }
  } else
    e.dispatch({ effects: [
      nY.of(!0),
      t ? xk.of(A8(e.state, t.query.spec)) : _n.appendConfig.of(T4t)
    ] });
  return !0;
}, rze = (e) => {
  let t = e.state.field(Km, !1);
  if (!t || !t.panel)
    return !1;
  let n = gk(e, rY);
  return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({ effects: nY.of(!1) }), !0;
}, x4t = [
  { key: "Mod-f", run: nze, scope: "editor search-panel" },
  { key: "F3", run: V_, shift: q_, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: V_, shift: q_, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: rze, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: A4t },
  { key: "Mod-Alt-g", run: e4t },
  { key: "Mod-d", run: f4t, preventDefault: !0 }
];
class S4t {
  constructor(t) {
    this.view = t;
    let n = this.query = t.state.field(Km).query.spec;
    this.commit = this.commit.bind(this), this.searchField = qr("input", {
      value: n.search,
      placeholder: Dl(t, "Find"),
      "aria-label": Dl(t, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = qr("input", {
      value: n.replace,
      placeholder: Dl(t, "Replace"),
      "aria-label": Dl(t, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = qr("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = qr("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = qr("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(i, o, s) {
      return qr("button", { class: "cm-button", name: i, onclick: o, type: "button" }, s);
    }
    this.dom = qr("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      r("next", () => V_(t), [Dl(t, "next")]),
      r("prev", () => q_(t), [Dl(t, "previous")]),
      r("select", () => O4t(t), [Dl(t, "all")]),
      qr("label", null, [this.caseField, Dl(t, "match case")]),
      qr("label", null, [this.reField, Dl(t, "regexp")]),
      qr("label", null, [this.wordField, Dl(t, "by word")]),
      ...t.state.readOnly ? [] : [
        qr("br"),
        this.replaceField,
        r("replace", () => gde(t), [Dl(t, "replace")]),
        r("replaceAll", () => w4t(t), [Dl(t, "replace all")])
      ],
      qr("button", {
        name: "close",
        onclick: () => rze(t),
        "aria-label": Dl(t, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let t = new Y2e({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    t.eq(this.query) || (this.query = t, this.view.dispatch({ effects: xk.of(t) }));
  }
  keydown(t) {
    z3t(this.view, t, "search-panel") ? t.preventDefault() : t.keyCode == 13 && t.target == this.searchField ? (t.preventDefault(), (t.shiftKey ? q_ : V_)(this.view)) : t.keyCode == 13 && t.target == this.replaceField && (t.preventDefault(), gde(this.view));
  }
  update(t) {
    for (let n of t.transactions)
      for (let r of n.effects)
        r.is(xk) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(t) {
    this.query = t, this.searchField.value = t.search, this.replaceField.value = t.replace, this.caseField.checked = t.caseSensitive, this.reField.checked = t.regexp, this.wordField.checked = t.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Rx).top;
  }
}
function Dl(e, t) {
  return e.state.phrase(t);
}
const VI = 30, qI = /[\s\.,:;?!]/;
function iY(e, { from: t, to: n }) {
  let r = e.state.doc.lineAt(t), i = e.state.doc.lineAt(n).to, o = Math.max(r.from, t - VI), s = Math.min(i, n + VI), l = e.state.sliceDoc(o, s);
  if (o != r.from) {
    for (let c = 0; c < VI; c++)
      if (!qI.test(l[c + 1]) && qI.test(l[c])) {
        l = l.slice(c);
        break;
      }
  }
  if (s != i) {
    for (let c = l.length - 1; c > l.length - VI; c--)
      if (!qI.test(l[c - 1]) && qI.test(l[c])) {
        l = l.slice(0, c);
        break;
      }
  }
  return kt.announce.of(`${e.state.phrase("current match")}. ${l} ${e.state.phrase("on line")} ${r.number}.`);
}
const E4t = /* @__PURE__ */ kt.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), T4t = [
  Km,
  /* @__PURE__ */ Dg.low(b4t),
  E4t
];
class yde {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.diagnostic = r;
  }
}
class Oy {
  constructor(t, n, r) {
    this.diagnostics = t, this.panel = n, this.selected = r;
  }
  static init(t, n, r) {
    let i = r.facet(Sk).markerFilter;
    i && (t = i(t, r));
    let o = t.slice().sort((u, f) => u.from - f.from || u.to - f.to), s = new hh(), l = [], c = 0;
    for (let u = 0; ; ) {
      let f = u == o.length ? null : o[u];
      if (!f && !l.length)
        break;
      let d, p;
      for (l.length ? (d = c, p = l.reduce((m, v) => Math.min(m, v.to), f && f.from > d ? f.from : 1e8)) : (d = f.from, p = f.to, l.push(f), u++); u < o.length; ) {
        let m = o[u];
        if (m.from == d && (m.to > m.from || m.to == d))
          l.push(m), u++, p = Math.min(m.to, p);
        else {
          p = Math.min(m.from, p);
          break;
        }
      }
      let h = F4t(l);
      if (l.some((m) => m.from == m.to || m.from == m.to - 1 && r.doc.lineAt(m.from).to == m.from))
        s.add(d, d, ln.widget({
          widget: new _4t(h),
          diagnostics: l.slice()
        }));
      else {
        let m = l.reduce((v, b) => b.markClass ? v + " " + b.markClass : v, "");
        s.add(d, p, ln.mark({
          class: "cm-lintRange cm-lintRange-" + h + m,
          diagnostics: l.slice(),
          inclusiveEnd: l.some((v) => v.to > p)
        }));
      }
      c = p;
      for (let m = 0; m < l.length; m++)
        l[m].to <= c && l.splice(m--, 1);
    }
    let a = s.finish();
    return new Oy(a, n, Cw(a));
  }
}
function Cw(e, t = null, n = 0) {
  let r = null;
  return e.between(n, 1e9, (i, o, { spec: s }) => {
    if (!(t && s.diagnostics.indexOf(t) < 0))
      if (!r)
        r = new yde(i, o, t || s.diagnostics[0]);
      else {
        if (s.diagnostics.indexOf(r.diagnostic) < 0)
          return !1;
        r = new yde(r.from, o, r.diagnostic);
      }
  }), r;
}
function k4t(e, t) {
  let n = t.pos, r = t.end || n, i = e.state.facet(Sk).hideOn(e, n, r);
  if (i != null)
    return i;
  let o = e.startState.doc.lineAt(t.pos);
  return !!(e.effects.some((s) => s.is(ize)) || e.changes.touchesRange(o.from, Math.max(o.to, r)));
}
function C4t(e, t) {
  return e.field(ec, !1) ? t : t.concat(_n.appendConfig.of(U4t));
}
const ize = /* @__PURE__ */ _n.define(), oY = /* @__PURE__ */ _n.define(), oze = /* @__PURE__ */ _n.define(), ec = /* @__PURE__ */ cs.define({
  create() {
    return new Oy(ln.none, null, null);
  },
  update(e, t) {
    if (t.docChanged && e.diagnostics.size) {
      let n = e.diagnostics.map(t.changes), r = null, i = e.panel;
      if (e.selected) {
        let o = t.changes.mapPos(e.selected.from, 1);
        r = Cw(n, e.selected.diagnostic, o) || Cw(n, null, o);
      }
      !n.size && i && t.state.facet(Sk).autoPanel && (i = null), e = new Oy(n, i, r);
    }
    for (let n of t.effects)
      if (n.is(ize)) {
        let r = t.state.facet(Sk).autoPanel ? n.value.length ? Ek.open : null : e.panel;
        e = Oy.init(n.value, r, t.state);
      } else n.is(oY) ? e = new Oy(e.diagnostics, n.value ? Ek.open : null, e.selected) : n.is(oze) && (e = new Oy(e.diagnostics, e.panel, n.value));
    return e;
  },
  provide: (e) => [
    yk.from(e, (t) => t.panel),
    kt.decorations.from(e, (t) => t.diagnostics)
  ]
}), N4t = /* @__PURE__ */ ln.mark({ class: "cm-lintRange cm-lintRange-active" });
function P4t(e, t, n) {
  let { diagnostics: r } = e.state.field(ec), i, o = -1, s = -1;
  r.between(t - (n < 0 ? 1 : 0), t + (n > 0 ? 1 : 0), (c, a, { spec: u }) => {
    if (t >= c && t <= a && (c == a || (t > c || n > 0) && (t < a || n < 0)))
      return i = u.diagnostics, o = c, s = a, !1;
  });
  let l = e.state.facet(Sk).tooltipFilter;
  return i && l && (i = l(i, e.state)), i ? {
    pos: o,
    end: s,
    above: e.state.doc.lineAt(o).to < s,
    create() {
      return { dom: I4t(e, i) };
    }
  } : null;
}
function I4t(e, t) {
  return qr("ul", { class: "cm-tooltip-lint" }, t.map((n) => aze(e, n, !1)));
}
const R4t = (e) => {
  let t = e.state.field(ec, !1);
  (!t || !t.panel) && e.dispatch({ effects: C4t(e.state, [oY.of(!0)]) });
  let n = gk(e, Ek.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, vde = (e) => {
  let t = e.state.field(ec, !1);
  return !t || !t.panel ? !1 : (e.dispatch({ effects: oY.of(!1) }), !0);
}, M4t = (e) => {
  let t = e.state.field(ec, !1);
  if (!t)
    return !1;
  let n = e.state.selection.main, r = t.diagnostics.iter(n.to + 1);
  return !r.value && (r = t.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (e.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, D4t = [
  { key: "Mod-Shift-m", run: R4t, preventDefault: !0 },
  { key: "F8", run: M4t }
], Sk = /* @__PURE__ */ Ht.define({
  combine(e) {
    return Object.assign({ sources: e.map((t) => t.source).filter((t) => t != null) }, Vf(e.map((t) => t.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null,
      hideOn: () => null
    }, {
      needsRefresh: (t, n) => t ? n ? (r) => t(r) || n(r) : t : n
    }));
  }
});
function sze(e) {
  let t = [];
  if (e)
    e: for (let { name: n } of e) {
      for (let r = 0; r < n.length; r++) {
        let i = n[r];
        if (/[a-zA-Z]/.test(i) && !t.some((o) => o.toLowerCase() == i.toLowerCase())) {
          t.push(i);
          continue e;
        }
      }
      t.push("");
    }
  return t;
}
function aze(e, t, n) {
  var r;
  let i = n ? sze(t.actions) : [];
  return qr("li", { class: "cm-diagnostic cm-diagnostic-" + t.severity }, qr("span", { class: "cm-diagnosticText" }, t.renderMessage ? t.renderMessage(e) : t.message), (r = t.actions) === null || r === void 0 ? void 0 : r.map((o, s) => {
    let l = !1, c = (d) => {
      if (d.preventDefault(), l)
        return;
      l = !0;
      let p = Cw(e.state.field(ec).diagnostics, t);
      p && o.apply(e, p.from, p.to);
    }, { name: a } = o, u = i[s] ? a.indexOf(i[s]) : -1, f = u < 0 ? a : [
      a.slice(0, u),
      qr("u", a.slice(u, u + 1)),
      a.slice(u + 1)
    ];
    return qr("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: c,
      onmousedown: c,
      "aria-label": ` Action: ${a}${u < 0 ? "" : ` (access key "${i[s]})"`}.`
    }, f);
  }), t.source && qr("div", { class: "cm-diagnosticSource" }, t.source));
}
class _4t extends qf {
  constructor(t) {
    super(), this.sev = t;
  }
  eq(t) {
    return t.sev == this.sev;
  }
  toDOM() {
    return qr("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class bde {
  constructor(t, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = aze(t, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class Ek {
  constructor(t) {
    this.view = t, this.items = [];
    let n = (i) => {
      if (i.keyCode == 27)
        vde(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: o } = this.items[this.selectedIndex], s = sze(o.actions);
        for (let l = 0; l < s.length; l++)
          if (s[l].toUpperCase().charCodeAt(0) == i.keyCode) {
            let c = Cw(this.view.state.field(ec).diagnostics, o);
            c && o.actions[l].apply(t, c.from, c.to);
          }
      } else
        return;
      i.preventDefault();
    }, r = (i) => {
      for (let o = 0; o < this.items.length; o++)
        this.items[o].dom.contains(i.target) && this.moveSelection(o);
    };
    this.list = qr("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = qr("div", { class: "cm-panel-lint" }, this.list, qr("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => vde(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let t = this.view.state.field(ec).selected;
    if (!t)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == t.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: t, selected: n } = this.view.state.field(ec), r = 0, i = !1, o = null, s = /* @__PURE__ */ new Set();
    for (t.between(0, this.view.state.doc.length, (l, c, { spec: a }) => {
      for (let u of a.diagnostics) {
        if (s.has(u))
          continue;
        s.add(u);
        let f = -1, d;
        for (let p = r; p < this.items.length; p++)
          if (this.items[p].diagnostic == u) {
            f = p;
            break;
          }
        f < 0 ? (d = new bde(this.view, u), this.items.splice(r, 0, d), i = !0) : (d = this.items[f], f > r && (this.items.splice(r, f - r), i = !0)), n && d.diagnostic == n.diagnostic ? d.dom.hasAttribute("aria-selected") || (d.dom.setAttribute("aria-selected", "true"), o = d) : d.dom.hasAttribute("aria-selected") && d.dom.removeAttribute("aria-selected"), r++;
      }
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new bde(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), o ? (this.list.setAttribute("aria-activedescendant", o.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: o.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: l, panel: c }) => {
        let a = c.height / this.list.offsetHeight;
        l.top < c.top ? this.list.scrollTop -= (c.top - l.top) / a : l.bottom > c.bottom && (this.list.scrollTop += (l.bottom - c.bottom) / a);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let t = this.list.firstChild;
    function n() {
      let r = t;
      t = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; t != r.dom; )
          n();
        t = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, t);
    for (; t; )
      n();
  }
  moveSelection(t) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(ec), r = Cw(n.diagnostics, this.items[t].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: oze.of(r)
    });
  }
  static open(t) {
    return new Ek(t);
  }
}
function L4t(e, t = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${t}>${encodeURIComponent(e)}</svg>')`;
}
function BI(e) {
  return L4t(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${e}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const z4t = /* @__PURE__ */ kt.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ BI("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ BI("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ BI("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ BI("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function j4t(e) {
  return e == "error" ? 4 : e == "warning" ? 3 : e == "info" ? 2 : 1;
}
function F4t(e) {
  let t = "hint", n = 1;
  for (let r of e) {
    let i = j4t(r.severity);
    i > n && (n = i, t = r.severity);
  }
  return t;
}
const U4t = [
  ec,
  /* @__PURE__ */ kt.decorations.compute([ec], (e) => {
    let { selected: t, panel: n } = e.field(ec);
    return !t || !n || t.from == t.to ? ln.none : ln.set([
      N4t.range(t.from, t.to)
    ]);
  }),
  /* @__PURE__ */ EFt(P4t, { hideOn: k4t }),
  z4t
];
var Ode = function(t) {
  t === void 0 && (t = {});
  var {
    crosshairCursor: n = !1
  } = t, r = [];
  t.closeBracketsKeymap !== !1 && (r = r.concat(g6t)), t.defaultKeymap !== !1 && (r = r.concat(GUt)), t.searchKeymap !== !1 && (r = r.concat(x4t)), t.historyKeymap !== !1 && (r = r.concat(sUt)), t.foldKeymap !== !1 && (r = r.concat(a5t)), t.completionKeymap !== !1 && (r = r.concat(a2e)), t.lintKeymap !== !1 && (r = r.concat(D4t));
  var i = [];
  return t.lineNumbers !== !1 && i.push(LFt()), t.highlightActiveLineGutter !== !1 && i.push(FFt()), t.highlightSpecialChars !== !1 && i.push(eFt()), t.history !== !1 && i.push(G6t()), t.foldGutter !== !1 && i.push(d5t()), t.drawSelection !== !1 && i.push(B3t()), t.dropCursor !== !1 && i.push(Q3t()), t.allowMultipleSelections !== !1 && i.push($n.allowMultipleSelections.of(!0)), t.indentOnInput !== !1 && i.push(YFt()), t.syntaxHighlighting !== !1 && i.push(XG(m5t, {
    fallback: !0
  })), t.bracketMatching !== !1 && i.push(w5t()), t.closeBrackets !== !1 && i.push(f6t()), t.autocompletion !== !1 && i.push(x6t()), t.rectangularSelection !== !1 && i.push(hFt()), n !== !1 && i.push(yFt()), t.highlightActiveLine !== !1 && i.push(sFt()), t.highlightSelectionMatches !== !1 && i.push(i4t()), t.tabSize && typeof t.tabSize == "number" && i.push(PN.of(" ".repeat(t.tabSize))), i.concat([CN.of(r.flat())]).filter(Boolean);
};
let V4t = 0;
class ss {
  /**
  Create a new node prop type.
  */
  constructor(t = {}) {
    this.id = V4t++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    }), this.combine = t.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(t) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Tk.match(t)), (n) => {
      let r = t(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
ss.closedBy = new ss({ deserialize: (e) => e.split(" ") });
ss.openedBy = new ss({ deserialize: (e) => e.split(" ") });
ss.group = new ss({ deserialize: (e) => e.split(" ") });
ss.isolate = new ss({ deserialize: (e) => {
  if (e && e != "rtl" && e != "ltr" && e != "auto")
    throw new RangeError("Invalid value for isolate: " + e);
  return e || "auto";
} });
ss.contextHash = new ss({ perNode: !0 });
ss.lookAhead = new ss({ perNode: !0 });
ss.mounted = new ss({ perNode: !0 });
const q4t = /* @__PURE__ */ Object.create(null);
class Tk {
  /**
  @internal
  */
  constructor(t, n, r, i = 0) {
    this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(t) {
    let n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : q4t, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new Tk(t.name || "", n, t.id, r);
    if (t.props) {
      for (let o of t.props)
        if (Array.isArray(o) || (o = o(i)), o) {
          if (o[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[o[0].id] = o[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(t) {
    return this.props[t.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      let n = this.prop(ss.group);
      return n ? n.indexOf(t) > -1 : !1;
    }
    return this.id == t;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in t)
      for (let i of r.split(" "))
        n[i] = t[r];
    return (r) => {
      for (let i = r.prop(ss.group), o = -1; o < (i ? i.length : 0); o++) {
        let s = n[o < 0 ? r.name : i[o]];
        if (s)
          return s;
      }
    };
  }
}
Tk.none = new Tk(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
var Ade;
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays", e[e.EnterBracketed = 16] = "EnterBracketed";
})(Ade || (Ade = {}));
new ss({ perNode: !0 });
let B4t = 0;
class zc {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.set = n, this.base = r, this.modified = i, this.id = B4t++;
  }
  toString() {
    let { name: t } = this;
    for (let n of this.modified)
      n.name && (t = `${n.name}(${t})`);
    return t;
  }
  static define(t, n) {
    let r = typeof t == "string" ? t : "?";
    if (t instanceof zc && (n = t), n != null && n.base)
      throw new Error("Can not derive from a modified tag");
    let i = new zc(r, [], null, []);
    if (i.set.push(i), n)
      for (let o of n.set)
        i.set.push(o);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(t) {
    let n = new B_(t);
    return (r) => r.modified.indexOf(n) > -1 ? r : B_.get(r.base || r, r.modified.concat(n).sort((i, o) => i.id - o.id));
  }
}
let X4t = 0;
class B_ {
  constructor(t) {
    this.name = t, this.instances = [], this.id = X4t++;
  }
  static get(t, n) {
    if (!n.length)
      return t;
    let r = n[0].instances.find((l) => l.base == t && W4t(n, l.modified));
    if (r)
      return r;
    let i = [], o = new zc(t.name, i, t, n);
    for (let l of n)
      l.instances.push(o);
    let s = Z4t(n);
    for (let l of t.set)
      if (!l.modified.length)
        for (let c of s)
          i.push(B_.get(l, c));
    return o;
  }
}
function W4t(e, t) {
  return e.length == t.length && e.every((n, r) => n == t[r]);
}
function Z4t(e) {
  let t = [[]];
  for (let n = 0; n < e.length; n++)
    for (let r = 0, i = t.length; r < i; r++)
      t.push(t[r].concat(e[n]));
  return t.sort((n, r) => r.length - n.length);
}
new ss({
  combine(e, t) {
    let n, r, i;
    for (; e || t; ) {
      if (!e || t && e.depth >= t.depth ? (i = t, t = t.next) : (i = e, e = e.next), n && n.mode == i.mode && !i.context && !n.context)
        continue;
      let o = new w8(i.tags, i.mode, i.context);
      n ? n.next = o : r = o, n = o;
    }
    return r;
  }
});
class w8 {
  constructor(t, n, r, i) {
    this.tags = t, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
w8.empty = new w8([], 2, null);
function H4t(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of e)
    if (!Array.isArray(o.tag))
      n[o.tag.id] = o.class;
    else
      for (let s of o.tag)
        n[s.id] = o.class;
  let { scope: r, all: i = null } = {};
  return {
    style: (o) => {
      let s = i;
      for (let l of o)
        for (let c of l.set) {
          let a = n[c.id];
          if (a) {
            s = s ? s + " " + a : a;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
const Lt = zc.define, XI = Lt(), im = Lt(), wde = Lt(im), xde = Lt(im), om = Lt(), WI = Lt(om), YU = Lt(om), jd = Lt(), iy = Lt(jd), Dd = Lt(), _d = Lt(), x8 = Lt(), xS = Lt(x8), ZI = Lt(), St = {
  /**
  A comment.
  */
  comment: XI,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Lt(XI),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Lt(XI),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Lt(XI),
  /**
  Any kind of identifier.
  */
  name: im,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Lt(im),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: wde,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Lt(wde),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: xde,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Lt(xde),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Lt(im),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Lt(im),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Lt(im),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Lt(im),
  /**
  A literal value.
  */
  literal: om,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: WI,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Lt(WI),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Lt(WI),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Lt(WI),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: YU,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Lt(YU),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Lt(YU),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Lt(om),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Lt(om),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Lt(om),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Lt(om),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Lt(om),
  /**
  A language keyword.
  */
  keyword: Dd,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Lt(Dd),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Lt(Dd),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Lt(Dd),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Lt(Dd),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Lt(Dd),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Lt(Dd),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Lt(Dd),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Lt(Dd),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Lt(Dd),
  /**
  An operator.
  */
  operator: _d,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Lt(_d),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Lt(_d),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Lt(_d),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Lt(_d),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Lt(_d),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Lt(_d),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Lt(_d),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Lt(_d),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Lt(_d),
  /**
  Program or markup punctuation.
  */
  punctuation: x8,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Lt(x8),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: xS,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Lt(xS),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Lt(xS),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Lt(xS),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Lt(xS),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: jd,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: iy,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Lt(iy),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Lt(iy),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Lt(iy),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Lt(iy),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Lt(iy),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Lt(iy),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: Lt(jd),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Lt(jd),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Lt(jd),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Lt(jd),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Lt(jd),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Lt(jd),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Lt(jd),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Lt(jd),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Lt(),
  /**
  Deleted text.
  */
  deleted: Lt(),
  /**
  Changed text.
  */
  changed: Lt(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Lt(),
  /**
  Metadata or meta-instruction.
  */
  meta: ZI,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Lt(ZI),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Lt(ZI),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Lt(ZI),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: zc.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: zc.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: zc.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: zc.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: zc.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: zc.defineModifier("special")
};
for (let e in St) {
  let t = St[e];
  t instanceof zc && (t.name = e);
}
H4t([
  { tag: St.link, class: "tok-link" },
  { tag: St.heading, class: "tok-heading" },
  { tag: St.emphasis, class: "tok-emphasis" },
  { tag: St.strong, class: "tok-strong" },
  { tag: St.keyword, class: "tok-keyword" },
  { tag: St.atom, class: "tok-atom" },
  { tag: St.bool, class: "tok-bool" },
  { tag: St.url, class: "tok-url" },
  { tag: St.labelName, class: "tok-labelName" },
  { tag: St.inserted, class: "tok-inserted" },
  { tag: St.deleted, class: "tok-deleted" },
  { tag: St.literal, class: "tok-literal" },
  { tag: St.string, class: "tok-string" },
  { tag: St.number, class: "tok-number" },
  { tag: [St.regexp, St.escape, St.special(St.string)], class: "tok-string2" },
  { tag: St.variableName, class: "tok-variableName" },
  { tag: St.local(St.variableName), class: "tok-variableName tok-local" },
  { tag: St.definition(St.variableName), class: "tok-variableName tok-definition" },
  { tag: St.special(St.variableName), class: "tok-variableName2" },
  { tag: St.definition(St.propertyName), class: "tok-propertyName tok-definition" },
  { tag: St.typeName, class: "tok-typeName" },
  { tag: St.namespace, class: "tok-namespace" },
  { tag: St.className, class: "tok-className" },
  { tag: St.macroName, class: "tok-macroName" },
  { tag: St.propertyName, class: "tok-propertyName" },
  { tag: St.operator, class: "tok-operator" },
  { tag: St.comment, class: "tok-comment" },
  { tag: St.meta, class: "tok-meta" },
  { tag: St.invalid, class: "tok-invalid" },
  { tag: St.punctuation, class: "tok-punctuation" }
]);
const Q4t = "#e5c07b", Sde = "#e06c75", $4t = "#56b6c2", K4t = "#ffffff", bM = "#abb2bf", S8 = "#7d8799", G4t = "#61afef", Y4t = "#98c379", Ede = "#d19a66", J4t = "#c678dd", eVt = "#21252b", Tde = "#2c313a", kde = "#282c34", JU = "#353a42", tVt = "#3E4451", Cde = "#528bff", nVt = /* @__PURE__ */ kt.theme({
  "&": {
    color: bM,
    backgroundColor: kde
  },
  ".cm-content": {
    caretColor: Cde
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: Cde },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: tVt },
  ".cm-panels": { backgroundColor: eVt, color: bM },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: kde,
    color: S8,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: Tde
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: JU
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: JU,
    borderBottomColor: JU
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: Tde,
      color: bM
    }
  }
}, { dark: !0 }), rVt = /* @__PURE__ */ Nx.define([
  {
    tag: St.keyword,
    color: J4t
  },
  {
    tag: [St.name, St.deleted, St.character, St.propertyName, St.macroName],
    color: Sde
  },
  {
    tag: [/* @__PURE__ */ St.function(St.variableName), St.labelName],
    color: G4t
  },
  {
    tag: [St.color, /* @__PURE__ */ St.constant(St.name), /* @__PURE__ */ St.standard(St.name)],
    color: Ede
  },
  {
    tag: [/* @__PURE__ */ St.definition(St.name), St.separator],
    color: bM
  },
  {
    tag: [St.typeName, St.className, St.number, St.changed, St.annotation, St.modifier, St.self, St.namespace],
    color: Q4t
  },
  {
    tag: [St.operator, St.operatorKeyword, St.url, St.escape, St.regexp, St.link, /* @__PURE__ */ St.special(St.string)],
    color: $4t
  },
  {
    tag: [St.meta, St.comment],
    color: S8
  },
  {
    tag: St.strong,
    fontWeight: "bold"
  },
  {
    tag: St.emphasis,
    fontStyle: "italic"
  },
  {
    tag: St.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: St.link,
    color: S8,
    textDecoration: "underline"
  },
  {
    tag: St.heading,
    fontWeight: "bold",
    color: Sde
  },
  {
    tag: [St.atom, St.bool, /* @__PURE__ */ St.special(St.variableName)],
    color: Ede
  },
  {
    tag: [St.processingInstruction, St.string, St.inserted],
    color: Y4t
  },
  {
    tag: St.invalid,
    color: K4t
  }
]), iVt = [nVt, /* @__PURE__ */ XG(rVt)];
var oVt = kt.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: !1
}), sVt = function(t) {
  t === void 0 && (t = {});
  var {
    indentWithTab: n = !0,
    editable: r = !0,
    readOnly: i = !1,
    theme: o = "light",
    placeholder: s = "",
    basicSetup: l = !0
  } = t, c = [];
  switch (n && c.unshift(CN.of([YUt])), l && (typeof l == "boolean" ? c.unshift(Ode()) : c.unshift(Ode(l))), s && c.unshift(uFt(s)), o) {
    case "light":
      c.push(oVt);
      break;
    case "dark":
      c.push(iVt);
      break;
    case "none":
      break;
    default:
      c.push(o);
      break;
  }
  return r === !1 && c.push(kt.editable.of(!1)), i && c.push($n.readOnly.of(!0)), [...c];
}, aVt = (e) => ({
  line: e.state.doc.lineAt(e.state.selection.main.from),
  lineCount: e.state.doc.lines,
  lineBreak: e.state.lineBreak,
  length: e.state.doc.length,
  readOnly: e.state.readOnly,
  tabSize: e.state.tabSize,
  selection: e.state.selection,
  selectionAsSingle: e.state.selection.asSingle().main,
  ranges: e.state.selection.ranges,
  selectionCode: e.state.sliceDoc(e.state.selection.main.from, e.state.selection.main.to),
  selections: e.state.selection.ranges.map((t) => e.state.sliceDoc(t.from, t.to)),
  selectedText: e.state.selection.ranges.some((t) => !t.empty)
}), Nde = Uf.define(), lVt = [];
function cVt(e) {
  var {
    value: t,
    selection: n,
    onChange: r,
    onStatistics: i,
    onCreateEditor: o,
    onUpdate: s,
    extensions: l = lVt,
    autoFocus: c,
    theme: a = "light",
    height: u = null,
    minHeight: f = null,
    maxHeight: d = null,
    width: p = null,
    minWidth: h = null,
    maxWidth: m = null,
    placeholder: v = "",
    editable: b = !0,
    readOnly: A = !1,
    indentWithTab: w = !0,
    basicSetup: O = !0,
    root: x,
    initialState: S
  } = e, [E, k] = He(), [T, R] = He(), [j, F] = He(), L = kt.theme({
    "&": {
      height: u,
      minHeight: f,
      maxHeight: d,
      width: p,
      minWidth: h,
      maxWidth: m
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  }), _ = kt.updateListener.of((C) => {
    if (C.docChanged && typeof r == "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !C.transactions.some((D) => D.annotation(Nde))) {
      var I = C.state.doc, M = I.toString();
      r(M, C);
    }
    i && i(aVt(C));
  }), U = sVt({
    theme: a,
    editable: b,
    readOnly: A,
    placeholder: v,
    indentWithTab: w,
    basicSetup: O
  }), z = [_, L, ...U];
  return s && typeof s == "function" && z.push(kt.updateListener.of(s)), z = z.concat(l), nt(() => {
    if (E && !j) {
      var C = {
        doc: t,
        selection: n,
        extensions: z
      }, I = S ? $n.fromJSON(S.json, C, S.fields) : $n.create(C);
      if (F(I), !T) {
        var M = new kt({
          state: I,
          parent: E,
          root: x
        });
        R(M), o && o(M, I);
      }
    }
    return () => {
      T && (F(void 0), R(void 0));
    };
  }, [E, j]), nt(() => k(e.container), [e.container]), nt(() => () => {
    T && (T.destroy(), R(void 0));
  }, [T]), nt(() => {
    c && T && T.focus();
  }, [c, T]), nt(() => {
    T && T.dispatch({
      effects: _n.reconfigure.of(z)
    });
  }, [a, l, u, f, d, p, h, m, v, b, A, w, O, r, s]), nt(() => {
    if (t !== void 0) {
      var C = T ? T.state.doc.toString() : "";
      T && t !== C && T.dispatch({
        changes: {
          from: 0,
          to: C.length,
          insert: t || ""
        },
        annotations: [Nde.of(!0)]
      });
    }
  }, [t, T]), {
    state: j,
    setState: F,
    view: T,
    setView: R,
    container: E,
    setContainer: k
  };
}
var uVt = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"], r3 = /* @__PURE__ */ Fo((e, t) => {
  var {
    className: n,
    value: r = "",
    selection: i,
    extensions: o = [],
    onChange: s,
    onStatistics: l,
    onCreateEditor: c,
    onUpdate: a,
    autoFocus: u,
    theme: f = "light",
    height: d,
    minHeight: p,
    maxHeight: h,
    width: m,
    minWidth: v,
    maxWidth: b,
    basicSetup: A,
    placeholder: w,
    indentWithTab: O,
    editable: x,
    readOnly: S,
    root: E,
    initialState: k
  } = e, T = LDe(e, uVt), R = Xe(null), {
    state: j,
    view: F,
    container: L
  } = cVt({
    container: R.current,
    root: E,
    value: r,
    autoFocus: u,
    theme: f,
    height: d,
    minHeight: p,
    maxHeight: h,
    width: m,
    minWidth: v,
    maxWidth: b,
    basicSetup: A,
    placeholder: w,
    indentWithTab: O,
    editable: x,
    readOnly: S,
    selection: i,
    onChange: s,
    onStatistics: l,
    onCreateEditor: c,
    onUpdate: a,
    extensions: o,
    initialState: k
  });
  if (rW(t, () => ({
    editor: R.current,
    state: j,
    view: F
  }), [R, L, j, F]), typeof r != "string")
    throw new Error("value must be typeof string but got " + typeof r);
  var _ = typeof f == "string" ? "cm-theme-" + f : "cm-theme";
  return /* @__PURE__ */ y("div", Ow({
    ref: R,
    className: "" + _ + (n ? " " + n : "")
  }, T));
});
r3.displayName = "CodeMirror";
function dVt(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const fVt = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, pVt = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, hVt = {};
function Pde(e, t) {
  return (hVt.jsx ? pVt : fVt).test(e);
}
const mVt = /[ \t\n\f\r]/g;
function gVt(e) {
  return typeof e == "object" ? e.type === "text" ? Ide(e.value) : !1 : Ide(e);
}
function Ide(e) {
  return e.replace(mVt, "") === "";
}
class _N {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
_N.prototype.normal = {};
_N.prototype.property = {};
_N.prototype.space = void 0;
function lze(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new _N(n, r, t);
}
function E8(e) {
  return e.toLowerCase();
}
class Cl {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Cl.prototype.attribute = "";
Cl.prototype.booleanish = !1;
Cl.prototype.boolean = !1;
Cl.prototype.commaOrSpaceSeparated = !1;
Cl.prototype.commaSeparated = !1;
Cl.prototype.defined = !1;
Cl.prototype.mustUseProperty = !1;
Cl.prototype.number = !1;
Cl.prototype.overloadedBoolean = !1;
Cl.prototype.property = "";
Cl.prototype.spaceSeparated = !1;
Cl.prototype.space = void 0;
let yVt = 0;
const Vn = Mb(), lo = Mb(), T8 = Mb(), vt = Mb(), Yr = Mb(), sA = Mb(), jl = Mb();
function Mb() {
  return 2 ** ++yVt;
}
const k8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Vn,
  booleanish: lo,
  commaOrSpaceSeparated: jl,
  commaSeparated: sA,
  number: vt,
  overloadedBoolean: T8,
  spaceSeparated: Yr
}, Symbol.toStringTag, { value: "Module" })), e4 = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(k8)
);
class sY extends Cl {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), Rde(this, "space", i), typeof r == "number")
      for (; ++o < e4.length; ) {
        const s = e4[o];
        Rde(this, e4[o], (r & k8[s]) === k8[s]);
      }
  }
}
sY.prototype.defined = !0;
function Rde(e, t, n) {
  n && (e[t] = n);
}
function Mx(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const o = new sY(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[E8(r)] = r, n[E8(o.attribute)] = r;
  }
  return new _N(t, n, e.space);
}
const cze = Mx({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: lo,
    ariaAutoComplete: null,
    ariaBusy: lo,
    ariaChecked: lo,
    ariaColCount: vt,
    ariaColIndex: vt,
    ariaColSpan: vt,
    ariaControls: Yr,
    ariaCurrent: null,
    ariaDescribedBy: Yr,
    ariaDetails: null,
    ariaDisabled: lo,
    ariaDropEffect: Yr,
    ariaErrorMessage: null,
    ariaExpanded: lo,
    ariaFlowTo: Yr,
    ariaGrabbed: lo,
    ariaHasPopup: null,
    ariaHidden: lo,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Yr,
    ariaLevel: vt,
    ariaLive: null,
    ariaModal: lo,
    ariaMultiLine: lo,
    ariaMultiSelectable: lo,
    ariaOrientation: null,
    ariaOwns: Yr,
    ariaPlaceholder: null,
    ariaPosInSet: vt,
    ariaPressed: lo,
    ariaReadOnly: lo,
    ariaRelevant: null,
    ariaRequired: lo,
    ariaRoleDescription: Yr,
    ariaRowCount: vt,
    ariaRowIndex: vt,
    ariaRowSpan: vt,
    ariaSelected: lo,
    ariaSetSize: vt,
    ariaSort: null,
    ariaValueMax: vt,
    ariaValueMin: vt,
    ariaValueNow: vt,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function uze(e, t) {
  return t in e ? e[t] : t;
}
function dze(e, t) {
  return uze(e, t.toLowerCase());
}
const vVt = Mx({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: sA,
    acceptCharset: Yr,
    accessKey: Yr,
    action: null,
    allow: null,
    allowFullScreen: Vn,
    allowPaymentRequest: Vn,
    allowUserMedia: Vn,
    alt: null,
    as: null,
    async: Vn,
    autoCapitalize: null,
    autoComplete: Yr,
    autoFocus: Vn,
    autoPlay: Vn,
    blocking: Yr,
    capture: null,
    charSet: null,
    checked: Vn,
    cite: null,
    className: Yr,
    cols: vt,
    colSpan: null,
    content: null,
    contentEditable: lo,
    controls: Vn,
    controlsList: Yr,
    coords: vt | sA,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Vn,
    defer: Vn,
    dir: null,
    dirName: null,
    disabled: Vn,
    download: T8,
    draggable: lo,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Vn,
    formTarget: null,
    headers: Yr,
    height: vt,
    hidden: T8,
    high: vt,
    href: null,
    hrefLang: null,
    htmlFor: Yr,
    httpEquiv: Yr,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Vn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Vn,
    itemId: null,
    itemProp: Yr,
    itemRef: Yr,
    itemScope: Vn,
    itemType: Yr,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Vn,
    low: vt,
    manifest: null,
    max: null,
    maxLength: vt,
    media: null,
    method: null,
    min: null,
    minLength: vt,
    multiple: Vn,
    muted: Vn,
    name: null,
    nonce: null,
    noModule: Vn,
    noValidate: Vn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Vn,
    optimum: vt,
    pattern: null,
    ping: Yr,
    placeholder: null,
    playsInline: Vn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Vn,
    referrerPolicy: null,
    rel: Yr,
    required: Vn,
    reversed: Vn,
    rows: vt,
    rowSpan: vt,
    sandbox: Yr,
    scope: null,
    scoped: Vn,
    seamless: Vn,
    selected: Vn,
    shadowRootClonable: Vn,
    shadowRootDelegatesFocus: Vn,
    shadowRootMode: null,
    shape: null,
    size: vt,
    sizes: null,
    slot: null,
    span: vt,
    spellCheck: lo,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: vt,
    step: null,
    style: null,
    tabIndex: vt,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Vn,
    useMap: null,
    value: lo,
    width: vt,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Yr,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: vt,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: vt,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Vn,
    // Lists. Use CSS to reduce space between items instead
    declare: Vn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: vt,
    // `<img>` and `<object>`
    leftMargin: vt,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: vt,
    // `<body>`
    marginWidth: vt,
    // `<body>`
    noResize: Vn,
    // `<frame>`
    noHref: Vn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Vn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Vn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: vt,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: lo,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: vt,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: vt,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Vn,
    disableRemotePlayback: Vn,
    prefix: null,
    property: null,
    results: vt,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: dze
}), bVt = Mx({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: jl,
    accentHeight: vt,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: vt,
    amplitude: vt,
    arabicForm: null,
    ascent: vt,
    attributeName: null,
    attributeType: null,
    azimuth: vt,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: vt,
    by: null,
    calcMode: null,
    capHeight: vt,
    className: Yr,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: vt,
    diffuseConstant: vt,
    direction: null,
    display: null,
    dur: null,
    divisor: vt,
    dominantBaseline: null,
    download: Vn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: vt,
    enableBackground: null,
    end: null,
    event: null,
    exponent: vt,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: vt,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: sA,
    g2: sA,
    glyphName: sA,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: vt,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: vt,
    horizOriginX: vt,
    horizOriginY: vt,
    id: null,
    ideographic: vt,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: vt,
    k: vt,
    k1: vt,
    k2: vt,
    k3: vt,
    k4: vt,
    kernelMatrix: jl,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: vt,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: vt,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: vt,
    overlineThickness: vt,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: vt,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Yr,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: vt,
    pointsAtY: vt,
    pointsAtZ: vt,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: jl,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: jl,
    rev: jl,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: jl,
    requiredFeatures: jl,
    requiredFonts: jl,
    requiredFormats: jl,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: vt,
    specularExponent: vt,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: vt,
    strikethroughThickness: vt,
    string: null,
    stroke: null,
    strokeDashArray: jl,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: vt,
    strokeOpacity: vt,
    strokeWidth: null,
    style: null,
    surfaceScale: vt,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: jl,
    tabIndex: vt,
    tableValues: null,
    target: null,
    targetX: vt,
    targetY: vt,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: jl,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: vt,
    underlineThickness: vt,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: vt,
    values: null,
    vAlphabetic: vt,
    vMathematical: vt,
    vectorEffect: null,
    vHanging: vt,
    vIdeographic: vt,
    version: null,
    vertAdvY: vt,
    vertOriginX: vt,
    vertOriginY: vt,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: vt,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: uze
}), fze = Mx({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), pze = Mx({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: dze
}), hze = Mx({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), OVt = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, AVt = /[A-Z]/g, Mde = /-[a-z]/g, wVt = /^data[-\w.:]+$/i;
function xVt(e, t) {
  const n = E8(t);
  let r = t, i = Cl;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && wVt.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(Mde, EVt);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!Mde.test(o)) {
        let s = o.replace(AVt, SVt);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = sY;
  }
  return new i(r, t);
}
function SVt(e) {
  return "-" + e.toLowerCase();
}
function EVt(e) {
  return e.charAt(1).toUpperCase();
}
const TVt = lze([cze, vVt, fze, pze, hze], "html"), aY = lze([cze, bVt, fze, pze, hze], "svg");
function kVt(e) {
  return e.join(" ").trim();
}
var s0 = {}, t4, Dde;
function CVt() {
  if (Dde) return t4;
  Dde = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, c = `
`, a = "/", u = "*", f = "", d = "comment", p = "declaration";
  t4 = function(m, v) {
    if (typeof m != "string")
      throw new TypeError("First argument must be a string");
    if (!m) return [];
    v = v || {};
    var b = 1, A = 1;
    function w(L) {
      var _ = L.match(t);
      _ && (b += _.length);
      var U = L.lastIndexOf(c);
      A = ~U ? L.length - U : A + L.length;
    }
    function O() {
      var L = { line: b, column: A };
      return function(_) {
        return _.position = new x(L), k(), _;
      };
    }
    function x(L) {
      this.start = L, this.end = { line: b, column: A }, this.source = v.source;
    }
    x.prototype.content = m;
    function S(L) {
      var _ = new Error(
        v.source + ":" + b + ":" + A + ": " + L
      );
      if (_.reason = L, _.filename = v.source, _.line = b, _.column = A, _.source = m, !v.silent) throw _;
    }
    function E(L) {
      var _ = L.exec(m);
      if (_) {
        var U = _[0];
        return w(U), m = m.slice(U.length), _;
      }
    }
    function k() {
      E(n);
    }
    function T(L) {
      var _;
      for (L = L || []; _ = R(); )
        _ !== !1 && L.push(_);
      return L;
    }
    function R() {
      var L = O();
      if (!(a != m.charAt(0) || u != m.charAt(1))) {
        for (var _ = 2; f != m.charAt(_) && (u != m.charAt(_) || a != m.charAt(_ + 1)); )
          ++_;
        if (_ += 2, f === m.charAt(_ - 1))
          return S("End of comment missing");
        var U = m.slice(2, _ - 2);
        return A += 2, w(U), m = m.slice(_), A += 2, L({
          type: d,
          comment: U
        });
      }
    }
    function j() {
      var L = O(), _ = E(r);
      if (_) {
        if (R(), !E(i)) return S("property missing ':'");
        var U = E(o), z = L({
          type: p,
          property: h(_[0].replace(e, f)),
          value: U ? h(U[0].replace(e, f)) : f
        });
        return E(s), z;
      }
    }
    function F() {
      var L = [];
      T(L);
      for (var _; _ = j(); )
        _ !== !1 && (L.push(_), T(L));
      return L;
    }
    return k(), F();
  };
  function h(m) {
    return m ? m.replace(l, f) : f;
  }
  return t4;
}
var _de;
function NVt() {
  if (_de) return s0;
  _de = 1;
  var e = s0 && s0.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(s0, "__esModule", { value: !0 }), s0.default = n;
  var t = e(CVt());
  function n(r, i) {
    var o = null;
    if (!r || typeof r != "string")
      return o;
    var s = (0, t.default)(r), l = typeof i == "function";
    return s.forEach(function(c) {
      if (c.type === "declaration") {
        var a = c.property, u = c.value;
        l ? i(a, u, c) : u && (o = o || {}, o[a] = u);
      }
    }), o;
  }
  return s0;
}
var SS = {}, Lde;
function PVt() {
  if (Lde) return SS;
  Lde = 1, Object.defineProperty(SS, "__esModule", { value: !0 }), SS.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, o = function(a) {
    return !a || n.test(a) || e.test(a);
  }, s = function(a, u) {
    return u.toUpperCase();
  }, l = function(a, u) {
    return "".concat(u, "-");
  }, c = function(a, u) {
    return u === void 0 && (u = {}), o(a) ? a : (a = a.toLowerCase(), u.reactCompat ? a = a.replace(i, l) : a = a.replace(r, l), a.replace(t, s));
  };
  return SS.camelCase = c, SS;
}
var ES, zde;
function IVt() {
  if (zde) return ES;
  zde = 1;
  var e = ES && ES.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, t = e(NVt()), n = PVt();
  function r(i, o) {
    var s = {};
    return !i || typeof i != "string" || (0, t.default)(i, function(l, c) {
      l && c && (s[(0, n.camelCase)(l, o)] = c);
    }), s;
  }
  return r.default = r, ES = r, ES;
}
var RVt = IVt();
const MVt = /* @__PURE__ */ Sl(RVt), mze = gze("end"), lY = gze("start");
function gze(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function DVt(e) {
  const t = lY(e), n = mze(e);
  if (t && n)
    return { start: t, end: n };
}
function qE(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? jde(e.position) : "start" in e || "end" in e ? jde(e) : "line" in e || "column" in e ? C8(e) : "";
}
function C8(e) {
  return Fde(e && e.line) + ":" + Fde(e && e.column);
}
function jde(e) {
  return C8(e && e.start) + "-" + C8(e && e.end);
}
function Fde(e) {
  return e && typeof e == "number" ? e : 1;
}
class aa extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, s = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (s = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? o.ruleId = r : (o.source = r.slice(0, c), o.ruleId = r.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = l ? l.line : void 0, this.name = qE(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
aa.prototype.file = "";
aa.prototype.name = "";
aa.prototype.reason = "";
aa.prototype.message = "";
aa.prototype.stack = "";
aa.prototype.column = void 0;
aa.prototype.line = void 0;
aa.prototype.ancestors = void 0;
aa.prototype.cause = void 0;
aa.prototype.fatal = void 0;
aa.prototype.place = void 0;
aa.prototype.ruleId = void 0;
aa.prototype.source = void 0;
const cY = {}.hasOwnProperty, _Vt = /* @__PURE__ */ new Map(), LVt = /[A-Z]/g, zVt = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), jVt = /* @__PURE__ */ new Set(["td", "th"]), yze = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function FVt(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = HVt(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = ZVt(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? aY : TVt,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = vze(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function vze(e, t, n) {
  if (t.type === "element")
    return UVt(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return VVt(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return BVt(e, t, n);
  if (t.type === "mdxjsEsm")
    return qVt(e, t);
  if (t.type === "root")
    return XVt(e, t, n);
  if (t.type === "text")
    return WVt(e, t);
}
function UVt(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = aY, e.schema = i), e.ancestors.push(t);
  const o = Oze(e, t.tagName, !1), s = QVt(e, t);
  let l = dY(e, t);
  return zVt.has(t.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !gVt(c) : !0;
  })), bze(e, s, o, t), uY(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function VVt(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  kk(e, t.position);
}
function qVt(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  kk(e, t.position);
}
function BVt(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = aY, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : Oze(e, t.name, !0), s = $Vt(e, t), l = dY(e, t);
  return bze(e, s, o, t), uY(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function XVt(e, t, n) {
  const r = {};
  return uY(r, dY(e, t)), e.create(t, e.Fragment, r, n);
}
function WVt(e, t) {
  return t.value;
}
function bze(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function uY(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function ZVt(e, t, n) {
  return r;
  function r(i, o, s, l) {
    const a = Array.isArray(s.children) ? n : t;
    return l ? a(o, s, l) : a(o, s);
  }
}
function HVt(e, t) {
  return n;
  function n(r, i, o, s) {
    const l = Array.isArray(o.children), c = lY(r);
    return t(
      i,
      o,
      s,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function QVt(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && cY.call(t.properties, i)) {
      const o = KVt(e, i, t.properties[i]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && jVt.has(t.tagName) ? r = l : n[s] = l;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function $Vt(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        kk(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          kk(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function dY(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : _Vt;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let s;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const a = i.get(c) || 0;
        s = c + "-" + a, i.set(c, a + 1);
      }
    }
    const l = vze(e, o, s);
    l !== void 0 && n.push(l);
  }
  return n;
}
function KVt(e, t, n) {
  const r = xVt(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? dVt(n) : kVt(n)), r.property === "style") {
      let i = typeof n == "object" ? n : GVt(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = YVt(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? OVt[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function GVt(e, t) {
  try {
    return MVt(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new aa("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = yze + "#cannot-parse-style-attribute", i;
  }
}
function Oze(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, s;
    for (; ++o < i.length; ) {
      const l = Pde(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = s;
  } else
    r = Pde(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return cY.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  kk(e);
}
function kk(e, t) {
  const n = new aa(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = yze + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function YVt(e) {
  const t = {};
  let n;
  for (n in e)
    cY.call(e, n) && (t[JVt(n)] = e[n]);
  return t;
}
function JVt(e) {
  let t = e.replace(LVt, eqt);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function eqt(e) {
  return "-" + e.toLowerCase();
}
const n4 = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, tqt = {};
function fY(e, t) {
  const n = tqt, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Aze(e, r, i);
}
function Aze(e, t, n) {
  if (nqt(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Ude(e.children, t, n);
  }
  return Array.isArray(e) ? Ude(e, t, n) : "";
}
function Ude(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Aze(e[i], t, n);
  return r.join("");
}
function nqt(e) {
  return !!(e && typeof e == "object");
}
const Vde = document.createElement("i");
function pY(e) {
  const t = "&" + e + ";";
  Vde.innerHTML = t;
  const n = Vde.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function sc(e, t, n, r) {
  const i = e.length;
  let o = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); o < r.length; )
      s = r.slice(o, o + 1e4), s.unshift(t, 0), e.splice(...s), o += 1e4, t += 1e4;
}
function jc(e, t) {
  return e.length > 0 ? (sc(e, e.length, 0, t), e) : t;
}
const qde = {}.hasOwnProperty;
function wze(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    rqt(t, e[n]);
  return t;
}
function rqt(e, t) {
  let n;
  for (n in t) {
    const i = (qde.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let s;
    if (o)
      for (s in o) {
        qde.call(i, s) || (i[s] = []);
        const l = o[s];
        iqt(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function iqt(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  sc(e, 0, 0, r);
}
function xze(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function Hu(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const xa = Lg(/[A-Za-z]/), Gs = Lg(/[\dA-Za-z]/), oqt = Lg(/[#-'*+\--9=?A-Z^-~]/);
function X_(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const N8 = Lg(/\d/), sqt = Lg(/[\dA-Fa-f]/), aqt = Lg(/[!-/:-@[-`{-~]/);
function gn(e) {
  return e !== null && e < -2;
}
function Qr(e) {
  return e !== null && (e < 0 || e === 32);
}
function tr(e) {
  return e === -2 || e === -1 || e === 32;
}
const i3 = Lg(new RegExp("\\p{P}|\\p{S}", "u")), Jv = Lg(/\s/);
function Lg(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Dx(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let s = "";
    if (o === 37 && Gs(e.charCodeAt(n + 1)) && Gs(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(n + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), i = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + i + 1, s = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function br(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return tr(c) ? (e.enter(n), l(c)) : t(c);
  }
  function l(c) {
    return tr(c) && o++ < i ? (e.consume(c), l) : (e.exit(n), t(c));
  }
}
const lqt = {
  tokenize: cqt
};
function cqt(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), br(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return gn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const uqt = {
  tokenize: dqt
}, Bde = {
  tokenize: fqt
};
function dqt(e) {
  const t = this, n = [];
  let r = 0, i, o, s;
  return l;
  function l(w) {
    if (r < n.length) {
      const O = n[r];
      return t.containerState = O[1], e.attempt(O[0].continuation, c, a)(w);
    }
    return a(w);
  }
  function c(w) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && A();
      const O = t.events.length;
      let x = O, S;
      for (; x--; )
        if (t.events[x][0] === "exit" && t.events[x][1].type === "chunkFlow") {
          S = t.events[x][1].end;
          break;
        }
      b(r);
      let E = O;
      for (; E < t.events.length; )
        t.events[E][1].end = {
          ...S
        }, E++;
      return sc(t.events, x + 1, 0, t.events.slice(O)), t.events.length = E, a(w);
    }
    return l(w);
  }
  function a(w) {
    if (r === n.length) {
      if (!i)
        return d(w);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return h(w);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Bde, u, f)(w);
  }
  function u(w) {
    return i && A(), b(r), d(w);
  }
  function f(w) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, h(w);
  }
  function d(w) {
    return t.containerState = {}, e.attempt(Bde, p, h)(w);
  }
  function p(w) {
    return r++, n.push([t.currentConstruct, t.containerState]), d(w);
  }
  function h(w) {
    if (w === null) {
      i && A(), b(0), e.consume(w);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: o
    }), m(w);
  }
  function m(w) {
    if (w === null) {
      v(e.exit("chunkFlow"), !0), b(0), e.consume(w);
      return;
    }
    return gn(w) ? (e.consume(w), v(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(w), m);
  }
  function v(w, O) {
    const x = t.sliceStream(w);
    if (O && x.push(null), w.previous = o, o && (o.next = w), o = w, i.defineSkip(w.start), i.write(x), t.parser.lazy[w.start.line]) {
      let S = i.events.length;
      for (; S--; )
        if (
          // The token starts before the line ending…
          i.events[S][1].start.offset < s && // …and either is not ended yet…
          (!i.events[S][1].end || // …or ends after it.
          i.events[S][1].end.offset > s)
        )
          return;
      const E = t.events.length;
      let k = E, T, R;
      for (; k--; )
        if (t.events[k][0] === "exit" && t.events[k][1].type === "chunkFlow") {
          if (T) {
            R = t.events[k][1].end;
            break;
          }
          T = !0;
        }
      for (b(r), S = E; S < t.events.length; )
        t.events[S][1].end = {
          ...R
        }, S++;
      sc(t.events, k + 1, 0, t.events.slice(E)), t.events.length = S;
    }
  }
  function b(w) {
    let O = n.length;
    for (; O-- > w; ) {
      const x = n[O];
      t.containerState = x[1], x[0].exit.call(t, e);
    }
    n.length = w;
  }
  function A() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function fqt(e, t, n) {
  return br(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Nw(e) {
  if (e === null || Qr(e) || Jv(e))
    return 1;
  if (i3(e))
    return 2;
}
function o3(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const P8 = {
  name: "attention",
  resolveAll: pqt,
  tokenize: hqt
};
function pqt(e, t) {
  let n = -1, r, i, o, s, l, c, a, u;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, d = {
            ...e[n][1].start
          };
          Xde(f, -c), Xde(d, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: d
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[r][1].end = {
            ...s.start
          }, e[n][1].start = {
            ...l.end
          }, a = [], e[r][1].end.offset - e[r][1].start.offset && (a = jc(a, [["enter", e[r][1], t], ["exit", e[r][1], t]])), a = jc(a, [["enter", i, t], ["enter", s, t], ["exit", s, t], ["enter", o, t]]), a = jc(a, o3(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), a = jc(a, [["exit", o, t], ["enter", l, t], ["exit", l, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, a = jc(a, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : u = 0, sc(e, r - 1, n - r + 3, a), n = r + a.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function hqt(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Nw(r);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const a = e.exit("attentionSequence"), u = Nw(c), f = !u || u === 2 && i || n.includes(c), d = !i || i === 2 && u || n.includes(r);
    return a._open = !!(o === 42 ? f : f && (i || !d)), a._close = !!(o === 42 ? d : d && (u || !f)), t(c);
  }
}
function Xde(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const mqt = {
  name: "autolink",
  tokenize: gqt
};
function gqt(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(p) {
    return xa(p) ? (e.consume(p), s) : p === 64 ? n(p) : a(p);
  }
  function s(p) {
    return p === 43 || p === 45 || p === 46 || Gs(p) ? (r = 1, l(p)) : a(p);
  }
  function l(p) {
    return p === 58 ? (e.consume(p), r = 0, c) : (p === 43 || p === 45 || p === 46 || Gs(p)) && r++ < 32 ? (e.consume(p), l) : (r = 0, a(p));
  }
  function c(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || X_(p) ? n(p) : (e.consume(p), c);
  }
  function a(p) {
    return p === 64 ? (e.consume(p), u) : oqt(p) ? (e.consume(p), a) : n(p);
  }
  function u(p) {
    return Gs(p) ? f(p) : n(p);
  }
  function f(p) {
    return p === 46 ? (e.consume(p), r = 0, u) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : d(p);
  }
  function d(p) {
    if ((p === 45 || Gs(p)) && r++ < 63) {
      const h = p === 45 ? d : f;
      return e.consume(p), h;
    }
    return n(p);
  }
}
const LN = {
  partial: !0,
  tokenize: yqt
};
function yqt(e, t, n) {
  return r;
  function r(o) {
    return tr(o) ? br(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || gn(o) ? t(o) : n(o);
  }
}
const Sze = {
  continuation: {
    tokenize: bqt
  },
  exit: Oqt,
  name: "blockQuote",
  tokenize: vqt
};
function vqt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return n(s);
  }
  function o(s) {
    return tr(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function bqt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return tr(s) ? br(e, o, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(Sze, t, n)(s);
  }
}
function Oqt(e) {
  e.exit("blockQuote");
}
const Eze = {
  name: "characterEscape",
  tokenize: Aqt
};
function Aqt(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return aqt(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const Tze = {
  name: "characterReference",
  tokenize: wqt
};
function wqt(e, t, n) {
  const r = this;
  let i = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), a) : (e.enter("characterReferenceValue"), o = 31, s = Gs, u(f));
  }
  function a(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = sqt, u) : (e.enter("characterReferenceValue"), o = 7, s = N8, u(f));
  }
  function u(f) {
    if (f === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return s === Gs && !pY(r.sliceSerialize(d)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(f) && i++ < o ? (e.consume(f), u) : n(f);
  }
}
const Wde = {
  partial: !0,
  tokenize: Sqt
}, Zde = {
  concrete: !0,
  name: "codeFenced",
  tokenize: xqt
};
function xqt(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: x
  };
  let o = 0, s = 0, l;
  return c;
  function c(S) {
    return a(S);
  }
  function a(S) {
    const E = r.events[r.events.length - 1];
    return o = E && E[1].type === "linePrefix" ? E[2].sliceSerialize(E[1], !0).length : 0, l = S, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(S);
  }
  function u(S) {
    return S === l ? (s++, e.consume(S), u) : s < 3 ? n(S) : (e.exit("codeFencedFenceSequence"), tr(S) ? br(e, f, "whitespace")(S) : f(S));
  }
  function f(S) {
    return S === null || gn(S) ? (e.exit("codeFencedFence"), r.interrupt ? t(S) : e.check(Wde, m, O)(S)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(S));
  }
  function d(S) {
    return S === null || gn(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(S)) : tr(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), br(e, p, "whitespace")(S)) : S === 96 && S === l ? n(S) : (e.consume(S), d);
  }
  function p(S) {
    return S === null || gn(S) ? f(S) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), h(S));
  }
  function h(S) {
    return S === null || gn(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(S)) : S === 96 && S === l ? n(S) : (e.consume(S), h);
  }
  function m(S) {
    return e.attempt(i, O, v)(S);
  }
  function v(S) {
    return e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), b;
  }
  function b(S) {
    return o > 0 && tr(S) ? br(e, A, "linePrefix", o + 1)(S) : A(S);
  }
  function A(S) {
    return S === null || gn(S) ? e.check(Wde, m, O)(S) : (e.enter("codeFlowValue"), w(S));
  }
  function w(S) {
    return S === null || gn(S) ? (e.exit("codeFlowValue"), A(S)) : (e.consume(S), w);
  }
  function O(S) {
    return e.exit("codeFenced"), t(S);
  }
  function x(S, E, k) {
    let T = 0;
    return R;
    function R(U) {
      return S.enter("lineEnding"), S.consume(U), S.exit("lineEnding"), j;
    }
    function j(U) {
      return S.enter("codeFencedFence"), tr(U) ? br(S, F, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(U) : F(U);
    }
    function F(U) {
      return U === l ? (S.enter("codeFencedFenceSequence"), L(U)) : k(U);
    }
    function L(U) {
      return U === l ? (T++, S.consume(U), L) : T >= s ? (S.exit("codeFencedFenceSequence"), tr(U) ? br(S, _, "whitespace")(U) : _(U)) : k(U);
    }
    function _(U) {
      return U === null || gn(U) ? (S.exit("codeFencedFence"), E(U)) : k(U);
    }
  }
}
function Sqt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const r4 = {
  name: "codeIndented",
  tokenize: Tqt
}, Eqt = {
  partial: !0,
  tokenize: kqt
};
function Tqt(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("codeIndented"), br(e, o, "linePrefix", 5)(a);
  }
  function o(a) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(a) : n(a);
  }
  function s(a) {
    return a === null ? c(a) : gn(a) ? e.attempt(Eqt, s, c)(a) : (e.enter("codeFlowValue"), l(a));
  }
  function l(a) {
    return a === null || gn(a) ? (e.exit("codeFlowValue"), s(a)) : (e.consume(a), l);
  }
  function c(a) {
    return e.exit("codeIndented"), t(a);
  }
}
function kqt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : br(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : gn(s) ? i(s) : n(s);
  }
}
const Cqt = {
  name: "codeText",
  previous: Pqt,
  resolve: Nqt,
  tokenize: Iqt
};
function Nqt(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Pqt(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Iqt(e, t, n) {
  let r = 0, i, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), r++, l) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (o = e.enter("codeTextSequence"), i = 0, u(f)) : gn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), a(f));
  }
  function a(f) {
    return f === null || f === 32 || f === 96 || gn(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), a);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (o.type = "codeTextData", a(f));
  }
}
class Rqt {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && TS(this.left, r), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), TS(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), TS(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        TS(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        TS(this.left, n.reverse());
      }
  }
}
function TS(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function kze(e) {
  const t = {};
  let n = -1, r, i, o, s, l, c, a;
  const u = new Rqt(e);
  for (; ++n < u.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Mqt(u, n)), n = t[n], a = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o--; )
        if (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank")
          s[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = o);
        else if (!(s[1].type === "linePrefix" || s[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...u.get(i)[1].start
      }, l = u.slice(i, n), l.unshift(r), u.splice(i, n - i + 1, l));
    }
  }
  return sc(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !a;
}
function Mqt(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const o = [];
  let s = n._tokenizer;
  s || (s = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (s._contentTypeTextTrailing = !0));
  const l = s.events, c = [], a = {};
  let u, f, d = -1, p = n, h = 0, m = 0;
  const v = [m];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    o.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), f && s.defineSkip(p.start), p._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), p._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = n; ++d < l.length; )
    // Find a void token that includes a break.
    l[d][0] === "exit" && l[d - 1][0] === "enter" && l[d][1].type === l[d - 1][1].type && l[d][1].start.line !== l[d][1].end.line && (m = d + 1, v.push(m), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (s.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : v.pop(), d = v.length; d--; ) {
    const b = l.slice(v[d], v[d + 1]), A = o.pop();
    c.push([A, A + b.length - 1]), e.splice(A, 2, b);
  }
  for (c.reverse(), d = -1; ++d < c.length; )
    a[h + c[d][0]] = h + c[d][1], h += c[d][1] - c[d][0] - 1;
  return a;
}
const Dqt = {
  resolve: Lqt,
  tokenize: zqt
}, _qt = {
  partial: !0,
  tokenize: jqt
};
function Lqt(e) {
  return kze(e), e;
}
function zqt(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? o(l) : gn(l) ? e.check(_qt, s, o)(l) : (e.consume(l), i);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function jqt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), br(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || gn(s))
      return n(s);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function Cze(e, t, n, r, i, o, s, l, c) {
  const a = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(b) {
    return b === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(b), e.exit(o), d) : b === null || b === 32 || b === 41 || X_(b) ? n(b) : (e.enter(r), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), m(b));
  }
  function d(b) {
    return b === 62 ? (e.enter(o), e.consume(b), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), p(b));
  }
  function p(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(l), d(b)) : b === null || b === 60 || gn(b) ? n(b) : (e.consume(b), b === 92 ? h : p);
  }
  function h(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), p) : p(b);
  }
  function m(b) {
    return !u && (b === null || b === 41 || Qr(b)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(r), t(b)) : u < a && b === 40 ? (e.consume(b), u++, m) : b === 41 ? (e.consume(b), u--, m) : b === null || b === 32 || b === 40 || X_(b) ? n(b) : (e.consume(b), b === 92 ? v : m);
  }
  function v(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), m) : m(b);
  }
}
function Nze(e, t, n, r, i, o) {
  const s = this;
  let l = 0, c;
  return a;
  function a(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(o), u;
  }
  function u(p) {
    return l > 999 || p === null || p === 91 || p === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? n(p) : p === 93 ? (e.exit(o), e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : gn(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || gn(p) || l++ > 999 ? (e.exit("chunkString"), u(p)) : (e.consume(p), c || (c = !tr(p)), p === 92 ? d : f);
  }
  function d(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), l++, f) : f(p);
  }
}
function Pze(e, t, n, r, i, o) {
  let s;
  return l;
  function l(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(r), e.enter(i), e.consume(d), e.exit(i), s = d === 40 ? 41 : d, c) : n(d);
  }
  function c(d) {
    return d === s ? (e.enter(i), e.consume(d), e.exit(i), e.exit(r), t) : (e.enter(o), a(d));
  }
  function a(d) {
    return d === s ? (e.exit(o), c(s)) : d === null ? n(d) : gn(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), br(e, a, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(d));
  }
  function u(d) {
    return d === s || d === null || gn(d) ? (e.exit("chunkString"), a(d)) : (e.consume(d), d === 92 ? f : u);
  }
  function f(d) {
    return d === s || d === 92 ? (e.consume(d), u) : u(d);
  }
}
function BE(e, t) {
  let n;
  return r;
  function r(i) {
    return gn(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : tr(i) ? br(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const Fqt = {
  name: "definition",
  tokenize: Vqt
}, Uqt = {
  partial: !0,
  tokenize: qqt
};
function Vqt(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(p) {
    return e.enter("definition"), s(p);
  }
  function s(p) {
    return Nze.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function l(p) {
    return i = Hu(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), c) : n(p);
  }
  function c(p) {
    return Qr(p) ? BE(e, a)(p) : a(p);
  }
  function a(p) {
    return Cze(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function u(p) {
    return e.attempt(Uqt, f, f)(p);
  }
  function f(p) {
    return tr(p) ? br(e, d, "whitespace")(p) : d(p);
  }
  function d(p) {
    return p === null || gn(p) ? (e.exit("definition"), r.parser.defined.push(i), t(p)) : n(p);
  }
}
function qqt(e, t, n) {
  return r;
  function r(l) {
    return Qr(l) ? BE(e, i)(l) : n(l);
  }
  function i(l) {
    return Pze(e, o, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return tr(l) ? br(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || gn(l) ? t(l) : n(l);
  }
}
const Bqt = {
  name: "hardBreakEscape",
  tokenize: Xqt
};
function Xqt(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return gn(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const Wqt = {
  name: "headingAtx",
  resolve: Zqt,
  tokenize: Hqt
};
function Zqt(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, sc(e, r, n - r + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function Hqt(e, t, n) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), s) : u === null || Qr(u) ? (e.exit("atxHeadingSequence"), l(u)) : n(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), c(u)) : u === null || gn(u) ? (e.exit("atxHeading"), t(u)) : tr(u) ? br(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), a(u));
  }
  function c(u) {
    return u === 35 ? (e.consume(u), c) : (e.exit("atxHeadingSequence"), l(u));
  }
  function a(u) {
    return u === null || u === 35 || Qr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), a);
  }
}
const Qqt = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Hde = ["pre", "script", "style", "textarea"], $qt = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Yqt,
  tokenize: Jqt
}, Kqt = {
  partial: !0,
  tokenize: tBt
}, Gqt = {
  partial: !0,
  tokenize: eBt
};
function Yqt(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Jqt(e, t, n) {
  const r = this;
  let i, o, s, l, c;
  return a;
  function a(q) {
    return u(q);
  }
  function u(q) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(q), f;
  }
  function f(q) {
    return q === 33 ? (e.consume(q), d) : q === 47 ? (e.consume(q), o = !0, m) : q === 63 ? (e.consume(q), i = 3, r.interrupt ? t : D) : xa(q) ? (e.consume(q), s = String.fromCharCode(q), v) : n(q);
  }
  function d(q) {
    return q === 45 ? (e.consume(q), i = 2, p) : q === 91 ? (e.consume(q), i = 5, l = 0, h) : xa(q) ? (e.consume(q), i = 4, r.interrupt ? t : D) : n(q);
  }
  function p(q) {
    return q === 45 ? (e.consume(q), r.interrupt ? t : D) : n(q);
  }
  function h(q) {
    const H = "CDATA[";
    return q === H.charCodeAt(l++) ? (e.consume(q), l === H.length ? r.interrupt ? t : F : h) : n(q);
  }
  function m(q) {
    return xa(q) ? (e.consume(q), s = String.fromCharCode(q), v) : n(q);
  }
  function v(q) {
    if (q === null || q === 47 || q === 62 || Qr(q)) {
      const H = q === 47, Y = s.toLowerCase();
      return !H && !o && Hde.includes(Y) ? (i = 1, r.interrupt ? t(q) : F(q)) : Qqt.includes(s.toLowerCase()) ? (i = 6, H ? (e.consume(q), b) : r.interrupt ? t(q) : F(q)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(q) : o ? A(q) : w(q));
    }
    return q === 45 || Gs(q) ? (e.consume(q), s += String.fromCharCode(q), v) : n(q);
  }
  function b(q) {
    return q === 62 ? (e.consume(q), r.interrupt ? t : F) : n(q);
  }
  function A(q) {
    return tr(q) ? (e.consume(q), A) : R(q);
  }
  function w(q) {
    return q === 47 ? (e.consume(q), R) : q === 58 || q === 95 || xa(q) ? (e.consume(q), O) : tr(q) ? (e.consume(q), w) : R(q);
  }
  function O(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || Gs(q) ? (e.consume(q), O) : x(q);
  }
  function x(q) {
    return q === 61 ? (e.consume(q), S) : tr(q) ? (e.consume(q), x) : w(q);
  }
  function S(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? n(q) : q === 34 || q === 39 ? (e.consume(q), c = q, E) : tr(q) ? (e.consume(q), S) : k(q);
  }
  function E(q) {
    return q === c ? (e.consume(q), c = null, T) : q === null || gn(q) ? n(q) : (e.consume(q), E);
  }
  function k(q) {
    return q === null || q === 34 || q === 39 || q === 47 || q === 60 || q === 61 || q === 62 || q === 96 || Qr(q) ? x(q) : (e.consume(q), k);
  }
  function T(q) {
    return q === 47 || q === 62 || tr(q) ? w(q) : n(q);
  }
  function R(q) {
    return q === 62 ? (e.consume(q), j) : n(q);
  }
  function j(q) {
    return q === null || gn(q) ? F(q) : tr(q) ? (e.consume(q), j) : n(q);
  }
  function F(q) {
    return q === 45 && i === 2 ? (e.consume(q), z) : q === 60 && i === 1 ? (e.consume(q), C) : q === 62 && i === 4 ? (e.consume(q), X) : q === 63 && i === 3 ? (e.consume(q), D) : q === 93 && i === 5 ? (e.consume(q), M) : gn(q) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Kqt, B, L)(q)) : q === null || gn(q) ? (e.exit("htmlFlowData"), L(q)) : (e.consume(q), F);
  }
  function L(q) {
    return e.check(Gqt, _, B)(q);
  }
  function _(q) {
    return e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), U;
  }
  function U(q) {
    return q === null || gn(q) ? L(q) : (e.enter("htmlFlowData"), F(q));
  }
  function z(q) {
    return q === 45 ? (e.consume(q), D) : F(q);
  }
  function C(q) {
    return q === 47 ? (e.consume(q), s = "", I) : F(q);
  }
  function I(q) {
    if (q === 62) {
      const H = s.toLowerCase();
      return Hde.includes(H) ? (e.consume(q), X) : F(q);
    }
    return xa(q) && s.length < 8 ? (e.consume(q), s += String.fromCharCode(q), I) : F(q);
  }
  function M(q) {
    return q === 93 ? (e.consume(q), D) : F(q);
  }
  function D(q) {
    return q === 62 ? (e.consume(q), X) : q === 45 && i === 2 ? (e.consume(q), D) : F(q);
  }
  function X(q) {
    return q === null || gn(q) ? (e.exit("htmlFlowData"), B(q)) : (e.consume(q), X);
  }
  function B(q) {
    return e.exit("htmlFlow"), t(q);
  }
}
function eBt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : n(s);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function tBt(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(LN, t, n);
  }
}
const nBt = {
  name: "htmlText",
  tokenize: rBt
};
function rBt(e, t, n) {
  const r = this;
  let i, o, s;
  return l;
  function l(D) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(D), c;
  }
  function c(D) {
    return D === 33 ? (e.consume(D), a) : D === 47 ? (e.consume(D), x) : D === 63 ? (e.consume(D), w) : xa(D) ? (e.consume(D), k) : n(D);
  }
  function a(D) {
    return D === 45 ? (e.consume(D), u) : D === 91 ? (e.consume(D), o = 0, h) : xa(D) ? (e.consume(D), A) : n(D);
  }
  function u(D) {
    return D === 45 ? (e.consume(D), p) : n(D);
  }
  function f(D) {
    return D === null ? n(D) : D === 45 ? (e.consume(D), d) : gn(D) ? (s = f, C(D)) : (e.consume(D), f);
  }
  function d(D) {
    return D === 45 ? (e.consume(D), p) : f(D);
  }
  function p(D) {
    return D === 62 ? z(D) : D === 45 ? d(D) : f(D);
  }
  function h(D) {
    const X = "CDATA[";
    return D === X.charCodeAt(o++) ? (e.consume(D), o === X.length ? m : h) : n(D);
  }
  function m(D) {
    return D === null ? n(D) : D === 93 ? (e.consume(D), v) : gn(D) ? (s = m, C(D)) : (e.consume(D), m);
  }
  function v(D) {
    return D === 93 ? (e.consume(D), b) : m(D);
  }
  function b(D) {
    return D === 62 ? z(D) : D === 93 ? (e.consume(D), b) : m(D);
  }
  function A(D) {
    return D === null || D === 62 ? z(D) : gn(D) ? (s = A, C(D)) : (e.consume(D), A);
  }
  function w(D) {
    return D === null ? n(D) : D === 63 ? (e.consume(D), O) : gn(D) ? (s = w, C(D)) : (e.consume(D), w);
  }
  function O(D) {
    return D === 62 ? z(D) : w(D);
  }
  function x(D) {
    return xa(D) ? (e.consume(D), S) : n(D);
  }
  function S(D) {
    return D === 45 || Gs(D) ? (e.consume(D), S) : E(D);
  }
  function E(D) {
    return gn(D) ? (s = E, C(D)) : tr(D) ? (e.consume(D), E) : z(D);
  }
  function k(D) {
    return D === 45 || Gs(D) ? (e.consume(D), k) : D === 47 || D === 62 || Qr(D) ? T(D) : n(D);
  }
  function T(D) {
    return D === 47 ? (e.consume(D), z) : D === 58 || D === 95 || xa(D) ? (e.consume(D), R) : gn(D) ? (s = T, C(D)) : tr(D) ? (e.consume(D), T) : z(D);
  }
  function R(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || Gs(D) ? (e.consume(D), R) : j(D);
  }
  function j(D) {
    return D === 61 ? (e.consume(D), F) : gn(D) ? (s = j, C(D)) : tr(D) ? (e.consume(D), j) : T(D);
  }
  function F(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), i = D, L) : gn(D) ? (s = F, C(D)) : tr(D) ? (e.consume(D), F) : (e.consume(D), _);
  }
  function L(D) {
    return D === i ? (e.consume(D), i = void 0, U) : D === null ? n(D) : gn(D) ? (s = L, C(D)) : (e.consume(D), L);
  }
  function _(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 96 ? n(D) : D === 47 || D === 62 || Qr(D) ? T(D) : (e.consume(D), _);
  }
  function U(D) {
    return D === 47 || D === 62 || Qr(D) ? T(D) : n(D);
  }
  function z(D) {
    return D === 62 ? (e.consume(D), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(D);
  }
  function C(D) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), I;
  }
  function I(D) {
    return tr(D) ? br(e, M, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : M(D);
  }
  function M(D) {
    return e.enter("htmlTextData"), s(D);
  }
}
const hY = {
  name: "labelEnd",
  resolveAll: aBt,
  resolveTo: lBt,
  tokenize: cBt
}, iBt = {
  tokenize: uBt
}, oBt = {
  tokenize: dBt
}, sBt = {
  tokenize: fBt
};
function aBt(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && sc(e, 0, e.length, n), e;
}
function lBt(e, t) {
  let n = e.length, r = 0, i, o, s, l;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (s = n);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, a = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + r + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", c, t], ["enter", a, t]], l = jc(l, e.slice(o + 1, o + r + 3)), l = jc(l, [["enter", u, t]]), l = jc(l, o3(t.parser.constructs.insideSpan.null, e.slice(o + r + 4, s - 3), t)), l = jc(l, [["exit", u, t], e[s - 2], e[s - 1], ["exit", a, t]]), l = jc(l, e.slice(s + 1)), l = jc(l, [["exit", c, t]]), sc(e, o, e.length, l), e;
}
function cBt(e, t, n) {
  const r = this;
  let i = r.events.length, o, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return l;
  function l(d) {
    return o ? o._inactive ? f(d) : (s = r.parser.defined.includes(Hu(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(d);
  }
  function c(d) {
    return d === 40 ? e.attempt(iBt, u, s ? u : f)(d) : d === 91 ? e.attempt(oBt, u, s ? a : f)(d) : s ? u(d) : f(d);
  }
  function a(d) {
    return e.attempt(sBt, u, f)(d);
  }
  function u(d) {
    return t(d);
  }
  function f(d) {
    return o._balanced = !0, n(d);
  }
}
function uBt(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return Qr(f) ? BE(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : Cze(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Qr(f) ? BE(e, c)(f) : u(f);
  }
  function l(f) {
    return n(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? Pze(e, a, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function a(f) {
    return Qr(f) ? BE(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function dBt(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return Nze.call(r, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return r.parser.defined.includes(Hu(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function s(l) {
    return n(l);
  }
}
function fBt(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const pBt = {
  name: "labelStartImage",
  resolveAll: hY.resolveAll,
  tokenize: hBt
};
function hBt(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : n(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const mBt = {
  name: "labelStartLink",
  resolveAll: hY.resolveAll,
  tokenize: gBt
};
function gBt(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const i4 = {
  name: "lineEnding",
  tokenize: yBt
};
function yBt(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), br(e, t, "linePrefix");
  }
}
const OM = {
  name: "thematicBreak",
  tokenize: vBt
};
function vBt(e, t, n) {
  let r = 0, i;
  return o;
  function o(a) {
    return e.enter("thematicBreak"), s(a);
  }
  function s(a) {
    return i = a, l(a);
  }
  function l(a) {
    return a === i ? (e.enter("thematicBreakSequence"), c(a)) : r >= 3 && (a === null || gn(a)) ? (e.exit("thematicBreak"), t(a)) : n(a);
  }
  function c(a) {
    return a === i ? (e.consume(a), r++, c) : (e.exit("thematicBreakSequence"), tr(a) ? br(e, l, "whitespace")(a) : l(a));
  }
}
const Za = {
  continuation: {
    tokenize: wBt
  },
  exit: SBt,
  name: "list",
  tokenize: ABt
}, bBt = {
  partial: !0,
  tokenize: EBt
}, OBt = {
  partial: !0,
  tokenize: xBt
};
function ABt(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return l;
  function l(p) {
    const h = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (h === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : N8(p)) {
      if (r.containerState.type || (r.containerState.type = h, e.enter(h, {
        _container: !0
      })), h === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(OM, n, a)(p) : a(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(p);
    }
    return n(p);
  }
  function c(p) {
    return N8(p) && ++s < 10 ? (e.consume(p), c) : (!r.interrupt || s < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), a(p)) : n(p);
  }
  function a(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      LN,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(bBt, d, f)
    );
  }
  function u(p) {
    return r.containerState.initialBlankLine = !0, o++, d(p);
  }
  function f(p) {
    return tr(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), d) : n(p);
  }
  function d(p) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function wBt(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(LN, i, o);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, br(e, t, "listItemIndent", r.containerState.size + 1)(l);
  }
  function o(l) {
    return r.containerState.furtherBlankLines || !tr(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(OBt, t, s)(l));
  }
  function s(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, br(e, e.attempt(Za, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function xBt(e, t, n) {
  const r = this;
  return br(e, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function SBt(e) {
  e.exit(this.containerState.type);
}
function EBt(e, t, n) {
  const r = this;
  return br(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return !tr(o) && s && s[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const Qde = {
  name: "setextUnderline",
  resolveTo: TBt,
  tokenize: kBt
};
function TBt(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const s = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", s, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[o][1].end
  }) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function kBt(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(a) {
    let u = r.events.length, f;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        f = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = a, s(a)) : n(a);
  }
  function s(a) {
    return e.enter("setextHeadingLineSequence"), l(a);
  }
  function l(a) {
    return a === i ? (e.consume(a), l) : (e.exit("setextHeadingLineSequence"), tr(a) ? br(e, c, "lineSuffix")(a) : c(a));
  }
  function c(a) {
    return a === null || gn(a) ? (e.exit("setextHeadingLine"), t(a)) : n(a);
  }
}
const CBt = {
  tokenize: NBt
};
function NBt(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    LN,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, br(e, e.attempt(this.parser.constructs.flow, i, e.attempt(Dqt, i)), "linePrefix"))
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const PBt = {
  resolveAll: Rze()
}, IBt = Ize("string"), RBt = Ize("text");
function Ize(e) {
  return {
    resolveAll: Rze(e === "text" ? MBt : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, s, l);
    return s;
    function s(u) {
      return a(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), c;
    }
    function c(u) {
      return a(u) ? (n.exit("data"), o(u)) : (n.consume(u), c);
    }
    function a(u) {
      if (u === null)
        return !0;
      const f = i[u];
      let d = -1;
      if (f)
        for (; ++d < f.length; ) {
          const p = f[d];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Rze(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function MBt(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, s = -1, l = 0, c;
      for (; o--; ) {
        const a = i[o];
        if (typeof a == "string") {
          for (s = a.length; a.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (a === -2)
          c = !0, l++;
        else if (a !== -1) {
          o++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (l = 0), l) {
        const a = {
          type: n === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : r.start._bufferIndex + s,
            _index: r.start._index + o,
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...a.start
        }, r.start.offset === r.end.offset ? Object.assign(r, a) : (e.splice(n, 0, ["enter", a, t], ["exit", a, t]), n += 2);
      }
      n++;
    }
  return e;
}
const DBt = {
  42: Za,
  43: Za,
  45: Za,
  48: Za,
  49: Za,
  50: Za,
  51: Za,
  52: Za,
  53: Za,
  54: Za,
  55: Za,
  56: Za,
  57: Za,
  62: Sze
}, _Bt = {
  91: Fqt
}, LBt = {
  [-2]: r4,
  [-1]: r4,
  32: r4
}, zBt = {
  35: Wqt,
  42: OM,
  45: [Qde, OM],
  60: $qt,
  61: Qde,
  95: OM,
  96: Zde,
  126: Zde
}, jBt = {
  38: Tze,
  92: Eze
}, FBt = {
  [-5]: i4,
  [-4]: i4,
  [-3]: i4,
  33: pBt,
  38: Tze,
  42: P8,
  60: [mqt, nBt],
  91: mBt,
  92: [Bqt, Eze],
  93: hY,
  95: P8,
  96: Cqt
}, UBt = {
  null: [P8, PBt]
}, VBt = {
  null: [42, 95]
}, qBt = {
  null: []
}, BBt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: VBt,
  contentInitial: _Bt,
  disable: qBt,
  document: DBt,
  flow: zBt,
  flowInitial: LBt,
  insideSpan: UBt,
  string: jBt,
  text: FBt
}, Symbol.toStringTag, { value: "Module" }));
function XBt(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, o = [];
  let s = [], l = [];
  const c = {
    attempt: E(x),
    check: E(S),
    consume: A,
    enter: w,
    exit: O,
    interrupt: E(S, {
      interrupt: !0
    })
  }, a = {
    code: null,
    containerState: {},
    defineSkip: m,
    events: [],
    now: h,
    parser: e,
    previous: null,
    sliceSerialize: d,
    sliceStream: p,
    write: f
  };
  let u = t.tokenize.call(a, c);
  return t.resolveAll && o.push(t), a;
  function f(j) {
    return s = jc(s, j), v(), s[s.length - 1] !== null ? [] : (k(t, 0), a.events = o3(o, a.events, a), a.events);
  }
  function d(j, F) {
    return ZBt(p(j), F);
  }
  function p(j) {
    return WBt(s, j);
  }
  function h() {
    const {
      _bufferIndex: j,
      _index: F,
      line: L,
      column: _,
      offset: U
    } = r;
    return {
      _bufferIndex: j,
      _index: F,
      line: L,
      column: _,
      offset: U
    };
  }
  function m(j) {
    i[j.line] = j.column, R();
  }
  function v() {
    let j;
    for (; r._index < s.length; ) {
      const F = s[r._index];
      if (typeof F == "string")
        for (j = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === j && r._bufferIndex < F.length; )
          b(F.charCodeAt(r._bufferIndex));
      else
        b(F);
    }
  }
  function b(j) {
    u = u(j);
  }
  function A(j) {
    gn(j) ? (r.line++, r.column = 1, r.offset += j === -3 ? 2 : 1, R()) : j !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[r._index].length && (r._bufferIndex = -1, r._index++)), a.previous = j;
  }
  function w(j, F) {
    const L = F || {};
    return L.type = j, L.start = h(), a.events.push(["enter", L, a]), l.push(L), L;
  }
  function O(j) {
    const F = l.pop();
    return F.end = h(), a.events.push(["exit", F, a]), F;
  }
  function x(j, F) {
    k(j, F.from);
  }
  function S(j, F) {
    F.restore();
  }
  function E(j, F) {
    return L;
    function L(_, U, z) {
      let C, I, M, D;
      return Array.isArray(_) ? (
        /* c8 ignore next 1 */
        B(_)
      ) : "tokenize" in _ ? (
        // Looks like a construct.
        B([
          /** @type {Construct} */
          _
        ])
      ) : X(_);
      function X(J) {
        return oe;
        function oe(ce) {
          const fe = ce !== null && J[ce], $ = ce !== null && J.null, pe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(fe) ? fe : fe ? [fe] : [],
            ...Array.isArray($) ? $ : $ ? [$] : []
          ];
          return B(pe)(ce);
        }
      }
      function B(J) {
        return C = J, I = 0, J.length === 0 ? z : q(J[I]);
      }
      function q(J) {
        return oe;
        function oe(ce) {
          return D = T(), M = J, J.partial || (a.currentConstruct = J), J.name && a.parser.constructs.disable.null.includes(J.name) ? Y() : J.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            F ? Object.assign(Object.create(a), F) : a,
            c,
            H,
            Y
          )(ce);
        }
      }
      function H(J) {
        return j(M, D), U;
      }
      function Y(J) {
        return D.restore(), ++I < C.length ? q(C[I]) : z;
      }
    }
  }
  function k(j, F) {
    j.resolveAll && !o.includes(j) && o.push(j), j.resolve && sc(a.events, F, a.events.length - F, j.resolve(a.events.slice(F), a)), j.resolveTo && (a.events = j.resolveTo(a.events, a));
  }
  function T() {
    const j = h(), F = a.previous, L = a.currentConstruct, _ = a.events.length, U = Array.from(l);
    return {
      from: _,
      restore: z
    };
    function z() {
      r = j, a.previous = F, a.currentConstruct = L, a.events.length = _, l = U, R();
    }
  }
  function R() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function WBt(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, o)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(r) : s.shift();
    }
    o > 0 && s.push(e[i].slice(0, o));
  }
  return s;
}
function ZBt(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    i = o === -2, r.push(s);
  }
  return r.join("");
}
function HBt(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      wze([BBt, ...(e || {}).extensions || []])
    ),
    content: i(lqt),
    defined: [],
    document: i(uqt),
    flow: i(CBt),
    lazy: {},
    string: i(IBt),
    text: i(RBt)
  };
  return r;
  function i(o) {
    return s;
    function s(l) {
      return XBt(r, o, l);
    }
  }
}
function QBt(e) {
  for (; !kze(e); )
    ;
  return e;
}
const $de = /[\0\t\n\r]/g;
function $Bt() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, s, l) {
    const c = [];
    let a, u, f, d, p;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, t = "", n && (o.charCodeAt(0) === 65279 && f++, n = void 0); f < o.length; ) {
      if ($de.lastIndex = f, a = $de.exec(o), d = a && a.index !== void 0 ? a.index : o.length, p = o.charCodeAt(d), !a) {
        t = o.slice(f);
        break;
      }
      if (p === 10 && f === d && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), f < d && (c.push(o.slice(f, d)), e += d - f), p) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, c.push(-2); e++ < u; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = d + 1;
    }
    return l && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const KBt = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function GBt(e) {
  return e.replace(KBt, YBt);
}
function YBt(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return xze(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return pY(n) || e;
}
const Mze = {}.hasOwnProperty;
function JBt(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), eXt(n)(QBt(HBt(n).document().write($Bt()(e, t, !0))));
}
function eXt(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Te),
      autolinkProtocol: T,
      autolinkEmail: T,
      atxHeading: o(Ve),
      blockQuote: o($),
      characterEscape: T,
      characterReference: T,
      codeFenced: o(pe),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(pe, s),
      codeText: o(ee, s),
      codeTextData: T,
      data: T,
      codeFlowValue: T,
      definition: o(Ce),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ee),
      hardBreakEscape: o(et),
      hardBreakTrailing: o(et),
      htmlFlow: o(ft, s),
      htmlFlowData: T,
      htmlText: o(ft, s),
      htmlTextData: T,
      image: o(me),
      label: s,
      link: o(Te),
      listItem: o(le),
      listItemValue: d,
      listOrdered: o(re, f),
      listUnordered: o(re),
      paragraph: o(Oe),
      reference: q,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(Ve),
      strong: o(be),
      thematicBreak: o(xe)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: x,
      autolink: c(),
      autolinkEmail: fe,
      autolinkProtocol: ce,
      blockQuote: c(),
      characterEscapeValue: R,
      characterReferenceMarkerHexadecimal: Y,
      characterReferenceMarkerNumeric: Y,
      characterReferenceValue: J,
      characterReference: oe,
      codeFenced: c(v),
      codeFencedFence: m,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: h,
      codeFlowValue: R,
      codeIndented: c(b),
      codeText: c(U),
      codeTextData: R,
      data: R,
      definition: c(),
      definitionDestinationString: O,
      definitionLabelString: A,
      definitionTitleString: w,
      emphasis: c(),
      hardBreakEscape: c(F),
      hardBreakTrailing: c(F),
      htmlFlow: c(L),
      htmlFlowData: R,
      htmlText: c(_),
      htmlTextData: R,
      image: c(C),
      label: M,
      labelText: I,
      lineEnding: j,
      link: c(z),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: H,
      resourceDestinationString: D,
      resourceTitleString: X,
      resource: B,
      setextHeading: c(k),
      setextHeadingLineSequence: E,
      setextHeadingText: S,
      strong: c(),
      thematicBreak: c()
    }
  };
  Dze(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(Q) {
    let ae = {
      type: "root",
      children: []
    };
    const Pe = {
      stack: [ae],
      tokenStack: [],
      config: t,
      enter: l,
      exit: a,
      buffer: s,
      resume: u,
      data: n
    }, Fe = [];
    let Ke = -1;
    for (; ++Ke < Q.length; )
      if (Q[Ke][1].type === "listOrdered" || Q[Ke][1].type === "listUnordered")
        if (Q[Ke][0] === "enter")
          Fe.push(Ke);
        else {
          const Ot = Fe.pop();
          Ke = i(Q, Ot, Ke);
        }
    for (Ke = -1; ++Ke < Q.length; ) {
      const Ot = t[Q[Ke][0]];
      Mze.call(Ot, Q[Ke][1].type) && Ot[Q[Ke][1].type].call(Object.assign({
        sliceSerialize: Q[Ke][2].sliceSerialize
      }, Pe), Q[Ke][1]);
    }
    if (Pe.tokenStack.length > 0) {
      const Ot = Pe.tokenStack[Pe.tokenStack.length - 1];
      (Ot[1] || Kde).call(Pe, void 0, Ot[0]);
    }
    for (ae.position = {
      start: Uh(Q.length > 0 ? Q[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Uh(Q.length > 0 ? Q[Q.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ke = -1; ++Ke < t.transforms.length; )
      ae = t.transforms[Ke](ae) || ae;
    return ae;
  }
  function i(Q, ae, Pe) {
    let Fe = ae - 1, Ke = -1, Ot = !1, Ct, Jt, yn, vn;
    for (; ++Fe <= Pe; ) {
      const Re = Q[Fe];
      switch (Re[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Re[0] === "enter" ? Ke++ : Ke--, vn = void 0;
          break;
        }
        case "lineEndingBlank": {
          Re[0] === "enter" && (Ct && !vn && !Ke && !yn && (yn = Fe), vn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          vn = void 0;
      }
      if (!Ke && Re[0] === "enter" && Re[1].type === "listItemPrefix" || Ke === -1 && Re[0] === "exit" && (Re[1].type === "listUnordered" || Re[1].type === "listOrdered")) {
        if (Ct) {
          let _e = Fe;
          for (Jt = void 0; _e--; ) {
            const jt = Q[_e];
            if (jt[1].type === "lineEnding" || jt[1].type === "lineEndingBlank") {
              if (jt[0] === "exit") continue;
              Jt && (Q[Jt][1].type = "lineEndingBlank", Ot = !0), jt[1].type = "lineEnding", Jt = _e;
            } else if (!(jt[1].type === "linePrefix" || jt[1].type === "blockQuotePrefix" || jt[1].type === "blockQuotePrefixWhitespace" || jt[1].type === "blockQuoteMarker" || jt[1].type === "listItemIndent")) break;
          }
          yn && (!Jt || yn < Jt) && (Ct._spread = !0), Ct.end = Object.assign({}, Jt ? Q[Jt][1].start : Re[1].end), Q.splice(Jt || Fe, 0, ["exit", Ct, Re[2]]), Fe++, Pe++;
        }
        if (Re[1].type === "listItemPrefix") {
          const _e = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Re[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ct = _e, Q.splice(Fe, 0, ["enter", _e, Re[2]]), Fe++, Pe++, yn = void 0, vn = !0;
        }
      }
    }
    return Q[ae][1]._spread = Ot, Pe;
  }
  function o(Q, ae) {
    return Pe;
    function Pe(Fe) {
      l.call(this, Q(Fe), Fe), ae && ae.call(this, Fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(Q, ae, Pe) {
    this.stack[this.stack.length - 1].children.push(Q), this.stack.push(Q), this.tokenStack.push([ae, Pe || void 0]), Q.position = {
      start: Uh(ae.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(Q) {
    return ae;
    function ae(Pe) {
      Q && Q.call(this, Pe), a.call(this, Pe);
    }
  }
  function a(Q, ae) {
    const Pe = this.stack.pop(), Fe = this.tokenStack.pop();
    if (Fe)
      Fe[0].type !== Q.type && (ae ? ae.call(this, Q, Fe[0]) : (Fe[1] || Kde).call(this, Q, Fe[0]));
    else throw new Error("Cannot close `" + Q.type + "` (" + qE({
      start: Q.start,
      end: Q.end
    }) + "): it’s not open");
    Pe.position.end = Uh(Q.end);
  }
  function u() {
    return fY(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(Q) {
    if (this.data.expectingFirstListItemValue) {
      const ae = this.stack[this.stack.length - 2];
      ae.start = Number.parseInt(this.sliceSerialize(Q), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.lang = Q;
  }
  function h() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.meta = Q;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function v() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = Q.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = Q.replace(/(\r?\n|\r)$/g, "");
  }
  function A(Q) {
    const ae = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = ae, Pe.identifier = Hu(this.sliceSerialize(Q)).toLowerCase();
  }
  function w() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.title = Q;
  }
  function O() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.url = Q;
  }
  function x(Q) {
    const ae = this.stack[this.stack.length - 1];
    if (!ae.depth) {
      const Pe = this.sliceSerialize(Q).length;
      ae.depth = Pe;
    }
  }
  function S() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function E(Q) {
    const ae = this.stack[this.stack.length - 1];
    ae.depth = this.sliceSerialize(Q).codePointAt(0) === 61 ? 1 : 2;
  }
  function k() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function T(Q) {
    const Pe = this.stack[this.stack.length - 1].children;
    let Fe = Pe[Pe.length - 1];
    (!Fe || Fe.type !== "text") && (Fe = je(), Fe.position = {
      start: Uh(Q.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Pe.push(Fe)), this.stack.push(Fe);
  }
  function R(Q) {
    const ae = this.stack.pop();
    ae.value += this.sliceSerialize(Q), ae.position.end = Uh(Q.end);
  }
  function j(Q) {
    const ae = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Pe = ae.children[ae.children.length - 1];
      Pe.position.end = Uh(Q.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(ae.type) && (T.call(this, Q), R.call(this, Q));
  }
  function F() {
    this.data.atHardBreak = !0;
  }
  function L() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = Q;
  }
  function _() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = Q;
  }
  function U() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.value = Q;
  }
  function z() {
    const Q = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ae = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = ae, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function C() {
    const Q = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ae = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = ae, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function I(Q) {
    const ae = this.sliceSerialize(Q), Pe = this.stack[this.stack.length - 2];
    Pe.label = GBt(ae), Pe.identifier = Hu(ae).toLowerCase();
  }
  function M() {
    const Q = this.stack[this.stack.length - 1], ae = this.resume(), Pe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Pe.type === "link") {
      const Fe = Q.children;
      Pe.children = Fe;
    } else
      Pe.alt = ae;
  }
  function D() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.url = Q;
  }
  function X() {
    const Q = this.resume(), ae = this.stack[this.stack.length - 1];
    ae.title = Q;
  }
  function B() {
    this.data.inReference = void 0;
  }
  function q() {
    this.data.referenceType = "collapsed";
  }
  function H(Q) {
    const ae = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = ae, Pe.identifier = Hu(this.sliceSerialize(Q)).toLowerCase(), this.data.referenceType = "full";
  }
  function Y(Q) {
    this.data.characterReferenceType = Q.type;
  }
  function J(Q) {
    const ae = this.sliceSerialize(Q), Pe = this.data.characterReferenceType;
    let Fe;
    Pe ? (Fe = xze(ae, Pe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Fe = pY(ae);
    const Ke = this.stack[this.stack.length - 1];
    Ke.value += Fe;
  }
  function oe(Q) {
    const ae = this.stack.pop();
    ae.position.end = Uh(Q.end);
  }
  function ce(Q) {
    R.call(this, Q);
    const ae = this.stack[this.stack.length - 1];
    ae.url = this.sliceSerialize(Q);
  }
  function fe(Q) {
    R.call(this, Q);
    const ae = this.stack[this.stack.length - 1];
    ae.url = "mailto:" + this.sliceSerialize(Q);
  }
  function $() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function pe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ce() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ee() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ve() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function et() {
    return {
      type: "break"
    };
  }
  function ft() {
    return {
      type: "html",
      value: ""
    };
  }
  function me() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Te() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function re(Q) {
    return {
      type: "list",
      ordered: Q.type === "listOrdered",
      start: null,
      spread: Q._spread,
      children: []
    };
  }
  function le(Q) {
    return {
      type: "listItem",
      spread: Q._spread,
      checked: null,
      children: []
    };
  }
  function Oe() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function be() {
    return {
      type: "strong",
      children: []
    };
  }
  function je() {
    return {
      type: "text",
      value: ""
    };
  }
  function xe() {
    return {
      type: "thematicBreak"
    };
  }
}
function Uh(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Dze(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Dze(e, r) : tXt(e, r);
  }
}
function tXt(e, t) {
  let n;
  for (n in t)
    if (Mze.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Kde(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + qE({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + qE({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + qE({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function nXt(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return JBt(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function rXt(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function iXt(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function oXt(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function sXt(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function aXt(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function lXt(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Dx(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let s, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(r, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, c);
  const a = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, a), e.applyData(t, a);
}
function cXt(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function uXt(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function _ze(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const s = i[i.length - 1];
  return s && s.type === "text" ? s.value += r : i.push({ type: "text", value: r }), i;
}
function dXt(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return _ze(e, t);
  const i = { src: Dx(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function fXt(e, t) {
  const n = { src: Dx(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function pXt(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function hXt(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return _ze(e, t);
  const i = { href: Dx(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function mXt(e, t) {
  const n = { href: Dx(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function gXt(e, t, n) {
  const r = e.all(t), i = n ? yXt(n) : Lze(t), o = {}, s = [];
  if (typeof t.checked == "boolean") {
    const u = r[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const u = r[l];
    (i || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? s.push(...u.children) : s.push(u);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const a = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(t, a), e.applyData(t, a);
}
function yXt(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Lze(n[r]);
  }
  return t;
}
function Lze(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function vXt(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const s = r[i];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function bXt(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function OXt(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function AXt(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function wXt(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), i.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = lY(t.children[1]), c = mze(t.children[t.children.length - 1]);
    l && c && (s.position = { start: l, end: c }), i.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function xXt(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, l = s ? s.length : t.children.length;
  let c = -1;
  const a = [];
  for (; ++c < l; ) {
    const f = t.children[c], d = {}, p = s ? s[c] : void 0;
    p && (d.align = p);
    let h = { type: "element", tagName: o, properties: d, children: [] };
    f && (h.children = e.all(f), e.patch(f, h), h = e.applyData(f, h)), a.push(h);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(t, u), e.applyData(t, u);
}
function SXt(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Gde = 9, Yde = 32;
function EXt(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      Jde(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(Jde(t.slice(i), i > 0, !1)), o.join("");
}
function Jde(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === Gde || o === Yde; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === Gde || o === Yde; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function TXt(e, t) {
  const n = { type: "text", value: EXt(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function kXt(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const CXt = {
  blockquote: rXt,
  break: iXt,
  code: oXt,
  delete: sXt,
  emphasis: aXt,
  footnoteReference: lXt,
  heading: cXt,
  html: uXt,
  imageReference: dXt,
  image: fXt,
  inlineCode: pXt,
  linkReference: hXt,
  link: mXt,
  listItem: gXt,
  list: vXt,
  paragraph: bXt,
  // @ts-expect-error: root is different, but hard to type.
  root: OXt,
  strong: AXt,
  table: wXt,
  tableCell: SXt,
  tableRow: xXt,
  text: TXt,
  thematicBreak: kXt,
  toml: HI,
  yaml: HI,
  definition: HI,
  footnoteDefinition: HI
};
function HI() {
}
const zze = -1, s3 = 0, XE = 1, W_ = 2, mY = 3, gY = 4, yY = 5, vY = 6, jze = 7, Fze = 8, efe = typeof self == "object" ? self : globalThis, NXt = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, s] = t[i];
    switch (o) {
      case s3:
      case zze:
        return n(s, i);
      case XE: {
        const l = n([], i);
        for (const c of s)
          l.push(r(c));
        return l;
      }
      case W_: {
        const l = n({}, i);
        for (const [c, a] of s)
          l[r(c)] = r(a);
        return l;
      }
      case mY:
        return n(new Date(s), i);
      case gY: {
        const { source: l, flags: c } = s;
        return n(new RegExp(l, c), i);
      }
      case yY: {
        const l = n(/* @__PURE__ */ new Map(), i);
        for (const [c, a] of s)
          l.set(r(c), r(a));
        return l;
      }
      case vY: {
        const l = n(/* @__PURE__ */ new Set(), i);
        for (const c of s)
          l.add(r(c));
        return l;
      }
      case jze: {
        const { name: l, message: c } = s;
        return n(new efe[l](c), i);
      }
      case Fze:
        return n(BigInt(s), i);
      case "BigInt":
        return n(Object(BigInt(s)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(s).buffer, s);
      case "DataView": {
        const { buffer: l } = new Uint8Array(s);
        return n(new DataView(l), s);
      }
    }
    return n(new efe[o](s), i);
  };
  return r;
}, tfe = (e) => NXt(/* @__PURE__ */ new Map(), e)(0), a0 = "", { toString: PXt } = {}, { keys: IXt } = Object, kS = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [s3, t];
  const n = PXt.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [XE, a0];
    case "Object":
      return [W_, a0];
    case "Date":
      return [mY, a0];
    case "RegExp":
      return [gY, a0];
    case "Map":
      return [yY, a0];
    case "Set":
      return [vY, a0];
    case "DataView":
      return [XE, n];
  }
  return n.includes("Array") ? [XE, n] : n.includes("Error") ? [jze, n] : [W_, n];
}, QI = ([e, t]) => e === s3 && (t === "function" || t === "symbol"), RXt = (e, t, n, r) => {
  const i = (s, l) => {
    const c = r.push(s) - 1;
    return n.set(l, c), c;
  }, o = (s) => {
    if (n.has(s))
      return n.get(s);
    let [l, c] = kS(s);
    switch (l) {
      case s3: {
        let u = s;
        switch (c) {
          case "bigint":
            l = Fze, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            u = null;
            break;
          case "undefined":
            return i([zze], s);
        }
        return i([l, u], s);
      }
      case XE: {
        if (c) {
          let d = s;
          return c === "DataView" ? d = new Uint8Array(s.buffer) : c === "ArrayBuffer" && (d = new Uint8Array(s)), i([c, [...d]], s);
        }
        const u = [], f = i([l, u], s);
        for (const d of s)
          u.push(o(d));
        return f;
      }
      case W_: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = i([l, u], s);
        for (const d of IXt(s))
          (e || !QI(kS(s[d]))) && u.push([o(d), o(s[d])]);
        return f;
      }
      case mY:
        return i([l, s.toISOString()], s);
      case gY: {
        const { source: u, flags: f } = s;
        return i([l, { source: u, flags: f }], s);
      }
      case yY: {
        const u = [], f = i([l, u], s);
        for (const [d, p] of s)
          (e || !(QI(kS(d)) || QI(kS(p)))) && u.push([o(d), o(p)]);
        return f;
      }
      case vY: {
        const u = [], f = i([l, u], s);
        for (const d of s)
          (e || !QI(kS(d))) && u.push(o(d));
        return f;
      }
    }
    const { message: a } = s;
    return i([l, { name: c, message: a }], s);
  };
  return o;
}, nfe = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return RXt(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Z_ = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? tfe(nfe(e, t)) : structuredClone(e)
) : (e, t) => tfe(nfe(e, t));
function MXt(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function DXt(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function _Xt(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || MXt, r = e.options.footnoteBackLabel || DXt, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const a = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!a)
      continue;
    const u = e.all(a), f = String(a.identifier).toUpperCase(), d = Dx(f.toLowerCase());
    let p = 0;
    const h = [], m = e.footnoteCounts.get(f);
    for (; m !== void 0 && ++p <= m; ) {
      h.length > 0 && h.push({ type: "text", value: " " });
      let A = typeof n == "string" ? n : n(c, p);
      typeof A == "string" && (A = { type: "text", value: A }), h.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + d + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(A) ? A : [A]
      });
    }
    const v = u[u.length - 1];
    if (v && v.type === "element" && v.tagName === "p") {
      const A = v.children[v.children.length - 1];
      A && A.type === "text" ? A.value += " " : v.children.push({ type: "text", value: " " }), v.children.push(...h);
    } else
      u.push(...h);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + d },
      children: e.wrap(u, !0)
    };
    e.patch(a, b), l.push(b);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Z_(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const a3 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return FXt;
    if (typeof e == "function")
      return l3(e);
    if (typeof e == "object")
      return Array.isArray(e) ? LXt(e) : zXt(e);
    if (typeof e == "string")
      return jXt(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function LXt(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = a3(e[n]);
  return l3(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i)) return !0;
    return !1;
  }
}
function zXt(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return l3(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o]) return !1;
    return !0;
  }
}
function jXt(e) {
  return l3(t);
  function t(n) {
    return n && n.type === e;
  }
}
function l3(e) {
  return t;
  function t(n, r, i) {
    return !!(UXt(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function FXt() {
  return !0;
}
function UXt(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Uze = [], VXt = !0, I8 = !1, qXt = "skip";
function Vze(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = a3(i), s = r ? -1 : 1;
  l(e, void 0, [])();
  function l(c, a, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof f.type == "string") {
      const p = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(d, "name", {
        value: "node (" + (c.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return d;
    function d() {
      let p = Uze, h, m, v;
      if ((!t || o(c, a, u[u.length - 1] || void 0)) && (p = BXt(n(c, u)), p[0] === I8))
        return p;
      if ("children" in c && c.children) {
        const b = (
          /** @type {UnistParent} */
          c
        );
        if (b.children && p[0] !== qXt)
          for (m = (r ? b.children.length : -1) + s, v = u.concat(b); m > -1 && m < b.children.length; ) {
            const A = b.children[m];
            if (h = l(A, m, v)(), h[0] === I8)
              return h;
            m = typeof h[1] == "number" ? h[1] : m + s;
          }
      }
      return p;
    }
  }
}
function BXt(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [VXt, e] : e == null ? Uze : [e];
}
function bY(e, t, n, r) {
  let i, o, s;
  typeof t == "function" ? (o = void 0, s = t, i = n) : (o = t, s = n, i = r), Vze(e, o, l, i);
  function l(c, a) {
    const u = a[a.length - 1], f = u ? u.children.indexOf(c) : void 0;
    return s(c, f, u);
  }
}
const R8 = {}.hasOwnProperty, XXt = {};
function WXt(e, t) {
  const n = t || XXt, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...CXt, ...n.handlers }, l = {
    all: a,
    applyData: HXt,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: n,
    patch: ZXt,
    wrap: $Xt
  };
  return bY(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? r : i, d = String(u.identifier).toUpperCase();
      f.has(d) || f.set(d, u);
    }
  }), l;
  function c(u, f) {
    const d = u.type, p = l.handlers[d];
    if (R8.call(l.handlers, d) && p)
      return p(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(d)) {
      if ("children" in u) {
        const { children: m, ...v } = u, b = Z_(v);
        return b.children = l.all(u), b;
      }
      return Z_(u);
    }
    return (l.options.unknownHandler || QXt)(l, u, f);
  }
  function a(u) {
    const f = [];
    if ("children" in u) {
      const d = u.children;
      let p = -1;
      for (; ++p < d.length; ) {
        const h = l.one(d[p], u);
        if (h) {
          if (p && d[p - 1].type === "break" && (!Array.isArray(h) && h.type === "text" && (h.value = rfe(h.value)), !Array.isArray(h) && h.type === "element")) {
            const m = h.children[0];
            m && m.type === "text" && (m.value = rfe(m.value));
          }
          Array.isArray(h) ? f.push(...h) : f.push(h);
        }
      }
    }
    return f;
  }
}
function ZXt(e, t) {
  e.position && (t.position = DVt(e));
}
function HXt(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && o && Object.assign(n.properties, Z_(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function QXt(e, t) {
  const n = t.data || {}, r = "value" in t && !(R8.call(n, "hProperties") || R8.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function $Xt(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function rfe(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function ife(e, t) {
  const n = WXt(e, t), r = n.one(e, void 0), i = _Xt(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function KXt(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      ife(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      ife(n, { file: r, ...e || t })
    );
  };
}
function ofe(e) {
  if (e)
    throw e;
}
var o4, sfe;
function GXt() {
  if (sfe) return o4;
  sfe = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(a) {
    return typeof Array.isArray == "function" ? Array.isArray(a) : t.call(a) === "[object Array]";
  }, o = function(a) {
    if (!a || t.call(a) !== "[object Object]")
      return !1;
    var u = e.call(a, "constructor"), f = a.constructor && a.constructor.prototype && e.call(a.constructor.prototype, "isPrototypeOf");
    if (a.constructor && !u && !f)
      return !1;
    var d;
    for (d in a)
      ;
    return typeof d > "u" || e.call(a, d);
  }, s = function(a, u) {
    n && u.name === "__proto__" ? n(a, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : a[u.name] = u.newValue;
  }, l = function(a, u) {
    if (u === "__proto__")
      if (e.call(a, u)) {
        if (r)
          return r(a, u).value;
      } else return;
    return a[u];
  };
  return o4 = function c() {
    var a, u, f, d, p, h, m = arguments[0], v = 1, b = arguments.length, A = !1;
    for (typeof m == "boolean" && (A = m, m = arguments[1] || {}, v = 2), (m == null || typeof m != "object" && typeof m != "function") && (m = {}); v < b; ++v)
      if (a = arguments[v], a != null)
        for (u in a)
          f = l(m, u), d = l(a, u), m !== d && (A && d && (o(d) || (p = i(d))) ? (p ? (p = !1, h = f && i(f) ? f : []) : h = f && o(f) ? f : {}, s(m, { name: u, newValue: c(A, h, d) })) : typeof d < "u" && s(m, { name: u, newValue: d }));
    return m;
  }, o4;
}
var YXt = GXt();
const s4 = /* @__PURE__ */ Sl(YXt);
function M8(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function JXt() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...i);
    function l(c, ...a) {
      const u = e[++o];
      let f = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++f < i.length; )
        (a[f] === null || a[f] === void 0) && (a[f] = i[f]);
      i = a, u ? e9t(u, l)(...a) : s(null, ...a);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function e9t(e, t) {
  let n;
  return r;
  function r(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(i);
    try {
      c = e.apply(this, s);
    } catch (a) {
      const u = (
        /** @type {Error} */
        a
      );
      if (l && n)
        throw u;
      return i(u);
    }
    l || (c && c.then && typeof c.then == "function" ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(s, ...l) {
    n || (n = !0, t(s, ...l));
  }
  function o(s) {
    i(null, s);
  }
}
const Fd = { basename: t9t, dirname: n9t, extname: r9t, join: i9t, sep: "/" };
function t9t(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  zN(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, l = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = i + 1), l > -1 && (e.codePointAt(i) === t.codePointAt(l--) ? l < 0 && (r = i) : (l = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function n9t(e) {
  if (zN(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function r9t(e) {
  zN(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, s;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), l === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function i9t(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    zN(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : o9t(n);
}
function o9t(e) {
  zN(e);
  const t = e.codePointAt(0) === 47;
  let n = s9t(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function s9t(e, t) {
  let n = "", r = 0, i = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === s - 1 || o === 1)) if (i !== s - 1 && o === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = s, o = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = s, o = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function zN(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const a9t = { cwd: l9t };
function l9t() {
  return "/";
}
function D8(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function c9t(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!D8(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return u9t(e);
}
function u9t(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const a4 = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class qze {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? D8(t) ? n = { path: t } : typeof t == "string" || d9t(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : a9t.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < a4.length; ) {
      const o = a4[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      a4.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Fd.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    c4(t, "basename"), l4(t, "basename"), this.path = Fd.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Fd.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    afe(this.basename, "dirname"), this.path = Fd.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Fd.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (l4(t, "extname"), afe(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Fd.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    D8(t) && (t = c9t(t)), c4(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Fd.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    c4(t, "stem"), l4(t, "stem"), this.path = Fd.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new aa(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function l4(e, t) {
  if (e && e.includes(Fd.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Fd.sep + "`"
    );
}
function c4(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function afe(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function d9t(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const f9t = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, r), o;
  }
), p9t = {}.hasOwnProperty;
class OY extends f9t {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = JXt();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new OY()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(s4(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (f4("data", this.frozen), this.namespace[t] = n, this) : p9t.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (f4("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = $I(t), r = this.parser || this.Parser;
    return u4("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), u4("process", this.parser || this.Parser), d4("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, s) {
      const l = $I(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(c, l, function(u, f, d) {
        if (u || !f || !d)
          return a(u);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), h = r.stringify(p, d);
        g9t(h) ? d.value = h : d.result = h, a(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          d
        );
      });
      function a(u, f) {
        u || !f ? s(u) : o ? o(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), u4("processSync", this.parser || this.Parser), d4("processSync", this.compiler || this.Compiler), this.process(t, i), cfe("processSync", "process", n), r;
    function i(o, s) {
      n = !0, ofe(o), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    lfe(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(s, l) {
      const c = $I(n);
      i.run(t, c, a);
      function a(u, f, d) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        u ? l(u) : s ? s(p) : r(void 0, p, d);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), cfe("runSync", "run", r), i;
    function o(s, l) {
      ofe(s), i = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = $I(n), i = this.compiler || this.Compiler;
    return d4("stringify", i), lfe(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (f4("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(a) {
      if (typeof a == "function")
        c(a, []);
      else if (typeof a == "object")
        if (Array.isArray(a)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            a
          );
          c(u, f);
        } else
          s(a);
      else
        throw new TypeError("Expected usable value, not `" + a + "`");
    }
    function s(a) {
      if (!("plugins" in a) && !("settings" in a))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(a.plugins), a.settings && (i.settings = s4(!0, i.settings, a.settings));
    }
    function l(a) {
      let u = -1;
      if (a != null) if (Array.isArray(a))
        for (; ++u < a.length; ) {
          const f = a[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + a + "`");
    }
    function c(a, u) {
      let f = -1, d = -1;
      for (; ++f < r.length; )
        if (r[f][0] === a) {
          d = f;
          break;
        }
      if (d === -1)
        r.push([a, ...u]);
      else if (u.length > 0) {
        let [p, ...h] = u;
        const m = r[d][1];
        M8(m) && M8(p) && (p = s4(!0, m, p)), r[d] = [a, p, ...h];
      }
    }
  }
}
const h9t = new OY().freeze();
function u4(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function d4(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function f4(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function lfe(e) {
  if (!M8(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function cfe(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function $I(e) {
  return m9t(e) ? e : new qze(e);
}
function m9t(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function g9t(e) {
  return typeof e == "string" || y9t(e);
}
function y9t(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const v9t = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ufe = [], dfe = { allowDangerousHtml: !0 }, b9t = /^(https?|ircs?|mailto|xmpp)$/i, O9t = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Bze(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || ufe, c = e.remarkPlugins || ufe, a = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...dfe } : dfe, u = e.skipHtml, f = e.unwrapDisallowed, d = e.urlTransform || A9t, p = h9t().use(nXt).use(c).use(KXt, a).use(l), h = new qze();
  typeof r == "string" && (h.value = r);
  for (const A of O9t)
    Object.hasOwn(e, A.from) && ("" + A.from + (A.to ? "use `" + A.to + "` instead" : "remove it") + v9t + A.id, void 0);
  const m = p.parse(h);
  let v = p.runSync(m, h);
  return i && (v = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      v.type === "root" ? v.children : [v]
    )
  }), bY(v, b), FVt(v, {
    Fragment: pt,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: y,
    jsxs: V,
    passKeys: !0,
    passNode: !0
  });
  function b(A, w, O) {
    if (A.type === "raw" && O && typeof w == "number")
      return u ? O.children.splice(w, 1) : O.children[w] = { type: "text", value: A.value }, w;
    if (A.type === "element") {
      let x;
      for (x in n4)
        if (Object.hasOwn(n4, x) && Object.hasOwn(A.properties, x)) {
          const S = A.properties[x], E = n4[x];
          (E === null || E.includes(A.tagName)) && (A.properties[x] = d(String(S || ""), x, A));
        }
    }
    if (A.type === "element") {
      let x = t ? !t.includes(A.tagName) : s ? s.includes(A.tagName) : !1;
      if (!x && n && typeof w == "number" && (x = !n(A, w, O)), x && O && typeof w == "number")
        return f && A.children ? O.children.splice(w, 1, ...A.children) : O.children.splice(w, 1), w;
    }
  }
}
function A9t(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    b9t.test(e.slice(0, t)) ? e : ""
  );
}
function ffe(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function w9t(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Xze(e, t, n) {
  const i = a3((n || {}).ignore || []), o = x9t(t);
  let s = -1;
  for (; ++s < o.length; )
    Vze(e, "text", l);
  function l(a, u) {
    let f = -1, d;
    for (; ++f < u.length; ) {
      const p = u[f], h = d ? d.children : void 0;
      if (i(
        p,
        h ? h.indexOf(p) : void 0,
        d
      ))
        return;
      d = p;
    }
    if (d)
      return c(a, u);
  }
  function c(a, u) {
    const f = u[u.length - 1], d = o[s][0], p = o[s][1];
    let h = 0;
    const v = f.children.indexOf(a);
    let b = !1, A = [];
    d.lastIndex = 0;
    let w = d.exec(a.value);
    for (; w; ) {
      const O = w.index, x = {
        index: w.index,
        input: w.input,
        stack: [...u, a]
      };
      let S = p(...w, x);
      if (typeof S == "string" && (S = S.length > 0 ? { type: "text", value: S } : void 0), S === !1 ? d.lastIndex = O + 1 : (h !== O && A.push({
        type: "text",
        value: a.value.slice(h, O)
      }), Array.isArray(S) ? A.push(...S) : S && A.push(S), h = O + w[0].length, b = !0), !d.global)
        break;
      w = d.exec(a.value);
    }
    return b ? (h < a.value.length && A.push({ type: "text", value: a.value.slice(h) }), f.children.splice(v, 1, ...A)) : A = [a], v + A.length;
  }
}
function x9t(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([S9t(i[0]), E9t(i[1])]);
  }
  return t;
}
function S9t(e) {
  return typeof e == "string" ? new RegExp(w9t(e), "g") : e;
}
function E9t(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const p4 = "phrasing", h4 = ["autolink", "link", "image", "label"];
function T9t() {
  return {
    transforms: [M9t],
    enter: {
      literalAutolink: C9t,
      literalAutolinkEmail: m4,
      literalAutolinkHttp: m4,
      literalAutolinkWww: m4
    },
    exit: {
      literalAutolink: R9t,
      literalAutolinkEmail: I9t,
      literalAutolinkHttp: N9t,
      literalAutolinkWww: P9t
    }
  };
}
function k9t() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: p4,
        notInConstruct: h4
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: p4,
        notInConstruct: h4
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: p4,
        notInConstruct: h4
      }
    ]
  };
}
function C9t(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function m4(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function N9t(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function P9t(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function I9t(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function R9t(e) {
  this.exit(e);
}
function M9t(e) {
  Xze(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, D9t],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), _9t]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function D9t(e, t, n, r, i) {
  let o = "";
  if (!Wze(i) || (/^w/i.test(t) && (n = t + n, t = "", o = "http://"), !L9t(n)))
    return !1;
  const s = z9t(n + r);
  if (!s[0]) return !1;
  const l = {
    type: "link",
    title: null,
    url: o + t + s[0],
    children: [{ type: "text", value: t + s[0] }]
  };
  return s[1] ? [l, { type: "text", value: s[1] }] : l;
}
function _9t(e, t, n, r) {
  return (
    // Not an expected previous character.
    !Wze(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function L9t(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function z9t(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = ffe(e, "(");
  let o = ffe(e, ")");
  for (; r !== -1 && i > o; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), o++;
  return [e, n];
}
function Wze(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Jv(n) || i3(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
Zze.peek = Z9t;
function j9t() {
  this.buffer();
}
function F9t(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function U9t() {
  this.buffer();
}
function V9t(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function q9t(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = Hu(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function B9t(e) {
  this.exit(e);
}
function X9t(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = Hu(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function W9t(e) {
  this.exit(e);
}
function Z9t() {
  return "[";
}
function Zze(e, t, n, r) {
  const i = n.createTracker(r);
  let o = i.move("[^");
  const s = n.enter("footnoteReference"), l = n.enter("reference");
  return o += i.move(
    n.safe(n.associationId(e), { after: "]", before: o })
  ), l(), s(), o += i.move("]"), o;
}
function H9t() {
  return {
    enter: {
      gfmFootnoteCallString: j9t,
      gfmFootnoteCall: F9t,
      gfmFootnoteDefinitionLabelString: U9t,
      gfmFootnoteDefinition: V9t
    },
    exit: {
      gfmFootnoteCallString: q9t,
      gfmFootnoteCall: B9t,
      gfmFootnoteDefinitionLabelString: X9t,
      gfmFootnoteDefinition: W9t
    }
  };
}
function Q9t(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: Zze },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, i, o, s) {
    const l = o.createTracker(s);
    let c = l.move("[^");
    const a = o.enter("footnoteDefinition"), u = o.enter("label");
    return c += l.move(
      o.safe(o.associationId(r), { before: c, after: "]" })
    ), u(), c += l.move("]:"), r.children && r.children.length > 0 && (l.shift(4), c += l.move(
      (t ? `
` : " ") + o.indentLines(
        o.containerFlow(r, l.current()),
        t ? Hze : $9t
      )
    )), a(), c;
  }
}
function $9t(e, t, n) {
  return t === 0 ? e : Hze(e, t, n);
}
function Hze(e, t, n) {
  return (n ? "" : "    ") + e;
}
const K9t = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
Qze.peek = t8t;
function G9t() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: J9t },
    exit: { strikethrough: e8t }
  };
}
function Y9t() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: K9t
      }
    ],
    handlers: { delete: Qze }
  };
}
function J9t(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function e8t(e) {
  this.exit(e);
}
function Qze(e, t, n, r) {
  const i = n.createTracker(r), o = n.enter("strikethrough");
  let s = i.move("~~");
  return s += n.containerPhrasing(e, {
    ...i.current(),
    before: s,
    after: "~"
  }), s += i.move("~~"), o(), s;
}
function t8t() {
  return "~";
}
function n8t(e) {
  return e.length;
}
function r8t(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || n8t, o = [], s = [], l = [], c = [];
  let a = 0, u = -1;
  for (; ++u < e.length; ) {
    const m = [], v = [];
    let b = -1;
    for (e[u].length > a && (a = e[u].length); ++b < e[u].length; ) {
      const A = i8t(e[u][b]);
      if (n.alignDelimiters !== !1) {
        const w = i(A);
        v[b] = w, (c[b] === void 0 || w > c[b]) && (c[b] = w);
      }
      m.push(A);
    }
    s[u] = m, l[u] = v;
  }
  let f = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++f < a; )
      o[f] = pfe(r[f]);
  else {
    const m = pfe(r);
    for (; ++f < a; )
      o[f] = m;
  }
  f = -1;
  const d = [], p = [];
  for (; ++f < a; ) {
    const m = o[f];
    let v = "", b = "";
    m === 99 ? (v = ":", b = ":") : m === 108 ? v = ":" : m === 114 && (b = ":");
    let A = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      c[f] - v.length - b.length
    );
    const w = v + "-".repeat(A) + b;
    n.alignDelimiters !== !1 && (A = v.length + A + b.length, A > c[f] && (c[f] = A), p[f] = A), d[f] = w;
  }
  s.splice(1, 0, d), l.splice(1, 0, p), u = -1;
  const h = [];
  for (; ++u < s.length; ) {
    const m = s[u], v = l[u];
    f = -1;
    const b = [];
    for (; ++f < a; ) {
      const A = m[f] || "";
      let w = "", O = "";
      if (n.alignDelimiters !== !1) {
        const x = c[f] - (v[f] || 0), S = o[f];
        S === 114 ? w = " ".repeat(x) : S === 99 ? x % 2 ? (w = " ".repeat(x / 2 + 0.5), O = " ".repeat(x / 2 - 0.5)) : (w = " ".repeat(x / 2), O = w) : O = " ".repeat(x);
      }
      n.delimiterStart !== !1 && !f && b.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && A === "") && (n.delimiterStart !== !1 || f) && b.push(" "), n.alignDelimiters !== !1 && b.push(w), b.push(A), n.alignDelimiters !== !1 && b.push(O), n.padding !== !1 && b.push(" "), (n.delimiterEnd !== !1 || f !== a - 1) && b.push("|");
    }
    h.push(
      n.delimiterEnd === !1 ? b.join("").replace(/ +$/, "") : b.join("")
    );
  }
  return h.join(`
`);
}
function i8t(e) {
  return e == null ? "" : String(e);
}
function pfe(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function o8t(e, t, n, r) {
  const i = n.enter("blockquote"), o = n.createTracker(r);
  o.move("> "), o.shift(2);
  const s = n.indentLines(
    n.containerFlow(e, o.current()),
    s8t
  );
  return i(), s;
}
function s8t(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function a8t(e, t) {
  return hfe(e, t.inConstruct, !0) && !hfe(e, t.notInConstruct, !1);
}
function hfe(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function mfe(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && a8t(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function l8t(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, o = 0, s = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++o > s && (s = o) : o = 1, i = r + t.length, r = n.indexOf(t, i);
  return s;
}
function c8t(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function u8t(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function d8t(e, t, n, r) {
  const i = u8t(n), o = e.value || "", s = i === "`" ? "GraveAccent" : "Tilde";
  if (c8t(e, n)) {
    const f = n.enter("codeIndented"), d = n.indentLines(o, f8t);
    return f(), d;
  }
  const l = n.createTracker(r), c = i.repeat(Math.max(l8t(o, i) + 1, 3)), a = n.enter("codeFenced");
  let u = l.move(c);
  if (e.lang) {
    const f = n.enter(`codeFencedLang${s}`);
    u += l.move(
      n.safe(e.lang, {
        before: u,
        after: " ",
        encode: ["`"],
        ...l.current()
      })
    ), f();
  }
  if (e.lang && e.meta) {
    const f = n.enter(`codeFencedMeta${s}`);
    u += l.move(" "), u += l.move(
      n.safe(e.meta, {
        before: u,
        after: `
`,
        encode: ["`"],
        ...l.current()
      })
    ), f();
  }
  return u += l.move(`
`), o && (u += l.move(o + `
`)), u += l.move(c), a(), u;
}
function f8t(e, t, n) {
  return (n ? "" : "    ") + e;
}
function AY(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function p8t(e, t, n, r) {
  const i = AY(n), o = i === '"' ? "Quote" : "Apostrophe", s = n.enter("definition");
  let l = n.enter("label");
  const c = n.createTracker(r);
  let a = c.move("[");
  return a += c.move(
    n.safe(n.associationId(e), {
      before: a,
      after: "]",
      ...c.current()
    })
  ), a += c.move("]: "), l(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), a += c.move("<"), a += c.move(
    n.safe(e.url, { before: a, after: ">", ...c.current() })
  ), a += c.move(">")) : (l = n.enter("destinationRaw"), a += c.move(
    n.safe(e.url, {
      before: a,
      after: e.title ? " " : `
`,
      ...c.current()
    })
  )), l(), e.title && (l = n.enter(`title${o}`), a += c.move(" " + i), a += c.move(
    n.safe(e.title, {
      before: a,
      after: i,
      ...c.current()
    })
  ), a += c.move(i), l()), s(), a;
}
function h8t(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Ck(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function H_(e, t, n) {
  const r = Nw(e), i = Nw(t);
  return r === void 0 ? i === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : i === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
$ze.peek = m8t;
function $ze(e, t, n, r) {
  const i = h8t(n), o = n.enter("emphasis"), s = n.createTracker(r), l = s.move(i);
  let c = s.move(
    n.containerPhrasing(e, {
      after: i,
      before: l,
      ...s.current()
    })
  );
  const a = c.charCodeAt(0), u = H_(
    r.before.charCodeAt(r.before.length - 1),
    a,
    i
  );
  u.inside && (c = Ck(a) + c.slice(1));
  const f = c.charCodeAt(c.length - 1), d = H_(r.after.charCodeAt(0), f, i);
  d.inside && (c = c.slice(0, -1) + Ck(f));
  const p = s.move(i);
  return o(), n.attentionEncodeSurroundingInfo = {
    after: d.outside,
    before: u.outside
  }, l + c + p;
}
function m8t(e, t, n) {
  return n.options.emphasis || "*";
}
function g8t(e, t) {
  let n = !1;
  return bY(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, I8;
  }), !!((!e.depth || e.depth < 3) && fY(e) && (t.options.setext || n));
}
function y8t(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), o = n.createTracker(r);
  if (g8t(e, n)) {
    const u = n.enter("headingSetext"), f = n.enter("phrasing"), d = n.containerPhrasing(e, {
      ...o.current(),
      before: `
`,
      after: `
`
    });
    return f(), u(), d + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      d.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(d.lastIndexOf("\r"), d.lastIndexOf(`
`)) + 1)
    );
  }
  const s = "#".repeat(i), l = n.enter("headingAtx"), c = n.enter("phrasing");
  o.move(s + " ");
  let a = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...o.current()
  });
  return /^[\t ]/.test(a) && (a = Ck(a.charCodeAt(0)) + a.slice(1)), a = a ? s + " " + a : s, n.options.closeAtx && (a += " " + s), c(), l(), a;
}
Kze.peek = v8t;
function Kze(e) {
  return e.value || "";
}
function v8t() {
  return "<";
}
Gze.peek = b8t;
function Gze(e, t, n, r) {
  const i = AY(n), o = i === '"' ? "Quote" : "Apostrophe", s = n.enter("image");
  let l = n.enter("label");
  const c = n.createTracker(r);
  let a = c.move("![");
  return a += c.move(
    n.safe(e.alt, { before: a, after: "]", ...c.current() })
  ), a += c.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), a += c.move("<"), a += c.move(
    n.safe(e.url, { before: a, after: ">", ...c.current() })
  ), a += c.move(">")) : (l = n.enter("destinationRaw"), a += c.move(
    n.safe(e.url, {
      before: a,
      after: e.title ? " " : ")",
      ...c.current()
    })
  )), l(), e.title && (l = n.enter(`title${o}`), a += c.move(" " + i), a += c.move(
    n.safe(e.title, {
      before: a,
      after: i,
      ...c.current()
    })
  ), a += c.move(i), l()), a += c.move(")"), s(), a;
}
function b8t() {
  return "!";
}
Yze.peek = O8t;
function Yze(e, t, n, r) {
  const i = e.referenceType, o = n.enter("imageReference");
  let s = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("![");
  const a = n.safe(e.alt, {
    before: c,
    after: "]",
    ...l.current()
  });
  c += l.move(a + "]["), s();
  const u = n.stack;
  n.stack = [], s = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: c,
    after: "]",
    ...l.current()
  });
  return s(), n.stack = u, o(), i === "full" || !a || a !== f ? c += l.move(f + "]") : i === "shortcut" ? c = c.slice(0, -1) : c += l.move("]"), c;
}
function O8t() {
  return "!";
}
Jze.peek = A8t;
function Jze(e, t, n) {
  let r = e.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const s = n.unsafe[o], l = n.compilePattern(s);
    let c;
    if (s.atBreak)
      for (; c = l.exec(r); ) {
        let a = c.index;
        r.charCodeAt(a) === 10 && r.charCodeAt(a - 1) === 13 && a--, r = r.slice(0, a) + " " + r.slice(c.index + 1);
      }
  }
  return i + r + i;
}
function A8t() {
  return "`";
}
function eje(e, t) {
  const n = fY(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
tje.peek = w8t;
function tje(e, t, n, r) {
  const i = AY(n), o = i === '"' ? "Quote" : "Apostrophe", s = n.createTracker(r);
  let l, c;
  if (eje(e, n)) {
    const u = n.stack;
    n.stack = [], l = n.enter("autolink");
    let f = s.move("<");
    return f += s.move(
      n.containerPhrasing(e, {
        before: f,
        after: ">",
        ...s.current()
      })
    ), f += s.move(">"), l(), n.stack = u, f;
  }
  l = n.enter("link"), c = n.enter("label");
  let a = s.move("[");
  return a += s.move(
    n.containerPhrasing(e, {
      before: a,
      after: "](",
      ...s.current()
    })
  ), a += s.move("]("), c(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (c = n.enter("destinationLiteral"), a += s.move("<"), a += s.move(
    n.safe(e.url, { before: a, after: ">", ...s.current() })
  ), a += s.move(">")) : (c = n.enter("destinationRaw"), a += s.move(
    n.safe(e.url, {
      before: a,
      after: e.title ? " " : ")",
      ...s.current()
    })
  )), c(), e.title && (c = n.enter(`title${o}`), a += s.move(" " + i), a += s.move(
    n.safe(e.title, {
      before: a,
      after: i,
      ...s.current()
    })
  ), a += s.move(i), c()), a += s.move(")"), l(), a;
}
function w8t(e, t, n) {
  return eje(e, n) ? "<" : "[";
}
nje.peek = x8t;
function nje(e, t, n, r) {
  const i = e.referenceType, o = n.enter("linkReference");
  let s = n.enter("label");
  const l = n.createTracker(r);
  let c = l.move("[");
  const a = n.containerPhrasing(e, {
    before: c,
    after: "]",
    ...l.current()
  });
  c += l.move(a + "]["), s();
  const u = n.stack;
  n.stack = [], s = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: c,
    after: "]",
    ...l.current()
  });
  return s(), n.stack = u, o(), i === "full" || !a || a !== f ? c += l.move(f + "]") : i === "shortcut" ? c = c.slice(0, -1) : c += l.move("]"), c;
}
function x8t() {
  return "[";
}
function wY(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function S8t(e) {
  const t = wY(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function E8t(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function rje(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function T8t(e, t, n, r) {
  const i = n.enter("list"), o = n.bulletCurrent;
  let s = e.ordered ? E8t(n) : wY(n);
  const l = e.ordered ? s === "." ? ")" : "." : S8t(n);
  let c = t && n.bulletLastUsed ? s === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const u = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (s === "*" || s === "-") && // Empty first list item:
      u && (!u.children || !u.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (c = !0), rje(n) === s && u
    ) {
      let f = -1;
      for (; ++f < e.children.length; ) {
        const d = e.children[f];
        if (d && d.type === "listItem" && d.children && d.children[0] && d.children[0].type === "thematicBreak") {
          c = !0;
          break;
        }
      }
    }
  }
  c && (s = l), n.bulletCurrent = s;
  const a = n.containerFlow(e, r);
  return n.bulletLastUsed = s, n.bulletCurrent = o, i(), a;
}
function k8t(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function C8t(e, t, n, r) {
  const i = k8t(n);
  let o = n.bulletCurrent || wY(n);
  t && t.type === "list" && t.ordered && (o = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + o);
  let s = o.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (s = Math.ceil(s / 4) * 4);
  const l = n.createTracker(r);
  l.move(o + " ".repeat(s - o.length)), l.shift(s);
  const c = n.enter("listItem"), a = n.indentLines(
    n.containerFlow(e, l.current()),
    u
  );
  return c(), a;
  function u(f, d, p) {
    return d ? (p ? "" : " ".repeat(s)) + f : (p ? o : o + " ".repeat(s - o.length)) + f;
  }
}
function N8t(e, t, n, r) {
  const i = n.enter("paragraph"), o = n.enter("phrasing"), s = n.containerPhrasing(e, r);
  return o(), i(), s;
}
const P8t = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  a3([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function I8t(e, t, n, r) {
  return (e.children.some(function(s) {
    return P8t(s);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function R8t(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
ije.peek = M8t;
function ije(e, t, n, r) {
  const i = R8t(n), o = n.enter("strong"), s = n.createTracker(r), l = s.move(i + i);
  let c = s.move(
    n.containerPhrasing(e, {
      after: i,
      before: l,
      ...s.current()
    })
  );
  const a = c.charCodeAt(0), u = H_(
    r.before.charCodeAt(r.before.length - 1),
    a,
    i
  );
  u.inside && (c = Ck(a) + c.slice(1));
  const f = c.charCodeAt(c.length - 1), d = H_(r.after.charCodeAt(0), f, i);
  d.inside && (c = c.slice(0, -1) + Ck(f));
  const p = s.move(i + i);
  return o(), n.attentionEncodeSurroundingInfo = {
    after: d.outside,
    before: u.outside
  }, l + c + p;
}
function M8t(e, t, n) {
  return n.options.strong || "*";
}
function D8t(e, t, n, r) {
  return n.safe(e.value, r);
}
function _8t(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function L8t(e, t, n) {
  const r = (rje(n) + (n.options.ruleSpaces ? " " : "")).repeat(_8t(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const oje = {
  blockquote: o8t,
  break: mfe,
  code: d8t,
  definition: p8t,
  emphasis: $ze,
  hardBreak: mfe,
  heading: y8t,
  html: Kze,
  image: Gze,
  imageReference: Yze,
  inlineCode: Jze,
  link: tje,
  linkReference: nje,
  list: T8t,
  listItem: C8t,
  paragraph: N8t,
  root: I8t,
  strong: ije,
  text: D8t,
  thematicBreak: L8t
};
function z8t() {
  return {
    enter: {
      table: j8t,
      tableData: gfe,
      tableHeader: gfe,
      tableRow: U8t
    },
    exit: {
      codeText: V8t,
      table: F8t,
      tableData: g4,
      tableHeader: g4,
      tableRow: g4
    }
  };
}
function j8t(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function F8t(e) {
  this.exit(e), this.data.inTable = void 0;
}
function U8t(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function g4(e) {
  this.exit(e);
}
function gfe(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function V8t(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, q8t));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function q8t(e, t) {
  return t === "|" ? t : e;
}
function B8t(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: d,
      table: s,
      tableCell: c,
      tableRow: l
    }
  };
  function s(p, h, m, v) {
    return a(u(p, m, v), p.align);
  }
  function l(p, h, m, v) {
    const b = f(p, m, v), A = a([b]);
    return A.slice(0, A.indexOf(`
`));
  }
  function c(p, h, m, v) {
    const b = m.enter("tableCell"), A = m.enter("phrasing"), w = m.containerPhrasing(p, {
      ...v,
      before: o,
      after: o
    });
    return A(), b(), w;
  }
  function a(p, h) {
    return r8t(p, {
      align: h,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function u(p, h, m) {
    const v = p.children;
    let b = -1;
    const A = [], w = h.enter("table");
    for (; ++b < v.length; )
      A[b] = f(v[b], h, m);
    return w(), A;
  }
  function f(p, h, m) {
    const v = p.children;
    let b = -1;
    const A = [], w = h.enter("tableRow");
    for (; ++b < v.length; )
      A[b] = c(v[b], p, h, m);
    return w(), A;
  }
  function d(p, h, m) {
    let v = oje.inlineCode(p, h, m);
    return m.stack.includes("tableCell") && (v = v.replace(/\|/g, "\\$&")), v;
  }
}
function X8t() {
  return {
    exit: {
      taskListCheckValueChecked: yfe,
      taskListCheckValueUnchecked: yfe,
      paragraph: Z8t
    }
  };
}
function W8t() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: H8t }
  };
}
function yfe(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function Z8t(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let o = -1, s;
      for (; ++o < i.length; ) {
        const l = i[o];
        if (l.type === "paragraph") {
          s = l;
          break;
        }
      }
      s === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function H8t(e, t, n, r) {
  const i = e.children[0], o = typeof e.checked == "boolean" && i && i.type === "paragraph", s = "[" + (e.checked ? "x" : " ") + "] ", l = n.createTracker(r);
  o && l.move(s);
  let c = oje.listItem(e, t, n, {
    ...r,
    ...l.current()
  });
  return o && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, a)), c;
  function a(u) {
    return u + s;
  }
}
function Q8t() {
  return [
    T9t(),
    H9t(),
    G9t(),
    z8t(),
    X8t()
  ];
}
function $8t(e) {
  return {
    extensions: [
      k9t(),
      Q9t(e),
      Y9t(),
      B8t(e),
      W8t()
    ]
  };
}
const K8t = {
  tokenize: n7t,
  partial: !0
}, sje = {
  tokenize: r7t,
  partial: !0
}, aje = {
  tokenize: i7t,
  partial: !0
}, lje = {
  tokenize: o7t,
  partial: !0
}, G8t = {
  tokenize: s7t,
  partial: !0
}, cje = {
  name: "wwwAutolink",
  tokenize: e7t,
  previous: dje
}, uje = {
  name: "protocolAutolink",
  tokenize: t7t,
  previous: fje
}, Nh = {
  name: "emailAutolink",
  tokenize: J8t,
  previous: pje
}, Xf = {};
function Y8t() {
  return {
    text: Xf
  };
}
let oy = 48;
for (; oy < 123; )
  Xf[oy] = Nh, oy++, oy === 58 ? oy = 65 : oy === 91 && (oy = 97);
Xf[43] = Nh;
Xf[45] = Nh;
Xf[46] = Nh;
Xf[95] = Nh;
Xf[72] = [Nh, uje];
Xf[104] = [Nh, uje];
Xf[87] = [Nh, cje];
Xf[119] = [Nh, cje];
function J8t(e, t, n) {
  const r = this;
  let i, o;
  return s;
  function s(f) {
    return !_8(f) || !pje.call(r, r.previous) || xY(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(f));
  }
  function l(f) {
    return _8(f) ? (e.consume(f), l) : f === 64 ? (e.consume(f), c) : n(f);
  }
  function c(f) {
    return f === 46 ? e.check(G8t, u, a)(f) : f === 45 || f === 95 || Gs(f) ? (o = !0, e.consume(f), c) : u(f);
  }
  function a(f) {
    return e.consume(f), i = !0, c;
  }
  function u(f) {
    return o && i && xa(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function e7t(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s !== 87 && s !== 119 || !dje.call(r, r.previous) || xY(r.events) ? n(s) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(K8t, e.attempt(sje, e.attempt(aje, o), n), n)(s));
  }
  function o(s) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(s);
  }
}
function t7t(e, t, n) {
  const r = this;
  let i = "", o = !1;
  return s;
  function s(f) {
    return (f === 72 || f === 104) && fje.call(r, r.previous) && !xY(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(f), e.consume(f), l) : n(f);
  }
  function l(f) {
    if (xa(f) && i.length < 5)
      return i += String.fromCodePoint(f), e.consume(f), l;
    if (f === 58) {
      const d = i.toLowerCase();
      if (d === "http" || d === "https")
        return e.consume(f), c;
    }
    return n(f);
  }
  function c(f) {
    return f === 47 ? (e.consume(f), o ? a : (o = !0, c)) : n(f);
  }
  function a(f) {
    return f === null || X_(f) || Qr(f) || Jv(f) || i3(f) ? n(f) : e.attempt(sje, e.attempt(aje, u), n)(f);
  }
  function u(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function n7t(e, t, n) {
  let r = 0;
  return i;
  function i(s) {
    return (s === 87 || s === 119) && r < 3 ? (r++, e.consume(s), i) : s === 46 && r === 3 ? (e.consume(s), o) : n(s);
  }
  function o(s) {
    return s === null ? n(s) : t(s);
  }
}
function r7t(e, t, n) {
  let r, i, o;
  return s;
  function s(a) {
    return a === 46 || a === 95 ? e.check(lje, c, l)(a) : a === null || Qr(a) || Jv(a) || a !== 45 && i3(a) ? c(a) : (o = !0, e.consume(a), s);
  }
  function l(a) {
    return a === 95 ? r = !0 : (i = r, r = void 0), e.consume(a), s;
  }
  function c(a) {
    return i || r || !o ? n(a) : t(a);
  }
}
function i7t(e, t) {
  let n = 0, r = 0;
  return i;
  function i(s) {
    return s === 40 ? (n++, e.consume(s), i) : s === 41 && r < n ? o(s) : s === 33 || s === 34 || s === 38 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 60 || s === 63 || s === 93 || s === 95 || s === 126 ? e.check(lje, t, o)(s) : s === null || Qr(s) || Jv(s) ? t(s) : (e.consume(s), i);
  }
  function o(s) {
    return s === 41 && r++, e.consume(s), i;
  }
}
function o7t(e, t, n) {
  return r;
  function r(l) {
    return l === 33 || l === 34 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 63 || l === 95 || l === 126 ? (e.consume(l), r) : l === 38 ? (e.consume(l), o) : l === 93 ? (e.consume(l), i) : (
      // `<` is an end.
      l === 60 || // So is whitespace.
      l === null || Qr(l) || Jv(l) ? t(l) : n(l)
    );
  }
  function i(l) {
    return l === null || l === 40 || l === 91 || Qr(l) || Jv(l) ? t(l) : r(l);
  }
  function o(l) {
    return xa(l) ? s(l) : n(l);
  }
  function s(l) {
    return l === 59 ? (e.consume(l), r) : xa(l) ? (e.consume(l), s) : n(l);
  }
}
function s7t(e, t, n) {
  return r;
  function r(o) {
    return e.consume(o), i;
  }
  function i(o) {
    return Gs(o) ? n(o) : t(o);
  }
}
function dje(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Qr(e);
}
function fje(e) {
  return !xa(e);
}
function pje(e) {
  return !(e === 47 || _8(e));
}
function _8(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Gs(e);
}
function xY(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const a7t = {
  tokenize: m7t,
  partial: !0
};
function l7t() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: f7t,
        continuation: {
          tokenize: p7t
        },
        exit: h7t
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: d7t
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: c7t,
        resolveTo: u7t
      }
    }
  };
}
function c7t(e, t, n) {
  const r = this;
  let i = r.events.length;
  const o = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let s;
  for (; i--; ) {
    const c = r.events[i][1];
    if (c.type === "labelImage") {
      s = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return l;
  function l(c) {
    if (!s || !s._balanced)
      return n(c);
    const a = Hu(r.sliceSerialize({
      start: s.end,
      end: r.now()
    }));
    return a.codePointAt(0) !== 94 || !o.includes(a.slice(1)) ? n(c) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), t(c));
  }
}
function u7t(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, s = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, l = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", o, t],
    ["enter", s, t],
    ["exit", s, t],
    ["exit", o, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...l), e;
}
function d7t(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o = 0, s;
  return l;
  function l(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", a);
  }
  function a(f) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      f === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      f === null || f === 91 || Qr(f)
    )
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const d = e.exit("gfmFootnoteCallString");
      return i.includes(Hu(r.sliceSerialize(d))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return Qr(f) || (s = !0), o++, e.consume(f), f === 92 ? u : a;
  }
  function u(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), o++, a) : a(f);
  }
}
function f7t(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o, s = 0, l;
  return c;
  function c(h) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(h), e.exit("gfmFootnoteDefinitionLabelMarker"), a;
  }
  function a(h) {
    return h === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(h), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", u) : n(h);
  }
  function u(h) {
    if (
      // Too long.
      s > 999 || // Closing brace with nothing.
      h === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      h === null || h === 91 || Qr(h)
    )
      return n(h);
    if (h === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteDefinitionLabelString");
      return o = Hu(r.sliceSerialize(m)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(h), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), d;
    }
    return Qr(h) || (l = !0), s++, e.consume(h), h === 92 ? f : u;
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), s++, u) : u(h);
  }
  function d(h) {
    return h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), i.includes(o) || i.push(o), br(e, p, "gfmFootnoteDefinitionWhitespace")) : n(h);
  }
  function p(h) {
    return t(h);
  }
}
function p7t(e, t, n) {
  return e.check(LN, t, e.attempt(a7t, t, n));
}
function h7t(e) {
  e.exit("gfmFootnoteDefinition");
}
function m7t(e, t, n) {
  const r = this;
  return br(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "gfmFootnoteDefinitionIndent" && s[2].sliceSerialize(s[1], !0).length === 4 ? t(o) : n(o);
  }
}
function g7t(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(s, l) {
    let c = -1;
    for (; ++c < s.length; )
      if (s[c][0] === "enter" && s[c][1].type === "strikethroughSequenceTemporary" && s[c][1]._close) {
        let a = c;
        for (; a--; )
          if (s[a][0] === "exit" && s[a][1].type === "strikethroughSequenceTemporary" && s[a][1]._open && // If the sizes are the same:
          s[c][1].end.offset - s[c][1].start.offset === s[a][1].end.offset - s[a][1].start.offset) {
            s[c][1].type = "strikethroughSequence", s[a][1].type = "strikethroughSequence";
            const u = {
              type: "strikethrough",
              start: Object.assign({}, s[a][1].start),
              end: Object.assign({}, s[c][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, s[a][1].end),
              end: Object.assign({}, s[c][1].start)
            }, d = [["enter", u, l], ["enter", s[a][1], l], ["exit", s[a][1], l], ["enter", f, l]], p = l.parser.constructs.insideSpan.null;
            p && sc(d, d.length, 0, o3(p, s.slice(a + 1, c), l)), sc(d, d.length, 0, [["exit", f, l], ["enter", s[c][1], l], ["exit", s[c][1], l], ["exit", u, l]]), sc(s, a - 1, c - a + 3, d), c = a + d.length - 2;
            break;
          }
      }
    for (c = -1; ++c < s.length; )
      s[c][1].type === "strikethroughSequenceTemporary" && (s[c][1].type = "data");
    return s;
  }
  function o(s, l, c) {
    const a = this.previous, u = this.events;
    let f = 0;
    return d;
    function d(h) {
      return a === 126 && u[u.length - 1][1].type !== "characterEscape" ? c(h) : (s.enter("strikethroughSequenceTemporary"), p(h));
    }
    function p(h) {
      const m = Nw(a);
      if (h === 126)
        return f > 1 ? c(h) : (s.consume(h), f++, p);
      if (f < 2 && !n) return c(h);
      const v = s.exit("strikethroughSequenceTemporary"), b = Nw(h);
      return v._open = !b || b === 2 && !!m, v._close = !m || m === 2 && !!b, l(h);
    }
  }
}
class y7t {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    v7t(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(o, s) {
      return o[0] - s[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let i = r.pop();
    for (; i; ) {
      for (const o of i)
        t.push(o);
      i = r.pop();
    }
    this.map.length = 0;
  }
}
function v7t(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function b7t(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function O7t() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: A7t,
        resolveAll: w7t
      }
    }
  };
}
function A7t(e, t, n) {
  const r = this;
  let i = 0, o = 0, s;
  return l;
  function l(R) {
    let j = r.events.length - 1;
    for (; j > -1; ) {
      const _ = r.events[j][1].type;
      if (_ === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      _ === "linePrefix") j--;
      else break;
    }
    const F = j > -1 ? r.events[j][1].type : null, L = F === "tableHead" || F === "tableRow" ? S : c;
    return L === S && r.parser.lazy[r.now().line] ? n(R) : L(R);
  }
  function c(R) {
    return e.enter("tableHead"), e.enter("tableRow"), a(R);
  }
  function a(R) {
    return R === 124 || (s = !0, o += 1), u(R);
  }
  function u(R) {
    return R === null ? n(R) : gn(R) ? o > 1 ? (o = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(R), e.exit("lineEnding"), p) : n(R) : tr(R) ? br(e, u, "whitespace")(R) : (o += 1, s && (s = !1, i += 1), R === 124 ? (e.enter("tableCellDivider"), e.consume(R), e.exit("tableCellDivider"), s = !0, u) : (e.enter("data"), f(R)));
  }
  function f(R) {
    return R === null || R === 124 || Qr(R) ? (e.exit("data"), u(R)) : (e.consume(R), R === 92 ? d : f);
  }
  function d(R) {
    return R === 92 || R === 124 ? (e.consume(R), f) : f(R);
  }
  function p(R) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(R) : (e.enter("tableDelimiterRow"), s = !1, tr(R) ? br(e, h, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(R) : h(R));
  }
  function h(R) {
    return R === 45 || R === 58 ? v(R) : R === 124 ? (s = !0, e.enter("tableCellDivider"), e.consume(R), e.exit("tableCellDivider"), m) : x(R);
  }
  function m(R) {
    return tr(R) ? br(e, v, "whitespace")(R) : v(R);
  }
  function v(R) {
    return R === 58 ? (o += 1, s = !0, e.enter("tableDelimiterMarker"), e.consume(R), e.exit("tableDelimiterMarker"), b) : R === 45 ? (o += 1, b(R)) : R === null || gn(R) ? O(R) : x(R);
  }
  function b(R) {
    return R === 45 ? (e.enter("tableDelimiterFiller"), A(R)) : x(R);
  }
  function A(R) {
    return R === 45 ? (e.consume(R), A) : R === 58 ? (s = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(R), e.exit("tableDelimiterMarker"), w) : (e.exit("tableDelimiterFiller"), w(R));
  }
  function w(R) {
    return tr(R) ? br(e, O, "whitespace")(R) : O(R);
  }
  function O(R) {
    return R === 124 ? h(R) : R === null || gn(R) ? !s || i !== o ? x(R) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(R)) : x(R);
  }
  function x(R) {
    return n(R);
  }
  function S(R) {
    return e.enter("tableRow"), E(R);
  }
  function E(R) {
    return R === 124 ? (e.enter("tableCellDivider"), e.consume(R), e.exit("tableCellDivider"), E) : R === null || gn(R) ? (e.exit("tableRow"), t(R)) : tr(R) ? br(e, E, "whitespace")(R) : (e.enter("data"), k(R));
  }
  function k(R) {
    return R === null || R === 124 || Qr(R) ? (e.exit("data"), E(R)) : (e.consume(R), R === 92 ? T : k);
  }
  function T(R) {
    return R === 92 || R === 124 ? (e.consume(R), k) : k(R);
  }
}
function w7t(e, t) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], s = [0, 0, 0, 0], l = !1, c = 0, a, u, f;
  const d = new y7t();
  for (; ++n < e.length; ) {
    const p = e[n], h = p[1];
    p[0] === "enter" ? h.type === "tableHead" ? (l = !1, c !== 0 && (vfe(d, t, c, a, u), u = void 0, c = 0), a = {
      type: "table",
      start: Object.assign({}, h.start),
      // Note: correct end is set later.
      end: Object.assign({}, h.end)
    }, d.add(n, 0, [["enter", a, t]])) : h.type === "tableRow" || h.type === "tableDelimiterRow" ? (r = !0, f = void 0, o = [0, 0, 0, 0], s = [0, n + 1, 0, 0], l && (l = !1, u = {
      type: "tableBody",
      start: Object.assign({}, h.start),
      // Note: correct end is set later.
      end: Object.assign({}, h.end)
    }, d.add(n, 0, [["enter", u, t]])), i = h.type === "tableDelimiterRow" ? 2 : u ? 3 : 1) : i && (h.type === "data" || h.type === "tableDelimiterMarker" || h.type === "tableDelimiterFiller") ? (r = !1, s[2] === 0 && (o[1] !== 0 && (s[0] = s[1], f = KI(d, t, o, i, void 0, f), o = [0, 0, 0, 0]), s[2] = n)) : h.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (s[0] = s[1], f = KI(d, t, o, i, void 0, f)), o = s, s = [o[1], n, 0, 0])) : h.type === "tableHead" ? (l = !0, c = n) : h.type === "tableRow" || h.type === "tableDelimiterRow" ? (c = n, o[1] !== 0 ? (s[0] = s[1], f = KI(d, t, o, i, n, f)) : s[1] !== 0 && (f = KI(d, t, s, i, n, f)), i = 0) : i && (h.type === "data" || h.type === "tableDelimiterMarker" || h.type === "tableDelimiterFiller") && (s[3] = n);
  }
  for (c !== 0 && vfe(d, t, c, a, u), d.consume(t.events), n = -1; ++n < t.events.length; ) {
    const p = t.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = b7t(t.events, n));
  }
  return e;
}
function KI(e, t, n, r, i, o) {
  const s = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", l = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, lO(t.events, n[0])), e.add(n[0], 0, [["exit", o, t]]));
  const c = lO(t.events, n[1]);
  if (o = {
    type: s,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, e.add(n[1], 0, [["enter", o, t]]), n[2] !== 0) {
    const a = lO(t.events, n[2]), u = lO(t.events, n[3]), f = {
      type: l,
      start: Object.assign({}, a),
      end: Object.assign({}, u)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const d = t.events[n[2]], p = t.events[n[3]];
      if (d[1].end = Object.assign({}, p[1].end), d[1].type = "chunkText", d[1].contentType = "text", n[3] > n[2] + 1) {
        const h = n[2] + 1, m = n[3] - n[2] - 1;
        e.add(h, m, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, lO(t.events, i)), e.add(i, 0, [["exit", o, t]]), o = void 0), o;
}
function vfe(e, t, n, r, i) {
  const o = [], s = lO(t.events, n);
  i && (i.end = Object.assign({}, s), o.push(["exit", i, t])), r.end = Object.assign({}, s), o.push(["exit", r, t]), e.add(n + 1, 0, o);
}
function lO(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const x7t = {
  name: "tasklistCheck",
  tokenize: E7t
};
function S7t() {
  return {
    text: {
      91: x7t
    }
  };
}
function E7t(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(c) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), o)
    );
  }
  function o(c) {
    return Qr(c) ? (e.enter("taskListCheckValueUnchecked"), e.consume(c), e.exit("taskListCheckValueUnchecked"), s) : c === 88 || c === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(c), e.exit("taskListCheckValueChecked"), s) : n(c);
  }
  function s(c) {
    return c === 93 ? (e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), l) : n(c);
  }
  function l(c) {
    return gn(c) ? t(c) : tr(c) ? e.check({
      tokenize: T7t
    }, t, n)(c) : n(c);
  }
}
function T7t(e, t, n) {
  return br(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function k7t(e) {
  return wze([
    Y8t(),
    l7t(),
    g7t(e),
    O7t(),
    S7t()
  ]);
}
const C7t = {};
function hje(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || C7t, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), o = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), s = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(k7t(n)), o.push(Q8t()), s.push($8t(n));
}
const SY = Fo(
  ({
    textToCopy: e,
    className: t,
    tooltipSide: n,
    withoutTooltip: r = !1,
    variant: i = "outline",
    ...o
  }, s) => {
    const [l, c] = He(!1), { mutate: a } = dr({
      mutationFn: async () => {
        await navigator.clipboard.writeText(e), c(!0), setTimeout(() => c(!1), 1500);
      },
      onError: () => {
        vr.error(Z("Failed to copy to clipboard"), {
          duration: 3e3
        });
      }
    });
    return r ? /* @__PURE__ */ y(
      Qe,
      {
        ref: s,
        variant: i,
        size: "icon",
        type: "button",
        className: t,
        onClick: () => a(),
        ...o,
        children: l ? /* @__PURE__ */ y(Af, { className: "h-4 w-4" }) : /* @__PURE__ */ y(Cv, { className: "h-4 w-4" })
      }
    ) : /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
        Qe,
        {
          ref: s,
          variant: i,
          size: "icon",
          type: "button",
          className: t,
          onClick: () => a(),
          ...o,
          children: l ? /* @__PURE__ */ y(Af, { className: "h-4 w-4" }) : /* @__PURE__ */ y(Cv, { className: "h-4 w-4" })
        }
      ) }),
      /* @__PURE__ */ y(An, { side: n, children: Z("Copy") })
    ] });
  }
);
SY.displayName = "CopyButton";
const mje = ie.memo(
  ({ content: e, role: t }) => {
    const { theme: n } = Jw(), r = [
      n === "dark" ? L_ : __,
      $n.readOnly.of(!0),
      kt.editable.of(!1),
      m2e({ jsx: !1, typescript: !0 })
    ];
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        Bze,
        {
          remarkPlugins: [hje],
          className: "bg-inherit",
          components: {
            code({ node: i, inline: o, className: s, children: l, ...c }) {
              if (t === "user")
                return /* @__PURE__ */ y("div", { className: "font-mono text-sm", children: l });
              const a = /language-(\w+)/.exec(s || "");
              return !o && a && a[1] ? /* @__PURE__ */ V(
                "div",
                {
                  className: Se(
                    "relative border rounded-md p-4 pt-12",
                    n === "dark" ? "bg-[#0E1117]" : "bg-background"
                  ),
                  children: [
                    /* @__PURE__ */ y(
                      r3,
                      {
                        value: String(l).trim(),
                        className: "border-none",
                        width: "100%",
                        minWidth: "100%",
                        maxWidth: "100%",
                        minHeight: "50px",
                        basicSetup: {
                          syntaxHighlighting: !0,
                          foldGutter: !1,
                          lineNumbers: !1,
                          searchKeymap: !0,
                          lintKeymap: !0,
                          autocompletion: !1,
                          highlightActiveLine: !1,
                          highlightActiveLineGutter: !1,
                          highlightSpecialChars: !1,
                          indentOnInput: !1,
                          bracketMatching: !1,
                          closeBrackets: !1
                        },
                        lang: a[1],
                        theme: n === "dark" ? L_ : __,
                        readOnly: !0,
                        extensions: r
                      }
                    ),
                    /* @__PURE__ */ y("div", { className: "absolute top-4 left-5 text-xs text-gray-500", children: /* @__PURE__ */ V("div", { className: "flex items-center gap-1", children: [
                      /* @__PURE__ */ y(txe, { className: "size-3" }),
                      /* @__PURE__ */ y("span", { children: a[1] })
                    ] }) }),
                    /* @__PURE__ */ y(
                      N7t,
                      {
                        textToCopy: String(l).trim(),
                        className: "absolute top-2 right-2 text-xs text-gray-500"
                      }
                    )
                  ]
                }
              ) : /* @__PURE__ */ y(
                "code",
                {
                  className: Se(
                    s,
                    "bg-gray-200 px-[6px] py-[2px] rounded-xs font-mono text-sm"
                  ),
                  ...c,
                  children: String(l).trim()
                }
              );
            }
          },
          children: e
        }
      ),
      t === "bot" && /* @__PURE__ */ y(
        SY,
        {
          textToCopy: e,
          tooltipSide: "bottom",
          className: "size-6 p-1 mt-2"
        }
      )
    ] });
  },
  (e, t) => e.content === t.content && e.role === t.role
);
mje.displayName = "TextMessage";
const N7t = ({
  textToCopy: e,
  className: t
}) => {
  const [n, r] = ie.useState(!1);
  return /* @__PURE__ */ y("div", { className: t, children: /* @__PURE__ */ V(
    Qe,
    {
      variant: "ghost",
      className: "gap-2",
      size: "xs",
      onClick: () => {
        r(!0), navigator.clipboard.writeText(e), setTimeout(() => r(!1), 1500);
      },
      children: [
        /* @__PURE__ */ y(Cv, { className: "size-4" }),
        /* @__PURE__ */ y("span", { className: "text-xs", children: n ? "Copied!" : "Copy Code" })
      ]
    }
  ) });
}, P7t = ({
  textContent: e,
  role: t,
  attachments: n,
  setSelectedImage: r
}) => /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
  e && /* @__PURE__ */ y(mje, { content: e, role: t }),
  n && n.length > 0 && /* @__PURE__ */ y("div", { className: "flex flex-col gap-2 mt-2", children: n.map((i, o) => {
    var s;
    if ("url" in i && "mimeType" in i)
      return ((s = i.mimeType) == null ? void 0 : s.startsWith("image/")) ? /* @__PURE__ */ y(
        F2t,
        {
          content: i.url,
          setSelectedImage: r
        },
        o
      ) : /* @__PURE__ */ y(
        z2t,
        {
          content: i.url,
          mimeType: i.mimeType,
          fileName: i.fileName,
          role: t
        },
        o
      );
  }) })
] }), I7t = (e, t, n) => {
  switch (n.code) {
    case Ni.NO_CHAT_RESPONSE:
      return e ? /* @__PURE__ */ V("span", { children: [
        "No response from the chatbot. Ensure that",
        " ",
        /* @__PURE__ */ y("strong", { children: "Respond on UI" }),
        " is in",
        " ",
        /* @__PURE__ */ y(
          "a",
          {
            href: `/projects/${e}/flows/${t}`,
            className: "text-primary underline",
            target: "_blank",
            rel: "noreferrer",
            children: "your flow"
          }
        ),
        "."
      ] }) : /* @__PURE__ */ y("span", { children: "The chatbot is not responding. It seems there might be an issue with how this chat was set up. Please contact the person who shared this chat link with you for assistance." });
    case Ni.FLOW_NOT_FOUND:
      return /* @__PURE__ */ y("span", { children: "The chat flow you are trying to access no longer exists." });
    case Ni.VALIDATION:
      return /* @__PURE__ */ y("span", { children: `Validation error: ${n.params.message}` });
    default:
      return /* @__PURE__ */ y("span", { children: "Something went wrong. Please try again." });
  }
}, gje = ({
  chatUI: e,
  flowId: t,
  sendingError: n,
  sendMessage: r
}) => /* @__PURE__ */ V(m_, { variant: "received", className: "pb-8", children: [
  /* @__PURE__ */ V("div", { className: "relative", children: [
    /* @__PURE__ */ y(
      S9,
      {
        src: e == null ? void 0 : e.platformLogoUrl,
        fallback: /* @__PURE__ */ y(hB, { className: "size-5" })
      }
    ),
    /* @__PURE__ */ y("div", { className: "absolute -bottom-[2px] -right-[2px]", children: /* @__PURE__ */ y(hz, { className: "size-4 text-destructive", strokeWidth: 3 }) })
  ] }),
  /* @__PURE__ */ y(g_, { className: "text-destructive", children: I7t(e == null ? void 0 : e.projectId, t, n) }),
  /* @__PURE__ */ y("div", { className: "flex gap-1", children: /* @__PURE__ */ y(
    L2t,
    {
      variant: "outline",
      className: "size-5 mt-2",
      icon: /* @__PURE__ */ y(Xot, { className: "size-3" }),
      onClick: () => {
        r({ isRetrying: !0 });
      }
    }
  ) })
] });
gje.displayName = "ErrorBubble";
g.Array(
  g.Object({
    role: g.Union([g.Literal("user"), g.Literal("bot")]),
    textContent: g.Optional(g.String()),
    files: g.Optional(g.Array(HM))
  })
);
const yje = ie.forwardRef(
  ({
    className: e,
    children: t,
    messagesRef: n,
    messages: r,
    chatUI: i,
    sendingError: o,
    isSending: s,
    flowId: l,
    sendMessage: c,
    setSelectedImage: a,
    ...u
  }, f) => r && r.length > 0 ? /* @__PURE__ */ y("div", { className: "h-full w-full max-w-3xl flex items-center justify-center overflow-y-auto", children: /* @__PURE__ */ V(
    "div",
    {
      className: Se("flex flex-col w-full h-full p-4 gap-2", e),
      ref: n || f,
      ...u,
      children: [
        r.map((d, p) => {
          const h = p === r.length - 1;
          return /* @__PURE__ */ V(
            m_,
            {
              id: h ? "last-message" : void 0,
              variant: d.role === "user" ? "sent" : "received",
              className: Se(
                "flex items-start",
                h ? "pb-8" : ""
              ),
              children: [
                d.role === "bot" && /* @__PURE__ */ y(
                  S9,
                  {
                    src: "",
                    fallback: /* @__PURE__ */ y(hB, { className: "size-5" })
                  }
                ),
                /* @__PURE__ */ y(
                  g_,
                  {
                    className: Se(
                      "flex flex-col gap-2",
                      d.role === "bot" ? "w-full" : ""
                    ),
                    children: /* @__PURE__ */ y(
                      P7t,
                      {
                        textContent: d.textContent,
                        attachments: d.files,
                        role: d.role,
                        setSelectedImage: a || (() => {
                        })
                      }
                    )
                  }
                )
              ]
            },
            p
          );
        }),
        o && !s && l && c && /* @__PURE__ */ y(
          gje,
          {
            chatUI: i,
            flowId: l,
            sendingError: o,
            sendMessage: (d) => {
              De(d.message) || c({
                isRetrying: !1,
                message: d.message
              });
            }
          }
        ),
        s && /* @__PURE__ */ V(m_, { variant: "received", className: "pb-8", children: [
          /* @__PURE__ */ y(
            S9,
            {
              src: "",
              fallback: /* @__PURE__ */ y(hB, { className: "size-5" })
            }
          ),
          /* @__PURE__ */ y(g_, { isLoading: !0 })
        ] })
      ]
    }
  ) }) : /* @__PURE__ */ y("div", { className: "h-full w-full flex items-center justify-center overflow-y-auto", children: /* @__PURE__ */ y(
    "div",
    {
      className: Se("flex flex-col w-full h-full p-4 gap-2", e),
      ref: f,
      ...u,
      children: t
    }
  ) })
);
yje.displayName = "ChatMessageList";
const bfe = {
  getForm: (e, t) => dt.get(`/v1/human-input/form/${e}`, {
    [Vq]: t ?? !1
  }),
  getChatUI: (e, t) => dt.get(`/v1/human-input/chat/${e}`, {
    [Vq]: t ?? !1
  }),
  submitForm: async (e, t, n) => {
    const r = await M7t(
      n,
      e
    ), i = Ofe(
      t ? "draft" : "locked",
      e.props.waitForResponse
    );
    return dt.post(
      `/v1/webhooks/${e.id}${i}`,
      r,
      void 0,
      {
        "Content-Type": r instanceof FormData ? "multipart/form-data" : "application/json"
      }
    );
  },
  sendMessage: async ({
    flowId: e,
    chatId: t,
    message: n,
    files: r,
    mode: i
  }) => {
    const o = new FormData();
    o.append("chatId", t), o.append("message", n), r.forEach((l, c) => {
      o.append(`file[${c}]`, l);
    });
    const s = Ofe(i, !0);
    return dt.post(
      `/v1/webhooks/${e}${s}`,
      o,
      void 0,
      {
        "Content-Type": "multipart/form-data"
      }
    );
  }
}, R7t = (e) => new Promise((t, n) => {
  const r = new FileReader();
  r.readAsDataURL(e), r.onloadend = () => {
    r.result ? t(r.result) : n(new Error("Failed to read file"));
  }, r.onerror = () => {
    n(r.error);
  };
});
async function M7t(e, t) {
  const n = zq.gte(t.version, "0.4.1"), r = new FormData(), i = {};
  for (const [o, s] of Object.entries(e))
    n ? r.append(o, s instanceof File ? s : String(s)) : i[o] = s instanceof File ? await R7t(s) : s;
  return n ? r : i;
}
function Ofe(e, t) {
  return e === "test" ? "/test" : e === "draft" ? t ? "/draft/sync" : "/draft" : t ? "/sync" : "";
}
const D7t = ({
  title: e = "Oops! Page Not Found",
  description: t = "The page you're looking for isn't here. Want to try going back home?",
  showHomeButton: n = !0,
  buttonText: r = "Go Home",
  icon: i = YH
}) => /* @__PURE__ */ y("div", { className: "mx-auto max-w-(--breakpoint-xl) px-4 py-8 lg:px-6 lg:py-16 bg-background", children: /* @__PURE__ */ V("div", { className: "mx-auto max-w-(--breakpoint-sm) text-center", children: [
  /* @__PURE__ */ y("div", { className: "mx-auto mb-8 flex justify-center", children: /* @__PURE__ */ y(i, { className: "h-24 w-24" }) }),
  /* @__PURE__ */ y("p", { className: "mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl", children: Z(e) }),
  /* @__PURE__ */ y("p", { className: "mb-4 text-lg font-light text-foreground", children: Z(t) }),
  n && /* @__PURE__ */ y(oW, { to: "/", children: /* @__PURE__ */ y(Qe, { size: "lg", variant: "default", children: Z(r) }) })
] }) });
function _7t({
  flowId: e,
  className: t,
  showWelcomeMessage: n = !0,
  mode: r,
  onError: i,
  onSendingMessage: o,
  closeChat: s,
  messages: l = [],
  chatSessionId: c,
  onAddMessage: a,
  onSetSessionId: u
}) {
  const f = Xe(null), d = Xe(null), {
    data: p,
    isLoading: h,
    isError: m
  } = pr({
    queryKey: ["chat", e],
    queryFn: () => bfe.getChatUI(
      e,
      r === Jd.TEST_FLOW || r === Jd.TEST_STEP
    ),
    enabled: !De(e),
    staleTime: 1 / 0,
    retry: !1
  }), v = () => {
    setTimeout(() => {
      const _ = document.getElementById("last-message");
      _ && _.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };
  nt(() => {
    !c && u && u(Fu());
  }, [c, u]);
  const b = Xe(""), A = Xe([]), [w, O] = He(null), [x, S] = He(null), [E, k] = He(!1), T = (p == null ? void 0 : p.props.botName) ?? `${(p == null ? void 0 : p.platformName) ?? "Activepieces"} Bot`, { mutate: R, isPending: j } = dr({
    mutationFn: async ({
      isRetrying: _,
      message: U
    }) => {
      if (!e || !c) return null;
      const z = _ ? b.current : (U == null ? void 0 : U.textContent) || "", C = _ ? A.current : (U == null ? void 0 : U.files) || [];
      b.current = z, A.current = C, !_ && U && a && a({
        role: "user",
        textContent: z,
        files: C.map((D) => ({
          url: URL.createObjectURL(D),
          mimeType: D.type
        }))
      }), v();
      const I = r === Jd.TEST_FLOW, M = r === Jd.TEST_STEP;
      return bfe.sendMessage({
        flowId: e,
        chatId: c,
        message: z,
        files: C,
        mode: I ? "draft" : M ? "test" : "locked"
      });
    },
    onSuccess: (_) => {
      if (r === Jd.TEST_STEP && (s == null || s()), !_) {
        const U = {
          code: Ni.NO_CHAT_RESPONSE,
          params: {}
        };
        O(U), i == null || i(U);
        return;
      }
      if ("type" in _ && a)
        switch (O(null), i == null || i(null), _.type) {
          case QM.FILE: {
            "url" in _.value && a({
              role: "bot",
              files: [
                {
                  url: _.value.url,
                  mimeType: _.value.mimeType
                }
              ]
            });
            break;
          }
          case QM.MARKDOWN: {
            const U = (_.files ?? []).filter(
              (z) => "url" in z && "mimeType" in z
            );
            a({
              role: "bot",
              textContent: _.value,
              files: U.length > 0 ? U : void 0
            });
            break;
          }
        }
      v(), setTimeout(() => {
        d.current && d.current.focus();
      }, 100);
    },
    onError: (_) => {
      var z;
      const U = (z = _.response) == null ? void 0 : z.data;
      O(U), i == null || i(U), v();
    }
  });
  nt(v, [l, j]);
  const F = (_) => {
    o == null || o(_), R({ isRetrying: !1, message: _ });
  };
  if (m)
    return /* @__PURE__ */ y(L7t, {});
  if (h) return /* @__PURE__ */ y(_De, {});
  const L = (_) => {
    k(!!_), S(_);
  };
  return /* @__PURE__ */ V(
    "main",
    {
      className: Se(
        "flex w-full flex-col items-center justify-center pb-6",
        (l.length > 0, "h-screen"),
        t
      ),
      children: [
        l.length > 0 ? /* @__PURE__ */ V(pt, { children: [
          /* @__PURE__ */ y(
            yje,
            {
              messagesRef: f,
              messages: l,
              chatUI: p,
              sendingError: w,
              isSending: j,
              flowId: e,
              sendMessage: R,
              setSelectedImage: L
            }
          ),
          /* @__PURE__ */ y("div", { className: "w-full px-4 max-w-3xl", children: /* @__PURE__ */ y(
            x9,
            {
              ref: d,
              onSendMessage: F,
              disabled: j,
              placeholder: "Type your message here..."
            }
          ) })
        ] }) : /* @__PURE__ */ V(pt, { children: [
          n && /* @__PURE__ */ y(C2t, { chatUI: p, botName: T }),
          /* @__PURE__ */ y("div", { className: "w-full px-4 max-w-3xl absolute bottom-6", children: /* @__PURE__ */ y(
            x9,
            {
              ref: d,
              onSendMessage: F,
              disabled: j,
              placeholder: "Type your message here..."
            }
          ) })
        ] }),
        /* @__PURE__ */ y(
          N2t,
          {
            open: E,
            onOpenChange: (_) => {
              k(_), _ || S(null);
            },
            imageUrl: x
          }
        )
      ]
    }
  );
}
const L7t = () => /* @__PURE__ */ y(
  D7t,
  {
    title: "Hmm... this chat isn't here",
    description: "The chat you're looking for isn't here or maybe hasn't been published by the owner yet"
  }
), z7t = () => {
  const [
    e,
    t,
    n,
    r,
    i,
    o,
    s,
    l
  ] = tn((f) => [
    f.chatSessionMessages,
    f.chatSessionId,
    f.addChatMessage,
    f.flowVersion,
    f.setChatSessionId,
    f.setRun,
    f.chatDrawerOpenSource,
    f.setChatDrawerOpenSource
  ]), c = Zv(), a = Xe(!1), u = () => {
    a.current = !0;
    const f = (d) => {
      d.flowVersionId === r.id && d.environment === eg.TESTING && a.current && (o(d, r), a.current = !1, c.off(
        pi.TEST_FLOW_RUN_STARTED,
        f
      ));
    };
    c.on(pi.TEST_FLOW_RUN_STARTED, f);
  };
  return /* @__PURE__ */ y(
    a2t,
    {
      open: s !== null,
      onOpenChange: () => l(null),
      direction: "right",
      dismissible: !1,
      modal: !1,
      children: /* @__PURE__ */ V(c2t, { className: "w-[500px] overflow-x-hidden", children: [
        /* @__PURE__ */ y(u2t, { children: /* @__PURE__ */ y("div", { className: "p-4", children: /* @__PURE__ */ V("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ y(
            Qe,
            {
              variant: "basic",
              size: "icon",
              className: "text-foreground",
              onClick: () => l(null),
              children: /* @__PURE__ */ y(Jwe, { className: "h-5 w-5" })
            }
          ),
          /* @__PURE__ */ y(d2t, { children: "Chat" })
        ] }) }) }),
        /* @__PURE__ */ y("div", { className: "flex-1 overflow-hidden", children: /* @__PURE__ */ y(
          _7t,
          {
            flowId: r.flowId,
            className: "h-full",
            mode: s,
            showWelcomeMessage: !0,
            onError: () => {
            },
            onSendingMessage: () => {
              s === Jd.TEST_FLOW && u();
            },
            closeChat: () => {
              l(null);
            },
            messages: e,
            chatSessionId: t,
            onAddMessage: n,
            onSetSessionId: i
          }
        ) })
      ] })
    }
  );
}, vje = ({ show: e, position: t = "sticky" }) => e ? /* @__PURE__ */ y(
  "div",
  {
    className: Se("bottom-3 right-5 pointer-events-none z-10000", t, {
      "-mt-[30px]": t === "sticky",
      "mr-5": t === "sticky"
    }),
    children: /* @__PURE__ */ V(
      "div",
      {
        className: Se(
          "justify-end p-1 text-muted-foreground/70 text-sm items-center flex gap-1 transition group ",
          {
            "justify-center": t === "static"
          }
        ),
        children: [
          /* @__PURE__ */ y("div", { className: " text-sm transition", children: "Built with" }),
          /* @__PURE__ */ V("div", { className: "justify-center flex items-center gap-1", children: [
            /* @__PURE__ */ y(
              "svg",
              {
                width: 15,
                height: 15,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                className: "transition fill-muted-foreground/70",
                children: /* @__PURE__ */ y("path", { d: "M6.46013 5.81759C5.30809 4.10962 5.75876 1.79113 7.46672 0.639093C9.17469 -0.512944 11.4932 -0.0622757 12.6452 1.64569L20.4261 13.1813C21.5781 14.8893 21.1274 17.2077 19.4195 18.3598C17.7115 19.5118 15.393 19.0611 14.241 17.3532L10.8676 12.3519C10.4339 11.8054 9.55114 11.8905 9.02108 12.4205C8.58152 12.8601 8.43761 13.9846 8.31301 14.9582C8.29474 15.1009 8.27689 15.2405 8.25858 15.3741C8.19097 16.0114 7.97092 16.6418 7.58762 17.2101C6.33511 19.067 3.81375 19.5565 1.95682 18.304C0.0998936 17.0515 -0.390738 14.5304 0.861776 12.6734C1.51136 11.7104 2.50224 11.1151 3.56472 10.9399L3.56322 10.9384C6.63307 10.4932 7.20222 7.02864 6.64041 6.08487L6.46013 5.81759Z" })
              }
            ),
            /* @__PURE__ */ y("div", { className: "font-semibold", children: "activepieces" })
          ] })
        ]
      }
    )
  }
) : null;
vje.displayName = "ShowPoweredBy";
const {
  createElement: Pw,
  createContext: j7t,
  forwardRef: bje,
  useCallback: _l,
  useContext: Oje,
  useEffect: gv,
  useImperativeHandle: Aje,
  useLayoutEffect: F7t,
  useMemo: U7t,
  useRef: Ja,
  useState: WE
} = N, Afe = N.useId, V7t = F7t, c3 = j7t(null);
c3.displayName = "PanelGroupContext";
const yv = V7t, q7t = typeof Afe == "function" ? Afe : () => null;
let B7t = 0;
function EY(e = null) {
  const t = q7t(), n = Ja(e || t || null);
  return n.current === null && (n.current = "" + B7t++), e ?? n.current;
}
function wje({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: r,
  defaultSize: i,
  forwardedRef: o,
  id: s,
  maxSize: l,
  minSize: c,
  onCollapse: a,
  onExpand: u,
  onResize: f,
  order: d,
  style: p,
  tagName: h = "div",
  ...m
}) {
  const v = Oje(c3);
  if (v === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: b,
    expandPanel: A,
    getPanelSize: w,
    getPanelStyle: O,
    groupId: x,
    isPanelCollapsed: S,
    reevaluatePanelConstraints: E,
    registerPanel: k,
    resizePanel: T,
    unregisterPanel: R
  } = v, j = EY(s), F = Ja({
    callbacks: {
      onCollapse: a,
      onExpand: u,
      onResize: f
    },
    constraints: {
      collapsedSize: n,
      collapsible: r,
      defaultSize: i,
      maxSize: l,
      minSize: c
    },
    id: j,
    idIsFromProps: s !== void 0,
    order: d
  });
  Ja({
    didLogMissingDefaultSizeWarning: !1
  }), yv(() => {
    const {
      callbacks: _,
      constraints: U
    } = F.current, z = {
      ...U
    };
    F.current.id = j, F.current.idIsFromProps = s !== void 0, F.current.order = d, _.onCollapse = a, _.onExpand = u, _.onResize = f, U.collapsedSize = n, U.collapsible = r, U.defaultSize = i, U.maxSize = l, U.minSize = c, (z.collapsedSize !== U.collapsedSize || z.collapsible !== U.collapsible || z.maxSize !== U.maxSize || z.minSize !== U.minSize) && E(F.current, z);
  }), yv(() => {
    const _ = F.current;
    return k(_), () => {
      R(_);
    };
  }, [d, j, k, R]), Aje(o, () => ({
    collapse: () => {
      b(F.current);
    },
    expand: (_) => {
      A(F.current, _);
    },
    getId() {
      return j;
    },
    getSize() {
      return w(F.current);
    },
    isCollapsed() {
      return S(F.current);
    },
    isExpanded() {
      return !S(F.current);
    },
    resize: (_) => {
      T(F.current, _);
    }
  }), [b, A, w, S, j, T]);
  const L = O(F.current, i);
  return Pw(h, {
    ...m,
    children: e,
    className: t,
    id: s,
    style: {
      ...L,
      ...p
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-group-id": x,
    "data-panel-id": j,
    "data-panel-size": parseFloat("" + L.flexGrow).toFixed(1)
  });
}
const xje = bje((e, t) => Pw(wje, {
  ...e,
  forwardedRef: t
}));
wje.displayName = "Panel";
xje.displayName = "forwardRef(Panel)";
let L8 = null, My = null;
function X7t(e, t) {
  if (t) {
    const n = (t & Cje) !== 0, r = (t & Nje) !== 0, i = (t & Pje) !== 0, o = (t & Ije) !== 0;
    if (n)
      return i ? "se-resize" : o ? "ne-resize" : "e-resize";
    if (r)
      return i ? "sw-resize" : o ? "nw-resize" : "w-resize";
    if (i)
      return "s-resize";
    if (o)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function W7t() {
  My !== null && (document.head.removeChild(My), L8 = null, My = null);
}
function y4(e, t) {
  const n = X7t(e, t);
  L8 !== n && (L8 = n, My === null && (My = document.createElement("style"), document.head.appendChild(My)), My.innerHTML = `*{cursor: ${n}!important;}`);
}
function Sje(e) {
  return e.type === "keydown";
}
function Eje(e) {
  return e.type.startsWith("pointer");
}
function Tje(e) {
  return e.type.startsWith("mouse");
}
function u3(e) {
  if (Eje(e)) {
    if (e.isPrimary)
      return {
        x: e.clientX,
        y: e.clientY
      };
  } else if (Tje(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function Z7t() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function H7t(e, t, n) {
  return e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y;
}
function Q7t(e, t) {
  if (e === t) throw new Error("Cannot compare node with itself");
  const n = {
    a: Sfe(e),
    b: Sfe(t)
  };
  let r;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), r = e;
  Kn(r, "Stacking order can only be calculated for elements with a common ancestor");
  const i = {
    a: xfe(wfe(n.a)),
    b: xfe(wfe(n.b))
  };
  if (i.a === i.b) {
    const o = r.childNodes, s = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let l = o.length;
    for (; l--; ) {
      const c = o[l];
      if (c === s.a) return 1;
      if (c === s.b) return -1;
    }
  }
  return Math.sign(i.a - i.b);
}
const $7t = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function K7t(e) {
  var t;
  const n = getComputedStyle((t = kje(e)) !== null && t !== void 0 ? t : e).display;
  return n === "flex" || n === "inline-flex";
}
function G7t(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || K7t(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || $7t.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function wfe(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (Kn(n, "Missing node"), G7t(n)) return n;
  }
  return null;
}
function xfe(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function Sfe(e) {
  const t = [];
  for (; e; )
    t.push(e), e = kje(e);
  return t;
}
function kje(e) {
  const {
    parentNode: t
  } = e;
  return t && t instanceof ShadowRoot ? t.host : t;
}
const Cje = 1, Nje = 2, Pje = 4, Ije = 8, Y7t = Z7t() === "coarse";
let Qu = [], d3 = !1, fm = /* @__PURE__ */ new Map(), f3 = /* @__PURE__ */ new Map();
const Nk = /* @__PURE__ */ new Set();
function J7t(e, t, n, r, i) {
  var o;
  const {
    ownerDocument: s
  } = t, l = {
    direction: n,
    element: t,
    hitAreaMargins: r,
    setResizeHandlerState: i
  }, c = (o = fm.get(s)) !== null && o !== void 0 ? o : 0;
  return fm.set(s, c + 1), Nk.add(l), Q_(), function() {
    var u;
    f3.delete(e), Nk.delete(l);
    const f = (u = fm.get(s)) !== null && u !== void 0 ? u : 1;
    if (fm.set(s, f - 1), Q_(), f === 1 && fm.delete(s), Qu.includes(l)) {
      const d = Qu.indexOf(l);
      d >= 0 && Qu.splice(d, 1), kY();
    }
  };
}
function Efe(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = u3(e);
  d3 = !0, TY({
    target: t,
    x: n,
    y: r
  }), Q_(), Qu.length > 0 && (CY("down", e), e.preventDefault(), e.stopPropagation());
}
function CS(e) {
  const {
    x: t,
    y: n
  } = u3(e);
  if (!d3) {
    const {
      target: r
    } = e;
    TY({
      target: r,
      x: t,
      y: n
    });
  }
  CY("move", e), kY(), Qu.length > 0 && e.preventDefault();
}
function l0(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: r
  } = u3(e);
  f3.clear(), d3 = !1, Qu.length > 0 && e.preventDefault(), CY("up", e), TY({
    target: t,
    x: n,
    y: r
  }), kY(), Q_();
}
function TY({
  target: e,
  x: t,
  y: n
}) {
  Qu.splice(0);
  let r = null;
  e instanceof HTMLElement && (r = e), Nk.forEach((i) => {
    const {
      element: o,
      hitAreaMargins: s
    } = i, l = o.getBoundingClientRect(), {
      bottom: c,
      left: a,
      right: u,
      top: f
    } = l, d = Y7t ? s.coarse : s.fine;
    if (t >= a - d && t <= u + d && n >= f - d && n <= c + d) {
      if (r !== null && o !== r && !o.contains(r) && !r.contains(o) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      Q7t(r, o) > 0) {
        let h = r, m = !1;
        for (; h && !h.contains(o); ) {
          if (H7t(h.getBoundingClientRect(), l)) {
            m = !0;
            break;
          }
          h = h.parentElement;
        }
        if (m)
          return;
      }
      Qu.push(i);
    }
  });
}
function v4(e, t) {
  f3.set(e, t);
}
function kY() {
  let e = !1, t = !1;
  Qu.forEach((r) => {
    const {
      direction: i
    } = r;
    i === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  f3.forEach((r) => {
    n |= r;
  }), e && t ? y4("intersection", n) : e ? y4("horizontal", n) : t ? y4("vertical", n) : W7t();
}
function Q_() {
  fm.forEach((e, t) => {
    const {
      body: n
    } = t;
    n.removeEventListener("contextmenu", l0), n.removeEventListener("pointerdown", Efe), n.removeEventListener("pointerleave", CS), n.removeEventListener("pointermove", CS);
  }), window.removeEventListener("pointerup", l0), window.removeEventListener("pointercancel", l0), Nk.size > 0 && (d3 ? (Qu.length > 0 && fm.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("contextmenu", l0), n.addEventListener("pointerleave", CS), n.addEventListener("pointermove", CS));
  }), window.addEventListener("pointerup", l0), window.addEventListener("pointercancel", l0)) : fm.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("pointerdown", Efe, {
      capture: !0
    }), n.addEventListener("pointermove", CS));
  }));
}
function CY(e, t) {
  Nk.forEach((n) => {
    const {
      setResizeHandlerState: r
    } = n, i = Qu.includes(n);
    r(e, i, t);
  });
}
function Kn(e, t) {
  if (!e)
    throw console.error(t), Error(t);
}
const NY = 10;
function eb(e, t, n = NY) {
  return e.toFixed(n) === t.toFixed(n) ? 0 : e > t ? 1 : -1;
}
function jp(e, t, n = NY) {
  return eb(e, t, n) === 0;
}
function Xl(e, t, n) {
  return eb(e, t, n) === 0;
}
function eWt(e, t, n) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++) {
    const i = e[r], o = t[r];
    if (!Xl(i, o, n))
      return !1;
  }
  return !0;
}
function NO({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const r = e[t];
  Kn(r != null, `Panel constraints not found for index ${t}`);
  let {
    collapsedSize: i = 0,
    collapsible: o,
    maxSize: s = 100,
    minSize: l = 0
  } = r;
  if (eb(n, l) < 0)
    if (o) {
      const c = (i + l) / 2;
      eb(n, c) < 0 ? n = i : n = l;
    } else
      n = l;
  return n = Math.min(s, n), n = parseFloat(n.toFixed(NY)), n;
}
function A1({
  delta: e,
  initialLayout: t,
  panelConstraints: n,
  pivotIndices: r,
  prevLayout: i,
  trigger: o
}) {
  if (Xl(e, 0))
    return t;
  const s = [...t], [l, c] = r;
  Kn(l != null, "Invalid first pivot index"), Kn(c != null, "Invalid second pivot index");
  let a = 0;
  if (o === "keyboard") {
    {
      const f = e < 0 ? c : l, d = n[f];
      Kn(d, `Panel constraints not found for index ${f}`);
      const {
        collapsedSize: p = 0,
        collapsible: h,
        minSize: m = 0
      } = d;
      if (h) {
        const v = t[f];
        if (Kn(v != null, `Previous layout not found for panel index ${f}`), Xl(v, p)) {
          const b = m - v;
          eb(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
    {
      const f = e < 0 ? l : c, d = n[f];
      Kn(d, `No panel constraints found for index ${f}`);
      const {
        collapsedSize: p = 0,
        collapsible: h,
        minSize: m = 0
      } = d;
      if (h) {
        const v = t[f];
        if (Kn(v != null, `Previous layout not found for panel index ${f}`), Xl(v, m)) {
          const b = v - p;
          eb(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
  }
  {
    const f = e < 0 ? 1 : -1;
    let d = e < 0 ? c : l, p = 0;
    for (; ; ) {
      const m = t[d];
      Kn(m != null, `Previous layout not found for panel index ${d}`);
      const b = NO({
        panelConstraints: n,
        panelIndex: d,
        size: 100
      }) - m;
      if (p += b, d += f, d < 0 || d >= n.length)
        break;
    }
    const h = Math.min(Math.abs(e), Math.abs(p));
    e = e < 0 ? 0 - h : h;
  }
  {
    let d = e < 0 ? l : c;
    for (; d >= 0 && d < n.length; ) {
      const p = Math.abs(e) - Math.abs(a), h = t[d];
      Kn(h != null, `Previous layout not found for panel index ${d}`);
      const m = h - p, v = NO({
        panelConstraints: n,
        panelIndex: d,
        size: m
      });
      if (!Xl(h, v) && (a += h - v, s[d] = v, a.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? d-- : d++;
    }
  }
  if (eWt(i, s))
    return i;
  {
    const f = e < 0 ? c : l, d = t[f];
    Kn(d != null, `Previous layout not found for panel index ${f}`);
    const p = d + a, h = NO({
      panelConstraints: n,
      panelIndex: f,
      size: p
    });
    if (s[f] = h, !Xl(h, p)) {
      let m = p - h, b = e < 0 ? c : l;
      for (; b >= 0 && b < n.length; ) {
        const A = s[b];
        Kn(A != null, `Previous layout not found for panel index ${b}`);
        const w = A + m, O = NO({
          panelConstraints: n,
          panelIndex: b,
          size: w
        });
        if (Xl(A, O) || (m -= O - A, s[b] = O), Xl(m, 0))
          break;
        e > 0 ? b-- : b++;
      }
    }
  }
  const u = s.reduce((f, d) => d + f, 0);
  return Xl(u, 100) ? s : i;
}
function tWt({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let r = 0, i = 100, o = 0, s = 0;
  const l = n[0];
  Kn(l != null, "No pivot index found"), t.forEach((f, d) => {
    const {
      constraints: p
    } = f, {
      maxSize: h = 100,
      minSize: m = 0
    } = p;
    d === l ? (r = m, i = h) : (o += m, s += h);
  });
  const c = Math.min(i, 100 - o), a = Math.max(r, 100 - s), u = e[l];
  return {
    valueMax: c,
    valueMin: a,
    valueNow: u
  };
}
function Pk(e, t = document) {
  return Array.from(t.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function Rje(e, t, n = document) {
  const i = Pk(e, n).findIndex((o) => o.getAttribute("data-panel-resize-handle-id") === t);
  return i ?? null;
}
function Mje(e, t, n) {
  const r = Rje(e, t, n);
  return r != null ? [r, r + 1] : [-1, -1];
}
function Dje(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const r = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return r || null;
}
function p3(e, t = document) {
  const n = t.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return n || null;
}
function nWt(e, t, n, r = document) {
  var i, o, s, l;
  const c = p3(t, r), a = Pk(e, r), u = c ? a.indexOf(c) : -1, f = (i = (o = n[u]) === null || o === void 0 ? void 0 : o.id) !== null && i !== void 0 ? i : null, d = (s = (l = n[u + 1]) === null || l === void 0 ? void 0 : l.id) !== null && s !== void 0 ? s : null;
  return [f, d];
}
function rWt({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: r,
  panelDataArray: i,
  panelGroupElement: o,
  setLayout: s
}) {
  Ja({
    didWarnAboutMissingResizeHandle: !1
  }), yv(() => {
    if (!o)
      return;
    const l = Pk(n, o);
    for (let c = 0; c < i.length - 1; c++) {
      const {
        valueMax: a,
        valueMin: u,
        valueNow: f
      } = tWt({
        layout: r,
        panelsArray: i,
        pivotIndices: [c, c + 1]
      }), d = l[c];
      if (d != null) {
        const p = i[c];
        Kn(p, `No panel data found for index "${c}"`), d.setAttribute("aria-controls", p.id), d.setAttribute("aria-valuemax", "" + Math.round(a)), d.setAttribute("aria-valuemin", "" + Math.round(u)), d.setAttribute("aria-valuenow", f != null ? "" + Math.round(f) : "");
      }
    }
    return () => {
      l.forEach((c, a) => {
        c.removeAttribute("aria-controls"), c.removeAttribute("aria-valuemax"), c.removeAttribute("aria-valuemin"), c.removeAttribute("aria-valuenow");
      });
    };
  }, [n, r, i, o]), gv(() => {
    if (!o)
      return;
    const l = t.current;
    Kn(l, "Eager values not found");
    const {
      panelDataArray: c
    } = l, a = Dje(n, o);
    Kn(a != null, `No group found for id "${n}"`);
    const u = Pk(n, o);
    Kn(u, `No resize handles found for group id "${n}"`);
    const f = u.map((d) => {
      const p = d.getAttribute("data-panel-resize-handle-id");
      Kn(p, "Resize handle element has no handle id attribute");
      const [h, m] = nWt(n, p, c, o);
      if (h == null || m == null)
        return () => {
        };
      const v = (b) => {
        if (!b.defaultPrevented)
          switch (b.key) {
            case "Enter": {
              b.preventDefault();
              const A = c.findIndex((w) => w.id === h);
              if (A >= 0) {
                const w = c[A];
                Kn(w, `No panel data found for index ${A}`);
                const O = r[A], {
                  collapsedSize: x = 0,
                  collapsible: S,
                  minSize: E = 0
                } = w.constraints;
                if (O != null && S) {
                  const k = A1({
                    delta: Xl(O, x) ? E - x : x - O,
                    initialLayout: r,
                    panelConstraints: c.map((T) => T.constraints),
                    pivotIndices: Mje(n, p, o),
                    prevLayout: r,
                    trigger: "keyboard"
                  });
                  r !== k && s(k);
                }
              }
              break;
            }
          }
      };
      return d.addEventListener("keydown", v), () => {
        d.removeEventListener("keydown", v);
      };
    });
    return () => {
      f.forEach((d) => d());
    };
  }, [o, e, t, n, r, i, s]);
}
function Tfe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function _je(e, t) {
  const n = e === "horizontal", {
    x: r,
    y: i
  } = u3(t);
  return n ? r : i;
}
function iWt(e, t, n, r, i) {
  const o = n === "horizontal", s = p3(t, i);
  Kn(s, `No resize handle element found for id "${t}"`);
  const l = s.getAttribute("data-panel-group-id");
  Kn(l, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: c
  } = r;
  const a = _je(n, e), u = Dje(l, i);
  Kn(u, `No group element found for id "${l}"`);
  const f = u.getBoundingClientRect(), d = o ? f.width : f.height;
  return (a - c) / d * 100;
}
function oWt(e, t, n, r, i, o) {
  if (Sje(e)) {
    const s = n === "horizontal";
    let l = 0;
    e.shiftKey ? l = 100 : i != null ? l = i : l = 10;
    let c = 0;
    switch (e.key) {
      case "ArrowDown":
        c = s ? 0 : l;
        break;
      case "ArrowLeft":
        c = s ? -l : 0;
        break;
      case "ArrowRight":
        c = s ? l : 0;
        break;
      case "ArrowUp":
        c = s ? 0 : -l;
        break;
      case "End":
        c = 100;
        break;
      case "Home":
        c = -100;
        break;
    }
    return c;
  } else
    return r == null ? 0 : iWt(e, t, n, r, o);
}
function sWt({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((o) => o.constraints);
  let r = 0, i = 100;
  for (let o = 0; o < e.length; o++) {
    const s = n[o];
    Kn(s, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: l
    } = s;
    l != null && (r++, t[o] = l, i -= l);
  }
  for (let o = 0; o < e.length; o++) {
    const s = n[o];
    Kn(s, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: l
    } = s;
    if (l != null)
      continue;
    const c = e.length - r, a = i / c;
    r++, t[o] = a, i -= a;
  }
  return t;
}
function c0(e, t, n) {
  t.forEach((r, i) => {
    const o = e[i];
    Kn(o, `Panel data not found for index ${i}`);
    const {
      callbacks: s,
      constraints: l,
      id: c
    } = o, {
      collapsedSize: a = 0,
      collapsible: u
    } = l, f = n[c];
    if (f == null || r !== f) {
      n[c] = r;
      const {
        onCollapse: d,
        onExpand: p,
        onResize: h
      } = s;
      h && h(r, f), u && (d || p) && (p && (f == null || jp(f, a)) && !jp(r, a) && p(), d && (f == null || !jp(f, a)) && jp(r, a) && d());
    }
  });
}
function GI(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function aWt({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: r,
  panelIndex: i,
  precision: o = 3
}) {
  const s = n[i];
  let l;
  return s == null ? l = e != null ? e.toPrecision(o) : "1" : r.length === 1 ? l = "1" : l = s.toPrecision(o), {
    flexBasis: 0,
    flexGrow: l,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function lWt(e, t = 10) {
  let n = null;
  return (...i) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...i);
    }, t);
  };
}
function kfe(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function Lje(e) {
  return `react-resizable-panels:${e}`;
}
function zje(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: r,
      idIsFromProps: i,
      order: o
    } = t;
    return i ? r : o ? `${o}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function jje(e, t) {
  try {
    const n = Lje(e), r = t.getItem(n);
    if (r) {
      const i = JSON.parse(r);
      if (typeof i == "object" && i != null)
        return i;
    }
  } catch {
  }
  return null;
}
function cWt(e, t, n) {
  var r, i;
  const o = (r = jje(e, n)) !== null && r !== void 0 ? r : {}, s = zje(t);
  return (i = o[s]) !== null && i !== void 0 ? i : null;
}
function uWt(e, t, n, r, i) {
  var o;
  const s = Lje(e), l = zje(t), c = (o = jje(e, i)) !== null && o !== void 0 ? o : {};
  c[l] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: r
  };
  try {
    i.setItem(s, JSON.stringify(c));
  } catch (a) {
    console.error(a);
  }
}
function Cfe({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], r = n.reduce((o, s) => o + s, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((o) => `${o}%`).join(", ")}`);
  if (!Xl(r, 100))
    for (let o = 0; o < t.length; o++) {
      const s = n[o];
      Kn(s != null, `No layout data found for index ${o}`);
      const l = 100 / r * s;
      n[o] = l;
    }
  let i = 0;
  for (let o = 0; o < t.length; o++) {
    const s = n[o];
    Kn(s != null, `No layout data found for index ${o}`);
    const l = NO({
      panelConstraints: t,
      panelIndex: o,
      size: s
    });
    s != l && (i += s - l, n[o] = l);
  }
  if (!Xl(i, 0))
    for (let o = 0; o < t.length; o++) {
      const s = n[o];
      Kn(s != null, `No layout data found for index ${o}`);
      const l = s + i, c = NO({
        panelConstraints: t,
        panelIndex: o,
        size: l
      });
      if (s !== c && (i -= c - s, n[o] = c, Xl(i, 0)))
        break;
    }
  return n;
}
const dWt = 100, w1 = {
  getItem: (e) => (kfe(w1), w1.getItem(e)),
  setItem: (e, t) => {
    kfe(w1), w1.setItem(e, t);
  }
}, Nfe = {};
function Fje({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: r,
  forwardedRef: i,
  id: o = null,
  onLayout: s = null,
  keyboardResizeBy: l = null,
  storage: c = w1,
  style: a,
  tagName: u = "div",
  ...f
}) {
  const d = EY(o), p = Ja(null), [h, m] = WE(null), [v, b] = WE([]), A = Ja({}), w = Ja(/* @__PURE__ */ new Map()), O = Ja(0), x = Ja({
    autoSaveId: e,
    direction: r,
    dragState: h,
    id: d,
    keyboardResizeBy: l,
    onLayout: s,
    storage: c
  }), S = Ja({
    layout: v,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  Ja({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), Aje(i, () => ({
    getId: () => x.current.id,
    getLayout: () => {
      const {
        layout: B
      } = S.current;
      return B;
    },
    setLayout: (B) => {
      const {
        onLayout: q
      } = x.current, {
        layout: H,
        panelDataArray: Y
      } = S.current, J = Cfe({
        layout: B,
        panelConstraints: Y.map((oe) => oe.constraints)
      });
      Tfe(H, J) || (b(J), S.current.layout = J, q && q(J), c0(Y, J, A.current));
    }
  }), []), yv(() => {
    x.current.autoSaveId = e, x.current.direction = r, x.current.dragState = h, x.current.id = d, x.current.onLayout = s, x.current.storage = c;
  }), rWt({
    committedValuesRef: x,
    eagerValuesRef: S,
    groupId: d,
    layout: v,
    panelDataArray: S.current.panelDataArray,
    setLayout: b,
    panelGroupElement: p.current
  }), gv(() => {
    const {
      panelDataArray: B
    } = S.current;
    if (e) {
      if (v.length === 0 || v.length !== B.length)
        return;
      let q = Nfe[e];
      q == null && (q = lWt(uWt, dWt), Nfe[e] = q);
      const H = [...B], Y = new Map(w.current);
      q(e, H, Y, v, c);
    }
  }, [e, v, c]), gv(() => {
  });
  const E = _l((B) => {
    const {
      onLayout: q
    } = x.current, {
      layout: H,
      panelDataArray: Y
    } = S.current;
    if (B.constraints.collapsible) {
      const J = Y.map(($) => $.constraints), {
        collapsedSize: oe = 0,
        panelSize: ce,
        pivotIndices: fe
      } = sy(Y, B, H);
      if (Kn(ce != null, `Panel size not found for panel "${B.id}"`), !jp(ce, oe)) {
        w.current.set(B.id, ce);
        const pe = cO(Y, B) === Y.length - 1 ? ce - oe : oe - ce, ee = A1({
          delta: pe,
          initialLayout: H,
          panelConstraints: J,
          pivotIndices: fe,
          prevLayout: H,
          trigger: "imperative-api"
        });
        GI(H, ee) || (b(ee), S.current.layout = ee, q && q(ee), c0(Y, ee, A.current));
      }
    }
  }, []), k = _l((B, q) => {
    const {
      onLayout: H
    } = x.current, {
      layout: Y,
      panelDataArray: J
    } = S.current;
    if (B.constraints.collapsible) {
      const oe = J.map((Ce) => Ce.constraints), {
        collapsedSize: ce = 0,
        panelSize: fe = 0,
        minSize: $ = 0,
        pivotIndices: pe
      } = sy(J, B, Y), ee = q ?? $;
      if (jp(fe, ce)) {
        const Ce = w.current.get(B.id), Ee = Ce != null && Ce >= ee ? Ce : ee, et = cO(J, B) === J.length - 1 ? fe - Ee : Ee - fe, ft = A1({
          delta: et,
          initialLayout: Y,
          panelConstraints: oe,
          pivotIndices: pe,
          prevLayout: Y,
          trigger: "imperative-api"
        });
        GI(Y, ft) || (b(ft), S.current.layout = ft, H && H(ft), c0(J, ft, A.current));
      }
    }
  }, []), T = _l((B) => {
    const {
      layout: q,
      panelDataArray: H
    } = S.current, {
      panelSize: Y
    } = sy(H, B, q);
    return Kn(Y != null, `Panel size not found for panel "${B.id}"`), Y;
  }, []), R = _l((B, q) => {
    const {
      panelDataArray: H
    } = S.current, Y = cO(H, B);
    return aWt({
      defaultSize: q,
      dragState: h,
      layout: v,
      panelData: H,
      panelIndex: Y
    });
  }, [h, v]), j = _l((B) => {
    const {
      layout: q,
      panelDataArray: H
    } = S.current, {
      collapsedSize: Y = 0,
      collapsible: J,
      panelSize: oe
    } = sy(H, B, q);
    return Kn(oe != null, `Panel size not found for panel "${B.id}"`), J === !0 && jp(oe, Y);
  }, []), F = _l((B) => {
    const {
      layout: q,
      panelDataArray: H
    } = S.current, {
      collapsedSize: Y = 0,
      collapsible: J,
      panelSize: oe
    } = sy(H, B, q);
    return Kn(oe != null, `Panel size not found for panel "${B.id}"`), !J || eb(oe, Y) > 0;
  }, []), L = _l((B) => {
    const {
      panelDataArray: q
    } = S.current;
    q.push(B), q.sort((H, Y) => {
      const J = H.order, oe = Y.order;
      return J == null && oe == null ? 0 : J == null ? -1 : oe == null ? 1 : J - oe;
    }), S.current.panelDataArrayChanged = !0;
  }, []);
  yv(() => {
    if (S.current.panelDataArrayChanged) {
      S.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: B,
        onLayout: q,
        storage: H
      } = x.current, {
        layout: Y,
        panelDataArray: J
      } = S.current;
      let oe = null;
      if (B) {
        const fe = cWt(B, J, H);
        fe && (w.current = new Map(Object.entries(fe.expandToSizes)), oe = fe.layout);
      }
      oe == null && (oe = sWt({
        panelDataArray: J
      }));
      const ce = Cfe({
        layout: oe,
        panelConstraints: J.map((fe) => fe.constraints)
      });
      Tfe(Y, ce) || (b(ce), S.current.layout = ce, q && q(ce), c0(J, ce, A.current));
    }
  }), yv(() => {
    const B = S.current;
    return () => {
      B.layout = [];
    };
  }, []);
  const _ = _l((B) => function(H) {
    H.preventDefault();
    const Y = p.current;
    if (!Y)
      return () => null;
    const {
      direction: J,
      dragState: oe,
      id: ce,
      keyboardResizeBy: fe,
      onLayout: $
    } = x.current, {
      layout: pe,
      panelDataArray: ee
    } = S.current, {
      initialLayout: Ce
    } = oe ?? {}, Ee = Mje(ce, B, Y);
    let Ve = oWt(H, B, J, oe, fe, Y);
    if (Ve === 0)
      return;
    const et = J === "horizontal";
    document.dir === "rtl" && et && (Ve = -Ve);
    const ft = ee.map((re) => re.constraints), me = A1({
      delta: Ve,
      initialLayout: Ce ?? pe,
      panelConstraints: ft,
      pivotIndices: Ee,
      prevLayout: pe,
      trigger: Sje(H) ? "keyboard" : "mouse-or-touch"
    }), Te = !GI(pe, me);
    (Eje(H) || Tje(H)) && O.current != Ve && (O.current = Ve, Te ? v4(B, 0) : et ? v4(B, Ve < 0 ? Cje : Nje) : v4(B, Ve < 0 ? Pje : Ije)), Te && (b(me), S.current.layout = me, $ && $(me), c0(ee, me, A.current));
  }, []), U = _l((B, q) => {
    const {
      onLayout: H
    } = x.current, {
      layout: Y,
      panelDataArray: J
    } = S.current, oe = J.map((Ce) => Ce.constraints), {
      panelSize: ce,
      pivotIndices: fe
    } = sy(J, B, Y);
    Kn(ce != null, `Panel size not found for panel "${B.id}"`);
    const pe = cO(J, B) === J.length - 1 ? ce - q : q - ce, ee = A1({
      delta: pe,
      initialLayout: Y,
      panelConstraints: oe,
      pivotIndices: fe,
      prevLayout: Y,
      trigger: "imperative-api"
    });
    GI(Y, ee) || (b(ee), S.current.layout = ee, H && H(ee), c0(J, ee, A.current));
  }, []), z = _l((B, q) => {
    const {
      layout: H,
      panelDataArray: Y
    } = S.current, {
      collapsedSize: J = 0,
      collapsible: oe
    } = q, {
      collapsedSize: ce = 0,
      collapsible: fe,
      maxSize: $ = 100,
      minSize: pe = 0
    } = B.constraints, {
      panelSize: ee
    } = sy(Y, B, H);
    ee != null && (oe && fe && jp(ee, J) ? jp(J, ce) || U(B, ce) : ee < pe ? U(B, pe) : ee > $ && U(B, $));
  }, [U]), C = _l((B, q) => {
    const {
      direction: H
    } = x.current, {
      layout: Y
    } = S.current;
    if (!p.current)
      return;
    const J = p3(B, p.current);
    Kn(J, `Drag handle element not found for id "${B}"`);
    const oe = _je(H, q);
    m({
      dragHandleId: B,
      dragHandleRect: J.getBoundingClientRect(),
      initialCursorPosition: oe,
      initialLayout: Y
    });
  }, []), I = _l(() => {
    m(null);
  }, []), M = _l((B) => {
    const {
      panelDataArray: q
    } = S.current, H = cO(q, B);
    H >= 0 && (q.splice(H, 1), delete A.current[B.id], S.current.panelDataArrayChanged = !0);
  }, []), D = U7t(() => ({
    collapsePanel: E,
    direction: r,
    dragState: h,
    expandPanel: k,
    getPanelSize: T,
    getPanelStyle: R,
    groupId: d,
    isPanelCollapsed: j,
    isPanelExpanded: F,
    reevaluatePanelConstraints: z,
    registerPanel: L,
    registerResizeHandle: _,
    resizePanel: U,
    startDragging: C,
    stopDragging: I,
    unregisterPanel: M,
    panelGroupElement: p.current
  }), [E, h, r, k, T, R, d, j, F, z, L, _, U, C, I, M]), X = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Pw(c3.Provider, {
    value: D
  }, Pw(u, {
    ...f,
    children: t,
    className: n,
    id: o,
    ref: p,
    style: {
      ...X,
      ...a
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": r,
    "data-panel-group-id": d
  }));
}
const Uje = bje((e, t) => Pw(Fje, {
  ...e,
  forwardedRef: t
}));
Fje.displayName = "PanelGroup";
Uje.displayName = "forwardRef(PanelGroup)";
function cO(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function sy(e, t, n) {
  const r = cO(e, t), o = r === e.length - 1 ? [r - 1, r] : [r, r + 1], s = n[r];
  return {
    ...t.constraints,
    panelSize: s,
    pivotIndices: o
  };
}
function fWt({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: r
}) {
  gv(() => {
    if (e || n == null || r == null)
      return;
    const i = p3(t, r);
    if (i == null)
      return;
    const o = (s) => {
      if (!s.defaultPrevented)
        switch (s.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            s.preventDefault(), n(s);
            break;
          }
          case "F6": {
            s.preventDefault();
            const l = i.getAttribute("data-panel-group-id");
            Kn(l, `No group element found for id "${l}"`);
            const c = Pk(l, r), a = Rje(l, t, r);
            Kn(a !== null, `No resize element found for id "${t}"`);
            const u = s.shiftKey ? a > 0 ? a - 1 : c.length - 1 : a + 1 < c.length ? a + 1 : 0;
            c[u].focus();
            break;
          }
        }
    };
    return i.addEventListener("keydown", o), () => {
      i.removeEventListener("keydown", o);
    };
  }, [r, e, t, n]);
}
function Vje({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: r,
  id: i,
  onBlur: o,
  onDragging: s,
  onFocus: l,
  style: c = {},
  tabIndex: a = 0,
  tagName: u = "div",
  ...f
}) {
  var d, p;
  const h = Ja(null), m = Ja({
    onDragging: s
  });
  gv(() => {
    m.current.onDragging = s;
  });
  const v = Oje(c3);
  if (v === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: b,
    groupId: A,
    registerResizeHandle: w,
    startDragging: O,
    stopDragging: x,
    panelGroupElement: S
  } = v, E = EY(i), [k, T] = WE("inactive"), [R, j] = WE(!1), [F, L] = WE(null), _ = Ja({
    state: k
  });
  yv(() => {
    _.current.state = k;
  }), gv(() => {
    if (n)
      L(null);
    else {
      const I = w(E);
      L(() => I);
    }
  }, [n, E, w]);
  const U = (d = r == null ? void 0 : r.coarse) !== null && d !== void 0 ? d : 15, z = (p = r == null ? void 0 : r.fine) !== null && p !== void 0 ? p : 5;
  return gv(() => {
    if (n || F == null)
      return;
    const I = h.current;
    return Kn(I, "Element ref not attached"), J7t(E, I, b, {
      coarse: U,
      fine: z
    }, (D, X, B) => {
      if (X)
        switch (D) {
          case "down": {
            T("drag"), O(E, B);
            const {
              onDragging: q
            } = m.current;
            q && q(!0);
            break;
          }
          case "move": {
            const {
              state: q
            } = _.current;
            q !== "drag" && T("hover"), F(B);
            break;
          }
          case "up": {
            T("hover"), x();
            const {
              onDragging: q
            } = m.current;
            q && q(!1);
            break;
          }
        }
      else
        T("inactive");
    });
  }, [U, b, n, z, w, E, F, O, x]), fWt({
    disabled: n,
    handleId: E,
    resizeHandler: F,
    panelGroupElement: S
  }), Pw(u, {
    ...f,
    children: e,
    className: t,
    id: i,
    onBlur: () => {
      j(!1), o == null || o();
    },
    onFocus: () => {
      j(!0), l == null || l();
    },
    ref: h,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...c
    },
    tabIndex: a,
    // CSS selectors
    "data-panel-group-direction": b,
    "data-panel-group-id": A,
    "data-resize-handle": "",
    "data-resize-handle-active": k === "drag" ? "pointer" : R ? "keyboard" : void 0,
    "data-resize-handle-state": k,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": E
  });
}
Vje.displayName = "PanelResizeHandle";
const qje = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y(
  Uje,
  {
    className: Se(
      "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
      e
    ),
    ...t
  }
), $_ = xje, Bje = ({
  withHandle: e,
  className: t,
  ...n
}) => /* @__PURE__ */ y(
  Vje,
  {
    className: Se(
      "bg-border z-40 focus-visible:ring-ring relative flex w-[1px] items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-none data-[panel-group-direction=vertical]:h-[2px] data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:translate-x-0 data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90",
      t
    ),
    ...n,
    children: e && /* @__PURE__ */ y("div", { className: "bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border", children: /* @__PURE__ */ y(Vit, { className: "size-2.5 hover:fill-primary" }) })
  }
);
var PY = /* @__PURE__ */ ((e) => (e.CLIENT_INIT = "CLIENT_INIT", e.CLIENT_ROUTE_CHANGED = "CLIENT_ROUTE_CHANGED", e.CLIENT_NEW_CONNECTION_DIALOG_CLOSED = "CLIENT_NEW_CONNECTION_DIALOG_CLOSED", e.CLIENT_SHOW_CONNECTION_IFRAME = "CLIENT_SHOW_CONNECTION_IFRAME", e.CLIENT_CONNECTION_NAME_IS_INVALID = "CLIENT_CONNECTION_NAME_IS_INVALID", e.CLIENT_AUTHENTICATION_SUCCESS = "CLIENT_AUTHENTICATION_SUCCESS", e.CLIENT_AUTHENTICATION_FAILED = "CLIENT_AUTHENTICATION_FAILED", e.CLIENT_CONFIGURATION_FINISHED = "CLIENT_CONFIGURATION_FINISHED", e.CLIENT_CONNECTION_PIECE_NOT_FOUND = "CLIENT_CONNECTION_PIECE_NOT_FOUND", e.CLIENT_BUILDER_HOME_BUTTON_CLICKED = "CLIENT_BUILDER_HOME_BUTTON_CLICKED", e))(PY || {});
const YI = {
  name: "pieceName",
  connectionName: "connectionName"
};
class Xje {
  constructor() {
    rn(this, "_sdkVersion", "0.8.1");
    //used for  Automatically Sync URL feature i.e /org/1234
    rn(this, "_prefix", "/");
    rn(this, "_instanceUrl", "");
    //this is used to authenticate embedding for the first time
    rn(this, "_jwtToken", "");
    rn(this, "_resolveNewConnectionDialogClosed");
    rn(this, "_dashboardAndBuilderIframeWindow");
    rn(this, "_rejectNewConnectionDialogClosed");
    rn(this, "_handleVendorNavigation");
    rn(this, "_handleClientNavigation");
    rn(this, "_parentOrigin", window.location.origin);
    rn(this, "_MAX_CONTAINER_CHECK_COUNT", 100);
    rn(this, "_HUNDRED_MILLISECONDS", 100);
    rn(this, "_embeddingAuth");
    rn(this, "_embeddingState");
    rn(this, "_initializeBuilderAndDashboardIframe", ({
      containerSelector: t
    }) => new Promise((n, r) => {
      this._addGracePeriodBeforeMethod({
        condition: () => !!document.querySelector(t),
        method: () => {
          const i = document.querySelector(t);
          if (i) {
            const o = this.connectToEmbed({
              iframeContainer: i,
              callbackAfterConfigurationFinished: () => {
                n({ status: "success" });
              },
              initialRoute: "/"
            }).contentWindow;
            this._dashboardAndBuilderIframeWindow = o, this._checkForClientRouteChanges(o), this._checkForBuilderHomeButtonClicked(o);
          } else
            r({
              status: "error",
              error: {
                message: "container not found"
              }
            });
        },
        errorMessage: "container not found"
      });
    }));
    rn(this, "_createConfigurationFinishedListener", (t, n) => {
      const r = (i) => {
        i.data.type === "CLIENT_CONFIGURATION_FINISHED" && i.source === t && (this._logger().log("Configuration finished"), n && n());
      };
      window.addEventListener("message", r);
    });
    rn(this, "_createAuthenticationFailedListener", (t) => {
      const n = (r) => {
        r.data.type === "CLIENT_AUTHENTICATION_FAILED" && r.source === t && this._errorCreator("Authentication failed", r.data.data);
      };
      window.addEventListener("message", n);
    });
    rn(this, "_createAuthenticationSuccessListener", (t) => {
      const n = (r) => {
        r.data.type === "CLIENT_AUTHENTICATION_SUCCESS" && r.source === t && (this._logger().log("Authentication success"), window.removeEventListener("message", n));
      };
      window.addEventListener("message", n);
    });
    rn(this, "_checkForClientRouteChanges", (t) => {
      window.addEventListener(
        "message",
        (n) => {
          var r, i;
          if (n.data.type === "CLIENT_ROUTE_CHANGED" && n.source === t && ((i = (r = this._embeddingState) == null ? void 0 : r.navigation) != null && i.handler)) {
            const o = this._prefix + this._prependForwardSlashToRoute(n.data.data.route);
            this._embeddingState.navigation.handler({ route: o });
            return;
          }
        }
      );
    });
    rn(this, "_checkForBuilderHomeButtonClicked", (t) => {
      window.addEventListener("message", (n) => {
        var r, i, o;
        n.data.type === "CLIENT_BUILDER_HOME_BUTTON_CLICKED" && n.source === t && ((o = (i = (r = this._embeddingState) == null ? void 0 : r.builder) == null ? void 0 : i.homeButtonClickedHandler) == null || o.call(i, n.data.data));
      });
    });
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    rn(this, "_cleanConnectionIframe", () => {
    });
  }
  configure({
    jwtToken: t,
    instanceUrl: n,
    embedding: r,
    prefix: i
  }) {
    return this._instanceUrl = this._removeTrailingSlashes(n), this._jwtToken = t, this._prefix = this._removeTrailingSlashes(this._prependForwardSlashToRoute(i ?? "/")), this._embeddingState = r, r != null && r.containerId ? this._initializeBuilderAndDashboardIframe({
      containerSelector: `#${r.containerId}`
    }) : new Promise((o) => {
      o({ status: "success" });
    });
  }
  _setupInitialMessageHandler(t, n, r) {
    const i = (o) => {
      var s, l, c, a, u, f, d, p, h, m, v, b, A, w, O, x, S, E, k, T, R, j, F, L;
      if (o.source === t && o.origin === new URL(this._instanceUrl).origin)
        switch (o.data.type) {
          case "CLIENT_INIT": {
            const _ = {
              type: "VENDOR_INIT",
              data: {
                hideSidebar: ((l = (s = this._embeddingState) == null ? void 0 : s.dashboard) == null ? void 0 : l.hideSidebar) ?? !1,
                hideFlowsPageNavbar: ((a = (c = this._embeddingState) == null ? void 0 : c.dashboard) == null ? void 0 : a.hideFlowsPageNavbar) ?? !1,
                disableNavigationInBuilder: ((f = (u = this._embeddingState) == null ? void 0 : u.builder) == null ? void 0 : f.disableNavigation) ?? !1,
                hideFolders: ((d = this._embeddingState) == null ? void 0 : d.hideFolders) ?? !1,
                hideFlowNameInBuilder: ((h = (p = this._embeddingState) == null ? void 0 : p.builder) == null ? void 0 : h.hideFlowName) ?? !1,
                jwtToken: this._jwtToken,
                initialRoute: n,
                fontUrl: (v = (m = this._embeddingState) == null ? void 0 : m.styling) == null ? void 0 : v.fontUrl,
                fontFamily: (A = (b = this._embeddingState) == null ? void 0 : b.styling) == null ? void 0 : A.fontFamily,
                hideExportAndImportFlow: ((w = this._embeddingState) == null ? void 0 : w.hideExportAndImportFlow) ?? !1,
                emitHomeButtonClickedEvent: ((x = (O = this._embeddingState) == null ? void 0 : O.builder) == null ? void 0 : x.homeButtonClickedHandler) !== void 0,
                locale: ((S = this._embeddingState) == null ? void 0 : S.locale) ?? "en",
                sdkVersion: this._sdkVersion,
                homeButtonIcon: ((k = (E = this._embeddingState) == null ? void 0 : E.builder) == null ? void 0 : k.homeButtonIcon) ?? "logo",
                hideDuplicateFlow: ((T = this._embeddingState) == null ? void 0 : T.hideDuplicateFlow) ?? !1,
                mode: (j = (R = this._embeddingState) == null ? void 0 : R.styling) == null ? void 0 : j.mode,
                hidePageHeader: ((L = (F = this._embeddingState) == null ? void 0 : F.dashboard) == null ? void 0 : L.hidePageHeader) ?? !1
              }
            };
            t.postMessage(_, "*"), this._createAuthenticationSuccessListener(t), this._createAuthenticationFailedListener(t), this._createConfigurationFinishedListener(t, r), window.removeEventListener("message", i);
            break;
          }
        }
    };
    window.addEventListener("message", i);
  }
  connectToEmbed({ iframeContainer: t, initialRoute: n, callbackAfterConfigurationFinished: r }) {
    const i = this._createIframe({ src: `${this._instanceUrl}/embed?currentDate=${Date.now()}` });
    t.appendChild(i), this._doesFrameHaveWindow(i) || this._errorCreator("iframe window not accessible");
    const o = i.contentWindow;
    return this._setupInitialMessageHandler(o, n, r), i;
  }
  _createIframe({ src: t }) {
    const n = document.createElement("iframe");
    return n.src = t, n.setAttribute("allow", "clipboard-read; clipboard-write"), n;
  }
  _getNewWindowFeatures(t) {
    const n = {
      height: 700,
      width: 700,
      top: 0,
      left: 0
    };
    return Object.keys(n).forEach((r) => {
      typeof t == "object" && t[r] && (n[r] = t[r]);
    }), `width=${n.width},height=${n.height},top=${n.top},left=${n.left}`;
  }
  _addConnectionIframe({ pieceName: t, connectionName: n }) {
    const r = this.connectToEmbed({
      iframeContainer: document.body,
      initialRoute: `/embed/connections?${YI.name}=${t}&randomId=${Date.now()}&${YI.connectionName}=${n || ""}`
    });
    return r.style.cssText = ["display:none", "position:fixed", "top:0", "left:0", "width:100%", "height:100%", "border:none"].join(";"), r;
  }
  _openNewWindowForConnections({ pieceName: t, connectionName: n, newWindow: r }) {
    const i = window.open(`${this._instanceUrl}/embed`, "_blank", this._getNewWindowFeatures(r));
    return i || this._errorCreator("Failed to open popup window"), this._setupInitialMessageHandler(i, `/embed/connections?${YI.name}=${t}&randomId=${Date.now()}&${YI.connectionName}=${n || ""}`), i;
  }
  async connect({ pieceName: t, connectionName: n, newWindow: r }) {
    return this._cleanConnectionIframe(), this._addGracePeriodBeforeMethod({
      condition: () => !!document.body,
      method: async () => {
        const i = r ? this._openNewWindowForConnections({ pieceName: t, connectionName: n, newWindow: r }) : this._addConnectionIframe({ pieceName: t, connectionName: n });
        if (!(i instanceof HTMLIFrameElement)) {
          const o = setInterval(() => {
            i.closed && (clearInterval(o), this._resolveNewConnectionDialogClosed && this._resolveNewConnectionDialogClosed({ connection: void 0 }));
          }, 500);
        }
        return new Promise((o, s) => {
          this._resolveNewConnectionDialogClosed = o, this._rejectNewConnectionDialogClosed = s, this._setConnectionIframeEventsListener(i);
        });
      },
      errorMessage: "unable to add connection embedding"
    });
  }
  navigate({ route: t }) {
    if (!this._dashboardAndBuilderIframeWindow) {
      this._logger().error("dashboard iframe not found");
      return;
    }
    const n = {
      type: "VENDOR_ROUTE_CHANGED",
      data: {
        vendorRoute: this._prependForwardSlashToRoute(t)
      }
    };
    this._dashboardAndBuilderIframeWindow.postMessage(n, "*");
  }
  _prependForwardSlashToRoute(t) {
    return t.startsWith("/") ? t : `/${t}`;
  }
  _extractRouteAfterPrefix(t, n) {
    return t.split(n)[1];
  }
  //used for  Automatically Sync URL feature 
  extractActivepiecesRouteFromUrl({ vendorUrl: t }) {
    return this._extractRouteAfterPrefix(t, this._removeTrailingSlashes(this._parentOrigin) + this._prefix);
  }
  _doesFrameHaveWindow(t) {
    return t.contentWindow !== null;
  }
  _setConnectionIframeEventsListener(t) {
    const n = (r) => {
      if (r.data.type)
        switch (r.data.type) {
          case "CLIENT_NEW_CONNECTION_DIALOG_CLOSED": {
            this._resolveNewConnectionDialogClosed && this._resolveNewConnectionDialogClosed(r.data.data), this._removeEmbedding(t), window.removeEventListener("message", n);
            break;
          }
          case "CLIENT_CONNECTION_NAME_IS_INVALID":
          case "CLIENT_CONNECTION_PIECE_NOT_FOUND": {
            this._removeEmbedding(t), this._rejectNewConnectionDialogClosed ? this._rejectNewConnectionDialogClosed(r.data.data) : this._errorCreator(r.data.data.error), window.removeEventListener("message", n);
            break;
          }
          case "CLIENT_SHOW_CONNECTION_IFRAME": {
            t instanceof HTMLIFrameElement && (t.style.display = "block");
            break;
          }
        }
    };
    window.addEventListener(
      "message",
      n
    ), this._cleanConnectionIframe = () => {
      window.removeEventListener("message", n), this._resolveNewConnectionDialogClosed = void 0, this._rejectNewConnectionDialogClosed = void 0, this._removeEmbedding(t);
    };
  }
  _removeTrailingSlashes(t) {
    return t.endsWith("/") ? t.slice(0, -1) : t;
  }
  _removeStartingSlashes(t) {
    return t.startsWith("/") ? t.slice(1) : t;
  }
  /**Adds a grace period before executing the method depending on the condition */
  _addGracePeriodBeforeMethod({
    method: t,
    condition: n,
    errorMessage: r
  }) {
    return new Promise((i, o) => {
      let s = 0;
      if (n()) {
        i(t());
        return;
      }
      const l = setInterval(() => {
        if (s >= this._MAX_CONTAINER_CHECK_COUNT) {
          this._logger().error(r), o(r);
          return;
        }
        s++, n() && (clearInterval(l), i(t()));
      }, this._HUNDRED_MILLISECONDS);
    });
  }
  _errorCreator(t, ...n) {
    throw this._logger().error(t, ...n), new Error(`Activepieces: ${t}`);
  }
  _removeEmbedding(t) {
    t ? t instanceof HTMLIFrameElement ? t.remove() : t.close() : this._logger().warn("couldn't remove embedding");
  }
  _logger() {
    return {
      log: (t, ...n) => {
        console.log(`Activepieces: ${t}`, ...n);
      },
      error: (t, ...n) => {
        console.error(`Activepieces: ${t}`, ...n);
      },
      warn: (t, ...n) => {
        console.warn(`Activepieces: ${t}`, ...n);
      }
    };
  }
  async fetchEmbeddingAuth(t) {
    if (this._embeddingAuth)
      return this._embeddingAuth;
    const n = (t == null ? void 0 : t.jwtToken) ?? this._jwtToken;
    n || this._errorCreator("jwt token not found");
    const r = await this.request({ path: "/managed-authn/external-token", method: "POST", body: {
      externalAccessToken: n
    } }, !1);
    return this._embeddingAuth = {
      userJwtToken: r.token,
      platformId: r.platformId,
      projectId: r.projectId
    }, this._embeddingAuth;
  }
  async request({ path: t, method: n, body: r, queryParams: i }, o = !0) {
    const s = {};
    if (r && (s["Content-Type"] = "application/json"), o) {
      const c = await this.fetchEmbeddingAuth({ jwtToken: this._jwtToken });
      s.Authorization = `Bearer ${c.userJwtToken}`;
    }
    const l = i ? `?${new URLSearchParams(i).toString()}` : "";
    return fetch(`${this._removeTrailingSlashes(this._instanceUrl)}/api/v1/${this._removeStartingSlashes(t)}${l}`, {
      method: n,
      body: r ? JSON.stringify(r) : void 0,
      headers: s
    }).then((c) => c.json());
  }
}
window.activepieces = new Xje();
window.ActivepiecesEmbedded = Xje;
const pWt = ({ backPath: e }) => {
  const { embedState: t } = bd(), n = kqe(), r = Rn.appendProjectRoutePrefix(e);
  return t.emitHomeButtonClickedEvent ? /* @__PURE__ */ y(
    Qe,
    {
      variant: "ghost",
      size: "icon",
      className: "size-8",
      onClick: () => {
        window.parent.postMessage(
          {
            type: PY.CLIENT_BUILDER_HOME_BUTTON_CLICKED,
            data: {
              route: e
            }
          },
          "*"
        );
      },
      children: /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] h-4 w-4" })
    }
  ) : n ? /* @__PURE__ */ y(Qe, { variant: "ghost", size: "icon", className: "size-8", asChild: !0, children: /* @__PURE__ */ y(oW, { to: r, children: /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] h-4 w-4" }) }) }) : /* @__PURE__ */ y(Qe, { variant: "ghost", size: "icon", className: "size-8", asChild: !0, children: /* @__PURE__ */ y("a", { href: r, children: /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] h-4 w-4" }) }) });
}, hWt = ({
  title: e,
  description: t,
  leftContent: n,
  rightContent: r,
  showBorder: i = !1,
  className: o = "",
  hideSidebarTrigger: s = !1,
  showBackButton: l = !1,
  backPath: c = "/flows"
}) => {
  const { embedState: a } = bd();
  if (a.hidePageHeader)
    return null;
  const u = !s && !a.isEmbedded;
  return /* @__PURE__ */ y(
    "div",
    {
      className: `flex items-center justify-between py-3 w-full px-4 ${i ? "border-b" : ""} ${o}`,
      children: /* @__PURE__ */ V("div", { className: "flex items-center justify-between w-full", children: [
        /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
          l && /* @__PURE__ */ y(pWt, { backPath: c }),
          u && /* @__PURE__ */ y(KSe, {}),
          (u || l) && /* @__PURE__ */ y(Eh, { orientation: "vertical", className: "h-5 mr-2" }),
          /* @__PURE__ */ V("div", { children: [
            /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: typeof e == "string" ? /* @__PURE__ */ y("h1", { className: "text-base font-normal", children: e }) : e }),
            t && /* @__PURE__ */ y("span", { className: "text-xs text-muted-foreground", children: t })
          ] }),
          n
        ] }),
        r
      ] })
    }
  );
}, Wje = N.forwardRef(({ ...e }, t) => /* @__PURE__ */ y("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
Wje.displayName = "Breadcrumb";
const Zje = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "ol",
  {
    ref: n,
    className: Se(
      "flex flex-wrap items-center gap-1.5 wrap-break-word text-sm text-muted-foreground sm:gap-2.5",
      e
    ),
    ...t
  }
));
Zje.displayName = "BreadcrumbList";
const Hje = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "li",
  {
    ref: n,
    className: Se("inline-flex items-center gap-1.5", e),
    ...t
  }
));
Hje.displayName = "BreadcrumbItem";
const mWt = N.forwardRef(({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ y(
  e ? is : "a",
  {
    ref: r,
    className: Se("transition-colors hover:text-foreground", t),
    ...n
  }
));
mWt.displayName = "BreadcrumbLink";
const Qje = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "span",
  {
    ref: n,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: Se("font-normal text-foreground", e),
    ...t
  }
));
Qje.displayName = "BreadcrumbPage";
const Ik = ({
  value: e,
  className: t = "",
  readonly: n = !1,
  onValueChange: r,
  tooltipContent: i,
  disallowEditingOnClick: o,
  isEditing: s,
  setIsEditing: l
}) => {
  const [c, a] = He(e), u = Xe(!1), f = Xe(e);
  c !== e && a(e);
  const d = Xe(null), p = qn(() => {
    var b;
    const m = (((b = d.current) == null ? void 0 : b.textContent) ?? "").trim(), v = m.length > 0 && m !== f.current;
    a(v ? m : f.current), v && r(m);
  }, [r, f.current]), h = () => {
    requestAnimationFrame(() => {
      if (d.current && window.getSelection && document.createRange) {
        const m = document.createRange(), v = window.getSelection();
        m.selectNodeContents(d.current), v == null || v.removeAllRanges(), v == null || v.addRange(m);
      }
    });
  };
  return s && !u.current && (f.current = c ? c.trim() : "", h()), u.current = s, s ? /* @__PURE__ */ y(
    "div",
    {
      ref: d,
      contentEditable: !0,
      suppressContentEditableWarning: !0,
      className: `${t}  focus:outline-none break-all`,
      onBlur: () => {
        p(), l(!1);
      },
      onKeyDown: (m) => {
        m.key === "Escape" ? (a(f.current), l(!1)) : m.key === "Enter" && (p(), l(!1));
      },
      children: c
    },
    "editable"
  ) : /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(
      kn,
      {
        disabled: n || s || o || De(i),
        asChild: !0,
        children: /* @__PURE__ */ y(
          "div",
          {
            onClick: () => {
              !s && !n && !o && l(!0);
            },
            ref: d,
            className: `${t} truncate `,
            title: d.current && d.current.scrollWidth > d.current.clientWidth && c ? c : "",
            children: c
          },
          "viewed"
        )
      }
    ),
    i && /* @__PURE__ */ y(An, { className: "font-normal z-50", side: "bottom", children: i })
  ] });
};
Ik.displayName = "EditableText";
const gWt = ({ children: e }) => {
  const { embedState: t } = bd();
  return t.emitHomeButtonClickedEvent ? /* @__PURE__ */ y("div", { onClick: () => {
    window.parent.postMessage(
      {
        type: PY.CLIENT_BUILDER_HOME_BUTTON_CLICKED,
        data: {
          route: "/flows"
        }
      },
      "*"
    );
  }, children: e }) : /* @__PURE__ */ y(oW, { to: Rn.appendProjectRoutePrefix("/flows"), children: e });
}, $je = () => {
  const { embedState: e } = bd(), t = Go.useWebsiteBranding(), n = e.homeButtonIcon === "back";
  return /* @__PURE__ */ y(pt, { children: !e.hideHomeButtonInBuilder && /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(gWt, { children: /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V(
      Qe,
      {
        variant: "ghost",
        size: "icon",
        className: n ? "size-8" : "size-10",
        children: [
          !n && /* @__PURE__ */ y(
            "img",
            {
              className: "h-5 w-5 object-contain",
              src: t.logos.logoIconUrl,
              alt: t.websiteName
            }
          ),
          n && /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] h-4 w-4" })
        ]
      }
    ) }) }),
    !n && /* @__PURE__ */ y(An, { side: "bottom", children: Z("Go to Dashboard") })
  ] }) });
};
$je.displayName = "HomeButton";
const Kje = $w((e) => ({
  params: null,
  openDialog: (t) => e({ params: t }),
  closeDialog: () => e({ params: null })
})), _x = {
  list(e) {
    return dt.get("/v1/flow-runs", e);
  },
  getPopulated(e) {
    return dt.get(`/v1/flow-runs/${e}`);
  },
  bulkRetry(e) {
    return dt.post("/v1/flow-runs/retry", e);
  },
  bulkCancel(e) {
    return dt.post("/v1/flow-runs/cancel", e);
  },
  bulkArchive(e) {
    return dt.post("/v1/flow-runs/archive", e);
  },
  retry(e, t) {
    return dt.post(`/v1/flow-runs/${e}/retry`, t);
  },
  async testFlow(e, t, n) {
    e.emit(vH.TEST_FLOW_RUN, t);
    const r = await yWt(e, t.flowVersionId);
    n(r);
  },
  async testStep(e) {
    const { socket: t, request: n, onProgress: r, onFinish: i } = e, o = await dt.post(
      "/v1/sample-data/test-step",
      n
    );
    return new Promise((s, l) => {
      const c = (u) => {
        u.runId === o.id && (i == null || i(), t.off(
          pi.TEST_STEP_FINISHED,
          c
        ), t.off("error", a), s(u));
      }, a = (u) => {
        i == null || i(), t.off(pi.TEST_STEP_FINISHED, c), t.off("error", a), l(u);
      };
      if (t.on(pi.TEST_STEP_FINISHED, c), t.on("error", a), r) {
        const u = (f) => {
          f.runId === o.id && r(f);
        };
        t.on(pi.TEST_STEP_PROGRESS, u);
      }
    });
  }
};
function yWt(e, t) {
  return new Promise((n) => {
    const r = (i) => {
      i.flowVersionId === t && (e.off(pi.TEST_FLOW_RUN_STARTED, r), n(i));
    };
    e.on(pi.TEST_FLOW_RUN_STARTED, r);
  });
}
const Gje = {
  async list() {
    const e = {
      cursor: void 0,
      limit: 1e6,
      projectId: Rn.getProjectId()
    };
    return (await dt.get("/v1/folders", e)).data || [];
  },
  get(e) {
    return dt.get(`/v1/folders/${e}`);
  },
  create(e) {
    return dt.post("/v1/folders", e);
  },
  delete(e) {
    return dt.delete(`/v1/folders/${e}`);
  },
  renameFolder(e, t) {
    return dt.post(`/v1/folders/${e}`, t);
  }
};
var b4 = { exports: {} }, Pfe;
function vWt() {
  return Pfe || (Pfe = 1, function(e, t) {
    (function(r, i) {
      e.exports = i();
    })(globalThis, () => (
      /******/
      (() => {
        var n = {
          /***/
          794: (
            /***/
            (s, l, c) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.CronParser = void 0;
              var a = c(586), u = function() {
                function f(d, p, h) {
                  p === void 0 && (p = !0), h === void 0 && (h = !1), this.expression = d, this.dayOfWeekStartIndexZero = p, this.monthStartIndexZero = h;
                }
                return f.prototype.parse = function() {
                  var d = this.extractParts(this.expression);
                  return this.normalize(d), this.validate(d), d;
                }, f.prototype.extractParts = function(d) {
                  if (!this.expression)
                    throw new Error("Expression is empty");
                  var p = d.trim().split(/[ ]+/);
                  if (p.length < 5)
                    throw new Error("Expression has only ".concat(p.length, " part").concat(p.length == 1 ? "" : "s", ". At least 5 parts are required."));
                  if (p.length == 5)
                    p.unshift(""), p.push("");
                  else if (p.length == 6) {
                    var h = /\d{4}$/.test(p[5]) || p[4] == "?" || p[2] == "?";
                    h ? p.unshift("") : p.push("");
                  } else if (p.length > 7)
                    throw new Error("Expression has ".concat(p.length, " parts; too many!"));
                  return p;
                }, f.prototype.normalize = function(d) {
                  var p = this;
                  if (d[3] = d[3].replace("?", "*"), d[5] = d[5].replace("?", "*"), d[2] = d[2].replace("?", "*"), d[0].indexOf("0/") == 0 && (d[0] = d[0].replace("0/", "*/")), d[1].indexOf("0/") == 0 && (d[1] = d[1].replace("0/", "*/")), d[2].indexOf("0/") == 0 && (d[2] = d[2].replace("0/", "*/")), d[3].indexOf("1/") == 0 && (d[3] = d[3].replace("1/", "*/")), d[4].indexOf("1/") == 0 && (d[4] = d[4].replace("1/", "*/")), d[6].indexOf("1/") == 0 && (d[6] = d[6].replace("1/", "*/")), d[5] = d[5].replace(/(^\d)|([^#/\s]\d)/g, function(x) {
                    var S = x.replace(/\D/, ""), E = S;
                    return p.dayOfWeekStartIndexZero ? S == "7" && (E = "0") : E = (parseInt(S) - 1).toString(), x.replace(S, E);
                  }), d[5] == "L" && (d[5] = "6"), d[3] == "?" && (d[3] = "*"), d[3].indexOf("W") > -1 && (d[3].indexOf(",") > -1 || d[3].indexOf("-") > -1))
                    throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
                  var h = {
                    SUN: 0,
                    MON: 1,
                    TUE: 2,
                    WED: 3,
                    THU: 4,
                    FRI: 5,
                    SAT: 6
                  };
                  for (var m in h)
                    d[5] = d[5].replace(new RegExp(m, "gi"), h[m].toString());
                  d[4] = d[4].replace(/(^\d{1,2})|([^#/\s]\d{1,2})/g, function(x) {
                    var S = x.replace(/\D/, ""), E = S;
                    return p.monthStartIndexZero && (E = (parseInt(S) + 1).toString()), x.replace(S, E);
                  });
                  var v = {
                    JAN: 1,
                    FEB: 2,
                    MAR: 3,
                    APR: 4,
                    MAY: 5,
                    JUN: 6,
                    JUL: 7,
                    AUG: 8,
                    SEP: 9,
                    OCT: 10,
                    NOV: 11,
                    DEC: 12
                  };
                  for (var b in v)
                    d[4] = d[4].replace(new RegExp(b, "gi"), v[b].toString());
                  d[0] == "0" && (d[0] = ""), !/\*|\-|\,|\//.test(d[2]) && (/\*|\//.test(d[1]) || /\*|\//.test(d[0])) && (d[2] += "-".concat(d[2]));
                  for (var A = 0; A < d.length; A++)
                    if (d[A].indexOf(",") != -1 && (d[A] = d[A].split(",").filter(function(x) {
                      return x !== "";
                    }).join(",") || "*"), d[A] == "*/1" && (d[A] = "*"), d[A].indexOf("/") > -1 && !/^\*|\-|\,/.test(d[A])) {
                      var w = null;
                      switch (A) {
                        case 4:
                          w = "12";
                          break;
                        case 5:
                          w = "6";
                          break;
                        case 6:
                          w = "9999";
                          break;
                        default:
                          w = null;
                          break;
                      }
                      if (w !== null) {
                        var O = d[A].split("/");
                        d[A] = "".concat(O[0], "-").concat(w, "/").concat(O[1]);
                      }
                    }
                }, f.prototype.validate = function(d) {
                  this.assertNoInvalidCharacters("DOW", d[5]), this.assertNoInvalidCharacters("DOM", d[3]), this.validateRange(d);
                }, f.prototype.validateRange = function(d) {
                  a.default.secondRange(d[0]), a.default.minuteRange(d[1]), a.default.hourRange(d[2]), a.default.dayOfMonthRange(d[3]), a.default.monthRange(d[4], this.monthStartIndexZero), a.default.dayOfWeekRange(d[5], this.dayOfWeekStartIndexZero);
                }, f.prototype.assertNoInvalidCharacters = function(d, p) {
                  var h = p.match(/[A-KM-VX-Z]+/gi);
                  if (h && h.length)
                    throw new Error("".concat(d, " part contains invalid values: '").concat(h.toString(), "'"));
                }, f;
              }();
              l.CronParser = u;
            }
          ),
          /***/
          728: (
            /***/
            (s, l, c) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ExpressionDescriptor = void 0;
              var a = c(910), u = c(794), f = function() {
                function d(p, h) {
                  if (this.expression = p, this.options = h, this.expressionParts = new Array(5), !this.options.locale && d.defaultLocale && (this.options.locale = d.defaultLocale), !d.locales[this.options.locale]) {
                    var m = Object.keys(d.locales)[0];
                    console.warn("Locale '".concat(this.options.locale, "' could not be found; falling back to '").concat(m, "'.")), this.options.locale = m;
                  }
                  this.i18n = d.locales[this.options.locale], h.use24HourTimeFormat === void 0 && (h.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault());
                }
                return d.toString = function(p, h) {
                  var m = h === void 0 ? {} : h, v = m.throwExceptionOnParseError, b = v === void 0 ? !0 : v, A = m.verbose, w = A === void 0 ? !1 : A, O = m.dayOfWeekStartIndexZero, x = O === void 0 ? !0 : O, S = m.monthStartIndexZero, E = S === void 0 ? !1 : S, k = m.use24HourTimeFormat, T = m.locale, R = T === void 0 ? null : T, j = m.tzOffset, F = j === void 0 ? 0 : j, L = {
                    throwExceptionOnParseError: b,
                    verbose: w,
                    dayOfWeekStartIndexZero: x,
                    monthStartIndexZero: E,
                    use24HourTimeFormat: k,
                    locale: R,
                    tzOffset: F
                  }, _ = new d(p, L);
                  return _.getFullDescription();
                }, d.initialize = function(p, h) {
                  h === void 0 && (h = "en"), d.specialCharacters = ["/", "-", ",", "*"], d.defaultLocale = h, p.load(d.locales);
                }, d.prototype.getFullDescription = function() {
                  var p = "";
                  try {
                    var h = new u.CronParser(this.expression, this.options.dayOfWeekStartIndexZero, this.options.monthStartIndexZero);
                    this.expressionParts = h.parse();
                    var m = this.getTimeOfDayDescription(), v = this.getDayOfMonthDescription(), b = this.getMonthDescription(), A = this.getDayOfWeekDescription(), w = this.getYearDescription();
                    p += m + v + A + b + w, p = this.transformVerbosity(p, !!this.options.verbose), p = p.charAt(0).toLocaleUpperCase() + p.substr(1);
                  } catch (O) {
                    if (!this.options.throwExceptionOnParseError)
                      p = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
                    else
                      throw "".concat(O);
                  }
                  return p;
                }, d.prototype.getTimeOfDayDescription = function() {
                  var p = this.expressionParts[0], h = this.expressionParts[1], m = this.expressionParts[2], v = "";
                  if (!a.StringUtilities.containsAny(h, d.specialCharacters) && !a.StringUtilities.containsAny(m, d.specialCharacters) && !a.StringUtilities.containsAny(p, d.specialCharacters))
                    v += this.i18n.atSpace() + this.formatTime(m, h, p);
                  else if (!p && h.indexOf("-") > -1 && !(h.indexOf(",") > -1) && !(h.indexOf("/") > -1) && !a.StringUtilities.containsAny(m, d.specialCharacters)) {
                    var b = h.split("-");
                    v += a.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(m, b[0], ""), this.formatTime(m, b[1], ""));
                  } else if (!p && m.indexOf(",") > -1 && m.indexOf("-") == -1 && m.indexOf("/") == -1 && !a.StringUtilities.containsAny(h, d.specialCharacters)) {
                    var A = m.split(",");
                    v += this.i18n.at();
                    for (var w = 0; w < A.length; w++)
                      v += " ", v += this.formatTime(A[w], h, ""), w < A.length - 2 && (v += ","), w == A.length - 2 && (v += this.i18n.spaceAnd());
                  } else {
                    var O = this.getSecondsDescription(), x = this.getMinutesDescription(), S = this.getHoursDescription();
                    if (v += O, v && x && (v += ", "), v += x, x === S)
                      return v;
                    v && S && (v += ", "), v += S;
                  }
                  return v;
                }, d.prototype.getSecondsDescription = function() {
                  var p = this, h = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function(m) {
                    return m;
                  }, function(m) {
                    return a.StringUtilities.format(p.i18n.everyX0Seconds(m), m);
                  }, function(m) {
                    return p.i18n.secondsX0ThroughX1PastTheMinute();
                  }, function(m) {
                    return m == "0" ? "" : parseInt(m) < 20 ? p.i18n.atX0SecondsPastTheMinute(m) : p.i18n.atX0SecondsPastTheMinuteGt20() || p.i18n.atX0SecondsPastTheMinute(m);
                  });
                  return h;
                }, d.prototype.getMinutesDescription = function() {
                  var p = this, h = this.expressionParts[0], m = this.expressionParts[2], v = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function(b) {
                    return b;
                  }, function(b) {
                    return a.StringUtilities.format(p.i18n.everyX0Minutes(b), b);
                  }, function(b) {
                    return p.i18n.minutesX0ThroughX1PastTheHour();
                  }, function(b) {
                    try {
                      return b == "0" && m.indexOf("/") == -1 && h == "" ? p.i18n.everyHour() : parseInt(b) < 20 ? p.i18n.atX0MinutesPastTheHour(b) : p.i18n.atX0MinutesPastTheHourGt20() || p.i18n.atX0MinutesPastTheHour(b);
                    } catch {
                      return p.i18n.atX0MinutesPastTheHour(b);
                    }
                  });
                  return v;
                }, d.prototype.getHoursDescription = function() {
                  var p = this, h = this.expressionParts[2], m = this.getSegmentDescription(h, this.i18n.everyHour(), function(A) {
                    return p.formatTime(A, "0", "");
                  }, function(A) {
                    return a.StringUtilities.format(p.i18n.everyX0Hours(A), A);
                  }, function(A) {
                    return p.i18n.betweenX0AndX1();
                  }, function(A) {
                    return p.i18n.atX0();
                  });
                  if (m && h.includes("-") && this.expressionParts[1] != "0") {
                    var v = Array.from(m.matchAll(/:00/g));
                    if (v.length > 1) {
                      var b = v[v.length - 1].index;
                      m = m.substring(0, b) + ":59" + m.substring(b + 3);
                    }
                  }
                  return m;
                }, d.prototype.getDayOfWeekDescription = function() {
                  var p = this, h = this.i18n.daysOfTheWeek(), m = null;
                  return this.expressionParts[5] == "*" ? m = "" : m = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function(v, b) {
                    var A = v;
                    v.indexOf("#") > -1 ? A = v.substring(0, v.indexOf("#")) : v.indexOf("L") > -1 && (A = A.replace("L", ""));
                    var w = p.i18n.daysOfTheWeekInCase ? p.i18n.daysOfTheWeekInCase(b)[parseInt(A)] : h[parseInt(A)];
                    if (v.indexOf("#") > -1) {
                      var O = null, x = v.substring(v.indexOf("#") + 1), S = v.substring(0, v.indexOf("#"));
                      switch (x) {
                        case "1":
                          O = p.i18n.first(S);
                          break;
                        case "2":
                          O = p.i18n.second(S);
                          break;
                        case "3":
                          O = p.i18n.third(S);
                          break;
                        case "4":
                          O = p.i18n.fourth(S);
                          break;
                        case "5":
                          O = p.i18n.fifth(S);
                          break;
                      }
                      w = O + " " + w;
                    }
                    return w;
                  }, function(v) {
                    return parseInt(v) == 1 ? "" : a.StringUtilities.format(p.i18n.commaEveryX0DaysOfTheWeek(v), v);
                  }, function(v) {
                    var b = v.substring(0, v.indexOf("-")), A = p.expressionParts[3] != "*";
                    return A ? p.i18n.commaAndX0ThroughX1(b) : p.i18n.commaX0ThroughX1(b);
                  }, function(v) {
                    var b = null;
                    if (v.indexOf("#") > -1) {
                      var A = v.substring(v.indexOf("#") + 1);
                      b = p.i18n.commaOnThe(A).trim() + p.i18n.spaceX0OfTheMonth();
                    } else if (v.indexOf("L") > -1)
                      b = p.i18n.commaOnTheLastX0OfTheMonth(v.replace("L", ""));
                    else {
                      var w = p.expressionParts[3] != "*";
                      b = w ? p.i18n.commaAndOnX0() : p.i18n.commaOnlyOnX0(v);
                    }
                    return b;
                  }), m;
                }, d.prototype.getMonthDescription = function() {
                  var p = this, h = this.i18n.monthsOfTheYear(), m = this.getSegmentDescription(this.expressionParts[4], "", function(v, b) {
                    return b && p.i18n.monthsOfTheYearInCase ? p.i18n.monthsOfTheYearInCase(b)[parseInt(v) - 1] : h[parseInt(v) - 1];
                  }, function(v) {
                    return parseInt(v) == 1 ? "" : a.StringUtilities.format(p.i18n.commaEveryX0Months(v), v);
                  }, function(v) {
                    return p.i18n.commaMonthX0ThroughMonthX1() || p.i18n.commaX0ThroughX1();
                  }, function(v) {
                    return p.i18n.commaOnlyInMonthX0 ? p.i18n.commaOnlyInMonthX0() : p.i18n.commaOnlyInX0();
                  });
                  return m;
                }, d.prototype.getDayOfMonthDescription = function() {
                  var p = this, h = null, m = this.expressionParts[3];
                  switch (m) {
                    case "L":
                      h = this.i18n.commaOnTheLastDayOfTheMonth();
                      break;
                    case "WL":
                    case "LW":
                      h = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                      break;
                    default:
                      var v = m.match(/(\d{1,2}W)|(W\d{1,2})/);
                      if (v) {
                        var b = parseInt(v[0].replace("W", "")), A = b == 1 ? this.i18n.firstWeekday() : a.StringUtilities.format(this.i18n.weekdayNearestDayX0(), b.toString());
                        h = a.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), A);
                        break;
                      } else {
                        var w = m.match(/L-(\d{1,2})/);
                        if (w) {
                          var O = w[1];
                          h = a.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(O), O);
                          break;
                        } else {
                          if (m == "*" && this.expressionParts[5] != "*")
                            return "";
                          h = this.getSegmentDescription(m, this.i18n.commaEveryDay(), function(x) {
                            return x == "L" ? p.i18n.lastDay() : p.i18n.dayX0 ? a.StringUtilities.format(p.i18n.dayX0(), x) : x;
                          }, function(x) {
                            return x == "1" ? p.i18n.commaEveryDay() : p.i18n.commaEveryX0Days(x);
                          }, function(x) {
                            return p.i18n.commaBetweenDayX0AndX1OfTheMonth(x);
                          }, function(x) {
                            return p.i18n.commaOnDayX0OfTheMonth(x);
                          });
                        }
                        break;
                      }
                  }
                  return h;
                }, d.prototype.getYearDescription = function() {
                  var p = this, h = this.getSegmentDescription(this.expressionParts[6], "", function(m) {
                    return /^\d+$/.test(m) ? new Date(parseInt(m), 1).getFullYear().toString() : m;
                  }, function(m) {
                    return a.StringUtilities.format(p.i18n.commaEveryX0Years(m), m);
                  }, function(m) {
                    return p.i18n.commaYearX0ThroughYearX1() || p.i18n.commaX0ThroughX1();
                  }, function(m) {
                    return p.i18n.commaOnlyInYearX0 ? p.i18n.commaOnlyInYearX0() : p.i18n.commaOnlyInX0();
                  });
                  return h;
                }, d.prototype.getSegmentDescription = function(p, h, m, v, b, A) {
                  var w = null, O = p.indexOf("/") > -1, x = p.indexOf("-") > -1, S = p.indexOf(",") > -1;
                  if (!p)
                    w = "";
                  else if (p === "*")
                    w = h;
                  else if (!O && !x && !S)
                    w = a.StringUtilities.format(A(p), m(p));
                  else if (S) {
                    for (var E = p.split(","), k = "", T = 0; T < E.length; T++)
                      if (T > 0 && E.length > 2 && (k += ",", T < E.length - 1 && (k += " ")), T > 0 && E.length > 1 && (T == E.length - 1 || E.length == 2) && (k += "".concat(this.i18n.spaceAnd(), " ")), E[T].indexOf("/") > -1 || E[T].indexOf("-") > -1) {
                        var R = E[T].indexOf("-") > -1 && E[T].indexOf("/") == -1, j = this.getSegmentDescription(E[T], h, m, v, R ? this.i18n.commaX0ThroughX1 : b, A);
                        R && (j = j.replace(", ", "")), k += j;
                      } else O ? k += this.getSegmentDescription(E[T], h, m, v, b, A) : k += m(E[T]);
                    O ? w = k : w = a.StringUtilities.format(A(p), k);
                  } else if (O) {
                    var E = p.split("/");
                    if (w = a.StringUtilities.format(v(E[1]), E[1]), E[0].indexOf("-") > -1) {
                      var F = this.generateRangeSegmentDescription(E[0], b, m);
                      F.indexOf(", ") != 0 && (w += ", "), w += F;
                    } else if (E[0].indexOf("*") == -1) {
                      var L = a.StringUtilities.format(A(E[0]), m(E[0]));
                      L = L.replace(", ", ""), w += a.StringUtilities.format(this.i18n.commaStartingX0(), L);
                    }
                  } else x && (w = this.generateRangeSegmentDescription(p, b, m));
                  return w;
                }, d.prototype.generateRangeSegmentDescription = function(p, h, m) {
                  var v = "", b = p.split("-"), A = m(b[0], 1), w = m(b[1], 2), O = h(p);
                  return v += a.StringUtilities.format(O, A, w), v;
                }, d.prototype.formatTime = function(p, h, m) {
                  var v = parseInt(p) + (this.options.tzOffset ? this.options.tzOffset : 0);
                  v >= 24 ? v = v - 24 : v < 0 && (v = 24 + v);
                  var b = "", A = !1;
                  this.options.use24HourTimeFormat || (A = !!(this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime()), b = A ? "".concat(this.getPeriod(v), " ") : " ".concat(this.getPeriod(v)), v > 12 && (v -= 12), v === 0 && (v = 12));
                  var w = h, O = "";
                  return m && (O = ":".concat(("00" + m).substring(m.length))), "".concat(A ? b : "").concat(("00" + v.toString()).substring(v.toString().length), ":").concat(("00" + w.toString()).substring(w.toString().length)).concat(O).concat(A ? "" : b);
                }, d.prototype.transformVerbosity = function(p, h) {
                  return h || (p = p.replace(new RegExp(", ".concat(this.i18n.everyMinute()), "g"), ""), p = p.replace(new RegExp(", ".concat(this.i18n.everyHour()), "g"), ""), p = p.replace(new RegExp(this.i18n.commaEveryDay(), "g"), ""), p = p.replace(/\, ?$/, "")), p;
                }, d.prototype.getPeriod = function(p) {
                  return p >= 12 ? this.i18n.pm && this.i18n.pm() || "PM" : this.i18n.am && this.i18n.am() || "AM";
                }, d.locales = {}, d;
              }();
              l.ExpressionDescriptor = f;
            }
          ),
          /***/
          980: (
            /***/
            (s, l, c) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.my = l.vi = l.ar = l.th = l.af = l.hu = l.be = l.ca = l.fa = l.sw = l.sl = l.fi = l.sk = l.cs = l.he = l.ja = l.zh_TW = l.zh_CN = l.uk = l.tr = l.ru = l.ro = l.pt_PT = l.pt_BR = l.pl = l.sv = l.nb = l.nl = l.ko = l.id = l.it = l.fr = l.es = l.de = l.da = l.en = void 0;
              var a = c(751);
              Object.defineProperty(l, "en", { enumerable: !0, get: function() {
                return a.en;
              } });
              var u = c(904);
              Object.defineProperty(l, "da", { enumerable: !0, get: function() {
                return u.da;
              } });
              var f = c(511);
              Object.defineProperty(l, "de", { enumerable: !0, get: function() {
                return f.de;
              } });
              var d = c(470);
              Object.defineProperty(l, "es", { enumerable: !0, get: function() {
                return d.es;
              } });
              var p = c(953);
              Object.defineProperty(l, "fr", { enumerable: !0, get: function() {
                return p.fr;
              } });
              var h = c(128);
              Object.defineProperty(l, "it", { enumerable: !0, get: function() {
                return h.it;
              } });
              var m = c(258);
              Object.defineProperty(l, "id", { enumerable: !0, get: function() {
                return m.id;
              } });
              var v = c(305);
              Object.defineProperty(l, "ko", { enumerable: !0, get: function() {
                return v.ko;
              } });
              var b = c(771);
              Object.defineProperty(l, "nl", { enumerable: !0, get: function() {
                return b.nl;
              } });
              var A = c(869);
              Object.defineProperty(l, "nb", { enumerable: !0, get: function() {
                return A.nb;
              } });
              var w = c(673);
              Object.defineProperty(l, "sv", { enumerable: !0, get: function() {
                return w.sv;
              } });
              var O = c(665);
              Object.defineProperty(l, "pl", { enumerable: !0, get: function() {
                return O.pl;
              } });
              var x = c(461);
              Object.defineProperty(l, "pt_BR", { enumerable: !0, get: function() {
                return x.pt_BR;
              } });
              var S = c(713);
              Object.defineProperty(l, "pt_PT", { enumerable: !0, get: function() {
                return S.pt_PT;
              } });
              var E = c(408);
              Object.defineProperty(l, "ro", { enumerable: !0, get: function() {
                return E.ro;
              } });
              var k = c(392);
              Object.defineProperty(l, "ru", { enumerable: !0, get: function() {
                return k.ru;
              } });
              var T = c(999);
              Object.defineProperty(l, "tr", { enumerable: !0, get: function() {
                return T.tr;
              } });
              var R = c(716);
              Object.defineProperty(l, "uk", { enumerable: !0, get: function() {
                return R.uk;
              } });
              var j = c(419);
              Object.defineProperty(l, "zh_CN", { enumerable: !0, get: function() {
                return j.zh_CN;
              } });
              var F = c(139);
              Object.defineProperty(l, "zh_TW", { enumerable: !0, get: function() {
                return F.zh_TW;
              } });
              var L = c(949);
              Object.defineProperty(l, "ja", { enumerable: !0, get: function() {
                return L.ja;
              } });
              var _ = c(389);
              Object.defineProperty(l, "he", { enumerable: !0, get: function() {
                return _.he;
              } });
              var U = c(674);
              Object.defineProperty(l, "cs", { enumerable: !0, get: function() {
                return U.cs;
              } });
              var z = c(203);
              Object.defineProperty(l, "sk", { enumerable: !0, get: function() {
                return z.sk;
              } });
              var C = c(578);
              Object.defineProperty(l, "fi", { enumerable: !0, get: function() {
                return C.fi;
              } });
              var I = c(738);
              Object.defineProperty(l, "sl", { enumerable: !0, get: function() {
                return I.sl;
              } });
              var M = c(286);
              Object.defineProperty(l, "sw", { enumerable: !0, get: function() {
                return M.sw;
              } });
              var D = c(384);
              Object.defineProperty(l, "fa", { enumerable: !0, get: function() {
                return D.fa;
              } });
              var X = c(708);
              Object.defineProperty(l, "ca", { enumerable: !0, get: function() {
                return X.ca;
              } });
              var B = c(445);
              Object.defineProperty(l, "be", { enumerable: !0, get: function() {
                return B.be;
              } });
              var q = c(560);
              Object.defineProperty(l, "hu", { enumerable: !0, get: function() {
                return q.hu;
              } });
              var H = c(675);
              Object.defineProperty(l, "af", { enumerable: !0, get: function() {
                return H.af;
              } });
              var Y = c(312);
              Object.defineProperty(l, "th", { enumerable: !0, get: function() {
                return Y.th;
              } });
              var J = c(935);
              Object.defineProperty(l, "ar", { enumerable: !0, get: function() {
                return J.ar;
              } });
              var oe = c(533);
              Object.defineProperty(l, "vi", { enumerable: !0, get: function() {
                return oe.vi;
              } });
              var ce = c(863);
              Object.defineProperty(l, "my", { enumerable: !0, get: function() {
                return ce.my;
              } });
            }
          ),
          /***/
          282: (
            /***/
            (s, l, c) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.allLocalesLoader = void 0;
              var a = c(980), u = function() {
                function f() {
                }
                return f.prototype.load = function(d) {
                  for (var p in a)
                    a.hasOwnProperty(p) && (d[p] = new a[p]());
                }, f;
              }();
              l.allLocalesLoader = u;
            }
          ),
          /***/
          675: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.af = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", jaar %s na %s";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Daar was 'n fout om die tydsuitdrukking the genereer. Raadpleeg asb die uitdrukking formaat.";
                }, a.prototype.everyMinute = function() {
                  return "elke minuut";
                }, a.prototype.everyHour = function() {
                  return "elke uur";
                }, a.prototype.atSpace = function() {
                  return "Teen ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Elke minuut tussen %s en %s";
                }, a.prototype.at = function() {
                  return "Teen";
                }, a.prototype.spaceAnd = function() {
                  return " en";
                }, a.prototype.everySecond = function() {
                  return "elke sekonde";
                }, a.prototype.everyX0Seconds = function() {
                  return "elke %s sekonde";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekonde %s deur na %s na die minuut";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "teen %s sekondes na die minuut";
                }, a.prototype.everyX0Minutes = function() {
                  return "elke %s minute";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute %s deur na %s na die uur";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "teen %s minute na die uur";
                }, a.prototype.everyX0Hours = function() {
                  return "elke %s ure";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tussen %s en %s";
                }, a.prototype.atX0 = function() {
                  return "teen %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", elke dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", elke %s dae van die week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s deur na %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", en %s deur na %s";
                }, a.prototype.first = function() {
                  return "eerste";
                }, a.prototype.second = function() {
                  return "tweede";
                }, a.prototype.third = function() {
                  return "derde";
                }, a.prototype.fourth = function() {
                  return "vierde";
                }, a.prototype.fifth = function() {
                  return "vyfde";
                }, a.prototype.commaOnThe = function() {
                  return ", op die ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s van die maand";
                }, a.prototype.lastDay = function() {
                  return "die laaste dag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", op die laaste %s van die maand";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", net op %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", en op %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", elke %s maande";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", net in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", op die laaste dag van die maand";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", op die laaste weeksdag van die maand";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dae voor die laaste dag van die maand";
                }, a.prototype.firstWeekday = function() {
                  return "eerste weeksdag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "weeksdag naaste aan dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", op die %s van die maande";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", elke %s dae";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tussen dag %s en %s van die maand";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", op dag %s van die maand";
                }, a.prototype.commaEveryHour = function() {
                  return ", elke uur";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", elke %s jare";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnende %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januarie",
                    "Februarie",
                    "Maart",
                    "April",
                    "Mei",
                    "Junie",
                    "Julie",
                    "Augustus",
                    "September",
                    "Oktober",
                    "November",
                    "Desember"
                  ];
                }, a;
              }();
              l.af = c;
            }
          ),
          /***/
          935: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ar = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "حدث خطأ في إنشاء وصف المصطلح٠ تأكد من تركيب مصطلح الكرون";
                }, a.prototype.everyMinute = function() {
                  return "كل دقيقة";
                }, a.prototype.everyHour = function() {
                  return "كل ساعة";
                }, a.prototype.atSpace = function() {
                  return " ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "كل دقيقة بين %s و %s";
                }, a.prototype.at = function() {
                  return "";
                }, a.prototype.spaceAnd = function() {
                  return " و";
                }, a.prototype.everySecond = function() {
                  return "كل ثانية";
                }, a.prototype.everyX0Seconds = function() {
                  return "كل %s ثواني";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "الثواني %s حتى %s من بداية الدقيقة";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "الثانية %s من بداية الدقيقة";
                }, a.prototype.everyX0Minutes = function() {
                  return "كل %s دقائق";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "الدقائق %s حتى %s من بداية الساعة";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "الدقيقة %s من بداية الساعة";
                }, a.prototype.everyX0Hours = function() {
                  return "كل %s ساعات";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "بين %s و %s";
                }, a.prototype.atX0 = function() {
                  return "%s";
                }, a.prototype.commaEveryDay = function() {
                  return "، كل يوم";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return "، كل %s من أيام الأسبوع";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return "، %s حتى %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return "، و %s حتى %s";
                }, a.prototype.first = function() {
                  return "أول";
                }, a.prototype.second = function() {
                  return "ثاني";
                }, a.prototype.third = function() {
                  return "ثالث";
                }, a.prototype.fourth = function() {
                  return "رابع";
                }, a.prototype.fifth = function() {
                  return "خامس";
                }, a.prototype.commaOnThe = function() {
                  return "، في ال";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s من الشهر";
                }, a.prototype.lastDay = function() {
                  return "اليوم الأخير";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return "، في اخر %s من الشهر";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return "، %s فقط";
                }, a.prototype.commaAndOnX0 = function() {
                  return "، وفي %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return "، كل %s أشهر";
                }, a.prototype.commaOnlyInX0 = function() {
                  return "، %s فقط";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return "، في اخر يوم من الشهر";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return "، في اخر يوم أسبوع من الشهر";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return "، %s أيام قبل اخر يوم من الشهر";
                }, a.prototype.firstWeekday = function() {
                  return "اول ايام الأسبوع";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "يوم الأسبوع الأقرب ليوم %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return "، في %s من الشهر";
                }, a.prototype.commaEveryX0Days = function() {
                  return "، كل %s أيام";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return "، بين يوم %s و %s من الشهر";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return "، في اليوم %s من الشهر";
                }, a.prototype.commaEveryHour = function() {
                  return "، كل ساعة";
                }, a.prototype.commaEveryX0Years = function() {
                  return "، كل %s سنوات";
                }, a.prototype.commaStartingX0 = function() {
                  return "، بداية من %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "يناير",
                    "فبراير",
                    "مارس",
                    "ابريل",
                    "مايو",
                    "يونيو",
                    "يوليو",
                    "أغسطس",
                    "سبتمبر",
                    "أكتوبر",
                    "نوفمبر",
                    "ديسمبر"
                  ];
                }, a;
              }();
              l.ar = c;
            }
          ),
          /***/
          445: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.be = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "кожную хвіліну";
                }, a.prototype.everyHour = function() {
                  return "кожную гадзіну";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Адбылася памылка падчас генерацыі апісання выразы. Праверце сінтаксіс крон-выразы.";
                }, a.prototype.atSpace = function() {
                  return "У ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Кожную хвіліну з %s да %s";
                }, a.prototype.at = function() {
                  return "У";
                }, a.prototype.spaceAnd = function() {
                  return " і";
                }, a.prototype.everySecond = function() {
                  return "кожную секунду";
                }, a.prototype.everyX0Seconds = function() {
                  return "кожныя %s секунд";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "секунды з %s па %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "у %s секунд";
                }, a.prototype.everyX0Minutes = function() {
                  return "кожныя %s хвілін";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "хвіліны з %s па %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "у %s хвілін";
                }, a.prototype.everyX0Hours = function() {
                  return "кожныя %s гадзін";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "з %s па %s";
                }, a.prototype.atX0 = function() {
                  return "у %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", кожны дзень";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", кожныя %s дзён тыдня";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s па %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", і %s па %s";
                }, a.prototype.first = function() {
                  return "першы";
                }, a.prototype.second = function() {
                  return "другі";
                }, a.prototype.third = function() {
                  return "трэці";
                }, a.prototype.fourth = function() {
                  return "чацвёрты";
                }, a.prototype.fifth = function() {
                  return "пяты";
                }, a.prototype.commaOnThe = function() {
                  return ", у ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s месяца";
                }, a.prototype.lastDay = function() {
                  return "апошні дзень";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", у апошні %s месяца";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", толькі ў %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", і ў %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", кожныя %s месяцаў";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", толькі ў %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", у апошні дзень месяца";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", у апошні будні дзень месяца";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s дзён да апошняга дня месяца";
                }, a.prototype.firstWeekday = function() {
                  return "першы будны дзень";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "найбліжэйшы будны дзень да %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", у %s месяцы";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", кожныя %s дзён";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", з %s па %s лік месяца";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", у %s лік месяца";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", кожныя %s гадоў";
                }, a.prototype.commaStartingX0 = function() {
                  return ", пачатак %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["нядзеля", "панядзелак", "аўторак", "серада", "чацвер", "пятніца", "субота"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "студзень",
                    "люты",
                    "сакавік",
                    "красавік",
                    "травень",
                    "чэрвень",
                    "ліпень",
                    "жнівень",
                    "верасень",
                    "кастрычнік",
                    "лістапад",
                    "снежань"
                  ];
                }, a;
              }();
              l.be = c;
            }
          ),
          /***/
          708: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ca = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "S'ha produït un error mentres es generava la descripció de l'expressió. Revisi la sintaxi de la expressió de cron.";
                }, a.prototype.at = function() {
                  return "A les";
                }, a.prototype.atSpace = function() {
                  return "A les ";
                }, a.prototype.atX0 = function() {
                  return "a les %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "als %s minuts de l'hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "als %s segonds del minut";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre les %s i les %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre els dies %s i %s del mes";
                }, a.prototype.commaEveryDay = function() {
                  return ", cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", cada %s dies";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", cada %s dies de la setmana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", cada %s mesos";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", el dia %s del mes";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sólo en %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", només el %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i el %s";
                }, a.prototype.commaOnThe = function() {
                  return ", en el ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", en l'últim dia del mes";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", en l'últim dia de la setmana del mes";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dies abans de l'últim dia del mes";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", en l'últim %s del mes";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", en el %s del mes";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "cada hora";
                }, a.prototype.everyMinute = function() {
                  return "cada minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "cada minut entre les %s i les %s";
                }, a.prototype.everySecond = function() {
                  return "cada segon";
                }, a.prototype.everyX0Hours = function() {
                  return "cada %s hores";
                }, a.prototype.everyX0Minutes = function() {
                  return "cada %s minuts";
                }, a.prototype.everyX0Seconds = function() {
                  return "cada %s segons";
                }, a.prototype.fifth = function() {
                  return "cinquè";
                }, a.prototype.first = function() {
                  return "primer";
                }, a.prototype.firstWeekday = function() {
                  return "primer dia de la setmana";
                }, a.prototype.fourth = function() {
                  return "quart";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "del minut %s al %s passada l'hora";
                }, a.prototype.second = function() {
                  return "segon";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "En els segons %s al %s de cada minut";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mes";
                }, a.prototype.lastDay = function() {
                  return "l'últim dia";
                }, a.prototype.third = function() {
                  return "tercer";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia de la setmana més proper al %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", cada %s anys";
                }, a.prototype.commaStartingX0 = function() {
                  return ", començant %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "gener",
                    "febrer",
                    "març",
                    "abril",
                    "maig",
                    "juny",
                    "juliol",
                    "agost",
                    "setembre",
                    "octubre",
                    "novembre",
                    "desembre"
                  ];
                }, a;
              }();
              l.ca = c;
            }
          ),
          /***/
          674: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.cs = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Při vytváření popisu došlo k chybě. Zkontrolujte prosím správnost syntaxe cronu.";
                }, a.prototype.everyMinute = function() {
                  return "každou minutu";
                }, a.prototype.everyHour = function() {
                  return "každou hodinu";
                }, a.prototype.atSpace = function() {
                  return "V ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Každou minutu mezi %s a %s";
                }, a.prototype.at = function() {
                  return "V";
                }, a.prototype.spaceAnd = function() {
                  return " a";
                }, a.prototype.everySecond = function() {
                  return "každou sekundu";
                }, a.prototype.everyX0Seconds = function() {
                  return "každých %s sekund";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "v %s sekund";
                }, a.prototype.everyX0Minutes = function() {
                  return "každých %s minut";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuty od %s do %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "v %s minut";
                }, a.prototype.everyX0Hours = function() {
                  return "každých %s hodin";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mezi %s a %s";
                }, a.prototype.atX0 = function() {
                  return "v %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", každý den";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", každých %s dní v týdnu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", a od %s do %s";
                }, a.prototype.first = function() {
                  return "první";
                }, a.prototype.second = function() {
                  return "druhý";
                }, a.prototype.third = function() {
                  return "třetí";
                }, a.prototype.fourth = function() {
                  return "čtvrtý";
                }, a.prototype.fifth = function() {
                  return "pátý";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v měsíci";
                }, a.prototype.lastDay = function() {
                  return "poslední den";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", poslední %s v měsíci";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", pouze v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", a v %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", každých %s měsíců";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", pouze v %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", poslední den v měsíci";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", poslední pracovní den v měsíci";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dní před posledním dnem v měsíci";
                }, a.prototype.firstWeekday = function() {
                  return "první pracovní den";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "pracovní den nejblíže %s. dni";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", v %s v měsíci";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", každých %s dnů";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mezi dny %s a %s v měsíci";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. den v měsíci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", každých %s roků";
                }, a.prototype.commaStartingX0 = function() {
                  return ", začínající %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Leden",
                    "Únor",
                    "Březen",
                    "Duben",
                    "Květen",
                    "Červen",
                    "Červenec",
                    "Srpen",
                    "Září",
                    "Říjen",
                    "Listopad",
                    "Prosinec"
                  ];
                }, a;
              }();
              l.cs = c;
            }
          ),
          /***/
          904: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.da = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Der opstod en fejl ved generering af udtryksbeskrivelsen. Tjek cron-ekspressionssyntaxen.";
                }, a.prototype.at = function() {
                  return "kl";
                }, a.prototype.atSpace = function() {
                  return "kl ";
                }, a.prototype.atX0 = function() {
                  return "kl %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minutter efter timeskift";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s sekunder efter minutskift";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellem %s og %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellem dag %s og %s i måneden";
                }, a.prototype.commaEveryDay = function() {
                  return ", hver dag";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", hver %s. dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", hver %s. ugedag";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", hver %s. måned";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", hvert %s. år";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s i måneden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", kun i %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", kun på %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", og på %s";
                }, a.prototype.commaOnThe = function() {
                  return ", på den ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på den sidste dag i måneden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", på den sidste hverdag i måneden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dage før den sidste dag i måneden";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på den sidste %s i måneden";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s i måneden";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s til og med %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", og %s til og med %s";
                }, a.prototype.everyHour = function() {
                  return "hver time";
                }, a.prototype.everyMinute = function() {
                  return "hvert minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "hvert minut mellem %s og %s";
                }, a.prototype.everySecond = function() {
                  return "hvert sekund";
                }, a.prototype.everyX0Hours = function() {
                  return "hver %s. time";
                }, a.prototype.everyX0Minutes = function() {
                  return "hvert %s. minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "hvert %s. sekund";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.first = function() {
                  return "første";
                }, a.prototype.firstWeekday = function() {
                  return "første hverdag";
                }, a.prototype.fourth = function() {
                  return "fjerde";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutterne fra %s til og med %s hver time";
                }, a.prototype.second = function() {
                  return "anden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunderne fra %s til og med %s hvert minut";
                }, a.prototype.spaceAnd = function() {
                  return " og";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s i måneden";
                }, a.prototype.lastDay = function() {
                  return "sidste dag";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hverdag nærmest dag %s";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", startende %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "marts",
                    "april",
                    "maj",
                    "juni",
                    "juli",
                    "august",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              l.da = c;
            }
          ),
          /***/
          511: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.de = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "jede Minute";
                }, a.prototype.everyHour = function() {
                  return "jede Stunde";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Beim Generieren der Ausdrucksbeschreibung ist ein Fehler aufgetreten. Überprüfen Sie die Syntax des Cron-Ausdrucks.";
                }, a.prototype.atSpace = function() {
                  return "Um ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Jede Minute zwischen %s und %s";
                }, a.prototype.at = function() {
                  return "Um";
                }, a.prototype.spaceAnd = function() {
                  return " und";
                }, a.prototype.everySecond = function() {
                  return "Jede Sekunde";
                }, a.prototype.everyX0Seconds = function() {
                  return "alle %s Sekunden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "Sekunden %s bis %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "bei Sekunde %s";
                }, a.prototype.everyX0Minutes = function() {
                  return "alle %s Minuten";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "Minuten %s bis %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "bei Minute %s";
                }, a.prototype.everyX0Hours = function() {
                  return "alle %s Stunden";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "zwischen %s und %s";
                }, a.prototype.atX0 = function() {
                  return "um %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", jeden Tag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", alle %s Tage der Woche";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s bis %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", und %s bis %s";
                }, a.prototype.first = function() {
                  return "ersten";
                }, a.prototype.second = function() {
                  return "zweiten";
                }, a.prototype.third = function() {
                  return "dritten";
                }, a.prototype.fourth = function() {
                  return "vierten";
                }, a.prototype.fifth = function() {
                  return "fünften";
                }, a.prototype.commaOnThe = function() {
                  return ", am ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s des Monats";
                }, a.prototype.lastDay = function() {
                  return "der letzte Tag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", am letzten %s des Monats";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", nur jeden %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", und jeden %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", alle %s Monate";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", nur im %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", am letzten Tag des Monats";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", am letzten Werktag des Monats";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s tage vor dem letzten Tag des Monats";
                }, a.prototype.firstWeekday = function() {
                  return "ersten Werktag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "Werktag am nächsten zum %s Tag";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", am %s des Monats";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", alle %s Tage";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", zwischen Tag %s und %s des Monats";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", an Tag %s des Monats";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", alle %s Jahre";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnend %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                  ];
                }, a;
              }();
              l.de = c;
            }
          ),
          /***/
          751: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.en = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "An error occured when generating the expression description.  Check the cron expression syntax.";
                }, a.prototype.everyMinute = function() {
                  return "every minute";
                }, a.prototype.everyHour = function() {
                  return "every hour";
                }, a.prototype.atSpace = function() {
                  return "At ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Every minute between %s and %s";
                }, a.prototype.at = function() {
                  return "At";
                }, a.prototype.spaceAnd = function() {
                  return " and";
                }, a.prototype.everySecond = function() {
                  return "every second";
                }, a.prototype.everyX0Seconds = function() {
                  return "every %s seconds";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconds %s through %s past the minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "at %s seconds past the minute";
                }, a.prototype.everyX0Minutes = function() {
                  return "every %s minutes";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, a.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "between %s and %s";
                }, a.prototype.atX0 = function() {
                  return "at %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", every day";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", every %s days of the week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s through %s";
                }, a.prototype.first = function() {
                  return "first";
                }, a.prototype.second = function() {
                  return "second";
                }, a.prototype.third = function() {
                  return "third";
                }, a.prototype.fourth = function() {
                  return "fourth";
                }, a.prototype.fifth = function() {
                  return "fifth";
                }, a.prototype.commaOnThe = function() {
                  return ", on the ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s of the month";
                }, a.prototype.lastDay = function() {
                  return "the last day";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", on the last %s of the month";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", only on %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", and on %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", every %s months";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", only in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", on the last day of the month";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", on the last weekday of the month";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s days before the last day of the month";
                }, a.prototype.firstWeekday = function() {
                  return "first weekday";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "weekday nearest day %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", on the %s of the month";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", every %s days";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", between day %s and %s of the month";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", on day %s of the month";
                }, a.prototype.commaEveryHour = function() {
                  return ", every hour";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", every %s years";
                }, a.prototype.commaStartingX0 = function() {
                  return ", starting %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                  ];
                }, a;
              }();
              l.en = c;
            }
          ),
          /***/
          470: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.es = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocurrió un error mientras se generaba la descripción de la expresión. Revise la sintaxis de la expresión de cron.";
                }, a.prototype.at = function() {
                  return "A las";
                }, a.prototype.atSpace = function() {
                  return "A las ";
                }, a.prototype.atX0 = function() {
                  return "a las %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "a los %s minutos de la hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "a los %s segundos del minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre las %s y las %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre los días %s y %s del mes";
                }, a.prototype.commaEveryDay = function() {
                  return ", cada día";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", cada %s días";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", cada %s días de la semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", el día %s del mes";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sólo en %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", sólo el %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", y el %s";
                }, a.prototype.commaOnThe = function() {
                  return ", en el ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", en el último día del mes";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", en el último día de la semana del mes";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s días antes del último día del mes";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", en el último %s del mes";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", en el %s del mes";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", y de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "cada hora";
                }, a.prototype.everyMinute = function() {
                  return "cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "cada minuto entre las %s y las %s";
                }, a.prototype.everySecond = function() {
                  return "cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "cada %s segundos";
                }, a.prototype.fifth = function() {
                  return "quinto";
                }, a.prototype.first = function() {
                  return "primero";
                }, a.prototype.firstWeekday = function() {
                  return "primer día de la semana";
                }, a.prototype.fourth = function() {
                  return "cuarto";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "del minuto %s al %s pasada la hora";
                }, a.prototype.second = function() {
                  return "segundo";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "En los segundos %s al %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " y";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mes";
                }, a.prototype.lastDay = function() {
                  return "el último día";
                }, a.prototype.third = function() {
                  return "tercer";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "día de la semana más próximo al %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", cada %s años";
                }, a.prototype.commaStartingX0 = function() {
                  return ", comenzando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "enero",
                    "febrero",
                    "marzo",
                    "abril",
                    "mayo",
                    "junio",
                    "julio",
                    "agosto",
                    "septiembre",
                    "octubre",
                    "noviembre",
                    "diciembre"
                  ];
                }, a;
              }();
              l.es = c;
            }
          ),
          /***/
          384: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.fa = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "خطایی در نمایش توضیحات این وظیفه رخ داد. لطفا ساختار آن را بررسی کنید.";
                }, a.prototype.everyMinute = function() {
                  return "هر دقیقه";
                }, a.prototype.everyHour = function() {
                  return "هر ساعت";
                }, a.prototype.atSpace = function() {
                  return "در ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "هر دقیقه بین %s و %s";
                }, a.prototype.at = function() {
                  return "در";
                }, a.prototype.spaceAnd = function() {
                  return " و";
                }, a.prototype.everySecond = function() {
                  return "هر ثانیه";
                }, a.prototype.everyX0Seconds = function() {
                  return "هر %s ثانیه";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "ثانیه %s تا %s دقیقه گذشته";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "در %s قانیه از دقیقه گذشته";
                }, a.prototype.everyX0Minutes = function() {
                  return "هر %s دقیقه";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "دقیقه %s تا %s ساعت گذشته";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "در %s دقیقه پس از ساعت";
                }, a.prototype.everyX0Hours = function() {
                  return "هر %s ساعت";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "بین %s و %s";
                }, a.prototype.atX0 = function() {
                  return "در %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", هر روز";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", هر %s روز از هفته";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s تا %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", و %s تا %s";
                }, a.prototype.first = function() {
                  return "اول";
                }, a.prototype.second = function() {
                  return "دوم";
                }, a.prototype.third = function() {
                  return "سوم";
                }, a.prototype.fourth = function() {
                  return "چهارم";
                }, a.prototype.fifth = function() {
                  return "پنجم";
                }, a.prototype.commaOnThe = function() {
                  return ", در ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s ماه";
                }, a.prototype.lastDay = function() {
                  return "آخرین روز";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", فقط در %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", و در %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", هر %s ماه";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", فقط در %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", در آخرین روز ماه";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", در آخرین روز ماه";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s روز قبل از آخرین روز ماه";
                }, a.prototype.firstWeekday = function() {
                  return "اولین روز";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "روز نزدیک به روز %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", هر %s روز";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", بین روز %s و %s ماه";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", در %s ماه";
                }, a.prototype.commaEveryMinute = function() {
                  return ", هر minute";
                }, a.prototype.commaEveryHour = function() {
                  return ", هر ساعت";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", هر %s سال";
                }, a.prototype.commaStartingX0 = function() {
                  return ", آغاز %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["ژانویه", "فوریه", "مارس", "آپریل", "مه", "ژوئن", "ژوئیه", "آگوست", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"];
                }, a;
              }();
              l.fa = c;
            }
          ),
          /***/
          578: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.fi = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Virhe kuvauksen generoinnissa. Tarkista cron-syntaksi.";
                }, a.prototype.at = function() {
                  return "Klo";
                }, a.prototype.atSpace = function() {
                  return "Klo ";
                }, a.prototype.atX0 = function() {
                  return "klo %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minuuttia yli";
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return "%s minuuttia yli";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s sekunnnin jälkeen";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s - %s välillä";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", kuukauden päivien %s ja %s välillä";
                }, a.prototype.commaEveryDay = function() {
                  return ", joka päivä";
                }, a.prototype.commaEveryHour = function() {
                  return ", joka tunti";
                }, a.prototype.commaEveryMinute = function() {
                  return ", joka minuutti";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", joka %s. päivä";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", joka %s. viikonpäivä";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", joka %s. kuukausi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", joka %s. vuosi";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", kuukauden %s päivä";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", vain %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", vain %s";
                }, a.prototype.commaOnThe = function() {
                  return ",";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", kuukauden viimeisenä päivänä";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", kuukauden viimeisenä viikonpäivänä";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", kuukauden viimeinen %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", kuukauden %s";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s päivää ennen kuukauden viimeistä päivää";
                }, a.prototype.commaStartingX0 = function() {
                  return ", alkaen %s";
                }, a.prototype.everyHour = function() {
                  return "joka tunti";
                }, a.prototype.everyMinute = function() {
                  return "joka minuutti";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "joka minuutti %s - %s välillä";
                }, a.prototype.everySecond = function() {
                  return "joka sekunti";
                }, a.prototype.everyX0Hours = function() {
                  return "joka %s. tunti";
                }, a.prototype.everyX0Minutes = function() {
                  return "joka %s. minuutti";
                }, a.prototype.everyX0Seconds = function() {
                  return "joka %s. sekunti";
                }, a.prototype.fifth = function() {
                  return "viides";
                }, a.prototype.first = function() {
                  return "ensimmäinen";
                }, a.prototype.firstWeekday = function() {
                  return "ensimmäinen viikonpäivä";
                }, a.prototype.fourth = function() {
                  return "neljäs";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "joka tunti minuuttien %s - %s välillä";
                }, a.prototype.second = function() {
                  return "toinen";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "joka minuutti sekunttien %s - %s välillä";
                }, a.prototype.spaceAnd = function() {
                  return " ja";
                }, a.prototype.spaceAndSpace = function() {
                  return " ja ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s kuukaudessa";
                }, a.prototype.third = function() {
                  return "kolmas";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "viikonpäivä lähintä %s päivää";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.lastDay = function() {
                  return "viimeinen päivä";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", ja edelleen %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "tammikuu",
                    "helmikuu",
                    "maaliskuu",
                    "huhtikuu",
                    "toukokuu",
                    "kesäkuu",
                    "heinäkuu",
                    "elokuu",
                    "syyskuu",
                    "lokakuu",
                    "marraskuu",
                    "joulukuu"
                  ];
                }, a;
              }();
              l.fi = c;
            }
          ),
          /***/
          953: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.fr = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "toutes les minutes";
                }, a.prototype.everyHour = function() {
                  return "toutes les heures";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Une erreur est survenue en générant la description de l'expression cron. Vérifiez sa syntaxe.";
                }, a.prototype.atSpace = function() {
                  return "À ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Toutes les minutes entre %s et %s";
                }, a.prototype.at = function() {
                  return "À";
                }, a.prototype.spaceAnd = function() {
                  return " et";
                }, a.prototype.everySecond = function() {
                  return "toutes les secondes";
                }, a.prototype.everyX0Seconds = function() {
                  return "toutes les %s secondes";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "les secondes entre %s et %s après la minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s secondes après la minute";
                }, a.prototype.everyX0Minutes = function() {
                  return "toutes les %s minutes";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "les minutes entre %s et %s après l'heure";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s minutes après l'heure";
                }, a.prototype.everyX0Hours = function() {
                  return "toutes les %s heures";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "de %s à %s";
                }, a.prototype.atX0 = function() {
                  return "à %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", tous les jours";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", tous les %s jours de la semaine";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s à %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", et de %s à %s";
                }, a.prototype.first = function() {
                  return "premier";
                }, a.prototype.second = function() {
                  return "second";
                }, a.prototype.third = function() {
                  return "troisième";
                }, a.prototype.fourth = function() {
                  return "quatrième";
                }, a.prototype.fifth = function() {
                  return "cinquième";
                }, a.prototype.commaOnThe = function() {
                  return ", le ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s du mois";
                }, a.prototype.lastDay = function() {
                  return "le dernier jour";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", le dernier %s du mois";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", uniquement le %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", et %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", tous les %s mois";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", uniquement en %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", le dernier jour du mois";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", le dernier jour ouvrable du mois";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s jours avant le dernier jour du mois";
                }, a.prototype.firstWeekday = function() {
                  return "premier jour ouvrable";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "jour ouvrable le plus proche du %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", le %s du mois";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", tous les %s jours";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", du %s au %s du mois";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", le %s du mois";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", tous les %s ans";
                }, a.prototype.commaDaysX0ThroughX1 = function() {
                  return ", du %s au %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", à partir de %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janvier",
                    "février",
                    "mars",
                    "avril",
                    "mai",
                    "juin",
                    "juillet",
                    "août",
                    "septembre",
                    "octobre",
                    "novembre",
                    "décembre"
                  ];
                }, a;
              }();
              l.fr = c;
            }
          ),
          /***/
          389: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.he = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "אירעה שגיאה בעת יצירת תיאור הביטוי. בדוק את תחביר הביטוי cron.";
                }, a.prototype.everyMinute = function() {
                  return "כל דקה";
                }, a.prototype.everyHour = function() {
                  return "כל שעה";
                }, a.prototype.atSpace = function() {
                  return "ב ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "כל דקה %s עד %s";
                }, a.prototype.at = function() {
                  return "ב";
                }, a.prototype.spaceAnd = function() {
                  return " ו";
                }, a.prototype.everySecond = function() {
                  return "כל שניה";
                }, a.prototype.everyX0Seconds = function() {
                  return "כל %s שניות";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "%s עד %s שניות של הדקה";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "ב %s שניות של הדקה";
                }, a.prototype.everyX0Minutes = function() {
                  return "כל %s דקות";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "%s עד %s דקות של השעה";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "ב %s דקות של השעה";
                }, a.prototype.everyX0Hours = function() {
                  return "כל %s שעות";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s עד %s";
                }, a.prototype.atX0 = function() {
                  return "ב %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", כל יום";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", כל %s ימים בשבוע";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s עד %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", ו %s עד %s";
                }, a.prototype.first = function() {
                  return "ראשון";
                }, a.prototype.second = function() {
                  return "שני";
                }, a.prototype.third = function() {
                  return "שלישי";
                }, a.prototype.fourth = function() {
                  return "רביעי";
                }, a.prototype.fifth = function() {
                  return "חמישי";
                }, a.prototype.commaOnThe = function() {
                  return ", ב ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s של החודש";
                }, a.prototype.lastDay = function() {
                  return "היום האחרון";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", רק ב %s של החודש";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", רק ב %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", וב %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", כל %s חודשים";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", רק ב %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ביום האחרון של החודש";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ביום החול האחרון של החודש";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ימים לפני היום האחרון בחודש";
                }, a.prototype.firstWeekday = function() {
                  return "יום החול הראשון";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "יום החול הראשון הקרוב אל %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ביום ה%s של החודש";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", כל %s ימים";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", בין היום ה%s וה%s של החודש";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ביום ה%s של החודש";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", כל %s שנים";
                }, a.prototype.commaStartingX0 = function() {
                  return ", החל מ %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["יום ראשון", "יום שני", "יום שלישי", "יום רביעי", "יום חמישי", "יום שישי", "יום שבת"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
                }, a;
              }();
              l.he = c;
            }
          ),
          /***/
          560: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.hu = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Hiba történt a kifejezésleírás generálásakor. Ellenőrizze a cron kifejezés szintaxisát.";
                }, a.prototype.everyMinute = function() {
                  return "minden percben";
                }, a.prototype.everyHour = function() {
                  return "minden órában";
                }, a.prototype.atSpace = function() {
                  return "Ekkor: ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "percenként %s és %s között";
                }, a.prototype.at = function() {
                  return "Ekkor:";
                }, a.prototype.spaceAnd = function() {
                  return " és";
                }, a.prototype.everySecond = function() {
                  return "minden másodpercben";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s másodpercenként";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "%s. másodpercben %s perc után";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "%s. másodpercben";
                }, a.prototype.everyX0Minutes = function() {
                  return "minden %s. percben";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "%s. percben %s óra után";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "%s. percben";
                }, a.prototype.everyX0Hours = function() {
                  return "minden %s órában";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s és %s között";
                }, a.prototype.atX0 = function() {
                  return "ekkor %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", minden nap";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a hét minden %s napján";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s - %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", és %s - %s";
                }, a.prototype.first = function() {
                  return "első";
                }, a.prototype.second = function() {
                  return "második";
                }, a.prototype.third = function() {
                  return "harmadik";
                }, a.prototype.fourth = function() {
                  return "negyedik";
                }, a.prototype.fifth = function() {
                  return "ötödik";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s a hónapban";
                }, a.prototype.lastDay = function() {
                  return "az utolsó nap";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", a hónap utolsó %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", csak ekkor: %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", és %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", minden %s hónapban";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", csak ekkor: %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", a hónap utolsó napján";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", a hónap utolsó hétköznapján";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s nappal a hónap utolsó napja előtt";
                }, a.prototype.firstWeekday = function() {
                  return "első hétköznap";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hétköznap legközelebbi nap %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", a hónap %s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s naponként";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", a hónap %s és %s napja között";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", a hónap %s napján";
                }, a.prototype.commaEveryHour = function() {
                  return ", minden órában";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s évente";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s kezdettel";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "január",
                    "február",
                    "március",
                    "április",
                    "május",
                    "június",
                    "július",
                    "augusztus",
                    "szeptember",
                    "október",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              l.hu = c;
            }
          ),
          /***/
          258: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.id = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Terjadi kesalahan saat membuat deskripsi ekspresi. Periksa sintaks ekspresi cron.";
                }, a.prototype.everyMinute = function() {
                  return "setiap menit";
                }, a.prototype.everyHour = function() {
                  return "setiap jam";
                }, a.prototype.atSpace = function() {
                  return "Pada ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Setiap menit diantara %s dan %s";
                }, a.prototype.at = function() {
                  return "Pada";
                }, a.prototype.spaceAnd = function() {
                  return " dan";
                }, a.prototype.everySecond = function() {
                  return "setiap detik";
                }, a.prototype.everyX0Seconds = function() {
                  return "setiap %s detik";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "detik ke %s sampai %s melewati menit";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "pada %s detik lewat satu menit";
                }, a.prototype.everyX0Minutes = function() {
                  return "setiap %s menit";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "menit ke %s sampai %s melewati jam";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "pada %s menit melewati jam";
                }, a.prototype.everyX0Hours = function() {
                  return "setiap %s jam";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "diantara %s dan %s";
                }, a.prototype.atX0 = function() {
                  return "pada %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", setiap hari";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", setiap hari %s  dalam seminggu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s sampai %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", dan %s sampai %s";
                }, a.prototype.first = function() {
                  return "pertama";
                }, a.prototype.second = function() {
                  return "kedua";
                }, a.prototype.third = function() {
                  return "ketiga";
                }, a.prototype.fourth = function() {
                  return "keempat";
                }, a.prototype.fifth = function() {
                  return "kelima";
                }, a.prototype.commaOnThe = function() {
                  return ", di ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s pada bulan";
                }, a.prototype.lastDay = function() {
                  return "hari terakhir";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", pada %s terakhir bulan ini";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", dan pada %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", setiap bulan %s ";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", pada hari terakhir bulan ini";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", pada hari kerja terakhir setiap bulan";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s hari sebelum hari terakhir setiap bulan";
                }, a.prototype.firstWeekday = function() {
                  return "hari kerja pertama";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hari kerja terdekat %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", pada %s bulan ini";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", setiap %s hari";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", antara hari %s dan %s dalam sebulan";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", pada hari %s dalam sebulan";
                }, a.prototype.commaEveryHour = function() {
                  return ", setiap jam";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", setiap %s tahun";
                }, a.prototype.commaStartingX0 = function() {
                  return ", mulai pada %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Maret",
                    "April",
                    "Mei",
                    "Juni",
                    "Juli",
                    "Agustus",
                    "September",
                    "Oktober",
                    "November",
                    "Desember"
                  ];
                }, a;
              }();
              l.id = c;
            }
          ),
          /***/
          128: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.it = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "È verificato un errore durante la generazione la descrizione espressione. Controllare la sintassi delle espressioni cron.";
                }, a.prototype.at = function() {
                  return "Alle";
                }, a.prototype.atSpace = function() {
                  return "Alle ";
                }, a.prototype.atX0 = function() {
                  return "alle %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "al %s minuto passata l'ora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "al %s secondo passato il minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tra le %s e le %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tra il giorno %s e %s del mese";
                }, a.prototype.commaEveryDay = function() {
                  return ", ogni giorno";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", ogni %s giorni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ogni %s giorni della settimana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", ogni %s mesi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", ogni %s anni";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", il giorno %s del mese";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", solo in %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", solo il %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e il %s";
                }, a.prototype.commaOnThe = function() {
                  return ", il ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", l'ultimo giorno del mese";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", nell'ultima settimana del mese";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s giorni prima dell'ultimo giorno del mese";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", l'ultimo %s del mese";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", il %s del mese";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s al %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e %s al %s";
                }, a.prototype.everyHour = function() {
                  return "ogni ora";
                }, a.prototype.everyMinute = function() {
                  return "ogni minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Ogni minuto tra le %s e le %s";
                }, a.prototype.everySecond = function() {
                  return "ogni secondo";
                }, a.prototype.everyX0Hours = function() {
                  return "ogni %s ore";
                }, a.prototype.everyX0Minutes = function() {
                  return "ogni %s minuti";
                }, a.prototype.everyX0Seconds = function() {
                  return "ogni %s secondi";
                }, a.prototype.fifth = function() {
                  return "quinto";
                }, a.prototype.first = function() {
                  return "primo";
                }, a.prototype.firstWeekday = function() {
                  return "primo giorno della settimana";
                }, a.prototype.fourth = function() {
                  return "quarto";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuti %s al %s dopo l'ora";
                }, a.prototype.second = function() {
                  return "secondo";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "secondi %s al %s oltre il minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s del mese";
                }, a.prototype.lastDay = function() {
                  return "l'ultimo giorno";
                }, a.prototype.third = function() {
                  return "terzo";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "giorno della settimana più vicino al %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", a partire %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "gennaio",
                    "febbraio",
                    "marzo",
                    "aprile",
                    "maggio",
                    "giugno",
                    "luglio",
                    "agosto",
                    "settembre",
                    "ottobre",
                    "novembre",
                    "dicembre"
                  ];
                }, a;
              }();
              l.it = c;
            }
          ),
          /***/
          949: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ja = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "毎分";
                }, a.prototype.everyHour = function() {
                  return "毎時";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "式の記述を生成する際にエラーが発生しました。Cron 式の構文を確認してください。";
                }, a.prototype.atSpace = function() {
                  return "次において実施";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "%s から %s まで毎分";
                }, a.prototype.at = function() {
                  return "次において実施";
                }, a.prototype.spaceAnd = function() {
                  return "と";
                }, a.prototype.everySecond = function() {
                  return "毎秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s 秒ごと";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "毎分 %s 秒から %s 秒まで";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "毎分 %s 秒過ぎ";
                }, a.prototype.everyX0Minutes = function() {
                  return "%s 分ごと";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "毎時 %s 分から %s 分まで";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "毎時 %s 分過ぎ";
                }, a.prototype.everyX0Hours = function() {
                  return "%s 時間ごと";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s と %s の間";
                }, a.prototype.atX0 = function() {
                  return "次において実施 %s";
                }, a.prototype.commaEveryDay = function() {
                  return "、毎日";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return "、週のうち %s 日ごと";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return "、%s から %s まで";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return "、%s から %s まで";
                }, a.prototype.first = function() {
                  return "1 番目";
                }, a.prototype.second = function() {
                  return "2 番目";
                }, a.prototype.third = function() {
                  return "3 番目";
                }, a.prototype.fourth = function() {
                  return "4 番目";
                }, a.prototype.fifth = function() {
                  return "5 番目";
                }, a.prototype.commaOnThe = function() {
                  return "次に";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "月のうち %s";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return "月の最後の %s に";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return "%s にのみ";
                }, a.prototype.commaEveryX0Months = function() {
                  return "、%s か月ごと";
                }, a.prototype.commaOnlyInX0 = function() {
                  return "%s でのみ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return "次の最終日に";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return "月の最後の平日に";
                }, a.prototype.firstWeekday = function() {
                  return "最初の平日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "%s 日の直近の平日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return "月の %s に";
                }, a.prototype.commaEveryX0Days = function() {
                  return "、%s 日ごと";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return "、月の %s 日から %s 日の間";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return "、月の %s 日目";
                }, a.prototype.spaceAndSpace = function() {
                  return "と";
                }, a.prototype.commaEveryMinute = function() {
                  return "、毎分";
                }, a.prototype.commaEveryHour = function() {
                  return "、毎時";
                }, a.prototype.commaEveryX0Years = function() {
                  return "、%s 年ごと";
                }, a.prototype.commaStartingX0 = function() {
                  return "、%s に開始";
                }, a.prototype.aMPeriod = function() {
                  return "AM";
                }, a.prototype.pMPeriod = function() {
                  return "PM";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return "月の最終日の %s 日前";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.lastDay = function() {
                  return "最終日";
                }, a.prototype.commaAndOnX0 = function() {
                  return "、〜と %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
                }, a;
              }();
              l.ja = c;
            }
          ),
          /***/
          305: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ko = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.setPeriodBeforeTime = function() {
                  return !0;
                }, a.prototype.pm = function() {
                  return "오후";
                }, a.prototype.am = function() {
                  return "오전";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "표현식 설명을 생성하는 중 오류가 발생했습니다. cron 표현식 구문을 확인하십시오.";
                }, a.prototype.everyMinute = function() {
                  return "1분마다";
                }, a.prototype.everyHour = function() {
                  return "1시간마다";
                }, a.prototype.atSpace = function() {
                  return "시간 ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "%s 및 %s 사이에 매 분";
                }, a.prototype.at = function() {
                  return "시간";
                }, a.prototype.spaceAnd = function() {
                  return " 및";
                }, a.prototype.everySecond = function() {
                  return "1초마다";
                }, a.prototype.everyX0Seconds = function() {
                  return "%s초마다";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "정분 후 %s초에서 %s초까지";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "정분 후 %s초에서";
                }, a.prototype.everyX0Minutes = function() {
                  return "%s분마다";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "정시 후 %s분에서 %s까지";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "정시 후 %s분에서";
                }, a.prototype.everyX0Hours = function() {
                  return "%s시간마다";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s에서 %s 사이";
                }, a.prototype.atX0 = function() {
                  return "%s에서";
                }, a.prototype.commaEveryDay = function() {
                  return ", 매일";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 주 중 %s일마다";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s에서 %s까지";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 및 %s에서 %s까지";
                }, a.prototype.first = function() {
                  return "첫 번째";
                }, a.prototype.second = function() {
                  return "두 번째";
                }, a.prototype.third = function() {
                  return "세 번째";
                }, a.prototype.fourth = function() {
                  return "네 번째";
                }, a.prototype.fifth = function() {
                  return "다섯 번째";
                }, a.prototype.commaOnThe = function() {
                  return ", 해당 ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " 해당 월의 %s";
                }, a.prototype.lastDay = function() {
                  return "마지막 날";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 해당 월의 마지막 %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", %s에만";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 및 %s에";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", %s개월마다";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", %s에서만";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 해당 월의 마지막 날에";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 해당 월의 마지막 평일에";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", 해당 월의 마지막 날 %s일 전";
                }, a.prototype.firstWeekday = function() {
                  return "첫 번째 평일";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "평일 가장 가까운 날 %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 해당 월의 %s에";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s일마다";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 해당 월의 %s일 및 %s일 사이";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 해당 월의 %s일에";
                }, a.prototype.commaEveryMinute = function() {
                  return ", 1분마다";
                }, a.prototype.commaEveryHour = function() {
                  return ", 1시간마다";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s년마다";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s부터";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"];
                }, a;
              }();
              l.ko = c;
            }
          ),
          /***/
          863: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.my = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Terdapat ralat semasa menjana penerangan ungkapan. Sila periksa sintaks ungkapan cron.";
                }, a.prototype.everyMinute = function() {
                  return "setiap minit";
                }, a.prototype.everyHour = function() {
                  return "setiap jam";
                }, a.prototype.atSpace = function() {
                  return "Pada ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Setiap minit antara %s dan %s";
                }, a.prototype.at = function() {
                  return "Pada";
                }, a.prototype.spaceAnd = function() {
                  return " dan";
                }, a.prototype.everySecond = function() {
                  return "setiap saat";
                }, a.prototype.everyX0Seconds = function() {
                  return "setiap %s saat";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "saat ke %s hingga %s selepas minit";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "pada %s saat selepas minit";
                }, a.prototype.everyX0Minutes = function() {
                  return "setiap %s minit";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minit ke %s hingga %s selepas jam";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "pada %s minit selepas jam";
                }, a.prototype.everyX0Hours = function() {
                  return "setiap %s jam";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "antara %s dan %s";
                }, a.prototype.atX0 = function() {
                  return "pada %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", setiap hari";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", setiap %s hari dalam minggu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s hingga %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", dan %s hingga %s";
                }, a.prototype.first = function() {
                  return "pertama";
                }, a.prototype.second = function() {
                  return "kedua";
                }, a.prototype.third = function() {
                  return "ketiga";
                }, a.prototype.fourth = function() {
                  return "keempat";
                }, a.prototype.fifth = function() {
                  return "kelima";
                }, a.prototype.commaOnThe = function() {
                  return ", pada ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s pada bulan";
                }, a.prototype.lastDay = function() {
                  return "hari terakhir";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", pada %s terakhir bulan";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", dan pada %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", setiap bulan %s";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", hanya pada %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", pada hari terakhir bulan";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", pada minggu terakhir bulan";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s hari sebelum hari terakhir bulan";
                }, a.prototype.firstWeekday = function() {
                  return "hari pertama minggu bekerja";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "hari bekerja yang terdekat dengan %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", pada %s bulan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", setiap %s hari";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", antara hari %s dan %s dalam bulan";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", pada hari %s dalam bulan";
                }, a.prototype.commaEveryHour = function() {
                  return ", setiap jam";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", setiap %s tahun";
                }, a.prototype.commaStartingX0 = function() {
                  return ", bermula %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Mac",
                    "April",
                    "Mei",
                    "Jun",
                    "Julai",
                    "Ogos",
                    "September",
                    "Oktober",
                    "November",
                    "Disember"
                  ];
                }, a;
              }();
              l.my = c;
            }
          ),
          /***/
          869: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.nb = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "En feil inntraff ved generering av uttrykksbeskrivelse. Sjekk cron syntaks.";
                }, a.prototype.at = function() {
                  return "Kl.";
                }, a.prototype.atSpace = function() {
                  return "Kl.";
                }, a.prototype.atX0 = function() {
                  return "på %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "på %s minutter etter timen";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "på %s sekunder etter minuttet";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellom %s og %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellom dag %s og %s av måneden";
                }, a.prototype.commaEveryDay = function() {
                  return ", hver dag";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", hver %s dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", hver %s ukedag";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", hver %s måned";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", hvert %s år";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s av måneden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", bare i %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", på %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", og på %s";
                }, a.prototype.commaOnThe = function() {
                  return ", på ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på den siste dagen i måneden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", den siste ukedagen i måneden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dager før den siste dagen i måneden";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på den siste %s av måneden";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s av måneden";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s til og med %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", og %s til og med %s";
                }, a.prototype.everyHour = function() {
                  return "hver time";
                }, a.prototype.everyMinute = function() {
                  return "hvert minutt";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Hvert minutt mellom %s og %s";
                }, a.prototype.everySecond = function() {
                  return "hvert sekund";
                }, a.prototype.everyX0Hours = function() {
                  return "hver %s time";
                }, a.prototype.everyX0Minutes = function() {
                  return "hvert %s minutt";
                }, a.prototype.everyX0Seconds = function() {
                  return "hvert %s sekund";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.first = function() {
                  return "første";
                }, a.prototype.firstWeekday = function() {
                  return "første ukedag";
                }, a.prototype.fourth = function() {
                  return "fjerde";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuttene fra %s til og med %s etter timen";
                }, a.prototype.second = function() {
                  return "sekund";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundene fra %s til og med %s etter minuttet";
                }, a.prototype.spaceAnd = function() {
                  return " og";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s i måneden";
                }, a.prototype.lastDay = function() {
                  return "den siste dagen";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "ukedag nærmest dag %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", starter %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "mars",
                    "april",
                    "mai",
                    "juni",
                    "juli",
                    "august",
                    "september",
                    "oktober",
                    "november",
                    "desember"
                  ];
                }, a;
              }();
              l.nb = c;
            }
          ),
          /***/
          771: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.nl = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "elke minuut";
                }, a.prototype.everyHour = function() {
                  return "elk uur";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Er is een fout opgetreden bij het vertalen van de gegevens. Controleer de gegevens.";
                }, a.prototype.atSpace = function() {
                  return "Op ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Elke minuut tussen %s en %s";
                }, a.prototype.at = function() {
                  return "Op";
                }, a.prototype.spaceAnd = function() {
                  return " en";
                }, a.prototype.everySecond = function() {
                  return "elke seconde";
                }, a.prototype.everyX0Seconds = function() {
                  return "elke %s seconden";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconden %s t/m %s na de minuut";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "op %s seconden na de minuut";
                }, a.prototype.everyX0Minutes = function() {
                  return "elke %s minuten";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuut %s t/m %s na het uur";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "op %s minuten na het uur";
                }, a.prototype.everyX0Hours = function() {
                  return "elke %s uur";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "tussen %s en %s";
                }, a.prototype.atX0 = function() {
                  return "op %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", elke dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", elke %s dagen van de week";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s t/m %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", en %s t/m %s";
                }, a.prototype.first = function() {
                  return "eerste";
                }, a.prototype.second = function() {
                  return "tweede";
                }, a.prototype.third = function() {
                  return "derde";
                }, a.prototype.fourth = function() {
                  return "vierde";
                }, a.prototype.fifth = function() {
                  return "vijfde";
                }, a.prototype.commaOnThe = function() {
                  return ", op de ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s van de maand";
                }, a.prototype.lastDay = function() {
                  return "de laatste dag";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", op de laatste %s van de maand";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", alleen op %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", en op %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", elke %s maanden";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", alleen in %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", op de laatste dag van de maand";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", op de laatste werkdag van de maand";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dagen vóór de laatste dag van de maand";
                }, a.prototype.firstWeekday = function() {
                  return "eerste werkdag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "werkdag dichtst bij dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", op de %s van de maand";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", elke %s dagen";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", tussen dag %s en %s van de maand";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", op dag %s van de maand";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", elke %s jaren";
                }, a.prototype.commaStartingX0 = function() {
                  return ", beginnend %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januari",
                    "februari",
                    "maart",
                    "april",
                    "mei",
                    "juni",
                    "juli",
                    "augustus",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              l.nl = c;
            }
          ),
          /***/
          665: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.pl = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Wystąpił błąd podczas generowania opisu wyrażenia cron. Sprawdź składnię wyrażenia cron.";
                }, a.prototype.at = function() {
                  return "O";
                }, a.prototype.atSpace = function() {
                  return "O ";
                }, a.prototype.atX0 = function() {
                  return "o %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "w %s minucie";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "w %s sekundzie";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "od %s do %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", od %s-ego do %s-ego dnia miesiąca";
                }, a.prototype.commaEveryDay = function() {
                  return ", co dzień";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", co %s dni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", co %s dni tygodnia";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", co %s miesięcy";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", co %s lat";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s-ego dnia miesiąca";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", tylko %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", tylko %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", i %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ostatni dzień miesiąca";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ostatni dzień roboczy miesiąca";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dni przed ostatnim dniem miesiąca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ostatni %s miesiąca";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s miesiąca";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", i od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "co godzinę";
                }, a.prototype.everyMinute = function() {
                  return "co minutę";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Co minutę od %s do %s";
                }, a.prototype.everySecond = function() {
                  return "co sekundę";
                }, a.prototype.everyX0Hours = function() {
                  return "co %s godzin";
                }, a.prototype.everyX0Minutes = function() {
                  return "co %s minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "co %s sekund";
                }, a.prototype.fifth = function() {
                  return "piąty";
                }, a.prototype.first = function() {
                  return "pierwszy";
                }, a.prototype.firstWeekday = function() {
                  return "pierwszy dzień roboczy";
                }, a.prototype.fourth = function() {
                  return "czwarty";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuty od %s do %s";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.spaceAnd = function() {
                  return " i";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s miesiąca";
                }, a.prototype.lastDay = function() {
                  return "ostatni dzień";
                }, a.prototype.third = function() {
                  return "trzeci";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dzień roboczy najbliższy %s-ego dnia";
                }, a.prototype.commaStartingX0 = function() {
                  return ", startowy %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "styczeń",
                    "luty",
                    "marzec",
                    "kwiecień",
                    "maj",
                    "czerwiec",
                    "lipiec",
                    "sierpień",
                    "wrzesień",
                    "październik",
                    "listopad",
                    "grudzień"
                  ];
                }, a;
              }();
              l.pl = c;
            }
          ),
          /***/
          461: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.pt_BR = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
                }, a.prototype.at = function() {
                  return "às";
                }, a.prototype.atSpace = function() {
                  return "às ";
                }, a.prototype.atX0 = function() {
                  return "Às %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "aos %s minutos da hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "aos %s segundos do minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre %s e %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre os dias %s e %s do mês";
                }, a.prototype.commaEveryDay = function() {
                  return ", a cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", a cada %s dias";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a cada %s dias de semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", a cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", no dia %s do mês";
                }, a.prototype.commaOnlyInX0 = function(u) {
                  return u && u.length > 1 && u[1] === "-" ? "somente %s" : ", somente em %s";
                }, a.prototype.commaOnlyOnX0 = function(u) {
                  return u && u.length > 1 && u[1] === "-" ? ", somente %s" : ", somente de %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e de %s";
                }, a.prototype.commaOnThe = function() {
                  return ", na ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", no último dia do mês";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", no último dia da semana do mês";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dias antes do último dia do mês";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", na última %s do mês";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", no %s do mês";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "a cada hora";
                }, a.prototype.everyMinute = function() {
                  return "a cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "a cada minuto entre %s e %s";
                }, a.prototype.everySecond = function() {
                  return "a cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "a cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "a cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "a cada %s segundos";
                }, a.prototype.fifth = function() {
                  return "quinta";
                }, a.prototype.first = function() {
                  return "primeira";
                }, a.prototype.firstWeekday = function() {
                  return "primeiro dia da semana";
                }, a.prototype.fourth = function() {
                  return "quarta";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "do minuto %s até %s de cada hora";
                }, a.prototype.second = function() {
                  return "segunda";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "No segundo %s até %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s do mês";
                }, a.prototype.lastDay = function() {
                  return "o último dia";
                }, a.prototype.third = function() {
                  return "terceira";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia da semana mais próximo do dia %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", a cada %s anos";
                }, a.prototype.commaStartingX0 = function() {
                  return ", iniciando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janeiro",
                    "fevereiro",
                    "março",
                    "abril",
                    "maio",
                    "junho",
                    "julho",
                    "agosto",
                    "setembro",
                    "outubro",
                    "novembro",
                    "dezembro"
                  ];
                }, a;
              }();
              l.pt_BR = c;
            }
          ),
          /***/
          713: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.pt_PT = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ocorreu um erro ao gerar a descrição da expressão Cron.";
                }, a.prototype.at = function() {
                  return "às";
                }, a.prototype.atSpace = function() {
                  return "às ";
                }, a.prototype.atX0 = function() {
                  return "Às %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "aos %s minutos da hora";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "aos %s segundos do minuto";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "entre %s e %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", entre os dias %s e %s do mês";
                }, a.prototype.commaEveryDay = function() {
                  return ", a cada dia";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", a cada %s dias";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", a cada %s dias de semana";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", a cada %s meses";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", no dia %s do mês";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", somente em %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", somente de %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", e de %s";
                }, a.prototype.commaOnThe = function() {
                  return ", na ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", no último dia do mês";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", no último dia da semana do mês";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dias antes do último dia do mês";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", na última %s do mês";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", no %s do mês";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s a %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", e de %s a %s";
                }, a.prototype.everyHour = function() {
                  return "a cada hora";
                }, a.prototype.everyMinute = function() {
                  return "a cada minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "a cada minuto entre %s e %s";
                }, a.prototype.everySecond = function() {
                  return "a cada segundo";
                }, a.prototype.everyX0Hours = function() {
                  return "a cada %s horas";
                }, a.prototype.everyX0Minutes = function() {
                  return "a cada %s minutos";
                }, a.prototype.everyX0Seconds = function() {
                  return "a cada %s segundos";
                }, a.prototype.fifth = function() {
                  return "quinta";
                }, a.prototype.first = function() {
                  return "primeira";
                }, a.prototype.firstWeekday = function() {
                  return "primeiro dia da semana";
                }, a.prototype.fourth = function() {
                  return "quarta";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "do minuto %s até %s de cada hora";
                }, a.prototype.second = function() {
                  return "segunda";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "No segundo %s até %s de cada minuto";
                }, a.prototype.spaceAnd = function() {
                  return " e";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s do mês";
                }, a.prototype.lastDay = function() {
                  return "o último dia";
                }, a.prototype.third = function() {
                  return "terceira";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "dia da semana mais próximo do dia %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", a cada %s anos";
                }, a.prototype.commaStartingX0 = function() {
                  return ", iniciando %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "janeiro",
                    "fevereiro",
                    "março",
                    "abril",
                    "maio",
                    "junho",
                    "julho",
                    "agosto",
                    "setembro",
                    "outubro",
                    "novembro",
                    "dezembro"
                  ];
                }, a;
              }();
              l.pt_PT = c;
            }
          ),
          /***/
          408: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ro = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Eroare la generarea descrierii. Verificați sintaxa.";
                }, a.prototype.at = function() {
                  return "La";
                }, a.prototype.atSpace = function() {
                  return "La ";
                }, a.prototype.atX0 = function() {
                  return "la %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "la și %s minute";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "la și %s secunde";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "între %s și %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", între zilele %s și %s ale lunii";
                }, a.prototype.commaEveryDay = function() {
                  return ", în fiecare zi";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", la fiecare %s zile";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", la fiecare a %s-a zi a săptămânii";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", la fiecare %s luni";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", o dată la %s ani";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", în ziua %s a lunii";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", doar în %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", doar %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", și %s";
                }, a.prototype.commaOnThe = function() {
                  return ", în ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", în ultima zi a lunii";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", în ultima zi lucrătoare a lunii";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s zile înainte de ultima zi a lunii";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", în ultima %s a lunii";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", în %s a lunii";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", de %s până %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", și de %s până %s";
                }, a.prototype.everyHour = function() {
                  return "în fiecare oră";
                }, a.prototype.everyMinute = function() {
                  return "în fiecare minut";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "În fiecare minut între %s și %s";
                }, a.prototype.everySecond = function() {
                  return "în fiecare secundă";
                }, a.prototype.everyX0Hours = function() {
                  return "la fiecare %s ore";
                }, a.prototype.everyX0Minutes = function() {
                  return "la fiecare %s minute";
                }, a.prototype.everyX0Seconds = function() {
                  return "la fiecare %s secunde";
                }, a.prototype.fifth = function() {
                  return "a cincea";
                }, a.prototype.first = function() {
                  return "prima";
                }, a.prototype.firstWeekday = function() {
                  return "prima zi a săptămânii";
                }, a.prototype.fourth = function() {
                  return "a patra";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "între minutele %s și %s";
                }, a.prototype.second = function() {
                  return "a doua";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "între secunda %s și secunda %s";
                }, a.prototype.spaceAnd = function() {
                  return " și";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s a lunii";
                }, a.prototype.lastDay = function() {
                  return "ultima zi";
                }, a.prototype.third = function() {
                  return "a treia";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "cea mai apropiată zi a săptămânii de ziua %s";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return ", din %s până în %s";
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", din %s până în %s";
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return "la și %s de minute";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return "la și %s de secunde";
                }, a.prototype.commaStartingX0 = function() {
                  return ", pornire %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "ianuarie",
                    "februarie",
                    "martie",
                    "aprilie",
                    "mai",
                    "iunie",
                    "iulie",
                    "august",
                    "septembrie",
                    "octombrie",
                    "noiembrie",
                    "decembrie"
                  ];
                }, a;
              }();
              l.ro = c;
            }
          ),
          /***/
          392: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.ru = void 0;
              var c = function(f, d) {
                var p = Number(f);
                return p !== void 0 ? d[p % 100 > 4 && p % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][p % 10 < 5 ? Math.abs(p) % 10 : 5]] : d[2];
              }, a = function(f, d) {
                var p = Number(f);
                return p !== void 0 ? d[p === 0 ? 0 : p === 1 || p === 2 || p === 4 ? 1 : 2] : d[1];
              }, u = function() {
                function f() {
                }
                return f.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, f.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, f.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, f.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, f.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, f.prototype.everyMinute = function() {
                  return "каждую минуту";
                }, f.prototype.everyHour = function() {
                  return "каждый час";
                }, f.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Произошла ошибка во время генерации описания выражения. Проверьте синтаксис крон-выражения.";
                }, f.prototype.atSpace = function() {
                  return "В ";
                }, f.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Каждую минуту с %s по %s";
                }, f.prototype.at = function() {
                  return "В";
                }, f.prototype.spaceAnd = function() {
                  return " и";
                }, f.prototype.everySecond = function() {
                  return "каждую секунду";
                }, f.prototype.everyX0Seconds = function(d) {
                  return c(d, ["каждую %s секунду", "каждые %s секунды", "каждые %s секунд"]);
                }, f.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "секунды с %s по %s";
                }, f.prototype.atX0SecondsPastTheMinute = function(d) {
                  return c(d, ["в %s секунду", "в %s секунды", "в %s секунд"]);
                }, f.prototype.everyX0Minutes = function(d) {
                  return c(d, ["каждую %s минуту", "каждые %s минуты", "каждые %s минут"]);
                }, f.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "минуты с %s по %s";
                }, f.prototype.atX0MinutesPastTheHour = function(d) {
                  return c(d, ["в %s минуту", "в %s минуты", "в %s минут"]);
                }, f.prototype.everyX0Hours = function(d) {
                  return c(d, ["каждый %s час", "каждые %s часа", "каждые %s часов"]);
                }, f.prototype.betweenX0AndX1 = function() {
                  return "с %s по %s";
                }, f.prototype.atX0 = function() {
                  return "в %s";
                }, f.prototype.commaEveryDay = function() {
                  return ", каждый день";
                }, f.prototype.commaEveryX0DaysOfTheWeek = function(d) {
                  return c(d, ["", ", каждые %s дня недели", ", каждые %s дней недели"]);
                }, f.prototype.commaX0ThroughX1 = function(d) {
                  return d && (d[0] == "2" || d[0] == "3") ? ", со %s по %s" : ", с %s по %s";
                }, f.prototype.commaAndX0ThroughX1 = function(d) {
                  return d && (d[0] == "2" || d[0] == "3") ? " и со %s по %s" : " и с %s по %s";
                }, f.prototype.first = function(d) {
                  return a(d, ["первое", "первый", "первую"]);
                }, f.prototype.second = function(d) {
                  return a(d, ["второе", "второй", "вторую"]);
                }, f.prototype.third = function(d) {
                  return a(d, ["третье", "третий", "третью"]);
                }, f.prototype.fourth = function(d) {
                  return a(d, ["четвертое", "четвертый", "четвертую"]);
                }, f.prototype.fifth = function(d) {
                  return a(d, ["пятое", "пятый", "пятую"]);
                }, f.prototype.commaOnThe = function(d) {
                  return d === "2" ? ", во " : ", в ";
                }, f.prototype.spaceX0OfTheMonth = function() {
                  return " %s месяца";
                }, f.prototype.lastDay = function() {
                  return "последний день";
                }, f.prototype.commaOnTheLastX0OfTheMonth = function(d) {
                  return a(d, [", в последнее %s месяца", ", в последний %s месяца", ", в последнюю %s месяца"]);
                }, f.prototype.commaOnlyOnX0 = function(d) {
                  return d && d[0] === "2" ? ", только во %s" : ", только в %s";
                }, f.prototype.commaAndOnX0 = function() {
                  return ", и %s";
                }, f.prototype.commaEveryX0Months = function(d) {
                  return c(d, ["", " каждые %s месяца", " каждые %s месяцев"]);
                }, f.prototype.commaOnlyInMonthX0 = function() {
                  return ", только %s";
                }, f.prototype.commaOnlyInX0 = function() {
                  return ", только в %s";
                }, f.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", в последний день месяца";
                }, f.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", в последний будний день месяца";
                }, f.prototype.commaDaysBeforeTheLastDayOfTheMonth = function(d) {
                  return c(d, [
                    ", за %s день до конца месяца",
                    ", за %s дня до конца месяца",
                    ", за %s дней до конца месяца"
                  ]);
                }, f.prototype.firstWeekday = function() {
                  return "первый будний день";
                }, f.prototype.weekdayNearestDayX0 = function() {
                  return "ближайший будний день к %s числу";
                }, f.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", в %s месяца";
                }, f.prototype.commaEveryX0Days = function(d) {
                  return c(d, [", каждый %s день", ", каждые %s дня", ", каждые %s дней"]);
                }, f.prototype.commaBetweenDayX0AndX1OfTheMonth = function(d) {
                  return d && d.substring(0, d.indexOf("-")) == "2" ? ", со %s по %s число месяца" : ", с %s по %s число месяца";
                }, f.prototype.commaOnDayX0OfTheMonth = function(d) {
                  return d && d[0] == "2" ? ", во %s число месяца" : ", в %s число месяца";
                }, f.prototype.commaEveryX0Years = function(d) {
                  return c(d, [", каждый %s год", ", каждые %s года", ", каждые %s лет"]);
                }, f.prototype.commaStartingX0 = function() {
                  return ", начало %s";
                }, f.prototype.daysOfTheWeek = function() {
                  return ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
                }, f.prototype.daysOfTheWeekInCase = function(d) {
                  return d === void 0 && (d = 2), d == 1 ? ["воскресенья", "понедельника", "вторника", "среды", "четверга", "пятницы", "субботы"] : ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
                }, f.prototype.monthsOfTheYear = function() {
                  return [
                    "январь",
                    "февраль",
                    "март",
                    "апрель",
                    "май",
                    "июнь",
                    "июль",
                    "август",
                    "сентябрь",
                    "октябрь",
                    "ноябрь",
                    "декабрь"
                  ];
                }, f.prototype.monthsOfTheYearInCase = function(d) {
                  return d == 1 ? [
                    "января",
                    "февраля",
                    "марта",
                    "апреля",
                    "мая",
                    "июня",
                    "июля",
                    "августа",
                    "сентября",
                    "октября",
                    "ноября",
                    "декабря"
                  ] : this.monthsOfTheYear();
                }, f;
              }();
              l.ru = u;
            }
          ),
          /***/
          203: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.sk = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Pri vytváraní popisu došlo k chybe. Skontrolujte prosím správnosť syntaxe cronu.";
                }, a.prototype.everyMinute = function() {
                  return "každú minútu";
                }, a.prototype.everyHour = function() {
                  return "každú hodinu";
                }, a.prototype.atSpace = function() {
                  return "V ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Každú minútu medzi %s a %s";
                }, a.prototype.at = function() {
                  return "V";
                }, a.prototype.spaceAnd = function() {
                  return " a";
                }, a.prototype.everySecond = function() {
                  return "každú sekundu";
                }, a.prototype.everyX0Seconds = function() {
                  return "každých %s sekúnd";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekundy od %s do %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "v %s sekúnd";
                }, a.prototype.everyX0Minutes = function() {
                  return "každých %s minút";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minúty od %s do %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "v %s minút";
                }, a.prototype.everyX0Hours = function() {
                  return "každých %s hodín";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "medzi %s a %s";
                }, a.prototype.atX0 = function() {
                  return "v %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", každý deň";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", každých %s dní v týždni";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", a od %s do %s";
                }, a.prototype.first = function() {
                  return "prvý";
                }, a.prototype.second = function() {
                  return "druhý";
                }, a.prototype.third = function() {
                  return "tretí";
                }, a.prototype.fourth = function() {
                  return "štvrtý";
                }, a.prototype.fifth = function() {
                  return "piaty";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v mesiaci";
                }, a.prototype.lastDay = function() {
                  return "posledný deň";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", posledný %s v mesiaci";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", iba v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", a v %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", každých %s mesiacov";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", iba v %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", posledný deň v mesiaci";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", posledný pracovný deň v mesiaci";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dní pred posledným dňom v mesiaci";
                }, a.prototype.firstWeekday = function() {
                  return "prvý pracovný deň";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "pracovný deň najbližšie %s. dňu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", v %s v mesiaci";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", každých %s dní";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", medzi dňami %s a %s v mesiaci";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. deň v mesiaci";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", každých %s rokov";
                }, a.prototype.commaStartingX0 = function() {
                  return ", začínajúcich %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Január",
                    "Február",
                    "Marec",
                    "Apríl",
                    "Máj",
                    "Jún",
                    "Júl",
                    "August",
                    "September",
                    "Október",
                    "November",
                    "December"
                  ];
                }, a;
              }();
              l.sk = c;
            }
          ),
          /***/
          738: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.sl = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Pri generiranju opisa izraza je prišlo do napake. Preverite sintakso izraza cron.";
                }, a.prototype.at = function() {
                  return "Ob";
                }, a.prototype.atSpace = function() {
                  return "Ob ";
                }, a.prototype.atX0 = function() {
                  return "ob %s";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "ob %s.";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "ob %s.";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "od %s do %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", od %s. do %s. dne v mesecu";
                }, a.prototype.commaEveryDay = function() {
                  return ", vsak dan";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", vsakih %s dni";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", vsakih %s dni v tednu";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", vsakih %s mesecev";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", vsakih %s let";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", %s. dan v mesecu";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", samo v %s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", samo v %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return "in naprej %s";
                }, a.prototype.commaOnThe = function() {
                  return ", ";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", zadnji %s v mesecu";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", zadnji delovni dan v mesecu";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dni pred koncem meseca";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", zadnji %s v mesecu";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", %s v mesecu";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", od %s do %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", in od %s do %s";
                }, a.prototype.everyHour = function() {
                  return "vsako uro";
                }, a.prototype.everyMinute = function() {
                  return "vsako minuto";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Vsako minuto od %s do %s";
                }, a.prototype.everySecond = function() {
                  return "vsako sekundo";
                }, a.prototype.everyX0Hours = function() {
                  return "vsakih %s ur";
                }, a.prototype.everyX0Minutes = function() {
                  return "vsakih %s minut";
                }, a.prototype.everyX0Seconds = function() {
                  return "vsakih %s sekund";
                }, a.prototype.fifth = function() {
                  return "peti";
                }, a.prototype.first = function() {
                  return "prvi";
                }, a.prototype.firstWeekday = function() {
                  return "prvi delovni dan";
                }, a.prototype.fourth = function() {
                  return "četrti";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minute od %s do %s";
                }, a.prototype.second = function() {
                  return "drugi";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde od %s do %s";
                }, a.prototype.spaceAnd = function() {
                  return " in";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s v mesecu";
                }, a.prototype.lastDay = function() {
                  return "zadnjič";
                }, a.prototype.third = function() {
                  return "tretji";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "delovni dan, najbližji %s. dnevu";
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.commaStartingX0 = function() {
                  return ", začenši %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januar",
                    "februar",
                    "marec",
                    "april",
                    "maj",
                    "junij",
                    "julij",
                    "avgust",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              l.sl = c;
            }
          ),
          /***/
          673: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.sv = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Ett fel inträffade vid generering av uttryckets beskrivning. Kontrollera cron-uttryckets syntax.";
                }, a.prototype.everyMinute = function() {
                  return "varje minut";
                }, a.prototype.everyHour = function() {
                  return "varje timme";
                }, a.prototype.atSpace = function() {
                  return "Kl ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Varje minut mellan %s och %s";
                }, a.prototype.at = function() {
                  return "Kl";
                }, a.prototype.spaceAnd = function() {
                  return " och";
                }, a.prototype.everySecond = function() {
                  return "varje sekund";
                }, a.prototype.everyX0Seconds = function() {
                  return "varje %s sekund";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunderna från %s till och med %s efter minuten";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "på %s sekunder efter minuten";
                }, a.prototype.everyX0Minutes = function() {
                  return "var %s minut";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minuterna från %s till och med %s efter timmen";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "på %s minuten efter timmen";
                }, a.prototype.everyX0Hours = function() {
                  return "var %s timme";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "mellan %s och %s";
                }, a.prototype.atX0 = function() {
                  return "kl %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", varje dag";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", var %s dag i veckan";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s till %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", och %s till %s";
                }, a.prototype.first = function() {
                  return "första";
                }, a.prototype.second = function() {
                  return "andra";
                }, a.prototype.third = function() {
                  return "tredje";
                }, a.prototype.fourth = function() {
                  return "fjärde";
                }, a.prototype.fifth = function() {
                  return "femte";
                }, a.prototype.commaOnThe = function() {
                  return ", den ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %sen av månaden";
                }, a.prototype.lastDay = function() {
                  return "den sista dagen";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", på sista %s av månaden";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", varje %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", och på %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", var %s månad";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", bara på %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", på sista dagen av månaden";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", på sista veckodag av månaden";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s dagar före den sista dagen i månaden";
                }, a.prototype.firstWeekday = function() {
                  return "första veckodag";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "veckodagen närmast dag %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", på den %s av månaden";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", var %s dag";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", mellan dag %s och %s av månaden";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", på dag %s av månaden";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", var %s år";
                }, a.prototype.commaStartingX0 = function() {
                  return ", startar %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "januari",
                    "februari",
                    "mars",
                    "april",
                    "maj",
                    "juni",
                    "juli",
                    "augusti",
                    "september",
                    "oktober",
                    "november",
                    "december"
                  ];
                }, a;
              }();
              l.sv = c;
            }
          ),
          /***/
          286: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.sw = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Kuna tatizo wakati wa kutunga msemo. Angalia cron expression syntax.";
                }, a.prototype.everyMinute = function() {
                  return "kila dakika";
                }, a.prototype.everyHour = function() {
                  return "kila saa";
                }, a.prototype.atSpace = function() {
                  return "Kwa ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Kila dakika kwanzia %s hadi %s";
                }, a.prototype.at = function() {
                  return "Kwa";
                }, a.prototype.spaceAnd = function() {
                  return " na";
                }, a.prototype.everySecond = function() {
                  return "kila sekunde";
                }, a.prototype.everyX0Seconds = function() {
                  return "kila sekunde %s";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "sekunde ya %s hadi %s baada ya dakika";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "sekunde %s baada ya dakika";
                }, a.prototype.everyX0Minutes = function() {
                  return "kila dakika %s";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, a.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "kati ya %s na %s";
                }, a.prototype.atX0 = function() {
                  return "kwenye %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", kila siku";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", kila siku %s ya wiki";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s hadi %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", na %s hadi %s";
                }, a.prototype.first = function() {
                  return "ya kwanza";
                }, a.prototype.second = function() {
                  return "ya pili";
                }, a.prototype.third = function() {
                  return "ya tatu";
                }, a.prototype.fourth = function() {
                  return "ya nne";
                }, a.prototype.fifth = function() {
                  return "ya tano";
                }, a.prototype.commaOnThe = function() {
                  return ", kwenye ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " siku %s ya mwezi";
                }, a.prototype.lastDay = function() {
                  return "siku ya mwisho";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", kwa %s tu";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", na pia %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", kila mwezi wa %s";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", kwa %s tu";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", siku ya mwisho wa mwezi";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", wikendi ya mwisho wa mwezi";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", siku ya %s kabla ya siku ya mwisho wa mwezi";
                }, a.prototype.firstWeekday = function() {
                  return "siku za kazi ya kwanza";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "siku ya kazi karibu na siku ya %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", kila siku %s";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", kati ya siku %s na %s ya mwezi";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", siku ya %s ya mwezi";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", kila miaka %s";
                }, a.prototype.commaStartingX0 = function() {
                  return ", kwanzia %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Jumapili", "Jumatatu", "Jumanne", "Jumatano", "Alhamisi", "Ijumaa", "Jumamosi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Januari",
                    "Februari",
                    "Machi",
                    "Aprili",
                    "Mei",
                    "Juni",
                    "Julai",
                    "Agosti",
                    "Septemba",
                    "Oktoba",
                    "Novemba",
                    "Desemba"
                  ];
                }, a;
              }();
              l.sw = c;
            }
          ),
          /***/
          312: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.th = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "เกิดข้อผิดพลาดขณะสร้างคำอธิบายนิพจน์ ตรวจสอบไวยากรณ์นิพจน์ครอน";
                }, a.prototype.everyMinute = function() {
                  return "ทุกๆ นาที";
                }, a.prototype.everyHour = function() {
                  return "ทุกๆ ชั่วโมง";
                }, a.prototype.atSpace = function() {
                  return "เมื่อ ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "ทุกๆ นาที %s และ %s";
                }, a.prototype.at = function() {
                  return "เมื่อ";
                }, a.prototype.spaceAnd = function() {
                  return " และ";
                }, a.prototype.everySecond = function() {
                  return "ทุกๆ วินาที";
                }, a.prototype.everyX0Seconds = function() {
                  return "ทุกๆ %s วินาที";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "วินาที %s ถึง %s นาทีที่ผ่านมา";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "เมื่อ %s วินาที นาทีที่ผ่านมา";
                }, a.prototype.everyX0Minutes = function() {
                  return "ทุกๆ %s นาที";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "นาที %s ถึง %s ชั่วโมงที่ผ่านมา";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "เมื่อ %s นาที ชั่วโมงที่ผ่านมา";
                }, a.prototype.everyX0Hours = function() {
                  return "ทุกๆ %s ชั่วโมง";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "ระหว่าง %s ถึง %s";
                }, a.prototype.atX0 = function() {
                  return "เมื่อ %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", ทุกๆ วัน";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ทุกๆ %s วันของสัปดาห์";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s ถึง %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s ถึง %s";
                }, a.prototype.first = function() {
                  return "แรก";
                }, a.prototype.second = function() {
                  return "ที่สอง";
                }, a.prototype.third = function() {
                  return "ที่สาม";
                }, a.prototype.fourth = function() {
                  return "ที่สี่";
                }, a.prototype.fifth = function() {
                  return "ที่ห้า";
                }, a.prototype.commaOnThe = function() {
                  return ", ในวัน ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s ของเดือน";
                }, a.prototype.lastDay = function() {
                  return "วันสุดท้าย";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ณ สุดท้าย %s ของเดือน";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", เท่านั้น %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", และใน %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", ทุกๆ %s เดือน";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", เท่านั้น %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ในวันสิ้นเดือน";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ในวันธรรมดาสุดท้ายของเดือน";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s วันก่อนวันสุดท้ายของเดือน";
                }, a.prototype.firstWeekday = function() {
                  return "วันธรรมดาวันแรก";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "วันธรรมดาที่ใกล้ที่สุด %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ในวัน %s ของเดือน";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", ทุกๆ %s วัน";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", ระหว่างวัน %s และ %s ของเดือน";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ในวัน %s ของเดือน";
                }, a.prototype.commaEveryHour = function() {
                  return ", ทุกๆ ชั่วโมง";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", ทุกๆ %s ปี";
                }, a.prototype.commaStartingX0 = function() {
                  return ", เริ่ม %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "มกราคม",
                    "กุมภาพันธ์",
                    "มีนาคม",
                    "เมษายน",
                    "พฤษภาคม",
                    "มิถุนายน",
                    "กรกฎาคม",
                    "สิงหาคม",
                    "กันยายน",
                    "ตุลาคม",
                    "พฤศจิกายน",
                    "ธันวาคม"
                  ];
                }, a;
              }();
              l.th = c;
            }
          ),
          /***/
          999: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.tr = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "her dakika";
                }, a.prototype.everyHour = function() {
                  return "her saat";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "İfade açıklamasını oluştururken bir hata oluştu. Cron ifadesini gözden geçirin.";
                }, a.prototype.atSpace = function() {
                  return "Saat ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Saat %s ve %s arasındaki her dakika";
                }, a.prototype.at = function() {
                  return "Saat";
                }, a.prototype.spaceAnd = function() {
                  return " ve";
                }, a.prototype.everySecond = function() {
                  return "her saniye";
                }, a.prototype.everyX0Seconds = function() {
                  return "her %s saniyede bir";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "dakikaların %s. ve %s. saniyeleri arası";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "dakikaların %s. saniyesinde";
                }, a.prototype.everyX0Minutes = function() {
                  return "her %s dakikada bir";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "saatlerin %s. ve %s. dakikaları arası";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "saatlerin %s. dakikasında";
                }, a.prototype.everyX0Hours = function() {
                  return "her %s saatte";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "%s ile %s arasında";
                }, a.prototype.atX0 = function() {
                  return "saat %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", her gün";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", ayın her %s günü";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s ile %s arasında";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", ve %s ile %s arasında";
                }, a.prototype.first = function() {
                  return "ilk";
                }, a.prototype.second = function() {
                  return "ikinci";
                }, a.prototype.third = function() {
                  return "üçüncü";
                }, a.prototype.fourth = function() {
                  return "dördüncü";
                }, a.prototype.fifth = function() {
                  return "beşinci";
                }, a.prototype.commaOnThe = function() {
                  return ", ayın ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s günü";
                }, a.prototype.lastDay = function() {
                  return "son gün";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", ayın son %s günü";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", sadece %s günü";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", ve %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", %s ayda bir";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", sadece %s için";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", ayın son günü";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", ayın son iş günü";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ayın son gününden önceki günler";
                }, a.prototype.firstWeekday = function() {
                  return "ilk iş günü";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "%s. günü sonrasındaki ilk iş günü";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", ayın %s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", %s günde bir";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", ayın %s. ve %s. günleri arası";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", ayın %s. günü";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", %s yılda bir";
                }, a.prototype.commaStartingX0 = function() {
                  return ", başlangıç %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Ocak",
                    "Şubat",
                    "Mart",
                    "Nisan",
                    "Mayıs",
                    "Haziran",
                    "Temmuz",
                    "Ağustos",
                    "Eylül",
                    "Ekim",
                    "Kasım",
                    "Aralık"
                  ];
                }, a;
              }();
              l.tr = c;
            }
          ),
          /***/
          716: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.uk = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !0;
                }, a.prototype.everyMinute = function() {
                  return "щохвилини";
                }, a.prototype.everyHour = function() {
                  return "щогодини";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "ВІдбулася помилка підчас генерації опису. Перевірта правильність написання cron виразу.";
                }, a.prototype.atSpace = function() {
                  return "О ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Щохвилини між %s та %s";
                }, a.prototype.at = function() {
                  return "О";
                }, a.prototype.spaceAnd = function() {
                  return " та";
                }, a.prototype.everySecond = function() {
                  return "Щосекунди";
                }, a.prototype.everyX0Seconds = function() {
                  return "кожні %s секунд";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "з %s по %s секунду";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "о %s секунді";
                }, a.prototype.everyX0Minutes = function() {
                  return "кожні %s хвилин";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "з %s по %s хвилину";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "о %s хвилині";
                }, a.prototype.everyX0Hours = function() {
                  return "кожні %s годин";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "між %s та %s";
                }, a.prototype.atX0 = function() {
                  return "о %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", щоденно";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", кожен %s день тижня";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s по %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", та %s по %s";
                }, a.prototype.first = function() {
                  return "перший";
                }, a.prototype.second = function() {
                  return "другий";
                }, a.prototype.third = function() {
                  return "третій";
                }, a.prototype.fourth = function() {
                  return "четвертий";
                }, a.prototype.fifth = function() {
                  return "п'ятий";
                }, a.prototype.commaOnThe = function() {
                  return ", в ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s місяця";
                }, a.prototype.lastDay = function() {
                  return "останній день";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", в останній %s місяця";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", тільки в %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", і в %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", кожен %s місяць";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", тільки в %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", в останній день місяця";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", в останній будень місяця";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s днів до останнього дня місяця";
                }, a.prototype.firstWeekday = function() {
                  return "перший будень";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "будень найближчий до %s дня";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", в %s місяця";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", кожен %s день";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", між %s та %s днями місяця";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", на %s день місяця";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", кожні %s роки";
                }, a.prototype.commaStartingX0 = function() {
                  return ", початок %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "січень",
                    "лютий",
                    "березень",
                    "квітень",
                    "травень",
                    "червень",
                    "липень",
                    "серпень",
                    "вересень",
                    "жовтень",
                    "листопад",
                    "грудень"
                  ];
                }, a;
              }();
              l.uk = c;
            }
          ),
          /***/
          533: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.vi = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "Đã xảy ra lỗi khi tạo mô tả biểu thức. Vui lòng kiểm tra cú pháp biểu thức cron.";
                }, a.prototype.everyMinute = function() {
                  return "mỗi phút";
                }, a.prototype.everyHour = function() {
                  return "mỗi giờ";
                }, a.prototype.atSpace = function() {
                  return "Vào ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Mỗi phút giữa %s and %s";
                }, a.prototype.at = function() {
                  return "Vào";
                }, a.prototype.spaceAnd = function() {
                  return " và";
                }, a.prototype.everySecond = function() {
                  return "mỗi giây";
                }, a.prototype.everyX0Seconds = function() {
                  return "mỗi %s giây";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "giây thứ %s qua phút thứ %s";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "tại giây thứ %s của mỗi phút";
                }, a.prototype.everyX0Minutes = function() {
                  return "mỗi %s phút";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "phút thứ %s qua %s tiếng";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "vào %s phút của mỗi tiếng";
                }, a.prototype.everyX0Hours = function() {
                  return "mỗi %s tiếng";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "giữa %s và %s";
                }, a.prototype.atX0 = function() {
                  return "vào %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", mỗi ngày";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", mỗi %s ngày trong tuần";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s đến %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s đến %s";
                }, a.prototype.first = function() {
                  return "đầu tiên";
                }, a.prototype.second = function() {
                  return "thứ 2";
                }, a.prototype.third = function() {
                  return "thứ 3";
                }, a.prototype.fourth = function() {
                  return "thứ 4";
                }, a.prototype.fifth = function() {
                  return "thứ 5";
                }, a.prototype.commaOnThe = function() {
                  return ", trên ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return " %s của tháng";
                }, a.prototype.lastDay = function() {
                  return "ngày cuối cùng";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", vào ngày %s cuối cùng của tháng";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", chỉ trên %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", và hơn %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", mỗi ngày %s tháng";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", chỉ trong %s";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", vào ngày cuối cùng của tháng";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", vào ngày cuối tuần của tháng";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s ngày trước ngày cuối cùng của tháng";
                }, a.prototype.firstWeekday = function() {
                  return "ngày đầu tuần";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "ngày trong tuần ngày gần nhất %s";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", vào ngày %s của tháng";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", mỗi %s ngày";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", giữa ngày %s và %s trong tháng";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", vào %s ngày trong tháng";
                }, a.prototype.commaEveryHour = function() {
                  return ", mỗi tiếng";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", mỗi %s năm";
                }, a.prototype.commaStartingX0 = function() {
                  return ", bắt đầu %s";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
                }, a.prototype.monthsOfTheYear = function() {
                  return [
                    "Tháng 1",
                    "Tháng 2",
                    "Tháng 3",
                    "Tháng 4",
                    "Tháng 5",
                    "Tháng 6",
                    "Tháng 7",
                    "Tháng 8",
                    "Tháng 9",
                    "Tháng 10",
                    "Tháng 11",
                    "Tháng 12"
                  ];
                }, a;
              }();
              l.vi = c;
            }
          ),
          /***/
          419: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.zh_CN = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.setPeriodBeforeTime = function() {
                  return !0;
                }, a.prototype.pm = function() {
                  return "下午";
                }, a.prototype.am = function() {
                  return "上午";
                }, a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", 从%s年至%s年";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "每分钟";
                }, a.prototype.everyHour = function() {
                  return "每小时";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "生成表达式描述时发生了错误，请检查cron表达式语法。";
                }, a.prototype.atSpace = function() {
                  return "在";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "在 %s 至 %s 之间的每分钟";
                }, a.prototype.at = function() {
                  return "在";
                }, a.prototype.spaceAnd = function() {
                  return " 和";
                }, a.prototype.everySecond = function() {
                  return "每秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "每隔 %s 秒";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "在每分钟的第 %s 到 %s 秒";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "在每分钟的第 %s 秒";
                }, a.prototype.everyX0Minutes = function() {
                  return "每隔 %s 分钟";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "在每小时的第 %s 到 %s 分钟";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "在每小时的第 %s 分钟";
                }, a.prototype.everyX0Hours = function() {
                  return "每隔 %s 小时";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "在 %s 和 %s 之间";
                }, a.prototype.atX0 = function() {
                  return "在%s";
                }, a.prototype.commaEveryDay = function() {
                  return ", 每天";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 每周的每 %s 天";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s至%s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 和%s至%s";
                }, a.prototype.first = function() {
                  return "第一个";
                }, a.prototype.second = function() {
                  return "第二个";
                }, a.prototype.third = function() {
                  return "第三个";
                }, a.prototype.fourth = function() {
                  return "第四个";
                }, a.prototype.fifth = function() {
                  return "第五个";
                }, a.prototype.commaOnThe = function() {
                  return ", 限每月的";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "%s";
                }, a.prototype.lastDay = function() {
                  return "本月最后一天";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 限每月的最后一个%s";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", 仅%s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 并且为%s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", 每隔 %s 个月";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", 仅限%s";
                }, a.prototype.commaOnlyInMonthX0 = function() {
                  return ", 仅于%s份";
                }, a.prototype.commaOnlyInYearX0 = function() {
                  return ", 仅于 %s 年";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 限每月的最后一天";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 限每月的最后一个工作日";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", 限每月最后%s天";
                }, a.prototype.firstWeekday = function() {
                  return "第一个工作日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "最接近 %s 号的工作日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 限每月的%s";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", 每隔 %s 天";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 限每月的 %s 至 %s 之间";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 限每月%s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", 每隔 %s 年";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s开始";
                }, a.prototype.dayX0 = function() {
                  return " %s 号";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                }, a;
              }();
              l.zh_CN = c;
            }
          ),
          /***/
          139: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.zh_TW = void 0;
              var c = function() {
                function a() {
                }
                return a.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, a.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, a.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, a.prototype.commaYearX0ThroughYearX1 = function() {
                  return ", 從 %s 年至 %s 年";
                }, a.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, a.prototype.everyMinute = function() {
                  return "每分鐘";
                }, a.prototype.everyHour = function() {
                  return "每小時";
                }, a.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "產生表達式描述時發生了錯誤，請檢查 cron 表達式語法。";
                }, a.prototype.atSpace = function() {
                  return "在 ";
                }, a.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "在 %s 和 %s 之間的每分鐘";
                }, a.prototype.at = function() {
                  return "在";
                }, a.prototype.spaceAnd = function() {
                  return " 和";
                }, a.prototype.everySecond = function() {
                  return "每秒";
                }, a.prototype.everyX0Seconds = function() {
                  return "每 %s 秒";
                }, a.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "在每分鐘的 %s 到 %s 秒";
                }, a.prototype.atX0SecondsPastTheMinute = function() {
                  return "在每分鐘的 %s 秒";
                }, a.prototype.everyX0Minutes = function() {
                  return "每 %s 分鐘";
                }, a.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "在每小時的 %s 到 %s 分鐘";
                }, a.prototype.atX0MinutesPastTheHour = function() {
                  return "在每小時的 %s 分";
                }, a.prototype.everyX0Hours = function() {
                  return "每 %s 小時";
                }, a.prototype.betweenX0AndX1 = function() {
                  return "在 %s 和 %s 之間";
                }, a.prototype.atX0 = function() {
                  return "在 %s";
                }, a.prototype.commaEveryDay = function() {
                  return ", 每天";
                }, a.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", 每週的每 %s 天";
                }, a.prototype.commaX0ThroughX1 = function() {
                  return ", %s 到 %s";
                }, a.prototype.commaAndX0ThroughX1 = function() {
                  return ", 和 %s 到 %s";
                }, a.prototype.first = function() {
                  return "第一個";
                }, a.prototype.second = function() {
                  return "第二個";
                }, a.prototype.third = function() {
                  return "第三個";
                }, a.prototype.fourth = function() {
                  return "第四個";
                }, a.prototype.fifth = function() {
                  return "第五個";
                }, a.prototype.commaOnThe = function() {
                  return ", 在每月 ";
                }, a.prototype.spaceX0OfTheMonth = function() {
                  return "%s ";
                }, a.prototype.lastDay = function() {
                  return "最後一天";
                }, a.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", 每月的最後一個 %s ";
                }, a.prototype.commaOnlyOnX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaAndOnX0 = function() {
                  return ", 和 %s";
                }, a.prototype.commaEveryX0Months = function() {
                  return ", 每 %s 月";
                }, a.prototype.commaOnlyInX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaOnlyInMonthX0 = function() {
                  return ", 僅在 %s";
                }, a.prototype.commaOnlyInYearX0 = function() {
                  return ", 僅在 %s 年";
                }, a.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", 每月的最後一天";
                }, a.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", 每月的最後一個工作日";
                }, a.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s 這個月的最後一天的前幾天";
                }, a.prototype.firstWeekday = function() {
                  return "第一個工作日";
                }, a.prototype.weekdayNearestDayX0 = function() {
                  return "最接近 %s 號的工作日";
                }, a.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", 每月的 %s ";
                }, a.prototype.commaEveryX0Days = function() {
                  return ", 每 %s 天";
                }, a.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", 在每月的 %s 和 %s 之間";
                }, a.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", 每月的 %s";
                }, a.prototype.commaEveryX0Years = function() {
                  return ", 每 %s 年";
                }, a.prototype.commaStartingX0 = function() {
                  return ", %s 開始";
                }, a.prototype.dayX0 = function() {
                  return " %s 號";
                }, a.prototype.daysOfTheWeek = function() {
                  return ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                }, a.prototype.monthsOfTheYear = function() {
                  return ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
                }, a;
              }();
              l.zh_TW = c;
            }
          ),
          /***/
          586: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 });
              function c(u, f) {
                if (!u)
                  throw new Error(f);
              }
              var a = function() {
                function u() {
                }
                return u.secondRange = function(f) {
                  for (var d = f.split(","), p = 0; p < d.length; p++)
                    if (!isNaN(parseInt(d[p], 10))) {
                      var h = parseInt(d[p], 10);
                      c(h >= 0 && h <= 59, "seconds part must be >= 0 and <= 59");
                    }
                }, u.minuteRange = function(f) {
                  for (var d = f.split(","), p = 0; p < d.length; p++)
                    if (!isNaN(parseInt(d[p], 10))) {
                      var h = parseInt(d[p], 10);
                      c(h >= 0 && h <= 59, "minutes part must be >= 0 and <= 59");
                    }
                }, u.hourRange = function(f) {
                  for (var d = f.split(","), p = 0; p < d.length; p++)
                    if (!isNaN(parseInt(d[p], 10))) {
                      var h = parseInt(d[p], 10);
                      c(h >= 0 && h <= 23, "hours part must be >= 0 and <= 23");
                    }
                }, u.dayOfMonthRange = function(f) {
                  for (var d = f.split(","), p = 0; p < d.length; p++)
                    if (!isNaN(parseInt(d[p], 10))) {
                      var h = parseInt(d[p], 10);
                      c(h >= 1 && h <= 31, "DOM part must be >= 1 and <= 31");
                    }
                }, u.monthRange = function(f, d) {
                  for (var p = f.split(","), h = 0; h < p.length; h++)
                    if (!isNaN(parseInt(p[h], 10))) {
                      var m = parseInt(p[h], 10);
                      c(m >= 1 && m <= 12, d ? "month part must be >= 0 and <= 11" : "month part must be >= 1 and <= 12");
                    }
                }, u.dayOfWeekRange = function(f, d) {
                  for (var p = f.split(","), h = 0; h < p.length; h++)
                    if (!isNaN(parseInt(p[h], 10))) {
                      var m = parseInt(p[h], 10);
                      c(m >= 0 && m <= 6, d ? "DOW part must be >= 0 and <= 6" : "DOW part must be >= 1 and <= 7");
                    }
                }, u;
              }();
              l.default = a;
            }
          ),
          /***/
          910: (
            /***/
            (s, l) => {
              Object.defineProperty(l, "__esModule", { value: !0 }), l.StringUtilities = void 0;
              var c = function() {
                function a() {
                }
                return a.format = function(u) {
                  for (var f = [], d = 1; d < arguments.length; d++)
                    f[d - 1] = arguments[d];
                  return u.replace(/%s/g, function(p) {
                    return f.shift();
                  });
                }, a.containsAny = function(u, f) {
                  return f.some(function(d) {
                    return u.indexOf(d) > -1;
                  });
                }, a;
              }();
              l.StringUtilities = c;
            }
          )
          /******/
        }, r = {};
        function i(s) {
          var l = r[s];
          if (l !== void 0)
            return l.exports;
          var c = r[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[s](c, c.exports, i), c.exports;
        }
        var o = {};
        return (() => {
          var s = o;
          Object.defineProperty(s, "__esModule", { value: !0 }), s.toString = void 0;
          var l = i(728), c = i(282);
          l.ExpressionDescriptor.initialize(new c.allLocalesLoader()), s.default = l.ExpressionDescriptor;
          var a = l.ExpressionDescriptor.toString;
          s.toString = a;
        })(), o;
      })()
    ));
  }(b4)), b4.exports;
}
var O4, Ife;
function bWt() {
  if (Ife) return O4;
  Ife = 1;
  var e = vWt();
  return O4 = e, O4;
}
var OWt = bWt();
const AWt = /* @__PURE__ */ Sl(OWt), wWt = async (e) => {
  const t = await yi.getTemplate(e, {});
  gxe({
    obj: JSON.stringify(t, null, 2),
    fileName: t.name,
    extension: "json"
  });
}, xWt = async (e) => {
  const t = new Tve();
  for (const n of e) {
    const r = await yi.getTemplate(n.id, {});
    t.file(
      `${n.version.displayName}_${n.id}.json`,
      JSON.stringify(r, null, 2)
    );
  }
  return t;
}, K_ = {
  downloadFlow: wWt,
  zipFlows: xWt,
  flowStatusToolTipRenderer: (e) => {
    var n, r;
    const t = e.version.trigger;
    switch (t == null ? void 0 : t.type) {
      case Bt.PIECE: {
        const i = (r = (n = e.triggerSource) == null ? void 0 : n.schedule) == null ? void 0 : r.cronExpression;
        return i ? `${Z("Run")} ${AWt.toString(i, { locale: "en" }).toLocaleLowerCase()}` : Z("Real time flow");
      }
      case Bt.EMPTY:
        return console.error(
          Z("Flow can't be published with empty trigger {name}", {
            name: e.version.displayName
          })
        ), Z("Please contact support as your published flow has a problem");
    }
  },
  flowStatusIconRenderer: (e) => {
    var n, r;
    const t = e.version.trigger;
    switch (t == null ? void 0 : t.type) {
      case Bt.PIECE:
        return ((r = (n = e.triggerSource) == null ? void 0 : n.schedule) == null ? void 0 : r.cronExpression) ? /* @__PURE__ */ y(cst, { className: "h-4 w-4 text-foreground" }) : /* @__PURE__ */ y(Sst, { className: "h-4 w-4 text-foreground fill-foreground" });
      case Bt.EMPTY:
        return console.error(
          Z("Flow can't be published with empty trigger {name}", {
            name: e.version.displayName
          })
        ), /* @__PURE__ */ y(gz, { className: "h-4 w-4 text-destructive" });
    }
  }
}, Rfe = (e) => ["flows", e], xl = {
  invalidateFlowsQuery: (e) => {
    e.invalidateQueries({
      queryKey: Rfe(Rn.getProjectId())
    });
  },
  useFlows: (e) => pr({
    queryKey: Rfe(Rn.getProjectId()),
    queryFn: async () => await yi.list({
      ...e,
      projectId: Rn.getProjectId()
    }),
    staleTime: 5 * 1e3
  }),
  useChangeFlowStatus: ({
    flowId: e,
    change: t,
    onSuccess: n,
    setIsPublishing: r
  }) => {
    const { data: i } = Go.useFlag(
      As.ENABLE_FLOW_ON_PUBLISH
    ), o = Zv(), { openDialog: s } = Kje();
    return dr({
      mutationFn: async () => {
        var l, c, a, u, f, d, p;
        t === "publish" && (r == null || r(!0));
        try {
          return await new Promise(
            (h, m) => {
              const v = (b) => {
                console.log("Received FLOW_STATUS_UPDATED websocket event", b), b.flow.id === e && (o.off(
                  pi.FLOW_STATUS_UPDATED,
                  v
                ), h(b));
              };
              o.on(pi.FLOW_STATUS_UPDATED, v), yi.update(e, {
                type: t === "publish" ? Tt.LOCK_AND_PUBLISH : Tt.CHANGE_STATUS,
                request: {
                  status: t === "publish" ? i ? il.ENABLED : il.DISABLED : t
                }
              }).then(() => {
                console.log("SENT FLOW STATUS UPDATE REQUEST");
              }).catch((b) => {
                console.log("Error while sending flow status update request", b);
                try {
                  o.off(
                    pi.FLOW_STATUS_UPDATED,
                    v
                  );
                } catch (A) {
                  console.error("Failed to turn off socket listener", A);
                }
                m(b);
              });
            }
          );
        } catch (h) {
          console.error("Publish mutationFn caught error, resetting isPublishing", h), t === "publish" && (r == null || r(!1));
          const m = (c = (l = h == null ? void 0 : h.response) == null ? void 0 : l.data) == null ? void 0 : c.code, v = (f = (u = (a = h == null ? void 0 : h.response) == null ? void 0 : a.data) == null ? void 0 : u.params) == null ? void 0 : f.message, b = (p = (d = h == null ? void 0 : h.response) == null ? void 0 : d.data) == null ? void 0 : p.detail;
          throw m === Ni.FLOW_OPERATION_IN_PROGRESS && v ? vr.error(Z("Flow Is Busy"), {
            description: v,
            duration: 5e3
          }) : typeof b == "string" ? vr.error(Z(t === "publish" ? "Publish failed" : "Status update failed"), {
            description: b,
            duration: 5e3
          }) : Kc(), h;
        }
      },
      onSuccess: (l) => {
        if (console.log("In flow Hooks useChangeFlowStatus onSuccess", l), t === "publish" && (console.log("Setting isPublishing to false"), r == null || r(!1)), !De(l.error)) {
          s({
            title: Z(t === "publish" ? "Publish failed" : "Status update failed"),
            description: /* @__PURE__ */ y("p", { children: Z(
              "An error occurred while changing the flow status. This may be due to an issue in the trigger piece or its settings."
            ) }),
            error: {
              standardError: l.error.params.standardError,
              standardOutput: l.error.params.standardOutput || ""
            }
          });
          return;
        }
        n == null || n(l);
      },
      onError: (l) => {
        var f, d, p, h, m, v, b;
        console.log("Error occured while changing flow status", l), t === "publish" && (r == null || r(!1));
        const c = (d = (f = l == null ? void 0 : l.response) == null ? void 0 : f.data) == null ? void 0 : d.code, a = (m = (h = (p = l == null ? void 0 : l.response) == null ? void 0 : p.data) == null ? void 0 : h.params) == null ? void 0 : m.message, u = (b = (v = l == null ? void 0 : l.response) == null ? void 0 : v.data) == null ? void 0 : b.detail;
        c === Ni.FLOW_OPERATION_IN_PROGRESS && a ? vr.error(Z("Flow Is Busy"), {
          description: a,
          duration: 5e3
        }) : typeof u == "string" ? vr.error(Z("Publish failed"), {
          description: u,
          duration: 5e3
        }) : Kc();
      }
    });
  },
  useExportFlows: () => dr({
    mutationFn: async (e) => e.length === 0 ? e : e.length === 1 ? (await K_.downloadFlow(e[0].id), e) : (await gxe({
      obj: await K_.zipFlows(e),
      fileName: "flows",
      extension: "zip"
    }), e),
    onSuccess: (e) => {
      e.length > 0 && vr.success(
        e.length === 1 ? Z("{{name}} has been exported.", {
          name: e[0].version.displayName
        }) : Z("Flows have been exported."),
        {
          duration: 3e3
        }
      );
    }
  }),
  useFetchFlowVersion: ({
    onSuccess: e
  }) => dr({
    mutationFn: async (t) => (await yi.get(t.flowId, {
      versionId: t.id
    })).version,
    onSuccess: e
  }),
  useOverWriteDraftWithVersion: ({
    onSuccess: e
  }) => dr({
    mutationFn: async ({ flowId: t, versionId: n }) => await yi.update(t, {
      type: Tt.USE_AS_DRAFT,
      request: {
        versionId: n
      }
    }),
    onSuccess: e
  }),
  useCreateMcpFlow: () => {
    const e = sT();
    return dr({
      mutationFn: async () => {
        const t = await yi.create({
          projectId: Rn.getProjectId(),
          displayName: Z("Untitled")
        }), n = await Yd.get({
          name: "@activepieces/piece-mcp"
        }), r = n.triggers.mcp_tool;
        if (!r)
          throw new Error("MCP trigger not found");
        const i = xf.getDefaultStepValues({
          stepName: "trigger",
          pieceSelectorItem: {
            actionOrTrigger: r,
            type: Bt.PIECE,
            pieceMetadata: KO.mapPieceToMetadata({
              piece: n,
              type: "trigger"
            })
          }
        });
        return await yi.update(t.id, {
          type: Tt.UPDATE_TRIGGER,
          request: i
        }), t;
      },
      onSuccess: (t) => {
        e(`/flows/${t.id}/`);
      }
    });
  },
  useGetFlow: (e) => pr({
    queryKey: ["flow", e],
    queryFn: async () => {
      try {
        return await yi.get(e);
      } catch (t) {
        return console.error(t), null;
      }
    },
    staleTime: 0
  }),
  useTestFlow: ({
    flowVersionId: e,
    onUpdateRun: t
  }) => {
    const n = Zv();
    return dr({
      mutationFn: () => _x.testFlow(
        n,
        {
          flowVersionId: e
        },
        t
      )
    });
  },
  useListFlowVersions: (e) => pr({
    queryKey: ["flow-versions", e],
    queryFn: () => yi.listVersions(e, {
      limit: 1e3,
      cursor: void 0
    }),
    staleTime: 0
  }),
  useGetFlowVersionNumber: ({
    flowId: e,
    versionId: t
  }) => {
    const { data: n } = xl.useListFlowVersions(e);
    return n != null && n.data ? n.data.length - n.data.findIndex((r) => r.id === t) : "";
  },
  useStartFromScratch: (e) => {
    const t = sT();
    return dr({
      mutationFn: async () => {
        const n = e !== ZM ? await Gje.get(e) : void 0;
        return await yi.create({
          projectId: Rn.getProjectId(),
          displayName: Z("Untitled"),
          folderName: n == null ? void 0 : n.displayName
        });
      },
      onSuccess: (n) => {
        t(`/flows/${n.id}?${mxe}=true`);
      }
    });
  },
  importFlowIntoExisting: async ({
    template: e,
    existingFlowId: t
  }) => {
    var c;
    const n = e.flows || [];
    if (n.length === 0)
      throw new Error("Template has no flows");
    const r = n[0], i = await yi.get(t), o = De((c = e.metadata) == null ? void 0 : c.externalId) ? i.externalId : e.metadata.externalId, s = JSON.stringify(r.trigger).replaceAll(
      o,
      i.externalId
    ), l = JSON.parse(s);
    return await yi.update(i.id, {
      type: Tt.IMPORT_FLOW,
      request: {
        displayName: r.displayName,
        trigger: l,
        schemaVersion: r.schemaVersion
      }
    }, !0);
  },
  importFlowsFromTemplates: async ({
    templates: e,
    projectId: t,
    folderName: n
  }) => {
    var s;
    if (e.length === 0)
      return [];
    const r = [];
    for (const l of e) {
      const c = l.flows || [];
      if (c.length !== 0)
        for (const a of c) {
          const u = await yi.create({
            displayName: a.displayName,
            projectId: t,
            folderName: n
          }), f = De((s = l.metadata) == null ? void 0 : s.externalId) ? u.externalId : l.metadata.externalId;
          r.push({
            flow: u,
            templateFlow: a,
            oldExternalId: f
          });
        }
    }
    const i = /* @__PURE__ */ new Map();
    for (const { oldExternalId: l, flow: c } of r)
      i.set(l, c.externalId);
    const o = r.map(
      async ({ flow: l, templateFlow: c }) => {
        let a = JSON.stringify(c.trigger);
        for (const [f, d] of i.entries())
          a = a.replaceAll(f, d);
        const u = JSON.parse(a);
        return await yi.update(l.id, {
          type: Tt.IMPORT_FLOW,
          request: {
            displayName: c.displayName,
            trigger: u,
            schemaVersion: c.schemaVersion,
            notes: c.notes
          }
        }, !0);
      }
    );
    return await Promise.all(o);
  }
}, yc = () => {
  const { flowId: e } = ol(), { data: t, isLoading: n, isError: r } = pr({
    queryKey: ["flow-role", e],
    queryFn: async () => await pxe.getFlowRole(e),
    retry: !1,
    enabled: !0
  });
  return { checkAccess: (o) => {
    var s;
    return n || r ? !0 : ((s = t == null ? void 0 : t.permissions) == null ? void 0 : s.includes(o)) ?? !0;
  } };
}, SWt = () => !1, tb = ie.forwardRef(({ children: e, hasPermission: t }, n) => /* @__PURE__ */ V(wn, { delayDuration: 100, children: [
  /* @__PURE__ */ y(kn, { ref: n, asChild: !0, disabled: !t, children: /* @__PURE__ */ y("div", { children: e }) }),
  !t && /* @__PURE__ */ y(An, { side: "top", children: Z("Permission needed") })
] }));
tb.displayName = "PermissionNeededWrapper";
const EWt = as(
  "flex relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        warning: "border-warning/50 text-warning-300 dark:border-warning [&>svg]:text-warning",
        destructive: "border-destructive/50 text-destructive-300 dark:border-destructive [&>svg]:text-destructive",
        primary: "border-primary/50 text-primary bg-primary-100/10 dark:border-primary [&>svg]:text-primary"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), h3 = N.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ y(
  "div",
  {
    ref: r,
    role: "alert",
    className: Se(EWt({ variant: t }), e),
    ...n
  }
));
h3.displayName = "Alert";
const Yje = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "h5",
  {
    ref: n,
    className: Se("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
Yje.displayName = "AlertTitle";
const m3 = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    className: Se("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
m3.displayName = "AlertDescription";
var TWt = [" ", "Enter", "ArrowUp", "ArrowDown"], kWt = [" ", "Enter"], jN = "Select", [g3, y3, CWt] = Jz(jN), [Lx, Imn] = Ms(jN, [
  CWt,
  _f
]), v3 = _f(), [NWt, zg] = Lx(jN), [PWt, IWt] = Lx(jN), Jje = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    value: s,
    defaultValue: l,
    onValueChange: c,
    dir: a,
    name: u,
    autoComplete: f,
    disabled: d,
    required: p
  } = e, h = v3(t), [m, v] = N.useState(null), [b, A] = N.useState(null), [w, O] = N.useState(!1), x = Eb(a), [S = !1, E] = wl({
    prop: r,
    defaultProp: i,
    onChange: o
  }), [k, T] = wl({
    prop: s,
    defaultProp: l,
    onChange: c
  }), R = N.useRef(null), j = m ? !!m.closest("form") : !0, [F, L] = N.useState(/* @__PURE__ */ new Set()), _ = Array.from(F).map((U) => U.props.value).join(";");
  return /* @__PURE__ */ y(ox, { ...h, children: /* @__PURE__ */ V(
    NWt,
    {
      required: p,
      scope: t,
      trigger: m,
      onTriggerChange: v,
      valueNode: b,
      onValueNodeChange: A,
      valueNodeHasChildren: w,
      onValueNodeHasChildrenChange: O,
      contentId: ka(),
      value: k,
      onValueChange: T,
      open: S,
      onOpenChange: E,
      dir: x,
      triggerPointerDownPosRef: R,
      disabled: d,
      children: [
        /* @__PURE__ */ y(g3.Provider, { scope: t, children: /* @__PURE__ */ y(
          PWt,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: N.useCallback((U) => {
              L((z) => new Set(z).add(U));
            }, []),
            onNativeOptionRemove: N.useCallback((U) => {
              L((z) => {
                const C = new Set(z);
                return C.delete(U), C;
              });
            }, []),
            children: n
          }
        ) }),
        j ? /* @__PURE__ */ V(
          E3e,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: k,
            onChange: (U) => T(U.target.value),
            disabled: d,
            children: [
              k === void 0 ? /* @__PURE__ */ y("option", { value: "" }) : null,
              Array.from(F)
            ]
          },
          _
        ) : null
      ]
    }
  ) });
};
Jje.displayName = jN;
var e3e = "SelectTrigger", t3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, o = v3(n), s = zg(e3e, n), l = s.disabled || r, c = xn(t, s.onTriggerChange), a = y3(n), [u, f, d] = T3e((h) => {
      const m = a().filter((A) => !A.disabled), v = m.find((A) => A.value === s.value), b = k3e(m, h, v);
      b !== void 0 && s.onValueChange(b.value);
    }), p = () => {
      l || (s.onOpenChange(!0), d());
    };
    return /* @__PURE__ */ y(sx, { asChild: !0, ...o, children: /* @__PURE__ */ y(
      Zt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": S3e(s.value) ? "" : void 0,
        ...i,
        ref: c,
        onClick: ot(i.onClick, (h) => {
          h.currentTarget.focus();
        }),
        onPointerDown: ot(i.onPointerDown, (h) => {
          const m = h.target;
          m.hasPointerCapture(h.pointerId) && m.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && (p(), s.triggerPointerDownPosRef.current = {
            x: Math.round(h.pageX),
            y: Math.round(h.pageY)
          }, h.preventDefault());
        }),
        onKeyDown: ot(i.onKeyDown, (h) => {
          const m = u.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && f(h.key), !(m && h.key === " ") && TWt.includes(h.key) && (p(), h.preventDefault());
        })
      }
    ) });
  }
);
t3e.displayName = e3e;
var n3e = "SelectValue", r3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: o, placeholder: s = "", ...l } = e, c = zg(n3e, n), { onValueNodeHasChildrenChange: a } = c, u = o !== void 0, f = xn(t, c.onValueNodeChange);
    return qi(() => {
      a(u);
    }, [a, u]), /* @__PURE__ */ y(
      Zt.span,
      {
        ...l,
        ref: f,
        style: { pointerEvents: "none" },
        children: S3e(c.value) ? /* @__PURE__ */ y(pt, { children: s }) : o
      }
    );
  }
);
r3e.displayName = n3e;
var RWt = "SelectIcon", i3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ y(Zt.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
i3e.displayName = RWt;
var MWt = "SelectPortal", o3e = (e) => /* @__PURE__ */ y(ax, { asChild: !0, ...e });
o3e.displayName = MWt;
var nb = "SelectContent", s3e = N.forwardRef(
  (e, t) => {
    const n = zg(nb, e.__scopeSelect), [r, i] = N.useState();
    if (qi(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const o = r;
      return o ? sb.createPortal(
        /* @__PURE__ */ y(a3e, { scope: e.__scopeSelect, children: /* @__PURE__ */ y(g3.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ y("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ y(l3e, { ...e, ref: t });
  }
);
s3e.displayName = nb;
var Sp = 10, [a3e, jg] = Lx(nb), DWt = "SelectContentImpl", l3e = N.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: a,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: d,
      collisionPadding: p,
      sticky: h,
      hideWhenDetached: m,
      avoidCollisions: v,
      //
      ...b
    } = e, A = zg(nb, n), [w, O] = N.useState(null), [x, S] = N.useState(null), E = xn(t, (oe) => O(oe)), [k, T] = N.useState(null), [R, j] = N.useState(
      null
    ), F = y3(n), [L, _] = N.useState(!1), U = N.useRef(!1);
    N.useEffect(() => {
      if (w) return ux(w);
    }, [w]), Ez();
    const z = N.useCallback(
      (oe) => {
        const [ce, ...fe] = F().map((ee) => ee.ref.current), [$] = fe.slice(-1), pe = document.activeElement;
        for (const ee of oe)
          if (ee === pe || (ee == null || ee.scrollIntoView({ block: "nearest" }), ee === ce && x && (x.scrollTop = 0), ee === $ && x && (x.scrollTop = x.scrollHeight), ee == null || ee.focus(), document.activeElement !== pe)) return;
      },
      [F, x]
    ), C = N.useCallback(
      () => z([k, w]),
      [z, k, w]
    );
    N.useEffect(() => {
      L && C();
    }, [L, C]);
    const { onOpenChange: I, triggerPointerDownPosRef: M } = A;
    N.useEffect(() => {
      if (w) {
        let oe = { x: 0, y: 0 };
        const ce = ($) => {
          var pe, ee;
          oe = {
            x: Math.abs(Math.round($.pageX) - (((pe = M.current) == null ? void 0 : pe.x) ?? 0)),
            y: Math.abs(Math.round($.pageY) - (((ee = M.current) == null ? void 0 : ee.y) ?? 0))
          };
        }, fe = ($) => {
          oe.x <= 10 && oe.y <= 10 ? $.preventDefault() : w.contains($.target) || I(!1), document.removeEventListener("pointermove", ce), M.current = null;
        };
        return M.current !== null && (document.addEventListener("pointermove", ce), document.addEventListener("pointerup", fe, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", ce), document.removeEventListener("pointerup", fe, { capture: !0 });
        };
      }
    }, [w, I, M]), N.useEffect(() => {
      const oe = () => I(!1);
      return window.addEventListener("blur", oe), window.addEventListener("resize", oe), () => {
        window.removeEventListener("blur", oe), window.removeEventListener("resize", oe);
      };
    }, [I]);
    const [D, X] = T3e((oe) => {
      const ce = F().filter((pe) => !pe.disabled), fe = ce.find((pe) => pe.ref.current === document.activeElement), $ = k3e(ce, oe, fe);
      $ && setTimeout(() => $.ref.current.focus());
    }), B = N.useCallback(
      (oe, ce, fe) => {
        const $ = !U.current && !fe;
        (A.value !== void 0 && A.value === ce || $) && (T(oe), $ && (U.current = !0));
      },
      [A.value]
    ), q = N.useCallback(() => w == null ? void 0 : w.focus(), [w]), H = N.useCallback(
      (oe, ce, fe) => {
        const $ = !U.current && !fe;
        (A.value !== void 0 && A.value === ce || $) && j(oe);
      },
      [A.value]
    ), Y = r === "popper" ? z8 : c3e, J = Y === z8 ? {
      side: l,
      sideOffset: c,
      align: a,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: d,
      collisionPadding: p,
      sticky: h,
      hideWhenDetached: m,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ y(
      a3e,
      {
        scope: n,
        content: w,
        viewport: x,
        onViewportChange: S,
        itemRefCallback: B,
        selectedItem: k,
        onItemLeave: q,
        itemTextRefCallback: H,
        focusSelectedItem: C,
        selectedItemText: R,
        position: r,
        isPositioned: L,
        searchRef: D,
        children: /* @__PURE__ */ y(eN, { as: is, allowPinchZoom: !0, children: /* @__PURE__ */ y(
          lx,
          {
            asChild: !0,
            trapped: A.open,
            onMountAutoFocus: (oe) => {
              oe.preventDefault();
            },
            onUnmountAutoFocus: ot(i, (oe) => {
              var ce;
              (ce = A.trigger) == null || ce.focus({ preventScroll: !0 }), oe.preventDefault();
            }),
            children: /* @__PURE__ */ y(
              nx,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: s,
                onFocusOutside: (oe) => oe.preventDefault(),
                onDismiss: () => A.onOpenChange(!1),
                children: /* @__PURE__ */ y(
                  Y,
                  {
                    role: "listbox",
                    id: A.contentId,
                    "data-state": A.open ? "open" : "closed",
                    dir: A.dir,
                    onContextMenu: (oe) => oe.preventDefault(),
                    ...b,
                    ...J,
                    onPlaced: () => _(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: ot(b.onKeyDown, (oe) => {
                      const ce = oe.ctrlKey || oe.altKey || oe.metaKey;
                      if (oe.key === "Tab" && oe.preventDefault(), !ce && oe.key.length === 1 && X(oe.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(oe.key)) {
                        let $ = F().filter((pe) => !pe.disabled).map((pe) => pe.ref.current);
                        if (["ArrowUp", "End"].includes(oe.key) && ($ = $.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(oe.key)) {
                          const pe = oe.target, ee = $.indexOf(pe);
                          $ = $.slice(ee + 1);
                        }
                        setTimeout(() => z($)), oe.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
l3e.displayName = DWt;
var _Wt = "SelectItemAlignedPosition", c3e = N.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, o = zg(nb, n), s = jg(nb, n), [l, c] = N.useState(null), [a, u] = N.useState(null), f = xn(t, (E) => u(E)), d = y3(n), p = N.useRef(!1), h = N.useRef(!0), { viewport: m, selectedItem: v, selectedItemText: b, focusSelectedItem: A } = s, w = N.useCallback(() => {
    if (o.trigger && o.valueNode && l && a && m && v && b) {
      const E = o.trigger.getBoundingClientRect(), k = a.getBoundingClientRect(), T = o.valueNode.getBoundingClientRect(), R = b.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const pe = R.left - k.left, ee = T.left - pe, Ce = E.left - ee, Ee = E.width + Ce, Ve = Math.max(Ee, k.width), et = window.innerWidth - Sp, ft = GB(ee, [Sp, et - Ve]);
        l.style.minWidth = Ee + "px", l.style.left = ft + "px";
      } else {
        const pe = k.right - R.right, ee = window.innerWidth - T.right - pe, Ce = window.innerWidth - E.right - ee, Ee = E.width + Ce, Ve = Math.max(Ee, k.width), et = window.innerWidth - Sp, ft = GB(ee, [Sp, et - Ve]);
        l.style.minWidth = Ee + "px", l.style.right = ft + "px";
      }
      const j = d(), F = window.innerHeight - Sp * 2, L = m.scrollHeight, _ = window.getComputedStyle(a), U = parseInt(_.borderTopWidth, 10), z = parseInt(_.paddingTop, 10), C = parseInt(_.borderBottomWidth, 10), I = parseInt(_.paddingBottom, 10), M = U + z + L + I + C, D = Math.min(v.offsetHeight * 5, M), X = window.getComputedStyle(m), B = parseInt(X.paddingTop, 10), q = parseInt(X.paddingBottom, 10), H = E.top + E.height / 2 - Sp, Y = F - H, J = v.offsetHeight / 2, oe = v.offsetTop + J, ce = U + z + oe, fe = M - ce;
      if (ce <= H) {
        const pe = v === j[j.length - 1].ref.current;
        l.style.bottom = "0px";
        const ee = a.clientHeight - m.offsetTop - m.offsetHeight, Ce = Math.max(
          Y,
          J + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (pe ? q : 0) + ee + C
        ), Ee = ce + Ce;
        l.style.height = Ee + "px";
      } else {
        const pe = v === j[0].ref.current;
        l.style.top = "0px";
        const Ce = Math.max(
          H,
          U + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (pe ? B : 0) + J
        ) + fe;
        l.style.height = Ce + "px", m.scrollTop = ce - H + m.offsetTop;
      }
      l.style.margin = `${Sp}px 0`, l.style.minHeight = D + "px", l.style.maxHeight = F + "px", r == null || r(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    d,
    o.trigger,
    o.valueNode,
    l,
    a,
    m,
    v,
    b,
    o.dir,
    r
  ]);
  qi(() => w(), [w]);
  const [O, x] = N.useState();
  qi(() => {
    a && x(window.getComputedStyle(a).zIndex);
  }, [a]);
  const S = N.useCallback(
    (E) => {
      E && h.current === !0 && (w(), A == null || A(), h.current = !1);
    },
    [w, A]
  );
  return /* @__PURE__ */ y(
    zWt,
    {
      scope: n,
      contentWrapper: l,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ y(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: O
          },
          children: /* @__PURE__ */ y(
            Zt.div,
            {
              ...i,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
c3e.displayName = _Wt;
var LWt = "SelectPopperPosition", z8 = N.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Sp,
    ...o
  } = e, s = v3(n);
  return /* @__PURE__ */ y(
    KC,
    {
      ...s,
      ...o,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
z8.displayName = LWt;
var [zWt, IY] = Lx(nb, {}), j8 = "SelectViewport", u3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, o = jg(j8, n), s = IY(j8, n), l = xn(t, o.onViewportChange), c = N.useRef(0);
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ y(g3.Slot, { scope: n, children: /* @__PURE__ */ y(
        Zt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            overflow: "auto",
            ...i.style
          },
          onScroll: ot(i.onScroll, (a) => {
            const u = a.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: d } = s;
            if (d != null && d.current && f) {
              const p = Math.abs(c.current - u.scrollTop);
              if (p > 0) {
                const h = window.innerHeight - Sp * 2, m = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), b = Math.max(m, v);
                if (b < h) {
                  const A = b + p, w = Math.min(h, A), O = A - w;
                  f.style.height = w + "px", f.style.bottom === "0px" && (u.scrollTop = O > 0 ? O : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
u3e.displayName = j8;
var d3e = "SelectGroup", [jWt, FWt] = Lx(d3e), f3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = ka();
    return /* @__PURE__ */ y(jWt, { scope: n, id: i, children: /* @__PURE__ */ y(Zt.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
f3e.displayName = d3e;
var p3e = "SelectLabel", h3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = FWt(p3e, n);
    return /* @__PURE__ */ y(Zt.div, { id: i.id, ...r, ref: t });
  }
);
h3e.displayName = p3e;
var G_ = "SelectItem", [UWt, m3e] = Lx(G_), g3e = N.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: o,
      ...s
    } = e, l = zg(G_, n), c = jg(G_, n), a = l.value === r, [u, f] = N.useState(o ?? ""), [d, p] = N.useState(!1), h = xn(
      t,
      (b) => {
        var A;
        return (A = c.itemRefCallback) == null ? void 0 : A.call(c, b, r, i);
      }
    ), m = ka(), v = () => {
      i || (l.onValueChange(r), l.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ y(
      UWt,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: m,
        isSelected: a,
        onItemTextChange: N.useCallback((b) => {
          f((A) => A || ((b == null ? void 0 : b.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ y(
          g3.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: u,
            children: /* @__PURE__ */ y(
              Zt.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": d ? "" : void 0,
                "aria-selected": a && d,
                "data-state": a ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...s,
                ref: h,
                onFocus: ot(s.onFocus, () => p(!0)),
                onBlur: ot(s.onBlur, () => p(!1)),
                onPointerUp: ot(s.onPointerUp, v),
                onPointerMove: ot(s.onPointerMove, (b) => {
                  var A;
                  i ? (A = c.onItemLeave) == null || A.call(c) : b.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ot(s.onPointerLeave, (b) => {
                  var A;
                  b.currentTarget === document.activeElement && ((A = c.onItemLeave) == null || A.call(c));
                }),
                onKeyDown: ot(s.onKeyDown, (b) => {
                  var w;
                  ((w = c.searchRef) == null ? void 0 : w.current) !== "" && b.key === " " || (kWt.includes(b.key) && v(), b.key === " " && b.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
g3e.displayName = G_;
var x1 = "SelectItemText", y3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...o } = e, s = zg(x1, n), l = jg(x1, n), c = m3e(x1, n), a = IWt(x1, n), [u, f] = N.useState(null), d = xn(
      t,
      (b) => f(b),
      c.onItemTextChange,
      (b) => {
        var A;
        return (A = l.itemTextRefCallback) == null ? void 0 : A.call(l, b, c.value, c.disabled);
      }
    ), p = u == null ? void 0 : u.textContent, h = N.useMemo(
      () => /* @__PURE__ */ y("option", { value: c.value, disabled: c.disabled, children: p }, c.value),
      [c.disabled, c.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: v } = a;
    return qi(() => (m(h), () => v(h)), [m, v, h]), /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(Zt.span, { id: c.textId, ...o, ref: d }),
      c.isSelected && s.valueNode && !s.valueNodeHasChildren ? sb.createPortal(o.children, s.valueNode) : null
    ] });
  }
);
y3e.displayName = x1;
var v3e = "SelectItemIndicator", b3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return m3e(v3e, n).isSelected ? /* @__PURE__ */ y(Zt.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
b3e.displayName = v3e;
var F8 = "SelectScrollUpButton", O3e = N.forwardRef((e, t) => {
  const n = jg(F8, e.__scopeSelect), r = IY(F8, e.__scopeSelect), [i, o] = N.useState(!1), s = xn(t, r.onScrollButtonChange);
  return qi(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const a = c.scrollTop > 0;
        o(a);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ y(
    w3e,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
O3e.displayName = F8;
var U8 = "SelectScrollDownButton", A3e = N.forwardRef((e, t) => {
  const n = jg(U8, e.__scopeSelect), r = IY(U8, e.__scopeSelect), [i, o] = N.useState(!1), s = xn(t, r.onScrollButtonChange);
  return qi(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const a = c.scrollHeight - c.clientHeight, u = Math.ceil(c.scrollTop) < a;
        o(u);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ y(
    w3e,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
A3e.displayName = U8;
var w3e = N.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, o = jg("SelectScrollButton", n), s = N.useRef(null), l = y3(n), c = N.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return N.useEffect(() => () => c(), [c]), qi(() => {
    var u;
    const a = l().find((f) => f.ref.current === document.activeElement);
    (u = a == null ? void 0 : a.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ y(
    Zt.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: ot(i.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerMove: ot(i.onPointerMove, () => {
        var a;
        (a = o.onItemLeave) == null || a.call(o), s.current === null && (s.current = window.setInterval(r, 50));
      }),
      onPointerLeave: ot(i.onPointerLeave, () => {
        c();
      })
    }
  );
}), VWt = "SelectSeparator", x3e = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ y(Zt.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
x3e.displayName = VWt;
var V8 = "SelectArrow", qWt = N.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = v3(n), o = zg(V8, n), s = jg(V8, n);
    return o.open && s.position === "popper" ? /* @__PURE__ */ y(GC, { ...i, ...r, ref: t }) : null;
  }
);
qWt.displayName = V8;
function S3e(e) {
  return e === "" || e === void 0;
}
var E3e = N.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = N.useRef(null), o = xn(t, i), s = vj(n);
    return N.useEffect(() => {
      const l = i.current, c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (s !== n && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(l, n), l.dispatchEvent(f);
      }
    }, [s, n]), /* @__PURE__ */ y(dQ, { asChild: !0, children: /* @__PURE__ */ y("select", { ...r, ref: o, defaultValue: n }) });
  }
);
E3e.displayName = "BubbleSelect";
function T3e(e) {
  const t = ti(e), n = N.useRef(""), r = N.useRef(0), i = N.useCallback(
    (s) => {
      const l = n.current + s;
      t(l), function c(a) {
        n.current = a, window.clearTimeout(r.current), a !== "" && (r.current = window.setTimeout(() => c(""), 1e3));
      }(l);
    },
    [t]
  ), o = N.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return N.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, o];
}
function k3e(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((a) => a === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let s = BWt(e, Math.max(o, 0));
  i.length === 1 && (s = s.filter((a) => a !== n));
  const c = s.find(
    (a) => a.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function BWt(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var XWt = Jje, C3e = t3e, WWt = r3e, ZWt = i3e, HWt = o3e, N3e = s3e, QWt = u3e, $Wt = f3e, P3e = h3e, I3e = g3e, KWt = y3e, GWt = b3e, R3e = O3e, M3e = A3e, D3e = x3e;
const Cf = XWt, YWt = $Wt, Nf = WWt, sd = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ V(
  C3e,
  {
    ref: r,
    className: Se(
      "flex h-10 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none  disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ y(ZWt, { asChild: !0, children: /* @__PURE__ */ y(PRt, { className: "size-4 opacity-50" }) })
    ]
  }
));
sd.displayName = C3e.displayName;
const _3e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  R3e,
  {
    ref: n,
    className: Se(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ y(LRt, {})
  }
));
_3e.displayName = R3e.displayName;
const L3e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  M3e,
  {
    ref: n,
    className: Se(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ y(DRt, {})
  }
));
L3e.displayName = M3e.displayName;
const ad = N.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, i) => /* @__PURE__ */ y(HWt, { children: /* @__PURE__ */ V(
  N3e,
  {
    ref: i,
    className: Se(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      /* @__PURE__ */ y(_3e, {}),
      /* @__PURE__ */ y(
        QWt,
        {
          className: Se(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ y(L3e, {})
    ]
  }
) }));
ad.displayName = N3e.displayName;
const z3e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  P3e,
  {
    ref: n,
    className: Se("px-2 py-1.5 text-sm font-semibold", e),
    ...t
  }
));
z3e.displayName = P3e.displayName;
const Ti = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ V(
  I3e,
  {
    ref: r,
    className: Se(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ y("span", { className: "absolute right-9 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ y(GWt, { children: /* @__PURE__ */ y(Af, { className: "size-4" }) }) }),
      /* @__PURE__ */ y(KWt, { children: t })
    ]
  }
));
Ti.displayName = I3e.displayName;
const JWt = N.forwardRef(
  ({ className: e }, t) => /* @__PURE__ */ y(
    Ti,
    {
      disabled: !0,
      ref: t,
      value: "random-value",
      className: Se("flex items-center justify-center w-full", e),
      children: /* @__PURE__ */ y(mu, {})
    },
    "none"
  )
);
JWt.displayName = "SelectLoader";
const j3e = N.forwardRef(({ className: e, children: t, disabled: n, ...r }, i) => /* @__PURE__ */ y(
  "div",
  {
    ref: i,
    className: Se(
      "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none hover:bg-accent hover:text-accent-foreground",
      e
    ),
    ...r,
    onClick: (o) => {
      var s;
      n ? (o.preventDefault(), o.stopPropagation()) : (s = r.onClick) == null || s.call(r, o);
    },
    children: t
  }
));
j3e.displayName = "SelectAction";
const eZt = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  D3e,
  {
    ref: n,
    className: Se("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
eZt.displayName = D3e.displayName;
const tZt = {
  getTemplate(e) {
    return dt.get(`/v1/templates/${e}`);
  },
  create(e) {
    return dt.post("/v1/templates", e);
  },
  update(e, t) {
    return dt.post(`/v1/templates/${e}`, t);
  },
  list(e) {
    return dt.get("/v1/templates", e);
  },
  delete(e) {
    return dt.delete(`/v1/templates/${e}`);
  },
  incrementUsageCount(e) {
    return dt.post(`/v1/templates/${e}/increment-usage-count`);
  },
  getCategories() {
    return dt.get("/v1/templates/categories");
  }
};
var FN = (e) => e.type === "checkbox", PO = (e) => e instanceof Date, ba = (e) => e == null;
const F3e = (e) => typeof e == "object";
var jo = (e) => !ba(e) && !Array.isArray(e) && F3e(e) && !PO(e), U3e = (e) => jo(e) && e.target ? FN(e.target) ? e.target.checked : e.target.value : e, nZt = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, V3e = (e, t) => e.has(nZt(t)), rZt = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return jo(t) && t.hasOwnProperty("isPrototypeOf");
}, RY = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function No(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(RY && (e instanceof Blob || e instanceof FileList)) && (n || jo(e)))
    if (t = n ? [] : {}, !n && !rZt(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = No(e[r]));
  else
    return e;
  return t;
}
var UN = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Jr = (e) => e === void 0, Et = (e, t, n) => {
  if (!t || !jo(e))
    return n;
  const r = UN(t.split(/[,[\].]+?/)).reduce((i, o) => ba(i) ? i : i[o], e);
  return Jr(r) || r === e ? Jr(e[t]) ? n : e[t] : r;
}, rf = (e) => typeof e == "boolean", MY = (e) => /^\w*$/.test(e), q3e = (e) => UN(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Er = (e, t, n) => {
  let r = -1;
  const i = MY(t) ? [t] : q3e(t), o = i.length, s = o - 1;
  for (; ++r < o; ) {
    const l = i[r];
    let c = n;
    if (r !== s) {
      const a = e[l];
      c = jo(a) || Array.isArray(a) ? a : isNaN(+i[r + 1]) ? {} : [];
    }
    if (l === "__proto__")
      return;
    e[l] = c, e = e[l];
  }
  return e;
};
const Y_ = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Vc = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ep = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, B3e = ie.createContext(null), _r = () => ie.useContext(B3e), iZt = (e) => {
  const { children: t, ...n } = e;
  return ie.createElement(B3e.Provider, { value: n }, t);
};
var X3e = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const s = o;
        return t._proxyFormState[s] !== Vc.all && (t._proxyFormState[s] = !r || Vc.all), n && (n[s] = !0), e[s];
      }
    });
  return i;
}, va = (e) => jo(e) && !Object.keys(e).length, W3e = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return va(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((s) => t[s] === (!r || Vc.all));
}, fl = (e) => Array.isArray(e) ? e : [e], Z3e = (e, t, n) => !e || !t || e === t || fl(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function b3(e) {
  const t = ie.useRef(e);
  t.current = e, ie.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function oZt(e) {
  const t = _r(), { control: n = t.control, disabled: r, name: i, exact: o } = e || {}, [s, l] = ie.useState(n._formState), c = ie.useRef(!0), a = ie.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = ie.useRef(i);
  return u.current = i, b3({
    disabled: r,
    next: (f) => c.current && Z3e(u.current, f.name, o) && W3e(f, a.current, n._updateFormState) && l({
      ...n._formState,
      ...f
    }),
    subject: n._subjects.state
  }), ie.useEffect(() => (c.current = !0, a.current.isValid && n._updateValid(!0), () => {
    c.current = !1;
  }), [n]), X3e(s, n, a.current, !1);
}
var df = (e) => typeof e == "string", H3e = (e, t, n, r, i) => df(e) ? (r && t.watch.add(e), Et(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), Et(n, o))) : (r && (t.watchAll = !0), n);
function DY(e) {
  const t = _r(), { control: n = t.control, name: r, defaultValue: i, disabled: o, exact: s } = e || {}, l = ie.useRef(r);
  l.current = r, b3({
    disabled: o,
    subject: n._subjects.values,
    next: (u) => {
      Z3e(l.current, u.name, s) && a(No(H3e(l.current, n._names, u.values || n._formValues, !1, i)));
    }
  });
  const [c, a] = ie.useState(n._getWatch(r, i));
  return ie.useEffect(() => n._removeUnmounted()), c;
}
function sZt(e) {
  const t = _r(), { name: n, disabled: r, control: i = t.control, shouldUnregister: o } = e, s = V3e(i._names.array, n), l = DY({
    control: i,
    name: n,
    defaultValue: Et(i._formValues, n, Et(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = oZt({
    control: i,
    name: n,
    exact: !0
  }), a = ie.useRef(i.register(n, {
    ...e.rules,
    value: l,
    ...rf(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return ie.useEffect(() => {
    const u = i._options.shouldUnregister || o, f = (d, p) => {
      const h = Et(i._fields, d);
      h && h._f && (h._f.mount = p);
    };
    if (f(n, !0), u) {
      const d = No(Et(i._options.defaultValues, n));
      Er(i._defaultValues, n, d), Jr(Et(i._formValues, n)) && Er(i._formValues, n, d);
    }
    return () => {
      (s ? u && !i._state.action : u) ? i.unregister(n) : f(n, !1);
    };
  }, [n, i, s, o]), ie.useEffect(() => {
    Et(i._fields, n) && i._updateDisabledField({
      disabled: r,
      fields: i._fields,
      name: n,
      value: Et(i._fields, n)._f.value
    });
  }, [r, n, i]), {
    field: {
      name: n,
      value: l,
      ...rf(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: ie.useCallback((u) => a.current.onChange({
        target: {
          value: U3e(u),
          name: n
        },
        type: Y_.CHANGE
      }), [n]),
      onBlur: ie.useCallback(() => a.current.onBlur({
        target: {
          value: Et(i._formValues, n),
          name: n
        },
        type: Y_.BLUR
      }), [n, i]),
      ref: ie.useCallback((u) => {
        const f = Et(i._fields, n);
        f && u && (f._f.ref = {
          focus: () => u.focus(),
          select: () => u.select(),
          setCustomValidity: (d) => u.setCustomValidity(d),
          reportValidity: () => u.reportValidity()
        });
      }, [i._fields, n])
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!Et(c.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!Et(c.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!Et(c.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!Et(c.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => Et(c.errors, n)
      }
    })
  };
}
const aZt = (e) => e.render(sZt(e));
var Q3e = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, Vh = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, A4 = (e, t, n = {}) => n.shouldFocus || Jr(n.shouldFocus) ? n.focusName || `${e}.${Jr(n.focusIndex) ? t : n.focusIndex}.` : "", ZE = (e) => ({
  isOnSubmit: !e || e === Vc.onSubmit,
  isOnBlur: e === Vc.onBlur,
  isOnChange: e === Vc.onChange,
  isOnAll: e === Vc.all,
  isOnTouch: e === Vc.onTouched
}), q8 = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const aA = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = Et(e, i);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && t(s.refs[0], i) && !r)
          break;
        if (s.ref && t(s.ref, s.name) && !r)
          break;
        aA(l, t);
      } else jo(l) && aA(l, t);
    }
  }
};
var $3e = (e, t, n) => {
  const r = fl(Et(e, n));
  return Er(r, "root", t[n]), Er(e, n, r), e;
}, _Y = (e) => e.type === "file", Fm = (e) => typeof e == "function", J_ = (e) => {
  if (!RY)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, AM = (e) => df(e), LY = (e) => e.type === "radio", eL = (e) => e instanceof RegExp;
const Mfe = {
  value: !1,
  isValid: !1
}, Dfe = { value: !0, isValid: !0 };
var K3e = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Jr(e[0].attributes.value) ? Jr(e[0].value) || e[0].value === "" ? Dfe : { value: e[0].value, isValid: !0 } : Dfe
    ) : Mfe;
  }
  return Mfe;
};
const _fe = {
  isValid: !1,
  value: null
};
var G3e = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, _fe) : _fe;
function Lfe(e, t, n = "validate") {
  if (AM(e) || Array.isArray(e) && e.every(AM) || rf(e) && !e)
    return {
      type: n,
      message: AM(e) ? e : "",
      ref: t
    };
}
var u0 = (e) => jo(e) && !eL(e) ? e : {
  value: e,
  message: ""
}, B8 = async (e, t, n, r, i) => {
  const { ref: o, refs: s, required: l, maxLength: c, minLength: a, min: u, max: f, pattern: d, validate: p, name: h, valueAsNumber: m, mount: v, disabled: b } = e._f, A = Et(t, h);
  if (!v || b)
    return {};
  const w = s ? s[0] : o, O = (F) => {
    r && w.reportValidity && (w.setCustomValidity(rf(F) ? "" : F || ""), w.reportValidity());
  }, x = {}, S = LY(o), E = FN(o), k = S || E, T = (m || _Y(o)) && Jr(o.value) && Jr(A) || J_(o) && o.value === "" || A === "" || Array.isArray(A) && !A.length, R = Q3e.bind(null, h, n, x), j = (F, L, _, U = ep.maxLength, z = ep.minLength) => {
    const C = F ? L : _;
    x[h] = {
      type: F ? U : z,
      message: C,
      ref: o,
      ...R(F ? U : z, C)
    };
  };
  if (i ? !Array.isArray(A) || !A.length : l && (!k && (T || ba(A)) || rf(A) && !A || E && !K3e(s).isValid || S && !G3e(s).isValid)) {
    const { value: F, message: L } = AM(l) ? { value: !!l, message: l } : u0(l);
    if (F && (x[h] = {
      type: ep.required,
      message: L,
      ref: w,
      ...R(ep.required, L)
    }, !n))
      return O(L), x;
  }
  if (!T && (!ba(u) || !ba(f))) {
    let F, L;
    const _ = u0(f), U = u0(u);
    if (!ba(A) && !isNaN(A)) {
      const z = o.valueAsNumber || A && +A;
      ba(_.value) || (F = z > _.value), ba(U.value) || (L = z < U.value);
    } else {
      const z = o.valueAsDate || new Date(A), C = (D) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + D), I = o.type == "time", M = o.type == "week";
      df(_.value) && A && (F = I ? C(A) > C(_.value) : M ? A > _.value : z > new Date(_.value)), df(U.value) && A && (L = I ? C(A) < C(U.value) : M ? A < U.value : z < new Date(U.value));
    }
    if ((F || L) && (j(!!F, _.message, U.message, ep.max, ep.min), !n))
      return O(x[h].message), x;
  }
  if ((c || a) && !T && (df(A) || i && Array.isArray(A))) {
    const F = u0(c), L = u0(a), _ = !ba(F.value) && A.length > +F.value, U = !ba(L.value) && A.length < +L.value;
    if ((_ || U) && (j(_, F.message, L.message), !n))
      return O(x[h].message), x;
  }
  if (d && !T && df(A)) {
    const { value: F, message: L } = u0(d);
    if (eL(F) && !A.match(F) && (x[h] = {
      type: ep.pattern,
      message: L,
      ref: o,
      ...R(ep.pattern, L)
    }, !n))
      return O(L), x;
  }
  if (p) {
    if (Fm(p)) {
      const F = await p(A, t), L = Lfe(F, w);
      if (L && (x[h] = {
        ...L,
        ...R(ep.validate, L.message)
      }, !n))
        return O(L.message), x;
    } else if (jo(p)) {
      let F = {};
      for (const L in p) {
        if (!va(F) && !n)
          break;
        const _ = Lfe(await p[L](A, t), w, L);
        _ && (F = {
          ..._,
          ...R(L, _.message)
        }, O(_.message), n && (x[h] = F));
      }
      if (!va(F) && (x[h] = {
        ref: w,
        ...F
      }, !n))
        return x;
    }
  }
  return O(!0), x;
}, w4 = (e, t) => [
  ...e,
  ...fl(t)
], x4 = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function S4(e, t, n) {
  return [
    ...e.slice(0, t),
    ...fl(n),
    ...e.slice(t)
  ];
}
var E4 = (e, t, n) => Array.isArray(e) ? (Jr(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], T4 = (e, t) => [
  ...fl(t),
  ...fl(e)
];
function lZt(e, t) {
  let n = 0;
  const r = [...e];
  for (const i of t)
    r.splice(i - n, 1), n++;
  return UN(r).length ? r : [];
}
var k4 = (e, t) => Jr(t) ? [] : lZt(e, fl(t).sort((n, r) => n - r)), C4 = (e, t, n) => {
  [e[t], e[n]] = [e[n], e[t]];
};
function cZt(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = Jr(e) ? r++ : e[t[r++]];
  return e;
}
function uZt(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Jr(e[t]))
      return !1;
  return !0;
}
function oo(e, t) {
  const n = Array.isArray(t) ? t : MY(t) ? [t] : q3e(t), r = n.length === 1 ? e : cZt(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (jo(r) && va(r) || Array.isArray(r) && uZt(r)) && oo(e, n.slice(0, -1)), e;
}
var zfe = (e, t, n) => (e[t] = n, e);
function zY(e) {
  const t = _r(), { control: n = t.control, name: r, keyName: i = "id", shouldUnregister: o } = e, [s, l] = ie.useState(n._getFieldArray(r)), c = ie.useRef(n._getFieldArray(r).map(Vh)), a = ie.useRef(s), u = ie.useRef(r), f = ie.useRef(!1);
  u.current = r, a.current = s, n._names.array.add(r), e.rules && n.register(r, e.rules), b3({
    next: ({ values: x, name: S }) => {
      if (S === u.current || !S) {
        const E = Et(x, u.current);
        Array.isArray(E) && (l(E), c.current = E.map(Vh));
      }
    },
    subject: n._subjects.array
  });
  const d = ie.useCallback((x) => {
    f.current = !0, n._updateFieldArray(r, x);
  }, [n, r]), p = (x, S) => {
    const E = fl(No(x)), k = w4(n._getFieldArray(r), E);
    n._names.focus = A4(r, k.length - 1, S), c.current = w4(c.current, E.map(Vh)), d(k), l(k), n._updateFieldArray(r, k, w4, {
      argA: x4(x)
    });
  }, h = (x, S) => {
    const E = fl(No(x)), k = T4(n._getFieldArray(r), E);
    n._names.focus = A4(r, 0, S), c.current = T4(c.current, E.map(Vh)), d(k), l(k), n._updateFieldArray(r, k, T4, {
      argA: x4(x)
    });
  }, m = (x) => {
    const S = k4(n._getFieldArray(r), x);
    c.current = k4(c.current, x), d(S), l(S), n._updateFieldArray(r, S, k4, {
      argA: x
    });
  }, v = (x, S, E) => {
    const k = fl(No(S)), T = S4(n._getFieldArray(r), x, k);
    n._names.focus = A4(r, x, E), c.current = S4(c.current, x, k.map(Vh)), d(T), l(T), n._updateFieldArray(r, T, S4, {
      argA: x,
      argB: x4(S)
    });
  }, b = (x, S) => {
    const E = n._getFieldArray(r);
    C4(E, x, S), C4(c.current, x, S), d(E), l(E), n._updateFieldArray(r, E, C4, {
      argA: x,
      argB: S
    }, !1);
  }, A = (x, S) => {
    const E = n._getFieldArray(r);
    E4(E, x, S), E4(c.current, x, S), d(E), l(E), n._updateFieldArray(r, E, E4, {
      argA: x,
      argB: S
    }, !1);
  }, w = (x, S) => {
    const E = No(S), k = zfe(n._getFieldArray(r), x, E);
    c.current = [...k].map((T, R) => !T || R === x ? Vh() : c.current[R]), d(k), l([...k]), n._updateFieldArray(r, k, zfe, {
      argA: x,
      argB: E
    }, !0, !1);
  }, O = (x) => {
    const S = fl(No(x));
    c.current = S.map(Vh), d([...S]), l([...S]), n._updateFieldArray(r, [...S], (E) => E, {}, !0, !1);
  };
  return ie.useEffect(() => {
    if (n._state.action = !1, q8(r, n._names) && n._subjects.state.next({
      ...n._formState
    }), f.current && (!ZE(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([r]).then((x) => {
          const S = Et(x.errors, r), E = Et(n._formState.errors, r);
          (E ? !S && E.type || S && (E.type !== S.type || E.message !== S.message) : S && S.type) && (S ? Er(n._formState.errors, r, S) : oo(n._formState.errors, r), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const x = Et(n._fields, r);
        x && x._f && !(ZE(n._options.reValidateMode).isOnSubmit && ZE(n._options.mode).isOnSubmit) && B8(x, n._formValues, n._options.criteriaMode === Vc.all, n._options.shouldUseNativeValidation, !0).then((S) => !va(S) && n._subjects.state.next({
          errors: $3e(n._formState.errors, S, r)
        }));
      }
    n._subjects.values.next({
      name: r,
      values: { ...n._formValues }
    }), n._names.focus && aA(n._fields, (x, S) => {
      if (n._names.focus && S.startsWith(n._names.focus) && x.focus)
        return x.focus(), 1;
    }), n._names.focus = "", n._updateValid(), f.current = !1;
  }, [s, r, n]), ie.useEffect(() => (!Et(n._formValues, r) && n._updateFieldArray(r), () => {
    (n._options.shouldUnregister || o) && n.unregister(r);
  }), [r, n, i, o]), {
    swap: ie.useCallback(b, [d, r, n]),
    move: ie.useCallback(A, [d, r, n]),
    prepend: ie.useCallback(h, [d, r, n]),
    append: ie.useCallback(p, [d, r, n]),
    remove: ie.useCallback(m, [d, r, n]),
    insert: ie.useCallback(v, [d, r, n]),
    update: ie.useCallback(w, [d, r, n]),
    replace: ie.useCallback(O, [d, r, n]),
    fields: ie.useMemo(() => s.map((x, S) => ({
      ...x,
      [i]: c.current[S] || Vh()
    })), [s, i])
  };
}
var N4 = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, tL = (e) => ba(e) || !F3e(e);
function Dy(e, t) {
  if (tL(e) || tL(t))
    return e === t;
  if (PO(e) && PO(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n) {
    const o = e[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (PO(o) && PO(s) || jo(o) && jo(s) || Array.isArray(o) && Array.isArray(s) ? !Dy(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Y3e = (e) => e.type === "select-multiple", dZt = (e) => LY(e) || FN(e), P4 = (e) => J_(e) && e.isConnected, J3e = (e) => {
  for (const t in e)
    if (Fm(e[t]))
      return !0;
  return !1;
};
function nL(e, t = {}) {
  const n = Array.isArray(e);
  if (jo(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || jo(e[r]) && !J3e(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, nL(e[r], t[r])) : ba(e[r]) || (t[r] = !0);
  return t;
}
function eFe(e, t, n) {
  const r = Array.isArray(e);
  if (jo(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || jo(e[i]) && !J3e(e[i]) ? Jr(t) || tL(n[i]) ? n[i] = Array.isArray(e[i]) ? nL(e[i], []) : { ...nL(e[i]) } : eFe(e[i], ba(t) ? {} : t[i], n[i]) : n[i] = !Dy(e[i], t[i]);
  return n;
}
var JI = (e, t) => eFe(e, t, nL(t)), tFe = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Jr(e) ? e : t ? e === "" ? NaN : e && +e : n && df(e) ? new Date(e) : r ? r(e) : e;
function I4(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return _Y(t) ? t.files : LY(t) ? G3e(e.refs).value : Y3e(t) ? [...t.selectedOptions].map(({ value: n }) => n) : FN(t) ? K3e(e.refs).value : tFe(Jr(t.value) ? e.ref.value : t.value, e);
}
var fZt = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const s = Et(t, o);
    s && Er(i, o, s._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, NS = (e) => Jr(e) ? e : eL(e) ? e.source : jo(e) ? eL(e.value) ? e.value.source : e.value : e, pZt = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function jfe(e, t, n) {
  const r = Et(e, n);
  if (r || MY(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), s = Et(t, o), l = Et(e, o);
    if (s && !Array.isArray(s) && n !== o)
      return { name: n };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    i.pop();
  }
  return {
    name: n
  };
}
var hZt = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, mZt = (e, t) => !UN(Et(e, t)).length && oo(e, t);
const gZt = {
  mode: Vc.onSubmit,
  reValidateMode: Vc.onChange,
  shouldFocusError: !0
};
function yZt(e = {}) {
  let t = {
    ...gZt,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Fm(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = jo(t.defaultValues) || jo(t.values) ? No(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : No(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, a = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: N4(),
    array: N4(),
    state: N4()
  }, d = ZE(t.mode), p = ZE(t.reValidateMode), h = t.criteriaMode === Vc.all, m = (me) => (Te) => {
    clearTimeout(a), a = setTimeout(me, Te);
  }, v = async (me) => {
    if (u.isValid || me) {
      const Te = t.resolver ? va((await k()).errors) : await R(r, !0);
      Te !== n.isValid && f.state.next({
        isValid: Te
      });
    }
  }, b = (me, Te) => {
    (u.isValidating || u.validatingFields) && ((me || Array.from(l.mount)).forEach((re) => {
      re && (Te ? Er(n.validatingFields, re, Te) : oo(n.validatingFields, re));
    }), f.state.next({
      validatingFields: n.validatingFields,
      isValidating: !va(n.validatingFields)
    }));
  }, A = (me, Te = [], re, le, Oe = !0, be = !0) => {
    if (le && re) {
      if (s.action = !0, be && Array.isArray(Et(r, me))) {
        const je = re(Et(r, me), le.argA, le.argB);
        Oe && Er(r, me, je);
      }
      if (be && Array.isArray(Et(n.errors, me))) {
        const je = re(Et(n.errors, me), le.argA, le.argB);
        Oe && Er(n.errors, me, je), mZt(n.errors, me);
      }
      if (u.touchedFields && be && Array.isArray(Et(n.touchedFields, me))) {
        const je = re(Et(n.touchedFields, me), le.argA, le.argB);
        Oe && Er(n.touchedFields, me, je);
      }
      u.dirtyFields && (n.dirtyFields = JI(i, o)), f.state.next({
        name: me,
        isDirty: F(me, Te),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Er(o, me, Te);
  }, w = (me, Te) => {
    Er(n.errors, me, Te), f.state.next({
      errors: n.errors
    });
  }, O = (me) => {
    n.errors = me, f.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, x = (me, Te, re, le) => {
    const Oe = Et(r, me);
    if (Oe) {
      const be = Et(o, me, Jr(re) ? Et(i, me) : re);
      Jr(be) || le && le.defaultChecked || Te ? Er(o, me, Te ? be : I4(Oe._f)) : U(me, be), s.mount && v();
    }
  }, S = (me, Te, re, le, Oe) => {
    let be = !1, je = !1;
    const xe = {
      name: me
    }, Q = !!(Et(r, me) && Et(r, me)._f && Et(r, me)._f.disabled);
    if (!re || le) {
      u.isDirty && (je = n.isDirty, n.isDirty = xe.isDirty = F(), be = je !== xe.isDirty);
      const ae = Q || Dy(Et(i, me), Te);
      je = !!(!Q && Et(n.dirtyFields, me)), ae || Q ? oo(n.dirtyFields, me) : Er(n.dirtyFields, me, !0), xe.dirtyFields = n.dirtyFields, be = be || u.dirtyFields && je !== !ae;
    }
    if (re) {
      const ae = Et(n.touchedFields, me);
      ae || (Er(n.touchedFields, me, re), xe.touchedFields = n.touchedFields, be = be || u.touchedFields && ae !== re);
    }
    return be && Oe && f.state.next(xe), be ? xe : {};
  }, E = (me, Te, re, le) => {
    const Oe = Et(n.errors, me), be = u.isValid && rf(Te) && n.isValid !== Te;
    if (e.delayError && re ? (c = m(() => w(me, re)), c(e.delayError)) : (clearTimeout(a), c = null, re ? Er(n.errors, me, re) : oo(n.errors, me)), (re ? !Dy(Oe, re) : Oe) || !va(le) || be) {
      const je = {
        ...le,
        ...be && rf(Te) ? { isValid: Te } : {},
        errors: n.errors,
        name: me
      };
      n = {
        ...n,
        ...je
      }, f.state.next(je);
    }
  }, k = async (me) => {
    b(me, !0);
    const Te = await t.resolver(o, t.context, fZt(me || l.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return b(me), Te;
  }, T = async (me) => {
    const { errors: Te } = await k(me);
    if (me)
      for (const re of me) {
        const le = Et(Te, re);
        le ? Er(n.errors, re, le) : oo(n.errors, re);
      }
    else
      n.errors = Te;
    return Te;
  }, R = async (me, Te, re = {
    valid: !0
  }) => {
    for (const le in me) {
      const Oe = me[le];
      if (Oe) {
        const { _f: be, ...je } = Oe;
        if (be) {
          const xe = l.array.has(be.name);
          b([le], !0);
          const Q = await B8(Oe, o, h, t.shouldUseNativeValidation && !Te, xe);
          if (b([le]), Q[be.name] && (re.valid = !1, Te))
            break;
          !Te && (Et(Q, be.name) ? xe ? $3e(n.errors, Q, be.name) : Er(n.errors, be.name, Q[be.name]) : oo(n.errors, be.name));
        }
        !va(je) && await R(je, Te, re);
      }
    }
    return re.valid;
  }, j = () => {
    for (const me of l.unMount) {
      const Te = Et(r, me);
      Te && (Te._f.refs ? Te._f.refs.every((re) => !P4(re)) : !P4(Te._f.ref)) && J(me);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, F = (me, Te) => (me && Te && Er(o, me, Te), !Dy(X(), i)), L = (me, Te, re) => H3e(me, l, {
    ...s.mount ? o : Jr(Te) ? i : df(me) ? { [me]: Te } : Te
  }, re, Te), _ = (me) => UN(Et(s.mount ? o : i, me, e.shouldUnregister ? Et(i, me, []) : [])), U = (me, Te, re = {}) => {
    const le = Et(r, me);
    let Oe = Te;
    if (le) {
      const be = le._f;
      be && (!be.disabled && Er(o, me, tFe(Te, be)), Oe = J_(be.ref) && ba(Te) ? "" : Te, Y3e(be.ref) ? [...be.ref.options].forEach((je) => je.selected = Oe.includes(je.value)) : be.refs ? FN(be.ref) ? be.refs.length > 1 ? be.refs.forEach((je) => (!je.defaultChecked || !je.disabled) && (je.checked = Array.isArray(Oe) ? !!Oe.find((xe) => xe === je.value) : Oe === je.value)) : be.refs[0] && (be.refs[0].checked = !!Oe) : be.refs.forEach((je) => je.checked = je.value === Oe) : _Y(be.ref) ? be.ref.value = "" : (be.ref.value = Oe, be.ref.type || f.values.next({
        name: me,
        values: { ...o }
      })));
    }
    (re.shouldDirty || re.shouldTouch) && S(me, Oe, re.shouldTouch, re.shouldDirty, !0), re.shouldValidate && D(me);
  }, z = (me, Te, re) => {
    for (const le in Te) {
      const Oe = Te[le], be = `${me}.${le}`, je = Et(r, be);
      (l.array.has(me) || !tL(Oe) || je && !je._f) && !PO(Oe) ? z(be, Oe, re) : U(be, Oe, re);
    }
  }, C = (me, Te, re = {}) => {
    const le = Et(r, me), Oe = l.array.has(me), be = No(Te);
    Er(o, me, be), Oe ? (f.array.next({
      name: me,
      values: { ...o }
    }), (u.isDirty || u.dirtyFields) && re.shouldDirty && f.state.next({
      name: me,
      dirtyFields: JI(i, o),
      isDirty: F(me, be)
    })) : le && !le._f && !ba(be) ? z(me, be, re) : U(me, be, re), q8(me, l) && f.state.next({ ...n }), f.values.next({
      name: s.mount ? me : void 0,
      values: { ...o }
    });
  }, I = async (me) => {
    s.mount = !0;
    const Te = me.target;
    let re = Te.name, le = !0;
    const Oe = Et(r, re), be = () => Te.type ? I4(Oe._f) : U3e(me), je = (xe) => {
      le = Number.isNaN(xe) || xe === Et(o, re, xe);
    };
    if (Oe) {
      let xe, Q;
      const ae = be(), Pe = me.type === Y_.BLUR || me.type === Y_.FOCUS_OUT, Fe = !pZt(Oe._f) && !t.resolver && !Et(n.errors, re) && !Oe._f.deps || hZt(Pe, Et(n.touchedFields, re), n.isSubmitted, p, d), Ke = q8(re, l, Pe);
      Er(o, re, ae), Pe ? (Oe._f.onBlur && Oe._f.onBlur(me), c && c(0)) : Oe._f.onChange && Oe._f.onChange(me);
      const Ot = S(re, ae, Pe, !1), Ct = !va(Ot) || Ke;
      if (!Pe && f.values.next({
        name: re,
        type: me.type,
        values: { ...o }
      }), Fe)
        return u.isValid && v(), Ct && f.state.next({ name: re, ...Ke ? {} : Ot });
      if (!Pe && Ke && f.state.next({ ...n }), t.resolver) {
        const { errors: Jt } = await k([re]);
        if (je(ae), le) {
          const yn = jfe(n.errors, r, re), vn = jfe(Jt, r, yn.name || re);
          xe = vn.error, re = vn.name, Q = va(Jt);
        }
      } else
        b([re], !0), xe = (await B8(Oe, o, h, t.shouldUseNativeValidation))[re], b([re]), je(ae), le && (xe ? Q = !1 : u.isValid && (Q = await R(r, !0)));
      le && (Oe._f.deps && D(Oe._f.deps), E(re, Q, xe, Ot));
    }
  }, M = (me, Te) => {
    if (Et(n.errors, Te) && me.focus)
      return me.focus(), 1;
  }, D = async (me, Te = {}) => {
    let re, le;
    const Oe = fl(me);
    if (t.resolver) {
      const be = await T(Jr(me) ? me : Oe);
      re = va(be), le = me ? !Oe.some((je) => Et(be, je)) : re;
    } else me ? (le = (await Promise.all(Oe.map(async (be) => {
      const je = Et(r, be);
      return await R(je && je._f ? { [be]: je } : je);
    }))).every(Boolean), !(!le && !n.isValid) && v()) : le = re = await R(r);
    return f.state.next({
      ...!df(me) || u.isValid && re !== n.isValid ? {} : { name: me },
      ...t.resolver || !me ? { isValid: re } : {},
      errors: n.errors
    }), Te.shouldFocus && !le && aA(r, M, me ? Oe : l.mount), le;
  }, X = (me) => {
    const Te = {
      ...s.mount ? o : i
    };
    return Jr(me) ? Te : df(me) ? Et(Te, me) : me.map((re) => Et(Te, re));
  }, B = (me, Te) => ({
    invalid: !!Et((Te || n).errors, me),
    isDirty: !!Et((Te || n).dirtyFields, me),
    error: Et((Te || n).errors, me),
    isValidating: !!Et(n.validatingFields, me),
    isTouched: !!Et((Te || n).touchedFields, me)
  }), q = (me) => {
    me && fl(me).forEach((Te) => oo(n.errors, Te)), f.state.next({
      errors: me ? n.errors : {}
    });
  }, H = (me, Te, re) => {
    const le = (Et(r, me, { _f: {} })._f || {}).ref, Oe = Et(n.errors, me) || {}, { ref: be, message: je, type: xe, ...Q } = Oe;
    Er(n.errors, me, {
      ...Q,
      ...Te,
      ref: le
    }), f.state.next({
      name: me,
      errors: n.errors,
      isValid: !1
    }), re && re.shouldFocus && le && le.focus && le.focus();
  }, Y = (me, Te) => Fm(me) ? f.values.subscribe({
    next: (re) => me(L(void 0, Te), re)
  }) : L(me, Te, !0), J = (me, Te = {}) => {
    for (const re of me ? fl(me) : l.mount)
      l.mount.delete(re), l.array.delete(re), Te.keepValue || (oo(r, re), oo(o, re)), !Te.keepError && oo(n.errors, re), !Te.keepDirty && oo(n.dirtyFields, re), !Te.keepTouched && oo(n.touchedFields, re), !Te.keepIsValidating && oo(n.validatingFields, re), !t.shouldUnregister && !Te.keepDefaultValue && oo(i, re);
    f.values.next({
      values: { ...o }
    }), f.state.next({
      ...n,
      ...Te.keepDirty ? { isDirty: F() } : {}
    }), !Te.keepIsValid && v();
  }, oe = ({ disabled: me, name: Te, field: re, fields: le, value: Oe }) => {
    if (rf(me) && s.mount || me) {
      const be = me ? void 0 : Jr(Oe) ? I4(re ? re._f : Et(le, Te)._f) : Oe;
      Er(o, Te, be), S(Te, be, !1, !1, !0);
    }
  }, ce = (me, Te = {}) => {
    let re = Et(r, me);
    const le = rf(Te.disabled);
    return Er(r, me, {
      ...re || {},
      _f: {
        ...re && re._f ? re._f : { ref: { name: me } },
        name: me,
        mount: !0,
        ...Te
      }
    }), l.mount.add(me), re ? oe({
      field: re,
      disabled: Te.disabled,
      name: me,
      value: Te.value
    }) : x(me, !0, Te.value), {
      ...le ? { disabled: Te.disabled } : {},
      ...t.progressive ? {
        required: !!Te.required,
        min: NS(Te.min),
        max: NS(Te.max),
        minLength: NS(Te.minLength),
        maxLength: NS(Te.maxLength),
        pattern: NS(Te.pattern)
      } : {},
      name: me,
      onChange: I,
      onBlur: I,
      ref: (Oe) => {
        if (Oe) {
          ce(me, Te), re = Et(r, me);
          const be = Jr(Oe.value) && Oe.querySelectorAll && Oe.querySelectorAll("input,select,textarea")[0] || Oe, je = dZt(be), xe = re._f.refs || [];
          if (je ? xe.find((Q) => Q === be) : be === re._f.ref)
            return;
          Er(r, me, {
            _f: {
              ...re._f,
              ...je ? {
                refs: [
                  ...xe.filter(P4),
                  be,
                  ...Array.isArray(Et(i, me)) ? [{}] : []
                ],
                ref: { type: be.type, name: me }
              } : { ref: be }
            }
          }), x(me, !1, void 0, be);
        } else
          re = Et(r, me, {}), re._f && (re._f.mount = !1), (t.shouldUnregister || Te.shouldUnregister) && !(V3e(l.array, me) && s.action) && l.unMount.add(me);
      }
    };
  }, fe = () => t.shouldFocusError && aA(r, M, l.mount), $ = (me) => {
    rf(me) && (f.state.next({ disabled: me }), aA(r, (Te, re) => {
      const le = Et(r, re);
      le && (Te.disabled = le._f.disabled || me, Array.isArray(le._f.refs) && le._f.refs.forEach((Oe) => {
        Oe.disabled = le._f.disabled || me;
      }));
    }, 0, !1));
  }, pe = (me, Te) => async (re) => {
    let le;
    re && (re.preventDefault && re.preventDefault(), re.persist && re.persist());
    let Oe = No(o);
    if (f.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: be, values: je } = await k();
      n.errors = be, Oe = je;
    } else
      await R(r);
    if (oo(n.errors, "root"), va(n.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await me(Oe, re);
      } catch (be) {
        le = be;
      }
    } else
      Te && await Te({ ...n.errors }, re), fe(), setTimeout(fe);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: va(n.errors) && !le,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), le)
      throw le;
  }, ee = (me, Te = {}) => {
    Et(r, me) && (Jr(Te.defaultValue) ? C(me, No(Et(i, me))) : (C(me, Te.defaultValue), Er(i, me, No(Te.defaultValue))), Te.keepTouched || oo(n.touchedFields, me), Te.keepDirty || (oo(n.dirtyFields, me), n.isDirty = Te.defaultValue ? F(me, No(Et(i, me))) : F()), Te.keepError || (oo(n.errors, me), u.isValid && v()), f.state.next({ ...n }));
  }, Ce = (me, Te = {}) => {
    const re = me ? No(me) : i, le = No(re), Oe = va(me), be = Oe ? i : le;
    if (Te.keepDefaultValues || (i = re), !Te.keepValues) {
      if (Te.keepDirtyValues)
        for (const je of l.mount)
          Et(n.dirtyFields, je) ? Er(be, je, Et(o, je)) : C(je, Et(be, je));
      else {
        if (RY && Jr(me))
          for (const je of l.mount) {
            const xe = Et(r, je);
            if (xe && xe._f) {
              const Q = Array.isArray(xe._f.refs) ? xe._f.refs[0] : xe._f.ref;
              if (J_(Q)) {
                const ae = Q.closest("form");
                if (ae) {
                  ae.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      o = e.shouldUnregister ? Te.keepDefaultValues ? No(i) : {} : No(be), f.array.next({
        values: { ...be }
      }), f.values.next({
        values: { ...be }
      });
    }
    l = {
      mount: Te.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!Te.keepIsValid || !!Te.keepDirtyValues, s.watch = !!e.shouldUnregister, f.state.next({
      submitCount: Te.keepSubmitCount ? n.submitCount : 0,
      isDirty: Oe ? !1 : Te.keepDirty ? n.isDirty : !!(Te.keepDefaultValues && !Dy(me, i)),
      isSubmitted: Te.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: Oe ? {} : Te.keepDirtyValues ? Te.keepDefaultValues && o ? JI(i, o) : n.dirtyFields : Te.keepDefaultValues && me ? JI(i, me) : Te.keepDirty ? n.dirtyFields : {},
      touchedFields: Te.keepTouched ? n.touchedFields : {},
      errors: Te.keepErrors ? n.errors : {},
      isSubmitSuccessful: Te.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ee = (me, Te) => Ce(Fm(me) ? me(o) : me, Te);
  return {
    control: {
      register: ce,
      unregister: J,
      getFieldState: B,
      handleSubmit: pe,
      setError: H,
      _executeSchema: k,
      _getWatch: L,
      _getDirty: F,
      _updateValid: v,
      _removeUnmounted: j,
      _updateFieldArray: A,
      _updateDisabledField: oe,
      _getFieldArray: _,
      _reset: Ce,
      _resetDefaultValues: () => Fm(t.defaultValues) && t.defaultValues().then((me) => {
        Ee(me, t.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (me) => {
        n = {
          ...n,
          ...me
        };
      },
      _disableForm: $,
      _subjects: f,
      _proxyFormState: u,
      _setErrors: O,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(me) {
        s = me;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return l;
      },
      set _names(me) {
        l = me;
      },
      get _formState() {
        return n;
      },
      set _formState(me) {
        n = me;
      },
      get _options() {
        return t;
      },
      set _options(me) {
        t = {
          ...t,
          ...me
        };
      }
    },
    trigger: D,
    register: ce,
    handleSubmit: pe,
    watch: Y,
    setValue: C,
    getValues: X,
    reset: Ee,
    resetField: ee,
    clearErrors: q,
    unregister: J,
    setError: H,
    setFocus: (me, Te = {}) => {
      const re = Et(r, me), le = re && re._f;
      if (le) {
        const Oe = le.refs ? le.refs[0] : le.ref;
        Oe.focus && (Oe.focus(), Te.shouldSelect && Oe.select());
      }
    },
    getFieldState: B
  };
}
function Fg(e = {}) {
  const t = ie.useRef(), n = ie.useRef(), [r, i] = ie.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Fm(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Fm(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...yZt(e),
    formState: r
  });
  const o = t.current.control;
  return o._options = e, b3({
    subject: o._subjects.state,
    next: (s) => {
      W3e(s, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), ie.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), ie.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== r.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, r.isDirty]), ie.useEffect(() => {
    e.values && !Dy(e.values, n.current) ? (o._reset(e.values, o._options.resetOptions), n.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), ie.useEffect(() => {
    e.errors && o._setErrors(e.errors);
  }, [e.errors, o]), ie.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), ie.useEffect(() => {
    e.shouldUnregister && o._subjects.values.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), t.current.formState = X3e(r, o), t.current;
}
var vZt = "Label", nFe = N.forwardRef((e, t) => /* @__PURE__ */ y(
  Zt.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
nFe.displayName = vZt;
var rFe = nFe;
const bZt = as(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), fg = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  rFe,
  {
    ref: n,
    className: Se(bZt(), e),
    ...t
  }
));
fg.displayName = rFe.displayName;
const Ug = iZt, iFe = N.createContext(
  {}
), Zn = ({
  ...e
}) => /* @__PURE__ */ y(iFe.Provider, { value: { name: e.name }, children: /* @__PURE__ */ y(aZt, { ...e }) }), O3 = () => {
  const e = N.useContext(iFe), t = N.useContext(oFe), { getFieldState: n, formState: r } = _r(), i = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: o } = t;
  return {
    id: o,
    name: e.name,
    formItemId: `${o}-form-item`,
    formDescriptionId: `${o}-form-item-description`,
    formMessageId: `${o}-form-item-message`,
    ...i
  };
}, oFe = N.createContext(
  {}
), Jn = N.forwardRef(({ className: e, ...t }, n) => {
  const r = N.useId();
  return /* @__PURE__ */ y(oFe.Provider, { value: { id: r }, children: /* @__PURE__ */ y("div", { ref: n, className: Se("space-y-1", e), ...t }) });
});
Jn.displayName = "FormItem";
const ui = N.forwardRef(({ className: e, ...t }, n) => {
  const { error: r, formItemId: i } = O3();
  return /* @__PURE__ */ y(
    fg,
    {
      ref: n,
      className: Se(r && "text-destructive", e),
      htmlFor: i,
      ...t
    }
  );
});
ui.displayName = "FormLabel";
const Hi = N.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: i, formMessageId: o } = O3();
  return /* @__PURE__ */ y(
    is,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${i} ${o}` : `${i}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
Hi.displayName = "FormControl";
const rL = N.forwardRef(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = O3();
  return /* @__PURE__ */ y(
    "p",
    {
      ref: n,
      id: r,
      className: Se("text-sm text-muted-foreground", e),
      ...t
    }
  );
});
rL.displayName = "FormDescription";
const A3 = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ y(
  "p",
  {
    ref: r,
    id: n.formMessageId,
    className: Se(
      "text-sm font-medium text-destructive wrap-break-word",
      e
    ),
    ...n,
    children: t
  }
));
A3.displayName = "FormError";
const Ei = N.forwardRef(({ className: e, children: t, ...n }, r) => {
  const { error: i, formMessageId: o } = O3(), s = i ? String(i == null ? void 0 : i.message) : t;
  return s ? /* @__PURE__ */ y(A3, { formMessageId: o, ...n, ref: r, children: s }) : /* @__PURE__ */ y(pt, {});
});
Ei.displayName = "FormMessage";
const OZt = {
  parseTemplate: (e) => {
    try {
      const t = JSON.parse(e);
      let n;
      if (t.flows && Array.isArray(t.flows) && t.flows.length > 0)
        n = t;
      else if (t.template && t.name)
        n = {
          ...t,
          flows: [t.template]
        }, delete n.template;
      else
        return null;
      const { flows: r, name: i } = n;
      return !(r != null && r[0]) || !i || !r[0].trigger ? null : n;
    } catch {
      return null;
    }
  },
  extractFlow: (e) => {
    try {
      const t = JSON.parse(e);
      return t.flows && Array.isArray(t.flows) && t.flows.length > 0 ? t.flows[0] : t.template ? t.template : null;
    } catch {
      return null;
    }
  }
}, Ffe = async (e) => new Promise((t) => {
  const n = new FileReader();
  n.onload = () => {
    const r = OZt.parseTemplate(n.result);
    t(r);
  }, n.readAsText(e);
}), AZt = (e) => {
  const { capture: t } = yj(), [n, r] = He([]), i = Xe(null), [o, s] = He(""), [l, c] = He(!1), [a, u] = He([]), [f, d] = He(
    void 0
  ), { mutate: p, isPending: h } = dr({
    mutationFn: async (b) => {
      if (e.insideBuilder) {
        if (b.length === 0)
          throw new Error("No template selected");
        return [await xl.importFlowIntoExisting({
          template: b[0],
          existingFlowId: e.flowId
        })];
      }
      const A = !De(f) && f !== ZM ? await Gje.get(f) : void 0;
      return xl.importFlowsFromTemplates({
        templates: b,
        projectId: Rn.getProjectId(),
        folderName: A == null ? void 0 : A.displayName
      });
    },
    onSuccess: (b) => {
      if (t({
        name: Ww.FLOW_IMPORTED_USING_FILE,
        payload: {
          location: e.insideBuilder ? "inside the builder" : "inside dashboard",
          multiple: b.length > 1
        }
      }), tZt.incrementUsageCount(n[0].id), vr.success(
        Z("flowsImported", {
          flowsCount: b.length
        })
      ), window.location.reload(), b.length === 1) {
        console.log("Removed navigation to", `/flows/${b[0].id}`);
        return;
      }
      c(!1), (b.length === 1 || e.insideBuilder) && console.log("Removed navigation to", `/flow-import-redirect/${b[0].id}`), e.insideBuilder || e.onRefresh();
    },
    onError: (b) => {
      var A;
      dt.isError(b) && ((A = b.response) == null ? void 0 : A.status) === Uwe.BadRequest ? (s(Z("Template file is invalid")), console.log(b)) : Kc();
    }
  }), m = async () => {
    n.length === 0 ? s(
      a.length ? Z(
        "No valid templates found. The following files failed to import: "
      ) + a.join(", ") : Z("Please select a file first")
    ) : (s(""), p(n));
  }, v = async (b) => {
    const A = b.target.files;
    if (!(A != null && A[0])) return;
    r([]), u([]), s("");
    const w = A[0], O = [];
    if ((w.type === "application/zip" || w.type === "application/x-zip-compressed") && !e.insideBuilder) {
      const E = await new Tve().loadAsync(w), k = Object.keys(E.files).filter(
        (T) => T.endsWith(".json")
      );
      for (const T of k) {
        const R = await E.files[T].async("string"), j = await Ffe(new File([R], T));
        j ? O.push(j) : u((F) => [...F, T]);
      }
    } else if (w.type === "application/json") {
      const S = await Ffe(w);
      S ? O.push(S) : u((E) => [...E, w.name]);
    } else {
      s(Z("Unsupported file type"));
      return;
    }
    r(O);
  };
  return /* @__PURE__ */ V(
    qa,
    {
      open: l,
      onOpenChange: (b) => {
        c(b), b || (s(""), r([]), u([]));
      },
      children: [
        /* @__PURE__ */ y(z$, { asChild: !0, children: e.children }),
        /* @__PURE__ */ V(ia, { className: "sm:max-w-[500px]", children: [
          /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ y("div", { className: "flex flex-col gap-3", children: /* @__PURE__ */ y(_s, { children: Z("Import Flow") }) }) }),
          /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", children: [
            e.insideBuilder && /* @__PURE__ */ V(h3, { variant: "warning", children: [
              /* @__PURE__ */ y(gz, { className: "h-4 w-4" }),
              /* @__PURE__ */ y(m3, { children: Z("Importing a flow will overwrite your current one.") })
            ] }),
            /* @__PURE__ */ V("div", { className: "w-full flex flex-col gap-2 justify-between items-start", children: [
              /* @__PURE__ */ y("span", { className: "w-16 text-sm font-medium text-gray-700", children: Z("Flow") }),
              /* @__PURE__ */ y(
                fr,
                {
                  id: "file-input",
                  type: "file",
                  accept: e.insideBuilder ? ".json" : ".json,.zip",
                  ref: i,
                  onChange: v
                }
              )
            ] }),
            !e.insideBuilder && /* @__PURE__ */ V("div", { className: "w-full flex flex-col gap-2 justify-between items-start", children: [
              /* @__PURE__ */ y("span", { className: "w-16 text-sm font-medium text-gray-700", children: Z("Folder") }),
              isLoading ? /* @__PURE__ */ y("div", { className: "flex justify-center items-center w-full", children: /* @__PURE__ */ y(mu, {}) }) : /* @__PURE__ */ V(
                Cf,
                {
                  onValueChange: (b) => d(b),
                  defaultValue: f,
                  children: [
                    /* @__PURE__ */ y(sd, { children: /* @__PURE__ */ y(
                      Nf,
                      {
                        defaultValue: f,
                        placeholder: Z("Select a folder")
                      }
                    ) }),
                    /* @__PURE__ */ y(ad, { children: /* @__PURE__ */ V(YWt, { children: [
                      /* @__PURE__ */ y(z3e, { children: Z("Folders") }),
                      /* @__PURE__ */ y(Ti, { value: ZM, children: Z("Uncategorized") }),
                      folders == null ? void 0 : folders.map((b) => /* @__PURE__ */ y(Ti, { value: b.id, children: b.displayName }, b.id))
                    ] }) })
                  ]
                }
              )
            ] })
          ] }),
          o && /* @__PURE__ */ y(A3, { formMessageId: "import-flow-error-message", className: "mt-4", children: o }),
          /* @__PURE__ */ V(kl, { children: [
            /* @__PURE__ */ y(
              Qe,
              {
                variant: "outline",
                onClick: () => c(!1),
                disabled: h,
                children: Z("Cancel")
              }
            ),
            /* @__PURE__ */ y(Qe, { onClick: m, loading: h, children: Z("Import") })
          ] })
        ] })
      ]
    }
  );
}, Ufe = (e, t, n) => {
  if (e && "reportValidity" in e) {
    const r = Et(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, sFe = (e, t) => {
  for (const n in t.fields) {
    const r = t.fields[n];
    r && r.ref && "reportValidity" in r.ref ? Ufe(r.ref, n, e) : r.refs && r.refs.forEach((i) => Ufe(i, n, e));
  }
}, wZt = (e, t) => {
  t.shouldUseNativeValidation && sFe(e, t);
  const n = {};
  for (const r in e) {
    const i = Et(t.fields, r), o = Object.assign(e[r] || {}, { ref: i && i.ref });
    if (xZt(t.names || Object.keys(e), r)) {
      const s = Object.assign({}, Et(n, r));
      Er(s, "root", o), Er(n, r, s);
    } else Er(n, r, o);
  }
  return n;
}, xZt = (e, t) => e.some((n) => n.startsWith(t + "."));
var SZt = function(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], i = r.type, o = r.message, s = r.path.substring(1).replace(/\//g, ".");
    if (n[s] || (n[s] = { message: o, type: "" + i }), t) {
      var l = n[s].types, c = l && l["" + i];
      n[s] = Q3e(s, t, n, "" + i, c ? [].concat(c, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}, VN = function(e) {
  return function(t, n, r) {
    try {
      var i = Array.from(e instanceof nOe ? e.Errors(t) : XM(e, t));
      return r.shouldUseNativeValidation && sFe({}, r), Promise.resolve(i.length ? { values: {}, errors: wZt(SZt(i, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) } : { errors: {}, values: t });
    } catch (o) {
      return Promise.reject(o);
    }
  };
};
const EZt = g.Object({
  displayName: g.String()
}), TZt = ({
  children: e,
  flowId: t,
  onRename: n,
  flowName: r
}) => {
  var a, u, f;
  const [i, o] = He(!1), s = Fg({
    resolver: VN(EZt)
  }), { mutate: l, isPending: c } = dr({
    mutationFn: () => yi.update(t, {
      type: Tt.CHANGE_NAME,
      request: s.getValues()
    }),
    onSuccess: () => {
      o(!1), n(s.getValues().displayName), vr.success(Z("Flow has been renamed."), {
        duration: 3e3
      });
    }
  });
  return /* @__PURE__ */ V(
    qa,
    {
      open: i,
      onOpenChange: (d) => o(d),
      children: [
        /* @__PURE__ */ y(AQ, { asChild: !0, children: e }),
        /* @__PURE__ */ V(ia, { children: [
          /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ V(_s, { children: [
            Z("Rename"),
            " ",
            r
          ] }) }),
          /* @__PURE__ */ y(Ug, { ...s, children: /* @__PURE__ */ V(
            "form",
            {
              className: "grid space-y-4",
              onSubmit: s.handleSubmit(
                (d) => l({
                  flowId: t,
                  displayName: d.displayName
                })
              ),
              children: [
                /* @__PURE__ */ y(
                  Zn,
                  {
                    control: s.control,
                    name: "displayName",
                    render: ({ field: d }) => /* @__PURE__ */ V(Jn, { className: "grid space-y-2", children: [
                      /* @__PURE__ */ y(fg, { htmlFor: "displayName", children: Z("Name") }),
                      /* @__PURE__ */ y(
                        fr,
                        {
                          ...d,
                          id: "displayName",
                          placeholder: Z("New Flow Name"),
                          className: "rounded-sm",
                          defaultValue: r
                        }
                      ),
                      /* @__PURE__ */ y(Ei, {})
                    ] })
                  }
                ),
                ((f = (u = (a = s == null ? void 0 : s.formState) == null ? void 0 : a.errors) == null ? void 0 : u.root) == null ? void 0 : f.serverError) && /* @__PURE__ */ y(Ei, { children: s.formState.errors.root.serverError.message }),
                /* @__PURE__ */ y(Qe, { loading: c, children: Z("Confirm") })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, aFe = {
  list(e) {
    return dt.get(
      "/v1/project-members",
      e
    );
  },
  update(e, t) {
    return dt.post(`/v1/project-members/${e}`, t);
  },
  delete(e) {
    return dt.delete(`/v1/project-members/${e}`);
  }
}, kZt = {
  useProjectMembers: () => {
    const { data: e } = Go.useFlag(As.SHOW_PROJECT_MEMBERS), t = pr({
      queryKey: ["project-members", Rn.getProjectId()],
      queryFn: async () => {
        const n = Rn.getProjectId();
        return qm(n, "Project ID is null"), (await aFe.list({
          projectId: n,
          projectRoleId: void 0,
          cursor: void 0,
          limit: 100
        })).data;
      },
      staleTime: 1 / 0,
      enabled: !!e
    });
    return {
      projectMembers: t.data,
      isLoading: t.isLoading,
      refetch: t.refetch
    };
  }
}, CZt = ({
  flow: e,
  flowVersion: t,
  children: n,
  readonly: r,
  onRename: i,
  onMoveTo: o,
  onDuplicate: s,
  onDelete: l,
  onOwnerChange: c,
  onVersionsListClick: a,
  insideBuilder: u
}) => {
  const { i18n: f } = tc(), d = f.dir() === "rtl";
  dN.useCurrentPlatform();
  const { checkAccess: p } = yc();
  p(Es.WRITE_FOLDER);
  const h = p(Es.WRITE_FLOW);
  p(
    Es.WRITE_PROJECT_RELEASE
  );
  const [m, v] = He(!1);
  e.publishedVersionId !== null && (e.version.state, Lo.LOCKED);
  const { projectMembers: b } = kZt.useProjectMembers();
  b && b.length > 0;
  const { mutate: A, isPending: w } = dr({
    mutationFn: async () => {
      const S = {
        ...t,
        displayName: `${t.displayName} - Copy`
      }, E = await yi.create({
        displayName: S.displayName,
        projectId: Rn.getProjectId(),
        folderId: e.folderId ?? void 0
      });
      return await yi.update(
        E.id,
        {
          type: Tt.IMPORT_FLOW,
          request: {
            displayName: S.displayName,
            trigger: S.trigger,
            schemaVersion: S.schemaVersion,
            notes: S.notes
          }
        },
        !0
      );
    },
    onSuccess: (S) => {
      s();
    }
  }), { mutate: O, isPending: x } = xl.useExportFlows();
  return /* @__PURE__ */ V(mN, { open: m, onOpenChange: v, children: [
    /* @__PURE__ */ y(Aj, { asChild: !0, children: n }),
    /* @__PURE__ */ V(
      xx,
      {
        noAnimationOnOut: !0,
        onCloseAutoFocus: (S) => S.preventDefault(),
        children: [
          !r && /* @__PURE__ */ V(pt, { children: [
            u && /* @__PURE__ */ y(
              tb,
              {
                hasPermission: h,
                children: /* @__PURE__ */ y(
                  wa,
                  {
                    dir: d ? "rtl" : "ltr",
                    onSelect: (S) => {
                      S.preventDefault(), S.stopPropagation(), v(!1), i();
                    },
                    disabled: !h,
                    children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer flex-row gap-2 items-center", children: [
                      /* @__PURE__ */ y($A, { className: "h-4 w-4" }),
                      /* @__PURE__ */ y("span", { children: Z("Rename") })
                    ] })
                  }
                )
              }
            ),
            !u && /* @__PURE__ */ y(
              TZt,
              {
                flowId: e.id,
                onRename: i,
                flowName: t.displayName,
                children: /* @__PURE__ */ y(
                  wa,
                  {
                    dir: d ? "rtl" : "ltr",
                    onSelect: (S) => S.preventDefault(),
                    onClick: (S) => S.stopPropagation(),
                    disabled: !h,
                    children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer flex-row gap-2 items-center", children: [
                      /* @__PURE__ */ y($A, { className: "h-4 w-4" }),
                      /* @__PURE__ */ y("span", { children: Z("Rename") })
                    ] })
                  }
                )
              }
            )
          ] }),
          u && /* @__PURE__ */ y(
            wa,
            {
              dir: d ? "rtl" : "ltr",
              onClick: a,
              children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer  flex-row gap-2 items-center", children: [
                /* @__PURE__ */ y(Lit, { className: "h-4 w-4" }),
                /* @__PURE__ */ y("span", { children: Z("Versions") })
              ] })
            }
          ),
          !r && u && /* @__PURE__ */ y(
            tb,
            {
              hasPermission: h,
              children: /* @__PURE__ */ y(AZt, { insideBuilder: !0, flowId: e.id, children: /* @__PURE__ */ y(
                wa,
                {
                  dir: d ? "rtl" : "ltr",
                  disabled: !h,
                  onSelect: (S) => S.preventDefault(),
                  children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer flex-row gap-2 items-center", children: [
                    /* @__PURE__ */ y(Jit, { className: "w-4 h-4" }),
                    Z("Import")
                  ] })
                }
              ) })
            }
          ),
          /* @__PURE__ */ y(
            wa,
            {
              dir: d ? "rtl" : "ltr",
              onClick: () => O([e]),
              children: /* @__PURE__ */ V("div", { className: "flex cursor-pointer  flex-row gap-2 items-center", children: [
                x ? /* @__PURE__ */ y(mu, {}) : /* @__PURE__ */ y(mz, { className: "h-4 w-4" }),
                /* @__PURE__ */ y("span", { children: Z(x ? "Exporting" : "Export") })
              ] })
            }
          )
        ]
      }
    )
  ] });
};
function NZt({
  json: e,
  label: t,
  description: n,
  defaultOpen: r = !1,
  className: i = ""
}) {
  const [o, s] = He(r), l = () => s(!o), c = typeof e == "string" ? e : JSON.stringify(e, null, 2);
  return /* @__PURE__ */ V("div", { className: `flex flex-col gap-2 ${i}`, children: [
    /* @__PURE__ */ V(
      "button",
      {
        onClick: l,
        className: "flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors",
        children: [
          o ? /* @__PURE__ */ y(ex, { className: "h-4 w-4" }) : /* @__PURE__ */ y(HC, { className: "rtl:scale-x-[-1] h-4 w-4" }),
          t
        ]
      }
    ),
    o && /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 min-w-0", children: [
      /* @__PURE__ */ V("div", { className: "relative min-w-0", children: [
        /* @__PURE__ */ y("pre", { className: "bg-muted/50 whitespace-pre-wrap break-all rounded-md px-4 py-4 text-xs overflow-x-auto max-w-full", children: /* @__PURE__ */ y("code", { children: c }) }),
        /* @__PURE__ */ y("div", { className: "absolute top-2 right-2", children: /* @__PURE__ */ y(SY, { textToCopy: c }) })
      ] }),
      n && /* @__PURE__ */ y("p", { className: "text-xs text-muted-foreground", children: n })
    ] })
  ] });
}
const lFe = () => {
  const { params: e, closeDialog: t } = Kje();
  return De(e) ? null : /* @__PURE__ */ y(qa, { open: !!e, onOpenChange: t, children: /* @__PURE__ */ V(ia, { children: [
    /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ V("div", { className: "flex flex-col items-center", children: [
      /* @__PURE__ */ y(
        "span",
        {
          className: "rounded-full bg-red-100 flex items-center justify-center mb-2 mt-1",
          style: { width: 48, height: 48 },
          children: /* @__PURE__ */ y(Qh, { className: "h-8 w-8 text-red-500" })
        }
      ),
      /* @__PURE__ */ V("div", { className: "flex flex-col items-center text-center w-full gap-2", children: [
        /* @__PURE__ */ y(_s, { className: "text-lg font-semibold", children: e == null ? void 0 : e.title }),
        (e == null ? void 0 : e.description) && /* @__PURE__ */ y(kb, { className: "mt-0.5 text-sm text-muted-foreground", children: e.description })
      ] })
    ] }) }),
    /* @__PURE__ */ y("div", { className: "w-full flex flex-col items-stretch mt-2", children: /* @__PURE__ */ y(
      NZt,
      {
        json: e == null ? void 0 : e.error,
        label: Z("Technical Details"),
        defaultOpen: !0,
        className: "w-full text-left"
      }
    ) }),
    /* @__PURE__ */ y(kl, { className: "mt-2", children: /* @__PURE__ */ y(Qe, { variant: "outline", onClick: t, children: Z("Close") }) })
  ] }) });
};
lFe.displayName = "ApErrorDialog";
var jY = "Switch", [PZt, Rmn] = Ms(jY), [IZt, RZt] = PZt(jY), cFe = N.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: s,
      disabled: l,
      value: c = "on",
      onCheckedChange: a,
      ...u
    } = e, [f, d] = N.useState(null), p = xn(t, (A) => d(A)), h = N.useRef(!1), m = f ? !!f.closest("form") : !0, [v = !1, b] = wl({
      prop: i,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ V(IZt, { scope: n, checked: v, disabled: l, children: [
      /* @__PURE__ */ y(
        Zt.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": v,
          "aria-required": s,
          "data-state": fFe(v),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: c,
          ...u,
          ref: p,
          onClick: ot(e.onClick, (A) => {
            b((w) => !w), m && (h.current = A.isPropagationStopped(), h.current || A.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ y(
        MZt,
        {
          control: f,
          bubbles: !h.current,
          name: r,
          value: c,
          checked: v,
          required: s,
          disabled: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
cFe.displayName = jY;
var uFe = "SwitchThumb", dFe = N.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, i = RZt(uFe, n);
    return /* @__PURE__ */ y(
      Zt.span,
      {
        "data-state": fFe(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
dFe.displayName = uFe;
var MZt = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = N.useRef(null), s = vj(n), l = Az(t);
  return N.useEffect(() => {
    const c = o.current, a = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(a, "checked").set;
    if (s !== n && f) {
      const d = new Event("click", { bubbles: r });
      f.call(c, n), c.dispatchEvent(d);
    }
  }, [s, n, r]), /* @__PURE__ */ y(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function fFe(e) {
  return e ? "checked" : "unchecked";
}
var pFe = cFe, DZt = dFe;
const Iw = N.forwardRef(
  ({
    className: e,
    checkedIcon: t,
    uncheckedIcon: n,
    onCheckedChange: r,
    variant: i = "default",
    size: o = "default",
    color: s = "default",
    ...l
  }, c) => {
    const a = l.checked !== void 0, [u, f] = N.useState(
      l.defaultChecked ?? !1
    ), d = a ? l.checked : u, p = (O) => {
      a || f(O), r && r(O);
    }, v = d ? t : n || t, b = {
      sm: "h-4 w-8",
      default: "h-5 w-10",
      lg: "h-7 w-14",
      xl: "h-8 w-16"
    }, A = {
      sm: "h-3 w-3 data-[state=checked]:translate-x-4",
      default: "h-4 w-4 data-[state=checked]:translate-x-5",
      lg: "h-5 w-5 data-[state=checked]:translate-x-6",
      xl: "h-6 w-6 data-[state=checked]:translate-x-7"
    };
    return /* @__PURE__ */ y(
      pFe,
      {
        className: Se(
          "peer inline-flex shrink-0 cursor-pointer items-center border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
          {
            default: "data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
            secondary: "data-[state=checked]:bg-secondary data-[state=unchecked]:bg-input"
          }[s],
          i === "square" ? "rounded-md" : "rounded-full",
          b[o],
          e
        ),
        onCheckedChange: p,
        ...l,
        checked: d,
        ref: c,
        children: /* @__PURE__ */ y(
          DZt,
          {
            className: Se(
              "pointer-events-none flex items-center justify-center bg-background dark:bg-foreground shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0",
              i === "square" ? "rounded-sm" : "rounded-full",
              A[o]
              // thumbColorClasses[color]
            ),
            children: v && /* @__PURE__ */ y("span", { className: "flex items-center justify-center", children: v })
          }
        )
      }
    );
  }
);
Iw.displayName = pFe.displayName;
const hFe = ({ flow: e }) => {
  const [t, n] = He(
    e.status === il.ENABLED
  );
  nt(() => {
    n(e.status === il.ENABLED);
  }, [e]);
  const { checkAccess: r } = yc(), i = r(
    Es.UPDATE_FLOW_STATUS
  ), { mutate: o, isPending: s } = xl.useChangeFlowStatus({
    flowId: e.id,
    change: t ? il.DISABLED : il.ENABLED,
    onSuccess: (l) => {
      n(l.flow.status === il.ENABLED);
    }
  });
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(lFe, {}),
    /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ y(
        Iw,
        {
          checked: t,
          onCheckedChange: () => o(),
          disabled: s || !i || De(e.publishedVersionId)
        }
      ) }) }),
      /* @__PURE__ */ y(An, { side: "bottom", children: i ? De(e.publishedVersionId) ? Z("Please publish flow first") : Z(t ? "Flow is on" : "Flow is off") : Z("Permission Needed") })
    ] }),
    s ? /* @__PURE__ */ y(mu, {}) : t && /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, onClick: (l) => l.stopPropagation(), children: /* @__PURE__ */ y("div", { className: "p-2 rounded-full ", children: K_.flowStatusIconRenderer(e) }) }),
      /* @__PURE__ */ y(An, { side: "bottom", children: K_.flowStatusToolTipRenderer(e) })
    ] })
  ] });
};
hFe.displayName = "FlowStatusToggle";
const _Zt = ({
  state: e,
  publishedVersionId: t,
  versionId: n
}) => e === Lo.DRAFT ? "Draft" : t === n ? "Published" : "Locked", FY = ie.memo((e) => {
  const t = _Zt(e);
  return t === "Locked" ? null : /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V("div", { className: "size-8 flex justify-center items-center", children: [
      t === "Draft" && /* @__PURE__ */ y("span", { className: "bg-warning size-1.5 rounded-full" }),
      t === "Published" && /* @__PURE__ */ y("span", { className: "bg-success size-1.5 rounded-full" })
    ] }) }),
    /* @__PURE__ */ V(An, { children: [
      t === "Draft" && Z("Draft"),
      t === "Published" && Z("Published")
    ] })
  ] });
});
FY.displayName = "FlowVersionStateDot";
const mFe = ie.memo(() => {
  const [e, t] = tn((n) => [
    n.flowVersion,
    n.flow
  ]);
  return /* @__PURE__ */ V("div", { className: "flex items-center space-x-2", children: [
    /* @__PURE__ */ y(
      FY,
      {
        state: e.state,
        versionId: e.id,
        publishedVersionId: t.publishedVersionId
      }
    ),
    (t.publishedVersionId === e.id || e.state === Lo.DRAFT && !De(t.publishedVersionId)) && /* @__PURE__ */ y(hFe, { flow: t })
  ] });
});
mFe.displayName = "BuilderFlowStatusSection";
const LZt = (e) => {
  const { onBack: t } = e, n = Kw(), r = yc().checkAccess(
    Es.READ_FLOW
  ), [
    i,
    o,
    s,
    l,
    c
  ] = tn((v) => [
    v.flow,
    v.flowVersion,
    v.moveToFolderClientSide,
    v.applyOperation,
    v.setRightSidebar
  ]), { embedState: a } = bd(), u = o.state === Lo.DRAFT || o.id === i.publishedVersionId, [f, d] = He(!1), p = /* @__PURE__ */ y(Wje, { children: /* @__PURE__ */ y(Zje, { children: !a.hideFlowNameInBuilder && /* @__PURE__ */ y(Hje, { children: /* @__PURE__ */ y(Qje, { children: /* @__PURE__ */ V(
    "div",
    {
      className: Se("flex items-center gap-1 text-base", {
        "max-w-[500px]": !f
      }),
      children: [
        /* @__PURE__ */ y(
          Ik,
          {
            className: "hover:cursor-text",
            value: o.displayName,
            readonly: !u,
            onValueChange: (v) => {
              l(
                {
                  type: Tt.CHANGE_NAME,
                  request: {
                    displayName: v
                  }
                },
                () => {
                  xl.invalidateFlowsQuery(n);
                }
              );
            },
            isEditing: f,
            setIsEditing: d,
            tooltipContent: ""
          }
        ),
        /* @__PURE__ */ y(
          CZt,
          {
            onVersionsListClick: () => {
              c(zr.VERSIONS);
            },
            insideBuilder: !0,
            flow: i,
            flowVersion: o,
            readonly: !u,
            onDelete: t,
            onRename: () => {
              d(!0);
            },
            onMoveTo: (v) => s(v),
            onDuplicate: () => {
            },
            children: /* @__PURE__ */ y(
              Qe,
              {
                variant: "ghost",
                className: "size-6 flex items-center justify-center",
                children: /* @__PURE__ */ y(ex, { className: "h-4 w-4 text-muted-foreground" })
              }
            )
          }
        )
      ]
    }
  ) }) }) }) }), h = /* @__PURE__ */ V("div", { className: "flex items-center justify-center gap-4", children: [
    r && /* @__PURE__ */ V(
      Qe,
      {
        variant: "ghost",
        onClick: () => c(zr.RUNS),
        className: "gap-2 px-2",
        children: [
          /* @__PURE__ */ y($it, { className: "w-4 h-4" }),
          Z("Runs")
        ]
      }
    ),
    /* @__PURE__ */ y(mFe, {})
  ] }), m = a.isEmbedded ? /* @__PURE__ */ y($je, {}) : null;
  return /* @__PURE__ */ y(
    hWt,
    {
      title: p,
      rightContent: h,
      leftContent: m,
      showBorder: !0,
      className: "select-none",
      hideSidebarTrigger: !0,
      showBackButton: !0,
      backPath: "/flows"
    }
  );
};
function gFe({
  selectedNodes: e,
  flowVersion: t
}) {
  const r = {
    type: "COPY_ACTIONS",
    actions: Uu.getActionsForCopy(
      e,
      t
    )
  };
  navigator.clipboard.writeText(JSON.stringify(r));
}
function yFe({
  selectedNodes: e,
  applyOperation: t,
  selectedStep: n,
  exitStepSettings: r
}) {
  t({
    type: Tt.DELETE_ACTION,
    request: {
      names: e
    }
  }), n && e.includes(n) && r();
}
async function vFe() {
  try {
    const e = await navigator.clipboard.readText(), t = JSON.parse(e);
    if (t && t.type === "COPY_ACTIONS")
      return t.actions;
  } catch (e) {
    return console.error("Error getting actions in clipboard", e), [];
  }
  return [];
}
async function uO(e, t, n) {
  const r = await vFe(), i = Uu.getOperationsForPaste(
    r,
    e,
    t
  );
  i.forEach((o) => {
    n(o);
  }), i.length === 0 && vr(Z("No Steps Pasted"), {
    description: Z(
      "Please make sure you have copied a step(s) and allowed permission to your clipboard"
    )
  });
}
function zZt(e) {
  const t = [
    e.trigger,
    ...At.getAllNextActionsWithoutChildren(e.trigger)
  ];
  return {
    parentStepName: t[t.length - 1].name,
    stepLocationRelativeToParent: Hn.AFTER
  };
}
function bFe({
  selectedNodes: e,
  flowVersion: t,
  applyOperation: n
}) {
  const r = e.map(
    (o) => At.getStepOrThrow(o, t.trigger)
  ), i = r.every((o) => !!o.skip);
  n({
    type: Tt.SET_SKIP_ACTION,
    request: {
      names: r.map((o) => o.name),
      skip: !i
    }
  });
}
const PS = {
  copySelectedNodes: gFe,
  deleteSelectedNodes: yFe,
  getActionsInClipboard: vFe,
  pasteNodes: uO,
  toggleSkipSelectedNodes: bFe
}, jZt = () => {
  const [
    e,
    t,
    n,
    r,
    i,
    o,
    s,
    l,
    c,
    a
  ] = tn((f) => [
    f.selectedNodes,
    f.flowVersion,
    f.selectedStep,
    f.exitStepSettings,
    f.applyOperation,
    f.readonly,
    f.setShowMinimap,
    f.showMinimap,
    f.setDraggedNote,
    f.setActiveDraggingStep
  ]), u = qn(
    (f) => {
      const d = f.target instanceof HTMLElement && f.target.classList.contains(
        Ie.NODE_SELECTION_RECT_CLASS_NAME
      ), p = f.target instanceof HTMLElement && f.target.closest(
        `[data-${Ie.STEP_CONTEXT_MENU_ATTRIBUTE}]`
      ), h = f.target === document.body, m = e.filter(
        (v) => v !== t.trigger.name
      );
      FZt(f, {
        Minimap: () => {
          s(!l);
        },
        Copy: () => {
          var v;
          m.length > 0 && ((v = document.getSelection()) == null ? void 0 : v.toString()) === "" && (f.stopPropagation(), f.preventDefault(), PS.copySelectedNodes({
            selectedNodes: m,
            flowVersion: t
          }));
        },
        Delete: () => {
          o || e.length > 0 && (f.stopPropagation(), f.preventDefault(), PS.deleteSelectedNodes({
            exitStepSettings: r,
            selectedStep: n,
            selectedNodes: e,
            applyOperation: i
          }));
        },
        Skip: () => {
          o || m.length > 0 && PS.toggleSkipSelectedNodes({
            selectedNodes: m,
            flowVersion: t,
            applyOperation: i
          });
        },
        ExitDrag: () => {
          c(null, null), a(null);
        },
        Paste: () => {
          o || !d && !p && !h || (f.stopPropagation(), f.preventDefault(), PS.getActionsInClipboard().then((v) => {
            if (v.length > 0) {
              const b = [
                t.trigger,
                ...At.getAllNextActionsWithoutChildren(
                  t.trigger
                )
              ].at(-1).name, A = e.length === 1 ? e[0] : null;
              PS.pasteNodes(
                t,
                {
                  parentStepName: A ?? b,
                  stepLocationRelativeToParent: Hn.AFTER
                },
                i
              );
            }
          }));
        }
      });
    },
    [
      e,
      t,
      i,
      n,
      r,
      o,
      s,
      l,
      c,
      a
    ]
  );
  nt(() => (document.addEventListener("keydown", u), () => document.removeEventListener("keydown", u)), [u]);
}, FZt = (e, t) => {
  const n = Object.entries(wM).find(
    ([r, i]) => {
      var o;
      return ((o = i.shortcutKey) == null ? void 0 : o.toLowerCase()) === e.key.toLowerCase() && (i.withCtrl === e.ctrlKey || i.withCtrl === e.metaKey) && !!i.withShift === e.shiftKey;
    }
  );
  n && t[n[0]]();
}, wM = {
  ExitDrag: {
    withCtrl: !1,
    withShift: !1,
    shortcutKey: "Escape"
  },
  Minimap: {
    withCtrl: !0,
    withShift: !1,
    shortcutKey: "m"
  },
  Paste: {
    withCtrl: !0,
    withShift: !1,
    shortcutKey: "v"
  },
  Delete: {
    withCtrl: !1,
    withShift: !0,
    shortcutKey: "Delete"
  },
  Copy: {
    withCtrl: !0,
    withShift: !1,
    shortcutKey: "c"
  },
  Skip: {
    withCtrl: !0,
    withShift: !1,
    shortcutKey: "e"
  }
}, OFe = Ri({
  cursorPosition: { x: 0, y: 0 },
  setCursorPosition: () => {
  }
}), AFe = () => kr(OFe), UZt = ({
  children: e
}) => {
  const t = Xe({ x: 0, y: 0 }), n = (r) => {
    t.current = r;
  };
  return /* @__PURE__ */ y(
    OFe.Provider,
    {
      value: { cursorPosition: t.current, setCursorPosition: n },
      children: e
    }
  );
}, VZt = (e) => {
  nt(() => {
    const t = (n) => {
      e({ x: n.clientX, y: n.clientY });
    };
    return window.addEventListener("pointermove", t), () => {
      window.removeEventListener("pointermove", t);
    };
  }, []);
};
function wFe(e, t = []) {
  let n = [];
  function r(o, s) {
    const l = N.createContext(s), c = n.length;
    n = [...n, s];
    const a = (f) => {
      var b;
      const { scope: d, children: p, ...h } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || l, v = N.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ y(m.Provider, { value: v, children: p });
    };
    a.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || l, h = N.useContext(p);
      if (h) return h;
      if (s !== void 0) return s;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [a, u];
  }
  const i = () => {
    const o = n.map((s) => N.createContext(s));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || o;
      return N.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return i.scopeName = e, [r, qZt(i, ...t)];
}
function qZt(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((l, { useScope: c, scopeName: a }) => {
        const f = c(o)[`__scope${a}`];
        return { ...l, ...f };
      }, {});
      return N.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var BZt = "DismissableLayer", X8 = "dismissableLayer.update", XZt = "dismissableLayer.pointerDownOutside", WZt = "dismissableLayer.focusOutside", Vfe, xFe = N.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), SFe = N.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: l,
      ...c
    } = e, a = N.useContext(xFe), [u, f] = N.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = N.useState({}), h = xn(t, (E) => f(E)), m = Array.from(a.layers), [v] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(v), A = u ? m.indexOf(u) : -1, w = a.layersWithOutsidePointerEventsDisabled.size > 0, O = A >= b, x = QZt((E) => {
      const k = E.target, T = [...a.branches].some((R) => R.contains(k));
      !O || T || (i == null || i(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d), S = $Zt((E) => {
      const k = E.target;
      [...a.branches].some((R) => R.contains(k)) || (o == null || o(E), s == null || s(E), E.defaultPrevented || l == null || l());
    }, d);
    return bxe((E) => {
      A === a.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && l && (E.preventDefault(), l()));
    }, d), N.useEffect(() => {
      if (u)
        return n && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (Vfe = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(u)), a.layers.add(u), qfe(), () => {
          n && a.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Vfe);
        };
    }, [u, d, n, a]), N.useEffect(() => () => {
      u && (a.layers.delete(u), a.layersWithOutsidePointerEventsDisabled.delete(u), qfe());
    }, [u, a]), N.useEffect(() => {
      const E = () => p({});
      return document.addEventListener(X8, E), () => document.removeEventListener(X8, E);
    }, []), /* @__PURE__ */ y(
      Zt.div,
      {
        ...c,
        ref: h,
        style: {
          pointerEvents: w ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ot(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ot(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ot(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
SFe.displayName = BZt;
var ZZt = "DismissableLayerBranch", HZt = N.forwardRef((e, t) => {
  const n = N.useContext(xFe), r = N.useRef(null), i = xn(t, r);
  return N.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ y(Zt.div, { ...e, ref: i });
});
HZt.displayName = ZZt;
function QZt(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ti(e), r = N.useRef(!1), i = N.useRef(() => {
  });
  return N.useEffect(() => {
    const o = (l) => {
      if (l.target && !r.current) {
        let c = function() {
          EFe(
            XZt,
            n,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function $Zt(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ti(e), r = N.useRef(!1);
  return N.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && EFe(WZt, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function qfe() {
  const e = new CustomEvent(X8);
  document.dispatchEvent(e);
}
function EFe(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? yz(i, o) : i.dispatchEvent(o);
}
var R4 = 0;
function KZt() {
  N.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Bfe()), document.body.insertAdjacentElement("beforeend", e[1] ?? Bfe()), R4++, () => {
      R4 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), R4--;
    };
  }, []);
}
function Bfe() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var GZt = "Portal", TFe = N.forwardRef((e, t) => {
  var l;
  const { container: n, ...r } = e, [i, o] = N.useState(!1);
  qi(() => o(!0), []);
  const s = n || i && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return s ? _w.createPortal(/* @__PURE__ */ y(Zt.div, { ...r, ref: t }), s) : null;
});
TFe.displayName = GZt;
function YZt(e, t) {
  return N.useReducer((n, r) => t[n][r] ?? n, e);
}
var qN = (e) => {
  const { present: t, children: n } = e, r = JZt(t), i = typeof n == "function" ? n({ present: r.isPresent }) : N.Children.only(n), o = xn(r.ref, eHt(i));
  return typeof n == "function" || r.isPresent ? N.cloneElement(i, { ref: o }) : null;
};
qN.displayName = "Presence";
function JZt(e) {
  const [t, n] = N.useState(), r = N.useRef({}), i = N.useRef(e), o = N.useRef("none"), s = e ? "mounted" : "unmounted", [l, c] = YZt(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const a = eR(r.current);
    o.current = l === "mounted" ? a : "none";
  }, [l]), qi(() => {
    const a = r.current, u = i.current;
    if (u !== e) {
      const d = o.current, p = eR(a);
      e ? c("MOUNT") : p === "none" || (a == null ? void 0 : a.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), qi(() => {
    if (t) {
      let a;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const m = eR(r.current).includes(p.animationName);
        if (p.target === t && m && (c("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", a = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, d = (p) => {
        p.target === t && (o.current = eR(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(a), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: N.useCallback((a) => {
      a && (r.current = getComputedStyle(a)), n(a);
    }, [])
  };
}
function eR(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function eHt(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var kFe = yQ(), M4 = function() {
}, w3 = N.forwardRef(function(e, t) {
  var n = N.useRef(null), r = N.useState({
    onScrollCapture: M4,
    onWheelCapture: M4,
    onTouchMoveCapture: M4
  }), i = r[0], o = r[1], s = e.forwardProps, l = e.children, c = e.className, a = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, p = e.noIsolation, h = e.inert, m = e.allowPinchZoom, v = e.as, b = v === void 0 ? "div" : v, A = e.gapMode, w = cx(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), O = d, x = gQ([n, t]), S = bi(bi({}, w), i);
  return N.createElement(
    N.Fragment,
    null,
    u && N.createElement(O, { sideCar: kFe, removeScrollBar: a, shards: f, noIsolation: p, inert: h, setCallbacks: o, allowPinchZoom: !!m, lockRef: n, gapMode: A }),
    s ? N.cloneElement(N.Children.only(l), bi(bi({}, S), { ref: x })) : N.createElement(b, bi({}, S, { className: c, ref: x }), l)
  );
});
w3.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
w3.classNames = {
  fullWidth: VO,
  zeroRight: UO
};
var W8 = !1;
if (typeof window < "u")
  try {
    var tR = Object.defineProperty({}, "passive", {
      get: function() {
        return W8 = !0, !0;
      }
    });
    window.addEventListener("test", tR, tR), window.removeEventListener("test", tR, tR);
  } catch {
    W8 = !1;
  }
var d0 = W8 ? { passive: !1 } : !1, tHt = function(e) {
  return e.tagName === "TEXTAREA";
}, CFe = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !tHt(e) && n[t] === "visible")
  );
}, nHt = function(e) {
  return CFe(e, "overflowY");
}, rHt = function(e) {
  return CFe(e, "overflowX");
}, Xfe = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = NFe(e, r);
    if (i) {
      var o = PFe(e, r), s = o[1], l = o[2];
      if (s > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, iHt = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, oHt = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, NFe = function(e, t) {
  return e === "v" ? nHt(t) : rHt(t);
}, PFe = function(e, t) {
  return e === "v" ? iHt(t) : oHt(t);
}, sHt = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, aHt = function(e, t, n, r, i) {
  var o = sHt(e, window.getComputedStyle(t).direction), s = o * r, l = n.target, c = t.contains(l), a = !1, u = s > 0, f = 0, d = 0;
  do {
    var p = PFe(e, l), h = p[0], m = p[1], v = p[2], b = m - v - o * h;
    (h || b) && NFe(e, l) && (f += b, d += h), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(d) < 1) && (a = !0), a;
}, nR = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Wfe = function(e) {
  return [e.deltaX, e.deltaY];
}, Zfe = function(e) {
  return e && "current" in e ? e.current : e;
}, lHt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, cHt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, uHt = 0, f0 = [];
function dHt(e) {
  var t = N.useRef([]), n = N.useRef([0, 0]), r = N.useRef(), i = N.useState(uHt++)[0], o = N.useState(Cz)[0], s = N.useRef(e);
  N.useEffect(function() {
    s.current = e;
  }, [e]), N.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = JC([e.lockRef.current], (e.shards || []).map(Zfe), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = N.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !s.current.allowPinchZoom;
    var b = nR(m), A = n.current, w = "deltaX" in m ? m.deltaX : A[0] - b[0], O = "deltaY" in m ? m.deltaY : A[1] - b[1], x, S = m.target, E = Math.abs(w) > Math.abs(O) ? "h" : "v";
    if ("touches" in m && E === "h" && S.type === "range")
      return !1;
    var k = Xfe(E, S);
    if (!k)
      return !0;
    if (k ? x = E : (x = E === "v" ? "h" : "v", k = Xfe(E, S)), !k)
      return !1;
    if (!r.current && "changedTouches" in m && (w || O) && (r.current = x), !x)
      return !0;
    var T = r.current || x;
    return aHt(T, v, m, T === "h" ? w : O);
  }, []), c = N.useCallback(function(m) {
    var v = m;
    if (!(!f0.length || f0[f0.length - 1] !== o)) {
      var b = "deltaY" in v ? Wfe(v) : nR(v), A = t.current.filter(function(x) {
        return x.name === v.type && (x.target === v.target || v.target === x.shadowParent) && lHt(x.delta, b);
      })[0];
      if (A && A.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!A) {
        var w = (s.current.shards || []).map(Zfe).filter(Boolean).filter(function(x) {
          return x.contains(v.target);
        }), O = w.length > 0 ? l(v, w[0]) : !s.current.noIsolation;
        O && v.cancelable && v.preventDefault();
      }
    }
  }, []), a = N.useCallback(function(m, v, b, A) {
    var w = { name: m, delta: v, target: b, should: A, shadowParent: fHt(b) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== w;
      });
    }, 1);
  }, []), u = N.useCallback(function(m) {
    n.current = nR(m), r.current = void 0;
  }, []), f = N.useCallback(function(m) {
    a(m.type, Wfe(m), m.target, l(m, e.lockRef.current));
  }, []), d = N.useCallback(function(m) {
    a(m.type, nR(m), m.target, l(m, e.lockRef.current));
  }, []);
  N.useEffect(function() {
    return f0.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, d0), document.addEventListener("touchmove", c, d0), document.addEventListener("touchstart", u, d0), function() {
      f0 = f0.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, d0), document.removeEventListener("touchmove", c, d0), document.removeEventListener("touchstart", u, d0);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return N.createElement(
    N.Fragment,
    null,
    h ? N.createElement(o, { styles: cHt(i) }) : null,
    p ? N.createElement(bQ, { gapMode: e.gapMode }) : null
  );
}
function fHt(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const pHt = vQ(kFe, dHt);
var IFe = N.forwardRef(function(e, t) {
  return N.createElement(w3, bi({}, e, { ref: t, sideCar: pHt }));
});
IFe.classNames = w3.classNames;
var Z8 = ["Enter", " "], hHt = ["ArrowDown", "PageUp", "Home"], RFe = ["ArrowUp", "PageDown", "End"], mHt = [...hHt, ...RFe], gHt = {
  ltr: [...Z8, "ArrowRight"],
  rtl: [...Z8, "ArrowLeft"]
}, yHt = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, BN = "Menu", [Rk, vHt, bHt] = Jz(BN), [Db, MFe] = wFe(BN, [
  bHt,
  _f,
  Cg
]), XN = _f(), DFe = Cg(), [_Fe, Vg] = Db(BN), [OHt, WN] = Db(BN), LFe = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: s = !0 } = e, l = XN(t), [c, a] = N.useState(null), u = N.useRef(!1), f = ti(o), d = Eb(i);
  return N.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ y(ox, { ...l, children: /* @__PURE__ */ y(
    _Fe,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: c,
      onContentChange: a,
      children: /* @__PURE__ */ y(
        OHt,
        {
          scope: t,
          onClose: N.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: d,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
LFe.displayName = BN;
var AHt = "MenuAnchor", UY = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = XN(n);
    return /* @__PURE__ */ y(sx, { ...i, ...r, ref: t });
  }
);
UY.displayName = AHt;
var VY = "MenuPortal", [wHt, zFe] = Db(VY, {
  forceMount: void 0
}), jFe = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Vg(VY, t);
  return /* @__PURE__ */ y(wHt, { scope: t, forceMount: n, children: /* @__PURE__ */ y(qN, { present: n || o.open, children: /* @__PURE__ */ y(TFe, { asChild: !0, container: i, children: r }) }) });
};
jFe.displayName = VY;
var tu = "MenuContent", [xHt, qY] = Db(tu), FFe = N.forwardRef(
  (e, t) => {
    const n = zFe(tu, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Vg(tu, e.__scopeMenu), s = WN(tu, e.__scopeMenu);
    return /* @__PURE__ */ y(Rk.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(qN, { present: r || o.open, children: /* @__PURE__ */ y(Rk.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ y(SHt, { ...i, ref: t }) : /* @__PURE__ */ y(EHt, { ...i, ref: t }) }) }) });
  }
), SHt = N.forwardRef(
  (e, t) => {
    const n = Vg(tu, e.__scopeMenu), r = N.useRef(null), i = xn(t, r);
    return N.useEffect(() => {
      const o = r.current;
      if (o) return ux(o);
    }, []), /* @__PURE__ */ y(
      BY,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ot(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), EHt = N.forwardRef((e, t) => {
  const n = Vg(tu, e.__scopeMenu);
  return /* @__PURE__ */ y(
    BY,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), BY = N.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: o,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: l,
      onEntryFocus: c,
      onEscapeKeyDown: a,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: d,
      onDismiss: p,
      disableOutsideScroll: h,
      ...m
    } = e, v = Vg(tu, n), b = WN(tu, n), A = XN(n), w = DFe(n), O = vHt(n), [x, S] = N.useState(null), E = N.useRef(null), k = xn(t, E, v.onContentChange), T = N.useRef(0), R = N.useRef(""), j = N.useRef(0), F = N.useRef(null), L = N.useRef("right"), _ = N.useRef(0), U = h ? IFe : N.Fragment, z = h ? { as: is, allowPinchZoom: !0 } : void 0, C = (M) => {
      var oe, ce;
      const D = R.current + M, X = O().filter((fe) => !fe.disabled), B = document.activeElement, q = (oe = X.find((fe) => fe.ref.current === B)) == null ? void 0 : oe.textValue, H = X.map((fe) => fe.textValue), Y = zHt(H, D, q), J = (ce = X.find((fe) => fe.textValue === Y)) == null ? void 0 : ce.ref.current;
      (function fe($) {
        R.current = $, window.clearTimeout(T.current), $ !== "" && (T.current = window.setTimeout(() => fe(""), 1e3));
      })(D), J && setTimeout(() => J.focus());
    };
    N.useEffect(() => () => window.clearTimeout(T.current), []), KZt();
    const I = N.useCallback((M) => {
      var X, B;
      return L.current === ((X = F.current) == null ? void 0 : X.side) && FHt(M, (B = F.current) == null ? void 0 : B.area);
    }, []);
    return /* @__PURE__ */ y(
      xHt,
      {
        scope: n,
        searchRef: R,
        onItemEnter: N.useCallback(
          (M) => {
            I(M) && M.preventDefault();
          },
          [I]
        ),
        onItemLeave: N.useCallback(
          (M) => {
            var D;
            I(M) || ((D = E.current) == null || D.focus(), S(null));
          },
          [I]
        ),
        onTriggerLeave: N.useCallback(
          (M) => {
            I(M) && M.preventDefault();
          },
          [I]
        ),
        pointerGraceTimerRef: j,
        onPointerGraceIntentChange: N.useCallback((M) => {
          F.current = M;
        }, []),
        children: /* @__PURE__ */ y(U, { ...z, children: /* @__PURE__ */ y(
          lx,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: ot(o, (M) => {
              var D;
              M.preventDefault(), (D = E.current) == null || D.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ y(
              SFe,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: a,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: d,
                onDismiss: p,
                children: /* @__PURE__ */ y(
                  tj,
                  {
                    asChild: !0,
                    ...w,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: S,
                    onEntryFocus: ot(c, (M) => {
                      b.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ y(
                      KC,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": n5e(v.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...A,
                        ...m,
                        ref: k,
                        style: { outline: "none", ...m.style },
                        onKeyDown: ot(m.onKeyDown, (M) => {
                          const X = M.target.closest("[data-radix-menu-content]") === M.currentTarget, B = M.ctrlKey || M.altKey || M.metaKey, q = M.key.length === 1;
                          X && (M.key === "Tab" && M.preventDefault(), !B && q && C(M.key));
                          const H = E.current;
                          if (M.target !== H || !mHt.includes(M.key)) return;
                          M.preventDefault();
                          const J = O().filter((oe) => !oe.disabled).map((oe) => oe.ref.current);
                          RFe.includes(M.key) && J.reverse(), _Ht(J);
                        }),
                        onBlur: ot(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(T.current), R.current = "");
                        }),
                        onPointerMove: ot(
                          e.onPointerMove,
                          Mk((M) => {
                            const D = M.target, X = _.current !== M.clientX;
                            if (M.currentTarget.contains(D) && X) {
                              const B = M.clientX > _.current ? "right" : "left";
                              L.current = B, _.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
FFe.displayName = tu;
var THt = "MenuGroup", XY = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(Zt.div, { role: "group", ...r, ref: t });
  }
);
XY.displayName = THt;
var kHt = "MenuLabel", UFe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(Zt.div, { ...r, ref: t });
  }
);
UFe.displayName = kHt;
var iL = "MenuItem", Hfe = "menu.itemSelect", x3 = N.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...i } = e, o = N.useRef(null), s = WN(iL, e.__scopeMenu), l = qY(iL, e.__scopeMenu), c = xn(t, o), a = N.useRef(!1), u = () => {
      const f = o.current;
      if (!n && f) {
        const d = new CustomEvent(Hfe, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Hfe, (p) => r == null ? void 0 : r(p), { once: !0 }), yz(f, d), d.defaultPrevented ? a.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ y(
      VFe,
      {
        ...i,
        ref: c,
        disabled: n,
        onClick: ot(e.onClick, u),
        onPointerDown: (f) => {
          var d;
          (d = e.onPointerDown) == null || d.call(e, f), a.current = !0;
        },
        onPointerUp: ot(e.onPointerUp, (f) => {
          var d;
          a.current || (d = f.currentTarget) == null || d.click();
        }),
        onKeyDown: ot(e.onKeyDown, (f) => {
          const d = l.searchRef.current !== "";
          n || d && f.key === " " || Z8.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
x3.displayName = iL;
var VFe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, s = qY(iL, n), l = DFe(n), c = N.useRef(null), a = xn(t, c), [u, f] = N.useState(!1), [d, p] = N.useState("");
    return N.useEffect(() => {
      const h = c.current;
      h && p((h.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ y(
      Rk.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? d,
        children: /* @__PURE__ */ y(nj, { asChild: !0, ...l, focusable: !r, children: /* @__PURE__ */ y(
          Zt.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...o,
            ref: a,
            onPointerMove: ot(
              e.onPointerMove,
              Mk((h) => {
                r ? s.onItemLeave(h) : (s.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ot(
              e.onPointerLeave,
              Mk((h) => s.onItemLeave(h))
            ),
            onFocus: ot(e.onFocus, () => f(!0)),
            onBlur: ot(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), CHt = "MenuCheckboxItem", qFe = N.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = e;
    return /* @__PURE__ */ y(HFe, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ y(
      x3,
      {
        role: "menuitemcheckbox",
        "aria-checked": oL(n) ? "mixed" : n,
        ...i,
        ref: t,
        "data-state": HY(n),
        onSelect: ot(
          i.onSelect,
          () => r == null ? void 0 : r(oL(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
qFe.displayName = CHt;
var BFe = "MenuRadioGroup", [NHt, PHt] = Db(
  BFe,
  { value: void 0, onValueChange: () => {
  } }
), XFe = N.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...i } = e, o = ti(r);
    return /* @__PURE__ */ y(NHt, { scope: e.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ y(XY, { ...i, ref: t }) });
  }
);
XFe.displayName = BFe;
var WFe = "MenuRadioItem", ZFe = N.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = PHt(WFe, e.__scopeMenu), o = n === i.value;
    return /* @__PURE__ */ y(HFe, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ y(
      x3,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...r,
        ref: t,
        "data-state": HY(o),
        onSelect: ot(
          r.onSelect,
          () => {
            var s;
            return (s = i.onValueChange) == null ? void 0 : s.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ZFe.displayName = WFe;
var WY = "MenuItemIndicator", [HFe, IHt] = Db(
  WY,
  { checked: !1 }
), QFe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...i } = e, o = IHt(WY, n);
    return /* @__PURE__ */ y(
      qN,
      {
        present: r || oL(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ y(
          Zt.span,
          {
            ...i,
            ref: t,
            "data-state": HY(o.checked)
          }
        )
      }
    );
  }
);
QFe.displayName = WY;
var RHt = "MenuSeparator", $Fe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ y(
      Zt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
$Fe.displayName = RHt;
var MHt = "MenuArrow", KFe = N.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = XN(n);
    return /* @__PURE__ */ y(GC, { ...i, ...r, ref: t });
  }
);
KFe.displayName = MHt;
var ZY = "MenuSub", [DHt, GFe] = Db(ZY), YFe = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: i } = e, o = Vg(ZY, t), s = XN(t), [l, c] = N.useState(null), [a, u] = N.useState(null), f = ti(i);
  return N.useEffect(() => (o.open === !1 && f(!1), () => f(!1)), [o.open, f]), /* @__PURE__ */ y(ox, { ...s, children: /* @__PURE__ */ y(
    _Fe,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: a,
      onContentChange: u,
      children: /* @__PURE__ */ y(
        DHt,
        {
          scope: t,
          contentId: ka(),
          triggerId: ka(),
          trigger: l,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
YFe.displayName = ZY;
var S1 = "MenuSubTrigger", JFe = N.forwardRef(
  (e, t) => {
    const n = Vg(S1, e.__scopeMenu), r = WN(S1, e.__scopeMenu), i = GFe(S1, e.__scopeMenu), o = qY(S1, e.__scopeMenu), s = N.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: c } = o, a = { __scopeMenu: e.__scopeMenu }, u = N.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return N.useEffect(() => u, [u]), N.useEffect(() => {
      const f = l.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [l, c]), /* @__PURE__ */ y(UY, { asChild: !0, ...a, children: /* @__PURE__ */ y(
      VFe,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": n5e(n.open),
        ...e,
        ref: ZC(t, i.onTriggerChange),
        onClick: (f) => {
          var d;
          (d = e.onClick) == null || d.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ot(
          e.onPointerMove,
          Mk((f) => {
            o.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: ot(
          e.onPointerLeave,
          Mk((f) => {
            var p, h;
            u();
            const d = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (d) {
              const m = (h = n.content) == null ? void 0 : h.dataset.side, v = m === "right", b = v ? -5 : 5, A = d[v ? "left" : "right"], w = d[v ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + b, y: f.clientY },
                  { x: A, y: d.top },
                  { x: w, y: d.top },
                  { x: w, y: d.bottom },
                  { x: A, y: d.bottom }
                ],
                side: m
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(f), f.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ot(e.onKeyDown, (f) => {
          var p;
          const d = o.searchRef.current !== "";
          e.disabled || d && f.key === " " || gHt[r.dir].includes(f.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
JFe.displayName = S1;
var e5e = "MenuSubContent", t5e = N.forwardRef(
  (e, t) => {
    const n = zFe(tu, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Vg(tu, e.__scopeMenu), s = WN(tu, e.__scopeMenu), l = GFe(e5e, e.__scopeMenu), c = N.useRef(null), a = xn(t, c);
    return /* @__PURE__ */ y(Rk.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(qN, { present: r || o.open, children: /* @__PURE__ */ y(Rk.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ y(
      BY,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...i,
        ref: a,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          s.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: ot(e.onFocusOutside, (u) => {
          u.target !== l.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: ot(e.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: ot(e.onKeyDown, (u) => {
          var p;
          const f = u.currentTarget.contains(u.target), d = yHt[s.dir].includes(u.key);
          f && d && (o.onOpenChange(!1), (p = l.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
t5e.displayName = e5e;
function n5e(e) {
  return e ? "open" : "closed";
}
function oL(e) {
  return e === "indeterminate";
}
function HY(e) {
  return oL(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function _Ht(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function LHt(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function zHt(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((a) => a === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let s = LHt(e, Math.max(o, 0));
  i.length === 1 && (s = s.filter((a) => a !== n));
  const c = s.find(
    (a) => a.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function jHt(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const l = t[o].x, c = t[o].y, a = t[s].x, u = t[s].y;
    c > r != u > r && n < (a - l) * (r - c) / (u - c) + l && (i = !i);
  }
  return i;
}
function FHt(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return jHt(n, t);
}
function Mk(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var UHt = LFe, VHt = UY, qHt = jFe, BHt = FFe, XHt = XY, WHt = UFe, ZHt = x3, HHt = qFe, QHt = XFe, $Ht = ZFe, KHt = QFe, GHt = $Fe, YHt = KFe, JHt = YFe, eQt = JFe, tQt = t5e, QY = "ContextMenu", [nQt, Mmn] = wFe(QY, [
  MFe
]), la = MFe(), [rQt, r5e] = nQt(QY), i5e = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: r, dir: i, modal: o = !0 } = e, [s, l] = N.useState(!1), c = la(t), a = ti(r), u = N.useCallback(
    (f) => {
      l(f), a(f);
    },
    [a]
  );
  return /* @__PURE__ */ y(
    rQt,
    {
      scope: t,
      open: s,
      onOpenChange: u,
      modal: o,
      children: /* @__PURE__ */ y(
        UHt,
        {
          ...c,
          dir: i,
          open: s,
          onOpenChange: u,
          modal: o,
          children: n
        }
      )
    }
  );
};
i5e.displayName = QY;
var o5e = "ContextMenuTrigger", s5e = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, disabled: r = !1, ...i } = e, o = r5e(o5e, n), s = la(n), l = N.useRef({ x: 0, y: 0 }), c = N.useRef({
      getBoundingClientRect: () => DOMRect.fromRect({ width: 0, height: 0, ...l.current })
    }), a = N.useRef(0), u = N.useCallback(
      () => window.clearTimeout(a.current),
      []
    ), f = (d) => {
      l.current = { x: d.clientX, y: d.clientY }, o.onOpenChange(!0);
    };
    return N.useEffect(() => u, [u]), N.useEffect(() => void (r && u()), [r, u]), /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(VHt, { ...s, virtualRef: c }),
      /* @__PURE__ */ y(
        Zt.span,
        {
          "data-state": o.open ? "open" : "closed",
          "data-disabled": r ? "" : void 0,
          ...i,
          ref: t,
          style: { WebkitTouchCallout: "none", ...e.style },
          onContextMenu: r ? e.onContextMenu : ot(e.onContextMenu, (d) => {
            u(), f(d), d.preventDefault();
          }),
          onPointerDown: r ? e.onPointerDown : ot(
            e.onPointerDown,
            rR((d) => {
              u(), a.current = window.setTimeout(() => f(d), 700);
            })
          ),
          onPointerMove: r ? e.onPointerMove : ot(e.onPointerMove, rR(u)),
          onPointerCancel: r ? e.onPointerCancel : ot(e.onPointerCancel, rR(u)),
          onPointerUp: r ? e.onPointerUp : ot(e.onPointerUp, rR(u))
        }
      )
    ] });
  }
);
s5e.displayName = o5e;
var iQt = "ContextMenuPortal", a5e = (e) => {
  const { __scopeContextMenu: t, ...n } = e, r = la(t);
  return /* @__PURE__ */ y(qHt, { ...r, ...n });
};
a5e.displayName = iQt;
var l5e = "ContextMenuContent", c5e = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, i = r5e(l5e, n), o = la(n), s = N.useRef(!1);
    return /* @__PURE__ */ y(
      BHt,
      {
        ...o,
        ...r,
        ref: t,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (l) => {
          var c;
          (c = e.onCloseAutoFocus) == null || c.call(e, l), !l.defaultPrevented && s.current && l.preventDefault(), s.current = !1;
        },
        onInteractOutside: (l) => {
          var c;
          (c = e.onInteractOutside) == null || c.call(e, l), !l.defaultPrevented && !i.modal && (s.current = !0);
        },
        style: {
          ...e.style,
          "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
c5e.displayName = l5e;
var oQt = "ContextMenuGroup", sQt = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, i = la(n);
    return /* @__PURE__ */ y(XHt, { ...i, ...r, ref: t });
  }
);
sQt.displayName = oQt;
var aQt = "ContextMenuLabel", u5e = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, i = la(n);
    return /* @__PURE__ */ y(WHt, { ...i, ...r, ref: t });
  }
);
u5e.displayName = aQt;
var lQt = "ContextMenuItem", d5e = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, i = la(n);
    return /* @__PURE__ */ y(ZHt, { ...i, ...r, ref: t });
  }
);
d5e.displayName = lQt;
var cQt = "ContextMenuCheckboxItem", f5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(HHt, { ...i, ...r, ref: t });
});
f5e.displayName = cQt;
var uQt = "ContextMenuRadioGroup", dQt = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(QHt, { ...i, ...r, ref: t });
});
dQt.displayName = uQt;
var fQt = "ContextMenuRadioItem", p5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y($Ht, { ...i, ...r, ref: t });
});
p5e.displayName = fQt;
var pQt = "ContextMenuItemIndicator", h5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(KHt, { ...i, ...r, ref: t });
});
h5e.displayName = pQt;
var hQt = "ContextMenuSeparator", m5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(GHt, { ...i, ...r, ref: t });
});
m5e.displayName = hQt;
var mQt = "ContextMenuArrow", gQt = N.forwardRef(
  (e, t) => {
    const { __scopeContextMenu: n, ...r } = e, i = la(n);
    return /* @__PURE__ */ y(YHt, { ...i, ...r, ref: t });
  }
);
gQt.displayName = mQt;
var yQt = "ContextMenuSub", g5e = (e) => {
  const { __scopeContextMenu: t, children: n, onOpenChange: r, open: i, defaultOpen: o } = e, s = la(t), [l, c] = wl({
    prop: i,
    defaultProp: o,
    onChange: r
  });
  return /* @__PURE__ */ y(JHt, { ...s, open: l, onOpenChange: c, children: n });
};
g5e.displayName = yQt;
var vQt = "ContextMenuSubTrigger", y5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(eQt, { ...i, ...r, ref: t });
});
y5e.displayName = vQt;
var bQt = "ContextMenuSubContent", v5e = N.forwardRef((e, t) => {
  const { __scopeContextMenu: n, ...r } = e, i = la(n);
  return /* @__PURE__ */ y(
    tQt,
    {
      ...i,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
v5e.displayName = bQt;
function rR(e) {
  return (t) => t.pointerType !== "mouse" ? e(t) : void 0;
}
var OQt = i5e, AQt = s5e, wQt = a5e, b5e = c5e, O5e = u5e, A5e = d5e, w5e = f5e, x5e = p5e, S5e = h5e, E5e = m5e, xQt = g5e, T5e = y5e, k5e = v5e;
const SQt = OQt, EQt = AQt, TQt = xQt, C5e = N.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ V(
  T5e,
  {
    ref: i,
    className: Se(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ y(HC, { className: "rtl:scale-x-[-1] ml-auto h-4 w-4" })
    ]
  }
));
C5e.displayName = T5e.displayName;
const N5e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  k5e,
  {
    ref: n,
    className: Se(
      "z-50 min-w-32 overflow-hidden rounded-md border bg-background p-1 text-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
N5e.displayName = k5e.displayName;
const P5e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(wQt, { children: /* @__PURE__ */ y(
  b5e,
  {
    ref: n,
    className: Se(
      "z-50 min-w-32 overflow-hidden rounded-md border bg-background p-1 text-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
) }));
P5e.displayName = b5e.displayName;
const Su = N.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ y(
  A5e,
  {
    ref: r,
    className: Se(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Su.displayName = A5e.displayName;
const kQt = N.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ V(
  w5e,
  {
    ref: i,
    className: Se(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ y("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ y(S5e, { children: /* @__PURE__ */ y(Af, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
kQt.displayName = w5e.displayName;
const CQt = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ V(
  x5e,
  {
    ref: r,
    className: Se(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ y("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ y(S5e, { children: /* @__PURE__ */ y(QH, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
CQt.displayName = x5e.displayName;
const NQt = N.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ y(
  O5e,
  {
    ref: r,
    className: Se(
      "px-2 py-1.5 text-sm font-semibold text-foreground",
      t && "pl-8",
      e
    ),
    ...n
  }
));
NQt.displayName = O5e.displayName;
const H8 = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  E5e,
  {
    ref: n,
    className: Se("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
H8.displayName = E5e.displayName;
const D4 = ({
  children: e,
  shortcut: t
}) => /* @__PURE__ */ V("div", { className: "flex items-center justify-between gap-4 grow", children: [
  /* @__PURE__ */ y("div", { className: "flex gap-2 items-center", children: e }),
  /* @__PURE__ */ y(vxe, { ...t, className: "text-end" })
] }), PQt = ({
  contextMenuType: e,
  contextMenuStepName: t
}) => {
  const [
    n,
    r,
    i,
    o,
    s,
    l,
    c
  ] = tn((R) => [
    R.selectedNodes,
    R.applyOperation,
    R.selectedStep,
    R.flowVersion,
    R.exitStepSettings,
    R.readonly,
    R.setOpenedPieceSelectorStepNameOrAddButtonId
  ]), a = t ? [t] : n, u = a.length === 0, f = a.every(
    (R) => {
      var j;
      return !!((j = At.getStep(R, o.trigger)) != null && j.skip);
    }
  ), d = a.some(
    (R) => R === o.trigger.name
  ), p = At.getStep(
    a[0],
    o.trigger
  ), h = !l && e === ql.CANVAS, m = a.length === 1 && (p == null ? void 0 : p.type) === qe.LOOP_ON_ITEMS && !l && e === ql.STEP, v = a.length === 1 && (p == null ? void 0 : p.type) === qe.ROUTER && !l && e === ql.STEP, b = a.length === 1 && !l && e === ql.STEP, A = a.length === 1 && !l && e === ql.STEP, w = !d && e === ql.STEP, O = a.length === 1 && !d && e === ql.STEP && !l, x = !d && e === ql.STEP && !l, S = a.length === 1 && d, E = !l && e === ql.STEP && !S, k = () => {
    r({
      type: Tt.DUPLICATE_ACTION,
      request: {
        stepName: a[0]
      }
    });
  };
  return A || w || O || x || m || v || b || h || E ? /* @__PURE__ */ V(P5e, { children: [
    A && /* @__PURE__ */ V(
      Su,
      {
        disabled: u,
        onClick: () => {
          c(
            a[0]
          );
        },
        className: "flex items-center gap-2",
        children: [
          /* @__PURE__ */ y(Wrt, { className: "w-4 h-4" }),
          " ",
          Z("Replace")
        ]
      }
    ),
    w && /* @__PURE__ */ y(
      Su,
      {
        disabled: u,
        onClick: () => {
          gFe({
            selectedNodes: a,
            flowVersion: o
          });
        },
        children: /* @__PURE__ */ V(D4, { shortcut: wM.Copy, children: [
          /* @__PURE__ */ y(Cv, { className: "w-4 h-4" }),
          " ",
          Z("Copy")
        ] })
      }
    ),
    /* @__PURE__ */ V(pt, { children: [
      O && /* @__PURE__ */ V(
        Su,
        {
          disabled: u,
          onClick: k,
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ y($H, { className: "w-4 h-4" }),
            " ",
            Z("Duplicate")
          ]
        }
      ),
      x && /* @__PURE__ */ y(
        Su,
        {
          disabled: u,
          onClick: () => {
            bFe({
              selectedNodes: a,
              flowVersion: o,
              applyOperation: r
            });
          },
          children: /* @__PURE__ */ V(D4, { shortcut: wM.Skip, children: [
            f ? /* @__PURE__ */ y(Hot, { className: "h-4 w-4" }) : /* @__PURE__ */ y(ixe, { className: "h-4 w-4" }),
            Z(f ? "Unskip" : "Skip")
          ] })
        }
      ),
      (m || v || b) && /* @__PURE__ */ y(H8, {}),
      h && /* @__PURE__ */ V(
        Su,
        {
          onClick: () => {
            const R = zZt(o);
            R && uO(o, R, r);
          },
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ y(Kre, { className: "w-4 h-4" }),
            " ",
            Z("Paste After Last Step")
          ]
        }
      ),
      m && /* @__PURE__ */ V(
        Su,
        {
          onClick: () => {
            uO(
              o,
              {
                parentStepName: a[0],
                stepLocationRelativeToParent: Hn.INSIDE_LOOP
              },
              r
            );
          },
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ y($re, { className: "w-4 h-4" }),
            " ",
            Z("Paste Inside Loop")
          ]
        }
      ),
      b && /* @__PURE__ */ V(
        Su,
        {
          onClick: () => {
            uO(
              o,
              {
                parentStepName: a[0],
                stepLocationRelativeToParent: Hn.AFTER
              },
              r
            );
          },
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ y(Kre, { className: "w-4 h-4" }),
            " ",
            Z("Paste After")
          ]
        }
      ),
      v && /* @__PURE__ */ V(TQt, { children: [
        /* @__PURE__ */ V(C5e, { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ y($re, { className: "w-4 h-4" }),
          " ",
          Z("Paste Inside...")
        ] }),
        /* @__PURE__ */ y(N5e, { children: (() => {
          const R = (p == null ? void 0 : p.settings.branches) ?? [], j = Math.max(0, R.length - 1), F = `Branch ${Math.max(1, R.length)}`;
          return /* @__PURE__ */ V(pt, { children: [
            p && R.map(
              (L, _) => /* @__PURE__ */ y(
                Su,
                {
                  onClick: () => {
                    uO(
                      o,
                      {
                        parentStepName: a[0],
                        stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
                        branchIndex: _
                      },
                      r
                    );
                  },
                  children: L.branchName
                },
                L.branchName
              )
            ),
            /* @__PURE__ */ V(
              Su,
              {
                onClick: () => {
                  r({
                    type: Tt.ADD_BRANCH,
                    request: {
                      stepName: p.name,
                      branchIndex: j,
                      branchName: F
                    }
                  }), uO(
                    o,
                    {
                      parentStepName: p.name,
                      stepLocationRelativeToParent: Hn.INSIDE_BRANCH,
                      branchIndex: j
                    },
                    r
                  );
                },
                children: [
                  "+ ",
                  Z("New Branch")
                ]
              }
            )
          ] });
        })() })
      ] }),
      E && /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y(H8, {}),
        /* @__PURE__ */ y(
          Su,
          {
            disabled: u,
            onClick: () => {
              yFe({
                selectedNodes: a,
                applyOperation: r,
                selectedStep: i,
                exitStepSettings: s
              });
            },
            children: /* @__PURE__ */ V(D4, { shortcut: wM.Delete, children: [
              /* @__PURE__ */ y(xb, { className: "w-4 stroke-destructive h-4" }),
              " ",
              /* @__PURE__ */ y("div", { className: "text-destructive", children: Z("Delete") })
            ] })
          }
        )
      ] })
    ] })
  ] }) : null;
};
var ql = /* @__PURE__ */ ((e) => (e.CANVAS = "CANVAS", e.STEP = "STEP", e))(ql || {});
const IQt = ({
  contextMenuType: e,
  contextMenuStepName: t,
  children: n
}) => /* @__PURE__ */ V(SQt, { children: [
  /* @__PURE__ */ y(EQt, { asChild: !0, children: n }),
  /* @__PURE__ */ y(
    PQt,
    {
      contextMenuType: e,
      contextMenuStepName: t
    }
  )
] }), RQt = Ri({
  cursorPosition: { x: 0, y: 0 },
  setCursorPosition: () => {
  }
}), MQt = () => kr(RQt), DQt = (e) => {
  nt(() => {
    const t = (n) => {
      e({ x: n.clientX, y: n.clientY });
    };
    return window.addEventListener("pointermove", t), () => {
      window.removeEventListener("pointermove", t);
    };
  }, [e]);
}, _Qt = () => {
  const { open: e } = dx(), { cursorPosition: t } = MQt(), [n, r] = He(t), i = document.getElementById(
    Ie.BUILDER_NAVIGATION_SIDEBAR_ID
  ), [o, s, l] = tn(
    (m) => [m.draggedNote, m.noteDragOverlayMode, m.addNote]
  ), c = yd(), a = Xe(null), u = e ? (i == null ? void 0 : i.clientWidth) ?? 0 : 0, f = {
    width: ((o == null ? void 0 : o.size.width) ?? 0) * c.getZoom(),
    height: ((o == null ? void 0 : o.size.height) ?? 0) * c.getZoom()
  }, d = `${n.x - f.width / 2 - u}px`, p = `${n.y - 50 - f.height / 2}px`;
  return DQt((m) => {
    r(m);
  }), De(o) || De(s) ? null : /* @__PURE__ */ y(
    "div",
    {
      className: "absolute left-0 top-0  !cursor-grabbing note-drag-overlay",
      ref: a,
      onClick: () => {
        var m;
        if (s === KK.CREATE) {
          const v = (m = a.current) == null ? void 0 : m.getBoundingClientRect();
          if (v) {
            const b = c.screenToFlowPosition({
              x: v.left,
              y: v.top
            });
            l({
              content: Ie.DEFAULT_NOTE_CONTENT,
              position: b,
              size: o.size,
              color: Ie.DEFAULT_NOTE_COLOR
            });
          }
        }
      },
      style: {
        left: d,
        top: p,
        height: `${o.size.height * c.getZoom()}px`,
        width: `${o.size.width * c.getZoom()}px`
      },
      children: /* @__PURE__ */ y(
        dMe,
        {
          isDragging: !0,
          note: {
            ...o,
            size: {
              width: o.size.width * c.getZoom(),
              height: o.size.height * c.getZoom()
            }
          }
        }
      )
    }
  );
}, LQt = ({ step: e }) => {
  var u;
  const { open: t } = dx(), { cursorPosition: n } = AFe(), [r, i] = He(n), o = document.getElementById(
    Ie.BUILDER_NAVIGATION_SIDEBAR_ID
  ), s = t ? (o == null ? void 0 : o.clientWidth) ?? 0 : 0, l = `${r.x - Ie.STEP_DRAG_OVERLAY_WIDTH / 2 - s}px`, c = `${r.y - Ie.STEP_DRAG_OVERLAY_HEIGHT - 20}px`, { stepMetadata: a } = vd.useStepMetadata({
    step: e
  });
  return VZt((f) => {
    i(f);
  }), /* @__PURE__ */ y(
    "div",
    {
      className: "p-4 absolute left-0 top-0 cursor-grabbing  opacity-75  flex items-center justify-center rounded-2xl border border-solid border bg-background",
      style: {
        left: l,
        top: c,
        height: `${Ie.STEP_DRAG_OVERLAY_HEIGHT}px`,
        width: `${Ie.STEP_DRAG_OVERLAY_WIDTH}px`
      },
      children: /* @__PURE__ */ y(
        "img",
        {
          id: Z("logo"),
          className: "object-contain left-0 right-0 static",
          src: ((u = e == null ? void 0 : e.settings) == null ? void 0 : u.customLogoUrl) ?? (a == null ? void 0 : a.logoUrl),
          alt: Z("Step Icon")
        }
      )
    }
  );
}, zQt = ({ children: e }) => {
  const t = tyt(), [n, r] = He(t), [
    i,
    o,
    s,
    l,
    c,
    a,
    u
  ] = tn((A) => [
    A.setActiveDraggingStep,
    A.applyOperation,
    A.flowVersion,
    A.activeDraggingStep,
    A.setDraggedNote,
    A.getNoteById,
    A.moveNote
  ]), f = qn(
    (A) => {
      if (!A.pointerCoordinates)
        return XB(A);
      const { x: w, y: O } = A.pointerCoordinates, { width: x, height: S } = A.collisionRect, E = {
        x: n.x - t.x,
        y: n.y - t.y
      }, k = {
        ...A,
        // The collision rectangle is broken when using snapCenterToCursor. Reset
        // the collision rectangle based on pointer location and overlay size.
        collisionRect: {
          width: x,
          height: S,
          bottom: O + S / 2 + E.y,
          left: w - x / 2 + E.x,
          right: w + x / 2 + E.x,
          top: O - S / 2 + E.y
        }
      };
      return XB(k);
    },
    [t.x, t.y, n.x, n.y]
  ), d = l ? At.getStep(l, s.trigger) : void 0, p = (A) => {
    var w, O;
    if (((w = A.active.data.current) == null ? void 0 : w.type) === Ie.DRAGGED_STEP_TAG && i(A.active.id.toString()), ((O = A.active.data.current) == null ? void 0 : O.type) === Ie.DRAGGED_NOTE_TAG) {
      const x = a(A.active.id.toString());
      x && c(x, KK.MOVE);
    }
    r(t);
  }, h = () => {
    i(null), c(null, null);
  }, m = yd(), v = (A) => {
    i(null), c(null, null), jQt({ e: A, applyOperation: o, activeDraggingStep: l, flowVersion: s }), FQt({ e: A, getNoteById: a, moveNote: u, reactFlow: m });
  }, b = VEe(
    wE(KQ, {
      activationConstraint: {
        distance: 10
      }
    }),
    wE(GQ)
  );
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V(
      iTe,
      {
        onDragStart: p,
        onDragEnd: v,
        onDragCancel: h,
        sensors: b,
        collisionDetection: f,
        children: [
          e,
          /* @__PURE__ */ y(aTe, { dropAnimation: { duration: 0 } })
        ]
      }
    ),
    d && /* @__PURE__ */ y(LQt, { step: d }),
    /* @__PURE__ */ y(_Qt, {})
  ] });
};
function jQt({
  e,
  applyOperation: t,
  activeDraggingStep: n,
  flowVersion: r
}) {
  var s, l, c, a, u;
  const i = n ? At.getStep(n, r.trigger) : void 0;
  if (!De((l = (s = e.over) == null ? void 0 : s.data) == null ? void 0 : l.current) && e.over.data.current.accepts === ((a = (c = e.active.data) == null ? void 0 : c.current) == null ? void 0 : a.type)) {
    const f = (u = e.over) == null ? void 0 : u.data.current;
    if (f != null && f.parentStepName && i && i.name !== f.parentStepName) {
      if (At.isChildOf(
        i,
        f.parentStepName
      )) {
        vr(Z("Invalid Move"), {
          description: Z(
            "The destination location is a child of the dragged step"
          ),
          duration: 3e3
        });
        return;
      }
      t({
        type: Tt.MOVE_ACTION,
        request: {
          name: i.name,
          newParentStep: f.parentStepName,
          stepLocationRelativeToNewParent: f.stepLocationRelativeToParent,
          branchIndex: f.stepLocationRelativeToParent === Hn.INSIDE_BRANCH ? f.branchIndex : void 0
        }
      });
    }
  }
}
function FQt({
  e,
  getNoteById: t,
  moveNote: n,
  reactFlow: r
}) {
  var i;
  if (((i = e.active.data.current) == null ? void 0 : i.type) === Ie.DRAGGED_NOTE_TAG) {
    const o = t(e.active.id.toString());
    if (o) {
      const s = document.getElementById(e.active.id.toString());
      if (s) {
        const l = r.screenToFlowPosition({
          x: s.getBoundingClientRect().left,
          y: s.getBoundingClientRect().top
        });
        n(o.id, l);
      }
    }
  }
}
const UQt = (e) => {
  const t = Xe(null), n = e === zr.NONE;
  return nt(() => {
    var i, o, s;
    const r = ((i = t.current) == null ? void 0 : i.getSize()) ?? 0;
    n ? (o = t.current) == null || o.resize(0) : r === 0 && ((s = t.current) == null || s.resize(25));
  }, [t, e, n]), t;
}, VQt = (e) => {
  const t = Zv(), { mutate: n } = dr({
    mutationFn: _x.getPopulated
  }), [r, i, o] = tn((s) => [
    s.run,
    s.setRun,
    s.flowVersion
  ]);
  nt(() => (t.on(pi.REFRESH_PIECE, () => {
    e();
  }), t.on(pi.FLOW_RUN_PROGRESS, (s) => {
    const l = s == null ? void 0 : s.runId;
    r && (r == null ? void 0 : r.id) === l && n(l, {
      onSuccess: (c) => {
        i(c, o);
      }
    });
  }), () => {
    t.removeAllListeners(pi.REFRESH_PIECE), t.removeAllListeners(pi.FLOW_RUN_PROGRESS);
  }), [t.id, r == null ? void 0 : r.id]);
}, qQt = () => {
  const {
    embedState: { isEmbedded: e }
  } = bd(), t = tn((n) => n.saving);
  nt(() => {
    if (e)
      return;
    const n = Z(
      "Leaving this page while saving will discard your changes, are you sure you want to leave?"
    ), r = (i) => {
      if (t)
        return i.preventDefault(), i.returnValue = n, n;
    };
    return t && window.addEventListener("beforeunload", r), () => {
      window.removeEventListener("beforeunload", r);
    };
  }, [t, e]);
}, BQt = () => {
  const [e, t, n, r] = tn(
    (c) => [
      c.flowVersion,
      c.setVersion,
      c.clearRun,
      c.setFlow
    ]
  ), { checkAccess: i } = yc(), o = i(Es.WRITE_FLOW), { mutate: s, isPending: l } = dr({
    mutationFn: async () => await yi.get(e.flowId),
    onSuccess: (c) => {
      r(c), t(c.version), n(o);
    }
  });
  return {
    switchToDraft: s,
    isSwitchingToDraftPending: l
  };
}, XQt = ({
  containerRef: e,
  setIsFocusInsideListMapperModeInput: t,
  isFocusInsideListMapperModeInput: n
}) => {
  nt(() => {
    const r = () => {
      var l;
      const i = document.activeElement, o = !!((l = e.current) != null && l.contains(i)), s = !De(document.activeElement) && document.activeElement instanceof HTMLElement && Zp.isDataSelectorOrChildOfDataSelector(
        document.activeElement
      );
      t(
        o || s && n
      );
    };
    return document.addEventListener("focusin", r), () => {
      document.removeEventListener("focusin", r);
    };
  }, [t, n]);
}, WQt = () => {
  const [e, t] = tn((s) => [
    s.run,
    s.selectStepByName
  ]), n = Vse(e == null ? void 0 : e.status), r = Ks.findLastStepWithStatus(
    n ?? cr.RUNNING,
    (e == null ? void 0 : e.steps) ?? {}
  ), i = Vse(r), { fitView: o } = yd();
  nt(() => {
    !De(i) && i !== r && !De(r) && setTimeout(() => {
      console.log("focusing on step", r), o(Na.createFocusStepInGraphParams(r)), t(r);
    });
  }, [i, r, t, o]);
}, ZQt = (e, t) => {
  const n = Xe({
    width: 0,
    height: 0
  }), { getViewport: r, setViewport: i } = yd();
  nt(() => {
    if (!e.current) return;
    const o = new ResizeObserver((s) => {
      const { width: l, height: c } = s[0].contentRect;
      t(!0);
      const { x: a, y: u, zoom: f } = r();
      if (e.current && l !== n.current.width) {
        const d = a + (l - n.current.width) / 2;
        i({ x: d, y: u, zoom: f });
      }
      n.current = {
        width: l,
        height: c
      };
    });
    return o.observe(e.current), () => {
      o.disconnect();
    };
  }, [i, r]);
}, vv = {
  useAnimateSidebar: UQt,
  useSetSocketListener: VQt,
  useShowBuilderIsSavingWarningBeforeLeaving: qQt,
  useIsFocusInsideListMapperModeInput: XQt,
  useFocusOnStep: WQt,
  useResizeCanvas: ZQt,
  useSwitchToDraft: BQt
}, I5e = ({
  flowVersion: e,
  selectStepByName: t
}) => {
  const n = Kt(
    () => At.getAllSteps(e.trigger).filter(Qfe).length,
    [e]
  ), { fitView: r } = yd();
  function i() {
    const o = At.getAllSteps(e.trigger).filter(Qfe);
    o.length > 0 && (t(o[0].name), r(
      Na.createFocusStepInGraphParams(o[0].name)
    ));
  }
  return !e.valid && /* @__PURE__ */ y(
    Qe,
    {
      variant: "ghost",
      className: "h-[28px] hover:bg-amber-50 p-2 dark:hover:bg-amber-950 dark:bg-amber-950 bg-amber-50 border border-solid border-amber-500 hover:border-amber-700 dark:hover:border-amber-600  dark:border-amber-900 dark:text-amber-600 text-amber-700 hover:text-amber-700 dark:hover:text-amber-600   animate-fade",
      onClick: (o) => {
        i(), o.stopPropagation(), o.preventDefault();
      },
      children: Z("incompleteSteps", { invalidSteps: n })
    },
    "complete-flow-button"
  );
};
I5e.displayName = "IncompleteSettingsButton";
function Qfe(e) {
  return e.skip ? !1 : !e.valid;
}
const sL = ({
  onClick: e,
  text: t,
  triggerHasNoSampleData: n = !1,
  loading: r = !1,
  showKeyboardShortcut: i = !0,
  shortCutIsEscape: o = !1,
  showPrimaryBg: s = !0
}) => {
  const l = vB();
  return nt(() => {
    const c = (a) => {
      const u = a.key === "Escape" && o, f = l && a.metaKey && a.key.toLocaleLowerCase() === "d" || !l && a.ctrlKey && a.key.toLocaleLowerCase() === "d";
      (u || f) && (a.preventDefault(), a.stopPropagation(), !r && !n && e());
    };
    return window.addEventListener("keydown", c, { capture: !0 }), () => {
      window.removeEventListener("keydown", c, { capture: !0 });
    };
  }, [vB, r, e]), /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y("div", { className: "bg-builder-background", children: /* @__PURE__ */ y(
      Qe,
      {
        variant: "ghost",
        className: Se(
          "h-8 bg-background border-input hover:border-border  border p-2.5 border-solid rounded-lg animate-fade",
          {
            "bg-primary-100/50! dark:text-primary-foreground  text-primary hover:text-primary disabled:pointer-events-auto hover:border-primary!  border-primary/50": s
          }
        ),
        loading: r,
        disabled: n,
        onClick: e,
        children: /* @__PURE__ */ V("div", { className: "flex justify-center items-center gap-2", children: [
          t,
          i && /* @__PURE__ */ y(
            "span",
            {
              className: Se(
                "text-[10px] bg-muted h-[20px] flex items-center justify-center px-1 rounded-sm tracking-widest whitespace-nowrap text-muted-foreground",
                {
                  "bg-primary/13 text-primary": s
                }
              ),
              children: o ? "Esc" : l ? "⌘ + D" : "Ctrl + D"
            }
          )
        ] })
      }
    ) }) }),
    n && /* @__PURE__ */ y(An, { side: "bottom", children: Z("Please test the trigger first") })
  ] });
};
sL.displayName = "AboveTriggerButton";
const $Y = ({ onCanvas: e }) => {
  const t = JAt(), { checkAccess: n } = yc(), { switchToDraft: r, isSwitchingToDraftPending: i } = vv.useSwitchToDraft(), [o, s, l, c] = tn(
    (h) => [h.flowVersion, h.flow.id, h.readonly, h.run]
  ), a = o.state === Lo.DRAFT, u = n(Es.WRITE_FLOW);
  if (!l || a && !c)
    return null;
  const f = () => {
    var h;
    (h = t.pathname) != null && h.includes("/runs") || r();
  }, { text: d, icon: p } = HQt({
    hasPermissionToEditFlow: u
  });
  return /* @__PURE__ */ V(pt, { children: [
    e && /* @__PURE__ */ y(
      sL,
      {
        shortCutIsEscape: !0,
        showPrimaryBg: !1,
        onClick: f,
        text: d
      }
    ),
    !e && /* @__PURE__ */ V(
      Qe,
      {
        size: "sm",
        variant: "basic",
        loading: i,
        className: "gap-2",
        onClick: () => {
          var h;
          (h = t.pathname) != null && h.includes("/runs") ? navigate(`/flows/${s}`) : r();
        },
        children: [
          p,
          d
        ]
      }
    )
  ] });
};
$Y.displayName = "EditFlowOrViewDraftButton";
function HQt({
  hasPermissionToEditFlow: e
}) {
  const t = Z(e ? "Edit flow" : "View draft");
  return e ? {
    icon: /* @__PURE__ */ y($A, { className: "size-4" }),
    text: t
  } : {
    icon: /* @__PURE__ */ y(NT, { className: "size-4" }),
    text: t
  };
}
const R5e = () => {
  var a;
  const [
    e,
    t,
    n,
    r,
    i
  ] = tn((u) => [
    u.setChatDrawerOpenSource,
    u.flowVersion,
    u.readonly,
    u.hideTestWidget,
    u.setRun
  ]), o = t.trigger.type === Bt.PIECE && !De((a = t.trigger.settings.sampleData) == null ? void 0 : a.lastTestDate), s = xf.isChatTrigger(
    t.trigger.settings.pieceName,
    t.trigger.settings.triggerName
  ), { mutate: l, isPending: c } = xl.useTestFlow({
    flowVersionId: t.id,
    onUpdateRun: (u) => {
      i(u, t);
    }
  });
  return !t.valid || r ? null : s ? /* @__PURE__ */ y(
    sL,
    {
      onClick: () => {
        e(Jd.TEST_FLOW);
      },
      text: Z("Open Chat"),
      loading: c
    }
  ) : n ? /* @__PURE__ */ y($Y, { onCanvas: !0 }) : /* @__PURE__ */ y(
    sL,
    {
      onClick: () => {
        l();
      },
      text: Z("Test Flow"),
      triggerHasNoSampleData: !o,
      loading: c
    }
  );
};
R5e.displayName = "TestFlowWidget";
const M5e = ie.memo(() => {
  const [e, t, n] = tn(
    (r) => [r.flowVersion, r.selectStepByName, r.readonly]
  );
  return /* @__PURE__ */ y(DEe, { children: /* @__PURE__ */ y(D5e, { children: /* @__PURE__ */ y(
    "div",
    {
      style: {
        transform: `translate(0px,-${Ie.AP_NODE_SIZE.STEP.height}px )`,
        position: "absolute",
        pointerEvents: "auto"
      },
      children: /* @__PURE__ */ V("div", { className: "justify-center items-center flex w-[260px]", children: [
        /* @__PURE__ */ y(R5e, {}),
        !n && /* @__PURE__ */ y(
          I5e,
          {
            flowVersion: e,
            selectStepByName: t
          }
        )
      ] })
    }
  ) }) });
});
M5e.displayName = "AboveFlowWidgets";
const QQt = ie.memo(() => /* @__PURE__ */ y(DEe, { children: /* @__PURE__ */ y(D5e, { children: /* @__PURE__ */ y(
  "div",
  {
    style: {
      pointerEvents: "auto"
    },
    children: /* @__PURE__ */ y(
      "div",
      {
        className: "flex items-center justify-center gap-2",
        style: { width: Ie.AP_NODE_SIZE.STEP.width + "px" },
        children: /* @__PURE__ */ y(Y$, {})
      }
    )
  }
) }) })), D5e = ({ children: e }) => /* @__PURE__ */ y(
  "div",
  {
    style: { width: Ie.AP_NODE_SIZE.STEP.width + "px" },
    className: "flex items-center justify-center",
    children: e
  }
);
QQt.displayName = "BelowFlowWidget";
const $Qt = () => {
  const [e] = tn((r) => [r.showMinimap]), { theme: t } = Jw();
  return /* @__PURE__ */ y(pt, { children: e && /* @__PURE__ */ y(
    Syt,
    {
      position: "bottom-left",
      className: "!rounded-md border border-border !left-0 !ml-2 overflow-hidden !bottom-[45px] animate-in fade-in duration-300",
      zoomable: !0,
      pannable: !0,
      zoomStep: 0.3,
      bgColor: "var(--background)",
      maskColor: `rgba(0, 0, 0, ${t === "dark" ? 0.8 : 0.055})`,
      nodeComponent: (r) => /* @__PURE__ */ y(YQt, { node: r })
    }
  ) });
}, KQt = ({
  stepMetadata: e,
  node: t
}) => {
  const n = ZD.useAverageColorInImage({
    imgUrl: e.logoUrl ?? "",
    transparency: 50
  });
  return /* @__PURE__ */ y(
    "rect",
    {
      width: t.width,
      height: t.height,
      x: t.x,
      y: t.y,
      fill: n ?? "oklch(92.8% 0.006 264.531)"
    },
    t.id
  );
}, GQt = ({
  step: e,
  node: t
}) => {
  const { stepMetadata: n } = vd.useStepMetadata({
    step: e
  });
  return De(n) ? null : /* @__PURE__ */ y(KQt, { stepMetadata: n, node: t });
}, YQt = ({ node: e }) => {
  const [t] = tn((r) => [
    r.flowVersion.trigger
  ]), n = At.getStep(e.id, t);
  return De(n) ? null : /* @__PURE__ */ y(GQt, { step: n, node: e });
};
var p0 = {}, $fe;
function JQt() {
  if ($fe) return p0;
  $fe = 1;
  var e = _w;
  if (process.env.NODE_ENV === "production")
    p0.createRoot = e.createRoot, p0.hydrateRoot = e.hydrateRoot;
  else {
    var t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    p0.createRoot = function(n, r) {
      t.usingClientEntryPoint = !0;
      try {
        return e.createRoot(n, r);
      } finally {
        t.usingClientEntryPoint = !1;
      }
    }, p0.hydrateRoot = function(n, r, i) {
      t.usingClientEntryPoint = !0;
      try {
        return e.hydrateRoot(n, r, i);
      } finally {
        t.usingClientEntryPoint = !1;
      }
    };
  }
  return p0;
}
var _5e = JQt();
const e$t = (e) => {
  const t = document.createElement("div");
  e.appendChild(t);
  const n = _5e.createRoot(t);
  return n.render(
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "outline",
        size: "icon",
        className: "absolute top-[10px] -left-10 z-50",
        [`data-${Ie.SELECTION_RECT_CHEVRON_ATTRIBUTE}`]: !0,
        onClick: (r) => {
          const i = new MouseEvent("contextmenu", {
            bubbles: !0,
            cancelable: !0,
            view: window,
            button: 2,
            clientX: r.clientX,
            clientY: r.clientY
          });
          r.target.dispatchEvent(i);
        },
        children: /* @__PURE__ */ y(ex, { className: "w-4 h-4" })
      }
    )
  ), n;
}, t$t = () => {
  nt(() => {
    let e = null;
    const t = new MutationObserver((n) => {
      n.forEach((r) => {
        r.addedNodes.forEach((i) => {
          i instanceof HTMLElement && i.children.length > 0 && i.children[0].classList.contains(
            Ie.NODE_SELECTION_RECT_CLASS_NAME
          ) && (e = e$t(i.children[0]));
        }), r.removedNodes.forEach((i) => {
          i instanceof HTMLElement && i.children.length > 0 && i.children[0].classList.contains(
            Ie.NODE_SELECTION_RECT_CLASS_NAME
          ) && e && (e.unmount(), e = null);
        });
      });
    });
    return t.observe(document.body, {
      childList: !0,
      subtree: !0
    }), () => {
      t.disconnect(), e && e.unmount();
    };
  }, []);
}, L5e = ie.memo(
  ({
    setHasCanvasBeenInitialised: e
  }) => {
    const [
      t,
      n,
      r,
      i,
      o,
      s,
      l,
      c
    ] = tn((k) => [
      k.flowVersion,
      k.setSelectedNodes,
      k.selectedNodes,
      k.selectedStep,
      k.panningMode,
      k.selectStepByName,
      k.rightSidebar,
      k.flowVersion.notes || []
    ]), a = Xe(null);
    t$t(), vv.useFocusOnStep(), jZt(), vv.useResizeCanvas(a, e);
    const u = mi(), d = !rg("Shift") && o === "grab", p = qn(
      (k) => {
        const T = k.nodes.map((R) => R.id);
        T.length === 0 && i && T.push(i), n(T);
      },
      [n, i]
    ), h = r$t(t, c), m = Kt(() => Na.createFlowGraph(t, c), [h]), [v, b] = He(
      ql.CANVAS
    ), [A, w] = He(null), O = qn(
      (k) => {
        var T;
        if (k.target instanceof HTMLElement || k.target instanceof SVGElement) {
          const R = k.target.closest(
            `[data-${Ie.STEP_CONTEXT_MENU_ATTRIBUTE}]`
          ), j = R == null ? void 0 : R.getAttribute(
            `data-${Ie.STEP_CONTEXT_MENU_ATTRIBUTE}`
          );
          R && j ? (s(j), u.getState().addSelectedNodes([j]), w(j)) : w(null);
          const F = k.target.closest(
            `[data-${Ie.SELECTION_RECT_CHEVRON_ATTRIBUTE}]`
          ), L = k.target.classList.contains(
            Ie.NODE_SELECTION_RECT_CLASS_NAME
          );
          b(R || L || F ? ql.STEP : ql.CANVAS), !L && !F && ((T = document.querySelector(
            `.${Ie.NODE_SELECTION_RECT_CLASS_NAME}`
          )) == null || T.remove());
        }
      },
      [n, r, l]
    ), x = qn(() => {
      const k = r.map((R) => At.getStep(R, t.trigger)).filter((R) => !De(R));
      k.forEach((R) => {
        if (R.type === qe.LOOP_ON_ITEMS || R.type === qe.ROUTER) {
          const j = At.getAllChildSteps(R).filter((F) => De(r.find((L) => L === F.name)));
          k.push(...j);
        }
      });
      const T = i ? At.getStep(i, t.trigger) : null;
      r.length === 0 && T && k.push(T), u.getState().addSelectedNodes(k.map((R) => R.name));
    }, [r, u, i]), { setCursorPosition: S } = AFe(), E = Kt(() => {
      const k = m.nodes, T = I1e(k), R = Ie.AP_NODE_SIZE.STEP.width, j = {
        x: -T.width - 5 * R,
        y: -T.height
      }, F = {
        x: 2.5 * T.width + 5 * R,
        y: 2 * T.height
      };
      return [
        [j.x, j.y],
        [F.x, F.y]
      ];
    }, [h]);
    return /* @__PURE__ */ y(
      "div",
      {
        ref: a,
        className: "size-full relative overflow-hidden z-30 bg-background",
        onMouseMove: (k) => {
          const T = { x: k.clientX, y: k.clientY };
          S(T);
        },
        children: /* @__PURE__ */ y(zQt, { children: /* @__PURE__ */ y(
          IQt,
          {
            contextMenuType: v,
            contextMenuStepName: A,
            children: /* @__PURE__ */ V(
              Ygt,
              {
                className: "bg-builder-background",
                onContextMenu: O,
                onPaneClick: () => {
                  u.getState().unselectNodesAndEdges();
                },
                translateExtent: E,
                nodeTypes: Ie.nodeTypes,
                nodes: m.nodes,
                edgeTypes: Ie.edgeTypes,
                edges: m.edges,
                draggable: !1,
                edgesFocusable: !1,
                elevateEdgesOnSelect: !1,
                maxZoom: 1.5,
                minZoom: 0.5,
                panOnDrag: d ? [0, 1] : [1],
                zoomOnDoubleClick: !1,
                panOnScroll: !0,
                panOnScrollMode: Bm.Free,
                fitView: !1,
                nodesConnectable: !1,
                elementsSelectable: !0,
                nodesDraggable: !1,
                nodesFocusable: !1,
                selectionKeyCode: d ? "Shift" : null,
                multiSelectionKeyCode: d ? "Shift" : null,
                selectionOnDrag: !d,
                selectNodesOnDrag: !0,
                selectionMode: nw.Partial,
                onSelectionChange: p,
                onSelectionEnd: x,
                children: [
                  /* @__PURE__ */ y(M5e, {}),
                  /* @__PURE__ */ y(
                    syt,
                    {
                      gap: 10,
                      size: 1,
                      variant: Yp.Dots,
                      bgColor: "var(--builder-background)",
                      color: "var(--builder-background-pattern)"
                    }
                  ),
                  /* @__PURE__ */ y($Qt, {}, h)
                ]
              }
            )
          }
        ) })
      }
    );
  }
);
L5e.displayName = "FlowCanvas";
const n$t = (e) => {
  switch (e.type) {
    case qe.LOOP_ON_ITEMS:
      return e.firstLoopAction ? e.firstLoopAction.name : "";
    case qe.ROUTER:
      return e.children.reduce((t, n) => {
        const r = n ? At.getAllSteps(n).reduce(
          (i, o) => `${i}-${o.name}`,
          ""
        ) : "null";
        return `${t}-${r}`;
      }, "");
    case qe.CODE:
    case qe.PIECE:
      return "";
  }
}, r$t = (e, t) => {
  console.log(
    "createGraphKey called FlowVersion:",
    e,
    "Notes:",
    t
  );
  const n = At.getAllSteps(e.trigger).reduce((i, o) => {
    const s = o.type === qe.ROUTER ? (o.settings.branches ?? []).map((c) => c.branchName).join("-") : "0", l = n$t(o);
    return `${i}-${o.displayName}-${o.type}-${o.nextAction ? o.nextAction.name : ""}-${o.type === qe.PIECE ? o.settings.pieceName : ""}-${s}-${l}}`;
  }, ""), r = t.map((i) => `${i.id}-${i.position.x}-${i.position.y}`).join("-");
  return `${e.id}-${n}-${r}`;
}, S3 = ({
  children: e,
  containerClassName: t
}) => /* @__PURE__ */ y("div", { className: "absolute top-[12px] z-40 w-full px-2 flex justify-center", children: /* @__PURE__ */ y(
  "div",
  {
    className: Se(
      "py-1.5 px-3.5 border min-h-11.5  border border-border  bg-background z-40  w-full animate animate-fade duration-300 rounded-md  flex items-center justify-between",
      t
    ),
    children: e
  }
) });
S3.displayName = "LargeWidgetWrapper";
const z5e = () => {
  const [
    e,
    t,
    n,
    r,
    i,
    o,
    s,
    l,
    c,
    a
  ] = tn((b) => [
    b.saving,
    b.isPublishing,
    b.setIsPublishing,
    b.flowVersion.valid,
    b.flow,
    b.setFlow,
    b.setVersion,
    b.setRightSidebar,
    b.flowVersion,
    b.run
  ]), u = i$t({
    flowVersion: c,
    isPublishing: t,
    run: a,
    isValid: r,
    isSaving: e
  }), { mutate: f, isPending: d } = dr(
    {
      mutationFn: async () => {
        i.publishedVersionId && (await h({
          flowId: i.id,
          versionId: i.publishedVersionId
        }), await p().catch(() => {
        }));
      }
    }
  ), { mutateAsync: p } = xl.useChangeFlowStatus({
    flowId: i.id,
    change: "publish",
    onSuccess: (b) => {
      o(b.flow), s(b.flow.version), console.log("Publish successful, updated flow:", b.flow);
    },
    setIsPublishing: n
  }), { mutateAsync: h } = xl.useOverWriteDraftWithVersion({
    onSuccess: (b) => {
      s(b.version), l(zr.NONE);
    }
  });
  if (!u)
    return null;
  console.log("Current states, isSaving:", e, "isPublishing:", t, "isDiscardingChanges:", d);
  const m = t || d || e, v = o$t({
    isDiscardingChanges: d,
    isPublishing: t,
    isSaving: e
  });
  return /* @__PURE__ */ V(S3, { children: [
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ y(pMe, { className: "size-5" }),
      m ? v : Z("You have unpublished changes")
    ] }),
    m ? /* @__PURE__ */ y(mu, { className: "size-5 stroke-foreground" }) : /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      !De(i.publishedVersionId) && !e && /* @__PURE__ */ y(
        Qe,
        {
          size: "sm",
          variant: "ghost",
          className: "hover:bg-gray-300/10 text-foreground",
          onClick: () => f(),
          children: Z("Discard changes")
        }
      ),
      /* @__PURE__ */ V(wn, { children: [
        /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
          Qe,
          {
            size: "sm",
            variant: "default",
            loading: e,
            name: "Publish",
            onClick: () => p().catch(() => {
            }),
            children: Z("Publish")
          }
        ) }),
        e && /* @__PURE__ */ y(An, { children: Z("Saving...") })
      ] })
    ] })
  ] });
};
z5e.displayName = "PublishFlowReminderWidget";
const i$t = ({
  flowVersion: e,
  isPublishing: t,
  run: n,
  isValid: r,
  isSaving: i
}) => {
  const { checkAccess: o } = yc(), s = o(Es.WRITE_FLOW), l = e.state === Lo.DRAFT;
  return (s && l || t || i) && De(n) && r;
};
function o$t({
  isDiscardingChanges: e,
  isPublishing: t,
  isSaving: n
}) {
  return n ? Z("Saving...") : e ? Z("Discarding changes...") : t ? Z("Publishing...") : "";
}
function s$t({
  status: e,
  timeout: t,
  memoryLimit: n
}) {
  switch (e) {
    case cr.SUCCEEDED:
      return Z("Run Succeeded");
    case cr.FAILED:
      return Z("Run Failed");
    case cr.PAUSED:
      return Z("Run Paused");
    case cr.QUOTA_EXCEEDED:
      return Z("Quota Exceeded");
    case cr.MEMORY_LIMIT_EXCEEDED:
      return Z(
        "Run failed due to exceeding the memory limit of {memoryLimit} MB",
        {
          memoryLimit: Math.floor(n / 1024)
        }
      );
    case cr.QUEUED:
      return Z("Queued");
    case cr.RUNNING:
      return Z("Running");
    case cr.TIMEOUT:
      return Z("Run exceeded {timeout} seconds, try to optimize your steps.", {
        timeout: t
      });
    case cr.INTERNAL_ERROR:
      return Z("Run failed for an unknown reason, contact support.");
    case cr.CANCELED:
      return Z("Run Cancelled");
  }
}
const j5e = () => {
  const [e] = tn((l) => [l.run]), { variant: t, Icon: n } = e ? Ks.getStatusIcon(e.status) : { variant: "default", Icon: qRt }, { data: r } = Go.useFlag(
    As.FLOW_RUN_TIME_SECONDS
  ), { data: i } = Go.useFlag(
    As.FLOW_RUN_MEMORY_LIMIT_KB
  ), { setRunId: o } = ol();
  if (!e)
    return null;
  const s = DC({
    status: e.status,
    ignoreInternalError: !1
  });
  return /* @__PURE__ */ y(
    S3,
    {
      containerClassName: Se(
        Ks.getStatusContainerClassName(t),
        "bg-background border border-border dark:bg-background dark:border-border"
      ),
      children: /* @__PURE__ */ V("div", { className: "flex items-center justify-between w-full flex-wrap", children: [
        /* @__PURE__ */ V("div", { className: "flex items-center text-sm shrink-0", children: [
          /* @__PURE__ */ y(n, { className: "size-5 mr-2" }),
          /* @__PURE__ */ y("span", { className: "text-foreground dark:text-foreground font-medium", children: s$t({
            status: e.status,
            timeout: r ?? -1,
            memoryLimit: i ?? -1
          }) }),
          /* @__PURE__ */ y("div", { className: "shrink-0 text-foreground dark:text-foreground", children: s && /* @__PURE__ */ V(pt, { children: [
            " - ",
            e.startTime && /* @__PURE__ */ y(
              Kfe,
              {
                text: Z("Started"),
                dateOrDuration: rc.formatDateWithTime(
                  new Date(e.startTime),
                  !0
                )
              }
            ),
            ", ",
            e.finishTime && e.startTime && /* @__PURE__ */ y(
              Kfe,
              {
                text: Z("Took"),
                dateOrDuration: rc.formatDuration(
                  new Date(e.finishTime).getTime() - new Date(e.startTime).getTime()
                )
              }
            )
          ] }) })
        ] }),
        /* @__PURE__ */ y(Qe, { size: "sm", variant: "basic", className: "gap-2", onClick: () => {
          o(null), window.location.reload();
        }, children: "Edit Flow" })
      ] })
    },
    e.id + e.status
  );
};
j5e.displayName = "RunInfoWidget";
const Kfe = ({
  text: e,
  dateOrDuration: t
}) => /* @__PURE__ */ V(pt, { children: [
  /* @__PURE__ */ y("span", { children: `${e}: ` }),
  /* @__PURE__ */ y("span", { children: `${t}` })
] }), F5e = ({
  onConfirm: e,
  children: t,
  versionId: n,
  versionNumber: r
}) => {
  const { checkAccess: i } = yc(), [o, s, l] = tn(
    (p) => [p.setVersion, p.setRightSidebar, p.flow]
  ), { mutate: c, isPending: a } = xl.useOverWriteDraftWithVersion({
    onSuccess: (p) => {
      o(p.version), s(zr.NONE);
    }
  }), u = i(Es.WRITE_FLOW), [f, d] = He(!1);
  return /* @__PURE__ */ V(qa, { open: f, onOpenChange: d, children: [
    /* @__PURE__ */ y(
      z$,
      {
        disabled: !u,
        className: "w-full",
        children: /* @__PURE__ */ y(tb, { hasPermission: u, children: t })
      }
    ),
    /* @__PURE__ */ V(ia, { children: [
      /* @__PURE__ */ V(Ds, { children: [
        /* @__PURE__ */ y(_s, { children: Z("Are you sure?") }),
        /* @__PURE__ */ V(kb, { children: [
          Z("Your current draft version will be overwritten with"),
          " ",
          /* @__PURE__ */ V("span", { className: "font-semibold", children: [
            Z("version #"),
            r
          ] })
        ] })
      ] }),
      /* @__PURE__ */ V(kl, { className: "justify-end", children: [
        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "outline", children: Z("Cancel") }) }),
        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(
          Qe,
          {
            loading: a,
            onClick: () => {
              c({
                flowId: l.id,
                versionId: n
              }), e == null || e();
            },
            children: Z("Confirm")
          }
        ) })
      ] })
    ] })
  ] });
}, a$t = () => {
  const [e, t, n, r] = tn(
    (l) => [
      l.run,
      l.readonly,
      l.flowVersion,
      l.isPublishing
    ]
  ), i = xl.useGetFlowVersionNumber({ flowId: n.flowId, versionId: n.id }).toString(), { checkAccess: o } = yc(), s = o(Es.WRITE_FLOW);
  return !De(e) || !t || r ? null : /* @__PURE__ */ y(S3, { children: /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ y(pMe, { className: "size-5" }),
      /* @__PURE__ */ V("span", { children: [
        Z("Viewing version"),
        " #",
        i
      ] })
    ] }),
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      s && /* @__PURE__ */ y(
        F5e,
        {
          versionId: n.id,
          versionNumber: i,
          onConfirm: void 0,
          children: /* @__PURE__ */ y(Qe, { variant: "ghost", size: "sm", children: Z("Use as Draft") })
        }
      ),
      /* @__PURE__ */ y(
        $Y,
        {
          onCanvas: !1
        }
      )
    ] })
  ] }) });
}, KY = ({ children: e, onClose: t }) => /* @__PURE__ */ V("div", { className: "flex p-4 w-full gap-2 text-lg items-center", children: [
  e,
  /* @__PURE__ */ y("div", { className: "grow" }),
  /* @__PURE__ */ y(
    Qe,
    {
      variant: "ghost",
      size: "sm",
      onClick: (n) => {
        n.stopPropagation(), t();
      },
      "aria-label": Z("Close"),
      children: /* @__PURE__ */ y(ks, { size: 16 })
    }
  )
] }), U5e = ({
  date: e,
  includeTime: t,
  className: n
}) => {
  const r = rc.formatDate(e), i = rc.formatDateWithTime(e, !1), o = rc.formatDateWithTime(e, !0);
  return /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y("span", { className: n, children: t ? i : r }) }),
    /* @__PURE__ */ y(An, { children: /* @__PURE__ */ y("p", { children: o }) })
  ] });
};
var xM = { exports: {} }, l$t = xM.exports, Gfe;
function c$t() {
  return Gfe || (Gfe = 1, function(e, t) {
    (function(n, r) {
      e.exports = r(ie);
    })(l$t, function(n) {
      return function(r) {
        var i = {};
        function o(s) {
          if (i[s]) return i[s].exports;
          var l = i[s] = { i: s, l: !1, exports: {} };
          return r[s].call(l.exports, l, l.exports, o), l.l = !0, l.exports;
        }
        return o.m = r, o.c = i, o.d = function(s, l, c) {
          o.o(s, l) || Object.defineProperty(s, l, { enumerable: !0, get: c });
        }, o.r = function(s) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        }, o.t = function(s, l) {
          if (1 & l && (s = o(s)), 8 & l || 4 & l && typeof s == "object" && s && s.__esModule) return s;
          var c = /* @__PURE__ */ Object.create(null);
          if (o.r(c), Object.defineProperty(c, "default", { enumerable: !0, value: s }), 2 & l && typeof s != "string") for (var a in s) o.d(c, a, (function(u) {
            return s[u];
          }).bind(null, a));
          return c;
        }, o.n = function(s) {
          var l = s && s.__esModule ? function() {
            return s.default;
          } : function() {
            return s;
          };
          return o.d(l, "a", l), l;
        }, o.o = function(s, l) {
          return Object.prototype.hasOwnProperty.call(s, l);
        }, o.p = "/", o(o.s = 1);
      }([function(r, i) {
        r.exports = n;
      }, function(r, i, o) {
        r.exports = o(2);
      }, function(r, i, o) {
        function s(A, w) {
          if (A == null) return {};
          var O, x, S = function(k, T) {
            if (k == null) return {};
            var R, j, F = {}, L = Object.keys(k);
            for (j = 0; j < L.length; j++) R = L[j], T.indexOf(R) >= 0 || (F[R] = k[R]);
            return F;
          }(A, w);
          if (Object.getOwnPropertySymbols) {
            var E = Object.getOwnPropertySymbols(A);
            for (x = 0; x < E.length; x++) O = E[x], w.indexOf(O) >= 0 || Object.prototype.propertyIsEnumerable.call(A, O) && (S[O] = A[O]);
          }
          return S;
        }
        o.r(i);
        var l = o(0), c = o.n(l), a = function(A) {
          for (var w = 0, O = 0; O < A.length; O++)
            w = (w << 5) - w + A.charCodeAt(O), w &= w;
          return Math.abs(w);
        }, u = function(A, w) {
          return Math.floor(A / Math.pow(10, w) % 10);
        }, f = function(A, w) {
          return !(u(A, w) % 2);
        }, d = function(A, w, O) {
          var x = A % w;
          return O && u(A, O) % 2 === 0 ? -x : x;
        }, p = function(A, w, O) {
          return w[A % O];
        }, h = function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(j, F) {
            var L = a(j), _ = F && F.length;
            return Array.from({ length: 3 }, function(U, z) {
              return { color: p(L + z, F, _), translateX: d(L * (z + 1), 8, 1), translateY: d(L * (z + 1), 8, 2), scale: 1.2 + d(L * (z + 1), 4) / 10, rotate: d(L * (z + 1), 360, 1) };
            });
          }(w, O), R = l.useId();
          return l.createElement("svg", Object.assign({ viewBox: "0 0 80 80", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && l.createElement("title", null, w), l.createElement("mask", { id: R, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 80, height: 80 }, l.createElement("rect", { width: 80, height: 80, rx: S ? void 0 : 160, fill: "#FFFFFF" })), l.createElement("g", { mask: "url(#".concat(R, ")") }, l.createElement("rect", { width: 80, height: 80, fill: T[0].color }), l.createElement("path", { filter: "url(#filter_".concat(R, ")"), d: "M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z", fill: T[1].color, transform: "translate(" + T[1].translateX + " " + T[1].translateY + ") rotate(" + T[1].rotate + " 40 40) scale(" + T[2].scale + ")" }), l.createElement("path", { filter: "url(#filter_".concat(R, ")"), style: { mixBlendMode: "overlay" }, d: "M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z", fill: T[2].color, transform: "translate(" + T[2].translateX + " " + T[2].translateY + ") rotate(" + T[2].rotate + " 40 40) scale(" + T[2].scale + ")" })), l.createElement("defs", null, l.createElement("filter", { id: "filter_".concat(R), filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, l.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), l.createElement("feBlend", { in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), l.createElement("feGaussianBlur", { stdDeviation: 7, result: "effect1_foregroundBlur" }))));
        }, m = { pixel: function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(j, F) {
            var L = a(j), _ = F && F.length;
            return Array.from({ length: 64 }, function(U, z) {
              return p(L % (z + 1), F, _);
            });
          }(w, O), R = l.useId();
          return l.createElement("svg", Object.assign({ viewBox: "0 0 80 80", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && l.createElement("title", null, w), l.createElement("mask", { id: R, "mask-type": "alpha", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 80, height: 80 }, l.createElement("rect", { width: 80, height: 80, rx: S ? void 0 : 160, fill: "#FFFFFF" })), l.createElement("g", { mask: "url(#".concat(R, ")") }, l.createElement("rect", { width: 10, height: 10, fill: T[0] }), l.createElement("rect", { x: 20, width: 10, height: 10, fill: T[1] }), l.createElement("rect", { x: 40, width: 10, height: 10, fill: T[2] }), l.createElement("rect", { x: 60, width: 10, height: 10, fill: T[3] }), l.createElement("rect", { x: 10, width: 10, height: 10, fill: T[4] }), l.createElement("rect", { x: 30, width: 10, height: 10, fill: T[5] }), l.createElement("rect", { x: 50, width: 10, height: 10, fill: T[6] }), l.createElement("rect", { x: 70, width: 10, height: 10, fill: T[7] }), l.createElement("rect", { y: 10, width: 10, height: 10, fill: T[8] }), l.createElement("rect", { y: 20, width: 10, height: 10, fill: T[9] }), l.createElement("rect", { y: 30, width: 10, height: 10, fill: T[10] }), l.createElement("rect", { y: 40, width: 10, height: 10, fill: T[11] }), l.createElement("rect", { y: 50, width: 10, height: 10, fill: T[12] }), l.createElement("rect", { y: 60, width: 10, height: 10, fill: T[13] }), l.createElement("rect", { y: 70, width: 10, height: 10, fill: T[14] }), l.createElement("rect", { x: 20, y: 10, width: 10, height: 10, fill: T[15] }), l.createElement("rect", { x: 20, y: 20, width: 10, height: 10, fill: T[16] }), l.createElement("rect", { x: 20, y: 30, width: 10, height: 10, fill: T[17] }), l.createElement("rect", { x: 20, y: 40, width: 10, height: 10, fill: T[18] }), l.createElement("rect", { x: 20, y: 50, width: 10, height: 10, fill: T[19] }), l.createElement("rect", { x: 20, y: 60, width: 10, height: 10, fill: T[20] }), l.createElement("rect", { x: 20, y: 70, width: 10, height: 10, fill: T[21] }), l.createElement("rect", { x: 40, y: 10, width: 10, height: 10, fill: T[22] }), l.createElement("rect", { x: 40, y: 20, width: 10, height: 10, fill: T[23] }), l.createElement("rect", { x: 40, y: 30, width: 10, height: 10, fill: T[24] }), l.createElement("rect", { x: 40, y: 40, width: 10, height: 10, fill: T[25] }), l.createElement("rect", { x: 40, y: 50, width: 10, height: 10, fill: T[26] }), l.createElement("rect", { x: 40, y: 60, width: 10, height: 10, fill: T[27] }), l.createElement("rect", { x: 40, y: 70, width: 10, height: 10, fill: T[28] }), l.createElement("rect", { x: 60, y: 10, width: 10, height: 10, fill: T[29] }), l.createElement("rect", { x: 60, y: 20, width: 10, height: 10, fill: T[30] }), l.createElement("rect", { x: 60, y: 30, width: 10, height: 10, fill: T[31] }), l.createElement("rect", { x: 60, y: 40, width: 10, height: 10, fill: T[32] }), l.createElement("rect", { x: 60, y: 50, width: 10, height: 10, fill: T[33] }), l.createElement("rect", { x: 60, y: 60, width: 10, height: 10, fill: T[34] }), l.createElement("rect", { x: 60, y: 70, width: 10, height: 10, fill: T[35] }), l.createElement("rect", { x: 10, y: 10, width: 10, height: 10, fill: T[36] }), l.createElement("rect", { x: 10, y: 20, width: 10, height: 10, fill: T[37] }), l.createElement("rect", { x: 10, y: 30, width: 10, height: 10, fill: T[38] }), l.createElement("rect", { x: 10, y: 40, width: 10, height: 10, fill: T[39] }), l.createElement("rect", { x: 10, y: 50, width: 10, height: 10, fill: T[40] }), l.createElement("rect", { x: 10, y: 60, width: 10, height: 10, fill: T[41] }), l.createElement("rect", { x: 10, y: 70, width: 10, height: 10, fill: T[42] }), l.createElement("rect", { x: 30, y: 10, width: 10, height: 10, fill: T[43] }), l.createElement("rect", { x: 30, y: 20, width: 10, height: 10, fill: T[44] }), l.createElement("rect", { x: 30, y: 30, width: 10, height: 10, fill: T[45] }), l.createElement("rect", { x: 30, y: 40, width: 10, height: 10, fill: T[46] }), l.createElement("rect", { x: 30, y: 50, width: 10, height: 10, fill: T[47] }), l.createElement("rect", { x: 30, y: 60, width: 10, height: 10, fill: T[48] }), l.createElement("rect", { x: 30, y: 70, width: 10, height: 10, fill: T[49] }), l.createElement("rect", { x: 50, y: 10, width: 10, height: 10, fill: T[50] }), l.createElement("rect", { x: 50, y: 20, width: 10, height: 10, fill: T[51] }), l.createElement("rect", { x: 50, y: 30, width: 10, height: 10, fill: T[52] }), l.createElement("rect", { x: 50, y: 40, width: 10, height: 10, fill: T[53] }), l.createElement("rect", { x: 50, y: 50, width: 10, height: 10, fill: T[54] }), l.createElement("rect", { x: 50, y: 60, width: 10, height: 10, fill: T[55] }), l.createElement("rect", { x: 50, y: 70, width: 10, height: 10, fill: T[56] }), l.createElement("rect", { x: 70, y: 10, width: 10, height: 10, fill: T[57] }), l.createElement("rect", { x: 70, y: 20, width: 10, height: 10, fill: T[58] }), l.createElement("rect", { x: 70, y: 30, width: 10, height: 10, fill: T[59] }), l.createElement("rect", { x: 70, y: 40, width: 10, height: 10, fill: T[60] }), l.createElement("rect", { x: 70, y: 50, width: 10, height: 10, fill: T[61] }), l.createElement("rect", { x: 70, y: 60, width: 10, height: 10, fill: T[62] }), l.createElement("rect", { x: 70, y: 70, width: 10, height: 10, fill: T[63] })));
        }, bauhaus: function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(j, F) {
            var L = a(j), _ = F && F.length;
            return Array.from({ length: 4 }, function(U, z) {
              return { color: p(L + z, F, _), translateX: d(L * (z + 1), 40 - (z + 17), 1), translateY: d(L * (z + 1), 40 - (z + 17), 2), rotate: d(L * (z + 1), 360), isSquare: f(L, 2) };
            });
          }(w, O), R = l.useId();
          return l.createElement("svg", Object.assign({ viewBox: "0 0 80 80", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && l.createElement("title", null, w), l.createElement("mask", { id: R, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 80, height: 80 }, l.createElement("rect", { width: 80, height: 80, rx: S ? void 0 : 160, fill: "#FFFFFF" })), l.createElement("g", { mask: "url(#".concat(R, ")") }, l.createElement("rect", { width: 80, height: 80, fill: T[0].color }), l.createElement("rect", { x: 10, y: 30, width: 80, height: T[1].isSquare ? 80 : 10, fill: T[1].color, transform: "translate(" + T[1].translateX + " " + T[1].translateY + ") rotate(" + T[1].rotate + " 40 40)" }), l.createElement("circle", { cx: 40, cy: 40, fill: T[2].color, r: 16, transform: "translate(" + T[2].translateX + " " + T[2].translateY + ")" }), l.createElement("line", { x1: 0, y1: 40, x2: 80, y2: 40, strokeWidth: 2, stroke: T[3].color, transform: "translate(" + T[3].translateX + " " + T[3].translateY + ") rotate(" + T[3].rotate + " 40 40)" })));
        }, ring: function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(j, F) {
            var L = a(F), _ = j && j.length, U = Array.from({ length: 5 }, function(C, I) {
              return p(L + I, j, _);
            }), z = [];
            return z[0] = U[0], z[1] = U[1], z[2] = U[1], z[3] = U[2], z[4] = U[2], z[5] = U[3], z[6] = U[3], z[7] = U[0], z[8] = U[4], z;
          }(O, w), R = c.a.useId();
          return c.a.createElement("svg", Object.assign({ viewBox: "0 0 90 90", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && c.a.createElement("title", null, w), c.a.createElement("mask", { id: R, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 90, height: 90 }, c.a.createElement("rect", { width: 90, height: 90, rx: S ? void 0 : 180, fill: "#FFFFFF" })), c.a.createElement("g", { mask: "url(#".concat(R, ")") }, c.a.createElement("path", { d: "M0 0h90v45H0z", fill: T[0] }), c.a.createElement("path", { d: "M0 45h90v45H0z", fill: T[1] }), c.a.createElement("path", { d: "M83 45a38 38 0 00-76 0h76z", fill: T[2] }), c.a.createElement("path", { d: "M83 45a38 38 0 01-76 0h76z", fill: T[3] }), c.a.createElement("path", { d: "M77 45a32 32 0 10-64 0h64z", fill: T[4] }), c.a.createElement("path", { d: "M77 45a32 32 0 11-64 0h64z", fill: T[5] }), c.a.createElement("path", { d: "M71 45a26 26 0 00-52 0h52z", fill: T[6] }), c.a.createElement("path", { d: "M71 45a26 26 0 01-52 0h52z", fill: T[7] }), c.a.createElement("circle", { cx: 45, cy: 45, r: 23, fill: T[8] })));
        }, beam: function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(j, F) {
            var L, _ = a(j), U = F && F.length, z = p(_, F, U), C = d(_, 10, 1), I = C < 5 ? C + 4 : C, M = d(_, 10, 2), D = M < 5 ? M + 4 : M;
            return { wrapperColor: z, faceColor: (L = z, L.slice(0, 1) === "#" && (L = L.slice(1)), (299 * parseInt(L.substr(0, 2), 16) + 587 * parseInt(L.substr(2, 2), 16) + 114 * parseInt(L.substr(4, 2), 16)) / 1e3 >= 128 ? "#000000" : "#FFFFFF"), backgroundColor: p(_ + 13, F, U), wrapperTranslateX: I, wrapperTranslateY: D, wrapperRotate: d(_, 360), wrapperScale: 1 + d(_, 3) / 10, isMouthOpen: f(_, 2), isCircle: f(_, 1), eyeSpread: d(_, 5), mouthSpread: d(_, 3), faceRotate: d(_, 10, 3), faceTranslateX: I > 6 ? I / 2 : d(_, 8, 1), faceTranslateY: D > 6 ? D / 2 : d(_, 7, 2) };
          }(w, O), R = l.useId();
          return l.createElement("svg", Object.assign({ viewBox: "0 0 36 36", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && l.createElement("title", null, w), l.createElement("mask", { id: R, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 36, height: 36 }, l.createElement("rect", { width: 36, height: 36, rx: S ? void 0 : 72, fill: "#FFFFFF" })), l.createElement("g", { mask: "url(#".concat(R, ")") }, l.createElement("rect", { width: 36, height: 36, fill: T.backgroundColor }), l.createElement("rect", { x: "0", y: "0", width: 36, height: 36, transform: "translate(" + T.wrapperTranslateX + " " + T.wrapperTranslateY + ") rotate(" + T.wrapperRotate + " 18 18) scale(" + T.wrapperScale + ")", fill: T.wrapperColor, rx: T.isCircle ? 36 : 6 }), l.createElement("g", { transform: "translate(" + T.faceTranslateX + " " + T.faceTranslateY + ") rotate(" + T.faceRotate + " 18 18)" }, T.isMouthOpen ? l.createElement("path", { d: "M15 " + (19 + T.mouthSpread) + "c2 1 4 1 6 0", stroke: T.faceColor, fill: "none", strokeLinecap: "round" }) : l.createElement("path", { d: "M13," + (19 + T.mouthSpread) + " a1,0.75 0 0,0 10,0", fill: T.faceColor }), l.createElement("rect", { x: 14 - T.eyeSpread, y: 14, width: 1.5, height: 2, rx: 1, stroke: "none", fill: T.faceColor }), l.createElement("rect", { x: 20 + T.eyeSpread, y: 14, width: 1.5, height: 2, rx: 1, stroke: "none", fill: T.faceColor }))));
        }, sunset: function(A) {
          var w = A.name, O = A.colors, x = A.title, S = A.square, E = A.size, k = s(A, ["name", "colors", "title", "square", "size"]), T = function(F, L) {
            var _ = a(F), U = L && L.length;
            return Array.from({ length: 4 }, function(z, C) {
              return p(_ + C, L, U);
            });
          }(w, O), R = w.replace(/\s/g, ""), j = l.useId();
          return l.createElement("svg", Object.assign({ viewBox: "0 0 80 80", fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: E, height: E }, k), x && l.createElement("title", null, w), l.createElement("mask", { id: j, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 80, height: 80 }, l.createElement("rect", { width: 80, height: 80, rx: S ? void 0 : 160, fill: "#FFFFFF" })), l.createElement("g", { mask: "url(#".concat(j, ")") }, l.createElement("path", { fill: "url(#gradient_paint0_linear_" + R + ")", d: "M0 0h80v40H0z" }), l.createElement("path", { fill: "url(#gradient_paint1_linear_" + R + ")", d: "M0 40h80v40H0z" })), l.createElement("defs", null, l.createElement("linearGradient", { id: "gradient_paint0_linear_" + R, x1: 40, y1: 0, x2: 40, y2: 40, gradientUnits: "userSpaceOnUse" }, l.createElement("stop", { stopColor: T[0] }), l.createElement("stop", { offset: 1, stopColor: T[1] })), l.createElement("linearGradient", { id: "gradient_paint1_linear_" + R, x1: 40, y1: 40, x2: 40, y2: 80, gradientUnits: "userSpaceOnUse" }, l.createElement("stop", { stopColor: T[2] }), l.createElement("stop", { offset: 1, stopColor: T[3] }))));
        }, marble: h }, v = { geometric: "beam", abstract: "bauhaus" }, b = function(A) {
          var w = A.variant, O = w === void 0 ? "marble" : w, x = A.colors, S = x === void 0 ? ["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"] : x, E = A.name, k = E === void 0 ? "Clara Barton" : E, T = A.title, R = T !== void 0 && T, j = A.size, F = A.square, L = F !== void 0 && F, _ = s(A, ["variant", "colors", "name", "title", "size", "square"]), U = m[v[O] || O] || h;
          return c.a.createElement(U, Object.assign({ colors: S, name: k, title: R, size: j, square: L }, _));
        };
        i.default = b;
      }]);
    });
  }(xM)), xM.exports;
}
var u$t = c$t();
const d$t = /* @__PURE__ */ Sl(u$t);
function aL({
  name: e,
  email: t,
  size: n,
  disableTooltip: r = !1
}) {
  const i = `${e} (${t})`, o = /* @__PURE__ */ y(
    d$t,
    {
      name: t,
      size: n,
      colors: ["#0a0310", "#49007e", "#ff005b", "#ff7d10", "#ffb238"],
      variant: "bauhaus",
      square: !0,
      className: "rounded-full"
    }
  );
  return r ? o : /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V("div", { children: [
      o,
      " ",
      r
    ] }) }),
    /* @__PURE__ */ y(An, { side: "bottom", children: i })
  ] });
}
const V5e = ie.memo(
  ({
    flowVersion: e,
    selected: t,
    publishedVersionId: n,
    flowVersionNumber: r
  }) => {
    const { checkAccess: i } = yc(), o = i(Es.WRITE_FLOW), [s, l] = tn((p) => [
      p.setVersion,
      p.setReadOnly
    ]), [c, a] = He(!1), { mutate: u, isPending: f } = xl.useFetchFlowVersion({
      onSuccess: (p) => {
        s(p), l(
          p.state === Lo.LOCKED || !o
        );
      }
    }), d = !bd().embedState.isEmbedded;
    return /* @__PURE__ */ V(Ng, { interactive: !1, className: "px-4", children: [
      d && e.updatedByUser && /* @__PURE__ */ y(
        aL,
        {
          size: 28,
          name: e.updatedByUser.firstName + " " + e.updatedByUser.lastName,
          email: e.updatedByUser.email
        }
      ),
      /* @__PURE__ */ V("div", { className: "grid gap-2", children: [
        /* @__PURE__ */ y(
          U5e,
          {
            date: new Date(e.created),
            includeTime: !0,
            className: "text-sm font-medium leading-none select-none cursor-default"
          }
        ),
        /* @__PURE__ */ V("p", { className: "flex gap-1 text-xs text-muted-foreground", children: [
          Z("Version"),
          " #",
          r
        ] })
      ] }),
      /* @__PURE__ */ y("div", { className: "grow" }),
      /* @__PURE__ */ V("div", { className: "flex font-medium gap-2 justify-center items-center", children: [
        t && /* @__PURE__ */ V(wn, { children: [
          /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y("div", { className: "size-10 flex justify-center items-center", children: /* @__PURE__ */ y(NT, { className: "w-5 h-5 " }) }) }),
          /* @__PURE__ */ y(An, { children: Z("Viewing") })
        ] }),
        /* @__PURE__ */ y(
          FY,
          {
            state: e.state,
            versionId: e.id,
            publishedVersionId: n
          }
        ),
        /* @__PURE__ */ V(
          mN,
          {
            onOpenChange: (p) => a(p),
            open: c,
            children: [
              /* @__PURE__ */ y(Aj, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "ghost", disabled: f, size: "icon", children: /* @__PURE__ */ y(jRt, {}) }) }),
              /* @__PURE__ */ V(xx, { className: "w-40", children: [
                /* @__PURE__ */ V(
                  wa,
                  {
                    onClick: () => u(e),
                    className: "w-full",
                    children: [
                      /* @__PURE__ */ y(NT, { className: "mr-2 h-4 w-4" }),
                      /* @__PURE__ */ y("span", { children: Z("View") })
                    ]
                  }
                ),
                e.state !== Lo.DRAFT && /* @__PURE__ */ y(
                  F5e,
                  {
                    versionNumber: r.toString(),
                    versionId: e.id,
                    onConfirm: () => {
                      a(!1);
                    },
                    children: /* @__PURE__ */ V(
                      wa,
                      {
                        className: "w-full",
                        onSelect: (p) => {
                          p.preventDefault();
                        },
                        disabled: !o,
                        children: [
                          /* @__PURE__ */ y($A, { className: "mr-2 h-4 w-4" }),
                          /* @__PURE__ */ y("span", { children: Z("Use as Draft") })
                        ]
                      }
                    )
                  }
                )
              ] })
            ]
          }
        )
      ] })
    ] });
  }
);
V5e.displayName = "FlowVersionDetailsCard";
const q5e = () => {
  const [e, t, n] = tn(
    (s) => [s.flow, s.setRightSidebar, s.flowVersion]
  ), {
    data: r,
    isLoading: i,
    isError: o
  } = xl.useListFlowVersions(e.id);
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(KY, { onClose: () => t(zr.NONE), children: Z("Version History") }),
    /* @__PURE__ */ V(w$, { children: [
      i && /* @__PURE__ */ y(Ax, { numberOfCards: 10 }),
      o && /* @__PURE__ */ y("div", { children: Z("Error, please try again.") }),
      r && r.data && /* @__PURE__ */ y(Bi, { className: "w-full h-full", children: r.data.map((s, l) => /* @__PURE__ */ y(
        V5e,
        {
          selected: s.id === (n == null ? void 0 : n.id),
          publishedVersionId: e.publishedVersionId,
          flowVersion: s,
          flowVersionNumber: r.data.length - l
        },
        s.id
      )) })
    ] })
  ] });
};
q5e.displayName = "FlowVersionsList";
const B5e = 70, X5e = ie.memo(
  ({ run: e, viewedRunId: t, refetchRuns: n }) => {
    const { Icon: r, variant: i } = Ks.getStatusIcon(e.status), o = yc().checkAccess(
      Es.WRITE_RUN
    ), { projectId: s, setRunId: l } = ol(), [c, a] = He(!1), { mutate: u, isPending: f } = dr({
      mutationFn: async ({ run: d, retryStrategy: p }) => {
        if (s) {
          const h = await _x.retry(d.id, {
            projectId: s,
            strategy: p
          }), m = await yi.get(d.flowId, {
            versionId: h.flowVersionId
          });
          return {
            run: h,
            populatedFlow: m
          };
        }
        throw Error("Project id isn't defined");
      },
      onSuccess: ({ run: d }) => {
        n();
      }
    });
    return /* @__PURE__ */ V(
      Ng,
      {
        className: Se("px-3 group", {
          "bg-accent text-accent-foreground": e.id === t
        }),
        style: { height: `${B5e}px` },
        onClick: () => {
          l(e.id);
        },
        children: [
          /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y("span", { children: e.status === cr.CANCELED ? /* @__PURE__ */ V(wn, { children: [
            /* @__PURE__ */ y(kn, { children: /* @__PURE__ */ y(
              r,
              {
                className: Se("w-5 h-5", {
                  "text-success": i === "success",
                  "text-destructive": i === "error"
                })
              }
            ) }),
            /* @__PURE__ */ y(An, { children: Z("Canceled") })
          ] }) : /* @__PURE__ */ y(
            r,
            {
              className: Se("w-5 h-5", {
                "text-success": i === "success",
                "text-destructive": i === "error"
              })
            }
          ) }) }),
          /* @__PURE__ */ V("div", { className: "grid gap-2", children: [
            /* @__PURE__ */ V("div", { className: "text-sm font-medium leading-none flex gap-2 items-center", children: [
              /* @__PURE__ */ y(
                U5e,
                {
                  date: new Date(e.created ?? /* @__PURE__ */ new Date()),
                  includeTime: !0,
                  className: "text-sm font-medium leading-none select-none cursor-default"
                }
              ),
              e.id === t && /* @__PURE__ */ y(NT, { className: "w-3.5 h-3.5" })
            ] }),
            DC({
              status: e.status,
              ignoreInternalError: !1
            }) && /* @__PURE__ */ V("p", { className: "flex gap-1 text-xs text-muted-foreground", children: [
              /* @__PURE__ */ y(XRt, { className: "h-3.5 w-3.5" }),
              Z("Took"),
              " ",
              rc.formatDuration(
                e.startTime && e.finishTime ? new Date(e.finishTime).getTime() - new Date(e.startTime).getTime() : void 0,
                !1
              )
            ] }),
            e.status === cr.RUNNING && /* @__PURE__ */ V("p", { className: "flex gap-1 text-xs text-muted-foreground", children: [
              Z("Running"),
              "..."
            ] }),
            e.status === cr.QUEUED && /* @__PURE__ */ V("p", { className: "flex gap-1 text-xs text-muted-foreground", children: [
              Z("Queued"),
              "..."
            ] })
          ] }),
          /* @__PURE__ */ V("div", { className: "ml-auto font-medium", children: [
            f && /* @__PURE__ */ y(mu, { className: "size-4" }),
            !f && /* @__PURE__ */ y(
              tb,
              {
                hasPermission: o,
                children: /* @__PURE__ */ V(
                  mN,
                  {
                    modal: !1,
                    open: c,
                    onOpenChange: a,
                    children: [
                      /* @__PURE__ */ V(wn, { children: [
                        /* @__PURE__ */ y(kn, { children: /* @__PURE__ */ y(Aj, { children: /* @__PURE__ */ y(
                          Qe,
                          {
                            variant: "ghost",
                            size: "icon",
                            className: Se(
                              "group-hover:opacity-100 opacity-0 rounded-full bg-accent drop-shadow-md",
                              {
                                "opacity-100": c
                              }
                            ),
                            onClick: (d) => {
                              d.preventDefault(), d.stopPropagation();
                            },
                            children: /* @__PURE__ */ y(qot, { className: "w-4 h-4" })
                          }
                        ) }) }),
                        /* @__PURE__ */ y(An, { children: Z("Retry run") })
                      ] }),
                      /* @__PURE__ */ V(xx, { children: [
                        /* @__PURE__ */ y(
                          wa,
                          {
                            disabled: !o,
                            onClick: (d) => {
                              d.preventDefault(), d.stopPropagation(), u({
                                run: e,
                                retryStrategy: qA.ON_LATEST_VERSION
                              });
                            },
                            className: "cursor-pointer",
                            children: /* @__PURE__ */ y("div", { className: "flex flex-row gap-2 items-center", children: /* @__PURE__ */ y("span", { children: Z("On latest version") }) })
                          }
                        ),
                        OZ(e.status) && /* @__PURE__ */ y(
                          wa,
                          {
                            onClick: (d) => {
                              d.preventDefault(), d.stopPropagation(), f || u({
                                run: e,
                                retryStrategy: qA.FROM_FAILED_STEP
                              });
                            },
                            className: "cursor-pointer",
                            children: /* @__PURE__ */ y("div", { className: "flex flex-row gap-2 items-center", children: /* @__PURE__ */ y("span", { children: Z("From failed step") }) })
                          }
                        )
                      ] })
                    ]
                  }
                )
              }
            )
          ] })
        ]
      },
      e.id
    );
  }
);
X5e.displayName = "FlowRunCard";
const Yfe = 15, W5e = ie.memo(() => {
  const [e, t, n] = tn((v) => [
    v.flow,
    v.setRightSidebar,
    v.run
  ]), [r, i] = He(1);
  nt(() => {
    i(1);
  }, [e.id]);
  const {
    data: o,
    isLoading: s,
    isError: l,
    refetch: c,
    isRefetching: a,
    isFetching: u
  } = pr({
    queryKey: ["flow-runs", e.id, r],
    queryFn: () => _x.list({
      flowId: [e.id],
      projectId: e.projectId,
      limit: Yfe,
      page: r
    }),
    refetchOnMount: !0,
    staleTime: 0,
    placeholderData: Get,
    refetchInterval: (v) => {
      var w;
      const b = (w = v.state.data) == null ? void 0 : w.data, A = b == null ? void 0 : b.filter(
        (O) => !DC({
          status: O.status,
          ignoreInternalError: !1
        })
      );
      return A != null && A.length ? 15 * 1e3 : !1;
    }
  }), f = Kt(() => (o == null ? void 0 : o.data) ?? [], [o]), d = (o == null ? void 0 : o.count) ?? f.length, p = Math.max(1, Math.ceil(d / Yfe));
  nt(() => {
    r > p && i(p);
  }, [r, p]);
  const h = () => {
    r >= p || i((v) => v + 1);
  }, m = () => {
    r !== 1 && i((v) => v - 1);
  };
  return /* @__PURE__ */ V("div", { className: "h-full w-full flex flex-col", children: [
    /* @__PURE__ */ y(KY, { onClose: () => t(zr.NONE), children: Z("Recent Runs") }),
    s && /* @__PURE__ */ y(Ax, { numberOfCards: 10 }),
    l && /* @__PURE__ */ y("div", { children: Z("Error, please try again.") }),
    f.length === 0 && !s && !a && /* @__PURE__ */ y(Dke, { message: Z("No runs found") }),
    f.length > 0 && /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        V$,
        {
          className: "w-full grow max-w-[calc(100%-6px)]",
          items: f,
          estimateSize: () => B5e,
          getItemKey: (v) => f[v].id,
          renderItem: (v) => /* @__PURE__ */ y(
            X5e,
            {
              refetchRuns: () => {
                c();
              },
              run: v,
              viewedRunId: n == null ? void 0 : n.id
            },
            v.id + v.status
          )
        }
      ),
      /* @__PURE__ */ V("div", { className: "flex items-center justify-between gap-2 border-t px-4 py-3", children: [
        /* @__PURE__ */ y(
          Qe,
          {
            variant: "ghost",
            onClick: m,
            disabled: r === 1 || u,
            children: Z("Previous")
          }
        ),
        /* @__PURE__ */ V("div", { className: "text-sm text-muted-foreground", children: [
          Z("Page"),
          " ",
          r,
          " ",
          Z("of"),
          " ",
          p
        ] }),
        /* @__PURE__ */ y(
          Qe,
          {
            variant: "ghost",
            onClick: h,
            disabled: r >= p || u,
            children: Z("Next")
          }
        )
      ] })
    ] })
  ] });
});
W5e.displayName = "RunsList";
var _4, Jfe;
function Z5e() {
  if (Jfe) return _4;
  Jfe = 1;
  var e = Object.prototype.toString;
  return _4 = function(n) {
    var r = e.call(n), i = r === "[object Arguments]";
    return i || (i = r !== "[object Array]" && n !== null && typeof n == "object" && typeof n.length == "number" && n.length >= 0 && e.call(n.callee) === "[object Function]"), i;
  }, _4;
}
var L4, epe;
function f$t() {
  if (epe) return L4;
  epe = 1;
  var e;
  if (!Object.keys) {
    var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Z5e(), i = Object.prototype.propertyIsEnumerable, o = !i.call({ toString: null }, "toString"), s = i.call(function() {
    }, "prototype"), l = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], c = function(d) {
      var p = d.constructor;
      return p && p.prototype === d;
    }, a = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = function() {
      if (typeof window > "u")
        return !1;
      for (var d in window)
        try {
          if (!a["$" + d] && t.call(window, d) && window[d] !== null && typeof window[d] == "object")
            try {
              c(window[d]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), f = function(d) {
      if (typeof window > "u" || !u)
        return c(d);
      try {
        return c(d);
      } catch {
        return !1;
      }
    };
    e = function(p) {
      var h = p !== null && typeof p == "object", m = n.call(p) === "[object Function]", v = r(p), b = h && n.call(p) === "[object String]", A = [];
      if (!h && !m && !v)
        throw new TypeError("Object.keys called on a non-object");
      var w = s && m;
      if (b && p.length > 0 && !t.call(p, 0))
        for (var O = 0; O < p.length; ++O)
          A.push(String(O));
      if (v && p.length > 0)
        for (var x = 0; x < p.length; ++x)
          A.push(String(x));
      else
        for (var S in p)
          !(w && S === "prototype") && t.call(p, S) && A.push(String(S));
      if (o)
        for (var E = f(p), k = 0; k < l.length; ++k)
          !(E && l[k] === "constructor") && t.call(p, l[k]) && A.push(l[k]);
      return A;
    };
  }
  return L4 = e, L4;
}
var z4, tpe;
function GY() {
  if (tpe) return z4;
  tpe = 1;
  var e = Array.prototype.slice, t = Z5e(), n = Object.keys, r = n ? function(s) {
    return n(s);
  } : f$t(), i = Object.keys;
  return r.shim = function() {
    if (Object.keys) {
      var s = function() {
        var l = Object.keys(arguments);
        return l && l.length === arguments.length;
      }(1, 2);
      s || (Object.keys = function(c) {
        return t(c) ? i(e.call(c)) : i(c);
      });
    } else
      Object.keys = r;
    return Object.keys || r;
  }, z4 = r, z4;
}
var j4, npe;
function YY() {
  if (npe) return j4;
  npe = 1;
  var e = /* @__PURE__ */ dz(), t = /* @__PURE__ */ UH(), n = /* @__PURE__ */ hu(), r = /* @__PURE__ */ wb();
  return j4 = function(o, s, l) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof s != "string" && typeof s != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var c = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, u = arguments.length > 5 ? arguments[5] : null, f = arguments.length > 6 ? arguments[6] : !1, d = !!r && r(o, s);
    if (e)
      e(o, s, {
        configurable: u === null && d ? d.configurable : !u,
        enumerable: c === null && d ? d.enumerable : !c,
        value: l,
        writable: a === null && d ? d.writable : !a
      });
    else if (f || !c && !a && !u)
      o[s] = l;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, j4;
}
var F4, rpe;
function JY() {
  if (rpe) return F4;
  rpe = 1;
  var e = /* @__PURE__ */ dz(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, F4 = t, F4;
}
var U4, ipe;
function _b() {
  if (ipe) return U4;
  ipe = 1;
  var e = GY(), t = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", n = Object.prototype.toString, r = Array.prototype.concat, i = /* @__PURE__ */ YY(), o = function(a) {
    return typeof a == "function" && n.call(a) === "[object Function]";
  }, s = /* @__PURE__ */ JY()(), l = function(a, u, f, d) {
    if (u in a) {
      if (d === !0) {
        if (a[u] === f)
          return;
      } else if (!o(d) || !d())
        return;
    }
    s ? i(a, u, f, !0) : i(a, u, f);
  }, c = function(a, u) {
    var f = arguments.length > 2 ? arguments[2] : {}, d = e(u);
    t && (d = r.call(d, Object.getOwnPropertySymbols(u)));
    for (var p = 0; p < d.length; p += 1)
      l(a, d[p], u[d[p]], f[d[p]]);
  };
  return c.supportsDescriptors = !!s, U4 = c, U4;
}
var V4 = { exports: {} }, q4, ope;
function p$t() {
  if (ope) return q4;
  ope = 1;
  var e = /* @__PURE__ */ Sh(), t = /* @__PURE__ */ YY(), n = /* @__PURE__ */ JY()(), r = /* @__PURE__ */ wb(), i = /* @__PURE__ */ hu(), o = e("%Math.floor%");
  return q4 = function(l, c) {
    if (typeof l != "function")
      throw new i("`fn` is not a function");
    if (typeof c != "number" || c < 0 || c > 4294967295 || o(c) !== c)
      throw new i("`length` must be a positive 32-bit integer");
    var a = arguments.length > 2 && !!arguments[2], u = !0, f = !0;
    if ("length" in l && r) {
      var d = r(l, "length");
      d && !d.configurable && (u = !1), d && !d.writable && (f = !1);
    }
    return (u || f || !a) && (n ? t(
      /** @type {Parameters<define>[0]} */
      l,
      "length",
      c,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      l,
      "length",
      c
    )), l;
  }, q4;
}
var B4, spe;
function h$t() {
  if (spe) return B4;
  spe = 1;
  var e = WC(), t = BH(), n = Xwe();
  return B4 = function() {
    return n(e, t, arguments);
  }, B4;
}
var ape;
function zx() {
  return ape || (ape = 1, function(e) {
    var t = /* @__PURE__ */ p$t(), n = /* @__PURE__ */ dz(), r = XH(), i = h$t();
    e.exports = function(s) {
      var l = r(arguments), c = s.length - (arguments.length - 1);
      return t(
        l,
        1 + (c > 0 ? c : 0),
        !0
      );
    }, n ? n(e.exports, "apply", { value: i }) : e.exports.apply = i;
  }(V4)), V4.exports;
}
var X4, lpe;
function H5e() {
  if (lpe) return X4;
  lpe = 1;
  var e = GY(), t = fz()(), n = /* @__PURE__ */ ra(), r = /* @__PURE__ */ FH(), i = n("Array.prototype.push"), o = n("Object.prototype.propertyIsEnumerable"), s = t ? r.getOwnPropertySymbols : null;
  return X4 = function(c, a) {
    if (c == null)
      throw new TypeError("target must be an object");
    var u = r(c);
    if (arguments.length === 1)
      return u;
    for (var f = 1; f < arguments.length; ++f) {
      var d = r(arguments[f]), p = e(d), h = t && (r.getOwnPropertySymbols || s);
      if (h)
        for (var m = h(d), v = 0; v < m.length; ++v) {
          var b = m[v];
          o(d, b) && i(p, b);
        }
      for (var A = 0; A < p.length; ++A) {
        var w = p[A];
        if (o(d, w)) {
          var O = d[w];
          u[w] = O;
        }
      }
    }
    return u;
  }, X4;
}
var W4, cpe;
function Q5e() {
  if (cpe) return W4;
  cpe = 1;
  var e = H5e(), t = function() {
    if (!Object.assign)
      return !1;
    for (var r = "abcdefghijklmnopqrst", i = r.split(""), o = {}, s = 0; s < i.length; ++s)
      o[i[s]] = i[s];
    var l = Object.assign({}, o), c = "";
    for (var a in l)
      c += a;
    return r !== c;
  }, n = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var r = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(r, "xy");
    } catch {
      return r[1] === "y";
    }
    return !1;
  };
  return W4 = function() {
    return !Object.assign || t() || n() ? e : Object.assign;
  }, W4;
}
var Z4, upe;
function m$t() {
  if (upe) return Z4;
  upe = 1;
  var e = _b(), t = Q5e();
  return Z4 = function() {
    var r = t();
    return e(
      Object,
      { assign: r },
      { assign: function() {
        return Object.assign !== r;
      } }
    ), r;
  }, Z4;
}
var H4, dpe;
function g$t() {
  if (dpe) return H4;
  dpe = 1;
  var e = _b(), t = zx(), n = H5e(), r = Q5e(), i = m$t(), o = t.apply(r()), s = function(c, a) {
    return o(Object, arguments);
  };
  return e(s, {
    getPolyfill: r,
    implementation: n,
    shim: i
  }), H4 = s, H4;
}
var Q4, fpe;
function $5e() {
  if (fpe) return Q4;
  fpe = 1;
  var e = /* @__PURE__ */ Sh(), t = zx(), n = t(e("String.prototype.indexOf"));
  return Q4 = function(i, o) {
    var s = e(i, !!o);
    return typeof s == "function" && n(i, ".prototype.") > -1 ? t(s) : s;
  }, Q4;
}
var $4, ppe;
function y$t() {
  if (ppe) return $4;
  ppe = 1;
  var e = function() {
    return typeof (function() {
    }).name == "string";
  }, t = Object.getOwnPropertyDescriptor;
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  e.functionsHaveConfigurableNames = function() {
    if (!e() || !t)
      return !1;
    var i = t(function() {
    }, "name");
    return !!i && !!i.configurable;
  };
  var n = Function.prototype.bind;
  return e.boundFunctionsHaveNames = function() {
    return e() && typeof n == "function" && (function() {
    }).bind().name !== "";
  }, $4 = e, $4;
}
var K4, hpe;
function v$t() {
  if (hpe) return K4;
  hpe = 1;
  var e = /* @__PURE__ */ YY(), t = /* @__PURE__ */ JY()(), n = y$t().functionsHaveConfigurableNames(), r = /* @__PURE__ */ hu();
  return K4 = function(o, s) {
    if (typeof o != "function")
      throw new r("`fn` is not a function");
    var l = arguments.length > 2 && !!arguments[2];
    return (!l || n) && (t ? e(
      /** @type {Parameters<define>[0]} */
      o,
      "name",
      s,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      o,
      "name",
      s
    )), o;
  }, K4;
}
var G4, mpe;
function K5e() {
  if (mpe) return G4;
  mpe = 1;
  var e = v$t(), t = /* @__PURE__ */ hu(), n = Object;
  return G4 = e(function() {
    if (this == null || this !== n(this))
      throw new t("RegExp.prototype.flags getter called on non-object");
    var i = "";
    return this.hasIndices && (i += "d"), this.global && (i += "g"), this.ignoreCase && (i += "i"), this.multiline && (i += "m"), this.dotAll && (i += "s"), this.unicode && (i += "u"), this.unicodeSets && (i += "v"), this.sticky && (i += "y"), i;
  }, "get flags", !0), G4;
}
var Y4, gpe;
function G5e() {
  if (gpe) return Y4;
  gpe = 1;
  var e = K5e(), t = _b().supportsDescriptors, n = Object.getOwnPropertyDescriptor;
  return Y4 = function() {
    if (t && /a/mig.flags === "gim") {
      var i = n(RegExp.prototype, "flags");
      if (i && typeof i.get == "function" && "dotAll" in RegExp.prototype && "hasIndices" in RegExp.prototype) {
        var o = "", s = {};
        if (Object.defineProperty(s, "hasIndices", {
          get: function() {
            o += "d";
          }
        }), Object.defineProperty(s, "sticky", {
          get: function() {
            o += "y";
          }
        }), i.get.call(s), o === "dy")
          return i.get;
      }
    }
    return e;
  }, Y4;
}
var J4, ype;
function b$t() {
  if (ype) return J4;
  ype = 1;
  var e = _b().supportsDescriptors, t = G5e(), n = /* @__PURE__ */ wb(), r = Object.defineProperty, i = /* @__PURE__ */ Vwe(), o = WH(), s = /a/;
  return J4 = function() {
    if (!e || !o)
      throw new i("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var c = t(), a = o(s), u = n(a, "flags");
    return (!u || u.get !== c) && r(a, "flags", {
      configurable: !0,
      enumerable: !1,
      get: c
    }), c;
  }, J4;
}
var eV, vpe;
function O$t() {
  if (vpe) return eV;
  vpe = 1;
  var e = _b(), t = zx(), n = K5e(), r = G5e(), i = b$t(), o = t(r());
  return e(o, {
    getPolyfill: r,
    implementation: n,
    shim: i
  }), eV = o, eV;
}
var IS = { exports: {} }, tV, bpe;
function Lb() {
  if (bpe) return tV;
  bpe = 1;
  var e = fz();
  return tV = function() {
    return e() && !!Symbol.toStringTag;
  }, tV;
}
var nV, Ope;
function Y5e() {
  if (Ope) return nV;
  Ope = 1;
  var e = Lb()(), t = /* @__PURE__ */ ra(), n = t("Object.prototype.toString"), r = function(l) {
    return e && l && typeof l == "object" && Symbol.toStringTag in l ? !1 : n(l) === "[object Arguments]";
  }, i = function(l) {
    return r(l) ? !0 : l !== null && typeof l == "object" && "length" in l && typeof l.length == "number" && l.length >= 0 && n(l) !== "[object Array]" && "callee" in l && n(l.callee) === "[object Function]";
  }, o = function() {
    return r(arguments);
  }();
  return r.isLegacyArguments = i, nV = o ? r : i, nV;
}
var rV, Ape;
function A$t() {
  if (Ape) return rV;
  Ape = 1;
  var e = /* @__PURE__ */ ZH(), t = pz()(), n = /* @__PURE__ */ hu(), r = {
    assert: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new n("`O` is not an object");
      if (typeof o != "string")
        throw new n("`slot` must be a string");
      if (t.assert(i), !r.has(i, o))
        throw new n("`" + o + "` is not present on `O`");
    },
    get: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new n("`O` is not an object");
      if (typeof o != "string")
        throw new n("`slot` must be a string");
      var s = t.get(i);
      return s && s[
        /** @type {SaltedInternalSlot} */
        "$" + o
      ];
    },
    has: function(i, o) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new n("`O` is not an object");
      if (typeof o != "string")
        throw new n("`slot` must be a string");
      var s = t.get(i);
      return !!s && e(
        s,
        /** @type {SaltedInternalSlot} */
        "$" + o
      );
    },
    set: function(i, o, s) {
      if (!i || typeof i != "object" && typeof i != "function")
        throw new n("`O` is not an object");
      if (typeof o != "string")
        throw new n("`slot` must be a string");
      var l = t.get(i);
      l || (l = {}, t.set(i, l)), l[
        /** @type {SaltedInternalSlot} */
        "$" + o
      ] = s;
    }
  };
  return Object.freeze && Object.freeze(r), rV = r, rV;
}
var iV, wpe;
function w$t() {
  if (wpe) return iV;
  wpe = 1;
  var e = A$t(), t = /* @__PURE__ */ UH(), n = typeof StopIteration == "object" ? StopIteration : null;
  return iV = function(i) {
    if (!n)
      throw new t("this environment lacks StopIteration");
    e.set(i, "[[Done]]", !1);
    var o = {
      next: (
        /** @type {() => IteratorResult<T>} */
        function() {
          var l = (
            /** @type {typeof origIterator} */
            e.get(this, "[[Iterator]]")
          ), c = !!e.get(l, "[[Done]]");
          try {
            return {
              done: c,
              // eslint-disable-next-line no-extra-parens
              value: c ? void 0 : (
                /** @type {T} */
                l.next()
              )
            };
          } catch (a) {
            if (e.set(l, "[[Done]]", !0), a !== n)
              throw a;
            return {
              done: !0,
              value: void 0
            };
          }
        }
      )
    };
    return e.set(o, "[[Iterator]]", i), o;
  }, iV;
}
var oV, xpe;
function J5e() {
  if (xpe) return oV;
  xpe = 1;
  var e = {}.toString;
  return oV = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, oV;
}
var sV, Spe;
function e6e() {
  if (Spe) return sV;
  Spe = 1;
  var e = /* @__PURE__ */ ra(), t = e("String.prototype.valueOf"), n = function(l) {
    try {
      return t(l), !0;
    } catch {
      return !1;
    }
  }, r = e("Object.prototype.toString"), i = "[object String]", o = Lb()();
  return sV = function(l) {
    return typeof l == "string" ? !0 : !l || typeof l != "object" ? !1 : o ? n(l) : r(l) === i;
  }, sV;
}
var aV, Epe;
function t6e() {
  if (Epe) return aV;
  Epe = 1;
  var e = typeof Map == "function" && Map.prototype ? Map : null, t = typeof Set == "function" && Set.prototype ? Set : null, n;
  e || (n = function(s) {
    return !1;
  });
  var r = e ? Map.prototype.has : null, i = t ? Set.prototype.has : null;
  return !n && !r && (n = function(s) {
    return !1;
  }), aV = n || function(s) {
    if (!s || typeof s != "object")
      return !1;
    try {
      if (r.call(s), i)
        try {
          i.call(s);
        } catch {
          return !0;
        }
      return s instanceof e;
    } catch {
    }
    return !1;
  }, aV;
}
var lV, Tpe;
function n6e() {
  if (Tpe) return lV;
  Tpe = 1;
  var e = typeof Map == "function" && Map.prototype ? Map : null, t = typeof Set == "function" && Set.prototype ? Set : null, n;
  t || (n = function(s) {
    return !1;
  });
  var r = e ? Map.prototype.has : null, i = t ? Set.prototype.has : null;
  return !n && !i && (n = function(s) {
    return !1;
  }), lV = n || function(s) {
    if (!s || typeof s != "object")
      return !1;
    try {
      if (i.call(s), r)
        try {
          r.call(s);
        } catch {
          return !0;
        }
      return s instanceof t;
    } catch {
    }
    return !1;
  }, lV;
}
var kpe;
function x$t() {
  if (kpe) return IS.exports;
  kpe = 1;
  var e = /* @__PURE__ */ Y5e(), t = /* @__PURE__ */ w$t();
  if (VH()() || fz()()) {
    var n = Symbol.iterator;
    IS.exports = function(T) {
      if (T != null && typeof T[n] < "u")
        return T[n]();
      if (e(T))
        return Array.prototype[n].call(T);
    };
  } else {
    var r = J5e(), i = e6e(), o = /* @__PURE__ */ Sh(), s = o("%Map%", !0), l = o("%Set%", !0), c = $5e(), a = c("Array.prototype.push"), u = c("String.prototype.charCodeAt"), f = c("String.prototype.slice"), d = function(T, R) {
      var j = T.length;
      if (R + 1 >= j)
        return R + 1;
      var F = u(T, R);
      if (F < 55296 || F > 56319)
        return R + 1;
      var L = u(T, R + 1);
      return L < 56320 || L > 57343 ? R + 1 : R + 2;
    }, p = function(T) {
      var R = 0;
      return {
        next: function() {
          var F = R >= T.length, L;
          return F || (L = T[R], R += 1), {
            done: F,
            value: L
          };
        }
      };
    }, h = function(T, R) {
      if (r(T) || e(T))
        return p(T);
      if (i(T)) {
        var j = 0;
        return {
          next: function() {
            var L = d(T, j), _ = f(T, j, L);
            return j = L, {
              done: L > T.length,
              value: _
            };
          }
        };
      }
      if (R && typeof T["_es6-shim iterator_"] < "u")
        return T["_es6-shim iterator_"]();
    };
    if (!s && !l)
      IS.exports = function(T) {
        if (T != null)
          return h(T, !0);
      };
    else {
      var m = /* @__PURE__ */ t6e(), v = /* @__PURE__ */ n6e(), b = c("Map.prototype.forEach", !0), A = c("Set.prototype.forEach", !0);
      if (typeof process > "u" || !process.versions || !process.versions.node)
        var w = c("Map.prototype.iterator", !0), O = c("Set.prototype.iterator", !0);
      var x = c("Map.prototype.@@iterator", !0) || c("Map.prototype._es6-shim iterator_", !0), S = c("Set.prototype.@@iterator", !0) || c("Set.prototype._es6-shim iterator_", !0), E = function(T) {
        if (m(T)) {
          if (w)
            return t(w(T));
          if (x)
            return x(T);
          if (b) {
            var R = [];
            return b(T, function(F, L) {
              a(R, [L, F]);
            }), p(R);
          }
        }
        if (v(T)) {
          if (O)
            return t(O(T));
          if (S)
            return S(T);
          if (A) {
            var j = [];
            return A(T, function(F) {
              a(j, F);
            }), p(j);
          }
        }
      };
      IS.exports = function(T) {
        return E(T) || h(T);
      };
    }
  }
  return IS.exports;
}
var cV, Cpe;
function r6e() {
  if (Cpe) return cV;
  Cpe = 1;
  var e = function(t) {
    return t !== t;
  };
  return cV = function(n, r) {
    return n === 0 && r === 0 ? 1 / n === 1 / r : !!(n === r || e(n) && e(r));
  }, cV;
}
var uV, Npe;
function i6e() {
  if (Npe) return uV;
  Npe = 1;
  var e = r6e();
  return uV = function() {
    return typeof Object.is == "function" ? Object.is : e;
  }, uV;
}
var dV, Ppe;
function S$t() {
  if (Ppe) return dV;
  Ppe = 1;
  var e = i6e(), t = _b();
  return dV = function() {
    var r = e();
    return t(Object, { is: r }, {
      is: function() {
        return Object.is !== r;
      }
    }), r;
  }, dV;
}
var fV, Ipe;
function E$t() {
  if (Ipe) return fV;
  Ipe = 1;
  var e = _b(), t = zx(), n = r6e(), r = i6e(), i = S$t(), o = t(r(), Object);
  return e(o, {
    getPolyfill: r,
    implementation: n,
    shim: i
  }), fV = o, fV;
}
var pV, Rpe;
function o6e() {
  if (Rpe) return pV;
  Rpe = 1;
  var e = zx(), t = /* @__PURE__ */ ra(), n = /* @__PURE__ */ Sh(), r = n("%ArrayBuffer%", !0), i = t("ArrayBuffer.prototype.byteLength", !0), o = t("Object.prototype.toString"), s = !!r && !i && new r(0).slice, l = !!s && e(s);
  return pV = i || l ? function(a) {
    if (!a || typeof a != "object")
      return !1;
    try {
      return i ? i(a) : l(a, 0), !0;
    } catch {
      return !1;
    }
  } : r ? function(a) {
    return o(a) === "[object ArrayBuffer]";
  } : function(a) {
    return !1;
  }, pV;
}
var hV, Mpe;
function T$t() {
  if (Mpe) return hV;
  Mpe = 1;
  var e = /* @__PURE__ */ ra(), t = e("Date.prototype.getDay"), n = function(l) {
    try {
      return t(l), !0;
    } catch {
      return !1;
    }
  }, r = e("Object.prototype.toString"), i = "[object Date]", o = Lb()();
  return hV = function(l) {
    return typeof l != "object" || l === null ? !1 : o ? n(l) : r(l) === i;
  }, hV;
}
var mV, Dpe;
function s6e() {
  if (Dpe) return mV;
  Dpe = 1;
  var e = /* @__PURE__ */ ra(), t = Lb()(), n = /* @__PURE__ */ ZH(), r = /* @__PURE__ */ wb(), i;
  if (t) {
    var o = e("RegExp.prototype.exec"), s = {}, l = function() {
      throw s;
    }, c = {
      toString: l,
      valueOf: l
    };
    typeof Symbol.toPrimitive == "symbol" && (c[Symbol.toPrimitive] = l), i = function(d) {
      if (!d || typeof d != "object")
        return !1;
      var p = (
        /** @type {NonNullable<typeof gOPD>} */
        r(
          /** @type {{ lastIndex?: unknown }} */
          d,
          "lastIndex"
        )
      ), h = p && n(p, "value");
      if (!h)
        return !1;
      try {
        o(
          d,
          /** @type {string} */
          /** @type {unknown} */
          c
        );
      } catch (m) {
        return m === s;
      }
    };
  } else {
    var a = e("Object.prototype.toString"), u = "[object RegExp]";
    i = function(d) {
      return !d || typeof d != "object" && typeof d != "function" ? !1 : a(d) === u;
    };
  }
  return mV = i, mV;
}
var gV, _pe;
function k$t() {
  if (_pe) return gV;
  _pe = 1;
  var e = /* @__PURE__ */ ra(), t = e("SharedArrayBuffer.prototype.byteLength", !0);
  return gV = t ? function(r) {
    if (!r || typeof r != "object")
      return !1;
    try {
      return t(r), !0;
    } catch {
      return !1;
    }
  } : function(r) {
    return !1;
  }, gV;
}
var yV, Lpe;
function C$t() {
  if (Lpe) return yV;
  Lpe = 1;
  var e = /* @__PURE__ */ ra(), t = e("Number.prototype.toString"), n = function(l) {
    try {
      return t(l), !0;
    } catch {
      return !1;
    }
  }, r = e("Object.prototype.toString"), i = "[object Number]", o = Lb()();
  return yV = function(l) {
    return typeof l == "number" ? !0 : !l || typeof l != "object" ? !1 : o ? n(l) : r(l) === i;
  }, yV;
}
var vV, zpe;
function N$t() {
  if (zpe) return vV;
  zpe = 1;
  var e = /* @__PURE__ */ ra(), t = e("Boolean.prototype.toString"), n = e("Object.prototype.toString"), r = function(l) {
    try {
      return t(l), !0;
    } catch {
      return !1;
    }
  }, i = "[object Boolean]", o = Lb()();
  return vV = function(l) {
    return typeof l == "boolean" ? !0 : l === null || typeof l != "object" ? !1 : o ? r(l) : n(l) === i;
  }, vV;
}
var iR = { exports: {} }, bV, jpe;
function P$t() {
  if (jpe) return bV;
  jpe = 1;
  var e = /* @__PURE__ */ ra(), t = s6e(), n = e("RegExp.prototype.exec"), r = /* @__PURE__ */ hu();
  return bV = function(o) {
    if (!t(o))
      throw new r("`regex` must be a RegExp");
    return function(l) {
      return n(o, l) !== null;
    };
  }, bV;
}
var Fpe;
function I$t() {
  if (Fpe) return iR.exports;
  Fpe = 1;
  var e = /* @__PURE__ */ ra(), t = e("Object.prototype.toString"), n = VH()(), r = /* @__PURE__ */ P$t();
  if (n) {
    var i = e("Symbol.prototype.toString"), o = r(/^Symbol\(.*\)$/), s = function(c) {
      return typeof c.valueOf() != "symbol" ? !1 : o(i(c));
    };
    iR.exports = function(c) {
      if (typeof c == "symbol")
        return !0;
      if (!c || typeof c != "object" || t(c) !== "[object Symbol]")
        return !1;
      try {
        return s(c);
      } catch {
        return !1;
      }
    };
  } else
    iR.exports = function(c) {
      return !1;
    };
  return iR.exports;
}
var oR = { exports: {} }, OV, Upe;
function R$t() {
  if (Upe) return OV;
  Upe = 1;
  var e = typeof BigInt < "u" && BigInt;
  return OV = function() {
    return typeof e == "function" && typeof BigInt == "function" && typeof e(42) == "bigint" && typeof BigInt(42) == "bigint";
  }, OV;
}
var Vpe;
function M$t() {
  if (Vpe) return oR.exports;
  Vpe = 1;
  var e = R$t()();
  if (e) {
    var t = BigInt.prototype.valueOf, n = function(i) {
      try {
        return t.call(i), !0;
      } catch {
      }
      return !1;
    };
    oR.exports = function(i) {
      return i === null || typeof i > "u" || typeof i == "boolean" || typeof i == "string" || typeof i == "number" || typeof i == "symbol" || typeof i == "function" ? !1 : typeof i == "bigint" ? !0 : n(i);
    };
  } else
    oR.exports = function(i) {
      return !1;
    };
  return oR.exports;
}
var AV, qpe;
function D$t() {
  if (qpe) return AV;
  qpe = 1;
  var e = e6e(), t = C$t(), n = N$t(), r = I$t(), i = M$t();
  return AV = function(s) {
    if (s == null || typeof s != "object" && typeof s != "function")
      return null;
    if (e(s))
      return "String";
    if (t(s))
      return "Number";
    if (n(s))
      return "Boolean";
    if (r(s))
      return "Symbol";
    if (i(s))
      return "BigInt";
  }, AV;
}
var wV, Bpe;
function _$t() {
  if (Bpe) return wV;
  Bpe = 1;
  var e = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap : null, t = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet : null, n;
  e || (n = function(s) {
    return !1;
  });
  var r = e ? e.prototype.has : null, i = t ? t.prototype.has : null;
  return !n && !r && (n = function(s) {
    return !1;
  }), wV = n || function(s) {
    if (!s || typeof s != "object")
      return !1;
    try {
      if (r.call(s, r), i)
        try {
          i.call(s, i);
        } catch {
          return !0;
        }
      return s instanceof e;
    } catch {
    }
    return !1;
  }, wV;
}
var sR = { exports: {} }, Xpe;
function L$t() {
  if (Xpe) return sR.exports;
  Xpe = 1;
  var e = /* @__PURE__ */ Sh(), t = /* @__PURE__ */ ra(), n = e("%WeakSet%", !0), r = t("WeakSet.prototype.has", !0);
  if (r) {
    var i = t("WeakMap.prototype.has", !0);
    sR.exports = function(s) {
      if (!s || typeof s != "object")
        return !1;
      try {
        if (r(s, r), i)
          try {
            i(s, i);
          } catch {
            return !0;
          }
        return s instanceof n;
      } catch {
      }
      return !1;
    };
  } else
    sR.exports = function(s) {
      return !1;
    };
  return sR.exports;
}
var xV, Wpe;
function z$t() {
  if (Wpe) return xV;
  Wpe = 1;
  var e = /* @__PURE__ */ t6e(), t = /* @__PURE__ */ n6e(), n = _$t(), r = /* @__PURE__ */ L$t();
  return xV = function(o) {
    if (o && typeof o == "object") {
      if (e(o))
        return "Map";
      if (t(o))
        return "Set";
      if (n(o))
        return "WeakMap";
      if (r(o))
        return "WeakSet";
    }
    return !1;
  }, xV;
}
var SV, Zpe;
function j$t() {
  if (Zpe) return SV;
  Zpe = 1;
  var e = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, t(function() {
        throw 42;
      }, null, n);
    } catch (A) {
      A !== r && (t = null);
    }
  else
    t = null;
  var i = /^\s*class\b/, o = function(w) {
    try {
      var O = e.call(w);
      return i.test(O);
    } catch {
      return !1;
    }
  }, s = function(w) {
    try {
      return o(w) ? !1 : (e.call(w), !0);
    } catch {
      return !1;
    }
  }, l = Object.prototype.toString, c = "[object Object]", a = "[object Function]", u = "[object GeneratorFunction]", f = "[object HTMLAllCollection]", d = "[object HTML document.all class]", p = "[object HTMLCollection]", h = typeof Symbol == "function" && !!Symbol.toStringTag, m = !(0 in [,]), v = function() {
    return !1;
  };
  if (typeof document == "object") {
    var b = document.all;
    l.call(b) === l.call(document.all) && (v = function(w) {
      if ((m || !w) && (typeof w > "u" || typeof w == "object"))
        try {
          var O = l.call(w);
          return (O === f || O === d || O === p || O === c) && w("") == null;
        } catch {
        }
      return !1;
    });
  }
  return SV = t ? function(w) {
    if (v(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    try {
      t(w, null, n);
    } catch (O) {
      if (O !== r)
        return !1;
    }
    return !o(w) && s(w);
  } : function(w) {
    if (v(w))
      return !0;
    if (!w || typeof w != "function" && typeof w != "object")
      return !1;
    if (h)
      return s(w);
    if (o(w))
      return !1;
    var O = l.call(w);
    return O !== a && O !== u && !/^\[object HTML/.test(O) ? !1 : s(w);
  }, SV;
}
var EV, Hpe;
function F$t() {
  if (Hpe) return EV;
  Hpe = 1;
  var e = j$t(), t = Object.prototype.toString, n = Object.prototype.hasOwnProperty, r = function(c, a, u) {
    for (var f = 0, d = c.length; f < d; f++)
      n.call(c, f) && (u == null ? a(c[f], f, c) : a.call(u, c[f], f, c));
  }, i = function(c, a, u) {
    for (var f = 0, d = c.length; f < d; f++)
      u == null ? a(c.charAt(f), f, c) : a.call(u, c.charAt(f), f, c);
  }, o = function(c, a, u) {
    for (var f in c)
      n.call(c, f) && (u == null ? a(c[f], f, c) : a.call(u, c[f], f, c));
  };
  function s(l) {
    return t.call(l) === "[object Array]";
  }
  return EV = function(c, a, u) {
    if (!e(a))
      throw new TypeError("iterator must be a function");
    var f;
    arguments.length >= 3 && (f = u), s(c) ? r(c, a, f) : typeof c == "string" ? i(c, a, f) : o(c, a, f);
  }, EV;
}
var TV, Qpe;
function U$t() {
  return Qpe || (Qpe = 1, TV = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), TV;
}
var kV, $pe;
function V$t() {
  if ($pe) return kV;
  $pe = 1;
  var e = /* @__PURE__ */ U$t(), t = typeof globalThis > "u" ? lT : globalThis;
  return kV = function() {
    for (var r = [], i = 0; i < e.length; i++)
      typeof t[e[i]] == "function" && (r[r.length] = e[i]);
    return r;
  }, kV;
}
var CV, Kpe;
function q$t() {
  if (Kpe) return CV;
  Kpe = 1;
  var e = F$t(), t = /* @__PURE__ */ V$t(), n = zx(), r = /* @__PURE__ */ ra(), i = /* @__PURE__ */ wb(), o = WH(), s = r("Object.prototype.toString"), l = Lb()(), c = typeof globalThis > "u" ? lT : globalThis, a = t(), u = r("String.prototype.slice"), f = r("Array.prototype.indexOf", !0) || function(v, b) {
    for (var A = 0; A < v.length; A += 1)
      if (v[A] === b)
        return A;
    return -1;
  }, d = { __proto__: null };
  l && i && o ? e(a, function(m) {
    var v = new c[m]();
    if (Symbol.toStringTag in v && o) {
      var b = o(v), A = i(b, Symbol.toStringTag);
      if (!A && b) {
        var w = o(b);
        A = i(w, Symbol.toStringTag);
      }
      d["$" + m] = n(A.get);
    }
  }) : e(a, function(m) {
    var v = new c[m](), b = v.slice || v.set;
    b && (d[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + m
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    n(b));
  });
  var p = function(v) {
    var b = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      d,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(A, w) {
        if (!b)
          try {
            "$" + A(v) === w && (b = /** @type {import('.').TypedArrayName} */
            u(w, 1));
          } catch {
          }
      }
    ), b;
  }, h = function(v) {
    var b = !1;
    return e(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      d,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(A, w) {
        if (!b)
          try {
            A(v), b = /** @type {import('.').TypedArrayName} */
            u(w, 1);
          } catch {
          }
      }
    ), b;
  };
  return CV = function(v) {
    if (!v || typeof v != "object")
      return !1;
    if (!l) {
      var b = u(s(v), 8, -1);
      return f(a, b) > -1 ? b : b !== "Object" ? !1 : h(v);
    }
    return i ? p(v) : null;
  }, CV;
}
var NV, Gpe;
function B$t() {
  if (Gpe) return NV;
  Gpe = 1;
  var e = /* @__PURE__ */ ra(), t = e("ArrayBuffer.prototype.byteLength", !0), n = /* @__PURE__ */ o6e();
  return NV = function(i) {
    return n(i) ? t ? t(i) : i.byteLength : NaN;
  }, NV;
}
var PV, Ype;
function X$t() {
  if (Ype) return PV;
  Ype = 1;
  var e = g$t(), t = $5e(), n = O$t(), r = /* @__PURE__ */ Sh(), i = x$t(), o = pz(), s = E$t(), l = /* @__PURE__ */ Y5e(), c = J5e(), a = /* @__PURE__ */ o6e(), u = /* @__PURE__ */ T$t(), f = s6e(), d = /* @__PURE__ */ k$t(), p = GY(), h = D$t(), m = /* @__PURE__ */ z$t(), v = /* @__PURE__ */ q$t(), b = /* @__PURE__ */ B$t(), A = t("SharedArrayBuffer.prototype.byteLength", !0), w = t("Date.prototype.getTime"), O = Object.getPrototypeOf, x = t("Object.prototype.toString"), S = r("%Set%", !0), E = t("Map.prototype.has", !0), k = t("Map.prototype.get", !0), T = t("Map.prototype.size", !0), R = t("Set.prototype.add", !0), j = t("Set.prototype.delete", !0), F = t("Set.prototype.has", !0), L = t("Set.prototype.size", !0);
  function _(H, Y, J, oe) {
    for (var ce = i(H), fe; (fe = ce.next()) && !fe.done; )
      if (M(Y, fe.value, J, oe))
        return j(H, fe.value), !0;
    return !1;
  }
  function U(H) {
    if (typeof H > "u")
      return null;
    if (typeof H != "object")
      return typeof H == "symbol" ? !1 : typeof H == "string" || typeof H == "number" ? +H == +H : !0;
  }
  function z(H, Y, J, oe, ce, fe) {
    var $ = U(J);
    if ($ != null)
      return $;
    var pe = k(Y, $), ee = e({}, ce, { strict: !1 });
    return typeof pe > "u" && !E(Y, $) || !M(oe, pe, ee, fe) ? !1 : !E(H, $) && M(oe, pe, ee, fe);
  }
  function C(H, Y, J) {
    var oe = U(J);
    return oe ?? (F(Y, oe) && !F(H, oe));
  }
  function I(H, Y, J, oe, ce, fe) {
    for (var $ = i(H), pe, ee; (pe = $.next()) && !pe.done; )
      if (ee = pe.value, // eslint-disable-next-line no-use-before-define
      M(J, ee, ce, fe) && M(oe, k(Y, ee), ce, fe))
        return j(H, ee), !0;
    return !1;
  }
  function M(H, Y, J, oe) {
    var ce = J || {};
    if (ce.strict ? s(H, Y) : H === Y)
      return !0;
    var fe = h(H), $ = h(Y);
    if (fe !== $)
      return !1;
    if (!H || !Y || typeof H != "object" && typeof Y != "object")
      return ce.strict ? s(H, Y) : H == Y;
    var pe = oe.has(H), ee = oe.has(Y), Ce;
    if (pe && ee) {
      if (oe.get(H) === oe.get(Y))
        return !0;
    } else
      Ce = {};
    return pe || oe.set(H, Ce), ee || oe.set(Y, Ce), q(H, Y, ce, oe);
  }
  function D(H) {
    return !H || typeof H != "object" || typeof H.length != "number" || typeof H.copy != "function" || typeof H.slice != "function" || H.length > 0 && typeof H[0] != "number" ? !1 : !!(H.constructor && H.constructor.isBuffer && H.constructor.isBuffer(H));
  }
  function X(H, Y, J, oe) {
    if (L(H) !== L(Y))
      return !1;
    for (var ce = i(H), fe = i(Y), $, pe, ee; ($ = ce.next()) && !$.done; )
      if ($.value && typeof $.value == "object")
        ee || (ee = new S()), R(ee, $.value);
      else if (!F(Y, $.value)) {
        if (J.strict || !C(H, Y, $.value))
          return !1;
        ee || (ee = new S()), R(ee, $.value);
      }
    if (ee) {
      for (; (pe = fe.next()) && !pe.done; )
        if (pe.value && typeof pe.value == "object") {
          if (!_(ee, pe.value, J.strict, oe))
            return !1;
        } else if (!J.strict && !F(H, pe.value) && !_(ee, pe.value, J.strict, oe))
          return !1;
      return L(ee) === 0;
    }
    return !0;
  }
  function B(H, Y, J, oe) {
    if (T(H) !== T(Y))
      return !1;
    for (var ce = i(H), fe = i(Y), $, pe, ee, Ce, Ee, Ve; ($ = ce.next()) && !$.done; )
      if (Ce = $.value[0], Ee = $.value[1], Ce && typeof Ce == "object")
        ee || (ee = new S()), R(ee, Ce);
      else if (Ve = k(Y, Ce), typeof Ve > "u" && !E(Y, Ce) || !M(Ee, Ve, J, oe)) {
        if (J.strict || !z(H, Y, Ce, Ee, J, oe))
          return !1;
        ee || (ee = new S()), R(ee, Ce);
      }
    if (ee) {
      for (; (pe = fe.next()) && !pe.done; )
        if (Ce = pe.value[0], Ve = pe.value[1], Ce && typeof Ce == "object") {
          if (!I(ee, H, Ce, Ve, J, oe))
            return !1;
        } else if (!J.strict && (!H.has(Ce) || !M(k(H, Ce), Ve, J, oe)) && !I(ee, H, Ce, Ve, e({}, J, { strict: !1 }), oe))
          return !1;
      return L(ee) === 0;
    }
    return !0;
  }
  function q(H, Y, J, oe) {
    var ce, fe;
    if (typeof H != typeof Y || H == null || Y == null || x(H) !== x(Y) || l(H) !== l(Y))
      return !1;
    var $ = c(H), pe = c(Y);
    if ($ !== pe)
      return !1;
    var ee = H instanceof Error, Ce = Y instanceof Error;
    if (ee !== Ce || (ee || Ce) && (H.name !== Y.name || H.message !== Y.message))
      return !1;
    var Ee = f(H), Ve = f(Y);
    if (Ee !== Ve || (Ee || Ve) && (H.source !== Y.source || n(H) !== n(Y)))
      return !1;
    var et = u(H), ft = u(Y);
    if (et !== ft || (et || ft) && w(H) !== w(Y) || J.strict && O && O(H) !== O(Y))
      return !1;
    var me = v(H), Te = v(Y);
    if (me !== Te)
      return !1;
    if (me || Te) {
      if (H.length !== Y.length)
        return !1;
      for (ce = 0; ce < H.length; ce++)
        if (H[ce] !== Y[ce])
          return !1;
      return !0;
    }
    var re = D(H), le = D(Y);
    if (re !== le)
      return !1;
    if (re || le) {
      if (H.length !== Y.length)
        return !1;
      for (ce = 0; ce < H.length; ce++)
        if (H[ce] !== Y[ce])
          return !1;
      return !0;
    }
    var Oe = a(H), be = a(Y);
    if (Oe !== be)
      return !1;
    if (Oe || be)
      return b(H) !== b(Y) ? !1 : typeof Uint8Array == "function" && M(new Uint8Array(H), new Uint8Array(Y), J, oe);
    var je = d(H), xe = d(Y);
    if (je !== xe)
      return !1;
    if (je || xe)
      return A(H) !== A(Y) ? !1 : typeof Uint8Array == "function" && M(new Uint8Array(H), new Uint8Array(Y), J, oe);
    if (typeof H != typeof Y)
      return !1;
    var Q = p(H), ae = p(Y);
    if (Q.length !== ae.length)
      return !1;
    for (Q.sort(), ae.sort(), ce = Q.length - 1; ce >= 0; ce--)
      if (Q[ce] != ae[ce])
        return !1;
    for (ce = Q.length - 1; ce >= 0; ce--)
      if (fe = Q[ce], !M(H[fe], Y[fe], J, oe))
        return !1;
    var Pe = m(H), Fe = m(Y);
    return Pe !== Fe ? !1 : Pe === "Set" || Fe === "Set" ? X(H, Y, J, oe) : Pe === "Map" ? B(H, Y, J, oe) : !0;
  }
  return PV = function(Y, J, oe) {
    return M(Y, J, oe, o());
  }, PV;
}
var W$t = X$t();
const qg = /* @__PURE__ */ Sl(W$t);
var eJ = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Z$t = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, Hd, Wy, vve, H$t = (vve = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    tt(this, Hd, Z$t);
    tt(this, Wy, !1);
  }
  setTimeoutProvider(e) {
    process.env.NODE_ENV !== "production" && K(this, Wy) && e !== K(this, Hd) && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: K(this, Hd), provider: e }
    ), $e(this, Hd, e), process.env.NODE_ENV !== "production" && $e(this, Wy, !1);
  }
  setTimeout(e, t) {
    return process.env.NODE_ENV !== "production" && $e(this, Wy, !0), K(this, Hd).setTimeout(e, t);
  }
  clearTimeout(e) {
    K(this, Hd).clearTimeout(e);
  }
  setInterval(e, t) {
    return process.env.NODE_ENV !== "production" && $e(this, Wy, !0), K(this, Hd).setInterval(e, t);
  }
  clearInterval(e) {
    K(this, Hd).clearInterval(e);
  }
}, Hd = new WeakMap(), Wy = new WeakMap(), vve), aR = new H$t();
function Q$t(e) {
  setTimeout(e, 0);
}
var lL = typeof window > "u" || "Deno" in globalThis;
function $$t() {
}
function Jpe(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function K$t(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function HE(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Mu(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function lR(e) {
  return JSON.stringify(
    e,
    (t, n) => K8(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
var G$t = Object.prototype.hasOwnProperty;
function Q8(e, t) {
  if (e === t)
    return e;
  const n = ehe(e) && ehe(t);
  if (!n && !(K8(e) && K8(t))) return t;
  const i = (n ? e : Object.keys(e)).length, o = n ? t : Object.keys(t), s = o.length, l = n ? new Array(s) : {};
  let c = 0;
  for (let a = 0; a < s; a++) {
    const u = n ? a : o[a], f = e[u], d = t[u];
    if (f === d) {
      l[u] = f, (n ? a < i : G$t.call(e, u)) && c++;
      continue;
    }
    if (f === null || d === null || typeof f != "object" || typeof d != "object") {
      l[u] = d;
      continue;
    }
    const p = Q8(f, d);
    l[u] = p, p === f && c++;
  }
  return i === s && c === i ? e : l;
}
function $8(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function ehe(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function K8(e) {
  if (!the(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!the(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function the(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function nhe(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Q8(e, t);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        ), r;
      }
    return Q8(e, t);
  }
  return t;
}
var Zy, wm, kA, bve, Y$t = (bve = class extends eJ {
  constructor() {
    super();
    tt(this, Zy);
    tt(this, wm);
    tt(this, kA);
    $e(this, kA, (t) => {
      if (!lL && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    K(this, wm) || this.setEventListener(K(this, kA));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = K(this, wm)) == null || t.call(this), $e(this, wm, void 0));
  }
  setEventListener(t) {
    var n;
    $e(this, kA, t), (n = K(this, wm)) == null || n.call(this), $e(this, wm, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    K(this, Zy) !== t && ($e(this, Zy, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof K(this, Zy) == "boolean" ? K(this, Zy) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, Zy = new WeakMap(), wm = new WeakMap(), kA = new WeakMap(), bve), J$t = new Y$t();
function rhe() {
  let e, t;
  const n = new Promise((i, o) => {
    e = i, t = o;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(i) {
    Object.assign(n, i), delete n.resolve, delete n.reject;
  }
  return n.resolve = (i) => {
    r({
      status: "fulfilled",
      value: i
    }), e(i);
  }, n.reject = (i) => {
    r({
      status: "rejected",
      reason: i
    }), t(i);
  }, n;
}
var eKt = Q$t;
function tKt() {
  let e = [], t = 0, n = (l) => {
    l();
  }, r = (l) => {
    l();
  }, i = eKt;
  const o = (l) => {
    t ? e.push(l) : i(() => {
      n(l);
    });
  }, s = () => {
    const l = e;
    e = [], l.length && i(() => {
      r(() => {
        l.forEach((c) => {
          n(c);
        });
      });
    });
  };
  return {
    batch: (l) => {
      let c;
      t++;
      try {
        c = l();
      } finally {
        t--, t || s();
      }
      return c;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (l) => (...c) => {
      o(() => {
        l(...c);
      });
    },
    schedule: o,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (l) => {
      n = l;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (l) => {
      r = l;
    },
    setScheduler: (l) => {
      i = l;
    }
  };
}
var nKt = tKt(), CA, xm, NA, Ove, rKt = (Ove = class extends eJ {
  constructor() {
    super();
    tt(this, CA, !0);
    tt(this, xm);
    tt(this, NA);
    $e(this, NA, (t) => {
      if (!lL && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    K(this, xm) || this.setEventListener(K(this, NA));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = K(this, xm)) == null || t.call(this), $e(this, xm, void 0));
  }
  setEventListener(t) {
    var n;
    $e(this, NA, t), (n = K(this, xm)) == null || n.call(this), $e(this, xm, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    K(this, CA) !== t && ($e(this, CA, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return K(this, CA);
  }
}, CA = new WeakMap(), xm = new WeakMap(), NA = new WeakMap(), Ove), iKt = new rKt();
function oKt(e) {
  return (e ?? "online") === "online" ? iKt.isOnline() : !0;
}
function sKt(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: oKt(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
var Ka, ar, Jk, ya, Hy, PA, Pp, Sm, eC, IA, RA, Qy, $y, Em, MA, Mr, E1, G8, Y8, J8, e7, t7, n7, r7, a6e, Ave, aKt = (Ave = class extends eJ {
  constructor(t, n) {
    super();
    tt(this, Mr);
    tt(this, Ka);
    tt(this, ar);
    tt(this, Jk);
    tt(this, ya);
    tt(this, Hy);
    tt(this, PA);
    tt(this, Pp);
    tt(this, Sm);
    tt(this, eC);
    tt(this, IA);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    tt(this, RA);
    tt(this, Qy);
    tt(this, $y);
    tt(this, Em);
    tt(this, MA, /* @__PURE__ */ new Set());
    this.options = n, $e(this, Ka, t), $e(this, Sm, null), $e(this, Pp, rhe()), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (K(this, ar).addObserver(this), ihe(K(this, ar), this.options) ? Dt(this, Mr, E1).call(this) : this.updateResult(), Dt(this, Mr, e7).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return i7(
      K(this, ar),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return i7(
      K(this, ar),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Dt(this, Mr, t7).call(this), Dt(this, Mr, n7).call(this), K(this, ar).removeObserver(this);
  }
  setOptions(t) {
    const n = this.options, r = K(this, ar);
    if (this.options = K(this, Ka).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Mu(this.options.enabled, K(this, ar)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    Dt(this, Mr, r7).call(this), K(this, ar).setOptions(this.options), n._defaulted && !$8(this.options, n) && K(this, Ka).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: K(this, ar),
      observer: this
    });
    const i = this.hasListeners();
    i && ohe(
      K(this, ar),
      r,
      this.options,
      n
    ) && Dt(this, Mr, E1).call(this), this.updateResult(), i && (K(this, ar) !== r || Mu(this.options.enabled, K(this, ar)) !== Mu(n.enabled, K(this, ar)) || HE(this.options.staleTime, K(this, ar)) !== HE(n.staleTime, K(this, ar))) && Dt(this, Mr, G8).call(this);
    const o = Dt(this, Mr, Y8).call(this);
    i && (K(this, ar) !== r || Mu(this.options.enabled, K(this, ar)) !== Mu(n.enabled, K(this, ar)) || o !== K(this, Em)) && Dt(this, Mr, J8).call(this, o);
  }
  getOptimisticResult(t) {
    const n = K(this, Ka).getQueryCache().build(K(this, Ka), t), r = this.createResult(n, t);
    return cKt(this, r) && ($e(this, ya, r), $e(this, PA, this.options), $e(this, Hy, K(this, ar).state)), r;
  }
  getCurrentResult() {
    return K(this, ya);
  }
  trackResult(t, n) {
    return new Proxy(t, {
      get: (r, i) => (this.trackProp(i), n == null || n(i), i === "promise" && !this.options.experimental_prefetchInRender && K(this, Pp).status === "pending" && K(this, Pp).reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      ), Reflect.get(r, i))
    });
  }
  trackProp(t) {
    K(this, MA).add(t);
  }
  getCurrentQuery() {
    return K(this, ar);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = K(this, Ka).defaultQueryOptions(t), r = K(this, Ka).getQueryCache().build(K(this, Ka), n);
    return r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return Dt(this, Mr, E1).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), K(this, ya)));
  }
  createResult(t, n) {
    var T;
    const r = K(this, ar), i = this.options, o = K(this, ya), s = K(this, Hy), l = K(this, PA), a = t !== r ? t.state : K(this, Jk), { state: u } = t;
    let f = { ...u }, d = !1, p;
    if (n._optimisticResults) {
      const R = this.hasListeners(), j = !R && ihe(t, n), F = R && ohe(t, r, n, i);
      (j || F) && (f = {
        ...f,
        ...sKt(u.data, t.options)
      }), n._optimisticResults === "isRestoring" && (f.fetchStatus = "idle");
    }
    let { error: h, errorUpdatedAt: m, status: v } = f;
    p = f.data;
    let b = !1;
    if (n.placeholderData !== void 0 && p === void 0 && v === "pending") {
      let R;
      o != null && o.isPlaceholderData && n.placeholderData === (l == null ? void 0 : l.placeholderData) ? (R = o.data, b = !0) : R = typeof n.placeholderData == "function" ? n.placeholderData(
        (T = K(this, RA)) == null ? void 0 : T.state.data,
        K(this, RA)
      ) : n.placeholderData, R !== void 0 && (v = "success", p = nhe(
        o == null ? void 0 : o.data,
        R,
        n
      ), d = !0);
    }
    if (n.select && p !== void 0 && !b)
      if (o && p === (s == null ? void 0 : s.data) && n.select === K(this, eC))
        p = K(this, IA);
      else
        try {
          $e(this, eC, n.select), p = n.select(p), p = nhe(o == null ? void 0 : o.data, p, n), $e(this, IA, p), $e(this, Sm, null);
        } catch (R) {
          $e(this, Sm, R);
        }
    K(this, Sm) && (h = K(this, Sm), p = K(this, IA), m = Date.now(), v = "error");
    const A = f.fetchStatus === "fetching", w = v === "pending", O = v === "error", x = w && A, S = p !== void 0, k = {
      status: v,
      fetchStatus: f.fetchStatus,
      isPending: w,
      isSuccess: v === "success",
      isError: O,
      isInitialLoading: x,
      isLoading: x,
      data: p,
      dataUpdatedAt: f.dataUpdatedAt,
      error: h,
      errorUpdatedAt: m,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > a.dataUpdateCount || f.errorUpdateCount > a.errorUpdateCount,
      isFetching: A,
      isRefetching: A && !w,
      isLoadingError: O && !S,
      isPaused: f.fetchStatus === "paused",
      isPlaceholderData: d,
      isRefetchError: O && S,
      isStale: tJ(t, n),
      refetch: this.refetch,
      promise: K(this, Pp),
      isEnabled: Mu(n.enabled, t) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const R = (L) => {
        k.status === "error" ? L.reject(k.error) : k.data !== void 0 && L.resolve(k.data);
      }, j = () => {
        const L = $e(this, Pp, k.promise = rhe());
        R(L);
      }, F = K(this, Pp);
      switch (F.status) {
        case "pending":
          t.queryHash === r.queryHash && R(F);
          break;
        case "fulfilled":
          (k.status === "error" || k.data !== F.value) && j();
          break;
        case "rejected":
          (k.status !== "error" || k.error !== F.reason) && j();
          break;
      }
    }
    return k;
  }
  updateResult() {
    const t = K(this, ya), n = this.createResult(K(this, ar), this.options);
    if ($e(this, Hy, K(this, ar).state), $e(this, PA, this.options), K(this, Hy).data !== void 0 && $e(this, RA, K(this, ar)), $8(n, t))
      return;
    $e(this, ya, n);
    const r = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: i } = this.options, o = typeof i == "function" ? i() : i;
      if (o === "all" || !o && !K(this, MA).size)
        return !0;
      const s = new Set(
        o ?? K(this, MA)
      );
      return this.options.throwOnError && s.add("error"), Object.keys(K(this, ya)).some((l) => {
        const c = l;
        return K(this, ya)[c] !== t[c] && s.has(c);
      });
    };
    Dt(this, Mr, a6e).call(this, { listeners: r() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Dt(this, Mr, e7).call(this);
  }
}, Ka = new WeakMap(), ar = new WeakMap(), Jk = new WeakMap(), ya = new WeakMap(), Hy = new WeakMap(), PA = new WeakMap(), Pp = new WeakMap(), Sm = new WeakMap(), eC = new WeakMap(), IA = new WeakMap(), RA = new WeakMap(), Qy = new WeakMap(), $y = new WeakMap(), Em = new WeakMap(), MA = new WeakMap(), Mr = new WeakSet(), E1 = function(t) {
  Dt(this, Mr, r7).call(this);
  let n = K(this, ar).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch($$t)), n;
}, G8 = function() {
  Dt(this, Mr, t7).call(this);
  const t = HE(
    this.options.staleTime,
    K(this, ar)
  );
  if (lL || K(this, ya).isStale || !Jpe(t))
    return;
  const r = K$t(K(this, ya).dataUpdatedAt, t) + 1;
  $e(this, Qy, aR.setTimeout(() => {
    K(this, ya).isStale || this.updateResult();
  }, r));
}, Y8 = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(K(this, ar)) : this.options.refetchInterval) ?? !1;
}, J8 = function(t) {
  Dt(this, Mr, n7).call(this), $e(this, Em, t), !(lL || Mu(this.options.enabled, K(this, ar)) === !1 || !Jpe(K(this, Em)) || K(this, Em) === 0) && $e(this, $y, aR.setInterval(() => {
    (this.options.refetchIntervalInBackground || J$t.isFocused()) && Dt(this, Mr, E1).call(this);
  }, K(this, Em)));
}, e7 = function() {
  Dt(this, Mr, G8).call(this), Dt(this, Mr, J8).call(this, Dt(this, Mr, Y8).call(this));
}, t7 = function() {
  K(this, Qy) && (aR.clearTimeout(K(this, Qy)), $e(this, Qy, void 0));
}, n7 = function() {
  K(this, $y) && (aR.clearInterval(K(this, $y)), $e(this, $y, void 0));
}, r7 = function() {
  const t = K(this, Ka).getQueryCache().build(K(this, Ka), this.options);
  if (t === K(this, ar))
    return;
  const n = K(this, ar);
  $e(this, ar, t), $e(this, Jk, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, a6e = function(t) {
  nKt.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(K(this, ya));
    }), K(this, Ka).getQueryCache().notify({
      query: K(this, ar),
      type: "observerResultsUpdated"
    });
  });
}, Ave);
function lKt(e, t) {
  return Mu(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function ihe(e, t) {
  return lKt(e, t) || e.state.data !== void 0 && i7(e, t, t.refetchOnMount);
}
function i7(e, t, n) {
  if (Mu(t.enabled, e) !== !1 && HE(t.staleTime, e) !== "static") {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && tJ(e, t);
  }
  return !1;
}
function ohe(e, t, n, r) {
  return (e !== t || Mu(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && tJ(e, n);
}
function tJ(e, t) {
  return Mu(t.enabled, e) !== !1 && e.isStaleByTime(HE(t.staleTime, e));
}
function cKt(e, t) {
  return !$8(e.getCurrentResult(), t);
}
class jx {
}
class Rw extends jx {
  constructor(t, n) {
    super(), this.collection = t, this.alias = n, this.type = "collectionRef";
  }
}
class qc extends jx {
  constructor(t, n) {
    super(), this.query = t, this.alias = n, this.type = "queryRef";
  }
}
class Ma extends jx {
  constructor(t) {
    super(), this.path = t, this.type = "ref";
  }
}
class pl extends jx {
  constructor(t) {
    super(), this.value = t, this.type = "val";
  }
}
class bu extends jx {
  constructor(t, n) {
    super(), this.name = t, this.args = n, this.type = "func";
  }
}
class l6e extends jx {
  constructor(t, n) {
    super(), this.name = t, this.args = n, this.type = "agg";
  }
}
function Dk(e) {
  return e instanceof l6e || e instanceof bu || e instanceof Ma || e instanceof pl;
}
function nJ(e) {
  return typeof e == "object" && "expression" in e ? e.expression : e;
}
function she(e) {
  return typeof e == "object" && "expression" in e ? e.expression : e;
}
function ahe(e) {
  return typeof e == "object" && "expression" in e && e.residual === !0;
}
function uKt(e) {
  return { expression: e, residual: !0 };
}
function dKt(e, t) {
  if (e.from.alias === t)
    return e.from;
  for (const n of e.join || [])
    if (n.from.alias === t)
      return n.from;
}
function _k(e, t, n) {
  if (t.path.length !== 0) {
    if (t.path.length === 1) {
      const r = t.path[0];
      if (e.select) {
        const i = e.select[r];
        if (i && i.type === "ref")
          return _k(e, i, n);
      }
      return { collection: n, path: [r] };
    }
    if (t.path.length > 1) {
      const [r, ...i] = t.path, o = dKt(e, r);
      return o ? o.type === "queryRef" ? _k(o.query, new Ma(i), n) : { collection: o.collection, path: i } : void 0;
    }
  }
}
class vc extends Error {
  constructor(t) {
    super(t), this.name = "TanStackDBError";
  }
}
class lhe extends vc {
  constructor(t, n, r) {
    const i = `${t === "insert" ? "Insert" : "Update"} validation failed: ${n.map((o) => `
- ${o.message} - path: ${o.path}`).join("")}`;
    super(r || i), this.name = "SchemaValidationError", this.type = t, this.issues = n;
  }
}
class ZN extends vc {
  constructor(t) {
    super(t), this.name = "CollectionConfigurationError";
  }
}
class fKt extends ZN {
  constructor() {
    super("Collection requires a config");
  }
}
class pKt extends ZN {
  constructor() {
    super("Collection requires a sync config");
  }
}
class hKt extends ZN {
  constructor() {
    super("Schema must implement the standard-schema interface");
  }
}
class che extends ZN {
  constructor() {
    super("Schema validation must be synchronous");
  }
}
class HN extends vc {
  constructor(t) {
    super(t), this.name = "CollectionStateError";
  }
}
class mKt extends HN {
  constructor(t, n) {
    super(
      `Cannot perform ${t} on collection "${n}" - collection is in error state. Try calling cleanup() and restarting the collection.`
    );
  }
}
class gKt extends HN {
  constructor(t, n, r) {
    super(
      `Invalid collection status transition from "${t}" to "${n}" for collection "${r}"`
    );
  }
}
class yKt extends HN {
  constructor() {
    super("Collection is in error state");
  }
}
class vKt extends HN {
  constructor() {
    super("Active subscribers count is negative - this should never happen");
  }
}
class Wf extends vc {
  constructor(t) {
    super(t), this.name = "CollectionOperationError";
  }
}
class bKt extends Wf {
  constructor(t) {
    super(
      `An object was created without a defined key: ${JSON.stringify(t)}`
    );
  }
}
class OKt extends Wf {
  constructor(t, n) {
    const r = t === null ? "null" : typeof t;
    super(
      `getKey returned an invalid key type. Expected string or number, but got ${r}: ${JSON.stringify(t)}. Item: ${JSON.stringify(n)}`
    );
  }
}
class AKt extends Wf {
  constructor(t) {
    super(
      `Cannot insert document with ID "${t}" because it already exists in the collection`
    );
  }
}
class wKt extends Wf {
  constructor(t, n, r) {
    const i = `Cannot insert document with key "${t}" from sync because it already exists in the collection "${n}"`;
    r != null && r.hasCustomGetKey && r.hasJoins ? super(
      `${i}. This collection uses a custom getKey with joined queries. Joined queries can produce multiple rows with the same key when relationships are not 1:1. Consider: (1) using a composite key in your getKey function (e.g., \`\${item.key1}-\${item.key2}\`), (2) ensuring your join produces unique rows per key, or (3) removing the custom getKey to use the default composite key behavior.`
    ) : super(i);
  }
}
class xKt extends Wf {
  constructor() {
    super("The first argument to update is missing");
  }
}
class SKt extends Wf {
  constructor() {
    super("No keys were passed to update");
  }
}
class EKt extends Wf {
  constructor(t) {
    super(
      `The key "${t}" was passed to update but an object for this key was not found in the collection`
    );
  }
}
class TKt extends Wf {
  constructor(t, n) {
    super(
      `Updating the key of an item is not allowed. Original key: "${t}", Attempted new key: "${n}". Please delete the old item and create a new one if a key change is necessary.`
    );
  }
}
class kKt extends Wf {
  constructor() {
    super("No keys were passed to delete");
  }
}
class CKt extends Wf {
  constructor(t) {
    super(
      `Collection.delete was called with key '${t}' but there is no item in the collection with this key`
    );
  }
}
class rJ extends vc {
  constructor(t) {
    super(t), this.name = "MissingHandlerError";
  }
}
class NKt extends rJ {
  constructor() {
    super(
      "Collection.insert called directly (not within an explicit transaction) but no 'onInsert' handler is configured."
    );
  }
}
class PKt extends rJ {
  constructor() {
    super(
      "Collection.update called directly (not within an explicit transaction) but no 'onUpdate' handler is configured."
    );
  }
}
class IKt extends rJ {
  constructor() {
    super(
      "Collection.delete called directly (not within an explicit transaction) but no 'onDelete' handler is configured."
    );
  }
}
class Bg extends vc {
  constructor(t) {
    super(t), this.name = "TransactionError";
  }
}
class RKt extends Bg {
  constructor() {
    super("mutationFn is required when creating a transaction");
  }
}
class MKt extends Bg {
  constructor() {
    super(
      "You can no longer call .mutate() as the transaction is no longer pending"
    );
  }
}
class DKt extends Bg {
  constructor() {
    super(
      "You can no longer call .rollback() as the transaction is already completed"
    );
  }
}
class _Kt extends Bg {
  constructor() {
    super(
      "You can no longer call .commit() as the transaction is no longer pending"
    );
  }
}
class uhe extends Bg {
  constructor() {
    super("No pending sync transaction to write to");
  }
}
class dhe extends Bg {
  constructor() {
    super(
      "The pending sync transaction is already committed, you can't still write to it."
    );
  }
}
class LKt extends Bg {
  constructor() {
    super("No pending sync transaction to commit");
  }
}
class zKt extends Bg {
  constructor() {
    super(
      "The pending sync transaction is already committed, you can't commit it again."
    );
  }
}
class zb extends vc {
  constructor(t) {
    super(t), this.name = "QueryBuilderError";
  }
}
class jKt extends zb {
  constructor(t) {
    super(`Only one source is allowed in the ${t}`);
  }
}
class FKt extends zb {
  constructor(t) {
    super(`A sub query passed to a ${t} must have a from clause itself`);
  }
}
class UKt extends zb {
  constructor(t) {
    super(
      `Invalid source for live query: The value provided for alias "${t}" is not a Collection or subquery. Live queries only accept Collection instances or subqueries. Please ensure you're passing a valid Collection or QueryBuilder, not a plain array or other data type.`
    );
  }
}
class cR extends zb {
  constructor(t, n) {
    super(
      `Invalid source for ${t}: Expected an object with a single key-value pair like { alias: collection }. For example: .from({ todos: todosCollection }). Got: ${n}`
    );
  }
}
class VKt extends zb {
  constructor() {
    super("Join condition must be an equality expression");
  }
}
class qKt extends zb {
  constructor() {
    super("Query must have a from clause");
  }
}
class fhe extends zb {
  constructor(t) {
    super(
      `Invalid where() expression: Expected a query expression, but received a ${t}. This usually happens when using JavaScript's comparison operators (===, !==, <, >, etc.) directly. Instead, use the query builder functions:

  ❌ .where(({ user }) => user.id === 'abc')
  ✅ .where(({ user }) => eq(user.id, 'abc'))

Available comparison functions: eq, gt, gte, lt, lte, and, or, not, like, ilike, isNull, isUndefined`
    );
  }
}
class bc extends vc {
  constructor(t) {
    super(t), this.name = "QueryCompilationError";
  }
}
class BKt extends bc {
  constructor() {
    super("DISTINCT requires a SELECT clause.");
  }
}
class XKt extends bc {
  constructor() {
    super("HAVING clause requires GROUP BY clause");
  }
}
class WKt extends bc {
  constructor() {
    super(
      "LIMIT and OFFSET require an ORDER BY clause to ensure deterministic results"
    );
  }
}
class c6e extends bc {
  constructor(t, n, r) {
    const i = n ? `alias "${t}" (collection "${n}")` : `collection "${t}"`, o = r != null && r.length ? `. Available keys: ${r.join(", ")}` : "";
    super(`Input for ${i} not found in inputs map${o}`);
  }
}
class ZKt extends bc {
  constructor(t, n) {
    super(
      `Subquery uses alias "${t}" which is already used in the parent query. Each alias must be unique across parent and subquery contexts. Parent query aliases: ${n.join(", ")}. Please rename "${t}" in either the parent query or subquery to avoid conflicts.`
    );
  }
}
class HKt extends bc {
  constructor(t) {
    super(`Unsupported FROM type: ${t}`);
  }
}
class QKt extends bc {
  constructor(t) {
    super(`Unknown expression type: ${t}`);
  }
}
class $Kt extends bc {
  constructor() {
    super("Reference path cannot be empty");
  }
}
class KKt extends bc {
  constructor(t) {
    super(`Unknown function: ${t}`);
  }
}
class phe extends bc {
  constructor(t) {
    super(`Collection "${t}" not found during compilation of join`);
  }
}
class jb extends vc {
  constructor(t) {
    super(t), this.name = "JoinError";
  }
}
class GKt extends jb {
  constructor(t) {
    super(`Unsupported join type: ${t}`);
  }
}
class YKt extends jb {
  constructor(t) {
    super(
      `Invalid join condition: both expressions refer to the same source "${t}"`
    );
  }
}
class JKt extends jb {
  constructor() {
    super("Invalid join condition: expressions must reference source aliases");
  }
}
class eGt extends jb {
  constructor(t) {
    super(
      `Invalid join condition: left expression refers to an unavailable source "${t}"`
    );
  }
}
class tGt extends jb {
  constructor(t) {
    super(
      `Invalid join condition: right expression does not refer to the joined source "${t}"`
    );
  }
}
class nGt extends jb {
  constructor() {
    super("Invalid join condition");
  }
}
class rGt extends jb {
  constructor(t) {
    super(`Unsupported join source type: ${t}`);
  }
}
class E3 extends vc {
  constructor(t) {
    super(t), this.name = "GroupByError";
  }
}
class iGt extends E3 {
  constructor(t) {
    super(
      `Non-aggregate expression '${t}' in SELECT must also appear in GROUP BY clause`
    );
  }
}
class oGt extends E3 {
  constructor(t) {
    super(`Unsupported aggregate function: ${t}`);
  }
}
class sGt extends E3 {
  constructor(t) {
    super(
      `Aggregate function in HAVING clause must also be in SELECT clause: ${t}`
    );
  }
}
class aGt extends E3 {
  constructor(t) {
    super(`Unknown expression type in HAVING clause: ${t}`);
  }
}
class hhe extends vc {
  constructor(t, n) {
    const r = n instanceof Error ? n.message : String(n);
    super(
      `Collection "${t}" sync cleanup function threw an error: ${r}`
    ), this.name = "SyncCleanupError";
  }
}
class lGt extends vc {
  constructor(t) {
    super(t), this.name = "QueryOptimizerError";
  }
}
class cGt extends lGt {
  constructor() {
    super("Cannot combine empty expression list");
  }
}
class uGt extends bc {
  constructor(t, n, r, i) {
    super(
      `Internal error: subscription for alias '${t}' (remapped from '${n}', collection '${r}') is missing in join pipeline. Available aliases: ${i.join(", ")}. This indicates a bug in alias tracking.`
    );
  }
}
class dGt extends bc {
  constructor(t) {
    super(
      `Internal error: compiler returned aliases without inputs: ${t.join(", ")}. This indicates a bug in query compilation. Please report this issue.`
    );
  }
}
class fGt extends bc {
  constructor() {
    super(
      "setWindow() can only be called on collections with an ORDER BY clause. Add .orderBy() to your query to enable window movement."
    );
  }
}
const IV = /* @__PURE__ */ new WeakMap();
let pGt = 1;
function mhe(e) {
  if (IV.has(e))
    return IV.get(e);
  const t = pGt++;
  return IV.set(e, t), t;
}
const iJ = (e, t, n) => {
  const { nulls: r } = n;
  if (e == null && t == null) return 0;
  if (e == null) return r === "first" ? -1 : 1;
  if (t == null) return r === "first" ? 1 : -1;
  if (typeof e == "string" && typeof t == "string" && n.stringSort === "locale")
    return e.localeCompare(t, n.locale, n.localeOptions);
  if (Array.isArray(e) && Array.isArray(t)) {
    for (let s = 0; s < Math.min(e.length, t.length); s++) {
      const l = iJ(e[s], t[s], n);
      if (l !== 0)
        return l;
    }
    return e.length - t.length;
  }
  if (e instanceof Date && t instanceof Date)
    return e.getTime() - t.getTime();
  const i = typeof e == "object", o = typeof t == "object";
  if (i || o) {
    if (i && o) {
      const s = mhe(e), l = mhe(t);
      return s - l;
    }
    if (i) return 1;
    if (o) return -1;
  }
  return e < t ? -1 : e > t ? 1 : 0;
}, hGt = (e, t, n) => iJ(t, e, {
  ...n,
  nulls: n.nulls === "first" ? "last" : "first"
});
function cL(e) {
  return (t, n) => e.direction === "asc" ? iJ(t, n, e) : hGt(t, n, e);
}
const o7 = cL({
  direction: "asc",
  nulls: "first",
  stringSort: "locale"
});
function mGt(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  for (let n = 0; n < e.byteLength; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const gGt = 128;
function Ep(e) {
  return e instanceof Date ? e.getTime() : (typeof Buffer < "u" && e instanceof Buffer || e instanceof Uint8Array) && e.byteLength <= gGt ? `__u8__${Array.from(e).join(",")}` : e;
}
function yGt(e, t) {
  if (e === t)
    return !0;
  const n = typeof Buffer < "u" && e instanceof Buffer || e instanceof Uint8Array, r = typeof Buffer < "u" && t instanceof Buffer || t instanceof Uint8Array;
  return n && r ? mGt(e, t) : !1;
}
function Bo(e) {
  return e == null;
}
function lA(e) {
  return e === !0;
}
function hl(e, t = !1) {
  return sJ(e, t);
}
function oJ(e) {
  return sJ(e, !0);
}
function sJ(e, t) {
  switch (e.type) {
    case "val": {
      const n = e.value;
      return () => n;
    }
    case "ref":
      return t ? bGt(e) : vGt(e);
    case "func":
      return OGt(e, t);
    default:
      throw new QKt(e.type);
  }
}
function vGt(e) {
  const [t, ...n] = e.path;
  if (!t)
    throw new $Kt();
  if (t === "$selected") {
    if (n.length === 0)
      return (i) => i.$selected;
    if (n.length === 1) {
      const i = n[0];
      return (o) => {
        const s = o.$selected;
        return s == null ? void 0 : s[i];
      };
    } else
      return (i) => {
        const o = i.$selected;
        if (o === void 0)
          return;
        let s = o;
        for (const l of n) {
          if (s == null)
            return s;
          s = s[l];
        }
        return s;
      };
  }
  const r = t;
  if (n.length === 0)
    return (i) => i[r];
  if (n.length === 1) {
    const i = n[0];
    return (o) => {
      const s = o[r];
      return s == null ? void 0 : s[i];
    };
  } else
    return (i) => {
      const o = i[r];
      if (o === void 0)
        return;
      let s = o;
      for (const l of n) {
        if (s == null)
          return s;
        s = s[l];
      }
      return s;
    };
}
function bGt(e) {
  const t = e.path;
  return (n) => {
    let r = n;
    for (const i of t) {
      if (r == null)
        return r;
      r = r[i];
    }
    return r;
  };
}
function OGt(e, t) {
  const n = e.args.map(
    (r) => sJ(r, t)
  );
  switch (e.name) {
    // Comparison operators
    case "eq": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = Ep(r(o)), l = Ep(i(o));
        return Bo(s) || Bo(l) ? null : yGt(s, l);
      };
    }
    case "gt": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : s > l;
      };
    }
    case "gte": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : s >= l;
      };
    }
    case "lt": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : s < l;
      };
    }
    case "lte": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : s <= l;
      };
    }
    // Boolean operators
    case "and":
      return (r) => {
        let i = !1;
        for (const o of n) {
          const s = o(r);
          if (s === !1)
            return !1;
          Bo(s) && (i = !0);
        }
        return i ? null : !0;
      };
    case "or":
      return (r) => {
        let i = !1;
        for (const o of n) {
          const s = o(r);
          if (s === !0)
            return !0;
          Bo(s) && (i = !0);
        }
        return i ? null : !1;
      };
    case "not": {
      const r = n[0];
      return (i) => {
        const o = r(i);
        return Bo(o) ? null : !o;
      };
    }
    // Array operators
    case "in": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) ? null : Array.isArray(l) ? l.includes(s) : !1;
      };
    }
    // String operators
    case "like": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : ghe(s, l, !1);
      };
    }
    case "ilike": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return Bo(s) || Bo(l) ? null : ghe(s, l, !0);
      };
    }
    // String functions
    case "upper": {
      const r = n[0];
      return (i) => {
        const o = r(i);
        return typeof o == "string" ? o.toUpperCase() : o;
      };
    }
    case "lower": {
      const r = n[0];
      return (i) => {
        const o = r(i);
        return typeof o == "string" ? o.toLowerCase() : o;
      };
    }
    case "length": {
      const r = n[0];
      return (i) => {
        const o = r(i);
        return typeof o == "string" || Array.isArray(o) ? o.length : 0;
      };
    }
    case "concat":
      return (r) => n.map((i) => {
        const o = i(r);
        try {
          return String(o ?? "");
        } catch {
          try {
            return JSON.stringify(o) || "";
          } catch {
            return "[object]";
          }
        }
      }).join("");
    case "coalesce":
      return (r) => {
        for (const i of n) {
          const o = i(r);
          if (o != null)
            return o;
        }
        return null;
      };
    // Math functions
    case "add": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return (s ?? 0) + (l ?? 0);
      };
    }
    case "subtract": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return (s ?? 0) - (l ?? 0);
      };
    }
    case "multiply": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), l = i(o);
        return (s ?? 0) * (l ?? 0);
      };
    }
    case "divide": {
      const r = n[0], i = n[1];
      return (o) => {
        const s = r(o), c = i(o) ?? 0;
        return c !== 0 ? (s ?? 0) / c : null;
      };
    }
    // Null/undefined checking functions
    case "isUndefined": {
      const r = n[0];
      return (i) => r(i) === void 0;
    }
    case "isNull": {
      const r = n[0];
      return (i) => r(i) === null;
    }
    default:
      throw new KKt(e.name);
  }
}
function ghe(e, t, n) {
  if (typeof e != "string" || typeof t != "string")
    return !1;
  const r = n ? e.toLowerCase() : e;
  let o = (n ? t.toLowerCase() : t).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return o = o.replace(/%/g, ".*"), o = o.replace(/_/g, "."), new RegExp(`^${o}$`).test(r);
}
function Xu(e, t) {
  return SM(e, t, /* @__PURE__ */ new Map());
}
function SM(e, t, n) {
  if (e === t) return !0;
  if (e == null || t == null || typeof e != typeof t) return !1;
  if (e instanceof Date)
    return t instanceof Date ? e.getTime() === t.getTime() : !1;
  if (t instanceof Date) return !1;
  if (e instanceof RegExp)
    return t instanceof RegExp ? e.source === t.source && e.flags === t.flags : !1;
  if (t instanceof RegExp) return !1;
  if (e instanceof Map) {
    if (!(t instanceof Map) || e.size !== t.size) return !1;
    if (n.has(e))
      return n.get(e) === t;
    n.set(e, t);
    const i = Array.from(e.entries()).every(([o, s]) => t.has(o) && SM(s, t.get(o), n));
    return n.delete(e), i;
  }
  if (t instanceof Map) return !1;
  if (e instanceof Set) {
    if (!(t instanceof Set) || e.size !== t.size) return !1;
    if (n.has(e))
      return n.get(e) === t;
    n.set(e, t);
    const r = Array.from(e), i = Array.from(t);
    if (r.every((s) => typeof s != "object"))
      return n.delete(e), r.every((s) => t.has(s));
    const o = r.length === i.length;
    return n.delete(e), o;
  }
  if (t instanceof Set) return !1;
  if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t) && !(e instanceof DataView) && !(t instanceof DataView)) {
    const r = e, i = t;
    if (r.length !== i.length) return !1;
    for (let o = 0; o < r.length; o++)
      if (r[o] !== i[o]) return !1;
    return !0;
  }
  if (ArrayBuffer.isView(t) && !(t instanceof DataView) && !ArrayBuffer.isView(e))
    return !1;
  if (QE(e) && QE(t)) {
    const r = s7(e), i = s7(t);
    return r !== i ? !1 : typeof e.equals == "function" ? e.equals(t) : e.toString() === t.toString();
  }
  if (QE(t)) return !1;
  if (Array.isArray(e)) {
    if (!Array.isArray(t) || e.length !== t.length) return !1;
    if (n.has(e))
      return n.get(e) === t;
    n.set(e, t);
    const r = e.every(
      (i, o) => SM(i, t[o], n)
    );
    return n.delete(e), r;
  }
  if (Array.isArray(t)) return !1;
  if (typeof e == "object") {
    if (n.has(e))
      return n.get(e) === t;
    n.set(e, t);
    const r = Object.keys(e), i = Object.keys(t);
    if (r.length !== i.length)
      return n.delete(e), !1;
    const o = r.every(
      (s) => s in t && SM(e[s], t[s], n)
    );
    return n.delete(e), o;
  }
  return !1;
}
const AGt = [
  "Temporal.Duration",
  "Temporal.Instant",
  "Temporal.PlainDate",
  "Temporal.PlainDateTime",
  "Temporal.PlainMonthDay",
  "Temporal.PlainTime",
  "Temporal.PlainYearMonth",
  "Temporal.ZonedDateTime"
];
function s7(e) {
  return e[Symbol.toStringTag];
}
function QE(e) {
  const t = s7(e);
  return typeof t == "string" && AGt.includes(t);
}
const aJ = {
  direction: "asc",
  nulls: "first",
  stringSort: "locale"
};
class wGt {
  constructor(t) {
    this.originalIndex = t;
  }
  // Define the reversed operations
  lookup(t, n) {
    const r = t === "gt" ? "lt" : t === "gte" ? "lte" : t === "lt" ? "gt" : t === "lte" ? "gte" : t;
    return this.originalIndex.lookup(r, n);
  }
  rangeQuery(t = {}) {
    return this.originalIndex.rangeQueryReversed(t);
  }
  rangeQueryReversed(t = {}) {
    return this.originalIndex.rangeQuery(t);
  }
  take(t, n, r) {
    return this.originalIndex.takeReversed(t, n, r);
  }
  takeReversed(t, n, r) {
    return this.originalIndex.take(t, n, r);
  }
  get orderedEntriesArray() {
    return this.originalIndex.orderedEntriesArrayReversed;
  }
  get orderedEntriesArrayReversed() {
    return this.originalIndex.orderedEntriesArray;
  }
  // All operations below delegate to the original index
  supports(t) {
    return this.originalIndex.supports(t);
  }
  matchesField(t) {
    return this.originalIndex.matchesField(t);
  }
  matchesCompareOptions(t) {
    return this.originalIndex.matchesCompareOptions(t);
  }
  matchesDirection(t) {
    return this.originalIndex.matchesDirection(t);
  }
  getStats() {
    return this.originalIndex.getStats();
  }
  add(t, n) {
    this.originalIndex.add(t, n);
  }
  remove(t, n) {
    this.originalIndex.remove(t, n);
  }
  update(t, n, r) {
    this.originalIndex.update(t, n, r);
  }
  build(t) {
    this.originalIndex.build(t);
  }
  clear() {
    this.originalIndex.clear();
  }
  get keyCount() {
    return this.originalIndex.keyCount;
  }
  equalityLookup(t) {
    return this.originalIndex.equalityLookup(t);
  }
  inArrayLookup(t) {
    return this.originalIndex.inArrayLookup(t);
  }
  get indexedKeysSet() {
    return this.originalIndex.indexedKeysSet;
  }
  get valueMapData() {
    return this.originalIndex.valueMapData;
  }
}
function QN(e, t, n) {
  const r = n ?? {
    ...aJ,
    ...e.compareOptions
  };
  for (const i of e.indexes.values())
    if (i.matchesField(t) && i.matchesCompareOptions(r))
      return i.matchesDirection(r.direction) ? i : new wGt(i);
}
function xGt(e) {
  if (e.length === 0) return /* @__PURE__ */ new Set();
  if (e.length === 1) return new Set(e[0]);
  let t = new Set(e[0]);
  for (let n = 1; n < e.length; n++) {
    const r = /* @__PURE__ */ new Set();
    for (const i of t)
      e[n].has(i) && r.add(i);
    t = r;
  }
  return t;
}
function SGt(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of n)
      t.add(r);
  return t;
}
function EGt(e, t) {
  return lJ(e, t);
}
function lJ(e, t) {
  if (e.type === "func")
    switch (e.name) {
      case "eq":
      case "gt":
      case "gte":
      case "lt":
      case "lte":
        return kGt(e, t);
      case "and":
        return CGt(e, t);
      case "or":
        return NGt(e, t);
      case "in":
        return PGt(e, t);
    }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
function TGt(e, t) {
  if (e.type !== "func" || e.args.length < 2)
    return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
  const n = /* @__PURE__ */ new Map();
  for (const r of e.args)
    if (r.type === "func" && ["gt", "gte", "lt", "lte"].includes(r.name)) {
      const i = r;
      if (i.args.length === 2) {
        const o = i.args[0], s = i.args[1];
        let l = null, c = null, a = i.name;
        if (o.type === "ref" && s.type === "val")
          l = o, c = s;
        else if (o.type === "val" && s.type === "ref")
          switch (l = s, c = o, a) {
            case "gt":
              a = "lt";
              break;
            case "gte":
              a = "lte";
              break;
            case "lt":
              a = "gt";
              break;
            case "lte":
              a = "gte";
              break;
          }
        if (l && c) {
          const f = l.path.join("."), d = c.value;
          n.has(f) || n.set(f, []), n.get(f).push({ operation: a, value: d });
        }
      }
    }
  for (const [r, i] of n)
    if (i.length >= 2) {
      const o = r.split("."), s = QN(t, o);
      if (s && s.supports("gt") && s.supports("lt")) {
        let l, c, a = !0, u = !0;
        for (const { operation: d, value: p } of i)
          switch (d) {
            case "gt":
              (l === void 0 || p > l) && (l = p, a = !1);
              break;
            case "gte":
              (l === void 0 || p > l) && (l = p, a = !0);
              break;
            case "lt":
              (c === void 0 || p < c) && (c = p, u = !1);
              break;
            case "lte":
              (c === void 0 || p < c) && (c = p, u = !0);
              break;
          }
        return { canOptimize: !0, matchingKeys: s.rangeQuery({
          from: l,
          to: c,
          fromInclusive: a,
          toInclusive: u
        }) };
      }
    }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
function kGt(e, t) {
  if (e.type !== "func" || e.args.length !== 2)
    return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
  const n = e.args[0], r = e.args[1];
  let i = null, o = null, s = e.name;
  if (n.type === "ref" && r.type === "val")
    i = n, o = r;
  else if (n.type === "val" && r.type === "ref")
    switch (i = r, o = n, s) {
      case "gt":
        s = "lt";
        break;
      case "gte":
        s = "lte";
        break;
      case "lt":
        s = "gt";
        break;
      case "lte":
        s = "gte";
        break;
    }
  if (i && o) {
    const l = i.path, c = QN(t, l);
    if (c) {
      const a = o.value, u = s;
      return c.supports(u) ? { canOptimize: !0, matchingKeys: c.lookup(u, a) } : { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
    }
  }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
function CGt(e, t) {
  if (e.type !== "func" || e.args.length < 2)
    return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
  const n = TGt(e, t);
  if (n.canOptimize)
    return n;
  const r = [];
  for (const i of e.args) {
    const o = lJ(i, t);
    o.canOptimize && r.push(o);
  }
  if (r.length > 0) {
    const i = r.map((s) => s.matchingKeys);
    return { canOptimize: !0, matchingKeys: xGt(i) };
  }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
function NGt(e, t) {
  if (e.type !== "func" || e.args.length < 2)
    return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
  const n = [];
  for (const r of e.args) {
    const i = lJ(r, t);
    i.canOptimize && n.push(i);
  }
  if (n.length > 0) {
    const r = n.map((o) => o.matchingKeys);
    return { canOptimize: !0, matchingKeys: SGt(r) };
  }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
function PGt(e, t) {
  if (e.type !== "func" || e.args.length !== 2)
    return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
  const n = e.args[0], r = e.args[1];
  if (n.type === "ref" && r.type === "val" && Array.isArray(r.value)) {
    const i = n.path, o = r.value, s = QN(t, i);
    if (s) {
      if (s.supports("in"))
        return { canOptimize: !0, matchingKeys: s.lookup("in", o) };
      if (s.supports("eq")) {
        const l = /* @__PURE__ */ new Set();
        for (const c of o) {
          const a = s.lookup("eq", c);
          for (const u of a)
            l.add(u);
        }
        return { canOptimize: !0, matchingKeys: l };
      }
    }
  }
  return { canOptimize: !1, matchingKeys: /* @__PURE__ */ new Set() };
}
class IGt extends Map {
  constructor(t, n) {
    super(n), this.defaultValue = t;
  }
  get(t) {
    return this.has(t) ? super.get(t) : this.defaultValue();
  }
  /**
   * Update the value for a key using a function.
   */
  update(t, n) {
    const r = this.get(t), i = n(r);
    return this.set(t, i), i;
  }
}
const RV = 3e4;
function MV(e, t) {
  if (t.length <= RV)
    e.push(...t);
  else
    for (let n = 0; n < t.length; n += RV) {
      const r = t.slice(n, n + RV);
      e.push(...r);
    }
}
function RGt(e, t, n) {
  let r = 0, i = e.length;
  for (; r < i; ) {
    const o = Math.floor((r + i) / 2), s = n(e[o], t);
    if (s < 0)
      r = o + 1;
    else if (s > 0)
      i = o;
    else
      return o;
  }
  return r;
}
class MGt {
  constructor() {
    this.objectIds = /* @__PURE__ */ new WeakMap(), this.nextId = 0;
  }
  /**
   * Get a unique identifier for any value.
   * - Objects: Uses WeakMap for reference-based identity
   * - Primitives: Uses consistent string-based hashing
   */
  getId(t) {
    if (typeof t != "object" || t === null) {
      const n = String(t);
      let r = 0;
      for (let i = 0; i < n.length; i++) {
        const o = n.charCodeAt(i);
        r = (r << 5) - r + o, r = r & r;
      }
      return r;
    }
    return this.objectIds.has(t) || this.objectIds.set(t, this.nextId++), this.objectIds.get(t);
  }
  /**
   * Get a string representation of the ID for use in composite keys.
   */
  getStringId(t) {
    return t === null ? "null" : t === void 0 ? "undefined" : typeof t != "object" ? `str_${String(t)}` : `obj_${this.getId(t)}`;
  }
}
const DV = new MGt();
function DGt(e, t) {
  const [n, r] = e, [i, o] = t, s = [
    ...uR(n, Math.min(r, i)),
    // left side of A outside B
    ...uR(Math.max(n, o), r)
    // right side of A outside B
  ], l = [
    ...uR(i, Math.min(o, n)),
    ...uR(Math.max(i, r), o)
  ];
  return { onlyInA: s, onlyInB: l };
}
function uR(e, t) {
  const n = [];
  for (let r = e; r < t; r++) n.push(r);
  return n;
}
function uL(e, t) {
  return typeof e == typeof t ? e < t ? -1 : e > t ? 1 : 0 : typeof e == "string" ? -1 : 1;
}
function u6e(e) {
  return JSON.stringify(e, (t, n) => typeof n == "bigint" ? n.toString() : n instanceof Date ? n.toISOString() : n);
}
const _Gt = Ls(), LGt = Ls(), zGt = Ls(), jGt = Ls(), FGt = Ls();
function Ls() {
  return Math.random() * (2 ** 31 - 1) >>> 0;
}
const d6e = new ArrayBuffer(8), UGt = new DataView(d6e), qh = new Uint8Array(d6e);
class T3 {
  constructor() {
    this.hash = _Gt, this.length = 0, this.carry = 0, this.carryBytes = 0;
  }
  _mix(t) {
    t = Math.imul(t, 3432918353), t = t << 15 | t >>> 17, t = Math.imul(t, 461845907), this.hash ^= t, this.hash = this.hash << 13 | this.hash >>> 19, this.hash = Math.imul(this.hash, 5) + 3864292196;
  }
  writeByte(t) {
    this.carry |= (t & 255) << 8 * this.carryBytes, this.carryBytes++, this.length++, this.carryBytes === 4 && (this._mix(this.carry >>> 0), this.carry = 0, this.carryBytes = 0);
  }
  update(t) {
    switch (typeof t) {
      case "symbol": {
        this.update(FGt);
        const n = t.description;
        if (!n)
          return;
        for (let r = 0; r < n.length; r++) {
          const i = n.charCodeAt(r);
          this.writeByte(i & 255), this.writeByte(i >>> 8 & 255);
        }
        return;
      }
      case "string":
        this.update(LGt);
        for (let n = 0; n < t.length; n++) {
          const r = t.charCodeAt(n);
          this.writeByte(r & 255), this.writeByte(r >>> 8 & 255);
        }
        return;
      case "number":
        UGt.setFloat64(0, t, !0), this.writeByte(qh[0]), this.writeByte(qh[1]), this.writeByte(qh[2]), this.writeByte(qh[3]), this.writeByte(qh[4]), this.writeByte(qh[5]), this.writeByte(qh[6]), this.writeByte(qh[7]);
        return;
      case "bigint": {
        let n = t;
        for (n < 0n ? (n = -n, this.update(jGt)) : this.update(zGt); n > 0n; )
          this.writeByte(Number(n & 0xffn)), n >>= 8n;
        t === 0n && this.writeByte(0);
        return;
      }
      default:
        throw new TypeError(`Unsupported input type: ${typeof t}`);
    }
  }
  digest() {
    if (this.carryBytes > 0) {
      let t = this.carry >>> 0;
      t = Math.imul(t, 3432918353), t = t << 15 | t >>> 17, t = Math.imul(t, 461845907), this.hash ^= t;
    }
    return this.hash ^= this.length, this.hash ^= this.hash >>> 16, this.hash = Math.imul(this.hash, 2246822507), this.hash ^= this.hash >>> 13, this.hash = Math.imul(this.hash, 3266489909), this.hash ^= this.hash >>> 16, this.hash >>> 0;
  }
}
const VGt = Ls(), qGt = Ls(), BGt = Ls(), XGt = Ls(), WGt = Ls(), ZGt = Ls(), HGt = Ls(), QGt = Ls(), $Gt = Ls(), KGt = Ls(), GGt = Ls(), YGt = Ls(), JGt = 128, Lk = /* @__PURE__ */ new WeakMap();
function Aa(e) {
  const t = new T3();
  return f6e(t, e), t.digest();
}
function eYt(e) {
  const t = Lk.get(e);
  if (t !== void 0)
    return t;
  let n;
  if (e instanceof Date)
    n = tYt(e);
  else if (
    // Check if input is a Uint8Array or Buffer
    typeof Buffer < "u" && e instanceof Buffer || e instanceof Uint8Array
  )
    if (e.byteLength <= JGt)
      n = nYt(e);
    else
      return a7(e);
  else {
    if (e instanceof File)
      return a7(e);
    {
      let r = e, i = QGt;
      e instanceof Array && (i = $Gt), e instanceof Map && (i = KGt, r = [...e.entries()]), e instanceof Set && (i = GGt, r = [...e.entries()]), n = rYt(r, i);
    }
  }
  return Lk.set(e, n), n;
}
function tYt(e) {
  const t = new T3();
  return t.update(HGt), t.update(e.getTime()), t.digest();
}
function nYt(e) {
  const t = new T3();
  t.update(YGt), t.update(e.byteLength);
  for (let n = 0; n < e.byteLength; n++)
    t.writeByte(e[n]);
  return t.digest();
}
function rYt(e, t) {
  const n = new T3();
  n.update(t);
  const r = Object.keys(e);
  r.sort(oYt);
  for (const i of r)
    n.update(WGt), n.update(i), f6e(n, e[i]);
  return n.digest();
}
function f6e(e, t) {
  if (t === null) {
    e.update(BGt);
    return;
  }
  switch (typeof t) {
    case "undefined":
      e.update(XGt);
      return;
    case "boolean":
      e.update(t ? VGt : qGt);
      return;
    case "number":
      e.update(isNaN(t) ? NaN : t === 0 ? 0 : t);
      return;
    case "bigint":
    case "string":
    case "symbol":
      e.update(t);
      return;
    case "object":
      e.update(iYt(t));
      return;
    case "function":
      e.update(a7(t));
      return;
    default:
      console.warn(
        `Ignored input during hashing because it is of type ${typeof t} which is not supported`
      );
  }
}
function iYt(e) {
  let t = Lk.get(e);
  return t === void 0 && (t = eYt(e)), t;
}
let yhe = 1;
function a7(e) {
  let t = Lk.get(e);
  return t === void 0 && (t = yhe ^ ZGt, yhe++, Lk.set(e, t)), t;
}
function oYt(e, t) {
  return e.localeCompare(t);
}
var ds, Gm, p6e, EM;
const qd = class qd {
  constructor(t = []) {
    tt(this, Gm);
    tt(this, ds);
    $e(this, ds, t);
  }
  toString(t = !1) {
    return `MultiSet(${JSON.stringify(K(this, ds), null, t ? 2 : void 0)})`;
  }
  toJSON() {
    return JSON.stringify(Array.from(this.getInner()));
  }
  static fromJSON(t) {
    return new qd(JSON.parse(t));
  }
  /**
   * Apply a function to all records in the collection.
   */
  map(t) {
    return new qd(
      K(this, ds).map(([n, r]) => [t(n), r])
    );
  }
  /**
   * Filter out records for which a function f(record) evaluates to False.
   */
  filter(t) {
    return new qd(K(this, ds).filter(([n, r]) => t(n)));
  }
  /**
   * Negate all multiplicities in the collection.
   */
  negate() {
    return new qd(
      K(this, ds).map(([t, n]) => [t, -n])
    );
  }
  /**
   * Concatenate two collections together.
   */
  concat(t) {
    const n = [];
    return MV(n, K(this, ds)), MV(n, t.getInner()), new qd(n);
  }
  /**
   * Produce as output a collection that is logically equivalent to the input
   * but which combines identical instances of the same record into one
   * (record, multiplicity) pair.
   */
  consolidate() {
    var t;
    if (K(this, ds).length > 0) {
      const n = (t = K(this, ds)[0]) == null ? void 0 : t[0];
      if (Array.isArray(n) && n.length === 2)
        return Dt(this, Gm, p6e).call(this);
    }
    return Dt(this, Gm, EM).call(this);
  }
  extend(t) {
    const n = t instanceof qd ? t.getInner() : t;
    MV(K(this, ds), n);
  }
  add(t, n) {
    n !== 0 && K(this, ds).push([t, n]);
  }
  getInner() {
    return K(this, ds);
  }
};
ds = new WeakMap(), Gm = new WeakSet(), /**
 * Private method for consolidating keyed multisets where keys are strings/numbers
 * and values are compared by reference equality.
 *
 * This method provides significant performance improvements over the hash-based approach
 * by using WeakMap for object reference tracking and avoiding expensive serialization.
 *
 * Special handling for join operations: When values are tuples of length 2 (common in joins),
 * we unpack them and compare each element individually to maintain proper equality semantics.
 */
p6e = function() {
  const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r = (o) => {
    if (o.length !== 2)
      throw new Error("Expected tuple of length 2");
    const [s, l] = o;
    return `${DV.getStringId(s)}|${DV.getStringId(l)}`;
  };
  for (const [o, s] of K(this, ds)) {
    if (!Array.isArray(o) || o.length !== 2)
      return Dt(this, Gm, EM).call(this);
    const [l, c] = o;
    if (typeof l != "string" && typeof l != "number")
      return Dt(this, Gm, EM).call(this);
    let a;
    Array.isArray(c) && c.length === 2 ? a = r(c) : a = DV.getStringId(c);
    const u = l + "|" + a;
    t.set(
      u,
      (t.get(u) || 0) + s
    ), n.has(u) || n.set(u, o);
  }
  const i = [];
  for (const [o, s] of t)
    s !== 0 && i.push([n.get(o), s]);
  return new qd(i);
}, /**
 * Private method for consolidating unkeyed multisets using the original approach.
 */
EM = function() {
  const t = new IGt(() => 0), n = /* @__PURE__ */ new Map();
  let r = !1, i = !1, o = !1;
  for (const [c, a] of K(this, ds))
    if (typeof c == "string")
      r = !0;
    else if (typeof c == "number")
      i = !0;
    else {
      o = !0;
      break;
    }
  const s = o || r && i;
  for (const [c, a] of K(this, ds)) {
    const u = s ? Aa(c) : c;
    s && !n.has(u) && n.set(u, c), t.update(u, (f) => f + a);
  }
  const l = [];
  for (const [c, a] of t.entries())
    if (a !== 0) {
      const u = s ? n.get(c) : c;
      l.push([u, a]);
    }
  return new qd(l);
};
let cu = qd;
var Ky;
class sYt {
  constructor(t) {
    tt(this, Ky);
    $e(this, Ky, t);
  }
  drain() {
    const t = [...K(this, Ky)].reverse();
    return K(this, Ky).length = 0, t;
  }
  isEmpty() {
    return K(this, Ky).length === 0;
  }
}
Ky = new WeakMap();
var tC;
class Zf {
  constructor() {
    tt(this, tC, []);
  }
  sendData(t) {
    t instanceof cu || (t = new cu(t));
    for (const n of K(this, tC))
      n.unshift(t);
  }
  newReader() {
    const t = [];
    return K(this, tC).push(t), new sYt(t);
  }
}
tC = new WeakMap();
class h6e {
  constructor(t, n, r) {
    this.id = t, this.inputs = n, this.output = r;
  }
  hasPendingWork() {
    return this.inputs.some((t) => !t.isEmpty());
  }
}
class Fx extends h6e {
  constructor(t, n, r) {
    super(t, [n], r), this.id = t;
  }
  inputMessages() {
    return this.inputs[0].drain();
  }
}
class aYt extends h6e {
  constructor(t, n, r, i) {
    super(t, [n, r], i), this.id = t;
  }
  inputAMessages() {
    return this.inputs[0].drain();
  }
  inputBMessages() {
    return this.inputs[1].drain();
  }
}
class cJ extends Fx {
  run() {
    for (const t of this.inputMessages())
      this.output.sendData(this.inner(t));
  }
}
var DA, i2, _A, Gy, T1;
class lYt {
  constructor() {
    tt(this, Gy);
    tt(this, DA, []);
    tt(this, i2, 0);
    tt(this, _A, !1);
  }
  getNextOperatorId() {
    return Dt(this, Gy, T1).call(this), Hx(this, i2)._++;
  }
  newInput() {
    Dt(this, Gy, T1).call(this);
    const t = new Zf();
    return new cYt(this, t);
  }
  addOperator(t) {
    Dt(this, Gy, T1).call(this), K(this, DA).push(t);
  }
  finalize() {
    Dt(this, Gy, T1).call(this), $e(this, _A, !0);
  }
  step() {
    if (!K(this, _A))
      throw new Error("Graph not finalized");
    for (const t of K(this, DA))
      t.run();
  }
  pendingWork() {
    return K(this, DA).some((t) => t.hasPendingWork());
  }
  run() {
    for (; this.pendingWork(); )
      this.step();
  }
}
DA = new WeakMap(), i2 = new WeakMap(), _A = new WeakMap(), Gy = new WeakSet(), T1 = function() {
  if (K(this, _A))
    throw new Error("Graph already finalized");
};
var nC, LA;
class Hf {
  constructor(t, n) {
    tt(this, nC);
    tt(this, LA);
    $e(this, nC, t), $e(this, LA, n);
  }
  connectReader() {
    return K(this, LA).newReader();
  }
  get writer() {
    return K(this, LA);
  }
  get graph() {
    return K(this, nC);
  }
  pipe(...t) {
    return t.reduce((n, r) => r(n), this);
  }
}
nC = new WeakMap(), LA = new WeakMap();
class cYt extends Hf {
  sendData(t) {
    this.writer.sendData(t);
  }
}
var rC;
class uYt extends cJ {
  constructor(n, r, i, o) {
    super(n, r, i);
    tt(this, rC);
    $e(this, rC, o);
  }
  inner(n) {
    return n.map(K(this, rC));
  }
}
rC = new WeakMap();
function Sa(e) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new uYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
const k1 = /* @__PURE__ */ Symbol("NO_PREFIX");
class vhe extends Map {
  /**
   * Add a value to the PrefixMap. Returns true if the map becomes empty after the operation.
   */
  addValue(t, n) {
    if (n === 0) return this.size === 0;
    const r = $E(t), i = this.get(r);
    if (TM(i)) {
      const [o, s] = i;
      if ($E(o) !== r)
        throw new Error("Mismatching prefixes, this should never happen");
      if (o === t || Aa(o) === Aa(t)) {
        const c = s + n;
        c === 0 ? this.delete(r) : this.set(r, [t, c]);
      } else {
        const c = new C1();
        c.set(Aa(o), i), c.set(Aa(t), [t, n]), this.set(r, c);
      }
    } else i === void 0 ? this.set(r, [t, n]) : i.addValue(t, n) && this.delete(r);
    return this.size === 0;
  }
}
class C1 extends Map {
  /**
   * Add a value to the ValueMap. Returns true if the map becomes empty after the operation.
   * @param value - The full value to store
   * @param multiplicity - The multiplicity to add
   * @param hashKey - Optional hash key to use instead of hashing the full value (used when in PrefixMap context)
   */
  addValue(t, n) {
    if (n === 0) return this.size === 0;
    const r = Aa(t), i = this.get(r);
    if (i) {
      const [, o] = i, s = o + n;
      s === 0 ? this.delete(r) : this.set(r, [t, s]);
    } else
      this.set(r, [t, n]);
    return this.size === 0;
  }
}
var so, Ip, o2, m6e;
const xee = class xee {
  // sum of multiplicities per key
  constructor() {
    tt(this, o2);
    /*
     * This index maintains a nested map of keys -> (value, multiplicities), where:
     * - initially the values are stored against the key as a single value tuple
     * - when a key gets additional values, the values are stored against the key in a
     *   prefix map
     * - the prefix is extract where possible from values that are structured as
     *   [rowPrimaryKey, rowValue], as they are in the Tanstack DB query pipeline.
     * - only when there are multiple values for a given prefix do we fall back to a
     *   hash to identify identical values, storing them in a third level value map.
     */
    tt(this, so);
    tt(this, Ip, /* @__PURE__ */ new Map());
    $e(this, so, /* @__PURE__ */ new Map());
  }
  /**
   * Create an Index from multiple MultiSet messages.
   * @param messages - Array of MultiSet messages to build the index from.
   * @returns A new Index containing all the data from the messages.
   */
  static fromMultiSets(t) {
    const n = new xee();
    for (const r of t)
      for (const [i, o] of r.getInner()) {
        const [s, l] = i;
        n.addValue(s, [l, o]);
      }
    return n;
  }
  /**
   * This method returns a string representation of the index.
   * @param indent - Whether to indent the string representation.
   * @returns A string representation of the index.
   */
  toString(t = !1) {
    return `Index(${JSON.stringify(
      [...this.entries()],
      void 0,
      t ? 2 : void 0
    )})`;
  }
  /**
   * The size of the index.
   */
  get size() {
    return K(this, so).size;
  }
  /**
   * This method checks if the index has a given key.
   * @param key - The key to check.
   * @returns True if the index has the key, false otherwise.
   */
  has(t) {
    return K(this, so).has(t);
  }
  /**
   * Check if a key has presence (non-zero consolidated multiplicity).
   * @param key - The key to check.
   * @returns True if the key has non-zero consolidated multiplicity, false otherwise.
   */
  hasPresence(t) {
    return (K(this, Ip).get(t) || 0) !== 0;
  }
  /**
   * Get the consolidated multiplicity (sum of multiplicities) for a key.
   * @param key - The key to get the consolidated multiplicity for.
   * @returns The consolidated multiplicity for the key.
   */
  getConsolidatedMultiplicity(t) {
    return K(this, Ip).get(t) || 0;
  }
  /**
   * Get all keys that have presence (non-zero consolidated multiplicity).
   * @returns An iterator of keys with non-zero consolidated multiplicity.
   */
  getPresenceKeys() {
    return K(this, Ip).keys();
  }
  /**
   * This method returns all values for a given key.
   * @param key - The key to get the values for.
   * @returns An array of value tuples [value, multiplicity].
   */
  get(t) {
    return [...this.getIterator(t)];
  }
  /**
   * This method returns an iterator over all values for a given key.
   * @param key - The key to get the values for.
   * @returns An iterator of value tuples [value, multiplicity].
   */
  *getIterator(t) {
    const n = K(this, so).get(t);
    if (TM(n))
      yield n;
    else {
      if (n === void 0)
        return;
      if (n instanceof C1)
        for (const r of n.values())
          yield r;
      else
        for (const r of n.values())
          if (TM(r))
            yield r;
          else
            for (const i of r.values())
              yield i;
    }
  }
  /**
   * This returns an iterator that iterates over all key-value pairs.
   * @returns An iterable of all key-value pairs (and their multiplicities) in the index.
   */
  *entries() {
    for (const t of K(this, so).keys())
      for (const n of this.getIterator(t))
        yield [t, n];
  }
  /**
   * This method only iterates over the keys and not over the values.
   * Hence, it is more efficient than the `#entries` method.
   * It returns an iterator that you can use if you need to iterate over the values for a given key.
   * @returns An iterator of all *keys* in the index and their corresponding value iterator.
   */
  *entriesIterators() {
    for (const t of K(this, so).keys())
      yield [t, this.getIterator(t)];
  }
  /**
   * This method adds a value to the index.
   * @param key - The key to add the value to.
   * @param valueTuple - The value tuple [value, multiplicity] to add to the index.
   */
  addValue(t, n) {
    const [r, i] = n;
    if (i === 0) return;
    const o = (K(this, Ip).get(t) || 0) + i;
    o === 0 ? K(this, Ip).delete(t) : K(this, Ip).set(t, o);
    const s = K(this, so).get(t);
    if (s === void 0) {
      K(this, so).set(t, n);
      return;
    }
    if (TM(s)) {
      Dt(this, o2, m6e).call(this, t, s, r, i);
      return;
    }
    if (s instanceof C1) {
      const l = $E(r);
      if (l !== k1) {
        const c = new vhe();
        c.set(k1, s), c.set(l, n), K(this, so).set(t, c);
      } else
        s.addValue(r, i) && K(this, so).delete(t);
    } else
      s.addValue(r, i) && K(this, so).delete(t);
  }
  /**
   * This method appends another index to the current index.
   * @param other - The index to append to the current index.
   */
  append(t) {
    for (const [n, r] of t.entries())
      this.addValue(n, r);
  }
  /**
   * This method joins two indexes.
   * @param other - The index to join with the current index.
   * @returns A multiset of the joined values.
   */
  join(t) {
    const n = [];
    if (this.size <= t.size)
      for (const [r, i] of this.entriesIterators()) {
        if (!t.has(r)) continue;
        const o = t.get(r);
        for (const [s, l] of i)
          for (const [c, a] of o)
            l !== 0 && a !== 0 && n.push([[r, [s, c]], l * a]);
      }
    else
      for (const [r, i] of t.entriesIterators()) {
        if (!this.has(r)) continue;
        const o = this.get(r);
        for (const [s, l] of i)
          for (const [c, a] of o)
            a !== 0 && l !== 0 && n.push([[r, [c, s]], a * l]);
      }
    return new cu(n);
  }
};
so = new WeakMap(), Ip = new WeakMap(), o2 = new WeakSet(), /**
 * Handle the transition from a single value to either a ValueMap or PrefixMap
 */
m6e = function(t, n, r, i) {
  const [o, s] = n;
  if (o === r) {
    const a = s + i;
    a === 0 ? K(this, so).delete(t) : K(this, so).set(t, [r, a]);
    return;
  }
  const l = $E(r), c = $E(o);
  if (c === l && (o === r || Aa(o) === Aa(r))) {
    const a = s + i;
    a === 0 ? K(this, so).delete(t) : K(this, so).set(t, [r, a]);
    return;
  }
  if (c === k1 && l === k1) {
    const a = new C1();
    a.set(Aa(o), n), a.set(Aa(r), [r, i]), K(this, so).set(t, a);
  } else {
    const a = new vhe();
    if (c === l) {
      const u = new C1();
      u.set(Aa(o), n), u.set(Aa(r), [r, i]), a.set(c, u);
    } else
      a.set(c, n), a.set(l, [r, i]);
    K(this, so).set(t, a);
  }
};
let Um = xee;
function $E(e) {
  return Array.isArray(e) && (typeof e[0] == "string" || typeof e[0] == "number" || typeof e[0] == "bigint") ? e[0] : k1;
}
function TM(e) {
  return Array.isArray(e);
}
var iC, Yy, oC;
class dYt extends Fx {
  constructor(n, r, i, o) {
    super(n, r, i);
    tt(this, iC, new Um());
    tt(this, Yy, new Um());
    tt(this, oC);
    $e(this, oC, o);
  }
  run() {
    const n = /* @__PURE__ */ new Set();
    for (const i of this.inputMessages())
      for (const [o, s] of i.getInner()) {
        const [l, c] = o;
        K(this, iC).addValue(l, [c, s]), n.add(l);
      }
    const r = [];
    for (const i of n) {
      const o = K(this, iC).get(i), s = K(this, Yy).get(i), l = K(this, oC).call(this, o), c = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (const [u, f] of l) {
        const d = c.get(u) ?? 0;
        c.set(u, d + f);
      }
      for (const [u, f] of s) {
        const d = a.get(u) ?? 0;
        a.set(u, d + f);
      }
      for (const [u, f] of a)
        c.has(u) || (r.push([[i, u], -f]), K(this, Yy).addValue(i, [u, -f]));
      for (const [u, f] of c)
        a.has(u) || f !== 0 && (r.push([[i, u], f]), K(this, Yy).addValue(i, [u, f]));
      for (const [u, f] of c) {
        const d = a.get(u);
        if (d !== void 0) {
          const p = f - d;
          p !== 0 && (r.push([[i, u], p]), K(this, Yy).addValue(i, [u, p]));
        }
      }
    }
    r.length > 0 && this.output.sendData(new cu(r));
  }
}
iC = new WeakMap(), Yy = new WeakMap(), oC = new WeakMap();
function fYt(e) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new dYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
function bhe(e) {
  return "pipe" in e;
}
function Ohe(e, t = {}) {
  const n = Object.fromEntries(
    Object.entries(t).filter(
      ([r, i]) => !bhe(i)
    )
  );
  return Object.fromEntries(
    Object.entries(t).filter(
      ([r, i]) => bhe(i)
    )
  ), (r) => {
    const i = "__original_key__";
    return r.pipe(
      Sa((l) => {
        const c = e(l), a = u6e(c), u = {};
        u[i] = c;
        for (const [f, d] of Object.entries(n))
          u[f] = d.preMap(l);
        return [a, u];
      })
    ).pipe(
      fYt((l) => {
        var f, d;
        let c = 0;
        for (const [p, h] of l)
          c += h;
        if (c <= 0)
          return [];
        const a = {}, u = (d = (f = l[0]) == null ? void 0 : f[0]) == null ? void 0 : d[i];
        a[i] = u;
        for (const [p, h] of Object.entries(n)) {
          const m = l.map(
            ([v, b]) => [v[p], b]
          );
          a[p] = h.reduce(m);
        }
        return [[a, 1]];
      })
    ).pipe(
      Sa(([l, c]) => {
        const a = c[i], u = {};
        Object.assign(u, a);
        for (const [f, d] of Object.entries(n))
          d.postMap ? u[f] = d.postMap(c[f]) : u[f] = c[f];
        return [l, u];
      })
    );
  };
}
function pYt(e = (t) => t) {
  return {
    preMap: (t) => e(t),
    reduce: (t) => {
      let n = 0;
      for (const [r, i] of t)
        n += r * i;
      return n;
    }
  };
}
function hYt(e = (t) => t) {
  return {
    // Count only not-null values (the `== null` comparison gives true for both null and undefined)
    preMap: (t) => e(t) == null ? 0 : 1,
    reduce: (t) => {
      let n = 0;
      for (const [r, i] of t)
        n += r * i;
      return n;
    }
  };
}
function mYt(e = (t) => t) {
  return {
    preMap: (t) => ({
      sum: e(t),
      count: 0
    }),
    reduce: (t) => {
      let n = 0, r = 0;
      for (const [i, o] of t)
        n += i.sum * o, r += o;
      return {
        sum: n,
        count: r
      };
    },
    postMap: (t) => t.sum / t.count
  };
}
function gYt(e) {
  const t = e ?? ((n) => n);
  return {
    preMap: (n) => t(n),
    reduce: (n) => {
      let r;
      for (const [i, o] of n)
        (!r || i && i < r) && (r = i);
      return r;
    }
  };
}
function yYt(e) {
  const t = e ?? ((n) => n);
  return {
    preMap: (n) => t(n),
    reduce: (n) => {
      let r;
      for (const [i, o] of n)
        (!r || i && i > r) && (r = i);
      return r;
    }
  };
}
const vYt = {
  sum: pYt,
  count: hYt,
  avg: mYt,
  min: gYt,
  max: yYt
};
var sC;
class bYt extends cJ {
  constructor(n, r, i, o) {
    super(n, r, i);
    tt(this, sC);
    $e(this, sC, o);
  }
  inner(n) {
    return K(this, sC).call(this, n), n;
  }
}
sC = new WeakMap();
function OYt(e) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new bYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
var aC;
class AYt extends cJ {
  constructor(n, r, i, o) {
    super(n, r, i);
    tt(this, aC);
    $e(this, aC, o);
  }
  inner(n) {
    return n.filter(K(this, aC));
  }
}
aC = new WeakMap();
function Vm(e) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new AYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
var lC;
class wYt extends Fx {
  constructor(n, r, i, o) {
    super(n, r, i);
    tt(this, lC);
    $e(this, lC, o);
  }
  run() {
    for (const n of this.inputMessages())
      K(this, lC).call(this, n), this.output.sendData(n);
  }
}
lC = new WeakMap();
function xYt(e) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new wYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
class SYt extends Fx {
  run() {
    const t = this.inputMessages();
    if (t.length === 0)
      return;
    const n = new cu();
    for (const i of t)
      n.extend(i);
    const r = n.consolidate();
    r.getInner().length > 0 && this.output.sendData(r);
  }
}
function EYt() {
  return (e) => {
    const t = new Hf(
      e.graph,
      new Zf()
    ), n = new SYt(
      e.graph.getNextOperatorId(),
      e.connectReader(),
      t.writer
    );
    return e.graph.addOperator(n), t;
  };
}
var Tm, km, Qd;
class TYt extends aYt {
  constructor(n, r, i, o, s = "inner") {
    super(n, r, i, o);
    tt(this, Tm, new Um());
    tt(this, km, new Um());
    tt(this, Qd);
    $e(this, Qd, s);
  }
  run() {
    const n = Um.fromMultiSets(
      this.inputAMessages()
    ), r = Um.fromMultiSets(
      this.inputBMessages()
    );
    if (n.size === 0 && r.size === 0) return;
    const i = new cu();
    K(this, Qd) !== "anti" && this.emitInnerResults(n, r, i), (K(this, Qd) === "left" || K(this, Qd) === "full" || K(this, Qd) === "anti") && this.emitLeftOuterResults(n, r, i), (K(this, Qd) === "right" || K(this, Qd) === "full") && this.emitRightOuterResults(n, r, i), K(this, Tm).append(n), K(this, km).append(r), i.getInner().length > 0 && this.output.sendData(i);
  }
  emitInnerResults(n, r, i) {
    n.size > 0 && i.extend(n.join(K(this, km))), r.size > 0 && i.extend(K(this, Tm).join(r)), n.size > 0 && r.size > 0 && i.extend(n.join(r));
  }
  emitLeftOuterResults(n, r, i) {
    if (n.size > 0)
      for (const [o, s] of n.entriesIterators()) {
        const l = K(this, km).getConsolidatedMultiplicity(o), c = r.getConsolidatedMultiplicity(o);
        if (l + c === 0)
          for (const [u, f] of s)
            f !== 0 && i.add([o, [u, null]], f);
      }
    if (r.size > 0)
      for (const o of r.getPresenceKeys()) {
        const s = K(this, km).getConsolidatedMultiplicity(o), l = r.getConsolidatedMultiplicity(o);
        if (l === 0) continue;
        const c = s + l;
        if (s === 0 == (c === 0)) continue;
        const a = s === 0;
        for (const [u, f] of K(this, Tm).getIterator(o))
          f !== 0 && i.add(
            [o, [u, null]],
            a ? -f : +f
          );
      }
  }
  emitRightOuterResults(n, r, i) {
    if (r.size > 0)
      for (const [o, s] of r.entriesIterators()) {
        const l = K(this, Tm).getConsolidatedMultiplicity(o), c = n.getConsolidatedMultiplicity(o);
        if (l + c === 0)
          for (const [u, f] of s)
            f !== 0 && i.add([o, [null, u]], f);
      }
    if (n.size > 0)
      for (const o of n.getPresenceKeys()) {
        const s = K(this, Tm).getConsolidatedMultiplicity(o), l = n.getConsolidatedMultiplicity(o);
        if (l === 0) continue;
        const c = s + l;
        if (s === 0 == (c === 0)) continue;
        const a = s === 0;
        for (const [u, f] of K(this, km).getIterator(o))
          f !== 0 && i.add(
            [o, [null, u]],
            a ? -f : +f
          );
      }
  }
}
Tm = new WeakMap(), km = new WeakMap(), Qd = new WeakMap();
function kYt(e, t = "inner") {
  return (n) => {
    if (n.graph !== e.graph)
      throw new Error("Cannot join streams from different graphs");
    const r = new Hf(
      n.graph,
      new Zf()
    ), i = new TYt(
      n.graph.getNextOperatorId(),
      n.connectReader(),
      e.connectReader(),
      r.writer,
      t
    );
    return n.graph.addOperator(i), r;
  };
}
var Jy, Cm;
class CYt extends Fx {
  // keeps track of the number of times each value has been seen
  constructor(n, r, i, o = (s) => s) {
    super(n, r, i);
    tt(this, Jy);
    tt(this, Cm);
    $e(this, Jy, o), $e(this, Cm, /* @__PURE__ */ new Map());
  }
  run() {
    var i;
    const n = /* @__PURE__ */ new Map();
    for (const o of this.inputMessages())
      for (const [s, l] of o.getInner()) {
        const c = Aa(K(this, Jy).call(this, s)), u = (((i = n.get(c)) == null ? void 0 : i[0]) ?? K(this, Cm).get(c) ?? 0) + l;
        n.set(c, [u, s]);
      }
    const r = [];
    for (const [
      o,
      [s, l]
    ] of n.entries()) {
      const c = K(this, Cm).get(o) ?? 0;
      s === 0 ? K(this, Cm).delete(o) : K(this, Cm).set(o, s), c <= 0 && s > 0 ? r.push([[Aa(K(this, Jy).call(this, l)), l[1]], 1]) : c > 0 && s <= 0 && r.push([[Aa(K(this, Jy).call(this, l)), l[1]], -1]);
    }
    r.length > 0 && this.output.sendData(new cu(r));
  }
}
Jy = new WeakMap(), Cm = new WeakMap();
function NYt(e = (t) => t) {
  return (t) => {
    const n = new Hf(
      t.graph,
      new Zf()
    ), r = new CYt(
      t.graph.getNextOperatorId(),
      t.connectReader(),
      n.writer,
      e
    );
    return t.graph.addOperator(r), n;
  };
}
const PYt = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
function IO(e, t, n) {
  const r = n[0];
  if (t != null && e >= t)
    throw new Error(e + " >= " + t);
  if (e.slice(-1) === r || t && t.slice(-1) === r)
    throw new Error("trailing zero");
  if (t) {
    let s = 0;
    for (; (e[s] || r) === t[s]; )
      s++;
    if (s > 0)
      return t.slice(0, s) + IO(e.slice(s), t.slice(s), n);
  }
  const i = e ? n.indexOf(e[0]) : 0, o = t != null ? n.indexOf(t[0]) : n.length;
  if (o - i > 1) {
    const s = Math.round(0.5 * (i + o));
    return n[s];
  } else
    return t && t.length > 1 ? t.slice(0, 1) : n[i] + IO(e.slice(1), null, n);
}
function g6e(e) {
  if (e.length !== y6e(e[0]))
    throw new Error("invalid integer part of order key: " + e);
}
function y6e(e) {
  if (e >= "a" && e <= "z")
    return e.charCodeAt(0) - 97 + 2;
  if (e >= "A" && e <= "Z")
    return 90 - e.charCodeAt(0) + 2;
  throw new Error("invalid order key head: " + e);
}
function N1(e) {
  const t = y6e(e[0]);
  if (t > e.length)
    throw new Error("invalid order key: " + e);
  return e.slice(0, t);
}
function Ahe(e, t) {
  if (e === "A" + t[0].repeat(26))
    throw new Error("invalid order key: " + e);
  const n = N1(e);
  if (e.slice(n.length).slice(-1) === t[0])
    throw new Error("invalid order key: " + e);
}
function whe(e, t) {
  g6e(e);
  const [n, ...r] = e.split("");
  let i = !0;
  for (let o = r.length - 1; i && o >= 0; o--) {
    const s = t.indexOf(r[o]) + 1;
    s === t.length ? r[o] = t[0] : (r[o] = t[s], i = !1);
  }
  if (i) {
    if (n === "Z")
      return "a" + t[0];
    if (n === "z")
      return null;
    const o = String.fromCharCode(n.charCodeAt(0) + 1);
    return o > "a" ? r.push(t[0]) : r.pop(), o + r.join("");
  } else
    return n + r.join("");
}
function IYt(e, t) {
  g6e(e);
  const [n, ...r] = e.split("");
  let i = !0;
  for (let o = r.length - 1; i && o >= 0; o--) {
    const s = t.indexOf(r[o]) - 1;
    s === -1 ? r[o] = t.slice(-1) : (r[o] = t[s], i = !1);
  }
  if (i) {
    if (n === "a")
      return "Z" + t.slice(-1);
    if (n === "A")
      return null;
    const o = String.fromCharCode(n.charCodeAt(0) - 1);
    return o < "Z" ? r.push(t.slice(-1)) : r.pop(), o + r.join("");
  } else
    return n + r.join("");
}
function RYt(e, t, n = PYt) {
  if (e != null && Ahe(e, n), t != null && Ahe(t, n), e != null && t != null && e >= t)
    throw new Error(e + " >= " + t);
  if (e == null) {
    if (t == null)
      return "a" + n[0];
    const c = N1(t), a = t.slice(c.length);
    if (c === "A" + n[0].repeat(26))
      return c + IO("", a, n);
    if (c < t)
      return c;
    const u = IYt(c, n);
    if (u == null)
      throw new Error("cannot decrement any more");
    return u;
  }
  if (t == null) {
    const c = N1(e), a = e.slice(c.length), u = whe(c, n);
    return u ?? c + IO(a, null, n);
  }
  const r = N1(e), i = e.slice(r.length), o = N1(t), s = t.slice(o.length);
  if (r === o)
    return r + IO(i, s, n);
  const l = whe(r, n);
  if (l == null)
    throw new Error("cannot increment any more");
  return l < t ? l : r + IO(i, null, n);
}
function xhe(e, t) {
  return [e, t];
}
function She(e) {
  return e[0];
}
function Ehe(e) {
  return e[1];
}
function MYt(e) {
  return ([t, n], [r, i]) => {
    const o = e(n, i);
    return o !== 0 ? o : uL(t, r);
  };
}
var ao, cC, fs, qs, uC, l7;
class v6e {
  constructor(t, n, r) {
    tt(this, uC);
    tt(this, ao, []);
    tt(this, cC);
    tt(this, fs);
    tt(this, qs);
    $e(this, fs, t), $e(this, qs, t + n), $e(this, cC, r);
  }
  get size() {
    const t = K(this, fs), n = K(this, qs) - K(this, fs), r = K(this, ao).length - t;
    return Math.max(0, Math.min(n, r));
  }
  /**
   * Moves the topK window
   */
  move({
    offset: t,
    limit: n
  }) {
    const r = K(this, fs), i = K(this, qs) - K(this, fs), o = [
      K(this, fs),
      K(this, qs) === 1 / 0 ? K(this, fs) + this.size : K(this, qs)
    ];
    $e(this, fs, t ?? r), $e(this, qs, K(this, fs) + (n ?? i));
    const s = [
      K(this, fs),
      K(this, qs) === 1 / 0 ? Math.max(K(this, fs) + this.size, o[1]) : K(this, qs)
    ], { onlyInA: l, onlyInB: c } = DGt(o, s), a = [];
    c.forEach((f) => {
      const d = K(this, ao)[f];
      d && a.push(d);
    });
    const u = [];
    return l.forEach((f) => {
      const d = K(this, ao)[f];
      d && u.push(d);
    }), { moveIns: a, moveOuts: u, changes: l.length + c.length > 0 };
  }
  insert(t) {
    const n = { moveIn: null, moveOut: null }, r = Dt(this, uC, l7).call(this, t), i = r === 0 ? null : Ehe(K(this, ao)[r - 1]), o = r === K(this, ao).length ? null : Ehe(K(this, ao)[r]), s = RYt(i, o), l = xhe(t, s);
    if (K(this, ao).splice(r, 0, l), r < K(this, qs)) {
      const c = Math.max(r, K(this, fs));
      c < K(this, ao).length && (n.moveIn = K(this, ao)[c], K(this, qs) < K(this, ao).length && (n.moveOut = K(this, ao)[K(this, qs)]));
    }
    return n;
  }
  /**
   * Deletes a value that may or may not be in the topK.
   * IMPORTANT: this assumes that the value is present in the collection
   *            if it's not the case it will remove the element
   *            that is on the position where the provided `value` would be.
   */
  delete(t) {
    const n = { moveIn: null, moveOut: null }, r = Dt(this, uC, l7).call(this, t), [i] = K(this, ao).splice(r, 1);
    if (r < K(this, qs)) {
      if (n.moveOut = i, r < K(this, fs)) {
        const s = K(this, fs) - 1;
        s < K(this, ao).length ? n.moveOut = K(this, ao)[s] : n.moveOut = null;
      }
      const o = K(this, qs) - 1;
      o < K(this, ao).length && (n.moveIn = K(this, ao)[o]);
    }
    return n;
  }
}
ao = new WeakMap(), cC = new WeakMap(), fs = new WeakMap(), qs = new WeakMap(), uC = new WeakSet(), // TODO: see if there is a way to refactor the code for insert and delete in the topK above
//       because they are very similar, one is shifting the topK window to the left and the other is shifting it to the right
//       so i have the feeling there is a common pattern here and we can implement both cases using that pattern
l7 = function(t) {
  return RGt(
    K(this, ao),
    xhe(t, ""),
    (n, r) => K(this, cC).call(this, She(n), She(r))
  );
};
var Nm, $d, s2, b6e;
class DYt {
  constructor(t) {
    tt(this, s2);
    tt(this, Nm, /* @__PURE__ */ new Map());
    tt(this, $d);
    $e(this, $d, t);
  }
  get size() {
    return K(this, $d).size;
  }
  get isEmpty() {
    return K(this, Nm).size === 0 && K(this, $d).size === 0;
  }
  /**
   * Process an element update (insert or delete based on multiplicity change).
   * Returns the changes to the topK window.
   */
  processElement(t, n, r) {
    const { oldMultiplicity: i, newMultiplicity: o } = Dt(this, s2, b6e).call(this, t, r);
    return i <= 0 && o > 0 ? K(this, $d).insert([t, n]) : i > 0 && o <= 0 ? K(this, $d).delete([t, n]) : { moveIn: null, moveOut: null };
  }
  /**
   * Move the topK window. Only works with TopKArray implementation.
   */
  move(t) {
    if (!(K(this, $d) instanceof v6e))
      throw new Error(
        "Cannot move B+-tree implementation of TopK with fractional index"
      );
    return K(this, $d).move(t);
  }
}
Nm = new WeakMap(), $d = new WeakMap(), s2 = new WeakSet(), b6e = function(t, n) {
  if (n === 0) {
    const o = K(this, Nm).get(t) ?? 0;
    return { oldMultiplicity: o, newMultiplicity: o };
  }
  const r = K(this, Nm).get(t) ?? 0, i = r + n;
  return i === 0 ? K(this, Nm).delete(t) : K(this, Nm).set(t, i), { oldMultiplicity: r, newMultiplicity: i };
};
function The(e, t) {
  if (e) {
    const [[n, r], i] = e;
    t.push([[n, [r, i]], 1]);
  }
}
function khe(e, t) {
  if (e) {
    const [[n, r], i] = e;
    t.push([[n, [r, i]], -1]);
  }
}
var ev;
class _Yt extends Fx {
  constructor(n, r, i, o, s) {
    var u, f;
    super(n, r, i);
    tt(this, ev);
    const l = s.limit ?? 1 / 0, c = s.offset ?? 0, a = this.createTopK(
      c,
      l,
      MYt(o)
    );
    $e(this, ev, new DYt(a)), (u = s.setSizeCallback) == null || u.call(s, () => K(this, ev).size), (f = s.setWindowFn) == null || f.call(s, this.moveTopK.bind(this));
  }
  createTopK(n, r, i) {
    return new v6e(n, r, i);
  }
  /**
   * Moves the topK window based on the provided offset and limit.
   * Any changes to the topK are sent to the output.
   */
  moveTopK({ offset: n, limit: r }) {
    const i = [], o = K(this, ev).move({ offset: n, limit: r });
    o.moveIns.forEach((s) => The(s, i)), o.moveOuts.forEach((s) => khe(s, i)), o.changes && this.output.sendData(new cu(i));
  }
  run() {
    const n = [];
    for (const r of this.inputMessages())
      for (const [i, o] of r.getInner()) {
        const [s, l] = i;
        this.processElement(s, l, o, n);
      }
    n.length > 0 && this.output.sendData(new cu(n));
  }
  processElement(n, r, i, o) {
    const s = K(this, ev).processElement(n, r, i);
    The(s.moveIn, o), khe(s.moveOut, o);
  }
}
ev = new WeakMap();
function LYt(e, t) {
  const n = t || {};
  return (r) => {
    const i = new Hf(
      r.graph,
      new Zf()
    ), o = new _Yt(
      r.graph.getNextOperatorId(),
      r.connectReader(),
      i.writer,
      e,
      n
    );
    return r.graph.addOperator(o), i;
  };
}
function zYt(e, t, n) {
  const r = (n == null ? void 0 : n.limit) ?? 1 / 0, i = (n == null ? void 0 : n.offset) ?? 0, o = n == null ? void 0 : n.setSizeCallback, s = n == null ? void 0 : n.setWindowFn, l = (n == null ? void 0 : n.comparator) ?? ((c, a) => c === a ? 0 : c < a ? -1 : 1);
  return (c) => c.pipe(
    e(
      (a, u) => l(t(a), t(u)),
      {
        limit: r,
        offset: i,
        setSizeCallback: o,
        setWindowFn: s
      }
    ),
    EYt()
  );
}
function jYt(e, t) {
  return zYt(
    LYt,
    e,
    t
  );
}
class FYt {
  /**
   * Initializes an empty B+ tree.
   * @param compare Custom function to compare pairs of elements in the tree.
   *   If not specified, defaultComparator will be used which is valid as long as K extends DefaultComparable.
   * @param entries A set of key-value pairs to initialize the tree
   * @param maxNodeSize Branching factor (maximum items or children per node)
   *   Must be in range 4..256. If undefined or <4 then default is used; if >256 then 256.
   */
  constructor(t, n, r) {
    this._root = _V, this._size = 0, this._maxNodeSize = r >= 4 ? Math.min(r, 256) : 32, this._compare = t, n && this.setPairs(n);
  }
  // ///////////////////////////////////////////////////////////////////////////
  // ES6 Map<K,V> methods /////////////////////////////////////////////////////
  /** Gets the number of key-value pairs in the tree. */
  get size() {
    return this._size;
  }
  /** Gets the number of key-value pairs in the tree. */
  get length() {
    return this._size;
  }
  /** Returns true iff the tree contains no key-value pairs. */
  get isEmpty() {
    return this._size === 0;
  }
  /** Releases the tree so that its size is 0. */
  clear() {
    this._root = _V, this._size = 0;
  }
  /**
   * Finds a pair in the tree and returns the associated value.
   * @param defaultValue a value to return if the key was not found.
   * @returns the value, or defaultValue if the key was not found.
   * @description Computational complexity: O(log size)
   */
  get(t, n) {
    return this._root.get(t, n, this);
  }
  /**
   * Adds or overwrites a key-value pair in the B+ tree.
   * @param key the key is used to determine the sort order of
   *        data in the tree.
   * @param value data to associate with the key (optional)
   * @param overwrite Whether to overwrite an existing key-value pair
   *        (default: true). If this is false and there is an existing
   *        key-value pair then this method has no effect.
   * @returns true if a new key-value pair was added.
   * @description Computational complexity: O(log size)
   * Note: when overwriting a previous entry, the key is updated
   * as well as the value. This has no effect unless the new key
   * has data that does not affect its sort order.
   */
  set(t, n, r) {
    this._root.isShared && (this._root = this._root.clone());
    const i = this._root.set(t, n, r, this);
    return i === !0 || i === !1 ? i : (this._root = new uJ([this._root, i]), !0);
  }
  /**
   * Returns true if the key exists in the B+ tree, false if not.
   * Use get() for best performance; use has() if you need to
   * distinguish between "undefined value" and "key not present".
   * @param key Key to detect
   * @description Computational complexity: O(log size)
   */
  has(t) {
    return this.forRange(t, t, !0, void 0) !== 0;
  }
  /**
   * Removes a single key-value pair from the B+ tree.
   * @param key Key to find
   * @returns true if a pair was found and removed, false otherwise.
   * @description Computational complexity: O(log size)
   */
  delete(t) {
    return this.editRange(t, t, !0, VYt) !== 0;
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Additional methods ///////////////////////////////////////////////////////
  /** Returns the maximum number of children/values before nodes will split. */
  get maxNodeSize() {
    return this._maxNodeSize;
  }
  /** Gets the lowest key in the tree. Complexity: O(log size) */
  minKey() {
    return this._root.minKey();
  }
  /** Gets the highest key in the tree. Complexity: O(1) */
  maxKey() {
    return this._root.maxKey();
  }
  /** Gets an array of all keys, sorted */
  keysArray() {
    const t = [];
    return this._root.forRange(
      this.minKey(),
      this.maxKey(),
      !0,
      !1,
      this,
      0,
      (n, r) => {
        t.push(n);
      }
    ), t;
  }
  /** Returns the next pair whose key is larger than the specified key (or undefined if there is none).
   * If key === undefined, this function returns the lowest pair.
   * @param key The key to search for.
   * @param reusedArray Optional array used repeatedly to store key-value pairs, to
   * avoid creating a new array on every iteration.
   */
  nextHigherPair(t, n) {
    return n = n || [], t === void 0 ? this._root.minPair(n) : this._root.getPairOrNextHigher(
      t,
      this._compare,
      !1,
      n
    );
  }
  /** Returns the next key larger than the specified key, or undefined if there is none.
   *  Also, nextHigherKey(undefined) returns the lowest key.
   */
  nextHigherKey(t) {
    const n = this.nextHigherPair(t, Che);
    return n && n[0];
  }
  /** Returns the next pair whose key is smaller than the specified key (or undefined if there is none).
   *  If key === undefined, this function returns the highest pair.
   * @param key The key to search for.
   * @param reusedArray Optional array used repeatedly to store key-value pairs, to
   *        avoid creating a new array each time you call this method.
   */
  nextLowerPair(t, n) {
    return n = n || [], t === void 0 ? this._root.maxPair(n) : this._root.getPairOrNextLower(t, this._compare, !1, n);
  }
  /** Returns the next key smaller than the specified key, or undefined if there is none.
   *  Also, nextLowerKey(undefined) returns the highest key.
   */
  nextLowerKey(t) {
    const n = this.nextLowerPair(t, Che);
    return n && n[0];
  }
  /** Adds all pairs from a list of key-value pairs.
   * @param pairs Pairs to add to this tree. If there are duplicate keys,
   *        later pairs currently overwrite earlier ones (e.g. [[0,1],[0,7]]
   *        associates 0 with 7.)
   * @param overwrite Whether to overwrite pairs that already exist (if false,
   *        pairs[i] is ignored when the key pairs[i][0] already exists.)
   * @returns The number of pairs added to the collection.
   * @description Computational complexity: O(pairs.length * log(size + pairs.length))
   */
  setPairs(t, n) {
    let r = 0;
    for (const i of t)
      this.set(i[0], i[1], n) && r++;
    return r;
  }
  /**
   * Scans the specified range of keys, in ascending order by key.
   * Note: the callback `onFound` must not insert or remove items in the
   * collection. Doing so may cause incorrect data to be sent to the
   * callback afterward.
   * @param low The first key scanned will be greater than or equal to `low`.
   * @param high Scanning stops when a key larger than this is reached.
   * @param includeHigh If the `high` key is present, `onFound` is called for
   *        that final pair if and only if this parameter is true.
   * @param onFound A function that is called for each key-value pair. This
   *        function can return {break:R} to stop early with result R.
   * @param initialCounter Initial third argument of onFound. This value
   *        increases by one each time `onFound` is called. Default: 0
   * @returns The number of values found, or R if the callback returned
   *        `{break:R}` to stop early.
   * @description Computational complexity: O(number of items scanned + log size)
   */
  forRange(t, n, r, i, o) {
    const s = this._root.forRange(
      t,
      n,
      r,
      !1,
      this,
      o || 0,
      i
    );
    return typeof s == "number" ? s : s.break;
  }
  /**
   * Scans and potentially modifies values for a subsequence of keys.
   * Note: the callback `onFound` should ideally be a pure function.
   *   Specfically, it must not insert items, call clone(), or change
   *   the collection except via return value; out-of-band editing may
   *   cause an exception or may cause incorrect data to be sent to
   *   the callback (duplicate or missed items). It must not cause a
   *   clone() of the collection, otherwise the clone could be modified
   *   by changes requested by the callback.
   * @param low The first key scanned will be greater than or equal to `low`.
   * @param high Scanning stops when a key larger than this is reached.
   * @param includeHigh If the `high` key is present, `onFound` is called for
   *        that final pair if and only if this parameter is true.
   * @param onFound A function that is called for each key-value pair. This
   *        function can return `{value:v}` to change the value associated
   *        with the current key, `{delete:true}` to delete the current pair,
   *        `{break:R}` to stop early with result R, or it can return nothing
   *        (undefined or {}) to cause no effect and continue iterating.
   *        `{break:R}` can be combined with one of the other two commands.
   *        The third argument `counter` is the number of items iterated
   *        previously; it equals 0 when `onFound` is called the first time.
   * @returns The number of values scanned, or R if the callback returned
   *        `{break:R}` to stop early.
   * @description
   *   Computational complexity: O(number of items scanned + log size)
   *   Note: if the tree has been cloned with clone(), any shared
   *   nodes are copied before `onFound` is called. This takes O(n) time
   *   where n is proportional to the amount of shared data scanned.
   */
  editRange(t, n, r, i, o) {
    let s = this._root;
    s.isShared && (this._root = s = s.clone());
    try {
      const l = s.forRange(
        t,
        n,
        r,
        !0,
        this,
        o || 0,
        i
      );
      return typeof l == "number" ? l : l.break;
    } finally {
      let l;
      for (; s.keys.length <= 1 && !s.isLeaf; )
        l || (l = s.isShared), this._root = s = s.keys.length === 0 ? _V : s.children[0];
      l && (s.isShared = !0);
    }
  }
}
class zk {
  get isLeaf() {
    return this.children === void 0;
  }
  constructor(t = [], n) {
    this.keys = t, this.values = n || Us, this.isShared = void 0;
  }
  // /////////////////////////////////////////////////////////////////////////
  // Shared methods /////////////////////////////////////////////////////////
  maxKey() {
    return this.keys[this.keys.length - 1];
  }
  // If key not found, returns i^failXor where i is the insertion index.
  // Callers that don't care whether there was a match will set failXor=0.
  indexOf(t, n, r) {
    const i = this.keys;
    let o = 0, s = i.length, l = s >> 1;
    for (; o < s; ) {
      const c = r(i[l], t);
      if (c < 0) o = l + 1;
      else if (c > 0)
        s = l;
      else {
        if (c === 0) return l;
        if (t === t)
          return i.length;
        throw new Error("BTree: NaN was used as a key");
      }
      l = o + s >> 1;
    }
    return l ^ n;
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Leaf Node: misc //////////////////////////////////////////////////////////
  minKey() {
    return this.keys[0];
  }
  minPair(t) {
    if (this.keys.length !== 0)
      return t[0] = this.keys[0], t[1] = this.values[0], t;
  }
  maxPair(t) {
    if (this.keys.length === 0) return;
    const n = this.keys.length - 1;
    return t[0] = this.keys[n], t[1] = this.values[n], t;
  }
  clone() {
    const t = this.values;
    return new zk(this.keys.slice(0), t === Us ? t : t.slice(0));
  }
  get(t, n, r) {
    const i = this.indexOf(t, -1, r._compare);
    return i < 0 ? n : this.values[i];
  }
  getPairOrNextLower(t, n, r, i) {
    const o = this.indexOf(t, -1, n), s = o < 0 ? ~o - 1 : r ? o : o - 1;
    if (s >= 0)
      return i[0] = this.keys[s], i[1] = this.values[s], i;
  }
  getPairOrNextHigher(t, n, r, i) {
    const o = this.indexOf(t, -1, n), s = o < 0 ? ~o : r ? o : o + 1, l = this.keys;
    if (s < l.length)
      return i[0] = l[s], i[1] = this.values[s], i;
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Leaf Node: set & node splitting //////////////////////////////////////////
  set(t, n, r, i) {
    let o = this.indexOf(t, -1, i._compare);
    if (o < 0) {
      if (o = ~o, i._size++, this.keys.length < i._maxNodeSize)
        return this.insertInLeaf(o, t, n, i);
      {
        const s = this.splitOffRightSide();
        let l = this;
        return o > this.keys.length && (o -= this.keys.length, l = s), l.insertInLeaf(o, t, n, i), s;
      }
    } else
      return r !== !1 && (n !== void 0 && this.reifyValues(), this.keys[o] = t, this.values[o] = n), !1;
  }
  reifyValues() {
    return this.values === Us ? this.values = this.values.slice(0, this.keys.length) : this.values;
  }
  insertInLeaf(t, n, r, i) {
    if (this.keys.splice(t, 0, n), this.values === Us) {
      for (; Us.length < i._maxNodeSize; ) Us.push(void 0);
      if (r === void 0)
        return !0;
      this.values = Us.slice(0, this.keys.length - 1);
    }
    return this.values.splice(t, 0, r), !0;
  }
  takeFromRight(t) {
    let n = this.values;
    t.values === Us ? n !== Us && n.push(void 0) : (n = this.reifyValues(), n.push(t.values.shift())), this.keys.push(t.keys.shift());
  }
  takeFromLeft(t) {
    let n = this.values;
    t.values === Us ? n !== Us && n.unshift(void 0) : (n = this.reifyValues(), n.unshift(t.values.pop())), this.keys.unshift(t.keys.pop());
  }
  splitOffRightSide() {
    const t = this.keys.length >> 1, n = this.keys.splice(t), r = this.values === Us ? Us : this.values.splice(t);
    return new zk(n, r);
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Leaf Node: scanning & deletions //////////////////////////////////////////
  forRange(t, n, r, i, o, s, l) {
    const c = o._compare;
    let a, u;
    if (n === t) {
      if (!r || (u = (a = this.indexOf(t, -1, c)) + 1, a < 0)) return s;
    } else
      a = this.indexOf(t, 0, c), u = this.indexOf(n, -1, c), u < 0 ? u = ~u : r === !0 && u++;
    const f = this.keys, d = this.values;
    if (l !== void 0)
      for (let p = a; p < u; p++) {
        const h = f[p], m = l(h, d[p], s++);
        if (m !== void 0) {
          if (i === !0) {
            if (h !== f[p] || this.isShared === !0)
              throw new Error("BTree illegally changed or cloned in editRange");
            m.delete ? (this.keys.splice(p, 1), this.values !== Us && this.values.splice(p, 1), o._size--, p--, u--) : m.hasOwnProperty("value") && (d[p] = m.value);
          }
          if (m.break !== void 0) return m;
        }
      }
    else s += u - a;
    return s;
  }
  /** Adds entire contents of right-hand sibling (rhs is left unchanged) */
  mergeSibling(t, n) {
    if (this.keys.push.apply(this.keys, t.keys), this.values === Us) {
      if (t.values === Us) return;
      this.values = this.values.slice(0, this.keys.length);
    }
    this.values.push.apply(this.values, t.reifyValues());
  }
}
class uJ extends zk {
  /**
   * This does not mark `children` as shared, so it is the responsibility of the caller
   * to ensure children are either marked shared, or aren't included in another tree.
   */
  constructor(t, n) {
    if (!n) {
      n = [];
      for (let r = 0; r < t.length; r++) n[r] = t[r].maxKey();
    }
    super(n), this.children = t;
  }
  minKey() {
    return this.children[0].minKey();
  }
  minPair(t) {
    return this.children[0].minPair(t);
  }
  maxPair(t) {
    return this.children[this.children.length - 1].maxPair(t);
  }
  get(t, n, r) {
    const i = this.indexOf(t, 0, r._compare), o = this.children;
    return i < o.length ? o[i].get(t, n, r) : void 0;
  }
  getPairOrNextLower(t, n, r, i) {
    const o = this.indexOf(t, 0, n), s = this.children;
    if (o >= s.length) return this.maxPair(i);
    const l = s[o].getPairOrNextLower(
      t,
      n,
      r,
      i
    );
    return l === void 0 && o > 0 ? s[o - 1].maxPair(i) : l;
  }
  getPairOrNextHigher(t, n, r, i) {
    const o = this.indexOf(t, 0, n), s = this.children, l = s.length;
    if (o >= l) return;
    const c = s[o].getPairOrNextHigher(
      t,
      n,
      r,
      i
    );
    return c === void 0 && o < l - 1 ? s[o + 1].minPair(i) : c;
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Internal Node: set & node splitting //////////////////////////////////////
  set(t, n, r, i) {
    const o = this.children, s = i._maxNodeSize, l = i._compare;
    let c = Math.min(this.indexOf(t, 0, l), o.length - 1), a = o[c];
    if (a.isShared && (o[c] = a = a.clone()), a.keys.length >= s) {
      let f;
      c > 0 && (f = o[c - 1]).keys.length < s && l(a.keys[0], t) < 0 ? (f.isShared && (o[c - 1] = f = f.clone()), f.takeFromRight(a), this.keys[c - 1] = f.maxKey()) : (f = o[c + 1]) !== void 0 && f.keys.length < s && l(a.maxKey(), t) < 0 && (f.isShared && (o[c + 1] = f = f.clone()), f.takeFromLeft(a), this.keys[c] = o[c].maxKey());
    }
    const u = a.set(t, n, r, i);
    if (u === !1) return !1;
    if (this.keys[c] = a.maxKey(), u === !0) return !0;
    if (this.keys.length < s)
      return this.insert(c + 1, u), !0;
    {
      const f = this.splitOffRightSide();
      let d = this;
      return l(u.maxKey(), this.maxKey()) > 0 && (d = f, c -= this.keys.length), d.insert(c + 1, u), f;
    }
  }
  /**
   * Inserts `child` at index `i`.
   * This does not mark `child` as shared, so it is the responsibility of the caller
   * to ensure that either child is marked shared, or it is not included in another tree.
   */
  insert(t, n) {
    this.children.splice(t, 0, n), this.keys.splice(t, 0, n.maxKey());
  }
  /**
   * Split this node.
   * Modifies this to remove the second half of the items, returning a separate node containing them.
   */
  splitOffRightSide() {
    const t = this.children.length >> 1;
    return new uJ(
      this.children.splice(t),
      this.keys.splice(t)
    );
  }
  takeFromRight(t) {
    this.keys.push(t.keys.shift()), this.children.push(t.children.shift());
  }
  takeFromLeft(t) {
    this.keys.unshift(t.keys.pop()), this.children.unshift(t.children.pop());
  }
  // ///////////////////////////////////////////////////////////////////////////
  // Internal Node: scanning & deletions //////////////////////////////////////
  // Note: `count` is the next value of the third argument to `onFound`.
  //       A leaf node's `forRange` function returns a new value for this counter,
  //       unless the operation is to stop early.
  forRange(t, n, r, i, o, s, l) {
    const c = o._compare, a = this.keys, u = this.children;
    let f = this.indexOf(t, 0, c), d = f;
    const p = Math.min(
      n === t ? f : this.indexOf(n, 0, c),
      a.length - 1
    );
    if (i) {
      if (d <= p)
        try {
          for (; d <= p; d++) {
            u[d].isShared && (u[d] = u[d].clone());
            const h = u[d].forRange(
              t,
              n,
              r,
              i,
              o,
              s,
              l
            );
            if (a[d] = u[d].maxKey(), typeof h != "number") return h;
            s = h;
          }
        } finally {
          const h = o._maxNodeSize >> 1;
          for (f > 0 && f--, d = p; d >= f; d--)
            u[d].keys.length <= h && (u[d].keys.length !== 0 ? this.tryMerge(d, o._maxNodeSize) : (a.splice(d, 1), u.splice(d, 1)));
          u.length !== 0 && u[0].keys.length === 0 && qYt(!1, "emptiness bug");
        }
    } else for (; d <= p; d++) {
      const h = u[d].forRange(
        t,
        n,
        r,
        i,
        o,
        s,
        l
      );
      if (typeof h != "number") return h;
      s = h;
    }
    return s;
  }
  /** Merges child i with child i+1 if their combined size is not too large */
  tryMerge(t, n) {
    const r = this.children;
    return t >= 0 && t + 1 < r.length && r[t].keys.length + r[t + 1].keys.length <= n ? (r[t].isShared && (r[t] = r[t].clone()), r[t].mergeSibling(r[t + 1], n), r.splice(t + 1, 1), this.keys.splice(t + 1, 1), this.keys[t] = r[t].maxKey(), !0) : !1;
  }
  /**
   * Move children from `rhs` into this.
   * `rhs` must be part of this tree, and be removed from it after this call
   * (otherwise isShared for its children could be incorrect).
   */
  mergeSibling(t, n) {
    const r = this.keys.length;
    this.keys.push.apply(this.keys, t.keys);
    const i = t.children;
    if (this.children.push.apply(this.children, i), t.isShared && !this.isShared)
      for (const o of i) o.isShared = !0;
    this.tryMerge(r - 1, n);
  }
}
const Us = [], UYt = { delete: !0 }, VYt = () => UYt, _V = function() {
  const e = new zk();
  return e.isShared = !0, e;
}(), Che = [];
function qYt(e, ...t) {
  throw t.unshift("B+ tree"), new Error(t.join(" "));
}
function O6e() {
  const e = /* @__PURE__ */ new Map();
  function t(n) {
    const r = n.join(".");
    if (e.has(r))
      return e.get(r);
    const i = new Proxy({}, {
      get(o, s, l) {
        if (s === "__refProxy") return !0;
        if (s === "__path") return n;
        if (s === "__type") return;
        if (typeof s == "symbol") return Reflect.get(o, s, l);
        const c = [...n, String(s)];
        return t(c);
      },
      has(o, s) {
        return s === "__refProxy" || s === "__path" || s === "__type" ? !0 : Reflect.has(o, s);
      },
      ownKeys(o) {
        return Reflect.ownKeys(o);
      },
      getOwnPropertyDescriptor(o, s) {
        return s === "__refProxy" || s === "__path" || s === "__type" ? { enumerable: !1, configurable: !0 } : Reflect.getOwnPropertyDescriptor(o, s);
      }
    });
    return e.set(r, i), i;
  }
  return t([]);
}
function py(e) {
  const t = /* @__PURE__ */ new Map();
  let n = 0;
  function r(o) {
    const s = o.join(".");
    if (t.has(s))
      return t.get(s);
    const l = new Proxy({}, {
      get(c, a, u) {
        if (a === "__refProxy") return !0;
        if (a === "__path") return o;
        if (a === "__type") return;
        if (typeof a == "symbol") return Reflect.get(c, a, u);
        const f = [...o, String(a)];
        return r(f);
      },
      has(c, a) {
        return a === "__refProxy" || a === "__path" || a === "__type" ? !0 : Reflect.has(c, a);
      },
      ownKeys(c) {
        const a = ++n, u = `__SPREAD_SENTINEL__${o.join(".")}__${a}`;
        return Object.prototype.hasOwnProperty.call(c, u) || Object.defineProperty(c, u, {
          enumerable: !0,
          configurable: !0,
          value: !0
        }), Reflect.ownKeys(c);
      },
      getOwnPropertyDescriptor(c, a) {
        return a === "__refProxy" || a === "__path" || a === "__type" ? { enumerable: !1, configurable: !0 } : Reflect.getOwnPropertyDescriptor(c, a);
      }
    });
    return t.set(s, l), l;
  }
  return new Proxy({}, {
    get(o, s, l) {
      if (s === "__refProxy") return !0;
      if (s === "__path") return [];
      if (s === "__type") return;
      if (typeof s == "symbol") return Reflect.get(o, s, l);
      const c = String(s);
      if (e.includes(c))
        return r([c]);
    },
    has(o, s) {
      return s === "__refProxy" || s === "__path" || s === "__type" || typeof s == "string" && e.includes(s) ? !0 : Reflect.has(o, s);
    },
    ownKeys(o) {
      return [...e, "__refProxy", "__path", "__type"];
    },
    getOwnPropertyDescriptor(o, s) {
      if (s === "__refProxy" || s === "__path" || s === "__type")
        return { enumerable: !1, configurable: !0 };
      if (typeof s == "string" && e.includes(s))
        return { enumerable: !0, configurable: !0 };
    }
  });
}
function Nhe(e) {
  const t = py(e), n = /* @__PURE__ */ new Map();
  function r(o) {
    const s = o.join(".");
    if (n.has(s))
      return n.get(s);
    const l = new Proxy({}, {
      get(c, a, u) {
        if (a === "__refProxy") return !0;
        if (a === "__path") return ["$selected", ...o];
        if (a === "__type") return;
        if (typeof a == "symbol") return Reflect.get(c, a, u);
        const f = [...o, String(a)];
        return r(f);
      },
      has(c, a) {
        return a === "__refProxy" || a === "__path" || a === "__type" ? !0 : Reflect.has(c, a);
      },
      ownKeys(c) {
        return Reflect.ownKeys(c);
      },
      getOwnPropertyDescriptor(c, a) {
        return a === "__refProxy" || a === "__path" || a === "__type" ? { enumerable: !1, configurable: !0 } : Reflect.getOwnPropertyDescriptor(c, a);
      }
    });
    return n.set(s, l), l;
  }
  const i = r([]);
  return new Proxy(t, {
    get(o, s, l) {
      return s === "$selected" ? i : Reflect.get(o, s, l);
    },
    has(o, s) {
      return s === "$selected" ? !0 : Reflect.has(o, s);
    },
    ownKeys(o) {
      return [...Reflect.ownKeys(o), "$selected"];
    },
    getOwnPropertyDescriptor(o, s) {
      return s === "$selected" ? {
        enumerable: !0,
        configurable: !0,
        value: i
      } : Reflect.getOwnPropertyDescriptor(o, s);
    }
  });
}
function _o(e) {
  return BYt(e) ? new Ma(e.__path) : e && typeof e == "object" && "type" in e && (e.type === "func" || e.type === "ref" || e.type === "val" || e.type === "agg") ? e : new pl(e);
}
function BYt(e) {
  return e && typeof e == "object" && e.__refProxy === !0;
}
function cA(e, t) {
  return new bu("eq", [_o(e), _o(t)]);
}
function Phe(e, t) {
  return new bu("gt", [_o(e), _o(t)]);
}
function XYt(e, t) {
  return new bu("gte", [_o(e), _o(t)]);
}
function c7(e, t) {
  return new bu("lt", [_o(e), _o(t)]);
}
function u7(e, t, ...n) {
  const r = [e, t, ...n];
  return new bu(
    "and",
    r.map((i) => _o(i))
  );
}
function A6e(e, t, ...n) {
  const r = [e, t, ...n];
  return new bu(
    "or",
    r.map((i) => _o(i))
  );
}
function WYt(e, t) {
  return new bu("in", [_o(e), _o(t)]);
}
class ZYt {
  constructor(t, n, r, i) {
    this.lookupCount = 0, this.totalLookupTime = 0, this.lastUpdated = /* @__PURE__ */ new Date(), this.id = t, this.expression = n, this.compareOptions = aJ, this.name = r, this.initialize(i);
  }
  // Common methods
  supports(t) {
    return this.supportedOperations.has(t);
  }
  matchesField(t) {
    return this.expression.type === "ref" && this.expression.path.length === t.length && this.expression.path.every((n, r) => n === t[r]);
  }
  /**
   * Checks if the compare options match the index's compare options.
   * The direction is ignored because the index can be reversed if the direction is different.
   */
  matchesCompareOptions(t) {
    const n = {
      ...this.compareOptions,
      direction: void 0
    }, r = {
      ...t,
      direction: void 0
    };
    return Xu(
      n,
      r
    );
  }
  /**
   * Checks if the index matches the provided direction.
   */
  matchesDirection(t) {
    return this.compareOptions.direction === t;
  }
  getStats() {
    return {
      entryCount: this.keyCount,
      lookupCount: this.lookupCount,
      averageLookupTime: this.lookupCount > 0 ? this.totalLookupTime / this.lookupCount : 0,
      lastUpdated: this.lastUpdated
    };
  }
  evaluateIndexExpression(t) {
    return oJ(this.expression)(t);
  }
  trackLookup(t) {
    const n = performance.now() - t;
    this.lookupCount++, this.totalLookupTime += n;
  }
  updateTimestamp() {
    this.lastUpdated = /* @__PURE__ */ new Date();
  }
}
class d7 extends ZYt {
  constructor(t, n, r, i) {
    super(t, n, r, i), this.supportedOperations = /* @__PURE__ */ new Set([
      "eq",
      "gt",
      "gte",
      "lt",
      "lte",
      "in"
    ]), this.valueMap = /* @__PURE__ */ new Map(), this.indexedKeys = /* @__PURE__ */ new Set(), this.compareFn = o7, this.compareFn = (i == null ? void 0 : i.compareFn) ?? o7, i != null && i.compareOptions && (this.compareOptions = i.compareOptions), this.orderedEntries = new FYt(this.compareFn);
  }
  initialize(t) {
  }
  /**
   * Adds a value to the index
   */
  add(t, n) {
    let r;
    try {
      r = this.evaluateIndexExpression(n);
    } catch (o) {
      throw new Error(
        `Failed to evaluate index expression for key ${t}: ${o}`
      );
    }
    const i = Ep(r);
    if (this.valueMap.has(i))
      this.valueMap.get(i).add(t);
    else {
      const o = /* @__PURE__ */ new Set([t]);
      this.valueMap.set(i, o), this.orderedEntries.set(i, void 0);
    }
    this.indexedKeys.add(t), this.updateTimestamp();
  }
  /**
   * Removes a value from the index
   */
  remove(t, n) {
    let r;
    try {
      r = this.evaluateIndexExpression(n);
    } catch (o) {
      console.warn(
        `Failed to evaluate index expression for key ${t} during removal:`,
        o
      );
      return;
    }
    const i = Ep(r);
    if (this.valueMap.has(i)) {
      const o = this.valueMap.get(i);
      o.delete(t), o.size === 0 && (this.valueMap.delete(i), this.orderedEntries.delete(i));
    }
    this.indexedKeys.delete(t), this.updateTimestamp();
  }
  /**
   * Updates a value in the index
   */
  update(t, n, r) {
    this.remove(t, n), this.add(t, r);
  }
  /**
   * Builds the index from a collection of entries
   */
  build(t) {
    this.clear();
    for (const [n, r] of t)
      this.add(n, r);
  }
  /**
   * Clears all data from the index
   */
  clear() {
    this.orderedEntries.clear(), this.valueMap.clear(), this.indexedKeys.clear(), this.updateTimestamp();
  }
  /**
   * Performs a lookup operation
   */
  lookup(t, n) {
    const r = performance.now();
    let i;
    switch (t) {
      case "eq":
        i = this.equalityLookup(n);
        break;
      case "gt":
        i = this.rangeQuery({ from: n, fromInclusive: !1 });
        break;
      case "gte":
        i = this.rangeQuery({ from: n, fromInclusive: !0 });
        break;
      case "lt":
        i = this.rangeQuery({ to: n, toInclusive: !1 });
        break;
      case "lte":
        i = this.rangeQuery({ to: n, toInclusive: !0 });
        break;
      case "in":
        i = this.inArrayLookup(n);
        break;
      default:
        throw new Error(`Operation ${t} not supported by BTreeIndex`);
    }
    return this.trackLookup(r), i;
  }
  /**
   * Gets the number of indexed keys
   */
  get keyCount() {
    return this.indexedKeys.size;
  }
  // Public methods for backward compatibility (used by tests)
  /**
   * Performs an equality lookup
   */
  equalityLookup(t) {
    const n = Ep(t);
    return new Set(this.valueMap.get(n) ?? []);
  }
  /**
   * Performs a range query with options
   * This is more efficient for compound queries like "WHERE a > 5 AND a < 10"
   */
  rangeQuery(t = {}) {
    const { from: n, to: r, fromInclusive: i = !0, toInclusive: o = !0 } = t, s = /* @__PURE__ */ new Set(), l = Ep(n), c = Ep(r), a = l ?? this.orderedEntries.minKey(), u = c ?? this.orderedEntries.maxKey();
    return this.orderedEntries.forRange(
      a,
      u,
      o,
      (f, d) => {
        if (!i && this.compareFn(f, n) === 0)
          return;
        const p = this.valueMap.get(f);
        p && p.forEach((h) => s.add(h));
      }
    ), s;
  }
  /**
   * Performs a reversed range query
   */
  rangeQueryReversed(t = {}) {
    const { from: n, to: r, fromInclusive: i = !0, toInclusive: o = !0 } = t;
    return this.rangeQuery({
      from: r ?? this.orderedEntries.maxKey(),
      to: n ?? this.orderedEntries.minKey(),
      fromInclusive: o,
      toInclusive: i
    });
  }
  takeInternal(t, n, r, i, o = !1) {
    const s = /* @__PURE__ */ new Set(), l = [];
    let c, a = Ep(r);
    for (; (c = n(a)) !== void 0 && l.length < t; ) {
      a = c[0];
      const u = this.valueMap.get(a);
      if (u && u.size > 0) {
        const f = Array.from(u).sort(uL);
        o && f.reverse();
        for (const d of f) {
          if (l.length >= t) break;
          !s.has(d) && ((i == null ? void 0 : i(d)) ?? !0) && (l.push(d), s.add(d));
        }
      }
    }
    return l;
  }
  /**
   * Returns the next n items after the provided item or the first n items if no from item is provided.
   * @param n - The number of items to return
   * @param from - The item to start from (exclusive). Starts from the smallest item (inclusive) if not provided.
   * @returns The next n items after the provided key. Returns the first n items if no from item is provided.
   */
  take(t, n, r) {
    const i = (o) => this.orderedEntries.nextHigherPair(o);
    return this.takeInternal(t, i, n, r);
  }
  /**
   * Returns the next n items **before** the provided item (in descending order) or the last n items if no from item is provided.
   * @param n - The number of items to return
   * @param from - The item to start from (exclusive). Starts from the largest item (inclusive) if not provided.
   * @returns The next n items **before** the provided key. Returns the last n items if no from item is provided.
   */
  takeReversed(t, n, r) {
    const i = (o) => this.orderedEntries.nextLowerPair(o);
    return this.takeInternal(t, i, n, r, !0);
  }
  /**
   * Performs an IN array lookup
   */
  inArrayLookup(t) {
    const n = /* @__PURE__ */ new Set();
    for (const r of t) {
      const i = Ep(r), o = this.valueMap.get(i);
      o && o.forEach((s) => n.add(s));
    }
    return n;
  }
  // Getter methods for testing compatibility
  get indexedKeysSet() {
    return this.indexedKeys;
  }
  get orderedEntriesArray() {
    return this.orderedEntries.keysArray().map((t) => [t, this.valueMap.get(t) ?? /* @__PURE__ */ new Set()]);
  }
  get orderedEntriesArrayReversed() {
    return this.takeReversed(this.orderedEntries.size).map((t) => [
      t,
      this.valueMap.get(t) ?? /* @__PURE__ */ new Set()
    ]);
  }
  get valueMapData() {
    return this.valueMap;
  }
}
function w6e(e) {
  return e.config.autoIndex === "eager";
}
function k3(e, t, n, r, i) {
  if (!w6e(n))
    return;
  const o = r ?? {
    ...aJ,
    ...n.compareOptions
  };
  if (!Array.from(n.indexes.values()).find(
    (l) => l.matchesField(t) && l.matchesCompareOptions(o)
  ))
    try {
      n.createIndex(
        (l) => {
          let c = l;
          for (const a of t)
            c = c[a];
          return c;
        },
        {
          name: `auto:${t.join(".")}`,
          indexType: d7,
          options: i ? { compareFn: i, compareOptions: o } : {}
        }
      );
    } catch (l) {
      console.warn(
        `${n.id ? `[${n.id}] ` : ""}Failed to create auto-index for field path "${t.join(".")}":`,
        l
      );
    }
}
function HYt(e, t) {
  if (!w6e(t))
    return;
  const n = QYt(e);
  for (const { fieldName: r, fieldPath: i } of n)
    k3(r, i, t);
}
function QYt(e) {
  const t = [];
  function n(r) {
    if (r.type !== "func")
      return;
    const i = r;
    if (i.name === "and") {
      for (const a of i.args)
        n(a);
      return;
    }
    if (!["eq", "gt", "gte", "lt", "lte", "in"].includes(i.name) || i.args.length < 1 || i.args[0].type !== "ref")
      return;
    const l = i.args[0].path;
    if (l.length === 0)
      return;
    const c = l.join("_");
    t.push({ fieldName: c, fieldPath: l });
  }
  return n(e), t;
}
const { sum: $Yt, count: KYt, avg: GYt, min: YYt, max: JYt } = vYt;
function eJt(e, t) {
  const n = /* @__PURE__ */ new Map(), r = [...e];
  if (!t)
    return { selectToGroupByIndex: n, groupByExpressions: r };
  for (const [i, o] of Object.entries(t)) {
    if (o.type === "agg")
      continue;
    const s = r.findIndex(
      (l) => dL(o, l)
    );
    if (s === -1)
      throw new iGt(i);
    n.set(i, s);
  }
  return { selectToGroupByIndex: n, groupByExpressions: r };
}
function Ihe(e, t, n, r, i) {
  if (t.length === 0) {
    const a = {};
    if (r) {
      for (const [f, d] of Object.entries(r))
        if (d.type === "agg") {
          const p = d;
          a[f] = Rhe(p);
        }
    }
    const u = () => ({ __singleGroup: !0 });
    if (e = e.pipe(
      Ohe(u, a)
    ), e = e.pipe(
      Sa(([, f]) => {
        const p = { ...f.$selected || {} };
        if (r)
          for (const [h, m] of Object.entries(r))
            m.type === "agg" && (p[h] = f[h]);
        return [
          "single_group",
          {
            ...f,
            $selected: p
          }
        ];
      })
    ), n && n.length > 0)
      for (const f of n) {
        const d = she(f), p = fL(
          d,
          r || {},
          "$selected"
        ), h = hl(p);
        e = e.pipe(
          Vm(([, m]) => {
            const v = { $selected: m.$selected };
            return lA(h(v));
          })
        );
      }
    if (i && i.length > 0)
      for (const f of i)
        e = e.pipe(
          Vm(([, d]) => {
            const p = { $selected: d.$selected };
            return lA(f(p));
          })
        );
    return e;
  }
  const o = eJt(t, r), s = t.map(
    (a) => hl(a)
  ), l = ([, a]) => {
    const u = { ...a };
    delete u.$selected;
    const f = {};
    for (let d = 0; d < t.length; d++) {
      const p = s[d], h = p(u);
      f[`__key_${d}`] = h;
    }
    return f;
  }, c = {};
  if (r) {
    for (const [a, u] of Object.entries(r))
      if (u.type === "agg") {
        const f = u;
        c[a] = Rhe(f);
      }
  }
  if (e = e.pipe(Ohe(l, c)), e = e.pipe(
    Sa(([, a]) => {
      const u = a.$selected || {}, f = {};
      if (r)
        for (const [p, h] of Object.entries(r))
          if (h.type !== "agg") {
            const m = o.selectToGroupByIndex.get(p);
            m !== void 0 ? f[p] = a[`__key_${m}`] : f[p] = u[p];
          } else
            f[p] = a[p];
      else
        for (let p = 0; p < t.length; p++)
          f[`__key_${p}`] = a[`__key_${p}`];
      let d;
      if (t.length === 1)
        d = a.__key_0;
      else {
        const p = [];
        for (let h = 0; h < t.length; h++)
          p.push(a[`__key_${h}`]);
        d = u6e(p);
      }
      return [
        d,
        {
          ...a,
          $selected: f
        }
      ];
    })
  ), n && n.length > 0)
    for (const a of n) {
      const u = she(a), f = fL(
        u,
        r || {}
      ), d = hl(f);
      e = e.pipe(
        Vm(([, p]) => {
          const h = { $selected: p.$selected };
          return d(h);
        })
      );
    }
  if (i && i.length > 0)
    for (const a of i)
      e = e.pipe(
        Vm(([, u]) => {
          const f = { $selected: u.$selected };
          return lA(a(f));
        })
      );
  return e;
}
function dL(e, t) {
  var n, r, i, o;
  if (!e || !t || e.type !== t.type) return !1;
  switch (e.type) {
    case "ref":
      return !e.path || !t.path || e.path.length !== t.path.length ? !1 : e.path.every(
        (s, l) => s === t.path[l]
      );
    case "val":
      return e.value === t.value;
    case "func":
      return e.name === t.name && ((n = e.args) == null ? void 0 : n.length) === ((r = t.args) == null ? void 0 : r.length) && (e.args || []).every(
        (s, l) => dL(s, t.args[l])
      );
    case "agg":
      return e.name === t.name && ((i = e.args) == null ? void 0 : i.length) === ((o = t.args) == null ? void 0 : o.length) && (e.args || []).every(
        (s, l) => dL(s, t.args[l])
      );
    default:
      return !1;
  }
}
function Rhe(e) {
  const t = hl(e.args[0]), n = ([, o]) => {
    const s = t(o);
    return typeof s == "number" ? s : s != null ? Number(s) : 0;
  }, r = ([, o]) => {
    const s = t(o);
    return typeof s == "number" || s instanceof Date ? s : s != null ? Number(s) : 0;
  }, i = ([, o]) => t(o);
  switch (e.name.toLowerCase()) {
    case "sum":
      return $Yt(n);
    case "count":
      return KYt(i);
    case "avg":
      return GYt(n);
    case "min":
      return YYt(r);
    case "max":
      return JYt(r);
    default:
      throw new oGt(e.name);
  }
}
function fL(e, t, n = "$selected") {
  switch (e.type) {
    case "agg": {
      const r = e;
      for (const [i, o] of Object.entries(t))
        if (o.type === "agg" && tJt(r, o))
          return new Ma([n, i]);
      throw new sGt(r.name);
    }
    case "func": {
      const r = e, i = r.args.map(
        (o) => fL(o, t)
      );
      return new bu(r.name, i);
    }
    case "ref": {
      const i = e.path;
      if (i.length === 0)
        return e;
      if (i.length > 0 && i[0] === "$selected") {
        const o = i.slice(1);
        return o.length === 0 || o.join(".") in t, e;
      }
      return e;
    }
    case "val":
      return e;
    default:
      throw new aGt(e.type);
  }
}
function tJt(e, t) {
  return e.name === t.name && e.args.length === t.args.length && e.args.every((n, r) => dL(n, t.args[r]));
}
function nJt(e, t, n, r, i, o, s, l, c) {
  const a = n.map((h) => {
    const m = fL(
      h.expression,
      r,
      "$selected"
    );
    return {
      compiledExpression: hl(m),
      compareOptions: f7(h, i)
    };
  }), u = (h) => {
    const m = h;
    return n.length > 1 ? a.map(
      (v) => v.compiledExpression(m)
    ) : n.length === 1 ? a[0].compiledExpression(m) : null;
  }, f = (h, m) => {
    if (n.length > 1) {
      const v = h, b = m;
      for (let A = 0; A < n.length; A++) {
        const w = a[A], x = cL(w.compareOptions)(v[A], b[A]);
        if (x !== 0)
          return x;
      }
      return v.length - b.length;
    }
    if (n.length === 1) {
      const v = a[0];
      return cL(v.compareOptions)(h, m);
    }
    return o7(h, m);
  };
  let d, p;
  if (l) {
    let h, m, v, b = e.from.alias;
    const A = n[0], w = A.expression;
    if (w.type === "ref") {
      const O = _k(
        e,
        w,
        i
      );
      if (O) {
        m = O.collection;
        const x = O.path[0], S = f7(
          A,
          m
        );
        x && k3(
          x,
          O.path,
          m,
          S,
          f
        ), v = hl(
          new Ma(O.path),
          !0
        ), h = QN(
          m,
          O.path,
          S
        ), h != null && h.supports("gt") || (h = void 0), b = w.path.length > 1 ? String(w.path[0]) : e.from.alias;
      }
    }
    if (v) {
      const x = n.every(
        (T) => T.expression.type === "ref"
      ) ? n.map((T) => {
        const R = T.expression, j = _k(e, R, i);
        return hl(
          j ? new Ma(j.path) : T.expression,
          !0
        );
      }) : void 0;
      p = {
        alias: b,
        offset: c ?? 0,
        limit: l,
        comparator: (T, R) => {
          if (n.length === 1) {
            const j = T && v(T), F = R && v(R);
            return f(j, F);
          }
          if (x) {
            const j = (F) => F && x.map((L) => L(F));
            return f(j(T), j(R));
          }
          return 0;
        },
        valueExtractorForRawRow: (T) => {
          if (n.length === 1)
            return v(T);
          if (x)
            return x.map((R) => R(T));
        },
        firstColumnValueExtractor: v,
        index: h,
        orderBy: n
      };
      const k = (m == null ? void 0 : m.id) ?? i.id;
      o[k] = p, h && (d = (T) => {
        o[k].dataNeeded = () => {
          const R = T();
          return Math.max(0, p.limit - R);
        };
      });
    }
  }
  return t.pipe(
    jYt(u, {
      limit: l,
      offset: c,
      comparator: f,
      setSizeCallback: d,
      setWindowFn: (h) => {
        s(
          // We wrap the move function such that we update the orderByOptimizationInfo
          // because that is used by the `dataNeeded` callback to determine if we need to load more data
          (m) => {
            h(m), p && (p.offset = m.offset ?? p.offset, p.limit = m.limit ?? p.limit);
          }
        );
      }
    })
    // orderByWithFractionalIndex returns [key, [value, index]] - we keep this format
  );
}
function f7(e, t) {
  return e.compareOptions.stringSort !== void 0 ? e.compareOptions : {
    ...t.compareOptions,
    direction: e.compareOptions.direction,
    nulls: e.compareOptions.nulls
  };
}
function rJt(e, t = {}) {
  const n = (r) => {
    const i = [];
    for (const [o, s] of e.entries())
      ((r == null ? void 0 : r(s)) ?? !0) && i.push({
        type: "insert",
        key: o,
        value: s
      });
    return i;
  };
  if (t.limit !== void 0 && !t.orderBy)
    throw new Error("limit cannot be used without orderBy");
  if (t.orderBy) {
    const r = t.where ? KE(t.where) : void 0, i = oJt(
      e,
      t.orderBy,
      t.limit,
      r,
      t.optimizedOnly
    );
    if (i === void 0)
      return;
    const o = [];
    for (const s of i) {
      const l = e.get(s);
      l !== void 0 && o.push({
        type: "insert",
        key: s,
        value: l
      });
    }
    return o;
  }
  if (!t.where)
    return n();
  try {
    const r = t.where, i = EGt(
      r,
      e
    );
    if (i.canOptimize) {
      const o = [];
      for (const s of i.matchingKeys) {
        const l = e.get(s);
        l !== void 0 && o.push({
          type: "insert",
          key: s,
          value: l
        });
      }
      return o;
    } else {
      if (t.optimizedOnly)
        return;
      const o = KE(r);
      return n(o);
    }
  } catch (r) {
    console.warn(
      `${e.id ? `[${e.id}] ` : ""}Error processing where clause, falling back to full scan:`,
      r
    );
    const i = KE(t.where);
    return t.optimizedOnly ? void 0 : n(i);
  }
}
function KE(e) {
  const t = oJ(e);
  return (n) => {
    try {
      const r = t(n);
      return lA(r);
    } catch {
      return !1;
    }
  };
}
function iJt(e, t) {
  const n = KE(t.whereExpression);
  return (r) => {
    const i = [];
    for (const o of r)
      if (o.type === "insert")
        n(o.value) && i.push(o);
      else if (o.type === "update") {
        const s = n(o.value), l = o.previousValue ? n(o.previousValue) : !1;
        s && l ? i.push(o) : s && !l ? i.push({
          ...o,
          type: "insert"
        }) : !s && l && i.push({
          ...o,
          type: "delete",
          value: o.previousValue
          // Use the previous value for the delete
        });
      } else
        n(o.value) && i.push(o);
    (i.length > 0 || r.length === 0) && e(i);
  };
}
function oJt(e, t, n, r, i) {
  if (t.length === 1) {
    const c = t[0], a = c.expression;
    if (a.type === "ref") {
      const f = a.path, d = f7(c, e);
      k3(
        f[0],
        f,
        e,
        d
      );
      const p = QN(e, f, d);
      if (p && p.supports("gt")) {
        const h = (m) => {
          const v = e.get(m);
          return v === void 0 ? !1 : (r == null ? void 0 : r(v)) ?? !0;
        };
        return p.take(n ?? p.keyCount, void 0, h);
      }
    }
  }
  if (i)
    return;
  const o = [];
  for (const [c, a] of e.entries())
    ((r == null ? void 0 : r(a)) ?? !0) && o.push({ key: c, value: a });
  const s = (c, a) => {
    for (const u of t) {
      const f = cL(u.compareOptions), d = Mhe(c.value, u.expression), p = Mhe(a.value, u.expression), h = f(d, p);
      if (h !== 0)
        return h;
    }
    return 0;
  };
  o.sort(s);
  const l = o.map((c) => c.key);
  return n !== void 0 ? l.slice(0, n) : l;
}
function Mhe(e, t) {
  if (t.type === "ref") {
    const n = t;
    let r = e;
    for (const i of n.path)
      r = r == null ? void 0 : r[i];
    return r;
  } else return t.type === "val" ? t.value : oJ(t)(e);
}
class Dhe {
  /**
   * Creates a new SortedMap instance
   *
   * @param comparator - Optional function to compare values for sorting.
   *                     If not provided, entries are sorted by key only.
   */
  constructor(t) {
    this.map = /* @__PURE__ */ new Map(), this.sortedKeys = [], this.comparator = t;
  }
  /**
   * Finds the index where a key-value pair should be inserted to maintain sort order.
   * Uses binary search to find the correct position based on the value (if comparator provided),
   * with key-based tie-breaking for deterministic ordering when values compare as equal.
   * If no comparator is provided, sorts by key only.
   * Runs in O(log n) time.
   *
   * @param key - The key to find position for (used as tie-breaker or primary sort when no comparator)
   * @param value - The value to compare against (only used if comparator is provided)
   * @returns The index where the key should be inserted
   */
  indexOf(t, n) {
    let r = 0, i = this.sortedKeys.length;
    if (!this.comparator) {
      for (; r < i; ) {
        const o = Math.floor((r + i) / 2), s = this.sortedKeys[o], l = uL(t, s);
        if (l < 0)
          i = o;
        else if (l > 0)
          r = o + 1;
        else
          return o;
      }
      return r;
    }
    for (; r < i; ) {
      const o = Math.floor((r + i) / 2), s = this.sortedKeys[o], l = this.map.get(s), c = this.comparator(n, l);
      if (c < 0)
        i = o;
      else if (c > 0)
        r = o + 1;
      else {
        const a = uL(t, s);
        if (a < 0)
          i = o;
        else if (a > 0)
          r = o + 1;
        else
          return o;
      }
    }
    return r;
  }
  /**
   * Sets a key-value pair in the map and maintains sort order
   *
   * @param key - The key to set
   * @param value - The value to associate with the key
   * @returns This SortedMap instance for chaining
   */
  set(t, n) {
    if (this.map.has(t)) {
      const i = this.map.get(t), o = this.indexOf(t, i);
      this.sortedKeys.splice(o, 1);
    }
    const r = this.indexOf(t, n);
    return this.sortedKeys.splice(r, 0, t), this.map.set(t, n), this;
  }
  /**
   * Gets a value by its key
   *
   * @param key - The key to look up
   * @returns The value associated with the key, or undefined if not found
   */
  get(t) {
    return this.map.get(t);
  }
  /**
   * Removes a key-value pair from the map
   *
   * @param key - The key to remove
   * @returns True if the key was found and removed, false otherwise
   */
  delete(t) {
    if (this.map.has(t)) {
      const n = this.map.get(t), r = this.indexOf(t, n);
      return this.sortedKeys.splice(r, 1), this.map.delete(t);
    }
    return !1;
  }
  /**
   * Checks if a key exists in the map
   *
   * @param key - The key to check
   * @returns True if the key exists, false otherwise
   */
  has(t) {
    return this.map.has(t);
  }
  /**
   * Removes all key-value pairs from the map
   */
  clear() {
    this.map.clear(), this.sortedKeys = [];
  }
  /**
   * Gets the number of key-value pairs in the map
   */
  get size() {
    return this.map.size;
  }
  /**
   * Default iterator that returns entries in sorted order
   *
   * @returns An iterator for the map's entries
   */
  *[Symbol.iterator]() {
    for (const t of this.sortedKeys)
      yield [t, this.map.get(t)];
  }
  /**
   * Returns an iterator for the map's entries in sorted order
   *
   * @returns An iterator for the map's entries
   */
  entries() {
    return this[Symbol.iterator]();
  }
  /**
   * Returns an iterator for the map's keys in sorted order
   *
   * @returns An iterator for the map's keys
   */
  keys() {
    return this.sortedKeys[Symbol.iterator]();
  }
  /**
   * Returns an iterator for the map's values in sorted order
   *
   * @returns An iterator for the map's values
   */
  values() {
    return (function* () {
      for (const t of this.sortedKeys)
        yield this.map.get(t);
    }).call(this);
  }
  /**
   * Executes a callback function for each key-value pair in the map in sorted order
   *
   * @param callbackfn - Function to execute for each entry
   */
  forEach(t) {
    for (const n of this.sortedKeys)
      t(this.map.get(n), n, this.map);
  }
}
class sJt {
  /**
   * Creates a new CollectionState manager
   */
  constructor(t) {
    this.pendingSyncedTransactions = [], this.syncedMetadata = /* @__PURE__ */ new Map(), this.optimisticUpserts = /* @__PURE__ */ new Map(), this.optimisticDeletes = /* @__PURE__ */ new Set(), this.size = 0, this.syncedKeys = /* @__PURE__ */ new Set(), this.preSyncVisibleState = /* @__PURE__ */ new Map(), this.recentlySyncedKeys = /* @__PURE__ */ new Set(), this.hasReceivedFirstCommit = !1, this.isCommittingSyncTransactions = !1, this.commitPendingTransactions = () => {
      var s;
      let n = !1;
      for (const l of this.transactions.values())
        if (l.state === "persisting") {
          n = !0;
          break;
        }
      const {
        committedSyncedTransactions: r,
        uncommittedSyncedTransactions: i,
        hasTruncateSync: o
      } = this.pendingSyncedTransactions.reduce(
        (l, c) => (c.committed ? (l.committedSyncedTransactions.push(c), c.truncate === !0 && (l.hasTruncateSync = !0)) : l.uncommittedSyncedTransactions.push(c), l),
        {
          committedSyncedTransactions: [],
          uncommittedSyncedTransactions: [],
          hasTruncateSync: !1
        }
      );
      if (!n || o) {
        this.isCommittingSyncTransactions = !0;
        const l = o ? (s = r.find((p) => p.truncate)) == null ? void 0 : s.optimisticSnapshot : null, c = /* @__PURE__ */ new Set();
        for (const p of r)
          for (const h of p.operations)
            c.add(h.key);
        let a = this.preSyncVisibleState;
        if (a.size === 0) {
          a = /* @__PURE__ */ new Map();
          for (const p of c) {
            const h = this.get(p);
            h !== void 0 && a.set(p, h);
          }
        }
        const u = [], f = this.config.sync.rowUpdateMode || "partial";
        for (const p of r) {
          if (p.truncate) {
            const h = /* @__PURE__ */ new Set([
              ...this.syncedData.keys(),
              ...(l == null ? void 0 : l.upserts.keys()) || []
            ]);
            for (const m of h) {
              if (l != null && l.deletes.has(m)) continue;
              const v = (l == null ? void 0 : l.upserts.get(m)) || this.syncedData.get(m);
              v !== void 0 && u.push({ type: "delete", key: m, value: v });
            }
            this.syncedData.clear(), this.syncedMetadata.clear(), this.syncedKeys.clear();
            for (const m of c)
              a.delete(m);
            this._events.emit("truncate", {
              type: "truncate",
              collection: this.collection
            });
          }
          for (const h of p.operations) {
            const m = h.key;
            switch (this.syncedKeys.add(m), h.type) {
              case "insert":
                this.syncedMetadata.set(m, h.metadata);
                break;
              case "update":
                this.syncedMetadata.set(
                  m,
                  Object.assign(
                    {},
                    this.syncedMetadata.get(m),
                    h.metadata
                  )
                );
                break;
              case "delete":
                this.syncedMetadata.delete(m);
                break;
            }
            switch (h.type) {
              case "insert":
                this.syncedData.set(m, h.value);
                break;
              case "update": {
                if (f === "partial") {
                  const v = Object.assign(
                    {},
                    this.syncedData.get(m),
                    h.value
                  );
                  this.syncedData.set(m, v);
                } else
                  this.syncedData.set(m, h.value);
                break;
              }
              case "delete":
                this.syncedData.delete(m);
                break;
            }
          }
        }
        if (o) {
          const p = /* @__PURE__ */ new Set();
          for (const v of r)
            for (const b of v.operations)
              (b.type === "insert" || b.type === "update") && p.add(b.key);
          const h = new Map(
            l.upserts
          ), m = new Set(
            l.deletes
          );
          for (const [v, b] of h)
            if (!m.has(v))
              if (p.has(v)) {
                let A = !1;
                for (let w = u.length - 1; w >= 0; w--) {
                  const O = u[w];
                  if (O.key === v && O.type === "insert") {
                    O.value = b, A = !0;
                    break;
                  }
                }
                A || u.push({ type: "insert", key: v, value: b });
              } else
                u.push({ type: "insert", key: v, value: b });
          if (u.length > 0 && m.size > 0) {
            const v = [];
            for (const b of u)
              b.type === "insert" && m.has(b.key) || v.push(b);
            u.length = 0, u.push(...v);
          }
          this.lifecycle.status !== "ready" && this.lifecycle.markReady();
        }
        if (this.optimisticUpserts.clear(), this.optimisticDeletes.clear(), this.isCommittingSyncTransactions = !1, o && l) {
          for (const [p, h] of l.upserts)
            this.optimisticUpserts.set(p, h);
          for (const p of l.deletes)
            this.optimisticDeletes.add(p);
        }
        for (const p of this.transactions.values())
          if (!["completed", "failed"].includes(p.state)) {
            for (const h of p.mutations)
              if (this.isThisCollection(h.collection) && h.optimistic)
                switch (h.type) {
                  case "insert":
                  case "update":
                    this.optimisticUpserts.set(
                      h.key,
                      h.modified
                    ), this.optimisticDeletes.delete(h.key);
                    break;
                  case "delete":
                    this.optimisticUpserts.delete(h.key), this.optimisticDeletes.add(h.key);
                    break;
                }
          }
        const d = /* @__PURE__ */ new Map();
        for (const p of this.transactions.values())
          if (p.state === "completed")
            for (const h of p.mutations)
              h.optimistic && this.isThisCollection(h.collection) && c.has(h.key) && d.set(h.key, {
                type: h.type,
                value: h.modified
              });
        for (const p of c) {
          const h = a.get(p), m = this.get(p), v = d.get(p);
          let b = !1;
          v && (v.type === "delete" && h !== void 0 && m === void 0 && Xu(v.value, h) || m !== void 0 && Xu(v.value, m)) && (b = !0), b || (h === void 0 && m !== void 0 ? u.push({
            type: "insert",
            key: p,
            value: m
          }) : h !== void 0 && m === void 0 ? u.push({
            type: "delete",
            key: p,
            value: h
          }) : h !== void 0 && m !== void 0 && !Xu(h, m) && u.push({
            type: "update",
            key: p,
            value: m,
            previousValue: h
          }));
        }
        this.size = this.calculateSize(), u.length > 0 && this.indexes.updateIndexes(u), this.changes.emitEvents(u, !0), this.pendingSyncedTransactions = i, this.preSyncVisibleState.clear(), Promise.resolve().then(() => {
          this.recentlySyncedKeys.clear();
        }), this.hasReceivedFirstCommit || (this.hasReceivedFirstCommit = !0);
      }
    }, this.config = t, this.transactions = new Dhe(
      (n, r) => n.compareCreatedAt(r)
    ), this.syncedData = new Dhe(t.compare);
  }
  setDeps(t) {
    this.collection = t.collection, this.lifecycle = t.lifecycle, this.changes = t.changes, this.indexes = t.indexes, this._events = t.events;
  }
  /**
   * Get the current value for a key (virtual derived state)
   */
  get(t) {
    const { optimisticDeletes: n, optimisticUpserts: r, syncedData: i } = this;
    if (!n.has(t))
      return r.has(t) ? r.get(t) : i.get(t);
  }
  /**
   * Check if a key exists in the collection (virtual derived state)
   */
  has(t) {
    const { optimisticDeletes: n, optimisticUpserts: r, syncedData: i } = this;
    return n.has(t) ? !1 : r.has(t) ? !0 : i.has(t);
  }
  /**
   * Get all keys (virtual derived state)
   */
  *keys() {
    const { syncedData: t, optimisticDeletes: n, optimisticUpserts: r } = this;
    for (const i of t.keys())
      n.has(i) || (yield i);
    for (const i of r.keys())
      !t.has(i) && !n.has(i) && (yield i);
  }
  /**
   * Get all values (virtual derived state)
   */
  *values() {
    for (const t of this.keys()) {
      const n = this.get(t);
      n !== void 0 && (yield n);
    }
  }
  /**
   * Get all entries (virtual derived state)
   */
  *entries() {
    for (const t of this.keys()) {
      const n = this.get(t);
      n !== void 0 && (yield [t, n]);
    }
  }
  /**
   * Get all entries (virtual derived state)
   */
  *[Symbol.iterator]() {
    for (const [t, n] of this.entries())
      yield [t, n];
  }
  /**
   * Execute a callback for each entry in the collection
   */
  forEach(t) {
    let n = 0;
    for (const [r, i] of this.entries())
      t(i, r, n++);
  }
  /**
   * Create a new array with the results of calling a function for each entry in the collection
   */
  map(t) {
    const n = [];
    let r = 0;
    for (const [i, o] of this.entries())
      n.push(t(o, i, r++));
    return n;
  }
  /**
   * Check if the given collection is this collection
   * @param collection The collection to check
   * @returns True if the given collection is this collection, false otherwise
   */
  isThisCollection(t) {
    return t === this.collection;
  }
  /**
   * Recompute optimistic state from active transactions
   */
  recomputeOptimisticState(t = !1) {
    if (this.isCommittingSyncTransactions && !t)
      return;
    const n = new Map(this.optimisticUpserts), r = new Set(this.optimisticDeletes);
    this.optimisticUpserts.clear(), this.optimisticDeletes.clear();
    const i = [];
    for (const l of this.transactions.values())
      ["completed", "failed"].includes(l.state) || i.push(l);
    for (const l of i)
      for (const c of l.mutations)
        if (this.isThisCollection(c.collection) && c.optimistic)
          switch (c.type) {
            case "insert":
            case "update":
              this.optimisticUpserts.set(
                c.key,
                c.modified
              ), this.optimisticDeletes.delete(c.key);
              break;
            case "delete":
              this.optimisticUpserts.delete(c.key), this.optimisticDeletes.add(c.key);
              break;
          }
    this.size = this.calculateSize();
    const o = [];
    this.collectOptimisticChanges(n, r, o);
    const s = o.filter((l) => !!(!this.recentlySyncedKeys.has(l.key) || t));
    if (this.pendingSyncedTransactions.length > 0 && !t) {
      const l = /* @__PURE__ */ new Set();
      for (const a of this.pendingSyncedTransactions)
        for (const u of a.operations)
          l.add(u.key);
      const c = s.filter((a) => !(a.type === "delete" && l.has(a.key) && !i.some(
        (f) => f.mutations.some(
          (d) => this.isThisCollection(d.collection) && d.key === a.key
        )
      )));
      c.length > 0 && this.indexes.updateIndexes(c), this.changes.emitEvents(c, t);
    } else
      s.length > 0 && this.indexes.updateIndexes(s), this.changes.emitEvents(s, t);
  }
  /**
   * Calculate the current size based on synced data and optimistic changes
   */
  calculateSize() {
    const t = this.syncedData.size, n = Array.from(this.optimisticDeletes).filter(
      (i) => this.syncedData.has(i) && !this.optimisticUpserts.has(i)
    ).length, r = Array.from(this.optimisticUpserts.keys()).filter(
      (i) => !this.syncedData.has(i)
    ).length;
    return t - n + r;
  }
  /**
   * Collect events for optimistic changes
   */
  collectOptimisticChanges(t, n, r) {
    const i = /* @__PURE__ */ new Set([
      ...t.keys(),
      ...this.optimisticUpserts.keys(),
      ...n,
      ...this.optimisticDeletes
    ]);
    for (const o of i) {
      const s = this.get(o), l = this.getPreviousValue(
        o,
        t,
        n
      );
      l !== void 0 && s === void 0 ? r.push({ type: "delete", key: o, value: l }) : l === void 0 && s !== void 0 ? r.push({ type: "insert", key: o, value: s }) : l !== void 0 && s !== void 0 && l !== s && r.push({
        type: "update",
        key: o,
        value: s,
        previousValue: l
      });
    }
  }
  /**
   * Get the previous value for a key given previous optimistic state
   */
  getPreviousValue(t, n, r) {
    if (!r.has(t))
      return n.has(t) ? n.get(t) : this.syncedData.get(t);
  }
  /**
   * Schedule cleanup of a transaction when it completes
   */
  scheduleTransactionCleanup(t) {
    if (t.state === "completed") {
      this.transactions.delete(t.id);
      return;
    }
    t.isPersisted.promise.then(() => {
      this.transactions.delete(t.id);
    }).catch(() => {
    });
  }
  /**
   * Capture visible state for keys that will be affected by pending sync operations
   * This must be called BEFORE onTransactionStateChange clears optimistic state
   */
  capturePreSyncVisibleState() {
    if (this.pendingSyncedTransactions.length === 0) return;
    const t = /* @__PURE__ */ new Set();
    for (const n of this.pendingSyncedTransactions)
      for (const r of n.operations)
        t.add(r.key);
    for (const n of t)
      this.recentlySyncedKeys.add(n);
    for (const n of t)
      if (!this.preSyncVisibleState.has(n)) {
        const r = this.get(n);
        r !== void 0 && this.preSyncVisibleState.set(n, r);
      }
  }
  /**
   * Trigger a recomputation when transactions change
   * This method should be called by the Transaction class when state changes
   */
  onTransactionStateChange() {
    this.changes.shouldBatchEvents = this.pendingSyncedTransactions.length > 0, this.capturePreSyncVisibleState(), this.recomputeOptimisticState(!1);
  }
  /**
   * Clean up the collection by stopping sync and clearing data
   * This can be called manually or automatically by garbage collection
   */
  cleanup() {
    this.syncedData.clear(), this.syncedMetadata.clear(), this.optimisticUpserts.clear(), this.optimisticDeletes.clear(), this.size = 0, this.pendingSyncedTransactions = [], this.syncedKeys.clear(), this.hasReceivedFirstCommit = !1;
  }
}
class x6e {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
  }
  /**
   * Subscribe to an event
   * @param event - Event name to listen for
   * @param callback - Function to call when event is emitted
   * @returns Unsubscribe function
   */
  on(t, n) {
    return this.listeners.has(t) || this.listeners.set(t, /* @__PURE__ */ new Set()), this.listeners.get(t).add(n), () => {
      var r;
      (r = this.listeners.get(t)) == null || r.delete(n);
    };
  }
  /**
   * Subscribe to an event once (automatically unsubscribes after first emission)
   * @param event - Event name to listen for
   * @param callback - Function to call when event is emitted
   * @returns Unsubscribe function
   */
  once(t, n) {
    const r = this.on(t, (i) => {
      n(i), r();
    });
    return r;
  }
  /**
   * Unsubscribe from an event
   * @param event - Event name to stop listening for
   * @param callback - Function to remove
   */
  off(t, n) {
    var r;
    (r = this.listeners.get(t)) == null || r.delete(n);
  }
  /**
   * Wait for an event to be emitted
   * @param event - Event name to wait for
   * @param timeout - Optional timeout in milliseconds
   * @returns Promise that resolves with the event payload
   */
  waitFor(t, n) {
    return new Promise((r, i) => {
      let o;
      const s = this.on(t, (l) => {
        o && (clearTimeout(o), o = void 0), r(l), s();
      });
      n && (o = setTimeout(() => {
        o = void 0, s(), i(new Error(`Timeout waiting for event ${String(t)}`));
      }, n));
    });
  }
  /**
   * Emit an event to all listeners
   * @param event - Event name to emit
   * @param eventPayload - Event payload
   * @internal For use by subclasses - subclasses should wrap this with a public emit if needed
   */
  emitInner(t, n) {
    var r;
    (r = this.listeners.get(t)) == null || r.forEach((i) => {
      try {
        i(n);
      } catch (o) {
        queueMicrotask(() => {
          throw o;
        });
      }
    });
  }
  /**
   * Clear all listeners
   */
  clearListeners() {
    this.listeners.clear();
  }
}
function aJt(e, t) {
  if (t.length === 0 || e.length === 0)
    return;
  if (e.length === 1) {
    const { expression: r, compareOptions: i } = e[0];
    return (i.direction === "asc" ? Phe : c7)(r, new pl(t[0]));
  }
  const n = [];
  for (let r = 0; r < e.length && r < t.length; r++) {
    const i = e[r], o = t[r], s = [];
    for (let a = 0; a < r; a++) {
      const u = e[a], f = t[a];
      s.push(cA(u.expression, new pl(f)));
    }
    const c = (i.compareOptions.direction === "asc" ? Phe : c7)(i.expression, new pl(o));
    if (s.length === 0)
      n.push(c);
    else {
      const a = [...s, c];
      n.push(a.reduce((u, f) => u7(u, f)));
    }
  }
  return n.length === 1 ? n[0] : n.reduce((r, i) => A6e(r, i));
}
class lJt extends x6e {
  constructor(t, n, r) {
    super(), this.collection = t, this.callback = n, this.options = r, this.loadedInitialState = !1, this.skipFiltering = !1, this.snapshotSent = !1, this.loadedSubsets = [], this.sentKeys = /* @__PURE__ */ new Set(), this.limitedSnapshotRowCount = 0, this._status = "ready", this.pendingLoadSubsetPromises = /* @__PURE__ */ new Set(), this.isBufferingForTruncate = !1, this.truncateBuffer = [], this.pendingTruncateRefetches = /* @__PURE__ */ new Set(), r.onUnsubscribe && this.on("unsubscribed", (o) => r.onUnsubscribe(o)), r.whereExpression && HYt(r.whereExpression, this.collection);
    const i = (o) => {
      n(o), this.trackSentKeys(o);
    };
    this.callback = i, this.filteredCallback = r.whereExpression ? iJt(this.callback, r) : this.callback, this.truncateCleanup = this.collection.on("truncate", () => {
      this.handleTruncate();
    });
  }
  get status() {
    return this._status;
  }
  /**
   * Handle collection truncate event by resetting state and re-requesting subsets.
   * This is called when the sync layer receives a must-refetch and clears all data.
   *
   * To prevent a flash of missing content, we buffer all changes (deletes from truncate
   * and inserts from refetch) until all loadSubset promises resolve, then emit them together.
   */
  handleTruncate() {
    const t = [...this.loadedSubsets], n = this.collection._sync.syncLoadSubsetFn !== null;
    if (t.length === 0 || !n) {
      this.snapshotSent = !1, this.loadedInitialState = !1, this.limitedSnapshotRowCount = 0, this.lastSentKey = void 0, this.loadedSubsets = [];
      return;
    }
    this.isBufferingForTruncate = !0, this.truncateBuffer = [], this.pendingTruncateRefetches.clear(), this.snapshotSent = !1, this.loadedInitialState = !1, this.limitedSnapshotRowCount = 0, this.lastSentKey = void 0, this.loadedSubsets = [], queueMicrotask(() => {
      if (this.isBufferingForTruncate) {
        for (const r of t) {
          const i = this.collection._sync.loadSubset(r);
          this.loadedSubsets.push(r), this.trackLoadSubsetPromise(i), i instanceof Promise && (this.pendingTruncateRefetches.add(i), i.catch(() => {
          }).finally(() => {
            this.pendingTruncateRefetches.delete(i), this.checkTruncateRefetchComplete();
          }));
        }
        this.pendingTruncateRefetches.size === 0 && this.flushTruncateBuffer();
      }
    });
  }
  /**
   * Check if all truncate refetch promises have completed and flush buffer if so
   */
  checkTruncateRefetchComplete() {
    this.pendingTruncateRefetches.size === 0 && this.isBufferingForTruncate && this.flushTruncateBuffer();
  }
  /**
   * Flush the truncate buffer, emitting all buffered changes to the callback
   */
  flushTruncateBuffer() {
    this.isBufferingForTruncate = !1;
    const t = this.truncateBuffer.flat();
    t.length > 0 && this.filteredCallback(t), this.truncateBuffer = [];
  }
  setOrderByIndex(t) {
    this.orderByIndex = t;
  }
  /**
   * Set subscription status and emit events if changed
   */
  setStatus(t) {
    if (this._status === t)
      return;
    const n = this._status;
    this._status = t, this.emitInner("status:change", {
      type: "status:change",
      subscription: this,
      previousStatus: n,
      status: t
    });
    const r = `status:${t}`;
    this.emitInner(r, {
      type: r,
      subscription: this,
      previousStatus: n,
      status: t
    });
  }
  /**
   * Track a loadSubset promise and manage loading status
   */
  trackLoadSubsetPromise(t) {
    t instanceof Promise && (this.pendingLoadSubsetPromises.add(t), this.setStatus("loadingSubset"), t.finally(() => {
      this.pendingLoadSubsetPromises.delete(t), this.pendingLoadSubsetPromises.size === 0 && this.setStatus("ready");
    }));
  }
  hasLoadedInitialState() {
    return this.loadedInitialState;
  }
  hasSentAtLeastOneSnapshot() {
    return this.snapshotSent;
  }
  emitEvents(t) {
    const n = this.filterAndFlipChanges(t);
    this.isBufferingForTruncate ? n.length > 0 && this.truncateBuffer.push(n) : this.filteredCallback(n);
  }
  /**
   * Sends the snapshot to the callback.
   * Returns a boolean indicating if it succeeded.
   * It can only fail if there is no index to fulfill the request
   * and the optimizedOnly option is set to true,
   * or, the entire state was already loaded.
   */
  requestSnapshot(t) {
    if (this.loadedInitialState)
      return !1;
    const n = {
      where: this.options.whereExpression,
      optimizedOnly: (t == null ? void 0 : t.optimizedOnly) ?? !1
    };
    if (t) {
      if ("where" in t) {
        const c = t.where;
        if (n.where) {
          const a = n.where, u = u7(a, c);
          n.where = u;
        } else
          n.where = c;
      }
    } else
      this.loadedInitialState = !0;
    const r = {
      where: n.where,
      subscription: this,
      // Include orderBy and limit if provided so sync layer can optimize the query
      orderBy: t == null ? void 0 : t.orderBy,
      limit: t == null ? void 0 : t.limit
    }, i = this.collection._sync.loadSubset(r);
    this.loadedSubsets.push(r), ((t == null ? void 0 : t.trackLoadSubsetPromise) ?? !0) && this.trackLoadSubsetPromise(i);
    const s = this.collection.currentStateAsChanges(n);
    if (s === void 0)
      return !1;
    const l = s.filter(
      (c) => !this.sentKeys.has(c.key)
    );
    for (const c of l)
      this.sentKeys.add(c.key);
    return this.snapshotSent = !0, this.callback(l), !0;
  }
  /**
   * Sends a snapshot that fulfills the `where` clause and all rows are bigger or equal to the cursor.
   * Requires a range index to be set with `setOrderByIndex` prior to calling this method.
   * It uses that range index to load the items in the order of the index.
   *
   * For multi-column orderBy:
   * - Uses first value from `minValues` for LOCAL index operations (wide bounds, ensures no missed rows)
   * - Uses all `minValues` to build a precise composite cursor for SYNC layer loadSubset
   *
   * Note 1: it may load more rows than the provided LIMIT because it loads all values equal to the first cursor value + limit values greater.
   *         This is needed to ensure that it does not accidentally skip duplicate values when the limit falls in the middle of some duplicated values.
   * Note 2: it does not send keys that have already been sent before.
   */
  requestLimitedSnapshot({
    orderBy: t,
    limit: n,
    minValues: r,
    offset: i
  }) {
    if (!n) throw new Error("limit is required");
    if (!this.orderByIndex)
      throw new Error(
        "Ordered snapshot was requested but no index was found. You have to call setOrderByIndex before requesting an ordered snapshot."
      );
    const s = r == null ? void 0 : r[0], l = this.orderByIndex, c = this.options.whereExpression, a = c ? KE(c) : void 0, u = (S) => {
      if (this.sentKeys.has(S))
        return !1;
      const E = this.collection.get(S);
      return E === void 0 ? !1 : (a == null ? void 0 : a(E)) ?? !0;
    };
    let f = s;
    const d = [];
    let p = [];
    if (s !== void 0) {
      const { expression: S } = t[0], E = this.collection.currentStateAsChanges({
        where: cA(S, new pl(s))
      });
      if (E) {
        const k = E.map((R) => R.key).filter((R) => !this.sentKeys.has(R) && u(R));
        p.push(...k);
        const T = l.take(
          n - p.length,
          s,
          u
        );
        p.push(...T);
      } else
        p = l.take(n, s, u);
    } else
      p = l.take(n, s, u);
    const h = () => Math.max(n - d.length, 0), m = () => p.length === 0, v = t[0].expression, b = v.type === "ref" ? hl(new Ma(v.path), !0) : null;
    for (; h() > 0 && !m(); ) {
      const S = /* @__PURE__ */ new Set();
      for (const E of p) {
        const k = this.collection.get(E);
        d.push({
          type: "insert",
          key: E,
          value: k
        }), f = b ? b(k) : k, S.add(E);
      }
      p = l.take(h(), f, u);
    }
    const A = this.limitedSnapshotRowCount;
    for (const S of d)
      this.sentKeys.add(S.key);
    this.callback(d), this.limitedSnapshotRowCount += d.length, d.length > 0 && (this.lastSentKey = d[d.length - 1].key);
    let w;
    if (r !== void 0 && r.length > 0) {
      const S = aJt(t, r);
      if (S) {
        const { expression: E } = t[0], k = r[0];
        let T;
        if (k instanceof Date) {
          const R = new Date(k.getTime() + 1);
          T = u7(
            XYt(E, new pl(k)),
            c7(E, new pl(R))
          );
        } else
          T = cA(E, new pl(k));
        w = {
          whereFrom: S,
          whereCurrent: T,
          lastKey: this.lastSentKey
        };
      }
    }
    const O = {
      where: c,
      // Main filter only, no cursor
      limit: n,
      orderBy: t,
      cursor: w,
      // Cursor expressions passed separately
      offset: i ?? A,
      // Use provided offset, or auto-tracked offset
      subscription: this
    }, x = this.collection._sync.loadSubset(O);
    this.loadedSubsets.push(O), this.trackLoadSubsetPromise(x);
  }
  // TODO: also add similar test but that checks that it can also load it from the collection's loadSubset function
  //       and that that also works properly (i.e. does not skip duplicate values)
  /**
   * Filters and flips changes for keys that have not been sent yet.
   * Deletes are filtered out for keys that have not been sent yet.
   * Updates are flipped into inserts for keys that have not been sent yet.
   * Duplicate inserts are filtered out to prevent D2 multiplicity > 1.
   */
  filterAndFlipChanges(t) {
    if (this.loadedInitialState || this.skipFiltering)
      return t;
    const n = this.isBufferingForTruncate, r = [];
    for (const i of t) {
      let o = i;
      if (this.sentKeys.has(i.key)) {
        if (i.type === "insert")
          continue;
        i.type === "delete" && this.sentKeys.delete(i.key);
      } else {
        if (i.type === "update")
          o = { ...i, type: "insert", previousValue: void 0 };
        else if (i.type === "delete" && !n)
          continue;
        this.sentKeys.add(i.key);
      }
      r.push(o);
    }
    return r;
  }
  trackSentKeys(t) {
    if (!(this.loadedInitialState || this.skipFiltering))
      for (const n of t)
        n.type === "delete" ? this.sentKeys.delete(n.key) : this.sentKeys.add(n.key);
  }
  /**
   * Mark that the subscription should not filter any changes.
   * This is used when includeInitialState is explicitly set to false,
   * meaning the caller doesn't want initial state but does want ALL future changes.
   */
  markAllStateAsSeen() {
    this.skipFiltering = !0;
  }
  unsubscribe() {
    var t;
    (t = this.truncateCleanup) == null || t.call(this), this.truncateCleanup = void 0, this.isBufferingForTruncate = !1, this.truncateBuffer = [], this.pendingTruncateRefetches.clear();
    for (const n of this.loadedSubsets)
      this.collection._sync.unloadSubset(n);
    this.loadedSubsets = [], this.emitInner("unsubscribed", {
      type: "unsubscribed",
      subscription: this
    }), this.clearListeners();
  }
}
class cJt {
  /**
   * Creates a new CollectionChangesManager instance
   */
  constructor() {
    this.activeSubscribersCount = 0, this.changeSubscriptions = /* @__PURE__ */ new Set(), this.batchedEvents = [], this.shouldBatchEvents = !1;
  }
  setDeps(t) {
    this.lifecycle = t.lifecycle, this.sync = t.sync, this.events = t.events, this.collection = t.collection;
  }
  /**
   * Emit an empty ready event to notify subscribers that the collection is ready
   * This bypasses the normal empty array check in emitEvents
   */
  emitEmptyReadyEvent() {
    for (const t of this.changeSubscriptions)
      t.emitEvents([]);
  }
  /**
   * Emit events either immediately or batch them for later emission
   */
  emitEvents(t, n = !1) {
    if (this.shouldBatchEvents && !n) {
      this.batchedEvents.push(...t);
      return;
    }
    let r = t;
    if (n && (this.batchedEvents.length > 0 && (r = [...this.batchedEvents, ...t]), this.batchedEvents = [], this.shouldBatchEvents = !1), r.length !== 0)
      for (const i of this.changeSubscriptions)
        i.emitEvents(r);
  }
  /**
   * Subscribe to changes in the collection
   */
  subscribeChanges(t, n = {}) {
    if (this.addSubscriber(), n.where && n.whereExpression)
      throw new Error(
        "Cannot specify both 'where' and 'whereExpression' options. Use one or the other."
      );
    const { where: r, ...i } = n;
    let o = i.whereExpression;
    if (r) {
      const l = O6e(), c = r(l);
      o = _o(c);
    }
    const s = new lJt(this.collection, t, {
      ...i,
      whereExpression: o,
      onUnsubscribe: () => {
        this.removeSubscriber(), this.changeSubscriptions.delete(s);
      }
    });
    return n.onStatusChange && s.on("status:change", n.onStatusChange), n.includeInitialState ? s.requestSnapshot({ trackLoadSubsetPromise: !1 }) : n.includeInitialState === !1 && s.markAllStateAsSeen(), this.changeSubscriptions.add(s), s;
  }
  /**
   * Increment the active subscribers count and start sync if needed
   */
  addSubscriber() {
    const t = this.activeSubscribersCount;
    this.activeSubscribersCount++, this.lifecycle.cancelGCTimer(), (this.lifecycle.status === "cleaned-up" || this.lifecycle.status === "idle") && this.sync.startSync(), this.events.emitSubscribersChange(
      this.activeSubscribersCount,
      t
    );
  }
  /**
   * Decrement the active subscribers count and start GC timer if needed
   */
  removeSubscriber() {
    const t = this.activeSubscribersCount;
    if (this.activeSubscribersCount--, this.activeSubscribersCount === 0)
      this.lifecycle.startGCTimer();
    else if (this.activeSubscribersCount < 0)
      throw new vKt();
    this.events.emitSubscribersChange(
      this.activeSubscribersCount,
      t
    );
  }
  /**
   * Clean up the collection by stopping sync and clearing data
   * This can be called manually or automatically by garbage collection
   */
  cleanup() {
    this.batchedEvents = [], this.shouldBatchEvents = !1;
  }
}
const uJt = (e) => setTimeout(() => {
  e({
    didTimeout: !0,
    // Always indicate timeout for the polyfill
    timeRemaining: () => 50
    // Return some time remaining for polyfill
  });
}, 0), dJt = (e) => {
  clearTimeout(e);
}, fJt = typeof window < "u" && "requestIdleCallback" in window ? (e, t) => window.requestIdleCallback(e, t) : (e, t) => uJt(e), LV = typeof window < "u" && "cancelIdleCallback" in window ? (e) => window.cancelIdleCallback(e) : dJt;
class pJt {
  /**
   * Creates a new CollectionLifecycleManager instance
   */
  constructor(t, n) {
    this.status = "idle", this.hasBeenReady = !1, this.hasReceivedFirstCommit = !1, this.onFirstReadyCallbacks = [], this.gcTimeoutId = null, this.idleCallbackId = null, this.config = t, this.id = n;
  }
  setDeps(t) {
    this.indexes = t.indexes, this.events = t.events, this.changes = t.changes, this.sync = t.sync, this.state = t.state;
  }
  /**
   * Validates state transitions to prevent invalid status changes
   */
  validateStatusTransition(t, n) {
    if (t === n)
      return;
    if (!{
      idle: ["loading", "error", "cleaned-up"],
      loading: ["ready", "error", "cleaned-up"],
      ready: ["cleaned-up", "error"],
      error: ["cleaned-up", "idle"],
      "cleaned-up": ["loading", "error"]
    }[t].includes(n))
      throw new gKt(t, n, this.id);
  }
  /**
   * Safely update the collection status with validation
   * @private
   */
  setStatus(t, n = !1) {
    if (t === "ready" && !n)
      throw new HN(
        `You can't directly call "setStatus('ready'). You must use markReady instead.`
      );
    this.validateStatusTransition(this.status, t);
    const r = this.status;
    this.status = t, t === "ready" && !this.indexes.isIndexesResolved && this.indexes.resolveAllIndexes().catch((i) => {
      console.warn(
        `${this.config.id ? `[${this.config.id}] ` : ""}Failed to resolve indexes:`,
        i
      );
    }), this.events.emitStatusChange(t, r);
  }
  /**
   * Validates that the collection is in a usable state for data operations
   * @private
   */
  validateCollectionUsable(t) {
    switch (this.status) {
      case "error":
        throw new mKt(t, this.id);
      case "cleaned-up":
        this.sync.startSync();
        break;
    }
  }
  /**
   * Mark the collection as ready for use
   * This is called by sync implementations to explicitly signal that the collection is ready,
   * providing a more intuitive alternative to using commits for readiness signaling
   * @private - Should only be called by sync implementations
   */
  markReady() {
    if (this.validateStatusTransition(this.status, "ready"), this.status === "loading") {
      if (this.setStatus("ready", !0), !this.hasBeenReady) {
        this.hasBeenReady = !0, this.hasReceivedFirstCommit || (this.hasReceivedFirstCommit = !0);
        const t = [...this.onFirstReadyCallbacks];
        this.onFirstReadyCallbacks = [], t.forEach((n) => n());
      }
      this.changes.changeSubscriptions.size > 0 && this.changes.emitEmptyReadyEvent();
    }
  }
  /**
   * Start the garbage collection timer
   * Called when the collection becomes inactive (no subscribers)
   */
  startGCTimer() {
    this.gcTimeoutId && clearTimeout(this.gcTimeoutId);
    const t = this.config.gcTime ?? 3e5;
    t !== 0 && (this.gcTimeoutId = setTimeout(() => {
      this.changes.activeSubscribersCount === 0 && this.scheduleIdleCleanup();
    }, t));
  }
  /**
   * Cancel the garbage collection timer
   * Called when the collection becomes active again
   */
  cancelGCTimer() {
    this.gcTimeoutId && (clearTimeout(this.gcTimeoutId), this.gcTimeoutId = null), this.idleCallbackId !== null && (LV(this.idleCallbackId), this.idleCallbackId = null);
  }
  /**
   * Schedule cleanup to run during browser idle time
   * This prevents blocking the UI thread during cleanup operations
   */
  scheduleIdleCleanup() {
    this.idleCallbackId !== null && LV(this.idleCallbackId), this.idleCallbackId = fJt(
      (t) => {
        this.changes.activeSubscribersCount === 0 ? this.performCleanup(t) && (this.idleCallbackId = null) : this.idleCallbackId = null;
      },
      { timeout: 1e3 }
    );
  }
  /**
   * Perform cleanup operations, optionally in chunks during idle time
   * @returns true if cleanup was completed, false if it was rescheduled
   */
  performCleanup(t) {
    return !t || t.timeRemaining() > 0 || t.didTimeout ? (this.sync.cleanup(), this.state.cleanup(), this.changes.cleanup(), this.indexes.cleanup(), this.gcTimeoutId && (clearTimeout(this.gcTimeoutId), this.gcTimeoutId = null), this.hasBeenReady = !1, this.onFirstReadyCallbacks = [], this.setStatus("cleaned-up"), this.events.cleanup(), !0) : (this.scheduleIdleCleanup(), !1);
  }
  /**
   * Register a callback to be executed when the collection first becomes ready
   * Useful for preloading collections
   * @param callback Function to call when the collection first becomes ready
   */
  onFirstReady(t) {
    if (this.hasBeenReady) {
      t();
      return;
    }
    this.onFirstReadyCallbacks.push(t);
  }
  cleanup() {
    this.idleCallbackId !== null && (LV(this.idleCallbackId), this.idleCallbackId = null), this.performCleanup();
  }
}
const dJ = /* @__PURE__ */ Symbol("liveQueryInternal");
class hJt {
  /**
   * Creates a new CollectionSyncManager instance
   */
  constructor(t, n) {
    this.preloadPromise = null, this.syncCleanupFn = null, this.syncLoadSubsetFn = null, this.syncUnloadSubsetFn = null, this.pendingLoadSubsetPromises = /* @__PURE__ */ new Set(), this.config = t, this.id = n, this.syncMode = t.syncMode ?? "eager";
  }
  setDeps(t) {
    this.collection = t.collection, this.state = t.state, this.lifecycle = t.lifecycle, this._events = t.events;
  }
  /**
   * Start the sync process for this collection
   * This is called when the collection is first accessed or preloaded
   */
  startSync() {
    if (!(this.lifecycle.status !== "idle" && this.lifecycle.status !== "cleaned-up")) {
      this.lifecycle.setStatus("loading");
      try {
        const t = mJt(
          this.config.sync.sync({
            collection: this.collection,
            begin: () => {
              this.state.pendingSyncedTransactions.push({
                committed: !1,
                operations: [],
                deletedKeys: /* @__PURE__ */ new Set()
              });
            },
            write: (n) => {
              const r = this.state.pendingSyncedTransactions[this.state.pendingSyncedTransactions.length - 1];
              if (!r)
                throw new uhe();
              if (r.committed)
                throw new dhe();
              let i;
              "key" in n ? i = n.key : i = this.config.getKey(n.value);
              let o = n.type;
              if (n.type === "insert") {
                const l = this.state.syncedData.has(i), c = r.deletedKeys.has(i), a = r.truncate === !0;
                if (l && !c && !a) {
                  const u = this.state.syncedData.get(i);
                  if (u !== void 0 && Xu(u, n.value))
                    o = "update";
                  else {
                    const p = this.config.utils[dJ];
                    throw new wKt(i, this.id, {
                      hasCustomGetKey: (p == null ? void 0 : p.hasCustomGetKey) ?? !1,
                      hasJoins: (p == null ? void 0 : p.hasJoins) ?? !1
                    });
                  }
                }
              }
              const s = {
                ...n,
                type: o,
                key: i
              };
              r.operations.push(s), o === "delete" && r.deletedKeys.add(i);
            },
            commit: () => {
              const n = this.state.pendingSyncedTransactions[this.state.pendingSyncedTransactions.length - 1];
              if (!n)
                throw new LKt();
              if (n.committed)
                throw new zKt();
              n.committed = !0, this.state.commitPendingTransactions();
            },
            markReady: () => {
              this.lifecycle.markReady();
            },
            truncate: () => {
              const n = this.state.pendingSyncedTransactions[this.state.pendingSyncedTransactions.length - 1];
              if (!n)
                throw new uhe();
              if (n.committed)
                throw new dhe();
              n.operations = [], n.deletedKeys.clear(), n.truncate = !0, n.optimisticSnapshot = {
                upserts: new Map(this.state.optimisticUpserts),
                deletes: new Set(this.state.optimisticDeletes)
              };
            }
          })
        );
        if (this.syncCleanupFn = (t == null ? void 0 : t.cleanup) ?? null, this.syncLoadSubsetFn = (t == null ? void 0 : t.loadSubset) ?? null, this.syncUnloadSubsetFn = (t == null ? void 0 : t.unloadSubset) ?? null, this.syncMode === "on-demand" && !this.syncLoadSubsetFn)
          throw new ZN(
            `Collection "${this.id}" is configured with syncMode "on-demand" but the sync function did not return a loadSubset handler. Either provide a loadSubset handler or use syncMode "eager".`
          );
      } catch (t) {
        throw this.lifecycle.setStatus("error"), t;
      }
    }
  }
  /**
   * Preload the collection data by starting sync if not already started
   * Multiple concurrent calls will share the same promise
   */
  preload() {
    return this.preloadPromise ? this.preloadPromise : (this.syncMode === "on-demand" && console.warn(
      `${this.id ? `[${this.id}] ` : ""}Calling .preload() on a collection with syncMode "on-demand" is a no-op. In on-demand mode, data is only loaded when queries request it. Instead, create a live query and call .preload() on that to load the specific data you need. See https://tanstack.com/blog/tanstack-db-0.5-query-driven-sync for more details.`
    ), this.preloadPromise = new Promise((t, n) => {
      if (this.lifecycle.status === "ready") {
        t();
        return;
      }
      if (this.lifecycle.status === "error") {
        n(new yKt());
        return;
      }
      if (this.lifecycle.onFirstReady(() => {
        t();
      }), this.lifecycle.status === "idle" || this.lifecycle.status === "cleaned-up")
        try {
          this.startSync();
        } catch (r) {
          n(r);
          return;
        }
    }), this.preloadPromise);
  }
  /**
   * Gets whether the collection is currently loading more data
   */
  get isLoadingSubset() {
    return this.pendingLoadSubsetPromises.size > 0;
  }
  /**
   * Tracks a load promise for isLoadingSubset state.
   * @internal This is for internal coordination (e.g., live-query glue code), not for general use.
   */
  trackLoadPromise(t) {
    const n = !this.isLoadingSubset;
    this.pendingLoadSubsetPromises.add(t), n && this._events.emit("loadingSubset:change", {
      type: "loadingSubset:change",
      collection: this.collection,
      isLoadingSubset: !0,
      previousIsLoadingSubset: !1,
      loadingSubsetTransition: "start"
    }), t.finally(() => {
      const r = this.pendingLoadSubsetPromises.size === 1 && this.pendingLoadSubsetPromises.has(t);
      this.pendingLoadSubsetPromises.delete(t), r && this._events.emit("loadingSubset:change", {
        type: "loadingSubset:change",
        collection: this.collection,
        isLoadingSubset: !1,
        previousIsLoadingSubset: !0,
        loadingSubsetTransition: "end"
      });
    });
  }
  /**
   * Requests the sync layer to load more data.
   * @param options Options to control what data is being loaded
   * @returns If data loading is asynchronous, this method returns a promise that resolves when the data is loaded.
   *          Returns true if no sync function is configured, if syncMode is 'eager', or if there is no work to do.
   */
  loadSubset(t) {
    if (this.syncMode === "eager")
      return !0;
    if (this.syncLoadSubsetFn) {
      const n = this.syncLoadSubsetFn(t);
      if (n instanceof Promise)
        return this.trackLoadPromise(n), n;
    }
    return !0;
  }
  /**
   * Notifies the sync layer that a subset is no longer needed.
   * @param options Options that identify what data is being unloaded
   */
  unloadSubset(t) {
    this.syncUnloadSubsetFn && this.syncUnloadSubsetFn(t);
  }
  cleanup() {
    try {
      this.syncCleanupFn && (this.syncCleanupFn(), this.syncCleanupFn = null);
    } catch (t) {
      queueMicrotask(() => {
        if (t instanceof Error) {
          const n = new hhe(this.id, t);
          throw n.cause = t, n.stack = t.stack, n;
        } else
          throw new hhe(this.id, t);
      });
    }
    this.preloadPromise = null;
  }
}
function mJt(e) {
  if (typeof e == "function")
    return { cleanup: e };
  if (typeof e == "object")
    return e;
}
function S6e(e) {
  return typeof e == "function" && e.prototype !== void 0 && e.prototype.constructor === e;
}
async function gJt(e) {
  return S6e(e) ? e : await e();
}
class yJt {
  constructor(t, n, r, i, o, s) {
    this.id = t, this.expression = n, this.name = r, this.resolver = i, this.options = o, this.collectionEntries = s, this.indexPromise = null, this.resolvedIndex = null, S6e(this.resolver) && (this.resolvedIndex = new this.resolver(
      this.id,
      this.expression,
      this.name,
      this.options
    ), this.collectionEntries && this.resolvedIndex.build(this.collectionEntries));
  }
  /**
   * Resolve the actual index
   */
  async resolve() {
    return this.resolvedIndex ? this.resolvedIndex : (this.indexPromise || (this.indexPromise = this.createIndex()), this.resolvedIndex = await this.indexPromise, this.resolvedIndex);
  }
  /**
   * Check if already resolved
   */
  isResolved() {
    return this.resolvedIndex !== null;
  }
  /**
   * Get resolved index (throws if not ready)
   */
  getResolved() {
    if (!this.resolvedIndex)
      throw new Error(
        `Index ${this.id} has not been resolved yet. Ensure collection is synced.`
      );
    return this.resolvedIndex;
  }
  /**
   * Get the index ID
   */
  getId() {
    return this.id;
  }
  /**
   * Get the index name
   */
  getName() {
    return this.name;
  }
  /**
   * Get the index expression
   */
  getExpression() {
    return this.expression;
  }
  async createIndex() {
    const t = await gJt(this.resolver);
    return new t(this.id, this.expression, this.name, this.options);
  }
}
class vJt {
  constructor(t, n) {
    this.indexId = t, this.lazyIndex = n;
  }
  /**
   * Get the resolved index (throws if not ready)
   */
  get index() {
    return this.lazyIndex.getResolved();
  }
  /**
   * Check if index is ready
   */
  get isReady() {
    return this.lazyIndex.isResolved();
  }
  /**
   * Wait for index to be ready
   */
  async whenReady() {
    return await this.lazyIndex.resolve();
  }
  /**
   * Get the index ID
   */
  get id() {
    return this.indexId;
  }
  /**
   * Get the index name (throws if not ready)
   */
  get name() {
    return this.isReady ? this.index.name : this.lazyIndex.getName();
  }
  /**
   * Get the index expression (available immediately)
   */
  get expression() {
    return this.lazyIndex.getExpression();
  }
  /**
   * Check if index supports an operation (throws if not ready)
   */
  supports(t) {
    return this.index.supports(t);
  }
  /**
   * Get index statistics (throws if not ready)
   */
  getStats() {
    return this.index.getStats();
  }
  /**
   * Check if index matches a field path (available immediately)
   */
  matchesField(t) {
    const n = this.expression;
    return n.type === "ref" && n.path.length === t.length && n.path.every((r, i) => r === t[i]);
  }
  /**
   * Get the key count (throws if not ready)
   */
  get keyCount() {
    return this.index.keyCount;
  }
  // Test compatibility properties - delegate to resolved index
  get indexedKeysSet() {
    return this.index.indexedKeysSet;
  }
  get orderedEntriesArray() {
    return this.index.orderedEntriesArray;
  }
  get valueMapData() {
    return this.index.valueMapData;
  }
  // BTreeIndex compatibility methods
  equalityLookup(t) {
    var r;
    const n = this.index;
    return ((r = n.equalityLookup) == null ? void 0 : r.call(n, t)) ?? /* @__PURE__ */ new Set();
  }
  rangeQuery(t) {
    var r;
    const n = this.index;
    return ((r = n.rangeQuery) == null ? void 0 : r.call(n, t)) ?? /* @__PURE__ */ new Set();
  }
  inArrayLookup(t) {
    var r;
    const n = this.index;
    return ((r = n.inArrayLookup) == null ? void 0 : r.call(n, t)) ?? /* @__PURE__ */ new Set();
  }
  // Internal method for the collection to get the lazy wrapper
  _getLazyWrapper() {
    return this.lazyIndex;
  }
}
class bJt {
  constructor() {
    this.lazyIndexes = /* @__PURE__ */ new Map(), this.resolvedIndexes = /* @__PURE__ */ new Map(), this.isIndexesResolved = !1, this.indexCounter = 0;
  }
  setDeps(t) {
    this.state = t.state, this.lifecycle = t.lifecycle;
  }
  /**
   * Creates an index on a collection for faster queries.
   */
  createIndex(t, n = {}) {
    this.lifecycle.validateCollectionUsable("createIndex");
    const r = ++this.indexCounter, i = O6e(), o = t(i), s = _o(o), l = n.indexType ?? d7, c = new yJt(
      r,
      s,
      n.name,
      l,
      n.options,
      this.state.entries()
    );
    if (this.lazyIndexes.set(r, c), l === d7)
      try {
        const a = c.getResolved();
        this.resolvedIndexes.set(r, a);
      } catch (a) {
        console.warn("Failed to resolve BTreeIndex:", a);
      }
    else if (typeof l == "function" && l.prototype)
      try {
        const a = c.getResolved();
        this.resolvedIndexes.set(r, a);
      } catch {
        this.resolveSingleIndex(r, c).catch((a) => {
          console.warn("Failed to resolve single index:", a);
        });
      }
    else this.isIndexesResolved && this.resolveSingleIndex(r, c).catch((a) => {
      console.warn("Failed to resolve single index:", a);
    });
    return new vJt(r, c);
  }
  /**
   * Resolve all lazy indexes (called when collection first syncs)
   */
  async resolveAllIndexes() {
    if (this.isIndexesResolved) return;
    const t = Array.from(this.lazyIndexes.entries()).map(
      async ([n, r]) => {
        const i = await r.resolve();
        return i.build(this.state.entries()), this.resolvedIndexes.set(n, i), { indexId: n, resolvedIndex: i };
      }
    );
    await Promise.all(t), this.isIndexesResolved = !0;
  }
  /**
   * Resolve a single index immediately
   */
  async resolveSingleIndex(t, n) {
    const r = await n.resolve();
    return r.build(this.state.entries()), this.resolvedIndexes.set(t, r), r;
  }
  /**
   * Get resolved indexes for query optimization
   */
  get indexes() {
    return this.resolvedIndexes;
  }
  /**
   * Updates all indexes when the collection changes
   */
  updateIndexes(t) {
    for (const n of this.resolvedIndexes.values())
      for (const r of t)
        switch (r.type) {
          case "insert":
            n.add(r.key, r.value);
            break;
          case "update":
            r.previousValue ? n.update(r.key, r.previousValue, r.value) : n.add(r.key, r.value);
            break;
          case "delete":
            n.remove(r.key, r.value);
            break;
        }
  }
  /**
   * Clean up the collection by stopping sync and clearing data
   * This can be called manually or automatically by garbage collection
   */
  cleanup() {
    this.lazyIndexes.clear(), this.resolvedIndexes.clear();
  }
}
const OJt = /* @__PURE__ */ new Set([
  "find",
  "findLast",
  "findIndex",
  "findLastIndex",
  "filter",
  "map",
  "flatMap",
  "forEach",
  "some",
  "every",
  "reduce",
  "reduceRight"
]), AJt = /* @__PURE__ */ new Set([
  "pop",
  "push",
  "shift",
  "unshift",
  "splice",
  "sort",
  "reverse",
  "fill",
  "copyWithin"
]), wJt = /* @__PURE__ */ new Set(["set", "delete", "clear", "add"]), xJt = /* @__PURE__ */ new Set([
  "entries",
  "keys",
  "values",
  "forEach"
]);
function fJ(e) {
  return e !== null && typeof e == "object" && !(e instanceof Date) && !(e instanceof RegExp) && !QE(e);
}
function SJt(e, t, n, r) {
  if (OJt.has(e))
    return function(...i) {
      const o = i[0];
      if (typeof o != "function")
        return t.apply(n.copy_, i);
      const s = (a, u) => {
        if (fJ(a)) {
          const f = {
            tracker: n,
            prop: String(u)
          }, { proxy: d } = r(
            a,
            f
          );
          return d;
        }
        return a;
      }, l = function(a, u, f) {
        const d = s(a, u);
        return o.call(this, d, u, f);
      };
      if (e === "reduce" || e === "reduceRight") {
        const a = function(u, f, d, p) {
          const h = s(f, d);
          return o.call(this, u, h, d, p);
        };
        return t.apply(n.copy_, [
          a,
          ...i.slice(1)
        ]);
      }
      const c = t.apply(n.copy_, [
        l,
        ...i.slice(1)
      ]);
      if ((e === "find" || e === "findLast") && c && typeof c == "object") {
        const a = n.copy_.indexOf(c);
        if (a !== -1)
          return s(c, a);
      }
      return e === "filter" && Array.isArray(c) ? c.map((a) => {
        const u = n.copy_.indexOf(a);
        return u !== -1 ? s(a, u) : a;
      }) : c;
    };
}
function EJt(e, t) {
  return function() {
    const n = e.copy_;
    let r = 0;
    return {
      next() {
        if (r >= n.length)
          return { done: !0, value: void 0 };
        const i = n[r];
        let o = i;
        if (fJ(i)) {
          const s = {
            tracker: e,
            prop: String(r)
          }, { proxy: l } = t(
            i,
            s
          );
          o = l;
        }
        return r++, { done: !1, value: o };
      },
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function _he(e, t, n) {
  return function(...r) {
    const i = e.apply(t.copy_, r);
    return n(t), i;
  };
}
function TJt(e, t, n, r, i, o, s) {
  if (xJt.has(e) || t === Symbol.iterator)
    return function(...c) {
      const a = n.apply(i.copy_, c);
      if (e === "forEach") {
        const f = c[0];
        if (typeof f == "function") {
          const d = function(p, h, m) {
            const v = f.call(this, p, h, m);
            return s(i), v;
          };
          return n.apply(r, [d, ...c.slice(1)]);
        }
      }
      if (e === "entries" || e === "values" || e === Symbol.iterator.toString() || t === Symbol.iterator) {
        const f = a, d = /* @__PURE__ */ new Map();
        if (e === "values" && r instanceof Map)
          for (const [h, m] of i.copy_.entries())
            d.set(m, h);
        const p = /* @__PURE__ */ new Map();
        if (r instanceof Set)
          for (const h of i.copy_.values())
            p.set(h, h);
        return {
          next() {
            const h = f.next();
            if (!h.done && h.value && typeof h.value == "object") {
              if (e === "entries" && Array.isArray(h.value) && h.value.length === 2) {
                if (h.value[1] && typeof h.value[1] == "object") {
                  const m = h.value[0], v = {
                    tracker: i,
                    prop: m,
                    updateMap: (A) => {
                      i.copy_ instanceof Map && i.copy_.set(
                        m,
                        A
                      );
                    }
                  }, { proxy: b } = o(
                    h.value[1],
                    v
                  );
                  h.value[1] = b;
                }
              } else if (e === "values" || e === Symbol.iterator.toString() || t === Symbol.iterator)
                if (e === "values" && r instanceof Map) {
                  const m = d.get(h.value);
                  if (m !== void 0) {
                    const v = {
                      tracker: i,
                      prop: m,
                      updateMap: (A) => {
                        i.copy_ instanceof Map && i.copy_.set(
                          m,
                          A
                        );
                      }
                    }, { proxy: b } = o(
                      h.value,
                      v
                    );
                    h.value = b;
                  }
                } else if (r instanceof Set) {
                  const m = h.value, v = {
                    tracker: i,
                    prop: m,
                    updateSet: (A) => {
                      i.copy_ instanceof Set && (i.copy_.delete(
                        m
                      ), i.copy_.add(A), p.set(m, A));
                    }
                  }, { proxy: b } = o(
                    h.value,
                    v
                  );
                  h.value = b;
                } else {
                  const m = /* @__PURE__ */ Symbol("iterator-value"), { proxy: v } = o(
                    h.value,
                    {
                      tracker: i,
                      prop: m
                    }
                  );
                  h.value = v;
                }
            }
            return h;
          },
          [Symbol.iterator]() {
            return this;
          }
        };
      }
      return a;
    };
}
function ir(...e) {
  const t = typeof window < "u" && typeof localStorage < "u";
  t && localStorage.getItem("DEBUG") === "true" ? console.log("[proxy]", ...e) : (
    // true
    !t && typeof process < "u" && process.env.DEBUG === "true" && console.log("[proxy]", ...e)
  );
}
function Fp(e, t = /* @__PURE__ */ new WeakMap()) {
  if (e == null || typeof e != "object")
    return e;
  if (t.has(e))
    return t.get(e);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e.source, e.flags);
  if (Array.isArray(e)) {
    const i = [];
    return t.set(e, i), e.forEach((o, s) => {
      i[s] = Fp(o, t);
    }), i;
  }
  if (ArrayBuffer.isView(e) && !(e instanceof DataView)) {
    const i = Object.getPrototypeOf(e).constructor, o = new i(
      e.length
    );
    t.set(e, o);
    for (let s = 0; s < e.length; s++)
      o[s] = e[s];
    return o;
  }
  if (e instanceof Map) {
    const i = /* @__PURE__ */ new Map();
    return t.set(e, i), e.forEach((o, s) => {
      i.set(s, Fp(o, t));
    }), i;
  }
  if (e instanceof Set) {
    const i = /* @__PURE__ */ new Set();
    return t.set(e, i), e.forEach((o) => {
      i.add(Fp(o, t));
    }), i;
  }
  if (QE(e))
    return e;
  const n = {};
  t.set(e, n);
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (n[i] = Fp(
      e[i],
      t
    ));
  const r = Object.getOwnPropertySymbols(e);
  for (const i of r)
    n[i] = Fp(
      e[i],
      t
    );
  return n;
}
let Lhe = 0;
function kJt() {
  return Lhe += 1, Lhe;
}
function pJ(e, t) {
  const n = /* @__PURE__ */ new Map();
  function r(f, d) {
    if (ir("Object ID:", f.constructor.name), n.has(f))
      return n.get(f);
    {
      const p = pJ(f, d);
      return n.set(f, p), p;
    }
  }
  const i = /* @__PURE__ */ new Map(), o = {
    copy_: Fp(e),
    originalObject: Fp(e),
    proxyCount: kJt(),
    modified: !1,
    assigned_: {},
    parent: t,
    target: e
    // Store reference to the target object
  };
  ir(
    "createChangeProxy called for target",
    e,
    o.proxyCount
  );
  function s(f) {
    f.modified || (f.modified = !0), f.parent && (ir("propagating change to parent"), "updateMap" in f.parent ? f.parent.updateMap(f.copy_) : "updateSet" in f.parent ? f.parent.updateSet(f.copy_) : (f.parent.tracker.copy_[f.parent.prop] = f.copy_, f.parent.tracker.assigned_[f.parent.prop] = !0), s(f.parent.tracker));
  }
  function l(f) {
    if (ir(
      "checkIfReverted called with assigned keys:",
      Object.keys(f.assigned_)
    ), Object.keys(f.assigned_).length === 0 && Object.getOwnPropertySymbols(f.assigned_).length === 0)
      return ir("No assigned properties, returning true"), !0;
    for (const p in f.assigned_)
      if (f.assigned_[p] === !0) {
        const h = f.copy_[p], m = f.originalObject[p];
        if (ir(
          `Checking property ${String(p)}, current:`,
          h,
          "original:",
          m
        ), !Xu(h, m))
          return ir(`Property ${String(p)} is different, returning false`), !1;
      } else if (f.assigned_[p] === !1)
        return ir(`Property ${String(p)} was deleted, returning false`), !1;
    const d = Object.getOwnPropertySymbols(f.assigned_);
    for (const p of d)
      if (f.assigned_[p] === !0) {
        const h = f.copy_[p], m = f.originalObject[p];
        if (!Xu(h, m))
          return ir("Symbol property is different, returning false"), !1;
      } else if (f.assigned_[p] === !1)
        return ir("Symbol property was deleted, returning false"), !1;
    return ir("All properties match original values, returning true"), !0;
  }
  function c(f, d) {
    ir("checkParentStatus called for child prop:", d);
    const p = l(f);
    ir("Parent checkIfReverted returned:", p), p && (ir("Parent is fully reverted, clearing tracking"), f.modified = !1, f.assigned_ = {}, f.parent && (ir("Continuing up the parent chain"), c(f.parent.tracker, f.parent.prop)));
  }
  function a(f) {
    if (ir("createObjectProxy", f), i.has(f))
      return ir("proxyCache found match"), i.get(f);
    const d = new Proxy(f, {
      get(p, h) {
        ir("get", p, h);
        const m = o.copy_[h] ?? o.originalObject[h], v = o.originalObject[h];
        ir("value (at top of proxy get)", m);
        const b = Object.getOwnPropertyDescriptor(p, h);
        if (b != null && b.get)
          return m;
        if (typeof m == "function") {
          if (Array.isArray(p)) {
            const A = h.toString();
            if (AJt.has(A))
              return _he(
                m,
                o,
                s
              );
            const w = SJt(
              A,
              m,
              o,
              r
            );
            if (w)
              return w;
            if (h === Symbol.iterator)
              return EJt(
                o,
                r
              );
          }
          if (p instanceof Map || p instanceof Set) {
            const A = h.toString();
            if (wJt.has(A))
              return _he(
                m,
                o,
                s
              );
            const w = TJt(
              A,
              h,
              m,
              p,
              o,
              r,
              s
            );
            if (w)
              return w;
          }
          return m.bind(p);
        }
        if (fJ(m)) {
          const A = {
            tracker: o,
            prop: String(h)
          }, { proxy: w } = r(
            v,
            A
          );
          return i.set(m, w), w;
        }
        return m;
      },
      set(p, h, m) {
        const v = o.copy_[h];
        if (ir(
          `set called for property ${String(h)}, current:`,
          v,
          "new:",
          m
        ), Xu(v, m))
          ir("Value unchanged, not tracking");
        else {
          const b = o.originalObject[h], A = Xu(m, b);
          if (ir(
            "value:",
            m,
            "original:",
            b,
            "isRevertToOriginal:",
            A
          ), A) {
            ir(`Reverting property ${String(h)} to original value`), delete o.assigned_[h.toString()], ir(`Updating copy with original value for ${String(h)}`), o.copy_[h] = Fp(b), ir("Checking if all properties reverted");
            const w = l(o);
            ir("All reverted:", w), w ? (ir("All properties reverted, clearing tracking"), o.modified = !1, o.assigned_ = {}, t && (ir("Updating parent for property:", t.prop), c(t.tracker, t.prop))) : (ir("Some properties still changed, keeping modified flag"), o.modified = !0);
          } else
            ir(`Setting new value for property ${String(h)}`), o.copy_[h] = m, o.assigned_[h.toString()] = !0, ir("Marking object and ancestors as modified", o), s(o);
        }
        return !0;
      },
      defineProperty(p, h, m) {
        const v = Reflect.defineProperty(p, h, m);
        return v && "value" in m && (o.copy_[h] = Fp(m.value), o.assigned_[h.toString()] = !0, s(o)), v;
      },
      getOwnPropertyDescriptor(p, h) {
        return Reflect.getOwnPropertyDescriptor(p, h);
      },
      preventExtensions(p) {
        return Reflect.preventExtensions(p);
      },
      isExtensible(p) {
        return Reflect.isExtensible(p);
      },
      deleteProperty(p, h) {
        ir("deleteProperty", p, h);
        const m = typeof h == "symbol" ? h.toString() : h;
        if (m in p) {
          const v = m in o.originalObject, b = Reflect.deleteProperty(p, h);
          return b && (v ? (o.assigned_[m] = !1, s(o)) : (delete o.assigned_[m], Object.keys(o.assigned_).length === 0 && Object.getOwnPropertySymbols(o.assigned_).length === 0 ? o.modified = !1 : o.modified = !0)), b;
        }
        return !0;
      }
    });
    return i.set(f, d), d;
  }
  return {
    proxy: a(o.copy_),
    getChanges: () => {
      if (ir("getChanges called, modified:", o.modified), ir(o), !o.modified)
        return ir("Object not modified, returning empty object"), {};
      if (typeof o.copy_ != "object" || Array.isArray(o.copy_) || Object.keys(o.assigned_).length === 0)
        return o.copy_;
      const f = {};
      for (const d in o.copy_)
        o.assigned_[d] === !0 && d in o.copy_ && (f[d] = o.copy_[d]);
      return ir("Returning copy:", f), f;
    }
  };
}
function CJt(e) {
  const t = e.map((n) => pJ(n));
  return {
    proxies: t.map((n) => n.proxy),
    getChanges: () => t.map((n) => n.getChanges())
  };
}
function NJt(e, t) {
  const { proxy: n, getChanges: r } = pJ(e);
  return t(n), r();
}
function PJt(e, t) {
  const { proxies: n, getChanges: r } = CJt(e);
  return t(n), r();
}
function IJt() {
  let e, t, n = !0;
  return {
    promise: new Promise((i, o) => {
      e = (s) => {
        n = !1, i(s);
      }, t = (s) => {
        n = !1, o(s);
      };
    }),
    resolve: e,
    reject: t,
    isPending: () => n
  };
}
function RJt(e) {
  return typeof e == "object" && e !== null && typeof e.hasPendingGraphRun == "function";
}
class MJt {
  constructor() {
    this.contexts = /* @__PURE__ */ new Map(), this.clearListeners = /* @__PURE__ */ new Set();
  }
  /**
   * Get or create the state bucket for a context.
   */
  getOrCreateContext(t) {
    let n = this.contexts.get(t);
    return n || (n = {
      queue: [],
      jobs: /* @__PURE__ */ new Map(),
      dependencies: /* @__PURE__ */ new Map(),
      completed: /* @__PURE__ */ new Set()
    }, this.contexts.set(t, n)), n;
  }
  /**
   * Schedule work. Without a context id, executes immediately.
   * Otherwise queues the job to be flushed once dependencies are satisfied.
   * Scheduling the same jobId again replaces the previous run function.
   */
  schedule({ contextId: t, jobId: n, dependencies: r, run: i }) {
    if (typeof t > "u") {
      i();
      return;
    }
    const o = this.getOrCreateContext(t);
    if (o.jobs.has(n) || o.queue.push(n), o.jobs.set(n, i), r) {
      const s = new Set(r);
      s.delete(n), o.dependencies.set(n, s);
    } else o.dependencies.has(n) || o.dependencies.set(n, /* @__PURE__ */ new Set());
    o.completed.delete(n);
  }
  /**
   * Flush all queued work for a context. Jobs with unmet dependencies are retried.
   * Throws if a pass completes without running any job (dependency cycle).
   */
  flush(t) {
    const n = this.contexts.get(t);
    if (!n) return;
    const { queue: r, jobs: i, dependencies: o, completed: s } = n;
    for (; r.length > 0; ) {
      let l = !1;
      const c = r.length;
      for (let a = 0; a < c; a++) {
        const u = r.shift(), f = i.get(u);
        if (!f) {
          o.delete(u), s.delete(u);
          continue;
        }
        const d = o.get(u);
        let p = !d;
        if (d) {
          p = !0;
          for (const h of d) {
            if (h === u) continue;
            const m = RJt(h) && h.hasPendingGraphRun(t);
            if (i.has(h) && !s.has(h) || !i.has(h) && m) {
              p = !1;
              break;
            }
          }
        }
        p ? (i.delete(u), o.delete(u), f(), s.add(u), l = !0) : r.push(u);
      }
      if (!l)
        throw new Error(
          `Scheduler detected unresolved dependencies for context ${String(
            t
          )}.`
        );
    }
    this.contexts.delete(t);
  }
  /**
   * Flush all contexts with pending work. Useful during tear-down.
   */
  flushAll() {
    for (const t of Array.from(this.contexts.keys()))
      this.flush(t);
  }
  /** Clear all scheduled jobs for a context. */
  clear(t) {
    this.contexts.delete(t), this.clearListeners.forEach((n) => n(t));
  }
  /** Register a listener to be notified when a context is cleared. */
  onClear(t) {
    return this.clearListeners.add(t), () => this.clearListeners.delete(t);
  }
  /** Check if a context has pending jobs. */
  hasPendingJobs(t) {
    const n = this.contexts.get(t);
    return !!n && n.jobs.size > 0;
  }
  /** Remove a single job from a context and clean up its dependencies. */
  clearJob(t, n) {
    const r = this.contexts.get(t);
    r && (r.jobs.delete(n), r.dependencies.delete(n), r.completed.delete(n), r.queue = r.queue.filter((i) => i !== n), r.jobs.size === 0 && this.contexts.delete(t));
  }
}
const pL = new MJt(), hL = [];
let jk = [], DJt = 0;
function _Jt(e, t) {
  switch (`${e.type}-${t.type}`) {
    case "insert-update":
      return {
        ...e,
        type: "insert",
        original: {},
        modified: t.modified,
        changes: { ...e.changes, ...t.changes },
        // Keep existing keys (key changes not allowed in updates)
        key: e.key,
        globalKey: e.globalKey,
        // Merge metadata (last-write-wins)
        metadata: t.metadata ?? e.metadata,
        syncMetadata: { ...e.syncMetadata, ...t.syncMetadata },
        // Update tracking info
        mutationId: t.mutationId,
        updatedAt: t.updatedAt
      };
    case "insert-delete":
      return null;
    case "update-delete":
      return t;
    case "update-update":
      return {
        ...t,
        // Keep original from first update
        original: e.original,
        // Union the changes from both updates
        changes: { ...e.changes, ...t.changes },
        // Merge metadata
        metadata: t.metadata ?? e.metadata,
        syncMetadata: { ...e.syncMetadata, ...t.syncMetadata }
      };
    case "delete-delete":
    case "insert-insert":
      return t;
    default: {
      const n = `${e.type}-${t.type}`;
      throw new Error(`Unhandled mutation combination: ${n}`);
    }
  }
}
function dR(e) {
  const t = new FJt(e);
  return hL.push(t), t;
}
function kM() {
  if (jk.length > 0)
    return jk.slice(-1)[0];
}
function LJt(e) {
  pL.clear(e.id), jk.push(e);
}
function zJt(e) {
  try {
    pL.flush(e.id);
  } finally {
    jk = jk.filter((t) => t.id !== e.id);
  }
}
function jJt(e) {
  const t = hL.findIndex((n) => n.id === e.id);
  t !== -1 && hL.splice(t, 1);
}
class FJt {
  constructor(t) {
    if (typeof t.mutationFn > "u")
      throw new RKt();
    this.id = t.id ?? crypto.randomUUID(), this.mutationFn = t.mutationFn, this.state = "pending", this.mutations = [], this.isPersisted = IJt(), this.autoCommit = t.autoCommit ?? !0, this.createdAt = /* @__PURE__ */ new Date(), this.sequenceNumber = DJt++, this.metadata = t.metadata ?? {};
  }
  setState(t) {
    this.state = t, (t === "completed" || t === "failed") && jJt(this);
  }
  /**
   * Execute collection operations within this transaction
   * @param callback - Function containing collection operations to group together. If the
   * callback returns a Promise, the transaction context will remain active until the promise
   * settles, allowing optimistic writes after `await` boundaries.
   * @returns This transaction for chaining
   * @example
   * // Group multiple operations
   * const tx = createTransaction({ mutationFn: async () => {
   *   // Send to API
   * }})
   *
   * tx.mutate(() => {
   *   collection.insert({ id: "1", text: "Buy milk" })
   *   collection.update("2", draft => { draft.completed = true })
   *   collection.delete("3")
   * })
   *
   * await tx.isPersisted.promise
   *
   * @example
   * // Handle mutate errors
   * try {
   *   tx.mutate(() => {
   *     collection.insert({ id: "invalid" }) // This might throw
   *   })
   * } catch (error) {
   *   console.log('Mutation failed:', error)
   * }
   *
   * @example
   * // Manual commit control
   * const tx = createTransaction({ autoCommit: false, mutationFn: async () => {} })
   *
   * tx.mutate(() => {
   *   collection.insert({ id: "1", text: "Item" })
   * })
   *
   * // Commit later when ready
   * await tx.commit()
   */
  mutate(t) {
    if (this.state !== "pending")
      throw new MKt();
    LJt(this);
    try {
      t();
    } finally {
      zJt(this);
    }
    return this.autoCommit && this.commit().catch(() => {
    }), this;
  }
  /**
   * Apply new mutations to this transaction, intelligently merging with existing mutations
   *
   * When mutations operate on the same item (same globalKey), they are merged according to
   * the following rules:
   *
   * - **insert + update** → insert (merge changes, keep empty original)
   * - **insert + delete** → removed (mutations cancel each other out)
   * - **update + delete** → delete (delete dominates)
   * - **update + update** → update (union changes, keep first original)
   * - **same type** → replace with latest
   *
   * This merging reduces over-the-wire churn and keeps the optimistic local view
   * aligned with user intent.
   *
   * @param mutations - Array of new mutations to apply
   */
  applyMutations(t) {
    for (const n of t) {
      const r = this.mutations.findIndex(
        (i) => i.globalKey === n.globalKey
      );
      if (r >= 0) {
        const i = this.mutations[r], o = _Jt(i, n);
        o === null ? this.mutations.splice(r, 1) : this.mutations[r] = o;
      } else
        this.mutations.push(n);
    }
  }
  /**
   * Rollback the transaction and any conflicting transactions
   * @param config - Configuration for rollback behavior
   * @returns This transaction for chaining
   * @example
   * // Manual rollback
   * const tx = createTransaction({ mutationFn: async () => {
   *   // Send to API
   * }})
   *
   * tx.mutate(() => {
   *   collection.insert({ id: "1", text: "Buy milk" })
   * })
   *
   * // Rollback if needed
   * if (shouldCancel) {
   *   tx.rollback()
   * }
   *
   * @example
   * // Handle rollback cascade (automatic)
   * const tx1 = createTransaction({ mutationFn: async () => {} })
   * const tx2 = createTransaction({ mutationFn: async () => {} })
   *
   * tx1.mutate(() => collection.update("1", draft => { draft.value = "A" }))
   * tx2.mutate(() => collection.update("1", draft => { draft.value = "B" })) // Same item
   *
   * tx1.rollback() // This will also rollback tx2 due to conflict
   *
   * @example
   * // Handle rollback in error scenarios
   * try {
   *   await tx.isPersisted.promise
   * } catch (error) {
   *   console.log('Transaction was rolled back:', error)
   *   // Transaction automatically rolled back on mutation function failure
   * }
   */
  rollback(t) {
    var r;
    const n = (t == null ? void 0 : t.isSecondaryRollback) ?? !1;
    if (this.state === "completed")
      throw new DKt();
    if (this.setState("failed"), !n) {
      const i = /* @__PURE__ */ new Set();
      this.mutations.forEach((o) => i.add(o.globalKey));
      for (const o of hL)
        o.state === "pending" && o.mutations.some((s) => i.has(s.globalKey)) && o.rollback({ isSecondaryRollback: !0 });
    }
    return this.isPersisted.reject((r = this.error) == null ? void 0 : r.error), this.touchCollection(), this;
  }
  // Tell collection that something has changed with the transaction
  touchCollection() {
    const t = /* @__PURE__ */ new Set();
    for (const n of this.mutations)
      t.has(n.collection.id) || (n.collection._state.onTransactionStateChange(), n.collection._state.pendingSyncedTransactions.length > 0 && n.collection._state.commitPendingTransactions(), t.add(n.collection.id));
  }
  /**
   * Commit the transaction and execute the mutation function
   * @returns Promise that resolves to this transaction when complete
   * @example
   * // Manual commit (when autoCommit is false)
   * const tx = createTransaction({
   *   autoCommit: false,
   *   mutationFn: async ({ transaction }) => {
   *     await api.saveChanges(transaction.mutations)
   *   }
   * })
   *
   * tx.mutate(() => {
   *   collection.insert({ id: "1", text: "Buy milk" })
   * })
   *
   * await tx.commit() // Manually commit
   *
   * @example
   * // Handle commit errors
   * try {
   *   const tx = createTransaction({
   *     mutationFn: async () => { throw new Error("API failed") }
   *   })
   *
   *   tx.mutate(() => {
   *     collection.insert({ id: "1", text: "Item" })
   *   })
   *
   *   await tx.commit()
   * } catch (error) {
   *   console.log('Commit failed, transaction rolled back:', error)
   * }
   *
   * @example
   * // Check transaction state after commit
   * await tx.commit()
   * console.log(tx.state) // "completed" or "failed"
   */
  async commit() {
    if (this.state !== "pending")
      throw new _Kt();
    if (this.setState("persisting"), this.mutations.length === 0)
      return this.setState("completed"), this.isPersisted.resolve(this), this;
    try {
      await this.mutationFn({
        transaction: this
      }), this.setState("completed"), this.touchCollection(), this.isPersisted.resolve(this);
    } catch (t) {
      const n = t instanceof Error ? t : new Error(String(t));
      throw this.error = {
        message: n.message,
        error: n
      }, this.rollback(), n;
    }
    return this;
  }
  /**
   * Compare two transactions by their createdAt time and sequence number in order
   * to sort them in the order they were created.
   * @param other - The other transaction to compare to
   * @returns -1 if this transaction was created before the other, 1 if it was created after, 0 if they were created at the same time
   */
  compareCreatedAt(t) {
    const n = this.createdAt.getTime() - t.createdAt.getTime();
    return n !== 0 ? n : this.sequenceNumber - t.sequenceNumber;
  }
}
class UJt {
  constructor(t, n) {
    this.insert = (r, i) => {
      this.lifecycle.validateCollectionUsable("insert");
      const o = this.state, s = kM();
      if (!s && !this.config.onInsert)
        throw new NKt();
      const l = Array.isArray(r) ? r : [r], c = [], a = /* @__PURE__ */ new Set();
      if (l.forEach((u) => {
        var m, v;
        const f = this.validateData(u, "insert"), d = this.config.getKey(f);
        if (this.state.has(d) || a.has(d))
          throw new AKt(d);
        a.add(d);
        const p = this.generateGlobalKey(d, u), h = {
          mutationId: crypto.randomUUID(),
          original: {},
          modified: f,
          // Pick the values from validatedData based on what's passed in - this is for cases
          // where a schema has default values. The validated data has the extra default
          // values but for changes, we just want to show the data that was actually passed in.
          changes: Object.fromEntries(
            Object.keys(u).map((b) => [
              b,
              f[b]
            ])
          ),
          globalKey: p,
          key: d,
          metadata: i == null ? void 0 : i.metadata,
          syncMetadata: ((v = (m = this.config.sync).getSyncMetadata) == null ? void 0 : v.call(m)) || {},
          optimistic: (i == null ? void 0 : i.optimistic) ?? !0,
          type: "insert",
          createdAt: /* @__PURE__ */ new Date(),
          updatedAt: /* @__PURE__ */ new Date(),
          collection: this.collection
        };
        c.push(h);
      }), s)
        return s.applyMutations(c), o.transactions.set(s.id, s), o.scheduleTransactionCleanup(s), o.recomputeOptimisticState(!0), s;
      {
        const u = dR({
          mutationFn: async (f) => await this.config.onInsert({
            transaction: f.transaction,
            collection: this.collection
          })
        });
        return u.applyMutations(c), u.commit().catch(() => {
        }), o.transactions.set(u.id, u), o.scheduleTransactionCleanup(u), o.recomputeOptimisticState(!0), u;
      }
    }, this.delete = (r, i) => {
      const o = this.state;
      this.lifecycle.validateCollectionUsable("delete");
      const s = kM();
      if (!s && !this.config.onDelete)
        throw new IKt();
      if (Array.isArray(r) && r.length === 0)
        throw new kKt();
      const l = Array.isArray(r) ? r : [r], c = [];
      for (const u of l) {
        if (!this.state.has(u))
          throw new CKt(u);
        const f = this.generateGlobalKey(u, this.state.get(u)), d = {
          mutationId: crypto.randomUUID(),
          original: this.state.get(u),
          modified: this.state.get(u),
          changes: this.state.get(u),
          globalKey: f,
          key: u,
          metadata: i == null ? void 0 : i.metadata,
          syncMetadata: o.syncedMetadata.get(u) || {},
          optimistic: (i == null ? void 0 : i.optimistic) ?? !0,
          type: "delete",
          createdAt: /* @__PURE__ */ new Date(),
          updatedAt: /* @__PURE__ */ new Date(),
          collection: this.collection
        };
        c.push(d);
      }
      if (s)
        return s.applyMutations(c), o.transactions.set(s.id, s), o.scheduleTransactionCleanup(s), o.recomputeOptimisticState(!0), s;
      const a = dR({
        autoCommit: !0,
        mutationFn: async (u) => this.config.onDelete({
          transaction: u.transaction,
          collection: this.collection
        })
      });
      return a.applyMutations(c), a.commit().catch(() => {
      }), o.transactions.set(a.id, a), o.scheduleTransactionCleanup(a), o.recomputeOptimisticState(!0), a;
    }, this.id = n, this.config = t;
  }
  setDeps(t) {
    this.lifecycle = t.lifecycle, this.state = t.state, this.collection = t.collection;
  }
  ensureStandardSchema(t) {
    if (t && "~standard" in t)
      return t;
    throw new hKt();
  }
  validateData(t, n, r) {
    if (!this.config.schema) return t;
    const i = this.ensureStandardSchema(this.config.schema);
    if (n === "update" && r) {
      const s = this.state.get(r);
      if (s && t && typeof t == "object" && typeof s == "object") {
        const l = Object.assign({}, s, t), c = i["~standard"].validate(l);
        if (c instanceof Promise)
          throw new che();
        if ("issues" in c && c.issues) {
          const d = c.issues.map((p) => {
            var h;
            return {
              message: p.message,
              path: (h = p.path) == null ? void 0 : h.map((m) => String(m))
            };
          });
          throw new lhe(n, d);
        }
        const a = c.value, u = Object.keys(t);
        return Object.fromEntries(
          u.map((d) => [d, a[d]])
        );
      }
    }
    const o = i["~standard"].validate(t);
    if (o instanceof Promise)
      throw new che();
    if ("issues" in o && o.issues) {
      const s = o.issues.map((l) => {
        var c;
        return {
          message: l.message,
          path: (c = l.path) == null ? void 0 : c.map((a) => String(a))
        };
      });
      throw new lhe(n, s);
    }
    return o.value;
  }
  generateGlobalKey(t, n) {
    if (typeof t != "string" && typeof t != "number")
      throw typeof t > "u" ? new bKt(n) : new OKt(t, n);
    return `KEY::${this.id}/${t}`;
  }
  /**
   * Updates one or more items in the collection using a callback function
   */
  update(t, n, r) {
    if (typeof t > "u")
      throw new xKt();
    const i = this.state;
    this.lifecycle.validateCollectionUsable("update");
    const o = kM();
    if (!o && !this.config.onUpdate)
      throw new PKt();
    const s = Array.isArray(t), l = s ? t : [t];
    if (s && l.length === 0)
      throw new SKt();
    const c = typeof n == "function" ? n : r, a = typeof n == "function" ? {} : n, u = l.map((h) => {
      const m = this.state.get(h);
      if (!m)
        throw new EKt(h);
      return m;
    });
    let f;
    s ? f = PJt(
      u,
      c
    ) : f = [NJt(
      u[0],
      c
    )];
    const d = l.map((h, m) => {
      const v = f[m];
      if (!v || Object.keys(v).length === 0)
        return null;
      const b = u[m], A = this.validateData(
        v,
        "update",
        h
      ), w = Object.assign(
        {},
        b,
        A
      ), O = this.config.getKey(b), x = this.config.getKey(w);
      if (O !== x)
        throw new TKt(O, x);
      const S = this.generateGlobalKey(x, w);
      return {
        mutationId: crypto.randomUUID(),
        original: b,
        modified: w,
        // Pick the values from modifiedItem based on what's passed in - this is for cases
        // where a schema has default values or transforms. The modified data has the extra
        // default or transformed values but for changes, we just want to show the data that
        // was actually passed in.
        changes: Object.fromEntries(
          Object.keys(v).map((E) => [
            E,
            w[E]
          ])
        ),
        globalKey: S,
        key: h,
        metadata: a.metadata,
        syncMetadata: i.syncedMetadata.get(h) || {},
        optimistic: a.optimistic ?? !0,
        type: "update",
        createdAt: /* @__PURE__ */ new Date(),
        updatedAt: /* @__PURE__ */ new Date(),
        collection: this.collection
      };
    }).filter(Boolean);
    if (d.length === 0) {
      const h = dR({
        mutationFn: async () => {
        }
      });
      return h.commit().catch(() => {
      }), i.scheduleTransactionCleanup(h), h;
    }
    if (o)
      return o.applyMutations(d), i.transactions.set(o.id, o), i.scheduleTransactionCleanup(o), i.recomputeOptimisticState(!0), o;
    const p = dR({
      mutationFn: async (h) => this.config.onUpdate({
        transaction: h.transaction,
        collection: this.collection
      })
    });
    return p.applyMutations(d), p.commit().catch(() => {
    }), i.transactions.set(p.id, p), i.scheduleTransactionCleanup(p), i.recomputeOptimisticState(!0), p;
  }
}
class VJt extends x6e {
  constructor() {
    super();
  }
  setDeps(t) {
    this.collection = t.collection;
  }
  /**
   * Emit an event to all listeners
   * Public API for emitting collection events
   */
  emit(t, n) {
    this.emitInner(t, n);
  }
  emitStatusChange(t, n) {
    this.emit("status:change", {
      type: "status:change",
      collection: this.collection,
      previousStatus: n,
      status: t
    });
    const r = `status:${t}`;
    this.emit(r, {
      type: r,
      collection: this.collection,
      previousStatus: n,
      status: t
    });
  }
  emitSubscribersChange(t, n) {
    this.emit("subscribers:change", {
      type: "subscribers:change",
      collection: this.collection,
      previousSubscriberCount: n,
      subscriberCount: t
    });
  }
  cleanup() {
    this.clearListeners();
  }
}
function E6e(e) {
  const t = new hJ(
    e
  );
  return e.utils ? t.utils = e.utils : t.utils = {}, t;
}
class hJ {
  /**
   * Creates a new Collection instance
   *
   * @param config - Configuration object for the collection
   * @throws Error if sync config is missing
   */
  constructor(t) {
    if (this.utils = {}, this.insert = (n, r) => this._mutations.insert(n, r), this.delete = (n, r) => this._mutations.delete(n, r), !t)
      throw new fKt();
    if (!t.sync)
      throw new pKt();
    t.id ? this.id = t.id : this.id = crypto.randomUUID(), this.config = {
      ...t,
      autoIndex: t.autoIndex ?? "eager"
    }, this._changes = new cJt(), this._events = new VJt(), this._indexes = new bJt(), this._lifecycle = new pJt(t, this.id), this._mutations = new UJt(t, this.id), this._state = new sJt(t), this._sync = new hJt(t, this.id), this.comparisonOpts = qJt(t), this._changes.setDeps({
      collection: this,
      // Required for passing to CollectionSubscription
      lifecycle: this._lifecycle,
      sync: this._sync,
      events: this._events
    }), this._events.setDeps({
      collection: this
      // Required for adding to emitted events
    }), this._indexes.setDeps({
      state: this._state,
      lifecycle: this._lifecycle
    }), this._lifecycle.setDeps({
      changes: this._changes,
      events: this._events,
      indexes: this._indexes,
      state: this._state,
      sync: this._sync
    }), this._mutations.setDeps({
      collection: this,
      // Required for passing to config.onInsert/onUpdate/onDelete and annotating mutations
      lifecycle: this._lifecycle,
      state: this._state
    }), this._state.setDeps({
      collection: this,
      // Required for filtering events to only include this collection
      lifecycle: this._lifecycle,
      changes: this._changes,
      indexes: this._indexes,
      events: this._events
    }), this._sync.setDeps({
      collection: this,
      // Required for passing to config.sync callback
      state: this._state,
      lifecycle: this._lifecycle,
      events: this._events
    }), t.startSync === !0 && this._sync.startSync();
  }
  /**
   * Gets the current status of the collection
   */
  get status() {
    return this._lifecycle.status;
  }
  /**
   * Get the number of subscribers to the collection
   */
  get subscriberCount() {
    return this._changes.activeSubscribersCount;
  }
  /**
   * Register a callback to be executed when the collection first becomes ready
   * Useful for preloading collections
   * @param callback Function to call when the collection first becomes ready
   * @example
   * collection.onFirstReady(() => {
   *   console.log('Collection is ready for the first time')
   *   // Safe to access collection.state now
   * })
   */
  onFirstReady(t) {
    return this._lifecycle.onFirstReady(t);
  }
  /**
   * Check if the collection is ready for use
   * Returns true if the collection has been marked as ready by its sync implementation
   * @returns true if the collection is ready, false otherwise
   * @example
   * if (collection.isReady()) {
   *   console.log('Collection is ready, data is available')
   *   // Safe to access collection.state
   * } else {
   *   console.log('Collection is still loading')
   * }
   */
  isReady() {
    return this._lifecycle.status === "ready";
  }
  /**
   * Check if the collection is currently loading more data
   * @returns true if the collection has pending load more operations, false otherwise
   */
  get isLoadingSubset() {
    return this._sync.isLoadingSubset;
  }
  /**
   * Start sync immediately - internal method for compiled queries
   * This bypasses lazy loading for special cases like live query results
   */
  startSyncImmediate() {
    this._sync.startSync();
  }
  /**
   * Preload the collection data by starting sync if not already started
   * Multiple concurrent calls will share the same promise
   */
  preload() {
    return this._sync.preload();
  }
  /**
   * Get the current value for a key (virtual derived state)
   */
  get(t) {
    return this._state.get(t);
  }
  /**
   * Check if a key exists in the collection (virtual derived state)
   */
  has(t) {
    return this._state.has(t);
  }
  /**
   * Get the current size of the collection (cached)
   */
  get size() {
    return this._state.size;
  }
  /**
   * Get all keys (virtual derived state)
   */
  *keys() {
    yield* this._state.keys();
  }
  /**
   * Get all values (virtual derived state)
   */
  *values() {
    yield* this._state.values();
  }
  /**
   * Get all entries (virtual derived state)
   */
  *entries() {
    yield* this._state.entries();
  }
  /**
   * Get all entries (virtual derived state)
   */
  *[Symbol.iterator]() {
    yield* this._state[Symbol.iterator]();
  }
  /**
   * Execute a callback for each entry in the collection
   */
  forEach(t) {
    return this._state.forEach(t);
  }
  /**
   * Create a new array with the results of calling a function for each entry in the collection
   */
  map(t) {
    return this._state.map(t);
  }
  getKeyFromItem(t) {
    return this.config.getKey(t);
  }
  /**
   * Creates an index on a collection for faster queries.
   * Indexes significantly improve query performance by allowing constant time lookups
   * and logarithmic time range queries instead of full scans.
   *
   * @template TResolver - The type of the index resolver (constructor or async loader)
   * @param indexCallback - Function that extracts the indexed value from each item
   * @param config - Configuration including index type and type-specific options
   * @returns An index proxy that provides access to the index when ready
   *
   * @example
   * // Create a default B+ tree index
   * const ageIndex = collection.createIndex((row) => row.age)
   *
   * // Create a ordered index with custom options
   * const ageIndex = collection.createIndex((row) => row.age, {
   *   indexType: BTreeIndex,
   *   options: {
   *     compareFn: customComparator,
   *     compareOptions: { direction: 'asc', nulls: 'first', stringSort: 'lexical' }
   *   },
   *   name: 'age_btree'
   * })
   *
   * // Create an async-loaded index
   * const textIndex = collection.createIndex((row) => row.content, {
   *   indexType: async () => {
   *     const { FullTextIndex } = await import('./indexes/fulltext.js')
   *     return FullTextIndex
   *   },
   *   options: { language: 'en' }
   * })
   */
  createIndex(t, n = {}) {
    return this._indexes.createIndex(t, n);
  }
  /**
   * Get resolved indexes for query optimization
   */
  get indexes() {
    return this._indexes.indexes;
  }
  /**
   * Validates the data against the schema
   */
  validateData(t, n, r) {
    return this._mutations.validateData(t, n, r);
  }
  get compareOptions() {
    return { ...this.comparisonOpts };
  }
  update(t, n, r) {
    return this._mutations.update(t, n, r);
  }
  /**
   * Gets the current state of the collection as a Map
   * @returns Map containing all items in the collection, with keys as identifiers
   * @example
   * const itemsMap = collection.state
   * console.log(`Collection has ${itemsMap.size} items`)
   *
   * for (const [key, item] of itemsMap) {
   *   console.log(`${key}: ${item.title}`)
   * }
   *
   * // Check if specific item exists
   * if (itemsMap.has("todo-1")) {
   *   console.log("Todo 1 exists:", itemsMap.get("todo-1"))
   * }
   */
  get state() {
    const t = /* @__PURE__ */ new Map();
    for (const [n, r] of this.entries())
      t.set(n, r);
    return t;
  }
  /**
   * Gets the current state of the collection as a Map, but only resolves when data is available
   * Waits for the first sync commit to complete before resolving
   *
   * @returns Promise that resolves to a Map containing all items in the collection
   */
  stateWhenReady() {
    return this.size > 0 || this.isReady() ? Promise.resolve(this.state) : this.preload().then(() => this.state);
  }
  /**
   * Gets the current state of the collection as an Array
   *
   * @returns An Array containing all items in the collection
   */
  get toArray() {
    return Array.from(this.values());
  }
  /**
   * Gets the current state of the collection as an Array, but only resolves when data is available
   * Waits for the first sync commit to complete before resolving
   *
   * @returns Promise that resolves to an Array containing all items in the collection
   */
  toArrayWhenReady() {
    return this.size > 0 || this.isReady() ? Promise.resolve(this.toArray) : this.preload().then(() => this.toArray);
  }
  /**
   * Returns the current state of the collection as an array of changes
   * @param options - Options including optional where filter
   * @returns An array of changes
   * @example
   * // Get all items as changes
   * const allChanges = collection.currentStateAsChanges()
   *
   * // Get only items matching a condition
   * const activeChanges = collection.currentStateAsChanges({
   *   where: (row) => row.status === 'active'
   * })
   *
   * // Get only items using a pre-compiled expression
   * const activeChanges = collection.currentStateAsChanges({
   *   whereExpression: eq(row.status, 'active')
   * })
   */
  currentStateAsChanges(t = {}) {
    return rJt(this, t);
  }
  /**
   * Subscribe to changes in the collection
   * @param callback - Function called when items change
   * @param options - Subscription options including includeInitialState and where filter
   * @returns Unsubscribe function - Call this to stop listening for changes
   * @example
   * // Basic subscription
   * const subscription = collection.subscribeChanges((changes) => {
   *   changes.forEach(change => {
   *     console.log(`${change.type}: ${change.key}`, change.value)
   *   })
   * })
   *
   * // Later: subscription.unsubscribe()
   *
   * @example
   * // Include current state immediately
   * const subscription = collection.subscribeChanges((changes) => {
   *   updateUI(changes)
   * }, { includeInitialState: true })
   *
   * @example
   * // Subscribe only to changes matching a condition using where callback
   * import { eq } from "@tanstack/db"
   *
   * const subscription = collection.subscribeChanges((changes) => {
   *   updateUI(changes)
   * }, {
   *   includeInitialState: true,
   *   where: (row) => eq(row.status, "active")
   * })
   *
   * @example
   * // Using multiple conditions with and()
   * import { and, eq, gt } from "@tanstack/db"
   *
   * const subscription = collection.subscribeChanges((changes) => {
   *   updateUI(changes)
   * }, {
   *   where: (row) => and(eq(row.status, "active"), gt(row.priority, 5))
   * })
   */
  subscribeChanges(t, n = {}) {
    return this._changes.subscribeChanges(t, n);
  }
  /**
   * Subscribe to a collection event
   */
  on(t, n) {
    return this._events.on(t, n);
  }
  /**
   * Subscribe to a collection event once
   */
  once(t, n) {
    return this._events.once(t, n);
  }
  /**
   * Unsubscribe from a collection event
   */
  off(t, n) {
    this._events.off(t, n);
  }
  /**
   * Wait for a collection event
   */
  waitFor(t, n) {
    return this._events.waitFor(t, n);
  }
  /**
   * Clean up the collection by stopping sync and clearing data
   * This can be called manually or automatically by garbage collection
   */
  async cleanup() {
    return this._lifecycle.cleanup(), Promise.resolve();
  }
}
function qJt(e) {
  if (e.defaultStringCollation) {
    const t = e.defaultStringCollation;
    return {
      stringSort: t.stringSort ?? "locale",
      locale: t.stringSort === "locale" ? t.locale : void 0,
      localeOptions: t.stringSort === "locale" ? t.localeOptions : void 0
    };
  } else
    return {
      stringSort: "locale"
    };
}
class ko {
  constructor(t = {}) {
    this.query = {}, this.query = { ...t };
  }
  /**
   * Creates a CollectionRef or QueryRef from a source object
   * @param source - An object with a single key-value pair
   * @param context - Context string for error messages (e.g., "from clause", "join clause")
   * @returns A tuple of [alias, ref] where alias is the source key and ref is the created reference
   */
  _createRefForSource(t, n) {
    let r;
    try {
      r = Object.keys(t);
    } catch {
      const l = t === null ? "null" : "undefined";
      throw new cR(n, l);
    }
    if (Array.isArray(t))
      throw new cR(n, "array");
    if (r.length !== 1)
      throw r.length === 0 ? new cR(n, "empty object") : r.every((l) => !isNaN(Number(l))) ? new cR(n, "string") : new jKt(n);
    const i = r[0], o = t[i];
    let s;
    if (o instanceof hJ)
      s = new Rw(o, i);
    else if (o instanceof ko) {
      const l = o._getQuery();
      if (!l.from)
        throw new FKt(n);
      s = new qc(l, i);
    } else
      throw new UKt(i);
    return [i, s];
  }
  /**
   * Specify the source table or subquery for the query
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @returns A QueryBuilder with the specified source
   *
   * @example
   * ```ts
   * // Query from a collection
   * query.from({ users: usersCollection })
   *
   * // Query from a subquery
   * const activeUsers = query.from({ u: usersCollection }).where(({u}) => u.active)
   * query.from({ activeUsers })
   * ```
   */
  from(t) {
    const [, n] = this._createRefForSource(t, "from clause");
    return new ko({
      ...this.query,
      from: n
    });
  }
  /**
   * Join another table or subquery to the current query
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @param onCallback - A function that receives table references and returns the join condition
   * @param type - The type of join: 'inner', 'left', 'right', or 'full' (defaults to 'left')
   * @returns A QueryBuilder with the joined table available
   *
   * @example
   * ```ts
   * // Left join users with posts
   * query
   *   .from({ users: usersCollection })
   *   .join({ posts: postsCollection }, ({users, posts}) => eq(users.id, posts.userId))
   *
   * // Inner join with explicit type
   * query
   *   .from({ u: usersCollection })
   *   .join({ p: postsCollection }, ({u, p}) => eq(u.id, p.userId), 'inner')
   * ```
   *
   * // Join with a subquery
   * const activeUsers = query.from({ u: usersCollection }).where(({u}) => u.active)
   * query
   *   .from({ activeUsers })
   *   .join({ p: postsCollection }, ({u, p}) => eq(u.id, p.userId))
   */
  join(t, n, r = "left") {
    const [i, o] = this._createRefForSource(t, "join clause"), l = [...this._getCurrentAliases(), i], c = py(l), a = n(c);
    let u, f;
    if (a.type === "func" && a.name === "eq" && a.args.length === 2)
      u = a.args[0], f = a.args[1];
    else
      throw new VKt();
    const d = {
      from: o,
      type: r,
      left: u,
      right: f
    }, p = this.query.join || [];
    return new ko({
      ...this.query,
      join: [...p, d]
    });
  }
  /**
   * Perform a LEFT JOIN with another table or subquery
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @param onCallback - A function that receives table references and returns the join condition
   * @returns A QueryBuilder with the left joined table available
   *
   * @example
   * ```ts
   * // Left join users with posts
   * query
   *   .from({ users: usersCollection })
   *   .leftJoin({ posts: postsCollection }, ({users, posts}) => eq(users.id, posts.userId))
   * ```
   */
  leftJoin(t, n) {
    return this.join(t, n, "left");
  }
  /**
   * Perform a RIGHT JOIN with another table or subquery
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @param onCallback - A function that receives table references and returns the join condition
   * @returns A QueryBuilder with the right joined table available
   *
   * @example
   * ```ts
   * // Right join users with posts
   * query
   *   .from({ users: usersCollection })
   *   .rightJoin({ posts: postsCollection }, ({users, posts}) => eq(users.id, posts.userId))
   * ```
   */
  rightJoin(t, n) {
    return this.join(t, n, "right");
  }
  /**
   * Perform an INNER JOIN with another table or subquery
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @param onCallback - A function that receives table references and returns the join condition
   * @returns A QueryBuilder with the inner joined table available
   *
   * @example
   * ```ts
   * // Inner join users with posts
   * query
   *   .from({ users: usersCollection })
   *   .innerJoin({ posts: postsCollection }, ({users, posts}) => eq(users.id, posts.userId))
   * ```
   */
  innerJoin(t, n) {
    return this.join(t, n, "inner");
  }
  /**
   * Perform a FULL JOIN with another table or subquery
   *
   * @param source - An object with a single key-value pair where the key is the table alias and the value is a Collection or subquery
   * @param onCallback - A function that receives table references and returns the join condition
   * @returns A QueryBuilder with the full joined table available
   *
   * @example
   * ```ts
   * // Full join users with posts
   * query
   *   .from({ users: usersCollection })
   *   .fullJoin({ posts: postsCollection }, ({users, posts}) => eq(users.id, posts.userId))
   * ```
   */
  fullJoin(t, n) {
    return this.join(t, n, "full");
  }
  /**
   * Filter rows based on a condition
   *
   * @param callback - A function that receives table references and returns an expression
   * @returns A QueryBuilder with the where condition applied
   *
   * @example
   * ```ts
   * // Simple condition
   * query
   *   .from({ users: usersCollection })
   *   .where(({users}) => gt(users.age, 18))
   *
   * // Multiple conditions
   * query
   *   .from({ users: usersCollection })
   *   .where(({users}) => and(
   *     gt(users.age, 18),
   *     eq(users.active, true)
   *   ))
   *
   * // Multiple where calls are ANDed together
   * query
   *   .from({ users: usersCollection })
   *   .where(({users}) => gt(users.age, 18))
   *   .where(({users}) => eq(users.active, true))
   * ```
   */
  where(t) {
    const n = this._getCurrentAliases(), r = py(n), i = t(r);
    if (!Dk(i))
      throw new fhe(zhe(i));
    const o = this.query.where || [];
    return new ko({
      ...this.query,
      where: [...o, i]
    });
  }
  /**
   * Filter grouped rows based on aggregate conditions
   *
   * @param callback - A function that receives table references and returns an expression
   * @returns A QueryBuilder with the having condition applied
   *
   * @example
   * ```ts
   * // Filter groups by count
   * query
   *   .from({ posts: postsCollection })
   *   .groupBy(({posts}) => posts.userId)
   *   .having(({posts}) => gt(count(posts.id), 5))
   *
   * // Filter by average
   * query
   *   .from({ orders: ordersCollection })
   *   .groupBy(({orders}) => orders.customerId)
   *   .having(({orders}) => gt(avg(orders.total), 100))
   *
   * // Multiple having calls are ANDed together
   * query
   *   .from({ orders: ordersCollection })
   *   .groupBy(({orders}) => orders.customerId)
   *   .having(({orders}) => gt(count(orders.id), 5))
   *   .having(({orders}) => gt(avg(orders.total), 100))
   * ```
   */
  having(t) {
    const n = this._getCurrentAliases(), r = this.query.select ? Nhe(n) : py(n), i = t(r);
    if (!Dk(i))
      throw new fhe(zhe(i));
    const o = this.query.having || [];
    return new ko({
      ...this.query,
      having: [...o, i]
    });
  }
  /**
   * Select specific columns or computed values from the query
   *
   * @param callback - A function that receives table references and returns an object with selected fields or expressions
   * @returns A QueryBuilder that returns only the selected fields
   *
   * @example
   * ```ts
   * // Select specific columns
   * query
   *   .from({ users: usersCollection })
   *   .select(({users}) => ({
   *     name: users.name,
   *     email: users.email
   *   }))
   *
   * // Select with computed values
   * query
   *   .from({ users: usersCollection })
   *   .select(({users}) => ({
   *     fullName: concat(users.firstName, ' ', users.lastName),
   *     ageInMonths: mul(users.age, 12)
   *   }))
   *
   * // Select with aggregates (requires GROUP BY)
   * query
   *   .from({ posts: postsCollection })
   *   .groupBy(({posts}) => posts.userId)
   *   .select(({posts, count}) => ({
   *     userId: posts.userId,
   *     postCount: count(posts.id)
   *   }))
   * ```
   */
  select(t) {
    const n = this._getCurrentAliases(), r = py(n), i = t(r), o = T6e(i);
    return new ko({
      ...this.query,
      select: o,
      fnSelect: void 0
      // remove the fnSelect clause if it exists
    });
  }
  /**
   * Sort the query results by one or more columns
   *
   * @param callback - A function that receives table references and returns the field to sort by
   * @param direction - Sort direction: 'asc' for ascending, 'desc' for descending (defaults to 'asc')
   * @returns A QueryBuilder with the ordering applied
   *
   * @example
   * ```ts
   * // Sort by a single column
   * query
   *   .from({ users: usersCollection })
   *   .orderBy(({users}) => users.name)
   *
   * // Sort descending
   * query
   *   .from({ users: usersCollection })
   *   .orderBy(({users}) => users.createdAt, 'desc')
   *
   * // Multiple sorts (chain orderBy calls)
   * query
   *   .from({ users: usersCollection })
   *   .orderBy(({users}) => users.lastName)
   *   .orderBy(({users}) => users.firstName)
   * ```
   */
  orderBy(t, n = "asc") {
    const r = this._getCurrentAliases(), i = this.query.select ? Nhe(r) : py(r), o = t(i), s = typeof n == "string" ? { direction: n, nulls: "first" } : {
      direction: n.direction ?? "asc",
      nulls: n.nulls ?? "first",
      stringSort: n.stringSort,
      locale: n.stringSort === "locale" ? n.locale : void 0,
      localeOptions: n.stringSort === "locale" ? n.localeOptions : void 0
    }, l = (u) => ({
      expression: _o(u),
      compareOptions: s
    }), c = Array.isArray(o) ? o.map((u) => l(u)) : [l(o)], a = this.query.orderBy || [];
    return new ko({
      ...this.query,
      orderBy: [...a, ...c]
    });
  }
  /**
   * Group rows by one or more columns for aggregation
   *
   * @param callback - A function that receives table references and returns the field(s) to group by
   * @returns A QueryBuilder with grouping applied (enables aggregate functions in SELECT and HAVING)
   *
   * @example
   * ```ts
   * // Group by a single column
   * query
   *   .from({ posts: postsCollection })
   *   .groupBy(({posts}) => posts.userId)
   *   .select(({posts, count}) => ({
   *     userId: posts.userId,
   *     postCount: count()
   *   }))
   *
   * // Group by multiple columns
   * query
   *   .from({ sales: salesCollection })
   *   .groupBy(({sales}) => [sales.region, sales.category])
   *   .select(({sales, sum}) => ({
   *     region: sales.region,
   *     category: sales.category,
   *     totalSales: sum(sales.amount)
   *   }))
   * ```
   */
  groupBy(t) {
    const n = this._getCurrentAliases(), r = py(n), i = t(r), o = Array.isArray(i) ? i.map((l) => _o(l)) : [_o(i)], s = this.query.groupBy || [];
    return new ko({
      ...this.query,
      groupBy: [...s, ...o]
    });
  }
  /**
   * Limit the number of rows returned by the query
   * `orderBy` is required for `limit`
   *
   * @param count - Maximum number of rows to return
   * @returns A QueryBuilder with the limit applied
   *
   * @example
   * ```ts
   * // Get top 5 posts by likes
   * query
   *   .from({ posts: postsCollection })
   *   .orderBy(({posts}) => posts.likes, 'desc')
   *   .limit(5)
   * ```
   */
  limit(t) {
    return new ko({
      ...this.query,
      limit: t
    });
  }
  /**
   * Skip a number of rows before returning results
   * `orderBy` is required for `offset`
   *
   * @param count - Number of rows to skip
   * @returns A QueryBuilder with the offset applied
   *
   * @example
   * ```ts
   * // Get second page of results
   * query
   *   .from({ posts: postsCollection })
   *   .orderBy(({posts}) => posts.createdAt, 'desc')
   *   .offset(page * pageSize)
   *   .limit(pageSize)
   * ```
   */
  offset(t) {
    return new ko({
      ...this.query,
      offset: t
    });
  }
  /**
   * Specify that the query should return distinct rows.
   * Deduplicates rows based on the selected columns.
   * @returns A QueryBuilder with distinct enabled
   *
   * @example
   * ```ts
   * // Get countries our users are from
   * query
   *   .from({ users: usersCollection })
   *   .select(({users}) => users.country)
   *   .distinct()
   * ```
   */
  distinct() {
    return new ko({
      ...this.query,
      distinct: !0
    });
  }
  /**
   * Specify that the query should return a single result
   * @returns A QueryBuilder that returns the first result
   *
   * @example
   * ```ts
   * // Get the user matching the query
   * query
   *   .from({ users: usersCollection })
   *   .where(({users}) => eq(users.id, 1))
   *   .findOne()
   *```
   */
  findOne() {
    return new ko({
      ...this.query,
      // TODO: enforcing return only one result with also a default orderBy if none is specified
      // limit: 1,
      singleResult: !0
    });
  }
  // Helper methods
  _getCurrentAliases() {
    const t = [];
    if (this.query.from && t.push(this.query.from.alias), this.query.join)
      for (const n of this.query.join)
        t.push(n.from.alias);
    return t;
  }
  /**
   * Functional variants of the query builder
   * These are imperative function that are called for ery row.
   * Warning: that these cannot be optimized by the query compiler, and may prevent
   * some type of optimizations being possible.
   * @example
   * ```ts
   * q.fn.select((row) => ({
   *   name: row.user.name.toUpperCase(),
   *   age: row.user.age + 1,
   * }))
   * ```
   */
  get fn() {
    const t = this;
    return {
      /**
       * Select fields using a function that operates on each row
       * Warning: This cannot be optimized by the query compiler
       *
       * @param callback - A function that receives a row and returns the selected value
       * @returns A QueryBuilder with functional selection applied
       *
       * @example
       * ```ts
       * // Functional select (not optimized)
       * query
       *   .from({ users: usersCollection })
       *   .fn.select(row => ({
       *     name: row.users.name.toUpperCase(),
       *     age: row.users.age + 1,
       *   }))
       * ```
       */
      select(n) {
        return new ko({
          ...t.query,
          select: void 0,
          // remove the select clause if it exists
          fnSelect: n
        });
      },
      /**
       * Filter rows using a function that operates on each row
       * Warning: This cannot be optimized by the query compiler
       *
       * @param callback - A function that receives a row and returns a boolean
       * @returns A QueryBuilder with functional filtering applied
       *
       * @example
       * ```ts
       * // Functional where (not optimized)
       * query
       *   .from({ users: usersCollection })
       *   .fn.where(row => row.users.name.startsWith('A'))
       * ```
       */
      where(n) {
        return new ko({
          ...t.query,
          fnWhere: [
            ...t.query.fnWhere || [],
            n
          ]
        });
      },
      /**
       * Filter grouped rows using a function that operates on each aggregated row
       * Warning: This cannot be optimized by the query compiler
       *
       * @param callback - A function that receives an aggregated row (with $selected when select() was called) and returns a boolean
       * @returns A QueryBuilder with functional having filter applied
       *
       * @example
       * ```ts
       * // Functional having (not optimized)
       * query
       *   .from({ posts: postsCollection })
       *   .groupBy(({posts}) => posts.userId)
       *   .select(({posts}) => ({ userId: posts.userId, count: count(posts.id) }))
       *   .fn.having(({ $selected }) => $selected.count > 5)
       * ```
       */
      having(n) {
        return new ko({
          ...t.query,
          fnHaving: [
            ...t.query.fnHaving || [],
            n
          ]
        });
      }
    };
  }
  _getQuery() {
    if (!this.query.from)
      throw new qKt();
    return this.query;
  }
}
function zhe(e) {
  return e === null ? "null" : e === void 0 ? "undefined" : typeof e == "object" ? "object" : typeof e;
}
function BJt(e) {
  return e === void 0 ? _o(null) : e instanceof l6e || e instanceof bu || e instanceof Ma || e instanceof pl ? e : _o(e);
}
function XJt(e) {
  return e !== null && typeof e == "object" && !Dk(e) && !e.__refProxy;
}
function T6e(e) {
  if (!XJt(e)) return BJt(e);
  const t = {};
  for (const [n, r] of Object.entries(e)) {
    if (typeof n == "string" && n.startsWith("__SPREAD_SENTINEL__")) {
      t[n] = r;
      continue;
    }
    t[n] = T6e(r);
  }
  return t;
}
function WJt(e) {
  const t = e(new ko());
  return k6e(t);
}
function k6e(e) {
  return e._getQuery();
}
function ZJt(e) {
  const t = HJt(e);
  let n = e, r, i = 0;
  const o = 10;
  for (; i < o && !Xu(n, r); )
    r = n, n = p7(n), i++;
  return {
    optimizedQuery: C6e(n),
    sourceWhereClauses: t
  };
}
function HJt(e) {
  const t = /* @__PURE__ */ new Map();
  if (!e.where || e.where.length === 0)
    return t;
  const r = m7(e.where).map(
    (o) => N6e(o)
  ), i = P6e(r);
  for (const [o, s] of i.singleSource)
    QJt(e, o) && t.set(o, s);
  return t;
}
function QJt(e, t) {
  if (e.from.alias === t)
    return e.from.type === "collectionRef";
  if (e.join) {
    for (const n of e.join)
      if (n.from.alias === t)
        return n.from.type === "collectionRef";
  }
  return !1;
}
function p7(e) {
  var n;
  const t = {
    ...e,
    from: e.from.type === "queryRef" ? new qc(
      p7(e.from.query),
      e.from.alias
    ) : e.from,
    join: (n = e.join) == null ? void 0 : n.map((r) => ({
      ...r,
      from: r.from.type === "queryRef" ? new qc(
        p7(r.from.query),
        r.from.alias
      ) : r.from
    }))
  };
  return $Jt(t);
}
function $Jt(e) {
  if (!e.where || e.where.length === 0)
    return e;
  if (!e.join || e.join.length === 0) {
    if (e.where.length > 1) {
      const l = m7(e.where), c = mL(l);
      return {
        ...e,
        where: [c]
      };
    }
    return e;
  }
  const t = e.where.filter(
    (l) => !ahe(l)
  ), r = m7(t).map(
    (l) => N6e(l)
  ), i = P6e(r), o = GJt(e, i), s = e.where.filter(
    (l) => ahe(l)
  );
  return s.length > 0 && (o.where = [
    ...o.where || [],
    ...s
  ]), o;
}
function C6e(e) {
  var t;
  return {
    ...e,
    from: h7(e.from),
    join: (t = e.join) == null ? void 0 : t.map((n) => ({
      ...n,
      from: h7(n.from)
    }))
  };
}
function h7(e) {
  if (e.type === "collectionRef")
    return e;
  const t = C6e(e.query);
  if (KJt(t)) {
    const n = h7(t.from);
    return n.type === "collectionRef" ? new Rw(n.collection, e.alias) : new qc(n.query, e.alias);
  }
  return new qc(t, e.alias);
}
function KJt(e) {
  return (!e.where || e.where.length === 0) && !e.select && (!e.groupBy || e.groupBy.length === 0) && (!e.having || e.having.length === 0) && (!e.orderBy || e.orderBy.length === 0) && (!e.join || e.join.length === 0) && e.limit === void 0 && e.offset === void 0 && !e.fnSelect && (!e.fnWhere || e.fnWhere.length === 0) && (!e.fnHaving || e.fnHaving.length === 0);
}
function m7(e) {
  const t = [];
  for (const n of e) {
    const r = nJ(n);
    t.push(...mJ(r));
  }
  return t;
}
function mJ(e) {
  if (e.type === "func" && e.name === "and") {
    const t = [];
    for (const n of e.args)
      t.push(...mJ(n));
    return t;
  } else
    return [e];
}
function N6e(e) {
  const t = /* @__PURE__ */ new Set();
  let n = !1;
  function r(i) {
    switch (i.type) {
      case "ref":
        if (i.path && i.path.length > 0) {
          const o = i.path[0];
          o && (t.add(o), i.path.length === 1 && (n = !0));
        }
        break;
      case "func":
        i.args && i.args.forEach(r);
        break;
      case "val":
        break;
      case "agg":
        i.args && i.args.forEach(r);
        break;
    }
  }
  return r(e), {
    expression: e,
    touchedSources: t,
    hasNamespaceOnlyRef: n
  };
}
function P6e(e) {
  const t = /* @__PURE__ */ new Map(), n = [];
  for (const o of e)
    if (o.touchedSources.size === 1 && !o.hasNamespaceOnlyRef) {
      const s = Array.from(o.touchedSources)[0];
      t.has(s) || t.set(s, []), t.get(s).push(o.expression);
    } else (o.touchedSources.size > 1 || o.hasNamespaceOnlyRef) && n.push(o.expression);
  const r = /* @__PURE__ */ new Map();
  for (const [o, s] of t)
    r.set(o, mL(s));
  const i = n.length > 0 ? mL(n) : void 0;
  return {
    singleSource: r,
    multiSource: i
  };
}
function GJt(e, t) {
  const n = /* @__PURE__ */ new Set(), r = jhe(
    e.from,
    t.singleSource,
    n
  ), i = e.join ? e.join.map((a) => ({
    ...a,
    from: jhe(
      a.from,
      t.singleSource,
      n
    )
  })) : void 0, o = [];
  t.multiSource && o.push(t.multiSource);
  const s = e.join && e.join.some(
    (a) => a.type === "left" || a.type === "right" || a.type === "full"
  );
  for (const [a, u] of t.singleSource)
    n.has(a) ? s && o.push(uKt(u)) : o.push(u);
  const l = o.length > 1 ? [
    mL(
      o.flatMap(
        (a) => mJ(nJ(a))
      )
    )
  ] : o;
  return {
    // Copy all non-optimized fields as-is
    select: e.select,
    groupBy: e.groupBy ? [...e.groupBy] : void 0,
    having: e.having ? [...e.having] : void 0,
    orderBy: e.orderBy ? [...e.orderBy] : void 0,
    limit: e.limit,
    offset: e.offset,
    distinct: e.distinct,
    fnSelect: e.fnSelect,
    fnWhere: e.fnWhere ? [...e.fnWhere] : void 0,
    fnHaving: e.fnHaving ? [...e.fnHaving] : void 0,
    // Use the optimized FROM and JOIN clauses
    from: r,
    join: i,
    // Include combined WHERE clauses
    where: l.length > 0 ? l : []
  };
}
function RO(e) {
  return {
    // Recursively copy the FROM clause
    from: e.from.type === "collectionRef" ? new Rw(e.from.collection, e.from.alias) : new qc(RO(e.from.query), e.from.alias),
    // Copy all other fields, creating new arrays where necessary
    select: e.select,
    join: e.join ? e.join.map((t) => ({
      type: t.type,
      left: t.left,
      right: t.right,
      from: t.from.type === "collectionRef" ? new Rw(
        t.from.collection,
        t.from.alias
      ) : new qc(
        RO(t.from.query),
        t.from.alias
      )
    })) : void 0,
    where: e.where ? [...e.where] : void 0,
    groupBy: e.groupBy ? [...e.groupBy] : void 0,
    having: e.having ? [...e.having] : void 0,
    orderBy: e.orderBy ? [...e.orderBy] : void 0,
    limit: e.limit,
    offset: e.offset,
    fnSelect: e.fnSelect,
    fnWhere: e.fnWhere ? [...e.fnWhere] : void 0,
    fnHaving: e.fnHaving ? [...e.fnHaving] : void 0
  };
}
function jhe(e, t, n) {
  const r = t.get(e.alias);
  if (!r)
    return e.type === "collectionRef" ? new Rw(e.collection, e.alias) : new qc(RO(e.query), e.alias);
  if (e.type === "collectionRef") {
    const s = {
      from: new Rw(e.collection, e.alias),
      where: [r]
    };
    return n.add(e.alias), new qc(s, e.alias);
  }
  if (!ren(e.query, r, e.alias))
    return new qc(RO(e.query), e.alias);
  if (oen(e.query, r, e.alias))
    return new qc(RO(e.query), e.alias);
  const i = e.query.where || [], o = {
    ...RO(e.query),
    where: [...i, r]
  };
  return n.add(e.alias), new qc(o, e.alias);
}
function YJt(e, t, n) {
  return e.select ? I6e(e.select) || ien(e.select, t, n) : !1;
}
function JJt(e) {
  return e.groupBy && e.groupBy.length > 0;
}
function een(e) {
  return e.having && e.having.length > 0;
}
function ten(e) {
  return e.orderBy && e.orderBy.length > 0 && (e.limit !== void 0 || e.offset !== void 0);
}
function nen(e) {
  return e.fnSelect || e.fnWhere && e.fnWhere.length > 0 || e.fnHaving && e.fnHaving.length > 0;
}
function ren(e, t, n) {
  return !(YJt(e, t, n) || JJt(e) || een(e) || ten(e) || nen(e));
}
function I6e(e) {
  for (const t of Object.values(e))
    if (typeof t == "object") {
      const n = t;
      if (n.type === "agg" || !("type" in n) && I6e(n))
        return !0;
    }
  return !1;
}
function gJ(e) {
  const t = [];
  if (e == null || typeof e != "object") return t;
  switch (e.type) {
    case "ref":
      t.push(e);
      break;
    case "func":
    case "agg":
      for (const n of e.args ?? [])
        t.push(...gJ(n));
      break;
  }
  return t;
}
function ien(e, t, n) {
  const r = /* @__PURE__ */ new Set();
  for (const [o, s] of Object.entries(e))
    o.startsWith("__SPREAD_SENTINEL__") || s instanceof Ma || r.add(o);
  const i = gJ(t);
  for (const o of i) {
    const s = o.path;
    if (!Array.isArray(s) || s.length < 2) continue;
    const l = s[0], c = s[1];
    if (l === n && r.has(c))
      return !0;
  }
  return !1;
}
function oen(e, t, n) {
  const r = gJ(t);
  if (r.every((o) => o.path[0] !== n))
    return !1;
  if (e.fnSelect)
    return !0;
  const i = e.select;
  if (!i)
    return !1;
  for (const o of r) {
    const s = o.path;
    if (s.length < 2 || s[0] !== n) continue;
    const l = i[s[1]];
    if (!l) continue;
    if (!(l instanceof Ma) || l.path.length < 2)
      return !0;
    const [c, a] = l.path;
    if (c !== n && c !== e.from.alias || a !== s[1])
      return !0;
  }
  return !1;
}
function mL(e) {
  if (e.length === 0)
    throw new cGt();
  return e.length === 1 ? e[0] : new bu("and", e);
}
function sen(e, t, n, r, i, o, s, l, c, a, u, f, d, p, h, m, v, b) {
  let A = e;
  for (const w of t)
    A = aen(
      A,
      w,
      n,
      r,
      i,
      o,
      s,
      l,
      c,
      a,
      u,
      f,
      d,
      p,
      h,
      m,
      v,
      b
    );
  return A;
}
function aen(e, t, n, r, i, o, s, l, c, a, u, f, d, p, h, m, v, b) {
  const A = t.from.type === "collectionRef", {
    alias: w,
    input: O,
    collectionId: x
  } = cen(
    t.from,
    o,
    c,
    a,
    u,
    f,
    d,
    p,
    s,
    l,
    m,
    v,
    b
  );
  n[w] = O, A && (v[w] = x);
  const S = c[r], E = c[x];
  if (!S)
    throw new phe(r);
  if (!E)
    throw new phe(x);
  const { activeSource: k, lazySource: T } = den(
    t.type,
    S,
    E
  ), R = Object.keys(n), { mainExpr: j, joinedExpr: F } = len(
    t.left,
    t.right,
    R,
    w
  ), L = hl(j), _ = hl(F);
  let U = e.pipe(
    Sa(([C, I]) => [L(I), [C, I]])
  ), z = O.pipe(
    Sa(([C, I]) => {
      const M = { [w]: I };
      return [_(M), [C, M]];
    })
  );
  if (!["inner", "left", "right", "full"].includes(t.type))
    throw new GKt(t.type);
  if (k) {
    const C = k === "main" ? t.from : h.from, I = C.type === "queryRef" && (C.query.limit || C.query.offset), M = j.type === "func" || F.type === "func";
    if (!I && !M) {
      const D = k === "main" ? w : i;
      f.add(D);
      const X = k === "main" ? U : z, q = _k(
        h,
        k === "main" ? F : j,
        T
      ), H = q.collection, Y = q.path[0];
      Y && k3(
        Y,
        q.path,
        H
      );
      const J = X.pipe(
        OYt((oe) => {
          const ce = b[D] || D, fe = a[ce];
          if (!fe)
            throw new uGt(
              ce,
              D,
              T.id,
              Object.keys(a)
            );
          if (fe.hasLoadedInitialState())
            return;
          const $ = oe.getInner().map(([[Ce]]) => Ce), pe = new Ma(q.path);
          fe.requestSnapshot({
            where: WYt(pe, $),
            optimizedOnly: !0
          }) || fe.requestSnapshot();
        })
      );
      k === "main" ? U = J : z = J;
    }
  }
  return U.pipe(
    kYt(z, t.type),
    uen(t.type)
  );
}
function len(e, t, n, r) {
  const i = n.filter(
    (l) => l !== r
  ), o = g7(e), s = g7(t);
  if (o && i.includes(o) && s === r)
    return { mainExpr: e, joinedExpr: t };
  if (o === r && s && i.includes(s))
    return { mainExpr: t, joinedExpr: e };
  throw !o || !s ? new JKt() : o === s ? new YKt(o) : i.includes(o) ? s !== r ? new tGt(r) : new nGt() : new eGt(o);
}
function g7(e) {
  switch (e.type) {
    case "ref":
      return e.path[0] || null;
    case "func": {
      const t = /* @__PURE__ */ new Set();
      for (const n of e.args) {
        const r = g7(n);
        r && t.add(r);
      }
      return t.size === 1 ? Array.from(t)[0] : null;
    }
    default:
      return null;
  }
}
function cen(e, t, n, r, i, o, s, l, c, a, u, f, d) {
  switch (e.type) {
    case "collectionRef": {
      const p = t[e.alias];
      if (!p)
        throw new c6e(
          e.alias,
          e.collection.id,
          Object.keys(t)
        );
      return f[e.alias] = e.collection.id, { alias: e.alias, input: p, collectionId: e.collection.id };
    }
    case "queryRef": {
      const p = a.get(e.query) || e.query, h = u(
        p,
        t,
        n,
        r,
        i,
        o,
        s,
        l,
        c,
        a
      );
      Object.assign(f, h.aliasToCollectionId), Object.assign(d, h.aliasRemapping);
      const m = Object.keys(h.aliasToCollectionId).find(
        (A) => h.aliasToCollectionId[A] === h.collectionId
      );
      m && m !== e.alias && (d[e.alias] = m);
      const b = h.pipeline.pipe(
        Sa((A) => {
          const [w, [O, x]] = A;
          return [w, O];
        })
      );
      return {
        alias: e.alias,
        input: b,
        collectionId: h.collectionId
      };
    }
    default:
      throw new rGt(e.type);
  }
}
function uen(e) {
  return function(t) {
    return t.pipe(
      // Process the join result and handle nulls
      Vm((n) => {
        const [r, [i, o]] = n, s = i == null ? void 0 : i[1], l = o == null ? void 0 : o[1];
        return e === "inner" ? !!(s && l) : e === "left" ? !!s : e === "right" ? !!l : !0;
      }),
      Sa((n) => {
        const [r, [i, o]] = n, s = i == null ? void 0 : i[0], l = i == null ? void 0 : i[1], c = o == null ? void 0 : o[0], a = o == null ? void 0 : o[1], u = {};
        return l && Object.assign(u, l), a && Object.assign(u, a), [`[${s},${c}]`, u];
      })
    );
  };
}
function den(e, t, n) {
  switch (e) {
    case "left":
      return { activeSource: "main", lazySource: n };
    case "right":
      return { activeSource: "joined", lazySource: t };
    case "inner":
      return t.size < n.size ? { activeSource: "main", lazySource: n } : { activeSource: "joined", lazySource: t };
    default:
      return { activeSource: void 0, lazySource: void 0 };
  }
}
function y7(e) {
  return e instanceof pl ? e.value : e;
}
function fen(e, t, n) {
  const r = e.source(t);
  if (r && typeof r == "object") {
    let i = n;
    const o = e.targetPath;
    if (o.length === 0)
      for (const [s, l] of Object.entries(r))
        n[s] = y7(l);
    else
      for (let s = 0; s < o.length; s++) {
        const l = o[s];
        if (s === o.length - 1) {
          const c = i[l] ?? (i[l] = {});
          if (typeof c == "object")
            for (const [a, u] of Object.entries(r))
              c[a] = y7(u);
        } else {
          const c = i[l];
          (c == null || typeof c != "object") && (i[l] = {}), i = i[l];
        }
      }
  }
}
function pen(e, t, n) {
  const r = e.alias.split(".");
  if (r.length === 1)
    n[e.alias] = e.compiled(t);
  else {
    let i = n;
    for (let o = 0; o < r.length - 1; o++) {
      const s = r[o], l = i[s];
      (l == null || typeof l != "object") && (i[s] = {}), i = i[s];
    }
    i[r[r.length - 1]] = y7(e.compiled(t));
  }
}
function hen([e, t], n) {
  const r = {};
  for (const i of n)
    i.kind === "merge" ? fen(i, t, r) : pen(i, t, r);
  return [
    e,
    {
      ...t,
      $selected: r
    }
  ];
}
function men(e, t, n) {
  const r = [];
  return R6e([], t, r), e.pipe(Sa((i) => hen(i, r)));
}
function gen(e) {
  return e.type === "agg";
}
function yen(e) {
  return e && typeof e == "object" && !Dk(e);
}
function R6e(e, t, n) {
  for (const [r, i] of Object.entries(t)) {
    if (r.startsWith("__SPREAD_SENTINEL__")) {
      const s = r.slice(19), l = s.lastIndexOf("__"), c = l >= 0 ? s.slice(0, l) : s, a = i && typeof i == "object" && "type" in i && i.type === "ref";
      if (c.includes(".") || a) {
        const u = [...e], f = a ? i : new Ma(c.split(".")), d = hl(f);
        n.push({ kind: "merge", targetPath: u, source: d });
      } else {
        const u = c, f = [...e];
        n.push({
          kind: "merge",
          targetPath: f,
          source: (d) => d[u]
        });
      }
      continue;
    }
    const o = i;
    if (yen(o)) {
      R6e([...e, r], o, n);
      continue;
    }
    if (gen(o))
      n.push({
        kind: "field",
        alias: [...e, r].join("."),
        compiled: () => null
      });
    else {
      if (o === void 0 || !Dk(o)) {
        n.push({
          kind: "field",
          alias: [...e, r].join("."),
          compiled: () => o
        });
        continue;
      }
      if (o instanceof pl) {
        const s = o.value;
        n.push({
          kind: "field",
          alias: [...e, r].join("."),
          compiled: () => s
        });
      } else
        n.push({
          kind: "field",
          alias: [...e, r].join("."),
          compiled: hl(o)
        });
    }
  }
}
function yJ(e, t, n, r, i, o, s, l, c = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap()) {
  const u = c.get(e);
  if (u)
    return u;
  v7(e);
  const { optimizedQuery: f, sourceWhereClauses: d } = ZJt(e);
  a.set(f, e), O7(f, e, a);
  const p = { ...t }, h = {}, m = {}, v = {}, {
    alias: b,
    input: A,
    collectionId: w
  } = ben(
    f.from,
    p,
    n,
    r,
    i,
    o,
    s,
    l,
    c,
    a,
    h,
    m
  );
  v[b] = A;
  let O = A.pipe(
    Sa(([k, T]) => [k, { [b]: T }])
  );
  if (f.join && f.join.length > 0 && (O = sen(
    O,
    f.join,
    v,
    w,
    b,
    p,
    c,
    a,
    n,
    r,
    i,
    o,
    s,
    l,
    e,
    yJ,
    h,
    m
  )), f.where && f.where.length > 0)
    for (const k of f.where) {
      const T = nJ(k), R = hl(T);
      O = O.pipe(
        Vm(([j, F]) => lA(R(F)))
      );
    }
  if (f.fnWhere && f.fnWhere.length > 0)
    for (const k of f.fnWhere)
      O = O.pipe(
        Vm(([T, R]) => lA(k(R)))
      );
  if (f.distinct && !f.fnSelect && !f.select)
    throw new BKt();
  if (f.fnSelect ? O = O.pipe(
    Sa(([k, T]) => {
      const R = f.fnSelect(T);
      return [
        k,
        {
          ...T,
          $selected: R
        }
      ];
    })
  ) : f.select ? O = men(O, f.select) : O = O.pipe(
    Sa(([k, T]) => {
      const R = !f.join && !f.groupBy ? T[b] : T;
      return [
        k,
        {
          ...T,
          $selected: R
        }
      ];
    })
  ), f.groupBy && f.groupBy.length > 0 ? O = Ihe(
    O,
    f.groupBy,
    f.having,
    f.select,
    f.fnHaving
  ) : f.select && Object.values(f.select).some(
    (T) => T.type === "agg"
  ) && (O = Ihe(
    O,
    [],
    // Empty group by means single group
    f.having,
    f.select,
    f.fnHaving
  )), f.having && (!f.groupBy || f.groupBy.length === 0) && !(f.select ? Object.values(f.select).some((T) => T.type === "agg") : !1))
    throw new XKt();
  if (f.fnHaving && f.fnHaving.length > 0 && (!f.groupBy || f.groupBy.length === 0))
    for (const k of f.fnHaving)
      O = O.pipe(
        Vm(([T, R]) => k(R))
      );
  if (f.distinct && (O = O.pipe(NYt(([k, T]) => T.$selected))), f.orderBy && f.orderBy.length > 0) {
    const R = nJt(
      e,
      O,
      f.orderBy,
      f.select || {},
      n[w],
      s,
      l,
      f.limit,
      f.offset
    ).pipe(
      Sa(([F, [L, _]]) => {
        const U = L.$selected, z = b7(U);
        return [F, [z, _]];
      })
    ), j = {
      collectionId: w,
      pipeline: R,
      sourceWhereClauses: d,
      aliasToCollectionId: h,
      aliasRemapping: m
    };
    return c.set(e, j), j;
  } else if (f.limit !== void 0 || f.offset !== void 0)
    throw new WKt();
  const S = O.pipe(
    Sa(([k, T]) => {
      const R = T.$selected, j = b7(R);
      return [k, [j, void 0]];
    })
  ), E = {
    collectionId: w,
    pipeline: S,
    sourceWhereClauses: d,
    aliasToCollectionId: h,
    aliasRemapping: m
  };
  return c.set(e, E), E;
}
function ven(e) {
  const t = /* @__PURE__ */ new Set();
  if (e.from.type === "collectionRef" && t.add(e.from.alias), e.join)
    for (const n of e.join)
      n.from.type === "collectionRef" && t.add(n.from.alias);
  return t;
}
function v7(e, t = /* @__PURE__ */ new Set()) {
  const n = ven(e);
  for (const i of n)
    if (t.has(i))
      throw new ZKt(
        i,
        Array.from(t)
      );
  const r = /* @__PURE__ */ new Set([
    ...t,
    ...n
  ]);
  if (e.from.type === "queryRef" && v7(e.from.query, r), e.join)
    for (const i of e.join)
      i.from.type === "queryRef" && v7(i.from.query, r);
}
function ben(e, t, n, r, i, o, s, l, c, a, u, f) {
  switch (e.type) {
    case "collectionRef": {
      const d = t[e.alias];
      if (!d)
        throw new c6e(
          e.alias,
          e.collection.id,
          Object.keys(t)
        );
      return u[e.alias] = e.collection.id, { alias: e.alias, input: d, collectionId: e.collection.id };
    }
    case "queryRef": {
      const d = a.get(e.query) || e.query, p = yJ(
        d,
        t,
        n,
        r,
        i,
        o,
        s,
        l,
        c,
        a
      );
      Object.assign(u, p.aliasToCollectionId), Object.assign(f, p.aliasRemapping);
      const h = Object.keys(p.aliasToCollectionId).find(
        (b) => p.aliasToCollectionId[b] === p.collectionId
      );
      h && h !== e.alias && (f[e.alias] = h);
      const v = p.pipeline.pipe(
        Sa((b) => {
          const [A, [w, O]] = b, x = b7(w);
          return [A, x];
        })
      );
      return {
        alias: e.alias,
        input: v,
        collectionId: p.collectionId
      };
    }
    default:
      throw new HKt(e.type);
  }
}
function Oen(e) {
  return e instanceof pl || e && typeof e == "object" && "type" in e && e.type === "val";
}
function b7(e) {
  return Oen(e) ? e.value : e;
}
function O7(e, t, n) {
  if (e.from.type === "queryRef" && t.from.type === "queryRef" && (n.set(e.from.query, t.from.query), O7(
    e.from.query,
    t.from.query,
    n
  )), e.join && t.join)
    for (let r = 0; r < e.join.length && r < t.join.length; r++) {
      const i = e.join[r], o = t.join[r];
      i.from.type === "queryRef" && o.from.type === "queryRef" && (n.set(i.from.query, o.from.query), O7(
        i.from.query,
        o.from.query,
        n
      ));
    }
}
function vJ(e, t) {
  const n = e.type;
  if (n === "val")
    return new pl(e.value);
  if (n === "ref") {
    const r = e.path;
    if (Array.isArray(r)) {
      if (r[0] === t && r.length > 1)
        return new Ma(r.slice(1));
      if (r.length === 1 && r[0] !== void 0)
        return new Ma([r[0]]);
    }
    return new Ma(Array.isArray(r) ? r : [String(r)]);
  } else {
    const r = [];
    for (const i of e.args) {
      const o = vJ(
        i,
        t
      );
      r.push(o);
    }
    return new bu(e.name, r);
  }
}
function Fhe(e, t) {
  return e.map((r) => {
    const i = vJ(
      r.expression,
      t
    );
    return {
      ...r,
      expression: i
    };
  });
}
const fR = /* @__PURE__ */ Symbol.for(
  "@tanstack/db.collection-config-builder"
);
class Aen {
  constructor(t, n, r, i) {
    this.alias = t, this.collectionId = n, this.collection = r, this.collectionConfigBuilder = i, this.biggest = void 0, this.subscriptionLoadingPromises = /* @__PURE__ */ new Map(), this.sentToD2Keys = /* @__PURE__ */ new Set();
  }
  subscribe() {
    const t = this.getWhereClauseForAlias();
    if (t) {
      const n = vJ(t, this.alias);
      return this.subscribeToChanges(n);
    }
    return this.subscribeToChanges();
  }
  subscribeToChanges(t) {
    const n = this.getOrderByInfo(), r = (l) => {
      if (!this.subscriptionLoadingPromises.has(l)) {
        let c;
        const a = new Promise((u) => {
          c = u;
        });
        this.subscriptionLoadingPromises.set(l, {
          resolve: c
        }), this.collectionConfigBuilder.liveQueryCollection._sync.trackLoadPromise(
          a
        );
      }
    }, i = (l) => {
      const c = l.subscription;
      if (l.status === "loadingSubset")
        r(c);
      else {
        const a = this.subscriptionLoadingPromises.get(c);
        a && (this.subscriptionLoadingPromises.delete(c), a.resolve());
      }
    };
    let o;
    if (n)
      o = this.subscribeToOrderedChanges(
        t,
        n,
        i
      );
    else {
      const l = !this.collectionConfigBuilder.isLazyAlias(
        this.alias
      );
      o = this.subscribeToMatchingChanges(
        t,
        l,
        i
      );
    }
    o.status === "loadingSubset" && r(o);
    const s = () => {
      const l = this.subscriptionLoadingPromises.get(o);
      l && (this.subscriptionLoadingPromises.delete(o), l.resolve()), o.unsubscribe();
    };
    return this.collectionConfigBuilder.currentSyncState.unsubscribeCallbacks.add(
      s
    ), o;
  }
  sendChangesToPipeline(t, n) {
    const r = Array.isArray(t) ? t : [...t], i = [];
    for (const c of r) {
      if (c.type === "insert") {
        if (this.sentToD2Keys.has(c.key))
          continue;
        this.sentToD2Keys.add(c.key);
      } else c.type === "delete" && this.sentToD2Keys.delete(c.key);
      i.push(c);
    }
    const o = this.collectionConfigBuilder.currentSyncState.inputs[this.alias], l = wen(
      o,
      i,
      this.collection.config.getKey
    ) > 0 ? n : void 0;
    this.collectionConfigBuilder.scheduleGraphRun(l, {
      alias: this.alias
    });
  }
  subscribeToMatchingChanges(t, n, r) {
    const i = (s) => {
      this.sendChangesToPipeline(s);
    };
    return this.collection.subscribeChanges(i, {
      ...n && { includeInitialState: n },
      whereExpression: t,
      onStatusChange: r
    });
  }
  subscribeToOrderedChanges(t, n, r) {
    const { orderBy: i, offset: o, limit: s, index: l } = n, c = {}, a = (p) => {
      const h = xen(p);
      this.sendChangesToPipelineWithTracking(
        h,
        c.current
      );
    }, u = this.collection.subscribeChanges(a, {
      whereExpression: t,
      onStatusChange: r
    });
    c.current = u;
    const f = this.collection.on("truncate", () => {
      this.biggest = void 0, this.sentToD2Keys.clear();
    });
    u.on("unsubscribed", () => {
      f();
    });
    const d = Fhe(i, this.alias);
    return l ? (u.setOrderByIndex(l), u.requestLimitedSnapshot({
      limit: o + s,
      orderBy: d
    })) : u.requestSnapshot({
      orderBy: d,
      limit: o + s
    }), u;
  }
  // This function is called by maybeRunGraph
  // after each iteration of the query pipeline
  // to ensure that the orderBy operator has enough data to work with
  loadMoreIfNeeded(t) {
    const n = this.getOrderByInfo();
    if (!n)
      return !0;
    const { dataNeeded: r } = n;
    if (!r)
      return !0;
    const i = r();
    return i > 0 && this.loadNextItems(i, t), !0;
  }
  sendChangesToPipelineWithTracking(t, n) {
    const r = this.getOrderByInfo();
    if (!r) {
      this.sendChangesToPipeline(t);
      return;
    }
    const i = this.trackSentValues(t, r.comparator), o = n;
    o[fR] ?? (o[fR] = this.loadMoreIfNeeded.bind(this, n)), this.sendChangesToPipeline(
      i,
      o[fR]
    );
  }
  // Loads the next `n` items from the collection
  // starting from the biggest item it has sent
  loadNextItems(t, n) {
    const r = this.getOrderByInfo();
    if (!r)
      return;
    const { orderBy: i, valueExtractorForRawRow: o, offset: s } = r, l = this.biggest, c = l ? o(l) : void 0, a = c !== void 0 ? Array.isArray(c) ? c : [c] : void 0, u = Fhe(i, this.alias);
    n.requestLimitedSnapshot({
      orderBy: u,
      limit: t,
      minValues: a,
      offset: s
    });
  }
  getWhereClauseForAlias() {
    const t = this.collectionConfigBuilder.sourceWhereClausesCache;
    if (t)
      return t.get(this.alias);
  }
  getOrderByInfo() {
    const t = this.collectionConfigBuilder.optimizableOrderByCollections[this.collectionId];
    if (t && t.alias === this.alias)
      return t;
  }
  *trackSentValues(t, n) {
    for (const r of t)
      r.type !== "delete" && (this.biggest ? n(this.biggest, r.value) < 0 && (this.biggest = r.value) : this.biggest = r.value), yield r;
  }
}
function wen(e, t, n) {
  const r = [];
  for (const i of t) {
    const o = n(i.value);
    i.type === "insert" ? r.push([[o, i.value], 1]) : i.type === "update" ? (r.push([[o, i.previousValue], -1]), r.push([[o, i.value], 1])) : r.push([[o, i.value], -1]);
  }
  return r.length !== 0 && e.sendData(new cu(r)), r.length;
}
function* xen(e) {
  for (const t of e)
    t.type === "update" ? (yield { type: "delete", key: t.key, value: t.previousValue }, yield { type: "insert", key: t.key, value: t.value }) : yield t;
}
const M6e = /* @__PURE__ */ new WeakMap();
function Sen(e) {
  var t, n, r;
  return (r = (n = (t = e.utils) == null ? void 0 : t[dJ]) == null ? void 0 : n.getBuilder) == null ? void 0 : r.call(n);
}
function Een(e, t) {
  M6e.set(e, t);
}
function Ten(e) {
  return M6e.get(e);
}
let ken = 0;
class Cen {
  constructor(t) {
    this.config = t, this.compiledAliasToCollectionId = {}, this.resultKeys = /* @__PURE__ */ new WeakMap(), this.orderByIndices = /* @__PURE__ */ new WeakMap(), this.isGraphRunning = !1, this.runCount = 0, this.isInErrorState = !1, this.aliasDependencies = {}, this.builderDependencies = /* @__PURE__ */ new Set(), this.pendingGraphRuns = /* @__PURE__ */ new Map(), this.subscriptions = {}, this.lazySourcesCallbacks = {}, this.lazySources = /* @__PURE__ */ new Set(), this.optimizableOrderByCollections = {}, this.id = t.id || `live-query-${++ken}`, this.query = Nen(t), this.collections = Ien(this.query);
    const n = Ren(this.query);
    this.collectionByAlias = {};
    for (const [r, i] of n.entries()) {
      const o = this.collections[r];
      if (o)
        for (const s of i)
          this.collectionByAlias[s] = o;
    }
    this.query.orderBy && this.query.orderBy.length > 0 && (this.compare = Pen(this.orderByIndices)), this.compareOptions = this.config.defaultStringCollation ?? D6e(this.query).compareOptions, this.compileBasePipeline();
  }
  /**
   * Recursively checks if a query or any of its subqueries contains joins
   */
  hasJoins(t) {
    return !!(t.join && t.join.length > 0 || t.from.type === "queryRef" && this.hasJoins(t.from.query));
  }
  getConfig() {
    return {
      id: this.id,
      getKey: this.config.getKey || ((t) => this.resultKeys.get(t)),
      sync: this.getSyncConfig(),
      compare: this.compare,
      defaultStringCollation: this.compareOptions,
      gcTime: this.config.gcTime || 5e3,
      // 5 seconds by default for live queries
      schema: this.config.schema,
      onInsert: this.config.onInsert,
      onUpdate: this.config.onUpdate,
      onDelete: this.config.onDelete,
      startSync: this.config.startSync,
      singleResult: this.query.singleResult,
      utils: {
        getRunCount: this.getRunCount.bind(this),
        setWindow: this.setWindow.bind(this),
        getWindow: this.getWindow.bind(this),
        [dJ]: {
          getBuilder: () => this,
          hasCustomGetKey: !!this.config.getKey,
          hasJoins: this.hasJoins(this.query)
        }
      }
    };
  }
  setWindow(t) {
    var n, r;
    if (!this.windowFn)
      throw new fGt();
    return this.currentWindow = t, this.windowFn(t), (n = this.maybeRunGraphFn) == null || n.call(this), (r = this.liveQueryCollection) != null && r.isLoadingSubset ? new Promise((i) => {
      const o = this.liveQueryCollection.on(
        "loadingSubset:change",
        (s) => {
          s.isLoadingSubset || (o(), i());
        }
      );
    }) : !0;
  }
  getWindow() {
    if (!(!this.windowFn || !this.currentWindow))
      return {
        offset: this.currentWindow.offset ?? 0,
        limit: this.currentWindow.limit ?? 0
      };
  }
  /**
   * Resolves a collection alias to its collection ID.
   *
   * Uses a two-tier lookup strategy:
   * 1. First checks compiled aliases (includes subquery inner aliases)
   * 2. Falls back to declared aliases from the query's from/join clauses
   *
   * @param alias - The alias to resolve (e.g., "employee", "manager")
   * @returns The collection ID that the alias references
   * @throws {Error} If the alias is not found in either lookup
   */
  getCollectionIdForAlias(t) {
    const n = this.compiledAliasToCollectionId[t];
    if (n)
      return n;
    const r = this.collectionByAlias[t];
    if (r)
      return r.id;
    throw new Error(`Unknown source alias "${t}"`);
  }
  isLazyAlias(t) {
    return this.lazySources.has(t);
  }
  // The callback function is called after the graph has run.
  // This gives the callback a chance to load more data if needed,
  // that's used to optimize orderBy operators that set a limit,
  // in order to load some more data if we still don't have enough rows after the pipeline has run.
  // That can happen because even though we load N rows, the pipeline might filter some of these rows out
  // causing the orderBy operator to receive less than N rows or even no rows at all.
  // So this callback would notice that it doesn't have enough rows and load some more.
  // The callback returns a boolean, when it's true it's done loading data and we can mark the collection as ready.
  maybeRunGraph(t) {
    var n;
    if (!this.isGraphRunning) {
      if (!this.currentSyncConfig || !this.currentSyncState)
        throw new Error(
          "maybeRunGraph called without active sync session. This should not happen."
        );
      this.isGraphRunning = !0;
      try {
        const { begin: r, commit: i } = this.currentSyncConfig, o = this.currentSyncState;
        if (this.isInErrorState)
          return;
        if (o.subscribedToAllCollections) {
          for (; o.graph.pendingWork(); )
            o.graph.run(), (n = o.flushPendingChanges) == null || n.call(o), t == null || t();
          o.messagesCount === 0 && (r(), i()), this.updateLiveQueryStatus(this.currentSyncConfig);
        }
      } finally {
        this.isGraphRunning = !1;
      }
    }
  }
  /**
   * Schedules a graph run with the transaction-scoped scheduler.
   * Ensures each builder runs at most once per transaction, with automatic dependency tracking
   * to run parent queries before child queries. Outside a transaction, runs immediately.
   *
   * Multiple calls during a transaction are coalesced into a single execution.
   * Dependencies are auto-discovered from subscribed live queries, or can be overridden.
   * Load callbacks are combined when entries merge.
   *
   * Uses the current sync session's config and syncState from instance properties.
   *
   * @param callback - Optional callback to load more data if needed (returns true when done)
   * @param options - Optional scheduling configuration
   * @param options.contextId - Transaction ID to group work; defaults to active transaction
   * @param options.jobId - Unique identifier for this job; defaults to this builder instance
   * @param options.alias - Source alias that triggered this schedule; adds alias-specific dependencies
   * @param options.dependencies - Explicit dependency list; overrides auto-discovered dependencies
   */
  scheduleGraphRun(t, n) {
    var c;
    const r = (n == null ? void 0 : n.contextId) ?? ((c = kM()) == null ? void 0 : c.id), i = (n == null ? void 0 : n.jobId) ?? this, o = (() => {
      if (n != null && n.dependencies)
        return n.dependencies;
      const a = new Set(this.builderDependencies);
      if (n != null && n.alias) {
        const u = this.aliasDependencies[n.alias];
        if (u)
          for (const f of u)
            a.add(f);
      }
      return a.delete(this), Array.from(a);
    })();
    if (r)
      for (const a of o)
        typeof a.scheduleGraphRun == "function" && a.scheduleGraphRun(void 0, { contextId: r });
    if (!this.currentSyncConfig || !this.currentSyncState)
      throw new Error(
        "scheduleGraphRun called without active sync session. This should not happen."
      );
    let s = r ? this.pendingGraphRuns.get(r) : void 0;
    s || (s = {
      loadCallbacks: /* @__PURE__ */ new Set()
    }, r && this.pendingGraphRuns.set(r, s)), t && s.loadCallbacks.add(t);
    const l = r ? void 0 : s;
    pL.schedule({
      contextId: r,
      jobId: i,
      dependencies: o,
      run: () => this.executeGraphRun(r, l)
    });
  }
  /**
   * Clears pending graph run state for a specific context.
   * Called when the scheduler clears a context (e.g., transaction rollback/abort).
   */
  clearPendingGraphRun(t) {
    this.pendingGraphRuns.delete(t);
  }
  /**
   * Returns true if this builder has a pending graph run for the given context.
   */
  hasPendingGraphRun(t) {
    return this.pendingGraphRuns.has(t);
  }
  /**
   * Executes a pending graph run. Called by the scheduler when dependencies are satisfied.
   * Clears the pending state BEFORE execution so that any re-schedules during the run
   * create fresh state and don't interfere with the current execution.
   * Uses instance sync state - if sync has ended, gracefully returns without executing.
   *
   * @param contextId - Optional context ID to look up pending state
   * @param pendingParam - For immediate execution (no context), pending state is passed directly
   */
  executeGraphRun(t, n) {
    const r = n ?? (t ? this.pendingGraphRuns.get(t) : void 0);
    if (t && this.pendingGraphRuns.delete(t), !r || !this.currentSyncConfig || !this.currentSyncState)
      return;
    this.incrementRunCount();
    const i = () => {
      let o = !0, s;
      if (r.loadCallbacks.forEach((l) => {
        try {
          o = l() && o;
        } catch (c) {
          o = !1, s ?? (s = c);
        }
      }), s)
        throw s;
      return o;
    };
    this.maybeRunGraph(i);
  }
  getSyncConfig() {
    return {
      rowUpdateMode: "full",
      sync: this.syncFn.bind(this)
    };
  }
  incrementRunCount() {
    this.runCount++;
  }
  getRunCount() {
    return this.runCount;
  }
  syncFn(t) {
    this.liveQueryCollection = t.collection, this.currentSyncConfig = t;
    const n = {
      messagesCount: 0,
      subscribedToAllCollections: !1,
      unsubscribeCallbacks: /* @__PURE__ */ new Set()
    }, r = this.extendPipelineWithChangeProcessing(
      t,
      n
    );
    this.currentSyncState = r, this.unsubscribeFromSchedulerClears = pL.onClear(
      (s) => {
        this.clearPendingGraphRun(s);
      }
    );
    const i = t.collection.on(
      "loadingSubset:change",
      (s) => {
        s.isLoadingSubset || this.updateLiveQueryStatus(t);
      }
    );
    n.unsubscribeCallbacks.add(i);
    const o = this.subscribeToAllCollections(
      t,
      r
    );
    return this.maybeRunGraphFn = () => this.scheduleGraphRun(o), this.scheduleGraphRun(o), () => {
      var s;
      n.unsubscribeCallbacks.forEach((l) => l()), this.currentSyncConfig = void 0, this.currentSyncState = void 0, this.pendingGraphRuns.clear(), this.graphCache = void 0, this.inputsCache = void 0, this.pipelineCache = void 0, this.sourceWhereClausesCache = void 0, this.lazySources.clear(), this.optimizableOrderByCollections = {}, this.lazySourcesCallbacks = {}, Object.keys(this.subscriptions).forEach(
        (l) => delete this.subscriptions[l]
      ), this.compiledAliasToCollectionId = {}, (s = this.unsubscribeFromSchedulerClears) == null || s.call(this), this.unsubscribeFromSchedulerClears = void 0;
    };
  }
  /**
   * Compiles the query pipeline with all declared aliases.
   */
  compileBasePipeline() {
    this.graphCache = new lYt(), this.inputsCache = Object.fromEntries(
      Object.keys(this.collectionByAlias).map((r) => [
        r,
        this.graphCache.newInput()
      ])
    );
    const t = yJ(
      this.query,
      this.inputsCache,
      this.collections,
      this.subscriptions,
      this.lazySourcesCallbacks,
      this.lazySources,
      this.optimizableOrderByCollections,
      (r) => {
        this.windowFn = r;
      }
    );
    this.pipelineCache = t.pipeline, this.sourceWhereClausesCache = t.sourceWhereClauses, this.compiledAliasToCollectionId = t.aliasToCollectionId;
    const n = Object.keys(this.compiledAliasToCollectionId).filter(
      (r) => !Object.hasOwn(this.inputsCache, r)
    );
    if (n.length > 0)
      throw new dGt(n);
  }
  maybeCompileBasePipeline() {
    return (!this.graphCache || !this.inputsCache || !this.pipelineCache) && this.compileBasePipeline(), {
      graph: this.graphCache,
      inputs: this.inputsCache,
      pipeline: this.pipelineCache
    };
  }
  extendPipelineWithChangeProcessing(t, n) {
    const { begin: r, commit: i } = t, { graph: o, inputs: s, pipeline: l } = this.maybeCompileBasePipeline();
    let c = /* @__PURE__ */ new Map();
    return l.pipe(
      xYt((a) => {
        const u = a.getInner();
        n.messagesCount += u.length, u.reduce(Men, c);
      })
    ), n.flushPendingChanges = () => {
      c.size !== 0 && (r(), c.forEach(this.applyChanges.bind(this, t)), i(), c = /* @__PURE__ */ new Map());
    }, o.finalize(), n.graph = o, n.inputs = s, n.pipeline = l, n;
  }
  applyChanges(t, n, r) {
    const { write: i, collection: o } = t, { deletes: s, inserts: l, value: c, orderByIndex: a } = n;
    if (this.resultKeys.set(c, r), a !== void 0 && this.orderByIndices.set(c, a), l && s === 0)
      i({
        value: c,
        type: "insert"
      });
    else if (
      // Insert & update(s) (updates are a delete & insert)
      l > s || // Just update(s) but the item is already in the collection (so
      // was inserted previously).
      l === s && o.has(o.getKeyFromItem(c))
    )
      i({
        value: c,
        type: "update"
      });
    else if (s > 0)
      i({
        value: c,
        type: "delete"
      });
    else
      throw new Error(
        `Could not apply changes: ${JSON.stringify(n)}. This should never happen.`
      );
  }
  /**
   * Handle status changes from source collections
   */
  handleSourceStatusChange(t, n, r) {
    const { status: i } = r;
    if (i === "error") {
      this.transitionToError(
        `Source collection '${n}' entered error state`
      );
      return;
    }
    if (i === "cleaned-up") {
      this.transitionToError(
        `Source collection '${n}' was manually cleaned up while live query '${this.id}' depends on it. Live queries prevent automatic GC, so this was likely a manual cleanup() call.`
      );
      return;
    }
    this.updateLiveQueryStatus(t);
  }
  /**
   * Update the live query status based on source collection statuses
   */
  updateLiveQueryStatus(t) {
    var r, i;
    const { markReady: n } = t;
    this.isInErrorState || (r = this.currentSyncState) != null && r.subscribedToAllCollections && this.allCollectionsReady() && !((i = this.liveQueryCollection) != null && i.isLoadingSubset) && n();
  }
  /**
   * Transition the live query to error state
   */
  transitionToError(t) {
    var n;
    this.isInErrorState = !0, console.error(`[Live Query Error] ${t}`), (n = this.liveQueryCollection) == null || n._lifecycle.setStatus("error");
  }
  allCollectionsReady() {
    return Object.values(this.collections).every(
      (t) => t.isReady()
    );
  }
  /**
   * Creates per-alias subscriptions enabling self-join support.
   * Each alias gets its own subscription with independent filters, even for the same collection.
   * Example: `{ employee: col, manager: col }` creates two separate subscriptions.
   */
  subscribeToAllCollections(t, n) {
    const r = Object.entries(this.compiledAliasToCollectionId);
    if (r.length === 0)
      throw new Error(
        `Compiler returned no alias metadata for query '${this.id}'. This should not happen; please report.`
      );
    const i = r.map(([s, l]) => {
      const c = this.collectionByAlias[s] ?? this.collections[l], a = Ten(c);
      a && a !== this ? (this.aliasDependencies[s] = [a], this.builderDependencies.add(a)) : this.aliasDependencies[s] = [];
      const u = new Aen(
        s,
        l,
        c,
        this
      ), f = c.on("status:change", (h) => {
        this.handleSourceStatusChange(t, l, h);
      });
      n.unsubscribeCallbacks.add(f);
      const d = u.subscribe();
      return this.subscriptions[s] = d, u.loadMoreIfNeeded.bind(
        u,
        d
      );
    }), o = () => (i.map((s) => s()), !0);
    return n.subscribedToAllCollections = !0, o;
  }
}
function Nen(e) {
  return typeof e.query == "function" ? WJt(e.query) : k6e(e.query);
}
function Pen(e) {
  return (t, n) => {
    const r = e.get(t), i = e.get(n);
    return r && i ? r < i ? -1 : r > i ? 1 : 0 : 0;
  };
}
function Ien(e) {
  const t = {};
  function n(i) {
    i.type === "collectionRef" ? t[i.collection.id] = i.collection : i.type === "queryRef" && r(i.query);
  }
  function r(i) {
    if (i.from && n(i.from), i.join && Array.isArray(i.join))
      for (const o of i.join)
        o.from && n(o.from);
  }
  return r(e), t;
}
function D6e(e) {
  const t = e.from;
  if (t.type === "collectionRef")
    return t.collection;
  if (t.type === "queryRef")
    return D6e(t.query);
  throw new Error(
    `Failed to extract collection. Invalid FROM clause: ${JSON.stringify(e)}`
  );
}
function Ren(e) {
  const t = /* @__PURE__ */ new Map();
  function n(i) {
    if (i)
      if (i.type === "collectionRef") {
        const { id: o } = i.collection, s = t.get(o);
        s ? s.add(i.alias) : t.set(o, /* @__PURE__ */ new Set([i.alias]));
      } else i.type === "queryRef" && r(i.query);
  }
  function r(i) {
    if (i && (n(i.from), i.join))
      for (const o of i.join)
        n(o.from);
  }
  return r(e), t;
}
function Men(e, [[t, n], r]) {
  const [i, o] = n, s = e.get(t) || {
    deletes: 0,
    inserts: 0,
    value: i,
    orderByIndex: o
  };
  return r < 0 ? s.deletes += Math.abs(r) : r > 0 && (s.inserts += r, s.value = i, o !== void 0 && (s.orderByIndex = o)), e.set(t, s), e;
}
function Uhe(e) {
  return new Cen(e).getConfig();
}
function zV(e) {
  if (typeof e == "function") {
    const n = Uhe({
      query: e
    });
    return Vhe(n);
  } else {
    const t = e, n = Uhe(t);
    return t.utils && (n.utils = { ...n.utils, ...t.utils }), Vhe(n);
  }
}
function Vhe(e) {
  const t = E6e(e), n = Sen(e);
  return n && Een(t, n), t;
}
class Xg extends vc {
  constructor(t) {
    super(t), this.name = "QueryCollectionError";
  }
}
class Den extends Xg {
  constructor() {
    super("[QueryCollection] queryKey must be provided."), this.name = "QueryKeyRequiredError";
  }
}
class _en extends Xg {
  constructor() {
    super("[QueryCollection] queryFn must be provided."), this.name = "QueryFnRequiredError";
  }
}
class Len extends Xg {
  constructor() {
    super("[QueryCollection] queryClient must be provided."), this.name = "QueryClientRequiredError";
  }
}
class zen extends Xg {
  constructor() {
    super("[QueryCollection] getKey must be provided."), this.name = "GetKeyRequiredError";
  }
}
class jen extends Xg {
  constructor() {
    super(
      "Collection must be in 'ready' state for manual sync operations. Sync not initialized yet."
    ), this.name = "SyncNotInitializedError";
  }
}
class Fen extends Xg {
  constructor(t) {
    super(`Duplicate key '${t}' found within batch operations`), this.name = "DuplicateKeyInBatchError";
  }
}
class Uen extends Xg {
  constructor(t) {
    super(`Update operation: Item with key '${t}' does not exist`), this.name = "UpdateOperationItemNotFoundError";
  }
}
class Ven extends Xg {
  constructor(t) {
    super(`Delete operation: Item with key '${t}' does not exist`), this.name = "DeleteOperationItemNotFoundError";
  }
}
const ay = /* @__PURE__ */ new WeakMap();
function qen(e, t) {
  const n = Array.isArray(e) ? e : [e], r = [];
  for (const i of n)
    if (i.type === "delete") {
      const o = Array.isArray(i.key) ? i.key : [i.key];
      for (const s of o)
        r.push({ type: "delete", key: s });
    } else {
      const o = Array.isArray(i.data) ? i.data : [i.data];
      for (const s of o) {
        let l;
        if (i.type === "update")
          l = t.getKey(s);
        else {
          const c = t.collection.validateData(
            s,
            i.type === "upsert" ? "insert" : i.type
          );
          l = t.getKey(c);
        }
        r.push({ type: i.type, key: l, data: s });
      }
    }
  return r;
}
function Ben(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const r of e) {
    if (n.has(r.key))
      throw new Fen(r.key);
    if (n.add(r.key), r.type === "update") {
      if (!t.collection._state.syncedData.has(r.key))
        throw new Uen(r.key);
    } else if (r.type === "delete" && !t.collection._state.syncedData.has(r.key))
      throw new Ven(r.key);
  }
}
function RS(e, t) {
  const n = qen(e, t);
  Ben(n, t), t.begin();
  for (const i of n)
    switch (i.type) {
      case "insert": {
        const o = t.collection.validateData(i.data, "insert");
        t.write({
          type: "insert",
          value: o
        });
        break;
      }
      case "update": {
        const s = {
          ...t.collection._state.syncedData.get(i.key),
          ...i.data
        }, l = t.collection.validateData(
          s,
          "update",
          i.key
        );
        t.write({
          type: "update",
          value: l
        });
        break;
      }
      case "delete": {
        const o = t.collection._state.syncedData.get(i.key);
        t.write({
          type: "delete",
          value: o
        });
        break;
      }
      case "upsert": {
        const o = t.collection._state.syncedData.has(i.key), s = t.collection.validateData(
          i.data,
          o ? "update" : "insert",
          i.key
        );
        o ? t.write({
          type: "update",
          value: s
        }) : t.write({
          type: "insert",
          value: s
        });
        break;
      }
    }
  t.commit();
  const r = Array.from(t.collection._state.syncedData.values());
  t.updateCacheData ? t.updateCacheData(r) : t.queryClient.setQueryData(t.queryKey, r);
}
function Xen(e) {
  function t() {
    const n = e();
    if (!n)
      throw new jen();
    return n;
  }
  return {
    writeInsert(n) {
      const r = {
        type: "insert",
        data: n
      }, i = t(), o = ay.get(i);
      if (o != null && o.isActive) {
        o.operations.push(r);
        return;
      }
      RS(r, i);
    },
    writeUpdate(n) {
      const r = {
        type: "update",
        data: n
      }, i = t(), o = ay.get(i);
      if (o != null && o.isActive) {
        o.operations.push(r);
        return;
      }
      RS(r, i);
    },
    writeDelete(n) {
      const r = {
        type: "delete",
        key: n
      }, i = t(), o = ay.get(i);
      if (o != null && o.isActive) {
        o.operations.push(r);
        return;
      }
      RS(r, i);
    },
    writeUpsert(n) {
      const r = {
        type: "upsert",
        data: n
      }, i = t(), o = ay.get(i);
      if (o != null && o.isActive) {
        o.operations.push(r);
        return;
      }
      RS(r, i);
    },
    writeBatch(n) {
      const r = t(), i = ay.get(r);
      if (i != null && i.isActive)
        throw new Error(
          "Cannot nest writeBatch calls. Complete the current batch before starting a new one."
        );
      const o = {
        operations: [],
        isActive: !0
      };
      ay.set(r, o);
      try {
        const s = n();
        if (
          // @ts-expect-error - Runtime check for async callback, callback is typed as () => void but user might pass async
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          s && typeof s == "object" && "then" in s && // @ts-expect-error - Runtime check for async callback, callback is typed as () => void but user might pass async
          typeof s.then == "function"
        )
          throw new Error(
            "writeBatch does not support async callbacks. The callback must be synchronous."
          );
        o.operations.length > 0 && RS(o.operations, r);
      } finally {
        o.isActive = !1, ay.delete(r);
      }
    }
  };
}
function Wen(e) {
  var n;
  if (!e)
    return;
  const t = {};
  return e.where && (t.where = A7(e.where)), (n = e.orderBy) != null && n.length && (t.orderBy = e.orderBy.map((r) => {
    const i = {
      expression: A7(r.expression),
      direction: r.compareOptions.direction,
      nulls: r.compareOptions.nulls,
      stringSort: r.compareOptions.stringSort
    };
    return r.compareOptions.stringSort === "locale" ? {
      ...i,
      locale: r.compareOptions.locale,
      localeOptions: r.compareOptions.localeOptions
    } : i;
  })), e.limit !== void 0 && (t.limit = e.limit), e.offset !== void 0 && (t.offset = e.offset), Object.keys(t).length === 0 ? void 0 : JSON.stringify(t);
}
function A7(e) {
  if (!e)
    return null;
  switch (e.type) {
    case "val":
      return {
        type: "val",
        value: w7(e.value)
      };
    case "ref":
      return {
        type: "ref",
        path: [...e.path]
      };
    case "func":
      return {
        type: "func",
        name: e.name,
        args: e.args.map((t) => A7(t))
      };
    default:
      return null;
  }
}
function w7(e) {
  if (e === void 0)
    return { __type: "undefined" };
  if (typeof e == "number") {
    if (Number.isNaN(e))
      return { __type: "nan" };
    if (e === Number.POSITIVE_INFINITY)
      return { __type: "infinity", sign: 1 };
    if (e === Number.NEGATIVE_INFINITY)
      return { __type: "infinity", sign: -1 };
  }
  return e === null || typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? e : e instanceof Date ? { __type: "date", value: e.toJSON() } : Array.isArray(e) ? e.map((t) => w7(t)) : typeof e == "object" ? Object.fromEntries(
    Object.entries(e).map(([t, n]) => [
      t,
      w7(n)
    ])
  ) : e;
}
class Zen {
  constructor(t, n, r) {
    this.state = t, this.refetchFn = n, this.refetch = n, this.writeInsert = r.writeInsert, this.writeUpdate = r.writeUpdate, this.writeDelete = r.writeDelete, this.writeUpsert = r.writeUpsert, this.writeBatch = r.writeBatch;
  }
  async clearError() {
    this.state.lastError = void 0, this.state.errorCount = 0, this.state.lastErrorUpdatedAt = 0, await this.refetchFn({ throwOnError: !0 });
  }
  // Getters for error state
  get lastError() {
    return this.state.lastError;
  }
  get isError() {
    return !!this.state.lastError;
  }
  get errorCount() {
    return this.state.errorCount;
  }
  // Getters for QueryObserver state
  get isFetching() {
    return Array.from(this.state.observers.values()).some(
      (t) => t.getCurrentResult().isFetching
    );
  }
  get isRefetching() {
    return Array.from(this.state.observers.values()).some(
      (t) => t.getCurrentResult().isRefetching
    );
  }
  get isLoading() {
    return Array.from(this.state.observers.values()).some(
      (t) => t.getCurrentResult().isLoading
    );
  }
  get dataUpdatedAt() {
    return Math.max(
      0,
      ...Array.from(this.state.observers.values()).map(
        (t) => t.getCurrentResult().dataUpdatedAt
      )
    );
  }
  get fetchStatus() {
    return Array.from(this.state.observers.values()).map(
      (t) => t.getCurrentResult().fetchStatus
    );
  }
}
function Hen(e) {
  const {
    queryKey: t,
    queryFn: n,
    select: r,
    queryClient: i,
    enabled: o,
    refetchInterval: s,
    retry: l,
    retryDelay: c,
    staleTime: a,
    getKey: u,
    onInsert: f,
    onUpdate: d,
    onDelete: p,
    meta: h,
    ...m
  } = e, v = m.syncMode ?? "eager";
  if (!t)
    throw new Den();
  if (!n)
    throw new _en();
  if (!i)
    throw new Len();
  if (!u)
    throw new zen();
  const b = {
    lastError: void 0,
    errorCount: 0,
    lastErrorUpdatedAt: 0,
    observers: /* @__PURE__ */ new Map()
  }, A = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), O = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map(), E = (M, D) => {
    const X = O.get(M) || /* @__PURE__ */ new Set();
    X.add(D), O.set(M, X);
    const B = w.get(D) || /* @__PURE__ */ new Set();
    B.add(M), w.set(D, B);
  }, k = (M, D) => {
    const X = O.get(M) || /* @__PURE__ */ new Set();
    X.delete(D), O.set(M, X);
    const B = w.get(D) || /* @__PURE__ */ new Set();
    return B.delete(M), w.set(D, B), X.size === 0;
  }, T = (M) => {
    const { begin: D, write: X, commit: B, markReady: q, collection: H } = M;
    let Y = !1;
    const J = (le) => {
      if (typeof t == "function")
        return t(le);
      if (v === "on-demand") {
        const Oe = Wen(le);
        return Oe !== void 0 ? [...t, Oe] : t;
      } else
        return t;
    }, oe = (le = {}, Oe = n) => {
      const be = J(le), je = lR(be), xe = { ...h, loadSubsetOptions: le };
      if (b.observers.has(je)) {
        S.set(
          je,
          (S.get(je) || 0) + 1
        );
        const Fe = b.observers.get(je), Ke = Fe.getCurrentResult();
        return Ke.isSuccess ? !0 : Ke.isError ? Promise.reject(Ke.error) : new Promise((Ot, Ct) => {
          const Jt = Fe.subscribe((yn) => {
            queueMicrotask(() => {
              yn.isSuccess ? (Jt(), Ot()) : yn.isError && (Jt(), Ct(yn.error));
            });
          });
        });
      }
      const Q = {
        queryKey: be,
        queryFn: Oe,
        meta: xe,
        structuralSharing: !0,
        notifyOnChangeProps: "all",
        // Only include options that are explicitly defined to allow QueryClient defaultOptions to be used
        ...o !== void 0 && { enabled: o },
        ...s !== void 0 && { refetchInterval: s },
        ...l !== void 0 && { retry: l },
        ...c !== void 0 && { retryDelay: c },
        ...a !== void 0 && { staleTime: a }
      }, ae = new aKt(i, Q);
      A.set(je, be), b.observers.set(je, ae), S.set(
        je,
        (S.get(je) || 0) + 1
      );
      const Pe = new Promise((Fe, Ke) => {
        const Ot = ae.subscribe((Ct) => {
          queueMicrotask(() => {
            Ct.isSuccess ? (Ot(), Fe()) : Ct.isError && (Ot(), Ke(Ct.error));
          });
        });
      });
      return (Y || H.subscriberCount > 0) && $(ae, je), Pe;
    }, ce = (le) => {
      const Oe = lR(le);
      return (je) => {
        if (je.isSuccess) {
          b.lastError = void 0, b.errorCount = 0;
          const xe = je.data, Q = r ? r(xe) : xe;
          if (!Array.isArray(Q) || Q.some((Fe) => typeof Fe != "object")) {
            const Fe = r ? `@tanstack/query-db-collection: select() must return an array of objects. Got: ${typeof Q} for queryKey ${JSON.stringify(le)}` : `@tanstack/query-db-collection: queryFn must return an array of objects. Got: ${typeof Q} for queryKey ${JSON.stringify(le)}`;
            console.error(Fe);
            return;
          }
          const ae = new Map(
            H._state.syncedData.entries()
          ), Pe = /* @__PURE__ */ new Map();
          Q.forEach((Fe) => {
            const Ke = u(Fe);
            Pe.set(Ke, Fe);
          }), D(), ae.forEach((Fe, Ke) => {
            const Ot = Pe.get(Ke);
            Ot ? Xu(Fe, Ot) || X({ type: "update", value: Ot }) : k(Ke, Oe) && X({ type: "delete", value: Fe });
          }), Pe.forEach((Fe, Ke) => {
            E(Ke, Oe), ae.has(Ke) || X({ type: "insert", value: Fe });
          }), B(), q();
        } else je.isError && (je.errorUpdatedAt !== b.lastErrorUpdatedAt && (b.lastError = je.error, b.errorCount++, b.lastErrorUpdatedAt = je.errorUpdatedAt), console.error(
          `[QueryCollection] Error observing query ${String(le)}:`,
          je.error
        ), q());
      };
    }, fe = (le) => x.has(le), $ = (le, Oe) => {
      if (!fe(Oe)) {
        const be = A.get(Oe), je = ce(be), xe = le.subscribe(je);
        x.set(Oe, xe);
        const Q = le.getCurrentResult();
        (Q.isSuccess || Q.isError) && je(Q);
      }
    }, pe = () => {
      b.observers.forEach($);
    }, ee = () => {
      x.forEach((le) => {
        le();
      }), x.clear();
    };
    Y = !0;
    const Ce = H.on(
      "subscribers:change",
      ({ subscriberCount: le }) => {
        le > 0 ? pe() : le === 0 && ee();
      }
    );
    if (v === "eager") {
      const le = oe({});
      le instanceof Promise && le.catch(() => {
      });
    } else
      q();
    pe(), b.observers.forEach((le, Oe) => {
      const be = A.get(Oe);
      ce(be)(le.getCurrentResult());
    });
    const Ee = (le) => {
      var je;
      (je = x.get(le)) == null || je(), x.delete(le);
      const Oe = w.get(le) ?? /* @__PURE__ */ new Set(), be = [];
      Oe.forEach((xe) => {
        const Q = O.get(xe);
        Q && (Q.delete(le), Q.size === 0 && (O.delete(xe), H.has(xe) && be.push(H.get(xe))));
      }), be.length > 0 && (D(), be.forEach((xe) => {
        X({ type: "delete", value: xe });
      }), B()), b.observers.delete(le), w.delete(le), A.delete(le), S.delete(le);
    }, Ve = (le) => {
      var xe;
      const Oe = S.get(le) || 0, be = b.observers.get(le);
      if (Oe <= 0 && ((xe = x.get(le)) == null || xe(), x.delete(le)), (be == null ? void 0 : be.hasListeners()) ?? !1) {
        S.set(le, 0);
        return;
      }
      Oe > 0 && console.warn(
        `[cleanupQueryIfIdle] Invariant violation: refcount=${Oe} but no listeners. Cleaning up to prevent leak.`,
        { hashedQueryKey: le }
      ), Ee(le);
    }, et = (le) => {
      Ee(le);
    }, ft = i.getQueryCache().subscribe((le) => {
      const Oe = le.query.queryHash;
      le.type === "removed" && A.has(Oe) && Ve(Oe);
    });
    return {
      loadSubset: v === "eager" ? void 0 : oe,
      unloadSubset: v === "eager" ? void 0 : (le) => {
        const Oe = J(le), be = lR(Oe), xe = (S.get(be) || 0) - 1;
        xe <= 0 ? (S.set(be, 0), Ve(be)) : S.set(be, xe);
      },
      cleanup: async () => {
        Ce(), ee();
        const le = [...A.values()], Oe = [...b.observers.keys()];
        for (const be of Oe)
          et(be);
        ft(), await Promise.all(
          le.map(async (be) => {
            await i.cancelQueries({ queryKey: be, exact: !0 }), i.removeQueries({ queryKey: be, exact: !0 });
          })
        );
      }
    };
  }, R = async (M) => {
    const X = [...A.values()].map((B) => b.observers.get(lR(B)).refetch({
      throwOnError: M == null ? void 0 : M.throwOnError
    }));
    await Promise.all(X);
  }, j = (M) => {
    const D = typeof t == "function" ? t({}) : t;
    r ? i.setQueryData(D, (X) => {
      if (!X || typeof X != "object")
        return X;
      if (Array.isArray(X))
        return M;
      const B = r(X);
      if (Array.isArray(B)) {
        for (const q of Object.keys(X))
          if (X[q] === B)
            return { ...X, [q]: M };
      }
      if (Array.isArray(X.data))
        return { ...X, data: M };
      if (Array.isArray(X.items))
        return { ...X, items: M };
      if (Array.isArray(X.results))
        return { ...X, results: M };
      for (const q of Object.keys(X))
        if (Array.isArray(X[q]))
          return { ...X, [q]: M };
      return X;
    }) : i.setQueryData(D, M);
  };
  let F = null;
  const L = (M) => {
    const { begin: D, write: X, commit: B, collection: q } = M, H = typeof t == "function" ? t({}) : t;
    return F = {
      collection: q,
      queryClient: i,
      queryKey: H,
      getKey: u,
      begin: D,
      write: X,
      commit: B,
      updateCacheData: j
    }, T(M);
  }, _ = Xen(
    () => F
  ), U = f ? async (M) => {
    const D = await f(M) ?? {};
    return D.refetch !== !1 && await R(), D;
  } : void 0, z = d ? async (M) => {
    const D = await d(M) ?? {};
    return D.refetch !== !1 && await R(), D;
  } : void 0, C = p ? async (M) => {
    const D = await p(M) ?? {};
    return D.refetch !== !1 && await R(), D;
  } : void 0, I = new Zen(b, R, _);
  return {
    ...m,
    getKey: u,
    syncMode: v,
    sync: { sync: L },
    onInsert: U,
    onUpdate: z,
    onDelete: C,
    utils: I
  };
}
const jV = 1;
function Qen(e, t = []) {
  const n = e && typeof e == "object" && typeof e.subscribeChanges == "function" && typeof e.startSyncImmediate == "function" && typeof e.id == "string", r = Xe(
    null
  ), i = Xe(null), o = Xe(null), s = Xe(0), l = Xe(null), c = !r.current || n && o.current !== e || !n && (i.current === null || i.current.length !== t.length || i.current.some((h, m) => h !== t[m]));
  if (c)
    if (n)
      e.startSyncImmediate(), r.current = e, o.current = e;
    else if (typeof e == "function") {
      const h = new ko(), m = e(h);
      if (m == null)
        r.current = null;
      else if (m instanceof hJ)
        m.startSyncImmediate(), r.current = m;
      else if (m instanceof ko)
        r.current = zV({
          query: e,
          startSync: !0,
          gcTime: jV
        });
      else if (m && typeof m == "object")
        r.current = zV({
          startSync: !0,
          gcTime: jV,
          ...m
        });
      else
        throw new Error(
          `useLiveQuery callback must return a QueryBuilder, LiveQueryCollectionConfig, Collection, undefined, or null. Got: ${typeof m}`
        );
      i.current = [...t];
    } else
      r.current = zV({
        startSync: !0,
        gcTime: jV,
        ...e
      }), i.current = [...t];
  c && (s.current = 0, l.current = null);
  const a = Xe(null);
  (!a.current || c) && (a.current = (h) => {
    if (!r.current)
      return () => {
      };
    const m = r.current.subscribeChanges(() => {
      s.current += 1, h();
    });
    return r.current.status === "ready" && (s.current += 1, h()), () => {
      m.unsubscribe();
    };
  });
  const u = Xe(null);
  (!u.current || c) && (u.current = () => {
    const h = s.current, m = r.current;
    return (!l.current || l.current.version !== h || l.current.collection !== m) && (l.current = {
      collection: m,
      version: h
    }), l.current;
  });
  const f = Eqe(
    a.current,
    u.current
  ), d = Xe(null), p = Xe(null);
  if (!d.current || d.current.version !== f.version || d.current.collection !== f.collection) {
    if (!f.collection)
      p.current = {
        state: void 0,
        data: void 0,
        collection: void 0,
        status: "disabled",
        isLoading: !1,
        isReady: !0,
        isIdle: !1,
        isError: !1,
        isCleanedUp: !1,
        isEnabled: !1
      };
    else {
      const h = Array.from(f.collection.entries()), v = f.collection.config.singleResult;
      let b = null, A = null;
      p.current = {
        get state() {
          return b || (b = new Map(h)), b;
        },
        get data() {
          return A || (A = h.map(([, w]) => w)), v ? A[0] : A;
        },
        collection: f.collection,
        status: f.collection.status,
        isLoading: f.collection.status === "loading",
        isReady: f.collection.status === "ready",
        isIdle: f.collection.status === "idle",
        isError: f.collection.status === "error",
        isCleanedUp: f.collection.status === "cleaned-up",
        isEnabled: !0
      };
    }
    d.current = f;
  }
  return p.current;
}
function qhe(e, t = []) {
  const n = Xe(null), r = Xe(null), i = Xe(!1), o = Qen(e, t);
  if (r.current !== o.collection && (n.current = null, r.current = o.collection, i.current = !1), o.status === "ready" && (i.current = !0, n.current = null), !o.isEnabled)
    throw new Error(
      "useLiveSuspenseQuery does not support disabled queries (callback returned undefined/null). The Suspense pattern requires data to always be defined (T, not T | undefined). Solutions: 1) Use conditional rendering - don't render the component until the condition is met. 2) Use useLiveQuery instead, which supports disabled queries with the 'isEnabled' flag."
    );
  if (o.status === "error" && !i.current)
    throw n.current = null, new Error(`Collection "${o.collection.id}" failed to load`);
  if (o.status === "loading" || o.status === "idle")
    throw n.current || (n.current = o.collection.preload()), n.current;
  return {
    state: o.state,
    data: o.data,
    collection: o.collection
  };
}
const _6e = {
  current: async (e) => _6e.get(e),
  list(e) {
    return dt.get("/users/projects", e);
  },
  get: async (e) => dt.get(`/users/projects/${e}`),
  update: async (e, t) => dt.post(`/projects/${e}`, t),
  create: async (e) => dt.post("/projects", e),
  delete: async (e) => dt.delete(`/projects/${e}`),
  listForPlatforms: async () => dt.get(
    "/users/projects/platforms"
  )
}, $en = new rwe(), MS = E6e(
  Hen({
    queryKey: ["projects"],
    queryClient: $en,
    queryFn: async () => {
      const e = {
        cursor: void 0,
        limit: 3e4
      };
      return (await dt.get(
        "/users/projects",
        e
      )).data;
    },
    getKey: (e) => e.id,
    onUpdate: async ({ transaction: e }) => {
      for (const { original: t, modified: n } of e.mutations) {
        const r = {
          displayName: n.displayName,
          metadata: n.metadata ?? void 0,
          releasesEnabled: n.releasesEnabled,
          externalId: !De(n.externalId) && n.externalId.trim() !== "" ? n.externalId : void 0,
          icon: n.icon,
          plan: n.plan
        };
        await dt.post(
          `/users/projects/${t.id}`,
          r
        );
      }
    },
    onInsert: async ({ transaction: e }) => {
      for (const { modified: t } of e.mutations)
        await dt.post("/v1/projects", t);
    },
    onDelete: async ({ transaction: e }) => {
      for (const { original: t } of e.mutations)
        await dt.delete(`/v1/projects/${t.id}`);
    }
  })
), bJ = {
  useCreateProject: (e, t) => dr({
    mutationFn: (n) => dt.post("/v1/projects", n),
    onSuccess: (n) => {
      MS.utils.writeInsert(n), e(n);
    },
    onError: (n) => {
      t(n);
    }
  }),
  update: (e, t) => {
    MS.update(e, (n) => {
      Object.assign(
        n,
        Object.fromEntries(
          Object.entries(t).filter(([r, i]) => i !== void 0)
        )
      );
    });
  },
  delete: (e) => {
    MS.delete(e);
  },
  setCurrentProject: (e, t) => {
    if (Rn.switchToProject(e), t) {
      const n = t.replace(
        /\/projects\/\w+/,
        `/projects/${e}`
      );
      window.location.href = n;
    }
  },
  useCurrentProject: () => {
    const { projectId: e } = ol();
    return {
      ...pr({
        queryKey: ["current-project", e],
        queryFn: () => _6e.current(e),
        staleTime: 1 / 0
      }),
      project: {
        id: e
      }
    };
  },
  useAll: () => {
    const e = Rn.getCurrentUserId();
    return qhe(
      (t) => t.from({ project: MS }).where(
        ({ project: n }) => A6e(
          cA(n.type, H2.TEAM),
          cA(n.ownerId, e)
        )
      ).orderBy(({ project: n }) => n.type, "asc").orderBy(({ project: n }) => n.created, "asc").select(({ project: n }) => ({ ...n })),
      [e]
    );
  },
  useHasAccessToProject: (e) => {
    const { data: t } = qhe(
      (n) => n.from({ project: MS }).where(({ project: r }) => cA(r.id, e)).select(({ project: r }) => ({ ...r })).findOne()
    );
    return !De(t);
  }
}, x7 = ({
  text: e,
  amountOfCharacters: t = 80
}) => {
  const [n, r] = He(!1), i = e.length > t, o = i ? e.slice(0, t) : e, s = e.slice(t);
  return /* @__PURE__ */ V("p", { className: "text-muted-foreground text-xs whitespace-pre-wrap", children: [
    o,
    i && /* @__PURE__ */ V(pt, { children: [
      !n && /* @__PURE__ */ y("span", { children: "... " }),
      /* @__PURE__ */ y(
        "span",
        {
          className: `${!n && "hidden"} whitespace-pre-wrap`,
          "aria-hidden": !n,
          children: s
        }
      ),
      /* @__PURE__ */ y(
        "span",
        {
          className: "text-primary ml-2 cursor-pointer",
          role: "button",
          tabIndex: 0,
          "aria-expanded": n,
          onKeyDown: (c) => {
            (c.code === "Space" || c.code === "Enter") && r(!n);
          },
          onClick: () => r(!n),
          children: n ? "show less" : "show more"
        }
      )
    ] })
  ] });
}, L6e = ie.memo(
  ({
    hideContinueOnFailure: e,
    hideRetryOnFailure: t,
    disabled: n
  }) => {
    const r = _r();
    return /* @__PURE__ */ V("div", { className: "grid gap-4", children: [
      e !== !0 && /* @__PURE__ */ y(
        Zn,
        {
          name: "settings.errorHandlingOptions.continueOnFailure.value",
          control: r.control,
          render: ({ field: i }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col items-start justify-between", children: [
            /* @__PURE__ */ V(
              ui,
              {
                htmlFor: "continueOnFailure",
                className: "flex items-center justify-center",
                children: [
                  /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(
                    Iw,
                    {
                      disabled: n,
                      id: "continueOnFailure",
                      checked: i.value,
                      onCheckedChange: i.onChange
                    }
                  ) }),
                  /* @__PURE__ */ y("span", { className: "ml-3 grow", children: Z("Continue on Failure") })
                ]
              }
            ),
            /* @__PURE__ */ y(
              x7,
              {
                text: Z(
                  "Enable this option to skip this step and continue the flow normally if it fails."
                )
              }
            )
          ] })
        }
      ),
      t !== !0 && /* @__PURE__ */ y(
        Zn,
        {
          name: "settings.errorHandlingOptions.retryOnFailure.value",
          control: r.control,
          render: ({ field: i }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col items-start justify-between", children: [
            /* @__PURE__ */ V(
              ui,
              {
                htmlFor: "retryOnFailure",
                className: "flex items-center justify-center",
                children: [
                  /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(
                    Iw,
                    {
                      disabled: n,
                      id: "retryOnFailure",
                      checked: i.value,
                      onCheckedChange: i.onChange
                    }
                  ) }),
                  /* @__PURE__ */ y("span", { className: "ml-3 grow", children: Z("Retry on Failure") })
                ]
              }
            ),
            /* @__PURE__ */ y(
              x7,
              {
                text: Z(
                  "Automatically retry up to four attempts when failed."
                )
              }
            )
          ] })
        }
      )
    ] });
  }
);
L6e.displayName = "ActionErrorHandlingForm";
const Fb = Ri({
  propertiesNamesStillLoading: [],
  propertyLoadingFinished: (e) => {
  },
  propertyLoadingStarted: (e) => {
  },
  isLoadingDynamicProperties: !1
}), Ken = ({
  children: e
}) => {
  const [t, n] = He([]), r = qn((l) => {
    n(
      (c) => c.filter((a) => a !== l)
    );
  }, []), i = qn((l) => {
    n((c) => [...c, l]);
  }, []), o = Kt(
    () => t.length > 0,
    [t]
  ), s = Kt(
    () => ({
      propertiesNamesStillLoading: t,
      propertyLoadingFinished: r,
      propertyLoadingStarted: i,
      isLoadingDynamicProperties: o
    }),
    [
      t,
      r,
      i,
      o
    ]
  );
  return /* @__PURE__ */ y(Fb.Provider, { value: s, children: e });
};
var CM = { exports: {} }, Gen = CM.exports, Bhe;
function Yen() {
  return Bhe || (Bhe = 1, function(e, t) {
    (function(n, r) {
      e.exports = r(ie);
    })(Gen, function(n) {
      return function(r) {
        var i = {};
        function o(s) {
          if (i[s]) return i[s].exports;
          var l = i[s] = { i: s, l: !1, exports: {} };
          return r[s].call(l.exports, l, l.exports, o), l.l = !0, l.exports;
        }
        return o.m = r, o.c = i, o.d = function(s, l, c) {
          o.o(s, l) || Object.defineProperty(s, l, { enumerable: !0, get: c });
        }, o.r = function(s) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        }, o.t = function(s, l) {
          if (1 & l && (s = o(s)), 8 & l || 4 & l && typeof s == "object" && s && s.__esModule) return s;
          var c = /* @__PURE__ */ Object.create(null);
          if (o.r(c), Object.defineProperty(c, "default", { enumerable: !0, value: s }), 2 & l && typeof s != "string") for (var a in s) o.d(c, a, (function(u) {
            return s[u];
          }).bind(null, a));
          return c;
        }, o.n = function(s) {
          var l = s && s.__esModule ? function() {
            return s.default;
          } : function() {
            return s;
          };
          return o.d(l, "a", l), l;
        }, o.o = function(s, l) {
          return Object.prototype.hasOwnProperty.call(s, l);
        }, o.p = "", o(o.s = 48);
      }([function(r, i) {
        r.exports = n;
      }, function(r, i) {
        var o = r.exports = { version: "2.6.12" };
        typeof __e == "number" && (__e = o);
      }, function(r, i, o) {
        var s = o(26)("wks"), l = o(17), c = o(3).Symbol, a = typeof c == "function";
        (r.exports = function(u) {
          return s[u] || (s[u] = a && c[u] || (a ? c : l)("Symbol." + u));
        }).store = s;
      }, function(r, i) {
        var o = r.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
        typeof __g == "number" && (__g = o);
      }, function(r, i, o) {
        r.exports = !o(8)(function() {
          return Object.defineProperty({}, "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, function(r, i) {
        var o = {}.hasOwnProperty;
        r.exports = function(s, l) {
          return o.call(s, l);
        };
      }, function(r, i, o) {
        var s = o(7), l = o(16);
        r.exports = o(4) ? function(c, a, u) {
          return s.f(c, a, l(1, u));
        } : function(c, a, u) {
          return c[a] = u, c;
        };
      }, function(r, i, o) {
        var s = o(10), l = o(35), c = o(23), a = Object.defineProperty;
        i.f = o(4) ? Object.defineProperty : function(u, f, d) {
          if (s(u), f = c(f, !0), s(d), l) try {
            return a(u, f, d);
          } catch {
          }
          if ("get" in d || "set" in d) throw TypeError("Accessors not supported!");
          return "value" in d && (u[f] = d.value), u;
        };
      }, function(r, i) {
        r.exports = function(o) {
          try {
            return !!o();
          } catch {
            return !0;
          }
        };
      }, function(r, i, o) {
        var s = o(40), l = o(22);
        r.exports = function(c) {
          return s(l(c));
        };
      }, function(r, i, o) {
        var s = o(11);
        r.exports = function(l) {
          if (!s(l)) throw TypeError(l + " is not an object!");
          return l;
        };
      }, function(r, i) {
        r.exports = function(o) {
          return typeof o == "object" ? o !== null : typeof o == "function";
        };
      }, function(r, i) {
        r.exports = {};
      }, function(r, i, o) {
        var s = o(39), l = o(27);
        r.exports = Object.keys || function(c) {
          return s(c, l);
        };
      }, function(r, i) {
        r.exports = !0;
      }, function(r, i, o) {
        var s = o(3), l = o(1), c = o(53), a = o(6), u = o(5), f = function(d, p, h) {
          var m, v, b, A = d & f.F, w = d & f.G, O = d & f.S, x = d & f.P, S = d & f.B, E = d & f.W, k = w ? l : l[p] || (l[p] = {}), T = k.prototype, R = w ? s : O ? s[p] : (s[p] || {}).prototype;
          for (m in w && (h = p), h) (v = !A && R && R[m] !== void 0) && u(k, m) || (b = v ? R[m] : h[m], k[m] = w && typeof R[m] != "function" ? h[m] : S && v ? c(b, s) : E && R[m] == b ? function(j) {
            var F = function(L, _, U) {
              if (this instanceof j) {
                switch (arguments.length) {
                  case 0:
                    return new j();
                  case 1:
                    return new j(L);
                  case 2:
                    return new j(L, _);
                }
                return new j(L, _, U);
              }
              return j.apply(this, arguments);
            };
            return F.prototype = j.prototype, F;
          }(b) : x && typeof b == "function" ? c(Function.call, b) : b, x && ((k.virtual || (k.virtual = {}))[m] = b, d & f.R && T && !T[m] && a(T, m, b)));
        };
        f.F = 1, f.G = 2, f.S = 4, f.P = 8, f.B = 16, f.W = 32, f.U = 64, f.R = 128, r.exports = f;
      }, function(r, i) {
        r.exports = function(o, s) {
          return { enumerable: !(1 & o), configurable: !(2 & o), writable: !(4 & o), value: s };
        };
      }, function(r, i) {
        var o = 0, s = Math.random();
        r.exports = function(l) {
          return "Symbol(".concat(l === void 0 ? "" : l, ")_", (++o + s).toString(36));
        };
      }, function(r, i, o) {
        var s = o(22);
        r.exports = function(l) {
          return Object(s(l));
        };
      }, function(r, i) {
        i.f = {}.propertyIsEnumerable;
      }, function(r, i, o) {
        var s = o(52)(!0);
        o(34)(String, "String", function(l) {
          this._t = String(l), this._i = 0;
        }, function() {
          var l, c = this._t, a = this._i;
          return a >= c.length ? { value: void 0, done: !0 } : (l = s(c, a), this._i += l.length, { value: l, done: !1 });
        });
      }, function(r, i) {
        var o = Math.ceil, s = Math.floor;
        r.exports = function(l) {
          return isNaN(l = +l) ? 0 : (l > 0 ? s : o)(l);
        };
      }, function(r, i) {
        r.exports = function(o) {
          if (o == null) throw TypeError("Can't call method on  " + o);
          return o;
        };
      }, function(r, i, o) {
        var s = o(11);
        r.exports = function(l, c) {
          if (!s(l)) return l;
          var a, u;
          if (c && typeof (a = l.toString) == "function" && !s(u = a.call(l)) || typeof (a = l.valueOf) == "function" && !s(u = a.call(l)) || !c && typeof (a = l.toString) == "function" && !s(u = a.call(l))) return u;
          throw TypeError("Can't convert object to primitive value");
        };
      }, function(r, i) {
        var o = {}.toString;
        r.exports = function(s) {
          return o.call(s).slice(8, -1);
        };
      }, function(r, i, o) {
        var s = o(26)("keys"), l = o(17);
        r.exports = function(c) {
          return s[c] || (s[c] = l(c));
        };
      }, function(r, i, o) {
        var s = o(1), l = o(3), c = l["__core-js_shared__"] || (l["__core-js_shared__"] = {});
        (r.exports = function(a, u) {
          return c[a] || (c[a] = u !== void 0 ? u : {});
        })("versions", []).push({ version: s.version, mode: o(14) ? "pure" : "global", copyright: "© 2020 Denis Pushkarev (zloirock.ru)" });
      }, function(r, i) {
        r.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
      }, function(r, i, o) {
        var s = o(7).f, l = o(5), c = o(2)("toStringTag");
        r.exports = function(a, u, f) {
          a && !l(a = f ? a : a.prototype, c) && s(a, c, { configurable: !0, value: u });
        };
      }, function(r, i, o) {
        o(62);
        for (var s = o(3), l = o(6), c = o(12), a = o(2)("toStringTag"), u = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), f = 0; f < u.length; f++) {
          var d = u[f], p = s[d], h = p && p.prototype;
          h && !h[a] && l(h, a, d), c[d] = c.Array;
        }
      }, function(r, i, o) {
        i.f = o(2);
      }, function(r, i, o) {
        var s = o(3), l = o(1), c = o(14), a = o(30), u = o(7).f;
        r.exports = function(f) {
          var d = l.Symbol || (l.Symbol = c ? {} : s.Symbol || {});
          f.charAt(0) == "_" || f in d || u(d, f, { value: a.f(f) });
        };
      }, function(r, i) {
        i.f = Object.getOwnPropertySymbols;
      }, function(r, i) {
        r.exports = function(o, s, l) {
          return Math.min(Math.max(o, s), l);
        };
      }, function(r, i, o) {
        var s = o(14), l = o(15), c = o(37), a = o(6), u = o(12), f = o(55), d = o(28), p = o(61), h = o(2)("iterator"), m = !([].keys && "next" in [].keys()), v = function() {
          return this;
        };
        r.exports = function(b, A, w, O, x, S, E) {
          f(w, A, O);
          var k, T, R, j = function(D) {
            if (!m && D in U) return U[D];
            switch (D) {
              case "keys":
              case "values":
                return function() {
                  return new w(this, D);
                };
            }
            return function() {
              return new w(this, D);
            };
          }, F = A + " Iterator", L = x == "values", _ = !1, U = b.prototype, z = U[h] || U["@@iterator"] || x && U[x], C = z || j(x), I = x ? L ? j("entries") : C : void 0, M = A == "Array" && U.entries || z;
          if (M && (R = p(M.call(new b()))) !== Object.prototype && R.next && (d(R, F, !0), s || typeof R[h] == "function" || a(R, h, v)), L && z && z.name !== "values" && (_ = !0, C = function() {
            return z.call(this);
          }), s && !E || !m && !_ && U[h] || a(U, h, C), u[A] = C, u[F] = v, x) if (k = { values: L ? C : j("values"), keys: S ? C : j("keys"), entries: I }, E) for (T in k) T in U || c(U, T, k[T]);
          else l(l.P + l.F * (m || _), A, k);
          return k;
        };
      }, function(r, i, o) {
        r.exports = !o(4) && !o(8)(function() {
          return Object.defineProperty(o(36)("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, function(r, i, o) {
        var s = o(11), l = o(3).document, c = s(l) && s(l.createElement);
        r.exports = function(a) {
          return c ? l.createElement(a) : {};
        };
      }, function(r, i, o) {
        r.exports = o(6);
      }, function(r, i, o) {
        var s = o(10), l = o(56), c = o(27), a = o(25)("IE_PROTO"), u = function() {
        }, f = function() {
          var d, p = o(36)("iframe"), h = c.length;
          for (p.style.display = "none", o(60).appendChild(p), p.src = "javascript:", (d = p.contentWindow.document).open(), d.write("<script>document.F=Object<\/script>"), d.close(), f = d.F; h--; ) delete f.prototype[c[h]];
          return f();
        };
        r.exports = Object.create || function(d, p) {
          var h;
          return d !== null ? (u.prototype = s(d), h = new u(), u.prototype = null, h[a] = d) : h = f(), p === void 0 ? h : l(h, p);
        };
      }, function(r, i, o) {
        var s = o(5), l = o(9), c = o(57)(!1), a = o(25)("IE_PROTO");
        r.exports = function(u, f) {
          var d, p = l(u), h = 0, m = [];
          for (d in p) d != a && s(p, d) && m.push(d);
          for (; f.length > h; ) s(p, d = f[h++]) && (~c(m, d) || m.push(d));
          return m;
        };
      }, function(r, i, o) {
        var s = o(24);
        r.exports = Object("z").propertyIsEnumerable(0) ? Object : function(l) {
          return s(l) == "String" ? l.split("") : Object(l);
        };
      }, function(r, i, o) {
        var s = o(39), l = o(27).concat("length", "prototype");
        i.f = Object.getOwnPropertyNames || function(c) {
          return s(c, l);
        };
      }, function(r, i, o) {
        var s = o(24), l = o(2)("toStringTag"), c = s(/* @__PURE__ */ function() {
          return arguments;
        }()) == "Arguments";
        r.exports = function(a) {
          var u, f, d;
          return a === void 0 ? "Undefined" : a === null ? "Null" : typeof (f = function(p, h) {
            try {
              return p[h];
            } catch {
            }
          }(u = Object(a), l)) == "string" ? f : c ? s(u) : (d = s(u)) == "Object" && typeof u.callee == "function" ? "Arguments" : d;
        };
      }, function(r, i) {
        var o;
        o = /* @__PURE__ */ function() {
          return this;
        }();
        try {
          o = o || new Function("return this")();
        } catch {
          typeof window == "object" && (o = window);
        }
        r.exports = o;
      }, function(r, i) {
        var o = /-?\d+(\.\d+)?%?/g;
        r.exports = function(s) {
          return s.match(o);
        };
      }, function(r, i, o) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.getBase16Theme = i.createStyling = i.invertTheme = void 0;
        var s = v(o(49)), l = v(o(76)), c = v(o(81)), a = v(o(89)), u = v(o(93)), f = function(T) {
          if (T && T.__esModule) return T;
          var R = {};
          if (T != null) for (var j in T) Object.prototype.hasOwnProperty.call(T, j) && (R[j] = T[j]);
          return R.default = T, R;
        }(o(94)), d = v(o(132)), p = v(o(133)), h = v(o(138)), m = o(139);
        function v(T) {
          return T && T.__esModule ? T : { default: T };
        }
        var b = f.default, A = (0, a.default)(b), w = (0, h.default)(p.default, m.rgb2yuv, function(T) {
          var R, j = (0, c.default)(T, 3), F = j[0], L = j[1], _ = j[2];
          return [(R = F, R < 0.25 ? 1 : R < 0.5 ? 0.9 - R : 1.1 - R), L, _];
        }, m.yuv2rgb, d.default), O = function(T) {
          return function(R) {
            return { className: [R.className, T.className].filter(Boolean).join(" "), style: (0, l.default)({}, R.style || {}, T.style || {}) };
          };
        }, x = function(T, R) {
          var j = (0, a.default)(R);
          for (var F in T) j.indexOf(F) === -1 && j.push(F);
          return j.reduce(function(L, _) {
            return L[_] = function(U, z) {
              if (U === void 0) return z;
              if (z === void 0) return U;
              var C = U === void 0 ? "undefined" : (0, s.default)(U), I = z === void 0 ? "undefined" : (0, s.default)(z);
              switch (C) {
                case "string":
                  switch (I) {
                    case "string":
                      return [z, U].filter(Boolean).join(" ");
                    case "object":
                      return O({ className: U, style: z });
                    case "function":
                      return function(M) {
                        for (var D = arguments.length, X = Array(D > 1 ? D - 1 : 0), B = 1; B < D; B++) X[B - 1] = arguments[B];
                        return O({ className: U })(z.apply(void 0, [M].concat(X)));
                      };
                  }
                case "object":
                  switch (I) {
                    case "string":
                      return O({ className: z, style: U });
                    case "object":
                      return (0, l.default)({}, z, U);
                    case "function":
                      return function(M) {
                        for (var D = arguments.length, X = Array(D > 1 ? D - 1 : 0), B = 1; B < D; B++) X[B - 1] = arguments[B];
                        return O({ style: U })(z.apply(void 0, [M].concat(X)));
                      };
                  }
                case "function":
                  switch (I) {
                    case "string":
                      return function(M) {
                        for (var D = arguments.length, X = Array(D > 1 ? D - 1 : 0), B = 1; B < D; B++) X[B - 1] = arguments[B];
                        return U.apply(void 0, [O(M)({ className: z })].concat(X));
                      };
                    case "object":
                      return function(M) {
                        for (var D = arguments.length, X = Array(D > 1 ? D - 1 : 0), B = 1; B < D; B++) X[B - 1] = arguments[B];
                        return U.apply(void 0, [O(M)({ style: z })].concat(X));
                      };
                    case "function":
                      return function(M) {
                        for (var D = arguments.length, X = Array(D > 1 ? D - 1 : 0), B = 1; B < D; B++) X[B - 1] = arguments[B];
                        return U.apply(void 0, [z.apply(void 0, [M].concat(X))].concat(X));
                      };
                  }
              }
            }(T[_], R[_]), L;
          }, {});
        }, S = function(T, R) {
          for (var j = arguments.length, F = Array(j > 2 ? j - 2 : 0), L = 2; L < j; L++) F[L - 2] = arguments[L];
          if (R === null) return T;
          Array.isArray(R) || (R = [R]);
          var _ = R.map(function(z) {
            return T[z];
          }).filter(Boolean), U = _.reduce(function(z, C) {
            return typeof C == "string" ? z.className = [z.className, C].filter(Boolean).join(" ") : (C === void 0 ? "undefined" : (0, s.default)(C)) === "object" ? z.style = (0, l.default)({}, z.style, C) : typeof C == "function" && (z = (0, l.default)({}, z, C.apply(void 0, [z].concat(F)))), z;
          }, { className: "", style: {} });
          return U.className || delete U.className, (0, a.default)(U.style).length === 0 && delete U.style, U;
        }, E = i.invertTheme = function(T) {
          return (0, a.default)(T).reduce(function(R, j) {
            return R[j] = /^base/.test(j) ? w(T[j]) : j === "scheme" ? T[j] + ":inverted" : T[j], R;
          }, {});
        }, k = (i.createStyling = (0, u.default)(function(T) {
          for (var R = arguments.length, j = Array(R > 3 ? R - 3 : 0), F = 3; F < R; F++) j[F - 3] = arguments[F];
          var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, U = L.defaultBase16, z = U === void 0 ? b : U, C = L.base16Themes, I = C === void 0 ? null : C, M = k(_, I);
          M && (_ = (0, l.default)({}, M, _));
          var D = A.reduce(function(H, Y) {
            return H[Y] = _[Y] || z[Y], H;
          }, {}), X = (0, a.default)(_).reduce(function(H, Y) {
            return A.indexOf(Y) === -1 && (H[Y] = _[Y]), H;
          }, {}), B = T(D), q = x(X, B);
          return (0, u.default)(S, 2).apply(void 0, [q].concat(j));
        }, 3), i.getBase16Theme = function(T, R) {
          if (T && T.extend && (T = T.extend), typeof T == "string") {
            var j = T.split(":"), F = (0, c.default)(j, 2), L = F[0], _ = F[1];
            T = (R || {})[L] || f[L], _ === "inverted" && (T = E(T));
          }
          return T && T.hasOwnProperty("base00") ? T : void 0;
        });
      }, function(r, i, o) {
        var s, l = typeof Reflect == "object" ? Reflect : null, c = l && typeof l.apply == "function" ? l.apply : function(O, x, S) {
          return Function.prototype.apply.call(O, x, S);
        };
        s = l && typeof l.ownKeys == "function" ? l.ownKeys : Object.getOwnPropertySymbols ? function(O) {
          return Object.getOwnPropertyNames(O).concat(Object.getOwnPropertySymbols(O));
        } : function(O) {
          return Object.getOwnPropertyNames(O);
        };
        var a = Number.isNaN || function(O) {
          return O != O;
        };
        function u() {
          u.init.call(this);
        }
        r.exports = u, r.exports.once = function(O, x) {
          return new Promise(function(S, E) {
            function k() {
              T !== void 0 && O.removeListener("error", T), S([].slice.call(arguments));
            }
            var T;
            x !== "error" && (T = function(R) {
              O.removeListener(x, k), E(R);
            }, O.once("error", T)), O.once(x, k);
          });
        }, u.EventEmitter = u, u.prototype._events = void 0, u.prototype._eventsCount = 0, u.prototype._maxListeners = void 0;
        var f = 10;
        function d(O) {
          if (typeof O != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof O);
        }
        function p(O) {
          return O._maxListeners === void 0 ? u.defaultMaxListeners : O._maxListeners;
        }
        function h(O, x, S, E) {
          var k, T, R, j;
          if (d(S), (T = O._events) === void 0 ? (T = O._events = /* @__PURE__ */ Object.create(null), O._eventsCount = 0) : (T.newListener !== void 0 && (O.emit("newListener", x, S.listener ? S.listener : S), T = O._events), R = T[x]), R === void 0) R = T[x] = S, ++O._eventsCount;
          else if (typeof R == "function" ? R = T[x] = E ? [S, R] : [R, S] : E ? R.unshift(S) : R.push(S), (k = p(O)) > 0 && R.length > k && !R.warned) {
            R.warned = !0;
            var F = new Error("Possible EventEmitter memory leak detected. " + R.length + " " + String(x) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            F.name = "MaxListenersExceededWarning", F.emitter = O, F.type = x, F.count = R.length, j = F, console && console.warn && console.warn(j);
          }
          return O;
        }
        function m() {
          if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function v(O, x, S) {
          var E = { fired: !1, wrapFn: void 0, target: O, type: x, listener: S }, k = m.bind(E);
          return k.listener = S, E.wrapFn = k, k;
        }
        function b(O, x, S) {
          var E = O._events;
          if (E === void 0) return [];
          var k = E[x];
          return k === void 0 ? [] : typeof k == "function" ? S ? [k.listener || k] : [k] : S ? function(T) {
            for (var R = new Array(T.length), j = 0; j < R.length; ++j) R[j] = T[j].listener || T[j];
            return R;
          }(k) : w(k, k.length);
        }
        function A(O) {
          var x = this._events;
          if (x !== void 0) {
            var S = x[O];
            if (typeof S == "function") return 1;
            if (S !== void 0) return S.length;
          }
          return 0;
        }
        function w(O, x) {
          for (var S = new Array(x), E = 0; E < x; ++E) S[E] = O[E];
          return S;
        }
        Object.defineProperty(u, "defaultMaxListeners", { enumerable: !0, get: function() {
          return f;
        }, set: function(O) {
          if (typeof O != "number" || O < 0 || a(O)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + O + ".");
          f = O;
        } }), u.init = function() {
          this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, u.prototype.setMaxListeners = function(O) {
          if (typeof O != "number" || O < 0 || a(O)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + O + ".");
          return this._maxListeners = O, this;
        }, u.prototype.getMaxListeners = function() {
          return p(this);
        }, u.prototype.emit = function(O) {
          for (var x = [], S = 1; S < arguments.length; S++) x.push(arguments[S]);
          var E = O === "error", k = this._events;
          if (k !== void 0) E = E && k.error === void 0;
          else if (!E) return !1;
          if (E) {
            var T;
            if (x.length > 0 && (T = x[0]), T instanceof Error) throw T;
            var R = new Error("Unhandled error." + (T ? " (" + T.message + ")" : ""));
            throw R.context = T, R;
          }
          var j = k[O];
          if (j === void 0) return !1;
          if (typeof j == "function") c(j, this, x);
          else {
            var F = j.length, L = w(j, F);
            for (S = 0; S < F; ++S) c(L[S], this, x);
          }
          return !0;
        }, u.prototype.addListener = function(O, x) {
          return h(this, O, x, !1);
        }, u.prototype.on = u.prototype.addListener, u.prototype.prependListener = function(O, x) {
          return h(this, O, x, !0);
        }, u.prototype.once = function(O, x) {
          return d(x), this.on(O, v(this, O, x)), this;
        }, u.prototype.prependOnceListener = function(O, x) {
          return d(x), this.prependListener(O, v(this, O, x)), this;
        }, u.prototype.removeListener = function(O, x) {
          var S, E, k, T, R;
          if (d(x), (E = this._events) === void 0) return this;
          if ((S = E[O]) === void 0) return this;
          if (S === x || S.listener === x) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete E[O], E.removeListener && this.emit("removeListener", O, S.listener || x));
          else if (typeof S != "function") {
            for (k = -1, T = S.length - 1; T >= 0; T--) if (S[T] === x || S[T].listener === x) {
              R = S[T].listener, k = T;
              break;
            }
            if (k < 0) return this;
            k === 0 ? S.shift() : function(j, F) {
              for (; F + 1 < j.length; F++) j[F] = j[F + 1];
              j.pop();
            }(S, k), S.length === 1 && (E[O] = S[0]), E.removeListener !== void 0 && this.emit("removeListener", O, R || x);
          }
          return this;
        }, u.prototype.off = u.prototype.removeListener, u.prototype.removeAllListeners = function(O) {
          var x, S, E;
          if ((S = this._events) === void 0) return this;
          if (S.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : S[O] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete S[O]), this;
          if (arguments.length === 0) {
            var k, T = Object.keys(S);
            for (E = 0; E < T.length; ++E) (k = T[E]) !== "removeListener" && this.removeAllListeners(k);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (typeof (x = S[O]) == "function") this.removeListener(O, x);
          else if (x !== void 0) for (E = x.length - 1; E >= 0; E--) this.removeListener(O, x[E]);
          return this;
        }, u.prototype.listeners = function(O) {
          return b(this, O, !0);
        }, u.prototype.rawListeners = function(O) {
          return b(this, O, !1);
        }, u.listenerCount = function(O, x) {
          return typeof O.listenerCount == "function" ? O.listenerCount(x) : A.call(O, x);
        }, u.prototype.listenerCount = A, u.prototype.eventNames = function() {
          return this._eventsCount > 0 ? s(this._events) : [];
        };
      }, function(r, i, o) {
        r.exports.Dispatcher = o(140);
      }, function(r, i, o) {
        r.exports = o(142);
      }, function(r, i, o) {
        i.__esModule = !0;
        var s = a(o(50)), l = a(o(65)), c = typeof l.default == "function" && typeof s.default == "symbol" ? function(u) {
          return typeof u;
        } : function(u) {
          return u && typeof l.default == "function" && u.constructor === l.default && u !== l.default.prototype ? "symbol" : typeof u;
        };
        function a(u) {
          return u && u.__esModule ? u : { default: u };
        }
        i.default = typeof l.default == "function" && c(s.default) === "symbol" ? function(u) {
          return u === void 0 ? "undefined" : c(u);
        } : function(u) {
          return u && typeof l.default == "function" && u.constructor === l.default && u !== l.default.prototype ? "symbol" : u === void 0 ? "undefined" : c(u);
        };
      }, function(r, i, o) {
        r.exports = { default: o(51), __esModule: !0 };
      }, function(r, i, o) {
        o(20), o(29), r.exports = o(30).f("iterator");
      }, function(r, i, o) {
        var s = o(21), l = o(22);
        r.exports = function(c) {
          return function(a, u) {
            var f, d, p = String(l(a)), h = s(u), m = p.length;
            return h < 0 || h >= m ? c ? "" : void 0 : (f = p.charCodeAt(h)) < 55296 || f > 56319 || h + 1 === m || (d = p.charCodeAt(h + 1)) < 56320 || d > 57343 ? c ? p.charAt(h) : f : c ? p.slice(h, h + 2) : d - 56320 + (f - 55296 << 10) + 65536;
          };
        };
      }, function(r, i, o) {
        var s = o(54);
        r.exports = function(l, c, a) {
          if (s(l), c === void 0) return l;
          switch (a) {
            case 1:
              return function(u) {
                return l.call(c, u);
              };
            case 2:
              return function(u, f) {
                return l.call(c, u, f);
              };
            case 3:
              return function(u, f, d) {
                return l.call(c, u, f, d);
              };
          }
          return function() {
            return l.apply(c, arguments);
          };
        };
      }, function(r, i) {
        r.exports = function(o) {
          if (typeof o != "function") throw TypeError(o + " is not a function!");
          return o;
        };
      }, function(r, i, o) {
        var s = o(38), l = o(16), c = o(28), a = {};
        o(6)(a, o(2)("iterator"), function() {
          return this;
        }), r.exports = function(u, f, d) {
          u.prototype = s(a, { next: l(1, d) }), c(u, f + " Iterator");
        };
      }, function(r, i, o) {
        var s = o(7), l = o(10), c = o(13);
        r.exports = o(4) ? Object.defineProperties : function(a, u) {
          l(a);
          for (var f, d = c(u), p = d.length, h = 0; p > h; ) s.f(a, f = d[h++], u[f]);
          return a;
        };
      }, function(r, i, o) {
        var s = o(9), l = o(58), c = o(59);
        r.exports = function(a) {
          return function(u, f, d) {
            var p, h = s(u), m = l(h.length), v = c(d, m);
            if (a && f != f) {
              for (; m > v; ) if ((p = h[v++]) != p) return !0;
            } else for (; m > v; v++) if ((a || v in h) && h[v] === f) return a || v || 0;
            return !a && -1;
          };
        };
      }, function(r, i, o) {
        var s = o(21), l = Math.min;
        r.exports = function(c) {
          return c > 0 ? l(s(c), 9007199254740991) : 0;
        };
      }, function(r, i, o) {
        var s = o(21), l = Math.max, c = Math.min;
        r.exports = function(a, u) {
          return (a = s(a)) < 0 ? l(a + u, 0) : c(a, u);
        };
      }, function(r, i, o) {
        var s = o(3).document;
        r.exports = s && s.documentElement;
      }, function(r, i, o) {
        var s = o(5), l = o(18), c = o(25)("IE_PROTO"), a = Object.prototype;
        r.exports = Object.getPrototypeOf || function(u) {
          return u = l(u), s(u, c) ? u[c] : typeof u.constructor == "function" && u instanceof u.constructor ? u.constructor.prototype : u instanceof Object ? a : null;
        };
      }, function(r, i, o) {
        var s = o(63), l = o(64), c = o(12), a = o(9);
        r.exports = o(34)(Array, "Array", function(u, f) {
          this._t = a(u), this._i = 0, this._k = f;
        }, function() {
          var u = this._t, f = this._k, d = this._i++;
          return !u || d >= u.length ? (this._t = void 0, l(1)) : l(0, f == "keys" ? d : f == "values" ? u[d] : [d, u[d]]);
        }, "values"), c.Arguments = c.Array, s("keys"), s("values"), s("entries");
      }, function(r, i) {
        r.exports = function() {
        };
      }, function(r, i) {
        r.exports = function(o, s) {
          return { value: s, done: !!o };
        };
      }, function(r, i, o) {
        r.exports = { default: o(66), __esModule: !0 };
      }, function(r, i, o) {
        o(67), o(73), o(74), o(75), r.exports = o(1).Symbol;
      }, function(r, i, o) {
        var s = o(3), l = o(5), c = o(4), a = o(15), u = o(37), f = o(68).KEY, d = o(8), p = o(26), h = o(28), m = o(17), v = o(2), b = o(30), A = o(31), w = o(69), O = o(70), x = o(10), S = o(11), E = o(18), k = o(9), T = o(23), R = o(16), j = o(38), F = o(71), L = o(72), _ = o(32), U = o(7), z = o(13), C = L.f, I = U.f, M = F.f, D = s.Symbol, X = s.JSON, B = X && X.stringify, q = v("_hidden"), H = v("toPrimitive"), Y = {}.propertyIsEnumerable, J = p("symbol-registry"), oe = p("symbols"), ce = p("op-symbols"), fe = Object.prototype, $ = typeof D == "function" && !!_.f, pe = s.QObject, ee = !pe || !pe.prototype || !pe.prototype.findChild, Ce = c && d(function() {
          return j(I({}, "a", { get: function() {
            return I(this, "a", { value: 7 }).a;
          } })).a != 7;
        }) ? function(ae, Pe, Fe) {
          var Ke = C(fe, Pe);
          Ke && delete fe[Pe], I(ae, Pe, Fe), Ke && ae !== fe && I(fe, Pe, Ke);
        } : I, Ee = function(ae) {
          var Pe = oe[ae] = j(D.prototype);
          return Pe._k = ae, Pe;
        }, Ve = $ && typeof D.iterator == "symbol" ? function(ae) {
          return typeof ae == "symbol";
        } : function(ae) {
          return ae instanceof D;
        }, et = function(ae, Pe, Fe) {
          return ae === fe && et(ce, Pe, Fe), x(ae), Pe = T(Pe, !0), x(Fe), l(oe, Pe) ? (Fe.enumerable ? (l(ae, q) && ae[q][Pe] && (ae[q][Pe] = !1), Fe = j(Fe, { enumerable: R(0, !1) })) : (l(ae, q) || I(ae, q, R(1, {})), ae[q][Pe] = !0), Ce(ae, Pe, Fe)) : I(ae, Pe, Fe);
        }, ft = function(ae, Pe) {
          x(ae);
          for (var Fe, Ke = w(Pe = k(Pe)), Ot = 0, Ct = Ke.length; Ct > Ot; ) et(ae, Fe = Ke[Ot++], Pe[Fe]);
          return ae;
        }, me = function(ae) {
          var Pe = Y.call(this, ae = T(ae, !0));
          return !(this === fe && l(oe, ae) && !l(ce, ae)) && (!(Pe || !l(this, ae) || !l(oe, ae) || l(this, q) && this[q][ae]) || Pe);
        }, Te = function(ae, Pe) {
          if (ae = k(ae), Pe = T(Pe, !0), ae !== fe || !l(oe, Pe) || l(ce, Pe)) {
            var Fe = C(ae, Pe);
            return !Fe || !l(oe, Pe) || l(ae, q) && ae[q][Pe] || (Fe.enumerable = !0), Fe;
          }
        }, re = function(ae) {
          for (var Pe, Fe = M(k(ae)), Ke = [], Ot = 0; Fe.length > Ot; ) l(oe, Pe = Fe[Ot++]) || Pe == q || Pe == f || Ke.push(Pe);
          return Ke;
        }, le = function(ae) {
          for (var Pe, Fe = ae === fe, Ke = M(Fe ? ce : k(ae)), Ot = [], Ct = 0; Ke.length > Ct; ) !l(oe, Pe = Ke[Ct++]) || Fe && !l(fe, Pe) || Ot.push(oe[Pe]);
          return Ot;
        };
        $ || (u((D = function() {
          if (this instanceof D) throw TypeError("Symbol is not a constructor!");
          var ae = m(arguments.length > 0 ? arguments[0] : void 0), Pe = function(Fe) {
            this === fe && Pe.call(ce, Fe), l(this, q) && l(this[q], ae) && (this[q][ae] = !1), Ce(this, ae, R(1, Fe));
          };
          return c && ee && Ce(fe, ae, { configurable: !0, set: Pe }), Ee(ae);
        }).prototype, "toString", function() {
          return this._k;
        }), L.f = Te, U.f = et, o(41).f = F.f = re, o(19).f = me, _.f = le, c && !o(14) && u(fe, "propertyIsEnumerable", me, !0), b.f = function(ae) {
          return Ee(v(ae));
        }), a(a.G + a.W + a.F * !$, { Symbol: D });
        for (var Oe = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), be = 0; Oe.length > be; ) v(Oe[be++]);
        for (var je = z(v.store), xe = 0; je.length > xe; ) A(je[xe++]);
        a(a.S + a.F * !$, "Symbol", { for: function(ae) {
          return l(J, ae += "") ? J[ae] : J[ae] = D(ae);
        }, keyFor: function(ae) {
          if (!Ve(ae)) throw TypeError(ae + " is not a symbol!");
          for (var Pe in J) if (J[Pe] === ae) return Pe;
        }, useSetter: function() {
          ee = !0;
        }, useSimple: function() {
          ee = !1;
        } }), a(a.S + a.F * !$, "Object", { create: function(ae, Pe) {
          return Pe === void 0 ? j(ae) : ft(j(ae), Pe);
        }, defineProperty: et, defineProperties: ft, getOwnPropertyDescriptor: Te, getOwnPropertyNames: re, getOwnPropertySymbols: le });
        var Q = d(function() {
          _.f(1);
        });
        a(a.S + a.F * Q, "Object", { getOwnPropertySymbols: function(ae) {
          return _.f(E(ae));
        } }), X && a(a.S + a.F * (!$ || d(function() {
          var ae = D();
          return B([ae]) != "[null]" || B({ a: ae }) != "{}" || B(Object(ae)) != "{}";
        })), "JSON", { stringify: function(ae) {
          for (var Pe, Fe, Ke = [ae], Ot = 1; arguments.length > Ot; ) Ke.push(arguments[Ot++]);
          if (Fe = Pe = Ke[1], (S(Pe) || ae !== void 0) && !Ve(ae)) return O(Pe) || (Pe = function(Ct, Jt) {
            if (typeof Fe == "function" && (Jt = Fe.call(this, Ct, Jt)), !Ve(Jt)) return Jt;
          }), Ke[1] = Pe, B.apply(X, Ke);
        } }), D.prototype[H] || o(6)(D.prototype, H, D.prototype.valueOf), h(D, "Symbol"), h(Math, "Math", !0), h(s.JSON, "JSON", !0);
      }, function(r, i, o) {
        var s = o(17)("meta"), l = o(11), c = o(5), a = o(7).f, u = 0, f = Object.isExtensible || function() {
          return !0;
        }, d = !o(8)(function() {
          return f(Object.preventExtensions({}));
        }), p = function(m) {
          a(m, s, { value: { i: "O" + ++u, w: {} } });
        }, h = r.exports = { KEY: s, NEED: !1, fastKey: function(m, v) {
          if (!l(m)) return typeof m == "symbol" ? m : (typeof m == "string" ? "S" : "P") + m;
          if (!c(m, s)) {
            if (!f(m)) return "F";
            if (!v) return "E";
            p(m);
          }
          return m[s].i;
        }, getWeak: function(m, v) {
          if (!c(m, s)) {
            if (!f(m)) return !0;
            if (!v) return !1;
            p(m);
          }
          return m[s].w;
        }, onFreeze: function(m) {
          return d && h.NEED && f(m) && !c(m, s) && p(m), m;
        } };
      }, function(r, i, o) {
        var s = o(13), l = o(32), c = o(19);
        r.exports = function(a) {
          var u = s(a), f = l.f;
          if (f) for (var d, p = f(a), h = c.f, m = 0; p.length > m; ) h.call(a, d = p[m++]) && u.push(d);
          return u;
        };
      }, function(r, i, o) {
        var s = o(24);
        r.exports = Array.isArray || function(l) {
          return s(l) == "Array";
        };
      }, function(r, i, o) {
        var s = o(9), l = o(41).f, c = {}.toString, a = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        r.exports.f = function(u) {
          return a && c.call(u) == "[object Window]" ? function(f) {
            try {
              return l(f);
            } catch {
              return a.slice();
            }
          }(u) : l(s(u));
        };
      }, function(r, i, o) {
        var s = o(19), l = o(16), c = o(9), a = o(23), u = o(5), f = o(35), d = Object.getOwnPropertyDescriptor;
        i.f = o(4) ? d : function(p, h) {
          if (p = c(p), h = a(h, !0), f) try {
            return d(p, h);
          } catch {
          }
          if (u(p, h)) return l(!s.f.call(p, h), p[h]);
        };
      }, function(r, i) {
      }, function(r, i, o) {
        o(31)("asyncIterator");
      }, function(r, i, o) {
        o(31)("observable");
      }, function(r, i, o) {
        i.__esModule = !0;
        var s, l = o(77), c = (s = l) && s.__esModule ? s : { default: s };
        i.default = c.default || function(a) {
          for (var u = 1; u < arguments.length; u++) {
            var f = arguments[u];
            for (var d in f) Object.prototype.hasOwnProperty.call(f, d) && (a[d] = f[d]);
          }
          return a;
        };
      }, function(r, i, o) {
        r.exports = { default: o(78), __esModule: !0 };
      }, function(r, i, o) {
        o(79), r.exports = o(1).Object.assign;
      }, function(r, i, o) {
        var s = o(15);
        s(s.S + s.F, "Object", { assign: o(80) });
      }, function(r, i, o) {
        var s = o(4), l = o(13), c = o(32), a = o(19), u = o(18), f = o(40), d = Object.assign;
        r.exports = !d || o(8)(function() {
          var p = {}, h = {}, m = Symbol(), v = "abcdefghijklmnopqrst";
          return p[m] = 7, v.split("").forEach(function(b) {
            h[b] = b;
          }), d({}, p)[m] != 7 || Object.keys(d({}, h)).join("") != v;
        }) ? function(p, h) {
          for (var m = u(p), v = arguments.length, b = 1, A = c.f, w = a.f; v > b; ) for (var O, x = f(arguments[b++]), S = A ? l(x).concat(A(x)) : l(x), E = S.length, k = 0; E > k; ) O = S[k++], s && !w.call(x, O) || (m[O] = x[O]);
          return m;
        } : d;
      }, function(r, i, o) {
        i.__esModule = !0;
        var s = c(o(82)), l = c(o(85));
        function c(a) {
          return a && a.__esModule ? a : { default: a };
        }
        i.default = function(a, u) {
          if (Array.isArray(a)) return a;
          if ((0, s.default)(Object(a))) return function(f, d) {
            var p = [], h = !0, m = !1, v = void 0;
            try {
              for (var b, A = (0, l.default)(f); !(h = (b = A.next()).done) && (p.push(b.value), !d || p.length !== d); h = !0) ;
            } catch (w) {
              m = !0, v = w;
            } finally {
              try {
                !h && A.return && A.return();
              } finally {
                if (m) throw v;
              }
            }
            return p;
          }(a, u);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }, function(r, i, o) {
        r.exports = { default: o(83), __esModule: !0 };
      }, function(r, i, o) {
        o(29), o(20), r.exports = o(84);
      }, function(r, i, o) {
        var s = o(42), l = o(2)("iterator"), c = o(12);
        r.exports = o(1).isIterable = function(a) {
          var u = Object(a);
          return u[l] !== void 0 || "@@iterator" in u || c.hasOwnProperty(s(u));
        };
      }, function(r, i, o) {
        r.exports = { default: o(86), __esModule: !0 };
      }, function(r, i, o) {
        o(29), o(20), r.exports = o(87);
      }, function(r, i, o) {
        var s = o(10), l = o(88);
        r.exports = o(1).getIterator = function(c) {
          var a = l(c);
          if (typeof a != "function") throw TypeError(c + " is not iterable!");
          return s(a.call(c));
        };
      }, function(r, i, o) {
        var s = o(42), l = o(2)("iterator"), c = o(12);
        r.exports = o(1).getIteratorMethod = function(a) {
          if (a != null) return a[l] || a["@@iterator"] || c[s(a)];
        };
      }, function(r, i, o) {
        r.exports = { default: o(90), __esModule: !0 };
      }, function(r, i, o) {
        o(91), r.exports = o(1).Object.keys;
      }, function(r, i, o) {
        var s = o(18), l = o(13);
        o(92)("keys", function() {
          return function(c) {
            return l(s(c));
          };
        });
      }, function(r, i, o) {
        var s = o(15), l = o(1), c = o(8);
        r.exports = function(a, u) {
          var f = (l.Object || {})[a] || Object[a], d = {};
          d[a] = u(f), s(s.S + s.F * c(function() {
            f(1);
          }), "Object", d);
        };
      }, function(r, i, o) {
        (function(s) {
          var l = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]], c = /^\s+|\s+$/g, a = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, u = /\{\n\/\* \[wrapped with (.+)\] \*/, f = /,? & /, d = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, h = /^\[object .+?Constructor\]$/, m = /^0o[0-7]+$/i, v = /^(?:0|[1-9]\d*)$/, b = parseInt, A = typeof s == "object" && s && s.Object === Object && s, w = typeof self == "object" && self && self.Object === Object && self, O = A || w || Function("return this")();
          function x(xe, Q, ae) {
            switch (ae.length) {
              case 0:
                return xe.call(Q);
              case 1:
                return xe.call(Q, ae[0]);
              case 2:
                return xe.call(Q, ae[0], ae[1]);
              case 3:
                return xe.call(Q, ae[0], ae[1], ae[2]);
            }
            return xe.apply(Q, ae);
          }
          function S(xe, Q) {
            return !!(xe && xe.length) && function(ae, Pe, Fe) {
              if (Pe != Pe) return function(Ct, Jt, yn, vn) {
                for (var Re = Ct.length, _e = yn + -1; ++_e < Re; ) if (Jt(Ct[_e], _e, Ct)) return _e;
                return -1;
              }(ae, E, Fe);
              for (var Ke = Fe - 1, Ot = ae.length; ++Ke < Ot; ) if (ae[Ke] === Pe) return Ke;
              return -1;
            }(xe, Q, 0) > -1;
          }
          function E(xe) {
            return xe != xe;
          }
          function k(xe, Q) {
            for (var ae = xe.length, Pe = 0; ae--; ) xe[ae] === Q && Pe++;
            return Pe;
          }
          function T(xe, Q) {
            for (var ae = -1, Pe = xe.length, Fe = 0, Ke = []; ++ae < Pe; ) {
              var Ot = xe[ae];
              Ot !== Q && Ot !== "__lodash_placeholder__" || (xe[ae] = "__lodash_placeholder__", Ke[Fe++] = ae);
            }
            return Ke;
          }
          var R, j, F, L = Function.prototype, _ = Object.prototype, U = O["__core-js_shared__"], z = (R = /[^.]+$/.exec(U && U.keys && U.keys.IE_PROTO || "")) ? "Symbol(src)_1." + R : "", C = L.toString, I = _.hasOwnProperty, M = _.toString, D = RegExp("^" + C.call(I).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), X = Object.create, B = Math.max, q = Math.min, H = (j = Ee(Object, "defineProperty"), (F = Ee.name) && F.length > 2 ? j : void 0);
          function Y(xe) {
            return Oe(xe) ? X(xe) : {};
          }
          function J(xe) {
            return !(!Oe(xe) || function(Q) {
              return !!z && z in Q;
            }(xe)) && (function(Q) {
              var ae = Oe(Q) ? M.call(Q) : "";
              return ae == "[object Function]" || ae == "[object GeneratorFunction]";
            }(xe) || function(Q) {
              var ae = !1;
              if (Q != null && typeof Q.toString != "function") try {
                ae = !!(Q + "");
              } catch {
              }
              return ae;
            }(xe) ? D : h).test(function(Q) {
              if (Q != null) {
                try {
                  return C.call(Q);
                } catch {
                }
                try {
                  return Q + "";
                } catch {
                }
              }
              return "";
            }(xe));
          }
          function oe(xe, Q, ae, Pe) {
            for (var Fe = -1, Ke = xe.length, Ot = ae.length, Ct = -1, Jt = Q.length, yn = B(Ke - Ot, 0), vn = Array(Jt + yn), Re = !Pe; ++Ct < Jt; ) vn[Ct] = Q[Ct];
            for (; ++Fe < Ot; ) (Re || Fe < Ke) && (vn[ae[Fe]] = xe[Fe]);
            for (; yn--; ) vn[Ct++] = xe[Fe++];
            return vn;
          }
          function ce(xe, Q, ae, Pe) {
            for (var Fe = -1, Ke = xe.length, Ot = -1, Ct = ae.length, Jt = -1, yn = Q.length, vn = B(Ke - Ct, 0), Re = Array(vn + yn), _e = !Pe; ++Fe < vn; ) Re[Fe] = xe[Fe];
            for (var jt = Fe; ++Jt < yn; ) Re[jt + Jt] = Q[Jt];
            for (; ++Ot < Ct; ) (_e || Fe < Ke) && (Re[jt + ae[Ot]] = xe[Fe++]);
            return Re;
          }
          function fe(xe) {
            return function() {
              var Q = arguments;
              switch (Q.length) {
                case 0:
                  return new xe();
                case 1:
                  return new xe(Q[0]);
                case 2:
                  return new xe(Q[0], Q[1]);
                case 3:
                  return new xe(Q[0], Q[1], Q[2]);
                case 4:
                  return new xe(Q[0], Q[1], Q[2], Q[3]);
                case 5:
                  return new xe(Q[0], Q[1], Q[2], Q[3], Q[4]);
                case 6:
                  return new xe(Q[0], Q[1], Q[2], Q[3], Q[4], Q[5]);
                case 7:
                  return new xe(Q[0], Q[1], Q[2], Q[3], Q[4], Q[5], Q[6]);
              }
              var ae = Y(xe.prototype), Pe = xe.apply(ae, Q);
              return Oe(Pe) ? Pe : ae;
            };
          }
          function $(xe, Q, ae, Pe, Fe, Ke, Ot, Ct, Jt, yn) {
            var vn = 128 & Q, Re = 1 & Q, _e = 2 & Q, jt = 24 & Q, st = 512 & Q, Mt = _e ? void 0 : fe(xe);
            return function lt() {
              for (var xt = arguments.length, yt = Array(xt), ct = xt; ct--; ) yt[ct] = arguments[ct];
              if (jt) var Rt = Ce(lt), Yt = k(yt, Rt);
              if (Pe && (yt = oe(yt, Pe, Fe, jt)), Ke && (yt = ce(yt, Ke, Ot, jt)), xt -= Yt, jt && xt < yn) {
                var Gt = T(yt, Rt);
                return pe(xe, Q, $, lt.placeholder, ae, yt, Gt, Ct, Jt, yn - xt);
              }
              var hn = Re ? ae : this, en = _e ? hn[xe] : xe;
              return xt = yt.length, Ct ? yt = me(yt, Ct) : st && xt > 1 && yt.reverse(), vn && Jt < xt && (yt.length = Jt), this && this !== O && this instanceof lt && (en = Mt || fe(en)), en.apply(hn, yt);
            };
          }
          function pe(xe, Q, ae, Pe, Fe, Ke, Ot, Ct, Jt, yn) {
            var vn = 8 & Q;
            Q |= vn ? 32 : 64, 4 & (Q &= ~(vn ? 64 : 32)) || (Q &= -4);
            var Re = ae(xe, Q, Fe, vn ? Ke : void 0, vn ? Ot : void 0, vn ? void 0 : Ke, vn ? void 0 : Ot, Ct, Jt, yn);
            return Re.placeholder = Pe, Te(Re, xe, Q);
          }
          function ee(xe, Q, ae, Pe, Fe, Ke, Ot, Ct) {
            var Jt = 2 & Q;
            if (!Jt && typeof xe != "function") throw new TypeError("Expected a function");
            var yn = Pe ? Pe.length : 0;
            if (yn || (Q &= -97, Pe = Fe = void 0), Ot = Ot === void 0 ? Ot : B(je(Ot), 0), Ct = Ct === void 0 ? Ct : je(Ct), yn -= Fe ? Fe.length : 0, 64 & Q) {
              var vn = Pe, Re = Fe;
              Pe = Fe = void 0;
            }
            var _e = [xe, Q, ae, Pe, Fe, vn, Re, Ke, Ot, Ct];
            if (xe = _e[0], Q = _e[1], ae = _e[2], Pe = _e[3], Fe = _e[4], !(Ct = _e[9] = _e[9] == null ? Jt ? 0 : xe.length : B(_e[9] - yn, 0)) && 24 & Q && (Q &= -25), Q && Q != 1) jt = Q == 8 || Q == 16 ? function(st, Mt, lt) {
              var xt = fe(st);
              return function yt() {
                for (var ct = arguments.length, Rt = Array(ct), Yt = ct, Gt = Ce(yt); Yt--; ) Rt[Yt] = arguments[Yt];
                var hn = ct < 3 && Rt[0] !== Gt && Rt[ct - 1] !== Gt ? [] : T(Rt, Gt);
                if ((ct -= hn.length) < lt) return pe(st, Mt, $, yt.placeholder, void 0, Rt, hn, void 0, void 0, lt - ct);
                var en = this && this !== O && this instanceof yt ? xt : st;
                return x(en, this, Rt);
              };
            }(xe, Q, Ct) : Q != 32 && Q != 33 || Fe.length ? $.apply(void 0, _e) : function(st, Mt, lt, xt) {
              var yt = 1 & Mt, ct = fe(st);
              return function Rt() {
                for (var Yt = -1, Gt = arguments.length, hn = -1, en = xt.length, Sn = Array(en + Gt), Ar = this && this !== O && this instanceof Rt ? ct : st; ++hn < en; ) Sn[hn] = xt[hn];
                for (; Gt--; ) Sn[hn++] = arguments[++Yt];
                return x(Ar, yt ? lt : this, Sn);
              };
            }(xe, Q, ae, Pe);
            else var jt = function(st, Mt, lt) {
              var xt = 1 & Mt, yt = fe(st);
              return function ct() {
                var Rt = this && this !== O && this instanceof ct ? yt : st;
                return Rt.apply(xt ? lt : this, arguments);
              };
            }(xe, Q, ae);
            return Te(jt, xe, Q);
          }
          function Ce(xe) {
            return xe.placeholder;
          }
          function Ee(xe, Q) {
            var ae = function(Pe, Fe) {
              return Pe == null ? void 0 : Pe[Fe];
            }(xe, Q);
            return J(ae) ? ae : void 0;
          }
          function Ve(xe) {
            var Q = xe.match(u);
            return Q ? Q[1].split(f) : [];
          }
          function et(xe, Q) {
            var ae = Q.length, Pe = ae - 1;
            return Q[Pe] = (ae > 1 ? "& " : "") + Q[Pe], Q = Q.join(ae > 2 ? ", " : " "), xe.replace(a, `{
/* [wrapped with ` + Q + `] */
`);
          }
          function ft(xe, Q) {
            return !!(Q = Q ?? 9007199254740991) && (typeof xe == "number" || v.test(xe)) && xe > -1 && xe % 1 == 0 && xe < Q;
          }
          function me(xe, Q) {
            for (var ae = xe.length, Pe = q(Q.length, ae), Fe = function(Ot, Ct) {
              var Jt = -1, yn = Ot.length;
              for (Ct || (Ct = Array(yn)); ++Jt < yn; ) Ct[Jt] = Ot[Jt];
              return Ct;
            }(xe); Pe--; ) {
              var Ke = Q[Pe];
              xe[Pe] = ft(Ke, ae) ? Fe[Ke] : void 0;
            }
            return xe;
          }
          var Te = H ? function(xe, Q, ae) {
            var Pe, Fe = Q + "";
            return H(xe, "toString", { configurable: !0, enumerable: !1, value: (Pe = et(Fe, re(Ve(Fe), ae)), function() {
              return Pe;
            }) });
          } : function(xe) {
            return xe;
          };
          function re(xe, Q) {
            return function(ae, Pe) {
              for (var Fe = -1, Ke = ae ? ae.length : 0; ++Fe < Ke && Pe(ae[Fe], Fe, ae) !== !1; ) ;
            }(l, function(ae) {
              var Pe = "_." + ae[0];
              Q & ae[1] && !S(xe, Pe) && xe.push(Pe);
            }), xe.sort();
          }
          function le(xe, Q, ae) {
            var Pe = ee(xe, 8, void 0, void 0, void 0, void 0, void 0, Q = ae ? void 0 : Q);
            return Pe.placeholder = le.placeholder, Pe;
          }
          function Oe(xe) {
            var Q = typeof xe;
            return !!xe && (Q == "object" || Q == "function");
          }
          function be(xe) {
            return xe ? (xe = function(Q) {
              if (typeof Q == "number") return Q;
              if (function(Fe) {
                return typeof Fe == "symbol" || /* @__PURE__ */ function(Ke) {
                  return !!Ke && typeof Ke == "object";
                }(Fe) && M.call(Fe) == "[object Symbol]";
              }(Q)) return NaN;
              if (Oe(Q)) {
                var ae = typeof Q.valueOf == "function" ? Q.valueOf() : Q;
                Q = Oe(ae) ? ae + "" : ae;
              }
              if (typeof Q != "string") return Q === 0 ? Q : +Q;
              Q = Q.replace(c, "");
              var Pe = p.test(Q);
              return Pe || m.test(Q) ? b(Q.slice(2), Pe ? 2 : 8) : d.test(Q) ? NaN : +Q;
            }(xe)) === 1 / 0 || xe === -1 / 0 ? 17976931348623157e292 * (xe < 0 ? -1 : 1) : xe == xe ? xe : 0 : xe === 0 ? xe : 0;
          }
          function je(xe) {
            var Q = be(xe), ae = Q % 1;
            return Q == Q ? ae ? Q - ae : Q : 0;
          }
          le.placeholder = {}, r.exports = le;
        }).call(this, o(43));
      }, function(r, i, o) {
        function s(ce) {
          return ce && ce.__esModule ? ce.default : ce;
        }
        i.__esModule = !0;
        var l = o(95);
        i.threezerotwofour = s(l);
        var c = o(96);
        i.apathy = s(c);
        var a = o(97);
        i.ashes = s(a);
        var u = o(98);
        i.atelierDune = s(u);
        var f = o(99);
        i.atelierForest = s(f);
        var d = o(100);
        i.atelierHeath = s(d);
        var p = o(101);
        i.atelierLakeside = s(p);
        var h = o(102);
        i.atelierSeaside = s(h);
        var m = o(103);
        i.bespin = s(m);
        var v = o(104);
        i.brewer = s(v);
        var b = o(105);
        i.bright = s(b);
        var A = o(106);
        i.chalk = s(A);
        var w = o(107);
        i.codeschool = s(w);
        var O = o(108);
        i.colors = s(O);
        var x = o(109);
        i.default = s(x);
        var S = o(110);
        i.eighties = s(S);
        var E = o(111);
        i.embers = s(E);
        var k = o(112);
        i.flat = s(k);
        var T = o(113);
        i.google = s(T);
        var R = o(114);
        i.grayscale = s(R);
        var j = o(115);
        i.greenscreen = s(j);
        var F = o(116);
        i.harmonic = s(F);
        var L = o(117);
        i.hopscotch = s(L);
        var _ = o(118);
        i.isotope = s(_);
        var U = o(119);
        i.marrakesh = s(U);
        var z = o(120);
        i.mocha = s(z);
        var C = o(121);
        i.monokai = s(C);
        var I = o(122);
        i.ocean = s(I);
        var M = o(123);
        i.paraiso = s(M);
        var D = o(124);
        i.pop = s(D);
        var X = o(125);
        i.railscasts = s(X);
        var B = o(126);
        i.shapeshifter = s(B);
        var q = o(127);
        i.solarized = s(q);
        var H = o(128);
        i.summerfruit = s(H);
        var Y = o(129);
        i.tomorrow = s(Y);
        var J = o(130);
        i.tube = s(J);
        var oe = o(131);
        i.twilight = s(oe);
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "threezerotwofour", author: "jan t. sott (http://github.com/idleberg)", base00: "#090300", base01: "#3a3432", base02: "#4a4543", base03: "#5c5855", base04: "#807d7c", base05: "#a5a2a2", base06: "#d6d5d4", base07: "#f7f7f7", base08: "#db2d20", base09: "#e8bbd0", base0A: "#fded02", base0B: "#01a252", base0C: "#b5e4f4", base0D: "#01a0e4", base0E: "#a16a94", base0F: "#cdab53" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "apathy", author: "jannik siebert (https://github.com/janniks)", base00: "#031A16", base01: "#0B342D", base02: "#184E45", base03: "#2B685E", base04: "#5F9C92", base05: "#81B5AC", base06: "#A7CEC8", base07: "#D2E7E4", base08: "#3E9688", base09: "#3E7996", base0A: "#3E4C96", base0B: "#883E96", base0C: "#963E4C", base0D: "#96883E", base0E: "#4C963E", base0F: "#3E965B" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "ashes", author: "jannik siebert (https://github.com/janniks)", base00: "#1C2023", base01: "#393F45", base02: "#565E65", base03: "#747C84", base04: "#ADB3BA", base05: "#C7CCD1", base06: "#DFE2E5", base07: "#F3F4F5", base08: "#C7AE95", base09: "#C7C795", base0A: "#AEC795", base0B: "#95C7AE", base0C: "#95AEC7", base0D: "#AE95C7", base0E: "#C795AE", base0F: "#C79595" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "atelier dune", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)", base00: "#20201d", base01: "#292824", base02: "#6e6b5e", base03: "#7d7a68", base04: "#999580", base05: "#a6a28c", base06: "#e8e4cf", base07: "#fefbec", base08: "#d73737", base09: "#b65611", base0A: "#cfb017", base0B: "#60ac39", base0C: "#1fad83", base0D: "#6684e1", base0E: "#b854d4", base0F: "#d43552" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "atelier forest", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)", base00: "#1b1918", base01: "#2c2421", base02: "#68615e", base03: "#766e6b", base04: "#9c9491", base05: "#a8a19f", base06: "#e6e2e0", base07: "#f1efee", base08: "#f22c40", base09: "#df5320", base0A: "#d5911a", base0B: "#5ab738", base0C: "#00ad9c", base0D: "#407ee7", base0E: "#6666ea", base0F: "#c33ff3" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "atelier heath", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)", base00: "#1b181b", base01: "#292329", base02: "#695d69", base03: "#776977", base04: "#9e8f9e", base05: "#ab9bab", base06: "#d8cad8", base07: "#f7f3f7", base08: "#ca402b", base09: "#a65926", base0A: "#bb8a35", base0B: "#379a37", base0C: "#159393", base0D: "#516aec", base0E: "#7b59c0", base0F: "#cc33cc" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "atelier lakeside", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)", base00: "#161b1d", base01: "#1f292e", base02: "#516d7b", base03: "#5a7b8c", base04: "#7195a8", base05: "#7ea2b4", base06: "#c1e4f6", base07: "#ebf8ff", base08: "#d22d72", base09: "#935c25", base0A: "#8a8a0f", base0B: "#568c3b", base0C: "#2d8f6f", base0D: "#257fad", base0E: "#5d5db1", base0F: "#b72dd2" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "atelier seaside", author: "bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)", base00: "#131513", base01: "#242924", base02: "#5e6e5e", base03: "#687d68", base04: "#809980", base05: "#8ca68c", base06: "#cfe8cf", base07: "#f0fff0", base08: "#e6193c", base09: "#87711d", base0A: "#c3c322", base0B: "#29a329", base0C: "#1999b3", base0D: "#3d62f5", base0E: "#ad2bee", base0F: "#e619c3" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "bespin", author: "jan t. sott", base00: "#28211c", base01: "#36312e", base02: "#5e5d5c", base03: "#666666", base04: "#797977", base05: "#8a8986", base06: "#9d9b97", base07: "#baae9e", base08: "#cf6a4c", base09: "#cf7d34", base0A: "#f9ee98", base0B: "#54be0d", base0C: "#afc4db", base0D: "#5ea6ea", base0E: "#9b859d", base0F: "#937121" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "brewer", author: "timothée poisot (http://github.com/tpoisot)", base00: "#0c0d0e", base01: "#2e2f30", base02: "#515253", base03: "#737475", base04: "#959697", base05: "#b7b8b9", base06: "#dadbdc", base07: "#fcfdfe", base08: "#e31a1c", base09: "#e6550d", base0A: "#dca060", base0B: "#31a354", base0C: "#80b1d3", base0D: "#3182bd", base0E: "#756bb1", base0F: "#b15928" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "bright", author: "chris kempson (http://chriskempson.com)", base00: "#000000", base01: "#303030", base02: "#505050", base03: "#b0b0b0", base04: "#d0d0d0", base05: "#e0e0e0", base06: "#f5f5f5", base07: "#ffffff", base08: "#fb0120", base09: "#fc6d24", base0A: "#fda331", base0B: "#a1c659", base0C: "#76c7b7", base0D: "#6fb3d2", base0E: "#d381c3", base0F: "#be643c" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "chalk", author: "chris kempson (http://chriskempson.com)", base00: "#151515", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#b0b0b0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#f5f5f5", base08: "#fb9fb1", base09: "#eda987", base0A: "#ddb26f", base0B: "#acc267", base0C: "#12cfc0", base0D: "#6fc2ef", base0E: "#e1a3ee", base0F: "#deaf8f" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "codeschool", author: "brettof86", base00: "#232c31", base01: "#1c3657", base02: "#2a343a", base03: "#3f4944", base04: "#84898c", base05: "#9ea7a6", base06: "#a7cfa3", base07: "#b5d8f6", base08: "#2a5491", base09: "#43820d", base0A: "#a03b1e", base0B: "#237986", base0C: "#b02f30", base0D: "#484d79", base0E: "#c59820", base0F: "#c98344" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "colors", author: "mrmrs (http://clrs.cc)", base00: "#111111", base01: "#333333", base02: "#555555", base03: "#777777", base04: "#999999", base05: "#bbbbbb", base06: "#dddddd", base07: "#ffffff", base08: "#ff4136", base09: "#ff851b", base0A: "#ffdc00", base0B: "#2ecc40", base0C: "#7fdbff", base0D: "#0074d9", base0E: "#b10dc9", base0F: "#85144b" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "default", author: "chris kempson (http://chriskempson.com)", base00: "#181818", base01: "#282828", base02: "#383838", base03: "#585858", base04: "#b8b8b8", base05: "#d8d8d8", base06: "#e8e8e8", base07: "#f8f8f8", base08: "#ab4642", base09: "#dc9656", base0A: "#f7ca88", base0B: "#a1b56c", base0C: "#86c1b9", base0D: "#7cafc2", base0E: "#ba8baf", base0F: "#a16946" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "eighties", author: "chris kempson (http://chriskempson.com)", base00: "#2d2d2d", base01: "#393939", base02: "#515151", base03: "#747369", base04: "#a09f93", base05: "#d3d0c8", base06: "#e8e6df", base07: "#f2f0ec", base08: "#f2777a", base09: "#f99157", base0A: "#ffcc66", base0B: "#99cc99", base0C: "#66cccc", base0D: "#6699cc", base0E: "#cc99cc", base0F: "#d27b53" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "embers", author: "jannik siebert (https://github.com/janniks)", base00: "#16130F", base01: "#2C2620", base02: "#433B32", base03: "#5A5047", base04: "#8A8075", base05: "#A39A90", base06: "#BEB6AE", base07: "#DBD6D1", base08: "#826D57", base09: "#828257", base0A: "#6D8257", base0B: "#57826D", base0C: "#576D82", base0D: "#6D5782", base0E: "#82576D", base0F: "#825757" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "flat", author: "chris kempson (http://chriskempson.com)", base00: "#2C3E50", base01: "#34495E", base02: "#7F8C8D", base03: "#95A5A6", base04: "#BDC3C7", base05: "#e0e0e0", base06: "#f5f5f5", base07: "#ECF0F1", base08: "#E74C3C", base09: "#E67E22", base0A: "#F1C40F", base0B: "#2ECC71", base0C: "#1ABC9C", base0D: "#3498DB", base0E: "#9B59B6", base0F: "#be643c" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "google", author: "seth wright (http://sethawright.com)", base00: "#1d1f21", base01: "#282a2e", base02: "#373b41", base03: "#969896", base04: "#b4b7b4", base05: "#c5c8c6", base06: "#e0e0e0", base07: "#ffffff", base08: "#CC342B", base09: "#F96A38", base0A: "#FBA922", base0B: "#198844", base0C: "#3971ED", base0D: "#3971ED", base0E: "#A36AC7", base0F: "#3971ED" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "grayscale", author: "alexandre gavioli (https://github.com/alexx2/)", base00: "#101010", base01: "#252525", base02: "#464646", base03: "#525252", base04: "#ababab", base05: "#b9b9b9", base06: "#e3e3e3", base07: "#f7f7f7", base08: "#7c7c7c", base09: "#999999", base0A: "#a0a0a0", base0B: "#8e8e8e", base0C: "#868686", base0D: "#686868", base0E: "#747474", base0F: "#5e5e5e" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "green screen", author: "chris kempson (http://chriskempson.com)", base00: "#001100", base01: "#003300", base02: "#005500", base03: "#007700", base04: "#009900", base05: "#00bb00", base06: "#00dd00", base07: "#00ff00", base08: "#007700", base09: "#009900", base0A: "#007700", base0B: "#00bb00", base0C: "#005500", base0D: "#009900", base0E: "#00bb00", base0F: "#005500" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "harmonic16", author: "jannik siebert (https://github.com/janniks)", base00: "#0b1c2c", base01: "#223b54", base02: "#405c79", base03: "#627e99", base04: "#aabcce", base05: "#cbd6e2", base06: "#e5ebf1", base07: "#f7f9fb", base08: "#bf8b56", base09: "#bfbf56", base0A: "#8bbf56", base0B: "#56bf8b", base0C: "#568bbf", base0D: "#8b56bf", base0E: "#bf568b", base0F: "#bf5656" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "hopscotch", author: "jan t. sott", base00: "#322931", base01: "#433b42", base02: "#5c545b", base03: "#797379", base04: "#989498", base05: "#b9b5b8", base06: "#d5d3d5", base07: "#ffffff", base08: "#dd464c", base09: "#fd8b19", base0A: "#fdcc59", base0B: "#8fc13e", base0C: "#149b93", base0D: "#1290bf", base0E: "#c85e7c", base0F: "#b33508" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "isotope", author: "jan t. sott", base00: "#000000", base01: "#404040", base02: "#606060", base03: "#808080", base04: "#c0c0c0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#ffffff", base08: "#ff0000", base09: "#ff9900", base0A: "#ff0099", base0B: "#33ff00", base0C: "#00ffff", base0D: "#0066ff", base0E: "#cc00ff", base0F: "#3300ff" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "marrakesh", author: "alexandre gavioli (http://github.com/alexx2/)", base00: "#201602", base01: "#302e00", base02: "#5f5b17", base03: "#6c6823", base04: "#86813b", base05: "#948e48", base06: "#ccc37a", base07: "#faf0a5", base08: "#c35359", base09: "#b36144", base0A: "#a88339", base0B: "#18974e", base0C: "#75a738", base0D: "#477ca1", base0E: "#8868b3", base0F: "#b3588e" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "mocha", author: "chris kempson (http://chriskempson.com)", base00: "#3B3228", base01: "#534636", base02: "#645240", base03: "#7e705a", base04: "#b8afad", base05: "#d0c8c6", base06: "#e9e1dd", base07: "#f5eeeb", base08: "#cb6077", base09: "#d28b71", base0A: "#f4bc87", base0B: "#beb55b", base0C: "#7bbda4", base0D: "#8ab3b5", base0E: "#a89bb9", base0F: "#bb9584" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "monokai", author: "wimer hazenberg (http://www.monokai.nl)", base00: "#272822", base01: "#383830", base02: "#49483e", base03: "#75715e", base04: "#a59f85", base05: "#f8f8f2", base06: "#f5f4f1", base07: "#f9f8f5", base08: "#f92672", base09: "#fd971f", base0A: "#f4bf75", base0B: "#a6e22e", base0C: "#a1efe4", base0D: "#66d9ef", base0E: "#ae81ff", base0F: "#cc6633" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "ocean", author: "chris kempson (http://chriskempson.com)", base00: "#2b303b", base01: "#343d46", base02: "#4f5b66", base03: "#65737e", base04: "#a7adba", base05: "#c0c5ce", base06: "#dfe1e8", base07: "#eff1f5", base08: "#bf616a", base09: "#d08770", base0A: "#ebcb8b", base0B: "#a3be8c", base0C: "#96b5b4", base0D: "#8fa1b3", base0E: "#b48ead", base0F: "#ab7967" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "paraiso", author: "jan t. sott", base00: "#2f1e2e", base01: "#41323f", base02: "#4f424c", base03: "#776e71", base04: "#8d8687", base05: "#a39e9b", base06: "#b9b6b0", base07: "#e7e9db", base08: "#ef6155", base09: "#f99b15", base0A: "#fec418", base0B: "#48b685", base0C: "#5bc4bf", base0D: "#06b6ef", base0E: "#815ba4", base0F: "#e96ba8" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "pop", author: "chris kempson (http://chriskempson.com)", base00: "#000000", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#b0b0b0", base05: "#d0d0d0", base06: "#e0e0e0", base07: "#ffffff", base08: "#eb008a", base09: "#f29333", base0A: "#f8ca12", base0B: "#37b349", base0C: "#00aabb", base0D: "#0e5a94", base0E: "#b31e8d", base0F: "#7a2d00" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "railscasts", author: "ryan bates (http://railscasts.com)", base00: "#2b2b2b", base01: "#272935", base02: "#3a4055", base03: "#5a647e", base04: "#d4cfc9", base05: "#e6e1dc", base06: "#f4f1ed", base07: "#f9f7f3", base08: "#da4939", base09: "#cc7833", base0A: "#ffc66d", base0B: "#a5c261", base0C: "#519f50", base0D: "#6d9cbe", base0E: "#b6b3eb", base0F: "#bc9458" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "shapeshifter", author: "tyler benziger (http://tybenz.com)", base00: "#000000", base01: "#040404", base02: "#102015", base03: "#343434", base04: "#555555", base05: "#ababab", base06: "#e0e0e0", base07: "#f9f9f9", base08: "#e92f2f", base09: "#e09448", base0A: "#dddd13", base0B: "#0ed839", base0C: "#23edda", base0D: "#3b48e3", base0E: "#f996e2", base0F: "#69542d" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "solarized", author: "ethan schoonover (http://ethanschoonover.com/solarized)", base00: "#002b36", base01: "#073642", base02: "#586e75", base03: "#657b83", base04: "#839496", base05: "#93a1a1", base06: "#eee8d5", base07: "#fdf6e3", base08: "#dc322f", base09: "#cb4b16", base0A: "#b58900", base0B: "#859900", base0C: "#2aa198", base0D: "#268bd2", base0E: "#6c71c4", base0F: "#d33682" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "summerfruit", author: "christopher corley (http://cscorley.github.io/)", base00: "#151515", base01: "#202020", base02: "#303030", base03: "#505050", base04: "#B0B0B0", base05: "#D0D0D0", base06: "#E0E0E0", base07: "#FFFFFF", base08: "#FF0086", base09: "#FD8900", base0A: "#ABA800", base0B: "#00C918", base0C: "#1faaaa", base0D: "#3777E6", base0E: "#AD00A1", base0F: "#cc6633" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "tomorrow", author: "chris kempson (http://chriskempson.com)", base00: "#1d1f21", base01: "#282a2e", base02: "#373b41", base03: "#969896", base04: "#b4b7b4", base05: "#c5c8c6", base06: "#e0e0e0", base07: "#ffffff", base08: "#cc6666", base09: "#de935f", base0A: "#f0c674", base0B: "#b5bd68", base0C: "#8abeb7", base0D: "#81a2be", base0E: "#b294bb", base0F: "#a3685a" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "london tube", author: "jan t. sott", base00: "#231f20", base01: "#1c3f95", base02: "#5a5758", base03: "#737171", base04: "#959ca1", base05: "#d9d8d8", base06: "#e7e7e8", base07: "#ffffff", base08: "#ee2e24", base09: "#f386a1", base0A: "#ffd204", base0B: "#00853e", base0C: "#85cebc", base0D: "#009ddc", base0E: "#98005d", base0F: "#b06110" }, r.exports = i.default;
      }, function(r, i, o) {
        i.__esModule = !0, i.default = { scheme: "twilight", author: "david hart (http://hart-dev.com)", base00: "#1e1e1e", base01: "#323537", base02: "#464b50", base03: "#5f5a60", base04: "#838184", base05: "#a7a7a7", base06: "#c3c3c3", base07: "#ffffff", base08: "#cf6a4c", base09: "#cda869", base0A: "#f9ee98", base0B: "#8f9d6a", base0C: "#afc4db", base0D: "#7587a6", base0E: "#9b859d", base0F: "#9b703f" }, r.exports = i.default;
      }, function(r, i, o) {
        var s = o(33);
        function l(c) {
          var a = Math.round(s(c, 0, 255)).toString(16);
          return a.length == 1 ? "0" + a : a;
        }
        r.exports = function(c) {
          var a = c.length === 4 ? l(255 * c[3]) : "";
          return "#" + l(c[0]) + l(c[1]) + l(c[2]) + a;
        };
      }, function(r, i, o) {
        var s = o(134), l = o(135), c = o(136), a = o(137), u = { "#": l, hsl: function(d) {
          var p = s(d), h = a(p);
          return p.length === 4 && h.push(p[3]), h;
        }, rgb: c };
        function f(d) {
          for (var p in u) if (d.indexOf(p) === 0) return u[p](d);
        }
        f.rgb = c, f.hsl = s, f.hex = l, r.exports = f;
      }, function(r, i, o) {
        var s = o(44), l = o(33);
        function c(a, u) {
          switch (a = parseFloat(a), u) {
            case 0:
              return l(a, 0, 360);
            case 1:
            case 2:
              return l(a, 0, 100);
            case 3:
              return l(a, 0, 1);
          }
        }
        r.exports = function(a) {
          return s(a).map(c);
        };
      }, function(r, i) {
        r.exports = function(o) {
          o.length !== 4 && o.length !== 5 || (o = function(c) {
            for (var a = "#", u = 1; u < c.length; u++) {
              var f = c.charAt(u);
              a += f + f;
            }
            return a;
          }(o));
          var s = [parseInt(o.substring(1, 3), 16), parseInt(o.substring(3, 5), 16), parseInt(o.substring(5, 7), 16)];
          if (o.length === 9) {
            var l = parseFloat((parseInt(o.substring(7, 9), 16) / 255).toFixed(2));
            s.push(l);
          }
          return s;
        };
      }, function(r, i, o) {
        var s = o(44), l = o(33);
        function c(a, u) {
          return u < 3 ? a.indexOf("%") != -1 ? Math.round(255 * l(parseInt(a, 10), 0, 100) / 100) : l(parseInt(a, 10), 0, 255) : l(parseFloat(a), 0, 1);
        }
        r.exports = function(a) {
          return s(a).map(c);
        };
      }, function(r, i) {
        r.exports = function(o) {
          var s, l, c, a, u, f = o[0] / 360, d = o[1] / 100, p = o[2] / 100;
          if (d == 0) return [u = 255 * p, u, u];
          s = 2 * p - (l = p < 0.5 ? p * (1 + d) : p + d - p * d), a = [0, 0, 0];
          for (var h = 0; h < 3; h++) (c = f + 1 / 3 * -(h - 1)) < 0 && c++, c > 1 && c--, u = 6 * c < 1 ? s + 6 * (l - s) * c : 2 * c < 1 ? l : 3 * c < 2 ? s + (l - s) * (2 / 3 - c) * 6 : s, a[h] = 255 * u;
          return a;
        };
      }, function(r, i, o) {
        (function(s) {
          var l = typeof s == "object" && s && s.Object === Object && s, c = typeof self == "object" && self && self.Object === Object && self, a = l || c || Function("return this")();
          function u(T, R, j) {
            switch (j.length) {
              case 0:
                return T.call(R);
              case 1:
                return T.call(R, j[0]);
              case 2:
                return T.call(R, j[0], j[1]);
              case 3:
                return T.call(R, j[0], j[1], j[2]);
            }
            return T.apply(R, j);
          }
          function f(T, R) {
            for (var j = -1, F = R.length, L = T.length; ++j < F; ) T[L + j] = R[j];
            return T;
          }
          var d = Object.prototype, p = d.hasOwnProperty, h = d.toString, m = a.Symbol, v = d.propertyIsEnumerable, b = m ? m.isConcatSpreadable : void 0, A = Math.max;
          function w(T) {
            return O(T) || function(R) {
              return function(j) {
                return /* @__PURE__ */ function(F) {
                  return !!F && typeof F == "object";
                }(j) && function(F) {
                  return F != null && function(L) {
                    return typeof L == "number" && L > -1 && L % 1 == 0 && L <= 9007199254740991;
                  }(F.length) && !function(L) {
                    var _ = function(U) {
                      var z = typeof U;
                      return !!U && (z == "object" || z == "function");
                    }(L) ? h.call(L) : "";
                    return _ == "[object Function]" || _ == "[object GeneratorFunction]";
                  }(F);
                }(j);
              }(R) && p.call(R, "callee") && (!v.call(R, "callee") || h.call(R) == "[object Arguments]");
            }(T) || !!(b && T && T[b]);
          }
          var O = Array.isArray, x, S, E, k = (S = function(T) {
            var R = (T = function(L, _, U, z, C) {
              var I = -1, M = L.length;
              for (U || (U = w), C || (C = []); ++I < M; ) {
                var D = L[I];
                U(D) ? f(C, D) : C[C.length] = D;
              }
              return C;
            }(T)).length, j = R;
            for (x; j--; ) if (typeof T[j] != "function") throw new TypeError("Expected a function");
            return function() {
              for (var F = 0, L = R ? T[F].apply(this, arguments) : arguments[0]; ++F < R; ) L = T[F].call(this, L);
              return L;
            };
          }, E = A(E === void 0 ? S.length - 1 : E, 0), function() {
            for (var T = arguments, R = -1, j = A(T.length - E, 0), F = Array(j); ++R < j; ) F[R] = T[E + R];
            R = -1;
            for (var L = Array(E + 1); ++R < E; ) L[R] = T[R];
            return L[E] = F, u(S, this, L);
          });
          r.exports = k;
        }).call(this, o(43));
      }, function(r, i, o) {
        Object.defineProperty(i, "__esModule", { value: !0 }), i.yuv2rgb = function(s) {
          var l, c, a, u = s[0], f = s[1], d = s[2];
          return l = 1 * u + 0 * f + 1.13983 * d, c = 1 * u + -0.39465 * f + -0.5806 * d, a = 1 * u + 2.02311 * f + 0 * d, l = Math.min(Math.max(0, l), 1), c = Math.min(Math.max(0, c), 1), a = Math.min(Math.max(0, a), 1), [255 * l, 255 * c, 255 * a];
        }, i.rgb2yuv = function(s) {
          var l = s[0] / 255, c = s[1] / 255, a = s[2] / 255;
          return [0.299 * l + 0.587 * c + 0.114 * a, -0.14713 * l + -0.28886 * c + 0.436 * a, 0.615 * l + -0.51499 * c + -0.10001 * a];
        };
      }, function(r, i, o) {
        function s(a, u, f) {
          return u in a ? Object.defineProperty(a, u, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : a[u] = f, a;
        }
        var l = o(141), c = function() {
          function a() {
            s(this, "_callbacks", void 0), s(this, "_isDispatching", void 0), s(this, "_isHandled", void 0), s(this, "_isPending", void 0), s(this, "_lastID", void 0), s(this, "_pendingPayload", void 0), this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
          }
          var u = a.prototype;
          return u.register = function(f) {
            var d = "ID_" + this._lastID++;
            return this._callbacks[d] = f, d;
          }, u.unregister = function(f) {
            this._callbacks[f] || l(!1), delete this._callbacks[f];
          }, u.waitFor = function(f) {
            this._isDispatching || l(!1);
            for (var d = 0; d < f.length; d++) {
              var p = f[d];
              this._isPending[p] ? this._isHandled[p] || l(!1) : (this._callbacks[p] || l(!1), this._invokeCallback(p));
            }
          }, u.dispatch = function(f) {
            this._isDispatching && l(!1), this._startDispatching(f);
            try {
              for (var d in this._callbacks) this._isPending[d] || this._invokeCallback(d);
            } finally {
              this._stopDispatching();
            }
          }, u.isDispatching = function() {
            return this._isDispatching;
          }, u._invokeCallback = function(f) {
            this._isPending[f] = !0, this._callbacks[f](this._pendingPayload), this._isHandled[f] = !0;
          }, u._startDispatching = function(f) {
            for (var d in this._callbacks) this._isPending[d] = !1, this._isHandled[d] = !1;
            this._pendingPayload = f, this._isDispatching = !0;
          }, u._stopDispatching = function() {
            delete this._pendingPayload, this._isDispatching = !1;
          }, a;
        }();
        r.exports = c;
      }, function(r, i, o) {
        r.exports = function(s, l) {
          for (var c = arguments.length, a = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++) a[u - 2] = arguments[u];
          if (!s) {
            var f;
            if (l === void 0) f = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
              var d = 0;
              (f = new Error(l.replace(/%s/g, function() {
                return String(a[d++]);
              }))).name = "Invariant Violation";
            }
            throw f.framesToPop = 1, f;
          }
        };
      }, function(r, i, o) {
        function s(ge, ve, se) {
          return ve in ge ? Object.defineProperty(ge, ve, { value: se, enumerable: !0, configurable: !0, writable: !0 }) : ge[ve] = se, ge;
        }
        function l(ge, ve) {
          var se = Object.keys(ge);
          if (Object.getOwnPropertySymbols) {
            var P = Object.getOwnPropertySymbols(ge);
            ve && (P = P.filter(function(W) {
              return Object.getOwnPropertyDescriptor(ge, W).enumerable;
            })), se.push.apply(se, P);
          }
          return se;
        }
        function c(ge) {
          for (var ve = 1; ve < arguments.length; ve++) {
            var se = arguments[ve] != null ? arguments[ve] : {};
            ve % 2 ? l(Object(se), !0).forEach(function(P) {
              s(ge, P, se[P]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ge, Object.getOwnPropertyDescriptors(se)) : l(Object(se)).forEach(function(P) {
              Object.defineProperty(ge, P, Object.getOwnPropertyDescriptor(se, P));
            });
          }
          return ge;
        }
        function a(ge, ve) {
          if (!(ge instanceof ve)) throw new TypeError("Cannot call a class as a function");
        }
        function u(ge, ve) {
          for (var se = 0; se < ve.length; se++) {
            var P = ve[se];
            P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(ge, P.key, P);
          }
        }
        function f(ge, ve, se) {
          return ve && u(ge.prototype, ve), se && u(ge, se), ge;
        }
        function d(ge, ve) {
          return (d = Object.setPrototypeOf || function(se, P) {
            return se.__proto__ = P, se;
          })(ge, ve);
        }
        function p(ge, ve) {
          if (typeof ve != "function" && ve !== null) throw new TypeError("Super expression must either be null or a function");
          ge.prototype = Object.create(ve && ve.prototype, { constructor: { value: ge, writable: !0, configurable: !0 } }), ve && d(ge, ve);
        }
        function h(ge) {
          return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function(ve) {
            return ve.__proto__ || Object.getPrototypeOf(ve);
          })(ge);
        }
        function m(ge) {
          return (m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ve) {
            return typeof ve;
          } : function(ve) {
            return ve && typeof Symbol == "function" && ve.constructor === Symbol && ve !== Symbol.prototype ? "symbol" : typeof ve;
          })(ge);
        }
        function v(ge) {
          if (ge === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return ge;
        }
        function b(ge, ve) {
          return !ve || m(ve) !== "object" && typeof ve != "function" ? v(ge) : ve;
        }
        function A(ge) {
          var ve = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var se, P = h(ge);
            if (ve) {
              var W = h(this).constructor;
              se = Reflect.construct(P, arguments, W);
            } else se = P.apply(this, arguments);
            return b(this, se);
          };
        }
        o.r(i);
        var w = o(0), O = o.n(w);
        function x() {
          var ge = this.constructor.getDerivedStateFromProps(this.props, this.state);
          ge != null && this.setState(ge);
        }
        function S(ge) {
          this.setState((function(ve) {
            var se = this.constructor.getDerivedStateFromProps(ge, ve);
            return se ?? null;
          }).bind(this));
        }
        function E(ge, ve) {
          try {
            var se = this.props, P = this.state;
            this.props = ge, this.state = ve, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(se, P);
          } finally {
            this.props = se, this.state = P;
          }
        }
        function k(ge) {
          var ve = ge.prototype;
          if (!ve || !ve.isReactComponent) throw new Error("Can only polyfill class components");
          if (typeof ge.getDerivedStateFromProps != "function" && typeof ve.getSnapshotBeforeUpdate != "function") return ge;
          var se = null, P = null, W = null;
          if (typeof ve.componentWillMount == "function" ? se = "componentWillMount" : typeof ve.UNSAFE_componentWillMount == "function" && (se = "UNSAFE_componentWillMount"), typeof ve.componentWillReceiveProps == "function" ? P = "componentWillReceiveProps" : typeof ve.UNSAFE_componentWillReceiveProps == "function" && (P = "UNSAFE_componentWillReceiveProps"), typeof ve.componentWillUpdate == "function" ? W = "componentWillUpdate" : typeof ve.UNSAFE_componentWillUpdate == "function" && (W = "UNSAFE_componentWillUpdate"), se !== null || P !== null || W !== null) {
            var te = ge.displayName || ge.name, de = typeof ge.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            throw Error(`Unsafe legacy lifecycles will not be called for components using new component APIs.

` + te + " uses " + de + " but also contains the following legacy lifecycles:" + (se !== null ? `
  ` + se : "") + (P !== null ? `
  ` + P : "") + (W !== null ? `
  ` + W : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`);
          }
          if (typeof ge.getDerivedStateFromProps == "function" && (ve.componentWillMount = x, ve.componentWillReceiveProps = S), typeof ve.getSnapshotBeforeUpdate == "function") {
            if (typeof ve.componentDidUpdate != "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
            ve.componentWillUpdate = E;
            var Ne = ve.componentDidUpdate;
            ve.componentDidUpdate = function(Me, Ge, $t) {
              var In = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : $t;
              Ne.call(this, Me, Ge, In);
            };
          }
          return ge;
        }
        function T(ge, ve) {
          if (ge == null) return {};
          var se, P, W = function(de, Ne) {
            if (de == null) return {};
            var Me, Ge, $t = {}, In = Object.keys(de);
            for (Ge = 0; Ge < In.length; Ge++) Me = In[Ge], Ne.indexOf(Me) >= 0 || ($t[Me] = de[Me]);
            return $t;
          }(ge, ve);
          if (Object.getOwnPropertySymbols) {
            var te = Object.getOwnPropertySymbols(ge);
            for (P = 0; P < te.length; P++) se = te[P], ve.indexOf(se) >= 0 || Object.prototype.propertyIsEnumerable.call(ge, se) && (W[se] = ge[se]);
          }
          return W;
        }
        function R(ge) {
          var ve = function(se) {
            return {}.toString.call(se).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
          }(ge);
          return ve === "number" && (ve = isNaN(ge) ? "nan" : (0 | ge) != ge ? "float" : "integer"), ve;
        }
        x.__suppressDeprecationWarning = !0, S.__suppressDeprecationWarning = !0, E.__suppressDeprecationWarning = !0;
        var j = { scheme: "rjv-default", author: "mac gainor", base00: "rgba(0, 0, 0, 0)", base01: "rgb(245, 245, 245)", base02: "rgb(235, 235, 235)", base03: "#93a1a1", base04: "rgba(0, 0, 0, 0.3)", base05: "#586e75", base06: "#073642", base07: "#002b36", base08: "#d33682", base09: "#cb4b16", base0A: "#dc322f", base0B: "#859900", base0C: "#6c71c4", base0D: "#586e75", base0E: "#2aa198", base0F: "#268bd2" }, F = { scheme: "rjv-grey", author: "mac gainor", base00: "rgba(1, 1, 1, 0)", base01: "rgba(1, 1, 1, 0.1)", base02: "rgba(0, 0, 0, 0.2)", base03: "rgba(1, 1, 1, 0.3)", base04: "rgba(0, 0, 0, 0.4)", base05: "rgba(1, 1, 1, 0.5)", base06: "rgba(1, 1, 1, 0.6)", base07: "rgba(1, 1, 1, 0.7)", base08: "rgba(1, 1, 1, 0.8)", base09: "rgba(1, 1, 1, 0.8)", base0A: "rgba(1, 1, 1, 0.8)", base0B: "rgba(1, 1, 1, 0.8)", base0C: "rgba(1, 1, 1, 0.8)", base0D: "rgba(1, 1, 1, 0.8)", base0E: "rgba(1, 1, 1, 0.8)", base0F: "rgba(1, 1, 1, 0.8)" }, L = { globalFontFamily: "monospace", globalCursor: "default", braceFontWeight: "bold", braceCursor: "pointer", ellipsisFontSize: "18px", ellipsisLineHeight: "10px", ellipsisCursor: "pointer", keyMargin: "0px 5px", keyLetterSpacing: "0.5px", keyFontStyle: "none", keyVerticalAlign: "top", keyOpacity: "0.85", keyOpacityHover: "1", keyValPaddingTop: "3px", keyValPaddingBottom: "3px", keyValPaddingRight: "5px", keyValBorderLeft: "1px solid", keyValBorderHover: "2px solid", pushedContentMarginLeft: "6px", variableValuePaddingRight: "6px", nullFontSize: "11px", nullFontWeight: "bold", nullPadding: "1px 2px", nullBorderRadius: "3px", nanFontSize: "11px", nanFontWeight: "bold", nanPadding: "1px 2px", nanBorderRadius: "3px", undefinedFontSize: "11px", undefinedPadding: "1px 2px", undefinedBorderRadius: "3px", dataTypeFontSize: "11px", dataTypeMarginRight: "4px", datatypeOpacity: "0.8", objectSizeBorderRadius: "3px", objectSizeFontStyle: "italic", objectSizeMargin: "0px 6px 0px 0px", clipboardCursor: "pointer", clipboardCheckMarginLeft: "-12px", metaDataPadding: "0px 0px 0px 10px", arrayGroupMetaPadding: "0px 0px 0px 4px", iconContainerWidth: "17px", tooltipPadding: "4px", editInputMinWidth: "130px", editInputBorderRadius: "2px", editInputPadding: "5px", editInputMarginRight: "4px", editInputFontFamily: "monospace", iconCursor: "pointer", iconFontSize: "15px", iconPaddingRight: "1px", dateValueMarginLeft: "2px", iconMarginRight: "3px", detectedRowPaddingTop: "3px", addKeyCoverBackground: "rgba(255, 255, 255, 0.3)", addKeyCoverPosition: "absolute", addKeyCoverPositionPx: "0px", addKeyModalWidth: "200px", addKeyModalMargin: "auto", addKeyModalPadding: "10px", addKeyModalRadius: "3px" }, _ = o(45), U = function(ge) {
          var ve = function(se) {
            return { backgroundColor: se.base00, ellipsisColor: se.base09, braceColor: se.base07, expandedIcon: se.base0D, collapsedIcon: se.base0E, keyColor: se.base07, arrayKeyColor: se.base0C, objectSize: se.base04, copyToClipboard: se.base0F, copyToClipboardCheck: se.base0D, objectBorder: se.base02, dataTypes: { boolean: se.base0E, date: se.base0D, float: se.base0B, function: se.base0D, integer: se.base0F, string: se.base09, nan: se.base08, null: se.base0A, undefined: se.base05, regexp: se.base0A, background: se.base02 }, editVariable: { editIcon: se.base0E, cancelIcon: se.base09, removeIcon: se.base09, addIcon: se.base0E, checkIcon: se.base0E, background: se.base01, color: se.base0A, border: se.base07 }, addKeyModal: { background: se.base05, border: se.base04, color: se.base0A, labelColor: se.base01 }, validationFailure: { background: se.base09, iconColor: se.base01, fontColor: se.base01 } };
          }(ge);
          return { "app-container": { fontFamily: L.globalFontFamily, cursor: L.globalCursor, backgroundColor: ve.backgroundColor, position: "relative" }, ellipsis: { display: "inline-block", color: ve.ellipsisColor, fontSize: L.ellipsisFontSize, lineHeight: L.ellipsisLineHeight, cursor: L.ellipsisCursor }, "brace-row": { display: "inline-block", cursor: "pointer" }, brace: { display: "inline-block", cursor: L.braceCursor, fontWeight: L.braceFontWeight, color: ve.braceColor }, "expanded-icon": { color: ve.expandedIcon }, "collapsed-icon": { color: ve.collapsedIcon }, colon: { display: "inline-block", margin: L.keyMargin, color: ve.keyColor, verticalAlign: "top" }, objectKeyVal: function(se, P) {
            return { style: c({ paddingTop: L.keyValPaddingTop, paddingRight: L.keyValPaddingRight, paddingBottom: L.keyValPaddingBottom, borderLeft: L.keyValBorderLeft + " " + ve.objectBorder, ":hover": { paddingLeft: P.paddingLeft - 1 + "px", borderLeft: L.keyValBorderHover + " " + ve.objectBorder } }, P) };
          }, "object-key-val-no-border": { padding: L.keyValPadding }, "pushed-content": { marginLeft: L.pushedContentMarginLeft }, variableValue: function(se, P) {
            return { style: c({ display: "inline-block", paddingRight: L.variableValuePaddingRight, position: "relative" }, P) };
          }, "object-name": { display: "inline-block", color: ve.keyColor, letterSpacing: L.keyLetterSpacing, fontStyle: L.keyFontStyle, verticalAlign: L.keyVerticalAlign, opacity: L.keyOpacity, ":hover": { opacity: L.keyOpacityHover } }, "array-key": { display: "inline-block", color: ve.arrayKeyColor, letterSpacing: L.keyLetterSpacing, fontStyle: L.keyFontStyle, verticalAlign: L.keyVerticalAlign, opacity: L.keyOpacity, ":hover": { opacity: L.keyOpacityHover } }, "object-size": { color: ve.objectSize, borderRadius: L.objectSizeBorderRadius, fontStyle: L.objectSizeFontStyle, margin: L.objectSizeMargin, cursor: "default" }, "data-type-label": { fontSize: L.dataTypeFontSize, marginRight: L.dataTypeMarginRight, opacity: L.datatypeOpacity }, boolean: { display: "inline-block", color: ve.dataTypes.boolean }, date: { display: "inline-block", color: ve.dataTypes.date }, "date-value": { marginLeft: L.dateValueMarginLeft }, float: { display: "inline-block", color: ve.dataTypes.float }, function: { display: "inline-block", color: ve.dataTypes.function, cursor: "pointer", whiteSpace: "pre-line" }, "function-value": { fontStyle: "italic" }, integer: { display: "inline-block", color: ve.dataTypes.integer }, string: { display: "inline-block", color: ve.dataTypes.string }, nan: { display: "inline-block", color: ve.dataTypes.nan, fontSize: L.nanFontSize, fontWeight: L.nanFontWeight, backgroundColor: ve.dataTypes.background, padding: L.nanPadding, borderRadius: L.nanBorderRadius }, null: { display: "inline-block", color: ve.dataTypes.null, fontSize: L.nullFontSize, fontWeight: L.nullFontWeight, backgroundColor: ve.dataTypes.background, padding: L.nullPadding, borderRadius: L.nullBorderRadius }, undefined: { display: "inline-block", color: ve.dataTypes.undefined, fontSize: L.undefinedFontSize, padding: L.undefinedPadding, borderRadius: L.undefinedBorderRadius, backgroundColor: ve.dataTypes.background }, regexp: { display: "inline-block", color: ve.dataTypes.regexp }, "copy-to-clipboard": { cursor: L.clipboardCursor }, "copy-icon": { color: ve.copyToClipboard, fontSize: L.iconFontSize, marginRight: L.iconMarginRight, verticalAlign: "top" }, "copy-icon-copied": { color: ve.copyToClipboardCheck, marginLeft: L.clipboardCheckMarginLeft }, "array-group-meta-data": { display: "inline-block", padding: L.arrayGroupMetaPadding }, "object-meta-data": { display: "inline-block", padding: L.metaDataPadding }, "icon-container": { display: "inline-block", width: L.iconContainerWidth }, tooltip: { padding: L.tooltipPadding }, removeVarIcon: { verticalAlign: "top", display: "inline-block", color: ve.editVariable.removeIcon, cursor: L.iconCursor, fontSize: L.iconFontSize, marginRight: L.iconMarginRight }, addVarIcon: { verticalAlign: "top", display: "inline-block", color: ve.editVariable.addIcon, cursor: L.iconCursor, fontSize: L.iconFontSize, marginRight: L.iconMarginRight }, editVarIcon: { verticalAlign: "top", display: "inline-block", color: ve.editVariable.editIcon, cursor: L.iconCursor, fontSize: L.iconFontSize, marginRight: L.iconMarginRight }, "edit-icon-container": { display: "inline-block", verticalAlign: "top" }, "check-icon": { display: "inline-block", cursor: L.iconCursor, color: ve.editVariable.checkIcon, fontSize: L.iconFontSize, paddingRight: L.iconPaddingRight }, "cancel-icon": { display: "inline-block", cursor: L.iconCursor, color: ve.editVariable.cancelIcon, fontSize: L.iconFontSize, paddingRight: L.iconPaddingRight }, "edit-input": { display: "inline-block", minWidth: L.editInputMinWidth, borderRadius: L.editInputBorderRadius, backgroundColor: ve.editVariable.background, color: ve.editVariable.color, padding: L.editInputPadding, marginRight: L.editInputMarginRight, fontFamily: L.editInputFontFamily }, "detected-row": { paddingTop: L.detectedRowPaddingTop }, "key-modal-request": { position: L.addKeyCoverPosition, top: L.addKeyCoverPositionPx, left: L.addKeyCoverPositionPx, right: L.addKeyCoverPositionPx, bottom: L.addKeyCoverPositionPx, backgroundColor: L.addKeyCoverBackground }, "key-modal": { width: L.addKeyModalWidth, backgroundColor: ve.addKeyModal.background, marginLeft: L.addKeyModalMargin, marginRight: L.addKeyModalMargin, padding: L.addKeyModalPadding, borderRadius: L.addKeyModalRadius, marginTop: "15px", position: "relative" }, "key-modal-label": { color: ve.addKeyModal.labelColor, marginLeft: "2px", marginBottom: "5px", fontSize: "11px" }, "key-modal-input-container": { overflow: "hidden" }, "key-modal-input": { width: "100%", padding: "3px 6px", fontFamily: "monospace", color: ve.addKeyModal.color, border: "none", boxSizing: "border-box", borderRadius: "2px" }, "key-modal-cancel": { backgroundColor: ve.editVariable.removeIcon, position: "absolute", top: "0px", right: "0px", borderRadius: "0px 3px 0px 3px", cursor: "pointer" }, "key-modal-cancel-icon": { color: ve.addKeyModal.labelColor, fontSize: L.iconFontSize, transform: "rotate(45deg)" }, "key-modal-submit": { color: ve.editVariable.addIcon, fontSize: L.iconFontSize, position: "absolute", right: "2px", top: "3px", cursor: "pointer" }, "function-ellipsis": { display: "inline-block", color: ve.ellipsisColor, fontSize: L.ellipsisFontSize, lineHeight: L.ellipsisLineHeight, cursor: L.ellipsisCursor }, "validation-failure": { float: "right", padding: "3px 6px", borderRadius: "2px", cursor: "pointer", color: ve.validationFailure.fontColor, backgroundColor: ve.validationFailure.background }, "validation-failure-label": { marginRight: "6px" }, "validation-failure-clear": { position: "relative", verticalAlign: "top", cursor: "pointer", color: ve.validationFailure.iconColor, fontSize: L.iconFontSize, transform: "rotate(45deg)" } };
        };
        function z(ge, ve, se) {
          return ge || console.error("theme has not been set"), function(P) {
            var W = j;
            return P !== !1 && P !== "none" || (W = F), Object(_.createStyling)(U, { defaultBase16: W })(P);
          }(ge)(ve, se);
        }
        var C = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = (P.rjvId, P.type_name), te = P.displayDataTypes, de = P.theme;
            return te ? O.a.createElement("span", Object.assign({ className: "data-type-label" }, z(de, "data-type-label")), W) : null;
          } }]), se;
        }(O.a.PureComponent), I = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props;
            return O.a.createElement("div", z(P.theme, "boolean"), O.a.createElement(C, Object.assign({ type_name: "bool" }, P)), P.value ? "true" : "false");
          } }]), se;
        }(O.a.PureComponent), M = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props;
            return O.a.createElement("div", z(P.theme, "date"), O.a.createElement(C, Object.assign({ type_name: "date" }, P)), O.a.createElement("span", Object.assign({ className: "date-value" }, z(P.theme, "date-value")), P.value.toLocaleTimeString("en-us", { weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })));
          } }]), se;
        }(O.a.PureComponent), D = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props;
            return O.a.createElement("div", z(P.theme, "float"), O.a.createElement(C, Object.assign({ type_name: "float" }, P)), this.props.value);
          } }]), se;
        }(O.a.PureComponent);
        function X(ge, ve) {
          (ve == null || ve > ge.length) && (ve = ge.length);
          for (var se = 0, P = new Array(ve); se < ve; se++) P[se] = ge[se];
          return P;
        }
        function B(ge, ve) {
          if (ge) {
            if (typeof ge == "string") return X(ge, ve);
            var se = Object.prototype.toString.call(ge).slice(8, -1);
            return se === "Object" && ge.constructor && (se = ge.constructor.name), se === "Map" || se === "Set" ? Array.from(ge) : se === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(se) ? X(ge, ve) : void 0;
          }
        }
        function q(ge, ve) {
          var se;
          if (typeof Symbol > "u" || ge[Symbol.iterator] == null) {
            if (Array.isArray(ge) || (se = B(ge)) || ve) {
              se && (ge = se);
              var P = 0, W = function() {
              };
              return { s: W, n: function() {
                return P >= ge.length ? { done: !0 } : { done: !1, value: ge[P++] };
              }, e: function(Me) {
                throw Me;
              }, f: W };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var te, de = !0, Ne = !1;
          return { s: function() {
            se = ge[Symbol.iterator]();
          }, n: function() {
            var Me = se.next();
            return de = Me.done, Me;
          }, e: function(Me) {
            Ne = !0, te = Me;
          }, f: function() {
            try {
              de || se.return == null || se.return();
            } finally {
              if (Ne) throw te;
            }
          } };
        }
        function H(ge) {
          return function(ve) {
            if (Array.isArray(ve)) return X(ve);
          }(ge) || function(ve) {
            if (typeof Symbol < "u" && Symbol.iterator in Object(ve)) return Array.from(ve);
          }(ge) || B(ge) || function() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }
        var Y = o(46), J = new (o(47)).Dispatcher(), oe = new (function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            var P;
            a(this, se);
            for (var W = arguments.length, te = new Array(W), de = 0; de < W; de++) te[de] = arguments[de];
            return (P = ve.call.apply(ve, [this].concat(te))).objects = {}, P.set = function(Ne, Me, Ge, $t) {
              P.objects[Ne] === void 0 && (P.objects[Ne] = {}), P.objects[Ne][Me] === void 0 && (P.objects[Ne][Me] = {}), P.objects[Ne][Me][Ge] = $t;
            }, P.get = function(Ne, Me, Ge, $t) {
              return P.objects[Ne] === void 0 || P.objects[Ne][Me] === void 0 || P.objects[Ne][Me][Ge] == null ? $t : P.objects[Ne][Me][Ge];
            }, P.handleAction = function(Ne) {
              var Me = Ne.rjvId, Ge = Ne.data;
              switch (Ne.name) {
                case "RESET":
                  P.emit("reset-" + Me);
                  break;
                case "VARIABLE_UPDATED":
                  Ne.data.updated_src = P.updateSrc(Me, Ge), P.set(Me, "action", "variable-update", c(c({}, Ge), {}, { type: "variable-edited" })), P.emit("variable-update-" + Me);
                  break;
                case "VARIABLE_REMOVED":
                  Ne.data.updated_src = P.updateSrc(Me, Ge), P.set(Me, "action", "variable-update", c(c({}, Ge), {}, { type: "variable-removed" })), P.emit("variable-update-" + Me);
                  break;
                case "VARIABLE_ADDED":
                  Ne.data.updated_src = P.updateSrc(Me, Ge), P.set(Me, "action", "variable-update", c(c({}, Ge), {}, { type: "variable-added" })), P.emit("variable-update-" + Me);
                  break;
                case "ADD_VARIABLE_KEY_REQUEST":
                  P.set(Me, "action", "new-key-request", Ge), P.emit("add-key-request-" + Me);
              }
            }, P.updateSrc = function(Ne, Me) {
              var Ge = Me.name, $t = Me.namespace, In = Me.new_value, Qn = (Me.existing_value, Me.variable_removed);
              $t.shift();
              var yr, Cn = P.get(Ne, "global", "src"), Ln = P.deepCopy(Cn, H($t)), Lr = Ln, bn = q($t);
              try {
                for (bn.s(); !(yr = bn.n()).done; )
                  Lr = Lr[yr.value];
              } catch (Cr) {
                bn.e(Cr);
              } finally {
                bn.f();
              }
              return Qn ? R(Lr) == "array" ? Lr.splice(Ge, 1) : delete Lr[Ge] : Ge !== null ? Lr[Ge] = In : Ln = In, P.set(Ne, "global", "src", Ln), Ln;
            }, P.deepCopy = function(Ne, Me) {
              var Ge, $t = R(Ne), In = Me.shift();
              return $t == "array" ? Ge = H(Ne) : $t == "object" && (Ge = c({}, Ne)), In !== void 0 && (Ge[In] = P.deepCopy(Ne[In], Me)), Ge;
            }, P;
          }
          return se;
        }(Y.EventEmitter))();
        J.register(oe.handleAction.bind(oe));
        var ce = oe, fe = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).toggleCollapsed = function() {
              W.setState({ collapsed: !W.state.collapsed }, function() {
                ce.set(W.props.rjvId, W.props.namespace, "collapsed", W.state.collapsed);
              });
            }, W.getFunctionDisplay = function(te) {
              var de = v(W).props;
              return te ? O.a.createElement("span", null, W.props.value.toString().slice(9, -1).replace(/\{[\s\S]+/, ""), O.a.createElement("span", { className: "function-collapsed", style: { fontWeight: "bold" } }, O.a.createElement("span", null, "{"), O.a.createElement("span", z(de.theme, "ellipsis"), "..."), O.a.createElement("span", null, "}"))) : W.props.value.toString().slice(9, -1);
            }, W.state = { collapsed: ce.get(P.rjvId, P.namespace, "collapsed", !0) }, W;
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = this.state.collapsed;
            return O.a.createElement("div", z(P.theme, "function"), O.a.createElement(C, Object.assign({ type_name: "function" }, P)), O.a.createElement("span", Object.assign({}, z(P.theme, "function-value"), { className: "rjv-function-container", onClick: this.toggleCollapsed }), this.getFunctionDisplay(W)));
          } }]), se;
        }(O.a.PureComponent), $ = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            return O.a.createElement("div", z(this.props.theme, "nan"), "NaN");
          } }]), se;
        }(O.a.PureComponent), pe = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            return O.a.createElement("div", z(this.props.theme, "null"), "NULL");
          } }]), se;
        }(O.a.PureComponent), ee = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props;
            return O.a.createElement("div", z(P.theme, "integer"), O.a.createElement(C, Object.assign({ type_name: "int" }, P)), this.props.value);
          } }]), se;
        }(O.a.PureComponent), Ce = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props;
            return O.a.createElement("div", z(P.theme, "regexp"), O.a.createElement(C, Object.assign({ type_name: "regexp" }, P)), this.props.value.toString());
          } }]), se;
        }(O.a.PureComponent), Ee = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).toggleCollapsed = function() {
              W.setState({ collapsed: !W.state.collapsed }, function() {
                ce.set(W.props.rjvId, W.props.namespace, "collapsed", W.state.collapsed);
              });
            }, W.state = { collapsed: ce.get(P.rjvId, P.namespace, "collapsed", !0) }, W;
          }
          return f(se, [{ key: "render", value: function() {
            this.state.collapsed;
            var P = this.props, W = P.collapseStringsAfterLength, te = P.theme, de = P.value, Ne = { style: { cursor: "default" } };
            return R(W) === "integer" && de.length > W && (Ne.style.cursor = "pointer", this.state.collapsed && (de = O.a.createElement("span", null, de.substring(0, W), O.a.createElement("span", z(te, "ellipsis"), " ...")))), O.a.createElement("div", z(te, "string"), O.a.createElement(C, Object.assign({ type_name: "string" }, P)), O.a.createElement("span", Object.assign({ className: "string-value" }, Ne, { onClick: this.toggleCollapsed }), '"', de, '"'));
          } }]), se;
        }(O.a.PureComponent), Ve = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            return O.a.createElement("div", z(this.props.theme, "undefined"), "undefined");
          } }]), se;
        }(O.a.PureComponent);
        function et() {
          return (et = Object.assign || function(ge) {
            for (var ve = 1; ve < arguments.length; ve++) {
              var se = arguments[ve];
              for (var P in se) Object.prototype.hasOwnProperty.call(se, P) && (ge[P] = se[P]);
            }
            return ge;
          }).apply(this, arguments);
        }
        var ft = w.useLayoutEffect, me = function(ge) {
          var ve = Object(w.useRef)(ge);
          return ft(function() {
            ve.current = ge;
          }), ve;
        }, Te = function(ge, ve) {
          typeof ge != "function" ? ge.current = ve : ge(ve);
        }, re = function(ge, ve) {
          var se = Object(w.useRef)();
          return Object(w.useCallback)(function(P) {
            ge.current = P, se.current && Te(se.current, null), se.current = ve, ve && Te(ve, P);
          }, [ve]);
        }, le = { "min-height": "0", "max-height": "none", height: "0", visibility: "hidden", overflow: "hidden", position: "absolute", "z-index": "-1000", top: "0", right: "0" }, Oe = function(ge) {
          Object.keys(le).forEach(function(ve) {
            ge.style.setProperty(ve, le[ve], "important");
          });
        }, be = null, je = function() {
        }, xe = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width"], Q = !!document.documentElement.currentStyle, ae = function(ge, ve) {
          var se = ge.cacheMeasurements, P = ge.maxRows, W = ge.minRows, te = ge.onChange, de = te === void 0 ? je : te, Ne = ge.onHeightChange, Me = Ne === void 0 ? je : Ne, Ge = function(bn, Cr) {
            if (bn == null) return {};
            var ro, zs, xd = {}, ua = Object.keys(bn);
            for (zs = 0; zs < ua.length; zs++) ro = ua[zs], Cr.indexOf(ro) >= 0 || (xd[ro] = bn[ro]);
            return xd;
          }(ge, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]), $t, In = Ge.value !== void 0, Qn = Object(w.useRef)(null), yr = re(Qn, ve), Cn = Object(w.useRef)(0), Ln = Object(w.useRef)(), Lr = function() {
            var bn = Qn.current, Cr = se && Ln.current ? Ln.current : function(ua) {
              var Pl = window.getComputedStyle(ua);
              if (Pl === null) return null;
              var Il, ye = (Il = Pl, xe.reduce(function(ht, On) {
                return ht[On] = Il[On], ht;
              }, {})), Ae = ye.boxSizing;
              return Ae === "" ? null : (Q && Ae === "border-box" && (ye.width = parseFloat(ye.width) + parseFloat(ye.borderRightWidth) + parseFloat(ye.borderLeftWidth) + parseFloat(ye.paddingRight) + parseFloat(ye.paddingLeft) + "px"), { sizingStyle: ye, paddingSize: parseFloat(ye.paddingBottom) + parseFloat(ye.paddingTop), borderSize: parseFloat(ye.borderBottomWidth) + parseFloat(ye.borderTopWidth) });
            }(bn);
            if (Cr) {
              Ln.current = Cr;
              var ro = function(ua, Pl, Il, ye) {
                Il === void 0 && (Il = 1), ye === void 0 && (ye = 1 / 0), be || ((be = document.createElement("textarea")).setAttribute("tab-index", "-1"), be.setAttribute("aria-hidden", "true"), Oe(be)), be.parentNode === null && document.body.appendChild(be);
                var Ae = ua.paddingSize, ht = ua.borderSize, On = ua.sizingStyle, Wn = On.boxSizing;
                Object.keys(On).forEach(function(Bb) {
                  var Sd = Bb;
                  be.style[Sd] = On[Sd];
                }), Oe(be), be.value = Pl;
                var da = function(Bb, Sd) {
                  var Xx = Bb.scrollHeight;
                  return Sd.sizingStyle.boxSizing === "border-box" ? Xx + Sd.borderSize : Xx - Sd.paddingSize;
                }(be, ua);
                be.value = "x";
                var Oc = be.scrollHeight - Ae, fa = Oc * Il;
                Wn === "border-box" && (fa = fa + Ae + ht), da = Math.max(fa, da);
                var Ih = Oc * ye;
                return Wn === "border-box" && (Ih = Ih + Ae + ht), [da = Math.min(Ih, da), Oc];
              }(Cr, bn.value || bn.placeholder || "x", W, P), zs = ro[0], xd = ro[1];
              Cn.current !== zs && (Cn.current = zs, bn.style.setProperty("height", zs + "px", "important"), Me(zs, { rowHeight: xd }));
            }
          };
          return Object(w.useLayoutEffect)(Lr), $t = me(Lr), Object(w.useLayoutEffect)(function() {
            var bn = function(Cr) {
              $t.current(Cr);
            };
            return window.addEventListener("resize", bn), function() {
              window.removeEventListener("resize", bn);
            };
          }, []), Object(w.createElement)("textarea", et({}, Ge, { onChange: function(bn) {
            In || Lr(), de(bn);
          }, ref: yr }));
        }, Pe = Object(w.forwardRef)(ae);
        function Fe(ge) {
          ge = ge.trim();
          try {
            if ((ge = JSON.stringify(JSON.parse(ge)))[0] === "[") return Ke("array", JSON.parse(ge));
            if (ge[0] === "{") return Ke("object", JSON.parse(ge));
            if (ge.match(/\-?\d+\.\d+/) && ge.match(/\-?\d+\.\d+/)[0] === ge) return Ke("float", parseFloat(ge));
            if (ge.match(/\-?\d+e-\d+/) && ge.match(/\-?\d+e-\d+/)[0] === ge) return Ke("float", Number(ge));
            if (ge.match(/\-?\d+/) && ge.match(/\-?\d+/)[0] === ge) return Ke("integer", parseInt(ge));
            if (ge.match(/\-?\d+e\+\d+/) && ge.match(/\-?\d+e\+\d+/)[0] === ge) return Ke("integer", Number(ge));
          } catch {
          }
          switch (ge = ge.toLowerCase()) {
            case "undefined":
              return Ke("undefined", void 0);
            case "nan":
              return Ke("nan", NaN);
            case "null":
              return Ke("null", null);
            case "true":
              return Ke("boolean", !0);
            case "false":
              return Ke("boolean", !1);
            default:
              if (ge = Date.parse(ge)) return Ke("date", new Date(ge));
          }
          return Ke(!1, null);
        }
        function Ke(ge, ve) {
          return { type: ge, value: ve };
        }
        var Ot = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 24 24", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("path", { d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7" })));
          } }]), se;
        }(O.a.PureComponent), Ct = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 24 24", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("path", { d: "M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z" })));
          } }]), se;
        }(O.a.PureComponent), Jt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]), de = yt(W).style;
            return O.a.createElement("span", te, O.a.createElement("svg", { fill: de.color, width: de.height, height: de.width, style: de, viewBox: "0 0 1792 1792" }, O.a.createElement("path", { d: "M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z" })));
          } }]), se;
        }(O.a.PureComponent), yn = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]), de = yt(W).style;
            return O.a.createElement("span", te, O.a.createElement("svg", { fill: de.color, width: de.height, height: de.width, style: de, viewBox: "0 0 1792 1792" }, O.a.createElement("path", { d: "M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z" })));
          } }]), se;
        }(O.a.PureComponent), vn = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", { style: c(c({}, yt(W).style), {}, { paddingLeft: "2px", verticalAlign: "top" }), viewBox: "0 0 15 15", fill: "currentColor" }, O.a.createElement("path", { d: "M0 14l6-6-6-6z" })));
          } }]), se;
        }(O.a.PureComponent), Re = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", { style: c(c({}, yt(W).style), {}, { paddingLeft: "2px", verticalAlign: "top" }), viewBox: "0 0 15 15", fill: "currentColor" }, O.a.createElement("path", { d: "M0 5l6 6 6-6z" })));
          } }]), se;
        }(O.a.PureComponent), _e = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z" }))));
          } }]), se;
        }(O.a.PureComponent), jt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), se;
        }(O.a.PureComponent), st = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), se;
        }(O.a.PureComponent), Mt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z" }))));
          } }]), se;
        }(O.a.PureComponent), lt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z" }))));
          } }]), se;
        }(O.a.PureComponent), xt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.style, te = T(P, ["style"]);
            return O.a.createElement("span", te, O.a.createElement("svg", Object.assign({}, yt(W), { viewBox: "0 0 40 40", fill: "currentColor", preserveAspectRatio: "xMidYMid meet" }), O.a.createElement("g", null, O.a.createElement("path", { d: "m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z" }))));
          } }]), se;
        }(O.a.PureComponent);
        function yt(ge) {
          return ge || (ge = {}), { style: c(c({ verticalAlign: "middle" }, ge), {}, { color: ge.color ? ge.color : "#000000", height: "1em", width: "1em" }) };
        }
        var ct = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).copiedTimer = null, W.handleCopy = function() {
              var te = document.createElement("textarea"), de = W.props, Ne = de.clickCallback, Me = de.src, Ge = de.namespace;
              te.innerHTML = JSON.stringify(W.clipboardValue(Me), null, "  "), document.body.appendChild(te), te.select(), document.execCommand("copy"), document.body.removeChild(te), W.copiedTimer = setTimeout(function() {
                W.setState({ copied: !1 });
              }, 5500), W.setState({ copied: !0 }, function() {
                typeof Ne == "function" && Ne({ src: Me, namespace: Ge, name: Ge[Ge.length - 1] });
              });
            }, W.getClippyIcon = function() {
              var te = W.props.theme;
              return W.state.copied ? O.a.createElement("span", null, O.a.createElement(_e, Object.assign({ className: "copy-icon" }, z(te, "copy-icon"))), O.a.createElement("span", z(te, "copy-icon-copied"), "✔")) : O.a.createElement(_e, Object.assign({ className: "copy-icon" }, z(te, "copy-icon")));
            }, W.clipboardValue = function(te) {
              switch (R(te)) {
                case "function":
                case "regexp":
                  return te.toString();
                default:
                  return te;
              }
            }, W.state = { copied: !1 }, W;
          }
          return f(se, [{ key: "componentWillUnmount", value: function() {
            this.copiedTimer && (clearTimeout(this.copiedTimer), this.copiedTimer = null);
          } }, { key: "render", value: function() {
            var P = this.props, W = (P.src, P.theme), te = P.hidden, de = P.rowHovered, Ne = z(W, "copy-to-clipboard").style, Me = "inline";
            return te && (Me = "none"), O.a.createElement("span", { className: "copy-to-clipboard-container", title: "Copy to clipboard", style: { verticalAlign: "top", display: de ? "inline-block" : "none" } }, O.a.createElement("span", { style: c(c({}, Ne), {}, { display: Me }), onClick: this.handleCopy }, this.getClippyIcon()));
          } }]), se;
        }(O.a.PureComponent), Rt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).getEditIcon = function() {
              var te = W.props, de = te.variable, Ne = te.theme;
              return O.a.createElement("div", { className: "click-to-edit", style: { verticalAlign: "top", display: W.state.hovered ? "inline-block" : "none" } }, O.a.createElement(lt, Object.assign({ className: "click-to-edit-icon" }, z(Ne, "editVarIcon"), { onClick: function() {
                W.prepopInput(de);
              } })));
            }, W.prepopInput = function(te) {
              if (W.props.onEdit !== !1) {
                var de = function(Me) {
                  var Ge;
                  switch (R(Me)) {
                    case "undefined":
                      Ge = "undefined";
                      break;
                    case "nan":
                      Ge = "NaN";
                      break;
                    case "string":
                      Ge = Me;
                      break;
                    case "date":
                    case "function":
                    case "regexp":
                      Ge = Me.toString();
                      break;
                    default:
                      try {
                        Ge = JSON.stringify(Me, null, "  ");
                      } catch {
                        Ge = "";
                      }
                  }
                  return Ge;
                }(te.value), Ne = Fe(de);
                W.setState({ editMode: !0, editValue: de, parsedInput: { type: Ne.type, value: Ne.value } });
              }
            }, W.getRemoveIcon = function() {
              var te = W.props, de = te.variable, Ne = te.namespace, Me = te.theme, Ge = te.rjvId;
              return O.a.createElement("div", { className: "click-to-remove", style: { verticalAlign: "top", display: W.state.hovered ? "inline-block" : "none" } }, O.a.createElement(jt, Object.assign({ className: "click-to-remove-icon" }, z(Me, "removeVarIcon"), { onClick: function() {
                J.dispatch({ name: "VARIABLE_REMOVED", rjvId: Ge, data: { name: de.name, namespace: Ne, existing_value: de.value, variable_removed: !0 } });
              } })));
            }, W.getValue = function(te, de) {
              var Ne = !de && te.type, Me = v(W).props;
              switch (Ne) {
                case !1:
                  return W.getEditInput();
                case "string":
                  return O.a.createElement(Ee, Object.assign({ value: te.value }, Me));
                case "integer":
                  return O.a.createElement(ee, Object.assign({ value: te.value }, Me));
                case "float":
                  return O.a.createElement(D, Object.assign({ value: te.value }, Me));
                case "boolean":
                  return O.a.createElement(I, Object.assign({ value: te.value }, Me));
                case "function":
                  return O.a.createElement(fe, Object.assign({ value: te.value }, Me));
                case "null":
                  return O.a.createElement(pe, Me);
                case "nan":
                  return O.a.createElement($, Me);
                case "undefined":
                  return O.a.createElement(Ve, Me);
                case "date":
                  return O.a.createElement(M, Object.assign({ value: te.value }, Me));
                case "regexp":
                  return O.a.createElement(Ce, Object.assign({ value: te.value }, Me));
                default:
                  return O.a.createElement("div", { className: "object-value" }, JSON.stringify(te.value));
              }
            }, W.getEditInput = function() {
              var te = W.props.theme, de = W.state.editValue;
              return O.a.createElement("div", null, O.a.createElement(Pe, Object.assign({ type: "text", inputRef: function(Ne) {
                return Ne && Ne.focus();
              }, value: de, className: "variable-editor", onChange: function(Ne) {
                var Me = Ne.target.value, Ge = Fe(Me);
                W.setState({ editValue: Me, parsedInput: { type: Ge.type, value: Ge.value } });
              }, onKeyDown: function(Ne) {
                switch (Ne.key) {
                  case "Escape":
                    W.setState({ editMode: !1, editValue: "" });
                    break;
                  case "Enter":
                    (Ne.ctrlKey || Ne.metaKey) && W.submitEdit(!0);
                }
                Ne.stopPropagation();
              }, placeholder: "update this value", minRows: 2 }, z(te, "edit-input"))), O.a.createElement("div", z(te, "edit-icon-container"), O.a.createElement(jt, Object.assign({ className: "edit-cancel" }, z(te, "cancel-icon"), { onClick: function() {
                W.setState({ editMode: !1, editValue: "" });
              } })), O.a.createElement(xt, Object.assign({ className: "edit-check string-value" }, z(te, "check-icon"), { onClick: function() {
                W.submitEdit();
              } })), O.a.createElement("div", null, W.showDetected())));
            }, W.submitEdit = function(te) {
              var de = W.props, Ne = de.variable, Me = de.namespace, Ge = de.rjvId, $t = W.state, In = $t.editValue, Qn = $t.parsedInput, yr = In;
              te && Qn.type && (yr = Qn.value), W.setState({ editMode: !1 }), J.dispatch({ name: "VARIABLE_UPDATED", rjvId: Ge, data: { name: Ne.name, namespace: Me, existing_value: Ne.value, new_value: yr, variable_removed: !1 } });
            }, W.showDetected = function() {
              var te = W.props, de = te.theme, Ne = (te.variable, te.namespace, te.rjvId, W.state.parsedInput), Me = (Ne.type, Ne.value, W.getDetectedInput());
              if (Me) return O.a.createElement("div", null, O.a.createElement("div", z(de, "detected-row"), Me, O.a.createElement(xt, { className: "edit-check detected", style: c({ verticalAlign: "top", paddingLeft: "3px" }, z(de, "check-icon").style), onClick: function() {
                W.submitEdit(!0);
              } })));
            }, W.getDetectedInput = function() {
              var te = W.state.parsedInput, de = te.type, Ne = te.value, Me = v(W).props, Ge = Me.theme;
              if (de !== !1) switch (de.toLowerCase()) {
                case "object":
                  return O.a.createElement("span", null, O.a.createElement("span", { style: c(c({}, z(Ge, "brace").style), {}, { cursor: "default" }) }, "{"), O.a.createElement("span", { style: c(c({}, z(Ge, "ellipsis").style), {}, { cursor: "default" }) }, "..."), O.a.createElement("span", { style: c(c({}, z(Ge, "brace").style), {}, { cursor: "default" }) }, "}"));
                case "array":
                  return O.a.createElement("span", null, O.a.createElement("span", { style: c(c({}, z(Ge, "brace").style), {}, { cursor: "default" }) }, "["), O.a.createElement("span", { style: c(c({}, z(Ge, "ellipsis").style), {}, { cursor: "default" }) }, "..."), O.a.createElement("span", { style: c(c({}, z(Ge, "brace").style), {}, { cursor: "default" }) }, "]"));
                case "string":
                  return O.a.createElement(Ee, Object.assign({ value: Ne }, Me));
                case "integer":
                  return O.a.createElement(ee, Object.assign({ value: Ne }, Me));
                case "float":
                  return O.a.createElement(D, Object.assign({ value: Ne }, Me));
                case "boolean":
                  return O.a.createElement(I, Object.assign({ value: Ne }, Me));
                case "function":
                  return O.a.createElement(fe, Object.assign({ value: Ne }, Me));
                case "null":
                  return O.a.createElement(pe, Me);
                case "nan":
                  return O.a.createElement($, Me);
                case "undefined":
                  return O.a.createElement(Ve, Me);
                case "date":
                  return O.a.createElement(M, Object.assign({ value: new Date(Ne) }, Me));
              }
            }, W.state = { editMode: !1, editValue: "", hovered: !1, renameKey: !1, parsedInput: { type: !1, value: null } }, W;
          }
          return f(se, [{ key: "render", value: function() {
            var P = this, W = this.props, te = W.variable, de = W.singleIndent, Ne = W.type, Me = W.theme, Ge = W.namespace, $t = W.indentWidth, In = W.enableClipboard, Qn = W.onEdit, yr = W.onDelete, Cn = W.onSelect, Ln = W.displayArrayKey, Lr = W.quotesOnKeys, bn = this.state.editMode;
            return O.a.createElement("div", Object.assign({}, z(Me, "objectKeyVal", { paddingLeft: $t * de }), { onMouseEnter: function() {
              return P.setState(c(c({}, P.state), {}, { hovered: !0 }));
            }, onMouseLeave: function() {
              return P.setState(c(c({}, P.state), {}, { hovered: !1 }));
            }, className: "variable-row", key: te.name }), Ne == "array" ? Ln ? O.a.createElement("span", Object.assign({}, z(Me, "array-key"), { key: te.name + "_" + Ge }), te.name, O.a.createElement("div", z(Me, "colon"), ":")) : null : O.a.createElement("span", null, O.a.createElement("span", Object.assign({}, z(Me, "object-name"), { className: "object-key", key: te.name + "_" + Ge }), !!Lr && O.a.createElement("span", { style: { verticalAlign: "top" } }, '"'), O.a.createElement("span", { style: { display: "inline-block" } }, te.name), !!Lr && O.a.createElement("span", { style: { verticalAlign: "top" } }, '"')), O.a.createElement("span", z(Me, "colon"), ":")), O.a.createElement("div", Object.assign({ className: "variable-value", onClick: Cn === !1 && Qn === !1 ? null : function(Cr) {
              var ro = H(Ge);
              (Cr.ctrlKey || Cr.metaKey) && Qn !== !1 ? P.prepopInput(te) : Cn !== !1 && (ro.shift(), Cn(c(c({}, te), {}, { namespace: ro })));
            } }, z(Me, "variableValue", { cursor: Cn === !1 ? "default" : "pointer" })), this.getValue(te, bn)), In ? O.a.createElement(ct, { rowHovered: this.state.hovered, hidden: bn, src: te.value, clickCallback: In, theme: Me, namespace: [].concat(H(Ge), [te.name]) }) : null, Qn !== !1 && bn == 0 ? this.getEditIcon() : null, yr !== !1 && bn == 0 ? this.getRemoveIcon() : null);
          } }]), se;
        }(O.a.PureComponent), Yt = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            var P;
            a(this, se);
            for (var W = arguments.length, te = new Array(W), de = 0; de < W; de++) te[de] = arguments[de];
            return (P = ve.call.apply(ve, [this].concat(te))).getObjectSize = function() {
              var Ne = P.props, Me = Ne.size, Ge = Ne.theme;
              if (Ne.displayObjectSize) return O.a.createElement("span", Object.assign({ className: "object-size" }, z(Ge, "object-size")), Me, " item", Me === 1 ? "" : "s");
            }, P.getAddAttribute = function(Ne) {
              var Me = P.props, Ge = Me.theme, $t = Me.namespace, In = Me.name, Qn = Me.src, yr = Me.rjvId, Cn = Me.depth;
              return O.a.createElement("span", { className: "click-to-add", style: { verticalAlign: "top", display: Ne ? "inline-block" : "none" } }, O.a.createElement(st, Object.assign({ className: "click-to-add-icon" }, z(Ge, "addVarIcon"), { onClick: function() {
                var Ln = { name: Cn > 0 ? In : null, namespace: $t.splice(0, $t.length - 1), existing_value: Qn, variable_removed: !1, key_name: null };
                R(Qn) === "object" ? J.dispatch({ name: "ADD_VARIABLE_KEY_REQUEST", rjvId: yr, data: Ln }) : J.dispatch({ name: "VARIABLE_ADDED", rjvId: yr, data: c(c({}, Ln), {}, { new_value: [].concat(H(Qn), [null]) }) });
              } })));
            }, P.getRemoveObject = function(Ne) {
              var Me = P.props, Ge = Me.theme, $t = (Me.hover, Me.namespace), In = Me.name, Qn = Me.src, yr = Me.rjvId;
              if ($t.length !== 1) return O.a.createElement("span", { className: "click-to-remove", style: { display: Ne ? "inline-block" : "none" } }, O.a.createElement(jt, Object.assign({ className: "click-to-remove-icon" }, z(Ge, "removeVarIcon"), { onClick: function() {
                J.dispatch({ name: "VARIABLE_REMOVED", rjvId: yr, data: { name: In, namespace: $t.splice(0, $t.length - 1), existing_value: Qn, variable_removed: !0 } });
              } })));
            }, P.render = function() {
              var Ne = P.props, Me = Ne.theme, Ge = Ne.onDelete, $t = Ne.onAdd, In = Ne.enableClipboard, Qn = Ne.src, yr = Ne.namespace, Cn = Ne.rowHovered;
              return O.a.createElement("div", Object.assign({}, z(Me, "object-meta-data"), { className: "object-meta-data", onClick: function(Ln) {
                Ln.stopPropagation();
              } }), P.getObjectSize(), In ? O.a.createElement(ct, { rowHovered: Cn, clickCallback: In, src: Qn, theme: Me, namespace: yr }) : null, $t !== !1 ? P.getAddAttribute(Cn) : null, Ge !== !1 ? P.getRemoveObject(Cn) : null);
            }, P;
          }
          return se;
        }(O.a.PureComponent);
        function Gt(ge) {
          var ve = ge.parent_type, se = ge.namespace, P = ge.quotesOnKeys, W = ge.theme, te = ge.jsvRoot, de = ge.name, Ne = ge.displayArrayKey, Me = ge.name ? ge.name : "";
          return !te || de !== !1 && de !== null ? ve == "array" ? Ne ? O.a.createElement("span", Object.assign({}, z(W, "array-key"), { key: se }), O.a.createElement("span", { className: "array-key" }, Me), O.a.createElement("span", z(W, "colon"), ":")) : O.a.createElement("span", null) : O.a.createElement("span", Object.assign({}, z(W, "object-name"), { key: se }), O.a.createElement("span", { className: "object-key" }, P && O.a.createElement("span", { style: { verticalAlign: "top" } }, '"'), O.a.createElement("span", null, Me), P && O.a.createElement("span", { style: { verticalAlign: "top" } }, '"')), O.a.createElement("span", z(W, "colon"), ":")) : O.a.createElement("span", null);
        }
        function hn(ge) {
          var ve = ge.theme;
          switch (ge.iconStyle) {
            case "triangle":
              return O.a.createElement(Re, Object.assign({}, z(ve, "expanded-icon"), { className: "expanded-icon" }));
            case "square":
              return O.a.createElement(Jt, Object.assign({}, z(ve, "expanded-icon"), { className: "expanded-icon" }));
            default:
              return O.a.createElement(Ot, Object.assign({}, z(ve, "expanded-icon"), { className: "expanded-icon" }));
          }
        }
        function en(ge) {
          var ve = ge.theme;
          switch (ge.iconStyle) {
            case "triangle":
              return O.a.createElement(vn, Object.assign({}, z(ve, "collapsed-icon"), { className: "collapsed-icon" }));
            case "square":
              return O.a.createElement(yn, Object.assign({}, z(ve, "collapsed-icon"), { className: "collapsed-icon" }));
            default:
              return O.a.createElement(Ct, Object.assign({}, z(ve, "collapsed-icon"), { className: "collapsed-icon" }));
          }
        }
        var Sn = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).toggleCollapsed = function(te) {
              var de = [];
              for (var Ne in W.state.expanded) de.push(W.state.expanded[Ne]);
              de[te] = !de[te], W.setState({ expanded: de });
            }, W.state = { expanded: [] }, W;
          }
          return f(se, [{ key: "getExpandedIcon", value: function(P) {
            var W = this.props, te = W.theme, de = W.iconStyle;
            return this.state.expanded[P] ? O.a.createElement(hn, { theme: te, iconStyle: de }) : O.a.createElement(en, { theme: te, iconStyle: de });
          } }, { key: "render", value: function() {
            var P = this, W = this.props, te = W.src, de = W.groupArraysAfterLength, Ne = (W.depth, W.name), Me = W.theme, Ge = W.jsvRoot, $t = W.namespace, In = (W.parent_type, T(W, ["src", "groupArraysAfterLength", "depth", "name", "theme", "jsvRoot", "namespace", "parent_type"])), Qn = 0, yr = 5 * this.props.indentWidth;
            Ge || (Qn = 5 * this.props.indentWidth);
            var Cn = de, Ln = Math.ceil(te.length / Cn);
            return O.a.createElement("div", Object.assign({ className: "object-key-val" }, z(Me, Ge ? "jsv-root" : "objectKeyVal", { paddingLeft: Qn })), O.a.createElement(Gt, this.props), O.a.createElement("span", null, O.a.createElement(Yt, Object.assign({ size: te.length }, this.props))), H(Array(Ln)).map(function(Lr, bn) {
              return O.a.createElement("div", Object.assign({ key: bn, className: "object-key-val array-group" }, z(Me, "objectKeyVal", { marginLeft: 6, paddingLeft: yr })), O.a.createElement("span", z(Me, "brace-row"), O.a.createElement("div", Object.assign({ className: "icon-container" }, z(Me, "icon-container"), { onClick: function(Cr) {
                P.toggleCollapsed(bn);
              } }), P.getExpandedIcon(bn)), P.state.expanded[bn] ? O.a.createElement(rr, Object.assign({ key: Ne + bn, depth: 0, name: !1, collapsed: !1, groupArraysAfterLength: Cn, index_offset: bn * Cn, src: te.slice(bn * Cn, bn * Cn + Cn), namespace: $t, type: "array", parent_type: "array_group", theme: Me }, In)) : O.a.createElement("span", Object.assign({}, z(Me, "brace"), { onClick: function(Cr) {
                P.toggleCollapsed(bn);
              }, className: "array-group-brace" }), "[", O.a.createElement("div", Object.assign({}, z(Me, "array-group-meta-data"), { className: "array-group-meta-data" }), O.a.createElement("span", Object.assign({ className: "object-size" }, z(Me, "object-size")), bn * Cn, " - ", bn * Cn + Cn > te.length ? te.length : bn * Cn + Cn)), "]")));
            }));
          } }]), se;
        }(O.a.PureComponent), Ar = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            a(this, se), (W = ve.call(this, P)).toggleCollapsed = function() {
              W.setState({ expanded: !W.state.expanded }, function() {
                ce.set(W.props.rjvId, W.props.namespace, "expanded", W.state.expanded);
              });
            }, W.getObjectContent = function(de, Ne, Me) {
              return O.a.createElement("div", { className: "pushed-content object-container" }, O.a.createElement("div", Object.assign({ className: "object-content" }, z(W.props.theme, "pushed-content")), W.renderObjectContents(Ne, Me)));
            }, W.getEllipsis = function() {
              return W.state.size === 0 ? null : O.a.createElement("div", Object.assign({}, z(W.props.theme, "ellipsis"), { className: "node-ellipsis", onClick: W.toggleCollapsed }), "...");
            }, W.getObjectMetaData = function(de) {
              var Ne = W.props, Me = (Ne.rjvId, Ne.theme, W.state), Ge = Me.size, $t = Me.hovered;
              return O.a.createElement(Yt, Object.assign({ rowHovered: $t, size: Ge }, W.props));
            }, W.renderObjectContents = function(de, Ne) {
              var Me, Ge = W.props, $t = Ge.depth, In = Ge.parent_type, Qn = Ge.index_offset, yr = Ge.groupArraysAfterLength, Cn = Ge.namespace, Ln = W.state.object_type, Lr = [], bn = Object.keys(de || {});
              return W.props.sortKeys && Ln !== "array" && (bn = bn.sort()), bn.forEach(function(Cr) {
                if (Me = new or(Cr, de[Cr]), In === "array_group" && Qn && (Me.name = parseInt(Me.name) + Qn), de.hasOwnProperty(Cr)) if (Me.type === "object") Lr.push(O.a.createElement(rr, Object.assign({ key: Me.name, depth: $t + 1, name: Me.name, src: Me.value, namespace: Cn.concat(Me.name), parent_type: Ln }, Ne)));
                else if (Me.type === "array") {
                  var ro = rr;
                  yr && Me.value.length > yr && (ro = Sn), Lr.push(O.a.createElement(ro, Object.assign({ key: Me.name, depth: $t + 1, name: Me.name, src: Me.value, namespace: Cn.concat(Me.name), type: "array", parent_type: Ln }, Ne)));
                } else Lr.push(O.a.createElement(Rt, Object.assign({ key: Me.name + "_" + Cn, variable: Me, singleIndent: 5, namespace: Cn, type: W.props.type }, Ne)));
              }), Lr;
            };
            var te = se.getState(P);
            return W.state = c(c({}, te), {}, { prevProps: {} }), W;
          }
          return f(se, [{ key: "getBraceStart", value: function(P, W) {
            var te = this, de = this.props, Ne = de.src, Me = de.theme, Ge = de.iconStyle;
            if (de.parent_type === "array_group") return O.a.createElement("span", null, O.a.createElement("span", z(Me, "brace"), P === "array" ? "[" : "{"), W ? this.getObjectMetaData(Ne) : null);
            var $t = W ? hn : en;
            return O.a.createElement("span", null, O.a.createElement("span", Object.assign({ onClick: function(In) {
              te.toggleCollapsed();
            } }, z(Me, "brace-row")), O.a.createElement("div", Object.assign({ className: "icon-container" }, z(Me, "icon-container")), O.a.createElement($t, { theme: Me, iconStyle: Ge })), O.a.createElement(Gt, this.props), O.a.createElement("span", z(Me, "brace"), P === "array" ? "[" : "{")), W ? this.getObjectMetaData(Ne) : null);
          } }, { key: "render", value: function() {
            var P = this, W = this.props, te = W.depth, de = W.src, Ne = (W.namespace, W.name, W.type, W.parent_type), Me = W.theme, Ge = W.jsvRoot, $t = W.iconStyle, In = T(W, ["depth", "src", "namespace", "name", "type", "parent_type", "theme", "jsvRoot", "iconStyle"]), Qn = this.state, yr = Qn.object_type, Cn = Qn.expanded, Ln = {};
            return Ge || Ne === "array_group" ? Ne === "array_group" && (Ln.borderLeft = 0, Ln.display = "inline") : Ln.paddingLeft = 5 * this.props.indentWidth, O.a.createElement("div", Object.assign({ className: "object-key-val", onMouseEnter: function() {
              return P.setState(c(c({}, P.state), {}, { hovered: !0 }));
            }, onMouseLeave: function() {
              return P.setState(c(c({}, P.state), {}, { hovered: !1 }));
            } }, z(Me, Ge ? "jsv-root" : "objectKeyVal", Ln)), this.getBraceStart(yr, Cn), Cn ? this.getObjectContent(te, de, c({ theme: Me, iconStyle: $t }, In)) : this.getEllipsis(), O.a.createElement("span", { className: "brace-row" }, O.a.createElement("span", { style: c(c({}, z(Me, "brace").style), {}, { paddingLeft: Cn ? "3px" : "0px" }) }, yr === "array" ? "]" : "}"), Cn ? null : this.getObjectMetaData(de)));
          } }], [{ key: "getDerivedStateFromProps", value: function(P, W) {
            var te = W.prevProps;
            return P.src !== te.src || P.collapsed !== te.collapsed || P.name !== te.name || P.namespace !== te.namespace || P.rjvId !== te.rjvId ? c(c({}, se.getState(P)), {}, { prevProps: P }) : null;
          } }]), se;
        }(O.a.PureComponent);
        Ar.getState = function(ge) {
          var ve = Object.keys(ge.src).length, se = (ge.collapsed === !1 || ge.collapsed !== !0 && ge.collapsed > ge.depth) && (!ge.shouldCollapse || ge.shouldCollapse({ name: ge.name, src: ge.src, type: R(ge.src), namespace: ge.namespace }) === !1) && ve !== 0;
          return { expanded: ce.get(ge.rjvId, ge.namespace, "expanded", se), object_type: ge.type === "array" ? "array" : "object", parent_type: ge.type === "array" ? "array" : "object", size: ve, hovered: !1 };
        };
        var or = function ge(ve, se) {
          a(this, ge), this.name = ve, this.value = se, this.type = R(se);
        };
        k(Ar);
        var rr = Ar, no = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            var P;
            a(this, se);
            for (var W = arguments.length, te = new Array(W), de = 0; de < W; de++) te[de] = arguments[de];
            return (P = ve.call.apply(ve, [this].concat(te))).render = function() {
              var Ne = v(P).props, Me = [Ne.name], Ge = rr;
              return Array.isArray(Ne.src) && Ne.groupArraysAfterLength && Ne.src.length > Ne.groupArraysAfterLength && (Ge = Sn), O.a.createElement("div", { className: "pretty-json-container object-container" }, O.a.createElement("div", { className: "object-content" }, O.a.createElement(Ge, Object.assign({ namespace: Me, depth: 0, jsvRoot: !0 }, Ne))));
            }, P;
          }
          return se;
        }(O.a.PureComponent), jn = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).closeModal = function() {
              J.dispatch({ rjvId: W.props.rjvId, name: "RESET" });
            }, W.submit = function() {
              W.props.submit(W.state.input);
            }, W.state = { input: P.input ? P.input : "" }, W;
          }
          return f(se, [{ key: "render", value: function() {
            var P = this, W = this.props, te = W.theme, de = W.rjvId, Ne = W.isValid, Me = this.state.input, Ge = Ne(Me);
            return O.a.createElement("div", Object.assign({ className: "key-modal-request" }, z(te, "key-modal-request"), { onClick: this.closeModal }), O.a.createElement("div", Object.assign({}, z(te, "key-modal"), { onClick: function($t) {
              $t.stopPropagation();
            } }), O.a.createElement("div", z(te, "key-modal-label"), "Key Name:"), O.a.createElement("div", { style: { position: "relative" } }, O.a.createElement("input", Object.assign({}, z(te, "key-modal-input"), { className: "key-modal-input", ref: function($t) {
              return $t && $t.focus();
            }, spellCheck: !1, value: Me, placeholder: "...", onChange: function($t) {
              P.setState({ input: $t.target.value });
            }, onKeyPress: function($t) {
              Ge && $t.key === "Enter" ? P.submit() : $t.key === "Escape" && P.closeModal();
            } })), Ge ? O.a.createElement(xt, Object.assign({}, z(te, "key-modal-submit"), { className: "key-modal-submit", onClick: function($t) {
              return P.submit();
            } })) : null), O.a.createElement("span", z(te, "key-modal-cancel"), O.a.createElement(Mt, Object.assign({}, z(te, "key-modal-cancel-icon"), { className: "key-modal-cancel", onClick: function() {
              J.dispatch({ rjvId: de, name: "RESET" });
            } })))));
          } }]), se;
        }(O.a.PureComponent), Xi = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            var P;
            a(this, se);
            for (var W = arguments.length, te = new Array(W), de = 0; de < W; de++) te[de] = arguments[de];
            return (P = ve.call.apply(ve, [this].concat(te))).isValid = function(Ne) {
              var Me = P.props.rjvId, Ge = ce.get(Me, "action", "new-key-request");
              return Ne != "" && Object.keys(Ge.existing_value).indexOf(Ne) === -1;
            }, P.submit = function(Ne) {
              var Me = P.props.rjvId, Ge = ce.get(Me, "action", "new-key-request");
              Ge.new_value = c({}, Ge.existing_value), Ge.new_value[Ne] = P.props.defaultValue, J.dispatch({ name: "VARIABLE_ADDED", rjvId: Me, data: Ge });
            }, P;
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.active, te = P.theme, de = P.rjvId;
            return W ? O.a.createElement(jn, { rjvId: de, theme: te, isValid: this.isValid, submit: this.submit }) : null;
          } }]), se;
        }(O.a.PureComponent), us = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se() {
            return a(this, se), ve.apply(this, arguments);
          }
          return f(se, [{ key: "render", value: function() {
            var P = this.props, W = P.message, te = P.active, de = P.theme, Ne = P.rjvId;
            return te ? O.a.createElement("div", Object.assign({ className: "validation-failure" }, z(de, "validation-failure"), { onClick: function() {
              J.dispatch({ rjvId: Ne, name: "RESET" });
            } }), O.a.createElement("span", z(de, "validation-failure-label"), W), O.a.createElement(Mt, z(de, "validation-failure-clear"))) : null;
          } }]), se;
        }(O.a.PureComponent), ca = function(ge) {
          p(se, ge);
          var ve = A(se);
          function se(P) {
            var W;
            return a(this, se), (W = ve.call(this, P)).rjvId = Date.now().toString(), W.getListeners = function() {
              return { reset: W.resetState, "variable-update": W.updateSrc, "add-key-request": W.addKeyRequest };
            }, W.updateSrc = function() {
              var te, de = ce.get(W.rjvId, "action", "variable-update"), Ne = de.name, Me = de.namespace, Ge = de.new_value, $t = de.existing_value, In = (de.variable_removed, de.updated_src), Qn = de.type, yr = W.props, Cn = yr.onEdit, Ln = yr.onDelete, Lr = yr.onAdd, bn = { existing_src: W.state.src, new_value: Ge, updated_src: In, name: Ne, namespace: Me, existing_value: $t };
              switch (Qn) {
                case "variable-added":
                  te = Lr(bn);
                  break;
                case "variable-edited":
                  te = Cn(bn);
                  break;
                case "variable-removed":
                  te = Ln(bn);
              }
              te !== !1 ? (ce.set(W.rjvId, "global", "src", In), W.setState({ src: In })) : W.setState({ validationFailure: !0 });
            }, W.addKeyRequest = function() {
              W.setState({ addKeyRequest: !0 });
            }, W.resetState = function() {
              W.setState({ validationFailure: !1, addKeyRequest: !1 });
            }, W.state = { addKeyRequest: !1, editKeyRequest: !1, validationFailure: !1, src: se.defaultProps.src, name: se.defaultProps.name, theme: se.defaultProps.theme, validationMessage: se.defaultProps.validationMessage, prevSrc: se.defaultProps.src, prevName: se.defaultProps.name, prevTheme: se.defaultProps.theme }, W;
          }
          return f(se, [{ key: "componentDidMount", value: function() {
            ce.set(this.rjvId, "global", "src", this.state.src);
            var P = this.getListeners();
            for (var W in P) ce.on(W + "-" + this.rjvId, P[W]);
            this.setState({ addKeyRequest: !1, editKeyRequest: !1 });
          } }, { key: "componentDidUpdate", value: function(P, W) {
            W.addKeyRequest !== !1 && this.setState({ addKeyRequest: !1 }), W.editKeyRequest !== !1 && this.setState({ editKeyRequest: !1 }), P.src !== this.state.src && ce.set(this.rjvId, "global", "src", this.state.src);
          } }, { key: "componentWillUnmount", value: function() {
            var P = this.getListeners();
            for (var W in P) ce.removeListener(W + "-" + this.rjvId, P[W]);
          } }, { key: "render", value: function() {
            var P = this.state, W = P.validationFailure, te = P.validationMessage, de = P.addKeyRequest, Ne = P.theme, Me = P.src, Ge = P.name, $t = this.props, In = $t.style, Qn = $t.defaultValue;
            return O.a.createElement("div", { className: "react-json-view", style: c(c({}, z(Ne, "app-container").style), In) }, O.a.createElement(us, { message: te, active: W, theme: Ne, rjvId: this.rjvId }), O.a.createElement(no, Object.assign({}, this.props, { src: Me, name: Ge, theme: Ne, type: R(Me), rjvId: this.rjvId })), O.a.createElement(Xi, { active: de, theme: Ne, rjvId: this.rjvId, defaultValue: Qn }));
          } }], [{ key: "getDerivedStateFromProps", value: function(P, W) {
            if (P.src !== W.prevSrc || P.name !== W.prevName || P.theme !== W.prevTheme) {
              var te = { src: P.src, name: P.name, theme: P.theme, validationMessage: P.validationMessage, prevSrc: P.src, prevName: P.name, prevTheme: P.theme };
              return se.validateState(te);
            }
            return null;
          } }]), se;
        }(O.a.PureComponent);
        ca.defaultProps = { src: {}, name: "root", theme: "rjv-default", collapsed: !1, collapseStringsAfterLength: !1, shouldCollapse: !1, sortKeys: !1, quotesOnKeys: !0, groupArraysAfterLength: 100, indentWidth: 4, enableClipboard: !0, displayObjectSize: !0, displayDataTypes: !0, onEdit: !1, onDelete: !1, onAdd: !1, onSelect: !1, iconStyle: "triangle", style: {}, validationMessage: "Validation Error", defaultValue: null, displayArrayKey: !0 }, ca.validateState = function(ge) {
          var ve = {};
          return R(ge.theme) !== "object" || function(se) {
            var P = ["base00", "base01", "base02", "base03", "base04", "base05", "base06", "base07", "base08", "base09", "base0A", "base0B", "base0C", "base0D", "base0E", "base0F"];
            if (R(se) === "object") {
              for (var W = 0; W < P.length; W++) if (!(P[W] in se)) return !1;
              return !0;
            }
            return !1;
          }(ge.theme) || (console.error("react-json-view error:", "theme prop must be a theme name or valid base-16 theme object.", 'defaulting to "rjv-default" theme'), ve.theme = "rjv-default"), R(ge.src) !== "object" && R(ge.src) !== "array" && (console.error("react-json-view error:", "src property must be a valid json object"), ve.name = "ERROR", ve.src = { message: "src property must be a valid json object" }), c(c({}, ge), ve);
        }, k(ca), i.default = ca;
      }]);
    });
  }(CM)), CM.exports;
}
var Jen = Yen();
const z6e = /* @__PURE__ */ Sl(Jen), FV = ({ fileUrl: e, handleDownloadFile: t }) => {
  const n = e.includes("file://");
  return /* @__PURE__ */ y("div", { className: "flex items-center gap-0", children: /* @__PURE__ */ V(
    Qe,
    {
      variant: "ghost",
      size: "sm",
      disabled: n,
      onClick: () => t(e),
      className: "flex items-center gap-2 p-2 max-h-[20px] text-xs",
      children: [
        n ? /* @__PURE__ */ y(Pit, { className: "w-4 h-4" }) : /* @__PURE__ */ y(NT, { className: "w-4 h-4" }),
        Z("Download File")
      ]
    }
  ) });
}, etn = (e) => e.startsWith('"') && e.endsWith('"') ? e.slice(1, -1) : e, S7 = (e) => Array.isArray(e) ? e.map(S7) : typeof e == "object" && e !== null ? Object.fromEntries(
  Object.entries(e).filter(([t, n]) => n !== void 0).map(([t, n]) => [t, S7(n)])
) : e, Hp = ie.memo(
  ({
    json: e,
    title: t,
    hideDownload: n = !1,
    className: r
  }) => {
    const { theme: i } = Jw(), o = Kt(() => S7(e), [e]), s = i === "dark" ? "bright" : "rjv-default", l = () => {
      navigator.clipboard.writeText(JSON.stringify(o, null, 2)), vr.success(Z("Copied to clipboard"), {
        duration: 1e3
      });
    }, c = () => {
      const u = new Blob([JSON.stringify(o, null, 2)], {
        type: "application/json"
      }), f = URL.createObjectURL(u);
      a(f);
    }, a = (u, f = "") => {
      const d = document.createElement("a");
      d.href = u, d.download = `${t}${f}`, d.click(), URL.revokeObjectURL(u);
    };
    return Og(() => {
      typeof o == "object" && Array.from(
        document.getElementsByClassName("string-value")
      ).filter(
        (d) => {
          var p;
          return e6(d.innerHTML) || e6((p = d.parentElement.nextElementSibling) == null ? void 0 : p.innerHTML);
        }
      ).forEach((d) => {
        const p = etn(d.innerHTML).trim().replace(`
`, "");
        d.className += " hidden";
        const h = document.createElement("div"), m = _5e.createRoot(h);
        d.parentElement.replaceChildren(d, h);
        const v = p.includes("file://");
        m.render(
          /* @__PURE__ */ y("div", { "data-file-root": "true", children: v ? /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ V(wn, { children: [
            /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
              FV,
              {
                fileUrl: p,
                handleDownloadFile: a
              }
            ) }),
            /* @__PURE__ */ y(An, { side: "right", children: Z("File is not available after execution.") })
          ] }) }) : /* @__PURE__ */ y(
            FV,
            {
              fileUrl: p,
              handleDownloadFile: a
            }
          ) })
        );
      });
    }), e6(o) ? /* @__PURE__ */ y(FV, { fileUrl: o, handleDownloadFile: a }) : /* @__PURE__ */ V(
      "div",
      {
        className: Se(
          "rounded-lg border border-solid border-dividers overflow-hidden relative",
          r
        ),
        children: [
          /* @__PURE__ */ V("div", { className: "px-3 py-2 flex border-solid border-b border-dividers justify-center items-center", children: [
            /* @__PURE__ */ y("div", { className: "grow justify-center items-center", children: /* @__PURE__ */ y("span", { className: "text-md", children: t }) }),
            /* @__PURE__ */ V("div", { className: "flex items-center gap-0", children: [
              !n && /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ V(wn, { children: [
                /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                  Qe,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: c,
                    children: /* @__PURE__ */ y(mz, { className: "w-4 h-4" })
                  }
                ) }),
                /* @__PURE__ */ y(An, { side: "bottom", children: Z("Download JSON") })
              ] }) }),
              /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ V(wn, { children: [
                /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "ghost", size: "sm", onClick: l, children: /* @__PURE__ */ y(Cv, { className: "w-4 h-4" }) }) }),
                /* @__PURE__ */ y(An, { side: "bottom", children: Z("Copy to clipboard") })
              ] }) })
            ] })
          ] }),
          /* @__PURE__ */ y(pt, { children: De(o) ? /* @__PURE__ */ y("pre", { className: "text-sm whitespace-pre-wrap overflow-x-auto p-2", children: o === null ? "null" : "undefined" }) : /* @__PURE__ */ V(pt, { children: [
            typeof o != "string" && typeof o != "object" && /* @__PURE__ */ y("pre", { className: "text-sm whitespace-pre-wrap  break-all overflow-x-auto p-2", children: JSON.stringify(o) }),
            typeof o == "string" && /* @__PURE__ */ y("pre", { className: "text-sm whitespace-pre-wrap break-all overflow-x-auto p-2", children: o }),
            typeof o == "object" && /* @__PURE__ */ y("div", { className: "max-w-full", children: /* @__PURE__ */ y(
              z6e,
              {
                style: {
                  overflowX: "auto",
                  padding: "0.5rem",
                  wordBreak: "break-word"
                },
                theme: s,
                enableClipboard: !1,
                groupArraysAfterLength: 20,
                displayDataTypes: !1,
                name: !1,
                quotesOnKeys: !1,
                src: o
              }
            ) })
          ] }) })
        ]
      }
    );
  }
);
Hp.displayName = "JsonViewer";
function ttn(e) {
  Xze(e, [/\r?\n|\r/g, ntn]);
}
function ntn() {
  return { type: "break" };
}
function rtn() {
  return function(e) {
    ttn(e);
  };
}
function itn(e, t) {
  if (typeof e != "string")
    return "";
  let n = e.split("<br>").join(`
`);
  return n = n.replace(/\{\{(.*?)\}\}/g, (r, i) => t[i] ?? ""), n;
}
const Xhe = ({
  variant: e,
  children: t
}) => /* @__PURE__ */ V(
  h3,
  {
    className: Se("rounded-md border", {
      "dark:bg-amber-950 bg-amber-50  border-none dark:text-amber-600 text-amber-700": e === gs.WARNING,
      "bg-success-100 text-success-300 border-none": e === gs.TIP,
      "p-0 bg-transparent border-none": e === gs.BORDERLESS
    }),
    children: [
      e !== gs.BORDERLESS && /* @__PURE__ */ V(pt, { children: [
        (e === gs.INFO || e === void 0) && /* @__PURE__ */ y(QA, { className: "w-4 h-4 mt-1" }),
        e === gs.WARNING && /* @__PURE__ */ y(gz, { className: "w-4 h-4 mt-1 stroke-amber-700" }),
        e === gs.TIP && /* @__PURE__ */ y(sot, { className: "w-4 h-4 mt-1" })
      ] }),
      /* @__PURE__ */ y(m3, { className: "grow w-full", children: t })
    ]
  }
), uu = ie.memo(
  ({ markdown: e, variables: t, variant: n, className: r, loading: i }) => {
    const [o, s] = He(null), { mutate: l } = dr({
      mutationFn: async (a) => {
        await navigator.clipboard.writeText(a), s(a), await new Promise((u) => setTimeout(u, 1e3)), s(null);
      },
      onError: () => {
        vr.error(Z("Failed to copy to clipboard"), {
          duration: 3e3
        });
      }
    });
    if (i && i.length > 0)
      return /* @__PURE__ */ y(Xhe, { variant: n, children: /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: i }) });
    if (!e)
      return null;
    const c = itn(e, t ?? {});
    return /* @__PURE__ */ y(Xhe, { variant: n, children: /* @__PURE__ */ y(
      Bze,
      {
        className: Se("grow w-full ", r),
        remarkPlugins: [hje, rtn],
        components: {
          code(a) {
            var p;
            if (!((p = a.className) == null ? void 0 : p.includes("language-text")))
              return /* @__PURE__ */ y("code", { ...a, className: "text-wrap" });
            const f = String(a.children).trim();
            return /* @__PURE__ */ V("div", { className: "relative w-full items-center flex bg-background border border-solid text-sm rounded block w-full gap-1 p-1.5", children: [
              /* @__PURE__ */ y(
                "input",
                {
                  type: "text",
                  className: "grow bg-background",
                  value: f,
                  disabled: !0
                }
              ),
              /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  className: "bg-background rounded p-2 inline-flex items-center justify-center h-8",
                  onClick: () => l(f),
                  children: f === o ? /* @__PURE__ */ y(Af, { className: "w-3 h-3" }) : /* @__PURE__ */ y(Cv, { className: "w-3 h-3" })
                }
              )
            ] });
          },
          h1: ({ node: a, ...u }) => /* @__PURE__ */ y(
            "h1",
            {
              className: "scroll-m-20 text-xl font-extrabold tracking-tight lg:text-3xl",
              ...u
            }
          ),
          h2: ({ node: a, ...u }) => /* @__PURE__ */ y(
            "h2",
            {
              className: "scroll-m-20 text-lg text-xl font-semibold tracking-tight first:mt-0",
              ...u
            }
          ),
          h3: ({ node: a, ...u }) => /* @__PURE__ */ y(
            "h3",
            {
              className: "scroll-m-20 text-lg font-semibold tracking-tight",
              ...u
            }
          ),
          p: ({ node: a, ...u }) => /* @__PURE__ */ y("p", { className: "leading-7 not-first:mt-2 w-full", ...u }),
          ul: ({ node: a, ...u }) => /* @__PURE__ */ y("ul", { className: "mt-4 ml-6 list-disc [&>li]:mt-2", ...u }),
          ol: ({ node: a, ...u }) => /* @__PURE__ */ y("ol", { className: "mt-4 ml-6 list-decimal [&>li]:mt-2", ...u }),
          li: ({ node: a, ...u }) => /* @__PURE__ */ y("li", { ...u }),
          a: ({ node: a, ...u }) => /* @__PURE__ */ y(
            "a",
            {
              className: "font-medium text-primary underline underline-offset-4",
              target: "_blank",
              rel: "noreferrer noopener",
              ...u
            }
          ),
          blockquote: ({ node: a, ...u }) => /* @__PURE__ */ y(
            "blockquote",
            {
              className: "mt-4 first:mt-0 border-l-2 pl-6 italic",
              ...u
            }
          ),
          hr: ({ node: a, ...u }) => /* @__PURE__ */ y("hr", { className: "my-4 border-t border-border/50", ...u }),
          img: ({ node: a, ...u }) => /* @__PURE__ */ y("img", { className: "my-8", ...u }),
          b: ({ node: a, ...u }) => /* @__PURE__ */ y("b", { ...u }),
          em: ({ node: a, ...u }) => /* @__PURE__ */ y("em", { ...u }),
          table: ({ node: a, ...u }) => /* @__PURE__ */ y("table", { className: "w-full my-4 border-collapse", ...u }),
          thead: ({ node: a, ...u }) => /* @__PURE__ */ y("thead", { className: "bg-muted", ...u }),
          tr: ({ node: a, ...u }) => /* @__PURE__ */ y("tr", { className: "border-b border-border", ...u }),
          th: ({ node: a, ...u }) => /* @__PURE__ */ y("th", { className: "text-left p-2 font-medium", ...u }),
          td: ({ node: a, ...u }) => /* @__PURE__ */ y("td", { className: "p-2", ...u })
        },
        children: c.trim()
      }
    ) });
  }
);
uu.displayName = "ApMarkdown";
function otn(e) {
  return Array.isArray(e) ? e.join(", ") : e == null ? "" : typeof e == "object" ? JSON.stringify(e) : String(e);
}
const stn = ({
  data: e = {},
  className: t = ""
}) => {
  const n = Object.entries(e).filter(
    ([r, i]) => i != null
  );
  return n.length === 0 ? /* @__PURE__ */ y("div", { className: `text-sm text-muted-foreground italic ${t}`, children: "No data available" }) : /* @__PURE__ */ y(
    "dl",
    {
      className: `grid gap-y-2 text-sm leading-relaxed ${t}`,
      style: { wordBreak: "break-word" },
      children: n.map(([r, i]) => /* @__PURE__ */ V(
        "div",
        {
          className: "grid grid-cols-[auto_1fr] gap-x-3 items-start",
          children: [
            /* @__PURE__ */ y("dt", { className: "font-medium text-muted-foreground capitalize", children: r }),
            /* @__PURE__ */ y("dd", { className: "text-primary", children: otn(i) })
          ]
        },
        r
      ))
    }
  );
}, atn = ({
  data: e,
  readOnly: t = !0,
  hideCopyButton: n = !1,
  maxHeight: r = 400
}) => {
  const [i, o] = He(!1), { theme: s } = Jw(), l = typeof e == "string" ? e : JSON.stringify(e, null, 2), c = () => {
    navigator.clipboard.writeText(l), o(!0), vr.success(Z("Copied to clipboard"), {
      duration: 1e3
    }), setTimeout(() => {
      o(!1);
    }, 3e3);
  }, a = s === "dark" ? "bright" : "rjv-default";
  return /* @__PURE__ */ V(
    "div",
    {
      className: "w-full relative text-foreground overflow-hidden",
      style: {
        maxWidth: "100%"
      },
      children: [
        !n && /* @__PURE__ */ y("div", { className: "absolute top-2 right-5 z-10", children: /* @__PURE__ */ y(
          Qe,
          {
            variant: "transparent",
            size: "sm",
            onClick: c,
            className: "p-0 ",
            children: i ? /* @__PURE__ */ y(Af, { className: "w-4 h-4 text-green-500" }) : /* @__PURE__ */ y(
              Cv,
              {
                className: `w-4 h-4 ${s === "dark" ? "text-white" : "text-black"}`
              }
            )
          }
        ) }),
        /* @__PURE__ */ y(
          "div",
          {
            className: "p-2",
            style: {
              maxHeight: typeof r == "number" ? `${r}px` : "400px",
              overflow: "auto",
              overflowX: "auto",
              width: "100%",
              boxSizing: "border-box"
            },
            children: typeof e == "string" ? /* @__PURE__ */ y("pre", { className: "text-sm whitespace-pre-wrap break-all overflow-x-auto p-2", children: e }) : /* @__PURE__ */ y("div", { style: { minWidth: 0, width: "100%", height: "100%" }, children: /* @__PURE__ */ y(
              z6e,
              {
                style: {
                  overflowX: "auto",
                  padding: "0.5rem",
                  fontSize: "14px",
                  width: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap"
                },
                theme: a,
                enableClipboard: !1,
                groupArraysAfterLength: 20,
                displayDataTypes: !1,
                name: !1,
                quotesOnKeys: !1,
                src: e,
                collapsed: !1,
                displayObjectSize: !1,
                iconStyle: "triangle",
                shouldCollapse: !1,
                onEdit: t ? !1 : void 0,
                onAdd: t ? !1 : void 0,
                onDelete: t ? !1 : void 0
              }
            ) })
          }
        )
      ]
    }
  );
};
// @__NO_SIDE_EFFECTS__
function E7(e) {
  const t = /* @__PURE__ */ ltn(e), n = N.forwardRef((r, i) => {
    const { children: o, ...s } = r, l = N.Children.toArray(o), c = l.find(utn);
    if (c) {
      const a = c.props.children, u = l.map((f) => f === c ? N.Children.count(a) > 1 ? N.Children.only(null) : N.isValidElement(a) ? a.props.children : null : f);
      return /* @__PURE__ */ y(t, { ...s, ref: i, children: N.isValidElement(a) ? N.cloneElement(a, void 0, u) : null });
    }
    return /* @__PURE__ */ y(t, { ...s, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function ltn(e) {
  const t = N.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (N.isValidElement(i)) {
      const s = ftn(i), l = dtn(o, i.props);
      return i.type !== N.Fragment && (l.ref = r ? sg(r, s) : s), N.cloneElement(i, l);
    }
    return N.Children.count(i) > 1 ? N.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ctn = Symbol("radix.slottable");
function utn(e) {
  return N.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ctn;
}
function dtn(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...l) => {
      o(...l), i(...l);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ftn(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ptn(e) {
  const t = e + "CollectionProvider", [n, r] = Tx(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (m) => {
    const { scope: v, children: b } = m, A = ie.useRef(null), w = ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y(i, { scope: v, itemMap: w, collectionRef: A, children: b });
  };
  s.displayName = t;
  const l = e + "CollectionSlot", c = /* @__PURE__ */ E7(l), a = ie.forwardRef(
    (m, v) => {
      const { scope: b, children: A } = m, w = o(l, b), O = ja(v, w.collectionRef);
      return /* @__PURE__ */ y(c, { ref: O, children: A });
    }
  );
  a.displayName = l;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", d = /* @__PURE__ */ E7(u), p = ie.forwardRef(
    (m, v) => {
      const { scope: b, children: A, ...w } = m, O = ie.useRef(null), x = ja(v, O), S = o(u, b);
      return ie.useEffect(() => (S.itemMap.set(O, { ref: O, ...w }), () => void S.itemMap.delete(O))), /* @__PURE__ */ y(d, { [f]: "", ref: x, children: A });
    }
  );
  p.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return ie.useCallback(() => {
      const A = v.collectionRef.current;
      if (!A) return [];
      const w = Array.from(A.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, E) => w.indexOf(S.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: a, ItemSlot: p },
    h,
    r
  ];
}
function j6e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function OJ({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = htn({ defaultProp: t, onChange: n }), o = e !== void 0, s = o ? e : r, l = ag(n), c = N.useCallback(
    (a) => {
      if (o) {
        const f = typeof a == "function" ? a(e) : a;
        f !== e && l(f);
      } else
        i(a);
    },
    [o, e, i, l]
  );
  return [s, c];
}
function htn({
  defaultProp: e,
  onChange: t
}) {
  const n = N.useState(e), [r] = n, i = N.useRef(r), o = ag(t);
  return N.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var mtn = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $N = mtn.reduce((e, t) => {
  const n = /* @__PURE__ */ E7(`Primitive.${t}`), r = N.forwardRef((i, o) => {
    const { asChild: s, ...l } = i, c = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(c, { ...l, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function gtn(e, t) {
  return N.useReducer((n, r) => t[n][r] ?? n, e);
}
var F6e = (e) => {
  const { present: t, children: n } = e, r = ytn(t), i = typeof n == "function" ? n({ present: r.isPresent }) : N.Children.only(n), o = ja(r.ref, vtn(i));
  return typeof n == "function" || r.isPresent ? N.cloneElement(i, { ref: o }) : null;
};
F6e.displayName = "Presence";
function ytn(e) {
  const [t, n] = N.useState(), r = N.useRef({}), i = N.useRef(e), o = N.useRef("none"), s = e ? "mounted" : "unmounted", [l, c] = gtn(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return N.useEffect(() => {
    const a = pR(r.current);
    o.current = l === "mounted" ? a : "none";
  }, [l]), rd(() => {
    const a = r.current, u = i.current;
    if (u !== e) {
      const d = o.current, p = pR(a);
      e ? c("MOUNT") : p === "none" || (a == null ? void 0 : a.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), rd(() => {
    if (t) {
      let a;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const m = pR(r.current).includes(p.animationName);
        if (p.target === t && m && (c("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", a = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, d = (p) => {
        p.target === t && (o.current = pR(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(a), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: N.useCallback((a) => {
      a && (r.current = getComputedStyle(a)), n(a);
    }, [])
  };
}
function pR(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function vtn(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var AJ = "Collapsible", [btn, U6e] = Tx(AJ), [Otn, wJ] = btn(AJ), V6e = N.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: o,
      onOpenChange: s,
      ...l
    } = e, [c = !1, a] = OJ({
      prop: r,
      defaultProp: i,
      onChange: s
    });
    return /* @__PURE__ */ y(
      Otn,
      {
        scope: n,
        disabled: o,
        contentId: Zu(),
        open: c,
        onOpenToggle: N.useCallback(() => a((u) => !u), [a]),
        children: /* @__PURE__ */ y(
          $N.div,
          {
            "data-state": SJ(c),
            "data-disabled": o ? "" : void 0,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
V6e.displayName = AJ;
var q6e = "CollapsibleTrigger", B6e = N.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = wJ(q6e, n);
    return /* @__PURE__ */ y(
      $N.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": SJ(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: j6e(e.onClick, i.onOpenToggle)
      }
    );
  }
);
B6e.displayName = q6e;
var xJ = "CollapsibleContent", X6e = N.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = wJ(xJ, e.__scopeCollapsible);
    return /* @__PURE__ */ y(F6e, { present: n || i.open, children: ({ present: o }) => /* @__PURE__ */ y(Atn, { ...r, ref: t, present: o }) });
  }
);
X6e.displayName = xJ;
var Atn = N.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, s = wJ(xJ, n), [l, c] = N.useState(r), a = N.useRef(null), u = ja(t, a), f = N.useRef(0), d = f.current, p = N.useRef(0), h = p.current, m = s.open || l, v = N.useRef(m), b = N.useRef(void 0);
  return N.useEffect(() => {
    const A = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(A);
  }, []), rd(() => {
    const A = a.current;
    if (A) {
      b.current = b.current || {
        transitionDuration: A.style.transitionDuration,
        animationName: A.style.animationName
      }, A.style.transitionDuration = "0s", A.style.animationName = "none";
      const w = A.getBoundingClientRect();
      f.current = w.height, p.current = w.width, v.current || (A.style.transitionDuration = b.current.transitionDuration, A.style.animationName = b.current.animationName), c(r);
    }
  }, [s.open, r]), /* @__PURE__ */ y(
    $N.div,
    {
      "data-state": SJ(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !m,
      ...o,
      ref: u,
      style: {
        "--radix-collapsible-content-height": d ? `${d}px` : void 0,
        "--radix-collapsible-content-width": h ? `${h}px` : void 0,
        ...e.style
      },
      children: m && i
    }
  );
});
function SJ(e) {
  return e ? "open" : "closed";
}
var wtn = V6e, xtn = B6e, Stn = X6e, Etn = N.createContext(void 0);
function Ttn(e) {
  const t = N.useContext(Etn);
  return e || t || "ltr";
}
var Ph = "Accordion", ktn = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [EJ, Ctn, Ntn] = ptn(Ph), [C3, Dmn] = Tx(Ph, [
  Ntn,
  U6e
]), TJ = U6e(), kJ = ie.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, i = r, o = r;
    return /* @__PURE__ */ y(EJ.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ y(Mtn, { ...o, ref: t }) : /* @__PURE__ */ y(Rtn, { ...i, ref: t }) });
  }
);
kJ.displayName = Ph;
var [W6e, Ptn] = C3(Ph), [Z6e, Itn] = C3(
  Ph,
  { collapsible: !1 }
), Rtn = ie.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: o = !1,
      ...s
    } = e, [l, c] = OJ({
      prop: n,
      defaultProp: r,
      onChange: i
    });
    return /* @__PURE__ */ y(
      W6e,
      {
        scope: e.__scopeAccordion,
        value: l ? [l] : [],
        onItemOpen: c,
        onItemClose: ie.useCallback(() => o && c(""), [o, c]),
        children: /* @__PURE__ */ y(Z6e, { scope: e.__scopeAccordion, collapsible: o, children: /* @__PURE__ */ y(H6e, { ...s, ref: t }) })
      }
    );
  }
), Mtn = ie.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...o
  } = e, [s = [], l] = OJ({
    prop: n,
    defaultProp: r,
    onChange: i
  }), c = ie.useCallback(
    (u) => l((f = []) => [...f, u]),
    [l]
  ), a = ie.useCallback(
    (u) => l((f = []) => f.filter((d) => d !== u)),
    [l]
  );
  return /* @__PURE__ */ y(
    W6e,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: c,
      onItemClose: a,
      children: /* @__PURE__ */ y(Z6e, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ y(H6e, { ...o, ref: t }) })
    }
  );
}), [Dtn, N3] = C3(Ph), H6e = ie.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: o = "vertical", ...s } = e, l = ie.useRef(null), c = ja(l, t), a = Ctn(n), f = Ttn(i) === "ltr", d = j6e(e.onKeyDown, (p) => {
      var k;
      if (!ktn.includes(p.key)) return;
      const h = p.target, m = a().filter((T) => {
        var R;
        return !((R = T.ref.current) != null && R.disabled);
      }), v = m.findIndex((T) => T.ref.current === h), b = m.length;
      if (v === -1) return;
      p.preventDefault();
      let A = v;
      const w = 0, O = b - 1, x = () => {
        A = v + 1, A > O && (A = w);
      }, S = () => {
        A = v - 1, A < w && (A = O);
      };
      switch (p.key) {
        case "Home":
          A = w;
          break;
        case "End":
          A = O;
          break;
        case "ArrowRight":
          o === "horizontal" && (f ? x() : S());
          break;
        case "ArrowDown":
          o === "vertical" && x();
          break;
        case "ArrowLeft":
          o === "horizontal" && (f ? S() : x());
          break;
        case "ArrowUp":
          o === "vertical" && S();
          break;
      }
      const E = A % b;
      (k = m[E].ref.current) == null || k.focus();
    });
    return /* @__PURE__ */ y(
      Dtn,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: o,
        children: /* @__PURE__ */ y(EJ.Slot, { scope: n, children: /* @__PURE__ */ y(
          $N.div,
          {
            ...s,
            "data-orientation": o,
            ref: c,
            onKeyDown: r ? void 0 : d
          }
        ) })
      }
    );
  }
), gL = "AccordionItem", [_tn, CJ] = C3(gL), Q6e = ie.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...i } = e, o = N3(gL, n), s = Ptn(gL, n), l = TJ(n), c = Zu(), a = r && s.value.includes(r) || !1, u = o.disabled || e.disabled;
    return /* @__PURE__ */ y(
      _tn,
      {
        scope: n,
        open: a,
        disabled: u,
        triggerId: c,
        children: /* @__PURE__ */ y(
          wtn,
          {
            "data-orientation": o.orientation,
            "data-state": eUe(a),
            ...l,
            ...i,
            ref: t,
            disabled: u,
            open: a,
            onOpenChange: (f) => {
              f ? s.onItemOpen(r) : s.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
Q6e.displayName = gL;
var $6e = "AccordionHeader", K6e = ie.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = N3(Ph, n), o = CJ($6e, n);
    return /* @__PURE__ */ y(
      $N.h3,
      {
        "data-orientation": i.orientation,
        "data-state": eUe(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
K6e.displayName = $6e;
var T7 = "AccordionTrigger", G6e = ie.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = N3(Ph, n), o = CJ(T7, n), s = Itn(T7, n), l = TJ(n);
    return /* @__PURE__ */ y(EJ.ItemSlot, { scope: n, children: /* @__PURE__ */ y(
      xtn,
      {
        "aria-disabled": o.open && !s.collapsible || void 0,
        "data-orientation": i.orientation,
        id: o.triggerId,
        ...l,
        ...r,
        ref: t
      }
    ) });
  }
);
G6e.displayName = T7;
var Y6e = "AccordionContent", J6e = ie.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = N3(Ph, n), o = CJ(Y6e, n), s = TJ(n);
    return /* @__PURE__ */ y(
      Stn,
      {
        role: "region",
        "aria-labelledby": o.triggerId,
        "data-orientation": i.orientation,
        ...s,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
J6e.displayName = Y6e;
function eUe(e) {
  return e ? "open" : "closed";
}
var Ltn = kJ, ztn = Q6e, jtn = K6e, tUe = G6e, nUe = J6e;
const Ftn = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y(
  Ltn,
  {
    className: Se("rounded-md border", e),
    ...t
  }
), KN = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(ztn, { ref: n, className: Se(e), ...t }));
KN.displayName = "AccordionItem";
const GN = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ y(jtn, { className: "flex", children: /* @__PURE__ */ V(
  tUe,
  {
    ref: r,
    className: Se(
      "flex flex-1  px-4 py-3 items-center justify-between text-sm font-medium transition-all text-left [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ y(ex, { className: "h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" })
    ]
  }
) }));
GN.displayName = tUe.displayName;
const YN = N.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ y(
  nUe,
  {
    ref: r,
    className: Se(
      "overflow-hidden px-3 pb-3 text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      e
    ),
    ...n,
    children: t
  }
));
YN.displayName = nUe.displayName;
const Utn = {
  useToolMetadata(e) {
    return pr({
      queryKey: [
        "mcp-tool-metadata",
        e.toolName,
        e.toolCallType
      ],
      queryFn: async () => {
        switch (e.toolCallType) {
          case GM.PIECE: {
            const t = await Yd.get({
              name: e.pieceName,
              version: e.pieceVersion
            }), n = t.actions[e.actionName];
            return {
              displayName: (n == null ? void 0 : n.displayName) ?? e.actionName,
              logoUrl: t.logoUrl
            };
          }
          case GM.FLOW:
            return {
              displayName: e.displayName,
              logoUrl: null
            };
          default:
            return { displayName: null, logoUrl: null };
        }
      }
    });
  }
}, Vtn = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, Ub = ({
  icon: e,
  children: t,
  iconLeft: n = "left-0"
}) => /* @__PURE__ */ V("div", { className: "relative pl-7 animate-fade", children: [
  /* @__PURE__ */ y(
    "div",
    {
      className: `absolute bg-background ${n} w-4 h-4 top-3.5 flex items-center justify-center`,
      children: e
    }
  ),
  t
] }), qtn = ({ block: e, index: t }) => {
  var m, v;
  if ([xAe].includes(e.toolName ?? "")) return null;
  const { data: n, isLoading: r } = Utn.useToolMetadata(e), i = e.output, o = i == null ? void 0 : i.errorMessage, s = e.status === tz.COMPLETED, l = (i == null ? void 0 : i.status) ?? KM.FAILED, c = !De((m = e.input) == null ? void 0 : m.instruction), a = (i == null ? void 0 : i.resolvedInput) ?? null, u = i != null && i.output ? Vtn(i.output) : null, f = a ? "resolvedFields" : "result", d = () => s ? l === KM.SUCCESS ? /* @__PURE__ */ y(oit, { className: "h-4 w-4 text-success shrink-0" }) : /* @__PURE__ */ y(hz, { className: "h-4 w-4 text-destructive shrink-0" }) : /* @__PURE__ */ y(PT, { className: "h-4 w-4 animate-spin shrink-0" }), h = /* @__PURE__ */ V("div", { className: "flex items-center gap-2 w-full", children: [
    r ? /* @__PURE__ */ y(PT, { className: "h-4 w-4 animate-spin shrink-0" }) : n != null && n.logoUrl ? /* @__PURE__ */ y(
      "img",
      {
        src: n.logoUrl,
        alt: "Tool logo",
        className: "h-4 w-4 object-contain shrink-0"
      }
    ) : /* @__PURE__ */ y(sxe, { className: "h-4 w-4 shrink-0" }),
    /* @__PURE__ */ y(
      "span",
      {
        className: `flex gap-1 items-center ${l ? "" : "text-destructive"}`,
        children: /* @__PURE__ */ V("span", { className: "text-sm font-semibold", children: [
          r ? "Loading..." : (n == null ? void 0 : n.displayName) ?? "Unknown Tool",
          !l && Z(" (Failed)")
        ] })
      }
    )
  ] });
  return /* @__PURE__ */ y(Ub, { icon: d(), children: /* @__PURE__ */ y(
    Ftn,
    {
      type: "single",
      collapsible: !0,
      className: "w-full bg-accent/20 rounded-md text-foreground border border-border",
      children: /* @__PURE__ */ V(KN, { value: `block-${t}`, className: "border-0", children: [
        /* @__PURE__ */ y(GN, { className: "p-3 text-sm", children: h }),
        /* @__PURE__ */ y(YN, { children: /* @__PURE__ */ V("div", { className: "space-y-3 w-full my-2", children: [
          c && /* @__PURE__ */ y(
            uu,
            {
              variant: gs.BORDERLESS,
              markdown: (v = e.input) == null ? void 0 : v.instruction
            }
          ),
          !r && /* @__PURE__ */ V(vx, { defaultValue: f, className: "w-full", children: [
            /* @__PURE__ */ V(Tb, { variant: "outline", className: "mb-0", children: [
              /* @__PURE__ */ y(
                Ca,
                {
                  value: "resolvedFields",
                  variant: "outline",
                  className: "text-xs",
                  children: Z("Parameters")
                }
              ),
              /* @__PURE__ */ y(
                Ca,
                {
                  value: "result",
                  variant: "outline",
                  className: "text-xs",
                  children: De(o) ? Z("Output") : Z("Error")
                }
              )
            ] }),
            /* @__PURE__ */ y(
              yl,
              {
                value: "resolvedFields",
                className: "overflow-hidden mt-3",
                children: a ? /* @__PURE__ */ y(stn, { data: a }) : /* @__PURE__ */ y("div", { className: "text-muted-foreground text-sm", children: Z("No resolved fields") })
              }
            ),
            /* @__PURE__ */ y(yl, { value: "result", className: "overflow-hidden mt-3", children: u ? /* @__PURE__ */ y(
              atn,
              {
                data: u,
                hideCopyButton: !0,
                maxHeight: 300
              }
            ) : De(o) ? /* @__PURE__ */ y("div", { className: "text-muted-foreground text-sm", children: Z("No result") }) : /* @__PURE__ */ y(
              uu,
              {
                variant: gs.BORDERLESS,
                markdown: o
              }
            ) })
          ] })
        ] }) })
      ] })
    }
  ) }, `step-${t}-${e.type}`);
}, Btn = ({
  index: e,
  step: t
}) => /* @__PURE__ */ y(
  Ub,
  {
    icon: /* @__PURE__ */ y(yot, { className: "h-4 w-4 text-muted-foreground" }),
    children: /* @__PURE__ */ y("div", { className: "bg-accent/20 rounded-md p-3 text-sm text-foreground border border-border", children: /* @__PURE__ */ y(
      uu,
      {
        markdown: t.markdown,
        variant: gs.BORDERLESS
      }
    ) })
  },
  `step-${e}-${t.type}`
), Xtn = ({ output: e }) => /* @__PURE__ */ y(Ub, { icon: /* @__PURE__ */ y(tit, { className: "h-4 w-4 text-muted-foreground" }), children: /* @__PURE__ */ y(Hp, { json: e, title: Z("output") }) }), Wtn = () => /* @__PURE__ */ y(
  Ub,
  {
    icon: /* @__PURE__ */ y(PT, { className: "h-4 w-4 text-muted-foreground animate-spin" }),
    children: /* @__PURE__ */ y("div", { className: "bg-accent/20 rounded-md p-3 w-full text-sm text-foreground border border-border animate-pulse", children: /* @__PURE__ */ y("span", { children: Z("Agent is thinking...") }) })
  }
), Ztn = ({ prompt: e }) => {
  const [n, r] = He(!1), i = e.length > 180, o = Kt(() => n || !i ? e : e.slice(0, 180) + "…", [n, i, e]);
  return /* @__PURE__ */ y(Ub, { icon: /* @__PURE__ */ y(ost, { className: "h-4 w-4 text-primary" }), children: /* @__PURE__ */ V("div", { className: "bg-primary/5 rounded-md p-3 text-sm text-foreground border border-border space-y-2", children: [
    /* @__PURE__ */ y(
      uu,
      {
        markdown: o,
        variant: gs.BORDERLESS
      }
    ),
    i && /* @__PURE__ */ y(
      "button",
      {
        onClick: () => r((s) => !s),
        className: "text-xs text-primary hover:underline",
        children: n ? "Read less" : "Read more"
      }
    )
  ] }) });
}, Htn = () => /* @__PURE__ */ y(Ub, { icon: /* @__PURE__ */ y(mB, { className: "h-4 w-4 text-green-600" }), children: /* @__PURE__ */ y("div", { className: "border border-green-500/40 bg-green-50/60 rounded-md p-3 text-sm text-green-700 font-medium flex items-center gap-2", children: /* @__PURE__ */ y("span", { children: Z("Done!") }) }) }), Qtn = () => /* @__PURE__ */ y(Ub, { icon: /* @__PURE__ */ y(hz, { className: "h-4 w-4 text-red-600" }), children: /* @__PURE__ */ y("div", { className: "border border-red-500/40 bg-red-50/60 rounded-md p-3 text-sm text-red-700 font-medium flex items-center gap-2", children: /* @__PURE__ */ y("span", { children: Z("Failed") }) }) }), rUe = ({
  agentResult: e,
  className: t = ""
}) => De(e) ? /* @__PURE__ */ y("p", { children: Z("No agent output available") }) : /* @__PURE__ */ y("div", { className: `h-full flex w-full flex-col ${t}`, children: /* @__PURE__ */ V(Bi, { className: "flex-1 min-h-0 relative", children: [
  /* @__PURE__ */ y("div", { className: "absolute left-2 top-4 bottom-8 w-px bg-border" }),
  /* @__PURE__ */ V("div", { className: "space-y-7 pb-4", children: [
    e.prompt.length > 0 && /* @__PURE__ */ y(Ztn, { prompt: e.prompt }),
    e.steps.map((n, r) => {
      switch (n.type) {
        case $M.MARKDOWN:
          return /* @__PURE__ */ y(Btn, { step: n, index: r }, r);
        case $M.TOOL_CALL:
          return /* @__PURE__ */ y(qtn, { block: n, index: r }, r);
        default:
          return null;
      }
    }),
    !De(e.structuredOutput) && /* @__PURE__ */ y(Xtn, { output: e.structuredOutput }),
    e.status === iv.IN_PROGRESS && /* @__PURE__ */ y(Wtn, {}),
    e.status === iv.COMPLETED && /* @__PURE__ */ y(Htn, {}),
    e.status === iv.FAILED && /* @__PURE__ */ y(Qtn, {})
  ] })
] }) }), yL = (e) => !De(e) && e.type === qe.PIECE && e.settings.pieceName === X2 && e.settings.actionName === "run_agent", iUe = {
  prompt: "",
  status: iv.IN_PROGRESS,
  steps: [],
  message: null
}, $tn = ({
  agentResult: e,
  errorMessage: t
}) => (console.log("AGENT RESULT", e), /* @__PURE__ */ y("div", { className: "flex flex-col justify-center w-full items-start", children: /* @__PURE__ */ V(vx, { defaultValue: "timeline", className: "w-full", children: [
  /* @__PURE__ */ V(Tb, { className: "w-[250px] grid grid-cols-2", children: [
    /* @__PURE__ */ y(Ca, { value: "timeline", children: Z("Timeline") }),
    /* @__PURE__ */ y(Ca, { value: "output", children: Z("Output") })
  ] }),
  /* @__PURE__ */ y(yl, { value: "timeline", children: /* @__PURE__ */ y(rUe, { agentResult: e }) }),
  /* @__PURE__ */ y(yl, { value: "output", children: /* @__PURE__ */ y(Hp, { json: t ?? e, title: Z("Output") }) })
] }) })), Ktn = () => {
  const [e, t, n, r] = tn(
    (p) => [
      p.run,
      p.loopsIndexes,
      p.flowVersion,
      p.selectedStep ? At.getStepOrThrow(
        p.selectedStep,
        p.flowVersion.trigger
      ) : null
    ]
  ), i = Kt(() => e && r && e.steps ? Ks.extractStepOutput(
    r.name,
    t,
    e.steps,
    n.trigger
  ) : null, [e, r == null ? void 0 : r.name, t, n.trigger]), o = yL(r), s = (i == null ? void 0 : i.status) === po.RUNNING || (i == null ? void 0 : i.status) === po.PAUSED, l = (i == null ? void 0 : i.errorMessage) ?? (i == null ? void 0 : i.output) ?? "No output", a = (o ? 3 : 2) === 3 ? "grid-cols-3" : "grid-cols-2";
  if (!e)
    return /* @__PURE__ */ y(pt, {});
  const u = DC({
    status: e.status,
    ignoreInternalError: !0
  }), { data: f } = Go.useFlag(
    As.EXECUTION_DATA_RETENTION_DAYS
  ), d = Gtn(e, f);
  return d ? /* @__PURE__ */ V("div", { className: "flex flex-col justify-center items-center gap-4 w-full pt-8  px-5", children: [
    /* @__PURE__ */ y(QA, { size: 36, className: "text-muted-foreground" }),
    /* @__PURE__ */ y("h4", { className: "px-6 text-sm text-center text-muted-foreground ", children: d })
  ] }) : u ? !i || !r ? /* @__PURE__ */ V("div", { className: "px-4 bg-muted rounded-md m-4 py-2 flex items-center gap-1.5", children: [
    /* @__PURE__ */ y(QA, { className: "w-4 h-4" }),
    /* @__PURE__ */ y("span", { children: Z("This step didn't run") })
  ] }) : /* @__PURE__ */ y(Bi, { className: "h-full p-4", children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2 text-base font-medium", children: [
      /* @__PURE__ */ y(JO, { status: i.status, size: "4.5" }),
      /* @__PURE__ */ y("span", { children: r.displayName })
    ] }),
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2 text-sm text-muted-foreground", children: [
      /* @__PURE__ */ y(iD, { className: "w-4 h-4" }),
      /* @__PURE__ */ V("span", { children: [
        Z("Duration"),
        ":",
        " ",
        rc.formatDuration(
          i.duration ?? 0,
          !1
        )
      ] })
    ] }),
    /* @__PURE__ */ V(vx, { defaultValue: o ? "timeline" : "output", className: "w-full", children: [
      /* @__PURE__ */ V(Tb, { className: `w-full grid ${a}`, children: [
        /* @__PURE__ */ y(Ca, { value: "input", children: Z("Input") }),
        o && /* @__PURE__ */ y(Ca, { value: "timeline", children: Z("Timeline") }),
        /* @__PURE__ */ y(Ca, { value: "output", children: Z("Output") })
      ] }),
      /* @__PURE__ */ y(yl, { value: "input", children: /* @__PURE__ */ y(Hp, { json: i.input, title: Z("Input") }) }),
      o && /* @__PURE__ */ y(yl, { value: "timeline", children: /* @__PURE__ */ y(
        rUe,
        {
          agentResult: i.output
        }
      ) }),
      /* @__PURE__ */ y(yl, { value: "output", children: s ? /* @__PURE__ */ y(Whe, {}) : /* @__PURE__ */ y(Hp, { json: l, title: Z("Output") }) })
    ] })
  ] }) }) : /* @__PURE__ */ y(Whe, {});
}, Whe = () => /* @__PURE__ */ y("div", { className: "flex  w-full  h-full  p-4", children: /* @__PURE__ */ V("div", { className: "space-y-2 grow", children: [
  /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ y(Tr, { className: "w-40 h-4" }) }),
  /* @__PURE__ */ y(Tr, { className: "w-full h-40" })
] }) });
function Gtn(e, t) {
  return De(e) ? null : [cr.INTERNAL_ERROR].includes(e.status) ? Z(
    "There are no logs captured for this run, because of an internal error, please contact support."
  ) : De(e.logsFileId) ? Z(
    "Logs are kept for {days} days after execution and then deleted.",
    { days: t }
  ) : null;
}
const Ytn = as("size-2 rounded-full", {
  variants: {
    variant: {
      destructive: "bg-destructive",
      primary: "bg-primary"
    }
  },
  defaultVariants: {}
}), GE = ie.forwardRef(
  ({ className: e, animation: t = !1, variant: n, ...r }, i) => /* @__PURE__ */ y(
    "div",
    {
      ref: i,
      className: Se(
        Ytn({ variant: n }),
        t && "animate-pulse",
        e
      ),
      ...r
    }
  )
);
GE.displayName = "Dot";
const uA = {
  async get(e) {
    return await dt.get(`/v1/todos/${e}`);
  },
  async list(e) {
    return await dt.get("/v1/todos", e);
  },
  async update(e, t) {
    return await dt.post(`/v1/todos/${e}`, t);
  },
  async delete(e) {
    return await dt.delete(`/v1/todos/${e}`);
  }
}, UV = {
  single: (e) => ["todo", e],
  list: (e, t, n) => ["todos", e, t, n.toString()]
}, Jtn = {
  useTodo: (e) => pr({
    queryKey: UV.single(e),
    queryFn: () => uA.get(e),
    enabled: !!e
  }),
  setTodoManually: (e, t, n) => {
    n.setQueryData(UV.single(e), t);
  },
  useDeleteTodos: (e) => dr({
    mutationFn: async (t) => {
      await Promise.all(t.map((n) => uA.delete(n)));
    },
    onSuccess: () => {
      e();
    }
  }),
  useTodosList: (e = "all") => {
    const t = Rn.getProjectId(), n = Rn.getPlatformId(), [r] = Eve();
    return pr({
      queryKey: UV.list(t, e, r),
      queryFn: () => {
        const i = r.get("cursor"), o = r.get("limit") ? parseInt(r.get("limit")) : 10, s = r.get("assigneeId") ?? void 0, l = r.get("title") ?? void 0, c = e === "needs-action" ? [WA.name] : void 0;
        return uA.list({
          projectId: t,
          cursor: i ?? void 0,
          limit: o,
          platformId: n,
          assigneeId: s,
          statusOptions: c,
          title: l
        });
      }
    });
  }
}, oUe = {
  async list(e) {
    return await dt.get(
      "/v1/todo-activities",
      e
    );
  },
  async create(e) {
    return await dt.post("/v1/todo-activities", e);
  }
}, enn = {
  useComments: (e) => pr({
    queryKey: ["todos", e, "comments"],
    queryFn: () => oUe.list({
      todoId: e,
      cursor: void 0,
      limit: 100,
      type: void 0
    }),
    enabled: !!e
  })
}, tnn = ({
  onSubmit: e,
  placeholder: t = "You can use markdown to format your comment",
  disabled: n = !1,
  title: r
}) => {
  const [i, o] = He(""), [s, l] = He(!1), { data: c } = gj.useCurrentUser(), a = async () => {
    if (!(!i.trim() || n)) {
      l(!0);
      try {
        await e(i), o("");
      } finally {
        l(!1);
      }
    }
  }, u = (f) => {
    f.key === "Enter" && !f.shiftKey && (f.preventDefault(), a());
  };
  return n ? null : /* @__PURE__ */ y("div", { className: "flex flex-col gap-2 mt-4", children: /* @__PURE__ */ V("div", { className: "flex gap-4", children: [
    /* @__PURE__ */ y("div", { className: "shrink-0", children: c && /* @__PURE__ */ y(
      aL,
      {
        size: 32,
        email: c == null ? void 0 : c.email,
        name: (c == null ? void 0 : c.firstName) + " " + (c == null ? void 0 : c.lastName)
      }
    ) }),
    /* @__PURE__ */ V("div", { className: "flex-1", children: [
      r && /* @__PURE__ */ y("div", { className: "flex items-center gap-2 h-8 font-bold", children: r }),
      /* @__PURE__ */ y("div", { className: "relative mt-1", children: /* @__PURE__ */ y("div", { className: "h-[155px] w-full p-px rounded-lg border border-input-border", children: /* @__PURE__ */ V(
        "div",
        {
          className: Se(
            "relative rounded-md bg-background w-full h-full flex flex-col justify-between"
          ),
          children: [
            /* @__PURE__ */ y(Bi, { className: "w-full grow overflow-auto", children: /* @__PURE__ */ y("div", { className: "p-2 pb-0", children: /* @__PURE__ */ y(
              mG,
              {
                className: "w-full bg-background border-none resize-none overflow-hidden",
                placeholder: t,
                minRows: 2,
                maxRows: 10,
                value: i,
                onChange: (f) => o(f.target.value),
                onKeyDown: u,
                disabled: s
              }
            ) }) }),
            /* @__PURE__ */ y("div", { className: "flex justify-end mx-2 mb-3", children: /* @__PURE__ */ y(
              Qe,
              {
                size: "icon",
                onClick: a,
                loading: s,
                disabled: !i.trim(),
                "aria-label": "Submit",
                children: /* @__PURE__ */ y(Jwe, { className: "w-5 h-5" })
              }
            ) })
          ]
        }
      ) }) })
    ] })
  ] }) });
}, nnn = ({
  todo: e,
  refetchComments: t
}) => /* @__PURE__ */ y(
  tnn,
  {
    onSubmit: async (r) => {
      e.locked || (await oUe.create({
        todoId: e.id,
        content: r
      }), t());
    },
    disabled: e.locked,
    title: "Add a Comment"
  }
), Zhe = as(
  "inline-flex gap-1 rounded px-2.5 py-1 text-xs font-semibold",
  {
    variants: {
      variant: {
        success: "bg-success-100 text-success-300",
        error: "bg-destructive-100 text-destructive-300",
        default: "bg-accent text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), sUe = ie.memo(
  ({
    icon: e,
    text: t,
    variant: n,
    color: r,
    textColor: i
  }) => De(r) || De(i) ? /* @__PURE__ */ V("span", { className: Zhe({ variant: n }), children: [
    /* @__PURE__ */ y(e, { className: "size-4" }),
    /* @__PURE__ */ y("span", { children: t })
  ] }) : /* @__PURE__ */ V(
    "span",
    {
      className: Zhe({ variant: n }),
      style: { backgroundColor: r || void 0 },
      children: [
        /* @__PURE__ */ y(e, { className: "size-4", style: { color: i } }),
        /* @__PURE__ */ y("span", { style: { color: i }, children: t })
      ]
    }
  )
);
sUe.displayName = "StatusIconWithText";
const rnn = ({
  todo: e,
  isUpdatingStatus: t,
  onStatusChange: n
}) => {
  const r = (s) => s === Vp.NEGATIVE ? ks : s === Vp.POSITIVE ? mB : Qre, i = (s, l) => s === WA.name ? /* @__PURE__ */ y(Qre, { className: "h-4 w-4 text-warning-300" }) : l === Vp.NEGATIVE ? /* @__PURE__ */ y(ks, { className: "h-4 w-4 text-destructive-300" }) : /* @__PURE__ */ y(mB, { className: "h-4 w-4 text-success-300" }), o = e.status.name !== WA.name && e.status.continueFlow !== !1;
  return /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ y(
      sUe,
      {
        icon: r(e.status.variant),
        text: e.status.name,
        color: qq[e.status.variant].color,
        textColor: qq[e.status.variant].textColor
      }
    ),
    !o && !e.locked && /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: e.statusOptions.map((s) => /* @__PURE__ */ y(
      Qe,
      {
        variant: "ghost",
        size: "sm",
        className: "h-8 px-2 flex gap-2 items-center",
        onClick: () => n(s, "manual"),
        disabled: t || s.name === e.status.name,
        children: t && s.name === e.status.name ? /* @__PURE__ */ y(cot, { className: "h-4 w-4" }) : /* @__PURE__ */ V(pt, { children: [
          i(s.name, s.variant),
          /* @__PURE__ */ V("span", { className: "text-sm", children: [
            "Mark as ",
            s.name
          ] })
        ] })
      },
      s.name
    )) })
  ] });
}, Fl = {
  getAuthorName: (e) => {
    var n, r, i, o, s;
    switch (Fl.getAuthorType(e)) {
      case "user":
        return "createdByUser" in e && e.createdByUser ? ((n = e.createdByUser) == null ? void 0 : n.firstName) + " " + ((r = e.createdByUser) == null ? void 0 : r.lastName) : "user" in e && e.user ? ((i = e.user) == null ? void 0 : i.firstName) + " " + ((o = e.user) == null ? void 0 : o.lastName) : "Unknown";
      case "flow":
        return "flow" in e && e.flow ? ((s = e.flow) == null ? void 0 : s.version.displayName) ?? "Flow" : "Unknown";
    }
  },
  getAuthorType: (e) => "createdByUser" in e && !De(e.createdByUser) || "user" in e && !De(e.user) ? "user" : "flow",
  getAuthorEmail: (e) => {
    var t, n;
    if ("createdByUser" in e && e.createdByUser)
      return (t = e.createdByUser) == null ? void 0 : t.email;
    if ("user" in e && e.user)
      return (n = e.user) == null ? void 0 : n.email;
  },
  getAuthorId: (e) => {
    var t, n;
    if ("createdByUser" in e && e.createdByUser)
      return (t = e.createdByUser) == null ? void 0 : t.id;
    if ("user" in e && e.user)
      return (n = e.user) == null ? void 0 : n.id;
  }
}, inn = ({
  user: e,
  showLockedBadges: t = !0,
  showBorder: n = !1
}) => {
  const { data: r } = Go.useFlag(
    As.SHOW_BADGES
  );
  if (!r)
    return null;
  const i = (e == null ? void 0 : e.badges) ?? [];
  if (!t && i.length === 0)
    return null;
  const o = t ? Object.entries(IR) : i.filter((s) => IR[s.name]).map((s) => [s.name, IR[s.name]]);
  return /* @__PURE__ */ V("div", { className: n ? "mt-3 pt-3 border-t" : "space-y-3", children: [
    /* @__PURE__ */ y(
      "h5",
      {
        className: `text-xs text-foreground tracking-wide ${n ? "mb-2" : ""}`,
        children: Z("Badges")
      }
    ),
    /* @__PURE__ */ y("div", { className: "flex items-center gap-1 flex-wrap", children: o.map(([s, l]) => {
      const c = i.some(
        (a) => a.name === s
      );
      return /* @__PURE__ */ V(wn, { children: [
        /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V("div", { className: "cursor-pointer relative", children: [
          /* @__PURE__ */ y(
            "img",
            {
              src: l.imageUrl,
              alt: l.title,
              className: `h-12 w-12 object-cover rounded-md ${!c && t ? "opacity-50 grayscale" : ""}`
            }
          ),
          !c && t && /* @__PURE__ */ y("div", { className: "absolute inset-0 flex items-center justify-center rounded", children: /* @__PURE__ */ y(dot, { className: "h-5 w-5 text-muted-foreground" }) })
        ] }) }),
        /* @__PURE__ */ y(An, { className: "text-left", children: /* @__PURE__ */ V("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ y("p", { className: "font-semibold", children: l.title }),
          /* @__PURE__ */ y("p", { className: "text-xs", children: l.description })
        ] }) })
      ] }, s);
    }) })
  ] });
}, onn = ["top", "right", "bottom", "left"], pg = Math.min, Hl = Math.max, vL = Math.round, hR = Math.floor, bf = (e) => ({
  x: e,
  y: e
}), snn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ann = {
  start: "end",
  end: "start"
};
function k7(e, t, n) {
  return Hl(e, pg(t, n));
}
function yh(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vh(e) {
  return e.split("-")[0];
}
function Ux(e) {
  return e.split("-")[1];
}
function NJ(e) {
  return e === "x" ? "y" : "x";
}
function PJ(e) {
  return e === "y" ? "height" : "width";
}
const lnn = /* @__PURE__ */ new Set(["top", "bottom"]);
function ff(e) {
  return lnn.has(vh(e)) ? "y" : "x";
}
function IJ(e) {
  return NJ(ff(e));
}
function cnn(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ux(e), i = IJ(e), o = PJ(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = bL(s)), [s, bL(s)];
}
function unn(e) {
  const t = bL(e);
  return [C7(e), t, C7(t)];
}
function C7(e) {
  return e.replace(/start|end/g, (t) => ann[t]);
}
const Hhe = ["left", "right"], Qhe = ["right", "left"], dnn = ["top", "bottom"], fnn = ["bottom", "top"];
function pnn(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Qhe : Hhe : t ? Hhe : Qhe;
    case "left":
    case "right":
      return t ? dnn : fnn;
    default:
      return [];
  }
}
function hnn(e, t, n, r) {
  const i = Ux(e);
  let o = pnn(vh(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(C7)))), o;
}
function bL(e) {
  return e.replace(/left|right|bottom|top/g, (t) => snn[t]);
}
function mnn(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function aUe(e) {
  return typeof e != "number" ? mnn(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function OL(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function $he(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = ff(t), s = IJ(t), l = PJ(s), c = vh(t), a = o === "y", u = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, d = r[l] / 2 - i[l] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ux(t)) {
    case "start":
      p[s] -= d * (n && a ? -1 : 1);
      break;
    case "end":
      p[s] += d * (n && a ? -1 : 1);
      break;
  }
  return p;
}
const gnn = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, l = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let a = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: f
  } = $he(a, r, c), d = r, p = {}, h = 0;
  for (let m = 0; m < l.length; m++) {
    const {
      name: v,
      fn: b
    } = l[m], {
      x: A,
      y: w,
      data: O,
      reset: x
    } = await b({
      x: u,
      y: f,
      initialPlacement: r,
      placement: d,
      strategy: i,
      middlewareData: p,
      rects: a,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = A ?? u, f = w ?? f, p = {
      ...p,
      [v]: {
        ...p[v],
        ...O
      }
    }, x && h <= 50 && (h++, typeof x == "object" && (x.placement && (d = x.placement), x.rects && (a = x.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : x.rects), {
      x: u,
      y: f
    } = $he(a, d, c)), m = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: p
  };
};
async function Fk(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: l,
    strategy: c
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = yh(t, e), h = aUe(p), v = l[d ? f === "floating" ? "reference" : "floating" : f], b = OL(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(v))) == null || n ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(l.floating)),
    boundary: a,
    rootBoundary: u,
    strategy: c
  })), A = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l.floating)), O = await (o.isElement == null ? void 0 : o.isElement(w)) ? await (o.getScale == null ? void 0 : o.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = OL(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: A,
    offsetParent: w,
    strategy: c
  }) : A);
  return {
    top: (b.top - x.top + h.top) / O.y,
    bottom: (x.bottom - b.bottom + h.bottom) / O.y,
    left: (b.left - x.left + h.left) / O.x,
    right: (x.right - b.right + h.right) / O.x
  };
}
const ynn = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: l,
      middlewareData: c
    } = t, {
      element: a,
      padding: u = 0
    } = yh(e, t) || {};
    if (a == null)
      return {};
    const f = aUe(u), d = {
      x: n,
      y: r
    }, p = IJ(i), h = PJ(p), m = await s.getDimensions(a), v = p === "y", b = v ? "top" : "left", A = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", O = o.reference[h] + o.reference[p] - d[p] - o.floating[h], x = d[p] - o.reference[p], S = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let E = S ? S[w] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(S))) && (E = l.floating[w] || o.floating[h]);
    const k = O / 2 - x / 2, T = E / 2 - m[h] / 2 - 1, R = pg(f[b], T), j = pg(f[A], T), F = R, L = E - m[h] - j, _ = E / 2 - m[h] / 2 + k, U = k7(F, _, L), z = !c.arrow && Ux(i) != null && _ !== U && o.reference[h] / 2 - (_ < F ? R : j) - m[h] / 2 < 0, C = z ? _ < F ? _ - F : _ - L : 0;
    return {
      [p]: d[p] + C,
      data: {
        [p]: U,
        centerOffset: _ - U - C,
        ...z && {
          alignmentOffset: C
        }
      },
      reset: z
    };
  }
}), vnn = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: l,
        platform: c,
        elements: a
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...v
      } = yh(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const b = vh(i), A = ff(l), w = vh(l) === l, O = await (c.isRTL == null ? void 0 : c.isRTL(a.floating)), x = d || (w || !m ? [bL(l)] : unn(l)), S = h !== "none";
      !d && S && x.push(...hnn(l, m, h, O));
      const E = [l, ...x], k = await Fk(t, v), T = [];
      let R = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (u && T.push(k[b]), f) {
        const _ = cnn(i, s, O);
        T.push(k[_[0]], k[_[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: T
      }], !T.every((_) => _ <= 0)) {
        var j, F;
        const _ = (((j = o.flip) == null ? void 0 : j.index) || 0) + 1, U = E[_];
        if (U && (!(f === "alignment" ? A !== ff(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((I) => ff(I.placement) === A ? I.overflows[0] > 0 : !0)))
          return {
            data: {
              index: _,
              overflows: R
            },
            reset: {
              placement: U
            }
          };
        let z = (F = R.filter((C) => C.overflows[0] <= 0).sort((C, I) => C.overflows[1] - I.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!z)
          switch (p) {
            case "bestFit": {
              var L;
              const C = (L = R.filter((I) => {
                if (S) {
                  const M = ff(I.placement);
                  return M === A || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((M) => M > 0).reduce((M, D) => M + D, 0)]).sort((I, M) => I[1] - M[1])[0]) == null ? void 0 : L[0];
              C && (z = C);
              break;
            }
            case "initialPlacement":
              z = l;
              break;
          }
        if (i !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
};
function Khe(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ghe(e) {
  return onn.some((t) => e[t] >= 0);
}
const bnn = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = yh(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await Fk(t, {
            ...i,
            elementContext: "reference"
          }), s = Khe(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Ghe(s)
            }
          };
        }
        case "escaped": {
          const o = await Fk(t, {
            ...i,
            altBoundary: !0
          }), s = Khe(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Ghe(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, lUe = /* @__PURE__ */ new Set(["left", "top"]);
async function Onn(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = vh(n), l = Ux(n), c = ff(n) === "y", a = lUe.has(s) ? -1 : 1, u = o && c ? -1 : 1, f = yh(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof h == "number" && (p = l === "end" ? h * -1 : h), c ? {
    x: p * u,
    y: d * a
  } : {
    x: d * a,
    y: p * u
  };
}
const Ann = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: l
      } = t, c = await Onn(t, e);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, wnn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: b,
              y: A
            } = v;
            return {
              x: b,
              y: A
            };
          }
        },
        ...c
      } = yh(e, t), a = {
        x: n,
        y: r
      }, u = await Fk(t, c), f = ff(vh(i)), d = NJ(f);
      let p = a[d], h = a[f];
      if (o) {
        const v = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", A = p + u[v], w = p - u[b];
        p = k7(A, p, w);
      }
      if (s) {
        const v = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", A = h + u[v], w = h - u[b];
        h = k7(A, h, w);
      }
      const m = l.fn({
        ...t,
        [d]: p,
        [f]: h
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [d]: o,
            [f]: s
          }
        }
      };
    }
  };
}, xnn = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: s
      } = t, {
        offset: l = 0,
        mainAxis: c = !0,
        crossAxis: a = !0
      } = yh(e, t), u = {
        x: n,
        y: r
      }, f = ff(i), d = NJ(f);
      let p = u[d], h = u[f];
      const m = yh(l, t), v = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const w = d === "y" ? "height" : "width", O = o.reference[d] - o.floating[w] + v.mainAxis, x = o.reference[d] + o.reference[w] - v.mainAxis;
        p < O ? p = O : p > x && (p = x);
      }
      if (a) {
        var b, A;
        const w = d === "y" ? "width" : "height", O = lUe.has(vh(i)), x = o.reference[f] - o.floating[w] + (O && ((b = s.offset) == null ? void 0 : b[f]) || 0) + (O ? 0 : v.crossAxis), S = o.reference[f] + o.reference[w] + (O ? 0 : ((A = s.offset) == null ? void 0 : A[f]) || 0) - (O ? v.crossAxis : 0);
        h < x ? h = x : h > S && (h = S);
      }
      return {
        [d]: p,
        [f]: h
      };
    }
  };
}, Snn = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: s,
        elements: l
      } = t, {
        apply: c = () => {
        },
        ...a
      } = yh(e, t), u = await Fk(t, a), f = vh(i), d = Ux(i), p = ff(i) === "y", {
        width: h,
        height: m
      } = o.floating;
      let v, b;
      f === "top" || f === "bottom" ? (v = f, b = d === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (b = f, v = d === "end" ? "top" : "bottom");
      const A = m - u.top - u.bottom, w = h - u.left - u.right, O = pg(m - u[v], A), x = pg(h - u[b], w), S = !t.middlewareData.shift;
      let E = O, k = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = w), (r = t.middlewareData.shift) != null && r.enabled.y && (E = A), S && !d) {
        const R = Hl(u.left, 0), j = Hl(u.right, 0), F = Hl(u.top, 0), L = Hl(u.bottom, 0);
        p ? k = h - 2 * (R !== 0 || j !== 0 ? R + j : Hl(u.left, u.right)) : E = m - 2 * (F !== 0 || L !== 0 ? F + L : Hl(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: k,
        availableHeight: E
      });
      const T = await s.getDimensions(l.floating);
      return h !== T.width || m !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function P3() {
  return typeof window < "u";
}
function Vx(e) {
  return cUe(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ac(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Qf(e) {
  var t;
  return (t = (cUe(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function cUe(e) {
  return P3() ? e instanceof Node || e instanceof ac(e).Node : !1;
}
function ld(e) {
  return P3() ? e instanceof Element || e instanceof ac(e).Element : !1;
}
function Pf(e) {
  return P3() ? e instanceof HTMLElement || e instanceof ac(e).HTMLElement : !1;
}
function Yhe(e) {
  return !P3() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ac(e).ShadowRoot;
}
const Enn = /* @__PURE__ */ new Set(["inline", "contents"]);
function JN(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = cd(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Enn.has(i);
}
const Tnn = /* @__PURE__ */ new Set(["table", "td", "th"]);
function knn(e) {
  return Tnn.has(Vx(e));
}
const Cnn = [":popover-open", ":modal"];
function I3(e) {
  return Cnn.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Nnn = ["transform", "translate", "scale", "rotate", "perspective"], Pnn = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Inn = ["paint", "layout", "strict", "content"];
function RJ(e) {
  const t = MJ(), n = ld(e) ? cd(e) : e;
  return Nnn.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Pnn.some((r) => (n.willChange || "").includes(r)) || Inn.some((r) => (n.contain || "").includes(r));
}
function Rnn(e) {
  let t = hg(e);
  for (; Pf(t) && !Mw(t); ) {
    if (RJ(t))
      return t;
    if (I3(t))
      return null;
    t = hg(t);
  }
  return null;
}
function MJ() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Mnn = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Mw(e) {
  return Mnn.has(Vx(e));
}
function cd(e) {
  return ac(e).getComputedStyle(e);
}
function R3(e) {
  return ld(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function hg(e) {
  if (Vx(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yhe(e) && e.host || // Fallback.
    Qf(e)
  );
  return Yhe(t) ? t.host : t;
}
function uUe(e) {
  const t = hg(e);
  return Mw(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Pf(t) && JN(t) ? t : uUe(t);
}
function Uk(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = uUe(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = ac(i);
  if (o) {
    const l = N7(s);
    return t.concat(s, s.visualViewport || [], JN(i) ? i : [], l && n ? Uk(l) : []);
  }
  return t.concat(i, Uk(i, [], n));
}
function N7(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function dUe(e) {
  const t = cd(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Pf(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, l = vL(n) !== o || vL(r) !== s;
  return l && (n = o, r = s), {
    width: n,
    height: r,
    $: l
  };
}
function DJ(e) {
  return ld(e) ? e : e.contextElement;
}
function dA(e) {
  const t = DJ(e);
  if (!Pf(t))
    return bf(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = dUe(t);
  let s = (o ? vL(n.width) : n.width) / r, l = (o ? vL(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const Dnn = /* @__PURE__ */ bf(0);
function fUe(e) {
  const t = ac(e);
  return !MJ() || !t.visualViewport ? Dnn : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function _nn(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ac(e) ? !1 : t;
}
function rb(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = DJ(e);
  let s = bf(1);
  t && (r ? ld(r) && (s = dA(r)) : s = dA(e));
  const l = _nn(o, n, r) ? fUe(o) : bf(0);
  let c = (i.left + l.x) / s.x, a = (i.top + l.y) / s.y, u = i.width / s.x, f = i.height / s.y;
  if (o) {
    const d = ac(o), p = r && ld(r) ? ac(r) : r;
    let h = d, m = N7(h);
    for (; m && r && p !== h; ) {
      const v = dA(m), b = m.getBoundingClientRect(), A = cd(m), w = b.left + (m.clientLeft + parseFloat(A.paddingLeft)) * v.x, O = b.top + (m.clientTop + parseFloat(A.paddingTop)) * v.y;
      c *= v.x, a *= v.y, u *= v.x, f *= v.y, c += w, a += O, h = ac(m), m = N7(h);
    }
  }
  return OL({
    width: u,
    height: f,
    x: c,
    y: a
  });
}
function M3(e, t) {
  const n = R3(e).scrollLeft;
  return t ? t.left + n : rb(Qf(e)).left + n;
}
function pUe(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - M3(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Lnn(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = Qf(r), l = t ? I3(t.floating) : !1;
  if (r === s || l && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = bf(1);
  const u = bf(0), f = Pf(r);
  if ((f || !f && !o) && ((Vx(r) !== "body" || JN(s)) && (c = R3(r)), Pf(r))) {
    const p = rb(r);
    a = dA(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  const d = s && !f && !o ? pUe(s, c) : bf(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - c.scrollLeft * a.x + u.x + d.x,
    y: n.y * a.y - c.scrollTop * a.y + u.y + d.y
  };
}
function znn(e) {
  return Array.from(e.getClientRects());
}
function jnn(e) {
  const t = Qf(e), n = R3(e), r = e.ownerDocument.body, i = Hl(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Hl(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + M3(e);
  const l = -n.scrollTop;
  return cd(r).direction === "rtl" && (s += Hl(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
const Jhe = 25;
function Fnn(e, t) {
  const n = ac(e), r = Qf(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, l = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const u = MJ();
    (!u || u && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  const a = M3(r);
  if (a <= 0) {
    const u = r.ownerDocument, f = u.body, d = getComputedStyle(f), p = u.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0, h = Math.abs(r.clientWidth - f.clientWidth - p);
    h <= Jhe && (o -= h);
  } else a <= Jhe && (o += a);
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
const Unn = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Vnn(e, t) {
  const n = rb(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = Pf(e) ? dA(e) : bf(1), s = e.clientWidth * o.x, l = e.clientHeight * o.y, c = i * o.x, a = r * o.y;
  return {
    width: s,
    height: l,
    x: c,
    y: a
  };
}
function eme(e, t, n) {
  let r;
  if (t === "viewport")
    r = Fnn(e, n);
  else if (t === "document")
    r = jnn(Qf(e));
  else if (ld(t))
    r = Vnn(t, n);
  else {
    const i = fUe(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return OL(r);
}
function hUe(e, t) {
  const n = hg(e);
  return n === t || !ld(n) || Mw(n) ? !1 : cd(n).position === "fixed" || hUe(n, t);
}
function qnn(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Uk(e, [], !1).filter((l) => ld(l) && Vx(l) !== "body"), i = null;
  const o = cd(e).position === "fixed";
  let s = o ? hg(e) : e;
  for (; ld(s) && !Mw(s); ) {
    const l = cd(s), c = RJ(s);
    !c && l.position === "fixed" && (i = null), (o ? !c && !i : !c && l.position === "static" && !!i && Unn.has(i.position) || JN(s) && !c && hUe(e, s)) ? r = r.filter((u) => u !== s) : i = l, s = hg(s);
  }
  return t.set(e, r), r;
}
function Bnn(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? I3(t) ? [] : qnn(t, this._c) : [].concat(n), r], l = s[0], c = s.reduce((a, u) => {
    const f = eme(t, u, i);
    return a.top = Hl(f.top, a.top), a.right = pg(f.right, a.right), a.bottom = pg(f.bottom, a.bottom), a.left = Hl(f.left, a.left), a;
  }, eme(t, l, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Xnn(e) {
  const {
    width: t,
    height: n
  } = dUe(e);
  return {
    width: t,
    height: n
  };
}
function Wnn(e, t, n) {
  const r = Pf(t), i = Qf(t), o = n === "fixed", s = rb(e, !0, o, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = bf(0);
  function a() {
    c.x = M3(i);
  }
  if (r || !r && !o)
    if ((Vx(t) !== "body" || JN(i)) && (l = R3(t)), r) {
      const p = rb(t, !0, o, t);
      c.x = p.x + t.clientLeft, c.y = p.y + t.clientTop;
    } else i && a();
  o && !r && i && a();
  const u = i && !r && !o ? pUe(i, l) : bf(0), f = s.left + l.scrollLeft - c.x - u.x, d = s.top + l.scrollTop - c.y - u.y;
  return {
    x: f,
    y: d,
    width: s.width,
    height: s.height
  };
}
function VV(e) {
  return cd(e).position === "static";
}
function tme(e, t) {
  if (!Pf(e) || cd(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Qf(e) === n && (n = n.ownerDocument.body), n;
}
function mUe(e, t) {
  const n = ac(e);
  if (I3(e))
    return n;
  if (!Pf(e)) {
    let i = hg(e);
    for (; i && !Mw(i); ) {
      if (ld(i) && !VV(i))
        return i;
      i = hg(i);
    }
    return n;
  }
  let r = tme(e, t);
  for (; r && knn(r) && VV(r); )
    r = tme(r, t);
  return r && Mw(r) && VV(r) && !RJ(r) ? n : r || Rnn(e) || n;
}
const Znn = async function(e) {
  const t = this.getOffsetParent || mUe, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Wnn(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Hnn(e) {
  return cd(e).direction === "rtl";
}
const Qnn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Lnn,
  getDocumentElement: Qf,
  getClippingRect: Bnn,
  getOffsetParent: mUe,
  getElementRects: Znn,
  getClientRects: znn,
  getDimensions: Xnn,
  getScale: dA,
  isElement: ld,
  isRTL: Hnn
};
function gUe(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function $nn(e, t) {
  let n = null, r;
  const i = Qf(e);
  function o() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), o();
    const a = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: d,
      height: p
    } = a;
    if (l || t(), !d || !p)
      return;
    const h = hR(f), m = hR(i.clientWidth - (u + d)), v = hR(i.clientHeight - (f + p)), b = hR(u), w = {
      rootMargin: -h + "px " + -m + "px " + -v + "px " + -b + "px",
      threshold: Hl(0, pg(1, c)) || 1
    };
    let O = !0;
    function x(S) {
      const E = S[0].intersectionRatio;
      if (E !== c) {
        if (!O)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !gUe(a, e.getBoundingClientRect()) && s(), O = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function Knn(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, a = DJ(e), u = i || o ? [...a ? Uk(a) : [], ...Uk(t)] : [];
  u.forEach((b) => {
    i && b.addEventListener("scroll", n, {
      passive: !0
    }), o && b.addEventListener("resize", n);
  });
  const f = a && l ? $nn(a, n) : null;
  let d = -1, p = null;
  s && (p = new ResizeObserver((b) => {
    let [A] = b;
    A && A.target === a && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var w;
      (w = p) == null || w.observe(t);
    })), n();
  }), a && !c && p.observe(a), p.observe(t));
  let h, m = c ? rb(e) : null;
  c && v();
  function v() {
    const b = rb(e);
    m && !gUe(m, b) && n(), m = b, h = requestAnimationFrame(v);
  }
  return n(), () => {
    var b;
    u.forEach((A) => {
      i && A.removeEventListener("scroll", n), o && A.removeEventListener("resize", n);
    }), f == null || f(), (b = p) == null || b.disconnect(), p = null, c && cancelAnimationFrame(h);
  };
}
const Gnn = Ann, Ynn = wnn, Jnn = vnn, ern = Snn, trn = bnn, nme = ynn, nrn = xnn, rrn = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Qnn,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return gnn(e, t, {
    ...i,
    platform: o
  });
};
var irn = typeof document < "u", orn = function() {
}, NM = irn ? Og : orn;
function AL(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!AL(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !AL(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function yUe(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function rme(e, t) {
  const n = yUe(e);
  return Math.round(t * n) / n;
}
function qV(e) {
  const t = N.useRef(e);
  return NM(() => {
    t.current = e;
  }), t;
}
function srn(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: a
  } = e, [u, f] = N.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, p] = N.useState(r);
  AL(d, r) || p(r);
  const [h, m] = N.useState(null), [v, b] = N.useState(null), A = N.useCallback((I) => {
    I !== S.current && (S.current = I, m(I));
  }, []), w = N.useCallback((I) => {
    I !== E.current && (E.current = I, b(I));
  }, []), O = o || h, x = s || v, S = N.useRef(null), E = N.useRef(null), k = N.useRef(u), T = c != null, R = qV(c), j = qV(i), F = qV(a), L = N.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const I = {
      placement: t,
      strategy: n,
      middleware: d
    };
    j.current && (I.platform = j.current), rrn(S.current, E.current, I).then((M) => {
      const D = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      _.current && !AL(k.current, D) && (k.current = D, sb.flushSync(() => {
        f(D);
      }));
    });
  }, [d, t, n, j, F]);
  NM(() => {
    a === !1 && k.current.isPositioned && (k.current.isPositioned = !1, f((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [a]);
  const _ = N.useRef(!1);
  NM(() => (_.current = !0, () => {
    _.current = !1;
  }), []), NM(() => {
    if (O && (S.current = O), x && (E.current = x), O && x) {
      if (R.current)
        return R.current(O, x, L);
      L();
    }
  }, [O, x, L, R, T]);
  const U = N.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: A,
    setFloating: w
  }), [A, w]), z = N.useMemo(() => ({
    reference: O,
    floating: x
  }), [O, x]), C = N.useMemo(() => {
    const I = {
      position: n,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return I;
    const M = rme(z.floating, u.x), D = rme(z.floating, u.y);
    return l ? {
      ...I,
      transform: "translate(" + M + "px, " + D + "px)",
      ...yUe(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: D
    };
  }, [n, l, z.floating, u.x, u.y]);
  return N.useMemo(() => ({
    ...u,
    update: L,
    refs: U,
    elements: z,
    floatingStyles: C
  }), [u, L, U, z, C]);
}
const arn = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? nme({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? nme({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, lrn = (e, t) => ({
  ...Gnn(e),
  options: [e, t]
}), crn = (e, t) => ({
  ...Ynn(e),
  options: [e, t]
}), urn = (e, t) => ({
  ...nrn(e),
  options: [e, t]
}), drn = (e, t) => ({
  ...Jnn(e),
  options: [e, t]
}), frn = (e, t) => ({
  ...ern(e),
  options: [e, t]
}), prn = (e, t) => ({
  ...trn(e),
  options: [e, t]
}), hrn = (e, t) => ({
  ...arn(e),
  options: [e, t]
});
var mrn = "Arrow", vUe = N.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ y(
    to.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ y("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
vUe.displayName = mrn;
var grn = vUe;
function yrn(e) {
  const [t, n] = N.useState(void 0);
  return rd(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let s, l;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, a = Array.isArray(c) ? c[0] : c;
          s = a.inlineSize, l = a.blockSize;
        } else
          s = e.offsetWidth, l = e.offsetHeight;
        n({ width: s, height: l });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var _J = "Popper", [bUe, OUe] = Tx(_J), [vrn, AUe] = bUe(_J), wUe = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = N.useState(null);
  return /* @__PURE__ */ y(vrn, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
wUe.displayName = _J;
var xUe = "PopperAnchor", SUe = N.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = AUe(xUe, n), s = N.useRef(null), l = ja(t, s), c = N.useRef(null);
    return N.useEffect(() => {
      const a = c.current;
      c.current = (r == null ? void 0 : r.current) || s.current, a !== c.current && o.onAnchorChange(c.current);
    }), r ? null : /* @__PURE__ */ y(to.div, { ...i, ref: l });
  }
);
SUe.displayName = xUe;
var LJ = "PopperContent", [brn, Orn] = bUe(LJ), EUe = N.forwardRef(
  (e, t) => {
    var oe, ce, fe, $, pe, ee;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: s = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: a = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: h,
      ...m
    } = e, v = AUe(LJ, n), [b, A] = N.useState(null), w = ja(t, (Ce) => A(Ce)), [O, x] = N.useState(null), S = yrn(O), E = (S == null ? void 0 : S.width) ?? 0, k = (S == null ? void 0 : S.height) ?? 0, T = r + (o !== "center" ? "-" + o : ""), R = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, j = Array.isArray(a) ? a : [a], F = j.length > 0, L = {
      padding: R,
      boundary: j.filter(wrn),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: _, floatingStyles: U, placement: z, isPositioned: C, middlewareData: I } = srn({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: T,
      whileElementsMounted: (...Ce) => Knn(...Ce, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        lrn({ mainAxis: i + k, alignmentAxis: s }),
        c && crn({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? urn() : void 0,
          ...L
        }),
        c && drn({ ...L }),
        frn({
          ...L,
          apply: ({ elements: Ce, rects: Ee, availableWidth: Ve, availableHeight: et }) => {
            const { width: ft, height: me } = Ee.reference, Te = Ce.floating.style;
            Te.setProperty("--radix-popper-available-width", `${Ve}px`), Te.setProperty("--radix-popper-available-height", `${et}px`), Te.setProperty("--radix-popper-anchor-width", `${ft}px`), Te.setProperty("--radix-popper-anchor-height", `${me}px`);
          }
        }),
        O && hrn({ element: O, padding: l }),
        xrn({ arrowWidth: E, arrowHeight: k }),
        d && prn({ strategy: "referenceHidden", ...L })
      ]
    }), [M, D] = CUe(z), X = ag(h);
    rd(() => {
      C && (X == null || X());
    }, [C, X]);
    const B = (oe = I.arrow) == null ? void 0 : oe.x, q = (ce = I.arrow) == null ? void 0 : ce.y, H = ((fe = I.arrow) == null ? void 0 : fe.centerOffset) !== 0, [Y, J] = N.useState();
    return rd(() => {
      b && J(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ y(
      "div",
      {
        ref: _.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: C ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Y,
          "--radix-popper-transform-origin": [
            ($ = I.transformOrigin) == null ? void 0 : $.x,
            (pe = I.transformOrigin) == null ? void 0 : pe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ee = I.hide) == null ? void 0 : ee.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ y(
          brn,
          {
            scope: n,
            placedSide: M,
            onArrowChange: x,
            arrowX: B,
            arrowY: q,
            shouldHideArrow: H,
            children: /* @__PURE__ */ y(
              to.div,
              {
                "data-side": M,
                "data-align": D,
                ...m,
                ref: w,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: C ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
EUe.displayName = LJ;
var TUe = "PopperArrow", Arn = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, kUe = N.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Orn(TUe, r), s = Arn[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ y(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ y(
          grn,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
kUe.displayName = TUe;
function wrn(e) {
  return e !== null;
}
var xrn = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, b, A;
    const { placement: n, rects: r, middlewareData: i } = t, s = ((v = i.arrow) == null ? void 0 : v.centerOffset) !== 0, l = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [a, u] = CUe(n), f = { start: "0%", center: "50%", end: "100%" }[u], d = (((b = i.arrow) == null ? void 0 : b.x) ?? 0) + l / 2, p = (((A = i.arrow) == null ? void 0 : A.y) ?? 0) + c / 2;
    let h = "", m = "";
    return a === "bottom" ? (h = s ? f : `${d}px`, m = `${-c}px`) : a === "top" ? (h = s ? f : `${d}px`, m = `${r.floating.height + c}px`) : a === "right" ? (h = `${-c}px`, m = s ? f : `${p}px`) : a === "left" && (h = `${r.floating.width + c}px`, m = s ? f : `${p}px`), { data: { x: h, y: m } };
  }
});
function CUe(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Srn = wUe, Ern = SUe, Trn = EUe, krn = kUe, BV, D3 = "HoverCard", [NUe, _mn] = Tx(D3, [
  OUe
]), _3 = OUe(), [Crn, L3] = NUe(D3), PUe = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    openDelay: s = 700,
    closeDelay: l = 300
  } = e, c = _3(t), a = N.useRef(0), u = N.useRef(0), f = N.useRef(!1), d = N.useRef(!1), [p, h] = p_({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: D3
  }), m = N.useCallback(() => {
    clearTimeout(u.current), a.current = window.setTimeout(() => h(!0), s);
  }, [s, h]), v = N.useCallback(() => {
    clearTimeout(a.current), !f.current && !d.current && (u.current = window.setTimeout(() => h(!1), l));
  }, [l, h]), b = N.useCallback(() => h(!1), [h]);
  return N.useEffect(() => () => {
    clearTimeout(a.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ y(
    Crn,
    {
      scope: t,
      open: p,
      onOpenChange: h,
      onOpen: m,
      onClose: v,
      onDismiss: b,
      hasSelectionRef: f,
      isPointerDownOnContentRef: d,
      children: /* @__PURE__ */ y(Srn, { ...c, children: n })
    }
  );
};
PUe.displayName = D3;
var IUe = "HoverCardTrigger", RUe = N.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, i = L3(IUe, n), o = _3(n);
    return /* @__PURE__ */ y(Ern, { asChild: !0, ...o, children: /* @__PURE__ */ y(
      to.a,
      {
        "data-state": i.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: bs(e.onPointerEnter, xL(i.onOpen)),
        onPointerLeave: bs(e.onPointerLeave, xL(i.onClose)),
        onFocus: bs(e.onFocus, i.onOpen),
        onBlur: bs(e.onBlur, i.onClose),
        onTouchStart: bs(e.onTouchStart, (s) => s.preventDefault())
      }
    ) });
  }
);
RUe.displayName = IUe;
var zJ = "HoverCardPortal", [Nrn, Prn] = NUe(zJ, {
  forceMount: void 0
}), MUe = (e) => {
  const { __scopeHoverCard: t, forceMount: n, children: r, container: i } = e, o = L3(zJ, t);
  return /* @__PURE__ */ y(Nrn, { scope: t, forceMount: n, children: /* @__PURE__ */ y(kx, { present: n || o.open, children: /* @__PURE__ */ y(uG, { asChild: !0, container: i, children: r }) }) });
};
MUe.displayName = zJ;
var wL = "HoverCardContent", DUe = N.forwardRef(
  (e, t) => {
    const n = Prn(wL, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...i } = e, o = L3(wL, e.__scopeHoverCard);
    return /* @__PURE__ */ y(kx, { present: r || o.open, children: /* @__PURE__ */ y(
      Irn,
      {
        "data-state": o.open ? "open" : "closed",
        ...i,
        onPointerEnter: bs(e.onPointerEnter, xL(o.onOpen)),
        onPointerLeave: bs(e.onPointerLeave, xL(o.onClose)),
        ref: t
      }
    ) });
  }
);
DUe.displayName = wL;
var Irn = N.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: i,
    onFocusOutside: o,
    onInteractOutside: s,
    ...l
  } = e, c = L3(wL, n), a = _3(n), u = N.useRef(null), f = ja(t, u), [d, p] = N.useState(!1);
  return N.useEffect(() => {
    if (d) {
      const h = document.body;
      return BV = h.style.userSelect || h.style.webkitUserSelect, h.style.userSelect = "none", h.style.webkitUserSelect = "none", () => {
        h.style.userSelect = BV, h.style.webkitUserSelect = BV;
      };
    }
  }, [d]), N.useEffect(() => {
    if (u.current) {
      const h = () => {
        p(!1), c.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var v;
          ((v = document.getSelection()) == null ? void 0 : v.toString()) !== "" && (c.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", h), () => {
        document.removeEventListener("pointerup", h), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [c.isPointerDownOnContentRef, c.hasSelectionRef]), N.useEffect(() => {
    u.current && Drn(u.current).forEach((m) => m.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ y(
    cG,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: s,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: bs(o, (h) => {
        h.preventDefault();
      }),
      onDismiss: c.onDismiss,
      children: /* @__PURE__ */ y(
        Trn,
        {
          ...a,
          ...l,
          onPointerDown: bs(l.onPointerDown, (h) => {
            h.currentTarget.contains(h.target) && p(!0), c.hasSelectionRef.current = !1, c.isPointerDownOnContentRef.current = !0;
          }),
          ref: f,
          style: {
            ...l.style,
            userSelect: d ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: d ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), Rrn = "HoverCardArrow", Mrn = N.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, i = _3(n);
    return /* @__PURE__ */ y(krn, { ...i, ...r, ref: t });
  }
);
Mrn.displayName = Rrn;
function xL(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function Drn(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var _rn = PUe, Lrn = RUe, zrn = MUe, jrn = DUe;
function Frn({
  ...e
}) {
  return /* @__PURE__ */ y(_rn, { "data-slot": "hover-card", ...e });
}
function Urn({
  ...e
}) {
  return /* @__PURE__ */ y(Lrn, { "data-slot": "hover-card-trigger", ...e });
}
function Vrn({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  return /* @__PURE__ */ y(zrn, { "data-slot": "hover-card-portal", children: /* @__PURE__ */ y(
    jrn,
    {
      "data-slot": "hover-card-content",
      align: t,
      sideOffset: n,
      className: Se(
        "cn-hover-card-content z-50 origin-(--radix-hover-card-content-transform-origin) outline-none",
        e
      ),
      ...r
    }
  ) });
}
const qrn = ({
  id: e,
  includeAvatar: t = !0,
  includeName: n = !1,
  size: r = "medium",
  hideHover: i = !1
}) => {
  const o = r === "small" ? 24 : 32, { data: s } = gj.useUserById(e);
  if (!s || De(e))
    return /* @__PURE__ */ y("span", { className: "text-muted-foreground", children: "—" });
  const l = /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
    t && /* @__PURE__ */ y("div", { className: "shrink-0", children: /* @__PURE__ */ y(
      aL,
      {
        name: `${s.firstName} ${s.lastName}`,
        email: s.email,
        size: o,
        disableTooltip: !0
      }
    ) }),
    n && /* @__PURE__ */ y("span", { className: "text-xs truncate", children: `${s.firstName}` })
  ] });
  return i ? l : /* @__PURE__ */ V(Frn, { children: [
    /* @__PURE__ */ y(Urn, { asChild: !0, children: /* @__PURE__ */ y("div", { className: "cursor-pointer", children: l }) }),
    /* @__PURE__ */ V(
      Vrn,
      {
        className: "w-80 rounded-md border bg-background p-4 shadow-md",
        align: "start",
        children: [
          /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ y(
              aL,
              {
                name: `${s.firstName} ${s.lastName}`,
                email: s.email,
                size: 36,
                disableTooltip: !0
              }
            ),
            /* @__PURE__ */ V("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ y("div", { className: "flex items-center justify-between gap-2", children: /* @__PURE__ */ V("h4", { className: "text-sm font-semibold leading-none truncate", children: [
                s.firstName,
                " ",
                s.lastName
              ] }) }),
              /* @__PURE__ */ V("div", { className: "flex items-center gap-2 mt-1.5", children: [
                /* @__PURE__ */ y(pot, { className: "h-3.5 w-3.5 text-muted-foreground shrink-0" }),
                /* @__PURE__ */ y("span", { className: "text-xs text-muted-foreground truncate", children: s.email })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ y(inn, { user: s, showLockedBadges: !1, showBorder: !0 })
        ]
      }
    )
  ] });
}, ime = ({ comment: e, showConnector: t }) => /* @__PURE__ */ y("div", { className: "relative", children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-1", children: [
  /* @__PURE__ */ V("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ y(qrn, { size: "medium", id: e.authorId }),
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ y("div", { className: "text-sm font-bold", children: e.authorName }),
      /* @__PURE__ */ V("div", { className: "text-xs text-muted-foreground", children: [
        "created ",
        rc.formatDateToAgo(e.timestamp)
      ] })
    ] })
  ] }),
  /* @__PURE__ */ V("div", { className: "relative", children: [
    t && /* @__PURE__ */ y("div", { className: "absolute left-4 top-0 bottom-0 w-px bg-border" }),
    /* @__PURE__ */ y("div", { className: "pl-12", children: /* @__PURE__ */ y("div", { className: "prose prose-sm max-w-none", children: /* @__PURE__ */ y(
      uu,
      {
        markdown: e.content,
        variant: gs.BORDERLESS
      }
    ) }) }),
    t && /* @__PURE__ */ y("div", { className: "mb-8" })
  ] })
] }) }), XV = ({
  showConnector: e
}) => /* @__PURE__ */ y("div", { className: "relative", children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-1", children: [
  /* @__PURE__ */ V("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ y(Tr, { className: "w-8 h-8 rounded-full" }),
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ y(Tr, { className: "h-4 w-24" }),
      /* @__PURE__ */ y(Tr, { className: "h-3 w-20" })
    ] })
  ] }),
  /* @__PURE__ */ V("div", { className: "relative", children: [
    e && /* @__PURE__ */ y("div", { className: "absolute left-4 top-0 bottom-0 w-px bg-border" }),
    /* @__PURE__ */ y("div", { className: "pl-12", children: /* @__PURE__ */ V("div", { className: "space-y-2", children: [
      /* @__PURE__ */ y(Tr, { className: "h-4 w-full" }),
      /* @__PURE__ */ y(Tr, { className: "h-4 w-3/4" })
    ] }) }),
    e && /* @__PURE__ */ y("div", { className: "mb-8" })
  ] })
] }) }), Brn = ({ todo: e }) => {
  if (e.status.variant === Vp.NEUTRAL)
    return null;
  const t = {
    [Vp.POSITIVE]: "bg-emerald-700",
    [Vp.NEGATIVE]: "bg-destructive-300",
    [Vp.NEUTRAL]: "bg-gray-700"
  }[e.status.variant];
  return /* @__PURE__ */ y("div", { className: "flex justify-center mt-6", children: /* @__PURE__ */ y(
    "div",
    {
      className: `${t} text-background text-sm rounded-sm py-1 px-4`,
      children: Z(`This todo is now marked as ${e.status.name}`)
    }
  ) });
}, Xrn = ({
  todo: e,
  comments: t,
  isLoading: n,
  refetchComments: r
}) => {
  const i = Zv(), o = (c) => {
    const a = encodeURIComponent(JSON.stringify(c.content));
    return {
      type: "comment",
      authorType: Fl.getAuthorType(c),
      content: c.content,
      timestamp: new Date(c.created),
      authorId: Fl.getAuthorId(c),
      authorName: Fl.getAuthorName(c),
      userEmail: Fl.getAuthorEmail(c),
      key: a,
      id: c.id
    };
  }, [s, l] = He([
    {
      type: "comment",
      content: e.description ?? "",
      timestamp: new Date(e.created),
      authorId: Fl.getAuthorId(e),
      authorType: Fl.getAuthorType(e),
      authorName: Fl.getAuthorName(e),
      userEmail: Fl.getAuthorEmail(e),
      flowId: e.flowId
    }
  ]);
  return nt(() => {
    const c = (u) => {
      u.todoId === e.id && r();
    }, a = (u) => {
      l((f) => f.map((p) => p.id === u.activityId ? { ...p, content: u.content } : p));
    };
    return i.on(pi.TODO_CHANGED, c), i.on(
      pi.TODO_ACTIVITY_CHANGED,
      a
    ), () => {
      i.off(pi.TODO_CHANGED, c), i.off(
        pi.TODO_ACTIVITY_CHANGED,
        a
      );
    };
  }, [i, r]), /* @__PURE__ */ y("div", { className: "flex flex-col mt-4", children: n ? /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      ime,
      {
        comment: {
          type: "comment",
          content: e.description ?? "",
          timestamp: new Date(e.created),
          authorId: Fl.getAuthorId(e),
          authorType: Fl.getAuthorType(e),
          authorName: Fl.getAuthorName(e),
          userEmail: Fl.getAuthorEmail(e),
          flowId: e.flowId
        },
        showConnector: !0
      }
    ),
    /* @__PURE__ */ y(XV, { showConnector: !0 }),
    /* @__PURE__ */ y(XV, { showConnector: !0 }),
    /* @__PURE__ */ y(XV, { showConnector: !1 })
  ] }) : /* @__PURE__ */ V(pt, { children: [
    (t ?? []).map(o).map((c, a) => /* @__PURE__ */ y(
      ime,
      {
        comment: c,
        showConnector: a !== s.length - 1
      },
      c.id
    )),
    /* @__PURE__ */ y(Brn, { todo: e })
  ] }) });
}, Wrn = ({
  todoId: e,
  onClose: t,
  onStatusChange: n,
  className: r,
  simpleTitle: i = !1
}) => {
  const [o, s] = He(!1), l = Zv(), c = Xe(), { data: a, isLoading: u, refetch: f } = Jtn.useTodo(e);
  function d(w) {
    if (w && c.current) {
      const O = c.current.name === WA.name, x = w.status.name !== WA.name;
      O && x && (n == null || n(w.status, "agent"));
    }
    c.current = w == null ? void 0 : w.status;
  }
  nt(() => {
    a && d(a);
  }, [a]);
  const p = async (w) => {
    w.todoId === e && await f();
  }, h = async (w) => {
    w.todoId === e && await b();
  };
  nt(() => (l.on(pi.TODO_CHANGED, p), l.on(
    pi.TODO_ACTIVITY_CREATED,
    h
  ), () => {
    l.off(pi.TODO_CHANGED, p), l.off(
      pi.TODO_ACTIVITY_CREATED,
      h
    );
  }), [l, f, e]);
  const {
    data: m,
    isLoading: v,
    refetch: b
  } = enn.useComments(e), A = async (w, O) => {
    if (a) {
      s(!0);
      try {
        await uA.update(a.id, { status: w }), n == null || n(w, O);
      } finally {
        s(!1);
      }
    }
  };
  return /* @__PURE__ */ V("div", { className: Se("flex flex-col w-full ", r), children: [
    u && /* @__PURE__ */ y(_De, { mode: "container" }),
    !u && a && /* @__PURE__ */ V(Bi, { className: "flex-1 px-0", children: [
      /* @__PURE__ */ V("div", { className: "flex flex-col py-2 gap-2", children: [
        /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
          t && /* @__PURE__ */ y(Qe, { variant: "ghost", size: "icon", onClick: t, children: /* @__PURE__ */ y(ks, { className: "h-5 w-5" }) }),
          !i && /* @__PURE__ */ V("div", { className: "text-2xl font-bold flex items-center gap-4", children: [
            /* @__PURE__ */ y("div", { className: "max-w-[40ch] truncate", children: a == null ? void 0 : a.title }),
            a && /* @__PURE__ */ y(
              rnn,
              {
                todo: a,
                isUpdatingStatus: o,
                onStatusChange: A
              }
            )
          ] }),
          i && /* @__PURE__ */ y("div", { className: "text-lg font-bold flex items-center gap-4", children: /* @__PURE__ */ y("div", { className: "max-w-[40ch] truncate", children: a == null ? void 0 : a.title }) })
        ] }),
        a && /* @__PURE__ */ V(pt, { children: [
          /* @__PURE__ */ y(
            Xrn,
            {
              todo: a,
              comments: (m == null ? void 0 : m.data) ?? [],
              isLoading: v,
              refetchComments: b
            }
          ),
          /* @__PURE__ */ y(
            nnn,
            {
              todo: a,
              refetchComments: b
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ y("div", { className: "mb-10" })
    ] })
  ] });
}, Zrn = {
  get(e) {
    return dt.get("/v1/sample-data", e);
  }
}, P7 = {
  useSampleDataForFlow: (e, t) => pr({
    queryKey: ["sampleData", e == null ? void 0 : e.id],
    enabled: !!e,
    staleTime: 0,
    retry: 4,
    refetchOnWindowFocus: !1,
    queryFn: async () => {
      console.log("Getting sample data for flow version", e == null ? void 0 : e.id, e);
      const n = At.getAllSteps(e.trigger), r = await Promise.all(
        n.map(async (o) => ({
          [o.name]: await ome(
            e,
            o.name,
            t,
            Jm.OUTPUT
          )
        }))
      ), i = {};
      return r.forEach((o) => {
        Object.assign(i, o);
      }), console.log("Fetched sample data for flow version", e == null ? void 0 : e.id, i), i;
    }
  }),
  useSampleDataInputForFlow: (e, t) => pr({
    queryKey: ["sampleDataInput", e == null ? void 0 : e.id],
    enabled: !!e,
    staleTime: 0,
    retry: 4,
    refetchOnWindowFocus: !1,
    queryFn: async () => {
      const n = At.getAllSteps(e.trigger), r = await Promise.all(
        n.map(async (o) => {
          var s;
          return {
            [o.name]: (s = o.settings.sampleData) != null && s.sampleDataInputFileId ? await ome(
              e,
              o.name,
              t,
              Jm.INPUT
            ) : void 0
          };
        })
      ), i = {};
      return r.forEach((o) => {
        Object.assign(i, o);
      }), i;
    }
  }),
  invalidateSampleData: (e, t) => {
    t.invalidateQueries({ queryKey: ["sampleData", e] }), t.invalidateQueries({
      queryKey: ["sampleDataInput", e]
    });
  }
};
async function ome(e, t, n, r) {
  return Zrn.get({
    flowId: e.flowId,
    flowVersionId: e.id,
    stepName: t,
    projectId: n,
    type: r
  }).catch((i) => {
    console.error(i);
  });
}
const dO = {
  test(e) {
    return dt.post(
      "/v1/test-trigger",
      e
    );
  },
  list(e) {
    return dt.get(
      "/v1/trigger-events",
      e
    );
  },
  saveTriggerMockdata(e) {
    return dt.post("/v1/trigger-events", {
      flowId: e.flowId,
      mockData: e.mockData
    });
  }
};
function Hrn(e) {
  const t = e.split("Error:");
  if (t.length < 2)
    return e;
  const n = t.map((i) => i.trim().replace(/^\n+|\n+$/g, "")).filter((i) => i !== ""), r = "  ";
  return n.reduce((i, o, s) => {
    const l = r.repeat(s), c = n.length === 1 ? "Error" : `Error ${s + 1}`;
    return `${i}${l}${c}: ${o}
`;
  }, "");
}
const WV = {
  formatErrorMessage: Hrn
}, sme = (e) => e === void 0 ? "undefined" : "null", Hc = {
  useUpdateSampleData: (e) => {
    const t = Kw(), { flowVersionId: n, applyOperation: r, step: i, setSampleData: o } = tn((s) => ({
      flowVersionId: s.flowVersion.id,
      step: At.getStep(e, s.flowVersion.trigger),
      applyOperation: s.applyOperation,
      setSampleData: s.setSampleData
    }));
    return dr({
      mutationFn: async ({
        response: s
      }) => {
        if (De(i)) {
          console.error(`Step ${e} not found`), Kc();
          return;
        }
        if (s.success) {
          const l = De(s.output) ? sme(s.output) : s.output;
          if (o({ stepName: i.name, type: "output", value: l }), r({
            type: Tt.SAVE_SAMPLE_DATA,
            request: {
              stepName: i.name,
              payload: l,
              type: Jm.OUTPUT,
              dataType: typeof l == "string" ? wy.STRING : wy.JSON
            }
          }), s.testType === "action") {
            const c = De(s.input) ? sme(s.input) : s.input;
            o({ stepName: i.name, type: "input", value: c }), r({
              type: Tt.SAVE_SAMPLE_DATA,
              request: {
                stepName: i.name,
                payload: c,
                type: Jm.INPUT,
                dataType: typeof c == "string" ? wy.STRING : wy.JSON
              }
            });
          }
        }
      },
      onSuccess: () => {
        P7.invalidateSampleData(n, t);
      }
    });
  },
  useSimulateTrigger: ({
    setErrorMessage: e,
    onSuccess: t
  }) => {
    const { form: n, builderState: r } = mR(), i = r.flow.id, o = r.flowVersionId, { mutate: s } = Hc.useUpdateSampleData(
      n.getValues().name
    );
    return dr({
      mutationFn: async (l) => {
        e == null || e(void 0);
        const c = (await dO.list({
          projectId: Rn.getProjectId(),
          flowId: i,
          cursor: void 0,
          limit: 5
        })).data.map((u) => u.id);
        await dO.test({
          projectId: Rn.getProjectId(),
          flowId: i,
          flowVersionId: o,
          testStrategy: $l.SIMULATION
        });
        let a = 0;
        for (; a < 1e3; ) {
          if (l.aborted)
            return [];
          const u = await dO.list({
            projectId: Rn.getProjectId(),
            flowId: i,
            cursor: void 0,
            limit: 5
          }), f = u.data.map((d) => d.id);
          if (!qg(c, f))
            return u.data.length > 0 && await s({
              response: {
                testType: "trigger",
                success: !0,
                output: u.data[0].payload
              }
            }), u.data;
          await yxe(2e3), a++;
        }
        return [];
      },
      onSuccess: async (l) => {
        l.length > 0 && t();
      },
      onError: async (l) => {
        console.error(l), e == null || e(
          WV.formatErrorMessage(
            Z("There is no sample data available found for this trigger.")
          )
        );
      }
    });
  },
  useSaveMockData: ({ onSuccess: e }) => {
    const { form: t, builderState: n } = mR(), r = n.flow.id, { mutate: i } = Hc.useUpdateSampleData(
      t.getValues().name
    );
    return dr({
      mutationFn: async (o) => {
        const s = await dO.saveTriggerMockdata({
          projectId: Rn.getProjectId(),
          flowId: r,
          mockData: o
        });
        return await i({
          response: {
            testType: "mockData",
            success: !0,
            output: s.payload
          }
        }), s;
      },
      onSuccess: e
    });
  },
  usePollTrigger: ({
    setErrorMessage: e,
    onSuccess: t
  }) => {
    const { form: n, builderState: r } = mR(), i = r.flow.id, o = r.flowVersionId, { mutate: s } = Hc.useUpdateSampleData(
      n.getValues().name
    );
    return dr({
      mutationFn: async () => {
        e(void 0);
        const { data: l } = await dO.test({
          projectId: Rn.getProjectId(),
          flowId: i,
          flowVersionId: o,
          testStrategy: $l.TEST_FUNCTION
        });
        return l.length > 0 && await s({
          response: {
            testType: "trigger",
            success: !0,
            output: l[0].payload
          }
        }), l;
      },
      onSuccess: async (l) => {
        l.length > 0 && t();
      },
      onError: (l) => {
        var c;
        if (dt.isError(l)) {
          const a = (c = l.response) == null ? void 0 : c.data;
          let u = "Failed to run test step, please ensure settings are correct.";
          a.code === Ni.TEST_TRIGGER_FAILED && (u = JSON.stringify(
            {
              message: "Failed to run test step, please ensure settings are correct.",
              error: Vbe(a.params.message)
            },
            null,
            2
          )), e(u);
        } else
          e(
            WV.formatErrorMessage(
              Z("Internal error, please try again later.")
            )
          );
      }
    });
  },
  /**To reset the loading state of the mutation use a new mutation key, but to make sure sucess never gets called, use the abortSignal */
  useTestAction: ({
    currentStep: e,
    setErrorMessage: t,
    setConsoleLogs: n,
    onSuccess: r,
    mutationKey: i
  }) => {
    const o = Zv(), { flowVersionId: s } = mR().builderState, { mutate: l } = Hc.useUpdateSampleData(
      e.name
    );
    return dr({
      mutationKey: i,
      mutationFn: async (c) => (c == null ? void 0 : c.type) === "webhookAction" && !De(c == null ? void 0 : c.preExistingSampleData) ? c.preExistingSampleData : await _x.testStep({
        socket: o,
        request: {
          projectId: Rn.getProjectId(),
          flowVersionId: s,
          stepName: e.name
        },
        onProgress: c == null ? void 0 : c.onProgress,
        onFinish: (c == null ? void 0 : c.type) === "agentAction" ? c.onFinish : void 0
      }),
      onSuccess: (c) => {
        const { success: a, standardOutput: u, standardError: f } = c, d = a ? u : f;
        t == null || t(void 0), n == null || n(d ?? null), a ? (l({
          response: { testType: "action", ...c }
        }), r == null || r()) : t == null || t(
          WV.formatErrorMessage(
            d ?? Z(
              "Failed to run test step, please ensure settings are correct."
            )
          )
        );
      },
      onError: (c) => {
        c.message !== Qrn && Kc();
      }
    });
  }
}, mR = () => {
  const e = _r(), t = tn((n) => ({
    flow: n.flow,
    flowVersion: n.flowVersion,
    flowVersionId: n.flowVersion.id
  }));
  return { form: e, builderState: t };
}, Qrn = "Test step aborted";
function $rn({
  open: e,
  onOpenChange: t,
  todo: n,
  currentStep: r,
  type: i,
  setErrorMessage: o
}) {
  const { mutate: s } = Hc.useUpdateSampleData(
    r.name
  ), l = (u) => {
    var p;
    if (i === $s.INTERNAL)
      return {
        status: u.status.name
      };
    const f = (p = u.resolveUrl) == null ? void 0 : p.split("/flow-runs/")[0], d = u.statusOptions.map((h) => ({
      name: h.name,
      url: `${f}/todos/${u.id}/resolve?status=${h.name}&isTest=true`
    }));
    return {
      id: u.id,
      links: d
    };
  }, { mutate: c } = dr({
    mutationFn: async (u) => await uA.update(n.id, {
      status: u,
      isTest: !0
    }),
    onSuccess: (u) => {
      o(void 0);
      const f = l(u);
      s({
        response: { testType: "todo", output: f, success: !0 }
      }), t(!1);
    }
  }), a = (u) => {
    c(u);
  };
  return /* @__PURE__ */ y(qa, { open: e, onOpenChange: t, children: /* @__PURE__ */ y(ia, { className: "w-full max-w-3xl  p-3 overflow-hidden", children: /* @__PURE__ */ y(Wrn, { todoId: n.id, onStatusChange: a }) }) });
}
function ut(e, t, n) {
  function r(l, c) {
    if (l._zod || Object.defineProperty(l, "_zod", {
      value: {
        def: c,
        constr: s,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), l._zod.traits.has(e))
      return;
    l._zod.traits.add(e), t(l, c);
    const a = s.prototype, u = Object.keys(a);
    for (let f = 0; f < u.length; f++) {
      const d = u[f];
      d in l || (l[d] = a[d].bind(l));
    }
  }
  const i = (n == null ? void 0 : n.Parent) ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function s(l) {
    var c;
    const a = n != null && n.Parent ? new o() : this;
    r(a, l), (c = a._zod).deferred ?? (c.deferred = []);
    for (const u of a._zod.deferred)
      u();
    return a;
  }
  return Object.defineProperty(s, "init", { value: r }), Object.defineProperty(s, Symbol.hasInstance, {
    value: (l) => {
      var c, a;
      return n != null && n.Parent && l instanceof n.Parent ? !0 : (a = (c = l == null ? void 0 : l._zod) == null ? void 0 : c.traits) == null ? void 0 : a.has(e);
    }
  }), Object.defineProperty(s, "name", { value: e }), s;
}
class fA extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class _Ue extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const LUe = {};
function mg(e) {
  return LUe;
}
function Krn(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, i]) => t.indexOf(+r) === -1).map(([r, i]) => i);
}
function I7(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function jJ(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function FJ(e) {
  return e == null;
}
function UJ(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const ame = Symbol("evaluating");
function ri(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== ame)
        return r === void 0 && (r = ame, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Vb(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function qb(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function lme(e) {
  return JSON.stringify(e);
}
function Grn(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const zUe = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function SL(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Yrn = jJ(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Dw(e) {
  if (SL(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(SL(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function jUe(e) {
  return Dw(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Jrn = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function z3(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Wg(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Nn(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function ein(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function tin(e, t) {
  const n = e._zod.def, r = qb(e._zod.def, {
    get shape() {
      const i = {};
      for (const o in t) {
        if (!(o in n.shape))
          throw new Error(`Unrecognized key: "${o}"`);
        t[o] && (i[o] = n.shape[o]);
      }
      return Vb(this, "shape", i), i;
    },
    checks: []
  });
  return Wg(e, r);
}
function nin(e, t) {
  const n = e._zod.def, r = qb(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape };
      for (const o in t) {
        if (!(o in n.shape))
          throw new Error(`Unrecognized key: "${o}"`);
        t[o] && delete i[o];
      }
      return Vb(this, "shape", i), i;
    },
    checks: []
  });
  return Wg(e, r);
}
function rin(e, t) {
  if (!Dw(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const i = qb(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return Vb(this, "shape", o), o;
    },
    checks: []
  });
  return Wg(e, i);
}
function iin(e, t) {
  if (!Dw(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Vb(this, "shape", r), r;
    },
    checks: e._zod.def.checks
  };
  return Wg(e, n);
}
function oin(e, t) {
  const n = qb(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Vb(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Wg(e, n);
}
function sin(e, t, n) {
  const r = qb(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const s in n) {
          if (!(s in i))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (o[s] = e ? new e({
            type: "optional",
            innerType: i[s]
          }) : i[s]);
        }
      else
        for (const s in i)
          o[s] = e ? new e({
            type: "optional",
            innerType: i[s]
          }) : i[s];
      return Vb(this, "shape", o), o;
    },
    checks: []
  });
  return Wg(t, r);
}
function ain(e, t, n) {
  const r = qb(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (o[s] = new e({
            type: "nonoptional",
            innerType: i[s]
          }));
        }
      else
        for (const s in i)
          o[s] = new e({
            type: "nonoptional",
            innerType: i[s]
          });
      return Vb(this, "shape", o), o;
    },
    checks: []
  });
  return Wg(t, r);
}
function MO(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function DO(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function gR(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function gg(e, t, n) {
  var i, o, s, l, c, a;
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const u = gR((s = (o = (i = e.inst) == null ? void 0 : i._zod.def) == null ? void 0 : o.error) == null ? void 0 : s.call(o, e)) ?? gR((l = t == null ? void 0 : t.error) == null ? void 0 : l.call(t, e)) ?? gR((c = n.customError) == null ? void 0 : c.call(n, e)) ?? gR((a = n.localeError) == null ? void 0 : a.call(n, e)) ?? "Invalid input";
    r.message = u;
  }
  return delete r.inst, delete r.continue, t != null && t.reportInput || delete r.input, r;
}
function VJ(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Vk(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const FUe = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, I7, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, UUe = ut("$ZodError", FUe), VUe = ut("$ZodError", FUe, { Parent: Error });
function lin(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function cin(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((s) => r({ issues: s }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let s = n, l = 0;
        for (; l < o.path.length; ) {
          const c = o.path[l];
          l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(t(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
        }
      }
  };
  return r(e), n;
}
const qJ = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, o);
  if (s instanceof Promise)
    throw new fA();
  if (s.issues.length) {
    const l = new ((i == null ? void 0 : i.Err) ?? e)(s.issues.map((c) => gg(c, o, mg())));
    throw zUe(l, i == null ? void 0 : i.callee), l;
  }
  return s.value;
}, BJ = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, o);
  if (s instanceof Promise && (s = await s), s.issues.length) {
    const l = new ((i == null ? void 0 : i.Err) ?? e)(s.issues.map((c) => gg(c, o, mg())));
    throw zUe(l, i == null ? void 0 : i.callee), l;
  }
  return s.value;
}, j3 = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new fA();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? UUe)(o.issues.map((s) => gg(s, i, mg())))
  } : { success: !0, data: o.value };
}, uin = /* @__PURE__ */ j3(VUe), F3 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((s) => gg(s, i, mg())))
  } : { success: !0, data: o.value };
}, din = /* @__PURE__ */ F3(VUe), fin = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return qJ(e)(t, n, i);
}, pin = (e) => (t, n, r) => qJ(e)(t, n, r), hin = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return BJ(e)(t, n, i);
}, min = (e) => async (t, n, r) => BJ(e)(t, n, r), gin = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return j3(e)(t, n, i);
}, yin = (e) => (t, n, r) => j3(e)(t, n, r), vin = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return F3(e)(t, n, i);
}, bin = (e) => async (t, n, r) => F3(e)(t, n, r), Oin = /^[cC][^\s-]{8,}$/, Ain = /^[0-9a-z]+$/, win = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, xin = /^[0-9a-vA-V]{20}$/, Sin = /^[A-Za-z0-9]{27}$/, Ein = /^[a-zA-Z0-9_-]{21}$/, Tin = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, kin = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, cme = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Cin = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Nin = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Pin() {
  return new RegExp(Nin, "u");
}
const Iin = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Rin = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Min = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Din = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _in = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, qUe = /^[A-Za-z0-9_-]*$/, Lin = /^\+(?:[0-9]){6,14}[0-9]$/, BUe = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", zin = /* @__PURE__ */ new RegExp(`^${BUe}$`);
function XUe(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function jin(e) {
  return new RegExp(`^${XUe(e)}$`);
}
function Fin(e) {
  const t = XUe({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${BUe}T(?:${r})$`);
}
const Uin = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Vin = /^[^A-Z]*$/, qin = /^[^a-z]*$/, $f = /* @__PURE__ */ ut("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Bin = /* @__PURE__ */ ut("$ZodCheckMaxLength", (e, t) => {
  var n;
  $f.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !FJ(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const s = VJ(i);
    r.issues.push({
      origin: s,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Xin = /* @__PURE__ */ ut("$ZodCheckMinLength", (e, t) => {
  var n;
  $f.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !FJ(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const s = VJ(i);
    r.issues.push({
      origin: s,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Win = /* @__PURE__ */ ut("$ZodCheckLengthEquals", (e, t) => {
  var n;
  $f.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !FJ(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const s = VJ(i), l = o > t.length;
    r.issues.push({
      origin: s,
      ...l ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), U3 = /* @__PURE__ */ ut("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  $f.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Zin = /* @__PURE__ */ ut("$ZodCheckRegex", (e, t) => {
  U3.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Hin = /* @__PURE__ */ ut("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Vin), U3.init(e, t);
}), Qin = /* @__PURE__ */ ut("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = qin), U3.init(e, t);
}), $in = /* @__PURE__ */ ut("$ZodCheckIncludes", (e, t) => {
  $f.init(e, t);
  const n = z3(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Kin = /* @__PURE__ */ ut("$ZodCheckStartsWith", (e, t) => {
  $f.init(e, t);
  const n = new RegExp(`^${z3(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Gin = /* @__PURE__ */ ut("$ZodCheckEndsWith", (e, t) => {
  $f.init(e, t);
  const n = new RegExp(`.*${z3(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Yin = /* @__PURE__ */ ut("$ZodCheckOverwrite", (e, t) => {
  $f.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class Jin {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((s) => s), i = Math.min(...r.map((s) => s.length - s.trimStart().length)), o = r.map((s) => s.slice(i)).map((s) => " ".repeat(this.indent * 2) + s);
    for (const s of o)
      this.content.push(s);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, i = [...((this == null ? void 0 : this.content) ?? [""]).map((o) => `  ${o}`)];
    return new t(...n, i.join(`
`));
  }
}
const eon = {
  major: 4,
  minor: 1,
  patch: 13
}, Eo = /* @__PURE__ */ ut("$ZodType", (e, t) => {
  var i;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = eon;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const o of r)
    for (const s of o._zod.onattach)
      s(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (i = e._zod.deferred) == null || i.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (l, c, a) => {
      let u = MO(l), f;
      for (const d of c) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(l))
            continue;
        } else if (u)
          continue;
        const p = l.issues.length, h = d._zod.check(l);
        if (h instanceof Promise && (a == null ? void 0 : a.async) === !1)
          throw new fA();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, l.issues.length !== p && (u || (u = MO(l, p)));
          });
        else {
          if (l.issues.length === p)
            continue;
          u || (u = MO(l, p));
        }
      }
      return f ? f.then(() => l) : l;
    }, s = (l, c, a) => {
      if (MO(l))
        return l.aborted = !0, l;
      const u = o(c, r, a);
      if (u instanceof Promise) {
        if (a.async === !1)
          throw new fA();
        return u.then((f) => e._zod.parse(f, a));
      }
      return e._zod.parse(u, a);
    };
    e._zod.run = (l, c) => {
      if (c.skipChecks)
        return e._zod.parse(l, c);
      if (c.direction === "backward") {
        const u = e._zod.parse({ value: l.value, issues: [] }, { ...c, skipChecks: !0 });
        return u instanceof Promise ? u.then((f) => s(f, l, c)) : s(u, l, c);
      }
      const a = e._zod.parse(l, c);
      if (a instanceof Promise) {
        if (c.async === !1)
          throw new fA();
        return a.then((u) => o(u, r, c));
      }
      return o(a, r, c);
    };
  }
  e["~standard"] = {
    validate: (o) => {
      var s;
      try {
        const l = uin(e, o);
        return l.success ? { value: l.data } : { issues: (s = l.error) == null ? void 0 : s.issues };
      } catch {
        return din(e, o).then((c) => {
          var a;
          return c.success ? { value: c.data } : { issues: (a = c.error) == null ? void 0 : a.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), XJ = /* @__PURE__ */ ut("$ZodString", (e, t) => {
  var n;
  Eo.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? Uin(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), wi = /* @__PURE__ */ ut("$ZodStringFormat", (e, t) => {
  U3.init(e, t), XJ.init(e, t);
}), ton = /* @__PURE__ */ ut("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = kin), wi.init(e, t);
}), non = /* @__PURE__ */ ut("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = cme(r));
  } else
    t.pattern ?? (t.pattern = cme());
  wi.init(e, t);
}), ron = /* @__PURE__ */ ut("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Cin), wi.init(e, t);
}), ion = /* @__PURE__ */ ut("$ZodURL", (e, t) => {
  wi.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), oon = /* @__PURE__ */ ut("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Pin()), wi.init(e, t);
}), son = /* @__PURE__ */ ut("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Ein), wi.init(e, t);
}), aon = /* @__PURE__ */ ut("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Oin), wi.init(e, t);
}), lon = /* @__PURE__ */ ut("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Ain), wi.init(e, t);
}), con = /* @__PURE__ */ ut("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = win), wi.init(e, t);
}), uon = /* @__PURE__ */ ut("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = xin), wi.init(e, t);
}), don = /* @__PURE__ */ ut("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Sin), wi.init(e, t);
}), fon = /* @__PURE__ */ ut("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Fin(t)), wi.init(e, t);
}), pon = /* @__PURE__ */ ut("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = zin), wi.init(e, t);
}), hon = /* @__PURE__ */ ut("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = jin(t)), wi.init(e, t);
}), mon = /* @__PURE__ */ ut("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Tin), wi.init(e, t);
}), gon = /* @__PURE__ */ ut("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Iin), wi.init(e, t), e._zod.bag.format = "ipv4";
}), yon = /* @__PURE__ */ ut("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Rin), wi.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), von = /* @__PURE__ */ ut("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Min), wi.init(e, t);
}), bon = /* @__PURE__ */ ut("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Din), wi.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const s = Number(o);
      if (`${s}` !== o)
        throw new Error();
      if (s < 0 || s > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function WUe(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Oon = /* @__PURE__ */ ut("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = _in), wi.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    WUe(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Aon(e) {
  if (!qUe.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return WUe(n);
}
const won = /* @__PURE__ */ ut("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = qUe), wi.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    Aon(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), xon = /* @__PURE__ */ ut("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Lin), wi.init(e, t);
});
function Son(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && (i == null ? void 0 : i.typ) !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const Eon = /* @__PURE__ */ ut("$ZodJWT", (e, t) => {
  wi.init(e, t), e._zod.check = (n) => {
    Son(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ton = /* @__PURE__ */ ut("$ZodUnknown", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n) => n;
}), kon = /* @__PURE__ */ ut("$ZodNever", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function ume(e, t, n) {
  e.issues.length && t.issues.push(...DO(n, e.issues)), t.value[n] = e.value;
}
const Con = /* @__PURE__ */ ut("$ZodArray", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let s = 0; s < i.length; s++) {
      const l = i[s], c = t.element._zod.run({
        value: l,
        issues: []
      }, r);
      c instanceof Promise ? o.push(c.then((a) => ume(a, n, s))) : ume(c, n, s);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function EL(e, t, n, r) {
  e.issues.length && t.issues.push(...DO(n, e.issues)), e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function ZUe(e) {
  var r, i, o, s;
  const t = Object.keys(e.shape);
  for (const l of t)
    if (!((s = (o = (i = (r = e.shape) == null ? void 0 : r[l]) == null ? void 0 : i._zod) == null ? void 0 : o.traits) != null && s.has("$ZodType")))
      throw new Error(`Invalid element at key "${l}": expected a Zod schema`);
  const n = ein(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function HUe(e, t, n, r, i, o) {
  const s = [], l = i.keySet, c = i.catchall._zod, a = c.def.type;
  for (const u in t) {
    if (l.has(u))
      continue;
    if (a === "never") {
      s.push(u);
      continue;
    }
    const f = c.run({ value: t[u], issues: [] }, r);
    f instanceof Promise ? e.push(f.then((d) => EL(d, n, u, t))) : EL(f, n, u, t);
  }
  return s.length && n.issues.push({
    code: "unrecognized_keys",
    keys: s,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const Non = /* @__PURE__ */ ut("$ZodObject", (e, t) => {
  Eo.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const l = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const c = { ...l };
        return Object.defineProperty(t, "shape", {
          value: c
        }), c;
      }
    });
  }
  const r = jJ(() => ZUe(t));
  ri(e._zod, "propValues", () => {
    const l = t.shape, c = {};
    for (const a in l) {
      const u = l[a]._zod;
      if (u.values) {
        c[a] ?? (c[a] = /* @__PURE__ */ new Set());
        for (const f of u.values)
          c[a].add(f);
      }
    }
    return c;
  });
  const i = SL, o = t.catchall;
  let s;
  e._zod.parse = (l, c) => {
    s ?? (s = r.value);
    const a = l.value;
    if (!i(a))
      return l.issues.push({
        expected: "object",
        code: "invalid_type",
        input: a,
        inst: e
      }), l;
    l.value = {};
    const u = [], f = s.shape;
    for (const d of s.keys) {
      const h = f[d]._zod.run({ value: a[d], issues: [] }, c);
      h instanceof Promise ? u.push(h.then((m) => EL(m, l, d, a))) : EL(h, l, d, a);
    }
    return o ? HUe(u, a, l, c, r.value, e) : u.length ? Promise.all(u).then(() => l) : l;
  };
}), Pon = /* @__PURE__ */ ut("$ZodObjectJIT", (e, t) => {
  Non.init(e, t);
  const n = e._zod.parse, r = jJ(() => ZUe(t)), i = (d) => {
    const p = new Jin(["shape", "payload", "ctx"]), h = r.value, m = (w) => {
      const O = lme(w);
      return `shape[${O}]._zod.run({ value: input[${O}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let b = 0;
    for (const w of h.keys)
      v[w] = `key_${b++}`;
    p.write("const newResult = {};");
    for (const w of h.keys) {
      const O = v[w], x = lme(w);
      p.write(`const ${O} = ${m(w)};`), p.write(`
        if (${O}.issues.length) {
          payload.issues = payload.issues.concat(${O}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${x}, ...iss.path] : [${x}]
          })));
        }
        
        
        if (${O}.value === undefined) {
          if (${x} in input) {
            newResult[${x}] = undefined;
          }
        } else {
          newResult[${x}] = ${O}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const A = p.compile();
    return (w, O) => A(d, w, O);
  };
  let o;
  const s = SL, l = !LUe.jitless, a = l && Yrn.value, u = t.catchall;
  let f;
  e._zod.parse = (d, p) => {
    f ?? (f = r.value);
    const h = d.value;
    return s(h) ? l && a && (p == null ? void 0 : p.async) === !1 && p.jitless !== !0 ? (o || (o = i(t.shape)), d = o(d, p), u ? HUe([], h, d, p, f, e) : d) : n(d, p) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: h,
      inst: e
    }), d);
  };
});
function dme(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !MO(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((s) => gg(s, r, mg())))
  }), t);
}
const Ion = /* @__PURE__ */ ut("$ZodUnion", (e, t) => {
  Eo.init(e, t), ri(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), ri(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), ri(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), ri(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => UJ(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let s = !1;
    const l = [];
    for (const c of t.options) {
      const a = c._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (a instanceof Promise)
        l.push(a), s = !0;
      else {
        if (a.issues.length === 0)
          return a;
        l.push(a);
      }
    }
    return s ? Promise.all(l).then((c) => dme(c, i, e, o)) : dme(l, i, e, o);
  };
}), Ron = /* @__PURE__ */ ut("$ZodIntersection", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), s = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || s instanceof Promise ? Promise.all([o, s]).then(([c, a]) => fme(n, c, a)) : fme(n, o, s);
  };
});
function R7(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Dw(e) && Dw(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const s = R7(e[o], t[o]);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...s.mergeErrorPath]
        };
      i[o] = s.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], s = R7(i, o);
      if (!s.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...s.mergeErrorPath]
        };
      n.push(s.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function fme(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), MO(e))
    return e;
  const r = R7(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const Mon = /* @__PURE__ */ ut("$ZodRecord", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Dw(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const o = [], s = t.keyType._zod.values;
    if (s) {
      n.value = {};
      const l = /* @__PURE__ */ new Set();
      for (const a of s)
        if (typeof a == "string" || typeof a == "number" || typeof a == "symbol") {
          l.add(typeof a == "number" ? a.toString() : a);
          const u = t.valueType._zod.run({ value: i[a], issues: [] }, r);
          u instanceof Promise ? o.push(u.then((f) => {
            f.issues.length && n.issues.push(...DO(a, f.issues)), n.value[a] = f.value;
          })) : (u.issues.length && n.issues.push(...DO(a, u.issues)), n.value[a] = u.value);
        }
      let c;
      for (const a in i)
        l.has(a) || (c = c ?? [], c.push(a));
      c && c.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: c
      });
    } else {
      n.value = {};
      for (const l of Reflect.ownKeys(i)) {
        if (l === "__proto__")
          continue;
        const c = t.keyType._zod.run({ value: l, issues: [] }, r);
        if (c instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (c.issues.length) {
          n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: c.issues.map((u) => gg(u, r, mg())),
            input: l,
            path: [l],
            inst: e
          }), n.value[c.value] = c.value;
          continue;
        }
        const a = t.valueType._zod.run({ value: i[l], issues: [] }, r);
        a instanceof Promise ? o.push(a.then((u) => {
          u.issues.length && n.issues.push(...DO(l, u.issues)), n.value[c.value] = u.value;
        })) : (a.issues.length && n.issues.push(...DO(l, a.issues)), n.value[c.value] = a.value);
      }
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
}), Don = /* @__PURE__ */ ut("$ZodEnum", (e, t) => {
  Eo.init(e, t);
  const n = Krn(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => Jrn.has(typeof i)).map((i) => typeof i == "string" ? z3(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const s = i.value;
    return r.has(s) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: s,
      inst: e
    }), i;
  };
}), _on = /* @__PURE__ */ ut("$ZodTransform", (e, t) => {
  Eo.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new _Ue(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((s) => (n.value = s, n));
    if (i instanceof Promise)
      throw new fA();
    return n.value = i, n;
  };
});
function pme(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Lon = /* @__PURE__ */ ut("$ZodOptional", (e, t) => {
  Eo.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", ri(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), ri(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${UJ(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => pme(o, n.value)) : pme(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), zon = /* @__PURE__ */ ut("$ZodNullable", (e, t) => {
  Eo.init(e, t), ri(e._zod, "optin", () => t.innerType._zod.optin), ri(e._zod, "optout", () => t.innerType._zod.optout), ri(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${UJ(n.source)}|null)$`) : void 0;
  }), ri(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), jon = /* @__PURE__ */ ut("$ZodDefault", (e, t) => {
  Eo.init(e, t), e._zod.optin = "optional", ri(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => hme(o, t)) : hme(i, t);
  };
});
function hme(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Fon = /* @__PURE__ */ ut("$ZodPrefault", (e, t) => {
  Eo.init(e, t), e._zod.optin = "optional", ri(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Uon = /* @__PURE__ */ ut("$ZodNonOptional", (e, t) => {
  Eo.init(e, t), ri(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => mme(o, e)) : mme(i, e);
  };
});
function mme(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Von = /* @__PURE__ */ ut("$ZodCatch", (e, t) => {
  Eo.init(e, t), ri(e._zod, "optin", () => t.innerType._zod.optin), ri(e._zod, "optout", () => t.innerType._zod.optout), ri(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((s) => gg(s, r, mg()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => gg(o, r, mg()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), qon = /* @__PURE__ */ ut("$ZodPipe", (e, t) => {
  Eo.init(e, t), ri(e._zod, "values", () => t.in._zod.values), ri(e._zod, "optin", () => t.in._zod.optin), ri(e._zod, "optout", () => t.out._zod.optout), ri(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((s) => yR(s, t.in, r)) : yR(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => yR(o, t.out, r)) : yR(i, t.out, r);
  };
});
function yR(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Bon = /* @__PURE__ */ ut("$ZodReadonly", (e, t) => {
  Eo.init(e, t), ri(e._zod, "propValues", () => t.innerType._zod.propValues), ri(e._zod, "values", () => t.innerType._zod.values), ri(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), ri(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(gme) : gme(i);
  };
});
function gme(e) {
  return e.value = Object.freeze(e.value), e;
}
const Xon = /* @__PURE__ */ ut("$ZodCustom", (e, t) => {
  $f.init(e, t), Eo.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => yme(o, n, r, e));
    yme(i, n, r, e);
  };
});
function yme(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Vk(i));
  }
}
var vme;
class Won {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    if (this._map.set(t, r), r && typeof r == "object" && "id" in r) {
      if (this._idmap.has(r.id))
        throw new Error(`ID ${r.id} already exists in the registry`);
      this._idmap.set(r.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Zon() {
  return new Won();
}
(vme = globalThis).__zod_globalRegistry ?? (vme.__zod_globalRegistry = Zon());
const vR = globalThis.__zod_globalRegistry;
function Hon(e, t) {
  return new e({
    type: "string",
    ...Nn(t)
  });
}
function Qon(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function bme(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function $on(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function Kon(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Nn(t)
  });
}
function Gon(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Nn(t)
  });
}
function Yon(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Nn(t)
  });
}
function Jon(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function esn(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function tsn(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function nsn(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function rsn(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function isn(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function osn(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function ssn(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function asn(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function lsn(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function csn(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function usn(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function dsn(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function fsn(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function psn(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function hsn(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Nn(t)
  });
}
function msn(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Nn(t)
  });
}
function gsn(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Nn(t)
  });
}
function ysn(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Nn(t)
  });
}
function vsn(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Nn(t)
  });
}
function bsn(e) {
  return new e({
    type: "unknown"
  });
}
function Osn(e, t) {
  return new e({
    type: "never",
    ...Nn(t)
  });
}
function QUe(e, t) {
  return new Bin({
    check: "max_length",
    ...Nn(t),
    maximum: e
  });
}
function TL(e, t) {
  return new Xin({
    check: "min_length",
    ...Nn(t),
    minimum: e
  });
}
function $Ue(e, t) {
  return new Win({
    check: "length_equals",
    ...Nn(t),
    length: e
  });
}
function Asn(e, t) {
  return new Zin({
    check: "string_format",
    format: "regex",
    ...Nn(t),
    pattern: e
  });
}
function wsn(e) {
  return new Hin({
    check: "string_format",
    format: "lowercase",
    ...Nn(e)
  });
}
function xsn(e) {
  return new Qin({
    check: "string_format",
    format: "uppercase",
    ...Nn(e)
  });
}
function Ssn(e, t) {
  return new $in({
    check: "string_format",
    format: "includes",
    ...Nn(t),
    includes: e
  });
}
function Esn(e, t) {
  return new Kin({
    check: "string_format",
    format: "starts_with",
    ...Nn(t),
    prefix: e
  });
}
function Tsn(e, t) {
  return new Gin({
    check: "string_format",
    format: "ends_with",
    ...Nn(t),
    suffix: e
  });
}
function qx(e) {
  return new Yin({
    check: "overwrite",
    tx: e
  });
}
function ksn(e) {
  return qx((t) => t.normalize(e));
}
function Csn() {
  return qx((e) => e.trim());
}
function Nsn() {
  return qx((e) => e.toLowerCase());
}
function Psn() {
  return qx((e) => e.toUpperCase());
}
function Isn() {
  return qx((e) => Grn(e));
}
function Rsn(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Nn(n)
  });
}
function Msn(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Nn(n)
  });
}
function Dsn(e) {
  const t = _sn((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Vk(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Vk(i));
    }
  }, e(n.value, n)));
  return t;
}
function _sn(e, t) {
  const n = new $f({
    check: "custom",
    ...Nn(t)
  });
  return n._zod.check = e, n;
}
const Lsn = /* @__PURE__ */ ut("ZodISODateTime", (e, t) => {
  fon.init(e, t), Di.init(e, t);
});
function zsn(e) {
  return msn(Lsn, e);
}
const jsn = /* @__PURE__ */ ut("ZodISODate", (e, t) => {
  pon.init(e, t), Di.init(e, t);
});
function Fsn(e) {
  return gsn(jsn, e);
}
const Usn = /* @__PURE__ */ ut("ZodISOTime", (e, t) => {
  hon.init(e, t), Di.init(e, t);
});
function Vsn(e) {
  return ysn(Usn, e);
}
const qsn = /* @__PURE__ */ ut("ZodISODuration", (e, t) => {
  mon.init(e, t), Di.init(e, t);
});
function Bsn(e) {
  return vsn(qsn, e);
}
const Xsn = (e, t) => {
  UUe.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => cin(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => lin(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, I7, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, I7, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Ou = ut("ZodError", Xsn, {
  Parent: Error
}), Wsn = /* @__PURE__ */ qJ(Ou), Zsn = /* @__PURE__ */ BJ(Ou), Hsn = /* @__PURE__ */ j3(Ou), Qsn = /* @__PURE__ */ F3(Ou), $sn = /* @__PURE__ */ fin(Ou), Ksn = /* @__PURE__ */ pin(Ou), Gsn = /* @__PURE__ */ hin(Ou), Ysn = /* @__PURE__ */ min(Ou), Jsn = /* @__PURE__ */ gin(Ou), ean = /* @__PURE__ */ yin(Ou), tan = /* @__PURE__ */ vin(Ou), nan = /* @__PURE__ */ bin(Ou), Vo = /* @__PURE__ */ ut("ZodType", (e, t) => (Eo.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(qb(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
})), e.clone = (n, r) => Wg(e, n, r), e.brand = () => e, e.register = (n, r) => (n.add(e, r), e), e.parse = (n, r) => Wsn(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Hsn(e, n, r), e.parseAsync = async (n, r) => Zsn(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => Qsn(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => $sn(e, n, r), e.decode = (n, r) => Ksn(e, n, r), e.encodeAsync = async (n, r) => Gsn(e, n, r), e.decodeAsync = async (n, r) => Ysn(e, n, r), e.safeEncode = (n, r) => Jsn(e, n, r), e.safeDecode = (n, r) => ean(e, n, r), e.safeEncodeAsync = async (n, r) => tan(e, n, r), e.safeDecodeAsync = async (n, r) => nan(e, n, r), e.refine = (n, r) => e.check(Zan(n, r)), e.superRefine = (n) => e.check(Han(n)), e.overwrite = (n) => e.check(qx(n)), e.optional = () => Eme(e), e.nullable = () => Tme(e), e.nullish = () => Eme(Tme(e)), e.nonoptional = (n) => Fan(e, n), e.array = () => Ean(e), e.or = (n) => GUe([e, n]), e.and = (n) => Nan(e, n), e.transform = (n) => kme(e, Man(n)), e.default = (n) => Lan(e, n), e.prefault = (n) => jan(e, n), e.catch = (n) => Van(e, n), e.pipe = (n) => kme(e, n), e.readonly = () => Xan(e), e.describe = (n) => {
  const r = e.clone();
  return vR.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = vR.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return vR.get(e);
  const r = e.clone();
  return vR.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), KUe = /* @__PURE__ */ ut("_ZodString", (e, t) => {
  XJ.init(e, t), Vo.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(Asn(...r)), e.includes = (...r) => e.check(Ssn(...r)), e.startsWith = (...r) => e.check(Esn(...r)), e.endsWith = (...r) => e.check(Tsn(...r)), e.min = (...r) => e.check(TL(...r)), e.max = (...r) => e.check(QUe(...r)), e.length = (...r) => e.check($Ue(...r)), e.nonempty = (...r) => e.check(TL(1, ...r)), e.lowercase = (r) => e.check(wsn(r)), e.uppercase = (r) => e.check(xsn(r)), e.trim = () => e.check(Csn()), e.normalize = (...r) => e.check(ksn(...r)), e.toLowerCase = () => e.check(Nsn()), e.toUpperCase = () => e.check(Psn()), e.slugify = () => e.check(Isn());
}), ran = /* @__PURE__ */ ut("ZodString", (e, t) => {
  XJ.init(e, t), KUe.init(e, t), e.email = (n) => e.check(Qon(ian, n)), e.url = (n) => e.check(Jon(oan, n)), e.jwt = (n) => e.check(hsn(Oan, n)), e.emoji = (n) => e.check(esn(san, n)), e.guid = (n) => e.check(bme(Ome, n)), e.uuid = (n) => e.check($on(bR, n)), e.uuidv4 = (n) => e.check(Kon(bR, n)), e.uuidv6 = (n) => e.check(Gon(bR, n)), e.uuidv7 = (n) => e.check(Yon(bR, n)), e.nanoid = (n) => e.check(tsn(aan, n)), e.guid = (n) => e.check(bme(Ome, n)), e.cuid = (n) => e.check(nsn(lan, n)), e.cuid2 = (n) => e.check(rsn(can, n)), e.ulid = (n) => e.check(isn(uan, n)), e.base64 = (n) => e.check(dsn(yan, n)), e.base64url = (n) => e.check(fsn(van, n)), e.xid = (n) => e.check(osn(dan, n)), e.ksuid = (n) => e.check(ssn(fan, n)), e.ipv4 = (n) => e.check(asn(pan, n)), e.ipv6 = (n) => e.check(lsn(han, n)), e.cidrv4 = (n) => e.check(csn(man, n)), e.cidrv6 = (n) => e.check(usn(gan, n)), e.e164 = (n) => e.check(psn(ban, n)), e.datetime = (n) => e.check(zsn(n)), e.date = (n) => e.check(Fsn(n)), e.time = (n) => e.check(Vsn(n)), e.duration = (n) => e.check(Bsn(n));
});
function DS(e) {
  return Hon(ran, e);
}
const Di = /* @__PURE__ */ ut("ZodStringFormat", (e, t) => {
  wi.init(e, t), KUe.init(e, t);
}), ian = /* @__PURE__ */ ut("ZodEmail", (e, t) => {
  ron.init(e, t), Di.init(e, t);
}), Ome = /* @__PURE__ */ ut("ZodGUID", (e, t) => {
  ton.init(e, t), Di.init(e, t);
}), bR = /* @__PURE__ */ ut("ZodUUID", (e, t) => {
  non.init(e, t), Di.init(e, t);
}), oan = /* @__PURE__ */ ut("ZodURL", (e, t) => {
  ion.init(e, t), Di.init(e, t);
}), san = /* @__PURE__ */ ut("ZodEmoji", (e, t) => {
  oon.init(e, t), Di.init(e, t);
}), aan = /* @__PURE__ */ ut("ZodNanoID", (e, t) => {
  son.init(e, t), Di.init(e, t);
}), lan = /* @__PURE__ */ ut("ZodCUID", (e, t) => {
  aon.init(e, t), Di.init(e, t);
}), can = /* @__PURE__ */ ut("ZodCUID2", (e, t) => {
  lon.init(e, t), Di.init(e, t);
}), uan = /* @__PURE__ */ ut("ZodULID", (e, t) => {
  con.init(e, t), Di.init(e, t);
}), dan = /* @__PURE__ */ ut("ZodXID", (e, t) => {
  uon.init(e, t), Di.init(e, t);
}), fan = /* @__PURE__ */ ut("ZodKSUID", (e, t) => {
  don.init(e, t), Di.init(e, t);
}), pan = /* @__PURE__ */ ut("ZodIPv4", (e, t) => {
  gon.init(e, t), Di.init(e, t);
}), han = /* @__PURE__ */ ut("ZodIPv6", (e, t) => {
  yon.init(e, t), Di.init(e, t);
}), man = /* @__PURE__ */ ut("ZodCIDRv4", (e, t) => {
  von.init(e, t), Di.init(e, t);
}), gan = /* @__PURE__ */ ut("ZodCIDRv6", (e, t) => {
  bon.init(e, t), Di.init(e, t);
}), yan = /* @__PURE__ */ ut("ZodBase64", (e, t) => {
  Oon.init(e, t), Di.init(e, t);
}), van = /* @__PURE__ */ ut("ZodBase64URL", (e, t) => {
  won.init(e, t), Di.init(e, t);
}), ban = /* @__PURE__ */ ut("ZodE164", (e, t) => {
  xon.init(e, t), Di.init(e, t);
}), Oan = /* @__PURE__ */ ut("ZodJWT", (e, t) => {
  Eon.init(e, t), Di.init(e, t);
}), Aan = /* @__PURE__ */ ut("ZodUnknown", (e, t) => {
  Ton.init(e, t), Vo.init(e, t);
});
function Ame() {
  return bsn(Aan);
}
const wan = /* @__PURE__ */ ut("ZodNever", (e, t) => {
  kon.init(e, t), Vo.init(e, t);
});
function xan(e) {
  return Osn(wan, e);
}
const San = /* @__PURE__ */ ut("ZodArray", (e, t) => {
  Con.init(e, t), Vo.init(e, t), e.element = t.element, e.min = (n, r) => e.check(TL(n, r)), e.nonempty = (n) => e.check(TL(1, n)), e.max = (n, r) => e.check(QUe(n, r)), e.length = (n, r) => e.check($Ue(n, r)), e.unwrap = () => e.element;
});
function Ean(e, t) {
  return Rsn(San, e, t);
}
const Tan = /* @__PURE__ */ ut("ZodObject", (e, t) => {
  Pon.init(e, t), Vo.init(e, t), ri(e, "shape", () => t.shape), e.keyof = () => Ian(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ame() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ame() }), e.strict = () => e.clone({ ...e._zod.def, catchall: xan() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => rin(e, n), e.safeExtend = (n) => iin(e, n), e.merge = (n) => oin(e, n), e.pick = (n) => tin(e, n), e.omit = (n) => nin(e, n), e.partial = (...n) => sin(YUe, e, n[0]), e.required = (...n) => ain(JUe, e, n[0]);
});
function wme(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Nn(t)
  };
  return new Tan(n);
}
const kan = /* @__PURE__ */ ut("ZodUnion", (e, t) => {
  Ion.init(e, t), Vo.init(e, t), e.options = t.options;
});
function GUe(e, t) {
  return new kan({
    type: "union",
    options: e,
    ...Nn(t)
  });
}
const Can = /* @__PURE__ */ ut("ZodIntersection", (e, t) => {
  Ron.init(e, t), Vo.init(e, t);
});
function Nan(e, t) {
  return new Can({
    type: "intersection",
    left: e,
    right: t
  });
}
const Pan = /* @__PURE__ */ ut("ZodRecord", (e, t) => {
  Mon.init(e, t), Vo.init(e, t), e.keyType = t.keyType, e.valueType = t.valueType;
});
function xme(e, t, n) {
  return new Pan({
    type: "record",
    keyType: e,
    valueType: t,
    ...Nn(n)
  });
}
const kL = /* @__PURE__ */ ut("ZodEnum", (e, t) => {
  Don.init(e, t), Vo.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const s of r)
      if (n.has(s))
        o[s] = t.entries[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new kL({
      ...t,
      checks: [],
      ...Nn(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const s of r)
      if (n.has(s))
        delete o[s];
      else
        throw new Error(`Key ${s} not found in enum`);
    return new kL({
      ...t,
      checks: [],
      ...Nn(i),
      entries: o
    });
  };
});
function Ian(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new kL({
    type: "enum",
    entries: n,
    ...Nn(t)
  });
}
function Sme(e, t) {
  return new kL({
    type: "enum",
    entries: e,
    ...Nn(t)
  });
}
const Ran = /* @__PURE__ */ ut("ZodTransform", (e, t) => {
  _on.init(e, t), Vo.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new _Ue(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Vk(o, n.value, t));
      else {
        const s = o;
        s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = n.value), s.inst ?? (s.inst = e), n.issues.push(Vk(s));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function Man(e) {
  return new Ran({
    type: "transform",
    transform: e
  });
}
const YUe = /* @__PURE__ */ ut("ZodOptional", (e, t) => {
  Lon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Eme(e) {
  return new YUe({
    type: "optional",
    innerType: e
  });
}
const Dan = /* @__PURE__ */ ut("ZodNullable", (e, t) => {
  zon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Tme(e) {
  return new Dan({
    type: "nullable",
    innerType: e
  });
}
const _an = /* @__PURE__ */ ut("ZodDefault", (e, t) => {
  jon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Lan(e, t) {
  return new _an({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : jUe(t);
    }
  });
}
const zan = /* @__PURE__ */ ut("ZodPrefault", (e, t) => {
  Fon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function jan(e, t) {
  return new zan({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : jUe(t);
    }
  });
}
const JUe = /* @__PURE__ */ ut("ZodNonOptional", (e, t) => {
  Uon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Fan(e, t) {
  return new JUe({
    type: "nonoptional",
    innerType: e,
    ...Nn(t)
  });
}
const Uan = /* @__PURE__ */ ut("ZodCatch", (e, t) => {
  Von.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Van(e, t) {
  return new Uan({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const qan = /* @__PURE__ */ ut("ZodPipe", (e, t) => {
  qon.init(e, t), Vo.init(e, t), e.in = t.in, e.out = t.out;
});
function kme(e, t) {
  return new qan({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Ban = /* @__PURE__ */ ut("ZodReadonly", (e, t) => {
  Bon.init(e, t), Vo.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Xan(e) {
  return new Ban({
    type: "readonly",
    innerType: e
  });
}
const Wan = /* @__PURE__ */ ut("ZodCustom", (e, t) => {
  Xon.init(e, t), Vo.init(e, t);
});
function Zan(e, t = {}) {
  return Msn(Wan, e, t);
}
function Han(e) {
  return Dsn(e);
}
const Qan = wG({
  String: ke.string,
  Number: ke.number,
  "True False": ke.bool,
  PropertyName: ke.propertyName,
  Null: ke.null,
  ", :": ke.separator,
  "[ ]": ke.squareBracket,
  "{ }": ke.brace
}), $an = ck.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
  stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
  goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["isolate", -2, 6, 11, ""],
    ["openedBy", 7, "{", 14, "["],
    ["closedBy", 8, "}", 15, "]"]
  ],
  propSources: [Qan],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
}), Kan = /* @__PURE__ */ vk.define({
  name: "json",
  parser: /* @__PURE__ */ $an.configure({
    props: [
      /* @__PURE__ */ VG.add({
        Object: /* @__PURE__ */ UE({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ UE({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ BG.add({
        "Object Array": jLe
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function e4e() {
  return new _Le(Kan);
}
const Gan = kt.baseTheme({
  "&.cm-editor.cm-focused": {
    outline: "none"
  }
}), Yan = (e) => typeof e == "string" ? e : JSON.stringify(e, null, 2), Jan = (e) => {
  if (typeof e != "string")
    return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, V3 = ie.memo(
  ({ field: e, readonly: t, onFocus: n, className: r }) => {
    const [i, o] = He(Yan(e.value)), s = localStorage.getItem("themeMode") === "dark" ? L_ : __, l = [
      Gan,
      $n.readOnly.of(t),
      kt.editable.of(!t),
      kt.lineWrapping,
      e4e()
    ], c = Xe(null);
    return /* @__PURE__ */ y("div", { className: "flex flex-col gap-2 border rounded py-2 px-2", children: /* @__PURE__ */ y(
      r3,
      {
        ref: c,
        value: i,
        className: Se("border-none", r),
        height: "250px",
        width: "100%",
        maxWidth: "100%",
        basicSetup: {
          foldGutter: !1,
          lineNumbers: !0,
          searchKeymap: !1,
          lintKeymap: !0,
          autocompletion: !0
        },
        lang: "json",
        onChange: (a) => {
          o(a), e.onChange(Jan(a));
        },
        theme: s,
        readOnly: t,
        onFocus: () => n == null ? void 0 : n(c),
        extensions: l
      }
    ) });
  }
);
V3.displayName = "JsonEditor";
var Cme = 1, eln = 0.9, tln = 0.8, nln = 0.17, ZV = 0.1, HV = 0.999, rln = 0.9999, iln = 0.99, oln = /[\\\/_+.#"@\[\(\{&]/, sln = /[\\\/_+.#"@\[\(\{&]/g, aln = /[\s-]/, t4e = /[\s-]/g;
function M7(e, t, n, r, i, o, s) {
  if (o === t.length) return i === e.length ? Cme : iln;
  var l = `${i},${o}`;
  if (s[l] !== void 0) return s[l];
  for (var c = r.charAt(o), a = n.indexOf(c, i), u = 0, f, d, p, h; a >= 0; ) f = M7(e, t, n, r, a + 1, o + 1, s), f > u && (a === i ? f *= Cme : oln.test(e.charAt(a - 1)) ? (f *= tln, p = e.slice(i, a - 1).match(sln), p && i > 0 && (f *= Math.pow(HV, p.length))) : aln.test(e.charAt(a - 1)) ? (f *= eln, h = e.slice(i, a - 1).match(t4e), h && i > 0 && (f *= Math.pow(HV, h.length))) : (f *= nln, i > 0 && (f *= Math.pow(HV, a - i))), e.charAt(a) !== t.charAt(o) && (f *= rln)), (f < ZV && n.charAt(a - 1) === r.charAt(o + 1) || r.charAt(o + 1) === r.charAt(o) && n.charAt(a - 1) !== r.charAt(o)) && (d = M7(e, t, n, r, a + 1, o + 2, s), d * ZV > f && (f = d * ZV)), f > u && (u = f), a = n.indexOf(c, a + 1);
  return s[l] = u, u;
}
function Nme(e) {
  return e.toLowerCase().replace(t4e, " ");
}
function lln(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, M7(e, t, Nme(e), Nme(t), 0, 0, {});
}
var _S = '[cmdk-group=""]', QV = '[cmdk-group-items=""]', cln = '[cmdk-group-heading=""]', n4e = '[cmdk-item=""]', Pme = `${n4e}:not([aria-disabled="true"])`, D7 = "cmdk-item-select", fO = "data-value", uln = (e, t, n) => lln(e, t, n), r4e = N.createContext(void 0), eP = () => N.useContext(r4e), i4e = N.createContext(void 0), WJ = () => N.useContext(i4e), o4e = N.createContext(void 0), s4e = N.forwardRef((e, t) => {
  let n = pO(() => {
    var B, q;
    return { search: "", value: (q = (B = e.value) != null ? B : e.defaultValue) != null ? q : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = pO(() => /* @__PURE__ */ new Set()), i = pO(() => /* @__PURE__ */ new Map()), o = pO(() => /* @__PURE__ */ new Map()), s = pO(() => /* @__PURE__ */ new Set()), l = a4e(e), { label: c, children: a, value: u, onValueChange: f, filter: d, shouldFilter: p, loop: h, disablePointerSelection: m = !1, vimBindings: v = !0, ...b } = e, A = Zu(), w = Zu(), O = Zu(), x = N.useRef(null), S = Aln();
  ib(() => {
    if (u !== void 0) {
      let B = u.trim();
      n.current.value = B, E.emit();
    }
  }, [u]), ib(() => {
    S(6, L);
  }, []);
  let E = N.useMemo(() => ({ subscribe: (B) => (s.current.add(B), () => s.current.delete(B)), snapshot: () => n.current, setState: (B, q, H) => {
    var Y, J, oe, ce;
    if (!Object.is(n.current[B], q)) {
      if (n.current[B] = q, B === "search") F(), R(), S(1, j);
      else if (B === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let fe = document.getElementById(O);
          fe ? fe.focus() : (Y = document.getElementById(A)) == null || Y.focus();
        }
        if (S(7, () => {
          var fe;
          n.current.selectedItemId = (fe = _()) == null ? void 0 : fe.id, E.emit();
        }), H || S(5, L), ((J = l.current) == null ? void 0 : J.value) !== void 0) {
          let fe = q ?? "";
          (ce = (oe = l.current).onValueChange) == null || ce.call(oe, fe);
          return;
        }
      }
      E.emit();
    }
  }, emit: () => {
    s.current.forEach((B) => B());
  } }), []), k = N.useMemo(() => ({ value: (B, q, H) => {
    var Y;
    q !== ((Y = o.current.get(B)) == null ? void 0 : Y.value) && (o.current.set(B, { value: q, keywords: H }), n.current.filtered.items.set(B, T(q, H)), S(2, () => {
      R(), E.emit();
    }));
  }, item: (B, q) => (r.current.add(B), q && (i.current.has(q) ? i.current.get(q).add(B) : i.current.set(q, /* @__PURE__ */ new Set([B]))), S(3, () => {
    F(), R(), n.current.value || j(), E.emit();
  }), () => {
    o.current.delete(B), r.current.delete(B), n.current.filtered.items.delete(B);
    let H = _();
    S(4, () => {
      F(), (H == null ? void 0 : H.getAttribute("id")) === B && j(), E.emit();
    });
  }), group: (B) => (i.current.has(B) || i.current.set(B, /* @__PURE__ */ new Set()), () => {
    o.current.delete(B), i.current.delete(B);
  }), filter: () => l.current.shouldFilter, label: c || e["aria-label"], getDisablePointerSelection: () => l.current.disablePointerSelection, listId: A, inputId: O, labelId: w, listInnerRef: x }), []);
  function T(B, q) {
    var H, Y;
    let J = (Y = (H = l.current) == null ? void 0 : H.filter) != null ? Y : uln;
    return B ? J(B, n.current.search, q) : 0;
  }
  function R() {
    if (!n.current.search || l.current.shouldFilter === !1) return;
    let B = n.current.filtered.items, q = [];
    n.current.filtered.groups.forEach((Y) => {
      let J = i.current.get(Y), oe = 0;
      J.forEach((ce) => {
        let fe = B.get(ce);
        oe = Math.max(fe, oe);
      }), q.push([Y, oe]);
    });
    let H = x.current;
    U().sort((Y, J) => {
      var oe, ce;
      let fe = Y.getAttribute("id"), $ = J.getAttribute("id");
      return ((oe = B.get($)) != null ? oe : 0) - ((ce = B.get(fe)) != null ? ce : 0);
    }).forEach((Y) => {
      let J = Y.closest(QV);
      J ? J.appendChild(Y.parentElement === J ? Y : Y.closest(`${QV} > *`)) : H.appendChild(Y.parentElement === H ? Y : Y.closest(`${QV} > *`));
    }), q.sort((Y, J) => J[1] - Y[1]).forEach((Y) => {
      var J;
      let oe = (J = x.current) == null ? void 0 : J.querySelector(`${_S}[${fO}="${encodeURIComponent(Y[0])}"]`);
      oe == null || oe.parentElement.appendChild(oe);
    });
  }
  function j() {
    let B = U().find((H) => H.getAttribute("aria-disabled") !== "true"), q = B == null ? void 0 : B.getAttribute(fO);
    E.setState("value", q || void 0);
  }
  function F() {
    var B, q, H, Y;
    if (!n.current.search || l.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let J = 0;
    for (let oe of r.current) {
      let ce = (q = (B = o.current.get(oe)) == null ? void 0 : B.value) != null ? q : "", fe = (Y = (H = o.current.get(oe)) == null ? void 0 : H.keywords) != null ? Y : [], $ = T(ce, fe);
      n.current.filtered.items.set(oe, $), $ > 0 && J++;
    }
    for (let [oe, ce] of i.current) for (let fe of ce) if (n.current.filtered.items.get(fe) > 0) {
      n.current.filtered.groups.add(oe);
      break;
    }
    n.current.filtered.count = J;
  }
  function L() {
    var B, q, H;
    let Y = _();
    Y && (((B = Y.parentElement) == null ? void 0 : B.firstChild) === Y && ((H = (q = Y.closest(_S)) == null ? void 0 : q.querySelector(cln)) == null || H.scrollIntoView({ block: "nearest" })), Y.scrollIntoView({ block: "nearest" }));
  }
  function _() {
    var B;
    return (B = x.current) == null ? void 0 : B.querySelector(`${n4e}[aria-selected="true"]`);
  }
  function U() {
    var B;
    return Array.from(((B = x.current) == null ? void 0 : B.querySelectorAll(Pme)) || []);
  }
  function z(B) {
    let q = U()[B];
    q && E.setState("value", q.getAttribute(fO));
  }
  function C(B) {
    var q;
    let H = _(), Y = U(), J = Y.findIndex((ce) => ce === H), oe = Y[J + B];
    (q = l.current) != null && q.loop && (oe = J + B < 0 ? Y[Y.length - 1] : J + B === Y.length ? Y[0] : Y[J + B]), oe && E.setState("value", oe.getAttribute(fO));
  }
  function I(B) {
    let q = _(), H = q == null ? void 0 : q.closest(_S), Y;
    for (; H && !Y; ) H = B > 0 ? bln(H, _S) : Oln(H, _S), Y = H == null ? void 0 : H.querySelector(Pme);
    Y ? E.setState("value", Y.getAttribute(fO)) : C(B);
  }
  let M = () => z(U().length - 1), D = (B) => {
    B.preventDefault(), B.metaKey ? M() : B.altKey ? I(1) : C(1);
  }, X = (B) => {
    B.preventDefault(), B.metaKey ? z(0) : B.altKey ? I(-1) : C(-1);
  };
  return N.createElement(to.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (B) => {
    var q;
    (q = b.onKeyDown) == null || q.call(b, B);
    let H = B.nativeEvent.isComposing || B.keyCode === 229;
    if (!(B.defaultPrevented || H)) switch (B.key) {
      case "n":
      case "j": {
        v && B.ctrlKey && D(B);
        break;
      }
      case "ArrowDown": {
        D(B);
        break;
      }
      case "p":
      case "k": {
        v && B.ctrlKey && X(B);
        break;
      }
      case "ArrowUp": {
        X(B);
        break;
      }
      case "Home": {
        B.preventDefault(), z(0);
        break;
      }
      case "End": {
        B.preventDefault(), M();
        break;
      }
      case "Enter": {
        B.preventDefault();
        let Y = _();
        if (Y) {
          let J = new Event(D7);
          Y.dispatchEvent(J);
        }
      }
    }
  } }, N.createElement("label", { "cmdk-label": "", htmlFor: k.inputId, id: k.labelId, style: xln }, c), q3(e, (B) => N.createElement(i4e.Provider, { value: E }, N.createElement(r4e.Provider, { value: k }, B))));
}), dln = N.forwardRef((e, t) => {
  var n, r;
  let i = Zu(), o = N.useRef(null), s = N.useContext(o4e), l = eP(), c = a4e(e), a = (r = (n = c.current) == null ? void 0 : n.forceMount) != null ? r : s == null ? void 0 : s.forceMount;
  ib(() => {
    if (!a) return l.item(i, s == null ? void 0 : s.id);
  }, [a]);
  let u = l4e(i, o, [e.value, e.children, o], e.keywords), f = WJ(), d = yg((S) => S.value && S.value === u.current), p = yg((S) => a || l.filter() === !1 ? !0 : S.search ? S.filtered.items.get(i) > 0 : !0);
  N.useEffect(() => {
    let S = o.current;
    if (!(!S || e.disabled)) return S.addEventListener(D7, h), () => S.removeEventListener(D7, h);
  }, [p, e.onSelect, e.disabled]);
  function h() {
    var S, E;
    m(), (E = (S = c.current).onSelect) == null || E.call(S, u.current);
  }
  function m() {
    f.setState("value", u.current, !0);
  }
  if (!p) return null;
  let { disabled: v, value: b, onSelect: A, forceMount: w, keywords: O, ...x } = e;
  return N.createElement(to.div, { ref: sg(o, t), ...x, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!d, "data-disabled": !!v, "data-selected": !!d, onPointerMove: v || l.getDisablePointerSelection() ? void 0 : m, onClick: v ? void 0 : h }, e.children);
}), fln = N.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: i, ...o } = e, s = Zu(), l = N.useRef(null), c = N.useRef(null), a = Zu(), u = eP(), f = yg((p) => i || u.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(s) : !0);
  ib(() => u.group(s), []), l4e(s, l, [e.value, e.heading, c]);
  let d = N.useMemo(() => ({ id: s, forceMount: i }), [i]);
  return N.createElement(to.div, { ref: sg(l, t), ...o, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && N.createElement("div", { ref: c, "cmdk-group-heading": "", "aria-hidden": !0, id: a }, n), q3(e, (p) => N.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? a : void 0 }, N.createElement(o4e.Provider, { value: d }, p))));
}), pln = N.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, i = N.useRef(null), o = yg((s) => !s.search);
  return !n && !o ? null : N.createElement(to.div, { ref: sg(i, t), ...r, "cmdk-separator": "", role: "separator" });
}), hln = N.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, i = e.value != null, o = WJ(), s = yg((a) => a.search), l = yg((a) => a.selectedItemId), c = eP();
  return N.useEffect(() => {
    e.value != null && o.setState("search", e.value);
  }, [e.value]), N.createElement(to.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": c.listId, "aria-labelledby": c.labelId, "aria-activedescendant": l, id: c.inputId, type: "text", value: i ? e.value : s, onChange: (a) => {
    i || o.setState("search", a.target.value), n == null || n(a.target.value);
  } });
}), mln = N.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...i } = e, o = N.useRef(null), s = N.useRef(null), l = yg((a) => a.selectedItemId), c = eP();
  return N.useEffect(() => {
    if (s.current && o.current) {
      let a = s.current, u = o.current, f, d = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let p = a.offsetHeight;
          u.style.setProperty("--cmdk-list-height", p.toFixed(1) + "px");
        });
      });
      return d.observe(a), () => {
        cancelAnimationFrame(f), d.unobserve(a);
      };
    }
  }, []), N.createElement(to.div, { ref: sg(o, t), ...i, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": l, "aria-label": r, id: c.listId }, q3(e, (a) => N.createElement("div", { ref: sg(s, c.listInnerRef), "cmdk-list-sizer": "" }, a)));
}), gln = N.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: i, contentClassName: o, container: s, ...l } = e;
  return N.createElement(ADe, { open: n, onOpenChange: r }, N.createElement(wDe, { container: s }, N.createElement(xDe, { "cmdk-overlay": "", className: i }), N.createElement(SDe, { "aria-label": e.label, "cmdk-dialog": "", className: o }, N.createElement(s4e, { ref: t, ...l }))));
}), yln = N.forwardRef((e, t) => yg((n) => n.filtered.count === 0) ? N.createElement(to.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), vln = N.forwardRef((e, t) => {
  let { progress: n, children: r, label: i = "Loading...", ...o } = e;
  return N.createElement(to.div, { ref: t, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, q3(e, (s) => N.createElement("div", { "aria-hidden": !0 }, s)));
}), Nl = Object.assign(s4e, { List: mln, Item: dln, Input: hln, Group: fln, Separator: pln, Dialog: gln, Empty: yln, Loading: vln });
function bln(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function Oln(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function a4e(e) {
  let t = N.useRef(e);
  return ib(() => {
    t.current = e;
  }), t;
}
var ib = typeof window > "u" ? N.useEffect : N.useLayoutEffect;
function pO(e) {
  let t = N.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function yg(e) {
  let t = WJ(), n = () => e(t.snapshot());
  return N.useSyncExternalStore(t.subscribe, n, n);
}
function l4e(e, t, n, r = []) {
  let i = N.useRef(), o = eP();
  return ib(() => {
    var s;
    let l = (() => {
      var a;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (a = u.current.textContent) == null ? void 0 : a.trim() : i.current;
      }
    })(), c = r.map((a) => a.trim());
    o.value(e, l, c), (s = t.current) == null || s.setAttribute(fO, l), i.current = l;
  }), i;
}
var Aln = () => {
  let [e, t] = N.useState(), n = pO(() => /* @__PURE__ */ new Map());
  return ib(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, i) => {
    n.current.set(r, i), t({});
  };
};
function wln(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function q3({ asChild: e, children: t }, n) {
  return e && N.isValidElement(t) ? N.cloneElement(wln(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var xln = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const CL = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nl,
  {
    ref: n,
    className: Se(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-background text-foreground",
      e
    ),
    ...t
  }
));
CL.displayName = Nl.displayName;
const ZJ = N.forwardRef(({ className: e, ...t }, n) => (
  // eslint-disable-next-line react/no-unknown-property -- temp fix while using wrong cmdk package
  /* @__PURE__ */ V("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ y(QC, { className: "mr-2 size-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ y(
      Nl.Input,
      {
        ref: n,
        className: Se(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground",
          { "cursor-not-allowed opacity-50": t.disabled },
          e
        ),
        ...t
      }
    )
  ] })
));
ZJ.displayName = Nl.Input.displayName;
const HJ = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nl.List,
  {
    ref: n,
    className: Se(
      "max-h-[300px] overflow-y-hidden overflow-x-hidden",
      e
    ),
    ...t
  }
));
HJ.displayName = Nl.List.displayName;
const B3 = N.forwardRef((e, t) => /* @__PURE__ */ y(
  Nl.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
B3.displayName = Nl.Empty.displayName;
const QJ = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nl.Group,
  {
    ref: n,
    className: Se(
      "overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
QJ.displayName = Nl.Group.displayName;
const c4e = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  Nl.Separator,
  {
    ref: n,
    className: Se("-mx-1 h-px bg-border", e),
    ...t
  }
));
c4e.displayName = Nl.Separator.displayName;
const NL = N.forwardRef(({ className: e, disabled: t, ...n }, r) => /* @__PURE__ */ y(
  Nl.Item,
  {
    ref: r,
    className: Se(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground",
      { "pointer-events-none opacity-50": t },
      e
    ),
    disabled: t,
    ...n
  }
));
NL.displayName = Nl.Item.displayName;
const Sln = (e) => {
  const [t, n] = He(!1);
  return e || {
    open: t,
    setOpen: n
  };
}, vg = ({
  options: e,
  onChange: t,
  value: n,
  placeholder: r,
  disabled: i,
  loading: o,
  showDeselect: s,
  onRefresh: l,
  showRefresh: c,
  onClose: a,
  triggerClassName: u,
  valuesRendering: f,
  openState: d,
  refreshOnSearch: p,
  cachedOptions: h = []
}) => {
  var k;
  const m = Xe(null), [v, b] = He(""), { open: A, setOpen: w } = Sln(d), O = `${((k = m.current) == null ? void 0 : k.clientWidth) ?? 0}px`, x = [...h, ...e].find(
    (T) => qg(T.value, n)
  ) ?? void 0, S = e.map((T, R) => ({
    label: T.label,
    value: T.value,
    index: R,
    description: T.description ?? ""
  })).filter((T) => p || v.length === 0 ? !0 : T.label.toLowerCase().includes(v.toLowerCase()) || T.description.toLowerCase().includes(v.toLowerCase())).map((T) => T.index), E = (T) => {
    const R = Number.isInteger(parseInt(T)) && !Number.isNaN(parseInt(T)) ? parseInt(T) : -1;
    if (b(""), R === -1)
      return;
    const j = e[R];
    t(j.value);
  };
  return /* @__PURE__ */ V(
    mx,
    {
      modal: !0,
      open: A,
      onOpenChange: (T) => {
        T || a == null || a(), p && v.length > 0 && (p(""), b("")), w(T);
      },
      children: [
        /* @__PURE__ */ y(
          gx,
          {
            asChild: !0,
            className: Se({
              "cursor-not-allowed opacity-80 ": i
            }),
            onClick: (T) => {
              i && T.preventDefault(), T.stopPropagation();
            },
            children: /* @__PURE__ */ V("div", { className: "relative", children: [
              /* @__PURE__ */ V(
                Qe,
                {
                  ref: m,
                  variant: "outline",
                  disabled: i,
                  role: "combobox",
                  loading: o,
                  "aria-expanded": A,
                  className: Se("w-full justify-between", u),
                  onClick: (T) => {
                    w(!A), T.preventDefault();
                  },
                  children: [
                    /* @__PURE__ */ y("span", { className: "flex w-full truncate select-none", children: x ? f ? f(x.value) : x.label : r }),
                    /* @__PURE__ */ y(exe, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                  ]
                }
              ),
              /* @__PURE__ */ V("div", { className: "right-10 top-2 absolute flex gap-2  z-50 items-center", children: [
                s && !i && x && !o && /* @__PURE__ */ y(
                  Pv,
                  {
                    tooltipText: Z("Unset"),
                    onClick: (T) => {
                      T.stopPropagation(), T.preventDefault(), t(null);
                    },
                    Icon: ks
                  }
                ),
                c && !o && /* @__PURE__ */ y(
                  Pv,
                  {
                    tooltipText: Z("Refresh"),
                    onClick: (T) => {
                      T.stopPropagation(), T.preventDefault(), l && l();
                    },
                    Icon: rD
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ y(
          Sb,
          {
            style: {
              maxWidth: O,
              minWidth: O
            },
            className: "min-w-full w-full p-0",
            children: /* @__PURE__ */ V(CL, { className: "w-full", shouldFilter: !1, children: [
              /* @__PURE__ */ y(
                ZJ,
                {
                  placeholder: Z(r),
                  value: v,
                  onValueChange: (T) => {
                    b(T), p && p(T);
                  }
                }
              ),
              S.length === 0 && /* @__PURE__ */ y(B3, { children: Z("No results found.") }),
              /* @__PURE__ */ y(QJ, { children: /* @__PURE__ */ y(HJ, { children: /* @__PURE__ */ V(
                Bi,
                {
                  className: "h-full",
                  viewPortClassName: "max-h-[200px]",
                  children: [
                    S && !o && S.map((T) => {
                      const R = e[T];
                      return R ? /* @__PURE__ */ V(
                        NL,
                        {
                          value: String(T),
                          onSelect: (j) => {
                            w(!1), E(j);
                          },
                          className: "flex gap-2 flex-col items-start",
                          children: [
                            /* @__PURE__ */ V("div", { className: "flex gap-2 items-center justify-between w-full", children: [
                              R.label === "" ? /* @__PURE__ */ y("span", { className: "", children: " " }) : f ? f(R.value) : R.label,
                              /* @__PURE__ */ y(
                                Af,
                                {
                                  className: Se("shrink-0 w-4 h-4", {
                                    hidden: (x == null ? void 0 : x.value) !== R.value
                                  })
                                }
                              )
                            ] }),
                            R.description && /* @__PURE__ */ y("div", { className: "text-sm text-muted-foreground", children: R.description })
                          ]
                        },
                        T
                      ) : null;
                    }),
                    o && /* @__PURE__ */ y(NL, { disabled: !0, children: Z("Loading...") })
                  ]
                }
              ) }) })
            ] })
          }
        )
      ]
    }
  );
};
vg.displayName = "SearchableSelect";
var $V = {}, LS = {}, Ime;
function u4e() {
  if (Ime) return LS;
  Ime = 1, Object.defineProperty(LS, "__esModule", { value: !0 }), LS.AuthenticationType = void 0;
  var e;
  return function(t) {
    t.BEARER_TOKEN = "BEARER_TOKEN", t.BASIC = "BASIC";
  }(e || (LS.AuthenticationType = e = {})), LS;
}
var ly = {};
const Eln = /* @__PURE__ */ c2(t0t);
var KV = {}, zS = {};
/*! Axios v1.13.1 Copyright (c) 2025 Matt Zabriskie and contributors */
var GV, Rme;
function Tln() {
  if (Rme) return GV;
  Rme = 1;
  function e(G, ne) {
    return function() {
      return G.apply(ne, arguments);
    };
  }
  const { toString: t } = Object.prototype, { getPrototypeOf: n } = Object, { iterator: r, toStringTag: i } = Symbol, o = /* @__PURE__ */ ((G) => (ne) => {
    const ue = t.call(ne);
    return G[ue] || (G[ue] = ue.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null)), s = (G) => (G = G.toLowerCase(), (ne) => o(ne) === G), l = (G) => (ne) => typeof ne === G, { isArray: c } = Array, a = l("undefined");
  function u(G) {
    return G !== null && !a(G) && G.constructor !== null && !a(G.constructor) && h(G.constructor.isBuffer) && G.constructor.isBuffer(G);
  }
  const f = s("ArrayBuffer");
  function d(G) {
    let ne;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ne = ArrayBuffer.isView(G) : ne = G && G.buffer && f(G.buffer), ne;
  }
  const p = l("string"), h = l("function"), m = l("number"), v = (G) => G !== null && typeof G == "object", b = (G) => G === !0 || G === !1, A = (G) => {
    if (o(G) !== "object")
      return !1;
    const ne = n(G);
    return (ne === null || ne === Object.prototype || Object.getPrototypeOf(ne) === null) && !(i in G) && !(r in G);
  }, w = (G) => {
    if (!v(G) || u(G))
      return !1;
    try {
      return Object.keys(G).length === 0 && Object.getPrototypeOf(G) === Object.prototype;
    } catch {
      return !1;
    }
  }, O = s("Date"), x = s("File"), S = s("Blob"), E = s("FileList"), k = (G) => v(G) && h(G.pipe), T = (G) => {
    let ne;
    return G && (typeof FormData == "function" && G instanceof FormData || h(G.append) && ((ne = o(G)) === "formdata" || // detect form-data instance
    ne === "object" && h(G.toString) && G.toString() === "[object FormData]"));
  }, R = s("URLSearchParams"), [j, F, L, _] = ["ReadableStream", "Request", "Response", "Headers"].map(s), U = (G) => G.trim ? G.trim() : G.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function z(G, ne, { allOwnKeys: ue = !1 } = {}) {
    if (G === null || typeof G > "u")
      return;
    let he, we;
    if (typeof G != "object" && (G = [G]), c(G))
      for (he = 0, we = G.length; he < we; he++)
        ne.call(null, G[he], he, G);
    else {
      if (u(G))
        return;
      const Ue = ue ? Object.getOwnPropertyNames(G) : Object.keys(G), ze = Ue.length;
      let it;
      for (he = 0; he < ze; he++)
        it = Ue[he], ne.call(null, G[it], it, G);
    }
  }
  function C(G, ne) {
    if (u(G))
      return null;
    ne = ne.toLowerCase();
    const ue = Object.keys(G);
    let he = ue.length, we;
    for (; he-- > 0; )
      if (we = ue[he], ne === we.toLowerCase())
        return we;
    return null;
  }
  const I = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : lT, M = (G) => !a(G) && G !== I;
  function D() {
    const { caseless: G, skipUndefined: ne } = M(this) && this || {}, ue = {}, he = (we, Ue) => {
      const ze = G && C(ue, Ue) || Ue;
      A(ue[ze]) && A(we) ? ue[ze] = D(ue[ze], we) : A(we) ? ue[ze] = D({}, we) : c(we) ? ue[ze] = we.slice() : (!ne || !a(we)) && (ue[ze] = we);
    };
    for (let we = 0, Ue = arguments.length; we < Ue; we++)
      arguments[we] && z(arguments[we], he);
    return ue;
  }
  const X = (G, ne, ue, { allOwnKeys: he } = {}) => (z(ne, (we, Ue) => {
    ue && h(we) ? G[Ue] = e(we, ue) : G[Ue] = we;
  }, { allOwnKeys: he }), G), B = (G) => (G.charCodeAt(0) === 65279 && (G = G.slice(1)), G), q = (G, ne, ue, he) => {
    G.prototype = Object.create(ne.prototype, he), G.prototype.constructor = G, Object.defineProperty(G, "super", {
      value: ne.prototype
    }), ue && Object.assign(G.prototype, ue);
  }, H = (G, ne, ue, he) => {
    let we, Ue, ze;
    const it = {};
    if (ne = ne || {}, G == null) return ne;
    do {
      for (we = Object.getOwnPropertyNames(G), Ue = we.length; Ue-- > 0; )
        ze = we[Ue], (!he || he(ze, G, ne)) && !it[ze] && (ne[ze] = G[ze], it[ze] = !0);
      G = ue !== !1 && n(G);
    } while (G && (!ue || ue(G, ne)) && G !== Object.prototype);
    return ne;
  }, Y = (G, ne, ue) => {
    G = String(G), (ue === void 0 || ue > G.length) && (ue = G.length), ue -= ne.length;
    const he = G.indexOf(ne, ue);
    return he !== -1 && he === ue;
  }, J = (G) => {
    if (!G) return null;
    if (c(G)) return G;
    let ne = G.length;
    if (!m(ne)) return null;
    const ue = new Array(ne);
    for (; ne-- > 0; )
      ue[ne] = G[ne];
    return ue;
  }, oe = /* @__PURE__ */ ((G) => (ne) => G && ne instanceof G)(typeof Uint8Array < "u" && n(Uint8Array)), ce = (G, ne) => {
    const he = (G && G[r]).call(G);
    let we;
    for (; (we = he.next()) && !we.done; ) {
      const Ue = we.value;
      ne.call(G, Ue[0], Ue[1]);
    }
  }, fe = (G, ne) => {
    let ue;
    const he = [];
    for (; (ue = G.exec(ne)) !== null; )
      he.push(ue);
    return he;
  }, $ = s("HTMLFormElement"), pe = (G) => G.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function(ue, he, we) {
      return he.toUpperCase() + we;
    }
  ), ee = (({ hasOwnProperty: G }) => (ne, ue) => G.call(ne, ue))(Object.prototype), Ce = s("RegExp"), Ee = (G, ne) => {
    const ue = Object.getOwnPropertyDescriptors(G), he = {};
    z(ue, (we, Ue) => {
      let ze;
      (ze = ne(we, Ue, G)) !== !1 && (he[Ue] = ze || we);
    }), Object.defineProperties(G, he);
  }, Ve = (G) => {
    Ee(G, (ne, ue) => {
      if (h(G) && ["arguments", "caller", "callee"].indexOf(ue) !== -1)
        return !1;
      const he = G[ue];
      if (h(he)) {
        if (ne.enumerable = !1, "writable" in ne) {
          ne.writable = !1;
          return;
        }
        ne.set || (ne.set = () => {
          throw Error("Can not rewrite read-only method '" + ue + "'");
        });
      }
    });
  }, et = (G, ne) => {
    const ue = {}, he = (we) => {
      we.forEach((Ue) => {
        ue[Ue] = !0;
      });
    };
    return c(G) ? he(G) : he(String(G).split(ne)), ue;
  }, ft = () => {
  }, me = (G, ne) => G != null && Number.isFinite(G = +G) ? G : ne;
  function Te(G) {
    return !!(G && h(G.append) && G[i] === "FormData" && G[r]);
  }
  const re = (G) => {
    const ne = new Array(10), ue = (he, we) => {
      if (v(he)) {
        if (ne.indexOf(he) >= 0)
          return;
        if (u(he))
          return he;
        if (!("toJSON" in he)) {
          ne[we] = he;
          const Ue = c(he) ? [] : {};
          return z(he, (ze, it) => {
            const nn = ue(ze, we + 1);
            !a(nn) && (Ue[it] = nn);
          }), ne[we] = void 0, Ue;
        }
      }
      return he;
    };
    return ue(G, 0);
  }, le = s("AsyncFunction"), Oe = (G) => G && (v(G) || h(G)) && h(G.then) && h(G.catch), be = ((G, ne) => G ? setImmediate : ne ? ((ue, he) => (I.addEventListener("message", ({ source: we, data: Ue }) => {
    we === I && Ue === ue && he.length && he.shift()();
  }, !1), (we) => {
    he.push(we), I.postMessage(ue, "*");
  }))(`axios@${Math.random()}`, []) : (ue) => setTimeout(ue))(
    typeof setImmediate == "function",
    h(I.postMessage)
  ), je = typeof queueMicrotask < "u" ? queueMicrotask.bind(I) : typeof process < "u" && process.nextTick || be;
  var Q = {
    isArray: c,
    isArrayBuffer: f,
    isBuffer: u,
    isFormData: T,
    isArrayBufferView: d,
    isString: p,
    isNumber: m,
    isBoolean: b,
    isObject: v,
    isPlainObject: A,
    isEmptyObject: w,
    isReadableStream: j,
    isRequest: F,
    isResponse: L,
    isHeaders: _,
    isUndefined: a,
    isDate: O,
    isFile: x,
    isBlob: S,
    isRegExp: Ce,
    isFunction: h,
    isStream: k,
    isURLSearchParams: R,
    isTypedArray: oe,
    isFileList: E,
    forEach: z,
    merge: D,
    extend: X,
    trim: U,
    stripBOM: B,
    inherits: q,
    toFlatObject: H,
    kindOf: o,
    kindOfTest: s,
    endsWith: Y,
    toArray: J,
    forEachEntry: ce,
    matchAll: fe,
    isHTMLForm: $,
    hasOwnProperty: ee,
    hasOwnProp: ee,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors: Ee,
    freezeMethods: Ve,
    toObjectSet: et,
    toCamelCase: pe,
    noop: ft,
    toFiniteNumber: me,
    findKey: C,
    global: I,
    isContextDefined: M,
    isSpecCompliantForm: Te,
    toJSONObject: re,
    isAsyncFn: le,
    isThenable: Oe,
    setImmediate: be,
    asap: je,
    isIterable: (G) => G != null && h(G[r])
  };
  function ae(G, ne, ue, he, we) {
    Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = G, this.name = "AxiosError", ne && (this.code = ne), ue && (this.config = ue), he && (this.request = he), we && (this.response = we, this.status = we.status ? we.status : null);
  }
  Q.inherits(ae, Error, {
    toJSON: function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: Q.toJSONObject(this.config),
        code: this.code,
        status: this.status
      };
    }
  });
  const Pe = ae.prototype, Fe = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
    // eslint-disable-next-line func-names
  ].forEach((G) => {
    Fe[G] = { value: G };
  }), Object.defineProperties(ae, Fe), Object.defineProperty(Pe, "isAxiosError", { value: !0 }), ae.from = (G, ne, ue, he, we, Ue) => {
    const ze = Object.create(Pe);
    Q.toFlatObject(G, ze, function(wt) {
      return wt !== Error.prototype;
    }, (Pt) => Pt !== "isAxiosError");
    const it = G && G.message ? G.message : "Error", nn = ne == null && G ? G.code : ne;
    return ae.call(ze, it, nn, ue, he, we), G && ze.cause == null && Object.defineProperty(ze, "cause", { value: G, configurable: !0 }), ze.name = G && G.name || "Error", Ue && Object.assign(ze, Ue), ze;
  };
  var Ke = null;
  function Ot(G) {
    return Q.isPlainObject(G) || Q.isArray(G);
  }
  function Ct(G) {
    return Q.endsWith(G, "[]") ? G.slice(0, -2) : G;
  }
  function Jt(G, ne, ue) {
    return G ? G.concat(ne).map(function(we, Ue) {
      return we = Ct(we), !ue && Ue ? "[" + we + "]" : we;
    }).join(ue ? "." : "") : ne;
  }
  function yn(G) {
    return Q.isArray(G) && !G.some(Ot);
  }
  const vn = Q.toFlatObject(Q, {}, null, function(ne) {
    return /^is[A-Z]/.test(ne);
  });
  function Re(G, ne, ue) {
    if (!Q.isObject(G))
      throw new TypeError("target must be an object");
    ne = ne || new FormData(), ue = Q.toFlatObject(ue, {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    }, !1, function(Pn, an) {
      return !Q.isUndefined(an[Pn]);
    });
    const he = ue.metaTokens, we = ue.visitor || wt, Ue = ue.dots, ze = ue.indexes, nn = (ue.Blob || typeof Blob < "u" && Blob) && Q.isSpecCompliantForm(ne);
    if (!Q.isFunction(we))
      throw new TypeError("visitor must be a function");
    function Pt(Nt) {
      if (Nt === null) return "";
      if (Q.isDate(Nt))
        return Nt.toISOString();
      if (Q.isBoolean(Nt))
        return Nt.toString();
      if (!nn && Q.isBlob(Nt))
        throw new ae("Blob is not supported. Use a Buffer instead.");
      return Q.isArrayBuffer(Nt) || Q.isTypedArray(Nt) ? nn && typeof Blob == "function" ? new Blob([Nt]) : Buffer.from(Nt) : Nt;
    }
    function wt(Nt, Pn, an) {
      let To = Nt;
      if (Nt && !an && typeof Nt == "object") {
        if (Q.endsWith(Pn, "{}"))
          Pn = he ? Pn : Pn.slice(0, -2), Nt = JSON.stringify(Nt);
        else if (Q.isArray(Nt) && yn(Nt) || (Q.isFileList(Nt) || Q.endsWith(Pn, "[]")) && (To = Q.toArray(Nt)))
          return Pn = Ct(Pn), To.forEach(function(qo, Xa) {
            !(Q.isUndefined(qo) || qo === null) && ne.append(
              // eslint-disable-next-line no-nested-ternary
              ze === !0 ? Jt([Pn], Xa, Ue) : ze === null ? Pn : Pn + "[]",
              Pt(qo)
            );
          }), !1;
      }
      return Ot(Nt) ? !0 : (ne.append(Jt(an, Pn, Ue), Pt(Nt)), !1);
    }
    const mn = [], Kr = Object.assign(vn, {
      defaultVisitor: wt,
      convertValue: Pt,
      isVisitable: Ot
    });
    function js(Nt, Pn) {
      if (!Q.isUndefined(Nt)) {
        if (mn.indexOf(Nt) !== -1)
          throw Error("Circular reference detected in " + Pn.join("."));
        mn.push(Nt), Q.forEach(Nt, function(To, Ac) {
          (!(Q.isUndefined(To) || To === null) && we.call(
            ne,
            To,
            Q.isString(Ac) ? Ac.trim() : Ac,
            Pn,
            Kr
          )) === !0 && js(To, Pn ? Pn.concat(Ac) : [Ac]);
        }), mn.pop();
      }
    }
    if (!Q.isObject(G))
      throw new TypeError("data must be an object");
    return js(G), ne;
  }
  function _e(G) {
    const ne = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    };
    return encodeURIComponent(G).replace(/[!'()~]|%20|%00/g, function(he) {
      return ne[he];
    });
  }
  function jt(G, ne) {
    this._pairs = [], G && Re(G, this, ne);
  }
  const st = jt.prototype;
  st.append = function(ne, ue) {
    this._pairs.push([ne, ue]);
  }, st.toString = function(ne) {
    const ue = ne ? function(he) {
      return ne.call(this, he, _e);
    } : _e;
    return this._pairs.map(function(we) {
      return ue(we[0]) + "=" + ue(we[1]);
    }, "").join("&");
  };
  function Mt(G) {
    return encodeURIComponent(G).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
  }
  function lt(G, ne, ue) {
    if (!ne)
      return G;
    const he = ue && ue.encode || Mt;
    Q.isFunction(ue) && (ue = {
      serialize: ue
    });
    const we = ue && ue.serialize;
    let Ue;
    if (we ? Ue = we(ne, ue) : Ue = Q.isURLSearchParams(ne) ? ne.toString() : new jt(ne, ue).toString(he), Ue) {
      const ze = G.indexOf("#");
      ze !== -1 && (G = G.slice(0, ze)), G += (G.indexOf("?") === -1 ? "?" : "&") + Ue;
    }
    return G;
  }
  class xt {
    constructor() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(ne, ue, he) {
      return this.handlers.push({
        fulfilled: ne,
        rejected: ue,
        synchronous: he ? he.synchronous : !1,
        runWhen: he ? he.runWhen : null
      }), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {void}
     */
    eject(ne) {
      this.handlers[ne] && (this.handlers[ne] = null);
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      this.handlers && (this.handlers = []);
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(ne) {
      Q.forEach(this.handlers, function(he) {
        he !== null && ne(he);
      });
    }
  }
  var yt = xt, ct = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  }, Rt = typeof URLSearchParams < "u" ? URLSearchParams : jt, Yt = typeof FormData < "u" ? FormData : null, Gt = typeof Blob < "u" ? Blob : null, hn = {
    isBrowser: !0,
    classes: {
      URLSearchParams: Rt,
      FormData: Yt,
      Blob: Gt
    },
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };
  const en = typeof window < "u" && typeof document < "u", Sn = typeof navigator == "object" && navigator || void 0, Ar = en && (!Sn || ["ReactNative", "NativeScript", "NS"].indexOf(Sn.product) < 0), or = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts == "function", rr = en && window.location.href || "http://localhost";
  var no = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    hasBrowserEnv: en,
    hasStandardBrowserWebWorkerEnv: or,
    hasStandardBrowserEnv: Ar,
    navigator: Sn,
    origin: rr
  }), jn = {
    ...no,
    ...hn
  };
  function Xi(G, ne) {
    return Re(G, new jn.classes.URLSearchParams(), {
      visitor: function(ue, he, we, Ue) {
        return jn.isNode && Q.isBuffer(ue) ? (this.append(he, ue.toString("base64")), !1) : Ue.defaultVisitor.apply(this, arguments);
      },
      ...ne
    });
  }
  function us(G) {
    return Q.matchAll(/\w+|\[(\w*)]/g, G).map((ne) => ne[0] === "[]" ? "" : ne[1] || ne[0]);
  }
  function ca(G) {
    const ne = {}, ue = Object.keys(G);
    let he;
    const we = ue.length;
    let Ue;
    for (he = 0; he < we; he++)
      Ue = ue[he], ne[Ue] = G[Ue];
    return ne;
  }
  function ge(G) {
    function ne(ue, he, we, Ue) {
      let ze = ue[Ue++];
      if (ze === "__proto__") return !0;
      const it = Number.isFinite(+ze), nn = Ue >= ue.length;
      return ze = !ze && Q.isArray(we) ? we.length : ze, nn ? (Q.hasOwnProp(we, ze) ? we[ze] = [we[ze], he] : we[ze] = he, !it) : ((!we[ze] || !Q.isObject(we[ze])) && (we[ze] = []), ne(ue, he, we[ze], Ue) && Q.isArray(we[ze]) && (we[ze] = ca(we[ze])), !it);
    }
    if (Q.isFormData(G) && Q.isFunction(G.entries)) {
      const ue = {};
      return Q.forEachEntry(G, (he, we) => {
        ne(us(he), we, ue, 0);
      }), ue;
    }
    return null;
  }
  function ve(G, ne, ue) {
    if (Q.isString(G))
      try {
        return (ne || JSON.parse)(G), Q.trim(G);
      } catch (he) {
        if (he.name !== "SyntaxError")
          throw he;
      }
    return (ue || JSON.stringify)(G);
  }
  const se = {
    transitional: ct,
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [function(ne, ue) {
      const he = ue.getContentType() || "", we = he.indexOf("application/json") > -1, Ue = Q.isObject(ne);
      if (Ue && Q.isHTMLForm(ne) && (ne = new FormData(ne)), Q.isFormData(ne))
        return we ? JSON.stringify(ge(ne)) : ne;
      if (Q.isArrayBuffer(ne) || Q.isBuffer(ne) || Q.isStream(ne) || Q.isFile(ne) || Q.isBlob(ne) || Q.isReadableStream(ne))
        return ne;
      if (Q.isArrayBufferView(ne))
        return ne.buffer;
      if (Q.isURLSearchParams(ne))
        return ue.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), ne.toString();
      let it;
      if (Ue) {
        if (he.indexOf("application/x-www-form-urlencoded") > -1)
          return Xi(ne, this.formSerializer).toString();
        if ((it = Q.isFileList(ne)) || he.indexOf("multipart/form-data") > -1) {
          const nn = this.env && this.env.FormData;
          return Re(
            it ? { "files[]": ne } : ne,
            nn && new nn(),
            this.formSerializer
          );
        }
      }
      return Ue || we ? (ue.setContentType("application/json", !1), ve(ne)) : ne;
    }],
    transformResponse: [function(ne) {
      const ue = this.transitional || se.transitional, he = ue && ue.forcedJSONParsing, we = this.responseType === "json";
      if (Q.isResponse(ne) || Q.isReadableStream(ne))
        return ne;
      if (ne && Q.isString(ne) && (he && !this.responseType || we)) {
        const ze = !(ue && ue.silentJSONParsing) && we;
        try {
          return JSON.parse(ne, this.parseReviver);
        } catch (it) {
          if (ze)
            throw it.name === "SyntaxError" ? ae.from(it, ae.ERR_BAD_RESPONSE, this, null, this.response) : it;
        }
      }
      return ne;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: jn.classes.FormData,
      Blob: jn.classes.Blob
    },
    validateStatus: function(ne) {
      return ne >= 200 && ne < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": void 0
      }
    }
  };
  Q.forEach(["delete", "get", "head", "post", "put", "patch"], (G) => {
    se.headers[G] = {};
  });
  var P = se;
  const W = Q.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  var te = (G) => {
    const ne = {};
    let ue, he, we;
    return G && G.split(`
`).forEach(function(ze) {
      we = ze.indexOf(":"), ue = ze.substring(0, we).trim().toLowerCase(), he = ze.substring(we + 1).trim(), !(!ue || ne[ue] && W[ue]) && (ue === "set-cookie" ? ne[ue] ? ne[ue].push(he) : ne[ue] = [he] : ne[ue] = ne[ue] ? ne[ue] + ", " + he : he);
    }), ne;
  };
  const de = Symbol("internals");
  function Ne(G) {
    return G && String(G).trim().toLowerCase();
  }
  function Me(G) {
    return G === !1 || G == null ? G : Q.isArray(G) ? G.map(Me) : String(G);
  }
  function Ge(G) {
    const ne = /* @__PURE__ */ Object.create(null), ue = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let he;
    for (; he = ue.exec(G); )
      ne[he[1]] = he[2];
    return ne;
  }
  const $t = (G) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(G.trim());
  function In(G, ne, ue, he, we) {
    if (Q.isFunction(he))
      return he.call(this, ne, ue);
    if (we && (ne = ue), !!Q.isString(ne)) {
      if (Q.isString(he))
        return ne.indexOf(he) !== -1;
      if (Q.isRegExp(he))
        return he.test(ne);
    }
  }
  function Qn(G) {
    return G.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (ne, ue, he) => ue.toUpperCase() + he);
  }
  function yr(G, ne) {
    const ue = Q.toCamelCase(" " + ne);
    ["get", "set", "has"].forEach((he) => {
      Object.defineProperty(G, he + ue, {
        value: function(we, Ue, ze) {
          return this[he].call(this, ne, we, Ue, ze);
        },
        configurable: !0
      });
    });
  }
  class Cn {
    constructor(ne) {
      ne && this.set(ne);
    }
    set(ne, ue, he) {
      const we = this;
      function Ue(it, nn, Pt) {
        const wt = Ne(nn);
        if (!wt)
          throw new Error("header name must be a non-empty string");
        const mn = Q.findKey(we, wt);
        (!mn || we[mn] === void 0 || Pt === !0 || Pt === void 0 && we[mn] !== !1) && (we[mn || nn] = Me(it));
      }
      const ze = (it, nn) => Q.forEach(it, (Pt, wt) => Ue(Pt, wt, nn));
      if (Q.isPlainObject(ne) || ne instanceof this.constructor)
        ze(ne, ue);
      else if (Q.isString(ne) && (ne = ne.trim()) && !$t(ne))
        ze(te(ne), ue);
      else if (Q.isObject(ne) && Q.isIterable(ne)) {
        let it = {}, nn, Pt;
        for (const wt of ne) {
          if (!Q.isArray(wt))
            throw TypeError("Object iterator must return a key-value pair");
          it[Pt = wt[0]] = (nn = it[Pt]) ? Q.isArray(nn) ? [...nn, wt[1]] : [nn, wt[1]] : wt[1];
        }
        ze(it, ue);
      } else
        ne != null && Ue(ue, ne, he);
      return this;
    }
    get(ne, ue) {
      if (ne = Ne(ne), ne) {
        const he = Q.findKey(this, ne);
        if (he) {
          const we = this[he];
          if (!ue)
            return we;
          if (ue === !0)
            return Ge(we);
          if (Q.isFunction(ue))
            return ue.call(this, we, he);
          if (Q.isRegExp(ue))
            return ue.exec(we);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(ne, ue) {
      if (ne = Ne(ne), ne) {
        const he = Q.findKey(this, ne);
        return !!(he && this[he] !== void 0 && (!ue || In(this, this[he], he, ue)));
      }
      return !1;
    }
    delete(ne, ue) {
      const he = this;
      let we = !1;
      function Ue(ze) {
        if (ze = Ne(ze), ze) {
          const it = Q.findKey(he, ze);
          it && (!ue || In(he, he[it], it, ue)) && (delete he[it], we = !0);
        }
      }
      return Q.isArray(ne) ? ne.forEach(Ue) : Ue(ne), we;
    }
    clear(ne) {
      const ue = Object.keys(this);
      let he = ue.length, we = !1;
      for (; he--; ) {
        const Ue = ue[he];
        (!ne || In(this, this[Ue], Ue, ne, !0)) && (delete this[Ue], we = !0);
      }
      return we;
    }
    normalize(ne) {
      const ue = this, he = {};
      return Q.forEach(this, (we, Ue) => {
        const ze = Q.findKey(he, Ue);
        if (ze) {
          ue[ze] = Me(we), delete ue[Ue];
          return;
        }
        const it = ne ? Qn(Ue) : String(Ue).trim();
        it !== Ue && delete ue[Ue], ue[it] = Me(we), he[it] = !0;
      }), this;
    }
    concat(...ne) {
      return this.constructor.concat(this, ...ne);
    }
    toJSON(ne) {
      const ue = /* @__PURE__ */ Object.create(null);
      return Q.forEach(this, (he, we) => {
        he != null && he !== !1 && (ue[we] = ne && Q.isArray(he) ? he.join(", ") : he);
      }), ue;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([ne, ue]) => ne + ": " + ue).join(`
`);
    }
    getSetCookie() {
      return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(ne) {
      return ne instanceof this ? ne : new this(ne);
    }
    static concat(ne, ...ue) {
      const he = new this(ne);
      return ue.forEach((we) => he.set(we)), he;
    }
    static accessor(ne) {
      const he = (this[de] = this[de] = {
        accessors: {}
      }).accessors, we = this.prototype;
      function Ue(ze) {
        const it = Ne(ze);
        he[it] || (yr(we, ze), he[it] = !0);
      }
      return Q.isArray(ne) ? ne.forEach(Ue) : Ue(ne), this;
    }
  }
  Cn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), Q.reduceDescriptors(Cn.prototype, ({ value: G }, ne) => {
    let ue = ne[0].toUpperCase() + ne.slice(1);
    return {
      get: () => G,
      set(he) {
        this[ue] = he;
      }
    };
  }), Q.freezeMethods(Cn);
  var Ln = Cn;
  function Lr(G, ne) {
    const ue = this || P, he = ne || ue, we = Ln.from(he.headers);
    let Ue = he.data;
    return Q.forEach(G, function(it) {
      Ue = it.call(ue, Ue, we.normalize(), ne ? ne.status : void 0);
    }), we.normalize(), Ue;
  }
  function bn(G) {
    return !!(G && G.__CANCEL__);
  }
  function Cr(G, ne, ue) {
    ae.call(this, G ?? "canceled", ae.ERR_CANCELED, ne, ue), this.name = "CanceledError";
  }
  Q.inherits(Cr, ae, {
    __CANCEL__: !0
  });
  function ro(G, ne, ue) {
    const he = ue.config.validateStatus;
    !ue.status || !he || he(ue.status) ? G(ue) : ne(new ae(
      "Request failed with status code " + ue.status,
      [ae.ERR_BAD_REQUEST, ae.ERR_BAD_RESPONSE][Math.floor(ue.status / 100) - 4],
      ue.config,
      ue.request,
      ue
    ));
  }
  function zs(G) {
    const ne = /^([-+\w]{1,25})(:?\/\/|:)/.exec(G);
    return ne && ne[1] || "";
  }
  function xd(G, ne) {
    G = G || 10;
    const ue = new Array(G), he = new Array(G);
    let we = 0, Ue = 0, ze;
    return ne = ne !== void 0 ? ne : 1e3, function(nn) {
      const Pt = Date.now(), wt = he[Ue];
      ze || (ze = Pt), ue[we] = nn, he[we] = Pt;
      let mn = Ue, Kr = 0;
      for (; mn !== we; )
        Kr += ue[mn++], mn = mn % G;
      if (we = (we + 1) % G, we === Ue && (Ue = (Ue + 1) % G), Pt - ze < ne)
        return;
      const js = wt && Pt - wt;
      return js ? Math.round(Kr * 1e3 / js) : void 0;
    };
  }
  function ua(G, ne) {
    let ue = 0, he = 1e3 / ne, we, Ue;
    const ze = (Pt, wt = Date.now()) => {
      ue = wt, we = null, Ue && (clearTimeout(Ue), Ue = null), G(...Pt);
    };
    return [(...Pt) => {
      const wt = Date.now(), mn = wt - ue;
      mn >= he ? ze(Pt, wt) : (we = Pt, Ue || (Ue = setTimeout(() => {
        Ue = null, ze(we);
      }, he - mn)));
    }, () => we && ze(we)];
  }
  const Pl = (G, ne, ue = 3) => {
    let he = 0;
    const we = xd(50, 250);
    return ua((Ue) => {
      const ze = Ue.loaded, it = Ue.lengthComputable ? Ue.total : void 0, nn = ze - he, Pt = we(nn), wt = ze <= it;
      he = ze;
      const mn = {
        loaded: ze,
        total: it,
        progress: it ? ze / it : void 0,
        bytes: nn,
        rate: Pt || void 0,
        estimated: Pt && it && wt ? (it - ze) / Pt : void 0,
        event: Ue,
        lengthComputable: it != null,
        [ne ? "download" : "upload"]: !0
      };
      G(mn);
    }, ue);
  }, Il = (G, ne) => {
    const ue = G != null;
    return [(he) => ne[0]({
      lengthComputable: ue,
      total: G,
      loaded: he
    }), ne[1]];
  }, ye = (G) => (...ne) => Q.asap(() => G(...ne));
  var Ae = jn.hasStandardBrowserEnv ? /* @__PURE__ */ ((G, ne) => (ue) => (ue = new URL(ue, jn.origin), G.protocol === ue.protocol && G.host === ue.host && (ne || G.port === ue.port)))(
    new URL(jn.origin),
    jn.navigator && /(msie|trident)/i.test(jn.navigator.userAgent)
  ) : () => !0, ht = jn.hasStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    {
      write(G, ne, ue, he, we, Ue, ze) {
        if (typeof document > "u") return;
        const it = [`${G}=${encodeURIComponent(ne)}`];
        Q.isNumber(ue) && it.push(`expires=${new Date(ue).toUTCString()}`), Q.isString(he) && it.push(`path=${he}`), Q.isString(we) && it.push(`domain=${we}`), Ue === !0 && it.push("secure"), Q.isString(ze) && it.push(`SameSite=${ze}`), document.cookie = it.join("; ");
      },
      read(G) {
        if (typeof document > "u") return null;
        const ne = document.cookie.match(new RegExp("(?:^|; )" + G + "=([^;]*)"));
        return ne ? decodeURIComponent(ne[1]) : null;
      },
      remove(G) {
        this.write(G, "", Date.now() - 864e5, "/");
      }
    }
  ) : (
    // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {
      },
      read() {
        return null;
      },
      remove() {
      }
    }
  );
  function On(G) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(G);
  }
  function Wn(G, ne) {
    return ne ? G.replace(/\/?\/$/, "") + "/" + ne.replace(/^\/+/, "") : G;
  }
  function da(G, ne, ue) {
    let he = !On(ne);
    return G && (he || ue == !1) ? Wn(G, ne) : ne;
  }
  const Oc = (G) => G instanceof Ln ? { ...G } : G;
  function fa(G, ne) {
    ne = ne || {};
    const ue = {};
    function he(Pt, wt, mn, Kr) {
      return Q.isPlainObject(Pt) && Q.isPlainObject(wt) ? Q.merge.call({ caseless: Kr }, Pt, wt) : Q.isPlainObject(wt) ? Q.merge({}, wt) : Q.isArray(wt) ? wt.slice() : wt;
    }
    function we(Pt, wt, mn, Kr) {
      if (Q.isUndefined(wt)) {
        if (!Q.isUndefined(Pt))
          return he(void 0, Pt, mn, Kr);
      } else return he(Pt, wt, mn, Kr);
    }
    function Ue(Pt, wt) {
      if (!Q.isUndefined(wt))
        return he(void 0, wt);
    }
    function ze(Pt, wt) {
      if (Q.isUndefined(wt)) {
        if (!Q.isUndefined(Pt))
          return he(void 0, Pt);
      } else return he(void 0, wt);
    }
    function it(Pt, wt, mn) {
      if (mn in ne)
        return he(Pt, wt);
      if (mn in G)
        return he(void 0, Pt);
    }
    const nn = {
      url: Ue,
      method: Ue,
      data: Ue,
      baseURL: ze,
      transformRequest: ze,
      transformResponse: ze,
      paramsSerializer: ze,
      timeout: ze,
      timeoutMessage: ze,
      withCredentials: ze,
      withXSRFToken: ze,
      adapter: ze,
      responseType: ze,
      xsrfCookieName: ze,
      xsrfHeaderName: ze,
      onUploadProgress: ze,
      onDownloadProgress: ze,
      decompress: ze,
      maxContentLength: ze,
      maxBodyLength: ze,
      beforeRedirect: ze,
      transport: ze,
      httpAgent: ze,
      httpsAgent: ze,
      cancelToken: ze,
      socketPath: ze,
      responseEncoding: ze,
      validateStatus: it,
      headers: (Pt, wt, mn) => we(Oc(Pt), Oc(wt), mn, !0)
    };
    return Q.forEach(Object.keys({ ...G, ...ne }), function(wt) {
      const mn = nn[wt] || we, Kr = mn(G[wt], ne[wt], wt);
      Q.isUndefined(Kr) && mn !== it || (ue[wt] = Kr);
    }), ue;
  }
  var Ih = (G) => {
    const ne = fa({}, G);
    let { data: ue, withXSRFToken: he, xsrfHeaderName: we, xsrfCookieName: Ue, headers: ze, auth: it } = ne;
    if (ne.headers = ze = Ln.from(ze), ne.url = lt(da(ne.baseURL, ne.url, ne.allowAbsoluteUrls), G.params, G.paramsSerializer), it && ze.set(
      "Authorization",
      "Basic " + btoa((it.username || "") + ":" + (it.password ? unescape(encodeURIComponent(it.password)) : ""))
    ), Q.isFormData(ue)) {
      if (jn.hasStandardBrowserEnv || jn.hasStandardBrowserWebWorkerEnv)
        ze.setContentType(void 0);
      else if (Q.isFunction(ue.getHeaders)) {
        const nn = ue.getHeaders(), Pt = ["content-type", "content-length"];
        Object.entries(nn).forEach(([wt, mn]) => {
          Pt.includes(wt.toLowerCase()) && ze.set(wt, mn);
        });
      }
    }
    if (jn.hasStandardBrowserEnv && (he && Q.isFunction(he) && (he = he(ne)), he || he !== !1 && Ae(ne.url))) {
      const nn = we && Ue && ht.read(Ue);
      nn && ze.set(we, nn);
    }
    return ne;
  }, Sd = typeof XMLHttpRequest < "u" && function(G) {
    return new Promise(function(ue, he) {
      const we = Ih(G);
      let Ue = we.data;
      const ze = Ln.from(we.headers).normalize();
      let { responseType: it, onUploadProgress: nn, onDownloadProgress: Pt } = we, wt, mn, Kr, js, Nt;
      function Pn() {
        js && js(), Nt && Nt(), we.cancelToken && we.cancelToken.unsubscribe(wt), we.signal && we.signal.removeEventListener("abort", wt);
      }
      let an = new XMLHttpRequest();
      an.open(we.method.toUpperCase(), we.url, !0), an.timeout = we.timeout;
      function To() {
        if (!an)
          return;
        const qo = Ln.from(
          "getAllResponseHeaders" in an && an.getAllResponseHeaders()
        ), Au = {
          data: !it || it === "text" || it === "json" ? an.responseText : an.response,
          status: an.status,
          statusText: an.statusText,
          headers: qo,
          config: G,
          request: an
        };
        ro(function(wc) {
          ue(wc), Pn();
        }, function(wc) {
          he(wc), Pn();
        }, Au), an = null;
      }
      "onloadend" in an ? an.onloadend = To : an.onreadystatechange = function() {
        !an || an.readyState !== 4 || an.status === 0 && !(an.responseURL && an.responseURL.indexOf("file:") === 0) || setTimeout(To);
      }, an.onabort = function() {
        an && (he(new ae("Request aborted", ae.ECONNABORTED, G, an)), an = null);
      }, an.onerror = function(Xa) {
        const Au = Xa && Xa.message ? Xa.message : "Network Error", Hg = new ae(Au, ae.ERR_NETWORK, G, an);
        Hg.event = Xa || null, he(Hg), an = null;
      }, an.ontimeout = function() {
        let Xa = we.timeout ? "timeout of " + we.timeout + "ms exceeded" : "timeout exceeded";
        const Au = we.transitional || ct;
        we.timeoutErrorMessage && (Xa = we.timeoutErrorMessage), he(new ae(
          Xa,
          Au.clarifyTimeoutError ? ae.ETIMEDOUT : ae.ECONNABORTED,
          G,
          an
        )), an = null;
      }, Ue === void 0 && ze.setContentType(null), "setRequestHeader" in an && Q.forEach(ze.toJSON(), function(Xa, Au) {
        an.setRequestHeader(Au, Xa);
      }), Q.isUndefined(we.withCredentials) || (an.withCredentials = !!we.withCredentials), it && it !== "json" && (an.responseType = we.responseType), Pt && ([Kr, Nt] = Pl(Pt, !0), an.addEventListener("progress", Kr)), nn && an.upload && ([mn, js] = Pl(nn), an.upload.addEventListener("progress", mn), an.upload.addEventListener("loadend", js)), (we.cancelToken || we.signal) && (wt = (qo) => {
        an && (he(!qo || qo.type ? new Cr(null, G, an) : qo), an.abort(), an = null);
      }, we.cancelToken && we.cancelToken.subscribe(wt), we.signal && (we.signal.aborted ? wt() : we.signal.addEventListener("abort", wt)));
      const Ac = zs(we.url);
      if (Ac && jn.protocols.indexOf(Ac) === -1) {
        he(new ae("Unsupported protocol " + Ac + ":", ae.ERR_BAD_REQUEST, G));
        return;
      }
      an.send(Ue || null);
    });
  }, rP = (G, ne) => {
    const { length: ue } = G = G ? G.filter(Boolean) : [];
    if (ne || ue) {
      let he = new AbortController(), we;
      const Ue = function(Pt) {
        if (!we) {
          we = !0, it();
          const wt = Pt instanceof Error ? Pt : this.reason;
          he.abort(wt instanceof ae ? wt : new Cr(wt instanceof Error ? wt.message : wt));
        }
      };
      let ze = ne && setTimeout(() => {
        ze = null, Ue(new ae(`timeout ${ne} of ms exceeded`, ae.ETIMEDOUT));
      }, ne);
      const it = () => {
        G && (ze && clearTimeout(ze), ze = null, G.forEach((Pt) => {
          Pt.unsubscribe ? Pt.unsubscribe(Ue) : Pt.removeEventListener("abort", Ue);
        }), G = null);
      };
      G.forEach((Pt) => Pt.addEventListener("abort", Ue));
      const { signal: nn } = he;
      return nn.unsubscribe = () => Q.asap(it), nn;
    }
  };
  const Rl = function* (G, ne) {
    let ue = G.byteLength;
    if (ue < ne) {
      yield G;
      return;
    }
    let he = 0, we;
    for (; he < ue; )
      we = he + ne, yield G.slice(he, we), he = we;
  }, Wx = async function* (G, ne) {
    for await (const ue of Xb(G))
      yield* Rl(ue, ne);
  }, Xb = async function* (G) {
    if (G[Symbol.asyncIterator]) {
      yield* G;
      return;
    }
    const ne = G.getReader();
    try {
      for (; ; ) {
        const { done: ue, value: he } = await ne.read();
        if (ue)
          break;
        yield he;
      }
    } finally {
      await ne.cancel();
    }
  }, See = (G, ne, ue, he) => {
    const we = Wx(G, ne);
    let Ue = 0, ze, it = (nn) => {
      ze || (ze = !0, he && he(nn));
    };
    return new ReadableStream({
      async pull(nn) {
        try {
          const { done: Pt, value: wt } = await we.next();
          if (Pt) {
            it(), nn.close();
            return;
          }
          let mn = wt.byteLength;
          if (ue) {
            let Kr = Ue += mn;
            ue(Kr);
          }
          nn.enqueue(new Uint8Array(wt));
        } catch (Pt) {
          throw it(Pt), Pt;
        }
      },
      cancel(nn) {
        return it(nn), we.return();
      }
    }, {
      highWaterMark: 2
    });
  }, Eee = 64 * 1024, { isFunction: iP } = Q, dqe = (({ Request: G, Response: ne }) => ({
    Request: G,
    Response: ne
  }))(Q.global), {
    ReadableStream: Tee,
    TextEncoder: kee
  } = Q.global, Cee = (G, ...ne) => {
    try {
      return !!G(...ne);
    } catch {
      return !1;
    }
  }, fqe = (G) => {
    G = Q.merge.call({
      skipUndefined: !0
    }, dqe, G);
    const { fetch: ne, Request: ue, Response: he } = G, we = ne ? iP(ne) : typeof fetch == "function", Ue = iP(ue), ze = iP(he);
    if (!we)
      return !1;
    const it = we && iP(Tee), nn = we && (typeof kee == "function" ? /* @__PURE__ */ ((Nt) => (Pn) => Nt.encode(Pn))(new kee()) : async (Nt) => new Uint8Array(await new ue(Nt).arrayBuffer())), Pt = Ue && it && Cee(() => {
      let Nt = !1;
      const Pn = new ue(jn.origin, {
        body: new Tee(),
        method: "POST",
        get duplex() {
          return Nt = !0, "half";
        }
      }).headers.has("Content-Type");
      return Nt && !Pn;
    }), wt = ze && it && Cee(() => Q.isReadableStream(new he("").body)), mn = {
      stream: wt && ((Nt) => Nt.body)
    };
    we && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((Nt) => {
      !mn[Nt] && (mn[Nt] = (Pn, an) => {
        let To = Pn && Pn[Nt];
        if (To)
          return To.call(Pn);
        throw new ae(`Response type '${Nt}' is not supported`, ae.ERR_NOT_SUPPORT, an);
      });
    });
    const Kr = async (Nt) => {
      if (Nt == null)
        return 0;
      if (Q.isBlob(Nt))
        return Nt.size;
      if (Q.isSpecCompliantForm(Nt))
        return (await new ue(jn.origin, {
          method: "POST",
          body: Nt
        }).arrayBuffer()).byteLength;
      if (Q.isArrayBufferView(Nt) || Q.isArrayBuffer(Nt))
        return Nt.byteLength;
      if (Q.isURLSearchParams(Nt) && (Nt = Nt + ""), Q.isString(Nt))
        return (await nn(Nt)).byteLength;
    }, js = async (Nt, Pn) => {
      const an = Q.toFiniteNumber(Nt.getContentLength());
      return an ?? Kr(Pn);
    };
    return async (Nt) => {
      let {
        url: Pn,
        method: an,
        data: To,
        signal: Ac,
        cancelToken: qo,
        timeout: Xa,
        onDownloadProgress: Au,
        onUploadProgress: Hg,
        responseType: wc,
        headers: J3,
        withCredentials: cP = "same-origin",
        fetchOptions: Lee
      } = Ih(Nt), zee = ne || fetch;
      wc = wc ? (wc + "").toLowerCase() : "text";
      let uP = rP([Ac, qo && qo.toAbortSignal()], Xa), Zx = null;
      const Qg = uP && uP.unsubscribe && (() => {
        uP.unsubscribe();
      });
      let jee;
      try {
        if (Hg && Pt && an !== "get" && an !== "head" && (jee = await js(J3, To)) !== 0) {
          let Mh = new ue(Pn, {
            method: "POST",
            body: To,
            duplex: "half"
          }), Wb;
          if (Q.isFormData(To) && (Wb = Mh.headers.get("content-type")) && J3.setContentType(Wb), Mh.body) {
            const [eF, dP] = Il(
              jee,
              Pl(ye(Hg))
            );
            To = See(Mh.body, Eee, eF, dP);
          }
        }
        Q.isString(cP) || (cP = cP ? "include" : "omit");
        const Td = Ue && "credentials" in ue.prototype, Fee = {
          ...Lee,
          signal: uP,
          method: an.toUpperCase(),
          headers: J3.normalize().toJSON(),
          body: To,
          duplex: "half",
          credentials: Td ? cP : void 0
        };
        Zx = Ue && new ue(Pn, Fee);
        let Rh = await (Ue ? zee(Zx, Lee) : zee(Pn, Fee));
        const Uee = wt && (wc === "stream" || wc === "response");
        if (wt && (Au || Uee && Qg)) {
          const Mh = {};
          ["status", "statusText", "headers"].forEach((Vee) => {
            Mh[Vee] = Rh[Vee];
          });
          const Wb = Q.toFiniteNumber(Rh.headers.get("content-length")), [eF, dP] = Au && Il(
            Wb,
            Pl(ye(Au), !0)
          ) || [];
          Rh = new he(
            See(Rh.body, Eee, eF, () => {
              dP && dP(), Qg && Qg();
            }),
            Mh
          );
        }
        wc = wc || "text";
        let Aqe = await mn[Q.findKey(mn, wc) || "text"](Rh, Nt);
        return !Uee && Qg && Qg(), await new Promise((Mh, Wb) => {
          ro(Mh, Wb, {
            data: Aqe,
            headers: Ln.from(Rh.headers),
            status: Rh.status,
            statusText: Rh.statusText,
            config: Nt,
            request: Zx
          });
        });
      } catch (Td) {
        throw Qg && Qg(), Td && Td.name === "TypeError" && /Load failed|fetch/i.test(Td.message) ? Object.assign(
          new ae("Network Error", ae.ERR_NETWORK, Nt, Zx),
          {
            cause: Td.cause || Td
          }
        ) : ae.from(Td, Td && Td.code, Nt, Zx);
      }
    };
  }, pqe = /* @__PURE__ */ new Map(), Nee = (G) => {
    let ne = G && G.env || {};
    const { fetch: ue, Request: he, Response: we } = ne, Ue = [
      he,
      we,
      ue
    ];
    let ze = Ue.length, it = ze, nn, Pt, wt = pqe;
    for (; it--; )
      nn = Ue[it], Pt = wt.get(nn), Pt === void 0 && wt.set(nn, Pt = it ? /* @__PURE__ */ new Map() : fqe(ne)), wt = Pt;
    return Pt;
  };
  Nee();
  const $3 = {
    http: Ke,
    xhr: Sd,
    fetch: {
      get: Nee
    }
  };
  Q.forEach($3, (G, ne) => {
    if (G) {
      try {
        Object.defineProperty(G, "name", { value: ne });
      } catch {
      }
      Object.defineProperty(G, "adapterName", { value: ne });
    }
  });
  const Pee = (G) => `- ${G}`, hqe = (G) => Q.isFunction(G) || G === null || G === !1;
  function mqe(G, ne) {
    G = Q.isArray(G) ? G : [G];
    const { length: ue } = G;
    let he, we;
    const Ue = {};
    for (let ze = 0; ze < ue; ze++) {
      he = G[ze];
      let it;
      if (we = he, !hqe(he) && (we = $3[(it = String(he)).toLowerCase()], we === void 0))
        throw new ae(`Unknown adapter '${it}'`);
      if (we && (Q.isFunction(we) || (we = we.get(ne))))
        break;
      Ue[it || "#" + ze] = we;
    }
    if (!we) {
      const ze = Object.entries(Ue).map(
        ([nn, Pt]) => `adapter ${nn} ` + (Pt === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let it = ue ? ze.length > 1 ? `since :
` + ze.map(Pee).join(`
`) : " " + Pee(ze[0]) : "as no adapter specified";
      throw new ae(
        "There is no suitable adapter to dispatch the request " + it,
        "ERR_NOT_SUPPORT"
      );
    }
    return we;
  }
  var Iee = {
    /**
     * Resolve an adapter from a list of adapter names or functions.
     * @type {Function}
     */
    getAdapter: mqe,
    /**
     * Exposes all known adapters
     * @type {Object<string, Function|Object>}
     */
    adapters: $3
  };
  function K3(G) {
    if (G.cancelToken && G.cancelToken.throwIfRequested(), G.signal && G.signal.aborted)
      throw new Cr(null, G);
  }
  function Ree(G) {
    return K3(G), G.headers = Ln.from(G.headers), G.data = Lr.call(
      G,
      G.transformRequest
    ), ["post", "put", "patch"].indexOf(G.method) !== -1 && G.headers.setContentType("application/x-www-form-urlencoded", !1), Iee.getAdapter(G.adapter || P.adapter, G)(G).then(function(he) {
      return K3(G), he.data = Lr.call(
        G,
        G.transformResponse,
        he
      ), he.headers = Ln.from(he.headers), he;
    }, function(he) {
      return bn(he) || (K3(G), he && he.response && (he.response.data = Lr.call(
        G,
        G.transformResponse,
        he.response
      ), he.response.headers = Ln.from(he.response.headers))), Promise.reject(he);
    });
  }
  const Mee = "1.13.1", oP = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((G, ne) => {
    oP[G] = function(he) {
      return typeof he === G || "a" + (ne < 1 ? "n " : " ") + G;
    };
  });
  const Dee = {};
  oP.transitional = function(ne, ue, he) {
    function we(Ue, ze) {
      return "[Axios v" + Mee + "] Transitional option '" + Ue + "'" + ze + (he ? ". " + he : "");
    }
    return (Ue, ze, it) => {
      if (ne === !1)
        throw new ae(
          we(ze, " has been removed" + (ue ? " in " + ue : "")),
          ae.ERR_DEPRECATED
        );
      return ue && !Dee[ze] && (Dee[ze] = !0, console.warn(
        we(
          ze,
          " has been deprecated since v" + ue + " and will be removed in the near future"
        )
      )), ne ? ne(Ue, ze, it) : !0;
    };
  }, oP.spelling = function(ne) {
    return (ue, he) => (console.warn(`${he} is likely a misspelling of ${ne}`), !0);
  };
  function gqe(G, ne, ue) {
    if (typeof G != "object")
      throw new ae("options must be an object", ae.ERR_BAD_OPTION_VALUE);
    const he = Object.keys(G);
    let we = he.length;
    for (; we-- > 0; ) {
      const Ue = he[we], ze = ne[Ue];
      if (ze) {
        const it = G[Ue], nn = it === void 0 || ze(it, Ue, G);
        if (nn !== !0)
          throw new ae("option " + Ue + " must be " + nn, ae.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (ue !== !0)
        throw new ae("Unknown option " + Ue, ae.ERR_BAD_OPTION);
    }
  }
  var sP = {
    assertOptions: gqe,
    validators: oP
  };
  const Ed = sP.validators;
  class aP {
    constructor(ne) {
      this.defaults = ne || {}, this.interceptors = {
        request: new yt(),
        response: new yt()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    async request(ne, ue) {
      try {
        return await this._request(ne, ue);
      } catch (he) {
        if (he instanceof Error) {
          let we = {};
          Error.captureStackTrace ? Error.captureStackTrace(we) : we = new Error();
          const Ue = we.stack ? we.stack.replace(/^.+\n/, "") : "";
          try {
            he.stack ? Ue && !String(he.stack).endsWith(Ue.replace(/^.+\n.+\n/, "")) && (he.stack += `
` + Ue) : he.stack = Ue;
          } catch {
          }
        }
        throw he;
      }
    }
    _request(ne, ue) {
      typeof ne == "string" ? (ue = ue || {}, ue.url = ne) : ue = ne || {}, ue = fa(this.defaults, ue);
      const { transitional: he, paramsSerializer: we, headers: Ue } = ue;
      he !== void 0 && sP.assertOptions(he, {
        silentJSONParsing: Ed.transitional(Ed.boolean),
        forcedJSONParsing: Ed.transitional(Ed.boolean),
        clarifyTimeoutError: Ed.transitional(Ed.boolean)
      }, !1), we != null && (Q.isFunction(we) ? ue.paramsSerializer = {
        serialize: we
      } : sP.assertOptions(we, {
        encode: Ed.function,
        serialize: Ed.function
      }, !0)), ue.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? ue.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : ue.allowAbsoluteUrls = !0), sP.assertOptions(ue, {
        baseUrl: Ed.spelling("baseURL"),
        withXsrfToken: Ed.spelling("withXSRFToken")
      }, !0), ue.method = (ue.method || this.defaults.method || "get").toLowerCase();
      let ze = Ue && Q.merge(
        Ue.common,
        Ue[ue.method]
      );
      Ue && Q.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        (Nt) => {
          delete Ue[Nt];
        }
      ), ue.headers = Ln.concat(ze, Ue);
      const it = [];
      let nn = !0;
      this.interceptors.request.forEach(function(Pn) {
        typeof Pn.runWhen == "function" && Pn.runWhen(ue) === !1 || (nn = nn && Pn.synchronous, it.unshift(Pn.fulfilled, Pn.rejected));
      });
      const Pt = [];
      this.interceptors.response.forEach(function(Pn) {
        Pt.push(Pn.fulfilled, Pn.rejected);
      });
      let wt, mn = 0, Kr;
      if (!nn) {
        const Nt = [Ree.bind(this), void 0];
        for (Nt.unshift(...it), Nt.push(...Pt), Kr = Nt.length, wt = Promise.resolve(ue); mn < Kr; )
          wt = wt.then(Nt[mn++], Nt[mn++]);
        return wt;
      }
      Kr = it.length;
      let js = ue;
      for (; mn < Kr; ) {
        const Nt = it[mn++], Pn = it[mn++];
        try {
          js = Nt(js);
        } catch (an) {
          Pn.call(this, an);
          break;
        }
      }
      try {
        wt = Ree.call(this, js);
      } catch (Nt) {
        return Promise.reject(Nt);
      }
      for (mn = 0, Kr = Pt.length; mn < Kr; )
        wt = wt.then(Pt[mn++], Pt[mn++]);
      return wt;
    }
    getUri(ne) {
      ne = fa(this.defaults, ne);
      const ue = da(ne.baseURL, ne.url, ne.allowAbsoluteUrls);
      return lt(ue, ne.params, ne.paramsSerializer);
    }
  }
  Q.forEach(["delete", "get", "head", "options"], function(ne) {
    aP.prototype[ne] = function(ue, he) {
      return this.request(fa(he || {}, {
        method: ne,
        url: ue,
        data: (he || {}).data
      }));
    };
  }), Q.forEach(["post", "put", "patch"], function(ne) {
    function ue(he) {
      return function(Ue, ze, it) {
        return this.request(fa(it || {}, {
          method: ne,
          headers: he ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: Ue,
          data: ze
        }));
      };
    }
    aP.prototype[ne] = ue(), aP.prototype[ne + "Form"] = ue(!0);
  });
  var lP = aP;
  class G3 {
    constructor(ne) {
      if (typeof ne != "function")
        throw new TypeError("executor must be a function.");
      let ue;
      this.promise = new Promise(function(Ue) {
        ue = Ue;
      });
      const he = this;
      this.promise.then((we) => {
        if (!he._listeners) return;
        let Ue = he._listeners.length;
        for (; Ue-- > 0; )
          he._listeners[Ue](we);
        he._listeners = null;
      }), this.promise.then = (we) => {
        let Ue;
        const ze = new Promise((it) => {
          he.subscribe(it), Ue = it;
        }).then(we);
        return ze.cancel = function() {
          he.unsubscribe(Ue);
        }, ze;
      }, ne(function(Ue, ze, it) {
        he.reason || (he.reason = new Cr(Ue, ze, it), ue(he.reason));
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason)
        throw this.reason;
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(ne) {
      if (this.reason) {
        ne(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(ne) : this._listeners = [ne];
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(ne) {
      if (!this._listeners)
        return;
      const ue = this._listeners.indexOf(ne);
      ue !== -1 && this._listeners.splice(ue, 1);
    }
    toAbortSignal() {
      const ne = new AbortController(), ue = (he) => {
        ne.abort(he);
      };
      return this.subscribe(ue), ne.signal.unsubscribe = () => this.unsubscribe(ue), ne.signal;
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let ne;
      return {
        token: new G3(function(we) {
          ne = we;
        }),
        cancel: ne
      };
    }
  }
  var yqe = G3;
  function vqe(G) {
    return function(ue) {
      return G.apply(null, ue);
    };
  }
  function bqe(G) {
    return Q.isObject(G) && G.isAxiosError === !0;
  }
  const Y3 = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
  };
  Object.entries(Y3).forEach(([G, ne]) => {
    Y3[ne] = G;
  });
  var Oqe = Y3;
  function _ee(G) {
    const ne = new lP(G), ue = e(lP.prototype.request, ne);
    return Q.extend(ue, lP.prototype, ne, { allOwnKeys: !0 }), Q.extend(ue, ne, null, { allOwnKeys: !0 }), ue.create = function(we) {
      return _ee(fa(G, we));
    }, ue;
  }
  const io = _ee(P);
  return io.Axios = lP, io.CanceledError = Cr, io.CancelToken = yqe, io.isCancel = bn, io.VERSION = Mee, io.toFormData = Re, io.AxiosError = ae, io.Cancel = io.CanceledError, io.all = function(ne) {
    return Promise.all(ne);
  }, io.spread = vqe, io.isAxiosError = bqe, io.mergeConfig = fa, io.AxiosHeaders = Ln, io.formToJSON = (G) => ge(Q.isHTMLForm(G) ? new FormData(G) : G), io.getAdapter = Iee.getAdapter, io.HttpStatusCode = Oqe, io.default = io, GV = io, GV;
}
var cy = {}, YV, Mme;
function kln() {
  if (Mme) return YV;
  Mme = 1;
  const e = /* @__PURE__ */ new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
  ]);
  return YV = (t) => !e.has(t && t.code), YV;
}
var Dme;
function Cln() {
  return Dme || (Dme = 1, function(e) {
    var t = cy && cy.__awaiter || function(x, S, E, k) {
      function T(R) {
        return R instanceof E ? R : new E(function(j) {
          j(R);
        });
      }
      return new (E || (E = Promise))(function(R, j) {
        function F(U) {
          try {
            _(k.next(U));
          } catch (z) {
            j(z);
          }
        }
        function L(U) {
          try {
            _(k.throw(U));
          } catch (z) {
            j(z);
          }
        }
        function _(U) {
          U.done ? R(U.value) : T(U.value).then(F, L);
        }
        _((k = k.apply(x, S || [])).next());
      });
    }, n = cy && cy.__importDefault || function(x) {
      return x && x.__esModule ? x : { default: x };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DEFAULT_OPTIONS = e.exponentialDelay = e.retryAfter = e.isNetworkOrIdempotentRequestError = e.isIdempotentRequestError = e.isSafeRequestError = e.isRetryableError = e.isNetworkError = e.namespace = void 0;
    const r = n(kln());
    e.namespace = "axios-retry";
    function i(x) {
      const S = ["ERR_CANCELED", "ECONNABORTED"];
      return x.response || !x.code || S.includes(x.code) ? !1 : (0, r.default)(x);
    }
    e.isNetworkError = i;
    const o = ["get", "head", "options"], s = o.concat(["put", "delete"]);
    function l(x) {
      return x.code !== "ECONNABORTED" && (!x.response || x.response.status === 429 || x.response.status >= 500 && x.response.status <= 599);
    }
    e.isRetryableError = l;
    function c(x) {
      var S;
      return !((S = x.config) === null || S === void 0) && S.method ? l(x) && o.indexOf(x.config.method) !== -1 : !1;
    }
    e.isSafeRequestError = c;
    function a(x) {
      var S;
      return !((S = x.config) === null || S === void 0) && S.method ? l(x) && s.indexOf(x.config.method) !== -1 : !1;
    }
    e.isIdempotentRequestError = a;
    function u(x) {
      return i(x) || a(x);
    }
    e.isNetworkOrIdempotentRequestError = u;
    function f(x = void 0) {
      var S;
      const E = (S = x == null ? void 0 : x.response) === null || S === void 0 ? void 0 : S.headers["retry-after"];
      if (!E)
        return 0;
      let k = (Number(E) || 0) * 1e3;
      return k === 0 && (k = (new Date(E).valueOf() || 0) - Date.now()), Math.max(0, k);
    }
    e.retryAfter = f;
    function d(x = 0, S = void 0) {
      return Math.max(0, f(S));
    }
    function p(x = 0, S = void 0, E = 100) {
      const k = Math.pow(2, x) * E, T = Math.max(k, f(S)), R = T * 0.2 * Math.random();
      return T + R;
    }
    e.exponentialDelay = p, e.DEFAULT_OPTIONS = {
      retries: 3,
      retryCondition: u,
      retryDelay: d,
      shouldResetTimeout: !1,
      onRetry: () => {
      },
      onMaxRetryTimesExceeded: () => {
      },
      validateResponse: null
    };
    function h(x, S) {
      return Object.assign(Object.assign(Object.assign({}, e.DEFAULT_OPTIONS), S), x[e.namespace]);
    }
    function m(x, S) {
      const E = h(x, S || {});
      return E.retryCount = E.retryCount || 0, E.lastRequestTime = E.lastRequestTime || Date.now(), x[e.namespace] = E, E;
    }
    function v(x, S) {
      x.defaults.agent === S.agent && delete S.agent, x.defaults.httpAgent === S.httpAgent && delete S.httpAgent, x.defaults.httpsAgent === S.httpsAgent && delete S.httpsAgent;
    }
    function b(x, S) {
      return t(this, void 0, void 0, function* () {
        const { retries: E, retryCondition: k } = x, T = (x.retryCount || 0) < E && k(S);
        if (typeof T == "object")
          try {
            return (yield T) !== !1;
          } catch {
            return !1;
          }
        return T;
      });
    }
    function A(x, S, E, k) {
      var T;
      return t(this, void 0, void 0, function* () {
        S.retryCount += 1;
        const { retryDelay: R, shouldResetTimeout: j, onRetry: F } = S, L = R(S.retryCount, E);
        if (v(x, k), !j && k.timeout && S.lastRequestTime) {
          const _ = Date.now() - S.lastRequestTime, U = k.timeout - _ - L;
          if (U <= 0)
            return Promise.reject(E);
          k.timeout = U;
        }
        return k.transformRequest = [(_) => _], yield F(S.retryCount, E, k), !((T = k.signal) === null || T === void 0) && T.aborted ? Promise.resolve(x(k)) : new Promise((_) => {
          var U;
          const z = () => {
            clearTimeout(C), _(x(k));
          }, C = setTimeout(() => {
            var I;
            _(x(k)), !((I = k.signal) === null || I === void 0) && I.removeEventListener && k.signal.removeEventListener("abort", z);
          }, L);
          !((U = k.signal) === null || U === void 0) && U.addEventListener && k.signal.addEventListener("abort", z, { once: !0 });
        });
      });
    }
    function w(x, S) {
      return t(this, void 0, void 0, function* () {
        x.retryCount >= x.retries && (yield x.onMaxRetryTimesExceeded(S, x.retryCount));
      });
    }
    const O = (x, S) => {
      const E = x.interceptors.request.use((T) => {
        var R;
        return m(T, S), !((R = T[e.namespace]) === null || R === void 0) && R.validateResponse && (T.validateStatus = () => !1), T;
      }), k = x.interceptors.response.use(null, (T) => t(void 0, void 0, void 0, function* () {
        var R;
        const { config: j } = T;
        if (!j)
          return Promise.reject(T);
        const F = m(j, S);
        return T.response && (!((R = F.validateResponse) === null || R === void 0) && R.call(F, T.response)) ? T.response : (yield b(F, T)) ? A(x, F, T, j) : (yield w(F, T), Promise.reject(T));
      }));
      return { requestInterceptorId: E, responseInterceptorId: k };
    };
    O.isNetworkError = i, O.isSafeRequestError = c, O.isIdempotentRequestError = a, O.isNetworkOrIdempotentRequestError = u, O.exponentialDelay = p, O.isRetryableError = l, e.default = O;
  }(cy)), cy;
}
var jS = {}, FS = {}, _me;
function $J() {
  if (_me) return FS;
  _me = 1, Object.defineProperty(FS, "__esModule", { value: !0 }), FS.HttpHeader = void 0;
  var e;
  return function(t) {
    t.AUTHORIZATION = "Authorization", t.ACCEPT = "Accept", t.API_KEY = "x-api-key", t.CONTENT_TYPE = "Content-Type";
  }(e || (FS.HttpHeader = e = {})), FS;
}
var Lme;
function d4e() {
  if (Lme) return jS;
  Lme = 1, Object.defineProperty(jS, "__esModule", { value: !0 }), jS.DelegatingAuthenticationConverter = void 0;
  const e = $J(), t = u4e();
  class n {
    constructor(s = new r(), l = new i()) {
      this.converters = {
        [t.AuthenticationType.BEARER_TOKEN]: s,
        [t.AuthenticationType.BASIC]: l
      };
    }
    convert(s, l) {
      return this.converters[s.type].convert(s, l);
    }
  }
  jS.DelegatingAuthenticationConverter = n;
  class r {
    convert(s, l) {
      return l[e.HttpHeader.AUTHORIZATION] = `Bearer ${s.token}`, l;
    }
  }
  class i {
    convert(s, l) {
      const c = `${s.username}:${s.password}`, a = Buffer.from(c).toString("base64");
      return l[e.HttpHeader.AUTHORIZATION] = `Basic ${a}`, l;
    }
  }
  return jS;
}
var US = {}, VS = {}, zme;
function f4e() {
  if (zme) return VS;
  zme = 1, Object.defineProperty(VS, "__esModule", { value: !0 }), VS.MediaType = void 0;
  var e;
  return function(t) {
    t.APPLICATION_JSON = "application/json", t.TEXT_CSV = "text/csv";
  }(e || (VS.MediaType = e = {})), VS;
}
var jme;
function p4e() {
  if (jme) return US;
  jme = 1, Object.defineProperty(US, "__esModule", { value: !0 }), US.BaseHttpClient = void 0;
  const e = $J(), t = f4e();
  class n {
    constructor(i, o) {
      this.baseUrl = i, this.authenticationConverter = o;
    }
    getUrl(i) {
      const o = new URL(`${this.baseUrl}${i.url}`), s = `${o.origin}${o.pathname}`, l = new URLSearchParams();
      return o.searchParams.forEach((c, a) => {
        l.append(a, c);
      }), {
        urlWithoutQueryParams: s,
        queryParams: l
      };
    }
    getHeaders(i) {
      var o;
      let s = {
        [e.HttpHeader.ACCEPT]: t.MediaType.APPLICATION_JSON
      };
      if (i.authentication && this.populateAuthentication(i.authentication, s), i.body)
        switch ((o = i.headers) === null || o === void 0 ? void 0 : o["Content-Type"]) {
          case "text/csv":
            s[e.HttpHeader.CONTENT_TYPE] = t.MediaType.TEXT_CSV;
            break;
          default:
            s[e.HttpHeader.CONTENT_TYPE] = t.MediaType.APPLICATION_JSON;
            break;
        }
      return i.headers && (s = Object.assign(Object.assign({}, s), i.headers)), s;
    }
    populateAuthentication(i, o) {
      this.authenticationConverter.convert(i, o);
    }
  }
  return US.BaseHttpClient = n, US;
}
var qS = {}, Fme;
function h4e() {
  if (Fme) return qS;
  Fme = 1, Object.defineProperty(qS, "__esModule", { value: !0 }), qS.HttpError = void 0;
  class e extends Error {
    constructor(n, r) {
      var i, o, s, l;
      const c = ((i = r == null ? void 0 : r.response) === null || i === void 0 ? void 0 : i.status) || 500, a = Buffer.isBuffer((o = r == null ? void 0 : r.response) === null || o === void 0 ? void 0 : o.data) ? (s = r == null ? void 0 : r.response) === null || s === void 0 ? void 0 : s.data.toString() : (l = r == null ? void 0 : r.response) === null || l === void 0 ? void 0 : l.data;
      super(JSON.stringify({
        response: {
          status: c,
          body: a
        },
        request: {
          body: n
        }
      })), this.requestBody = n, this.status = c, this.responseBody = a;
    }
    errorMessage() {
      return {
        response: {
          status: this.status,
          body: this.responseBody
        },
        request: {
          body: this.requestBody
        }
      };
    }
    get response() {
      return {
        status: this.status,
        body: this.responseBody
      };
    }
    get request() {
      return {
        body: this.requestBody
      };
    }
  }
  return qS.HttpError = e, qS;
}
var Ume;
function m4e() {
  if (Ume) return zS;
  Ume = 1, Object.defineProperty(zS, "__esModule", { value: !0 }), zS.AxiosHttpClient = void 0;
  const e = wx, t = e.__importDefault(/* @__PURE__ */ Tln()), n = e.__importDefault(Cln()), r = d4e(), i = p4e(), o = h4e();
  class s extends i.BaseHttpClient {
    constructor(c = "", a = new r.DelegatingAuthenticationConverter()) {
      super(c, a);
    }
    sendRequest(c, a) {
      return e.__awaiter(this, void 0, void 0, function* () {
        try {
          const u = a || t.default;
          process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
          const { urlWithoutQueryParams: f, queryParams: d } = this.getUrl(c), p = this.getHeaders(c), h = this.getAxiosRequestMethod(c.method), m = c.timeout ? c.timeout : 0, v = c.queryParams || {}, b = c.responseType || "json";
          for (const [O, x] of Object.entries(v))
            d.append(O, x);
          const A = {
            method: h,
            url: f,
            params: d,
            headers: p,
            data: c.body,
            timeout: m,
            responseType: b
          };
          c.retries && c.retries > 0 && (0, n.default)(u, {
            retries: c.retries,
            retryDelay: n.default.exponentialDelay,
            retryCondition: (O) => n.default.isNetworkOrIdempotentRequestError(O) || O.response && O.response.status >= 500 || !1
          });
          const w = yield u.request(A);
          return {
            status: w.status,
            headers: w.headers,
            body: w.data
          };
        } catch (u) {
          if (t.default.isAxiosError(u)) {
            const f = new o.HttpError(c.body, u);
            throw console.error("[HttpClient#(sanitized error message)] Request failed:", f), f;
          }
          throw u;
        }
      });
    }
    getAxiosRequestMethod(c) {
      return c.toString();
    }
  }
  return zS.AxiosHttpClient = s, zS;
}
var BS = {}, Vme;
function Nln() {
  if (Vme) return BS;
  Vme = 1, Object.defineProperty(BS, "__esModule", { value: !0 }), BS.httpClient = void 0;
  const e = m4e();
  return BS.httpClient = new e.AxiosHttpClient(), BS;
}
var JV = {}, qme;
function Pln() {
  return qme || (qme = 1, Object.defineProperty(JV, "__esModule", { value: !0 })), JV;
}
var eq = {}, Bme;
function Iln() {
  return Bme || (Bme = 1, Object.defineProperty(eq, "__esModule", { value: !0 })), eq;
}
var XS = {}, Xme;
function Rln() {
  if (Xme) return XS;
  Xme = 1, Object.defineProperty(XS, "__esModule", { value: !0 }), XS.HttpMethod = void 0;
  var e;
  return function(t) {
    t.GET = "GET", t.POST = "POST", t.PATCH = "PATCH", t.PUT = "PUT", t.DELETE = "DELETE", t.HEAD = "HEAD";
  }(e || (XS.HttpMethod = e = {})), XS;
}
var tq = {}, Wme;
function Mln() {
  return Wme || (Wme = 1, Object.defineProperty(tq, "__esModule", { value: !0 })), tq;
}
var nq = {}, Zme;
function Dln() {
  return Zme || (Zme = 1, Object.defineProperty(nq, "__esModule", { value: !0 })), nq;
}
var rq = {}, Hme;
function _ln() {
  return Hme || (Hme = 1, Object.defineProperty(rq, "__esModule", { value: !0 })), rq;
}
var Qme;
function g4e() {
  return Qme || (Qme = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = wx;
    t.__exportStar(m4e(), e), t.__exportStar(p4e(), e), t.__exportStar(d4e(), e), t.__exportStar(Nln(), e), t.__exportStar(h4e(), e), t.__exportStar($J(), e), t.__exportStar(Pln(), e), t.__exportStar(Iln(), e), t.__exportStar(Rln(), e), t.__exportStar(Mln(), e), t.__exportStar(Dln(), e), t.__exportStar(f4e(), e), t.__exportStar(_ln(), e);
  }(KV)), KV;
}
const y4e = /* @__PURE__ */ c2(Det);
var iq = {};
const Lln = {
  "application/1d-interleaved-parityfec": { source: "iana" },
  "application/3gpdash-qoe-report+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/3gpp-ims+xml": { source: "iana", compressible: !0 },
  "application/3gpphal+json": { source: "iana", compressible: !0 },
  "application/3gpphalforms+json": { source: "iana", compressible: !0 },
  "application/a2l": { source: "iana" },
  "application/ace+cbor": { source: "iana" },
  "application/activemessage": { source: "iana" },
  "application/activity+json": { source: "iana", compressible: !0 },
  "application/alto-costmap+json": { source: "iana", compressible: !0 },
  "application/alto-costmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-directory+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcost+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcostparams+json": { source: "iana", compressible: !0 },
  "application/alto-endpointprop+json": { source: "iana", compressible: !0 },
  "application/alto-endpointpropparams+json": { source: "iana", compressible: !0 },
  "application/alto-error+json": { source: "iana", compressible: !0 },
  "application/alto-networkmap+json": { source: "iana", compressible: !0 },
  "application/alto-networkmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamcontrol+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamparams+json": { source: "iana", compressible: !0 },
  "application/aml": { source: "iana" },
  "application/andrew-inset": { source: "iana", extensions: ["ez"] },
  "application/applefile": { source: "iana" },
  "application/applixware": { source: "apache", extensions: ["aw"] },
  "application/at+jwt": { source: "iana" },
  "application/atf": { source: "iana" },
  "application/atfx": { source: "iana" },
  "application/atom+xml": { source: "iana", compressible: !0, extensions: ["atom"] },
  "application/atomcat+xml": { source: "iana", compressible: !0, extensions: ["atomcat"] },
  "application/atomdeleted+xml": { source: "iana", compressible: !0, extensions: ["atomdeleted"] },
  "application/atomicmail": { source: "iana" },
  "application/atomsvc+xml": { source: "iana", compressible: !0, extensions: ["atomsvc"] },
  "application/atsc-dwd+xml": { source: "iana", compressible: !0, extensions: ["dwd"] },
  "application/atsc-dynamic-event-message": { source: "iana" },
  "application/atsc-held+xml": { source: "iana", compressible: !0, extensions: ["held"] },
  "application/atsc-rdt+json": { source: "iana", compressible: !0 },
  "application/atsc-rsat+xml": { source: "iana", compressible: !0, extensions: ["rsat"] },
  "application/atxml": { source: "iana" },
  "application/auth-policy+xml": { source: "iana", compressible: !0 },
  "application/bacnet-xdd+zip": { source: "iana", compressible: !1 },
  "application/batch-smtp": { source: "iana" },
  "application/bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/beep+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/calendar+json": { source: "iana", compressible: !0 },
  "application/calendar+xml": { source: "iana", compressible: !0, extensions: ["xcs"] },
  "application/call-completion": { source: "iana" },
  "application/cals-1840": { source: "iana" },
  "application/captive+json": { source: "iana", compressible: !0 },
  "application/cbor": { source: "iana" },
  "application/cbor-seq": { source: "iana" },
  "application/cccex": { source: "iana" },
  "application/ccmp+xml": { source: "iana", compressible: !0 },
  "application/ccxml+xml": { source: "iana", compressible: !0, extensions: ["ccxml"] },
  "application/cdfx+xml": { source: "iana", compressible: !0, extensions: ["cdfx"] },
  "application/cdmi-capability": { source: "iana", extensions: ["cdmia"] },
  "application/cdmi-container": { source: "iana", extensions: ["cdmic"] },
  "application/cdmi-domain": { source: "iana", extensions: ["cdmid"] },
  "application/cdmi-object": { source: "iana", extensions: ["cdmio"] },
  "application/cdmi-queue": { source: "iana", extensions: ["cdmiq"] },
  "application/cdni": { source: "iana" },
  "application/cea": { source: "iana" },
  "application/cea-2018+xml": { source: "iana", compressible: !0 },
  "application/cellml+xml": { source: "iana", compressible: !0 },
  "application/cfw": { source: "iana" },
  "application/city+json": { source: "iana", compressible: !0 },
  "application/clr": { source: "iana" },
  "application/clue+xml": { source: "iana", compressible: !0 },
  "application/clue_info+xml": { source: "iana", compressible: !0 },
  "application/cms": { source: "iana" },
  "application/cnrp+xml": { source: "iana", compressible: !0 },
  "application/coap-group+json": { source: "iana", compressible: !0 },
  "application/coap-payload": { source: "iana" },
  "application/commonground": { source: "iana" },
  "application/conference-info+xml": { source: "iana", compressible: !0 },
  "application/cose": { source: "iana" },
  "application/cose-key": { source: "iana" },
  "application/cose-key-set": { source: "iana" },
  "application/cpl+xml": { source: "iana", compressible: !0, extensions: ["cpl"] },
  "application/csrattrs": { source: "iana" },
  "application/csta+xml": { source: "iana", compressible: !0 },
  "application/cstadata+xml": { source: "iana", compressible: !0 },
  "application/csvm+json": { source: "iana", compressible: !0 },
  "application/cu-seeme": { source: "apache", extensions: ["cu"] },
  "application/cwt": { source: "iana" },
  "application/cybercash": { source: "iana" },
  "application/dart": { compressible: !0 },
  "application/dash+xml": { source: "iana", compressible: !0, extensions: ["mpd"] },
  "application/dash-patch+xml": { source: "iana", compressible: !0, extensions: ["mpp"] },
  "application/dashdelta": { source: "iana" },
  "application/davmount+xml": { source: "iana", compressible: !0, extensions: ["davmount"] },
  "application/dca-rft": { source: "iana" },
  "application/dcd": { source: "iana" },
  "application/dec-dx": { source: "iana" },
  "application/dialog-info+xml": { source: "iana", compressible: !0 },
  "application/dicom": { source: "iana" },
  "application/dicom+json": { source: "iana", compressible: !0 },
  "application/dicom+xml": { source: "iana", compressible: !0 },
  "application/dii": { source: "iana" },
  "application/dit": { source: "iana" },
  "application/dns": { source: "iana" },
  "application/dns+json": { source: "iana", compressible: !0 },
  "application/dns-message": { source: "iana" },
  "application/docbook+xml": { source: "apache", compressible: !0, extensions: ["dbk"] },
  "application/dots+cbor": { source: "iana" },
  "application/dskpp+xml": { source: "iana", compressible: !0 },
  "application/dssc+der": { source: "iana", extensions: ["dssc"] },
  "application/dssc+xml": { source: "iana", compressible: !0, extensions: ["xdssc"] },
  "application/dvcs": { source: "iana" },
  "application/ecmascript": { source: "iana", compressible: !0, extensions: ["es", "ecma"] },
  "application/edi-consent": { source: "iana" },
  "application/edi-x12": { source: "iana", compressible: !1 },
  "application/edifact": { source: "iana", compressible: !1 },
  "application/efi": { source: "iana" },
  "application/elm+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/elm+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.cap+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/emergencycalldata.comment+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.control+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.deviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.ecall.msd": { source: "iana" },
  "application/emergencycalldata.providerinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.serviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.subscriberinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.veds+xml": { source: "iana", compressible: !0 },
  "application/emma+xml": { source: "iana", compressible: !0, extensions: ["emma"] },
  "application/emotionml+xml": { source: "iana", compressible: !0, extensions: ["emotionml"] },
  "application/encaprtp": { source: "iana" },
  "application/epp+xml": { source: "iana", compressible: !0 },
  "application/epub+zip": { source: "iana", compressible: !1, extensions: ["epub"] },
  "application/eshop": { source: "iana" },
  "application/exi": { source: "iana", extensions: ["exi"] },
  "application/expect-ct-report+json": { source: "iana", compressible: !0 },
  "application/express": { source: "iana", extensions: ["exp"] },
  "application/fastinfoset": { source: "iana" },
  "application/fastsoap": { source: "iana" },
  "application/fdt+xml": { source: "iana", compressible: !0, extensions: ["fdt"] },
  "application/fhir+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fhir+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fido.trusted-apps+json": { compressible: !0 },
  "application/fits": { source: "iana" },
  "application/flexfec": { source: "iana" },
  "application/font-sfnt": { source: "iana" },
  "application/font-tdpfr": { source: "iana", extensions: ["pfr"] },
  "application/font-woff": { source: "iana", compressible: !1 },
  "application/framework-attributes+xml": { source: "iana", compressible: !0 },
  "application/geo+json": { source: "iana", compressible: !0, extensions: ["geojson"] },
  "application/geo+json-seq": { source: "iana" },
  "application/geopackage+sqlite3": { source: "iana" },
  "application/geoxacml+xml": { source: "iana", compressible: !0 },
  "application/gltf-buffer": { source: "iana" },
  "application/gml+xml": { source: "iana", compressible: !0, extensions: ["gml"] },
  "application/gpx+xml": { source: "apache", compressible: !0, extensions: ["gpx"] },
  "application/gxf": { source: "apache", extensions: ["gxf"] },
  "application/gzip": { source: "iana", compressible: !1, extensions: ["gz"] },
  "application/h224": { source: "iana" },
  "application/held+xml": { source: "iana", compressible: !0 },
  "application/hjson": { extensions: ["hjson"] },
  "application/http": { source: "iana" },
  "application/hyperstudio": { source: "iana", extensions: ["stk"] },
  "application/ibe-key-request+xml": { source: "iana", compressible: !0 },
  "application/ibe-pkg-reply+xml": { source: "iana", compressible: !0 },
  "application/ibe-pp-data": { source: "iana" },
  "application/iges": { source: "iana" },
  "application/im-iscomposing+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/index": { source: "iana" },
  "application/index.cmd": { source: "iana" },
  "application/index.obj": { source: "iana" },
  "application/index.response": { source: "iana" },
  "application/index.vnd": { source: "iana" },
  "application/inkml+xml": { source: "iana", compressible: !0, extensions: ["ink", "inkml"] },
  "application/iotp": { source: "iana" },
  "application/ipfix": { source: "iana", extensions: ["ipfix"] },
  "application/ipp": { source: "iana" },
  "application/isup": { source: "iana" },
  "application/its+xml": { source: "iana", compressible: !0, extensions: ["its"] },
  "application/java-archive": { source: "apache", compressible: !1, extensions: ["jar", "war", "ear"] },
  "application/java-serialized-object": { source: "apache", compressible: !1, extensions: ["ser"] },
  "application/java-vm": { source: "apache", compressible: !1, extensions: ["class"] },
  "application/javascript": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["js", "mjs"] },
  "application/jf2feed+json": { source: "iana", compressible: !0 },
  "application/jose": { source: "iana" },
  "application/jose+json": { source: "iana", compressible: !0 },
  "application/jrd+json": { source: "iana", compressible: !0 },
  "application/jscalendar+json": { source: "iana", compressible: !0 },
  "application/json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["json", "map"] },
  "application/json-patch+json": { source: "iana", compressible: !0 },
  "application/json-seq": { source: "iana" },
  "application/json5": { extensions: ["json5"] },
  "application/jsonml+json": { source: "apache", compressible: !0, extensions: ["jsonml"] },
  "application/jwk+json": { source: "iana", compressible: !0 },
  "application/jwk-set+json": { source: "iana", compressible: !0 },
  "application/jwt": { source: "iana" },
  "application/kpml-request+xml": { source: "iana", compressible: !0 },
  "application/kpml-response+xml": { source: "iana", compressible: !0 },
  "application/ld+json": { source: "iana", compressible: !0, extensions: ["jsonld"] },
  "application/lgr+xml": { source: "iana", compressible: !0, extensions: ["lgr"] },
  "application/link-format": { source: "iana" },
  "application/load-control+xml": { source: "iana", compressible: !0 },
  "application/lost+xml": { source: "iana", compressible: !0, extensions: ["lostxml"] },
  "application/lostsync+xml": { source: "iana", compressible: !0 },
  "application/lpf+zip": { source: "iana", compressible: !1 },
  "application/lxf": { source: "iana" },
  "application/mac-binhex40": { source: "iana", extensions: ["hqx"] },
  "application/mac-compactpro": { source: "apache", extensions: ["cpt"] },
  "application/macwriteii": { source: "iana" },
  "application/mads+xml": { source: "iana", compressible: !0, extensions: ["mads"] },
  "application/manifest+json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["webmanifest"] },
  "application/marc": { source: "iana", extensions: ["mrc"] },
  "application/marcxml+xml": { source: "iana", compressible: !0, extensions: ["mrcx"] },
  "application/mathematica": { source: "iana", extensions: ["ma", "nb", "mb"] },
  "application/mathml+xml": { source: "iana", compressible: !0, extensions: ["mathml"] },
  "application/mathml-content+xml": { source: "iana", compressible: !0 },
  "application/mathml-presentation+xml": { source: "iana", compressible: !0 },
  "application/mbms-associated-procedure-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-deregister+xml": { source: "iana", compressible: !0 },
  "application/mbms-envelope+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-protection-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-reception-report+xml": { source: "iana", compressible: !0 },
  "application/mbms-register+xml": { source: "iana", compressible: !0 },
  "application/mbms-register-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-schedule+xml": { source: "iana", compressible: !0 },
  "application/mbms-user-service-description+xml": { source: "iana", compressible: !0 },
  "application/mbox": { source: "iana", extensions: ["mbox"] },
  "application/media-policy-dataset+xml": { source: "iana", compressible: !0, extensions: ["mpf"] },
  "application/media_control+xml": { source: "iana", compressible: !0 },
  "application/mediaservercontrol+xml": { source: "iana", compressible: !0, extensions: ["mscml"] },
  "application/merge-patch+json": { source: "iana", compressible: !0 },
  "application/metalink+xml": { source: "apache", compressible: !0, extensions: ["metalink"] },
  "application/metalink4+xml": { source: "iana", compressible: !0, extensions: ["meta4"] },
  "application/mets+xml": { source: "iana", compressible: !0, extensions: ["mets"] },
  "application/mf4": { source: "iana" },
  "application/mikey": { source: "iana" },
  "application/mipc": { source: "iana" },
  "application/missing-blocks+cbor-seq": { source: "iana" },
  "application/mmt-aei+xml": { source: "iana", compressible: !0, extensions: ["maei"] },
  "application/mmt-usd+xml": { source: "iana", compressible: !0, extensions: ["musd"] },
  "application/mods+xml": { source: "iana", compressible: !0, extensions: ["mods"] },
  "application/moss-keys": { source: "iana" },
  "application/moss-signature": { source: "iana" },
  "application/mosskey-data": { source: "iana" },
  "application/mosskey-request": { source: "iana" },
  "application/mp21": { source: "iana", extensions: ["m21", "mp21"] },
  "application/mp4": { source: "iana", extensions: ["mp4s", "m4p"] },
  "application/mpeg4-generic": { source: "iana" },
  "application/mpeg4-iod": { source: "iana" },
  "application/mpeg4-iod-xmt": { source: "iana" },
  "application/mrb-consumer+xml": { source: "iana", compressible: !0 },
  "application/mrb-publish+xml": { source: "iana", compressible: !0 },
  "application/msc-ivr+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msc-mixer+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msword": { source: "iana", compressible: !1, extensions: ["doc", "dot"] },
  "application/mud+json": { source: "iana", compressible: !0 },
  "application/multipart-core": { source: "iana" },
  "application/mxf": { source: "iana", extensions: ["mxf"] },
  "application/n-quads": { source: "iana", extensions: ["nq"] },
  "application/n-triples": { source: "iana", extensions: ["nt"] },
  "application/nasdata": { source: "iana" },
  "application/news-checkgroups": { source: "iana", charset: "US-ASCII" },
  "application/news-groupinfo": { source: "iana", charset: "US-ASCII" },
  "application/news-transmission": { source: "iana" },
  "application/nlsml+xml": { source: "iana", compressible: !0 },
  "application/node": { source: "iana", extensions: ["cjs"] },
  "application/nss": { source: "iana" },
  "application/oauth-authz-req+jwt": { source: "iana" },
  "application/oblivious-dns-message": { source: "iana" },
  "application/ocsp-request": { source: "iana" },
  "application/ocsp-response": { source: "iana" },
  "application/octet-stream": { source: "iana", compressible: !1, extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { source: "iana", extensions: ["oda"] },
  "application/odm+xml": { source: "iana", compressible: !0 },
  "application/odx": { source: "iana" },
  "application/oebps-package+xml": { source: "iana", compressible: !0, extensions: ["opf"] },
  "application/ogg": { source: "iana", compressible: !1, extensions: ["ogx"] },
  "application/omdoc+xml": { source: "apache", compressible: !0, extensions: ["omdoc"] },
  "application/onenote": { source: "apache", extensions: ["onetoc", "onetoc2", "onetmp", "onepkg"] },
  "application/opc-nodeset+xml": { source: "iana", compressible: !0 },
  "application/oscore": { source: "iana" },
  "application/oxps": { source: "iana", extensions: ["oxps"] },
  "application/p21": { source: "iana" },
  "application/p21+zip": { source: "iana", compressible: !1 },
  "application/p2p-overlay+xml": { source: "iana", compressible: !0, extensions: ["relo"] },
  "application/parityfec": { source: "iana" },
  "application/passport": { source: "iana" },
  "application/patch-ops-error+xml": { source: "iana", compressible: !0, extensions: ["xer"] },
  "application/pdf": { source: "iana", compressible: !1, extensions: ["pdf"] },
  "application/pdx": { source: "iana" },
  "application/pem-certificate-chain": { source: "iana" },
  "application/pgp-encrypted": { source: "iana", compressible: !1, extensions: ["pgp"] },
  "application/pgp-keys": { source: "iana", extensions: ["asc"] },
  "application/pgp-signature": { source: "iana", extensions: ["asc", "sig"] },
  "application/pics-rules": { source: "apache", extensions: ["prf"] },
  "application/pidf+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pidf-diff+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pkcs10": { source: "iana", extensions: ["p10"] },
  "application/pkcs12": { source: "iana" },
  "application/pkcs7-mime": { source: "iana", extensions: ["p7m", "p7c"] },
  "application/pkcs7-signature": { source: "iana", extensions: ["p7s"] },
  "application/pkcs8": { source: "iana", extensions: ["p8"] },
  "application/pkcs8-encrypted": { source: "iana" },
  "application/pkix-attr-cert": { source: "iana", extensions: ["ac"] },
  "application/pkix-cert": { source: "iana", extensions: ["cer"] },
  "application/pkix-crl": { source: "iana", extensions: ["crl"] },
  "application/pkix-pkipath": { source: "iana", extensions: ["pkipath"] },
  "application/pkixcmp": { source: "iana", extensions: ["pki"] },
  "application/pls+xml": { source: "iana", compressible: !0, extensions: ["pls"] },
  "application/poc-settings+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/postscript": { source: "iana", compressible: !0, extensions: ["ai", "eps", "ps"] },
  "application/ppsp-tracker+json": { source: "iana", compressible: !0 },
  "application/problem+json": { source: "iana", compressible: !0 },
  "application/problem+xml": { source: "iana", compressible: !0 },
  "application/provenance+xml": { source: "iana", compressible: !0, extensions: ["provx"] },
  "application/prs.alvestrand.titrax-sheet": { source: "iana" },
  "application/prs.cww": { source: "iana", extensions: ["cww"] },
  "application/prs.cyn": { source: "iana", charset: "7-BIT" },
  "application/prs.hpub+zip": { source: "iana", compressible: !1 },
  "application/prs.nprend": { source: "iana" },
  "application/prs.plucker": { source: "iana" },
  "application/prs.rdf-xml-crypt": { source: "iana" },
  "application/prs.xsf+xml": { source: "iana", compressible: !0 },
  "application/pskc+xml": { source: "iana", compressible: !0, extensions: ["pskcxml"] },
  "application/pvd+json": { source: "iana", compressible: !0 },
  "application/qsig": { source: "iana" },
  "application/raml+yaml": { compressible: !0, extensions: ["raml"] },
  "application/raptorfec": { source: "iana" },
  "application/rdap+json": { source: "iana", compressible: !0 },
  "application/rdf+xml": { source: "iana", compressible: !0, extensions: ["rdf", "owl"] },
  "application/reginfo+xml": { source: "iana", compressible: !0, extensions: ["rif"] },
  "application/relax-ng-compact-syntax": { source: "iana", extensions: ["rnc"] },
  "application/remote-printing": { source: "iana" },
  "application/reputon+json": { source: "iana", compressible: !0 },
  "application/resource-lists+xml": { source: "iana", compressible: !0, extensions: ["rl"] },
  "application/resource-lists-diff+xml": { source: "iana", compressible: !0, extensions: ["rld"] },
  "application/rfc+xml": { source: "iana", compressible: !0 },
  "application/riscos": { source: "iana" },
  "application/rlmi+xml": { source: "iana", compressible: !0 },
  "application/rls-services+xml": { source: "iana", compressible: !0, extensions: ["rs"] },
  "application/route-apd+xml": { source: "iana", compressible: !0, extensions: ["rapd"] },
  "application/route-s-tsid+xml": { source: "iana", compressible: !0, extensions: ["sls"] },
  "application/route-usd+xml": { source: "iana", compressible: !0, extensions: ["rusd"] },
  "application/rpki-ghostbusters": { source: "iana", extensions: ["gbr"] },
  "application/rpki-manifest": { source: "iana", extensions: ["mft"] },
  "application/rpki-publication": { source: "iana" },
  "application/rpki-roa": { source: "iana", extensions: ["roa"] },
  "application/rpki-updown": { source: "iana" },
  "application/rsd+xml": { source: "apache", compressible: !0, extensions: ["rsd"] },
  "application/rss+xml": { source: "apache", compressible: !0, extensions: ["rss"] },
  "application/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "application/rtploopback": { source: "iana" },
  "application/rtx": { source: "iana" },
  "application/samlassertion+xml": { source: "iana", compressible: !0 },
  "application/samlmetadata+xml": { source: "iana", compressible: !0 },
  "application/sarif+json": { source: "iana", compressible: !0 },
  "application/sarif-external-properties+json": { source: "iana", compressible: !0 },
  "application/sbe": { source: "iana" },
  "application/sbml+xml": { source: "iana", compressible: !0, extensions: ["sbml"] },
  "application/scaip+xml": { source: "iana", compressible: !0 },
  "application/scim+json": { source: "iana", compressible: !0 },
  "application/scvp-cv-request": { source: "iana", extensions: ["scq"] },
  "application/scvp-cv-response": { source: "iana", extensions: ["scs"] },
  "application/scvp-vp-request": { source: "iana", extensions: ["spq"] },
  "application/scvp-vp-response": { source: "iana", extensions: ["spp"] },
  "application/sdp": { source: "iana", extensions: ["sdp"] },
  "application/secevent+jwt": { source: "iana" },
  "application/senml+cbor": { source: "iana" },
  "application/senml+json": { source: "iana", compressible: !0 },
  "application/senml+xml": { source: "iana", compressible: !0, extensions: ["senmlx"] },
  "application/senml-etch+cbor": { source: "iana" },
  "application/senml-etch+json": { source: "iana", compressible: !0 },
  "application/senml-exi": { source: "iana" },
  "application/sensml+cbor": { source: "iana" },
  "application/sensml+json": { source: "iana", compressible: !0 },
  "application/sensml+xml": { source: "iana", compressible: !0, extensions: ["sensmlx"] },
  "application/sensml-exi": { source: "iana" },
  "application/sep+xml": { source: "iana", compressible: !0 },
  "application/sep-exi": { source: "iana" },
  "application/session-info": { source: "iana" },
  "application/set-payment": { source: "iana" },
  "application/set-payment-initiation": { source: "iana", extensions: ["setpay"] },
  "application/set-registration": { source: "iana" },
  "application/set-registration-initiation": { source: "iana", extensions: ["setreg"] },
  "application/sgml": { source: "iana" },
  "application/sgml-open-catalog": { source: "iana" },
  "application/shf+xml": { source: "iana", compressible: !0, extensions: ["shf"] },
  "application/sieve": { source: "iana", extensions: ["siv", "sieve"] },
  "application/simple-filter+xml": { source: "iana", compressible: !0 },
  "application/simple-message-summary": { source: "iana" },
  "application/simplesymbolcontainer": { source: "iana" },
  "application/sipc": { source: "iana" },
  "application/slate": { source: "iana" },
  "application/smil": { source: "iana" },
  "application/smil+xml": { source: "iana", compressible: !0, extensions: ["smi", "smil"] },
  "application/smpte336m": { source: "iana" },
  "application/soap+fastinfoset": { source: "iana" },
  "application/soap+xml": { source: "iana", compressible: !0 },
  "application/sparql-query": { source: "iana", extensions: ["rq"] },
  "application/sparql-results+xml": { source: "iana", compressible: !0, extensions: ["srx"] },
  "application/spdx+json": { source: "iana", compressible: !0 },
  "application/spirits-event+xml": { source: "iana", compressible: !0 },
  "application/sql": { source: "iana" },
  "application/srgs": { source: "iana", extensions: ["gram"] },
  "application/srgs+xml": { source: "iana", compressible: !0, extensions: ["grxml"] },
  "application/sru+xml": { source: "iana", compressible: !0, extensions: ["sru"] },
  "application/ssdl+xml": { source: "apache", compressible: !0, extensions: ["ssdl"] },
  "application/ssml+xml": { source: "iana", compressible: !0, extensions: ["ssml"] },
  "application/stix+json": { source: "iana", compressible: !0 },
  "application/swid+xml": { source: "iana", compressible: !0, extensions: ["swidtag"] },
  "application/tamp-apex-update": { source: "iana" },
  "application/tamp-apex-update-confirm": { source: "iana" },
  "application/tamp-community-update": { source: "iana" },
  "application/tamp-community-update-confirm": { source: "iana" },
  "application/tamp-error": { source: "iana" },
  "application/tamp-sequence-adjust": { source: "iana" },
  "application/tamp-sequence-adjust-confirm": { source: "iana" },
  "application/tamp-status-query": { source: "iana" },
  "application/tamp-status-response": { source: "iana" },
  "application/tamp-update": { source: "iana" },
  "application/tamp-update-confirm": { source: "iana" },
  "application/tar": { compressible: !0 },
  "application/taxii+json": { source: "iana", compressible: !0 },
  "application/td+json": { source: "iana", compressible: !0 },
  "application/tei+xml": { source: "iana", compressible: !0, extensions: ["tei", "teicorpus"] },
  "application/tetra_isi": { source: "iana" },
  "application/thraud+xml": { source: "iana", compressible: !0, extensions: ["tfi"] },
  "application/timestamp-query": { source: "iana" },
  "application/timestamp-reply": { source: "iana" },
  "application/timestamped-data": { source: "iana", extensions: ["tsd"] },
  "application/tlsrpt+gzip": { source: "iana" },
  "application/tlsrpt+json": { source: "iana", compressible: !0 },
  "application/tnauthlist": { source: "iana" },
  "application/token-introspection+jwt": { source: "iana" },
  "application/toml": { compressible: !0, extensions: ["toml"] },
  "application/trickle-ice-sdpfrag": { source: "iana" },
  "application/trig": { source: "iana", extensions: ["trig"] },
  "application/ttml+xml": { source: "iana", compressible: !0, extensions: ["ttml"] },
  "application/tve-trigger": { source: "iana" },
  "application/tzif": { source: "iana" },
  "application/tzif-leap": { source: "iana" },
  "application/ubjson": { compressible: !1, extensions: ["ubj"] },
  "application/ulpfec": { source: "iana" },
  "application/urc-grpsheet+xml": { source: "iana", compressible: !0 },
  "application/urc-ressheet+xml": { source: "iana", compressible: !0, extensions: ["rsheet"] },
  "application/urc-targetdesc+xml": { source: "iana", compressible: !0, extensions: ["td"] },
  "application/urc-uisocketdesc+xml": { source: "iana", compressible: !0 },
  "application/vcard+json": { source: "iana", compressible: !0 },
  "application/vcard+xml": { source: "iana", compressible: !0 },
  "application/vemmi": { source: "iana" },
  "application/vividence.scriptfile": { source: "apache" },
  "application/vnd.1000minds.decision-model+xml": { source: "iana", compressible: !0, extensions: ["1km"] },
  "application/vnd.3gpp-prose+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-prose-pc3ch+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-v2x-local-service-information": { source: "iana" },
  "application/vnd.3gpp.5gnas": { source: "iana" },
  "application/vnd.3gpp.access-transfer-events+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.bsf+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gmop+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gtpc": { source: "iana" },
  "application/vnd.3gpp.interworking-data": { source: "iana" },
  "application/vnd.3gpp.lpp": { source: "iana" },
  "application/vnd.3gpp.mc-signalling-ear": { source: "iana" },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-payload": { source: "iana" },
  "application/vnd.3gpp.mcdata-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-signalling": { source: "iana" },
  "application/vnd.3gpp.mcdata-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-floor-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-signed+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mid-call+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ngap": { source: "iana" },
  "application/vnd.3gpp.pfcp": { source: "iana" },
  "application/vnd.3gpp.pic-bw-large": { source: "iana", extensions: ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { source: "iana", extensions: ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { source: "iana", extensions: ["pvb"] },
  "application/vnd.3gpp.s1ap": { source: "iana" },
  "application/vnd.3gpp.sms": { source: "iana" },
  "application/vnd.3gpp.sms+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-ext+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.state-and-event-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ussd+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.bcmcsinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.sms": { source: "iana" },
  "application/vnd.3gpp2.tcap": { source: "iana", extensions: ["tcap"] },
  "application/vnd.3lightssoftware.imagescal": { source: "iana" },
  "application/vnd.3m.post-it-notes": { source: "iana", extensions: ["pwn"] },
  "application/vnd.accpac.simply.aso": { source: "iana", extensions: ["aso"] },
  "application/vnd.accpac.simply.imp": { source: "iana", extensions: ["imp"] },
  "application/vnd.acucobol": { source: "iana", extensions: ["acu"] },
  "application/vnd.acucorp": { source: "iana", extensions: ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { source: "apache", compressible: !1, extensions: ["air"] },
  "application/vnd.adobe.flash.movie": { source: "iana" },
  "application/vnd.adobe.formscentral.fcdt": { source: "iana", extensions: ["fcdt"] },
  "application/vnd.adobe.fxp": { source: "iana", extensions: ["fxp", "fxpl"] },
  "application/vnd.adobe.partial-upload": { source: "iana" },
  "application/vnd.adobe.xdp+xml": { source: "iana", compressible: !0, extensions: ["xdp"] },
  "application/vnd.adobe.xfdf": { source: "iana", extensions: ["xfdf"] },
  "application/vnd.aether.imp": { source: "iana" },
  "application/vnd.afpc.afplinedata": { source: "iana" },
  "application/vnd.afpc.afplinedata-pagedef": { source: "iana" },
  "application/vnd.afpc.cmoca-cmresource": { source: "iana" },
  "application/vnd.afpc.foca-charset": { source: "iana" },
  "application/vnd.afpc.foca-codedfont": { source: "iana" },
  "application/vnd.afpc.foca-codepage": { source: "iana" },
  "application/vnd.afpc.modca": { source: "iana" },
  "application/vnd.afpc.modca-cmtable": { source: "iana" },
  "application/vnd.afpc.modca-formdef": { source: "iana" },
  "application/vnd.afpc.modca-mediummap": { source: "iana" },
  "application/vnd.afpc.modca-objectcontainer": { source: "iana" },
  "application/vnd.afpc.modca-overlay": { source: "iana" },
  "application/vnd.afpc.modca-pagesegment": { source: "iana" },
  "application/vnd.age": { source: "iana", extensions: ["age"] },
  "application/vnd.ah-barcode": { source: "iana" },
  "application/vnd.ahead.space": { source: "iana", extensions: ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { source: "iana", extensions: ["azf"] },
  "application/vnd.airzip.filesecure.azs": { source: "iana", extensions: ["azs"] },
  "application/vnd.amadeus+json": { source: "iana", compressible: !0 },
  "application/vnd.amazon.ebook": { source: "apache", extensions: ["azw"] },
  "application/vnd.amazon.mobi8-ebook": { source: "iana" },
  "application/vnd.americandynamics.acc": { source: "iana", extensions: ["acc"] },
  "application/vnd.amiga.ami": { source: "iana", extensions: ["ami"] },
  "application/vnd.amundsen.maze+xml": { source: "iana", compressible: !0 },
  "application/vnd.android.ota": { source: "iana" },
  "application/vnd.android.package-archive": { source: "apache", compressible: !1, extensions: ["apk"] },
  "application/vnd.anki": { source: "iana" },
  "application/vnd.anser-web-certificate-issue-initiation": { source: "iana", extensions: ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { source: "apache", extensions: ["fti"] },
  "application/vnd.antix.game-component": { source: "iana", extensions: ["atx"] },
  "application/vnd.apache.arrow.file": { source: "iana" },
  "application/vnd.apache.arrow.stream": { source: "iana" },
  "application/vnd.apache.thrift.binary": { source: "iana" },
  "application/vnd.apache.thrift.compact": { source: "iana" },
  "application/vnd.apache.thrift.json": { source: "iana" },
  "application/vnd.api+json": { source: "iana", compressible: !0 },
  "application/vnd.aplextor.warrp+json": { source: "iana", compressible: !0 },
  "application/vnd.apothekende.reservation+json": { source: "iana", compressible: !0 },
  "application/vnd.apple.installer+xml": { source: "iana", compressible: !0, extensions: ["mpkg"] },
  "application/vnd.apple.keynote": { source: "iana", extensions: ["key"] },
  "application/vnd.apple.mpegurl": { source: "iana", extensions: ["m3u8"] },
  "application/vnd.apple.numbers": { source: "iana", extensions: ["numbers"] },
  "application/vnd.apple.pages": { source: "iana", extensions: ["pages"] },
  "application/vnd.apple.pkpass": { compressible: !1, extensions: ["pkpass"] },
  "application/vnd.arastra.swi": { source: "iana" },
  "application/vnd.aristanetworks.swi": { source: "iana", extensions: ["swi"] },
  "application/vnd.artisan+json": { source: "iana", compressible: !0 },
  "application/vnd.artsquare": { source: "iana" },
  "application/vnd.astraea-software.iota": { source: "iana", extensions: ["iota"] },
  "application/vnd.audiograph": { source: "iana", extensions: ["aep"] },
  "application/vnd.autopackage": { source: "iana" },
  "application/vnd.avalon+json": { source: "iana", compressible: !0 },
  "application/vnd.avistar+xml": { source: "iana", compressible: !0 },
  "application/vnd.balsamiq.bmml+xml": { source: "iana", compressible: !0, extensions: ["bmml"] },
  "application/vnd.balsamiq.bmpr": { source: "iana" },
  "application/vnd.banana-accounting": { source: "iana" },
  "application/vnd.bbf.usp.error": { source: "iana" },
  "application/vnd.bbf.usp.msg": { source: "iana" },
  "application/vnd.bbf.usp.msg+json": { source: "iana", compressible: !0 },
  "application/vnd.bekitzur-stech+json": { source: "iana", compressible: !0 },
  "application/vnd.bint.med-content": { source: "iana" },
  "application/vnd.biopax.rdf+xml": { source: "iana", compressible: !0 },
  "application/vnd.blink-idb-value-wrapper": { source: "iana" },
  "application/vnd.blueice.multipass": { source: "iana", extensions: ["mpm"] },
  "application/vnd.bluetooth.ep.oob": { source: "iana" },
  "application/vnd.bluetooth.le.oob": { source: "iana" },
  "application/vnd.bmi": { source: "iana", extensions: ["bmi"] },
  "application/vnd.bpf": { source: "iana" },
  "application/vnd.bpf3": { source: "iana" },
  "application/vnd.businessobjects": { source: "iana", extensions: ["rep"] },
  "application/vnd.byu.uapi+json": { source: "iana", compressible: !0 },
  "application/vnd.cab-jscript": { source: "iana" },
  "application/vnd.canon-cpdl": { source: "iana" },
  "application/vnd.canon-lips": { source: "iana" },
  "application/vnd.capasystems-pg+json": { source: "iana", compressible: !0 },
  "application/vnd.cendio.thinlinc.clientconf": { source: "iana" },
  "application/vnd.century-systems.tcp_stream": { source: "iana" },
  "application/vnd.chemdraw+xml": { source: "iana", compressible: !0, extensions: ["cdxml"] },
  "application/vnd.chess-pgn": { source: "iana" },
  "application/vnd.chipnuts.karaoke-mmd": { source: "iana", extensions: ["mmd"] },
  "application/vnd.ciedi": { source: "iana" },
  "application/vnd.cinderella": { source: "iana", extensions: ["cdy"] },
  "application/vnd.cirpack.isdn-ext": { source: "iana" },
  "application/vnd.citationstyles.style+xml": { source: "iana", compressible: !0, extensions: ["csl"] },
  "application/vnd.claymore": { source: "iana", extensions: ["cla"] },
  "application/vnd.cloanto.rp9": { source: "iana", extensions: ["rp9"] },
  "application/vnd.clonk.c4group": { source: "iana", extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { source: "iana", extensions: ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { source: "iana", extensions: ["c11amz"] },
  "application/vnd.coffeescript": { source: "iana" },
  "application/vnd.collabio.xodocuments.document": { source: "iana" },
  "application/vnd.collabio.xodocuments.document-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet-template": { source: "iana" },
  "application/vnd.collection+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.doc+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.next+json": { source: "iana", compressible: !0 },
  "application/vnd.comicbook+zip": { source: "iana", compressible: !1 },
  "application/vnd.comicbook-rar": { source: "iana" },
  "application/vnd.commerce-battelle": { source: "iana" },
  "application/vnd.commonspace": { source: "iana", extensions: ["csp"] },
  "application/vnd.contact.cmsg": { source: "iana", extensions: ["cdbcmsg"] },
  "application/vnd.coreos.ignition+json": { source: "iana", compressible: !0 },
  "application/vnd.cosmocaller": { source: "iana", extensions: ["cmc"] },
  "application/vnd.crick.clicker": { source: "iana", extensions: ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { source: "iana", extensions: ["clkk"] },
  "application/vnd.crick.clicker.palette": { source: "iana", extensions: ["clkp"] },
  "application/vnd.crick.clicker.template": { source: "iana", extensions: ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { source: "iana", extensions: ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { source: "iana", compressible: !0, extensions: ["wbs"] },
  "application/vnd.cryptii.pipe+json": { source: "iana", compressible: !0 },
  "application/vnd.crypto-shade-file": { source: "iana" },
  "application/vnd.cryptomator.encrypted": { source: "iana" },
  "application/vnd.cryptomator.vault": { source: "iana" },
  "application/vnd.ctc-posml": { source: "iana", extensions: ["pml"] },
  "application/vnd.ctct.ws+xml": { source: "iana", compressible: !0 },
  "application/vnd.cups-pdf": { source: "iana" },
  "application/vnd.cups-postscript": { source: "iana" },
  "application/vnd.cups-ppd": { source: "iana", extensions: ["ppd"] },
  "application/vnd.cups-raster": { source: "iana" },
  "application/vnd.cups-raw": { source: "iana" },
  "application/vnd.curl": { source: "iana" },
  "application/vnd.curl.car": { source: "apache", extensions: ["car"] },
  "application/vnd.curl.pcurl": { source: "apache", extensions: ["pcurl"] },
  "application/vnd.cyan.dean.root+xml": { source: "iana", compressible: !0 },
  "application/vnd.cybank": { source: "iana" },
  "application/vnd.cyclonedx+json": { source: "iana", compressible: !0 },
  "application/vnd.cyclonedx+xml": { source: "iana", compressible: !0 },
  "application/vnd.d2l.coursepackage1p0+zip": { source: "iana", compressible: !1 },
  "application/vnd.d3m-dataset": { source: "iana" },
  "application/vnd.d3m-problem": { source: "iana" },
  "application/vnd.dart": { source: "iana", compressible: !0, extensions: ["dart"] },
  "application/vnd.data-vision.rdz": { source: "iana", extensions: ["rdz"] },
  "application/vnd.datapackage+json": { source: "iana", compressible: !0 },
  "application/vnd.dataresource+json": { source: "iana", compressible: !0 },
  "application/vnd.dbf": { source: "iana", extensions: ["dbf"] },
  "application/vnd.debian.binary-package": { source: "iana" },
  "application/vnd.dece.data": { source: "iana", extensions: ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { source: "iana", compressible: !0, extensions: ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { source: "iana", extensions: ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { source: "iana", extensions: ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { source: "iana", extensions: ["fe_launch"] },
  "application/vnd.desmume.movie": { source: "iana" },
  "application/vnd.dir-bi.plate-dl-nosuffix": { source: "iana" },
  "application/vnd.dm.delegation+xml": { source: "iana", compressible: !0 },
  "application/vnd.dna": { source: "iana", extensions: ["dna"] },
  "application/vnd.document+json": { source: "iana", compressible: !0 },
  "application/vnd.dolby.mlp": { source: "apache", extensions: ["mlp"] },
  "application/vnd.dolby.mobile.1": { source: "iana" },
  "application/vnd.dolby.mobile.2": { source: "iana" },
  "application/vnd.doremir.scorecloud-binary-document": { source: "iana" },
  "application/vnd.dpgraph": { source: "iana", extensions: ["dpg"] },
  "application/vnd.dreamfactory": { source: "iana", extensions: ["dfac"] },
  "application/vnd.drive+json": { source: "iana", compressible: !0 },
  "application/vnd.ds-keypoint": { source: "apache", extensions: ["kpxx"] },
  "application/vnd.dtg.local": { source: "iana" },
  "application/vnd.dtg.local.flash": { source: "iana" },
  "application/vnd.dtg.local.html": { source: "iana" },
  "application/vnd.dvb.ait": { source: "iana", extensions: ["ait"] },
  "application/vnd.dvb.dvbisl+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.dvbj": { source: "iana" },
  "application/vnd.dvb.esgcontainer": { source: "iana" },
  "application/vnd.dvb.ipdcdftnotifaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess2": { source: "iana" },
  "application/vnd.dvb.ipdcesgpdd": { source: "iana" },
  "application/vnd.dvb.ipdcroaming": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-base": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-enhancement": { source: "iana" },
  "application/vnd.dvb.notif-aggregate-root+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-container+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-generic+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-msglist+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-response+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-init+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.pfr": { source: "iana" },
  "application/vnd.dvb.service": { source: "iana", extensions: ["svc"] },
  "application/vnd.dxr": { source: "iana" },
  "application/vnd.dynageo": { source: "iana", extensions: ["geo"] },
  "application/vnd.dzr": { source: "iana" },
  "application/vnd.easykaraoke.cdgdownload": { source: "iana" },
  "application/vnd.ecdis-update": { source: "iana" },
  "application/vnd.ecip.rlp": { source: "iana" },
  "application/vnd.eclipse.ditto+json": { source: "iana", compressible: !0 },
  "application/vnd.ecowin.chart": { source: "iana", extensions: ["mag"] },
  "application/vnd.ecowin.filerequest": { source: "iana" },
  "application/vnd.ecowin.fileupdate": { source: "iana" },
  "application/vnd.ecowin.series": { source: "iana" },
  "application/vnd.ecowin.seriesrequest": { source: "iana" },
  "application/vnd.ecowin.seriesupdate": { source: "iana" },
  "application/vnd.efi.img": { source: "iana" },
  "application/vnd.efi.iso": { source: "iana" },
  "application/vnd.emclient.accessrequest+xml": { source: "iana", compressible: !0 },
  "application/vnd.enliven": { source: "iana", extensions: ["nml"] },
  "application/vnd.enphase.envoy": { source: "iana" },
  "application/vnd.eprints.data+xml": { source: "iana", compressible: !0 },
  "application/vnd.epson.esf": { source: "iana", extensions: ["esf"] },
  "application/vnd.epson.msf": { source: "iana", extensions: ["msf"] },
  "application/vnd.epson.quickanime": { source: "iana", extensions: ["qam"] },
  "application/vnd.epson.salt": { source: "iana", extensions: ["slt"] },
  "application/vnd.epson.ssf": { source: "iana", extensions: ["ssf"] },
  "application/vnd.ericsson.quickcall": { source: "iana" },
  "application/vnd.espass-espass+zip": { source: "iana", compressible: !1 },
  "application/vnd.eszigno3+xml": { source: "iana", compressible: !0, extensions: ["es3", "et3"] },
  "application/vnd.etsi.aoc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.asic-e+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.asic-s+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.cug+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvcommand+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-bc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-cod+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-npvr+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvservice+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsync+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mcid+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mheg5": { source: "iana" },
  "application/vnd.etsi.overload-control-policy-dataset+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.pstn+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.sci+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.simservs+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.timestamp-token": { source: "iana" },
  "application/vnd.etsi.tsl+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.tsl.der": { source: "iana" },
  "application/vnd.eu.kasparian.car+json": { source: "iana", compressible: !0 },
  "application/vnd.eudora.data": { source: "iana" },
  "application/vnd.evolv.ecig.profile": { source: "iana" },
  "application/vnd.evolv.ecig.settings": { source: "iana" },
  "application/vnd.evolv.ecig.theme": { source: "iana" },
  "application/vnd.exstream-empower+zip": { source: "iana", compressible: !1 },
  "application/vnd.exstream-package": { source: "iana" },
  "application/vnd.ezpix-album": { source: "iana", extensions: ["ez2"] },
  "application/vnd.ezpix-package": { source: "iana", extensions: ["ez3"] },
  "application/vnd.f-secure.mobile": { source: "iana" },
  "application/vnd.familysearch.gedcom+zip": { source: "iana", compressible: !1 },
  "application/vnd.fastcopy-disk-image": { source: "iana" },
  "application/vnd.fdf": { source: "iana", extensions: ["fdf"] },
  "application/vnd.fdsn.mseed": { source: "iana", extensions: ["mseed"] },
  "application/vnd.fdsn.seed": { source: "iana", extensions: ["seed", "dataless"] },
  "application/vnd.ffsns": { source: "iana" },
  "application/vnd.ficlab.flb+zip": { source: "iana", compressible: !1 },
  "application/vnd.filmit.zfc": { source: "iana" },
  "application/vnd.fints": { source: "iana" },
  "application/vnd.firemonkeys.cloudcell": { source: "iana" },
  "application/vnd.flographit": { source: "iana", extensions: ["gph"] },
  "application/vnd.fluxtime.clip": { source: "iana", extensions: ["ftc"] },
  "application/vnd.font-fontforge-sfd": { source: "iana" },
  "application/vnd.framemaker": { source: "iana", extensions: ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { source: "iana", extensions: ["fnc"] },
  "application/vnd.frogans.ltf": { source: "iana", extensions: ["ltf"] },
  "application/vnd.fsc.weblaunch": { source: "iana", extensions: ["fsc"] },
  "application/vnd.fujifilm.fb.docuworks": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.binder": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.container": { source: "iana" },
  "application/vnd.fujifilm.fb.jfi+xml": { source: "iana", compressible: !0 },
  "application/vnd.fujitsu.oasys": { source: "iana", extensions: ["oas"] },
  "application/vnd.fujitsu.oasys2": { source: "iana", extensions: ["oa2"] },
  "application/vnd.fujitsu.oasys3": { source: "iana", extensions: ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { source: "iana", extensions: ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { source: "iana", extensions: ["bh2"] },
  "application/vnd.fujixerox.art-ex": { source: "iana" },
  "application/vnd.fujixerox.art4": { source: "iana" },
  "application/vnd.fujixerox.ddd": { source: "iana", extensions: ["ddd"] },
  "application/vnd.fujixerox.docuworks": { source: "iana", extensions: ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { source: "iana", extensions: ["xbd"] },
  "application/vnd.fujixerox.docuworks.container": { source: "iana" },
  "application/vnd.fujixerox.hbpl": { source: "iana" },
  "application/vnd.fut-misnet": { source: "iana" },
  "application/vnd.futoin+cbor": { source: "iana" },
  "application/vnd.futoin+json": { source: "iana", compressible: !0 },
  "application/vnd.fuzzysheet": { source: "iana", extensions: ["fzs"] },
  "application/vnd.genomatix.tuxedo": { source: "iana", extensions: ["txd"] },
  "application/vnd.gentics.grd+json": { source: "iana", compressible: !0 },
  "application/vnd.geo+json": { source: "iana", compressible: !0 },
  "application/vnd.geocube+xml": { source: "iana", compressible: !0 },
  "application/vnd.geogebra.file": { source: "iana", extensions: ["ggb"] },
  "application/vnd.geogebra.slides": { source: "iana" },
  "application/vnd.geogebra.tool": { source: "iana", extensions: ["ggt"] },
  "application/vnd.geometry-explorer": { source: "iana", extensions: ["gex", "gre"] },
  "application/vnd.geonext": { source: "iana", extensions: ["gxt"] },
  "application/vnd.geoplan": { source: "iana", extensions: ["g2w"] },
  "application/vnd.geospace": { source: "iana", extensions: ["g3w"] },
  "application/vnd.gerber": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt-response": { source: "iana" },
  "application/vnd.gmx": { source: "iana", extensions: ["gmx"] },
  "application/vnd.google-apps.document": { compressible: !1, extensions: ["gdoc"] },
  "application/vnd.google-apps.presentation": { compressible: !1, extensions: ["gslides"] },
  "application/vnd.google-apps.spreadsheet": { compressible: !1, extensions: ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { source: "iana", compressible: !0, extensions: ["kml"] },
  "application/vnd.google-earth.kmz": { source: "iana", compressible: !1, extensions: ["kmz"] },
  "application/vnd.gov.sk.e-form+xml": { source: "iana", compressible: !0 },
  "application/vnd.gov.sk.e-form+zip": { source: "iana", compressible: !1 },
  "application/vnd.gov.sk.xmldatacontainer+xml": { source: "iana", compressible: !0 },
  "application/vnd.grafeq": { source: "iana", extensions: ["gqf", "gqs"] },
  "application/vnd.gridmp": { source: "iana" },
  "application/vnd.groove-account": { source: "iana", extensions: ["gac"] },
  "application/vnd.groove-help": { source: "iana", extensions: ["ghf"] },
  "application/vnd.groove-identity-message": { source: "iana", extensions: ["gim"] },
  "application/vnd.groove-injector": { source: "iana", extensions: ["grv"] },
  "application/vnd.groove-tool-message": { source: "iana", extensions: ["gtm"] },
  "application/vnd.groove-tool-template": { source: "iana", extensions: ["tpl"] },
  "application/vnd.groove-vcard": { source: "iana", extensions: ["vcg"] },
  "application/vnd.hal+json": { source: "iana", compressible: !0 },
  "application/vnd.hal+xml": { source: "iana", compressible: !0, extensions: ["hal"] },
  "application/vnd.handheld-entertainment+xml": { source: "iana", compressible: !0, extensions: ["zmm"] },
  "application/vnd.hbci": { source: "iana", extensions: ["hbci"] },
  "application/vnd.hc+json": { source: "iana", compressible: !0 },
  "application/vnd.hcl-bireports": { source: "iana" },
  "application/vnd.hdt": { source: "iana" },
  "application/vnd.heroku+json": { source: "iana", compressible: !0 },
  "application/vnd.hhe.lesson-player": { source: "iana", extensions: ["les"] },
  "application/vnd.hl7cda+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hl7v2+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hp-hpgl": { source: "iana", extensions: ["hpgl"] },
  "application/vnd.hp-hpid": { source: "iana", extensions: ["hpid"] },
  "application/vnd.hp-hps": { source: "iana", extensions: ["hps"] },
  "application/vnd.hp-jlyt": { source: "iana", extensions: ["jlt"] },
  "application/vnd.hp-pcl": { source: "iana", extensions: ["pcl"] },
  "application/vnd.hp-pclxl": { source: "iana", extensions: ["pclxl"] },
  "application/vnd.httphone": { source: "iana" },
  "application/vnd.hydrostatix.sof-data": { source: "iana", extensions: ["sfd-hdstx"] },
  "application/vnd.hyper+json": { source: "iana", compressible: !0 },
  "application/vnd.hyper-item+json": { source: "iana", compressible: !0 },
  "application/vnd.hyperdrive+json": { source: "iana", compressible: !0 },
  "application/vnd.hzn-3d-crossword": { source: "iana" },
  "application/vnd.ibm.afplinedata": { source: "iana" },
  "application/vnd.ibm.electronic-media": { source: "iana" },
  "application/vnd.ibm.minipay": { source: "iana", extensions: ["mpy"] },
  "application/vnd.ibm.modcap": { source: "iana", extensions: ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { source: "iana", extensions: ["irm"] },
  "application/vnd.ibm.secure-container": { source: "iana", extensions: ["sc"] },
  "application/vnd.iccprofile": { source: "iana", extensions: ["icc", "icm"] },
  "application/vnd.ieee.1905": { source: "iana" },
  "application/vnd.igloader": { source: "iana", extensions: ["igl"] },
  "application/vnd.imagemeter.folder+zip": { source: "iana", compressible: !1 },
  "application/vnd.imagemeter.image+zip": { source: "iana", compressible: !1 },
  "application/vnd.immervision-ivp": { source: "iana", extensions: ["ivp"] },
  "application/vnd.immervision-ivu": { source: "iana", extensions: ["ivu"] },
  "application/vnd.ims.imsccv1p1": { source: "iana" },
  "application/vnd.ims.imsccv1p2": { source: "iana" },
  "application/vnd.ims.imsccv1p3": { source: "iana" },
  "application/vnd.ims.lis.v2.result+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy.id+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": { source: "iana", compressible: !0 },
  "application/vnd.informedcontrol.rms+xml": { source: "iana", compressible: !0 },
  "application/vnd.informix-visionary": { source: "iana" },
  "application/vnd.infotech.project": { source: "iana" },
  "application/vnd.infotech.project+xml": { source: "iana", compressible: !0 },
  "application/vnd.innopath.wamp.notification": { source: "iana" },
  "application/vnd.insors.igm": { source: "iana", extensions: ["igm"] },
  "application/vnd.intercon.formnet": { source: "iana", extensions: ["xpw", "xpx"] },
  "application/vnd.intergeo": { source: "iana", extensions: ["i2g"] },
  "application/vnd.intertrust.digibox": { source: "iana" },
  "application/vnd.intertrust.nncp": { source: "iana" },
  "application/vnd.intu.qbo": { source: "iana", extensions: ["qbo"] },
  "application/vnd.intu.qfx": { source: "iana", extensions: ["qfx"] },
  "application/vnd.iptc.g2.catalogitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.conceptitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.knowledgeitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.packageitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.planningitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.ipunplugged.rcprofile": { source: "iana", extensions: ["rcprofile"] },
  "application/vnd.irepository.package+xml": { source: "iana", compressible: !0, extensions: ["irp"] },
  "application/vnd.is-xpr": { source: "iana", extensions: ["xpr"] },
  "application/vnd.isac.fcs": { source: "iana", extensions: ["fcs"] },
  "application/vnd.iso11783-10+zip": { source: "iana", compressible: !1 },
  "application/vnd.jam": { source: "iana", extensions: ["jam"] },
  "application/vnd.japannet-directory-service": { source: "iana" },
  "application/vnd.japannet-jpnstore-wakeup": { source: "iana" },
  "application/vnd.japannet-payment-wakeup": { source: "iana" },
  "application/vnd.japannet-registration": { source: "iana" },
  "application/vnd.japannet-registration-wakeup": { source: "iana" },
  "application/vnd.japannet-setstore-wakeup": { source: "iana" },
  "application/vnd.japannet-verification": { source: "iana" },
  "application/vnd.japannet-verification-wakeup": { source: "iana" },
  "application/vnd.jcp.javame.midlet-rms": { source: "iana", extensions: ["rms"] },
  "application/vnd.jisp": { source: "iana", extensions: ["jisp"] },
  "application/vnd.joost.joda-archive": { source: "iana", extensions: ["joda"] },
  "application/vnd.jsk.isdn-ngn": { source: "iana" },
  "application/vnd.kahootz": { source: "iana", extensions: ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { source: "iana", extensions: ["karbon"] },
  "application/vnd.kde.kchart": { source: "iana", extensions: ["chrt"] },
  "application/vnd.kde.kformula": { source: "iana", extensions: ["kfo"] },
  "application/vnd.kde.kivio": { source: "iana", extensions: ["flw"] },
  "application/vnd.kde.kontour": { source: "iana", extensions: ["kon"] },
  "application/vnd.kde.kpresenter": { source: "iana", extensions: ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { source: "iana", extensions: ["ksp"] },
  "application/vnd.kde.kword": { source: "iana", extensions: ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { source: "iana", extensions: ["htke"] },
  "application/vnd.kidspiration": { source: "iana", extensions: ["kia"] },
  "application/vnd.kinar": { source: "iana", extensions: ["kne", "knp"] },
  "application/vnd.koan": { source: "iana", extensions: ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { source: "iana", extensions: ["sse"] },
  "application/vnd.las": { source: "iana" },
  "application/vnd.las.las+json": { source: "iana", compressible: !0 },
  "application/vnd.las.las+xml": { source: "iana", compressible: !0, extensions: ["lasxml"] },
  "application/vnd.laszip": { source: "iana" },
  "application/vnd.leap+json": { source: "iana", compressible: !0 },
  "application/vnd.liberty-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.llamagraphics.life-balance.desktop": { source: "iana", extensions: ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { source: "iana", compressible: !0, extensions: ["lbe"] },
  "application/vnd.logipipe.circuit+zip": { source: "iana", compressible: !1 },
  "application/vnd.loom": { source: "iana" },
  "application/vnd.lotus-1-2-3": { source: "iana", extensions: ["123"] },
  "application/vnd.lotus-approach": { source: "iana", extensions: ["apr"] },
  "application/vnd.lotus-freelance": { source: "iana", extensions: ["pre"] },
  "application/vnd.lotus-notes": { source: "iana", extensions: ["nsf"] },
  "application/vnd.lotus-organizer": { source: "iana", extensions: ["org"] },
  "application/vnd.lotus-screencam": { source: "iana", extensions: ["scm"] },
  "application/vnd.lotus-wordpro": { source: "iana", extensions: ["lwp"] },
  "application/vnd.macports.portpkg": { source: "iana", extensions: ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { source: "iana", extensions: ["mvt"] },
  "application/vnd.marlin.drm.actiontoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.conftoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.license+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.mdcf": { source: "iana" },
  "application/vnd.mason+json": { source: "iana", compressible: !0 },
  "application/vnd.maxar.archive.3tz+zip": { source: "iana", compressible: !1 },
  "application/vnd.maxmind.maxmind-db": { source: "iana" },
  "application/vnd.mcd": { source: "iana", extensions: ["mcd"] },
  "application/vnd.medcalcdata": { source: "iana", extensions: ["mc1"] },
  "application/vnd.mediastation.cdkey": { source: "iana", extensions: ["cdkey"] },
  "application/vnd.meridian-slingshot": { source: "iana" },
  "application/vnd.mfer": { source: "iana", extensions: ["mwf"] },
  "application/vnd.mfmp": { source: "iana", extensions: ["mfm"] },
  "application/vnd.micro+json": { source: "iana", compressible: !0 },
  "application/vnd.micrografx.flo": { source: "iana", extensions: ["flo"] },
  "application/vnd.micrografx.igx": { source: "iana", extensions: ["igx"] },
  "application/vnd.microsoft.portable-executable": { source: "iana" },
  "application/vnd.microsoft.windows.thumbnail-cache": { source: "iana" },
  "application/vnd.miele+json": { source: "iana", compressible: !0 },
  "application/vnd.mif": { source: "iana", extensions: ["mif"] },
  "application/vnd.minisoft-hp3000-save": { source: "iana" },
  "application/vnd.mitsubishi.misty-guard.trustweb": { source: "iana" },
  "application/vnd.mobius.daf": { source: "iana", extensions: ["daf"] },
  "application/vnd.mobius.dis": { source: "iana", extensions: ["dis"] },
  "application/vnd.mobius.mbk": { source: "iana", extensions: ["mbk"] },
  "application/vnd.mobius.mqy": { source: "iana", extensions: ["mqy"] },
  "application/vnd.mobius.msl": { source: "iana", extensions: ["msl"] },
  "application/vnd.mobius.plc": { source: "iana", extensions: ["plc"] },
  "application/vnd.mobius.txf": { source: "iana", extensions: ["txf"] },
  "application/vnd.mophun.application": { source: "iana", extensions: ["mpn"] },
  "application/vnd.mophun.certificate": { source: "iana", extensions: ["mpc"] },
  "application/vnd.motorola.flexsuite": { source: "iana" },
  "application/vnd.motorola.flexsuite.adsi": { source: "iana" },
  "application/vnd.motorola.flexsuite.fis": { source: "iana" },
  "application/vnd.motorola.flexsuite.gotap": { source: "iana" },
  "application/vnd.motorola.flexsuite.kmr": { source: "iana" },
  "application/vnd.motorola.flexsuite.ttc": { source: "iana" },
  "application/vnd.motorola.flexsuite.wem": { source: "iana" },
  "application/vnd.motorola.iprm": { source: "iana" },
  "application/vnd.mozilla.xul+xml": { source: "iana", compressible: !0, extensions: ["xul"] },
  "application/vnd.ms-3mfdocument": { source: "iana" },
  "application/vnd.ms-artgalry": { source: "iana", extensions: ["cil"] },
  "application/vnd.ms-asf": { source: "iana" },
  "application/vnd.ms-cab-compressed": { source: "iana", extensions: ["cab"] },
  "application/vnd.ms-color.iccprofile": { source: "apache" },
  "application/vnd.ms-excel": { source: "iana", compressible: !1, extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { source: "iana", extensions: ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { source: "iana", extensions: ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { source: "iana", extensions: ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { source: "iana", extensions: ["xltm"] },
  "application/vnd.ms-fontobject": { source: "iana", compressible: !0, extensions: ["eot"] },
  "application/vnd.ms-htmlhelp": { source: "iana", extensions: ["chm"] },
  "application/vnd.ms-ims": { source: "iana", extensions: ["ims"] },
  "application/vnd.ms-lrm": { source: "iana", extensions: ["lrm"] },
  "application/vnd.ms-office.activex+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-officetheme": { source: "iana", extensions: ["thmx"] },
  "application/vnd.ms-opentype": { source: "apache", compressible: !0 },
  "application/vnd.ms-outlook": { compressible: !1, extensions: ["msg"] },
  "application/vnd.ms-package.obfuscated-opentype": { source: "apache" },
  "application/vnd.ms-pki.seccat": { source: "apache", extensions: ["cat"] },
  "application/vnd.ms-pki.stl": { source: "apache", extensions: ["stl"] },
  "application/vnd.ms-playready.initiator+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-powerpoint": { source: "iana", compressible: !1, extensions: ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { source: "iana", extensions: ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { source: "iana", extensions: ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { source: "iana", extensions: ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { source: "iana", extensions: ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { source: "iana", extensions: ["potm"] },
  "application/vnd.ms-printdevicecapabilities+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-printing.printticket+xml": { source: "apache", compressible: !0 },
  "application/vnd.ms-printschematicket+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-project": { source: "iana", extensions: ["mpp", "mpt"] },
  "application/vnd.ms-tnef": { source: "iana" },
  "application/vnd.ms-windows.devicepairing": { source: "iana" },
  "application/vnd.ms-windows.nwprinting.oob": { source: "iana" },
  "application/vnd.ms-windows.printerpairing": { source: "iana" },
  "application/vnd.ms-windows.wsd.oob": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-resp": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-resp": { source: "iana" },
  "application/vnd.ms-word.document.macroenabled.12": { source: "iana", extensions: ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { source: "iana", extensions: ["dotm"] },
  "application/vnd.ms-works": { source: "iana", extensions: ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { source: "iana", extensions: ["wpl"] },
  "application/vnd.ms-xpsdocument": { source: "iana", compressible: !1, extensions: ["xps"] },
  "application/vnd.msa-disk-image": { source: "iana" },
  "application/vnd.mseq": { source: "iana", extensions: ["mseq"] },
  "application/vnd.msign": { source: "iana" },
  "application/vnd.multiad.creator": { source: "iana" },
  "application/vnd.multiad.creator.cif": { source: "iana" },
  "application/vnd.music-niff": { source: "iana" },
  "application/vnd.musician": { source: "iana", extensions: ["mus"] },
  "application/vnd.muvee.style": { source: "iana", extensions: ["msty"] },
  "application/vnd.mynfc": { source: "iana", extensions: ["taglet"] },
  "application/vnd.nacamar.ybrid+json": { source: "iana", compressible: !0 },
  "application/vnd.ncd.control": { source: "iana" },
  "application/vnd.ncd.reference": { source: "iana" },
  "application/vnd.nearst.inv+json": { source: "iana", compressible: !0 },
  "application/vnd.nebumind.line": { source: "iana" },
  "application/vnd.nervana": { source: "iana" },
  "application/vnd.netfpx": { source: "iana" },
  "application/vnd.neurolanguage.nlu": { source: "iana", extensions: ["nlu"] },
  "application/vnd.nimn": { source: "iana" },
  "application/vnd.nintendo.nitro.rom": { source: "iana" },
  "application/vnd.nintendo.snes.rom": { source: "iana" },
  "application/vnd.nitf": { source: "iana", extensions: ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { source: "iana", extensions: ["nnd"] },
  "application/vnd.noblenet-sealer": { source: "iana", extensions: ["nns"] },
  "application/vnd.noblenet-web": { source: "iana", extensions: ["nnw"] },
  "application/vnd.nokia.catalogs": { source: "iana" },
  "application/vnd.nokia.conml+wbxml": { source: "iana" },
  "application/vnd.nokia.conml+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.iptv.config+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.isds-radio-presets": { source: "iana" },
  "application/vnd.nokia.landmark+wbxml": { source: "iana" },
  "application/vnd.nokia.landmark+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.landmarkcollection+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.n-gage.ac+xml": { source: "iana", compressible: !0, extensions: ["ac"] },
  "application/vnd.nokia.n-gage.data": { source: "iana", extensions: ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { source: "iana", extensions: ["n-gage"] },
  "application/vnd.nokia.ncd": { source: "iana" },
  "application/vnd.nokia.pcd+wbxml": { source: "iana" },
  "application/vnd.nokia.pcd+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.radio-preset": { source: "iana", extensions: ["rpst"] },
  "application/vnd.nokia.radio-presets": { source: "iana", extensions: ["rpss"] },
  "application/vnd.novadigm.edm": { source: "iana", extensions: ["edm"] },
  "application/vnd.novadigm.edx": { source: "iana", extensions: ["edx"] },
  "application/vnd.novadigm.ext": { source: "iana", extensions: ["ext"] },
  "application/vnd.ntt-local.content-share": { source: "iana" },
  "application/vnd.ntt-local.file-transfer": { source: "iana" },
  "application/vnd.ntt-local.ogw_remote-access": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_remote": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_tcp_stream": { source: "iana" },
  "application/vnd.oasis.opendocument.chart": { source: "iana", extensions: ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { source: "iana", extensions: ["otc"] },
  "application/vnd.oasis.opendocument.database": { source: "iana", extensions: ["odb"] },
  "application/vnd.oasis.opendocument.formula": { source: "iana", extensions: ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { source: "iana", extensions: ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { source: "iana", compressible: !1, extensions: ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { source: "iana", extensions: ["otg"] },
  "application/vnd.oasis.opendocument.image": { source: "iana", extensions: ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { source: "iana", extensions: ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { source: "iana", compressible: !1, extensions: ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { source: "iana", extensions: ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { source: "iana", compressible: !1, extensions: ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { source: "iana", extensions: ["ots"] },
  "application/vnd.oasis.opendocument.text": { source: "iana", compressible: !1, extensions: ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { source: "iana", extensions: ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { source: "iana", extensions: ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { source: "iana", extensions: ["oth"] },
  "application/vnd.obn": { source: "iana" },
  "application/vnd.ocf+cbor": { source: "iana" },
  "application/vnd.oci.image.manifest.v1+json": { source: "iana", compressible: !0 },
  "application/vnd.oftn.l10n+json": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessdownload+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessstreaming+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.cspg-hexbinary": { source: "iana" },
  "application/vnd.oipf.dae.svg+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.dae.xhtml+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.mippvcontrolmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.pae.gem": { source: "iana" },
  "application/vnd.oipf.spdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.spdlist+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.ueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.userprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.olpc-sugar": { source: "iana", extensions: ["xo"] },
  "application/vnd.oma-scws-config": { source: "iana" },
  "application/vnd.oma-scws-http-request": { source: "iana" },
  "application/vnd.oma-scws-http-response": { source: "iana" },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.drm-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.imd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.ltkm": { source: "iana" },
  "application/vnd.oma.bcast.notification+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.provisioningtrigger": { source: "iana" },
  "application/vnd.oma.bcast.sgboot": { source: "iana" },
  "application/vnd.oma.bcast.sgdd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sgdu": { source: "iana" },
  "application/vnd.oma.bcast.simple-symbol-container": { source: "iana" },
  "application/vnd.oma.bcast.smartcard-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sprov+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.stkm": { source: "iana" },
  "application/vnd.oma.cab-address-book+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-feature-handler+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-pcc+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-subs-invite+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-user-prefs+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.dcd": { source: "iana" },
  "application/vnd.oma.dcdc": { source: "iana" },
  "application/vnd.oma.dd2+xml": { source: "iana", compressible: !0, extensions: ["dd2"] },
  "application/vnd.oma.drm.risd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.group-usage-list+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+cbor": { source: "iana" },
  "application/vnd.oma.lwm2m+json": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+tlv": { source: "iana" },
  "application/vnd.oma.pal+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.detailed-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.final-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.groups+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.invocation-descriptor+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.optimized-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.push": { source: "iana" },
  "application/vnd.oma.scidm.messages+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.xcap-directory+xml": { source: "iana", compressible: !0 },
  "application/vnd.omads-email+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-file+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-folder+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omaloc-supl-init": { source: "iana" },
  "application/vnd.onepager": { source: "iana" },
  "application/vnd.onepagertamp": { source: "iana" },
  "application/vnd.onepagertamx": { source: "iana" },
  "application/vnd.onepagertat": { source: "iana" },
  "application/vnd.onepagertatp": { source: "iana" },
  "application/vnd.onepagertatx": { source: "iana" },
  "application/vnd.openblox.game+xml": { source: "iana", compressible: !0, extensions: ["obgx"] },
  "application/vnd.openblox.game-binary": { source: "iana" },
  "application/vnd.openeye.oeb": { source: "iana" },
  "application/vnd.openofficeorg.extension": { source: "apache", extensions: ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { source: "iana", compressible: !0, extensions: ["osm"] },
  "application/vnd.opentimestamps.ots": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawing+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { source: "iana", compressible: !1, extensions: ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { source: "iana", extensions: ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { source: "iana", extensions: ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { source: "iana", extensions: ["potx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { source: "iana", compressible: !1, extensions: ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { source: "iana", extensions: ["xltx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.theme+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.vmldrawing": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { source: "iana", compressible: !1, extensions: ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { source: "iana", extensions: ["dotx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.core-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.relationships+xml": { source: "iana", compressible: !0 },
  "application/vnd.oracle.resource+json": { source: "iana", compressible: !0 },
  "application/vnd.orange.indata": { source: "iana" },
  "application/vnd.osa.netdeploy": { source: "iana" },
  "application/vnd.osgeo.mapguide.package": { source: "iana", extensions: ["mgp"] },
  "application/vnd.osgi.bundle": { source: "iana" },
  "application/vnd.osgi.dp": { source: "iana", extensions: ["dp"] },
  "application/vnd.osgi.subsystem": { source: "iana", extensions: ["esa"] },
  "application/vnd.otps.ct-kip+xml": { source: "iana", compressible: !0 },
  "application/vnd.oxli.countgraph": { source: "iana" },
  "application/vnd.pagerduty+json": { source: "iana", compressible: !0 },
  "application/vnd.palm": { source: "iana", extensions: ["pdb", "pqa", "oprc"] },
  "application/vnd.panoply": { source: "iana" },
  "application/vnd.paos.xml": { source: "iana" },
  "application/vnd.patentdive": { source: "iana" },
  "application/vnd.patientecommsdoc": { source: "iana" },
  "application/vnd.pawaafile": { source: "iana", extensions: ["paw"] },
  "application/vnd.pcos": { source: "iana" },
  "application/vnd.pg.format": { source: "iana", extensions: ["str"] },
  "application/vnd.pg.osasli": { source: "iana", extensions: ["ei6"] },
  "application/vnd.piaccess.application-licence": { source: "iana" },
  "application/vnd.picsel": { source: "iana", extensions: ["efif"] },
  "application/vnd.pmi.widget": { source: "iana", extensions: ["wg"] },
  "application/vnd.poc.group-advertisement+xml": { source: "iana", compressible: !0 },
  "application/vnd.pocketlearn": { source: "iana", extensions: ["plf"] },
  "application/vnd.powerbuilder6": { source: "iana", extensions: ["pbd"] },
  "application/vnd.powerbuilder6-s": { source: "iana" },
  "application/vnd.powerbuilder7": { source: "iana" },
  "application/vnd.powerbuilder7-s": { source: "iana" },
  "application/vnd.powerbuilder75": { source: "iana" },
  "application/vnd.powerbuilder75-s": { source: "iana" },
  "application/vnd.preminet": { source: "iana" },
  "application/vnd.previewsystems.box": { source: "iana", extensions: ["box"] },
  "application/vnd.proteus.magazine": { source: "iana", extensions: ["mgz"] },
  "application/vnd.psfs": { source: "iana" },
  "application/vnd.publishare-delta-tree": { source: "iana", extensions: ["qps"] },
  "application/vnd.pvi.ptid1": { source: "iana", extensions: ["ptid"] },
  "application/vnd.pwg-multiplexed": { source: "iana" },
  "application/vnd.pwg-xhtml-print+xml": { source: "iana", compressible: !0 },
  "application/vnd.qualcomm.brew-app-res": { source: "iana" },
  "application/vnd.quarantainenet": { source: "iana" },
  "application/vnd.quark.quarkxpress": { source: "iana", extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.quobject-quoxdocument": { source: "iana" },
  "application/vnd.radisys.moml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conn+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-stream+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-base+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-group+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-speech+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-transform+xml": { source: "iana", compressible: !0 },
  "application/vnd.rainstor.data": { source: "iana" },
  "application/vnd.rapid": { source: "iana" },
  "application/vnd.rar": { source: "iana", extensions: ["rar"] },
  "application/vnd.realvnc.bed": { source: "iana", extensions: ["bed"] },
  "application/vnd.recordare.musicxml": { source: "iana", extensions: ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { source: "iana", compressible: !0, extensions: ["musicxml"] },
  "application/vnd.renlearn.rlprint": { source: "iana" },
  "application/vnd.resilient.logic": { source: "iana" },
  "application/vnd.restful+json": { source: "iana", compressible: !0 },
  "application/vnd.rig.cryptonote": { source: "iana", extensions: ["cryptonote"] },
  "application/vnd.rim.cod": { source: "apache", extensions: ["cod"] },
  "application/vnd.rn-realmedia": { source: "apache", extensions: ["rm"] },
  "application/vnd.rn-realmedia-vbr": { source: "apache", extensions: ["rmvb"] },
  "application/vnd.route66.link66+xml": { source: "iana", compressible: !0, extensions: ["link66"] },
  "application/vnd.rs-274x": { source: "iana" },
  "application/vnd.ruckus.download": { source: "iana" },
  "application/vnd.s3sms": { source: "iana" },
  "application/vnd.sailingtracker.track": { source: "iana", extensions: ["st"] },
  "application/vnd.sar": { source: "iana" },
  "application/vnd.sbm.cid": { source: "iana" },
  "application/vnd.sbm.mid2": { source: "iana" },
  "application/vnd.scribus": { source: "iana" },
  "application/vnd.sealed.3df": { source: "iana" },
  "application/vnd.sealed.csf": { source: "iana" },
  "application/vnd.sealed.doc": { source: "iana" },
  "application/vnd.sealed.eml": { source: "iana" },
  "application/vnd.sealed.mht": { source: "iana" },
  "application/vnd.sealed.net": { source: "iana" },
  "application/vnd.sealed.ppt": { source: "iana" },
  "application/vnd.sealed.tiff": { source: "iana" },
  "application/vnd.sealed.xls": { source: "iana" },
  "application/vnd.sealedmedia.softseal.html": { source: "iana" },
  "application/vnd.sealedmedia.softseal.pdf": { source: "iana" },
  "application/vnd.seemail": { source: "iana", extensions: ["see"] },
  "application/vnd.seis+json": { source: "iana", compressible: !0 },
  "application/vnd.sema": { source: "iana", extensions: ["sema"] },
  "application/vnd.semd": { source: "iana", extensions: ["semd"] },
  "application/vnd.semf": { source: "iana", extensions: ["semf"] },
  "application/vnd.shade-save-file": { source: "iana" },
  "application/vnd.shana.informed.formdata": { source: "iana", extensions: ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { source: "iana", extensions: ["itp"] },
  "application/vnd.shana.informed.interchange": { source: "iana", extensions: ["iif"] },
  "application/vnd.shana.informed.package": { source: "iana", extensions: ["ipk"] },
  "application/vnd.shootproof+json": { source: "iana", compressible: !0 },
  "application/vnd.shopkick+json": { source: "iana", compressible: !0 },
  "application/vnd.shp": { source: "iana" },
  "application/vnd.shx": { source: "iana" },
  "application/vnd.sigrok.session": { source: "iana" },
  "application/vnd.simtech-mindmapper": { source: "iana", extensions: ["twd", "twds"] },
  "application/vnd.siren+json": { source: "iana", compressible: !0 },
  "application/vnd.smaf": { source: "iana", extensions: ["mmf"] },
  "application/vnd.smart.notebook": { source: "iana" },
  "application/vnd.smart.teacher": { source: "iana", extensions: ["teacher"] },
  "application/vnd.snesdev-page-table": { source: "iana" },
  "application/vnd.software602.filler.form+xml": { source: "iana", compressible: !0, extensions: ["fo"] },
  "application/vnd.software602.filler.form-xml-zip": { source: "iana" },
  "application/vnd.solent.sdkm+xml": { source: "iana", compressible: !0, extensions: ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { source: "iana", extensions: ["dxp"] },
  "application/vnd.spotfire.sfs": { source: "iana", extensions: ["sfs"] },
  "application/vnd.sqlite3": { source: "iana" },
  "application/vnd.sss-cod": { source: "iana" },
  "application/vnd.sss-dtf": { source: "iana" },
  "application/vnd.sss-ntf": { source: "iana" },
  "application/vnd.stardivision.calc": { source: "apache", extensions: ["sdc"] },
  "application/vnd.stardivision.draw": { source: "apache", extensions: ["sda"] },
  "application/vnd.stardivision.impress": { source: "apache", extensions: ["sdd"] },
  "application/vnd.stardivision.math": { source: "apache", extensions: ["smf"] },
  "application/vnd.stardivision.writer": { source: "apache", extensions: ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { source: "apache", extensions: ["sgl"] },
  "application/vnd.stepmania.package": { source: "iana", extensions: ["smzip"] },
  "application/vnd.stepmania.stepchart": { source: "iana", extensions: ["sm"] },
  "application/vnd.street-stream": { source: "iana" },
  "application/vnd.sun.wadl+xml": { source: "iana", compressible: !0, extensions: ["wadl"] },
  "application/vnd.sun.xml.calc": { source: "apache", extensions: ["sxc"] },
  "application/vnd.sun.xml.calc.template": { source: "apache", extensions: ["stc"] },
  "application/vnd.sun.xml.draw": { source: "apache", extensions: ["sxd"] },
  "application/vnd.sun.xml.draw.template": { source: "apache", extensions: ["std"] },
  "application/vnd.sun.xml.impress": { source: "apache", extensions: ["sxi"] },
  "application/vnd.sun.xml.impress.template": { source: "apache", extensions: ["sti"] },
  "application/vnd.sun.xml.math": { source: "apache", extensions: ["sxm"] },
  "application/vnd.sun.xml.writer": { source: "apache", extensions: ["sxw"] },
  "application/vnd.sun.xml.writer.global": { source: "apache", extensions: ["sxg"] },
  "application/vnd.sun.xml.writer.template": { source: "apache", extensions: ["stw"] },
  "application/vnd.sus-calendar": { source: "iana", extensions: ["sus", "susp"] },
  "application/vnd.svd": { source: "iana", extensions: ["svd"] },
  "application/vnd.swiftview-ics": { source: "iana" },
  "application/vnd.sycle+xml": { source: "iana", compressible: !0 },
  "application/vnd.syft+json": { source: "iana", compressible: !0 },
  "application/vnd.symbian.install": { source: "apache", extensions: ["sis", "sisx"] },
  "application/vnd.syncml+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { source: "iana", charset: "UTF-8", extensions: ["bdm"] },
  "application/vnd.syncml.dm+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xdm"] },
  "application/vnd.syncml.dm.notification": { source: "iana" },
  "application/vnd.syncml.dmddf+wbxml": { source: "iana" },
  "application/vnd.syncml.dmddf+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["ddf"] },
  "application/vnd.syncml.dmtnds+wbxml": { source: "iana" },
  "application/vnd.syncml.dmtnds+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.syncml.ds.notification": { source: "iana" },
  "application/vnd.tableschema+json": { source: "iana", compressible: !0 },
  "application/vnd.tao.intent-module-archive": { source: "iana", extensions: ["tao"] },
  "application/vnd.tcpdump.pcap": { source: "iana", extensions: ["pcap", "cap", "dmp"] },
  "application/vnd.think-cell.ppttc+json": { source: "iana", compressible: !0 },
  "application/vnd.tmd.mediaflex.api+xml": { source: "iana", compressible: !0 },
  "application/vnd.tml": { source: "iana" },
  "application/vnd.tmobile-livetv": { source: "iana", extensions: ["tmo"] },
  "application/vnd.tri.onesource": { source: "iana" },
  "application/vnd.trid.tpt": { source: "iana", extensions: ["tpt"] },
  "application/vnd.triscape.mxs": { source: "iana", extensions: ["mxs"] },
  "application/vnd.trueapp": { source: "iana", extensions: ["tra"] },
  "application/vnd.truedoc": { source: "iana" },
  "application/vnd.ubisoft.webplayer": { source: "iana" },
  "application/vnd.ufdl": { source: "iana", extensions: ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { source: "iana", extensions: ["utz"] },
  "application/vnd.umajin": { source: "iana", extensions: ["umj"] },
  "application/vnd.unity": { source: "iana", extensions: ["unityweb"] },
  "application/vnd.uoml+xml": { source: "iana", compressible: !0, extensions: ["uoml"] },
  "application/vnd.uplanet.alert": { source: "iana" },
  "application/vnd.uplanet.alert-wbxml": { source: "iana" },
  "application/vnd.uplanet.bearer-choice": { source: "iana" },
  "application/vnd.uplanet.bearer-choice-wbxml": { source: "iana" },
  "application/vnd.uplanet.cacheop": { source: "iana" },
  "application/vnd.uplanet.cacheop-wbxml": { source: "iana" },
  "application/vnd.uplanet.channel": { source: "iana" },
  "application/vnd.uplanet.channel-wbxml": { source: "iana" },
  "application/vnd.uplanet.list": { source: "iana" },
  "application/vnd.uplanet.list-wbxml": { source: "iana" },
  "application/vnd.uplanet.listcmd": { source: "iana" },
  "application/vnd.uplanet.listcmd-wbxml": { source: "iana" },
  "application/vnd.uplanet.signal": { source: "iana" },
  "application/vnd.uri-map": { source: "iana" },
  "application/vnd.valve.source.material": { source: "iana" },
  "application/vnd.vcx": { source: "iana", extensions: ["vcx"] },
  "application/vnd.vd-study": { source: "iana" },
  "application/vnd.vectorworks": { source: "iana" },
  "application/vnd.vel+json": { source: "iana", compressible: !0 },
  "application/vnd.verimatrix.vcas": { source: "iana" },
  "application/vnd.veritone.aion+json": { source: "iana", compressible: !0 },
  "application/vnd.veryant.thin": { source: "iana" },
  "application/vnd.ves.encrypted": { source: "iana" },
  "application/vnd.vidsoft.vidconference": { source: "iana" },
  "application/vnd.visio": { source: "iana", extensions: ["vsd", "vst", "vss", "vsw"] },
  "application/vnd.visionary": { source: "iana", extensions: ["vis"] },
  "application/vnd.vividence.scriptfile": { source: "iana" },
  "application/vnd.vsf": { source: "iana", extensions: ["vsf"] },
  "application/vnd.wap.sic": { source: "iana" },
  "application/vnd.wap.slc": { source: "iana" },
  "application/vnd.wap.wbxml": { source: "iana", charset: "UTF-8", extensions: ["wbxml"] },
  "application/vnd.wap.wmlc": { source: "iana", extensions: ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { source: "iana", extensions: ["wmlsc"] },
  "application/vnd.webturbo": { source: "iana", extensions: ["wtb"] },
  "application/vnd.wfa.dpp": { source: "iana" },
  "application/vnd.wfa.p2p": { source: "iana" },
  "application/vnd.wfa.wsc": { source: "iana" },
  "application/vnd.windows.devicepairing": { source: "iana" },
  "application/vnd.wmc": { source: "iana" },
  "application/vnd.wmf.bootstrap": { source: "iana" },
  "application/vnd.wolfram.mathematica": { source: "iana" },
  "application/vnd.wolfram.mathematica.package": { source: "iana" },
  "application/vnd.wolfram.player": { source: "iana", extensions: ["nbp"] },
  "application/vnd.wordperfect": { source: "iana", extensions: ["wpd"] },
  "application/vnd.wqd": { source: "iana", extensions: ["wqd"] },
  "application/vnd.wrq-hp3000-labelled": { source: "iana" },
  "application/vnd.wt.stf": { source: "iana", extensions: ["stf"] },
  "application/vnd.wv.csp+wbxml": { source: "iana" },
  "application/vnd.wv.csp+xml": { source: "iana", compressible: !0 },
  "application/vnd.wv.ssp+xml": { source: "iana", compressible: !0 },
  "application/vnd.xacml+json": { source: "iana", compressible: !0 },
  "application/vnd.xara": { source: "iana", extensions: ["xar"] },
  "application/vnd.xfdl": { source: "iana", extensions: ["xfdl"] },
  "application/vnd.xfdl.webform": { source: "iana" },
  "application/vnd.xmi+xml": { source: "iana", compressible: !0 },
  "application/vnd.xmpie.cpkg": { source: "iana" },
  "application/vnd.xmpie.dpkg": { source: "iana" },
  "application/vnd.xmpie.plan": { source: "iana" },
  "application/vnd.xmpie.ppkg": { source: "iana" },
  "application/vnd.xmpie.xlim": { source: "iana" },
  "application/vnd.yamaha.hv-dic": { source: "iana", extensions: ["hvd"] },
  "application/vnd.yamaha.hv-script": { source: "iana", extensions: ["hvs"] },
  "application/vnd.yamaha.hv-voice": { source: "iana", extensions: ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { source: "iana", extensions: ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { source: "iana", compressible: !0, extensions: ["osfpvg"] },
  "application/vnd.yamaha.remote-setup": { source: "iana" },
  "application/vnd.yamaha.smaf-audio": { source: "iana", extensions: ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { source: "iana", extensions: ["spf"] },
  "application/vnd.yamaha.through-ngn": { source: "iana" },
  "application/vnd.yamaha.tunnel-udpencap": { source: "iana" },
  "application/vnd.yaoweme": { source: "iana" },
  "application/vnd.yellowriver-custom-menu": { source: "iana", extensions: ["cmp"] },
  "application/vnd.youtube.yt": { source: "iana" },
  "application/vnd.zul": { source: "iana", extensions: ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { source: "iana", compressible: !0, extensions: ["zaz"] },
  "application/voicexml+xml": { source: "iana", compressible: !0, extensions: ["vxml"] },
  "application/voucher-cms+json": { source: "iana", compressible: !0 },
  "application/vq-rtcpxr": { source: "iana" },
  "application/wasm": { source: "iana", compressible: !0, extensions: ["wasm"] },
  "application/watcherinfo+xml": { source: "iana", compressible: !0, extensions: ["wif"] },
  "application/webpush-options+json": { source: "iana", compressible: !0 },
  "application/whoispp-query": { source: "iana" },
  "application/whoispp-response": { source: "iana" },
  "application/widget": { source: "iana", extensions: ["wgt"] },
  "application/winhlp": { source: "apache", extensions: ["hlp"] },
  "application/wita": { source: "iana" },
  "application/wordperfect5.1": { source: "iana" },
  "application/wsdl+xml": { source: "iana", compressible: !0, extensions: ["wsdl"] },
  "application/wspolicy+xml": { source: "iana", compressible: !0, extensions: ["wspolicy"] },
  "application/x-7z-compressed": { source: "apache", compressible: !1, extensions: ["7z"] },
  "application/x-abiword": { source: "apache", extensions: ["abw"] },
  "application/x-ace-compressed": { source: "apache", extensions: ["ace"] },
  "application/x-amf": { source: "apache" },
  "application/x-apple-diskimage": { source: "apache", extensions: ["dmg"] },
  "application/x-arj": { compressible: !1, extensions: ["arj"] },
  "application/x-authorware-bin": { source: "apache", extensions: ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { source: "apache", extensions: ["aam"] },
  "application/x-authorware-seg": { source: "apache", extensions: ["aas"] },
  "application/x-bcpio": { source: "apache", extensions: ["bcpio"] },
  "application/x-bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/x-bittorrent": { source: "apache", extensions: ["torrent"] },
  "application/x-blorb": { source: "apache", extensions: ["blb", "blorb"] },
  "application/x-bzip": { source: "apache", compressible: !1, extensions: ["bz"] },
  "application/x-bzip2": { source: "apache", compressible: !1, extensions: ["bz2", "boz"] },
  "application/x-cbr": { source: "apache", extensions: ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { source: "apache", extensions: ["vcd"] },
  "application/x-cfs-compressed": { source: "apache", extensions: ["cfs"] },
  "application/x-chat": { source: "apache", extensions: ["chat"] },
  "application/x-chess-pgn": { source: "apache", extensions: ["pgn"] },
  "application/x-chrome-extension": { extensions: ["crx"] },
  "application/x-cocoa": { source: "nginx", extensions: ["cco"] },
  "application/x-compress": { source: "apache" },
  "application/x-conference": { source: "apache", extensions: ["nsc"] },
  "application/x-cpio": { source: "apache", extensions: ["cpio"] },
  "application/x-csh": { source: "apache", extensions: ["csh"] },
  "application/x-deb": { compressible: !1 },
  "application/x-debian-package": { source: "apache", extensions: ["deb", "udeb"] },
  "application/x-dgc-compressed": { source: "apache", extensions: ["dgc"] },
  "application/x-director": { source: "apache", extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { source: "apache", extensions: ["wad"] },
  "application/x-dtbncx+xml": { source: "apache", compressible: !0, extensions: ["ncx"] },
  "application/x-dtbook+xml": { source: "apache", compressible: !0, extensions: ["dtb"] },
  "application/x-dtbresource+xml": { source: "apache", compressible: !0, extensions: ["res"] },
  "application/x-dvi": { source: "apache", compressible: !1, extensions: ["dvi"] },
  "application/x-envoy": { source: "apache", extensions: ["evy"] },
  "application/x-eva": { source: "apache", extensions: ["eva"] },
  "application/x-font-bdf": { source: "apache", extensions: ["bdf"] },
  "application/x-font-dos": { source: "apache" },
  "application/x-font-framemaker": { source: "apache" },
  "application/x-font-ghostscript": { source: "apache", extensions: ["gsf"] },
  "application/x-font-libgrx": { source: "apache" },
  "application/x-font-linux-psf": { source: "apache", extensions: ["psf"] },
  "application/x-font-pcf": { source: "apache", extensions: ["pcf"] },
  "application/x-font-snf": { source: "apache", extensions: ["snf"] },
  "application/x-font-speedo": { source: "apache" },
  "application/x-font-sunos-news": { source: "apache" },
  "application/x-font-type1": { source: "apache", extensions: ["pfa", "pfb", "pfm", "afm"] },
  "application/x-font-vfont": { source: "apache" },
  "application/x-freearc": { source: "apache", extensions: ["arc"] },
  "application/x-futuresplash": { source: "apache", extensions: ["spl"] },
  "application/x-gca-compressed": { source: "apache", extensions: ["gca"] },
  "application/x-glulx": { source: "apache", extensions: ["ulx"] },
  "application/x-gnumeric": { source: "apache", extensions: ["gnumeric"] },
  "application/x-gramps-xml": { source: "apache", extensions: ["gramps"] },
  "application/x-gtar": { source: "apache", extensions: ["gtar"] },
  "application/x-gzip": { source: "apache" },
  "application/x-hdf": { source: "apache", extensions: ["hdf"] },
  "application/x-httpd-php": { compressible: !0, extensions: ["php"] },
  "application/x-install-instructions": { source: "apache", extensions: ["install"] },
  "application/x-iso9660-image": { source: "apache", extensions: ["iso"] },
  "application/x-iwork-keynote-sffkey": { extensions: ["key"] },
  "application/x-iwork-numbers-sffnumbers": { extensions: ["numbers"] },
  "application/x-iwork-pages-sffpages": { extensions: ["pages"] },
  "application/x-java-archive-diff": { source: "nginx", extensions: ["jardiff"] },
  "application/x-java-jnlp-file": { source: "apache", compressible: !1, extensions: ["jnlp"] },
  "application/x-javascript": { compressible: !0 },
  "application/x-keepass2": { extensions: ["kdbx"] },
  "application/x-latex": { source: "apache", compressible: !1, extensions: ["latex"] },
  "application/x-lua-bytecode": { extensions: ["luac"] },
  "application/x-lzh-compressed": { source: "apache", extensions: ["lzh", "lha"] },
  "application/x-makeself": { source: "nginx", extensions: ["run"] },
  "application/x-mie": { source: "apache", extensions: ["mie"] },
  "application/x-mobipocket-ebook": { source: "apache", extensions: ["prc", "mobi"] },
  "application/x-mpegurl": { compressible: !1 },
  "application/x-ms-application": { source: "apache", extensions: ["application"] },
  "application/x-ms-shortcut": { source: "apache", extensions: ["lnk"] },
  "application/x-ms-wmd": { source: "apache", extensions: ["wmd"] },
  "application/x-ms-wmz": { source: "apache", extensions: ["wmz"] },
  "application/x-ms-xbap": { source: "apache", extensions: ["xbap"] },
  "application/x-msaccess": { source: "apache", extensions: ["mdb"] },
  "application/x-msbinder": { source: "apache", extensions: ["obd"] },
  "application/x-mscardfile": { source: "apache", extensions: ["crd"] },
  "application/x-msclip": { source: "apache", extensions: ["clp"] },
  "application/x-msdos-program": { extensions: ["exe"] },
  "application/x-msdownload": { source: "apache", extensions: ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { source: "apache", extensions: ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { source: "apache", extensions: ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { source: "apache", extensions: ["mny"] },
  "application/x-mspublisher": { source: "apache", extensions: ["pub"] },
  "application/x-msschedule": { source: "apache", extensions: ["scd"] },
  "application/x-msterminal": { source: "apache", extensions: ["trm"] },
  "application/x-mswrite": { source: "apache", extensions: ["wri"] },
  "application/x-netcdf": { source: "apache", extensions: ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { compressible: !0, extensions: ["pac"] },
  "application/x-nzb": { source: "apache", extensions: ["nzb"] },
  "application/x-perl": { source: "nginx", extensions: ["pl", "pm"] },
  "application/x-pilot": { source: "nginx", extensions: ["prc", "pdb"] },
  "application/x-pkcs12": { source: "apache", compressible: !1, extensions: ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { source: "apache", extensions: ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { source: "apache", extensions: ["p7r"] },
  "application/x-pki-message": { source: "iana" },
  "application/x-rar-compressed": { source: "apache", compressible: !1, extensions: ["rar"] },
  "application/x-redhat-package-manager": { source: "nginx", extensions: ["rpm"] },
  "application/x-research-info-systems": { source: "apache", extensions: ["ris"] },
  "application/x-sea": { source: "nginx", extensions: ["sea"] },
  "application/x-sh": { source: "apache", compressible: !0, extensions: ["sh"] },
  "application/x-shar": { source: "apache", extensions: ["shar"] },
  "application/x-shockwave-flash": { source: "apache", compressible: !1, extensions: ["swf"] },
  "application/x-silverlight-app": { source: "apache", extensions: ["xap"] },
  "application/x-sql": { source: "apache", extensions: ["sql"] },
  "application/x-stuffit": { source: "apache", compressible: !1, extensions: ["sit"] },
  "application/x-stuffitx": { source: "apache", extensions: ["sitx"] },
  "application/x-subrip": { source: "apache", extensions: ["srt"] },
  "application/x-sv4cpio": { source: "apache", extensions: ["sv4cpio"] },
  "application/x-sv4crc": { source: "apache", extensions: ["sv4crc"] },
  "application/x-t3vm-image": { source: "apache", extensions: ["t3"] },
  "application/x-tads": { source: "apache", extensions: ["gam"] },
  "application/x-tar": { source: "apache", compressible: !0, extensions: ["tar"] },
  "application/x-tcl": { source: "apache", extensions: ["tcl", "tk"] },
  "application/x-tex": { source: "apache", extensions: ["tex"] },
  "application/x-tex-tfm": { source: "apache", extensions: ["tfm"] },
  "application/x-texinfo": { source: "apache", extensions: ["texinfo", "texi"] },
  "application/x-tgif": { source: "apache", extensions: ["obj"] },
  "application/x-ustar": { source: "apache", extensions: ["ustar"] },
  "application/x-virtualbox-hdd": { compressible: !0, extensions: ["hdd"] },
  "application/x-virtualbox-ova": { compressible: !0, extensions: ["ova"] },
  "application/x-virtualbox-ovf": { compressible: !0, extensions: ["ovf"] },
  "application/x-virtualbox-vbox": { compressible: !0, extensions: ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { compressible: !1, extensions: ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { compressible: !0, extensions: ["vdi"] },
  "application/x-virtualbox-vhd": { compressible: !0, extensions: ["vhd"] },
  "application/x-virtualbox-vmdk": { compressible: !0, extensions: ["vmdk"] },
  "application/x-wais-source": { source: "apache", extensions: ["src"] },
  "application/x-web-app-manifest+json": { compressible: !0, extensions: ["webapp"] },
  "application/x-www-form-urlencoded": { source: "iana", compressible: !0 },
  "application/x-x509-ca-cert": { source: "iana", extensions: ["der", "crt", "pem"] },
  "application/x-x509-ca-ra-cert": { source: "iana" },
  "application/x-x509-next-ca-cert": { source: "iana" },
  "application/x-xfig": { source: "apache", extensions: ["fig"] },
  "application/x-xliff+xml": { source: "apache", compressible: !0, extensions: ["xlf"] },
  "application/x-xpinstall": { source: "apache", compressible: !1, extensions: ["xpi"] },
  "application/x-xz": { source: "apache", extensions: ["xz"] },
  "application/x-zmachine": { source: "apache", extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/x400-bp": { source: "iana" },
  "application/xacml+xml": { source: "iana", compressible: !0 },
  "application/xaml+xml": { source: "apache", compressible: !0, extensions: ["xaml"] },
  "application/xcap-att+xml": { source: "iana", compressible: !0, extensions: ["xav"] },
  "application/xcap-caps+xml": { source: "iana", compressible: !0, extensions: ["xca"] },
  "application/xcap-diff+xml": { source: "iana", compressible: !0, extensions: ["xdf"] },
  "application/xcap-el+xml": { source: "iana", compressible: !0, extensions: ["xel"] },
  "application/xcap-error+xml": { source: "iana", compressible: !0 },
  "application/xcap-ns+xml": { source: "iana", compressible: !0, extensions: ["xns"] },
  "application/xcon-conference-info+xml": { source: "iana", compressible: !0 },
  "application/xcon-conference-info-diff+xml": { source: "iana", compressible: !0 },
  "application/xenc+xml": { source: "iana", compressible: !0, extensions: ["xenc"] },
  "application/xhtml+xml": { source: "iana", compressible: !0, extensions: ["xhtml", "xht"] },
  "application/xhtml-voice+xml": { source: "apache", compressible: !0 },
  "application/xliff+xml": { source: "iana", compressible: !0, extensions: ["xlf"] },
  "application/xml": { source: "iana", compressible: !0, extensions: ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { source: "iana", compressible: !0, extensions: ["dtd"] },
  "application/xml-external-parsed-entity": { source: "iana" },
  "application/xml-patch+xml": { source: "iana", compressible: !0 },
  "application/xmpp+xml": { source: "iana", compressible: !0 },
  "application/xop+xml": { source: "iana", compressible: !0, extensions: ["xop"] },
  "application/xproc+xml": { source: "apache", compressible: !0, extensions: ["xpl"] },
  "application/xslt+xml": { source: "iana", compressible: !0, extensions: ["xsl", "xslt"] },
  "application/xspf+xml": { source: "apache", compressible: !0, extensions: ["xspf"] },
  "application/xv+xml": { source: "iana", compressible: !0, extensions: ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { source: "iana", extensions: ["yang"] },
  "application/yang-data+json": { source: "iana", compressible: !0 },
  "application/yang-data+xml": { source: "iana", compressible: !0 },
  "application/yang-patch+json": { source: "iana", compressible: !0 },
  "application/yang-patch+xml": { source: "iana", compressible: !0 },
  "application/yin+xml": { source: "iana", compressible: !0, extensions: ["yin"] },
  "application/zip": { source: "iana", compressible: !1, extensions: ["zip"] },
  "application/zlib": { source: "iana" },
  "application/zstd": { source: "iana" },
  "audio/1d-interleaved-parityfec": { source: "iana" },
  "audio/32kadpcm": { source: "iana" },
  "audio/3gpp": { source: "iana", compressible: !1, extensions: ["3gpp"] },
  "audio/3gpp2": { source: "iana" },
  "audio/aac": { source: "iana" },
  "audio/ac3": { source: "iana" },
  "audio/adpcm": { source: "apache", extensions: ["adp"] },
  "audio/amr": { source: "iana", extensions: ["amr"] },
  "audio/amr-wb": { source: "iana" },
  "audio/amr-wb+": { source: "iana" },
  "audio/aptx": { source: "iana" },
  "audio/asc": { source: "iana" },
  "audio/atrac-advanced-lossless": { source: "iana" },
  "audio/atrac-x": { source: "iana" },
  "audio/atrac3": { source: "iana" },
  "audio/basic": { source: "iana", compressible: !1, extensions: ["au", "snd"] },
  "audio/bv16": { source: "iana" },
  "audio/bv32": { source: "iana" },
  "audio/clearmode": { source: "iana" },
  "audio/cn": { source: "iana" },
  "audio/dat12": { source: "iana" },
  "audio/dls": { source: "iana" },
  "audio/dsr-es201108": { source: "iana" },
  "audio/dsr-es202050": { source: "iana" },
  "audio/dsr-es202211": { source: "iana" },
  "audio/dsr-es202212": { source: "iana" },
  "audio/dv": { source: "iana" },
  "audio/dvi4": { source: "iana" },
  "audio/eac3": { source: "iana" },
  "audio/encaprtp": { source: "iana" },
  "audio/evrc": { source: "iana" },
  "audio/evrc-qcp": { source: "iana" },
  "audio/evrc0": { source: "iana" },
  "audio/evrc1": { source: "iana" },
  "audio/evrcb": { source: "iana" },
  "audio/evrcb0": { source: "iana" },
  "audio/evrcb1": { source: "iana" },
  "audio/evrcnw": { source: "iana" },
  "audio/evrcnw0": { source: "iana" },
  "audio/evrcnw1": { source: "iana" },
  "audio/evrcwb": { source: "iana" },
  "audio/evrcwb0": { source: "iana" },
  "audio/evrcwb1": { source: "iana" },
  "audio/evs": { source: "iana" },
  "audio/flexfec": { source: "iana" },
  "audio/fwdred": { source: "iana" },
  "audio/g711-0": { source: "iana" },
  "audio/g719": { source: "iana" },
  "audio/g722": { source: "iana" },
  "audio/g7221": { source: "iana" },
  "audio/g723": { source: "iana" },
  "audio/g726-16": { source: "iana" },
  "audio/g726-24": { source: "iana" },
  "audio/g726-32": { source: "iana" },
  "audio/g726-40": { source: "iana" },
  "audio/g728": { source: "iana" },
  "audio/g729": { source: "iana" },
  "audio/g7291": { source: "iana" },
  "audio/g729d": { source: "iana" },
  "audio/g729e": { source: "iana" },
  "audio/gsm": { source: "iana" },
  "audio/gsm-efr": { source: "iana" },
  "audio/gsm-hr-08": { source: "iana" },
  "audio/ilbc": { source: "iana" },
  "audio/ip-mr_v2.5": { source: "iana" },
  "audio/isac": { source: "apache" },
  "audio/l16": { source: "iana" },
  "audio/l20": { source: "iana" },
  "audio/l24": { source: "iana", compressible: !1 },
  "audio/l8": { source: "iana" },
  "audio/lpc": { source: "iana" },
  "audio/melp": { source: "iana" },
  "audio/melp1200": { source: "iana" },
  "audio/melp2400": { source: "iana" },
  "audio/melp600": { source: "iana" },
  "audio/mhas": { source: "iana" },
  "audio/midi": { source: "apache", extensions: ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { source: "iana", extensions: ["mxmf"] },
  "audio/mp3": { compressible: !1, extensions: ["mp3"] },
  "audio/mp4": { source: "iana", compressible: !1, extensions: ["m4a", "mp4a"] },
  "audio/mp4a-latm": { source: "iana" },
  "audio/mpa": { source: "iana" },
  "audio/mpa-robust": { source: "iana" },
  "audio/mpeg": { source: "iana", compressible: !1, extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/mpeg4-generic": { source: "iana" },
  "audio/musepack": { source: "apache" },
  "audio/ogg": { source: "iana", compressible: !1, extensions: ["oga", "ogg", "spx", "opus"] },
  "audio/opus": { source: "iana" },
  "audio/parityfec": { source: "iana" },
  "audio/pcma": { source: "iana" },
  "audio/pcma-wb": { source: "iana" },
  "audio/pcmu": { source: "iana" },
  "audio/pcmu-wb": { source: "iana" },
  "audio/prs.sid": { source: "iana" },
  "audio/qcelp": { source: "iana" },
  "audio/raptorfec": { source: "iana" },
  "audio/red": { source: "iana" },
  "audio/rtp-enc-aescm128": { source: "iana" },
  "audio/rtp-midi": { source: "iana" },
  "audio/rtploopback": { source: "iana" },
  "audio/rtx": { source: "iana" },
  "audio/s3m": { source: "apache", extensions: ["s3m"] },
  "audio/scip": { source: "iana" },
  "audio/silk": { source: "apache", extensions: ["sil"] },
  "audio/smv": { source: "iana" },
  "audio/smv-qcp": { source: "iana" },
  "audio/smv0": { source: "iana" },
  "audio/sofa": { source: "iana" },
  "audio/sp-midi": { source: "iana" },
  "audio/speex": { source: "iana" },
  "audio/t140c": { source: "iana" },
  "audio/t38": { source: "iana" },
  "audio/telephone-event": { source: "iana" },
  "audio/tetra_acelp": { source: "iana" },
  "audio/tetra_acelp_bb": { source: "iana" },
  "audio/tone": { source: "iana" },
  "audio/tsvcis": { source: "iana" },
  "audio/uemclip": { source: "iana" },
  "audio/ulpfec": { source: "iana" },
  "audio/usac": { source: "iana" },
  "audio/vdvi": { source: "iana" },
  "audio/vmr-wb": { source: "iana" },
  "audio/vnd.3gpp.iufp": { source: "iana" },
  "audio/vnd.4sb": { source: "iana" },
  "audio/vnd.audiokoz": { source: "iana" },
  "audio/vnd.celp": { source: "iana" },
  "audio/vnd.cisco.nse": { source: "iana" },
  "audio/vnd.cmles.radio-events": { source: "iana" },
  "audio/vnd.cns.anp1": { source: "iana" },
  "audio/vnd.cns.inf1": { source: "iana" },
  "audio/vnd.dece.audio": { source: "iana", extensions: ["uva", "uvva"] },
  "audio/vnd.digital-winds": { source: "iana", extensions: ["eol"] },
  "audio/vnd.dlna.adts": { source: "iana" },
  "audio/vnd.dolby.heaac.1": { source: "iana" },
  "audio/vnd.dolby.heaac.2": { source: "iana" },
  "audio/vnd.dolby.mlp": { source: "iana" },
  "audio/vnd.dolby.mps": { source: "iana" },
  "audio/vnd.dolby.pl2": { source: "iana" },
  "audio/vnd.dolby.pl2x": { source: "iana" },
  "audio/vnd.dolby.pl2z": { source: "iana" },
  "audio/vnd.dolby.pulse.1": { source: "iana" },
  "audio/vnd.dra": { source: "iana", extensions: ["dra"] },
  "audio/vnd.dts": { source: "iana", extensions: ["dts"] },
  "audio/vnd.dts.hd": { source: "iana", extensions: ["dtshd"] },
  "audio/vnd.dts.uhd": { source: "iana" },
  "audio/vnd.dvb.file": { source: "iana" },
  "audio/vnd.everad.plj": { source: "iana" },
  "audio/vnd.hns.audio": { source: "iana" },
  "audio/vnd.lucent.voice": { source: "iana", extensions: ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { source: "iana", extensions: ["pya"] },
  "audio/vnd.nokia.mobile-xmf": { source: "iana" },
  "audio/vnd.nortel.vbk": { source: "iana" },
  "audio/vnd.nuera.ecelp4800": { source: "iana", extensions: ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { source: "iana", extensions: ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { source: "iana", extensions: ["ecelp9600"] },
  "audio/vnd.octel.sbc": { source: "iana" },
  "audio/vnd.presonus.multitrack": { source: "iana" },
  "audio/vnd.qcelp": { source: "iana" },
  "audio/vnd.rhetorex.32kadpcm": { source: "iana" },
  "audio/vnd.rip": { source: "iana", extensions: ["rip"] },
  "audio/vnd.rn-realaudio": { compressible: !1 },
  "audio/vnd.sealedmedia.softseal.mpeg": { source: "iana" },
  "audio/vnd.vmx.cvsd": { source: "iana" },
  "audio/vnd.wave": { compressible: !1 },
  "audio/vorbis": { source: "iana", compressible: !1 },
  "audio/vorbis-config": { source: "iana" },
  "audio/wav": { compressible: !1, extensions: ["wav"] },
  "audio/wave": { compressible: !1, extensions: ["wav"] },
  "audio/webm": { source: "apache", compressible: !1, extensions: ["weba"] },
  "audio/x-aac": { source: "apache", compressible: !1, extensions: ["aac"] },
  "audio/x-aiff": { source: "apache", extensions: ["aif", "aiff", "aifc"] },
  "audio/x-caf": { source: "apache", compressible: !1, extensions: ["caf"] },
  "audio/x-flac": { source: "apache", extensions: ["flac"] },
  "audio/x-m4a": { source: "nginx", extensions: ["m4a"] },
  "audio/x-matroska": { source: "apache", extensions: ["mka"] },
  "audio/x-mpegurl": { source: "apache", extensions: ["m3u"] },
  "audio/x-ms-wax": { source: "apache", extensions: ["wax"] },
  "audio/x-ms-wma": { source: "apache", extensions: ["wma"] },
  "audio/x-pn-realaudio": { source: "apache", extensions: ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { source: "apache", extensions: ["rmp"] },
  "audio/x-realaudio": { source: "nginx", extensions: ["ra"] },
  "audio/x-tta": { source: "apache" },
  "audio/x-wav": { source: "apache", extensions: ["wav"] },
  "audio/xm": { source: "apache", extensions: ["xm"] },
  "chemical/x-cdx": { source: "apache", extensions: ["cdx"] },
  "chemical/x-cif": { source: "apache", extensions: ["cif"] },
  "chemical/x-cmdf": { source: "apache", extensions: ["cmdf"] },
  "chemical/x-cml": { source: "apache", extensions: ["cml"] },
  "chemical/x-csml": { source: "apache", extensions: ["csml"] },
  "chemical/x-pdb": { source: "apache" },
  "chemical/x-xyz": { source: "apache", extensions: ["xyz"] },
  "font/collection": { source: "iana", extensions: ["ttc"] },
  "font/otf": { source: "iana", compressible: !0, extensions: ["otf"] },
  "font/sfnt": { source: "iana" },
  "font/ttf": { source: "iana", compressible: !0, extensions: ["ttf"] },
  "font/woff": { source: "iana", extensions: ["woff"] },
  "font/woff2": { source: "iana", extensions: ["woff2"] },
  "image/aces": { source: "iana", extensions: ["exr"] },
  "image/apng": { compressible: !1, extensions: ["apng"] },
  "image/avci": { source: "iana", extensions: ["avci"] },
  "image/avcs": { source: "iana", extensions: ["avcs"] },
  "image/avif": { source: "iana", compressible: !1, extensions: ["avif"] },
  "image/bmp": { source: "iana", compressible: !0, extensions: ["bmp"] },
  "image/cgm": { source: "iana", extensions: ["cgm"] },
  "image/dicom-rle": { source: "iana", extensions: ["drle"] },
  "image/emf": { source: "iana", extensions: ["emf"] },
  "image/fits": { source: "iana", extensions: ["fits"] },
  "image/g3fax": { source: "iana", extensions: ["g3"] },
  "image/gif": { source: "iana", compressible: !1, extensions: ["gif"] },
  "image/heic": { source: "iana", extensions: ["heic"] },
  "image/heic-sequence": { source: "iana", extensions: ["heics"] },
  "image/heif": { source: "iana", extensions: ["heif"] },
  "image/heif-sequence": { source: "iana", extensions: ["heifs"] },
  "image/hej2k": { source: "iana", extensions: ["hej2"] },
  "image/hsj2": { source: "iana", extensions: ["hsj2"] },
  "image/ief": { source: "iana", extensions: ["ief"] },
  "image/jls": { source: "iana", extensions: ["jls"] },
  "image/jp2": { source: "iana", compressible: !1, extensions: ["jp2", "jpg2"] },
  "image/jpeg": { source: "iana", compressible: !1, extensions: ["jpeg", "jpg", "jpe"] },
  "image/jph": { source: "iana", extensions: ["jph"] },
  "image/jphc": { source: "iana", extensions: ["jhc"] },
  "image/jpm": { source: "iana", compressible: !1, extensions: ["jpm"] },
  "image/jpx": { source: "iana", compressible: !1, extensions: ["jpx", "jpf"] },
  "image/jxr": { source: "iana", extensions: ["jxr"] },
  "image/jxra": { source: "iana", extensions: ["jxra"] },
  "image/jxrs": { source: "iana", extensions: ["jxrs"] },
  "image/jxs": { source: "iana", extensions: ["jxs"] },
  "image/jxsc": { source: "iana", extensions: ["jxsc"] },
  "image/jxsi": { source: "iana", extensions: ["jxsi"] },
  "image/jxss": { source: "iana", extensions: ["jxss"] },
  "image/ktx": { source: "iana", extensions: ["ktx"] },
  "image/ktx2": { source: "iana", extensions: ["ktx2"] },
  "image/naplps": { source: "iana" },
  "image/pjpeg": { compressible: !1 },
  "image/png": { source: "iana", compressible: !1, extensions: ["png"] },
  "image/prs.btif": { source: "iana", extensions: ["btif"] },
  "image/prs.pti": { source: "iana", extensions: ["pti"] },
  "image/pwg-raster": { source: "iana" },
  "image/sgi": { source: "apache", extensions: ["sgi"] },
  "image/svg+xml": { source: "iana", compressible: !0, extensions: ["svg", "svgz"] },
  "image/t38": { source: "iana", extensions: ["t38"] },
  "image/tiff": { source: "iana", compressible: !1, extensions: ["tif", "tiff"] },
  "image/tiff-fx": { source: "iana", extensions: ["tfx"] },
  "image/vnd.adobe.photoshop": { source: "iana", compressible: !0, extensions: ["psd"] },
  "image/vnd.airzip.accelerator.azv": { source: "iana", extensions: ["azv"] },
  "image/vnd.cns.inf2": { source: "iana" },
  "image/vnd.dece.graphic": { source: "iana", extensions: ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { source: "iana", extensions: ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "image/vnd.dwg": { source: "iana", extensions: ["dwg"] },
  "image/vnd.dxf": { source: "iana", extensions: ["dxf"] },
  "image/vnd.fastbidsheet": { source: "iana", extensions: ["fbs"] },
  "image/vnd.fpx": { source: "iana", extensions: ["fpx"] },
  "image/vnd.fst": { source: "iana", extensions: ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { source: "iana", extensions: ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { source: "iana", extensions: ["rlc"] },
  "image/vnd.globalgraphics.pgb": { source: "iana" },
  "image/vnd.microsoft.icon": { source: "iana", compressible: !0, extensions: ["ico"] },
  "image/vnd.mix": { source: "iana" },
  "image/vnd.mozilla.apng": { source: "iana" },
  "image/vnd.ms-dds": { compressible: !0, extensions: ["dds"] },
  "image/vnd.ms-modi": { source: "iana", extensions: ["mdi"] },
  "image/vnd.ms-photo": { source: "apache", extensions: ["wdp"] },
  "image/vnd.net-fpx": { source: "iana", extensions: ["npx"] },
  "image/vnd.pco.b16": { source: "iana", extensions: ["b16"] },
  "image/vnd.radiance": { source: "iana" },
  "image/vnd.sealed.png": { source: "iana" },
  "image/vnd.sealedmedia.softseal.gif": { source: "iana" },
  "image/vnd.sealedmedia.softseal.jpg": { source: "iana" },
  "image/vnd.svf": { source: "iana" },
  "image/vnd.tencent.tap": { source: "iana", extensions: ["tap"] },
  "image/vnd.valve.source.texture": { source: "iana", extensions: ["vtf"] },
  "image/vnd.wap.wbmp": { source: "iana", extensions: ["wbmp"] },
  "image/vnd.xiff": { source: "iana", extensions: ["xif"] },
  "image/vnd.zbrush.pcx": { source: "iana", extensions: ["pcx"] },
  "image/webp": { source: "apache", extensions: ["webp"] },
  "image/wmf": { source: "iana", extensions: ["wmf"] },
  "image/x-3ds": { source: "apache", extensions: ["3ds"] },
  "image/x-cmu-raster": { source: "apache", extensions: ["ras"] },
  "image/x-cmx": { source: "apache", extensions: ["cmx"] },
  "image/x-freehand": { source: "apache", extensions: ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { source: "apache", compressible: !0, extensions: ["ico"] },
  "image/x-jng": { source: "nginx", extensions: ["jng"] },
  "image/x-mrsid-image": { source: "apache", extensions: ["sid"] },
  "image/x-ms-bmp": { source: "nginx", compressible: !0, extensions: ["bmp"] },
  "image/x-pcx": { source: "apache", extensions: ["pcx"] },
  "image/x-pict": { source: "apache", extensions: ["pic", "pct"] },
  "image/x-portable-anymap": { source: "apache", extensions: ["pnm"] },
  "image/x-portable-bitmap": { source: "apache", extensions: ["pbm"] },
  "image/x-portable-graymap": { source: "apache", extensions: ["pgm"] },
  "image/x-portable-pixmap": { source: "apache", extensions: ["ppm"] },
  "image/x-rgb": { source: "apache", extensions: ["rgb"] },
  "image/x-tga": { source: "apache", extensions: ["tga"] },
  "image/x-xbitmap": { source: "apache", extensions: ["xbm"] },
  "image/x-xcf": { compressible: !1 },
  "image/x-xpixmap": { source: "apache", extensions: ["xpm"] },
  "image/x-xwindowdump": { source: "apache", extensions: ["xwd"] },
  "message/cpim": { source: "iana" },
  "message/delivery-status": { source: "iana" },
  "message/disposition-notification": { source: "iana", extensions: ["disposition-notification"] },
  "message/external-body": { source: "iana" },
  "message/feedback-report": { source: "iana" },
  "message/global": { source: "iana", extensions: ["u8msg"] },
  "message/global-delivery-status": { source: "iana", extensions: ["u8dsn"] },
  "message/global-disposition-notification": { source: "iana", extensions: ["u8mdn"] },
  "message/global-headers": { source: "iana", extensions: ["u8hdr"] },
  "message/http": { source: "iana", compressible: !1 },
  "message/imdn+xml": { source: "iana", compressible: !0 },
  "message/news": { source: "iana" },
  "message/partial": { source: "iana", compressible: !1 },
  "message/rfc822": { source: "iana", compressible: !0, extensions: ["eml", "mime"] },
  "message/s-http": { source: "iana" },
  "message/sip": { source: "iana" },
  "message/sipfrag": { source: "iana" },
  "message/tracking-status": { source: "iana" },
  "message/vnd.si.simp": { source: "iana" },
  "message/vnd.wfa.wsc": { source: "iana", extensions: ["wsc"] },
  "model/3mf": { source: "iana", extensions: ["3mf"] },
  "model/e57": { source: "iana" },
  "model/gltf+json": { source: "iana", compressible: !0, extensions: ["gltf"] },
  "model/gltf-binary": { source: "iana", compressible: !0, extensions: ["glb"] },
  "model/iges": { source: "iana", compressible: !1, extensions: ["igs", "iges"] },
  "model/mesh": { source: "iana", compressible: !1, extensions: ["msh", "mesh", "silo"] },
  "model/mtl": { source: "iana", extensions: ["mtl"] },
  "model/obj": { source: "iana", extensions: ["obj"] },
  "model/step": { source: "iana" },
  "model/step+xml": { source: "iana", compressible: !0, extensions: ["stpx"] },
  "model/step+zip": { source: "iana", compressible: !1, extensions: ["stpz"] },
  "model/step-xml+zip": { source: "iana", compressible: !1, extensions: ["stpxz"] },
  "model/stl": { source: "iana", extensions: ["stl"] },
  "model/vnd.collada+xml": { source: "iana", compressible: !0, extensions: ["dae"] },
  "model/vnd.dwf": { source: "iana", extensions: ["dwf"] },
  "model/vnd.flatland.3dml": { source: "iana" },
  "model/vnd.gdl": { source: "iana", extensions: ["gdl"] },
  "model/vnd.gs-gdl": { source: "apache" },
  "model/vnd.gs.gdl": { source: "iana" },
  "model/vnd.gtw": { source: "iana", extensions: ["gtw"] },
  "model/vnd.moml+xml": { source: "iana", compressible: !0 },
  "model/vnd.mts": { source: "iana", extensions: ["mts"] },
  "model/vnd.opengex": { source: "iana", extensions: ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { source: "iana", extensions: ["x_b"] },
  "model/vnd.parasolid.transmit.text": { source: "iana", extensions: ["x_t"] },
  "model/vnd.pytha.pyox": { source: "iana" },
  "model/vnd.rosette.annotated-data-model": { source: "iana" },
  "model/vnd.sap.vds": { source: "iana", extensions: ["vds"] },
  "model/vnd.usdz+zip": { source: "iana", compressible: !1, extensions: ["usdz"] },
  "model/vnd.valve.source.compiled-map": { source: "iana", extensions: ["bsp"] },
  "model/vnd.vtu": { source: "iana", extensions: ["vtu"] },
  "model/vrml": { source: "iana", compressible: !1, extensions: ["wrl", "vrml"] },
  "model/x3d+binary": { source: "apache", compressible: !1, extensions: ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { source: "iana", extensions: ["x3db"] },
  "model/x3d+vrml": { source: "apache", compressible: !1, extensions: ["x3dv", "x3dvz"] },
  "model/x3d+xml": { source: "iana", compressible: !0, extensions: ["x3d", "x3dz"] },
  "model/x3d-vrml": { source: "iana", extensions: ["x3dv"] },
  "multipart/alternative": { source: "iana", compressible: !1 },
  "multipart/appledouble": { source: "iana" },
  "multipart/byteranges": { source: "iana" },
  "multipart/digest": { source: "iana" },
  "multipart/encrypted": { source: "iana", compressible: !1 },
  "multipart/form-data": { source: "iana", compressible: !1 },
  "multipart/header-set": { source: "iana" },
  "multipart/mixed": { source: "iana" },
  "multipart/multilingual": { source: "iana" },
  "multipart/parallel": { source: "iana" },
  "multipart/related": { source: "iana", compressible: !1 },
  "multipart/report": { source: "iana" },
  "multipart/signed": { source: "iana", compressible: !1 },
  "multipart/vnd.bint.med-plus": { source: "iana" },
  "multipart/voice-message": { source: "iana" },
  "multipart/x-mixed-replace": { source: "iana" },
  "text/1d-interleaved-parityfec": { source: "iana" },
  "text/cache-manifest": { source: "iana", compressible: !0, extensions: ["appcache", "manifest"] },
  "text/calendar": { source: "iana", extensions: ["ics", "ifb"] },
  "text/calender": { compressible: !0 },
  "text/cmd": { compressible: !0 },
  "text/coffeescript": { extensions: ["coffee", "litcoffee"] },
  "text/cql": { source: "iana" },
  "text/cql-expression": { source: "iana" },
  "text/cql-identifier": { source: "iana" },
  "text/css": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["css"] },
  "text/csv": { source: "iana", compressible: !0, extensions: ["csv"] },
  "text/csv-schema": { source: "iana" },
  "text/directory": { source: "iana" },
  "text/dns": { source: "iana" },
  "text/ecmascript": { source: "iana" },
  "text/encaprtp": { source: "iana" },
  "text/enriched": { source: "iana" },
  "text/fhirpath": { source: "iana" },
  "text/flexfec": { source: "iana" },
  "text/fwdred": { source: "iana" },
  "text/gff3": { source: "iana" },
  "text/grammar-ref-list": { source: "iana" },
  "text/html": { source: "iana", compressible: !0, extensions: ["html", "htm", "shtml"] },
  "text/jade": { extensions: ["jade"] },
  "text/javascript": { source: "iana", compressible: !0 },
  "text/jcr-cnd": { source: "iana" },
  "text/jsx": { compressible: !0, extensions: ["jsx"] },
  "text/less": { compressible: !0, extensions: ["less"] },
  "text/markdown": { source: "iana", compressible: !0, extensions: ["markdown", "md"] },
  "text/mathml": { source: "nginx", extensions: ["mml"] },
  "text/mdx": { compressible: !0, extensions: ["mdx"] },
  "text/mizar": { source: "iana" },
  "text/n3": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["n3"] },
  "text/parameters": { source: "iana", charset: "UTF-8" },
  "text/parityfec": { source: "iana" },
  "text/plain": { source: "iana", compressible: !0, extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/provenance-notation": { source: "iana", charset: "UTF-8" },
  "text/prs.fallenstein.rst": { source: "iana" },
  "text/prs.lines.tag": { source: "iana", extensions: ["dsc"] },
  "text/prs.prop.logic": { source: "iana" },
  "text/raptorfec": { source: "iana" },
  "text/red": { source: "iana" },
  "text/rfc822-headers": { source: "iana" },
  "text/richtext": { source: "iana", compressible: !0, extensions: ["rtx"] },
  "text/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "text/rtp-enc-aescm128": { source: "iana" },
  "text/rtploopback": { source: "iana" },
  "text/rtx": { source: "iana" },
  "text/sgml": { source: "iana", extensions: ["sgml", "sgm"] },
  "text/shaclc": { source: "iana" },
  "text/shex": { source: "iana", extensions: ["shex"] },
  "text/slim": { extensions: ["slim", "slm"] },
  "text/spdx": { source: "iana", extensions: ["spdx"] },
  "text/strings": { source: "iana" },
  "text/stylus": { extensions: ["stylus", "styl"] },
  "text/t140": { source: "iana" },
  "text/tab-separated-values": { source: "iana", compressible: !0, extensions: ["tsv"] },
  "text/troff": { source: "iana", extensions: ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { source: "iana", charset: "UTF-8", extensions: ["ttl"] },
  "text/ulpfec": { source: "iana" },
  "text/uri-list": { source: "iana", compressible: !0, extensions: ["uri", "uris", "urls"] },
  "text/vcard": { source: "iana", compressible: !0, extensions: ["vcard"] },
  "text/vnd.a": { source: "iana" },
  "text/vnd.abc": { source: "iana" },
  "text/vnd.ascii-art": { source: "iana" },
  "text/vnd.curl": { source: "iana", extensions: ["curl"] },
  "text/vnd.curl.dcurl": { source: "apache", extensions: ["dcurl"] },
  "text/vnd.curl.mcurl": { source: "apache", extensions: ["mcurl"] },
  "text/vnd.curl.scurl": { source: "apache", extensions: ["scurl"] },
  "text/vnd.debian.copyright": { source: "iana", charset: "UTF-8" },
  "text/vnd.dmclientscript": { source: "iana" },
  "text/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "text/vnd.esmertec.theme-descriptor": { source: "iana", charset: "UTF-8" },
  "text/vnd.familysearch.gedcom": { source: "iana", extensions: ["ged"] },
  "text/vnd.ficlab.flt": { source: "iana" },
  "text/vnd.fly": { source: "iana", extensions: ["fly"] },
  "text/vnd.fmi.flexstor": { source: "iana", extensions: ["flx"] },
  "text/vnd.gml": { source: "iana" },
  "text/vnd.graphviz": { source: "iana", extensions: ["gv"] },
  "text/vnd.hans": { source: "iana" },
  "text/vnd.hgl": { source: "iana" },
  "text/vnd.in3d.3dml": { source: "iana", extensions: ["3dml"] },
  "text/vnd.in3d.spot": { source: "iana", extensions: ["spot"] },
  "text/vnd.iptc.newsml": { source: "iana" },
  "text/vnd.iptc.nitf": { source: "iana" },
  "text/vnd.latex-z": { source: "iana" },
  "text/vnd.motorola.reflex": { source: "iana" },
  "text/vnd.ms-mediapackage": { source: "iana" },
  "text/vnd.net2phone.commcenter.command": { source: "iana" },
  "text/vnd.radisys.msml-basic-layout": { source: "iana" },
  "text/vnd.senx.warpscript": { source: "iana" },
  "text/vnd.si.uricatalogue": { source: "iana" },
  "text/vnd.sosi": { source: "iana" },
  "text/vnd.sun.j2me.app-descriptor": { source: "iana", charset: "UTF-8", extensions: ["jad"] },
  "text/vnd.trolltech.linguist": { source: "iana", charset: "UTF-8" },
  "text/vnd.wap.si": { source: "iana" },
  "text/vnd.wap.sl": { source: "iana" },
  "text/vnd.wap.wml": { source: "iana", extensions: ["wml"] },
  "text/vnd.wap.wmlscript": { source: "iana", extensions: ["wmls"] },
  "text/vtt": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["vtt"] },
  "text/x-asm": { source: "apache", extensions: ["s", "asm"] },
  "text/x-c": { source: "apache", extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { source: "nginx", extensions: ["htc"] },
  "text/x-fortran": { source: "apache", extensions: ["f", "for", "f77", "f90"] },
  "text/x-gwt-rpc": { compressible: !0 },
  "text/x-handlebars-template": { extensions: ["hbs"] },
  "text/x-java-source": { source: "apache", extensions: ["java"] },
  "text/x-jquery-tmpl": { compressible: !0 },
  "text/x-lua": { extensions: ["lua"] },
  "text/x-markdown": { compressible: !0, extensions: ["mkd"] },
  "text/x-nfo": { source: "apache", extensions: ["nfo"] },
  "text/x-opml": { source: "apache", extensions: ["opml"] },
  "text/x-org": { compressible: !0, extensions: ["org"] },
  "text/x-pascal": { source: "apache", extensions: ["p", "pas"] },
  "text/x-processing": { compressible: !0, extensions: ["pde"] },
  "text/x-sass": { extensions: ["sass"] },
  "text/x-scss": { extensions: ["scss"] },
  "text/x-setext": { source: "apache", extensions: ["etx"] },
  "text/x-sfv": { source: "apache", extensions: ["sfv"] },
  "text/x-suse-ymp": { compressible: !0, extensions: ["ymp"] },
  "text/x-uuencode": { source: "apache", extensions: ["uu"] },
  "text/x-vcalendar": { source: "apache", extensions: ["vcs"] },
  "text/x-vcard": { source: "apache", extensions: ["vcf"] },
  "text/xml": { source: "iana", compressible: !0, extensions: ["xml"] },
  "text/xml-external-parsed-entity": { source: "iana" },
  "text/yaml": { compressible: !0, extensions: ["yaml", "yml"] },
  "video/1d-interleaved-parityfec": { source: "iana" },
  "video/3gpp": { source: "iana", extensions: ["3gp", "3gpp"] },
  "video/3gpp-tt": { source: "iana" },
  "video/3gpp2": { source: "iana", extensions: ["3g2"] },
  "video/av1": { source: "iana" },
  "video/bmpeg": { source: "iana" },
  "video/bt656": { source: "iana" },
  "video/celb": { source: "iana" },
  "video/dv": { source: "iana" },
  "video/encaprtp": { source: "iana" },
  "video/ffv1": { source: "iana" },
  "video/flexfec": { source: "iana" },
  "video/h261": { source: "iana", extensions: ["h261"] },
  "video/h263": { source: "iana", extensions: ["h263"] },
  "video/h263-1998": { source: "iana" },
  "video/h263-2000": { source: "iana" },
  "video/h264": { source: "iana", extensions: ["h264"] },
  "video/h264-rcdo": { source: "iana" },
  "video/h264-svc": { source: "iana" },
  "video/h265": { source: "iana" },
  "video/iso.segment": { source: "iana", extensions: ["m4s"] },
  "video/jpeg": { source: "iana", extensions: ["jpgv"] },
  "video/jpeg2000": { source: "iana" },
  "video/jpm": { source: "apache", extensions: ["jpm", "jpgm"] },
  "video/jxsv": { source: "iana" },
  "video/mj2": { source: "iana", extensions: ["mj2", "mjp2"] },
  "video/mp1s": { source: "iana" },
  "video/mp2p": { source: "iana" },
  "video/mp2t": { source: "iana", extensions: ["ts"] },
  "video/mp4": { source: "iana", compressible: !1, extensions: ["mp4", "mp4v", "mpg4"] },
  "video/mp4v-es": { source: "iana" },
  "video/mpeg": { source: "iana", compressible: !1, extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/mpeg4-generic": { source: "iana" },
  "video/mpv": { source: "iana" },
  "video/nv": { source: "iana" },
  "video/ogg": { source: "iana", compressible: !1, extensions: ["ogv"] },
  "video/parityfec": { source: "iana" },
  "video/pointer": { source: "iana" },
  "video/quicktime": { source: "iana", compressible: !1, extensions: ["qt", "mov"] },
  "video/raptorfec": { source: "iana" },
  "video/raw": { source: "iana" },
  "video/rtp-enc-aescm128": { source: "iana" },
  "video/rtploopback": { source: "iana" },
  "video/rtx": { source: "iana" },
  "video/scip": { source: "iana" },
  "video/smpte291": { source: "iana" },
  "video/smpte292m": { source: "iana" },
  "video/ulpfec": { source: "iana" },
  "video/vc1": { source: "iana" },
  "video/vc2": { source: "iana" },
  "video/vnd.cctv": { source: "iana" },
  "video/vnd.dece.hd": { source: "iana", extensions: ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { source: "iana", extensions: ["uvm", "uvvm"] },
  "video/vnd.dece.mp4": { source: "iana" },
  "video/vnd.dece.pd": { source: "iana", extensions: ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { source: "iana", extensions: ["uvs", "uvvs"] },
  "video/vnd.dece.video": { source: "iana", extensions: ["uvv", "uvvv"] },
  "video/vnd.directv.mpeg": { source: "iana" },
  "video/vnd.directv.mpeg-tts": { source: "iana" },
  "video/vnd.dlna.mpeg-tts": { source: "iana" },
  "video/vnd.dvb.file": { source: "iana", extensions: ["dvb"] },
  "video/vnd.fvt": { source: "iana", extensions: ["fvt"] },
  "video/vnd.hns.video": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.ttsavc": { source: "iana" },
  "video/vnd.iptvforum.ttsmpeg2": { source: "iana" },
  "video/vnd.motorola.video": { source: "iana" },
  "video/vnd.motorola.videop": { source: "iana" },
  "video/vnd.mpegurl": { source: "iana", extensions: ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { source: "iana", extensions: ["pyv"] },
  "video/vnd.nokia.interleaved-multimedia": { source: "iana" },
  "video/vnd.nokia.mp4vr": { source: "iana" },
  "video/vnd.nokia.videovoip": { source: "iana" },
  "video/vnd.objectvideo": { source: "iana" },
  "video/vnd.radgamettools.bink": { source: "iana" },
  "video/vnd.radgamettools.smacker": { source: "iana" },
  "video/vnd.sealed.mpeg1": { source: "iana" },
  "video/vnd.sealed.mpeg4": { source: "iana" },
  "video/vnd.sealed.swf": { source: "iana" },
  "video/vnd.sealedmedia.softseal.mov": { source: "iana" },
  "video/vnd.uvvu.mp4": { source: "iana", extensions: ["uvu", "uvvu"] },
  "video/vnd.vivo": { source: "iana", extensions: ["viv"] },
  "video/vnd.youtube.yt": { source: "iana" },
  "video/vp8": { source: "iana" },
  "video/vp9": { source: "iana" },
  "video/webm": { source: "apache", compressible: !1, extensions: ["webm"] },
  "video/x-f4v": { source: "apache", extensions: ["f4v"] },
  "video/x-fli": { source: "apache", extensions: ["fli"] },
  "video/x-flv": { source: "apache", compressible: !1, extensions: ["flv"] },
  "video/x-m4v": { source: "apache", extensions: ["m4v"] },
  "video/x-matroska": { source: "apache", compressible: !1, extensions: ["mkv", "mk3d", "mks"] },
  "video/x-mng": { source: "apache", extensions: ["mng"] },
  "video/x-ms-asf": { source: "apache", extensions: ["asf", "asx"] },
  "video/x-ms-vob": { source: "apache", extensions: ["vob"] },
  "video/x-ms-wm": { source: "apache", extensions: ["wm"] },
  "video/x-ms-wmv": { source: "apache", compressible: !1, extensions: ["wmv"] },
  "video/x-ms-wmx": { source: "apache", extensions: ["wmx"] },
  "video/x-ms-wvx": { source: "apache", extensions: ["wvx"] },
  "video/x-msvideo": { source: "apache", extensions: ["avi"] },
  "video/x-sgi-movie": { source: "apache", extensions: ["movie"] },
  "video/x-smv": { source: "apache", extensions: ["smv"] },
  "x-conference/x-cooltalk": { source: "apache", extensions: ["ice"] },
  "x-shader/x-fragment": { compressible: !0 },
  "x-shader/x-vertex": { compressible: !0 }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var oq, $me;
function zln() {
  return $me || ($me = 1, oq = Lln), oq;
}
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var Kme;
function jln() {
  return Kme || (Kme = 1, function(e) {
    var t = zln(), n = jH.extname, r = /^\s*([^;\s]*)(?:;|\s|$)/, i = /^text\//i;
    e.charset = o, e.charsets = { lookup: o }, e.contentType = s, e.extension = l, e.extensions = /* @__PURE__ */ Object.create(null), e.lookup = c, e.types = /* @__PURE__ */ Object.create(null), a(e.extensions, e.types);
    function o(u) {
      if (!u || typeof u != "string")
        return !1;
      var f = r.exec(u), d = f && t[f[1].toLowerCase()];
      return d && d.charset ? d.charset : f && i.test(f[1]) ? "UTF-8" : !1;
    }
    function s(u) {
      if (!u || typeof u != "string")
        return !1;
      var f = u.indexOf("/") === -1 ? e.lookup(u) : u;
      if (!f)
        return !1;
      if (f.indexOf("charset") === -1) {
        var d = e.charset(f);
        d && (f += "; charset=" + d.toLowerCase());
      }
      return f;
    }
    function l(u) {
      if (!u || typeof u != "string")
        return !1;
      var f = r.exec(u), d = f && e.extensions[f[1].toLowerCase()];
      return !d || !d.length ? !1 : d[0];
    }
    function c(u) {
      if (!u || typeof u != "string")
        return !1;
      var f = n("x." + u).toLowerCase().substr(1);
      return f && e.types[f] || !1;
    }
    function a(u, f) {
      var d = ["nginx", "apache", void 0, "iana"];
      Object.keys(t).forEach(function(h) {
        var m = t[h], v = m.extensions;
        if (!(!v || !v.length)) {
          u[h] = v;
          for (var b = 0; b < v.length; b++) {
            var A = v[b];
            if (f[A]) {
              var w = d.indexOf(t[f[A]].source), O = d.indexOf(m.source);
              if (f[A] !== "application/octet-stream" && (w > O || w === O && f[A].substr(0, 12) === "application/"))
                continue;
            }
            f[A] = h;
          }
        }
      });
    }
  }(iq)), iq;
}
var sq, Gme;
function Fln() {
  return Gme || (Gme = 1, sq = typeof self == "object" ? self.FormData : window.FormData), sq;
}
var Yme;
function Uln() {
  if (Yme) return ly;
  Yme = 1, Object.defineProperty(ly, "__esModule", { value: !0 }), ly.getAccessTokenOrThrow = void 0, ly.createCustomApiCallAction = u, ly.is_chromium_installed = f;
  const e = wx, t = Eln, n = g4e(), r = y4e, i = e.__importDefault(jH), o = e.__importDefault(jln()), s = e.__importDefault(Fln()), l = (h) => {
    const m = h == null ? void 0 : h.access_token;
    if (m === void 0)
      throw new Error("Invalid bearer token");
    return m;
  };
  ly.getAccessTokenOrThrow = l;
  const c = ({ baseUrl: h, relativePath: m }) => {
    const v = h.endsWith("/") ? h : `${h}/`, b = m.startsWith("/") ? m.slice(1) : m;
    return `${v}${b}`;
  }, a = (h, m) => {
    const v = "https://api.example.com";
    try {
      const b = m ? h(m) : void 0, A = b != null && b.endsWith("/") ? b.slice(0, -1) : b;
      return A ?? v;
    } catch {
      return v;
    }
  };
  function u({ auth: h, baseUrl: m, authMapping: v, description: b, displayName: A, name: w, props: O, extraProps: x, authLocation: S = "headers" }) {
    var E, k, T, R, j;
    return (0, t.createAction)({
      name: w || "custom_api_call",
      displayName: A || "Custom API Call",
      description: b || "Make a custom API call to a specific endpoint",
      auth: h,
      requireAuth: !!h,
      props: Object.assign({ url: t.Property.DynamicProperties({
        auth: h,
        displayName: "",
        required: !0,
        refreshers: [],
        props: (F) => e.__awaiter(this, [F], void 0, function* ({ auth: L }) {
          var _;
          return {
            url: t.Property.ShortText(Object.assign({ displayName: "URL", description: `You can either use the full URL or the relative path to the base URL
i.e ${a(m, L)}/resource or /resource`, required: !0, defaultValue: L ? m(L) : "" }, (_ = O == null ? void 0 : O.url) !== null && _ !== void 0 ? _ : {}))
          };
        })
      }), method: t.Property.StaticDropdown(Object.assign({ displayName: "Method", required: !0, options: {
        options: Object.values(n.HttpMethod).map((F) => ({
          label: F,
          value: F
        }))
      } }, (E = O == null ? void 0 : O.method) !== null && E !== void 0 ? E : {})), headers: t.Property.Object(Object.assign({ displayName: "Headers", description: "Authorization headers are injected automatically from your connection.", required: !0 }, (k = O == null ? void 0 : O.headers) !== null && k !== void 0 ? k : {})), queryParams: t.Property.Object(Object.assign({ displayName: "Query Parameters", required: !0 }, (T = O == null ? void 0 : O.queryParams) !== null && T !== void 0 ? T : {})), body_type: t.Property.StaticDropdown({
        displayName: "Body Type",
        required: !1,
        defaultValue: "none",
        options: {
          disabled: !1,
          options: [
            {
              label: "None",
              value: "none"
            },
            {
              label: "JSON",
              value: "json"
            },
            {
              label: "Form Data",
              value: "form_data"
            },
            {
              label: "Raw",
              value: "raw"
            }
          ]
        }
      }), body: t.Property.DynamicProperties({
        auth: h,
        displayName: "Body",
        refreshers: ["body_type"],
        required: !1,
        props: (F) => e.__awaiter(this, [F], void 0, function* ({ body_type: L }) {
          var _;
          if (!L)
            return {};
          const U = L, z = {};
          switch (U) {
            case "none":
              break;
            case "json":
              z.data = t.Property.Json(Object.assign({ displayName: "JSON Body", required: !0 }, (_ = O == null ? void 0 : O.body) !== null && _ !== void 0 ? _ : {}));
              break;
            case "raw":
              z.data = t.Property.LongText({
                displayName: "Raw Body",
                required: !0
              });
              break;
            case "form_data":
              z.data = t.Property.Array({
                displayName: "Form Data",
                required: !0,
                properties: {
                  fieldName: t.Property.ShortText({
                    displayName: "Field Name",
                    required: !0
                  }),
                  fieldType: t.Property.StaticDropdown({
                    displayName: "Field Type",
                    required: !0,
                    options: {
                      disabled: !1,
                      options: [
                        { label: "Text", value: "text" },
                        { label: "File", value: "file" }
                      ]
                    }
                  }),
                  textFieldValue: t.Property.LongText({
                    displayName: "Text Field Value",
                    required: !1
                  }),
                  fileFieldValue: t.Property.File({
                    displayName: "File Field Value",
                    required: !1
                  })
                }
              });
              break;
          }
          return z;
        })
      }), response_is_binary: t.Property.Checkbox({
        displayName: "Response is Binary ?",
        description: "Enable for files like PDFs, images, etc.",
        required: !1,
        defaultValue: !1
      }), failsafe: t.Property.Checkbox(Object.assign({ displayName: "No Error on Failure", required: !1 }, (R = O == null ? void 0 : O.failsafe) !== null && R !== void 0 ? R : {})), timeout: t.Property.Number(Object.assign({ displayName: "Timeout (in seconds)", required: !1 }, (j = O == null ? void 0 : O.timeout) !== null && j !== void 0 ? j : {})) }, x),
      run: (F) => e.__awaiter(this, void 0, void 0, function* () {
        var L;
        const { method: _, url: U, headers: z, queryParams: C, body: I, body_type: M, failsafe: D, timeout: X, response_is_binary: B } = F.propsValue;
        (0, r.assertNotNullOrUndefined)(_, "Method"), (0, r.assertNotNullOrUndefined)(U, "URL");
        const q = (0, r.isNil)(v) ? {} : yield v(F.auth, F.propsValue), H = U.url, Y = H.startsWith("http://") || H.startsWith("https://") ? H : c({
          baseUrl: m(F.auth),
          relativePath: H
        }), J = {
          method: _,
          url: Y,
          headers: Object.assign(Object.assign({}, z ?? {}), S === "headers" || !(0, r.isNil)(S) ? q : {}),
          queryParams: Object.assign(Object.assign({}, S === "queryParams" ? q : {}), (L = C) !== null && L !== void 0 ? L : {}),
          timeout: X ? X * 1e3 : 0
        };
        if (B && (J.responseType = "arraybuffer"), I)
          if (M && M !== "none") {
            const oe = I.data;
            if (M === "form_data") {
              const ce = oe, fe = new s.default();
              for (const { fieldName: $, fieldType: pe, textFieldValue: ee, fileFieldValue: Ce } of ce)
                pe === "text" && !(0, r.isEmpty)(ee) ? fe.append($, ee) : pe === "file" && !(0, r.isEmpty)(Ce) && fe.append($, Ce.data, {
                  filename: Ce == null ? void 0 : Ce.filename
                });
              J.body = fe, J.headers = Object.assign(Object.assign({}, J.headers), fe.getHeaders());
            } else
              J.body = oe;
          } else M || (J.body = I);
        try {
          const oe = yield n.httpClient.sendRequest(J);
          return yield d(F.files, oe.body, oe.status, oe.headers, B);
        } catch (oe) {
          if (D)
            return oe.errorMessage();
          throw oe;
        }
      })
    });
  }
  function f() {
    return i.default.existsSync("/usr/bin/chromium");
  }
  const d = (h, m, v, b, A) => e.__awaiter(void 0, void 0, void 0, function* () {
    let w;
    if (A && p(m)) {
      const O = Array.isArray(b == null ? void 0 : b["content-type"]) ? b["content-type"][0] : b == null ? void 0 : b["content-type"], x = o.default.extension(O ?? "") || "txt";
      let S;
      m instanceof ArrayBuffer ? S = Buffer.from(new Uint8Array(m)) : Buffer.isBuffer(m) ? S = m : S = Buffer.from(m), w = yield h.write({
        fileName: `output.${x}`,
        data: S
      });
    } else
      w = m;
    return { status: v, headers: b, body: w };
  }), p = (h) => h instanceof ArrayBuffer || Buffer.isBuffer(h);
  return ly;
}
var uy = {}, Jme;
function Vln() {
  if (Jme) return uy;
  Jme = 1, Object.defineProperty(uy, "__esModule", { value: !0 }), uy.pollingHelper = uy.DedupeStrategy = void 0;
  const e = wx, t = y4e;
  var n;
  (function(i) {
    i[i.TIMEBASED = 0] = "TIMEBASED", i[i.LAST_ITEM = 1] = "LAST_ITEM";
  })(n || (uy.DedupeStrategy = n = {})), uy.pollingHelper = {
    poll(i, o) {
      return e.__awaiter(this, arguments, void 0, function* (s, { store: l, auth: c, propsValue: a, maxItemsToPoll: u, files: f }) {
        var d, p;
        switch (s.strategy) {
          case n.TIMEBASED: {
            const h = yield l.get("lastPoll");
            if ((0, t.isNil)(h))
              throw new Error("lastPoll doesn't exist in the store.");
            const m = yield s.items({
              store: l,
              auth: c,
              propsValue: a,
              lastFetchEpochMS: h
            }), v = m.reduce((b, A) => Math.max(b, A.epochMilliSeconds), h);
            return yield l.put("lastPoll", v), m.filter((b) => b.epochMilliSeconds > h).map((b) => b.data);
          }
          case n.LAST_ITEM: {
            const h = yield l.get("lastItem"), m = yield s.items({
              store: l,
              auth: c,
              propsValue: a,
              lastItemId: h,
              files: f
            }), v = m.findIndex((w) => w.id === h);
            let b = [];
            (0, t.isNil)(h) || v == -1 ? b = m ?? [] : b = (d = m == null ? void 0 : m.slice(0, v)) !== null && d !== void 0 ? d : [], (0, t.isNil)(u) || (b = b.slice(-u));
            const A = (p = b == null ? void 0 : b[0]) === null || p === void 0 ? void 0 : p.id;
            return (0, t.isNil)(A) || (yield l.put("lastItem", A)), b.map((w) => w.data);
          }
        }
      });
    },
    onEnable(i, o) {
      return e.__awaiter(this, arguments, void 0, function* (s, { store: l, auth: c, propsValue: a }) {
        var u;
        switch (s.strategy) {
          case n.TIMEBASED: {
            yield l.put("lastPoll", Date.now());
            break;
          }
          case n.LAST_ITEM: {
            const f = yield s.items({
              store: l,
              auth: c,
              propsValue: a,
              lastItemId: null
            }), d = (u = f == null ? void 0 : f[0]) === null || u === void 0 ? void 0 : u.id;
            (0, t.isNil)(d) ? yield l.delete("lastItem") : yield l.put("lastItem", d);
            break;
          }
        }
      });
    },
    onDisable(i, o) {
      return e.__awaiter(this, void 0, void 0, function* () {
        switch (i.strategy) {
          case n.TIMEBASED:
          case n.LAST_ITEM:
            return;
        }
      });
    },
    test(i, o) {
      return e.__awaiter(this, arguments, void 0, function* (s, { auth: l, propsValue: c, store: a, files: u }) {
        let f = [];
        switch (s.strategy) {
          case n.TIMEBASED: {
            f = yield s.items({
              store: a,
              auth: l,
              propsValue: c,
              lastFetchEpochMS: 0
            });
            break;
          }
          case n.LAST_ITEM: {
            f = yield s.items({
              store: a,
              auth: l,
              propsValue: c,
              lastItemId: null,
              files: u
            });
            break;
          }
        }
        return r(f.map((d) => d.data));
      });
    }
  };
  function r(i) {
    return i.length <= 5 ? i : i.slice(0, 5);
  }
  return uy;
}
var WS = {}, wu = {}, Ll = {}, xu = {}, aq = {}, ege;
function tP() {
  return ege || (ege = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.globalConfig = e.$ZodEncodeError = e.$ZodAsyncError = e.$brand = e.NEVER = void 0, e.$constructor = t, e.config = i, e.NEVER = Object.freeze({
      status: "aborted"
    });
    function t(o, s, l) {
      function c(d, p) {
        if (d._zod || Object.defineProperty(d, "_zod", {
          value: {
            def: p,
            constr: f,
            traits: /* @__PURE__ */ new Set()
          },
          enumerable: !1
        }), d._zod.traits.has(o))
          return;
        d._zod.traits.add(o), s(d, p);
        const h = f.prototype, m = Object.keys(h);
        for (let v = 0; v < m.length; v++) {
          const b = m[v];
          b in d || (d[b] = h[b].bind(d));
        }
      }
      const a = (l == null ? void 0 : l.Parent) ?? Object;
      class u extends a {
      }
      Object.defineProperty(u, "name", { value: o });
      function f(d) {
        var p;
        const h = l != null && l.Parent ? new u() : this;
        c(h, d), (p = h._zod).deferred ?? (p.deferred = []);
        for (const m of h._zod.deferred)
          m();
        return h;
      }
      return Object.defineProperty(f, "init", { value: c }), Object.defineProperty(f, Symbol.hasInstance, {
        value: (d) => {
          var p, h;
          return l != null && l.Parent && d instanceof l.Parent ? !0 : (h = (p = d == null ? void 0 : d._zod) == null ? void 0 : p.traits) == null ? void 0 : h.has(o);
        }
      }), Object.defineProperty(f, "name", { value: o }), f;
    }
    e.$brand = Symbol("zod_brand");
    class n extends Error {
      constructor() {
        super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
      }
    }
    e.$ZodAsyncError = n;
    class r extends Error {
      constructor(s) {
        super(`Encountered unidirectional transform during encode: ${s}`), this.name = "ZodEncodeError";
      }
    }
    e.$ZodEncodeError = r, e.globalConfig = {};
    function i(o) {
      return o && Object.assign(e.globalConfig, o), e.globalConfig;
    }
  }(aq)), aq;
}
var tp = {}, Xo = {}, Xt = {}, tge;
function fn() {
  if (tge) return Xt;
  tge = 1, Object.defineProperty(Xt, "__esModule", { value: !0 }), Xt.Class = Xt.BIGINT_FORMAT_RANGES = Xt.NUMBER_FORMAT_RANGES = Xt.primitiveTypes = Xt.propertyKeyTypes = Xt.getParsedType = Xt.allowsEval = Xt.captureStackTrace = void 0, Xt.assertEqual = e, Xt.assertNotEqual = t, Xt.assertIs = n, Xt.assertNever = r, Xt.assert = i, Xt.getEnumValues = o, Xt.joinValues = s, Xt.jsonStringifyReplacer = l, Xt.cached = c, Xt.nullish = a, Xt.cleanRegex = u, Xt.floatSafeRemainder = f, Xt.defineLazy = p, Xt.objectClone = h, Xt.assignProp = m, Xt.mergeDefs = v, Xt.cloneDef = b, Xt.getElementAtPath = A, Xt.promiseAllObject = w, Xt.randomString = O, Xt.esc = x, Xt.slugify = S, Xt.isObject = E, Xt.isPlainObject = k, Xt.shallowClone = T, Xt.numKeys = R, Xt.escapeRegex = F, Xt.clone = L, Xt.normalizeParams = _, Xt.createTransparentProxy = U, Xt.stringifyPrimitive = z, Xt.optionalKeys = C, Xt.pick = I, Xt.omit = M, Xt.extend = D, Xt.safeExtend = X, Xt.merge = B, Xt.partial = q, Xt.required = H, Xt.aborted = Y, Xt.prefixIssues = J, Xt.unwrapMessage = oe, Xt.finalizeIssue = ce, Xt.getSizableOrigin = fe, Xt.getLengthableOrigin = $, Xt.issue = pe, Xt.cleanEnum = ee, Xt.base64ToUint8Array = Ce, Xt.uint8ArrayToBase64 = Ee, Xt.base64urlToUint8Array = Ve, Xt.uint8ArrayToBase64url = et, Xt.hexToUint8Array = ft, Xt.uint8ArrayToHex = me;
  function e(re) {
    return re;
  }
  function t(re) {
    return re;
  }
  function n(re) {
  }
  function r(re) {
    throw new Error();
  }
  function i(re) {
  }
  function o(re) {
    const le = Object.values(re).filter((be) => typeof be == "number");
    return Object.entries(re).filter(([be, je]) => le.indexOf(+be) === -1).map(([be, je]) => je);
  }
  function s(re, le = "|") {
    return re.map((Oe) => z(Oe)).join(le);
  }
  function l(re, le) {
    return typeof le == "bigint" ? le.toString() : le;
  }
  function c(re) {
    return {
      get value() {
        {
          const le = re();
          return Object.defineProperty(this, "value", { value: le }), le;
        }
      }
    };
  }
  function a(re) {
    return re == null;
  }
  function u(re) {
    const le = re.startsWith("^") ? 1 : 0, Oe = re.endsWith("$") ? re.length - 1 : re.length;
    return re.slice(le, Oe);
  }
  function f(re, le) {
    const Oe = (re.toString().split(".")[1] || "").length, be = le.toString();
    let je = (be.split(".")[1] || "").length;
    if (je === 0 && /\d?e-\d?/.test(be)) {
      const Pe = be.match(/\d?e-(\d?)/);
      Pe != null && Pe[1] && (je = Number.parseInt(Pe[1]));
    }
    const xe = Oe > je ? Oe : je, Q = Number.parseInt(re.toFixed(xe).replace(".", "")), ae = Number.parseInt(le.toFixed(xe).replace(".", ""));
    return Q % ae / 10 ** xe;
  }
  const d = Symbol("evaluating");
  function p(re, le, Oe) {
    let be;
    Object.defineProperty(re, le, {
      get() {
        if (be !== d)
          return be === void 0 && (be = d, be = Oe()), be;
      },
      set(je) {
        Object.defineProperty(re, le, {
          value: je
          // configurable: true,
        });
      },
      configurable: !0
    });
  }
  function h(re) {
    return Object.create(Object.getPrototypeOf(re), Object.getOwnPropertyDescriptors(re));
  }
  function m(re, le, Oe) {
    Object.defineProperty(re, le, {
      value: Oe,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  }
  function v(...re) {
    const le = {};
    for (const Oe of re) {
      const be = Object.getOwnPropertyDescriptors(Oe);
      Object.assign(le, be);
    }
    return Object.defineProperties({}, le);
  }
  function b(re) {
    return v(re._zod.def);
  }
  function A(re, le) {
    return le ? le.reduce((Oe, be) => Oe == null ? void 0 : Oe[be], re) : re;
  }
  function w(re) {
    const le = Object.keys(re), Oe = le.map((be) => re[be]);
    return Promise.all(Oe).then((be) => {
      const je = {};
      for (let xe = 0; xe < le.length; xe++)
        je[le[xe]] = be[xe];
      return je;
    });
  }
  function O(re = 10) {
    const le = "abcdefghijklmnopqrstuvwxyz";
    let Oe = "";
    for (let be = 0; be < re; be++)
      Oe += le[Math.floor(Math.random() * le.length)];
    return Oe;
  }
  function x(re) {
    return JSON.stringify(re);
  }
  function S(re) {
    return re.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
  }
  Xt.captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (...re) => {
  };
  function E(re) {
    return typeof re == "object" && re !== null && !Array.isArray(re);
  }
  Xt.allowsEval = c(() => {
    var re;
    if (typeof navigator < "u" && ((re = navigator == null ? void 0 : navigator.userAgent) != null && re.includes("Cloudflare")))
      return !1;
    try {
      const le = Function;
      return new le(""), !0;
    } catch {
      return !1;
    }
  });
  function k(re) {
    if (E(re) === !1)
      return !1;
    const le = re.constructor;
    if (le === void 0 || typeof le != "function")
      return !0;
    const Oe = le.prototype;
    return !(E(Oe) === !1 || Object.prototype.hasOwnProperty.call(Oe, "isPrototypeOf") === !1);
  }
  function T(re) {
    return k(re) ? { ...re } : Array.isArray(re) ? [...re] : re;
  }
  function R(re) {
    let le = 0;
    for (const Oe in re)
      Object.prototype.hasOwnProperty.call(re, Oe) && le++;
    return le;
  }
  const j = (re) => {
    const le = typeof re;
    switch (le) {
      case "undefined":
        return "undefined";
      case "string":
        return "string";
      case "number":
        return Number.isNaN(re) ? "nan" : "number";
      case "boolean":
        return "boolean";
      case "function":
        return "function";
      case "bigint":
        return "bigint";
      case "symbol":
        return "symbol";
      case "object":
        return Array.isArray(re) ? "array" : re === null ? "null" : re.then && typeof re.then == "function" && re.catch && typeof re.catch == "function" ? "promise" : typeof Map < "u" && re instanceof Map ? "map" : typeof Set < "u" && re instanceof Set ? "set" : typeof Date < "u" && re instanceof Date ? "date" : typeof File < "u" && re instanceof File ? "file" : "object";
      default:
        throw new Error(`Unknown data type: ${le}`);
    }
  };
  Xt.getParsedType = j, Xt.propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]), Xt.primitiveTypes = /* @__PURE__ */ new Set(["string", "number", "bigint", "boolean", "symbol", "undefined"]);
  function F(re) {
    return re.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function L(re, le, Oe) {
    const be = new re._zod.constr(le ?? re._zod.def);
    return (!le || Oe != null && Oe.parent) && (be._zod.parent = re), be;
  }
  function _(re) {
    const le = re;
    if (!le)
      return {};
    if (typeof le == "string")
      return { error: () => le };
    if ((le == null ? void 0 : le.message) !== void 0) {
      if ((le == null ? void 0 : le.error) !== void 0)
        throw new Error("Cannot specify both `message` and `error` params");
      le.error = le.message;
    }
    return delete le.message, typeof le.error == "string" ? { ...le, error: () => le.error } : le;
  }
  function U(re) {
    let le;
    return new Proxy({}, {
      get(Oe, be, je) {
        return le ?? (le = re()), Reflect.get(le, be, je);
      },
      set(Oe, be, je, xe) {
        return le ?? (le = re()), Reflect.set(le, be, je, xe);
      },
      has(Oe, be) {
        return le ?? (le = re()), Reflect.has(le, be);
      },
      deleteProperty(Oe, be) {
        return le ?? (le = re()), Reflect.deleteProperty(le, be);
      },
      ownKeys(Oe) {
        return le ?? (le = re()), Reflect.ownKeys(le);
      },
      getOwnPropertyDescriptor(Oe, be) {
        return le ?? (le = re()), Reflect.getOwnPropertyDescriptor(le, be);
      },
      defineProperty(Oe, be, je) {
        return le ?? (le = re()), Reflect.defineProperty(le, be, je);
      }
    });
  }
  function z(re) {
    return typeof re == "bigint" ? re.toString() + "n" : typeof re == "string" ? `"${re}"` : `${re}`;
  }
  function C(re) {
    return Object.keys(re).filter((le) => re[le]._zod.optin === "optional" && re[le]._zod.optout === "optional");
  }
  Xt.NUMBER_FORMAT_RANGES = {
    safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
    int32: [-2147483648, 2147483647],
    uint32: [0, 4294967295],
    float32: [-34028234663852886e22, 34028234663852886e22],
    float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
  }, Xt.BIGINT_FORMAT_RANGES = {
    int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
    uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
  };
  function I(re, le) {
    const Oe = re._zod.def, be = v(re._zod.def, {
      get shape() {
        const je = {};
        for (const xe in le) {
          if (!(xe in Oe.shape))
            throw new Error(`Unrecognized key: "${xe}"`);
          le[xe] && (je[xe] = Oe.shape[xe]);
        }
        return m(this, "shape", je), je;
      },
      checks: []
    });
    return L(re, be);
  }
  function M(re, le) {
    const Oe = re._zod.def, be = v(re._zod.def, {
      get shape() {
        const je = { ...re._zod.def.shape };
        for (const xe in le) {
          if (!(xe in Oe.shape))
            throw new Error(`Unrecognized key: "${xe}"`);
          le[xe] && delete je[xe];
        }
        return m(this, "shape", je), je;
      },
      checks: []
    });
    return L(re, be);
  }
  function D(re, le) {
    if (!k(le))
      throw new Error("Invalid input to extend: expected a plain object");
    const Oe = re._zod.def.checks;
    if (Oe && Oe.length > 0)
      throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
    const je = v(re._zod.def, {
      get shape() {
        const xe = { ...re._zod.def.shape, ...le };
        return m(this, "shape", xe), xe;
      },
      checks: []
    });
    return L(re, je);
  }
  function X(re, le) {
    if (!k(le))
      throw new Error("Invalid input to safeExtend: expected a plain object");
    const Oe = {
      ...re._zod.def,
      get shape() {
        const be = { ...re._zod.def.shape, ...le };
        return m(this, "shape", be), be;
      },
      checks: re._zod.def.checks
    };
    return L(re, Oe);
  }
  function B(re, le) {
    const Oe = v(re._zod.def, {
      get shape() {
        const be = { ...re._zod.def.shape, ...le._zod.def.shape };
        return m(this, "shape", be), be;
      },
      get catchall() {
        return le._zod.def.catchall;
      },
      checks: []
      // delete existing checks
    });
    return L(re, Oe);
  }
  function q(re, le, Oe) {
    const be = v(le._zod.def, {
      get shape() {
        const je = le._zod.def.shape, xe = { ...je };
        if (Oe)
          for (const Q in Oe) {
            if (!(Q in je))
              throw new Error(`Unrecognized key: "${Q}"`);
            Oe[Q] && (xe[Q] = re ? new re({
              type: "optional",
              innerType: je[Q]
            }) : je[Q]);
          }
        else
          for (const Q in je)
            xe[Q] = re ? new re({
              type: "optional",
              innerType: je[Q]
            }) : je[Q];
        return m(this, "shape", xe), xe;
      },
      checks: []
    });
    return L(le, be);
  }
  function H(re, le, Oe) {
    const be = v(le._zod.def, {
      get shape() {
        const je = le._zod.def.shape, xe = { ...je };
        if (Oe)
          for (const Q in Oe) {
            if (!(Q in xe))
              throw new Error(`Unrecognized key: "${Q}"`);
            Oe[Q] && (xe[Q] = new re({
              type: "nonoptional",
              innerType: je[Q]
            }));
          }
        else
          for (const Q in je)
            xe[Q] = new re({
              type: "nonoptional",
              innerType: je[Q]
            });
        return m(this, "shape", xe), xe;
      },
      checks: []
    });
    return L(le, be);
  }
  function Y(re, le = 0) {
    var Oe;
    if (re.aborted === !0)
      return !0;
    for (let be = le; be < re.issues.length; be++)
      if (((Oe = re.issues[be]) == null ? void 0 : Oe.continue) !== !0)
        return !0;
    return !1;
  }
  function J(re, le) {
    return le.map((Oe) => {
      var be;
      return (be = Oe).path ?? (be.path = []), Oe.path.unshift(re), Oe;
    });
  }
  function oe(re) {
    return typeof re == "string" ? re : re == null ? void 0 : re.message;
  }
  function ce(re, le, Oe) {
    var je, xe, Q, ae, Pe, Fe;
    const be = { ...re, path: re.path ?? [] };
    if (!re.message) {
      const Ke = oe((Q = (xe = (je = re.inst) == null ? void 0 : je._zod.def) == null ? void 0 : xe.error) == null ? void 0 : Q.call(xe, re)) ?? oe((ae = le == null ? void 0 : le.error) == null ? void 0 : ae.call(le, re)) ?? oe((Pe = Oe.customError) == null ? void 0 : Pe.call(Oe, re)) ?? oe((Fe = Oe.localeError) == null ? void 0 : Fe.call(Oe, re)) ?? "Invalid input";
      be.message = Ke;
    }
    return delete be.inst, delete be.continue, le != null && le.reportInput || delete be.input, be;
  }
  function fe(re) {
    return re instanceof Set ? "set" : re instanceof Map ? "map" : re instanceof File ? "file" : "unknown";
  }
  function $(re) {
    return Array.isArray(re) ? "array" : typeof re == "string" ? "string" : "unknown";
  }
  function pe(...re) {
    const [le, Oe, be] = re;
    return typeof le == "string" ? {
      message: le,
      code: "custom",
      input: Oe,
      inst: be
    } : { ...le };
  }
  function ee(re) {
    return Object.entries(re).filter(([le, Oe]) => Number.isNaN(Number.parseInt(le, 10))).map((le) => le[1]);
  }
  function Ce(re) {
    const le = atob(re), Oe = new Uint8Array(le.length);
    for (let be = 0; be < le.length; be++)
      Oe[be] = le.charCodeAt(be);
    return Oe;
  }
  function Ee(re) {
    let le = "";
    for (let Oe = 0; Oe < re.length; Oe++)
      le += String.fromCharCode(re[Oe]);
    return btoa(le);
  }
  function Ve(re) {
    const le = re.replace(/-/g, "+").replace(/_/g, "/"), Oe = "=".repeat((4 - le.length % 4) % 4);
    return Ce(le + Oe);
  }
  function et(re) {
    return Ee(re).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  }
  function ft(re) {
    const le = re.replace(/^0x/, "");
    if (le.length % 2 !== 0)
      throw new Error("Invalid hex string length");
    const Oe = new Uint8Array(le.length / 2);
    for (let be = 0; be < le.length; be += 2)
      Oe[be / 2] = Number.parseInt(le.slice(be, be + 2), 16);
    return Oe;
  }
  function me(re) {
    return Array.from(re).map((le) => le.toString(16).padStart(2, "0")).join("");
  }
  class Te {
    constructor(...le) {
    }
  }
  return Xt.Class = Te, Xt;
}
var nge;
function v4e() {
  if (nge) return Xo;
  nge = 1;
  var e = Xo && Xo.__createBinding || (Object.create ? function(f, d, p, h) {
    h === void 0 && (h = p);
    var m = Object.getOwnPropertyDescriptor(d, p);
    (!m || ("get" in m ? !d.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return d[p];
    } }), Object.defineProperty(f, h, m);
  } : function(f, d, p, h) {
    h === void 0 && (h = p), f[h] = d[p];
  }), t = Xo && Xo.__setModuleDefault || (Object.create ? function(f, d) {
    Object.defineProperty(f, "default", { enumerable: !0, value: d });
  } : function(f, d) {
    f.default = d;
  }), n = Xo && Xo.__importStar || function(f) {
    if (f && f.__esModule) return f;
    var d = {};
    if (f != null) for (var p in f) p !== "default" && Object.prototype.hasOwnProperty.call(f, p) && e(d, f, p);
    return t(d, f), d;
  };
  Object.defineProperty(Xo, "__esModule", { value: !0 }), Xo.$ZodRealError = Xo.$ZodError = void 0, Xo.flattenError = s, Xo.formatError = l, Xo.treeifyError = c, Xo.toDotPath = a, Xo.prettifyError = u;
  const r = tP(), i = n(fn()), o = (f, d) => {
    f.name = "$ZodError", Object.defineProperty(f, "_zod", {
      value: f._zod,
      enumerable: !1
    }), Object.defineProperty(f, "issues", {
      value: d,
      enumerable: !1
    }), f.message = JSON.stringify(d, i.jsonStringifyReplacer, 2), Object.defineProperty(f, "toString", {
      value: () => f.message,
      enumerable: !1
    });
  };
  Xo.$ZodError = (0, r.$constructor)("$ZodError", o), Xo.$ZodRealError = (0, r.$constructor)("$ZodError", o, { Parent: Error });
  function s(f, d = (p) => p.message) {
    const p = {}, h = [];
    for (const m of f.issues)
      m.path.length > 0 ? (p[m.path[0]] = p[m.path[0]] || [], p[m.path[0]].push(d(m))) : h.push(d(m));
    return { formErrors: h, fieldErrors: p };
  }
  function l(f, d = (p) => p.message) {
    const p = { _errors: [] }, h = (m) => {
      for (const v of m.issues)
        if (v.code === "invalid_union" && v.errors.length)
          v.errors.map((b) => h({ issues: b }));
        else if (v.code === "invalid_key")
          h({ issues: v.issues });
        else if (v.code === "invalid_element")
          h({ issues: v.issues });
        else if (v.path.length === 0)
          p._errors.push(d(v));
        else {
          let b = p, A = 0;
          for (; A < v.path.length; ) {
            const w = v.path[A];
            A === v.path.length - 1 ? (b[w] = b[w] || { _errors: [] }, b[w]._errors.push(d(v))) : b[w] = b[w] || { _errors: [] }, b = b[w], A++;
          }
        }
    };
    return h(f), p;
  }
  function c(f, d = (p) => p.message) {
    const p = { errors: [] }, h = (m, v = []) => {
      var b, A;
      for (const w of m.issues)
        if (w.code === "invalid_union" && w.errors.length)
          w.errors.map((O) => h({ issues: O }, w.path));
        else if (w.code === "invalid_key")
          h({ issues: w.issues }, w.path);
        else if (w.code === "invalid_element")
          h({ issues: w.issues }, w.path);
        else {
          const O = [...v, ...w.path];
          if (O.length === 0) {
            p.errors.push(d(w));
            continue;
          }
          let x = p, S = 0;
          for (; S < O.length; ) {
            const E = O[S], k = S === O.length - 1;
            typeof E == "string" ? (x.properties ?? (x.properties = {}), (b = x.properties)[E] ?? (b[E] = { errors: [] }), x = x.properties[E]) : (x.items ?? (x.items = []), (A = x.items)[E] ?? (A[E] = { errors: [] }), x = x.items[E]), k && x.errors.push(d(w)), S++;
          }
        }
    };
    return h(f), p;
  }
  function a(f) {
    const d = [], p = f.map((h) => typeof h == "object" ? h.key : h);
    for (const h of p)
      typeof h == "number" ? d.push(`[${h}]`) : typeof h == "symbol" ? d.push(`[${JSON.stringify(String(h))}]`) : /[^\w$]/.test(h) ? d.push(`[${JSON.stringify(h)}]`) : (d.length && d.push("."), d.push(h));
    return d.join("");
  }
  function u(f) {
    var h;
    const d = [], p = [...f.issues].sort((m, v) => (m.path ?? []).length - (v.path ?? []).length);
    for (const m of p)
      d.push(`✖ ${m.message}`), (h = m.path) != null && h.length && d.push(`  → at ${a(m.path)}`);
    return d.join(`
`);
  }
  return Xo;
}
var rge;
function b4e() {
  return rge || (rge = 1, function(e) {
    var t = tp && tp.__createBinding || (Object.create ? function(w, O, x, S) {
      S === void 0 && (S = x);
      var E = Object.getOwnPropertyDescriptor(O, x);
      (!E || ("get" in E ? !O.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return O[x];
      } }), Object.defineProperty(w, S, E);
    } : function(w, O, x, S) {
      S === void 0 && (S = x), w[S] = O[x];
    }), n = tp && tp.__setModuleDefault || (Object.create ? function(w, O) {
      Object.defineProperty(w, "default", { enumerable: !0, value: O });
    } : function(w, O) {
      w.default = O;
    }), r = tp && tp.__importStar || function(w) {
      if (w && w.__esModule) return w;
      var O = {};
      if (w != null) for (var x in w) x !== "default" && Object.prototype.hasOwnProperty.call(w, x) && t(O, w, x);
      return n(O, w), O;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.safeDecodeAsync = e._safeDecodeAsync = e.safeEncodeAsync = e._safeEncodeAsync = e.safeDecode = e._safeDecode = e.safeEncode = e._safeEncode = e.decodeAsync = e._decodeAsync = e.encodeAsync = e._encodeAsync = e.decode = e._decode = e.encode = e._encode = e.safeParseAsync = e._safeParseAsync = e.safeParse = e._safeParse = e.parseAsync = e._parseAsync = e.parse = e._parse = void 0;
    const i = r(tP()), o = r(v4e()), s = r(fn()), l = (w) => (O, x, S, E) => {
      const k = S ? Object.assign(S, { async: !1 }) : { async: !1 }, T = O._zod.run({ value: x, issues: [] }, k);
      if (T instanceof Promise)
        throw new i.$ZodAsyncError();
      if (T.issues.length) {
        const R = new ((E == null ? void 0 : E.Err) ?? w)(T.issues.map((j) => s.finalizeIssue(j, k, i.config())));
        throw s.captureStackTrace(R, E == null ? void 0 : E.callee), R;
      }
      return T.value;
    };
    e._parse = l, e.parse = (0, e._parse)(o.$ZodRealError);
    const c = (w) => async (O, x, S, E) => {
      const k = S ? Object.assign(S, { async: !0 }) : { async: !0 };
      let T = O._zod.run({ value: x, issues: [] }, k);
      if (T instanceof Promise && (T = await T), T.issues.length) {
        const R = new ((E == null ? void 0 : E.Err) ?? w)(T.issues.map((j) => s.finalizeIssue(j, k, i.config())));
        throw s.captureStackTrace(R, E == null ? void 0 : E.callee), R;
      }
      return T.value;
    };
    e._parseAsync = c, e.parseAsync = (0, e._parseAsync)(o.$ZodRealError);
    const a = (w) => (O, x, S) => {
      const E = S ? { ...S, async: !1 } : { async: !1 }, k = O._zod.run({ value: x, issues: [] }, E);
      if (k instanceof Promise)
        throw new i.$ZodAsyncError();
      return k.issues.length ? {
        success: !1,
        error: new (w ?? o.$ZodError)(k.issues.map((T) => s.finalizeIssue(T, E, i.config())))
      } : { success: !0, data: k.value };
    };
    e._safeParse = a, e.safeParse = (0, e._safeParse)(o.$ZodRealError);
    const u = (w) => async (O, x, S) => {
      const E = S ? Object.assign(S, { async: !0 }) : { async: !0 };
      let k = O._zod.run({ value: x, issues: [] }, E);
      return k instanceof Promise && (k = await k), k.issues.length ? {
        success: !1,
        error: new w(k.issues.map((T) => s.finalizeIssue(T, E, i.config())))
      } : { success: !0, data: k.value };
    };
    e._safeParseAsync = u, e.safeParseAsync = (0, e._safeParseAsync)(o.$ZodRealError);
    const f = (w) => (O, x, S) => {
      const E = S ? Object.assign(S, { direction: "backward" }) : { direction: "backward" };
      return (0, e._parse)(w)(O, x, E);
    };
    e._encode = f, e.encode = (0, e._encode)(o.$ZodRealError);
    const d = (w) => (O, x, S) => (0, e._parse)(w)(O, x, S);
    e._decode = d, e.decode = (0, e._decode)(o.$ZodRealError);
    const p = (w) => async (O, x, S) => {
      const E = S ? Object.assign(S, { direction: "backward" }) : { direction: "backward" };
      return (0, e._parseAsync)(w)(O, x, E);
    };
    e._encodeAsync = p, e.encodeAsync = (0, e._encodeAsync)(o.$ZodRealError);
    const h = (w) => async (O, x, S) => (0, e._parseAsync)(w)(O, x, S);
    e._decodeAsync = h, e.decodeAsync = (0, e._decodeAsync)(o.$ZodRealError);
    const m = (w) => (O, x, S) => {
      const E = S ? Object.assign(S, { direction: "backward" }) : { direction: "backward" };
      return (0, e._safeParse)(w)(O, x, E);
    };
    e._safeEncode = m, e.safeEncode = (0, e._safeEncode)(o.$ZodRealError);
    const v = (w) => (O, x, S) => (0, e._safeParse)(w)(O, x, S);
    e._safeDecode = v, e.safeDecode = (0, e._safeDecode)(o.$ZodRealError);
    const b = (w) => async (O, x, S) => {
      const E = S ? Object.assign(S, { direction: "backward" }) : { direction: "backward" };
      return (0, e._safeParseAsync)(w)(O, x, E);
    };
    e._safeEncodeAsync = b, e.safeEncodeAsync = (0, e._safeEncodeAsync)(o.$ZodRealError);
    const A = (w) => async (O, x, S) => (0, e._safeParseAsync)(w)(O, x, S);
    e._safeDecodeAsync = A, e.safeDecodeAsync = (0, e._safeDecodeAsync)(o.$ZodRealError);
  }(tp)), tp;
}
var np = {}, rp = {}, ip = {}, ige;
function KJ() {
  return ige || (ige = 1, function(e) {
    var t = ip && ip.__createBinding || (Object.create ? function(A, w, O, x) {
      x === void 0 && (x = O);
      var S = Object.getOwnPropertyDescriptor(w, O);
      (!S || ("get" in S ? !w.__esModule : S.writable || S.configurable)) && (S = { enumerable: !0, get: function() {
        return w[O];
      } }), Object.defineProperty(A, x, S);
    } : function(A, w, O, x) {
      x === void 0 && (x = O), A[x] = w[O];
    }), n = ip && ip.__setModuleDefault || (Object.create ? function(A, w) {
      Object.defineProperty(A, "default", { enumerable: !0, value: w });
    } : function(A, w) {
      A.default = w;
    }), r = ip && ip.__importStar || function(A) {
      if (A && A.__esModule) return A;
      var w = {};
      if (A != null) for (var O in A) O !== "default" && Object.prototype.hasOwnProperty.call(A, O) && t(w, A, O);
      return n(w, A), w;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.sha384_hex = e.sha256_base64url = e.sha256_base64 = e.sha256_hex = e.sha1_base64url = e.sha1_base64 = e.sha1_hex = e.md5_base64url = e.md5_base64 = e.md5_hex = e.hex = e.uppercase = e.lowercase = e.undefined = e.null = e.boolean = e.number = e.integer = e.bigint = e.string = e.date = e.e164 = e.domain = e.hostname = e.base64url = e.base64 = e.cidrv6 = e.cidrv4 = e.mac = e.ipv6 = e.ipv4 = e.browserEmail = e.idnEmail = e.unicodeEmail = e.rfc5322Email = e.html5Email = e.email = e.uuid7 = e.uuid6 = e.uuid4 = e.uuid = e.guid = e.extendedDuration = e.duration = e.nanoid = e.ksuid = e.xid = e.ulid = e.cuid2 = e.cuid = void 0, e.sha512_base64url = e.sha512_base64 = e.sha512_hex = e.sha384_base64url = e.sha384_base64 = void 0, e.emoji = l, e.time = f, e.datetime = d;
    const i = r(fn());
    e.cuid = /^[cC][^\s-]{8,}$/, e.cuid2 = /^[0-9a-z]+$/, e.ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, e.xid = /^[0-9a-vA-V]{20}$/, e.ksuid = /^[A-Za-z0-9]{27}$/, e.nanoid = /^[a-zA-Z0-9_-]{21}$/, e.duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, e.extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, e.guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
    const o = (A) => A ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${A}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    e.uuid = o, e.uuid4 = (0, e.uuid)(4), e.uuid6 = (0, e.uuid)(6), e.uuid7 = (0, e.uuid)(7), e.email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, e.html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, e.rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, e.unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u, e.idnEmail = e.unicodeEmail, e.browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const s = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
    function l() {
      return new RegExp(s, "u");
    }
    e.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, e.ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
    const c = (A) => {
      const w = i.escapeRegex(A ?? ":");
      return new RegExp(`^(?:[0-9A-F]{2}${w}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${w}){5}[0-9a-f]{2}$`);
    };
    e.mac = c, e.cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, e.cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, e.base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, e.base64url = /^[A-Za-z0-9_-]*$/, e.hostname = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, e.domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, e.e164 = /^\+(?:[0-9]){6,14}[0-9]$/;
    const a = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))";
    e.date = new RegExp(`^${a}$`);
    function u(A) {
      const w = "(?:[01]\\d|2[0-3]):[0-5]\\d";
      return typeof A.precision == "number" ? A.precision === -1 ? `${w}` : A.precision === 0 ? `${w}:[0-5]\\d` : `${w}:[0-5]\\d\\.\\d{${A.precision}}` : `${w}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    }
    function f(A) {
      return new RegExp(`^${u(A)}$`);
    }
    function d(A) {
      const w = u({ precision: A.precision }), O = ["Z"];
      A.local && O.push(""), A.offset && O.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
      const x = `${w}(?:${O.join("|")})`;
      return new RegExp(`^${a}T(?:${x})$`);
    }
    const p = (A) => {
      const w = A ? `[\\s\\S]{${(A == null ? void 0 : A.minimum) ?? 0},${(A == null ? void 0 : A.maximum) ?? ""}}` : "[\\s\\S]*";
      return new RegExp(`^${w}$`);
    };
    e.string = p, e.bigint = /^-?\d+n?$/, e.integer = /^-?\d+$/, e.number = /^-?\d+(?:\.\d+)?/, e.boolean = /^(?:true|false)$/i;
    const h = /^null$/i;
    e.null = h;
    const m = /^undefined$/i;
    e.undefined = m, e.lowercase = /^[^A-Z]*$/, e.uppercase = /^[^a-z]*$/, e.hex = /^[0-9a-fA-F]*$/;
    function v(A, w) {
      return new RegExp(`^[A-Za-z0-9+/]{${A}}${w}$`);
    }
    function b(A) {
      return new RegExp(`^[A-Za-z0-9_-]{${A}}$`);
    }
    e.md5_hex = /^[0-9a-fA-F]{32}$/, e.md5_base64 = v(22, "=="), e.md5_base64url = b(22), e.sha1_hex = /^[0-9a-fA-F]{40}$/, e.sha1_base64 = v(27, "="), e.sha1_base64url = b(27), e.sha256_hex = /^[0-9a-fA-F]{64}$/, e.sha256_base64 = v(43, "="), e.sha256_base64url = b(43), e.sha384_hex = /^[0-9a-fA-F]{96}$/, e.sha384_base64 = v(64, ""), e.sha384_base64url = b(64), e.sha512_hex = /^[0-9a-fA-F]{128}$/, e.sha512_base64 = v(86, "=="), e.sha512_base64url = b(86);
  }(ip)), ip;
}
var oge;
function GJ() {
  return oge || (oge = 1, function(e) {
    var t = rp && rp.__createBinding || (Object.create ? function(a, u, f, d) {
      d === void 0 && (d = f);
      var p = Object.getOwnPropertyDescriptor(u, f);
      (!p || ("get" in p ? !u.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return u[f];
      } }), Object.defineProperty(a, d, p);
    } : function(a, u, f, d) {
      d === void 0 && (d = f), a[d] = u[f];
    }), n = rp && rp.__setModuleDefault || (Object.create ? function(a, u) {
      Object.defineProperty(a, "default", { enumerable: !0, value: u });
    } : function(a, u) {
      a.default = u;
    }), r = rp && rp.__importStar || function(a) {
      if (a && a.__esModule) return a;
      var u = {};
      if (a != null) for (var f in a) f !== "default" && Object.prototype.hasOwnProperty.call(a, f) && t(u, a, f);
      return n(u, a), u;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodCheckOverwrite = e.$ZodCheckMimeType = e.$ZodCheckProperty = e.$ZodCheckEndsWith = e.$ZodCheckStartsWith = e.$ZodCheckIncludes = e.$ZodCheckUpperCase = e.$ZodCheckLowerCase = e.$ZodCheckRegex = e.$ZodCheckStringFormat = e.$ZodCheckLengthEquals = e.$ZodCheckMinLength = e.$ZodCheckMaxLength = e.$ZodCheckSizeEquals = e.$ZodCheckMinSize = e.$ZodCheckMaxSize = e.$ZodCheckBigIntFormat = e.$ZodCheckNumberFormat = e.$ZodCheckMultipleOf = e.$ZodCheckGreaterThan = e.$ZodCheckLessThan = e.$ZodCheck = void 0;
    const i = r(tP()), o = r(KJ()), s = r(fn());
    e.$ZodCheck = i.$constructor("$ZodCheck", (a, u) => {
      var f;
      a._zod ?? (a._zod = {}), a._zod.def = u, (f = a._zod).onattach ?? (f.onattach = []);
    });
    const l = {
      number: "number",
      bigint: "bigint",
      object: "date"
    };
    e.$ZodCheckLessThan = i.$constructor("$ZodCheckLessThan", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = l[typeof u.value];
      a._zod.onattach.push((d) => {
        const p = d._zod.bag, h = (u.inclusive ? p.maximum : p.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        u.value < h && (u.inclusive ? p.maximum = u.value : p.exclusiveMaximum = u.value);
      }), a._zod.check = (d) => {
        (u.inclusive ? d.value <= u.value : d.value < u.value) || d.issues.push({
          origin: f,
          code: "too_big",
          maximum: u.value,
          input: d.value,
          inclusive: u.inclusive,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckGreaterThan = i.$constructor("$ZodCheckGreaterThan", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = l[typeof u.value];
      a._zod.onattach.push((d) => {
        const p = d._zod.bag, h = (u.inclusive ? p.minimum : p.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        u.value > h && (u.inclusive ? p.minimum = u.value : p.exclusiveMinimum = u.value);
      }), a._zod.check = (d) => {
        (u.inclusive ? d.value >= u.value : d.value > u.value) || d.issues.push({
          origin: f,
          code: "too_small",
          minimum: u.value,
          input: d.value,
          inclusive: u.inclusive,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMultipleOf = /* @__PURE__ */ i.$constructor("$ZodCheckMultipleOf", (a, u) => {
      e.$ZodCheck.init(a, u), a._zod.onattach.push((f) => {
        var d;
        (d = f._zod.bag).multipleOf ?? (d.multipleOf = u.value);
      }), a._zod.check = (f) => {
        if (typeof f.value != typeof u.value)
          throw new Error("Cannot mix number and bigint in multiple_of check.");
        (typeof f.value == "bigint" ? f.value % u.value === BigInt(0) : s.floatSafeRemainder(f.value, u.value) === 0) || f.issues.push({
          origin: typeof f.value,
          code: "not_multiple_of",
          divisor: u.value,
          input: f.value,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckNumberFormat = i.$constructor("$ZodCheckNumberFormat", (a, u) => {
      var m;
      e.$ZodCheck.init(a, u), u.format = u.format || "float64";
      const f = (m = u.format) == null ? void 0 : m.includes("int"), d = f ? "int" : "number", [p, h] = s.NUMBER_FORMAT_RANGES[u.format];
      a._zod.onattach.push((v) => {
        const b = v._zod.bag;
        b.format = u.format, b.minimum = p, b.maximum = h, f && (b.pattern = o.integer);
      }), a._zod.check = (v) => {
        const b = v.value;
        if (f) {
          if (!Number.isInteger(b)) {
            v.issues.push({
              expected: d,
              format: u.format,
              code: "invalid_type",
              continue: !1,
              input: b,
              inst: a
            });
            return;
          }
          if (!Number.isSafeInteger(b)) {
            b > 0 ? v.issues.push({
              input: b,
              code: "too_big",
              maximum: Number.MAX_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: a,
              origin: d,
              continue: !u.abort
            }) : v.issues.push({
              input: b,
              code: "too_small",
              minimum: Number.MIN_SAFE_INTEGER,
              note: "Integers must be within the safe integer range.",
              inst: a,
              origin: d,
              continue: !u.abort
            });
            return;
          }
        }
        b < p && v.issues.push({
          origin: "number",
          input: b,
          code: "too_small",
          minimum: p,
          inclusive: !0,
          inst: a,
          continue: !u.abort
        }), b > h && v.issues.push({
          origin: "number",
          input: b,
          code: "too_big",
          maximum: h,
          inst: a
        });
      };
    }), e.$ZodCheckBigIntFormat = i.$constructor("$ZodCheckBigIntFormat", (a, u) => {
      e.$ZodCheck.init(a, u);
      const [f, d] = s.BIGINT_FORMAT_RANGES[u.format];
      a._zod.onattach.push((p) => {
        const h = p._zod.bag;
        h.format = u.format, h.minimum = f, h.maximum = d;
      }), a._zod.check = (p) => {
        const h = p.value;
        h < f && p.issues.push({
          origin: "bigint",
          input: h,
          code: "too_small",
          minimum: f,
          inclusive: !0,
          inst: a,
          continue: !u.abort
        }), h > d && p.issues.push({
          origin: "bigint",
          input: h,
          code: "too_big",
          maximum: d,
          inst: a
        });
      };
    }), e.$ZodCheckMaxSize = i.$constructor("$ZodCheckMaxSize", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.size !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        u.maximum < p && (d._zod.bag.maximum = u.maximum);
      }), a._zod.check = (d) => {
        const p = d.value;
        p.size <= u.maximum || d.issues.push({
          origin: s.getSizableOrigin(p),
          code: "too_big",
          maximum: u.maximum,
          inclusive: !0,
          input: p,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMinSize = i.$constructor("$ZodCheckMinSize", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.size !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        u.minimum > p && (d._zod.bag.minimum = u.minimum);
      }), a._zod.check = (d) => {
        const p = d.value;
        p.size >= u.minimum || d.issues.push({
          origin: s.getSizableOrigin(p),
          code: "too_small",
          minimum: u.minimum,
          inclusive: !0,
          input: p,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckSizeEquals = i.$constructor("$ZodCheckSizeEquals", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.size !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag;
        p.minimum = u.size, p.maximum = u.size, p.size = u.size;
      }), a._zod.check = (d) => {
        const p = d.value, h = p.size;
        if (h === u.size)
          return;
        const m = h > u.size;
        d.issues.push({
          origin: s.getSizableOrigin(p),
          ...m ? { code: "too_big", maximum: u.size } : { code: "too_small", minimum: u.size },
          inclusive: !0,
          exact: !0,
          input: d.value,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMaxLength = i.$constructor("$ZodCheckMaxLength", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.length !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        u.maximum < p && (d._zod.bag.maximum = u.maximum);
      }), a._zod.check = (d) => {
        const p = d.value;
        if (p.length <= u.maximum)
          return;
        const m = s.getLengthableOrigin(p);
        d.issues.push({
          origin: m,
          code: "too_big",
          maximum: u.maximum,
          inclusive: !0,
          input: p,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckMinLength = i.$constructor("$ZodCheckMinLength", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.length !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        u.minimum > p && (d._zod.bag.minimum = u.minimum);
      }), a._zod.check = (d) => {
        const p = d.value;
        if (p.length >= u.minimum)
          return;
        const m = s.getLengthableOrigin(p);
        d.issues.push({
          origin: m,
          code: "too_small",
          minimum: u.minimum,
          inclusive: !0,
          input: p,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckLengthEquals = i.$constructor("$ZodCheckLengthEquals", (a, u) => {
      var f;
      e.$ZodCheck.init(a, u), (f = a._zod.def).when ?? (f.when = (d) => {
        const p = d.value;
        return !s.nullish(p) && p.length !== void 0;
      }), a._zod.onattach.push((d) => {
        const p = d._zod.bag;
        p.minimum = u.length, p.maximum = u.length, p.length = u.length;
      }), a._zod.check = (d) => {
        const p = d.value, h = p.length;
        if (h === u.length)
          return;
        const m = s.getLengthableOrigin(p), v = h > u.length;
        d.issues.push({
          origin: m,
          ...v ? { code: "too_big", maximum: u.length } : { code: "too_small", minimum: u.length },
          inclusive: !0,
          exact: !0,
          input: d.value,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckStringFormat = i.$constructor("$ZodCheckStringFormat", (a, u) => {
      var f, d;
      e.$ZodCheck.init(a, u), a._zod.onattach.push((p) => {
        const h = p._zod.bag;
        h.format = u.format, u.pattern && (h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(u.pattern));
      }), u.pattern ? (f = a._zod).check ?? (f.check = (p) => {
        u.pattern.lastIndex = 0, !u.pattern.test(p.value) && p.issues.push({
          origin: "string",
          code: "invalid_format",
          format: u.format,
          input: p.value,
          ...u.pattern ? { pattern: u.pattern.toString() } : {},
          inst: a,
          continue: !u.abort
        });
      }) : (d = a._zod).check ?? (d.check = () => {
      });
    }), e.$ZodCheckRegex = i.$constructor("$ZodCheckRegex", (a, u) => {
      e.$ZodCheckStringFormat.init(a, u), a._zod.check = (f) => {
        u.pattern.lastIndex = 0, !u.pattern.test(f.value) && f.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "regex",
          input: f.value,
          pattern: u.pattern.toString(),
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckLowerCase = i.$constructor("$ZodCheckLowerCase", (a, u) => {
      u.pattern ?? (u.pattern = o.lowercase), e.$ZodCheckStringFormat.init(a, u);
    }), e.$ZodCheckUpperCase = i.$constructor("$ZodCheckUpperCase", (a, u) => {
      u.pattern ?? (u.pattern = o.uppercase), e.$ZodCheckStringFormat.init(a, u);
    }), e.$ZodCheckIncludes = i.$constructor("$ZodCheckIncludes", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = s.escapeRegex(u.includes), d = new RegExp(typeof u.position == "number" ? `^.{${u.position}}${f}` : f);
      u.pattern = d, a._zod.onattach.push((p) => {
        const h = p._zod.bag;
        h.patterns ?? (h.patterns = /* @__PURE__ */ new Set()), h.patterns.add(d);
      }), a._zod.check = (p) => {
        p.value.includes(u.includes, u.position) || p.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "includes",
          includes: u.includes,
          input: p.value,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckStartsWith = i.$constructor("$ZodCheckStartsWith", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = new RegExp(`^${s.escapeRegex(u.prefix)}.*`);
      u.pattern ?? (u.pattern = f), a._zod.onattach.push((d) => {
        const p = d._zod.bag;
        p.patterns ?? (p.patterns = /* @__PURE__ */ new Set()), p.patterns.add(f);
      }), a._zod.check = (d) => {
        d.value.startsWith(u.prefix) || d.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "starts_with",
          prefix: u.prefix,
          input: d.value,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckEndsWith = i.$constructor("$ZodCheckEndsWith", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = new RegExp(`.*${s.escapeRegex(u.suffix)}$`);
      u.pattern ?? (u.pattern = f), a._zod.onattach.push((d) => {
        const p = d._zod.bag;
        p.patterns ?? (p.patterns = /* @__PURE__ */ new Set()), p.patterns.add(f);
      }), a._zod.check = (d) => {
        d.value.endsWith(u.suffix) || d.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "ends_with",
          suffix: u.suffix,
          input: d.value,
          inst: a,
          continue: !u.abort
        });
      };
    });
    function c(a, u, f) {
      a.issues.length && u.issues.push(...s.prefixIssues(f, a.issues));
    }
    e.$ZodCheckProperty = i.$constructor("$ZodCheckProperty", (a, u) => {
      e.$ZodCheck.init(a, u), a._zod.check = (f) => {
        const d = u.schema._zod.run({
          value: f.value[u.property],
          issues: []
        }, {});
        if (d instanceof Promise)
          return d.then((p) => c(p, f, u.property));
        c(d, f, u.property);
      };
    }), e.$ZodCheckMimeType = i.$constructor("$ZodCheckMimeType", (a, u) => {
      e.$ZodCheck.init(a, u);
      const f = new Set(u.mime);
      a._zod.onattach.push((d) => {
        d._zod.bag.mime = u.mime;
      }), a._zod.check = (d) => {
        f.has(d.value.type) || d.issues.push({
          code: "invalid_value",
          values: u.mime,
          input: d.value.type,
          inst: a,
          continue: !u.abort
        });
      };
    }), e.$ZodCheckOverwrite = i.$constructor("$ZodCheckOverwrite", (a, u) => {
      e.$ZodCheck.init(a, u), a._zod.check = (f) => {
        f.value = u.tx(f.value);
      };
    });
  }(rp)), rp;
}
var ZS = {}, sge;
function O4e() {
  if (sge) return ZS;
  sge = 1, Object.defineProperty(ZS, "__esModule", { value: !0 }), ZS.Doc = void 0;
  class e {
    constructor(n = []) {
      this.content = [], this.indent = 0, this && (this.args = n);
    }
    indented(n) {
      this.indent += 1, n(this), this.indent -= 1;
    }
    write(n) {
      if (typeof n == "function") {
        n(this, { execution: "sync" }), n(this, { execution: "async" });
        return;
      }
      const i = n.split(`
`).filter((l) => l), o = Math.min(...i.map((l) => l.length - l.trimStart().length)), s = i.map((l) => l.slice(o)).map((l) => " ".repeat(this.indent * 2) + l);
      for (const l of s)
        this.content.push(l);
    }
    compile() {
      const n = Function, r = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((s) => `  ${s}`)];
      return new n(...r, o.join(`
`));
    }
  }
  return ZS.Doc = e, ZS;
}
var HS = {}, age;
function A4e() {
  return age || (age = 1, Object.defineProperty(HS, "__esModule", { value: !0 }), HS.version = void 0, HS.version = {
    major: 4,
    minor: 1,
    patch: 13
  }), HS;
}
var lge;
function w4e() {
  return lge || (lge = 1, function(e) {
    var t = np && np.__createBinding || (Object.create ? function(C, I, M, D) {
      D === void 0 && (D = M);
      var X = Object.getOwnPropertyDescriptor(I, M);
      (!X || ("get" in X ? !I.__esModule : X.writable || X.configurable)) && (X = { enumerable: !0, get: function() {
        return I[M];
      } }), Object.defineProperty(C, D, X);
    } : function(C, I, M, D) {
      D === void 0 && (D = M), C[D] = I[M];
    }), n = np && np.__setModuleDefault || (Object.create ? function(C, I) {
      Object.defineProperty(C, "default", { enumerable: !0, value: I });
    } : function(C, I) {
      C.default = I;
    }), r = np && np.__importStar || function(C) {
      if (C && C.__esModule) return C;
      var I = {};
      if (C != null) for (var M in C) M !== "default" && Object.prototype.hasOwnProperty.call(C, M) && t(I, C, M);
      return n(I, C), I;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.$ZodRecord = e.$ZodTuple = e.$ZodIntersection = e.$ZodDiscriminatedUnion = e.$ZodUnion = e.$ZodObjectJIT = e.$ZodObject = e.$ZodArray = e.$ZodDate = e.$ZodVoid = e.$ZodNever = e.$ZodUnknown = e.$ZodAny = e.$ZodNull = e.$ZodUndefined = e.$ZodSymbol = e.$ZodBigIntFormat = e.$ZodBigInt = e.$ZodBoolean = e.$ZodNumberFormat = e.$ZodNumber = e.$ZodCustomStringFormat = e.$ZodJWT = e.$ZodE164 = e.$ZodBase64URL = e.$ZodBase64 = e.$ZodCIDRv6 = e.$ZodCIDRv4 = e.$ZodMAC = e.$ZodIPv6 = e.$ZodIPv4 = e.$ZodISODuration = e.$ZodISOTime = e.$ZodISODate = e.$ZodISODateTime = e.$ZodKSUID = e.$ZodXID = e.$ZodULID = e.$ZodCUID2 = e.$ZodCUID = e.$ZodNanoID = e.$ZodEmoji = e.$ZodURL = e.$ZodEmail = e.$ZodUUID = e.$ZodGUID = e.$ZodStringFormat = e.$ZodString = e.clone = e.$ZodType = void 0, e.$ZodCustom = e.$ZodLazy = e.$ZodPromise = e.$ZodFunction = e.$ZodTemplateLiteral = e.$ZodReadonly = e.$ZodCodec = e.$ZodPipe = e.$ZodNaN = e.$ZodCatch = e.$ZodSuccess = e.$ZodNonOptional = e.$ZodPrefault = e.$ZodDefault = e.$ZodNullable = e.$ZodOptional = e.$ZodTransform = e.$ZodFile = e.$ZodLiteral = e.$ZodEnum = e.$ZodSet = e.$ZodMap = void 0, e.isValidBase64 = d, e.isValidBase64URL = p, e.isValidJWT = h;
    const i = r(GJ()), o = r(tP()), s = O4e(), l = b4e(), c = r(KJ()), a = r(fn()), u = A4e();
    e.$ZodType = o.$constructor("$ZodType", (C, I) => {
      var X;
      var M;
      C ?? (C = {}), C._zod.def = I, C._zod.bag = C._zod.bag || {}, C._zod.version = u.version;
      const D = [...C._zod.def.checks ?? []];
      C._zod.traits.has("$ZodCheck") && D.unshift(C);
      for (const B of D)
        for (const q of B._zod.onattach)
          q(C);
      if (D.length === 0)
        (M = C._zod).deferred ?? (M.deferred = []), (X = C._zod.deferred) == null || X.push(() => {
          C._zod.run = C._zod.parse;
        });
      else {
        const B = (H, Y, J) => {
          let oe = a.aborted(H), ce;
          for (const fe of Y) {
            if (fe._zod.def.when) {
              if (!fe._zod.def.when(H))
                continue;
            } else if (oe)
              continue;
            const $ = H.issues.length, pe = fe._zod.check(H);
            if (pe instanceof Promise && (J == null ? void 0 : J.async) === !1)
              throw new o.$ZodAsyncError();
            if (ce || pe instanceof Promise)
              ce = (ce ?? Promise.resolve()).then(async () => {
                await pe, H.issues.length !== $ && (oe || (oe = a.aborted(H, $)));
              });
            else {
              if (H.issues.length === $)
                continue;
              oe || (oe = a.aborted(H, $));
            }
          }
          return ce ? ce.then(() => H) : H;
        }, q = (H, Y, J) => {
          if (a.aborted(H))
            return H.aborted = !0, H;
          const oe = B(Y, D, J);
          if (oe instanceof Promise) {
            if (J.async === !1)
              throw new o.$ZodAsyncError();
            return oe.then((ce) => C._zod.parse(ce, J));
          }
          return C._zod.parse(oe, J);
        };
        C._zod.run = (H, Y) => {
          if (Y.skipChecks)
            return C._zod.parse(H, Y);
          if (Y.direction === "backward") {
            const oe = C._zod.parse({ value: H.value, issues: [] }, { ...Y, skipChecks: !0 });
            return oe instanceof Promise ? oe.then((ce) => q(ce, H, Y)) : q(oe, H, Y);
          }
          const J = C._zod.parse(H, Y);
          if (J instanceof Promise) {
            if (Y.async === !1)
              throw new o.$ZodAsyncError();
            return J.then((oe) => B(oe, D, Y));
          }
          return B(J, D, Y);
        };
      }
      C["~standard"] = {
        validate: (B) => {
          var q;
          try {
            const H = (0, l.safeParse)(C, B);
            return H.success ? { value: H.data } : { issues: (q = H.error) == null ? void 0 : q.issues };
          } catch {
            return (0, l.safeParseAsync)(C, B).then((Y) => {
              var J;
              return Y.success ? { value: Y.data } : { issues: (J = Y.error) == null ? void 0 : J.issues };
            });
          }
        },
        vendor: "zod",
        version: 1
      };
    });
    var f = fn();
    Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return f.clone;
    } }), e.$ZodString = o.$constructor("$ZodString", (C, I) => {
      var M;
      e.$ZodType.init(C, I), C._zod.pattern = [...((M = C == null ? void 0 : C._zod.bag) == null ? void 0 : M.patterns) ?? []].pop() ?? c.string(C._zod.bag), C._zod.parse = (D, X) => {
        if (I.coerce)
          try {
            D.value = String(D.value);
          } catch {
          }
        return typeof D.value == "string" || D.issues.push({
          expected: "string",
          code: "invalid_type",
          input: D.value,
          inst: C
        }), D;
      };
    }), e.$ZodStringFormat = o.$constructor("$ZodStringFormat", (C, I) => {
      i.$ZodCheckStringFormat.init(C, I), e.$ZodString.init(C, I);
    }), e.$ZodGUID = o.$constructor("$ZodGUID", (C, I) => {
      I.pattern ?? (I.pattern = c.guid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodUUID = o.$constructor("$ZodUUID", (C, I) => {
      if (I.version) {
        const D = {
          v1: 1,
          v2: 2,
          v3: 3,
          v4: 4,
          v5: 5,
          v6: 6,
          v7: 7,
          v8: 8
        }[I.version];
        if (D === void 0)
          throw new Error(`Invalid UUID version: "${I.version}"`);
        I.pattern ?? (I.pattern = c.uuid(D));
      } else
        I.pattern ?? (I.pattern = c.uuid());
      e.$ZodStringFormat.init(C, I);
    }), e.$ZodEmail = o.$constructor("$ZodEmail", (C, I) => {
      I.pattern ?? (I.pattern = c.email), e.$ZodStringFormat.init(C, I);
    }), e.$ZodURL = o.$constructor("$ZodURL", (C, I) => {
      e.$ZodStringFormat.init(C, I), C._zod.check = (M) => {
        try {
          const D = M.value.trim(), X = new URL(D);
          I.hostname && (I.hostname.lastIndex = 0, I.hostname.test(X.hostname) || M.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid hostname",
            pattern: I.hostname.source,
            input: M.value,
            inst: C,
            continue: !I.abort
          })), I.protocol && (I.protocol.lastIndex = 0, I.protocol.test(X.protocol.endsWith(":") ? X.protocol.slice(0, -1) : X.protocol) || M.issues.push({
            code: "invalid_format",
            format: "url",
            note: "Invalid protocol",
            pattern: I.protocol.source,
            input: M.value,
            inst: C,
            continue: !I.abort
          })), I.normalize ? M.value = X.href : M.value = D;
          return;
        } catch {
          M.issues.push({
            code: "invalid_format",
            format: "url",
            input: M.value,
            inst: C,
            continue: !I.abort
          });
        }
      };
    }), e.$ZodEmoji = o.$constructor("$ZodEmoji", (C, I) => {
      I.pattern ?? (I.pattern = c.emoji()), e.$ZodStringFormat.init(C, I);
    }), e.$ZodNanoID = o.$constructor("$ZodNanoID", (C, I) => {
      I.pattern ?? (I.pattern = c.nanoid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodCUID = o.$constructor("$ZodCUID", (C, I) => {
      I.pattern ?? (I.pattern = c.cuid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodCUID2 = o.$constructor("$ZodCUID2", (C, I) => {
      I.pattern ?? (I.pattern = c.cuid2), e.$ZodStringFormat.init(C, I);
    }), e.$ZodULID = o.$constructor("$ZodULID", (C, I) => {
      I.pattern ?? (I.pattern = c.ulid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodXID = o.$constructor("$ZodXID", (C, I) => {
      I.pattern ?? (I.pattern = c.xid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodKSUID = o.$constructor("$ZodKSUID", (C, I) => {
      I.pattern ?? (I.pattern = c.ksuid), e.$ZodStringFormat.init(C, I);
    }), e.$ZodISODateTime = o.$constructor("$ZodISODateTime", (C, I) => {
      I.pattern ?? (I.pattern = c.datetime(I)), e.$ZodStringFormat.init(C, I);
    }), e.$ZodISODate = o.$constructor("$ZodISODate", (C, I) => {
      I.pattern ?? (I.pattern = c.date), e.$ZodStringFormat.init(C, I);
    }), e.$ZodISOTime = o.$constructor("$ZodISOTime", (C, I) => {
      I.pattern ?? (I.pattern = c.time(I)), e.$ZodStringFormat.init(C, I);
    }), e.$ZodISODuration = o.$constructor("$ZodISODuration", (C, I) => {
      I.pattern ?? (I.pattern = c.duration), e.$ZodStringFormat.init(C, I);
    }), e.$ZodIPv4 = o.$constructor("$ZodIPv4", (C, I) => {
      I.pattern ?? (I.pattern = c.ipv4), e.$ZodStringFormat.init(C, I), C._zod.bag.format = "ipv4";
    }), e.$ZodIPv6 = o.$constructor("$ZodIPv6", (C, I) => {
      I.pattern ?? (I.pattern = c.ipv6), e.$ZodStringFormat.init(C, I), C._zod.bag.format = "ipv6", C._zod.check = (M) => {
        try {
          new URL(`http://[${M.value}]`);
        } catch {
          M.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: M.value,
            inst: C,
            continue: !I.abort
          });
        }
      };
    }), e.$ZodMAC = o.$constructor("$ZodMAC", (C, I) => {
      I.pattern ?? (I.pattern = c.mac(I.delimiter)), e.$ZodStringFormat.init(C, I), C._zod.bag.format = "mac";
    }), e.$ZodCIDRv4 = o.$constructor("$ZodCIDRv4", (C, I) => {
      I.pattern ?? (I.pattern = c.cidrv4), e.$ZodStringFormat.init(C, I);
    }), e.$ZodCIDRv6 = o.$constructor("$ZodCIDRv6", (C, I) => {
      I.pattern ?? (I.pattern = c.cidrv6), e.$ZodStringFormat.init(C, I), C._zod.check = (M) => {
        const D = M.value.split("/");
        try {
          if (D.length !== 2)
            throw new Error();
          const [X, B] = D;
          if (!B)
            throw new Error();
          const q = Number(B);
          if (`${q}` !== B)
            throw new Error();
          if (q < 0 || q > 128)
            throw new Error();
          new URL(`http://[${X}]`);
        } catch {
          M.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: M.value,
            inst: C,
            continue: !I.abort
          });
        }
      };
    });
    function d(C) {
      if (C === "")
        return !0;
      if (C.length % 4 !== 0)
        return !1;
      try {
        return atob(C), !0;
      } catch {
        return !1;
      }
    }
    e.$ZodBase64 = o.$constructor("$ZodBase64", (C, I) => {
      I.pattern ?? (I.pattern = c.base64), e.$ZodStringFormat.init(C, I), C._zod.bag.contentEncoding = "base64", C._zod.check = (M) => {
        d(M.value) || M.issues.push({
          code: "invalid_format",
          format: "base64",
          input: M.value,
          inst: C,
          continue: !I.abort
        });
      };
    });
    function p(C) {
      if (!c.base64url.test(C))
        return !1;
      const I = C.replace(/[-_]/g, (D) => D === "-" ? "+" : "/"), M = I.padEnd(Math.ceil(I.length / 4) * 4, "=");
      return d(M);
    }
    e.$ZodBase64URL = o.$constructor("$ZodBase64URL", (C, I) => {
      I.pattern ?? (I.pattern = c.base64url), e.$ZodStringFormat.init(C, I), C._zod.bag.contentEncoding = "base64url", C._zod.check = (M) => {
        p(M.value) || M.issues.push({
          code: "invalid_format",
          format: "base64url",
          input: M.value,
          inst: C,
          continue: !I.abort
        });
      };
    }), e.$ZodE164 = o.$constructor("$ZodE164", (C, I) => {
      I.pattern ?? (I.pattern = c.e164), e.$ZodStringFormat.init(C, I);
    });
    function h(C, I = null) {
      try {
        const M = C.split(".");
        if (M.length !== 3)
          return !1;
        const [D] = M;
        if (!D)
          return !1;
        const X = JSON.parse(atob(D));
        return !("typ" in X && (X == null ? void 0 : X.typ) !== "JWT" || !X.alg || I && (!("alg" in X) || X.alg !== I));
      } catch {
        return !1;
      }
    }
    e.$ZodJWT = o.$constructor("$ZodJWT", (C, I) => {
      e.$ZodStringFormat.init(C, I), C._zod.check = (M) => {
        h(M.value, I.alg) || M.issues.push({
          code: "invalid_format",
          format: "jwt",
          input: M.value,
          inst: C,
          continue: !I.abort
        });
      };
    }), e.$ZodCustomStringFormat = o.$constructor("$ZodCustomStringFormat", (C, I) => {
      e.$ZodStringFormat.init(C, I), C._zod.check = (M) => {
        I.fn(M.value) || M.issues.push({
          code: "invalid_format",
          format: I.format,
          input: M.value,
          inst: C,
          continue: !I.abort
        });
      };
    }), e.$ZodNumber = o.$constructor("$ZodNumber", (C, I) => {
      e.$ZodType.init(C, I), C._zod.pattern = C._zod.bag.pattern ?? c.number, C._zod.parse = (M, D) => {
        if (I.coerce)
          try {
            M.value = Number(M.value);
          } catch {
          }
        const X = M.value;
        if (typeof X == "number" && !Number.isNaN(X) && Number.isFinite(X))
          return M;
        const B = typeof X == "number" ? Number.isNaN(X) ? "NaN" : Number.isFinite(X) ? void 0 : "Infinity" : void 0;
        return M.issues.push({
          expected: "number",
          code: "invalid_type",
          input: X,
          inst: C,
          ...B ? { received: B } : {}
        }), M;
      };
    }), e.$ZodNumberFormat = o.$constructor("$ZodNumberFormat", (C, I) => {
      i.$ZodCheckNumberFormat.init(C, I), e.$ZodNumber.init(C, I);
    }), e.$ZodBoolean = o.$constructor("$ZodBoolean", (C, I) => {
      e.$ZodType.init(C, I), C._zod.pattern = c.boolean, C._zod.parse = (M, D) => {
        if (I.coerce)
          try {
            M.value = !!M.value;
          } catch {
          }
        const X = M.value;
        return typeof X == "boolean" || M.issues.push({
          expected: "boolean",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodBigInt = o.$constructor("$ZodBigInt", (C, I) => {
      e.$ZodType.init(C, I), C._zod.pattern = c.bigint, C._zod.parse = (M, D) => {
        if (I.coerce)
          try {
            M.value = BigInt(M.value);
          } catch {
          }
        return typeof M.value == "bigint" || M.issues.push({
          expected: "bigint",
          code: "invalid_type",
          input: M.value,
          inst: C
        }), M;
      };
    }), e.$ZodBigIntFormat = o.$constructor("$ZodBigIntFormat", (C, I) => {
      i.$ZodCheckBigIntFormat.init(C, I), e.$ZodBigInt.init(C, I);
    }), e.$ZodSymbol = o.$constructor("$ZodSymbol", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        return typeof X == "symbol" || M.issues.push({
          expected: "symbol",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodUndefined = o.$constructor("$ZodUndefined", (C, I) => {
      e.$ZodType.init(C, I), C._zod.pattern = c.undefined, C._zod.values = /* @__PURE__ */ new Set([void 0]), C._zod.optin = "optional", C._zod.optout = "optional", C._zod.parse = (M, D) => {
        const X = M.value;
        return typeof X > "u" || M.issues.push({
          expected: "undefined",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodNull = o.$constructor("$ZodNull", (C, I) => {
      e.$ZodType.init(C, I), C._zod.pattern = c.null, C._zod.values = /* @__PURE__ */ new Set([null]), C._zod.parse = (M, D) => {
        const X = M.value;
        return X === null || M.issues.push({
          expected: "null",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodAny = o.$constructor("$ZodAny", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M) => M;
    }), e.$ZodUnknown = o.$constructor("$ZodUnknown", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M) => M;
    }), e.$ZodNever = o.$constructor("$ZodNever", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => (M.issues.push({
        expected: "never",
        code: "invalid_type",
        input: M.value,
        inst: C
      }), M);
    }), e.$ZodVoid = o.$constructor("$ZodVoid", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        return typeof X > "u" || M.issues.push({
          expected: "void",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodDate = o.$constructor("$ZodDate", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        if (I.coerce)
          try {
            M.value = new Date(M.value);
          } catch {
          }
        const X = M.value, B = X instanceof Date;
        return B && !Number.isNaN(X.getTime()) || M.issues.push({
          expected: "date",
          code: "invalid_type",
          input: X,
          ...B ? { received: "Invalid Date" } : {},
          inst: C
        }), M;
      };
    });
    function m(C, I, M) {
      C.issues.length && I.issues.push(...a.prefixIssues(M, C.issues)), I.value[M] = C.value;
    }
    e.$ZodArray = o.$constructor("$ZodArray", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        if (!Array.isArray(X))
          return M.issues.push({
            expected: "array",
            code: "invalid_type",
            input: X,
            inst: C
          }), M;
        M.value = Array(X.length);
        const B = [];
        for (let q = 0; q < X.length; q++) {
          const H = X[q], Y = I.element._zod.run({
            value: H,
            issues: []
          }, D);
          Y instanceof Promise ? B.push(Y.then((J) => m(J, M, q))) : m(Y, M, q);
        }
        return B.length ? Promise.all(B).then(() => M) : M;
      };
    });
    function v(C, I, M, D) {
      C.issues.length && I.issues.push(...a.prefixIssues(M, C.issues)), C.value === void 0 ? M in D && (I.value[M] = void 0) : I.value[M] = C.value;
    }
    function b(C) {
      var D, X, B, q;
      const I = Object.keys(C.shape);
      for (const H of I)
        if (!((q = (B = (X = (D = C.shape) == null ? void 0 : D[H]) == null ? void 0 : X._zod) == null ? void 0 : B.traits) != null && q.has("$ZodType")))
          throw new Error(`Invalid element at key "${H}": expected a Zod schema`);
      const M = a.optionalKeys(C.shape);
      return {
        ...C,
        keys: I,
        keySet: new Set(I),
        numKeys: I.length,
        optionalKeys: new Set(M)
      };
    }
    function A(C, I, M, D, X, B) {
      const q = [], H = X.keySet, Y = X.catchall._zod, J = Y.def.type;
      for (const oe in I) {
        if (H.has(oe))
          continue;
        if (J === "never") {
          q.push(oe);
          continue;
        }
        const ce = Y.run({ value: I[oe], issues: [] }, D);
        ce instanceof Promise ? C.push(ce.then((fe) => v(fe, M, oe, I))) : v(ce, M, oe, I);
      }
      return q.length && M.issues.push({
        code: "unrecognized_keys",
        keys: q,
        input: I,
        inst: B
      }), C.length ? Promise.all(C).then(() => M) : M;
    }
    e.$ZodObject = o.$constructor("$ZodObject", (C, I) => {
      e.$ZodType.init(C, I);
      const M = Object.getOwnPropertyDescriptor(I, "shape");
      if (!(M != null && M.get)) {
        const H = I.shape;
        Object.defineProperty(I, "shape", {
          get: () => {
            const Y = { ...H };
            return Object.defineProperty(I, "shape", {
              value: Y
            }), Y;
          }
        });
      }
      const D = a.cached(() => b(I));
      a.defineLazy(C._zod, "propValues", () => {
        const H = I.shape, Y = {};
        for (const J in H) {
          const oe = H[J]._zod;
          if (oe.values) {
            Y[J] ?? (Y[J] = /* @__PURE__ */ new Set());
            for (const ce of oe.values)
              Y[J].add(ce);
          }
        }
        return Y;
      });
      const X = a.isObject, B = I.catchall;
      let q;
      C._zod.parse = (H, Y) => {
        q ?? (q = D.value);
        const J = H.value;
        if (!X(J))
          return H.issues.push({
            expected: "object",
            code: "invalid_type",
            input: J,
            inst: C
          }), H;
        H.value = {};
        const oe = [], ce = q.shape;
        for (const fe of q.keys) {
          const pe = ce[fe]._zod.run({ value: J[fe], issues: [] }, Y);
          pe instanceof Promise ? oe.push(pe.then((ee) => v(ee, H, fe, J))) : v(pe, H, fe, J);
        }
        return B ? A(oe, J, H, Y, D.value, C) : oe.length ? Promise.all(oe).then(() => H) : H;
      };
    }), e.$ZodObjectJIT = o.$constructor("$ZodObjectJIT", (C, I) => {
      e.$ZodObject.init(C, I);
      const M = C._zod.parse, D = a.cached(() => b(I)), X = (fe) => {
        const $ = new s.Doc(["shape", "payload", "ctx"]), pe = D.value, ee = (et) => {
          const ft = a.esc(et);
          return `shape[${ft}]._zod.run({ value: input[${ft}], issues: [] }, ctx)`;
        };
        $.write("const input = payload.value;");
        const Ce = /* @__PURE__ */ Object.create(null);
        let Ee = 0;
        for (const et of pe.keys)
          Ce[et] = `key_${Ee++}`;
        $.write("const newResult = {};");
        for (const et of pe.keys) {
          const ft = Ce[et], me = a.esc(et);
          $.write(`const ${ft} = ${ee(et)};`), $.write(`
        if (${ft}.issues.length) {
          payload.issues = payload.issues.concat(${ft}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${me}, ...iss.path] : [${me}]
          })));
        }
        
        
        if (${ft}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${ft}.value;
        }
        
      `);
        }
        $.write("payload.value = newResult;"), $.write("return payload;");
        const Ve = $.compile();
        return (et, ft) => Ve(fe, et, ft);
      };
      let B;
      const q = a.isObject, H = !o.globalConfig.jitless, Y = a.allowsEval, J = H && Y.value, oe = I.catchall;
      let ce;
      C._zod.parse = (fe, $) => {
        ce ?? (ce = D.value);
        const pe = fe.value;
        return q(pe) ? H && J && ($ == null ? void 0 : $.async) === !1 && $.jitless !== !0 ? (B || (B = X(I.shape)), fe = B(fe, $), oe ? A([], pe, fe, $, ce, C) : fe) : M(fe, $) : (fe.issues.push({
          expected: "object",
          code: "invalid_type",
          input: pe,
          inst: C
        }), fe);
      };
    });
    function w(C, I, M, D) {
      for (const B of C)
        if (B.issues.length === 0)
          return I.value = B.value, I;
      const X = C.filter((B) => !a.aborted(B));
      return X.length === 1 ? (I.value = X[0].value, X[0]) : (I.issues.push({
        code: "invalid_union",
        input: I.value,
        inst: M,
        errors: C.map((B) => B.issues.map((q) => a.finalizeIssue(q, D, o.config())))
      }), I);
    }
    e.$ZodUnion = o.$constructor("$ZodUnion", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "optin", () => I.options.some((X) => X._zod.optin === "optional") ? "optional" : void 0), a.defineLazy(C._zod, "optout", () => I.options.some((X) => X._zod.optout === "optional") ? "optional" : void 0), a.defineLazy(C._zod, "values", () => {
        if (I.options.every((X) => X._zod.values))
          return new Set(I.options.flatMap((X) => Array.from(X._zod.values)));
      }), a.defineLazy(C._zod, "pattern", () => {
        if (I.options.every((X) => X._zod.pattern)) {
          const X = I.options.map((B) => B._zod.pattern);
          return new RegExp(`^(${X.map((B) => a.cleanRegex(B.source)).join("|")})$`);
        }
      });
      const M = I.options.length === 1, D = I.options[0]._zod.run;
      C._zod.parse = (X, B) => {
        if (M)
          return D(X, B);
        let q = !1;
        const H = [];
        for (const Y of I.options) {
          const J = Y._zod.run({
            value: X.value,
            issues: []
          }, B);
          if (J instanceof Promise)
            H.push(J), q = !0;
          else {
            if (J.issues.length === 0)
              return J;
            H.push(J);
          }
        }
        return q ? Promise.all(H).then((Y) => w(Y, X, C, B)) : w(H, X, C, B);
      };
    }), e.$ZodDiscriminatedUnion = /* @__PURE__ */ o.$constructor("$ZodDiscriminatedUnion", (C, I) => {
      e.$ZodUnion.init(C, I);
      const M = C._zod.parse;
      a.defineLazy(C._zod, "propValues", () => {
        const X = {};
        for (const B of I.options) {
          const q = B._zod.propValues;
          if (!q || Object.keys(q).length === 0)
            throw new Error(`Invalid discriminated union option at index "${I.options.indexOf(B)}"`);
          for (const [H, Y] of Object.entries(q)) {
            X[H] || (X[H] = /* @__PURE__ */ new Set());
            for (const J of Y)
              X[H].add(J);
          }
        }
        return X;
      });
      const D = a.cached(() => {
        var q;
        const X = I.options, B = /* @__PURE__ */ new Map();
        for (const H of X) {
          const Y = (q = H._zod.propValues) == null ? void 0 : q[I.discriminator];
          if (!Y || Y.size === 0)
            throw new Error(`Invalid discriminated union option at index "${I.options.indexOf(H)}"`);
          for (const J of Y) {
            if (B.has(J))
              throw new Error(`Duplicate discriminator value "${String(J)}"`);
            B.set(J, H);
          }
        }
        return B;
      });
      C._zod.parse = (X, B) => {
        const q = X.value;
        if (!a.isObject(q))
          return X.issues.push({
            code: "invalid_type",
            expected: "object",
            input: q,
            inst: C
          }), X;
        const H = D.value.get(q == null ? void 0 : q[I.discriminator]);
        return H ? H._zod.run(X, B) : I.unionFallback ? M(X, B) : (X.issues.push({
          code: "invalid_union",
          errors: [],
          note: "No matching discriminator",
          discriminator: I.discriminator,
          input: q,
          path: [I.discriminator],
          inst: C
        }), X);
      };
    }), e.$ZodIntersection = o.$constructor("$ZodIntersection", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value, B = I.left._zod.run({ value: X, issues: [] }, D), q = I.right._zod.run({ value: X, issues: [] }, D);
        return B instanceof Promise || q instanceof Promise ? Promise.all([B, q]).then(([Y, J]) => x(M, Y, J)) : x(M, B, q);
      };
    });
    function O(C, I) {
      if (C === I)
        return { valid: !0, data: C };
      if (C instanceof Date && I instanceof Date && +C == +I)
        return { valid: !0, data: C };
      if (a.isPlainObject(C) && a.isPlainObject(I)) {
        const M = Object.keys(I), D = Object.keys(C).filter((B) => M.indexOf(B) !== -1), X = { ...C, ...I };
        for (const B of D) {
          const q = O(C[B], I[B]);
          if (!q.valid)
            return {
              valid: !1,
              mergeErrorPath: [B, ...q.mergeErrorPath]
            };
          X[B] = q.data;
        }
        return { valid: !0, data: X };
      }
      if (Array.isArray(C) && Array.isArray(I)) {
        if (C.length !== I.length)
          return { valid: !1, mergeErrorPath: [] };
        const M = [];
        for (let D = 0; D < C.length; D++) {
          const X = C[D], B = I[D], q = O(X, B);
          if (!q.valid)
            return {
              valid: !1,
              mergeErrorPath: [D, ...q.mergeErrorPath]
            };
          M.push(q.data);
        }
        return { valid: !0, data: M };
      }
      return { valid: !1, mergeErrorPath: [] };
    }
    function x(C, I, M) {
      if (I.issues.length && C.issues.push(...I.issues), M.issues.length && C.issues.push(...M.issues), a.aborted(C))
        return C;
      const D = O(I.value, M.value);
      if (!D.valid)
        throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(D.mergeErrorPath)}`);
      return C.value = D.data, C;
    }
    e.$ZodTuple = o.$constructor("$ZodTuple", (C, I) => {
      e.$ZodType.init(C, I);
      const M = I.items;
      C._zod.parse = (D, X) => {
        const B = D.value;
        if (!Array.isArray(B))
          return D.issues.push({
            input: B,
            inst: C,
            expected: "tuple",
            code: "invalid_type"
          }), D;
        D.value = [];
        const q = [], H = [...M].reverse().findIndex((oe) => oe._zod.optin !== "optional"), Y = H === -1 ? 0 : M.length - H;
        if (!I.rest) {
          const oe = B.length > M.length, ce = B.length < Y - 1;
          if (oe || ce)
            return D.issues.push({
              ...oe ? { code: "too_big", maximum: M.length } : { code: "too_small", minimum: M.length },
              input: B,
              inst: C,
              origin: "array"
            }), D;
        }
        let J = -1;
        for (const oe of M) {
          if (J++, J >= B.length && J >= Y)
            continue;
          const ce = oe._zod.run({
            value: B[J],
            issues: []
          }, X);
          ce instanceof Promise ? q.push(ce.then((fe) => S(fe, D, J))) : S(ce, D, J);
        }
        if (I.rest) {
          const oe = B.slice(M.length);
          for (const ce of oe) {
            J++;
            const fe = I.rest._zod.run({
              value: ce,
              issues: []
            }, X);
            fe instanceof Promise ? q.push(fe.then(($) => S($, D, J))) : S(fe, D, J);
          }
        }
        return q.length ? Promise.all(q).then(() => D) : D;
      };
    });
    function S(C, I, M) {
      C.issues.length && I.issues.push(...a.prefixIssues(M, C.issues)), I.value[M] = C.value;
    }
    e.$ZodRecord = o.$constructor("$ZodRecord", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        if (!a.isPlainObject(X))
          return M.issues.push({
            expected: "record",
            code: "invalid_type",
            input: X,
            inst: C
          }), M;
        const B = [], q = I.keyType._zod.values;
        if (q) {
          M.value = {};
          const H = /* @__PURE__ */ new Set();
          for (const J of q)
            if (typeof J == "string" || typeof J == "number" || typeof J == "symbol") {
              H.add(typeof J == "number" ? J.toString() : J);
              const oe = I.valueType._zod.run({ value: X[J], issues: [] }, D);
              oe instanceof Promise ? B.push(oe.then((ce) => {
                ce.issues.length && M.issues.push(...a.prefixIssues(J, ce.issues)), M.value[J] = ce.value;
              })) : (oe.issues.length && M.issues.push(...a.prefixIssues(J, oe.issues)), M.value[J] = oe.value);
            }
          let Y;
          for (const J in X)
            H.has(J) || (Y = Y ?? [], Y.push(J));
          Y && Y.length > 0 && M.issues.push({
            code: "unrecognized_keys",
            input: X,
            inst: C,
            keys: Y
          });
        } else {
          M.value = {};
          for (const H of Reflect.ownKeys(X)) {
            if (H === "__proto__")
              continue;
            const Y = I.keyType._zod.run({ value: H, issues: [] }, D);
            if (Y instanceof Promise)
              throw new Error("Async schemas not supported in object keys currently");
            if (Y.issues.length) {
              M.issues.push({
                code: "invalid_key",
                origin: "record",
                issues: Y.issues.map((oe) => a.finalizeIssue(oe, D, o.config())),
                input: H,
                path: [H],
                inst: C
              }), M.value[Y.value] = Y.value;
              continue;
            }
            const J = I.valueType._zod.run({ value: X[H], issues: [] }, D);
            J instanceof Promise ? B.push(J.then((oe) => {
              oe.issues.length && M.issues.push(...a.prefixIssues(H, oe.issues)), M.value[Y.value] = oe.value;
            })) : (J.issues.length && M.issues.push(...a.prefixIssues(H, J.issues)), M.value[Y.value] = J.value);
          }
        }
        return B.length ? Promise.all(B).then(() => M) : M;
      };
    }), e.$ZodMap = o.$constructor("$ZodMap", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        if (!(X instanceof Map))
          return M.issues.push({
            expected: "map",
            code: "invalid_type",
            input: X,
            inst: C
          }), M;
        const B = [];
        M.value = /* @__PURE__ */ new Map();
        for (const [q, H] of X) {
          const Y = I.keyType._zod.run({ value: q, issues: [] }, D), J = I.valueType._zod.run({ value: H, issues: [] }, D);
          Y instanceof Promise || J instanceof Promise ? B.push(Promise.all([Y, J]).then(([oe, ce]) => {
            E(oe, ce, M, q, X, C, D);
          })) : E(Y, J, M, q, X, C, D);
        }
        return B.length ? Promise.all(B).then(() => M) : M;
      };
    });
    function E(C, I, M, D, X, B, q) {
      C.issues.length && (a.propertyKeyTypes.has(typeof D) ? M.issues.push(...a.prefixIssues(D, C.issues)) : M.issues.push({
        code: "invalid_key",
        origin: "map",
        input: X,
        inst: B,
        issues: C.issues.map((H) => a.finalizeIssue(H, q, o.config()))
      })), I.issues.length && (a.propertyKeyTypes.has(typeof D) ? M.issues.push(...a.prefixIssues(D, I.issues)) : M.issues.push({
        origin: "map",
        code: "invalid_element",
        input: X,
        inst: B,
        key: D,
        issues: I.issues.map((H) => a.finalizeIssue(H, q, o.config()))
      })), M.value.set(C.value, I.value);
    }
    e.$ZodSet = o.$constructor("$ZodSet", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        if (!(X instanceof Set))
          return M.issues.push({
            input: X,
            inst: C,
            expected: "set",
            code: "invalid_type"
          }), M;
        const B = [];
        M.value = /* @__PURE__ */ new Set();
        for (const q of X) {
          const H = I.valueType._zod.run({ value: q, issues: [] }, D);
          H instanceof Promise ? B.push(H.then((Y) => k(Y, M))) : k(H, M);
        }
        return B.length ? Promise.all(B).then(() => M) : M;
      };
    });
    function k(C, I) {
      C.issues.length && I.issues.push(...C.issues), I.value.add(C.value);
    }
    e.$ZodEnum = o.$constructor("$ZodEnum", (C, I) => {
      e.$ZodType.init(C, I);
      const M = a.getEnumValues(I.entries), D = new Set(M);
      C._zod.values = D, C._zod.pattern = new RegExp(`^(${M.filter((X) => a.propertyKeyTypes.has(typeof X)).map((X) => typeof X == "string" ? a.escapeRegex(X) : X.toString()).join("|")})$`), C._zod.parse = (X, B) => {
        const q = X.value;
        return D.has(q) || X.issues.push({
          code: "invalid_value",
          values: M,
          input: q,
          inst: C
        }), X;
      };
    }), e.$ZodLiteral = o.$constructor("$ZodLiteral", (C, I) => {
      if (e.$ZodType.init(C, I), I.values.length === 0)
        throw new Error("Cannot create literal schema with no valid values");
      const M = new Set(I.values);
      C._zod.values = M, C._zod.pattern = new RegExp(`^(${I.values.map((D) => typeof D == "string" ? a.escapeRegex(D) : D ? a.escapeRegex(D.toString()) : String(D)).join("|")})$`), C._zod.parse = (D, X) => {
        const B = D.value;
        return M.has(B) || D.issues.push({
          code: "invalid_value",
          values: I.values,
          input: B,
          inst: C
        }), D;
      };
    }), e.$ZodFile = o.$constructor("$ZodFile", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        const X = M.value;
        return X instanceof File || M.issues.push({
          expected: "file",
          code: "invalid_type",
          input: X,
          inst: C
        }), M;
      };
    }), e.$ZodTransform = o.$constructor("$ZodTransform", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        if (D.direction === "backward")
          throw new o.$ZodEncodeError(C.constructor.name);
        const X = I.transform(M.value, M);
        if (D.async)
          return (X instanceof Promise ? X : Promise.resolve(X)).then((q) => (M.value = q, M));
        if (X instanceof Promise)
          throw new o.$ZodAsyncError();
        return M.value = X, M;
      };
    });
    function T(C, I) {
      return C.issues.length && I === void 0 ? { issues: [], value: void 0 } : C;
    }
    e.$ZodOptional = o.$constructor("$ZodOptional", (C, I) => {
      e.$ZodType.init(C, I), C._zod.optin = "optional", C._zod.optout = "optional", a.defineLazy(C._zod, "values", () => I.innerType._zod.values ? /* @__PURE__ */ new Set([...I.innerType._zod.values, void 0]) : void 0), a.defineLazy(C._zod, "pattern", () => {
        const M = I.innerType._zod.pattern;
        return M ? new RegExp(`^(${a.cleanRegex(M.source)})?$`) : void 0;
      }), C._zod.parse = (M, D) => {
        if (I.innerType._zod.optin === "optional") {
          const X = I.innerType._zod.run(M, D);
          return X instanceof Promise ? X.then((B) => T(B, M.value)) : T(X, M.value);
        }
        return M.value === void 0 ? M : I.innerType._zod.run(M, D);
      };
    }), e.$ZodNullable = o.$constructor("$ZodNullable", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "optin", () => I.innerType._zod.optin), a.defineLazy(C._zod, "optout", () => I.innerType._zod.optout), a.defineLazy(C._zod, "pattern", () => {
        const M = I.innerType._zod.pattern;
        return M ? new RegExp(`^(${a.cleanRegex(M.source)}|null)$`) : void 0;
      }), a.defineLazy(C._zod, "values", () => I.innerType._zod.values ? /* @__PURE__ */ new Set([...I.innerType._zod.values, null]) : void 0), C._zod.parse = (M, D) => M.value === null ? M : I.innerType._zod.run(M, D);
    }), e.$ZodDefault = o.$constructor("$ZodDefault", (C, I) => {
      e.$ZodType.init(C, I), C._zod.optin = "optional", a.defineLazy(C._zod, "values", () => I.innerType._zod.values), C._zod.parse = (M, D) => {
        if (D.direction === "backward")
          return I.innerType._zod.run(M, D);
        if (M.value === void 0)
          return M.value = I.defaultValue, M;
        const X = I.innerType._zod.run(M, D);
        return X instanceof Promise ? X.then((B) => R(B, I)) : R(X, I);
      };
    });
    function R(C, I) {
      return C.value === void 0 && (C.value = I.defaultValue), C;
    }
    e.$ZodPrefault = o.$constructor("$ZodPrefault", (C, I) => {
      e.$ZodType.init(C, I), C._zod.optin = "optional", a.defineLazy(C._zod, "values", () => I.innerType._zod.values), C._zod.parse = (M, D) => (D.direction === "backward" || M.value === void 0 && (M.value = I.defaultValue), I.innerType._zod.run(M, D));
    }), e.$ZodNonOptional = o.$constructor("$ZodNonOptional", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "values", () => {
        const M = I.innerType._zod.values;
        return M ? new Set([...M].filter((D) => D !== void 0)) : void 0;
      }), C._zod.parse = (M, D) => {
        const X = I.innerType._zod.run(M, D);
        return X instanceof Promise ? X.then((B) => j(B, C)) : j(X, C);
      };
    });
    function j(C, I) {
      return !C.issues.length && C.value === void 0 && C.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: C.value,
        inst: I
      }), C;
    }
    e.$ZodSuccess = o.$constructor("$ZodSuccess", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => {
        if (D.direction === "backward")
          throw new o.$ZodEncodeError("ZodSuccess");
        const X = I.innerType._zod.run(M, D);
        return X instanceof Promise ? X.then((B) => (M.value = B.issues.length === 0, M)) : (M.value = X.issues.length === 0, M);
      };
    }), e.$ZodCatch = o.$constructor("$ZodCatch", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "optin", () => I.innerType._zod.optin), a.defineLazy(C._zod, "optout", () => I.innerType._zod.optout), a.defineLazy(C._zod, "values", () => I.innerType._zod.values), C._zod.parse = (M, D) => {
        if (D.direction === "backward")
          return I.innerType._zod.run(M, D);
        const X = I.innerType._zod.run(M, D);
        return X instanceof Promise ? X.then((B) => (M.value = B.value, B.issues.length && (M.value = I.catchValue({
          ...M,
          error: {
            issues: B.issues.map((q) => a.finalizeIssue(q, D, o.config()))
          },
          input: M.value
        }), M.issues = []), M)) : (M.value = X.value, X.issues.length && (M.value = I.catchValue({
          ...M,
          error: {
            issues: X.issues.map((B) => a.finalizeIssue(B, D, o.config()))
          },
          input: M.value
        }), M.issues = []), M);
      };
    }), e.$ZodNaN = o.$constructor("$ZodNaN", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => ((typeof M.value != "number" || !Number.isNaN(M.value)) && M.issues.push({
        input: M.value,
        inst: C,
        expected: "nan",
        code: "invalid_type"
      }), M);
    }), e.$ZodPipe = o.$constructor("$ZodPipe", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "values", () => I.in._zod.values), a.defineLazy(C._zod, "optin", () => I.in._zod.optin), a.defineLazy(C._zod, "optout", () => I.out._zod.optout), a.defineLazy(C._zod, "propValues", () => I.in._zod.propValues), C._zod.parse = (M, D) => {
        if (D.direction === "backward") {
          const B = I.out._zod.run(M, D);
          return B instanceof Promise ? B.then((q) => F(q, I.in, D)) : F(B, I.in, D);
        }
        const X = I.in._zod.run(M, D);
        return X instanceof Promise ? X.then((B) => F(B, I.out, D)) : F(X, I.out, D);
      };
    });
    function F(C, I, M) {
      return C.issues.length ? (C.aborted = !0, C) : I._zod.run({ value: C.value, issues: C.issues }, M);
    }
    e.$ZodCodec = o.$constructor("$ZodCodec", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "values", () => I.in._zod.values), a.defineLazy(C._zod, "optin", () => I.in._zod.optin), a.defineLazy(C._zod, "optout", () => I.out._zod.optout), a.defineLazy(C._zod, "propValues", () => I.in._zod.propValues), C._zod.parse = (M, D) => {
        if ((D.direction || "forward") === "forward") {
          const B = I.in._zod.run(M, D);
          return B instanceof Promise ? B.then((q) => L(q, I, D)) : L(B, I, D);
        } else {
          const B = I.out._zod.run(M, D);
          return B instanceof Promise ? B.then((q) => L(q, I, D)) : L(B, I, D);
        }
      };
    });
    function L(C, I, M) {
      if (C.issues.length)
        return C.aborted = !0, C;
      if ((M.direction || "forward") === "forward") {
        const X = I.transform(C.value, C);
        return X instanceof Promise ? X.then((B) => _(C, B, I.out, M)) : _(C, X, I.out, M);
      } else {
        const X = I.reverseTransform(C.value, C);
        return X instanceof Promise ? X.then((B) => _(C, B, I.in, M)) : _(C, X, I.in, M);
      }
    }
    function _(C, I, M, D) {
      return C.issues.length ? (C.aborted = !0, C) : M._zod.run({ value: I, issues: C.issues }, D);
    }
    e.$ZodReadonly = o.$constructor("$ZodReadonly", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "propValues", () => I.innerType._zod.propValues), a.defineLazy(C._zod, "values", () => I.innerType._zod.values), a.defineLazy(C._zod, "optin", () => {
        var M, D;
        return (D = (M = I.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.optin;
      }), a.defineLazy(C._zod, "optout", () => {
        var M, D;
        return (D = (M = I.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.optout;
      }), C._zod.parse = (M, D) => {
        if (D.direction === "backward")
          return I.innerType._zod.run(M, D);
        const X = I.innerType._zod.run(M, D);
        return X instanceof Promise ? X.then(U) : U(X);
      };
    });
    function U(C) {
      return C.value = Object.freeze(C.value), C;
    }
    e.$ZodTemplateLiteral = o.$constructor("$ZodTemplateLiteral", (C, I) => {
      e.$ZodType.init(C, I);
      const M = [];
      for (const D of I.parts)
        if (typeof D == "object" && D !== null) {
          if (!D._zod.pattern)
            throw new Error(`Invalid template literal part, no pattern found: ${[...D._zod.traits].shift()}`);
          const X = D._zod.pattern instanceof RegExp ? D._zod.pattern.source : D._zod.pattern;
          if (!X)
            throw new Error(`Invalid template literal part: ${D._zod.traits}`);
          const B = X.startsWith("^") ? 1 : 0, q = X.endsWith("$") ? X.length - 1 : X.length;
          M.push(X.slice(B, q));
        } else if (D === null || a.primitiveTypes.has(typeof D))
          M.push(a.escapeRegex(`${D}`));
        else
          throw new Error(`Invalid template literal part: ${D}`);
      C._zod.pattern = new RegExp(`^${M.join("")}$`), C._zod.parse = (D, X) => typeof D.value != "string" ? (D.issues.push({
        input: D.value,
        inst: C,
        expected: "template_literal",
        code: "invalid_type"
      }), D) : (C._zod.pattern.lastIndex = 0, C._zod.pattern.test(D.value) || D.issues.push({
        input: D.value,
        inst: C,
        code: "invalid_format",
        format: I.format ?? "template_literal",
        pattern: C._zod.pattern.source
      }), D);
    }), e.$ZodFunction = o.$constructor("$ZodFunction", (C, I) => (e.$ZodType.init(C, I), C._def = I, C._zod.def = I, C.implement = (M) => {
      if (typeof M != "function")
        throw new Error("implement() must be called with a function");
      return function(...D) {
        const X = C._def.input ? (0, l.parse)(C._def.input, D) : D, B = Reflect.apply(M, this, X);
        return C._def.output ? (0, l.parse)(C._def.output, B) : B;
      };
    }, C.implementAsync = (M) => {
      if (typeof M != "function")
        throw new Error("implementAsync() must be called with a function");
      return async function(...D) {
        const X = C._def.input ? await (0, l.parseAsync)(C._def.input, D) : D, B = await Reflect.apply(M, this, X);
        return C._def.output ? await (0, l.parseAsync)(C._def.output, B) : B;
      };
    }, C._zod.parse = (M, D) => typeof M.value != "function" ? (M.issues.push({
      code: "invalid_type",
      expected: "function",
      input: M.value,
      inst: C
    }), M) : (C._def.output && C._def.output._zod.def.type === "promise" ? M.value = C.implementAsync(M.value) : M.value = C.implement(M.value), M), C.input = (...M) => {
      const D = C.constructor;
      return Array.isArray(M[0]) ? new D({
        type: "function",
        input: new e.$ZodTuple({
          type: "tuple",
          items: M[0],
          rest: M[1]
        }),
        output: C._def.output
      }) : new D({
        type: "function",
        input: M[0],
        output: C._def.output
      });
    }, C.output = (M) => {
      const D = C.constructor;
      return new D({
        type: "function",
        input: C._def.input,
        output: M
      });
    }, C)), e.$ZodPromise = o.$constructor("$ZodPromise", (C, I) => {
      e.$ZodType.init(C, I), C._zod.parse = (M, D) => Promise.resolve(M.value).then((X) => I.innerType._zod.run({ value: X, issues: [] }, D));
    }), e.$ZodLazy = o.$constructor("$ZodLazy", (C, I) => {
      e.$ZodType.init(C, I), a.defineLazy(C._zod, "innerType", () => I.getter()), a.defineLazy(C._zod, "pattern", () => {
        var M, D;
        return (D = (M = C._zod.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.pattern;
      }), a.defineLazy(C._zod, "propValues", () => {
        var M, D;
        return (D = (M = C._zod.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.propValues;
      }), a.defineLazy(C._zod, "optin", () => {
        var M, D;
        return ((D = (M = C._zod.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.optin) ?? void 0;
      }), a.defineLazy(C._zod, "optout", () => {
        var M, D;
        return ((D = (M = C._zod.innerType) == null ? void 0 : M._zod) == null ? void 0 : D.optout) ?? void 0;
      }), C._zod.parse = (M, D) => C._zod.innerType._zod.run(M, D);
    }), e.$ZodCustom = o.$constructor("$ZodCustom", (C, I) => {
      i.$ZodCheck.init(C, I), e.$ZodType.init(C, I), C._zod.parse = (M, D) => M, C._zod.check = (M) => {
        const D = M.value, X = I.fn(D);
        if (X instanceof Promise)
          return X.then((B) => z(B, M, D, C));
        z(X, M, D, C);
      };
    });
    function z(C, I, M, D) {
      if (!C) {
        const X = {
          code: "custom",
          input: M,
          inst: D,
          // incorporates params.error into issue reporting
          path: [...D._zod.def.path ?? []],
          // incorporates params.error into issue reporting
          continue: !D._zod.def.abort
          // params: inst._zod.def.params,
        };
        D._zod.def.params && (X.params = D._zod.def.params), I.issues.push(a.issue(X));
      }
    }
  }(np)), np;
}
var QS = {}, P1 = { exports: {} }, h0 = P1.exports, cge;
function qln() {
  return cge || (cge = 1, function(e, t) {
    var n = h0 && h0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = h0 && h0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = h0 && h0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "حرف", verb: "أن يحوي" },
        file: { unit: "بايت", verb: "أن يحوي" },
        array: { unit: "عنصر", verb: "أن يحوي" },
        set: { unit: "عنصر", verb: "أن يحوي" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "مدخل",
        email: "بريد إلكتروني",
        url: "رابط",
        emoji: "إيموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاريخ ووقت بمعيار ISO",
        date: "تاريخ بمعيار ISO",
        time: "وقت بمعيار ISO",
        duration: "مدة بمعيار ISO",
        ipv4: "عنوان IPv4",
        ipv6: "عنوان IPv6",
        cidrv4: "مدى عناوين بصيغة IPv4",
        cidrv6: "مدى عناوين بصيغة IPv6",
        base64: "نَص بترميز base64-encoded",
        base64url: "نَص بترميز base64url-encoded",
        json_string: "نَص على هيئة JSON",
        e164: "رقم هاتف بمعيار E.164",
        jwt: "JWT",
        template_literal: "مدخل"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `مدخلات غير مقبولة: يفترض إدخال ${d.expected}، ولكن تم إدخال ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `مدخلات غير مقبولة: يفترض إدخال ${o.stringifyPrimitive(d.values[0])}` : `اختيار غير مقبول: يتوقع انتقاء أحد هذه الخيارات: ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? ` أكبر من اللازم: يفترض أن تكون ${d.origin ?? "القيمة"} ${p} ${d.maximum.toString()} ${h.unit ?? "عنصر"}` : `أكبر من اللازم: يفترض أن تكون ${d.origin ?? "القيمة"} ${p} ${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `أصغر من اللازم: يفترض لـ ${d.origin} أن يكون ${p} ${d.minimum.toString()} ${h.unit}` : `أصغر من اللازم: يفترض لـ ${d.origin} أن يكون ${p} ${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `نَص غير مقبول: يجب أن يبدأ بـ "${d.prefix}"` : p.format === "ends_with" ? `نَص غير مقبول: يجب أن ينتهي بـ "${p.suffix}"` : p.format === "includes" ? `نَص غير مقبول: يجب أن يتضمَّن "${p.includes}"` : p.format === "regex" ? `نَص غير مقبول: يجب أن يطابق النمط ${p.pattern}` : `${f[p.format] ?? d.format} غير مقبول`;
          }
          case "not_multiple_of":
            return `رقم غير مقبول: يجب أن يكون من مضاعفات ${d.divisor}`;
          case "unrecognized_keys":
            return `معرف${d.keys.length > 1 ? "ات" : ""} غريب${d.keys.length > 1 ? "ة" : ""}: ${o.joinValues(d.keys, "، ")}`;
          case "invalid_key":
            return `معرف غير مقبول في ${d.origin}`;
          case "invalid_union":
            return "مدخل غير مقبول";
          case "invalid_element":
            return `مدخل غير مقبول في ${d.origin}`;
          default:
            return "مدخل غير مقبول";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(P1, P1.exports)), P1.exports;
}
var I1 = { exports: {} }, m0 = I1.exports, uge;
function Bln() {
  return uge || (uge = 1, function(e, t) {
    var n = m0 && m0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = m0 && m0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = m0 && m0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "simvol", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "element", verb: "olmalıdır" },
        set: { unit: "element", verb: "olmalıdır" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Yanlış dəyər: gözlənilən ${d.expected}, daxil olan ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Yanlış dəyər: gözlənilən ${o.stringifyPrimitive(d.values[0])}` : `Yanlış seçim: aşağıdakılardan biri olmalıdır: ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Çox böyük: gözlənilən ${d.origin ?? "dəyər"} ${p}${d.maximum.toString()} ${h.unit ?? "element"}` : `Çox böyük: gözlənilən ${d.origin ?? "dəyər"} ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Çox kiçik: gözlənilən ${d.origin} ${p}${d.minimum.toString()} ${h.unit}` : `Çox kiçik: gözlənilən ${d.origin} ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Yanlış mətn: "${p.prefix}" ilə başlamalıdır` : p.format === "ends_with" ? `Yanlış mətn: "${p.suffix}" ilə bitməlidir` : p.format === "includes" ? `Yanlış mətn: "${p.includes}" daxil olmalıdır` : p.format === "regex" ? `Yanlış mətn: ${p.pattern} şablonuna uyğun olmalıdır` : `Yanlış ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Yanlış ədəd: ${d.divisor} ilə bölünə bilən olmalıdır`;
          case "unrecognized_keys":
            return `Tanınmayan açar${d.keys.length > 1 ? "lar" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `${d.origin} daxilində yanlış açar`;
          case "invalid_union":
            return "Yanlış dəyər";
          case "invalid_element":
            return `${d.origin} daxilində yanlış dəyər`;
          default:
            return "Yanlış dəyər";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(I1, I1.exports)), I1.exports;
}
var R1 = { exports: {} }, g0 = R1.exports, dge;
function Xln() {
  return dge || (dge = 1, function(e, t) {
    var n = g0 && g0.__createBinding || (Object.create ? function(a, u, f, d) {
      d === void 0 && (d = f);
      var p = Object.getOwnPropertyDescriptor(u, f);
      (!p || ("get" in p ? !u.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return u[f];
      } }), Object.defineProperty(a, d, p);
    } : function(a, u, f, d) {
      d === void 0 && (d = f), a[d] = u[f];
    }), r = g0 && g0.__setModuleDefault || (Object.create ? function(a, u) {
      Object.defineProperty(a, "default", { enumerable: !0, value: u });
    } : function(a, u) {
      a.default = u;
    }), i = g0 && g0.__importStar || function(a) {
      if (a && a.__esModule) return a;
      var u = {};
      if (a != null) for (var f in a) f !== "default" && Object.prototype.hasOwnProperty.call(a, f) && n(u, a, f);
      return r(u, a), u;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = c;
    const o = i(fn());
    function s(a, u, f, d) {
      const p = Math.abs(a), h = p % 10, m = p % 100;
      return m >= 11 && m <= 19 ? d : h === 1 ? u : h >= 2 && h <= 4 ? f : d;
    }
    const l = () => {
      const a = {
        string: {
          unit: {
            one: "сімвал",
            few: "сімвалы",
            many: "сімвалаў"
          },
          verb: "мець"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элементы",
            many: "элементаў"
          },
          verb: "мець"
        },
        file: {
          unit: {
            one: "байт",
            few: "байты",
            many: "байтаў"
          },
          verb: "мець"
        }
      };
      function u(p) {
        return a[p] ?? null;
      }
      const f = (p) => {
        const h = typeof p;
        switch (h) {
          case "number":
            return Number.isNaN(p) ? "NaN" : "лік";
          case "object": {
            if (Array.isArray(p))
              return "масіў";
            if (p === null)
              return "null";
            if (Object.getPrototypeOf(p) !== Object.prototype && p.constructor)
              return p.constructor.name;
          }
        }
        return h;
      }, d = {
        regex: "увод",
        email: "email адрас",
        url: "URL",
        emoji: "эмодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата і час",
        date: "ISO дата",
        time: "ISO час",
        duration: "ISO працягласць",
        ipv4: "IPv4 адрас",
        ipv6: "IPv6 адрас",
        cidrv4: "IPv4 дыяпазон",
        cidrv6: "IPv6 дыяпазон",
        base64: "радок у фармаце base64",
        base64url: "радок у фармаце base64url",
        json_string: "JSON радок",
        e164: "нумар E.164",
        jwt: "JWT",
        template_literal: "увод"
      };
      return (p) => {
        switch (p.code) {
          case "invalid_type":
            return `Няправільны ўвод: чакаўся ${p.expected}, атрымана ${f(p.input)}`;
          case "invalid_value":
            return p.values.length === 1 ? `Няправільны ўвод: чакалася ${o.stringifyPrimitive(p.values[0])}` : `Няправільны варыянт: чакаўся адзін з ${o.joinValues(p.values, "|")}`;
          case "too_big": {
            const h = p.inclusive ? "<=" : "<", m = u(p.origin);
            if (m) {
              const v = Number(p.maximum), b = s(v, m.unit.one, m.unit.few, m.unit.many);
              return `Занадта вялікі: чакалася, што ${p.origin ?? "значэнне"} павінна ${m.verb} ${h}${p.maximum.toString()} ${b}`;
            }
            return `Занадта вялікі: чакалася, што ${p.origin ?? "значэнне"} павінна быць ${h}${p.maximum.toString()}`;
          }
          case "too_small": {
            const h = p.inclusive ? ">=" : ">", m = u(p.origin);
            if (m) {
              const v = Number(p.minimum), b = s(v, m.unit.one, m.unit.few, m.unit.many);
              return `Занадта малы: чакалася, што ${p.origin} павінна ${m.verb} ${h}${p.minimum.toString()} ${b}`;
            }
            return `Занадта малы: чакалася, што ${p.origin} павінна быць ${h}${p.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = p;
            return h.format === "starts_with" ? `Няправільны радок: павінен пачынацца з "${h.prefix}"` : h.format === "ends_with" ? `Няправільны радок: павінен заканчвацца на "${h.suffix}"` : h.format === "includes" ? `Няправільны радок: павінен змяшчаць "${h.includes}"` : h.format === "regex" ? `Няправільны радок: павінен адпавядаць шаблону ${h.pattern}` : `Няправільны ${d[h.format] ?? p.format}`;
          }
          case "not_multiple_of":
            return `Няправільны лік: павінен быць кратным ${p.divisor}`;
          case "unrecognized_keys":
            return `Нераспазнаны ${p.keys.length > 1 ? "ключы" : "ключ"}: ${o.joinValues(p.keys, ", ")}`;
          case "invalid_key":
            return `Няправільны ключ у ${p.origin}`;
          case "invalid_union":
            return "Няправільны ўвод";
          case "invalid_element":
            return `Няправільнае значэнне ў ${p.origin}`;
          default:
            return "Няправільны ўвод";
        }
      };
    };
    function c() {
      return {
        localeError: l()
      };
    }
    e.exports = t.default;
  }(R1, R1.exports)), R1.exports;
}
var op = {}, fge;
function Wln() {
  return fge || (fge = 1, function(e) {
    var t = op && op.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = op && op.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = op && op.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "число";
        case "object": {
          if (Array.isArray(c))
            return "масив";
          if (c === null)
            return "null";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "символа", verb: "да съдържа" },
        file: { unit: "байта", verb: "да съдържа" },
        array: { unit: "елемента", verb: "да съдържа" },
        set: { unit: "елемента", verb: "да съдържа" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "вход",
        email: "имейл адрес",
        url: "URL",
        emoji: "емоджи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO време",
        date: "ISO дата",
        time: "ISO време",
        duration: "ISO продължителност",
        ipv4: "IPv4 адрес",
        ipv6: "IPv6 адрес",
        cidrv4: "IPv4 диапазон",
        cidrv6: "IPv6 диапазон",
        base64: "base64-кодиран низ",
        base64url: "base64url-кодиран низ",
        json_string: "JSON низ",
        e164: "E.164 номер",
        jwt: "JWT",
        template_literal: "вход"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Невалиден вход: очакван ${f.expected}, получен ${(0, e.parsedType)(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Невалиден вход: очакван ${i.stringifyPrimitive(f.values[0])}` : `Невалидна опция: очаквано едно от ${i.joinValues(f.values, "|")}`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `Твърде голямо: очаква се ${f.origin ?? "стойност"} да съдържа ${d}${f.maximum.toString()} ${p.unit ?? "елемента"}` : `Твърде голямо: очаква се ${f.origin ?? "стойност"} да бъде ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `Твърде малко: очаква се ${f.origin} да съдържа ${d}${f.minimum.toString()} ${p.unit}` : `Твърде малко: очаква се ${f.origin} да бъде ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            if (d.format === "starts_with")
              return `Невалиден низ: трябва да започва с "${d.prefix}"`;
            if (d.format === "ends_with")
              return `Невалиден низ: трябва да завършва с "${d.suffix}"`;
            if (d.format === "includes")
              return `Невалиден низ: трябва да включва "${d.includes}"`;
            if (d.format === "regex")
              return `Невалиден низ: трябва да съвпада с ${d.pattern}`;
            let p = "Невалиден";
            return d.format === "emoji" && (p = "Невалидно"), d.format === "datetime" && (p = "Невалидно"), d.format === "date" && (p = "Невалидна"), d.format === "time" && (p = "Невалидно"), d.format === "duration" && (p = "Невалидна"), `${p} ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Невалидно число: трябва да бъде кратно на ${f.divisor}`;
          case "unrecognized_keys":
            return `Неразпознат${f.keys.length > 1 ? "и" : ""} ключ${f.keys.length > 1 ? "ове" : ""}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Невалиден ключ в ${f.origin}`;
          case "invalid_union":
            return "Невалиден вход";
          case "invalid_element":
            return `Невалидна стойност в ${f.origin}`;
          default:
            return "Невалиден вход";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(op)), op;
}
var M1 = { exports: {} }, y0 = M1.exports, pge;
function Zln() {
  return pge || (pge = 1, function(e, t) {
    var n = y0 && y0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = y0 && y0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = y0 && y0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caràcters", verb: "contenir" },
        file: { unit: "bytes", verb: "contenir" },
        array: { unit: "elements", verb: "contenir" },
        set: { unit: "elements", verb: "contenir" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "entrada",
        email: "adreça electrònica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adreça IPv4",
        ipv6: "adreça IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Tipus invàlid: s'esperava ${d.expected}, s'ha rebut ${u(d.input)}`;
          // return `Tipus invàlid: s'esperava ${issue.expected}, s'ha rebut ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Valor invàlid: s'esperava ${o.stringifyPrimitive(d.values[0])}` : `Opció invàlida: s'esperava una de ${o.joinValues(d.values, " o ")}`;
          case "too_big": {
            const p = d.inclusive ? "com a màxim" : "menys de", h = a(d.origin);
            return h ? `Massa gran: s'esperava que ${d.origin ?? "el valor"} contingués ${p} ${d.maximum.toString()} ${h.unit ?? "elements"}` : `Massa gran: s'esperava que ${d.origin ?? "el valor"} fos ${p} ${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? "com a mínim" : "més de", h = a(d.origin);
            return h ? `Massa petit: s'esperava que ${d.origin} contingués ${p} ${d.minimum.toString()} ${h.unit}` : `Massa petit: s'esperava que ${d.origin} fos ${p} ${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Format invàlid: ha de començar amb "${p.prefix}"` : p.format === "ends_with" ? `Format invàlid: ha d'acabar amb "${p.suffix}"` : p.format === "includes" ? `Format invàlid: ha d'incloure "${p.includes}"` : p.format === "regex" ? `Format invàlid: ha de coincidir amb el patró ${p.pattern}` : `Format invàlid per a ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Número invàlid: ha de ser múltiple de ${d.divisor}`;
          case "unrecognized_keys":
            return `Clau${d.keys.length > 1 ? "s" : ""} no reconeguda${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Clau invàlida a ${d.origin}`;
          case "invalid_union":
            return "Entrada invàlida";
          // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
          case "invalid_element":
            return `Element invàlid a ${d.origin}`;
          default:
            return "Entrada invàlida";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(M1, M1.exports)), M1.exports;
}
var D1 = { exports: {} }, v0 = D1.exports, hge;
function Hln() {
  return hge || (hge = 1, function(e, t) {
    var n = v0 && v0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = v0 && v0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = v0 && v0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "znaků", verb: "mít" },
        file: { unit: "bajtů", verb: "mít" },
        array: { unit: "prvků", verb: "mít" },
        set: { unit: "prvků", verb: "mít" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "číslo";
          case "string":
            return "řetězec";
          case "boolean":
            return "boolean";
          case "bigint":
            return "bigint";
          case "function":
            return "funkce";
          case "symbol":
            return "symbol";
          case "undefined":
            return "undefined";
          case "object": {
            if (Array.isArray(d))
              return "pole";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "regulární výraz",
        email: "e-mailová adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a čas ve formátu ISO",
        date: "datum ve formátu ISO",
        time: "čas ve formátu ISO",
        duration: "doba trvání ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "řetězec zakódovaný ve formátu base64",
        base64url: "řetězec zakódovaný ve formátu base64url",
        json_string: "řetězec ve formátu JSON",
        e164: "číslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Neplatný vstup: očekáváno ${d.expected}, obdrženo ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Neplatný vstup: očekáváno ${o.stringifyPrimitive(d.values[0])}` : `Neplatná možnost: očekávána jedna z hodnot ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Hodnota je příliš velká: ${d.origin ?? "hodnota"} musí mít ${p}${d.maximum.toString()} ${h.unit ?? "prvků"}` : `Hodnota je příliš velká: ${d.origin ?? "hodnota"} musí být ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Hodnota je příliš malá: ${d.origin ?? "hodnota"} musí mít ${p}${d.minimum.toString()} ${h.unit ?? "prvků"}` : `Hodnota je příliš malá: ${d.origin ?? "hodnota"} musí být ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Neplatný řetězec: musí začínat na "${p.prefix}"` : p.format === "ends_with" ? `Neplatný řetězec: musí končit na "${p.suffix}"` : p.format === "includes" ? `Neplatný řetězec: musí obsahovat "${p.includes}"` : p.format === "regex" ? `Neplatný řetězec: musí odpovídat vzoru ${p.pattern}` : `Neplatný formát ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Neplatné číslo: musí být násobkem ${d.divisor}`;
          case "unrecognized_keys":
            return `Neznámé klíče: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Neplatný klíč v ${d.origin}`;
          case "invalid_union":
            return "Neplatný vstup";
          case "invalid_element":
            return `Neplatná hodnota v ${d.origin}`;
          default:
            return "Neplatný vstup";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(D1, D1.exports)), D1.exports;
}
var _1 = { exports: {} }, b0 = _1.exports, mge;
function Qln() {
  return mge || (mge = 1, function(e, t) {
    var n = b0 && b0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = b0 && b0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = b0 && b0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "tegn", verb: "havde" },
        file: { unit: "bytes", verb: "havde" },
        array: { unit: "elementer", verb: "indeholdt" },
        set: { unit: "elementer", verb: "indeholdt" }
      }, a = {
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "sæt",
        file: "fil"
      };
      function u(h) {
        return c[h] ?? null;
      }
      function f(h) {
        return a[h] ?? h;
      }
      const d = (h) => {
        const m = typeof h;
        switch (m) {
          case "number":
            return Number.isNaN(h) ? "NaN" : "tal";
          case "object":
            return Array.isArray(h) ? "liste" : h === null ? "null" : Object.getPrototypeOf(h) !== Object.prototype && h.constructor ? h.constructor.name : "objekt";
        }
        return m;
      }, p = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslæt",
        date: "ISO-dato",
        time: "ISO-klokkeslæt",
        duration: "ISO-varighed",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      };
      return (h) => {
        switch (h.code) {
          case "invalid_type":
            return `Ugyldigt input: forventede ${f(h.expected)}, fik ${f(d(h.input))}`;
          case "invalid_value":
            return h.values.length === 1 ? `Ugyldig værdi: forventede ${o.stringifyPrimitive(h.values[0])}` : `Ugyldigt valg: forventede en af følgende ${o.joinValues(h.values, "|")}`;
          case "too_big": {
            const m = h.inclusive ? "<=" : "<", v = u(h.origin), b = f(h.origin);
            return v ? `For stor: forventede ${b ?? "value"} ${v.verb} ${m} ${h.maximum.toString()} ${v.unit ?? "elementer"}` : `For stor: forventede ${b ?? "value"} havde ${m} ${h.maximum.toString()}`;
          }
          case "too_small": {
            const m = h.inclusive ? ">=" : ">", v = u(h.origin), b = f(h.origin);
            return v ? `For lille: forventede ${b} ${v.verb} ${m} ${h.minimum.toString()} ${v.unit}` : `For lille: forventede ${b} havde ${m} ${h.minimum.toString()}`;
          }
          case "invalid_format": {
            const m = h;
            return m.format === "starts_with" ? `Ugyldig streng: skal starte med "${m.prefix}"` : m.format === "ends_with" ? `Ugyldig streng: skal ende med "${m.suffix}"` : m.format === "includes" ? `Ugyldig streng: skal indeholde "${m.includes}"` : m.format === "regex" ? `Ugyldig streng: skal matche mønsteret ${m.pattern}` : `Ugyldig ${p[m.format] ?? h.format}`;
          }
          case "not_multiple_of":
            return `Ugyldigt tal: skal være deleligt med ${h.divisor}`;
          case "unrecognized_keys":
            return `${h.keys.length > 1 ? "Ukendte nøgler" : "Ukendt nøgle"}: ${o.joinValues(h.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøgle i ${h.origin}`;
          case "invalid_union":
            return "Ugyldigt input: matcher ingen af de tilladte typer";
          case "invalid_element":
            return `Ugyldig værdi i ${h.origin}`;
          default:
            return "Ugyldigt input";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(_1, _1.exports)), _1.exports;
}
var L1 = { exports: {} }, O0 = L1.exports, gge;
function $ln() {
  return gge || (gge = 1, function(e, t) {
    var n = O0 && O0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = O0 && O0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = O0 && O0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "Zeichen", verb: "zu haben" },
        file: { unit: "Bytes", verb: "zu haben" },
        array: { unit: "Elemente", verb: "zu haben" },
        set: { unit: "Elemente", verb: "zu haben" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "Zahl";
          case "object": {
            if (Array.isArray(d))
              return "Array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Ungültige Eingabe: erwartet ${d.expected}, erhalten ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Ungültige Eingabe: erwartet ${o.stringifyPrimitive(d.values[0])}` : `Ungültige Option: erwartet eine von ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Zu groß: erwartet, dass ${d.origin ?? "Wert"} ${p}${d.maximum.toString()} ${h.unit ?? "Elemente"} hat` : `Zu groß: erwartet, dass ${d.origin ?? "Wert"} ${p}${d.maximum.toString()} ist`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Zu klein: erwartet, dass ${d.origin} ${p}${d.minimum.toString()} ${h.unit} hat` : `Zu klein: erwartet, dass ${d.origin} ${p}${d.minimum.toString()} ist`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Ungültiger String: muss mit "${p.prefix}" beginnen` : p.format === "ends_with" ? `Ungültiger String: muss mit "${p.suffix}" enden` : p.format === "includes" ? `Ungültiger String: muss "${p.includes}" enthalten` : p.format === "regex" ? `Ungültiger String: muss dem Muster ${p.pattern} entsprechen` : `Ungültig: ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Ungültige Zahl: muss ein Vielfaches von ${d.divisor} sein`;
          case "unrecognized_keys":
            return `${d.keys.length > 1 ? "Unbekannte Schlüssel" : "Unbekannter Schlüssel"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Ungültiger Schlüssel in ${d.origin}`;
          case "invalid_union":
            return "Ungültige Eingabe";
          case "invalid_element":
            return `Ungültiger Wert in ${d.origin}`;
          default:
            return "Ungültige Eingabe";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(L1, L1.exports)), L1.exports;
}
var sp = {}, yge;
function x4e() {
  return yge || (yge = 1, function(e) {
    var t = sp && sp.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = sp && sp.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = sp && sp.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "number";
        case "object": {
          if (Array.isArray(c))
            return "array";
          if (c === null)
            return "null";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "characters", verb: "to have" },
        file: { unit: "bytes", verb: "to have" },
        array: { unit: "items", verb: "to have" },
        set: { unit: "items", verb: "to have" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Invalid input: expected ${f.expected}, received ${(0, e.parsedType)(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Invalid input: expected ${i.stringifyPrimitive(f.values[0])}` : `Invalid option: expected one of ${i.joinValues(f.values, "|")}`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `Too big: expected ${f.origin ?? "value"} to have ${d}${f.maximum.toString()} ${p.unit ?? "elements"}` : `Too big: expected ${f.origin ?? "value"} to be ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `Too small: expected ${f.origin} to have ${d}${f.minimum.toString()} ${p.unit}` : `Too small: expected ${f.origin} to be ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            return d.format === "starts_with" ? `Invalid string: must start with "${d.prefix}"` : d.format === "ends_with" ? `Invalid string: must end with "${d.suffix}"` : d.format === "includes" ? `Invalid string: must include "${d.includes}"` : d.format === "regex" ? `Invalid string: must match pattern ${d.pattern}` : `Invalid ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Invalid number: must be a multiple of ${f.divisor}`;
          case "unrecognized_keys":
            return `Unrecognized key${f.keys.length > 1 ? "s" : ""}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Invalid key in ${f.origin}`;
          case "invalid_union":
            return "Invalid input";
          case "invalid_element":
            return `Invalid value in ${f.origin}`;
          default:
            return "Invalid input";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(sp)), sp;
}
var ap = {}, vge;
function Kln() {
  return vge || (vge = 1, function(e) {
    var t = ap && ap.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = ap && ap.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = ap && ap.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "nombro";
        case "object": {
          if (Array.isArray(c))
            return "tabelo";
          if (c === null)
            return "senvalora";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "karaktrojn", verb: "havi" },
        file: { unit: "bajtojn", verb: "havi" },
        array: { unit: "elementojn", verb: "havi" },
        set: { unit: "elementojn", verb: "havi" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emoĝio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-daŭro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Nevalida enigo: atendiĝis ${f.expected}, riceviĝis ${(0, e.parsedType)(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Nevalida enigo: atendiĝis ${i.stringifyPrimitive(f.values[0])}` : `Nevalida opcio: atendiĝis unu el ${i.joinValues(f.values, "|")}`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `Tro granda: atendiĝis ke ${f.origin ?? "valoro"} havu ${d}${f.maximum.toString()} ${p.unit ?? "elementojn"}` : `Tro granda: atendiĝis ke ${f.origin ?? "valoro"} havu ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `Tro malgranda: atendiĝis ke ${f.origin} havu ${d}${f.minimum.toString()} ${p.unit}` : `Tro malgranda: atendiĝis ke ${f.origin} estu ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            return d.format === "starts_with" ? `Nevalida karaktraro: devas komenciĝi per "${d.prefix}"` : d.format === "ends_with" ? `Nevalida karaktraro: devas finiĝi per "${d.suffix}"` : d.format === "includes" ? `Nevalida karaktraro: devas inkluzivi "${d.includes}"` : d.format === "regex" ? `Nevalida karaktraro: devas kongrui kun la modelo ${d.pattern}` : `Nevalida ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Nevalida nombro: devas esti oblo de ${f.divisor}`;
          case "unrecognized_keys":
            return `Nekonata${f.keys.length > 1 ? "j" : ""} ŝlosilo${f.keys.length > 1 ? "j" : ""}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Nevalida ŝlosilo en ${f.origin}`;
          case "invalid_union":
            return "Nevalida enigo";
          case "invalid_element":
            return `Nevalida valoro en ${f.origin}`;
          default:
            return "Nevalida enigo";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(ap)), ap;
}
var z1 = { exports: {} }, A0 = z1.exports, bge;
function Gln() {
  return bge || (bge = 1, function(e, t) {
    var n = A0 && A0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = A0 && A0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = A0 && A0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caracteres", verb: "tener" },
        file: { unit: "bytes", verb: "tener" },
        array: { unit: "elementos", verb: "tener" },
        set: { unit: "elementos", verb: "tener" }
      }, a = {
        string: "texto",
        number: "número",
        boolean: "booleano",
        array: "arreglo",
        object: "objeto",
        set: "conjunto",
        file: "archivo",
        date: "fecha",
        bigint: "número grande",
        symbol: "símbolo",
        undefined: "indefinido",
        null: "nulo",
        function: "función",
        map: "mapa",
        record: "registro",
        tuple: "tupla",
        enum: "enumeración",
        union: "unión",
        literal: "literal",
        promise: "promesa",
        void: "vacío",
        never: "nunca",
        unknown: "desconocido",
        any: "cualquiera"
      };
      function u(h) {
        return c[h] ?? null;
      }
      function f(h) {
        return a[h] ?? h;
      }
      const d = (h) => {
        const m = typeof h;
        switch (m) {
          case "number":
            return Number.isNaN(h) ? "NaN" : "number";
          case "object":
            return Array.isArray(h) ? "array" : h === null ? "null" : Object.getPrototypeOf(h) !== Object.prototype ? h.constructor.name : "object";
        }
        return m;
      }, p = {
        regex: "entrada",
        email: "dirección de correo electrónico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duración ISO",
        ipv4: "dirección IPv4",
        ipv6: "dirección IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (h) => {
        switch (h.code) {
          case "invalid_type":
            return `Entrada inválida: se esperaba ${f(h.expected)}, recibido ${f(d(h.input))}`;
          // return `Entrada inválida: se esperaba ${issue.expected}, recibido ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return h.values.length === 1 ? `Entrada inválida: se esperaba ${o.stringifyPrimitive(h.values[0])}` : `Opción inválida: se esperaba una de ${o.joinValues(h.values, "|")}`;
          case "too_big": {
            const m = h.inclusive ? "<=" : "<", v = u(h.origin), b = f(h.origin);
            return v ? `Demasiado grande: se esperaba que ${b ?? "valor"} tuviera ${m}${h.maximum.toString()} ${v.unit ?? "elementos"}` : `Demasiado grande: se esperaba que ${b ?? "valor"} fuera ${m}${h.maximum.toString()}`;
          }
          case "too_small": {
            const m = h.inclusive ? ">=" : ">", v = u(h.origin), b = f(h.origin);
            return v ? `Demasiado pequeño: se esperaba que ${b} tuviera ${m}${h.minimum.toString()} ${v.unit}` : `Demasiado pequeño: se esperaba que ${b} fuera ${m}${h.minimum.toString()}`;
          }
          case "invalid_format": {
            const m = h;
            return m.format === "starts_with" ? `Cadena inválida: debe comenzar con "${m.prefix}"` : m.format === "ends_with" ? `Cadena inválida: debe terminar en "${m.suffix}"` : m.format === "includes" ? `Cadena inválida: debe incluir "${m.includes}"` : m.format === "regex" ? `Cadena inválida: debe coincidir con el patrón ${m.pattern}` : `Inválido ${p[m.format] ?? h.format}`;
          }
          case "not_multiple_of":
            return `Número inválido: debe ser múltiplo de ${h.divisor}`;
          case "unrecognized_keys":
            return `Llave${h.keys.length > 1 ? "s" : ""} desconocida${h.keys.length > 1 ? "s" : ""}: ${o.joinValues(h.keys, ", ")}`;
          case "invalid_key":
            return `Llave inválida en ${f(h.origin)}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido en ${f(h.origin)}`;
          default:
            return "Entrada inválida";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(z1, z1.exports)), z1.exports;
}
var j1 = { exports: {} }, w0 = j1.exports, Oge;
function Yln() {
  return Oge || (Oge = 1, function(e, t) {
    var n = w0 && w0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = w0 && w0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = w0 && w0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "کاراکتر", verb: "داشته باشد" },
        file: { unit: "بایت", verb: "داشته باشد" },
        array: { unit: "آیتم", verb: "داشته باشد" },
        set: { unit: "آیتم", verb: "داشته باشد" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "عدد";
          case "object": {
            if (Array.isArray(d))
              return "آرایه";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ورودی",
        email: "آدرس ایمیل",
        url: "URL",
        emoji: "ایموجی",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "تاریخ و زمان ایزو",
        date: "تاریخ ایزو",
        time: "زمان ایزو",
        duration: "مدت زمان ایزو",
        ipv4: "IPv4 آدرس",
        ipv6: "IPv6 آدرس",
        cidrv4: "IPv4 دامنه",
        cidrv6: "IPv6 دامنه",
        base64: "base64-encoded رشته",
        base64url: "base64url-encoded رشته",
        json_string: "JSON رشته",
        e164: "E.164 عدد",
        jwt: "JWT",
        template_literal: "ورودی"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `ورودی نامعتبر: می‌بایست ${d.expected} می‌بود، ${u(d.input)} دریافت شد`;
          case "invalid_value":
            return d.values.length === 1 ? `ورودی نامعتبر: می‌بایست ${o.stringifyPrimitive(d.values[0])} می‌بود` : `گزینه نامعتبر: می‌بایست یکی از ${o.joinValues(d.values, "|")} می‌بود`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `خیلی بزرگ: ${d.origin ?? "مقدار"} باید ${p}${d.maximum.toString()} ${h.unit ?? "عنصر"} باشد` : `خیلی بزرگ: ${d.origin ?? "مقدار"} باید ${p}${d.maximum.toString()} باشد`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `خیلی کوچک: ${d.origin} باید ${p}${d.minimum.toString()} ${h.unit} باشد` : `خیلی کوچک: ${d.origin} باید ${p}${d.minimum.toString()} باشد`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `رشته نامعتبر: باید با "${p.prefix}" شروع شود` : p.format === "ends_with" ? `رشته نامعتبر: باید با "${p.suffix}" تمام شود` : p.format === "includes" ? `رشته نامعتبر: باید شامل "${p.includes}" باشد` : p.format === "regex" ? `رشته نامعتبر: باید با الگوی ${p.pattern} مطابقت داشته باشد` : `${f[p.format] ?? d.format} نامعتبر`;
          }
          case "not_multiple_of":
            return `عدد نامعتبر: باید مضرب ${d.divisor} باشد`;
          case "unrecognized_keys":
            return `کلید${d.keys.length > 1 ? "های" : ""} ناشناس: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `کلید ناشناس در ${d.origin}`;
          case "invalid_union":
            return "ورودی نامعتبر";
          case "invalid_element":
            return `مقدار نامعتبر در ${d.origin}`;
          default:
            return "ورودی نامعتبر";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(j1, j1.exports)), j1.exports;
}
var F1 = { exports: {} }, x0 = F1.exports, Age;
function Jln() {
  return Age || (Age = 1, function(e, t) {
    var n = x0 && x0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = x0 && x0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = x0 && x0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "merkkiä", subject: "merkkijonon" },
        file: { unit: "tavua", subject: "tiedoston" },
        array: { unit: "alkiota", subject: "listan" },
        set: { unit: "alkiota", subject: "joukon" },
        number: { unit: "", subject: "luvun" },
        bigint: { unit: "", subject: "suuren kokonaisluvun" },
        int: { unit: "", subject: "kokonaisluvun" },
        date: { unit: "", subject: "päivämäärän" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "säännöllinen lauseke",
        email: "sähköpostiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-päivämäärä",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Virheellinen tyyppi: odotettiin ${d.expected}, oli ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Virheellinen syöte: täytyy olla ${o.stringifyPrimitive(d.values[0])}` : `Virheellinen valinta: täytyy olla yksi seuraavista: ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Liian suuri: ${h.subject} täytyy olla ${p}${d.maximum.toString()} ${h.unit}`.trim() : `Liian suuri: arvon täytyy olla ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Liian pieni: ${h.subject} täytyy olla ${p}${d.minimum.toString()} ${h.unit}`.trim() : `Liian pieni: arvon täytyy olla ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Virheellinen syöte: täytyy alkaa "${p.prefix}"` : p.format === "ends_with" ? `Virheellinen syöte: täytyy loppua "${p.suffix}"` : p.format === "includes" ? `Virheellinen syöte: täytyy sisältää "${p.includes}"` : p.format === "regex" ? `Virheellinen syöte: täytyy vastata säännöllistä lauseketta ${p.pattern}` : `Virheellinen ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Virheellinen luku: täytyy olla luvun ${d.divisor} monikerta`;
          case "unrecognized_keys":
            return `${d.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return "Virheellinen avain tietueessa";
          case "invalid_union":
            return "Virheellinen unioni";
          case "invalid_element":
            return "Virheellinen arvo joukossa";
          default:
            return "Virheellinen syöte";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(F1, F1.exports)), F1.exports;
}
var U1 = { exports: {} }, S0 = U1.exports, wge;
function ecn() {
  return wge || (wge = 1, function(e, t) {
    var n = S0 && S0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = S0 && S0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = S0 && S0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "nombre";
          case "object": {
            if (Array.isArray(d))
              return "tableau";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "entrée",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Entrée invalide : ${d.expected} attendu, ${u(d.input)} reçu`;
          case "invalid_value":
            return d.values.length === 1 ? `Entrée invalide : ${o.stringifyPrimitive(d.values[0])} attendu` : `Option invalide : une valeur parmi ${o.joinValues(d.values, "|")} attendue`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Trop grand : ${d.origin ?? "valeur"} doit ${h.verb} ${p}${d.maximum.toString()} ${h.unit ?? "élément(s)"}` : `Trop grand : ${d.origin ?? "valeur"} doit être ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Trop petit : ${d.origin} doit ${h.verb} ${p}${d.minimum.toString()} ${h.unit}` : `Trop petit : ${d.origin} doit être ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Chaîne invalide : doit commencer par "${p.prefix}"` : p.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${p.suffix}"` : p.format === "includes" ? `Chaîne invalide : doit inclure "${p.includes}"` : p.format === "regex" ? `Chaîne invalide : doit correspondre au modèle ${p.pattern}` : `${f[p.format] ?? d.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${d.divisor}`;
          case "unrecognized_keys":
            return `Clé${d.keys.length > 1 ? "s" : ""} non reconnue${d.keys.length > 1 ? "s" : ""} : ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${d.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${d.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(U1, U1.exports)), U1.exports;
}
var V1 = { exports: {} }, E0 = V1.exports, xge;
function tcn() {
  return xge || (xge = 1, function(e, t) {
    var n = E0 && E0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = E0 && E0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = E0 && E0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caractères", verb: "avoir" },
        file: { unit: "octets", verb: "avoir" },
        array: { unit: "éléments", verb: "avoir" },
        set: { unit: "éléments", verb: "avoir" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "entrée",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "durée ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "chaîne encodée en base64",
        base64url: "chaîne encodée en base64url",
        json_string: "chaîne JSON",
        e164: "numéro E.164",
        jwt: "JWT",
        template_literal: "entrée"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Entrée invalide : attendu ${d.expected}, reçu ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Entrée invalide : attendu ${o.stringifyPrimitive(d.values[0])}` : `Option invalide : attendu l'une des valeurs suivantes ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "≤" : "<", h = a(d.origin);
            return h ? `Trop grand : attendu que ${d.origin ?? "la valeur"} ait ${p}${d.maximum.toString()} ${h.unit}` : `Trop grand : attendu que ${d.origin ?? "la valeur"} soit ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? "≥" : ">", h = a(d.origin);
            return h ? `Trop petit : attendu que ${d.origin} ait ${p}${d.minimum.toString()} ${h.unit}` : `Trop petit : attendu que ${d.origin} soit ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Chaîne invalide : doit commencer par "${p.prefix}"` : p.format === "ends_with" ? `Chaîne invalide : doit se terminer par "${p.suffix}"` : p.format === "includes" ? `Chaîne invalide : doit inclure "${p.includes}"` : p.format === "regex" ? `Chaîne invalide : doit correspondre au motif ${p.pattern}` : `${f[p.format] ?? d.format} invalide`;
          }
          case "not_multiple_of":
            return `Nombre invalide : doit être un multiple de ${d.divisor}`;
          case "unrecognized_keys":
            return `Clé${d.keys.length > 1 ? "s" : ""} non reconnue${d.keys.length > 1 ? "s" : ""} : ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Clé invalide dans ${d.origin}`;
          case "invalid_union":
            return "Entrée invalide";
          case "invalid_element":
            return `Valeur invalide dans ${d.origin}`;
          default:
            return "Entrée invalide";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(V1, V1.exports)), V1.exports;
}
var q1 = { exports: {} }, T0 = q1.exports, Sge;
function ncn() {
  return Sge || (Sge = 1, function(e, t) {
    var n = T0 && T0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = T0 && T0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = T0 && T0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { label: "מחרוזת", gender: "f" },
        number: { label: "מספר", gender: "m" },
        boolean: { label: "ערך בוליאני", gender: "m" },
        bigint: { label: "BigInt", gender: "m" },
        date: { label: "תאריך", gender: "m" },
        array: { label: "מערך", gender: "m" },
        object: { label: "אובייקט", gender: "m" },
        null: { label: "ערך ריק (null)", gender: "m" },
        undefined: { label: "ערך לא מוגדר (undefined)", gender: "m" },
        symbol: { label: "סימבול (Symbol)", gender: "m" },
        function: { label: "פונקציה", gender: "f" },
        map: { label: "מפה (Map)", gender: "f" },
        set: { label: "קבוצה (Set)", gender: "f" },
        file: { label: "קובץ", gender: "m" },
        promise: { label: "Promise", gender: "m" },
        NaN: { label: "NaN", gender: "m" },
        unknown: { label: "ערך לא ידוע", gender: "m" },
        value: { label: "ערך", gender: "m" }
      }, a = {
        string: { unit: "תווים", shortLabel: "קצר", longLabel: "ארוך" },
        file: { unit: "בייטים", shortLabel: "קטן", longLabel: "גדול" },
        array: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
        set: { unit: "פריטים", shortLabel: "קטן", longLabel: "גדול" },
        number: { unit: "", shortLabel: "קטן", longLabel: "גדול" }
        // no unit
      }, u = (b) => b ? c[b] : void 0, f = (b) => {
        const A = u(b);
        return A ? A.label : b ?? c.unknown.label;
      }, d = (b) => `ה${f(b)}`, p = (b) => {
        const A = u(b);
        return ((A == null ? void 0 : A.gender) ?? "m") === "f" ? "צריכה להיות" : "צריך להיות";
      }, h = (b) => b ? a[b] ?? null : null, m = (b) => {
        const A = typeof b;
        switch (A) {
          case "number":
            return Number.isNaN(b) ? "NaN" : "number";
          case "object":
            return Array.isArray(b) ? "array" : b === null ? "null" : Object.getPrototypeOf(b) !== Object.prototype && b.constructor ? b.constructor.name : "object";
          default:
            return A;
        }
      }, v = {
        regex: { label: "קלט", gender: "m" },
        email: { label: "כתובת אימייל", gender: "f" },
        url: { label: "כתובת רשת", gender: "f" },
        emoji: { label: "אימוג'י", gender: "m" },
        uuid: { label: "UUID", gender: "m" },
        nanoid: { label: "nanoid", gender: "m" },
        guid: { label: "GUID", gender: "m" },
        cuid: { label: "cuid", gender: "m" },
        cuid2: { label: "cuid2", gender: "m" },
        ulid: { label: "ULID", gender: "m" },
        xid: { label: "XID", gender: "m" },
        ksuid: { label: "KSUID", gender: "m" },
        datetime: { label: "תאריך וזמן ISO", gender: "m" },
        date: { label: "תאריך ISO", gender: "m" },
        time: { label: "זמן ISO", gender: "m" },
        duration: { label: "משך זמן ISO", gender: "m" },
        ipv4: { label: "כתובת IPv4", gender: "f" },
        ipv6: { label: "כתובת IPv6", gender: "f" },
        cidrv4: { label: "טווח IPv4", gender: "m" },
        cidrv6: { label: "טווח IPv6", gender: "m" },
        base64: { label: "מחרוזת בבסיס 64", gender: "f" },
        base64url: { label: "מחרוזת בבסיס 64 לכתובות רשת", gender: "f" },
        json_string: { label: "מחרוזת JSON", gender: "f" },
        e164: { label: "מספר E.164", gender: "m" },
        jwt: { label: "JWT", gender: "m" },
        ends_with: { label: "קלט", gender: "m" },
        includes: { label: "קלט", gender: "m" },
        lowercase: { label: "קלט", gender: "m" },
        starts_with: { label: "קלט", gender: "m" },
        uppercase: { label: "קלט", gender: "m" }
      };
      return (b) => {
        var A;
        switch (b.code) {
          case "invalid_type": {
            const w = b.expected, O = f(w), x = m(b.input), S = ((A = c[x]) == null ? void 0 : A.label) ?? x;
            return `קלט לא תקין: צריך להיות ${O}, התקבל ${S}`;
          }
          case "invalid_value": {
            if (b.values.length === 1)
              return `ערך לא תקין: הערך חייב להיות ${o.stringifyPrimitive(b.values[0])}`;
            const w = b.values.map((S) => o.stringifyPrimitive(S));
            if (b.values.length === 2)
              return `ערך לא תקין: האפשרויות המתאימות הן ${w[0]} או ${w[1]}`;
            const O = w[w.length - 1];
            return `ערך לא תקין: האפשרויות המתאימות הן ${w.slice(0, -1).join(", ")} או ${O}`;
          }
          case "too_big": {
            const w = h(b.origin), O = d(b.origin ?? "value");
            if (b.origin === "string")
              return `${(w == null ? void 0 : w.longLabel) ?? "ארוך"} מדי: ${O} צריכה להכיל ${b.maximum.toString()} ${(w == null ? void 0 : w.unit) ?? ""} ${b.inclusive ? "או פחות" : "לכל היותר"}`.trim();
            if (b.origin === "number") {
              const E = b.inclusive ? `קטן או שווה ל-${b.maximum}` : `קטן מ-${b.maximum}`;
              return `גדול מדי: ${O} צריך להיות ${E}`;
            }
            if (b.origin === "array" || b.origin === "set") {
              const E = b.origin === "set" ? "צריכה" : "צריך", k = b.inclusive ? `${b.maximum} ${(w == null ? void 0 : w.unit) ?? ""} או פחות` : `פחות מ-${b.maximum} ${(w == null ? void 0 : w.unit) ?? ""}`;
              return `גדול מדי: ${O} ${E} להכיל ${k}`.trim();
            }
            const x = b.inclusive ? "<=" : "<", S = p(b.origin ?? "value");
            return w != null && w.unit ? `${w.longLabel} מדי: ${O} ${S} ${x}${b.maximum.toString()} ${w.unit}` : `${(w == null ? void 0 : w.longLabel) ?? "גדול"} מדי: ${O} ${S} ${x}${b.maximum.toString()}`;
          }
          case "too_small": {
            const w = h(b.origin), O = d(b.origin ?? "value");
            if (b.origin === "string")
              return `${(w == null ? void 0 : w.shortLabel) ?? "קצר"} מדי: ${O} צריכה להכיל ${b.minimum.toString()} ${(w == null ? void 0 : w.unit) ?? ""} ${b.inclusive ? "או יותר" : "לפחות"}`.trim();
            if (b.origin === "number") {
              const E = b.inclusive ? `גדול או שווה ל-${b.minimum}` : `גדול מ-${b.minimum}`;
              return `קטן מדי: ${O} צריך להיות ${E}`;
            }
            if (b.origin === "array" || b.origin === "set") {
              const E = b.origin === "set" ? "צריכה" : "צריך";
              if (b.minimum === 1 && b.inclusive) {
                const T = (b.origin === "set", "לפחות פריט אחד");
                return `קטן מדי: ${O} ${E} להכיל ${T}`;
              }
              const k = b.inclusive ? `${b.minimum} ${(w == null ? void 0 : w.unit) ?? ""} או יותר` : `יותר מ-${b.minimum} ${(w == null ? void 0 : w.unit) ?? ""}`;
              return `קטן מדי: ${O} ${E} להכיל ${k}`.trim();
            }
            const x = b.inclusive ? ">=" : ">", S = p(b.origin ?? "value");
            return w != null && w.unit ? `${w.shortLabel} מדי: ${O} ${S} ${x}${b.minimum.toString()} ${w.unit}` : `${(w == null ? void 0 : w.shortLabel) ?? "קטן"} מדי: ${O} ${S} ${x}${b.minimum.toString()}`;
          }
          case "invalid_format": {
            const w = b;
            if (w.format === "starts_with")
              return `המחרוזת חייבת להתחיל ב "${w.prefix}"`;
            if (w.format === "ends_with")
              return `המחרוזת חייבת להסתיים ב "${w.suffix}"`;
            if (w.format === "includes")
              return `המחרוזת חייבת לכלול "${w.includes}"`;
            if (w.format === "regex")
              return `המחרוזת חייבת להתאים לתבנית ${w.pattern}`;
            const O = v[w.format], x = (O == null ? void 0 : O.label) ?? w.format, E = ((O == null ? void 0 : O.gender) ?? "m") === "f" ? "תקינה" : "תקין";
            return `${x} לא ${E}`;
          }
          case "not_multiple_of":
            return `מספר לא תקין: חייב להיות מכפלה של ${b.divisor}`;
          case "unrecognized_keys":
            return `מפתח${b.keys.length > 1 ? "ות" : ""} לא מזוה${b.keys.length > 1 ? "ים" : "ה"}: ${o.joinValues(b.keys, ", ")}`;
          case "invalid_key":
            return "שדה לא תקין באובייקט";
          case "invalid_union":
            return "קלט לא תקין";
          case "invalid_element":
            return `ערך לא תקין ב${d(b.origin ?? "array")}`;
          default:
            return "קלט לא תקין";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(q1, q1.exports)), q1.exports;
}
var B1 = { exports: {} }, k0 = B1.exports, Ege;
function rcn() {
  return Ege || (Ege = 1, function(e, t) {
    var n = k0 && k0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = k0 && k0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = k0 && k0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "karakter", verb: "legyen" },
        file: { unit: "byte", verb: "legyen" },
        array: { unit: "elem", verb: "legyen" },
        set: { unit: "elem", verb: "legyen" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "szám";
          case "object": {
            if (Array.isArray(d))
              return "tömb";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "bemenet",
        email: "email cím",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO időbélyeg",
        date: "ISO dátum",
        time: "ISO idő",
        duration: "ISO időintervallum",
        ipv4: "IPv4 cím",
        ipv6: "IPv6 cím",
        cidrv4: "IPv4 tartomány",
        cidrv6: "IPv6 tartomány",
        base64: "base64-kódolt string",
        base64url: "base64url-kódolt string",
        json_string: "JSON string",
        e164: "E.164 szám",
        jwt: "JWT",
        template_literal: "bemenet"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Érvénytelen bemenet: a várt érték ${d.expected}, a kapott érték ${u(d.input)}`;
          // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Érvénytelen bemenet: a várt érték ${o.stringifyPrimitive(d.values[0])}` : `Érvénytelen opció: valamelyik érték várt ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Túl nagy: ${d.origin ?? "érték"} mérete túl nagy ${p}${d.maximum.toString()} ${h.unit ?? "elem"}` : `Túl nagy: a bemeneti érték ${d.origin ?? "érték"} túl nagy: ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Túl kicsi: a bemeneti érték ${d.origin} mérete túl kicsi ${p}${d.minimum.toString()} ${h.unit}` : `Túl kicsi: a bemeneti érték ${d.origin} túl kicsi ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Érvénytelen string: "${p.prefix}" értékkel kell kezdődnie` : p.format === "ends_with" ? `Érvénytelen string: "${p.suffix}" értékkel kell végződnie` : p.format === "includes" ? `Érvénytelen string: "${p.includes}" értéket kell tartalmaznia` : p.format === "regex" ? `Érvénytelen string: ${p.pattern} mintának kell megfelelnie` : `Érvénytelen ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Érvénytelen szám: ${d.divisor} többszörösének kell lennie`;
          case "unrecognized_keys":
            return `Ismeretlen kulcs${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Érvénytelen kulcs ${d.origin}`;
          case "invalid_union":
            return "Érvénytelen bemenet";
          case "invalid_element":
            return `Érvénytelen érték: ${d.origin}`;
          default:
            return "Érvénytelen bemenet";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(B1, B1.exports)), B1.exports;
}
var X1 = { exports: {} }, C0 = X1.exports, Tge;
function icn() {
  return Tge || (Tge = 1, function(e, t) {
    var n = C0 && C0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = C0 && C0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = C0 && C0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "karakter", verb: "memiliki" },
        file: { unit: "byte", verb: "memiliki" },
        array: { unit: "item", verb: "memiliki" },
        set: { unit: "item", verb: "memiliki" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Input tidak valid: diharapkan ${d.expected}, diterima ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Input tidak valid: diharapkan ${o.stringifyPrimitive(d.values[0])}` : `Pilihan tidak valid: diharapkan salah satu dari ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Terlalu besar: diharapkan ${d.origin ?? "value"} memiliki ${p}${d.maximum.toString()} ${h.unit ?? "elemen"}` : `Terlalu besar: diharapkan ${d.origin ?? "value"} menjadi ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Terlalu kecil: diharapkan ${d.origin} memiliki ${p}${d.minimum.toString()} ${h.unit}` : `Terlalu kecil: diharapkan ${d.origin} menjadi ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `String tidak valid: harus dimulai dengan "${p.prefix}"` : p.format === "ends_with" ? `String tidak valid: harus berakhir dengan "${p.suffix}"` : p.format === "includes" ? `String tidak valid: harus menyertakan "${p.includes}"` : p.format === "regex" ? `String tidak valid: harus sesuai pola ${p.pattern}` : `${f[p.format] ?? d.format} tidak valid`;
          }
          case "not_multiple_of":
            return `Angka tidak valid: harus kelipatan dari ${d.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali ${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak valid di ${d.origin}`;
          case "invalid_union":
            return "Input tidak valid";
          case "invalid_element":
            return `Nilai tidak valid di ${d.origin}`;
          default:
            return "Input tidak valid";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(X1, X1.exports)), X1.exports;
}
var lp = {}, kge;
function ocn() {
  return kge || (kge = 1, function(e) {
    var t = lp && lp.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = lp && lp.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = lp && lp.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "númer";
        case "object": {
          if (Array.isArray(c))
            return "fylki";
          if (c === null)
            return "null";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "stafi", verb: "að hafa" },
        file: { unit: "bæti", verb: "að hafa" },
        array: { unit: "hluti", verb: "að hafa" },
        set: { unit: "hluti", verb: "að hafa" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "gildi",
        email: "netfang",
        url: "vefslóð",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og tími",
        date: "ISO dagsetning",
        time: "ISO tími",
        duration: "ISO tímalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 tölugildi",
        jwt: "JWT",
        template_literal: "gildi"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Rangt gildi: Þú slóst inn ${(0, e.parsedType)(f.input)} þar sem á að vera ${f.expected}`;
          case "invalid_value":
            return f.values.length === 1 ? `Rangt gildi: gert ráð fyrir ${i.stringifyPrimitive(f.values[0])}` : `Ógilt val: má vera eitt af eftirfarandi ${i.joinValues(f.values, "|")}`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `Of stórt: gert er ráð fyrir að ${f.origin ?? "gildi"} hafi ${d}${f.maximum.toString()} ${p.unit ?? "hluti"}` : `Of stórt: gert er ráð fyrir að ${f.origin ?? "gildi"} sé ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `Of lítið: gert er ráð fyrir að ${f.origin} hafi ${d}${f.minimum.toString()} ${p.unit}` : `Of lítið: gert er ráð fyrir að ${f.origin} sé ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            return d.format === "starts_with" ? `Ógildur strengur: verður að byrja á "${d.prefix}"` : d.format === "ends_with" ? `Ógildur strengur: verður að enda á "${d.suffix}"` : d.format === "includes" ? `Ógildur strengur: verður að innihalda "${d.includes}"` : d.format === "regex" ? `Ógildur strengur: verður að fylgja mynstri ${d.pattern}` : `Rangt ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Röng tala: verður að vera margfeldi af ${f.divisor}`;
          case "unrecognized_keys":
            return `Óþekkt ${f.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `Rangur lykill í ${f.origin}`;
          case "invalid_union":
            return "Rangt gildi";
          case "invalid_element":
            return `Rangt gildi í ${f.origin}`;
          default:
            return "Rangt gildi";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(lp)), lp;
}
var W1 = { exports: {} }, N0 = W1.exports, Cge;
function scn() {
  return Cge || (Cge = 1, function(e, t) {
    var n = N0 && N0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = N0 && N0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = N0 && N0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caratteri", verb: "avere" },
        file: { unit: "byte", verb: "avere" },
        array: { unit: "elementi", verb: "avere" },
        set: { unit: "elementi", verb: "avere" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "numero";
          case "object": {
            if (Array.isArray(d))
              return "vettore";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Input non valido: atteso ${d.expected}, ricevuto ${u(d.input)}`;
          // return `Input non valido: atteso ${issue.expected}, ricevuto ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Input non valido: atteso ${o.stringifyPrimitive(d.values[0])}` : `Opzione non valida: atteso uno tra ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Troppo grande: ${d.origin ?? "valore"} deve avere ${p}${d.maximum.toString()} ${h.unit ?? "elementi"}` : `Troppo grande: ${d.origin ?? "valore"} deve essere ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Troppo piccolo: ${d.origin} deve avere ${p}${d.minimum.toString()} ${h.unit}` : `Troppo piccolo: ${d.origin} deve essere ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Stringa non valida: deve iniziare con "${p.prefix}"` : p.format === "ends_with" ? `Stringa non valida: deve terminare con "${p.suffix}"` : p.format === "includes" ? `Stringa non valida: deve includere "${p.includes}"` : p.format === "regex" ? `Stringa non valida: deve corrispondere al pattern ${p.pattern}` : `Invalid ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Numero non valido: deve essere un multiplo di ${d.divisor}`;
          case "unrecognized_keys":
            return `Chiav${d.keys.length > 1 ? "i" : "e"} non riconosciut${d.keys.length > 1 ? "e" : "a"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Chiave non valida in ${d.origin}`;
          case "invalid_union":
            return "Input non valido";
          case "invalid_element":
            return `Valore non valido in ${d.origin}`;
          default:
            return "Input non valido";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(W1, W1.exports)), W1.exports;
}
var Z1 = { exports: {} }, P0 = Z1.exports, Nge;
function acn() {
  return Nge || (Nge = 1, function(e, t) {
    var n = P0 && P0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = P0 && P0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = P0 && P0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "文字", verb: "である" },
        file: { unit: "バイト", verb: "である" },
        array: { unit: "要素", verb: "である" },
        set: { unit: "要素", verb: "である" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "数値";
          case "object": {
            if (Array.isArray(d))
              return "配列";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "入力値",
        email: "メールアドレス",
        url: "URL",
        emoji: "絵文字",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日時",
        date: "ISO日付",
        time: "ISO時刻",
        duration: "ISO期間",
        ipv4: "IPv4アドレス",
        ipv6: "IPv6アドレス",
        cidrv4: "IPv4範囲",
        cidrv6: "IPv6範囲",
        base64: "base64エンコード文字列",
        base64url: "base64urlエンコード文字列",
        json_string: "JSON文字列",
        e164: "E.164番号",
        jwt: "JWT",
        template_literal: "入力値"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `無効な入力: ${d.expected}が期待されましたが、${u(d.input)}が入力されました`;
          case "invalid_value":
            return d.values.length === 1 ? `無効な入力: ${o.stringifyPrimitive(d.values[0])}が期待されました` : `無効な選択: ${o.joinValues(d.values, "、")}のいずれかである必要があります`;
          case "too_big": {
            const p = d.inclusive ? "以下である" : "より小さい", h = a(d.origin);
            return h ? `大きすぎる値: ${d.origin ?? "値"}は${d.maximum.toString()}${h.unit ?? "要素"}${p}必要があります` : `大きすぎる値: ${d.origin ?? "値"}は${d.maximum.toString()}${p}必要があります`;
          }
          case "too_small": {
            const p = d.inclusive ? "以上である" : "より大きい", h = a(d.origin);
            return h ? `小さすぎる値: ${d.origin}は${d.minimum.toString()}${h.unit}${p}必要があります` : `小さすぎる値: ${d.origin}は${d.minimum.toString()}${p}必要があります`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `無効な文字列: "${p.prefix}"で始まる必要があります` : p.format === "ends_with" ? `無効な文字列: "${p.suffix}"で終わる必要があります` : p.format === "includes" ? `無効な文字列: "${p.includes}"を含む必要があります` : p.format === "regex" ? `無効な文字列: パターン${p.pattern}に一致する必要があります` : `無効な${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `無効な数値: ${d.divisor}の倍数である必要があります`;
          case "unrecognized_keys":
            return `認識されていないキー${d.keys.length > 1 ? "群" : ""}: ${o.joinValues(d.keys, "、")}`;
          case "invalid_key":
            return `${d.origin}内の無効なキー`;
          case "invalid_union":
            return "無効な入力";
          case "invalid_element":
            return `${d.origin}内の無効な値`;
          default:
            return "無効な入力";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(Z1, Z1.exports)), Z1.exports;
}
var cp = {}, Pge;
function lcn() {
  return Pge || (Pge = 1, function(e) {
    var t = cp && cp.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = cp && cp.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = cp && cp.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "რიცხვი";
        case "object": {
          if (Array.isArray(c))
            return "მასივი";
          if (c === null)
            return "null";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return {
        string: "სტრინგი",
        boolean: "ბულეანი",
        undefined: "undefined",
        bigint: "bigint",
        symbol: "symbol",
        function: "ფუნქცია"
      }[a] ?? a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "სიმბოლო", verb: "უნდა შეიცავდეს" },
        file: { unit: "ბაიტი", verb: "უნდა შეიცავდეს" },
        array: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" },
        set: { unit: "ელემენტი", verb: "უნდა შეიცავდეს" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "შეყვანა",
        email: "ელ-ფოსტის მისამართი",
        url: "URL",
        emoji: "ემოჯი",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "თარიღი-დრო",
        date: "თარიღი",
        time: "დრო",
        duration: "ხანგრძლივობა",
        ipv4: "IPv4 მისამართი",
        ipv6: "IPv6 მისამართი",
        cidrv4: "IPv4 დიაპაზონი",
        cidrv6: "IPv6 დიაპაზონი",
        base64: "base64-კოდირებული სტრინგი",
        base64url: "base64url-კოდირებული სტრინგი",
        json_string: "JSON სტრინგი",
        e164: "E.164 ნომერი",
        jwt: "JWT",
        template_literal: "შეყვანა"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `არასწორი შეყვანა: მოსალოდნელი ${f.expected}, მიღებული ${(0, e.parsedType)(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `არასწორი შეყვანა: მოსალოდნელი ${i.stringifyPrimitive(f.values[0])}` : `არასწორი ვარიანტი: მოსალოდნელია ერთ-ერთი ${i.joinValues(f.values, "|")}-დან`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `ზედმეტად დიდი: მოსალოდნელი ${f.origin ?? "მნიშვნელობა"} ${p.verb} ${d}${f.maximum.toString()} ${p.unit}` : `ზედმეტად დიდი: მოსალოდნელი ${f.origin ?? "მნიშვნელობა"} იყოს ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `ზედმეტად პატარა: მოსალოდნელი ${f.origin} ${p.verb} ${d}${f.minimum.toString()} ${p.unit}` : `ზედმეტად პატარა: მოსალოდნელი ${f.origin} იყოს ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            return d.format === "starts_with" ? `არასწორი სტრინგი: უნდა იწყებოდეს "${d.prefix}"-ით` : d.format === "ends_with" ? `არასწორი სტრინგი: უნდა მთავრდებოდეს "${d.suffix}"-ით` : d.format === "includes" ? `არასწორი სტრინგი: უნდა შეიცავდეს "${d.includes}"-ს` : d.format === "regex" ? `არასწორი სტრინგი: უნდა შეესაბამებოდეს შაბლონს ${d.pattern}` : `არასწორი ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `არასწორი რიცხვი: უნდა იყოს ${f.divisor}-ის ჯერადი`;
          case "unrecognized_keys":
            return `უცნობი გასაღებ${f.keys.length > 1 ? "ები" : "ი"}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `არასწორი გასაღები ${f.origin}-ში`;
          case "invalid_union":
            return "არასწორი შეყვანა";
          case "invalid_element":
            return `არასწორი მნიშვნელობა ${f.origin}-ში`;
          default:
            return "არასწორი შეყვანა";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(cp)), cp;
}
var H1 = { exports: {} }, Q1 = { exports: {} }, I0 = Q1.exports, Ige;
function S4e() {
  return Ige || (Ige = 1, function(e, t) {
    var n = I0 && I0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = I0 && I0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = I0 && I0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "តួអក្សរ", verb: "គួរមាន" },
        file: { unit: "បៃ", verb: "គួរមាន" },
        array: { unit: "ធាតុ", verb: "គួរមាន" },
        set: { unit: "ធាតុ", verb: "គួរមាន" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "មិនមែនជាលេខ (NaN)" : "លេខ";
          case "object": {
            if (Array.isArray(d))
              return "អារេ (Array)";
            if (d === null)
              return "គ្មានតម្លៃ (null)";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ទិន្នន័យបញ្ចូល",
        email: "អាសយដ្ឋានអ៊ីមែល",
        url: "URL",
        emoji: "សញ្ញាអារម្មណ៍",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "កាលបរិច្ឆេទ និងម៉ោង ISO",
        date: "កាលបរិច្ឆេទ ISO",
        time: "ម៉ោង ISO",
        duration: "រយៈពេល ISO",
        ipv4: "អាសយដ្ឋាន IPv4",
        ipv6: "អាសយដ្ឋាន IPv6",
        cidrv4: "ដែនអាសយដ្ឋាន IPv4",
        cidrv6: "ដែនអាសយដ្ឋាន IPv6",
        base64: "ខ្សែអក្សរអ៊ិកូដ base64",
        base64url: "ខ្សែអក្សរអ៊ិកូដ base64url",
        json_string: "ខ្សែអក្សរ JSON",
        e164: "លេខ E.164",
        jwt: "JWT",
        template_literal: "ទិន្នន័យបញ្ចូល"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${d.expected} ប៉ុន្តែទទួលបាន ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `ទិន្នន័យបញ្ចូលមិនត្រឹមត្រូវ៖ ត្រូវការ ${o.stringifyPrimitive(d.values[0])}` : `ជម្រើសមិនត្រឹមត្រូវ៖ ត្រូវជាមួយក្នុងចំណោម ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `ធំពេក៖ ត្រូវការ ${d.origin ?? "តម្លៃ"} ${p} ${d.maximum.toString()} ${h.unit ?? "ធាតុ"}` : `ធំពេក៖ ត្រូវការ ${d.origin ?? "តម្លៃ"} ${p} ${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `តូចពេក៖ ត្រូវការ ${d.origin} ${p} ${d.minimum.toString()} ${h.unit}` : `តូចពេក៖ ត្រូវការ ${d.origin} ${p} ${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវចាប់ផ្តើមដោយ "${p.prefix}"` : p.format === "ends_with" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវបញ្ចប់ដោយ "${p.suffix}"` : p.format === "includes" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវមាន "${p.includes}"` : p.format === "regex" ? `ខ្សែអក្សរមិនត្រឹមត្រូវ៖ ត្រូវតែផ្គូផ្គងនឹងទម្រង់ដែលបានកំណត់ ${p.pattern}` : `មិនត្រឹមត្រូវ៖ ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `លេខមិនត្រឹមត្រូវ៖ ត្រូវតែជាពហុគុណនៃ ${d.divisor}`;
          case "unrecognized_keys":
            return `រកឃើញសោមិនស្គាល់៖ ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `សោមិនត្រឹមត្រូវនៅក្នុង ${d.origin}`;
          case "invalid_union":
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
          case "invalid_element":
            return `ទិន្នន័យមិនត្រឹមត្រូវនៅក្នុង ${d.origin}`;
          default:
            return "ទិន្នន័យមិនត្រឹមត្រូវ";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(Q1, Q1.exports)), Q1.exports;
}
var Rge = H1.exports, Mge;
function ccn() {
  return Mge || (Mge = 1, function(e, t) {
    var n = Rge && Rge.__importDefault || function(o) {
      return o && o.__esModule ? o : { default: o };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = i;
    const r = n(S4e());
    function i() {
      return (0, r.default)();
    }
    e.exports = t.default;
  }(H1, H1.exports)), H1.exports;
}
var $1 = { exports: {} }, R0 = $1.exports, Dge;
function ucn() {
  return Dge || (Dge = 1, function(e, t) {
    var n = R0 && R0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = R0 && R0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = R0 && R0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "문자", verb: "to have" },
        file: { unit: "바이트", verb: "to have" },
        array: { unit: "개", verb: "to have" },
        set: { unit: "개", verb: "to have" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "입력",
        email: "이메일 주소",
        url: "URL",
        emoji: "이모지",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 날짜시간",
        date: "ISO 날짜",
        time: "ISO 시간",
        duration: "ISO 기간",
        ipv4: "IPv4 주소",
        ipv6: "IPv6 주소",
        cidrv4: "IPv4 범위",
        cidrv6: "IPv6 범위",
        base64: "base64 인코딩 문자열",
        base64url: "base64url 인코딩 문자열",
        json_string: "JSON 문자열",
        e164: "E.164 번호",
        jwt: "JWT",
        template_literal: "입력"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `잘못된 입력: 예상 타입은 ${d.expected}, 받은 타입은 ${u(d.input)}입니다`;
          case "invalid_value":
            return d.values.length === 1 ? `잘못된 입력: 값은 ${o.stringifyPrimitive(d.values[0])} 이어야 합니다` : `잘못된 옵션: ${o.joinValues(d.values, "또는 ")} 중 하나여야 합니다`;
          case "too_big": {
            const p = d.inclusive ? "이하" : "미만", h = p === "미만" ? "이어야 합니다" : "여야 합니다", m = a(d.origin), v = (m == null ? void 0 : m.unit) ?? "요소";
            return m ? `${d.origin ?? "값"}이 너무 큽니다: ${d.maximum.toString()}${v} ${p}${h}` : `${d.origin ?? "값"}이 너무 큽니다: ${d.maximum.toString()} ${p}${h}`;
          }
          case "too_small": {
            const p = d.inclusive ? "이상" : "초과", h = p === "이상" ? "이어야 합니다" : "여야 합니다", m = a(d.origin), v = (m == null ? void 0 : m.unit) ?? "요소";
            return m ? `${d.origin ?? "값"}이 너무 작습니다: ${d.minimum.toString()}${v} ${p}${h}` : `${d.origin ?? "값"}이 너무 작습니다: ${d.minimum.toString()} ${p}${h}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `잘못된 문자열: "${p.prefix}"(으)로 시작해야 합니다` : p.format === "ends_with" ? `잘못된 문자열: "${p.suffix}"(으)로 끝나야 합니다` : p.format === "includes" ? `잘못된 문자열: "${p.includes}"을(를) 포함해야 합니다` : p.format === "regex" ? `잘못된 문자열: 정규식 ${p.pattern} 패턴과 일치해야 합니다` : `잘못된 ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `잘못된 숫자: ${d.divisor}의 배수여야 합니다`;
          case "unrecognized_keys":
            return `인식할 수 없는 키: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `잘못된 키: ${d.origin}`;
          case "invalid_union":
            return "잘못된 입력";
          case "invalid_element":
            return `잘못된 값: ${d.origin}`;
          default:
            return "잘못된 입력";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }($1, $1.exports)), $1.exports;
}
var up = {}, _ge;
function dcn() {
  return _ge || (_ge = 1, function(e) {
    var t = up && up.__createBinding || (Object.create ? function(f, d, p, h) {
      h === void 0 && (h = p);
      var m = Object.getOwnPropertyDescriptor(d, p);
      (!m || ("get" in m ? !d.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
        return d[p];
      } }), Object.defineProperty(f, h, m);
    } : function(f, d, p, h) {
      h === void 0 && (h = p), f[h] = d[p];
    }), n = up && up.__setModuleDefault || (Object.create ? function(f, d) {
      Object.defineProperty(f, "default", { enumerable: !0, value: d });
    } : function(f, d) {
      f.default = d;
    }), r = up && up.__importStar || function(f) {
      if (f && f.__esModule) return f;
      var d = {};
      if (f != null) for (var p in f) p !== "default" && Object.prototype.hasOwnProperty.call(f, p) && t(d, f, p);
      return n(d, f), d;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = u;
    const i = r(fn()), o = (f) => s(typeof f, f);
    e.parsedType = o;
    const s = (f, d = void 0) => {
      switch (f) {
        case "number":
          return Number.isNaN(d) ? "NaN" : "skaičius";
        case "bigint":
          return "sveikasis skaičius";
        case "string":
          return "eilutė";
        case "boolean":
          return "loginė reikšmė";
        case "undefined":
        case "void":
          return "neapibrėžta reikšmė";
        case "function":
          return "funkcija";
        case "symbol":
          return "simbolis";
        case "object":
          return d === void 0 ? "nežinomas objektas" : d === null ? "nulinė reikšmė" : Array.isArray(d) ? "masyvas" : Object.getPrototypeOf(d) !== Object.prototype && d.constructor ? d.constructor.name : "objektas";
        //Zod types below
        case "null":
          return "nulinė reikšmė";
      }
      return f;
    }, l = (f) => f.charAt(0).toUpperCase() + f.slice(1);
    function c(f) {
      const d = Math.abs(f), p = d % 10, h = d % 100;
      return h >= 11 && h <= 19 || p === 0 ? "many" : p === 1 ? "one" : "few";
    }
    const a = () => {
      const f = {
        string: {
          unit: {
            one: "simbolis",
            few: "simboliai",
            many: "simbolių"
          },
          verb: {
            smaller: {
              inclusive: "turi būti ne ilgesnė kaip",
              notInclusive: "turi būti trumpesnė kaip"
            },
            bigger: {
              inclusive: "turi būti ne trumpesnė kaip",
              notInclusive: "turi būti ilgesnė kaip"
            }
          }
        },
        file: {
          unit: {
            one: "baitas",
            few: "baitai",
            many: "baitų"
          },
          verb: {
            smaller: {
              inclusive: "turi būti ne didesnis kaip",
              notInclusive: "turi būti mažesnis kaip"
            },
            bigger: {
              inclusive: "turi būti ne mažesnis kaip",
              notInclusive: "turi būti didesnis kaip"
            }
          }
        },
        array: {
          unit: {
            one: "elementą",
            few: "elementus",
            many: "elementų"
          },
          verb: {
            smaller: {
              inclusive: "turi turėti ne daugiau kaip",
              notInclusive: "turi turėti mažiau kaip"
            },
            bigger: {
              inclusive: "turi turėti ne mažiau kaip",
              notInclusive: "turi turėti daugiau kaip"
            }
          }
        },
        set: {
          unit: {
            one: "elementą",
            few: "elementus",
            many: "elementų"
          },
          verb: {
            smaller: {
              inclusive: "turi turėti ne daugiau kaip",
              notInclusive: "turi turėti mažiau kaip"
            },
            bigger: {
              inclusive: "turi turėti ne mažiau kaip",
              notInclusive: "turi turėti daugiau kaip"
            }
          }
        }
      };
      function d(h, m, v, b) {
        const A = f[h] ?? null;
        return A === null ? A : {
          unit: A.unit[m],
          verb: A.verb[b][v ? "inclusive" : "notInclusive"]
        };
      }
      const p = {
        regex: "įvestis",
        email: "el. pašto adresas",
        url: "URL",
        emoji: "jaustukas",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO data ir laikas",
        date: "ISO data",
        time: "ISO laikas",
        duration: "ISO trukmė",
        ipv4: "IPv4 adresas",
        ipv6: "IPv6 adresas",
        cidrv4: "IPv4 tinklo prefiksas (CIDR)",
        cidrv6: "IPv6 tinklo prefiksas (CIDR)",
        base64: "base64 užkoduota eilutė",
        base64url: "base64url užkoduota eilutė",
        json_string: "JSON eilutė",
        e164: "E.164 numeris",
        jwt: "JWT",
        template_literal: "įvestis"
      };
      return (h) => {
        switch (h.code) {
          case "invalid_type":
            return `Gautas tipas ${(0, e.parsedType)(h.input)}, o tikėtasi - ${s(h.expected)}`;
          case "invalid_value":
            return h.values.length === 1 ? `Privalo būti ${i.stringifyPrimitive(h.values[0])}` : `Privalo būti vienas iš ${i.joinValues(h.values, "|")} pasirinkimų`;
          case "too_big": {
            const m = s(h.origin), v = d(h.origin, c(Number(h.maximum)), h.inclusive ?? !1, "smaller");
            if (v != null && v.verb)
              return `${l(m ?? h.origin ?? "reikšmė")} ${v.verb} ${h.maximum.toString()} ${v.unit ?? "elementų"}`;
            const b = h.inclusive ? "ne didesnis kaip" : "mažesnis kaip";
            return `${l(m ?? h.origin ?? "reikšmė")} turi būti ${b} ${h.maximum.toString()} ${v == null ? void 0 : v.unit}`;
          }
          case "too_small": {
            const m = s(h.origin), v = d(h.origin, c(Number(h.minimum)), h.inclusive ?? !1, "bigger");
            if (v != null && v.verb)
              return `${l(m ?? h.origin ?? "reikšmė")} ${v.verb} ${h.minimum.toString()} ${v.unit ?? "elementų"}`;
            const b = h.inclusive ? "ne mažesnis kaip" : "didesnis kaip";
            return `${l(m ?? h.origin ?? "reikšmė")} turi būti ${b} ${h.minimum.toString()} ${v == null ? void 0 : v.unit}`;
          }
          case "invalid_format": {
            const m = h;
            return m.format === "starts_with" ? `Eilutė privalo prasidėti "${m.prefix}"` : m.format === "ends_with" ? `Eilutė privalo pasibaigti "${m.suffix}"` : m.format === "includes" ? `Eilutė privalo įtraukti "${m.includes}"` : m.format === "regex" ? `Eilutė privalo atitikti ${m.pattern}` : `Neteisingas ${p[m.format] ?? h.format}`;
          }
          case "not_multiple_of":
            return `Skaičius privalo būti ${h.divisor} kartotinis.`;
          case "unrecognized_keys":
            return `Neatpažint${h.keys.length > 1 ? "i" : "as"} rakt${h.keys.length > 1 ? "ai" : "as"}: ${i.joinValues(h.keys, ", ")}`;
          case "invalid_key":
            return "Rastas klaidingas raktas";
          case "invalid_union":
            return "Klaidinga įvestis";
          case "invalid_element": {
            const m = s(h.origin);
            return `${l(m ?? h.origin ?? "reikšmė")} turi klaidingą įvestį`;
          }
          default:
            return "Klaidinga įvestis";
        }
      };
    };
    function u() {
      return {
        localeError: a()
      };
    }
  }(up)), up;
}
var K1 = { exports: {} }, M0 = K1.exports, Lge;
function fcn() {
  return Lge || (Lge = 1, function(e, t) {
    var n = M0 && M0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = M0 && M0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = M0 && M0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "знаци", verb: "да имаат" },
        file: { unit: "бајти", verb: "да имаат" },
        array: { unit: "ставки", verb: "да имаат" },
        set: { unit: "ставки", verb: "да имаат" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "број";
          case "object": {
            if (Array.isArray(d))
              return "низа";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "внес",
        email: "адреса на е-пошта",
        url: "URL",
        emoji: "емоџи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO датум и време",
        date: "ISO датум",
        time: "ISO време",
        duration: "ISO времетраење",
        ipv4: "IPv4 адреса",
        ipv6: "IPv6 адреса",
        cidrv4: "IPv4 опсег",
        cidrv6: "IPv6 опсег",
        base64: "base64-енкодирана низа",
        base64url: "base64url-енкодирана низа",
        json_string: "JSON низа",
        e164: "E.164 број",
        jwt: "JWT",
        template_literal: "внес"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Грешен внес: се очекува ${d.expected}, примено ${u(d.input)}`;
          // return `Invalid input: expected ${issue.expected}, received ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Invalid input: expected ${o.stringifyPrimitive(d.values[0])}` : `Грешана опција: се очекува една ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Премногу голем: се очекува ${d.origin ?? "вредноста"} да има ${p}${d.maximum.toString()} ${h.unit ?? "елементи"}` : `Премногу голем: се очекува ${d.origin ?? "вредноста"} да биде ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Премногу мал: се очекува ${d.origin} да има ${p}${d.minimum.toString()} ${h.unit}` : `Премногу мал: се очекува ${d.origin} да биде ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Неважечка низа: мора да започнува со "${p.prefix}"` : p.format === "ends_with" ? `Неважечка низа: мора да завршува со "${p.suffix}"` : p.format === "includes" ? `Неважечка низа: мора да вклучува "${p.includes}"` : p.format === "regex" ? `Неважечка низа: мора да одгоара на патернот ${p.pattern}` : `Invalid ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Грешен број: мора да биде делив со ${d.divisor}`;
          case "unrecognized_keys":
            return `${d.keys.length > 1 ? "Непрепознаени клучеви" : "Непрепознаен клуч"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Грешен клуч во ${d.origin}`;
          case "invalid_union":
            return "Грешен внес";
          case "invalid_element":
            return `Грешна вредност во ${d.origin}`;
          default:
            return "Грешен внес";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(K1, K1.exports)), K1.exports;
}
var G1 = { exports: {} }, D0 = G1.exports, zge;
function pcn() {
  return zge || (zge = 1, function(e, t) {
    var n = D0 && D0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = D0 && D0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = D0 && D0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "aksara", verb: "mempunyai" },
        file: { unit: "bait", verb: "mempunyai" },
        array: { unit: "elemen", verb: "mempunyai" },
        set: { unit: "elemen", verb: "mempunyai" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "nombor";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Input tidak sah: dijangka ${d.expected}, diterima ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Input tidak sah: dijangka ${o.stringifyPrimitive(d.values[0])}` : `Pilihan tidak sah: dijangka salah satu daripada ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Terlalu besar: dijangka ${d.origin ?? "nilai"} ${h.verb} ${p}${d.maximum.toString()} ${h.unit ?? "elemen"}` : `Terlalu besar: dijangka ${d.origin ?? "nilai"} adalah ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Terlalu kecil: dijangka ${d.origin} ${h.verb} ${p}${d.minimum.toString()} ${h.unit}` : `Terlalu kecil: dijangka ${d.origin} adalah ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `String tidak sah: mesti bermula dengan "${p.prefix}"` : p.format === "ends_with" ? `String tidak sah: mesti berakhir dengan "${p.suffix}"` : p.format === "includes" ? `String tidak sah: mesti mengandungi "${p.includes}"` : p.format === "regex" ? `String tidak sah: mesti sepadan dengan corak ${p.pattern}` : `${f[p.format] ?? d.format} tidak sah`;
          }
          case "not_multiple_of":
            return `Nombor tidak sah: perlu gandaan ${d.divisor}`;
          case "unrecognized_keys":
            return `Kunci tidak dikenali: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Kunci tidak sah dalam ${d.origin}`;
          case "invalid_union":
            return "Input tidak sah";
          case "invalid_element":
            return `Nilai tidak sah dalam ${d.origin}`;
          default:
            return "Input tidak sah";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(G1, G1.exports)), G1.exports;
}
var Y1 = { exports: {} }, _0 = Y1.exports, jge;
function hcn() {
  return jge || (jge = 1, function(e, t) {
    var n = _0 && _0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = _0 && _0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = _0 && _0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "tekens", verb: "te hebben" },
        file: { unit: "bytes", verb: "te hebben" },
        array: { unit: "elementen", verb: "te hebben" },
        set: { unit: "elementen", verb: "te hebben" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "getal";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Ongeldige invoer: verwacht ${d.expected}, ontving ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Ongeldige invoer: verwacht ${o.stringifyPrimitive(d.values[0])}` : `Ongeldige optie: verwacht één van ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Te groot: verwacht dat ${d.origin ?? "waarde"} ${h.verb} ${p}${d.maximum.toString()} ${h.unit ?? "elementen"}` : `Te groot: verwacht dat ${d.origin ?? "waarde"} ${p}${d.maximum.toString()} is`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Te klein: verwacht dat ${d.origin} ${h.verb} ${p}${d.minimum.toString()} ${h.unit}` : `Te klein: verwacht dat ${d.origin} ${p}${d.minimum.toString()} is`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Ongeldige tekst: moet met "${p.prefix}" beginnen` : p.format === "ends_with" ? `Ongeldige tekst: moet op "${p.suffix}" eindigen` : p.format === "includes" ? `Ongeldige tekst: moet "${p.includes}" bevatten` : p.format === "regex" ? `Ongeldige tekst: moet overeenkomen met patroon ${p.pattern}` : `Ongeldig: ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Ongeldig getal: moet een veelvoud van ${d.divisor} zijn`;
          case "unrecognized_keys":
            return `Onbekende key${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Ongeldige key in ${d.origin}`;
          case "invalid_union":
            return "Ongeldige invoer";
          case "invalid_element":
            return `Ongeldige waarde in ${d.origin}`;
          default:
            return "Ongeldige invoer";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(Y1, Y1.exports)), Y1.exports;
}
var J1 = { exports: {} }, L0 = J1.exports, Fge;
function mcn() {
  return Fge || (Fge = 1, function(e, t) {
    var n = L0 && L0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = L0 && L0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = L0 && L0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "tegn", verb: "å ha" },
        file: { unit: "bytes", verb: "å ha" },
        array: { unit: "elementer", verb: "å inneholde" },
        set: { unit: "elementer", verb: "å inneholde" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "tall";
          case "object": {
            if (Array.isArray(d))
              return "liste";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-område",
        ipv6: "IPv6-område",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Ugyldig input: forventet ${d.expected}, fikk ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Ugyldig verdi: forventet ${o.stringifyPrimitive(d.values[0])}` : `Ugyldig valg: forventet en av ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `For stor(t): forventet ${d.origin ?? "value"} til å ha ${p}${d.maximum.toString()} ${h.unit ?? "elementer"}` : `For stor(t): forventet ${d.origin ?? "value"} til å ha ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `For lite(n): forventet ${d.origin} til å ha ${p}${d.minimum.toString()} ${h.unit}` : `For lite(n): forventet ${d.origin} til å ha ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Ugyldig streng: må starte med "${p.prefix}"` : p.format === "ends_with" ? `Ugyldig streng: må ende med "${p.suffix}"` : p.format === "includes" ? `Ugyldig streng: må inneholde "${p.includes}"` : p.format === "regex" ? `Ugyldig streng: må matche mønsteret ${p.pattern}` : `Ugyldig ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Ugyldig tall: må være et multiplum av ${d.divisor}`;
          case "unrecognized_keys":
            return `${d.keys.length > 1 ? "Ukjente nøkler" : "Ukjent nøkkel"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Ugyldig nøkkel i ${d.origin}`;
          case "invalid_union":
            return "Ugyldig input";
          case "invalid_element":
            return `Ugyldig verdi i ${d.origin}`;
          default:
            return "Ugyldig input";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(J1, J1.exports)), J1.exports;
}
var eE = { exports: {} }, z0 = eE.exports, Uge;
function gcn() {
  return Uge || (Uge = 1, function(e, t) {
    var n = z0 && z0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = z0 && z0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = z0 && z0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "harf", verb: "olmalıdır" },
        file: { unit: "bayt", verb: "olmalıdır" },
        array: { unit: "unsur", verb: "olmalıdır" },
        set: { unit: "unsur", verb: "olmalıdır" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "numara";
          case "object": {
            if (Array.isArray(d))
              return "saf";
            if (d === null)
              return "gayb";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "giren",
        email: "epostagâh",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO hengâmı",
        date: "ISO tarihi",
        time: "ISO zamanı",
        duration: "ISO müddeti",
        ipv4: "IPv4 nişânı",
        ipv6: "IPv6 nişânı",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-şifreli metin",
        base64url: "base64url-şifreli metin",
        json_string: "JSON metin",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "giren"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Fâsit giren: umulan ${d.expected}, alınan ${u(d.input)}`;
          // return `Fâsit giren: umulan ${issue.expected}, alınan ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Fâsit giren: umulan ${o.stringifyPrimitive(d.values[0])}` : `Fâsit tercih: mûteberler ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Fazla büyük: ${d.origin ?? "value"}, ${p}${d.maximum.toString()} ${h.unit ?? "elements"} sahip olmalıydı.` : `Fazla büyük: ${d.origin ?? "value"}, ${p}${d.maximum.toString()} olmalıydı.`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Fazla küçük: ${d.origin}, ${p}${d.minimum.toString()} ${h.unit} sahip olmalıydı.` : `Fazla küçük: ${d.origin}, ${p}${d.minimum.toString()} olmalıydı.`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Fâsit metin: "${p.prefix}" ile başlamalı.` : p.format === "ends_with" ? `Fâsit metin: "${p.suffix}" ile bitmeli.` : p.format === "includes" ? `Fâsit metin: "${p.includes}" ihtivâ etmeli.` : p.format === "regex" ? `Fâsit metin: ${p.pattern} nakşına uymalı.` : `Fâsit ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Fâsit sayı: ${d.divisor} katı olmalıydı.`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar ${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `${d.origin} için tanınmayan anahtar var.`;
          case "invalid_union":
            return "Giren tanınamadı.";
          case "invalid_element":
            return `${d.origin} için tanınmayan kıymet var.`;
          default:
            return "Kıymet tanınamadı.";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(eE, eE.exports)), eE.exports;
}
var tE = { exports: {} }, j0 = tE.exports, Vge;
function ycn() {
  return Vge || (Vge = 1, function(e, t) {
    var n = j0 && j0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = j0 && j0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = j0 && j0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "توکي", verb: "ولري" },
        file: { unit: "بایټس", verb: "ولري" },
        array: { unit: "توکي", verb: "ولري" },
        set: { unit: "توکي", verb: "ولري" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "عدد";
          case "object": {
            if (Array.isArray(d))
              return "ارې";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ورودي",
        email: "بریښنالیک",
        url: "یو آر ال",
        emoji: "ایموجي",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "نیټه او وخت",
        date: "نېټه",
        time: "وخت",
        duration: "موده",
        ipv4: "د IPv4 پته",
        ipv6: "د IPv6 پته",
        cidrv4: "د IPv4 ساحه",
        cidrv6: "د IPv6 ساحه",
        base64: "base64-encoded متن",
        base64url: "base64url-encoded متن",
        json_string: "JSON متن",
        e164: "د E.164 شمېره",
        jwt: "JWT",
        template_literal: "ورودي"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `ناسم ورودي: باید ${d.expected} وای, مګر ${u(d.input)} ترلاسه شو`;
          case "invalid_value":
            return d.values.length === 1 ? `ناسم ورودي: باید ${o.stringifyPrimitive(d.values[0])} وای` : `ناسم انتخاب: باید یو له ${o.joinValues(d.values, "|")} څخه وای`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `ډیر لوی: ${d.origin ?? "ارزښت"} باید ${p}${d.maximum.toString()} ${h.unit ?? "عنصرونه"} ولري` : `ډیر لوی: ${d.origin ?? "ارزښت"} باید ${p}${d.maximum.toString()} وي`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `ډیر کوچنی: ${d.origin} باید ${p}${d.minimum.toString()} ${h.unit} ولري` : `ډیر کوچنی: ${d.origin} باید ${p}${d.minimum.toString()} وي`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `ناسم متن: باید د "${p.prefix}" سره پیل شي` : p.format === "ends_with" ? `ناسم متن: باید د "${p.suffix}" سره پای ته ورسيږي` : p.format === "includes" ? `ناسم متن: باید "${p.includes}" ولري` : p.format === "regex" ? `ناسم متن: باید د ${p.pattern} سره مطابقت ولري` : `${f[p.format] ?? d.format} ناسم دی`;
          }
          case "not_multiple_of":
            return `ناسم عدد: باید د ${d.divisor} مضرب وي`;
          case "unrecognized_keys":
            return `ناسم ${d.keys.length > 1 ? "کلیډونه" : "کلیډ"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `ناسم کلیډ په ${d.origin} کې`;
          case "invalid_union":
            return "ناسمه ورودي";
          case "invalid_element":
            return `ناسم عنصر په ${d.origin} کې`;
          default:
            return "ناسمه ورودي";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(tE, tE.exports)), tE.exports;
}
var nE = { exports: {} }, F0 = nE.exports, qge;
function vcn() {
  return qge || (qge = 1, function(e, t) {
    var n = F0 && F0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = F0 && F0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = F0 && F0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "znaków", verb: "mieć" },
        file: { unit: "bajtów", verb: "mieć" },
        array: { unit: "elementów", verb: "mieć" },
        set: { unit: "elementów", verb: "mieć" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "liczba";
          case "object": {
            if (Array.isArray(d))
              return "tablica";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "wyrażenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ciąg znaków zakodowany w formacie base64",
        base64url: "ciąg znaków zakodowany w formacie base64url",
        json_string: "ciąg znaków w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wejście"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Nieprawidłowe dane wejściowe: oczekiwano ${d.expected}, otrzymano ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Nieprawidłowe dane wejściowe: oczekiwano ${o.stringifyPrimitive(d.values[0])}` : `Nieprawidłowa opcja: oczekiwano jednej z wartości ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Za duża wartość: oczekiwano, że ${d.origin ?? "wartość"} będzie mieć ${p}${d.maximum.toString()} ${h.unit ?? "elementów"}` : `Zbyt duż(y/a/e): oczekiwano, że ${d.origin ?? "wartość"} będzie wynosić ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Za mała wartość: oczekiwano, że ${d.origin ?? "wartość"} będzie mieć ${p}${d.minimum.toString()} ${h.unit ?? "elementów"}` : `Zbyt mał(y/a/e): oczekiwano, że ${d.origin ?? "wartość"} będzie wynosić ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Nieprawidłowy ciąg znaków: musi zaczynać się od "${p.prefix}"` : p.format === "ends_with" ? `Nieprawidłowy ciąg znaków: musi kończyć się na "${p.suffix}"` : p.format === "includes" ? `Nieprawidłowy ciąg znaków: musi zawierać "${p.includes}"` : p.format === "regex" ? `Nieprawidłowy ciąg znaków: musi odpowiadać wzorcowi ${p.pattern}` : `Nieprawidłow(y/a/e) ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Nieprawidłowa liczba: musi być wielokrotnością ${d.divisor}`;
          case "unrecognized_keys":
            return `Nierozpoznane klucze${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Nieprawidłowy klucz w ${d.origin}`;
          case "invalid_union":
            return "Nieprawidłowe dane wejściowe";
          case "invalid_element":
            return `Nieprawidłowa wartość w ${d.origin}`;
          default:
            return "Nieprawidłowe dane wejściowe";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(nE, nE.exports)), nE.exports;
}
var rE = { exports: {} }, U0 = rE.exports, Bge;
function bcn() {
  return Bge || (Bge = 1, function(e, t) {
    var n = U0 && U0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = U0 && U0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = U0 && U0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "caracteres", verb: "ter" },
        file: { unit: "bytes", verb: "ter" },
        array: { unit: "itens", verb: "ter" },
        set: { unit: "itens", verb: "ter" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "número";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "nulo";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "padrão",
        email: "endereço de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "duração ISO",
        ipv4: "endereço IPv4",
        ipv6: "endereço IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "número E.164",
        jwt: "JWT",
        template_literal: "entrada"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Tipo inválido: esperado ${d.expected}, recebido ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Entrada inválida: esperado ${o.stringifyPrimitive(d.values[0])}` : `Opção inválida: esperada uma das ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Muito grande: esperado que ${d.origin ?? "valor"} tivesse ${p}${d.maximum.toString()} ${h.unit ?? "elementos"}` : `Muito grande: esperado que ${d.origin ?? "valor"} fosse ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Muito pequeno: esperado que ${d.origin} tivesse ${p}${d.minimum.toString()} ${h.unit}` : `Muito pequeno: esperado que ${d.origin} fosse ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Texto inválido: deve começar com "${p.prefix}"` : p.format === "ends_with" ? `Texto inválido: deve terminar com "${p.suffix}"` : p.format === "includes" ? `Texto inválido: deve incluir "${p.includes}"` : p.format === "regex" ? `Texto inválido: deve corresponder ao padrão ${p.pattern}` : `${f[p.format] ?? d.format} inválido`;
          }
          case "not_multiple_of":
            return `Número inválido: deve ser múltiplo de ${d.divisor}`;
          case "unrecognized_keys":
            return `Chave${d.keys.length > 1 ? "s" : ""} desconhecida${d.keys.length > 1 ? "s" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Chave inválida em ${d.origin}`;
          case "invalid_union":
            return "Entrada inválida";
          case "invalid_element":
            return `Valor inválido em ${d.origin}`;
          default:
            return "Campo inválido";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(rE, rE.exports)), rE.exports;
}
var iE = { exports: {} }, V0 = iE.exports, Xge;
function Ocn() {
  return Xge || (Xge = 1, function(e, t) {
    var n = V0 && V0.__createBinding || (Object.create ? function(a, u, f, d) {
      d === void 0 && (d = f);
      var p = Object.getOwnPropertyDescriptor(u, f);
      (!p || ("get" in p ? !u.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return u[f];
      } }), Object.defineProperty(a, d, p);
    } : function(a, u, f, d) {
      d === void 0 && (d = f), a[d] = u[f];
    }), r = V0 && V0.__setModuleDefault || (Object.create ? function(a, u) {
      Object.defineProperty(a, "default", { enumerable: !0, value: u });
    } : function(a, u) {
      a.default = u;
    }), i = V0 && V0.__importStar || function(a) {
      if (a && a.__esModule) return a;
      var u = {};
      if (a != null) for (var f in a) f !== "default" && Object.prototype.hasOwnProperty.call(a, f) && n(u, a, f);
      return r(u, a), u;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = c;
    const o = i(fn());
    function s(a, u, f, d) {
      const p = Math.abs(a), h = p % 10, m = p % 100;
      return m >= 11 && m <= 19 ? d : h === 1 ? u : h >= 2 && h <= 4 ? f : d;
    }
    const l = () => {
      const a = {
        string: {
          unit: {
            one: "символ",
            few: "символа",
            many: "символов"
          },
          verb: "иметь"
        },
        file: {
          unit: {
            one: "байт",
            few: "байта",
            many: "байт"
          },
          verb: "иметь"
        },
        array: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        },
        set: {
          unit: {
            one: "элемент",
            few: "элемента",
            many: "элементов"
          },
          verb: "иметь"
        }
      };
      function u(p) {
        return a[p] ?? null;
      }
      const f = (p) => {
        const h = typeof p;
        switch (h) {
          case "number":
            return Number.isNaN(p) ? "NaN" : "число";
          case "object": {
            if (Array.isArray(p))
              return "массив";
            if (p === null)
              return "null";
            if (Object.getPrototypeOf(p) !== Object.prototype && p.constructor)
              return p.constructor.name;
          }
        }
        return h;
      }, d = {
        regex: "ввод",
        email: "email адрес",
        url: "URL",
        emoji: "эмодзи",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO дата и время",
        date: "ISO дата",
        time: "ISO время",
        duration: "ISO длительность",
        ipv4: "IPv4 адрес",
        ipv6: "IPv6 адрес",
        cidrv4: "IPv4 диапазон",
        cidrv6: "IPv6 диапазон",
        base64: "строка в формате base64",
        base64url: "строка в формате base64url",
        json_string: "JSON строка",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "ввод"
      };
      return (p) => {
        switch (p.code) {
          case "invalid_type":
            return `Неверный ввод: ожидалось ${p.expected}, получено ${f(p.input)}`;
          case "invalid_value":
            return p.values.length === 1 ? `Неверный ввод: ожидалось ${o.stringifyPrimitive(p.values[0])}` : `Неверный вариант: ожидалось одно из ${o.joinValues(p.values, "|")}`;
          case "too_big": {
            const h = p.inclusive ? "<=" : "<", m = u(p.origin);
            if (m) {
              const v = Number(p.maximum), b = s(v, m.unit.one, m.unit.few, m.unit.many);
              return `Слишком большое значение: ожидалось, что ${p.origin ?? "значение"} будет иметь ${h}${p.maximum.toString()} ${b}`;
            }
            return `Слишком большое значение: ожидалось, что ${p.origin ?? "значение"} будет ${h}${p.maximum.toString()}`;
          }
          case "too_small": {
            const h = p.inclusive ? ">=" : ">", m = u(p.origin);
            if (m) {
              const v = Number(p.minimum), b = s(v, m.unit.one, m.unit.few, m.unit.many);
              return `Слишком маленькое значение: ожидалось, что ${p.origin} будет иметь ${h}${p.minimum.toString()} ${b}`;
            }
            return `Слишком маленькое значение: ожидалось, что ${p.origin} будет ${h}${p.minimum.toString()}`;
          }
          case "invalid_format": {
            const h = p;
            return h.format === "starts_with" ? `Неверная строка: должна начинаться с "${h.prefix}"` : h.format === "ends_with" ? `Неверная строка: должна заканчиваться на "${h.suffix}"` : h.format === "includes" ? `Неверная строка: должна содержать "${h.includes}"` : h.format === "regex" ? `Неверная строка: должна соответствовать шаблону ${h.pattern}` : `Неверный ${d[h.format] ?? p.format}`;
          }
          case "not_multiple_of":
            return `Неверное число: должно быть кратным ${p.divisor}`;
          case "unrecognized_keys":
            return `Нераспознанн${p.keys.length > 1 ? "ые" : "ый"} ключ${p.keys.length > 1 ? "и" : ""}: ${o.joinValues(p.keys, ", ")}`;
          case "invalid_key":
            return `Неверный ключ в ${p.origin}`;
          case "invalid_union":
            return "Неверные входные данные";
          case "invalid_element":
            return `Неверное значение в ${p.origin}`;
          default:
            return "Неверные входные данные";
        }
      };
    };
    function c() {
      return {
        localeError: l()
      };
    }
    e.exports = t.default;
  }(iE, iE.exports)), iE.exports;
}
var oE = { exports: {} }, q0 = oE.exports, Wge;
function Acn() {
  return Wge || (Wge = 1, function(e, t) {
    var n = q0 && q0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = q0 && q0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = q0 && q0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "znakov", verb: "imeti" },
        file: { unit: "bajtov", verb: "imeti" },
        array: { unit: "elementov", verb: "imeti" },
        set: { unit: "elementov", verb: "imeti" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "število";
          case "object": {
            if (Array.isArray(d))
              return "tabela";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "vnos",
        email: "e-poštni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in čas",
        date: "ISO datum",
        time: "ISO čas",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 številka",
        jwt: "JWT",
        template_literal: "vnos"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Neveljaven vnos: pričakovano ${d.expected}, prejeto ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Neveljaven vnos: pričakovano ${o.stringifyPrimitive(d.values[0])}` : `Neveljavna možnost: pričakovano eno izmed ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Preveliko: pričakovano, da bo ${d.origin ?? "vrednost"} imelo ${p}${d.maximum.toString()} ${h.unit ?? "elementov"}` : `Preveliko: pričakovano, da bo ${d.origin ?? "vrednost"} ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Premajhno: pričakovano, da bo ${d.origin} imelo ${p}${d.minimum.toString()} ${h.unit}` : `Premajhno: pričakovano, da bo ${d.origin} ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Neveljaven niz: mora se začeti z "${p.prefix}"` : p.format === "ends_with" ? `Neveljaven niz: mora se končati z "${p.suffix}"` : p.format === "includes" ? `Neveljaven niz: mora vsebovati "${p.includes}"` : p.format === "regex" ? `Neveljaven niz: mora ustrezati vzorcu ${p.pattern}` : `Neveljaven ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Neveljavno število: mora biti večkratnik ${d.divisor}`;
          case "unrecognized_keys":
            return `Neprepoznan${d.keys.length > 1 ? "i ključi" : " ključ"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Neveljaven ključ v ${d.origin}`;
          case "invalid_union":
            return "Neveljaven vnos";
          case "invalid_element":
            return `Neveljavna vrednost v ${d.origin}`;
          default:
            return "Neveljaven vnos";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(oE, oE.exports)), oE.exports;
}
var sE = { exports: {} }, B0 = sE.exports, Zge;
function wcn() {
  return Zge || (Zge = 1, function(e, t) {
    var n = B0 && B0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = B0 && B0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = B0 && B0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "tecken", verb: "att ha" },
        file: { unit: "bytes", verb: "att ha" },
        array: { unit: "objekt", verb: "att innehålla" },
        set: { unit: "objekt", verb: "att innehålla" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "antal";
          case "object": {
            if (Array.isArray(d))
              return "lista";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "reguljärt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad sträng",
        base64url: "base64url-kodad sträng",
        json_string: "JSON-sträng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Ogiltig inmatning: förväntat ${d.expected}, fick ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Ogiltig inmatning: förväntat ${o.stringifyPrimitive(d.values[0])}` : `Ogiltigt val: förväntade en av ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `För stor(t): förväntade ${d.origin ?? "värdet"} att ha ${p}${d.maximum.toString()} ${h.unit ?? "element"}` : `För stor(t): förväntat ${d.origin ?? "värdet"} att ha ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `För lite(t): förväntade ${d.origin ?? "värdet"} att ha ${p}${d.minimum.toString()} ${h.unit}` : `För lite(t): förväntade ${d.origin ?? "värdet"} att ha ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Ogiltig sträng: måste börja med "${p.prefix}"` : p.format === "ends_with" ? `Ogiltig sträng: måste sluta med "${p.suffix}"` : p.format === "includes" ? `Ogiltig sträng: måste innehålla "${p.includes}"` : p.format === "regex" ? `Ogiltig sträng: måste matcha mönstret "${p.pattern}"` : `Ogiltig(t) ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Ogiltigt tal: måste vara en multipel av ${d.divisor}`;
          case "unrecognized_keys":
            return `${d.keys.length > 1 ? "Okända nycklar" : "Okänd nyckel"}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Ogiltig nyckel i ${d.origin ?? "värdet"}`;
          case "invalid_union":
            return "Ogiltig input";
          case "invalid_element":
            return `Ogiltigt värde i ${d.origin ?? "värdet"}`;
          default:
            return "Ogiltig input";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(sE, sE.exports)), sE.exports;
}
var aE = { exports: {} }, X0 = aE.exports, Hge;
function xcn() {
  return Hge || (Hge = 1, function(e, t) {
    var n = X0 && X0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = X0 && X0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = X0 && X0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "எழுத்துக்கள்", verb: "கொண்டிருக்க வேண்டும்" },
        file: { unit: "பைட்டுகள்", verb: "கொண்டிருக்க வேண்டும்" },
        array: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" },
        set: { unit: "உறுப்புகள்", verb: "கொண்டிருக்க வேண்டும்" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "எண் அல்லாதது" : "எண்";
          case "object": {
            if (Array.isArray(d))
              return "அணி";
            if (d === null)
              return "வெறுமை";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "உள்ளீடு",
        email: "மின்னஞ்சல் முகவரி",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO தேதி நேரம்",
        date: "ISO தேதி",
        time: "ISO நேரம்",
        duration: "ISO கால அளவு",
        ipv4: "IPv4 முகவரி",
        ipv6: "IPv6 முகவரி",
        cidrv4: "IPv4 வரம்பு",
        cidrv6: "IPv6 வரம்பு",
        base64: "base64-encoded சரம்",
        base64url: "base64url-encoded சரம்",
        json_string: "JSON சரம்",
        e164: "E.164 எண்",
        jwt: "JWT",
        template_literal: "input"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${d.expected}, பெறப்பட்டது ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `தவறான உள்ளீடு: எதிர்பார்க்கப்பட்டது ${o.stringifyPrimitive(d.values[0])}` : `தவறான விருப்பம்: எதிர்பார்க்கப்பட்டது ${o.joinValues(d.values, "|")} இல் ஒன்று`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${d.origin ?? "மதிப்பு"} ${p}${d.maximum.toString()} ${h.unit ?? "உறுப்புகள்"} ஆக இருக்க வேண்டும்` : `மிக பெரியது: எதிர்பார்க்கப்பட்டது ${d.origin ?? "மதிப்பு"} ${p}${d.maximum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${d.origin} ${p}${d.minimum.toString()} ${h.unit} ஆக இருக்க வேண்டும்` : `மிகச் சிறியது: எதிர்பார்க்கப்பட்டது ${d.origin} ${p}${d.minimum.toString()} ஆக இருக்க வேண்டும்`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `தவறான சரம்: "${p.prefix}" இல் தொடங்க வேண்டும்` : p.format === "ends_with" ? `தவறான சரம்: "${p.suffix}" இல் முடிவடைய வேண்டும்` : p.format === "includes" ? `தவறான சரம்: "${p.includes}" ஐ உள்ளடக்க வேண்டும்` : p.format === "regex" ? `தவறான சரம்: ${p.pattern} முறைபாட்டுடன் பொருந்த வேண்டும்` : `தவறான ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `தவறான எண்: ${d.divisor} இன் பலமாக இருக்க வேண்டும்`;
          case "unrecognized_keys":
            return `அடையாளம் தெரியாத விசை${d.keys.length > 1 ? "கள்" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `${d.origin} இல் தவறான விசை`;
          case "invalid_union":
            return "தவறான உள்ளீடு";
          case "invalid_element":
            return `${d.origin} இல் தவறான மதிப்பு`;
          default:
            return "தவறான உள்ளீடு";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(aE, aE.exports)), aE.exports;
}
var lE = { exports: {} }, W0 = lE.exports, Qge;
function Scn() {
  return Qge || (Qge = 1, function(e, t) {
    var n = W0 && W0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = W0 && W0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = W0 && W0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "ตัวอักษร", verb: "ควรมี" },
        file: { unit: "ไบต์", verb: "ควรมี" },
        array: { unit: "รายการ", verb: "ควรมี" },
        set: { unit: "รายการ", verb: "ควรมี" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "ไม่ใช่ตัวเลข (NaN)" : "ตัวเลข";
          case "object": {
            if (Array.isArray(d))
              return "อาร์เรย์ (Array)";
            if (d === null)
              return "ไม่มีค่า (null)";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ข้อมูลที่ป้อน",
        email: "ที่อยู่อีเมล",
        url: "URL",
        emoji: "อิโมจิ",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "วันที่เวลาแบบ ISO",
        date: "วันที่แบบ ISO",
        time: "เวลาแบบ ISO",
        duration: "ช่วงเวลาแบบ ISO",
        ipv4: "ที่อยู่ IPv4",
        ipv6: "ที่อยู่ IPv6",
        cidrv4: "ช่วง IP แบบ IPv4",
        cidrv6: "ช่วง IP แบบ IPv6",
        base64: "ข้อความแบบ Base64",
        base64url: "ข้อความแบบ Base64 สำหรับ URL",
        json_string: "ข้อความแบบ JSON",
        e164: "เบอร์โทรศัพท์ระหว่างประเทศ (E.164)",
        jwt: "โทเคน JWT",
        template_literal: "ข้อมูลที่ป้อน"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `ประเภทข้อมูลไม่ถูกต้อง: ควรเป็น ${d.expected} แต่ได้รับ ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `ค่าไม่ถูกต้อง: ควรเป็น ${o.stringifyPrimitive(d.values[0])}` : `ตัวเลือกไม่ถูกต้อง: ควรเป็นหนึ่งใน ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "ไม่เกิน" : "น้อยกว่า", h = a(d.origin);
            return h ? `เกินกำหนด: ${d.origin ?? "ค่า"} ควรมี${p} ${d.maximum.toString()} ${h.unit ?? "รายการ"}` : `เกินกำหนด: ${d.origin ?? "ค่า"} ควรมี${p} ${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? "อย่างน้อย" : "มากกว่า", h = a(d.origin);
            return h ? `น้อยกว่ากำหนด: ${d.origin} ควรมี${p} ${d.minimum.toString()} ${h.unit}` : `น้อยกว่ากำหนด: ${d.origin} ควรมี${p} ${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องขึ้นต้นด้วย "${p.prefix}"` : p.format === "ends_with" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องลงท้ายด้วย "${p.suffix}"` : p.format === "includes" ? `รูปแบบไม่ถูกต้อง: ข้อความต้องมี "${p.includes}" อยู่ในข้อความ` : p.format === "regex" ? `รูปแบบไม่ถูกต้อง: ต้องตรงกับรูปแบบที่กำหนด ${p.pattern}` : `รูปแบบไม่ถูกต้อง: ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `ตัวเลขไม่ถูกต้อง: ต้องเป็นจำนวนที่หารด้วย ${d.divisor} ได้ลงตัว`;
          case "unrecognized_keys":
            return `พบคีย์ที่ไม่รู้จัก: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `คีย์ไม่ถูกต้องใน ${d.origin}`;
          case "invalid_union":
            return "ข้อมูลไม่ถูกต้อง: ไม่ตรงกับรูปแบบยูเนียนที่กำหนดไว้";
          case "invalid_element":
            return `ข้อมูลไม่ถูกต้องใน ${d.origin}`;
          default:
            return "ข้อมูลไม่ถูกต้อง";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(lE, lE.exports)), lE.exports;
}
var dp = {}, $ge;
function Ecn() {
  return $ge || ($ge = 1, function(e) {
    var t = dp && dp.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), n = dp && dp.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), r = dp && dp.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(a, c, u);
      return n(a, c), a;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.parsedType = void 0, e.default = l;
    const i = r(fn()), o = (c) => {
      const a = typeof c;
      switch (a) {
        case "number":
          return Number.isNaN(c) ? "NaN" : "number";
        case "object": {
          if (Array.isArray(c))
            return "array";
          if (c === null)
            return "null";
          if (Object.getPrototypeOf(c) !== Object.prototype && c.constructor)
            return c.constructor.name;
        }
      }
      return a;
    };
    e.parsedType = o;
    const s = () => {
      const c = {
        string: { unit: "karakter", verb: "olmalı" },
        file: { unit: "bayt", verb: "olmalı" },
        array: { unit: "öğe", verb: "olmalı" },
        set: { unit: "öğe", verb: "olmalı" }
      };
      function a(f) {
        return c[f] ?? null;
      }
      const u = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO süre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aralığı",
        cidrv6: "IPv6 aralığı",
        base64: "base64 ile şifrelenmiş metin",
        base64url: "base64url ile şifrelenmiş metin",
        json_string: "JSON dizesi",
        e164: "E.164 sayısı",
        jwt: "JWT",
        template_literal: "Şablon dizesi"
      };
      return (f) => {
        switch (f.code) {
          case "invalid_type":
            return `Geçersiz değer: beklenen ${f.expected}, alınan ${(0, e.parsedType)(f.input)}`;
          case "invalid_value":
            return f.values.length === 1 ? `Geçersiz değer: beklenen ${i.stringifyPrimitive(f.values[0])}` : `Geçersiz seçenek: aşağıdakilerden biri olmalı: ${i.joinValues(f.values, "|")}`;
          case "too_big": {
            const d = f.inclusive ? "<=" : "<", p = a(f.origin);
            return p ? `Çok büyük: beklenen ${f.origin ?? "değer"} ${d}${f.maximum.toString()} ${p.unit ?? "öğe"}` : `Çok büyük: beklenen ${f.origin ?? "değer"} ${d}${f.maximum.toString()}`;
          }
          case "too_small": {
            const d = f.inclusive ? ">=" : ">", p = a(f.origin);
            return p ? `Çok küçük: beklenen ${f.origin} ${d}${f.minimum.toString()} ${p.unit}` : `Çok küçük: beklenen ${f.origin} ${d}${f.minimum.toString()}`;
          }
          case "invalid_format": {
            const d = f;
            return d.format === "starts_with" ? `Geçersiz metin: "${d.prefix}" ile başlamalı` : d.format === "ends_with" ? `Geçersiz metin: "${d.suffix}" ile bitmeli` : d.format === "includes" ? `Geçersiz metin: "${d.includes}" içermeli` : d.format === "regex" ? `Geçersiz metin: ${d.pattern} desenine uymalı` : `Geçersiz ${u[d.format] ?? f.format}`;
          }
          case "not_multiple_of":
            return `Geçersiz sayı: ${f.divisor} ile tam bölünebilmeli`;
          case "unrecognized_keys":
            return `Tanınmayan anahtar${f.keys.length > 1 ? "lar" : ""}: ${i.joinValues(f.keys, ", ")}`;
          case "invalid_key":
            return `${f.origin} içinde geçersiz anahtar`;
          case "invalid_union":
            return "Geçersiz değer";
          case "invalid_element":
            return `${f.origin} içinde geçersiz değer`;
          default:
            return "Geçersiz değer";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
  }(dp)), dp;
}
var cE = { exports: {} }, uE = { exports: {} }, Z0 = uE.exports, Kge;
function E4e() {
  return Kge || (Kge = 1, function(e, t) {
    var n = Z0 && Z0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = Z0 && Z0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = Z0 && Z0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "символів", verb: "матиме" },
        file: { unit: "байтів", verb: "матиме" },
        array: { unit: "елементів", verb: "матиме" },
        set: { unit: "елементів", verb: "матиме" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "число";
          case "object": {
            if (Array.isArray(d))
              return "масив";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "вхідні дані",
        email: "адреса електронної пошти",
        url: "URL",
        emoji: "емодзі",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "дата та час ISO",
        date: "дата ISO",
        time: "час ISO",
        duration: "тривалість ISO",
        ipv4: "адреса IPv4",
        ipv6: "адреса IPv6",
        cidrv4: "діапазон IPv4",
        cidrv6: "діапазон IPv6",
        base64: "рядок у кодуванні base64",
        base64url: "рядок у кодуванні base64url",
        json_string: "рядок JSON",
        e164: "номер E.164",
        jwt: "JWT",
        template_literal: "вхідні дані"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Неправильні вхідні дані: очікується ${d.expected}, отримано ${u(d.input)}`;
          // return `Неправильні вхідні дані: очікується ${issue.expected}, отримано ${util.getParsedType(issue.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Неправильні вхідні дані: очікується ${o.stringifyPrimitive(d.values[0])}` : `Неправильна опція: очікується одне з ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Занадто велике: очікується, що ${d.origin ?? "значення"} ${h.verb} ${p}${d.maximum.toString()} ${h.unit ?? "елементів"}` : `Занадто велике: очікується, що ${d.origin ?? "значення"} буде ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Занадто мале: очікується, що ${d.origin} ${h.verb} ${p}${d.minimum.toString()} ${h.unit}` : `Занадто мале: очікується, що ${d.origin} буде ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Неправильний рядок: повинен починатися з "${p.prefix}"` : p.format === "ends_with" ? `Неправильний рядок: повинен закінчуватися на "${p.suffix}"` : p.format === "includes" ? `Неправильний рядок: повинен містити "${p.includes}"` : p.format === "regex" ? `Неправильний рядок: повинен відповідати шаблону ${p.pattern}` : `Неправильний ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Неправильне число: повинно бути кратним ${d.divisor}`;
          case "unrecognized_keys":
            return `Нерозпізнаний ключ${d.keys.length > 1 ? "і" : ""}: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Неправильний ключ у ${d.origin}`;
          case "invalid_union":
            return "Неправильні вхідні дані";
          case "invalid_element":
            return `Неправильне значення у ${d.origin}`;
          default:
            return "Неправильні вхідні дані";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(uE, uE.exports)), uE.exports;
}
var Gge = cE.exports, Yge;
function Tcn() {
  return Yge || (Yge = 1, function(e, t) {
    var n = Gge && Gge.__importDefault || function(o) {
      return o && o.__esModule ? o : { default: o };
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = i;
    const r = n(E4e());
    function i() {
      return (0, r.default)();
    }
    e.exports = t.default;
  }(cE, cE.exports)), cE.exports;
}
var dE = { exports: {} }, H0 = dE.exports, Jge;
function kcn() {
  return Jge || (Jge = 1, function(e, t) {
    var n = H0 && H0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = H0 && H0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = H0 && H0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "حروف", verb: "ہونا" },
        file: { unit: "بائٹس", verb: "ہونا" },
        array: { unit: "آئٹمز", verb: "ہونا" },
        set: { unit: "آئٹمز", verb: "ہونا" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "نمبر";
          case "object": {
            if (Array.isArray(d))
              return "آرے";
            if (d === null)
              return "نل";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ان پٹ",
        email: "ای میل ایڈریس",
        url: "یو آر ایل",
        emoji: "ایموجی",
        uuid: "یو یو آئی ڈی",
        uuidv4: "یو یو آئی ڈی وی 4",
        uuidv6: "یو یو آئی ڈی وی 6",
        nanoid: "نینو آئی ڈی",
        guid: "جی یو آئی ڈی",
        cuid: "سی یو آئی ڈی",
        cuid2: "سی یو آئی ڈی 2",
        ulid: "یو ایل آئی ڈی",
        xid: "ایکس آئی ڈی",
        ksuid: "کے ایس یو آئی ڈی",
        datetime: "آئی ایس او ڈیٹ ٹائم",
        date: "آئی ایس او تاریخ",
        time: "آئی ایس او وقت",
        duration: "آئی ایس او مدت",
        ipv4: "آئی پی وی 4 ایڈریس",
        ipv6: "آئی پی وی 6 ایڈریس",
        cidrv4: "آئی پی وی 4 رینج",
        cidrv6: "آئی پی وی 6 رینج",
        base64: "بیس 64 ان کوڈڈ سٹرنگ",
        base64url: "بیس 64 یو آر ایل ان کوڈڈ سٹرنگ",
        json_string: "جے ایس او این سٹرنگ",
        e164: "ای 164 نمبر",
        jwt: "جے ڈبلیو ٹی",
        template_literal: "ان پٹ"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `غلط ان پٹ: ${d.expected} متوقع تھا، ${u(d.input)} موصول ہوا`;
          case "invalid_value":
            return d.values.length === 1 ? `غلط ان پٹ: ${o.stringifyPrimitive(d.values[0])} متوقع تھا` : `غلط آپشن: ${o.joinValues(d.values, "|")} میں سے ایک متوقع تھا`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `بہت بڑا: ${d.origin ?? "ویلیو"} کے ${p}${d.maximum.toString()} ${h.unit ?? "عناصر"} ہونے متوقع تھے` : `بہت بڑا: ${d.origin ?? "ویلیو"} کا ${p}${d.maximum.toString()} ہونا متوقع تھا`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `بہت چھوٹا: ${d.origin} کے ${p}${d.minimum.toString()} ${h.unit} ہونے متوقع تھے` : `بہت چھوٹا: ${d.origin} کا ${p}${d.minimum.toString()} ہونا متوقع تھا`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `غلط سٹرنگ: "${p.prefix}" سے شروع ہونا چاہیے` : p.format === "ends_with" ? `غلط سٹرنگ: "${p.suffix}" پر ختم ہونا چاہیے` : p.format === "includes" ? `غلط سٹرنگ: "${p.includes}" شامل ہونا چاہیے` : p.format === "regex" ? `غلط سٹرنگ: پیٹرن ${p.pattern} سے میچ ہونا چاہیے` : `غلط ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `غلط نمبر: ${d.divisor} کا مضاعف ہونا چاہیے`;
          case "unrecognized_keys":
            return `غیر تسلیم شدہ کی${d.keys.length > 1 ? "ز" : ""}: ${o.joinValues(d.keys, "، ")}`;
          case "invalid_key":
            return `${d.origin} میں غلط کی`;
          case "invalid_union":
            return "غلط ان پٹ";
          case "invalid_element":
            return `${d.origin} میں غلط ویلیو`;
          default:
            return "غلط ان پٹ";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(dE, dE.exports)), dE.exports;
}
var fE = { exports: {} }, Q0 = fE.exports, eye;
function Ccn() {
  return eye || (eye = 1, function(e, t) {
    var n = Q0 && Q0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = Q0 && Q0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = Q0 && Q0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "ký tự", verb: "có" },
        file: { unit: "byte", verb: "có" },
        array: { unit: "phần tử", verb: "có" },
        set: { unit: "phần tử", verb: "có" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "số";
          case "object": {
            if (Array.isArray(d))
              return "mảng";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "đầu vào",
        email: "địa chỉ email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ngày giờ ISO",
        date: "ngày ISO",
        time: "giờ ISO",
        duration: "khoảng thời gian ISO",
        ipv4: "địa chỉ IPv4",
        ipv6: "địa chỉ IPv6",
        cidrv4: "dải IPv4",
        cidrv6: "dải IPv6",
        base64: "chuỗi mã hóa base64",
        base64url: "chuỗi mã hóa base64url",
        json_string: "chuỗi JSON",
        e164: "số E.164",
        jwt: "JWT",
        template_literal: "đầu vào"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Đầu vào không hợp lệ: mong đợi ${d.expected}, nhận được ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Đầu vào không hợp lệ: mong đợi ${o.stringifyPrimitive(d.values[0])}` : `Tùy chọn không hợp lệ: mong đợi một trong các giá trị ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Quá lớn: mong đợi ${d.origin ?? "giá trị"} ${h.verb} ${p}${d.maximum.toString()} ${h.unit ?? "phần tử"}` : `Quá lớn: mong đợi ${d.origin ?? "giá trị"} ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Quá nhỏ: mong đợi ${d.origin} ${h.verb} ${p}${d.minimum.toString()} ${h.unit}` : `Quá nhỏ: mong đợi ${d.origin} ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Chuỗi không hợp lệ: phải bắt đầu bằng "${p.prefix}"` : p.format === "ends_with" ? `Chuỗi không hợp lệ: phải kết thúc bằng "${p.suffix}"` : p.format === "includes" ? `Chuỗi không hợp lệ: phải bao gồm "${p.includes}"` : p.format === "regex" ? `Chuỗi không hợp lệ: phải khớp với mẫu ${p.pattern}` : `${f[p.format] ?? d.format} không hợp lệ`;
          }
          case "not_multiple_of":
            return `Số không hợp lệ: phải là bội số của ${d.divisor}`;
          case "unrecognized_keys":
            return `Khóa không được nhận dạng: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Khóa không hợp lệ trong ${d.origin}`;
          case "invalid_union":
            return "Đầu vào không hợp lệ";
          case "invalid_element":
            return `Giá trị không hợp lệ trong ${d.origin}`;
          default:
            return "Đầu vào không hợp lệ";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(fE, fE.exports)), fE.exports;
}
var pE = { exports: {} }, $0 = pE.exports, tye;
function Ncn() {
  return tye || (tye = 1, function(e, t) {
    var n = $0 && $0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = $0 && $0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = $0 && $0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "字符", verb: "包含" },
        file: { unit: "字节", verb: "包含" },
        array: { unit: "项", verb: "包含" },
        set: { unit: "项", verb: "包含" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "非数字(NaN)" : "数字";
          case "object": {
            if (Array.isArray(d))
              return "数组";
            if (d === null)
              return "空值(null)";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "输入",
        email: "电子邮件",
        url: "URL",
        emoji: "表情符号",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO日期时间",
        date: "ISO日期",
        time: "ISO时间",
        duration: "ISO时长",
        ipv4: "IPv4地址",
        ipv6: "IPv6地址",
        cidrv4: "IPv4网段",
        cidrv6: "IPv6网段",
        base64: "base64编码字符串",
        base64url: "base64url编码字符串",
        json_string: "JSON字符串",
        e164: "E.164号码",
        jwt: "JWT",
        template_literal: "输入"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `无效输入：期望 ${d.expected}，实际接收 ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `无效输入：期望 ${o.stringifyPrimitive(d.values[0])}` : `无效选项：期望以下之一 ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `数值过大：期望 ${d.origin ?? "值"} ${p}${d.maximum.toString()} ${h.unit ?? "个元素"}` : `数值过大：期望 ${d.origin ?? "值"} ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `数值过小：期望 ${d.origin} ${p}${d.minimum.toString()} ${h.unit}` : `数值过小：期望 ${d.origin} ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `无效字符串：必须以 "${p.prefix}" 开头` : p.format === "ends_with" ? `无效字符串：必须以 "${p.suffix}" 结尾` : p.format === "includes" ? `无效字符串：必须包含 "${p.includes}"` : p.format === "regex" ? `无效字符串：必须满足正则表达式 ${p.pattern}` : `无效${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `无效数字：必须是 ${d.divisor} 的倍数`;
          case "unrecognized_keys":
            return `出现未知的键(key): ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `${d.origin} 中的键(key)无效`;
          case "invalid_union":
            return "无效输入";
          case "invalid_element":
            return `${d.origin} 中包含无效值(value)`;
          default:
            return "无效输入";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(pE, pE.exports)), pE.exports;
}
var hE = { exports: {} }, K0 = hE.exports, nye;
function Pcn() {
  return nye || (nye = 1, function(e, t) {
    var n = K0 && K0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = K0 && K0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = K0 && K0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "字元", verb: "擁有" },
        file: { unit: "位元組", verb: "擁有" },
        array: { unit: "項目", verb: "擁有" },
        set: { unit: "項目", verb: "擁有" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "number";
          case "object": {
            if (Array.isArray(d))
              return "array";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "輸入",
        email: "郵件地址",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO 日期時間",
        date: "ISO 日期",
        time: "ISO 時間",
        duration: "ISO 期間",
        ipv4: "IPv4 位址",
        ipv6: "IPv6 位址",
        cidrv4: "IPv4 範圍",
        cidrv6: "IPv6 範圍",
        base64: "base64 編碼字串",
        base64url: "base64url 編碼字串",
        json_string: "JSON 字串",
        e164: "E.164 數值",
        jwt: "JWT",
        template_literal: "輸入"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `無效的輸入值：預期為 ${d.expected}，但收到 ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `無效的輸入值：預期為 ${o.stringifyPrimitive(d.values[0])}` : `無效的選項：預期為以下其中之一 ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `數值過大：預期 ${d.origin ?? "值"} 應為 ${p}${d.maximum.toString()} ${h.unit ?? "個元素"}` : `數值過大：預期 ${d.origin ?? "值"} 應為 ${p}${d.maximum.toString()}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `數值過小：預期 ${d.origin} 應為 ${p}${d.minimum.toString()} ${h.unit}` : `數值過小：預期 ${d.origin} 應為 ${p}${d.minimum.toString()}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `無效的字串：必須以 "${p.prefix}" 開頭` : p.format === "ends_with" ? `無效的字串：必須以 "${p.suffix}" 結尾` : p.format === "includes" ? `無效的字串：必須包含 "${p.includes}"` : p.format === "regex" ? `無效的字串：必須符合格式 ${p.pattern}` : `無效的 ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `無效的數字：必須為 ${d.divisor} 的倍數`;
          case "unrecognized_keys":
            return `無法識別的鍵值${d.keys.length > 1 ? "們" : ""}：${o.joinValues(d.keys, "、")}`;
          case "invalid_key":
            return `${d.origin} 中有無效的鍵值`;
          case "invalid_union":
            return "無效的輸入值";
          case "invalid_element":
            return `${d.origin} 中有無效的值`;
          default:
            return "無效的輸入值";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(hE, hE.exports)), hE.exports;
}
var mE = { exports: {} }, G0 = mE.exports, rye;
function Icn() {
  return rye || (rye = 1, function(e, t) {
    var n = G0 && G0.__createBinding || (Object.create ? function(c, a, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(a, u);
      (!d || ("get" in d ? !a.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return a[u];
      } }), Object.defineProperty(c, f, d);
    } : function(c, a, u, f) {
      f === void 0 && (f = u), c[f] = a[u];
    }), r = G0 && G0.__setModuleDefault || (Object.create ? function(c, a) {
      Object.defineProperty(c, "default", { enumerable: !0, value: a });
    } : function(c, a) {
      c.default = a;
    }), i = G0 && G0.__importStar || function(c) {
      if (c && c.__esModule) return c;
      var a = {};
      if (c != null) for (var u in c) u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && n(a, c, u);
      return r(a, c), a;
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = l;
    const o = i(fn()), s = () => {
      const c = {
        string: { unit: "àmi", verb: "ní" },
        file: { unit: "bytes", verb: "ní" },
        array: { unit: "nkan", verb: "ní" },
        set: { unit: "nkan", verb: "ní" }
      };
      function a(d) {
        return c[d] ?? null;
      }
      const u = (d) => {
        const p = typeof d;
        switch (p) {
          case "number":
            return Number.isNaN(d) ? "NaN" : "nọ́mbà";
          case "object": {
            if (Array.isArray(d))
              return "akopọ";
            if (d === null)
              return "null";
            if (Object.getPrototypeOf(d) !== Object.prototype && d.constructor)
              return d.constructor.name;
          }
        }
        return p;
      }, f = {
        regex: "ẹ̀rọ ìbáwọlé",
        email: "àdírẹ́sì ìmẹ́lì",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "àkókò ISO",
        date: "ọjọ́ ISO",
        time: "àkókò ISO",
        duration: "àkókò tó pé ISO",
        ipv4: "àdírẹ́sì IPv4",
        ipv6: "àdírẹ́sì IPv6",
        cidrv4: "àgbègbè IPv4",
        cidrv6: "àgbègbè IPv6",
        base64: "ọ̀rọ̀ tí a kọ́ ní base64",
        base64url: "ọ̀rọ̀ base64url",
        json_string: "ọ̀rọ̀ JSON",
        e164: "nọ́mbà E.164",
        jwt: "JWT",
        template_literal: "ẹ̀rọ ìbáwọlé"
      };
      return (d) => {
        switch (d.code) {
          case "invalid_type":
            return `Ìbáwọlé aṣìṣe: a ní láti fi ${d.expected}, àmọ̀ a rí ${u(d.input)}`;
          case "invalid_value":
            return d.values.length === 1 ? `Ìbáwọlé aṣìṣe: a ní láti fi ${o.stringifyPrimitive(d.values[0])}` : `Àṣàyàn aṣìṣe: yan ọ̀kan lára ${o.joinValues(d.values, "|")}`;
          case "too_big": {
            const p = d.inclusive ? "<=" : "<", h = a(d.origin);
            return h ? `Tó pọ̀ jù: a ní láti jẹ́ pé ${d.origin ?? "iye"} ${h.verb} ${p}${d.maximum} ${h.unit}` : `Tó pọ̀ jù: a ní láti jẹ́ ${p}${d.maximum}`;
          }
          case "too_small": {
            const p = d.inclusive ? ">=" : ">", h = a(d.origin);
            return h ? `Kéré ju: a ní láti jẹ́ pé ${d.origin} ${h.verb} ${p}${d.minimum} ${h.unit}` : `Kéré ju: a ní láti jẹ́ ${p}${d.minimum}`;
          }
          case "invalid_format": {
            const p = d;
            return p.format === "starts_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bẹ̀rẹ̀ pẹ̀lú "${p.prefix}"` : p.format === "ends_with" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ parí pẹ̀lú "${p.suffix}"` : p.format === "includes" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ ní "${p.includes}"` : p.format === "regex" ? `Ọ̀rọ̀ aṣìṣe: gbọ́dọ̀ bá àpẹẹrẹ mu ${p.pattern}` : `Aṣìṣe: ${f[p.format] ?? d.format}`;
          }
          case "not_multiple_of":
            return `Nọ́mbà aṣìṣe: gbọ́dọ̀ jẹ́ èyà pípín ti ${d.divisor}`;
          case "unrecognized_keys":
            return `Bọtìnì àìmọ̀: ${o.joinValues(d.keys, ", ")}`;
          case "invalid_key":
            return `Bọtìnì aṣìṣe nínú ${d.origin}`;
          case "invalid_union":
            return "Ìbáwọlé aṣìṣe";
          case "invalid_element":
            return `Iye aṣìṣe nínú ${d.origin}`;
          default:
            return "Ìbáwọlé aṣìṣe";
        }
      };
    };
    function l() {
      return {
        localeError: s()
      };
    }
    e.exports = t.default;
  }(mE, mE.exports)), mE.exports;
}
var iye;
function T4e() {
  return iye || (iye = 1, function(e) {
    var t = QS && QS.__importDefault || function(Ce) {
      return Ce && Ce.__esModule ? Ce : { default: Ce };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.yo = e.zhTW = e.zhCN = e.vi = e.ur = e.uk = e.ua = e.tr = e.th = e.ta = e.sv = e.sl = e.ru = e.pt = e.pl = e.ps = e.ota = e.no = e.nl = e.ms = e.mk = e.lt = e.ko = e.km = e.kh = e.ka = e.ja = e.it = e.is = e.id = e.hu = e.he = e.frCA = e.fr = e.fi = e.fa = e.es = e.eo = e.en = e.de = e.da = e.cs = e.ca = e.bg = e.be = e.az = e.ar = void 0;
    var n = qln();
    Object.defineProperty(e, "ar", { enumerable: !0, get: function() {
      return t(n).default;
    } });
    var r = Bln();
    Object.defineProperty(e, "az", { enumerable: !0, get: function() {
      return t(r).default;
    } });
    var i = Xln();
    Object.defineProperty(e, "be", { enumerable: !0, get: function() {
      return t(i).default;
    } });
    var o = Wln();
    Object.defineProperty(e, "bg", { enumerable: !0, get: function() {
      return t(o).default;
    } });
    var s = Zln();
    Object.defineProperty(e, "ca", { enumerable: !0, get: function() {
      return t(s).default;
    } });
    var l = Hln();
    Object.defineProperty(e, "cs", { enumerable: !0, get: function() {
      return t(l).default;
    } });
    var c = Qln();
    Object.defineProperty(e, "da", { enumerable: !0, get: function() {
      return t(c).default;
    } });
    var a = $ln();
    Object.defineProperty(e, "de", { enumerable: !0, get: function() {
      return t(a).default;
    } });
    var u = x4e();
    Object.defineProperty(e, "en", { enumerable: !0, get: function() {
      return t(u).default;
    } });
    var f = Kln();
    Object.defineProperty(e, "eo", { enumerable: !0, get: function() {
      return t(f).default;
    } });
    var d = Gln();
    Object.defineProperty(e, "es", { enumerable: !0, get: function() {
      return t(d).default;
    } });
    var p = Yln();
    Object.defineProperty(e, "fa", { enumerable: !0, get: function() {
      return t(p).default;
    } });
    var h = Jln();
    Object.defineProperty(e, "fi", { enumerable: !0, get: function() {
      return t(h).default;
    } });
    var m = ecn();
    Object.defineProperty(e, "fr", { enumerable: !0, get: function() {
      return t(m).default;
    } });
    var v = tcn();
    Object.defineProperty(e, "frCA", { enumerable: !0, get: function() {
      return t(v).default;
    } });
    var b = ncn();
    Object.defineProperty(e, "he", { enumerable: !0, get: function() {
      return t(b).default;
    } });
    var A = rcn();
    Object.defineProperty(e, "hu", { enumerable: !0, get: function() {
      return t(A).default;
    } });
    var w = icn();
    Object.defineProperty(e, "id", { enumerable: !0, get: function() {
      return t(w).default;
    } });
    var O = ocn();
    Object.defineProperty(e, "is", { enumerable: !0, get: function() {
      return t(O).default;
    } });
    var x = scn();
    Object.defineProperty(e, "it", { enumerable: !0, get: function() {
      return t(x).default;
    } });
    var S = acn();
    Object.defineProperty(e, "ja", { enumerable: !0, get: function() {
      return t(S).default;
    } });
    var E = lcn();
    Object.defineProperty(e, "ka", { enumerable: !0, get: function() {
      return t(E).default;
    } });
    var k = ccn();
    Object.defineProperty(e, "kh", { enumerable: !0, get: function() {
      return t(k).default;
    } });
    var T = S4e();
    Object.defineProperty(e, "km", { enumerable: !0, get: function() {
      return t(T).default;
    } });
    var R = ucn();
    Object.defineProperty(e, "ko", { enumerable: !0, get: function() {
      return t(R).default;
    } });
    var j = dcn();
    Object.defineProperty(e, "lt", { enumerable: !0, get: function() {
      return t(j).default;
    } });
    var F = fcn();
    Object.defineProperty(e, "mk", { enumerable: !0, get: function() {
      return t(F).default;
    } });
    var L = pcn();
    Object.defineProperty(e, "ms", { enumerable: !0, get: function() {
      return t(L).default;
    } });
    var _ = hcn();
    Object.defineProperty(e, "nl", { enumerable: !0, get: function() {
      return t(_).default;
    } });
    var U = mcn();
    Object.defineProperty(e, "no", { enumerable: !0, get: function() {
      return t(U).default;
    } });
    var z = gcn();
    Object.defineProperty(e, "ota", { enumerable: !0, get: function() {
      return t(z).default;
    } });
    var C = ycn();
    Object.defineProperty(e, "ps", { enumerable: !0, get: function() {
      return t(C).default;
    } });
    var I = vcn();
    Object.defineProperty(e, "pl", { enumerable: !0, get: function() {
      return t(I).default;
    } });
    var M = bcn();
    Object.defineProperty(e, "pt", { enumerable: !0, get: function() {
      return t(M).default;
    } });
    var D = Ocn();
    Object.defineProperty(e, "ru", { enumerable: !0, get: function() {
      return t(D).default;
    } });
    var X = Acn();
    Object.defineProperty(e, "sl", { enumerable: !0, get: function() {
      return t(X).default;
    } });
    var B = wcn();
    Object.defineProperty(e, "sv", { enumerable: !0, get: function() {
      return t(B).default;
    } });
    var q = xcn();
    Object.defineProperty(e, "ta", { enumerable: !0, get: function() {
      return t(q).default;
    } });
    var H = Scn();
    Object.defineProperty(e, "th", { enumerable: !0, get: function() {
      return t(H).default;
    } });
    var Y = Ecn();
    Object.defineProperty(e, "tr", { enumerable: !0, get: function() {
      return t(Y).default;
    } });
    var J = Tcn();
    Object.defineProperty(e, "ua", { enumerable: !0, get: function() {
      return t(J).default;
    } });
    var oe = E4e();
    Object.defineProperty(e, "uk", { enumerable: !0, get: function() {
      return t(oe).default;
    } });
    var ce = kcn();
    Object.defineProperty(e, "ur", { enumerable: !0, get: function() {
      return t(ce).default;
    } });
    var fe = Ccn();
    Object.defineProperty(e, "vi", { enumerable: !0, get: function() {
      return t(fe).default;
    } });
    var $ = Ncn();
    Object.defineProperty(e, "zhCN", { enumerable: !0, get: function() {
      return t($).default;
    } });
    var pe = Pcn();
    Object.defineProperty(e, "zhTW", { enumerable: !0, get: function() {
      return t(pe).default;
    } });
    var ee = Icn();
    Object.defineProperty(e, "yo", { enumerable: !0, get: function() {
      return t(ee).default;
    } });
  }(QS)), QS;
}
var xc = {}, oye;
function YJ() {
  if (oye) return xc;
  oye = 1;
  var e;
  Object.defineProperty(xc, "__esModule", { value: !0 }), xc.globalRegistry = xc.$ZodRegistry = xc.$input = xc.$output = void 0, xc.registry = n, xc.$output = Symbol("ZodOutput"), xc.$input = Symbol("ZodInput");
  class t {
    constructor() {
      this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
    }
    add(i, ...o) {
      const s = o[0];
      if (this._map.set(i, s), s && typeof s == "object" && "id" in s) {
        if (this._idmap.has(s.id))
          throw new Error(`ID ${s.id} already exists in the registry`);
        this._idmap.set(s.id, i);
      }
      return this;
    }
    clear() {
      return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
    }
    remove(i) {
      const o = this._map.get(i);
      return o && typeof o == "object" && "id" in o && this._idmap.delete(o.id), this._map.delete(i), this;
    }
    get(i) {
      const o = i._zod.parent;
      if (o) {
        const s = { ...this.get(o) ?? {} };
        delete s.id;
        const l = { ...s, ...this._map.get(i) };
        return Object.keys(l).length ? l : void 0;
      }
      return this._map.get(i);
    }
    has(i) {
      return this._map.has(i);
    }
  }
  xc.$ZodRegistry = t;
  function n() {
    return new t();
  }
  return (e = globalThis).__zod_globalRegistry ?? (e.__zod_globalRegistry = n()), xc.globalRegistry = globalThis.__zod_globalRegistry, xc;
}
var Je = {}, sye;
function Rcn() {
  if (sye) return Je;
  sye = 1;
  var e = Je && Je.__createBinding || (Object.create ? function(ye, Ae, ht, On) {
    On === void 0 && (On = ht);
    var Wn = Object.getOwnPropertyDescriptor(Ae, ht);
    (!Wn || ("get" in Wn ? !Ae.__esModule : Wn.writable || Wn.configurable)) && (Wn = { enumerable: !0, get: function() {
      return Ae[ht];
    } }), Object.defineProperty(ye, On, Wn);
  } : function(ye, Ae, ht, On) {
    On === void 0 && (On = ht), ye[On] = Ae[ht];
  }), t = Je && Je.__setModuleDefault || (Object.create ? function(ye, Ae) {
    Object.defineProperty(ye, "default", { enumerable: !0, value: Ae });
  } : function(ye, Ae) {
    ye.default = Ae;
  }), n = Je && Je.__importStar || function(ye) {
    if (ye && ye.__esModule) return ye;
    var Ae = {};
    if (ye != null) for (var ht in ye) ht !== "default" && Object.prototype.hasOwnProperty.call(ye, ht) && e(Ae, ye, ht);
    return t(Ae, ye), Ae;
  };
  Object.defineProperty(Je, "__esModule", { value: !0 }), Je.TimePrecision = void 0, Je._string = l, Je._coercedString = c, Je._email = a, Je._guid = u, Je._uuid = f, Je._uuidv4 = d, Je._uuidv6 = p, Je._uuidv7 = h, Je._url = m, Je._emoji = v, Je._nanoid = b, Je._cuid = A, Je._cuid2 = w, Je._ulid = O, Je._xid = x, Je._ksuid = S, Je._ipv4 = E, Je._ipv6 = k, Je._mac = T, Je._cidrv4 = R, Je._cidrv6 = j, Je._base64 = F, Je._base64url = L, Je._e164 = _, Je._jwt = U, Je._isoDateTime = z, Je._isoDate = C, Je._isoTime = I, Je._isoDuration = M, Je._number = D, Je._coercedNumber = X, Je._int = B, Je._float32 = q, Je._float64 = H, Je._int32 = Y, Je._uint32 = J, Je._boolean = oe, Je._coercedBoolean = ce, Je._bigint = fe, Je._coercedBigint = $, Je._int64 = pe, Je._uint64 = ee, Je._symbol = Ce, Je._undefined = Ee, Je._null = Ve, Je._any = et, Je._unknown = ft, Je._never = me, Je._void = Te, Je._date = re, Je._coercedDate = le, Je._nan = Oe, Je._lt = be, Je._lte = je, Je._max = je, Je._lte = je, Je._max = je, Je._gt = xe, Je._gte = Q, Je._min = Q, Je._gte = Q, Je._min = Q, Je._positive = ae, Je._negative = Pe, Je._nonpositive = Fe, Je._nonnegative = Ke, Je._multipleOf = Ot, Je._maxSize = Ct, Je._minSize = Jt, Je._size = yn, Je._maxLength = vn, Je._minLength = Re, Je._length = _e, Je._regex = jt, Je._lowercase = st, Je._uppercase = Mt, Je._includes = lt, Je._startsWith = xt, Je._endsWith = yt, Je._property = ct, Je._mime = Rt, Je._overwrite = Yt, Je._normalize = Gt, Je._trim = hn, Je._toLowerCase = en, Je._toUpperCase = Sn, Je._slugify = Ar, Je._array = or, Je._union = rr, Je._discriminatedUnion = no, Je._intersection = jn, Je._tuple = Xi, Je._record = us, Je._map = ca, Je._set = ge, Je._enum = ve, Je._nativeEnum = se, Je._literal = P, Je._file = W, Je._transform = te, Je._optional = de, Je._nullable = Ne, Je._default = Me, Je._nonoptional = Ge, Je._success = $t, Je._catch = In, Je._pipe = Qn, Je._readonly = yr, Je._templateLiteral = Cn, Je._lazy = Ln, Je._promise = Lr, Je._custom = bn, Je._refine = Cr, Je._superRefine = ro, Je._check = zs, Je.describe = xd, Je.meta = ua, Je._stringbool = Pl, Je._stringFormat = Il;
  const r = n(GJ()), i = n(YJ()), o = n(w4e()), s = n(fn());
  function l(ye, Ae) {
    return new ye({
      type: "string",
      ...s.normalizeParams(Ae)
    });
  }
  function c(ye, Ae) {
    return new ye({
      type: "string",
      coerce: !0,
      ...s.normalizeParams(Ae)
    });
  }
  function a(ye, Ae) {
    return new ye({
      type: "string",
      format: "email",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function u(ye, Ae) {
    return new ye({
      type: "string",
      format: "guid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function f(ye, Ae) {
    return new ye({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function d(ye, Ae) {
    return new ye({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v4",
      ...s.normalizeParams(Ae)
    });
  }
  function p(ye, Ae) {
    return new ye({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v6",
      ...s.normalizeParams(Ae)
    });
  }
  function h(ye, Ae) {
    return new ye({
      type: "string",
      format: "uuid",
      check: "string_format",
      abort: !1,
      version: "v7",
      ...s.normalizeParams(Ae)
    });
  }
  function m(ye, Ae) {
    return new ye({
      type: "string",
      format: "url",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function v(ye, Ae) {
    return new ye({
      type: "string",
      format: "emoji",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function b(ye, Ae) {
    return new ye({
      type: "string",
      format: "nanoid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function A(ye, Ae) {
    return new ye({
      type: "string",
      format: "cuid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function w(ye, Ae) {
    return new ye({
      type: "string",
      format: "cuid2",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function O(ye, Ae) {
    return new ye({
      type: "string",
      format: "ulid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function x(ye, Ae) {
    return new ye({
      type: "string",
      format: "xid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function S(ye, Ae) {
    return new ye({
      type: "string",
      format: "ksuid",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function E(ye, Ae) {
    return new ye({
      type: "string",
      format: "ipv4",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function k(ye, Ae) {
    return new ye({
      type: "string",
      format: "ipv6",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function T(ye, Ae) {
    return new ye({
      type: "string",
      format: "mac",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function R(ye, Ae) {
    return new ye({
      type: "string",
      format: "cidrv4",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function j(ye, Ae) {
    return new ye({
      type: "string",
      format: "cidrv6",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function F(ye, Ae) {
    return new ye({
      type: "string",
      format: "base64",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function L(ye, Ae) {
    return new ye({
      type: "string",
      format: "base64url",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function _(ye, Ae) {
    return new ye({
      type: "string",
      format: "e164",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  function U(ye, Ae) {
    return new ye({
      type: "string",
      format: "jwt",
      check: "string_format",
      abort: !1,
      ...s.normalizeParams(Ae)
    });
  }
  Je.TimePrecision = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
  };
  function z(ye, Ae) {
    return new ye({
      type: "string",
      format: "datetime",
      check: "string_format",
      offset: !1,
      local: !1,
      precision: null,
      ...s.normalizeParams(Ae)
    });
  }
  function C(ye, Ae) {
    return new ye({
      type: "string",
      format: "date",
      check: "string_format",
      ...s.normalizeParams(Ae)
    });
  }
  function I(ye, Ae) {
    return new ye({
      type: "string",
      format: "time",
      check: "string_format",
      precision: null,
      ...s.normalizeParams(Ae)
    });
  }
  function M(ye, Ae) {
    return new ye({
      type: "string",
      format: "duration",
      check: "string_format",
      ...s.normalizeParams(Ae)
    });
  }
  function D(ye, Ae) {
    return new ye({
      type: "number",
      checks: [],
      ...s.normalizeParams(Ae)
    });
  }
  function X(ye, Ae) {
    return new ye({
      type: "number",
      coerce: !0,
      checks: [],
      ...s.normalizeParams(Ae)
    });
  }
  function B(ye, Ae) {
    return new ye({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "safeint",
      ...s.normalizeParams(Ae)
    });
  }
  function q(ye, Ae) {
    return new ye({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float32",
      ...s.normalizeParams(Ae)
    });
  }
  function H(ye, Ae) {
    return new ye({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "float64",
      ...s.normalizeParams(Ae)
    });
  }
  function Y(ye, Ae) {
    return new ye({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "int32",
      ...s.normalizeParams(Ae)
    });
  }
  function J(ye, Ae) {
    return new ye({
      type: "number",
      check: "number_format",
      abort: !1,
      format: "uint32",
      ...s.normalizeParams(Ae)
    });
  }
  function oe(ye, Ae) {
    return new ye({
      type: "boolean",
      ...s.normalizeParams(Ae)
    });
  }
  function ce(ye, Ae) {
    return new ye({
      type: "boolean",
      coerce: !0,
      ...s.normalizeParams(Ae)
    });
  }
  function fe(ye, Ae) {
    return new ye({
      type: "bigint",
      ...s.normalizeParams(Ae)
    });
  }
  function $(ye, Ae) {
    return new ye({
      type: "bigint",
      coerce: !0,
      ...s.normalizeParams(Ae)
    });
  }
  function pe(ye, Ae) {
    return new ye({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "int64",
      ...s.normalizeParams(Ae)
    });
  }
  function ee(ye, Ae) {
    return new ye({
      type: "bigint",
      check: "bigint_format",
      abort: !1,
      format: "uint64",
      ...s.normalizeParams(Ae)
    });
  }
  function Ce(ye, Ae) {
    return new ye({
      type: "symbol",
      ...s.normalizeParams(Ae)
    });
  }
  function Ee(ye, Ae) {
    return new ye({
      type: "undefined",
      ...s.normalizeParams(Ae)
    });
  }
  function Ve(ye, Ae) {
    return new ye({
      type: "null",
      ...s.normalizeParams(Ae)
    });
  }
  function et(ye) {
    return new ye({
      type: "any"
    });
  }
  function ft(ye) {
    return new ye({
      type: "unknown"
    });
  }
  function me(ye, Ae) {
    return new ye({
      type: "never",
      ...s.normalizeParams(Ae)
    });
  }
  function Te(ye, Ae) {
    return new ye({
      type: "void",
      ...s.normalizeParams(Ae)
    });
  }
  function re(ye, Ae) {
    return new ye({
      type: "date",
      ...s.normalizeParams(Ae)
    });
  }
  function le(ye, Ae) {
    return new ye({
      type: "date",
      coerce: !0,
      ...s.normalizeParams(Ae)
    });
  }
  function Oe(ye, Ae) {
    return new ye({
      type: "nan",
      ...s.normalizeParams(Ae)
    });
  }
  function be(ye, Ae) {
    return new r.$ZodCheckLessThan({
      check: "less_than",
      ...s.normalizeParams(Ae),
      value: ye,
      inclusive: !1
    });
  }
  function je(ye, Ae) {
    return new r.$ZodCheckLessThan({
      check: "less_than",
      ...s.normalizeParams(Ae),
      value: ye,
      inclusive: !0
    });
  }
  function xe(ye, Ae) {
    return new r.$ZodCheckGreaterThan({
      check: "greater_than",
      ...s.normalizeParams(Ae),
      value: ye,
      inclusive: !1
    });
  }
  function Q(ye, Ae) {
    return new r.$ZodCheckGreaterThan({
      check: "greater_than",
      ...s.normalizeParams(Ae),
      value: ye,
      inclusive: !0
    });
  }
  function ae(ye) {
    return xe(0, ye);
  }
  function Pe(ye) {
    return be(0, ye);
  }
  function Fe(ye) {
    return je(0, ye);
  }
  function Ke(ye) {
    return Q(0, ye);
  }
  function Ot(ye, Ae) {
    return new r.$ZodCheckMultipleOf({
      check: "multiple_of",
      ...s.normalizeParams(Ae),
      value: ye
    });
  }
  function Ct(ye, Ae) {
    return new r.$ZodCheckMaxSize({
      check: "max_size",
      ...s.normalizeParams(Ae),
      maximum: ye
    });
  }
  function Jt(ye, Ae) {
    return new r.$ZodCheckMinSize({
      check: "min_size",
      ...s.normalizeParams(Ae),
      minimum: ye
    });
  }
  function yn(ye, Ae) {
    return new r.$ZodCheckSizeEquals({
      check: "size_equals",
      ...s.normalizeParams(Ae),
      size: ye
    });
  }
  function vn(ye, Ae) {
    return new r.$ZodCheckMaxLength({
      check: "max_length",
      ...s.normalizeParams(Ae),
      maximum: ye
    });
  }
  function Re(ye, Ae) {
    return new r.$ZodCheckMinLength({
      check: "min_length",
      ...s.normalizeParams(Ae),
      minimum: ye
    });
  }
  function _e(ye, Ae) {
    return new r.$ZodCheckLengthEquals({
      check: "length_equals",
      ...s.normalizeParams(Ae),
      length: ye
    });
  }
  function jt(ye, Ae) {
    return new r.$ZodCheckRegex({
      check: "string_format",
      format: "regex",
      ...s.normalizeParams(Ae),
      pattern: ye
    });
  }
  function st(ye) {
    return new r.$ZodCheckLowerCase({
      check: "string_format",
      format: "lowercase",
      ...s.normalizeParams(ye)
    });
  }
  function Mt(ye) {
    return new r.$ZodCheckUpperCase({
      check: "string_format",
      format: "uppercase",
      ...s.normalizeParams(ye)
    });
  }
  function lt(ye, Ae) {
    return new r.$ZodCheckIncludes({
      check: "string_format",
      format: "includes",
      ...s.normalizeParams(Ae),
      includes: ye
    });
  }
  function xt(ye, Ae) {
    return new r.$ZodCheckStartsWith({
      check: "string_format",
      format: "starts_with",
      ...s.normalizeParams(Ae),
      prefix: ye
    });
  }
  function yt(ye, Ae) {
    return new r.$ZodCheckEndsWith({
      check: "string_format",
      format: "ends_with",
      ...s.normalizeParams(Ae),
      suffix: ye
    });
  }
  function ct(ye, Ae, ht) {
    return new r.$ZodCheckProperty({
      check: "property",
      property: ye,
      schema: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function Rt(ye, Ae) {
    return new r.$ZodCheckMimeType({
      check: "mime_type",
      mime: ye,
      ...s.normalizeParams(Ae)
    });
  }
  function Yt(ye) {
    return new r.$ZodCheckOverwrite({
      check: "overwrite",
      tx: ye
    });
  }
  function Gt(ye) {
    return Yt((Ae) => Ae.normalize(ye));
  }
  function hn() {
    return Yt((ye) => ye.trim());
  }
  function en() {
    return Yt((ye) => ye.toLowerCase());
  }
  function Sn() {
    return Yt((ye) => ye.toUpperCase());
  }
  function Ar() {
    return Yt((ye) => s.slugify(ye));
  }
  function or(ye, Ae, ht) {
    return new ye({
      type: "array",
      element: Ae,
      // get element() {
      //   return element;
      // },
      ...s.normalizeParams(ht)
    });
  }
  function rr(ye, Ae, ht) {
    return new ye({
      type: "union",
      options: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function no(ye, Ae, ht, On) {
    return new ye({
      type: "union",
      options: ht,
      discriminator: Ae,
      ...s.normalizeParams(On)
    });
  }
  function jn(ye, Ae, ht) {
    return new ye({
      type: "intersection",
      left: Ae,
      right: ht
    });
  }
  function Xi(ye, Ae, ht, On) {
    const Wn = ht instanceof o.$ZodType, da = Wn ? On : ht, Oc = Wn ? ht : null;
    return new ye({
      type: "tuple",
      items: Ae,
      rest: Oc,
      ...s.normalizeParams(da)
    });
  }
  function us(ye, Ae, ht, On) {
    return new ye({
      type: "record",
      keyType: Ae,
      valueType: ht,
      ...s.normalizeParams(On)
    });
  }
  function ca(ye, Ae, ht, On) {
    return new ye({
      type: "map",
      keyType: Ae,
      valueType: ht,
      ...s.normalizeParams(On)
    });
  }
  function ge(ye, Ae, ht) {
    return new ye({
      type: "set",
      valueType: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function ve(ye, Ae, ht) {
    const On = Array.isArray(Ae) ? Object.fromEntries(Ae.map((Wn) => [Wn, Wn])) : Ae;
    return new ye({
      type: "enum",
      entries: On,
      ...s.normalizeParams(ht)
    });
  }
  function se(ye, Ae, ht) {
    return new ye({
      type: "enum",
      entries: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function P(ye, Ae, ht) {
    return new ye({
      type: "literal",
      values: Array.isArray(Ae) ? Ae : [Ae],
      ...s.normalizeParams(ht)
    });
  }
  function W(ye, Ae) {
    return new ye({
      type: "file",
      ...s.normalizeParams(Ae)
    });
  }
  function te(ye, Ae) {
    return new ye({
      type: "transform",
      transform: Ae
    });
  }
  function de(ye, Ae) {
    return new ye({
      type: "optional",
      innerType: Ae
    });
  }
  function Ne(ye, Ae) {
    return new ye({
      type: "nullable",
      innerType: Ae
    });
  }
  function Me(ye, Ae, ht) {
    return new ye({
      type: "default",
      innerType: Ae,
      get defaultValue() {
        return typeof ht == "function" ? ht() : s.shallowClone(ht);
      }
    });
  }
  function Ge(ye, Ae, ht) {
    return new ye({
      type: "nonoptional",
      innerType: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function $t(ye, Ae) {
    return new ye({
      type: "success",
      innerType: Ae
    });
  }
  function In(ye, Ae, ht) {
    return new ye({
      type: "catch",
      innerType: Ae,
      catchValue: typeof ht == "function" ? ht : () => ht
    });
  }
  function Qn(ye, Ae, ht) {
    return new ye({
      type: "pipe",
      in: Ae,
      out: ht
    });
  }
  function yr(ye, Ae) {
    return new ye({
      type: "readonly",
      innerType: Ae
    });
  }
  function Cn(ye, Ae, ht) {
    return new ye({
      type: "template_literal",
      parts: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function Ln(ye, Ae) {
    return new ye({
      type: "lazy",
      getter: Ae
    });
  }
  function Lr(ye, Ae) {
    return new ye({
      type: "promise",
      innerType: Ae
    });
  }
  function bn(ye, Ae, ht) {
    const On = s.normalizeParams(ht);
    return On.abort ?? (On.abort = !0), new ye({
      type: "custom",
      check: "custom",
      fn: Ae,
      ...On
    });
  }
  function Cr(ye, Ae, ht) {
    return new ye({
      type: "custom",
      check: "custom",
      fn: Ae,
      ...s.normalizeParams(ht)
    });
  }
  function ro(ye) {
    const Ae = zs((ht) => (ht.addIssue = (On) => {
      if (typeof On == "string")
        ht.issues.push(s.issue(On, ht.value, Ae._zod.def));
      else {
        const Wn = On;
        Wn.fatal && (Wn.continue = !1), Wn.code ?? (Wn.code = "custom"), Wn.input ?? (Wn.input = ht.value), Wn.inst ?? (Wn.inst = Ae), Wn.continue ?? (Wn.continue = !Ae._zod.def.abort), ht.issues.push(s.issue(Wn));
      }
    }, ye(ht.value, ht)));
    return Ae;
  }
  function zs(ye, Ae) {
    const ht = new r.$ZodCheck({
      check: "custom",
      ...s.normalizeParams(Ae)
    });
    return ht._zod.check = ye, ht;
  }
  function xd(ye) {
    const Ae = new r.$ZodCheck({ check: "describe" });
    return Ae._zod.onattach = [
      (ht) => {
        const On = i.globalRegistry.get(ht) ?? {};
        i.globalRegistry.add(ht, { ...On, description: ye });
      }
    ], Ae._zod.check = () => {
    }, Ae;
  }
  function ua(ye) {
    const Ae = new r.$ZodCheck({ check: "meta" });
    return Ae._zod.onattach = [
      (ht) => {
        const On = i.globalRegistry.get(ht) ?? {};
        i.globalRegistry.add(ht, { ...On, ...ye });
      }
    ], Ae._zod.check = () => {
    }, Ae;
  }
  function Pl(ye, Ae) {
    const ht = s.normalizeParams(Ae);
    let On = ht.truthy ?? ["true", "1", "yes", "on", "y", "enabled"], Wn = ht.falsy ?? ["false", "0", "no", "off", "n", "disabled"];
    ht.case !== "sensitive" && (On = On.map((Rl) => typeof Rl == "string" ? Rl.toLowerCase() : Rl), Wn = Wn.map((Rl) => typeof Rl == "string" ? Rl.toLowerCase() : Rl));
    const da = new Set(On), Oc = new Set(Wn), fa = ye.Codec ?? o.$ZodCodec, Ih = ye.Boolean ?? o.$ZodBoolean, Bb = ye.String ?? o.$ZodString, Sd = new Bb({ type: "string", error: ht.error }), Xx = new Ih({ type: "boolean", error: ht.error }), rP = new fa({
      type: "pipe",
      in: Sd,
      out: Xx,
      transform: (Rl, Wx) => {
        let Xb = Rl;
        return ht.case !== "sensitive" && (Xb = Xb.toLowerCase()), da.has(Xb) ? !0 : Oc.has(Xb) ? !1 : (Wx.issues.push({
          code: "invalid_value",
          expected: "stringbool",
          values: [...da, ...Oc],
          input: Wx.value,
          inst: rP,
          continue: !1
        }), {});
      },
      reverseTransform: (Rl, Wx) => Rl === !0 ? On[0] || "true" : Wn[0] || "false",
      error: ht.error
    });
    return rP;
  }
  function Il(ye, Ae, ht, On = {}) {
    const Wn = s.normalizeParams(On), da = {
      ...s.normalizeParams(On),
      check: "string_format",
      type: "string",
      format: Ae,
      fn: typeof ht == "function" ? ht : (fa) => ht.test(fa),
      ...Wn
    };
    return ht instanceof RegExp && (da.pattern = ht), new ye(da);
  }
  return Je;
}
var Y0 = {}, aye;
function Mcn() {
  if (aye) return Y0;
  aye = 1, Object.defineProperty(Y0, "__esModule", { value: !0 }), Y0.JSONSchemaGenerator = void 0, Y0.toJSONSchema = r;
  const e = YJ(), t = fn();
  class n {
    constructor(s) {
      this.counter = 0, this.metadataRegistry = (s == null ? void 0 : s.metadata) ?? e.globalRegistry, this.target = (s == null ? void 0 : s.target) ?? "draft-2020-12", this.unrepresentable = (s == null ? void 0 : s.unrepresentable) ?? "throw", this.override = (s == null ? void 0 : s.override) ?? (() => {
      }), this.io = (s == null ? void 0 : s.io) ?? "output", this.seen = /* @__PURE__ */ new Map();
    }
    process(s, l = { path: [], schemaPath: [] }) {
      var v, b, A;
      var c;
      const a = s._zod.def, u = {
        guid: "uuid",
        url: "uri",
        datetime: "date-time",
        json_string: "json-string",
        regex: ""
        // do not set
      }, f = this.seen.get(s);
      if (f)
        return f.count++, l.schemaPath.includes(s) && (f.cycle = l.path), f.schema;
      const d = { schema: {}, count: 1, cycle: void 0, path: l.path };
      this.seen.set(s, d);
      const p = (b = (v = s._zod).toJSONSchema) == null ? void 0 : b.call(v);
      if (p)
        d.schema = p;
      else {
        const w = {
          ...l,
          schemaPath: [...l.schemaPath, s],
          path: l.path
        }, O = s._zod.parent;
        if (O)
          d.ref = O, this.process(O, w), this.seen.get(O).isParent = !0;
        else {
          const x = d.schema;
          switch (a.type) {
            case "string": {
              const S = x;
              S.type = "string";
              const { minimum: E, maximum: k, format: T, patterns: R, contentEncoding: j } = s._zod.bag;
              if (typeof E == "number" && (S.minLength = E), typeof k == "number" && (S.maxLength = k), T && (S.format = u[T] ?? T, S.format === "" && delete S.format), j && (S.contentEncoding = j), R && R.size > 0) {
                const F = [...R];
                F.length === 1 ? S.pattern = F[0].source : F.length > 1 && (d.schema.allOf = [
                  ...F.map((L) => ({
                    ...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? { type: "string" } : {},
                    pattern: L.source
                  }))
                ]);
              }
              break;
            }
            case "number": {
              const S = x, { minimum: E, maximum: k, format: T, multipleOf: R, exclusiveMaximum: j, exclusiveMinimum: F } = s._zod.bag;
              typeof T == "string" && T.includes("int") ? S.type = "integer" : S.type = "number", typeof F == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (S.minimum = F, S.exclusiveMinimum = !0) : S.exclusiveMinimum = F), typeof E == "number" && (S.minimum = E, typeof F == "number" && this.target !== "draft-4" && (F >= E ? delete S.minimum : delete S.exclusiveMinimum)), typeof j == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (S.maximum = j, S.exclusiveMaximum = !0) : S.exclusiveMaximum = j), typeof k == "number" && (S.maximum = k, typeof j == "number" && this.target !== "draft-4" && (j <= k ? delete S.maximum : delete S.exclusiveMaximum)), typeof R == "number" && (S.multipleOf = R);
              break;
            }
            case "boolean": {
              const S = x;
              S.type = "boolean";
              break;
            }
            case "bigint": {
              if (this.unrepresentable === "throw")
                throw new Error("BigInt cannot be represented in JSON Schema");
              break;
            }
            case "symbol": {
              if (this.unrepresentable === "throw")
                throw new Error("Symbols cannot be represented in JSON Schema");
              break;
            }
            case "null": {
              this.target === "openapi-3.0" ? (x.type = "string", x.nullable = !0, x.enum = [null]) : x.type = "null";
              break;
            }
            case "any":
              break;
            case "unknown":
              break;
            case "undefined": {
              if (this.unrepresentable === "throw")
                throw new Error("Undefined cannot be represented in JSON Schema");
              break;
            }
            case "void": {
              if (this.unrepresentable === "throw")
                throw new Error("Void cannot be represented in JSON Schema");
              break;
            }
            case "never": {
              x.not = {};
              break;
            }
            case "date": {
              if (this.unrepresentable === "throw")
                throw new Error("Date cannot be represented in JSON Schema");
              break;
            }
            case "array": {
              const S = x, { minimum: E, maximum: k } = s._zod.bag;
              typeof E == "number" && (S.minItems = E), typeof k == "number" && (S.maxItems = k), S.type = "array", S.items = this.process(a.element, { ...w, path: [...w.path, "items"] });
              break;
            }
            case "object": {
              const S = x;
              S.type = "object", S.properties = {};
              const E = a.shape;
              for (const R in E)
                S.properties[R] = this.process(E[R], {
                  ...w,
                  path: [...w.path, "properties", R]
                });
              const k = new Set(Object.keys(E)), T = new Set([...k].filter((R) => {
                const j = a.shape[R]._zod;
                return this.io === "input" ? j.optin === void 0 : j.optout === void 0;
              }));
              T.size > 0 && (S.required = Array.from(T)), ((A = a.catchall) == null ? void 0 : A._zod.def.type) === "never" ? S.additionalProperties = !1 : a.catchall ? a.catchall && (S.additionalProperties = this.process(a.catchall, {
                ...w,
                path: [...w.path, "additionalProperties"]
              })) : this.io === "output" && (S.additionalProperties = !1);
              break;
            }
            case "union": {
              const S = x, E = a.discriminator !== void 0, k = a.options.map((T, R) => this.process(T, {
                ...w,
                path: [...w.path, E ? "oneOf" : "anyOf", R]
              }));
              E ? S.oneOf = k : S.anyOf = k;
              break;
            }
            case "intersection": {
              const S = x, E = this.process(a.left, {
                ...w,
                path: [...w.path, "allOf", 0]
              }), k = this.process(a.right, {
                ...w,
                path: [...w.path, "allOf", 1]
              }), T = (j) => "allOf" in j && Object.keys(j).length === 1, R = [
                ...T(E) ? E.allOf : [E],
                ...T(k) ? k.allOf : [k]
              ];
              S.allOf = R;
              break;
            }
            case "tuple": {
              const S = x;
              S.type = "array";
              const E = this.target === "draft-2020-12" ? "prefixItems" : "items", k = this.target === "draft-2020-12" || this.target === "openapi-3.0" ? "items" : "additionalItems", T = a.items.map((L, _) => this.process(L, {
                ...w,
                path: [...w.path, E, _]
              })), R = a.rest ? this.process(a.rest, {
                ...w,
                path: [...w.path, k, ...this.target === "openapi-3.0" ? [a.items.length] : []]
              }) : null;
              this.target === "draft-2020-12" ? (S.prefixItems = T, R && (S.items = R)) : this.target === "openapi-3.0" ? (S.items = {
                anyOf: T
              }, R && S.items.anyOf.push(R), S.minItems = T.length, R || (S.maxItems = T.length)) : (S.items = T, R && (S.additionalItems = R));
              const { minimum: j, maximum: F } = s._zod.bag;
              typeof j == "number" && (S.minItems = j), typeof F == "number" && (S.maxItems = F);
              break;
            }
            case "record": {
              const S = x;
              S.type = "object", (this.target === "draft-7" || this.target === "draft-2020-12") && (S.propertyNames = this.process(a.keyType, {
                ...w,
                path: [...w.path, "propertyNames"]
              })), S.additionalProperties = this.process(a.valueType, {
                ...w,
                path: [...w.path, "additionalProperties"]
              });
              break;
            }
            case "map": {
              if (this.unrepresentable === "throw")
                throw new Error("Map cannot be represented in JSON Schema");
              break;
            }
            case "set": {
              if (this.unrepresentable === "throw")
                throw new Error("Set cannot be represented in JSON Schema");
              break;
            }
            case "enum": {
              const S = x, E = (0, t.getEnumValues)(a.entries);
              E.every((k) => typeof k == "number") && (S.type = "number"), E.every((k) => typeof k == "string") && (S.type = "string"), S.enum = E;
              break;
            }
            case "literal": {
              const S = x, E = [];
              for (const k of a.values)
                if (k === void 0) {
                  if (this.unrepresentable === "throw")
                    throw new Error("Literal `undefined` cannot be represented in JSON Schema");
                } else if (typeof k == "bigint") {
                  if (this.unrepresentable === "throw")
                    throw new Error("BigInt literals cannot be represented in JSON Schema");
                  E.push(Number(k));
                } else
                  E.push(k);
              if (E.length !== 0) if (E.length === 1) {
                const k = E[0];
                S.type = k === null ? "null" : typeof k, this.target === "draft-4" || this.target === "openapi-3.0" ? S.enum = [k] : S.const = k;
              } else
                E.every((k) => typeof k == "number") && (S.type = "number"), E.every((k) => typeof k == "string") && (S.type = "string"), E.every((k) => typeof k == "boolean") && (S.type = "string"), E.every((k) => k === null) && (S.type = "null"), S.enum = E;
              break;
            }
            case "file": {
              const S = x, E = {
                type: "string",
                format: "binary",
                contentEncoding: "binary"
              }, { minimum: k, maximum: T, mime: R } = s._zod.bag;
              k !== void 0 && (E.minLength = k), T !== void 0 && (E.maxLength = T), R ? R.length === 1 ? (E.contentMediaType = R[0], Object.assign(S, E)) : S.anyOf = R.map((j) => ({ ...E, contentMediaType: j })) : Object.assign(S, E);
              break;
            }
            case "transform": {
              if (this.unrepresentable === "throw")
                throw new Error("Transforms cannot be represented in JSON Schema");
              break;
            }
            case "nullable": {
              const S = this.process(a.innerType, w);
              this.target === "openapi-3.0" ? (d.ref = a.innerType, x.nullable = !0) : x.anyOf = [S, { type: "null" }];
              break;
            }
            case "nonoptional": {
              this.process(a.innerType, w), d.ref = a.innerType;
              break;
            }
            case "success": {
              const S = x;
              S.type = "boolean";
              break;
            }
            case "default": {
              this.process(a.innerType, w), d.ref = a.innerType, x.default = JSON.parse(JSON.stringify(a.defaultValue));
              break;
            }
            case "prefault": {
              this.process(a.innerType, w), d.ref = a.innerType, this.io === "input" && (x._prefault = JSON.parse(JSON.stringify(a.defaultValue)));
              break;
            }
            case "catch": {
              this.process(a.innerType, w), d.ref = a.innerType;
              let S;
              try {
                S = a.catchValue(void 0);
              } catch {
                throw new Error("Dynamic catch values are not supported in JSON Schema");
              }
              x.default = S;
              break;
            }
            case "nan": {
              if (this.unrepresentable === "throw")
                throw new Error("NaN cannot be represented in JSON Schema");
              break;
            }
            case "template_literal": {
              const S = x, E = s._zod.pattern;
              if (!E)
                throw new Error("Pattern not found in template literal");
              S.type = "string", S.pattern = E.source;
              break;
            }
            case "pipe": {
              const S = this.io === "input" ? a.in._zod.def.type === "transform" ? a.out : a.in : a.out;
              this.process(S, w), d.ref = S;
              break;
            }
            case "readonly": {
              this.process(a.innerType, w), d.ref = a.innerType, x.readOnly = !0;
              break;
            }
            // passthrough types
            case "promise": {
              this.process(a.innerType, w), d.ref = a.innerType;
              break;
            }
            case "optional": {
              this.process(a.innerType, w), d.ref = a.innerType;
              break;
            }
            case "lazy": {
              const S = s._zod.innerType;
              this.process(S, w), d.ref = S;
              break;
            }
            case "custom": {
              if (this.unrepresentable === "throw")
                throw new Error("Custom types cannot be represented in JSON Schema");
              break;
            }
            case "function": {
              if (this.unrepresentable === "throw")
                throw new Error("Function types cannot be represented in JSON Schema");
              break;
            }
          }
        }
      }
      const h = this.metadataRegistry.get(s);
      return h && Object.assign(d.schema, h), this.io === "input" && i(s) && (delete d.schema.examples, delete d.schema.default), this.io === "input" && d.schema._prefault && ((c = d.schema).default ?? (c.default = d.schema._prefault)), delete d.schema._prefault, this.seen.get(s).schema;
    }
    emit(s, l) {
      var m, v, b, A, w, O;
      const c = {
        cycles: (l == null ? void 0 : l.cycles) ?? "ref",
        reused: (l == null ? void 0 : l.reused) ?? "inline",
        // unrepresentable: _params?.unrepresentable ?? "throw",
        // uri: _params?.uri ?? ((id) => `${id}`),
        external: (l == null ? void 0 : l.external) ?? void 0
      }, a = this.seen.get(s);
      if (!a)
        throw new Error("Unprocessed schema. This is a bug in Zod.");
      const u = (x) => {
        var R;
        const S = this.target === "draft-2020-12" ? "$defs" : "definitions";
        if (c.external) {
          const j = (R = c.external.registry.get(x[0])) == null ? void 0 : R.id, F = c.external.uri ?? ((_) => _);
          if (j)
            return { ref: F(j) };
          const L = x[1].defId ?? x[1].schema.id ?? `schema${this.counter++}`;
          return x[1].defId = L, { defId: L, ref: `${F("__shared")}#/${S}/${L}` };
        }
        if (x[1] === a)
          return { ref: "#" };
        const k = `#/${S}/`, T = x[1].schema.id ?? `__schema${this.counter++}`;
        return { defId: T, ref: k + T };
      }, f = (x) => {
        if (x[1].schema.$ref)
          return;
        const S = x[1], { ref: E, defId: k } = u(x);
        S.def = { ...S.schema }, k && (S.defId = k);
        const T = S.schema;
        for (const R in T)
          delete T[R];
        T.$ref = E;
      };
      if (c.cycles === "throw")
        for (const x of this.seen.entries()) {
          const S = x[1];
          if (S.cycle)
            throw new Error(`Cycle detected: #/${(m = S.cycle) == null ? void 0 : m.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
        }
      for (const x of this.seen.entries()) {
        const S = x[1];
        if (s === x[0]) {
          f(x);
          continue;
        }
        if (c.external) {
          const k = (v = c.external.registry.get(x[0])) == null ? void 0 : v.id;
          if (s !== x[0] && k) {
            f(x);
            continue;
          }
        }
        if ((b = this.metadataRegistry.get(x[0])) == null ? void 0 : b.id) {
          f(x);
          continue;
        }
        if (S.cycle) {
          f(x);
          continue;
        }
        if (S.count > 1 && c.reused === "ref") {
          f(x);
          continue;
        }
      }
      const d = (x, S) => {
        const E = this.seen.get(x), k = E.def ?? E.schema, T = { ...k };
        if (E.ref === null)
          return;
        const R = E.ref;
        if (E.ref = null, R) {
          d(R, S);
          const j = this.seen.get(R).schema;
          j.$ref && (S.target === "draft-7" || S.target === "draft-4" || S.target === "openapi-3.0") ? (k.allOf = k.allOf ?? [], k.allOf.push(j)) : (Object.assign(k, j), Object.assign(k, T));
        }
        E.isParent || this.override({
          zodSchema: x,
          jsonSchema: k,
          path: E.path ?? []
        });
      };
      for (const x of [...this.seen.entries()].reverse())
        d(x[0], { target: this.target });
      const p = {};
      if (this.target === "draft-2020-12" ? p.$schema = "https://json-schema.org/draft/2020-12/schema" : this.target === "draft-7" ? p.$schema = "http://json-schema.org/draft-07/schema#" : this.target === "draft-4" ? p.$schema = "http://json-schema.org/draft-04/schema#" : this.target === "openapi-3.0" || console.warn(`Invalid target: ${this.target}`), (A = c.external) != null && A.uri) {
        const x = (w = c.external.registry.get(s)) == null ? void 0 : w.id;
        if (!x)
          throw new Error("Schema is missing an `id` property");
        p.$id = c.external.uri(x);
      }
      Object.assign(p, a.def);
      const h = ((O = c.external) == null ? void 0 : O.defs) ?? {};
      for (const x of this.seen.entries()) {
        const S = x[1];
        S.def && S.defId && (h[S.defId] = S.def);
      }
      c.external || Object.keys(h).length > 0 && (this.target === "draft-2020-12" ? p.$defs = h : p.definitions = h);
      try {
        return JSON.parse(JSON.stringify(p));
      } catch {
        throw new Error("Error converting schema to JSON.");
      }
    }
  }
  Y0.JSONSchemaGenerator = n;
  function r(o, s) {
    if (o instanceof e.$ZodRegistry) {
      const c = new n(s), a = {};
      for (const d of o._idmap.entries()) {
        const [p, h] = d;
        c.process(h);
      }
      const u = {}, f = {
        registry: o,
        uri: s == null ? void 0 : s.uri,
        defs: a
      };
      for (const d of o._idmap.entries()) {
        const [p, h] = d;
        u[p] = c.emit(h, {
          ...s,
          external: f
        });
      }
      if (Object.keys(a).length > 0) {
        const d = c.target === "draft-2020-12" ? "$defs" : "definitions";
        u.__shared = {
          [d]: a
        };
      }
      return { schemas: u };
    }
    const l = new n(s);
    return l.process(o), l.emit(o, s);
  }
  function i(o, s) {
    const l = s ?? { seen: /* @__PURE__ */ new Set() };
    if (l.seen.has(o))
      return !1;
    l.seen.add(o);
    const c = o._zod.def;
    if (c.type === "transform")
      return !0;
    if (c.type === "array")
      return i(c.element, l);
    if (c.type === "set")
      return i(c.valueType, l);
    if (c.type === "lazy")
      return i(c.getter(), l);
    if (c.type === "promise" || c.type === "optional" || c.type === "nonoptional" || c.type === "nullable" || c.type === "readonly" || c.type === "default" || c.type === "prefault")
      return i(c.innerType, l);
    if (c.type === "intersection")
      return i(c.left, l) || i(c.right, l);
    if (c.type === "record" || c.type === "map")
      return i(c.keyType, l) || i(c.valueType, l);
    if (c.type === "pipe")
      return i(c.in, l) || i(c.out, l);
    if (c.type === "object") {
      for (const a in c.shape)
        if (i(c.shape[a], l))
          return !0;
      return !1;
    }
    if (c.type === "union") {
      for (const a of c.options)
        if (i(a, l))
          return !0;
      return !1;
    }
    if (c.type === "tuple") {
      for (const a of c.items)
        if (i(a, l))
          return !0;
      return !!(c.rest && i(c.rest, l));
    }
    return !1;
  }
  return Y0;
}
var lq = {}, lye;
function Dcn() {
  return lye || (lye = 1, Object.defineProperty(lq, "__esModule", { value: !0 })), lq;
}
var cye;
function lc() {
  return cye || (cye = 1, function(e) {
    var t = xu && xu.__createBinding || (Object.create ? function(o, s, l, c) {
      c === void 0 && (c = l);
      var a = Object.getOwnPropertyDescriptor(s, l);
      (!a || ("get" in a ? !s.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
        return s[l];
      } }), Object.defineProperty(o, c, a);
    } : function(o, s, l, c) {
      c === void 0 && (c = l), o[c] = s[l];
    }), n = xu && xu.__setModuleDefault || (Object.create ? function(o, s) {
      Object.defineProperty(o, "default", { enumerable: !0, value: s });
    } : function(o, s) {
      o.default = s;
    }), r = xu && xu.__exportStar || function(o, s) {
      for (var l in o) l !== "default" && !Object.prototype.hasOwnProperty.call(s, l) && t(s, o, l);
    }, i = xu && xu.__importStar || function(o) {
      if (o && o.__esModule) return o;
      var s = {};
      if (o != null) for (var l in o) l !== "default" && Object.prototype.hasOwnProperty.call(o, l) && t(s, o, l);
      return n(s, o), s;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.JSONSchema = e.locales = e.regexes = e.util = void 0, r(tP(), e), r(b4e(), e), r(v4e(), e), r(w4e(), e), r(GJ(), e), r(A4e(), e), e.util = i(fn()), e.regexes = i(KJ()), e.locales = i(T4e()), r(YJ(), e), r(O4e(), e), r(Rcn(), e), r(Mcn(), e), e.JSONSchema = i(Dcn());
  }(xu)), xu;
}
var fp = {}, cq = {}, uye;
function k4e() {
  return uye || (uye = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.slugify = e.toUpperCase = e.toLowerCase = e.trim = e.normalize = e.overwrite = e.mime = e.property = e.endsWith = e.startsWith = e.includes = e.uppercase = e.lowercase = e.regex = e.length = e.minLength = e.maxLength = e.size = e.minSize = e.maxSize = e.multipleOf = e.nonnegative = e.nonpositive = e.negative = e.positive = e.gte = e.gt = e.lte = e.lt = void 0;
    var t = lc();
    Object.defineProperty(e, "lt", { enumerable: !0, get: function() {
      return t._lt;
    } }), Object.defineProperty(e, "lte", { enumerable: !0, get: function() {
      return t._lte;
    } }), Object.defineProperty(e, "gt", { enumerable: !0, get: function() {
      return t._gt;
    } }), Object.defineProperty(e, "gte", { enumerable: !0, get: function() {
      return t._gte;
    } }), Object.defineProperty(e, "positive", { enumerable: !0, get: function() {
      return t._positive;
    } }), Object.defineProperty(e, "negative", { enumerable: !0, get: function() {
      return t._negative;
    } }), Object.defineProperty(e, "nonpositive", { enumerable: !0, get: function() {
      return t._nonpositive;
    } }), Object.defineProperty(e, "nonnegative", { enumerable: !0, get: function() {
      return t._nonnegative;
    } }), Object.defineProperty(e, "multipleOf", { enumerable: !0, get: function() {
      return t._multipleOf;
    } }), Object.defineProperty(e, "maxSize", { enumerable: !0, get: function() {
      return t._maxSize;
    } }), Object.defineProperty(e, "minSize", { enumerable: !0, get: function() {
      return t._minSize;
    } }), Object.defineProperty(e, "size", { enumerable: !0, get: function() {
      return t._size;
    } }), Object.defineProperty(e, "maxLength", { enumerable: !0, get: function() {
      return t._maxLength;
    } }), Object.defineProperty(e, "minLength", { enumerable: !0, get: function() {
      return t._minLength;
    } }), Object.defineProperty(e, "length", { enumerable: !0, get: function() {
      return t._length;
    } }), Object.defineProperty(e, "regex", { enumerable: !0, get: function() {
      return t._regex;
    } }), Object.defineProperty(e, "lowercase", { enumerable: !0, get: function() {
      return t._lowercase;
    } }), Object.defineProperty(e, "uppercase", { enumerable: !0, get: function() {
      return t._uppercase;
    } }), Object.defineProperty(e, "includes", { enumerable: !0, get: function() {
      return t._includes;
    } }), Object.defineProperty(e, "startsWith", { enumerable: !0, get: function() {
      return t._startsWith;
    } }), Object.defineProperty(e, "endsWith", { enumerable: !0, get: function() {
      return t._endsWith;
    } }), Object.defineProperty(e, "property", { enumerable: !0, get: function() {
      return t._property;
    } }), Object.defineProperty(e, "mime", { enumerable: !0, get: function() {
      return t._mime;
    } }), Object.defineProperty(e, "overwrite", { enumerable: !0, get: function() {
      return t._overwrite;
    } }), Object.defineProperty(e, "normalize", { enumerable: !0, get: function() {
      return t._normalize;
    } }), Object.defineProperty(e, "trim", { enumerable: !0, get: function() {
      return t._trim;
    } }), Object.defineProperty(e, "toLowerCase", { enumerable: !0, get: function() {
      return t._toLowerCase;
    } }), Object.defineProperty(e, "toUpperCase", { enumerable: !0, get: function() {
      return t._toUpperCase;
    } }), Object.defineProperty(e, "slugify", { enumerable: !0, get: function() {
      return t._slugify;
    } });
  }(cq)), cq;
}
var pp = {}, dye;
function _7() {
  return dye || (dye = 1, function(e) {
    var t = pp && pp.__createBinding || (Object.create ? function(u, f, d, p) {
      p === void 0 && (p = d);
      var h = Object.getOwnPropertyDescriptor(f, d);
      (!h || ("get" in h ? !f.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return f[d];
      } }), Object.defineProperty(u, p, h);
    } : function(u, f, d, p) {
      p === void 0 && (p = d), u[p] = f[d];
    }), n = pp && pp.__setModuleDefault || (Object.create ? function(u, f) {
      Object.defineProperty(u, "default", { enumerable: !0, value: f });
    } : function(u, f) {
      u.default = f;
    }), r = pp && pp.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var f = {};
      if (u != null) for (var d in u) d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && t(f, u, d);
      return n(f, u), f;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = void 0, e.datetime = s, e.date = l, e.time = c, e.duration = a;
    const i = r(lc()), o = r(JJ());
    e.ZodISODateTime = i.$constructor("ZodISODateTime", (u, f) => {
      i.$ZodISODateTime.init(u, f), o.ZodStringFormat.init(u, f);
    });
    function s(u) {
      return i._isoDateTime(e.ZodISODateTime, u);
    }
    e.ZodISODate = i.$constructor("ZodISODate", (u, f) => {
      i.$ZodISODate.init(u, f), o.ZodStringFormat.init(u, f);
    });
    function l(u) {
      return i._isoDate(e.ZodISODate, u);
    }
    e.ZodISOTime = i.$constructor("ZodISOTime", (u, f) => {
      i.$ZodISOTime.init(u, f), o.ZodStringFormat.init(u, f);
    });
    function c(u) {
      return i._isoTime(e.ZodISOTime, u);
    }
    e.ZodISODuration = i.$constructor("ZodISODuration", (u, f) => {
      i.$ZodISODuration.init(u, f), o.ZodStringFormat.init(u, f);
    });
    function a(u) {
      return i._isoDuration(e.ZodISODuration, u);
    }
  }(pp)), pp;
}
var wr = {}, zl = {}, fye;
function C4e() {
  if (fye) return zl;
  fye = 1;
  var e = zl && zl.__createBinding || (Object.create ? function(l, c, a, u) {
    u === void 0 && (u = a);
    var f = Object.getOwnPropertyDescriptor(c, a);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[a];
    } }), Object.defineProperty(l, u, f);
  } : function(l, c, a, u) {
    u === void 0 && (u = a), l[u] = c[a];
  }), t = zl && zl.__setModuleDefault || (Object.create ? function(l, c) {
    Object.defineProperty(l, "default", { enumerable: !0, value: c });
  } : function(l, c) {
    l.default = c;
  }), n = zl && zl.__importStar || function(l) {
    if (l && l.__esModule) return l;
    var c = {};
    if (l != null) for (var a in l) a !== "default" && Object.prototype.hasOwnProperty.call(l, a) && e(c, l, a);
    return t(c, l), c;
  };
  Object.defineProperty(zl, "__esModule", { value: !0 }), zl.ZodRealError = zl.ZodError = void 0;
  const r = n(lc()), i = lc(), o = n(fn()), s = (l, c) => {
    i.$ZodError.init(l, c), l.name = "ZodError", Object.defineProperties(l, {
      format: {
        value: (a) => r.formatError(l, a)
        // enumerable: false,
      },
      flatten: {
        value: (a) => r.flattenError(l, a)
        // enumerable: false,
      },
      addIssue: {
        value: (a) => {
          l.issues.push(a), l.message = JSON.stringify(l.issues, o.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      addIssues: {
        value: (a) => {
          l.issues.push(...a), l.message = JSON.stringify(l.issues, o.jsonStringifyReplacer, 2);
        }
        // enumerable: false,
      },
      isEmpty: {
        get() {
          return l.issues.length === 0;
        }
        // enumerable: false,
      }
    });
  };
  return zl.ZodError = r.$constructor("ZodError", s), zl.ZodRealError = r.$constructor("ZodError", s, {
    Parent: Error
  }), zl;
}
var pye;
function N4e() {
  if (pye) return wr;
  pye = 1;
  var e = wr && wr.__createBinding || (Object.create ? function(o, s, l, c) {
    c === void 0 && (c = l);
    var a = Object.getOwnPropertyDescriptor(s, l);
    (!a || ("get" in a ? !s.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return s[l];
    } }), Object.defineProperty(o, c, a);
  } : function(o, s, l, c) {
    c === void 0 && (c = l), o[c] = s[l];
  }), t = wr && wr.__setModuleDefault || (Object.create ? function(o, s) {
    Object.defineProperty(o, "default", { enumerable: !0, value: s });
  } : function(o, s) {
    o.default = s;
  }), n = wr && wr.__importStar || function(o) {
    if (o && o.__esModule) return o;
    var s = {};
    if (o != null) for (var l in o) l !== "default" && Object.prototype.hasOwnProperty.call(o, l) && e(s, o, l);
    return t(s, o), s;
  };
  Object.defineProperty(wr, "__esModule", { value: !0 }), wr.safeDecodeAsync = wr.safeEncodeAsync = wr.safeDecode = wr.safeEncode = wr.decodeAsync = wr.encodeAsync = wr.decode = wr.encode = wr.safeParseAsync = wr.safeParse = wr.parseAsync = wr.parse = void 0;
  const r = n(lc()), i = C4e();
  return wr.parse = r._parse(i.ZodRealError), wr.parseAsync = r._parseAsync(i.ZodRealError), wr.safeParse = r._safeParse(i.ZodRealError), wr.safeParseAsync = r._safeParseAsync(i.ZodRealError), wr.encode = r._encode(i.ZodRealError), wr.decode = r._decode(i.ZodRealError), wr.encodeAsync = r._encodeAsync(i.ZodRealError), wr.decodeAsync = r._decodeAsync(i.ZodRealError), wr.safeEncode = r._safeEncode(i.ZodRealError), wr.safeDecode = r._safeDecode(i.ZodRealError), wr.safeEncodeAsync = r._safeEncodeAsync(i.ZodRealError), wr.safeDecodeAsync = r._safeDecodeAsync(i.ZodRealError), wr;
}
var hye;
function JJ() {
  return hye || (hye = 1, function(e) {
    var t = fp && fp.__createBinding || (Object.create ? function(P, W, te, de) {
      de === void 0 && (de = te);
      var Ne = Object.getOwnPropertyDescriptor(W, te);
      (!Ne || ("get" in Ne ? !W.__esModule : Ne.writable || Ne.configurable)) && (Ne = { enumerable: !0, get: function() {
        return W[te];
      } }), Object.defineProperty(P, de, Ne);
    } : function(P, W, te, de) {
      de === void 0 && (de = te), P[de] = W[te];
    }), n = fp && fp.__setModuleDefault || (Object.create ? function(P, W) {
      Object.defineProperty(P, "default", { enumerable: !0, value: W });
    } : function(P, W) {
      P.default = W;
    }), r = fp && fp.__importStar || function(P) {
      if (P && P.__esModule) return P;
      var W = {};
      if (P != null) for (var te in P) te !== "default" && Object.prototype.hasOwnProperty.call(P, te) && t(W, P, te);
      return n(W, P), W;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodFile = e.ZodLiteral = e.ZodEnum = e.ZodSet = e.ZodMap = e.ZodRecord = e.ZodTuple = e.ZodIntersection = e.ZodDiscriminatedUnion = e.ZodUnion = e.ZodObject = e.ZodArray = e.ZodDate = e.ZodVoid = e.ZodNever = e.ZodUnknown = e.ZodAny = e.ZodNull = e.ZodUndefined = e.ZodSymbol = e.ZodBigIntFormat = e.ZodBigInt = e.ZodBoolean = e.ZodNumberFormat = e.ZodNumber = e.ZodCustomStringFormat = e.ZodJWT = e.ZodE164 = e.ZodBase64URL = e.ZodBase64 = e.ZodCIDRv6 = e.ZodCIDRv4 = e.ZodIPv6 = e.ZodMAC = e.ZodIPv4 = e.ZodKSUID = e.ZodXID = e.ZodULID = e.ZodCUID2 = e.ZodCUID = e.ZodNanoID = e.ZodEmoji = e.ZodURL = e.ZodUUID = e.ZodGUID = e.ZodEmail = e.ZodStringFormat = e.ZodString = e._ZodString = e.ZodType = void 0, e.stringbool = e.meta = e.describe = e.ZodCustom = e.ZodFunction = e.ZodPromise = e.ZodLazy = e.ZodTemplateLiteral = e.ZodReadonly = e.ZodCodec = e.ZodPipe = e.ZodNaN = e.ZodCatch = e.ZodSuccess = e.ZodNonOptional = e.ZodPrefault = e.ZodDefault = e.ZodNullable = e.ZodOptional = e.ZodTransform = void 0, e.string = a, e.email = u, e.guid = f, e.uuid = d, e.uuidv4 = p, e.uuidv6 = h, e.uuidv7 = m, e.url = v, e.httpUrl = b, e.emoji = A, e.nanoid = w, e.cuid = O, e.cuid2 = x, e.ulid = S, e.xid = E, e.ksuid = k, e.ipv4 = T, e.mac = R, e.ipv6 = j, e.cidrv4 = F, e.cidrv6 = L, e.base64 = _, e.base64url = U, e.e164 = z, e.jwt = C, e.stringFormat = I, e.hostname = M, e.hex = D, e.hash = X, e.number = B, e.int = q, e.float32 = H, e.float64 = Y, e.int32 = J, e.uint32 = oe, e.boolean = ce, e.bigint = fe, e.int64 = $, e.uint64 = pe, e.symbol = ee, e.undefined = Ce, e.null = Ee, e.any = Ve, e.unknown = et, e.never = ft, e.void = me, e.date = Te, e.array = re, e.keyof = le, e.object = Oe, e.strictObject = be, e.looseObject = je, e.union = xe, e.discriminatedUnion = Q, e.intersection = ae, e.tuple = Pe, e.record = Fe, e.partialRecord = Ke, e.map = Ot, e.set = Ct, e.enum = Jt, e.nativeEnum = yn, e.literal = vn, e.file = Re, e.transform = _e, e.optional = jt, e.nullable = st, e.nullish = Mt, e._default = lt, e.prefault = xt, e.nonoptional = yt, e.success = ct, e.catch = Rt, e.nan = Yt, e.pipe = Gt, e.codec = hn, e.readonly = en, e.templateLiteral = Sn, e.lazy = Ar, e.promise = or, e._function = rr, e.function = rr, e._function = rr, e.function = rr, e.check = no, e.custom = jn, e.refine = Xi, e.superRefine = us, e.instanceof = ca, e.json = ve, e.preprocess = se;
    const i = r(lc()), o = lc(), s = r(k4e()), l = r(_7()), c = r(N4e());
    e.ZodType = i.$constructor("ZodType", (P, W) => (i.$ZodType.init(P, W), P.def = W, P.type = W.type, Object.defineProperty(P, "_def", { value: W }), P.check = (...te) => P.clone(o.util.mergeDefs(W, {
      checks: [
        ...W.checks ?? [],
        ...te.map((de) => typeof de == "function" ? { _zod: { check: de, def: { check: "custom" }, onattach: [] } } : de)
      ]
    })), P.clone = (te, de) => i.clone(P, te, de), P.brand = () => P, P.register = (te, de) => (te.add(P, de), P), P.parse = (te, de) => c.parse(P, te, de, { callee: P.parse }), P.safeParse = (te, de) => c.safeParse(P, te, de), P.parseAsync = async (te, de) => c.parseAsync(P, te, de, { callee: P.parseAsync }), P.safeParseAsync = async (te, de) => c.safeParseAsync(P, te, de), P.spa = P.safeParseAsync, P.encode = (te, de) => c.encode(P, te, de), P.decode = (te, de) => c.decode(P, te, de), P.encodeAsync = async (te, de) => c.encodeAsync(P, te, de), P.decodeAsync = async (te, de) => c.decodeAsync(P, te, de), P.safeEncode = (te, de) => c.safeEncode(P, te, de), P.safeDecode = (te, de) => c.safeDecode(P, te, de), P.safeEncodeAsync = async (te, de) => c.safeEncodeAsync(P, te, de), P.safeDecodeAsync = async (te, de) => c.safeDecodeAsync(P, te, de), P.refine = (te, de) => P.check(Xi(te, de)), P.superRefine = (te) => P.check(us(te)), P.overwrite = (te) => P.check(s.overwrite(te)), P.optional = () => jt(P), P.nullable = () => st(P), P.nullish = () => jt(st(P)), P.nonoptional = (te) => yt(P, te), P.array = () => re(P), P.or = (te) => xe([P, te]), P.and = (te) => ae(P, te), P.transform = (te) => Gt(P, _e(te)), P.default = (te) => lt(P, te), P.prefault = (te) => xt(P, te), P.catch = (te) => Rt(P, te), P.pipe = (te) => Gt(P, te), P.readonly = () => en(P), P.describe = (te) => {
      const de = P.clone();
      return i.globalRegistry.add(de, { description: te }), de;
    }, Object.defineProperty(P, "description", {
      get() {
        var te;
        return (te = i.globalRegistry.get(P)) == null ? void 0 : te.description;
      },
      configurable: !0
    }), P.meta = (...te) => {
      if (te.length === 0)
        return i.globalRegistry.get(P);
      const de = P.clone();
      return i.globalRegistry.add(de, te[0]), de;
    }, P.isOptional = () => P.safeParse(void 0).success, P.isNullable = () => P.safeParse(null).success, P)), e._ZodString = i.$constructor("_ZodString", (P, W) => {
      i.$ZodString.init(P, W), e.ZodType.init(P, W);
      const te = P._zod.bag;
      P.format = te.format ?? null, P.minLength = te.minimum ?? null, P.maxLength = te.maximum ?? null, P.regex = (...de) => P.check(s.regex(...de)), P.includes = (...de) => P.check(s.includes(...de)), P.startsWith = (...de) => P.check(s.startsWith(...de)), P.endsWith = (...de) => P.check(s.endsWith(...de)), P.min = (...de) => P.check(s.minLength(...de)), P.max = (...de) => P.check(s.maxLength(...de)), P.length = (...de) => P.check(s.length(...de)), P.nonempty = (...de) => P.check(s.minLength(1, ...de)), P.lowercase = (de) => P.check(s.lowercase(de)), P.uppercase = (de) => P.check(s.uppercase(de)), P.trim = () => P.check(s.trim()), P.normalize = (...de) => P.check(s.normalize(...de)), P.toLowerCase = () => P.check(s.toLowerCase()), P.toUpperCase = () => P.check(s.toUpperCase()), P.slugify = () => P.check(s.slugify());
    }), e.ZodString = i.$constructor("ZodString", (P, W) => {
      i.$ZodString.init(P, W), e._ZodString.init(P, W), P.email = (te) => P.check(i._email(e.ZodEmail, te)), P.url = (te) => P.check(i._url(e.ZodURL, te)), P.jwt = (te) => P.check(i._jwt(e.ZodJWT, te)), P.emoji = (te) => P.check(i._emoji(e.ZodEmoji, te)), P.guid = (te) => P.check(i._guid(e.ZodGUID, te)), P.uuid = (te) => P.check(i._uuid(e.ZodUUID, te)), P.uuidv4 = (te) => P.check(i._uuidv4(e.ZodUUID, te)), P.uuidv6 = (te) => P.check(i._uuidv6(e.ZodUUID, te)), P.uuidv7 = (te) => P.check(i._uuidv7(e.ZodUUID, te)), P.nanoid = (te) => P.check(i._nanoid(e.ZodNanoID, te)), P.guid = (te) => P.check(i._guid(e.ZodGUID, te)), P.cuid = (te) => P.check(i._cuid(e.ZodCUID, te)), P.cuid2 = (te) => P.check(i._cuid2(e.ZodCUID2, te)), P.ulid = (te) => P.check(i._ulid(e.ZodULID, te)), P.base64 = (te) => P.check(i._base64(e.ZodBase64, te)), P.base64url = (te) => P.check(i._base64url(e.ZodBase64URL, te)), P.xid = (te) => P.check(i._xid(e.ZodXID, te)), P.ksuid = (te) => P.check(i._ksuid(e.ZodKSUID, te)), P.ipv4 = (te) => P.check(i._ipv4(e.ZodIPv4, te)), P.ipv6 = (te) => P.check(i._ipv6(e.ZodIPv6, te)), P.cidrv4 = (te) => P.check(i._cidrv4(e.ZodCIDRv4, te)), P.cidrv6 = (te) => P.check(i._cidrv6(e.ZodCIDRv6, te)), P.e164 = (te) => P.check(i._e164(e.ZodE164, te)), P.datetime = (te) => P.check(l.datetime(te)), P.date = (te) => P.check(l.date(te)), P.time = (te) => P.check(l.time(te)), P.duration = (te) => P.check(l.duration(te));
    });
    function a(P) {
      return i._string(e.ZodString, P);
    }
    e.ZodStringFormat = i.$constructor("ZodStringFormat", (P, W) => {
      i.$ZodStringFormat.init(P, W), e._ZodString.init(P, W);
    }), e.ZodEmail = i.$constructor("ZodEmail", (P, W) => {
      i.$ZodEmail.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function u(P) {
      return i._email(e.ZodEmail, P);
    }
    e.ZodGUID = i.$constructor("ZodGUID", (P, W) => {
      i.$ZodGUID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function f(P) {
      return i._guid(e.ZodGUID, P);
    }
    e.ZodUUID = i.$constructor("ZodUUID", (P, W) => {
      i.$ZodUUID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function d(P) {
      return i._uuid(e.ZodUUID, P);
    }
    function p(P) {
      return i._uuidv4(e.ZodUUID, P);
    }
    function h(P) {
      return i._uuidv6(e.ZodUUID, P);
    }
    function m(P) {
      return i._uuidv7(e.ZodUUID, P);
    }
    e.ZodURL = i.$constructor("ZodURL", (P, W) => {
      i.$ZodURL.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function v(P) {
      return i._url(e.ZodURL, P);
    }
    function b(P) {
      return i._url(e.ZodURL, {
        protocol: /^https?$/,
        hostname: i.regexes.domain,
        ...o.util.normalizeParams(P)
      });
    }
    e.ZodEmoji = i.$constructor("ZodEmoji", (P, W) => {
      i.$ZodEmoji.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function A(P) {
      return i._emoji(e.ZodEmoji, P);
    }
    e.ZodNanoID = i.$constructor("ZodNanoID", (P, W) => {
      i.$ZodNanoID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function w(P) {
      return i._nanoid(e.ZodNanoID, P);
    }
    e.ZodCUID = i.$constructor("ZodCUID", (P, W) => {
      i.$ZodCUID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function O(P) {
      return i._cuid(e.ZodCUID, P);
    }
    e.ZodCUID2 = i.$constructor("ZodCUID2", (P, W) => {
      i.$ZodCUID2.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function x(P) {
      return i._cuid2(e.ZodCUID2, P);
    }
    e.ZodULID = i.$constructor("ZodULID", (P, W) => {
      i.$ZodULID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function S(P) {
      return i._ulid(e.ZodULID, P);
    }
    e.ZodXID = i.$constructor("ZodXID", (P, W) => {
      i.$ZodXID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function E(P) {
      return i._xid(e.ZodXID, P);
    }
    e.ZodKSUID = i.$constructor("ZodKSUID", (P, W) => {
      i.$ZodKSUID.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function k(P) {
      return i._ksuid(e.ZodKSUID, P);
    }
    e.ZodIPv4 = i.$constructor("ZodIPv4", (P, W) => {
      i.$ZodIPv4.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function T(P) {
      return i._ipv4(e.ZodIPv4, P);
    }
    e.ZodMAC = i.$constructor("ZodMAC", (P, W) => {
      i.$ZodMAC.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function R(P) {
      return i._mac(e.ZodMAC, P);
    }
    e.ZodIPv6 = i.$constructor("ZodIPv6", (P, W) => {
      i.$ZodIPv6.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function j(P) {
      return i._ipv6(e.ZodIPv6, P);
    }
    e.ZodCIDRv4 = i.$constructor("ZodCIDRv4", (P, W) => {
      i.$ZodCIDRv4.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function F(P) {
      return i._cidrv4(e.ZodCIDRv4, P);
    }
    e.ZodCIDRv6 = i.$constructor("ZodCIDRv6", (P, W) => {
      i.$ZodCIDRv6.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function L(P) {
      return i._cidrv6(e.ZodCIDRv6, P);
    }
    e.ZodBase64 = i.$constructor("ZodBase64", (P, W) => {
      i.$ZodBase64.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function _(P) {
      return i._base64(e.ZodBase64, P);
    }
    e.ZodBase64URL = i.$constructor("ZodBase64URL", (P, W) => {
      i.$ZodBase64URL.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function U(P) {
      return i._base64url(e.ZodBase64URL, P);
    }
    e.ZodE164 = i.$constructor("ZodE164", (P, W) => {
      i.$ZodE164.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function z(P) {
      return i._e164(e.ZodE164, P);
    }
    e.ZodJWT = i.$constructor("ZodJWT", (P, W) => {
      i.$ZodJWT.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function C(P) {
      return i._jwt(e.ZodJWT, P);
    }
    e.ZodCustomStringFormat = i.$constructor("ZodCustomStringFormat", (P, W) => {
      i.$ZodCustomStringFormat.init(P, W), e.ZodStringFormat.init(P, W);
    });
    function I(P, W, te = {}) {
      return i._stringFormat(e.ZodCustomStringFormat, P, W, te);
    }
    function M(P) {
      return i._stringFormat(e.ZodCustomStringFormat, "hostname", i.regexes.hostname, P);
    }
    function D(P) {
      return i._stringFormat(e.ZodCustomStringFormat, "hex", i.regexes.hex, P);
    }
    function X(P, W) {
      const te = (W == null ? void 0 : W.enc) ?? "hex", de = `${P}_${te}`, Ne = i.regexes[de];
      if (!Ne)
        throw new Error(`Unrecognized hash format: ${de}`);
      return i._stringFormat(e.ZodCustomStringFormat, de, Ne, W);
    }
    e.ZodNumber = i.$constructor("ZodNumber", (P, W) => {
      i.$ZodNumber.init(P, W), e.ZodType.init(P, W), P.gt = (de, Ne) => P.check(s.gt(de, Ne)), P.gte = (de, Ne) => P.check(s.gte(de, Ne)), P.min = (de, Ne) => P.check(s.gte(de, Ne)), P.lt = (de, Ne) => P.check(s.lt(de, Ne)), P.lte = (de, Ne) => P.check(s.lte(de, Ne)), P.max = (de, Ne) => P.check(s.lte(de, Ne)), P.int = (de) => P.check(q(de)), P.safe = (de) => P.check(q(de)), P.positive = (de) => P.check(s.gt(0, de)), P.nonnegative = (de) => P.check(s.gte(0, de)), P.negative = (de) => P.check(s.lt(0, de)), P.nonpositive = (de) => P.check(s.lte(0, de)), P.multipleOf = (de, Ne) => P.check(s.multipleOf(de, Ne)), P.step = (de, Ne) => P.check(s.multipleOf(de, Ne)), P.finite = () => P;
      const te = P._zod.bag;
      P.minValue = Math.max(te.minimum ?? Number.NEGATIVE_INFINITY, te.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, P.maxValue = Math.min(te.maximum ?? Number.POSITIVE_INFINITY, te.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, P.isInt = (te.format ?? "").includes("int") || Number.isSafeInteger(te.multipleOf ?? 0.5), P.isFinite = !0, P.format = te.format ?? null;
    });
    function B(P) {
      return i._number(e.ZodNumber, P);
    }
    e.ZodNumberFormat = i.$constructor("ZodNumberFormat", (P, W) => {
      i.$ZodNumberFormat.init(P, W), e.ZodNumber.init(P, W);
    });
    function q(P) {
      return i._int(e.ZodNumberFormat, P);
    }
    function H(P) {
      return i._float32(e.ZodNumberFormat, P);
    }
    function Y(P) {
      return i._float64(e.ZodNumberFormat, P);
    }
    function J(P) {
      return i._int32(e.ZodNumberFormat, P);
    }
    function oe(P) {
      return i._uint32(e.ZodNumberFormat, P);
    }
    e.ZodBoolean = i.$constructor("ZodBoolean", (P, W) => {
      i.$ZodBoolean.init(P, W), e.ZodType.init(P, W);
    });
    function ce(P) {
      return i._boolean(e.ZodBoolean, P);
    }
    e.ZodBigInt = i.$constructor("ZodBigInt", (P, W) => {
      i.$ZodBigInt.init(P, W), e.ZodType.init(P, W), P.gte = (de, Ne) => P.check(s.gte(de, Ne)), P.min = (de, Ne) => P.check(s.gte(de, Ne)), P.gt = (de, Ne) => P.check(s.gt(de, Ne)), P.gte = (de, Ne) => P.check(s.gte(de, Ne)), P.min = (de, Ne) => P.check(s.gte(de, Ne)), P.lt = (de, Ne) => P.check(s.lt(de, Ne)), P.lte = (de, Ne) => P.check(s.lte(de, Ne)), P.max = (de, Ne) => P.check(s.lte(de, Ne)), P.positive = (de) => P.check(s.gt(BigInt(0), de)), P.negative = (de) => P.check(s.lt(BigInt(0), de)), P.nonpositive = (de) => P.check(s.lte(BigInt(0), de)), P.nonnegative = (de) => P.check(s.gte(BigInt(0), de)), P.multipleOf = (de, Ne) => P.check(s.multipleOf(de, Ne));
      const te = P._zod.bag;
      P.minValue = te.minimum ?? null, P.maxValue = te.maximum ?? null, P.format = te.format ?? null;
    });
    function fe(P) {
      return i._bigint(e.ZodBigInt, P);
    }
    e.ZodBigIntFormat = i.$constructor("ZodBigIntFormat", (P, W) => {
      i.$ZodBigIntFormat.init(P, W), e.ZodBigInt.init(P, W);
    });
    function $(P) {
      return i._int64(e.ZodBigIntFormat, P);
    }
    function pe(P) {
      return i._uint64(e.ZodBigIntFormat, P);
    }
    e.ZodSymbol = i.$constructor("ZodSymbol", (P, W) => {
      i.$ZodSymbol.init(P, W), e.ZodType.init(P, W);
    });
    function ee(P) {
      return i._symbol(e.ZodSymbol, P);
    }
    e.ZodUndefined = i.$constructor("ZodUndefined", (P, W) => {
      i.$ZodUndefined.init(P, W), e.ZodType.init(P, W);
    });
    function Ce(P) {
      return i._undefined(e.ZodUndefined, P);
    }
    e.ZodNull = i.$constructor("ZodNull", (P, W) => {
      i.$ZodNull.init(P, W), e.ZodType.init(P, W);
    });
    function Ee(P) {
      return i._null(e.ZodNull, P);
    }
    e.ZodAny = i.$constructor("ZodAny", (P, W) => {
      i.$ZodAny.init(P, W), e.ZodType.init(P, W);
    });
    function Ve() {
      return i._any(e.ZodAny);
    }
    e.ZodUnknown = i.$constructor("ZodUnknown", (P, W) => {
      i.$ZodUnknown.init(P, W), e.ZodType.init(P, W);
    });
    function et() {
      return i._unknown(e.ZodUnknown);
    }
    e.ZodNever = i.$constructor("ZodNever", (P, W) => {
      i.$ZodNever.init(P, W), e.ZodType.init(P, W);
    });
    function ft(P) {
      return i._never(e.ZodNever, P);
    }
    e.ZodVoid = i.$constructor("ZodVoid", (P, W) => {
      i.$ZodVoid.init(P, W), e.ZodType.init(P, W);
    });
    function me(P) {
      return i._void(e.ZodVoid, P);
    }
    e.ZodDate = i.$constructor("ZodDate", (P, W) => {
      i.$ZodDate.init(P, W), e.ZodType.init(P, W), P.min = (de, Ne) => P.check(s.gte(de, Ne)), P.max = (de, Ne) => P.check(s.lte(de, Ne));
      const te = P._zod.bag;
      P.minDate = te.minimum ? new Date(te.minimum) : null, P.maxDate = te.maximum ? new Date(te.maximum) : null;
    });
    function Te(P) {
      return i._date(e.ZodDate, P);
    }
    e.ZodArray = i.$constructor("ZodArray", (P, W) => {
      i.$ZodArray.init(P, W), e.ZodType.init(P, W), P.element = W.element, P.min = (te, de) => P.check(s.minLength(te, de)), P.nonempty = (te) => P.check(s.minLength(1, te)), P.max = (te, de) => P.check(s.maxLength(te, de)), P.length = (te, de) => P.check(s.length(te, de)), P.unwrap = () => P.element;
    });
    function re(P, W) {
      return i._array(e.ZodArray, P, W);
    }
    function le(P) {
      const W = P._zod.def.shape;
      return Jt(Object.keys(W));
    }
    e.ZodObject = i.$constructor("ZodObject", (P, W) => {
      i.$ZodObjectJIT.init(P, W), e.ZodType.init(P, W), o.util.defineLazy(P, "shape", () => W.shape), P.keyof = () => Jt(Object.keys(P._zod.def.shape)), P.catchall = (te) => P.clone({ ...P._zod.def, catchall: te }), P.passthrough = () => P.clone({ ...P._zod.def, catchall: et() }), P.loose = () => P.clone({ ...P._zod.def, catchall: et() }), P.strict = () => P.clone({ ...P._zod.def, catchall: ft() }), P.strip = () => P.clone({ ...P._zod.def, catchall: void 0 }), P.extend = (te) => o.util.extend(P, te), P.safeExtend = (te) => o.util.safeExtend(P, te), P.merge = (te) => o.util.merge(P, te), P.pick = (te) => o.util.pick(P, te), P.omit = (te) => o.util.omit(P, te), P.partial = (...te) => o.util.partial(e.ZodOptional, P, te[0]), P.required = (...te) => o.util.required(e.ZodNonOptional, P, te[0]);
    });
    function Oe(P, W) {
      const te = {
        type: "object",
        shape: P ?? {},
        ...o.util.normalizeParams(W)
      };
      return new e.ZodObject(te);
    }
    function be(P, W) {
      return new e.ZodObject({
        type: "object",
        shape: P,
        catchall: ft(),
        ...o.util.normalizeParams(W)
      });
    }
    function je(P, W) {
      return new e.ZodObject({
        type: "object",
        shape: P,
        catchall: et(),
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodUnion = i.$constructor("ZodUnion", (P, W) => {
      i.$ZodUnion.init(P, W), e.ZodType.init(P, W), P.options = W.options;
    });
    function xe(P, W) {
      return new e.ZodUnion({
        type: "union",
        options: P,
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodDiscriminatedUnion = i.$constructor("ZodDiscriminatedUnion", (P, W) => {
      e.ZodUnion.init(P, W), i.$ZodDiscriminatedUnion.init(P, W);
    });
    function Q(P, W, te) {
      return new e.ZodDiscriminatedUnion({
        type: "union",
        options: W,
        discriminator: P,
        ...o.util.normalizeParams(te)
      });
    }
    e.ZodIntersection = i.$constructor("ZodIntersection", (P, W) => {
      i.$ZodIntersection.init(P, W), e.ZodType.init(P, W);
    });
    function ae(P, W) {
      return new e.ZodIntersection({
        type: "intersection",
        left: P,
        right: W
      });
    }
    e.ZodTuple = i.$constructor("ZodTuple", (P, W) => {
      i.$ZodTuple.init(P, W), e.ZodType.init(P, W), P.rest = (te) => P.clone({
        ...P._zod.def,
        rest: te
      });
    });
    function Pe(P, W, te) {
      const de = W instanceof i.$ZodType, Ne = de ? te : W, Me = de ? W : null;
      return new e.ZodTuple({
        type: "tuple",
        items: P,
        rest: Me,
        ...o.util.normalizeParams(Ne)
      });
    }
    e.ZodRecord = i.$constructor("ZodRecord", (P, W) => {
      i.$ZodRecord.init(P, W), e.ZodType.init(P, W), P.keyType = W.keyType, P.valueType = W.valueType;
    });
    function Fe(P, W, te) {
      return new e.ZodRecord({
        type: "record",
        keyType: P,
        valueType: W,
        ...o.util.normalizeParams(te)
      });
    }
    function Ke(P, W, te) {
      const de = i.clone(P);
      return de._zod.values = void 0, new e.ZodRecord({
        type: "record",
        keyType: de,
        valueType: W,
        ...o.util.normalizeParams(te)
      });
    }
    e.ZodMap = i.$constructor("ZodMap", (P, W) => {
      i.$ZodMap.init(P, W), e.ZodType.init(P, W), P.keyType = W.keyType, P.valueType = W.valueType;
    });
    function Ot(P, W, te) {
      return new e.ZodMap({
        type: "map",
        keyType: P,
        valueType: W,
        ...o.util.normalizeParams(te)
      });
    }
    e.ZodSet = i.$constructor("ZodSet", (P, W) => {
      i.$ZodSet.init(P, W), e.ZodType.init(P, W), P.min = (...te) => P.check(i._minSize(...te)), P.nonempty = (te) => P.check(i._minSize(1, te)), P.max = (...te) => P.check(i._maxSize(...te)), P.size = (...te) => P.check(i._size(...te));
    });
    function Ct(P, W) {
      return new e.ZodSet({
        type: "set",
        valueType: P,
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodEnum = i.$constructor("ZodEnum", (P, W) => {
      i.$ZodEnum.init(P, W), e.ZodType.init(P, W), P.enum = W.entries, P.options = Object.values(W.entries);
      const te = new Set(Object.keys(W.entries));
      P.extract = (de, Ne) => {
        const Me = {};
        for (const Ge of de)
          if (te.has(Ge))
            Me[Ge] = W.entries[Ge];
          else
            throw new Error(`Key ${Ge} not found in enum`);
        return new e.ZodEnum({
          ...W,
          checks: [],
          ...o.util.normalizeParams(Ne),
          entries: Me
        });
      }, P.exclude = (de, Ne) => {
        const Me = { ...W.entries };
        for (const Ge of de)
          if (te.has(Ge))
            delete Me[Ge];
          else
            throw new Error(`Key ${Ge} not found in enum`);
        return new e.ZodEnum({
          ...W,
          checks: [],
          ...o.util.normalizeParams(Ne),
          entries: Me
        });
      };
    });
    function Jt(P, W) {
      const te = Array.isArray(P) ? Object.fromEntries(P.map((de) => [de, de])) : P;
      return new e.ZodEnum({
        type: "enum",
        entries: te,
        ...o.util.normalizeParams(W)
      });
    }
    function yn(P, W) {
      return new e.ZodEnum({
        type: "enum",
        entries: P,
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodLiteral = i.$constructor("ZodLiteral", (P, W) => {
      i.$ZodLiteral.init(P, W), e.ZodType.init(P, W), P.values = new Set(W.values), Object.defineProperty(P, "value", {
        get() {
          if (W.values.length > 1)
            throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
          return W.values[0];
        }
      });
    });
    function vn(P, W) {
      return new e.ZodLiteral({
        type: "literal",
        values: Array.isArray(P) ? P : [P],
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodFile = i.$constructor("ZodFile", (P, W) => {
      i.$ZodFile.init(P, W), e.ZodType.init(P, W), P.min = (te, de) => P.check(i._minSize(te, de)), P.max = (te, de) => P.check(i._maxSize(te, de)), P.mime = (te, de) => P.check(i._mime(Array.isArray(te) ? te : [te], de));
    });
    function Re(P) {
      return i._file(e.ZodFile, P);
    }
    e.ZodTransform = i.$constructor("ZodTransform", (P, W) => {
      i.$ZodTransform.init(P, W), e.ZodType.init(P, W), P._zod.parse = (te, de) => {
        if (de.direction === "backward")
          throw new i.$ZodEncodeError(P.constructor.name);
        te.addIssue = (Me) => {
          if (typeof Me == "string")
            te.issues.push(o.util.issue(Me, te.value, W));
          else {
            const Ge = Me;
            Ge.fatal && (Ge.continue = !1), Ge.code ?? (Ge.code = "custom"), Ge.input ?? (Ge.input = te.value), Ge.inst ?? (Ge.inst = P), te.issues.push(o.util.issue(Ge));
          }
        };
        const Ne = W.transform(te.value, te);
        return Ne instanceof Promise ? Ne.then((Me) => (te.value = Me, te)) : (te.value = Ne, te);
      };
    });
    function _e(P) {
      return new e.ZodTransform({
        type: "transform",
        transform: P
      });
    }
    e.ZodOptional = i.$constructor("ZodOptional", (P, W) => {
      i.$ZodOptional.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function jt(P) {
      return new e.ZodOptional({
        type: "optional",
        innerType: P
      });
    }
    e.ZodNullable = i.$constructor("ZodNullable", (P, W) => {
      i.$ZodNullable.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function st(P) {
      return new e.ZodNullable({
        type: "nullable",
        innerType: P
      });
    }
    function Mt(P) {
      return jt(st(P));
    }
    e.ZodDefault = i.$constructor("ZodDefault", (P, W) => {
      i.$ZodDefault.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType, P.removeDefault = P.unwrap;
    });
    function lt(P, W) {
      return new e.ZodDefault({
        type: "default",
        innerType: P,
        get defaultValue() {
          return typeof W == "function" ? W() : o.util.shallowClone(W);
        }
      });
    }
    e.ZodPrefault = i.$constructor("ZodPrefault", (P, W) => {
      i.$ZodPrefault.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function xt(P, W) {
      return new e.ZodPrefault({
        type: "prefault",
        innerType: P,
        get defaultValue() {
          return typeof W == "function" ? W() : o.util.shallowClone(W);
        }
      });
    }
    e.ZodNonOptional = i.$constructor("ZodNonOptional", (P, W) => {
      i.$ZodNonOptional.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function yt(P, W) {
      return new e.ZodNonOptional({
        type: "nonoptional",
        innerType: P,
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodSuccess = i.$constructor("ZodSuccess", (P, W) => {
      i.$ZodSuccess.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function ct(P) {
      return new e.ZodSuccess({
        type: "success",
        innerType: P
      });
    }
    e.ZodCatch = i.$constructor("ZodCatch", (P, W) => {
      i.$ZodCatch.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType, P.removeCatch = P.unwrap;
    });
    function Rt(P, W) {
      return new e.ZodCatch({
        type: "catch",
        innerType: P,
        catchValue: typeof W == "function" ? W : () => W
      });
    }
    e.ZodNaN = i.$constructor("ZodNaN", (P, W) => {
      i.$ZodNaN.init(P, W), e.ZodType.init(P, W);
    });
    function Yt(P) {
      return i._nan(e.ZodNaN, P);
    }
    e.ZodPipe = i.$constructor("ZodPipe", (P, W) => {
      i.$ZodPipe.init(P, W), e.ZodType.init(P, W), P.in = W.in, P.out = W.out;
    });
    function Gt(P, W) {
      return new e.ZodPipe({
        type: "pipe",
        in: P,
        out: W
        // ...util.normalizeParams(params),
      });
    }
    e.ZodCodec = i.$constructor("ZodCodec", (P, W) => {
      e.ZodPipe.init(P, W), i.$ZodCodec.init(P, W);
    });
    function hn(P, W, te) {
      return new e.ZodCodec({
        type: "pipe",
        in: P,
        out: W,
        transform: te.decode,
        reverseTransform: te.encode
      });
    }
    e.ZodReadonly = i.$constructor("ZodReadonly", (P, W) => {
      i.$ZodReadonly.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function en(P) {
      return new e.ZodReadonly({
        type: "readonly",
        innerType: P
      });
    }
    e.ZodTemplateLiteral = i.$constructor("ZodTemplateLiteral", (P, W) => {
      i.$ZodTemplateLiteral.init(P, W), e.ZodType.init(P, W);
    });
    function Sn(P, W) {
      return new e.ZodTemplateLiteral({
        type: "template_literal",
        parts: P,
        ...o.util.normalizeParams(W)
      });
    }
    e.ZodLazy = i.$constructor("ZodLazy", (P, W) => {
      i.$ZodLazy.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.getter();
    });
    function Ar(P) {
      return new e.ZodLazy({
        type: "lazy",
        getter: P
      });
    }
    e.ZodPromise = i.$constructor("ZodPromise", (P, W) => {
      i.$ZodPromise.init(P, W), e.ZodType.init(P, W), P.unwrap = () => P._zod.def.innerType;
    });
    function or(P) {
      return new e.ZodPromise({
        type: "promise",
        innerType: P
      });
    }
    e.ZodFunction = i.$constructor("ZodFunction", (P, W) => {
      i.$ZodFunction.init(P, W), e.ZodType.init(P, W);
    });
    function rr(P) {
      return new e.ZodFunction({
        type: "function",
        input: Array.isArray(P == null ? void 0 : P.input) ? Pe(P == null ? void 0 : P.input) : (P == null ? void 0 : P.input) ?? re(et()),
        output: (P == null ? void 0 : P.output) ?? et()
      });
    }
    e.ZodCustom = i.$constructor("ZodCustom", (P, W) => {
      i.$ZodCustom.init(P, W), e.ZodType.init(P, W);
    });
    function no(P) {
      const W = new i.$ZodCheck({
        check: "custom"
        // ...util.normalizeParams(params),
      });
      return W._zod.check = P, W;
    }
    function jn(P, W) {
      return i._custom(e.ZodCustom, P ?? (() => !0), W);
    }
    function Xi(P, W = {}) {
      return i._refine(e.ZodCustom, P, W);
    }
    function us(P) {
      return i._superRefine(P);
    }
    e.describe = i.describe, e.meta = i.meta;
    function ca(P, W = {
      error: `Input not instance of ${P.name}`
    }) {
      const te = new e.ZodCustom({
        type: "custom",
        check: "custom",
        fn: (de) => de instanceof P,
        abort: !0,
        ...o.util.normalizeParams(W)
      });
      return te._zod.bag.Class = P, te;
    }
    const ge = (...P) => i._stringbool({
      Codec: e.ZodCodec,
      Boolean: e.ZodBoolean,
      String: e.ZodString
    }, ...P);
    e.stringbool = ge;
    function ve(P) {
      const W = Ar(() => xe([a(P), B(), ce(), Ee(), re(W), Fe(a(), W)]));
      return W;
    }
    function se(P, W) {
      return Gt(_e(P), W);
    }
  }(fp)), fp;
}
var hp = {}, mye;
function _cn() {
  return mye || (mye = 1, function(e) {
    var t = hp && hp.__createBinding || (Object.create ? function(a, u, f, d) {
      d === void 0 && (d = f);
      var p = Object.getOwnPropertyDescriptor(u, f);
      (!p || ("get" in p ? !u.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
        return u[f];
      } }), Object.defineProperty(a, d, p);
    } : function(a, u, f, d) {
      d === void 0 && (d = f), a[d] = u[f];
    }), n = hp && hp.__setModuleDefault || (Object.create ? function(a, u) {
      Object.defineProperty(a, "default", { enumerable: !0, value: u });
    } : function(a, u) {
      a.default = u;
    }), r = hp && hp.__importStar || function(a) {
      if (a && a.__esModule) return a;
      var u = {};
      if (a != null) for (var f in a) f !== "default" && Object.prototype.hasOwnProperty.call(a, f) && t(u, a, f);
      return n(u, a), u;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ZodFirstPartyTypeKind = e.config = e.$brand = e.ZodIssueCode = void 0, e.setErrorMap = s, e.getErrorMap = l;
    const i = r(lc());
    e.ZodIssueCode = {
      invalid_type: "invalid_type",
      too_big: "too_big",
      too_small: "too_small",
      invalid_format: "invalid_format",
      not_multiple_of: "not_multiple_of",
      unrecognized_keys: "unrecognized_keys",
      invalid_union: "invalid_union",
      invalid_key: "invalid_key",
      invalid_element: "invalid_element",
      invalid_value: "invalid_value",
      custom: "custom"
    };
    var o = lc();
    Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return o.$brand;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return o.config;
    } });
    function s(a) {
      i.config({
        customError: a
      });
    }
    function l() {
      return i.config().customError;
    }
    var c;
    c || (e.ZodFirstPartyTypeKind = c = {});
  }(hp)), hp;
}
var Wa = {}, gye;
function Lcn() {
  if (gye) return Wa;
  gye = 1;
  var e = Wa && Wa.__createBinding || (Object.create ? function(u, f, d, p) {
    p === void 0 && (p = d);
    var h = Object.getOwnPropertyDescriptor(f, d);
    (!h || ("get" in h ? !f.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(u, p, h);
  } : function(u, f, d, p) {
    p === void 0 && (p = d), u[p] = f[d];
  }), t = Wa && Wa.__setModuleDefault || (Object.create ? function(u, f) {
    Object.defineProperty(u, "default", { enumerable: !0, value: f });
  } : function(u, f) {
    u.default = f;
  }), n = Wa && Wa.__importStar || function(u) {
    if (u && u.__esModule) return u;
    var f = {};
    if (u != null) for (var d in u) d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && e(f, u, d);
    return t(f, u), f;
  };
  Object.defineProperty(Wa, "__esModule", { value: !0 }), Wa.string = o, Wa.number = s, Wa.boolean = l, Wa.bigint = c, Wa.date = a;
  const r = n(lc()), i = n(JJ());
  function o(u) {
    return r._coercedString(i.ZodString, u);
  }
  function s(u) {
    return r._coercedNumber(i.ZodNumber, u);
  }
  function l(u) {
    return r._coercedBoolean(i.ZodBoolean, u);
  }
  function c(u) {
    return r._coercedBigint(i.ZodBigInt, u);
  }
  function a(u) {
    return r._coercedDate(i.ZodDate, u);
  }
  return Wa;
}
var yye;
function vye() {
  return yye || (yye = 1, function(e) {
    var t = Ll && Ll.__createBinding || (Object.create ? function(u, f, d, p) {
      p === void 0 && (p = d);
      var h = Object.getOwnPropertyDescriptor(f, d);
      (!h || ("get" in h ? !f.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
        return f[d];
      } }), Object.defineProperty(u, p, h);
    } : function(u, f, d, p) {
      p === void 0 && (p = d), u[p] = f[d];
    }), n = Ll && Ll.__setModuleDefault || (Object.create ? function(u, f) {
      Object.defineProperty(u, "default", { enumerable: !0, value: f });
    } : function(u, f) {
      u.default = f;
    }), r = Ll && Ll.__importStar || function(u) {
      if (u && u.__esModule) return u;
      var f = {};
      if (u != null) for (var d in u) d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && t(f, u, d);
      return n(f, u), f;
    }, i = Ll && Ll.__exportStar || function(u, f) {
      for (var d in u) d !== "default" && !Object.prototype.hasOwnProperty.call(f, d) && t(f, u, d);
    }, o = Ll && Ll.__importDefault || function(u) {
      return u && u.__esModule ? u : { default: u };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.coerce = e.iso = e.ZodISODuration = e.ZodISOTime = e.ZodISODate = e.ZodISODateTime = e.locales = e.NEVER = e.util = e.TimePrecision = e.toJSONSchema = e.flattenError = e.formatError = e.prettifyError = e.treeifyError = e.regexes = e.clone = e.$brand = e.$input = e.$output = e.config = e.registry = e.globalRegistry = e.core = void 0, e.core = r(lc()), i(JJ(), e), i(k4e(), e), i(C4e(), e), i(N4e(), e), i(_cn(), e);
    const s = lc(), l = o(x4e());
    (0, s.config)((0, l.default)());
    var c = lc();
    Object.defineProperty(e, "globalRegistry", { enumerable: !0, get: function() {
      return c.globalRegistry;
    } }), Object.defineProperty(e, "registry", { enumerable: !0, get: function() {
      return c.registry;
    } }), Object.defineProperty(e, "config", { enumerable: !0, get: function() {
      return c.config;
    } }), Object.defineProperty(e, "$output", { enumerable: !0, get: function() {
      return c.$output;
    } }), Object.defineProperty(e, "$input", { enumerable: !0, get: function() {
      return c.$input;
    } }), Object.defineProperty(e, "$brand", { enumerable: !0, get: function() {
      return c.$brand;
    } }), Object.defineProperty(e, "clone", { enumerable: !0, get: function() {
      return c.clone;
    } }), Object.defineProperty(e, "regexes", { enumerable: !0, get: function() {
      return c.regexes;
    } }), Object.defineProperty(e, "treeifyError", { enumerable: !0, get: function() {
      return c.treeifyError;
    } }), Object.defineProperty(e, "prettifyError", { enumerable: !0, get: function() {
      return c.prettifyError;
    } }), Object.defineProperty(e, "formatError", { enumerable: !0, get: function() {
      return c.formatError;
    } }), Object.defineProperty(e, "flattenError", { enumerable: !0, get: function() {
      return c.flattenError;
    } }), Object.defineProperty(e, "toJSONSchema", { enumerable: !0, get: function() {
      return c.toJSONSchema;
    } }), Object.defineProperty(e, "TimePrecision", { enumerable: !0, get: function() {
      return c.TimePrecision;
    } }), Object.defineProperty(e, "util", { enumerable: !0, get: function() {
      return c.util;
    } }), Object.defineProperty(e, "NEVER", { enumerable: !0, get: function() {
      return c.NEVER;
    } }), e.locales = r(T4e());
    var a = _7();
    Object.defineProperty(e, "ZodISODateTime", { enumerable: !0, get: function() {
      return a.ZodISODateTime;
    } }), Object.defineProperty(e, "ZodISODate", { enumerable: !0, get: function() {
      return a.ZodISODate;
    } }), Object.defineProperty(e, "ZodISOTime", { enumerable: !0, get: function() {
      return a.ZodISOTime;
    } }), Object.defineProperty(e, "ZodISODuration", { enumerable: !0, get: function() {
      return a.ZodISODuration;
    } }), e.iso = r(_7()), e.coerce = r(Lcn());
  }(Ll)), Ll;
}
var bye;
function zcn() {
  return bye || (bye = 1, function(e) {
    var t = wu && wu.__createBinding || (Object.create ? function(s, l, c, a) {
      a === void 0 && (a = c);
      var u = Object.getOwnPropertyDescriptor(l, c);
      (!u || ("get" in u ? !l.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return l[c];
      } }), Object.defineProperty(s, a, u);
    } : function(s, l, c, a) {
      a === void 0 && (a = c), s[a] = l[c];
    }), n = wu && wu.__setModuleDefault || (Object.create ? function(s, l) {
      Object.defineProperty(s, "default", { enumerable: !0, value: l });
    } : function(s, l) {
      s.default = l;
    }), r = wu && wu.__importStar || function(s) {
      if (s && s.__esModule) return s;
      var l = {};
      if (s != null) for (var c in s) c !== "default" && Object.prototype.hasOwnProperty.call(s, c) && t(l, s, c);
      return n(l, s), l;
    }, i = wu && wu.__exportStar || function(s, l) {
      for (var c in s) c !== "default" && !Object.prototype.hasOwnProperty.call(l, c) && t(l, s, c);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.z = void 0;
    const o = r(vye());
    e.z = o, i(vye(), e), e.default = o;
  }(wu)), wu;
}
var Oye;
function jcn() {
  if (Oye) return WS;
  Oye = 1, Object.defineProperty(WS, "__esModule", { value: !0 }), WS.propsValidation = void 0;
  const e = wx, t = /* @__PURE__ */ zcn();
  return WS.propsValidation = {
    validateZod(n, r) {
      return e.__awaiter(this, void 0, void 0, function* () {
        const i = t.z.object(Object.entries(r).reduce((o, [s, l]) => Object.assign(Object.assign({}, o), { [s]: l }), {}));
        try {
          yield i.parseAsync(n);
        } catch (o) {
          if (o instanceof t.z.ZodError) {
            const s = o.issues.reduce((l, c) => {
              const a = c.path.join(".");
              return Object.assign(Object.assign({}, l), { [a]: c.message });
            }, {});
            throw new Error(JSON.stringify({ errors: s }, null, 2));
          }
          throw o;
        }
      });
    }
  }, WS;
}
var Aye;
function Fcn() {
  return Aye || (Aye = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = wx;
    t.__exportStar(u4e(), e), t.__exportStar(Uln(), e), t.__exportStar(g4e(), e), t.__exportStar(Vln(), e), t.__exportStar(jcn(), e);
  }($V)), $V;
}
var L7 = Fcn();
function eee({
  icon: e,
  text: t,
  className: n = "",
  children: r
}) {
  return /* @__PURE__ */ V("div", { className: `flex items-center gap-2 ${n}`, children: [
    e,
    t,
    r
  ] });
}
const Ucn = So.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Ir(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: i, storedMarks: o } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: l } = r.extensionManager, c = o || i.$to.parentOffset && i.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: a, dispatch: u }) => {
            if (u && c && s) {
              const f = c.filter((d) => l.includes(d.type.name));
              a.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), Vcn = si.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => zK(e, t),
      redo: () => ({ state: e, dispatch: t }) => jK(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [
      XRe(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
});
function qcn(e) {
  var t;
  const { char: n, allowSpaces: r, allowedPrefixes: i, startOfLine: o, $position: s } = e, l = sNt(n), c = new RegExp(`\\s${l}$`), a = o ? "^" : "", u = r ? new RegExp(`${a}${l}.*?(?=\\s${l}|$)`, "gm") : new RegExp(`${a}(?:^)?${l}[^\\s${l}]*`, "gm"), f = ((t = s.nodeBefore) === null || t === void 0 ? void 0 : t.isText) && s.nodeBefore.text;
  if (!f)
    return null;
  const d = s.pos - f.length, p = Array.from(f.matchAll(u)).pop();
  if (!p || p.input === void 0 || p.index === void 0)
    return null;
  const h = p.input.slice(Math.max(0, p.index - 1), p.index), m = new RegExp(`^[${i == null ? void 0 : i.join("")}\0]?$`).test(h);
  if (i !== null && !m)
    return null;
  const v = d + p.index;
  let b = v + p[0].length;
  return r && c.test(f.slice(b - 1, b + 1)) && (p[0] += " ", b += 1), v < s.pos && b >= s.pos ? {
    range: {
      from: v,
      to: b
    },
    query: p[0].slice(n.length),
    text: p[0]
  } : null;
}
const Bcn = new gi("suggestion");
function Xcn({ pluginKey: e = Bcn, editor: t, char: n = "@", allowSpaces: r = !1, allowedPrefixes: i = [" "], startOfLine: o = !1, decorationTag: s = "span", decorationClass: l = "suggestion", command: c = () => null, items: a = () => [], render: u = () => ({}), allow: f = () => !0, findSuggestionMatch: d = qcn }) {
  let p;
  const h = u == null ? void 0 : u(), m = new $r({
    key: e,
    view() {
      return {
        update: async (v, b) => {
          var A, w, O, x, S, E, k;
          const T = (A = this.key) === null || A === void 0 ? void 0 : A.getState(b), R = (w = this.key) === null || w === void 0 ? void 0 : w.getState(v.state), j = T.active && R.active && T.range.from !== R.range.from, F = !T.active && R.active, L = T.active && !R.active, _ = !F && !L && T.query !== R.query, U = F, z = _ || j, C = L;
          if (!U && !z && !C)
            return;
          const I = C && !U ? T : R, M = v.dom.querySelector(`[data-decoration-id="${I.decorationId}"]`);
          p = {
            editor: t,
            range: I.range,
            query: I.query,
            text: I.text,
            items: [],
            command: (D) => c({
              editor: t,
              range: I.range,
              props: D
            }),
            decorationNode: M,
            // virtual node for popper.js or tippy.js
            // this can be used for building popups without a DOM node
            clientRect: M ? () => {
              var D;
              const { decorationId: X } = (D = this.key) === null || D === void 0 ? void 0 : D.getState(t.state), B = v.dom.querySelector(`[data-decoration-id="${X}"]`);
              return (B == null ? void 0 : B.getBoundingClientRect()) || null;
            } : null
          }, U && ((O = h == null ? void 0 : h.onBeforeStart) === null || O === void 0 || O.call(h, p)), z && ((x = h == null ? void 0 : h.onBeforeUpdate) === null || x === void 0 || x.call(h, p)), (z || U) && (p.items = await a({
            editor: t,
            query: I.query
          })), C && ((S = h == null ? void 0 : h.onExit) === null || S === void 0 || S.call(h, p)), z && ((E = h == null ? void 0 : h.onUpdate) === null || E === void 0 || E.call(h, p)), U && ((k = h == null ? void 0 : h.onStart) === null || k === void 0 || k.call(h, p));
        },
        destroy: () => {
          var v;
          p && ((v = h == null ? void 0 : h.onExit) === null || v === void 0 || v.call(h, p));
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        return {
          active: !1,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: !1
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply(v, b, A, w) {
        const { isEditable: O } = t, { composing: x } = t.view, { selection: S } = v, { empty: E, from: k } = S, T = { ...b };
        if (T.composing = x, O && (E || t.view.composing)) {
          (k < b.range.from || k > b.range.to) && !x && !b.composing && (T.active = !1);
          const R = d({
            char: n,
            allowSpaces: r,
            allowedPrefixes: i,
            startOfLine: o,
            $position: S.$from
          }), j = `id_${Math.floor(Math.random() * 4294967295)}`;
          R && f({
            editor: t,
            state: w,
            range: R.range,
            isActive: b.active
          }) ? (T.active = !0, T.decorationId = b.decorationId ? b.decorationId : j, T.range = R.range, T.query = R.query, T.text = R.text) : T.active = !1;
        } else
          T.active = !1;
        return T.active || (T.decorationId = null, T.range = { from: 0, to: 0 }, T.query = null, T.text = null), T;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(v, b) {
        var A;
        const { active: w, range: O } = m.getState(v.state);
        return w && ((A = h == null ? void 0 : h.onKeyDown) === null || A === void 0 ? void 0 : A.call(h, { view: v, event: b, range: O })) || !1;
      },
      // Setup decorator on the currently active suggestion.
      decorations(v) {
        const { active: b, range: A, decorationId: w } = m.getState(v);
        return b ? Vr.create(v.doc, [
          za.inline(A.from, A.to, {
            nodeName: s,
            class: l,
            "data-decoration-id": w
          })
        ]) : null;
      }
    }
  });
  return m;
}
const Wcn = new gi("mention"), Zcn = So.create({
  name: "mention",
  addOptions() {
    return {
      HTMLAttributes: {},
      renderText({ options: e, node: t }) {
        var n;
        return `${e.suggestion.char}${(n = t.attrs.label) !== null && n !== void 0 ? n : t.attrs.id}`;
      },
      deleteTriggerWithBackspace: !1,
      renderHTML({ options: e, node: t }) {
        var n;
        return [
          "span",
          Ir(this.HTMLAttributes, e.HTMLAttributes),
          `${e.suggestion.char}${(n = t.attrs.label) !== null && n !== void 0 ? n : t.attrs.id}`
        ];
      },
      suggestion: {
        char: "@",
        pluginKey: Wcn,
        command: ({ editor: e, range: t, props: n }) => {
          var r, i;
          const o = e.view.state.selection.$to.nodeAfter;
          ((r = o == null ? void 0 : o.text) === null || r === void 0 ? void 0 : r.startsWith(" ")) && (t.to += 1), e.chain().focus().insertContentAt(t, [
            {
              type: this.name,
              attrs: n
            },
            {
              type: "text",
              text: " "
            }
          ]).run(), (i = window.getSelection()) === null || i === void 0 || i.collapseToEnd();
        },
        allow: ({ state: e, range: t }) => {
          const n = e.doc.resolve(t.from), r = e.schema.nodes[this.name];
          return !!n.parent.type.contentMatch.matchType(r);
        }
      }
    };
  },
  group: "inline",
  inline: !0,
  selectable: !1,
  atom: !0,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-id"),
        renderHTML: (e) => e.id ? {
          "data-id": e.id
        } : {}
      },
      label: {
        default: null,
        parseHTML: (e) => e.getAttribute("data-label"),
        renderHTML: (e) => e.label ? {
          "data-label": e.label
        } : {}
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    if (this.options.renderLabel !== void 0)
      return console.warn("renderLabel is deprecated use renderText and renderHTML instead"), [
        "span",
        Ir({ "data-type": this.name }, this.options.HTMLAttributes, t),
        this.options.renderLabel({
          options: this.options,
          node: e
        })
      ];
    const n = { ...this.options };
    n.HTMLAttributes = Ir({ "data-type": this.name }, this.options.HTMLAttributes, t);
    const r = this.options.renderHTML({
      options: n,
      node: e
    });
    return typeof r == "string" ? [
      "span",
      Ir({ "data-type": this.name }, this.options.HTMLAttributes, t),
      r
    ] : r;
  },
  renderText({ node: e }) {
    return this.options.renderLabel !== void 0 ? (console.warn("renderLabel is deprecated use renderText and renderHTML instead"), this.options.renderLabel({
      options: this.options,
      node: e
    })) : this.options.renderText({
      options: this.options,
      node: e
    });
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: e, state: t }) => {
        let n = !1;
        const { selection: r } = t, { empty: i, anchor: o } = r;
        return i ? (t.doc.nodesBetween(o - 1, o, (s, l) => {
          if (s.type.name === this.name)
            return n = !0, e.insertText(this.options.deleteTriggerWithBackspace ? "" : this.options.suggestion.char || "", l, l + s.nodeSize), !1;
        }), n) : !1;
      })
    };
  },
  addProseMirrorPlugins() {
    return [
      Xcn({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
}), Hcn = si.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new gi("placeholder"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = t, i = [];
            if (!n)
              return null;
            const o = this.editor.isEmpty;
            return e.descendants((s, l) => {
              const c = r >= l && r <= l + s.nodeSize, a = !s.isLeaf && bN(s);
              if ((c || !this.options.showOnlyCurrent) && a) {
                const u = [this.options.emptyNodeClass];
                o && u.push(this.options.emptyEditorClass);
                const f = za.node(l, l + s.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: s,
                    pos: l,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                i.push(f);
              }
              return this.options.includeChildren;
            }), Vr.create(e, i);
          }
        }
      })
    ];
  }
});
var Qcn = /^\s*>\s$/, $cn = So.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ s_("blockquote", { ...Ir(this.options.HTMLAttributes, e), children: /* @__PURE__ */ s_("slot", {}) });
  },
  parseMarkdown: (e, t) => t.createNode("blockquote", void 0, t.parseChildren(e.tokens || [])),
  renderMarkdown: (e, t) => {
    if (!e.content)
      return "";
    const n = ">", r = [];
    return e.content.forEach((i) => {
      const l = t.renderChildren([i]).split(`
`).map((c) => c.trim() === "" ? n : `${n} ${c}`);
      r.push(l.join(`
`));
    }), r.join(`
${n}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      bw({
        find: Qcn,
        type: this.type
      })
    ];
  }
}), Kcn = /(^|[^`])`([^`]+)`(?!`)$/, Gcn = /(^|[^`])`([^`]+)`(?!`)/g, Ycn = Ib.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", Ir(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, t) => t.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, t) => e.content ? `\`${t.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      vw({
        find: Kcn,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qv({
        find: Gcn,
        type: this.type
      })
    ];
  }
}), uq = 4, Jcn = /^```([a-z]+)?[\s\n]$/, eun = /^~~~([a-z]+)?[\s\n]$/, tun = So.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: uq,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options;
          if (!n)
            return null;
          const o = [...((t = e.firstElementChild) == null ? void 0 : t.classList) || []].filter((s) => s.startsWith(n)).map((s) => s.replace(n, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      Ir(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, t) => {
    var n;
    return ((n = e.raw) == null ? void 0 : n.startsWith("```")) === !1 && e.codeBlockStyle !== "indented" ? [] : t.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [t.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, t) => {
    var n;
    let r = "";
    const i = ((n = e.attrs) == null ? void 0 : n.language) || "";
    return e.content ? r = [`\`\`\`${i}`, t.renderChildren(e.content), "```"].join(`
`) : r = `\`\`\`${i}

\`\`\``, r;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var t;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (t = this.options.tabSize) != null ? t : uq, { state: r } = e, { selection: i } = r, { $from: o, empty: s } = i;
        if (o.parent.type !== this.type)
          return !1;
        const l = " ".repeat(n);
        return s ? e.commands.insertContent(l) : e.commands.command(({ tr: c }) => {
          const { from: a, to: u } = i, p = r.doc.textBetween(a, u, `
`, `
`).split(`
`).map((h) => l + h).join(`
`);
          return c.replaceWith(a, u, r.schema.text(p)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var t;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (t = this.options.tabSize) != null ? t : uq, { state: r } = e, { selection: i } = r, { $from: o, empty: s } = i;
        return o.parent.type !== this.type ? !1 : s ? e.commands.command(({ tr: l }) => {
          var c;
          const { pos: a } = o, u = o.start(), f = o.end(), p = r.doc.textBetween(u, f, `
`, `
`).split(`
`);
          let h = 0, m = 0;
          const v = a - u;
          for (let S = 0; S < p.length; S += 1) {
            if (m + p[S].length >= v) {
              h = S;
              break;
            }
            m += p[S].length + 1;
          }
          const A = ((c = p[h].match(/^ */)) == null ? void 0 : c[0]) || "", w = Math.min(A.length, n);
          if (w === 0)
            return !0;
          let O = u;
          for (let S = 0; S < h; S += 1)
            O += p[S].length + 1;
          return l.delete(O, O + w), a - O <= w && l.setSelection(pn.create(l.doc, O)), !0;
        }) : e.commands.command(({ tr: l }) => {
          const { from: c, to: a } = i, d = r.doc.textBetween(c, a, `
`, `
`).split(`
`).map((p) => {
            var h;
            const m = ((h = p.match(/^ */)) == null ? void 0 : h[0]) || "", v = Math.min(m.length, n);
            return p.slice(v);
          }).join(`
`);
          return l.replaceWith(c, a, r.schema.text(d)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const o = r.parentOffset === r.parent.nodeSize - 2, s = r.parent.textContent.endsWith(`

`);
        return !o || !s ? !1 : e.chain().command(({ tr: l }) => (l.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: r } = t, { $from: i, empty: o } = n;
        if (!o || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const l = i.after();
        return l === void 0 ? !1 : r.nodeAt(l) ? e.commands.command(({ tr: a }) => (a.setSelection(En.near(r.resolve(l))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      $X({
        find: Jcn,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      $X({
        find: eun,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new $r({
        key: new gi("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), r = t.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, o = i == null ? void 0 : i.mode;
            if (!n || !o)
              return !1;
            const { tr: s, schema: l } = e.state, c = l.text(n.replace(/\r\n?/g, `
`));
            return s.replaceSelectionWith(this.type.create({ language: o }, c)), s.selection.$from.parent.type !== this.type && s.setSelection(pn.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.setMeta("paste", !0), e.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), nun = So.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Ir(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: i, storedMarks: o } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: l } = r.extensionManager, c = o || i.$to.parentOffset && i.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: a, dispatch: u }) => {
            if (u && c && s) {
              const f = c.filter((d) => l.includes(d.type.name));
              a.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), run = So.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Ir(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown: (e, t) => t.createNode("heading", { level: e.depth || 1 }, t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => {
    var n;
    const r = (n = e.attrs) != null && n.level ? parseInt(e.attrs.level, 10) : 1, i = "#".repeat(r);
    return e.content ? `${i} ${t.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, t) => ({
        ...e,
        [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => $X({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), iun = So.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", Ir(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, t) => t.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: t }) => {
        if (!oNt(t, t.schema.nodes[this.name]))
          return !1;
        const { selection: n } = t, { $to: r } = n, i = e();
        return nRe(n) ? i.insertContentAt(r.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ state: o, tr: s, dispatch: l }) => {
          if (l) {
            const { $to: c } = s.selection, a = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? s.setSelection(pn.create(s.doc, c.pos + 1)) : c.nodeAfter.isBlock ? s.setSelection(dn.create(s.doc, c.pos)) : s.setSelection(pn.create(s.doc, c.pos));
            else {
              const u = o.schema.nodes[this.options.nextNodeType] || c.parent.type.contentMatch.defaultType, f = u == null ? void 0 : u.create();
              f && (s.insert(a, f), s.setSelection(pn.create(s.doc, a + 1)));
            }
            s.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      bRe({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
});
const oun = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", sun = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", z7 = "numeric", j7 = "ascii", F7 = "alpha", YE = "asciinumeric", gE = "alphanumeric", U7 = "domain", P4e = "emoji", aun = "scheme", lun = "slashscheme", dq = "whitespace";
function cun(e, t) {
  return e in t || (t[e] = []), t[e];
}
function _y(e, t, n) {
  t[z7] && (t[YE] = !0, t[gE] = !0), t[j7] && (t[YE] = !0, t[F7] = !0), t[YE] && (t[gE] = !0), t[F7] && (t[gE] = !0), t[gE] && (t[U7] = !0), t[P4e] && (t[U7] = !0);
  for (const r in t) {
    const i = cun(r, n);
    i.indexOf(e) < 0 && i.push(e);
  }
}
function uun(e, t) {
  const n = {};
  for (const r in t)
    t[r].indexOf(e) >= 0 && (n[r] = !0);
  return n;
}
function rl(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
rl.groups = {};
rl.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, n = t.j[e];
    if (n)
      return n;
    for (let r = 0; r < t.jr.length; r++) {
      const i = t.jr[r][0], o = t.jr[r][1];
      if (o && i.test(e))
        return o;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t = !1) {
    return t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, n, r) {
    for (let i = 0; i < e.length; i++)
      this.tt(e[i], t, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, n, r) {
    r = r || rl.groups;
    let i;
    return t && t.j ? i = t : (i = new rl(t), n && r && _y(t, n, r)), this.jr.push([e, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, n, r) {
    let i = this;
    const o = e.length;
    if (!o)
      return i;
    for (let s = 0; s < o - 1; s++)
      i = i.tt(e[s]);
    return i.tt(e[o - 1], t, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, n, r) {
    r = r || rl.groups;
    const i = this;
    if (t && t.j)
      return i.j[e] = t, t;
    const o = t;
    let s, l = i.go(e);
    if (l ? (s = new rl(), Object.assign(s.j, l.j), s.jr.push.apply(s.jr, l.jr), s.jd = l.jd, s.t = l.t) : s = new rl(), o) {
      if (r)
        if (s.t && typeof s.t == "string") {
          const c = Object.assign(uun(s.t, r), n);
          _y(o, c, r);
        } else n && _y(o, n, r);
      s.t = o;
    }
    return i.j[e] = s, s;
  }
};
const Bn = (e, t, n, r, i) => e.ta(t, n, r, i), _i = (e, t, n, r, i) => e.tr(t, n, r, i), wye = (e, t, n, r, i) => e.ts(t, n, r, i), mt = (e, t, n, r, i) => e.tt(t, n, r, i), bp = "WORD", V7 = "UWORD", I4e = "ASCIINUMERICAL", R4e = "ALPHANUMERICAL", qk = "LOCALHOST", q7 = "TLD", B7 = "UTLD", PM = "SCHEME", hO = "SLASH_SCHEME", tee = "NUM", X7 = "WS", nee = "NL", JE = "OPENBRACE", eT = "CLOSEBRACE", PL = "OPENBRACKET", IL = "CLOSEBRACKET", RL = "OPENPAREN", ML = "CLOSEPAREN", DL = "OPENANGLEBRACKET", _L = "CLOSEANGLEBRACKET", LL = "FULLWIDTHLEFTPAREN", zL = "FULLWIDTHRIGHTPAREN", jL = "LEFTCORNERBRACKET", FL = "RIGHTCORNERBRACKET", UL = "LEFTWHITECORNERBRACKET", VL = "RIGHTWHITECORNERBRACKET", qL = "FULLWIDTHLESSTHAN", BL = "FULLWIDTHGREATERTHAN", XL = "AMPERSAND", WL = "APOSTROPHE", ZL = "ASTERISK", sm = "AT", HL = "BACKSLASH", QL = "BACKTICK", $L = "CARET", pm = "COLON", ree = "COMMA", KL = "DOLLAR", Ud = "DOT", GL = "EQUALS", iee = "EXCLAMATION", kc = "HYPHEN", tT = "PERCENT", YL = "PIPE", JL = "PLUS", e2 = "POUND", nT = "QUERY", oee = "QUOTE", M4e = "FULLWIDTHMIDDLEDOT", see = "SEMI", Vd = "SLASH", rT = "TILDE", t2 = "UNDERSCORE", D4e = "EMOJI", n2 = "SYM";
var _4e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: R4e,
  AMPERSAND: XL,
  APOSTROPHE: WL,
  ASCIINUMERICAL: I4e,
  ASTERISK: ZL,
  AT: sm,
  BACKSLASH: HL,
  BACKTICK: QL,
  CARET: $L,
  CLOSEANGLEBRACKET: _L,
  CLOSEBRACE: eT,
  CLOSEBRACKET: IL,
  CLOSEPAREN: ML,
  COLON: pm,
  COMMA: ree,
  DOLLAR: KL,
  DOT: Ud,
  EMOJI: D4e,
  EQUALS: GL,
  EXCLAMATION: iee,
  FULLWIDTHGREATERTHAN: BL,
  FULLWIDTHLEFTPAREN: LL,
  FULLWIDTHLESSTHAN: qL,
  FULLWIDTHMIDDLEDOT: M4e,
  FULLWIDTHRIGHTPAREN: zL,
  HYPHEN: kc,
  LEFTCORNERBRACKET: jL,
  LEFTWHITECORNERBRACKET: UL,
  LOCALHOST: qk,
  NL: nee,
  NUM: tee,
  OPENANGLEBRACKET: DL,
  OPENBRACE: JE,
  OPENBRACKET: PL,
  OPENPAREN: RL,
  PERCENT: tT,
  PIPE: YL,
  PLUS: JL,
  POUND: e2,
  QUERY: nT,
  QUOTE: oee,
  RIGHTCORNERBRACKET: FL,
  RIGHTWHITECORNERBRACKET: VL,
  SCHEME: PM,
  SEMI: see,
  SLASH: Vd,
  SLASH_SCHEME: hO,
  SYM: n2,
  TILDE: rT,
  TLD: q7,
  UNDERSCORE: t2,
  UTLD: B7,
  UWORD: V7,
  WORD: bp,
  WS: X7
});
const mp = /[a-z]/, $S = new RegExp("\\p{L}", "u"), fq = new RegExp("\\p{Emoji}", "u"), gp = /\d/, pq = /\s/, xye = "\r", hq = `
`, dun = "️", fun = "‍", mq = "￼";
let OR = null, AR = null;
function pun(e = []) {
  const t = {};
  rl.groups = t;
  const n = new rl();
  OR == null && (OR = Sye(oun)), AR == null && (AR = Sye(sun)), mt(n, "'", WL), mt(n, "{", JE), mt(n, "}", eT), mt(n, "[", PL), mt(n, "]", IL), mt(n, "(", RL), mt(n, ")", ML), mt(n, "<", DL), mt(n, ">", _L), mt(n, "（", LL), mt(n, "）", zL), mt(n, "「", jL), mt(n, "」", FL), mt(n, "『", UL), mt(n, "』", VL), mt(n, "＜", qL), mt(n, "＞", BL), mt(n, "&", XL), mt(n, "*", ZL), mt(n, "@", sm), mt(n, "`", QL), mt(n, "^", $L), mt(n, ":", pm), mt(n, ",", ree), mt(n, "$", KL), mt(n, ".", Ud), mt(n, "=", GL), mt(n, "!", iee), mt(n, "-", kc), mt(n, "%", tT), mt(n, "|", YL), mt(n, "+", JL), mt(n, "#", e2), mt(n, "?", nT), mt(n, '"', oee), mt(n, "/", Vd), mt(n, ";", see), mt(n, "~", rT), mt(n, "_", t2), mt(n, "\\", HL), mt(n, "・", M4e);
  const r = _i(n, gp, tee, {
    [z7]: !0
  });
  _i(r, gp, r);
  const i = _i(r, mp, I4e, {
    [YE]: !0
  }), o = _i(r, $S, R4e, {
    [gE]: !0
  }), s = _i(n, mp, bp, {
    [j7]: !0
  });
  _i(s, gp, i), _i(s, mp, s), _i(i, gp, i), _i(i, mp, i);
  const l = _i(n, $S, V7, {
    [F7]: !0
  });
  _i(l, mp), _i(l, gp, o), _i(l, $S, l), _i(o, gp, o), _i(o, mp), _i(o, $S, o);
  const c = mt(n, hq, nee, {
    [dq]: !0
  }), a = mt(n, xye, X7, {
    [dq]: !0
  }), u = _i(n, pq, X7, {
    [dq]: !0
  });
  mt(n, mq, u), mt(a, hq, c), mt(a, mq, u), _i(a, pq, u), mt(u, xye), mt(u, hq), _i(u, pq, u), mt(u, mq, u);
  const f = _i(n, fq, D4e, {
    [P4e]: !0
  });
  mt(f, "#"), _i(f, fq, f), mt(f, dun, f);
  const d = mt(f, fun);
  mt(d, "#"), _i(d, fq, f);
  const p = [[mp, s], [gp, i]], h = [[mp, null], [$S, l], [gp, o]];
  for (let m = 0; m < OR.length; m++)
    Bh(n, OR[m], q7, bp, p);
  for (let m = 0; m < AR.length; m++)
    Bh(n, AR[m], B7, V7, h);
  _y(q7, {
    tld: !0,
    ascii: !0
  }, t), _y(B7, {
    utld: !0,
    alpha: !0
  }, t), Bh(n, "file", PM, bp, p), Bh(n, "mailto", PM, bp, p), Bh(n, "http", hO, bp, p), Bh(n, "https", hO, bp, p), Bh(n, "ftp", hO, bp, p), Bh(n, "ftps", hO, bp, p), _y(PM, {
    scheme: !0,
    ascii: !0
  }, t), _y(hO, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((m, v) => m[0] > v[0] ? 1 : -1);
  for (let m = 0; m < e.length; m++) {
    const v = e[m][0], A = e[m][1] ? {
      [aun]: !0
    } : {
      [lun]: !0
    };
    v.indexOf("-") >= 0 ? A[U7] = !0 : mp.test(v) ? gp.test(v) ? A[YE] = !0 : A[j7] = !0 : A[z7] = !0, wye(n, v, v, A);
  }
  return wye(n, "localhost", qk, {
    ascii: !0
  }), n.jd = new rl(n2), {
    start: n,
    tokens: Object.assign({
      groups: t
    }, _4e)
  };
}
function L4e(e, t) {
  const n = hun(t.replace(/[A-Z]/g, (l) => l.toLowerCase())), r = n.length, i = [];
  let o = 0, s = 0;
  for (; s < r; ) {
    let l = e, c = null, a = 0, u = null, f = -1, d = -1;
    for (; s < r && (c = l.go(n[s])); )
      l = c, l.accepts() ? (f = 0, d = 0, u = l) : f >= 0 && (f += n[s].length, d++), a += n[s].length, o += n[s].length, s++;
    o -= f, s -= d, a -= f, i.push({
      t: u.t,
      // token type/name
      v: t.slice(o - a, o),
      // string value
      s: o - a,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return i;
}
function hun(e) {
  const t = [], n = e.length;
  let r = 0;
  for (; r < n; ) {
    let i = e.charCodeAt(r), o, s = i < 55296 || i > 56319 || r + 1 === n || (o = e.charCodeAt(r + 1)) < 56320 || o > 57343 ? e[r] : e.slice(r, r + 2);
    t.push(s), r += s.length;
  }
  return t;
}
function Bh(e, t, n, r, i) {
  let o;
  const s = t.length;
  for (let l = 0; l < s - 1; l++) {
    const c = t[l];
    e.j[c] ? o = e.j[c] : (o = new rl(r), o.jr = i.slice(), e.j[c] = o), e = o;
  }
  return o = new rl(n), o.jr = i.slice(), e.j[t[s - 1]] = o, o;
}
function Sye(e) {
  const t = [], n = [];
  let r = 0, i = "0123456789";
  for (; r < e.length; ) {
    let o = 0;
    for (; i.indexOf(e[r + o]) >= 0; )
      o++;
    if (o > 0) {
      t.push(n.join(""));
      for (let s = parseInt(e.substring(r, r + o), 10); s > 0; s--)
        n.pop();
      r += o;
    } else
      n.push(e[r]), r++;
  }
  return t;
}
const Bk = {
  defaultProtocol: "http",
  events: null,
  format: Eye,
  formatHref: Eye,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function aee(e, t = null) {
  let n = Object.assign({}, Bk);
  e && (n = Object.assign(n, e instanceof aee ? e.o : e));
  const r = n.ignoreTags, i = [];
  for (let o = 0; o < r.length; o++)
    i.push(r[o].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = i;
}
aee.prototype = {
  o: Bk,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, n) {
    const r = t != null;
    let i = this.o[e];
    return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : Bk[e], typeof i == "function" && r && (i = i(t, n))) : typeof i == "function" && r && (i = i(t, n.t, n)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, n) {
    let r = this.o[e];
    return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function Eye(e) {
  return e;
}
function z4e(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
z4e.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = Bk.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), i = e.get("tagName", n, t), o = this.toFormattedString(e), s = {}, l = e.get("className", n, t), c = e.get("target", n, t), a = e.get("rel", n, t), u = e.getObj("attributes", n, t), f = e.getObj("events", n, t);
    return s.href = r, l && (s.class = l), c && (s.target = c), a && (s.rel = a), u && Object.assign(s, u), {
      tagName: i,
      attributes: s,
      content: o,
      eventListeners: f
    };
  }
};
function X3(e, t) {
  class n extends z4e {
    constructor(i, o) {
      super(i, o), this.t = e;
    }
  }
  for (const r in t)
    n.prototype[r] = t[r];
  return n.t = e, n;
}
const Tye = X3("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), kye = X3("text"), mun = X3("nl"), wR = X3("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = Bk.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== qk && e[1].t === pm;
  }
}), Sc = (e) => new rl(e);
function gun({
  groups: e
}) {
  const t = e.domain.concat([XL, ZL, sm, HL, QL, $L, KL, GL, kc, tee, tT, YL, JL, e2, Vd, n2, rT, t2]), n = [WL, pm, ree, Ud, iee, tT, nT, oee, see, DL, _L, JE, eT, IL, PL, RL, ML, LL, zL, jL, FL, UL, VL, qL, BL], r = [XL, WL, ZL, HL, QL, $L, KL, GL, kc, JE, eT, tT, YL, JL, e2, nT, Vd, n2, rT, t2], i = Sc(), o = mt(i, rT);
  Bn(o, r, o), Bn(o, e.domain, o);
  const s = Sc(), l = Sc(), c = Sc();
  Bn(i, e.domain, s), Bn(i, e.scheme, l), Bn(i, e.slashscheme, c), Bn(s, r, o), Bn(s, e.domain, s);
  const a = mt(s, sm);
  mt(o, sm, a), mt(l, sm, a), mt(c, sm, a);
  const u = mt(o, Ud);
  Bn(u, r, o), Bn(u, e.domain, o);
  const f = Sc();
  Bn(a, e.domain, f), Bn(f, e.domain, f);
  const d = mt(f, Ud);
  Bn(d, e.domain, f);
  const p = Sc(Tye);
  Bn(d, e.tld, p), Bn(d, e.utld, p), mt(a, qk, p);
  const h = mt(f, kc);
  mt(h, kc, h), Bn(h, e.domain, f), Bn(p, e.domain, f), mt(p, Ud, d), mt(p, kc, h);
  const m = mt(p, pm);
  Bn(m, e.numeric, Tye);
  const v = mt(s, kc), b = mt(s, Ud);
  mt(v, kc, v), Bn(v, e.domain, s), Bn(b, r, o), Bn(b, e.domain, s);
  const A = Sc(wR);
  Bn(b, e.tld, A), Bn(b, e.utld, A), Bn(A, e.domain, s), Bn(A, r, o), mt(A, Ud, b), mt(A, kc, v), mt(A, sm, a);
  const w = mt(A, pm), O = Sc(wR);
  Bn(w, e.numeric, O);
  const x = Sc(wR), S = Sc();
  Bn(x, t, x), Bn(x, n, S), Bn(S, t, x), Bn(S, n, S), mt(A, Vd, x), mt(O, Vd, x);
  const E = mt(l, pm), k = mt(c, pm), T = mt(k, Vd), R = mt(T, Vd);
  Bn(l, e.domain, s), mt(l, Ud, b), mt(l, kc, v), Bn(c, e.domain, s), mt(c, Ud, b), mt(c, kc, v), Bn(E, e.domain, x), mt(E, Vd, x), mt(E, nT, x), Bn(R, e.domain, x), Bn(R, t, x), mt(R, Vd, x);
  const j = [
    [JE, eT],
    // {}
    [PL, IL],
    // []
    [RL, ML],
    // ()
    [DL, _L],
    // <>
    [LL, zL],
    // （）
    [jL, FL],
    // 「」
    [UL, VL],
    // 『』
    [qL, BL]
    // ＜＞
  ];
  for (let F = 0; F < j.length; F++) {
    const [L, _] = j[F], U = mt(x, L);
    mt(S, L, U), mt(U, _, x);
    const z = Sc(wR);
    Bn(U, t, z);
    const C = Sc();
    Bn(U, n), Bn(z, t, z), Bn(z, n, C), Bn(C, t, z), Bn(C, n, C), mt(z, _, x), mt(C, _, x);
  }
  return mt(i, qk, A), mt(i, nee, mun), {
    start: i,
    tokens: _4e
  };
}
function yun(e, t, n) {
  let r = n.length, i = 0, o = [], s = [];
  for (; i < r; ) {
    let l = e, c = null, a = null, u = 0, f = null, d = -1;
    for (; i < r && !(c = l.go(n[i].t)); )
      s.push(n[i++]);
    for (; i < r && (a = c || l.go(n[i].t)); )
      c = null, l = a, l.accepts() ? (d = 0, f = l) : d >= 0 && d++, i++, u++;
    if (d < 0)
      i -= u, i < r && (s.push(n[i]), i++);
    else {
      s.length > 0 && (o.push(gq(kye, t, s)), s = []), i -= d, u -= d;
      const p = f.t, h = n.slice(i - u, i);
      o.push(gq(p, t, h));
    }
  }
  return s.length > 0 && o.push(gq(kye, t, s)), o;
}
function gq(e, t, n) {
  const r = n[0].s, i = n[n.length - 1].e, o = t.slice(r, i);
  return new e(o, n);
}
const vun = typeof console < "u" && console && console.warn || (() => {
}), bun = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", li = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function Oun() {
  return rl.groups = {}, li.scanner = null, li.parser = null, li.tokenQueue = [], li.pluginQueue = [], li.customSchemes = [], li.initialized = !1, li;
}
function Cye(e, t = !1) {
  if (li.initialized && vun(`linkifyjs: already initialized - will not register custom scheme "${e}" ${bun}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  li.customSchemes.push([e, t]);
}
function Aun() {
  li.scanner = pun(li.customSchemes);
  for (let e = 0; e < li.tokenQueue.length; e++)
    li.tokenQueue[e][1]({
      scanner: li.scanner
    });
  li.parser = gun(li.scanner.tokens);
  for (let e = 0; e < li.pluginQueue.length; e++)
    li.pluginQueue[e][1]({
      scanner: li.scanner,
      parser: li.parser
    });
  return li.initialized = !0, li;
}
function lee(e) {
  return li.initialized || Aun(), yun(li.parser.start, e, L4e(li.scanner.start, e));
}
lee.scan = L4e;
function j4e(e, t = null, n = null) {
  if (t && typeof t == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const r = new aee(n), i = lee(e), o = [];
  for (let s = 0; s < i.length; s++) {
    const l = i[s];
    l.isLink && (!t || l.t === t) && r.check(l) && o.push(l.toFormattedObject(r));
  }
  return o;
}
var cee = "[\0-   ᠎ -\u2029 　]", wun = new RegExp(cee), xun = new RegExp(`${cee}$`), Sun = new RegExp(cee, "g");
function Eun(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function Tun(e) {
  return new $r({
    key: new gi("autolink"),
    appendTransaction: (t, n, r) => {
      const i = t.some((a) => a.docChanged) && !n.doc.eq(r.doc), o = t.some((a) => a.getMeta("preventAutolink"));
      if (!i || o)
        return;
      const { tr: s } = r, l = HIe(n.doc, [...t]);
      if (tRe(l).forEach(({ newRange: a }) => {
        const u = iCt(r.doc, a, (p) => p.isTextblock);
        let f, d;
        if (u.length > 1)
          f = u[0], d = r.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const p = r.doc.textBetween(a.from, a.to, " ", " ");
          if (!xun.test(p))
            return;
          f = u[0], d = r.doc.textBetween(f.pos, a.to, void 0, " ");
        }
        if (f && d) {
          const p = d.split(wun).filter(Boolean);
          if (p.length <= 0)
            return !1;
          const h = p[p.length - 1], m = f.pos + d.lastIndexOf(h);
          if (!h)
            return !1;
          const v = lee(h).map((b) => b.toObject(e.defaultProtocol));
          if (!Eun(v))
            return !1;
          v.filter((b) => b.isLink).map((b) => ({
            ...b,
            from: m + b.start + 1,
            to: m + b.end + 1
          })).filter((b) => r.schema.marks.code ? !r.doc.rangeHasMark(b.from, b.to, r.schema.marks.code) : !0).filter((b) => e.validate(b.value)).filter((b) => e.shouldAutoLink(b.value)).forEach((b) => {
            xK(b.from, b.to, r.doc).some((A) => A.mark.type === e.type) || s.addMark(
              b.from,
              b.to,
              e.type.create({
                href: b.href
              })
            );
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function kun(e) {
  return new $r({
    key: new gi("handleClickLink"),
    props: {
      handleClick: (t, n, r) => {
        var i, o;
        if (r.button !== 0 || !t.editable)
          return !1;
        let s = !1;
        if (e.enableClickSelection && (s = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          let l = null;
          if (r.target instanceof HTMLAnchorElement)
            l = r.target;
          else {
            let f = r.target;
            const d = [];
            for (; f.nodeName !== "DIV"; )
              d.push(f), f = f.parentNode;
            l = d.find((p) => p.nodeName === "A");
          }
          if (!l)
            return s;
          const c = eRe(t.state, e.type.name), a = (i = l == null ? void 0 : l.href) != null ? i : c.href, u = (o = l == null ? void 0 : l.target) != null ? o : c.target;
          l && a && (window.open(a, u), s = !0);
        }
        return s;
      }
    }
  });
}
function Cun(e) {
  return new $r({
    key: new gi("handlePasteLink"),
    props: {
      handlePaste: (t, n, r) => {
        const { shouldAutoLink: i } = e, { state: o } = t, { selection: s } = o, { empty: l } = s;
        if (l)
          return !1;
        let c = "";
        r.content.forEach((u) => {
          c += u.textContent;
        });
        const a = j4e(c, { defaultProtocol: e.defaultProtocol }).find(
          (u) => u.isLink && u.value === c
        );
        return !c || !a || i !== void 0 && !i(a.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: a.href
        });
      }
    }
  });
}
function dy(e, t) {
  const n = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return t && t.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && n.push(i);
  }), !e || e.replace(Sun, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var Nun = Ib.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        Cye(e);
        return;
      }
      Cye(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    Oun();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, t) => !!dy(e, t.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const t = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), n = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (t || n && !e.includes("@"))
          return !0;
        const i = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(i) || !/\./.test(i));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const t = e.getAttribute("href");
          return !t || !this.options.isAllowedUri(t, {
            defaultValidate: (n) => !!dy(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (t) => !!dy(t, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Ir(this.options.HTMLAttributes, e), 0] : ["a", Ir(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, t) => t.applyMark("link", t.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, t) => {
    var n;
    const r = ((n = e.attrs) == null ? void 0 : n.href) || "";
    return `[${t.renderChildren(e)}](${r})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => {
        const { href: n } = e;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!dy(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? t().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: t }) => {
        const { href: n } = e || {};
        return n && !this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!dy(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      qv({
        find: (e) => {
          const t = [];
          if (e) {
            const { protocols: n, defaultProtocol: r } = this.options, i = j4e(e).filter(
              (o) => o.isLink && this.options.isAllowedUri(o.value, {
                defaultValidate: (s) => !!dy(s, n),
                protocols: n,
                defaultProtocol: r
              })
            );
            i.length && i.forEach((o) => {
              this.options.shouldAutoLink(o.value) && t.push({
                text: o.value,
                data: {
                  href: o.href
                },
                index: o.start
              });
            });
          }
          return t;
        },
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) == null ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: t, defaultProtocol: n } = this.options;
    return this.options.autolink && e.push(
      Tun({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (r) => this.options.isAllowedUri(r, {
          defaultValidate: (i) => !!dy(i, t),
          protocols: t,
          defaultProtocol: n
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      kun({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      Cun({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), Pun = si.create({
  name: "starterKit",
  addExtensions() {
    var e, t, n, r;
    const i = [];
    return this.options.bold !== !1 && i.push(ARe.configure(this.options.bold)), this.options.blockquote !== !1 && i.push($cn.configure(this.options.blockquote)), this.options.bulletList !== !1 && i.push(NK.configure(this.options.bulletList)), this.options.code !== !1 && i.push(Ycn.configure(this.options.code)), this.options.codeBlock !== !1 && i.push(tun.configure(this.options.codeBlock)), this.options.document !== !1 && i.push(CK.configure(this.options.document)), this.options.dropcursor !== !1 && i.push(hIt.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && i.push(gIt.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && i.push(nun.configure(this.options.hardBreak)), this.options.heading !== !1 && i.push(run.configure(this.options.heading)), this.options.undoRedo !== !1 && i.push(ZRe.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && i.push(iun.configure(this.options.horizontalRule)), this.options.italic !== !1 && i.push(wRe.configure(this.options.italic)), this.options.listItem !== !1 && i.push(PK.configure(this.options.listItem)), this.options.listKeymap !== !1 && i.push(CRe.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && i.push(Nun.configure((t = this.options) == null ? void 0 : t.link)), this.options.orderedList !== !1 && i.push(RK.configure(this.options.orderedList)), this.options.paragraph !== !1 && i.push(MK.configure(this.options.paragraph)), this.options.strike !== !1 && i.push(PRe.configure(this.options.strike)), this.options.text !== !1 && i.push(_K.configure(this.options.text)), this.options.underline !== !1 && i.push(URe.configure((n = this.options) == null ? void 0 : n.underline)), this.options.trailingNode !== !1 && i.push(yIt.configure((r = this.options) == null ? void 0 : r.trailingNode)), i;
  }
}), Iun = Pun;
const Run = ({
  enableMarkdown: e,
  placeholder: t
}) => {
  const n = [
    Hcn.configure({
      placeholder: t,
      emptyNodeClass: "before:text-muted-foreground opacity-75"
    }),
    Zcn.configure({
      suggestion: {
        char: ""
      },
      deleteTriggerWithBackspace: !0,
      renderHTML({ node: r }) {
        const i = r.attrs;
        return Zp.generateMentionHtmlElement(i);
      }
    })
  ];
  return e ? [
    ...n,
    Iun.configure({
      heading: {
        levels: [1, 2, 3]
      }
    })
  ] : [
    ...n,
    CK,
    Vcn,
    Ucn,
    _K,
    MK.configure({
      HTMLAttributes: {}
    })
  ];
};
function Mun(e) {
  return De(e) ? "" : typeof e == "string" ? e : typeof e == "number" ? e.toString() : JSON.stringify(e);
}
const bg = ({
  className: e,
  initialValue: t,
  onChange: n,
  disabled: r,
  placeholder: i,
  enableMarkdown: o
}) => {
  const s = tn(
    (f) => At.getAllSteps(f.flowVersion.trigger)
  ), l = vd.useStepsMetadata(s).map(({ data: f }, d) => {
    if (f)
      return {
        ...f,
        stepDisplayName: s[d].displayName
      };
  }), c = tn(
    (f) => f.setInsertMentionHandler
  ), a = (f) => {
    const d = Zp.createMentionNodeFromText(
      `{{${f}}}`,
      s,
      l
    );
    u == null || u.chain().focus().insertContent(d).run();
  }, u = sMe({
    editable: !r,
    extensions: Run({ placeholder: i, enableMarkdown: o }),
    content: {
      type: "doc",
      content: Zp.convertTextToTipTapJsonContent(
        Mun(t),
        s,
        l
      )
    },
    editorProps: {
      attributes: {
        class: Se(
          e ?? "w-full bg-background px-3 py-2 text-sm rounded-sm ring-offset-background  min-h-9 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
          Zp.inputWithMentionsCssClass,
          {
            "cursor-not-allowed opacity-50": r
          }
        )
      }
    },
    onUpdate: ({ editor: f }) => {
      const d = f.getJSON(), p = Zp.convertTiptapJsonToText(d);
      n && n(p);
    },
    onFocus: () => {
      c(a);
    }
  });
  return u ? /* @__PURE__ */ y("div", { className: "w-full border rounded-sm", children: /* @__PURE__ */ y(iMe, { editor: u }) }) : null;
}, Xk = ({
  values: e,
  onChange: t,
  disabled: n,
  useMentionTextInput: r
}) => {
  const i = Xe(1), o = Object.entries(e ?? {}).map((p) => (i.current++, {
    key: p[0],
    value: p[1],
    id: `${i.current}`
  })), s = Xe(o), l = s.current.toReversed().filter(
    (p, h, m) => m.findIndex((v) => v.key === p.key) === h
  ).toReversed();
  (l.length !== o.length || o.reduce((p, h, m) => p || l[m].key !== o[m].key || l[m].value !== o[m].value, !1)) && (s.current = o);
  const a = (p) => {
    const h = s.current.filter((m, v) => v !== p);
    s.current = h, d(h);
  }, u = () => {
    i.current++;
    const p = [
      ...s.current,
      { key: "", value: "", id: `${i.current}` }
    ];
    s.current = p, d(p);
  }, f = (p, h, m) => {
    const v = [...s.current];
    h !== void 0 && (v[p].value = h), m !== void 0 && (v[p].key = m), s.current = v, d(v);
  }, d = (p) => {
    t(
      p.reduce((h, m) => ({ ...h, [m.key]: m.value }), {})
    );
  };
  return /* @__PURE__ */ V("div", { className: "flex w-full flex-col gap-4", children: [
    s.current.map(({ key: p, value: h, id: m }, v) => /* @__PURE__ */ V(
      "div",
      {
        className: "flex items-center gap-3 items-center",
        children: [
          /* @__PURE__ */ y(
            fr,
            {
              value: p,
              disabled: n,
              className: "basis-[50%] h-full max-w-[50%] h-[38px]",
              onChange: (b) => f(v, void 0, b.target.value)
            }
          ),
          /* @__PURE__ */ y("div", { className: "basis-[50%] max-w-[50%]", children: r ? /* @__PURE__ */ y(
            bg,
            {
              initialValue: h,
              disabled: n,
              onChange: (b) => f(v, b, void 0)
            }
          ) : /* @__PURE__ */ y(
            fr,
            {
              value: h,
              disabled: n,
              className: "h-full",
              onChange: (b) => f(v, b.target.value, void 0)
            }
          ) }),
          /* @__PURE__ */ V(
            Qe,
            {
              type: "button",
              variant: "outline",
              size: "icon",
              className: "size-8 shrink-0",
              disabled: n,
              onClick: () => a(v),
              children: [
                /* @__PURE__ */ y(xb, { className: "size-4 text-destructive", "aria-hidden": "true" }),
                /* @__PURE__ */ y("span", { className: "sr-only", children: Z("Remove") })
              ]
            }
          )
        ]
      },
      "dictionary-input-" + m
    )),
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "outline",
        size: "sm",
        onClick: u,
        type: "button",
        disabled: n,
        children: /* @__PURE__ */ y(eee, { icon: /* @__PURE__ */ y(Da, { size: 18 }), text: Z("Add Item") })
      }
    )
  ] });
};
var F4e = /* @__PURE__ */ ((e) => (e.JSON = "json", e.TEXT = "text", e.FORM_DATA = "form-data", e))(F4e || {});
const Dun = ({
  bodyType: e,
  field: t
}) => {
  switch (e) {
    case "json":
      return /* @__PURE__ */ y(V3, { field: t, readonly: !1 });
    case "text":
      return /* @__PURE__ */ y(fr, { ...t });
    case "form-data":
      return /* @__PURE__ */ y(
        Xk,
        {
          values: t.value,
          onChange: t.onChange,
          disabled: !1,
          useMentionTextInput: !1
        }
      );
  }
};
wme({
  bodyType: Sme(F4e),
  body: GUe([wme({}), DS()]),
  headers: xme(DS(), DS()),
  queryParams: xme(DS(), DS()),
  method: Sme(L7.HttpMethod)
});
const _un = ({
  open: e,
  onOpenChange: t
}) => {
  const n = tn((s) => s.flow.id), [r, i] = He(!1), { mutate: o } = dr({
    mutationFn: async (s) => {
      i(!0), console.log("Sending request to webhook with data:", s);
      try {
        await dt.any(`${kv}/webhooks/${n}/test`, {
          method: s.method,
          data: s.body,
          headers: s.headers,
          params: s.queryParams
        });
      } catch (l) {
        throw console.error("Error sending request to webhook:", l), l;
      } finally {
        i(!1);
      }
    }
  });
  return /* @__PURE__ */ y(
    qa,
    {
      open: e,
      onOpenChange: (s) => {
        t(s);
      },
      children: /* @__PURE__ */ V(ia, { children: [
        /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ y(_s, { children: Z("Send Sample Data to Webhook") }) }),
        /* @__PURE__ */ y(
          uee,
          {
            showMethodDropdown: !0,
            onSubmit: o,
            isLoading: r
          }
        )
      ] })
    }
  );
}, Lun = ({
  currentStep: e,
  onOpenChange: t,
  open: n
}) => {
  const { mutate: r, isPending: i } = Hc.useTestAction({
    currentStep: e,
    setErrorMessage: void 0,
    setConsoleLogs: void 0,
    onSuccess: () => {
      t(!1);
    }
  });
  return /* @__PURE__ */ y(qa, { open: n, onOpenChange: t, children: /* @__PURE__ */ V(ia, { children: [
    /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ y(_s, { children: Z("Send Sample Data to Webhook") }) }),
    /* @__PURE__ */ y(
      uee,
      {
        showMethodDropdown: !1,
        onSubmit: (o) => {
          r({
            type: "webhookAction",
            preExistingSampleData: {
              runId: IC(),
              success: !0,
              output: {
                body: o.body,
                headers: o.headers,
                queryParams: o.queryParams
              },
              standardError: "",
              standardOutput: "",
              input: {}
            },
            onProgress: void 0
          });
        },
        isLoading: i
      }
    )
  ] }) });
}, uee = (e) => {
  const { i18n: t } = tc(), n = t.dir() === "rtl", { showMethodDropdown: r, onSubmit: i, isLoading: o } = e, s = Fg({
    defaultValues: {
      bodyType: "json",
      body: {},
      headers: {},
      queryParams: {},
      method: L7.HttpMethod.POST
    }
  });
  return /* @__PURE__ */ y(Ug, { ...s, children: /* @__PURE__ */ V("form", { className: "space-y-4", onSubmit: s.handleSubmit(i), children: [
    r && /* @__PURE__ */ y(
      Zn,
      {
        control: s.control,
        name: "method",
        render: ({ field: l }) => /* @__PURE__ */ V(Jn, { children: [
          /* @__PURE__ */ y(ui, { children: Z("Method") }),
          /* @__PURE__ */ y(
            vg,
            {
              options: Object.values(L7.HttpMethod).map((c) => ({
                value: c,
                label: c
              })),
              onChange: (c) => {
                l.onChange(c);
              },
              value: l.value,
              disabled: !1,
              placeholder: Z("Select an option")
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ V(vx, { defaultValue: "queryParams", children: [
      /* @__PURE__ */ V(
        Tb,
        {
          dir: n ? "rtl" : "ltr",
          className: "grid w-full grid-cols-3",
          children: [
            /* @__PURE__ */ y(Ca, { value: "queryParams", children: Z("Query Params") }),
            /* @__PURE__ */ y(Ca, { value: "headers", children: Z("Headers") }),
            /* @__PURE__ */ y(Ca, { value: "body", children: Z("Body") })
          ]
        }
      ),
      /* @__PURE__ */ y(yl, { value: "queryParams", children: /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "queryParams",
          render: ({ field: l }) => /* @__PURE__ */ y(Jn, { children: /* @__PURE__ */ y(
            Xk,
            {
              values: l.value,
              onChange: l.onChange,
              disabled: !1,
              useMentionTextInput: !1
            }
          ) })
        }
      ) }),
      /* @__PURE__ */ y(yl, { value: "headers", children: /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "headers",
          render: ({ field: l }) => /* @__PURE__ */ y(Jn, { children: /* @__PURE__ */ y(
            Xk,
            {
              values: l.value,
              onChange: l.onChange,
              disabled: !1,
              useMentionTextInput: !1
            }
          ) })
        }
      ) }),
      /* @__PURE__ */ y(yl, { value: "body", children: /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y(
          Zn,
          {
            name: "bodyType",
            render: ({ field: l }) => /* @__PURE__ */ V(Jn, { children: [
              /* @__PURE__ */ y(ui, { children: Z("Type") }),
              /* @__PURE__ */ y(
                vg,
                {
                  options: [
                    {
                      value: "json",
                      label: Z("JSON")
                    },
                    {
                      value: "text",
                      label: Z("Text")
                    },
                    {
                      value: "form-data",
                      label: Z("Form Data")
                    }
                  ],
                  onChange: (c) => {
                    switch (l.onChange(c), c) {
                      case "json":
                      case "form-data":
                        s.setValue("body", {});
                        break;
                      case "text":
                        s.setValue("body", "");
                        break;
                    }
                  },
                  value: l.value,
                  disabled: !1,
                  placeholder: Z("Select an option"),
                  showDeselect: !0
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ y(
          Zn,
          {
            control: s.control,
            name: "body",
            render: ({ field: l }) => /* @__PURE__ */ V(Jn, { className: "mt-4", children: [
              /* @__PURE__ */ y(ui, { children: Z("Body") }),
              /* @__PURE__ */ y(
                Dun,
                {
                  bodyType: s.getValues("bodyType"),
                  field: l
                }
              )
            ] })
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ V(kl, { children: [
      /* @__PURE__ */ y(SQ, { asChild: !0, children: /* @__PURE__ */ y(Qe, { type: "button", variant: "outline", children: Z("Cancel") }) }),
      /* @__PURE__ */ y(Qe, { type: "submit", loading: o, children: Z("Send") })
    ] })
  ] }) });
};
uee.displayName = "TestWebhookFunctionalityDialog";
const dee = (e) => {
  const { testingMode: t, currentStep: n, open: r, onOpenChange: i } = e;
  if (t === "returnResponseAndWaitForNextWebhook")
    return /* @__PURE__ */ y(
      Lun,
      {
        currentStep: n,
        open: r,
        onOpenChange: i,
        testingMode: t
      }
    );
  if (t === "trigger")
    return /* @__PURE__ */ y(
      _un,
      {
        currentStep: n,
        open: r,
        onOpenChange: i,
        testingMode: t
      }
    );
};
dee.displayName = "TestWebhookDialog";
const bv = ({ children: e, invalid: t }) => {
  const { isLoadingDynamicProperties: n } = kr(Fb);
  return /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, className: "disabled:pointer-events-auto", children: e }),
    t && /* @__PURE__ */ y(An, { side: "bottom", children: Z("Please fix inputs first") }),
    n && /* @__PURE__ */ y(An, { side: "bottom", children: Z("Please wait until all inputs are loaded") })
  ] }) });
};
bv.displayName = "TestButtonTooltip";
const U4e = ie.forwardRef(
  ({ isValid: e, isSaving: t, isTesting: n, onRetest: r }, i) => {
    const { isLoadingDynamicProperties: o } = kr(Fb);
    return /* @__PURE__ */ y(bv, { invalid: !e, children: /* @__PURE__ */ y(
      Qe,
      {
        ref: i,
        variant: "outline",
        size: "sm",
        disabled: !e || t || o,
        keyboardShortcut: "G",
        onKeyboardShortcut: r,
        onClick: r,
        loading: n,
        children: Z("Test")
      }
    ) });
  }
);
U4e.displayName = "TestButton";
const xR = (e) => De(e) ? !1 : e !== "", Nye = (e, t) => t ?? (e && typeof e == "object" && Object.keys(e).length > 0 ? e : iUe), fee = ie.memo(
  ({
    isValid: e,
    isTesting: t,
    sampleData: n,
    sampleDataInput: r,
    errorMessage: i,
    lastTestDate: o,
    agentResult: s,
    currentStep: l,
    children: c,
    consoleLogs: a,
    isSaving: u,
    onRetest: f
  }) => {
    const d = () => yL(l) ? /* @__PURE__ */ y(
      $tn,
      {
        agentResult: Nye(n, s),
        errorMessage: i
      }
    ) : De(r) && !xR(a) ? /* @__PURE__ */ y(Hp, { json: i ?? n, title: Z("Output") }) : /* @__PURE__ */ V(vx, { defaultValue: "Output", children: [
      /* @__PURE__ */ V(
        Tb,
        {
          className: `grid w-full ${!De(r) && xR(a) ? "w-[300px] grid-cols-3" : "w-[250px] grid-cols-2"}`,
          children: [
            !De(r) && /* @__PURE__ */ y(Ca, { value: "Input", children: Z("Input") }),
            /* @__PURE__ */ y(Ca, { value: "Output", children: Z("Output") }),
            xR(a) && /* @__PURE__ */ y(Ca, { value: "Logs", children: Z("Logs") })
          ]
        }
      ),
      !De(r) && /* @__PURE__ */ y(yl, { value: "Input", children: /* @__PURE__ */ y(Hp, { json: r, title: Z("Input") }) }),
      /* @__PURE__ */ y(yl, { value: "Output", children: /* @__PURE__ */ y(
        Hp,
        {
          json: i ?? n,
          title: Z("Output")
        }
      ) }),
      xR(a) && /* @__PURE__ */ y(yl, { value: "Logs", children: /* @__PURE__ */ y(Hp, { json: a, title: Z("Logs") }) })
    ] });
    return /* @__PURE__ */ V(pt, { children: [
      !t && c,
      /* @__PURE__ */ V("div", { className: "grow flex flex-col w-full text-start gap-4", children: [
        /* @__PURE__ */ V("div", { className: "flex justify-center items-center", children: [
          /* @__PURE__ */ V("div", { className: "flex flex-col grow gap-1", children: [
            /* @__PURE__ */ y("div", { className: "text-md flex gap-1 items-center", children: (() => {
              if (yL(l)) {
                const h = Nye(
                  n,
                  s
                ).status === iv.FAILED;
                return /* @__PURE__ */ V(pt, { children: [
                  /* @__PURE__ */ y(
                    JO,
                    {
                      status: h ? po.FAILED : po.SUCCEEDED,
                      size: "5"
                    }
                  ),
                  /* @__PURE__ */ y("span", { children: Z(
                    h ? "Testing Failed" : "Tested Successfully"
                  ) })
                ] });
              }
              return i ? /* @__PURE__ */ V(pt, { children: [
                /* @__PURE__ */ y(
                  JO,
                  {
                    status: po.FAILED,
                    size: "5"
                  }
                ),
                /* @__PURE__ */ y("span", { children: Z("Testing Failed") })
              ] }) : /* @__PURE__ */ V(pt, { children: [
                /* @__PURE__ */ y(
                  JO,
                  {
                    status: po.SUCCEEDED,
                    size: "5"
                  }
                ),
                /* @__PURE__ */ y("span", { children: Z("Tested Successfully") })
              ] });
            })() }),
            /* @__PURE__ */ y("div", { className: "text-muted-foreground text-xs", children: o && !i && rc.formatDate(new Date(o)) })
          ] }),
          /* @__PURE__ */ y(bv, { invalid: !e, children: /* @__PURE__ */ y(
            U4e,
            {
              isValid: e,
              isSaving: u,
              isTesting: t,
              onRetest: f
            }
          ) })
        ] }),
        d()
      ] })
    ] });
  }
);
fee.displayName = "TestSampleDataViewer";
const zun = (e) => e.type === qe.PIECE && e.settings.pieceName === "@activepieces/piece-todos" && e.settings.actionName === "createTodoAndWait", jun = (e) => e.type === qe.PIECE && e.settings.pieceName === "@activepieces/piece-webhook" && e.settings.actionName === "return_response_and_wait_for_next_webhook", V4e = ie.memo(
  ({
    isSaving: e,
    currentStep: t
  }) => {
    var j;
    const [n, r] = He(
      void 0
    ), [i, o] = He(null), [s, l] = He(
      "NONE"
      /* NONE */
    ), { sampleData: c, sampleDataInput: a } = tn((F) => ({
      sampleData: t.name && F.outputSampleData ? F.outputSampleData[t.name] : {},
      sampleDataInput: t.name && F.inputSampleData ? F.inputSampleData[t.name] : {}
    })), u = Xe(new AbortController()), [f, d] = He([]), [p, h] = He(void 0), { mutate: m, isPending: v } = Hc.useTestAction({
      mutationKey: f,
      currentStep: t,
      setErrorMessage: r,
      setConsoleLogs: o,
      onSuccess: () => {
        A(null);
      }
    }), [b, A] = He(null), w = (j = t.settings.sampleData) == null ? void 0 : j.lastTestDate, O = !De(w) || !De(n), x = async () => {
      l(
        "TODO_CREATE_TASK"
        /* TODO_CREATE_TASK */
      ), m({
        type: "todoAction",
        onProgress: async (F) => {
          if (F.success) {
            const L = Uun(F);
            if (L) {
              const _ = await uA.get(L);
              A(_);
            } else
              r(
                `${Z("Can't find todo ID in the response")} ${JSON.stringify(
                  F.output
                )}`
              );
          }
        }
      });
    }, S = async () => {
      m({
        type: "agentAction",
        onProgress: async (F) => {
          const L = F.output;
          De(L) || h(L);
        },
        onFinish: () => {
          h(void 0);
        }
      });
    }, E = async () => {
      zun(t) ? x() : yL(t) ? (h(iUe), S()) : jun(t) ? l(
        "WEBHOOK"
        /* WEBHOOK */
      ) : m(void 0);
    }, k = () => {
      l(
        "NONE"
        /* NONE */
      ), A(null), u.current.abort(), d([Date.now().toString()]);
    }, T = s !== "NONE" || v, { isLoadingDynamicProperties: R } = kr(Fb);
    return /* @__PURE__ */ V(pt, { children: [
      !O && /* @__PURE__ */ y("div", { className: "grow flex justify-center items-center w-full h-full", children: /* @__PURE__ */ y(bv, { invalid: !t.valid, children: /* @__PURE__ */ V(
        Qe,
        {
          variant: "outline",
          size: "sm",
          onClick: E,
          keyboardShortcut: "G",
          onKeyboardShortcut: E,
          loading: T || e,
          disabled: !t.valid || R,
          children: [
            /* @__PURE__ */ y(GE, { animation: !0, variant: "primary" }),
            Z("Test Step")
          ]
        }
      ) }) }),
      O && /* @__PURE__ */ y(
        fee,
        {
          isValid: t.valid,
          currentStep: t,
          agentResult: p,
          isTesting: T || R,
          sampleData: c,
          sampleDataInput: a ?? null,
          errorMessage: n,
          lastTestDate: w,
          consoleLogs: t.type === qe.CODE ? i : null,
          isSaving: e,
          onRetest: E
        }
      ),
      s === "TODO_CREATE_TASK" && t.type === qe.PIECE && b && /* @__PURE__ */ y(
        $rn,
        {
          open: !0,
          onOpenChange: (F) => {
            F || k();
          },
          todo: b,
          currentStep: t,
          setErrorMessage: r,
          type: t.settings.actionName === "createTodoAndWait" ? $s.INTERNAL : $s.EXTERNAL
        },
        b.id
      ),
      s === "WEBHOOK" && /* @__PURE__ */ y(
        dee,
        {
          testingMode: "returnResponseAndWaitForNextWebhook",
          open: !0,
          onOpenChange: (F) => !F && k(),
          currentStep: t
        }
      )
    ] });
  }
), Fun = (e) => At.isAction(e.type), q4e = ie.memo((e) => {
  const t = tn(
    (n) => n.selectedStep ? At.getStep(n.selectedStep, n.flowVersion.trigger) : null
  );
  return De(t) || !Fun(t) ? null : /* @__PURE__ */ y(V4e, { ...e, currentStep: t });
});
V4e.displayName = "TestStepSectionImplementation";
q4e.displayName = "TestActionSection";
const Uun = (e) => e.output && typeof e.output == "object" && "id" in e.output && typeof e.output.id == "string" ? e.output.id : null, Vun = {
  usePollResults: (e, t) => {
    const { data: n, refetch: r } = pr({
      queryKey: ["triggerEvents", e],
      queryFn: () => dO.list({
        projectId: Rn.getProjectId(),
        flowId: t,
        limit: 5,
        cursor: void 0
      }),
      staleTime: 0
    });
    return { pollResults: n, refetch: r };
  }
}, qun = as(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        accent: "border-transparent bg-accent text-accent-foreground",
        destructive: "border-transparent bg-destructive-100",
        outline: "text-foreground",
        ghost: "border-none",
        success: "bg-success-100"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Bun({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ y("div", { className: Se(qun({ variant: t }), e), ...n });
}
const B4e = ie.createContext(void 0), nP = () => {
  const e = ie.useContext(B4e);
  if (!e)
    throw new Error(
      Z("useMultiSelect must be used within MultiSelectProvider")
    );
  return e;
}, X4e = ({
  value: e,
  onValueChange: t,
  onDeselect: n,
  onSelect: r,
  defaultValue: i,
  open: o,
  onOpenChange: s,
  defaultOpen: l,
  onSearch: c,
  filter: a,
  disabled: u,
  maxCount: f,
  ...d
}) => {
  const p = ie.useRef(
    /* @__PURE__ */ new Map()
  ).current, h = ie.useCallback(
    (S) => {
      if (t) {
        const E = S.map((k) => p.get(k));
        t(S, E);
      }
    },
    [t]
  ), [m, v] = p_({
    prop: e,
    defaultProp: i,
    onChange: h
  }), [b, A] = p_({
    prop: o,
    defaultProp: l,
    onChange: s
  }), w = ie.useCallback(
    (S, E) => {
      v((k) => k != null && k.includes(S) ? k : (r == null || r(S, E), k ? [...k, S] : [S]));
    },
    [r, v]
  ), O = ie.useCallback(
    (S, E) => {
      v((k) => !k || !k.includes(S) ? k : (n == null || n(S, E), k.filter((T) => T !== S)));
    },
    [n, v]
  ), x = ie.useMemo(() => ({
    value: m || [],
    open: b || !1,
    onSearch: c,
    filter: a,
    disabled: u,
    maxCount: f,
    onSelect: w,
    onDeselect: O,
    itemCache: p
  }), [
    m,
    b,
    c,
    a,
    u,
    f,
    w,
    O,
    p
  ]);
  return /* @__PURE__ */ y(B4e.Provider, { value: x, children: /* @__PURE__ */ y(
    bTe,
    {
      ...d,
      open: b,
      onOpenChange: A
    }
  ) });
};
X4e.displayName = "MultiSelect";
const Pye = (e) => {
  e.preventDefault(), e.stopPropagation();
}, W4e = ie.forwardRef(
  ({ className: e, children: t, showDeselect: n, onDeselect: r, loading: i, ...o }, s) => {
    const { disabled: l } = nP();
    return /* @__PURE__ */ y(OTe, { ref: s, asChild: !0, children: /* @__PURE__ */ V(
      Qe,
      {
        variant: "outline",
        "aria-disabled": l,
        disabled: l,
        role: "combobox",
        loading: i,
        className: Se(
          "flex min-h-10 h-auto  w-full items-center justify-between cursor-pointer gap-2 whitespace-nowrap rounded-sm border border-input bg-transparent px-4 py-1 text-sm  ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring [&>span]:line-clamp-1",
          {
            "cursor-not-allowed opacity-80": l,
            "cursor-pointer": !l
          },
          e
        ),
        onClick: l ? Pye : o.onClick,
        onTouchStart: l ? Pye : o.onTouchStart,
        children: [
          t,
          /* @__PURE__ */ V("div", { className: "flex gap-2 items-center", children: [
            n && /* @__PURE__ */ y(
              Pv,
              {
                tooltipText: Z("Unset"),
                onClick: (c) => {
                  c.preventDefault(), c.stopPropagation(), r == null || r();
                },
                Icon: ks
              }
            ),
            o.showRefresh && /* @__PURE__ */ y(
              Pv,
              {
                tooltipText: Z("Refresh"),
                onClick: o.onRefresh,
                Icon: rD
              }
            ),
            /* @__PURE__ */ y(
              exe,
              {
                "aria-hidden": !0,
                className: "h-4 w-4 opacity-50 shrink-0"
              }
            )
          ] })
        ]
      }
    ) });
  }
);
W4e.displayName = "MultiSelectTrigger";
const Z4e = ie.forwardRef(
  ({ className: e, placeholder: t, maxDisplay: n, maxItemLength: r, ...i }, o) => {
    const { value: s, itemCache: l, onDeselect: c, disabled: a } = nP(), [u, f] = ie.useState(!1), d = n && s.length > n ? s.length - n : 0, p = d ? s.slice(0, n) : s;
    return ie.useLayoutEffect(() => {
      f(!0);
    }, []), !s.length || !u ? /* @__PURE__ */ y("span", { className: "pointer-events-none text-muted-foreground opacity-80", children: t }) : /* @__PURE__ */ y(Kp, { delayDuration: 300, children: /* @__PURE__ */ V(
      "div",
      {
        className: Se(
          "flex flex-1 overflow-x-hidden flex-wrap items-center gap-1.5",
          e
        ),
        ...i,
        ref: o,
        children: [
          p.map((h) => {
            const m = l.get(h), v = (m == null ? void 0 : m.label) || h, b = r && typeof v == "string" && v.length > r ? `${v.slice(0, r)}...` : v, A = /* @__PURE__ */ V(
              Bun,
              {
                variant: "outline",
                className: Se("pr-1.5 group/multi-select-badge rounded-full", {
                  "cursor-pointer": !a,
                  "cursor-not-allowed opacity-80": a
                }),
                onClick: (w) => {
                  w.preventDefault(), w.stopPropagation(), c(h, m);
                },
                children: [
                  /* @__PURE__ */ y("span", { children: b }),
                  !a && /* @__PURE__ */ y(ks, { className: "h-3 w-3 ml-1 text-muted-foreground group-hover/multi-select-badge:text-foreground" })
                ]
              },
              h
            );
            return b !== v ? /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { className: "inline-flex", children: A }),
              /* @__PURE__ */ y(An, { side: "bottom", align: "start", className: "z-51", children: v })
            ] }, h) : A;
          }),
          d ? /* @__PURE__ */ y("span", { className: "text-muted-foreground text-xs leading-4 py-.5", children: Z("+{remainingPiecesCount} more", {
            remainingPiecesCount: d
          }) }) : null
        ]
      }
    ) });
  }
);
Z4e.displayName = "MultiSelectValue";
const H4e = ie.forwardRef((e, t) => {
  const { onSearch: n } = nP();
  return /* @__PURE__ */ y(ZJ, { ref: t, ...e, onValueChange: n });
});
H4e.displayName = "MultiSelectSearch";
const Q4e = ie.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(HJ, { ref: n, className: Se("py-1 px-0 ", e), ...t, children: /* @__PURE__ */ y(Bi, { viewPortClassName: "max-h-[200px]", children: t.children }) }));
Q4e.displayName = "MultiSelectList";
const $4e = ie.forwardRef(({ className: e, children: t, ...n }, r) => {
  const i = nP(), o = ie.useRef();
  return !o.current && typeof window < "u" && (o.current = document.createDocumentFragment()), i.open ? /* @__PURE__ */ y(ATe, { forceMount: !0, children: /* @__PURE__ */ y(
    r$,
    {
      ref: r,
      align: "start",
      sideOffset: 4,
      collisionPadding: 10,
      className: Se(
        "z-50 w-full rounded-md border bg-background p-0 text-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
      ),
      style: {
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      },
      ...n,
      children: /* @__PURE__ */ y(
        CL,
        {
          className: Se(
            "px-1 max-h-96 w-full min-w-(--radix-select-trigger-width)",
            e
          ),
          shouldFilter: !i.onSearch,
          children: t
        }
      )
    }
  ) }) : o.current ? iW(/* @__PURE__ */ y(CL, { children: t }), o.current) : null;
});
$4e.displayName = "MultiSelectContent";
const IM = ie.forwardRef(
  ({
    value: e,
    onSelect: t,
    onDeselect: n,
    children: r,
    label: i,
    disabled: o,
    className: s,
    ...l
  }, c) => {
    const {
      value: a,
      maxCount: u,
      onSelect: f,
      onDeselect: d,
      itemCache: p
    } = nP(), h = ie.useMemo(() => e ? {
      value: e,
      label: i || (typeof r == "string" ? r : void 0)
    } : void 0, [e, i, r]), m = !!(e && a.includes(e));
    ie.useEffect(() => {
      e && p.set(e, h);
    }, [m, e, h]);
    const v = !!(o || !m && u && a.length >= u), b = () => {
      m ? (n == null || n(e, h), d(e, h)) : (p.set(e, h), t == null || t(e, h), f(e, h));
    };
    return /* @__PURE__ */ V(
      NL,
      {
        ...l,
        value: e,
        className: Se(
          "cursor-pointer",
          v && "text-muted-foreground cursor-not-allowed",
          s
        ),
        disabled: v,
        onSelect: !v && e ? b : void 0,
        ref: c,
        children: [
          /* @__PURE__ */ y("span", { className: "mr-2 whitespace-nowrap overflow-hidden text-ellipsis", children: r || i || e }),
          m ? /* @__PURE__ */ y(Af, { className: "h-4 w-4 ml-auto shrink-0" }) : null
        ]
      }
    );
  }
);
IM.displayName = "MultiSelectItem";
const Xun = ie.forwardRef((e, t) => /* @__PURE__ */ y(QJ, { ...e, ref: t }));
Xun.displayName = "MultiSelectGroup";
const Wun = ie.forwardRef((e, t) => /* @__PURE__ */ y(c4e, { ...e, ref: t }));
Wun.displayName = "MultiSelectSeparator";
const Zun = ie.forwardRef(({ children: e = "No Content", ...t }, n) => /* @__PURE__ */ y(B3, { ...t, ref: n, children: e }));
Zun.displayName = "MultiSelectEmpty";
const W3 = ({
  placeholder: e,
  options: t,
  onChange: n,
  disabled: r,
  initialValues: i,
  showDeselect: o,
  showRefresh: s,
  onRefresh: l,
  loading: c,
  refreshOnSearch: a,
  cachedOptions: u = []
}) => {
  const [f, d] = He(""), p = t.map((v, b) => ({
    ...v,
    originalIndex: b
  })).filter((v) => {
    var b, A;
    return a ? !0 : (A = (b = v.label) == null ? void 0 : b.toLowerCase()) == null ? void 0 : A.includes(f == null ? void 0 : f.toLowerCase());
  }), h = i ? i.map(
    (v) => [...u, ...t].findIndex(
      (b) => qg(b.value, v)
    )
  ).filter((v) => v > -1).map((v) => String(v)) : [];
  return /* @__PURE__ */ V(
    X4e,
    {
      modal: !0,
      value: h,
      onValueChange: (v) => {
        const b = v.filter(
          (A) => A !== void 0
        );
        b.length === 0 ? n([]) : n(
          b.map((A) => t[Number(A)].value)
        );
      },
      disabled: r,
      onSearch: (v) => {
        d(v ?? ""), a && a(v ?? "");
      },
      onOpenChange: (v) => {
        v || (d(""), a && f.length > 0 && a(""));
      },
      children: [
        /* @__PURE__ */ y(
          W4e,
          {
            showDeselect: o && !r,
            onDeselect: () => n([]),
            showRefresh: s && !r,
            onRefresh: l,
            loading: c,
            children: h.length < 10 ? /* @__PURE__ */ y(Z4e, { placeholder: e }) : Z("{number} items selected", { number: h.length })
          }
        ),
        /* @__PURE__ */ V($4e, { children: [
          /* @__PURE__ */ y(H4e, { placeholder: e }),
          /* @__PURE__ */ V(Q4e, { children: [
            !c && /* @__PURE__ */ V(pt, { children: [
              /* @__PURE__ */ y(
                "div",
                {
                  onClick: (v) => {
                    v.stopPropagation(), v.preventDefault(), n(p.map((b) => b.value));
                  },
                  children: p.length > 1 && /* @__PURE__ */ y(IM, { children: Z("Select All") })
                }
              ),
              p.map((v) => /* @__PURE__ */ y(
                IM,
                {
                  value: String(v.originalIndex),
                  children: v.label
                },
                v.originalIndex
              )),
              p.length === 0 && /* @__PURE__ */ y(B3, { children: Z("No results found.") })
            ] }),
            c && /* @__PURE__ */ y(IM, { disabled: !0, children: Z("Loading...") })
          ] })
        ] })
      ]
    }
  );
};
W3.displayName = "MultiSelectPieceProperty";
function Z3() {
  return (Z3 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function K4e(e, t) {
  if (e == null) return {};
  var n, r, i = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++) t.indexOf(n = o[r]) >= 0 || (i[n] = e[n]);
  return i;
}
function W7(e) {
  var t = Xe(e), n = Xe(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Wk = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, iT = function(e) {
  return "touches" in e;
}, Z7 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, Iye = function(e, t, n) {
  var r = e.getBoundingClientRect(), i = iT(t) ? function(o, s) {
    for (var l = 0; l < o.length; l++) if (o[l].identifier === s) return o[l];
    return o[0];
  }(t.touches, n) : t;
  return { left: Wk((i.pageX - (r.left + Z7(e).pageXOffset)) / r.width), top: Wk((i.pageY - (r.top + Z7(e).pageYOffset)) / r.height) };
}, Rye = function(e) {
  !iT(e) && e.preventDefault();
}, G4e = ie.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = K4e(e, ["onMove", "onKey"]), i = Xe(null), o = W7(t), s = W7(n), l = Xe(null), c = Xe(!1), a = Kt(function() {
    var p = function(v) {
      Rye(v), (iT(v) ? v.touches.length > 0 : v.buttons > 0) && i.current ? o(Iye(i.current, v, l.current)) : m(!1);
    }, h = function() {
      return m(!1);
    };
    function m(v) {
      var b = c.current, A = Z7(i.current), w = v ? A.addEventListener : A.removeEventListener;
      w(b ? "touchmove" : "mousemove", p), w(b ? "touchend" : "mouseup", h);
    }
    return [function(v) {
      var b = v.nativeEvent, A = i.current;
      if (A && (Rye(b), !function(O, x) {
        return x && !iT(O);
      }(b, c.current) && A)) {
        if (iT(b)) {
          c.current = !0;
          var w = b.changedTouches || [];
          w.length && (l.current = w[0].identifier);
        }
        A.focus(), o(Iye(A, b, l.current)), m(!0);
      }
    }, function(v) {
      var b = v.which || v.keyCode;
      b < 37 || b > 40 || (v.preventDefault(), s({ left: b === 39 ? 0.05 : b === 37 ? -0.05 : 0, top: b === 40 ? 0.05 : b === 38 ? -0.05 : 0 }));
    }, m];
  }, [s, o]), u = a[0], f = a[1], d = a[2];
  return nt(function() {
    return d;
  }, [d]), ie.createElement("div", Z3({}, r, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: i, onKeyDown: f, tabIndex: 0, role: "slider" }));
}), pee = function(e) {
  return e.filter(Boolean).join(" ");
}, Y4e = function(e) {
  var t = e.color, n = e.left, r = e.top, i = r === void 0 ? 0.5 : r, o = pee(["react-colorful__pointer", e.className]);
  return ie.createElement("div", { className: o, style: { top: 100 * i + "%", left: 100 * n + "%" } }, ie.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, Ss = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, Hun = function(e) {
  return Yun(H7(e));
}, H7 = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? Ss(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? Ss(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, Qun = function(e) {
  return Gun(Kun(e));
}, $un = function(e) {
  var t = e.s, n = e.v, r = e.a, i = (200 - t) * n / 100;
  return { h: Ss(e.h), s: Ss(i > 0 && i < 200 ? t * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: Ss(i / 2), a: Ss(r, 2) };
}, Q7 = function(e) {
  var t = $un(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, Kun = function(e) {
  var t = e.h, n = e.s, r = e.v, i = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var o = Math.floor(t), s = r * (1 - n), l = r * (1 - (t - o) * n), c = r * (1 - (1 - t + o) * n), a = o % 6;
  return { r: Ss(255 * [r, l, s, s, c, r][a]), g: Ss(255 * [c, r, r, l, s, s][a]), b: Ss(255 * [s, s, c, r, r, l][a]), a: Ss(i, 2) };
}, SR = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, Gun = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, o = i < 1 ? SR(Ss(255 * i)) : "";
  return "#" + SR(t) + SR(n) + SR(r) + o;
}, Yun = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, o = Math.max(t, n, r), s = o - Math.min(t, n, r), l = s ? o === t ? (n - r) / s : o === n ? 2 + (r - t) / s : 4 + (t - n) / s : 0;
  return { h: Ss(60 * (l < 0 ? l + 6 : l)), s: Ss(o ? s / o * 100 : 0), v: Ss(o / 255 * 100), a: i };
}, Jun = ie.memo(function(e) {
  var t = e.hue, n = e.onChange, r = pee(["react-colorful__hue", e.className]);
  return ie.createElement("div", { className: r }, ie.createElement(G4e, { onMove: function(i) {
    n({ h: 360 * i.left });
  }, onKey: function(i) {
    n({ h: Wk(t + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": Ss(t), "aria-valuemax": "360", "aria-valuemin": "0" }, ie.createElement(Y4e, { className: "react-colorful__hue-pointer", left: t / 360, color: Q7({ h: t, s: 100, v: 100, a: 1 }) })));
}), edn = ie.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: Q7({ h: t.h, s: 100, v: 100, a: 1 }) };
  return ie.createElement("div", { className: "react-colorful__saturation", style: r }, ie.createElement(G4e, { onMove: function(i) {
    n({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    n({ s: Wk(t.s + 100 * i.left, 0, 100), v: Wk(t.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + Ss(t.s) + "%, Brightness " + Ss(t.v) + "%" }, ie.createElement(Y4e, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Q7(t) })));
}), J4e = function(e, t) {
  if (e === t) return !0;
  for (var n in e) if (e[n] !== t[n]) return !1;
  return !0;
}, tdn = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || J4e(H7(e), H7(t));
};
function ndn(e, t, n) {
  var r = W7(n), i = He(function() {
    return e.toHsva(t);
  }), o = i[0], s = i[1], l = Xe({ color: t, hsva: o });
  nt(function() {
    if (!e.equal(t, l.current.color)) {
      var a = e.toHsva(t);
      l.current = { hsva: a, color: t }, s(a);
    }
  }, [t, e]), nt(function() {
    var a;
    J4e(o, l.current.hsva) || e.equal(a = e.fromHsva(o), l.current.color) || (l.current = { hsva: o, color: a }, r(a));
  }, [o, e, r]);
  var c = qn(function(a) {
    s(function(u) {
      return Object.assign({}, u, a);
    });
  }, []);
  return [o, c];
}
var rdn = typeof window < "u" ? Og : nt, idn = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, Mye = /* @__PURE__ */ new Map(), odn = function(e) {
  rdn(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !Mye.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, Mye.set(t, n);
      var r = idn();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, sdn = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, i = r === void 0 ? n.defaultColor : r, o = e.onChange, s = K4e(e, ["className", "colorModel", "color", "onChange"]), l = Xe(null);
  odn(l);
  var c = ndn(n, i, o), a = c[0], u = c[1], f = pee(["react-colorful", t]);
  return ie.createElement("div", Z3({}, s, { ref: l, className: f }), ie.createElement(edn, { hsva: a, onChange: u }), ie.createElement(Jun, { hue: a.h, onChange: u, className: "react-colorful__last-control" }));
}, adn = { defaultColor: "000", toHsva: Hun, fromHsva: function(e) {
  return Qun({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: tdn }, ldn = function(e) {
  return ie.createElement(sdn, Z3({}, e, { colorModel: adn }));
};
const eVe = Fo(
  ({ disabled: e, value: t, onChange: n, onBlur: r, name: i, className: o, ...s }, l) => {
    const c = dat(l), [a, u] = He(!1), f = Kt(() => t || "var(--color-3)", [t]);
    return /* @__PURE__ */ V(mx, { onOpenChange: u, open: a, children: [
      /* @__PURE__ */ y(gx, { asChild: !0, disabled: e, onBlur: r, children: /* @__PURE__ */ y(
        Qe,
        {
          ...s,
          className: Se("block rounded-full", o),
          name: i,
          onClick: () => {
            u(!0);
          },
          size: "icon",
          style: {
            backgroundColor: f
          },
          variant: "outline",
          children: /* @__PURE__ */ y("div", {})
        }
      ) }),
      /* @__PURE__ */ V(Sb, { className: "w-full", children: [
        /* @__PURE__ */ y(ldn, { color: f, onChange: n }),
        /* @__PURE__ */ y(
          fr,
          {
            maxLength: 7,
            onChange: (d) => {
              var p;
              n((p = d == null ? void 0 : d.currentTarget) == null ? void 0 : p.value);
            },
            ref: c,
            value: f
          }
        )
      ] })
    ] });
  }
);
eVe.displayName = "ColorPicker";
const cdn = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    y: 0
  };
};
function udn(e, t, n) {
  const r = {
    ...e
  };
  return t.top + e.y <= n.top ? r.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (r.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? r.x = n.left - t.left : t.right + e.x >= n.left + n.width && (r.x = n.left + n.width - t.right), r;
}
const yq = (e) => {
  let {
    containerNodeRect: t,
    draggingNodeRect: n,
    transform: r
  } = e;
  return !n || !t ? r : udn(r, n, t);
}, ddn = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    x: 0
  };
};
function hee(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function fdn(e, t) {
  return e.reduce((n, r, i) => {
    const o = t.get(r);
    return o && (n[i] = o), n;
  }, Array(e.length));
}
function ER(e) {
  return e !== null && e >= 0;
}
function pdn(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function hdn(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const TR = {
  scaleX: 1,
  scaleY: 1
}, mdn = (e) => {
  var t;
  let {
    rects: n,
    activeNodeRect: r,
    activeIndex: i,
    overIndex: o,
    index: s
  } = e;
  const l = (t = n[i]) != null ? t : r;
  if (!l)
    return null;
  const c = gdn(n, s, i);
  if (s === i) {
    const a = n[o];
    return a ? {
      x: i < o ? a.left + a.width - (l.left + l.width) : a.left - l.left,
      y: 0,
      ...TR
    } : null;
  }
  return s > i && s <= o ? {
    x: -l.width - c,
    y: 0,
    ...TR
  } : s < i && s >= o ? {
    x: l.width + c,
    y: 0,
    ...TR
  } : {
    x: 0,
    y: 0,
    ...TR
  };
};
function gdn(e, t, n) {
  const r = e[t], i = e[t - 1], o = e[t + 1];
  return !r || !i && !o ? 0 : n < t ? i ? r.left - (i.left + i.width) : o.left - (r.left + r.width) : o ? o.left - (r.left + r.width) : r.left - (i.left + i.width);
}
const tVe = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: i
  } = e;
  const o = hee(t, r, n), s = t[i], l = o[i];
  return !l || !s ? null : {
    x: l.left - s.left,
    y: l.top - s.top,
    scaleX: l.width / s.width,
    scaleY: l.height / s.height
  };
}, kR = {
  scaleX: 1,
  scaleY: 1
}, ydn = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: i,
    rects: o,
    overIndex: s
  } = e;
  const l = (t = o[n]) != null ? t : r;
  if (!l)
    return null;
  if (i === n) {
    const a = o[s];
    return a ? {
      x: 0,
      y: n < s ? a.top + a.height - (l.top + l.height) : a.top - l.top,
      ...kR
    } : null;
  }
  const c = vdn(o, i, n);
  return i > n && i <= s ? {
    x: 0,
    y: -l.height - c,
    ...kR
  } : i < n && i >= s ? {
    x: 0,
    y: l.height + c,
    ...kR
  } : {
    x: 0,
    y: 0,
    ...kR
  };
};
function vdn(e, t, n) {
  const r = e[t], i = e[t - 1], o = e[t + 1];
  return r ? n < t ? i ? r.top - (i.top + i.height) : o ? o.top - (r.top + r.height) : 0 : o ? o.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
const nVe = "Sortable", rVe = /* @__PURE__ */ ie.createContext({
  activeIndex: -1,
  containerId: nVe,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: tVe,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function bdn(e) {
  let {
    children: t,
    id: n,
    items: r,
    strategy: i = tVe,
    disabled: o = !1
  } = e;
  const {
    active: s,
    dragOverlay: l,
    droppableRects: c,
    over: a,
    measureDroppableContainers: u
  } = oTe(), f = lN(nVe, n), d = l.rect !== null, p = Kt(() => r.map((S) => typeof S == "object" && "id" in S ? S.id : S), [r]), h = s != null, m = s ? p.indexOf(s.id) : -1, v = a ? p.indexOf(a.id) : -1, b = Xe(p), A = !pdn(p, b.current), w = v !== -1 && m === -1 || A, O = hdn(o);
  su(() => {
    A && h && u(p);
  }, [A, p, h, u]), nt(() => {
    b.current = p;
  }, [p]);
  const x = Kt(
    () => ({
      activeIndex: m,
      containerId: f,
      disabled: O,
      disableTransforms: w,
      items: p,
      overIndex: v,
      useDragOverlay: d,
      sortedRects: fdn(p, c),
      strategy: i
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m, f, O.draggable, O.droppable, w, p, v, c, d, i]
  );
  return ie.createElement(rVe.Provider, {
    value: x
  }, t);
}
const Odn = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: i
  } = e;
  return hee(n, r, i).indexOf(t);
}, Adn = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: i,
    items: o,
    newIndex: s,
    previousItems: l,
    previousContainerId: c,
    transition: a
  } = e;
  return !a || !r || l !== o && i === s ? !1 : n ? !0 : s !== i && t === c;
}, wdn = {
  duration: 200,
  easing: "ease"
}, iVe = "transform", xdn = /* @__PURE__ */ ig.Transition.toString({
  property: iVe,
  duration: 0,
  easing: "linear"
}), Sdn = {
  roleDescription: "sortable"
};
function Edn(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: i
  } = e;
  const [o, s] = He(null), l = Xe(n);
  return su(() => {
    if (!t && n !== l.current && r.current) {
      const c = i.current;
      if (c) {
        const a = hx(r.current, {
          ignoreTransform: !0
        }), u = {
          x: c.left - a.left,
          y: c.top - a.top,
          scaleX: c.width / a.width,
          scaleY: c.height / a.height
        };
        (u.x || u.y) && s(u);
      }
    }
    n !== l.current && (l.current = n);
  }, [t, n, r, i]), nt(() => {
    o && s(null);
  }, [o]), o;
}
function Tdn(e) {
  let {
    animateLayoutChanges: t = Adn,
    attributes: n,
    disabled: r,
    data: i,
    getNewIndex: o = Odn,
    id: s,
    strategy: l,
    resizeObserverConfig: c,
    transition: a = wdn
  } = e;
  const {
    items: u,
    containerId: f,
    activeIndex: d,
    disabled: p,
    disableTransforms: h,
    sortedRects: m,
    overIndex: v,
    useDragOverlay: b,
    strategy: A
  } = kr(rVe), w = kdn(r, p), O = u.indexOf(s), x = Kt(() => ({
    sortable: {
      containerId: f,
      index: O,
      items: u
    },
    ...i
  }), [f, i, O, u]), S = Kt(() => u.slice(u.indexOf(s)), [u, s]), {
    rect: E,
    node: k,
    isOver: T,
    setNodeRef: R
  } = e$({
    id: s,
    data: x,
    disabled: w.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: S,
      ...c
    }
  }), {
    active: j,
    activatorEvent: F,
    activeNodeRect: L,
    attributes: _,
    setNodeRef: U,
    listeners: z,
    isDragging: C,
    over: I,
    setActivatorNodeRef: M,
    transform: D
  } = JQ({
    id: s,
    data: x,
    attributes: {
      ...Sdn,
      ...n
    },
    disabled: w.draggable
  }), X = Ryt(R, U), B = !!j, q = B && !h && ER(d) && ER(v), H = !b && C, Y = H && q ? D : null, oe = q ? Y ?? (l ?? A)({
    rects: m,
    activeNodeRect: L,
    activeIndex: d,
    overIndex: v,
    index: O
  }) : null, ce = ER(d) && ER(v) ? o({
    id: s,
    items: u,
    activeIndex: d,
    overIndex: v
  }) : O, fe = j == null ? void 0 : j.id, $ = Xe({
    activeId: fe,
    items: u,
    newIndex: ce,
    containerId: f
  }), pe = u !== $.current.items, ee = t({
    active: j,
    containerId: f,
    isDragging: C,
    isSorting: B,
    id: s,
    index: O,
    items: u,
    newIndex: $.current.newIndex,
    previousItems: $.current.items,
    previousContainerId: $.current.containerId,
    transition: a,
    wasDragging: $.current.activeId != null
  }), Ce = Edn({
    disabled: !ee,
    index: O,
    node: k,
    rect: E
  });
  return nt(() => {
    B && $.current.newIndex !== ce && ($.current.newIndex = ce), f !== $.current.containerId && ($.current.containerId = f), u !== $.current.items && ($.current.items = u);
  }, [B, ce, f, u]), nt(() => {
    if (fe === $.current.activeId)
      return;
    if (fe && !$.current.activeId) {
      $.current.activeId = fe;
      return;
    }
    const Ve = setTimeout(() => {
      $.current.activeId = fe;
    }, 50);
    return () => clearTimeout(Ve);
  }, [fe]), {
    active: j,
    activeIndex: d,
    attributes: _,
    data: x,
    rect: E,
    index: O,
    newIndex: ce,
    items: u,
    isOver: T,
    isSorting: B,
    isDragging: C,
    listeners: z,
    node: k,
    overIndex: v,
    over: I,
    setNodeRef: X,
    setActivatorNodeRef: M,
    setDroppableNodeRef: R,
    setDraggableNodeRef: U,
    transform: Ce ?? oe,
    transition: Ee()
  };
  function Ee() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      Ce || // Or to prevent items jumping to back to their "new" position when items change
      pe && $.current.newIndex === O
    )
      return xdn;
    if (!(H && !Qz(F) || !a) && (B || ee))
      return ig.Transition.toString({
        ...a,
        property: iVe
      });
  }
}
function kdn(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
Pr.Down, Pr.Right, Pr.Up, Pr.Left;
function Cdn(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function oVe(...e) {
  return (t) => e.forEach((n) => Cdn(n, t));
}
const Ndn = {
  vertical: {
    modifiers: [ddn, yq],
    strategy: ydn
  },
  horizontal: {
    modifiers: [cdn, yq],
    strategy: mdn
  },
  mixed: {
    modifiers: [yq],
    strategy: void 0
  }
};
function sVe({
  value: e,
  onValueChange: t,
  collisionDetection: n = Kyt,
  modifiers: r,
  strategy: i,
  onMove: o,
  orientation: s = "vertical",
  overlay: l,
  children: c,
  ...a
}) {
  const [u, f] = N.useState(null), d = VEe(
    wE(YEe),
    wE(GQ),
    wE(QQ)
  ), p = Ndn[s];
  return /* @__PURE__ */ V(
    iTe,
    {
      modifiers: r ?? p.modifiers,
      sensors: d,
      onDragStart: ({ active: h }) => f(h.id),
      onDragEnd: ({ active: h, over: m }) => {
        if (m && h.id !== (m == null ? void 0 : m.id)) {
          const v = e.findIndex((A) => A.id === h.id), b = e.findIndex((A) => A.id === m.id);
          o ? o({ activeIndex: v, overIndex: b }) : t == null || t(hee(e, v, b));
        }
        f(null);
      },
      onDragCancel: () => f(null),
      collisionDetection: n,
      ...a,
      children: [
        /* @__PURE__ */ y(bdn, { items: e, strategy: i ?? p.strategy, children: c }),
        l ? /* @__PURE__ */ y(aVe, { activeId: u, children: l }) : null
      ]
    }
  );
}
const Pdn = {
  sideEffects: sTe({
    styles: {
      active: {
        opacity: "0.4"
      }
    }
  })
}, aVe = N.forwardRef(
  ({ activeId: e, dropAnimation: t = Pdn, children: n, ...r }, i) => /* @__PURE__ */ y(aTe, { dropAnimation: t, ...r, children: e ? /* @__PURE__ */ y(
    H3,
    {
      ref: i,
      value: e,
      className: "cursor-grabbing",
      asChild: !0,
      children: n
    }
  ) : null })
);
aVe.displayName = "SortableOverlay";
const lVe = N.createContext({
  attributes: {},
  listeners: void 0,
  isDragging: !1
});
function Idn() {
  const e = N.useContext(lVe);
  if (!e)
    throw new Error("useSortableItem must be used within a SortableItem");
  return e;
}
const H3 = N.forwardRef(
  ({ value: e, asTrigger: t, asChild: n, className: r, ...i }, o) => {
    const {
      attributes: s,
      listeners: l,
      setNodeRef: c,
      transform: a,
      transition: u,
      isDragging: f
    } = Tdn({ id: e }), d = N.useMemo(
      () => ({
        attributes: s,
        listeners: l,
        isDragging: f
      }),
      [s, l, f]
    ), p = {
      opacity: f ? 0.5 : 1,
      transform: ig.Translate.toString(a),
      transition: u
    }, h = n ? is : "div";
    return /* @__PURE__ */ y(lVe.Provider, { value: d, children: /* @__PURE__ */ y(
      h,
      {
        "data-state": f ? "dragging" : void 0,
        className: Se(
          "data-[state=dragging]:cursor-grabbing",
          { "cursor-grab": !f && t },
          r
        ),
        ref: oVe(o, c),
        style: p,
        ...t ? s : {},
        ...t ? l : {},
        ...i
      }
    ) });
  }
);
H3.displayName = "SortableItem";
const mee = N.forwardRef(({ className: e, ...t }, n) => {
  const { attributes: r, listeners: i, isDragging: o } = Idn();
  return /* @__PURE__ */ y(
    Qe,
    {
      ref: oVe(n),
      "data-state": o ? "dragging" : void 0,
      className: Se(
        "cursor-grab data-[state=dragging]:cursor-grabbing",
        e
      ),
      type: "button",
      ...r,
      ...i,
      ...t
    }
  );
});
mee.displayName = "SortableDragHandle";
const cVe = ie.memo(
  ({
    inputName: e,
    disabled: t,
    required: n,
    customInputNode: r,
    thinInputs: i
  }) => {
    const o = _r(), [s, l] = He(() => {
      const h = o.getValues(e);
      return h ? h.map((m) => ({
        id: Fu(),
        value: m
      })) : [];
    }), c = (h) => {
      o.setValue(
        e,
        h.map((m) => m.value),
        { shouldValidate: !0 }
      );
    }, a = () => {
      const m = [
        ...(o.getValues(e) || []).map((v) => ({
          id: Fu(),
          value: v
        })),
        { id: Fu(), value: "" }
      ];
      l(m), c(m);
    }, u = (h) => {
      const v = o.getValues(e).map((b) => ({
        id: Fu(),
        value: b
      })).filter((b, A) => A !== h);
      l(v), c(v);
    }, f = (h, m) => {
      const v = [...s], [b] = v.splice(h, 1);
      v.splice(m, 0, b), l(v), c(v);
    }, d = (h, m) => {
      const v = s.map(
        (b, A) => A === h ? { ...b, value: m } : b
      );
      l(v), c(v);
    }, p = !n || s.length > 1;
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y("div", { className: "flex w-full flex-col gap-4 ", children: /* @__PURE__ */ y(
        sVe,
        {
          value: s,
          onMove: ({ activeIndex: h, overIndex: m }) => {
            f(h, m);
          },
          children: s.map((h, m) => /* @__PURE__ */ y(H3, { value: h.id, asChild: !0, children: /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ y(
              mee,
              {
                variant: "outline",
                size: "icon",
                disabled: t,
                className: Se("shrink-0 size-8", i && "size-7"),
                children: /* @__PURE__ */ y(
                  fMe,
                  {
                    className: "size-4",
                    "aria-hidden": "true"
                  }
                )
              }
            ),
            /* @__PURE__ */ y(
              Zn,
              {
                control: o.control,
                name: `${e}.${m}`,
                render: () => /* @__PURE__ */ y(Jn, { className: "grow", children: /* @__PURE__ */ y(Hi, { children: r ? r(
                  (v) => d(m, v),
                  h.value,
                  t
                ) : /* @__PURE__ */ y(
                  fr,
                  {
                    thin: i,
                    value: h.value,
                    onChange: (v) => d(m, v.target.value),
                    disabled: t,
                    className: "grow"
                  }
                ) }) })
              }
            ),
            p && /* @__PURE__ */ V(
              Qe,
              {
                type: "button",
                variant: "outline",
                size: "icon",
                disabled: t,
                className: Se("shrink-0 size-8", i && "size-7"),
                onClick: () => {
                  u(m);
                },
                children: [
                  /* @__PURE__ */ y(
                    xb,
                    {
                      className: "size-4 text-destructive",
                      "aria-hidden": "true"
                    }
                  ),
                  /* @__PURE__ */ y("span", { className: "sr-only", children: Z("Remove") })
                ]
              }
            )
          ] }) }, h.id))
        }
      ) }),
      !t && /* @__PURE__ */ y(
        Qe,
        {
          variant: "outline",
          size: "sm",
          className: "mt-3",
          onClick: () => {
            a();
          },
          type: "button",
          children: /* @__PURE__ */ y(eee, { icon: /* @__PURE__ */ y(Da, { size: 18 }), text: Z("Add Item") })
        }
      )
    ] });
  }
);
cVe.displayName = "ArrayInput";
const Rdn = (e) => Object.entries(e).reduce((t, [n, r]) => {
  switch (r.type) {
    case Le.LONG_TEXT:
    case Le.SHORT_TEXT:
    case Le.NUMBER:
    case Le.JSON:
    case Le.COLOR:
      return {
        ...t,
        [n]: ""
      };
    case Le.CHECKBOX:
      return {
        ...t,
        [n]: !1
      };
    case Le.STATIC_DROPDOWN:
    case Le.STATIC_MULTI_SELECT_DROPDOWN:
    case Le.MULTI_SELECT_DROPDOWN:
    case Le.DATE_TIME:
      return {
        ...t,
        [n]: null
      };
    case Le.FILE:
      return {
        ...t,
        [n]: null
      };
  }
}, {}), uVe = ie.memo(
  ({
    inputName: e,
    useMentionTextInput: t,
    disabled: n,
    arrayProperty: r
  }) => {
    const i = _r(), [o, s] = He(() => {
      const u = i.getValues(e);
      return u ? u.map((f) => ({
        id: Fu(),
        value: f
      })) : [];
    }), l = (u) => {
      i.setValue(
        e,
        u.map((f) => f.value),
        { shouldValidate: !0 }
      );
    }, c = () => {
      const u = r.properties ? Rdn(r.properties) : "", d = [
        ...(i.getValues(e) || []).map((p) => ({
          id: Fu(),
          value: p
        })),
        { id: Fu(), value: u }
      ];
      s(d), l(d);
    }, a = (u) => {
      const d = i.getValues(e).map((p) => ({
        id: Fu(),
        value: p
      })).filter((p, h) => h !== u);
      s(d), l(d);
    };
    return /* @__PURE__ */ V(pt, { children: [
      r.properties && /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y("div", { className: "flex w-full flex-col gap-4", children: o.map((u, f) => /* @__PURE__ */ V(
          "div",
          {
            className: "p-4 border rounded-md flex flex-col gap-4",
            children: [
              /* @__PURE__ */ V("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ V("div", { className: "font-semibold", children: [
                  " #",
                  f + 1
                ] }),
                /* @__PURE__ */ V(
                  Qe,
                  {
                    variant: "outline",
                    size: "icon",
                    className: "size-8 shrink-0",
                    onClick: () => {
                      a(f);
                    },
                    disabled: n,
                    children: [
                      /* @__PURE__ */ y(
                        xb,
                        {
                          className: "size-4 text-destructive",
                          "aria-hidden": "true"
                        }
                      ),
                      /* @__PURE__ */ y("span", { className: "sr-only", children: Z("Remove") })
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ y(
                bh,
                {
                  prefixValue: `${e}.[${f}]`,
                  props: r.properties,
                  useMentionTextInput: t,
                  propertySettings: null,
                  dynamicPropsInfo: null,
                  disabled: n,
                  onValueChange: () => {
                    i.trigger(e);
                  }
                }
              )
            ]
          },
          "array-item-" + u.id
        )) }),
        !n && /* @__PURE__ */ y(
          Qe,
          {
            variant: "outline",
            size: "sm",
            className: "mt-2",
            onClick: () => {
              c();
            },
            type: "button",
            children: /* @__PURE__ */ y(eee, { icon: /* @__PURE__ */ y(Da, { size: 18 }), text: Z("Add Item") })
          }
        )
      ] }),
      !r.properties && /* @__PURE__ */ y(
        cVe,
        {
          inputName: e,
          disabled: n,
          required: r.required,
          customInputNode: (u, f, d) => t ? /* @__PURE__ */ y(
            bg,
            {
              initialValue: f,
              onChange: (p) => u(p),
              disabled: d
            }
          ) : /* @__PURE__ */ y(
            fr,
            {
              value: f,
              onChange: (p) => u(p.target.value),
              disabled: d
            }
          )
        }
      )
    ] });
  }
);
uVe.displayName = "ArrayPieceProperty";
const Mdn = Ri(null), vq = {
  didCatch: !1,
  error: null
};
class dVe extends Tqe {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = vq;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(vq);
    }
  }
  componentDidCatch(t, n) {
    var r, i;
    (r = (i = this.props).onError) === null || r === void 0 || r.call(i, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (r && n.error !== null && Ddn(t.resetKeys, i)) {
      var o, s;
      (o = (s = this.props).onReset) === null || o === void 0 || o.call(s, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(vq);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: i
    } = this.props, {
      didCatch: o,
      error: s
    } = this.state;
    let l = t;
    if (o) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof n == "function")
        l = n(c);
      else if (r)
        l = oi(r, c);
      else if (i !== void 0)
        l = i;
      else
        throw s;
    }
    return oi(Mdn.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, l);
  }
}
function Ddn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
var _dn = "Toggle", fVe = N.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: i, ...o } = e, [s = !1, l] = wl({
    prop: n,
    onChange: i,
    defaultProp: r
  });
  return /* @__PURE__ */ y(
    Zt.button,
    {
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...o,
      ref: t,
      onClick: ot(e.onClick, () => {
        e.disabled || l(!s);
      })
    }
  );
});
fVe.displayName = _dn;
var pVe = fVe;
const Ldn = as(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-10 px-3",
        sm: "h-9 px-2.5",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), hVe = N.forwardRef(({ className: e, variant: t, size: n, ...r }, i) => /* @__PURE__ */ y(
  pVe,
  {
    ref: i,
    className: Se(Ldn({ variant: t, size: n, className: e })),
    ...r
  }
));
hVe.displayName = pVe.displayName;
const mVe = ie.memo(
  (e) => {
    const t = Xe(null), [
      n,
      r
    ] = tn((s) => [
      s.isFocusInsideListMapperModeInput,
      s.setIsFocusInsideListMapperModeInput
    ]), { inputName: i, disabled: o } = e;
    return vv.useIsFocusInsideListMapperModeInput({
      containerRef: t,
      setIsFocusInsideListMapperModeInput: r,
      isFocusInsideListMapperModeInput: n
    }), /* @__PURE__ */ y("div", { className: "w-full", ref: t, children: e.arrayProperties ? /* @__PURE__ */ y("div", { className: "p-4 border rounded-md flex flex-col gap-4", children: /* @__PURE__ */ y(
      bh,
      {
        prefixValue: i,
        props: e.arrayProperties,
        useMentionTextInput: !0,
        propertySettings: null,
        disabled: o,
        dynamicPropsInfo: null
      }
    ) }) : /* @__PURE__ */ y(
      bg,
      {
        disabled: o,
        onChange: e.onChange,
        initialValue: e.value ?? null
      }
    ) });
  }
);
mVe.displayName = "ArrayPiecePropertyInInlineItemMode";
function ku({
  placeBeforeLabelText: e = !1,
  hideLabel: t,
  children: n,
  allowDynamicValues: r,
  propertyName: i,
  inputName: o,
  property: s,
  disabled: l,
  field: c,
  dynamicInputModeToggled: a,
  //we have to pass this prop, because props inside custom auth can be secret text, which means their labels will become (Connection)
  isForConnectionSelect: u = !1
}) {
  const f = !gVe(s) && s.type === Le.ARRAY, d = u || Array.isArray(s);
  return /* @__PURE__ */ y(
    zdn,
    {
      field: c,
      property: s ?? null,
      dynamicInputModeToggled: a,
      children: /* @__PURE__ */ V(Jn, { className: "flex flex-col gap-1", children: [
        (!t || e) && /* @__PURE__ */ V(ui, { className: "flex items-center gap-1 ", children: [
          e && !a && n,
          /* @__PURE__ */ V("div", { children: [
            /* @__PURE__ */ y("span", { children: d ? Z("Connection") : s.displayName }),
            " ",
            (d || s.required) && /* @__PURE__ */ y("span", { className: "text-destructive", children: "*" })
          ] }),
          s && !d && /* @__PURE__ */ y(Udn, { property: s }),
          /* @__PURE__ */ y("span", { className: "grow" }),
          r && /* @__PURE__ */ y(
            Fdn,
            {
              propertyName: i,
              inputName: o,
              property: s,
              disabled: l,
              isToggled: a ?? !1
            }
          )
        ] }),
        a && !f && /* @__PURE__ */ y(
          bg,
          {
            disabled: l,
            onChange: c.onChange,
            initialValue: c.value ?? null
          }
        ),
        f && a && /* @__PURE__ */ y(
          mVe,
          {
            disabled: l,
            arrayProperties: s.properties,
            inputName: o,
            onChange: c.onChange,
            value: c.value ?? null
          }
        ),
        !e && !a && /* @__PURE__ */ y("div", { children: n }),
        !u && !Array.isArray(s) && s.description && /* @__PURE__ */ y(x7, { text: Z(s.description) })
      ] })
    }
  );
}
function zdn({
  children: e,
  field: t,
  property: n,
  dynamicInputModeToggled: r
}) {
  return /* @__PURE__ */ y(
    dVe,
    {
      fallbackRender: () => /* @__PURE__ */ V("div", { className: "text-sm  flex items-center justify-between", children: [
        /* @__PURE__ */ y("div", { className: "text-red-500", children: Z("input value is invalid, please contact support") }),
        /* @__PURE__ */ y(
          Qe,
          {
            variant: "outline",
            size: "sm",
            onClick: () => {
              navigator.clipboard.writeText(
                JSON.stringify({
                  stringifiedValue: Vdn(t.value),
                  property: n,
                  dynamicInputModeToggled: r,
                  disabled: t.disabled
                })
              ), vr(Z("Info copied to clipboard, please send it to support"), {
                duration: 3e3
              });
            },
            children: Z("Info")
          }
        )
      ] }),
      children: e
    }
  );
}
function jdn(e, t, n) {
  const r = gVe(e);
  switch (t) {
    case dc.DYNAMIC:
      return !r && e.type === Le.ARRAY ? Bc.getDefaultPropertyValue({
        property: e,
        dynamicInputModeToggled: !0
      }) : typeof n == "string" || typeof n == "number" ? n : JSON.stringify(n);
    case dc.MANUAL:
      return r ? "" : Bc.getDefaultPropertyValue({
        property: e,
        dynamicInputModeToggled: !1
      });
  }
}
function Fdn({
  propertyName: e,
  inputName: t,
  property: n,
  disabled: r,
  isToggled: i
}) {
  const o = _r();
  function s(c) {
    var u, f;
    const a = {
      ...(f = (u = o.getValues().settings) == null ? void 0 : u.propertySettings) == null ? void 0 : f[e],
      type: c
    };
    o.setValue(
      `settings.propertySettings.${e}`,
      a
    );
  }
  function l(c) {
    if (s(c), qdn(t)) {
      const a = o.getValues(t), u = jdn(
        n,
        c,
        a
      );
      o.setValue(t, u, {
        shouldValidate: !0
      });
    } else
      throw new Error(
        "inputName is not a member of step settings input, you might be using dynamic properties where you should not"
      );
  }
  return /* @__PURE__ */ y("div", { className: "flex gap-2 items-center", children: /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
      hVe,
      {
        pressed: i,
        onPressedChange: (c) => l(
          c ? dc.DYNAMIC : dc.MANUAL
        ),
        disabled: r,
        children: /* @__PURE__ */ y(
          rst,
          {
            className: Se("size-5", {
              "text-foreground": i,
              "text-muted-foreground": !i
            })
          }
        )
      }
    ) }),
    /* @__PURE__ */ y(An, { side: "top", children: Z("Dynamic value") })
  ] }) });
}
function Udn({ property: e }) {
  return e.type !== Le.FILE && e.type !== Le.DATE_TIME ? null : /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: e.type === Le.FILE ? /* @__PURE__ */ y(KH, { className: "w-4 h-4 stroke-foreground/55" }) : e.type === Le.DATE_TIME && /* @__PURE__ */ y(rit, { className: "w-4 h-4 stroke-foreground/55" }) }),
    /* @__PURE__ */ y(An, { side: "bottom", children: /* @__PURE__ */ V(pt, { children: [
      e.type === Le.FILE && Z("File Input i.e a url or file passed from a previous step"),
      e.type === Le.DATE_TIME && Z("Date Input must comply with ISO 8601 format")
    ] }) })
  ] });
}
function Vdn(e) {
  try {
    return typeof e == "string" || typeof e == "number" ? e : JSON.stringify(e);
  } catch {
    return e;
  }
}
ku.displayName = "AutoFormFieldWrapper";
function qdn(e) {
  return e.match(/settings\.input\./) !== null;
}
function gVe(e) {
  const t = [
    Le.SECRET_TEXT,
    Le.BASIC_AUTH,
    Le.OAUTH2,
    Le.CUSTOM_AUTH
  ];
  return Array.isArray(e) || t.some((n) => e.type === n);
}
const yVe = ({
  field: e,
  disabled: t
}) => {
  const [n] = tn((r) => [
    r.setInsertMentionHandler
  ]);
  return /* @__PURE__ */ y(
    V3,
    {
      field: e,
      readonly: t ?? !1,
      onFocus: (r) => {
        n((i) => {
          var o, s;
          (s = (o = r.current) == null ? void 0 : o.view) == null || s.dispatch({
            changes: {
              from: r.current.view.state.selection.main.head,
              insert: `{{${i}}}`
            }
          });
        });
      },
      className: Zp.inputWithMentionsCssClass
    }
  );
};
yVe.displayName = "BuilderJsonEditorWrapper";
const Bdn = "custom-property-container", Xdn = (e) => new Function(
  "params",
  `
    return (${e})(params);
  `
), vVe = ({
  value: e,
  onChange: t,
  code: n,
  disabled: r,
  property: i
}) => {
  const { project: o } = bJ.useCurrentProject(), { embedState: s } = bd(), l = wve(), c = Bdn + "-" + l;
  return nt(() => {
    try {
      const a = {
        containerId: c,
        value: e,
        onChange: t,
        isEmbedded: s.isEmbedded,
        projectId: o.id,
        disabled: r,
        property: i
      }, f = Xdn(n)(a);
      if (f && typeof f == "function")
        return f;
    } catch (a) {
      console.error("Error executing custom code:", a);
    }
  }, []), /* @__PURE__ */ y("div", { id: c });
};
vVe.displayName = "CustomProperty";
const gee = ({
  children: e
}) => {
  const [t, n] = He(Date.now()), r = Xe(!1);
  return /* @__PURE__ */ y(
    dVe,
    {
      fallback: r.current ? /* @__PURE__ */ V("div", { className: "text-sm text-red-500 italic flex justify-between items-center", children: [
        Z("Unexpected error, please refresh the page or contact support"),
        /* @__PURE__ */ V(
          Qe,
          {
            size: "icon",
            variant: "outline",
            onClick: () => {
              window.location.reload();
            },
            children: [
              /* @__PURE__ */ y(rD, { className: "w-4 h-4 text-foreground!" }),
              " "
            ]
          }
        )
      ] }) : /* @__PURE__ */ V("div", { className: "text-sm text-red-500 italic flex justify-between items-center", children: [
        Z("Unexpected error, please retry"),
        /* @__PURE__ */ V(
          Qe,
          {
            size: "icon",
            variant: "outline",
            onClick: () => {
              n(Date.now()), r.current = !0;
            },
            children: [
              /* @__PURE__ */ y(rD, { className: "w-4 h-4 text-foreground!" }),
              " "
            ]
          }
        )
      ] }),
      children: e
    },
    t
  );
};
gee.displayName = "DynamicPropertiesErrorBoundary";
const bVe = ie.memo(
  (e) => {
    var A, w;
    const [t, n] = tn((O) => [
      O.flowVersion,
      O.readonly
    ]), r = Xe(!0), i = Xe(void 0), o = Xe(
      void 0
    ), s = [
      ...e.refreshers,
      F2
    ], [l, c] = He({
      disabled: !1,
      placeholder: Z("Select an option"),
      options: []
    }), { propertyLoadingFinished: a, propertyLoadingStarted: u } = kr(
      Fb
    ), { mutate: f, isPending: d, error: p } = nd.usePieceOptions({
      onMutate: () => {
        u(e.propertyName);
      },
      onError: (O) => {
        console.error(O), a(e.propertyName);
      },
      onSuccess: () => {
        a(e.propertyName);
      }
    });
    if (p)
      throw p;
    const h = DY({
      name: s.map((O) => e.placedInside === "stepSettings" ? `settings.input.${O}` : O),
      control: e.form.control
    }), m = (O) => {
      const x = {};
      s.forEach((S, E) => {
        x[S] = h[E];
      }), f(
        {
          request: {
            projectId: Rn.getProjectId(),
            pieceName: e.pieceName,
            pieceVersion: e.pieceVersion,
            propertyName: e.propertyName,
            actionOrTriggerName: e.actionOrTriggerName,
            input: x,
            flowVersionId: t.id,
            flowId: t.flowId,
            searchValue: O
          },
          propertyType: Le.DROPDOWN
        },
        {
          onSuccess: (S) => {
            o.current || (o.current = S.options), c(S.options);
          }
        }
      );
    };
    nt(() => {
      !r.current && !qg(i.current, h) && e.onChange(null), i.current = h, r.current = !1, m();
    }, h);
    const v = l.options.map((O) => ({
      label: O.label,
      value: O.value
    })), b = l.disabled || e.disabled;
    return e.multiple ? /* @__PURE__ */ y(
      W3,
      {
        placeholder: l.placeholder ?? Z("Select an option"),
        options: v,
        loading: d,
        onChange: (O) => e.onChange(O),
        disabled: b,
        initialValues: e.value,
        showDeselect: e.showDeselect && !De(e.value) && Array.isArray(e.value) && e.value.length > 0 && !b,
        showRefresh: !d && !n,
        onRefresh: m,
        refreshOnSearch: e.shouldRefreshOnSearch ? m : void 0,
        cachedOptions: ((A = o.current) == null ? void 0 : A.options) ?? []
      }
    ) : /* @__PURE__ */ y(
      vg,
      {
        options: v,
        disabled: l.disabled || e.disabled,
        loading: d,
        placeholder: l.placeholder ?? Z("Select an option"),
        value: e.value,
        onChange: (O) => e.onChange(O),
        showDeselect: e.showDeselect && !De(e.value) && !e.disabled,
        onRefresh: m,
        showRefresh: !d && !n,
        refreshOnSearch: e.shouldRefreshOnSearch ? m : void 0,
        cachedOptions: ((w = o.current) == null ? void 0 : w.options) ?? []
      }
    );
  }
), OVe = ie.memo(
  (e) => /* @__PURE__ */ y(gee, { children: /* @__PURE__ */ y(bVe, { ...e }) })
);
OVe.displayName = "DynamicDropdownPieceProperty";
bVe.displayName = "DynamicDropdownPiecePropertyImplementation";
var Dye = Object.prototype.hasOwnProperty;
function _ye(e, t, n) {
  for (n of e.keys())
    if (oT(n, t)) return n;
}
function oT(e, t) {
  var n, r, i;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((r = e.length) === t.length)
        for (; r-- && oT(e[r], t[r]); ) ;
      return r === -1;
    }
    if (n === Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if (i = r, i && typeof i == "object" && (i = _ye(t, i), !i) || !t.has(i)) return !1;
      return !0;
    }
    if (n === Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if (i = r[0], i && typeof i == "object" && (i = _ye(t, i), !i) || !oT(r[1], t.get(i)))
          return !1;
      return !0;
    }
    if (n === ArrayBuffer)
      e = new Uint8Array(e), t = new Uint8Array(t);
    else if (n === DataView) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e.getInt8(r) === t.getInt8(r); ) ;
      return r === -1;
    }
    if (ArrayBuffer.isView(e)) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e[r] === t[r]; ) ;
      return r === -1;
    }
    if (!n || typeof e == "object") {
      r = 0;
      for (n in e)
        if (Dye.call(e, n) && ++r && !Dye.call(t, n) || !(n in t) || !oT(e[n], t[n])) return !1;
      return Object.keys(t).length === r;
    }
  }
  return e !== e && t !== t;
}
function Wdn(e) {
  var t = N.useRef(e), n = N.useRef(0);
  return oT(e, t.current) || (t.current = e, n.current += 1), N.useMemo(function() {
    return t.current;
  }, [n.current]);
}
function Zdn(e, t) {
  return N.useEffect(e, Wdn(t));
}
const Hdn = (e) => Object.fromEntries(
  Object.entries(e).map(([t, n]) => n.type === Le.STATIC_DROPDOWN || n.type === Le.STATIC_MULTI_SELECT_DROPDOWN ? [t, { ...n, options: { disabled: !1, options: [] } }] : [t, n])
), AVe = ie.memo(
  (e) => {
    const [t, n] = tn((b) => [
      b.flowVersion,
      b.readonly
    ]), r = _r(), i = {
      name: e.placedInside === "stepSettings" ? "settings.input" : void 0
    }, o = DY(i), l = [
      ...e.refreshers,
      F2
    ].reduce((b, A) => (b[A] = o[A], b), {}), c = Xe(l), { propertyLoadingFinished: a, propertyLoadingStarted: u } = kr(
      Fb
    ), [f, d] = He(void 0), p = e.placedInside === "stepSettings" ? "settings.input" : "", { mutate: h, isPending: m } = nd.usePieceOptions({
      onMutate: () => {
        u(e.propertyName);
      },
      onError: (b) => {
        console.error(b), a(e.propertyName);
      },
      onSuccess: () => {
        a(e.propertyName);
      }
    }), v = () => {
      f && Object.keys(f).forEach((b) => {
        r.setValue(
          J0({
            propertyName: `${e.propertyName}.${b}`,
            prefix: p
          }),
          null,
          {
            //never validate for each prop, it can be a long list of props and cause the browser to freeze
            shouldValidate: !1
          }
        );
      }), r.setValue(
        J0({
          propertyName: e.propertyName,
          prefix: p
        }),
        null,
        {
          shouldValidate: !0
        }
      );
    };
    return Zdn(() => {
      qg(c.current, l) || v(), c.current = l, h(
        {
          request: {
            projectId: Rn.getProjectId(),
            pieceName: e.pieceName,
            pieceVersion: e.pieceVersion,
            propertyName: e.propertyName,
            actionOrTriggerName: e.actionOrTriggerName,
            input: l,
            flowVersionId: t.id,
            flowId: t.flowId
          },
          propertyType: Le.DYNAMIC
        },
        {
          onSuccess: (b) => {
            var x;
            const A = r.getValues(
              J0({
                propertyName: e.propertyName,
                prefix: p
              })
            ), w = Bc.getDefaultValueForProperties({
              props: b.options,
              existingInput: A ?? {},
              propertySettings: void 0
            });
            d(b.options);
            const O = Hdn(b.options);
            (x = e.updateFormSchema) == null || x.call(
              e,
              J0({
                propertyName: e.propertyName,
                prefix: p
              }),
              O
            ), !n && e.updatePropertySettingsSchema && e.updatePropertySettingsSchema(
              O,
              e.propertyName,
              r
            ), r.setValue(
              J0({
                propertyName: e.propertyName,
                prefix: p
              }),
              w,
              {
                shouldValidate: !0,
                shouldDirty: !0
              }
            );
          }
        }
      );
    }, [l]), /* @__PURE__ */ V(pt, { children: [
      m && /* @__PURE__ */ y(kQ, { numberOfItems: 3, className: "h-7" }),
      !m && f && /* @__PURE__ */ y(
        bh,
        {
          prefixValue: J0({
            propertyName: e.propertyName,
            prefix: p
          }),
          props: f,
          useMentionTextInput: !De(e.propertySettings),
          disabled: e.disabled,
          propertySettings: e.propertySettings,
          dynamicPropsInfo: null
        }
      )
    ] });
  }
), wVe = ie.memo((e) => /* @__PURE__ */ y(gee, { children: /* @__PURE__ */ y(AVe, { ...e }) }));
AVe.displayName = "DynamicPropertiesImplementation";
wVe.displayName = "DynamicProperties";
const J0 = ({
  propertyName: e,
  prefix: t
}) => t.length === 0 ? e : `${t}.${e}`, yee = ({
  field: e,
  propertyName: t,
  inputName: n,
  property: r,
  allowDynamicValues: i,
  markdownVariables: o,
  useMentionTextInput: s,
  disabled: l,
  dynamicInputModeToggled: c,
  form: a,
  dynamicPropsInfo: u,
  propertySettings: f,
  hideLabel: d,
  enableMarkdownForInputWithMention: p
}) => {
  switch (r.type) {
    case Le.ARRAY:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          hideLabel: d,
          propertyName: t,
          field: e,
          disabled: l,
          inputName: n,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(
            uVe,
            {
              disabled: l,
              arrayProperty: r,
              inputName: n,
              useMentionTextInput: s
            }
          )
        }
      );
    case Le.OBJECT:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          propertyName: t,
          field: e,
          hideLabel: d,
          inputName: n,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(
            Xk,
            {
              disabled: l,
              values: e.value,
              onChange: e.onChange,
              useMentionTextInput: s
            }
          )
        }
      );
    case Le.CHECKBOX:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          propertyName: t,
          disabled: l,
          hideLabel: d,
          field: e,
          inputName: n,
          allowDynamicValues: i,
          placeBeforeLabelText: !0,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(
            Iw,
            {
              id: t,
              checked: e.value,
              disabled: l,
              onCheckedChange: e.onChange
            }
          ) })
        }
      );
    case Le.MARKDOWN:
      return /* @__PURE__ */ y(
        uu,
        {
          markdown: r.description,
          variables: o,
          variant: r.variant
        }
      );
    case Le.STATIC_DROPDOWN:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          propertyName: t,
          inputName: n,
          field: e,
          hideLabel: d,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(
            vg,
            {
              options: r.options.options,
              onChange: e.onChange,
              value: e.value,
              disabled: l,
              placeholder: r.options.placeholder ?? Z("Select an option"),
              showDeselect: !r.required
            }
          )
        }
      );
    case Le.JSON:
      return /* @__PURE__ */ y(
        ku,
        {
          propertyName: t,
          inputName: n,
          property: r,
          field: e,
          hideLabel: d,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: s ? /* @__PURE__ */ y(
            yVe,
            {
              field: e,
              disabled: l
            }
          ) : /* @__PURE__ */ y(V3, { field: e, readonly: l })
        }
      );
    case Le.STATIC_MULTI_SELECT_DROPDOWN:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          inputName: n,
          propertyName: t,
          field: e,
          hideLabel: d,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(
            W3,
            {
              placeholder: r.options.placeholder ?? Z("Select an option"),
              options: r.options.options,
              onChange: e.onChange,
              initialValues: e.value,
              disabled: l,
              showDeselect: !De(e.value) && e.value.length > 0 && !r.required
            }
          )
        }
      );
    case Le.MULTI_SELECT_DROPDOWN:
    case Le.DROPDOWN:
      return /* @__PURE__ */ y(
        ku,
        {
          inputName: n,
          property: r,
          propertyName: t,
          field: e,
          hideLabel: d,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: De(u) ? /* @__PURE__ */ y("div", { children: "Error: dynamicPropsInfo is required" }) : /* @__PURE__ */ y(
            OVe,
            {
              refreshers: r.refreshers,
              value: e.value,
              actionOrTriggerName: u.actionOrTriggerName,
              pieceName: u.pieceName,
              pieceVersion: u.pieceVersion,
              form: a,
              placedInside: u.placedInside,
              onChange: e.onChange,
              disabled: l,
              propertyName: t,
              multiple: r.type === Le.MULTI_SELECT_DROPDOWN,
              showDeselect: !r.required,
              shouldRefreshOnSearch: r.refreshOnSearch ?? !1
            }
          )
        }
      );
    case Le.DATE_TIME:
    case Le.SHORT_TEXT:
    case Le.LONG_TEXT:
    case Le.FILE:
    case Le.NUMBER:
    case Le.SECRET_TEXT:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          inputName: n,
          field: e,
          hideLabel: d,
          propertyName: t,
          disabled: l,
          allowDynamicValues: !1,
          dynamicInputModeToggled: c,
          children: s ? /* @__PURE__ */ y(
            bg,
            {
              disabled: l,
              initialValue: e.value,
              onChange: e.onChange,
              enableMarkdown: p
            }
          ) : /* @__PURE__ */ y(
            fr,
            {
              ref: e.ref,
              value: e.value,
              onChange: e.onChange,
              disabled: l,
              type: r.type === Le.SECRET_TEXT ? "password" : "text"
            }
          )
        }
      );
    case Le.DYNAMIC:
      return u ? /* @__PURE__ */ y(
        wVe,
        {
          refreshers: r.refreshers,
          propertyName: t,
          disabled: l,
          pieceName: u.pieceName,
          pieceVersion: u.pieceVersion,
          actionOrTriggerName: u.actionOrTriggerName,
          placedInside: u.placedInside,
          propertySettings: f,
          updateFormSchema: u.updateFormSchema,
          updatePropertySettingsSchema: u.updatePropertySettingsSchema
        }
      ) : /* @__PURE__ */ y("div", { children: "Error: dynamicPropsInfo is required" });
    case Le.CUSTOM_AUTH:
    case Le.BASIC_AUTH:
    case Le.OAUTH2:
      return /* @__PURE__ */ y(pt, {});
    case Le.CUSTOM:
      return /* @__PURE__ */ y(
        vVe,
        {
          code: r.code,
          value: e.value,
          onChange: e.onChange,
          disabled: l,
          property: r
        }
      );
    case Le.COLOR:
      return /* @__PURE__ */ y(
        ku,
        {
          property: r,
          inputName: n,
          propertyName: t,
          field: e,
          hideLabel: d,
          disabled: l,
          allowDynamicValues: i,
          dynamicInputModeToggled: c,
          children: /* @__PURE__ */ y(eVe, { value: e.value, onChange: e.onChange })
        }
      );
  }
}, bh = ie.memo(
  ({
    markdownVariables: e,
    props: t,
    propertySettings: n,
    prefixValue: r,
    disabled: i,
    useMentionTextInput: o,
    onValueChange: s,
    dynamicPropsInfo: l
  }) => {
    const c = _r();
    return Object.keys(t).length > 0 && /* @__PURE__ */ y("div", { className: "flex flex-col gap-4 w-full", children: Object.entries(t).map(([a]) => {
      var f;
      const u = ((f = n == null ? void 0 : n[a]) == null ? void 0 : f.type) === dc.DYNAMIC;
      return /* @__PURE__ */ y(
        Zn,
        {
          name: r.length > 0 ? `${r}.${a}` : a,
          control: c.control,
          render: ({ field: d }) => yee({
            field: {
              ...d,
              onChange: (p) => {
                d.onChange(p), s == null || s({
                  value: p,
                  propertyName: a
                });
              }
            },
            propertyName: a,
            inputName: r.length > 0 ? `${r}.${a}` : a,
            property: t[a],
            allowDynamicValues: !De(n),
            markdownVariables: e ?? {},
            useMentionTextInput: o,
            disabled: i ?? !1,
            dynamicInputModeToggled: u,
            form: c,
            dynamicPropsInfo: l,
            propertySettings: n
          })
        },
        a
      );
    }) });
  }
);
bh.displayName = "GenericFormComponent";
function Qdn(e) {
  switch (e) {
    case Kd.NUMBER:
      return Le.NUMBER;
    case Kd.BOOLEAN:
      return Le.CHECKBOX;
    case Kd.OBJECT:
      return Le.OBJECT;
    case Kd.DATE:
      return Le.DATE_TIME;
    case Kd.ARRAY:
      return Le.ARRAY;
    case Kd.TEXT:
    default:
      return Le.SHORT_TEXT;
  }
}
function $dn({
  open: e,
  onOpenChange: t,
  onTestingSuccess: n
}) {
  const o = _r().getValues().settings.input.inputSchema, { mutate: s, isPending: l } = Hc.useSaveMockData({
    onSuccess: () => {
      n(), t(!1);
    }
  }), c = Fg({
    shouldFocusError: !0,
    defaultValues: o.filter((f) => f.name.trim() !== "").reduce((f, d) => (f[d.name] = d.type === Kd.BOOLEAN ? !1 : "", f), {}),
    resolver: (f) => {
      const d = o.reduce((p, h) => (h.required && h.type !== Kd.BOOLEAN && !f[h.name] && (p[h.name] = {
        type: "required",
        message: Z("{field} is required", { field: h.name })
      }), p), {});
      return {
        values: Object.keys(d).length === 0 ? f : {},
        errors: d
      };
    },
    mode: "onChange"
  });
  function a(f) {
    return f.replace(/[\s/@-]+/g, "_");
  }
  const u = o.reduce((f, d) => {
    const p = {
      displayName: d.name,
      description: d.description || "",
      required: d.required,
      type: Qdn(d.type),
      defaultValue: d.defaultValue
    };
    return f[d.name] = p, f;
  }, {});
  return /* @__PURE__ */ y(qa, { open: e, onOpenChange: t, children: /* @__PURE__ */ V(ia, { className: "w-full max-w-xl flex flex-col max-h-[90vh]", children: [
    /* @__PURE__ */ V(Ds, { children: [
      /* @__PURE__ */ y(_s, { className: "px-0.5", children: Z("Tool Sample Data") }),
      /* @__PURE__ */ y(kb, { className: "px-0.5", children: Z(
        "Fill in the following fields to use them as sample data for the trigger."
      ) })
    ] }),
    /* @__PURE__ */ y(Ug, { ...c, children: /* @__PURE__ */ V(
      "form",
      {
        className: "grid space-y-4",
        onSubmit: c.handleSubmit((f) => {
          const d = Object.fromEntries(
            Object.entries(f).filter(([p, h]) => p.trim() !== "").map(([p, h]) => [a(p), h])
          );
          s(d);
        }),
        children: [
          /* @__PURE__ */ y(Bi, { className: "flex-1 max-h-[50vh]", children: /* @__PURE__ */ y("div", { className: "py-4", children: Object.keys(u).length > 0 ? /* @__PURE__ */ y("div", { className: "space-y-4", children: Object.entries(u).map(
            ([f, d]) => {
              var h;
              const p = c.formState.errors[f];
              return /* @__PURE__ */ V(
                "div",
                {
                  className: "grid space-y-2 px-0.5",
                  children: [
                    /* @__PURE__ */ y(
                      bh,
                      {
                        props: { [f]: d },
                        propertySettings: null,
                        dynamicPropsInfo: null,
                        prefixValue: "",
                        useMentionTextInput: !1,
                        disabled: !1
                      }
                    ),
                    p && /* @__PURE__ */ y("p", { className: "text-xs text-destructive font-medium", children: (h = p.message) == null ? void 0 : h.toString() })
                  ]
                },
                f
              );
            }
          ) }) : /* @__PURE__ */ y("div", { className: "p-4 rounded-lg text-center", children: /* @__PURE__ */ y("p", { className: "text-sm text-muted-foreground", children: Z("No input fields defined in the schema") }) }) }) }),
          /* @__PURE__ */ V(kl, { children: [
            /* @__PURE__ */ y(
              Qe,
              {
                type: "button",
                variant: "outline",
                onClick: () => t(!1),
                disabled: l,
                children: Z("Cancel")
              }
            ),
            /* @__PURE__ */ y(Qe, { type: "submit", loading: l, children: Z("Save") })
          ] })
        ]
      }
    ) })
  ] }) });
}
const Kdn = ({
  isValid: e,
  testType: t,
  mockData: n,
  isSaving: r,
  isTesting: i,
  onSimulateTrigger: o,
  onPollTrigger: s,
  onMcpToolTesting: l,
  onSaveMockAsSampleData: c
}) => {
  const { isLoadingDynamicProperties: a } = kr(Fb);
  return t === "simulation" || t === "webhook" || t === "chat-trigger" ? /* @__PURE__ */ V("div", { className: "flex justify-center flex-col gap-2 items-center", children: [
    /* @__PURE__ */ y(bv, { invalid: !e, children: /* @__PURE__ */ V(
      Qe,
      {
        variant: "outline",
        size: "sm",
        onClick: o,
        keyboardShortcut: "G",
        onKeyboardShortcut: o,
        disabled: !e || a,
        loading: r,
        "data-testid": "test-trigger-button",
        children: [
          /* @__PURE__ */ y(GE, { animation: !0, variant: "primary" }),
          Z("Test Trigger")
        ]
      }
    ) }),
    !De(n) && JSON.stringify(n) !== "{}" && /* @__PURE__ */ V(pt, { children: [
      Z("Or"),
      /* @__PURE__ */ y(
        Qe,
        {
          variant: "outline",
          size: "sm",
          onClick: () => c(n),
          loading: r,
          children: Z("Use Mock Data")
        }
      )
    ] })
  ] }) : t === "mcp-tool" ? /* @__PURE__ */ y("div", { className: "flex justify-center", children: /* @__PURE__ */ y(bv, { invalid: !e, children: /* @__PURE__ */ V(
    Qe,
    {
      variant: "outline",
      size: "sm",
      onClick: l,
      keyboardShortcut: "G",
      onKeyboardShortcut: l,
      loading: i,
      disabled: !e || a,
      children: [
        /* @__PURE__ */ y(GE, { animation: !0, variant: "primary" }),
        Z("Test Tool")
      ]
    }
  ) }) }) : /* @__PURE__ */ y("div", { className: "flex justify-center", children: /* @__PURE__ */ y(bv, { invalid: !e, children: /* @__PURE__ */ V(
    Qe,
    {
      variant: "outline",
      size: "sm",
      onClick: s,
      keyboardShortcut: "G",
      onKeyboardShortcut: s,
      loading: i,
      disabled: !e || a,
      children: [
        /* @__PURE__ */ y(GE, { animation: !0, variant: "primary" }),
        Z("Load Sample Data")
      ]
    }
  ) }) });
}, Gdn = ({
  isWebhookTestingDialogOpen: e,
  setIsWebhookTestingDialogOpen: t
}) => {
  const [n, r] = He(0), i = _r().getValues();
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "default",
        size: "sm",
        className: "flex items-center gap-2",
        onClick: () => {
          t(!0);
        },
        children: Z("Generate Sample Data")
      }
    ),
    /* @__PURE__ */ y(
      dee,
      {
        open: e,
        onOpenChange: (o) => {
          o || setTimeout(() => {
            r(n + 1);
          }, 200), t(o);
        },
        testingMode: "trigger",
        currentStep: i
      },
      `test-webhook-dialog-${n}`
    )
  ] });
}, Ydn = ({
  note: e,
  resetSimulation: t,
  abortControllerRef: n
}) => /* @__PURE__ */ V("div", { className: "flex flex-col gap-4 w-full", children: [
  /* @__PURE__ */ V("div", { className: "flex gap-2 items-center justify-center w-full", children: [
    /* @__PURE__ */ y(mu, { className: "size-4" }),
    /* @__PURE__ */ y("div", { children: Z("Testing Trigger") }),
    /* @__PURE__ */ y("div", { className: "grow" }),
    /* @__PURE__ */ y(
      Qe,
      {
        variant: "outline",
        size: "sm",
        onClick: () => {
          t(), n.current.abort(), n.current = new AbortController();
        },
        children: Z("Cancel")
      }
    )
  ] }),
  e && /* @__PURE__ */ V(h3, { children: [
    /* @__PURE__ */ y(Qh, { className: "h-4 w-4 text-warning" }),
    /* @__PURE__ */ V("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ V(Yje, { children: [
        Z("Action Required"),
        ":"
      ] }),
      /* @__PURE__ */ y(m3, { children: /* @__PURE__ */ y("div", { className: "break-wrods", children: e }) })
    ] })
  ] })
] }), xVe = ie.memo(
  ({ pollResults: e, sampleData: t }) => {
    const n = Jdn(t, (e == null ? void 0 : e.data) ?? []), i = _r().getValues(), { mutate: o } = Hc.useUpdateSampleData(
      i.name
    );
    return /* @__PURE__ */ V("div", { className: "mb-3", children: [
      /* @__PURE__ */ V(
        Cf,
        {
          value: n,
          onValueChange: (s) => {
            const l = e == null ? void 0 : e.data.find(
              (c) => c.id === s
            );
            l && o({
              response: {
                testType: "trigger",
                output: l.payload,
                success: !0
              }
            });
          },
          children: [
            /* @__PURE__ */ y(
              sd,
              {
                className: "w-full",
                disabled: e && e.data.length === 0,
                children: e && e.data.length > 0 ? /* @__PURE__ */ y(
                  Nf,
                  {
                    placeholder: Z("No sample data available")
                  }
                ) : Z("Old results were removed, retest for new sample data")
              }
            ),
            /* @__PURE__ */ y(ad, { children: e && e.data.map((s, l) => /* @__PURE__ */ y(Ti, { value: s.id, children: Z("Result #") + (l + 1) }, s.id)) })
          ]
        }
      ),
      /* @__PURE__ */ y("span", { className: "text-sm mt-2 text-muted-foreground", children: Z("The sample data can be used in the next steps.") })
    ] });
  }
);
xVe.displayName = "TriggerEventSelect";
function Jdn(e, t) {
  var n;
  if (e !== void 0)
    return (n = t.find((r) => qg(e, r.payload))) == null ? void 0 : n.id;
}
const efn = {
  getTestType: ({
    triggerName: e,
    pieceName: t,
    trigger: n
  }) => {
    if (xf.isMcpToolTrigger(t, e))
      return "mcp-tool";
    if (xf.isChatTrigger(t, e))
      return "chat-trigger";
    if (t === "@activepieces/piece-webhook" && e === "catch_webhook")
      return "webhook";
    if (n.type === hf.APP_WEBHOOK || n.type === hf.WEBHOOK)
      switch (n.testStrategy) {
        case $l.TEST_FUNCTION:
          return "polling";
        case $l.SIMULATION:
          return "simulation";
      }
    return "polling";
  }
}, SVe = ie.memo(
  ({ isSaving: e, flowVersionId: t, flowId: n }) => {
    var D, X, B, q, H;
    const r = _r(), i = r.getValues(), o = r.formState.isValid, s = Xe(new AbortController()), l = (D = i.settings.sampleData) == null ? void 0 : D.lastTestDate, [c, a] = He(!1), { pieceModel: u, isLoading: f } = nd.usePiece({
      name: i.settings.pieceName,
      version: i.settings.pieceVersion
    });
    console.log("pieceModel", u);
    const d = (X = u == null ? void 0 : u.triggers) == null ? void 0 : X[i.settings.triggerName];
    console.log("trigger", d);
    const p = (q = (B = u == null ? void 0 : u.triggers) == null ? void 0 : B[i.settings.triggerName]) == null ? void 0 : q.sampleData, [h, m] = He(
      void 0
    );
    console.log("formValues", i);
    const { sampleData: v, sampleDataInput: b, setChatDrawerOpenSource: A } = tn((Y) => (console.log("BUILDER STATE CONTEXT", Y), {
      sampleData: i.name && Y.outputSampleData ? Y.outputSampleData[i.name] : {},
      sampleDataInput: i.name && Y.inputSampleData ? Y.inputSampleData[i.name] : {},
      setChatDrawerOpenSource: Y.setChatDrawerOpenSource
    })), w = async () => {
      r.setValue("settings.sampleData.lastTestDate", Gd().toISOString()), await F();
    }, { mutate: O, isPending: x } = Hc.useSaveMockData({
      onSuccess: w
    }), {
      mutate: S,
      isPending: E,
      reset: k
    } = Hc.useSimulateTrigger({
      setErrorMessage: m,
      onSuccess: async () => {
        await w(), a(!1);
      }
    }), { mutate: T, isPending: R } = Hc.usePollTrigger({
      setErrorMessage: m,
      onSuccess: w
    }), { pollResults: j, refetch: F } = Vun.usePollResults(
      t,
      n
    ), L = !De(l) || !De(h), U = !!De(
      (H = r.getValues().settings.sampleData) == null ? void 0 : H.lastTestDate
    ) && !E;
    if (f || De(d))
      return null;
    const z = efn.getTestType({
      triggerName: i.settings.triggerName,
      pieceName: i.settings.pieceName,
      trigger: d
    }), C = L && !E && !x, I = () => {
      switch (z) {
        case "chat-trigger":
          A(Jd.TEST_STEP), S(s.current.signal);
          break;
        case "simulation":
        case "webhook":
          S(s.current.signal);
          break;
        case "polling":
          T();
          break;
        case "mcp-tool":
          a(!0);
          break;
      }
    }, M = () => {
      switch (z) {
        case "simulation":
          return Z("testPieceWebhookTriggerNote", {
            pieceName: u == null ? void 0 : u.displayName,
            triggerName: u == null ? void 0 : u.triggers[i.settings.triggerName].displayName
          });
        case "webhook":
          return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ y("p", { children: Z(
              "Send Data to the webhook URL to generate sample data to use in the next steps"
            ) }),
            /* @__PURE__ */ y(
              Gdn,
              {
                isWebhookTestingDialogOpen: c,
                setIsWebhookTestingDialogOpen: (Y) => {
                  a(Y), Y || (s.current.abort(), s.current = new AbortController());
                }
              }
            )
          ] });
        default:
          return null;
      }
    };
    return /* @__PURE__ */ V("div", { children: [
      U && !h && /* @__PURE__ */ y(
        Kdn,
        {
          isValid: o,
          testType: z,
          isTesting: R || E || c,
          mockData: p,
          isSaving: e || x,
          onSimulateTrigger: () => {
            z === "chat-trigger" && A(Jd.TEST_STEP), S(s.current.signal);
          },
          onPollTrigger: T,
          onMcpToolTesting: () => a(!0),
          onSaveMockAsSampleData: O
        }
      ),
      (!U || h) && /* @__PURE__ */ V(pt, { children: [
        C && /* @__PURE__ */ y(
          fee,
          {
            onRetest: I,
            isValid: o,
            isTesting: R,
            sampleData: v ?? {},
            sampleDataInput: b ?? {},
            errorMessage: h,
            lastTestDate: l,
            isSaving: e,
            children: (j == null ? void 0 : j.data) && !h && /* @__PURE__ */ y(
              xVe,
              {
                pollResults: j,
                sampleData: v
              }
            )
          }
        ),
        E && /* @__PURE__ */ y(
          Ydn,
          {
            note: M(),
            resetSimulation: k,
            abortControllerRef: s
          }
        )
      ] }),
      z === "mcp-tool" && /* @__PURE__ */ y(
        $dn,
        {
          open: c,
          onOpenChange: a,
          onTestingSuccess: w
        }
      )
    ] });
  }
);
SVe.displayName = "TestTriggerSection";
const EVe = ie.memo(
  ({
    flowVersionId: e,
    isSaving: t,
    type: n,
    flowId: r,
    projectId: i
  }) => /* @__PURE__ */ V("div", { className: "flex flex-col gap-4 p-4 pb-10", children: [
    /* @__PURE__ */ y("div", { className: "text-md font-semibold ", children: Z("Generate Sample Data") }),
    n === Bt.PIECE ? /* @__PURE__ */ y(
      SVe,
      {
        flowId: r,
        isSaving: t,
        flowVersionId: e,
        projectId: i
      }
    ) : /* @__PURE__ */ y(
      q4e,
      {
        flowVersionId: e,
        isSaving: t,
        projectId: i
      }
    )
  ] })
);
EVe.displayName = "TestStepContainer";
const TVe = ({ className: e }) => /* @__PURE__ */ V(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    className: Se("w-6 h-6 transition-all duration-150 ease-in-out", e),
    children: [
      /* @__PURE__ */ y(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "4.312",
          d: "M6.288 30.06 30.68 5.669a8.624 8.624 0 0 1 12.196 0v0a8.624 8.624 0 0 1 0 12.197l-18.42 18.421"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "4.312",
          d: "m24.71 36.032 18.166-18.167a8.624 8.624 0 0 1 12.197 0l.127.127a8.624 8.624 0 0 1 0 12.196l-22.061 22.06a2.874 2.874 0 0 0 0 4.066l4.53 4.53"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: "4.312",
          d: "m36.778 11.766-18.04 18.04a8.624 8.624 0 0 0 0 12.197v0a8.624 8.624 0 0 0 12.196 0l18.04-18.04"
        }
      )
    ]
  }
), tfn = {
  showAddFlowDialog: !1,
  searchQuery: ""
}, vee = $w((e) => ({
  ...tfn,
  setShowAddFlowDialog: (t) => e({ showAddFlowDialog: t }),
  setSearchQuery: (t) => e({ searchQuery: t }),
  resetDialogState: () => {
    e({
      searchQuery: ""
    });
  }
})), nfn = {
  showAddMcpDialog: !1,
  editingMcpTool: null
}, bee = $w((e, t) => ({
  ...nfn,
  setShowAddMcpDialog: (n, r) => e({ showAddMcpDialog: n, editingMcpTool: r }),
  resetDialogState: () => {
    e({
      editingMcpTool: null
    });
  },
  closeMcpDialog: () => {
    t().resetDialogState(), e({ showAddMcpDialog: !1 });
  }
}));
function Q3(e) {
  return e.replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 128);
}
const rfn = ({
  disabled: e,
  tools: t,
  removeTool: n
}) => {
  const { openAddPieceToolDialog: r } = ob(), { metadata: i } = vd.useAllStepsMetadata({
    searchQuery: "",
    type: "action"
  }), o = Kt(() => i == null ? void 0 : i.filter(
    (c) => "suggestedActions" in c && "suggestedTriggers" in c
  ), [i]), s = o == null ? void 0 : o.find(
    (c) => c.pieceName === t[0].pieceMetadata.pieceName
  );
  if (!s)
    return /* @__PURE__ */ V("div", { className: "flex  w-full items-center justify-between px-3 h-12  border-b last:border-0 py-2", children: [
      /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ y(Tr, { className: "h-6 w-6 rounded-md" }),
        /* @__PURE__ */ y(Tr, { className: "h-4 w-32" })
      ] }),
      /* @__PURE__ */ y(Tr, { className: "h-4 w-4 rounded-sm" })
    ] });
  const l = (c) => {
    r({ page: "action-inputs", tool: c });
  };
  return /* @__PURE__ */ V(
    KN,
    {
      value: s.pieceName,
      className: "border-b last:border-0",
      children: [
        /* @__PURE__ */ y(GN, { className: "px-4 py-3 hover:no-underline hover:bg-accent transition-all", children: /* @__PURE__ */ y("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ y("div", { className: "h-8 w-8 rounded-md bg-muted flex items-center justify-center", children: s.logoUrl ? /* @__PURE__ */ y(
            "img",
            {
              src: s.logoUrl,
              alt: s.displayName,
              className: "h-5 w-5 object-contain"
            }
          ) : /* @__PURE__ */ y(rxe, { className: "h-5 w-5 text-muted-foreground" }) }),
          /* @__PURE__ */ y("span", { className: "text-sm font-medium", children: s.displayName })
        ] }) }) }),
        /* @__PURE__ */ V(YN, { className: "px-4 py-2", children: [
          /* @__PURE__ */ y("div", { className: "flex flex-wrap gap-2", children: t.map((c) => {
            var u, f;
            const a = (f = (u = s.suggestedActions) == null ? void 0 : u.find(
              (d) => Q3(
                `${s.pieceName}-${d.name}`
              ) === c.toolName
            )) == null ? void 0 : f.displayName;
            return /* @__PURE__ */ V(
              "div",
              {
                onClick: () => l(c),
                className: `
                  group flex items-center gap-2 px-3 py-1 cursor-pointer
                  rounded-full border bg-muted/50
                  ${e ? "opacity-50 pointer-events-none" : ""}
                `,
                children: [
                  /* @__PURE__ */ y("span", { className: "text-xs font-medium", children: a || c.toolName }),
                  /* @__PURE__ */ y("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ V(wn, { children: [
                    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                      Qe,
                      {
                        disabled: e,
                        onClick: (d) => {
                          d.stopPropagation(), n(c.toolName);
                        },
                        variant: "ghost",
                        size: "icon",
                        className: `
                          size-5 p-0.5
                          text-muted-foreground
                          hover:text-destructive
                          hover:bg-destructive/10
                          transition
                        `,
                        children: /* @__PURE__ */ y(ks, { className: "h-3 w-3" })
                      }
                    ) }),
                    /* @__PURE__ */ y(An, { children: Z("Remove tool") })
                  ] }) })
                ]
              },
              c.toolName
            );
          }) }),
          /* @__PURE__ */ V(
            Qe,
            {
              variant: "link",
              className: "mt-4",
              size: "xs",
              onClick: () => r({
                page: "actions-list",
                piece: s
              }),
              children: [
                /* @__PURE__ */ y(Da, { className: "size-3 mr-1" }),
                Z("Add Action")
              ]
            }
          )
        ] })
      ]
    }
  );
}, ifn = {
  showAddPieceDialog: !1,
  selectedPage: "pieces-list",
  searchQuery: "",
  selectedPiece: void 0,
  selectedAction: void 0,
  predefinedInputs: void 0,
  editingPieceTool: void 0
}, ob = $w(
  (e, t) => ({
    ...ifn,
    setSelectedPage: (n) => e({ selectedPage: n }),
    setSearchQuery: (n) => e({ searchQuery: n }),
    setPredefinedInputs: (n) => e({ predefinedInputs: n }),
    openAddPieceToolDialog: ({ page: n = "pieces-list", tool: r, piece: i }) => {
      e({
        showAddPieceDialog: !0,
        selectedPage: n,
        editingPieceTool: r,
        predefinedInputs: r == null ? void 0 : r.pieceMetadata.predefinedInput,
        selectedPiece: i
      });
    },
    handlePieceSelect: (n) => {
      e({
        selectedPiece: n,
        selectedPage: "actions-list"
      });
    },
    handleActionSelect: (n) => {
      e({
        selectedAction: n,
        selectedPage: "action-inputs"
      });
    },
    goBackToPiecesList: () => {
      e({
        selectedPage: "pieces-list"
      }), t().resetDialogState();
    },
    goBackToActionsList: () => {
      e({
        selectedPage: "actions-list",
        selectedAction: void 0,
        predefinedInputs: void 0
      });
    },
    isPieceAuthSet: () => {
      const { selectedPiece: n, selectedAction: r, predefinedInputs: i } = t();
      return De(n) || De(r) ? !1 : !!(!r.requireAuth || De(n.auth) || !De(i == null ? void 0 : i.auth));
    },
    createNewPieceTool: () => {
      const {
        selectedAction: n,
        selectedPiece: r,
        predefinedInputs: i,
        isPieceAuthSet: o
      } = t();
      return !n || !r || !o() ? null : {
        type: Wu.PIECE,
        toolName: Q3(
          `${r.pieceName}-${n.name}`
        ),
        pieceMetadata: {
          pieceVersion: r.pieceVersion,
          pieceName: r.pieceName,
          actionName: n.name,
          predefinedInput: i || void 0
        }
      };
    },
    resetDialogState: () => {
      e({
        searchQuery: "",
        selectedPiece: void 0,
        selectedAction: void 0,
        predefinedInputs: void 0,
        editingPieceTool: void 0,
        selectedPage: "pieces-list"
      });
    },
    closePieceDialog: () => {
      e({ showAddPieceDialog: !1 }), t().resetDialogState();
    }
  })
), Lye = ({
  disabled: e,
  children: t,
  align: n
}) => {
  const [r, i] = He(!1), { setShowAddFlowDialog: o } = vee(), { openAddPieceToolDialog: s } = ob(), { setShowAddMcpDialog: l } = bee();
  return /* @__PURE__ */ V(
    mN,
    {
      modal: !1,
      open: r,
      onOpenChange: i,
      children: [
        /* @__PURE__ */ y(Aj, { disabled: e, asChild: !0, children: t }),
        /* @__PURE__ */ V(xx, { align: n, children: [
          /* @__PURE__ */ V(
            wa,
            {
              onSelect: () => s({ page: "pieces-list" }),
              children: [
                /* @__PURE__ */ y(Bit, { className: "size-3.5 me-2" }),
                /* @__PURE__ */ y("span", { children: Z("Piece tool") })
              ]
            }
          ),
          /* @__PURE__ */ V(wa, { onSelect: () => o(!0), children: [
            /* @__PURE__ */ y(JH, { className: "size-3.5 me-2" }),
            /* @__PURE__ */ y("span", { children: Z("Flow tool") })
          ] }),
          /* @__PURE__ */ V(wa, { onSelect: () => l(!0), children: [
            /* @__PURE__ */ y(TVe, { className: "size-3.5 me-2" }),
            /* @__PURE__ */ y("span", { children: Z("Mcp server") })
          ] })
        ] })
      ]
    }
  );
}, ofn = ({
  disabled: e,
  tools: t,
  removeTool: n
}) => {
  const { setShowAddFlowDialog: r } = vee();
  return /* @__PURE__ */ V(KN, { value: "flows", className: "border-b last:border-0", children: [
    /* @__PURE__ */ y(GN, { className: "px-4 py-3 hover:no-underline hover:bg-accent transition-all", children: /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ y("div", { className: "h-8 w-8 rounded-md bg-muted flex items-center justify-center", children: /* @__PURE__ */ y(JH, { className: "size-4 text-muted-foreground" }) }),
      /* @__PURE__ */ y("span", { className: "text-sm font-medium", children: Z("Flows") })
    ] }) }),
    /* @__PURE__ */ V(YN, { className: "px-4 py-2", children: [
      /* @__PURE__ */ y("div", { className: "flex flex-wrap gap-2", children: t.map((i) => /* @__PURE__ */ V(
        "div",
        {
          className: `
                group flex items-center gap-2 px-3 py-1
                rounded-full border bg-muted/50
                ${e ? "opacity-50 pointer-events-none" : ""}
              `,
          children: [
            /* @__PURE__ */ y("span", { className: "text-xs font-medium max-w-40 truncate", children: i.toolName.split("_")[0] || Z("Flow") }),
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  disabled: e,
                  onClick: () => n(i.toolName),
                  variant: "ghost",
                  size: "icon",
                  className: `
                      size-5 p-0.5
                      text-muted-foreground
                      hover:text-destructive
                      hover:bg-destructive/10
                      transition
                    `,
                  children: /* @__PURE__ */ y(ks, { className: "h-3 w-3" })
                }
              ) }),
              /* @__PURE__ */ y(An, { children: Z("Remove flow") })
            ] })
          ]
        },
        i.toolName
      )) }),
      /* @__PURE__ */ V(
        Qe,
        {
          variant: "link",
          className: "mt-4",
          size: "xs",
          onClick: () => r(!0),
          children: [
            /* @__PURE__ */ y(Da, { className: "size-3 mr-1" }),
            Z("Add Flow")
          ]
        }
      )
    ] })
  ] });
}, sfn = ({
  disabled: e,
  tools: t,
  removeTool: n
}) => {
  const { setShowAddMcpDialog: r } = bee();
  return /* @__PURE__ */ V(KN, { value: "mcp", className: "border-b last:border-0", children: [
    /* @__PURE__ */ y(GN, { className: "px-4 py-3 hover:no-underline hover:bg-accent transition-all", children: /* @__PURE__ */ V("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ y("div", { className: "h-8 w-8 rounded-md bg-muted flex items-center justify-center", children: /* @__PURE__ */ y(TVe, { className: "size-3.5" }) }),
      /* @__PURE__ */ y("span", { className: "text-sm font-medium", children: Z("MCP Servers") })
    ] }) }),
    /* @__PURE__ */ V(YN, { className: "px-4 py-2", children: [
      /* @__PURE__ */ y("div", { className: "flex flex-wrap gap-2", children: t.map((i) => /* @__PURE__ */ V(
        "div",
        {
          onClick: () => r(!0, i),
          className: `
                group flex items-center gap-2 px-3 py-1 cursor-pointer
                rounded-full border bg-muted/50
                ${e ? "opacity-50 pointer-events-none" : ""}
              `,
          children: [
            /* @__PURE__ */ y("span", { className: "text-xs font-medium max-w-40 truncate", children: i.toolName }),
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  disabled: e,
                  onClick: (o) => {
                    o.stopPropagation(), n(i.toolName);
                  },
                  variant: "ghost",
                  size: "icon",
                  className: `
                      size-5 p-0.5
                      text-muted-foreground
                      hover:text-destructive
                      hover:bg-destructive/10
                      transition
                    `,
                  children: /* @__PURE__ */ y(ks, { className: "h-3 w-3" })
                }
              ) }),
              /* @__PURE__ */ y(An, { children: Z("Remove MCP server") })
            ] })
          ]
        },
        i.toolName
      )) }),
      /* @__PURE__ */ V(
        Qe,
        {
          variant: "link",
          className: "mt-4",
          size: "xs",
          onClick: () => r(!0),
          children: [
            /* @__PURE__ */ y(Da, { className: "size-3 mr-1" }),
            Z("Add MCP Server")
          ]
        }
      )
    ] })
  ] });
}, kVe = () => {
  const { mutate: e, isPending: t } = xl.useCreateMcpFlow();
  return /* @__PURE__ */ y(
    Qe,
    {
      onClick: () => e(),
      variant: "outline",
      className: "mr-auto",
      children: Z(t ? "Creating..." : "New MCP Flow")
    }
  );
};
var Oee = "Checkbox", [afn, Lmn] = Ms(Oee), [lfn, cfn] = afn(Oee), CVe = N.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: s,
      disabled: l,
      value: c = "on",
      onCheckedChange: a,
      ...u
    } = e, [f, d] = N.useState(null), p = xn(t, (w) => d(w)), h = N.useRef(!1), m = f ? !!f.closest("form") : !0, [v = !1, b] = wl({
      prop: i,
      defaultProp: o,
      onChange: a
    }), A = N.useRef(v);
    return N.useEffect(() => {
      const w = f == null ? void 0 : f.form;
      if (w) {
        const O = () => b(A.current);
        return w.addEventListener("reset", O), () => w.removeEventListener("reset", O);
      }
    }, [f, b]), /* @__PURE__ */ V(lfn, { scope: n, state: v, disabled: l, children: [
      /* @__PURE__ */ y(
        Zt.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Ov(v) ? "mixed" : v,
          "aria-required": s,
          "data-state": IVe(v),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: c,
          ...u,
          ref: p,
          onKeyDown: ot(e.onKeyDown, (w) => {
            w.key === "Enter" && w.preventDefault();
          }),
          onClick: ot(e.onClick, (w) => {
            b((O) => Ov(O) ? !0 : !O), m && (h.current = w.isPropagationStopped(), h.current || w.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ y(
        ufn,
        {
          control: f,
          bubbles: !h.current,
          name: r,
          value: c,
          checked: v,
          required: s,
          disabled: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
CVe.displayName = Oee;
var NVe = "CheckboxIndicator", PVe = N.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = e, o = cfn(NVe, n);
    return /* @__PURE__ */ y(wo, { present: r || Ov(o.state) || o.state === !0, children: /* @__PURE__ */ y(
      Zt.span,
      {
        "data-state": IVe(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
PVe.displayName = NVe;
var ufn = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = N.useRef(null), s = vj(n), l = Az(t);
  return N.useEffect(() => {
    const c = o.current, a = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(a, "checked").set;
    if (s !== n && f) {
      const d = new Event("click", { bubbles: r });
      c.indeterminate = Ov(n), f.call(c, Ov(n) ? !1 : n), c.dispatchEvent(d);
    }
  }, [s, n, r]), /* @__PURE__ */ y(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: Ov(n) ? !1 : n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Ov(e) {
  return e === "indeterminate";
}
function IVe(e) {
  return Ov(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var dfn = CVe, ffn = PVe;
const pfn = as(
  "peer border-input dark:bg-input/30 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary",
        secondary: "data-[state=checked]:bg-secondary data-[state=checked]:text-secondary-foreground dark:data-[state=checked]:bg-secondary data-[state=checked]:border-secondary data-[state=indeterminate]:bg-secondary data-[state=indeterminate]:text-secondary-foreground data-[state=indeterminate]:border-secondary"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
);
function hfn({ className: e, variant: t, checked: n, ...r }) {
  return /* @__PURE__ */ y(
    dfn,
    {
      "data-slot": "checkbox",
      checked: n,
      className: Se(pfn({ variant: t }), e),
      ...r,
      children: /* @__PURE__ */ y(
        ffn,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none",
          children: n === "indeterminate" ? /* @__PURE__ */ y(GH, { className: "size-3.5" }) : /* @__PURE__ */ y(Af, { className: "size-3.5" })
        }
      )
    }
  );
}
const mfn = as(
  "flex items-center justify-center p-2 bg-background border border-solid text-xs select-none",
  {
    variants: {
      size: {
        xxl: "size-[64px]",
        xl: "size-[48px]",
        lg: "size-[40px]",
        md: "size-[36px]",
        sm: "size-[25px]"
      },
      circle: {
        true: "rounded-full",
        false: "rounded-md"
      }
    }
  }
);
function gfn({
  maxNumberOfIconsToShow: e,
  trigger: t,
  size: n,
  className: r,
  circle: i = !0,
  background: o,
  excludeCore: s = !1
}) {
  const l = At.getAllSteps(t), c = vd.useStepsMetadata(l).map((h) => h.data).filter((h) => !!h), u = (s ? c.filter((h) => {
    const m = h;
    return !m.categories || !m.categories.includes(Of.CORE);
  }) : c).filter(
    (h, m, v) => v.findIndex(
      (b) => h.displayName === b.displayName
    ) === m
  ), f = u.slice(0, e), d = u.length - f.length, p = u.slice(e);
  return /* @__PURE__ */ V("div", { className: r || "flex gap-0.5 ", children: [
    f.map((h) => /* @__PURE__ */ y(
      Ig,
      {
        logoUrl: h.logoUrl,
        showTooltip: !0,
        circle: i,
        size: n ?? "md",
        border: !0,
        displayName: h.displayName,
        background: o
      },
      h.logoUrl
    )),
    d > 0 && /* @__PURE__ */ V(wn, { children: [
      /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ V("div", { className: mfn({ size: n ?? "md", circle: i }), children: [
        "+",
        d
      ] }) }),
      /* @__PURE__ */ V(An, { side: "bottom", children: [
        p.length > 1 && p.map((h) => (h == null ? void 0 : h.displayName) || "").slice(0, -1).join(", ") + ` ${Z("and")} ${p[p.length - 1].displayName}`,
        p.length === 1 && p[0].displayName
      ] })
    ] })
  ] });
}
const yfn = (e) => e.version.state === Lo.LOCKED && e.status === "ENABLED", vfn = (e) => e.version.state !== Lo.LOCKED ? Z("Flow must be published to be selected") : e.status !== "ENABLED" ? Z("Flow must be enabled to be selected") : "", zye = {
  isFlowSelectable: yfn,
  getFlowTooltip: vfn
}, bfn = ({
  flows: e,
  selectedFlows: t,
  setSelectedFlows: n,
  searchQuery: r
}) => {
  const [i] = Gz(r, 300), o = Kt(() => {
    if (!i) return e;
    const c = i.toLowerCase();
    return e.filter(
      (a) => a.version.displayName.toLowerCase().includes(c)
    );
  }, [e, i]), s = (c) => t.some((a) => a.externalFlowId === c.externalId), l = (c) => {
    n((a) => a.some(
      (f) => f.externalFlowId === c.externalId
    ) ? a.filter((f) => f.externalFlowId !== c.externalId) : [
      ...a,
      {
        externalFlowId: c.externalId,
        toolName: `${c.version.displayName}_${c.id}`,
        type: Wu.FLOW
      }
    ]);
  };
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y("div", { className: "flex flex-col px-4 py-2", children: o.map((c, a) => {
      const u = zye.getFlowTooltip(c), f = zye.isFlowSelectable(c), d = s(c);
      return /* @__PURE__ */ V("div", { children: [
        /* @__PURE__ */ V(
          "div",
          {
            className: `
                  flex items-center gap-4 px-4 py-2 h-14 rounded-md cursor-pointer
                  hover:bg-accent hover:text-accent-foreground
                  ${d ? "bg-accent" : ""}
                  ${f ? "" : "opacity-50 cursor-not-allowed"}
                `,
            onClick: () => f && l(c),
            children: [
              /* @__PURE__ */ y(
                hfn,
                {
                  checked: d,
                  disabled: !f,
                  onCheckedChange: () => f && l(c),
                  onClick: (p) => p.stopPropagation()
                }
              ),
              /* @__PURE__ */ V("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ y("div", { className: "truncate text-sm font-medium", children: c.version.displayName }),
                u && /* @__PURE__ */ y("div", { className: "text-xs text-muted-foreground truncate", children: u })
              ] }),
              /* @__PURE__ */ y(
                gfn,
                {
                  trigger: c.version.trigger,
                  maxNumberOfIconsToShow: 3
                }
              )
            ]
          }
        ),
        a < o.length - 1 && /* @__PURE__ */ y("div", { className: "h-px bg-border my-1" })
      ] }, c.id);
    }) }),
    o.length === 0 && /* @__PURE__ */ V("div", { className: "flex flex-col items-center justify-center py-20 text-center", children: [
      /* @__PURE__ */ y("div", { className: "mb-5 flex size-14 items-center justify-center rounded-xl border bg-muted/40", children: /* @__PURE__ */ y(JH, { className: "size-7 text-muted-foreground" }) }),
      /* @__PURE__ */ y("div", { className: "text-base font-semibold text-foreground", children: Z("No flows found") }),
      /* @__PURE__ */ y("div", { className: "mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground", children: Z(r ? "Try adjusting your search or create a new flow." : "Create a flow to use it as a tool in your agent.") }),
      !r && /* @__PURE__ */ y("div", { className: "mt-6", children: /* @__PURE__ */ y(kVe, {}) })
    ] })
  ] });
};
function Ofn({
  onToolsUpdate: e,
  tools: t
}) {
  const [n, r] = He(
    t.filter((d) => d.type === Wu.FLOW)
  ), {
    showAddFlowDialog: i,
    setShowAddFlowDialog: o,
    searchQuery: s,
    setSearchQuery: l
  } = vee(), c = Rn.getProjectId(), { data: a } = pr({
    queryKey: ["flows", c],
    queryFn: async () => await yi.list({
      cursor: void 0,
      limit: 1e3,
      projectId: c
    })
  }), u = Kt(() => a == null ? void 0 : a.data.filter(
    (d) => d.version.trigger.type === Bt.PIECE && d.version.trigger.settings.pieceName === "@activepieces/piece-mcp"
  ), [a]), f = () => {
    const p = [...t.filter(
      (h) => h.type !== Wu.FLOW
    ), ...n];
    o(!1), e(p), vr("Changes to flow tools saved");
  };
  return /* @__PURE__ */ y(qa, { open: i, onOpenChange: o, children: /* @__PURE__ */ V(ia, { className: "w-[90vw] max-w-[750px] h-[80vh] max-h-[800px] flex flex-col overflow-hidden p-0", children: [
    /* @__PURE__ */ y(Ds, { className: "min-h-16 flex px-4 items-start justify-center mb-0 border-b", children: /* @__PURE__ */ y(_s, { children: Z("Add Flow Tools") }) }),
    /* @__PURE__ */ y("div", { className: "px-4 py-3 border-b", children: /* @__PURE__ */ V("div", { className: "relative border rounded-sm", children: [
      /* @__PURE__ */ y(QC, { className: "absolute left-2 top-2.5 size-4 text-muted-foreground" }),
      /* @__PURE__ */ y(
        fr,
        {
          placeholder: Z("Search"),
          value: s,
          onChange: (d) => l(d.target.value),
          className: "pl-9 shadow-none border-none"
        }
      )
    ] }) }),
    /* @__PURE__ */ y(Bi, { className: "grow overflow-y-auto", children: /* @__PURE__ */ y(
      bfn,
      {
        flows: u || [],
        searchQuery: s,
        selectedFlows: n,
        setSelectedFlows: r
      }
    ) }),
    /* @__PURE__ */ V(kl, { className: "border-t p-4 mt-auto", children: [
      /* @__PURE__ */ y(kVe, {}),
      /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { type: "button", variant: "ghost", children: Z("Close") }) }),
      /* @__PURE__ */ y(Qe, { type: "button", onClick: f, children: Z("Save") })
    ] })
  ] }) });
}
g.Object({
  toolName: g.String({ minLength: 1 }),
  serverUrl: g.String({ format: "uri" }),
  protocol: g.Enum(Pm),
  authType: g.Enum(xi),
  accessToken: g.Optional(g.String()),
  apiKeyHeader: g.Optional(g.String()),
  apiKey: g.Optional(g.String()),
  headers: g.Optional(
    g.Array(
      g.Object({
        key: g.String(),
        value: g.String()
      })
    )
  )
});
function Afn({
  tools: e,
  onToolsUpdate: t
}) {
  const { showAddMcpDialog: n, editingMcpTool: r, closeMcpDialog: i } = bee(), o = (p) => !e.some(
    (h) => h.toolName === p && h.toolName !== (r == null ? void 0 : r.toolName)
  ), s = Fg({
    defaultValues: {
      toolName: "",
      serverUrl: "",
      protocol: Pm.STREAMABLE_HTTP,
      authType: xi.NONE,
      accessToken: "",
      apiKey: "",
      apiKeyHeader: "X-API-Key",
      headers: [{ key: "", value: "" }]
    },
    mode: "onChange"
  }), l = s.watch("authType"), c = s.watch("headers");
  nt(() => {
    r && s.reset({
      toolName: r.toolName,
      serverUrl: r.serverUrl,
      protocol: r.protocol,
      authType: r.auth.type,
      ...r.auth.type === xi.ACCESS_TOKEN && {
        accessToken: r.auth.accessToken
      },
      ...r.auth.type === xi.API_KEY && {
        apiKey: r.auth.apiKey,
        apiKeyHeader: r.auth.apiKeyHeader
      },
      ...r.auth.type === xi.HEADERS && {
        headers: Object.entries(r.auth.headers).map(
          ([p, h]) => ({
            key: p,
            value: h
          })
        )
      }
    });
  }, [r, s]);
  const a = (p) => {
    var v;
    let h;
    switch (p.authType) {
      case xi.NONE: {
        h = { type: xi.NONE };
        break;
      }
      case xi.ACCESS_TOKEN: {
        h = {
          type: xi.ACCESS_TOKEN,
          accessToken: p.accessToken
        };
        break;
      }
      case xi.API_KEY: {
        h = {
          type: xi.API_KEY,
          apiKey: p.apiKey,
          apiKeyHeader: p.apiKeyHeader
        };
        break;
      }
      case xi.HEADERS: {
        const b = {};
        (v = p.headers) == null || v.forEach(({ key: A, value: w }) => {
          A && w && (b[A] = w);
        }), h = {
          type: xi.HEADERS,
          headers: b
        };
        break;
      }
      default:
        h = { type: xi.NONE };
    }
    const m = {
      type: Wu.MCP,
      toolName: `${p.toolName}`,
      serverUrl: p.serverUrl,
      protocol: p.protocol,
      auth: h
    };
    if (r) {
      const b = e.map(
        (A) => A.type === Wu.MCP && A.toolName === r.toolName ? m : A
      );
      t(b);
    } else
      t([...e, m]);
    s.reset(), i(), vr(Z("MCP server added successfully"));
  }, u = () => {
    s.setValue("headers", [...c || [], { key: "", value: "" }]);
  }, f = (p) => {
    const h = (c == null ? void 0 : c.filter((m, v) => v !== p)) || [];
    s.setValue(
      "headers",
      h.length > 0 ? h : [{ key: "", value: "" }]
    );
  }, d = () => {
    s.reset(), i();
  };
  return /* @__PURE__ */ y(qa, { open: n, onOpenChange: d, children: /* @__PURE__ */ V(ia, { className: "sm:max-w-2xl max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ y(Ds, { children: /* @__PURE__ */ y(_s, { children: Z(r ? "Edit MCP Server" : "Add MCP Server") }) }),
    /* @__PURE__ */ y(Ug, { ...s, children: /* @__PURE__ */ V("div", { className: "space-y-4", children: [
      /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "toolName",
          rules: {
            required: "Tool name is required",
            minLength: { value: 1, message: "Tool name is required" },
            validate: (p) => o(p) || Z("An MCP server with this name already exists")
          },
          render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("MCP Name"),
              " *"
            ] }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "e.g., my-mcp-server", ...p }) }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ),
      /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "serverUrl",
          rules: {
            required: "Server URL is required",
            pattern: {
              value: /^https?:\/\/.+/,
              message: "Must be a valid URL"
            }
          },
          render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("Server URL"),
              " *"
            ] }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "https://example.com/mcp", ...p }) }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ),
      /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "protocol",
          render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("Protocol"),
              " *"
            ] }),
            /* @__PURE__ */ V(Cf, { value: p.value, onValueChange: p.onChange, children: [
              /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(sd, { children: /* @__PURE__ */ y(Nf, {}) }) }),
              /* @__PURE__ */ V(ad, { children: [
                /* @__PURE__ */ y(Ti, { value: Pm.SSE, children: Z("SSE") }),
                /* @__PURE__ */ y(Ti, { value: Pm.SIMPLE_HTTP, children: Z("Simple HTTP") }),
                /* @__PURE__ */ y(Ti, { value: Pm.STREAMABLE_HTTP, children: Z("Streamable HTTP") })
              ] })
            ] }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ),
      /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "authType",
          render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("Authentication Type"),
              " *"
            ] }),
            /* @__PURE__ */ V(Cf, { value: p.value, onValueChange: p.onChange, children: [
              /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(sd, { children: /* @__PURE__ */ y(Nf, {}) }) }),
              /* @__PURE__ */ V(ad, { children: [
                /* @__PURE__ */ y(Ti, { value: xi.NONE, children: Z("None") }),
                /* @__PURE__ */ y(Ti, { value: xi.HEADERS, children: Z("Headers") }),
                /* @__PURE__ */ y(Ti, { value: xi.ACCESS_TOKEN, children: Z("Access Token") }),
                /* @__PURE__ */ y(Ti, { value: xi.API_KEY, children: Z("Api Key") })
              ] })
            ] }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ),
      l === xi.ACCESS_TOKEN && /* @__PURE__ */ y("div", { className: "space-y-4 p-4 border rounded-lg", children: /* @__PURE__ */ y(
        Zn,
        {
          control: s.control,
          name: "accessToken",
          render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("Access Token"),
              " *"
            ] }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "Enter access token", ...p }) }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ) }),
      l === xi.API_KEY && /* @__PURE__ */ V("div", { className: "space-y-4 p-4 border rounded-lg", children: [
        /* @__PURE__ */ y(
          Zn,
          {
            control: s.control,
            name: "apiKeyHeader",
            render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
              /* @__PURE__ */ V(ui, { children: [
                Z("API Key Header"),
                " *"
              ] }),
              /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "X-API-KEY", ...p }) }),
              /* @__PURE__ */ y(Ei, {})
            ] })
          }
        ),
        /* @__PURE__ */ y(
          Zn,
          {
            control: s.control,
            name: "apiKey",
            render: ({ field: p }) => /* @__PURE__ */ V(Jn, { children: [
              /* @__PURE__ */ V(ui, { children: [
                Z("Api Key"),
                " *"
              ] }),
              /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "Enter API Key", ...p }) }),
              /* @__PURE__ */ y(Ei, {})
            ] })
          }
        )
      ] }),
      l === xi.HEADERS && /* @__PURE__ */ V("div", { className: "space-y-4 p-4 border rounded-lg", children: [
        c == null ? void 0 : c.map((p, h) => /* @__PURE__ */ y("div", { className: "space-y-3", children: /* @__PURE__ */ V("div", { className: "flex gap-2 items-end", children: [
          /* @__PURE__ */ y(
            Zn,
            {
              control: s.control,
              name: `headers.${h}.key`,
              render: ({ field: m }) => /* @__PURE__ */ V(Jn, { className: "flex-1", children: [
                /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "Authorization", ...m }) }),
                /* @__PURE__ */ y(Ei, {})
              ] })
            }
          ),
          /* @__PURE__ */ y(
            Zn,
            {
              control: s.control,
              name: `headers.${h}.value`,
              render: ({ field: m }) => /* @__PURE__ */ V(Jn, { className: "flex-1", children: [
                /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { placeholder: "Bearer token...", ...m }) }),
                /* @__PURE__ */ y(Ei, {})
              ] })
            }
          ),
          c.length > 1 && /* @__PURE__ */ y(
            Qe,
            {
              type: "button",
              size: "icon",
              variant: "ghost",
              onClick: () => f(h),
              children: /* @__PURE__ */ y(ks, { className: "size-4" })
            }
          )
        ] }) }, h)),
        /* @__PURE__ */ y(
          Qe,
          {
            type: "button",
            size: "sm",
            variant: "outline",
            className: "w-full",
            onClick: u,
            children: Z("+ Add Header")
          }
        )
      ] }),
      /* @__PURE__ */ V(kl, { className: "mt-6", children: [
        /* @__PURE__ */ y(Qe, { type: "button", variant: "outline", onClick: d, children: Z("Cancel") }),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: s.handleSubmit(a),
            disabled: !s.formState.isValid,
            children: Z(r ? "Update Server" : "Add Server")
          }
        )
      ] })
    ] }) })
  ] }) });
}
function Oh(e) {
  return Array.isArray ? Array.isArray(e) : DVe(e) === "[object Array]";
}
function wfn(e) {
  if (typeof e == "string")
    return e;
  let t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function xfn(e) {
  return e == null ? "" : wfn(e);
}
function pf(e) {
  return typeof e == "string";
}
function RVe(e) {
  return typeof e == "number";
}
function Sfn(e) {
  return e === !0 || e === !1 || Efn(e) && DVe(e) == "[object Boolean]";
}
function MVe(e) {
  return typeof e == "object";
}
function Efn(e) {
  return MVe(e) && e !== null;
}
function Ql(e) {
  return e != null;
}
function bq(e) {
  return !e.trim().length;
}
function DVe(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
const Tfn = "Incorrect 'index' type", kfn = (e) => `Invalid value for key ${e}`, Cfn = (e) => `Pattern length exceeds max of ${e}.`, Nfn = (e) => `Missing ${e} property in key`, Pfn = (e) => `Property 'weight' in key '${e}' must be a positive integer`, jye = Object.prototype.hasOwnProperty;
class Ifn {
  constructor(t) {
    this._keys = [], this._keyMap = {};
    let n = 0;
    t.forEach((r) => {
      let i = _Ve(r);
      this._keys.push(i), this._keyMap[i.id] = i, n += i.weight;
    }), this._keys.forEach((r) => {
      r.weight /= n;
    });
  }
  get(t) {
    return this._keyMap[t];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function _Ve(e) {
  let t = null, n = null, r = null, i = 1, o = null;
  if (pf(e) || Oh(e))
    r = e, t = Fye(e), n = $7(e);
  else {
    if (!jye.call(e, "name"))
      throw new Error(Nfn("name"));
    const s = e.name;
    if (r = s, jye.call(e, "weight") && (i = e.weight, i <= 0))
      throw new Error(Pfn(s));
    t = Fye(s), n = $7(s), o = e.getFn;
  }
  return { path: t, id: n, weight: i, src: r, getFn: o };
}
function Fye(e) {
  return Oh(e) ? e : e.split(".");
}
function $7(e) {
  return Oh(e) ? e.join(".") : e;
}
function Rfn(e, t) {
  let n = [], r = !1;
  const i = (o, s, l) => {
    if (Ql(o))
      if (!s[l])
        n.push(o);
      else {
        let c = s[l];
        const a = o[c];
        if (!Ql(a))
          return;
        if (l === s.length - 1 && (pf(a) || RVe(a) || Sfn(a)))
          n.push(xfn(a));
        else if (Oh(a)) {
          r = !0;
          for (let u = 0, f = a.length; u < f; u += 1)
            i(a[u], s, l + 1);
        } else s.length && i(a, s, l + 1);
      }
  };
  return i(e, pf(t) ? t.split(".") : t, 0), r ? n : n[0];
}
const Mfn = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, Dfn = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (e, t) => e.score === t.score ? e.idx < t.idx ? -1 : 1 : e.score < t.score ? -1 : 1
}, _fn = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, Lfn = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: Rfn,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var Dn = {
  ...Dfn,
  ...Mfn,
  ..._fn,
  ...Lfn
};
const zfn = /[^ ]+/g;
function jfn(e = 1, t = 3) {
  const n = /* @__PURE__ */ new Map(), r = Math.pow(10, t);
  return {
    get(i) {
      const o = i.match(zfn).length;
      if (n.has(o))
        return n.get(o);
      const s = 1 / Math.pow(o, 0.5 * e), l = parseFloat(Math.round(s * r) / r);
      return n.set(o, l), l;
    },
    clear() {
      n.clear();
    }
  };
}
class Aee {
  constructor({
    getFn: t = Dn.getFn,
    fieldNormWeight: n = Dn.fieldNormWeight
  } = {}) {
    this.norm = jfn(n, 3), this.getFn = t, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(t = []) {
    this.docs = t;
  }
  setIndexRecords(t = []) {
    this.records = t;
  }
  setKeys(t = []) {
    this.keys = t, this._keysMap = {}, t.forEach((n, r) => {
      this._keysMap[n.id] = r;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, pf(this.docs[0]) ? this.docs.forEach((t, n) => {
      this._addString(t, n);
    }) : this.docs.forEach((t, n) => {
      this._addObject(t, n);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(t) {
    const n = this.size();
    pf(t) ? this._addString(t, n) : this._addObject(t, n);
  }
  // Removes the doc at the specified index of the index
  removeAt(t) {
    this.records.splice(t, 1);
    for (let n = t, r = this.size(); n < r; n += 1)
      this.records[n].i -= 1;
  }
  getValueForItemAtKeyId(t, n) {
    return t[this._keysMap[n]];
  }
  size() {
    return this.records.length;
  }
  _addString(t, n) {
    if (!Ql(t) || bq(t))
      return;
    let r = {
      v: t,
      i: n,
      n: this.norm.get(t)
    };
    this.records.push(r);
  }
  _addObject(t, n) {
    let r = { i: n, $: {} };
    this.keys.forEach((i, o) => {
      let s = i.getFn ? i.getFn(t) : this.getFn(t, i.path);
      if (Ql(s)) {
        if (Oh(s)) {
          let l = [];
          const c = [{ nestedArrIndex: -1, value: s }];
          for (; c.length; ) {
            const { nestedArrIndex: a, value: u } = c.pop();
            if (Ql(u))
              if (pf(u) && !bq(u)) {
                let f = {
                  v: u,
                  i: a,
                  n: this.norm.get(u)
                };
                l.push(f);
              } else Oh(u) && u.forEach((f, d) => {
                c.push({
                  nestedArrIndex: d,
                  value: f
                });
              });
          }
          r.$[o] = l;
        } else if (pf(s) && !bq(s)) {
          let l = {
            v: s,
            n: this.norm.get(s)
          };
          r.$[o] = l;
        }
      }
    }), this.records.push(r);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function LVe(e, t, { getFn: n = Dn.getFn, fieldNormWeight: r = Dn.fieldNormWeight } = {}) {
  const i = new Aee({ getFn: n, fieldNormWeight: r });
  return i.setKeys(e.map(_Ve)), i.setSources(t), i.create(), i;
}
function Ffn(e, { getFn: t = Dn.getFn, fieldNormWeight: n = Dn.fieldNormWeight } = {}) {
  const { keys: r, records: i } = e, o = new Aee({ getFn: t, fieldNormWeight: n });
  return o.setKeys(r), o.setIndexRecords(i), o;
}
function CR(e, {
  errors: t = 0,
  currentLocation: n = 0,
  expectedLocation: r = 0,
  distance: i = Dn.distance,
  ignoreLocation: o = Dn.ignoreLocation
} = {}) {
  const s = t / e.length;
  if (o)
    return s;
  const l = Math.abs(r - n);
  return i ? s + l / i : l ? 1 : s;
}
function Ufn(e = [], t = Dn.minMatchCharLength) {
  let n = [], r = -1, i = -1, o = 0;
  for (let s = e.length; o < s; o += 1) {
    let l = e[o];
    l && r === -1 ? r = o : !l && r !== -1 && (i = o - 1, i - r + 1 >= t && n.push([r, i]), r = -1);
  }
  return e[o - 1] && o - r >= t && n.push([r, o - 1]), n;
}
const Ay = 32;
function Vfn(e, t, n, {
  location: r = Dn.location,
  distance: i = Dn.distance,
  threshold: o = Dn.threshold,
  findAllMatches: s = Dn.findAllMatches,
  minMatchCharLength: l = Dn.minMatchCharLength,
  includeMatches: c = Dn.includeMatches,
  ignoreLocation: a = Dn.ignoreLocation
} = {}) {
  if (t.length > Ay)
    throw new Error(Cfn(Ay));
  const u = t.length, f = e.length, d = Math.max(0, Math.min(r, f));
  let p = o, h = d;
  const m = l > 1 || c, v = m ? Array(f) : [];
  let b;
  for (; (b = e.indexOf(t, h)) > -1; ) {
    let E = CR(t, {
      currentLocation: b,
      expectedLocation: d,
      distance: i,
      ignoreLocation: a
    });
    if (p = Math.min(E, p), h = b + u, m) {
      let k = 0;
      for (; k < u; )
        v[b + k] = 1, k += 1;
    }
  }
  h = -1;
  let A = [], w = 1, O = u + f;
  const x = 1 << u - 1;
  for (let E = 0; E < u; E += 1) {
    let k = 0, T = O;
    for (; k < T; )
      CR(t, {
        errors: E,
        currentLocation: d + T,
        expectedLocation: d,
        distance: i,
        ignoreLocation: a
      }) <= p ? k = T : O = T, T = Math.floor((O - k) / 2 + k);
    O = T;
    let R = Math.max(1, d - T + 1), j = s ? f : Math.min(d + T, f) + u, F = Array(j + 2);
    F[j + 1] = (1 << E) - 1;
    for (let _ = j; _ >= R; _ -= 1) {
      let U = _ - 1, z = n[e.charAt(U)];
      if (m && (v[U] = +!!z), F[_] = (F[_ + 1] << 1 | 1) & z, E && (F[_] |= (A[_ + 1] | A[_]) << 1 | 1 | A[_ + 1]), F[_] & x && (w = CR(t, {
        errors: E,
        currentLocation: U,
        expectedLocation: d,
        distance: i,
        ignoreLocation: a
      }), w <= p)) {
        if (p = w, h = U, h <= d)
          break;
        R = Math.max(1, 2 * d - h);
      }
    }
    if (CR(t, {
      errors: E + 1,
      currentLocation: d,
      expectedLocation: d,
      distance: i,
      ignoreLocation: a
    }) > p)
      break;
    A = F;
  }
  const S = {
    isMatch: h >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, w)
  };
  if (m) {
    const E = Ufn(v, l);
    E.length ? c && (S.indices = E) : S.isMatch = !1;
  }
  return S;
}
function qfn(e) {
  let t = {};
  for (let n = 0, r = e.length; n < r; n += 1) {
    const i = e.charAt(n);
    t[i] = (t[i] || 0) | 1 << r - n - 1;
  }
  return t;
}
class zVe {
  constructor(t, {
    location: n = Dn.location,
    threshold: r = Dn.threshold,
    distance: i = Dn.distance,
    includeMatches: o = Dn.includeMatches,
    findAllMatches: s = Dn.findAllMatches,
    minMatchCharLength: l = Dn.minMatchCharLength,
    isCaseSensitive: c = Dn.isCaseSensitive,
    ignoreLocation: a = Dn.ignoreLocation
  } = {}) {
    if (this.options = {
      location: n,
      threshold: r,
      distance: i,
      includeMatches: o,
      findAllMatches: s,
      minMatchCharLength: l,
      isCaseSensitive: c,
      ignoreLocation: a
    }, this.pattern = c ? t : t.toLowerCase(), this.chunks = [], !this.pattern.length)
      return;
    const u = (d, p) => {
      this.chunks.push({
        pattern: d,
        alphabet: qfn(d),
        startIndex: p
      });
    }, f = this.pattern.length;
    if (f > Ay) {
      let d = 0;
      const p = f % Ay, h = f - p;
      for (; d < h; )
        u(this.pattern.substr(d, Ay), d), d += Ay;
      if (p) {
        const m = f - Ay;
        u(this.pattern.substr(m), m);
      }
    } else
      u(this.pattern, 0);
  }
  searchIn(t) {
    const { isCaseSensitive: n, includeMatches: r } = this.options;
    if (n || (t = t.toLowerCase()), this.pattern === t) {
      let h = {
        isMatch: !0,
        score: 0
      };
      return r && (h.indices = [[0, t.length - 1]]), h;
    }
    const {
      location: i,
      distance: o,
      threshold: s,
      findAllMatches: l,
      minMatchCharLength: c,
      ignoreLocation: a
    } = this.options;
    let u = [], f = 0, d = !1;
    this.chunks.forEach(({ pattern: h, alphabet: m, startIndex: v }) => {
      const { isMatch: b, score: A, indices: w } = Vfn(t, h, m, {
        location: i + v,
        distance: o,
        threshold: s,
        findAllMatches: l,
        minMatchCharLength: c,
        includeMatches: r,
        ignoreLocation: a
      });
      b && (d = !0), f += A, b && w && (u = [...u, ...w]);
    });
    let p = {
      isMatch: d,
      score: d ? f / this.chunks.length : 1
    };
    return d && r && (p.indices = u), p;
  }
}
class Zg {
  constructor(t) {
    this.pattern = t;
  }
  static isMultiMatch(t) {
    return Uye(t, this.multiRegex);
  }
  static isSingleMatch(t) {
    return Uye(t, this.singleRegex);
  }
  search() {
  }
}
function Uye(e, t) {
  const n = e.match(t);
  return n ? n[1] : null;
}
class Bfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(t) {
    const n = t === this.pattern;
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class Xfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(t) {
    const r = t.indexOf(this.pattern) === -1;
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class Wfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(t) {
    const n = t.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class Zfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(t) {
    const n = !t.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class Hfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(t) {
    const n = t.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [t.length - this.pattern.length, t.length - 1]
    };
  }
}
class Qfn extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(t) {
    const n = !t.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, t.length - 1]
    };
  }
}
class jVe extends Zg {
  constructor(t, {
    location: n = Dn.location,
    threshold: r = Dn.threshold,
    distance: i = Dn.distance,
    includeMatches: o = Dn.includeMatches,
    findAllMatches: s = Dn.findAllMatches,
    minMatchCharLength: l = Dn.minMatchCharLength,
    isCaseSensitive: c = Dn.isCaseSensitive,
    ignoreLocation: a = Dn.ignoreLocation
  } = {}) {
    super(t), this._bitapSearch = new zVe(t, {
      location: n,
      threshold: r,
      distance: i,
      includeMatches: o,
      findAllMatches: s,
      minMatchCharLength: l,
      isCaseSensitive: c,
      ignoreLocation: a
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(t) {
    return this._bitapSearch.searchIn(t);
  }
}
class FVe extends Zg {
  constructor(t) {
    super(t);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(t) {
    let n = 0, r;
    const i = [], o = this.pattern.length;
    for (; (r = t.indexOf(this.pattern, n)) > -1; )
      n = r + o, i.push([r, n - 1]);
    const s = !!i.length;
    return {
      isMatch: s,
      score: s ? 0 : 1,
      indices: i
    };
  }
}
const K7 = [
  Bfn,
  FVe,
  Wfn,
  Zfn,
  Qfn,
  Hfn,
  Xfn,
  jVe
], Vye = K7.length, $fn = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, Kfn = "|";
function Gfn(e, t = {}) {
  return e.split(Kfn).map((n) => {
    let r = n.trim().split($fn).filter((o) => o && !!o.trim()), i = [];
    for (let o = 0, s = r.length; o < s; o += 1) {
      const l = r[o];
      let c = !1, a = -1;
      for (; !c && ++a < Vye; ) {
        const u = K7[a];
        let f = u.isMultiMatch(l);
        f && (i.push(new u(f, t)), c = !0);
      }
      if (!c)
        for (a = -1; ++a < Vye; ) {
          const u = K7[a];
          let f = u.isSingleMatch(l);
          if (f) {
            i.push(new u(f, t));
            break;
          }
        }
    }
    return i;
  });
}
const Yfn = /* @__PURE__ */ new Set([jVe.type, FVe.type]);
class Jfn {
  constructor(t, {
    isCaseSensitive: n = Dn.isCaseSensitive,
    includeMatches: r = Dn.includeMatches,
    minMatchCharLength: i = Dn.minMatchCharLength,
    ignoreLocation: o = Dn.ignoreLocation,
    findAllMatches: s = Dn.findAllMatches,
    location: l = Dn.location,
    threshold: c = Dn.threshold,
    distance: a = Dn.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: n,
      includeMatches: r,
      minMatchCharLength: i,
      findAllMatches: s,
      ignoreLocation: o,
      location: l,
      threshold: c,
      distance: a
    }, this.pattern = n ? t : t.toLowerCase(), this.query = Gfn(this.pattern, this.options);
  }
  static condition(t, n) {
    return n.useExtendedSearch;
  }
  searchIn(t) {
    const n = this.query;
    if (!n)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: r, isCaseSensitive: i } = this.options;
    t = i ? t : t.toLowerCase();
    let o = 0, s = [], l = 0;
    for (let c = 0, a = n.length; c < a; c += 1) {
      const u = n[c];
      s.length = 0, o = 0;
      for (let f = 0, d = u.length; f < d; f += 1) {
        const p = u[f], { isMatch: h, indices: m, score: v } = p.search(t);
        if (h) {
          if (o += 1, l += v, r) {
            const b = p.constructor.type;
            Yfn.has(b) ? s = [...s, ...m] : s.push(m);
          }
        } else {
          l = 0, o = 0, s.length = 0;
          break;
        }
      }
      if (o) {
        let f = {
          isMatch: !0,
          score: l / o
        };
        return r && (f.indices = s), f;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const G7 = [];
function epn(...e) {
  G7.push(...e);
}
function Y7(e, t) {
  for (let n = 0, r = G7.length; n < r; n += 1) {
    let i = G7[n];
    if (i.condition(e, t))
      return new i(e, t);
  }
  return new zVe(e, t);
}
const r2 = {
  AND: "$and",
  OR: "$or"
}, J7 = {
  PATH: "$path",
  PATTERN: "$val"
}, eW = (e) => !!(e[r2.AND] || e[r2.OR]), tpn = (e) => !!e[J7.PATH], npn = (e) => !Oh(e) && MVe(e) && !eW(e), qye = (e) => ({
  [r2.AND]: Object.keys(e).map((t) => ({
    [t]: e[t]
  }))
});
function UVe(e, t, { auto: n = !0 } = {}) {
  const r = (i) => {
    let o = Object.keys(i);
    const s = tpn(i);
    if (!s && o.length > 1 && !eW(i))
      return r(qye(i));
    if (npn(i)) {
      const c = s ? i[J7.PATH] : o[0], a = s ? i[J7.PATTERN] : i[c];
      if (!pf(a))
        throw new Error(kfn(c));
      const u = {
        keyId: $7(c),
        pattern: a
      };
      return n && (u.searcher = Y7(a, t)), u;
    }
    let l = {
      children: [],
      operator: o[0]
    };
    return o.forEach((c) => {
      const a = i[c];
      Oh(a) && a.forEach((u) => {
        l.children.push(r(u));
      });
    }), l;
  };
  return eW(e) || (e = qye(e)), r(e);
}
function rpn(e, { ignoreFieldNorm: t = Dn.ignoreFieldNorm }) {
  e.forEach((n) => {
    let r = 1;
    n.matches.forEach(({ key: i, norm: o, score: s }) => {
      const l = i ? i.weight : null;
      r *= Math.pow(
        s === 0 && l ? Number.EPSILON : s,
        (l || 1) * (t ? 1 : o)
      );
    }), n.score = r;
  });
}
function ipn(e, t) {
  const n = e.matches;
  t.matches = [], Ql(n) && n.forEach((r) => {
    if (!Ql(r.indices) || !r.indices.length)
      return;
    const { indices: i, value: o } = r;
    let s = {
      indices: i,
      value: o
    };
    r.key && (s.key = r.key.src), r.idx > -1 && (s.refIndex = r.idx), t.matches.push(s);
  });
}
function opn(e, t) {
  t.score = e.score;
}
function spn(e, t, {
  includeMatches: n = Dn.includeMatches,
  includeScore: r = Dn.includeScore
} = {}) {
  const i = [];
  return n && i.push(ipn), r && i.push(opn), e.map((o) => {
    const { idx: s } = o, l = {
      item: t[s],
      refIndex: s
    };
    return i.length && i.forEach((c) => {
      c(o, l);
    }), l;
  });
}
class Bx {
  constructor(t, n = {}, r) {
    this.options = { ...Dn, ...n }, this.options.useExtendedSearch, this._keyStore = new Ifn(this.options.keys), this.setCollection(t, r);
  }
  setCollection(t, n) {
    if (this._docs = t, n && !(n instanceof Aee))
      throw new Error(Tfn);
    this._myIndex = n || LVe(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(t) {
    Ql(t) && (this._docs.push(t), this._myIndex.add(t));
  }
  remove(t = () => !1) {
    const n = [];
    for (let r = 0, i = this._docs.length; r < i; r += 1) {
      const o = this._docs[r];
      t(o, r) && (this.removeAt(r), r -= 1, i -= 1, n.push(o));
    }
    return n;
  }
  removeAt(t) {
    this._docs.splice(t, 1), this._myIndex.removeAt(t);
  }
  getIndex() {
    return this._myIndex;
  }
  search(t, { limit: n = -1 } = {}) {
    const {
      includeMatches: r,
      includeScore: i,
      shouldSort: o,
      sortFn: s,
      ignoreFieldNorm: l
    } = this.options;
    let c = pf(t) ? pf(this._docs[0]) ? this._searchStringList(t) : this._searchObjectList(t) : this._searchLogical(t);
    return rpn(c, { ignoreFieldNorm: l }), o && c.sort(s), RVe(n) && n > -1 && (c = c.slice(0, n)), spn(c, this._docs, {
      includeMatches: r,
      includeScore: i
    });
  }
  _searchStringList(t) {
    const n = Y7(t, this.options), { records: r } = this._myIndex, i = [];
    return r.forEach(({ v: o, i: s, n: l }) => {
      if (!Ql(o))
        return;
      const { isMatch: c, score: a, indices: u } = n.searchIn(o);
      c && i.push({
        item: o,
        idx: s,
        matches: [{ score: a, value: o, norm: l, indices: u }]
      });
    }), i;
  }
  _searchLogical(t) {
    const n = UVe(t, this.options), r = (l, c, a) => {
      if (!l.children) {
        const { keyId: f, searcher: d } = l, p = this._findMatches({
          key: this._keyStore.get(f),
          value: this._myIndex.getValueForItemAtKeyId(c, f),
          searcher: d
        });
        return p && p.length ? [
          {
            idx: a,
            item: c,
            matches: p
          }
        ] : [];
      }
      const u = [];
      for (let f = 0, d = l.children.length; f < d; f += 1) {
        const p = l.children[f], h = r(p, c, a);
        if (h.length)
          u.push(...h);
        else if (l.operator === r2.AND)
          return [];
      }
      return u;
    }, i = this._myIndex.records, o = {}, s = [];
    return i.forEach(({ $: l, i: c }) => {
      if (Ql(l)) {
        let a = r(n, l, c);
        a.length && (o[c] || (o[c] = { idx: c, item: l, matches: [] }, s.push(o[c])), a.forEach(({ matches: u }) => {
          o[c].matches.push(...u);
        }));
      }
    }), s;
  }
  _searchObjectList(t) {
    const n = Y7(t, this.options), { keys: r, records: i } = this._myIndex, o = [];
    return i.forEach(({ $: s, i: l }) => {
      if (!Ql(s))
        return;
      let c = [];
      r.forEach((a, u) => {
        c.push(
          ...this._findMatches({
            key: a,
            value: s[u],
            searcher: n
          })
        );
      }), c.length && o.push({
        idx: l,
        item: s,
        matches: c
      });
    }), o;
  }
  _findMatches({ key: t, value: n, searcher: r }) {
    if (!Ql(n))
      return [];
    let i = [];
    if (Oh(n))
      n.forEach(({ v: o, i: s, n: l }) => {
        if (!Ql(o))
          return;
        const { isMatch: c, score: a, indices: u } = r.searchIn(o);
        c && i.push({
          score: a,
          key: t,
          value: o,
          idx: s,
          norm: l,
          indices: u
        });
      });
    else {
      const { v: o, n: s } = n, { isMatch: l, score: c, indices: a } = r.searchIn(o);
      l && i.push({ score: c, key: t, value: o, norm: s, indices: a });
    }
    return i;
  }
}
Bx.version = "7.0.0";
Bx.createIndex = LVe;
Bx.parseIndex = Ffn;
Bx.config = Dn;
Bx.parseQuery = UVe;
epn(Jfn);
const apn = ({
  tools: e
}) => {
  const [t, n] = He(""), [r] = Gz(t, 200), { handleActionSelect: i, selectedPiece: o } = ob(), s = Kt(
    () => new Set(e.map((a) => a.toolName)),
    [e]
  ), l = Kt(() => De(o) || De(o.suggestedActions) ? null : new Bx(o.suggestedActions, {
    keys: [
      { name: "displayName", weight: 0.8 },
      { name: "description", weight: 0.2 }
    ],
    threshold: 0.35,
    ignoreLocation: !0
  }), [o == null ? void 0 : o.suggestedActions]), c = Kt(() => !r.trim() || De(l) ? (o == null ? void 0 : o.suggestedActions) || [] : l.search(r).map((a) => a.item), [r, l, o == null ? void 0 : o.suggestedActions]);
  return De(o) ? /* @__PURE__ */ y("p", { children: Z("No app is selected") }) : /* @__PURE__ */ V(Bi, { className: "overflow-y-auto", children: [
    /* @__PURE__ */ y("div", { className: "px-4 py-3 border-b", children: /* @__PURE__ */ V("div", { className: "relative border rounded-sm", children: [
      /* @__PURE__ */ y(QC, { className: "absolute left-2 top-2.5 size-4 text-muted-foreground" }),
      /* @__PURE__ */ y(
        fr,
        {
          placeholder: Z("Search"),
          value: t,
          onChange: (a) => n(a.target.value),
          className: "pl-9 shadow-none border-none"
        }
      )
    ] }) }),
    /* @__PURE__ */ V("div", { className: "flex p-4 flex-col gap-2", children: [
      c.map((a) => {
        const u = s.has(
          Q3(`${o.pieceName}-${a.name}`)
        );
        return /* @__PURE__ */ y(
          "div",
          {
            className: `
                p-2 flex items-center gap-x-2 rounded-lg transition
                ${u ? "opacity-50 cursor-not-allowed" : "hover:bg-accent cursor-pointer"}
              `,
            onClick: () => {
              u || i(a);
            },
            children: /* @__PURE__ */ V("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ y("div", { className: "size-9 flex items-center justify-center rounded-sm border bg-background", children: /* @__PURE__ */ y(
                "img",
                {
                  className: "size-6 object-contain",
                  src: o.logoUrl,
                  alt: o.displayName
                }
              ) }),
              /* @__PURE__ */ V("div", { className: "flex-1", children: [
                /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ y("span", { className: "font-medium text-sm", children: a.displayName }),
                  u && /* @__PURE__ */ y("span", { className: "text-xs text-muted-foreground", children: Z("(Already added)") })
                ] }),
                a.description && /* @__PURE__ */ y("div", { className: "text-xs text-muted-foreground mt-0.5 line-clamp-2", children: a.description })
              ] })
            ] })
          },
          a.name
        );
      }),
      c.length === 0 && /* @__PURE__ */ y("div", { className: "text-center text-muted-foreground py-8", children: Z("No actions found") })
    ] })
  ] });
}, lpn = ({
  isPiecesLoading: e,
  pieceMetadata: t
}) => {
  const { searchQuery: n, setSearchQuery: r, handlePieceSelect: i } = ob(), o = !e && t.length === 0;
  return /* @__PURE__ */ V("div", { className: "flex flex-col h-full", children: [
    /* @__PURE__ */ y("div", { className: "px-4 py-3 border-b", children: /* @__PURE__ */ V("div", { className: "relative border rounded-sm", children: [
      /* @__PURE__ */ y(QC, { className: "absolute left-2 top-2.5 size-4 text-muted-foreground" }),
      /* @__PURE__ */ y(
        fr,
        {
          placeholder: Z("Search"),
          value: n,
          onChange: (s) => r(s.target.value),
          className: "pl-9 shadow-none border-none"
        }
      )
    ] }) }),
    /* @__PURE__ */ y(Bi, { className: "flex-1 min-h-0 px-4 py-2", children: e ? /* @__PURE__ */ y("div", { className: "grid grid-cols-3 gap-4", children: Array.from({ length: 22 }).map((s, l) => /* @__PURE__ */ y(Tr, { className: "h-12 w-full rounded-lg" }, l)) }) : o ? /* @__PURE__ */ y("div", { className: "h-full flex items-center py-2 justify-center text-muted-foreground", children: Z("No pieces found") }) : /* @__PURE__ */ y("div", { className: "grid grid-cols-3 gap-4", children: t.map((s, l) => /* @__PURE__ */ V(
      "div",
      {
        onClick: () => i(s),
        className: "p-2 flex items-center gap-x-2 hover:bg-accent cursor-pointer rounded-lg",
        children: [
          /* @__PURE__ */ y("div", { className: "size-9 flex items-center justify-center rounded-sm aspect-square border bg-background", children: /* @__PURE__ */ y(
            "img",
            {
              className: "size-6 rounded object-contain",
              src: s.logoUrl,
              alt: s.displayName
            }
          ) }),
          /* @__PURE__ */ y("p", { className: "font-semibold text-sm", children: s.displayName })
        ]
      },
      l
    )) }) })
  ] });
}, cpn = ({
  control: e,
  name: t
}) => {
  const { data: n } = bJ.useAll();
  return /* @__PURE__ */ y(
    Zn,
    {
      control: e,
      name: t,
      render: ({ field: r }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ y(fg, { children: Z("Available for Projects") }),
        /* @__PURE__ */ y(
          W3,
          {
            placeholder: Z("Select projects"),
            options: (n == null ? void 0 : n.map((i) => ({
              value: i.id,
              label: i.displayName
            }))) ?? [],
            loading: !n,
            onChange: (i) => {
              r.onChange(De(i) ? [] : i);
            },
            initialValues: r.value,
            showDeselect: r.value.length > 0
          }
        ),
        /* @__PURE__ */ y(Ei, { className: "mt-4!" })
      ] })
    }
  );
}, VVe = {
  list(e) {
    return dt.get(
      "/v1/global-connections",
      e
    );
  },
  upsert(e) {
    return dt.post(
      "/v1/global-connections",
      e
    );
  },
  delete(e) {
    return dt.delete(`/v1/global-connections/${e}`);
  },
  update(e, t) {
    return dt.post(
      `/v1/global-connections/${e}`,
      t
    );
  }
};
class NR extends Error {
  constructor() {
    super(Z("Connection name already used")), this.name = "ConnectionNameAlreadyExists";
  }
}
class Bye extends Error {
  constructor() {
    super(Z("Please select at least one project")), this.name = "NoProjectSelected";
  }
}
const Xye = {
  getConnectionName(e, t, n) {
    return t ? {
      externalId: t.externalId,
      displayName: t.displayName
    } : n ? {
      externalId: n,
      displayName: n
    } : {
      externalId: IC(),
      displayName: e.displayName
    };
  },
  createDefaultValues({
    auth: e,
    suggestedExternalId: t,
    suggestedDisplayName: n,
    pieceName: r,
    grantType: i,
    oauth2App: o,
    redirectUrl: s,
    projectId: l
  }) {
    if (qm(l, "projectId"), !e)
      throw new Error(`Unsupported property type: ${e}`);
    const c = {
      externalId: t,
      displayName: n,
      pieceName: r,
      projectId: l
    };
    switch (e.type) {
      case Le.SECRET_TEXT:
        return {
          ...c,
          type: Mn.SECRET_TEXT,
          value: {
            type: Mn.SECRET_TEXT,
            secret_text: ""
          }
        };
      case Le.BASIC_AUTH:
        return {
          ...c,
          type: Mn.BASIC_AUTH,
          value: {
            type: Mn.BASIC_AUTH,
            username: "",
            password: ""
          }
        };
      case Le.CUSTOM_AUTH:
        return {
          ...c,
          type: Mn.CUSTOM_AUTH,
          value: {
            type: Mn.CUSTOM_AUTH,
            props: Bc.getDefaultValueForProperties({
              props: e.props ?? {},
              existingInput: {}
            })
          }
        };
      case Le.OAUTH2:
        switch (o == null ? void 0 : o.oauth2Type) {
          case Mn.CLOUD_OAUTH2:
            return {
              ...c,
              type: Mn.CLOUD_OAUTH2,
              value: {
                type: Mn.CLOUD_OAUTH2,
                client_id: o.clientId,
                code: "",
                scope: e.scope.join(" "),
                authorization_method: e.authorizationMethod,
                props: Bc.getDefaultValueForProperties({
                  props: e.props ?? {},
                  existingInput: {}
                })
              }
            };
          case Mn.PLATFORM_OAUTH2:
            return {
              ...c,
              type: Mn.PLATFORM_OAUTH2,
              value: {
                type: Mn.PLATFORM_OAUTH2,
                client_id: o.clientId,
                redirect_url: s,
                code: "",
                scope: e.scope.join(" "),
                authorization_method: e.authorizationMethod,
                props: Bc.getDefaultValueForProperties({
                  props: e.props ?? {},
                  existingInput: {}
                })
              }
            };
          default:
            return {
              ...c,
              type: Mn.OAUTH2,
              value: {
                type: Mn.OAUTH2,
                client_id: "",
                redirect_url: s,
                code: i === Xs.CLIENT_CREDENTIALS ? "FAKE_CODE" : "",
                scope: e.scope.join(" "),
                authorization_method: e.authorizationMethod,
                props: Bc.getDefaultValueForProperties({
                  props: e.props ?? {},
                  existingInput: {}
                }),
                client_secret: "",
                grant_type: i ?? Xs.AUTHORIZATION_CODE
              }
            };
        }
    }
  },
  extractDefaultPropsValues(e) {
    return e ? Object.entries(e).reduce((t, [n, r]) => r.defaultValue ? {
      ...t,
      [n]: r.defaultValue
    } : r.type === Le.CHECKBOX ? {
      ...t,
      [n]: !1
    } : t, {}) : {};
  }
}, Wye = async (e, t, n = null) => {
  const i = (e ? await VVe.list({
    limit: 1e4
  }) : await Lp.list({
    projectId: n,
    limit: 1e4
  })).data.find(
    (o) => o.displayName === t
  );
  return De(i);
}, qVe = {
  useUpsertAppConnection: ({
    isGlobalConnection: e,
    reconnectConnection: t,
    externalIdComingFromSdk: n,
    setErrorMessage: r,
    form: i,
    setOpen: o
  }) => {
    const { projectId: s } = ol();
    return dr({
      mutationFn: async () => {
        r("");
        const l = i.getValues().request;
        if (!await Wye(
          e,
          l.displayName,
          s
        ) && (t == null ? void 0 : t.displayName) !== l.displayName && (De(n) || n === ""))
          throw new NR();
        if (e) {
          if (l.projectIds.length === 0)
            throw new Bye();
          return VVe.upsert({
            ...l,
            projectIds: l.projectIds,
            scope: _u.PLATFORM
          });
        }
        return Lp.upsert({ ...l, projectId: s });
      },
      onSuccess: (l) => {
        o(!1, l), r("");
      },
      onError: (l) => {
        var c;
        if (l instanceof NR)
          i.setError("request.displayName", {
            message: l.message
          });
        else if (l instanceof Bye)
          i.setError("request.projectIds", {
            message: l.message
          });
        else if (dt.isError(l)) {
          const a = (c = l.response) == null ? void 0 : c.data;
          switch (a.code) {
            case Ni.INVALID_CLOUD_CLAIM: {
              r(
                Z(
                  "Could not claim the authorization code, make sure you have correct settings and try again."
                )
              );
              break;
            }
            case Ni.INVALID_CLAIM: {
              r(
                Z("Connection failed with error {msg}", {
                  msg: a.params.message
                })
              );
              break;
            }
            case Ni.INVALID_APP_CONNECTION: {
              r(
                Z("Connection failed with error {msg}", {
                  msg: a.params.error
                })
              );
              break;
            }
            // can happen in embedding sdk connect method
            case Ni.PERMISSION_DENIED: {
              r(
                Z("You don't have the permission to create a connection.")
              );
              break;
            }
            default:
              r("Unexpected error, please contact support"), Kc(), console.error(l);
          }
        }
      }
    });
  },
  useBulkDeleteAppConnections: (e) => {
    const { projectId: t } = ol();
    return dr({
      mutationFn: async (n) => {
        await Promise.all(
          n.map((r) => Lp.delete(r, t))
        );
      },
      onSuccess: () => {
        e();
      },
      onError: () => {
        Kc();
      }
    });
  },
  useDeleteConnection: () => {
    const { projectId: e } = ol(), t = Kw();
    return dr({
      mutationFn: async (n) => {
        await Lp.delete(n, e);
      },
      onSuccess: () => {
        t.invalidateQueries({ queryKey: ["app-connections"] });
      }
    });
  },
  useRenameAppConnection: ({
    currentName: e,
    setIsRenameDialogOpen: t,
    renameConnectionForm: n,
    refetch: r
  }) => {
    const { projectId: i } = ol();
    return dr({
      mutationFn: async ({
        connectionId: o,
        displayName: s
      }) => {
        if (!await Wye(
          !1,
          s,
          i
        ) && s !== e)
          throw new NR();
        return Lp.update(o, { displayName: s });
      },
      onSuccess: () => {
        r(), vr.success(Z("Success"), {
          description: Z("Connection has been renamed."),
          duration: 3e3
        }), t(!1);
      },
      onError: (o) => {
        o instanceof NR ? n.setError("displayName", {
          message: o.message
        }) : Kc();
      }
    });
  },
  useReplaceConnections: ({
    setDialogOpen: e,
    refetch: t
  }) => {
    const { projectId: n } = ol();
    return dr({
      mutationFn: async (r) => {
        await Lp.replace({ ...r, projectId: n });
      },
      onSuccess: () => {
        vr.success(Z("Success"), {
          description: Z("Connections replaced successfully")
        }), e(!1), t();
      },
      onError: () => {
        vr.error(Z("Error"), {
          description: Z("Failed to replace connections")
        });
      }
    });
  }
}, BVe = {
  useAppConnections: ({
    request: e,
    extraKeys: t,
    enabled: n,
    staleTime: r,
    pieceAuth: i
  }) => {
    const { projectId: o } = ol();
    return pr({
      queryKey: ["app-connections", ...t],
      queryFn: async () => {
        const s = await Lp.list({
          ...e,
          projectId: o
        });
        return i ? {
          ...s,
          data: s.data.filter(
            (l) => !De(
              h$({
                authValueType: l.type,
                pieceAuth: i
              })
            )
          )
        } : s;
      },
      enabled: n,
      staleTime: r
    });
  },
  useConnectionsOwners: () => {
    const { projectId: e } = ol(), t = bd().embedState.isEmbedded;
    return pr({
      queryKey: ["app-connections-owners", e],
      queryFn: async () => {
        const { data: n } = await Lp.getOwners({
          projectId: e
        }), { data: r } = await aFe.list({
          projectId: e
        });
        return t ? n.filter(
          (i) => !De(
            r.find(
              (o) => o.user.email === i.email
            )
          )
        ) : n;
      }
    });
  }
}, Oq = {
  listCloudOAuth2Apps(e) {
    return dt.get(
      `${kv}/oauth/clients`,
      {
        edition: e
      }
    );
  },
  listPlatformOAuth2Apps(e) {
    return dt.get("/v1/oauth-apps", e);
  },
  delete(e) {
    return dt.delete(`/v1/oauth-apps/${e}`);
  },
  upsert(e) {
    return dt.post("/v1/oauth-apps", e);
  }
}, upn = {
  useOAuthAppConfigured(e) {
    const t = pr({
      queryKey: ["oauth2-apps-configured"],
      queryFn: async () => (await Oq.listPlatformOAuth2Apps({
        limit: 1e6
      })).data,
      select: (n) => n.find((r) => r.pieceName === e),
      staleTime: 1 / 0
    });
    return {
      refetch: t.refetch,
      oauth2App: t.data
    };
  },
  usePiecesOAuth2AppsMap() {
    const { platform: e } = dN.useCurrentPlatform(), { data: t } = Go.useFlag(As.EDITION);
    return pr({
      queryKey: ["oauth-apps"],
      queryFn: async () => {
        const n = t === Bw.COMMUNITY ? {
          data: []
        } : await Oq.listPlatformOAuth2Apps({
          limit: 1e6,
          cursor: void 0
        }), r = e.cloudAuthEnabled ? await Oq.listCloudOAuth2Apps(t) : {}, i = {};
        return Object.entries(r).forEach(([o, s]) => {
          i[o] = {
            cloudOAuth2App: {
              oauth2Type: Mn.CLOUD_OAUTH2,
              clientId: s.clientId
            },
            platformOAuth2App: null
          };
        }), n.data.forEach((o) => {
          var s;
          i[o.pieceName] = {
            platformOAuth2App: {
              oauth2Type: Mn.PLATFORM_OAUTH2,
              clientId: o.clientId
            },
            cloudOAuth2App: ((s = i[o.pieceName]) == null ? void 0 : s.cloudOAuth2App) ?? null
          };
        }), i;
      },
      staleTime: 0
    });
  }
};
let RM = null;
function dpn() {
  const [e] = Eve();
  return (t, n) => {
    const r = e.get(Qse) || "/flows", i = {
      [Vwt]: n,
      [Qse]: r,
      [Uwt]: "true"
    }, o = new URL(t);
    o.searchParams.set(
      Fwt,
      JSON.stringify(i)
    ), window.location.href = o.toString();
  };
}
async function fpn(e) {
  XVe();
  const t = Fu(43), n = await mpn(e, t);
  return RM = ppn(n), {
    code: await gpn(e.redirectUrl),
    codeChallenge: e.pkce ? t : void 0
  };
}
function ppn(e) {
  const t = [
    "resizable=no",
    "toolbar=no",
    "left=100",
    "top=100",
    "scrollbars=no",
    "menubar=no",
    "status=no",
    "directories=no",
    "location=no",
    "width=600",
    "height=800"
  ].join(", ");
  return window.open(e, "_blank", t);
}
function XVe() {
  RM == null || RM.close();
}
async function hpn(e) {
  const n = new TextEncoder().encode(e), r = await window.crypto.subtle.digest("SHA-256", n);
  return btoa(String.fromCharCode(...new Uint8Array(r))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
async function mpn(e, t) {
  const n = {
    response_type: "code",
    client_id: e.clientId,
    redirect_uri: e.redirectUrl,
    access_type: "offline",
    state: Fu(),
    prompt: "consent",
    scope: e.scope,
    ...e.extraParams || {}
  };
  if (e.prompt === "omit" ? delete n.prompt : De(e.prompt) || (n.prompt = e.prompt), e.pkce) {
    const i = e.pkceMethod || "plain";
    n.code_challenge_method = i, i === "S256" ? n.code_challenge = await hpn(
      t
    ) : n.code_challenge = t;
  }
  const r = new URL(e.authUrl);
  return Object.entries(n).forEach(([i, o]) => {
    o !== "" && r.searchParams.append(i, o);
  }), r.toString();
}
function gpn(e) {
  return new Promise((t) => {
    window.addEventListener("message", function n(r) {
      e && e.startsWith(r.origin) && r.data.code && (t(decodeURIComponent(r.data.code)), XVe(), window.removeEventListener("message", n));
    });
  });
}
function ypn(e) {
  return De(e.grantType) || e.grantType === nv ? Xs.AUTHORIZATION_CODE : e.grantType;
}
function vpn(e, t) {
  const n = e[t];
  return De(n) ? null : n.platformOAuth2App ? n.platformOAuth2App : n.cloudOAuth2App ? n.cloudOAuth2App : null;
}
const Zk = {
  openOAuth2Popup: fpn,
  useThirdPartyLogin: dpn,
  getGrantType: ypn,
  getPredefinedOAuth2App: vpn
}, bpn = (e) => {
  const t = document.cookie.match(
    new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
  ), n = t ? decodeURIComponent(t[3]) : null;
  return n ? n.trim() : null;
}, Opn = () => {
  const e = bpn("kc_access_token"), t = localStorage.getItem("currentOrganizationId") || void 0, n = localStorage.getItem("currentOrganizationSlug") || void 0;
  if (!e)
    return null;
  try {
    const r = tQ(e);
    return {
      token: e,
      email: r.email,
      name: r.name,
      organization_id: t,
      organization_slug: n
    };
  } catch {
    return null;
  }
}, Apn = (e) => {
  const t = e.name;
  return t.includes("bunyan") || t.includes("omni-model");
}, wpn = () => {
  var r;
  const [e, t] = He(null);
  g.Object({
    request: Xw
  });
  const n = _r();
  return nt(() => {
    const i = Opn();
    console.log(
      "ORGANIZATION",
      i == null ? void 0 : i.organization_id,
      i == null ? void 0 : i.organization_slug
    ), i && (t(i), n.setValue(
      "request.displayName",
      `${i.name}<${i.email}>`,
      {
        shouldValidate: !0
      }
    ), n.setValue(
      "request.value.secret_text",
      i.organization_id ? `${i.token},${i.organization_id}` : i.token,
      {
        shouldValidate: !0
      }
    ));
  }, []), e ? /* @__PURE__ */ V("div", { className: "border border-solid p-2 rounded-lg gap-2 flex text-center items-center justify-center h-full", children: [
    /* @__PURE__ */ y("div", { className: "rounded-full border border-solid p-1 flex items-center justify-center", children: /* @__PURE__ */ y(yG, { children: (r = e == null ? void 0 : e.name) == null ? void 0 : r.charAt(0).toUpperCase() }) }),
    /* @__PURE__ */ V("div", { className: "text-sm", children: [
      e == null ? void 0 : e.name,
      " ",
      e != null && e.organization_slug ? `(Org: ${e == null ? void 0 : e.organization_slug})` : ""
    ] })
  ] }) : null;
}, WVe = ie.memo(
  ({ authProperty: e }) => {
    g.Object({
      request: MC
    });
    const t = _r();
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        Zn,
        {
          name: "request.value.username",
          control: t.control,
          render: ({ field: n }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col", children: [
            /* @__PURE__ */ y(ui, { children: e.username.displayName }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { ...n, type: "text" }) }),
            /* @__PURE__ */ y(rL, { children: e.username.description })
          ] })
        }
      ),
      /* @__PURE__ */ y(
        Zn,
        {
          name: "request.value.password",
          control: t.control,
          render: ({ field: n }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col mt-3.5", children: [
            /* @__PURE__ */ y(ui, { children: e.password.displayName }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { ...n, type: "password" }) }),
            /* @__PURE__ */ y(rL, { children: e.password.description })
          ] })
        }
      )
    ] });
  }
);
WVe.displayName = "BasicAuthConnectionSettings";
const ZVe = ie.memo(
  ({ authProperty: e }) => /* @__PURE__ */ y(
    bh,
    {
      prefixValue: "request.value.props",
      props: e.props,
      useMentionTextInput: !1,
      propertySettings: null,
      dynamicPropsInfo: null
    }
  )
);
ZVe.displayName = "CustomAuthConnectionSettings";
function xpn({
  pieceAuth: e,
  setSelectedItem: t,
  confirmSelectedItem: n,
  piecesOAuth2AppsMap: r,
  pieceName: i,
  selectedItem: o
}) {
  const s = e.flatMap(
    (c) => {
      const a = Spn(c);
      if (c.type === Le.OAUTH2) {
        const u = Zk.getPredefinedOAuth2App(
          r,
          i
        );
        return Epn(c, u);
      }
      return {
        label: a,
        value: { authProperty: c, grantType: null, oauth2App: null },
        description: ""
      };
    }
  ), l = s.find(
    (c) => qg(c.value, o)
  );
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(Ds, { className: "mb-0", children: /* @__PURE__ */ y(_s, { className: "px-5", children: /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: Z("Select an Authentication Method") }) }) }),
    /* @__PURE__ */ y(
      L$,
      {
        className: "px-5 mt-5",
        items: s,
        onChange: t,
        value: (l == null ? void 0 : l.value) ?? null
      }
    ),
    /* @__PURE__ */ y(kl, { className: "mt-4", children: /* @__PURE__ */ V("div", { className: "mx-5 w-full flex justify-end gap-2", children: [
      /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "outline", children: Z("Cancel") }) }),
      /* @__PURE__ */ y(Qe, { variant: "default", onClick: () => n(), children: Z("Next") })
    ] }) })
  ] });
}
const Spn = (e) => e.displayName !== TE && e.type !== Le.OAUTH2 ? e.displayName : e.type === Le.OAUTH2 ? "OAuth2" : rc.convertEnumToHumanReadable(e.type);
function Epn(e, t) {
  const n = [], r = e.grantType ?? Xs.AUTHORIZATION_CODE, i = {
    oauth2Type: Mn.OAUTH2,
    clientId: null
  };
  return t && (r === Xs.AUTHORIZATION_CODE || r === nv) && n.push({
    label: Z("OAuth2 (Recommended)"),
    value: {
      authProperty: e,
      grantType: Xs.AUTHORIZATION_CODE,
      oauth2App: t
    },
    description: Z(
      "Quickly connect using a preconfigured OAuth2 app. No setup required."
    )
  }), (r === Xs.AUTHORIZATION_CODE || r === nv) && n.push({
    label: Z("Custom OAuth2 App (Advanced)"),
    value: {
      authProperty: e,
      grantType: Xs.AUTHORIZATION_CODE,
      oauth2App: i
    },
    description: Z(
      "Connect using your own OAuth2 credentials for more flexibility and control."
    )
  }), (r === Xs.CLIENT_CREDENTIALS || r === nv) && n.push({
    label: Z("Server-to-Server (Client Credentials)"),
    value: {
      authProperty: e,
      grantType: Xs.CLIENT_CREDENTIALS,
      oauth2App: i
    },
    description: Z(
      "Authenticate securely from your server using the Client Credentials flow. Ideal for backend integrations."
    )
  }), n;
}
function HVe({
  authProperty: e,
  oauth2App: t,
  piece: n,
  grantType: r
}) {
  var d, p, h, m;
  const i = _r(), o = De(
    (p = (d = i.formState.errors.request) == null ? void 0 : d.value) == null ? void 0 : p.client_id
  ), s = t.oauth2Type !== Mn.OAUTH2 || i.getValues("request.value.client_secret"), l = De((m = (h = i.formState.errors.request) == null ? void 0 : h.value) == null ? void 0 : m.props), c = o && s && l, a = `${kv}/oauth`;
  nt(
    () => {
      i.setValue("request.value.redirect_url", a, { shouldValidate: !0 });
    },
    [a]
  );
  const u = i.getValues().request.value.code, f = t.oauth2Type === Mn.OAUTH2 && r === Xs.AUTHORIZATION_CODE;
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", children: [
    f && /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ y(ui, { children: Z("Redirect URL") }),
      /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { disabled: !0, type: "text", value: a }) }),
      /* @__PURE__ */ y(Ei, {})
    ] }),
    t.oauth2Type === Mn.OAUTH2 && /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        Zn,
        {
          name: "request.value.client_id",
          control: i.control,
          render: ({ field: v }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col", children: [
            /* @__PURE__ */ y(ui, { children: Z("Client ID") }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { ...v, type: "text", placeholder: Z("Client ID") }) })
          ] })
        }
      ),
      /* @__PURE__ */ y(
        Zn,
        {
          name: "request.value.client_secret",
          control: i.control,
          render: ({ field: v }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col", children: [
            /* @__PURE__ */ y(ui, { children: Z("Client Secret") }),
            /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(
              fr,
              {
                ...v,
                type: "password",
                placeholder: Z("Client Secret")
              }
            ) })
          ] })
        }
      )
    ] }),
    e.props && /* @__PURE__ */ y(
      bh,
      {
        prefixValue: "request.value.props",
        props: e.props,
        useMentionTextInput: !1,
        propertySettings: null,
        dynamicPropsInfo: null
      }
    ),
    r !== Xs.CLIENT_CREDENTIALS && /* @__PURE__ */ V("div", { className: "border border-solid p-2 rounded-lg gap-2 flex text-center items-center justify-center h-full", children: [
      /* @__PURE__ */ y("div", { className: "rounded-full border border-solid p-1 flex items-center justify-center", children: /* @__PURE__ */ y("img", { src: n.logoUrl, className: "w-5 h-5" }) }),
      /* @__PURE__ */ y("div", { className: "text-sm", children: n.displayName }),
      /* @__PURE__ */ y("div", { className: "grow" }),
      /* @__PURE__ */ y(
        Qe,
        {
          size: "sm",
          variant: "basic",
          className: u ? "text-destructive" : "",
          disabled: !c,
          type: "button",
          onClick: async () => {
            u ? (i.setValue("request.value.code", "", {
              shouldValidate: !0
            }), i.setValue("request.value.code_challenge", "", {
              shouldValidate: !0
            })) : Tpn(
              a,
              i.getValues().request.value.client_id,
              i.getValues().request.value.props,
              e,
              i
            );
          },
          children: Z(u ? "Disconnect" : "Connect")
        }
      )
    ] })
  ] });
}
HVe.displayName = "OAuth2ConnectionSettings";
async function Tpn(e, t, n, r, i) {
  const o = Dq(n, r.scope.join(" ")), s = Dq(n, r.authUrl), { code: l, codeChallenge: c } = await Zk.openOAuth2Popup({
    authUrl: s,
    clientId: t,
    redirectUrl: e,
    scope: o,
    prompt: r.prompt,
    pkce: r.pkce ?? !1,
    pkceMethod: r.pkceMethod ?? "plain",
    extraParams: r.extra ?? {}
  });
  i.setValue("request.value.code", l, { shouldValidate: !0 }), i.setValue("request.value.code_challenge", c, {
    shouldValidate: !0
  });
}
const QVe = ie.memo(
  ({ authProperty: e }) => {
    g.Object({
      request: Xw
    });
    const t = _r();
    return /* @__PURE__ */ y(
      Zn,
      {
        name: "request.value.secret_text",
        control: t.control,
        render: ({ field: n }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col", children: [
          /* @__PURE__ */ y(ui, { children: e.displayName }),
          /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(fr, { ...n, type: "password" }) })
        ] })
      }
    );
  }
);
QVe.displayName = "SecretTextConnectionSettings";
function kpn({
  piece: e,
  reconnectConnection: t,
  isGlobalConnection: n,
  externalIdComingFromSdk: r,
  setOpen: i,
  selectedAuth: o,
  onTryAnotherMethodButtonClicked: s,
  showTryAnotherMethodButton: l
}) {
  const c = Bc.buildConnectionSchema(o.authProperty), { projectId: a } = ol(), { externalId: u, displayName: f } = Xye.getConnectionName(
    e,
    t,
    r
  ), d = `${kv}/oauth`, p = Fg({
    defaultValues: {
      request: {
        ...Xye.createDefaultValues({
          auth: o.authProperty,
          suggestedExternalId: u,
          suggestedDisplayName: f,
          pieceName: e.name,
          oauth2App: o.oauth2App,
          grantType: o.grantType,
          redirectUrl: d ?? "",
          projectId: a
        }),
        projectIds: (t == null ? void 0 : t.projectIds) ?? [],
        pieceVersion: e.version
      }
    },
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: VN(c)
  });
  $At(() => {
    p.trigger();
  });
  const [h, m] = He(""), { mutate: v, isPending: b } = qVe.useUpsertAppConnection({
    isGlobalConnection: n,
    reconnectConnection: t,
    externalIdComingFromSdk: r,
    setErrorMessage: m,
    form: p,
    setOpen: i
  });
  return nt(() => {
    console.log("Error message changed:", h);
  }, [h]), /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V(Ds, { className: "mb-0", children: [
      /* @__PURE__ */ y(_s, { className: "px-5", children: /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: t ? Z("Reconnect {displayName} Connection", {
        displayName: t.displayName
      }) : Z("Connect to {displayName}", {
        displayName: e.displayName
      }) }) }),
      /* @__PURE__ */ y(kb, {})
    ] }),
    /* @__PURE__ */ y(Ug, { ...p, children: /* @__PURE__ */ V("form", { className: "flex flex-col gap-3 ", children: [
      /* @__PURE__ */ V(
        Bi,
        {
          className: "px-2",
          viewPortClassName: "max-h-[calc(70vh-180px)] px-4 mb-1",
          children: [
            " ",
            /* @__PURE__ */ y(
              uu,
              {
                markdown: o.authProperty.description
              }
            ),
            o.authProperty.description && /* @__PURE__ */ y(Eh, { className: "my-4" }),
            (De(r) || r === "") && /* @__PURE__ */ y(
              Zn,
              {
                name: "request.displayName",
                control: p.control,
                render: ({ field: A }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col gap-2", children: [
                  /* @__PURE__ */ y(ui, { htmlFor: "displayName", children: Z("Connection Name") }),
                  /* @__PURE__ */ y(Hi, { children: /* @__PURE__ */ y(
                    fr,
                    {
                      ...A,
                      required: !0,
                      id: "displayName",
                      type: "text",
                      placeholder: Z("Connection name")
                    }
                  ) }),
                  /* @__PURE__ */ y(Ei, {})
                ] })
              }
            ),
            n && /* @__PURE__ */ V("div", { className: "my-4 flex flex-col gap-4", children: [
              /* @__PURE__ */ y(
                cpn,
                {
                  control: p.control,
                  name: "request.projectIds"
                }
              ),
              n && De(t) && /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y(
                Zn,
                {
                  control: p.control,
                  name: "request.externalId",
                  render: ({ field: A }) => /* @__PURE__ */ V(Jn, { children: [
                    /* @__PURE__ */ y(ui, { children: Z("External ID") }),
                    /* @__PURE__ */ y(fr, { ...A })
                  ] })
                }
              ) })
            ] }),
            /* @__PURE__ */ y("div", { className: "mt-3.5", children: /* @__PURE__ */ y(Cpn, { selectedAuth: o, piece: e }) })
          ]
        }
      ),
      h && /* @__PURE__ */ y(
        A3,
        {
          formMessageId: "create-connection-server-error-message",
          className: "text-left px-6",
          children: h
        }
      ),
      /* @__PURE__ */ y(kl, { className: "mt-0", children: /* @__PURE__ */ V("div", { className: "mx-5 flex gap-2 w-full", children: [
        l && /* @__PURE__ */ y(
          Qe,
          {
            variant: "outline",
            type: "button",
            onClick: s,
            children: Z("Try another method")
          }
        ),
        /* @__PURE__ */ y("div", { className: "grow" }),
        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "outline", children: Z("Cancel") }) }),
        /* @__PURE__ */ y(
          Qe,
          {
            onClick: (A) => p.handleSubmit(() => {
              console.log("Submitting form to upsert connection"), v();
            })(A),
            loading: b,
            type: "submit",
            disabled: !p.formState.isValid,
            children: Z("Save")
          }
        )
      ] }) })
    ] }) })
  ] });
}
function Cpn({ selectedAuth: e, piece: t }) {
  if (Apn(t))
    return /* @__PURE__ */ y(wpn, {});
  switch (e.authProperty.type) {
    case Le.SECRET_TEXT:
      return /* @__PURE__ */ y(
        QVe,
        {
          authProperty: e.authProperty
        }
      );
    case Le.BASIC_AUTH:
      return /* @__PURE__ */ y(WVe, { authProperty: e.authProperty });
    case Le.CUSTOM_AUTH:
      return /* @__PURE__ */ y(
        ZVe,
        {
          authProperty: e.authProperty
        }
      );
    case Le.OAUTH2:
      return De(e.grantType) || De(e.oauth2App) ? /* @__PURE__ */ y("div", { children: "Error: Grant type and OAuth2 app are required" }) : /* @__PURE__ */ y(
        HVe,
        {
          authProperty: e.authProperty,
          piece: t,
          grantType: e.grantType,
          oauth2App: e.oauth2App
        }
      );
  }
}
function $Ve(e) {
  const t = e.piece, [n, r] = He(
    t.auth ? Ipn(
      t.auth,
      e.reconnectConnection,
      e.piecesOAuth2AppsMap,
      t.name
    ) : null
  ), [i, o] = He(!1);
  if (De(t.auth))
    return null;
  const s = !De(
    Zk.getPredefinedOAuth2App(e.piecesOAuth2AppsMap, t.name)
  ), l = Array.isArray(t.auth) || KVe(t.auth) || s;
  return /* @__PURE__ */ V(pt, { children: [
    !i && n && /* @__PURE__ */ y(
      kpn,
      {
        ...e,
        selectedAuth: n,
        onTryAnotherMethodButtonClicked: () => o(!0),
        showTryAnotherMethodButton: l
      }
    ),
    i && l && t.auth && n && /* @__PURE__ */ y(
      xpn,
      {
        pieceName: t.name,
        piecesOAuth2AppsMap: e.piecesOAuth2AppsMap,
        selectedItem: n,
        pieceAuth: Array.isArray(t.auth) ? t.auth : [t.auth],
        setSelectedItem: r,
        confirmSelectedItem: () => {
          o(!1);
        }
      }
    )
  ] });
}
$Ve.displayName = "CreateOrEditConnectionDialogContent";
function wee({
  piece: e,
  open: t,
  setOpen: n,
  reconnectConnection: r,
  isGlobalConnection: i,
  externalIdComingFromSdk: o
}) {
  const { data: s, isPending: l } = upn.usePiecesOAuth2AppsMap();
  return /* @__PURE__ */ y(qa, { open: t, onOpenChange: (c) => n(c), children: /* @__PURE__ */ y(
    ia,
    {
      onInteractOutside: (c) => c.preventDefault(),
      className: "max-h-[70vh] px-0  min-w-[450px] max-w-[450px] lg:min-w-[650px] lg:max-w-[650px] overflow-y-auto",
      children: l && Npn(e) ? /* @__PURE__ */ V(pt, { children: [
        /* @__PURE__ */ y(Ds, { className: "mb-0", children: /* @__PURE__ */ y(_s, { className: "px-5", children: /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: r ? Z("Reconnect {displayName} Connection", {
          displayName: r.displayName
        }) : Z("Connect to {displayName}", {
          displayName: e.displayName
        }) }) }) }),
        /* @__PURE__ */ y(kQ, { numberOfItems: 4, className: "h-7 mt-2" })
      ] }) : /* @__PURE__ */ y(
        $Ve,
        {
          piece: e,
          piecesOAuth2AppsMap: s ?? {},
          setOpen: n,
          reconnectConnection: r,
          isGlobalConnection: i,
          externalIdComingFromSdk: o
        }
      )
    }
  ) }, e.name);
}
function Npn(e) {
  return De(e.auth) ? !1 : Array.isArray(e.auth) ? e.auth.some((t) => t.type === Le.OAUTH2) : e.auth.type === Le.OAUTH2;
}
wee.displayName = "CreateOrEditConnectionDialog";
function Ppn(e, t) {
  return Array.isArray(e) ? t ? h$({
    authValueType: t.type,
    pieceAuth: e
  }) : e.at(0) : e;
}
function Ipn(e, t, n, r) {
  const i = Ppn(
    e,
    t
  );
  return i ? i.type === Le.OAUTH2 ? {
    authProperty: i,
    grantType: Zk.getGrantType(i),
    oauth2App: Zk.getPredefinedOAuth2App(
      n,
      r
    ) ?? {
      oauth2Type: Mn.OAUTH2,
      clientId: null
    }
  } : {
    authProperty: i,
    grantType: null,
    oauth2App: null
  } : null;
}
function KVe(e) {
  return Array.isArray(e) ? e.some(KVe) : e.type === Le.OAUTH2 && e.grantType === nv;
}
function Rpn(e) {
  if (typeof e != "string") return;
  const t = e.match(/^\{\{connections\['([^']+)'\]\}\}$/);
  return t == null ? void 0 : t[1];
}
const GVe = ie.memo(
  ({
    piece: e,
    value: t,
    onChange: n,
    disabled: r = !1,
    showError: i = !1,
    placeholder: o = Z("Select a connection")
  }) => {
    var m;
    const [s, l] = He(!1), {
      data: c,
      isLoading: a,
      refetch: u,
      isRefetching: f
    } = BVe.useAppConnections({
      request: {
        pieceName: (e == null ? void 0 : e.name) || "",
        projectId: Rn.getProjectId(),
        limit: 1e3
      },
      extraKeys: [e == null ? void 0 : e.name, Rn.getProjectId()],
      staleTime: 0
    });
    if (!e)
      return null;
    const d = ((m = c == null ? void 0 : c.data) == null ? void 0 : m.map((v) => ({
      label: v.displayName,
      value: v.externalId
    }))) ?? [], p = [
      { label: Z("+ New Connection"), value: "" },
      ...d
    ], h = (v) => {
      v ? n(`{{connections['${v}']}}`) : l(!0);
    };
    return /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ y(
        wee,
        {
          piece: e,
          open: s,
          setOpen: (v, b) => {
            l(v), b && (n(`{{connections['${b.externalId}']}}`), u());
          },
          reconnectConnection: null,
          isGlobalConnection: !1
        }
      ),
      /* @__PURE__ */ V("div", { className: "space-y-2", children: [
        /* @__PURE__ */ y(
          vg,
          {
            value: Rpn(t),
            onChange: h,
            options: p,
            placeholder: o,
            loading: a || f,
            disabled: r,
            showDeselect: !r && t !== null,
            triggerClassName: i ? "border-destructive" : void 0
          }
        ),
        i && /* @__PURE__ */ y("p", { className: "text-sm font-medium text-destructive break-words", children: Z("Connection is required") })
      ] })
    ] });
  }
);
GVe.displayName = "ConnectionDropdown";
const Mpn = (e) => g.Object(
  e ? {
    auth: g.String({ minLength: 1 })
  } : {},
  {
    additionalProperties: !0,
    ...e && { required: ["auth"] }
  }
), Dpn = () => {
  const {
    predefinedInputs: e,
    setPredefinedInputs: t,
    selectedAction: n,
    selectedPiece: r
  } = ob(), { pieces: i } = nd.usePieces({}), o = i == null ? void 0 : i.find((m) => m.name === (r == null ? void 0 : r.pieceName)), s = (n == null ? void 0 : n.requireAuth) ?? !0, l = Kt(
    () => Mpn(s),
    [s]
  ), c = Kt(
    () => n ? Object.fromEntries(
      Object.entries(n.props).map(([m, v]) => [
        m,
        v
      ])
    ) : {},
    [n]
  ), a = Kt(() => {
    const m = {};
    return s && (e != null && e.auth) && (m.auth = e.auth), e != null && e.fields && Object.entries(e.fields).forEach(([v, b]) => {
      b.mode === Cc.CHOOSE_YOURSELF && !De(b.value) && (m[v] = b.value);
    }), m;
  }, [e, s]), u = Fg({
    resolver: VN(l),
    defaultValues: a,
    mode: "onChange",
    reValidateMode: "onChange"
  });
  nt(() => {
    const m = u.watch((v, { name: b }) => {
      var x;
      if (!b || b === "auth") return;
      const A = ob.getState().predefinedInputs, O = { ...(A == null ? void 0 : A.fields) ?? {} };
      ((x = O[b]) == null ? void 0 : x.mode) === Cc.CHOOSE_YOURSELF && (O[b] = {
        ...O[b],
        value: v[b]
      }), t({
        ...A,
        fields: O
      });
    });
    return () => m.unsubscribe();
  }, [u, t]);
  const f = (m) => {
    const v = De(m) ? void 0 : m;
    t({
      auth: v,
      fields: (e == null ? void 0 : e.fields) || {}
    }), u.setValue("auth", m ?? "");
  }, d = (m) => {
    var v, b;
    return ((b = (v = e == null ? void 0 : e.fields) == null ? void 0 : v[m]) == null ? void 0 : b.mode) ?? Cc.AGENT_DECIDE;
  }, p = (m, v) => {
    const b = (e == null ? void 0 : e.fields) ?? {}, A = b[m], w = {
      mode: v,
      value: v === Cc.CHOOSE_YOURSELF ? (A == null ? void 0 : A.value) ?? u.getValues(m) : void 0
    };
    t({
      ...e,
      fields: {
        ...b,
        [m]: w
      }
    }), v === Cc.CHOOSE_YOURSELF ? u.setValue(m, w.value ?? "") : u.setValue(m, void 0, { shouldDirty: !1 });
  }, h = s && (o == null ? void 0 : o.auth);
  return /* @__PURE__ */ y(Ug, { ...u, children: /* @__PURE__ */ V(Bi, { className: "h-full", children: [
    /* @__PURE__ */ V("div", { className: "flex items-start border-b gap-3 p-4", children: [
      /* @__PURE__ */ y("div", { className: "flex size-11 shrink-0 items-center justify-center rounded-sm border bg-background", children: /* @__PURE__ */ y(
        "img",
        {
          className: "size-8 object-contain",
          src: o == null ? void 0 : o.logoUrl,
          alt: o == null ? void 0 : o.displayName
        }
      ) }),
      /* @__PURE__ */ V("div", { className: "min-w-0 flex-1", children: [
        /* @__PURE__ */ y("div", { className: "text-sm font-medium", children: n == null ? void 0 : n.displayName }),
        (n == null ? void 0 : n.description) && /* @__PURE__ */ y("p", { className: "mt-0.5 text-xs text-muted-foreground line-clamp-2", children: n.description })
      ] })
    ] }),
    /* @__PURE__ */ V("div", { className: "space-y-6 p-4", children: [
      h && !De(o) && /* @__PURE__ */ y(
        GVe,
        {
          piece: o,
          value: u.watch("auth"),
          onChange: f,
          placeholder: Z("Connect your account")
        }
      ),
      Object.keys(c).length > 0 && /* @__PURE__ */ y("div", { className: "space-y-5", children: Object.entries(c).map(([m, v]) => {
        if (v.type === Le.MARKDOWN)
          return /* @__PURE__ */ y(
            uu,
            {
              markdown: v.description,
              variables: {},
              variant: v.variant
            },
            m
          );
        const A = d(m), w = A === Cc.CHOOSE_YOURSELF;
        return /* @__PURE__ */ V("div", { className: "space-y-2", children: [
          /* @__PURE__ */ V("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ V("h3", { className: "text-sm font-medium", children: [
              v.displayName,
              " ",
              v.required && "*"
            ] }),
            /* @__PURE__ */ V(
              Cf,
              {
                value: A,
                onValueChange: (O) => p(m, O),
                children: [
                  /* @__PURE__ */ y(sd, { className: "w-80", children: /* @__PURE__ */ y(Nf, {}) }),
                  /* @__PURE__ */ V(ad, { children: [
                    /* @__PURE__ */ y(Ti, { value: Cc.AGENT_DECIDE, children: Z("Let agent decide") }),
                    /* @__PURE__ */ y(Ti, { value: Cc.CHOOSE_YOURSELF, children: Z("Set value myself") }),
                    !v.required && /* @__PURE__ */ y(Ti, { value: Cc.LEAVE_EMPTY, children: Z("Leave empty") })
                  ] })
                ]
              }
            )
          ] }),
          w && /* @__PURE__ */ y(
            Zn,
            {
              name: m,
              control: u.control,
              render: ({ field: O }) => yee({
                field: O,
                hideLabel: !0,
                propertyName: m,
                inputName: m,
                property: v,
                allowDynamicValues: !1,
                markdownVariables: {},
                useMentionTextInput: !0,
                disabled: !1,
                dynamicInputModeToggled: !1,
                form: u,
                dynamicPropsInfo: {
                  pieceName: (o == null ? void 0 : o.name) ?? "",
                  pieceVersion: (o == null ? void 0 : o.version) ?? "",
                  actionOrTriggerName: (n == null ? void 0 : n.name) ?? "",
                  placedInside: "predefinedAgentInputs",
                  updateFormSchema: null,
                  updatePropertySettingsSchema: null
                },
                propertySettings: null
              })
            }
          )
        ] }, m);
      }) })
    ] })
  ] }) });
}, _pn = [
  "@activepieces/piece-ai",
  "@activepieces/piece-mcp",
  "@activepieces/piece-openai",
  "@activepieces/piece-claude",
  "@activepieces/piece-google-gemini",
  "@activepieces/piece-grok-xai"
];
function Lpn({
  tools: e,
  onToolsUpdate: t
}) {
  const {
    showAddPieceDialog: n,
    selectedPage: r,
    searchQuery: i,
    selectedAction: o,
    isPieceAuthSet: s,
    selectedPiece: l,
    editingPieceTool: c,
    createNewPieceTool: a,
    goBackToActionsList: u,
    handlePieceSelect: f,
    handleActionSelect: d,
    goBackToPiecesList: p,
    closePieceDialog: h
  } = ob(), [m] = Gz(i, 300), { metadata: v, isLoading: b } = vd.useAllStepsMetadata({
    searchQuery: m,
    type: "action"
  }), A = Kt(() => (v == null ? void 0 : v.filter(
    (k) => "suggestedActions" in k && "suggestedTriggers" in k
  ).filter((k) => !_pn.includes(k.pieceName))) ?? [], [v]);
  nt(() => {
    var k;
    if (n && !De(c) && A.length > 0) {
      const T = A.find(
        (R) => R.pieceName === c.pieceMetadata.pieceName
      );
      if (T) {
        f(T);
        const R = (k = T.suggestedActions) == null ? void 0 : k.find(
          (j) => Q3(`${T.pieceName}-${j.name}`) === c.toolName
        );
        R && d(R);
      }
    }
  }, [n, c, A]);
  const w = s(), O = () => {
    const k = a();
    if (!De(k)) {
      if (De(c))
        t([...e, k]), vr("Piece tool added");
      else {
        const T = e.map(
          (R) => R.toolName === c.toolName ? k : R
        );
        t(T), vr("Piece tool updated");
      }
      h();
    }
  }, x = (k) => {
    k || h();
  }, S = () => {
    switch (r) {
      case "pieces-list":
        return /* @__PURE__ */ y(
          lpn,
          {
            isPiecesLoading: b,
            pieceMetadata: A
          }
        );
      case "actions-list":
        return /* @__PURE__ */ y(apn, { tools: e });
      case "action-inputs":
        return /* @__PURE__ */ y(Dpn, {});
    }
  };
  return /* @__PURE__ */ y(qa, { open: n, onOpenChange: x, children: /* @__PURE__ */ V(ia, { className: "w-[90vw] max-w-[750px] h-[80vh] max-h-[800px] flex flex-col overflow-hidden p-0", children: [
    /* @__PURE__ */ y(Ds, { className: "min-h-16 flex px-4 items-start justify-center mb-0 border-b", children: /* @__PURE__ */ y(_s, { children: (() => {
      switch (r) {
        case "pieces-list":
          return Z("Connect apps with the agent");
        case "actions-list":
          return l && /* @__PURE__ */ V("div", { className: "flex items-center justify-start gap-2", children: [
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  size: "icon",
                  onClick: p,
                  children: /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] size-4" })
                }
              ) }),
              /* @__PURE__ */ y(An, { children: Z("Back") })
            ] }),
            Z(l.displayName)
          ] });
        case "action-inputs":
          return o && /* @__PURE__ */ V("div", { className: "flex items-center justify-start gap-2", children: [
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  size: "icon",
                  onClick: u,
                  children: /* @__PURE__ */ y(sv, { className: "rtl:scale-x-[-1] size-4" })
                }
              ) }),
              /* @__PURE__ */ y(An, { children: Z("Back") })
            ] }),
            o.displayName
          ] });
      }
    })() }) }),
    S(),
    r === "action-inputs" && /* @__PURE__ */ V(kl, { className: "border-t p-4 mt-auto", children: [
      /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { type: "button", variant: "outline", children: Z("Close") }) }),
      /* @__PURE__ */ y(
        Qe,
        {
          loading: !1,
          disabled: !w,
          type: "button",
          onClick: O,
          children: Z(c ? "Update Tool" : "Add Tool")
        }
      )
    ] })
  ] }) });
}
const zpn = [
  "https://cdn.activepieces.com/pieces/youtube.png",
  "https://cdn.activepieces.com/pieces/slack.png",
  "https://cdn.activepieces.com/pieces/github.png",
  "https://cdn.activepieces.com/pieces/notion.png"
], jpn = ({
  disabled: e,
  toolsField: t
}) => {
  const n = Array.isArray(t.value) ? t.value : [], r = (c) => t.onChange(c), i = (c) => {
    r(n.filter((a) => c !== a.toolName));
  }, o = n.filter((c) => c.type === Wu.FLOW), s = n.filter((c) => c.type === Wu.MCP), l = n.filter((c) => c.type === Wu.PIECE).reduce((c, a) => {
    var f;
    const u = (f = a.pieceMetadata) == null ? void 0 : f.pieceName;
    return u && (c[u] ?? (c[u] = [])).push(a), c;
  }, {});
  return /* @__PURE__ */ V("div", { children: [
    /* @__PURE__ */ y("h2", { className: "text-sm font-medium", children: Z("Agent Tools") }),
    /* @__PURE__ */ y("div", { className: "mt-2", children: n.length > 0 ? /* @__PURE__ */ V(pt, { children: [
      /* @__PURE__ */ V(
        kJ,
        {
          type: "single",
          collapsible: !0,
          className: "border rounded-md overflow-hidden shadow-none",
          children: [
            Object.entries(l).map(([c, a]) => /* @__PURE__ */ y(
              rfn,
              {
                disabled: e,
                tools: a,
                removeTool: i
              },
              c
            )),
            o.length > 0 && /* @__PURE__ */ y(
              ofn,
              {
                disabled: e,
                tools: o,
                removeTool: i
              }
            ),
            s.length > 0 && /* @__PURE__ */ y(
              sfn,
              {
                disabled: e,
                tools: s,
                removeTool: i
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ y(Lye, { disabled: e, align: "start", children: /* @__PURE__ */ V(Qe, { variant: "outline", className: "mt-2", children: [
        /* @__PURE__ */ y(Da, { className: "size-4 mr-2" }),
        Z("Add")
      ] }) })
    ] }) : /* @__PURE__ */ V("div", { className: "flex flex-col items-center justify-center gap-4 rounded-xl border bg-card px-4 py-8 text-center", children: [
      /* @__PURE__ */ V("div", { className: "flex items-center", children: [
        zpn.slice(0, 4).map((c, a) => /* @__PURE__ */ y(
          "div",
          {
            className: "relative flex size-9 items-center justify-center rounded-full border bg-background",
            style: { marginLeft: a === 0 ? 0 : -10 },
            children: /* @__PURE__ */ y(
              "img",
              {
                src: c,
                alt: c,
                className: "size-4 object-contain"
              }
            )
          },
          c
        )),
        /* @__PURE__ */ y(
          "div",
          {
            className: "relative flex size-9 items-center justify-center rounded-full border text-[10px] bg-background text-foreground font-medium",
            style: { marginLeft: -10 },
            children: /* @__PURE__ */ y("span", { children: "+500" })
          }
        )
      ] }),
      /* @__PURE__ */ y("p", { className: "text-sm font-medium text-muted-foreground", children: Z("Connect apps, flows, MCPs and more.") }),
      /* @__PURE__ */ y(Lye, { disabled: e, align: "center", children: /* @__PURE__ */ V(Qe, { variant: "outline", className: "gap-2", children: [
        /* @__PURE__ */ y(Da, { className: "size-4" }),
        Z("Add")
      ] }) })
    ] }) }),
    /* @__PURE__ */ y(Ofn, { onToolsUpdate: r, tools: n }),
    /* @__PURE__ */ y(Lpn, { tools: n, onToolsUpdate: r }),
    /* @__PURE__ */ y(Afn, { tools: n, onToolsUpdate: r })
  ] });
}, Zye = {
  list() {
    return dt.get("/v1/ai-providers");
  },
  listModelsForProvider(e) {
    return dt.get(`/v1/ai-providers/${e}/models`);
  },
  upsert(e) {
    return dt.post("/v1/ai-providers", e);
  },
  update(e, t) {
    return dt.post(`/v1/ai-providers/${e}`, t);
  },
  delete(e) {
    return dt.delete(`/v1/ai-providers/${e}`);
  }
}, Hye = ["gpt-5.2", "gpt-5.1", "gpt-5-mini"], Qye = [
  "claude-sonnet-4-5-20250929",
  "claude-opus-4-5-20251101",
  "claude-haiku-4-5-20251001"
], $ye = [
  "gemini-3-pro-preview",
  "gemini-3-flash-preview",
  "gemini-2.5-flash-preview-09-2025",
  "gemini-2.5-flash-lite-preview-09-2025"
], Fpn = {
  openai: Hye,
  anthropic: Qye,
  google: $ye,
  activepieces: [...Hye, ...Qye, ...$ye]
};
function Upn(e, t, n) {
  const r = Fpn[e];
  return t.filter((i) => i.type === n).filter((i) => De(r) ? !0 : r.includes(i.id)).sort((i, o) => i.name.localeCompare(o.name));
}
const Kye = {
  useListProviders: () => pr({
    queryKey: ["ai-providers"],
    queryFn: () => Zye.list()
  }),
  useGetModelsForProvider: (e) => pr({
    queryKey: ["ai-models", e],
    enabled: !!e,
    queryFn: async () => {
      if (De(e)) return [];
      const t = await Zye.listModelsForProvider(e);
      return Upn(e, t, "text");
    }
  })
};
function Vpn({
  defaultProvider: e,
  defaultModel: t,
  disabled: n,
  onChange: r
}) {
  var b;
  const { data: i = [], isLoading: o } = Kye.useListProviders(), [s, l] = N.useState(e), [c, a] = N.useState(
    t
  ), u = (A) => {
    var w;
    return (w = $Oe.find((O) => O.provider === A)) == null ? void 0 : w.logoUrl;
  }, { data: f = [], isLoading: d } = Kye.useGetModelsForProvider(s), p = N.useMemo(
    () => i.find((A) => A.provider === rv.ACTIVEPIECES),
    [i]
  );
  N.useEffect(() => {
    var A;
    if (!s && !o && i.length > 0) {
      const w = (p == null ? void 0 : p.provider) || ((A = i[0]) == null ? void 0 : A.provider);
      w && l(w);
    }
  }, [i, o, s, p]), N.useEffect(() => {
    if (s && f.length > 0 && !c && !d) {
      const A = f[0].id;
      a(A), r({ provider: s, model: A });
    }
  }, [f, d, s, c, r]), N.useEffect(() => {
    var A;
    if (c && f.length > 0 && !f.some((w) => w.id === c)) {
      const w = (A = f[0]) == null ? void 0 : A.id;
      a(w), r({ provider: s, model: w });
    }
  }, [f, c, s, r]);
  const h = o || d, m = i.length > 0, v = f.length > 0;
  return /* @__PURE__ */ V("div", { className: "space-y-2", children: [
    /* @__PURE__ */ y("h2", { className: "text-sm font-medium", children: Z("AI Model *") }),
    /* @__PURE__ */ V("div", { className: "flex items-center border rounded-md bg-background", children: [
      /* @__PURE__ */ V(
        Cf,
        {
          value: s,
          onValueChange: (A) => {
            const w = A;
            l(w), a(void 0), r({ provider: w, model: void 0 });
          },
          disabled: h || !m || n,
          children: [
            /* @__PURE__ */ y(sd, { className: "border-0 focus:ring-0 rounded-none rounded-l-md max-w-72", children: /* @__PURE__ */ y(
              Nf,
              {
                placeholder: o ? "Loading..." : m ? "Select provider" : "No providers",
                children: s && /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
                  u(s) && /* @__PURE__ */ y(
                    "img",
                    {
                      src: u(s),
                      alt: s,
                      className: "h-4 w-4 object-contain"
                    }
                  ),
                  /* @__PURE__ */ y("span", { children: ((b = i.find((A) => A.provider === s)) == null ? void 0 : b.name) ?? s })
                ] })
              }
            ) }),
            /* @__PURE__ */ y(ad, { children: m ? [...i].sort((A, w) => A.provider === rv.ACTIVEPIECES ? -1 : w.provider === rv.ACTIVEPIECES ? 1 : 0).map((A) => /* @__PURE__ */ y(Ti, { value: A.provider, children: /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
              u(A.provider) && /* @__PURE__ */ y(
                "img",
                {
                  src: u(A.provider),
                  alt: "",
                  className: "h-4 w-4 object-contain"
                }
              ),
              /* @__PURE__ */ y("span", { children: A.name })
            ] }) }, A.id)) : /* @__PURE__ */ y("div", { className: "px-4 py-8 text-center text-sm text-muted-foreground", children: Z("No providers configured") }) })
          ]
        }
      ),
      /* @__PURE__ */ y("div", { className: "h-8 w-px bg-border" }),
      /* @__PURE__ */ V(
        Cf,
        {
          value: c,
          onValueChange: (A) => {
            a(A), r({ provider: s, model: A });
          },
          disabled: h || !s || !v || n,
          children: [
            /* @__PURE__ */ y(sd, { className: "border-0 focus:ring-0 rounded-none rounded-r-md min-w-28", children: /* @__PURE__ */ y(
              Nf,
              {
                placeholder: d ? "Loading models..." : s ? v ? "Select model..." : "No models available" : "Select provider first"
              }
            ) }),
            /* @__PURE__ */ y(ad, { children: v ? f.map((A) => /* @__PURE__ */ y(Ti, { value: A.id, children: A.name }, A.id)) : /* @__PURE__ */ y("div", { className: "px-4 py-8 text-center text-sm text-muted-foreground", children: Z("This provider doesn't have any models configured yet") }) })
          ]
        }
      )
    ] })
  ] });
}
const qpn = as("rounded-lg border bg-background text-foreground", {
  variants: {
    variant: {
      default: " shadow-xs",
      interactive: "cursor-pointer hover:border-gray-400 transition-colors duration-200 flex flex-col justify-between"
    },
    isSelected: {
      true: "border-gray-400",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    isSelected: !1
  }
}), YVe = N.forwardRef(
  ({ className: e, variant: t, isSelected: n, ...r }, i) => /* @__PURE__ */ y(
    "div",
    {
      ref: i,
      className: Se(qpn({ variant: t, isSelected: n }), e),
      ...r
    }
  )
);
YVe.displayName = "Card";
const Bpn = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    className: Se("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
Bpn.displayName = "CardHeader";
const Xpn = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    className: Se("font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Xpn.displayName = "CardTitle";
const Wpn = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    className: Se("text-sm text-muted-foreground", e),
    ...t
  }
));
Wpn.displayName = "CardDescription";
const JVe = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y("div", { ref: n, className: Se("p-6 pt-0", e), ...t }));
JVe.displayName = "CardContent";
const Zpn = N.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ y(
  "div",
  {
    ref: n,
    className: Se("flex items-center p-6 pt-0", e),
    ...t
  }
));
Zpn.displayName = "CardFooter";
const MM = ({
  type: e,
  className: t = "h-4 w-4"
}) => {
  switch (e) {
    case _c.TEXT:
      return /* @__PURE__ */ y(mst, { className: t });
    case _c.NUMBER:
      return /* @__PURE__ */ y(Hit, { className: t });
    case _c.BOOLEAN:
      return /* @__PURE__ */ y(tst, { className: t });
    default:
      return null;
  }
}, Hpn = ({
  onAddField: e,
  disabled: t
}) => {
  const [n, r] = He(
    void 0
  ), [i, o] = He(""), [s, l] = He(""), [c, a] = He(!1), u = () => {
    n && i.trim() && s.trim() && (e(n, i.trim(), s.trim()), r(void 0), o(""), l(""), a(!1));
  };
  return /* @__PURE__ */ V(mx, { open: c, onOpenChange: a, children: [
    /* @__PURE__ */ y(gx, { asChild: !0, children: /* @__PURE__ */ V(Qe, { variant: "outline", className: "w-full", disabled: t, children: [
      /* @__PURE__ */ y(Da, { className: "h-4 w-4 mr-2" }),
      Z("Add Field")
    ] }) }),
    /* @__PURE__ */ y(
      Sb,
      {
        className: "w-80",
        side: "bottom",
        align: "center",
        sideOffset: 10,
        children: /* @__PURE__ */ V("div", { className: "space-y-4", children: [
          /* @__PURE__ */ V("div", { className: "space-y-2", children: [
            /* @__PURE__ */ y("label", { className: "text-sm font-medium", children: "Field Type" }),
            /* @__PURE__ */ V(
              Cf,
              {
                value: n,
                onValueChange: (f) => r(f),
                children: [
                  /* @__PURE__ */ y(sd, { children: /* @__PURE__ */ y(Nf, { placeholder: "Select type" }) }),
                  /* @__PURE__ */ V(ad, { children: [
                    /* @__PURE__ */ y(Ti, { value: _c.TEXT, children: /* @__PURE__ */ V("div", { className: "flex items-center", children: [
                      /* @__PURE__ */ y(
                        MM,
                        {
                          type: _c.TEXT,
                          className: "h-4 w-4 mr-2 text-muted-foreground"
                        }
                      ),
                      /* @__PURE__ */ y("span", { children: "Text" })
                    ] }) }),
                    /* @__PURE__ */ y(Ti, { value: _c.NUMBER, children: /* @__PURE__ */ V("div", { className: "flex items-center", children: [
                      /* @__PURE__ */ y(
                        MM,
                        {
                          type: _c.NUMBER,
                          className: "h-4 w-4 mr-2 text-muted-foreground"
                        }
                      ),
                      /* @__PURE__ */ y("span", { children: "Number" })
                    ] }) }),
                    /* @__PURE__ */ y(Ti, { value: _c.BOOLEAN, children: /* @__PURE__ */ V("div", { className: "flex items-center", children: [
                      /* @__PURE__ */ y(
                        MM,
                        {
                          type: _c.BOOLEAN,
                          className: "h-4 w-4 mr-2 text-muted-foreground"
                        }
                      ),
                      /* @__PURE__ */ y("span", { children: "Yes/No" })
                    ] }) })
                  ] })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ V("div", { className: "space-y-2", children: [
            /* @__PURE__ */ y("label", { className: "text-sm font-medium", children: "Field Name" }),
            /* @__PURE__ */ y(
              fr,
              {
                id: "field-name",
                placeholder: "Enter field name",
                value: i,
                onChange: (f) => o(f.target.value)
              }
            )
          ] }),
          /* @__PURE__ */ V("div", { className: "space-y-2", children: [
            /* @__PURE__ */ y("label", { className: "text-sm font-medium", children: "Field Description" }),
            /* @__PURE__ */ y(
              fr,
              {
                id: "field-description",
                placeholder: "Enter field description",
                value: s,
                onChange: (f) => l(f.target.value)
              }
            )
          ] }),
          /* @__PURE__ */ y(
            Qe,
            {
              className: "w-full",
              onClick: u,
              variant: "default",
              disabled: !n || !i.trim() || !s.trim(),
              children: "Add"
            }
          )
        ] })
      }
    )
  ] });
}, Qpn = ({
  structuredOutputField: e,
  disabled: t
}) => {
  const n = e.value, r = Array.isArray(n) ? n : [], i = (s, l, c) => {
    const a = { displayName: l, description: c, type: s };
    e.onChange([...r ?? [], a]);
  }, o = (s) => {
    const l = r.filter((c) => c.displayName !== s);
    e.onChange(l);
  };
  return /* @__PURE__ */ V("div", { children: [
    /* @__PURE__ */ y("div", { className: "flex items-center justify-between mb-2", children: /* @__PURE__ */ y("h2", { className: "text-sm font-medium", children: Z("Structured Output") }) }),
    /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 mt-4", children: [
      r.length > 0 ? /* @__PURE__ */ y(YVe, { children: /* @__PURE__ */ y(JVe, { className: "px-2 py-2", children: /* @__PURE__ */ y("div", { className: "flex flex-col gap-3", children: r.map((s, l) => /* @__PURE__ */ y(
        "div",
        {
          className: "flex items-center justify-between",
          children: /* @__PURE__ */ V("div", { className: "grid grid-cols-12 gap-2 w-full items-center", children: [
            /* @__PURE__ */ y("div", { className: "col-span-1 flex items-center justify-center h-full", children: /* @__PURE__ */ y(MM, { type: s.type, className: "h-4 w-4" }) }),
            /* @__PURE__ */ V("div", { className: "col-span-10 flex flex-col justify-center", children: [
              /* @__PURE__ */ y("span", { className: "font-medium text-sm", children: s.displayName }),
              s.description && /* @__PURE__ */ y("span", { className: "text-xs text-muted-foreground", children: s.description })
            ] }),
            /* @__PURE__ */ y("div", { className: "col-span-1 flex items-center justify-end", children: /* @__PURE__ */ y(
              Qe,
              {
                variant: "ghost",
                size: "icon",
                onClick: () => o(s.displayName),
                disabled: t,
                children: /* @__PURE__ */ y(ks, { className: "h-4 w-4" })
              }
            ) })
          ] })
        },
        s.displayName + s.type + l
      )) }) }) }) : /* @__PURE__ */ y("div", { className: "text-muted-foreground text-sm", children: Z("No structured output fields yet.") }),
      /* @__PURE__ */ y(Hpn, { disabled: t, onAddField: i })
    ] })
  ] });
}, $pn = (e) => {
  const { pieceModel: t, updateFormSchema: n, updatePropertySettingsSchema: r } = rG(), i = _r();
  if (De(t))
    return /* @__PURE__ */ y("div", { className: "space-y-3", children: Array.from({ length: 5 }).map((c, a) => /* @__PURE__ */ V("div", { className: "space-y-2", children: [
      /* @__PURE__ */ V("div", { className: "flex justify-between items-center", children: [
        /* @__PURE__ */ y(Tr, { className: "w-40 h-4" }),
        /* @__PURE__ */ y(Tr, { className: "size-8" })
      ] }),
      /* @__PURE__ */ y(Tr, { className: "w-full h-12" })
    ] }, a)) });
  const o = e.step.settings.actionName, s = t.actions[o], l = (({ auth: c, ...a }) => a)(s.props);
  return /* @__PURE__ */ y("div", { className: "w-full", children: /* @__PURE__ */ y("div", { className: "flex flex-col gap-4 w-full", children: Object.keys(l).map((c) => /* @__PURE__ */ y(
    Zn,
    {
      name: `settings.input.${c}`,
      control: i.control,
      render: ({ field: a }) => Kpn({
        field: a,
        allowDynamicValues: !1,
        dynamicInputModeToggled: !1,
        markdownVariables: {},
        propertyName: c,
        inputName: `settings.input.${c}`,
        property: l[c],
        useMentionTextInput: !0,
        disabled: e.readonly,
        form: i,
        dynamicPropsInfo: {
          pieceName: e.step.settings.pieceName,
          pieceVersion: e.step.settings.pieceVersion,
          actionOrTriggerName: o,
          placedInside: "stepSettings",
          updateFormSchema: n,
          updatePropertySettingsSchema: r
        },
        propertySettings: null
      })
    },
    c
  )) }) });
}, Kpn = (e) => {
  const { propertyName: t, disabled: n, field: r } = e;
  switch (t) {
    case bO.AGENT_TOOLS:
      return /* @__PURE__ */ y(jpn, { disabled: n, toolsField: r });
    case bO.STRUCTURED_OUTPUT:
      return /* @__PURE__ */ y(
        Qpn,
        {
          disabled: n,
          structuredOutputField: r
        }
      );
    case bO.AI_PROVIDER_MODEL: {
      const i = r.value.provider, o = r.value.model;
      return /* @__PURE__ */ y(
        Vpn,
        {
          defaultModel: o,
          defaultProvider: i,
          onChange: r.onChange,
          disabled: n
        }
      );
    }
    default:
      return yee({
        ...e,
        enableMarkdownForInputWithMention: t === bO.PROMPT
      });
  }
}, Gpn = g.Object({
  packageName: g.String({
    minLength: 1,
    errorMessage: Z("The package name is required")
  })
}), eqe = ({ children: e, onAdd: t }) => {
  var l, c, a;
  const [n, r] = He(!1), i = Fg({
    defaultValues: {},
    resolver: VN(Gpn)
  }), { mutate: o, isPending: s } = dr({
    mutationFn: async () => {
      const { packageName: u } = i.getValues(), f = await dt.get(
        `https://registry.npmjs.org/${u}`
      );
      return {
        packageName: u,
        packageVersion: f["dist-tags"].latest
      };
    },
    onSuccess: (u) => {
      t(u), r(!1), vr.success(Z("Package added successfully"), {
        duration: 3e3
      });
    },
    onError: () => {
      i.setError("root.serverError", {
        message: Z("Could not fetch package version")
      });
    }
  });
  return /* @__PURE__ */ V(qa, { open: n, onOpenChange: (u) => r(u), children: [
    /* @__PURE__ */ y(z$, { asChild: !0, children: e }),
    /* @__PURE__ */ V(ia, { className: "sm:max-w-[425px]", children: [
      /* @__PURE__ */ V(Ds, { children: [
        /* @__PURE__ */ y(_s, { children: Z("Add NPM Package") }),
        /* @__PURE__ */ y(kb, { children: Z("Type the name of the npm package you want to add.") })
      ] }),
      /* @__PURE__ */ y(Ug, { ...i, children: /* @__PURE__ */ V(
        "form",
        {
          onSubmit: (u) => i.handleSubmit(() => o())(u),
          className: "flex flex-col gap-4",
          children: [
            /* @__PURE__ */ y(
              Zn,
              {
                control: i.control,
                name: "packageName",
                render: ({ field: u }) => /* @__PURE__ */ V(Jn, { children: [
                  /* @__PURE__ */ y(fg, { htmlFor: "packageName", children: Z("Package Name") }),
                  /* @__PURE__ */ y(
                    fr,
                    {
                      ...u,
                      id: "packageName",
                      type: "text",
                      placeholder: "hello-world",
                      className: "rounded-sm"
                    }
                  ),
                  /* @__PURE__ */ y(Ei, {})
                ] })
              }
            ),
            /* @__PURE__ */ y(rL, { children: Z("The latest version will be fetched and added") }),
            ((a = (c = (l = i == null ? void 0 : i.formState) == null ? void 0 : l.errors) == null ? void 0 : c.root) == null ? void 0 : a.serverError) && /* @__PURE__ */ y(Ei, { children: i.formState.errors.root.serverError.message })
          ]
        }
      ) }),
      /* @__PURE__ */ V(kl, { children: [
        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { type: "button", variant: "outline", children: Z("Cancel") }) }),
        /* @__PURE__ */ y(Qe, { type: "submit", loading: s, onClick: () => o(), children: Z("Add") })
      ] })
    ] })
  ] });
};
eqe.displayName = "AddNpmDialog";
const Ypn = kt.baseTheme({
  "&.cm-editor.cm-focused": {
    outline: "none"
  }
}), Jpn = ({
  sourceCode: e,
  readonly: t,
  onChange: n,
  applyCodeToCurrentStep: r,
  minHeight: i
}) => {
  const { code: o, packageJson: s } = e, [l, c] = He("code"), [a, u] = He("typescript"), f = typeof r == "function", d = Xe(null), p = localStorage.getItem("themeMode") === "dark" ? L_ : __, { data: h } = Go.useFlag(
    As.ALLOW_NPM_PACKAGES_IN_CODE_STEP
  ), m = [
    Ypn,
    $n.readOnly.of(t),
    kt.editable.of(!t),
    a === "json" ? e4e() : m2e({ jsx: !1, typescript: !0 })
  ];
  function v() {
    c("packageJson"), u("json");
  }
  function b() {
    c("code"), u("typescript");
  }
  function A({
    packageName: w,
    packageVersion: O
  }) {
    try {
      const x = hy(JSON.parse(s), {
        dependencies: {
          [w]: O
        }
      });
      c("packageJson"), n({ code: o, packageJson: JSON.stringify(x, null, 2) });
    } catch (x) {
      console.error(x), Kc();
    }
  }
  return /* @__PURE__ */ V(
    "div",
    {
      className: "flex flex-col gap-2 border rounded py-2 px-2 transition-all",
      ref: d,
      children: [
        /* @__PURE__ */ V("div", { className: "flex flex-row justify-center items-center h-full", children: [
          /* @__PURE__ */ V("div", { className: "flex justify-start gap-4 items-center", children: [
            /* @__PURE__ */ y(
              "div",
              {
                className: Se("text-sm cursor-pointer", {
                  "font-bold": l === "code"
                }),
                onClick: () => b(),
                children: Z("Code")
              }
            ),
            h && /* @__PURE__ */ y(
              "div",
              {
                className: Se("text-sm cursor-pointer", {
                  "font-bold": l === "packageJson"
                }),
                onClick: () => v(),
                children: Z("Dependencies")
              }
            )
          ] }),
          /* @__PURE__ */ y("div", { className: "flex grow" }),
          f ? /* @__PURE__ */ V(
            Qe,
            {
              variant: "outline",
              className: "flex gap-2",
              size: "sm",
              onClick: r,
              children: [
                /* @__PURE__ */ y(txe, { className: "w-3 h-3" }),
                Z("Use code")
              ]
            }
          ) : h && /* @__PURE__ */ y(eqe, { onAdd: A, children: /* @__PURE__ */ V(
            Qe,
            {
              variant: "outline",
              className: "flex gap-2",
              size: "sm",
              onClick: () => {
              },
              children: [
                /* @__PURE__ */ y(Cot, { className: "w-4 h-4" }),
                Z("Add package")
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ y(
          r3,
          {
            value: l === "code" ? o : s,
            className: "border-none",
            minHeight: i ?? "200px",
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            basicSetup: {
              foldGutter: !0,
              lineNumbers: !0,
              searchKeymap: !1,
              lintKeymap: !0,
              autocompletion: !0,
              foldKeymap: !0
            },
            lang: "typescript",
            onChange: (w) => {
              n(
                l === "code" ? { code: w, packageJson: s } : { code: o, packageJson: w }
              );
            },
            theme: p,
            readOnly: t,
            extensions: [...m, kt.lineWrapping]
          }
        )
      ]
    }
  );
}, ehn = "\nTo use data from previous steps in your code, include them as pairs of keys and values below. \n\nYou can access these inputs in your code using `inputs.key`, where `key` is the name you assigned below.  \n", thn = `
**const code** is the entry to the code. If it is removed or renamed, your step will fail.
`, tqe = ie.memo(({ readonly: e }) => {
  const t = _r();
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ y(
      Zn,
      {
        control: t.control,
        name: "settings.input",
        render: ({ field: n }) => /* @__PURE__ */ V(Jn, { children: [
          /* @__PURE__ */ y("div", { className: "pb-4", children: /* @__PURE__ */ y(uu, { markdown: ehn, variant: gs.INFO }) }),
          /* @__PURE__ */ y("div", { className: "flex items-center justify-between mb-2!", children: /* @__PURE__ */ y(ui, { children: Z("Inputs") }) }),
          /* @__PURE__ */ y(
            Xk,
            {
              disabled: e,
              values: n.value,
              onChange: n.onChange,
              useMentionTextInput: !0
            }
          ),
          /* @__PURE__ */ y(Ei, {})
        ] })
      }
    ),
    /* @__PURE__ */ y("div", { children: /* @__PURE__ */ y(
      uu,
      {
        markdown: thn,
        variant: gs.WARNING
      }
    ) }),
    /* @__PURE__ */ y(
      Zn,
      {
        control: t.control,
        name: "settings.sourceCode",
        render: ({ field: n }) => /* @__PURE__ */ V(Jn, { children: [
          /* @__PURE__ */ y(
            Jpn,
            {
              sourceCode: n.value,
              onChange: n.onChange,
              readonly: e
            }
          ),
          /* @__PURE__ */ y(Ei, {})
        ] })
      }
    )
  ] });
});
tqe.displayName = "CodeSettings";
const nhn = ({
  selectedBranchIndex: e,
  displayName: t,
  branchName: n,
  setDisplayName: r,
  setBranchName: i,
  readonly: o,
  isEditingStepOrBranchName: s,
  setIsEditingStepOrBranchName: l,
  setSelectedBranchIndex: c
}) => /* @__PURE__ */ V(pt, { children: [
  De(e) ? /* @__PURE__ */ y(
    Ik,
    {
      onValueChange: (a) => {
        a && r(a);
      },
      readonly: o,
      value: t,
      tooltipContent: o ? "" : Z("Edit Step Name"),
      isEditing: s,
      setIsEditing: l
    }
  ) : /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ y(
      "div",
      {
        className: "truncate cursor-pointer hover:underline",
        onClick: (a) => {
          a.stopPropagation(), c(null);
        },
        children: t
      }
    ),
    "/",
    /* @__PURE__ */ y(
      Ik,
      {
        onValueChange: (a) => {
          a && i(a);
        },
        readonly: o,
        value: n,
        tooltipContent: o ? "" : Z("Edit Branch Name"),
        isEditing: s,
        setIsEditing: l
      },
      n
    )
  ] }),
  !s && !o && /* @__PURE__ */ y(
    $A,
    {
      className: "h-4 w-4 shrink-0",
      onClick: () => {
        l(!0);
      }
    }
  )
] }), rhn = Z(
  `Select the items to iterate over from the previous step by clicking on the **Items** input, which should be a **list** of items.

The loop will iterate over each item in the list and execute the next step for every item.`
), nqe = ie.memo(({ readonly: e }) => {
  const t = _r();
  return /* @__PURE__ */ y(
    Zn,
    {
      control: t.control,
      name: "settings.items",
      render: ({ field: n }) => /* @__PURE__ */ V(Jn, { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ y(uu, { markdown: rhn }),
        /* @__PURE__ */ V(ui, { children: [
          Z("Items"),
          " ",
          /* @__PURE__ */ y("span", { className: "text-destructive", children: "*" })
        ] }),
        /* @__PURE__ */ y(
          bg,
          {
            disabled: e,
            onChange: n.onChange,
            initialValue: n.value,
            placeholder: Z("Select an array of items")
          }
        )
      ] })
    }
  );
});
nqe.displayName = "LoopsSettings";
function rqe(e) {
  var E, k;
  const [t, n] = He(!1), [r, i] = He(!1), [o, s] = He(null), { pieceModel: l, isLoading: c } = nd.usePiece({
    name: e.piece.name,
    version: (o == null ? void 0 : o.pieceVersion) ?? e.piece.version
  }), [a, u] = He(!1), [f, d] = He(null), p = _r(), h = yc().checkAccess(
    Es.WRITE_APP_CONNECTION
  ), m = qVe.useDeleteConnection(), {
    data: v,
    isLoading: b,
    refetch: A
  } = BVe.useAppConnections({
    request: {
      pieceName: e.piece.name,
      projectId: Rn.getProjectId(),
      limit: 1e3
    },
    pieceAuth: e.piece.auth,
    extraKeys: [e.piece.name, Rn.getProjectId()],
    staleTime: 0
  }), w = (E = v == null ? void 0 : v.data) == null ? void 0 : E.find(
    (T) => T.externalId === eO(p.getValues().settings.input.auth ?? "")
  ), O = (w == null ? void 0 : w.scope) === _u.PLATFORM, x = ((k = p.getValues().settings.propertySettings.auth) == null ? void 0 : k.type) === dc.DYNAMIC, S = SWt();
  return /* @__PURE__ */ y(
    Zn,
    {
      control: p.control,
      name: "settings.input.auth",
      render: ({ field: T }) => {
        var R, j, F, L, _, U, z;
        return /* @__PURE__ */ V(pt, { children: [
          (b || !l) && /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ V(ui, { children: [
              Z("Connection"),
              " ",
              /* @__PURE__ */ y("span", { className: "text-destructive", children: "*" })
            ] }),
            /* @__PURE__ */ y(
              vg,
              {
                options: [],
                disabled: !0,
                loading: b,
                placeholder: Z("Select a connection"),
                value: T.value,
                onChange: (C) => T.onChange(C),
                showDeselect: !1,
                onRefresh: () => {
                },
                showRefresh: !1
              }
            )
          ] }),
          !b && l && e.piece.auth && /* @__PURE__ */ V(
            ku,
            {
              property: e.piece.auth,
              propertyName: "auth",
              field: T,
              disabled: e.disabled,
              inputName: "settings.input.auth",
              allowDynamicValues: !e.isTrigger,
              dynamicInputModeToggled: x,
              isForConnectionSelect: !0,
              children: [
                /* @__PURE__ */ y(
                  wee,
                  {
                    reconnectConnection: o,
                    isGlobalConnection: O,
                    piece: l,
                    open: t,
                    setOpen: (C, I) => {
                      n(C), I && (A(), T.onChange(Gye(I.externalId)));
                    }
                  },
                  `CreateOrEditConnectionDialog-open-${t}`
                ),
                /* @__PURE__ */ V(
                  Cf,
                  {
                    open: r,
                    onOpenChange: i,
                    defaultValue: T.value,
                    onValueChange: T.onChange,
                    disabled: e.disabled,
                    children: [
                      /* @__PURE__ */ V("div", { className: "relative", children: [
                        T.value && !T.disabled && w && (!O || S) && /* @__PURE__ */ y("div", { className: "z-50 absolute right-8 top-2 ", children: /* @__PURE__ */ y(
                          tb,
                          {
                            hasPermission: h,
                            children: /* @__PURE__ */ y(
                              Qe,
                              {
                                variant: "ghost",
                                size: "xs",
                                loading: c,
                                onClick: (C) => {
                                  C.stopPropagation(), s(w), i(!1), n(!0);
                                },
                                disabled: !h,
                                children: Z("Reconnect")
                              }
                            )
                          }
                        ) }),
                        /* @__PURE__ */ V(sd, { className: "flex gap-2 items-center", children: [
                          /* @__PURE__ */ y(
                            Nf,
                            {
                              className: "truncate grow shrink",
                              placeholder: Z("Select a connection"),
                              "data-testid": "select-connection-value",
                              children: !De(T.value) && !De(
                                (R = v == null ? void 0 : v.data) == null ? void 0 : R.find(
                                  (C) => C.externalId === eO(T.value)
                                )
                              ) ? /* @__PURE__ */ V("div", { className: "truncate grow shrink flex items-center gap-2", children: [
                                ((F = (j = v == null ? void 0 : v.data) == null ? void 0 : j.find(
                                  (C) => C.externalId === eO(T.value)
                                )) == null ? void 0 : F.scope) === _u.PLATFORM && /* @__PURE__ */ y(Gre, { size: 16, className: "shrink-0" }),
                                (_ = (L = v == null ? void 0 : v.data) == null ? void 0 : L.find(
                                  (C) => C.externalId === eO(T.value)
                                )) == null ? void 0 : _.displayName
                              ] }) : null
                            }
                          ),
                          /* @__PURE__ */ y("div", { className: "grow" }),
                          T.value && ((U = v == null ? void 0 : v.data) == null ? void 0 : U.find(
                            (C) => C.externalId === eO(T.value) && C.scope !== _u.PLATFORM
                          )) && /* @__PURE__ */ y(
                            "span",
                            {
                              role: "button",
                              className: "z-50 opacity-0 pointer-events-none",
                              children: Z("Reconnect")
                            }
                          )
                        ] })
                      ] }),
                      /* @__PURE__ */ V(ad, { children: [
                        /* @__PURE__ */ y(
                          tb,
                          {
                            hasPermission: h,
                            children: /* @__PURE__ */ y(
                              j3e,
                              {
                                onClick: () => {
                                  i(!1), s(null), n(!0);
                                },
                                disabled: !h,
                                children: /* @__PURE__ */ V(
                                  "span",
                                  {
                                    className: Se(
                                      "flex items-center gap-1 text-primary w-full",
                                      {
                                        "text-muted-foreground cursor-not-allowed": !h
                                      }
                                    ),
                                    children: [
                                      /* @__PURE__ */ y(Da, { size: 16 }),
                                      Z("Create Connection")
                                    ]
                                  }
                                )
                              }
                            )
                          }
                        ),
                        v && v.data && ((z = v.data) == null ? void 0 : z.map((C) => {
                          const I = C.scope !== _u.PLATFORM;
                          return /* @__PURE__ */ V(
                            "div",
                            {
                              className: "relative flex items-center group",
                              children: [
                                /* @__PURE__ */ y(
                                  Ti,
                                  {
                                    value: Gye(C.externalId),
                                    children: /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
                                      C.scope === _u.PLATFORM && /* @__PURE__ */ y(Gre, { size: 16, className: "shrink-0" }),
                                      C.displayName
                                    ] })
                                  },
                                  C.externalId
                                ),
                                I && /* @__PURE__ */ y(
                                  Qe,
                                  {
                                    variant: "ghost",
                                    size: "xs",
                                    className: "absolute right-2 z-10 h-6 w-6 p-0",
                                    onClick: (M) => {
                                      M.stopPropagation(), M.preventDefault(), d(C), u(!0);
                                    },
                                    children: /* @__PURE__ */ y(oxe, { size: 14, className: "text-red-500" })
                                  }
                                )
                              ]
                            },
                            C.externalId
                          );
                        }))
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ y(
                  qa,
                  {
                    open: a,
                    onOpenChange: u,
                    children: /* @__PURE__ */ V(ia, { children: [
                      /* @__PURE__ */ V(Ds, { children: [
                        /* @__PURE__ */ y(_s, { children: Z("Are you sure?") }),
                        /* @__PURE__ */ V(kb, { children: [
                          Z("This will permanently delete the connection"),
                          " ",
                          /* @__PURE__ */ y("span", { className: "font-semibold", children: f == null ? void 0 : f.displayName })
                        ] })
                      ] }),
                      /* @__PURE__ */ V(kl, { className: "justify-end", children: [
                        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(Qe, { variant: "outline", children: Z("Cancel") }) }),
                        /* @__PURE__ */ y(fh, { asChild: !0, children: /* @__PURE__ */ y(
                          Qe,
                          {
                            variant: "destructive",
                            disabled: m.isPending,
                            onClick: async () => {
                              f && (await m.mutateAsync(
                                f.id
                              ), d(null), eO(T.value) === f.externalId && T.onChange(""), A());
                            },
                            children: Z("Confirm")
                          }
                        ) })
                      ] })
                    ] })
                  }
                )
              ]
            }
          )
        ] });
      }
    },
    p.getValues().settings.input.auth
  );
}
rqe.displayName = "ConnectionSelect";
function Gye(e) {
  return `{{connections['${e}']}}`;
}
function eO(e) {
  if (!De(e))
    return e.replace(
      /\{\{connections\['(.*?)'\]\}\}/g,
      (t, n) => n
    );
}
const Yye = (e) => {
  const { auth: t, ...n } = e;
  return n;
}, tW = ie.memo((e) => {
  const {
    pieceModel: t,
    selectedStep: n,
    updateFormSchema: r,
    updatePropertySettingsSchema: i
  } = rG(), o = e.step.settings.actionName, s = o ? t == null ? void 0 : t.actions[o] : void 0, l = e.step.settings.triggerName, c = l ? t == null ? void 0 : t.triggers[l] : void 0, a = Yye(
    (s == null ? void 0 : s.props) ?? {}
  ), u = Yye(
    (c == null ? void 0 : c.props) ?? {}
  ), { data: f } = Go.useFlag(
    As.WEBHOOK_URL_PREFIX
  ), { data: d } = Go.useFlag(
    As.PAUSED_FLOW_TIMEOUT_DAYS
  ), { data: p } = Go.useFlag(
    As.WEBHOOK_TIMEOUT_SECONDS
  ), { data: h } = Go.useFlag(As.PUBLIC_URL), m = {
    webhookUrl: `${f ?? `${kv}/webhooks`}/${e.flowId}`,
    formUrl: `${h}forms/${e.flowId}`,
    chatUrl: `${h}chats/${e.flowId}`,
    pausedFlowTimeoutDays: (d == null ? void 0 : d.toString()) ?? "",
    webhookTimeoutSeconds: (p == null ? void 0 : p.toString()) ?? ""
  }, v = !De(s) && (s.requireAuth ?? !0), b = !De(c) && (c.requireAuth ?? !0);
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-4 w-full", children: [
    !t && /* @__PURE__ */ y("div", { className: "space-y-3", children: Array.from({ length: 5 }).map((A, w) => /* @__PURE__ */ V("div", { className: "space-y-2", children: [
      /* @__PURE__ */ V("div", { className: "flex justify-between items-center", children: [
        /* @__PURE__ */ y(Tr, { className: "w-40 h-4" }),
        /* @__PURE__ */ y(Tr, { className: "size-8" })
      ] }),
      /* @__PURE__ */ y(Tr, { className: "w-full h-12" })
    ] }, w)) }),
    t && /* @__PURE__ */ V(pt, { children: [
      t.auth && (v || b) && /* @__PURE__ */ y(
        rqe,
        {
          isTrigger: !De(c),
          piece: t,
          disabled: e.readonly
        }
      ),
      s && /* @__PURE__ */ y(
        bh,
        {
          prefixValue: "settings.input",
          props: a,
          propertySettings: n.settings.propertySettings,
          disabled: e.readonly,
          useMentionTextInput: !0,
          markdownVariables: m,
          dynamicPropsInfo: {
            pieceName: t.name,
            pieceVersion: t.version,
            actionOrTriggerName: s.name,
            placedInside: "stepSettings",
            updateFormSchema: r,
            updatePropertySettingsSchema: i
          }
        },
        s.name
      ),
      c && /* @__PURE__ */ y(
        bh,
        {
          dynamicPropsInfo: {
            pieceName: t.name,
            pieceVersion: t.version,
            actionOrTriggerName: c.name,
            placedInside: "stepSettings",
            updateFormSchema: r,
            updatePropertySettingsSchema: i
          },
          prefixValue: "settings.input",
          props: u,
          useMentionTextInput: !1,
          propertySettings: n.settings.propertySettings,
          disabled: e.readonly,
          markdownVariables: m
        },
        c.name
      )
    ] })
  ] });
});
tW.displayName = "PieceSettings";
const iqe = Ri({
  height: 50,
  setHeight: () => {
  }
}), ihn = ({
  children: e
}) => {
  const [t] = tn((i) => [!De(i.run)]), [n, r] = He(t ? 65 : 40);
  return /* @__PURE__ */ y(iqe.Provider, { value: { height: n, setHeight: r }, children: e });
}, ohn = () => kr(iqe), nW = (e) => /* @__PURE__ */ V("div", { className: "flex gap-2 text-center justify-end", children: [
  e.showAnd && /* @__PURE__ */ y(
    Qe,
    {
      variant: "basic",
      size: "sm",
      onClick: e.onAnd,
      disabled: e.readonly,
      children: Z("+ And")
    }
  ),
  e.showOr && /* @__PURE__ */ y(
    Qe,
    {
      variant: "basic",
      size: "sm",
      onClick: e.onOr,
      disabled: e.readonly,
      children: Z("+ Or")
    }
  )
] });
nW.displayName = "BranchConditionToolbar";
const Jye = {
  [Gr.TEXT_CONTAINS]: Z("(Text) Contains"),
  [Gr.TEXT_DOES_NOT_CONTAIN]: Z("(Text) Does not contain"),
  [Gr.TEXT_EXACTLY_MATCHES]: Z("(Text) Exactly matches"),
  [Gr.TEXT_DOES_NOT_EXACTLY_MATCH]: Z(
    "(Text) Does not exactly match"
  ),
  [Gr.TEXT_STARTS_WITH]: Z("(Text) Starts with"),
  [Gr.TEXT_DOES_NOT_START_WITH]: Z("(Text) Does not start with"),
  [Gr.TEXT_ENDS_WITH]: Z("(Text) Ends with"),
  [Gr.TEXT_DOES_NOT_END_WITH]: Z("(Text) Does not end with"),
  [Gr.LIST_CONTAINS]: Z("(List) Contains"),
  [Gr.LIST_DOES_NOT_CONTAIN]: Z("(List) Does not contain"),
  [Gr.NUMBER_IS_GREATER_THAN]: Z("(Number) Is greater than"),
  [Gr.NUMBER_IS_LESS_THAN]: Z("(Number) Is less than"),
  [Gr.NUMBER_IS_EQUAL_TO]: Z("(Number) Is equal to"),
  [Gr.DATE_IS_AFTER]: Z("(Date/time) After"),
  [Gr.DATE_IS_BEFORE]: Z("(Date/time) Before"),
  [Gr.DATE_IS_EQUAL]: Z("(Date/time) Equals"),
  [Gr.BOOLEAN_IS_TRUE]: Z("(Boolean) Is true"),
  [Gr.BOOLEAN_IS_FALSE]: Z("(Boolean) Is false"),
  [Gr.LIST_IS_EMPTY]: Z("(List) Is empty"),
  [Gr.LIST_IS_NOT_EMPTY]: Z("(List) Is not empty"),
  [Gr.EXISTS]: Z("Exists"),
  [Gr.DOES_NOT_EXIST]: Z("Does not exist")
}, shn = Object.keys(Jye).map((e) => ({
  label: Jye[e],
  value: e
})), oqe = ({
  deleteClick: e,
  groupIndex: t,
  conditionIndex: n,
  showDelete: r,
  readonly: i,
  branchIndex: o
}) => {
  var f;
  const s = _r(), l = s.getValues(
    `settings.branches.${o}.conditions.${t}.${n}`
  ), c = l.operator && l0e.includes(l == null ? void 0 : l.operator), a = l.operator && Mq.includes(l == null ? void 0 : l.operator), u = a ? l.firstValue.length === 0 : l.firstValue.length === 0 || "secondValue" in l && ((f = l.secondValue) == null ? void 0 : f.length) === 0;
  return /* @__PURE__ */ V(pt, { children: [
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      u && /* @__PURE__ */ V(wn, { children: [
        /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(QK, { className: "h-4 w-4 shrink-0" }) }),
        /* @__PURE__ */ y(An, { side: "bottom", children: Z("Incomplete condition") })
      ] }),
      /* @__PURE__ */ V(
        "div",
        {
          className: Se("grid gap-2 grow", {
            "grid-cols-2": a,
            "grid-cols-3": !a
          }),
          children: [
            /* @__PURE__ */ y(
              Zn,
              {
                name: `settings.branches.${o}.conditions.${t}.${n}.firstValue`,
                control: s.control,
                render: ({ field: d }) => /* @__PURE__ */ V(Jn, { children: [
                  /* @__PURE__ */ y(
                    bg,
                    {
                      disabled: i,
                      placeholder: Z("First value"),
                      onChange: (p) => {
                        d.onChange(p), s.trigger();
                      },
                      initialValue: d.value
                    }
                  ),
                  /* @__PURE__ */ y(Ei, {})
                ] })
              }
            ),
            /* @__PURE__ */ y(
              Zn,
              {
                name: `settings.branches.${o}.conditions.${t}.${n}.operator`,
                control: s.control,
                render: ({ field: d }) => /* @__PURE__ */ V(Jn, { children: [
                  /* @__PURE__ */ y(
                    vg,
                    {
                      disabled: i,
                      value: d.value,
                      options: shn,
                      placeholder: "",
                      onChange: (p) => {
                        a && p !== null && !Mq.includes(p) && s.setValue(
                          `settings.branches.${o}.conditions.${t}.${n}.secondValue`,
                          ""
                        ), d.onChange(p), s.trigger();
                      }
                    }
                  ),
                  /* @__PURE__ */ y(Ei, {})
                ] })
              }
            ),
            !a && /* @__PURE__ */ y(
              Zn,
              {
                name: `settings.branches.${o}.conditions.${t}.${n}.secondValue`,
                control: s.control,
                render: ({ field: d }) => /* @__PURE__ */ V(Jn, { children: [
                  /* @__PURE__ */ y(
                    bg,
                    {
                      placeholder: Z("Second value"),
                      disabled: i,
                      initialValue: d.value || "",
                      onChange: (p) => {
                        d.onChange(p), s.trigger();
                      }
                    }
                  ),
                  /* @__PURE__ */ y(Ei, {})
                ] })
              }
            )
          ]
        }
      )
    ] }),
    /* @__PURE__ */ V("div", { className: "flex justify-start items-center gap-2 mt-2", children: [
      c && /* @__PURE__ */ y(
        Zn,
        {
          name: `settings.branches.${o}.conditions.${t}.${n}.caseSensitive`,
          control: s.control,
          render: ({ field: d }) => /* @__PURE__ */ V(Jn, { children: [
            /* @__PURE__ */ V("div", { className: "flex items-center gap-2 p-1", children: [
              /* @__PURE__ */ y(
                Iw,
                {
                  disabled: i,
                  id: "case-sensitive",
                  checked: d.value,
                  onCheckedChange: (p) => d.onChange(p)
                }
              ),
              /* @__PURE__ */ y(fg, { htmlFor: "case-sensitive", children: Z("Case sensitive") })
            ] }),
            /* @__PURE__ */ y(Ei, {})
          ] })
        }
      ),
      /* @__PURE__ */ y("div", { className: "grow" }),
      /* @__PURE__ */ y("div", { children: r && /* @__PURE__ */ V(
        Qe,
        {
          variant: "basic",
          className: "text-destructive gap-2 items-center",
          size: "sm",
          onClick: e,
          children: [
            /* @__PURE__ */ y(xb, { className: "w-4 h-4" }),
            " ",
            Z("Remove")
          ]
        }
      ) })
    ] })
  ] });
};
oqe.displayName = "BranchSingleCondition";
const sqe = ie.memo(
  ({
    readonly: e,
    groupIndex: t,
    onAnd: n,
    onOr: r,
    handleDelete: i,
    numberOfGroups: o,
    branchIndex: s
  }) => {
    const l = _r(), { fields: c } = zY({
      control: l.control,
      name: `settings.branches.${s}.conditions.${t}`
    });
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", children: [
      t > 0 && /* @__PURE__ */ y(Yxe, { className: "my-2", children: Z("OR") }),
      c.length === 0 && /* @__PURE__ */ y(
        nW,
        {
          readonly: e,
          onAnd: n,
          onOr: r,
          showOr: !0,
          showAnd: !0
        },
        `toolbar-${t}`
      ),
      c.map((a, u) => /* @__PURE__ */ V(ie.Fragment, { children: [
        u > 0 && /* @__PURE__ */ y("div", { children: Z("And If") }),
        /* @__PURE__ */ y(
          oqe,
          {
            groupIndex: t,
            readonly: e,
            conditionIndex: u,
            deleteClick: () => i(u),
            showDelete: o !== 1 || c.length !== 1,
            branchIndex: s
          }
        )
      ] }, a.id)),
      /* @__PURE__ */ y(
        nW,
        {
          onAnd: n,
          onOr: r,
          readonly: e,
          showOr: !0,
          showAnd: !0
        }
      )
    ] });
  }
);
sqe.displayName = "ConditionGroup";
const aqe = ie.memo(
  ({ readonly: e, branchIndex: t }) => {
    const n = _r(), { fields: r, append: i, remove: o, update: s } = zY({
      control: n.control,
      name: `settings.branches.${t}.conditions`
    }), l = (u, f) => {
      const d = n.getValues(
        `settings.branches.${t}.conditions`
      ), p = [...d[u]], h = d.length === 1, m = p.length === 1;
      h && m ? s(u, [vE]) : m ? o(u) : (p.splice(f, 1), s(u, p));
    }, c = (u) => {
      const f = n.getValues(
        `settings.branches.${t}.conditions`
      );
      f[u] = [...f[u], vE], s(u, f[u]);
    }, a = () => {
      i([[vE]]);
    };
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-4", onSubmit: (u) => u.preventDefault(), children: [
      /* @__PURE__ */ y("div", { className: "text-md ", children: Z("Execute If") }),
      r.map((u, f) => /* @__PURE__ */ y(
        sqe,
        {
          readonly: e,
          branchIndex: t,
          numberOfGroups: r.length,
          groupIndex: f,
          onAnd: () => c(f),
          onOr: a,
          handleDelete: (d) => l(f, d)
        },
        u.id
      ))
    ] });
  }
);
aqe.displayName = "BranchSettings";
const ahn = ({
  step: e,
  setSelectedBranchIndex: t,
  errors: n,
  duplicateBranch: r,
  deleteBranch: i,
  readonly: o,
  branchNameChanged: s,
  moveBranch: l
}) => {
  const [c, a] = He(null), u = _r(), f = e.settings.branches ?? [];
  return /* @__PURE__ */ y(
    sVe,
    {
      value: f.map((d, p) => ({
        id: p + 1,
        branch: d
      })),
      onMove: ({ activeIndex: d, overIndex: p }) => {
        l({ sourceIndex: d, targetIndex: p });
      },
      children: f.map(
        (d, p) => d.branchType === iu.FALLBACK ? /* @__PURE__ */ y(ie.Fragment, {}, p) : /* @__PURE__ */ y(H3, { value: p + 1, asChild: !0, children: /* @__PURE__ */ V("div", { children: [
          /* @__PURE__ */ y(
            lhn,
            {
              branch: d,
              branchIndex: p,
              readonly: o,
              onClick: () => {
                t(p);
              },
              errors: n,
              duplicateBranch: () => {
                r(p), u.trigger();
              },
              deleteBranch: () => {
                i(p), u.trigger();
              },
              isEditingBranchName: c === p,
              setIsEditingBranchName: (h) => a(h ? p : null),
              branchNameChanged: (h) => {
                s(p, h);
              },
              showDeleteButton: f.length > 2
            }
          ),
          p === f.length - 2 ? null : /* @__PURE__ */ y(Eh, {})
        ] }) }, p)
      )
    }
  );
}, lhn = ({
  branch: e,
  branchIndex: t,
  readonly: n,
  onClick: r,
  errors: i,
  duplicateBranch: o,
  deleteBranch: s,
  isEditingBranchName: l,
  setIsEditingBranchName: c,
  branchNameChanged: a,
  showDeleteButton: u
}) => /* @__PURE__ */ V(
  "div",
  {
    className: "flex items-center gap-2 hover:transition-colors   has-[div.button-group:hover]:bg-background  text-sm hover:bg-gray-100 dark:hover:bg-accent px-2 cursor-pointer",
    onClick: () => {
      r();
    },
    children: [
      /* @__PURE__ */ y(
        Ik,
        {
          readonly: n,
          value: e.branchName,
          onValueChange: (f) => {
            f && a(f);
          },
          isEditing: l,
          setIsEditing: c,
          disallowEditingOnClick: !0
        },
        e.branchName + t
      ),
      !De(i[t]) && /* @__PURE__ */ y("div", { className: "min-w-[16px]", children: /* @__PURE__ */ V(wn, { children: [
        /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(QK, { className: "h-4 w-4 shrink-0" }) }),
        /* @__PURE__ */ y(An, { side: "bottom", children: Z("Incomplete settings") })
      ] }) }),
      /* @__PURE__ */ y("div", { className: "grow" }),
      /* @__PURE__ */ V(
        "div",
        {
          className: Se("flex gap-2 py-3 items-center button-group", {
            "pointer-events-none": n,
            "opacity-0": n
          }),
          children: [
            u && /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  size: "icon",
                  onClick: (f) => {
                    f.stopPropagation(), s();
                  },
                  children: /* @__PURE__ */ y(xb, { className: "w-4 h-4 stroke-destructive" })
                }
              ) }),
              /* @__PURE__ */ y(An, { side: "bottom", children: Z("Delete") })
            ] }),
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  size: "icon",
                  onClick: (f) => {
                    f.stopPropagation(), c(!0);
                  },
                  children: /* @__PURE__ */ y($A, { className: "h-4 w-4" })
                }
              ) }),
              /* @__PURE__ */ y(An, { side: "bottom", children: Z("Rename") })
            ] }),
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                Qe,
                {
                  variant: "ghost",
                  size: "icon",
                  onClick: (f) => {
                    f.stopPropagation(), o();
                  },
                  children: /* @__PURE__ */ y($H, { className: "h-4 w-4" })
                }
              ) }),
              /* @__PURE__ */ y(An, { side: "bottom", children: Z("Duplicate") })
            ] }),
            /* @__PURE__ */ V(wn, { children: [
              /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
                mee,
                {
                  variant: "ghost",
                  size: "icon",
                  disabled: n,
                  className: "shrink-0 size-7",
                  children: /* @__PURE__ */ y(fMe, { className: "size-4", "aria-hidden": "true" })
                }
              ) }),
              /* @__PURE__ */ y(An, { side: "bottom", children: Z("Move") })
            ] })
          ]
        }
      )
    ]
  }
), chn = ({
  addButtonClicked: e
}) => /* @__PURE__ */ y("div", { className: "flex items-center gap-2 justify-end mb-2", children: /* @__PURE__ */ V(
  Qe,
  {
    variant: "basic",
    className: "gap-1 items-center",
    onClick: e,
    children: [
      /* @__PURE__ */ y(Da, { className: "w-4 h-4" }),
      Z("Add Branch")
    ]
  }
) }), lqe = Ji(({ readonly: e }) => {
  var A;
  const [
    t,
    n,
    r,
    i,
    o,
    s
  ] = tn((w) => [
    At.getActionOrThrow(
      w.selectedStep,
      w.flowVersion.trigger
    ),
    w.applyOperation,
    w.setSelectedBranchIndex,
    w.selectedBranchIndex,
    w.addOperationListener,
    w.removeOperationListener
  ]), { fitView: l } = yd(), c = t.settings.branches ?? [], a = t.children ?? [], { control: u, setValue: f, formState: d } = _r(), { insert: p, remove: h, move: m } = zY({
    control: u,
    name: "settings.branches"
  }), v = _r(), b = (w) => {
    n({
      type: Tt.DELETE_BRANCH,
      request: {
        stepName: t.name,
        branchIndex: w
      }
    }), r(null), l(Na.createFocusStepInGraphParams(t.name));
  };
  return nt(() => {
    const w = (O, x) => {
      var S;
      switch (x.type) {
        case Tt.DELETE_BRANCH: {
          if (x.request.stepName !== t.name)
            return;
          h(x.request.branchIndex);
          break;
        }
        case Tt.DUPLICATE_BRANCH:
        case Tt.ADD_BRANCH: {
          if (x.request.stepName !== t.name) return;
          const E = At.getActionOrThrow(
            x.request.stepName,
            O.trigger
          );
          if (E.type !== qe.ROUTER) {
            console.error(
              `Trying to duplicate a branch on a none router step! ${x.request.stepName}`
            );
            return;
          }
          const k = (S = E.settings.branches) == null ? void 0 : S[x.request.branchIndex];
          if (!k)
            return;
          x.type === Tt.DUPLICATE_BRANCH ? p(x.request.branchIndex + 1, {
            ...k,
            branchName: `${k.branchName} Copy`
          }) : p(
            E.settings.branches.length - 1,
            At.createBranch(
              `Branch ${E.settings.branches.length}`,
              void 0
            )
          ), v.trigger();
          break;
        }
        case Tt.MOVE_BRANCH: {
          if (x.request.stepName !== t.name) return;
          m(
            x.request.sourceBranchIndex,
            x.request.targetBranchIndex
          );
          break;
        }
      }
    };
    return o(w), () => s(w);
  }, []), /* @__PURE__ */ V(pt, { children: [
    De(i) && /* @__PURE__ */ y(
      Zn,
      {
        control: u,
        name: "settings.executionType",
        render: ({ field: w }) => /* @__PURE__ */ V(Jn, { children: [
          /* @__PURE__ */ y(fg, { children: Z("Execute") }),
          /* @__PURE__ */ V(
            Cf,
            {
              disabled: w.disabled,
              onValueChange: w.onChange,
              value: w.value,
              children: [
                /* @__PURE__ */ y(sd, { children: /* @__PURE__ */ y(Nf, { placeholder: Z("Execute") }) }),
                /* @__PURE__ */ V(ad, { children: [
                  /* @__PURE__ */ y(
                    Ti,
                    {
                      value: `${ah.EXECUTE_FIRST_MATCH}`,
                      children: Z("Only the first (left) matching branch")
                    }
                  ),
                  /* @__PURE__ */ y(
                    Ti,
                    {
                      value: `${ah.EXECUTE_ALL_MATCH}`,
                      children: Z("All matching paths from left to right")
                    }
                  )
                ] })
              ]
            }
          )
        ] })
      }
    ),
    De(i) && /* @__PURE__ */ V("div", { className: "mt-4", children: [
      /* @__PURE__ */ V("div", { className: "flex gap-2 mb-2 items-center", children: [
        /* @__PURE__ */ y(Jot, { className: "w-4 h-4 rotate-180" }),
        /* @__PURE__ */ y(fg, { children: Z("Branches") })
      ] }),
      /* @__PURE__ */ y(
        ahn,
        {
          errors: ((A = d.errors.settings) == null ? void 0 : A.branches) ?? [],
          readonly: e,
          step: t,
          branchNameChanged: (w, O) => {
            f(`settings.branches.${w}.branchName`, O, {
              shouldValidate: !0
            });
          },
          deleteBranch: b,
          moveBranch: ({ sourceIndex: w, targetIndex: O }) => {
            n({
              type: Tt.MOVE_BRANCH,
              request: {
                stepName: t.name,
                sourceBranchIndex: w,
                targetBranchIndex: O
              }
            });
          },
          duplicateBranch: (w) => {
            n({
              type: Tt.DUPLICATE_BRANCH,
              request: {
                stepName: t.name,
                branchIndex: w
              }
            }), r(w + 1);
          },
          setSelectedBranchIndex: (w) => {
            r(w), a[w] ? l(
              Na.createFocusStepInGraphParams(
                a[w].name
              )
            ) : l(
              Na.createFocusStepInGraphParams(
                `${t.name}-big-add-button-${t.name}-branch-${w}-start-edge`
              )
            );
          }
        }
      ),
      !e && /* @__PURE__ */ y("div", { className: "mt-2", children: /* @__PURE__ */ y(
        chn,
        {
          addButtonClicked: () => {
            n({
              type: Tt.ADD_BRANCH,
              request: {
                stepName: t.name,
                branchIndex: Math.max(0, c.length - 1),
                branchName: `Branch ${Math.max(1, c.length)}`
              }
            }), r(Math.max(0, c.length - 1));
          }
        }
      ) })
    ] }),
    !De(i) && /* @__PURE__ */ y(
      aqe,
      {
        readonly: e,
        branchIndex: i
      },
      `settings.branches[${i}].conditions`
    )
  ] });
});
lqe.displayName = "RouterSettings";
const uhn = ({ step: e }) => {
  const { stepMetadata: t } = vd.useStepMetadata({
    step: e
  }), r = (t == null ? void 0 : t.type) === qe.PIECE || (t == null ? void 0 : t.type) === Bt.PIECE ? t == null ? void 0 : t.pieceVersion : void 0, i = t == null ? void 0 : t.actionOrTriggerOrAgentDisplayName;
  return /* @__PURE__ */ V("div", { className: "flex items-center justify-between gap-1", children: [
    /* @__PURE__ */ y(eve, { isNext: !1 }),
    /* @__PURE__ */ V("div", { className: "flex grow items-center justify-between gap-3 min-h-[36px]", children: [
      /* @__PURE__ */ V("div", { className: "flex items-center gap-2 min-w-0", children: [
        /* @__PURE__ */ y(
          Ig,
          {
            logoUrl: t == null ? void 0 : t.logoUrl,
            displayName: t == null ? void 0 : t.displayName,
            showTooltip: !1,
            size: "md"
          }
        ),
        /* @__PURE__ */ y("div", { className: "flex items-center gap-0.5 min-w-0 text-sm", children: De(t == null ? void 0 : t.displayName) ? /* @__PURE__ */ y(Tr, { className: "h-4 w-32 rounded" }) : /* @__PURE__ */ V(pt, { children: [
          /* @__PURE__ */ y(
            "span",
            {
              className: i ? "text-muted-foreground" : "text-foreground font-medium",
              children: t.displayName
            }
          ),
          i && /* @__PURE__ */ V(pt, { children: [
            /* @__PURE__ */ y(HC, { className: "size-4 text-muted-foreground shrink-0 rtl:rotate-180" }),
            /* @__PURE__ */ y(
              Fj,
              {
                tooltipMessage: i,
                children: /* @__PURE__ */ y("span", { className: "font-medium text-foreground", children: i })
              }
            )
          ] })
        ] }) }),
        !De(t == null ? void 0 : t.actionOrTriggerOrAgentDescription) && t.actionOrTriggerOrAgentDescription.length > 0 && /* @__PURE__ */ V(wn, { children: [
          /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(QA, { className: "size-4 text-muted-foreground shrink-0 cursor-help" }) }),
          /* @__PURE__ */ y(An, { side: "bottom", className: "max-w-xs", children: t.actionOrTriggerOrAgentDescription })
        ] })
      ] }),
      r && /* @__PURE__ */ V("div", { className: "text-xs text-muted-foreground shrink-0", children: [
        "v",
        r
      ] })
    ] }),
    /* @__PURE__ */ y(eve, { isNext: !0 })
  ] });
}, eve = ({ isNext: e }) => {
  const [t, n, r] = tn(
    (a) => [a.selectedStep, a.selectStepByName, a.flowVersion]
  ), i = At.getAllSteps(r.trigger), o = i.findIndex(
    (a) => a.name === t
  ), s = i.at(o + 1), l = o > 0 ? i.at(o - 1) : void 0;
  return /* @__PURE__ */ V(wn, { children: [
    /* @__PURE__ */ y(kn, { asChild: !0, children: /* @__PURE__ */ y(
      Qe,
      {
        variant: "ghost",
        disabled: !e && !l || e && !s,
        onClick: (a) => {
          a.preventDefault(), a.stopPropagation(), e && s ? n(s.name) : !e && l && n(l.name);
        },
        size: "icon",
        className: "size-7",
        children: e ? /* @__PURE__ */ y(HC, { className: "size-4 rtl:rotate-180" }) : /* @__PURE__ */ y(sv, { className: "size-4 rtl:rotate-180" })
      }
    ) }),
    !(!e && !l || e && !s) && /* @__PURE__ */ y(An, { side: "bottom", children: Z(e ? "Next step" : "Previous step") })
  ] });
}, cqe = () => {
  var T, R, j, F, L, _;
  const { selectedStep: e, pieceModel: t, formSchema: n } = rG(), { project: r } = bJ.useCurrentProject(), [
    i,
    o,
    s,
    l,
    c,
    a,
    u,
    f
  ] = tn((U) => [
    U.readonly,
    U.exitStepSettings,
    U.applyOperation,
    U.saving,
    U.flowVersion,
    U.selectedBranchIndex,
    U.setSelectedBranchIndex,
    U.run
  ]), { stepMetadata: d } = vd.useStepMetadata({
    step: e
  }), p = Xe(e), h = Fg({
    mode: "all",
    disabled: i,
    reValidateMode: "onChange",
    defaultValues: e,
    resolver: async (U, z, C) => {
      const I = await VN(n)(
        U,
        z,
        C
      ), M = Bc.removeUndefinedFromInput(U), D = Bc.removeUndefinedFromInput(
        p.current
      );
      if (M.type === Bt.EMPTY || De(t) && (M.type === qe.PIECE || M.type === Bt.PIECE))
        return I;
      const X = Object.keys(I.errors).length === 0, B = !qg(M, D), q = D.valid !== X;
      return !B && !q || (p.current = JSON.parse(
        JSON.stringify({
          ...M,
          valid: X
        })
      ), M.type === Bt.PIECE ? s({
        type: Tt.UPDATE_TRIGGER,
        request: {
          ...M,
          valid: X
        }
      }) : s({
        type: Tt.UPDATE_ACTION,
        request: {
          ...M,
          valid: X
        }
      })), I;
    }
  }), m = Xe(null), v = h.getValues(), b = !i, A = !De(f), [w, O] = He(!1), x = [qe.CODE, qe.PIECE].includes(
    v.type
  ) && !De(d), S = v.settings.pieceName === "@activepieces/piece-ai" && v.settings.actionName === "run_agent";
  nt(() => {
    h.trigger();
  }, []), nt(() => {
    p.current = e, h.reset(e), e.type !== qe.ROUTER && u(null);
  }, [h, e, u]);
  const { height: E, setHeight: k } = ohn();
  return /* @__PURE__ */ y(Ug, { ...h, children: /* @__PURE__ */ V(
    "form",
    {
      onSubmit: (U) => U.preventDefault(),
      onChange: (U) => U.preventDefault(),
      className: "w-full h-full",
      children: [
        /* @__PURE__ */ y("div", { ref: m, children: /* @__PURE__ */ y(KY, { onClose: () => o(), children: /* @__PURE__ */ y(
          nhn,
          {
            selectedBranchIndex: a,
            setDisplayName: (U) => {
              h.setValue("displayName", U, {
                shouldValidate: !0
              });
            },
            readonly: i,
            displayName: v.displayName,
            branchName: De(a) || (R = (T = v.settings.branches) == null ? void 0 : T[a]) == null ? void 0 : R.branchName,
            setBranchName: (U) => {
              De(a) || h.setValue(
                `settings.branches[${a}].branchName`,
                U,
                {
                  shouldValidate: !0
                }
              );
            },
            setSelectedBranchIndex: u,
            isEditingStepOrBranchName: w,
            setIsEditingStepOrBranchName: O
          }
        ) }) }),
        /* @__PURE__ */ y(
          Ken,
          {
            children: /* @__PURE__ */ V(qje, { direction: "vertical", children: [
              /* @__PURE__ */ y($_, { className: "min-h-[80px]", children: /* @__PURE__ */ y(Bi, { className: "h-full", children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 px-4 pb-6", children: [
                /* @__PURE__ */ y(uhn, { step: v }),
                v.type === qe.LOOP_ON_ITEMS && /* @__PURE__ */ y(nqe, { readonly: i }),
                v.type === qe.CODE && /* @__PURE__ */ y(tqe, { readonly: i }),
                v.type === qe.PIECE && S && v && /* @__PURE__ */ y(
                  $pn,
                  {
                    step: v,
                    flowId: c.flowId,
                    readonly: i
                  }
                ),
                v.type === qe.PIECE && !S && v && /* @__PURE__ */ y(
                  tW,
                  {
                    step: v,
                    flowId: c.flowId,
                    readonly: i
                  }
                ),
                v.type === qe.ROUTER && v && /* @__PURE__ */ y(lqe, { readonly: i }),
                v.type === Bt.PIECE && v && /* @__PURE__ */ y(
                  tW,
                  {
                    step: v,
                    flowId: c.flowId,
                    readonly: i
                  }
                ),
                x && /* @__PURE__ */ y(
                  L6e,
                  {
                    hideContinueOnFailure: d.type === qe.PIECE ? (F = (j = d.errorHandlingOptions) == null ? void 0 : j.continueOnFailure) == null ? void 0 : F.hide : !1,
                    disabled: i,
                    hideRetryOnFailure: d.type === qe.PIECE ? (_ = (L = d.errorHandlingOptions) == null ? void 0 : L.retryOnFailure) == null ? void 0 : _.hide : !1
                  }
                )
              ] }) }) }),
              (b || A) && /* @__PURE__ */ V(pt, { children: [
                /* @__PURE__ */ y(Bje, { withHandle: !0 }),
                /* @__PURE__ */ y(
                  $_,
                  {
                    defaultSize: E,
                    onResize: (U) => k(U),
                    className: "min-h-[130px]",
                    children: /* @__PURE__ */ V(
                      Bi,
                      {
                        className: "h-[calc(100%-35px)]",
                        viewPortClassName: "h-full",
                        children: [
                          b && /* @__PURE__ */ y(
                            EVe,
                            {
                              type: v.type,
                              flowId: c.flowId,
                              flowVersionId: c.id,
                              projectId: r == null ? void 0 : r.id,
                              isSaving: l
                            }
                          ),
                          A && /* @__PURE__ */ y(Ktn, {})
                        ]
                      }
                    )
                  }
                )
              ] })
            ] })
          },
          `${e.name}-${e.type}`
        )
      ]
    }
  ) });
};
cqe.displayName = "StepSettingsContainer";
const dhn = "min-w-[max(20vw,400px)]", fhn = "transition-all ", uqe = (e) => {
  var b, A;
  const { onBack: t } = e, { platform: n } = dN.useCurrentPlatform(), [r, i, o] = tn(
    (w) => [w.flowVersion, w.rightSidebar, w.selectedStep]
  );
  vv.useShowBuilderIsSavingWarningBeforeLeaving();
  const s = Kt(() => {
    if (!(De(o) || De(r)))
      return At.getStep(o, r.trigger);
  }, [r, o]), l = Xe(null), c = hxe(l), [a, u] = He(!1), f = vv.useAnimateSidebar(i), d = Xe(null), { pieceModel: p, refetch: h } = nd.usePieceModelForStepSettings({
    name: s == null ? void 0 : s.settings.pieceName,
    version: s == null ? void 0 : s.settings.pieceVersion,
    enabled: (s == null ? void 0 : s.type) === qe.PIECE || (s == null ? void 0 : s.type) === Bt.PIECE,
    getExactVersion: r.state === Lo.LOCKED
  });
  vv.useSetSocketListener(h);
  const [m, v] = He(!1);
  return /* @__PURE__ */ V("div", { className: "flex h-full w-full flex-col relative", children: [
    /* @__PURE__ */ y("div", { className: "z-50", children: /* @__PURE__ */ y(LZt, { onBack: t }) }),
    /* @__PURE__ */ V(qje, { direction: "horizontal", children: [
      /* @__PURE__ */ y($_, { defaultSize: 100, order: 2, id: "flow-canvas", children: /* @__PURE__ */ V("div", { ref: l, className: "relative h-full w-full", children: [
        /* @__PURE__ */ y(UZt, { children: /* @__PURE__ */ y(
          L5e,
          {
            setHasCanvasBeenInitialised: v
          }
        ) }),
        /* @__PURE__ */ y(z5e, {}),
        /* @__PURE__ */ y(j5e, {}),
        /* @__PURE__ */ y(a$t, {}),
        l.current && l.current.clientWidth > 0 && /* @__PURE__ */ y(
          kDt,
          {
            canvasHeight: ((b = l.current) == null ? void 0 : b.clientHeight) ?? 0,
            canvasWidth: ((A = l.current) == null ? void 0 : A.clientWidth) ?? 0,
            hasCanvasBeenInitialised: m,
            selectedStep: o
          }
        ),
        /* @__PURE__ */ y(
          vje,
          {
            position: "absolute",
            show: n == null ? void 0 : n.plan.showPoweredBy
          }
        ),
        /* @__PURE__ */ y(
          _Me,
          {
            parentHeight: c.height,
            parentWidth: c.width
          }
        )
      ] }) }),
      /* @__PURE__ */ y(
        Bje,
        {
          disabled: i === zr.NONE,
          withHandle: i !== zr.NONE,
          onDragging: u,
          className: i === zr.NONE ? "bg-transparent" : ""
        }
      ),
      /* @__PURE__ */ y(
        $_,
        {
          ref: f,
          id: "right-sidebar",
          defaultSize: 0,
          minSize: 0,
          maxSize: 60,
          order: 3,
          className: Se("min-w-0 bg-background z-30", {
            [dhn]: i !== zr.NONE,
            [fhn]: !a
          }),
          style: {
            transitionDuration: `${Ie.SIDEBAR_ANIMATION_DURATION}ms`
          },
          children: /* @__PURE__ */ V("div", { ref: d, className: "h-full w-full", children: [
            i === zr.PIECE_SETTINGS && s && /* @__PURE__ */ y(ihn, { children: /* @__PURE__ */ y(
              IDt,
              {
                pieceModel: p,
                selectedStep: s,
                children: /* @__PURE__ */ y(
                  cqe,
                  {},
                  tve({
                    flowVersionId: r.id,
                    step: s,
                    hasPieceModelLoaded: !!p
                  })
                )
              },
              tve({
                flowVersionId: r.id,
                step: s,
                hasPieceModelLoaded: !!p
              })
            ) }),
            i === zr.RUNS && /* @__PURE__ */ y(W5e, {}),
            i === zr.VERSIONS && /* @__PURE__ */ y(q5e, {})
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ y(z7t, {})
  ] });
};
uqe.displayName = "BuilderPage";
function tve({
  flowVersionId: e,
  step: t,
  hasPieceModelLoaded: n
}) {
  const r = t == null ? void 0 : t.name, i = t == null ? void 0 : t.type, o = (t == null ? void 0 : t.type) === Bt.PIECE ? t == null ? void 0 : t.settings.triggerName : t == null ? void 0 : t.settings.actionName, s = (t == null ? void 0 : t.type) === Bt.PIECE || (t == null ? void 0 : t.type) === qe.PIECE ? t == null ? void 0 : t.settings.pieceName : void 0, l = (t == null ? void 0 : t.type) != Bt.EMPTY && (t == null ? void 0 : t.type) != Bt.PIECE && (t == null ? void 0 : t.skip);
  return `${e}-${r ?? ""}-${i ?? ""}-${o ?? ""}-${s ?? ""}-${"skipped-" + !!l}-${n ? "loaded" : "not-loaded"}`;
}
function phn({
  children: e,
  outputSampleData: t,
  inputSampleData: n,
  ...r
}) {
  const i = Xe(), { checkAccess: o } = yc(), s = !o(Es.WRITE_FLOW) || r.readonly;
  return i.current || (i.current = ZMt({
    ...r,
    readonly: s,
    outputSampleData: t,
    inputSampleData: n
  })), /* @__PURE__ */ y(xMe.Provider, { value: i.current, children: e });
}
const hhn = (e) => {
  var m;
  const { runId: t } = ol(), { flowId: n, readonly: r, onBack: i } = e, {
    data: o,
    isLoading: s,
    isError: l
  } = pr({
    queryKey: ["flow", n],
    queryFn: () => yi.get(n),
    gcTime: 0,
    retry: !1,
    refetchOnWindowFocus: !1
  }), { data: c, isLoading: a } = pr({
    queryKey: ["run", t],
    queryFn: async () => {
      const v = await _x.getPopulated(t), b = await yi.get(v.flowId, {
        versionId: v.flowVersionId
      });
      return {
        run: v,
        flow: b
      };
    },
    enabled: !De(t)
  }), u = s || (t ? a : !1), { data: f, isLoading: d } = P7.useSampleDataForFlow(o == null ? void 0 : o.version, o == null ? void 0 : o.projectId), { data: p, isLoading: h } = P7.useSampleDataInputForFlow(o == null ? void 0 : o.version, o == null ? void 0 : o.projectId);
  return l ? (console.error("Error fetching flow", n), /* @__PURE__ */ y("div", { className: "bg-background flex h-screen w-screen items-center justify-center ", children: /* @__PURE__ */ y("p", { children: Z("Flow not found") }) })) : u || d || h ? /* @__PURE__ */ y("div", { className: "bg-background flex h-screen w-screen items-center justify-center ", children: /* @__PURE__ */ y(mu, { size: 50 }) }) : /* @__PURE__ */ y(MEe, { children: /* @__PURE__ */ y(
    phn,
    {
      flow: o,
      canExitRun: !0,
      flowVersion: c ? c.flow.version : o.version,
      readonly: t !== void 0 ? !0 : r ?? !1,
      run: c == null ? void 0 : c.run,
      outputSampleData: f ?? {},
      inputSampleData: p ?? {},
      children: /* @__PURE__ */ y(uqe, { onBack: i })
    },
    ((m = c == null ? void 0 : c.run) == null ? void 0 : m.id) ?? "draft"
  ) });
}, mhn = (e) => {
  const { flowId: t, onBack: n } = e, i = !yc().checkAccess(
    Es.WRITE_FLOW
  ) || e.readonly;
  return /* @__PURE__ */ y("div", { className: "omniflow-container flex items-center justify-center h-full w-full", children: /* @__PURE__ */ y(
    hhn,
    {
      flowId: t,
      readonly: i,
      onBack: n
    }
  ) });
};
let nve = !1;
nve || (YQe((e) => {
  var t;
  return ((t = e == null ? void 0 : e.schema) == null ? void 0 : t.errorMessage) ?? K0e(e);
}), nve = !0);
const ghn = new rwe({
  mutationCache: new nwe({
    onError: (e, t, n, r) => {
      if (dt.isApError(e, Ni.QUOTA_EXCEEDED)) {
        const { openDialog: i } = Qet.getState();
        i();
      } else De(r.options.onError) && Kc();
    }
  })
}), yhn = (e) => {
  nt(() => {
    if (typeof window > "u")
      return;
    const t = () => {
      const r = qAe();
      YM(r), e.changeLanguage(r);
    };
    t();
    const n = new MutationObserver(() => {
      const r = UC(document.documentElement.lang);
      YM(r), e.changeLanguage(r);
    });
    return n.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["lang"]
    }), window.addEventListener("storage", t), () => {
      n.disconnect(), window.removeEventListener("storage", t);
    };
  }, [e]);
};
function zmn({
  queryClient: e,
  flowId: t,
  projectId: n,
  platformId: r,
  readonly: i,
  onBack: o,
  apiService: s
}) {
  const l = e ?? ghn, { i18n: c } = tc(), a = UC(
    c.resolvedLanguage ?? c.language
  );
  return yhn(c), /* @__PURE__ */ y(
    dwt,
    {
      flowId: t,
      projectId: n,
      platformId: r,
      apiService: s,
      children: /* @__PURE__ */ y(mtt, { client: l, children: /* @__PURE__ */ y(Kp, { children: /* @__PURE__ */ y(Prt, { storageKey: "themeMode", children: /* @__PURE__ */ V($Se, { children: [
        /* @__PURE__ */ y(E_t, { children: /* @__PURE__ */ y(
          "div",
          {
            className: "h-full w-full",
            dir: CH(a),
            lang: a,
            children: t ? /* @__PURE__ */ y(
              mhn,
              {
                flowId: t,
                readonly: i,
                onBack: o
              }
            ) : /* @__PURE__ */ y("span", { children: Z("No flow id provided") })
          }
        ) }),
        /* @__PURE__ */ y(lwt, {})
      ] }) }) }) })
    }
  );
}
zet();
export {
  zmn as Omniflow
};
